(function () {

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree24f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree24f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("033rz", function(module, exports) {
$parcel$extendImportMap({
    "ez9Wz": "atkinson-hyperlegible-next-latin-400-normal.61627e05.woff2",
    "favaH": "atkinson-hyperlegible-next-latin-400-normal.74b3a7cf.woff",
    "KWWxJ": "atkinson-hyperlegible-next-latin-ext-400-normal.ca516a01.woff2",
    "eh3vC": "atkinson-hyperlegible-next-latin-ext-400-normal.94c8c42a.woff"
});

});

parcelRegister("iJKv7", function(module, exports) {
// The Panoramax viewer bundles its own Font Awesome and ships its styles in its shadow DOM:
// the <style> auto-injected in <head> is useless and blocked by our CSP (no nonce).
// Must run before the viewer is imported, as Font Awesome reads this global at load time.
window.FontAwesomeConfig = {
    autoAddCss: false
};

});

parcelRegister("e61jG", function(module, exports) {
"use strict";

});

parcelRegister("9YUWX", function(module, exports) {
// Shared behaviour for the Panoramax bundles (panoramax.js and panoramaxPhoto.js).
// Must be imported after the viewer so its custom elements are defined.
// The viewer's CJS build declares its Atkinson Hyperlegible @font-face (adopted by the
// document) with absolute /fonts/ URLs, which we don't serve. Point them to the copies
// bundled by Parcel.




function $7445e4b9cacd04d8$var$fixPanoramaxFontUrls() {
    const PANORAMAX_FONTS = {
        'atkinson-hyperlegible-next-latin-400-normal.woff2': new URL((parcelRequire("ennuU"))),
        'atkinson-hyperlegible-next-latin-400-normal.woff': new URL((parcelRequire("eQsaR"))),
        'atkinson-hyperlegible-next-latin-ext-400-normal.woff2': new URL((parcelRequire("Tnrg7"))),
        'atkinson-hyperlegible-next-latin-ext-400-normal.woff': new URL((parcelRequire("1ntUo")))
    };
    document.adoptedStyleSheets.forEach((sheet)=>{
        Array.from(sheet.cssRules).forEach((rule, index)=>{
            if (!(rule instanceof CSSFontFaceRule) || !rule.cssText.includes('/fonts/')) return;
            const cssText = rule.cssText.replace(/url\("?\/fonts\/([^")]+)"?\)/g, (match, file)=>PANORAMAX_FONTS[file] ? `url("${PANORAMAX_FONTS[file]}")` : match);
            sheet.deleteRule(index);
            sheet.insertRule(cssText, index);
        });
    });
}
// Parcel only registers its asset URL manifest after the entry module has run, so the
// URLs above can't be resolved synchronously here. A microtask still runs before any
// rendering, so the browser never requests /fonts/.
queueMicrotask($7445e4b9cacd04d8$var$fixPanoramaxFontUrls);
document.addEventListener('DOMContentLoaded', ()=>{
    const browser = document.querySelector('pnx-viewer');
    const xyzField = document.getElementById('xyz-coords');
    const imageId = document.getElementById('image-id');
    // Panoramax 5.3.1 bug: with widgets="false" the viewer never creates its legend but
    // still reads this.legend.parentNode when focusing the picture, which aborts its init
    // and leaves the loader over the photo. Give it a detached placeholder legend.
    if (browser?.getAttribute('widgets') === 'false') browser.legend ??= document.createElement('span');
    if (browser && xyzField) {
        const updateXYZandImageID = (event)=>{
            const { x: x, y: y, z: z } = event.detail;
            const xyz = `${x}/${y}/${z}`;
            xyzField.value = xyz;
            imageId.value = browser.getAttribute('picture');
        };
        browser.addEventListener('psv:view-rotated', updateXYZandImageID);
        browser.addEventListener('psv:position-changed', updateXYZandImageID);
    }
    const viewer = document.querySelector('pnx-photo-viewer');
    if (viewer) {
        const xyz = viewer.getAttribute('xyz');
        viewer.addEventListener('psv:picture-loaded', ()=>{
            if (xyz) {
                const [x, y, z] = xyz.split('/').map(Number);
                viewer.psv.setXYZ(x, y, z);
            }
        });
    }
    $7445e4b9cacd04d8$var$enableKeyboardOnFocus();
    $7445e4b9cacd04d8$var$enhancePanoramaxLegendA11y();
});
// RGAA 12.x: the Panoramax viewer reacts to keyboard shortcuts via a window-level
// keydown listener gated by psv.state.keyboardEnabled. The component only flips
// that flag on mouse click / character keypress, so a keyboard-only user can
// never reach it. Make the host focusable and enable the shortcuts while it
// holds focus, disabling them on blur so they don't fire from elsewhere.
function $7445e4b9cacd04d8$var$enableKeyboardOnFocus() {
    // Keys the viewer consumes for navigation; prevent them from also scrolling
    // the page while the viewer holds focus.
    const SCROLL_KEYS = [
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'PageUp',
        'PageDown',
        'Home',
        'End',
        ' ',
        'Spacebar'
    ];
    document.querySelectorAll('pnx-photo-viewer, pnx-viewer').forEach((host)=>{
        host.setAttribute('tabindex', '0');
        host.addEventListener('focus', ()=>host.psv?.startKeyboardControl?.());
        host.addEventListener('blur', ()=>host.psv?.stopKeyboardControl?.());
        host.addEventListener('keydown', (event)=>{
            if (event.target !== host || !SCROLL_KEYS.includes(event.key)) return;
            host.psv?.startKeyboardControl?.();
            event.preventDefault();
        });
    });
}
// RGAA 6.1: the Panoramax legend (shadow DOM, third-party component) ships
// non-explicit links. Make their accessible names explicit and signal that
// they open in a new window. Re-applied on every Lit re-render via observers.
function $7445e4b9cacd04d8$var$enhancePanoramaxLegendA11y() {
    const legend = document.querySelector('pnx-widget-legend');
    if (!legend) return;
    // Lit re-renders the legend on every picture change, overwriting the title and
    // wiping any icon we appended. So enhancement must be idempotent and re-run
    // after each render. We watch with observers and mask our own writes (disconnect
    // while writing) to avoid a feedback loop, since setAttribute fires the observer
    // even when the value is unchanged.
    const rootObserver = new MutationObserver(()=>enhance());
    const pictureObserver = new MutationObserver(()=>enhance());
    const setExternalLink = (link, label, visibleText)=>{
        if (!link) return;
        link.setAttribute('title', `${label} - ${gettext("nouvelle fen\xeatre")}`);
        link.setAttribute('rel', 'noopener');
        // Replace the on-screen text when it isn't self-explanatory (e.g. the photo
        // link only shows the author name). The descriptive label stays in title.
        if (visibleText && link.firstChild?.textContent !== visibleText) link.textContent = visibleText;
        // Append the new-window indicator once; Lit drops it on re-render so we
        // re-add it whenever it is missing. The legend lives in a shadow root that
        // can't reach the DSFR icon font, so we reproduce DSFR's external-link icon
        // (remixicon external-link-line) as an inline SVG mask tinted to the link
        // colour — same box-with-arrow as fr-link[target="_blank"].
        if (!link.querySelector('[data-a11y-icon]')) {
            const svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L18.585 5H13V3h8z'/></svg>";
            const mask = `url("data:image/svg+xml,${encodeURIComponent(svg)}") no-repeat center / contain`;
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden', 'true');
            icon.setAttribute('data-a11y-icon', '');
            icon.style.cssText = [
                'display:inline-block',
                'width:1em',
                'height:1em',
                'margin-left:0.25em',
                'vertical-align:middle',
                'background-color:currentColor',
                `-webkit-mask:${mask}`,
                `mask:${mask}`
            ].join(';');
            link.appendChild(icon);
        }
    };
    const enhance = ()=>{
        const root = legend.shadowRoot;
        if (!root) return;
        rootObserver.disconnect();
        pictureObserver.disconnect();
        setExternalLink(root.querySelector('.presentation a[target="_blank"]'), gettext('Panoramax'));
        const pictureRoot = root.querySelector('pnx-picture-legend')?.shadowRoot;
        if (pictureRoot) {
            pictureRoot.querySelectorAll('a[target="_blank"]').forEach((link)=>{
                if (link.href.includes('/?pic=')) {
                    // Visible text becomes the author name; cache it on first pass so the
                    // descriptive title survives our own text replacement and re-renders.
                    const author = link.dataset.a11yAuthor || (link.dataset.a11yAuthor = link.textContent.trim());
                    setExternalLink(link, 'Voir sur Panoramax', gettext('Voir sur Panoramax'));
                } else {
                    const licence = link.textContent.replace("\u2197", '').trim();
                    setExternalLink(link, licence);
                }
            });
            pictureObserver.observe(pictureRoot, {
                childList: true,
                subtree: true
            });
        }
        rootObserver.observe(root, {
            childList: true,
            subtree: true
        });
    };
    const start = ()=>{
        if (!legend.shadowRoot) {
            requestAnimationFrame(start);
            return;
        }
        enhance();
    };
    start();
}

});
parcelRegister("ennuU", function(module, exports) {
module.exports = $parcel$resolve("ez9Wz");

});

parcelRegister("eQsaR", function(module, exports) {
module.exports = $parcel$resolve("favaH");

});

parcelRegister("Tnrg7", function(module, exports) {
module.exports = $parcel$resolve("KWWxJ");

});

parcelRegister("1ntUo", function(module, exports) {
module.exports = $parcel$resolve("eh3vC");

});


// Full Panoramax viewer (<pnx-viewer>, with map): used by the contribution pages.
parcelRequire("iJKv7");
var $785da19a645c07eb$export$f361a1aa61d15026;
var $785da19a645c07eb$export$7cda8d932e2f33c0;
var $785da19a645c07eb$export$fe59e85e16b5f4fb;
var $785da19a645c07eb$export$2ec4afd9b3c16a85;
var $785da19a645c07eb$export$9b5ac10f59f76296;
var $785da19a645c07eb$export$eab97d15b1788b8d;
var $785da19a645c07eb$var$__filename = "node_modules/.pnpm/@panoramax+web-viewer@5.3.1/node_modules/@panoramax/web-viewer/build/cjs/index.js";
"use strict";
var $785da19a645c07eb$var$e1 = "undefined" != typeof document ? document.currentScript : null;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $785da19a645c07eb$var$t = globalThis, $785da19a645c07eb$var$i = $785da19a645c07eb$var$t.ShadowRoot && (void 0 === $785da19a645c07eb$var$t.ShadyCSS || $785da19a645c07eb$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $785da19a645c07eb$var$n = Symbol(), $785da19a645c07eb$var$a = new WeakMap;
let $785da19a645c07eb$var$r = class {
    constructor(e1, t, i){
        if (this._$cssResult$ = !0, i !== $785da19a645c07eb$var$n) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = e1, this.t = t;
    }
    get styleSheet() {
        let e1 = this.o;
        const t = this.t;
        if ($785da19a645c07eb$var$i && void 0 === e1) {
            const i = void 0 !== t && 1 === t.length;
            i && (e1 = $785da19a645c07eb$var$a.get(t)), void 0 === e1 && ((this.o = e1 = new CSSStyleSheet).replaceSync(this.cssText), i && $785da19a645c07eb$var$a.set(t, e1));
        }
        return e1;
    }
    toString() {
        return this.cssText;
    }
};
const $785da19a645c07eb$var$s = (e1)=>new $785da19a645c07eb$var$r("string" == typeof e1 ? e1 : e1 + "", void 0, $785da19a645c07eb$var$n), $785da19a645c07eb$var$o = (e1, ...t)=>{
    const i = 1 === e1.length ? e1[0] : t.reduce((t, i, n)=>t + ((e1)=>{
            if (!0 === e1._$cssResult$) return e1.cssText;
            if ("number" == typeof e1) return e1;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + e1 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(i) + e1[n + 1], e1[0]);
    return new $785da19a645c07eb$var$r(i, e1, $785da19a645c07eb$var$n);
}, $785da19a645c07eb$var$l = $785da19a645c07eb$var$i ? (e1)=>e1 : (e1)=>e1 instanceof CSSStyleSheet ? ((e1)=>{
        let t = "";
        for (const i of e1.cssRules)t += i.cssText;
        return $785da19a645c07eb$var$s(t);
    })(e1) : e1, { is: $785da19a645c07eb$var$c, defineProperty: $785da19a645c07eb$var$u, getOwnPropertyDescriptor: $785da19a645c07eb$var$h, getOwnPropertyNames: $785da19a645c07eb$var$d, getOwnPropertySymbols: $785da19a645c07eb$var$p, getPrototypeOf: $785da19a645c07eb$var$m } = Object, $785da19a645c07eb$var$g = globalThis, $785da19a645c07eb$var$f = $785da19a645c07eb$var$g.trustedTypes, $785da19a645c07eb$var$A = $785da19a645c07eb$var$f ? $785da19a645c07eb$var$f.emptyScript : "", $785da19a645c07eb$var$_ = $785da19a645c07eb$var$g.reactiveElementPolyfillSupport, $785da19a645c07eb$var$v = (e1, t)=>e1, $785da19a645c07eb$var$y = {
    toAttribute (e1, t) {
        switch(t){
            case Boolean:
                e1 = e1 ? $785da19a645c07eb$var$A : null;
                break;
            case Object:
            case Array:
                e1 = null == e1 ? e1 : JSON.stringify(e1);
        }
        return e1;
    },
    fromAttribute (e1, t) {
        let i = e1;
        switch(t){
            case Boolean:
                i = null !== e1;
                break;
            case Number:
                i = null === e1 ? null : Number(e1);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(e1);
                } catch (e1) {
                    i = null;
                }
        }
        return i;
    }
}, $785da19a645c07eb$var$x = (e1, t)=>!$785da19a645c07eb$var$c(e1, t), $785da19a645c07eb$var$b = {
    attribute: !0,
    type: String,
    converter: $785da19a645c07eb$var$y,
    reflect: !1,
    useDefault: !1,
    hasChanged: $785da19a645c07eb$var$x
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ Symbol.metadata ??= Symbol("metadata"), $785da19a645c07eb$var$g.litPropertyMetadata ??= new WeakMap;
let $785da19a645c07eb$var$w = class extends HTMLElement {
    static addInitializer(e1) {
        this._$Ei(), (this.l ??= []).push(e1);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(e1, t = $785da19a645c07eb$var$b) {
        if (t.state && (t.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(e1) && ((t = Object.create(t)).wrapped = !0), this.elementProperties.set(e1, t), !t.noAccessor) {
            const i = Symbol(), n = this.getPropertyDescriptor(e1, i, t);
            void 0 !== n && $785da19a645c07eb$var$u(this.prototype, e1, n);
        }
    }
    static getPropertyDescriptor(e1, t, i) {
        const { get: n, set: a } = $785da19a645c07eb$var$h(this.prototype, e1) ?? {
            get () {
                return this[t];
            },
            set (e1) {
                this[t] = e1;
            }
        };
        return {
            get: n,
            set (t) {
                const r = n?.call(this);
                a?.call(this, t), this.requestUpdate(e1, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(e1) {
        return this.elementProperties.get(e1) ?? $785da19a645c07eb$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($785da19a645c07eb$var$v("elementProperties"))) return;
        const e1 = $785da19a645c07eb$var$m(this);
        e1.finalize(), void 0 !== e1.l && (this.l = [
            ...e1.l
        ]), this.elementProperties = new Map(e1.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($785da19a645c07eb$var$v("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($785da19a645c07eb$var$v("properties"))) {
            const e1 = this.properties, t = [
                ...$785da19a645c07eb$var$d(e1),
                ...$785da19a645c07eb$var$p(e1)
            ];
            for (const i of t)this.createProperty(i, e1[i]);
        }
        const e1 = this[Symbol.metadata];
        if (null !== e1) {
            const t = litPropertyMetadata.get(e1);
            if (void 0 !== t) for (const [e1, i] of t)this.elementProperties.set(e1, i);
        }
        this._$Eh = new Map;
        for (const [e1, t] of this.elementProperties){
            const i = this._$Eu(e1, t);
            void 0 !== i && this._$Eh.set(i, e1);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(e1) {
        const t = [];
        if (Array.isArray(e1)) {
            const i = new Set(e1.flat(1 / 0).reverse());
            for (const e1 of i)t.unshift($785da19a645c07eb$var$l(e1));
        } else void 0 !== e1 && t.push($785da19a645c07eb$var$l(e1));
        return t;
    }
    static _$Eu(e1, t) {
        const i = t.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof e1 ? e1.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((e1)=>this.enableUpdating = e1), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((e1)=>e1(this));
    }
    addController(e1) {
        (this._$EO ??= new Set).add(e1), void 0 !== this.renderRoot && this.isConnected && e1.hostConnected?.();
    }
    removeController(e1) {
        this._$EO?.delete(e1);
    }
    _$E_() {
        const e1 = new Map, t = this.constructor.elementProperties;
        for (const i of t.keys())this.hasOwnProperty(i) && (e1.set(i, this[i]), delete this[i]);
        e1.size > 0 && (this._$Ep = e1);
    }
    createRenderRoot() {
        const e1 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return ((e1, n)=>{
            if ($785da19a645c07eb$var$i) e1.adoptedStyleSheets = n.map((e1)=>e1 instanceof CSSStyleSheet ? e1 : e1.styleSheet);
            else for (const i of n){
                const n = document.createElement("style"), a = $785da19a645c07eb$var$t.litNonce;
                void 0 !== a && n.setAttribute("nonce", a), n.textContent = i.cssText, e1.appendChild(n);
            }
        })(e1, this.constructor.elementStyles), e1;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((e1)=>e1.hostConnected?.());
    }
    enableUpdating(e1) {}
    disconnectedCallback() {
        this._$EO?.forEach((e1)=>e1.hostDisconnected?.());
    }
    attributeChangedCallback(e1, t, i) {
        this._$AK(e1, i);
    }
    _$ET(e1, t) {
        const i = this.constructor.elementProperties.get(e1), n = this.constructor._$Eu(e1, i);
        if (void 0 !== n && !0 === i.reflect) {
            const a = (void 0 !== i.converter?.toAttribute ? i.converter : $785da19a645c07eb$var$y).toAttribute(t, i.type);
            this._$Em = e1, null == a ? this.removeAttribute(n) : this.setAttribute(n, a), this._$Em = null;
        }
    }
    _$AK(e1, t) {
        const i = this.constructor, n = i._$Eh.get(e1);
        if (void 0 !== n && this._$Em !== n) {
            const e1 = i.getPropertyOptions(n), a = "function" == typeof e1.converter ? {
                fromAttribute: e1.converter
            } : void 0 !== e1.converter?.fromAttribute ? e1.converter : $785da19a645c07eb$var$y;
            this._$Em = n;
            const r = a.fromAttribute(t, e1.type);
            this[n] = r ?? this._$Ej?.get(n) ?? r, this._$Em = null;
        }
    }
    requestUpdate(e1, t, i, n = !1, a) {
        if (void 0 !== e1) {
            const r = this.constructor;
            if (!1 === n && (a = this[e1]), i ??= r.getPropertyOptions(e1), !((i.hasChanged ?? $785da19a645c07eb$var$x)(a, t) || i.useDefault && i.reflect && a === this._$Ej?.get(e1) && !this.hasAttribute(r._$Eu(e1, i)))) return;
            this.C(e1, t, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(e1, t, { useDefault: i, reflect: n, wrapped: a }, r) {
        i && !(this._$Ej ??= new Map).has(e1) && (this._$Ej.set(e1, r ?? t ?? this[e1]), !0 !== a || void 0 !== r) || (this._$AL.has(e1) || (this.hasUpdated || i || (t = void 0), this._$AL.set(e1, t)), !0 === n && this._$Em !== e1 && (this._$Eq ??= new Set).add(e1));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (e1) {
            Promise.reject(e1);
        }
        const e1 = this.scheduleUpdate();
        return null != e1 && await e1, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [e1, t] of this._$Ep)this[e1] = t;
                this._$Ep = void 0;
            }
            const e1 = this.constructor.elementProperties;
            if (e1.size > 0) for (const [t, i] of e1){
                const { wrapped: e1 } = i, n = this[t];
                !0 !== e1 || this._$AL.has(t) || void 0 === n || this.C(t, void 0, i, n);
            }
        }
        let e1 = !1;
        const t = this._$AL;
        try {
            e1 = this.shouldUpdate(t), e1 ? (this.willUpdate(t), this._$EO?.forEach((e1)=>e1.hostUpdate?.()), this.update(t)) : this._$EM();
        } catch (t) {
            throw e1 = !1, this._$EM(), t;
        }
        e1 && this._$AE(t);
    }
    willUpdate(e1) {}
    _$AE(e1) {
        this._$EO?.forEach((e1)=>e1.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(e1)), this.updated(e1);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(e1) {
        return !0;
    }
    update(e1) {
        this._$Eq &&= this._$Eq.forEach((e1)=>this._$ET(e1, this[e1])), this._$EM();
    }
    updated(e1) {}
    firstUpdated(e1) {}
};
$785da19a645c07eb$var$w.elementStyles = [], $785da19a645c07eb$var$w.shadowRootOptions = {
    mode: "open"
}, $785da19a645c07eb$var$w[$785da19a645c07eb$var$v("elementProperties")] = new Map, $785da19a645c07eb$var$w[$785da19a645c07eb$var$v("finalized")] = new Map, $785da19a645c07eb$var$_?.({
    ReactiveElement: $785da19a645c07eb$var$w
}), ($785da19a645c07eb$var$g.reactiveElementVersions ??= []).push("2.1.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $785da19a645c07eb$var$E = globalThis, $785da19a645c07eb$var$k = (e1)=>e1, $785da19a645c07eb$var$S = $785da19a645c07eb$var$E.trustedTypes, $785da19a645c07eb$var$M = $785da19a645c07eb$var$S ? $785da19a645c07eb$var$S.createPolicy("lit-html", {
    createHTML: (e1)=>e1
}) : void 0, $785da19a645c07eb$var$C = "$lit$", $785da19a645c07eb$var$T = `lit$${Math.random().toFixed(9).slice(2)}$`, $785da19a645c07eb$var$D = "?" + $785da19a645c07eb$var$T, $785da19a645c07eb$var$P = `<${$785da19a645c07eb$var$D}>`, $785da19a645c07eb$var$I = document, $785da19a645c07eb$var$F = ()=>$785da19a645c07eb$var$I.createComment(""), $785da19a645c07eb$var$z = (e1)=>null === e1 || "object" != typeof e1 && "function" != typeof e1, $785da19a645c07eb$var$R = Array.isArray, $785da19a645c07eb$var$B = "[ \t\n\f\r]", $785da19a645c07eb$var$O = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $785da19a645c07eb$var$U = /-->/g, $785da19a645c07eb$var$N = />/g, $785da19a645c07eb$var$j = RegExp(`>|${$785da19a645c07eb$var$B}(?:([^\\s"'>=/]+)(${$785da19a645c07eb$var$B}*=${$785da19a645c07eb$var$B}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $785da19a645c07eb$var$V = /'/g, $785da19a645c07eb$var$q = /"/g, $785da19a645c07eb$var$G = /^(?:script|style|textarea|title)$/i, $785da19a645c07eb$var$H = ((e1)=>(t, ...i)=>({
            _$litType$: e1,
            strings: t,
            values: i
        }))(1), $785da19a645c07eb$var$W = Symbol.for("lit-noChange"), $785da19a645c07eb$var$Z = Symbol.for("lit-nothing"), $785da19a645c07eb$var$K = new WeakMap, $785da19a645c07eb$var$X = $785da19a645c07eb$var$I.createTreeWalker($785da19a645c07eb$var$I, 129);
function $785da19a645c07eb$var$Q(e1, t) {
    if (!$785da19a645c07eb$var$R(e1) || !e1.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $785da19a645c07eb$var$M ? $785da19a645c07eb$var$M.createHTML(t) : t;
}
let $785da19a645c07eb$var$Y = class e1 {
    constructor({ strings: t, _$litType$: i }, n){
        let a;
        this.parts = [];
        let r = 0, s = 0;
        const o = t.length - 1, l = this.parts, [c, u] = ((e1, t)=>{
            const i = e1.length - 1, n = [];
            let a, r = 2 === t ? "<svg>" : 3 === t ? "<math>" : "", s = $785da19a645c07eb$var$O;
            for(let t = 0; t < i; t++){
                const i = e1[t];
                let o, l, c = -1, u = 0;
                for(; u < i.length && (s.lastIndex = u, l = s.exec(i), null !== l);)u = s.lastIndex, s === $785da19a645c07eb$var$O ? "!--" === l[1] ? s = $785da19a645c07eb$var$U : void 0 !== l[1] ? s = $785da19a645c07eb$var$N : void 0 !== l[2] ? ($785da19a645c07eb$var$G.test(l[2]) && (a = RegExp("</" + l[2], "g")), s = $785da19a645c07eb$var$j) : void 0 !== l[3] && (s = $785da19a645c07eb$var$j) : s === $785da19a645c07eb$var$j ? ">" === l[0] ? (s = a ?? $785da19a645c07eb$var$O, c = -1) : void 0 === l[1] ? c = -2 : (c = s.lastIndex - l[2].length, o = l[1], s = void 0 === l[3] ? $785da19a645c07eb$var$j : '"' === l[3] ? $785da19a645c07eb$var$q : $785da19a645c07eb$var$V) : s === $785da19a645c07eb$var$q || s === $785da19a645c07eb$var$V ? s = $785da19a645c07eb$var$j : s === $785da19a645c07eb$var$U || s === $785da19a645c07eb$var$N ? s = $785da19a645c07eb$var$O : (s = $785da19a645c07eb$var$j, a = void 0);
                const h = s === $785da19a645c07eb$var$j && e1[t + 1].startsWith("/>") ? " " : "";
                r += s === $785da19a645c07eb$var$O ? i + $785da19a645c07eb$var$P : c >= 0 ? (n.push(o), i.slice(0, c) + $785da19a645c07eb$var$C + i.slice(c) + $785da19a645c07eb$var$T + h) : i + $785da19a645c07eb$var$T + (-2 === c ? t : h);
            }
            return [
                $785da19a645c07eb$var$Q(e1, r + (e1[i] || "<?>") + (2 === t ? "</svg>" : 3 === t ? "</math>" : "")),
                n
            ];
        })(t, i);
        if (this.el = e1.createElement(c, n), $785da19a645c07eb$var$X.currentNode = this.el.content, 2 === i || 3 === i) {
            const e1 = this.el.content.firstChild;
            e1.replaceWith(...e1.childNodes);
        }
        for(; null !== (a = $785da19a645c07eb$var$X.nextNode()) && l.length < o;){
            if (1 === a.nodeType) {
                if (a.hasAttributes()) for (const e1 of a.getAttributeNames())if (e1.endsWith($785da19a645c07eb$var$C)) {
                    const t = u[s++], i = a.getAttribute(e1).split($785da19a645c07eb$var$T), n = /([.?@])?(.*)/.exec(t);
                    l.push({
                        type: 1,
                        index: r,
                        name: n[2],
                        strings: i,
                        ctor: "." === n[1] ? $785da19a645c07eb$var$ie : "?" === n[1] ? $785da19a645c07eb$var$ne : "@" === n[1] ? $785da19a645c07eb$var$ae : $785da19a645c07eb$var$te
                    }), a.removeAttribute(e1);
                } else e1.startsWith($785da19a645c07eb$var$T) && (l.push({
                    type: 6,
                    index: r
                }), a.removeAttribute(e1));
                if ($785da19a645c07eb$var$G.test(a.tagName)) {
                    const e1 = a.textContent.split($785da19a645c07eb$var$T), t = e1.length - 1;
                    if (t > 0) {
                        a.textContent = $785da19a645c07eb$var$S ? $785da19a645c07eb$var$S.emptyScript : "";
                        for(let i = 0; i < t; i++)a.append(e1[i], $785da19a645c07eb$var$F()), $785da19a645c07eb$var$X.nextNode(), l.push({
                            type: 2,
                            index: ++r
                        });
                        a.append(e1[t], $785da19a645c07eb$var$F());
                    }
                }
            } else if (8 === a.nodeType) {
                if (a.data === $785da19a645c07eb$var$D) l.push({
                    type: 2,
                    index: r
                });
                else {
                    let e1 = -1;
                    for(; -1 !== (e1 = a.data.indexOf($785da19a645c07eb$var$T, e1 + 1));)l.push({
                        type: 7,
                        index: r
                    }), e1 += $785da19a645c07eb$var$T.length - 1;
                }
            }
            r++;
        }
    }
    static createElement(e1, t) {
        const i = $785da19a645c07eb$var$I.createElement("template");
        return i.innerHTML = e1, i;
    }
};
function $785da19a645c07eb$var$J(e1, t, i = e1, n) {
    if (t === $785da19a645c07eb$var$W) return t;
    let a = void 0 !== n ? i._$Co?.[n] : i._$Cl;
    const r = $785da19a645c07eb$var$z(t) ? void 0 : t._$litDirective$;
    return a?.constructor !== r && (a?._$AO?.(!1), void 0 === r ? a = void 0 : (a = new r(e1), a._$AT(e1, i, n)), void 0 !== n ? (i._$Co ??= [])[n] = a : i._$Cl = a), void 0 !== a && (t = $785da19a645c07eb$var$J(e1, a._$AS(e1, t.values), a, n)), t;
}
let $785da19a645c07eb$var$$ = class {
    constructor(e1, t){
        this._$AV = [], this._$AN = void 0, this._$AD = e1, this._$AM = t;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(e1) {
        const { el: { content: t }, parts: i } = this._$AD, n = (e1?.creationScope ?? $785da19a645c07eb$var$I).importNode(t, !0);
        $785da19a645c07eb$var$X.currentNode = n;
        let a = $785da19a645c07eb$var$X.nextNode(), r = 0, s = 0, o = i[0];
        for(; void 0 !== o;){
            if (r === o.index) {
                let t;
                2 === o.type ? t = new $785da19a645c07eb$var$ee(a, a.nextSibling, this, e1) : 1 === o.type ? t = new o.ctor(a, o.name, o.strings, this, e1) : 6 === o.type && (t = new $785da19a645c07eb$var$re(a, this, e1)), this._$AV.push(t), o = i[++s];
            }
            r !== o?.index && (a = $785da19a645c07eb$var$X.nextNode(), r++);
        }
        return $785da19a645c07eb$var$X.currentNode = $785da19a645c07eb$var$I, n;
    }
    p(e1) {
        let t = 0;
        for (const i of this._$AV)void 0 !== i && (void 0 !== i.strings ? (i._$AI(e1, i, t), t += i.strings.length - 2) : i._$AI(e1[t])), t++;
    }
}, $785da19a645c07eb$var$ee = class e1 {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(e1, t, i, n){
        this.type = 2, this._$AH = $785da19a645c07eb$var$Z, this._$AN = void 0, this._$AA = e1, this._$AB = t, this._$AM = i, this.options = n, this._$Cv = n?.isConnected ?? !0;
    }
    get parentNode() {
        let e1 = this._$AA.parentNode;
        const t = this._$AM;
        return void 0 !== t && 11 === e1?.nodeType && (e1 = t.parentNode), e1;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(e1, t = this) {
        e1 = $785da19a645c07eb$var$J(this, e1, t), $785da19a645c07eb$var$z(e1) ? e1 === $785da19a645c07eb$var$Z || null == e1 || "" === e1 ? (this._$AH !== $785da19a645c07eb$var$Z && this._$AR(), this._$AH = $785da19a645c07eb$var$Z) : e1 !== this._$AH && e1 !== $785da19a645c07eb$var$W && this._(e1) : void 0 !== e1._$litType$ ? this.$(e1) : void 0 !== e1.nodeType ? this.T(e1) : ((e1)=>$785da19a645c07eb$var$R(e1) || "function" == typeof e1?.[Symbol.iterator])(e1) ? this.k(e1) : this._(e1);
    }
    O(e1) {
        return this._$AA.parentNode.insertBefore(e1, this._$AB);
    }
    T(e1) {
        this._$AH !== e1 && (this._$AR(), this._$AH = this.O(e1));
    }
    _(e1) {
        this._$AH !== $785da19a645c07eb$var$Z && $785da19a645c07eb$var$z(this._$AH) ? this._$AA.nextSibling.data = e1 : this.T($785da19a645c07eb$var$I.createTextNode(e1)), this._$AH = e1;
    }
    $(e1) {
        const { values: t, _$litType$: i } = e1, n = "number" == typeof i ? this._$AC(e1) : (void 0 === i.el && (i.el = $785da19a645c07eb$var$Y.createElement($785da19a645c07eb$var$Q(i.h, i.h[0]), this.options)), i);
        if (this._$AH?._$AD === n) this._$AH.p(t);
        else {
            const e1 = new $785da19a645c07eb$var$$(n, this), i = e1.u(this.options);
            e1.p(t), this.T(i), this._$AH = e1;
        }
    }
    _$AC(e1) {
        let t = $785da19a645c07eb$var$K.get(e1.strings);
        return void 0 === t && $785da19a645c07eb$var$K.set(e1.strings, t = new $785da19a645c07eb$var$Y(e1)), t;
    }
    k(t) {
        $785da19a645c07eb$var$R(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let n, a = 0;
        for (const r of t)a === i.length ? i.push(n = new e1(this.O($785da19a645c07eb$var$F()), this.O($785da19a645c07eb$var$F()), this, this.options)) : n = i[a], n._$AI(r), a++;
        a < i.length && (this._$AR(n && n._$AB.nextSibling, a), i.length = a);
    }
    _$AR(e1 = this._$AA.nextSibling, t) {
        for(this._$AP?.(!1, !0, t); e1 !== this._$AB;){
            const t = $785da19a645c07eb$var$k(e1).nextSibling;
            $785da19a645c07eb$var$k(e1).remove(), e1 = t;
        }
    }
    setConnected(e1) {
        void 0 === this._$AM && (this._$Cv = e1, this._$AP?.(e1));
    }
}, $785da19a645c07eb$var$te = class {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(e1, t, i, n, a){
        this.type = 1, this._$AH = $785da19a645c07eb$var$Z, this._$AN = void 0, this.element = e1, this.name = t, this._$AM = n, this.options = a, i.length > 2 || "" !== i[0] || "" !== i[1] ? (this._$AH = Array(i.length - 1).fill(new String), this.strings = i) : this._$AH = $785da19a645c07eb$var$Z;
    }
    _$AI(e1, t = this, i, n) {
        const a = this.strings;
        let r = !1;
        if (void 0 === a) e1 = $785da19a645c07eb$var$J(this, e1, t, 0), r = !$785da19a645c07eb$var$z(e1) || e1 !== this._$AH && e1 !== $785da19a645c07eb$var$W, r && (this._$AH = e1);
        else {
            const n = e1;
            let s, o;
            for(e1 = a[0], s = 0; s < a.length - 1; s++)o = $785da19a645c07eb$var$J(this, n[i + s], t, s), o === $785da19a645c07eb$var$W && (o = this._$AH[s]), r ||= !$785da19a645c07eb$var$z(o) || o !== this._$AH[s], o === $785da19a645c07eb$var$Z ? e1 = $785da19a645c07eb$var$Z : e1 !== $785da19a645c07eb$var$Z && (e1 += (o ?? "") + a[s + 1]), this._$AH[s] = o;
        }
        r && !n && this.j(e1);
    }
    j(e1) {
        e1 === $785da19a645c07eb$var$Z ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, e1 ?? "");
    }
}, $785da19a645c07eb$var$ie = class extends $785da19a645c07eb$var$te {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(e1) {
        this.element[this.name] = e1 === $785da19a645c07eb$var$Z ? void 0 : e1;
    }
}, $785da19a645c07eb$var$ne = class extends $785da19a645c07eb$var$te {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(e1) {
        this.element.toggleAttribute(this.name, !!e1 && e1 !== $785da19a645c07eb$var$Z);
    }
}, $785da19a645c07eb$var$ae = class extends $785da19a645c07eb$var$te {
    constructor(e1, t, i, n, a){
        super(e1, t, i, n, a), this.type = 5;
    }
    _$AI(e1, t = this) {
        if ((e1 = $785da19a645c07eb$var$J(this, e1, t, 0) ?? $785da19a645c07eb$var$Z) === $785da19a645c07eb$var$W) return;
        const i = this._$AH, n = e1 === $785da19a645c07eb$var$Z && i !== $785da19a645c07eb$var$Z || e1.capture !== i.capture || e1.once !== i.once || e1.passive !== i.passive, a = e1 !== $785da19a645c07eb$var$Z && (i === $785da19a645c07eb$var$Z || n);
        n && this.element.removeEventListener(this.name, this, i), a && this.element.addEventListener(this.name, this, e1), this._$AH = e1;
    }
    handleEvent(e1) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, e1) : this._$AH.handleEvent(e1);
    }
}, $785da19a645c07eb$var$re = class {
    constructor(e1, t, i){
        this.element = e1, this.type = 6, this._$AN = void 0, this._$AM = t, this.options = i;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(e1) {
        $785da19a645c07eb$var$J(this, e1);
    }
};
const $785da19a645c07eb$var$se = $785da19a645c07eb$var$E.litHtmlPolyfillSupport;
$785da19a645c07eb$var$se?.($785da19a645c07eb$var$Y, $785da19a645c07eb$var$ee), ($785da19a645c07eb$var$E.litHtmlVersions ??= []).push("3.3.3");
const $785da19a645c07eb$var$oe = (e1, t, i)=>{
    const n = i?.renderBefore ?? t;
    let a = n._$litPart$;
    if (void 0 === a) {
        const e1 = i?.renderBefore ?? null;
        n._$litPart$ = a = new $785da19a645c07eb$var$ee(t.insertBefore($785da19a645c07eb$var$F(), e1), e1, void 0, i ?? {});
    }
    return a._$AI(e1), a;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }, $785da19a645c07eb$var$le = globalThis;
let $785da19a645c07eb$var$ce = class extends $785da19a645c07eb$var$w {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const e1 = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= e1.firstChild, e1;
    }
    update(e1) {
        const t = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e1), this._$Do = $785da19a645c07eb$var$oe(t, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return $785da19a645c07eb$var$W;
    }
};
$785da19a645c07eb$var$ce._$litElement$ = !0, $785da19a645c07eb$var$ce.finalized = !0, $785da19a645c07eb$var$le.litElementHydrateSupport?.({
    LitElement: $785da19a645c07eb$var$ce
});
const $785da19a645c07eb$var$ue = $785da19a645c07eb$var$le.litElementPolyfillSupport;
function $785da19a645c07eb$var$he() {
    return "https://panoramax.openstreetmap.fr/pmtiles/basic.json";
}
function $785da19a645c07eb$var$de() {
    return "https://panoramax.fr";
}
function $785da19a645c07eb$var$pe() {
    return "https://presets.panoramax.fr";
}
function $785da19a645c07eb$var$me() {
    return "https://explore.panoramax.fr";
}
function $785da19a645c07eb$var$ge(e1) {
    return `https://raw.githubusercontent.com/rapideditor/temaki/refs/heads/main/icons/${e1}.svg`;
}
function $785da19a645c07eb$var$fe() {
    return "https://www.wikidata.org/wiki";
}
function $785da19a645c07eb$var$Ae() {
    return "https://www.wikidata.org/w/rest.php/wikibase/v1";
}
function $785da19a645c07eb$var$_e() {
    return "https://www.openstreetmap.org/edit?editor=id";
}
function $785da19a645c07eb$var$ve() {
    return "https://wiki.openstreetmap.org/wiki";
}
function $785da19a645c07eb$var$ye() {
    return "https://openstreetmap.org";
}
function $785da19a645c07eb$var$xe() {
    return "https://files.pavie.info/depot/remote/indoorequal/indoorequal";
}
function $785da19a645c07eb$var$be() {
    return 10;
}
function $785da19a645c07eb$var$we() {
    return "https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg";
}
function $785da19a645c07eb$var$Ee() {
    return "https://data.geopf.fr/geocodage/search";
}
function $785da19a645c07eb$var$ke() {
    return "https://nominatim.openstreetmap.org";
}
$785da19a645c07eb$var$ue?.({
    LitElement: $785da19a645c07eb$var$ce
}), ($785da19a645c07eb$var$le.litElementVersions ??= []).push("4.2.2");
var $785da19a645c07eb$var$Se = Object.freeze({
    __proto__: null,
    AdresseDataGouvBaseURL: $785da19a645c07eb$var$Ee,
    IdEditorURL: $785da19a645c07eb$var$_e,
    IndoorEqualSpritesURL: $785da19a645c07eb$var$xe,
    InternetFastTestFile: $785da19a645c07eb$var$we,
    InternetFastThreshold: $785da19a645c07eb$var$be,
    MapTiles: $785da19a645c07eb$var$he,
    NominatimBaseUrl: $785da19a645c07eb$var$ke,
    OSMURL: $785da19a645c07eb$var$ye,
    OSMWikiURL: $785da19a645c07eb$var$ve,
    PanoramaxMetaCatalogURL: $785da19a645c07eb$var$me,
    PanoramaxPresetsURL: $785da19a645c07eb$var$pe,
    PanoramaxWebsiteURL: $785da19a645c07eb$var$de,
    TemakiIconURL: $785da19a645c07eb$var$ge,
    WikidataAPIURL: $785da19a645c07eb$var$Ae,
    WikidataURL: $785da19a645c07eb$var$fe
});
const $785da19a645c07eb$var$Me = "pnx-disable-annotations", $785da19a645c07eb$var$Ce = "geovisio-fake-id-0", $785da19a645c07eb$var$Te = {
    BASE: "#54278f",
    SELECTED: "#F4511E",
    HIDDEN: "#34495E",
    NEXT: "#ffab40",
    QUALI_1: "#00695C",
    QUALI_2: "#fd8d3c",
    PALETTE_0: "#FFF59D",
    PALETTE_1: "#FF8A65",
    PALETTE_2: "#C2185B",
    PALETTE_3: "#311B92",
    PALETTE_4: "#000000"
}, $785da19a645c07eb$var$De = Object.fromEntries(Object.entries($785da19a645c07eb$var$Te).map((e1)=>(e1[1] = parseInt(e1[1].slice(1), 16), e1))), $785da19a645c07eb$var$Pe = [
    {
        color: "#007f4e",
        label: "A"
    },
    {
        color: "#72b043",
        label: "B"
    },
    {
        color: "#b5be2f",
        label: "C"
    },
    {
        color: "#f8cc1b",
        label: "D"
    },
    {
        color: "#f6a020",
        label: "E"
    }
], $785da19a645c07eb$var$Ie = [
    1,
    10,
    2,
    15,
    3,
    30,
    4
], $785da19a645c07eb$var$Fe = [
    3,
    15,
    4,
    30,
    5
], $785da19a645c07eb$var$ze = [
    5,
    .5,
    4,
    2.01,
    3,
    5.01,
    2,
    10.01,
    1
], $785da19a645c07eb$var$Re = [
    {
        score: $785da19a645c07eb$var$ze[0],
        color: $785da19a645c07eb$var$Te.PALETTE_4,
        label: `- ${$785da19a645c07eb$var$ze[1]} m`
    },
    {
        score: $785da19a645c07eb$var$ze[2],
        color: $785da19a645c07eb$var$Te.PALETTE_3,
        label: `${$785da19a645c07eb$var$ze[1]} - ${Math.round($785da19a645c07eb$var$ze[3])} m`
    },
    {
        score: $785da19a645c07eb$var$ze[4],
        color: $785da19a645c07eb$var$Te.PALETTE_2,
        label: `${Math.round($785da19a645c07eb$var$ze[3])} - ${Math.round($785da19a645c07eb$var$ze[5])} m`
    },
    {
        score: $785da19a645c07eb$var$ze[6],
        color: $785da19a645c07eb$var$Te.PALETTE_1,
        label: `+ ${Math.round($785da19a645c07eb$var$ze[5])} m`
    }
];
function $785da19a645c07eb$var$Le(e1) {
    return [
        null,
        void 0,
        "",
        $785da19a645c07eb$var$Ce
    ].includes(e1);
}
function $785da19a645c07eb$var$Be(e1, t) {
    if (null == t || "" === t) return null;
    for(let i = 0; i < e1.length; i += 2){
        const n = e1[i];
        if (t < e1[i + 1]) return n;
    }
    return e1[e1.length - 1];
}
function $785da19a645c07eb$var$Oe(e1, t) {
    const i = e1[0] - t[0], n = e1[1] - t[1];
    return Math.sqrt(i * i + n * n);
}
function $785da19a645c07eb$var$Ue(e1, t = null) {
    return "HTMLImageElement" === e1.constructor.name ? (t && (e1.width = t.width, e1.height = t.height, e1.onload = t.onload), e1) : "string" == typeof e1 ? (t || ((t = new Image).alt = ""), e1.startsWith("<?xml") && (e1 = URL.createObjectURL(new Blob([
        e1
    ], {
        type: "image/svg+xml"
    }))), t.src = e1, t) : void 0;
}
function $785da19a645c07eb$var$Ne(e1, t) {
    try {
        if (e1.startsWith("data:image/svg+xml,") && (e1 = decodeURIComponent(e1.replace("data:image/svg+xml,", ""))), !e1.startsWith("<svg")) throw new Error;
        const i = (new DOMParser).parseFromString(e1, "image/svg+xml").childNodes[0], n = document.createElement("button");
        return n.appendChild(i), n.classList.add("pnx-psv-tour-arrows", "pnx-print-hidden"), n.style.color = t, n;
    } catch (t) {
        return $785da19a645c07eb$var$Ue(e1);
    }
}
function $785da19a645c07eb$var$je(e1) {
    const t = e1.cloneNode(!0);
    return t.addEventListener("pointerup", ()=>t.classList.add("pnx-clicked")), t;
}
function $785da19a645c07eb$var$Ve(e1, t) {
    return ($785da19a645c07eb$var$nt(Math.atan2(t[0] - e1[0], t[1] - e1[1])) + 360) % 360;
}
function $785da19a645c07eb$var$qe(e1, t) {
    const i = Math.abs(e1 - t) % 360;
    return i > 180 ? 360 - i : i;
}
function $785da19a645c07eb$var$Ge(e1) {
    if (!e1) return 0;
    let t, i;
    if (e1?.sequence?.prevPic) {
        const i = e1?.links?.find((t)=>t.nodeId === e1.sequence.prevPic);
        i && (t = $785da19a645c07eb$var$Ve(i.gps, e1.gps));
    }
    if (e1?.sequence?.nextPic) {
        const t = e1?.links?.find((t)=>t.nodeId === e1.sequence.nextPic);
        t && (i = $785da19a645c07eb$var$Ve(e1.gps, t.gps));
    }
    return void 0 !== t && void 0 !== i ? (t + i) / 2 % 360 : void 0 !== t ? t : void 0 !== i ? i : 0;
}
function $785da19a645c07eb$var$He(e1) {
    if (!e1) throw new Error("No picture selected");
    let t, i;
    const n = e1.properties["view:azimuth"];
    if (e1?.sequence?.prevPic) {
        const i = e1?.links?.find((t)=>t.nodeId === e1.sequence.prevPic);
        i && (t = (n - $785da19a645c07eb$var$Ve(i.gps, e1.gps) + 180) % 360 - 180);
    }
    if (e1?.sequence?.nextPic) {
        const t = e1?.links?.find((t)=>t.nodeId === e1.sequence.nextPic);
        t && (i = (n - $785da19a645c07eb$var$Ve(e1.gps, t.gps) + 180) % 360 - 180);
    }
    return void 0 !== t ? t : void 0 !== i ? i : 0;
}
function $785da19a645c07eb$var$We(e1, t) {
    const i = $785da19a645c07eb$var$nt(Math.atan2(t[0] - e1[0], t[1] - e1[1]));
    return Math.abs(i) < 30 ? "N" : i >= 30 && i < 90 ? "ENE" : i >= 90 && i < 150 ? "ESE" : Math.abs(i) >= 150 ? "S" : i <= -30 && i > -90 ? "WNW" : i <= -90 && i > -150 ? "WSW" : void 0;
}
function $785da19a645c07eb$var$Ze(e1, t) {
    const i = {
        x: $785da19a645c07eb$var$nt(e1.yaw),
        y: $785da19a645c07eb$var$nt(e1.pitch)
    };
    return void 0 !== t && (i.z = t), i;
}
function $785da19a645c07eb$var$Ke(e1, t, i) {
    return {
        yaw: $785da19a645c07eb$var$at(e1),
        pitch: $785da19a645c07eb$var$at(t),
        zoom: i
    };
}
function $785da19a645c07eb$var$Xe(e1) {
    const t = e1 < 0 ? Math.ceil(e1) : Math.floor(e1), i = 60 * Math.abs(e1 - t), n = Math.floor(i);
    return {
        d: t,
        m: n,
        s: parseFloat((60 * (i - n)).toFixed(3))
    };
}
function $785da19a645c07eb$var$Qe(e1) {
    if (e1) {
        const t = e1.gps, i = e1?.properties?.["view:azimuth"], n = 2e-4, a = {
            left: t[0] - (null === i || i >= 180 ? n : 0),
            right: t[0] + (null === i || i <= 180 ? n : 0),
            top: t[1] + (null === i || i <= 90 || i >= 270 ? n : 0),
            bottom: t[1] - (null === i || i >= 90 && i <= 270 ? n : 0),
            changeset_source: "Panoramax"
        };
        return Object.entries(a).map((e1)=>e1.join("=")).join("&");
    }
    return null;
}
function $785da19a645c07eb$var$Ye() {
    try {
        return window.self !== window.top;
    } catch (e1) {
        return !0;
    }
}
const $785da19a645c07eb$var$Je = "pnx-internet-fast";
function $785da19a645c07eb$var$$e() {
    try {
        const e1 = navigator.connection.downlink;
        return Promise.resolve(e1 >= 10);
    } catch (e1) {
        try {
            const e1 = sessionStorage.getItem($785da19a645c07eb$var$Je);
            if ([
                "true",
                "false"
            ].includes(e1)) return Promise.resolve("true" === e1);
            const t = (new Date).getTime();
            return fetch(`https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg?nocache=${t}`).then(async (e1)=>[
                    e1,
                    await e1.blob()
                ]).then(([e1, i])=>{
                const n = 8 * parseInt(e1.headers.get("Content-Length") || i.size) / 1024 / 1024 / (((new Date).getTime() - t) / 1e3) >= 10;
                return sessionStorage.setItem($785da19a645c07eb$var$Je, n ? "true" : "false"), n;
            }).catch((e1)=>(console.warn("Failed to run speedtest", e1), !1));
        } catch (e1) {
            return Promise.resolve(!1);
        }
    }
}
function $785da19a645c07eb$var$et(e1) {
    const t = document.cookie?.split(";")?.find((t)=>t.trimStart().startsWith(`${e1}=`))?.split("=");
    if (t) return t.shift(), t.join("=");
}
function $785da19a645c07eb$var$tt() {
    const e1 = $785da19a645c07eb$var$et("session"), t = $785da19a645c07eb$var$et("user_id"), i = $785da19a645c07eb$var$et("user_name");
    return e1 && t && i ? {
        id: t,
        name: i
    } : null;
}
function $785da19a645c07eb$var$it(e1, t) {
    const i = new Uint32Array(1);
    crypto.getRandomValues(i);
    let n = i[0] / 4294967296;
    return e1 = Math.ceil(e1), t = Math.floor(t), Math.floor(n * (t - e1 + 1)) + e1;
}
function $785da19a645c07eb$var$nt(e1) {
    return 180 * e1 / Math.PI;
}
function $785da19a645c07eb$var$at(e1) {
    return e1 * (Math.PI / 180);
}
var $785da19a645c07eb$var$rt = Object.freeze({
    __proto__: null,
    BASE_PANORAMA_ID: $785da19a645c07eb$var$Ce,
    COLORS: $785da19a645c07eb$var$Te,
    COLORS_HEX: $785da19a645c07eb$var$De,
    DISABLE_ANNOTATIONS_PARAM: $785da19a645c07eb$var$Me,
    GPS_VALUES: $785da19a645c07eb$var$Re,
    QUALITYSCORE_GPS_VALUES: $785da19a645c07eb$var$ze,
    QUALITYSCORE_POND_GPS: .2,
    QUALITYSCORE_POND_RES: .8,
    QUALITYSCORE_RES_360_VALUES: $785da19a645c07eb$var$Fe,
    QUALITYSCORE_RES_FLAT_VALUES: $785da19a645c07eb$var$Ie,
    QUALITYSCORE_VALUES: $785da19a645c07eb$var$Pe,
    deg2rad: $785da19a645c07eb$var$at,
    degToDms: $785da19a645c07eb$var$Xe,
    getAngularDiff: $785da19a645c07eb$var$qe,
    getArrow: $785da19a645c07eb$var$je,
    getAzimuth: $785da19a645c07eb$var$Ve,
    getCookie: $785da19a645c07eb$var$et,
    getDistance: $785da19a645c07eb$var$Oe,
    getGrade: $785da19a645c07eb$var$Be,
    getRelativeHeading: $785da19a645c07eb$var$He,
    getRoadAbsoluteHeading: $785da19a645c07eb$var$Ge,
    getSimplifiedAngle: $785da19a645c07eb$var$We,
    getUserAccount: $785da19a645c07eb$var$tt,
    inRangeRandom: $785da19a645c07eb$var$it,
    isInIframe: $785da19a645c07eb$var$Ye,
    isInternetFast: $785da19a645c07eb$var$$e,
    isNullId: $785da19a645c07eb$var$Le,
    josmBboxParameters: $785da19a645c07eb$var$Qe,
    positionToXYZ: $785da19a645c07eb$var$Ze,
    rad2deg: $785da19a645c07eb$var$nt,
    svgToImg: $785da19a645c07eb$var$Ue,
    svgToPSVLink: $785da19a645c07eb$var$Ne,
    xyzToPosition: $785da19a645c07eb$var$Ke
});
class $785da19a645c07eb$var$st extends EventTarget {
    constructor(e1, t = {}){
        if (super(), null == e1 || "string" != typeof e1) {
            const e1 = new Error("endpoint parameter is empty or not a valid string");
            throw this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: e1
                }
            })), e1;
        }
        if (e1.startsWith("/") && (e1 = window.location.href.split("/").slice(0, 3).join("/") + e1), !$785da19a645c07eb$var$st.isValidHttpUrl(e1)) {
            const t = new Error(`endpoint parameter is not a valid URL: ${e1}`);
            throw this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: t
                }
            })), t;
        }
        this._endpoint = e1, this._isReady = 0, this._dataBbox = null, this._fetchOpts = t?.fetch || {}, this._metadata = {}, this._configuration = null, t.skipReadLanding || (this._readLanding = fetch(e1, this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>this._parseLanding(e1, t)).catch((e1)=>(this._isReady = -1, console.error(e1), this.dispatchEvent(new CustomEvent("broken", {
                detail: {
                    error: e1
                }
            })), Promise.reject("Viewer failed to communicate with API"))).then(()=>(this._isReady = 1, this.dispatchEvent(new Event("ready")), "API is ready")));
    }
    onceReady() {
        return -1 === this._isReady ? Promise.reject("Viewer failed to communicate with API") : 1 === this._isReady ? Promise.resolve("API is ready") : this._readLanding;
    }
    isReady() {
        return 1 === this._isReady;
    }
    getAvailableFeatures() {
        return Object.entries(this._endpoints).filter((e1)=>null !== e1[1]).map((e1)=>e1[0]);
    }
    getUnavailableFeatures() {
        return Object.entries(this._endpoints).filter((e1)=>null === e1[1]).map((e1)=>e1[0]);
    }
    _parseLanding(e1, t) {
        if (this._endpoints = {
            collections: null,
            search: null,
            style: null,
            user_style: null,
            tiles: t?.tiles || null,
            user_tiles: null,
            user_search: null,
            collection_preview: null,
            item_preview: null,
            rss: null,
            report: null,
            queryables: null
        }, !e1 || !e1.links || !Array.isArray(e1.links)) throw new Error("API Landing page doesn't contain 'links' list");
        if (!e1.stac_version.startsWith("1.")) throw new Error(`API is not in a supported STAC version (Panoramax viewer supports only 1.x, API is ${e1.stac_version})`);
        this._metadata.name = e1.title || "Unnamed", this._metadata.stac_version = e1.stac_version, this._metadata.geovisio_version = e1.geovisio_version;
        const i = [], n = [];
        if ([
            {
                rel: "search",
                type: "application/geo+json",
                endpointId: "search",
                mandatory: !0,
                missingIssue: "No direct access to pictures metadata."
            },
            {
                rel: "data",
                type: "application/json",
                endpointId: "collections",
                mandatory: !0,
                missingIssue: "No way for viewer to access sequences."
            },
            {
                rel: "data",
                type: "application/rss+xml",
                endpointId: "rss"
            },
            {
                rel: "xyz",
                type: "application/vnd.mapbox-vector-tile",
                endpointId: "tiles"
            },
            {
                rel: "xyz-style",
                type: "application/json",
                endpointId: "style"
            },
            {
                rel: "user-xyz-style",
                type: "application/json",
                endpointId: "user_style"
            },
            {
                rel: "user-xyz",
                type: "application/vnd.mapbox-vector-tile",
                endpointId: "user_tiles"
            },
            {
                rel: "user-search",
                type: "application/json",
                endpointId: "user_search",
                missingIssue: "Filter map data by user name will not be available."
            },
            {
                rel: "collection-preview",
                type: "image/jpeg",
                endpointId: "collection_preview",
                missingIssue: "Display of thumbnail could be slower."
            },
            {
                rel: "item-preview",
                type: "image/jpeg",
                endpointId: "item_preview",
                missingIssue: "Display of thumbnail could be slower."
            },
            {
                rel: "report",
                type: "application/json",
                endpointId: "report"
            },
            {
                rel: "http://www.opengis.net/def/rel/ogc/1.0/queryables",
                type: "application/schema+json",
                endpointId: "queryables",
                missingIssue: "Tags map overlay will not be available."
            }
        ].forEach((t)=>{
            const a = e1.links.filter((e1)=>e1.rel === t.rel && e1.type === t.type);
            if (0 === a.length) {
                if (!this._endpoints[t.endpointId]) {
                    let e1 = `API doesn't offer a '${t.rel}' (${t.type}) endpoint in its links`;
                    t.missingIssue && (e1 += `\n${t.missingIssue}`), t.mandatory ? i.push(e1) : t.missingIssue && n.push(e1);
                }
            } else {
                const e1 = 1 === a.length ? a[0] : a.find((e1)=>e1.title?.includes("v2")) || a[0];
                if (!$785da19a645c07eb$var$st.isValidHttpUrl(e1.href)) throw new Error(`API endpoint '${e1.rel}' (${e1.type}) is not a valid URL: ${e1.href}`);
                this._endpoints[t.endpointId] && "xyz-style" !== t.endpointId || (this._endpoints[t.endpointId] = e1.href);
            }
        }), this._endpoints.style || this._endpoints.tiles || n.push("API doesn't offer 'xyz' or 'xyz-style' endpoints in its links.\nMap widget will not be available."), this._endpoints.user_style || this._endpoints.user_tiles || n.push("API doesn't offer 'user-xyz' or 'user-xyz-style' endpoints in its links.\nFilter map data by user ID will not be available."), n.forEach((e1)=>console.warn(e1)), i.length > 0) throw new Error(i.join("\n"));
        const a = e1?.extent?.spatial?.bbox;
        this._dataBbox = a && Array.isArray(a) && a.length > 0 && Array.isArray(a[0]) && 4 === a[0].length ? [
            [
                a[0][0],
                a[0][1]
            ],
            [
                a[0][2],
                a[0][3]
            ]
        ] : null;
    }
    _getFetchOptions(e1 = !1) {
        const t = Object.assign({}, this._fetchOpts);
        return e1 || (t.signal = AbortSignal.timeout(15e3)), t;
    }
    _getMapRequestTransform() {
        const e1 = this._getFetchOptions();
        return delete e1.signal, (t)=>{
            if (t.startsWith(this._endpoint)) {
                if (Object.keys(e1).length > 0) return {
                    url: t,
                    ...e1
                };
            } else if (t.includes("data.geopf.fr") && t.includes("@2x")) return {
                url: t.replace("@2x", "")
            };
        };
    }
    _getPSVWithCredentials() {
        return "include" === this._getFetchOptions().credentials ? (e1)=>e1.startsWith(this._endpoint) : void 0;
    }
    cleanResourceURL(e1) {
        if (!e1) return;
        const t = new URL(this._endpoint);
        return e1.startsWith("/") ? t.protocol + "//" + t.host + e1 : e1.startsWith("./") ? this._endpoint + e1.substring(1) : e1;
    }
    async getSequenceItems(e1, t = null, i = null, n = null) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        try {
            return $785da19a645c07eb$var$st.isIdValid(e1), await fetch(t || `${this._endpoints.collections}/${e1}/items${n ? "?limit=" + n : ""}`, this._getFetchOptions(!0)).then((e1)=>e1.json()).then((t)=>{
                let a = t;
                i && (a.features = i.features.concat(a.features));
                const r = t.links.find((e1)=>"next" === e1.rel);
                return !n && r ? this.getSequenceItems(e1, r.href, a) : a;
            });
        } catch (e1) {
            return await Promise.reject(e1);
        }
    }
    getPicturesAroundCoordinatesUrl(e1, t, i = 5e-4, n = null, a = null) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (isNaN(parseFloat(e1)) || isNaN(parseFloat(t))) throw new Error("lat and lon parameters should be valid numbers");
        const r = [
            t - i,
            e1 - i,
            t + i,
            e1 + i
        ].map((e1)=>e1.toFixed(7)).join(","), s = n ? `&limit=${n}` : "", o = a ? `&collections=${a}` : "";
        return `${this._endpoints.search}?bbox=${r}${s}${o}`;
    }
    getPicturesAroundCoordinates(e1, t, i, n, a) {
        return fetch(this.getPicturesAroundCoordinatesUrl(e1, t, i, n, a), this._getFetchOptions()).then((e1)=>e1.json());
    }
    getPictureMetadataUrl(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if ($785da19a645c07eb$var$st.isIdValid(e1)) return t ? `${this._endpoints.collections}/${t}/items/${e1}` : `${this._endpoints.search}?ids=${e1}`;
    }
    findThumbnailInPictureFeature(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e1 || !e1.assets) return null;
        let t = null;
        for (let i of Object.values(e1.assets)){
            if (i.roles.includes("thumbnail") && "image/jpeg" === i.type && $785da19a645c07eb$var$st.isValidHttpUrl(i.href)) return this.cleanResourceURL(i.href);
            i.roles.includes("visual") && "image/jpeg" === i.type && $785da19a645c07eb$var$st.isValidHttpUrl(i.href) && (t = this.cleanResourceURL(i.href));
        }
        return t;
    }
    getPictureThumbnailURLForSequence(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (this._endpoints.collection_preview) return Promise.resolve(this._endpoints.collection_preview.replace("{id}", e1));
        if (t && Array.isArray(t.links) && t.links.length > 0) {
            let e1 = t.links.find((e1)=>"preview" === e1.rel && "image/jpeg" === e1.type);
            if (e1 && $785da19a645c07eb$var$st.isValidHttpUrl(e1.href)) return Promise.resolve(e1.href);
        }
        const i = `${this._endpoints.search}?limit=1&collections=${e1}`;
        return fetch(i, this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>Array.isArray(e1.features) && 0 !== e1.features.length ? this.findThumbnailInPictureFeature(e1.features.pop()) : null);
    }
    getPictureThumbnailURL(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return e1 ? this._endpoints.item_preview ? Promise.resolve(this._endpoints.item_preview.replace("{id}", e1)) : e1 && t ? fetch(`${this._endpoints.collections}/${t}/items/${e1}`, this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>e1 ? this.findThumbnailInPictureFeature(e1) : null) : fetch(`${this._endpoints.search}?ids=${e1}`, this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>e1 && Array.isArray(e1.features) && 0 !== e1.features.length ? this.findThumbnailInPictureFeature(e1.features.pop()) : null) : Promise.resolve(null);
    }
    getRSSURL(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (this._endpoints.rss) {
            let t = this._endpoints.rss;
            return e1 && (t += t.includes("?") ? "&" : "?", t += "bbox=" + [
                e1.getWest(),
                e1.getSouth(),
                e1.getEast(),
                e1.getNorth()
            ].join(",")), t;
        }
        return null;
    }
    getSequenceMetadataUrl(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return `${this._endpoints.collections}/${e1}`;
    }
    getSequenceMetadata(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return fetch(this.getSequenceMetadataUrl(e1), this._getFetchOptions()).then((e1)=>e1.json());
    }
    getDataBbox() {
        if (!this.isReady()) throw new Error("API is not ready to use");
        return this._dataBbox;
    }
    searchUsers(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.user_search) throw new Error("User search is not available");
        return fetch(`${this._endpoints.user_search}?q=${e1}`, this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>e1?.features || null);
    }
    getUserName(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.user_search) throw new Error("User search is not available");
        return fetch(this._endpoints.user_search.replace(/\/search$/, `/${e1}`), this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>e1?.label || e1?.name || null);
    }
    sendReport(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!this._endpoints.report) throw new Error("Report sending is not available");
        const t = {
            ...this._getFetchOptions(),
            method: "POST",
            body: JSON.stringify(e1),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(this._endpoints.report, t).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return e1.json();
        });
    }
    deletePicture(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let i = `${this._endpoint}/collections/${e1}/items/${t}`;
        const n = {
            ...this._getFetchOptions(),
            method: "DELETE"
        };
        return fetch(i, n).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return !0;
        });
    }
    sendPictureSemantics(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e1?.sequence?.id || !e1?.id) throw new Error("Missing IDs from picture");
        let i = this.getPictureMetadataUrl(e1.id, e1.sequence.id);
        e1?.origInstance && (i = `${e1.origInstance.href}/api/collections/${e1.sequence.id}/items/${e1.id}`);
        const n = {
            ...this._getFetchOptions(),
            method: "PATCH",
            body: JSON.stringify({
                semantics: t
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(i, n).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return e1.json();
        });
    }
    createPictureAnnotation(e1, t, i) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        if (!e1?.sequence?.id || !e1?.id) throw new Error("Missing IDs from picture");
        let n = this.getPictureMetadataUrl(e1.id, e1.sequence.id) + "/annotations";
        e1?.origInstance && (n = `${e1.origInstance.href}/api/collections/${e1.sequence.id}/items/${e1.id}/annotations`);
        const a = {
            ...this._getFetchOptions(),
            method: "POST",
            body: JSON.stringify({
                semantics: i,
                shape: {
                    type: "Polygon",
                    coordinates: [
                        t
                    ]
                }
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(n, a).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return e1.json();
        });
    }
    editPictureAnnotation(e1, t) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let i = `${this._endpoint}/annotations/${e1}`;
        const n = {
            ...this._getFetchOptions(),
            method: "PATCH",
            body: JSON.stringify({
                semantics: t
            }),
            headers: {
                "Content-Type": "application/json"
            }
        };
        return fetch(i, n).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return e1.json();
        });
    }
    deletePictureAnnotation(e1) {
        if (!this.isReady()) throw new Error("API is not ready to use");
        let t = `${this._endpoint}/annotations/${e1}`;
        const i = {
            ...this._getFetchOptions(),
            method: "DELETE"
        };
        return fetch(t, i).then(async (e1)=>{
            if (e1.status >= 400) {
                let t = await e1.text();
                try {
                    t = JSON.parse(t).message;
                } catch (e1) {}
                return Promise.reject(t);
            }
            return !0;
        });
    }
    getAuthURL() {
        return this._configuration ? Promise.resolve(!!this._configuration?.auth?.enabled && `${this._endpoint}/auth/login?next_url=<CBURL>`) : null === this._configuration ? fetch(this._endpoint + "/configuration", this._getFetchOptions()).then((e1)=>e1.json()).then((e1)=>(this._configuration = e1, this.getAuthURL())).catch(()=>(this._configuration = !1, !1)) : Promise.resolve(!1);
    }
    static isValidHttpUrl(e1) {
        let t;
        try {
            t = new URL(e1);
        } catch (e1) {
            return !1;
        }
        return "http:" === t.protocol || "https:" === t.protocol;
    }
    static isIdValid(e1) {
        if ($785da19a645c07eb$var$Le(e1)) throw new Error("id should be a valid picture unique identifier");
        return !0;
    }
}
var $785da19a645c07eb$var$ot = {
    psv: {
        twoFingers: "Use two fingers to navigate",
        ctrlZoom: "Use ctrl + scroll to zoom the image",
        loadError: "The panorama can't be loaded"
    },
    maplibre: {
        "GeolocateControl.FindMyLocation": "Find my location",
        "GeolocateControl.LocationNotAvailable": "Location not available"
    },
    pnx: {
        zoom: "Zoom",
        zoomOut: "Zoom out",
        zoomIn: "Zoom in",
        moveUp: "Move up",
        moveDown: "Move down",
        moveLeft: "Move left",
        moveRight: "Move right",
        moveMiddle: "Center view",
        expand: "Expand",
        expand_info: "Make the widget appear in full page",
        show_psv: "Show the picture viewer",
        show_map: "Show the map",
        time_travel: "See this place on other dates",
        time_travel_close: "Hide other dates",
        minimize: "Hide this widget, you can show it again using the button in the bottom left corner",
        minimize_short: "Hide",
        options: "Options",
        filters: "Filters",
        layers: "Layers",
        search: "Search",
        search_empty: "No results found",
        search_address: "Search an address or city etc...",
        search_user: "Search a username\u2026",
        share: "Share",
        share_links: "Links",
        share_page: "Link to this picture",
        share_image: "HD Image",
        share_rss: "RSS feed",
        share_rss_title: "RSS feed of new sequences in the currently visible map area",
        share_embed: "Embed on your website",
        share_embed_docs: "Read more about embed configuration",
        share_print: "Print",
        panoramax: "Panoramax",
        whats_panoramax: "Panoramax is the geo-commons for territories' pictures.",
        copy: "Copy",
        copied: "Copied",
        error: "We have a problem\u2026",
        error_click: "Continue",
        error_retry: "Please retry later",
        sequence_next: "Next picture in sequence",
        sequence_play: "Play along this sequence",
        sequence_play_backwards: "Play along this sequence, backwards",
        sequence_pause: "Pause sequence",
        sequence_prev: "Previous picture in sequence",
        sequence_more: "More play options",
        sequence_speed: "Player speed",
        legend_license: "License: {l}",
        legend_title: "Show details of picture",
        id: "iD",
        contribute_id: "Contribute to OpenStreetMap with the iD editor",
        geo_uri: "External app",
        josm: "JOSM",
        josm_live: "Enable JOSM automatic sync on picture loading",
        loading_labels_serious: [
            "\uD83D\uDDFA\uFE0F Loading map data",
            "\uD83D\uDDA5\uFE0F Querying API",
            "\uD83D\uDDBC\uFE0F Loading thumbnails",
            "\uD83D\uDD0D Analyzing EXIF metadata",
            "\uD83C\uDFD8\uFE0F 3D rendering",
            "\uD83D\uDCF7 Initializing 360\xb0 pictures",
            "\uD83D\uDFE0 Colour balancing",
            "\uD83D\uDCAF Computing Quality Score \xa9",
            "\uD83D\uDCE1 Downloading updates",
            "\uD83C\uDF0D Fetching map tiles",
            "\uD83D\uDCF8 Processing shadows"
        ],
        loading_labels_fun: [
            "\uD83E\uDD8C Detecting deer crossing signs",
            "\uD83D\uDE98 Searching Panoramax Car \xa9",
            "\u2615 Injecting caffeine",
            "\uD83D\uDE00 Smile, you've been mapped!",
            "\uD83D\uDC08 Sharing cat pictures",
            "\uD83D\uDE34 Reducing procrastination",
            "\uD83E\uDED6 Brewing tea",
            "\uD83D\uDC27 Opening source code",
            "\uD83D\uDE87 Indexing Underground stations",
            "\uD83E\uDDF9 Cleaning up metadata",
            "\uD83D\uDE92 Sending fire station photos",
            "\uD83D\uDEB2 Updating cycling routes",
            "\uD83D\uDE89 Walking down station platform",
            "\uD83D\uDEF0\uFE0F Searching for satellites",
            "\uD83D\uDC65 Writing personas",
            "\uD83D\uDC1F Locating chip shops",
            "\uD83E\uDDD1\u200D\uD83D\uDCBB Debugging the interface",
            "\uD83D\uDCC8 Incrementing statistics",
            "\uD83E\uDD16 Learning semantics",
            "\uD83C\uDFA8 Redesigning interface",
            "\uD83D\uDCC5 Planning photo-mapping-parties",
            "\uD83E\uDDC0 Maturing cheddars",
            "\uD83C\uDF04 Calculating Cornish sunshine",
            "\uD83C\uDF0A Measuring the high tides"
        ],
        error_psv: "Photo Sphere Viewer is not loading properly",
        error_pic: "The requested picture wasn't found",
        error_nopic: "No picture available at given position",
        error_api: "The pictures server is not available",
        error_pic_load: "This picture can't be loaded at the moment.\nPlease check your Internet connection. If you're connected, make sure the picture ID is valid.",
        error_webgl: "WebGL is not supported by your browser",
        error_josm: "JOSM didn't respond, is it running and is Remote Control enabled?",
        error_api_compatibility: "The pictures server is not compatible with this viewer version",
        filter_source_world: "Entire world",
        filter_source_local: "This server",
        filter_date: "Date",
        filter_date_1month: "1 month",
        filter_date_6months: "6 months",
        filter_date_1year: "1 year",
        filter_user: "User",
        filter_user_mypics: "My pictures",
        filter_picture: "Picture type",
        filter_locked: "Filter disabled",
        filter_zoom_in: "Zoom-in to unlock",
        widget_locked: "Option disabled",
        picture_all: "All",
        picture_flat: "Classic",
        picture_360: "360\xb0",
        picture_flat_long: "Classic picture",
        picture_360_long: "Panoramic picture",
        popup_details_link: "More details",
        filter_qualityscore: "Quality score",
        filter_qualityscore_help: "Click to enable or disable",
        qualityscore_doc_1: "A Quality Score is computed for each picture.",
        qualityscore_doc_2: "The Score is shown as a letter:",
        qualityscore_doc_3: '"A" is the best grade, "E" the worst.',
        qualityscore_doc_4: "This Score is computed based on:",
        qualityscore_doc_41: "the GPS precision",
        qualityscore_doc_42: "the picture resolution",
        qualityscore_doc_5: "A professional device will have an A-grade, a 360\xb0 action camera a B-grade, and a smartphone a grade between C and E.",
        qualityscore_doc_link: "Know more about the Quality Score",
        filter_gps_precision: "Location precision",
        filter_gps_precision_lessthan: "Less than {n} meters",
        filter_gps_precision_between: "Between {n1} and {n2} meters",
        filter_gps_precision_morethan: "More than {n} meters",
        filter_gps_precision_help: "Learn more about Location Precision",
        filter_gps_precision_help_1: "A Location Precision score is available for every picture. This corresponds to GPS precision during picture capture.",
        filter_gps_precision_help_2: "The precision is expressed with stars:",
        filter_gps_precision_help_3: '"5\u2B50" is very precise (<= {p5}m), "1\u2B50" is very imprecise (> {p1}m) or unknown.',
        filter_gps_precision_help_4: 'A RTK GPS will have a "5\u2B50" grade, an action camera like GoPro Max a "3\u2B50" grade, and a smartphone GPS in an underground parking a "1\u2B50" grade.',
        map_background: "Background",
        map_background_aerial: "Aerial",
        map_background_streets: "Streets",
        map_background_default: "Default",
        map_background_more: "More",
        map_theme: "Theme",
        map_theme_default: "Default",
        map_theme_default_short: "Default",
        map_theme_default_coef: "Level of coverage",
        map_theme_default_coef_short: "Coverage",
        map_theme_default_1: "Low",
        map_theme_default_2: "Average",
        map_theme_default_3: "Good",
        map_theme_default_4: "Excellent",
        map_theme_age: "Capture date",
        map_theme_age_1: "+ 3 years",
        map_theme_age_2: "1 - 3 years",
        map_theme_age_3: "\xbd - 1 year",
        map_theme_age_4: "- 6 months",
        map_theme_type: "Camera type",
        map_theme_score: "Quality score",
        map_theme_gps: "GPS precision",
        map_theme_age_short: "Date",
        map_theme_type_short: "Camera",
        map_theme_score_short: "Quality",
        map_theme_gps_short: "Position",
        contrast: "Enable higher image contrast",
        low_contrast: "Lower image contrast",
        reset_contrast: "Reset image contrast",
        metadata: "Picture metadata",
        metadata_summary: "Summary",
        metadata_general_copy_id: "Copy ID",
        metadata_general_copy_picid: "Copy picture ID",
        metadata_general_picid: "Picture",
        metadata_general_seqid: "Sequence",
        metadata_general_picid_link: "Go to JSON description of the picture",
        metadata_general_seqid_link: "Go to JSON description of the sequence",
        metadata_general_title: "Title",
        metadata_general_author: "Author",
        metadata_general_license: "License",
        metadata_general_license_link: "See the full licence description",
        metadata_general_date: "Capture date",
        metadata_general_instance: "Origin instance",
        metadata_camera: "Camera",
        metadata_camera_make: "Make",
        metadata_camera_model: "Model",
        metadata_camera_type: "Type",
        metadata_camera_resolution: "Resolution",
        metadata_camera_focal_length: "Focal length",
        metadata_location: "Position",
        metadata_location_coordinates: "Coordinates (longitude, latitude)",
        metadata_location_orientation: "Direction",
        metadata_location_precision: "Positioning precision",
        metadata_location_copy: "Copy {v}",
        metadata_location_copy_more: "More coordinates copy options",
        metadata_quality: "Quality",
        metadata_quality_help: "Learn more about the Quality Score",
        metadata_quality_score: "Global score",
        metadata_quality_gps_score: "Positioning score",
        metadata_quality_resolution_score: "Resolution score",
        metadata_quality_missing: "no value set in picture",
        metadata_exif: "EXIF",
        metadata_exif_name: "Tag",
        metadata_exif_value: "Value",
        metadata_exif_doc: "Docs for EXIF tags",
        metadata_exif_doc_title: "Go to Exiv2 documentation to see full details of EXIF and XMP tag definitions",
        semantics_title: "Tags",
        semantics_tags: "{nb} tags",
        semantics_features: "Picture features",
        semantics_features_none: "No feature has been drawn in this picture yet.",
        semantics_features_default_title: "Tag {nb}",
        semantics_features_subtitle: "{nb} associated properties",
        semantics_annotation_tooltip: "Click to see details",
        semantics_annotation_tooltip_close: "Click to unselect",
        semantics_show_all_tags: "Show all tags",
        semantics_hide_all_tags: "Hide all tags",
        semantics_key: "Key",
        semantics_value: "Value",
        semantics_sequence_tags: "Sequence tag",
        semantics_picture_tags: "Picture tag",
        semantics_annotation_tags: "Object tag",
        semantics_doc: "Help",
        semantics_doc_info1: "Give context around a picture using tags.",
        semantics_doc_info1u1: "You can tag it as captured by car with the transport=car tag.",
        semantics_doc_info2: "You can draw objects in the picture as well: road signs, urban equipments\u2026 Mark what you see using existing tags. You can create your own ones as well if necessary.",
        semantics_doc_info3: "Some objects are automatically detected with AI: quality is not guaranteed.",
        semantics_doc_link: "Know more about tags",
        semantics_key_doc: "Know more about this key",
        semantics_value_doc: "Know more about this tag",
        semantics_value_show_osm: "See on OpenStreetMap",
        semantics_qualifiers: "Qualifiers",
        semantics_show_annotations: "Display picture features",
        semantics_hide_annotations: "Hide picture features",
        semantics_zero_annotations: "No features drawn on this picture",
        semantics_add_annotation: "Add a new tag",
        semantics_draw_annotation: "You can draw the object you want to add over the picture (Optional).",
        semantics_draw_invalid_annotation: "The drawn area goes beyond picture limits. Please make sure to draw within visible picture.",
        semantics_draw_unfinished_annotation: "The drawn area is unfinished. Make sure the area is well-positioned before saving.",
        semantics_erase_annotation: "Erase drawn feature",
        semantics_delete_annotation: "Delete this feature",
        semantics_delete_annotation_confirm: "Do you really want to delete this tag?",
        semantics_wikidata_properties: {
            P31: "instance of",
            P180: "depicts",
            P279: "subclass of",
            P361: "part of"
        },
        semantics_editor_error: "The syntax is invalid. Your tags may look like:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nMax key length is 256 characters, max value length 2048 characters.",
        semantics_editor_example: "key=value\nprefix|key=value",
        semantics_copy: "Copy attributes",
        semantics_edit: "Edit attributes",
        semantics_save: "Save your changes",
        semantics_undo: "Cancel your edits",
        semantics_send_fail: "Unable to save your changes, please try again later",
        semantics_login_needed: "In order to edit picture tags or features, you need to login to Panoramax {n} instance. Do you want to login?",
        semantics_empty: "No tags defined",
        semantics_overlays: {
            tfsigns: "Traffic signs",
            features: "All features"
        },
        semantics_zoom_in: "Zoom in to the map to view tags",
        semantics_download: "Download",
        semantics_download_title: "Download tags",
        semantics_download_info: "All semantic data (tags) is available as open data. You can download and use them as you like.",
        semantics_download_cta: "Download open data",
        delete_picture: "Delete",
        delete_picture_warn: "\u26A0\uFE0F Caution: this will permanently delete this picture.\nAre you sure you want to proceed?",
        delete_picture_ok: "Picture was successfully deleted",
        delete_picture_error: "An error occurred when trying to delete the picture:\n{e}",
        report: "Report",
        report_auth: 'This report will be sent using your account "{a}"',
        report_nature_label: "Cause of the issue",
        report_nature: {
            "": "Select the nature of issue\u2026",
            blur_missing: "A person's face or car license plate is visible",
            blur_excess: "An unnecessary blur was applied to an object",
            inappropriate: "Picture is inappropriate (unrelated, nudity\u2026)",
            privacy: "Picture was taken from a private path or property",
            picture_low_quality: "Picture is low quality",
            mislocated: "Picture is poorly positioned on map",
            copyright: "Picture infringes copyright",
            other: "Any other kind of issue"
        },
        report_whole_sequence: "This concerns the entire sequence",
        report_details: "Additional details",
        report_details_placeholder: "Optionally, you can add details about the issue",
        report_email: "Your email",
        report_email_placeholder: "Optional",
        report_submit: "Submit",
        report_wait: "Sending report\u2026",
        report_success: "Report was sent successfully. It will be reviewed as soon as possible.",
        report_failure: "An error occurred when creating report: {e}. Please try again later.",
        indoor_switch: "Indoor spaces",
        indoor_selector_expand: "Click to see all available levels",
        indoor_selector_shrink: "Click to minimize",
        indoor_selector_levelup: "Go to upper level",
        indoor_selector_leveldown: "Go to lower level",
        indoor_selector_scrollup: "Scroll the level list up",
        indoor_selector_scrolldown: "Scroll the level list down",
        "visibility_logged-only": "Members",
        "visibility_title_logged-only": "Only people with an account can see this picture",
        "visibility_owner-only": "Hidden",
        "visibility_title_owner-only": "Only you can see this picture"
    },
    map: {
        loading: "Loading\u2026",
        thumbnail: "Thumbnail of hovered picture",
        not_public: "Not publicly visible",
        slow_loading: "Map is loading slowly and may appear broken",
        map_data: "Map based on {m}",
        more_panoramax: "Discover more about Panoramax"
    }
}, $785da19a645c07eb$var$lt = {
    pnx: {
        contrast: "\u589E\u52A0\u76F8\u7247\u5C0D\u6BD4\u5EA6",
        copied: "\u5DF2\u8907\u88FD",
        copy: "\u8907\u88FD",
        edit_osm: "\u7DE8\u8F2F OSM",
        error: "Panoramax \u7576\u6A5F\u4E86\u2026",
        error_api: "\u76F8\u7247\u4F3A\u670D\u5668\u7121\u6CD5\u4F7F\u7528",
        error_api_compatibility: "\u76F8\u7247\u4F3A\u670D\u5668\u548C\u6B64\u6AA2\u8996\u5668\u7684\u7248\u672C\u4E0D\u76F8\u5BB9",
        error_josm: "JOSM \u6C92\u6709\u56DE\u61C9\uFF0C\u5B83\u5DF2\u7D93\u555F\u52D5\u4E14\u555F\u7528\u9060\u7AEF\u63A7\u5236\u4E86\u55CE?",
        error_nopic: "\u641C\u5C0B\u7684\u4F4D\u7F6E\u9644\u8FD1\u6C92\u6709\u76F8\u7247",
        error_pic: "\u627E\u4E0D\u5230\u6307\u5B9A\u7684\u76F8\u7247",
        error_psv: "\u7121\u6CD5\u6B63\u78BA\u8F09\u5165 Photo Sphere Viewer",
        error_subtitle: "\u8ACB\u7A0D\u5F8C\u91CD\u8A66\u6216\u6AA2\u67E5\u700F\u89BD\u5668\u7684\u4E3B\u63A7\u53F0\u4EE5\u4E86\u89E3\u8A73\u60C5\u3002",
        error_webgl: "\u60A8\u7684\u700F\u89BD\u5668\u4E0D\u652F\u63F4 WebGL",
        expand: "\u5C55\u958B",
        expand_info: "\u5728\u6574\u500B\u756B\u9762\u986F\u793A\u6B64\u5C0F\u5DE5\u5177",
        filter_camera_model: "\u6309\u76F8\u6A5F\u578B\u865F",
        filter_date: "\u65E5\u671F",
        filter_picture: "\u76F8\u7247\u985E\u578B",
        filter_user: "\u4F7F\u7528\u8005",
        filter_zoom_in: "\u62C9\u8FD1\u89E3\u9396",
        filters: "\u7BE9\u9078\u5668",
        id: "iD",
        josm: "JOSM",
        josm_live: "\u555F\u7528\u8F09\u5165\u76F8\u7247\u6642\u81EA\u52D5\u540C\u6B65 JOSM",
        layers: "\u5716\u5C64",
        legend_license: "\u6388\u6B0A: {l}",
        loading_labels_fun: [
            "\uD83E\uDD8C \u5075\u6E2C\u5230\u7576\u5FC3\u6885\u82B1\u9E7F\u6A19\u8A8C",
            "\uD83D\uDE98 \u6B63\u5728\u641C\u5C0B Panoramax \u6C7D\u8ECA \xa9",
            "\u2615 \u6CE8\u5165\u5496\u5561\u56E0",
            "\uD83D\uDE00 \u8ACB\u5FAE\u7B11\uFF0C\u60A8\u5DF2\u88AB\u6A19\u8A18\u5728\u5730\u5716\u4E0A\u4E86\uFF01",
            "\uD83D\uDC08 \u6B63\u5728\u5206\u4EAB\u8C93\u54AA\u7684\u76F8\u7247",
            "\uD83D\uDE34 \u6B63\u5728\u6E1B\u5C11\u5EF6\u9072",
            "\uD83E\uDED6 \u6B63\u5728\u6C8F\u58FA\u597D\u8336",
            "\uD83D\uDC27 \u6B63\u5728\u958B\u555F\u539F\u59CB\u78BC",
            "\uD83D\uDE87 \u6B63\u5728\u7D22\u5F15\u5730\u9435\u8ECA\u7AD9",
            "\uD83E\uDDF9 \u6E05\u7406\u8A6E\u91CB\u8CC7\u6599",
            "\uD83D\uDE92 \u6B63\u5728\u50B3\u9001\u6D88\u9632\u968A\u7684\u76F8\u7247",
            "\uD83D\uDEB2 \u66F4\u65B0\u7DA0\u9053",
            "\uD83D\uDE89 \u6B63\u5728\u901A\u904E\u8ECA\u7AD9\u6708\u53F0",
            "\uD83D\uDEF0\uFE0F \u6B63\u5728\u641C\u5C0B\u885B\u661F",
            "\uD83D\uDC65 \u6B63\u5728\u64B0\u5BEB\u4EBA\u7269\u8A8C",
            "\uD83C\uDF57 \u6B63\u5728\u5B9A\u4F4D\u9E79\u9165\u96DE\u5E97",
            "\uD83E\uDDD1\u200D\uD83D\uDCBB \u6B63\u5728\u5075\u932F\u4ECB\u9762",
            "\uD83D\uDCC8 \u7D71\u8A08\u6578\u64DA\u6B63\u5728\u589E\u52A0",
            "\uD83E\uDD16 \u6B63\u5728\u5B78\u7FD2\u8A9E\u7FA9",
            "\uD83C\uDFA8 \u91CD\u65B0\u8A2D\u8A08\u4ECB\u9762",
            "\uD83D\uDCC5 \u6B63\u5728\u898F\u5283\u76F8\u7247\u5730\u5716\u7E6A\u5716\u805A\u6703",
            "\uD83E\uDDC0 \u6B63\u5728\u719F\u6210\u5207\u9054\u8D77\u53F8",
            "\uD83C\uDF04 \u6B63\u5728\u8A08\u7B97\u6046\u6625\u7684\u65E5\u7167\u6642\u6578",
            "\uD83C\uDF0A \u6B63\u5728\u6E2C\u91CF\u6F6E\u6C50"
        ],
        loading_labels_serious: [
            "\uD83D\uDDFA\uFE0F \u6B63\u5728\u8F09\u5165\u5730\u5716\u8CC7\u6599",
            "\uD83D\uDDA5\uFE0F \u6B63\u5728\u67E5\u8A62 API",
            "\uD83D\uDDBC\uFE0F \u6B63\u5728\u8F09\u5165\u7E2E\u5716",
            "\uD83D\uDD0D \u6B63\u5728\u5206\u6790 EXIF \u8A6E\u91CB\u8CC7\u6599",
            "\uD83C\uDFD8\uFE0F \u6B63\u5728\u7B97\u7E6A 3D",
            "\uD83D\uDCF7 \u6B63\u5728\u521D\u59CB\u5316 360\xb0 \u76F8\u7247",
            "\uD83D\uDFE0 \u6B63\u5728\u5E73\u8861\u8272\u5F69",
            "\uD83D\uDCAF \u6B63\u5728\u8A08\u7B97\u54C1\u8CEA\u5206\u6578 \xa9",
            "\uD83D\uDCE1 \u6B63\u5728\u4E0B\u8F09\u66F4\u65B0",
            "\uD83C\uDF0D \u6B63\u5728\u53D6\u5F97\u5730\u5716\u5716\u78DA",
            "\uD83D\uDCF8 \u6B63\u5728\u8655\u7406\u9670\u5F71"
        ],
        map_background: "\u80CC\u666F",
        map_background_aerial: "\u885B\u661F",
        map_background_streets: "\u9810\u8A2D",
        map_theme: "\u4E3B\u984C",
        map_theme_age: "\u62CD\u651D\u6642\u9593",
        map_theme_age_1: "> 3 \u5E74",
        map_theme_age_2: "< 3 \u5E74",
        map_theme_age_3: "\xbd - 1 \u5E74",
        map_theme_age_4: "< 6 \u500B\u6708",
        map_theme_default: "\u9810\u8A2D",
        map_theme_type: "\u76F8\u6A5F\u985E\u578B",
        metadata: "\u76F8\u7247\u8A6E\u91CB\u8CC7\u6599",
        metadata_camera: "\u76F8\u6A5F",
        metadata_camera_focal_length: "\u7126\u8DDD",
        metadata_camera_make: "\u88FD\u9020\u5546",
        metadata_camera_model: "\u578B\u865F",
        metadata_camera_type: "\u985E\u578B",
        metadata_exif: "EXIF",
        metadata_exif_name: "\u6A19\u7C64",
        metadata_exif_value: "\u503C",
        metadata_general_author: "\u4F5C\u8005",
        metadata_general_date: "\u62CD\u651D\u6642\u9593",
        metadata_general_license: "\u6388\u6B0A",
        metadata_general_license_link: "\u67E5\u770B\u5B8C\u6574\u6388\u6B0A\u689D\u6B3E",
        metadata_general_picid: "\u76F8\u7247",
        metadata_general_picid_link: "\u524D\u5F80\u672C\u76F8\u7247\u7684 JSON \u8AAA\u660E",
        metadata_general_seqid: "\u5E8F\u5217",
        metadata_general_seqid_link: "\u524D\u5F80\u672C\u5E8F\u5217\u7684 JSON \u8AAA\u660E",
        metadata_location: "\u4F4D\u7F6E",
        metadata_location_latitude: "\u7DEF\u5EA6",
        metadata_location_longitude: "\u7D93\u5EA6",
        metadata_location_orientation: "\u65B9\u5411",
        metadata_location_precision: "\u5B9A\u4F4D\u7CBE\u5EA6",
        minimize: "\u96B1\u85CF\u9019\u500B\u5C0F\u5DE5\u5177\uFF0C\u60A8\u53EF\u4EE5\u6309\u5DE6\u4E0B\u89D2\u7684\u6309\u9215\u518D\u6B21\u986F\u793A\u5B83",
        moveDown: "\u4E0B\u79FB",
        moveLeft: "\u5DE6\u79FB",
        moveMiddle: "\u756B\u9762\u7F6E\u4E2D",
        moveRight: "\u53F3\u79FB",
        moveUp: "\u4E0A\u79FB",
        options: "\u9078\u9805",
        picture_360: "360\xb0",
        picture_flat: "\u7D93\u5178",
        search: "\u641C\u5C0B",
        search_address: "\u641C\u5C0B\u5730\u5740\u6216\u57CE\u5E02\u2026",
        search_empty: "\u627E\u4E0D\u5230\u7D50\u679C",
        search_user: "\u641C\u5C0B\u5E33\u865F\u2026",
        sequence_more: "\u66F4\u591A\u64AD\u653E\u9078\u9805",
        sequence_next: "\u5E8F\u5217\u4E2D\u7684\u4E0B\u4E00\u5F35\u76F8\u7247",
        sequence_pause: "\u66AB\u505C\u5E8F\u5217",
        sequence_play: "\u64AD\u653E\u5E8F\u5217",
        sequence_prev: "\u5E8F\u5217\u4E2D\u7684\u4E0A\u4E00\u5F35\u76F8\u7247",
        sequence_speed: "\u64AD\u653E\u901F\u5EA6",
        share: "\u5206\u4EAB",
        share_embed: "\u5D4C\u5165\u5230\u60A8\u7684\u7DB2\u7AD9",
        share_image: "\u9AD8\u756B\u8CEA\u76F8\u7247",
        share_links: "\u8D85\u9023\u7D50",
        share_page: "\u9019\u5F35\u76F8\u7247\u7684\u9023\u7D50",
        share_print: "\u5217\u5370",
        share_rss: "RSS \u6458\u8981",
        share_rss_title: "\u76EE\u524D\u5730\u5716\u53EF\u898B\u5340\u57DF\u4E2D\u65B0\u76F8\u7247\u5E8F\u5217\u7684 RSS \u6458\u8981",
        show_map: "\u986F\u793A\u5730\u5716",
        show_psv: "\u986F\u793A\u76F8\u7247\u6AA2\u8996\u5668",
        zoom: "\u7E2E\u653E",
        zoomIn: "\u62C9\u8FD1",
        zoomOut: "\u62C9\u9060",
        report_submit: "\u9001\u51FA",
        report_email: "\u60A8\u7684 email",
        report_nature_label: "\u554F\u984C\u7684\u539F\u56E0",
        report_nature: {
            "": "\u9078\u64C7\u554F\u984C\u7684\u985E\u578B\u2026",
            blur_missing: "\u53EF\u4EE5\u770B\u898B\u4EBA\u81C9\u6216\u8ECA\u724C",
            blur_excess: "\u5C0D\u7269\u4EF6\u5957\u7528\u4E86\u4E0D\u5FC5\u8981\u7684\u6A21\u7CCA\u8655\u7406",
            inappropriate: "\u4E0D\u7576\u7684\u76F8\u7247 (\u4E0D\u76F8\u95DC\u3001\u88F8\u9AD4\u2026)",
            privacy: "\u76F8\u7247\u662F\u5F9E\u79C1\u4EBA\u9053\u8DEF\u6216\u5834\u6240\u62CD\u651D\u7684",
            picture_low_quality: "\u4F4E\u54C1\u8CEA\u7684\u76F8\u7247",
            mislocated: "\u76F8\u7247\u5728\u5730\u5716\u4E0A\u7684\u4F4D\u7F6E\u4E0D\u6B63\u78BA",
            copyright: "\u76F8\u7247\u4FB5\u72AF\u4E86\u7248\u6B0A",
            other: "\u4EFB\u4F55\u5176\u4ED6\u985E\u578B\u7684\u554F\u984C"
        },
        share_embed_docs: "\u6DF1\u5165\u4E86\u89E3\u5D4C\u5165\u8A2D\u5B9A\u503C",
        error_retry: "\u8ACB\u7A0D\u5F8C\u518D\u8A66",
        error_click: "\u7E7C\u7E8C",
        legend_title: "\u986F\u793A\u76F8\u7247\u7684\u8A73\u7D30\u8CC7\u6599",
        report_email_placeholder: "\u9078\u586B",
        report_whole_sequence: "\u9019\u500B\u554F\u984C\u5F71\u97FF\u6574\u500B\u5E8F\u5217",
        report_details: "\u66F4\u591A\u8CC7\u8A0A",
        report_details_placeholder: "\u9078\u586B\uFF0C\u60A8\u53EF\u4EE5\u8A73\u8FF0\u6B64\u554F\u984C",
        report_wait: "\u6B63\u5728\u50B3\u9001\u5831\u544A\u2026",
        report_success: "\u5DF2\u6210\u529F\u767C\u9001\u5831\u544A\uFF0C\u6211\u5011\u5C07\u5118\u5FEB\u5C0D\u5B83\u9032\u884C\u5BE9\u6838\u3002",
        report_failure: "\u5EFA\u7ACB\u5831\u544A\u6642\u767C\u9001\u932F\u8AA4: {e}\uFF0C\u8ACB\u7A0D\u5F8C\u518D\u8A66\u3002",
        report_auth: "\u6B64\u5831\u544A\u5C07\u4F7F\u7528\u60A8\u7684\u5E33\u6236\u300C{a}\u300D\u767C\u9001",
        filter_qualityscore: "\u54C1\u8CEA\u5206\u6578",
        filter_qualityscore_help: "\u9EDE\u64CA\u4EE5\u555F\u7528\u6216\u505C\u7528",
        map_theme_score: "\u54C1\u8CEA\u5206\u6578",
        metadata_camera_resolution: "\u89E3\u6790\u5EA6",
        metadata_quality: "\u54C1\u8CEA",
        metadata_quality_help: "\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578",
        metadata_quality_gps_score: "\u5B9A\u4F4D\u5206\u6578",
        metadata_quality_resolution_score: "\u89E3\u6790\u5EA6\u5206\u6578",
        metadata_quality_missing: "\u76F8\u7247\u672A\u5305\u542B\u8CC7\u8A0A",
        report: "\u6AA2\u8209",
        metadata_quality_score: "\u6574\u9AD4\u5206\u6578",
        filter_user_mypics: "\u6211\u7684\u76F8\u7247",
        filter_date_1month: "1 \u500B\u6708",
        filter_date_1year: "1 \u5E74",
        qualityscore_doc_2: "\u5206\u6578\u4EE5\u5B57\u6BCD\u8868\u793A:",
        qualityscore_doc_link: "\u6DF1\u5165\u4E86\u89E3\u54C1\u8CEA\u5206\u6578",
        qualityscore_title: "\u95DC\u65BC\u54C1\u8CEA\u5206\u6578",
        qualityscore_doc_1: "\u6211\u5011\u70BA\u6BCF\u5F35\u76F8\u7247\u8A08\u7B97\u54C1\u8CEA\u5206\u6578\u3002",
        qualityscore_doc_3: "A \u70BA\u6700\u4F73\u7B49\u7D1A\uFF0CE \u70BA\u6700\u5DEE\u7B49\u7D1A\u3002",
        minimize_short: "\u96B1\u85CF",
        metadata_general_instance: "\u4F86\u6E90\u7AD9\u53F0",
        metadata_general_copy_picid: "\u8907\u88FD\u76F8\u7247 ID",
        metadata_general_copy_id: "\u8907\u88FD ID",
        picture_360_long: "\u5168\u666F\u76F8\u7247",
        metadata_summary: "\u6458\u8981",
        picture_flat_long: "\u7D93\u5178\u76F8\u7247",
        geo_uri: "\u5916\u90E8\u7A0B\u5F0F",
        contribute_id: "\u900F\u904E iD \u7DE8\u8F2F\u5668\u4F86\u8CA2\u737B OpenStreetMap",
        filter_date_6months: "6 \u500B\u6708",
        picture_all: "\u5168\u90E8",
        metadata_exif_doc: "EXIF \u6A19\u7C64\u6587\u4EF6",
        metadata_exif_doc_title: "\u8ACB\u53C3\u95B1 Exiv2 \u6587\u4EF6\u4EE5\u4E86\u89E3 EXIF \u548C XMP \u6A19\u7C64\u5B9A\u7FA9\u7684\u5B8C\u6574\u8AAA\u660E",
        metadata_location_coordinates: "\u5EA7\u6A19 (\u7D93\u5EA6, \u7DEF\u5EA6)",
        metadata_location_copy: "\u8907\u88FD {v}",
        metadata_location_copy_more: "\u66F4\u591A\u5EA7\u6A19\u8907\u88FD\u9078\u9805",
        semantics_title: "\u6A19\u7C64",
        semantics_tags: "{nb} \u500B\u6A19\u7C64",
        semantics_show_annotations: "\u986F\u793A\u76F8\u7247\u7279\u5FB5",
        semantics_show_all_tags: "\u986F\u793A\u6240\u6709\u6A19\u7C64",
        semantics_key: "\u7D22\u5F15\u9375",
        semantics_annotation_tooltip: "\u9EDE\u64CA\u67E5\u770B\u8A73\u60C5",
        semantics_features_default_title: "\u6A19\u7C64 {nb}",
        semantics_features_subtitle: "{nb} \u500B\u95DC\u806F\u7684\u5C6C\u6027",
        semantics_hide_all_tags: "\u96B1\u85CF\u6240\u6709\u6A19\u7C64",
        semantics_features_none: "\u6B64\u76F8\u7247\u5C1A\u672A\u7E6A\u88FD\u4EFB\u4F55\u7279\u5FB5\u3002",
        semantics_value: "\u503C",
        semantics_tags_picture_none: "\u6B64\u76F8\u7247\u5C1A\u672A\u52A0\u4E0A\u4EFB\u4F55\u6A19\u7C64\u3002",
        semantics_tags_picture: "\u76F8\u7247\u6A19\u7C64",
        whats_panoramax: "Panoramax \u662F\u5404\u5730\u76F8\u7247\u7684\u5730\u7406\u5171\u4EAB\u8CC7\u6E90\u3002",
        semantics_features: "\u76F8\u7247\u7279\u5FB5",
        semantics_key_doc: "\u6DF1\u5165\u4E86\u89E3\u6B64\u7D22\u5F15\u9375",
        semantics_value_doc: "\u6DF1\u5165\u4E86\u89E3\u6B64\u6A19\u7C64",
        semantics_qualifiers: "\u9650\u5B9A\u689D\u4EF6",
        semantics_hide_annotations: "\u96B1\u85CF\u76F8\u7247\u7279\u5FB5",
        semantics_zero_annotations: "\u6B64\u76F8\u7247\u5C1A\u672A\u7E6A\u88FD\u4EFB\u4F55\u7279\u5FB5",
        semantics_hashtags: "\u76F8\u7247\u4E3B\u984C\u6A19\u7C64",
        semantics_wikidata_properties: {
            P31: "\u96B8\u5C6C\u65BC",
            P279: "\u4E0A\u7D1A\u5206\u985E",
            P361: "\u6240\u5C6C\u5BE6\u9AD4",
            P180: "\u63CF\u7E6A"
        },
        panoramax: "Panoramax",
        semantics_editor_example: "key=value\nprefix|key=value",
        semantics_edit: "\u7DE8\u8F2F\u5C6C\u6027",
        semantics_save: "\u5132\u5B58\u8B8A\u66F4",
        semantics_undo: "\u53D6\u6D88\u8B8A\u66F4",
        semantics_cantsave_invalid: "\u7121\u6CD5\u5132\u5B58\u8B8A\u66F4\uFF0C\u7121\u6548\u7684\u8F38\u5165",
        semantics_send_fail: "\u7121\u6CD5\u5132\u5B58\u8B8A\u66F4\uFF0C\u8ACB\u7A0D\u5019\u518D\u8A66",
        semantics_send_ok: "\u5DF2\u6210\u529F\u5132\u5B58\u8B8A\u66F4",
        semantics_add_annotation: "\u65B0\u589E\u6A19\u7C64",
        semantics_save_drawn_annotation: "\u5132\u5B58\u4F4D\u7F6E",
        semantics_undo_drawn_annotation: "\u53D6\u6D88",
        semantics_delete_annotation: "\u522A\u9664\u9019\u500B\u7279\u5FB5",
        semantics_delete_annotation_confirm: "\u60A8\u78BA\u5B9A\u8981\u522A\u9664\u9019\u500B\u6A19\u7C64\u55CE\uFF1F",
        semantics_save_drawn_annotation_incomplete: "\u60A8\u5FC5\u9808\u5728\u9A57\u8B49\u4E4B\u524D\u7E6A\u88FD\u4E00\u500B\u9069\u5408\u76F8\u7247\u7684\u77E9\u5F62",
        semantics_draw_annotation: "\u60A8\u53EF\u4EE5\u5C07\u60F3\u8981\u65B0\u589E\u7684\u7269\u4EF6\u7E6A\u88FD\u5728\u5716\u7247\u4E0A (\u9078\u7528)\u3002",
        semantics_editor_error: "\u8A9E\u6CD5\u7121\u6548\uFF0C\u60A8\u7684\u6A19\u7C64\u770B\u8D77\u4F86\u61C9\u8A72\u8981\u50CF:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nkey \u6700\u5927\u9577\u5EA6\u70BA 256 \u500B\u5B57\u5143\uFF0Cvalue \u6700\u5927\u9577\u5EA6\u70BA 2048 \u500B\u5B57\u5143\u3002",
        semantics_login_needed: "\u82E5\u8981\u7DE8\u8F2F\u76F8\u7247\u6A19\u7C64\u6216\u7279\u5FB5\uFF0C\u60A8\u9700\u8981\u767B\u5165 Panoramax {n} \u7AD9\u53F0\uFF0C\u60A8\u8981\u767B\u5165\u55CE\uFF1F",
        semantics_doc: "\u8AAA\u660E",
        semantics_doc_title: "\u95DC\u65BC\u6A19\u7C64",
        semantics_erase_annotation: "\u522A\u9664\u7E6A\u88FD\u7684\u6A19\u7C64",
        semantics_doc_info1: "\u4F7F\u7528\u6A19\u7C64\u6A19\u8A18\u5716\u7247\u7684\u80CC\u666F\u8CC7\u8A0A\u3002",
        semantics_doc_info2: "\u60A8\u4E5F\u53EF\u4EE5\u5728\u5716\u7247\u4E2D\u6A19\u8A18\u7269\u4EF6\uFF1A\u9053\u8DEF\u6A19\u8A8C\u3001\u90FD\u5E02\u8A2D\u5099\u7B49\u3002\u4F7F\u7528\u73FE\u6709\u7684\u6A19\u7C64\u6A19\u8A18\u60A8\u6240\u770B\u5230\u7684\uFF0C\u4E5F\u53EF\u4EE5\u6309\u7167\u9700\u6C42\u5EFA\u7ACB\u81EA\u5DF1\u7684\u6A19\u7C64\u3002",
        semantics_doc_info3: "\u6709\u4E9B\u7269\u4EF6\u662F\u7531 AI \u81EA\u52D5\u5075\u6E2C\u7684\uFF0C\u56E0\u6B64\u4E0D\u4FDD\u8B49\u54C1\u8CEA\u3002",
        semantics_doc_link: "\u6DF1\u5165\u4E86\u89E3\u6A19\u7C64",
        semantics_sequence_tags: "\u5E8F\u5217\u6A19\u7C64",
        semantics_picture_tags: "\u76F8\u7247\u6A19\u7C64",
        semantics_annotation_tags: "\u7269\u4EF6\u6A19\u7C64",
        filter_gps_precision_lessthan: "\u5C0F\u65BC {n} \u516C\u5C3A",
        filter_gps_precision_between: "\u4ECB\u65BC {n1} \u548C {n2} \u516C\u5C3A",
        map_theme_gps: "GPS \u7CBE\u78BA\u5EA6",
        filter_gps_precision_morethan: "\u5927\u65BC {n} \u516C\u5C3A",
        filter_gps_precision: "\u5B9A\u4F4D\u7CBE\u78BA\u5EA6",
        semantics_overlays: {
            tfsigns: "\u4EA4\u901A\u6A19\u8A8C",
            features: "\u6240\u6709\u7279\u5FB5"
        },
        semantics_doc_info1u1: "\u60A8\u53EF\u4EE5\u52A0\u4E0A transport=car \u9019\u500B\u6A19\u7C64\uFF0C\u5C07\u5176\u6A19\u8A18\u70BA\u99D5\u99DB\u6C7D\u8ECA\u62CD\u651D\u3002",
        semantics_zoom_in: "\u653E\u5927\u5730\u5716\u4EE5\u67E5\u770B\u6A19\u7C64",
        semantics_download: "\u4E0B\u8F09",
        semantics_download_title: "\u4E0B\u8F09\u6A19\u7C64",
        semantics_download_info: "\u6240\u6709\u8A9E\u7FA9\u8CC7\u6599 (\u6A19\u7C64) \u7686\u70BA\u958B\u653E\u8CC7\u6599\uFF0C\u60A8\u53EF\u4EE5\u4E0B\u8F09\u4E26\u81EA\u7531\u5730\u4F7F\u7528\u5B83\u5011\u3002",
        semantics_download_cta: "\u4E0B\u8F09\u958B\u653E\u8CC7\u6599",
        semantics_copy: "\u8907\u88FD\u5C6C\u6027",
        semantics_value_show_osm: "\u5728 OpenStreetMap \u4E0A\u67E5\u770B",
        filter_gps_precision_help: "\u6DF1\u5165\u4E86\u89E3\u5B9A\u4F4D\u7CBE\u78BA\u5EA6",
        filter_gps_precision_help_1: "\u6BCF\u5F35\u76F8\u7247\u6709\u5B9A\u4F4D\u7CBE\u78BA\u5EA6\u5206\u6578\uFF0C\u9019\u5C0D\u61C9\u65BC\u62CD\u7167\u6642\u7684 GPS \u7CBE\u78BA\u5EA6\u3002",
        filter_gps_precision_help_2: "\u7CBE\u78BA\u5EA6\u7528\u661F\u865F\u8868\u793A:",
        filter_gps_precision_help_3: "\u300C5\u2B50\u300D\u8868\u793A\u975E\u5E38\u7CBE\u78BA (<= {p5}m)\uFF0C\u300C1\u2B50\u300D\u8868\u793A\u975E\u5E38\u4E0D\u7CBE\u78BA (> {p1}m) \u6216\u672A\u77E5\u3002",
        filter_gps_precision_help_4: "RTK GPS \u7684\u6703\u5F97\u5230\u300C5\u2B50\u300D\u7B49\u7D1A\uFF0C\u50CF GoPro Max \u9019\u6A23\u7684\u904B\u52D5\u76F8\u6A5F\u6703\u5F97\u5230\u300C3\u2B50\u300D\uFF0C\u800C\u5730\u4E0B\u505C\u8ECA\u5834\u4E2D\u7684\u667A\u6167\u578B\u624B\u6A5F GPS \u6703\u5F97\u5230\u300C1\u2B50\u300D\u3002",
        qualityscore_doc_4: "\u6B64\u5206\u6578\u6839\u64DA\u4EE5\u4E0B\u56E0\u7D20\u8A08\u7B97\u5F97\u51FA:",
        qualityscore_doc_41: "GPS \u7CBE\u78BA\u5EA6",
        qualityscore_doc_42: "\u76F8\u7247\u89E3\u6790\u5EA6",
        qualityscore_doc_5: "\u5C08\u696D\u8A2D\u5099\u6703\u5F97\u5230 A \u7B49\u3001360\xb0 \u904B\u52D5\u76F8\u6A5F B \u7B49\u3001\u667A\u6167\u578B\u624B\u6A5F\u5247\u6703\u4ECB\u65BC C \u548C E \u4E4B\u9593\u3002",
        "visibility_title_logged-only": "\u53EA\u6709\u64C1\u6709\u5E33\u6236\u7684\u4EBA\u624D\u80FD\u67E5\u770B\u9019\u5F35\u76F8\u7247",
        "visibility_logged-only": "\u6210\u54E1",
        "visibility_owner-only": "\u96B1\u85CF",
        filter_locked: "\u5DF2\u505C\u7528\u7BE9\u9078\u5668",
        indoor_selector_scrolldown: "\u5411\u4E0B\u6372\u52D5\u6A13\u5C64\u6E05\u55AE",
        indoor_switch: "\u5BA4\u5167\u7A7A\u9593",
        indoor_selector_expand: "\u9EDE\u64CA\u67E5\u770B\u6240\u6709\u6A13\u5C64",
        indoor_selector_shrink: "\u9EDE\u64CA\u6700\u5C0F\u5316",
        indoor_selector_levelup: "\u524D\u5F80\u6A13\u4E0A",
        map_background_default: "\u9810\u8A2D",
        map_background_more: "\u66F4\u591A",
        indoor_selector_leveldown: "\u524D\u5F80\u6A13\u4E0B",
        indoor_selector_scrollup: "\u5411\u4E0A\u6372\u52D5\u6A13\u5C64\u6E05\u55AE",
        "visibility_title_owner-only": "\u53EA\u6709\u60A8\u53EF\u4EE5\u67E5\u770B\u6B64\u76F8\u7247",
        popup_details_link: "\u66F4\u591A\u8CC7\u8A0A",
        filter_source_local: "\u6B64\u4F3A\u670D\u5668",
        filter_source_world: "\u5168\u4E16\u754C",
        error_pic_load: "\u76EE\u524D\u7121\u6CD5\u8F09\u5165\u6B64\u76F8\u7247\u3002\n\u8ACB\u6AA2\u67E5\u60A8\u7684\u7DB2\u8DEF\u9023\u7DDA\u3002\u82E5\u5DF2\u9023\u7DDA\uFF0C\u8ACB\u78BA\u8A8D\u76F8\u7247 ID \u662F\u5426\u6709\u6548\u3002",
        low_contrast: "\u964D\u4F4E\u5F71\u50CF\u5C0D\u6BD4\u5EA6",
        reset_contrast: "\u91CD\u8A2D\u5F71\u50CF\u5C0D\u6BD4\u5EA6",
        delete_picture: "\u522A\u9664",
        delete_picture_warn: "\u26A0\uFE0F \u6CE8\u610F: \u6B64\u64CD\u4F5C\u5C07\u6C38\u4E45\u522A\u9664\u6B64\u76F8\u7247\u3002\n\u60A8\u78BA\u5B9A\u8981\u7E7C\u7E8C\u57F7\u884C\u55CE\uFF1F",
        metadata_general_title: "\u6A19\u984C",
        delete_picture_error: "\u522A\u9664\u76F8\u7247\u6642\u767C\u751F\u932F\u8AA4:\n{e}",
        semantics_empty: "\u672A\u5B9A\u7FA9\u4EFB\u4F55\u6A19\u7C64",
        widget_locked: "\u9078\u9805\u5DF2\u505C\u7528",
        map_theme_default_2: "\u5E73\u5747",
        map_theme_default_3: "\u826F\u597D",
        map_theme_default_coef: "\u76F8\u7247\u8986\u84CB\u7387",
        map_theme_default_coef_short: "\u8986\u84CB\u7387",
        map_theme_default_1: "\u4F4E",
        map_theme_default_4: "\u512A\u79C0",
        semantics_draw_unfinished_annotation: "\u7E6A\u88FD\u5340\u57DF\u5C1A\u672A\u5B8C\u6210\uFF0C\u5132\u5B58\u524D\u8ACB\u78BA\u8A8D\u5340\u57DF\u4F4D\u7F6E\u662F\u5426\u6B63\u78BA\u3002",
        time_travel: "\u67E5\u770B\u6B64\u5730\u9EDE\u7684\u5176\u4ED6\u65E5\u671F\u5F71\u50CF",
        time_travel_close: "\u96B1\u85CF\u5176\u4ED6\u65E5\u671F",
        semantics_draw_invalid_annotation: "\u7E6A\u88FD\u5340\u57DF\u5DF2\u8D85\u51FA\u76F8\u7247\u7BC4\u570D\uFF0C\u8ACB\u78BA\u4FDD\u7E6A\u88FD\u5728\u53EF\u898B\u7684\u76F8\u7247\u7BC4\u570D\u5167\u3002",
        map_theme_default_short: "\u9810\u8A2D",
        map_theme_age_short: "\u65E5\u671F",
        map_theme_type_short: "\u76F8\u6A5F",
        map_theme_score_short: "\u54C1\u8CEA",
        map_theme_gps_short: "\u4F4D\u7F6E",
        delete_picture_ok: "\u76F8\u7247\u5DF2\u6210\u529F\u522A\u9664",
        sequence_play_backwards: "\u53CD\u5411\u64AD\u653E\u5E8F\u5217",
        semantics_annotation_tooltip_close: "\u9EDE\u64CA\u4EE5\u53D6\u6D88\u9078\u53D6"
    },
    map: {
        loading: "\u6B63\u5728\u8F09\u5165\u2026",
        not_public: "\u672A\u516C\u958B\u986F\u793A",
        thumbnail: "\u904A\u6A19\u61F8\u505C\u76F8\u7247\u7684\u7E2E\u5716",
        slow_loading: "\u5730\u5716\u8F09\u5165\u7DE9\u6162\u800C\u4E14\u53EF\u80FD\u986F\u793A\u7570\u5E38",
        more_panoramax: "\u6DF1\u5165\u4E86\u89E3 Panoramax",
        map_data: "\u5730\u5716\u8CC7\u6599: {m}"
    },
    psv: {
        ctrlZoom: "\u4F7F\u7528 CTRL + \u6ED1\u9F20\u6EFE\u8F2A\u7E2E\u653E\u5716\u7247",
        loadError: "\u7121\u6CD5\u8F09\u5165\u5168\u666F\u5716",
        twoFingers: "\u4F7F\u7528\u96D9\u6307\u79FB\u52D5"
    },
    maplibre: {
        "GeolocateControl.FindMyLocation": "\u5C0B\u627E\u6211\u7684\u4F4D\u7F6E",
        "GeolocateControl.LocationNotAvailable": "\u7121\u6CD5\u4F7F\u7528\u4F4D\u7F6E\u8CC7\u8A0A"
    }
};
const $785da19a645c07eb$var$ct = "en", $785da19a645c07eb$var$ut = {
    be: {
        psv: {
            twoFingers: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 \u0434\u0432\u0430 \u043F\u0430\u043B\u044C\u0446\u044B \u0434\u043B\u044F \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u044B\u0456",
            ctrlZoom: "\u0412\u044B\u043A\u0430\u0440\u044B\u0441\u0442\u043E\u045E\u0432\u0430\u0439\u0446\u0435 ctrl + \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430 \u0434\u043B\u044F \u043C\u0430\u0448\u0442\u0430\u0431\u0430\u0432\u0430\u043D\u043D\u044F \u0432\u044B\u044F\u0432\u044B",
            loadError: "\u041F\u0430\u043D\u0430\u0440\u0430\u043C\u0443 \u043D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u0456\u0446\u044C"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u0417\u043D\u0430\u0439\u0441\u0446\u0456 \u043C\u0430\u0451 \u043C\u0435\u0441\u0446\u0430\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u0435",
            "GeolocateControl.LocationNotAvailable": "\u041C\u0435\u0441\u0446\u0430\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u0435 \u043D\u0435\u0434\u0430\u0441\u0442\u0443\u043F\u043D\u0430"
        },
        pnx: {
            zoom: "\u041C\u0430\u0448\u0442\u0430\u0431",
            zoomOut: "\u0410\u0434\u0434\u0430\u043B\u0456\u0446\u044C",
            zoomIn: "\u041D\u0430\u0431\u043B\u0456\u0437\u0456\u0446\u044C",
            moveUp: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045E\u0432\u0435\u0440\u0445",
            search_user: "\u0428\u0443\u043A\u0430\u0446\u044C \u0456\u043C\u044F \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u2026",
            share: "\u041F\u0430\u0434\u0437\u044F\u043B\u0456\u0446\u0446\u0430",
            share_links: "\u0421\u043F\u0430\u0441\u044B\u043B\u043A\u0456",
            share_page: "\u0421\u043F\u0430\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0433\u044D\u0442\u0443 \u0432\u044B\u044F\u0432\u0443",
            share_image: "\u0412\u044B\u044F\u0432\u0430 \u0432\u044B\u0441\u043E\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456",
            share_rss: "RSS \u0441\u0442\u0443\u0436\u043A\u0430",
            share_rss_title: "RSS \u0441\u0442\u0443\u0436\u043A\u0430 \u043D\u043E\u0432\u044B\u0445 \u0441\u0435\u0440\u044B\u0439 \u0443 \u0431\u0430\u0447\u043D\u0430\u0439 \u0432\u043E\u0431\u043B\u0430\u0441\u0446\u0456 \u043A\u0430\u0440\u0442\u044B",
            share_embed: "\u0423\u0431\u0443\u0434\u0430\u0432\u0430\u0446\u044C \u043D\u0430 \u0412\u0430\u0448 \u0441\u0430\u0439\u0442",
            share_embed_docs: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u043D\u0430\u043B\u0430\u0434\u043A\u0443 \u045E\u0431\u0443\u0434\u043E\u0432\u044B",
            share_print: "\u0414\u0440\u0443\u043A",
            panoramax: "Panoramax",
            copy: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u044B\u0445 \u043A\u0430\u0440\u0442\u044B",
                "\uD83D\uDDA5\uFE0F \u0417\u0430\u043F\u044B\u0442 \u0434\u0430 API",
                "\uD83D\uDDBC\uFE0F \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u0456\u043D\u0456\u044F\u0446\u044E\u0440",
                "\uD83D\uDD0D \u0410\u043D\u0430\u043B\u0456\u0437 EXIF \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u044B\u0445",
                "\uD83C\uDFD8\uFE0F 3D \u0440\u044D\u043D\u0434\u044D\u0440\u044B\u043D\u0433",
                "\uD83D\uDCF7 \u0406\u043D\u0456\u0446\u044B\u044F\u043B\u0456\u0437\u0430\u0446\u044B\u044F 360\xb0 \u0432\u044B\u044F\u045E",
                "\uD83D\uDFE0 \u0411\u0430\u043B\u0430\u043D\u0441 \u043A\u043E\u043B\u0435\u0440\u0430\u045E",
                "\uD83D\uDCAF \u0420\u0430\u0437\u043B\u0456\u043A \u0430\u0434\u0437\u043D\u0430\u043A\u0456 \u044F\u043A\u0430\u0441\u0446\u0456 \xa9",
                "\uD83D\uDCE1 \u0421\u0446\u044F\u0433\u0432\u0430\u043D\u043D\u0435 \u0430\u0431\u043D\u0430\u045E\u043B\u0435\u043D\u043D\u044F\u045E",
                "\uD83C\uDF0D \u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0442\u0430\u0439\u043B\u0430\u045E \u043A\u0430\u0440\u0442\u044B",
                "\uD83D\uDCF8 \u0410\u043F\u0440\u0430\u0446\u043E\u045E\u043A\u0430 \u0446\u0435\u043D\u044F\u045E"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C \u0412\u044B\u044F\u045E\u043B\u0435\u043D\u043D\u0435 \u0437\u043D\u0430\u043A\u0430\u045E \u043F\u0435\u0440\u0430\u0445\u043E\u0434\u0443 \u0430\u043B\u0435\u043D\u044F\u045E",
                "\uD83D\uDE98 \u041F\u043E\u0448\u0443\u043A \u0430\u045E\u0442\u0430\u043C\u0430\u0431\u0456\u043B\u044F Panoramax\xa9",
                "\u2615 \u0406\u043D'\u0435\u043A\u0446\u044B\u044F \u043A\u0430\u0444\u0435\u0456\u043D\u0443",
                "\uD83D\uDE00 \u0423\u0441\u043C\u0456\u0445\u043D\u0456\u0446\u0435\u0441\u044F, \u0432\u044B \u043D\u0430 \u043A\u0430\u0440\u0446\u0435!",
                "\uD83D\uDC08 \u041F\u0430\u0434\u0437\u044F\u043B\u044F\u0435\u043C\u0441\u044F \u0444\u0430\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u044F\u043C\u0456 \u043A\u0430\u0442\u043A\u043E\u045E",
                "\uD83D\uDE34 \u0417\u043C\u044F\u043D\u0448\u044D\u043D\u043D\u0435 \u043F\u0440\u0430\u043A\u0440\u0430\u0441\u0442\u044B\u043D\u0430\u0446\u044B\u0456",
                "\uD83E\uDED6 \u0417\u0430\u0432\u0430\u0440\u0432\u0430\u043D\u043D\u0435 \u0433\u0430\u0440\u0431\u0430\u0442\u044B",
                "\uD83D\uDC27 \u0410\u0434\u043A\u0440\u044B\u0446\u0446\u0451 \u0437\u044B\u0445\u043E\u0434\u043D\u0430\u0433\u0430 \u043A\u043E\u0434\u0430",
                "\uD83D\uDE87 \u0406\u043D\u0434\u044D\u043A\u0441\u0430\u0446\u044B\u044F \u0441\u0442\u0430\u043D\u0446\u044B\u0439 \u043C\u0435\u0442\u0440\u043E",
                "\uD83E\uDDF9 \u041F\u0440\u044B\u0431\u0456\u0440\u0430\u0435\u043C \u045E\u0441\u0451 \u0441\u043C\u0435\u0446\u0446\u0435 \u0437 \u0432\u0443\u043B\u0456\u0446",
                "\uD83D\uDE92 \u0420\u0430\u0441\u0447\u044B\u0448\u0447\u0430\u0435\u043C \u0432\u0443\u043B\u0456\u0446\u044B \u0430\u0434 \u043C\u0430\u0448\u044B\u043D \u0434\u043B\u044F \u043F\u0440\u0430\u0435\u0437\u0434\u0443 \u043F\u0430\u0436\u0430\u0440\u043D\u044B\u0445",
                "\uD83C\uDF33 \u041F\u0435\u0440\u0430\u043B\u0456\u0447\u0432\u0430\u0435\u043C \u043B\u044F\u0441\u043D\u044B\u044F \u0441\u0446\u0435\u0436\u0430\u0447\u043A\u0456 \u045E \u0411\u0435\u043B\u0430\u0432\u0435\u0436\u0441\u043A\u0430\u0439 \u043F\u0443\u0448\u0447\u044B... \u0410\u0434\u043D\u0430, \u0434\u0440\u0443\u0433\u0430\u044F, \u0442\u0440\u044D\u0446\u044F\u044F... \u0417\u0431\u0456\u043B\u0456\u0441\u044F! \u041F\u0430\u0447\u044B\u043D\u0430\u0435\u043C \u0441\u043F\u0430\u0447\u0430\u0442\u043A\u0443!",
                "\uD83D\uDE89 \u0410\u0433\u043B\u044F\u0434 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C \u0441\u0442\u0430\u043D\u0446\u044B\u0439",
                "\uD83D\uDEF0\uFE0F \u041F\u043E\u0448\u0443\u043A \u0441\u043F\u0430\u0434\u0430\u0440\u043E\u0436\u043D\u0456\u043A\u0430\u045E",
                "\uD83D\uDC65 \u0421\u0442\u0432\u0430\u0440\u044D\u043D\u043D\u0435 \u043F\u0435\u0440\u0441\u043E\u043D",
                "\uD83D\uDC1F \u041B\u0430\u043A\u0430\u0446\u044B\u044F \u0440\u044B\u0431\u043D\u044B\u0445 \u043A\u0440\u0430\u043C",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u0410\u0434\u043B\u0430\u0434\u043A\u0430 \u0456\u043D\u0442\u044D\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC8 \u041F\u0430\u0432\u0435\u043B\u0456\u0447\u044D\u043D\u043D\u0435 \u0441\u0442\u0430\u0442\u044B\u0441\u0442\u044B\u043A\u0456",
                "\uD83E\uDD16 \u0412\u044B\u0432\u0443\u0447\u044D\u043D\u043D\u0435 \u0441\u0435\u043C\u0430\u043D\u0442\u044B\u043A\u0456",
                "\uD83C\uDFA8 \u0420\u044D\u0434\u044B\u0437\u0430\u0439\u043D \u0456\u043D\u0442\u044D\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC5 \u041F\u043B\u0430\u043D\u0430\u0432\u0430\u043D\u043D\u0435 \u0444\u043E\u0442\u0430-\u043A\u0430\u0440\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u0447\u043D\u044B\u0445 \u0432\u0435\u0447\u0430\u0440\u044B\u043D",
                "\uD83E\uDDC0 \u041F\u0430\u0441\u043F\u044F\u0432\u0430\u043D\u043D\u0435 \u043A\u043B\u0456\u043D\u043A\u043E\u0432\u0430\u0433\u0430 \u0441\u044B\u0440\u0443",
                "\uD83C\uDF04 \u0427\u0430\u043A\u0430\u0435\u043C \u043D\u0430\u0441\u0442\u0443\u043F\u0443 \u0441\u0432\u0456\u0442\u0430\u043D\u043A\u0443",
                "\uD83C\uDF0A \u0412\u044B\u043C\u044F\u0440\u044D\u043D\u043D\u0435 \u043F\u0440\u044B\u043B\u0456\u0432\u0430\u045E"
            ],
            qualityscore_doc_3: "\u042F\u043D\u0430 \u0440\u0430\u0437\u043B\u0456\u0447\u0432\u0430\u0435\u0446\u0446\u0430 \u043D\u0430 \u0430\u0441\u043D\u043E\u0432\u0435 \u0434\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u0456 GPS \u0456 \u0440\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456 \u0432\u044B\u044F\u0432\u044B. \u041F\u0440\u0430\u0444\u0435\u0441\u0456\u0439\u043D\u0430\u044F \u0441\u0456\u0441\u0442\u044D\u043C\u0430 \u0431\u0443\u0434\u0437\u0435 \u043C\u0435\u0446\u044C \u0430\u0434\u0437\u043D\u0430\u043A\u0443 A, \u044D\u043A\u0448\u043D-\u043A\u0430\u043C\u0435\u0440\u0430 360\xb0 - B, \u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D - C/D/E.",
            qualityscore_doc_link: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            filter_gps_precision: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            filter_gps_precision_between: "\u041F\u0430\u043C\u0456\u0436 {n1} \u0456 {n2} \u043C\u0435\u0442\u0440\u0430\u043C\u0456",
            filter_gps_precision_morethan: "\u0411\u043E\u043B\u044C\u0448 \u0437\u0430 {n} \u043C\u0435\u0442\u0440\u0430\u045E",
            map_theme_age: "\u0414\u0430\u0442\u0430 \u0437\u0434\u044B\u043C\u043A\u0456",
            map_theme_type: "\u0422\u044B\u043F \u043A\u0430\u043C\u0435\u0440\u044B",
            map_theme_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u044F\u043A\u0430\u0441\u0446\u0456",
            map_theme_gps: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            map_theme_age_1: "> 3 \u0433\u0430\u0434\u044B",
            map_theme_age_2: "< 3 \u0433\u0430\u0434\u044B",
            map_theme_age_3: "< 1 \u0433\u043E\u0434",
            map_theme_age_4: "< 6 \u043C\u0435\u0441\u044F\u0446",
            contrast: "\u0423\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0431\u043E\u043B\u044C\u0448\u044B \u043A\u0430\u043D\u0442\u0440\u0430\u0441\u0442 \u0432\u044B\u044F\u0432\u044B",
            metadata: "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u044B\u044F \u0432\u044B\u044F\u0432\u044B",
            metadata_summary: "\u0410\u043F\u0456\u0441\u0430\u043D\u043D\u0435",
            metadata_location_coordinates: "\u041A\u0430\u0430\u0440\u0434\u044B\u043D\u0430\u0442\u044B (\u0434\u0430\u045E\u0433\u0430\u0442\u0430, \u0448\u044B\u0440\u0430\u0442\u0430)",
            metadata_location_orientation: "\u041D\u0430\u043F\u0440\u0430\u043C\u0430\u043A",
            metadata_location_precision: "\u0414\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u0441\u0446\u044C \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            metadata_location_copy: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C {v}",
            metadata_location_copy_more: "\u0411\u043E\u043B\u044C\u0448 \u043E\u043F\u0446\u044B\u0439 \u043A\u0430\u043F\u0456\u044F\u0432\u0430\u043D\u043D\u044F \u043A\u0430\u0430\u0440\u0434\u044B\u043D\u0430\u0442",
            metadata_quality: "\u042F\u043A\u0430\u0441\u0446\u044C",
            metadata_quality_help: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            metadata_quality_gps_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u043F\u0430\u0437\u0456\u0446\u044B\u044F\u043D\u0430\u0432\u0430\u043D\u043D\u044F",
            metadata_quality_resolution_score: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u0440\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u0456",
            metadata_quality_missing: "\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435 \u043D\u0435 \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u0430 \u045E \u0432\u044B\u044F\u0432\u0435",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0422\u044D\u0433",
            semantics_features: "\u0410\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_features_none: "\u041D\u0430 \u0433\u044D\u0442\u0430\u0439 \u0432\u044B\u044F\u0432\u0435 \u044F\u0448\u0447\u044D \u043D\u0435 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B \u043D\u0456\u0432\u043E\u0434\u043D\u044B \u0430\u0431'\u0435\u043A\u0442.",
            semantics_show_all_tags: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u0443\u0441\u0435 \u0442\u044D\u0433\u0456",
            semantics_hide_all_tags: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0443\u0441\u0435 \u0442\u044D\u0433\u0456",
            report_nature: {
                blur_missing: "\u0411\u0430\u0447\u043D\u044B \u0442\u0432\u0430\u0440 \u0447\u0430\u043B\u0430\u0432\u0435\u043A\u0430 \u0430\u0431\u043E \u043D\u0443\u043C\u0430\u0440\u043D\u044B \u0437\u043D\u0430\u043A \u0430\u045E\u0442\u043E",
                blur_excess: "\u041D\u0430 \u0430\u0431'\u0435\u043A\u0442 \u0431\u044B\u045E \u0443\u0436\u044B\u0442\u044B \u043D\u0435\u043F\u0430\u0442\u0440\u044D\u0431\u043D\u0430\u0435 \u0440\u0430\u0437\u043C\u044B\u0446\u0446\u0451",
                "": "\u0412\u044B\u0431\u0435\u0440\u044B\u0446\u0435 \u0442\u044B\u043F \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B\u2026",
                inappropriate: "\u041D\u0435\u0430\u0434\u043F\u0430\u0432\u0435\u0434\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 (\u043D\u0435 \u0437\u0432\u044F\u0437\u0430\u043D\u0430\u044F, \u0430\u0433\u043E\u043B\u0435\u043D\u0430\u0441\u0446\u044C\u2026)",
                privacy: "\u0411\u0430\u0447\u043D\u044B \u043F\u0440\u044B\u0432\u0430\u0442\u043D\u044B \u0448\u043B\u044F\u0445 \u0430\u0431\u043E \u045E\u043B\u0430\u0441\u043D\u0430\u0441\u0446\u044C",
                picture_low_quality: "\u0412\u044B\u044F\u0432\u0430 \u043D\u0456\u0437\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456",
                mislocated: "\u0412\u044B\u044F\u0432\u0430 \u0434\u0440\u044D\u043D\u043D\u0430 \u0440\u0430\u0437\u043C\u0435\u0448\u0447\u0430\u043D\u0430 \u043D\u0430 \u043A\u0430\u0440\u0446\u0435",
                copyright: "\u0412\u044B\u044F\u0432\u0430 \u043F\u0430\u0440\u0443\u0448\u0430\u0435 \u0430\u045E\u0442\u0430\u0440\u0441\u043A\u0456\u044F \u043F\u0440\u0430\u0432\u044B",
                other: "\u041B\u044E\u0431\u044B \u0456\u043D\u0448\u044B \u0432\u0456\u0434 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B"
            },
            semantics_editor_example: "\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435\n\u043F\u0440\u044D\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            moveDown: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045E\u043D\u0456\u0437",
            moveLeft: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043D\u0430\u043B\u0435\u0432\u0430",
            moveRight: "\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u0430",
            moveMiddle: "\u0426\u044D\u043D\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u0432\u0456\u0434",
            expand: "\u0420\u0430\u0437\u0433\u0430\u0440\u043D\u0443\u0446\u044C",
            expand_info: "\u0410\u0434\u043B\u044E\u0441\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u0432\u0456\u0434\u0436\u044D\u0442 \u043D\u0430 \u045E\u0441\u044E \u0441\u0442\u0430\u0440\u043E\u043D\u043A\u0443",
            show_psv: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043F\u0440\u0430\u0433\u043B\u044F\u0434\u0430\u043B\u044C\u043D\u0456\u043A \u0432\u044B\u044F\u045E",
            show_map: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043A\u0430\u0440\u0442\u0443",
            minimize: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0433\u044D\u0442\u044B \u0432\u0456\u0434\u0436\u044D\u0442, \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0437\u043D\u043E\u045E \u043F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u044F\u0433\u043E \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u043A\u043D\u043E\u043F\u043A\u0456 \u045E \u043B\u0435\u0432\u044B\u043C \u043D\u0456\u0436\u043D\u0456\u043C \u043A\u0443\u0446\u0435",
            minimize_short: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C",
            options: "\u041E\u043F\u0446\u044B\u0456",
            filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u044B",
            layers: "\u0421\u043B\u0430\u0456",
            search: "\u041F\u043E\u0448\u0443\u043A",
            search_empty: "\u0412\u044B\u043D\u0456\u043A\u0430\u045E \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
            search_address: "\u0428\u0443\u043A\u0430\u0446\u044C \u0430\u0434\u0440\u0430\u0441, \u0433\u043E\u0440\u0430\u0434\u2026",
            whats_panoramax: "Panoramax - \u0433\u044D\u0442\u0430 \u0430\u0434\u043A\u0440\u044B\u0442\u0430\u044F \u0433\u0435\u0430-\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0430 \u0434\u043B\u044F \u0432\u044B\u044F\u0432\u0430\u045E \u0442\u044D\u0440\u044B\u0442\u043E\u0440\u044B\u0439.",
            copied: "\u0421\u043A\u0430\u043F\u0456\u044F\u0432\u0430\u043D\u0430",
            error: "\u0423 \u043D\u0430\u0441 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u0430\u2026",
            error_click: "\u041F\u0440\u0430\u0446\u044F\u0433\u0432\u0430\u0446\u044C",
            error_retry: "\u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439",
            sequence_next: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 \u045E \u0441\u0435\u0440\u044B\u0456",
            sequence_play: "\u041F\u0440\u0430\u0439\u0433\u0440\u0430\u0446\u044C \u0433\u044D\u0442\u0443\u044E \u0441\u0435\u0440\u044B\u044E",
            sequence_pause: "\u041F\u0440\u044B\u043F\u044B\u043D\u0456\u0446\u044C \u0441\u0435\u0440\u044B\u044E",
            sequence_prev: "\u041F\u0430\u043F\u044F\u0440\u044D\u0434\u043D\u044F\u044F \u0432\u044B\u044F\u0432\u0430 \u045E \u0441\u0435\u0440\u044B\u0456",
            sequence_more: "\u0411\u043E\u043B\u044C\u0448 \u043E\u043F\u0446\u044B\u0439 \u043F\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043D\u043D\u044F",
            sequence_speed: "\u0425\u0443\u0442\u043A\u0430\u0441\u0446\u044C \u043F\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043D\u043D\u044F",
            legend_license: "\u041B\u0456\u0446\u044D\u043D\u0437\u0456\u044F: {l}",
            legend_title: "\u041F\u0430\u043A\u0430\u0437\u0430\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456 \u0432\u044B\u044F\u0432\u044B",
            id: "iD",
            contribute_id: "\u0423\u043D\u0435\u0441\u0446\u0456 \u045E\u043A\u043B\u0430\u0434 \u0443 OpenStreetMap \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0440\u044D\u0434\u0430\u043A\u0442\u0430\u0440\u0430 iD",
            geo_uri: "\u0417\u043D\u0435\u0448\u043D\u044F\u044F \u043F\u0440\u0430\u0433\u0440\u0430\u043C\u0430",
            josm: "JOSM",
            josm_live: "\u0423\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0443\u044E \u0441\u0456\u043D\u0445\u0440\u0430\u043D\u0456\u0437\u0430\u0446\u044B\u044E JOSM \u043F\u0440\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0446\u044B \u0432\u044B\u044F\u0432\u044B",
            error_psv: "Photo Sphere Viewer \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u043F\u0440\u0430\u0432\u0456\u043B\u044C\u043D\u0430",
            error_pic: "\u0417\u0430\u043F\u044B\u0442\u0430\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430 \u043D\u0435 \u0437\u043D\u043E\u0439\u0434\u0437\u0435\u043D\u0430",
            error_nopic: "\u041D\u044F\u043C\u0430 \u0432\u044B\u044F\u0432\u044B \u045E \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043D\u0430\u0439 \u043F\u0430\u0437\u0456\u0446\u044B\u0456",
            error_api: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044B\u044F\u045E \u043D\u0435\u0434\u0430\u0441\u0442\u0443\u043F\u043D\u044B",
            error_webgl: "WebGL \u043D\u0435 \u043F\u0430\u0434\u0442\u0440\u044B\u043C\u043B\u0456\u0432\u0430\u0435\u0446\u0446\u0430 \u0432\u0430\u0448\u044B\u043C \u0431\u0440\u0430\u045E\u0437\u0430\u0440\u0430\u043C",
            error_josm: "JOSM \u043D\u0435 \u0430\u0434\u043A\u0430\u0437\u0432\u0430\u0435, \u0446\u0456 \u0451\u043D \u0437\u0430\u043F\u0443\u0448\u0447\u0430\u043D\u044B \u0456 \u045E\u043A\u043B\u044E\u0447\u0430\u043D\u044B \u0432\u044B\u0434\u0430\u043B\u0435\u043D\u044B \u0434\u043E\u0441\u0442\u0443\u043F?",
            error_api_compatibility: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044B\u044F\u045E \u043D\u0435\u0441\u0443\u043C\u044F\u0448\u0447\u0430\u043B\u044C\u043D\u044B \u0437 \u0433\u044D\u0442\u0430\u0439 \u0432\u0435\u0440\u0441\u0456\u044F\u0439 \u043F\u0440\u0430\u0433\u043B\u044F\u0434\u0430\u043B\u044C\u043D\u0456\u043A\u0430",
            filter_date: "\u0414\u0430\u0442\u0430",
            filter_date_1month: "1 \u043C\u0435\u0441\u044F\u0446",
            filter_date_6months: "6 \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            filter_date_1year: "1 \u0433\u043E\u0434",
            filter_user: "\u041A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A",
            filter_user_mypics: "\u041C\u0430\u0435 \u0432\u044B\u044F\u0432\u044B",
            filter_picture: "\u0422\u044B\u043F \u0432\u044B\u044F\u0432\u044B",
            filter_zoom_in: "\u041D\u0430\u0431\u043B\u0456\u0437\u044C\u0446\u0435 \u043A\u0430\u0440\u0442\u0443, \u043A\u0430\u0431 \u0443\u0431\u0430\u0447\u044B\u0446\u044C \u0433\u044D\u0442\u044B \u0444\u0456\u043B\u044C\u0442\u0440",
            picture_all: "\u0423\u0441\u0435",
            picture_flat: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u044B\u044F",
            picture_360: "360\xb0",
            picture_flat_long: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430",
            picture_360_long: "\u041F\u0430\u043D\u0430\u0440\u0430\u043C\u043D\u0430\u044F \u0432\u044B\u044F\u0432\u0430",
            filter_qualityscore: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u044F\u043A\u0430\u0441\u0446\u0456",
            filter_qualityscore_help: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435, \u043A\u0430\u0431 \u0443\u043A\u043B\u044E\u0447\u044B\u0446\u044C \u0430\u0431\u043E \u0432\u044B\u043A\u043B\u044E\u0447\u044B\u0446\u044C",
            qualityscore_title: "\u041F\u0440\u0430 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456",
            qualityscore_doc_1: "Panoramax \u043F\u0440\u0430\u043F\u0430\u043D\u0443\u0435 \u0430\u0434\u0437\u043D\u0430\u043A\u0443 \u044F\u043A\u0430\u0441\u0446\u0456 \u0434\u043B\u044F \u043A\u043E\u0436\u043D\u0430\u0439 \u0432\u044B\u044F\u0432\u044B. \u0413\u044D\u0442\u0430 \u0434\u0430\u0437\u0432\u0430\u043B\u044F\u0435 \u043B\u0451\u0433\u043A\u0430 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0432\u0430\u0446\u044C \u043A\u0430\u0440\u0442\u0443 \u0456 \u043F\u0430\u043A\u0430\u0437\u0432\u0430\u0446\u044C \u043D\u0430\u044F\u045E\u043D\u0430\u0441\u0446\u044C \u0432\u044B\u044F\u045E \u0432\u044B\u0441\u043E\u043A\u0430\u0439 \u044F\u043A\u0430\u0441\u0446\u0456.",
            qualityscore_doc_2: "\u0410\u0434\u0437\u043D\u0430\u043A\u0430 \u043F\u0430\u043A\u0430\u0437\u0432\u0430\u0435\u0446\u0446\u0430 \u043A\u0430\u0440\u044B\u0441\u0442\u0430\u043B\u044C\u043D\u0456\u043A\u0430\u043C \u044F\u043A A/B/C/D/E (A - \u043B\u0435\u043F\u0448\u0430\u044F, E - \u0433\u043E\u0440\u0448\u0430\u044F) \u0434\u044B \u0430\u0434\u043B\u044E\u0441\u0442\u0440\u043E\u045E\u0432\u0430\u0435\u0446\u0446\u0430 \u0433\u0440\u0430\u0444\u0456\u0447\u043D\u0430 \u043F\u0440\u0430\u0437 \u0433\u044D\u0442\u0443\u044E \u0448\u043A\u0430\u043B\u0443:",
            filter_gps_precision_lessthan: "\u041C\u0435\u043D\u0448 \u0437\u0430 {n} \u043C\u0435\u0442\u0440\u0430\u045E",
            map_background: "\u0424\u043E\u043D \u043A\u0430\u0440\u0442\u044B",
            map_background_aerial: "\u0421\u043F\u0430\u0434\u0430\u0440\u043E\u0436\u043D\u0456\u043A\u0430\u0432\u044B",
            map_background_streets: "\u0412\u0443\u043B\u0456\u0447\u043D\u044B",
            map_theme: "\u0422\u044D\u043C\u0430 \u043A\u0430\u0440\u0442\u044B",
            map_theme_default: "\u041A\u043B\u0430\u0441\u0456\u0447\u043D\u0430\u044F",
            metadata_general_copy_id: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C ID",
            metadata_general_copy_picid: "\u041A\u0430\u043F\u0456\u044F\u0432\u0430\u0446\u044C ID \u0432\u044B\u044F\u0432\u044B",
            metadata_general_picid: "\u0412\u044B\u044F\u0432\u0430",
            metadata_general_seqid: "\u0421\u0435\u0440\u044B\u044F",
            metadata_general_picid_link: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u044F \u0432\u044B\u044F\u0432\u044B",
            metadata_general_seqid_link: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u044F \u0441\u0435\u0440\u044B\u0456",
            metadata_general_author: "\u0410\u045E\u0442\u0430\u0440",
            metadata_general_license: "\u041B\u0456\u0446\u044D\u043D\u0437\u0456\u044F",
            metadata_general_license_link: "\u0413\u043B\u044F\u0434\u0437\u0435\u0446\u044C \u043F\u043E\u045E\u043D\u0430\u0435 \u0430\u043F\u0456\u0441\u0430\u043D\u043D\u0435 \u043B\u0456\u0446\u044D\u043D\u0437\u0456\u0456",
            metadata_general_date: "\u0414\u0430\u0442\u0430 \u0437\u0434\u044B\u043C\u043A\u0456",
            metadata_general_instance: "\u0406\u043D\u0441\u0442\u0430\u043D\u0446\u044B\u044F \u043F\u0430\u0445\u043E\u0434\u0436\u0430\u043D\u043D\u044F",
            metadata_camera: "\u041A\u0430\u043C\u0435\u0440\u0430",
            metadata_camera_make: "\u0412\u044B\u0442\u0432\u043E\u0440\u0446\u0430",
            metadata_camera_model: "\u041C\u0430\u0434\u044D\u043B\u044C",
            metadata_camera_type: "\u0422\u044B\u043F",
            metadata_camera_resolution: "\u0420\u0430\u0437\u0434\u0437\u044F\u043B\u044F\u043B\u044C\u043D\u0430\u0441\u0446\u044C",
            metadata_camera_focal_length: "\u0424\u0430\u043A\u0443\u0441\u043D\u0430\u044F \u0430\u0434\u043B\u0435\u0433\u043B\u0430\u0441\u0446\u044C",
            metadata_location: "\u041F\u0430\u0437\u0456\u0446\u044B\u044F",
            metadata_quality_score: "\u0410\u0433\u0443\u043B\u044C\u043D\u0430\u044F \u0430\u0434\u0437\u043D\u0430\u043A\u0430",
            metadata_exif_value: "\u0417\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            metadata_exif_doc: "\u0414\u0430\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u044B\u044F \u043F\u0430 EXIF \u0442\u044D\u0433\u0430\u0445",
            metadata_exif_doc_title: "\u041F\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 \u0434\u0430\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u044B\u0456 Exiv2 \u0434\u043B\u044F \u043F\u043E\u045E\u043D\u044B\u0445 \u0437\u0432\u0435\u0441\u0442\u0430\u043A \u043F\u0440\u0430 \u0432\u044B\u0437\u043D\u0430\u0447\u044D\u043D\u043D\u0456 EXIF \u0456 XMP \u0442\u044D\u0433\u0430\u045E",
            semantics_title: "\u0422\u044D\u0433\u0456",
            semantics_tags: "{nb} \u0442\u044D\u0433\u0430\u045E",
            semantics_features_default_title: "\u0422\u044D\u0433 {nb}",
            semantics_features_subtitle: "{nb} \u0437\u0432\u044F\u0437\u0430\u043D\u044B\u0445 \u0443\u043B\u0430\u0441\u0446\u0456\u0432\u0430\u0441\u0446\u0435\u0439",
            semantics_annotation_tooltip: "\u041D\u0430\u0446\u0456\u0441\u043D\u0456\u0446\u0435, \u043A\u0430\u0431 \u0443\u0431\u0430\u0447\u044B\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456",
            semantics_key: "\u041A\u043B\u044E\u0447",
            semantics_value: "\u0417\u043D\u0430\u0447\u044D\u043D\u043D\u0435",
            semantics_sequence_tags: "\u0422\u044D\u0433 \u0441\u0435\u0440\u044B\u0456",
            semantics_picture_tags: "\u0422\u044D\u0433 \u0432\u044B\u044F\u0432\u044B",
            semantics_annotation_tags: "\u0422\u044D\u0433 \u0430\u0431'\u0435\u043A\u0442\u0430",
            semantics_doc: "\u0414\u0430\u043F\u0430\u043C\u043E\u0433\u0430",
            semantics_doc_title: "\u041F\u0440\u0430 \u0442\u044D\u0433\u0456",
            semantics_doc_info1: "\u0414\u0430\u0434\u0430\u0439\u0446\u0435 \u043A\u0430\u043D\u0442\u044D\u043A\u0441\u0442 \u0434\u0430 \u0432\u044B\u044F\u0432\u044B \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0442\u044D\u0433\u0430\u045E. \u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u043F\u0430\u0437\u043D\u0430\u0447\u044B\u0446\u044C, \u0448\u0442\u043E \u044F\u043D\u0430 \u0437\u0440\u043E\u0431\u043B\u0435\u043D\u0430 \u0437 \u043C\u0430\u0448\u044B\u043D\u044B, \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0442\u044D\u0433\u0430 transport=car.",
            semantics_doc_info2: "\u0412\u044B \u0442\u0430\u043A\u0441\u0430\u043C\u0430 \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043B\u0443\u0447\u044B\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435: \u0434\u0430\u0440\u043E\u0436\u043D\u044B\u044F \u0437\u043D\u0430\u043A\u0456, \u0433\u0430\u0440\u0430\u0434\u0441\u043A\u043E\u0435 \u0430\u0431\u0441\u0442\u0430\u043B\u044F\u0432\u0430\u043D\u043D\u0435\u2026 \u041F\u0430\u0437\u043D\u0430\u0447\u0430\u0439\u0446\u0435 \u0442\u043E\u0435, \u0448\u0442\u043E \u0431\u0430\u0447\u044B\u0446\u0435, \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0456\u0441\u043D\u0443\u044E\u0447\u044B\u0445 \u0442\u044D\u0433\u0430\u045E. \u041F\u0440\u044B \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430\u0441\u0446\u0456 \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0441\u0442\u0432\u0430\u0440\u0430\u0446\u044C \u0441\u0432\u0430\u0435 \u045E\u043B\u0430\u0441\u043D\u044B\u044F.",
            semantics_doc_info3: "\u041D\u0435\u043A\u0430\u0442\u043E\u0440\u044B\u044F \u0430\u0431'\u0435\u043A\u0442\u044B \u0430\u045E\u0442\u0430\u043C\u0430\u0442\u044B\u0447\u043D\u0430 \u0432\u044B\u044F\u045E\u043B\u044F\u044E\u0446\u0446\u0430 \u0437 \u0434\u0430\u043F\u0430\u043C\u043E\u0433\u0430\u0439 \u0428\u0406: \u044F\u043A\u0430\u0441\u0446\u044C \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0435\u0446\u0446\u0430.",
            semantics_doc_link: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0442\u044D\u0433\u0456",
            semantics_key_doc: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0433\u044D\u0442\u044B \u043A\u043B\u044E\u0447",
            semantics_value_doc: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 \u0433\u044D\u0442\u044B \u0442\u044D\u0433",
            semantics_qualifiers: "\u041A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0442\u0430\u0440\u044B",
            semantics_show_annotations: "\u0410\u0434\u043B\u044E\u0441\u0442\u0440\u043E\u045E\u0432\u0430\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_hide_annotations: "\u0421\u0445\u0430\u0432\u0430\u0446\u044C \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0430 \u0432\u044B\u044F\u0432\u0435",
            semantics_zero_annotations: "\u041D\u0430 \u0433\u044D\u0442\u0430\u0439 \u0432\u044B\u044F\u0432\u0435 \u0430\u0431'\u0435\u043A\u0442\u044B \u043D\u0435 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B",
            semantics_add_annotation: "\u0414\u0430\u0434\u0430\u0446\u044C \u043D\u043E\u0432\u044B \u0442\u044D\u0433",
            semantics_draw_annotation: "\u0412\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0432\u044B\u043B\u0443\u0447\u044B\u0446\u044C \u0430\u0431'\u0435\u043A\u0442, \u044F\u043A\u0456 \u0445\u043E\u0447\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044C, \u043D\u0430 \u0432\u044B\u044F\u0432\u0435 (\u041D\u0435\u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430).",
            semantics_erase_annotation: "\u0421\u0446\u0435\u0440\u0446\u0456 \u0432\u044B\u043B\u0443\u0447\u0430\u043D\u044B \u0430\u0431'\u0435\u043A\u0442",
            semantics_delete_annotation: "\u0412\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B \u0430\u0431'\u0435\u043A\u0442",
            semantics_delete_annotation_confirm: "\u0412\u044B \u0441\u0430\u043F\u0440\u0430\u045E\u0434\u044B \u0436\u0430\u0434\u0430\u0435\u0446\u0435 \u0432\u044B\u0434\u0430\u043B\u0456\u0446\u044C \u0433\u044D\u0442\u044B \u0442\u044D\u0433?",
            semantics_wikidata_properties: {
                P31: "\u0430\u0441\u043E\u0431\u043D\u0456\u043A \u043A\u043B\u0430\u0441\u0430",
                P279: "\u043F\u0430\u0434\u043A\u043B\u0430\u0441",
                P361: "\u0447\u0430\u0441\u0442\u043A\u0430"
            },
            semantics_editor_error: "\u0421\u0456\u043D\u0442\u0430\u043A\u0441\u0456\u0441 \u043D\u0435\u0441\u0430\u043F\u0440\u0430\u045E\u0434\u043D\u044B. \u0412\u0430\u0448\u044B \u0442\u044D\u0433\u0456 \u043C\u043E\u0433\u0443\u0446\u044C \u0432\u044B\u0433\u043B\u044F\u0434\u0430\u0446\u044C \u0442\u0430\u043A:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\n\u041C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u0430\u045E\u0436\u044B\u043D\u044F \u043A\u043B\u044E\u0447\u0430 - 256 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E, \u043C\u0430\u043A\u0441\u0456\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u0430\u045E\u0436\u044B\u043D\u044F \u0437\u043D\u0430\u0447\u044D\u043D\u043D\u044F - 2048 \u0441\u0456\u043C\u0432\u0430\u043B\u0430\u045E.",
            semantics_edit: "\u0420\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u0446\u044C \u0430\u0442\u0440\u044B\u0431\u0443\u0442\u044B",
            semantics_save: "\u0417\u0430\u0445\u0430\u0432\u0430\u0446\u044C \u0437\u043C\u0435\u043D\u044B",
            semantics_undo: "\u0421\u043A\u0430\u0441\u0430\u0432\u0430\u0446\u044C \u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u043D\u0435",
            semantics_send_fail: "\u041D\u0435\u043C\u0430\u0433\u0447\u044B\u043C\u0430 \u0437\u0430\u0445\u0430\u0432\u0430\u0446\u044C \u0437\u043C\u0435\u043D\u044B, \u043A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439",
            semantics_login_needed: "\u0414\u043B\u044F \u0440\u044D\u0434\u0430\u0433\u0430\u0432\u0430\u043D\u043D\u044F \u0442\u044D\u0433\u0430\u045E \u0430\u0431\u043E \u0430\u0431'\u0435\u043A\u0442\u0430\u045E \u043D\u0430 \u0432\u044B\u044F\u0432\u0435 \u0432\u0430\u043C \u043D\u0435\u0430\u0431\u0445\u043E\u0434\u043D\u0430 \u045E\u0432\u0430\u0439\u0441\u0446\u0456 \u045E \u0456\u043D\u0441\u0442\u0430\u043D\u0446\u044B\u044E Panoramax {n}. \u0416\u0430\u0434\u0430\u0435\u0446\u0435 \u045E\u0432\u0430\u0439\u0441\u0446\u0456?",
            report: "\u041F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435",
            report_auth: '\u0413\u044D\u0442\u0430\u044F \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430 \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045E\u043B\u0456\u043A\u043E\u0432\u0430\u0433\u0430 \u0437\u0430\u043F\u0456\u0441\u0443 "{a}"',
            report_nature_label: "\u041F\u0440\u044B\u0447\u044B\u043D\u0430 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u044B",
            report_whole_sequence: "\u0413\u044D\u0442\u0430 \u0442\u044B\u0447\u044B\u0446\u0446\u0430 \u045E\u0441\u0451\u0439 \u0441\u0435\u0440\u044B\u0456",
            report_details: "\u0414\u0430\u0434\u0430\u0442\u043A\u043E\u0432\u044B\u044F \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456",
            report_details_placeholder: "\u041F\u0430 \u0436\u0430\u0434\u0430\u043D\u043D\u0456, \u0432\u044B \u043C\u043E\u0436\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044C \u043F\u0430\u0434\u0440\u0430\u0431\u044F\u0437\u043D\u0430\u0441\u0446\u0456 \u043F\u0440\u0430 \u043F\u0440\u0430\u0431\u043B\u0435\u043C\u0443",
            report_email: "\u0412\u0430\u0448 email",
            report_email_placeholder: "\u041D\u0435\u0430\u0431\u0430\u0432\u044F\u0437\u043A\u043E\u0432\u0430",
            report_submit: "\u0410\u0434\u043F\u0440\u0430\u0432\u0456\u0446\u044C",
            report_wait: "\u0410\u0434\u043F\u0440\u0430\u045E\u043A\u0430 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u044F\u2026",
            report_failure: "\u041F\u0440\u044B \u0441\u0442\u0432\u0430\u0440\u044D\u043D\u043D\u0456 \u043F\u0430\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u044F \u0430\u0434\u0431\u044B\u043B\u0430\u0441\u044F \u043F\u0430\u043C\u044B\u043B\u043A\u0430: {e}. \u041A\u0430\u043B\u0456 \u043B\u0430\u0441\u043A\u0430, \u043F\u0430\u0441\u043F\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043F\u0430\u0437\u043D\u0435\u0439.",
            report_success: "\u041F\u0410\u0432\u0435\u0434\u0430\u043C\u043B\u0435\u043D\u043D\u0435 \u043F\u0430\u0441\u043F\u044F\u0445\u043E\u0432\u0430 \u0430\u0434\u043F\u0440\u0430\u045E\u043B\u0435\u043D\u0430. \u042F\u043D\u043E \u0431\u0443\u0434\u0437\u0435 \u0440\u0430\u0437\u0433\u043B\u0435\u0434\u0436\u0430\u043D\u0430 \u044F\u043A \u043C\u0430\u0433\u0430 \u0445\u0443\u0442\u0447\u044D\u0439."
        },
        map: {
            loading: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
            thumbnail: "\u041C\u0456\u043D\u0456\u044F\u0446\u044E\u0440\u0430 \u0432\u044B\u044F\u0432\u044B \u043F\u0430\u0434 \u043A\u0443\u0440\u0441\u043E\u0440\u0430\u043C",
            not_public: "\u041D\u0435\u043F\u0443\u0431\u043B\u0456\u0447\u043D\u0430 \u0431\u0430\u0447\u043D\u0430\u044F",
            slow_loading: "\u041A\u0430\u0440\u0442\u0430 \u043F\u0430\u0432\u043E\u043B\u044C\u043D\u0430 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u0456 \u043C\u043E\u0436\u0430 \u0437\u0434\u0430\u0432\u0430\u0446\u0446\u0430 \u043F\u0430\u0448\u043A\u043E\u0434\u0436\u0430\u043D\u0430\u0439",
            map_data: "\u041A\u0430\u0440\u0442\u0430 \u043D\u0430 \u0430\u0441\u043D\u043E\u0432\u0435 {m}",
            more_panoramax: "\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043E\u043B\u044C\u0448 \u043F\u0440\u0430 Panoramax"
        }
    },
    br: {
        pnx: {
            minimize_short: "Kuzhat",
            search: "Klask",
            copy: "Eila\xf1",
            map_theme_type: "Seurt kamera",
            metadata_general_copy_id: "Eila\xf1 an ID",
            metadata_general_copy_picid: "Eila\xf1 ID ar foto",
            metadata_general_picid: "Foto",
            metadata_location_copy: "Eila\xf1 {v}",
            filter_date: "Deiziad",
            loading_labels_serious: [
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                null,
                "\uD83D\uDCE1 O pellgarga\xf1 an hizivadenno\xf9"
            ],
            map_theme_age_4: "- 6 miz",
            map_theme_age_3: "\xbd - 1 bloaz",
            map_theme_age_2: "1 - 3 vloaz",
            map_theme_age_1: "+ 3 vloaz",
            error_click: "Kenderc'hel",
            id: "iD",
            josm: "JOSM",
            filter_date_1year: "1 bloaz",
            filter_user: "Implijer",
            filter_date_1month: "1 miz",
            filter_user_mypics: "Ma fotoio\xf9",
            filter_picture: "Seurt foto",
            semantics_download: "Pellgarga\xf1",
            filter_date_6months: "6 miz",
            picture_all: "An holl",
            metadata_camera: "Kamera",
            report_email: "Ho postel",
            report_submit: "Kinnig",
            semantics_doc: "Skoazell",
            metadata_summary: "Diverradenn",
            expand: "Brasaat",
            options: "Dibarzhio\xf9",
            show_map: "Diskwel ar gartenn",
            filters: "Silio\xf9",
            search_address: "Klask ur chomlec'h pe ur g\xear\u2026",
            share_rss: "Gwazh RSS",
            share_links: "Liammo\xf9",
            share_page: "Liamm ar foto",
            share_image: "Skeudenn HD",
            panoramax: "Panoramax",
            map_background: "Drekleur",
            map_background_streets: "Straedo\xf9",
            error: "Ur gudenn zo ganeomp\u2026",
            picture_360: "360\xb0",
            share_print: "Moulla\xf1",
            metadata_general_picid_link: "Mont d'an deskrivadur JSON eus ar foto",
            semantics_key: "Alc'hwez",
            "visibility_owner-only": "Kuzhet",
            semantics_value_show_osm: "Gwelout war OpenStreetMap",
            filter_gps_precision_between: "Etre {n1} ha {n2} metr",
            metadata_general_license: "Lisa\xf1s",
            share: "Ranna\xf1",
            copied: "Eilet",
            metadata_exif: "EXIF",
            "visibility_logged-only": "Izili",
            whats_panoramax: "Danvez geografel boutin evit poltriji an tiriado\xf9 eo Panoramax.",
            filter_locked: "Sil diweredekaet",
            map_background_default: "Dre ziouer",
            filter_source_local: "Ar servijer-ma\xf1",
            filter_source_world: "Bed a-bezh",
            map_theme_default_3: "Mat",
            metadata_general_title: "Titl",
            delete_picture: "Dilemel"
        },
        map: {
            more_panoramax: "Gouzout hiroc'h diwar-benn Panoramax",
            loading: "O karga\xf1\u2026"
        },
        psv: {
            twoFingers: "Implij daou viz evit kantreal"
        }
    },
    da: {
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Placering ikke tilg\xe6ngelig",
            "GeolocateControl.FindMyLocation": "Find min placering"
        },
        pnx: {
            minimize: "Skjul dette modul, du kan vise det igen ved hj\xe6lp af knappen i nederste venstre hj\xf8rne",
            share_embed_docs: "L\xe6s mere om indlejringskonfiguration",
            zoom: "Zoom",
            zoomOut: "Zoom ud",
            zoomIn: "Zoom ind",
            moveUp: "Ryk opad",
            moveDown: "Ryk nedad",
            moveLeft: "Ryk til venstre",
            moveRight: "Ryk til h\xf8jre",
            moveMiddle: "Centreret visning",
            expand: "Udvid",
            expand_info: "F\xe5 modulet til at blive vist p\xe5 hele siden",
            show_psv: "Vis billedfremviseren",
            show_map: "Vis kortet",
            options: "Valgmuligheder",
            filters: "Filtre",
            layers: "Lag",
            search: "S\xf8g",
            search_empty: "Ingen resultater fundet",
            search_user: "S\xf8g efter et brugernavn\u2026",
            share: "Del",
            share_links: "Links",
            share_page: "Link til dette billede",
            share_image: "HD-billede",
            share_rss: "RSS-feed",
            share_rss_title: "RSS-feed med nye sekvenser i det aktuelt synlige kortomr\xe5de",
            share_embed: "Indlejr p\xe5 din hjemmeside",
            share_print: "Udskriv",
            copy: "Kopi\xe9r",
            copied: "Kopieret",
            error_retry: "Pr\xf8v igen senere",
            sequence_next: "N\xe6ste billede i sekvensen",
            sequence_play: "Afspil denne sekvens",
            sequence_more: "Flere afspilningsmuligheder",
            sequence_speed: "Afspillerens hastighed",
            legend_license: "Licens: {l}",
            legend_title: "Vis detaljer om billedet",
            error_click: "Forts\xe6t",
            error: "Vi har et problem\u2026",
            search_address: "S\xf8g efter en adresse, by, etc\u2026",
            sequence_pause: "S\xe6t sekvensen p\xe5 pause",
            sequence_prev: "Forrige billede i sekvensen",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Indl\xe6ser kortdata",
                "\uD83D\uDDA5\uFE0F Anmoder API",
                "\uD83D\uDDBC\uFE0F Indl\xe6ser thumbnails",
                "\uD83D\uDD0D Analyserer EXIF-metadata",
                "\uD83C\uDFD8\uFE0F 3D-rendering",
                "\uD83D\uDCF7 Initialiserer 360\xb0-billeder",
                "\uD83D\uDFE0 Farveafstemning",
                "\uD83D\uDCAF Beregning af kvalitetsscore \xa9",
                "\uD83D\uDCE1 Downloader opdateringer",
                "\uD83C\uDF0D Henter kortfliser",
                "\uD83D\uDCF8 Behandler skygger"
            ],
            edit_osm: "Rediger OSM",
            josm_live: "Aktiv\xe9r automatisk JOSM-synkronisering ved indl\xe6sning af billeder",
            loading_labels_fun: [
                "\uD83E\uDD8C Registrering af skilte om hjortekrydsning",
                "\uD83D\uDE98 S\xf8ger Panoramax Car \xa9",
                "\u2615 Injicerer koffein",
                "\uD83D\uDE00 Smil, du er blevet kortlagt!",
                "\uD83D\uDC08 Deler kattebilleder",
                "\uD83D\uDE34 Reducerer overspringshandlinger",
                "\uD83E\uDED6 Brygger te",
                "\uD83D\uDC27 \xc5bner kildekode",
                "\uD83D\uDE87 Indekser undergrundsstationer",
                "\uD83E\uDDF9 Ryd op i metadata",
                "\uD83D\uDE92 Sender billeder af brandstation",
                "\uD83D\uDEB2 Opdatering af cykelruter",
                "\uD83D\uDE89 G\xe5r ned ad perron p\xe5 station",
                "\uD83D\uDEF0\uFE0F S\xf8ger efter satellitter",
                "\uD83D\uDC65 Skriver personaer",
                "\uD83D\uDC1F Finder fish and chip butik",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fejlfinder gr\xe6nseflade",
                "\uD83D\uDCC8 Inkrementelle statistikker",
                "\uD83E\uDD16 L\xe6rer semantik",
                "\uD83C\uDFA8 Redesign af gr\xe6nseflade",
                "\uD83D\uDCC5 Planl\xe6gning af foto-kortl\xe6gningsfester",
                "\uD83E\uDDC0 Modning af cheddars",
                "\uD83C\uDF04 Beregning af Cornwalls solskin",
                "\uD83C\uDF0A M\xe5ling af h\xf8jvande"
            ],
            error_psv: "Photo Sphere Viewer indl\xe6ses ikke korrekt",
            error_nopic: "Intet billede tilg\xe6ngeligt p\xe5 den givne position",
            error_api: "Billedserveren er ikke tilg\xe6ngelig",
            error_webgl: "WebGL underst\xf8ttes ikke af din browser",
            filter_date: "Dato",
            filter_date_1month: "1 m\xe5ned",
            filter_date_1year: "1 \xe5r",
            filter_user: "Bruger",
            filter_user_mypics: "Mine billeder",
            filter_picture: "Billedtype",
            filter_zoom_in: "Zoom ind for at l\xe5se op",
            picture_flat: "Klassisk",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Klik for at aktivere eller deaktivere",
            map_background: "Kortbaggrund",
            map_background_aerial: "Luftfoto",
            map_background_streets: "Gader",
            map_theme: "Korttema",
            error_pic: "Det \xf8nskede billede blev ikke fundet",
            error_api_compatibility: "Billedserveren er ikke kompatibel med denne version af fremviseren",
            filter_qualityscore: "Kvalitetsscore",
            error_josm: "JOSM svarer ikke, k\xf8rer den, og er fjernstyring aktiveret?",
            metadata_general_seqid_link: "G\xe5 til JSON-beskrivelse af sekvensen",
            map_theme_default: "Klassisk",
            map_theme_age_1: "> 3 \xe5r",
            map_theme_age_2: "< 3 \xe5r",
            map_theme_age_3: "< 1 \xe5r",
            map_theme_age_4: "< 6 m\xe5ned",
            map_theme_type: "Kameratype",
            map_theme_score: "Kvalitetsscore",
            contrast: "Aktiv\xe9r h\xf8jere billedkontrast",
            metadata_general_picid: "Billede",
            metadata_general_seqid: "Sekvens",
            metadata_general_picid_link: "G\xe5 til JSON-beskrivelse af billedet",
            metadata_general_author: "Forfatter",
            metadata_general_license: "Licens",
            metadata_general_license_link: "Se den fulde licensbeskrivelse",
            metadata_general_date: "Optagelsesdato",
            metadata_camera: "Kamera",
            metadata_camera_make: "Fabrikat",
            metadata_camera_model: "Model",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "Opl\xf8sning",
            metadata_camera_focal_length: "Br\xe6ndvidde",
            metadata_location_latitude: "Breddegrad",
            metadata_location_orientation: "Retning",
            metadata_location_precision: "Pr\xe6cision i positionering",
            metadata_quality: "Kvalitet",
            metadata_quality_score: "Global score",
            metadata_quality_gps_score: "Positioneringsscore",
            metadata_quality_help: "F\xe5 mere at vide om kvalitetsscore",
            map_theme_age: "Optagelsesdato",
            metadata_location: "Position",
            metadata: "Metadata for billede",
            metadata_location_longitude: "L\xe6ngdegrad",
            metadata_quality_resolution_score: "Opl\xf8sningsscore",
            metadata_quality_missing: "ingen v\xe6rdi indstillet i billedet",
            metadata_exif: "EXIF",
            metadata_exif_name: "Tag",
            metadata_exif_value: "V\xe6rdi",
            report: "Indberet",
            report_auth: 'Denne indberetning vil blive sendt via din konto "{a}"',
            report_nature_label: "Problemets \xe5rsag",
            report_nature: {
                "": "V\xe6lg problemets art\u2026",
                blur_missing: "En persons ansigt eller bils nummerplade er synlig",
                blur_excess: "Der blev anvendt un\xf8dvendig sl\xf8ring p\xe5 et objekt",
                inappropriate: "Billedet er upassende (ikke relevant, n\xf8genhed\u2026)",
                privacy: "Billedet er taget fra en privat sti eller ejendom",
                picture_low_quality: "Billedet er af lav kvalitet",
                mislocated: "Billedet er d\xe5rligt placeret p\xe5 kortet",
                copyright: "Billedet kr\xe6nker ophavsretten",
                other: "Enhver anden form for problem"
            },
            report_whole_sequence: "Det g\xe6lder hele sekvensen",
            report_details: "Yderligere detaljer",
            report_details_placeholder: "Du kan eventuelt tilf\xf8je detaljer om problemet",
            report_email: "Din e-mail",
            report_email_placeholder: "Valgfri",
            report_submit: "Indsend",
            report_wait: "Sender indberetning\u2026",
            report_success: "Indberetningen blev sendt. Den vil blive gennemg\xe5et hurtigst muligt.",
            report_failure: "Der opstod en fejl under oprettelse af indberetning: {e}. Pr\xf8v venligst igen senere.",
            qualityscore_title: "Om kvalitetsscoren",
            qualityscore_doc_2: "Scoren vises som et bogstav:",
            qualityscore_doc_3: '"A" er den bedste karakter, "E" den d\xe5rligste.',
            qualityscore_doc_link: "Yderligere oplysninger om kvalitetsscoren",
            qualityscore_doc_1: "Der beregnes en kvalitetsscore for hvert billede.",
            minimize_short: "Skjul",
            id: "iD",
            josm: "JOSM",
            metadata_general_instance: "Oprindelsesinstans",
            contribute_id: "Bidrag til OpenStreetMap med iD-editoren",
            geo_uri: "Ekstern app",
            picture_flat_long: "Klassisk billede",
            picture_360_long: "Panoramabillede",
            metadata_summary: "Opsummering",
            metadata_general_copy_id: "Kopi-ID",
            metadata_general_copy_picid: "Kopi\xe9r billed-ID",
            filter_date_6months: "6 m\xe5neder",
            picture_all: "Alle",
            panoramax: "Panoramax",
            semantics_send_ok: "Dine redigeringer blev indsendt",
            semantics_doc_info3: "Nogle objekter registreres automatisk med AI: kvaliteten er ikke garanteret.",
            semantics_doc_info1: "Giv kontekst for et billede ved hj\xe6lp af tags.",
            filter_gps_precision: "Placeringsn\xf8jagtighed",
            filter_gps_precision_lessthan: "Mindre {n} meter",
            filter_gps_precision_between: "Mellem {n1} og {n2} meter",
            filter_gps_precision_morethan: "Mere end {n} meter",
            map_theme_gps: "GPS-pr\xe6cision",
            metadata_location_copy: "Kopi\xe9r {v}",
            metadata_location_copy_more: "Flere muligheder for kopiering af koordinater",
            metadata_exif_doc: "Dok af EXIF-tags",
            semantics_editor_example: "key=v\xe6rdi\nprefix|key=v\xe6rdi",
            semantics_send_fail: "Kunne ikke gemme dine \xe6ndringer. Pr\xf8v igen senere",
            semantics_save: "Gem dine \xe6ndringer",
            semantics_edit: "Rediger egenskaber",
            semantics_undo: "Annuller dine \xe6ndringer",
            semantics_features: "Billedeobjekter",
            semantics_features_subtitle: "{nb} tilknyttede egenskaber",
            semantics_show_all_tags: "Vis alle tags",
            semantics_hide_all_tags: "Skjul alle tags",
            semantics_key: "N\xf8gle",
            semantics_title: "Tags",
            semantics_tags: "{nb} tags",
            semantics_value: "V\xe6rdi",
            semantics_key_doc: "F\xe5 mere at vide om denne n\xf8gle",
            semantics_annotation_tooltip: "Klik for at se detaljer",
            semantics_value_doc: "F\xe5 mere at vide om dette tag",
            semantics_qualifiers: "Kvalificerende",
            semantics_show_annotations: "Vis billedobjekter",
            semantics_doc_link: "F\xe5 mere at vide om tags",
            metadata_location_coordinates: "Koordinater (l\xe6ngdegrad, breddegrad)",
            whats_panoramax: "Panoramax er geo-commons for billeder af territorier.",
            semantics_features_none: "Der er endnu ikke tegnet nogen objekter p\xe5 dette billede.",
            semantics_wikidata_properties: {
                P361: "del af",
                P279: "underklasse af",
                P31: "instans af",
                P180: "afbilder"
            },
            metadata_exif_doc_title: "G\xe5 til Exiv2-dokumentationen for at f\xe5 alle detaljer om definitionerne af EXIF- og XMP-tags",
            semantics_features_default_title: "Tag {nb}",
            semantics_picture_tags: "Billed-tag",
            semantics_annotation_tags: "Objekt-tag",
            semantics_hide_annotations: "Skjul billedobjekter",
            semantics_sequence_tags: "Sekvens-tag",
            semantics_zero_annotations: "Ingen objekter tegnet p\xe5 dette billede",
            semantics_editor_error: "Syntaksen er ugyldig. Dine tags kan se s\xe5dan ud:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nDen maksimale n\xf8glel\xe6ngde er 256 tegn, den maksimale v\xe6rdil\xe6ngde er 2048 tegn.",
            semantics_delete_annotation: "Slet dette objekt",
            semantics_delete_annotation_confirm: "Vil du virkelig slette dette tag?",
            semantics_add_annotation: "Tilf\xf8j et nyt tag",
            semantics_draw_annotation: "Du kan tegne det objekt, du vil tilf\xf8je, over billedet (valgfrit).",
            semantics_login_needed: "For at redigere billedtags eller objekter skal du logge ind p\xe5 Panoramax {n} instance. Vil du logge ind?",
            semantics_doc: "Hj\xe6lp",
            semantics_doc_title: "Om tags",
            semantics_erase_annotation: "Slet tegnet objekt",
            semantics_doc_info2: "Du kan ogs\xe5 tegne objekter p\xe5 billedet: vejskilte, byudstyr\u2026 Mark\xe9r det, du ser, ved hj\xe6lp af eksisterende tags. Du kan ogs\xe5 oprette dine egne, hvis det er n\xf8dvendigt.",
            semantics_overlays: {
                tfsigns: "F\xe6rdselstavler",
                features: "Alle objekter"
            },
            semantics_zoom_in: "Zoom ind p\xe5 kortet for at se tags",
            semantics_download: "Download",
            semantics_download_title: "Download tags",
            semantics_download_cta: "Download open-data",
            semantics_download_info: "Alle semantiske data (tags) er tilg\xe6ngelige som \xe5bne data. Du kan downloade dem og bruge dem frit.",
            semantics_doc_info1u1: "Du kan tagge det som optaget fra bil med tagget transport=car.",
            semantics_copy: "Kopi\xe9r egenskaber",
            semantics_value_show_osm: "Se p\xe5 OpenStreetMap",
            popup_details_link: "Flere detaljer",
            qualityscore_doc_41: "GPS-pr\xe6cisionen",
            filter_gps_precision_help_4: 'En RTK GPS f\xe5r karakteren "5\u2B50" , et actionkamera som GoPro Max f\xe5r karakteren "3\u2B50", og en smartphone GPS i en underjordisk parkeringsk\xe6lder f\xe5r karakteren "1\u2B50".',
            filter_gps_precision_help_1: "Der er oplysninger om placeringspr\xe6cision tilg\xe6ngelige for hvert billede. Dette svarer til GPS-pr\xe6cision under billedoptagelsen.",
            filter_gps_precision_help_2: "Pr\xe6cisionen udtrykkes med stjerner:",
            filter_gps_precision_help: "F\xe5 mere at vide om placeringsn\xf8jagtighed",
            qualityscore_doc_4: "Denne score beregnes p\xe5 baggrund af:",
            qualityscore_doc_42: "billedopl\xf8sningen",
            qualityscore_doc_5: "Et professionelt kamera f\xe5r karakteren A, et 360\xb0-actionkamera f\xe5r karakteren B, og en smartphone f\xe5r en karakter mellem C og E.",
            filter_gps_precision_help_3: '"5\u2B50" er meget pr\xe6cis (<= {p5}m), "1\u2B50" er meget upr\xe6cis (> {p1}m) eller ukendt.',
            "visibility_logged-only": "Medlemmer",
            "visibility_title_logged-only": "Kun personer med en konto kan se dette billede",
            "visibility_owner-only": "Skjult",
            "visibility_title_owner-only": "Det er kun dig, der kan se dette billede",
            indoor_selector_shrink: "Klik for at minimere",
            indoor_switch: "Indend\xf8rs rum",
            indoor_selector_expand: "Klik for at se alle tilg\xe6ngelige niveauer",
            indoor_selector_levelup: "G\xe5 til \xf8verste niveau",
            indoor_selector_leveldown: "G\xe5 til nederste niveau",
            indoor_selector_scrollup: "Rul niveau-listen opad",
            indoor_selector_scrolldown: "Rul niveau-listen nedad",
            filter_source_world: "Hele verden",
            filter_source_local: "Denne server",
            filter_locked: "Filter deaktiveret",
            map_background_more: "Mere",
            map_background_default: "Standard",
            semantics_draw_invalid_annotation: "Det tegnede omr\xe5de g\xe5r ud over billedets gr\xe6nser. S\xf8rg for at tegne inden for det synlige billede.",
            semantics_draw_unfinished_annotation: "Det tegnede omr\xe5de er ikke f\xe6rdigt. S\xf8rg for, at omr\xe5det er placeret korrekt, inden du gemmer.",
            error_pic_load: "Billedet kan ikke indl\xe6ses i \xf8jeblikket.\nKontroller din internetforbindelse. Hvis du har forbindelse, skal du sikre dig, at billed-ID'et er gyldigt.",
            low_contrast: "Lavere billedkontrast",
            reset_contrast: "Nulstil billedkontrast",
            metadata_general_title: "Titel",
            delete_picture: "Slet",
            delete_picture_warn: "\u26A0\uFE0F Advarsel: Dette sletter billedet permanent.\nEr du sikker p\xe5, at du vil slette dette billede helt?",
            delete_picture_ok: "Billedet blev slettet",
            delete_picture_error: "Der opstod en fejl under fors\xf8get p\xe5 at slette billedet:\n{e}",
            semantics_empty: "Der er ikke defineret nogen tags",
            time_travel: "Se dette sted p\xe5 andre datoer",
            time_travel_close: "Skjul andre datoer",
            map_theme_default_short: "Standard",
            map_theme_age_short: "Dato",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kvalitet",
            map_theme_gps_short: "Position"
        },
        psv: {
            loadError: "Panoramaet kan ikke indl\xe6ses",
            twoFingers: "Brug to fingre til at navigere",
            ctrlZoom: "Brug ctrl + scroll til at zoome ind p\xe5 billedet"
        },
        map: {
            loading: "Indl\xe6ser\u2026",
            thumbnail: "Miniature af billedet, der holdes",
            not_public: "Ikke offentligt synlig",
            slow_loading: "Kortet indl\xe6ses langsomt og kan virke defekt",
            map_data: "Kortdata: {m}",
            more_panoramax: "F\xe5 mere at vide om Panoramax"
        }
    },
    de: {
        pnx: {
            options: "Optionen",
            filters: "Filter",
            search: "Suche",
            layers: "Ebenen",
            share_links: "Links",
            share_page: "Link zu diesem Bild",
            loading_labels_fun: [
                '\uD83E\uDD8C Erkennung von "Reh kreuzt"-Schildern',
                "\uD83D\uDE98 Suche Panoramax-Auto \xa9",
                "\u2615 Koffeininjektion",
                "\uD83D\uDE00 L\xe4chle, du wurdest kartografiert!",
                "\uD83D\uDC08 Katzenfotos teilen",
                "\uD83D\uDE34 Vermeide Prokrastination",
                "\uD83C\uDF7A\uFE0F Bier brauen",
                "\uD83D\uDC27 Quellcode \xf6ffnen",
                "\uD83D\uDEE3\uFE0F Indizierung der Autobahnen",
                "\uD83E\uDDF9 Metadaten werden aufger\xe4umt",
                "\uD83D\uDE92 Sende Fotos von Feuerwachen",
                "\uD83D\uDEB2 Radwege werden aktualisiert",
                "\uD83D\uDE89 Bahnsteig wird abgelaufen",
                "\uD83D\uDEF0\uFE0F Satelliten werden gesucht",
                "\uD83D\uDC65 Personas anlegen",
                "\uD83C\uDF2D\uFE0F Orte n\xe4chsten Currywurst-Stand",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fehlerbehebung wird ausgef\xfchrt",
                "\uD83D\uDCC8 Statistiken anpassen",
                "\uD83E\uDD16 Suche den Sinn des Lebens",
                "\uD83C\uDFA8 Benutzeroberfl\xe4che wird neu gestaltet",
                "\uD83D\uDCC5 Fotomapping-Partys planen",
                "\uD83E\uDDC0 Dem Emmentaler beim Reifen zuschauen",
                "\uD83C\uDF04 Sonnenstand berechnen",
                "\uD83C\uDF0A Messung der Gezeiten"
            ],
            search_empty: "Keine Ergebnisse gefunden",
            share: "Teilen",
            metadata_general_picid: "Bild",
            zoom: "Zoom",
            zoomOut: "Herauszoomen",
            zoomIn: "Hereinzoomen",
            moveUp: "Nach oben",
            moveDown: "Nach unten",
            moveRight: "Nach rechts",
            moveMiddle: "Sicht zentrieren",
            map_theme_age: "Aufnahmedatum",
            expand: "Ausklappen",
            expand_info: "Widget im Vollbild anzeigen",
            show_psv: "Bildbetrachter anzeigen",
            show_map: "Karte anzeigen",
            search_user: "Suche einen Nutzernamen\u2026",
            filter_zoom_in: "Vergr\xf6\xdfern, um freizuschalten",
            picture_flat: "Klassisch",
            picture_360: "360\xb0",
            filter_camera_model: "Nach Kameramodell",
            map_background: "Hintergrund",
            map_background_aerial: "Satelliten",
            map_background_streets: "Stra\xdfen",
            map_theme: "Thema",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Wert",
            map_theme_type: "Kameratyp",
            contrast: "H\xf6heren Bildkontrast aktivieren",
            metadata: "Bildmetadaten",
            metadata_general_seqid: "Sequenz",
            metadata_general_picid_link: "Zur JSON-Beschreibung des Bildes wechseln",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Lade Kartendaten",
                "\uD83D\uDDA5\uFE0F API anfragen",
                "\uD83D\uDDBC\uFE0F Vorschaubilder laden",
                "\uD83D\uDD0D EXIF-Metadaten analysieren",
                "\uD83C\uDFD8\uFE0F 3D-Rendering",
                "\uD83D\uDCF7 360\xb0 Fotos initialisieren",
                "\uD83D\uDFE0 Farben ausgleichen",
                "\uD83D\uDCAF Berechne Quality Score \xa9",
                "\uD83D\uDCE1 Herunterladen von Updates",
                "\uD83C\uDF0D Lade Kartenausschnitte",
                "\uD83D\uDCF8 Bearbeitung der Schatten"
            ],
            search_address: "Suche eine Adresse oder Stadt etc\u2026",
            share_image: "HD-Bild",
            share_rss: "RSS-Feed",
            share_embed: "Auf Webseite einbetten",
            share_print: "Drucken",
            copy: "Kopieren",
            copied: "Kopiert",
            error: "Ein Fehler ist aufgetreten\u2026",
            sequence_next: "N\xe4chstes Foto in der Sequenz",
            sequence_play: "Sequenz abspielen",
            sequence_pause: "Sequenz pausieren",
            sequence_prev: "Vorheriges Foto in der Sequenz",
            sequence_more: "Mehr Abspieloptionen",
            sequence_speed: "Abspielgeschwindigkeit",
            legend_license: "Lizenz: {l}",
            edit_osm: "OSM editieren",
            id: "iD",
            josm: "JOSM",
            josm_live: "Einschalten der automatischen JOSM-Synchronisierung beim Laden eines Bildes",
            error_psv: "Betrachter f\xfcr die Photospheres wurde nicht richtig geladen",
            error_pic: "Das angefragte Foto wurde nicht gefunden",
            error_nopic: "Kein Foto an dieser Position verf\xfcgbar",
            error_api: "Foto-Server ist nicht erreichbar",
            error_josm: "JOSM reagierte nicht. Ist das Programm ge\xf6ffnet und die Remote-Verbindung aktiv?",
            error_api_compatibility: "Der Foto-Server ist nicht mit dieser Version des Betrachters kompatibel",
            filter_date: "Datum",
            filter_user: "Benutzer",
            filter_picture: "Art des Fotos",
            map_theme_default: "Klassisch",
            map_theme_age_1: "> 3 Jahre",
            map_theme_age_2: "< 3 Jahre",
            map_theme_age_3: "\xbd - 1 Jahr",
            map_theme_age_4: "< 6 Monat",
            metadata_general_seqid_link: "Zur JSON-Beschreibung der Sequenz wechseln",
            metadata_general_author: "Autor",
            metadata_general_license: "Lizenz",
            metadata_general_date: "Aufnahmedatum",
            metadata_camera: "Kamera",
            metadata_camera_make: "Hersteller",
            metadata_camera_model: "Modell",
            metadata_camera_type: "Typ",
            metadata_camera_focal_length: "Brennweite",
            metadata_location: "Position",
            metadata_location_longitude: "L\xe4ngengrad",
            metadata_location_latitude: "Breitengrad",
            metadata_location_orientation: "Richtung",
            metadata_location_precision: "Genauigkeit der Positionierung",
            metadata_exif: "EXIF",
            minimize: "Dieses Widget verbergen. Du kannst es \xfcber die Schaltfl\xe4che in der linken, unteren Ecke wieder einblenden",
            error_subtitle: "Bitte versuchen sie es sp\xe4ter erneut, oder schauen sie in die Web-Browser-Konsole f\xfcr mehr Details.",
            moveLeft: "Nach links",
            share_rss_title: "RSS-Feed neuer Sequenzen auf dem aktuell sichtbaren Kartenbereich",
            error_webgl: "WebGL wird von ihrem Browser nicht unterst\xfctzt",
            metadata_general_license_link: "Vollst\xe4ndige Lizenzbeschreibung anschauen",
            share_embed_docs: "Mehr \xfcber die Einbettungs-Konfiguration lesen",
            report_nature: {
                "": "Art des Problems ausw\xe4hlen\u2026",
                inappropriate: "Das Bild ist unangemessen (irrelevant, Nacktheit, ...)",
                picture_low_quality: "Das Bild hat eine niedrige Qualit\xe4t",
                blur_missing: "Das Gesicht einer Person oder ein KFZ-Kennzeichen ist sichtbar",
                blur_excess: "Ein Objekt wurde unkenntlich gemacht, obwohl es nicht erforderlich war",
                privacy: "Das Foto wurde von einem privaten Weg oder Grundst\xfcck aus aufgenommen",
                mislocated: "Das Bild ist falsch auf der Karte eingezeichnet",
                copyright: "Das Bild verst\xf6\xdft gegen das Urheberrecht",
                other: "Eine andere Art von Problem"
            },
            report_details_placeholder: "Du kannst optional Details \xfcber das Problem hinzuf\xfcgen",
            report_auth: 'Diese Meldung wird \xfcber dein Konto "{a}" gesendet',
            report_nature_label: "Ursache des Problems",
            report_whole_sequence: "Dies betrifft die gesamte Sequenz",
            report_details: "Weitere Details",
            report_email: "Deine Email-Adresse",
            report_email_placeholder: "Optional",
            report_submit: "Absenden",
            report_success: "Deine Meldung wurde erfolgreich gesendet. Sie wird so schnell wie m\xf6glich \xfcberpr\xfcft.",
            report_failure: "Bei der Erstellung der Meldung ist ein Fehler aufgetreten: {e}. Bitte versuche es sp\xe4ter erneut.",
            report: "Melden",
            legend_title: "Zeige Bilderdetails",
            report_wait: "Meldung wird gesendet\u2026",
            error_click: "Weiter",
            error_retry: "Bitte sp\xe4ter erneut versuchen",
            metadata_camera_resolution: "Aufl\xf6sung",
            filter_user_mypics: "Meine Fotos",
            metadata_quality_missing: "kein Wert im Foto gesetzt",
            filter_date_1month: "1 Monat",
            filter_date_1year: "1 Jahr",
            filter_qualityscore: "Qualit\xe4tswert",
            filter_qualityscore_help: "Zum Aktivieren oder Deaktivieren klicken",
            map_theme_score: "Qualit\xe4tswert",
            metadata_quality: "Qualit\xe4t",
            metadata_quality_help: "Erfahre mehr \xfcber den Qualit\xe4tswert",
            metadata_quality_resolution_score: "Bewertung der Aufl\xf6sung",
            metadata_quality_gps_score: "Bewertung der Position",
            metadata_quality_score: "Gesamtwertung",
            qualityscore_title: "\xdcber den Qualit\xe4tswert",
            qualityscore_doc_link: "Weitere Informationen zur Berechnung des Qualit\xe4tsfaktors findest du in unserer Dokumentation",
            qualityscore_doc_1: "F\xfcr jedes Bild wird ein Qualit\xe4tswert berechnet.",
            qualityscore_doc_2: "Die Punktzahl wird als Buchstabe angezeigt:",
            qualityscore_doc_3: "\u201EA\u201C ist die beste Note, \u201EE\u201C die schlechteste.",
            minimize_short: "Verbergen",
            semantics_features_none: "Bislang wurde kein Feature in diesem Bild markiert.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} assoziierte Eigenschaften",
            semantics_show_all_tags: "Alle Tags anzeigen",
            semantics_title: "Tags",
            semantics_tags: "{nb] Tags",
            semantics_features: "Features im Bild",
            semantics_hide_all_tags: "Alle Tags verbergen",
            semantics_annotation_tooltip: "Klicke, um Details zu sehen",
            semantics_key: "Schl\xfcssel",
            semantics_value: "Wert",
            semantics_key_doc: "Mehr \xfcber diesen Schl\xfcssel erfahren",
            semantics_value_doc: "Mehr \xfcber dieses Tag erfahren",
            semantics_tags_picture: "Foto-Schlagworte",
            semantics_tags_picture_none: "Bislang wurden keine Schlagworte f\xfcr dieses Foto gesetzt.",
            semantics_show_annotations: "Features im Bild anzeigen",
            semantics_hide_annotations: "Features im Bild verbergen",
            semantics_wikidata_properties: {
                P31: "Instanz von",
                P279: "Unterklasse von",
                P361: "Teil von",
                P180: "zeigt"
            },
            metadata_exif_doc: "Dokumentation der EXIF-Tags",
            metadata_exif_doc_title: "Wechsle zur Exiv2-Dokumentation f\xfcr eine vollst\xe4ndige Beschreibung von EXIF- und XMP-Tags",
            metadata_location_coordinates: "Koordinaten (L\xe4ngengrad, Breitengrad)",
            metadata_location_copy: "Kopiere {v}",
            metadata_location_copy_more: "Mehr Optionen zum Kopieren der Koordinaten",
            whats_panoramax: "Panoramax ist eine Geo-Commons f\xfcr Gebietsfotos.",
            picture_360_long: "Panoramafoto",
            metadata_summary: "Zusammenfassung",
            filter_date_6months: "6 Monate",
            picture_all: "Alle",
            picture_flat_long: "Klassisches Foto",
            metadata_general_instance: "Quell-Instanz",
            geo_uri: "Externe App",
            contribute_id: "Zu OpenStreetMap mit dem iD Editor beitragen",
            metadata_general_copy_id: "ID kopieren",
            metadata_general_copy_picid: "Kopiere Foto-ID",
            semantics_qualifiers: "Qualifikatoren",
            panoramax: "Panoramax",
            semantics_zero_annotations: "In diesem Bild wurden keine Features markiert",
            semantics_hashtags: "Bild-Hashtags",
            semantics_editor_error: "Die Syntax ist ung\xfcltig. Deine Tags sollten so aussehen:\nSchl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel[Qualif_Schl\xfcssel=Qualif_Wert]=Wert\n\nDie maximale L\xe4nge eines Schl\xfcssels betr\xe4gt 256 Zeichen, die eines Wertes betr\xe4gt 2048 Zeichen.",
            semantics_cantsave_invalid: "\xc4nderungen k\xf6nnen nicht angewendet werden, Eingabe ist ung\xfcltig",
            semantics_editor_example: "Schl\xfcssel=Wert\nPr\xe4fix|Schl\xfcssel=Wert",
            semantics_edit: "Attribute bearbeiten",
            semantics_save: "\xc4nderungen speichern",
            semantics_undo: "Bearbeitung abbrechen",
            semantics_send_fail: "\xc4nderungen k\xf6nnen nicht angewendet werden. Bitte versuche es sp\xe4ter noch einmal",
            semantics_send_ok: "\xc4nderungen wurden erfolgreich hochgeladen",
            semantics_save_drawn_annotation: "Position speichern",
            semantics_undo_drawn_annotation: "Abbrechen",
            semantics_save_drawn_annotation_incomplete: "Sie m\xfcssen vor der Validierung ein Rechteck dass in das Foto passt zeichnen",
            semantics_delete_annotation: "Dieses Feature l\xf6schen",
            semantics_delete_annotation_confirm: "M\xf6chtest du dieses Tag wirklich l\xf6schen?",
            semantics_add_annotation: "Neues Tag hinzuf\xfcgen",
            semantics_draw_annotation: "Du kannst ein Objekt im Bild markieren, um es hinzuzuf\xfcgen (optional).",
            semantics_login_needed: "Um Tags oder Features in Fotos zu bearbeiten, ist es erforderlich, in der Panoramax-Instanz {n} angemeldet zu sein. M\xf6chtest du dich anmelden?",
            semantics_doc_title: "\xdcber Tags",
            semantics_erase_annotation: "Markiertes Feature entfernen",
            semantics_doc_info1: "Stelle mittels Tags mehr Kontext zu einem Bild bereit.",
            semantics_doc: "Hilfe",
            semantics_doc_info3: "Einige Objekte werden automatisch mittels KI erkannt: Eine gute Erkennungsrate kann nicht garantiert werden.",
            semantics_doc_link: "Erfahre mehr \xfcber Tags",
            semantics_doc_info2: "Du kannst auch Objekte im Bild markieren: Verkehrszeichen, Stadtmobiliar\u2026 Nutze bestehende Tags, um zu markieren, was du siehst. Du kannst au\xdferdem, falls erforderlich, neue Tags erstellen.",
            semantics_sequence_tags: "Sequenz-Tag",
            semantics_picture_tags: "Bild-Tag",
            semantics_annotation_tags: "Objekt-Tag",
            filter_gps_precision: "Standortgenauigkeit",
            filter_gps_precision_lessthan: "Weniger als {n} Meter",
            filter_gps_precision_between: "Zwischen {n1} und {n2} Metern",
            filter_gps_precision_morethan: "Mehr als {n} Meter",
            map_theme_gps: "GPS-Genauigkeit",
            semantics_overlays: {
                tfsigns: "Verkehrszeichen",
                features: "Alle Features"
            },
            semantics_doc_info1u1: "Mit dem Tag transport=car kannst du markieren, dass es mit Hilfe eines Autos aufgenommen wurde.",
            semantics_zoom_in: "Vergr\xf6\xdfere die Karte, um die Tags zu sehen",
            semantics_download: "Herunterladen",
            semantics_download_title: "Tags herunterladen",
            semantics_download_info: "Alle semantischen Daten (Tags) sind als offene Daten verf\xfcgbar. Du kannst sie herunterladen und nach Belieben nutzen.",
            semantics_download_cta: "Open Data herunterladen",
            semantics_copy: "Attribute kopieren",
            semantics_value_show_osm: "Auf OpenStreetMap ansehen",
            filter_gps_precision_help_1: "Zu jedem Bild gibt es einen Wert der Standortgenauigkeit. Dieser entspricht der GPS-Genauigkeit beim Fotografieren.",
            filter_gps_precision_help_2: "Die Genauigkeit wird mit Sternchen angezeigt:",
            filter_gps_precision_help: "Mehr \xfcber Standortgenauigkeit erfahren",
            filter_gps_precision_help_3: "\u201E5\u2B50\u201C ist sehr genau (<= {p5}m), \u201E1\u2B50\u201C ist sehr ungenau (> {p1}m) oder unbekannt.",
            filter_gps_precision_help_4: "Ein RTK-GPS kriegt eine Bewertung von \u201E5\u2B50\u201C, eine Actionkamera wie die GoPro Max eine Bewertung von \u201E3\u2B50\u201C und ein Smartphone-GPS in einer Tiefgarage eine Bewertung von \u201E1\u2B50\u201C.",
            qualityscore_doc_41: "die GPS-Genauigkeit",
            qualityscore_doc_42: "die Bildaufl\xf6sung",
            qualityscore_doc_5: "Ein Profi-Ger\xe4t kriegt die Note A, eine 360\xb0-Actionkamera die Note B und ein Smartphone eine Note zwischen C und E.",
            qualityscore_doc_4: "Dieser Score wird berechnet anhand von:",
            popup_details_link: "Mehr Details",
            indoor_selector_expand: "Klicken, um alle verf\xfcgbaren Level zu sehen",
            indoor_selector_levelup: "Zum h\xf6heren Level gehen",
            indoor_selector_leveldown: "Zum niedrigeren Level gehen",
            indoor_selector_scrollup: "Level-Liste nach oben scrollen",
            indoor_selector_scrolldown: "Level-Liste nach unten scrollen",
            indoor_selector_shrink: "Zum Minimieren klicken",
            indoor_switch: "Innenr\xe4ume",
            "visibility_logged-only": "Mitglieder",
            "visibility_title_logged-only": "Nur Personen mit einem Konto k\xf6nnen dieses Bild sehen",
            "visibility_owner-only": "Versteckt",
            "visibility_title_owner-only": "Nur du kannst dieses Bild sehen",
            filter_source_world: "Gesamte Welt",
            filter_source_local: "Dieser Server",
            filter_locked: "Filter deaktiviert",
            map_background_more: "Mehr",
            map_background_default: "Standard",
            semantics_draw_unfinished_annotation: "Der gezeichnete Bereich ist noch nicht fertig. Vergewissere dich vor dem Speichern, dass der Bereich richtig positioniert ist.",
            semantics_draw_invalid_annotation: "Der gezeichnete Bereich reicht \xfcber den Bildrand hinaus. Bitte achte darauf, innerhalb des sichtbaren Bildbereichs zu zeichnen.",
            error_pic_load: "Dieses Bild kann derzeit nicht geladen werden.\nBitte \xfcberpr\xfcfe deine Internetverbindung. Wenn du verbunden bist, vergewissere dich, dass die Bild-ID g\xfcltig ist.",
            low_contrast: "Bildkontrast verringern",
            reset_contrast: "Bildkontrast zur\xfccksetzen",
            delete_picture: "L\xf6schen",
            delete_picture_warn: "\u26A0\uFE0F Achtung: Dadurch wird dieses Bild endg\xfcltig gel\xf6scht.\nBist du sicher, dass du weitermachen m\xf6chtest?",
            delete_picture_ok: "Das Bild wurde erfolgreich gel\xf6scht",
            delete_picture_error: "Beim Versuch, das Bild zu l\xf6schen, ist ein Fehler aufgetreten:\n{e}",
            semantics_empty: "Es wurden keine Tags definiert",
            metadata_general_title: "Titel",
            time_travel: "Diesen Ort an anderen Daten anzeigen",
            time_travel_close: "Andere Daten verbergen",
            map_theme_default_short: "Standard",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Qualit\xe4t",
            map_theme_gps_short: "Position",
            widget_locked: "Option deaktiviert",
            map_theme_default_coef_short: "Abdeckung",
            map_theme_default_1: "Niedrig",
            map_theme_default_2: "Durchschnittlich",
            map_theme_default_3: "Gut",
            map_theme_default_4: "Hervorragend",
            map_theme_default_coef: "Abdeckungsgrad",
            sequence_play_backwards: "Sequenz abspielen, r\xfcckw\xe4rts",
            semantics_annotation_tooltip_close: "Zum Abw\xe4hlen klicken"
        },
        psv: {
            twoFingers: "Nutze zwei Finger zum Navigieren",
            ctrlZoom: "Nutze Strg + Scrollen, um das Bild zu vergr\xf6\xdfern",
            loadError: "Das Panorama konnte nicht geladen werden"
        },
        map: {
            thumbnail: "Vorschau des markierten Fotos",
            not_public: "Nicht \xf6ffentlich sichtbar",
            loading: "Laden\u2026",
            slow_loading: "Die Karte l\xe4dt nur langsam und kann fehlerhaft erscheinen",
            map_data: "Kartendaten: {m}",
            more_panoramax: "Mehr \xfcber Panoramax erfahren"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Meinen Standort finden",
            "GeolocateControl.LocationNotAvailable": "Standort nicht verf\xfcgbar"
        }
    },
    el: {
        pnx: {
            sequence_next: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            zoom: "\u0395\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7",
            zoomOut: "\u03A3\u03BC\u03AF\u03BA\u03C1\u03C5\u03BD\u03C3\u03B7",
            zoomIn: "\u039C\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7",
            moveLeft: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC",
            moveRight: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03B4\u03B5\u03BE\u03B9\u03AC",
            expand: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7",
            show_psv: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AD\u03B1 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03CE\u03BD",
            show_map: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C7\u03AC\u03C1\u03C4\u03B7",
            minimize_short: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7",
            options: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2",
            search: "\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7",
            search_empty: "\u0394\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1",
            search_user: "\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B7\u2026",
            share: "\u0394\u03B9\u03B1\u03BC\u03BF\u03B9\u03C1\u03B1\u03C3\u03BC\u03CC\u03C2",
            share_image: "HD \u0395\u03B9\u03BA\u03CC\u03BD\u03B1",
            share_rss: "RSS \u03C1\u03BF\u03AE",
            share_embed: "\u0395\u03BD\u03C3\u03C9\u03BC\u03AC\u03C4\u03C9\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03B9\u03C3\u03C4\u03CC\u03C4\u03BF\u03C0\u03CC \u03C3\u03B1\u03C2",
            share_print: "\u0395\u03BA\u03C4\u03CD\u03C0\u03C9\u03C3\u03B7",
            panoramax: "Panoramax",
            copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE",
            copied: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5",
            error: "\u0388\u03C7\u03BF\u03C5\u03BC\u03B5 \u03AD\u03BD\u03B1 \u03C0\u03C1\u03CC\u03B2\u03BB\u03B7\u03BC\u03B1\u2026",
            error_click: "\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1",
            error_retry: "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1",
            sequence_pause: "\u03A0\u03B1\u03CD\u03C3\u03B7 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            sequence_prev: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            sequence_more: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2",
            legend_license: "\u0386\u03B4\u03B5\u03B9\u03B1: {l}",
            legend_title: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03B5\u03C1\u03B5\u03B9\u03CE\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            id: "iD",
            sequence_play: "\u0391\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            geo_uri: "\u0395\u03BE\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03AE \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE",
            josm: "JOSM",
            report_wait: "\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C4\u03B7\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2\u2026",
            moveUp: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C0\u03AC\u03BD\u03C9",
            search_address: "\u0391\u03BD\u03B1\u03B6\u03B7\u03C4\u03AE\u03C3\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7, \u03C0\u03CC\u03BB\u03B7\u2026",
            share_links: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03B9",
            report_success: "\u0397 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03B5\u03C3\u03C4\u03AC\u03BB\u03B5\u03B9 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1. \u0398\u03B1 \u03B5\u03BB\u03B5\u03B3\u03C7\u03B5\u03AF \u03C4\u03BF \u03C3\u03C5\u03BD\u03C4\u03BF\u03BC\u03CC\u03C4\u03B5\u03C1\u03BF \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03BD.",
            moveDown: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03BA\u03AC\u03C4\u03C9",
            filters: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03B1",
            layers: "\u0395\u03C0\u03AF\u03C0\u03B5\u03B4\u03B1",
            share_page: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 \u03C0\u03C1\u03BF\u03C2 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            share_embed_docs: "\u0394\u03B9\u03B1\u03B2\u03AC\u03C3\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B4\u03B9\u03B1\u03BC\u03CC\u03C1\u03C6\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03B5\u03BD\u03C3\u03C9\u03BC\u03AC\u03C4\u03C9\u03C3\u03B7\u03C2",
            sequence_speed: "\u03A4\u03B1\u03C7\u03CD\u03C4\u03B7\u03C4\u03B1 \u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2",
            report_submit: "\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE",
            semantics_overlays: {
                features: "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1",
                tfsigns: "\u03A0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B5\u03C2 \u03C3\u03AE\u03BC\u03B1\u03BD\u03C3\u03B7\u03C2"
            },
            semantics_download: "\u039B\u03AE\u03C8\u03B7",
            semantics_download_title: "\u039B\u03AE\u03C8\u03B7 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_download_cta: "\u039B\u03AE\u03C8\u03B7 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03CE\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD",
            report_auth: '\u0391\u03C5\u03C4\u03AE \u03B7 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B8\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF\u03BD \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03C3\u03B1\u03C2 "{a}"',
            semantics_save: "\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2",
            report_details: "\u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            report_failure: "\u03A0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2: {e}. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1.",
            indoor_switch: "\u03A7\u03AC\u03C1\u03C4\u03B5\u03C2 \u03B5\u03C3\u03C9\u03C4\u03B5\u03C1\u03B9\u03BA\u03BF\u03CD \u03C7\u03CE\u03C1\u03BF\u03C5",
            report_email: "\u03A4\u03BF email \u03C3\u03B1\u03C2",
            report_email_placeholder: "\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC",
            indoor_selector_shrink: "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03B5\u03BB\u03B1\u03C7\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7",
            report: "\u0391\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC",
            "visibility_logged-only": "\u039C\u03AD\u03BB\u03B7",
            indoor_selector_levelup: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF \u03CC\u03C1\u03BF\u03C6\u03BF",
            indoor_selector_leveldown: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C7\u03B1\u03BC\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03BF \u03CC\u03C1\u03BF\u03C6\u03BF",
            "visibility_owner-only": "\u039A\u03C1\u03C5\u03BC\u03BC\u03AD\u03BD\u03B7",
            "visibility_title_owner-only": "\u039C\u03CC\u03BD\u03BF \u03B5\u03C3\u03B5\u03AF\u03C2 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1",
            report_details_placeholder: "\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03AC, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B3\u03B9' \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03B6\u03AE\u03C4\u03B7\u03BC\u03B1",
            "visibility_title_logged-only": "\u039C\u03CC\u03BD\u03BF \u03AC\u03C4\u03BF\u03BC\u03B1 \u03BC\u03B5 \u03BB\u03BF\u03B3\u03B1\u03C1\u03B9\u03B1\u03C3\u03BC\u03CC \u03BC\u03C0\u03BF\u03C1\u03BF\u03CD\u03BD \u03BD\u03B1 \u03B4\u03BF\u03C5\u03BD \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1",
            indoor_selector_expand: "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C5\u03C2 \u03BF\u03C1\u03CC\u03C6\u03BF\u03C5\u03C2",
            picture_flat: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03AE",
            metadata: "\u039C\u03B5\u03C4\u03B1\u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_location_copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE {v}",
            metadata_general_copy_picid: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE ID \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_features: "\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_delete_annotation: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B1\u03C5\u03C4\u03BF\u03CD \u03C4\u03BF\u03C5 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF\u03C5",
            metadata_general_seqid: "\u0391\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            map_theme_gps: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            filter_gps_precision_help: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            filter_picture: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_location_copy_more: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03B1\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03C3\u03C5\u03BD\u03C4\u03B5\u03C4\u03B1\u03B3\u03BC\u03AD\u03BD\u03C9\u03BD",
            semantics_show_all_tags: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_value_show_osm: "\u0394\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF OpenStreetMap",
            semantics_add_annotation: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03BD\u03AD\u03B1\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1\u03C2",
            semantics_wikidata_properties: {
                P279: "\u03C5\u03C0\u03BF\u03BA\u03BB\u03AC\u03C3\u03B7 \u03C4\u03BF\u03C5",
                P361: "\u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF \u03BC\u03AD\u03C1\u03BF\u03C2 \u03C4\u03BF\u03C5",
                P31: "\u03B5\u03AF\u03BD\u03B1\u03B9",
                P180: "\u03B1\u03BD\u03B1\u03C0\u03B1\u03C1\u03B9\u03C3\u03C4\u03AC"
            },
            semantics_delete_annotation_confirm: "\u03A3\u03AF\u03B3\u03BF\u03C5\u03C1\u03B1 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C8\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 ;",
            semantics_editor_error: "\u0397 \u03C3\u03CD\u03BD\u03C4\u03B1\u03BE\u03B7 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7. \u039F\u03B9 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03B1\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03BC\u03BF\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD \u03C9\u03C2:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\n\u03A4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03BC\u03AE\u03BA\u03BF\u03C2 \u03BA\u03BB\u03B5\u03B9\u03B4\u03B9\u03BF\u03CD \u03B5\u03AF\u03BD\u03B1\u03B9 256 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2, \u03C4\u03BF \u03BC\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF \u03BC\u03AE\u03BA\u03BF\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 2048 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.",
            semantics_undo: "\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2",
            semantics_send_fail: "\u0391\u03B4\u03CD\u03BD\u03B1\u03C4\u03B7 \u03B7 \u03B1\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C3\u03B1\u03C2, \u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03B1\u03C1\u03B3\u03CC\u03C4\u03B5\u03C1\u03B1",
            report_nature: {
                picture_low_quality: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C7\u03B1\u03BC\u03B7\u03BB\u03AE\u03C2 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
                "": "\u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C6\u03CD\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2\u2026",
                blur_missing: "\u03A4\u03BF \u03C0\u03C1\u03CC\u03C3\u03C9\u03C0\u03BF \u03B5\u03BD\u03CC\u03C2 \u03B1\u03C4\u03CC\u03BC\u03BF\u03C5 \u03AE \u03B7 \u03C0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B1 \u03BA\u03C5\u03BA\u03BB\u03BF\u03C6\u03BF\u03C1\u03AF\u03B1\u03C2 \u03B5\u03BD\u03CC\u03C2 \u03BF\u03C7\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03C1\u03B1\u03C4\u03AC",
                privacy: "\u0388\u03BD\u03B1 \u03B9\u03B4\u03B9\u03C9\u03C4\u03B9\u03BA\u03CC \u03BC\u03BF\u03BD\u03BF\u03C0\u03AC\u03C4\u03B9 \u03AE \u03B9\u03B4\u03B9\u03BF\u03BA\u03C4\u03B7\u03C3\u03AF\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03C1\u03B1\u03C4\u03AC",
                mislocated: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C7\u03AC\u03BB\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                copyright: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B2\u03B9\u03AC\u03B6\u03B5\u03B9 \u03C0\u03BD\u03B5\u03C5\u03BC\u03B1\u03C4\u03B9\u03BA\u03AC \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1",
                other: "\u039F\u03C0\u03BF\u03B9\u03BF\u03B4\u03AE\u03C0\u03BF\u03C4\u03B5 \u03AC\u03BB\u03BB\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2",
                blur_excess: "\u0388\u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03C4\u03C4\u03CC \u03B8\u03CC\u03BB\u03C9\u03BC\u03B1 \u03B5\u03C6\u03B1\u03C1\u03BC\u03CC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF",
                inappropriate: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03BA\u03B1\u03C4\u03AC\u03BB\u03BB\u03B7\u03BB\u03B7 (\u03AC\u03C3\u03C7\u03B5\u03C4\u03B7, \u03B3\u03CD\u03BC\u03BD\u03B9\u03B1\u2026)"
            },
            filter_source_world: "\u038C\u03BB\u03BF\u03C2 \u03BF \u03BA\u03CC\u03C3\u03BC\u03BF\u03C2",
            filter_source_local: "\u0391\u03C5\u03C4\u03CC\u03C2 \u03BF \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2",
            filter_date: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1",
            filter_date_1month: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
            filter_date_6months: "6 \u03BC\u03AE\u03BD\u03B5\u03C2",
            filter_date_1year: "1 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
            picture_360: "360\xb0",
            picture_flat_long: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03AE \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            filter_user: "\u03A7\u03C1\u03AE\u03C3\u03C4\u03B7\u03C2",
            filter_user_mypics: "\u039F\u03B9 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B5\u03C2 \u03BC\u03BF\u03C5",
            filter_locked: "\u03A6\u03AF\u03BB\u03C4\u03C1\u03BF \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03B7\u03BC\u03AD\u03BD\u03BF",
            filter_zoom_in: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BC\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BE\u03B5\u03BA\u03BB\u03B5\u03AF\u03B4\u03C9\u03BC\u03B1",
            picture_all: "\u038C\u03BB\u03B5\u03C2",
            filter_gps_precision: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2",
            picture_360_long: "\u03A0\u03B1\u03BD\u03BF\u03C1\u03B1\u03BC\u03B9\u03BA\u03AE \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            popup_details_link: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            filter_qualityscore_help: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03AE \u03B1\u03C0\u03B5\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7",
            filter_gps_precision_lessthan: "\u039B\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {n} \u03BC\u03AD\u03C4\u03C1\u03B1",
            filter_gps_precision_between: "\u039C\u03B5\u03C4\u03B1\u03BE\u03CD {n1} \u03BA\u03B1\u03B9 {n2} \u03BC\u03AD\u03C4\u03C1\u03C9\u03BD",
            filter_gps_precision_morethan: "\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {n} \u03BC\u03AD\u03C4\u03C1\u03B1",
            map_background_default: "\u03A0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE",
            filter_gps_precision_help_2: "\u0397 \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03B5\u03BA\u03C6\u03C1\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BC\u03B5 \u03B1\u03C3\u03C4\u03AD\u03C1\u03B9\u03B1:",
            map_background_streets: "\u0394\u03C1\u03CC\u03BC\u03BF\u03B9",
            map_theme_age: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03C8\u03B7\u03C2",
            map_theme: "\u0398\u03AD\u03BC\u03B1 \u03C7\u03AC\u03C1\u03C4\u03B7",
            map_theme_default: "\u039A\u03BB\u03B1\u03C3\u03C3\u03B9\u03BA\u03CC",
            map_theme_age_1: "> 3 \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1",
            map_theme_age_2: "< 3 \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1",
            map_theme_age_3: "< 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
            map_theme_age_4: "< 6 \u03BC\u03AE\u03BD\u03B1",
            map_theme_type: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1\u03C2",
            metadata_general_date: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03C8\u03B7\u03C2",
            metadata_summary: "\u03A3\u03CD\u03BD\u03BF\u03C8\u03B7",
            metadata_general_copy_id: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE ID",
            metadata_general_picid: "\u0395\u03B9\u03BA\u03CC\u03BD\u03B1",
            metadata_general_author: "\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03CC\u03C2",
            metadata_general_license: "\u0386\u03B4\u03B5\u03B9\u03B1",
            metadata_general_license_link: "\u0394\u03B5\u03AF\u03C4\u03B5 \u03C4\u03B7\u03BD \u03C0\u03BB\u03AE\u03C1\u03B7 \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03AC\u03B4\u03B5\u03B9\u03B1\u03C2",
            metadata_general_instance: "\u0391\u03C1\u03C7\u03B9\u03BA\u03CC\u03C2 \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2",
            metadata_camera: "\u039A\u03AC\u03BC\u03B5\u03C1\u03B1",
            metadata_camera_model: "\u039C\u03BF\u03BD\u03C4\u03AD\u03BB\u03BF",
            metadata_camera_type: "\u03A4\u03CD\u03C0\u03BF\u03C2",
            metadata_camera_resolution: "\u0391\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7",
            metadata_location: "\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1",
            metadata_location_coordinates: "\u03A3\u03C5\u03BD\u03C4\u03B5\u03C4\u03B1\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 (\u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03BC\u03AE\u03BA\u03BF\u03C2, \u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C0\u03BB\u03AC\u03C4\u03BF\u03C2)",
            metadata_location_orientation: "\u039A\u03B1\u03C4\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7",
            metadata_location_precision: "\u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2",
            metadata_quality: "\u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1",
            metadata_exif_value: "\u03A4\u03B9\u03BC\u03AE",
            metadata_exif_doc: "\u03A4\u03B5\u03BA\u03BC\u03B7\u03C1\u03AF\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 EXIF",
            semantics_title: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_tags: "{nb} \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_features_none: "\u039A\u03B1\u03BD\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B1\u03BA\u03CC\u03BC\u03B7.",
            semantics_features_default_title: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 {nb}",
            semantics_hide_all_tags: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD",
            semantics_key: "\u039A\u03BB\u03B5\u03B9\u03B4\u03AF",
            semantics_value: "\u03A4\u03B9\u03BC\u03AE",
            semantics_sequence_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            semantics_picture_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_annotation_tags: "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
            semantics_doc: "\u0392\u03BF\u03AE\u03B8\u03B5\u03B9\u03B1",
            semantics_erase_annotation: "\u03A3\u03B2\u03AE\u03C3\u03B9\u03BC\u03BF \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF\u03C5",
            share_rss_title: "\u0397 RSS \u03C1\u03BF\u03AE \u03C4\u03C9\u03BD \u03BD\u03AD\u03C9\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03B9\u03CE\u03BD \u03C3\u03C4\u03B7\u03BD \u03C4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u03BF\u03C1\u03B1\u03C4\u03AE \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03C4\u03BF\u03C5 \u03C7\u03AC\u03C1\u03C4\u03B7",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                "\uD83D\uDDA5\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B5\u03C1\u03CE\u03C4\u03B7\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C2 \u03C4\u03BF API",
                "\uD83D\uDDBC\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BC\u03B9\u03BA\u03C1\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03CE\u03BD",
                "\uD83D\uDD0D \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7 \u03C4\u03C9\u03BD \u03BC\u03B5\u03C4\u03B1\u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD EXIF",
                "\uD83C\uDFD8\uFE0F \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 3D \u03B1\u03C0\u03B5\u03B9\u03BA\u03CC\u03BD\u03B9\u03C3\u03B7",
                "\uD83D\uDCF7 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C1\u03C7\u03B9\u03BA\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C4\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD 360\xb0",
                "\uD83D\uDFE0 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B9\u03C3\u03BF\u03C1\u03C1\u03CC\u03C0\u03B7\u03C3\u03B7 \u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD",
                "\uD83D\uDCAF \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C4\u03BF\u03C5 \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \xa9",
                "\uD83D\uDCE1 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BB\u03AE\u03C8\u03B7 \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03C3\u03B5\u03C9\u03BD",
                "\uD83C\uDF0D \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BB\u03AE\u03C8\u03B7 \u03C0\u03BB\u03B1\u03BA\u03B9\u03B4\u03AF\u03C9\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7",
                "\uD83D\uDCF8 \u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C3\u03BA\u03B9\u03CE\u03BD"
            ],
            josm_live: "\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03BF \u03C3\u03C5\u03B3\u03C7\u03C1\u03BF\u03BD\u03B9\u03C3\u03BC\u03CC \u03C4\u03BF\u03C5 JOSM \u03C3\u03C4\u03BF \u03C6\u03CC\u03C1\u03C4\u03C9\u03BC\u03B1 \u03C4\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD",
            metadata_exif_doc_title: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03C4\u03B5\u03BA\u03BC\u03B7\u03C1\u03AF\u03C9\u03C3\u03B7 \u03C4\u03BF\u03C5 Exiv2 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03C0\u03BB\u03AE\u03C1\u03B5\u03B9\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03BF\u03C1\u03B9\u03C3\u03BC\u03BF\u03CD\u03C2 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD EXIF \u03BA\u03B1\u03B9 XMP",
            semantics_doc_info1u1: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BB\u03CE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C4\u03C1\u03B1\u03B2\u03AE\u03C7\u03C4\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC \u03B1\u03C5\u03C4\u03BF\u03BA\u03AF\u03BD\u03B7\u03C4\u03BF \u03BC\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 transport=car.",
            error_pic_load: "\u0397 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03C9\u03B8\u03B5\u03AF \u03C4\u03CE\u03C1\u03B1.\n\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03BF\u03CD\u03BC\u03B5 \u03B5\u03BB\u03AD\u03B3\u03BE\u03C4\u03B5 \u03C4\u03B7 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03B1\u03C2 \u03C3\u03C4\u03BF \u0394\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF. \u0395\u03AC\u03BD \u03B5\u03AF\u03C3\u03C4\u03B5 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF\u03B9, \u03B2\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C4\u03BF ID \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AD\u03B3\u03BA\u03C5\u03C1\u03BF.",
            qualityscore_doc_link: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            semantics_show_annotations: "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_hide_annotations: "\u0391\u03C0\u03CC\u03BA\u03C1\u03C5\u03C8\u03B7 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_zero_annotations: "\u039A\u03B1\u03BD\u03AD\u03BD\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            semantics_zoom_in: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BC\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C3\u03C4\u03BF\u03BD \u03C7\u03AC\u03C1\u03C4\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            report_nature_label: "\u0391\u03B9\u03C4\u03AF\u03B1 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BB\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2",
            report_whole_sequence: "\u0391\u03C5\u03C4\u03CC \u03B1\u03C6\u03BF\u03C1\u03AC \u03BF\u03BB\u03CC\u03BA\u03BB\u03B7\u03C1\u03B7 \u03C4\u03B7\u03BD \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1",
            semantics_copy: "\u0391\u03BD\u03C4\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03B7\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD",
            semantics_edit: "\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03B7\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CE\u03BD",
            semantics_login_needed: "\u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03AC\u03BD\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03B5\u03C4\u03B9\u03BA\u03B5\u03C4\u03CE\u03BD \u03AE \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03C9\u03BD \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03C3\u03C4\u03BF\u03BD \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE {n} \u03C4\u03BF\u03C5 Panoramax. \u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 ;",
            moveMiddle: "\u039A\u03B5\u03BD\u03C4\u03C1\u03AC\u03C1\u03B9\u03C3\u03BC\u03B1 \u03B8\u03AD\u03B1\u03C3\u03B7\u03C2",
            expand_info: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03C4\u03BF \u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03BD\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03C3\u03C4\u03B5\u03AF \u03C3\u03B5 \u03C0\u03BB\u03AE\u03C1\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1",
            minimize: "\u039A\u03C1\u03CD\u03C8\u03C4\u03B5 \u03C4\u03BF \u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF, \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03BF \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03C3\u03B5\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \u03C3\u03C4\u03B7\u03BD \u03BA\u03AC\u03C4\u03C9 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AE \u03B3\u03C9\u03BD\u03AF\u03B1",
            contribute_id: "\u03A3\u03C5\u03BD\u03B5\u03B9\u03C3\u03C6\u03AD\u03C1\u03B5\u03C4\u03B5 \u03C3\u03C4\u03BF OpenStreetMap \u03BC\u03B5 \u03C4\u03BF\u03BD \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03C4\u03AE iD",
            error_psv: "\u03A4\u03BF Photo Sphere Viewer \u03B4\u03B5\u03BD \u03C6\u03BF\u03C1\u03C4\u03CE\u03BD\u03B5\u03B9 \u03C3\u03C9\u03C3\u03C4\u03AC",
            error_api: "\u039F \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03C2",
            error_api_compatibility: "\u039F \u03B4\u03B9\u03B1\u03BA\u03BF\u03BC\u03B9\u03C3\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03C9\u03BD \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03CC\u03C2 \u03BC\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03C0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AD\u03B1",
            error_pic: "\u0397 \u03B6\u03B7\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B5",
            error_nopic: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C3\u03C4\u03B7 \u03B4\u03BF\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1",
            error_webgl: "\u03A4\u03BF WebGL \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C0\u03B5\u03C1\u03B9\u03B7\u03B3\u03B7\u03C4\u03AE \u03C3\u03B1\u03C2",
            error_josm: "\u03A4\u03BF JOSM \u03B4\u03B5\u03BD \u03B1\u03BD\u03C4\u03B1\u03C0\u03BF\u03BA\u03C1\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9, \u03C3\u03AF\u03B3\u03BF\u03C5\u03C1\u03B1 \u03B5\u03BA\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BA\u03B1\u03B9 \u03B5\u03BB\u03AD\u03B3\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03BF\u03BC\u03B1\u03BA\u03C1\u03C5\u03C3\u03BC\u03AD\u03BD\u03B1;",
            qualityscore_doc_3: '"A" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B7 \u03BA\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03B7 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1, "E" \u03B7 \u03C7\u03B5\u03B9\u03C1\u03CC\u03C4\u03B5\u03C1\u03B7.',
            filter_qualityscore: "\u03A3\u03BA\u03BF\u03C1 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            qualityscore_doc_2: "\u03A4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C9\u03C2 \u03AD\u03BD\u03B1 \u03B3\u03C1\u03AC\u03BC\u03BC\u03B1:",
            qualityscore_doc_1: "\u0388\u03BD\u03B1 \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1.",
            qualityscore_doc_4: "\u03A4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03B2\u03AC\u03C3\u03B5\u03B9:",
            qualityscore_doc_41: "\u03C4\u03B7\u03C2 \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1\u03C2 \u03C4\u03BF\u03C5 GPS",
            qualityscore_doc_42: "\u03C4\u03B7\u03C2 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            map_theme_score: "\u03A3\u03BA\u03BF\u03C1 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            metadata_general_picid_link: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD JSON \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            metadata_general_seqid_link: "\u039C\u03B5\u03C4\u03AC\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD JSON \u03C0\u03B5\u03C1\u03B9\u03B3\u03C1\u03B1\u03C6\u03AE \u03C4\u03B7\u03C2 \u03B1\u03BA\u03BF\u03BB\u03BF\u03C5\u03B8\u03AF\u03B1\u03C2",
            metadata_camera_focal_length: "\u0395\u03C3\u03C4\u03B9\u03B1\u03BA\u03AE \u03B1\u03C0\u03CC\u03C3\u03C4\u03B1\u03C3\u03B7",
            metadata_quality_missing: "\u03B4\u03B5\u03BD \u03BF\u03C1\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5 \u03C4\u03B9\u03BC\u03AE \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1",
            metadata_quality_help: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF \u03A3\u03BA\u03BF\u03C1 \u03A0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
            metadata_quality_score: "\u03A0\u03B1\u03B3\u03BA\u03CC\u03C3\u03BC\u03B9\u03BF \u03C3\u03BA\u03BF\u03C1",
            metadata_quality_gps_score: "\u03A3\u03BA\u03BF\u03C1 \u03C4\u03BF\u03C0\u03BF\u03B8\u03AD\u03C4\u03B7\u03C3\u03B7\u03C2",
            metadata_quality_resolution_score: "\u03A3\u03BA\u03BF\u03C1 \u03B1\u03BD\u03AC\u03BB\u03C5\u03C3\u03B7\u03C2",
            semantics_annotation_tooltip: "\u039A\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B4\u03B5\u03AF\u03C4\u03B5 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2",
            semantics_features_subtitle: "{nb} \u03C3\u03C5\u03C3\u03C7\u03B5\u03C4\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03B9\u03B4\u03B9\u03CC\u03C4\u03B7\u03C4\u03B5\u03C2",
            semantics_doc_info1: "\u0394\u03CE\u03C3\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03CC\u03BC\u03B5\u03BD\u03BF \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2.",
            semantics_doc_link: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
            semantics_key_doc: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03BA\u03BB\u03B5\u03B9\u03B4\u03AF",
            semantics_value_doc: "\u039C\u03AC\u03B8\u03B5\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1",
            semantics_qualifiers: "\u03A0\u03C1\u03BF\u03C3\u03B4\u03B9\u03BF\u03C1\u03B9\u03C3\u03C4\u03AD\u03C2",
            indoor_selector_scrollup: "\u03A3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BF\u03C1\u03CC\u03C6\u03C9\u03BD \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03C0\u03AC\u03BD\u03C9",
            indoor_selector_scrolldown: "\u03A3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1 \u03BF\u03C1\u03CC\u03C6\u03C9\u03BD \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03BA\u03AC\u03C4\u03C9",
            semantics_draw_invalid_annotation: "\u0397 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B2\u03B3\u03B1\u03AF\u03BD\u03B5\u03B9 \u03B5\u03BA\u03C4\u03CC\u03C2 \u03BF\u03C1\u03AF\u03C9\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2. \u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03B6\u03B5\u03C4\u03B5 \u03B5\u03BD\u03C4\u03CC\u03C2 \u03C4\u03B7\u03C2 \u03BF\u03C1\u03B1\u03C4\u03AE\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2.",
            qualityscore_doc_5: "\u039C\u03B9\u03B1 \u03B5\u03C0\u03B1\u03B3\u03B3\u03B5\u03BB\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 A, \u03BC\u03B9\u03B1 360\xb0 action camera \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 B, \u03BA\u03B1\u03B9 \u03AD\u03BD\u03B1 smartphone \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD C \u03BA\u03B1\u03B9 E.",
            map_background_aerial: "\u0395\u03BD\u03B1\u03AD\u03C1\u03B9\u03BF",
            map_background_more: "\u0386\u03BB\u03BB\u03B1 \u03C5\u03C0\u03CC\u03B2\u03B1\u03B8\u03C1\u03B1...",
            semantics_draw_unfinished_annotation: "\u0397 \u03C3\u03C7\u03B5\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03C9\u03BC\u03AD\u03BD\u03B7. \u0392\u03B5\u03B2\u03B1\u03B9\u03C9\u03B8\u03B5\u03AF\u03C4\u03B5 \u03CC\u03C4\u03B9 \u03B7 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03BB\u03AC \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C4\u03B7\u03BC\u03AD\u03BD\u03B7 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03BF\u03B8\u03B7\u03BA\u03B5\u03CD\u03C3\u03B5\u03C4\u03B5.",
            semantics_download_info: "\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03B7\u03BC\u03B1\u03C3\u03B9\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AC \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 (\u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2) \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C9\u03C2 \u03B1\u03BD\u03BF\u03B9\u03C7\u03C4\u03AC \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03C4\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03C4\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03C0\u03C9\u03C2 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5.",
            filter_gps_precision_help_4: '\u0388\u03BD\u03B1 RTK GPS \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "5\u2B50", \u03BC\u03B9\u03B1 action camera \u03CC\u03C0\u03C9\u03C2 \u03B7 GoPro Max \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "3\u2B50", \u03BA\u03B1\u03B9 \u03C4\u03BF GPS \u03B5\u03BD\u03CC\u03C2 smartphone \u03C3\u03B5 \u03C5\u03C0\u03CC\u03B3\u03B5\u03B9\u03BF \u03C0\u03AC\u03C1\u03BA\u03B9\u03BD\u03B3\u03BA \u03B8\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03B2\u03B1\u03B8\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1 "1\u2B50".',
            filter_gps_precision_help_1: "\u039C\u03B9\u03B1 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B1 \u0391\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1\u03C2 \u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1\u03C2 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7 \u03B3\u03B9\u03B1 \u03BA\u03AC\u03B8\u03B5 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1. \u0391\u03C5\u03C4\u03AE \u03B1\u03BD\u03C4\u03B9\u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF \u03C3\u03C4\u03B7\u03BD \u03B1\u03BA\u03C1\u03AF\u03B2\u03B5\u03B9\u03B1 \u03C4\u03BF\u03C5 GPS \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7 \u03BB\u03AE\u03C8\u03B7 \u03C4\u03B7\u03C2 \u03C6\u03C9\u03C4\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1\u03C2.",
            map_background: "\u03A5\u03C0\u03CC\u03B2\u03B1\u03B8\u03C1\u03BF \u03C7\u03AC\u03C1\u03C4\u03B7",
            filter_gps_precision_help_3: '"5\u2B50" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C0\u03BF\u03BB\u03CD \u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 (<= {p5}m), "1\u2B50" \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C1\u03BA\u03B5\u03C4\u03AC \u03B1\u03BD\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 (> {p1}m) \u03AE \u03AC\u03B3\u03BD\u03C9\u03C3\u03C4\u03B7.',
            contrast: "\u0395\u03BD\u03B5\u03C1\u03B3\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C5\u03C8\u03B7\u03BB\u03CC\u03C4\u03B5\u03C1\u03B7\u03C2 \u03B1\u03BD\u03C4\u03AF\u03B8\u03B5\u03C3\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            semantics_doc_info3: "\u039C\u03B5\u03C1\u03B9\u03BA\u03AC \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B1 \u03B5\u03BD\u03C4\u03BF\u03C0\u03AF\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03B1\u03C5\u03C4\u03CC\u03BC\u03B1\u03C4\u03B1 \u03BC\u03B5 AI: \u03B7 \u03C0\u03BF\u03B9\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03B3\u03B3\u03C5\u03B7\u03BC\u03AD\u03BD\u03B7.",
            semantics_doc_info2: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03B5\u03C0\u03AF\u03C3\u03B7\u03C2 \u03BD\u03B1 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03B5\u03C4\u03B5 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03B1 \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1: \u03C0\u03B9\u03BD\u03B1\u03BA\u03AF\u03B4\u03B5\u03C2 \u03C3\u03AE\u03BC\u03B1\u03BD\u03C3\u03B7\u03C2, \u03B1\u03C3\u03C4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2\u2026 \u03A3\u03B7\u03BC\u03AC\u03BD\u03B5\u03C4\u03B5 \u03C4\u03B9 \u03B2\u03BB\u03AD\u03C0\u03B5\u03C4\u03B5 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03C3\u03B5\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2. \u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B4\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03BA\u03B1\u03B9 \u03C4\u03B9\u03C2 \u03B4\u03B9\u03BA\u03AD\u03C2 \u03C3\u03B1\u03C2 \u03B5\u03AC\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C1\u03B1\u03AF\u03C4\u03B7\u03C4\u03BF.",
            semantics_draw_annotation: "\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03C0\u03BF\u03C5 \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03B5\u03C4\u03B5 \u03C0\u03AC\u03BD\u03C9 \u03C3\u03C4\u03B7\u03BD \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1 (\u03A0\u03C1\u03BF\u03B1\u03B9\u03C1\u03B5\u03C4\u03B9\u03BA\u03CC)."
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "\u03A4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03BC\u03B7 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B7",
            "GeolocateControl.FindMyLocation": "\u0392\u03C1\u03B5\u03C2 \u03C4\u03B7\u03BD \u03C4\u03BF\u03C0\u03BF\u03B8\u03B5\u03C3\u03AF\u03B1 \u03BC\u03BF\u03C5"
        },
        map: {
            loading: "\u0393\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u2026",
            more_panoramax: "\u0391\u03BD\u03B1\u03BA\u03B1\u03BB\u03CD\u03C8\u03C4\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03BF Panoramax",
            map_data: "\u03A7\u03AC\u03C1\u03C4\u03B7\u03C2 \u03B2\u03B1\u03C3\u03B9\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2 \u03C3\u03C4\u03BF {m}",
            thumbnail: "\u039C\u03B9\u03BA\u03C1\u03BF\u03B3\u03C1\u03B1\u03C6\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B4\u03B5\u03B9\u03BA\u03C4\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            slow_loading: "\u039F \u03C7\u03AC\u03C1\u03C4\u03B7\u03C2 \u03B1\u03C1\u03B3\u03B5\u03AF \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03CE\u03C3\u03B5\u03B9 \u03BA\u03B1\u03B9 \u03C0\u03B9\u03B8\u03B1\u03BD\u03CC\u03BD \u03BD\u03B1 \u03B5\u03BC\u03C6\u03B1\u03BD\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9 \u03C7\u03B1\u03BB\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF\u03C2",
            not_public: "\u038C\u03C7\u03B9 \u03B4\u03B7\u03BC\u03CC\u03C3\u03B9\u03B1 \u03BF\u03C1\u03B1\u03C4\u03AE"
        },
        psv: {
            twoFingers: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 \u03B4\u03CD\u03BF \u03B4\u03AC\u03C7\u03C4\u03C5\u03BB\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03BB\u03BF\u03B7\u03B3\u03B7\u03B8\u03B5\u03AF\u03C4\u03B5",
            ctrlZoom: "\u03A7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03C4\u03B5 Ctrl + \u03C3\u03BA\u03C1\u03BF\u03BB\u03AC\u03C1\u03B9\u03C3\u03BC\u03B1 \u03B3\u03B9\u03B1 \u03B6\u03BF\u03C5\u03BC \u03C4\u03B7\u03C2 \u03B5\u03B9\u03BA\u03CC\u03BD\u03B1\u03C2",
            loadError: "\u03A4\u03BF \u03C0\u03B1\u03BD\u03CC\u03C1\u03B1\u03BC\u03B1 \u03B4\u03B5\u03BD \u03BC\u03C0\u03CC\u03C1\u03B5\u03C3\u03B5 \u03BD\u03B1 \u03C6\u03BF\u03C1\u03C4\u03C9\u03B8\u03B5\u03AF"
        }
    },
    eo: {
        psv: {
            twoFingers: "Uzu du fingrojn por navigi",
            ctrlZoom: "Uzu ctrl + rulumo por zomi la bildon",
            loadError: "La bildo ne povas esti \u015Dar\u011Dita"
        },
        pnx: {
            zoom: "Zomo",
            zoomOut: "Malzomo",
            zoomIn: "Zomi",
            moveUp: "Movi supren",
            moveDown: "Movi malsupren",
            moveLeft: "Movi maldekstren",
            moveRight: "Movi dekstren",
            moveMiddle: "Centri vido",
            expand: "Pligrandigi",
            expand_info: "Aperigu la fenestra\u0135on en plena pa\u011Do",
            show_psv: "Montri la bildspektilo",
            show_map: "Montri la mapo",
            minimize: "Maski la fenestra\u0135o, vu povas montri \u011Din denove kun la butono en malsupra maldekstra angulo",
            sequence_prev: "Anta\u016Da foto en la sekvenco",
            sequence_more: "Pli da ludopcioj",
            sequence_speed: "Rapideco de legado",
            sequence_next: "Sekva foto en la sekvenco",
            sequence_play: "Foliumi \u0109i tiun sinsekvon",
            sequence_pause: "Pa\u016Dzi la sekvenco",
            copy: "Kopii",
            copied: "Kopiita",
            error: "Ni havas problemon\u2026",
            error_click: "Kontinui",
            error_retry: "Bonvolu reprovi poste",
            search_address: "Ser\u0109i adreson, urbon\u2026",
            filters: "Filtriloj",
            layers: "Tavoloj",
            search: "Ser\u0109i",
            share_embed_docs: "Pli pri enigito sur via retpa\u011Daro",
            search_empty: "Neniu rezulto trovita",
            search_user: "Ser\u0109i uzantnomon\u2026",
            share: "Kunhavigi",
            share_links: "Ligiloj",
            share_page: "Ligilo de la foto",
            share_image: "HD bildo",
            share_rss: "RSS abonfluo",
            share_rss_title: "RSS abonfluo de la novaj sekvecoj en la nuntempe videbla mapzono",
            share_embed: "Enigita en via retpa\u011Daro",
            share_print: "Presi",
            edit_osm: "Modifi OSM",
            legend_license: "Rajtigilo : {l}",
            josm_live: "Ebligas a\u016Dtomatan JOSM-sinkronigon dum \u015Dar\u011Do de bildo",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u015Cargo de la bazmapon",
                "\uD83D\uDDA5\uFE0F API demandado",
                "\uD83D\uDDBC\uFE0F \u015Car\u011Do de miniaturoj",
                "\uD83D\uDD0D Analizo de EXIF-metadatumoj",
                "\uD83C\uDFD8\uFE0F 3D-rendumo",
                "\uD83D\uDCF7 Inico de 360\xb0-bildoj",
                "\uD83D\uDFE0 Kolora ekvilibrigo",
                "\uD83D\uDCAF Kalkulo de kvalitpoentaro \xa9",
                "\uD83D\uDCE1 El\u015Dutante \u011Disdatoj",
                "\uD83C\uDF0D Reakirante mapkaheloj",
                "\uD83D\uDCF8 Traktadante ombroj"
            ],
            legend_title: "Montri la detaloj de la bildo",
            error_api: "La bildservilo ne estas disponebla",
            error_josm: "JOSM ne respondis. \u0108u \u011Di funkcias kaj la regilo estas \u015Daltita?",
            error_webgl: "WebGL ne estas subtenata per via retumilo",
            loading_labels_fun: [
                "\uD83E\uDD8C Detekto de cervinaj vojmontriloj",
                "\uD83D\uDE98 Ser\u0109o de Panoramax-a\u016Dto \xa9",
                "\u2615 Injekto de kafeino",
                "\uD83D\uDE00 Ridetu, vi estas mapita!",
                "\uD83D\uDC08 Kunhavigo de katbildoj",
                "\uD83D\uDE34 Redukto de prokrastado",
                "\uD83D\uDCD6 Lernado de Esperanto",
                "\uD83D\uDC27 Malfermo de fontkodo",
                "\uD83D\uDE87 Indekso de subteraj stacioj",
                "\uD83E\uDDF9 Purigo de metadatumoj",
                "\uD83D\uDE92 Sendado de fotoj de fajrostacioj",
                "\uD83D\uDEB2 \u011Cisdatigo de verdaj vojoj",
                "\uD83D\uDE89 Promenado tra stacioplatformoj",
                "\uD83D\uDEF0\uFE0F Ser\u0109o de satelitoj",
                "\uD83D\uDC65 Verkado de roluloj",
                "\u2747\uFE0F Lokalizo de la Esperanto-flagoj",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Sencimigado de la interfaco",
                "\uD83D\uDCC8 Alkrementi de la statistikoj",
                "\uD83E\uDD16 Lernadante semantiko",
                "\uD83C\uDFA8 Interfaca redezajno",
                "\uD83D\uDCC5 Planante fota-mapa-festoj",
                "\uD83E\uDDC0 Finmaturigo de la froma\u011Doj",
                "\uD83C\uDF04 Kalkulante la sunbrilon de la Saharo",
                "\uD83C\uDF0A Mezurado de la altaj tajdoj"
            ],
            picture_360: "360\xb0",
            picture_flat: "Klasika",
            report_nature_label: "Speco de problemo",
            report_nature: {
                "": "Elektu la specon de problemo\u2026",
                blur_missing: "Viza\u011Do a\u016D numerplato estas videbla",
                copyright: "La bildo malobeas kopirajton",
                blur_excess: "Objekto kiu ne bezonis malklari\u011Don estas malklarigita",
                inappropriate: "La bildo estas neta\u016Dga (nevera, nudeco...)",
                privacy: "Privata vojo a\u016D poseda\u0135o estas videbla",
                picture_low_quality: "La bildo estas de tre malbona kvalito",
                mislocated: "La bildo estas malbone poziciigita sur la mapo",
                other: "\u0108ia alia speco de problemo"
            },
            report: "Raporti",
            report_auth: '\u0108i tiu raporto estos sendita per via konto "{a}"',
            filter_date: "Dato",
            filter_user_mypics: "Miaj fotoj",
            options: "Opcioj",
            error_api_compatibility: "La fotoservilo ne kongruas kun \u0109i tiu spektilo",
            filter_qualityscore: "Kvalitpoentaro",
            filter_qualityscore_help: "Alllaku por aktivigi a\u016D mal\u015Dalti",
            map_theme_age: "Dato de fotado",
            map_theme_age_1: "> 3 jaroj",
            map_theme_age_2: "< 3 jaroj",
            map_theme_age_3: "< 1 jaro",
            map_theme_age_4: "< 6 monato",
            map_theme_score: "Kvalitpoentaro",
            metadata: "Metadatenoj de la bildo",
            map_theme_type: "Fotiltipo",
            metadata_general_seqid: "Sekvenco",
            metadata_camera_resolution: "Difino",
            metadata_quality_resolution_score: "Rezolucia poentaro",
            error_psv: "Foto-Sfera Spektilo ne \u015Dar\u011Di\u011Das \u011Duste",
            error_pic: "La petita bildo ne estis trovita",
            error_nopic: "Neniu bildo disponeblas \u0109e la donita pozicio",
            filter_user: "Uzanto",
            map_theme_default: "Klasika",
            filter_date_1month: "1 monato",
            filter_date_1year: "1 jaro",
            contrast: "Pliigi bildkontraston",
            metadata_general_picid: "Foto",
            filter_picture: "Bilda tipo",
            filter_zoom_in: "Zomu en la mapo por vidi",
            map_background: "Bazmapo",
            map_background_aerial: "Aera",
            map_background_streets: "Stratoj",
            map_theme: "Mapa etoso",
            metadata_general_picid_link: "Iru al la JSON-priskribo de la foto",
            metadata_general_seqid_link: "Iru al la JSON-priskribo de la sekvenco",
            metadata_general_author: "A\u016Dtoro",
            metadata_general_license: "Rajtigilo",
            metadata_general_license_link: "Vidi la kompletan rajtigilon en la priskribo",
            metadata_general_date: "Dato de la fotado",
            metadata_camera: "Fotilo",
            metadata_camera_make: "Faristo",
            metadata_camera_model: "\u015Cablono",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Fokuslongo",
            metadata_location: "Pozicio",
            metadata_location_longitude: "Longitudo",
            metadata_location_latitude: "Latitudo",
            metadata_location_orientation: "Direkto",
            metadata_location_precision: "Pozicia precizeco",
            metadata_quality: "Kvalito",
            metadata_quality_help: "Pli pri la Kvalitapoentaro",
            metadata_quality_score: "Malloka poentaro",
            metadata_quality_gps_score: "Pozicia poentaro",
            metadata_quality_missing: "neniu valoro en la bildo",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etikedo",
            metadata_exif_value: "Valoro",
            report_whole_sequence: "\u0108i tio koncernas la tutan sekvencon",
            report_details: "Aliaj detaloj",
            report_email: "Via retpo\u015Dto",
            report_submit: "Sendi",
            report_wait: "Sendante raporton\u2026",
            report_success: "La raporto estis sukcese sendita. \u011Ci estos reviziita balda\u016D.",
            report_details_placeholder: "Opcie, vi povas aldoni detalojn pri la problemo",
            report_email_placeholder: "Opcie",
            report_failure: "Eraro okazis dum kreo de la raporto: {e}. Bonvolu provi denove poste.",
            qualityscore_doc_3: '"A" estas la plej bona noto, "E" la plej malbona.',
            qualityscore_title: "Pri la kvalita poentaro",
            qualityscore_doc_1: "Kvalitan Poentaron estas kalkulita por \u0109iu bildo.",
            qualityscore_doc_link: "Pli da detaloj pri la kalkulo de la Kvalita Poentaro estas disponeblaj en nia dokumentado",
            minimize_short: "Maski",
            qualityscore_doc_2: "La Poentaro estas montrita kiel litero :",
            id: "iD",
            josm: "JOSM",
            contribute_id: "Kontribuu al OpenStreetMap kun iD-modifilo",
            filter_date_6months: "6 monatoj",
            picture_all: "\u0108iuj",
            picture_flat_long: "Klasika foto",
            picture_360_long: "Panorama foto",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Kopii la ID-on",
            metadata_general_copy_picid: "Kopii la fotan ID-on",
            metadata_general_instance: "Origina instanco",
            geo_uri: "Ekseteraj aplika\u0135oj",
            semantics_title: "Etikedoj",
            semantics_tags: "{nb} etikedoj",
            semantics_features: "Detektitaj objektoj",
            semantics_features_none: "No objekto estis ankora\u016D detektita a\u016D prinotita en \u0109i tiu foto.",
            semantics_features_default_title: "Objekto #{nb}",
            metadata_exif_doc: "Dokumentoj por EXIF-etikedoj",
            metadata_exif_doc_title: "Iru al la dokumentaro de Exiv2 por havi plenajn detalojn pri difinoj de EXIF kaj XMP-etikedoj",
            metadata_location_coordinates: "Koordinatoj (longitudo, latitudo)",
            metadata_location_copy: "Kopii {v}",
            metadata_location_copy_more: "Pli da ebloj por kopii koordinatojn",
            whats_panoramax: "Panoramax estas la geokomuna\u0135o por teritoriaj fotoj.",
            semantics_features_subtitle: "{nb} asociitaj atributoj",
            semantics_tags_picture_none: "Ankora\u016D neniuj atributoj estas difinitaj por \u0109i tiu foto.",
            semantics_hide_all_tags: "Maski la atributojn",
            semantics_key: "\u015Closilo",
            semantics_value: "Valoro",
            semantics_show_all_tags: "Vidi \u0109iujn atributojn",
            semantics_tags_picture: "Foto-atributoj",
            semantics_value_doc: "Lernu pli pri \u0109i tiu atributo",
            semantics_qualifiers: "Kvalifikiloj",
            semantics_hide_annotations: "Maski bildajn komentojn",
            semantics_wikidata_properties: {
                P279: "subklaso de",
                P361: "parto de",
                P31: "instanco de"
            },
            share_picture: "Foto",
            semantics_annotation_tooltip: "Alklaku por vidi la detalojn",
            semantics_show_annotations: "Montri bildajn komentojn",
            semantics_key_doc: "Lernu pli pri \u0109i tiu \u015Dlosilo",
            filter_gps_precision: "Lokprecizeco",
            filter_gps_precision_lessthan: "Malpli ol {n} metroj",
            filter_gps_precision_between: "Inter {n1} kaj {n2} metroj",
            popup_details_link: "Pli da detaloj",
            filter_gps_precision_morethan: "Pli ol {n} metroj",
            panoramax: "Panoramax",
            error_pic_load: "La foto ne povis al\u015Duti\u011Di.\nBonvolu kontroli vian interretan konekton. Se vi estas konektita, bonvolu kontroli, ke la fotidentilo estas valida.",
            filter_locked: "Filtrilo malaktivigita",
            qualityscore_doc_4: "\u0108i tiu poentaro estas kalkulata jene:",
            qualityscore_doc_41: "la GPS-precizeco",
            qualityscore_doc_42: "la difino de la foto",
            qualityscore_doc_5: "Profesia ekipa\u0135o ricevos gradon A, 360\xb0 ago-kamerao ricevos gradon B, kaj inteligenta telefono ricevos gradon inter C kaj E.",
            filter_source_world: "Tuta mondo",
            filter_source_local: "Tiu servilo"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Trovi mian pozicion",
            "GeolocateControl.LocationNotAvailable": "Loko ne disponeblas"
        },
        map: {
            slow_loading: "La mapo \u015Dar\u011Das malrapide kaj povus aperi rompi\u011Dinta",
            loading: "\u015Car\u011Danto\u2026",
            thumbnail: "Miniaturo de la surflikta bildo",
            not_public: "Ne publike videbla",
            more_panoramax: "Malkovri pli pri Panoramax",
            map_data: "Kartaj datumoj : {m}"
        }
    },
    en: $785da19a645c07eb$var$ot,
    es: {
        pnx: {
            report_auth: 'Esta denuncia se enviar\xe1 usando tu cuenta "{a}"',
            report: "Denunciar",
            report_nature_label: "Causa del problema",
            report_nature: {
                "": "Selecciona la naturaleza del problema\u2026",
                blur_missing: "La cara de una persona o la matr\xedcula de un auto es visible",
                blur_excess: "Se aplic\xf3 un difuminado innecesario a un objeto",
                inappropriate: "La imagen es inapropiada (no relacionada, desnudez\u2026)",
                privacy: "Un camino o propiedad privada es visible",
                mislocated: "La imagen est\xe1 mal posicionada en el mapa",
                picture_low_quality: "La imagen es de baja calidad",
                copyright: "La imagen infringe derechos de autor",
                other: "Cualquier otro tipo de problema"
            },
            sequence_more: "M\xe1s opciones de reproducci\xf3n",
            sequence_speed: "Velocidad de reproducci\xf3n",
            legend_license: "Licencia: {l}",
            edit_osm: "Editar OpenStreetMap",
            id: "iD",
            josm: "JOSM",
            josm_live: "Habilitar sincronizaci\xf3n autom\xe1tica de JOSM al cargar imagen",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Cargando datos del mapa",
                "\uD83D\uDDA5\uFE0F Consultando API",
                "\uD83D\uDDBC\uFE0F Cargando miniaturas",
                "\uD83D\uDD0D Analizando metadatos EXIF",
                "\uD83C\uDFD8\uFE0F Renderizado 3D",
                "\uD83D\uDCF7 Inicializando im\xe1genes 360\xb0",
                "\uD83D\uDFE0 Balanceando color",
                "\uD83D\uDCAF Calculando nivel de calidad \xa9",
                "\uD83D\uDCE1 Descargando actualizaciones",
                "\uD83C\uDF0D Obteniendo teselas del mapa",
                "\uD83D\uDCF8 Procesando sombras"
            ],
            metadata: "Metadatos de la imagen",
            map_theme_type: "Tipo de c\xe1mara",
            contrast: "Habilitar mayor contraste de imagen",
            zoom: "Zoom",
            zoomOut: "Alejar",
            map_background_streets: "Calles",
            loading_labels_fun: [
                "\uD83E\uDD8C Detectando se\xf1ales de cruce de venados",
                "\uD83D\uDE98 Buscando el Auto Panoramax \xa9",
                "\u2615 Inyectando cafe\xedna",
                "\uD83D\uDE00 \xa1Sonr\xede, est\xe1s en el mapa!",
                "\uD83D\uDC08 Compartiendo fotos de gatos",
                "\uD83D\uDE34 Reduciendo la procrastinaci\xf3n",
                "\uD83E\uDED6 Preparando el t\xe9",
                "\uD83D\uDC27 Abriendo el c\xf3digo fuente",
                "\uD83D\uDE87 Indexando estaciones de metro",
                "\uD83E\uDDF9 Limpiando metadatos",
                "\uD83D\uDE92 Enviando fotos de estaciones de bomberos",
                "\uD83D\uDEB2 Actualizando v\xedas verdes",
                "\uD83D\uDE89 Paseo por el and\xe9n de la estaci\xf3n",
                "\uD83D\uDEF0\uFE0F Buscando sat\xe9lites",
                "\uD83D\uDC65 Escribiendo perfiles de usuario",
                "\uD83D\uDC1F Localizando puestos de papas fritas",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando la interfaz",
                "\uD83D\uDCC8 Incrementando estad\xedsticas",
                "\uD83E\uDD16 Aprendiendo sem\xe1ntica",
                "\uD83C\uDFA8 Redise\xf1ando interfaz",
                "\uD83D\uDCC5 Planificando fiestas de foto-mapeo",
                "\uD83E\uDDC0 Madurando quesos",
                "\uD83C\uDF04 Calculando la luz solar de Cornualles",
                "\uD83C\uDF0A Midiendo las mareas altas"
            ],
            metadata_general_license_link: "Ver la descripci\xf3n completa de la licencia",
            metadata_general_picid: "Imagen",
            metadata_general_license: "Licencia",
            report_details_placeholder: "Opcionalmente, puedes a\xf1adir detalles sobre el problema",
            expand: "Expandir",
            expand_info: "Mostrar el elemento en p\xe1gina completa",
            show_psv: "Mostrar el visor de im\xe1genes",
            show_map: "Mostrar el mapa",
            zoomIn: "Acercar",
            moveUp: "Mover hacia arriba",
            moveDown: "Mover hacia abajo",
            moveLeft: "Mover a la izquierda",
            moveRight: "Mover a la derecha",
            moveMiddle: "Centrar vista",
            minimize: "Ocultar este elemento, puedes mostrarlo de nuevo usando el bot\xf3n en la esquina inferior izquierda",
            options: "Opciones",
            filters: "Filtros",
            layers: "Capas",
            search: "Buscar",
            search_empty: "No se encontraron resultados",
            search_address: "Buscar una direcci\xf3n, ciudad\u2026",
            search_user: "Buscar un nombre de usuario\u2026",
            share: "Compartir",
            share_links: "Enlaces",
            share_page: "Enlace a esta imagen",
            share_image: "Imagen HD",
            share_rss: "Feed RSS",
            share_rss_title: "Feed RSS de nuevas secuencias en el \xe1rea del mapa visible actualmente",
            share_embed: "Incrustar en tu sitio web",
            share_embed_docs: "Leer m\xe1s sobre la configuraci\xf3n de incrustaci\xf3n",
            share_print: "Imprimir",
            copy: "Copiar",
            copied: "Copiado",
            error: "Tenemos un problema\u2026",
            sequence_next: "Siguiente imagen en la secuencia",
            sequence_play: "Reproducir esta secuencia",
            sequence_pause: "Pausar secuencia",
            sequence_prev: "Imagen anterior en la secuencia",
            error_click: "Continuar",
            error_retry: "Por favor, reintenta m\xe1s tarde",
            error_psv: "El visor de fotos esf\xe9ricas no se est\xe1 cargando correctamente",
            error_pic: "No se encontr\xf3 la imagen solicitada",
            error_nopic: "No hay imagen disponible en la posici\xf3n dada",
            error_api: "El servidor de im\xe1genes no est\xe1 disponible",
            error_webgl: "Tu navegador no soporta WebGL",
            error_josm: "JOSM no responde, \xbfest\xe1 ejecut\xe1ndose y tiene habilitado el control remoto?",
            error_api_compatibility: "El servidor de im\xe1genes no es compatible con esta versi\xf3n del visor",
            filter_date: "Fecha",
            filter_user: "Usuario",
            filter_picture: "Tipo de imagen",
            filter_zoom_in: "Acerca el mapa para ver este filtro",
            picture_flat: "Cl\xe1sica",
            picture_360: "360\xb0",
            filter_camera_model: "Por modelo de c\xe1mara",
            map_background: "Fondo del mapa",
            map_background_aerial: "A\xe9rea",
            map_theme: "Tema del mapa",
            map_theme_default: "Cl\xe1sico",
            map_theme_age: "Fecha de captura",
            map_theme_age_1: "M\xe1s de tres a\xf1os",
            map_theme_age_2: "Menos de tres a\xf1os",
            map_theme_age_3: "Menos de un a\xf1o",
            map_theme_age_4: "Menos de seis mes",
            metadata_general_seqid: "Secuencia",
            metadata_general_picid_link: "Ir a la descripci\xf3n JSON de la imagen",
            metadata_general_seqid_link: "Ir a la descripci\xf3n JSON de la secuencia",
            metadata_general_author: "Autor",
            metadata_general_date: "Fecha de captura",
            metadata_camera: "C\xe1mara",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Distancia focal",
            metadata_location: "Posici\xf3n",
            metadata_location_longitude: "Longitud",
            metadata_location_latitude: "Latitud",
            metadata_location_orientation: "Direcci\xf3n",
            metadata_location_precision: "Precisi\xf3n de posicionamiento",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "Etiqueta",
            metadata_exif_value: "Valor",
            report_whole_sequence: "Esto concierne a toda la secuencia",
            report_details: "Detalles adicionales",
            report_email: "Tu correo electr\xf3nico",
            report_email_placeholder: "Opcional",
            report_submit: "Enviar",
            report_success: "La denuncia se envi\xf3 con \xe9xito. Ser\xe1 revisada lo antes posible.",
            report_failure: "Ocurri\xf3 un error al crear la denuncia: {e}. Por favor, int\xe9ntalo de nuevo m\xe1s tarde.",
            map_theme_score: "Nivel de calidad",
            filter_qualityscore: "Nivel de calidad",
            filter_qualityscore_help: "Haz clic para habilitar o deshabilitar",
            legend_title: "Mostrar detalles de la imagen",
            metadata_camera_resolution: "Resoluci\xf3n",
            metadata_quality: "Calidad",
            metadata_quality_help: "Saber m\xe1s sobre la puntuaci\xf3n de calidad",
            metadata_quality_score: "Puntuaci\xf3n global",
            metadata_quality_gps_score: "Puntuaci\xf3n de posicionamiento",
            metadata_quality_resolution_score: "Puntuaci\xf3n de resoluci\xf3n",
            metadata_quality_missing: "ning\xfan valor establecido en la imagen",
            report_wait: "Enviando denuncia\u2026",
            semantics_copy: "Copiar atributos",
            semantics_zoom_in: "Acerca el mapa para ver las etiquetas",
            semantics_download_info: "Todos los datos sem\xe1nticos (etiquetas) est\xe1n disponibles como datos abiertos. Puedes descargarlos y usarlos como quieras.",
            semantics_download_cta: "Descargar datos abiertos",
            semantics_editor_example: "clave=valor\nprefijo|clave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Guardar tus cambios",
            semantics_title: "Etiquetas",
            popup_details_link: "M\xe1s detalles",
            qualityscore_doc_5: "Un dispositivo profesional tendr\xe1 una calificaci\xf3n A, una c\xe1mara de acci\xf3n 360\xb0 una calificaci\xf3n B, y un tel\xe9fono inteligente una calificaci\xf3n entre C y E.",
            filter_gps_precision: "Precisi\xf3n de la ubicaci\xf3n",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} y {n2} metros",
            filter_gps_precision_help_1: "Hay informaci\xf3n de precisi\xf3n de la ubicaci\xf3n disponible para cada imagen. Esto corresponde a la precisi\xf3n del GPS durante la captura de la imagen.",
            filter_gps_precision_help_2: "La precisi\xf3n se expresa con estrellas:",
            filter_gps_precision_help_4: 'Un GPS RTK tendr\xe1 una calificaci\xf3n de "5\u2B50", una c\xe1mara de acci\xf3n como GoPro Max una calificaci\xf3n de "3\u2B50", y el GPS de un tel\xe9fono inteligente en un estacionamiento subterr\xe1neo una calificaci\xf3n de "1\u2B50".',
            map_theme_gps: "Precisi\xf3n de la ubicaci\xf3n",
            metadata_summary: "Resumen",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID de imagen",
            metadata_general_instance: "Instancia de origen",
            metadata_exif_doc: "Documentaci\xf3n para etiquetas EXIF",
            semantics_wikidata_properties: {
                P361: "parte de",
                P31: "instancia de",
                P180: "representa",
                P279: "subclase de"
            },
            semantics_annotation_tooltip: "Haz clic para ver detalles",
            minimize_short: "Ocultar",
            semantics_doc_link: "Saber m\xe1s sobre etiquetas",
            panoramax: "Panoramax",
            geo_uri: "Aplicaci\xf3n externa",
            filter_date_1year: "1 a\xf1o",
            filter_user_mypics: "Mis im\xe1genes",
            picture_all: "Todas",
            qualityscore_doc_1: "Se calcula una puntuaci\xf3n de calidad para cada imagen.",
            qualityscore_doc_2: "La puntuaci\xf3n se muestra como una letra:",
            metadata_location_coordinates: "Coordenadas (longitud, latitud)",
            whats_panoramax: "Panoramax es el geo-com\xfan para las im\xe1genes de los territorios.",
            picture_360_long: "Imagen panor\xe1mica",
            semantics_overlays: {
                features: "Todas las caracter\xedsticas",
                tfsigns: "Se\xf1ales de tr\xe1fico"
            },
            "visibility_logged-only": "Miembros",
            "visibility_title_logged-only": "Solo las personas con una cuenta pueden ver esta imagen",
            semantics_doc_info1u1: "Puedes etiquetarla como capturada por auto con la etiqueta transport=car.",
            semantics_download: "Descargar",
            filter_date_6months: "6 meses",
            semantics_sequence_tags: "Etiqueta de secuencia",
            semantics_picture_tags: "Etiqueta de imagen",
            semantics_annotation_tags: "Etiqueta de objeto",
            picture_flat_long: "Imagen cl\xe1sica",
            semantics_doc_info1: "Dar contexto a una imagen usando etiquetas.",
            semantics_doc_info3: "Algunos objetos son detectados autom\xe1ticamente con IA: la calidad no est\xe1 garantizada.",
            indoor_switch: "Mapas de interiores",
            indoor_selector_expand: "Haz clic para ver todos los niveles disponibles",
            indoor_selector_leveldown: "Ir al nivel inferior",
            indoor_selector_scrollup: "Desplazar la lista de niveles hacia arriba",
            indoor_selector_scrolldown: "Desplazar la lista de niveles hacia abajo",
            semantics_editor_error: "La sintaxis no es v\xe1lida. Tus etiquetas deben verse como:\nclave=valor\nprefijo|clave=valor\nprefijo|clave[clave_calif=val_calif]=valor\n\nLa longitud m\xe1xima de la clave es de 256 caracteres, la longitud m\xe1xima del valor es de 2048 caracteres.",
            contribute_id: "Contribuir a OpenStreetMap con el editor iD",
            semantics_value_show_osm: "Ver en OpenStreetMap",
            semantics_download_title: "Descargar etiquetas",
            semantics_add_annotation: "A\xf1adir una nueva etiqueta",
            semantics_draw_annotation: "Puedes dibujar el objeto que quieres a\xf1adir sobre la imagen (Opcional).",
            semantics_delete_annotation: "Eliminar esta caracter\xedstica",
            semantics_features_none: "A\xfan no se ha dibujado ninguna caracter\xedstica en esta imagen.",
            filter_gps_precision_help: "Saber m\xe1s sobre la precisi\xf3n de la ubicaci\xf3n",
            semantics_key_doc: "Saber m\xe1s sobre esta clave",
            semantics_doc: "Ayuda",
            qualityscore_doc_4: "Esta puntuaci\xf3n se calcula bas\xe1ndose en:",
            qualityscore_doc_41: "la precisi\xf3n del GPS",
            qualityscore_doc_42: "la resoluci\xf3n de la imagen",
            semantics_tags: "{nb} etiquetas",
            semantics_features: "Caracter\xedsticas de la imagen",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_show_all_tags: "Mostrar todas las etiquetas",
            filter_date_1month: "1 mes",
            qualityscore_doc_3: '"A" es la mejor calificaci\xf3n, "E" la peor.',
            qualityscore_doc_link: "Saber m\xe1s sobre la puntuaci\xf3n de calidad",
            filter_gps_precision_morethan: "M\xe1s de {n} metros",
            metadata_location_copy: "Copiar {v}",
            metadata_location_copy_more: "M\xe1s opciones de copia de coordenadas",
            metadata_exif_doc_title: "Ir a la documentaci\xf3n de Exiv2 para obtener detalles completos sobre las definiciones de etiquetas EXIF y XMP",
            semantics_features_subtitle: "{nb} propiedades asociadas",
            semantics_hide_all_tags: "Ocultar todas las etiquetas",
            semantics_key: "Clave",
            semantics_value: "Valor",
            semantics_doc_info2: "Tambi\xe9n puedes dibujar objetos en la imagen: se\xf1ales de tr\xe1fico, equipamiento urbano... Marca lo que veas usando etiquetas existentes. Tambi\xe9n puedes crear las tuyas propias si es necesario.",
            semantics_value_doc: "Saber m\xe1s sobre esta etiqueta",
            semantics_qualifiers: "Calificadores",
            semantics_show_annotations: "Mostrar caracter\xedsticas de la imagen",
            semantics_hide_annotations: "Ocultar caracter\xedsticas de la imagen",
            semantics_zero_annotations: "No hay caracter\xedsticas dibujadas en esta imagen",
            semantics_erase_annotation: "Borrar caracter\xedstica dibujada",
            semantics_delete_annotation_confirm: "\xbfRealmente quieres eliminar esta etiqueta?",
            semantics_undo: "Cancelar tus ediciones",
            semantics_send_fail: "No se pudieron guardar tus cambios, por favor int\xe9ntalo de nuevo m\xe1s tarde",
            semantics_login_needed: "Para editar etiquetas o caracter\xedsticas de la imagen, necesitas iniciar sesi\xf3n en la instancia {n} de Panoramax. \xbfQuieres iniciar sesi\xf3n?",
            indoor_selector_shrink: "Haz clic para minimizar",
            indoor_selector_levelup: "Ir al nivel superior",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Solo t\xfa puedes ver esta imagen"
        },
        psv: {
            ctrlZoom: "Usa Ctrl + rueda de desplazamiento para hacer zoom en la imagen",
            loadError: "El panorama no se puede cargar",
            twoFingers: "Usa dos dedos para navegar"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Buscar mi ubicaci\xf3n",
            "GeolocateControl.LocationNotAvailable": "Ubicaci\xf3n no disponible"
        },
        map: {
            loading: "Cargando\u2026",
            thumbnail: "Vista previa de la imagen bajo el cursor",
            not_public: "No es visible p\xfablicamente",
            slow_loading: "El mapa tarda en cargar y podr\xeda parecer roto",
            map_data: "Mapa basado en {m}",
            more_panoramax: "Descubre m\xe1s sobre Panoramax"
        }
    },
    fr: {
        psv: {
            twoFingers: "Utilisez deux doigts pour vous d\xe9placer",
            ctrlZoom: "Utilisez ctrl + scroll pour zoomer dans l'image",
            loadError: "L'image ne peut pas \xeatre charg\xe9e"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Afficher ma position",
            "GeolocateControl.LocationNotAvailable": "GPS non-disponible"
        },
        pnx: {
            zoom: "Zoom",
            zoomOut: "D\xe9zoomer",
            zoomIn: "Zoomer",
            moveUp: "Vers le haut",
            moveDown: "Vers le bas",
            moveLeft: "Vers la gauche",
            moveRight: "Vers la droite",
            moveMiddle: "Centrer la vue",
            expand: "Agrandir",
            expand_info: "Faire appara\xeetre ce widget en pleine page",
            show_psv: "Afficher la visionneuse de photos",
            show_map: "Afficher la carte",
            time_travel: "Voir ce lieu \xe0 d'autres dates",
            time_travel_close: "Masquer les autres dates",
            minimize: "Masquer ce widget, vous pouvez l'afficher de nouveau gr\xe2ce au bouton dans le coin en bas \xe0 gauche",
            minimize_short: "Masquer",
            options: "Options",
            filters: "Filtres",
            layers: "Calques",
            search: "Rechercher",
            search_empty: "Aucun r\xe9sultat",
            search_address: "Rechercher une adresse, ville\u2026",
            search_user: "Rechercher un nom d'utilisateur\u2026",
            share: "Partager",
            share_links: "Liens utiles",
            share_page: "Lien de la photo",
            share_image: "Image HD",
            share_rss: "Flux RSS",
            share_rss_title: "Flux RSS des nouvelles s\xe9quences dans la zone visible sur la carte",
            share_embed: "Int\xe9gration sur votre site",
            share_embed_docs: "D\xe9couvrir plus de possibilit\xe9s pour l'int\xe9gration sur votre site",
            share_print: "Imprimer",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax est le g\xe9ocommun des photos des territoires.",
            copy: "Copier",
            copied: "Copi\xe9",
            error: "On a un probl\xe8me\u2026",
            error_click: "Continuer",
            error_retry: "Merci de r\xe9essayer plus tard",
            sequence_next: "Photo suivante dans la s\xe9quence",
            sequence_play: "Parcourir cette s\xe9quence",
            sequence_play_backwards: "Parcourir cette s\xe9quence, \xe0 l'envers",
            sequence_pause: "Mettre en pause la s\xe9quence",
            sequence_prev: "Photo pr\xe9c\xe9dente dans la s\xe9quence",
            sequence_more: "Plus d'options de lecture",
            sequence_speed: "Vitesse de lecture",
            legend_license: "Licence : {l}",
            legend_title: "Afficher les d\xe9tails de l'image",
            id: "iD",
            contribute_id: "Contribuez \xe0 OpenStreetMap avec l'\xe9diteur iD",
            geo_uri: "App externe",
            josm: "JOSM",
            josm_live: "Active la synchronisation automatique de JOSM lors du chargement d'une photo",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Chargement du fond de carte",
                "\uD83D\uDDA5\uFE0F Interrogation de l'API",
                "\uD83D\uDDBC\uFE0F Chargement des miniatures",
                "\uD83D\uDD0D Analyse des m\xe9tadonn\xe9es EXIF",
                "\uD83C\uDFD8\uFE0F Cr\xe9ation du rendu 3D",
                "\uD83D\uDCF7 Initialisation des vues 360\xb0",
                "\uD83D\uDFE0 \xc9quilibrage des couleurs",
                "\uD83D\uDCAF Calcul du score qualit\xe9 \xa9",
                "\uD83D\uDCE1 T\xe9l\xe9chargement des mises \xe0 jour",
                "\uD83C\uDF0D R\xe9cup\xe9ration des tuiles",
                "\uD83D\uDCF8 Traitement des ombres"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C D\xe9tection des panneaux biche",
                "\uD83D\uDE98 Recherche de la Panoramax Car \xa9",
                "\u2615 Injection de caf\xe9ine",
                "\uD83D\uDE00 Souriez, vous \xeates mapp\xe9s\u202F!",
                "\uD83D\uDC08 Partage de photos de chats",
                "\uD83D\uDE34 R\xe9duction de la procrastination",
                "\uD83C\uDDF7\uD83C\uDDEA Chargement : 974%",
                "\uD83D\uDC27 Ouverture du code source",
                "\uD83E\uDD81 Indexation des traboules",
                "\uD83E\uDDF9 Nettoyage des m\xe9tadonn\xe9es",
                "\uD83D\uDE92 Envoi des photos du SDIS",
                "\uD83D\uDEB2 Mise \xe0 jour des voies vertes",
                "\uD83D\uDE89 Remont\xe9e des quais de gare",
                "\uD83D\uDEF0\uFE0F Recherche de satellites",
                "\uD83D\uDC65 \xc9criture des personas",
                "\uD83E\uDD5E Localisation des cr\xeaperies",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB D\xe9bogage de l'interface",
                "\uD83D\uDCC8 Incr\xe9mentation des statistiques",
                "\uD83E\uDD16 Apprentissage de la s\xe9mantique",
                "\uD83C\uDFA8 Redesign de l'interface",
                "\uD83D\uDCC5 Planification des photos-carto-parties",
                "\uD83E\uDDC0 Affinage des fromages",
                "\uD83C\uDF04 Calcul de l'ensoleillement corse",
                "\uD83C\uDF0A Mesure des grandes mar\xe9es"
            ],
            error_psv: "Photo Sphere Viewer ne s'est pas charg\xe9 correctement",
            error_pic: "La photo demand\xe9e est introuvable",
            error_nopic: "Aucune photo disponible autour de la localisation recherch\xe9e",
            error_api: "Le serveur de photos n'est pas disponible",
            error_pic_load: "La photo n'a pas pu \xeatre charg\xe9e.\nV\xe9rifiez votre connexion Internet. Si vous \xeates bien connect\xe9, v\xe9rifiez que l'identifiant de photo est bien valide.",
            error_webgl: "WebGL n'est pas support\xe9 par votre navigateur",
            error_josm: "JOSM n'a pas r\xe9pondu, est-il bien lanc\xe9 et la t\xe9l\xe9commande activ\xe9e\u202F?",
            error_api_compatibility: "Le serveur de photos n'est pas compatible avec cette visionneuse",
            filter_source_world: "Monde entier",
            filter_source_local: "Ce serveur",
            filter_date: "Date",
            filter_date_1month: "1 mois",
            filter_date_6months: "6 mois",
            filter_date_1year: "1 an",
            filter_user: "Utilisateur",
            filter_user_mypics: "Mes photos",
            filter_picture: "Type d'image",
            picture_all: "Tout",
            picture_flat: "Classique",
            picture_360: "360\xb0",
            picture_flat_long: "Photo classique",
            picture_360_long: "Photo panoramique",
            popup_details_link: "Plus de d\xe9tails",
            filter_qualityscore: "Score de qualit\xe9",
            filter_qualityscore_help: "Cliquez pour activer ou d\xe9sactiver",
            qualityscore_doc_1: "Un Score de Qualit\xe9 est calcul\xe9 pour chaque image.",
            qualityscore_doc_2: "Le Score est affich\xe9 sous la forme d'une lettre :",
            qualityscore_doc_3: '"A" est la meilleure note, "E" la moins bonne.',
            qualityscore_doc_4: "Ce score est calcul\xe9 selon :",
            qualityscore_doc_41: "la pr\xe9cision du GPS",
            qualityscore_doc_42: "la r\xe9solution de la photo",
            qualityscore_doc_5: "Un mat\xe9riel professionnel aura une note de A, une cam\xe9ra sportive 360\xb0 une note de B, et un smartphone une note entre C et E.",
            qualityscore_doc_link: "En savoir plus sur le Score de Qualit\xe9",
            filter_locked: "Filtre d\xe9sactiv\xe9",
            filter_zoom_in: "Zoomer pour voir",
            widget_locked: "Option d\xe9sactiv\xe9e",
            filter_gps_precision: "Pr\xe9cision du positionnement",
            filter_gps_precision_lessthan: "Moins de {n} m\xe8tres",
            filter_gps_precision_between: "Entre {n1} et {n2} m\xe8tres",
            filter_gps_precision_morethan: "Plus de {n} m\xe8tres",
            filter_gps_precision_help: "En savoir plus sur la pr\xe9cision du positionnement",
            filter_gps_precision_help_1: "Une Pr\xe9cision du positionnement est disponible pour chaque image. Cela correspond \xe0 la pr\xe9cision du GPS utilis\xe9.",
            filter_gps_precision_help_2: "La pr\xe9cision est exprim\xe9 sous forme d'\xe9toile :",
            filter_gps_precision_help_3: '"5\u2B50" est tr\xe8s pr\xe9cis (<= {p5}m), "1\u2B50" est tr\xe8s impr\xe9cis (> {p1}m) ou inconnu.',
            filter_gps_precision_help_4: 'Un GPS RTK aura une note de "5\u2B50", un GPS de cam\xe9ra sportive type GoPro Max une note de "3\u2B50", un GPS de smartphone dans un parking souterrain une note de "1\u2B50".',
            map_background: "Fond",
            map_background_aerial: "Satellite",
            map_background_streets: "Plan",
            map_background_default: "Par d\xe9faut",
            map_background_more: "Plus",
            map_theme: "Th\xe8me",
            map_theme_default: "Classique",
            map_theme_default_short: "Classique",
            map_theme_default_coef: "Niveau de couverture",
            map_theme_default_coef_short: "Couverture",
            map_theme_default_1: "Faible",
            map_theme_default_2: "Moyenne",
            map_theme_default_3: "Bonne",
            map_theme_default_4: "Excellente",
            map_theme_age_1: "+ 3 ans",
            map_theme_age_2: "1 - 3 ans",
            map_theme_age_3: "\xbd - 1 an",
            map_theme_age_4: "- 6 mois",
            map_theme_age: "Date de capture",
            map_theme_age_short: "Date",
            map_theme_type: "Type de cam\xe9ra",
            map_theme_type_short: "Cam\xe9ra",
            map_theme_score: "Score de qualit\xe9",
            map_theme_score_short: "Qualit\xe9",
            map_theme_gps: "Pr\xe9cision du GPS",
            map_theme_gps_short: "Position",
            contrast: "Augmenter le contraste de l'image",
            low_contrast: "Diminuer le contraste de l'image",
            reset_contrast: "R\xe9tablir le contraste de l'image",
            metadata: "M\xe9tadonn\xe9es de la photo",
            metadata_summary: "R\xe9sum\xe9",
            metadata_general_copy_id: "Copier l'ID",
            metadata_general_copy_picid: "Copier l'ID de photo",
            metadata_general_picid: "Photo",
            metadata_general_seqid: "S\xe9quence",
            metadata_general_picid_link: "Aller au descriptif JSON de la photo",
            metadata_general_seqid_link: "Aller au descriptif JSON de la s\xe9quence",
            metadata_general_title: "Titre",
            metadata_general_author: "Auteur",
            metadata_general_license: "Licence",
            metadata_general_license_link: "Voir la description compl\xe8te de la licence",
            metadata_general_date: "Date de prise de vue",
            metadata_general_instance: "Instance d'origine",
            metadata_camera: "Appareil",
            metadata_camera_make: "Fabricant",
            metadata_camera_model: "Mod\xe8le",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "R\xe9solution",
            metadata_camera_focal_length: "Longueur focale",
            metadata_location: "Position",
            metadata_location_coordinates: "Coordonn\xe9es (longitude, latitude)",
            metadata_location_orientation: "Direction",
            metadata_location_precision: "Pr\xe9cision du positionnement",
            metadata_location_copy: "Copier {v}",
            metadata_location_copy_more: "Copier d'autres formats de coordonn\xe9es",
            metadata_quality: "Qualit\xe9",
            metadata_quality_help: "En savoir plus sur le score de qualit\xe9",
            metadata_quality_score: "Note globale",
            metadata_quality_gps_score: "Note du positionnement",
            metadata_quality_resolution_score: "Note de la r\xe9solution",
            metadata_quality_missing: "pas d'info dans l'image",
            metadata_exif: "EXIF",
            metadata_exif_name: "Balise",
            metadata_exif_value: "Valeur",
            metadata_exif_doc: "Doc des attributs EXIF",
            metadata_exif_doc_title: "Voir la doc Exiv2 pour en savoir plus sur les attributs EXIF et XMP",
            semantics_title: "Tags",
            semantics_tags: "{nb} attributs",
            semantics_features: "Objets dans la photo",
            semantics_features_none: "Aucun objet n'a \xe9t\xe9 dessin\xe9 dans cette photo pour l'instant.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} attributs associ\xe9s",
            semantics_annotation_tooltip: "Cliquez pour voir les d\xe9tails",
            semantics_annotation_tooltip_close: "Cliquez pour d\xe9s\xe9lectionner",
            semantics_show_all_tags: "Voir tous les attributs",
            semantics_hide_all_tags: "Masquer les attributs",
            semantics_key: "Cl\xe9",
            semantics_value: "Valeur",
            semantics_sequence_tags: "Tag de s\xe9quence",
            semantics_picture_tags: "Tag de photo",
            semantics_annotation_tags: "Tag d'un objet",
            semantics_doc: "Aide",
            semantics_doc_info1: "Pr\xe9cisez le contexte d'une photo en utilisant un tag.",
            semantics_doc_info1u1: "Indiquez par exemple qu'elle a \xe9t\xe9 prise en voiture avec le tag transport=car.",
            semantics_doc_info2: "Vous pouvez \xe9galement d\xe9tourer des objets au sein d'une photo\u202F: panneaux routiers, mobilier urbain\u2026 Pr\xe9cisez ce que vous voyez en utilisant les tags d\xe9j\xe0 utilis\xe9s par la communaut\xe9. Vous pouvez \xe9galement cr\xe9er votre propre tag si besoin.",
            semantics_doc_info3: "Certains objets sont d\xe9tect\xe9s automatiquement par IA : il n'y a pas de garantie de qualit\xe9.",
            semantics_doc_link: "En savoir plus (documentation compl\xe8te en anglais)",
            semantics_key_doc: "En savoir plus \xe0 propos de cette cl\xe9",
            semantics_value_doc: "En savoir plus \xe0 propos de cet attribut",
            semantics_value_show_osm: "Voir sur OpenStreetMap",
            semantics_qualifiers: "Qualificateurs",
            semantics_show_annotations: "Afficher les objets dans la photo",
            semantics_hide_annotations: "Masquer les objets dans la photo",
            semantics_zero_annotations: "Aucun objet dessin\xe9 dans cette photo",
            semantics_add_annotation: "Ajouter un nouveau tag",
            semantics_draw_annotation: "Vous pouvez dessiner l'emplacement de l'objet \xe0 cr\xe9er sur la photo (Optionnel).",
            semantics_draw_invalid_annotation: "La zone dessin\xe9e d\xe9passe de la photo. Veuillez vous assurer que la zone dessin\xe9e soit bien \xe0 l'int\xe9rieur de la photo.",
            semantics_draw_unfinished_annotation: "La zone dessin\xe9e n'est pas termin\xe9e. Assurez-vous qu'elle soit bien positionn\xe9e avant d'enregistrer.",
            semantics_erase_annotation: "Effacer l'objet dessin\xe9",
            semantics_delete_annotation: "Supprimer cet objet",
            semantics_delete_annotation_confirm: "\xcates-vous s\xfbr(e) de vouloir supprimer ce tag\u202F?",
            semantics_wikidata_properties: {
                P31: "instance de",
                P180: "d\xe9peint",
                P279: "sous-classe de",
                P361: "partie de"
            },
            semantics_editor_error: "La syntaxe est invalide. Vos attributs doivent avoir cette forme:\ncl\xe9=valeur\npr\xe9fixe|cl\xe9=valeur\npr\xe9fixe|cl\xe9[qualif_cl\xe9=qualif_val]=valeur\n\nLongueur max des cl\xe9s : 256 caract\xe8res, max des valeurs 2048 caract\xe8res.",
            semantics_editor_example: "cl\xe9=valeur\npr\xe9fixe|cl\xe9=valeur",
            semantics_copy: "Copier les attributs",
            semantics_edit: "Modifier les attributs",
            semantics_save: "Enregistrer vos modifications",
            semantics_undo: "Annuler vos modifications",
            semantics_send_fail: "Impossible d'enregistrer vos modifications, merci de r\xe9essayer plus tard",
            semantics_login_needed: "Afin de pouvoir modifier les attributs ou objets de la photo, vous devez vous connecter sur l'instance Panoramax {n}. Voulez-vous vous connecter\u202F?",
            semantics_empty: "Aucun attribut renseign\xe9",
            semantics_overlays: {
                tfsigns: "Panneaux routiers",
                features: "Tous les objets"
            },
            semantics_zoom_in: "Zoomez la carte pour voir les tags",
            semantics_download: "T\xe9l\xe9charger",
            semantics_download_title: "T\xe9l\xe9charger les tags",
            semantics_download_info: "Toutes les donn\xe9es s\xe9mantiques (tags) sont disponibles en open data. Vous pouvez les t\xe9l\xe9charger et en faire un libre usage.",
            semantics_download_cta: "T\xe9l\xe9charger les donn\xe9es",
            delete_picture: "Supprimer",
            delete_picture_warn: "\u26A0\uFE0F Attention\u202F: ceci supprimera d\xe9finitivement la photo.\n\xcates-vous s\xfbr\xb7e de supprimer la photo\u202F?",
            delete_picture_ok: "La photo a bien \xe9t\xe9 supprim\xe9e",
            delete_picture_error: "Une erreur s'est produite lors de la suppression de la photo\u202F:\n{e}",
            report: "Signaler",
            report_auth: 'Ce signalement sera envoy\xe9 en utilisant votre compte "{a}"',
            report_nature_label: "Nature du probl\xe8me",
            report_nature: {
                "": "S\xe9lectionnez la nature du probl\xe8me\u2026",
                blur_missing: "Un visage ou une plaque d'immatriculation est visible",
                blur_excess: "Un objet a \xe9t\xe9 sur-flout\xe9",
                inappropriate: "L'image est inappropri\xe9e (non pertinente, nudit\xe9\u2026)",
                privacy: "L'image a \xe9t\xe9 prise depuis une voie ou une propri\xe9t\xe9 priv\xe9e",
                picture_low_quality: "L'image est de mauvaise qualit\xe9",
                mislocated: "L'image est mal g\xe9olocalis\xe9e",
                copyright: "L'image enfreint les droits d'auteur",
                other: "Tout autre type de probl\xe8me"
            },
            report_whole_sequence: "Cela concerne toute la s\xe9quence",
            report_details: "D\xe9tails suppl\xe9mentaires",
            report_details_placeholder: "Optionnel, vous pouvez ajouter des d\xe9tails sur le probl\xe8me",
            report_email: "Votre email",
            report_email_placeholder: "Optionnel",
            report_submit: "Envoyer",
            report_wait: "Envoi du signalement en cours\u2026",
            report_success: "Le signalement a \xe9t\xe9 envoy\xe9 avec succ\xe8s. Il sera examin\xe9 d\xe8s que possible.",
            report_failure: "Une erreur est survenue lors de la cr\xe9ation du signalement : {e}. Veuillez r\xe9essayer plus tard.",
            indoor_switch: "Espaces int\xe9rieurs",
            indoor_selector_expand: "Cliquez pour voir tous les niveaux disponibles",
            indoor_selector_shrink: "Cliquez pour r\xe9duire",
            indoor_selector_levelup: "Aller au niveau sup\xe9rieur",
            indoor_selector_leveldown: "Aller au niveau inf\xe9rieur",
            indoor_selector_scrollup: "D\xe9rouler la liste vers le haut",
            indoor_selector_scrolldown: "D\xe9rouler la liste vers le bas",
            "visibility_logged-only": "Membres",
            "visibility_title_logged-only": "Seules les personnes avec un compte peuvent voir cette image",
            "visibility_owner-only": "Masqu\xe9",
            "visibility_title_owner-only": "Personne \xe0 part vous ne peut voir cette image"
        },
        map: {
            loading: "Chargement\u2026",
            thumbnail: "Miniature de la photo survol\xe9e",
            not_public: "Masqu\xe9 au public",
            slow_loading: "La carte est longue \xe0 charger et pourrait para\xeetre cass\xe9e",
            map_data: "Carte bas\xe9e sur {m}",
            more_panoramax: "En savoir plus sur Panoramax"
        }
    },
    hr: {
        psv: {
            twoFingers: "Koristi dva prsta za navigaciju",
            ctrlZoom: "Koristi ctrl + scroll za zumiranje slike",
            loadError: "Panorama se ne mo\u017Ee u\u010Ditati"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Prona\u0111i moju lokaciju",
            "GeolocateControl.LocationNotAvailable": "Lokacija nije dostupna"
        },
        pnx: {
            zoom: "Zumiraj",
            zoomOut: "Smanji",
            zoomIn: "Pove\u0107aj",
            moveUp: "Pomakni se naprijed",
            moveDown: "Pomakni se natrag",
            moveLeft: "Pomakni se lijevo",
            moveRight: "Pomakni se desno",
            moveMiddle: "Sredi\u0161nji pogled",
            expand: "Pro\u0161iri",
            show_psv: "Poka\u017Ei preglednik slika",
            expand_info: "Neka se komponenta pojavi na cijeloj stranici",
            minimize_short: "Sakrij",
            options: "Opcije",
            filters: "Filteri",
            layers: "Slojevi",
            search: "Pretra\u017Ei",
            search_empty: "Nema prona\u0111enih rezultata",
            search_address: "Tra\u017Ei adresu ili grad\u2026",
            search_user: "Tra\u017Ei korisni\u010Dko ime\u2026",
            share: "Podijeli",
            share_links: "Poveznice",
            share_page: "Poveznica na ovu sliku",
            share_image: "HD slika",
            share_rss: "RSS sa\u017Eetak sadr\u017Eaja",
            share_rss_title: "RSS sa\u017Eetak sadr\u017Eaja novih sekvenci u trenutno vidljivom podru\u010Dju karte",
            share_embed: "Ugradi na svoju web stranicu",
            share_embed_docs: "Pro\u010Ditaj vi\u0161e o konfiguraciji ugradnje",
            share_print: "Ispi\u0161i",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax je geo-commons za slike teritorija.",
            copy: "Kopiraj",
            copied: "Kopirano",
            error: "Imamo problem\u2026",
            error_click: "Nastavi",
            error_retry: "Molim poku\u0161aj kasnije ponovo",
            sequence_next: "Slijede\u0107a slika u sekvenci",
            sequence_play: "Pokreni ovu sekvencu",
            sequence_pause: "Zaustavi ovu sekvencu",
            sequence_prev: "Prethodna slika u sekvenci",
            sequence_more: "Vi\u0161e mogu\u0107nosti igre",
            legend_license: "Licenca: {l}",
            legend_title: "Poka\u017Ei detalje slike",
            id: "iD",
            geo_uri: "Vanjska aplikacija",
            josm: "JOSM",
            josm_live: "Omogu\u0107i JOSM automatsku sinkronizaciju prilikom u\u010Ditavanja slike",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F U\u010Ditavanje podataka karte",
                "\uD83D\uDDA5\uFE0F API za upite",
                "\uD83D\uDDBC\uFE0F U\u010Ditavanje sli\u010Dica",
                "\uD83D\uDD0D Analiziranje EXIF metapodataka",
                "\uD83C\uDFD8\uFE0F 3D prikaz",
                "\uD83D\uDCF7 Pokretanje 360\xb0slika",
                "\uD83D\uDFE0 Balansiranje boje",
                "\uD83D\uDCAF Ocjena kvalitete ra\u010Dunalstva \xa9",
                "\uD83D\uDCE1 Preuzimanje a\u017Euriranja",
                "\uD83C\uDF0D Dohva\u0107anje plo\u010Dica karte",
                "\uD83D\uDCF8 Obrada sjena"
            ],
            show_map: "Poka\u017Ei kartu",
            sequence_speed: "Brzina igra\u010Da",
            minimize: "Sakrij ovu komponentu, mo\u017Ee\u0161 je ponovno prikazati pomo\u0107u tipke u donjem lijevom kutu",
            contribute_id: "Doprinesi OpenStreetMap pomo\u0107u iD ure\u0111iva\u010Da",
            loading_labels_fun: [
                "\uD83E\uDD8C Otkrivanje znakova prijelaza jelena",
                "\uD83D\uDE98 Pretra\u017Eivanje Panoramax Car \xa9",
                "\u2615 Injekcija kofeina",
                "\uD83D\uDE00 Osmjeh, kartiran si!",
                "\uD83D\uDC08 Dijeljenje slika ma\u010Daka",
                "\uD83D\uDE34 Smanjenje odga\u0111anja",
                "\uD83E\uDED6 Kuhanje \u010Daja",
                "\uD83D\uDC27 Otvaranje izvornog koda",
                "\uD83D\uDE87 Indeksiranje stanica podzemne \u017Eeljeznice",
                "\uD83E\uDDF9 \u010Ci\u0161\u0107enje metapodataka",
                "\uD83D\uDE92 Slanje fotografija vatrogasne stanice",
                "\uD83D\uDEB2 A\u017Euriranje zelenih staza",
                "\uD83D\uDE89 Prolaz na peron stanice",
                "\uD83D\uDEF0\uFE0F Tra\u017Eenje satelita",
                "\uD83D\uDC65 Pisanje persona",
                "\uD83D\uDC1F Lociranje trgovine ribom",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Su\u010Delje za otklanjanje pogre\u0161aka",
                "\uD83D\uDCC8 Statisti\u010Dko pove\u0107anje",
                "\uD83E\uDD16 U\u010Denje zna\u010Denja",
                "\uD83C\uDFA8 Redizajn su\u010Delja",
                "\uD83D\uDCC5 Planiranje zabava foto-kartiranja",
                "\uD83E\uDDC0 Dozrijevanje cheddar sira",
                "\uD83C\uDF04 Izra\u010Dunavanje kornvalskog sunca",
                "\uD83C\uDF0A Mjerenje plime i oseke"
            ],
            error_psv: "Photo Sphere Viewer se ne u\u010Ditava ispravno",
            error_pic: "Tra\u017Eena slika nije prona\u0111ena",
            error_api: "Poslu\u017Eitelj slika nije dostupan",
            error_webgl: "Va\u0161 preglednik ne podr\u017Eava WebGL",
            error_api_compatibility: "Poslu\u017Eitelj slika nije kompatibilan s ovom verzijom preglednika",
            filter_source_world: "Cijeli svijet",
            filter_source_local: "Ovaj server",
            filter_date: "Datum",
            filter_date_1month: "1 mjesec",
            filter_date_6months: "6 mjeseci",
            filter_user: "Korisnik",
            filter_user_mypics: "Moje slike",
            filter_picture: "Tip slike",
            filter_locked: "Filter onemogu\u0107en",
            filter_zoom_in: "Pove\u0107ajte za otklju\u010Davanje",
            picture_all: "Svi",
            picture_flat: "Klasi\u010Dno",
            picture_360: "360\xb0",
            picture_360_long: "Panoramska slika",
            popup_details_link: "Vi\u0161e detalja",
            filter_qualityscore: "Ocjena kvalitete",
            filter_qualityscore_help: "Klikni da omogu\u0107i\u0161 ili onemogu\u0107i\u0161",
            qualityscore_doc_1: "Ocjena kvalitete izra\u010Dunava se za svaku sliku.",
            qualityscore_doc_2: "Rezultat je prikazan kao slovo:",
            qualityscore_doc_3: '"A" je najbolja ocjena, "E" najgora.',
            qualityscore_doc_4: "Ova se ocjena izra\u010Dunava na temelju:",
            qualityscore_doc_41: "GPS preciznost",
            qualityscore_doc_42: "rezolucija slike",
            qualityscore_doc_link: "Saznajte vi\u0161e o ocjeni kvalitete",
            filter_gps_precision: "Preciznost lokacije",
            filter_gps_precision_lessthan: "Manje od {n} metara",
            filter_gps_precision_between: "Izme\u0111u {n1} i {n2} metara",
            filter_gps_precision_morethan: "Vi\u0161e od {n} metara",
            filter_gps_precision_help: "Saznajte vi\u0161e o preciznosti lokacije",
            filter_gps_precision_help_1: "Informacije o preciznosti lokacije dostupne su za svaku sliku. To odgovara GPS preciznosti tijekom snimanja slike.",
            filter_gps_precision_help_2: "Preciznost je izra\u017Eena zvjezdicama:",
            filter_gps_precision_help_4: 'RTK GPS imat \u0107e ocjenu "5\u2B50", akcijska kamera poput GoPro Maxa ocjenu "3\u2B50", a GPS za pametni telefon u podzemnom parkingu ocjenu "1\u2B50".',
            map_background: "Pozadina",
            map_background_aerial: "Zra\u010Dni",
            map_background_streets: "Ulice",
            map_background_default: "Po\u010Detna vrijednost",
            map_theme_default: "Predefinirano",
            semantics_features_default_title: "Oznaka {nb}",
            qualityscore_doc_5: "Profesionalni ure\u0111aj imat \u0107e ocjenu A, akcijska kamera od 360\xb0 ocjenu B, a pametni telefon ocjenu izme\u0111u C i E.",
            picture_flat_long: "Klasi\u010Dna slika",
            filter_gps_precision_help_3: '"5\u2B50" je vrlo precizno (<= {p5}m), "1\u2B50" je vrlo neprecizno (> {p1}m) ili nepoznato.',
            error_nopic: "Nema dostupnih slika na datoj poziciji",
            error_josm: "JOSM ne odgovara, radi li i je li daljinsko upravljanje omogu\u0107eno?",
            filter_date_1year: "1 godina",
            map_background_more: "Vi\u0161e",
            map_theme: "Tema",
            map_theme_age: "Datum snimanja",
            map_theme_age_1: "> 3 godine",
            map_theme_age_2: "< 3 godine",
            map_theme_age_3: "\xbd - 1 godine",
            map_theme_age_4: "< 6 mjeseca",
            map_theme_type: "Tip kamere",
            map_theme_score: "Ocjena kvalitete",
            map_theme_gps: "GNSS preciznost",
            contrast: "Omogu\u0107i ve\u0107i kontrast slike",
            metadata: "Metapodaci slike",
            metadata_summary: "Sa\u017Eetak",
            metadata_general_copy_id: "Kopiraj ID",
            metadata_general_copy_picid: "Kopiraj ID slike",
            metadata_general_picid: "Slika",
            metadata_general_seqid: "Sekvenca",
            metadata_general_picid_link: "Idi na JSON opis slike",
            metadata_general_seqid_link: "Idi na JSON opis sekvence",
            metadata_general_author: "Autor",
            metadata_general_license: "Licenca",
            metadata_general_license_link: "Pogledaj puni opis licence",
            metadata_general_date: "Datum snimanja",
            metadata_general_instance: "Izvorna instanca",
            metadata_camera: "Kamera",
            metadata_camera_make: "U\u010Dini",
            metadata_camera_model: "Model",
            metadata_camera_type: "Tip",
            metadata_camera_resolution: "Rezolucija",
            metadata_camera_focal_length: "\u017Dari\u0161na udaljenost",
            metadata_location: "Pozicija",
            metadata_location_coordinates: "Koordinate (du\u017Eina, \u0161irina)",
            metadata_location_orientation: "Smjer",
            metadata_location_precision: "Preciznost pozicioniranja",
            metadata_location_copy: "Kopiraj {v}",
            metadata_location_copy_more: "Vi\u0161e opcija kopiranja koordinata",
            metadata_quality: "Kvaliteta",
            metadata_quality_help: "Saznaj vi\u0161e o ocjeni kvalitete",
            metadata_quality_score: "Globalna ocjena",
            metadata_quality_gps_score: "Rezultat pozicioniranja",
            metadata_quality_resolution_score: "Rezultat rezolucije",
            metadata_quality_missing: "nema postavljene vrijednosti na slici",
            metadata_exif: "EXIF",
            metadata_exif_name: "Oznaka",
            metadata_exif_value: "Vrijednost",
            metadata_exif_doc: "Dokumenti za EXIF oznake",
            metadata_exif_doc_title: "Posjeti Exiv2 dokumentaciju kako bi saznao sve pojedinosti o definicijama EXIF i XMP oznaka",
            semantics_title: "Oznake",
            semantics_tags: "{nb} oznake",
            semantics_features: "Zna\u010Dajke slike",
            semantics_features_none: "Na ovoj slici jo\u0161 nije nacrtano nijedno zna\u010Dajka.",
            semantics_features_subtitle: "{nb} povezana svojstva",
            semantics_annotation_tooltip: "Klikni za detalje",
            semantics_show_all_tags: "Prika\u017Ei sve oznake",
            semantics_hide_all_tags: "Sakrij sve oznake",
            semantics_key: "Klju\u010D",
            semantics_value: "Vrijednost",
            semantics_sequence_tags: "Oznaka sekvence",
            semantics_picture_tags: "Oznaka slike",
            semantics_annotation_tags: "Oznaka objekta",
            semantics_doc: "Pomo\u0107",
            semantics_doc_info1: "Daj kontekst oko slike pomo\u0107u oznaka.",
            semantics_doc_info1u1: "Mo\u017Eete ga ozna\u010Diti da je snimljen automobilom s oznakom transport=car.",
            semantics_doc_info2: "Na slici mo\u017Ee\u0161 crtati i objekte: prometne znakove, urbanu opremu... Ozna\u010Di ono \u0161to vidi\u0161 koriste\u0107i postoje\u0107e oznake. Mo\u017Ee\u0161 izraditi i vlastite ako je potrebno.",
            semantics_doc_info3: "Neki se objekti automatski otkrivaju pomo\u0107u AI: kvaliteta nije zajam\u010Dena.",
            semantics_doc_link: "Saznaj vi\u0161e o oznakama",
            semantics_key_doc: "Saznaj vi\u0161e o ovom klju\u010Du",
            semantics_value_doc: "Saznaj vi\u0161e o ovoj oznaci",
            semantics_value_show_osm: "Pogledaj na OpenStreetMap",
            semantics_qualifiers: "Kvalifikacije",
            semantics_show_annotations: "Prikaz zna\u010Dajki slike",
            semantics_hide_annotations: "Sakrij zna\u010Dajke slike",
            semantics_zero_annotations: "Na ovoj slici nema zna\u010Dajki",
            semantics_add_annotation: "Dodaj novu oznaku",
            semantics_draw_annotation: "Preko slike mo\u017Eete nacrtati objekt koji \u017Eelite dodati (nije obavezno).",
            semantics_erase_annotation: "Obri\u0161i nacrtanu zna\u010Dajku",
            semantics_delete_annotation: "Obri\u0161i ovu zna\u010Dajku",
            semantics_delete_annotation_confirm: "\u017Deli\u0161 li zaista obrisati ovu oznaku?",
            semantics_wikidata_properties: {
                P31: "instanca",
                P180: "prikazuje",
                P279: "podklasa",
                P361: "dio"
            },
            semantics_editor_error: "Sintaksa je neva\u017Ee\u0107a. Tvoje oznake mogu izgledati ovako: \nklju\u010D=vrijednost\nprefiks|klju\u010D=vrijednosti\nprefix klju\u010D[qualif_key=qualif_val]=vrijednost \n\nMaksimalna duljina klju\u010Da je 256 znakova, maksimalna duljina vrijednosti 2048 znakova.",
            semantics_editor_example: "klju\u010D=vrijednost\nprefiks|klju\u010D=vrijednost",
            semantics_copy: "Kopiraj atribute",
            semantics_edit: "Uredi atribute",
            semantics_save: "Spremi svoje promjene",
            semantics_undo: "Otka\u017Ei svoje promjene",
            semantics_send_fail: "Nije mogu\u0107e spremiti tvoje promjene, poku\u0161aj ponovno kasnije",
            semantics_login_needed: "Kako bi uredio oznake ili zna\u010Dajke slika, mora\u0161 se prijaviti na Panoramax {n} instancu. \u017Deli\u0161 li se prijaviti?",
            semantics_overlays: {
                tfsigns: "Prometni znakovi",
                features: "Sve zna\u010Dajke"
            },
            semantics_zoom_in: "Pove\u0107aj kartu kako bi vidio oznake",
            semantics_download: "Preuzimanje",
            semantics_download_title: "Preuzmi oznake",
            semantics_download_info: "Svi semanti\u010Dki podaci (tagovi) dostupni su kao otvoreni podaci. Mo\u017Ee\u0161 ih preuzeti i koristiti kako \u017Eeli\u0161.",
            semantics_download_cta: "Preuzmi otvorene podatke",
            report: "Izvje\u0161taj",
            report_nature_label: "Uzrok problema",
            report_nature: {
                "": "Izaberi prirodu problema\u2026",
                blur_missing: "Vidljivo je lice osobe ili registarska tablica automobila",
                blur_excess: "Na objektu je primjenjeno nepotrebno zamu\u0107enje",
                privacy: "Slika je snimljena s privatnog puta ili imanja",
                picture_low_quality: "Slika je lo\u0161e kvalitete",
                mislocated: "Slika je lo\u0161e pozicionirana na karti",
                copyright: "Slika kr\u0161i autorska prava",
                other: "Bilo koja druga vrsta problema",
                inappropriate: "Slika nije odgovaraju\u0107a (nepovezana, nagost...)"
            },
            report_whole_sequence: "Ovo se odnosi na cijelu sekvencu",
            report_details: "Dodatni detalji",
            report_details_placeholder: "Po \u017Eelji, mo\u017Ee\u0161 dodati pojedinosti o problemu",
            report_email: "Tvoj email",
            report_email_placeholder: "Neobavezno",
            report_submit: "Dostavi",
            report_wait: "Slanje izvje\u0161\u0107a\u2026",
            report_success: "Izvje\u0161\u0107e je uspje\u0161no poslano. Bit \u0107e pregledano \u0161to je prije mogu\u0107e.",
            report_failure: "Do\u0161lo je do pogre\u0161ke prilikom izrade izvje\u0161\u0107a: {e}. Poku\u0161aj ponovno kasnije.",
            indoor_switch: "Unutarnji prostori",
            indoor_selector_expand: "Klikni za uvid u sve dostupne razine",
            indoor_selector_shrink: "Klikni za smanjivanje",
            indoor_selector_levelup: "Idi na vi\u0161u razinu",
            indoor_selector_leveldown: "Idi na ni\u017Eu razinu",
            indoor_selector_scrollup: "Pomakni popis razina prema gore",
            indoor_selector_scrolldown: "Pomakni popis razina prema dolje",
            "visibility_logged-only": "\u010Clanovi",
            "visibility_title_logged-only": "Samo osobe s ra\u010Dunom mogu vijeti ovu sliku",
            "visibility_owner-only": "Skirveno",
            "visibility_title_owner-only": "Samo ti mo\u017Ee\u0161 vidjeti ovu sliku",
            report_auth: 'Ovaj izvje\u0161taj \u0107e biti poslan upotrebom tvog ra\u010Duna "{a}"',
            semantics_draw_invalid_annotation: "Nacrtano podru\u010Dje prelazi granice slike. Obavezno crtaj unutar vidljive slike.",
            semantics_draw_unfinished_annotation: "Nacrtano podru\u010Dje je nedovr\u0161eno. Provjeri je li podru\u010Dje dobro pozicionirano prije spremanja.",
            error_pic_load: "Slika se trenutno ne mo\u017Ee u\u010Ditati. \nMolim provjeri svoju internetsku vezu. Ako si povezan, provjeri je li slikovni ID valjan.",
            reset_contrast: "Poni\u0161ti kontrast slike",
            low_contrast: "Smanji kontrast slike",
            delete_picture: "Obri\u0161i",
            delete_picture_warn: "\u26A0\uFE0FOprez: ovo trajno bri\u0161e sliku. \nJesti li siguran da \u017Eeli\u0161 potpuno izbrisati ovu sliku?",
            delete_picture_ok: "Slika je uspje\u0161no obrisana",
            delete_picture_error: "Do\u0161lo je do pogre\u0161ke prilikom poku\u0161aja brisanja slike:\n{e}",
            semantics_empty: "Nema definiranih oznaka",
            metadata_general_title: "Naslov",
            time_travel: "Pogledaj ovo mjesto za druge datume",
            time_travel_close: "Sakrij druge datume",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kvaliteta",
            map_theme_gps_short: "Pozicija",
            map_theme_default_short: "Predefinirano",
            map_theme_default_coef: "Razina pokrivenosti",
            map_theme_default_coef_short: "Pokrivenost",
            map_theme_default_1: "Niska",
            map_theme_default_2: "Prosje\u010Dna",
            map_theme_default_3: "Dobra",
            map_theme_default_4: "Odli\u010Dna",
            widget_locked: "Opcija onemogu\u0107ena",
            sequence_play_backwards: "Pratite ovu sekvencu, unatrag",
            semantics_annotation_tooltip_close: "Klikni za poni\u0161tavanje odabira"
        },
        map: {
            thumbnail: "Sli\u010Dica lebde\u0107e slike",
            not_public: "Nije javno vidljivo",
            slow_loading: "Karta se sporo u\u010Ditava i mogla bi izgledati neispravna",
            map_data: "Karta se temelji na {m}",
            more_panoramax: "Otkrij vi\u0161e o Panoramaxu",
            loading: "U\u010Ditavanje\u2026"
        }
    },
    hu: {
        psv: {
            twoFingers: "K\xe9t ujjal navig\xe1lhat",
            ctrlZoom: "K\xf6zel\xedt\xe9s vagy t\xe1vol\xedt\xe1s: Ctrl + g\xf6rget\xe9s",
            loadError: "A panor\xe1ma nem t\xf6lthet\u0151 be"
        },
        pnx: {
            zoom: "Nagy\xedt\xe1s",
            zoomOut: "T\xe1vol\xedt\xe1s",
            zoomIn: "K\xf6zel\xedt\xe9s",
            moveUp: "Mozg\xe1s fel",
            moveDown: "Mozg\xe1s le",
            moveLeft: "Mozg\xe1s balra",
            moveRight: "Mozg\xe1s jobbra",
            moveMiddle: "N\xe9zet k\xf6z\xe9pre hoz\xe1sa",
            expand: "Nagy\xedt\xe1s",
            expand_info: "Widget megjelen\xedt\xe9se teljes oldalon",
            show_psv: "K\xe9pn\xe9zeget\u0151 megjelen\xedt\xe9se",
            show_map: "T\xe9rk\xe9p megjelen\xedt\xe9se",
            minimize: "Widget elrejt\xe9se; a bal als\xf3 sarokban l\xe9v\u0151 gombbal \xfajra megjelen\xedtheted",
            options: "Be\xe1ll\xedt\xe1sok",
            filters: "Sz\u0171r\u0151k",
            layers: "R\xe9tegek",
            share: "Megoszt\xe1s",
            search: "Keres\xe9s",
            search_empty: "Nincs tal\xe1lat",
            share_links: "Linkek",
            share_page: "Link ehhez a k\xe9phez",
            share_image: "Nagy felbont\xe1s\xfa (HD) k\xe9p",
            share_rss: "RSS h\xedrcsatorna",
            share_rss_title: "A t\xe9rk\xe9p l\xe1that\xf3 ter\xfclet\xe9n l\xe9v\u0151 \xfaj sorozatok RSS-h\xedrcsatorn\xe1ja",
            share_embed: "Be\xe1gyaz\xe1s a weboldaladon",
            share_print: "Nyomtat\xe1s",
            copy: "M\xe1sol\xe1s",
            copied: "M\xe1solva",
            error: "Ajjaj, baj van\u2026",
            error_subtitle: "Pr\xf3b\xe1lja \xfajra k\xe9s\u0151bb, vagy n\xe9zze meg a b\xf6ng\xe9sz\u0151konzolt a tov\xe1bbi r\xe9szletek\xe9rt.",
            sequence_next: "A sorozat k\xf6vetkez\u0151 k\xe9pe",
            sequence_play: "Sorozat lej\xe1tsz\xe1sa",
            sequence_pause: "Sorozatlej\xe1tsz\xe1s sz\xfcneteltet\xe9se",
            sequence_prev: "A sorozat el\u0151z\u0151 k\xe9pe",
            sequence_more: "Tov\xe1bbi lej\xe1tsz\xe1si lehet\u0151s\xe9gek",
            sequence_speed: "Lej\xe1tsz\xe1s sebess\xe9ge",
            legend_license: "Licenc: {l}",
            edit_osm: "OSM szerkeszt\xe9se",
            id: "iD",
            josm: "JOSM",
            josm_live: "JOSM automatikus szinkroniz\xe1l\xe1s\xe1nak enged\xe9lyez\xe9se k\xe9pbet\xf6lt\xe9skor",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F T\xe9rk\xe9padatok bet\xf6lt\xe9se",
                "\uD83D\uDDA5\uFE0F API lek\xe9rdez\xe9se",
                "\uD83D\uDDBC\uFE0F B\xe9lyegk\xe9pek bet\xf6lt\xe9se",
                "\uD83D\uDD0D EXIF metaadatok elemz\xe9se",
                "\uD83C\uDFD8\uFE0F 3D megjelen\xedt\xe9s",
                "\uD83D\uDCF7 360\xb0-os k\xe9pek inicializ\xe1l\xe1sa",
                "\uD83D\uDFE0 Sz\xednek kiegyenl\xedt\xe9se",
                "\uD83D\uDCAF Min\u0151s\xe9gi pontsz\xe1m kisz\xe1m\xedt\xe1sa \xa9",
                "\uD83D\uDCE1 Friss\xedt\xe9sek let\xf6lt\xe9se",
                "\uD83C\uDF0D T\xe9rk\xe9pcsemp\xe9k beszerz\xe9se",
                "\uD83D\uDCF8 \xc1rny\xe9kok feldolgoz\xe1sa"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C Vadvesz\xe9lyt jelz\u0151 t\xe1bla \xe9szlel\xe9se",
                "\uD83D\uDE98 Panoramax aut\xf3 \xa9 keres\xe9se",
                "\u2615 Koffeininjekci\xf3",
                "\uD83D\uDE00 Mosolyogj, fel lett\xe9l t\xe9rk\xe9pezve!",
                "\uD83D\uDC08 Kiscic\xe1s k\xe9pek megoszt\xe1sa",
                "\uD83D\uDE34 Halogat\xe1s cs\xf6kkent\xe9se",
                "\uD83E\uDED6 Tea megf\u0151z\xe9se",
                "\uD83D\uDC27 Forr\xe1sk\xf3d felnyit\xe1sa",
                "\uD83D\uDE87 Metr\xf3\xe1llom\xe1sok indexel\xe9se",
                "\uD83E\uDDF9 Metaadatok tisztogat\xe1sa",
                "\uD83D\uDE92 T\u0171zolt\xf3s\xe1gr\xf3l sz\xf3l\xf3 fot\xf3k bek\xfcld\xe9se",
                "\uD83D\uDEB2 Ker\xe9kp\xe1rutak friss\xedt\xe9se",
                "\uD83D\uDE89 V\xe9gigs\xe9t\xe1l\xe1s az \xe1llom\xe1s peronj\xe1n",
                "\uD83D\uDEF0\uFE0F M\u0171holdak keres\xe9se",
                "\uD83D\uDC65 Person\xe1k meg\xedr\xe1sa",
                "\uD83D\uDC1F S\xfcltkrumplikap\xf3k lokaliz\xe1l\xe1sa",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Hibakeres\xe9s az interf\xe9szben",
                "\uD83D\uDCC8 Statisztika n\xf6vel\xe9se",
                "\uD83E\uDD16 Szemantika tanul\xe1sa",
                "\uD83C\uDFA8 Interf\xe9sz \xfajratervez\xe9se",
                "\uD83D\uDCC5 Foto-mapping partik tervez\xe9se",
                "\uD83E\uDDC0 Cheddar sajt \xe9rlel\xe9se",
                "\uD83C\uDF04 A cornwalli naps\xfct\xe9s kisz\xe1m\xedt\xe1sa",
                "\uD83C\uDF0A Dag\xe1lyok m\xe9r\xe9se"
            ],
            error_psv: "A Photo Sphere Viewer (g\xf6mbpanor\xe1ma-n\xe9zeget\u0151) nem t\xf6lt\u0151dik be megfelel\u0151en",
            error_pic: "A k\xe9rt k\xe9p nem tal\xe1lhat\xf3",
            error_nopic: "Az adott helyen nem \xe9rhet\u0151 el k\xe9p",
            error_api: "A k\xe9pkiszolg\xe1l\xf3 nem \xe9rhet\u0151 el",
            error_webgl: "A WebGL nem t\xe1mogatott ebben a b\xf6ng\xe9sz\u0151ben",
            error_josm: "A JOSM nem v\xe1laszolt. Val\xf3ban fut \xe9s enged\xe9lyezve van a t\xe1vir\xe1ny\xedt\xf3?",
            error_api_compatibility: "A k\xe9pkiszolg\xe1l\xf3 nem kompatibilis a k\xe9pn\xe9zeget\u0151 ezen verzi\xf3j\xe1val",
            filter_date: "D\xe1tum szerint",
            filter_user: "Felhaszn\xe1l\xf3 szerint",
            filter_picture: "K\xe9pt\xedpus szerint",
            picture_flat: "Klasszikus",
            picture_360: "360\xb0",
            filter_camera_model: "Kameramodell szerint",
            map_background: "H\xe1tt\xe9r",
            map_background_aerial: "L\xe9gi felv\xe9tel",
            map_background_streets: "k\xe9pUtca",
            map_theme: "T\xe9ma",
            map_theme_default: "Alap\xe9rtelmezett",
            map_theme_age: "K\xe9pk\xe9sz\xedt\xe9s ideje",
            map_theme_age_1: "3 \xe9vn\xe9l r\xe9gebben",
            map_theme_age_2: "1\u20133 \xe9ve",
            map_theme_age_3: "\xbd\u20131 \xe9ve",
            map_theme_age_4: "< 6 h\xf3napja",
            map_theme_type: "Kamerat\xedpus",
            contrast: "Nagyobb k\xe9pkontraszt enged\xe9lyez\xe9se",
            metadata: "K\xe9p metaadatai",
            metadata_general_picid: "K\xe9p",
            metadata_general_seqid: "Sorozat",
            metadata_general_picid_link: "Ugr\xe1s a k\xe9p JSON le\xedr\xe1s\xe1hoz",
            metadata_general_seqid_link: "Ugr\xe1s a sorozat JSON le\xedr\xe1s\xe1hoz",
            metadata_general_author: "Szerz\u0151",
            metadata_general_license: "Licenc (enged\xe9ly)",
            metadata_general_license_link: "Ugr\xe1s a licenc teljes le\xedr\xe1s\xe1hoz",
            metadata_general_date: "K\xe9sz\xedt\xe9s d\xe1tuma",
            metadata_camera: "Kamera",
            metadata_camera_make: "Gy\xe1rt\xf3",
            metadata_camera_model: "Modell",
            metadata_camera_type: "T\xedpus",
            metadata_camera_focal_length: "Gy\xfajt\xf3t\xe1vols\xe1g",
            metadata_location: "Poz\xedci\xf3",
            metadata_location_longitude: "Hossz\xfas\xe1g",
            metadata_location_latitude: "Sz\xe9less\xe9g",
            metadata_location_orientation: "Ir\xe1ny",
            metadata_location_precision: "Helymeghat\xe1roz\xe1s pontoss\xe1ga",
            metadata_exif: "EXIF",
            metadata_exif_name: "C\xedmke",
            metadata_exif_value: "\xc9rt\xe9k",
            report: "Bejelent\xe9se",
            report_auth: "A jelent\xe9s a fi\xf3kod ({a}) felhaszn\xe1l\xe1s\xe1val lesz elk\xfcldve",
            report_nature: {
                "": "Probl\xe9ma jelleg\xe9nek kiv\xe1laszt\xe1sa\u2026",
                blur_missing: "L\xe1tszik egy szem\xe9ly arca vagy egy rendsz\xe1mt\xe1bla",
                blur_excess: "A k\xe9pen sz\xfcks\xe9gtelen\xfcl el van hom\xe1lyos\xedtva valami",
                inappropriate: "A k\xe9p nem megfelel\u0151 (irrelev\xe1ns, meztelens\xe9get jelen\xedt meg stb.)",
                privacy: "A f\xe9nyk\xe9p egy mag\xe1n\xfatvonalr\xf3l vagy mag\xe1nter\xfcletr\u0151l k\xe9sz\xfclt",
                picture_low_quality: "A k\xe9p rossz min\u0151s\xe9g\u0171",
                mislocated: "A k\xe9p gyatr\xe1n van elhelyezve a t\xe9rk\xe9pen",
                copyright: "A k\xe9p szerz\u0151i jogot s\xe9rt",
                other: "B\xe1rmilyen m\xe1s jelleg\u0171 probl\xe9ma"
            },
            report_nature_label: "Probl\xe9ma oka",
            report_details: "Tov\xe1bbi r\xe9szletek",
            filter_zoom_in: "Nagy\xedts a felold\xe1shoz",
            report_email: "E-mail-c\xedm",
            report_email_placeholder: "Nem k\xf6telez\u0151",
            report_submit: "Bek\xfcld\xe9s",
            report_success: "A jelent\xe9s sikeresen be lett k\xfcldve; a lehet\u0151 leghamarabb megvizsg\xe1ljuk.",
            report_failure: "Hiba t\xf6rt\xe9nt a jelent\xe9s l\xe9trehoz\xe1sakor: {e}. K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra.",
            search_user: "Felhaszn\xe1l\xf3n\xe9v keres\xe9se\u2026",
            search_address: "C\xedm, v\xe1ros stb. keres\xe9se\u2026",
            share_embed_docs: "Tov\xe1bbi inform\xe1ci\xf3 a be\xe1gyaz\xe1s konfigur\xe1l\xe1s\xe1r\xf3l",
            error_click: "Kattints a folytat\xe1shoz",
            error_retry: "K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb",
            legend_title: "K\xe9p adatainak megjelen\xedt\xe9se",
            report_whole_sequence: "A teljes sorozatra vonatkozik",
            report_wait: "Jelent\xe9s bek\xfcld\xe9se\u2026",
            report_details_placeholder: "Megadhatsz tov\xe1bbi r\xe9szleteket a probl\xe9m\xe1r\xf3l (nem k\xf6telez\u0151)",
            filter_qualityscore_help: "Kattints az enged\xe9lyez\xe9shez vagy a letilt\xe1shoz",
            filter_qualityscore: "Min\u0151s\xe9gi pontsz\xe1m",
            map_theme_score: "Min\u0151s\xe9gi pontsz\xe1m",
            metadata_camera_resolution: "Felbont\xe1s",
            metadata_quality: "Min\u0151s\xe9g",
            metadata_quality_help: "Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l",
            metadata_quality_score: "\xd6sszes\xedtett pontsz\xe1m",
            metadata_quality_gps_score: "Pozicion\xe1l\xe1si pontsz\xe1m",
            metadata_quality_resolution_score: "Felbont\xe1si pontsz\xe1m",
            metadata_quality_missing: "a k\xe9pben nincs megadva \xe9rt\xe9k",
            popup_details_link: "Tov\xe1bbi r\xe9szletek",
            filter_gps_precision_lessthan: "Kevesebb mint {n} m\xe9ter",
            filter_gps_precision_between: "{n1}\u2013{n2} m\xe9ter",
            filter_gps_precision_morethan: "T\xf6bb mint {n} m\xe9ter",
            contribute_id: "Az OpenStreetMap szerkeszt\xe9se az iD szerkeszt\u0151vel",
            geo_uri: "K\xfcls\u0151 alkalmaz\xe1s",
            picture_all: "\xd6sszes",
            picture_flat_long: "Hagyom\xe1nyos k\xe9p",
            picture_360_long: "Panor\xe1mak\xe9p",
            minimize_short: "Elrejt\xe9s",
            panoramax: "Panoramax",
            filter_date_1year: "1 \xe9v",
            filter_date_1month: "1 h\xf3nap",
            whats_panoramax: "A Panoramax a terepen k\xe9sz\xfclt k\xe9pek f\xf6ldrajzi adatb\xe1zisa.",
            filter_user_mypics: "Saj\xe1t k\xe9pek",
            filter_date_6months: "6 h\xf3nap",
            semantics_editor_example: "kulcs=\xe9rt\xe9k\nel\u0151tag|kulcs=\xe9rt\xe9k",
            semantics_copy: "Tulajdons\xe1gok m\xe1sol\xe1sa",
            semantics_overlays: {
                features: "Minden objektum",
                tfsigns: "Jelz\u0151t\xe1bl\xe1k"
            },
            semantics_download_title: "C\xedmk\xe9k let\xf6lt\xe9se",
            semantics_download_info: "Minden szemantikai adat (c\xedmke) ny\xedlt adatk\xe9nt \xe1ll rendelkez\xe9sre. Let\xf6ltheted \xe9s tetsz\xe9s szerint felhaszn\xe1lhatod.",
            filter_gps_precision: "Hely pontoss\xe1ga",
            qualityscore_doc_3: "A a legjobb \xe9s E a legrosszabb.",
            qualityscore_doc_1: "Minden k\xe9phez kisz\xe1m\xedtunk egy min\u0151s\xe9gi pontsz\xe1mot.",
            qualityscore_doc_2: "A pontsz\xe1m bet\u0171k\xe9nt jelenik meg:",
            map_theme_gps: "GPS pontoss\xe1ga",
            metadata_general_copy_id: "Azonos\xedt\xf3 (ID) m\xe1sol\xe1sa",
            metadata_general_instance: "Eredeti p\xe9ld\xe1ny",
            metadata_exif_doc: "EXIF-c\xedmk\xe9k dokument\xe1ci\xf3ja",
            metadata_exif_doc_title: "Az EXIF \xe9s XMP c\xedmk\xe9k defin\xedci\xf3inak teljes le\xedr\xe1sa megtal\xe1lhat\xf3 az Exiv2 dokument\xe1ci\xf3ban",
            semantics_title: "C\xedmk\xe9k",
            semantics_features: "K\xe9pen tal\xe1lhat\xf3 objektumok",
            semantics_annotation_tooltip: "Kattints a r\xe9szletekhez",
            semantics_key: "Kulcs",
            semantics_key_doc: "Tov\xe1bbi tudnival\xf3k err\u0151l a kulcsr\xf3l",
            semantics_edit: "Tulajdons\xe1gok szerkeszt\xe9se",
            semantics_save: "M\xf3dos\xedt\xe1sok ment\xe9se",
            semantics_undo: "M\xf3dos\xedt\xe1sok elvet\xe9se",
            semantics_send_fail: "Nem siker\xfclt menteni a m\xf3dos\xedt\xe1sokat; pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra",
            semantics_wikidata_properties: {
                P279: "alkateg\xf3ri\xe1ja ennek:",
                P361: "r\xe9sze ennek:",
                P31: "p\xe9ld\xe1ny:",
                P180: "ezt \xe1br\xe1zolja:"
            },
            semantics_login_needed: "A k\xe9pc\xedmk\xe9k \xe9s az objektumok szerkeszt\xe9s\xe9hez be kell jelentkezned a Panoramax {n} p\xe9ld\xe1ny\xe1ra. Be szeretn\xe9l jelentkezni?",
            semantics_zoom_in: "A c\xedmk\xe9k megtekint\xe9s\xe9hez nagy\xedtsd a t\xe9rk\xe9pet",
            semantics_download: "Let\xf6lt\xe9s",
            semantics_download_cta: "Ny\xedlt adatok let\xf6lt\xe9se",
            semantics_tags: "{nb} c\xedmk\xe9k",
            semantics_features_subtitle: "{nb} kapcsol\xf3d\xf3 tulajdons\xe1g",
            semantics_show_all_tags: "C\xedmk\xe9k megjelen\xedt\xe9se",
            semantics_hide_all_tags: "C\xedmk\xe9k elrejt\xe9se",
            semantics_value: "\xc9rt\xe9k",
            metadata_general_copy_picid: "K\xe9pazonos\xedt\xf3 (ID) m\xe1sol\xe1sa",
            semantics_doc_info1: "C\xedmk\xe9k seg\xedts\xe9g\xe9vel megadhatod a k\xe9p kontextus\xe1t.",
            metadata_summary: "\xd6sszefoglal\xe1s",
            "visibility_logged-only": "Tagok",
            "visibility_title_logged-only": "Ezt a f\xe9nyk\xe9pet csak fi\xf3kkal rendelkez\u0151 szem\xe9lyek l\xe1thatj\xe1k",
            "visibility_owner-only": "Elrejtve",
            "visibility_title_owner-only": "Ezt a k\xe9pet csak te l\xe1thatod",
            semantics_doc_info1u1: "A transport=car c\xedmk\xe9vel jel\xf6lheted, hogy aut\xf3b\xf3l k\xe9sz\xedtetted.",
            semantics_doc_info2: "A k\xe9pen t\xe1rgyakat is felrajzolhatsz: k\xf6z\xfati jelz\xe9seket, \xe9p\xedtm\xe9nyeket, m\u0171t\xe1rgyakat\u2026 Jel\xf6ld meg a l\xe1tottakat a megl\xe9v\u0151 c\xedmk\xe9kkel. Sz\xfcks\xe9g eset\xe9n saj\xe1t c\xedmk\xe9ket is l\xe9trehozhatsz.",
            semantics_zero_annotations: "Erre a k\xe9pre nem rajzoltak objektumot",
            indoor_switch: "\xc9p\xfcleten bel\xfcli terek",
            indoor_selector_expand: "Kattints a rendelkez\xe9sre \xe1ll\xf3 szintek megtekint\xe9s\xe9hez",
            indoor_selector_shrink: "Kattints a minimaliz\xe1l\xe1shoz",
            indoor_selector_levelup: "Ugr\xe1s egy szinttel feljebb",
            indoor_selector_leveldown: "Ugr\xe1s egy szinttel lejjebb",
            indoor_selector_scrollup: "Szintlista g\xf6rget\xe9se felfel\xe9",
            indoor_selector_scrolldown: "Szintlista g\xf6rget\xe9se lefel\xe9",
            semantics_editor_error: "\xc9rv\xe9nytelen a szintaxis (mondattan). A c\xedmke a k\xf6vetkez\u0151k\xe9ppen n\xe9zhet ki:\nkulcs=\xe9rt\xe9k\nel\u0151tag|kulcs=\xe9rt\xe9k\nel\u0151gat|kulcs[min\u0151s\xedt\u0151_kulcs=min\u0151s\xedt\u0151_\xe9rt\xe9k]=\xe9rt\xe9k\n\nA kulcs legfeljebb 256 karakter, az \xe9rt\xe9k pedig legfeljebb 2048 karakter hossz\xfas\xe1g\xfa lehet.",
            qualityscore_doc_link: "Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l",
            semantics_draw_annotation: "A hozz\xe1adni k\xedv\xe1nt objektumot r\xe1rajzolhatod a k\xe9pre (nem k\xf6telez\u0151).",
            semantics_delete_annotation_confirm: "T\xe9nyleg t\xf6r\xf6lni szeretn\xe9d ezt a c\xedmk\xe9t?",
            semantics_add_annotation: "\xdaj c\xedmke hozz\xe1ad\xe1sa",
            semantics_delete_annotation: "Objektum t\xf6rl\xe9se",
            filter_gps_precision_help_1: "Minden k\xe9phez tartozik egy helypontoss\xe1gi \xe9rt\xe9k. Ez megfelel annak, hogy a k\xe9p k\xe9sz\xedt\xe9sekor mekkora volt a GPS pontoss\xe1ga.",
            filter_gps_precision_help_2: "A pontoss\xe1got csillagok fejezik ki:",
            filter_gps_precision_help_4: "Egy RTK-t tartalmaz\xf3 GPS \xe9rt\xe9kel\xe9se 5\u2B50, egy GoPo Max-hoz hasonl\xf3 akci\xf3kamer\xe1\xe9 3\u2B50, egy m\xe9lygar\xe1zsban haszn\xe1lt okostelefonos GPS-\xe9 pedig 1\u2B50.",
            filter_gps_precision_help: "Tov\xe1bbi tudnival\xf3k a hely pontoss\xe1g\xe1r\xf3l",
            semantics_doc: "S\xfag\xf3",
            semantics_erase_annotation: "Rajzolt objektum kirad\xedroz\xe1sa",
            qualityscore_doc_41: "a GPS pontoss\xe1ga",
            qualityscore_doc_42: "a k\xe9p felbont\xe1sa",
            qualityscore_doc_5: "Egy professzion\xe1lis k\xe9sz\xfcl\xe9k \xe9rt\xe9ke A, egy 360\xb0-os akci\xf3kamer\xe1\xe9 B, az okostelefonok\xe9 pedig C \xe9s E k\xf6z\xf6tti.",
            qualityscore_doc_4: "A pontsz\xe1m a k\xf6vetkez\u0151kb\u0151l \xe1ll \xf6ssze:",
            metadata_location_copy: "{v} m\xe1sol\xe1sa",
            metadata_location_copy_more: "Tov\xe1bbi koordin\xe1tam\xe1sol\xe1si lehet\u0151s\xe9gek",
            semantics_hide_annotations: "K\xe9pen l\xe9v\u0151 objektumok elrejt\xe9se",
            semantics_qualifiers: "Min\u0151s\xedt\u0151k",
            semantics_picture_tags: "K\xe9p c\xedmk\xe9je",
            semantics_annotation_tags: "Objektum c\xedmk\xe9je",
            semantics_doc_info3: "Egyes objektumok automatikusan felismerhet\u0151k a mesters\xe9ges intelligencia (MI) seg\xedts\xe9g\xe9vel: a min\u0151s\xe9g nem garant\xe1lt.",
            semantics_doc_link: "Tov\xe1bbi tudnival\xf3k a c\xedmk\xe9kr\u0151l",
            semantics_sequence_tags: "Sorozat c\xedmk\xe9je",
            semantics_features_none: "Erre a k\xe9pre m\xe9g nem rajzoltak objektumot.",
            semantics_show_annotations: "K\xe9pen l\xe9v\u0151 objektumok megjelen\xedt\xe9se",
            semantics_features_default_title: "C\xedmke {nb}",
            filter_gps_precision_help_3: "5\u2B50: nagyon ponos (<= {p5} m) \xe9s 1\u2B50: nagyon pontatlan (> {p1} m) vagy ismeretlen.",
            metadata_location_coordinates: "Koordin\xe1ta (hossz\xfas\xe1g, sz\xe9less\xe9g)",
            semantics_value_doc: "Tov\xe1bbi tudnival\xf3k err\u0151l a c\xedmk\xe9r\u0151l",
            semantics_value_show_osm: "Megtekint\xe9s az OpenStreetMapen",
            low_contrast: "Alacsonyabb k\xe9pkontraszt",
            reset_contrast: "K\xe9pkontraszt alaphelyzetbe \xe1ll\xedt\xe1sa",
            metadata_general_title: "C\xedm",
            delete_picture: "T\xf6rl\xe9s",
            delete_picture_error: "Hiba t\xf6r\xe9nt, amikor megpr\xf3b\xe1ltuk t\xf6r\xf6lni a k\xe9pet:\n{e}",
            delete_picture_ok: "A k\xe9p sikeresen t\xf6rl\u0151d\xf6tt",
            filter_locked: "Sz\u0171r\u0151 letiltva",
            map_background_default: "Alap\xe9rtelmezett",
            widget_locked: "Be\xe1ll\xedt\xe1s letiltva",
            map_theme_default_coef: "Lefedetts\xe9g szintje",
            map_theme_default_2: "\xc1tlagos",
            error_pic_load: "A k\xe9p pillanatnyilag nem t\xf6lthet\u0151 be.\nEllen\u0151rizd az internetkapcsolatod. Ha csatlakozva vagy, akkor gy\u0151z\u0151dj meg arr\xf3l, hogy a k\xe9p azonos\xedt\xf3ja (ID) \xe9rv\xe9nyes.",
            filter_source_world: "Eg\xe9sz vil\xe1g",
            filter_source_local: "Ez a kiszolg\xe1l\xf3",
            semantics_empty: "Nincs meghat\xe1rozva c\xedmke",
            time_travel: "Hely megtekint\xe9se m\xe1s id\u0151pontokban",
            time_travel_close: "M\xe1s id\u0151pontok elrejt\xe9se",
            map_theme_default_short: "Alap\xe9rtelmezett",
            map_theme_age_short: "D\xe1tum",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Min\u0151s\xe9g",
            map_theme_gps_short: "Poz\xedci\xf3",
            semantics_draw_invalid_annotation: "A megrajzolt ter\xfclet kil\xf3g a k\xe9pb\u0151l. K\xe9rj\xfck, \xfcgyeljen arra, hogy a l\xe1that\xf3 k\xe9p hat\xe1rain bel\xfcl rajzoljon.",
            semantics_draw_unfinished_annotation: "A megrajzolt ter\xfclet befejezetlen. Figyeljen arra, hogy a ment\xe9s el\u0151tt a ter\xfclet megfelel\u0151en legyen elhelyezve.",
            sequence_play_backwards: "Sorozat lej\xe1tsz\xe1sa visszafel\xe9",
            map_background_more: "Tov\xe1bb",
            map_theme_default_coef_short: "Lefedetts\xe9g",
            map_theme_default_1: "Alacsony",
            map_theme_default_3: "J\xf3",
            map_theme_default_4: "Kit\u0171n\u0151",
            semantics_annotation_tooltip_close: "Kattints a kijel\xf6l\xe9s visszavon\xe1s\xe1hoz",
            delete_picture_warn: "\u26A0\uFE0F Figyelem: ezzel a k\xe9p v\xe9glegesen t\xf6rl\u0151dik.\nBiztosan szeretn\xe9d folytatni?"
        },
        map: {
            loading: "Bet\xf6lt\xe9s\u2026",
            thumbnail: "A kurzor alatti k\xe9p b\xe9lyegk\xe9pe",
            not_public: "Nem l\xe1that\xf3 nyilv\xe1nosan",
            slow_loading: "A t\xe9rk\xe9p lassan t\xf6lt\u0151dik be, \xe9s hib\xe1snak t\u0171nhet",
            more_panoramax: "Ismerd meg jobban a Panoramaxot",
            map_data: "T\xe9rk\xe9p alapja: {m}"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Tart\xf3zkod\xe1si hely megtal\xe1l\xe1sa",
            "GeolocateControl.LocationNotAvailable": "Tart\xf3zkod\xe1si hely nem \xe9rhet\u0151 el"
        }
    },
    it: {
        pnx: {
            expand: "Espandi",
            zoomOut: "Rimpicciolisci",
            zoomIn: "Ingrandisci",
            zoom: "Zoom",
            moveUp: "Muovi in alto",
            moveDown: "Muovi in basso",
            moveLeft: "Muovi a sinistra",
            moveRight: "Muovi a destra",
            expand_info: "Fai apparire il widget a schermo pieno",
            options: "Opzioni",
            filters: "Filtri",
            layers: "Livelli",
            search: "Cerca",
            search_empty: "Nessun risultato trovato",
            search_address: "Cerca un indirizzo, citt\xe0\u2026",
            search_user: "Cerca un nome utente\u2026",
            share: "Condividi",
            share_links: "Collegamenti",
            share_page: "Collegamento a questa immagine",
            share_image: "Immagine HD",
            share_embed: "Incorpora nel tuo sito web",
            share_embed_docs: "Scopri di pi\xf9 sulla configurazione della incorporazione",
            share_print: "Stampa",
            copy: "Copia",
            copied: "Copiato",
            error: "Abbiamo un problema\u2026",
            error_click: "Continuare",
            error_retry: "Riprovare pi\xf9 tardi",
            sequence_play: "Riproduci questa sequenza",
            sequence_pause: "Pausa la sequenza",
            sequence_speed: "Velocit\xe0 di riproduzione",
            legend_license: "Licenza: {l}",
            legend_title: "Mostra dettagli della foto",
            edit_osm: "Modifica OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Caricamento dei dati della mappa",
                "\uD83D\uDDA5\uFE0F Interrogazione delle API",
                "\uD83D\uDDBC\uFE0F Caricamento delle miniature",
                "\uD83D\uDD0D Analisi dei metadata EXIF",
                "\uD83C\uDFD8\uFE0F Creazione del rendering 3D",
                "\uD83D\uDCF7 Inizializzazione delle foto a 360\xb0",
                "\uD83D\uDFE0 Bilanciamento del colore",
                "\uD83D\uDCAF Calcolo del punteggio della qualit\xe0 \xa9",
                "\uD83D\uDCE1 Scaricamento degli aggiornamenti",
                "\uD83C\uDF0D Recupero dei tasselli della mappa",
                "\uD83D\uDCF8 Elaborazione delle ombre"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C Rilevazione dei cartelli di attraversamento dei cervi",
                "\uD83D\uDE98 Ricerca dell\u2019auto Panoramax \xa9",
                "\u2615 Iniezione di caffeina",
                "\uD83D\uDE00 Sorridete, siete stati mappati!",
                "\uD83D\uDC08 Condivisione delle foto di gatti",
                "\uD83D\uDE34 Riduzione della procrastinazione",
                "\uD83E\uDED6 Preparazione del t\xe8",
                "\uD83D\uDC27 Apertura del codice sorgente",
                "\uD83D\uDE87 Indicizzazione delle stazioni della metro",
                "\uD83E\uDDF9 Pulizia dei metadata",
                "\uD83D\uDE92 Invio delle foto delle stazioni dei pompieri",
                "\uD83D\uDEB2 Aggiornamento delle strade verdi",
                "\uD83D\uDE89 Passeggiata sulle banchine della stazione",
                "\uD83D\uDEF0\uFE0F Ricerca dei satelliti",
                "\uD83D\uDC65 Scrittura delle persone",
                "\uD83D\uDC1F Ricerca dei negozi di patatine fritte",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Debug dell\u2019interfaccia",
                "\uD83D\uDCC8 Incremento delle statistiche",
                "\uD83E\uDD16 Apprendimento della semantica",
                "\uD83C\uDFA8 Riprogettazione dell\u2019interfaccia",
                "\uD83D\uDCC5 Pianificazione di eventi di photo-mapping",
                "\uD83E\uDDC0 Affinamento dei formaggi",
                "\uD83C\uDF04 Calcolo della nebbia in Valpadana",
                "\uD83C\uDF0A Misurazione delle grandi maree"
            ],
            error_psv: "Il visualizzatore delle foto sferiche non si sta caricando correttamente",
            error_pic: "La foto richiesta non \xe8 stata trovata",
            error_nopic: "Nessuna foto disponibile alla posizione richiesta",
            error_api: "Il server delle foto non \xe8 disponibile",
            error_webgl: "Il tuo browser non supporta WebGL",
            error_josm: "JOSM non risponde, \xe8 in esecuzione con il controllo remoto abilitato?",
            error_api_compatibility: "Il server delle foto non \xe8 compatibile con questa versione del visualizzatore",
            filter_date: "Data",
            filter_date_1month: "1 mese",
            filter_date_1year: "1 anno",
            filter_user_mypics: "Le mie foto",
            filter_picture: "Tipo di foto",
            filter_zoom_in: "Ingrandisci per sbloccare",
            picture_flat: "Classica",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Clicca per abilitare o disabilitare",
            map_background: "Sfondo della mappa",
            map_background_aerial: "Satellite",
            map_background_streets: "Strade",
            map_theme: "Tema della mappa",
            map_theme_default: "Classica",
            map_theme_age: "Data di acquisizione",
            map_theme_score: "Punteggio della qualit\xe0",
            contrast: "Abilita un maggiore contrasto della foto",
            metadata: "Metadata della foto",
            metadata_general_picid: "Foto",
            metadata_general_picid_link: "Vai alla descrizione JSON della foto",
            metadata_general_seqid_link: "Vai alla descrizione JSON della sequenza",
            metadata_general_author: "Autore",
            metadata_general_license: "Licenza",
            metadata_general_date: "Data di acquisizione",
            metadata_camera: "Fotocamera",
            metadata_camera_make: "Costruttore",
            metadata_camera_model: "Modello",
            metadata_camera_type: "Tipo",
            metadata_camera_resolution: "Risoluzione",
            metadata_location: "Posizione",
            metadata_location_longitude: "Longitudine",
            metadata_location_latitude: "Latitudine",
            metadata_location_precision: "Precisione della posizione",
            metadata_quality: "Qualit\xe0",
            metadata_quality_score: "Punteggio globale",
            metadata_quality_gps_score: "Punteggio della posizione",
            metadata_quality_resolution_score: "Punteggio della risoluzione",
            metadata_exif: "EXIF",
            metadata_exif_name: "Attributo",
            report_auth: "Questa segnalazione verr\xe0 inviata usando la tua utenza \u201C{a}\u201D",
            report_nature_label: "Causa del problema",
            report_nature: {
                blur_excess: "\xc8 stata applicata ad un oggetto una sfocatura non necessaria",
                inappropriate: "La foto \xe8 inappropriata (non pertinente, nudo, \u2026)",
                mislocated: "La posizione della foto sulla mappa \xe8 sbagliata",
                copyright: "La foto viola il diritto d\u2019autore",
                other: "Qualsiasi altro tipo di problema",
                picture_low_quality: "La foto \xe8 di bassa qualit\xe0",
                "": "Selezione la natura del problema\u2026",
                blur_missing: "Sono visibili la faccia di una persona o la targa di un\u2019auto",
                privacy: "La foto \xe8 stata scattata da un sentiero o propriet\xe0 privata"
            },
            report_whole_sequence: "Riguarda l\u2019intera sequenza",
            report_details: "Ulteriori dettagli",
            report_email: "La tua e-mail",
            report_email_placeholder: "Facoltativo",
            report_submit: "Invia",
            report_wait: "Invio della segnalazione\u2026",
            report_failure: "\xc8 avvenuto un errore durante la creazione della segnalazione: {e}. Riprovare pi\xf9 tardi.",
            moveMiddle: "Centra la visuale",
            show_map: "Mostra la mappa",
            sequence_next: "Prossima foto nella sequenza",
            map_theme_age_1: "> 3 anni",
            map_theme_age_2: "< 3 anni",
            map_theme_age_3: "< 1 anno",
            map_theme_age_4: "< 6 meses",
            map_theme_type: "Tipo di fotocamera",
            minimize: "Nascondi il widget, puoi mostrarlo di nuovo usando il pulsante nell\u2019angolo in basso a sinistra",
            metadata_general_license_link: "Vedi la descrizione completa della licenza",
            share_rss: "Feed RSS",
            show_psv: "Mostra il visualizzatore delle foto",
            share_rss_title: "Feed RSS delle nuove sequenze nell\u2019attuale area visibile della mappa",
            sequence_prev: "Foto precedente della sequenza",
            sequence_more: "Altre opzioni di riproduzione",
            josm_live: "Abilita la sincronizzazione automatica di JOSM al caricamento delle foto",
            metadata_general_seqid: "Sequenza",
            metadata_camera_focal_length: "Lunghezza focale",
            filter_user: "Utente",
            metadata_location_orientation: "Direzione",
            filter_qualityscore: "Punteggio della qualit\xe0",
            metadata_quality_help: "Per saperne di pi\xf9 sul punteggio della qualit\xe0",
            metadata_quality_missing: "Nessun valore impostato nella foto",
            metadata_exif_value: "Valore",
            report: "Segnala",
            report_details_placeholder: "Facoltativo, puoi aggiungere dei dettagli sul problema",
            report_success: "La segnalazione \xe8 stata inviata correttamente. Non appena possibile verr\xe0 esaminata.",
            minimize_short: "Nascondi",
            qualityscore_title: "Informazioni sul punteggio della qualit\xe0",
            qualityscore_doc_1: "Un punteggio sulla qualit\xe0 viene calcolato per ogni foto.",
            qualityscore_doc_2: "Il voto viene mostrato con una lettera:",
            qualityscore_doc_link: "Nella nostra documentazione sono presenti maggiori dettagli sul calcolo del Punteggio della qualit\xe0",
            qualityscore_doc_3: "\u201CA\u201D \xe8 il punteggio pi\xf9 alto, \u201CE\u201D quello pi\xf9 basso.",
            metadata_general_instance: "Istanza di origine",
            josm: "JOSM",
            picture_flat_long: "Foto classica",
            picture_360_long: "Foto panoramica",
            metadata_summary: "Sintesi",
            metadata_general_copy_id: "Copia l\u2019ID",
            metadata_general_copy_picid: "Copia l\u2019ID della foto",
            id: "iD",
            contribute_id: "Contribuisci a OpenStreetMap con l\u2019editor iD",
            geo_uri: "App esterna",
            filter_date_6months: "6 mesi",
            picture_all: "Tutte",
            metadata_exif_doc: "Doc per gli attributi EXIF",
            metadata_exif_doc_title: "Vai alla documentazione di Exiv2 per i dettagli completi sulle definizioni degli attributi EXIF e XMP",
            semantics_value: "Valore",
            semantics_key_doc: "Per saperne di pi\xf9 su questa chiave",
            semantics_title: "Etichette",
            semantics_features: "Oggetti nella foto",
            semantics_features_none: "Non \xe8 ancora stato disegnato alcun oggetto in questa foto.",
            semantics_features_default_title: "Etichetta {nb}",
            semantics_features_subtitle: "{nb} propriet\xe0 associate",
            semantics_tags: "{nb} attributi",
            semantics_show_all_tags: "Mostra tutti gli attributi",
            semantics_hide_all_tags: "Nascondi tutti gli attributi",
            semantics_key: "Chiave",
            semantics_value_doc: "Per saperne di pi\xf9 su questa etichetta",
            semantics_wikidata_properties: {
                P361: "parte di",
                P31: "instanza di",
                P279: "sottoclasse di",
                P180: "raffigura"
            },
            semantics_hide_annotations: "Nascondi gli oggetti nella foto",
            semantics_tags_picture: "Etichette della foto",
            semantics_show_annotations: "Mostra gli oggetti nella foto",
            semantics_annotation_tooltip: "Clicca per vedere i dettagli",
            semantics_tags_picture_none: "Non \xe8 stata ancora aggiunta alcuna etichetta su questa foto.",
            semantics_qualifiers: "Qualificatori",
            metadata_location_coordinates: "Coordinate (longitudine, latitudine)",
            metadata_location_copy: "Copia {v}",
            metadata_location_copy_more: "Ulteriori opzioni per la copia delle coordinate",
            whats_panoramax: "Panoramax \xe8 la geo-commons per le foto dei territori.",
            panoramax: "Panoramax",
            semantics_zero_annotations: "Nessun elemento disegnato su questa immagine",
            semantics_hashtags: "Hashtag dell\u2019immagine",
            semantics_editor_error: "La sintassi non \xe8 valida. Le tue etichette devono avere la seguente forma:\nchiave=valore\nprefisso|chiave=valore\nprefisso|chiave[qualif_chiave=qualif_valore]=valore\n\nLa lunghezza massima di una chiave \xe8 di 256 caratteri, quella di un valore \xe8 di 2048 caratteri.",
            semantics_editor_example: "chiave=valore\nprefisso|chiave=valore",
            semantics_edit: "Modifica gli attributi",
            semantics_save: "Salva le tue modifiche",
            semantics_undo: "Annulla le tue modifiche",
            semantics_send_fail: "Non \xe8 stato possibile salvare le tue modifiche, riprova pi\xf9 tardi",
            semantics_cantsave_invalid: "Impossibile salvare le modifiche, input non valido",
            semantics_send_ok: "Le tue modifiche sono state inviate con successo",
            semantics_add_annotation: "Aggiungi una nuova etichetta",
            semantics_draw_annotation: "Puoi disegnare l\u2019oggetto che vuoi aggiungere sopra l\u2019immagine (facoltativo).",
            semantics_save_drawn_annotation: "Salva posizione",
            semantics_undo_drawn_annotation: "Annulla",
            semantics_save_drawn_annotation_incomplete: "Devi disegnare un rettangolo all\u2019interno dell\u2019immagine prima di validarlo",
            semantics_delete_annotation: "Elimina questo oggetto",
            semantics_delete_annotation_confirm: "Vuoi veramente eliminare questa etichetta?",
            filter_gps_precision: "Precisione della posizione",
            filter_gps_precision_lessthan: "Meno di {n} metri",
            filter_gps_precision_between: "Tra {n1} e {n2} metri",
            filter_gps_precision_morethan: "Pi\xf9 di {n} metri",
            filter_gps_precision_help: "Per saperne di pi\xf9 sulla precisione della posizione",
            qualityscore_doc_4: "Il punteggio \xe8 calcolato basandosi su:",
            qualityscore_doc_41: "la precisione GPS",
            qualityscore_doc_42: "la risoluzione della foto",
            qualityscore_doc_5: "Un dispositivo professionale otterr\xe0 una A, un\u2019action camera a 360\xb0 una B mentre una smartphone si attester\xe0 tra una C e una E.",
            semantics_copy: "Copia gli attributi",
            map_theme_gps: "Precisione della posizione",
            semantics_doc_info1: "Specifica il contesto di una foto utilizzando un\u2019etichetta.",
            semantics_overlays: {
                features: "Tutti gli oggetti",
                tfsigns: "Segnali stradali"
            },
            semantics_doc_info1u1: "Puoi etichettarla come scattata dall\u2019auto con l\u2019etichetta transport=car.",
            semantics_zoom_in: "Ingrandisci la mappa per vedere le etichette",
            semantics_download: "Scarica",
            semantics_download_title: "Scarica le etichette",
            semantics_download_cta: "Scarica i dati aperti",
            semantics_value_show_osm: "Vedi su OpenStreetMap",
            filter_gps_precision_help_2: "La precisione viene espressa con delle stelle:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D \xe8 molto preciso (<={p5}m), \u201C1\u2B50\u201D molto impreciso (> {p1}m) o sconosciuto.",
            filter_gps_precision_help_4: "Un GPS RTK otterr\xe0 il voto \u201C5\u2B50\u201D, un\u2019action camera come la GoPro Max il voto \u201C3\u2B50\u201D, il GPS di uno smartphone in un garage sotterraneo un voto \u201C1\u2B50\u201D.",
            semantics_doc: "Assistenza",
            semantics_picture_tags: "Etichetta della foto",
            semantics_annotation_tags: "Etichetta dell\u2019oggetto",
            semantics_doc_link: "Per saperne di pi\xf9 sulle etichette",
            semantics_doc_info3: "Alcuni oggetti vengono automaticamente rilevati con la IA: la qualit\xe0 non \xe8 garantita.",
            semantics_sequence_tags: "Etichetta della sequenza",
            popup_details_link: "Pi\xf9 dettagli",
            semantics_login_needed: "Per modificare le etichette e gli oggetti della foto devi aver effettuato l\u2019accesso alla istanza Panoramax {n}. Vuoi accedere?",
            "visibility_logged-only": "Membri",
            "visibility_owner-only": "Nascosta",
            "visibility_title_owner-only": "Solo tu puoi vedere questa immagine",
            semantics_download_info: "Tutti i dati semantici (etichette) sono disponibili come open data. Puoi scaricarli e usarli come preferisci.",
            indoor_switch: "Planimetrie",
            indoor_selector_expand: "Clicca per vedere tutti i livelli disponibili",
            indoor_selector_shrink: "Clicca per ridurre",
            indoor_selector_levelup: "Vai al livello superiore",
            indoor_selector_leveldown: "Vai al livello inferiore",
            indoor_selector_scrollup: "Scorri la lista dei livelli in alto",
            indoor_selector_scrolldown: "Scorri la lista dei livelli in basso",
            filter_gps_precision_help_1: "Una precisione della posizione \xe8 disponibile per ogni foto. Ci\xf2 corrisponde alla precisione del GPS utilizzato durante lo scatto.",
            "visibility_title_logged-only": "Solo le persone co un\u2019utenza possono vedere questa immagine",
            semantics_erase_annotation: "Elimina l\u2019elemento disegnato",
            semantics_doc_info2: "Puoi anche disegnare gli oggetti nella foto: segnali stradali, attrezzature urbane\u2026 Segna quello che vedi usano le etichette esistenti. Se necessario puoi crearne di nuove.",
            filter_source_world: "Mondo intero",
            filter_source_local: "Questo server",
            filter_locked: "Filtro disabilitato",
            map_background_default: "Predefinito",
            map_background_more: "Altri sfondi...",
            low_contrast: "Riduci il contrasto dell'immagine",
            reset_contrast: "Ripristina contrasto immagine",
            semantics_draw_unfinished_annotation: "L'area tracciata non \xe8 completa. Assicurati che l'area sia ben posizionata prima di salvare.",
            metadata_general_title: "Titolo",
            semantics_draw_invalid_annotation: "L'area disegnata supera i limiti dell'immagine. Assicurati di disegnare all'interno dell'immagine visibile.",
            delete_picture_warn: "\u26A0\uFE0F Attenzione: questo elimina l'immagine in modo permanente.\nSi vuole davvero cancellare completamente questa immagine?",
            delete_picture: "Elimina",
            delete_picture_error: "Si \xe8 verificato un errore nel tentativo di eliminare l'immagine:\n{e}",
            delete_picture_ok: "L'immagine \xe8 stata eliminata con successo",
            error_pic_load: "Impossibile caricare l'immagine al momento.\nControlla la tua connessione Internet. Se sei connesso, assicurati che l'ID dell'immagine sia valido.",
            semantics_empty: "Nessuna etichetta definita"
        },
        psv: {
            loadError: "Impossibile caricare l\u2019immagine panoramica",
            ctrlZoom: "Utilizza Ctrl + rotellina del mouse per ingrandire l\u2019immagine",
            twoFingers: "Usa due dita per spostarti"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Trova la mia posizione",
            "GeolocateControl.LocationNotAvailable": "Posizione non disponibile"
        },
        map: {
            loading: "Caricamento\u2026",
            thumbnail: "Miniatura della foto passata con il mouse",
            not_public: "Non pubblicamente visibile",
            slow_loading: "La mappa impiega troppo tempo a caricarsi e potrebbe apparire a pezzi",
            map_data: "Dati cartografici: {m}",
            more_panoramax: "Per saperne di pi\xf9 su Panoramax"
        }
    },
    ja: {
        pnx: {
            metadata_general_picid: "\u753B\u50CF\u8B58\u5225\u5B50",
            loading_labels_fun: [
                "\uD83E\uDD8C \u9E7F\u306E\u6A2A\u65AD\u6A19\u8B58\u306E\u691C\u51FA",
                "\uD83D\uDE98 Panoramax Car \xa9\u3092\u691C\u7D22",
                "\u2615 \u30AB\u30D5\u30A7\u30A4\u30F3\u306E\u6CE8\u5165",
                "\uD83D\uDE00 \u7B11\u3063\u3066\u304F\u3060\u3055\u3044\u3001\u3042\u306A\u305F\u306F\u5730\u56F3\u306B\u8F09\u3063\u3066\u3044\u307E\u3059\uFF01",
                "\uD83D\uDC08 \u732B\u306E\u5199\u771F\u3092\u5171\u6709\u3059\u308B",
                "\uD83D\uDE34 \u5148\u5EF6\u3070\u3057\u3092\u6E1B\u3089\u3059",
                "\uD83E\uDED6 \u304A\u8336\u3092\u6DF9\u308C\u308B",
                "\uD83D\uDC27 \u30BD\u30FC\u30B9\u30B3\u30FC\u30C9\u3092\u516C\u958B",
                "\uD83D\uDE87 \u5730\u4E0B\u9244\u99C5\u306E\u7D22\u5F15",
                "\uD83E\uDDF9 \u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u30AF\u30EA\u30FC\u30F3\u30A2\u30C3\u30D7",
                "\uD83D\uDE92 \u6D88\u9632\u7F72\u306E\u5199\u771F\u3092\u9001\u4FE1",
                "\uD83D\uDEB2 \u30B0\u30EA\u30FC\u30F3\u30A6\u30A7\u30A4\u30BA\u306E\u66F4\u65B0",
                "\uD83D\uDE89 \u99C5\u306E\u30DB\u30FC\u30E0\u306E\u30A6\u30A9\u30FC\u30AF\u30B9\u30EB\u30FC",
                "\uD83D\uDEF0\uFE0F \u885B\u661F\u306E\u63A2\u7D22",
                "\uD83D\uDC65 \u30DA\u30EB\u30BD\u30CA\u3092\u66F8\u304F",
                "\uD83D\uDC1F \u30C1\u30C3\u30D7\u30B7\u30E7\u30C3\u30D7\u306E\u5834\u6240",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u30C7\u30D0\u30C3\u30B0\u30A4\u30F3\u30BF\u30FC\u30D5\u30A7\u30FC\u30B9",
                "\uD83D\uDCC8 \u7D71\u8A08\u306E\u5897\u52A0"
            ],
            share_embed_docs: "\u57CB\u3081\u8FBC\u307F\u8A2D\u5B9A\u306E\u8A73\u7D30\u3092\u8AAD\u3080",
            filter_zoom_in: "\u3053\u306E\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u8868\u793A\u3059\u308B\u306B\u306F\u62E1\u5927\u3057\u3066\u304F\u3060\u3055\u3044",
            metadata_camera_type: "\u30BF\u30A4\u30D7",
            minimize: "\u3053\u306E\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u975E\u8868\u793A\u306B\u3059\u308B\u306B\u306F\u3001\u5DE6\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u4F7F\u7528\u3057\u3066\u518D\u5EA6\u8868\u793A\u3057\u307E\u3059",
            error_psv: "Photo Sphere Viewer \u304C\u6B63\u3057\u304F\u8AAD\u307F\u8FBC\u307E\u308C\u307E\u305B\u3093\u3067\u3057\u305F",
            error_josm: "JOSM \u304C\u5FDC\u7B54\u3057\u307E\u305B\u3093\u3002\u5B9F\u884C\u3055\u308C\u3066\u3044\u3066\u3001\u30EA\u30E2\u30FC\u30C8\u304C\u6709\u52B9\u306B\u306A\u3063\u3066\u3044\u307E\u3059\u304B?",
            filter_user: "\u30E6\u30FC\u30B6\u30FC",
            qualityscore_doc_3: "\u3053\u308C\u306F GPS \u306E\u7CBE\u5EA6\u3068\u753B\u50CF\u306E\u89E3\u50CF\u5EA6\u306B\u57FA\u3065\u3044\u3066\u8A08\u7B97\u3055\u308C\u307E\u3059\u3002\u30D7\u30ED\u4ED5\u69D8\u306E\u30B7\u30B9\u30C6\u30E0\u306F A \u8A55\u4FA1\u3001360\xb0 \u30A2\u30AF\u30B7\u30E7\u30F3 \u30AB\u30E1\u30E9\u306F B \u8A55\u4FA1\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u306F C/D/E \u8A55\u4FA1\u306B\u306A\u308A\u307E\u3059\u3002",
            report_nature: {
                inappropriate: "\u5199\u771F\u304C\u4E0D\u9069\u5207\u3067\u3059\uFF08\u7121\u95A2\u4FC2\u3001\u30CC\u30FC\u30C9\u306A\u3069\uFF09",
                "": "\u554F\u984C\u306E\u6027\u8CEA\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u2026",
                blur_missing: "\u4EBA\u306E\u9854\u3084\u8ECA\u306E\u30CA\u30F3\u30D0\u30FC\u30D7\u30EC\u30FC\u30C8\u304C\u898B\u3048\u308B",
                blur_excess: "\u307C\u304B\u3059\u5FC5\u8981\u306E\u306A\u3044\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u304C\u307C\u3084\u3051\u3066\u3044\u308B",
                privacy: "\u30D7\u30E9\u30A4\u30D9\u30FC\u30C8\u30D1\u30B9\u307E\u305F\u306F\u30D7\u30ED\u30D1\u30C6\u30A3\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
                picture_low_quality: "\u753B\u50CF\u306E\u54C1\u8CEA\u304C\u60AA\u3044",
                mislocated: "\u5730\u56F3\u4E0A\u306E\u5199\u771F\u306E\u4F4D\u7F6E\u304C\u9069\u5207\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
                copyright: "\u753B\u50CF\u306F\u8457\u4F5C\u6A29\u3092\u4FB5\u5BB3\u3057\u3066\u3044\u307E\u3059",
                other: "\u305D\u306E\u4ED6\u306E\u554F\u984C"
            },
            sequence_next: "\u6B21\u306E\u753B\u50CF",
            sequence_play: "\u3053\u306E\u30B7\u30FC\u30B1\u30F3\u30B9\u306B\u6CBF\u3063\u3066\u30D7\u30EC\u30A4\u3057\u3066\u304F\u3060\u3055\u3044",
            sequence_pause: "\u4E00\u6642\u505C\u6B62\u30B7\u30FC\u30B1\u30F3\u30B9",
            sequence_prev: "\u524D\u306E\u753B\u50CF",
            sequence_more: "\u3088\u308A\u591A\u304F\u306E\u30D7\u30EC\u30A4\u30AA\u30D7\u30B7\u30E7\u30F3",
            sequence_speed: "\u30D7\u30EC\u30A4\u30E4\u30FC\u306E\u30B9\u30D4\u30FC\u30C9",
            legend_license: "\u30E9\u30A4\u30BB\u30F3\u30B9: {l}",
            legend_title: "\u5199\u771F\u306E\u8A73\u7D30\u3092\u8868\u793A",
            edit_osm: "OSM\u306B\u8CA2\u732E\u3059\u308B",
            josm_live: "\u753B\u50CF\u8AAD\u307F\u8FBC\u307F\u6642\u306BJOSM\u81EA\u52D5\u540C\u671F\u3092\u6709\u52B9\u306B\u3059\u308B",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u30DE\u30C3\u30D7\u30C7\u30FC\u30BF\u306E\u8AAD\u307F\u8FBC\u307F",
                "\uD83D\uDDA5\uFE0F \u30AF\u30A8\u30EAAPI",
                "\uD83D\uDDBC\uFE0F \u30B5\u30E0\u30CD\u30A4\u30EB\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u3044\u307E\u3059",
                "\uD83D\uDD0D EXIF\u30E1\u30BF\u30C7\u30FC\u30BF\u306E\u5206\u6790",
                "\uD83C\uDFD8\uFE0F 3D\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0",
                "\uD83D\uDCF7 360\xb0\u5199\u771F\u3092\u521D\u671F\u5316\u3057\u3066\u3044\u307E\u3059",
                "\uD83D\uDFE0 \u8272\u306E\u30D0\u30E9\u30F3\u30B9",
                "\uD83D\uDCAF \u30B3\u30F3\u30D4\u30E5\u30FC\u30C6\u30A3\u30F3\u30B0\u54C1\u8CEA\u30B9\u30B3\u30A2 \xa9"
            ],
            error_pic: "\u8981\u6C42\u3055\u308C\u305F\u5199\u771F\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
            error_nopic: "\u6307\u5B9A\u3055\u308C\u305F\u4F4D\u7F6E\u306B\u306F\u753B\u50CF\u304C\u3042\u308A\u307E\u305B\u3093",
            error_api: "\u5199\u771F\u30B5\u30FC\u30D0\u30FC\u304C\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
            error_webgl: "WebGL\u306F\u30D6\u30E9\u30A6\u30B6\u3067\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
            error_api_compatibility: "\u753B\u50CF\u30B5\u30FC\u30D0\u30FC\u306F\u3053\u306E\u30D3\u30E5\u30FC\u30A2\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3068\u4E92\u63DB\u6027\u304C\u3042\u308A\u307E\u305B\u3093",
            filter_date: "\u65E5\u4ED8",
            filter_date_1month: "1\u30F6\u6708",
            filter_date_1year: "1\u5E74",
            filter_user_mypics: "\u79C1\u306E\u5199\u771F",
            filter_picture: "\u753B\u50CF\u30BF\u30A4\u30D7",
            picture_flat: "\u30AF\u30E9\u30B7\u30C3\u30AF",
            picture_360: "360\xb0",
            filter_qualityscore: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            filter_qualityscore_help: "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u6709\u52B9\u307E\u305F\u306F\u7121\u52B9\u306B\u3057\u307E\u3059",
            qualityscore_title: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066",
            qualityscore_doc_1: "Panoramax \u306F\u3001\u5404\u5199\u771F\u306B\u54C1\u8CEA\u30B9\u30B3\u30A2\u3092\u63D0\u4F9B\u3057\u307E\u3059\u3002\u3053\u308C\u306B\u3088\u308A\u3001\u5730\u56F3\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0\u304C\u7C21\u5358\u306B\u306A\u308A\u3001\u9AD8\u54C1\u8CEA\u306E\u5199\u771F\u306E\u53EF\u7528\u6027\u3092\u5305\u62EC\u7684\u306B\u8868\u793A\u3067\u304D\u307E\u3059\u3002",
            qualityscore_doc_2: "\u8A55\u4FA1\u306F A/B/C/D/E \u30B9\u30B3\u30A2 (A \u304C\u6700\u9AD8\u3001E \u304C\u6700\u4F4E) \u3068\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u306B\u8868\u793A\u3055\u308C\u3001\u6B21\u306E\u30B9\u30B1\u30FC\u30EB\u3067\u30B0\u30E9\u30D5\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
            qualityscore_doc_link: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306E\u8A08\u7B97\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u306F\u3001\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002",
            map_background: "\u5730\u56F3\u306E\u80CC\u666F",
            map_background_aerial: "\u822A\u7A7A\u5199\u771F",
            map_background_streets: "\u901A\u308A",
            map_theme: "\u30DE\u30C3\u30D7\u30C6\u30FC\u30DE",
            map_theme_default: "\u30AF\u30E9\u30B7\u30C3\u30AF",
            map_theme_age: "\u64AE\u5F71\u65E5",
            map_theme_age_1: "3\u6B73\u4EE5\u4E0A",
            map_theme_age_2: "3\u6B73\u672A\u6E80",
            map_theme_age_3: "1\u6B73\u672A\u6E80",
            map_theme_age_4: "6\u304B\u6708\u672A\u6E80",
            map_theme_type: "\u30AB\u30E1\u30E9\u30BF\u30A4\u30D7",
            map_theme_score: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            contrast: "\u3088\u308A\u9AD8\u3044\u753B\u50CF\u30B3\u30F3\u30C8\u30E9\u30B9\u30C8\u3092\u6709\u52B9\u306B\u3059\u308B",
            metadata: "\u753B\u50CF\u30E1\u30BF\u30C7\u30FC\u30BF",
            metadata_general_seqid: "\u30B7\u30FC\u30B1\u30F3\u30B9\u8B58\u5225\u5B50",
            metadata_general_picid_link: "\u753B\u50CF\u306EJSON\u8AAC\u660E\u3078\u79FB\u52D5",
            metadata_general_seqid_link: "\u30B7\u30FC\u30B1\u30F3\u30B9\u306EJSON\u8A18\u8FF0\u3078\u79FB\u52D5",
            metadata_general_author: "\u8457\u8005",
            metadata_general_license: "\u30E9\u30A4\u30BB\u30F3\u30B9",
            metadata_general_license_link: "\u30E9\u30A4\u30BB\u30F3\u30B9\u306E\u5B8C\u5168\u306A\u8AAC\u660E\u3092\u898B\u308B",
            metadata_general_date: "\u64AE\u5F71\u65E5",
            metadata_camera: "\u30AB\u30E1\u30E9",
            metadata_camera_make: "\u30E1\u30FC\u30AB\u30FC",
            metadata_camera_model: "\u30E2\u30C7\u30EB",
            metadata_camera_resolution: "\u89E3\u50CF\u5EA6",
            metadata_camera_focal_length: "\u7126\u70B9\u8DDD\u96E2",
            metadata_location: "\u4F4D\u7F6E",
            metadata_location_longitude: "\u7D4C\u5EA6",
            metadata_location_latitude: "\u7DEF\u5EA6",
            metadata_location_orientation: "\u64AE\u5F71\u65B9\u5411",
            metadata_location_precision: "\u4F4D\u7F6E\u6C7A\u3081\u7CBE\u5EA6",
            metadata_quality: "\u54C1\u8CEA\u30B9\u30B3\u30A2",
            metadata_quality_help: "\u54C1\u8CEA\u30B9\u30B3\u30A2\u306B\u3064\u3044\u3066\u8A73\u3057\u304F\u77E5\u308B",
            metadata_quality_score: "\u30B0\u30ED\u30FC\u30D0\u30EB\u30B9\u30B3\u30A2",
            metadata_quality_gps_score: "\u30DD\u30B8\u30B7\u30E7\u30CB\u30F3\u30B0\u30B9\u30B3\u30A2",
            metadata_quality_resolution_score: "\u89E3\u6C7A\u30B9\u30B3\u30A2",
            metadata_quality_missing: "\u753B\u50CF\u306B\u5024\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "\u30BF\u30B0",
            metadata_exif_value: "\u4FA1\u5024",
            report: "\u5199\u771F\u3092\u5831\u544A\u3059\u308B",
            report_auth: "\u3053\u306E\u30EC\u30DD\u30FC\u30C8\u306F\u3042\u306A\u305F\u306E\u30A2\u30AB\u30A6\u30F3\u30C8\u300C{a}\u300D\u3092\u4F7F\u7528\u3057\u3066\u9001\u4FE1\u3055\u308C\u307E\u3059",
            report_nature_label: "\u554F\u984C\u306E\u6027\u8CEA",
            report_whole_sequence: "\u3053\u308C\u306F\u30B7\u30FC\u30B1\u30F3\u30B9\u5168\u4F53\u306B\u95A2\u4FC2\u3059\u308B",
            report_details: "\u8FFD\u52A0\u306E\u8A73\u7D30",
            report_details_placeholder: "\u30AA\u30D7\u30B7\u30E7\u30F3\u3068\u3057\u3066\u3001\u554F\u984C\u306E\u8A73\u7D30\u3068\u305D\u308C\u304C\u3069\u306E\u3088\u3046\u306B\u95A2\u4FC2\u3057\u3066\u3044\u308B\u304B\u3092\u8FFD\u52A0\u3067\u304D\u307E\u3059",
            report_email: "\u3042\u306A\u305F\u306E\u30E1\u30FC\u30EB",
            report_email_placeholder: "\u30AA\u30D7\u30B7\u30E7\u30F3",
            report_submit: "\u9001\u4FE1",
            report_wait: "\u30EC\u30DD\u30FC\u30C8\u3092\u9001\u4FE1\u3057\u3066\u3044\u307E\u3059\u2026",
            report_success: "\u30EC\u30DD\u30FC\u30C8\u306F\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002\u3067\u304D\u308B\u3060\u3051\u65E9\u304F\u78BA\u8A8D\u3055\u308C\u307E\u3059\u3002",
            report_failure: "\u30EC\u30DD\u30FC\u30C8\u306E\u4F5C\u6210\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F: {e}\u3002\u3057\u3070\u3089\u304F\u3057\u3066\u304B\u3089\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
            zoom: "\u30BA\u30FC\u30E0",
            zoomOut: "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8",
            zoomIn: "\u30BA\u30FC\u30E0\u30A4\u30F3",
            moveUp: "\u4E0A\u306B\u79FB\u52D5",
            moveDown: "\u4E0B\u306B\u79FB\u52D5",
            moveLeft: "\u5DE6\u306B\u79FB\u52D5",
            moveRight: "\u53F3\u306B\u79FB\u52D5",
            moveMiddle: "\u30D3\u30E5\u30FC\u3092\u4E2D\u592E\u306B\u914D\u7F6E\u3059\u308B",
            expand: "\u62E1\u5927\u3059\u308B",
            expand_info: "\u30A6\u30A3\u30B8\u30A7\u30C3\u30C8\u3092\u5168\u30DA\u30FC\u30B8\u306B\u8868\u793A\u3059\u308B",
            show_psv: "\u753B\u50CF\u30D3\u30E5\u30FC\u30A2\u3092\u8868\u793A\u3059\u308B",
            show_map: "\u5730\u56F3\u3092\u8868\u793A",
            minimize_short: "\u96A0\u308C\u308B",
            options: "\u30AA\u30D7\u30B7\u30E7\u30F3",
            filters: "\u30D5\u30A3\u30EB\u30BF\u30FC",
            layers: "\u30EC\u30A4\u30E4\u30FC",
            search: "\u691C\u7D22",
            search_empty: "\u7D50\u679C\u306A\u3057",
            search_address: "\u4F4F\u6240\u3001\u5E02\u533A\u753A\u6751\u306A\u3069\u3092\u691C\u7D22",
            search_user: "\u30E6\u30FC\u30B6\u30FC\u540D\u3092\u691C\u7D22\u2026",
            share: "\u5171\u6709",
            share_links: "\u30EA\u30F3\u30AF",
            share_page: "\u3053\u306E\u30DA\u30FC\u30B8\u3078\u306E\u30EA\u30F3\u30AF",
            share_image: "HD\u753B\u50CF",
            share_rss: "RSS\u30D5\u30A3\u30FC\u30C9",
            share_rss_title: "\u73FE\u5728\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u30DE\u30C3\u30D7\u30A8\u30EA\u30A2\u5185\u306E\u65B0\u3057\u3044\u30B7\u30FC\u30B1\u30F3\u30B9\u306E RSS \u30D5\u30A3\u30FC\u30C9",
            share_embed: "\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u306B\u57CB\u3081\u8FBC\u3080",
            share_print: "\u5370\u5237",
            copy: "\u30B3\u30D4\u30FC",
            copied: "\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
            error: "\u554F\u984C\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u2026",
            error_click: "\u7D9A\u304F",
            error_retry: "\u5F8C\u3067\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044"
        },
        map: {
            loading: "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
            thumbnail: "\u30DB\u30D0\u30FC\u3057\u305F\u753B\u50CF\u306E\u30B5\u30E0\u30CD\u30A4\u30EB",
            not_public: "\u516C\u958B\u3055\u308C\u306A\u3044",
            slow_loading: "\u30DE\u30C3\u30D7\u306E\u8AAD\u307F\u8FBC\u307F\u304C\u9045\u304F\u3001\u58CA\u308C\u3066\u3044\u308B\u3088\u3046\u306B\u898B\u3048\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059"
        },
        psv: {
            twoFingers: "2\u672C\u306E\u6307\u3067\u79FB\u52D5\u3057\u307E\u3059",
            ctrlZoom: "Ctrl + \u30B9\u30AF\u30ED\u30FC\u30EB\u3067\u753B\u50CF\u3092\u62E1\u5927\u3057\u307E\u3059",
            loadError: "\u753B\u50CF\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u81EA\u5206\u306E\u4F4D\u7F6E\u3092\u8868\u793A",
            "GeolocateControl.LocationNotAvailable": "GPS\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093"
        }
    },
    nl: {
        pnx: {
            zoomIn: "Zoom in",
            zoom: "Zoom",
            zoomOut: "Zoom uit",
            moveDown: "Naar beneden",
            search_user: "Zoek een gebruikersnaam\u2026",
            moveUp: "Ga omhoog",
            share_rss: "RSS-feed",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Kaart aan het laden",
                "\uD83D\uDDA5\uFE0F API opvragen",
                "\uD83D\uDDBC\uFE0F Miniatuurweergaven laden",
                "\uD83D\uDD0D EXIF metadata analyseren",
                "\uD83C\uDFD8\uFE0F 3D-rendering",
                "\uD83D\uDCF7 360\xb0 afbeelden initialiseren",
                "\uD83D\uDFE0 Kleur balancering",
                "\uD83D\uDCAF Bereken kwaliteits-score \xa9",
                "\uD83D\uDCE1 Updates downloaden",
                "\uD83C\uDF0D Kaarttegels ophalen",
                "\uD83D\uDCF8 Schaduwen verwerken"
            ],
            share_embed_docs: "Lees meer over embedded instellingen",
            sequence_pause: "Pauzeer sequentie",
            sequence_prev: "Vorige afbeelding uit de sequentie",
            id: "iD",
            josm: "JOSM",
            sequence_more: "Meer afspeelmogelijkheden",
            sequence_speed: "Afspeel snelheid",
            edit_osm: "OSM aanpassen",
            moveLeft: "Naar links",
            moveRight: "Naar rechts",
            moveMiddle: "Middelpunt",
            expand: "Vergroot",
            show_psv: "Toon de afbeeldingsviewer",
            show_map: "Toon de kaart",
            options: "Opties",
            filters: "Filters",
            layers: "Lagen",
            search: "Zoek",
            search_empty: "Geen resultaat gevonden",
            search_address: "Zoek een adres, een stad \u2026",
            share: "Deel",
            share_links: "Links",
            share_page: "Link naar deze foto",
            share_image: "HD afbeelding",
            share_embed: "Embedden op uw website",
            share_print: "Afdrukken",
            copy: "Kopieer",
            copied: "Gekopieerd",
            error: "We hebben een probleem\u2026",
            sequence_next: "Volgende afbeelding van de sequentie",
            error_click: "Klik om verder te gaan",
            error_retry: "Probeer later opnieuw",
            legend_license: "Licentie: {l}",
            legend_title: "Toon gegevens van de afbeelding",
            sequence_play: "Speel deze sequentie af",
            expand_info: "De widget op de volledige pagina weergeven",
            minimize: "Verberg deze widget, je kan hem terug tonen met de knop linksonder",
            loading_labels_fun: [
                "\uD83E\uDD8C Detectie verkeersborden overstekende herten",
                "\uD83D\uDE98 Panoramax auto zoeken \xa9",
                "\u2615 Cafe\xefne-injectie",
                "\uD83D\uDE00 Gelukt, je kaart is gekaart!",
                "\uD83D\uDC08 Foto's delen van katten",
                "\uD83D\uDE34 Uitstelgedrag verminderen",
                "\uD83E\uDED6 Thee zetten",
                "\uD83D\uDC27 Broncode openen",
                "\uD83D\uDE87 Indexering metrostations",
                "\uD83E\uDDF9 Metadata opschonen",
                "\uD83D\uDE92 Foto's van brandweerkazernes versturen",
                "\uD83D\uDEB2 Fiets- en wandelpaden bijwerken",
                "\uD83D\uDE89 Perron afwandelen",
                "\uD83D\uDEF0\uFE0F Satellieten zoeken",
                "\uD83D\uDC65 Personas opslaan",
                "\uD83E\uDD5E Pannenkoekenhuizen localiseren",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Interface debuggen",
                "\uD83D\uDCC8 Statistieken verhogen",
                "\uD83E\uDD16 Semantiek aanleren",
                "\uD83C\uDFA8 Interface herontwerpen",
                "\uD83D\uDCC5 Fotomappingparty's plannen",
                "\uD83E\uDDC0 Kazen laten rijpen",
                "\uD83C\uDF04 Prachtige zonneschijn berekenen",
                "\uD83C\uDF0A Meten van het hoogwater"
            ],
            share_rss_title: "RSS-feed van nieuwe reeksen in het nu zichtbare kaartgebied",
            josm_live: "Schakel JOSM automatische synchronisatie in bij het laden van afbeeldingen",
            minimize_short: "Verbergen",
            error_psv: "Photo Sphere Viewer werd niet correct geladen",
            error_nopic: "Geen foto beschikbaar op de aangegeven locatie",
            error_api: "De fotoserver is niet beschikbaar",
            error_webgl: "WebGL wordt niet ondersteund door je browser",
            error_api_compatibility: "De fotoserver is niet compatibel met deze viewer",
            filter_date_1month: "1 maand",
            filter_date_1year: "1 jaar",
            filter_user: "Gebruiker",
            filter_user_mypics: "Mijn foto's",
            filter_picture: "Afbeeldingstype",
            picture_flat: "Klassiek",
            picture_360: "360\xb0",
            filter_qualityscore: "Kwaliteitsscore",
            qualityscore_doc_2: "The score wordt getoond als een letter:",
            qualityscore_doc_link: "Meer weten over de Kwaliteitsscore",
            map_background: "Achtergrond",
            map_background_aerial: "Satelliet",
            map_background_streets: "Straten",
            map_theme: "Thema",
            map_theme_default: "Standaard",
            map_theme_age: "Opnamedatum",
            map_theme_age_1: "> 3 jaar",
            map_theme_age_2: "< 3 jaar",
            map_theme_age_3: "\xbd - 1 jaar",
            map_theme_age_4: "< 6 maand",
            filter_qualityscore_help: "Klik om aan- of uit te schakelen",
            report_failure: "Er is een fout opgetreden bij het aanmaken van het rapport: {e}. Probleem later opnieuw.",
            map_theme_score: "Kwaliteitsscore",
            contrast: "Afbeeldingscontrast verhogen",
            metadata: "Metadata van de foto",
            metadata_camera_make: "Fabrikant",
            filter_date: "Datum",
            filter_zoom_in: "Zoom in om te bekijken",
            metadata_general_license_link: "De volledige beschrijving van de licentie bekijken",
            metadata_general_seqid: "Serie",
            metadata_general_picid_link: "Ga naar de JSON-beschrijving van de foto",
            metadata_general_seqid_link: "Ga naar de JSON-beschrijving van de sequentie",
            metadata_general_author: "Auteur",
            error_josm: "JOSM antwoordde niet, is het actief en is afstandsbediening ingeschakeld?",
            qualityscore_title: "Over de kwaliteitsscore",
            metadata_general_license: "Licentie",
            error_pic: "De gevraagde foto werd niet gevonden",
            metadata_general_picid: "Afbeelding",
            metadata_general_date: "Opnamedatum",
            map_theme_type: "Cameratype",
            qualityscore_doc_1: "Voor elke afbeelding wordt een kwaliteitsscore berekend.",
            qualityscore_doc_3: "\u201CA\u201D is het slechtst, \u201CE\u201D het best.",
            report_details_placeholder: "Je kan, optioneel, details over het probleem toevoegen",
            metadata_camera: "Apparaat",
            metadata_camera_model: "Model",
            metadata_camera_type: "Type",
            metadata_camera_resolution: "Resolutie",
            metadata_camera_focal_length: "Brandpuntsafstand",
            metadata_location: "Positie",
            metadata_location_longitude: "Longitude",
            metadata_location_latitude: "Latitude",
            metadata_location_orientation: "Richting",
            metadata_location_precision: "Nauwkeurigheid van de positionering",
            metadata_quality: "Kwaliteit",
            metadata_quality_help: "Meer weten over de Kwaliteitsscore",
            metadata_quality_score: "Globale score",
            metadata_quality_gps_score: "Positioneringsscore",
            metadata_quality_resolution_score: "Resolutiescore",
            metadata_quality_missing: "geen info in de afbeelding",
            metadata_exif: "EXIF",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Waarde",
            report: "Rapporteer",
            report_auth: 'Dit rapport zal worden verstuurd met je account "{a}"',
            report_nature_label: "Oorzaak van het probleem",
            report_nature: {
                "": "Selecteer de aard van het probleem \u2026",
                blur_missing: "Het gezicht van een persoon of een nummerplaat is zichtbaar",
                blur_excess: "Een overbodige vervaging werd toegepast op een object",
                inappropriate: "De foto is ongepast (ongerelateerd, naaktheid \u2026)",
                privacy: "De foto werd genomen vanop een privaat pad of eigendom",
                picture_low_quality: "De foto is van lage kwaliteit",
                mislocated: "De foto is slecht gepositioneerd",
                copyright: "De foto schendt het auteursrecht",
                other: "Een ander soort probleem"
            },
            report_whole_sequence: "Dit betreft de volledige sequentie",
            report_details: "Aanvullende details",
            report_email: "Je e-mail",
            report_email_placeholder: "Optioneel",
            report_submit: "Verzenden",
            report_wait: "Rapport verzenden \u2026",
            report_success: "Het rapport werd succesvol verzonden. Het zal zo snel mogelijk behandeld worden.",
            whats_panoramax: "Panoramax is de geo-commons voor foto's van gebieden.",
            contribute_id: "Bijdragen aan OpenStreetMap met de iD-editor",
            geo_uri: "Externe app",
            semantics_hide_all_tags: "Verberg alle tags",
            semantics_key: "Sleutel",
            semantics_value: "Waarde",
            semantics_key_doc: "Meer weten over deze sleutel",
            semantics_value_doc: "Meer weten over deze tag",
            semantics_title: "Tags",
            semantics_tags: "{nb} tags",
            semantics_features: "Objecten in de foto",
            semantics_features_none: "Er is nog geen object getekend in deze afbeelding.",
            semantics_features_default_title: "Tag {nb}",
            semantics_features_subtitle: "{nb} geassocieerde eigenschappen",
            semantics_show_all_tags: "Toon alle tags",
            metadata_general_instance: "Bron instance",
            semantics_annotation_tooltip: "Klik om details te zien",
            semantics_tags_picture: "Afbeelding tags",
            semantics_tags_picture_none: "Er zijn nog geen tags ingesteld voor deze afbeelding.",
            semantics_qualifiers: "Kwalificaties",
            semantics_show_annotations: "Objecten in de foto weergeven",
            semantics_hide_annotations: "Objecten in de foto verbergen",
            semantics_wikidata_properties: {
                P31: "Instance van",
                P279: "subklasse van",
                P361: "onderdeel van",
                P180: "beeldt af"
            },
            metadata_exif_doc: "Documenten voor EXIF-tags",
            metadata_exif_doc_title: "Ga naar de documentatie van Exiv2 voor alle details over de definities van EXIF- en XMP-tags",
            metadata_location_copy: "Kopieer {v}",
            metadata_location_copy_more: "Meer kopieeropties voor co\xf6rdinaten",
            metadata_general_copy_picid: "Kopieer afbeelding ID",
            filter_date_6months: "6 maanden",
            picture_360_long: "Panorama afbeelding",
            metadata_summary: "Samenvatting",
            metadata_general_copy_id: "Kopieer ID",
            picture_flat_long: "Klassieke afbeelding",
            metadata_location_coordinates: "Co\xf6rdinaten (lengtegraad, breedtegraad)",
            picture_all: "Alles",
            semantics_zero_annotations: "Geen objecten getekend in deze afbeelding",
            semantics_hashtags: "Foto-hashtags",
            panoramax: "Panoramax",
            semantics_editor_error: "De syntax is ongeldig. Je tags moeten eruit zien als:\nsleutel=waarde\nprefix|sleutel=waarde\nprefix|sleutel[qualif_sleutel=qualif_waarde]=waarde\n\nMaximale lengte van de sleutel: 256 karakters, maximale lengte van de waarde: 2048 karakters.",
            semantics_save: "Je wijzigingen opslaan",
            semantics_editor_example: "sleutel=waarde\nprefix|sleutel=waarde",
            semantics_edit: "De attributen bewerken",
            semantics_undo: "Je bewerkingen annuleren",
            semantics_send_ok: "Je bewerkingen werden succesvol verzonden",
            semantics_cantsave_invalid: "Kan wijzigingen niet opslaan, input is ongeldig",
            semantics_send_fail: "Wijzigingen opslaan mislukt, probeer later opnieuw",
            semantics_save_drawn_annotation: "Bewaar positie",
            semantics_undo_drawn_annotation: "Annuleer",
            semantics_save_drawn_annotation_incomplete: "Er moet een rechthoek getekend worden die op de afbeelding past voor validatie mogelijk is",
            semantics_delete_annotation: "Verwijder dit object",
            semantics_delete_annotation_confirm: "Ben je zeker dat je deze tag wil verwijderen?",
            semantics_add_annotation: "Voeg een nieuwe tag toe",
            semantics_draw_annotation: "Je kan het object dat je wil toevoegen tekenen over de foto (optioneel).",
            filter_gps_precision_lessthan: "Minder dan {n} meter",
            filter_gps_precision_between: "Tussen {n1} en {n2} meter",
            filter_gps_precision_morethan: "Meer dan {n} meter",
            map_theme_gps: "GPS-precisie",
            filter_gps_precision: "Locatieprecisie",
            semantics_login_needed: "Om tags of objecten te bewerken moet je inloggen op de Panoramax-instantie {n}. Wil je inloggen?",
            semantics_doc_info3: "Sommige objecten worden automatisch gedetecteerd aan de hand van AI: kwaliteit is niet gegarandeerd.",
            semantics_sequence_tags: "Sequentietag",
            semantics_picture_tags: "Fototag",
            semantics_annotation_tags: "Objecttag",
            semantics_doc_info1: "Geef context over een foto door gebruik te maken van een tag.",
            semantics_doc_info2: "Je kan eveneens objecten tekenen in de foto: verkeersborden, straatmeubilair \u2026 Geef aan wat je zien aan de hand van de bestaande tags. Je kan ook je eigen tag cre\xebren mocht dat nodig zijn.",
            semantics_doc_link: "Meer weten over tags (volledige documentatie, in het Engels)",
            semantics_doc: "Hulp",
            semantics_doc_title: "Over de tags",
            semantics_erase_annotation: "Getekend object verwijderen",
            semantics_overlays: {
                tfsigns: "Verkeersborden",
                features: "Alle objecten"
            },
            semantics_doc_info1u1: "Gebruik bijvoorbeeld de tag transport=car om aan te geven dat een foto vanuit een auto genomen werd.",
            semantics_zoom_in: "Zoom in op de kaart om tags te zien",
            semantics_download: "Downloaden",
            semantics_download_title: "Download tags",
            semantics_download_info: "Alle semantische data (tags) zijn beschikbaar als open data. Je kan ze downloaden en vrij gebruiken.",
            semantics_download_cta: "Open data downloaden",
            semantics_copy: "Attributen kopi\xebren",
            popup_details_link: "Meer details",
            "visibility_logged-only": "Leden",
            "visibility_title_logged-only": "Enkel personen met een account kunnen deze afbeelding zien",
            "visibility_owner-only": "Verborgen",
            "visibility_title_owner-only": "Enken jij kan deze afbeelding zien",
            indoor_selector_expand: "Klik om alle beschikbare niveau's te zien",
            indoor_selector_shrink: "Klik om te minimaliseren",
            indoor_selector_leveldown: "Ga een verdieping omlaag",
            indoor_selector_scrollup: "Scrol de verdiepenlijst naar boven",
            indoor_selector_scrolldown: "Scrol de verdiepenlijst naar onder",
            semantics_value_show_osm: "Bekijken op OpenStreetMap",
            filter_gps_precision_help_2: "De precisie wordt uitgedrukt aan de hand van sterren:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D is zeer precies (<= {p5}m), \u201C1\u2B50\u201D is zeer weinig precies (> {p1}m) of onbekend.",
            filter_gps_precision_help_4: "Een RTK-GPS zal een \u201C5\u2B50\u201D-score hebben, een sportieve camera (zoals een GoPro Max) een \u201C3\u2B50\u201D-score, en een smartphone in een ondergrondse parking een \u201C1\u2B50\u201D-score.",
            filter_gps_precision_help: "Meer weten over de locatieprecisie",
            filter_gps_precision_help_1: "Voor elke afbeelding is een locatieprecisiescore beschikbaar. Deze komt overeen met de GPS-precisie op het moment dat de foto werd genomen.",
            indoor_selector_levelup: "Ga een verdieping omhoog",
            indoor_switch: "Binnenruimten",
            qualityscore_doc_4: "Deze score wordt berekend op basis van:",
            qualityscore_doc_41: "de GPS-precisie",
            qualityscore_doc_42: "de resolutie van de foto",
            qualityscore_doc_5: "Een professioneel toestel zal een A-score hebben, een sportieve 360\xb0-camera een B-score, en een smartphone een score tussen C en E.",
            filter_source_world: "Volledige wereld",
            filter_source_local: "Deze server",
            filter_locked: "Filter uitgeschakeld",
            map_background_more: "Meer",
            map_background_default: "Standaard",
            error_pic_load: "De foto kan op dit moment niet geladen worden.\nKijk je internetverbinding na. Indien je verbonden bent, verifieer dan of de ID van de foto geldig is.",
            semantics_draw_invalid_annotation: "De getekende zone overschrijdt de limieten van de foto. Teken enkel binnen de zichtbare afbeelding.",
            semantics_draw_unfinished_annotation: "De getekende zone is niet afgewerkt. Zorg ervoor dat ze correct gepositioneerd is vooraleer op te slaan.",
            low_contrast: "Afbeeldingscontrast verlagen",
            reset_contrast: "Afbeeldingscontrast resetten",
            delete_picture: "Verwijderen",
            delete_picture_warn: "\u26A0\uFE0F Opgelet: dit zal de afbeelding definitief verwijderen.\nBen je zeker dat je wil doorgaan?",
            delete_picture_ok: "De foto werd succesvol verwijderd",
            delete_picture_error: "Er is een fout opgetreden bij het verwijderen van de foto:\n{e}",
            semantics_empty: "Geen tags gedefinieerd",
            metadata_general_title: "Titel",
            widget_locked: "Optie uitgeschakeld",
            map_theme_default_coef: "Dekkingsniveau",
            map_theme_default_coef_short: "Dekking",
            map_theme_default_1: "Laag",
            map_theme_default_2: "Gemiddeld",
            map_theme_default_3: "Goed",
            map_theme_default_4: "Excellent",
            time_travel: "Bekijk deze plaats op andere data",
            time_travel_close: "Andere data verbergen",
            map_theme_default_short: "Klassiek",
            map_theme_score_short: "Kwaliteit",
            map_theme_gps_short: "Positie",
            map_theme_age_short: "Datum",
            map_theme_type_short: "Camera",
            sequence_play_backwards: "Deze sequentie afspelen, achterwaards"
        },
        psv: {
            twoFingers: "Gebruik twee vingers om te navigeren",
            ctrlZoom: "Gebruik ctrl + scroll om de afbeelding in en uit te zoomen",
            loadError: "Het panorama kan niet worden geupload"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Mijn locatie zoeken",
            "GeolocateControl.LocationNotAvailable": "Locatitie niet beschikbaar"
        },
        map: {
            loading: "Laden \u2026",
            slow_loading: "De kaart laadt traag en kan er gebroken uitzien",
            thumbnail: "Thumbnail van de aangeduide foto",
            not_public: "Niet openbaar zichtbaar",
            map_data: "Kaartdata: {m}",
            more_panoramax: "Meer weten over Panoramax"
        }
    },
    pl: {
        pnx: {
            moveRight: "Przesu\u0144 w prawo",
            sequence_speed: "Pr\u0119dko\u015B\u0107 odtwarzania",
            metadata_camera_model: "Model",
            search_address: "Szukaj adres, miasto\u2026",
            zoom: "Przybli\u017Cenie",
            zoomIn: "Przybli\u017C",
            moveUp: "Przesu\u0144 w g\xf3r\u0119",
            moveDown: "Przesu\u0144 w d\xf3\u0142",
            moveLeft: "Przesu\u0144 w lewo",
            moveMiddle: "Wycentruj widok",
            expand: "Rozszerz",
            show_psv: "Poka\u017C przegl\u0105dark\u0119 zdj\u0119\u0107",
            show_map: "Poka\u017C map\u0119",
            options: "Opcje",
            filters: "Filtry",
            layers: "Warstwy",
            search: "Szukaj",
            search_empty: "Brak wynik\xf3w",
            search_user: "Szukaj nazwy u\u017Cytkownika\u2026",
            share: "Udost\u0119pnij",
            share_links: "Linki",
            share_page: "Link do tego zdj\u0119cia",
            share_rss: "Kana\u0142 RSS",
            share_print: "Drukuj",
            copy: "Kopiuj",
            copied: "Skopiowano",
            error: "Mamy problem\u2026",
            error_click: "Kliknij, aby kontynuowa\u0107",
            error_retry: "Prosz\u0119 spr\xf3buj p\xf3\u017Aniej",
            sequence_next: "Nast\u0119pne zdj\u0119cie w sekwencji",
            sequence_pause: "Spauzuj sekwencj\u0119",
            sequence_prev: "Poprzednie zdj\u0119cie w sekwencji",
            sequence_more: "Wi\u0119cej opcji odtwarzania",
            legend_license: "Licencja: {l}",
            legend_title: "Poka\u017C szczeg\xf3\u0142y zdj\u0119cia",
            edit_osm: "Edytuj OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Wczytywanie danych mapy",
                "\uD83D\uDDA5\uFE0F Odpytywanie API",
                "\uD83D\uDDBC\uFE0F Wczytywanie miniaturek",
                "\uD83D\uDD0D Analizowanie metadanych EXIF",
                "\uD83C\uDFD8\uFE0F Renderowanie 3D",
                "\uD83D\uDCF7 Inicjowanie zdj\u0119\u0107 360\xb0",
                "\uD83D\uDFE0 Balansowanie kolor\xf3w",
                "\uD83D\uDCAF Obliczanie oceny jako\u015Bci \xa9",
                "\uD83D\uDCE1 Pobieranie aktualizacji",
                "\uD83C\uDF0D Pobieranie kafelk\xf3w map",
                "\uD83D\uDCF8 Procesowanie cieniowania"
            ],
            map_theme_age_2: "< 3 lata",
            map_theme_age_1: "> 3 lata",
            map_theme_age_3: "< rok",
            map_theme_age_4: "< 6 miesi\u0105c",
            map_theme_age: "Data zrobienia",
            filter_picture: "Typ zdj\u0119cia",
            map_theme_type: "Typ aparatu",
            metadata: "Metadane zdj\u0119cia",
            metadata_general_picid: "Zdj\u0119cie",
            metadata_general_seqid: "Sekwencja",
            metadata_general_license: "Licencja",
            metadata_general_author: "Autor",
            metadata_camera: "Aparat",
            metadata_camera_type: "Typ",
            metadata_camera_resolution: "Rozdzielczo\u015B\u0107",
            metadata_location: "Pozycja",
            metadata_exif: "EXIF",
            metadata_quality_missing: "Brak warto\u015Bci ustawionej w zdj\u0119ciu",
            metadata_exif_name: "Tag",
            metadata_exif_value: "Warto\u015B\u0107",
            report: "Zg\u0142o\u015B",
            report_nature: {
                privacy: "Prywatna droga lub w\u0142asno\u015B\u0107 widoczna",
                mislocated: "Zdj\u0119cie jest s\u0142abo pozycjonowane na mapie",
                copyright: "Zdj\u0119cie narusza prawa autorskie",
                picture_low_quality: "Obraz jest niskiej jako\u015Bci",
                other: "Inny problem",
                "": "Wybierz typ problemu\u2026",
                blur_missing: "Twarz osoby lub rejestracja samochodu jest widoczna",
                blur_excess: "Niepotrzebne zamazywanie zosta\u0142o wykonane na obiekcie",
                inappropriate: "Zdj\u0119cie jest niestosowne (niezwi\u0105zane, nago\u015B\u0107\u2026)"
            },
            zoomOut: "Oddal",
            report_whole_sequence: "Dotyczy ca\u0142ej sekwencji",
            report_details: "Dodatkowe szczeg\xf3\u0142y",
            report_email: "Tw\xf3j adres email",
            report_email_placeholder: "Opcjonalne",
            report_submit: "Wy\u015Blij",
            report_wait: "Wysy\u0142anie zg\u0142oszenia\u2026",
            report_success: "Zg\u0142oszenie zosta\u0142o skutecznie wys\u0142ane. Zostanie przejrzane tak szybko jak to mo\u017Cliwe.",
            share_rss_title: "Kana\u0142 RSS nowych sekwencji na widocznym obszarze mapy",
            loading_labels_fun: [
                "\uD83E\uDD8C Wykrywanie znak\xf3w przechodzenia jeleni",
                "\uD83D\uDE98Szukanie Panoramax Car \xa9",
                "\u2615 Wstrzykiwanie kofeiny",
                "\uD83D\uDE00 U\u015Bmiechnij si\u0119, jeste\u015B mapowany!",
                "\uD83D\uDC08 Udost\u0119pnianie zdj\u0119\u0107 kot\xf3w",
                "\uD83D\uDE34 Zmniejszanie prokrastynacji",
                "\uD83E\uDED6 Parzenie herbaty",
                "\uD83D\uDC27 Otwieranie kodu \u017Ar\xf3d\u0142owego",
                "\uD83D\uDE87 Indeksowanie stacji metra",
                "\uD83E\uDDF9 Czyszczenie metadanych",
                "\uD83D\uDE92 Przesy\u0142anie zdj\u0119\u0107 remiz",
                "\uD83D\uDEB2 Aktualizacja zielonych szlak\xf3w",
                "\uD83D\uDE89 Przechodzenie peron\xf3w stacji",
                "\uD83D\uDEF0\uFE0F Wyszukiwanie satelit",
                "\uD83D\uDC65 Wypisywanie os\xf3b",
                "\uD83D\uDC1F Szukanie sklep\xf3w z frytkami i ryb\u0105",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Interfejs debugowania",
                "\uD83D\uDCC8 Zwi\u0119kszanie statystyk",
                "\uD83E\uDD16 Semantyka uczenia",
                "\uD83C\uDFA8 Przeprojektowywanie interfejsu",
                "\uD83D\uDCC5 Planowanie element\xf3w mapowania zdj\u0119\u0107",
                "\uD83E\uDDC0 Dojrzewanie ser\xf3w",
                "\uD83C\uDF04 Obliczanie Kornwalijskiego blasku",
                "\uD83C\uDF0A Mierzenie przyp\u0142yw\xf3w"
            ],
            share_embed_docs: "Przeczytaj wi\u0119cej o konfiguracji osadzenia",
            sequence_play: "Odtw\xf3rz t\u0119 sekwencj\u0119",
            josm_live: "W\u0142\u0105cz automatyczn\u0105 synchronizacj\u0119 JOSM przy \u0142adowaniu zdj\u0119\u0107",
            error_api: "Serwer zdj\u0119\u0107 nie jest dost\u0119pny",
            error_webgl: "WebGL nie jest obs\u0142ugiwany przez t\u0119 przegl\u0105dark\u0119",
            error_api_compatibility: "Serwer zdj\u0119\u0107 nie jest kompatybilny z t\u0105 wersj\u0105 przegl\u0105darki",
            filter_date: "Data",
            filter_date_1month: "1 miesi\u0105c",
            filter_date_1year: "1 rok",
            filter_user: "U\u017Cytkownik",
            filter_user_mypics: "Moje zdj\u0119cia",
            filter_zoom_in: "Przybli\u017C, aby odblokowa\u0107",
            picture_flat: "Klasyczne",
            picture_360: "360\xb0",
            filter_qualityscore: "Ocena jako\u015Bci",
            map_background: "Podk\u0142ad mapowy",
            map_background_aerial: "Zdj\u0119cia lotnicze",
            map_background_streets: "Ulice",
            map_theme: "Motyw mapy",
            map_theme_default: "Klasyczny",
            map_theme_score: "Ocena jako\u015Bci",
            contrast: "W\u0142\u0105cz wy\u017Cszy kontrast zdj\u0119cia",
            metadata_general_picid_link: "Id\u017A do opisu zdj\u0119cia w JSON",
            metadata_general_seqid_link: "Id\u017A do opisu sekwencji w JSON",
            metadata_general_license_link: "Id\u017A do strony z pelnym opisem licencji",
            metadata_general_date: "Data zrobienia",
            metadata_camera_make: "Marka",
            metadata_camera_focal_length: "Ogniskowa",
            metadata_location_longitude: "D\u0142ugo\u015B\u0107 geograficzna",
            metadata_location_latitude: "Szeroko\u015B\u0107 geograficzna",
            metadata_location_orientation: "Kierunek",
            metadata_location_precision: "Precyzja lokalizacji",
            metadata_quality: "Jako\u015B\u0107",
            metadata_quality_help: "Dowiedz si\u0119 wi\u0119cej o ocenie jako\u015Bci",
            metadata_quality_score: "Ocena globalna",
            metadata_quality_gps_score: "Ocena pozycji",
            metadata_quality_resolution_score: "Ocena rozdzielczo\u015Bci",
            report_auth: 'To zg\u0142oszenie b\u0119dzie wys\u0142anie przy pomocy Twojego konta "{a}"',
            report_nature_label: "Przyczyna problemu",
            report_details_placeholder: "Opcjonalnie, mo\u017Cesz doda\u0107 szczeg\xf3\u0142y o problemie",
            report_failure: "B\u0142\u0105d wyst\u0105pi\u0142 podczas tworzenia zg\u0142oszenia: {e}. Prosz\u0119 spr\xf3buj ponownie.",
            filter_qualityscore_help: "Kliknij, aby w\u0142\u0105czy\u0107 lub wy\u0142\u0105czy\u0107",
            error_josm: "JOSM nie odpowiada, czy jest uruchomiony i czy dost\u0119p zdalny jest w\u0142\u0105czony?",
            expand_info: "Wy\u015Bwietl wid\u017Cet na ca\u0142ej stronie",
            filter_gps_precision_help_1: "Informacja o dok\u0142adno\u015Bci lokalizacji jest dost\u0119pna dla ka\u017Cdego zdj\u0119cia. Wi\u0105\u017Ce si\u0119 to z dok\u0142adno\u015Bci\u0105 GPS podczas robienia zdj\u0119\u0107.",
            popup_details_link: "Wi\u0119cej szczeg\xf3\u0142\xf3w",
            semantics_features_default_title: "Tag {nb}",
            qualityscore_doc_5: "Profesjonalne urz\u0105dzenie b\u0119dzie mia\u0142o rang\u0119 A, kamera sportowa 360\xb0 rang\u0119 B, a smartfon rang\u0119 mi\u0119dzy C i E.",
            filter_gps_precision: "Dok\u0142adno\u015B\u0107 lokalizacji",
            metadata_general_copy_picid: "Kopiuj ID zdj\u0119cia",
            filter_gps_precision_between: "Mi\u0119dzy {n1} a {n2} metr\xf3w",
            filter_gps_precision_morethan: "Wi\u0119cej ni\u017C {n} metr\xf3w",
            filter_gps_precision_lessthan: "Mniej ni\u017C {n} metr\xf3w",
            metadata_general_copy_id: "Kopiuj ID",
            metadata_general_instance: "Instancja \u017Ar\xf3d\u0142owa",
            semantics_doc_info1: "Nadaj kontekst zdj\u0119ciu u\u017Cywaj\u0105c tag\xf3w.",
            metadata_summary: "Podsumowanie",
            metadata_exif_doc: "Dokumentacja do tag\xf3w EXIF",
            metadata_exif_doc_title: "Id\u017A do dokumentacji Exiv2 aby pozna\u0107 pe\u0142ne szczeg\xf3\u0142y definicji tagowania EXIF i XMP",
            metadata_location_copy: "Kopia {v}",
            metadata_location_coordinates: "Koordynaty (d\u0142ugo\u015B\u0107, szeroko\u015B\u0107)",
            filter_locked: "Filtr wy\u0142\u0105czony",
            map_theme_gps: "Dok\u0142adno\u015B\u0107 lokalizacji",
            error_pic: "\u017B\u0105dane zdj\u0119cie nie zosta\u0142o znalezione",
            error_psv: "Przegl\u0105darka fotosfery nie \u0142aduje si\u0119 poprawnie",
            semantics_key: "Klucz",
            semantics_features_none: "Nie zapisano jeszcze \u017Cadnych funkcji w tym obrazie.",
            semantics_value: "Warto\u015B\u0107",
            whats_panoramax: "Panoramax jest geograficzn\u0105 wsp\xf3lnot\u0105 dla zdj\u0119\u0107 terenu.",
            panoramax: "Panoramax",
            error_nopic: "Nie ma dost\u0119pnych zdj\u0119\u0107 w podanej pozycji",
            picture_360_long: "Panoramiczne zdj\u0119cie",
            qualityscore_doc_2: "Ranking jest pokazywany jako litera:",
            qualityscore_doc_1: "Ranking jako\u015Bci jest wyliczany dla ka\u017Cdego zdj\u0119cia.",
            minimize_short: "Ukryj",
            minimize: "Ukryj ten wid\u017Cet, mo\u017Cesz go znowu pokaza\u0107 u\u017Cywaj\u0105c przycisku w dolnym lewym rogu",
            share_image: "Obraz wysokiej jako\u015Bci",
            semantics_doc_info1u1: "Mo\u017Cesz oznaczy\u0107 to jako zrobione z samochodu u\u017Cywaj\u0105c znacznika transport=car.",
            share_embed: "Osad\u017A na swojej stronie",
            id: "iD",
            filter_date_6months: "6 miesi\u0119cy",
            picture_all: "Wszystko",
            map_background_default: "Domy\u015Blne",
            map_background_more: "Inne t\u0142a...",
            metadata_location_copy_more: "Wi\u0119cej opcji kopiowania wsp\xf3\u0142rz\u0119dnych",
            semantics_title: "Tagi",
            semantics_tags: "{nb} tagi",
            semantics_features: "Funkcje obrazu",
            semantics_features_subtitle: "{nb} powi\u0105zane w\u0142a\u015Bciwo\u015Bci",
            semantics_annotation_tooltip: "Kliknij by pozna\u0107 szczeg\xf3\u0142y",
            semantics_show_all_tags: "Poka\u017C wszystkie tagi",
            semantics_hide_all_tags: "Ukryj wszystkie tagi",
            semantics_sequence_tags: "Znacznik sekwencji",
            semantics_picture_tags: "Znacznik obrazu",
            semantics_annotation_tags: "Znacznik obiektu",
            contribute_id: "Wsp\xf3\u0142tw\xf3rz OpenStreetMap u\u017Cywaj\u0105c edytora iD",
            geo_uri: "Aplikacja zewn\u0119trzna",
            josm: "JOSM",
            picture_flat_long: "Klasyczne zdj\u0119cie",
            semantics_doc: "Pomoc",
            filter_gps_precision_help: "Dowiedz si\u0119 wi\u0119cej o dok\u0142adno\u015Bci lokalizacji",
            filter_gps_precision_help_2: "Precyzja jest wyra\u017Cana za pomoc\u0105 gwiazdek:",
            qualityscore_doc_41: "Precyzj\u0119 GPS",
            qualityscore_doc_42: "rozdzielczo\u015B\u0107 zdj\u0119cia",
            qualityscore_doc_4: "Ten ranking jest wyliczony w oparciu o:",
            filter_source_world: "Ca\u0142y \u015Bwiat",
            filter_source_local: "Ten serwer",
            qualityscore_doc_3: '"A" to najlepsza jako\u015B\u0107, "E" najgorsza.',
            qualityscore_doc_link: "Dowiedz si\u0119 wi\u0119cej o Rankingu Jako\u015Bci",
            filter_gps_precision_help_3: '"5\u2B50" jest bardzo dok\u0142adne (<= {p5}m), "1\u2B50" jest bardzo niedok\u0142adne (> {p1}m) lub nieznane.',
            filter_gps_precision_help_4: 'RTK GPS b\u0119dzie mia\u0142 "5\u2B50" klas\u0119, kamera sportowa jak GoPro Max "3\u2B50" klas\u0119, a GPS w smartfonie na parkingu podziemnym "1\u2B50" klas\u0119.',
            semantics_copy: "Skopiuj atrybuty",
            semantics_draw_unfinished_annotation: "Obszar rysowania jest nie sko\u0144czony. Upewnij si\u0119 \u017Ce obszar jest dobrze spozycjonowany przed zapisaniem.",
            semantics_draw_invalid_annotation: "Obszar rysowania przekracza ograniczenia zdj\u0119cia. Upewnij si\u0119, \u017Ce rysujesz w widocznym obszarze zdj\u0119cia.",
            semantics_editor_example: "klucz=warto\u015B\u0107\nprefix|klucz=warto\u015B\u0107",
            semantics_download: "Pobierz",
            semantics_doc_info3: "Niekt\xf3re obiekty s\u0105 automatycznie wykrywane przez AI: jako\u015B\u0107 nie jest gwarantowana.",
            semantics_wikidata_properties: {
                P31: "instancja",
                P279: "podklasa",
                P180: "przedstawia",
                P361: "cz\u0119\u015B\u0107"
            },
            semantics_login_needed: "Aby edytowa\u0107 znaczniki lub cechy zdj\u0119cia, musisz zalogowa\u0107 si\u0119 w instancji {n} Panoramax. Chcesz si\u0119 zalogowa\u0107?",
            semantics_doc_info2: "Mo\u017Cesz wybiera\u0107 obiekty na zdj\u0119ciu takie jak: znaki drogowe, miejskie wyposa\u017Cenie... Oznacz co widzisz u\u017Cywaj\u0105c istniej\u0105cych znacznik\xf3w. Mo\u017Cesz utworzy\u0107 w\u0142asne je\u015Bli to potrzebne.",
            semantics_zero_annotations: "Nie wybrano cech tego zdj\u0119cia",
            semantics_doc_link: "Dowiedz si\u0119 wi\u0119cej o znacznikach",
            semantics_value_doc: "Dowiedz si\u0119 wi\u0119cej o tym znaczniku",
            semantics_qualifiers: "Kwalifikacje",
            semantics_show_annotations: "Wy\u015Bwietl cechy zdj\u0119cia",
            semantics_hide_annotations: "Ukryj cechy zdj\u0119cia",
            semantics_delete_annotation: "Skasuj ten element",
            semantics_delete_annotation_confirm: "Naprawd\u0119 chcesz skasowa\u0107 ten znacznik?",
            semantics_send_fail: "Nie mo\u017Cna zapisa\u0107 twoich zmian, prosz\u0119 spr\xf3buj ponownie p\xf3\u017Aniej",
            semantics_overlays: {
                features: "Wszystkie cechy",
                tfsigns: "Znaki drogowe"
            },
            semantics_editor_error: "Sk\u0142adnia nieprawid\u0142owa. Twoje znaczniki mog\u0105 wygl\u0105da\u0107 jak:\nklucz=warto\u015B\u0107\nprefix|klucz=warto\u015B\u0107\nprefix|klucz[qualif_key=qualif_val]=warto\u015B\u0107\n\nMaksymalna d\u0142ugo\u015B\u0107 klucza to 256 znak\xf3w, maksymalna d\u0142ugo\u015B\u0107 warto\u015Bci to 2048 znak\xf3w.",
            semantics_undo: "Anuluj swoje edycje",
            semantics_value_show_osm: "Zobacz na OpenStreetMap",
            semantics_draw_annotation: "Mo\u017Cesz wybra\u0107 obiekty kt\xf3re chcesz doda\u0107 do zdj\u0119cia (Opcjonalne).",
            semantics_add_annotation: "Dodaj nowy znacznik",
            semantics_key_doc: "Dowiedz si\u0119 wi\u0119cej o tym kluczu",
            semantics_erase_annotation: "Wyma\u017C narysowany element",
            semantics_edit: "Edytuj atrybuty",
            semantics_save: "Zapisz swoje zmiany",
            semantics_zoom_in: "Przybli\u017C map\u0119 by zobaczy\u0107 znaczniki",
            semantics_download_title: "Pobierz znaczniki",
            indoor_selector_levelup: "Id\u017A na wy\u017Cszy poziom",
            indoor_selector_scrollup: "Przewi\u0144 list\u0119 poziom\xf3w w g\xf3r\u0119",
            indoor_selector_scrolldown: "Przewi\u0144 list\u0119 poziom\xf3w w d\xf3\u0142",
            "visibility_owner-only": "Ukryte",
            "visibility_logged-only": "Cz\u0142onkowie",
            "visibility_title_logged-only": "Tylko osoby z kontem mog\u0105 zobaczy\u0107 to zdj\u0119cie",
            "visibility_title_owner-only": "Tylko ty mo\u017Cesz zobaczy\u0107 to zdj\u0119cie",
            indoor_switch: "Mapy wn\u0119trz",
            indoor_selector_shrink: "Kliknij by zminimalizowa\u0107",
            indoor_selector_expand: "Kliknij, by zobaczy\u0107 wszystkie dost\u0119pne poziomy",
            semantics_download_info: "Wszystkie dane semantyczne (znaczniki) s\u0105 dost\u0119pne jako otwarte dane. Mo\u017Cesz je pobra\u0107 i u\u017Cywa\u0107 jak lubisz.",
            indoor_selector_leveldown: "Id\u017A na ni\u017Cszy poziom",
            semantics_download_cta: "Pobierz otwarte dane"
        },
        psv: {
            twoFingers: "U\u017Cyj dw\xf3ch palc\xf3w do nawigacji",
            ctrlZoom: "U\u017Cyj ctrl + rolka myszy, aby powi\u0119kszy\u0107 zdj\u0119cie",
            loadError: "Panorama nie mo\u017Ce by\u0107 za\u0142adowana"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Znajd\u017A moj\u0105 lokalizacj\u0119",
            "GeolocateControl.LocationNotAvailable": "Lokalizacja niedost\u0119pna"
        },
        map: {
            thumbnail: "Miniaturki najechanego zdj\u0119cia",
            not_public: "Niewidoczne publicznie",
            slow_loading: "Mapa \u0142aduje si\u0119 wolno i mo\u017Ce si\u0119 wydawaj popsuta",
            loading: "\u0141adowanie\u2026",
            map_data: "Mapa na podstawie {m}",
            more_panoramax: "Odkryj wi\u0119cej o Panoramax"
        }
    },
    pt: {
        psv: {
            ctrlZoom: "Use ctrl + rolagem para ampliar a imagem",
            loadError: "O panorama n\xe3o pode ser carregado",
            twoFingers: "Use dois dedos para navegar"
        },
        pnx: {
            search_user: "Pesquisar um nome de utilizador\u2026",
            legend_license: "Licen\xe7a: {l}",
            map_background: "Fundo do mapa",
            semantics_features: "Caracter\xedsticas da imagem",
            show_map: "Exibir o mapa",
            minimize: "Ocultar este widget, pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo",
            share_image: "Imagem HD",
            error_retry: "Por favor, tente novamente mais tarde",
            picture_flat_long: "Imagem cl\xe1ssica",
            report_success: "O relat\xf3rio foi enviado com sucesso. Ser\xe1 analisado assim que poss\xedvel.",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Carregando dados do mapa",
                "\uD83D\uDDA5\uFE0F Consultando a API",
                "\uD83D\uDDBC\uFE0F Carregando miniaturas",
                "\uD83D\uDD0D Analisando os metadados EXIF",
                "\uD83C\uDFD8\uFE0F Renderiza\xe7\xe3o 3D",
                "\uD83D\uDCF7 Inicializando imagens em 360\xb0",
                "\uD83D\uDFE0 Ajuste de cores",
                "\uD83D\uDCAF Computando o Quality Score \xa9",
                "\uD83D\uDCE1 Transferindo atualiza\xe7\xf5es",
                "\uD83C\uDF0D Buscando blocos de mapa",
                "\uD83D\uDCF8 Processando sombras"
            ],
            loading_labels_fun: [
                "\uD83D\uDC17 Detetando placas de passagem de javalis",
                "\uD83D\uDE98 Pesquisando Panoramax Car \xa9",
                "\u2615 Injetando cafe\xedna",
                "\uD83D\uDE00 Sorria, est\xe1 a ser mapeado!",
                "\uD83D\uDC08 Partilhando fotos de gatos",
                "\uD83D\uDE34 Reduzindo a procrastina\xe7\xe3o",
                "\uD83E\uDED6 Preparando um ch\xe1",
                "\uD83D\uDC27 Abrindo o c\xf3digo-fonte",
                "\uD83D\uDE87 Indexando esta\xe7\xf5es de el\xe9trico",
                "\uD83E\uDDF9 Limpeza de metadados",
                "\uD83D\uDE92 Enviando fotos do quartel dos bombeiros",
                "\uD83D\uDEB2 Atualiza\xe7\xe3o das ciclovias",
                "\uD83D\uDE89 Passeio pela plataforma da esta\xe7\xe3o",
                "\uD83D\uDEF0\uFE0F Pesquisando sat\xe9lites",
                "\uD83D\uDE8B Mapeando Lisboa de el\xe9trico",
                "\uD83C\uDF5F Procurando lanchonetes",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando a interface",
                "\uD83D\uDCC8 Aumentando as estat\xedsticas",
                "\uD83D\uDEA2 Procurando portos em Porto",
                "\uD83C\uDFA8 Redesenho da interface",
                "\uD83C\uDFC4\u200D\u2640\uFE0F Mapeando e surfando nas ondas em Peniche",
                "\uD83E\uDDC0 Maturando os queijos",
                "\uD83C\uDF04 Calculando a insola\xe7\xe3o em Tavira",
                "\uD83C\uDF0A Medindo as mar\xe9s altas"
            ],
            error_psv: "O Photo Sphere Viewer n\xe3o est\xe1 a carregar corretamente",
            error_api: "O servidor de imagens n\xe3o est\xe1 dispon\xedvel",
            metadata_quality_resolution_score: "Pontua\xe7\xe3o de resolu\xe7\xe3o",
            semantics_doc: "Ajuda",
            map_theme_score: "Pontua\xe7\xe3o de qualidade",
            metadata_general_picid_link: "Ir para a descri\xe7\xe3o JSON da imagem",
            metadata_general_seqid_link: "Ir para a descri\xe7\xe3o JSON da sequ\xeancia",
            metadata_quality_help: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.",
            sequence_pause: "Pausar sequ\xeancia",
            contribute_id: "Contribua para o OpenStreetMap com o editor iD",
            josm_live: "Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens",
            zoom: "Zoom",
            zoomOut: "Diminuir o zoom",
            zoomIn: "Ampliar o zoom",
            moveUp: "Mover para cima",
            moveDown: "Mover para baixo",
            moveLeft: "Mover para a esquerda",
            moveMiddle: "Centralizar a vista",
            expand: "Expandir",
            expand_info: "Fazer com que o widget apare\xe7a em p\xe1gina inteira",
            show_psv: "Exibir o visualizador de imagens",
            minimize_short: "Ocultar",
            options: "Op\xe7\xf5es",
            filters: "Filtros",
            layers: "Camadas",
            search: "Pesquisa",
            search_empty: "Nenhum resultado encontrado",
            search_address: "Pesquisar um endere\xe7o, cidade\u2026",
            share: "Partilhar",
            share_links: "Links",
            share_page: "Link para esta foto",
            share_rss: "Feed RSS",
            share_embed: "Incorporar no seu site",
            share_embed_docs: "Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o",
            share_print: "Imprimir",
            copy: "Copiar",
            copied: "Copiado",
            error: "Temos um problema\u2026",
            error_click: "Continuar",
            sequence_next: "Pr\xf3xima imagem na sequ\xeancia",
            sequence_play: "Reproduzir esta sequ\xeancia",
            sequence_prev: "Imagem anterior na sequ\xeancia",
            sequence_more: "Mais op\xe7\xf5es de reprodu\xe7\xe3o",
            sequence_speed: "Velocidade de reprodu\xe7\xe3o",
            legend_title: "Exibir detalhes da imagem",
            id: "iD",
            geo_uri: "Aplica\xe7\xe3o externa",
            josm: "JOSM",
            error_nopic: "N\xe3o h\xe1 imagem dispon\xedvel na posi\xe7\xe3o indicada",
            error_webgl: "O WebGL n\xe3o \xe9 suportado pelo seu navegador",
            error_josm: "O JOSM n\xe3o responde, est\xe1 a funcionar e est\xe1 ativado o acesso remoto?",
            filter_date: "Data",
            filter_date_1month: "1 m\xeas",
            filter_date_1year: "1 ano",
            filter_user: "Utilizador",
            filter_user_mypics: "Minhas imagens",
            filter_picture: "Tipo de imagem",
            filter_zoom_in: "Amplie o mapa para desbloquear",
            picture_all: "Todas",
            picture_flat: "Cl\xe1ssica",
            picture_360: "360\xb0",
            picture_360_long: "Imagem panor\xe2mica",
            filter_qualityscore: "Pontua\xe7\xe3o de qualidade",
            filter_qualityscore_help: "Clique para ativar ou desativar",
            qualityscore_title: "Sobre a pontua\xe7\xe3o de qualidade",
            qualityscore_doc_3: "\xabA\xbb \xe9 a melhor nota, \xabE\xbb a pior.",
            qualityscore_doc_link: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            filter_gps_precision: "Precis\xe3o de localiza\xe7\xe3o",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} e {n2} metros",
            filter_gps_precision_morethan: "Mais de {n} metros",
            map_background_aerial: "A\xe9reo",
            map_background_streets: "Ruas",
            map_theme: "Tema do mapa",
            map_theme_default: "Padr\xe3o",
            map_theme_age: "Data da captura",
            map_theme_age_1: "> 3 anos",
            map_theme_age_2: "< 3 anos",
            map_theme_age_3: "< 1 ano",
            map_theme_age_4: "< 6 m\xeas",
            map_theme_type: "Tipo de c\xe2mara",
            map_theme_gps: "Precis\xe3o de GPS",
            contrast: "Ativar maior contraste da imagem",
            metadata: "Metadados de imagem",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID da imagem",
            metadata_general_picid: "Imagem",
            metadata_general_seqid: "Sequ\xeancia",
            metadata_general_author: "Autor",
            metadata_general_license: "Licen\xe7a",
            metadata_general_license_link: "Veja a descri\xe7\xe3o completa da licen\xe7a",
            metadata_general_date: "Data da captura",
            metadata_general_instance: "Inst\xe2ncia de origem",
            metadata_camera: "C\xe2mara",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_resolution: "Resolu\xe7\xe3o",
            metadata_camera_focal_length: "Dist\xe2ncia focal",
            metadata_location: "Posi\xe7\xe3o",
            metadata_location_orientation: "Dire\xe7\xe3o",
            metadata_location_precision: "Precis\xe3o de posicionamento",
            metadata_location_copy: "Copiar {v}",
            metadata_location_copy_more: "Mais op\xe7\xf5es de c\xf3pia de coordenadas",
            metadata_quality: "Qualidade",
            metadata_quality_score: "Pontua\xe7\xe3o global",
            metadata_quality_gps_score: "Pontua\xe7\xe3o de posicionamento",
            metadata_quality_missing: "nenhum valor definido na imagem",
            metadata_exif: "EXIF",
            metadata_exif_value: "Valor",
            semantics_features_subtitle: "{nb} propriedades associadas",
            semantics_annotation_tooltip: "Clique para ver detalhes",
            semantics_key: "Chave",
            semantics_value: "Valor",
            semantics_key_doc: "Saiba mais sobre esta chave",
            semantics_qualifiers: "Qualificadores",
            semantics_show_annotations: "Exibir caracter\xedsticas da imagem",
            semantics_hide_annotations: "Ocultar caracter\xedsticas da imagem",
            semantics_zero_annotations: "Nenhuma caracter\xedstica desenhada nesta imagem",
            semantics_erase_annotation: "Apagar caracter\xedstica desenhada",
            semantics_delete_annotation: "Eliminar esta caracter\xedstica",
            semantics_wikidata_properties: {
                P31: "inst\xe2ncia de",
                P361: "parte de",
                P279: "subclasse de",
                P180: "retrata"
            },
            semantics_editor_example: "chave=valor\nprefixo|chave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Salvar suas altera\xe7\xf5es",
            semantics_undo: "Cancelar suas edi\xe7\xf5es",
            report: "Denunciar",
            report_nature_label: "Causa do problema",
            report_nature: {
                "": "Selecione o tipo do problema\u2026",
                blur_missing: "O rosto de uma pessoa ou a matr\xedcula de um carro s\xe3o vis\xedveis",
                inappropriate: "A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)",
                privacy: "Um caminho ou propriedade privada \xe9 vis\xedvel",
                mislocated: "A imagem est\xe1 mal posicionada no mapa",
                copyright: "A imagem viola direitos autorais",
                other: "Qualquer outro tipo de problema",
                picture_low_quality: "A imagem \xe9 de baixa qualidade",
                blur_excess: "Foi aplicado um desfoque desnecess\xe1rio a um objeto"
            },
            report_whole_sequence: "Isto diz respeito a toda a sequ\xeancia",
            report_details: "Detalhes adicionais",
            report_email_placeholder: "Opcional",
            report_wait: "Enviando relat\xf3rio\u2026",
            report_failure: "Ocorreu um erro ao criar o relat\xf3rio: {e}. Por favor, tente novamente mais tarde.",
            moveRight: "Mover para a direita",
            share_rss_title: "Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel",
            error_pic: "A imagem solicitada n\xe3o foi encontrada",
            filter_date_6months: "6 meses",
            error_api_compatibility: "O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador",
            semantics_doc_info3: "Alguns objetos s\xe3o detetados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.",
            report_email: "Seu e-mail",
            metadata_location_coordinates: "Coordenadas (longitude, latitude)",
            qualityscore_doc_2: "A pontua\xe7\xe3o \xe9 apresentada como uma letra:",
            semantics_features_none: "Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.",
            qualityscore_doc_1: "\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.",
            semantics_draw_annotation: "Pode desenhar o objeto que deseja adicionar na imagem (opcional).",
            semantics_send_fail: "N\xe3o foi poss\xedvel guardar as suas altera\xe7\xf5es, por favor, tente novamente mais tarde",
            report_auth: 'Este relat\xf3rio ser\xe1 enviado usando a sua conta "{a}"',
            report_details_placeholder: "Opcionalmente, pode adicionar detalhes sobre o problema",
            report_submit: "Enviar",
            metadata_exif_name: "Tag",
            metadata_exif_doc: "Documenta\xe7\xe3o para etiquetas EXIF",
            semantics_tags: "{nb} etiquetas",
            semantics_title: "Etiquetas",
            semantics_show_all_tags: "Mostrar todas as etiquetas",
            semantics_hide_all_tags: "Ocultar todas as etiquetas",
            semantics_sequence_tags: "Etiqueta da sequ\xeancia",
            semantics_picture_tags: "Etiqueta de imagem",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_annotation_tags: "Etiqueta de objeto",
            semantics_doc_title: "Sobre etiquetas",
            semantics_doc_info2: "Tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que v\xea usando as etiquetas existentes. Tamb\xe9m pode criar as suas pr\xf3prias, se necess\xe1rio.",
            semantics_doc_link: "Saiba mais sobre etiquetas",
            semantics_value_doc: "Saiba mais sobre esta etiqueta",
            semantics_add_annotation: "Adicionar uma nova etiqueta",
            semantics_delete_annotation_confirm: "Quer mesmo eliminar esta etiqueta?",
            semantics_editor_error: "A sintaxe \xe9 inv\xe1lida. Suas etiquetas podem ficar assim:\nchave=valor\nprefixo|chave=valor\nprefixo|chave[qualif_chave=qualif_val]=valor\n\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.",
            semantics_login_needed: "Para editar tags ou recursos de imagens, \xe9 necess\xe1rio fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?",
            metadata_exif_doc_title: "Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das etiquetas EXIF e XMP",
            semantics_doc_info1: "D\xea contexto a uma imagem usando etiquetas.",
            semantics_overlays: {
                tfsigns: "Sinais de tr\xe2nsito",
                features: "Todas as caracter\xedsticas"
            },
            semantics_doc_info1u1: "Pode marc\xe1-la como capturada por carro com a etiqueta transport=car.",
            semantics_zoom_in: "Amplie o mapa para ver as etiquetas",
            semantics_download_info: "Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.",
            semantics_download_title: "Baixar etiquetas",
            semantics_download: "Baixar",
            semantics_download_cta: "Baixar dados abertos",
            semantics_copy: "Copiar atributos",
            popup_details_link: "Mais detalhes",
            qualityscore_doc_41: "a precis\xe3o do GPS",
            filter_gps_precision_help: "Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o",
            filter_gps_precision_help_1: "Informa\xe7\xf5es de precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedveis para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.",
            filter_gps_precision_help_3: "\xab5\u2B50\xbb \xe9 muito preciso (<= {p5}m), \xab1\u2B50\xbb \xe9 muito impreciso (> {p1}m) ou desconhecido.",
            qualityscore_doc_4: "Esta pontua\xe7\xe3o \xe9 calculada com base em:",
            filter_gps_precision_help_4: "Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \xab5\u2B50\xbb, uma c\xe2mara de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \xab3\u2B50\xbb e um GPS de smartphone num estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \xab1\u2B50\xbb.",
            filter_gps_precision_help_2: "A precis\xe3o \xe9 expressa com estrelas:",
            semantics_value_show_osm: "Ver no OpenStreetMap",
            qualityscore_doc_42: "a resolu\xe7\xe3o da imagem",
            qualityscore_doc_5: "Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mara de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.",
            indoor_selector_expand: "Clique para ver todos os n\xedveis dispon\xedveis",
            indoor_selector_shrink: "Clique para minimizar",
            indoor_selector_levelup: "Ir para o n\xedvel superior",
            indoor_selector_leveldown: "Ir para o n\xedvel inferior",
            indoor_selector_scrollup: "Role a lista de n\xedveis para cima",
            indoor_selector_scrolldown: "Role a lista de n\xedveis para baixo",
            indoor_switch: "Mapas de interiores",
            "visibility_logged-only": "Membros",
            "visibility_title_logged-only": "Somente pessoas com uma conta podem ver esta imagem",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Apenas voc\xea pode ver esta imagem",
            filter_locked: "Filtro desativado",
            map_background_default: "Padr\xe3o",
            map_background_more: "Mais",
            filter_source_world: "Mundo inteiro",
            filter_source_local: "Este servidor",
            time_travel: "Ver este local noutras datas",
            time_travel_close: "Ocultar outras datas",
            map_theme_default_short: "Padr\xe3o",
            map_theme_age_short: "Data",
            map_theme_type_short: "C\xe2mara",
            map_theme_score_short: "Qualidade",
            map_theme_gps_short: "Posi\xe7\xe3o"
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Localiza\xe7\xe3o n\xe3o dispon\xedvel",
            "GeolocateControl.FindMyLocation": "Encontre minha localiza\xe7\xe3o"
        },
        map: {
            thumbnail: "Miniatura da imagem ao passar o cursor",
            not_public: "N\xe3o vis\xedvel publicamente",
            slow_loading: "O mapa demora a carregar e pode aparecer corrompido",
            map_data: "Mapa baseado em {m}",
            more_panoramax: "Descubra mais sobre o Panoramax",
            loading: "Carregando\u2026"
        }
    },
    "pt-br": {
        pnx: {
            loading_labels_fun: [
                "\uD83E\uDDA5 Detectando placas de travessia de bichos-pregui\xe7a",
                "\uD83D\uDE98 Procurando Panoramax Car \xa9",
                "\u2615 Injetando cafe\xedna",
                "\uD83D\uDE00 Sorria, voc\xea foi mapeado!",
                "\uD83D\uDC08 Compartilhando imagens de gatos",
                "\uD83D\uDE34 Reduzindo a procrastina\xe7\xe3o",
                "\u2615 Preparando um cafezinho",
                "\uD83D\uDC27 Abrindo c\xf3digo-fonte",
                "\uD83D\uDE87 Indexando as esta\xe7\xf5es de metr\xf4",
                "\uD83E\uDDF9 Limpando os metadados",
                "\uD83D\uDE92 Enviando fotos do quartel dos bombeiros",
                "\uD83D\uDEB2 Atualizando as ciclovias",
                "\uD83D\uDE89 Caminhando pela plataforma da esta\xe7\xe3o",
                "\uD83D\uDEF0\uFE0F Procurando sat\xe9lites",
                "\uD83D\uDEA1 Subindo o P\xe3o de A\xe7\xfacar de telef\xe9rico",
                "\uD83C\uDF5F Localizando lanchonetes",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Depurando a interface",
                "\uD83D\uDCC8 Incrementando as estat\xedsticas",
                "\uD83C\uDFF0 Fortificando fortalezas em Fortaleza",
                "\uD83C\uDFA8 Redesenhando a interface",
                "\uD83D\uDC2C Procurando o boto-rosa no rio Amazonas",
                "\uD83E\uDDC0 Maturando os queijos minas",
                "\uD83C\uDF04 Calculando a insola\xe7\xe3o em Ubatuba",
                "\uD83C\uDF0A Medindo as mar\xe9s altas"
            ],
            zoom: "Zoom",
            zoomOut: "Diminuir o zoom",
            zoomIn: "Ampliar o zoom",
            moveUp: "Mover para cima",
            moveDown: "Mover para baixo",
            moveLeft: "Mover para a esquerda",
            expand: "Expandir",
            expand_info: "Fazer com que o widget apare\xe7a em p\xe1gina inteira",
            show_psv: "Exibir o visualizador de imagens",
            show_map: "Exibir o mapa",
            minimize_short: "Ocultar",
            options: "Op\xe7\xf5es",
            filters: "Filtros",
            layers: "Camadas",
            search: "Pesquisa",
            search_empty: "Nenhum resultado encontrado",
            search_address: "Pesquisar um endere\xe7o ou uma cidade etc.\u2026",
            search_user: "Pesquisar um nome de usu\xe1rio\u2026",
            share: "Compartilhar",
            share_links: "Links",
            share_page: "Link para esta foto",
            share_image: "Imagem HD",
            share_rss: "Feed RSS",
            share_embed: "Incorporar no seu site",
            share_embed_docs: "Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o",
            share_print: "Imprimir",
            panoramax: "Panoramax",
            whats_panoramax: "Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.",
            copy: "Copiar",
            copied: "Copiado",
            error: "Temos um problema\u2026",
            error_retry: "Por favor, tente novamente mais tarde",
            sequence_play: "Reproduzir esta sequ\xeancia",
            sequence_pause: "Pausar sequ\xeancia",
            sequence_next: "Pr\xf3xima imagem na sequ\xeancia",
            sequence_more: "Mais op\xe7\xf5es de reprodu\xe7\xe3o",
            sequence_speed: "Velocidade de reprodu\xe7\xe3o",
            legend_license: "Licen\xe7a: {l}",
            legend_title: "Exibir detalhes da imagem",
            id: "iD",
            geo_uri: "Aplicativo externo",
            josm: "JOSM",
            josm_live: "Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Carregando dados do mapa",
                "\uD83D\uDDA5\uFE0F Consultando a API",
                "\uD83D\uDDBC\uFE0F Carregando miniaturas",
                "\uD83D\uDD0D Analisando os metadados EXIF",
                "\uD83C\uDFD8\uFE0F Renderiza\xe7\xe3o 3D",
                "\uD83D\uDCF7 Inicializando imagens em 360\xb0",
                "\uD83D\uDFE0 Ajuste de cores",
                "\uD83D\uDCAF Computando o Quality Score \xa9",
                "\uD83D\uDCE1 Baixando atualiza\xe7\xf5es",
                "\uD83C\uDF0D Buscando blocos de mapa",
                "\uD83D\uDCF8 Processando sombras"
            ],
            moveMiddle: "Centralizar a visualiza\xe7\xe3o",
            share_rss_title: "Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel",
            contribute_id: "Contribua para o OpenStreetMap com o editor iD",
            moveRight: "Mover para a direita",
            sequence_prev: "Imagem anterior na sequ\xeancia",
            minimize: "Ocultar este widget. Voc\xea pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo",
            error_click: "Continuar",
            semantics_features_none: "Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.",
            semantics_draw_annotation: "Voc\xea pode desenhar o objeto que deseja adicionar na imagem (opcional).",
            semantics_login_needed: "Para editar etiquetas ou caracter\xedsticas de imagens, voc\xea precisa fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?",
            filter_zoom_in: "Amplie o mapa para desbloquear",
            picture_360: "360\xb0",
            picture_flat_long: "Imagem cl\xe1ssica",
            filter_qualityscore: "Pontua\xe7\xe3o de qualidade",
            filter_qualityscore_help: "Clique para ativar ou desativar",
            qualityscore_title: "Sobre a pontua\xe7\xe3o de qualidade",
            qualityscore_doc_2: "A pontua\xe7\xe3o \xe9 apresentada como uma letra:",
            semantics_features: "Caracter\xedsticas da imagem",
            semantics_features_default_title: "Etiqueta {nb}",
            semantics_features_subtitle: "{nb} propriedades associadas",
            semantics_annotation_tooltip: "Clique para ver detalhes",
            semantics_hide_all_tags: "Ocultar todas as etiquetas",
            semantics_key: "Chave",
            semantics_value: "Valor",
            semantics_value_doc: "Saiba mais sobre esta etiqueta",
            semantics_tags_picture: "Etiquetas de imagem",
            qualityscore_doc_3: "\u201CA\u201D \xe9 a melhor nota, \u201CE\u201D \xe9 a pior.",
            error_psv: "O Photo Sphere Viewer n\xe3o est\xe1 carregando corretamente",
            error_pic: "A imagem solicitada n\xe3o foi encontrada",
            error_api: "O servidor de imagens n\xe3o est\xe1 dispon\xedvel",
            error_webgl: "O WebGL n\xe3o \xe9 compat\xedvel com o seu navegador",
            error_api_compatibility: "O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador",
            filter_date: "Data",
            filter_date_1month: "1 m\xeas",
            filter_date_6months: "6 meses",
            filter_date_1year: "1 ano",
            filter_user: "Usu\xe1rio",
            filter_user_mypics: "Minhas imagens",
            error_josm: "O JOSM n\xe3o respondeu. Ele est\xe1 sendo executado e est\xe1 ativado o acesso remoto?",
            filter_picture: "Tipo de imagem",
            picture_flat: "Cl\xe1ssica",
            picture_360_long: "Imagem panor\xe2mica",
            qualityscore_doc_link: "Saiba mais sobre a Pontua\xe7\xe3o de Qualidade",
            metadata_general_picid_link: "Ir para a descri\xe7\xe3o JSON da imagem",
            metadata_camera_resolution: "Resolu\xe7\xe3o",
            metadata_exif_doc: "Documenta\xe7\xe3o para etiquetas EXIF",
            metadata_exif_doc_title: "Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das etiquetas EXIF e XMP",
            semantics_title: "Etiquetas",
            semantics_show_all_tags: "Mostrar todas as etiquetas",
            semantics_tags_picture_none: "Ainda n\xe3o foram definidas etiquetas para esta imagem.",
            semantics_send_fail: "N\xe3o \xe9 poss\xedvel salvar suas altera\xe7\xf5es, por favor, tente novamente mais tarde",
            report_details_placeholder: "Opcionalmente, voc\xea pode adicionar detalhes sobre o problema",
            report_nature: {
                inappropriate: "A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)",
                "": "Selecione o tipo do problema\u2026",
                blur_missing: "O rosto de uma pessoa ou a placa de um carro s\xe3o vis\xedveis",
                blur_excess: "Um desfoque desnecess\xe1rio foi aplicado a um objeto",
                privacy: "A foto foi tirada de uma trilha ou propriedade privada",
                picture_low_quality: "A imagem \xe9 de baixa qualidade",
                mislocated: "A imagem est\xe1 mal posicionada no mapa",
                copyright: "A imagem viola direitos autorais",
                other: "Qualquer outro tipo de problema"
            },
            error_nopic: "Nenhuma imagem dispon\xedvel na posi\xe7\xe3o indicada",
            picture_all: "Todas",
            metadata_location_copy_more: "Mais op\xe7\xf5es de c\xf3pia de coordenadas",
            semantics_tags: "{nb} etiquetas",
            semantics_zero_annotations: "Nenhuma caracter\xedstica desenhada nesta imagem",
            semantics_save_drawn_annotation_incomplete: "Voc\xea deve desenhar um ret\xe2ngulo que se encaixe na imagem antes de validar",
            map_background: "Fundo",
            map_background_aerial: "A\xe9reo",
            map_background_streets: "Ruas",
            map_theme: "Tema",
            map_theme_default: "Padr\xe3o",
            map_theme_age: "Data da captura",
            map_theme_age_1: "> 3 anos",
            map_theme_age_2: "< 3 anos",
            map_theme_age_3: "\xbd - 1 ano",
            map_theme_age_4: "< 6 m\xeas",
            map_theme_type: "Tipo de c\xe2mera",
            contrast: "Ativar maior contraste da imagem",
            metadata: "Metadados de imagem",
            metadata_summary: "Resumo",
            metadata_general_copy_id: "Copiar ID",
            metadata_general_copy_picid: "Copiar ID da imagem",
            metadata_general_picid: "Imagem",
            metadata_general_seqid: "Sequ\xeancia",
            metadata_general_seqid_link: "Ir para a descri\xe7\xe3o JSON da sequ\xeancia",
            metadata_general_author: "Autor",
            metadata_general_license: "Licen\xe7a",
            metadata_general_license_link: "Consulte a descri\xe7\xe3o completa da licen\xe7a",
            metadata_general_date: "Data da captura",
            metadata_general_instance: "Inst\xe2ncia de origem",
            metadata_camera: "C\xe2mera",
            metadata_camera_make: "Marca",
            metadata_camera_model: "Modelo",
            metadata_camera_type: "Tipo",
            metadata_camera_focal_length: "Dist\xe2ncia focal",
            metadata_location: "Posi\xe7\xe3o",
            metadata_location_coordinates: "Coordenadas (longitude, latitude)",
            metadata_location_orientation: "Dire\xe7\xe3o",
            metadata_location_precision: "Precis\xe3o de posicionamento",
            metadata_location_copy: "Copiar {v}",
            metadata_quality: "Qualidade",
            metadata_quality_help: "Saiba mais sobre a pontua\xe7\xe3o de qualidade",
            metadata_quality_score: "Pontua\xe7\xe3o global",
            metadata_quality_gps_score: "Pontua\xe7\xe3o de posicionamento",
            metadata_quality_resolution_score: "Pontua\xe7\xe3o de resolu\xe7\xe3o",
            metadata_quality_missing: "nenhum valor definido na imagem",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etiqueta",
            metadata_exif_value: "Valor",
            semantics_editor_error: "A sintaxe est\xe1 inv\xe1lida. Suas etiquetas podem ficar assim:\nchave=valor\nprefixo|chave=valor\nprefixo|chave[qualif_chave=qualif_val]=valor\n\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, e o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.",
            report: "Denunciar",
            report_auth: 'Este relat\xf3rio ser\xe1 enviado usando sua conta "{a}"',
            report_nature_label: "Causa do problema",
            semantics_qualifiers: "Qualificadores",
            semantics_show_annotations: "Exibir caracter\xedsticas da imagem",
            semantics_hide_annotations: "Ocultar caracter\xedsticas da imagem",
            semantics_add_annotation: "Adicionar uma nova etiqueta",
            semantics_save_drawn_annotation: "Salvar posi\xe7\xe3o",
            semantics_undo_drawn_annotation: "Cancelar",
            semantics_delete_annotation: "Excluir esta caracter\xedstica",
            semantics_delete_annotation_confirm: "Voc\xea realmente deseja excluir esta etiqueta?",
            semantics_hashtags: "Hashtags da imagem",
            semantics_wikidata_properties: {
                P31: "inst\xe2ncia de",
                P279: "subclasse de",
                P361: "parte de",
                P180: "retrata"
            },
            semantics_editor_example: "chave=valor\nprefixo|chave=valor",
            semantics_edit: "Editar atributos",
            semantics_save: "Salvar suas altera\xe7\xf5es",
            semantics_undo: "Cancelar suas edi\xe7\xf5es",
            semantics_cantsave_invalid: "N\xe3o \xe9 poss\xedvel salvar as altera\xe7\xf5es, entrada \xe9 inv\xe1lida",
            semantics_send_ok: "Suas edi\xe7\xf5es foram enviadas com \xeaxito",
            report_whole_sequence: "Isso diz respeito a toda a sequ\xeancia",
            report_details: "Detalhes adicionais",
            report_email: "Seu e-mail",
            report_email_placeholder: "Opcional",
            report_submit: "Enviar",
            report_wait: "Enviando relat\xf3rio\u2026",
            qualityscore_doc_1: "\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.",
            map_theme_score: "Pontua\xe7\xe3o de qualidade",
            report_success: "O relat\xf3rio foi enviado com sucesso. Ele ser\xe1 analisado assim que poss\xedvel.",
            report_failure: "Ocorreu um erro ao criar o relat\xf3rio: {e}. Tente novamente mais tarde.",
            semantics_key_doc: "Saiba mais sobre esta chave",
            semantics_doc: "Ajuda",
            semantics_erase_annotation: "Apagar caracter\xedstica desenhada",
            semantics_doc_title: "Sobre etiquetas",
            semantics_doc_info1: "D\xea contexto a uma imagem usando etiquetas.",
            semantics_doc_link: "Saiba mais sobre etiquetas",
            semantics_doc_info3: "Alguns objetos s\xe3o detectados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.",
            semantics_doc_info2: "Voc\xea tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que voc\xea v\xea usando as etiquetas existentes. Voc\xea tamb\xe9m pode criar suas pr\xf3prias etiquetas, se necess\xe1rio.",
            semantics_picture_tags: "Etiqueta de imagem",
            semantics_sequence_tags: "Etiqueta de sequ\xeancia",
            semantics_annotation_tags: "Etiqueta de objeto",
            filter_gps_precision: "Precis\xe3o de localiza\xe7\xe3o",
            filter_gps_precision_lessthan: "Menos de {n} metros",
            filter_gps_precision_between: "Entre {n1} e {n2} metros",
            filter_gps_precision_morethan: "Mais de {n} metros",
            map_theme_gps: "Precis\xe3o de GPS",
            semantics_overlays: {
                tfsigns: "Sinais de tr\xe2nsito",
                features: "Todas as caracter\xedsticas"
            },
            semantics_doc_info1u1: "Voc\xea pode marc\xe1-la como capturada por carro com a etiqueta transport=car.",
            semantics_zoom_in: "Amplie o mapa para ver as etiquetas",
            semantics_download: "Baixar",
            semantics_download_title: "Baixar etiquetas",
            semantics_download_info: "Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.",
            semantics_download_cta: "Baixar dados abertos",
            semantics_copy: "Copiar atributos",
            popup_details_link: "Mais detalhes",
            qualityscore_doc_5: "Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mera de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.",
            semantics_value_show_osm: "Ver no OpenStreetMap",
            filter_gps_precision_help_4: "Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \u201C5\u2B50\u201D, uma c\xe2mera de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \u201C3\u2B50\u201D e um GPS de smartphone em um estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \u201C1\u2B50\u201D.",
            filter_gps_precision_help: "Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o",
            filter_gps_precision_help_1: "Uma pontua\xe7\xe3o da precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedvel para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.",
            filter_gps_precision_help_2: "A precis\xe3o \xe9 expressa com estrelas:",
            filter_gps_precision_help_3: "\u201C5\u2B50\u201D \xe9 muito preciso (<= {p5}m), \u201C1\u2B50\u201D \xe9 muito impreciso (> {p1}m) ou desconhecido.",
            qualityscore_doc_4: "Esta pontua\xe7\xe3o \xe9 calculada com base em:",
            qualityscore_doc_41: "a precis\xe3o do GPS",
            qualityscore_doc_42: "a resolu\xe7\xe3o da imagem",
            indoor_selector_expand: "Clique para ver todos os n\xedveis dispon\xedveis",
            indoor_selector_shrink: "Clique para minimizar",
            indoor_selector_levelup: "Ir para o n\xedvel superior",
            indoor_selector_scrollup: "Role a lista de n\xedveis para cima",
            indoor_selector_scrolldown: "Role a lista de n\xedveis para baixo",
            indoor_selector_leveldown: "Ir para o n\xedvel inferior",
            indoor_switch: "Espa\xe7os interiores",
            "visibility_logged-only": "Membros",
            "visibility_title_logged-only": "Somente pessoas com uma conta podem ver esta imagem",
            "visibility_owner-only": "Oculto",
            "visibility_title_owner-only": "Apenas voc\xea pode ver esta imagem",
            filter_source_world: "Mundo inteiro",
            filter_source_local: "Este servidor",
            filter_locked: "Filtro desativado",
            map_background_default: "Padr\xe3o",
            map_background_more: "Mais",
            semantics_draw_invalid_annotation: "A \xe1rea desenhada ultrapassa os limites da imagem. Certifique-se de desenhar dentro da \xe1rea vis\xedvel da imagem.",
            semantics_draw_unfinished_annotation: "A \xe1rea desenhada ainda n\xe3o est\xe1 conclu\xedda. Certifique-se de que a \xe1rea esteja bem posicionada antes de salvar.",
            error_pic_load: "N\xe3o \xe9 poss\xedvel carregar esta imagem no momento.\nVerifique sua conex\xe3o com a Internet. Se estiver conectado, certifique-se de que o ID da imagem \xe9 v\xe1lido.",
            low_contrast: "Reduzir o contraste da imagem",
            reset_contrast: "Redefinir o contraste da imagem",
            delete_picture: "Excluir",
            delete_picture_ok: "A foto foi exclu\xedda com sucesso",
            delete_picture_error: "Ocorreu um erro ao tentar excluir a imagem:\n{e}",
            semantics_empty: "Nenhuma etiqueta definida",
            delete_picture_warn: "\u26A0\uFE0F Aten\xe7\xe3o: isso excluir\xe1 definitivamente esta foto.\nTem certeza de que deseja continuar?",
            metadata_general_title: "T\xedtulo",
            time_travel_close: "Ocultar outras datas",
            time_travel: "Ver este local em outras datas",
            map_theme_default_short: "Padr\xe3o",
            map_theme_age_short: "Data",
            map_theme_type_short: "C\xe2mera",
            map_theme_score_short: "Qualidade",
            map_theme_gps_short: "Posi\xe7\xe3o",
            widget_locked: "Op\xe7\xe3o desativada",
            map_theme_default_coef: "N\xedvel de cobertura",
            map_theme_default_coef_short: "Cobertura",
            map_theme_default_1: "Baixo",
            map_theme_default_2: "M\xe9dio",
            map_theme_default_3: "Bom",
            map_theme_default_4: "Excelente",
            sequence_play_backwards: "Reproduzir esta sequ\xeancia ao contr\xe1rio",
            semantics_annotation_tooltip_close: "Clique para desselecionar"
        },
        psv: {
            ctrlZoom: "Use ctrl + rolagem para ampliar a imagem",
            loadError: "O panorama n\xe3o pode ser carregado",
            twoFingers: "Use dois dedos para navegar"
        },
        maplibre: {
            "GeolocateControl.LocationNotAvailable": "Localiza\xe7\xe3o n\xe3o dispon\xedvel",
            "GeolocateControl.FindMyLocation": "Encontre minha localiza\xe7\xe3o"
        },
        map: {
            thumbnail: "Miniatura da imagem ao passar o cursor",
            not_public: "N\xe3o vis\xedvel publicamente",
            slow_loading: "O mapa est\xe1 carregando lentamente e pode parecer com defeito",
            map_data: "Mapa baseado em {m}",
            more_panoramax: "Descubra mais sobre o Panoramax",
            loading: "Carregando\u2026"
        }
    },
    sv: {
        psv: {
            twoFingers: "Anv\xe4nd tv\xe5 fingrar f\xf6r att panorera",
            loadError: "Panoramat kan inte laddas",
            ctrlZoom: "Anv\xe4nd ctrl + scroll f\xf6r att zooma in p\xe5 bilden"
        },
        pnx: {
            moveUp: "Flytta upp",
            zoom: "Zoom",
            zoomOut: "Zooma ut",
            zoomIn: "Zooma in",
            moveDown: "Flytta ner",
            moveLeft: "Flytta v\xe4nster",
            moveRight: "Flytta h\xf6ger",
            moveMiddle: "Centrera vy",
            expand: "Expandera",
            show_psv: "Visa bildvisaren",
            show_map: "Visa kartan",
            expand_info: "Visa widgeten p\xe5 hela sidan",
            minimize: "G\xf6m denna flik, du kan visa den igen genom att anv\xe4nda knappen i nedersta v\xe4nstra h\xf6rnet",
            minimize_short: "G\xf6m",
            options: "Alternativ",
            search: "S\xf6k",
            search_empty: "Inga resultat hittade",
            filters: "Filter",
            layers: "Lager",
            share: "Dela",
            share_links: "L\xe4nkar",
            share_page: "L\xe4nka till denna sida",
            share_image: "HD bild",
            share_rss: "RSS feed",
            share_embed: "B\xe4dda in p\xe5 din hemsida",
            share_embed_docs: "L\xe4s mer om inb\xe4ddad konfiguration",
            share_print: "Skriv ut",
            copy: "Kopiera",
            copied: "Kopierad",
            error: "Vi har ett problem\u2026",
            error_click: "Forts\xe4tt",
            error_retry: "V\xe4nligen f\xf6rs\xf6k igen senare",
            sequence_next: "N\xe4sta bild i sekvensen",
            sequence_play: "Spela upp bilder i sekvensen",
            sequence_pause: "Pausa sekvens",
            sequence_more: "Mera uppspelningsalternativ",
            sequence_speed: "Uppspelningshastighet",
            legend_license: "Licens: {l}",
            search_address: "S\xf6k en adress, stad\u2026",
            edit_osm: "Redigera OSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Laddar kartdata",
                "\uD83D\uDDA5\uFE0F Anropar API",
                "\uD83D\uDDBC\uFE0F Laddar miniatyrer",
                "\uD83D\uDD0D Analyserar EXIF metadata",
                "\uD83C\uDFD8\uFE0F 3D rendering",
                "\uD83D\uDCF7 Initialiserar 360\xb0 bilder",
                "\uD83D\uDFE0 F\xe4rg balansering",
                "\uD83D\uDCAF Ber\xe4kna Kvalitetspo\xe4ng \xa9"
            ],
            loading_labels_fun: [
                "\uD83E\uDD8C R\xe4knar \xe4lgar",
                "R\xe4knar gula bilar",
                "\u2615 Bunkrar upp med kaffe",
                "Kaj nu simmar du ur bild!",
                "\uD83D\uDC08 Delar kattbilder",
                "\uD83D\uDE34 Prokastinerar",
                "\uD83E\uDED6 Kokar te",
                "\uD83D\uDC27 \xd6ppnar k\xe4llkod",
                "\uD83D\uDE87 R\xe4knar t\xe5g",
                "\uD83E\uDDF9 St\xe4dar upp bland metadata",
                "\uD83D\uDC3F\uFE0F R\xe4knar ekorrar",
                "\uD83D\uDEB2 R\xe4knar cykelst\xe4ll",
                "\uD83D\uDE89 G\xe5r igenom stationer",
                "\uD83D\uDEF0\uFE0F S\xf6ker satelliter",
                "\uD83E\uDDD1\u200D\uD83C\uDF73 Lagar k\xf6ttbullar",
                "\uD83E\uDDCDSt\xe5r i k\xf6",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Fels\xf6ker gr\xe4nsnitt",
                "\uD83D\uDCC8 \xd6kar statistik"
            ],
            error_psv: "Foto-sf\xe4r visaren laddar inte ordentligt",
            error_nopic: "Ingen bild finns p\xe5 angiven position",
            error_api: "Bildservern \xe4r inte tillg\xe4nlig",
            error_webgl: "WebGL st\xf6ds inte i din webbl\xe4sare",
            error_api_compatibility: "Bildservern \xe4r inte kompatibel med den h\xe4r visarens version",
            filter_date: "Datum",
            filter_date_1month: "1 m\xe5nad",
            filter_date_1year: "1 \xe5r",
            filter_user: "Anv\xe4ndare",
            filter_user_mypics: "Mina bilder",
            filter_picture: "Bildtyp",
            filter_zoom_in: "Zooma in f\xf6r att se detta filter",
            picture_360: "360\xb0",
            filter_qualityscore_help: "Klicka f\xf6r att sl\xe5 p\xe5 eller av",
            qualityscore_title: "Om Kvalitetspo\xe4ng",
            filter_qualityscore: "Kvalitetspo\xe4ng",
            qualityscore_doc_2: "Kvalitet visas som en skala p\xe5 A/B/C/D/E (A \xe4r b\xe4st, E \xe4r s\xe4mst) och visas grafisk genom skalan:",
            map_theme_default: "Klassisk",
            map_theme_age_1: "> 3 \xe5r",
            map_theme_age_2: "< 3 \xe5r",
            map_theme_age_3: "< 1 \xe5r",
            map_theme_age_4: "< 6 m\xe5nad",
            map_theme_type: "Kameratyp",
            contrast: "Aktivera h\xf6gre bildkontrast",
            metadata: "Bildmetadata",
            metadata_general_picid: "Bild-identifierare",
            metadata_general_seqid: "Sekvens-identifierare",
            qualityscore_doc_link: "Mer information om hur Kvalitetspo\xe4ng ber\xe4knas finns i v\xe5r dokumentation.",
            map_theme_score: "Kvalitetspo\xe4ng",
            metadata_general_seqid_link: "G\xe5 till JSON beskrivning av sekvensen",
            metadata_general_author: "Upphovsman",
            metadata_general_license: "Licens",
            metadata_general_license_link: "Se full licensbeskrivning",
            metadata_general_date: "Bild tagen",
            metadata_camera: "Kamera",
            metadata_camera_make: "M\xe4rke",
            metadata_camera_model: "Modell",
            metadata_camera_type: "Typ",
            metadata_camera_resolution: "Uppl\xf6sning",
            metadata_location: "Plats",
            metadata_location_longitude: "Longitud",
            metadata_location_latitude: "Latitud",
            metadata_location_orientation: "Kamerariktning",
            metadata_location_precision: "Positionsprecision",
            metadata_quality: "Kvalitetspo\xe4ng",
            metadata_quality_score: "Global po\xe4ng",
            metadata_quality_gps_score: "Positioneringspo\xe4ng",
            metadata_quality_resolution_score: "Uppl\xf6sningspo\xe4ng",
            metadata_quality_missing: "Inget v\xe4rde satt i bilden",
            metadata_exif: "EXIF / XMP",
            metadata_exif_name: "Tag",
            metadata_exif_value: "V\xe4rde",
            report: "Rapportera bild",
            search_user: "S\xf6k anv\xe4ndarnamn\u2026",
            legend_title: "Visa detaljer f\xf6r bild",
            report_auth: 'Denna rapport kommer skickas genom ditt konto "{a}"',
            share_rss_title: "RSS feed av nya sekvensen f\xf6r karta i bild",
            error_josm: "JOSM svarar inte, k\xf6rs det och \xe4r remote p\xe5slaget?",
            sequence_prev: "F\xf6reg\xe5ende bild i sekvensen",
            josm_live: "Aktivera automatisk JOSM synkronisering vid inladdning av bild",
            metadata_general_picid_link: "G\xe5 till JSON beskrivning av bilden",
            metadata_quality_help: "L\xe4s mer om Kvalitetspo\xe4ng",
            error_pic: "Beg\xe4rd bild hittades inte",
            qualityscore_doc_3: "Det r\xe4knas ut baserat p\xe5 GPS precision och bildens uppl\xf6sning. Ett profesionellt system kommer ha A-kvalit\xe9, en 360\xb0 actionkamera kommer ha B-kvalit\xe9 och en telefon kommer ha C/D/E-kvalit\xe9.",
            qualityscore_doc_1: "Panoramax erbjuder en Kvalitetspo\xe4ng f\xf6r varje bild. Det m\xf6jlig\xf6r enkel kartfiltrering och en omfattande uppvisning av tillg\xe4nligheten av bilder av h\xf6g kvalitet.",
            metadata_camera_focal_length: "Br\xe4nnvidd",
            picture_flat: "Klassisk",
            map_background: "Kartbakgrund",
            map_background_aerial: "Sattelit",
            map_background_streets: "Gator",
            map_theme: "Karttema",
            map_theme_age: "Fotodatum",
            report_nature_label: "Typ av problem",
            report_nature: {
                "": "V\xe4lj typen av problem\u2026",
                blur_missing: "En persons ansikte eller en registreringspl\xe5t \xe4r synlig",
                blur_excess: "Ett objekt som inte beh\xf6ver suddas \xe4r suddad",
                inappropriate: "Bilden \xe4r ol\xe4mplig(orelaterat, nakenhet...)",
                privacy: "En privat v\xe4g eller fastighet \xe4r synlig",
                picture_low_quality: "Bilden \xe4r av mycket d\xe5lig kvalitet",
                mislocated: "Bilden \xe4r placerat d\xe5lig p\xe5 kartan",
                copyright: "Bilden inkr\xe4nker p\xe5 upphovsr\xe4tt",
                other: "N\xe5got annat typ av problem"
            },
            report_whole_sequence: "Detta g\xe4ller hela sekvensen",
            report_details: "Ytterligare detaljer",
            report_details_placeholder: "Valfritt, kan du l\xe4gga till information om problemet och varf\xf6r det \xe4r ett problem",
            report_email: "Din e-post",
            report_email_placeholder: "Valfri",
            report_submit: "Skicka",
            report_wait: "Skickar rapport \u2026",
            report_success: "Rapporten har skickats. Det kommer att ses \xf6ver s\xe5 snart som m\xf6jligt.",
            report_failure: "Ett fel uppstod n\xe4r rapporten skapades: {e}. F\xf6rs\xf6k igen senare."
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Hitta min postion",
            "GeolocateControl.LocationNotAvailable": "Plats inte tillg\xe4nlig"
        },
        map: {
            loading: "Laddar\u2026",
            thumbnail: "Miniatyrbild av r\xf6rd bild",
            not_public: "Inte offentligt synligt",
            slow_loading: "Kartan laddas l\xe5ngsamt och kan verka trasig"
        }
    },
    tr: {
        psv: {
            twoFingers: "Gezinmek i\xe7in iki parma\u011F\u0131n\u0131z\u0131 kullan\u0131n",
            loadError: "Panorama y\xfcklenemedi",
            ctrlZoom: "G\xf6r\xfcnt\xfcy\xfc yak\u0131nla\u015Ft\u0131rmak i\xe7in ctrl + kayd\u0131rma tu\u015Flar\u0131n\u0131 kullan\u0131n"
        },
        pnx: {
            search_empty: "Sonu\xe7 bulunamad\u0131",
            zoom: "Yak\u0131nla\u015Ft\u0131r",
            zoomIn: "Yak\u0131nla\u015Ft\u0131r",
            expand: "Geni\u015Flet",
            layers: "Katmanlar",
            search: "Ara",
            minimize_short: "Gizle",
            share_links: "Ba\u011Flant\u0131lar",
            share_embed_docs: "G\xf6mme yap\u0131land\u0131rmas\u0131 hakk\u0131nda daha fazla bilgi edinin",
            share_print: "Yazd\u0131r",
            panoramax: "Panoramax",
            copied: "Kopyaland\u0131",
            error_click: "Devam et",
            sequence_pause: "Sekans duraklat",
            legend_title: "Resim detaylar\u0131n\u0131 g\xf6r\xfcnt\xfcle",
            contribute_id: "iD edit\xf6r\xfc ile OpenStreetMap'e katk\u0131da bulunun",
            josm: "JOSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F Harita verisi y\xfckleniyor",
                "\uD83D\uDDA5\uFE0F API sorgulan\u0131yor",
                "\uD83D\uDDBC\uFE0F K\xfc\xe7\xfck resimler y\xfckleniyor",
                "\uD83D\uDD0D EXIF meta verileri analiz ediliyor",
                "\uD83C\uDFD8\uFE0F 3D i\u015Fleniyor",
                "\uD83D\uDCF7 360\xb0 resimler ba\u015Flat\u0131l\u0131yor",
                "\uD83D\uDFE0 Renk dengeleme",
                "\uD83D\uDCAF Kalite Skoru Hesaplan\u0131yor \xa9",
                "\uD83D\uDCE1 G\xfcncellemeler indiriliyor",
                "\uD83C\uDF0D Harita d\xf6\u015Femeleri getiriliyor",
                "\uD83D\uDCF8 G\xf6lgeler i\u015Fleniyor"
            ],
            metadata_general_license: "Lisans",
            metadata_general_picid: "Resim",
            metadata_general_seqid: "Sekans",
            metadata_general_seqid_link: "Sekans\u0131n JSON a\xe7\u0131klamas\u0131na git",
            metadata_camera_model: "Model",
            metadata_location: "Pozisyon",
            metadata_exif: "EXIF",
            metadata_exif_name: "Etiket",
            metadata_exif_value: "De\u011Fer",
            semantics_title: "Etiketler",
            share_embed: "Web sitenize yerle\u015Ftirin",
            sequence_speed: "Oynat\u0131c\u0131 h\u0131z\u0131",
            metadata_summary: "\xd6zet",
            metadata_general_license_link: "Lisans\u0131n tam a\xe7\u0131klamas\u0131n\u0131 g\xf6r\xfcn",
            metadata_quality: "Kalite",
            zoomOut: "Uzakla\u015Ft\u0131r",
            share: "Payla\u015F",
            share_image: "HD Resim",
            copy: "Kopyala",
            error_retry: "L\xfctfen daha sonra tekrar deneyin",
            show_map: "Haritay\u0131 g\xf6r\xfcnt\xfcle",
            metadata: "Resim meta verisi",
            metadata_general_picid_link: "Resmin JSON a\xe7\u0131klamas\u0131na git",
            metadata_camera_type: "Tip",
            metadata_camera_resolution: "\xc7\xf6z\xfcn\xfcrl\xfck",
            metadata_quality_resolution_score: "\xc7\xf6z\xfcn\xfcrl\xfck skoru",
            metadata_camera: "Kamera",
            report_wait: "Rapor g\xf6nderiliyor\u2026",
            semantics_show_all_tags: "T\xfcm etiketleri g\xf6r\xfcnt\xfcle",
            semantics_hide_all_tags: "T\xfcm etiketleri gizle",
            semantics_value: "De\u011Fer",
            semantics_delete_annotation: "\xd6zelli\u011Fi sil",
            semantics_annotation_tooltip: "Detaylar\u0131 g\xf6r\xfcnt\xfclemek i\xe7in t\u0131klay\u0131n",
            semantics_tags_picture: "Resim etiketleri",
            semantics_delete_annotation_confirm: "Etiketi ger\xe7ekten silmek istiyor musunuz?",
            semantics_save: "De\u011Fi\u015Fiklikleri kaydet",
            minimize: "Bu widget'\u0131 gizleyebilirsiniz, sol alt k\xf6\u015Fedeki d\xfc\u011Fmeyi kullanarak tekrar g\xf6sterebilirsiniz",
            moveUp: "Yukar\u0131 hareket et",
            moveDown: "A\u015Fa\u011F\u0131 hareket et",
            moveLeft: "Sola hareket et",
            moveRight: "Sa\u011Fa hareket et",
            moveMiddle: "Merkez g\xf6r\xfcn\xfcm",
            expand_info: "Widget'\u0131n tam sayfada g\xf6r\xfcnmesini sa\u011Fla",
            show_psv: "Resim g\xf6r\xfcnt\xfcleyiciyi g\xf6ster",
            options: "Se\xe7enekler",
            filters: "Filtreler",
            report_nature: {
                picture_low_quality: "Resim d\xfc\u015F\xfck kalitede",
                other: "Ba\u015Fka herhangi bir sorun",
                "": "Sorunun niteli\u011Fini se\xe7in\u2026",
                mislocated: "Resim haritada k\xf6t\xfc konumland\u0131r\u0131lm\u0131\u015F",
                copyright: "Resim telif hakk\u0131n\u0131 ihlal ediyor",
                blur_missing: "Bir ki\u015Finin y\xfcz\xfc veya ara\xe7 plakas\u0131 g\xf6r\xfcn\xfcyor",
                blur_excess: "Bir nesneye gereksiz bir bulan\u0131kl\u0131k uyguland\u0131",
                inappropriate: "Resim uygunsuz (ilgisiz, \xe7\u0131plakl\u0131k\u2026)",
                privacy: "Foto\u011Fraf \xf6zel bir yoldan veya m\xfclkten \xe7ekilmi\u015Ftir"
            },
            map_background_streets: "Sokaklar",
            contrast: "Daha y\xfcksek g\xf6r\xfcnt\xfc kontrast\u0131n\u0131 etkinle\u015Ftirin",
            search_address: "Adres veya \u015Fehir aray\u0131n...",
            search_user: "Bir kullan\u0131c\u0131 ad\u0131 aray\u0131n\u2026",
            share_page: "Resim ba\u011Flant\u0131s\u0131",
            share_rss: "RSS beslemesi",
            share_rss_title: "\u015Eu anda g\xf6r\xfcnen harita alan\u0131ndaki yeni sekanslar\u0131n RSS beslemesi",
            whats_panoramax: "Panoramax, b\xf6lgelerin resimlerinin co\u011Frafi ortak alan\u0131d\u0131r.",
            error: "Bir sorunumuz var\u2026",
            sequence_next: "S\u0131radaki resim",
            sequence_play: "Bu sekans\u0131 izleyin",
            sequence_prev: "\xd6nceki resim",
            sequence_more: "Daha fazla oynatma se\xe7ene\u011Fi",
            legend_license: "Lisans: {l}",
            id: "iD",
            geo_uri: "Harici uygulama",
            josm_live: "Resim y\xfcklenirken JOSM otomatik senkronizasyonunu etkinle\u015Ftir",
            loading_labels_fun: [
                "\uD83E\uDD8C Geyik ge\xe7i\u015F i\u015Faretlerini tespit etme",
                "\uD83D\uDE98 Panoramax Arac\u0131n\u0131 Bul \xa9",
                "\u2615 Kafein enjekte ediliyor",
                "\uD83D\uDE00 G\xfcl\xfcmse, haritaland\u0131n!",
                "\uD83D\uDC08Kedi resimleri payla\u015F\u0131n",
                "\uD83D\uDE34 Ertelemeyi azalt",
                "\uD83E\uDED6 \xc7ay demle",
                "\uD83D\uDC27 Kaynak kodunu a\xe7",
                "\uD83D\uDE87 Yeralt\u0131 istasyonlar\u0131n\u0131n indeksleniyor",
                "\uD83E\uDDF9 Meta veri temizleme",
                "\uD83D\uDE92 \u0130tfaiye istasyonu resimleri g\xf6nderiliyor",
                "\uD83D\uDEB2Bisiklet rotalar\u0131 g\xfcncelleniyor",
                "\uD83D\uDE89 \u0130stasyon platformu turu",
                "\uD83D\uDEF0\uFE0F Uydular Aran\u0131yor",
                "\uD83D\uDC65 Ki\u015Filikler yaz\u0131l\u0131yor",
                "\uD83D\uDC1F Bal\u0131k ve patates k\u0131zartmas\u0131 d\xfckkanlar\u0131 bulunuyor",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB Hata ay\u0131klama aray\xfcz\xfc",
                "\uD83D\uDCC8 \u0130statistikler artt\u0131r\u0131l\u0131yor",
                "\uD83E\uDD16 Anlam bilimi \xf6\u011Freniliyor",
                "\uD83C\uDFA8 Aray\xfcz yeniden tasarlan\u0131yor",
                "\uD83D\uDCC5 Foto\u011Fraf haritalama partileri planla",
                "\uD83E\uDDC0 Olgunla\u015Fan \xe7edarlar",
                "\uD83C\uDF04 Cornwall g\xfcne\u015F \u0131\u015F\u0131\u011F\u0131n\u0131n hesaplanmas\u0131",
                "\uD83C\uDF0A Y\xfcksek gelgitlerin \xf6l\xe7\xfcm\xfc"
            ],
            error_pic: "\u0130stenen resim bulunamad\u0131",
            error_nopic: "Belirtilen konumda resim mevcut de\u011Fil",
            error_api: "Resim sunucusu kullan\u0131lam\u0131yor",
            error_webgl: "Taray\u0131c\u0131n\u0131z WebGL'yi desteklemiyor",
            error_josm: "JOSM yan\u0131t vermedi, \xe7al\u0131\u015F\u0131yor mu ve Uzaktan Kumanda etkin mi?",
            error_api_compatibility: "Resim sunucusu bu g\xf6r\xfcnt\xfcleyici s\xfcr\xfcm\xfcyle uyumlu de\u011Fil",
            filter_date: "Tarih",
            filter_date_1month: "1 ay",
            filter_date_6months: "6 ay",
            filter_date_1year: "1 y\u0131l",
            filter_user: "Kullan\u0131c\u0131",
            filter_user_mypics: "Resimlerim",
            filter_picture: "Resim tipi",
            filter_zoom_in: "Kilidi a\xe7mak i\xe7in yak\u0131nla\u015Ft\u0131r\u0131n",
            picture_all: "T\xfcm\xfc",
            picture_flat: "Klasik",
            picture_360: "360\xb0",
            picture_flat_long: "Klasik resim",
            filter_qualityscore_help: "Etkinle\u015Ftirmek veya devre d\u0131\u015F\u0131 b\u0131rakmak i\xe7in t\u0131klay\u0131n",
            qualityscore_title: "Kalite skoru hakk\u0131nda",
            qualityscore_doc_link: "Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin",
            map_background: "Arkaplan",
            map_theme: "Tema",
            map_theme_default: "Varsay\u0131lan",
            map_theme_age: "Yakalama tarihi",
            map_theme_age_1: "> 3 y\u0131l",
            map_theme_age_2: "< 3 y\u0131l",
            map_theme_age_3: "\xbd - 1 y\u0131l",
            map_theme_age_4: "< 6 ay",
            map_theme_type: "Kamera tipi",
            map_theme_score: "Kalite skoru",
            metadata_general_copy_id: "ID Kopyala",
            metadata_general_copy_picid: "Resim ID kopyala",
            metadata_general_author: "Yazar",
            metadata_general_date: "Yakalama tarihi",
            metadata_general_instance: "K\xf6ken \xf6rne\u011Fi",
            metadata_camera_focal_length: "Odak uzakl\u0131\u011F\u0131",
            metadata_location_orientation: "Y\xf6n",
            metadata_location_copy: "Kopyala {v}",
            metadata_location_precision: "Konumland\u0131rma hassasiyeti",
            metadata_quality_help: "Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin",
            metadata_quality_score: "K\xfcresel skor",
            metadata_quality_gps_score: "Pozisyon skoru",
            metadata_quality_missing: "resimde herhangi bir de\u011Fer belirtilmemi\u015F",
            metadata_exif_doc: "EXIF etiketleri i\xe7in belgeler",
            semantics_tags: "{nb} etiketler",
            semantics_features: "Resim \xf6zellikleri",
            semantics_features_none: "Bu resimde hen\xfcz hi\xe7bir \xf6zellik \xe7izilmedi.",
            semantics_features_default_title: "Etiket {nb}",
            semantics_value_doc: "Bu etiket hakk\u0131nda daha fazla bilgi edinin",
            semantics_features_subtitle: "{nb} ili\u015Fkili \xf6zellikler",
            semantics_key: "Anahtar",
            semantics_key_doc: "Bu anahtar hakk\u0131nda daha fazla bilgi edinin",
            semantics_qualifiers: "Niteleyiciler",
            semantics_draw_annotation: "Resmin \xfczerine eklemek istedi\u011Finiz nesneyi \xe7izebilirsiniz (Opsiyonel).",
            semantics_login_needed: "Resim etiketlerini veya \xf6zelliklerini d\xfczenlemek i\xe7in Panoramax {n} \xf6rne\u011Finde oturum a\xe7man\u0131z gerekir. Oturum a\xe7mak istiyor musunuz?",
            report_email_placeholder: "\u0130ste\u011Fe ba\u011Fl\u0131",
            semantics_add_annotation: "Yeni bir etiket ekle",
            semantics_erase_annotation: "\xc7izilmi\u015F \xf6zelli\u011Fi sil",
            semantics_doc: "Yard\u0131m",
            semantics_doc_title: "Etiketler hakk\u0131nda",
            semantics_show_annotations: "Resim \xf6zelliklerini g\xf6r\xfcnt\xfcle",
            semantics_hide_annotations: "Resim \xf6zelliklerini gizle",
            semantics_zero_annotations: "Bu resimde hi\xe7bir \xf6zellik \xe7izilmedi",
            report: "Rapor et",
            report_auth: 'Bu rapor "{a}" hesab\u0131n\u0131z kullan\u0131larak g\xf6nderilecektir',
            report_nature_label: "Sorunun nedeni",
            semantics_doc_info3: "Baz\u0131 nesneler yapay zeka ile otomatik olarak alg\u0131lan\u0131yor: kalite garanti edilmiyor.",
            semantics_doc_link: "Etiketler hakk\u0131nda daha fazla bilgi edinin",
            report_whole_sequence: "Bu t\xfcm sekans\u0131 ilgilendiriyor",
            report_details: "Ek ayr\u0131nt\u0131lar",
            report_details_placeholder: "\u0130ste\u011Fe ba\u011Fl\u0131 olarak sorunla ilgili ayr\u0131nt\u0131lar\u0131 ekleyebilirsiniz",
            report_email: "Eposta adresin",
            metadata_exif_doc_title: "EXIF ve XMP etiket tan\u0131mlar\u0131n\u0131n t\xfcm ayr\u0131nt\u0131lar\u0131n\u0131 g\xf6rmek i\xe7in Exiv2 dok\xfcman\u0131na gidin",
            report_failure: "{e} raporu olu\u015Fturulurken bir hata olu\u015Ftu. L\xfctfen daha sonra tekrar deneyin.",
            error_psv: "Foto\u011Fraf K\xfcresi G\xf6r\xfcnt\xfcleyicisi d\xfczg\xfcn y\xfcklenmiyor",
            picture_360_long: "Panoramic resim",
            report_success: "Rapor ba\u015Far\u0131yla g\xf6nderildi. En k\u0131sa s\xfcrede incelenecektir.",
            filter_qualityscore: "Kalite skoru",
            metadata_location_coordinates: "Koordinatlar (boylam, enlem)",
            semantics_doc_info2: "Resimdeki nesneleri de \xe7izebilirsiniz: yol i\u015Faretleri, \u015Fehir ekipmanlar\u0131... G\xf6rd\xfcklerinizi mevcut etiketleri kullanarak i\u015Faretleyin. Gerekirse kendi etiketlerinizi de olu\u015Fturabilirsiniz.",
            map_background_aerial: "Havadan",
            qualityscore_doc_3: '"A" en iyi not, "E" en k\xf6t\xfc nottur.',
            metadata_location_copy_more: "Daha fazla koordinat kopyalama se\xe7ene\u011Fi",
            report_submit: "G\xf6nder",
            qualityscore_doc_2: "Puan, harf olarak g\xf6sterilir:",
            semantics_doc_info1: "Etiketler kullanarak bir resme ba\u011Flam kazand\u0131r\u0131n.",
            qualityscore_doc_1: "Her resim i\xe7in bir Kalite Puan\u0131 hesaplan\u0131r.",
            metadata_camera_make: "Olu\u015Ftur",
            semantics_wikidata_properties: {
                P31: "\xf6rne\u011Fi",
                P279: "alt s\u0131n\u0131f\u0131",
                P361: "par\xe7as\u0131",
                P180: "tasvir eder"
            },
            semantics_editor_error: "S\xf6zdizimi ge\xe7ersiz. Etiketleriniz \u015F\xf6yle g\xf6r\xfcnebilir:\nkey=value\nprefix|key=value\nprefix|key[qualif_key=qualif_val]=value\n\nMaksimum anahtar uzunlu\u011Fu 256 karakter, maksimum de\u011Fer uzunlu\u011Fu 2048 karakterdir.",
            semantics_send_fail: "De\u011Fi\u015Fiklikleriniz kaydedilemedi, l\xfctfen daha sonra tekrar deneyin",
            semantics_editor_example: "key=value\nprefix|key=value",
            semantics_edit: "Nitelikleri d\xfczenle",
            semantics_undo: "D\xfczenlemelerinizi iptal edin",
            semantics_sequence_tags: "Sekans etiketi",
            semantics_picture_tags: "Resim etiketi",
            semantics_annotation_tags: "Nesne etiketi",
            filter_gps_precision_lessthan: "{n} metreden az",
            filter_gps_precision_morethan: "{n} metreden fazla",
            filter_gps_precision: "Konum hassasiyeti",
            filter_gps_precision_between: "{n1} ile {n2} metre aras\u0131nda",
            map_theme_gps: "GPS hassasiyeti",
            semantics_overlays: {
                tfsigns: "Trafik i\u015Faretleri",
                features: "T\xfcm \xf6zellikler"
            },
            semantics_download: "\u0130ndir",
            semantics_doc_info1u1: '"transport=car" etiketini kullanarak, foto\u011Fraf\u0131n ara\xe7 taraf\u0131ndan \xe7ekildi\u011Fini belirtebilirsiniz.',
            semantics_zoom_in: "Etiketleri g\xf6rmek i\xe7in haritay\u0131 yak\u0131nla\u015Ft\u0131r\u0131n",
            semantics_download_title: "Etiketleri indir",
            semantics_download_cta: "A\xe7\u0131k verileri indirin",
            semantics_download_info: "T\xfcm anlamsal veriler (etiketler) a\xe7\u0131k veri olarak mevcuttur. Bunlar\u0131 diledi\u011Finiz gibi indirebilir ve kullanabilirsiniz.",
            semantics_copy: "\xd6zellikleri kopyala",
            semantics_value_show_osm: "OpenStreetMap'te g\xf6r\xfcnt\xfcle",
            filter_gps_precision_help: "Konum Hassasiyeti hakk\u0131nda daha fazla bilgi edinin",
            filter_gps_precision_help_1: "Her foto\u011Fraf i\xe7in bir Konum Hassasiyeti puan\u0131 mevcuttur. Bu, foto\u011Fraf \xe7ekimi s\u0131ras\u0131nda GPS hassasiyetine kar\u015F\u0131l\u0131k gelir.",
            filter_gps_precision_help_2: "Hassasiyet y\u0131ld\u0131zlarla ifade edilir:",
            filter_gps_precision_help_3: '"5\u2B50" \xe7ok hassast\u0131r (<= {p5}m), "1\u2B50" ise \xe7ok belirsizdir (> {p1}m) veya bilinmemektedir.',
            qualityscore_doc_4: "Bu puan a\u015Fa\u011F\u0131daki kriterlere g\xf6re hesaplan\u0131r:",
            qualityscore_doc_41: "GPS hassasiyeti",
            qualityscore_doc_42: "resim \xe7\xf6z\xfcn\xfcrl\xfc\u011F\xfc",
            qualityscore_doc_5: "Profesyonel bir cihaz A s\u0131n\u0131f\u0131, 360\xb0 aksiyon kameras\u0131 B s\u0131n\u0131f\u0131, ak\u0131ll\u0131 telefon ise C ile E aras\u0131nda bir s\u0131n\u0131fa sahip olacakt\u0131r.",
            filter_gps_precision_help_4: 'RTK GPS cihazlar\u0131 "5\u2B50" puan al\u0131rken, GoPro Max gibi aksiyon kameralar\u0131 "3\u2B50" puan, yer alt\u0131 otopark\u0131ndaki ak\u0131ll\u0131 telefon GPS\'leri ise "1\u2B50" puan alacakt\u0131r.',
            popup_details_link: "Daha fazla detay",
            indoor_selector_shrink: "K\xfc\xe7\xfcltmek i\xe7in t\u0131klay\u0131n",
            indoor_selector_leveldown: "Alt kata inin",
            indoor_selector_scrollup: "Seviye listesini yukar\u0131 kayd\u0131r\u0131n",
            indoor_selector_scrolldown: "Seviye listesini a\u015Fa\u011F\u0131 kayd\u0131r\u0131n",
            indoor_switch: "\u0130\xe7 mekanlar",
            indoor_selector_expand: "Mevcut t\xfcm seviyeleri g\xf6rmek i\xe7in t\u0131klay\u0131n",
            indoor_selector_levelup: "\xdcst kata \xe7\u0131k\u0131n",
            "visibility_logged-only": "\xdcyeler",
            "visibility_title_logged-only": "Bu resmi yaln\u0131zca hesab\u0131 olanlar g\xf6rebilir",
            "visibility_owner-only": "Gizli",
            "visibility_title_owner-only": "Bu resmi sadece sen g\xf6rebilirsin",
            filter_source_world: "T\xfcm d\xfcnya",
            filter_source_local: "Bu sunucu",
            filter_locked: "Filtre devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131",
            map_background_default: "Varsay\u0131lan",
            map_background_more: "Daha fazla",
            semantics_draw_invalid_annotation: "\xc7izilen alan, resmin s\u0131n\u0131rlar\u0131n\u0131 a\u015F\u0131yor. L\xfctfen g\xf6r\xfcn\xfcr resim alan\u0131 i\xe7inde \xe7izim yapmaya \xf6zen g\xf6sterin.",
            semantics_draw_unfinished_annotation: "\xc7izilen alan hen\xfcz tamamlanmad\u0131. Kaydetmeden \xf6nce alan\u0131n do\u011Fru konumland\u0131r\u0131ld\u0131\u011F\u0131ndan emin olun.",
            error_pic_load: "Bu resim \u015Fu anda y\xfcklenemiyor.\nL\xfctfen internet ba\u011Flant\u0131n\u0131z\u0131 kontrol edin. Ba\u011Flant\u0131n\u0131z varsa, resimdeki kimli\u011Fin ge\xe7erli oldu\u011Fundan emin olun.",
            semantics_empty: "Hi\xe7bir etiket tan\u0131mlanmad\u0131",
            low_contrast: "G\xf6r\xfcnt\xfc kontrast\u0131n\u0131 d\xfc\u015F\xfcr\xfcn",
            reset_contrast: "G\xf6r\xfcnt\xfc kontrast\u0131n\u0131 s\u0131f\u0131rla",
            delete_picture: "Sil",
            delete_picture_warn: "\u26A0\uFE0F Dikkat: Bu i\u015Flem bu resmi kal\u0131c\u0131 olarak silecektir.\nDevam etmek istedi\u011Finizden emin misiniz?",
            delete_picture_ok: "Resim ba\u015Far\u0131yla silindi",
            delete_picture_error: "Resim silinmeye \xe7al\u0131\u015F\u0131l\u0131rken bir hata olu\u015Ftu:\n{e}",
            metadata_general_title: "Ba\u015Fl\u0131k",
            time_travel: "Bu yeri di\u011Fer tarihlerde de g\xf6r\xfcn",
            time_travel_close: "Di\u011Fer tarihleri gizle",
            map_theme_default_short: "Varsay\u0131lan",
            map_theme_age_short: "Tarih",
            map_theme_type_short: "Kamera",
            map_theme_score_short: "Kalite",
            map_theme_gps_short: "Pozisyon",
            map_theme_default_coef_short: "Kapsam",
            map_theme_default_1: "D\xfc\u015F\xfck",
            map_theme_default_2: "Ortalama",
            map_theme_default_3: "\u0130yi",
            map_theme_default_4: "Harika",
            widget_locked: "Se\xe7enek devre d\u0131\u015F\u0131 b\u0131rak\u0131ld\u0131",
            map_theme_default_coef: "Kapsama d\xfczeyi",
            sequence_play_backwards: "Bu sekans\u0131 geriye do\u011Fru oynat\u0131n",
            semantics_annotation_tooltip_close: "Se\xe7imi kald\u0131rmak i\xe7in t\u0131klay\u0131n"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "Konumu bul",
            "GeolocateControl.LocationNotAvailable": "Lokasyon mevcut de\u011Fil"
        },
        map: {
            thumbnail: "\xdczerine gelinen k\xfc\xe7\xfck resim",
            not_public: "Kamuya a\xe7\u0131k de\u011Fil",
            slow_loading: "Harita yava\u015F y\xfckleniyor ve bozuk g\xf6r\xfcnebilir",
            map_data: "{m} temelli harita",
            loading: "Y\xfckleniyor\u2026",
            more_panoramax: "Panoramax hakk\u0131nda daha fazla bilgi edinin"
        }
    },
    uk: {
        psv: {
            twoFingers: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0434\u0432\u0430 \u043F\u0430\u043B\u044C\u0446\u0456 \u0434\u043B\u044F \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0457",
            ctrlZoom: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u043A\u043E\u043C\u0431\u0456\u043D\u0430\u0446\u0456\u044E \u043A\u043B\u0430\u0432\u0456\u0448 Ctrl + \u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430, \u0449\u043E\u0431 \u0437\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            loadError: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0430"
        },
        maplibre: {
            "GeolocateControl.FindMyLocation": "\u0417\u043D\u0430\u0439\u0442\u0438 \u043C\u043E\u0454 \u043C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
            "GeolocateControl.LocationNotAvailable": "\u041C\u0456\u0441\u0446\u0435\u0437\u043D\u0430\u0445\u043E\u0434\u0436\u0435\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435"
        },
        pnx: {
            zoomOut: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438",
            zoom: "\u041C\u0430\u0441\u0448\u0442\u0430\u0431\u0443\u0432\u0430\u043D\u043D\u044F",
            zoomIn: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
            moveDown: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437",
            moveLeft: "\u0420\u0443\u0445\u0430\u0442\u0438\u0441\u044F \u043B\u0456\u0432\u043E\u0440\u0443\u0447",
            moveUp: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
            moveMiddle: "\u0426\u0435\u043D\u0442\u0440\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0434",
            moveRight: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438\u0441\u044F \u0432\u043F\u0440\u0430\u0432\u043E",
            expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
            show_psv: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0447 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            show_map: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0443",
            minimize: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0432\u0456\u0434\u0436\u0435\u0442, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0439\u043E\u0433\u043E \u0437\u043D\u043E\u0432\u0443 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u043A\u043D\u043E\u043F\u043A\u0438 \u0432 \u043D\u0438\u0436\u043D\u044C\u043E\u043C\u0443 \u043B\u0456\u0432\u043E\u043C\u0443 \u043A\u0443\u0442\u0456",
            minimize_short: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438",
            options: "\u041E\u043F\u0446\u0456\u0457",
            filters: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438",
            layers: "\u0428\u0430\u0440\u0438",
            search: "\u041F\u043E\u0448\u0443\u043A",
            search_empty: "\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0456",
            search_user: "\u041F\u043E\u0448\u0443\u043A \u0456\u043C\u0435\u043D\u0456 \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u2026",
            share_links: "\u041B\u0456\u043D\u043A\u0438",
            share_image: "HD-\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            share_rss: "RSS-\u043A\u0430\u043D\u0430\u043B",
            share_embed: "\u0412\u0431\u0443\u0434\u0443\u0432\u0430\u0442\u0438 \u043D\u0430 \u0441\u0432\u0456\u0439 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442",
            share_embed_docs: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E \u0432\u0431\u0443\u0434\u043E\u0432\u0443\u0432\u0430\u043D\u043D\u044F",
            share_print: "\u0414\u0440\u0443\u043A",
            panoramax: "Panoramax",
            copy: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
            copied: "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E",
            error: "\u0423 \u043D\u0430\u0441 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u2026",
            error_click: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438",
            error_retry: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435",
            sequence_play: "\u0412\u0456\u0434\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u0446\u044E \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C",
            sequence_pause: "\u041F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u0430\u0443\u0437",
            sequence_prev: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            sequence_more: "\u0411\u0456\u043B\u044C\u0448\u0435 \u0432\u0430\u0440\u0456\u0430\u043D\u0442\u0456\u0432 \u0433\u0440\u0438",
            legend_license: "\u041B\u0456\u0446\u0435\u043D\u0437\u0456\u044F: {l}",
            legend_title: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            id: "iD",
            geo_uri: "\u0417\u043E\u0432\u043D\u0456\u0448\u043D\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u0430",
            josm: "JOSM",
            loading_labels_serious: [
                "\uD83D\uDDFA\uFE0F \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445 \u043A\u0430\u0440\u0442\u0438",
                "\uD83D\uDDA5\uFE0F \u0417\u0430\u043F\u0438\u0442 API",
                "\uD83D\uDDBC\uFE0F \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u0456\u043D\u0456\u0430\u0442\u044E\u0440",
                "\uD83D\uDD0D \u0410\u043D\u0430\u043B\u0456\u0437 \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u0438\u0445 EXIF",
                "\uD83C\uDFD8\uFE0F 3D-\u0432\u0456\u0437\u0443\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F",
                "\uD83D\uDCF7 \u0406\u043D\u0456\u0446\u0456\u0430\u043B\u0456\u0437\u0430\u0446\u0456\u044F 360\xb0-\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
                "\uD83D\uDFE0 \u0411\u0430\u043B\u0430\u043D\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043B\u044C\u043E\u0440\u0456\u0432",
                "\uD83D\uDCAF \u041E\u0431\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044F \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A\u0430 \u044F\u043A\u043E\u0441\u0442\u0456 \xa9",
                "\uD83D\uDCE1 \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u044C",
                "\uD83C\uDF0D \u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442\u0456\u0432 \u043A\u0430\u0440\u0442\u0438",
                "\uD83D\uDCF8 \u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u0442\u0456\u043D\u0435\u0439"
            ],
            expand_info: "\u0417\u0440\u043E\u0431\u0438\u0442\u0438 \u0432\u0456\u0434\u0436\u0435\u0442 \u0432\u0438\u0434\u0438\u043C\u0438\u043C \u043D\u0430 \u0432\u0441\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
            search_address: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0430\u0434\u0440\u0435\u0441\u043E\u044E, \u043C\u0456\u0441\u0442\u043E\u043C\u2026",
            sequence_speed: "\u0428\u0432\u0438\u0434\u043A\u0456\u0441\u0442\u044C \u0433\u0440\u0430\u0432\u0446\u044F",
            share_rss_title: "RSS-\u043A\u0430\u043D\u0430\u043B \u043D\u043E\u0432\u0438\u0445 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0435\u0439 \u0443 \u043F\u043E\u0442\u043E\u0447\u043D\u0456\u0439 \u0432\u0438\u0434\u0438\u043C\u0456\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0456 \u043A\u0430\u0440\u0442\u0438",
            whats_panoramax: "Panoramax \u2014 \u0446\u0435 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0456\u0447\u043D\u0430 \u0431\u0430\u0437\u0430 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u0442\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u0439.",
            share: "\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F",
            share_page: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0446\u044E \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0443",
            sequence_next: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0432 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            contribute_id: "\u0414\u043E\u043B\u0443\u0447\u0456\u0442\u044C\u0441\u044F \u0434\u043E OpenStreetMap \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0430 iD",
            josm_live: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u0443 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0430\u0446\u0456\u044E JOSM \u043F\u0456\u0434 \u0447\u0430\u0441 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            loading_labels_fun: [
                "\uD83E\uDD8C \u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u043D\u0430\u043A\u0456\u0432 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0443 \u0434\u043B\u044F \u043E\u043B\u0435\u043D\u0456\u0432",
                "\uD83D\uDE98 \u041F\u043E\u0448\u0443\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044F Panoramax \xa9",
                "\u2615 \u0406\u043D'\u0454\u043A\u0446\u0456\u0457 \u043A\u043E\u0444\u0435\u0457\u043D\u0443",
                "\uD83D\uDE00 \u041F\u043E\u0441\u043C\u0456\u0445\u043D\u0438\u0441\u044F, \u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456!",
                "\uD83D\uDC08 \u0414\u0456\u043B\u044E\u0441\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u044F\u043C\u0438 \u043A\u043E\u0442\u0456\u0432",
                "\uD83D\uDE34 \u0417\u043C\u0435\u043D\u0448\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u043A\u0440\u0430\u0441\u0442\u0438\u043D\u0430\u0446\u0456\u0457",
                "\uD83E\uDED6 \u0417\u0430\u0432\u0430\u0440\u044E\u0432\u0430\u043D\u043D\u044F \u0447\u0430\u044E",
                "\uD83D\uDC27 \u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u0432\u0438\u0445\u0456\u0434\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0443",
                "\uD83D\uDE87 \u0406\u043D\u0434\u0435\u043A\u0441\u0443\u0432\u0430\u043D\u043D\u044F \u0441\u0442\u0430\u043D\u0446\u0456\u0439 \u043C\u0435\u0442\u0440\u043E",
                "\uD83E\uDDF9 \u041E\u0447\u0438\u0449\u0435\u043D\u043D\u044F \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u0438\u0445",
                "\uD83D\uDE92 \u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0439 \u043F\u043E\u0436\u0435\u0436\u043D\u043E\u0457 \u0441\u0442\u0430\u043D\u0446\u0456\u0457",
                "\uD83D\uDEB2 \u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0437\u0435\u043B\u0435\u043D\u0438\u0445 \u0441\u0442\u0435\u0436\u043E\u043A",
                "\uD83D\uDE89 \u041E\u0433\u043B\u044F\u0434 \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u0438 \u0441\u0442\u0430\u043D\u0446\u0456\u0457",
                "\uD83D\uDEF0\uFE0F \u041F\u043E\u0448\u0443\u043A \u0441\u0443\u043F\u0443\u0442\u043D\u0438\u043A\u0456\u0432",
                "\uD83D\uDC65 \u041F\u0438\u0441\u044C\u043C\u0435\u043D\u043D\u0438\u0446\u044C\u043A\u0456 \u043F\u0435\u0440\u0441\u043E\u043D\u0438",
                "\uD83D\uDC1F \u041F\u043E\u0448\u0443\u043A \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0456\u0432 \u0447\u0456\u043F\u0441\u0456\u0432",
                "\uD83E\uDDD1\u200D\uD83D\uDCBB \u0406\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043D\u0430\u043B\u0430\u0433\u043E\u0434\u0436\u0435\u043D\u043D\u044F",
                "\uD83D\uDCC8 \u0417\u0431\u0456\u043B\u044C\u0448\u0435\u043D\u043D\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0438",
                "\uD83E\uDD16 \u0412\u0438\u0432\u0447\u0435\u043D\u043D\u044F \u0441\u0435\u043C\u0430\u043D\u0442\u0438\u043A\u0438",
                "\uD83C\uDFA8 \u0420\u0435\u0434\u0438\u0437\u0430\u0439\u043D \u0456\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0443",
                "\uD83D\uDCC5 \u041F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u0432\u0435\u0447\u0456\u0440\u043E\u043A \u0437 \u0444\u043E\u0442\u043E\u043C\u0435\u043F\u0456\u043D\u0433\u043E\u043C",
                "\uD83E\uDDC0 \u0412\u0438\u0437\u0440\u0456\u043B\u0438\u0439 \u0447\u0435\u0434\u0434\u0435\u0440",
                "\uD83C\uDF04 \u0420\u043E\u0437\u0440\u0430\u0445\u0443\u043D\u043E\u043A \u043A\u043E\u0440\u043D\u0443\u043E\u043B\u044C\u0441\u044C\u043A\u043E\u0457 \u0441\u043E\u043D\u044F\u0447\u043D\u043E\u0457 \u0435\u043D\u0435\u0440\u0433\u0456\u0457",
                "\uD83C\uDF0A \u0412\u0438\u043C\u0456\u0440\u044E\u0432\u0430\u043D\u043D\u044F \u043F\u0440\u0438\u043F\u043B\u0438\u0432\u0456\u0432"
            ],
            error_psv: "\u041F\u0440\u043E\u0433\u0440\u0430\u043C\u0430 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0443 \u0444\u043E\u0442\u043E\u0441\u0444\u0435\u0440 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430\u043B\u0435\u0436\u043D\u0438\u043C \u0447\u0438\u043D\u043E\u043C",
            error_pic: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
            error_nopic: "\u0423 \u0432\u043A\u0430\u0437\u0430\u043D\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456 \u043D\u0435\u043C\u0430\u0454 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            error_api: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
            error_webgl: "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 WebGL",
            error_josm: "JOSM \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454, \u0447\u0438 \u043F\u0440\u0430\u0446\u044E\u0454 \u0432\u0456\u043D \u0456 \u0447\u0438 \u0443\u0432\u0456\u043C\u043A\u043D\u0435\u043D\u043E \u0432\u0456\u0434\u0434\u0430\u043B\u0435\u043D\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F?",
            error_api_compatibility: "\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C \u043D\u0435 \u0441\u0443\u043C\u0456\u0441\u043D\u0438\u0439 \u0437 \u0446\u0456\u0454\u044E \u0432\u0435\u0440\u0441\u0456\u0454\u044E \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0447\u0430",
            filter_date: "\u0414\u0430\u0442\u0430",
            filter_date_1month: "1 \u043C\u0456\u0441\u044F\u0446\u044C",
            filter_date_6months: "6 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            filter_date_1year: "1 \u0440\u0456\u043A",
            filter_user: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
            filter_user_mypics: "\u041C\u043E\u0457 \u0444\u043E\u0442\u043E\u0433\u0440\u0430\u0444\u0456\u0457",
            filter_picture: "\u0422\u0438\u043F \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            filter_zoom_in: "\u0417\u0431\u0456\u043B\u044C\u0448\u0442\u0435 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u043A\u0430\u0440\u0442\u0438, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0446\u0435\u0439 \u0444\u0456\u043B\u044C\u0442\u0440",
            picture_all: "\u0423\u0441\u0456",
            picture_flat: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0438\u0439",
            picture_360: "360\xb0",
            picture_flat_long: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0430 \u043A\u0430\u0440\u0442\u0438\u043D\u0430",
            picture_360_long: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u043D\u0435 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            filter_qualityscore: "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            filter_qualityscore_help: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u0443\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0430\u0431\u043E \u0432\u0438\u043C\u043A\u043D\u0443\u0442\u0438",
            qualityscore_title: "\u041F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            qualityscore_doc_1: "Panoramax \u043F\u0440\u043E\u043F\u043E\u043D\u0443\u0454 \u043E\u0446\u0456\u043D\u043A\u0443 \u044F\u043A\u043E\u0441\u0442\u0456 \u0434\u043B\u044F \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F. \u0426\u0435 \u0434\u043E\u0437\u0432\u043E\u043B\u044F\u0454 \u043B\u0435\u0433\u043A\u043E \u0444\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043A\u0430\u0440\u0442\u0438 \u0442\u0430 \u043F\u043E\u0432\u043D\u0435 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0445 \u0432\u0438\u0441\u043E\u043A\u043E\u044F\u043A\u0456\u0441\u043D\u0438\u0445 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C.",
            qualityscore_doc_2: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043C \u0443 \u0432\u0438\u0433\u043B\u044F\u0434\u0456 \u0431\u0430\u043B\u0456\u0432 A/B/C/D/E (A \u2013 \u043D\u0430\u0439\u043A\u0440\u0430\u0449\u0438\u0439, E \u2013 \u043D\u0430\u0439\u0433\u0456\u0440\u0448\u0438\u0439) \u0442\u0430 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0433\u0440\u0430\u0444\u0456\u0447\u043D\u043E \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0456\u0454\u0457 \u0448\u043A\u0430\u043B\u0438:",
            qualityscore_doc_3: "\u0412\u0456\u043D \u0440\u043E\u0437\u0440\u0430\u0445\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0456 GPS \u0442\u0430 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u043E\u0457 \u0437\u0434\u0430\u0442\u043D\u043E\u0441\u0442\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F. \u041F\u0440\u043E\u0444\u0435\u0441\u0456\u0439\u043D\u0430 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043C\u0430\u0442\u0438\u043C\u0435 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 A, \u0435\u043A\u0448\u043D-\u043A\u0430\u043C\u0435\u0440\u0430 \u043D\u0430 360\xb0 \u2014 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 B, \u0430 \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D \u2014 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 C/D/E.",
            qualityscore_doc_link: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            map_background: "\u0424\u043E\u043D \u043A\u0430\u0440\u0442\u0438",
            map_background_aerial: "\u0421\u0443\u043F\u0443\u0442\u043D\u0438\u043A\u043E\u0432\u0438\u0439",
            map_background_streets: "\u0412\u0443\u043B\u0438\u0446\u0456",
            map_theme: "\u0422\u0435\u043C\u0430 \u043A\u0430\u0440\u0442\u0438",
            map_theme_default: "\u041A\u043B\u0430\u0441\u0438\u0447\u043D\u0438\u0439",
            map_theme_age: "\u0414\u0430\u0442\u0430 \u0437\u0439\u043E\u043C\u043A\u0438",
            map_theme_age_1: "> 3 \u0440\u043E\u043A\u0456\u0432",
            map_theme_age_2: "< 3 \u0440\u043E\u043A\u0456\u0432",
            map_theme_age_3: "< 1 \u0440\u043E\u043A\u0443",
            map_theme_age_4: "< 6 \u043C\u0456\u0441\u044F\u0446\u044F",
            map_theme_type: "\u0422\u0438\u043F \u043A\u0430\u043C\u0435\u0440\u0438",
            map_theme_score: "\u041F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            contrast: "\u0423\u0432\u0456\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0438\u0449\u0443 \u043A\u043E\u043D\u0442\u0440\u0430\u0441\u0442\u043D\u0456\u0441\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata: "\u041C\u0435\u0442\u0430\u0434\u0430\u043D\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_summary: "\u041A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0437\u043C\u0456\u0441\u0442",
            metadata_general_copy_id: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440",
            metadata_general_picid: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_seqid: "\u041F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u0456\u0441\u0442\u044C",
            metadata_general_copy_picid: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_picid_link: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E JSON-\u043E\u043F\u0438\u0441\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            metadata_general_seqid_link: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E JSON-\u043E\u043F\u0438\u0441\u0443 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            metadata_general_author: "\u0410\u0432\u0442\u043E\u0440",
            metadata_general_license: "\u041B\u0456\u0446\u0435\u043D\u0437\u0456\u044F",
            metadata_general_license_link: "\u0414\u0438\u0432. \u043F\u043E\u0432\u043D\u0438\u0439 \u043E\u043F\u0438\u0441 \u043B\u0456\u0446\u0435\u043D\u0437\u0456\u0457",
            metadata_general_date: "\u0414\u0430\u0442\u0430 \u0437\u0439\u043E\u043C\u043A\u0438",
            metadata_camera: "\u041A\u0430\u043C\u0435\u0440\u0430",
            metadata_camera_make: "\u0417\u0440\u043E\u0431\u0438\u0442\u0438",
            metadata_general_instance: "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0435\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440",
            metadata_camera_model: "\u041C\u043E\u0434\u0435\u043B\u044C",
            metadata_camera_type: "\u0422\u0438\u043F",
            metadata_camera_resolution: "\u0420\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u0430 \u0437\u0434\u0430\u0442\u043D\u0456\u0441\u0442\u044C",
            metadata_location: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F",
            metadata_location_coordinates: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438 (\u0434\u043E\u0432\u0433\u043E\u0442\u0430, \u0448\u0438\u0440\u043E\u0442\u0430)",
            metadata_location_orientation: "\u041D\u0430\u043F\u0440\u044F\u043C\u043E\u043A",
            metadata_location_precision: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u043E\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
            metadata_location_copy: "\u041A\u043E\u043F\u0456\u044F {v}",
            metadata_location_copy_more: "\u0411\u0456\u043B\u044C\u0448\u0435 \u043E\u043F\u0446\u0456\u0439 \u043A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
            metadata_quality: "\u042F\u043A\u0456\u0441\u0442\u044C",
            metadata_quality_help: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u043F\u043E\u043A\u0430\u0437\u043D\u0438\u043A \u044F\u043A\u043E\u0441\u0442\u0456",
            metadata_quality_score: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0438\u0439 \u0431\u0430\u043B",
            metadata_quality_gps_score: "\u041E\u0446\u0456\u043D\u043A\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u043E\u043D\u0443\u0432\u0430\u043D\u043D\u044F",
            metadata_quality_resolution_score: "\u041E\u0446\u0456\u043D\u043A\u0430 \u0440\u043E\u0437\u0434\u0456\u043B\u044C\u043D\u043E\u0457 \u0437\u0434\u0430\u0442\u043D\u043E\u0441\u0442\u0456",
            metadata_exif: "EXIF",
            metadata_exif_name: "\u0422\u0435\u0433",
            metadata_exif_value: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            metadata_exif_doc: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u044F \u0434\u043B\u044F \u0442\u0435\u0433\u0456\u0432 EXIF",
            metadata_exif_doc_title: "\u041F\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044C \u0434\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0456\u0457 Exiv2, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044E \u043F\u0440\u043E \u0432\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0442\u0435\u0433\u0456\u0432 EXIF \u0442\u0430 XMP",
            semantics_title: "\u0422\u0435\u0433\u0438",
            semantics_tags: "\u0442\u0435\u0433\u0438 {nb}",
            semantics_features_subtitle: "{nb} \u043F\u043E\u0432'\u044F\u0437\u0430\u043D\u0456 \u0432\u043B\u0430\u0441\u0442\u0438\u0432\u043E\u0441\u0442\u0456",
            semantics_annotation_tooltip: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456",
            semantics_show_all_tags: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438",
            semantics_hide_all_tags: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438",
            semantics_key: "\u041A\u043B\u044E\u0447",
            semantics_value: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_key_doc: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0446\u0435\u0439 \u043A\u043B\u044E\u0447",
            semantics_value_doc: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0446\u0435\u0439 \u0442\u0435\u0433",
            semantics_tags_picture: "\u0422\u0435\u0433\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            semantics_tags_picture_none: "\u0414\u043B\u044F \u0446\u044C\u043E\u0433\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0436\u043E\u0434\u043D\u0438\u0445 \u0442\u0435\u0433\u0456\u0432.",
            semantics_qualifiers: "\u041A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0442\u043E\u0440\u0438",
            semantics_features: "\u041E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            semantics_features_default_title: "\u0422\u0435\u0433 {nb}",
            semantics_features_none: "\u041D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u0449\u0435 \u043D\u0435 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u043E \u0436\u043E\u0434\u043D\u043E\u0457 \u043E\u0441\u043E\u0431\u043B\u0438\u0432\u043E\u0441\u0442\u0456.",
            semantics_show_annotations: "\u0424\u0443\u043D\u043A\u0446\u0456\u0457 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0430 \u0434\u0438\u0441\u043F\u043B\u0435\u0457",
            metadata_camera_focal_length: "\u0424\u043E\u043A\u0443\u0441\u043D\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043D\u044C",
            metadata_quality_missing: "\u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u043D\u0435 \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_draw_annotation: "\u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430\u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0438\u0439 \u043E\u0431'\u0454\u043A\u0442 \u043F\u043E\u0432\u0435\u0440\u0445 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F (\u043D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E).",
            semantics_save_drawn_annotation: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043F\u043E\u0437\u0438\u0446\u0456\u044E",
            semantics_undo_drawn_annotation: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
            semantics_delete_annotation: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u043E\u0431'\u0454\u043A\u0442",
            semantics_hashtags: "\u0425\u0435\u0448\u0442\u0435\u0433\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C",
            semantics_wikidata_properties: {
                P31: "\u043F\u0440\u0438\u043A\u043B\u0430\u0434",
                P279: "\u043F\u0456\u0434\u043A\u043B\u0430\u0441",
                P361: "\u0447\u0430\u0441\u0442\u0438\u043D\u0430"
            },
            semantics_editor_error: "\u0421\u0438\u043D\u0442\u0430\u043A\u0441\u0438\u0441 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439. \u0412\u0430\u0448\u0456 \u0442\u0435\u0433\u0438 \u043C\u043E\u0436\u0443\u0442\u044C \u0432\u0438\u0433\u043B\u044F\u0434\u0430\u0442\u0438 \u0442\u0430\u043A:\n\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447[\u043A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439_\u043A\u043B\u044E\u0447=\u043A\u0432\u0430\u043B\u0456\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0435_\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F]=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\n\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u043E\u0432\u0436\u0438\u043D\u0430 \u043A\u043B\u044E\u0447\u0430 \u2014 256 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432, \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430 \u0434\u043E\u0432\u0436\u0438\u043D\u0430 \u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u2014 2048 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432.",
            semantics_editor_example: "\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F\n\u043F\u0440\u0435\u0444\u0456\u043A\u0441|\u043A\u043B\u044E\u0447=\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
            semantics_edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0438",
            semantics_save: "\u0417\u0431\u0435\u0440\u0435\u0436\u0456\u0442\u044C \u0437\u043C\u0456\u043D\u0438",
            semantics_undo: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0430\u0448\u0456 \u0437\u043C\u0456\u043D\u0438",
            semantics_cantsave_invalid: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438, \u0432\u0432\u0435\u0434\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u043D\u0435\u0434\u0456\u0439\u0441\u043D\u0456",
            semantics_send_fail: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435",
            semantics_send_ok: "\u0412\u0430\u0448\u0456 \u0437\u043C\u0456\u043D\u0438 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
            report_details: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0435\u0442\u0430\u043B\u0456",
            report_details_placeholder: "\u0417\u0430 \u0431\u0430\u0436\u0430\u043D\u043D\u044F\u043C, \u0432\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043B\u0456 \u043F\u0440\u043E \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0443",
            semantics_zero_annotations: "\u041D\u0430 \u0446\u044C\u043E\u043C\u0443 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456 \u043D\u0435\u043C\u0430\u0454 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0445 \u0440\u0438\u0441",
            semantics_add_annotation: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u0442\u0435\u0433",
            semantics_delete_annotation_confirm: "\u0412\u0438 \u0441\u043F\u0440\u0430\u0432\u0434\u0456 \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0442\u0435\u0433?",
            semantics_login_needed: "\u0429\u043E\u0431 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0435\u0433\u0438 \u0430\u0431\u043E \u043E\u0431'\u0454\u043A\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u044C, \u0432\u0430\u043C \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0443\u0432\u0456\u0439\u0442\u0438 \u0432 \u0435\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440 Panoramax {n}. \u0412\u0438 \u0445\u043E\u0447\u0435\u0442\u0435 \u0443\u0432\u0456\u0439\u0442\u0438?",
            report: "\u0417\u0432\u0456\u0442",
            report_auth: '\u0426\u0435\u0439 \u0437\u0432\u0456\u0442 \u0431\u0443\u0434\u0435 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0437 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u0430\u043D\u043D\u044F\u043C \u0432\u0430\u0448\u043E\u0433\u043E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 "{a}"',
            report_nature_label: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
            report_nature: {
                blur_excess: "\u0414\u043E \u043E\u0431'\u0454\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u043E \u043D\u0435\u043F\u043E\u0442\u0440\u0456\u0431\u043D\u0435 \u0440\u043E\u0437\u043C\u0438\u0442\u0442\u044F",
                inappropriate: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0435\u0434\u043E\u0440\u0435\u0447\u043D\u0435 (\u043D\u0435 \u0441\u0442\u043E\u0441\u0443\u0454\u0442\u044C\u0441\u044F \u0442\u0435\u043C\u0438, \u043E\u0433\u043E\u043B\u0435\u043D\u0435 \u0442\u0456\u043B\u043E\u2026)",
                privacy: "\u0412\u0438\u0434\u043D\u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u0438\u0439 \u0448\u043B\u044F\u0445 \u0430\u0431\u043E \u0432\u043B\u0430\u0441\u043D\u0456\u0441\u0442\u044C",
                mislocated: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0433\u0430\u043D\u043E \u0440\u043E\u0437\u0442\u0430\u0448\u043E\u0432\u0430\u043D\u0435 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
                copyright: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u043E\u0440\u0443\u0448\u0443\u0454 \u0430\u0432\u0442\u043E\u0440\u0441\u044C\u043A\u0456 \u043F\u0440\u0430\u0432\u0430",
                other: "\u0411\u0443\u0434\u044C-\u044F\u043A\u0438\u0439 \u0456\u043D\u0448\u0438\u0439 \u0432\u0438\u0434 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438",
                picture_low_quality: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043D\u0438\u0437\u044C\u043A\u043E\u0457 \u044F\u043A\u043E\u0441\u0442\u0456",
                "": "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0438\u2026",
                blur_missing: "\u0412\u0438\u0434\u043D\u043E \u043E\u0431\u043B\u0438\u0447\u0447\u044F \u043B\u044E\u0434\u0438\u043D\u0438 \u0430\u0431\u043E \u043D\u043E\u043C\u0435\u0440\u043D\u0438\u0439 \u0437\u043D\u0430\u043A \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044F"
            },
            report_email: "\u0412\u0430\u0448\u0430 \u0435\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430 \u0430\u0434\u0440\u0435\u0441\u0430",
            report_email_placeholder: "\u041D\u0435\u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u043E",
            report_submit: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
            report_success: "\u0417\u0432\u0456\u0442 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E. \u0419\u043E\u0433\u043E \u0431\u0443\u0434\u0435 \u0440\u043E\u0437\u0433\u043B\u044F\u043D\u0443\u0442\u043E \u044F\u043A\u043E\u043C\u043E\u0433\u0430 \u0448\u0432\u0438\u0434\u0448\u0435.",
            report_failure: "\u041F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0443 \u0441\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430: {e}. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0441\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
            report_whole_sequence: "\u0426\u0435 \u0441\u0442\u043E\u0441\u0443\u0454\u0442\u044C\u0441\u044F \u0432\u0441\u0456\u0454\u0457 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            report_wait: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0443\u2026",
            semantics_save_drawn_annotation_incomplete: "\u041F\u0435\u0440\u0435\u0434 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u043E\u044E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u043D\u0430\u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043F\u0440\u044F\u043C\u043E\u043A\u0443\u0442\u043D\u0438\u043A, \u044F\u043A\u0438\u0439 \u043F\u043E\u043C\u0456\u0441\u0442\u0438\u0442\u044C\u0441\u044F \u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456",
            semantics_hide_annotations: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u043E\u0431'\u0454\u043A\u0442\u0456\u0432",
            semantics_doc: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
            semantics_doc_title: "\u041F\u0440\u043E \u0442\u0435\u0433\u0438",
            semantics_erase_annotation: "\u0421\u0442\u0435\u0440\u0442\u0438 \u043D\u0430\u043C\u0430\u043B\u044C\u043E\u0432\u0430\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442",
            semantics_doc_info1: "\u041D\u0430\u0434\u0430\u0439\u0442\u0435 \u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442 \u043D\u0430\u0432\u043A\u043E\u043B\u043E \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0442\u0435\u0433\u0456\u0432. \u0412\u0438 \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0439\u043E\u0433\u043E \u044F\u043A \u0437\u043D\u044F\u0442\u0435 \u0430\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u0435\u043C \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0442\u0435\u0433\u0443 transport=car.",
            semantics_doc_info2: "\u0412\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435 \u043C\u0430\u043B\u044E\u0432\u0430\u0442\u0438 \u043E\u0431'\u0454\u043A\u0442\u0438 \u043D\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u0456: \u0434\u043E\u0440\u043E\u0436\u043D\u0456 \u0437\u043D\u0430\u043A\u0438, \u043C\u0456\u0441\u044C\u043A\u0435 \u043E\u0431\u043B\u0430\u0434\u043D\u0430\u043D\u043D\u044F\u2026 \u041F\u043E\u0437\u043D\u0430\u0447\u0430\u0439\u0442\u0435 \u0442\u0435, \u0449\u043E \u0431\u0430\u0447\u0438\u0442\u0435, \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0447\u0438 \u0456\u0441\u043D\u0443\u044E\u0447\u0456 \u0442\u0435\u0433\u0438. \u0417\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0438 \u0432\u0438 \u0442\u0430\u043A\u043E\u0436 \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0441\u0432\u043E\u0457 \u0432\u043B\u0430\u0441\u043D\u0456.",
            semantics_doc_info3: "\u0414\u0435\u044F\u043A\u0456 \u043E\u0431'\u0454\u043A\u0442\u0438 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E \u0440\u043E\u0437\u043F\u0456\u0437\u043D\u0430\u044E\u0442\u044C\u0441\u044F \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0448\u0442\u0443\u0447\u043D\u043E\u0433\u043E \u0456\u043D\u0442\u0435\u043B\u0435\u043A\u0442\u0443: \u044F\u043A\u0456\u0441\u0442\u044C \u043D\u0435 \u0433\u0430\u0440\u0430\u043D\u0442\u0443\u0454\u0442\u044C\u0441\u044F.",
            semantics_doc_link: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E \u0442\u0435\u0433\u0438",
            semantics_sequence_tags: "\u0422\u0435\u0433 \u043F\u043E\u0441\u043B\u0456\u0434\u043E\u0432\u043D\u043E\u0441\u0442\u0456",
            semantics_picture_tags: "\u0422\u0435\u0433 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
            semantics_annotation_tags: "\u0422\u0435\u0433 \u043E\u0431'\u0454\u043A\u0442\u0430",
            filter_gps_precision_lessthan: "\u041C\u0435\u043D\u0448\u0435 {n} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision_morethan: "\u0411\u0456\u043B\u044C\u0448\u0435 {n} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision_between: "\u0412\u0456\u0434 {n1} \u0434\u043E {n2} \u043C\u0435\u0442\u0440\u0456\u0432",
            filter_gps_precision: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u044E\u0432\u0430\u043D\u043D\u044F",
            map_theme_gps: "\u0422\u043E\u0447\u043D\u0456\u0441\u0442\u044C \u043F\u043E\u0437\u0438\u0446\u0456\u044E\u0432\u0430\u043D\u043D\u044F",
            semantics_overlays: {
                tfsigns: "\u0414\u043E\u0440\u043E\u0436\u043D\u0456 \u0437\u043D\u0430\u043A\u0438"
            }
        },
        map: {
            not_public: "\u041D\u0435 \u043F\u0443\u0431\u043B\u0456\u0447\u043D\u043E \u0432\u0438\u0434\u0438\u043C\u0435",
            map_data: "\u041A\u0430\u0440\u0442\u0430 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0456 {m}",
            more_panoramax: "\u0414\u0456\u0437\u043D\u0430\u0439\u0442\u0435\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0435 \u043F\u0440\u043E Panoramax",
            thumbnail: "\u041C\u0456\u043D\u0456\u0430\u0442\u044E\u0440\u0430 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F, \u043D\u0430 \u044F\u043A\u0435 \u043D\u0430\u0432\u0435\u0434\u0435\u043D\u043E \u043A\u0443\u0440\u0441\u043E\u0440",
            slow_loading: "\u041A\u0430\u0440\u0442\u0430 \u043F\u043E\u0432\u0456\u043B\u044C\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F \u0442\u0430 \u043C\u043E\u0436\u0435 \u0432\u0438\u0433\u043B\u044F\u0434\u0430\u0442\u0438 \u043F\u043E\u0448\u043A\u043E\u0434\u0436\u0435\u043D\u043E\u044E",
            loading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026"
        }
    },
    "zh-hant": $785da19a645c07eb$var$lt,
    zh: $785da19a645c07eb$var$lt
};
function $785da19a645c07eb$var$ht(e1, t) {
    e1 = e1.map((e1)=>e1.toLowerCase());
    for (const t of $785da19a645c07eb$var$ft()){
        let i = t.toLowerCase();
        switch(i){
            case "zh-tw":
            case "zh-hk":
            case "zh-mo":
                i = "zh-hant";
                break;
            case "zh-cn":
            case "zh-sg":
                i = "zh-hans";
                break;
            default:
                i.length > 2 && !e1.includes(i) && (i = t.substring(0, 2));
        }
        const n = e1.find((e1)=>e1 === i);
        if (n) return n;
    }
    return t;
}
function $785da19a645c07eb$var$dt(e1, t) {
    if (!e1) return null;
    for(let i = 0; i < t.length; i++)e1 = e1?.[t[i]];
    return e1;
}
function $785da19a645c07eb$var$pt(e1, t, i, n) {
    return t || (t = []), Object.entries(e1).forEach(([a, r])=>{
        let s = t.concat([
            a
        ]);
        if ("string" == typeof r || Array.isArray(r)) {
            let t;
            if (i && (t = $785da19a645c07eb$var$dt($785da19a645c07eb$var$ut[i], s)), !t && i && i.length > 2 && (t = $785da19a645c07eb$var$dt($785da19a645c07eb$var$ut[i.substring(0, 2)], s)), !t && n) for(let e1 = 0; e1 < n.length && (t = $785da19a645c07eb$var$dt($785da19a645c07eb$var$ut[n[e1].toLowerCase()], s), !t); e1++);
            t || (t = $785da19a645c07eb$var$dt($785da19a645c07eb$var$ut[$785da19a645c07eb$var$ct], s)), e1[a] = t, Array.isArray(e1[a]) && (e1[a] = e1[a].filter((e1)=>e1));
        } else e1[a] = $785da19a645c07eb$var$pt(e1[a], s, i, n);
    }), e1;
}
function $785da19a645c07eb$var$mt(e1 = "") {
    e1 || (e1 = $785da19a645c07eb$var$ht(Object.keys($785da19a645c07eb$var$ut), $785da19a645c07eb$var$ct));
    let t = $785da19a645c07eb$var$ft(), i = [];
    t.forEach((e1)=>{
        e1 = e1.toLowerCase(), [
            "zh-tw",
            "zh-hk",
            "zh-mo"
        ].includes(e1) ? i.push("zh-hant") : [
            "zh-cn",
            "zh-sg"
        ].includes(e1) ? i.push("zh-hans") : e1.length > 2 ? (i.push(e1), i.push(e1.substring(0, 2))) : i.includes(e1) || i.push(e1);
    });
    let n = JSON.parse(JSON.stringify($785da19a645c07eb$var$ot));
    return n = $785da19a645c07eb$var$pt(n, null, e1, i), n.PREF_LANG = e1, n;
}
function $785da19a645c07eb$var$gt(e1, t) {
    return t = t ? t.toLowerCase() : null, e1 = Object.fromEntries(Object.entries(e1).map(([e1, t])=>[
            e1.toLowerCase(),
            t
        ])), t || (t = $785da19a645c07eb$var$ht(Object.keys(e1), $785da19a645c07eb$var$ct)), e1[t] ? e1[t] : t.length > 2 && e1[t.substring(0, 2)] ? e1[t.substring(0, 2)] : e1[$785da19a645c07eb$var$ct] || "";
}
function $785da19a645c07eb$var$ft() {
    let e1 = [];
    return window.navigator.languages ? e1 = window.navigator.languages : window.navigator.language && (e1 = [
        window.navigator.language
    ]), e1 = e1.filter((e1)=>e1 && "string" == typeof e1 && e1.length > 0), e1;
}
var $785da19a645c07eb$var$At = Object.freeze({
    __proto__: null,
    autoDetectLocale: $785da19a645c07eb$var$ht,
    getBestLabel: $785da19a645c07eb$var$gt,
    getBrowserLanguages: $785da19a645c07eb$var$ft,
    getTranslations: $785da19a645c07eb$var$mt
});
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function $785da19a645c07eb$var$_t(e1, t, i) {
    return (t = function(e1) {
        var t = function(e1, t) {
            if ("object" != typeof e1 || !e1) return e1;
            var i = e1[Symbol.toPrimitive];
            if (void 0 !== i) {
                var n = i.call(e1, t);
                if ("object" != typeof n) return n;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e1);
        }(e1, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e1 ? Object.defineProperty(e1, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e1[t] = i, e1;
}
function $785da19a645c07eb$var$vt(e1, t) {
    var i = Object.keys(e1);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e1);
        t && (n = n.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e1, t).enumerable;
        })), i.push.apply(i, n);
    }
    return i;
}
function $785da19a645c07eb$var$yt(e1) {
    for(var t = 1; t < arguments.length; t++){
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $785da19a645c07eb$var$vt(Object(i), !0).forEach(function(t) {
            $785da19a645c07eb$var$_t(e1, t, i[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e1, Object.getOwnPropertyDescriptors(i)) : $785da19a645c07eb$var$vt(Object(i)).forEach(function(t) {
            Object.defineProperty(e1, t, Object.getOwnPropertyDescriptor(i, t));
        });
    }
    return e1;
}
const $785da19a645c07eb$var$xt = ()=>{};
let $785da19a645c07eb$var$bt = {}, $785da19a645c07eb$var$wt = {}, $785da19a645c07eb$var$Et = null, $785da19a645c07eb$var$kt = {
    mark: $785da19a645c07eb$var$xt,
    measure: $785da19a645c07eb$var$xt
};
try {
    "undefined" != typeof window && ($785da19a645c07eb$var$bt = window), "undefined" != typeof document && ($785da19a645c07eb$var$wt = document), "undefined" != typeof MutationObserver && ($785da19a645c07eb$var$Et = MutationObserver), "undefined" != typeof performance && ($785da19a645c07eb$var$kt = performance);
} catch (w2) {}
const { userAgent: $785da19a645c07eb$var$St = "" } = $785da19a645c07eb$var$bt.navigator || {}, $785da19a645c07eb$var$Mt = $785da19a645c07eb$var$bt, $785da19a645c07eb$var$Ct = $785da19a645c07eb$var$wt, $785da19a645c07eb$var$Tt = $785da19a645c07eb$var$Et, $785da19a645c07eb$var$Dt = $785da19a645c07eb$var$kt;
$785da19a645c07eb$var$Mt.document;
const $785da19a645c07eb$var$Pt = !!$785da19a645c07eb$var$Ct.documentElement && !!$785da19a645c07eb$var$Ct.head && "function" == typeof $785da19a645c07eb$var$Ct.addEventListener && "function" == typeof $785da19a645c07eb$var$Ct.createElement, $785da19a645c07eb$var$It = ~$785da19a645c07eb$var$St.indexOf("MSIE") || ~$785da19a645c07eb$var$St.indexOf("Trident/");
var $785da19a645c07eb$var$Ft = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    }
}, $785da19a645c07eb$var$zt = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone"
], $785da19a645c07eb$var$Rt = "classic", $785da19a645c07eb$var$Lt = "duotone", $785da19a645c07eb$var$Bt = [
    $785da19a645c07eb$var$Rt,
    $785da19a645c07eb$var$Lt,
    "sharp",
    "sharp-duotone"
], $785da19a645c07eb$var$Ot = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ]
]), $785da19a645c07eb$var$Ut = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $785da19a645c07eb$var$Nt = {
    fak: "kit",
    "fa-kit": "kit"
}, $785da19a645c07eb$var$jt = {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
}, $785da19a645c07eb$var$Vt = [
    "fak",
    "fakd"
], $785da19a645c07eb$var$qt = {
    kit: "fak"
}, $785da19a645c07eb$var$Gt = {
    "kit-duotone": "fakd"
}, $785da19a645c07eb$var$Ht = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $785da19a645c07eb$var$Wt = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $785da19a645c07eb$var$Zt = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    }
}, $785da19a645c07eb$var$Kt = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands"
], $785da19a645c07eb$var$Xt = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $785da19a645c07eb$var$Qt = $785da19a645c07eb$var$Xt.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $785da19a645c07eb$var$Yt = [
    ...Object.keys({
        classic: [
            "fas",
            "far",
            "fal",
            "fat",
            "fad"
        ],
        duotone: [
            "fadr",
            "fadl",
            "fadt"
        ],
        sharp: [
            "fass",
            "fasr",
            "fasl",
            "fast"
        ],
        "sharp-duotone": [
            "fasds",
            "fasdr",
            "fasdl",
            "fasdt"
        ]
    }),
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "fw",
    "inverse",
    "layers-counter",
    "layers-text",
    "layers",
    "li",
    "pull-left",
    "pull-right",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    $785da19a645c07eb$var$Ht.GROUP,
    $785da19a645c07eb$var$Ht.SWAP_OPACITY,
    $785da19a645c07eb$var$Ht.PRIMARY,
    $785da19a645c07eb$var$Ht.SECONDARY
].concat($785da19a645c07eb$var$Xt.map((e1)=>"".concat(e1, "x"))).concat($785da19a645c07eb$var$Qt.map((e1)=>"w-".concat(e1)));
const $785da19a645c07eb$var$Jt = "___FONT_AWESOME___", $785da19a645c07eb$var$$t = 16, $785da19a645c07eb$var$ei = "svg-inline--fa", $785da19a645c07eb$var$ti = "data-fa-i2svg", $785da19a645c07eb$var$ii = "data-fa-pseudo-element", $785da19a645c07eb$var$ni = "data-prefix", $785da19a645c07eb$var$ai = "data-icon", $785da19a645c07eb$var$ri = "fontawesome-i2svg", $785da19a645c07eb$var$si = [
    "HTML",
    "HEAD",
    "STYLE",
    "SCRIPT"
], $785da19a645c07eb$var$oi = (()=>{
    try {
        return true;
    } catch (e1) {
        return !1;
    }
})();
function $785da19a645c07eb$var$li(e1) {
    return new Proxy(e1, {
        get: (e1, t)=>t in e1 ? e1[t] : e1[$785da19a645c07eb$var$Rt]
    });
}
const $785da19a645c07eb$var$ci = $785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ft);
$785da19a645c07eb$var$ci[$785da19a645c07eb$var$Rt] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, {
    "fa-duotone": "duotone"
}), $785da19a645c07eb$var$Ft[$785da19a645c07eb$var$Rt]), $785da19a645c07eb$var$Nt), $785da19a645c07eb$var$jt);
const $785da19a645c07eb$var$ui = $785da19a645c07eb$var$li($785da19a645c07eb$var$ci), $785da19a645c07eb$var$hi = $785da19a645c07eb$var$yt({}, {
    classic: {
        solid: "fas",
        regular: "far",
        light: "fal",
        thin: "fat",
        brands: "fab"
    },
    duotone: {
        solid: "fad",
        regular: "fadr",
        light: "fadl",
        thin: "fadt"
    },
    sharp: {
        solid: "fass",
        regular: "fasr",
        light: "fasl",
        thin: "fast"
    },
    "sharp-duotone": {
        solid: "fasds",
        regular: "fasdr",
        light: "fasdl",
        thin: "fasdt"
    }
});
$785da19a645c07eb$var$hi[$785da19a645c07eb$var$Rt] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, {
    duotone: "fad"
}), $785da19a645c07eb$var$hi[$785da19a645c07eb$var$Rt]), $785da19a645c07eb$var$qt), $785da19a645c07eb$var$Gt);
const $785da19a645c07eb$var$di = $785da19a645c07eb$var$li($785da19a645c07eb$var$hi), $785da19a645c07eb$var$pi = $785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Zt);
$785da19a645c07eb$var$pi[$785da19a645c07eb$var$Rt] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$pi[$785da19a645c07eb$var$Rt]), {
    fak: "fa-kit"
});
const $785da19a645c07eb$var$mi = $785da19a645c07eb$var$li($785da19a645c07eb$var$pi), $785da19a645c07eb$var$gi = $785da19a645c07eb$var$yt({}, {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    }
});
$785da19a645c07eb$var$gi[$785da19a645c07eb$var$Rt] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$gi[$785da19a645c07eb$var$Rt]), {
    "fa-kit": "fak"
}), $785da19a645c07eb$var$li($785da19a645c07eb$var$gi);
const $785da19a645c07eb$var$fi = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $785da19a645c07eb$var$Ai = "fa-layers-text", $785da19a645c07eb$var$_i = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i;
$785da19a645c07eb$var$li($785da19a645c07eb$var$yt({}, {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
}));
const $785da19a645c07eb$var$vi = [
    "class",
    "data-prefix",
    "data-icon",
    "data-fa-transform",
    "data-fa-mask"
], $785da19a645c07eb$var$yi = {
    GROUP: "duotone-group",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $785da19a645c07eb$var$xi = [
    "kit",
    ...$785da19a645c07eb$var$Yt
], $785da19a645c07eb$var$bi = $785da19a645c07eb$var$Mt.FontAwesomeConfig || {};
if ($785da19a645c07eb$var$Ct && "function" == typeof $785da19a645c07eb$var$Ct.querySelector) [
    [
        "data-family-prefix",
        "familyPrefix"
    ],
    [
        "data-css-prefix",
        "cssPrefix"
    ],
    [
        "data-family-default",
        "familyDefault"
    ],
    [
        "data-style-default",
        "styleDefault"
    ],
    [
        "data-replacement-class",
        "replacementClass"
    ],
    [
        "data-auto-replace-svg",
        "autoReplaceSvg"
    ],
    [
        "data-auto-add-css",
        "autoAddCss"
    ],
    [
        "data-auto-a11y",
        "autoA11y"
    ],
    [
        "data-search-pseudo-elements",
        "searchPseudoElements"
    ],
    [
        "data-observe-mutations",
        "observeMutations"
    ],
    [
        "data-mutate-approach",
        "mutateApproach"
    ],
    [
        "data-keep-original-source",
        "keepOriginalSource"
    ],
    [
        "data-measure-performance",
        "measurePerformance"
    ],
    [
        "data-show-missing-icons",
        "showMissingIcons"
    ]
].forEach((e1)=>{
    let [t, i] = e1;
    const n = function(e1) {
        return "" === e1 || "false" !== e1 && ("true" === e1 || e1);
    }(function(e1) {
        var t = $785da19a645c07eb$var$Ct.querySelector("script[" + e1 + "]");
        if (t) return t.getAttribute(e1);
    }(t));
    null != n && ($785da19a645c07eb$var$bi[i] = n);
});
const $785da19a645c07eb$var$wi = {
    styleDefault: "solid",
    familyDefault: $785da19a645c07eb$var$Rt,
    cssPrefix: "fa",
    replacementClass: $785da19a645c07eb$var$ei,
    autoReplaceSvg: !0,
    autoAddCss: !0,
    autoA11y: !0,
    searchPseudoElements: !1,
    observeMutations: !0,
    mutateApproach: "async",
    keepOriginalSource: !0,
    measurePerformance: !1,
    showMissingIcons: !0
};
$785da19a645c07eb$var$bi.familyPrefix && ($785da19a645c07eb$var$bi.cssPrefix = $785da19a645c07eb$var$bi.familyPrefix);
const $785da19a645c07eb$var$Ei = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$wi), $785da19a645c07eb$var$bi);
$785da19a645c07eb$var$Ei.autoReplaceSvg || ($785da19a645c07eb$var$Ei.observeMutations = !1);
const $785da19a645c07eb$var$ki = {};
Object.keys($785da19a645c07eb$var$wi).forEach((e1)=>{
    Object.defineProperty($785da19a645c07eb$var$ki, e1, {
        enumerable: !0,
        set: function(t) {
            $785da19a645c07eb$var$Ei[e1] = t, $785da19a645c07eb$var$Si.forEach((e1)=>e1($785da19a645c07eb$var$ki));
        },
        get: function() {
            return $785da19a645c07eb$var$Ei[e1];
        }
    });
}), Object.defineProperty($785da19a645c07eb$var$ki, "familyPrefix", {
    enumerable: !0,
    set: function(e1) {
        $785da19a645c07eb$var$Ei.cssPrefix = e1, $785da19a645c07eb$var$Si.forEach((e1)=>e1($785da19a645c07eb$var$ki));
    },
    get: function() {
        return $785da19a645c07eb$var$Ei.cssPrefix;
    }
}), $785da19a645c07eb$var$Mt.FontAwesomeConfig = $785da19a645c07eb$var$ki;
const $785da19a645c07eb$var$Si = [];
const $785da19a645c07eb$var$Mi = $785da19a645c07eb$var$$t, $785da19a645c07eb$var$Ci = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: !1,
    flipY: !1
};
function $785da19a645c07eb$var$Ti() {
    let e1 = 12, t = "";
    for(; e1-- > 0;)t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
    return t;
}
function $785da19a645c07eb$var$Di(e1) {
    const t = [];
    for(let i = (e1 || []).length >>> 0; i--;)t[i] = e1[i];
    return t;
}
function $785da19a645c07eb$var$Pi(e1) {
    return e1.classList ? $785da19a645c07eb$var$Di(e1.classList) : (e1.getAttribute("class") || "").split(" ").filter((e1)=>e1);
}
function $785da19a645c07eb$var$Ii(e1) {
    return "".concat(e1).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $785da19a645c07eb$var$Fi(e1) {
    return Object.keys(e1 || {}).reduce((t, i)=>t + "".concat(i, ": ").concat(e1[i].trim(), ";"), "");
}
function $785da19a645c07eb$var$zi(e1) {
    return e1.size !== $785da19a645c07eb$var$Ci.size || e1.x !== $785da19a645c07eb$var$Ci.x || e1.y !== $785da19a645c07eb$var$Ci.y || e1.rotate !== $785da19a645c07eb$var$Ci.rotate || e1.flipX || e1.flipY;
}
function $785da19a645c07eb$var$Ri() {
    const e1 = "fa", t = $785da19a645c07eb$var$ei, i = $785da19a645c07eb$var$ki.cssPrefix, n = $785da19a645c07eb$var$ki.replacementClass;
    let a = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}';
    if (i !== e1 || n !== t) {
        const r = new RegExp("\\.".concat(e1, "\\-"), "g"), s = new RegExp("\\--".concat(e1, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
        a = a.replace(r, ".".concat(i, "-")).replace(s, "--".concat(i, "-")).replace(o, ".".concat(n));
    }
    return a;
}
let $785da19a645c07eb$var$Li = !1;
function $785da19a645c07eb$var$Bi() {
    $785da19a645c07eb$var$ki.autoAddCss && !$785da19a645c07eb$var$Li && (!function(e1) {
        if (!e1 || !$785da19a645c07eb$var$Pt) return;
        const t = $785da19a645c07eb$var$Ct.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e1;
        const i = $785da19a645c07eb$var$Ct.head.childNodes;
        let n = null;
        for(let e1 = i.length - 1; e1 > -1; e1--){
            const t = i[e1], a = (t.tagName || "").toUpperCase();
            [
                "STYLE",
                "LINK"
            ].indexOf(a) > -1 && (n = t);
        }
        $785da19a645c07eb$var$Ct.head.insertBefore(t, n);
    }($785da19a645c07eb$var$Ri()), $785da19a645c07eb$var$Li = !0);
}
var $785da19a645c07eb$var$Oi = {
    mixout: ()=>({
            dom: {
                css: $785da19a645c07eb$var$Ri,
                insertCss: $785da19a645c07eb$var$Bi
            }
        }),
    hooks: ()=>({
            beforeDOMElementCreation () {
                $785da19a645c07eb$var$Bi();
            },
            beforeI2svg () {
                $785da19a645c07eb$var$Bi();
            }
        })
};
const $785da19a645c07eb$var$Ui = $785da19a645c07eb$var$Mt || {};
$785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt] || ($785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt] = {}), $785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].styles || ($785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].styles = {}), $785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].hooks || ($785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].hooks = {}), $785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].shims || ($785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt].shims = []);
var $785da19a645c07eb$var$Ni = $785da19a645c07eb$var$Ui[$785da19a645c07eb$var$Jt];
const $785da19a645c07eb$var$ji = [], $785da19a645c07eb$var$Vi = function() {
    $785da19a645c07eb$var$Ct.removeEventListener("DOMContentLoaded", $785da19a645c07eb$var$Vi), $785da19a645c07eb$var$qi = 1, $785da19a645c07eb$var$ji.map((e1)=>e1());
};
let $785da19a645c07eb$var$qi = !1;
function $785da19a645c07eb$var$Gi(e1) {
    const { tag: t, attributes: i = {}, children: n = [] } = e1;
    return "string" == typeof e1 ? $785da19a645c07eb$var$Ii(e1) : "<".concat(t, " ").concat(function(e1) {
        return Object.keys(e1 || {}).reduce((t, i)=>t + "".concat(i, '="').concat($785da19a645c07eb$var$Ii(e1[i]), '" '), "").trim();
    }(i), ">").concat(n.map($785da19a645c07eb$var$Gi).join(""), "</").concat(t, ">");
}
function $785da19a645c07eb$var$Hi(e1, t, i) {
    if (e1 && e1[t] && e1[t][i]) return {
        prefix: t,
        iconName: i,
        icon: e1[t][i]
    };
}
$785da19a645c07eb$var$Pt && ($785da19a645c07eb$var$qi = ($785da19a645c07eb$var$Ct.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($785da19a645c07eb$var$Ct.readyState), $785da19a645c07eb$var$qi || $785da19a645c07eb$var$Ct.addEventListener("DOMContentLoaded", $785da19a645c07eb$var$Vi));
var $785da19a645c07eb$var$Wi = function(e1, t, i, n) {
    var a, r, s, o = Object.keys(e1), l = o.length, c = t;
    for(void 0 === i ? (a = 1, s = e1[o[0]]) : (a = 0, s = i); a < l; a++)s = c(s, e1[r = o[a]], r, e1);
    return s;
};
function $785da19a645c07eb$var$Zi(e1) {
    const t = function(e1) {
        const t = [];
        let i = 0;
        const n = e1.length;
        for(; i < n;){
            const a = e1.charCodeAt(i++);
            if (a >= 55296 && a <= 56319 && i < n) {
                const n = e1.charCodeAt(i++);
                56320 == (64512 & n) ? t.push(((1023 & a) << 10) + (1023 & n) + 65536) : (t.push(a), i--);
            } else t.push(a);
        }
        return t;
    }(e1);
    return 1 === t.length ? t[0].toString(16) : null;
}
function $785da19a645c07eb$var$Ki(e1) {
    return Object.keys(e1).reduce((t, i)=>{
        const n = e1[i];
        return !!n.icon ? t[n.iconName] = n.icon : t[i] = n, t;
    }, {});
}
function $785da19a645c07eb$var$Xi(e1, t) {
    let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    const { skipHooks: n = !1 } = i, a = $785da19a645c07eb$var$Ki(t);
    "function" != typeof $785da19a645c07eb$var$Ni.hooks.addPack || n ? $785da19a645c07eb$var$Ni.styles[e1] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ni.styles[e1] || {}), a) : $785da19a645c07eb$var$Ni.hooks.addPack(e1, $785da19a645c07eb$var$Ki(t)), "fas" === e1 && $785da19a645c07eb$var$Xi("fa", t);
}
const { styles: $785da19a645c07eb$var$Qi, shims: $785da19a645c07eb$var$Yi } = $785da19a645c07eb$var$Ni, $785da19a645c07eb$var$Ji = Object.keys($785da19a645c07eb$var$mi), $785da19a645c07eb$var$$i = $785da19a645c07eb$var$Ji.reduce((e1, t)=>(e1[t] = Object.keys($785da19a645c07eb$var$mi[t]), e1), {});
let $785da19a645c07eb$var$en = null, $785da19a645c07eb$var$tn = {}, $785da19a645c07eb$var$nn = {}, $785da19a645c07eb$var$an = {}, $785da19a645c07eb$var$rn = {}, $785da19a645c07eb$var$sn = {};
function $785da19a645c07eb$var$on(e1, t) {
    const i = t.split("-"), n = i[0], a = i.slice(1).join("-");
    var r;
    return n !== e1 || "" === a || (r = a, ~$785da19a645c07eb$var$xi.indexOf(r)) ? null : a;
}
const $785da19a645c07eb$var$ln = ()=>{
    const e1 = (e1)=>$785da19a645c07eb$var$Wi($785da19a645c07eb$var$Qi, (t, i, n)=>(t[n] = $785da19a645c07eb$var$Wi(i, e1, {}), t), {});
    $785da19a645c07eb$var$tn = e1((e1, t, i)=>{
        if (t[3] && (e1[t[3]] = i), t[2]) t[2].filter((e1)=>"number" == typeof e1).forEach((t)=>{
            e1[t.toString(16)] = i;
        });
        return e1;
    }), $785da19a645c07eb$var$nn = e1((e1, t, i)=>{
        if (e1[i] = i, t[2]) t[2].filter((e1)=>"string" == typeof e1).forEach((t)=>{
            e1[t] = i;
        });
        return e1;
    }), $785da19a645c07eb$var$sn = e1((e1, t, i)=>{
        const n = t[2];
        return e1[i] = i, n.forEach((t)=>{
            e1[t] = i;
        }), e1;
    });
    const t = "far" in $785da19a645c07eb$var$Qi || $785da19a645c07eb$var$ki.autoFetchSvg, i = $785da19a645c07eb$var$Wi($785da19a645c07eb$var$Yi, (e1, i)=>{
        const n = i[0];
        let a = i[1];
        const r = i[2];
        return "far" !== a || t || (a = "fas"), "string" == typeof n && (e1.names[n] = {
            prefix: a,
            iconName: r
        }), "number" == typeof n && (e1.unicodes[n.toString(16)] = {
            prefix: a,
            iconName: r
        }), e1;
    }, {
        names: {},
        unicodes: {}
    });
    $785da19a645c07eb$var$an = i.names, $785da19a645c07eb$var$rn = i.unicodes, $785da19a645c07eb$var$en = $785da19a645c07eb$var$pn($785da19a645c07eb$var$ki.styleDefault, {
        family: $785da19a645c07eb$var$ki.familyDefault
    });
};
function $785da19a645c07eb$var$cn(e1, t) {
    return ($785da19a645c07eb$var$tn[e1] || {})[t];
}
function $785da19a645c07eb$var$un(e1, t) {
    return ($785da19a645c07eb$var$sn[e1] || {})[t];
}
function $785da19a645c07eb$var$hn(e1) {
    return $785da19a645c07eb$var$an[e1] || {
        prefix: null,
        iconName: null
    };
}
function $785da19a645c07eb$var$dn() {
    return $785da19a645c07eb$var$en;
}
!function(e1) {
    $785da19a645c07eb$var$Si.push(e1);
}((e1)=>{
    $785da19a645c07eb$var$en = $785da19a645c07eb$var$pn(e1.styleDefault, {
        family: $785da19a645c07eb$var$ki.familyDefault
    });
}), $785da19a645c07eb$var$ln();
function $785da19a645c07eb$var$pn(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { family: i = $785da19a645c07eb$var$Rt } = t, n = $785da19a645c07eb$var$ui[i][e1];
    if (i === $785da19a645c07eb$var$Lt && !e1) return "fad";
    const a = $785da19a645c07eb$var$di[i][e1] || $785da19a645c07eb$var$di[i][n], r = e1 in $785da19a645c07eb$var$Ni.styles ? e1 : null;
    return a || r || null;
}
function $785da19a645c07eb$var$mn(e1) {
    return e1.sort().filter((e1, t, i)=>i.indexOf(e1) === t);
}
function $785da19a645c07eb$var$gn(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { skipLookups: i = !1 } = t;
    let n = null;
    const a = $785da19a645c07eb$var$Kt.concat($785da19a645c07eb$var$Wt), r = $785da19a645c07eb$var$mn(e1.filter((e1)=>a.includes(e1))), s = $785da19a645c07eb$var$mn(e1.filter((e1)=>!$785da19a645c07eb$var$Kt.includes(e1))), o = r.filter((e1)=>(n = e1, !$785da19a645c07eb$var$zt.includes(e1))), [l = null] = o, c = function(e1) {
        let t = $785da19a645c07eb$var$Rt;
        const i = $785da19a645c07eb$var$Ji.reduce((e1, t)=>(e1[t] = "".concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat(t), e1), {});
        return $785da19a645c07eb$var$Bt.forEach((n)=>{
            (e1.includes(i[n]) || e1.some((e1)=>$785da19a645c07eb$var$$i[n].includes(e1))) && (t = n);
        }), t;
    }(r), u = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, function(e1) {
        let t = [], i = null;
        return e1.forEach((e1)=>{
            const n = $785da19a645c07eb$var$on($785da19a645c07eb$var$ki.cssPrefix, e1);
            n ? i = n : e1 && t.push(e1);
        }), {
            iconName: i,
            rest: t
        };
    }(s)), {}, {
        prefix: $785da19a645c07eb$var$pn(l, {
            family: c
        })
    });
    return $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, u), function(e1) {
        const { values: t, family: i, canonical: n, givenPrefix: a = "", styles: r = {}, config: s = {} } = e1, o = i === $785da19a645c07eb$var$Lt, l = t.includes("fa-duotone") || t.includes("fad"), c = "duotone" === s.familyDefault, u = "fad" === n.prefix || "fa-duotone" === n.prefix;
        !o && (l || c || u) && (n.prefix = "fad");
        (t.includes("fa-brands") || t.includes("fab")) && (n.prefix = "fab");
        if (!n.prefix && $785da19a645c07eb$var$fn.includes(i)) {
            const e1 = Object.keys(r).find((e1)=>$785da19a645c07eb$var$An.includes(e1));
            if (e1 || s.autoFetchSvg) {
                const e1 = $785da19a645c07eb$var$Ot.get(i).defaultShortPrefixId;
                n.prefix = e1, n.iconName = $785da19a645c07eb$var$un(n.prefix, n.iconName) || n.iconName;
            }
        }
        "fa" !== n.prefix && "fa" !== a || (n.prefix = $785da19a645c07eb$var$dn() || "fas");
        return n;
    }({
        values: e1,
        family: c,
        styles: $785da19a645c07eb$var$Qi,
        config: $785da19a645c07eb$var$ki,
        canonical: u,
        givenPrefix: n
    })), function(e1, t, i) {
        let { prefix: n, iconName: a } = i;
        if (e1 || !n || !a) return {
            prefix: n,
            iconName: a
        };
        const r = "fa" === t ? $785da19a645c07eb$var$hn(a) : {}, s = $785da19a645c07eb$var$un(n, a);
        a = r.iconName || s || a, n = r.prefix || n, "far" !== n || $785da19a645c07eb$var$Qi.far || !$785da19a645c07eb$var$Qi.fas || $785da19a645c07eb$var$ki.autoFetchSvg || (n = "fas");
        return {
            prefix: n,
            iconName: a
        };
    }(i, n, u));
}
const $785da19a645c07eb$var$fn = $785da19a645c07eb$var$Bt.filter((e1)=>e1 !== $785da19a645c07eb$var$Rt || e1 !== $785da19a645c07eb$var$Lt), $785da19a645c07eb$var$An = Object.keys($785da19a645c07eb$var$Zt).filter((e1)=>e1 !== $785da19a645c07eb$var$Rt).map((e1)=>Object.keys($785da19a645c07eb$var$Zt[e1])).flat();
let $785da19a645c07eb$var$_n = [], $785da19a645c07eb$var$vn = {};
const $785da19a645c07eb$var$yn = {}, $785da19a645c07eb$var$xn = Object.keys($785da19a645c07eb$var$yn);
function $785da19a645c07eb$var$bn(e1, t) {
    for(var i = arguments.length, n = new Array(i > 2 ? i - 2 : 0), a = 2; a < i; a++)n[a - 2] = arguments[a];
    return ($785da19a645c07eb$var$vn[e1] || []).forEach((e1)=>{
        t = e1.apply(null, [
            t,
            ...n
        ]);
    }), t;
}
function $785da19a645c07eb$var$wn(e1) {
    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
    ($785da19a645c07eb$var$vn[e1] || []).forEach((e1)=>{
        e1.apply(null, i);
    });
}
function $785da19a645c07eb$var$En() {
    const e1 = arguments[0], t = Array.prototype.slice.call(arguments, 1);
    return $785da19a645c07eb$var$yn[e1] ? $785da19a645c07eb$var$yn[e1].apply(null, t) : void 0;
}
function $785da19a645c07eb$var$kn(e1) {
    "fa" === e1.prefix && (e1.prefix = "fas");
    let { iconName: t } = e1;
    const i = e1.prefix || $785da19a645c07eb$var$dn();
    if (t) return t = $785da19a645c07eb$var$un(i, t) || t, $785da19a645c07eb$var$Hi($785da19a645c07eb$var$Sn.definitions, i, t) || $785da19a645c07eb$var$Hi($785da19a645c07eb$var$Ni.styles, i, t);
}
const $785da19a645c07eb$var$Sn = new class {
    constructor(){
        this.definitions = {};
    }
    add() {
        for(var e1 = arguments.length, t = new Array(e1), i = 0; i < e1; i++)t[i] = arguments[i];
        const n = t.reduce(this._pullDefinitions, {});
        Object.keys(n).forEach((e1)=>{
            this.definitions[e1] = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, this.definitions[e1] || {}), n[e1]), $785da19a645c07eb$var$Xi(e1, n[e1]);
            const t = $785da19a645c07eb$var$mi[$785da19a645c07eb$var$Rt][e1];
            t && $785da19a645c07eb$var$Xi(t, n[e1]), $785da19a645c07eb$var$ln();
        });
    }
    reset() {
        this.definitions = {};
    }
    _pullDefinitions(e1, t) {
        const i = t.prefix && t.iconName && t.icon ? {
            0: t
        } : t;
        return Object.keys(i).map((t)=>{
            const { prefix: n, iconName: a, icon: r } = i[t], s = r[2];
            e1[n] || (e1[n] = {}), s.length > 0 && s.forEach((t)=>{
                "string" == typeof t && (e1[n][t] = r);
            }), e1[n][a] = r;
        }), e1;
    }
}, $785da19a645c07eb$var$Mn = {
    i2svg: function() {
        let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return $785da19a645c07eb$var$Pt ? ($785da19a645c07eb$var$wn("beforeI2svg", e1), $785da19a645c07eb$var$En("pseudoElements2svg", e1), $785da19a645c07eb$var$En("i2svg", e1)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
    },
    watch: function() {
        let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        const { autoReplaceSvgRoot: t } = e1;
        !1 === $785da19a645c07eb$var$ki.autoReplaceSvg && ($785da19a645c07eb$var$ki.autoReplaceSvg = !0), $785da19a645c07eb$var$ki.observeMutations = !0, function(e1) {
            $785da19a645c07eb$var$Pt && ($785da19a645c07eb$var$qi ? setTimeout(e1, 0) : $785da19a645c07eb$var$ji.push(e1));
        }(()=>{
            $785da19a645c07eb$var$Dn({
                autoReplaceSvgRoot: t
            }), $785da19a645c07eb$var$wn("watch", e1);
        });
    }
}, $785da19a645c07eb$var$Cn = {
    icon: (e1)=>{
        if (null === e1) return null;
        if ("object" == typeof e1 && e1.prefix && e1.iconName) return {
            prefix: e1.prefix,
            iconName: $785da19a645c07eb$var$un(e1.prefix, e1.iconName) || e1.iconName
        };
        if (Array.isArray(e1) && 2 === e1.length) {
            const t = 0 === e1[1].indexOf("fa-") ? e1[1].slice(3) : e1[1], i = $785da19a645c07eb$var$pn(e1[0]);
            return {
                prefix: i,
                iconName: $785da19a645c07eb$var$un(i, t) || t
            };
        }
        if ("string" == typeof e1 && (e1.indexOf("".concat($785da19a645c07eb$var$ki.cssPrefix, "-")) > -1 || e1.match($785da19a645c07eb$var$fi))) {
            const t = $785da19a645c07eb$var$gn(e1.split(" "), {
                skipLookups: !0
            });
            return {
                prefix: t.prefix || $785da19a645c07eb$var$dn(),
                iconName: $785da19a645c07eb$var$un(t.prefix, t.iconName) || t.iconName
            };
        }
        if ("string" == typeof e1) {
            const t = $785da19a645c07eb$var$dn();
            return {
                prefix: t,
                iconName: $785da19a645c07eb$var$un(t, e1) || e1
            };
        }
    }
}, $785da19a645c07eb$var$Tn = {
    noAuto: ()=>{
        $785da19a645c07eb$var$ki.autoReplaceSvg = !1, $785da19a645c07eb$var$ki.observeMutations = !1, $785da19a645c07eb$var$wn("noAuto");
    },
    config: $785da19a645c07eb$var$ki,
    dom: $785da19a645c07eb$var$Mn,
    parse: $785da19a645c07eb$var$Cn,
    library: $785da19a645c07eb$var$Sn,
    findIconDefinition: $785da19a645c07eb$var$kn,
    toHtml: $785da19a645c07eb$var$Gi
}, $785da19a645c07eb$var$Dn = function() {
    let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    const { autoReplaceSvgRoot: t = $785da19a645c07eb$var$Ct } = e1;
    (Object.keys($785da19a645c07eb$var$Ni.styles).length > 0 || $785da19a645c07eb$var$ki.autoFetchSvg) && $785da19a645c07eb$var$Pt && $785da19a645c07eb$var$ki.autoReplaceSvg && $785da19a645c07eb$var$Tn.dom.i2svg({
        node: t
    });
};
function $785da19a645c07eb$var$Pn(e1, t) {
    return Object.defineProperty(e1, "abstract", {
        get: t
    }), Object.defineProperty(e1, "html", {
        get: function() {
            return e1.abstract.map((e1)=>$785da19a645c07eb$var$Gi(e1));
        }
    }), Object.defineProperty(e1, "node", {
        get: function() {
            if (!$785da19a645c07eb$var$Pt) return;
            const t = $785da19a645c07eb$var$Ct.createElement("div");
            return t.innerHTML = e1.html, t.children;
        }
    }), e1;
}
function $785da19a645c07eb$var$In(e1) {
    const { icons: { main: t, mask: i }, prefix: n, iconName: a, transform: r, symbol: s, title: o, maskId: l, titleId: c, extra: u, watchable: h = !1 } = e1, { width: d, height: p } = i.found ? i : t, m = $785da19a645c07eb$var$Vt.includes(n), g = [
        $785da19a645c07eb$var$ki.replacementClass,
        a ? "".concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat(a) : ""
    ].filter((e1)=>-1 === u.classes.indexOf(e1)).filter((e1)=>"" !== e1 || !!e1).concat(u.classes).join(" ");
    let f = {
        children: [],
        attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, u.attributes), {}, {
            "data-prefix": n,
            "data-icon": a,
            class: g,
            role: u.attributes.role || "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 ".concat(d, " ").concat(p)
        })
    };
    const A = m && !~u.classes.indexOf("fa-fw") ? {
        width: "".concat(d / p * 1, "em")
    } : {};
    h && (f.attributes[$785da19a645c07eb$var$ti] = ""), o && (f.children.push({
        tag: "title",
        attributes: {
            id: f.attributes["aria-labelledby"] || "title-".concat(c || $785da19a645c07eb$var$Ti())
        },
        children: [
            o
        ]
    }), delete f.attributes.title);
    const _ = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, f), {}, {
        prefix: n,
        iconName: a,
        main: t,
        mask: i,
        maskId: l,
        transform: r,
        symbol: s,
        styles: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, A), u.styles)
    }), { children: v, attributes: y } = i.found && t.found ? $785da19a645c07eb$var$En("generateAbstractMask", _) || {
        children: [],
        attributes: {}
    } : $785da19a645c07eb$var$En("generateAbstractIcon", _) || {
        children: [],
        attributes: {}
    };
    return _.children = v, _.attributes = y, s ? function(e1) {
        let { prefix: t, iconName: i, children: n, attributes: a, symbol: r } = e1;
        const s = !0 === r ? "".concat(t, "-").concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat(i) : r;
        return [
            {
                tag: "svg",
                attributes: {
                    style: "display: none;"
                },
                children: [
                    {
                        tag: "symbol",
                        attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, a), {}, {
                            id: s
                        }),
                        children: n
                    }
                ]
            }
        ];
    }(_) : function(e1) {
        let { children: t, main: i, mask: n, attributes: a, styles: r, transform: s } = e1;
        if ($785da19a645c07eb$var$zi(s) && i.found && !n.found) {
            const { width: e1, height: t } = i, n = {
                x: e1 / t / 2,
                y: .5
            };
            a.style = $785da19a645c07eb$var$Fi($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, r), {}, {
                "transform-origin": "".concat(n.x + s.x / 16, "em ").concat(n.y + s.y / 16, "em")
            }));
        }
        return [
            {
                tag: "svg",
                attributes: a,
                children: t
            }
        ];
    }(_);
}
function $785da19a645c07eb$var$Fn(e1) {
    const { content: t, width: i, height: n, transform: a, title: r, extra: s, watchable: o = !1 } = e1, l = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, s.attributes), r ? {
        title: r
    } : {}), {}, {
        class: s.classes.join(" ")
    });
    o && (l[$785da19a645c07eb$var$ti] = "");
    const c = $785da19a645c07eb$var$yt({}, s.styles);
    $785da19a645c07eb$var$zi(a) && (c.transform = function(e1) {
        let { transform: t, width: i = $785da19a645c07eb$var$$t, height: n = $785da19a645c07eb$var$$t, startCentered: a = !1 } = e1, r = "";
        return r += a && $785da19a645c07eb$var$It ? "translate(".concat(t.x / $785da19a645c07eb$var$Mi - i / 2, "em, ").concat(t.y / $785da19a645c07eb$var$Mi - n / 2, "em) ") : a ? "translate(calc(-50% + ".concat(t.x / $785da19a645c07eb$var$Mi, "em), calc(-50% + ").concat(t.y / $785da19a645c07eb$var$Mi, "em)) ") : "translate(".concat(t.x / $785da19a645c07eb$var$Mi, "em, ").concat(t.y / $785da19a645c07eb$var$Mi, "em) "), r += "scale(".concat(t.size / $785da19a645c07eb$var$Mi * (t.flipX ? -1 : 1), ", ").concat(t.size / $785da19a645c07eb$var$Mi * (t.flipY ? -1 : 1), ") "), r += "rotate(".concat(t.rotate, "deg) "), r;
    }({
        transform: a,
        startCentered: !0,
        width: i,
        height: n
    }), c["-webkit-transform"] = c.transform);
    const u = $785da19a645c07eb$var$Fi(c);
    u.length > 0 && (l.style = u);
    const h = [];
    return h.push({
        tag: "span",
        attributes: l,
        children: [
            t
        ]
    }), r && h.push({
        tag: "span",
        attributes: {
            class: "sr-only"
        },
        children: [
            r
        ]
    }), h;
}
const { styles: $785da19a645c07eb$var$zn } = $785da19a645c07eb$var$Ni;
function $785da19a645c07eb$var$Rn(e1) {
    const t = e1[0], i = e1[1], [n] = e1.slice(4);
    let a = null;
    return a = Array.isArray(n) ? {
        tag: "g",
        attributes: {
            class: "".concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat($785da19a645c07eb$var$yi.GROUP)
        },
        children: [
            {
                tag: "path",
                attributes: {
                    class: "".concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat($785da19a645c07eb$var$yi.SECONDARY),
                    fill: "currentColor",
                    d: n[0]
                }
            },
            {
                tag: "path",
                attributes: {
                    class: "".concat($785da19a645c07eb$var$ki.cssPrefix, "-").concat($785da19a645c07eb$var$yi.PRIMARY),
                    fill: "currentColor",
                    d: n[1]
                }
            }
        ]
    } : {
        tag: "path",
        attributes: {
            fill: "currentColor",
            d: n
        }
    }, {
        found: !0,
        width: t,
        height: i,
        icon: a
    };
}
const $785da19a645c07eb$var$Ln = {
    found: !1,
    width: 512,
    height: 512
};
function $785da19a645c07eb$var$Bn(e1, t) {
    let i = t;
    return "fa" === t && null !== $785da19a645c07eb$var$ki.styleDefault && (t = $785da19a645c07eb$var$dn()), new Promise((n, a)=>{
        if ("fa" === i) {
            const i = $785da19a645c07eb$var$hn(e1) || {};
            e1 = i.iconName || e1, t = i.prefix || t;
        }
        if (e1 && t && $785da19a645c07eb$var$zn[t] && $785da19a645c07eb$var$zn[t][e1]) return n($785da19a645c07eb$var$Rn($785da19a645c07eb$var$zn[t][e1]));
        !function(e1, t) {
            $785da19a645c07eb$var$oi || $785da19a645c07eb$var$ki.showMissingIcons || !e1 || console.error('Icon with name "'.concat(e1, '" and prefix "').concat(t, '" is missing.'));
        }(e1, t), n($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ln), {}, {
            icon: $785da19a645c07eb$var$ki.showMissingIcons && e1 && $785da19a645c07eb$var$En("missingIconAbstract") || {}
        }));
    });
}
const $785da19a645c07eb$var$On = ()=>{}, $785da19a645c07eb$var$Un = $785da19a645c07eb$var$ki.measurePerformance && $785da19a645c07eb$var$Dt && $785da19a645c07eb$var$Dt.mark && $785da19a645c07eb$var$Dt.measure ? $785da19a645c07eb$var$Dt : {
    mark: $785da19a645c07eb$var$On,
    measure: $785da19a645c07eb$var$On
}, $785da19a645c07eb$var$Nn = 'FA "6.7.2"', $785da19a645c07eb$var$jn = (e1)=>{
    $785da19a645c07eb$var$Un.mark("".concat($785da19a645c07eb$var$Nn, " ").concat(e1, " ends")), $785da19a645c07eb$var$Un.measure("".concat($785da19a645c07eb$var$Nn, " ").concat(e1), "".concat($785da19a645c07eb$var$Nn, " ").concat(e1, " begins"), "".concat($785da19a645c07eb$var$Nn, " ").concat(e1, " ends"));
};
var $785da19a645c07eb$var$Vn = (e1)=>($785da19a645c07eb$var$Un.mark("".concat($785da19a645c07eb$var$Nn, " ").concat(e1, " begins")), ()=>$785da19a645c07eb$var$jn(e1));
const $785da19a645c07eb$var$qn = ()=>{};
function $785da19a645c07eb$var$Gn(e1) {
    return "string" == typeof (e1.getAttribute ? e1.getAttribute($785da19a645c07eb$var$ti) : null);
}
function $785da19a645c07eb$var$Hn(e1) {
    return $785da19a645c07eb$var$Ct.createElementNS("http://www.w3.org/2000/svg", e1);
}
function $785da19a645c07eb$var$Wn(e1) {
    return $785da19a645c07eb$var$Ct.createElement(e1);
}
function $785da19a645c07eb$var$Zn(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { ceFn: i = "svg" === e1.tag ? $785da19a645c07eb$var$Hn : $785da19a645c07eb$var$Wn } = t;
    if ("string" == typeof e1) return $785da19a645c07eb$var$Ct.createTextNode(e1);
    const n = i(e1.tag);
    Object.keys(e1.attributes || []).forEach(function(t) {
        n.setAttribute(t, e1.attributes[t]);
    });
    return (e1.children || []).forEach(function(e1) {
        n.appendChild($785da19a645c07eb$var$Zn(e1, {
            ceFn: i
        }));
    }), n;
}
const $785da19a645c07eb$var$Kn = {
    replace: function(e1) {
        const t = e1[0];
        if (t.parentNode) {
            if (e1[1].forEach((e1)=>{
                t.parentNode.insertBefore($785da19a645c07eb$var$Zn(e1), t);
            }), null === t.getAttribute($785da19a645c07eb$var$ti) && $785da19a645c07eb$var$ki.keepOriginalSource) {
                let e1 = $785da19a645c07eb$var$Ct.createComment(function(e1) {
                    let t = " ".concat(e1.outerHTML, " ");
                    return t = "".concat(t, "Font Awesome fontawesome.com "), t;
                }(t));
                t.parentNode.replaceChild(e1, t);
            } else t.remove();
        }
    },
    nest: function(e1) {
        const t = e1[0], i = e1[1];
        if (~$785da19a645c07eb$var$Pi(t).indexOf($785da19a645c07eb$var$ki.replacementClass)) return $785da19a645c07eb$var$Kn.replace(e1);
        const n = new RegExp("".concat($785da19a645c07eb$var$ki.cssPrefix, "-.*"));
        if (delete i[0].attributes.id, i[0].attributes.class) {
            const e1 = i[0].attributes.class.split(" ").reduce((e1, t)=>(t === $785da19a645c07eb$var$ki.replacementClass || t.match(n) ? e1.toSvg.push(t) : e1.toNode.push(t), e1), {
                toNode: [],
                toSvg: []
            });
            i[0].attributes.class = e1.toSvg.join(" "), 0 === e1.toNode.length ? t.removeAttribute("class") : t.setAttribute("class", e1.toNode.join(" "));
        }
        const a = i.map((e1)=>$785da19a645c07eb$var$Gi(e1)).join("\n");
        t.setAttribute($785da19a645c07eb$var$ti, ""), t.innerHTML = a;
    }
};
function $785da19a645c07eb$var$Xn(e1) {
    e1();
}
function $785da19a645c07eb$var$Qn(e1, t) {
    const i = "function" == typeof t ? t : $785da19a645c07eb$var$qn;
    if (0 === e1.length) i();
    else {
        let t = $785da19a645c07eb$var$Xn;
        "async" === $785da19a645c07eb$var$ki.mutateApproach && (t = $785da19a645c07eb$var$Mt.requestAnimationFrame || $785da19a645c07eb$var$Xn), t(()=>{
            const t = !0 === $785da19a645c07eb$var$ki.autoReplaceSvg ? $785da19a645c07eb$var$Kn.replace : $785da19a645c07eb$var$Kn[$785da19a645c07eb$var$ki.autoReplaceSvg] || $785da19a645c07eb$var$Kn.replace, n = $785da19a645c07eb$var$Vn("mutate");
            e1.map(t), n(), i();
        });
    }
}
let $785da19a645c07eb$var$Yn = !1;
function $785da19a645c07eb$var$Jn() {
    $785da19a645c07eb$var$Yn = !0;
}
function $785da19a645c07eb$var$$n() {
    $785da19a645c07eb$var$Yn = !1;
}
let $785da19a645c07eb$var$ea = null;
function $785da19a645c07eb$var$ta(e1) {
    if (!$785da19a645c07eb$var$Tt) return;
    if (!$785da19a645c07eb$var$ki.observeMutations) return;
    const { treeCallback: t = $785da19a645c07eb$var$qn, nodeCallback: i = $785da19a645c07eb$var$qn, pseudoElementsCallback: n = $785da19a645c07eb$var$qn, observeMutationsRoot: a = $785da19a645c07eb$var$Ct } = e1;
    $785da19a645c07eb$var$ea = new $785da19a645c07eb$var$Tt((e1)=>{
        if ($785da19a645c07eb$var$Yn) return;
        const a = $785da19a645c07eb$var$dn();
        $785da19a645c07eb$var$Di(e1).forEach((e1)=>{
            if ("childList" === e1.type && e1.addedNodes.length > 0 && !$785da19a645c07eb$var$Gn(e1.addedNodes[0]) && ($785da19a645c07eb$var$ki.searchPseudoElements && n(e1.target), t(e1.target)), "attributes" === e1.type && e1.target.parentNode && $785da19a645c07eb$var$ki.searchPseudoElements && n(e1.target.parentNode), "attributes" === e1.type && $785da19a645c07eb$var$Gn(e1.target) && ~$785da19a645c07eb$var$vi.indexOf(e1.attributeName)) {
                if ("class" === e1.attributeName && function(e1) {
                    const t = e1.getAttribute ? e1.getAttribute($785da19a645c07eb$var$ni) : null, i = e1.getAttribute ? e1.getAttribute($785da19a645c07eb$var$ai) : null;
                    return t && i;
                }(e1.target)) {
                    const { prefix: t, iconName: i } = $785da19a645c07eb$var$gn($785da19a645c07eb$var$Pi(e1.target));
                    e1.target.setAttribute($785da19a645c07eb$var$ni, t || a), i && e1.target.setAttribute($785da19a645c07eb$var$ai, i);
                } else (r = e1.target) && r.classList && r.classList.contains && r.classList.contains($785da19a645c07eb$var$ki.replacementClass) && i(e1.target);
            }
            var r;
        });
    }), $785da19a645c07eb$var$Pt && $785da19a645c07eb$var$ea.observe(a, {
        childList: !0,
        attributes: !0,
        characterData: !0,
        subtree: !0
    });
}
function $785da19a645c07eb$var$ia(e1) {
    const t = e1.getAttribute("data-prefix"), i = e1.getAttribute("data-icon"), n = void 0 !== e1.innerText ? e1.innerText.trim() : "";
    let a = $785da19a645c07eb$var$gn($785da19a645c07eb$var$Pi(e1));
    var r, s;
    return a.prefix || (a.prefix = $785da19a645c07eb$var$dn()), t && i && (a.prefix = t, a.iconName = i), a.iconName && a.prefix || (a.prefix && n.length > 0 && (a.iconName = (r = a.prefix, s = e1.innerText, ($785da19a645c07eb$var$nn[r] || {})[s] || $785da19a645c07eb$var$cn(a.prefix, $785da19a645c07eb$var$Zi(e1.innerText)))), !a.iconName && $785da19a645c07eb$var$ki.autoFetchSvg && e1.firstChild && e1.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e1.firstChild.data)), a;
}
function $785da19a645c07eb$var$na(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
        styleParser: !0
    };
    const { iconName: i, prefix: n, rest: a } = $785da19a645c07eb$var$ia(e1), r = function(e1) {
        const t = $785da19a645c07eb$var$Di(e1.attributes).reduce((e1, t)=>("class" !== e1.name && "style" !== e1.name && (e1[t.name] = t.value), e1), {}), i = e1.getAttribute("title"), n = e1.getAttribute("data-fa-title-id");
        return $785da19a645c07eb$var$ki.autoA11y && (i ? t["aria-labelledby"] = "".concat($785da19a645c07eb$var$ki.replacementClass, "-title-").concat(n || $785da19a645c07eb$var$Ti()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
    }(e1), s = $785da19a645c07eb$var$bn("parseNodeAttributes", {}, e1);
    let o = t.styleParser ? function(e1) {
        const t = e1.getAttribute("style");
        let i = [];
        return t && (i = t.split(";").reduce((e1, t)=>{
            const i = t.split(":"), n = i[0], a = i.slice(1);
            return n && a.length > 0 && (e1[n] = a.join(":").trim()), e1;
        }, {})), i;
    }(e1) : [];
    return $785da19a645c07eb$var$yt({
        iconName: i,
        title: e1.getAttribute("title"),
        titleId: e1.getAttribute("data-fa-title-id"),
        prefix: n,
        transform: $785da19a645c07eb$var$Ci,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: !1,
        extra: {
            classes: a,
            styles: o,
            attributes: r
        }
    }, s);
}
const { styles: $785da19a645c07eb$var$aa } = $785da19a645c07eb$var$Ni;
function $785da19a645c07eb$var$ra(e1) {
    const t = "nest" === $785da19a645c07eb$var$ki.autoReplaceSvg ? $785da19a645c07eb$var$na(e1, {
        styleParser: !1
    }) : $785da19a645c07eb$var$na(e1);
    return ~t.extra.classes.indexOf($785da19a645c07eb$var$Ai) ? $785da19a645c07eb$var$En("generateLayersText", e1, t) : $785da19a645c07eb$var$En("generateSvgReplacementMutation", e1, t);
}
function $785da19a645c07eb$var$sa(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    if (!$785da19a645c07eb$var$Pt) return Promise.resolve();
    const i = $785da19a645c07eb$var$Ct.documentElement.classList, n = (e1)=>i.add("".concat($785da19a645c07eb$var$ri, "-").concat(e1)), a = (e1)=>i.remove("".concat($785da19a645c07eb$var$ri, "-").concat(e1)), r = $785da19a645c07eb$var$ki.autoFetchSvg ? [
        ...$785da19a645c07eb$var$Ut,
        ...$785da19a645c07eb$var$Kt
    ] : $785da19a645c07eb$var$zt.concat(Object.keys($785da19a645c07eb$var$aa));
    r.includes("fa") || r.push("fa");
    const s = [
        ".".concat($785da19a645c07eb$var$Ai, ":not([").concat($785da19a645c07eb$var$ti, "])")
    ].concat(r.map((e1)=>".".concat(e1, ":not([").concat($785da19a645c07eb$var$ti, "])"))).join(", ");
    if (0 === s.length) return Promise.resolve();
    let o = [];
    try {
        o = $785da19a645c07eb$var$Di(e1.querySelectorAll(s));
    } catch (e1) {}
    if (!(o.length > 0)) return Promise.resolve();
    n("pending"), a("complete");
    const l = $785da19a645c07eb$var$Vn("onTree"), c = o.reduce((e1, t)=>{
        try {
            const i = $785da19a645c07eb$var$ra(t);
            i && e1.push(i);
        } catch (e1) {
            $785da19a645c07eb$var$oi || "MissingIcon" === e1.name && console.error(e1);
        }
        return e1;
    }, []);
    return new Promise((e1, i)=>{
        Promise.all(c).then((i)=>{
            $785da19a645c07eb$var$Qn(i, ()=>{
                n("active"), n("complete"), a("pending"), "function" == typeof t && t(), l(), e1();
            });
        }).catch((e1)=>{
            l(), i(e1);
        });
    });
}
function $785da19a645c07eb$var$oa(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
    $785da19a645c07eb$var$ra(e1).then((e1)=>{
        e1 && $785da19a645c07eb$var$Qn([
            e1
        ], t);
    });
}
const $785da19a645c07eb$var$la = function(e1) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    const { transform: i = $785da19a645c07eb$var$Ci, symbol: n = !1, mask: a = null, maskId: r = null, title: s = null, titleId: o = null, classes: l = [], attributes: c = {}, styles: u = {} } = t;
    if (!e1) return;
    const { prefix: h, iconName: d, icon: p } = e1;
    return $785da19a645c07eb$var$Pn($785da19a645c07eb$var$yt({
        type: "icon"
    }, e1), ()=>($785da19a645c07eb$var$wn("beforeDOMElementCreation", {
            iconDefinition: e1,
            params: t
        }), $785da19a645c07eb$var$ki.autoA11y && (s ? c["aria-labelledby"] = "".concat($785da19a645c07eb$var$ki.replacementClass, "-title-").concat(o || $785da19a645c07eb$var$Ti()) : (c["aria-hidden"] = "true", c.focusable = "false")), $785da19a645c07eb$var$In({
            icons: {
                main: $785da19a645c07eb$var$Rn(p),
                mask: a ? $785da19a645c07eb$var$Rn(a.icon) : {
                    found: !1,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: h,
            iconName: d,
            transform: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ci), i),
            symbol: n,
            title: s,
            maskId: r,
            titleId: o,
            extra: {
                attributes: c,
                styles: u,
                classes: l
            }
        })));
};
var $785da19a645c07eb$var$ca = {
    mixout () {
        var e1;
        return {
            icon: (e1 = $785da19a645c07eb$var$la, function(t) {
                let i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const n = (t || {}).icon ? t : $785da19a645c07eb$var$kn(t || {});
                let { mask: a } = i;
                return a && (a = (a || {}).icon ? a : $785da19a645c07eb$var$kn(a || {})), e1(n, $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, i), {}, {
                    mask: a
                }));
            })
        };
    },
    hooks: ()=>({
            mutationObserverCallbacks: (e1)=>(e1.treeCallback = $785da19a645c07eb$var$sa, e1.nodeCallback = $785da19a645c07eb$var$oa, e1)
        }),
    provides (e1) {
        e1.i2svg = function(e1) {
            const { node: t = $785da19a645c07eb$var$Ct, callback: i = ()=>{} } = e1;
            return $785da19a645c07eb$var$sa(t, i);
        }, e1.generateSvgReplacementMutation = function(e1, t) {
            const { iconName: i, title: n, titleId: a, prefix: r, transform: s, symbol: o, mask: l, maskId: c, extra: u } = t;
            return new Promise((t, h)=>{
                Promise.all([
                    $785da19a645c07eb$var$Bn(i, r),
                    l.iconName ? $785da19a645c07eb$var$Bn(l.iconName, l.prefix) : Promise.resolve({
                        found: !1,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then((l)=>{
                    let [h, d] = l;
                    t([
                        e1,
                        $785da19a645c07eb$var$In({
                            icons: {
                                main: h,
                                mask: d
                            },
                            prefix: r,
                            iconName: i,
                            transform: s,
                            symbol: o,
                            maskId: c,
                            title: n,
                            titleId: a,
                            extra: u,
                            watchable: !0
                        })
                    ]);
                }).catch(h);
            });
        }, e1.generateAbstractIcon = function(e1) {
            let { children: t, attributes: i, main: n, transform: a, styles: r } = e1;
            const s = $785da19a645c07eb$var$Fi(r);
            let o;
            return s.length > 0 && (i.style = s), $785da19a645c07eb$var$zi(a) && (o = $785da19a645c07eb$var$En("generateAbstractTransformGrouping", {
                main: n,
                transform: a,
                containerWidth: n.width,
                iconWidth: n.width
            })), t.push(o || n.icon), {
                children: t,
                attributes: i
            };
        };
    }
}, $785da19a645c07eb$var$ua = {
    mixout: ()=>({
            layer (e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { classes: i = [] } = t;
                return $785da19a645c07eb$var$Pn({
                    type: "layer"
                }, ()=>{
                    $785da19a645c07eb$var$wn("beforeDOMElementCreation", {
                        assembler: e1,
                        params: t
                    });
                    let n = [];
                    return e1((e1)=>{
                        Array.isArray(e1) ? e1.map((e1)=>{
                            n = n.concat(e1.abstract);
                        }) : n = n.concat(e1.abstract);
                    }), [
                        {
                            tag: "span",
                            attributes: {
                                class: [
                                    "".concat($785da19a645c07eb$var$ki.cssPrefix, "-layers"),
                                    ...i
                                ].join(" ")
                            },
                            children: n
                        }
                    ];
                });
            }
        })
}, $785da19a645c07eb$var$ha = {
    mixout: ()=>({
            counter (e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { title: i = null, classes: n = [], attributes: a = {}, styles: r = {} } = t;
                return $785da19a645c07eb$var$Pn({
                    type: "counter",
                    content: e1
                }, ()=>($785da19a645c07eb$var$wn("beforeDOMElementCreation", {
                        content: e1,
                        params: t
                    }), function(e1) {
                        const { content: t, title: i, extra: n } = e1, a = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, n.attributes), i ? {
                            title: i
                        } : {}), {}, {
                            class: n.classes.join(" ")
                        }), r = $785da19a645c07eb$var$Fi(n.styles);
                        r.length > 0 && (a.style = r);
                        const s = [];
                        return s.push({
                            tag: "span",
                            attributes: a,
                            children: [
                                t
                            ]
                        }), i && s.push({
                            tag: "span",
                            attributes: {
                                class: "sr-only"
                            },
                            children: [
                                i
                            ]
                        }), s;
                    }({
                        content: e1.toString(),
                        title: i,
                        extra: {
                            attributes: a,
                            styles: r,
                            classes: [
                                "".concat($785da19a645c07eb$var$ki.cssPrefix, "-layers-counter"),
                                ...n
                            ]
                        }
                    })));
            }
        })
}, $785da19a645c07eb$var$da = {
    mixout: ()=>({
            text (e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const { transform: i = $785da19a645c07eb$var$Ci, title: n = null, classes: a = [], attributes: r = {}, styles: s = {} } = t;
                return $785da19a645c07eb$var$Pn({
                    type: "text",
                    content: e1
                }, ()=>($785da19a645c07eb$var$wn("beforeDOMElementCreation", {
                        content: e1,
                        params: t
                    }), $785da19a645c07eb$var$Fn({
                        content: e1,
                        transform: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ci), i),
                        title: n,
                        extra: {
                            attributes: r,
                            styles: s,
                            classes: [
                                "".concat($785da19a645c07eb$var$ki.cssPrefix, "-layers-text"),
                                ...a
                            ]
                        }
                    })));
            }
        }),
    provides (e1) {
        e1.generateLayersText = function(e1, t) {
            const { title: i, transform: n, extra: a } = t;
            let r = null, s = null;
            if ($785da19a645c07eb$var$It) {
                const t = parseInt(getComputedStyle(e1).fontSize, 10), i = e1.getBoundingClientRect();
                r = i.width / t, s = i.height / t;
            }
            return $785da19a645c07eb$var$ki.autoA11y && !i && (a.attributes["aria-hidden"] = "true"), Promise.resolve([
                e1,
                $785da19a645c07eb$var$Fn({
                    content: e1.innerHTML,
                    width: r,
                    height: s,
                    transform: n,
                    title: i,
                    extra: a,
                    watchable: !0
                })
            ]);
        };
    }
};
const $785da19a645c07eb$var$pa = new RegExp('"', "ug"), $785da19a645c07eb$var$ma = [
    1105920,
    1112319
], $785da19a645c07eb$var$ga = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, {
    FontAwesome: {
        normal: "fas",
        400: "fas"
    }
}), {
    "Font Awesome 6 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 6 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 6 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 6 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 6 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 6 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    }
}), {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
}), {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}), $785da19a645c07eb$var$fa = Object.keys($785da19a645c07eb$var$ga).reduce((e1, t)=>(e1[t.toLowerCase()] = $785da19a645c07eb$var$ga[t], e1), {}), $785da19a645c07eb$var$Aa = Object.keys($785da19a645c07eb$var$fa).reduce((e1, t)=>{
    const i = $785da19a645c07eb$var$fa[t];
    return e1[t] = i[900] || [
        ...Object.entries(i)
    ][0][1], e1;
}, {});
function $785da19a645c07eb$var$_a(e1, t) {
    const i = "".concat("data-fa-pseudo-element-pending").concat(t.replace(":", "-"));
    return new Promise((n, a)=>{
        if (null !== e1.getAttribute(i)) return n();
        const r = $785da19a645c07eb$var$Di(e1.children).filter((e1)=>e1.getAttribute($785da19a645c07eb$var$ii) === t)[0], s = $785da19a645c07eb$var$Mt.getComputedStyle(e1, t), o = s.getPropertyValue("font-family"), l = o.match($785da19a645c07eb$var$_i), c = s.getPropertyValue("font-weight"), u = s.getPropertyValue("content");
        if (r && !l) return e1.removeChild(r), n();
        if (l && "none" !== u && "" !== u) {
            const u = s.getPropertyValue("content");
            let h = function(e1, t) {
                const i = e1.replace(/^['"]|['"]$/g, "").toLowerCase(), n = parseInt(t), a = isNaN(n) ? "normal" : n;
                return ($785da19a645c07eb$var$fa[i] || {})[a] || $785da19a645c07eb$var$Aa[i];
            }(o, c);
            const { value: d, isSecondary: p } = function(e1) {
                const t = e1.replace($785da19a645c07eb$var$pa, ""), i = function(e1, t) {
                    const i = e1.length;
                    let n, a = e1.charCodeAt(t);
                    return a >= 55296 && a <= 56319 && i > t + 1 && (n = e1.charCodeAt(t + 1), n >= 56320 && n <= 57343) ? 1024 * (a - 55296) + n - 56320 + 65536 : a;
                }(t, 0), n = i >= $785da19a645c07eb$var$ma[0] && i <= $785da19a645c07eb$var$ma[1], a = 2 === t.length && t[0] === t[1];
                return {
                    value: $785da19a645c07eb$var$Zi(a ? t[0] : t),
                    isSecondary: n || a
                };
            }(u), m = l[0].startsWith("FontAwesome");
            let g = $785da19a645c07eb$var$cn(h, d), f = g;
            if (m) {
                const e1 = function(e1) {
                    const t = $785da19a645c07eb$var$rn[e1], i = $785da19a645c07eb$var$cn("fas", e1);
                    return t || (i ? {
                        prefix: "fas",
                        iconName: i
                    } : null) || {
                        prefix: null,
                        iconName: null
                    };
                }(d);
                e1.iconName && e1.prefix && (g = e1.iconName, h = e1.prefix);
            }
            if (!g || p || r && r.getAttribute($785da19a645c07eb$var$ni) === h && r.getAttribute($785da19a645c07eb$var$ai) === f) n();
            else {
                e1.setAttribute(i, f), r && e1.removeChild(r);
                const s = {
                    iconName: null,
                    title: null,
                    titleId: null,
                    prefix: null,
                    transform: $785da19a645c07eb$var$Ci,
                    symbol: !1,
                    mask: {
                        iconName: null,
                        prefix: null,
                        rest: []
                    },
                    maskId: null,
                    extra: {
                        classes: [],
                        styles: {},
                        attributes: {}
                    }
                }, { extra: o } = s;
                o.attributes[$785da19a645c07eb$var$ii] = t, $785da19a645c07eb$var$Bn(g, h).then((a)=>{
                    const r = $785da19a645c07eb$var$In($785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, s), {}, {
                        icons: {
                            main: a,
                            mask: {
                                prefix: null,
                                iconName: null,
                                rest: []
                            }
                        },
                        prefix: h,
                        iconName: f,
                        extra: o,
                        watchable: !0
                    })), l = $785da19a645c07eb$var$Ct.createElementNS("http://www.w3.org/2000/svg", "svg");
                    "::before" === t ? e1.insertBefore(l, e1.firstChild) : e1.appendChild(l), l.outerHTML = r.map((e1)=>$785da19a645c07eb$var$Gi(e1)).join("\n"), e1.removeAttribute(i), n();
                }).catch(a);
            }
        } else n();
    });
}
function $785da19a645c07eb$var$va(e1) {
    return Promise.all([
        $785da19a645c07eb$var$_a(e1, "::before"),
        $785da19a645c07eb$var$_a(e1, "::after")
    ]);
}
function $785da19a645c07eb$var$ya(e1) {
    return !(e1.parentNode === document.head || ~$785da19a645c07eb$var$si.indexOf(e1.tagName.toUpperCase()) || e1.getAttribute($785da19a645c07eb$var$ii) || e1.parentNode && "svg" === e1.parentNode.tagName);
}
function $785da19a645c07eb$var$xa(e1) {
    if ($785da19a645c07eb$var$Pt) return new Promise((t, i)=>{
        const n = $785da19a645c07eb$var$Di(e1.querySelectorAll("*")).filter($785da19a645c07eb$var$ya).map($785da19a645c07eb$var$va), a = $785da19a645c07eb$var$Vn("searchPseudoElements");
        $785da19a645c07eb$var$Jn(), Promise.all(n).then(()=>{
            a(), $785da19a645c07eb$var$$n(), t();
        }).catch(()=>{
            a(), $785da19a645c07eb$var$$n(), i();
        });
    });
}
var $785da19a645c07eb$var$ba = {
    hooks: ()=>({
            mutationObserverCallbacks: (e1)=>(e1.pseudoElementsCallback = $785da19a645c07eb$var$xa, e1)
        }),
    provides (e1) {
        e1.pseudoElements2svg = function(e1) {
            const { node: t = $785da19a645c07eb$var$Ct } = e1;
            $785da19a645c07eb$var$ki.searchPseudoElements && $785da19a645c07eb$var$xa(t);
        };
    }
};
let $785da19a645c07eb$var$wa = !1;
var $785da19a645c07eb$var$Ea = {
    mixout: ()=>({
            dom: {
                unwatch () {
                    $785da19a645c07eb$var$Jn(), $785da19a645c07eb$var$wa = !0;
                }
            }
        }),
    hooks: ()=>({
            bootstrap () {
                $785da19a645c07eb$var$ta($785da19a645c07eb$var$bn("mutationObserverCallbacks", {}));
            },
            noAuto () {
                $785da19a645c07eb$var$ea && $785da19a645c07eb$var$ea.disconnect();
            },
            watch (e1) {
                const { observeMutationsRoot: t } = e1;
                $785da19a645c07eb$var$wa ? $785da19a645c07eb$var$$n() : $785da19a645c07eb$var$ta($785da19a645c07eb$var$bn("mutationObserverCallbacks", {
                    observeMutationsRoot: t
                }));
            }
        })
};
const $785da19a645c07eb$var$ka = (e1)=>e1.toLowerCase().split(" ").reduce((e1, t)=>{
        const i = t.toLowerCase().split("-"), n = i[0];
        let a = i.slice(1).join("-");
        if (n && "h" === a) return e1.flipX = !0, e1;
        if (n && "v" === a) return e1.flipY = !0, e1;
        if (a = parseFloat(a), isNaN(a)) return e1;
        switch(n){
            case "grow":
                e1.size = e1.size + a;
                break;
            case "shrink":
                e1.size = e1.size - a;
                break;
            case "left":
                e1.x = e1.x - a;
                break;
            case "right":
                e1.x = e1.x + a;
                break;
            case "up":
                e1.y = e1.y - a;
                break;
            case "down":
                e1.y = e1.y + a;
                break;
            case "rotate":
                e1.rotate = e1.rotate + a;
        }
        return e1;
    }, {
        size: 16,
        x: 0,
        y: 0,
        flipX: !1,
        flipY: !1,
        rotate: 0
    });
var $785da19a645c07eb$var$Sa = {
    mixout: ()=>({
            parse: {
                transform: (e1)=>$785da19a645c07eb$var$ka(e1)
            }
        }),
    hooks: ()=>({
            parseNodeAttributes (e1, t) {
                const i = t.getAttribute("data-fa-transform");
                return i && (e1.transform = $785da19a645c07eb$var$ka(i)), e1;
            }
        }),
    provides (e1) {
        e1.generateAbstractTransformGrouping = function(e1) {
            let { main: t, transform: i, containerWidth: n, iconWidth: a } = e1;
            const r = {
                transform: "translate(".concat(n / 2, " 256)")
            }, s = "translate(".concat(32 * i.x, ", ").concat(32 * i.y, ") "), o = "scale(".concat(i.size / 16 * (i.flipX ? -1 : 1), ", ").concat(i.size / 16 * (i.flipY ? -1 : 1), ") "), l = "rotate(".concat(i.rotate, " 0 0)"), c = {
                outer: r,
                inner: {
                    transform: "".concat(s, " ").concat(o, " ").concat(l)
                },
                path: {
                    transform: "translate(".concat(a / 2 * -1, " -256)")
                }
            };
            return {
                tag: "g",
                attributes: $785da19a645c07eb$var$yt({}, c.outer),
                children: [
                    {
                        tag: "g",
                        attributes: $785da19a645c07eb$var$yt({}, c.inner),
                        children: [
                            {
                                tag: t.icon.tag,
                                children: t.icon.children,
                                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, t.icon.attributes), c.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
const $785da19a645c07eb$var$Ma = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
};
function $785da19a645c07eb$var$Ca(e1) {
    let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    return e1.attributes && (e1.attributes.fill || t) && (e1.attributes.fill = "black"), e1;
}
var $785da19a645c07eb$var$Ta = {
    hooks: ()=>({
            parseNodeAttributes (e1, t) {
                const i = t.getAttribute("data-fa-mask"), n = i ? $785da19a645c07eb$var$gn(i.split(" ").map((e1)=>e1.trim())) : {
                    prefix: null,
                    iconName: null,
                    rest: []
                };
                return n.prefix || (n.prefix = $785da19a645c07eb$var$dn()), e1.mask = n, e1.maskId = t.getAttribute("data-fa-mask-id"), e1;
            }
        }),
    provides (e1) {
        e1.generateAbstractMask = function(e1) {
            let { children: t, attributes: i, main: n, mask: a, maskId: r, transform: s } = e1;
            const { width: o, icon: l } = n, { width: c, icon: u } = a, h = function(e1) {
                let { transform: t, containerWidth: i, iconWidth: n } = e1;
                const a = {
                    transform: "translate(".concat(i / 2, " 256)")
                }, r = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "), s = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)");
                return {
                    outer: a,
                    inner: {
                        transform: "".concat(r, " ").concat(s, " ").concat(o)
                    },
                    path: {
                        transform: "translate(".concat(n / 2 * -1, " -256)")
                    }
                };
            }({
                transform: s,
                containerWidth: c,
                iconWidth: o
            }), d = {
                tag: "rect",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ma), {}, {
                    fill: "white"
                })
            }, p = l.children ? {
                children: l.children.map($785da19a645c07eb$var$Ca)
            } : {}, m = {
                tag: "g",
                attributes: $785da19a645c07eb$var$yt({}, h.inner),
                children: [
                    $785da19a645c07eb$var$Ca($785da19a645c07eb$var$yt({
                        tag: l.tag,
                        attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, l.attributes), h.path)
                    }, p))
                ]
            }, g = {
                tag: "g",
                attributes: $785da19a645c07eb$var$yt({}, h.outer),
                children: [
                    m
                ]
            }, f = "mask-".concat(r || $785da19a645c07eb$var$Ti()), A = "clip-".concat(r || $785da19a645c07eb$var$Ti()), _ = {
                tag: "mask",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, $785da19a645c07eb$var$Ma), {}, {
                    id: f,
                    maskUnits: "userSpaceOnUse",
                    maskContentUnits: "userSpaceOnUse"
                }),
                children: [
                    d,
                    g
                ]
            }, v = {
                tag: "defs",
                children: [
                    {
                        tag: "clipPath",
                        attributes: {
                            id: A
                        },
                        children: (y = u, "g" === y.tag ? y.children : [
                            y
                        ])
                    },
                    _
                ]
            };
            var y;
            return t.push(v, {
                tag: "rect",
                attributes: $785da19a645c07eb$var$yt({
                    fill: "currentColor",
                    "clip-path": "url(#".concat(A, ")"),
                    mask: "url(#".concat(f, ")")
                }, $785da19a645c07eb$var$Ma)
            }), {
                children: t,
                attributes: i
            };
        };
    }
}, $785da19a645c07eb$var$Da = {
    provides (e1) {
        let t = !1;
        $785da19a645c07eb$var$Mt.matchMedia && (t = $785da19a645c07eb$var$Mt.matchMedia("(prefers-reduced-motion: reduce)").matches), e1.missingIconAbstract = function() {
            const e1 = [], i = {
                fill: "currentColor"
            }, n = {
                attributeType: "XML",
                repeatCount: "indefinite",
                dur: "2s"
            };
            e1.push({
                tag: "path",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, i), {}, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                })
            });
            const a = $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, n), {}, {
                attributeName: "opacity"
            }), r = {
                tag: "circle",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, i), {}, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }),
                children: []
            };
            return t || r.children.push({
                tag: "animate",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, n), {}, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            }, {
                tag: "animate",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, a), {}, {
                    values: "1;0;1;1;0;1;"
                })
            }), e1.push(r), e1.push({
                tag: "path",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, i), {}, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }),
                children: t ? [] : [
                    {
                        tag: "animate",
                        attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, a), {}, {
                            values: "1;0;0;0;0;1;"
                        })
                    }
                ]
            }), t || e1.push({
                tag: "path",
                attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, i), {}, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }),
                children: [
                    {
                        tag: "animate",
                        attributes: $785da19a645c07eb$var$yt($785da19a645c07eb$var$yt({}, a), {}, {
                            values: "0;0;1;1;0;0;"
                        })
                    }
                ]
            }), {
                tag: "g",
                attributes: {
                    class: "missing"
                },
                children: e1
            };
        };
    }
};
!function(e1, t) {
    let { mixoutsTo: i } = t;
    $785da19a645c07eb$var$_n = e1, $785da19a645c07eb$var$vn = {}, Object.keys($785da19a645c07eb$var$yn).forEach((e1)=>{
        -1 === $785da19a645c07eb$var$xn.indexOf(e1) && delete $785da19a645c07eb$var$yn[e1];
    }), $785da19a645c07eb$var$_n.forEach((e1)=>{
        const t = e1.mixout ? e1.mixout() : {};
        if (Object.keys(t).forEach((e1)=>{
            "function" == typeof t[e1] && (i[e1] = t[e1]), "object" == typeof t[e1] && Object.keys(t[e1]).forEach((n)=>{
                i[e1] || (i[e1] = {}), i[e1][n] = t[e1][n];
            });
        }), e1.hooks) {
            const t = e1.hooks();
            Object.keys(t).forEach((e1)=>{
                $785da19a645c07eb$var$vn[e1] || ($785da19a645c07eb$var$vn[e1] = []), $785da19a645c07eb$var$vn[e1].push(t[e1]);
            });
        }
        e1.provides && e1.provides($785da19a645c07eb$var$yn);
    });
}([
    $785da19a645c07eb$var$Oi,
    $785da19a645c07eb$var$ca,
    $785da19a645c07eb$var$ua,
    $785da19a645c07eb$var$ha,
    $785da19a645c07eb$var$da,
    $785da19a645c07eb$var$ba,
    $785da19a645c07eb$var$Ea,
    $785da19a645c07eb$var$Sa,
    $785da19a645c07eb$var$Ta,
    $785da19a645c07eb$var$Da,
    {
        hooks: ()=>({
                parseNodeAttributes (e1, t) {
                    const i = t.getAttribute("data-fa-symbol"), n = null !== i && ("" === i || i);
                    return e1.symbol = n, e1;
                }
            })
    }
], {
    mixoutsTo: $785da19a645c07eb$var$Tn
});
const $785da19a645c07eb$var$Pa = $785da19a645c07eb$var$Tn.icon, $785da19a645c07eb$var$Ia = Object.freeze({
    left: 0,
    top: 0,
    width: 16,
    height: 16
}), $785da19a645c07eb$var$Fa = Object.freeze({
    rotate: 0,
    vFlip: !1,
    hFlip: !1
}), $785da19a645c07eb$var$za = Object.freeze({
    ...$785da19a645c07eb$var$Ia,
    ...$785da19a645c07eb$var$Fa
}), $785da19a645c07eb$var$Ra = Object.freeze({
    ...$785da19a645c07eb$var$za,
    body: "",
    hidden: !1
}), $785da19a645c07eb$var$La = Object.freeze({
    width: null,
    height: null
}), $785da19a645c07eb$var$Ba = Object.freeze({
    ...$785da19a645c07eb$var$La,
    ...$785da19a645c07eb$var$Fa
});
const $785da19a645c07eb$var$Oa = /[\s,]+/;
const $785da19a645c07eb$var$Ua = {
    ...$785da19a645c07eb$var$Ba,
    preserveAspectRatio: ""
};
function $785da19a645c07eb$var$Na(e1) {
    const t = {
        ...$785da19a645c07eb$var$Ua
    }, i = (t, i)=>e1.getAttribute(t) || i;
    var n;
    return t.width = i("width", null), t.height = i("height", null), t.rotate = function(e1, t = 0) {
        const i = e1.replace(/^-?[0-9.]*/, "");
        function n(e1) {
            for(; e1 < 0;)e1 += 4;
            return e1 % 4;
        }
        if ("" === i) {
            const t = parseInt(e1);
            return isNaN(t) ? 0 : n(t);
        }
        if (i !== e1) {
            let t = 0;
            switch(i){
                case "%":
                    t = 25;
                    break;
                case "deg":
                    t = 90;
            }
            if (t) {
                let a = parseFloat(e1.slice(0, e1.length - i.length));
                return isNaN(a) ? 0 : (a /= t, a % 1 == 0 ? n(a) : 0);
            }
        }
        return t;
    }(i("rotate", "")), n = t, i("flip", "").split($785da19a645c07eb$var$Oa).forEach((e1)=>{
        switch(e1.trim()){
            case "horizontal":
                n.hFlip = !0;
                break;
            case "vertical":
                n.vFlip = !0;
        }
    }), t.preserveAspectRatio = i("preserveAspectRatio", i("preserveaspectratio", "")), t;
}
const $785da19a645c07eb$var$ja = /^[a-z0-9]+(-[a-z0-9]+)*$/, $785da19a645c07eb$var$Va = (e1, t, i, n = "")=>{
    const a = e1.split(":");
    if ("@" === e1.slice(0, 1)) {
        if (a.length < 2 || a.length > 3) return null;
        n = a.shift().slice(1);
    }
    if (a.length > 3 || !a.length) return null;
    if (a.length > 1) {
        const e1 = a.pop(), i = a.pop(), r = {
            provider: a.length > 0 ? a[0] : n,
            prefix: i,
            name: e1
        };
        return t && !$785da19a645c07eb$var$qa(r) ? null : r;
    }
    const r = a[0], s = r.split("-");
    if (s.length > 1) {
        const e1 = {
            provider: n,
            prefix: s.shift(),
            name: s.join("-")
        };
        return t && !$785da19a645c07eb$var$qa(e1) ? null : e1;
    }
    if (i && "" === n) {
        const e1 = {
            provider: n,
            prefix: "",
            name: r
        };
        return t && !$785da19a645c07eb$var$qa(e1, i) ? null : e1;
    }
    return null;
}, $785da19a645c07eb$var$qa = (e1, t)=>!!e1 && !(!(t && "" === e1.prefix || e1.prefix) || !e1.name);
function $785da19a645c07eb$var$Ga(e1, t) {
    const i = function(e1, t) {
        const i = {};
        !e1.hFlip != !t.hFlip && (i.hFlip = !0), !e1.vFlip != !t.vFlip && (i.vFlip = !0);
        const n = ((e1.rotate || 0) + (t.rotate || 0)) % 4;
        return n && (i.rotate = n), i;
    }(e1, t);
    for(const n in $785da19a645c07eb$var$Ra)n in $785da19a645c07eb$var$Fa ? n in e1 && !(n in i) && (i[n] = $785da19a645c07eb$var$Fa[n]) : n in t ? i[n] = t[n] : n in e1 && (i[n] = e1[n]);
    return i;
}
function $785da19a645c07eb$var$Ha(e1, t, i) {
    const n = e1.icons, a = e1.aliases || Object.create(null);
    let r = {};
    function s(e1) {
        r = $785da19a645c07eb$var$Ga(n[e1] || a[e1], r);
    }
    return s(t), i.forEach(s), $785da19a645c07eb$var$Ga(e1, r);
}
function $785da19a645c07eb$var$Wa(e1, t) {
    const i = [];
    if ("object" != typeof e1 || "object" != typeof e1.icons) return i;
    e1.not_found instanceof Array && e1.not_found.forEach((e1)=>{
        t(e1, null), i.push(e1);
    });
    const n = function(e1) {
        const t = e1.icons, i = e1.aliases || Object.create(null), n = Object.create(null);
        return Object.keys(t).concat(Object.keys(i)).forEach(function e1(a) {
            if (t[a]) return n[a] = [];
            if (!(a in n)) {
                n[a] = null;
                const t = i[a] && i[a].parent, r = t && e1(t);
                r && (n[a] = [
                    t
                ].concat(r));
            }
            return n[a];
        }), n;
    }(e1);
    for(const a in n){
        const r = n[a];
        r && (t(a, $785da19a645c07eb$var$Ha(e1, a, r)), i.push(a));
    }
    return i;
}
const $785da19a645c07eb$var$Za = {
    provider: "",
    aliases: {},
    not_found: {},
    ...$785da19a645c07eb$var$Ia
};
function $785da19a645c07eb$var$Ka(e1, t) {
    for(const i in t)if (i in e1 && typeof e1[i] != typeof t[i]) return !1;
    return !0;
}
function $785da19a645c07eb$var$Xa(e1) {
    if ("object" != typeof e1 || null === e1) return null;
    const t = e1;
    if ("string" != typeof t.prefix || !e1.icons || "object" != typeof e1.icons) return null;
    if (!$785da19a645c07eb$var$Ka(e1, $785da19a645c07eb$var$Za)) return null;
    const i = t.icons;
    for(const e1 in i){
        const t = i[e1];
        if (!e1 || "string" != typeof t.body || !$785da19a645c07eb$var$Ka(t, $785da19a645c07eb$var$Ra)) return null;
    }
    const n = t.aliases || Object.create(null);
    for(const e1 in n){
        const t = n[e1], a = t.parent;
        if (!e1 || "string" != typeof a || !i[a] && !n[a] || !$785da19a645c07eb$var$Ka(t, $785da19a645c07eb$var$Ra)) return null;
    }
    return t;
}
const $785da19a645c07eb$var$Qa = Object.create(null);
function $785da19a645c07eb$var$Ya(e1, t) {
    const i = $785da19a645c07eb$var$Qa[e1] || ($785da19a645c07eb$var$Qa[e1] = Object.create(null));
    return i[t] || (i[t] = function(e1, t) {
        return {
            provider: e1,
            prefix: t,
            icons: Object.create(null),
            missing: new Set
        };
    }(e1, t));
}
function $785da19a645c07eb$var$Ja(e1, t) {
    return $785da19a645c07eb$var$Xa(t) ? $785da19a645c07eb$var$Wa(t, (t, i)=>{
        i ? e1.icons[t] = i : e1.missing.add(t);
    }) : [];
}
function $785da19a645c07eb$var$$a(e1, t) {
    let i = [];
    return ("string" == typeof e1 ? [
        e1
    ] : Object.keys($785da19a645c07eb$var$Qa)).forEach((e1)=>{
        ("string" == typeof e1 && "string" == typeof t ? [
            t
        ] : Object.keys($785da19a645c07eb$var$Qa[e1] || {})).forEach((t)=>{
            const n = $785da19a645c07eb$var$Ya(e1, t);
            i = i.concat(Object.keys(n.icons).map((i)=>("" !== e1 ? "@" + e1 + ":" : "") + t + ":" + i));
        });
    }), i;
}
let $785da19a645c07eb$var$er = !1;
function $785da19a645c07eb$var$tr(e1) {
    return "boolean" == typeof e1 && ($785da19a645c07eb$var$er = e1), $785da19a645c07eb$var$er;
}
function $785da19a645c07eb$var$ir(e1) {
    const t = "string" == typeof e1 ? $785da19a645c07eb$var$Va(e1, !0, $785da19a645c07eb$var$er) : e1;
    if (t) {
        const e1 = $785da19a645c07eb$var$Ya(t.provider, t.prefix), i = t.name;
        return e1.icons[i] || (e1.missing.has(i) ? null : void 0);
    }
}
function $785da19a645c07eb$var$nr(e1, t) {
    const i = $785da19a645c07eb$var$Va(e1, !0, $785da19a645c07eb$var$er);
    if (!i) return !1;
    const n = $785da19a645c07eb$var$Ya(i.provider, i.prefix);
    return t ? function(e1, t, i) {
        try {
            if ("string" == typeof i.body) return e1.icons[t] = {
                ...i
            }, !0;
        } catch (e1) {}
        return !1;
    }(n, i.name, t) : (n.missing.add(i.name), !0);
}
function $785da19a645c07eb$var$ar(e1, t) {
    if ("object" != typeof e1) return !1;
    if ("string" != typeof t && (t = e1.provider || ""), $785da19a645c07eb$var$er && !t && !e1.prefix) {
        let t = !1;
        return $785da19a645c07eb$var$Xa(e1) && (e1.prefix = "", $785da19a645c07eb$var$Wa(e1, (e1, i)=>{
            $785da19a645c07eb$var$nr(e1, i) && (t = !0);
        })), t;
    }
    const i = e1.prefix;
    return !!$785da19a645c07eb$var$qa({
        prefix: i,
        name: "a"
    }) && !!$785da19a645c07eb$var$Ja($785da19a645c07eb$var$Ya(t, i), e1);
}
function $785da19a645c07eb$var$rr(e1) {
    return !!$785da19a645c07eb$var$ir(e1);
}
function $785da19a645c07eb$var$sr(e1) {
    const t = $785da19a645c07eb$var$ir(e1);
    return t ? {
        ...$785da19a645c07eb$var$za,
        ...t
    } : t;
}
function $785da19a645c07eb$var$or(e1, t) {
    e1.forEach((e1)=>{
        const i = e1.loaderCallbacks;
        i && (e1.loaderCallbacks = i.filter((e1)=>e1.id !== t));
    });
}
let $785da19a645c07eb$var$lr = 0;
const $785da19a645c07eb$var$cr = Object.create(null);
function $785da19a645c07eb$var$ur(e1, t) {
    $785da19a645c07eb$var$cr[e1] = t;
}
function $785da19a645c07eb$var$hr(e1) {
    return $785da19a645c07eb$var$cr[e1] || $785da19a645c07eb$var$cr[""];
}
function $785da19a645c07eb$var$dr(e1) {
    let t;
    if ("string" == typeof e1.resources) t = [
        e1.resources
    ];
    else if (t = e1.resources, !(t instanceof Array && t.length)) return null;
    return {
        resources: t,
        path: e1.path || "/",
        maxURL: e1.maxURL || 500,
        rotate: e1.rotate || 750,
        timeout: e1.timeout || 5e3,
        random: !0 === e1.random,
        index: e1.index || 0,
        dataAfterTimeout: !1 !== e1.dataAfterTimeout
    };
}
const $785da19a645c07eb$var$pr = Object.create(null), $785da19a645c07eb$var$mr = [
    "https://api.simplesvg.com",
    "https://api.unisvg.com"
], $785da19a645c07eb$var$gr = [];
for(; $785da19a645c07eb$var$mr.length > 0;)1 === $785da19a645c07eb$var$mr.length || Math.random() > .5 ? $785da19a645c07eb$var$gr.push($785da19a645c07eb$var$mr.shift()) : $785da19a645c07eb$var$gr.push($785da19a645c07eb$var$mr.pop());
function $785da19a645c07eb$var$fr(e1, t) {
    const i = $785da19a645c07eb$var$dr(t);
    return null !== i && ($785da19a645c07eb$var$pr[e1] = i, !0);
}
function $785da19a645c07eb$var$Ar(e1) {
    return $785da19a645c07eb$var$pr[e1];
}
function $785da19a645c07eb$var$_r() {
    return Object.keys($785da19a645c07eb$var$pr);
}
$785da19a645c07eb$var$pr[""] = $785da19a645c07eb$var$dr({
    resources: [
        "https://api.iconify.design"
    ].concat($785da19a645c07eb$var$gr)
});
const $785da19a645c07eb$var$vr = {
    resources: [],
    index: 0,
    timeout: 2e3,
    rotate: 750,
    random: !1,
    dataAfterTimeout: !1
};
function $785da19a645c07eb$var$yr(e1, t, i, n) {
    const a = e1.resources.length, r = e1.random ? Math.floor(Math.random() * a) : e1.index;
    let s;
    if (e1.random) {
        let t = e1.resources.slice(0);
        for(s = []; t.length > 1;){
            const e1 = Math.floor(Math.random() * t.length);
            s.push(t[e1]), t = t.slice(0, e1).concat(t.slice(e1 + 1));
        }
        s = s.concat(t);
    } else s = e1.resources.slice(r).concat(e1.resources.slice(0, r));
    const o = Date.now();
    let l, c = "pending", u = 0, h = null, d = [], p = [];
    function m() {
        h && (clearTimeout(h), h = null);
    }
    function g() {
        "pending" === c && (c = "aborted"), m(), d.forEach((e1)=>{
            "pending" === e1.status && (e1.status = "aborted");
        }), d = [];
    }
    function f(e1, t) {
        t && (p = []), "function" == typeof e1 && p.push(e1);
    }
    function A() {
        c = "failed", p.forEach((e1)=>{
            e1(void 0, l);
        });
    }
    function _() {
        d.forEach((e1)=>{
            "pending" === e1.status && (e1.status = "aborted");
        }), d = [];
    }
    function v() {
        if ("pending" !== c) return;
        m();
        const n = s.shift();
        if (void 0 === n) return d.length ? void (h = setTimeout(()=>{
            m(), "pending" === c && (_(), A());
        }, e1.timeout)) : void A();
        const a = {
            status: "pending",
            resource: n,
            callback: (t, i)=>{
                !function(t, i, n) {
                    const a = "success" !== i;
                    switch(d = d.filter((e1)=>e1 !== t), c){
                        case "pending":
                            break;
                        case "failed":
                            if (a || !e1.dataAfterTimeout) return;
                            break;
                        default:
                            return;
                    }
                    if ("abort" === i) return l = n, void A();
                    if (a) return l = n, void (d.length || (s.length ? v() : A()));
                    if (m(), _(), !e1.random) {
                        const i = e1.resources.indexOf(t.resource);
                        -1 !== i && i !== e1.index && (e1.index = i);
                    }
                    c = "completed", p.forEach((e1)=>{
                        e1(n);
                    });
                }(a, t, i);
            }
        };
        d.push(a), u++, h = setTimeout(v, e1.rotate), i(n, t, a.callback);
    }
    return "function" == typeof n && p.push(n), setTimeout(v), function() {
        return {
            startTime: o,
            payload: t,
            status: c,
            queriesSent: u,
            queriesPending: d.length,
            subscribe: f,
            abort: g
        };
    };
}
function $785da19a645c07eb$var$xr(e1) {
    const t = {
        ...$785da19a645c07eb$var$vr,
        ...e1
    };
    let i = [];
    function n() {
        i = i.filter((e1)=>"pending" === e1().status);
    }
    return {
        query: function(e1, a, r) {
            const s = $785da19a645c07eb$var$yr(t, e1, a, (e1, t)=>{
                n(), r && r(e1, t);
            });
            return i.push(s), s;
        },
        find: function(e1) {
            return i.find((t)=>e1(t)) || null;
        },
        setIndex: (e1)=>{
            t.index = e1;
        },
        getIndex: ()=>t.index,
        cleanup: n
    };
}
function $785da19a645c07eb$var$br() {}
const $785da19a645c07eb$var$wr = Object.create(null);
function $785da19a645c07eb$var$Er(e1, t, i) {
    let n, a;
    if ("string" == typeof e1) {
        const t = $785da19a645c07eb$var$hr(e1);
        if (!t) return i(void 0, 424), $785da19a645c07eb$var$br;
        a = t.send;
        const r = function(e1) {
            if (!$785da19a645c07eb$var$wr[e1]) {
                const t = $785da19a645c07eb$var$Ar(e1);
                if (!t) return;
                $785da19a645c07eb$var$wr[e1] = {
                    config: t,
                    redundancy: $785da19a645c07eb$var$xr(t)
                };
            }
            return $785da19a645c07eb$var$wr[e1];
        }(e1);
        r && (n = r.redundancy);
    } else {
        const t = $785da19a645c07eb$var$dr(e1);
        if (t) {
            n = $785da19a645c07eb$var$xr(t);
            const i = $785da19a645c07eb$var$hr(e1.resources ? e1.resources[0] : "");
            i && (a = i.send);
        }
    }
    return n && a ? n.query(t, a, i)().abort : (i(void 0, 424), $785da19a645c07eb$var$br);
}
function $785da19a645c07eb$var$kr() {}
function $785da19a645c07eb$var$Sr(e1) {
    e1.iconsLoaderFlag || (e1.iconsLoaderFlag = !0, setTimeout(()=>{
        e1.iconsLoaderFlag = !1, function(e1) {
            e1.pendingCallbacksFlag || (e1.pendingCallbacksFlag = !0, setTimeout(()=>{
                e1.pendingCallbacksFlag = !1;
                const t = e1.loaderCallbacks ? e1.loaderCallbacks.slice(0) : [];
                if (!t.length) return;
                let i = !1;
                const n = e1.provider, a = e1.prefix;
                t.forEach((t)=>{
                    const r = t.icons, s = r.pending.length;
                    r.pending = r.pending.filter((t)=>{
                        if (t.prefix !== a) return !0;
                        const s = t.name;
                        if (e1.icons[s]) r.loaded.push({
                            provider: n,
                            prefix: a,
                            name: s
                        });
                        else {
                            if (!e1.missing.has(s)) return i = !0, !0;
                            r.missing.push({
                                provider: n,
                                prefix: a,
                                name: s
                            });
                        }
                        return !1;
                    }), r.pending.length !== s && (i || $785da19a645c07eb$var$or([
                        e1
                    ], t.id), t.callback(r.loaded.slice(0), r.missing.slice(0), r.pending.slice(0), t.abort));
                });
            }));
        }(e1);
    }));
}
function $785da19a645c07eb$var$Mr(e1, t, i) {
    function n() {
        const i = e1.pendingIcons;
        t.forEach((t)=>{
            i && i.delete(t), e1.icons[t] || e1.missing.add(t);
        });
    }
    if (i && "object" == typeof i) try {
        if (!$785da19a645c07eb$var$Ja(e1, i).length) return void n();
    } catch (e1) {
        console.error(e1);
    }
    n(), $785da19a645c07eb$var$Sr(e1);
}
function $785da19a645c07eb$var$Cr(e1, t) {
    e1 instanceof Promise ? e1.then((e1)=>{
        t(e1);
    }).catch(()=>{
        t(null);
    }) : t(e1);
}
function $785da19a645c07eb$var$Tr(e1, t) {
    e1.iconsToLoad ? e1.iconsToLoad = e1.iconsToLoad.concat(t).sort() : e1.iconsToLoad = t, e1.iconsQueueFlag || (e1.iconsQueueFlag = !0, setTimeout(()=>{
        e1.iconsQueueFlag = !1;
        const { provider: t, prefix: i } = e1, n = e1.iconsToLoad;
        if (delete e1.iconsToLoad, !n || !n.length) return;
        const a = e1.loadIcon;
        if (e1.loadIcons && (n.length > 1 || !a)) return void $785da19a645c07eb$var$Cr(e1.loadIcons(n, i, t), (t)=>{
            $785da19a645c07eb$var$Mr(e1, n, t);
        });
        if (a) return void n.forEach((n)=>{
            $785da19a645c07eb$var$Cr(a(n, i, t), (t)=>{
                $785da19a645c07eb$var$Mr(e1, [
                    n
                ], t ? {
                    prefix: i,
                    icons: {
                        [n]: t
                    }
                } : null);
            });
        });
        const { valid: r, invalid: s } = function(e1) {
            const t = [], i = [];
            return e1.forEach((e1)=>{
                (e1.match($785da19a645c07eb$var$ja) ? t : i).push(e1);
            }), {
                valid: t,
                invalid: i
            };
        }(n);
        if (s.length && $785da19a645c07eb$var$Mr(e1, s, null), !r.length) return;
        const o = i.match($785da19a645c07eb$var$ja) ? $785da19a645c07eb$var$hr(t) : null;
        o ? o.prepare(t, i, r).forEach((i)=>{
            $785da19a645c07eb$var$Er(t, i, (t)=>{
                $785da19a645c07eb$var$Mr(e1, i.icons, t);
            });
        }) : $785da19a645c07eb$var$Mr(e1, r, null);
    }));
}
const $785da19a645c07eb$var$Dr = (e1, t)=>{
    const i = function(e1) {
        const t = {
            loaded: [],
            missing: [],
            pending: []
        }, i = Object.create(null);
        e1.sort((e1, t)=>e1.provider !== t.provider ? e1.provider.localeCompare(t.provider) : e1.prefix !== t.prefix ? e1.prefix.localeCompare(t.prefix) : e1.name.localeCompare(t.name));
        let n = {
            provider: "",
            prefix: "",
            name: ""
        };
        return e1.forEach((e1)=>{
            if (n.name === e1.name && n.prefix === e1.prefix && n.provider === e1.provider) return;
            n = e1;
            const a = e1.provider, r = e1.prefix, s = e1.name, o = i[a] || (i[a] = Object.create(null)), l = o[r] || (o[r] = $785da19a645c07eb$var$Ya(a, r));
            let c;
            c = s in l.icons ? t.loaded : "" === r || l.missing.has(s) ? t.missing : t.pending;
            const u = {
                provider: a,
                prefix: r,
                name: s
            };
            c.push(u);
        }), t;
    }(function(e1, t = !0, i = !1) {
        const n = [];
        return e1.forEach((e1)=>{
            const a = "string" == typeof e1 ? $785da19a645c07eb$var$Va(e1, t, i) : e1;
            a && n.push(a);
        }), n;
    }(e1, !0, $785da19a645c07eb$var$tr()));
    if (!i.pending.length) {
        let e1 = !0;
        return t && setTimeout(()=>{
            e1 && t(i.loaded, i.missing, i.pending, $785da19a645c07eb$var$kr);
        }), ()=>{
            e1 = !1;
        };
    }
    const n = Object.create(null), a = [];
    let r, s;
    return i.pending.forEach((e1)=>{
        const { provider: t, prefix: i } = e1;
        if (i === s && t === r) return;
        r = t, s = i, a.push($785da19a645c07eb$var$Ya(t, i));
        const o = n[t] || (n[t] = Object.create(null));
        o[i] || (o[i] = []);
    }), i.pending.forEach((e1)=>{
        const { provider: t, prefix: i, name: a } = e1, r = $785da19a645c07eb$var$Ya(t, i), s = r.pendingIcons || (r.pendingIcons = new Set);
        s.has(a) || (s.add(a), n[t][i].push(a));
    }), a.forEach((e1)=>{
        const t = n[e1.provider][e1.prefix];
        t.length && $785da19a645c07eb$var$Tr(e1, t);
    }), t ? function(e1, t, i) {
        const n = $785da19a645c07eb$var$lr++, a = $785da19a645c07eb$var$or.bind(null, i, n);
        if (!t.pending.length) return a;
        const r = {
            id: n,
            icons: t,
            callback: e1,
            abort: a
        };
        return i.forEach((e1)=>{
            (e1.loaderCallbacks || (e1.loaderCallbacks = [])).push(r);
        }), a;
    }(t, i, a) : $785da19a645c07eb$var$kr;
}, $785da19a645c07eb$var$Pr = (e1)=>new Promise((t, i)=>{
        const n = "string" == typeof e1 ? $785da19a645c07eb$var$Va(e1, !0) : e1;
        n ? $785da19a645c07eb$var$Dr([
            n || e1
        ], (a)=>{
            if (a.length && n) {
                const e1 = $785da19a645c07eb$var$ir(n);
                if (e1) return void t({
                    ...$785da19a645c07eb$var$za,
                    ...e1
                });
            }
            i(e1);
        }) : i(e1);
    });
function $785da19a645c07eb$var$Ir(e1) {
    try {
        const t = "string" == typeof e1 ? JSON.parse(e1) : e1;
        if ("string" == typeof t.body) return {
            ...t
        };
    } catch (e1) {}
}
let $785da19a645c07eb$var$Fr = !1;
try {
    $785da19a645c07eb$var$Fr = 0 === navigator.vendor.indexOf("Apple");
} catch (cB) {}
const $785da19a645c07eb$var$zr = /(-?[0-9.]*[0-9]+[0-9.]*)/g, $785da19a645c07eb$var$Rr = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function $785da19a645c07eb$var$Lr(e1, t, i) {
    if (1 === t) return e1;
    if (i = i || 100, "number" == typeof e1) return Math.ceil(e1 * t * i) / i;
    if ("string" != typeof e1) return e1;
    const n = e1.split($785da19a645c07eb$var$zr);
    if (null === n || !n.length) return e1;
    const a = [];
    let r = n.shift(), s = $785da19a645c07eb$var$Rr.test(r);
    for(;;){
        if (s) {
            const e1 = parseFloat(r);
            isNaN(e1) ? a.push(r) : a.push(Math.ceil(e1 * t * i) / i);
        } else a.push(r);
        if (r = n.shift(), void 0 === r) return a.join("");
        s = !s;
    }
}
function $785da19a645c07eb$var$Br(e1, t) {
    const i = {
        ...$785da19a645c07eb$var$za,
        ...e1
    }, n = {
        ...$785da19a645c07eb$var$Ba,
        ...t
    }, a = {
        left: i.left,
        top: i.top,
        width: i.width,
        height: i.height
    };
    let r = i.body;
    [
        i,
        n
    ].forEach((e1)=>{
        const t = [], i = e1.hFlip, n = e1.vFlip;
        let s, o = e1.rotate;
        switch(i ? n ? o += 2 : (t.push("translate(" + (a.width + a.left).toString() + " " + (0 - a.top).toString() + ")"), t.push("scale(-1 1)"), a.top = a.left = 0) : n && (t.push("translate(" + (0 - a.left).toString() + " " + (a.height + a.top).toString() + ")"), t.push("scale(1 -1)"), a.top = a.left = 0), o < 0 && (o -= 4 * Math.floor(o / 4)), o %= 4, o){
            case 1:
                s = a.height / 2 + a.top, t.unshift("rotate(90 " + s.toString() + " " + s.toString() + ")");
                break;
            case 2:
                t.unshift("rotate(180 " + (a.width / 2 + a.left).toString() + " " + (a.height / 2 + a.top).toString() + ")");
                break;
            case 3:
                s = a.width / 2 + a.left, t.unshift("rotate(-90 " + s.toString() + " " + s.toString() + ")");
        }
        o % 2 == 1 && (a.left !== a.top && (s = a.left, a.left = a.top, a.top = s), a.width !== a.height && (s = a.width, a.width = a.height, a.height = s)), t.length && (r = function(e1, t, i) {
            const n = function(e1, t = "defs") {
                let i = "";
                const n = e1.indexOf("<" + t);
                for(; n >= 0;){
                    const a = e1.indexOf(">", n), r = e1.indexOf("</" + t);
                    if (-1 === a || -1 === r) break;
                    const s = e1.indexOf(">", r);
                    if (-1 === s) break;
                    i += e1.slice(a + 1, r).trim(), e1 = e1.slice(0, n).trim() + e1.slice(s + 1);
                }
                return {
                    defs: i,
                    content: e1
                };
            }(e1);
            var a, r;
            return a = n.defs, r = t + n.content + i, a ? "<defs>" + a + "</defs>" + r : r;
        }(r, '<g transform="' + t.join(" ") + '">', "</g>"));
    });
    const s = n.width, o = n.height, l = a.width, c = a.height;
    let u, h;
    null === s ? (h = null === o ? "1em" : "auto" === o ? c : o, u = $785da19a645c07eb$var$Lr(h, l / c)) : (u = "auto" === s ? l : s, h = null === o ? $785da19a645c07eb$var$Lr(u, c / l) : "auto" === o ? c : o);
    const d = {}, p = (e1, t)=>{
        ((e1)=>"unset" === e1 || "undefined" === e1 || "none" === e1)(t) || (d[e1] = t.toString());
    };
    p("width", u), p("height", h);
    const m = [
        a.left,
        a.top,
        l,
        c
    ];
    return d.viewBox = m.join(" "), {
        attributes: d,
        viewBox: m,
        body: r
    };
}
function $785da19a645c07eb$var$Or(e1, t) {
    let i = -1 === e1.indexOf("xlink:") ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
    for(const e1 in t)i += " " + e1 + '="' + t[e1] + '"';
    return '<svg xmlns="http://www.w3.org/2000/svg"' + i + ">" + e1 + "</svg>";
}
function $785da19a645c07eb$var$Ur(e1) {
    return 'url("' + function(e1) {
        return "data:image/svg+xml," + function(e1) {
            return e1.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
        }(e1);
    }(e1) + '")';
}
let $785da19a645c07eb$var$Nr = (()=>{
    let e1;
    try {
        if (e1 = fetch, "function" == typeof e1) return e1;
    } catch (e1) {}
})();
function $785da19a645c07eb$var$jr(e1) {
    $785da19a645c07eb$var$Nr = e1;
}
function $785da19a645c07eb$var$Vr() {
    return $785da19a645c07eb$var$Nr;
}
const $785da19a645c07eb$var$qr = {
    prepare: (e1, t, i)=>{
        const n = [], a = function(e1, t) {
            const i = $785da19a645c07eb$var$Ar(e1);
            if (!i) return 0;
            let n;
            if (i.maxURL) {
                let e1 = 0;
                i.resources.forEach((t)=>{
                    const i = t;
                    e1 = Math.max(e1, i.length);
                });
                const a = t + ".json?icons=";
                n = i.maxURL - e1 - i.path.length - a.length;
            } else n = 0;
            return n;
        }(e1, t), r = "icons";
        let s = {
            type: r,
            provider: e1,
            prefix: t,
            icons: []
        }, o = 0;
        return i.forEach((i, l)=>{
            o += i.length + 1, o >= a && l > 0 && (n.push(s), s = {
                type: r,
                provider: e1,
                prefix: t,
                icons: []
            }, o = i.length), s.icons.push(i);
        }), n.push(s), n;
    },
    send: (e1, t, i)=>{
        if (!$785da19a645c07eb$var$Nr) return void i("abort", 424);
        let n = function(e1) {
            if ("string" == typeof e1) {
                const t = $785da19a645c07eb$var$Ar(e1);
                if (t) return t.path;
            }
            return "/";
        }(t.provider);
        switch(t.type){
            case "icons":
                {
                    const e1 = t.prefix, i = t.icons.join(",");
                    n += e1 + ".json?" + new URLSearchParams({
                        icons: i
                    }).toString();
                    break;
                }
            case "custom":
                {
                    const e1 = t.uri;
                    n += "/" === e1.slice(0, 1) ? e1.slice(1) : e1;
                    break;
                }
            default:
                return void i("abort", 400);
        }
        let a = 503;
        $785da19a645c07eb$var$Nr(e1 + n).then((e1)=>{
            const t = e1.status;
            if (200 === t) return a = 501, e1.json();
            setTimeout(()=>{
                i(function(e1) {
                    return 404 === e1;
                }(t) ? "abort" : "next", t);
            });
        }).then((e1)=>{
            "object" == typeof e1 && null !== e1 ? setTimeout(()=>{
                i("success", e1);
            }) : setTimeout(()=>{
                404 === e1 ? i("abort", e1) : i("next", a);
            });
        }).catch(()=>{
            i("next", a);
        });
    }
};
function $785da19a645c07eb$var$Gr(e1, t, i) {
    $785da19a645c07eb$var$Ya(i || "", t).loadIcons = e1;
}
function $785da19a645c07eb$var$Hr(e1, t, i) {
    $785da19a645c07eb$var$Ya(i || "", t).loadIcon = e1;
}
const $785da19a645c07eb$var$Wr = "data-style";
let $785da19a645c07eb$var$Zr = "";
function $785da19a645c07eb$var$Kr(e1) {
    $785da19a645c07eb$var$Zr = e1;
}
function $785da19a645c07eb$var$Xr(e1, t) {
    let i = Array.from(e1.childNodes).find((e1)=>e1.hasAttribute && e1.hasAttribute($785da19a645c07eb$var$Wr));
    i || (i = document.createElement("style"), i.setAttribute($785da19a645c07eb$var$Wr, $785da19a645c07eb$var$Wr), e1.appendChild(i)), i.textContent = ":host{display:inline-block;vertical-align:" + (t ? "-0.125em" : "0") + "}span,svg{display:block;margin:auto}" + $785da19a645c07eb$var$Zr;
}
function $785da19a645c07eb$var$Qr() {
    let e1;
    $785da19a645c07eb$var$ur("", $785da19a645c07eb$var$qr), $785da19a645c07eb$var$tr(!0);
    try {
        e1 = window;
    } catch (e1) {}
    if (e1) {
        if (void 0 !== e1.IconifyPreload) {
            const t = e1.IconifyPreload, i = "Invalid IconifyPreload syntax.";
            "object" == typeof t && null !== t && (t instanceof Array ? t : [
                t
            ]).forEach((e1)=>{
                try {
                    ("object" != typeof e1 || null === e1 || e1 instanceof Array || "object" != typeof e1.icons || "string" != typeof e1.prefix || !$785da19a645c07eb$var$ar(e1)) && console.error(i);
                } catch (e1) {
                    console.error(i);
                }
            });
        }
        if (void 0 !== e1.IconifyProviders) {
            const t = e1.IconifyProviders;
            if ("object" == typeof t && null !== t) for(const e1 in t){
                const i = "IconifyProviders[" + e1 + "] is invalid.";
                try {
                    const n = t[e1];
                    if ("object" != typeof n || !n || void 0 === n.resources) continue;
                    $785da19a645c07eb$var$fr(e1, n) || console.error(i);
                } catch (e1) {
                    console.error(i);
                }
            }
        }
    }
    return {
        iconLoaded: $785da19a645c07eb$var$rr,
        getIcon: $785da19a645c07eb$var$sr,
        listIcons: $785da19a645c07eb$var$$a,
        addIcon: $785da19a645c07eb$var$nr,
        addCollection: $785da19a645c07eb$var$ar,
        calculateSize: $785da19a645c07eb$var$Lr,
        buildIcon: $785da19a645c07eb$var$Br,
        iconToHTML: $785da19a645c07eb$var$Or,
        svgToURL: $785da19a645c07eb$var$Ur,
        loadIcons: $785da19a645c07eb$var$Dr,
        loadIcon: $785da19a645c07eb$var$Pr,
        addAPIProvider: $785da19a645c07eb$var$fr,
        setCustomIconLoader: $785da19a645c07eb$var$Hr,
        setCustomIconsLoader: $785da19a645c07eb$var$Gr,
        appendCustomStyle: $785da19a645c07eb$var$Kr,
        _api: {
            getAPIConfig: $785da19a645c07eb$var$Ar,
            setAPIModule: $785da19a645c07eb$var$ur,
            sendAPIQuery: $785da19a645c07eb$var$Er,
            setFetch: $785da19a645c07eb$var$jr,
            getFetch: $785da19a645c07eb$var$Vr,
            listAPIProviders: $785da19a645c07eb$var$_r
        }
    };
}
const $785da19a645c07eb$var$Yr = {
    "background-color": "currentColor"
}, $785da19a645c07eb$var$Jr = {
    "background-color": "transparent"
}, $785da19a645c07eb$var$$r = {
    image: "var(--svg)",
    repeat: "no-repeat",
    size: "100% 100%"
}, $785da19a645c07eb$var$es = {
    "-webkit-mask": $785da19a645c07eb$var$Yr,
    mask: $785da19a645c07eb$var$Yr,
    background: $785da19a645c07eb$var$Jr
};
for(const e1 in $785da19a645c07eb$var$es){
    const t = $785da19a645c07eb$var$es[e1];
    for(const i in $785da19a645c07eb$var$$r)t[e1 + "-" + i] = $785da19a645c07eb$var$$r[i];
}
function $785da19a645c07eb$var$ts(e1) {
    return e1 ? e1 + (e1.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
}
let $785da19a645c07eb$var$is;
function $785da19a645c07eb$var$ns(e1) {
    return void 0 === $785da19a645c07eb$var$is && function() {
        try {
            $785da19a645c07eb$var$is = window.trustedTypes.createPolicy("iconify", {
                createHTML: (e1)=>e1
            });
        } catch (e1) {
            $785da19a645c07eb$var$is = null;
        }
    }(), $785da19a645c07eb$var$is ? $785da19a645c07eb$var$is.createHTML(e1) : e1;
}
function $785da19a645c07eb$var$as(e1) {
    return Array.from(e1.childNodes).find((e1)=>{
        const t = e1.tagName && e1.tagName.toUpperCase();
        return "SPAN" === t || "SVG" === t;
    });
}
function $785da19a645c07eb$var$rs(e1, t) {
    const i = t.icon.data, n = t.customisations, a = $785da19a645c07eb$var$Br(i, n);
    n.preserveAspectRatio && (a.attributes.preserveAspectRatio = n.preserveAspectRatio);
    const r = t.renderedMode;
    let s;
    if ("svg" === r) s = function(e1) {
        const t = document.createElement("span"), i = e1.attributes;
        let n = "";
        i.width || (n = "width: inherit;"), i.height || (n += "height: inherit;"), n && (i.style = n);
        const a = $785da19a645c07eb$var$Or(e1.body, i);
        return t.innerHTML = $785da19a645c07eb$var$ns(a), t.firstChild;
    }(a);
    else s = function(e1, t, i) {
        const n = document.createElement("span");
        let a = e1.body;
        -1 !== a.indexOf("<a") && (a += "\x3c!-- " + Date.now() + " --\x3e");
        const r = e1.attributes, s = $785da19a645c07eb$var$Ur($785da19a645c07eb$var$Or(a, {
            ...r,
            width: t.width + "",
            height: t.height + ""
        })), o = n.style, l = {
            "--svg": s,
            width: $785da19a645c07eb$var$ts(r.width),
            height: $785da19a645c07eb$var$ts(r.height),
            ...i ? $785da19a645c07eb$var$Yr : $785da19a645c07eb$var$Jr
        };
        for(const e1 in l)o.setProperty(e1, l[e1]);
        return n;
    }(a, {
        ...$785da19a645c07eb$var$za,
        ...i
    }, "mask" === r);
    const o = $785da19a645c07eb$var$as(e1);
    o ? "SPAN" === s.tagName && o.tagName === s.tagName ? o.setAttribute("style", s.getAttribute("style")) : e1.replaceChild(s, o) : e1.appendChild(s);
}
function $785da19a645c07eb$var$ss(e1, t, i) {
    return {
        rendered: !1,
        inline: t,
        icon: e1,
        lastRender: i && (i.rendered ? i : i.lastRender)
    };
}
const $785da19a645c07eb$var$os = function(e1 = "iconify-icon") {
    let t, i;
    try {
        t = window.customElements, i = window.HTMLElement;
    } catch (e1) {
        return;
    }
    if (!t || !i) return;
    const n = t.get(e1);
    if (n) return n;
    const a = [
        "icon",
        "mode",
        "inline",
        "noobserver",
        "width",
        "height",
        "rotate",
        "flip"
    ], r = class extends i {
        _shadowRoot;
        _initialised = !1;
        _state;
        _checkQueued = !1;
        _connected = !1;
        _observer = null;
        _visible = !0;
        constructor(){
            super();
            const e1 = this._shadowRoot = this.attachShadow({
                mode: "open"
            }), t = this.hasAttribute("inline");
            $785da19a645c07eb$var$Xr(e1, t), this._state = $785da19a645c07eb$var$ss({
                value: ""
            }, t), this._queueCheck();
        }
        connectedCallback() {
            this._connected = !0, this.startObserver();
        }
        disconnectedCallback() {
            this._connected = !1, this.stopObserver();
        }
        static get observedAttributes() {
            return a.slice(0);
        }
        attributeChangedCallback(e1) {
            switch(e1){
                case "inline":
                    {
                        const e1 = this.hasAttribute("inline"), t = this._state;
                        e1 !== t.inline && (t.inline = e1, $785da19a645c07eb$var$Xr(this._shadowRoot, e1));
                        break;
                    }
                case "noobserver":
                    this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
                    break;
                default:
                    this._queueCheck();
            }
        }
        get icon() {
            const e1 = this.getAttribute("icon");
            if (e1 && "{" === e1.slice(0, 1)) try {
                return JSON.parse(e1);
            } catch (e1) {}
            return e1;
        }
        set icon(e1) {
            "object" == typeof e1 && (e1 = JSON.stringify(e1)), this.setAttribute("icon", e1);
        }
        get inline() {
            return this.hasAttribute("inline");
        }
        set inline(e1) {
            e1 ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
        }
        get observer() {
            return this.hasAttribute("observer");
        }
        set observer(e1) {
            e1 ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
        }
        restartAnimation() {
            const e1 = this._state;
            if (e1.rendered) {
                const t = this._shadowRoot;
                if ("svg" === e1.renderedMode) try {
                    return void t.lastChild.setCurrentTime(0);
                } catch (e1) {}
                $785da19a645c07eb$var$rs(t, e1);
            }
        }
        get status() {
            const e1 = this._state;
            return e1.rendered ? "rendered" : null === e1.icon.data ? "failed" : "loading";
        }
        _queueCheck() {
            this._checkQueued || (this._checkQueued = !0, setTimeout(()=>{
                this._check();
            }));
        }
        _check() {
            if (!this._checkQueued) return;
            this._checkQueued = !1;
            const e1 = this._state, t = this.getAttribute("icon");
            if (t !== e1.icon.value) return void this._iconChanged(t);
            if (!e1.rendered || !this._visible) return;
            const i = this.getAttribute("mode"), n = $785da19a645c07eb$var$Na(this);
            e1.attrMode === i && !function(e1, t) {
                for(const i in $785da19a645c07eb$var$Ua)if (e1[i] !== t[i]) return !0;
                return !1;
            }(e1.customisations, n) && $785da19a645c07eb$var$as(this._shadowRoot) || this._renderIcon(e1.icon, n, i);
        }
        _iconChanged(e1) {
            const t = function(e1, t) {
                if ("object" == typeof e1) return {
                    data: $785da19a645c07eb$var$Ir(e1),
                    value: e1
                };
                if ("string" != typeof e1) return {
                    value: e1
                };
                if (e1.includes("{")) {
                    const t = $785da19a645c07eb$var$Ir(e1);
                    if (t) return {
                        data: t,
                        value: e1
                    };
                }
                const i = $785da19a645c07eb$var$Va(e1, !0, !0);
                if (!i) return {
                    value: e1
                };
                const n = $785da19a645c07eb$var$ir(i);
                if (void 0 !== n || !i.prefix) return {
                    value: e1,
                    name: i,
                    data: n
                };
                const a = $785da19a645c07eb$var$Dr([
                    i
                ], ()=>t(e1, i, $785da19a645c07eb$var$ir(i)));
                return {
                    value: e1,
                    name: i,
                    loading: a
                };
            }(e1, (e1, t, i)=>{
                const n = this._state;
                if (n.rendered || this.getAttribute("icon") !== e1) return;
                const a = {
                    value: e1,
                    name: t,
                    data: i
                };
                a.data ? this._gotIconData(a) : n.icon = a;
            });
            t.data ? this._gotIconData(t) : this._state = $785da19a645c07eb$var$ss(t, this._state.inline, this._state);
        }
        _forceRender() {
            if (!this._visible) {
                const e1 = $785da19a645c07eb$var$as(this._shadowRoot);
                return void (e1 && this._shadowRoot.removeChild(e1));
            }
            this._queueCheck();
        }
        _gotIconData(e1) {
            this._checkQueued = !1, this._renderIcon(e1, $785da19a645c07eb$var$Na(this), this.getAttribute("mode"));
        }
        _renderIcon(e1, t, i) {
            const n = function(e1, t) {
                switch(t){
                    case "svg":
                    case "bg":
                    case "mask":
                        return t;
                }
                return "style" === t || !$785da19a645c07eb$var$Fr && -1 !== e1.indexOf("<a") ? -1 === e1.indexOf("currentColor") ? "bg" : "mask" : "svg";
            }(e1.data.body, i), a = this._state.inline;
            $785da19a645c07eb$var$rs(this._shadowRoot, this._state = {
                rendered: !0,
                icon: e1,
                inline: a,
                customisations: t,
                attrMode: i,
                renderedMode: n
            });
        }
        startObserver() {
            if (!this._observer && !this.hasAttribute("noobserver")) try {
                this._observer = new IntersectionObserver((e1)=>{
                    const t = e1.some((e1)=>e1.isIntersecting);
                    t !== this._visible && (this._visible = t, this._forceRender());
                }), this._observer.observe(this);
            } catch (e1) {
                if (this._observer) {
                    try {
                        this._observer.disconnect();
                    } catch (e1) {}
                    this._observer = null;
                }
            }
        }
        stopObserver() {
            this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
        }
    };
    a.forEach((e1)=>{
        e1 in r.prototype || Object.defineProperty(r.prototype, e1, {
            get: function() {
                return this.getAttribute(e1);
            },
            set: function(t) {
                null !== t ? this.setAttribute(e1, t) : this.removeAttribute(e1);
            }
        });
    });
    const s = $785da19a645c07eb$var$Qr();
    for(const e1 in s)r[e1] = r.prototype[e1] = s[e1];
    return t.define(e1, r), r;
}() || $785da19a645c07eb$var$Qr(), { iconLoaded: $785da19a645c07eb$var$ls, getIcon: $785da19a645c07eb$var$cs, listIcons: $785da19a645c07eb$var$us, addIcon: $785da19a645c07eb$var$hs, addCollection: $785da19a645c07eb$var$ds, calculateSize: $785da19a645c07eb$var$ps, buildIcon: $785da19a645c07eb$var$ms, iconToHTML: $785da19a645c07eb$var$gs, svgToURL: $785da19a645c07eb$var$fs, loadIcons: $785da19a645c07eb$var$As, loadIcon: $785da19a645c07eb$var$_s, setCustomIconLoader: $785da19a645c07eb$var$vs, setCustomIconsLoader: $785da19a645c07eb$var$ys, addAPIProvider: $785da19a645c07eb$var$xs, _api: $785da19a645c07eb$var$bs } = $785da19a645c07eb$var$os;
function $785da19a645c07eb$var$ws(e1, t) {
    return $785da19a645c07eb$var$Pa(e1, t).node[0];
}
function $785da19a645c07eb$var$Es() {
    $785da19a645c07eb$var$vs(async (e1)=>{
        const t = await fetch($785da19a645c07eb$var$ge(e1));
        return t.ok ? {
            body: await t.text()
        } : null;
    }, "temaki");
}
function $785da19a645c07eb$var$ks(e1, t = {}) {
    const i = document.createElement(e1);
    return Object.entries(t).forEach(([e1, t])=>{
        e1.startsWith("_") ? i[e1] = t : e1.startsWith("fn") ? i[e1.substring(2)] = t : e1.startsWith("on") ? i.addEventListener(e1.substring(2), t) : t && i.setAttribute(e1, t);
    }), i;
}
function $785da19a645c07eb$var$Ss(e1, t) {
    e1._parent?.addEventListener("menu-opened", (i)=>{
        i.detail.menu !== e1 && t();
    }), e1._parent?.onceMapReady?.().then(()=>{
        e1._parent.map?.on?.("click", ()=>t());
    }), e1._parent?.oncePSVReady?.().then(()=>{
        e1._parent.psv.addEventListener("click", ()=>t());
    }), e1._parent?.onceReady?.().then(()=>{
        e1._parent.legend?.addEventListener("click", ()=>t());
    });
}
function $785da19a645c07eb$var$Ms(e1) {
    return e1._parent ? e1._parent : e1 === document.body ? null : e1.parentNode ? $785da19a645c07eb$var$Ms(e1.parentNode) : e1.host ? $785da19a645c07eb$var$Ms(e1.host) : void 0;
}
function $785da19a645c07eb$var$Cs(e1) {
    return e1._parent ? Promise.resolve(e1._parent) : new Promise((t)=>{
        const i = setInterval(()=>{
            const n = $785da19a645c07eb$var$Ms(e1);
            n && (e1._parent = n, clearInterval(i), t(e1._parent));
        }, 100);
    });
}
var $785da19a645c07eb$var$Ts = Object.freeze({
    __proto__: null,
    createWebComp: $785da19a645c07eb$var$ks,
    fa: $785da19a645c07eb$var$ws,
    listenForMenuClosure: $785da19a645c07eb$var$Ss,
    moreIcons: $785da19a645c07eb$var$Es,
    onceParentAvailable: $785da19a645c07eb$var$Cs
}), $785da19a645c07eb$var$Ds = {
    Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
    ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
    ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
}, $785da19a645c07eb$var$Ps = {
    isSpaceSeparator: (e1)=>"string" == typeof e1 && $785da19a645c07eb$var$Ds.Space_Separator.test(e1),
    isIdStartChar: (e1)=>"string" == typeof e1 && (e1 >= "a" && e1 <= "z" || e1 >= "A" && e1 <= "Z" || "$" === e1 || "_" === e1 || $785da19a645c07eb$var$Ds.ID_Start.test(e1)),
    isIdContinueChar: (e1)=>"string" == typeof e1 && (e1 >= "a" && e1 <= "z" || e1 >= "A" && e1 <= "Z" || e1 >= "0" && e1 <= "9" || "$" === e1 || "_" === e1 || "\u200C" === e1 || "\u200D" === e1 || $785da19a645c07eb$var$Ds.ID_Continue.test(e1)),
    isDigit: (e1)=>"string" == typeof e1 && /[0-9]/.test(e1),
    isHexDigit: (e1)=>"string" == typeof e1 && /[0-9A-Fa-f]/.test(e1)
};
let $785da19a645c07eb$var$Is, $785da19a645c07eb$var$Fs, $785da19a645c07eb$var$zs, $785da19a645c07eb$var$Rs, $785da19a645c07eb$var$Ls, $785da19a645c07eb$var$Bs, $785da19a645c07eb$var$Os, $785da19a645c07eb$var$Us, $785da19a645c07eb$var$Ns;
function $785da19a645c07eb$var$js(e1, t, i) {
    const n = e1[t];
    if (null != n && "object" == typeof n) {
        if (Array.isArray(n)) for(let e1 = 0; e1 < n.length; e1++){
            const t = String(e1), a = $785da19a645c07eb$var$js(n, t, i);
            void 0 === a ? delete n[t] : Object.defineProperty(n, t, {
                value: a,
                writable: !0,
                enumerable: !0,
                configurable: !0
            });
        }
        else for(const e1 in n){
            const t = $785da19a645c07eb$var$js(n, e1, i);
            void 0 === t ? delete n[e1] : Object.defineProperty(n, e1, {
                value: t,
                writable: !0,
                enumerable: !0,
                configurable: !0
            });
        }
    }
    return i.call(e1, t, n);
}
let $785da19a645c07eb$var$Vs, $785da19a645c07eb$var$qs, $785da19a645c07eb$var$Gs, $785da19a645c07eb$var$Hs, $785da19a645c07eb$var$Ws;
function $785da19a645c07eb$var$Zs() {
    for($785da19a645c07eb$var$Vs = "default", $785da19a645c07eb$var$qs = "", $785da19a645c07eb$var$Gs = !1, $785da19a645c07eb$var$Hs = 1;;){
        $785da19a645c07eb$var$Ws = $785da19a645c07eb$var$Ks();
        const e1 = $785da19a645c07eb$var$Qs[$785da19a645c07eb$var$Vs]();
        if (e1) return e1;
    }
}
function $785da19a645c07eb$var$Ks() {
    if ($785da19a645c07eb$var$Is[$785da19a645c07eb$var$Rs]) return String.fromCodePoint($785da19a645c07eb$var$Is.codePointAt($785da19a645c07eb$var$Rs));
}
function $785da19a645c07eb$var$Xs() {
    const e1 = $785da19a645c07eb$var$Ks();
    return "\n" === e1 ? ($785da19a645c07eb$var$Ls++, $785da19a645c07eb$var$Bs = 0) : e1 ? $785da19a645c07eb$var$Bs += e1.length : $785da19a645c07eb$var$Bs++, e1 && ($785da19a645c07eb$var$Rs += e1.length), e1;
}
const $785da19a645c07eb$var$Qs = {
    default () {
        switch($785da19a645c07eb$var$Ws){
            case "\t":
            case "\v":
            case "\f":
            case " ":
            case "\xa0":
            case "\ufeff":
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return void $785da19a645c07eb$var$Xs();
            case "/":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "comment");
            case void 0:
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Ys("eof");
        }
        if (!$785da19a645c07eb$var$Ps.isSpaceSeparator($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Qs[$785da19a645c07eb$var$Fs]();
        $785da19a645c07eb$var$Xs();
    },
    comment () {
        switch($785da19a645c07eb$var$Ws){
            case "*":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "multiLineComment");
            case "/":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "singleLineComment");
        }
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    multiLineComment () {
        switch($785da19a645c07eb$var$Ws){
            case "*":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "multiLineCommentAsterisk");
            case void 0:
                throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        }
        $785da19a645c07eb$var$Xs();
    },
    multiLineCommentAsterisk () {
        switch($785da19a645c07eb$var$Ws){
            case "*":
                return void $785da19a645c07eb$var$Xs();
            case "/":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "default");
            case void 0:
                throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        }
        $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Vs = "multiLineComment";
    },
    singleLineComment () {
        switch($785da19a645c07eb$var$Ws){
            case "\n":
            case "\r":
            case "\u2028":
            case "\u2029":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "default");
            case void 0:
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Ys("eof");
        }
        $785da19a645c07eb$var$Xs();
    },
    value () {
        switch($785da19a645c07eb$var$Ws){
            case "{":
            case "[":
                return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
            case "n":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("ull"), $785da19a645c07eb$var$Ys("null", null);
            case "t":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("rue"), $785da19a645c07eb$var$Ys("boolean", !0);
            case "f":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("alse"), $785da19a645c07eb$var$Ys("boolean", !1);
            case "-":
            case "+":
                return "-" === $785da19a645c07eb$var$Xs() && ($785da19a645c07eb$var$Hs = -1), void ($785da19a645c07eb$var$Vs = "sign");
            case ".":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalPointLeading");
            case "0":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "zero");
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalInteger");
            case "I":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("nfinity"), $785da19a645c07eb$var$Ys("numeric", 1 / 0);
            case "N":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("aN"), $785da19a645c07eb$var$Ys("numeric", NaN);
            case '"':
            case "'":
                return $785da19a645c07eb$var$Gs = '"' === $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$qs = "", void ($785da19a645c07eb$var$Vs = "string");
        }
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    identifierNameStartEscape () {
        if ("u" !== $785da19a645c07eb$var$Ws) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        $785da19a645c07eb$var$Xs();
        const e1 = $785da19a645c07eb$var$$s();
        switch(e1){
            case "$":
            case "_":
                break;
            default:
                if (!$785da19a645c07eb$var$Ps.isIdStartChar(e1)) throw $785da19a645c07eb$var$ro();
        }
        $785da19a645c07eb$var$qs += e1, $785da19a645c07eb$var$Vs = "identifierName";
    },
    identifierName () {
        switch($785da19a645c07eb$var$Ws){
            case "$":
            case "_":
            case "\u200C":
            case "\u200D":
                return void ($785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs());
            case "\\":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "identifierNameEscape");
        }
        if (!$785da19a645c07eb$var$Ps.isIdContinueChar($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Ys("identifier", $785da19a645c07eb$var$qs);
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    identifierNameEscape () {
        if ("u" !== $785da19a645c07eb$var$Ws) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        $785da19a645c07eb$var$Xs();
        const e1 = $785da19a645c07eb$var$$s();
        switch(e1){
            case "$":
            case "_":
            case "\u200C":
            case "\u200D":
                break;
            default:
                if (!$785da19a645c07eb$var$Ps.isIdContinueChar(e1)) throw $785da19a645c07eb$var$ro();
        }
        $785da19a645c07eb$var$qs += e1, $785da19a645c07eb$var$Vs = "identifierName";
    },
    sign () {
        switch($785da19a645c07eb$var$Ws){
            case ".":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalPointLeading");
            case "0":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "zero");
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalInteger");
            case "I":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("nfinity"), $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * (1 / 0));
            case "N":
                return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Js("aN"), $785da19a645c07eb$var$Ys("numeric", NaN);
        }
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    zero () {
        switch($785da19a645c07eb$var$Ws){
            case ".":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalPoint");
            case "e":
            case "E":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponent");
            case "x":
            case "X":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "hexadecimal");
        }
        return $785da19a645c07eb$var$Ys("numeric", 0 * $785da19a645c07eb$var$Hs);
    },
    decimalInteger () {
        switch($785da19a645c07eb$var$Ws){
            case ".":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalPoint");
            case "e":
            case "E":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponent");
        }
        if (!$785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * Number($785da19a645c07eb$var$qs));
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    decimalPointLeading () {
        if ($785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalFraction");
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    decimalPoint () {
        switch($785da19a645c07eb$var$Ws){
            case "e":
            case "E":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponent");
        }
        return $785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws) ? ($785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalFraction")) : $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * Number($785da19a645c07eb$var$qs));
    },
    decimalFraction () {
        switch($785da19a645c07eb$var$Ws){
            case "e":
            case "E":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponent");
        }
        if (!$785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * Number($785da19a645c07eb$var$qs));
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    decimalExponent () {
        switch($785da19a645c07eb$var$Ws){
            case "+":
            case "-":
                return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponentSign");
        }
        if ($785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponentInteger");
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    decimalExponentSign () {
        if ($785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "decimalExponentInteger");
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    decimalExponentInteger () {
        if (!$785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * Number($785da19a645c07eb$var$qs));
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    hexadecimal () {
        if ($785da19a645c07eb$var$Ps.isHexDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "hexadecimalInteger");
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    hexadecimalInteger () {
        if (!$785da19a645c07eb$var$Ps.isHexDigit($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$Ys("numeric", $785da19a645c07eb$var$Hs * Number($785da19a645c07eb$var$qs));
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    string () {
        switch($785da19a645c07eb$var$Ws){
            case "\\":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$qs += function() {
                    switch($785da19a645c07eb$var$Ks()){
                        case "b":
                            return $785da19a645c07eb$var$Xs(), "\b";
                        case "f":
                            return $785da19a645c07eb$var$Xs(), "\f";
                        case "n":
                            return $785da19a645c07eb$var$Xs(), "\n";
                        case "r":
                            return $785da19a645c07eb$var$Xs(), "\r";
                        case "t":
                            return $785da19a645c07eb$var$Xs(), "\t";
                        case "v":
                            return $785da19a645c07eb$var$Xs(), "\v";
                        case "0":
                            if ($785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Ps.isDigit($785da19a645c07eb$var$Ks())) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
                            return "\0";
                        case "x":
                            return $785da19a645c07eb$var$Xs(), function() {
                                let e1 = "", t = $785da19a645c07eb$var$Ks();
                                if (!$785da19a645c07eb$var$Ps.isHexDigit(t)) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
                                if (e1 += $785da19a645c07eb$var$Xs(), t = $785da19a645c07eb$var$Ks(), !$785da19a645c07eb$var$Ps.isHexDigit(t)) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
                                return e1 += $785da19a645c07eb$var$Xs(), String.fromCodePoint(parseInt(e1, 16));
                            }();
                        case "u":
                            return $785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$$s();
                        case "\n":
                        case "\u2028":
                        case "\u2029":
                            return $785da19a645c07eb$var$Xs(), "";
                        case "\r":
                            return $785da19a645c07eb$var$Xs(), "\n" === $785da19a645c07eb$var$Ks() && $785da19a645c07eb$var$Xs(), "";
                        case "1":
                        case "2":
                        case "3":
                        case "4":
                        case "5":
                        case "6":
                        case "7":
                        case "8":
                        case "9":
                        case void 0:
                            throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
                    }
                    return $785da19a645c07eb$var$Xs();
                }());
            case '"':
                return $785da19a645c07eb$var$Gs ? ($785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Ys("string", $785da19a645c07eb$var$qs)) : void ($785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs());
            case "'":
                return $785da19a645c07eb$var$Gs ? void ($785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs()) : ($785da19a645c07eb$var$Xs(), $785da19a645c07eb$var$Ys("string", $785da19a645c07eb$var$qs));
            case "\n":
            case "\r":
                throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
            case "\u2028":
            case "\u2029":
                !function(e1) {
                    console.warn(`JSON5: '${$785da19a645c07eb$var$so(e1)}' in strings is not valid ECMAScript; consider escaping`);
                }($785da19a645c07eb$var$Ws);
                break;
            case void 0:
                throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        }
        $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs();
    },
    start () {
        switch($785da19a645c07eb$var$Ws){
            case "{":
            case "[":
                return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
        }
        $785da19a645c07eb$var$Vs = "value";
    },
    beforePropertyName () {
        switch($785da19a645c07eb$var$Ws){
            case "$":
            case "_":
                return $785da19a645c07eb$var$qs = $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "identifierName");
            case "\\":
                return $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "identifierNameStartEscape");
            case "}":
                return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
            case '"':
            case "'":
                return $785da19a645c07eb$var$Gs = '"' === $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "string");
        }
        if ($785da19a645c07eb$var$Ps.isIdStartChar($785da19a645c07eb$var$Ws)) return $785da19a645c07eb$var$qs += $785da19a645c07eb$var$Xs(), void ($785da19a645c07eb$var$Vs = "identifierName");
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    afterPropertyName () {
        if (":" === $785da19a645c07eb$var$Ws) return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    beforePropertyValue () {
        $785da19a645c07eb$var$Vs = "value";
    },
    afterPropertyValue () {
        switch($785da19a645c07eb$var$Ws){
            case ",":
            case "}":
                return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
        }
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    beforeArrayValue () {
        if ("]" === $785da19a645c07eb$var$Ws) return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
        $785da19a645c07eb$var$Vs = "value";
    },
    afterArrayValue () {
        switch($785da19a645c07eb$var$Ws){
            case ",":
            case "]":
                return $785da19a645c07eb$var$Ys("punctuator", $785da19a645c07eb$var$Xs());
        }
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    },
    end () {
        throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
    }
};
function $785da19a645c07eb$var$Ys(e1, t) {
    return {
        type: e1,
        value: t,
        line: $785da19a645c07eb$var$Ls,
        column: $785da19a645c07eb$var$Bs
    };
}
function $785da19a645c07eb$var$Js(e1) {
    for (const t of e1){
        if ($785da19a645c07eb$var$Ks() !== t) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        $785da19a645c07eb$var$Xs();
    }
}
function $785da19a645c07eb$var$$s() {
    let e1 = "", t = 4;
    for(; t-- > 0;){
        const t = $785da19a645c07eb$var$Ks();
        if (!$785da19a645c07eb$var$Ps.isHexDigit(t)) throw $785da19a645c07eb$var$no($785da19a645c07eb$var$Xs());
        e1 += $785da19a645c07eb$var$Xs();
    }
    return String.fromCodePoint(parseInt(e1, 16));
}
const $785da19a645c07eb$var$eo = {
    start () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        $785da19a645c07eb$var$to();
    },
    beforePropertyName () {
        switch($785da19a645c07eb$var$Os.type){
            case "identifier":
            case "string":
                return $785da19a645c07eb$var$Us = $785da19a645c07eb$var$Os.value, void ($785da19a645c07eb$var$Fs = "afterPropertyName");
            case "punctuator":
                return void $785da19a645c07eb$var$io();
            case "eof":
                throw $785da19a645c07eb$var$ao();
        }
    },
    afterPropertyName () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        $785da19a645c07eb$var$Fs = "beforePropertyValue";
    },
    beforePropertyValue () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        $785da19a645c07eb$var$to();
    },
    beforeArrayValue () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        "punctuator" !== $785da19a645c07eb$var$Os.type || "]" !== $785da19a645c07eb$var$Os.value ? $785da19a645c07eb$var$to() : $785da19a645c07eb$var$io();
    },
    afterPropertyValue () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        switch($785da19a645c07eb$var$Os.value){
            case ",":
                return void ($785da19a645c07eb$var$Fs = "beforePropertyName");
            case "}":
                $785da19a645c07eb$var$io();
        }
    },
    afterArrayValue () {
        if ("eof" === $785da19a645c07eb$var$Os.type) throw $785da19a645c07eb$var$ao();
        switch($785da19a645c07eb$var$Os.value){
            case ",":
                return void ($785da19a645c07eb$var$Fs = "beforeArrayValue");
            case "]":
                $785da19a645c07eb$var$io();
        }
    },
    end () {}
};
function $785da19a645c07eb$var$to() {
    let e1;
    switch($785da19a645c07eb$var$Os.type){
        case "punctuator":
            switch($785da19a645c07eb$var$Os.value){
                case "{":
                    e1 = {};
                    break;
                case "[":
                    e1 = [];
            }
            break;
        case "null":
        case "boolean":
        case "numeric":
        case "string":
            e1 = $785da19a645c07eb$var$Os.value;
    }
    if (void 0 === $785da19a645c07eb$var$Ns) $785da19a645c07eb$var$Ns = e1;
    else {
        const t = $785da19a645c07eb$var$zs[$785da19a645c07eb$var$zs.length - 1];
        Array.isArray(t) ? t.push(e1) : Object.defineProperty(t, $785da19a645c07eb$var$Us, {
            value: e1,
            writable: !0,
            enumerable: !0,
            configurable: !0
        });
    }
    if (null !== e1 && "object" == typeof e1) $785da19a645c07eb$var$zs.push(e1), $785da19a645c07eb$var$Fs = Array.isArray(e1) ? "beforeArrayValue" : "beforePropertyName";
    else {
        const e1 = $785da19a645c07eb$var$zs[$785da19a645c07eb$var$zs.length - 1];
        $785da19a645c07eb$var$Fs = null == e1 ? "end" : Array.isArray(e1) ? "afterArrayValue" : "afterPropertyValue";
    }
}
function $785da19a645c07eb$var$io() {
    $785da19a645c07eb$var$zs.pop();
    const e1 = $785da19a645c07eb$var$zs[$785da19a645c07eb$var$zs.length - 1];
    $785da19a645c07eb$var$Fs = null == e1 ? "end" : Array.isArray(e1) ? "afterArrayValue" : "afterPropertyValue";
}
function $785da19a645c07eb$var$no(e1) {
    return $785da19a645c07eb$var$oo(void 0 === e1 ? `JSON5: invalid end of input at ${$785da19a645c07eb$var$Ls}:${$785da19a645c07eb$var$Bs}` : `JSON5: invalid character '${$785da19a645c07eb$var$so(e1)}' at ${$785da19a645c07eb$var$Ls}:${$785da19a645c07eb$var$Bs}`);
}
function $785da19a645c07eb$var$ao() {
    return $785da19a645c07eb$var$oo(`JSON5: invalid end of input at ${$785da19a645c07eb$var$Ls}:${$785da19a645c07eb$var$Bs}`);
}
function $785da19a645c07eb$var$ro() {
    return $785da19a645c07eb$var$Bs -= 5, $785da19a645c07eb$var$oo(`JSON5: invalid identifier character at ${$785da19a645c07eb$var$Ls}:${$785da19a645c07eb$var$Bs}`);
}
function $785da19a645c07eb$var$so(e1) {
    const t = {
        "'": "\\'",
        '"': '\\"',
        "\\": "\\\\",
        "\b": "\\b",
        "\f": "\\f",
        "\n": "\\n",
        "\r": "\\r",
        "\t": "\\t",
        "\v": "\\v",
        "\0": "\\0",
        "\u2028": "\\u2028",
        "\u2029": "\\u2029"
    };
    if (t[e1]) return t[e1];
    if (e1 < " ") {
        const t = e1.charCodeAt(0).toString(16);
        return "\\x" + ("00" + t).substring(t.length);
    }
    return e1;
}
function $785da19a645c07eb$var$oo(e1) {
    const t = new SyntaxError(e1);
    return t.lineNumber = $785da19a645c07eb$var$Ls, t.columnNumber = $785da19a645c07eb$var$Bs, t;
}
const $785da19a645c07eb$var$lo = {
    parse: function(e1, t) {
        $785da19a645c07eb$var$Is = String(e1), $785da19a645c07eb$var$Fs = "start", $785da19a645c07eb$var$zs = [], $785da19a645c07eb$var$Rs = 0, $785da19a645c07eb$var$Ls = 1, $785da19a645c07eb$var$Bs = 0, $785da19a645c07eb$var$Os = void 0, $785da19a645c07eb$var$Us = void 0, $785da19a645c07eb$var$Ns = void 0;
        do $785da19a645c07eb$var$Os = $785da19a645c07eb$var$Zs(), $785da19a645c07eb$var$eo[$785da19a645c07eb$var$Fs]();
        while ("eof" !== $785da19a645c07eb$var$Os.type);
        return "function" == typeof t ? $785da19a645c07eb$var$js({
            "": $785da19a645c07eb$var$Ns
        }, "", t) : $785da19a645c07eb$var$Ns;
    },
    stringify: function(e1, t, i) {
        const n = [];
        let a, r, s, o = "", l = "";
        if (null == t || "object" != typeof t || Array.isArray(t) || (i = t.space, s = t.quote, t = t.replacer), "function" == typeof t) r = t;
        else if (Array.isArray(t)) {
            a = [];
            for (const e1 of t){
                let t;
                "string" == typeof e1 ? t = e1 : ("number" == typeof e1 || e1 instanceof String || e1 instanceof Number) && (t = String(e1)), void 0 !== t && a.indexOf(t) < 0 && a.push(t);
            }
        }
        return i instanceof Number ? i = Number(i) : i instanceof String && (i = String(i)), "number" == typeof i ? i > 0 && (i = Math.min(10, Math.floor(i)), l = "          ".substr(0, i)) : "string" == typeof i && (l = i.substr(0, 10)), c("", {
            "": e1
        });
        function c(e1, t) {
            let i = t[e1];
            switch(null != i && ("function" == typeof i.toJSON5 ? i = i.toJSON5(e1) : "function" == typeof i.toJSON && (i = i.toJSON(e1))), r && (i = r.call(t, e1, i)), i instanceof Number ? i = Number(i) : i instanceof String ? i = String(i) : i instanceof Boolean && (i = i.valueOf()), i){
                case null:
                    return "null";
                case !0:
                    return "true";
                case !1:
                    return "false";
            }
            return "string" == typeof i ? u(i) : "number" == typeof i ? String(i) : "object" == typeof i ? Array.isArray(i) ? function(e1) {
                if (n.indexOf(e1) >= 0) throw TypeError("Converting circular structure to JSON5");
                n.push(e1);
                let t = o;
                o += l;
                let i, a = [];
                for(let t = 0; t < e1.length; t++){
                    const i = c(String(t), e1);
                    a.push(void 0 !== i ? i : "null");
                }
                if (0 === a.length) i = "[]";
                else if ("" === l) i = "[" + a.join(",") + "]";
                else {
                    let e1 = ",\n" + o, n = a.join(e1);
                    i = "[\n" + o + n + ",\n" + t + "]";
                }
                return n.pop(), o = t, i;
            }(i) : function(e1) {
                if (n.indexOf(e1) >= 0) throw TypeError("Converting circular structure to JSON5");
                n.push(e1);
                let t = o;
                o += l;
                let i, r = a || Object.keys(e1), s = [];
                for (const t of r){
                    const i = c(t, e1);
                    if (void 0 !== i) {
                        let e1 = h(t) + ":";
                        "" !== l && (e1 += " "), e1 += i, s.push(e1);
                    }
                }
                if (0 === s.length) i = "{}";
                else {
                    let e1;
                    if ("" === l) e1 = s.join(","), i = "{" + e1 + "}";
                    else {
                        let n = ",\n" + o;
                        e1 = s.join(n), i = "{\n" + o + e1 + ",\n" + t + "}";
                    }
                }
                return n.pop(), o = t, i;
            }(i) : void 0;
        }
        function u(e1) {
            const t = {
                "'": .1,
                '"': .2
            }, i = {
                "'": "\\'",
                '"': '\\"',
                "\\": "\\\\",
                "\b": "\\b",
                "\f": "\\f",
                "\n": "\\n",
                "\r": "\\r",
                "\t": "\\t",
                "\v": "\\v",
                "\0": "\\0",
                "\u2028": "\\u2028",
                "\u2029": "\\u2029"
            };
            let n = "";
            for(let a = 0; a < e1.length; a++){
                const r = e1[a];
                switch(r){
                    case "'":
                    case '"':
                        t[r]++, n += r;
                        continue;
                    case "\0":
                        if ($785da19a645c07eb$var$Ps.isDigit(e1[a + 1])) {
                            n += "\\x00";
                            continue;
                        }
                }
                if (i[r]) n += i[r];
                else {
                    if (r < " ") {
                        let e1 = r.charCodeAt(0).toString(16);
                        n += "\\x" + ("00" + e1).substring(e1.length);
                        continue;
                    }
                    n += r;
                }
            }
            const a = s || Object.keys(t).reduce((e1, i)=>t[e1] < t[i] ? e1 : i);
            return n = n.replace(new RegExp(a, "g"), i[a]), a + n + a;
        }
        function h(e1) {
            if (0 === e1.length) return u(e1);
            const t = String.fromCodePoint(e1.codePointAt(0));
            if (!$785da19a645c07eb$var$Ps.isIdStartChar(t)) return u(e1);
            for(let i = t.length; i < e1.length; i++)if (!$785da19a645c07eb$var$Ps.isIdContinueChar(String.fromCodePoint(e1.codePointAt(i)))) return u(e1);
            return e1;
        }
    }
};
var $785da19a645c07eb$var$co = $785da19a645c07eb$var$lo;
const $785da19a645c07eb$var$uo = new CSSStyleSheet;
$785da19a645c07eb$var$uo.replaceSync("/* atkinson-hyperlegible-next-latin-ext-400-normal */\n@font-face {\n  font-family: 'Atkinson Hyperlegible Next';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(/fonts/atkinson-hyperlegible-next-latin-ext-400-normal.woff2) format('woff2'), url(/fonts/atkinson-hyperlegible-next-latin-ext-400-normal.woff) format('woff');\n  unicode-range: U+0100-02BA,U+02BD-02C5,U+02C7-02CC,U+02CE-02D7,U+02DD-02FF,U+0304,U+0308,U+0329,U+1D00-1DBF,U+1E00-1E9F,U+1EF2-1EFF,U+2020,U+20A0-20AB,U+20AD-20C0,U+2113,U+2C60-2C7F,U+A720-A7FF;\n}\n\n/* atkinson-hyperlegible-next-latin-400-normal */\n@font-face {\n  font-family: 'Atkinson Hyperlegible Next';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(/fonts/atkinson-hyperlegible-next-latin-400-normal.woff2) format('woff2'), url(/fonts/atkinson-hyperlegible-next-latin-400-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}");
const $785da19a645c07eb$var$ho = new CSSStyleSheet;
$785da19a645c07eb$var$ho.replaceSync('/* Colors */\n:root, :host {\n\t--white: #ffffff;\n\t--black: #181818;\n\t--black-pale: #1b1a17;\n\t--red: #f70000;\n\t--red-transparent: rgba(247, 0, 0, 0.3);\n\t--red-pale: #ff726f;\n\t--grey: #f5f5f5;\n\t--grey-very-pale: #e6e6e6;\n\t--grey-pale: #cfd2cf;\n\t--grey-semi-dark: #808080;\n\t--grey-dark: #3e3e3e;\n\t--blue: #2954e9;\n\t--blue-dark: #0a1f69;\n\t--blue-semi: #d7dffc;\n\t--blue-pale: #f2f5ff;\n\t--blue-geovisio: #34495e;\n\t--beige: #f5f3ec;\n\t--yellow: #fec868;\n\t--orange: #ff6f00;\n\t--orange-transparent: rgba(255,111,0,0.3);\n\t--orange-pale: #fffafa;\n\t--green: #7ec636;\n\t--green-pale: #f0ffee;\n\t--widget-bg: var(--white);\n\t--widget-bg-hover: var(--grey);\n\t--widget-bg-active: var(--blue);\n\t--widget-bg-inactive: var(--grey-pale);\n\t--widget-bg-primary: var(--blue-semi);\n\t--widget-bg-primary-hover: #e0e7ff;\n\t--widget-bg-warn: #FFECB3;\n\t--widget-bg-danger: #FFCDD2;\n\t--widget-bg-success: #C8E6C9;\n\t--widget-border-div: var(--grey-pale);\n\t--widget-border-btn: var(--blue);\n\t--widget-font: var(--grey-dark);\n\t--widget-font-active: var(--white);\n\t--widget-font-direct: var(--blue);\n\t--widget-font-warn: #BF360C;\n\t--widget-font-danger: #B71C1C;\n\t--widget-font-success: #1B5E20;\n\t--font-family: "Atkinson Hyperlegible Next", sans-serif;\n\t--widget-option-left: #6A1B9A;\n\t--widget-option-right: #0D47A1;\n\toverscroll-behavior-y: contain;\n}\n\n.pnx-hidden { display: none !important; }\n\n/* Hidden elements on mobile */\n@container (max-width: 576px) {\n\t.pnx-mobile-hidden { display: none !important; }\n}\n\n/* Hidden elements on print */\n@media print {\n\t.pnx-print-hidden { display: none !important; }\n}\n'), document.adoptedStyleSheets.push($785da19a645c07eb$var$uo), document.adoptedStyleSheets.push($785da19a645c07eb$var$ho);
class $785da19a645c07eb$var$po extends $785da19a645c07eb$var$ce {
    static properties = {
        picture: {
            type: String,
            reflect: !0
        },
        sequence: {
            type: String,
            reflect: !0
        },
        "fetch-options": {
            converter: $785da19a645c07eb$var$po.GetJSONConverter()
        },
        lang: {
            type: String
        },
        endpoint: {
            type: String
        }
    };
    constructor(e1 = !1){
        super(), this.lang = this.getAttribute("lang") || null, this.endpoint = this.getAttribute("endpoint") || null, this.picture = this.getAttribute("picture") || null, this.sequence = this.getAttribute("sequence") || null, console.info(`\u{1F4F7} Panoramax ${this.getClassName()} - Version 5.3.1 (d2eaa71)

\u{1F198} Issues can be reported at https://gitlab.com/panoramax/clients/web-viewer/-/work_items`), e1 || (this._isInternetFast = null, $785da19a645c07eb$var$$e().then((e1)=>this._isInternetFast = e1));
    }
    connectedCallback() {
        super.connectedCallback(), this._t = $785da19a645c07eb$var$mt(this.lang), this.loader = $785da19a645c07eb$var$ks("pnx-loader", {
            _parent: this,
            "no-label": $785da19a645c07eb$var$Ye()
        }), this._loadsAPI && this.endpoint && this._loadsAPI === this.endpoint || this.api && this.api._endpoint === this.endpoint || !this.endpoint || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI()), Object.entries({
            map: "map-options",
            psv: "psv-options",
            fetchOptions: "fetch-options",
            mapstyle: "map-style"
        }).forEach(([e1, t])=>{
            this.getAttribute(e1) && console.error(`Component attribute "${e1}" has been renamed into "${t}". Old attribute "${e1}" is ignored.`);
        }), $785da19a645c07eb$var$Ye() && this.classList.add("pnx-iframed");
    }
    _setupAPI() {
        if (this.loader = this.loader || $785da19a645c07eb$var$ks("pnx-loader", {
            _parent: this
        }), !this.endpoint) return void console.warn("No endpoint is defined");
        this._loadsAPI = this.endpoint;
        let e1 = this.endpoint;
        try {
            this.api = new $785da19a645c07eb$var$st(this.endpoint, {
                fetch: this["fetch-options"]
            }), this.api.onceReady().then(()=>{
                if (e1 !== this._loadsAPI || !this.api) return;
                let t = this.api.getUnavailableFeatures(), i = this.api.getAvailableFeatures();
                i = 0 === t.length ? "\u2705 All features available" : "\u2705 Available features: " + i.join(", "), t = 0 === t.length ? "" : "\uD83D\uDEAB Unavailable features: " + t.join(", "), console.info(`\u{1F310} Connected to API "${this.api._metadata.name}" (${this.api._endpoint})
\u{2139}\u{FE0F} API runs STAC ${this.api._metadata.stac_version} ${this.api._metadata.geovisio_version ? "& GeoVisio " + this.api._metadata.geovisio_version : ""}\n   ${i}\n   ${t}\n`.trim());
            }).catch((e1)=>this.loader?.dismiss?.(e1, this._t?.pnx.error_api)).finally(()=>delete this._loadsAPI);
        } catch (e1) {
            delete this._loadsAPI, this.loader?.dismiss ? this.loader.dismiss(e1, this._t.pnx.error_api) : console.error(e1);
        }
    }
    onceReady() {
        throw new Error("You must override this method on sub-class");
    }
    onceAPIReady() {
        return this.api ? this.api.onceReady() : new Promise((e1)=>setTimeout(e1, 250)).then(this.onceAPIReady.bind(this));
    }
    createRenderRoot() {
        return this;
    }
    attributeChangedCallback(e1, t, i) {
        if (super.attributeChangedCallback(e1, t, i), "endpoint" === e1 && (this._loadsAPI && i && this._loadsAPI === i || this.api && this.api._endpoint === i || !i || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI())), [
            "picture",
            "sequence"
        ].includes(e1)) {
            let n, a, r, s;
            "picture" === e1 ? (n = this.sequence, r = this.sequence, a = i, s = t) : (n = i, r = t, a = this.picture, s = this.picture), this.dispatchEvent(new CustomEvent("select", {
                bubbles: !0,
                composed: !0,
                detail: {
                    seqId: n,
                    picId: a,
                    prevSeqId: r,
                    prevPicId: s
                }
            }));
        }
    }
    getClassName() {
        return "Basic";
    }
    select(e1 = null, t = null, i = !1) {
        i && (this.picture = null, this.sequence = null), this.picture = t, this.sequence = e1;
    }
    isWidthSmall() {
        return this?.offsetWidth < 576;
    }
    isWidthMedium() {
        return this?.offsetWidth >= 576 && this?.offsetWidth < 768;
    }
    isHeightSmall() {
        return this?.offsetHeight < 400;
    }
    render() {
        return $785da19a645c07eb$var$H`<p>Should not be used directly, use Viewer/CoverageMap/Editor instead</p>`;
    }
    getSubComponentsNames() {
        return [
            "loader",
            "api"
        ];
    }
    getAPI() {
        return this.api;
    }
    addEventListener(e1, t, i) {
        let n = e1.split(":").shift();
        if (n && this.getSubComponentsNames().includes(n)) {
            const a = e1.substring(n.length + 1);
            this[n]?.addEventListener ? this[n].addEventListener(a, t, i) : setTimeout(()=>this.addEventListener(e1, t, i), 50);
        } else super.addEventListener(e1, t, i);
    }
    static GetJSONConverter() {
        return {
            fromAttribute: (e1)=>null == e1 || "" === e1 ? null : "object" == typeof e1 || Array.isArray(e1) ? e1 : $785da19a645c07eb$var$co.parse(e1),
            toAttribute: (e1)=>null == e1 || "" === e1 ? "" : "string" == typeof e1 ? e1 : $785da19a645c07eb$var$co.stringify(e1)
        };
    }
}
var $785da19a645c07eb$var$mo = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg width='48' height='48' viewBox='0 0 48 48' version='1.1' id='svg1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cpath d='m 8.0222924%2c7.8597977 a 22.594107%2c22.594107 0 0 1 31.9555636%2c0.0027 L 24.001409%2c23.838916 Z' style='fill:%2354278f%3bfill-opacity:1%3bstroke:white%3bstroke-width:2.50003%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' id='path1' /%3e %3ccircle cx='24' cy='24' r='9.9777565' style='fill:%23b39ddb%3bfill-opacity:1%3bstroke:white%3bstroke-width:2.49449%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' id='circle1' /%3e%3c/svg%3e";
const $785da19a645c07eb$var$go = "pnx-aerial", $785da19a645c07eb$var$fo = 15, $785da19a645c07eb$var$Ao = [
    "!",
    [
        "has",
        "uncrowded"
    ]
], $785da19a645c07eb$var$_o = [
    "==",
    [
        "get",
        "type"
    ],
    "equirectangular"
];
function $785da19a645c07eb$var$vo(e1) {
    return {
        PICTURES: {
            paint: {
                "circle-radius": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    $785da19a645c07eb$var$fo,
                    0,
                    15.5,
                    e1 ? 1 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        0,
                        1
                    ],
                    16.5,
                    e1 ? 2 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        0,
                        2
                    ],
                    17,
                    e1 ? 4 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        1,
                        4
                    ],
                    18,
                    e1 ? 5 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        3,
                        5
                    ],
                    20,
                    e1 ? 7 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        5,
                        7
                    ],
                    22,
                    e1 ? 7 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        7,
                        7
                    ]
                ],
                "circle-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    $785da19a645c07eb$var$fo,
                    0,
                    15.5,
                    e1 ? 1 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        0,
                        1
                    ],
                    16.5,
                    e1 ? 1 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        0,
                        1
                    ],
                    17,
                    1
                ],
                "circle-stroke-opacity": [
                    "case",
                    [
                        "all",
                        $785da19a645c07eb$var$Ao,
                        $785da19a645c07eb$var$_o
                    ],
                    .2,
                    $785da19a645c07eb$var$_o,
                    .4,
                    0
                ],
                "circle-stroke-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    17.5,
                    0,
                    18.5,
                    e1 ? [
                        "case",
                        $785da19a645c07eb$var$_o,
                        10,
                        2
                    ] : [
                        "case",
                        [
                            "all",
                            $785da19a645c07eb$var$Ao,
                            $785da19a645c07eb$var$_o
                        ],
                        0,
                        $785da19a645c07eb$var$_o,
                        10,
                        $785da19a645c07eb$var$Ao,
                        0,
                        2
                    ],
                    19.5,
                    e1 ? [
                        "case",
                        $785da19a645c07eb$var$_o,
                        10,
                        2
                    ] : [
                        "case",
                        [
                            "all",
                            $785da19a645c07eb$var$Ao,
                            $785da19a645c07eb$var$_o
                        ],
                        10,
                        $785da19a645c07eb$var$_o,
                        10,
                        $785da19a645c07eb$var$Ao,
                        0,
                        2
                    ]
                ]
            },
            layout: {}
        },
        SEQUENCES: {
            paint: {
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    0,
                    .5,
                    10,
                    1.5,
                    14.5,
                    1.5,
                    15.5,
                    e1 ? 2 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        .5,
                        2
                    ],
                    22,
                    e1 ? 4 : [
                        "case",
                        $785da19a645c07eb$var$Ao,
                        1,
                        4
                    ]
                ]
            },
            layout: {
                "line-cap": "square"
            }
        },
        SEQUENCES_PLUS: {
            paint: {
                "line-width": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    0,
                    15,
                    16,
                    30
                ],
                "line-opacity": 0,
                "line-color": "#ff0000"
            },
            layout: {
                "line-cap": "square"
            }
        },
        GRID: {
            layout: {
                "circle-sort-key": [
                    "get",
                    "coef"
                ]
            },
            paint: {
                "circle-color": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "get",
                        "coef"
                    ],
                    0,
                    "#fff",
                    .1,
                    $785da19a645c07eb$var$Te.PALETTE_1,
                    .25,
                    $785da19a645c07eb$var$Te.PALETTE_1,
                    .5,
                    $785da19a645c07eb$var$Te.PALETTE_2,
                    .75,
                    $785da19a645c07eb$var$Te.PALETTE_3,
                    1,
                    $785da19a645c07eb$var$Te.PALETTE_4
                ],
                "circle-opacity": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    4,
                    .5,
                    5,
                    1,
                    6.75,
                    1,
                    7,
                    0
                ],
                "circle-radius": [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "zoom"
                    ],
                    1,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        1
                    ],
                    5,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        2.5
                    ],
                    7,
                    [
                        "match",
                        [
                            "get",
                            "coef"
                        ],
                        0,
                        0,
                        7
                    ]
                ]
            }
        }
    };
}
const $785da19a645c07eb$var$yo = $785da19a645c07eb$var$vo(!1), $785da19a645c07eb$var$xo = $785da19a645c07eb$var$vo(!0), $785da19a645c07eb$var$bo = [
    "case",
    [
        "==",
        [
            "get",
            "type"
        ],
        "equirectangular"
    ],
    [
        "case",
        [
            "has",
            "h_pixel_density"
        ],
        [
            "step",
            [
                "get",
                "h_pixel_density"
            ],
            ...$785da19a645c07eb$var$Fe
        ],
        1
    ],
    [
        "case",
        [
            "has",
            "h_pixel_density"
        ],
        [
            "step",
            [
                "get",
                "h_pixel_density"
            ],
            ...$785da19a645c07eb$var$Ie
        ],
        1
    ]
], $785da19a645c07eb$var$wo = [
    "case",
    [
        "==",
        [
            "get",
            "gps_accuracy"
        ],
        0
    ],
    1,
    [
        "has",
        "gps_accuracy"
    ],
    [
        "step",
        [
            "get",
            "gps_accuracy"
        ],
        ...$785da19a645c07eb$var$ze
    ],
    1
], $785da19a645c07eb$var$Eo = [
    "round",
    [
        "+",
        [
            "*",
            $785da19a645c07eb$var$bo,
            .8
        ],
        [
            "*",
            $785da19a645c07eb$var$wo,
            .2
        ]
    ]
], $785da19a645c07eb$var$ko = 864e5, $785da19a645c07eb$var$So = (e1)=>new Date(e1).toISOString().split("T")[0], $785da19a645c07eb$var$Mo = Date.now(), $785da19a645c07eb$var$Co = $785da19a645c07eb$var$So($785da19a645c07eb$var$Mo - 180 * $785da19a645c07eb$var$ko), $785da19a645c07eb$var$To = $785da19a645c07eb$var$So($785da19a645c07eb$var$Mo - 365 * $785da19a645c07eb$var$ko), $785da19a645c07eb$var$Do = $785da19a645c07eb$var$So($785da19a645c07eb$var$Mo - 94608e6), $785da19a645c07eb$var$Po = {
    default: {
        id: "default",
        sort: [],
        color: [
            [
                "==",
                [
                    "get",
                    "coef"
                ],
                1
            ],
            $785da19a645c07eb$var$Te.PALETTE_4,
            [
                ">=",
                [
                    "get",
                    "coef"
                ],
                .75
            ],
            $785da19a645c07eb$var$Te.PALETTE_3,
            [
                ">=",
                [
                    "get",
                    "coef"
                ],
                .5
            ],
            $785da19a645c07eb$var$Te.PALETTE_2,
            [
                ">=",
                [
                    "get",
                    "coef"
                ],
                .25
            ],
            $785da19a645c07eb$var$Te.PALETTE_1,
            [
                ">=",
                [
                    "get",
                    "coef"
                ],
                .1
            ],
            $785da19a645c07eb$var$Te.PALETTE_1,
            $785da19a645c07eb$var$Te.PALETTE_0
        ]
    },
    age: {
        id: "age",
        sort: [
            [
                "!",
                [
                    "any",
                    [
                        "has",
                        "date"
                    ],
                    [
                        "has",
                        "ts"
                    ]
                ]
            ],
            0,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$Co
            ],
            50,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$To
            ],
            49,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$Do
            ],
            48
        ],
        color: [
            [
                "!",
                [
                    "any",
                    [
                        "has",
                        "date"
                    ],
                    [
                        "has",
                        "ts"
                    ]
                ]
            ],
            $785da19a645c07eb$var$Te.BASE,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$Co
            ],
            $785da19a645c07eb$var$Te.PALETTE_4,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$To
            ],
            $785da19a645c07eb$var$Te.PALETTE_3,
            [
                ">=",
                [
                    "coalesce",
                    [
                        "get",
                        "date"
                    ],
                    [
                        "get",
                        "ts"
                    ]
                ],
                $785da19a645c07eb$var$Do
            ],
            $785da19a645c07eb$var$Te.PALETTE_2,
            $785da19a645c07eb$var$Te.PALETTE_1
        ]
    },
    type: {
        id: "type",
        sort: [
            [
                "!",
                [
                    "has",
                    "type"
                ]
            ],
            0,
            [
                "==",
                [
                    "get",
                    "type"
                ],
                "equirectangular"
            ],
            50
        ],
        color: [
            [
                "!",
                [
                    "has",
                    "type"
                ]
            ],
            $785da19a645c07eb$var$Te.BASE,
            [
                "==",
                [
                    "get",
                    "type"
                ],
                "equirectangular"
            ],
            $785da19a645c07eb$var$Te.QUALI_1,
            $785da19a645c07eb$var$Te.QUALI_2
        ]
    },
    score: {
        id: "score",
        sort: [
            [
                "==",
                $785da19a645c07eb$var$Eo,
                5
            ],
            80,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                4
            ],
            65,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                3
            ],
            50,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                2
            ],
            35,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                1
            ],
            20
        ],
        color: [
            [
                "==",
                $785da19a645c07eb$var$Eo,
                5
            ],
            $785da19a645c07eb$var$Pe[0].color,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                4
            ],
            $785da19a645c07eb$var$Pe[1].color,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                3
            ],
            $785da19a645c07eb$var$Pe[2].color,
            [
                "==",
                $785da19a645c07eb$var$Eo,
                2
            ],
            $785da19a645c07eb$var$Pe[3].color,
            $785da19a645c07eb$var$Pe[4].color
        ]
    },
    gps: {
        id: "gps",
        sort: [
            [
                "==",
                $785da19a645c07eb$var$wo,
                5
            ],
            80,
            [
                "==",
                $785da19a645c07eb$var$wo,
                4
            ],
            65,
            [
                "==",
                $785da19a645c07eb$var$wo,
                3
            ],
            50,
            [
                "==",
                $785da19a645c07eb$var$wo,
                2
            ],
            35,
            [
                "==",
                $785da19a645c07eb$var$wo,
                1
            ],
            20
        ],
        color: [
            [
                ">=",
                $785da19a645c07eb$var$wo,
                $785da19a645c07eb$var$Re[0].score
            ],
            $785da19a645c07eb$var$Re[0].color,
            [
                "==",
                $785da19a645c07eb$var$wo,
                $785da19a645c07eb$var$Re[1].score
            ],
            $785da19a645c07eb$var$Re[1].color,
            [
                "==",
                $785da19a645c07eb$var$wo,
                $785da19a645c07eb$var$Re[2].score
            ],
            $785da19a645c07eb$var$Re[2].color,
            $785da19a645c07eb$var$Re[3].color
        ]
    }
};
function $785da19a645c07eb$var$Io(e1) {
    const t = document.createElement("img");
    return $785da19a645c07eb$var$Ue($785da19a645c07eb$var$mo, t), t.alt = e1.loading, t.title = e1.loading, t.classList.add("pnx-map-thumb", "pnx-map-thumb-loader"), t;
}
function $785da19a645c07eb$var$Fo(e1) {
    return null == e1 || Array.isArray(e1) && (2 === e1.length && 0 === e1[0] && 0 === e1[1] || e1.length < 2);
}
function $785da19a645c07eb$var$zo(e1) {
    return "symbol" === e1.type && void 0 !== e1?.layout?.["text-field"] && (void 0 === e1.minzoom || e1.minzoom < 15);
}
function $785da19a645c07eb$var$Ro(e1) {
    const t = e1?.metadata?.["panoramax:fields"] || {};
    return t?.grid?.includes("logged_coef_360_pictures") && t?.grid?.includes("logged_coef_flat_pictures") && t?.grid?.includes("logged_coef") || !1;
}
function $785da19a645c07eb$var$Lo(e1) {
    const t = 2 === e1.metadata?.["panoramax:tiles_version"], i = Object.keys(e1.sources)[0], n = "vector" === e1.sources[i].type, a = n ? $785da19a645c07eb$var$yo : $785da19a645c07eb$var$xo;
    if (t) return e1.layers.push({
        id: `${i}_sequences_plus`,
        type: "line",
        source: i,
        "source-layer": "sequences",
        layout: {
            ...a.SEQUENCES_PLUS.layout
        },
        paint: {
            ...a.SEQUENCES_PLUS.paint
        }
    }), e1.layers;
    const r = [
        {
            id: `${i}_sequences`,
            type: "line",
            source: i,
            "source-layer": n ? "sequences" : void 0,
            layout: {
                ...a.SEQUENCES.layout
            },
            paint: {
                ...a.SEQUENCES.paint,
                "line-color": $785da19a645c07eb$var$Te.BASE
            }
        },
        {
            id: `${i}_sequences_plus`,
            type: "line",
            source: i,
            "source-layer": n ? "sequences" : void 0,
            layout: {
                ...a.SEQUENCES_PLUS.layout
            },
            paint: {
                ...a.SEQUENCES_PLUS.paint
            }
        },
        {
            id: `${i}_pictures`,
            type: "circle",
            source: i,
            "source-layer": n ? "pictures" : void 0,
            layout: {
                ...a.PICTURES.layout
            },
            paint: {
                ...a.PICTURES.paint,
                "circle-color": $785da19a645c07eb$var$Te.BASE
            }
        }
    ];
    return e1?.metadata?.["panoramax:fields"]?.grid && r.push({
        id: `${i}_grid`,
        type: "circle",
        source: i,
        "source-layer": "grid",
        layout: {
            ...a.GRID.layout
        },
        paint: {
            ...a.GRID.paint
        }
    }), r;
}
function $785da19a645c07eb$var$Bo(e1) {
    return ![
        "default",
        "metacatalog",
        "",
        null,
        void 0
    ].includes(e1);
}
function $785da19a645c07eb$var$Oo(e1, t) {
    if (Array.isArray(e1)) return e1.map((e1)=>$785da19a645c07eb$var$Oo(e1, t));
    if ("object" == typeof e1 && null !== e1) {
        const i = {};
        for(const n in e1)i[n] = $785da19a645c07eb$var$Oo(e1[n], t);
        return i;
    }
    return "string" == typeof e1 && (e1.startsWith("coef") || e1.startsWith("logged_coef")) ? t : e1;
}
function $785da19a645c07eb$var$Uo(e1) {
    const t = (t)=>{
        $785da19a645c07eb$var$Le(t.detail.picId) ? (e1.map.displayPictureMarker(), e1?.isMapWide?.() && e1?.mini?.setAttribute("collapsed", "")) : (e1.map.displayPictureMarker(t.detail.lon, t.detail.lat, e1.psv.getXY().x, t.detail.first && !$785da19a645c07eb$var$Fo(e1._initParams?.getMapPostInit()?.center), t.detail.picId), e1?.isMapWide?.() && e1?.mini?.removeAttribute("collapsed"));
    };
    e1.psv.addEventListener("picture-loading", t), e1.psv.addEventListener("picture-loaded", t), e1.psv.addEventListener("picture-failed", t), e1.psv.addEventListener("view-rotated", ()=>{
        let t = $785da19a645c07eb$var$nt(e1.psv.getPosition().yaw);
        t += e1.psv.getPictureOriginalHeading(), e1.map._picMarker.setRotation(t);
    }), e1.psv.addEventListener("picture-preview-started", (t)=>{
        e1.map._picMarkerPreview.setLngLat(t.detail.coordinates).setRotation(t.detail.direction || 0).addTo(e1.map);
    }), e1.psv.addEventListener("picture-preview-stopped", ()=>{
        e1.map._picMarkerPreview.remove();
    }), e1.psv.addEventListener("picture-loaded", (t)=>{
        e1.isWidthSmall() && e1._picPopup && t.detail.picId === e1._picPopup._picId && e1._picPopup.remove();
    }), e1.map.on("picture-click", (t)=>{
        e1.select(t.seqId, t.picId), !e1.psv._myVTour.state.currentNode && e1?._setFocus && e1._setFocus("pic");
    }), e1.map.on("sequence-click", (t)=>{
        (e1.getAPI?.() || e1.api).getPicturesAroundCoordinates(t.coordinates.lat, t.coordinates.lng, .01, 1, t.seqId).then((t)=>{
            t?.features?.length > 0 && (e1.select(t.features[0]?.collection, t.features[0].id), !e1.psv.getPictureMetadata() && e1?._setFocus && e1._setFocus("pic"));
        });
    }), e1._setFocus && (e1.psv.addEventListener("dblclick", ()=>{
        e1.isMapWide() && e1._setFocus("pic");
    }), e1.map.on("dblclick", ()=>{
        e1.isMapWide() ? "any" === e1.psv.getPicturesNavigation() && e1.select() : e1._setFocus("map");
    }), e1.addEventListener("focus-changed", (t)=>{
        "map" !== t.detail.focus && e1.map._dropPreview();
    }));
}
function $785da19a645c07eb$var$No(e1) {
    e1.map.keyboard.keydown = (function(t) {
        if (t.altKey || t.ctrlKey || t.metaKey) return;
        switch(t.key){
            case "*":
            case "5":
                return void e1.moveCenter();
            case "PageUp":
            case "9":
                return void e1.psv.goToNextPicture();
            case "PageDown":
            case "3":
                return void e1.psv.goToPrevPicture();
            case "Home":
            case "7":
                return t.stopPropagation(), void e1._toggleFocus();
            case "End":
            case "1":
                return void e1.mini.toggleAttribute("collapsed");
            case " ":
            case "0":
                return void e1.psv.toggleSequencePlaying();
        }
        let i = 0, n = 0, a = 0, r = 0, s = 0;
        switch(t.keyCode){
            case 61:
            case 107:
            case 171:
            case 187:
                i = 1;
                break;
            case 189:
            case 109:
            case 173:
                i = -1;
                break;
            case 37:
            case 100:
                t.shiftKey ? n = -1 : (t.preventDefault(), r = -1);
                break;
            case 39:
            case 102:
                t.shiftKey ? n = 1 : (t.preventDefault(), r = 1);
                break;
            case 38:
            case 104:
                t.shiftKey ? a = 1 : (t.preventDefault(), s = -1);
                break;
            case 40:
            case 98:
                t.shiftKey ? a = -1 : (t.preventDefault(), s = 1);
                break;
            default:
                return;
        }
        return this._rotationDisabled && (n = 0, a = 0), {
            cameraAnimation: (e1)=>{
                const o = this._tr;
                e1.easeTo({
                    duration: 300,
                    easeId: "keyboardHandler",
                    easing: (e1)=>e1 * (2 - e1),
                    zoom: i ? Math.round(o.zoom) + i * (t.shiftKey ? 2 : 1) : o.zoom,
                    bearing: o.bearing + n * this._bearingStep,
                    pitch: o.pitch + a * this._pitchStep,
                    offset: [
                        -r * this._panStep,
                        -s * this._panStep
                    ],
                    center: o.center
                }, {
                    originalEvent: t
                });
            }
        };
    }).bind(e1.map.keyboard);
}
const $785da19a645c07eb$var$jo = "pnx-map-parameters";
function $785da19a645c07eb$var$Vo() {
    const e1 = localStorage.getItem($785da19a645c07eb$var$jo);
    if (!e1) return {};
    try {
        return JSON.parse(e1);
    } catch (e1) {
        return console.warn("Can't read map parameters stored in localStorage", e1), {};
    }
}
function $785da19a645c07eb$var$qo(e1) {
    const t = ()=>localStorage.setItem($785da19a645c07eb$var$jo, JSON.stringify({
            center: Object.fromEntries(Object.entries(e1.getCenter()).map(([e1, t])=>[
                    e1,
                    t.toFixed(7)
                ])),
            zoom: e1.getZoom().toFixed(1),
            background: e1._parent.mapStyleComposer.basemap,
            theme: e1._parent.mapStyleComposer.panoramaxTheme,
            endpoint: e1._parent.mapStyleComposer.panoramax
        }));
    e1._parent.mapStyleComposer.addEventListener("filters-changed", t), e1._parent.mapStyleComposer.addEventListener("theme-changed", t), e1._parent.mapStyleComposer.addEventListener("basemap-changed", t), e1._parent.mapStyleComposer.addEventListener("panoramax-changed", t), e1.on("moveend", t), e1.on("zoomend", t), e1.on("dragend", t), e1.on("boxzoomend", t);
}
var $785da19a645c07eb$var$Go = Object.freeze({
    __proto__: null,
    MAP_EXPR_QUALITYSCORE: $785da19a645c07eb$var$Eo,
    MAP_EXPR_QUALITYSCORE_GPS: $785da19a645c07eb$var$wo,
    MAP_THEMES_STYLES: $785da19a645c07eb$var$Po,
    RASTER_LAYER_ID: $785da19a645c07eb$var$go,
    TILES_PICTURES_SYMBOL_ZOOM: 19,
    TILES_PICTURES_ZOOM: $785da19a645c07eb$var$fo,
    VECTOR_STYLES: $785da19a645c07eb$var$yo,
    VECTOR_STYLES_NOCROWD: $785da19a645c07eb$var$xo,
    getMapParamsFromLocalStorage: $785da19a645c07eb$var$Vo,
    getPanoramaxLayers: $785da19a645c07eb$var$Lo,
    getThumbGif: $785da19a645c07eb$var$Io,
    hasStyleLoggedGridStats: $785da19a645c07eb$var$Ro,
    initMapKeyboardHandler: $785da19a645c07eb$var$No,
    isLabelLayer: $785da19a645c07eb$var$zo,
    isNullCoordinates: $785da19a645c07eb$var$Fo,
    isPanoramaxEndpointSingleUser: $785da19a645c07eb$var$Bo,
    linkMapAndPhoto: $785da19a645c07eb$var$Uo,
    mapFiltersFormValues: function(e1, t, i) {
        const n = e1?.shadowRoot.getElementById("pnx-filter-date-from"), a = e1?.shadowRoot.getElementById("pnx-filter-date-end"), r = e1?.shadowRoot.querySelectorAll("input[name='pnx-filter-type']"), s = e1?.shadowRoot.getElementById("pnx-pictures-source");
        let o = "";
        for(let e1 = 0; e1 < r.length; e1++){
            const t = r[e1];
            if (t.checked) {
                o = t.value;
                break;
            }
        }
        let l = [], c = [];
        if (i) {
            const t = e1?.shadowRoot.getElementById("pnx-filter-qualityscore");
            l = (t?.grade || "").split(",").map((e1)=>parseInt(e1)).filter((e1)=>!isNaN(e1));
            const i = e1?.shadowRoot.getElementById("pnx-filter-gps");
            c = (i?.grade || "").split(",").map((e1)=>parseInt(e1)).filter((e1)=>!isNaN(e1));
        }
        return {
            minDate: n?.value,
            maxDate: a?.value,
            pic_type: o,
            theme: t?.value,
            qualityscore: l,
            gps: c,
            source: s?.checked ? "local" : "metacatalog"
        };
    },
    mapFiltersToLayersFilters: function(e1, t = !1, i = null) {
        let n = {}, a = [], r = [], s = !1;
        if (e1.minDate && "" !== e1.minDate && (n.minDate = e1.minDate, a.push([
            ">=",
            [
                "get",
                "date"
            ],
            e1.minDate
        ]), r.push([
            ">=",
            [
                "get",
                "ts"
            ],
            e1.minDate
        ])), e1.maxDate && "" !== e1.maxDate) {
            n.maxDate = e1.maxDate, a.push([
                "<=",
                [
                    "get",
                    "date"
                ],
                e1.maxDate
            ]);
            let t = new Date(e1.maxDate);
            t.setDate(t.getDate() + 1), t = t.toISOString().split("T")[0], r.push([
                "<=",
                [
                    "get",
                    "ts"
                ],
                t
            ]);
        }
        if (e1.pic_type && "" !== e1.pic_type && (n.pic_type = "flat" === e1.pic_type ? "flat" : "equirectangular", a.push([
            "==",
            [
                "get",
                "type"
            ],
            n.pic_type
        ]), r.push([
            "==",
            [
                "get",
                "type"
            ],
            n.pic_type
        ])), t && (s = !0), e1.camera && "" !== e1.camera) {
            n.camera = e1.camera;
            const t = e1.camera.toLowerCase().trim() + "                    ", i = e1.camera.toLowerCase().trim() + "zzzzzzzzzzzzzzzzzzzz", s = [
                "collator",
                {
                    "case-sensitive": !1,
                    "diacritic-sensitive": !1
                }
            ];
            a.push([
                ">=",
                [
                    "get",
                    "model"
                ],
                t,
                s
            ]), a.push([
                "<=",
                [
                    "get",
                    "model"
                ],
                i,
                s
            ]), r.push([
                ">=",
                [
                    "get",
                    "model"
                ],
                t,
                s
            ]), r.push([
                "<=",
                [
                    "get",
                    "model"
                ],
                i,
                s
            ]);
        }
        return e1.qualityscore && e1.qualityscore.length > 0 && (n.qualityscore = e1.qualityscore, a.push([
            "in",
            $785da19a645c07eb$var$Eo,
            [
                "literal",
                n.qualityscore
            ]
        ]), r.push([
            "in",
            $785da19a645c07eb$var$Eo,
            [
                "literal",
                n.qualityscore
            ]
        ])), e1.gps && e1.gps.length > 0 && (n.gps = e1.gps, a.push([
            "in",
            $785da19a645c07eb$var$wo,
            [
                "literal",
                n.gps
            ]
        ]), r.push([
            "in",
            $785da19a645c07eb$var$wo,
            [
                "literal",
                n.gps
            ]
        ])), e1.theme && $785da19a645c07eb$var$Po[e1.theme] && (n.theme = e1.theme, s = !0), i?.pictures && i.pictures.features?.length >= 0 && ("keep" === i.pictures.rule ? r.push([
            "in",
            [
                "get",
                "id"
            ],
            [
                "literal",
                i.pictures.features
            ]
        ]) : i.pictures.features.length > 0 && r.push([
            "!",
            [
                "in",
                [
                    "get",
                    "id"
                ],
                [
                    "literal",
                    i.pictures.features
                ]
            ]
        ])), i?.sequences && i.sequences.features?.length >= 0 && ("keep" === i.sequences.rule ? a.push([
            "in",
            [
                "get",
                "id"
            ],
            [
                "literal",
                i.sequences.features
            ]
        ]) : i.sequences.features.length > 0 && a.push([
            "!",
            [
                "in",
                [
                    "get",
                    "id"
                ],
                [
                    "literal",
                    i.sequences.features
                ]
            ]
        ])), 0 === a.length ? a = null : a.unshift("all"), 0 === r.length ? r = null : (r.unshift("all"), r = [
            "step",
            [
                "zoom"
            ],
            !0,
            $785da19a645c07eb$var$fo,
            r
        ]), {
            mapFilters: n,
            mapSeqFilters: a,
            mapPicFilters: r,
            reloadMapStyle: s
        };
    },
    saveMapParamsToLocalStorage: $785da19a645c07eb$var$qo,
    switchCoefValue: $785da19a645c07eb$var$Oo
});
function $785da19a645c07eb$var$Ho(e1, t, i, n) {
    let a = n;
    const r = t + (i - t >> 1);
    let s, o = i - t;
    const l = e1[t], c = e1[t + 1], u = e1[i], h = e1[i + 1];
    for(let n = t + 3; n < i; n += 3){
        const t = $785da19a645c07eb$var$Wo(e1[n], e1[n + 1], l, c, u, h);
        if (t > a) s = n, a = t;
        else if (t === a) {
            const e1 = Math.abs(n - r);
            e1 < o && (s = n, o = e1);
        }
    }
    a > n && (s - t > 3 && $785da19a645c07eb$var$Ho(e1, t, s, n), e1[s + 2] = a, i - s > 3 && $785da19a645c07eb$var$Ho(e1, s, i, n));
}
function $785da19a645c07eb$var$Wo(e1, t, i, n, a, r) {
    let s = a - i, o = r - n;
    if (0 !== s || 0 !== o) {
        const l = ((e1 - i) * s + (t - n) * o) / (s * s + o * o);
        l > 1 ? (i = a, n = r) : l > 0 && (i += s * l, n += o * l);
    }
    return s = e1 - i, o = t - n, s * s + o * o;
}
function $785da19a645c07eb$var$Zo(e1, t, i, n) {
    const a = {
        type: t,
        geom: i
    }, r = {
        id: null == e1 ? null : e1,
        type: a.type,
        geometry: a.geom,
        tags: n,
        minX: 1 / 0,
        minY: 1 / 0,
        maxX: -1 / 0,
        maxY: -1 / 0
    };
    switch(a.type){
        case "Point":
        case "MultiPoint":
            $785da19a645c07eb$var$Xo(r, a.geom);
            break;
        case "LineString":
            $785da19a645c07eb$var$Xo(r, a.geom.points);
            break;
        case "Polygon":
            $785da19a645c07eb$var$Xo(r, a.geom[0].points);
            break;
        case "MultiLineString":
            for (const e1 of a.geom)$785da19a645c07eb$var$Xo(r, e1.points);
            break;
        case "MultiPolygon":
            for (const e1 of a.geom)$785da19a645c07eb$var$Xo(r, e1[0].points);
    }
    return r;
}
function $785da19a645c07eb$var$Ko(e1) {
    const t = e1;
    e1.points.length > 64 && (t.points = new Float64Array(e1.points));
}
function $785da19a645c07eb$var$Xo(e1, t) {
    for(let i = 0; i < t.length; i += 3)e1.minX = Math.min(e1.minX, t[i]), e1.minY = Math.min(e1.minY, t[i + 1]), e1.maxX = Math.max(e1.maxX, t[i]), e1.maxY = Math.max(e1.maxY, t[i + 1]);
}
function $785da19a645c07eb$var$Qo(e1, t) {
    const i = [];
    switch(e1.type){
        case "FeatureCollection":
            for(let n = 0; n < e1.features.length; n++)$785da19a645c07eb$var$Yo(i, e1.features[n], t, n);
            break;
        case "Feature":
            $785da19a645c07eb$var$Yo(i, e1, t);
            break;
        default:
            $785da19a645c07eb$var$Yo(i, {
                geometry: e1,
                properties: void 0
            }, t);
    }
    return i;
}
function $785da19a645c07eb$var$Yo(e1, t, i, n, a = 0) {
    if (!t.geometry) return;
    if (a > 1024) throw new Error("GeometryCollection nesting exceeds supported depth: 1024");
    if ("GeometryCollection" === t.geometry.type) return void function(e1, t, i, n, a, r = 0) {
        for (const s of i.geometries)$785da19a645c07eb$var$Yo(e1, {
            id: t.id,
            geometry: s,
            properties: t.properties
        }, n, a, r);
    }(e1, t, t.geometry, i, n, a + 1);
    if (!t.geometry.coordinates?.length) return;
    const r = function(e1, t, i) {
        return t.promoteId ? e1.properties?.[t.promoteId] : t.generateId ? i || 0 : e1.id;
    }(t, i, n), s = Math.pow(i.tolerance / ((1 << i.maxZoom) * i.extent), 2);
    switch(t.geometry.type){
        case "Point":
            return void function(e1, t, i, n) {
                const a = [];
                a.push($785da19a645c07eb$var$el(i.coordinates[0]), $785da19a645c07eb$var$tl(i.coordinates[1]), 0), e1.push($785da19a645c07eb$var$Zo(t, "Point", a, n));
            }(e1, r, t.geometry, t.properties);
        case "MultiPoint":
            return void function(e1, t, i, n) {
                const a = [];
                for (const e1 of i.coordinates)a.push($785da19a645c07eb$var$el(e1[0]), $785da19a645c07eb$var$tl(e1[1]), 0);
                e1.push($785da19a645c07eb$var$Zo(t, "MultiPoint", a, n));
            }(e1, r, t.geometry, t.properties);
        case "LineString":
            return void function(e1, t, i, n, a) {
                const r = {
                    points: []
                };
                $785da19a645c07eb$var$Jo(i.coordinates, r, n, !1), e1.push($785da19a645c07eb$var$Zo(t, "LineString", r, a));
            }(e1, r, t.geometry, s, t.properties);
        case "MultiLineString":
            return void function(e1, t, i, n, a, r) {
                if (a.lineMetrics) for (const a of i.coordinates){
                    const i = {
                        points: []
                    };
                    $785da19a645c07eb$var$Jo(a, i, n, !1), e1.push($785da19a645c07eb$var$Zo(t, "LineString", i, r));
                }
                else {
                    const a = [];
                    $785da19a645c07eb$var$$o(i.coordinates, a, n, !1), e1.push($785da19a645c07eb$var$Zo(t, "MultiLineString", a, r));
                }
            }(e1, r, t.geometry, s, i, t.properties);
        case "Polygon":
            return void function(e1, t, i, n, a) {
                const r = [];
                $785da19a645c07eb$var$$o(i.coordinates, r, n, !0), e1.push($785da19a645c07eb$var$Zo(t, "Polygon", r, a));
            }(e1, r, t.geometry, s, t.properties);
        case "MultiPolygon":
            return void function(e1, t, i, n, a) {
                const r = [];
                for (const e1 of i.coordinates){
                    const t = [];
                    $785da19a645c07eb$var$$o(e1, t, n, !0), r.push(t);
                }
                e1.push($785da19a645c07eb$var$Zo(t, "MultiPolygon", r, a));
            }(e1, r, t.geometry, s, t.properties);
        default:
            throw new Error("Input data is not a valid GeoJSON object.");
    }
}
function $785da19a645c07eb$var$Jo(e1, t, i, n) {
    let a, r, s = 0;
    for(let i = 0; i < e1.length; i++){
        const o = $785da19a645c07eb$var$el(e1[i][0]), l = $785da19a645c07eb$var$tl(e1[i][1]);
        t.points.push(o, l, 0), i > 0 && (s += n ? (a * l - o * r) / 2 : Math.sqrt(Math.pow(o - a, 2) + Math.pow(l - r, 2))), a = o, r = l;
    }
    const o = t.points.length - 3;
    t.points[2] = 1, i > 0 && $785da19a645c07eb$var$Ho(t.points, 0, o, i), t.points[o + 2] = 1, $785da19a645c07eb$var$Ko(t), t.size = Math.abs(s), t.start = 0, t.end = t.size;
}
function $785da19a645c07eb$var$$o(e1, t, i, n) {
    for(let a = 0; a < e1.length; a++){
        const r = {
            points: []
        };
        $785da19a645c07eb$var$Jo(e1[a], r, i, n), t.push(r);
    }
}
function $785da19a645c07eb$var$el(e1) {
    return e1 / 360 + .5;
}
function $785da19a645c07eb$var$tl(e1) {
    const t = Math.sin(e1 * Math.PI / 180), i = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
    return i < 0 ? 0 : i > 1 ? 1 : i;
}
function $785da19a645c07eb$var$il(e1) {
    const t = {
        type: "Feature",
        geometry: $785da19a645c07eb$var$nl(e1),
        properties: e1.tags
    };
    return null != e1.id && (t.id = e1.id), t;
}
function $785da19a645c07eb$var$nl(e1) {
    const { type: t, geometry: i } = e1;
    switch(t){
        case "Point":
            return {
                type: t,
                coordinates: $785da19a645c07eb$var$rl(i[0], i[1])
            };
        case "MultiPoint":
            return {
                type: t,
                coordinates: $785da19a645c07eb$var$al(i)
            };
        case "LineString":
            return {
                type: t,
                coordinates: $785da19a645c07eb$var$al(i.points)
            };
        case "MultiLineString":
        case "Polygon":
            return {
                type: t,
                coordinates: i.map((e1)=>$785da19a645c07eb$var$al(e1.points))
            };
        case "MultiPolygon":
            return {
                type: t,
                coordinates: i.map((e1)=>e1.map((e1)=>$785da19a645c07eb$var$al(e1.points)))
            };
    }
}
function $785da19a645c07eb$var$al(e1) {
    const t = [];
    for(let i = 0; i < e1.length; i += 3)t.push($785da19a645c07eb$var$rl(e1[i], e1[i + 1]));
    return t;
}
function $785da19a645c07eb$var$rl(e1, t) {
    return [
        $785da19a645c07eb$var$sl(e1),
        $785da19a645c07eb$var$ol(t)
    ];
}
function $785da19a645c07eb$var$sl(e1) {
    return 360 * (e1 - .5);
}
function $785da19a645c07eb$var$ol(e1) {
    const t = (180 - 360 * e1) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
}
function $785da19a645c07eb$var$ll(e1, t, i, n, a, r, s, o) {
    if (n /= t, r >= (i /= t) && s < n) return e1;
    if (s < i || r >= n) return null;
    const l = [];
    for (const t of e1){
        const e1 = 0 === a ? t.minX : t.minY, r = 0 === a ? t.maxX : t.maxY;
        if (e1 >= i && r < n) l.push(t);
        else if (!(r < i || e1 >= n)) switch(t.type){
            case "Point":
            case "MultiPoint":
                $785da19a645c07eb$var$cl(t, l, i, n, a);
                continue;
            case "LineString":
                $785da19a645c07eb$var$ul(t, l, i, n, a, o);
                continue;
            case "MultiLineString":
                $785da19a645c07eb$var$hl(t, l, i, n, a);
                continue;
            case "Polygon":
                $785da19a645c07eb$var$dl(t, l, i, n, a);
                continue;
            case "MultiPolygon":
                $785da19a645c07eb$var$pl(t, l, i, n, a);
                continue;
        }
    }
    return l.length ? l : null;
}
function $785da19a645c07eb$var$cl(e1, t, i, n, a) {
    const r = [];
    if (function(e1, t, i, n, a) {
        for(let r = 0; r < e1.length; r += 3){
            const s = e1[r + a];
            s >= i && s <= n && $785da19a645c07eb$var$Al(t, e1[r], e1[r + 1], e1[r + 2]);
        }
    }(e1.geometry, r, i, n, a), !r.length) return;
    const s = 3 === r.length ? "Point" : "MultiPoint";
    t.push($785da19a645c07eb$var$Zo(e1.id, s, r, e1.tags));
}
function $785da19a645c07eb$var$ul(e1, t, i, n, a, r) {
    const s = [];
    if ($785da19a645c07eb$var$ml(e1.geometry, s, i, n, a, !1, r.lineMetrics), s.length) {
        if (r.lineMetrics) for (const i of s)t.push($785da19a645c07eb$var$Zo(e1.id, "LineString", i, e1.tags));
        else s.length > 1 ? t.push($785da19a645c07eb$var$Zo(e1.id, "MultiLineString", s, e1.tags)) : t.push($785da19a645c07eb$var$Zo(e1.id, "LineString", s[0], e1.tags));
    }
}
function $785da19a645c07eb$var$hl(e1, t, i, n, a) {
    const r = [];
    $785da19a645c07eb$var$fl(e1.geometry, r, i, n, a, !1), r.length && (1 !== r.length ? t.push($785da19a645c07eb$var$Zo(e1.id, "MultiLineString", r, e1.tags)) : t.push($785da19a645c07eb$var$Zo(e1.id, "LineString", r[0], e1.tags)));
}
function $785da19a645c07eb$var$dl(e1, t, i, n, a) {
    const r = [];
    $785da19a645c07eb$var$fl(e1.geometry, r, i, n, a, !0), r.length && t.push($785da19a645c07eb$var$Zo(e1.id, "Polygon", r, e1.tags));
}
function $785da19a645c07eb$var$pl(e1, t, i, n, a) {
    const r = [];
    for (const t of e1.geometry){
        const e1 = [];
        $785da19a645c07eb$var$fl(t, e1, i, n, a, !0), e1.length && r.push(e1);
    }
    r.length && t.push($785da19a645c07eb$var$Zo(e1.id, "MultiPolygon", r, e1.tags));
}
function $785da19a645c07eb$var$ml(e1, t, i, n, a, r, s) {
    let o = $785da19a645c07eb$var$gl(e1);
    const l = 0 === a ? $785da19a645c07eb$var$_l : $785da19a645c07eb$var$vl;
    let c, u, h = e1.start;
    for(let d = 0; d < e1.points.length - 3; d += 3){
        const p = e1.points[d], m = e1.points[d + 1], g = e1.points[d + 2], f = e1.points[d + 3], A = e1.points[d + 4], _ = 0 === a ? p : m, v = 0 === a ? f : A;
        let y = !1;
        s && (c = Math.sqrt(Math.pow(p - f, 2) + Math.pow(m - A, 2))), _ < i ? v > i && (u = l(o, p, m, f, A, i), s && (o.start = h + c * u)) : _ > n ? v < n && (u = l(o, p, m, f, A, n), s && (o.start = h + c * u)) : $785da19a645c07eb$var$Al(o.points, p, m, g), v < i && _ >= i && (u = l(o, p, m, f, A, i), y = !0), v > n && _ <= n && (u = l(o, p, m, f, A, n), y = !0), !r && y && (s && (o.end = h + c * u), t.push(o), o = $785da19a645c07eb$var$gl(e1)), s && (h += c);
    }
    let d = e1.points.length - 3;
    const p = e1.points[d], m = e1.points[d + 1], g = e1.points[d + 2], f = 0 === a ? p : m;
    f >= i && f <= n && $785da19a645c07eb$var$Al(o.points, p, m, g), d = o.points.length - 3, r && d >= 3 && (o.points[d] !== o.points[0] || o.points[d + 1] !== o.points[1]) && $785da19a645c07eb$var$Al(o.points, o.points[0], o.points[1], o.points[2]), o.points.length && ($785da19a645c07eb$var$Ko(o), t.push(o));
}
function $785da19a645c07eb$var$gl(e1) {
    return {
        points: [],
        size: e1.size,
        start: e1.start,
        end: e1.end
    };
}
function $785da19a645c07eb$var$fl(e1, t, i, n, a, r) {
    for (const s of e1)$785da19a645c07eb$var$ml(s, t, i, n, a, r, !1);
}
function $785da19a645c07eb$var$Al(e1, t, i, n) {
    e1.push(t, i, n);
}
function $785da19a645c07eb$var$_l(e1, t, i, n, a, r) {
    const s = (r - t) / (n - t);
    return $785da19a645c07eb$var$Al(e1.points, r, i + (a - i) * s, 1), s;
}
function $785da19a645c07eb$var$vl(e1, t, i, n, a, r) {
    const s = (r - i) / (a - i);
    return $785da19a645c07eb$var$Al(e1.points, t + (n - t) * s, r, 1), s;
}
function $785da19a645c07eb$var$yl(e1, t) {
    const i = t.buffer / t.extent;
    let n = e1;
    const a = $785da19a645c07eb$var$ll(e1, 1, -1 - i, i, 0, -1, 2, t), r = $785da19a645c07eb$var$ll(e1, 1, 1 - i, 2 + i, 0, -1, 2, t);
    return a || r ? (n = $785da19a645c07eb$var$ll(e1, 1, -i, 1 + i, 0, -1, 2, t) || [], a && (n = $785da19a645c07eb$var$xl(a, 1).concat(n)), r && (n = n.concat($785da19a645c07eb$var$xl(r, -1))), n) : n;
}
function $785da19a645c07eb$var$xl(e1, t) {
    const i = [];
    for (const n of e1)switch(n.type){
        case "Point":
        case "MultiPoint":
            {
                const e1 = $785da19a645c07eb$var$bl(n.geometry, t);
                i.push($785da19a645c07eb$var$Zo(n.id, n.type, e1, n.tags));
                continue;
            }
        case "LineString":
            {
                const e1 = $785da19a645c07eb$var$wl(n.geometry, t);
                i.push($785da19a645c07eb$var$Zo(n.id, n.type, e1, n.tags));
                continue;
            }
        case "MultiLineString":
        case "Polygon":
            {
                const e1 = [];
                for (const i of n.geometry)e1.push($785da19a645c07eb$var$wl(i, t));
                i.push($785da19a645c07eb$var$Zo(n.id, n.type, e1, n.tags));
                continue;
            }
        case "MultiPolygon":
            {
                const e1 = [];
                for (const i of n.geometry){
                    const n = [];
                    for (const e1 of i)n.push($785da19a645c07eb$var$wl(e1, t));
                    e1.push(n);
                }
                i.push($785da19a645c07eb$var$Zo(n.id, n.type, e1, n.tags));
                continue;
            }
    }
    return i;
}
function $785da19a645c07eb$var$bl(e1, t) {
    const i = [];
    for(let n = 0; n < e1.length; n += 3)i.push(e1[n] + t, e1[n + 1], e1[n + 2]);
    return i;
}
function $785da19a645c07eb$var$wl(e1, t) {
    const i = {
        points: [],
        size: e1.size
    };
    void 0 !== e1.start && (i.start = e1.start, i.end = e1.end);
    for(let n = 0; n < e1.points.length; n += 3)i.points.push(e1.points[n] + t, e1.points[n + 1], e1.points[n + 2]);
    return $785da19a645c07eb$var$Ko(i), i;
}
function $785da19a645c07eb$var$El(e1, t, i) {
    const n = function(e1, t) {
        return e1 ? {
            removeAll: e1.removeAll,
            remove: new Set(e1.remove || []),
            add: new Map(e1.add?.map((e1)=>[
                    t.promoteId ? e1.properties[t.promoteId] : e1.id,
                    e1
                ])),
            update: new Map(e1.update?.map((e1)=>[
                    e1.id,
                    e1
                ]))
        } : {
            remove: new Set,
            add: new Map,
            update: new Map
        };
    }(t, i);
    let a = [];
    if (n.removeAll && (a = e1, e1 = []), n.remove.size || n.add.size) {
        const t = [];
        for (const i of e1)(n.remove.has(i.id) || n.add.has(i.id)) && t.push(i);
        if (t.length) {
            a = a.concat(t);
            const i = new Set(t.map((e1)=>e1.id));
            e1 = e1.filter((e1)=>!i.has(e1.id));
        }
        if (n.add.size) {
            let t = $785da19a645c07eb$var$Qo({
                type: "FeatureCollection",
                features: Array.from(n.add.values())
            }, i);
            t = $785da19a645c07eb$var$yl(t, i), a = a.concat(t), e1 = e1.concat(t);
        }
    }
    if (n.update.size) {
        const t = new Map;
        let r = [];
        for (const i of e1)n.update.has(i.id) ? t.set(i.id, [
            ...t.get(i.id) || [],
            i
        ]) : r.push(i);
        for (const [e1, s] of n.update){
            const n = t.get(e1);
            if (!n || 0 === n.length) continue;
            const o = $785da19a645c07eb$var$kl(n, s, i);
            a = a.concat(n, o), r = r.concat(o);
        }
        e1 = r;
    }
    return {
        affected: a,
        source: e1
    };
}
function $785da19a645c07eb$var$kl(e1, t, i) {
    const n = !!t.newGeometry, a = t.removeAllProperties || t.removeProperties?.length > 0 || t.addOrUpdateProperties?.length > 0;
    if (n) {
        const n = e1[0];
        let r = $785da19a645c07eb$var$Qo({
            type: "FeatureCollection",
            features: [
                {
                    type: "Feature",
                    id: n.id,
                    geometry: t.newGeometry,
                    properties: a ? $785da19a645c07eb$var$Sl(n.tags, t) : n.tags
                }
            ]
        }, i);
        return r = $785da19a645c07eb$var$yl(r, i), r;
    }
    if (a) {
        const i = [];
        for (const n of e1){
            const e1 = {
                ...n
            };
            e1.tags = $785da19a645c07eb$var$Sl(e1.tags, t), i.push(e1);
        }
        return i;
    }
    return e1;
}
function $785da19a645c07eb$var$Sl(e1, t) {
    if (t.removeAllProperties) return {};
    const i = {
        ...e1 || {}
    };
    if (t.removeProperties) for (const e1 of t.removeProperties)delete i[e1];
    if (t.addOrUpdateProperties) for (const { key: e1, value: n } of t.addOrUpdateProperties)i[e1] = n;
    return i;
}
const $785da19a645c07eb$var$Ml = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], $785da19a645c07eb$var$Cl = new Uint32Array(96);
var $785da19a645c07eb$var$Tl = class e1 {
    static from(t) {
        if (!t || void 0 === t.byteLength || t.buffer) throw new Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
        const [i, n] = new Uint8Array(t, 0, 2);
        if (219 !== i) throw new Error("Data does not appear to be in a KDBush format.");
        const a = n >> 4;
        if (1 !== a) throw new Error(`Got v${a} data when expected v1.`);
        const r = $785da19a645c07eb$var$Ml[15 & n];
        if (!r) throw new Error("Unrecognized array type.");
        const [s] = new Uint16Array(t, 2, 1), [o] = new Uint32Array(t, 4, 1);
        return new e1(o, s, r, void 0, t);
    }
    constructor(e1, t = 64, i = Float64Array, n = ArrayBuffer, a){
        if (isNaN(e1) || e1 < 0) throw new Error(`Unexpected numItems value: ${e1}.`);
        this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
        const r = $785da19a645c07eb$var$Ml.indexOf(this.ArrayType), s = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, o = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - o % 8) % 8;
        if (r < 0) throw new Error(`Unexpected typed array class: ${i}.`);
        if (a) this.data = a, this.ids = new this.IndexArrayType(a, 8, e1), this.coords = new i(a, 8 + o + l, 2 * e1), this._pos = 2 * e1, this._finished = !0;
        else {
            const a = this.data = new n(8 + s + o + l);
            this.ids = new this.IndexArrayType(a, 8, e1), this.coords = new i(a, 8 + o + l, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(a, 0, 2).set([
                219,
                16 + r
            ]), new Uint16Array(a, 2, 1)[0] = t, new Uint32Array(a, 4, 1)[0] = e1;
        }
    }
    add(e1, t) {
        const i = this._pos >> 1;
        return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, i;
    }
    finish() {
        const e1 = this._pos >> 1;
        if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
        return $785da19a645c07eb$var$Dl(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e1, t, i, n) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: a, coords: r, nodeSize: s } = this;
        $785da19a645c07eb$var$Cl[0] = 0, $785da19a645c07eb$var$Cl[1] = a.length - 1, $785da19a645c07eb$var$Cl[2] = 0;
        let o = 3;
        const l = [];
        for(; o > 0;){
            const c = $785da19a645c07eb$var$Cl[--o], u = $785da19a645c07eb$var$Cl[--o], h = $785da19a645c07eb$var$Cl[--o];
            if (u - h <= s) {
                for(let s = h; s <= u; s++){
                    const o = r[2 * s], c = r[2 * s + 1];
                    o >= e1 && o <= i && c >= t && c <= n && l.push(a[s]);
                }
                continue;
            }
            const d = h + u >> 1, p = r[2 * d], m = r[2 * d + 1];
            p >= e1 && p <= i && m >= t && m <= n && l.push(a[d]), (0 === c ? e1 <= p : t <= m) && ($785da19a645c07eb$var$Cl[o++] = h, $785da19a645c07eb$var$Cl[o++] = d - 1, $785da19a645c07eb$var$Cl[o++] = 1 - c), (0 === c ? i >= p : n >= m) && ($785da19a645c07eb$var$Cl[o++] = d + 1, $785da19a645c07eb$var$Cl[o++] = u, $785da19a645c07eb$var$Cl[o++] = 1 - c);
        }
        return l;
    }
    within(e1, t, i) {
        const n = [];
        return this.withinInto(e1, t, i, n), n;
    }
    withinInto(e1, t, i, n) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: a, coords: r, nodeSize: s } = this;
        $785da19a645c07eb$var$Cl[0] = 0, $785da19a645c07eb$var$Cl[1] = a.length - 1, $785da19a645c07eb$var$Cl[2] = 0;
        let o = 3, l = 0;
        const c = i * i;
        for(; o > 0;){
            const u = $785da19a645c07eb$var$Cl[--o], h = $785da19a645c07eb$var$Cl[--o], d = $785da19a645c07eb$var$Cl[--o];
            if (h - d <= s) {
                for(let i = d; i <= h; i++)$785da19a645c07eb$var$zl(r[2 * i], r[2 * i + 1], e1, t) <= c && (n[l++] = a[i]);
                continue;
            }
            const p = d + h >> 1, m = r[2 * p], g = r[2 * p + 1];
            $785da19a645c07eb$var$zl(m, g, e1, t) <= c && (n[l++] = a[p]), (0 === u ? e1 - i <= m : t - i <= g) && ($785da19a645c07eb$var$Cl[o++] = d, $785da19a645c07eb$var$Cl[o++] = p - 1, $785da19a645c07eb$var$Cl[o++] = 1 - u), (0 === u ? e1 + i >= m : t + i >= g) && ($785da19a645c07eb$var$Cl[o++] = p + 1, $785da19a645c07eb$var$Cl[o++] = h, $785da19a645c07eb$var$Cl[o++] = 1 - u);
        }
        return l;
    }
};
function $785da19a645c07eb$var$Dl(e1, t, i, n, a, r) {
    if (a - n <= i) return;
    const s = n + a >> 1;
    $785da19a645c07eb$var$Pl(e1, t, s, n, a, r), $785da19a645c07eb$var$Dl(e1, t, i, n, s - 1, 1 - r), $785da19a645c07eb$var$Dl(e1, t, i, s + 1, a, 1 - r);
}
function $785da19a645c07eb$var$Pl(e1, t, i, n, a, r) {
    for(; a > n;){
        if (a - n > 600) {
            const s = a - n + 1, o = i - n + 1, l = Math.log(s), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (s - c) / s) * (o - s / 2 < 0 ? -1 : 1);
            $785da19a645c07eb$var$Pl(e1, t, i, Math.max(n, Math.floor(i - o * c / s + u)), Math.min(a, Math.floor(i + (s - o) * c / s + u)), r);
        }
        const s = t[2 * i + r];
        let o = n, l = a;
        for($785da19a645c07eb$var$Il(e1, t, n, i), t[2 * a + r] > s && $785da19a645c07eb$var$Il(e1, t, n, a); o < l;){
            for($785da19a645c07eb$var$Il(e1, t, o, l), o++, l--; t[2 * o + r] < s;)o++;
            for(; t[2 * l + r] > s;)l--;
        }
        t[2 * n + r] === s ? $785da19a645c07eb$var$Il(e1, t, n, l) : (l++, $785da19a645c07eb$var$Il(e1, t, l, a)), l <= i && (n = l + 1), i <= l && (a = l - 1);
    }
}
function $785da19a645c07eb$var$Il(e1, t, i, n) {
    $785da19a645c07eb$var$Fl(e1, i, n), $785da19a645c07eb$var$Fl(t, 2 * i, 2 * n), $785da19a645c07eb$var$Fl(t, 2 * i + 1, 2 * n + 1);
}
function $785da19a645c07eb$var$Fl(e1, t, i) {
    const n = e1[t];
    e1[t] = e1[i], e1[i] = n;
}
function $785da19a645c07eb$var$zl(e1, t, i, n) {
    const a = e1 - i, r = t - n;
    return a * a + r * r;
}
const $785da19a645c07eb$var$Rl = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: !1,
    generateId: !1,
    reduce: null,
    map: (e1)=>e1
};
var $785da19a645c07eb$var$Ll = class {
    constructor(e1){
        this.options = Object.assign(Object.create($785da19a645c07eb$var$Rl), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [], this.points = [];
    }
    load(e1) {
        const t = [];
        for (const i of e1){
            if (!i.geometry) continue;
            const [e1, n] = i.geometry.coordinates, [a, r] = [
                $785da19a645c07eb$var$el(e1),
                $785da19a645c07eb$var$tl(n)
            ], s = {
                id: i.id,
                type: "Point",
                geometry: [
                    a,
                    r
                ],
                tags: i.properties
            };
            t.push(s);
        }
        this.createIndex(t);
    }
    initialize(e1) {
        const t = [];
        for (const i of e1)"Point" === i.type && t.push(i);
        this.createIndex(t);
    }
    updateIndex(e1, t, i) {
        this.options = Object.assign(Object.create($785da19a645c07eb$var$Rl), i.clusterOptions), this.initialize(e1);
    }
    createIndex(e1) {
        const { log: t, minZoom: i, maxZoom: n } = this.options;
        t && console.time("total time");
        const a = `prepare ${e1.length} points`;
        t && console.time(a), this.points = e1;
        const r = [];
        for(let t = 0; t < e1.length; t++){
            const i = e1[t];
            if (!i?.geometry) continue;
            let [n, a] = i.geometry;
            n = Math.fround(n), a = Math.fround(a), r.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && r.push(0);
        }
        let s = this.trees[n + 1] = this.createTree(r);
        t && console.timeEnd(a);
        for(let e1 = n; e1 >= i; e1--){
            const i = Date.now();
            s = this.trees[e1] = this.createTree(this.cluster(s, e1)), t && console.log("z%d: %d clusters in %dms", e1, s.numItems, Date.now() - i);
        }
        t && console.timeEnd("total time");
    }
    getClusters(e1, t) {
        return this.getClustersInternal(e1, t).map((e1)=>$785da19a645c07eb$var$il(e1));
    }
    getClustersInternal(e1, t) {
        let i = ((e1[0] + 180) % 360 + 360) % 360 - 180;
        const n = Math.max(-90, Math.min(90, e1[1]));
        let a = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
        const r = Math.max(-90, Math.min(90, e1[3]));
        if (e1[2] - e1[0] >= 360) i = -180, a = 180;
        else if (i > a) {
            const e1 = this.getClustersInternal([
                i,
                n,
                180,
                r
            ], t), s = this.getClustersInternal([
                -180,
                n,
                a,
                r
            ], t);
            return e1.concat(s);
        }
        const s = this.trees[this.limitZoom(t)], o = s.range($785da19a645c07eb$var$el(i), $785da19a645c07eb$var$tl(r), $785da19a645c07eb$var$el(a), $785da19a645c07eb$var$tl(n)), l = s.flatData, c = [];
        for (const e1 of o){
            const t = this.stride * e1;
            c.push(l[t + 5] > 1 ? $785da19a645c07eb$var$Bl(l, t, this.clusterProps) : this.points[l[t + 3]]);
        }
        return c;
    }
    getChildren(e1) {
        const t = this.getOriginId(e1), i = this.getOriginZoom(e1), n = new Error("No cluster with the specified id: " + e1), a = this.trees[i];
        if (!a) throw n;
        const r = a.flatData;
        if (t * this.stride >= r.length) throw n;
        const s = this.options.radius / (this.options.extent * Math.pow(2, i - 1)), o = r[t * this.stride], l = r[t * this.stride + 1], c = a.within(o, l, s), u = [];
        for (const t of c){
            const i = t * this.stride;
            r[i + 4] === e1 && u.push(r[i + 5] > 1 ? $785da19a645c07eb$var$Ol(r, i, this.clusterProps) : $785da19a645c07eb$var$il(this.points[r[i + 3]]));
        }
        if (0 === u.length) throw n;
        return u;
    }
    getLeaves(e1, t, i) {
        t = t || 10, i = i || 0;
        const n = [];
        return this.appendLeaves(n, e1, t, i, 0), n;
    }
    getTile(e1, t, i) {
        const n = this.trees[this.limitZoom(e1)];
        if (!n) return null;
        const a = Math.pow(2, e1), { extent: r, radius: s } = this.options, o = s / r, l = (i - o) / a, c = (i + 1 + o) / a, u = {
            transformed: !0,
            features: [],
            source: null,
            x: t,
            y: i,
            z: e1
        };
        return this.addTileFeatures(n.range((t - o) / a, l, (t + 1 + o) / a, c), n.flatData, t, i, a, u), 0 === t && this.addTileFeatures(n.range(1 - o / a, l, 1, c), n.flatData, a, i, a, u), t === a - 1 && this.addTileFeatures(n.range(0, l, o / a, c), n.flatData, -1, i, a, u), u;
    }
    getClusterExpansionZoom(e1) {
        return this.getOriginZoom(e1);
    }
    appendLeaves(e1, t, i, n, a) {
        const r = this.getChildren(t);
        for (const t of r){
            const r = t.properties;
            if (r?.cluster ? a + r.point_count <= n ? a += r.point_count : a = this.appendLeaves(e1, r.cluster_id, i, n, a) : a < n ? a++ : e1.push(t), e1.length === i) break;
        }
        return a;
    }
    createTree(e1) {
        const t = new $785da19a645c07eb$var$Tl(e1.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < e1.length; i += this.stride)t.add(e1[i], e1[i + 1]);
        return t.finish(), t.flatData = e1, t.data = null, t;
    }
    addTileFeatures(e1, t, i, n, a, r) {
        for (const s of e1){
            const e1 = s * this.stride, o = t[e1 + 5] > 1;
            let l, c, u;
            if (o) l = $785da19a645c07eb$var$Ul(t, e1, this.clusterProps), c = t[e1], u = t[e1 + 1];
            else {
                const i = this.points[t[e1 + 3]];
                l = i.tags, [c, u] = i.geometry;
            }
            const h = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (c * a - i)),
                        Math.round(this.options.extent * (u * a - n))
                    ]
                ],
                tags: l
            };
            let d;
            d = o || this.options.generateId ? t[e1 + 3] : this.points[t[e1 + 3]].id, void 0 !== d && (h.id = d), r.features.push(h);
        }
    }
    limitZoom(e1) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
    }
    cluster(e1, t) {
        const { radius: i, extent: n, reduce: a, minPoints: r } = this.options, s = i / (n * Math.pow(2, t)), o = e1.flatData, l = [], c = this.stride;
        for(let i = 0; i < o.length; i += c){
            if (o[i + 2] <= t) continue;
            o[i + 2] = t;
            const n = o[i], u = o[i + 1], h = e1.within(o[i], o[i + 1], s), d = o[i + 5];
            let p = d;
            for (const e1 of h){
                const i = e1 * c;
                o[i + 2] > t && (p += o[i + 5]);
            }
            if (p > d && p >= r) {
                let e1, r = n * d, s = u * d, m = -1;
                const g = (i / c << 5) + (t + 1) + this.points.length;
                for (const n of h){
                    const l = n * c;
                    if (o[l + 2] <= t) continue;
                    o[l + 2] = t;
                    const u = o[l + 5];
                    r += o[l] * u, s += o[l + 1] * u, o[l + 4] = g, a && (e1 || (e1 = this.map(o, i, !0), m = this.clusterProps.length, this.clusterProps.push(e1)), a(e1, this.map(o, l)));
                }
                o[i + 4] = g, l.push(r / p, s / p, 1 / 0, g, -1, p), a && l.push(m);
            } else {
                for(let e1 = 0; e1 < c; e1++)l.push(o[i + e1]);
                if (p > 1) for (const e1 of h){
                    const i = e1 * c;
                    if (!(o[i + 2] <= t)) {
                        o[i + 2] = t;
                        for(let e1 = 0; e1 < c; e1++)l.push(o[i + e1]);
                    }
                }
            }
        }
        return l;
    }
    getOriginId(e1) {
        return e1 - this.points.length >> 5;
    }
    getOriginZoom(e1) {
        return (e1 - this.points.length) % 32;
    }
    map(e1, t, i) {
        if (e1[t + 5] > 1) {
            const n = this.clusterProps[e1[t + 6]];
            return i ? Object.assign({}, n) : n;
        }
        const n = this.points[e1[t + 3]].tags, a = this.options.map(n);
        return i && a === n ? Object.assign({}, a) : a;
    }
};
function $785da19a645c07eb$var$Bl(e1, t, i) {
    return {
        id: e1[t + 3],
        type: "Point",
        tags: $785da19a645c07eb$var$Ul(e1, t, i),
        geometry: [
            e1[t],
            e1[t + 1]
        ]
    };
}
function $785da19a645c07eb$var$Ol(e1, t, i) {
    return {
        type: "Feature",
        id: e1[t + 3],
        properties: $785da19a645c07eb$var$Ul(e1, t, i),
        geometry: {
            type: "Point",
            coordinates: [
                $785da19a645c07eb$var$sl(e1[t]),
                $785da19a645c07eb$var$ol(e1[t + 1])
            ]
        }
    };
}
function $785da19a645c07eb$var$Ul(e1, t, i) {
    const n = e1[t + 5], a = n >= 1e4 ? `${Math.round(n / 1e3)}k` : n >= 1e3 ? Math.round(n / 100) / 10 + "k" : n, r = e1[t + 6], s = -1 === r ? {} : Object.assign({}, i[r]);
    return Object.assign(s, {
        cluster: !0,
        cluster_id: e1[t + 3],
        point_count: n,
        point_count_abbreviated: a
    });
}
const $785da19a645c07eb$var$Nl = "geojsonvt_clip_start", $785da19a645c07eb$var$jl = "geojsonvt_clip_end";
function $785da19a645c07eb$var$Vl(e1, t, i, n, a) {
    const r = t === a.maxZoom ? 0 : a.tolerance / ((1 << t) * a.extent), s = {
        transformed: !1,
        features: [],
        source: null,
        x: i,
        y: n,
        z: t,
        minX: 2,
        minY: 1,
        maxX: -1,
        maxY: 0,
        numPoints: 0,
        numSimplified: 0,
        numFeatures: e1.length
    };
    for (const t of e1)$785da19a645c07eb$var$ql(s, t, r, a);
    return s;
}
function $785da19a645c07eb$var$ql(e1, t, i, n) {
    switch(e1.minX = Math.min(e1.minX, t.minX), e1.minY = Math.min(e1.minY, t.minY), e1.maxX = Math.max(e1.maxX, t.maxX), e1.maxY = Math.max(e1.maxY, t.maxY), t.type){
        case "Point":
        case "MultiPoint":
            return void function(e1, t) {
                const i = [];
                for(let n = 0; n < t.geometry.length; n += 3)i.push(t.geometry[n], t.geometry[n + 1]), e1.numPoints++, e1.numSimplified++;
                if (!i.length) return;
                const n = {
                    type: 1,
                    tags: t.tags || null,
                    geometry: i
                };
                null !== t.id && (n.id = t.id);
                e1.features.push(n);
            }(e1, t);
        case "LineString":
            return void function(e1, t, i, n) {
                const a = [];
                if ($785da19a645c07eb$var$Gl(a, t.geometry, e1, i, !1, !1), !a.length) return;
                let r = t.tags || null;
                if (n.lineMetrics) {
                    r = {};
                    for(const e1 in t.tags)r[e1] = t.tags[e1];
                    r[$785da19a645c07eb$var$Nl] = t.geometry.start / t.geometry.size, r[$785da19a645c07eb$var$jl] = t.geometry.end / t.geometry.size;
                }
                const s = {
                    type: 2,
                    tags: r,
                    geometry: a
                };
                null !== t.id && (s.id = t.id);
                e1.features.push(s);
            }(e1, t, i, n);
        case "MultiLineString":
        case "Polygon":
            return void function(e1, t, i) {
                const n = [];
                for(let a = 0; a < t.geometry.length; a++)$785da19a645c07eb$var$Gl(n, t.geometry[a], e1, i, "Polygon" === t.type, 0 === a);
                if (!n.length) return;
                const a = {
                    type: "Polygon" === t.type ? 3 : 2,
                    tags: t.tags || null,
                    geometry: n
                };
                null !== t.id && (a.id = t.id);
                e1.features.push(a);
            }(e1, t, i);
        case "MultiPolygon":
            return void function(e1, t, i) {
                const n = [];
                for(let a = 0; a < t.geometry.length; a++){
                    const r = t.geometry[a];
                    for(let t = 0; t < r.length; t++)$785da19a645c07eb$var$Gl(n, r[t], e1, i, !0, 0 === t);
                }
                if (!n.length) return;
                const a = {
                    type: 3,
                    tags: t.tags || null,
                    geometry: n
                };
                null !== t.id && (a.id = t.id);
                e1.features.push(a);
            }(e1, t, i);
    }
}
function $785da19a645c07eb$var$Gl(e1, t, i, n, a, r) {
    const s = n * n;
    if (n > 0 && t.size < (a ? s : n)) return void (i.numPoints += t.points.length / 3);
    const o = [];
    for(let e1 = 0; e1 < t.points.length; e1 += 3)(0 === n || t.points[e1 + 2] > s) && (i.numSimplified++, o.push(t.points[e1], t.points[e1 + 1])), i.numPoints++;
    a && function(e1, t) {
        let i = 0;
        for(let t = 0, n = e1.length, a = n - 2; t < n; a = t, t += 2)i += (e1[t] - e1[a]) * (e1[t + 1] + e1[a + 1]);
        if (i > 0 !== t) return;
        for(let t = 0, i = e1.length; t < i / 2; t += 2){
            const n = e1[t], a = e1[t + 1];
            e1[t] = e1[i - 2 - t], e1[t + 1] = e1[i - 1 - t], e1[i - 2 - t] = n, e1[i - 1 - t] = a;
        }
    }(o, r), e1.push(o);
}
function $785da19a645c07eb$var$Hl(e1, t) {
    if (e1.transformed) return e1;
    const i = 1 << e1.z, n = e1.x, a = e1.y;
    for (const r of e1.features)1 === r.type ? $785da19a645c07eb$var$Wl(r, t, i, n, a) : $785da19a645c07eb$var$Zl(r, t, i, n, a);
    return e1.transformed = !0, e1;
}
function $785da19a645c07eb$var$Wl(e1, t, i, n, a) {
    const r = e1, s = e1.geometry, o = [];
    for(let e1 = 0; e1 < s.length; e1 += 2)o.push($785da19a645c07eb$var$Kl(s[e1], s[e1 + 1], t, i, n, a));
    return r.geometry = o, r;
}
function $785da19a645c07eb$var$Zl(e1, t, i, n, a) {
    const r = e1, s = e1.geometry, o = [];
    for (const e1 of s){
        const r = [];
        for(let s = 0; s < e1.length; s += 2)r.push($785da19a645c07eb$var$Kl(e1[s], e1[s + 1], t, i, n, a));
        o.push(r);
    }
    return r.geometry = o, r;
}
function $785da19a645c07eb$var$Kl(e1, t, i, n, a, r) {
    return [
        Math.round(i * (e1 * n - a)),
        Math.round(i * (t * n - r))
    ];
}
var $785da19a645c07eb$var$Xl = class {
    constructor(e1){
        this.options = e1, this.total = 0, this.stats = {}, this.tiles = {}, this.tileCoords = [], this.stats = {}, this.total = 0;
    }
    initialize(e1) {
        this.splitTile(e1, 0, 0, 0), this.options.debug && (e1.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
    }
    updateIndex(e1, t, i) {
        i.debug > 1 && (console.log("invalidating tiles"), console.time("invalidating")), this.invalidateTiles(t), i.debug > 1 && console.timeEnd("invalidating");
        const [n, a, r] = [
            0,
            0,
            0
        ], s = $785da19a645c07eb$var$Vl(e1, n, a, r, i);
        s.source = e1;
        const o = $785da19a645c07eb$var$Ql(n, a, r);
        if (this.tiles[o] = s, this.tileCoords.push({
            z: n,
            x: a,
            y: r,
            id: o
        }), i.debug) {
            const e1 = `z${n}`;
            this.stats[e1] = (this.stats[e1] || 0) + 1, this.total++;
        }
    }
    getClusterExpansionZoom(e1) {
        return null;
    }
    getChildren(e1) {
        return null;
    }
    getLeaves(e1, t, i) {
        return null;
    }
    getTile(e1, t, i) {
        const { extent: n, debug: a } = this.options, r = 1 << e1, s = $785da19a645c07eb$var$Ql(e1, t = t + r & r - 1, i);
        if (this.tiles[s]) return $785da19a645c07eb$var$Hl(this.tiles[s], n);
        a > 1 && console.log("drilling down to z%d-%d-%d", e1, t, i);
        let o, l = e1, c = t, u = i;
        for(; !o && l > 0;)l--, c >>= 1, u >>= 1, o = this.tiles[$785da19a645c07eb$var$Ql(l, c, u)];
        return o?.source ? (a > 1 && (console.log("found parent tile z%d-%d-%d", l, c, u), console.time("drilling down")), this.splitTile(o.source, l, c, u, e1, t, i), a > 1 && console.timeEnd("drilling down"), this.tiles[s] ? $785da19a645c07eb$var$Hl(this.tiles[s], n) : null) : null;
    }
    splitTile(e1, t, i, n, a, r, s) {
        const o = [
            e1,
            t,
            i,
            n
        ], l = this.options, c = l.debug;
        for(; o.length;){
            n = o.pop(), i = o.pop(), t = o.pop(), e1 = o.pop();
            const u = 1 << t, h = $785da19a645c07eb$var$Ql(t, i, n);
            let d = this.tiles[h];
            if (!d && (c > 1 && console.time("creation"), d = this.tiles[h] = $785da19a645c07eb$var$Vl(e1, t, i, n, l), this.tileCoords.push({
                z: t,
                x: i,
                y: n,
                id: h
            }), c)) {
                c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, i, n, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                const e1 = `z${t}`;
                this.stats[e1] = (this.stats[e1] || 0) + 1, this.total++;
            }
            if (d.source = e1, null == a) {
                if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
            } else {
                if (t === l.maxZoom || t === a) continue;
                if (null != a) {
                    const e1 = a - t;
                    if (i !== r >> e1 || n !== s >> e1) continue;
                }
            }
            if (d.source = null, !e1.length) continue;
            c > 1 && console.time("clipping");
            const p = .5 * l.buffer / l.extent, m = .5 - p, g = .5 + p, f = 1 + p;
            let A = null, _ = null, v = null, y = null;
            const x = $785da19a645c07eb$var$ll(e1, u, i - p, i + g, 0, d.minX, d.maxX, l), b = $785da19a645c07eb$var$ll(e1, u, i + m, i + f, 0, d.minX, d.maxX, l);
            x && (A = $785da19a645c07eb$var$ll(x, u, n - p, n + g, 1, d.minY, d.maxY, l), _ = $785da19a645c07eb$var$ll(x, u, n + m, n + f, 1, d.minY, d.maxY, l)), b && (v = $785da19a645c07eb$var$ll(b, u, n - p, n + g, 1, d.minY, d.maxY, l), y = $785da19a645c07eb$var$ll(b, u, n + m, n + f, 1, d.minY, d.maxY, l)), c > 1 && console.timeEnd("clipping"), o.push(A || [], t + 1, 2 * i, 2 * n), o.push(_ || [], t + 1, 2 * i, 2 * n + 1), o.push(v || [], t + 1, 2 * i + 1, 2 * n), o.push(y || [], t + 1, 2 * i + 1, 2 * n + 1);
        }
    }
    invalidateTiles(e1) {
        if (!e1.length) return;
        const t = this.options, { debug: i } = t;
        let n = 1 / 0, a = -1 / 0, r = 1 / 0, s = -1 / 0;
        for (const t of e1)n = Math.min(n, t.minX), a = Math.max(a, t.maxX), r = Math.min(r, t.minY), s = Math.max(s, t.maxY);
        const o = t.buffer / t.extent, l = new Set;
        for(const t in this.tiles){
            const c = this.tiles[t], u = 1 << c.z, h = (c.x - o) / u, d = (c.x + 1 + o) / u, p = (c.y - o) / u, m = (c.y + 1 + o) / u;
            if (a < h || n >= d || s < p || r >= m) continue;
            let g = !1;
            for (const t of e1)if (t.maxX >= h && t.minX < d && t.maxY >= p && t.minY < m) {
                g = !0;
                break;
            }
            if (g) {
                if (i) {
                    i > 1 && console.log("invalidate tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", c.z, c.x, c.y, c.numFeatures, c.numPoints, c.numSimplified);
                    const e1 = `z${c.z}`;
                    this.stats[e1] = (this.stats[e1] || 0) - 1, this.total--;
                }
                delete this.tiles[t], l.add(t);
            }
        }
        l.size && (this.tileCoords = this.tileCoords.filter((e1)=>!l.has(e1.id)));
    }
};
function $785da19a645c07eb$var$Ql(e1, t, i) {
    return 32 * ((1 << e1) * i + t) + e1;
}
const $785da19a645c07eb$var$Yl = {
    maxZoom: 14,
    indexMaxZoom: 5,
    indexMaxPoints: 1e5,
    tolerance: 3,
    extent: 4096,
    buffer: 64,
    lineMetrics: !1,
    promoteId: null,
    generateId: !1,
    updateable: !1,
    cluster: !1,
    clusterOptions: $785da19a645c07eb$var$Rl,
    debug: 0
};
var $785da19a645c07eb$var$Jl = class {
    constructor(e1, t){
        const i = (t = this.options = Object.assign({}, $785da19a645c07eb$var$Yl, t)).debug;
        if (i && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
        if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
        let n = $785da19a645c07eb$var$Qo(e1, t);
        i && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles")), n = $785da19a645c07eb$var$yl(n, t), t.updateable && (this.source = n), this.initializeIndex(n, t);
    }
    initializeIndex(e1, t) {
        this.tileIndex = t.cluster ? new $785da19a645c07eb$var$Ll(t.clusterOptions) : new $785da19a645c07eb$var$Xl(t), e1.length && this.tileIndex.initialize(e1);
    }
    getTile(e1, t, i) {
        return t = +t, i = +i, (e1 = +e1) < 0 || e1 > 24 ? null : this.tileIndex.getTile(e1, t, i);
    }
    updateData(e1, t) {
        const i = this.options;
        if (!i.updateable) throw new Error("to update tile geojson `updateable` option must be set to true");
        let { affected: n, source: a } = $785da19a645c07eb$var$El(this.source, e1, i);
        t && ({ affected: n, source: a } = this.filterUpdate(a, n, t)), n.length && (this.source = a, this.tileIndex.updateIndex(a, n, i));
    }
    filterUpdate(e1, t, i) {
        const n = new Set;
        for (const a of e1)null != a.id && (i($785da19a645c07eb$var$il(a)) || (t.push(a), n.add(a.id)));
        return {
            affected: t,
            source: e1 = e1.filter((e1)=>!n.has(e1.id))
        };
    }
    getData() {
        if (!this.options.updateable) throw new Error("to retrieve data the `updateable` option must be set to true");
        return function(e1) {
            return {
                type: "FeatureCollection",
                features: e1.map((e1)=>$785da19a645c07eb$var$il(e1))
            };
        }(this.source);
    }
    updateClusterOptions(e1, t) {
        const i = this.options.cluster;
        this.options.cluster = e1, this.options.clusterOptions = t, i != e1 ? this.initializeIndex(this.source, this.options) : this.tileIndex.updateIndex(this.source, [], this.options);
    }
    getClusterExpansionZoom(e1) {
        return this.tileIndex.getClusterExpansionZoom(e1);
    }
    getClusterChildren(e1) {
        return this.tileIndex.getChildren(e1);
    }
    getClusterLeaves(e1, t, i) {
        return this.tileIndex.getLeaves(e1, t, i);
    }
};
const $785da19a645c07eb$var$$l = 4294967296, $785da19a645c07eb$var$ec = 1 / $785da19a645c07eb$var$$l, $785da19a645c07eb$var$tc = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
class $785da19a645c07eb$var$ic {
    constructor(e1){
        this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
    }
    readFields(e1, t, i = this.length) {
        let n;
        for(; n = this.nextField(i);)e1(n, t, this);
        return t;
    }
    readMessage(e1, t) {
        return this.readFields(e1, t, this.readVarint() + this.pos);
    }
    readFixed32() {
        const e1 = this.dataView.getUint32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readSFixed32() {
        const e1 = this.dataView.getInt32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readFixed64() {
        const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * $785da19a645c07eb$var$$l;
        return this.pos += 8, e1;
    }
    readSFixed64() {
        const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * $785da19a645c07eb$var$$l;
        return this.pos += 8, e1;
    }
    readFloat() {
        const e1 = this.dataView.getFloat32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readDouble() {
        const e1 = this.dataView.getFloat64(this.pos, !0);
        return this.pos += 8, e1;
    }
    readVarint(e1) {
        const t = this.buf, i = t[this.pos++];
        if (i < 128) return i;
        let n, a = 127 & i;
        return n = t[this.pos++], a |= (127 & n) << 7, n < 128 ? a : (n = t[this.pos++], a |= (127 & n) << 14, n < 128 ? a : (n = t[this.pos++], a |= (127 & n) << 21, n < 128 ? a : (n = t[this.pos], a |= (15 & n) << 28, function(e1, t, i) {
            const n = i.buf;
            let a, r;
            if (r = n[i.pos++], a = (112 & r) >> 4, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            if (r = n[i.pos++], a |= (127 & r) << 3, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            if (r = n[i.pos++], a |= (127 & r) << 10, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            if (r = n[i.pos++], a |= (127 & r) << 17, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            if (r = n[i.pos++], a |= (127 & r) << 24, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            if (r = n[i.pos++], a |= (1 & r) << 31, r < 128) return $785da19a645c07eb$var$ac(e1, a, t);
            throw new Error("Expected varint not more than 10 bytes");
        }(a, e1, this))));
    }
    readSVarint() {
        const e1 = this.readVarint();
        return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
    }
    readBoolean() {
        return Boolean(this.readVarint());
    }
    readString() {
        const e1 = this.readVarint() + this.pos, t = this.pos;
        return this.pos = e1, e1 - t >= 12 && $785da19a645c07eb$var$tc ? $785da19a645c07eb$var$tc.decode(this.buf.subarray(t, e1)) : function(e1, t, i) {
            let n = "", a = t;
            for(; a < i;){
                const t = e1[a];
                let r, s, o, l = null, c = t > 239 ? 4 : t > 223 ? 3 : t > 191 ? 2 : 1;
                if (a + c > i) break;
                1 === c ? t < 128 && (l = t) : 2 === c ? (r = e1[a + 1], 128 == (192 & r) && (l = (31 & t) << 6 | 63 & r, l <= 127 && (l = null))) : 3 === c ? (r = e1[a + 1], s = e1[a + 2], 128 == (192 & r) && 128 == (192 & s) && (l = (15 & t) << 12 | (63 & r) << 6 | 63 & s, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === c && (r = e1[a + 1], s = e1[a + 2], o = e1[a + 3], 128 == (192 & r) && 128 == (192 & s) && 128 == (192 & o) && (l = (15 & t) << 18 | (63 & r) << 12 | (63 & s) << 6 | 63 & o, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, c = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), a += c;
            }
            return n;
        }(this.buf, t, e1);
    }
    readBytes() {
        const e1 = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e1);
        return this.pos = e1, t;
    }
    readPackedVarint(e1 = [], t) {
        const i = this.readPackedEnd();
        for(; this.pos < i;)e1.push(this.readVarint(t));
        return e1;
    }
    readPackedSVarint(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSVarint());
        return e1;
    }
    readPackedBoolean(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readBoolean());
        return e1;
    }
    readPackedFloat(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFloat());
        return e1;
    }
    readPackedDouble(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readDouble());
        return e1;
    }
    readPackedFixed32(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFixed32());
        return e1;
    }
    readPackedSFixed32(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSFixed32());
        return e1;
    }
    readPackedFixed64(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFixed64());
        return e1;
    }
    readPackedSFixed64(e1 = []) {
        const t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSFixed64());
        return e1;
    }
    readPackedEnd() {
        return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
    }
    nextField(e1 = this.length) {
        if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e1) return 0;
        const t = this.readVarint();
        return this.type = 7 & t, this._valueStart = this.pos, t >>> 3;
    }
    skip(e1) {
        const t = 7 & e1;
        if (0 === t) for(; this.buf[this.pos++] > 127;);
        else if (2 === t) this.pos = this.readVarint() + this.pos;
        else if (5 === t) this.pos += 4;
        else {
            if (1 !== t) throw new Error(`Unimplemented type: ${t}`);
            this.pos += 8;
        }
    }
}
class $785da19a645c07eb$var$nc {
    constructor(e1 = new Uint8Array(16)){
        this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.length = this.buf.length;
    }
    writeTag(e1, t) {
        this.writeVarint(e1 << 3 | t);
    }
    realloc(e1) {
        let t = this.length || 16;
        for(; t < this.pos + e1;)t *= 2;
        if (t !== this.length) {
            const e1 = new Uint8Array(t);
            e1.set(this.buf), this.buf = e1, this.dataView = new DataView(e1.buffer), this.length = t;
        }
    }
    finish() {
        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
    }
    writeFixed32(e1) {
        this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
    }
    writeSFixed32(e1) {
        this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
    }
    writeFixed64(e1) {
        this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * $785da19a645c07eb$var$ec), !0), this.pos += 8;
    }
    writeSFixed64(e1) {
        this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * $785da19a645c07eb$var$ec), !0), this.pos += 8;
    }
    writeVarint(e1) {
        if ((e1 = +e1 || 0) >= 0 && e1 < 128) return this.pos >= this.length && this.realloc(1), void (this.buf[this.pos++] = e1);
        e1 > 268435455 || e1 < 0 ? function(e1, t) {
            let i, n;
            e1 >= 0 ? (i = e1 % 4294967296 | 0, n = e1 / 4294967296 | 0) : (i = ~(-e1 % 4294967296), n = ~(-e1 / 4294967296), 4294967295 ^ i ? i = i + 1 | 0 : (i = 0, n = n + 1 | 0));
            if (e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
            t.realloc(10), function(e1, t, i) {
                i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos] = 127 & e1;
            }(i, 0, t), function(e1, t) {
                const i = (7 & e1) << 4;
                if (t.buf[t.pos++] |= i | ((e1 >>>= 3) ? 128 : 0), !e1) return;
                if (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), !e1) return;
                if (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), !e1) return;
                if (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), !e1) return;
                if (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), !e1) return;
                t.buf[t.pos++] = 127 & e1;
            }(n, t);
        }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
    }
    writeSVarint(e1) {
        this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
    }
    writeBoolean(e1) {
        this.writeVarint(+e1);
    }
    writeString(e1) {
        e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
        const t = this.pos;
        this.pos = function(e1, t, i) {
            for(let n, a, r = 0; r < t.length; r++){
                if (n = t.charCodeAt(r), n > 55295 && n < 57344) {
                    if (!a) {
                        n > 56319 || r + 1 === t.length ? (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189) : a = n;
                        continue;
                    }
                    if (n < 56320) {
                        e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, a = n;
                        continue;
                    }
                    n = a - 55296 << 10 | n - 56320 | 65536, a = null;
                } else a && (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, a = null);
                n < 128 ? e1[i++] = n : (n < 2048 ? e1[i++] = n >> 6 | 192 : (n < 65536 ? e1[i++] = n >> 12 | 224 : (e1[i++] = n >> 18 | 240, e1[i++] = n >> 12 & 63 | 128), e1[i++] = n >> 6 & 63 | 128), e1[i++] = 63 & n | 128);
            }
            return i;
        }(this.buf, e1, this.pos);
        const i = this.pos - t;
        i >= 128 && $785da19a645c07eb$var$rc(t, i, this), this.pos = t - 1, this.writeVarint(i), this.pos += i;
    }
    writeFloat(e1) {
        this.realloc(4), this.dataView.setFloat32(this.pos, e1, !0), this.pos += 4;
    }
    writeDouble(e1) {
        this.realloc(8), this.dataView.setFloat64(this.pos, e1, !0), this.pos += 8;
    }
    writeBytes(e1) {
        const t = e1.length;
        this.writeVarint(t), this.realloc(t), this.buf.set(e1, this.pos), this.pos += t;
    }
    writeRawMessage(e1, t) {
        this.pos++;
        const i = this.pos;
        e1(t, this);
        const n = this.pos - i;
        n >= 128 && $785da19a645c07eb$var$rc(i, n, this), this.pos = i - 1, this.writeVarint(n), this.pos += n;
    }
    writeMessage(e1, t, i) {
        this.writeTag(e1, 2), this.writeRawMessage(t, i);
    }
    writePackedVarint(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$sc, t);
    }
    writePackedSVarint(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$oc, t);
    }
    writePackedBoolean(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$uc, t);
    }
    writePackedFloat(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$lc, t);
    }
    writePackedDouble(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$cc, t);
    }
    writePackedFixed32(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$hc, t);
    }
    writePackedSFixed32(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$dc, t);
    }
    writePackedFixed64(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$pc, t);
    }
    writePackedSFixed64(e1, t) {
        t.length && this.writeMessage(e1, $785da19a645c07eb$var$mc, t);
    }
    writeBytesField(e1, t) {
        this.writeTag(e1, 2), this.writeBytes(t);
    }
    writeFixed32Field(e1, t) {
        this.writeTag(e1, 5), this.writeFixed32(t);
    }
    writeSFixed32Field(e1, t) {
        this.writeTag(e1, 5), this.writeSFixed32(t);
    }
    writeFixed64Field(e1, t) {
        this.writeTag(e1, 1), this.writeFixed64(t);
    }
    writeSFixed64Field(e1, t) {
        this.writeTag(e1, 1), this.writeSFixed64(t);
    }
    writeVarintField(e1, t) {
        this.writeTag(e1, 0), this.writeVarint(t);
    }
    writeSVarintField(e1, t) {
        this.writeTag(e1, 0), this.writeSVarint(t);
    }
    writeStringField(e1, t) {
        this.writeTag(e1, 2), this.writeString(t);
    }
    writeFloatField(e1, t) {
        this.writeTag(e1, 5), this.writeFloat(t);
    }
    writeDoubleField(e1, t) {
        this.writeTag(e1, 1), this.writeDouble(t);
    }
    writeBooleanField(e1, t) {
        this.writeVarintField(e1, +t);
    }
}
function $785da19a645c07eb$var$ac(e1, t, i) {
    return i ? 4294967296 * t + (e1 >>> 0) : 4294967296 * (t >>> 0) + (e1 >>> 0);
}
function $785da19a645c07eb$var$rc(e1, t, i) {
    const n = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
    i.realloc(n), i.buf.copyWithin(e1 + n, e1, i.pos);
}
function $785da19a645c07eb$var$sc(e1, t) {
    const i = e1.length;
    let n = t.buf, a = t.pos, r = t.length;
    for(let s = 0; s < i; s++){
        let i = e1[s];
        if (i < 0 || a + 10 > r) t.pos = a, t.writeVarint(i), n = t.buf, a = t.pos, r = t.length;
        else {
            for(; i > 127;)n[a++] = i % 128 | 128, i = Math.floor(i / 128);
            n[a++] = i;
        }
    }
    t.pos = a;
}
function $785da19a645c07eb$var$oc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeSVarint(e1[i]);
}
function $785da19a645c07eb$var$lc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeFloat(e1[i]);
}
function $785da19a645c07eb$var$cc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeDouble(e1[i]);
}
function $785da19a645c07eb$var$uc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeBoolean(e1[i]);
}
function $785da19a645c07eb$var$hc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeFixed32(e1[i]);
}
function $785da19a645c07eb$var$dc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeSFixed32(e1[i]);
}
function $785da19a645c07eb$var$pc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeFixed64(e1[i]);
}
function $785da19a645c07eb$var$mc(e1, t) {
    for(let i = 0; i < e1.length; i++)t.writeSFixed64(e1[i]);
}
function $785da19a645c07eb$var$gc(e1, t) {
    this.x = e1, this.y = t;
}
$785da19a645c07eb$var$gc.prototype = {
    clone () {
        return new $785da19a645c07eb$var$gc(this.x, this.y);
    },
    add (e1) {
        return this.clone()._add(e1);
    },
    sub (e1) {
        return this.clone()._sub(e1);
    },
    multByPoint (e1) {
        return this.clone()._multByPoint(e1);
    },
    divByPoint (e1) {
        return this.clone()._divByPoint(e1);
    },
    mult (e1) {
        return this.clone()._mult(e1);
    },
    div (e1) {
        return this.clone()._div(e1);
    },
    rotate (e1) {
        return this.clone()._rotate(e1);
    },
    rotateAround (e1, t) {
        return this.clone()._rotateAround(e1, t);
    },
    matMult (e1) {
        return this.clone()._matMult(e1);
    },
    unit () {
        return this.clone()._unit();
    },
    perp () {
        return this.clone()._perp();
    },
    round () {
        return this.clone()._round();
    },
    mag () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals (e1) {
        return this.x === e1.x && this.y === e1.y;
    },
    dist (e1) {
        return Math.sqrt(this.distSqr(e1));
    },
    distSqr (e1) {
        const t = e1.x - this.x, i = e1.y - this.y;
        return t * t + i * i;
    },
    angle () {
        return Math.atan2(this.y, this.x);
    },
    angleTo (e1) {
        return Math.atan2(this.y - e1.y, this.x - e1.x);
    },
    angleWith (e1) {
        return this.angleWithSep(e1.x, e1.y);
    },
    angleWithSep (e1, t) {
        return Math.atan2(this.x * t - this.y * e1, this.x * e1 + this.y * t);
    },
    _matMult (e1) {
        const t = e1[0] * this.x + e1[1] * this.y, i = e1[2] * this.x + e1[3] * this.y;
        return this.x = t, this.y = i, this;
    },
    _add (e1) {
        return this.x += e1.x, this.y += e1.y, this;
    },
    _sub (e1) {
        return this.x -= e1.x, this.y -= e1.y, this;
    },
    _mult (e1) {
        return this.x *= e1, this.y *= e1, this;
    },
    _div (e1) {
        return this.x /= e1, this.y /= e1, this;
    },
    _multByPoint (e1) {
        return this.x *= e1.x, this.y *= e1.y, this;
    },
    _divByPoint (e1) {
        return this.x /= e1.x, this.y /= e1.y, this;
    },
    _unit () {
        return this._div(this.mag()), this;
    },
    _perp () {
        const e1 = this.y;
        return this.y = this.x, this.x = -e1, this;
    },
    _rotate (e1) {
        const t = Math.cos(e1), i = Math.sin(e1), n = t * this.x - i * this.y, a = i * this.x + t * this.y;
        return this.x = n, this.y = a, this;
    },
    _rotateAround (e1, t) {
        const i = Math.cos(e1), n = Math.sin(e1), a = t.x + i * (this.x - t.x) - n * (this.y - t.y), r = t.y + n * (this.x - t.x) + i * (this.y - t.y);
        return this.x = a, this.y = r, this;
    },
    _round () {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    },
    constructor: $785da19a645c07eb$var$gc
}, $785da19a645c07eb$var$gc.convert = function(e1) {
    if (e1 instanceof $785da19a645c07eb$var$gc) return e1;
    if (Array.isArray(e1)) return new $785da19a645c07eb$var$gc(+e1[0], +e1[1]);
    if (void 0 !== e1.x && void 0 !== e1.y) return new $785da19a645c07eb$var$gc(+e1.x, +e1.y);
    throw new Error("Expected [x, y] or {x, y} point format");
};
var $785da19a645c07eb$var$fc = class {
    constructor(e1, t){
        this.feature = e1, this.type = e1.type, this.properties = e1.tags ? e1.tags : {}, this.extent = t, "id" in e1 && ("string" == typeof e1.id ? this.id = parseInt(e1.id, 10) : "number" != typeof e1.id || isNaN(e1.id) || (this.id = e1.id));
    }
    loadGeometry() {
        const e1 = [], t = 1 === this.feature.type ? [
            this.feature.geometry
        ] : this.feature.geometry;
        for (const i of t){
            const t = [];
            for (const e1 of i)t.push(new $785da19a645c07eb$var$gc(e1[0], e1[1]));
            e1.push(t);
        }
        return e1;
    }
};
const $785da19a645c07eb$var$Ac = "_geojsonTileLayer";
var $785da19a645c07eb$var$_c = class {
    constructor(e1, t){
        this.layers = {
            [$785da19a645c07eb$var$Ac]: this
        }, this.name = $785da19a645c07eb$var$Ac, this.version = t ? t.version : 1, this.extent = t ? t.extent : 4096, this.length = e1.length, this.features = e1;
    }
    feature(e1) {
        return new $785da19a645c07eb$var$fc(this.features[e1], this.extent);
    }
};
function $785da19a645c07eb$var$vc(e1, t = "") {
    const i = new $785da19a645c07eb$var$nc;
    return function(e1, t, i = "") {
        for(const n in e1.layers)t.writeMessage(3, (e1, t)=>$785da19a645c07eb$var$yc(e1, t, i), e1.layers[n]);
    }(e1, i, t), i.finish();
}
function $785da19a645c07eb$var$yc(e1, t, i = "") {
    t.writeVarintField(15, e1.version || 1), t.writeStringField(1, e1.name || ""), t.writeVarintField(5, e1.extent || 4096);
    const n = {
        jsonPrefix: i,
        keys: [],
        values: [],
        keycache: {},
        valuecache: {}
    };
    for(let i = 0; i < e1.length; i++)n.feature = e1.feature(i), t.writeMessage(2, $785da19a645c07eb$var$xc, n);
    const a = n.keys;
    for (const e1 of a)t.writeStringField(3, e1);
    const r = n.values;
    for (const e1 of r)t.writeMessage(4, $785da19a645c07eb$var$Sc, e1);
}
function $785da19a645c07eb$var$xc(e1, t) {
    if (!e1.feature) return;
    const i = e1.feature;
    void 0 !== i.id && t.writeVarintField(1, i.id), t.writeMessage(2, $785da19a645c07eb$var$bc, e1), t.writeVarintField(3, i.type), t.writeMessage(4, $785da19a645c07eb$var$kc, i);
}
function $785da19a645c07eb$var$bc(e1, t) {
    for(const i in e1.feature?.properties){
        let n = e1.feature.properties[i], a = e1.keycache[i];
        if (null == n) continue;
        void 0 === a && (e1.keys.push(i), a = e1.keys.length - 1, e1.keycache[i] = a), t.writeVarint(a), "string" != typeof n && "boolean" != typeof n && "number" != typeof n && (n = e1.jsonPrefix + JSON.stringify(n));
        const r = typeof n + ":" + n;
        let s = e1.valuecache[r];
        void 0 === s && (e1.values.push(n), s = e1.values.length - 1, e1.valuecache[r] = s), t.writeVarint(s);
    }
}
function $785da19a645c07eb$var$wc(e1, t) {
    return (t << 3) + (7 & e1);
}
function $785da19a645c07eb$var$Ec(e1) {
    return e1 << 1 ^ e1 >> 31;
}
function $785da19a645c07eb$var$kc(e1, t) {
    const i = e1.loadGeometry(), n = e1.type;
    let a = 0, r = 0;
    for (const s of i){
        let i = 1;
        1 === n && (i = s.length), t.writeVarint($785da19a645c07eb$var$wc(1, i));
        const o = 3 === n ? s.length - 1 : s.length;
        for(let e1 = 0; e1 < o; e1++){
            1 === e1 && 1 !== n && t.writeVarint($785da19a645c07eb$var$wc(2, o - 1));
            const i = s[e1].x - a, l = s[e1].y - r;
            t.writeVarint($785da19a645c07eb$var$Ec(i)), t.writeVarint($785da19a645c07eb$var$Ec(l)), a += i, r += l;
        }
        3 === e1.type && t.writeVarint($785da19a645c07eb$var$wc(7, 1));
    }
}
function $785da19a645c07eb$var$Sc(e1, t) {
    const i = typeof e1;
    "string" === i ? t.writeStringField(1, e1) : "boolean" === i ? t.writeBooleanField(7, e1) : "number" === i && (e1 % 1 != 0 ? t.writeDoubleField(3, e1) : e1 < 0 ? t.writeSVarintField(6, e1) : t.writeVarintField(5, e1));
}
const $785da19a645c07eb$var$Mc = {
    15: 100,
    16: 300,
    17: 500,
    18: 800,
    19: 1e3
};
class $785da19a645c07eb$var$Cc {
    constructor(e1){
        this.tiles = new Map, this._parent = e1;
    }
    clearCache() {
        this.tiles = new Map;
    }
    _tileToBbox(e1, t, i) {
        const n = Math.pow(2, i), a = e1 / n * 360 - 180, r = (e1 + 1) / n * 360 - 180, s = $785da19a645c07eb$var$nt(Math.atan(Math.sinh(Math.PI * (1 - 2 * t / n))));
        return [
            a,
            $785da19a645c07eb$var$nt(Math.atan(Math.sinh(Math.PI * (1 - 2 * (t + 1) / n)))),
            r,
            s
        ];
    }
    _semanticsToBasicProps(e1) {
        const t = {}, i = (e1)=>{
            t[e1.key] ? t[e1.key].add(e1.value) : t[e1.key] = new Set([
                e1.value
            ]);
        };
        return (e1.properties?.collection?.semantics || []).forEach(i), (e1.properties?.semantics || []).forEach(i), (e1.properties?.annotations || []).forEach((e1)=>e1.semantics.forEach(i)), Object.keys(t).forEach((e1)=>t[e1] = [
                ...t[e1]
            ].join(";")), t.picid = e1.id, t.seqid = e1.collection, t;
    }
    tile() {
        return (e1, t)=>{
            t = t || new AbortController;
            const i = e1.url.match(/^sem:\/\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/);
            if (!i) throw new Error("Invalid URL");
            if (this.tiles.has(e1.url)) return {
                data: this.tiles.get(e1.url).buffer.slice(0)
            };
            const [, n, a, r, s] = i, o = this._tileToBbox(parseInt(r), parseInt(s), parseInt(a)), l = `${this._parent.getAPI()._endpoint}/search?bbox=${o.join(",")}&limit=${$785da19a645c07eb$var$Mc[parseInt(a)]}&sortby=id&filter=${encodeURIComponent(n)}`;
            return fetch(l, {
                signal: t.signal
            }).then((e1)=>e1.json()).then((t)=>{
                if (t.features) {
                    if (t.type = "FeatureCollection", 0 === t.features.length) {
                        const t = new Uint8Array;
                        return this.tiles.set(e1.url, t), {
                            data: t.buffer.slice(0)
                        };
                    }
                    t.features = t.features.filter((e1)=>{
                        let t = e1.properties?.semantics?.length > 0 || e1.properties?.annotations?.length > 0;
                        return t || e1.properties?.collection?.semantics?.find((e1)=>"osm|level" === e1.key) && (t = !0), t;
                    }).map((e1)=>({
                            type: e1.type,
                            geometry: e1.geometry,
                            id: e1.id,
                            properties: this._semanticsToBasicProps(e1)
                        }));
                }
                const i = new $785da19a645c07eb$var$Jl(t, {
                    minZoom: 15,
                    maxZoom: 19
                }).getTile(a, r, s);
                if (!i) throw new Error("Can't create tile");
                const n = function(e1, t) {
                    const i = {};
                    for(const n in e1)i[n] = new $785da19a645c07eb$var$_c(e1[n].features, t), i[n].name = n, i[n].version = t ? t.version : 1, i[n].extent = t ? t.extent : 4096;
                    return $785da19a645c07eb$var$vc({
                        layers: i
                    });
                }({
                    layer: i
                }, {
                    version: 2
                });
                return this.tiles.set(e1.url, n), {
                    data: n.buffer.slice(0)
                };
            }).catch((e1)=>{
                e1.message && e1.message.includes("The operation was aborted") || console.error(e1);
            });
        };
    }
}
class $785da19a645c07eb$var$Tc {
    constructor(e1, t, i, n, a){
        for(this.properties = Object.create(null), this.extent = i, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = a; e1.pos < t;){
            const t = e1.readVarint();
            if (8 === t) this.id = e1.readVarint();
            else if (18 === t) {
                const t = e1.readVarint() + e1.pos;
                for(; e1.pos < t;){
                    const t = n[e1.readVarint()], i = a[e1.readVarint()];
                    this.properties[t] = i;
                }
            } else 24 === t ? this.type = e1.readVarint() : 34 === t ? (this._geometry = e1.pos, e1.skip(t)) : e1.skip(t);
        }
    }
    loadGeometry() {
        if (this._geometry < 0) throw new Error("feature has no geometry");
        const e1 = this._pbf;
        e1.pos = this._geometry;
        const t = e1.readVarint() + e1.pos, i = [];
        let n, a = 1, r = 0, s = 0, o = 0;
        for(; e1.pos < t;){
            if (r <= 0) {
                const t = e1.readVarint();
                if (a = 7 & t, r = t >> 3, 0 === r) continue;
            }
            if (r--, 1 === a) s += e1.readSVarint(), o += e1.readSVarint(), n && i.push(n), n = [
                new $785da19a645c07eb$var$gc(s, o)
            ];
            else if (2 === a) s += e1.readSVarint(), o += e1.readSVarint(), n && n.push(new $785da19a645c07eb$var$gc(s, o));
            else {
                if (7 !== a) throw new Error(`unknown command ${a}`);
                n && n.push(n[0].clone());
            }
        }
        return n && i.push(n), i;
    }
    bbox() {
        if (this._geometry < 0) throw new Error("feature has no geometry");
        const e1 = this._pbf;
        e1.pos = this._geometry;
        const t = e1.readVarint() + e1.pos;
        let i = 1, n = 0, a = 0, r = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, c = -1 / 0;
        for(; e1.pos < t;){
            if (n <= 0) {
                const t = e1.readVarint();
                if (i = 7 & t, n = t >> 3, 0 === n) continue;
            }
            if (n--, 1 === i || 2 === i) a += e1.readSVarint(), r += e1.readSVarint(), a < s && (s = a), a > o && (o = a), r < l && (l = r), r > c && (c = r);
            else if (7 !== i) throw new Error(`unknown command ${i}`);
        }
        return [
            s,
            l,
            o,
            c
        ];
    }
    toGeoJSON(e1, t, i) {
        const n = this.extent * Math.pow(2, i), a = this.extent * e1, r = this.extent * t, s = this.loadGeometry();
        function o(e1) {
            return [
                360 * (e1.x + a) / n - 180,
                360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + r) / n) * Math.PI)) - 90
            ];
        }
        function l(e1) {
            return e1.map(o);
        }
        let c;
        if (1 === this.type) {
            const e1 = [];
            for (const t of s)e1.push(t[0]);
            const t = l(e1);
            c = 1 === e1.length ? {
                type: "Point",
                coordinates: t[0]
            } : {
                type: "MultiPoint",
                coordinates: t
            };
        } else if (2 === this.type) {
            const e1 = s.map(l);
            c = 1 === e1.length ? {
                type: "LineString",
                coordinates: e1[0]
            } : {
                type: "MultiLineString",
                coordinates: e1
            };
        } else {
            if (3 !== this.type) throw new Error("unknown feature type");
            {
                const e1 = function(e1) {
                    const t = e1.length;
                    if (t <= 1) return [
                        e1
                    ];
                    const i = [];
                    let n, a;
                    for(let r = 0; r < t; r++){
                        const t = $785da19a645c07eb$var$Dc(e1[r]);
                        0 !== t && (void 0 === a && (a = t < 0), a === t < 0 ? (n && i.push(n), n = [
                            e1[r]
                        ]) : n && n.push(e1[r]));
                    }
                    n && i.push(n);
                    return i;
                }(s), t = [];
                for (const i of e1)t.push(i.map(l));
                c = 1 === t.length ? {
                    type: "Polygon",
                    coordinates: t[0]
                } : {
                    type: "MultiPolygon",
                    coordinates: t
                };
            }
        }
        const u = {
            type: "Feature",
            geometry: c,
            properties: this.properties
        };
        return null != this.id && (u.id = this.id), u;
    }
}
function $785da19a645c07eb$var$Dc(e1) {
    let t = 0;
    for(let i, n, a = 0, r = e1.length, s = r - 1; a < r; s = a++)i = e1[a], n = e1[s], t += (n.x - i.x) * (i.y + n.y);
    return t;
}
$785da19a645c07eb$var$Tc.types = [
    "Unknown",
    "Point",
    "LineString",
    "Polygon"
];
class $785da19a645c07eb$var$Pc {
    constructor(e1, t){
        for(this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], void 0 === t && (t = e1.length); e1.pos < t;){
            const t = e1.readVarint();
            10 === t ? this.name = e1.readString() : 18 === t ? (this._features.push(e1.pos), e1.skip(t)) : 26 === t ? this._keys.push(e1.readString()) : 34 === t ? this._values.push($785da19a645c07eb$var$Ic(e1)) : 40 === t ? this.extent = e1.readVarint() : 120 === t ? this.version = e1.readVarint() : e1.skip(t);
        }
        this.length = this._features.length;
    }
    feature(e1) {
        if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
        this._pbf.pos = this._features[e1];
        const t = this._pbf.readVarint() + this._pbf.pos;
        return new $785da19a645c07eb$var$Tc(this._pbf, t, this.extent, this._keys, this._values);
    }
}
function $785da19a645c07eb$var$Ic(e1) {
    let t = null;
    const i = e1.readVarint() + e1.pos;
    for(; e1.pos < i;){
        const i = e1.readVarint();
        t = 10 === i ? e1.readString() : 21 === i ? e1.readFloat() : 25 === i ? e1.readDouble() : 32 === i ? e1.readVarint(!0) : 40 === i ? e1.readVarint() : 48 === i ? e1.readSVarint() : 56 === i ? e1.readBoolean() : (e1.skip(i), null);
    }
    if (null == t) throw new Error("unknown feature value");
    return t;
}
class $785da19a645c07eb$var$Fc {
    constructor(e1, t = e1.length){
        const i = Object.create(null);
        for(; e1.pos < t;){
            const t = e1.readVarint();
            if (26 === t) {
                const t = new $785da19a645c07eb$var$Pc(e1, e1.readVarint() + e1.pos);
                t.length && (i[t.name] = t);
            } else e1.skip(t);
        }
        this.layers = i;
    }
}
class $785da19a645c07eb$var$zc {
    tile() {
        return (e1, t)=>{
            t = t || new AbortController;
            const i = e1.url.replace(/^panora/, "http");
            return fetch(i, {
                signal: t.signal
            }).then((e1)=>e1.arrayBuffer()).then((e1)=>new $785da19a645c07eb$var$Fc(new $785da19a645c07eb$var$ic(e1))).then((e1)=>(!e1.layers.pictures || e1.layers.pictures.length >= 5e3 || Object.values(e1.layers).forEach((e1)=>{
                    const t = e1.feature.bind(e1);
                    e1.feature = (e1)=>{
                        const i = t(e1);
                        return i.properties.uncrowded = !0, i;
                    };
                }), e1)).then((e1)=>$785da19a645c07eb$var$vc(e1).buffer).then((e1)=>({
                    data: e1
                }));
        };
    }
}
const $785da19a645c07eb$var$Rc = "-1000", $785da19a645c07eb$var$Lc = "levels";
function $785da19a645c07eb$var$Bc() {
    try {
        return IndoorEqual, !0;
    } catch (e1) {
        return !1;
    }
}
function $785da19a645c07eb$var$Oc(e1, t = !1) {
    if (e1._options.indoor) {
        if ($785da19a645c07eb$var$Bc()) {
            if (!t && !1 === e1._options.indoor.visible) return;
            e1.indoorEqual = new IndoorEqual(e1, e1._options.indoor), e1.addControl(e1.indoorEqual), e1.indoorEqual.loadSprite("https://files.pavie.info/depot/remote/indoorequal/indoorequal"), e1.indoorEqual._refreshAfterLevelsUpdate = function() {
                this.levels.includes(this.level) || this.level == $785da19a645c07eb$var$Rc || this.setLevel("0");
            };
            const i = "sem-" + $785da19a645c07eb$var$Lc;
            e1.indoorEqual._updateLevels = function() {
                if (this.map.getSource(this.source.sourceId) && this.map.isSourceLoaded(this.source.sourceId) && this.map.getSource(i) && this.map.isSourceLoaded(i)) {
                    let e1 = new Set;
                    this.map.querySourceFeatures(this.source.sourceId, {
                        sourceLayer: "area"
                    }).forEach((t)=>{
                        "level" !== t.properties.class && void 0 !== t.properties.level && e1.add(t.properties.level.toString());
                    }), this.map.querySourceFeatures(i, {
                        sourceLayer: "layer"
                    }).forEach((t)=>{
                        void 0 !== t.properties["osm|level"] && e1.add(t.properties["osm|level"].toString());
                    }), e1.size > 0 && e1.add("0"), 0 !== e1.symmetricDifference(new Set(this.levels)).size && (this.levels = [
                        ...e1
                    ].sort((e1, t)=>parseFloat(e1) - parseFloat(t)).reverse(), this._emitLevelsChange(), this._refreshAfterLevelsUpdate());
                }
            }, e1._indoorFeaturesIDs = {
                pictures: {},
                sequences: {}
            }, e1.on("sourcedata", $785da19a645c07eb$var$Lc, (t)=>{
                t.sourceId === i && (t.features.forEach((t)=>{
                    e1._indoorFeaturesIDs.pictures[t.properties["osm|level"]] || (e1._indoorFeaturesIDs.pictures[t.properties["osm|level"]] = new Set), e1._indoorFeaturesIDs.sequences[t.properties["osm|level"]] || (e1._indoorFeaturesIDs.sequences[t.properties["osm|level"]] = new Set), e1._indoorFeaturesIDs.pictures[t.properties["osm|level"]].add(t.properties.picid), e1._indoorFeaturesIDs.sequences[t.properties["osm|level"]].add(t.properties.seqid);
                }), s());
            });
            const n = ()=>{
                e1.addSemanticOverlay?.($785da19a645c07eb$var$Lc, '"semantics.osm|level" IS NOT NULL', {
                    type: "circle",
                    layout: {
                        visibility: "visible"
                    },
                    paint: {
                        "circle-opacity": 0
                    }
                }), t && e1._parent._initParams?.getMapPostInit()?.level === $785da19a645c07eb$var$Rc ? e1.indoorEqual.setLevel("0") : [
                    null,
                    void 0,
                    ""
                ].includes(e1._parent._initParams?.getMapPostInit()?.level) || e1.indoorEqual.setLevel(e1._parent._initParams?.getMapPostInit()?.level);
            };
            if (e1.isStyleLoaded()) n();
            else {
                const t = setInterval(()=>{
                    e1.isStyleLoaded() && (n(), clearInterval(t));
                }, 250);
            }
            let a;
            e1._parent.grid.appendChild($785da19a645c07eb$var$ks("pnx-level-select", {
                slot: "bottom-right",
                _parent: e1._parent,
                class: "pnx-only-map pnx-print-hidden"
            }));
            const r = ()=>{
                if (e1.indoorEqual.level === $785da19a645c07eb$var$Rc) e1.restrictVisibleFeatures("hide", "pictures", []), e1.restrictVisibleFeatures("hide", "sequences", []);
                else if ("0" === e1.indoorEqual.level) {
                    const t = new Set;
                    Object.entries(e1._indoorFeaturesIDs.pictures).forEach(([e1, i])=>{
                        "0" != e1 && i.forEach((e1)=>t.add(e1));
                    }), e1.restrictVisibleFeatures("hide", "pictures", [
                        ...t
                    ]);
                    let i = new Set;
                    Object.entries(e1._indoorFeaturesIDs.sequences).forEach(([e1, t])=>{
                        "0" != e1 && (i = i.union(t));
                    }), e1._indoorFeaturesIDs.sequences[0] && (i = i.difference(e1._indoorFeaturesIDs.sequences[0])), e1.restrictVisibleFeatures("hide", "sequences", [
                        ...i
                    ]);
                } else e1.restrictVisibleFeatures("keep", "pictures", e1._indoorFeaturesIDs.pictures[e1.indoorEqual.level] ? [
                    ...e1._indoorFeaturesIDs.pictures[e1.indoorEqual.level]
                ] : []), e1.restrictVisibleFeatures("keep", "sequences", e1._indoorFeaturesIDs.sequences[e1.indoorEqual.level] ? [
                    ...e1._indoorFeaturesIDs.sequences[e1.indoorEqual.level]
                ] : []);
            }, s = ()=>{
                a && (clearTimeout(a), a = void 0), a = setTimeout(r, 250);
            };
            e1.indoorEqual.on("levelchange", s);
        } else console.error("The indoor= plugin is not enabled. Please add the maplibre-gl-indoorequal before calling 'indoor' option of Panoramax Viewer.");
    }
}
var $785da19a645c07eb$var$Uc = Object.freeze({
    __proto__: null,
    DISABLED_LEVEL: $785da19a645c07eb$var$Rc,
    initIndoorEqualOnMap: $785da19a645c07eb$var$Oc,
    isIndoorEqualAvailable: $785da19a645c07eb$var$Bc
}), $785da19a645c07eb$var$Nc = Object.create, $785da19a645c07eb$var$jc = Object.defineProperty, $785da19a645c07eb$var$Vc = Object.getOwnPropertyDescriptor, $785da19a645c07eb$var$qc = Object.getOwnPropertyNames, $785da19a645c07eb$var$Gc = Object.getPrototypeOf, $785da19a645c07eb$var$Hc = Object.prototype.hasOwnProperty, $785da19a645c07eb$var$Wc = (e1, t)=>()=>(t || (e1((t = {
            exports: {}
        }).exports, t), e1 = null), t.exports), $785da19a645c07eb$var$Zc = (e1, t, i, n)=>{
    if (t && "object" == typeof t || "function" == typeof t) for(var a, r = $785da19a645c07eb$var$qc(t), s = 0, o = r.length; s < o; s++)a = r[s], !$785da19a645c07eb$var$Hc.call(e1, a) && a !== i && $785da19a645c07eb$var$jc(e1, a, {
        get: ((e1)=>t[e1]).bind(null, a),
        enumerable: !(n = $785da19a645c07eb$var$Vc(t, a)) || n.enumerable
    });
    return e1;
};
/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.9.0/LICENSE.txt
*/ function $785da19a645c07eb$var$Kc(e1, t) {
    this.x = e1, this.y = t;
}
let $785da19a645c07eb$var$Xc, $785da19a645c07eb$var$Qc;
function $785da19a645c07eb$var$Yc() {
    return $785da19a645c07eb$var$Xc ??= typeof OffscreenCanvas < "u" && !!new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap, $785da19a645c07eb$var$Xc;
}
function $785da19a645c07eb$var$Jc() {
    if (null == $785da19a645c07eb$var$Qc && ($785da19a645c07eb$var$Qc = !1, $785da19a645c07eb$var$Yc())) {
        let e1 = new OffscreenCanvas(5, 5).getContext("2d", {
            willReadFrequently: !0
        });
        if (e1) {
            for(let t = 0; t < 25; t++){
                let i = 4 * t;
                e1.fillStyle = `rgb(${i},${i + 1},${i + 2})`, e1.fillRect(t % 5, Math.floor(t / 5), 1, 1);
            }
            let t = e1.getImageData(0, 0, 5, 5).data;
            for(let e1 = 0; e1 < 100; e1++)if (e1 % 4 != 3 && t[e1] !== e1) {
                $785da19a645c07eb$var$Qc = !0;
                break;
            }
        }
    }
    return $785da19a645c07eb$var$Qc || !1;
}
$785da19a645c07eb$var$Kc.prototype = {
    clone () {
        return new $785da19a645c07eb$var$Kc(this.x, this.y);
    },
    add (e1) {
        return this.clone()._add(e1);
    },
    sub (e1) {
        return this.clone()._sub(e1);
    },
    multByPoint (e1) {
        return this.clone()._multByPoint(e1);
    },
    divByPoint (e1) {
        return this.clone()._divByPoint(e1);
    },
    mult (e1) {
        return this.clone()._mult(e1);
    },
    div (e1) {
        return this.clone()._div(e1);
    },
    rotate (e1) {
        return this.clone()._rotate(e1);
    },
    rotateAround (e1, t) {
        return this.clone()._rotateAround(e1, t);
    },
    matMult (e1) {
        return this.clone()._matMult(e1);
    },
    unit () {
        return this.clone()._unit();
    },
    perp () {
        return this.clone()._perp();
    },
    round () {
        return this.clone()._round();
    },
    mag () {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals (e1) {
        return this.x === e1.x && this.y === e1.y;
    },
    dist (e1) {
        return Math.sqrt(this.distSqr(e1));
    },
    distSqr (e1) {
        let t = e1.x - this.x, i = e1.y - this.y;
        return t * t + i * i;
    },
    angle () {
        return Math.atan2(this.y, this.x);
    },
    angleTo (e1) {
        return Math.atan2(this.y - e1.y, this.x - e1.x);
    },
    angleWith (e1) {
        return this.angleWithSep(e1.x, e1.y);
    },
    angleWithSep (e1, t) {
        return Math.atan2(this.x * t - this.y * e1, this.x * e1 + this.y * t);
    },
    _matMult (e1) {
        let t = e1[0] * this.x + e1[1] * this.y, i = e1[2] * this.x + e1[3] * this.y;
        return this.x = t, this.y = i, this;
    },
    _add (e1) {
        return this.x += e1.x, this.y += e1.y, this;
    },
    _sub (e1) {
        return this.x -= e1.x, this.y -= e1.y, this;
    },
    _mult (e1) {
        return this.x *= e1, this.y *= e1, this;
    },
    _div (e1) {
        return this.x /= e1, this.y /= e1, this;
    },
    _multByPoint (e1) {
        return this.x *= e1.x, this.y *= e1.y, this;
    },
    _divByPoint (e1) {
        return this.x /= e1.x, this.y /= e1.y, this;
    },
    _unit () {
        return this._div(this.mag()), this;
    },
    _perp () {
        let e1 = this.y;
        return this.y = this.x, this.x = -e1, this;
    },
    _rotate (e1) {
        let t = Math.cos(e1), i = Math.sin(e1), n = t * this.x - i * this.y, a = i * this.x + t * this.y;
        return this.x = n, this.y = a, this;
    },
    _rotateAround (e1, t) {
        let i = Math.cos(e1), n = Math.sin(e1), a = t.x + i * (this.x - t.x) - n * (this.y - t.y), r = t.y + n * (this.x - t.x) + i * (this.y - t.y);
        return this.x = a, this.y = r, this;
    },
    _round () {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    },
    constructor: $785da19a645c07eb$var$Kc
}, $785da19a645c07eb$var$Kc.convert = function(e1) {
    if (e1 instanceof $785da19a645c07eb$var$Kc) return e1;
    if (Array.isArray(e1)) return new $785da19a645c07eb$var$Kc(+e1[0], +e1[1]);
    if (void 0 !== e1.x && void 0 !== e1.y) return new $785da19a645c07eb$var$Kc(+e1.x, +e1.y);
    throw Error("Expected [x, y] or {x, y} point format");
};
var $785da19a645c07eb$var$$c = typeof Float32Array < "u" ? Float32Array : Array;
function $785da19a645c07eb$var$eu() {
    var e1 = new $785da19a645c07eb$var$$c(9);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
}
function $785da19a645c07eb$var$tu() {
    var e1 = new $785da19a645c07eb$var$$c(16);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
}
function $785da19a645c07eb$var$iu(e1) {
    var t = new $785da19a645c07eb$var$$c(16);
    return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
}
function $785da19a645c07eb$var$nu(e1) {
    return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
}
function $785da19a645c07eb$var$au(e1, t) {
    var i = t[0], n = t[1], a = t[2], r = t[3], s = t[4], o = t[5], l = t[6], c = t[7], u = t[8], h = t[9], d = t[10], p = t[11], m = t[12], g = t[13], f = t[14], A = t[15], _ = i * o - n * s, v = i * l - a * s, y = i * c - r * s, x = n * l - a * o, b = n * c - r * o, w = a * c - r * l, E = u * g - h * m, k = u * f - d * m, S = u * A - p * m, M = h * f - d * g, C = h * A - p * g, T = d * A - p * f, D = _ * T - v * C + y * M + x * S - b * k + w * E;
    return D ? (D = 1 / D, e1[0] = (o * T - l * C + c * M) * D, e1[1] = (a * C - n * T - r * M) * D, e1[2] = (g * w - f * b + A * x) * D, e1[3] = (d * b - h * w - p * x) * D, e1[4] = (l * S - s * T - c * k) * D, e1[5] = (i * T - a * S + r * k) * D, e1[6] = (f * y - m * w - A * v) * D, e1[7] = (u * w - d * y + p * v) * D, e1[8] = (s * C - o * S + c * E) * D, e1[9] = (n * S - i * C - r * E) * D, e1[10] = (m * b - g * y + A * _) * D, e1[11] = (h * y - u * b - p * _) * D, e1[12] = (o * k - s * M - l * E) * D, e1[13] = (i * M - n * k + a * E) * D, e1[14] = (g * v - m * x - f * _) * D, e1[15] = (u * x - h * v + d * _) * D, e1) : null;
}
function $785da19a645c07eb$var$ru(e1, t, i) {
    var n = t[0], a = t[1], r = t[2], s = t[3], o = t[4], l = t[5], c = t[6], u = t[7], h = t[8], d = t[9], p = t[10], m = t[11], g = t[12], f = t[13], A = t[14], _ = t[15], v = i[0], y = i[1], x = i[2], b = i[3];
    return e1[0] = v * n + y * o + x * h + b * g, e1[1] = v * a + y * l + x * d + b * f, e1[2] = v * r + y * c + x * p + b * A, e1[3] = v * s + y * u + x * m + b * _, v = i[4], y = i[5], x = i[6], b = i[7], e1[4] = v * n + y * o + x * h + b * g, e1[5] = v * a + y * l + x * d + b * f, e1[6] = v * r + y * c + x * p + b * A, e1[7] = v * s + y * u + x * m + b * _, v = i[8], y = i[9], x = i[10], b = i[11], e1[8] = v * n + y * o + x * h + b * g, e1[9] = v * a + y * l + x * d + b * f, e1[10] = v * r + y * c + x * p + b * A, e1[11] = v * s + y * u + x * m + b * _, v = i[12], y = i[13], x = i[14], b = i[15], e1[12] = v * n + y * o + x * h + b * g, e1[13] = v * a + y * l + x * d + b * f, e1[14] = v * r + y * c + x * p + b * A, e1[15] = v * s + y * u + x * m + b * _, e1;
}
function $785da19a645c07eb$var$su(e1, t, i) {
    var n, a, r, s, o, l, c, u, h, d, p, m, g = i[0], f = i[1], A = i[2];
    return t === e1 ? (e1[12] = t[0] * g + t[4] * f + t[8] * A + t[12], e1[13] = t[1] * g + t[5] * f + t[9] * A + t[13], e1[14] = t[2] * g + t[6] * f + t[10] * A + t[14], e1[15] = t[3] * g + t[7] * f + t[11] * A + t[15]) : (n = t[0], a = t[1], r = t[2], s = t[3], o = t[4], l = t[5], c = t[6], u = t[7], h = t[8], d = t[9], p = t[10], m = t[11], e1[0] = n, e1[1] = a, e1[2] = r, e1[3] = s, e1[4] = o, e1[5] = l, e1[6] = c, e1[7] = u, e1[8] = h, e1[9] = d, e1[10] = p, e1[11] = m, e1[12] = n * g + o * f + h * A + t[12], e1[13] = a * g + l * f + d * A + t[13], e1[14] = r * g + c * f + p * A + t[14], e1[15] = s * g + u * f + m * A + t[15]), e1;
}
function $785da19a645c07eb$var$ou(e1, t, i) {
    var n = i[0], a = i[1], r = i[2];
    return e1[0] = t[0] * n, e1[1] = t[1] * n, e1[2] = t[2] * n, e1[3] = t[3] * n, e1[4] = t[4] * a, e1[5] = t[5] * a, e1[6] = t[6] * a, e1[7] = t[7] * a, e1[8] = t[8] * r, e1[9] = t[9] * r, e1[10] = t[10] * r, e1[11] = t[11] * r, e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
}
function $785da19a645c07eb$var$lu(e1, t, i) {
    var n = Math.sin(i), a = Math.cos(i), r = t[4], s = t[5], o = t[6], l = t[7], c = t[8], u = t[9], h = t[10], d = t[11];
    return t !== e1 && (e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[4] = r * a + c * n, e1[5] = s * a + u * n, e1[6] = o * a + h * n, e1[7] = l * a + d * n, e1[8] = c * a - r * n, e1[9] = u * a - s * n, e1[10] = h * a - o * n, e1[11] = d * a - l * n, e1;
}
function $785da19a645c07eb$var$cu(e1, t, i) {
    var n = Math.sin(i), a = Math.cos(i), r = t[0], s = t[1], o = t[2], l = t[3], c = t[8], u = t[9], h = t[10], d = t[11];
    return t !== e1 && (e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = r * a - c * n, e1[1] = s * a - u * n, e1[2] = o * a - h * n, e1[3] = l * a - d * n, e1[8] = r * n + c * a, e1[9] = s * n + u * a, e1[10] = o * n + h * a, e1[11] = l * n + d * a, e1;
}
function $785da19a645c07eb$var$uu(e1, t, i) {
    var n = Math.sin(i), a = Math.cos(i), r = t[0], s = t[1], o = t[2], l = t[3], c = t[4], u = t[5], h = t[6], d = t[7];
    return t !== e1 && (e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = r * a + c * n, e1[1] = s * a + u * n, e1[2] = o * a + h * n, e1[3] = l * a + d * n, e1[4] = c * a - r * n, e1[5] = u * a - s * n, e1[6] = h * a - o * n, e1[7] = d * a - l * n, e1;
}
var $785da19a645c07eb$var$hu = function(e1, t, i, n, a) {
    var r = 1 / Math.tan(t / 2);
    if (e1[0] = r / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = r, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != a && a !== 1 / 0) {
        var s = 1 / (n - a);
        e1[10] = (a + n) * s, e1[14] = 2 * a * n * s;
    } else e1[10] = -1, e1[14] = -2 * n;
    return e1;
};
var $785da19a645c07eb$var$du = function(e1, t, i, n, a, r, s) {
    var o = 1 / (t - i), l = 1 / (n - a), c = 1 / (r - s);
    return e1[0] = -2 * o, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * c, e1[11] = 0, e1[12] = (t + i) * o, e1[13] = (a + n) * l, e1[14] = (s + r) * c, e1[15] = 1, e1;
};
function $785da19a645c07eb$var$pu() {
    var e1 = new $785da19a645c07eb$var$$c(3);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
}
function $785da19a645c07eb$var$mu(e1) {
    var t = new $785da19a645c07eb$var$$c(3);
    return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t;
}
function $785da19a645c07eb$var$gu(e1) {
    var t = e1[0], i = e1[1], n = e1[2];
    return Math.sqrt(t * t + i * i + n * n);
}
function $785da19a645c07eb$var$fu(e1, t, i) {
    var n = new $785da19a645c07eb$var$$c(3);
    return n[0] = e1, n[1] = t, n[2] = i, n;
}
function $785da19a645c07eb$var$Au(e1, t, i) {
    return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1;
}
function $785da19a645c07eb$var$_u(e1, t, i) {
    return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1;
}
function $785da19a645c07eb$var$vu(e1, t, i) {
    return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1;
}
function $785da19a645c07eb$var$yu(e1, t, i, n) {
    return e1[0] = t[0] + i[0] * n, e1[1] = t[1] + i[1] * n, e1[2] = t[2] + i[2] * n, e1;
}
function $785da19a645c07eb$var$xu(e1, t) {
    var i = t[0], n = t[1], a = t[2], r = i * i + n * n + a * a;
    return r > 0 && (r = 1 / Math.sqrt(r)), e1[0] = t[0] * r, e1[1] = t[1] * r, e1[2] = t[2] * r, e1;
}
function $785da19a645c07eb$var$bu(e1, t) {
    return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2];
}
function $785da19a645c07eb$var$wu(e1, t, i) {
    var n = t[0], a = t[1], r = t[2], s = i[0], o = i[1], l = i[2];
    return e1[0] = a * l - r * o, e1[1] = r * s - n * l, e1[2] = n * o - a * s, e1;
}
function $785da19a645c07eb$var$Eu(e1, t, i) {
    var n = i[0], a = i[1], r = i[2], s = i[3], o = t[0], l = t[1], c = t[2], u = a * c - r * l, h = r * o - n * c, d = n * l - a * o;
    return u += u, h += h, d += d, e1[0] = o + s * u + a * d - r * h, e1[1] = l + s * h + r * u - n * d, e1[2] = c + s * d + n * h - a * u, e1;
}
function $785da19a645c07eb$var$ku(e1, t, i, n) {
    var a = [], r = [];
    return a[0] = t[0] - i[0], a[1] = t[1] - i[1], a[2] = t[2] - i[2], r[0] = a[0], r[1] = a[1] * Math.cos(n) - a[2] * Math.sin(n), r[2] = a[1] * Math.sin(n) + a[2] * Math.cos(n), e1[0] = r[0] + i[0], e1[1] = r[1] + i[1], e1[2] = r[2] + i[2], e1;
}
function $785da19a645c07eb$var$Su(e1, t, i, n) {
    var a = [], r = [];
    return a[0] = t[0] - i[0], a[1] = t[1] - i[1], a[2] = t[2] - i[2], r[0] = a[2] * Math.sin(n) + a[0] * Math.cos(n), r[1] = a[1], r[2] = a[2] * Math.cos(n) - a[0] * Math.sin(n), e1[0] = r[0] + i[0], e1[1] = r[1] + i[1], e1[2] = r[2] + i[2], e1;
}
function $785da19a645c07eb$var$Mu(e1, t, i, n) {
    var a = [], r = [];
    return a[0] = t[0] - i[0], a[1] = t[1] - i[1], a[2] = t[2] - i[2], r[0] = a[0] * Math.cos(n) - a[1] * Math.sin(n), r[1] = a[0] * Math.sin(n) + a[1] * Math.cos(n), r[2] = a[2], e1[0] = r[0] + i[0], e1[1] = r[1] + i[1], e1[2] = r[2] + i[2], e1;
}
var $785da19a645c07eb$var$Cu = $785da19a645c07eb$var$_u, $785da19a645c07eb$var$Tu = $785da19a645c07eb$var$gu;
function $785da19a645c07eb$var$Du(e1, t, i) {
    var n = t[0], a = t[1], r = t[2], s = t[3];
    return e1[0] = i[0] * n + i[4] * a + i[8] * r + i[12] * s, e1[1] = i[1] * n + i[5] * a + i[9] * r + i[13] * s, e1[2] = i[2] * n + i[6] * a + i[10] * r + i[14] * s, e1[3] = i[3] * n + i[7] * a + i[11] * r + i[15] * s, e1;
}
!function() {
    var e1 = $785da19a645c07eb$var$pu();
}();
var $785da19a645c07eb$var$Pu = function(e1, t, i) {
    return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1[2] = t[2] * i[2], e1[3] = t[3] * i[3], e1;
};
function $785da19a645c07eb$var$Iu() {
    var e1 = new $785da19a645c07eb$var$$c(4);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
}
function $785da19a645c07eb$var$Fu(e1, t, i, n) {
    var a, r, s, o, l = t[0], c = t[1], u = t[2], h = t[3], d = i[0], p = i[1], m = i[2], g = i[3], f = l * d + c * p + u * m + h * g;
    return f < 0 && (f = -f, d = -d, p = -p, m = -m, g = -g), 1 - f > 1e-6 ? (a = Math.acos(f), r = Math.sin(a), s = Math.sin((1 - n) * a) / r, o = Math.sin(n * a) / r) : (s = 1 - n, o = n), e1[0] = s * l + o * d, e1[1] = s * c + o * p, e1[2] = s * u + o * m, e1[3] = s * h + o * g, e1;
}
function $785da19a645c07eb$var$zu(e1, t, i, n) {
    var a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", r = Math.PI / 360;
    t *= r, n *= r, i *= r;
    var s = Math.sin(t), o = Math.cos(t), l = Math.sin(i), c = Math.cos(i), u = Math.sin(n), h = Math.cos(n);
    switch(a){
        case "xyz":
            e1[0] = s * c * h + o * l * u, e1[1] = o * l * h - s * c * u, e1[2] = o * c * u + s * l * h, e1[3] = o * c * h - s * l * u;
            break;
        case "xzy":
            e1[0] = s * c * h - o * l * u, e1[1] = o * l * h - s * c * u, e1[2] = o * c * u + s * l * h, e1[3] = o * c * h + s * l * u;
            break;
        case "yxz":
            e1[0] = s * c * h + o * l * u, e1[1] = o * l * h - s * c * u, e1[2] = o * c * u - s * l * h, e1[3] = o * c * h + s * l * u;
            break;
        case "yzx":
            e1[0] = s * c * h + o * l * u, e1[1] = o * l * h + s * c * u, e1[2] = o * c * u - s * l * h, e1[3] = o * c * h - s * l * u;
            break;
        case "zxy":
            e1[0] = s * c * h - o * l * u, e1[1] = o * l * h + s * c * u, e1[2] = o * c * u + s * l * h, e1[3] = o * c * h - s * l * u;
            break;
        case "zyx":
            e1[0] = s * c * h - o * l * u, e1[1] = o * l * h + s * c * u, e1[2] = o * c * u - s * l * h, e1[3] = o * c * h + s * l * u;
            break;
        default:
            throw Error("Unknown angle order " + a);
    }
    return e1;
}
!function() {
    var e1 = function() {
        var e1 = new $785da19a645c07eb$var$$c(4);
        return $785da19a645c07eb$var$$c != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
    }();
}();
var $785da19a645c07eb$var$Ru = function(e1, t, i, n) {
    var a = new $785da19a645c07eb$var$$c(4);
    return a[0] = e1, a[1] = t, a[2] = i, a[3] = n, a;
};
function $785da19a645c07eb$var$Lu() {
    var e1 = new $785da19a645c07eb$var$$c(2);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
}
function $785da19a645c07eb$var$Bu(e1, t) {
    var i = new $785da19a645c07eb$var$$c(2);
    return i[0] = e1, i[1] = t, i;
}
function $785da19a645c07eb$var$Ou(e1, t, i) {
    return e1[0] = t[0] * i, e1[1] = t[1] * i, e1;
}
function $785da19a645c07eb$var$Uu(e1) {
    var t = e1[0], i = e1[1];
    return Math.sqrt(t * t + i * i);
}
function $785da19a645c07eb$var$Nu(e1) {
    return e1[0] = 0, e1[1] = 0, e1;
}
(function() {
    var e1 = $785da19a645c07eb$var$pu(), t = $785da19a645c07eb$var$fu(1, 0, 0), i = $785da19a645c07eb$var$fu(0, 1, 0);
})(), function() {
    var e1 = $785da19a645c07eb$var$Iu(), t = $785da19a645c07eb$var$Iu();
}(), function() {
    var e1 = $785da19a645c07eb$var$eu();
}();
var $785da19a645c07eb$var$ju = function(e1) {
    var t = e1[0], i = e1[1];
    return t * t + i * i;
};
!function() {
    var e1 = $785da19a645c07eb$var$Lu();
}();
const $785da19a645c07eb$var$Vu = 8192;
function $785da19a645c07eb$var$qu(e1, t, i) {
    return t * ($785da19a645c07eb$var$Vu / (e1.tileSize * 2 ** (i - e1.tileID.overscaledZ)));
}
function $785da19a645c07eb$var$Gu(e1) {
    return e1 instanceof Error ? e1 : Error("string" == typeof e1 ? e1 : String(e1));
}
function $785da19a645c07eb$var$Hu() {
    return new Float64Array(4);
}
function $785da19a645c07eb$var$Wu() {
    return new Float64Array(3);
}
function $785da19a645c07eb$var$Zu() {
    return new Float64Array(16);
}
function $785da19a645c07eb$var$Ku() {
    let e1 = new Float64Array(16);
    return $785da19a645c07eb$var$nu(e1), e1;
}
function $785da19a645c07eb$var$Xu() {
    let e1 = new Float32Array(16);
    return $785da19a645c07eb$var$nu(e1), e1;
}
function $785da19a645c07eb$var$Qu(e1, t, i, n, a = !1) {
    if (!i[0] && !i[1]) return [
        0,
        0
    ];
    let r = a ? "map" === n ? -e1.bearingInRadians : 0 : "viewport" === n ? e1.bearingInRadians : 0;
    if (r) {
        let e1 = Math.sin(r), t = Math.cos(r);
        i = [
            i[0] * t - i[1] * e1,
            i[0] * e1 + i[1] * t
        ];
    }
    return [
        a ? i[0] : $785da19a645c07eb$var$qu(t, i[0], e1.zoom),
        a ? i[1] : $785da19a645c07eb$var$qu(t, i[1], e1.zoom)
    ];
}
function $785da19a645c07eb$var$Yu(e1, t) {
    return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3];
}
function $785da19a645c07eb$var$Ju(e1, t, i) {
    let n = function(e1) {
        var t = e1[0], i = e1[1], n = e1[2], a = e1[3], r = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
        return t * (c * r - s * l) + i * (-c * a + s * o) + n * (l * a - r * o);
    }([
        e1[0],
        e1[1],
        e1[2],
        t[0],
        t[1],
        t[2],
        i[0],
        i[1],
        i[2]
    ]);
    if (0 === n) return null;
    let a = $785da19a645c07eb$var$wu([], [
        t[0],
        t[1],
        t[2]
    ], [
        i[0],
        i[1],
        i[2]
    ]), r = $785da19a645c07eb$var$wu([], [
        i[0],
        i[1],
        i[2]
    ], [
        e1[0],
        e1[1],
        e1[2]
    ]), s = $785da19a645c07eb$var$wu([], [
        e1[0],
        e1[1],
        e1[2]
    ], [
        t[0],
        t[1],
        t[2]
    ]), o = $785da19a645c07eb$var$vu([], a, -e1[3]);
    return $785da19a645c07eb$var$Au(o, o, $785da19a645c07eb$var$vu([], r, -t[3])), $785da19a645c07eb$var$Au(o, o, $785da19a645c07eb$var$vu([], s, -i[3])), $785da19a645c07eb$var$vu(o, o, 1 / n), o;
}
function $785da19a645c07eb$var$$u(e1, t, i) {
    let n = e1[0] * i[0] + e1[1] * i[1] + e1[2] * i[2], a = t[0] * i[0] + t[1] * i[1] + t[2] * i[2];
    return 0 === a ? null : (-n - i[3]) / a;
}
function $785da19a645c07eb$var$eh(e1, t, i, n) {
    let a = Math.sqrt(e1 * e1 + t * t), r = Math.sqrt(i * i + n * n), s = (e1 /= a) * (i /= r) + (t /= a) * (n /= r), o = Math.acos(s);
    return -t * i + e1 * n > 0 ? o : -o;
}
function $785da19a645c07eb$var$th(e1, t) {
    let i = $785da19a645c07eb$var$nh(e1, 360), n = $785da19a645c07eb$var$nh(t, 360), a = n - i, r = n > i ? a - 360 : a + 360;
    return Math.abs(a) < Math.abs(r) ? a : r;
}
function $785da19a645c07eb$var$ih(e1, t) {
    let i = $785da19a645c07eb$var$nh(e1, 2 * Math.PI), n = $785da19a645c07eb$var$nh(t, 2 * Math.PI);
    return Math.min(Math.abs(i - n), Math.abs(i - n + 2 * Math.PI), Math.abs(i - n - 2 * Math.PI));
}
function $785da19a645c07eb$var$nh(e1, t) {
    return (e1 % t + t) % t;
}
function $785da19a645c07eb$var$ah(e1, t, i, n, a) {
    return $785da19a645c07eb$var$rh(n, a, $785da19a645c07eb$var$ch((e1 - t) / (i - t), 0, 1));
}
function $785da19a645c07eb$var$rh(e1, t, i) {
    return e1 * (1 - i) + t * i;
}
function $785da19a645c07eb$var$sh(e1) {
    let t = 1 / 0, i = 1 / 0, n = -1 / 0, a = -1 / 0;
    for (let r of e1)t = Math.min(t, r.x), i = Math.min(i, r.y), n = Math.max(n, r.x), a = Math.max(a, r.y);
    return [
        t,
        i,
        n,
        a
    ];
}
function $785da19a645c07eb$var$oh(e1, t, i, n) {
    return function(e1, t, i, n) {
        let a = 3 * e1, r = 3 * (i - e1) - a, s = 1 - a - r, o = 3 * t, l = 3 * (n - t) - o, c = 1 - o - l;
        return function(e1, t = 1e-6) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            let i = e1;
            for(let n = 0; n < 8; n++){
                let n = ((s * i + r) * i + a) * i - e1;
                if (Math.abs(n) < t) return ((c * i + l) * i + o) * i;
                let u = (3 * s * i + 2 * r) * i + a;
                if (Math.abs(u) < 1e-6) break;
                i -= n / u;
            }
            let n = 0, u = 1;
            i = e1;
            for(let o = 0; o < 20; o++){
                let o = ((s * i + r) * i + a) * i;
                if (Math.abs(o - e1) < t) break;
                e1 > o ? n = i : u = i, i = .5 * (n + u);
            }
            return ((c * i + l) * i + o) * i;
        };
    }(e1, t, i, n);
}
const $785da19a645c07eb$var$lh = $785da19a645c07eb$var$oh(.25, .1, .25, 1);
function $785da19a645c07eb$var$ch(e1, t, i) {
    return Math.min(i, Math.max(t, e1));
}
function $785da19a645c07eb$var$uh(e1, t, i) {
    let n = i - t, a = ((e1 - t) % n + n) % n + t;
    return a === t ? i : a;
}
function $785da19a645c07eb$var$hh(e1, ...t) {
    for (let i of t)for(let t in i)e1[t] = i[t];
    return e1;
}
function $785da19a645c07eb$var$dh(e1, t) {
    let i = {};
    for (let n of t)n in e1 && (i[n] = e1[n]);
    return i;
}
let $785da19a645c07eb$var$ph = 1;
function $785da19a645c07eb$var$mh() {
    return $785da19a645c07eb$var$ph++;
}
function $785da19a645c07eb$var$gh(e1) {
    return 2 ** e1;
}
function $785da19a645c07eb$var$fh(e1) {
    return Math.log(e1) / Math.LN2;
}
function $785da19a645c07eb$var$Ah(e1, t, i) {
    if (t <= 0) return e1;
    let n = 1 / t;
    return void 0 === i || Math.abs(i) < 1e-10 ? Math.round(e1 * n) / n : (i > 0 ? Math.ceil(e1 * n - 1e-9) : Math.floor(e1 * n + 1e-10)) / n;
}
function $785da19a645c07eb$var$_h(e1, t, i) {
    let n = {};
    for(let i in e1)n[i] = t.call(this, e1[i], i, e1);
    return n;
}
function $785da19a645c07eb$var$vh(e1, t, i) {
    let n = {};
    for(let i in e1)t.call(this, e1[i], i, e1) && (n[i] = e1[i]);
    return n;
}
function $785da19a645c07eb$var$yh(e1, t) {
    if (Array.isArray(e1)) {
        if (!Array.isArray(t) || e1.length !== t.length) return !1;
        for(let i = 0; i < e1.length; i++)if (!$785da19a645c07eb$var$yh(e1[i], t[i])) return !1;
        return !0;
    }
    if ("object" == typeof e1 && e1 && null !== t) {
        if ("object" != typeof t || Object.keys(e1).length !== Object.keys(t).length) return !1;
        for(let i in e1)if (!$785da19a645c07eb$var$yh(e1[i], t[i])) return !1;
        return !0;
    }
    return e1 === t;
}
function $785da19a645c07eb$var$xh(e1) {
    return Array.isArray(e1) ? e1.map($785da19a645c07eb$var$xh) : "object" == typeof e1 && e1 ? $785da19a645c07eb$var$_h(e1, $785da19a645c07eb$var$xh) : e1;
}
const $785da19a645c07eb$var$bh = {};
function $785da19a645c07eb$var$wh(e1) {
    $785da19a645c07eb$var$bh[e1] || (typeof console < "u" && console.warn(e1), $785da19a645c07eb$var$bh[e1] = !0);
}
function $785da19a645c07eb$var$Eh(e1, t, i) {
    return (i.y - e1.y) * (t.x - e1.x) > (t.y - e1.y) * (i.x - e1.x);
}
function $785da19a645c07eb$var$kh(e1) {
    return typeof WorkerGlobalScope < "u" && void 0 !== e1 && e1 instanceof WorkerGlobalScope;
}
let $785da19a645c07eb$var$Sh = null;
function $785da19a645c07eb$var$Mh(e1) {
    return typeof ImageBitmap < "u" && e1 instanceof ImageBitmap;
}
async function $785da19a645c07eb$var$Ch(e1, t, i, n, a) {
    if (typeof VideoFrame > "u") throw Error("VideoFrame not supported");
    let r = new VideoFrame(e1, {
        timestamp: 0
    });
    try {
        let s = r?.format;
        if (!s || !s.startsWith("BGR") && !s.startsWith("RGB")) throw Error(`Unrecognized format ${s}`);
        let o = s.startsWith("BGR"), l = new Uint8ClampedArray(n * a * 4);
        if (await r.copyTo(l, function(e1, t, i, n, a) {
            let r = 4 * Math.max(-t, 0), s = (Math.max(0, i) - i) * n * 4 + r, o = 4 * n, l = Math.max(0, t), c = Math.max(0, i);
            return {
                rect: {
                    x: l,
                    y: c,
                    width: Math.min(e1.width, t + n) - l,
                    height: Math.min(e1.height, i + a) - c
                },
                layout: [
                    {
                        offset: s,
                        stride: o
                    }
                ]
            };
        }(e1, t, i, n, a)), o) for(let e1 = 0; e1 < l.length; e1 += 4){
            let t = l[e1];
            l[e1] = l[e1 + 2], l[e1 + 2] = t;
        }
        return l;
    } finally{
        r.close();
    }
}
function $785da19a645c07eb$var$Th(e1, t, i, n) {
    return e1.addEventListener(t, i, n), {
        unsubscribe: ()=>{
            e1.removeEventListener(t, i, n);
        }
    };
}
function $785da19a645c07eb$var$Dh(e1) {
    return e1 * Math.PI / 180;
}
function $785da19a645c07eb$var$Ph(e1) {
    return e1 / Math.PI * 180;
}
function $785da19a645c07eb$var$Ih(e1, t) {
    return e1.roll == t.roll && e1.pitch == t.pitch && e1.bearing == t.bearing;
}
function $785da19a645c07eb$var$Fh(e1, t, i) {
    let n = $785da19a645c07eb$var$Bu(t.x - i.x, t.y - i.y), a = $785da19a645c07eb$var$Bu(e1.x - i.x, e1.y - i.y), r = n[0] * a[1] - n[1] * a[0];
    return $785da19a645c07eb$var$Ph(Math.atan2(r, function(e1, t) {
        return e1[0] * t[0] + e1[1] * t[1];
    }(n, a)));
}
function $785da19a645c07eb$var$zh(e1, t, i) {
    let n = new Float64Array(4);
    return $785da19a645c07eb$var$zu(n, e1, t - 90, i), n;
}
const $785da19a645c07eb$var$Rh = 85.051129, $785da19a645c07eb$var$Lh = {
    touchstart: !0,
    touchmove: !0,
    touchmoveWindow: !0,
    touchend: !0,
    touchcancel: !0
}, $785da19a645c07eb$var$Bh = {
    dblclick: !0,
    click: !0,
    mouseover: !0,
    mouseout: !0,
    mousedown: !0,
    mousemove: !0,
    mousemoveWindow: !0,
    mouseup: !0,
    mouseupWindow: !0,
    contextmenu: !0,
    wheel: !0
};
function $785da19a645c07eb$var$Oh(e1, t) {
    return $785da19a645c07eb$var$Lh[t] && "touches" in e1;
}
function $785da19a645c07eb$var$Uh(e1, t) {
    if (!$785da19a645c07eb$var$Bh[t]) return !1;
    let i = e1, n = i?.target?.ownerDocument?.defaultView || window;
    return i instanceof n.MouseEvent || i instanceof n.WheelEvent;
}
function $785da19a645c07eb$var$Nh(e1) {
    return $785da19a645c07eb$var$Lh[e1] || $785da19a645c07eb$var$Bh[e1];
}
const $785da19a645c07eb$var$jh = "AbortError";
var $785da19a645c07eb$var$Vh = class extends Error {
    constructor(e1 = $785da19a645c07eb$var$jh){
        super(e1 instanceof Error ? e1.message : e1), this.name = $785da19a645c07eb$var$jh, e1 instanceof Error && e1.stack && (this.stack = e1.stack);
    }
};
function $785da19a645c07eb$var$qh(e1) {
    return e1 instanceof Error && "AbortError" === e1.name;
}
function $785da19a645c07eb$var$Gh(e1) {
    if (e1.aborted) throw new $785da19a645c07eb$var$Vh(e1.reason);
}
const $785da19a645c07eb$var$Hh = {
    MAX_PARALLEL_IMAGE_REQUESTS: 16,
    MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
    MAX_TILE_CACHE_ZOOM_LEVELS: 5,
    REGISTERED_PROTOCOLS: {},
    WORKER_URL: ""
};
function $785da19a645c07eb$var$Wh(e1) {
    return $785da19a645c07eb$var$Hh.REGISTERED_PROTOCOLS[e1.substring(0, e1.indexOf("://"))];
}
function $785da19a645c07eb$var$Zh(e1, t) {
    $785da19a645c07eb$var$Hh.REGISTERED_PROTOCOLS[e1] = t;
}
const $785da19a645c07eb$var$Kh = "global-dispatcher";
var $785da19a645c07eb$var$Xh = class extends Error {
    constructor(e1, t, i, n){
        super(`AJAXError: ${t} (${e1}): ${i}`), this.status = e1, this.statusText = t, this.url = i, this.body = n;
    }
};
function $785da19a645c07eb$var$Qh() {
    if ($785da19a645c07eb$var$kh(self)) return self.worker?.referrer;
    if ("blob:" === window.location.protocol) try {
        return window.parent.location.href;
    } catch  {}
    return window.location.href;
}
const $785da19a645c07eb$var$Yh = async function(e1, t) {
    if (e1.url.includes("://") && !/^https?:|^file:/.test(e1.url)) {
        let i = $785da19a645c07eb$var$Wh(e1.url);
        if (i) {
            let n = await i(e1, t);
            return n.data || "arrayBuffer" !== e1.type ? n : $785da19a645c07eb$var$hh(n, {
                data: new ArrayBuffer(0)
            });
        }
        if ($785da19a645c07eb$var$kh(self) && self.worker?.actor) return self.worker.actor.sendAsync({
            type: "GR",
            data: e1,
            targetMapId: $785da19a645c07eb$var$Kh
        }, t);
    }
    if (!((e1)=>e1.startsWith("file:") || $785da19a645c07eb$var$Qh()?.startsWith("file:") && !/^\w+:/.test(e1))(e1.url)) {
        if (fetch && Request && AbortController && Object.hasOwn(Request.prototype, "signal")) return async function(e1, t) {
            let i, n, a = new Request(e1.url, {
                method: e1.method || "GET",
                body: e1.body,
                credentials: e1.credentials,
                headers: e1.headers,
                cache: e1.cache,
                referrer: $785da19a645c07eb$var$Qh(),
                referrerPolicy: e1.referrerPolicy,
                signal: t.signal
            });
            "json" === e1.type && !a.headers.has("Accept") && a.headers.set("Accept", "application/json");
            try {
                i = await fetch(a);
            } catch (t) {
                throw $785da19a645c07eb$var$qh(t) ? t : new $785da19a645c07eb$var$Xh(0, $785da19a645c07eb$var$Gu(t).message, e1.url, new Blob);
            }
            if (!i.ok) {
                let t = await i.blob();
                throw new $785da19a645c07eb$var$Xh(i.status, i.statusText, e1.url, t);
            }
            n = "arrayBuffer" === e1.type || "image" === e1.type ? i.arrayBuffer() : "json" === e1.type ? i.json() : i.text();
            let r = await n;
            return $785da19a645c07eb$var$Gh(t.signal), {
                data: r,
                cacheControl: i.headers.get("Cache-Control"),
                expires: i.headers.get("Expires"),
                etag: i.headers.get("ETag")
            };
        }(e1, t);
        if ($785da19a645c07eb$var$kh(self) && self.worker?.actor) return self.worker.actor.sendAsync({
            type: "GR",
            data: e1,
            mustQueue: !0,
            targetMapId: $785da19a645c07eb$var$Kh
        }, t);
    }
    return function(e1, t) {
        return new Promise((i, n)=>{
            let a = new XMLHttpRequest;
            a.open(e1.method || "GET", e1.url, !0), ("arrayBuffer" === e1.type || "image" === e1.type) && (a.responseType = "arraybuffer");
            for(let t in e1.headers)a.setRequestHeader(t, e1.headers[t]);
            "json" === e1.type && (a.responseType = "text", e1.headers?.Accept || a.setRequestHeader("Accept", "application/json")), a.withCredentials = "include" === e1.credentials, a.onerror = ()=>{
                n(Error(a.statusText));
            }, a.onload = ()=>{
                if (!t.signal.aborted) {
                    if ((a.status >= 200 && a.status < 300 || 0 === a.status) && null !== a.response) {
                        let t = a.response;
                        if ("json" === e1.type) try {
                            t = JSON.parse(a.response);
                        } catch (e1) {
                            return void n(e1);
                        }
                        i({
                            data: t,
                            cacheControl: a.getResponseHeader("Cache-Control"),
                            expires: a.getResponseHeader("Expires"),
                            etag: a.getResponseHeader("ETag")
                        });
                    } else {
                        let t = new Blob([
                            a.response
                        ], {
                            type: a.getResponseHeader("Content-Type")
                        });
                        n(new $785da19a645c07eb$var$Xh(a.status, a.statusText, e1.url, t));
                    }
                }
            }, t.signal.addEventListener("abort", ()=>{
                a.abort(), n(new $785da19a645c07eb$var$Vh(t.signal.reason));
            }), a.send(e1.body);
        });
    }(e1, t);
}, $785da19a645c07eb$var$Jh = (e1, t)=>$785da19a645c07eb$var$Yh($785da19a645c07eb$var$hh(e1, {
        type: "json"
    }), t), $785da19a645c07eb$var$$h = (e1, t)=>$785da19a645c07eb$var$Yh($785da19a645c07eb$var$hh(e1, {
        type: "arrayBuffer"
    }), t);
function $785da19a645c07eb$var$ed(e1) {
    if (!e1 || e1.startsWith("data:image/")) return !0;
    if (e1.startsWith("blob:") && (e1 = e1.slice(5)).startsWith("null")) return !1;
    if (e1.indexOf("://") <= 0) return !0;
    let t = new URL(e1), i = window.location;
    return t.protocol === i.protocol && t.host === i.host;
}
function $785da19a645c07eb$var$td(e1, t, i) {
    i[e1]?.includes(t) || (i[e1] ||= [], i[e1].push(t));
}
function $785da19a645c07eb$var$id(e1, t, i) {
    if (i?.[e1]) {
        let n = i[e1].indexOf(t);
        -1 !== n && i[e1].splice(n, 1);
    }
}
var $785da19a645c07eb$var$nd = class {
    constructor(e1, t = {}){
        $785da19a645c07eb$var$hh(this, t), this.type = e1;
    }
}, $785da19a645c07eb$var$ad = class extends $785da19a645c07eb$var$nd {
    constructor(e1, t = {}){
        super("error", $785da19a645c07eb$var$hh({
            error: e1
        }, t));
    }
}, $785da19a645c07eb$var$rd = class {
    on(e1, t) {
        return this._listeners ||= {}, $785da19a645c07eb$var$td(e1, t, this._listeners), {
            unsubscribe: ()=>{
                this.off(e1, t);
            }
        };
    }
    off(e1, t) {
        return $785da19a645c07eb$var$id(e1, t, this._listeners), $785da19a645c07eb$var$id(e1, t, this._oneTimeListeners), this;
    }
    once(e1, t) {
        return t ? (this._oneTimeListeners ||= {}, $785da19a645c07eb$var$td(e1, t, this._oneTimeListeners), this) : new Promise((t)=>this.once(e1, t));
    }
    fire(e1, t) {
        let i = "string" == typeof e1 ? new $785da19a645c07eb$var$nd(e1, t || {}) : e1, n = i.type;
        if (this.listens(n)) {
            i.target = this;
            let e1 = this._listeners?.[n]?.slice() ?? [];
            for (let t of e1)t.call(this, i);
            let t = this._oneTimeListeners?.[n]?.slice() ?? [];
            for (let e1 of t)$785da19a645c07eb$var$id(n, e1, this._oneTimeListeners), e1.call(this, i);
            let a = this._eventedParent;
            a && ($785da19a645c07eb$var$hh(i, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), a.fire(i));
        } else i instanceof $785da19a645c07eb$var$ad && console.error(i.error);
        return this;
    }
    listens(e1) {
        return !!(this._listeners?.[e1]?.length || this._oneTimeListeners?.[e1]?.length || this._eventedParent?.listens(e1));
    }
    setEventedParent(e1, t) {
        return this._eventedParent = e1, this._eventedParentData = t, this;
    }
}, $785da19a645c07eb$var$sd = {
    $version: 8,
    $root: {
        version: {
            required: !0,
            type: "enum",
            values: [
                8
            ]
        },
        name: {
            type: "string"
        },
        metadata: {
            type: "*"
        },
        center: {
            type: "array",
            value: "number",
            length: 2
        },
        centerAltitude: {
            type: "number"
        },
        zoom: {
            type: "number"
        },
        bearing: {
            type: "number",
            default: 0,
            period: 360,
            units: "degrees"
        },
        pitch: {
            type: "number",
            default: 0,
            units: "degrees"
        },
        roll: {
            type: "number",
            default: 0,
            units: "degrees"
        },
        state: {
            type: "state",
            default: {}
        },
        light: {
            type: "light"
        },
        sky: {
            type: "sky"
        },
        projection: {
            type: "projection"
        },
        terrain: {
            type: "terrain"
        },
        sources: {
            required: !0,
            type: "sources"
        },
        sprite: {
            type: "sprite"
        },
        glyphs: {
            type: "string"
        },
        "font-faces": {
            type: "fontFaces"
        },
        transition: {
            type: "transition"
        },
        layers: {
            required: !0,
            type: "array",
            value: "layer"
        }
    },
    sources: {
        "*": {
            type: "source"
        }
    },
    source: [
        "source_vector",
        "source_raster",
        "source_raster_dem",
        "source_geojson",
        "source_video",
        "source_image"
    ],
    source_vector: {
        type: {
            required: !0,
            type: "enum",
            values: {
                vector: {}
            }
        },
        url: {
            type: "string"
        },
        tiles: {
            type: "array",
            value: "string"
        },
        bounds: {
            type: "array",
            value: "number",
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        scheme: {
            type: "enum",
            values: {
                xyz: {},
                tms: {}
            },
            default: "xyz"
        },
        minzoom: {
            type: "number",
            default: 0
        },
        maxzoom: {
            type: "number",
            default: 22
        },
        attribution: {
            type: "string"
        },
        promoteId: {
            type: "promoteId"
        },
        volatile: {
            type: "boolean",
            default: !1
        },
        encoding: {
            type: "enum",
            values: {
                mvt: {},
                mlt: {}
            },
            default: "mvt"
        },
        "*": {
            type: "*"
        }
    },
    source_raster: {
        type: {
            required: !0,
            type: "enum",
            values: {
                raster: {}
            }
        },
        url: {
            type: "string"
        },
        tiles: {
            type: "array",
            value: "string"
        },
        bounds: {
            type: "array",
            value: "number",
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        minzoom: {
            type: "number",
            default: 0
        },
        maxzoom: {
            type: "number",
            default: 22
        },
        tileSize: {
            type: "number",
            default: 512,
            units: "pixels"
        },
        scheme: {
            type: "enum",
            values: {
                xyz: {},
                tms: {}
            },
            default: "xyz"
        },
        attribution: {
            type: "string"
        },
        volatile: {
            type: "boolean",
            default: !1
        },
        "*": {
            type: "*"
        }
    },
    source_raster_dem: {
        type: {
            required: !0,
            type: "enum",
            values: {
                "raster-dem": {}
            }
        },
        url: {
            type: "string"
        },
        tiles: {
            type: "array",
            value: "string"
        },
        bounds: {
            type: "array",
            value: "number",
            length: 4,
            default: [
                -180,
                -85.051129,
                180,
                85.051129
            ]
        },
        minzoom: {
            type: "number",
            default: 0
        },
        maxzoom: {
            type: "number",
            default: 22
        },
        tileSize: {
            type: "number",
            default: 512,
            units: "pixels"
        },
        attribution: {
            type: "string"
        },
        encoding: {
            type: "enum",
            values: {
                terrarium: {},
                mapbox: {},
                custom: {}
            },
            default: "mapbox"
        },
        redFactor: {
            type: "number",
            default: 1
        },
        blueFactor: {
            type: "number",
            default: 1
        },
        greenFactor: {
            type: "number",
            default: 1
        },
        baseShift: {
            type: "number",
            default: 0
        },
        volatile: {
            type: "boolean",
            default: !1
        },
        "*": {
            type: "*"
        }
    },
    source_geojson: {
        type: {
            required: !0,
            type: "enum",
            values: {
                geojson: {}
            }
        },
        data: {
            required: !0,
            type: "*"
        },
        maxzoom: {
            type: "number",
            default: 18
        },
        attribution: {
            type: "string"
        },
        buffer: {
            type: "number",
            default: 128,
            maximum: 512,
            minimum: 0
        },
        filter: {
            type: "filter"
        },
        tolerance: {
            type: "number",
            default: .375
        },
        cluster: {
            type: "boolean",
            default: !1
        },
        clusterRadius: {
            type: "number",
            default: 50,
            minimum: 0
        },
        clusterMaxZoom: {
            type: "number"
        },
        clusterMinPoints: {
            type: "number"
        },
        clusterProperties: {
            type: "*"
        },
        lineMetrics: {
            type: "boolean",
            default: !1
        },
        generateId: {
            type: "boolean",
            default: !1
        },
        promoteId: {
            type: "promoteId"
        }
    },
    source_video: {
        type: {
            required: !0,
            type: "enum",
            values: {
                video: {}
            }
        },
        urls: {
            required: !0,
            type: "array",
            value: "string"
        },
        coordinates: {
            required: !0,
            type: "array",
            length: 4,
            value: {
                type: "array",
                length: 2,
                value: "number"
            }
        }
    },
    source_image: {
        type: {
            required: !0,
            type: "enum",
            values: {
                image: {}
            }
        },
        url: {
            type: "string"
        },
        coordinates: {
            required: !0,
            type: "array",
            length: 4,
            value: {
                type: "array",
                length: 2,
                value: "number"
            }
        }
    },
    layer: {
        id: {
            type: "string",
            required: !0
        },
        type: {
            type: "enum",
            values: {
                fill: {},
                line: {},
                symbol: {},
                circle: {},
                heatmap: {},
                "fill-extrusion": {},
                raster: {},
                hillshade: {},
                "color-relief": {},
                background: {}
            },
            required: !0
        },
        metadata: {
            type: "*"
        },
        source: {
            type: "string"
        },
        "source-layer": {
            type: "string"
        },
        minzoom: {
            type: "number",
            minimum: 0,
            maximum: 24
        },
        maxzoom: {
            type: "number",
            minimum: 0,
            maximum: 24
        },
        filter: {
            type: "filter"
        },
        layout: {
            type: "layout"
        },
        paint: {
            type: "paint"
        }
    },
    layout: [
        "layout_fill",
        "layout_line",
        "layout_circle",
        "layout_heatmap",
        "layout_fill-extrusion",
        "layout_symbol",
        "layout_raster",
        "layout_hillshade",
        "layout_color-relief",
        "layout_background"
    ],
    layout_background: {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_fill: {
        "fill-sort-key": {
            type: "number",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_circle: {
        "circle-sort-key": {
            type: "number",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_heatmap: {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    "layout_fill-extrusion": {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-rounded-corner-distance": {
            type: "number",
            default: 0,
            minimum: 0,
            units: "meters",
            "property-type": "constant"
        }
    },
    layout_line: {
        "line-cap": {
            type: "enum",
            values: {
                butt: {},
                round: {},
                square: {}
            },
            default: "butt",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "line-join": {
            type: "enum",
            values: {
                bevel: {},
                round: {},
                miter: {}
            },
            default: "miter",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "line-miter-limit": {
            type: "number",
            default: 2,
            requires: [
                {
                    "line-join": "miter"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "line-round-limit": {
            type: "number",
            default: 1.05,
            requires: [
                {
                    "line-join": "round"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "line-sort-key": {
            type: "number",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_symbol: {
        "symbol-placement": {
            type: "enum",
            values: {
                point: {},
                line: {},
                "line-center": {}
            },
            default: "point",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "symbol-spacing": {
            type: "number",
            default: 250,
            minimum: 1,
            units: "pixels",
            requires: [
                {
                    "symbol-placement": "line"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "symbol-avoid-edges": {
            type: "boolean",
            default: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "symbol-sort-key": {
            type: "number",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "symbol-z-order": {
            type: "enum",
            values: {
                auto: {},
                "viewport-y": {},
                source: {}
            },
            default: "auto",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-allow-overlap": {
            type: "boolean",
            default: !1,
            requires: [
                "icon-image",
                {
                    "!": "icon-overlap"
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-overlap": {
            type: "enum",
            values: {
                never: {},
                always: {},
                cooperative: {}
            },
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-ignore-placement": {
            type: "boolean",
            default: !1,
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-optional": {
            type: "boolean",
            default: !1,
            requires: [
                "icon-image",
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-rotation-alignment": {
            type: "enum",
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: "auto",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-size": {
            type: "number",
            default: 1,
            minimum: 0,
            units: "factor of the original icon size",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-text-fit": {
            type: "enum",
            values: {
                none: {},
                width: {},
                height: {},
                both: {}
            },
            default: "none",
            requires: [
                "icon-image",
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-text-fit-padding": {
            type: "array",
            value: "number",
            length: 4,
            default: [
                0,
                0,
                0,
                0
            ],
            units: "pixels",
            requires: [
                "icon-image",
                "text-field",
                {
                    "icon-text-fit": [
                        "both",
                        "width",
                        "height"
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-image": {
            type: "resolvedImage",
            tokens: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-rotate": {
            type: "number",
            default: 0,
            period: 360,
            units: "degrees",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-padding": {
            type: "padding",
            default: [
                2
            ],
            units: "pixels",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-keep-upright": {
            type: "boolean",
            default: !1,
            requires: [
                "icon-image",
                {
                    "icon-rotation-alignment": "map"
                },
                {
                    "symbol-placement": [
                        "line",
                        "line-center"
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-offset": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-anchor": {
            type: "enum",
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            default: "center",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-pitch-alignment": {
            type: "enum",
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: "auto",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-pitch-alignment": {
            type: "enum",
            values: {
                map: {},
                viewport: {},
                auto: {}
            },
            default: "auto",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-rotation-alignment": {
            type: "enum",
            values: {
                map: {},
                viewport: {},
                "viewport-glyph": {},
                auto: {}
            },
            default: "auto",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-field": {
            type: "formatted",
            default: "",
            tokens: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-font": {
            type: "array",
            value: "string",
            default: [
                "Open Sans Regular",
                "Arial Unicode MS Regular"
            ],
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-size": {
            type: "number",
            default: 16,
            minimum: 0,
            units: "pixels",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-max-width": {
            type: "number",
            default: 10,
            minimum: 0,
            units: "ems",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-line-height": {
            type: "number",
            default: 1.2,
            units: "ems",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-letter-spacing": {
            type: "number",
            default: 0,
            units: "ems",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-justify": {
            type: "enum",
            values: {
                auto: {},
                left: {},
                center: {},
                right: {}
            },
            default: "center",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-radial-offset": {
            type: "number",
            units: "ems",
            default: 0,
            requires: [
                "text-field"
            ],
            "property-type": "data-driven",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        },
        "text-variable-anchor": {
            type: "array",
            value: "enum",
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            requires: [
                "text-field",
                {
                    "symbol-placement": [
                        "point"
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-variable-anchor-offset": {
            type: "variableAnchorOffsetCollection",
            requires: [
                "text-field",
                {
                    "symbol-placement": [
                        "point"
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-anchor": {
            type: "enum",
            values: {
                center: {},
                left: {},
                right: {},
                top: {},
                bottom: {},
                "top-left": {},
                "top-right": {},
                "bottom-left": {},
                "bottom-right": {}
            },
            default: "center",
            requires: [
                "text-field",
                {
                    "!": "text-variable-anchor"
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-max-angle": {
            type: "number",
            default: 45,
            units: "degrees",
            requires: [
                "text-field",
                {
                    "symbol-placement": [
                        "line",
                        "line-center"
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-writing-mode": {
            type: "array",
            value: "enum",
            values: {
                horizontal: {},
                vertical: {}
            },
            requires: [
                "text-field",
                {
                    "symbol-placement": [
                        "point"
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-rotate": {
            type: "number",
            default: 0,
            period: 360,
            units: "degrees",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-padding": {
            type: "number",
            default: 2,
            minimum: 0,
            units: "pixels",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-keep-upright": {
            type: "boolean",
            default: !0,
            requires: [
                "text-field",
                {
                    "text-rotation-alignment": "map"
                },
                {
                    "symbol-placement": [
                        "line",
                        "line-center"
                    ]
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-transform": {
            type: "enum",
            values: {
                none: {},
                uppercase: {},
                lowercase: {}
            },
            default: "none",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-offset": {
            type: "array",
            value: "number",
            units: "ems",
            length: 2,
            default: [
                0,
                0
            ],
            requires: [
                "text-field",
                {
                    "!": "text-radial-offset"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "text-allow-overlap": {
            type: "boolean",
            default: !1,
            requires: [
                "text-field",
                {
                    "!": "text-overlap"
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-overlap": {
            type: "enum",
            values: {
                never: {},
                always: {},
                cooperative: {}
            },
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-ignore-placement": {
            type: "boolean",
            default: !1,
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-optional": {
            type: "boolean",
            default: !1,
            requires: [
                "text-field",
                "icon-image"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "symbol-height-offset": {
            type: "number",
            default: 0,
            units: "meters",
            requires: [
                {
                    "symbol-placement": [
                        "point"
                    ]
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "data-driven"
        },
        "symbol-height-anchor": {
            type: "enum",
            values: {
                ground: {},
                absolute: {}
            },
            default: "ground",
            requires: [
                "symbol-height-offset"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_raster: {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    layout_hillshade: {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    "layout_color-relief": {
        visibility: {
            type: "enum",
            values: {
                visible: {},
                none: {}
            },
            default: "visible",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        }
    },
    filter: {
        type: "boolean",
        expression: {
            interpolated: !1,
            parameters: [
                "zoom",
                "feature"
            ]
        },
        "property-type": "data-driven"
    },
    filter_operator: {
        type: "enum",
        values: {
            "==": {},
            "!=": {},
            ">": {},
            ">=": {},
            "<": {},
            "<=": {},
            in: {},
            "!in": {},
            all: {},
            any: {},
            none: {},
            has: {},
            "!has": {}
        }
    },
    geometry_type: {
        type: "enum",
        values: {
            Point: {},
            LineString: {},
            Polygon: {}
        }
    },
    function: {
        expression: {
            type: "expression"
        },
        stops: {
            type: "array",
            value: "function_stop"
        },
        base: {
            type: "number",
            default: 1,
            minimum: 0
        },
        property: {
            type: "string",
            default: "$zoom"
        },
        type: {
            type: "enum",
            values: {
                identity: {},
                exponential: {},
                interval: {},
                categorical: {}
            },
            default: "exponential"
        },
        colorSpace: {
            type: "enum",
            values: {
                rgb: {},
                lab: {},
                hcl: {}
            },
            default: "rgb"
        },
        default: {
            type: "*",
            required: !1
        }
    },
    function_stop: {
        type: "array",
        minimum: 0,
        maximum: 24,
        value: [
            "number",
            "color"
        ],
        length: 2
    },
    expression: {
        type: "array",
        value: "expression_name",
        minimum: 1
    },
    light: {
        anchor: {
            type: "enum",
            default: "viewport",
            values: {
                map: {},
                viewport: {}
            },
            "property-type": "data-constant",
            transition: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            }
        },
        position: {
            type: "array",
            default: [
                1.15,
                210,
                30
            ],
            length: 3,
            value: "number",
            "property-type": "data-constant",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            }
        },
        color: {
            type: "color",
            "property-type": "data-constant",
            default: "#ffffff",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        intensity: {
            type: "number",
            "property-type": "data-constant",
            default: .5,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        }
    },
    sky: {
        "sky-color": {
            type: "color",
            "property-type": "data-constant",
            default: "#88C6FC",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "horizon-color": {
            type: "color",
            "property-type": "data-constant",
            default: "#ffffff",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "fog-color": {
            type: "color",
            "property-type": "data-constant",
            default: "#ffffff",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "fog-ground-blend": {
            type: "number",
            "property-type": "data-constant",
            default: .5,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "horizon-fog-blend": {
            type: "number",
            "property-type": "data-constant",
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "sky-horizon-blend": {
            type: "number",
            "property-type": "data-constant",
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        },
        "atmosphere-blend": {
            type: "number",
            "property-type": "data-constant",
            default: .8,
            minimum: 0,
            maximum: 1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            transition: !0
        }
    },
    terrain: {
        source: {
            type: "string",
            required: !0
        },
        exaggeration: {
            type: "number",
            minimum: 0,
            default: 1
        }
    },
    projection: {
        type: {
            type: "projectionDefinition",
            default: "mercator",
            "property-type": "data-constant",
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            }
        }
    },
    paint: [
        "paint_fill",
        "paint_line",
        "paint_circle",
        "paint_heatmap",
        "paint_fill-extrusion",
        "paint_symbol",
        "paint_raster",
        "paint_hillshade",
        "paint_color-relief",
        "paint_background"
    ],
    paint_fill: {
        "fill-antialias": {
            type: "boolean",
            default: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-layer-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-outline-color": {
            type: "color",
            transition: !0,
            requires: [
                {
                    "!": "fill-pattern"
                },
                {
                    "fill-antialias": !0
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "fill-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-pattern": {
            type: "resolvedImage",
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "cross-faded-data-driven"
        }
    },
    "paint_fill-extrusion": {
        "fill-extrusion-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            requires: [
                {
                    "!": "fill-extrusion-pattern"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "fill-extrusion-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "fill-extrusion-pattern": {
            type: "resolvedImage",
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "cross-faded-data-driven"
        },
        "fill-extrusion-height": {
            type: "number",
            default: 0,
            units: "meters",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-base": {
            type: "number",
            default: 0,
            units: "meters",
            transition: !0,
            requires: [
                "fill-extrusion-height"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "fill-extrusion-vertical-gradient": {
            type: "boolean",
            default: !0,
            transition: !1,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_line: {
        "line-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-layer-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "global-state"
                ]
            },
            "property-type": "data-constant"
        },
        "line-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            requires: [
                {
                    "!": "line-pattern"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "line-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "line-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "line-width": {
            type: "number",
            default: 1,
            minimum: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-gap-width": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-offset": {
            type: "number",
            default: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-blur": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "line-dasharray": {
            type: "array",
            value: "number",
            minimum: 0,
            transition: !0,
            units: "line widths",
            requires: [
                {
                    "!": "line-pattern"
                }
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "cross-faded-data-driven"
        },
        "line-pattern": {
            type: "resolvedImage",
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            },
            "property-type": "cross-faded-data-driven"
        },
        "line-gradient": {
            type: "color",
            transition: !1,
            requires: [
                {
                    "!": "line-dasharray"
                },
                {
                    "!": "line-pattern"
                },
                {
                    source: "geojson",
                    has: {
                        lineMetrics: !0
                    }
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "line-progress"
                ]
            },
            "property-type": "color-ramp"
        }
    },
    paint_circle: {
        "circle-radius": {
            type: "number",
            default: 5,
            minimum: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-blur": {
            type: "number",
            default: 0,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "circle-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "circle-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "circle-pitch-scale": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "circle-pitch-alignment": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "viewport",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "circle-stroke-width": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-stroke-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "circle-stroke-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        }
    },
    paint_heatmap: {
        "heatmap-radius": {
            type: "number",
            default: 30,
            minimum: 1,
            transition: !0,
            units: "pixels",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "heatmap-weight": {
            type: "number",
            default: 1,
            minimum: 0,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "heatmap-intensity": {
            type: "number",
            default: 1,
            minimum: 0,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "heatmap-color": {
            type: "color",
            default: [
                "interpolate",
                [
                    "linear"
                ],
                [
                    "heatmap-density"
                ],
                0,
                "rgba(0, 0, 255, 0)",
                .1,
                "royalblue",
                .3,
                "cyan",
                .5,
                "lime",
                .7,
                "yellow",
                1,
                "red"
            ],
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "heatmap-density"
                ]
            },
            "property-type": "color-ramp"
        },
        "heatmap-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_symbol: {
        "icon-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-halo-color": {
            type: "color",
            default: "rgba(0, 0, 0, 0)",
            transition: !0,
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-halo-width": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-halo-blur": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "icon-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            requires: [
                "icon-image"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "icon-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "icon-image",
                "icon-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "text-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            overridable: !0,
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "text-halo-color": {
            type: "color",
            default: "rgba(0, 0, 0, 0)",
            transition: !0,
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "text-halo-width": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "text-halo-blur": {
            type: "number",
            default: 0,
            minimum: 0,
            transition: !0,
            units: "pixels",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom",
                    "feature",
                    "feature-state"
                ]
            },
            "property-type": "data-driven"
        },
        "text-translate": {
            type: "array",
            value: "number",
            length: 2,
            default: [
                0,
                0
            ],
            transition: !0,
            units: "pixels",
            requires: [
                "text-field"
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "text-translate-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "map",
            requires: [
                "text-field",
                "text-translate"
            ],
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_raster: {
        "raster-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-hue-rotate": {
            type: "number",
            default: 0,
            period: 360,
            transition: !0,
            units: "degrees",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-brightness-min": {
            type: "number",
            default: 0,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-brightness-max": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-saturation": {
            type: "number",
            default: 0,
            minimum: -1,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-contrast": {
            type: "number",
            default: 0,
            minimum: -1,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        resampling: {
            type: "enum",
            values: {
                linear: {},
                nearest: {}
            },
            default: "linear",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-resampling": {
            type: "enum",
            values: {
                linear: {},
                nearest: {}
            },
            default: "linear",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "raster-fade-duration": {
            type: "number",
            default: 300,
            minimum: 0,
            transition: !1,
            units: "milliseconds",
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_hillshade: {
        "hillshade-illumination-direction": {
            type: "numberArray",
            default: 335,
            minimum: 0,
            maximum: 359,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-illumination-altitude": {
            type: "numberArray",
            default: 45,
            minimum: 0,
            maximum: 90,
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-illumination-anchor": {
            type: "enum",
            values: {
                map: {},
                viewport: {}
            },
            default: "viewport",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-exaggeration": {
            type: "number",
            default: .5,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-shadow-color": {
            type: "colorArray",
            default: "#000000",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-highlight-color": {
            type: "colorArray",
            default: "#FFFFFF",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-accent-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "hillshade-method": {
            type: "enum",
            values: {
                standard: {},
                basic: {},
                combined: {},
                igor: {},
                multidirectional: {}
            },
            default: "standard",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        resampling: {
            type: "enum",
            values: {
                linear: {},
                nearest: {}
            },
            default: "linear",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    "paint_color-relief": {
        "color-relief-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "color-relief-color": {
            type: "color",
            transition: !1,
            expression: {
                interpolated: !0,
                parameters: [
                    "elevation"
                ]
            },
            "property-type": "color-ramp"
        },
        resampling: {
            type: "enum",
            values: {
                linear: {},
                nearest: {}
            },
            default: "linear",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    paint_background: {
        "background-color": {
            type: "color",
            default: "#000000",
            transition: !0,
            requires: [
                {
                    "!": "background-pattern"
                }
            ],
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        },
        "background-pattern": {
            type: "resolvedImage",
            transition: !0,
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "cross-faded"
        },
        "background-opacity": {
            type: "number",
            default: 1,
            minimum: 0,
            maximum: 1,
            transition: !0,
            expression: {
                interpolated: !0,
                parameters: [
                    "zoom"
                ]
            },
            "property-type": "data-constant"
        }
    },
    transition: {
        duration: {
            type: "number",
            default: 300,
            minimum: 0,
            units: "milliseconds"
        },
        delay: {
            type: "number",
            default: 0,
            minimum: 0,
            units: "milliseconds"
        }
    },
    "property-type": {
        "data-driven": {
            type: "property-type"
        },
        "cross-faded": {
            type: "property-type"
        },
        "cross-faded-data-driven": {
            type: "property-type"
        },
        "color-ramp": {
            type: "property-type"
        },
        "data-constant": {
            type: "property-type"
        },
        constant: {
            type: "property-type"
        }
    },
    promoteId: {
        "*": {
            type: "string"
        }
    },
    interpolation: {
        type: "array",
        value: "interpolation_name",
        minimum: 1
    },
    interpolation_name: {
        type: "enum",
        values: {
            linear: {
                syntax: {
                    overloads: [
                        {
                            parameters: [],
                            "output-type": "interpolation"
                        }
                    ],
                    parameters: []
                }
            },
            exponential: {
                syntax: {
                    overloads: [
                        {
                            parameters: [
                                "base"
                            ],
                            "output-type": "interpolation"
                        }
                    ],
                    parameters: [
                        {
                            name: "base",
                            type: "number literal"
                        }
                    ]
                }
            },
            "cubic-bezier": {
                syntax: {
                    overloads: [
                        {
                            parameters: [
                                "x1",
                                "y1",
                                "x2",
                                "y2"
                            ],
                            "output-type": "interpolation"
                        }
                    ],
                    parameters: [
                        {
                            name: "x1",
                            type: "number literal"
                        },
                        {
                            name: "y1",
                            type: "number literal"
                        },
                        {
                            name: "x2",
                            type: "number literal"
                        },
                        {
                            name: "y2",
                            type: "number literal"
                        }
                    ]
                }
            }
        }
    }
};
const $785da19a645c07eb$var$od = $785da19a645c07eb$var$sd, $785da19a645c07eb$var$ld = [
    "type",
    "source",
    "source-layer",
    "minzoom",
    "maxzoom",
    "filter",
    "layout"
];
var $785da19a645c07eb$var$cd = class {
    constructor(e1, t, i, n, a = "error"){
        this.message = (e1 ? `${e1}: ` : "") + i, n && (this.identifier = n), this.severity = a, null != t && t.__line__ && (this.line = t.__line__);
    }
};
const $785da19a645c07eb$var$ud = {
    kind: "null"
}, $785da19a645c07eb$var$hd = {
    kind: "number"
}, $785da19a645c07eb$var$dd = {
    kind: "string"
}, $785da19a645c07eb$var$pd = {
    kind: "boolean"
}, $785da19a645c07eb$var$md = {
    kind: "color"
}, $785da19a645c07eb$var$gd = {
    kind: "projectionDefinition"
}, $785da19a645c07eb$var$fd = {
    kind: "object"
}, $785da19a645c07eb$var$Ad = {
    kind: "value"
}, $785da19a645c07eb$var$_d = {
    kind: "error"
}, $785da19a645c07eb$var$vd = {
    kind: "collator"
}, $785da19a645c07eb$var$yd = {
    kind: "formatted"
}, $785da19a645c07eb$var$xd = {
    kind: "padding"
}, $785da19a645c07eb$var$bd = {
    kind: "colorArray"
}, $785da19a645c07eb$var$wd = {
    kind: "numberArray"
}, $785da19a645c07eb$var$Ed = {
    kind: "resolvedImage"
}, $785da19a645c07eb$var$kd = {
    kind: "variableAnchorOffsetCollection"
};
function $785da19a645c07eb$var$Sd(e1, t) {
    return {
        kind: "array",
        itemType: e1,
        N: t
    };
}
function $785da19a645c07eb$var$Md(e1) {
    if ("array" === e1.kind) {
        let t = $785da19a645c07eb$var$Md(e1.itemType);
        return "number" == typeof e1.N ? `array<${t}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t}>`;
    }
    return e1.kind;
}
const $785da19a645c07eb$var$Cd = [
    $785da19a645c07eb$var$ud,
    $785da19a645c07eb$var$hd,
    $785da19a645c07eb$var$dd,
    $785da19a645c07eb$var$pd,
    $785da19a645c07eb$var$md,
    $785da19a645c07eb$var$gd,
    $785da19a645c07eb$var$yd,
    $785da19a645c07eb$var$fd,
    $785da19a645c07eb$var$Sd($785da19a645c07eb$var$Ad),
    $785da19a645c07eb$var$xd,
    $785da19a645c07eb$var$wd,
    $785da19a645c07eb$var$bd,
    $785da19a645c07eb$var$Ed,
    $785da19a645c07eb$var$kd
];
function $785da19a645c07eb$var$Td(e1, t) {
    if ("error" === t.kind) return null;
    if ("array" === e1.kind) {
        if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !$785da19a645c07eb$var$Td(e1.itemType, t.itemType)) && ("number" != typeof e1.N || e1.N === t.N)) return null;
    } else {
        if (e1.kind === t.kind) return null;
        if ("value" === e1.kind) {
            for (let e1 of $785da19a645c07eb$var$Cd)if (!$785da19a645c07eb$var$Td(e1, t)) return null;
        }
    }
    return `Expected ${$785da19a645c07eb$var$Md(e1)} but found ${$785da19a645c07eb$var$Md(t)} instead.`;
}
function $785da19a645c07eb$var$Dd(e1, t) {
    return t.some((t)=>t.kind === e1.kind);
}
function $785da19a645c07eb$var$Pd(e1, t) {
    return t.some((t)=>"null" === t ? null === e1 : "array" === t ? Array.isArray(e1) : "object" === t ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t === typeof e1);
}
function $785da19a645c07eb$var$Id(e1, t) {
    return "array" === e1.kind && "array" === t.kind ? e1.itemType.kind === t.itemType.kind && "number" == typeof e1.N : e1.kind === t.kind;
}
const $785da19a645c07eb$var$Fd = .96422, $785da19a645c07eb$var$zd = .82521, $785da19a645c07eb$var$Rd = 4 / 29, $785da19a645c07eb$var$Ld = 6 / 29, $785da19a645c07eb$var$Bd = 3 * $785da19a645c07eb$var$Ld * $785da19a645c07eb$var$Ld, $785da19a645c07eb$var$Od = Math.PI / 180, $785da19a645c07eb$var$Ud = 180 / Math.PI;
function $785da19a645c07eb$var$Nd(e1) {
    return (e1 %= 360) < 0 && (e1 += 360), e1;
}
function $785da19a645c07eb$var$jd([e1, t, i, n]) {
    let a, r, s = $785da19a645c07eb$var$qd((.2225045 * (e1 = $785da19a645c07eb$var$Vd(e1)) + .7168786 * (t = $785da19a645c07eb$var$Vd(t)) + .0606169 * (i = $785da19a645c07eb$var$Vd(i))) / 1);
    e1 === t && t === i ? a = r = s : (a = $785da19a645c07eb$var$qd((.4360747 * e1 + .3850649 * t + .1430804 * i) / $785da19a645c07eb$var$Fd), r = $785da19a645c07eb$var$qd((.0139322 * e1 + .0971045 * t + .7141733 * i) / $785da19a645c07eb$var$zd));
    let o = 116 * s - 16;
    return [
        o < 0 ? 0 : o,
        500 * (a - s),
        200 * (s - r),
        n
    ];
}
function $785da19a645c07eb$var$Vd(e1) {
    return e1 <= .04045 ? e1 / 12.92 : ((e1 + .055) / 1.055) ** 2.4;
}
function $785da19a645c07eb$var$qd(e1) {
    return e1 > .008856451679035631 ? e1 ** (1 / 3) : e1 / $785da19a645c07eb$var$Bd + $785da19a645c07eb$var$Rd;
}
function $785da19a645c07eb$var$Gd([e1, t, i, n]) {
    let a = (e1 + 16) / 116, r = isNaN(t) ? a : a + t / 500, s = isNaN(i) ? a : a - i / 200;
    return a = 1 * $785da19a645c07eb$var$Wd(a), r = $785da19a645c07eb$var$Fd * $785da19a645c07eb$var$Wd(r), s = $785da19a645c07eb$var$zd * $785da19a645c07eb$var$Wd(s), [
        $785da19a645c07eb$var$Hd(3.1338561 * r - 1.6168667 * a - .4906146 * s),
        $785da19a645c07eb$var$Hd(-0.9787684 * r + 1.9161415 * a + .033454 * s),
        $785da19a645c07eb$var$Hd(.0719453 * r - .2289914 * a + 1.4052427 * s),
        n
    ];
}
function $785da19a645c07eb$var$Hd(e1) {
    return (e1 = e1 <= .00304 ? 12.92 * e1 : 1.055 * e1 ** (1 / 2.4) - .055) < 0 ? 0 : e1 > 1 ? 1 : e1;
}
function $785da19a645c07eb$var$Wd(e1) {
    return e1 > $785da19a645c07eb$var$Ld ? e1 * e1 * e1 : $785da19a645c07eb$var$Bd * (e1 - $785da19a645c07eb$var$Rd);
}
const $785da19a645c07eb$var$Zd = Object.hasOwn || function(e1, t) {
    return Object.prototype.hasOwnProperty.call(e1, t);
};
function $785da19a645c07eb$var$Kd(e1, t) {
    return $785da19a645c07eb$var$Zd(e1, t) ? e1[t] : void 0;
}
function $785da19a645c07eb$var$Xd(e1) {
    if ("transparent" === (e1 = e1.toLowerCase().trim())) return [
        0,
        0,
        0,
        0
    ];
    let t = $785da19a645c07eb$var$Kd($785da19a645c07eb$var$ep, e1);
    if (t) {
        let [e1, i, n] = t;
        return [
            e1 / 255,
            i / 255,
            n / 255,
            1
        ];
    }
    if (e1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(e1)) {
        let t = e1.length < 6 ? 1 : 2, i = 1;
        return [
            $785da19a645c07eb$var$Qd(e1.slice(i, i += t)),
            $785da19a645c07eb$var$Qd(e1.slice(i, i += t)),
            $785da19a645c07eb$var$Qd(e1.slice(i, i += t)),
            $785da19a645c07eb$var$Qd(e1.slice(i, i + t) || "ff")
        ];
    }
    if (e1.startsWith("rgb")) {
        let t = e1.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
        if (t) {
            let [e1, i, n, a, r, s, o, l, c, u, h, d] = t, p = [
                a || " ",
                o || " ",
                u
            ].join("");
            if ("  " === p || "  /" === p || ",," === p || ",,," === p) {
                let e1 = [
                    n,
                    s,
                    c
                ].join(""), t = "%%%" === e1 ? 100 : "" === e1 ? 255 : 0;
                if (t) {
                    let e1 = [
                        $785da19a645c07eb$var$Jd(+i / t, 0, 1),
                        $785da19a645c07eb$var$Jd(+r / t, 0, 1),
                        $785da19a645c07eb$var$Jd(+l / t, 0, 1),
                        h ? $785da19a645c07eb$var$Yd(+h, d) : 1
                    ];
                    if ($785da19a645c07eb$var$$d(e1)) return e1;
                }
            }
            return;
        }
    }
    let i = e1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
    if (i) {
        let [e1, t, n, a, r, s, o, l, c] = i, u = [
            n || " ",
            r || " ",
            o
        ].join("");
        if ("  " === u || "  /" === u || ",," === u || ",,," === u) {
            let e1 = [
                +t,
                $785da19a645c07eb$var$Jd(+a, 0, 100),
                $785da19a645c07eb$var$Jd(+s, 0, 100),
                l ? $785da19a645c07eb$var$Yd(+l, c) : 1
            ];
            if ($785da19a645c07eb$var$$d(e1)) return function([e1, t, i, n]) {
                function a(n) {
                    let a = (n + e1 / 30) % 12, r = t * Math.min(i, 1 - i);
                    return i - r * Math.max(-1, Math.min(a - 3, 9 - a, 1));
                }
                return e1 = $785da19a645c07eb$var$Nd(e1), t /= 100, i /= 100, [
                    a(0),
                    a(8),
                    a(4),
                    n
                ];
            }(e1);
        }
    }
}
function $785da19a645c07eb$var$Qd(e1) {
    return parseInt(e1.padEnd(2, e1), 16) / 255;
}
function $785da19a645c07eb$var$Yd(e1, t) {
    return $785da19a645c07eb$var$Jd(t ? e1 / 100 : e1, 0, 1);
}
function $785da19a645c07eb$var$Jd(e1, t, i) {
    return Math.min(Math.max(t, e1), i);
}
function $785da19a645c07eb$var$$d(e1) {
    return !e1.some(Number.isNaN);
}
const $785da19a645c07eb$var$ep = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
function $785da19a645c07eb$var$tp(e1, t, i) {
    return e1 + i * (t - e1);
}
function $785da19a645c07eb$var$ip(e1, t, i) {
    return e1.map((e1, n)=>$785da19a645c07eb$var$tp(e1, t[n], i));
}
var $785da19a645c07eb$var$np = class e1 {
    constructor(e1, t, i, n = 1, a = !0){
        this.r = e1, this.g = t, this.b = i, this.a = n, a || (this.r *= n, this.g *= n, this.b *= n, n || this.overwriteGetter("rgb", [
            e1,
            t,
            i,
            n
        ]));
    }
    static{
        this.black = new e1(0, 0, 0, 1);
    }
    static{
        this.white = new e1(1, 1, 1, 1);
    }
    static{
        this.transparent = new e1(0, 0, 0, 0);
    }
    static{
        this.red = new e1(1, 0, 0, 1);
    }
    static parse(t) {
        if (t instanceof e1) return t;
        if ("string" != typeof t) return;
        let i = $785da19a645c07eb$var$Xd(t);
        return i ? new e1(...i, !1) : void 0;
    }
    get rgb() {
        let { r: e1, g: t, b: i, a: n } = this, a = n || 1 / 0;
        return this.overwriteGetter("rgb", [
            e1 / a,
            t / a,
            i / a,
            n
        ]);
    }
    get hcl() {
        return this.overwriteGetter("hcl", function(e1) {
            let [t, i, n, a] = $785da19a645c07eb$var$jd(e1), r = Math.sqrt(i * i + n * n);
            return [
                Math.round(1e4 * r) ? $785da19a645c07eb$var$Nd(Math.atan2(n, i) * $785da19a645c07eb$var$Ud) : NaN,
                r,
                t,
                a
            ];
        }(this.rgb));
    }
    get lab() {
        return this.overwriteGetter("lab", $785da19a645c07eb$var$jd(this.rgb));
    }
    overwriteGetter(e1, t) {
        return Object.defineProperty(this, e1, {
            value: t
        }), t;
    }
    toString() {
        let [e1, t, i, n] = this.rgb;
        return `rgba(${[
            e1,
            t,
            i
        ].map((e1)=>Math.round(255 * e1)).join(",")},${n})`;
    }
    static interpolate(t, i, n, a = "rgb") {
        switch(a){
            case "rgb":
                {
                    let [a, r, s, o] = $785da19a645c07eb$var$ip(t.rgb, i.rgb, n);
                    return new e1(a, r, s, o, !1);
                }
            case "hcl":
                {
                    let a, r, [s, o, l, c] = t.hcl, [u, h, d, p] = i.hcl;
                    if (isNaN(s) || isNaN(u)) isNaN(s) ? isNaN(u) ? a = NaN : (a = u, (1 === l || 0 === l) && (r = h)) : (a = s, (1 === d || 0 === d) && (r = o));
                    else {
                        let e1 = u - s;
                        u > s && e1 > 180 ? e1 -= 360 : u < s && s - u > 180 && (e1 += 360), a = s + n * e1;
                    }
                    let [m, g, f, A] = function([e1, t, i, n]) {
                        return e1 = isNaN(e1) ? 0 : e1 * $785da19a645c07eb$var$Od, $785da19a645c07eb$var$Gd([
                            i,
                            Math.cos(e1) * t,
                            Math.sin(e1) * t,
                            n
                        ]);
                    }([
                        a,
                        r ?? $785da19a645c07eb$var$tp(o, h, n),
                        $785da19a645c07eb$var$tp(l, d, n),
                        $785da19a645c07eb$var$tp(c, p, n)
                    ]);
                    return new e1(m, g, f, A, !1);
                }
            case "lab":
                {
                    let [a, r, s, o] = $785da19a645c07eb$var$Gd($785da19a645c07eb$var$ip(t.lab, i.lab, n));
                    return new e1(a, r, s, o, !1);
                }
        }
    }
};
const $785da19a645c07eb$var$ap = [
    "bottom",
    "center",
    "top"
];
var $785da19a645c07eb$var$rp = class {
    constructor(e1, t, i, n, a, r){
        this.text = e1, this.image = t, this.scale = i, this.fontStack = n, this.textColor = a, this.verticalAlign = r;
    }
}, $785da19a645c07eb$var$sp = class e1 {
    constructor(e1){
        this.sections = e1;
    }
    static fromString(t) {
        return new e1([
            new $785da19a645c07eb$var$rp(t, null, null, null, null, null)
        ]);
    }
    isEmpty() {
        return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || e1.image && 0 !== e1.image.name.length);
    }
    static factory(t) {
        return t instanceof e1 ? t : e1.fromString(t);
    }
    toString() {
        return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
    }
}, $785da19a645c07eb$var$op = class e1 {
    constructor(e1){
        this.values = e1.slice();
    }
    static parse(t) {
        if (t instanceof e1) return t;
        if ("number" == typeof t) return new e1([
            t,
            t,
            t,
            t
        ]);
        if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
            for (let e1 of t)if ("number" != typeof e1) return;
            switch(t.length){
                case 1:
                    t = [
                        t[0],
                        t[0],
                        t[0],
                        t[0]
                    ];
                    break;
                case 2:
                    t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ];
                    break;
                case 3:
                    t = [
                        t[0],
                        t[1],
                        t[2],
                        t[1]
                    ];
            }
            return new e1(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, i, n) {
        return new e1($785da19a645c07eb$var$ip(t.values, i.values, n));
    }
}, $785da19a645c07eb$var$lp = class e1 {
    constructor(e1){
        this.values = e1.slice();
    }
    static parse(t) {
        if (t instanceof e1) return t;
        if ("number" == typeof t) return new e1([
            t
        ]);
        if (Array.isArray(t)) {
            for (let e1 of t)if ("number" != typeof e1) return;
            return new e1(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, i, n) {
        return new e1($785da19a645c07eb$var$ip(t.values, i.values, n));
    }
}, $785da19a645c07eb$var$cp = class e1 {
    constructor(e1){
        this.values = e1.slice();
    }
    static parse(t) {
        if (t instanceof e1) return t;
        if ("string" == typeof t) {
            let i = $785da19a645c07eb$var$np.parse(t);
            return i ? new e1([
                i
            ]) : void 0;
        }
        if (!Array.isArray(t)) return;
        let i = [];
        for (let e1 of t){
            if ("string" != typeof e1) return;
            let t = $785da19a645c07eb$var$np.parse(e1);
            if (!t) return;
            i.push(t);
        }
        return new e1(i);
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, i, n, a = "rgb") {
        let r = [];
        if (t.values.length != i.values.length) throw Error(`colorArray: Arrays have mismatched length (${t.values.length} vs. ${i.values.length}), cannot interpolate.`);
        for(let e1 = 0; e1 < t.values.length; e1++)r.push($785da19a645c07eb$var$np.interpolate(t.values[e1], i.values[e1], n, a));
        return new e1(r);
    }
}, $785da19a645c07eb$var$up = class extends Error {
    constructor(e1, t){
        super(e1), this.name = "RuntimeError", this.path = t;
    }
    toJSON() {
        return this.message;
    }
};
const $785da19a645c07eb$var$hp = new Set([
    "center",
    "left",
    "right",
    "top",
    "bottom",
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right"
]);
var $785da19a645c07eb$var$dp = class e1 {
    constructor(e1){
        this.values = e1.slice();
    }
    static parse(t) {
        if (t instanceof e1) return t;
        if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
            for(let e1 = 0; e1 < t.length; e1 += 2){
                let i = t[e1], n = t[e1 + 1];
                if ("string" != typeof i || !$785da19a645c07eb$var$hp.has(i) || !Array.isArray(n) || 2 !== n.length || "number" != typeof n[0] || "number" != typeof n[1]) return;
            }
            return new e1(t);
        }
    }
    toString() {
        return JSON.stringify(this.values);
    }
    static interpolate(t, i, n, a) {
        let r = t.values, s = i.values;
        if (r.length !== s.length) throw new $785da19a645c07eb$var$up(`Cannot interpolate values of different length. from: ${t.toString()}, to: ${i.toString()}`, a);
        let o = [];
        for(let e1 = 0; e1 < r.length; e1 += 2){
            if (r[e1] !== s[e1]) throw new $785da19a645c07eb$var$up(`Cannot interpolate values containing mismatched anchors. from[${e1}]: ${r[e1]}, to[${e1}]: ${s[e1]}`, a);
            o.push(r[e1]);
            let [t, i] = r[e1 + 1], [l, c] = s[e1 + 1];
            o.push([
                $785da19a645c07eb$var$tp(t, l, n),
                $785da19a645c07eb$var$tp(i, c, n)
            ]);
        }
        return new e1(o);
    }
}, $785da19a645c07eb$var$pp = class e1 {
    constructor(e1){
        this.name = e1.name, this.available = e1.available;
    }
    toString() {
        return this.name;
    }
    static fromString(t) {
        return t ? new e1({
            name: t,
            available: !1
        }) : null;
    }
}, $785da19a645c07eb$var$mp = class e1 {
    constructor(e1, t, i){
        this.from = e1, this.to = t, this.transition = i;
    }
    toString() {
        return this.from === this.to && 1 === this.transition ? this.from : JSON.stringify([
            this.from,
            this.to,
            this.transition
        ]);
    }
    static interpolate(t, i, n) {
        return new e1(t, i, n);
    }
    static parse(t) {
        return t instanceof e1 ? t : Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2] ? new e1(t[0], t[1], t[2]) : "object" == typeof t && "string" == typeof t.from && "string" == typeof t.to && "number" == typeof t.transition ? new e1(t.from, t.to, t.transition) : "string" == typeof t ? new e1(t, t, 1) : void 0;
    }
}, $785da19a645c07eb$var$gp = class {
    constructor(e1, t, i){
        this.sensitivity = e1 ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = i, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
            sensitivity: this.sensitivity,
            usage: "search"
        });
    }
    compare(e1, t) {
        return this.collator.compare(e1, t);
    }
    resolvedLocale() {
        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
    }
};
function $785da19a645c07eb$var$fp(e1, t, i, n) {
    return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
        e1,
        t,
        i,
        n
    ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
        e1,
        t,
        i,
        n
    ] : [
        e1,
        t,
        i
    ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
}
function $785da19a645c07eb$var$Ap(e1) {
    if (null === e1 || "string" == typeof e1 || "boolean" == typeof e1 || "number" == typeof e1 || e1 instanceof $785da19a645c07eb$var$mp || e1 instanceof $785da19a645c07eb$var$np || e1 instanceof $785da19a645c07eb$var$gp || e1 instanceof $785da19a645c07eb$var$sp || e1 instanceof $785da19a645c07eb$var$op || e1 instanceof $785da19a645c07eb$var$lp || e1 instanceof $785da19a645c07eb$var$cp || e1 instanceof $785da19a645c07eb$var$dp || e1 instanceof $785da19a645c07eb$var$pp) return !0;
    if (Array.isArray(e1)) {
        for (let t of e1)if (!$785da19a645c07eb$var$Ap(t)) return !1;
        return !0;
    }
    if ("object" == typeof e1) {
        for(let t in e1)if (!$785da19a645c07eb$var$Ap(e1[t])) return !1;
        return !0;
    }
    return !1;
}
function $785da19a645c07eb$var$_p(e1) {
    if (null === e1) return $785da19a645c07eb$var$ud;
    if ("string" == typeof e1) return $785da19a645c07eb$var$dd;
    if ("boolean" == typeof e1) return $785da19a645c07eb$var$pd;
    if ("number" == typeof e1) return $785da19a645c07eb$var$hd;
    if (e1 instanceof $785da19a645c07eb$var$np) return $785da19a645c07eb$var$md;
    if (e1 instanceof $785da19a645c07eb$var$mp) return $785da19a645c07eb$var$gd;
    if (e1 instanceof $785da19a645c07eb$var$gp) return $785da19a645c07eb$var$vd;
    if (e1 instanceof $785da19a645c07eb$var$sp) return $785da19a645c07eb$var$yd;
    if (e1 instanceof $785da19a645c07eb$var$op) return $785da19a645c07eb$var$xd;
    if (e1 instanceof $785da19a645c07eb$var$lp) return $785da19a645c07eb$var$wd;
    if (e1 instanceof $785da19a645c07eb$var$cp) return $785da19a645c07eb$var$bd;
    if (e1 instanceof $785da19a645c07eb$var$dp) return $785da19a645c07eb$var$kd;
    if (e1 instanceof $785da19a645c07eb$var$pp) return $785da19a645c07eb$var$Ed;
    if (Array.isArray(e1)) {
        let t, i = e1.length;
        for (let i of e1){
            let e1 = $785da19a645c07eb$var$_p(i);
            if (t) {
                if (t === e1) continue;
                t = $785da19a645c07eb$var$Ad;
                break;
            }
            t = e1;
        }
        return $785da19a645c07eb$var$Sd(t || $785da19a645c07eb$var$Ad, i);
    }
    return $785da19a645c07eb$var$fd;
}
function $785da19a645c07eb$var$vp(e1) {
    let t = typeof e1;
    return null === e1 ? "" : "string" === t || "number" === t || "boolean" === t ? String(e1) : e1 instanceof $785da19a645c07eb$var$np || e1 instanceof $785da19a645c07eb$var$mp || e1 instanceof $785da19a645c07eb$var$sp || e1 instanceof $785da19a645c07eb$var$op || e1 instanceof $785da19a645c07eb$var$lp || e1 instanceof $785da19a645c07eb$var$cp || e1 instanceof $785da19a645c07eb$var$dp || e1 instanceof $785da19a645c07eb$var$pp ? e1.toString() : JSON.stringify(e1);
}
var $785da19a645c07eb$var$yp = class e1 {
    constructor(e1, t){
        this.type = e1, this.value = t;
    }
    static parse(t, i) {
        if (2 !== t.length) return i.error(`'literal' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if (!$785da19a645c07eb$var$Ap(t[1])) return i.error(`invalid value of type "${typeof t[1]}"`);
        let n = t[1], a = $785da19a645c07eb$var$_p(n), r = i.expectedType;
        return "array" === a.kind && 0 === a.N && r && "array" === r.kind && ("number" != typeof r.N || 0 === r.N) && (a = r), new e1(a, n);
    }
    evaluate() {
        return this.value;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
};
const $785da19a645c07eb$var$xp = [
    "Unknown",
    "Point",
    "LineString",
    "Polygon"
];
var $785da19a645c07eb$var$bp = class {
    constructor(){
        this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
    }
    id() {
        return this.feature && "id" in this.feature ? this.feature.id : null;
    }
    geometryType() {
        return this.feature ? "number" == typeof this.feature.type ? $785da19a645c07eb$var$xp[this.feature.type] : this.feature.type : null;
    }
    geometry() {
        return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
    }
    canonicalID() {
        return this.canonical;
    }
    properties() {
        return this.feature && this.feature.properties || {};
    }
    parseColor(e1) {
        let t = this._parseColorCache.get(e1);
        return t || (t = $785da19a645c07eb$var$np.parse(e1), this._parseColorCache.set(e1, t)), t;
    }
};
function $785da19a645c07eb$var$wp(e1, t, i) {
    let n, a, r = e1.length - 1, s = 0, o = r, l = 0;
    for(; s <= o;)if (l = Math.floor((s + o) / 2), n = e1[l], a = e1[l + 1], n <= t) {
        if (l === r || t < a) return l;
        s = l + 1;
    } else {
        if (!(n > t)) throw new $785da19a645c07eb$var$up("Input is not a number.", i);
        o = l - 1;
    }
    return 0;
}
var $785da19a645c07eb$var$Ep = class e1 {
    constructor(e1, t, i, n){
        this.type = e1, this.input = t, this.key = n, this.labels = [], this.outputs = [];
        for (let [e1, t] of i)this.labels.push(e1), this.outputs.push(t);
    }
    static parse(t, i) {
        if (t.length - 1 < 4) return i.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
        if ((t.length - 1) % 2 != 0) return i.error("Expected an even number of arguments.");
        let n = i.parse(t[1], 1, $785da19a645c07eb$var$hd);
        if (!n) return null;
        let a = [], r = null;
        i.expectedType && "value" !== i.expectedType.kind && (r = i.expectedType);
        for(let e1 = 1; e1 < t.length; e1 += 2){
            let n = 1 === e1 ? -1 / 0 : t[e1], s = t[e1 + 1], o = e1, l = e1 + 1;
            if ("number" != typeof n) return i.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
            if (a.length && a[a.length - 1][0] >= n) return i.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
            let c = i.parse(s, l, r);
            if (!c) return null;
            r ||= c.type, a.push([
                n,
                c
            ]);
        }
        return new e1(r, n, a, i.key);
    }
    evaluate(e1) {
        let t = this.labels, i = this.outputs;
        if (1 === t.length) return i[0].evaluate(e1);
        let n = this.input.evaluate(e1);
        if (n <= t[0]) return i[0].evaluate(e1);
        let a = t.length;
        return n >= t[a - 1] ? i[a - 1].evaluate(e1) : i[$785da19a645c07eb$var$wp(t, n, this.key)].evaluate(e1);
    }
    eachChild(e1) {
        e1(this.input);
        for (let t of this.outputs)e1(t);
    }
    outputDefined() {
        return this.outputs.every((e1)=>e1.outputDefined());
    }
};
var $785da19a645c07eb$var$kp = class e1 {
    constructor(e1, t, i, n, a, r){
        this.type = e1, this.operator = t, this.interpolation = i, this.input = n, this.key = r, this.labels = [], this.outputs = [];
        for (let [e1, t] of a)this.labels.push(e1), this.outputs.push(t);
    }
    static interpolationFactor(e1, t, i, n) {
        let a = 0;
        if ("exponential" === e1.name) a = $785da19a645c07eb$var$Sp(t, e1.base, i, n);
        else if ("linear" === e1.name) a = $785da19a645c07eb$var$Sp(t, 1, i, n);
        else if ("cubic-bezier" === e1.name) {
            let r = e1.controlPoints;
            a = (function(e1, t, i, n) {
                let a = 3 * e1, r = 3 * (i - e1) - a, s = 1 - a - r, o = 3 * t, l = 3 * (n - t) - o, c = 1 - o - l;
                return function(e1, t = 1e-6) {
                    if (e1 <= 0) return 0;
                    if (e1 >= 1) return 1;
                    let i = e1;
                    for(let n = 0; n < 8; n++){
                        let n = ((s * i + r) * i + a) * i - e1;
                        if (Math.abs(n) < t) return ((c * i + l) * i + o) * i;
                        let u = (3 * s * i + 2 * r) * i + a;
                        if (Math.abs(u) < 1e-6) break;
                        i -= n / u;
                    }
                    let n = 0, u = 1;
                    i = e1;
                    for(let o = 0; o < 20; o++){
                        let o = ((s * i + r) * i + a) * i;
                        if (Math.abs(o - e1) < t) break;
                        e1 > o ? n = i : u = i, i = .5 * (n + u);
                    }
                    return ((c * i + l) * i + o) * i;
                };
            })(r[0], r[1], r[2], r[3])($785da19a645c07eb$var$Sp(t, 1, i, n));
        }
        return a;
    }
    static parse(t, i) {
        let [n, a, r, ...s] = t;
        if (!Array.isArray(a) || 0 === a.length) return i.error("Expected an interpolation type expression.", 1);
        if ("linear" === a[0]) a = {
            name: "linear"
        };
        else if ("exponential" === a[0]) {
            let e1 = a[1];
            if ("number" != typeof e1) return i.error("Exponential interpolation requires a numeric base.", 1, 1);
            a = {
                name: "exponential",
                base: e1
            };
        } else {
            if ("cubic-bezier" !== a[0]) return i.error(`Unknown interpolation type ${String(a[0])}`, 1, 0);
            {
                let e1 = a.slice(1);
                if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return i.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                a = {
                    name: "cubic-bezier",
                    controlPoints: e1
                };
            }
        }
        if (t.length - 1 < 4) return i.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
        if ((t.length - 1) % 2 != 0) return i.error("Expected an even number of arguments.");
        if (r = i.parse(r, 2, $785da19a645c07eb$var$hd), !r) return null;
        let o = [], l = null;
        "interpolate-hcl" !== n && "interpolate-lab" !== n || i.expectedType == $785da19a645c07eb$var$bd ? i.expectedType && "value" !== i.expectedType.kind && (l = i.expectedType) : l = $785da19a645c07eb$var$md;
        for(let e1 = 0; e1 < s.length; e1 += 2){
            let t = s[e1], n = s[e1 + 1], a = e1 + 3, r = e1 + 4;
            if ("number" != typeof t) return i.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
            if (o.length && o[o.length - 1][0] >= t) return i.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', a);
            let c = i.parse(n, r, l);
            if (!c) return null;
            l ||= c.type, o.push([
                t,
                c
            ]);
        }
        return $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$hd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$gd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$md) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$xd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$wd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$bd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$kd) || $785da19a645c07eb$var$Id(l, $785da19a645c07eb$var$Sd($785da19a645c07eb$var$hd)) ? new e1(l, n, a, r, o, i.key) : i.error(`Type ${$785da19a645c07eb$var$Md(l)} is not interpolatable.`);
    }
    evaluate(t) {
        let i = this.labels, n = this.outputs;
        if (1 === i.length) return n[0].evaluate(t);
        let a = this.input.evaluate(t);
        if (a <= i[0]) return n[0].evaluate(t);
        let r = i.length;
        if (a >= i[r - 1]) return n[r - 1].evaluate(t);
        let s = $785da19a645c07eb$var$wp(i, a, this.key), o = i[s], l = i[s + 1], c = e1.interpolationFactor(this.interpolation, a, o, l), u = n[s].evaluate(t), h = n[s + 1].evaluate(t);
        switch(this.operator){
            case "interpolate":
                switch(this.type.kind){
                    case "number":
                        return $785da19a645c07eb$var$tp(u, h, c);
                    case "color":
                        return $785da19a645c07eb$var$np.interpolate(u, h, c);
                    case "padding":
                        return $785da19a645c07eb$var$op.interpolate(u, h, c);
                    case "colorArray":
                        return $785da19a645c07eb$var$cp.interpolate(u, h, c);
                    case "numberArray":
                        return $785da19a645c07eb$var$lp.interpolate(u, h, c);
                    case "variableAnchorOffsetCollection":
                        return $785da19a645c07eb$var$dp.interpolate(u, h, c, this.key);
                    case "array":
                        return $785da19a645c07eb$var$ip(u, h, c);
                    case "projectionDefinition":
                        return $785da19a645c07eb$var$mp.interpolate(u, h, c);
                }
            case "interpolate-hcl":
                switch(this.type.kind){
                    case "color":
                        return $785da19a645c07eb$var$np.interpolate(u, h, c, "hcl");
                    case "colorArray":
                        return $785da19a645c07eb$var$cp.interpolate(u, h, c, "hcl");
                }
            case "interpolate-lab":
                switch(this.type.kind){
                    case "color":
                        return $785da19a645c07eb$var$np.interpolate(u, h, c, "lab");
                    case "colorArray":
                        return $785da19a645c07eb$var$cp.interpolate(u, h, c, "lab");
                }
        }
    }
    eachChild(e1) {
        e1(this.input);
        for (let t of this.outputs)e1(t);
    }
    outputDefined() {
        return this.outputs.every((e1)=>e1.outputDefined());
    }
};
function $785da19a645c07eb$var$Sp(e1, t, i, n) {
    let a = n - i, r = e1 - i;
    return 0 === a ? 0 : 1 === t ? r / a : (t ** +r - 1) / (t ** +a - 1);
}
const $785da19a645c07eb$var$Mp = {
    color: $785da19a645c07eb$var$np.interpolate,
    number: $785da19a645c07eb$var$tp,
    padding: $785da19a645c07eb$var$op.interpolate,
    numberArray: $785da19a645c07eb$var$lp.interpolate,
    colorArray: $785da19a645c07eb$var$cp.interpolate,
    variableAnchorOffsetCollection: $785da19a645c07eb$var$dp.interpolate,
    array: $785da19a645c07eb$var$ip
};
var $785da19a645c07eb$var$Cp = class e1 {
    constructor(e1){
        this.type = $785da19a645c07eb$var$yd, this.sections = e1;
    }
    static parse(t, i) {
        if (t.length < 2) return i.error("Expected at least one argument.");
        let n = t[1];
        if (!Array.isArray(n) && "object" == typeof n) return i.error("First argument must be an image or text section.");
        let a = [], r = !1;
        for(let e1 = 1; e1 <= t.length - 1; ++e1){
            let n = t[e1];
            if (r && "object" == typeof n && !Array.isArray(n)) {
                r = !1;
                let e1 = null;
                if (n["font-scale"] && (e1 = i.parse(n["font-scale"], 1, $785da19a645c07eb$var$hd), !e1)) return null;
                let t = null;
                if (n["text-font"] && (t = i.parse(n["text-font"], 1, $785da19a645c07eb$var$Sd($785da19a645c07eb$var$dd)), !t)) return null;
                let s = null;
                if (n["text-color"] && (s = i.parse(n["text-color"], 1, $785da19a645c07eb$var$md), !s)) return null;
                let o = null;
                if (n["vertical-align"]) {
                    if ("string" == typeof n["vertical-align"] && !$785da19a645c07eb$var$ap.includes(n["vertical-align"])) return i.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${n["vertical-align"]}' instead.`);
                    if (o = i.parse(n["vertical-align"], 1, $785da19a645c07eb$var$dd), !o) return null;
                }
                let l = a[a.length - 1];
                l.scale = e1, l.font = t, l.textColor = s, l.verticalAlign = o;
            } else {
                let n = i.parse(t[e1], 1, $785da19a645c07eb$var$Ad);
                if (!n) return null;
                let s = n.type.kind;
                if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return i.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                r = !0, a.push({
                    content: n,
                    scale: null,
                    font: null,
                    textColor: null,
                    verticalAlign: null
                });
            }
        }
        return new e1(a);
    }
    evaluate(e1) {
        return new $785da19a645c07eb$var$sp(this.sections.map((t)=>{
            let i = t.content.evaluate(e1);
            return $785da19a645c07eb$var$_p(i) === $785da19a645c07eb$var$Ed ? new $785da19a645c07eb$var$rp("", i, null, null, null, t.verticalAlign ? t.verticalAlign.evaluate(e1) : null) : new $785da19a645c07eb$var$rp($785da19a645c07eb$var$vp(i), null, t.scale ? t.scale.evaluate(e1) : null, t.font ? t.font.evaluate(e1).join(",") : null, t.textColor ? t.textColor.evaluate(e1) : null, t.verticalAlign ? t.verticalAlign.evaluate(e1) : null);
        }));
    }
    eachChild(e1) {
        for (let t of this.sections)e1(t.content), t.scale && e1(t.scale), t.font && e1(t.font), t.textColor && e1(t.textColor), t.verticalAlign && e1(t.verticalAlign);
    }
    outputDefined() {
        return !1;
    }
};
function $785da19a645c07eb$var$Tp(e1, t, i = 0, n = e1.length - 1, a = $785da19a645c07eb$var$Pp) {
    for(; n > i;){
        if (n - i > 600) {
            let r = n - i + 1, s = t - i + 1, o = Math.log(r), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (r - l) / r) * (s - r / 2 < 0 ? -1 : 1);
            $785da19a645c07eb$var$Tp(e1, t, Math.max(i, Math.floor(t - s * l / r + c)), Math.min(n, Math.floor(t + (r - s) * l / r + c)), a);
        }
        let r = e1[t], s = i, o = n;
        for($785da19a645c07eb$var$Dp(e1, i, t), a(e1[n], r) > 0 && $785da19a645c07eb$var$Dp(e1, i, n); s < o;){
            for($785da19a645c07eb$var$Dp(e1, s, o), s++, o--; a(e1[s], r) < 0;)s++;
            for(; a(e1[o], r) > 0;)o--;
        }
        0 === a(e1[i], r) ? $785da19a645c07eb$var$Dp(e1, i, o) : (o++, $785da19a645c07eb$var$Dp(e1, o, n)), o <= t && (i = o + 1), t <= o && (n = o - 1);
    }
}
function $785da19a645c07eb$var$Dp(e1, t, i) {
    let n = e1[t];
    e1[t] = e1[i], e1[i] = n;
}
function $785da19a645c07eb$var$Pp(e1, t) {
    return e1 < t ? -1 : +(e1 > t);
}
function $785da19a645c07eb$var$Ip(e1, t) {
    if (e1.length <= 1) return [
        e1
    ];
    let i, n, a = [];
    for (let t of e1){
        let e1 = $785da19a645c07eb$var$zp(t);
        0 !== e1 && (t.area = Math.abs(e1), void 0 === n && (n = e1 < 0), n === e1 < 0 ? (i && a.push(i), i = [
            t
        ]) : i.push(t));
    }
    if (i && a.push(i), t > 1) for(let e1 = 0; e1 < a.length; e1++)a[e1].length <= t || ($785da19a645c07eb$var$Tp(a[e1], t, 1, a[e1].length - 1, $785da19a645c07eb$var$Fp), a[e1] = a[e1].slice(0, t));
    return a;
}
function $785da19a645c07eb$var$Fp(e1, t) {
    return t.area - e1.area;
}
function $785da19a645c07eb$var$zp(e1) {
    let t = 0;
    for(let i, n, a = 0, r = e1.length, s = r - 1; a < r; s = a++)i = e1[a], n = e1[s], t += (n.x - i.x) * (i.y + n.y);
    return t;
}
const $785da19a645c07eb$var$Rp = {
    string: $785da19a645c07eb$var$dd,
    number: $785da19a645c07eb$var$hd,
    boolean: $785da19a645c07eb$var$pd,
    object: $785da19a645c07eb$var$fd
};
var $785da19a645c07eb$var$Lp = class e1 {
    constructor(e1, t, i){
        this.type = e1, this.args = t, this.key = i;
    }
    static parse(t, i) {
        if (t.length < 2) return i.error("Expected at least one argument.");
        let n, a = 1, r = t[0];
        if ("array" === r) {
            let e1, r;
            if (t.length > 2) {
                let n = t[1];
                if ("string" != typeof n || !(n in $785da19a645c07eb$var$Rp) || "object" === n) return i.error('The item type argument of "array" must be one of string, number, boolean', 1);
                e1 = $785da19a645c07eb$var$Rp[n], a++;
            } else e1 = $785da19a645c07eb$var$Ad;
            if (t.length > 3) {
                if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return i.error('The length argument to "array" must be a positive integer literal', 2);
                r = t[2], a++;
            }
            n = $785da19a645c07eb$var$Sd(e1, r);
        } else {
            if (!$785da19a645c07eb$var$Rp[r]) throw Error(`Types doesn't contain name = ${r}`);
            n = $785da19a645c07eb$var$Rp[r];
        }
        let s = [];
        for(; a < t.length; a++){
            let e1 = i.parse(t[a], a, $785da19a645c07eb$var$Ad);
            if (!e1) return null;
            s.push(e1);
        }
        return new e1(n, s, i.key);
    }
    evaluate(e1) {
        for(let t = 0; t < this.args.length; t++){
            let i = this.args[t].evaluate(e1);
            if (!$785da19a645c07eb$var$Td(this.type, $785da19a645c07eb$var$_p(i))) return i;
            if (t === this.args.length - 1) throw new $785da19a645c07eb$var$up(`Expected value to be of type ${$785da19a645c07eb$var$Md(this.type)}, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(i))} instead.`, this.key);
        }
        throw Error();
    }
    eachChild(e1) {
        this.args.forEach(e1);
    }
    outputDefined() {
        return this.args.every((e1)=>e1.outputDefined());
    }
};
const $785da19a645c07eb$var$Bp = {
    "to-boolean": $785da19a645c07eb$var$pd,
    "to-color": $785da19a645c07eb$var$md,
    "to-number": $785da19a645c07eb$var$hd,
    "to-string": $785da19a645c07eb$var$dd
};
var $785da19a645c07eb$var$Op = class e1 {
    constructor(e1, t, i){
        this.type = e1, this.args = t, this.key = i;
    }
    static parse(t, i) {
        if (t.length < 2) return i.error("Expected at least one argument.");
        let n = t[0];
        if (!$785da19a645c07eb$var$Bp[n]) throw Error(`Can't parse ${n} as it is not part of the known types`);
        if (("to-boolean" === n || "to-string" === n) && 2 !== t.length) return i.error("Expected one argument.");
        let a = $785da19a645c07eb$var$Bp[n], r = [];
        for(let e1 = 1; e1 < t.length; e1++){
            let n = i.parse(t[e1], e1, $785da19a645c07eb$var$Ad);
            if (!n) return null;
            r.push(n);
        }
        return new e1(a, r, i.key);
    }
    evaluate(e1) {
        switch(this.type.kind){
            case "boolean":
                return !!this.args[0].evaluate(e1);
            case "color":
                {
                    let t, i;
                    for (let n of this.args){
                        if (t = n.evaluate(e1), i = null, t instanceof $785da19a645c07eb$var$np) return t;
                        if ("string" == typeof t) {
                            let i = e1.parseColor(t);
                            if (i) return i;
                        } else if (Array.isArray(t) && (i = t.length < 3 || t.length > 4 ? `Invalid rgba value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : $785da19a645c07eb$var$fp(t[0], t[1], t[2], t[3]), !i)) return new $785da19a645c07eb$var$np(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                    }
                    throw new $785da19a645c07eb$var$up(i || `Could not parse color from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            case "padding":
                {
                    let t;
                    for (let i of this.args){
                        t = i.evaluate(e1);
                        let n = $785da19a645c07eb$var$op.parse(t);
                        if (n) return n;
                    }
                    throw new $785da19a645c07eb$var$up(`Could not parse padding from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            case "numberArray":
                {
                    let t;
                    for (let i of this.args){
                        t = i.evaluate(e1);
                        let n = $785da19a645c07eb$var$lp.parse(t);
                        if (n) return n;
                    }
                    throw new $785da19a645c07eb$var$up(`Could not parse numberArray from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            case "colorArray":
                {
                    let t;
                    for (let i of this.args){
                        t = i.evaluate(e1);
                        let n = $785da19a645c07eb$var$cp.parse(t);
                        if (n) return n;
                    }
                    throw new $785da19a645c07eb$var$up(`Could not parse colorArray from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            case "variableAnchorOffsetCollection":
                {
                    let t;
                    for (let i of this.args){
                        t = i.evaluate(e1);
                        let n = $785da19a645c07eb$var$dp.parse(t);
                        if (n) return n;
                    }
                    throw new $785da19a645c07eb$var$up(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            case "number":
                {
                    let t = null;
                    for (let i of this.args){
                        if (t = i.evaluate(e1), null === t) return 0;
                        let n = Number(t);
                        if (!isNaN(n)) return n;
                    }
                    throw new $785da19a645c07eb$var$up(`Could not convert ${JSON.stringify(t)} to number.`, this.key);
                }
            case "formatted":
                return $785da19a645c07eb$var$sp.fromString($785da19a645c07eb$var$vp(this.args[0].evaluate(e1)));
            case "resolvedImage":
                return $785da19a645c07eb$var$pp.fromString($785da19a645c07eb$var$vp(this.args[0].evaluate(e1)));
            case "projectionDefinition":
                {
                    let t = this.args[0].evaluate(e1);
                    if ($785da19a645c07eb$var$mp.parse(t)) return t;
                    throw new $785da19a645c07eb$var$up(`Could not parse projectionDefinition from value '${"string" == typeof t ? t : JSON.stringify(t)}'`, this.key);
                }
            default:
                return $785da19a645c07eb$var$vp(this.args[0].evaluate(e1));
        }
    }
    eachChild(e1) {
        this.args.forEach(e1);
    }
    outputDefined() {
        return this.args.every((e1)=>e1.outputDefined());
    }
}, $785da19a645c07eb$var$Up = class e1 {
    constructor(e1, t){
        this.type = t.type, this.bindings = [].concat(e1), this.result = t;
    }
    evaluate(e1) {
        return this.result.evaluate(e1);
    }
    eachChild(e1) {
        for (let t of this.bindings)e1(t[1]);
        e1(this.result);
    }
    static parse(t, i) {
        if (t.length < 4) return i.error(`Expected at least 3 arguments, but found ${t.length - 1} instead.`);
        let n = [];
        for(let e1 = 1; e1 < t.length - 1; e1 += 2){
            let a = t[e1];
            if ("string" != typeof a) return i.error(`Expected string, but found ${typeof a} instead.`, e1);
            if (/[^a-zA-Z0-9_]/.test(a)) return i.error("Variable names must contain only alphanumeric characters or '_'.", e1);
            let r = i.parse(t[e1 + 1], e1 + 1);
            if (!r) return null;
            n.push([
                a,
                r
            ]);
        }
        let a = i.parse(t[t.length - 1], t.length - 1, i.expectedType, n);
        return a ? new e1(n, a) : null;
    }
    outputDefined() {
        return this.result.outputDefined();
    }
}, $785da19a645c07eb$var$Np = class e1 {
    constructor(e1, t){
        this.type = t.type, this.name = e1, this.boundExpression = t;
    }
    static parse(t, i) {
        if (2 !== t.length || "string" != typeof t[1]) return i.error("'var' expression requires exactly one string literal argument.");
        let n = t[1];
        return i.scope.has(n) ? new e1(n, i.scope.get(n)) : i.error(`Unknown variable "${n}". Make sure "${n}" has been bound in an enclosing "let" expression before using it.`, 1);
    }
    evaluate(e1) {
        return this.boundExpression.evaluate(e1);
    }
    eachChild() {}
    outputDefined() {
        return !1;
    }
}, $785da19a645c07eb$var$jp = class e1 {
    constructor(e1, t){
        this.type = e1, this.args = t;
    }
    static parse(t, i) {
        if (t.length < 2) return i.error("Expected at least one argument.");
        let n = null, a = i.expectedType;
        a && "value" !== a.kind && (n = a);
        let r = [];
        for (let e1 of t.slice(1)){
            let t = i.parse(e1, 1 + r.length, n, void 0, {
                typeAnnotation: "omit"
            });
            if (!t) return null;
            n ||= t.type, r.push(t);
        }
        if (!n) throw Error("No output type");
        return a && r.some((e1)=>$785da19a645c07eb$var$Td(a, e1.type)) ? new e1($785da19a645c07eb$var$Ad, r) : new e1(n, r);
    }
    evaluate(e1) {
        let t, i = null, n = 0;
        for (let a of this.args)if (n++, i = a.evaluate(e1), i && i instanceof $785da19a645c07eb$var$pp && !i.available && (t ||= i.name, i = null, n === this.args.length && (i = t)), null !== i) break;
        return i;
    }
    eachChild(e1) {
        this.args.forEach(e1);
    }
    outputDefined() {
        return this.args.every((e1)=>e1.outputDefined());
    }
};
function $785da19a645c07eb$var$Vp(e1, t) {
    return "==" === e1 || "!=" === e1 ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
}
function $785da19a645c07eb$var$qp(e1, t, i, n) {
    return 0 === n.compare(t, i);
}
function $785da19a645c07eb$var$Gp(e1, t, i) {
    let n = "==" !== e1 && "!=" !== e1;
    return class a {
        constructor(e1, t, i, n){
            this.lhs = e1, this.rhs = t, this.key = i, this.collator = n, this.type = $785da19a645c07eb$var$pd, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t.type.kind;
        }
        static parse(e1, t) {
            if (3 !== e1.length && 4 !== e1.length) return t.error("Expected two or three arguments.");
            let i = e1[0], r = t.parse(e1[1], 1, $785da19a645c07eb$var$Ad);
            if (!r) return null;
            if (!$785da19a645c07eb$var$Vp(i, r.type)) return t.concat(1).error(`"${i}" comparisons are not supported for type '${$785da19a645c07eb$var$Md(r.type)}'.`);
            let s = t.parse(e1[2], 2, $785da19a645c07eb$var$Ad);
            if (!s) return null;
            if (!$785da19a645c07eb$var$Vp(i, s.type)) return t.concat(2).error(`"${i}" comparisons are not supported for type '${$785da19a645c07eb$var$Md(s.type)}'.`);
            if (r.type.kind !== s.type.kind && "value" !== r.type.kind && "value" !== s.type.kind) return t.error(`Cannot compare types '${$785da19a645c07eb$var$Md(r.type)}' and '${$785da19a645c07eb$var$Md(s.type)}'.`);
            n && ("value" === r.type.kind && "value" !== s.type.kind ? r = new $785da19a645c07eb$var$Lp(s.type, [
                r
            ], t.key) : "value" !== r.type.kind && "value" === s.type.kind && (s = new $785da19a645c07eb$var$Lp(r.type, [
                s
            ], t.key)));
            let o = null;
            if (4 === e1.length) {
                if ("string" !== r.type.kind && "string" !== s.type.kind && "value" !== r.type.kind && "value" !== s.type.kind) return t.error("Cannot use collator to compare non-string types.");
                if (o = t.parse(e1[3], 3, $785da19a645c07eb$var$vd), !o) return null;
            }
            return new a(r, s, t.key, o);
        }
        evaluate(a) {
            let r = this.lhs.evaluate(a), s = this.rhs.evaluate(a);
            if (n && this.hasUntypedArgument) {
                let t = $785da19a645c07eb$var$_p(r), i = $785da19a645c07eb$var$_p(s);
                if (t.kind !== i.kind || "string" !== t.kind && "number" !== t.kind) throw new $785da19a645c07eb$var$up(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t.kind}, ${i.kind}) instead.`, this.key);
            }
            if (this.collator && !n && this.hasUntypedArgument) {
                let e1 = $785da19a645c07eb$var$_p(r), i = $785da19a645c07eb$var$_p(s);
                if ("string" !== e1.kind || "string" !== i.kind) return t(a, r, s);
            }
            return this.collator ? i(a, r, s, this.collator.evaluate(a)) : t(a, r, s);
        }
        eachChild(e1) {
            e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
        }
        outputDefined() {
            return !0;
        }
    };
}
const $785da19a645c07eb$var$Hp = $785da19a645c07eb$var$Gp("==", function(e1, t, i) {
    return t === i;
}, $785da19a645c07eb$var$qp), $785da19a645c07eb$var$Wp = $785da19a645c07eb$var$Gp("!=", function(e1, t, i) {
    return t !== i;
}, function(e1, t, i, n) {
    return !$785da19a645c07eb$var$qp(0, t, i, n);
}), $785da19a645c07eb$var$Zp = $785da19a645c07eb$var$Gp("<", function(e1, t, i) {
    return t < i;
}, function(e1, t, i, n) {
    return n.compare(t, i) < 0;
}), $785da19a645c07eb$var$Kp = $785da19a645c07eb$var$Gp(">", function(e1, t, i) {
    return t > i;
}, function(e1, t, i, n) {
    return n.compare(t, i) > 0;
}), $785da19a645c07eb$var$Xp = $785da19a645c07eb$var$Gp("<=", function(e1, t, i) {
    return t <= i;
}, function(e1, t, i, n) {
    return n.compare(t, i) <= 0;
}), $785da19a645c07eb$var$Qp = $785da19a645c07eb$var$Gp(">=", function(e1, t, i) {
    return t >= i;
}, function(e1, t, i, n) {
    return n.compare(t, i) >= 0;
});
var $785da19a645c07eb$var$Yp = class e1 {
    constructor(e1, t, i){
        this.type = $785da19a645c07eb$var$vd, this.locale = i, this.caseSensitive = e1, this.diacriticSensitive = t;
    }
    static parse(t, i) {
        if (2 !== t.length) return i.error("Expected one argument.");
        let n = t[1];
        if ("object" != typeof n || Array.isArray(n)) return i.error("Collator options argument must be an object.");
        let a = i.parse(void 0 !== n["case-sensitive"] && n["case-sensitive"], 1, $785da19a645c07eb$var$pd);
        if (!a) return null;
        let r = i.parse(void 0 !== n["diacritic-sensitive"] && n["diacritic-sensitive"], 1, $785da19a645c07eb$var$pd);
        if (!r) return null;
        let s = null;
        return n.locale && (s = i.parse(n.locale, 1, $785da19a645c07eb$var$dd), !s) ? null : new e1(a, r, s);
    }
    evaluate(e1) {
        return new $785da19a645c07eb$var$gp(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
    }
    eachChild(e1) {
        e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
    }
    outputDefined() {
        return !1;
    }
};
const $785da19a645c07eb$var$Jp = 8192;
function $785da19a645c07eb$var$$p(e1, t) {
    let i = function(e1) {
        return (180 + e1) / 360;
    }(e1[0]), n = function(e1) {
        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
    }(e1[1]), a = 2 ** t.z;
    return [
        Math.round(i * a * $785da19a645c07eb$var$Jp),
        Math.round(n * a * $785da19a645c07eb$var$Jp)
    ];
}
function $785da19a645c07eb$var$em(e1, t) {
    let i = 2 ** t.z, n = (e1[0] / $785da19a645c07eb$var$Jp + t.x) / i, a = (e1[1] / $785da19a645c07eb$var$Jp + t.y) / i;
    return [
        $785da19a645c07eb$var$tm(n),
        $785da19a645c07eb$var$im(a)
    ];
}
function $785da19a645c07eb$var$tm(e1) {
    return 360 * e1 - 180;
}
function $785da19a645c07eb$var$im(e1) {
    return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
}
function $785da19a645c07eb$var$nm(e1, t) {
    e1[0] = Math.min(e1[0], t[0]), e1[1] = Math.min(e1[1], t[1]), e1[2] = Math.max(e1[2], t[0]), e1[3] = Math.max(e1[3], t[1]);
}
function $785da19a645c07eb$var$am(e1, t) {
    return !(e1[0] <= t[0] || e1[2] >= t[2] || e1[1] <= t[1] || e1[3] >= t[3]);
}
function $785da19a645c07eb$var$rm(e1, t, i) {
    return t[1] > e1[1] != i[1] > e1[1] && e1[0] < (i[0] - t[0]) * (e1[1] - t[1]) / (i[1] - t[1]) + t[0];
}
function $785da19a645c07eb$var$sm(e1, t, i) {
    let n = e1[0] - t[0], a = e1[1] - t[1], r = e1[0] - i[0], s = e1[1] - i[1];
    return n * s - r * a === 0 && n * r <= 0 && a * s <= 0;
}
function $785da19a645c07eb$var$om(e1, t, i, n) {
    let a = [
        t[0] - e1[0],
        t[1] - e1[1]
    ];
    return 0 !== function(e1, t) {
        return e1[0] * t[1] - e1[1] * t[0];
    }([
        n[0] - i[0],
        n[1] - i[1]
    ], a) && !(!$785da19a645c07eb$var$pm(e1, t, i, n) || !$785da19a645c07eb$var$pm(i, n, e1, t));
}
function $785da19a645c07eb$var$lm(e1, t, i) {
    for (let n of i)for(let i = 0; i < n.length - 1; ++i)if ($785da19a645c07eb$var$om(e1, t, n[i], n[i + 1])) return !0;
    return !1;
}
function $785da19a645c07eb$var$cm(e1, t, i = !1) {
    let n = !1;
    for (let a of t)for(let t = 0; t < a.length - 1; t++){
        if ($785da19a645c07eb$var$sm(e1, a[t], a[t + 1])) return i;
        $785da19a645c07eb$var$rm(e1, a[t], a[t + 1]) && (n = !n);
    }
    return n;
}
function $785da19a645c07eb$var$um(e1, t) {
    for (let i of t)if ($785da19a645c07eb$var$cm(e1, i)) return !0;
    return !1;
}
function $785da19a645c07eb$var$hm(e1, t) {
    for (let i of e1)if (!$785da19a645c07eb$var$cm(i, t)) return !1;
    for(let i = 0; i < e1.length - 1; ++i)if ($785da19a645c07eb$var$lm(e1[i], e1[i + 1], t)) return !1;
    return !0;
}
function $785da19a645c07eb$var$dm(e1, t) {
    for (let i of t)if ($785da19a645c07eb$var$hm(e1, i)) return !0;
    return !1;
}
function $785da19a645c07eb$var$pm(e1, t, i, n) {
    let a = e1[0] - i[0], r = e1[1] - i[1], s = t[0] - i[0], o = t[1] - i[1], l = n[0] - i[0], c = n[1] - i[1], u = a * c - l * r, h = s * c - l * o;
    return u > 0 && h < 0 || u < 0 && h > 0;
}
function $785da19a645c07eb$var$mm(e1, t, i) {
    let n = [];
    for(let a = 0; a < e1.length; a++){
        let r = [];
        for(let n = 0; n < e1[a].length; n++){
            let s = $785da19a645c07eb$var$$p(e1[a][n], i);
            $785da19a645c07eb$var$nm(t, s), r.push(s);
        }
        n.push(r);
    }
    return n;
}
function $785da19a645c07eb$var$gm(e1, t, i) {
    let n = [];
    for(let a = 0; a < e1.length; a++){
        let r = $785da19a645c07eb$var$mm(e1[a], t, i);
        n.push(r);
    }
    return n;
}
function $785da19a645c07eb$var$fm(e1, t, i, n) {
    if (e1[0] < i[0] || e1[0] > i[2]) {
        let t = .5 * n, a = e1[0] - i[0] > t ? -n : i[0] - e1[0] > t ? n : 0;
        0 === a && (a = e1[0] - i[2] > t ? -n : i[2] - e1[0] > t ? n : 0), e1[0] += a;
    }
    $785da19a645c07eb$var$nm(t, e1);
}
function $785da19a645c07eb$var$Am(e1, t, i, n) {
    let a = 2 ** n.z * $785da19a645c07eb$var$Jp, r = [
        n.x * $785da19a645c07eb$var$Jp,
        n.y * $785da19a645c07eb$var$Jp
    ], s = [];
    for (let n of e1)for (let e1 of n){
        let n = [
            e1.x + r[0],
            e1.y + r[1]
        ];
        $785da19a645c07eb$var$fm(n, t, i, a), s.push(n);
    }
    return s;
}
function $785da19a645c07eb$var$_m(e1, t, i, n) {
    let a = 2 ** n.z * $785da19a645c07eb$var$Jp, r = [
        n.x * $785da19a645c07eb$var$Jp,
        n.y * $785da19a645c07eb$var$Jp
    ], s = [];
    for (let i of e1){
        let e1 = [];
        for (let n of i){
            let i = [
                n.x + r[0],
                n.y + r[1]
            ];
            $785da19a645c07eb$var$nm(t, i), e1.push(i);
        }
        s.push(e1);
    }
    if (t[2] - t[0] <= a / 2) {
        !function(e1) {
            e1[0] = e1[1] = 1 / 0, e1[2] = e1[3] = -1 / 0;
        }(t);
        for (let e1 of s)for (let n of e1)$785da19a645c07eb$var$fm(n, t, i, a);
    }
    return s;
}
var $785da19a645c07eb$var$vm = class e1 {
    constructor(e1, t){
        this.type = $785da19a645c07eb$var$pd, this.geojson = e1, this.geometries = t;
    }
    static parse(t, i) {
        if (2 !== t.length) return i.error(`'within' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if ($785da19a645c07eb$var$Ap(t[1])) {
            let i = t[1];
            if ("FeatureCollection" === i.type) {
                let t = [];
                for (let e1 of i.features){
                    let { type: i, coordinates: n } = e1.geometry;
                    "Polygon" === i && t.push(n), "MultiPolygon" === i && t.push(...n);
                }
                if (t.length) return new e1(i, {
                    type: "MultiPolygon",
                    coordinates: t
                });
            } else if ("Feature" === i.type) {
                let t = i.geometry.type;
                if ("Polygon" === t || "MultiPolygon" === t) return new e1(i, i.geometry);
            } else if ("Polygon" === i.type || "MultiPolygon" === i.type) return new e1(i, i);
        }
        return i.error("'within' expression requires valid geojson object that contains polygon geometry type.");
    }
    evaluate(e1) {
        if (null != e1.geometry() && null != e1.canonicalID()) {
            if ("Point" === e1.geometryType()) return function(e1, t) {
                let i = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], n = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], a = e1.canonicalID();
                if ("Polygon" === t.type) {
                    let r = $785da19a645c07eb$var$mm(t.coordinates, n, a), s = $785da19a645c07eb$var$Am(e1.geometry(), i, n, a);
                    if (!$785da19a645c07eb$var$am(i, n)) return !1;
                    for (let e1 of s)if (!$785da19a645c07eb$var$cm(e1, r)) return !1;
                }
                if ("MultiPolygon" === t.type) {
                    let r = $785da19a645c07eb$var$gm(t.coordinates, n, a), s = $785da19a645c07eb$var$Am(e1.geometry(), i, n, a);
                    if (!$785da19a645c07eb$var$am(i, n)) return !1;
                    for (let e1 of s)if (!$785da19a645c07eb$var$um(e1, r)) return !1;
                }
                return !0;
            }(e1, this.geometries);
            if ("LineString" === e1.geometryType()) return function(e1, t) {
                let i = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], n = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], a = e1.canonicalID();
                if ("Polygon" === t.type) {
                    let r = $785da19a645c07eb$var$mm(t.coordinates, n, a), s = $785da19a645c07eb$var$_m(e1.geometry(), i, n, a);
                    if (!$785da19a645c07eb$var$am(i, n)) return !1;
                    for (let e1 of s)if (!$785da19a645c07eb$var$hm(e1, r)) return !1;
                }
                if ("MultiPolygon" === t.type) {
                    let r = $785da19a645c07eb$var$gm(t.coordinates, n, a), s = $785da19a645c07eb$var$_m(e1.geometry(), i, n, a);
                    if (!$785da19a645c07eb$var$am(i, n)) return !1;
                    for (let e1 of s)if (!$785da19a645c07eb$var$dm(e1, r)) return !1;
                }
                return !0;
            }(e1, this.geometries);
        }
        return !1;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
}, $785da19a645c07eb$var$ym = class {
    constructor(e1 = [], t = (e1, t)=>e1 < t ? -1 : +(e1 > t)){
        if (this.data = e1, this.length = this.data.length, this.compare = t, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
    }
    push(e1) {
        this.data.push(e1), this._up(this.length++);
    }
    pop() {
        if (0 === this.length) return;
        let e1 = this.data[0], t = this.data.pop();
        return --this.length > 0 && (this.data[0] = t, this._down(0)), e1;
    }
    peek() {
        return this.data[0];
    }
    _up(e1) {
        let { data: t, compare: i } = this, n = t[e1];
        for(; e1 > 0;){
            let a = e1 - 1 >> 1, r = t[a];
            if (i(n, r) >= 0) break;
            t[e1] = r, e1 = a;
        }
        t[e1] = n;
    }
    _down(e1) {
        let { data: t, compare: i } = this, n = this.length >> 1, a = t[e1];
        for(; e1 < n;){
            let n = 1 + (e1 << 1), r = n + 1;
            if (r < this.length && i(t[r], t[n]) < 0 && (n = r), i(t[n], a) >= 0) break;
            t[e1] = t[n], e1 = n;
        }
        t[e1] = a;
    }
};
const $785da19a645c07eb$var$xm = Math.PI / 180;
var $785da19a645c07eb$var$bm = class {
    constructor(e1){
        let t = 6378.137 * $785da19a645c07eb$var$xm * 1e3, i = Math.cos(e1 * $785da19a645c07eb$var$xm), n = 1 / (1 - .0066943799901413165 * (1 - i * i)), a = Math.sqrt(n);
        this.kx = t * a * i, this.ky = t * a * n * .9933056200098587;
    }
    distance(e1, t) {
        let i = this.wrap(e1[0] - t[0]) * this.kx, n = (e1[1] - t[1]) * this.ky;
        return Math.sqrt(i * i + n * n);
    }
    pointOnLine(e1, t) {
        let i, n, a, r, s = 1 / 0;
        for(let o = 0; o < e1.length - 1; o++){
            let l = e1[o][0], c = e1[o][1], u = this.wrap(e1[o + 1][0] - l) * this.kx, h = (e1[o + 1][1] - c) * this.ky, d = 0;
            (0 !== u || 0 !== h) && (d = (this.wrap(t[0] - l) * this.kx * u + (t[1] - c) * this.ky * h) / (u * u + h * h), d > 1 ? (l = e1[o + 1][0], c = e1[o + 1][1]) : d > 0 && (l += u / this.kx * d, c += h / this.ky * d)), u = this.wrap(t[0] - l) * this.kx, h = (t[1] - c) * this.ky;
            let p = u * u + h * h;
            p < s && (s = p, i = l, n = c, a = o, r = d);
        }
        return {
            point: [
                i,
                n
            ],
            index: a,
            t: Math.max(0, Math.min(1, r))
        };
    }
    wrap(e1) {
        for(; e1 < -180;)e1 += 360;
        for(; e1 > 180;)e1 -= 360;
        return e1;
    }
};
function $785da19a645c07eb$var$wm(e1, t) {
    return t[0] - e1[0];
}
function $785da19a645c07eb$var$Em(e1) {
    return e1[1] - e1[0] + 1;
}
function $785da19a645c07eb$var$km(e1, t) {
    return e1[1] >= e1[0] && e1[1] < t;
}
function $785da19a645c07eb$var$Sm(e1, t) {
    if (e1[0] > e1[1]) return [
        null,
        null
    ];
    let i = $785da19a645c07eb$var$Em(e1);
    if (t) {
        if (2 === i) return [
            e1,
            null
        ];
        let t = Math.floor(i / 2);
        return [
            [
                e1[0],
                e1[0] + t
            ],
            [
                e1[0] + t,
                e1[1]
            ]
        ];
    }
    if (1 === i) return [
        e1,
        null
    ];
    let n = Math.floor(i / 2) - 1;
    return [
        [
            e1[0],
            e1[0] + n
        ],
        [
            e1[0] + n + 1,
            e1[1]
        ]
    ];
}
function $785da19a645c07eb$var$Mm(e1, t) {
    if (!$785da19a645c07eb$var$km(t, e1.length)) return [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    let i = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for(let n = t[0]; n <= t[1]; ++n)$785da19a645c07eb$var$nm(i, e1[n]);
    return i;
}
function $785da19a645c07eb$var$Cm(e1) {
    let t = [
        1 / 0,
        1 / 0,
        -1 / 0,
        -1 / 0
    ];
    for (let i of e1)for (let e1 of i)$785da19a645c07eb$var$nm(t, e1);
    return t;
}
function $785da19a645c07eb$var$Tm(e1) {
    return e1[0] !== -1 / 0 && e1[1] !== -1 / 0 && e1[2] !== 1 / 0 && e1[3] !== 1 / 0;
}
function $785da19a645c07eb$var$Dm(e1, t, i) {
    if (!$785da19a645c07eb$var$Tm(e1) || !$785da19a645c07eb$var$Tm(t)) return NaN;
    let n = 0, a = 0;
    return e1[2] < t[0] && (n = t[0] - e1[2]), e1[0] > t[2] && (n = e1[0] - t[2]), e1[1] > t[3] && (a = e1[1] - t[3]), e1[3] < t[1] && (a = t[1] - e1[3]), i.distance([
        0,
        0
    ], [
        n,
        a
    ]);
}
function $785da19a645c07eb$var$Pm(e1, t, i) {
    let n = i.pointOnLine(t, e1);
    return i.distance(e1, n.point);
}
function $785da19a645c07eb$var$Im(e1, t, i, n, a) {
    let r = Math.min($785da19a645c07eb$var$Pm(e1, [
        i,
        n
    ], a), $785da19a645c07eb$var$Pm(t, [
        i,
        n
    ], a)), s = Math.min($785da19a645c07eb$var$Pm(i, [
        e1,
        t
    ], a), $785da19a645c07eb$var$Pm(n, [
        e1,
        t
    ], a));
    return Math.min(r, s);
}
function $785da19a645c07eb$var$Fm(e1, t, i, n, a) {
    if (!$785da19a645c07eb$var$km(t, e1.length) || !$785da19a645c07eb$var$km(n, i.length)) return 1 / 0;
    let r = 1 / 0;
    for(let s = t[0]; s < t[1]; ++s){
        let t = e1[s], o = e1[s + 1];
        for(let e1 = n[0]; e1 < n[1]; ++e1){
            let n = i[e1], s = i[e1 + 1];
            if ($785da19a645c07eb$var$om(t, o, n, s)) return 0;
            r = Math.min(r, $785da19a645c07eb$var$Im(t, o, n, s, a));
        }
    }
    return r;
}
function $785da19a645c07eb$var$zm(e1, t, i, n, a) {
    if (!$785da19a645c07eb$var$km(t, e1.length) || !$785da19a645c07eb$var$km(n, i.length)) return NaN;
    let r = 1 / 0;
    for(let s = t[0]; s <= t[1]; ++s)for(let t = n[0]; t <= n[1]; ++t)if (r = Math.min(r, a.distance(e1[s], i[t])), 0 === r) return r;
    return r;
}
function $785da19a645c07eb$var$Rm(e1, t, i) {
    if ($785da19a645c07eb$var$cm(e1, t, !0)) return 0;
    let n = 1 / 0;
    for (let a of t){
        let t = a[0], r = a[a.length - 1];
        if (t !== r && (n = Math.min(n, $785da19a645c07eb$var$Pm(e1, [
            r,
            t
        ], i)), 0 === n)) return n;
        let s = i.pointOnLine(a, e1);
        if (n = Math.min(n, i.distance(e1, s.point)), 0 === n) return n;
    }
    return n;
}
function $785da19a645c07eb$var$Lm(e1, t, i, n) {
    if (!$785da19a645c07eb$var$km(t, e1.length)) return NaN;
    for(let n = t[0]; n <= t[1]; ++n)if ($785da19a645c07eb$var$cm(e1[n], i, !0)) return 0;
    let a = 1 / 0;
    for(let r = t[0]; r < t[1]; ++r){
        let t = e1[r], s = e1[r + 1];
        for (let e1 of i)for(let i = 0, r = e1.length, o = r - 1; i < r; o = i++){
            let r = e1[o], l = e1[i];
            if ($785da19a645c07eb$var$om(t, s, r, l)) return 0;
            a = Math.min(a, $785da19a645c07eb$var$Im(t, s, r, l, n));
        }
    }
    return a;
}
function $785da19a645c07eb$var$Bm(e1, t) {
    for (let i of e1)for (let e1 of i)if ($785da19a645c07eb$var$cm(e1, t, !0)) return !0;
    return !1;
}
function $785da19a645c07eb$var$Om(e1, t, i, n = 1 / 0) {
    let a = $785da19a645c07eb$var$Cm(e1), r = $785da19a645c07eb$var$Cm(t);
    if (n !== 1 / 0 && $785da19a645c07eb$var$Dm(a, r, i) >= n) return n;
    if ($785da19a645c07eb$var$am(a, r)) {
        if ($785da19a645c07eb$var$Bm(e1, t)) return 0;
    } else if ($785da19a645c07eb$var$Bm(t, e1)) return 0;
    let s = 1 / 0;
    for (let n of e1)for(let e1 = 0, a = n.length, r = a - 1; e1 < a; r = e1++){
        let a = n[r], o = n[e1];
        for (let e1 of t)for(let t = 0, n = e1.length, r = n - 1; t < n; r = t++){
            let n = e1[r], l = e1[t];
            if ($785da19a645c07eb$var$om(a, o, n, l)) return 0;
            s = Math.min(s, $785da19a645c07eb$var$Im(a, o, n, l, i));
        }
    }
    return s;
}
function $785da19a645c07eb$var$Um(e1, t, i, n, a, r) {
    if (!r) return;
    let s = $785da19a645c07eb$var$Dm($785da19a645c07eb$var$Mm(n, r), a, i);
    s < t && e1.push([
        s,
        r,
        [
            0,
            0
        ]
    ]);
}
function $785da19a645c07eb$var$Nm(e1, t, i, n, a, r, s) {
    if (!r || !s) return;
    let o = $785da19a645c07eb$var$Dm($785da19a645c07eb$var$Mm(n, r), $785da19a645c07eb$var$Mm(a, s), i);
    o < t && e1.push([
        o,
        r,
        s
    ]);
}
function $785da19a645c07eb$var$jm(e1, t, i, n, a = 1 / 0) {
    let r = Math.min(n.distance(e1[0], i[0][0]), a);
    if (0 === r) return r;
    let s = new $785da19a645c07eb$var$ym([
        [
            0,
            [
                0,
                e1.length - 1
            ],
            [
                0,
                0
            ]
        ]
    ], $785da19a645c07eb$var$wm), o = $785da19a645c07eb$var$Cm(i);
    for(; s.length > 0;){
        let a = s.pop();
        if (a[0] >= r) continue;
        let l = a[1], c = t ? 50 : 100;
        if ($785da19a645c07eb$var$Em(l) <= c) {
            if (!$785da19a645c07eb$var$km(l, e1.length)) return NaN;
            if (t) {
                let t = $785da19a645c07eb$var$Lm(e1, l, i, n);
                if (isNaN(t) || 0 === t) return t;
                r = Math.min(r, t);
            } else for(let t = l[0]; t <= l[1]; ++t){
                let a = $785da19a645c07eb$var$Rm(e1[t], i, n);
                if (r = Math.min(r, a), 0 === r) return 0;
            }
        } else {
            let i = $785da19a645c07eb$var$Sm(l, t);
            $785da19a645c07eb$var$Um(s, r, n, e1, o, i[0]), $785da19a645c07eb$var$Um(s, r, n, e1, o, i[1]);
        }
    }
    return r;
}
function $785da19a645c07eb$var$Vm(e1, t, i, n, a, r = 1 / 0) {
    let s = Math.min(r, a.distance(e1[0], i[0]));
    if (0 === s) return s;
    let o = new $785da19a645c07eb$var$ym([
        [
            0,
            [
                0,
                e1.length - 1
            ],
            [
                0,
                i.length - 1
            ]
        ]
    ], $785da19a645c07eb$var$wm);
    for(; o.length > 0;){
        let r = o.pop();
        if (r[0] >= s) continue;
        let l = r[1], c = r[2], u = t ? 50 : 100, h = n ? 50 : 100;
        if ($785da19a645c07eb$var$Em(l) <= u && $785da19a645c07eb$var$Em(c) <= h) {
            if (!$785da19a645c07eb$var$km(l, e1.length) && $785da19a645c07eb$var$km(c, i.length)) return NaN;
            let r;
            if (t && n) r = $785da19a645c07eb$var$Fm(e1, l, i, c, a), s = Math.min(s, r);
            else if (t && !n) {
                let t = e1.slice(l[0], l[1] + 1);
                for(let e1 = c[0]; e1 <= c[1]; ++e1)if (r = $785da19a645c07eb$var$Pm(i[e1], t, a), s = Math.min(s, r), 0 === s) return s;
            } else if (!t && n) {
                let t = i.slice(c[0], c[1] + 1);
                for(let i = l[0]; i <= l[1]; ++i)if (r = $785da19a645c07eb$var$Pm(e1[i], t, a), s = Math.min(s, r), 0 === s) return s;
            } else r = $785da19a645c07eb$var$zm(e1, l, i, c, a), s = Math.min(s, r);
        } else {
            let r = $785da19a645c07eb$var$Sm(l, t), u = $785da19a645c07eb$var$Sm(c, n);
            $785da19a645c07eb$var$Nm(o, s, a, e1, i, r[0], u[0]), $785da19a645c07eb$var$Nm(o, s, a, e1, i, r[0], u[1]), $785da19a645c07eb$var$Nm(o, s, a, e1, i, r[1], u[0]), $785da19a645c07eb$var$Nm(o, s, a, e1, i, r[1], u[1]);
        }
    }
    return s;
}
function $785da19a645c07eb$var$qm(e1) {
    return "MultiPolygon" === e1.type ? e1.coordinates.map((e1)=>({
            type: "Polygon",
            coordinates: e1
        })) : "MultiLineString" === e1.type ? e1.coordinates.map((e1)=>({
            type: "LineString",
            coordinates: e1
        })) : "MultiPoint" === e1.type ? e1.coordinates.map((e1)=>({
            type: "Point",
            coordinates: e1
        })) : [
        e1
    ];
}
var $785da19a645c07eb$var$Gm = class e1 {
    constructor(e1, t){
        this.type = $785da19a645c07eb$var$hd, this.geojson = e1, this.geometries = t;
    }
    static parse(t, i) {
        if (2 !== t.length) return i.error(`'distance' expression requires exactly one argument, but found ${t.length - 1} instead.`);
        if ($785da19a645c07eb$var$Ap(t[1])) {
            let i = t[1];
            if ("FeatureCollection" === i.type) return new e1(i, i.features.map((e1)=>$785da19a645c07eb$var$qm(e1.geometry)).flat());
            if ("Feature" === i.type) return new e1(i, $785da19a645c07eb$var$qm(i.geometry));
            if ("type" in i && "coordinates" in i) return new e1(i, $785da19a645c07eb$var$qm(i));
        }
        return i.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
    }
    evaluate(e1) {
        if (null != e1.geometry() && null != e1.canonicalID()) {
            if ("Point" === e1.geometryType()) return function(e1, t) {
                let i = e1.geometry(), n = i.flat().map((t)=>$785da19a645c07eb$var$em([
                        t.x,
                        t.y
                    ], e1.canonical));
                if (0 === i.length) return NaN;
                let a = new $785da19a645c07eb$var$bm(n[0][1]), r = 1 / 0;
                for (let e1 of t){
                    switch(e1.type){
                        case "Point":
                            r = Math.min(r, $785da19a645c07eb$var$Vm(n, !1, [
                                e1.coordinates
                            ], !1, a, r));
                            break;
                        case "LineString":
                            r = Math.min(r, $785da19a645c07eb$var$Vm(n, !1, e1.coordinates, !0, a, r));
                            break;
                        case "Polygon":
                            r = Math.min(r, $785da19a645c07eb$var$jm(n, !1, e1.coordinates, a, r));
                    }
                    if (0 === r) return r;
                }
                return r;
            }(e1, this.geometries);
            if ("LineString" === e1.geometryType()) return function(e1, t) {
                let i = e1.geometry(), n = i.flat().map((t)=>$785da19a645c07eb$var$em([
                        t.x,
                        t.y
                    ], e1.canonical));
                if (0 === i.length) return NaN;
                let a = new $785da19a645c07eb$var$bm(n[0][1]), r = 1 / 0;
                for (let e1 of t){
                    switch(e1.type){
                        case "Point":
                            r = Math.min(r, $785da19a645c07eb$var$Vm(n, !0, [
                                e1.coordinates
                            ], !1, a, r));
                            break;
                        case "LineString":
                            r = Math.min(r, $785da19a645c07eb$var$Vm(n, !0, e1.coordinates, !0, a, r));
                            break;
                        case "Polygon":
                            r = Math.min(r, $785da19a645c07eb$var$jm(n, !0, e1.coordinates, a, r));
                    }
                    if (0 === r) return r;
                }
                return r;
            }(e1, this.geometries);
            if ("Polygon" === e1.geometryType()) return function(e1, t) {
                let i = e1.geometry();
                if (0 === i.length || 0 === i[0].length) return NaN;
                let n = $785da19a645c07eb$var$Ip(i, 0).map((t)=>t.map((t)=>t.map((t)=>$785da19a645c07eb$var$em([
                                t.x,
                                t.y
                            ], e1.canonical)))), a = new $785da19a645c07eb$var$bm(n[0][0][0][1]), r = 1 / 0;
                for (let e1 of t)for (let t of n){
                    switch(e1.type){
                        case "Point":
                            r = Math.min(r, $785da19a645c07eb$var$jm([
                                e1.coordinates
                            ], !1, t, a, r));
                            break;
                        case "LineString":
                            r = Math.min(r, $785da19a645c07eb$var$jm(e1.coordinates, !0, t, a, r));
                            break;
                        case "Polygon":
                            r = Math.min(r, $785da19a645c07eb$var$Om(t, e1.coordinates, a, r));
                    }
                    if (0 === r) return r;
                }
                return r;
            }(e1, this.geometries);
        }
        return NaN;
    }
    eachChild() {}
    outputDefined() {
        return !0;
    }
}, $785da19a645c07eb$var$Hm = class e1 {
    constructor(e1){
        this.key = e1, this.type = $785da19a645c07eb$var$Ad;
    }
    static parse(t, i) {
        if (2 !== t.length) return i.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
        let n = t[1];
        return null == n ? i.error("Global state property must be defined.") : "string" == typeof n ? new e1(n) : i.error(`Global state property must be string, but found ${typeof t[1]} instead.`);
    }
    evaluate(e1) {
        let t = e1.globals?.globalState;
        return t && 0 !== Object.keys(t).length ? $785da19a645c07eb$var$Kd(t, this.key) ?? null : null;
    }
    eachChild() {}
    outputDefined() {
        return !1;
    }
};
const $785da19a645c07eb$var$Wm = {
    "==": $785da19a645c07eb$var$Hp,
    "!=": $785da19a645c07eb$var$Wp,
    ">": $785da19a645c07eb$var$Kp,
    "<": $785da19a645c07eb$var$Zp,
    ">=": $785da19a645c07eb$var$Qp,
    "<=": $785da19a645c07eb$var$Xp,
    array: $785da19a645c07eb$var$Lp,
    at: class e1 {
        constructor(e1, t, i, n){
            this.type = e1, this.index = t, this.input = i, this.key = n;
        }
        static parse(t, i) {
            if (3 !== t.length) return i.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$hd), a = i.parse(t[2], 2, $785da19a645c07eb$var$Sd(i.expectedType || $785da19a645c07eb$var$Ad));
            if (!n || !a) return null;
            let r = a.type;
            return new e1(r.itemType, n, a, i.key);
        }
        evaluate(e1) {
            let t = this.index.evaluate(e1), i = this.input.evaluate(e1);
            if (t < 0) throw new $785da19a645c07eb$var$up(`Array index out of bounds: ${t} < 0.`, this.key);
            if (t >= i.length) throw new $785da19a645c07eb$var$up(`Array index out of bounds: ${t} > ${i.length - 1}.`, this.key);
            if (t !== Math.floor(t)) throw new $785da19a645c07eb$var$up(`Array index must be an integer, but found ${t} instead.`, this.key);
            return i[t];
        }
        eachChild(e1) {
            e1(this.index), e1(this.input);
        }
        outputDefined() {
            return !1;
        }
    },
    boolean: $785da19a645c07eb$var$Lp,
    case: class e1 {
        constructor(e1, t, i){
            this.type = e1, this.branches = t, this.otherwise = i;
        }
        static parse(t, i) {
            if (t.length < 4) return i.error(`Expected at least 3 arguments, but found only ${t.length - 1}.`);
            if (t.length % 2 != 0) return i.error("Expected an odd number of arguments.");
            let n;
            i.expectedType && "value" !== i.expectedType.kind && (n = i.expectedType);
            let a = [];
            for(let e1 = 1; e1 < t.length - 1; e1 += 2){
                let r = i.parse(t[e1], e1, $785da19a645c07eb$var$pd);
                if (!r) return null;
                let s = i.parse(t[e1 + 1], e1 + 1, n);
                if (!s) return null;
                a.push([
                    r,
                    s
                ]), n ||= s.type;
            }
            let r = i.parse(t[t.length - 1], t.length - 1, n);
            if (!r) return null;
            if (!n) throw Error("Can't infer output type");
            return new e1(n, a, r);
        }
        evaluate(e1) {
            for (let [t, i] of this.branches)if (t.evaluate(e1)) return i.evaluate(e1);
            return this.otherwise.evaluate(e1);
        }
        eachChild(e1) {
            for (let [t, i] of this.branches)e1(t), e1(i);
            e1(this.otherwise);
        }
        outputDefined() {
            return this.branches.every(([e1, t])=>t.outputDefined()) && this.otherwise.outputDefined();
        }
    },
    coalesce: $785da19a645c07eb$var$jp,
    collator: $785da19a645c07eb$var$Yp,
    format: $785da19a645c07eb$var$Cp,
    image: class e1 {
        constructor(e1){
            this.type = $785da19a645c07eb$var$Ed, this.input = e1;
        }
        static parse(t, i) {
            if (2 !== t.length) return i.error("Expected two arguments.");
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$dd);
            return n ? new e1(n) : i.error("No image name provided.");
        }
        evaluate(e1) {
            let t = this.input.evaluate(e1), i = $785da19a645c07eb$var$pp.fromString(t);
            return i && e1.availableImages && (i.available = e1.availableImages.indexOf(t) > -1), i;
        }
        eachChild(e1) {
            e1(this.input);
        }
        outputDefined() {
            return !1;
        }
    },
    in: class e1 {
        constructor(e1, t, i){
            this.needle = e1, this.haystack = t, this.key = i, this.type = $785da19a645c07eb$var$pd;
        }
        static parse(t, i) {
            if (3 !== t.length) return i.error(`Expected 2 arguments, but found ${t.length - 1} instead.`);
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$Ad), a = i.parse(t[2], 2, $785da19a645c07eb$var$Ad);
            return n && a ? $785da19a645c07eb$var$Dd(n.type, [
                $785da19a645c07eb$var$pd,
                $785da19a645c07eb$var$dd,
                $785da19a645c07eb$var$hd,
                $785da19a645c07eb$var$ud,
                $785da19a645c07eb$var$Ad
            ]) ? new e1(n, a, i.key) : i.error(`Expected first argument to be of type boolean, string, number or null, but found ${$785da19a645c07eb$var$Md(n.type)} instead`) : null;
        }
        evaluate(e1) {
            let t = this.needle.evaluate(e1), i = this.haystack.evaluate(e1);
            if (!i) return !1;
            if (!$785da19a645c07eb$var$Pd(t, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new $785da19a645c07eb$var$up(`Expected first argument to be of type boolean, string, number or null, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(t))} instead.`, this.key);
            if (!$785da19a645c07eb$var$Pd(i, [
                "string",
                "array"
            ])) throw new $785da19a645c07eb$var$up(`Expected second argument to be of type array or string, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(i))} instead.`, this.key);
            return i.indexOf(t) >= 0;
        }
        eachChild(e1) {
            e1(this.needle), e1(this.haystack);
        }
        outputDefined() {
            return !0;
        }
    },
    "index-of": class e1 {
        constructor(e1, t, i, n){
            this.needle = e1, this.haystack = t, this.key = i, this.fromIndex = n, this.type = $785da19a645c07eb$var$hd;
        }
        static parse(t, i) {
            if (t.length <= 2 || t.length >= 5) return i.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$Ad), a = i.parse(t[2], 2, $785da19a645c07eb$var$Ad);
            if (!n || !a) return null;
            if (!$785da19a645c07eb$var$Dd(n.type, [
                $785da19a645c07eb$var$pd,
                $785da19a645c07eb$var$dd,
                $785da19a645c07eb$var$hd,
                $785da19a645c07eb$var$ud,
                $785da19a645c07eb$var$Ad
            ])) return i.error(`Expected first argument to be of type boolean, string, number or null, but found ${$785da19a645c07eb$var$Md(n.type)} instead`);
            if (4 === t.length) {
                let r = i.parse(t[3], 3, $785da19a645c07eb$var$hd);
                return r ? new e1(n, a, i.key, r) : null;
            }
            return new e1(n, a, i.key);
        }
        evaluate(e1) {
            let t, i = this.needle.evaluate(e1), n = this.haystack.evaluate(e1);
            if (!$785da19a645c07eb$var$Pd(i, [
                "boolean",
                "string",
                "number",
                "null"
            ])) throw new $785da19a645c07eb$var$up(`Expected first argument to be of type boolean, string, number or null, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(i))} instead.`, this.key);
            if (this.fromIndex && (t = this.fromIndex.evaluate(e1)), $785da19a645c07eb$var$Pd(n, [
                "string"
            ])) {
                let e1 = n.indexOf(i, t);
                return -1 === e1 ? -1 : [
                    ...n.slice(0, e1)
                ].length;
            }
            if ($785da19a645c07eb$var$Pd(n, [
                "array"
            ])) return n.indexOf(i, t);
            throw new $785da19a645c07eb$var$up(`Expected second argument to be of type array or string, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(n))} instead.`, this.key);
        }
        eachChild(e1) {
            e1(this.needle), e1(this.haystack), this.fromIndex && e1(this.fromIndex);
        }
        outputDefined() {
            return !1;
        }
    },
    interpolate: $785da19a645c07eb$var$kp,
    "interpolate-hcl": $785da19a645c07eb$var$kp,
    "interpolate-lab": $785da19a645c07eb$var$kp,
    length: class e1 {
        constructor(e1, t){
            this.input = e1, this.key = t, this.type = $785da19a645c07eb$var$hd;
        }
        static parse(t, i) {
            if (2 !== t.length) return i.error(`Expected 1 argument, but found ${t.length - 1} instead.`);
            let n = i.parse(t[1], 1);
            return n ? "array" !== n.type.kind && "string" !== n.type.kind && "value" !== n.type.kind ? i.error(`Expected argument of type string or array, but found ${$785da19a645c07eb$var$Md(n.type)} instead.`) : new e1(n, i.key) : null;
        }
        evaluate(e1) {
            let t = this.input.evaluate(e1);
            if ("string" == typeof t) return [
                ...t
            ].length;
            if (Array.isArray(t)) return t.length;
            throw new $785da19a645c07eb$var$up(`Expected value to be of type string or array, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(t))} instead.`, this.key);
        }
        eachChild(e1) {
            e1(this.input);
        }
        outputDefined() {
            return !1;
        }
    },
    let: $785da19a645c07eb$var$Up,
    literal: $785da19a645c07eb$var$yp,
    match: class e1 {
        constructor(e1, t, i, n, a, r){
            this.inputType = e1, this.type = t, this.input = i, this.cases = n, this.outputs = a, this.otherwise = r;
        }
        static parse(t, i) {
            if (t.length < 5) return i.error(`Expected at least 4 arguments, but found only ${t.length - 1}.`);
            if (t.length % 2 != 1) return i.error("Expected an even number of arguments.");
            let n, a;
            i.expectedType && "value" !== i.expectedType.kind && (a = i.expectedType);
            let r = {}, s = [];
            for(let e1 = 2; e1 < t.length - 1; e1 += 2){
                let o = t[e1], l = t[e1 + 1];
                Array.isArray(o) || (o = [
                    o
                ]);
                let c = i.concat(e1);
                if (0 === o.length) return c.error("Expected at least one branch label.");
                for (let e1 of o){
                    if ("number" != typeof e1 && "string" != typeof e1) return c.error("Branch labels must be numbers or strings.");
                    if ("number" == typeof e1 && Math.abs(e1) > 2 ** 53 - 1) return c.error(`Branch labels must be integers no larger than ${2 ** 53 - 1}.`);
                    if ("number" == typeof e1 && Math.floor(e1) !== e1) return c.error("Numeric branch labels must be integer values.");
                    if (n) {
                        if (c.checkSubtype(n, $785da19a645c07eb$var$_p(e1))) return null;
                    } else n = $785da19a645c07eb$var$_p(e1);
                    if (void 0 !== r[String(e1)]) return c.error("Branch labels must be unique.");
                    r[String(e1)] = s.length;
                }
                let u = i.parse(l, e1, a);
                if (!u) return null;
                a ||= u.type, s.push(u);
            }
            let o = i.parse(t[1], 1, $785da19a645c07eb$var$Ad);
            if (!o) return null;
            let l = i.parse(t[t.length - 1], t.length - 1, a);
            return !l || "value" !== o.type.kind && i.concat(1).checkSubtype(n, o.type) ? null : new e1(n, a, o, r, s, l);
        }
        evaluate(e1) {
            let t = this.input.evaluate(e1);
            return ($785da19a645c07eb$var$_p(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e1);
        }
        eachChild(e1) {
            e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
        }
        outputDefined() {
            return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
        }
    },
    number: $785da19a645c07eb$var$Lp,
    "number-format": class e1 {
        constructor(e1, t, i, n, a, r){
            this.type = $785da19a645c07eb$var$dd, this.number = e1, this.locale = t, this.currency = i, this.unit = n, this.minFractionDigits = a, this.maxFractionDigits = r;
        }
        static parse(t, i) {
            if (3 !== t.length) return i.error("Expected two arguments.");
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$hd);
            if (!n) return null;
            let a = t[2];
            if ("object" != typeof a || Array.isArray(a)) return i.error("NumberFormat options argument must be an object.");
            let r = null;
            if (a.locale && (r = i.parse(a.locale, 1, $785da19a645c07eb$var$dd), !r)) return null;
            let s = null;
            if (a.currency && (s = i.parse(a.currency, 1, $785da19a645c07eb$var$dd), !s)) return null;
            let o = null;
            if (a.unit && (o = i.parse(a.unit, 1, $785da19a645c07eb$var$dd), !o)) return null;
            if (s && o) return i.error("NumberFormat options `currency` and `unit` are mutually exclusive");
            let l = null;
            if (a["min-fraction-digits"] && (l = i.parse(a["min-fraction-digits"], 1, $785da19a645c07eb$var$hd), !l)) return null;
            let c = null;
            return a["max-fraction-digits"] && (c = i.parse(a["max-fraction-digits"], 1, $785da19a645c07eb$var$hd), !c) ? null : new e1(n, r, s, o, l, c);
        }
        evaluate(e1) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                style: this.currency ? "currency" : this.unit ? "unit" : "decimal",
                currency: this.currency ? this.currency.evaluate(e1) : void 0,
                unit: this.unit ? this.unit.evaluate(e1) : void 0,
                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
            }).format(this.number.evaluate(e1));
        }
        eachChild(e1) {
            e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
        }
        outputDefined() {
            return !1;
        }
    },
    object: $785da19a645c07eb$var$Lp,
    semiliteral: class e1 {
        constructor(e1){
            let t = null;
            for (let i of e1){
                if (t) {
                    if (t === i.type) continue;
                    t = $785da19a645c07eb$var$Ad;
                    break;
                }
                t = i.type;
            }
            this.type = $785da19a645c07eb$var$Sd(t ?? $785da19a645c07eb$var$Ad, e1.length), this.arr = e1;
        }
        static parse(t, i) {
            if (2 !== t.length) return i.error(`'semiliteral' expression requires exactly one argument, but found ${t.length - 1} instead.`);
            if (!$785da19a645c07eb$var$Ap(t[1])) return i.error(`invalid value of type "${typeof t[1]}"`);
            let n = t[1], a = $785da19a645c07eb$var$_p(n);
            if ("array" === a.kind) {
                let t = n.map((e1)=>i.parse(e1, null, $785da19a645c07eb$var$Ad));
                return new e1(t);
            }
            return new $785da19a645c07eb$var$yp(a, n);
        }
        evaluate(e1) {
            return this.arr.map((t)=>t.evaluate(e1));
        }
        eachChild(e1) {
            this.arr.forEach(e1);
        }
        outputDefined() {
            return this.arr.every((e1)=>e1.outputDefined());
        }
    },
    slice: class e1 {
        constructor(e1, t, i, n, a){
            this.type = e1, this.input = t, this.beginIndex = i, this.key = n, this.endIndex = a;
        }
        static parse(t, i) {
            if (t.length <= 2 || t.length >= 5) return i.error(`Expected 2 or 3 arguments, but found ${t.length - 1} instead.`);
            let n = i.parse(t[1], 1, $785da19a645c07eb$var$Ad), a = i.parse(t[2], 2, $785da19a645c07eb$var$hd);
            if (!n || !a) return null;
            if (!$785da19a645c07eb$var$Dd(n.type, [
                $785da19a645c07eb$var$Sd($785da19a645c07eb$var$Ad),
                $785da19a645c07eb$var$dd,
                $785da19a645c07eb$var$Ad
            ])) return i.error(`Expected first argument to be of type array or string, but found ${$785da19a645c07eb$var$Md(n.type)} instead`);
            if (4 === t.length) {
                let r = i.parse(t[3], 3, $785da19a645c07eb$var$hd);
                return r ? new e1(n.type, n, a, i.key, r) : null;
            }
            return new e1(n.type, n, a, i.key);
        }
        evaluate(e1) {
            let t, i = this.input.evaluate(e1), n = this.beginIndex.evaluate(e1);
            if (this.endIndex && (t = this.endIndex.evaluate(e1)), $785da19a645c07eb$var$Pd(i, [
                "string"
            ])) return [
                ...i
            ].slice(n, t).join("");
            if ($785da19a645c07eb$var$Pd(i, [
                "array"
            ])) return i.slice(n, t);
            throw new $785da19a645c07eb$var$up(`Expected first argument to be of type array or string, but found ${$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(i))} instead.`, this.key);
        }
        eachChild(e1) {
            e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
        }
        outputDefined() {
            return !1;
        }
    },
    step: $785da19a645c07eb$var$Ep,
    string: $785da19a645c07eb$var$Lp,
    "to-boolean": $785da19a645c07eb$var$Op,
    "to-color": $785da19a645c07eb$var$Op,
    "to-number": $785da19a645c07eb$var$Op,
    "to-string": $785da19a645c07eb$var$Op,
    var: $785da19a645c07eb$var$Np,
    within: $785da19a645c07eb$var$vm,
    distance: $785da19a645c07eb$var$Gm,
    "global-state": $785da19a645c07eb$var$Hm
};
var $785da19a645c07eb$var$Zm = class extends Error {
    constructor(e1, t){
        super(t), this.message = t, this.key = e1;
    }
}, $785da19a645c07eb$var$Km = class e1 {
    constructor(e1, t = []){
        this.parent = e1, this.bindings = {};
        for (let [e1, i] of t)this.bindings[e1] = i;
    }
    concat(t) {
        return new e1(this, t);
    }
    get(e1) {
        if (this.bindings[e1]) return this.bindings[e1];
        if (this.parent) return this.parent.get(e1);
        throw Error(`${e1} not found in scope.`);
    }
    has(e1) {
        return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
    }
}, $785da19a645c07eb$var$Xm = class e1 {
    constructor(e1, t, i = [], n, a = new $785da19a645c07eb$var$Km, r = []){
        this.registry = e1, this.path = i, this.key = i.map((e1)=>`[${e1}]`).join(""), this.scope = a, this.errors = r, this.expectedType = n, this._isConstant = t;
    }
    parse(e1, t, i, n, a = {}) {
        return t ? this.concat(t, i, n)._parse(e1, a) : this._parse(e1, a);
    }
    _parse(e1, t) {
        (null === e1 || "string" == typeof e1 || "boolean" == typeof e1 || "number" == typeof e1) && (e1 = [
            "literal",
            e1
        ]);
        let i = this.key;
        function n(e1, t, n) {
            return "assert" === n ? new $785da19a645c07eb$var$Lp(t, [
                e1
            ], i) : "coerce" === n ? new $785da19a645c07eb$var$Op(t, [
                e1
            ], i) : e1;
        }
        if (Array.isArray(e1)) {
            if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
            let i = e1[0];
            if ("string" != typeof i) return this.error(`Expression name must be a string, but found ${typeof i} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
            let a = this.registry[i];
            if (a) {
                let i = a.parse(e1, this);
                if (!i) return null;
                if (this.expectedType) {
                    let e1 = this.expectedType, a = i.type;
                    if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== a.kind) {
                        if ("projectionDefinition" === e1.kind && [
                            "string",
                            "array",
                            "value"
                        ].includes(a.kind) || [
                            "color",
                            "formatted",
                            "resolvedImage"
                        ].includes(e1.kind) && [
                            "value",
                            "string"
                        ].includes(a.kind) || [
                            "padding",
                            "numberArray"
                        ].includes(e1.kind) && [
                            "value",
                            "number",
                            "array"
                        ].includes(a.kind) || "colorArray" === e1.kind && [
                            "value",
                            "string",
                            "array"
                        ].includes(a.kind) || "variableAnchorOffsetCollection" === e1.kind && [
                            "value",
                            "array"
                        ].includes(a.kind)) i = n(i, e1, t.typeAnnotation || "coerce");
                        else if (this.checkSubtype(e1, a)) return null;
                    } else i = n(i, e1, t.typeAnnotation || "assert");
                }
                if (!(i instanceof $785da19a645c07eb$var$yp) && "resolvedImage" !== i.type.kind && this._isConstant(i)) {
                    let t = new $785da19a645c07eb$var$bp;
                    try {
                        i = new $785da19a645c07eb$var$yp(i.type, i.evaluate(t));
                    } catch (e1) {
                        return this.error(e1.message), null;
                    }
                }
                return i;
            }
            return this.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
        }
        return void 0 === e1 ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof e1 ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error(`Expected an array, but found ${typeof e1} instead.`);
    }
    concat(t, i, n) {
        let a = "number" == typeof t ? this.path.concat(t) : this.path, r = n ? this.scope.concat(n) : this.scope;
        return new e1(this.registry, this._isConstant, a, i || null, r, this.errors);
    }
    error(e1, ...t) {
        let i = `${this.key}${t.map((e1)=>`[${e1}]`).join("")}`;
        this.errors.push(new $785da19a645c07eb$var$Zm(i, e1));
    }
    checkSubtype(e1, t) {
        let i = $785da19a645c07eb$var$Td(e1, t);
        return i && this.error(i), i;
    }
}, $785da19a645c07eb$var$Qm = class e1 {
    constructor(e1, t, i, n, a){
        this.name = e1, this.type = t, this._evaluate = i, this.args = n, this.key = a;
    }
    evaluate(e1) {
        return this._evaluate(e1, this.args, this.key);
    }
    eachChild(e1) {
        this.args.forEach(e1);
    }
    outputDefined() {
        return !1;
    }
    static parse(t, i) {
        let n = t[0], a = e1.definitions[n];
        if (!a) return i.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
        let r = Array.isArray(a) ? a[0] : a.type, s = Array.isArray(a) ? [
            [
                a[1],
                a[2]
            ]
        ] : a.overloads, o = s.filter(([e1])=>!Array.isArray(e1) || e1.length === t.length - 1), l = null;
        for (let [a, s] of o){
            l = new $785da19a645c07eb$var$Xm(i.registry, $785da19a645c07eb$var$tg, i.path, null, i.scope);
            let o = [], c = !1;
            for(let e1 = 1; e1 < t.length; e1++){
                let i = t[e1], n = Array.isArray(a) ? a[e1 - 1] : a.type, r = l.parse(i, 1 + o.length, n);
                if (!r) {
                    c = !0;
                    break;
                }
                o.push(r);
            }
            if (!c) {
                if (Array.isArray(a) && a.length !== o.length) {
                    l.error(`Expected ${a.length} arguments, but found ${o.length} instead.`);
                    continue;
                }
                for(let e1 = 0; e1 < o.length; e1++){
                    let t = Array.isArray(a) ? a[e1] : a.type, i = o[e1];
                    l.concat(e1 + 1).checkSubtype(t, i.type);
                }
                if (0 === l.errors.length) return new e1(n, r, s, o, i.key);
            }
        }
        if (1 === o.length) i.errors.push(...l.errors);
        else {
            let e1 = (o.length ? o : s).map(([e1])=>(function(e1) {
                    return Array.isArray(e1) ? `(${e1.map($785da19a645c07eb$var$Md).join(", ")})` : `(${$785da19a645c07eb$var$Md(e1.type)}...)`;
                })(e1)).join(" | "), n = [];
            for(let e1 = 1; e1 < t.length; e1++){
                let a = i.parse(t[e1], 1 + n.length);
                if (!a) return null;
                n.push($785da19a645c07eb$var$Md(a.type));
            }
            i.error(`Expected arguments of type ${e1}, but found (${n.join(", ")}) instead.`);
        }
        return null;
    }
    static register(t, i) {
        e1.definitions = i;
        for(let n in i)t[n] = e1;
    }
};
function $785da19a645c07eb$var$Ym(e1, [t, i, n, a], r) {
    t = t.evaluate(e1), i = i.evaluate(e1), n = n.evaluate(e1);
    let s = a ? a.evaluate(e1) : 1, o = $785da19a645c07eb$var$fp(t, i, n, s);
    if (o) throw new $785da19a645c07eb$var$up(o, r);
    return new $785da19a645c07eb$var$np(t / 255, i / 255, n / 255, s, !1);
}
function $785da19a645c07eb$var$Jm(e1, t) {
    return e1 in t && void 0 !== t[e1];
}
function $785da19a645c07eb$var$$m(e1, t) {
    let i = t[e1];
    return void 0 === i ? null : i;
}
function $785da19a645c07eb$var$eg(e1) {
    return {
        type: e1
    };
}
function $785da19a645c07eb$var$tg(e1) {
    if (e1 instanceof $785da19a645c07eb$var$Np) return $785da19a645c07eb$var$tg(e1.boundExpression);
    if (e1 instanceof $785da19a645c07eb$var$Qm && "error" === e1.name || e1 instanceof $785da19a645c07eb$var$Yp || e1 instanceof $785da19a645c07eb$var$vm || e1 instanceof $785da19a645c07eb$var$Gm || e1 instanceof $785da19a645c07eb$var$Hm) return !1;
    let t = e1 instanceof $785da19a645c07eb$var$Op || e1 instanceof $785da19a645c07eb$var$Lp, i = !0;
    return e1.eachChild((e1)=>{
        i &&= t ? $785da19a645c07eb$var$tg(e1) : e1 instanceof $785da19a645c07eb$var$yp;
    }), !!i && $785da19a645c07eb$var$ig(e1) && $785da19a645c07eb$var$ag(e1, [
        "zoom",
        "heatmap-density",
        "elevation",
        "line-progress",
        "accumulated",
        "is-supported-script"
    ]);
}
function $785da19a645c07eb$var$ig(e1) {
    if (e1 instanceof $785da19a645c07eb$var$Qm && ("get" === e1.name && 1 === e1.args.length || "feature-state" === e1.name || "has" === e1.name && 1 === e1.args.length || "properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name || /^filter-/.test(e1.name)) || e1 instanceof $785da19a645c07eb$var$vm || e1 instanceof $785da19a645c07eb$var$Gm) return !1;
    let t = !0;
    return e1.eachChild((e1)=>{
        t && !$785da19a645c07eb$var$ig(e1) && (t = !1);
    }), t;
}
function $785da19a645c07eb$var$ng(e1) {
    if (e1 instanceof $785da19a645c07eb$var$Qm && "feature-state" === e1.name) return !1;
    let t = !0;
    return e1.eachChild((e1)=>{
        t && !$785da19a645c07eb$var$ng(e1) && (t = !1);
    }), t;
}
function $785da19a645c07eb$var$ag(e1, t) {
    if (e1 instanceof $785da19a645c07eb$var$Qm && t.indexOf(e1.name) >= 0) return !1;
    let i = !0;
    return e1.eachChild((e1)=>{
        i && !$785da19a645c07eb$var$ag(e1, t) && (i = !1);
    }), i;
}
function $785da19a645c07eb$var$rg(e1) {
    return "data-driven" === e1["property-type"] || "cross-faded-data-driven" === e1["property-type"];
}
function $785da19a645c07eb$var$sg(e1) {
    return !!e1.expression && e1.expression.parameters.indexOf("zoom") > -1;
}
function $785da19a645c07eb$var$og(e1) {
    return !!e1.expression && e1.expression.interpolated;
}
$785da19a645c07eb$var$Qm.register($785da19a645c07eb$var$Wm, {
    error: [
        $785da19a645c07eb$var$_d,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t], i)=>{
            throw new $785da19a645c07eb$var$up(t.evaluate(e1), i);
        }
    ],
    typeof: [
        $785da19a645c07eb$var$dd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>$785da19a645c07eb$var$Md($785da19a645c07eb$var$_p(t.evaluate(e1)))
    ],
    "to-rgba": [
        $785da19a645c07eb$var$Sd($785da19a645c07eb$var$hd, 4),
        [
            $785da19a645c07eb$var$md
        ],
        (e1, [t])=>{
            let [i, n, a, r] = t.evaluate(e1).rgb;
            return [
                255 * i,
                255 * n,
                255 * a,
                r
            ];
        }
    ],
    rgb: [
        $785da19a645c07eb$var$md,
        [
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd
        ],
        $785da19a645c07eb$var$Ym
    ],
    rgba: [
        $785da19a645c07eb$var$md,
        [
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd
        ],
        $785da19a645c07eb$var$Ym
    ],
    has: {
        type: $785da19a645c07eb$var$pd,
        overloads: [
            [
                [
                    $785da19a645c07eb$var$dd
                ],
                (e1, [t])=>$785da19a645c07eb$var$Jm(t.evaluate(e1), e1.properties())
            ],
            [
                [
                    $785da19a645c07eb$var$dd,
                    $785da19a645c07eb$var$fd
                ],
                (e1, [t, i])=>$785da19a645c07eb$var$Jm(t.evaluate(e1), i.evaluate(e1))
            ]
        ]
    },
    get: {
        type: $785da19a645c07eb$var$Ad,
        overloads: [
            [
                [
                    $785da19a645c07eb$var$dd
                ],
                (e1, [t])=>$785da19a645c07eb$var$$m(t.evaluate(e1), e1.properties())
            ],
            [
                [
                    $785da19a645c07eb$var$dd,
                    $785da19a645c07eb$var$fd
                ],
                (e1, [t, i])=>$785da19a645c07eb$var$$m(t.evaluate(e1), i.evaluate(e1))
            ]
        ]
    },
    "feature-state": [
        $785da19a645c07eb$var$Ad,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t])=>$785da19a645c07eb$var$$m(t.evaluate(e1), e1.featureState || {})
    ],
    properties: [
        $785da19a645c07eb$var$fd,
        [],
        (e1)=>e1.properties()
    ],
    "geometry-type": [
        $785da19a645c07eb$var$dd,
        [],
        (e1)=>e1.geometryType()
    ],
    id: [
        $785da19a645c07eb$var$Ad,
        [],
        (e1)=>e1.id()
    ],
    zoom: [
        $785da19a645c07eb$var$hd,
        [],
        (e1)=>e1.globals.zoom
    ],
    "heatmap-density": [
        $785da19a645c07eb$var$hd,
        [],
        (e1)=>e1.globals.heatmapDensity || 0
    ],
    elevation: [
        $785da19a645c07eb$var$hd,
        [],
        (e1)=>e1.globals.elevation || 0
    ],
    "line-progress": [
        $785da19a645c07eb$var$hd,
        [],
        (e1)=>e1.globals.lineProgress || 0
    ],
    accumulated: [
        $785da19a645c07eb$var$Ad,
        [],
        (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
    ],
    "+": [
        $785da19a645c07eb$var$hd,
        $785da19a645c07eb$var$eg($785da19a645c07eb$var$hd),
        (e1, t)=>{
            let i = 0;
            for (let n of t)i += n.evaluate(e1);
            return i;
        }
    ],
    "*": [
        $785da19a645c07eb$var$hd,
        $785da19a645c07eb$var$eg($785da19a645c07eb$var$hd),
        (e1, t)=>{
            let i = 1;
            for (let n of t)i *= n.evaluate(e1);
            return i;
        }
    ],
    "-": {
        type: $785da19a645c07eb$var$hd,
        overloads: [
            [
                [
                    $785da19a645c07eb$var$hd,
                    $785da19a645c07eb$var$hd
                ],
                (e1, [t, i])=>t.evaluate(e1) - i.evaluate(e1)
            ],
            [
                [
                    $785da19a645c07eb$var$hd
                ],
                (e1, [t])=>-t.evaluate(e1)
            ]
        ]
    },
    "/": [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd
        ],
        (e1, [t, i])=>t.evaluate(e1) / i.evaluate(e1)
    ],
    "%": [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd
        ],
        (e1, [t, i])=>t.evaluate(e1) % i.evaluate(e1)
    ],
    ln2: [
        $785da19a645c07eb$var$hd,
        [],
        ()=>Math.LN2
    ],
    pi: [
        $785da19a645c07eb$var$hd,
        [],
        ()=>Math.PI
    ],
    e: [
        $785da19a645c07eb$var$hd,
        [],
        ()=>Math.E
    ],
    "^": [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd,
            $785da19a645c07eb$var$hd
        ],
        (e1, [t, i])=>t.evaluate(e1) ** +i.evaluate(e1)
    ],
    sqrt: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.sqrt(t.evaluate(e1))
    ],
    log10: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN10
    ],
    ln: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.log(t.evaluate(e1))
    ],
    log2: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN2
    ],
    sin: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.sin(t.evaluate(e1))
    ],
    cos: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.cos(t.evaluate(e1))
    ],
    tan: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.tan(t.evaluate(e1))
    ],
    asin: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.asin(t.evaluate(e1))
    ],
    acos: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.acos(t.evaluate(e1))
    ],
    atan: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.atan(t.evaluate(e1))
    ],
    min: [
        $785da19a645c07eb$var$hd,
        $785da19a645c07eb$var$eg($785da19a645c07eb$var$hd),
        (e1, t)=>Math.min(...t.map((t)=>t.evaluate(e1)))
    ],
    max: [
        $785da19a645c07eb$var$hd,
        $785da19a645c07eb$var$eg($785da19a645c07eb$var$hd),
        (e1, t)=>Math.max(...t.map((t)=>t.evaluate(e1)))
    ],
    abs: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.abs(t.evaluate(e1))
    ],
    round: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>{
            let i = t.evaluate(e1);
            return i < 0 ? -Math.round(-i) : Math.round(i);
        }
    ],
    floor: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.floor(t.evaluate(e1))
    ],
    ceil: [
        $785da19a645c07eb$var$hd,
        [
            $785da19a645c07eb$var$hd
        ],
        (e1, [t])=>Math.ceil(t.evaluate(e1))
    ],
    "filter-==": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t, i])=>e1.properties()[t.value] === i.value
    ],
    "filter-id-==": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>e1.id() === t.value
    ],
    "filter-type-==": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t])=>e1.geometryType() === t.value
    ],
    "filter-<": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t, i])=>{
            let n = e1.properties()[t.value], a = i.value;
            return typeof n == typeof a && n < a;
        }
    ],
    "filter-id-<": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>{
            let i = e1.id(), n = t.value;
            return typeof i == typeof n && i < n;
        }
    ],
    "filter->": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t, i])=>{
            let n = e1.properties()[t.value], a = i.value;
            return typeof n == typeof a && n > a;
        }
    ],
    "filter-id->": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>{
            let i = e1.id(), n = t.value;
            return typeof i == typeof n && i > n;
        }
    ],
    "filter-<=": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t, i])=>{
            let n = e1.properties()[t.value], a = i.value;
            return typeof n == typeof a && n <= a;
        }
    ],
    "filter-id-<=": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>{
            let i = e1.id(), n = t.value;
            return typeof i == typeof n && i <= n;
        }
    ],
    "filter->=": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t, i])=>{
            let n = e1.properties()[t.value], a = i.value;
            return typeof n == typeof a && n >= a;
        }
    ],
    "filter-id->=": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>{
            let i = e1.id(), n = t.value;
            return typeof i == typeof n && i >= n;
        }
    ],
    "filter-has": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Ad
        ],
        (e1, [t])=>{
            let i = t.value, n = e1.properties();
            return i in n && void 0 !== n[i];
        }
    ],
    "filter-has-id": [
        $785da19a645c07eb$var$pd,
        [],
        (e1)=>null !== e1.id() && void 0 !== e1.id()
    ],
    "filter-type-in": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Sd($785da19a645c07eb$var$dd)
        ],
        (e1, [t])=>t.value.indexOf(e1.geometryType()) >= 0
    ],
    "filter-id-in": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$Sd($785da19a645c07eb$var$Ad)
        ],
        (e1, [t])=>t.value.indexOf(e1.id()) >= 0
    ],
    "filter-in-small": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Sd($785da19a645c07eb$var$Ad)
        ],
        (e1, [t, i])=>i.value.indexOf(e1.properties()[t.value]) >= 0
    ],
    "filter-in-large": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$Sd($785da19a645c07eb$var$Ad)
        ],
        (e1, [t, i])=>(function(e1, t, i, n) {
                for(; i <= n;){
                    let a = i + n >> 1;
                    if (t[a] === e1) return !0;
                    t[a] > e1 ? n = a - 1 : i = a + 1;
                }
                return !1;
            })(e1.properties()[t.value], i.value, 0, i.value.length - 1)
    ],
    all: {
        type: $785da19a645c07eb$var$pd,
        overloads: [
            [
                [
                    $785da19a645c07eb$var$pd,
                    $785da19a645c07eb$var$pd
                ],
                (e1, [t, i])=>t.evaluate(e1) && i.evaluate(e1)
            ],
            [
                $785da19a645c07eb$var$eg($785da19a645c07eb$var$pd),
                (e1, t)=>{
                    for (let i of t)if (!i.evaluate(e1)) return !1;
                    return !0;
                }
            ]
        ]
    },
    any: {
        type: $785da19a645c07eb$var$pd,
        overloads: [
            [
                [
                    $785da19a645c07eb$var$pd,
                    $785da19a645c07eb$var$pd
                ],
                (e1, [t, i])=>t.evaluate(e1) || i.evaluate(e1)
            ],
            [
                $785da19a645c07eb$var$eg($785da19a645c07eb$var$pd),
                (e1, t)=>{
                    for (let i of t)if (i.evaluate(e1)) return !0;
                    return !1;
                }
            ]
        ]
    },
    "!": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$pd
        ],
        (e1, [t])=>!t.evaluate(e1)
    ],
    "is-supported-script": [
        $785da19a645c07eb$var$pd,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t])=>{
            let i = e1.globals && e1.globals.isSupportedScript;
            return !i || i(t.evaluate(e1));
        }
    ],
    upcase: [
        $785da19a645c07eb$var$dd,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t])=>t.evaluate(e1).toUpperCase()
    ],
    downcase: [
        $785da19a645c07eb$var$dd,
        [
            $785da19a645c07eb$var$dd
        ],
        (e1, [t])=>t.evaluate(e1).toLowerCase()
    ],
    concat: [
        $785da19a645c07eb$var$dd,
        $785da19a645c07eb$var$eg($785da19a645c07eb$var$Ad),
        (e1, t)=>t.map((t)=>$785da19a645c07eb$var$vp(t.evaluate(e1))).join("")
    ],
    split: [
        $785da19a645c07eb$var$Sd($785da19a645c07eb$var$dd),
        [
            $785da19a645c07eb$var$dd,
            $785da19a645c07eb$var$dd
        ],
        (e1, [t, i])=>t.evaluate(e1).split(i.evaluate(e1))
    ],
    join: [
        $785da19a645c07eb$var$dd,
        [
            $785da19a645c07eb$var$Sd($785da19a645c07eb$var$dd),
            $785da19a645c07eb$var$dd
        ],
        (e1, [t, i])=>t.evaluate(e1).join(i.evaluate(e1))
    ],
    "resolved-locale": [
        $785da19a645c07eb$var$dd,
        [
            $785da19a645c07eb$var$vd
        ],
        (e1, [t])=>t.evaluate(e1).resolvedLocale()
    ]
});
const $785da19a645c07eb$var$lg = /^(.*)-transition$/;
function $785da19a645c07eb$var$cg(e1, ...t) {
    for (let i of t)for(let t in i)e1[t] = i[t];
    return e1;
}
function $785da19a645c07eb$var$ug(e1) {
    return e1 instanceof Number ? "number" : e1 instanceof String ? "string" : e1 instanceof Boolean ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : typeof e1;
}
function $785da19a645c07eb$var$hg(e1) {
    return "object" == typeof e1 && !!e1 && !Array.isArray(e1) && $785da19a645c07eb$var$_p(e1) === $785da19a645c07eb$var$fd;
}
function $785da19a645c07eb$var$dg(e1) {
    return e1;
}
function $785da19a645c07eb$var$pg(e1, t) {
    let i = e1.stops && "object" == typeof e1.stops[0][0], n = i || void 0 !== e1.property, a = i || !n, r = e1.type || ($785da19a645c07eb$var$og(t) ? "exponential" : "interval"), s = function(e1) {
        switch(e1.type){
            case "color":
                return $785da19a645c07eb$var$np.parse;
            case "padding":
                return $785da19a645c07eb$var$op.parse;
            case "numberArray":
                return $785da19a645c07eb$var$lp.parse;
            case "colorArray":
                return $785da19a645c07eb$var$cp.parse;
            default:
                return null;
        }
    }(t);
    if (s && ((e1 = $785da19a645c07eb$var$cg({}, e1)).stops && (e1.stops = e1.stops.map((e1)=>[
            e1[0],
            s(e1[1])
        ])), e1.default ? e1.default = s(e1.default) : e1.default = s(t.default)), e1.colorSpace && !function(e1) {
        return "rgb" === e1 || "hcl" === e1 || "lab" === e1;
    }(e1.colorSpace)) throw Error(`Unknown color space: "${e1.colorSpace}"`);
    let o, l, c = function(e1) {
        switch(e1){
            case "exponential":
                return $785da19a645c07eb$var$Ag;
            case "interval":
                return $785da19a645c07eb$var$fg;
            case "categorical":
                return $785da19a645c07eb$var$gg;
            case "identity":
                return $785da19a645c07eb$var$_g;
            default:
                throw Error(`Unknown function type "${e1}"`);
        }
    }(r);
    if ("categorical" === r) {
        o = Object.create(null);
        for (let t of e1.stops)o[t[0]] = t[1];
        l = typeof e1.stops[0][0];
    }
    if (i) {
        let i = {}, n = [];
        for(let t = 0; t < e1.stops.length; t++){
            let a = e1.stops[t], r = a[0].zoom;
            void 0 === i[r] && (i[r] = {
                zoom: r,
                type: e1.type,
                property: e1.property,
                default: e1.default,
                stops: []
            }, n.push(r)), i[r].stops.push([
                a[0].value,
                a[1]
            ]);
        }
        let a = [];
        for (let e1 of n)a.push([
            i[e1].zoom,
            $785da19a645c07eb$var$pg(i[e1], t)
        ]);
        let r = {
            name: "linear"
        };
        return {
            kind: "composite",
            interpolationType: r,
            interpolationFactor: $785da19a645c07eb$var$kp.interpolationFactor.bind(void 0, r),
            zoomStops: a.map((e1)=>e1[0]),
            evaluate: ({ zoom: i }, n)=>$785da19a645c07eb$var$Ag({
                    stops: a,
                    base: e1.base
                }, t, i).evaluate(i, n)
        };
    }
    if (a) {
        let i = "exponential" === r ? {
            name: "exponential",
            base: void 0 === e1.base ? 1 : e1.base
        } : null;
        return {
            kind: "camera",
            interpolationType: i,
            interpolationFactor: $785da19a645c07eb$var$kp.interpolationFactor.bind(void 0, i),
            zoomStops: e1.stops.map((e1)=>e1[0]),
            evaluate: ({ zoom: i })=>c(e1, t, i, o, l)
        };
    }
    return {
        kind: "source",
        evaluate (i, n) {
            let a = n && n.properties ? n.properties[e1.property] : void 0;
            return void 0 === a ? $785da19a645c07eb$var$mg(e1.default, t.default) : c(e1, t, a, o, l);
        }
    };
}
function $785da19a645c07eb$var$mg(e1, t, i) {
    return void 0 !== e1 ? e1 : void 0 !== t ? t : void 0 !== i ? i : void 0;
}
function $785da19a645c07eb$var$gg(e1, t, i, n, a) {
    return $785da19a645c07eb$var$mg(typeof i === a ? n[i] : void 0, e1.default, t.default);
}
function $785da19a645c07eb$var$fg(e1, t, i) {
    if ("number" !== $785da19a645c07eb$var$ug(i)) return $785da19a645c07eb$var$mg(e1.default, t.default);
    let n = e1.stops.length;
    if (1 === n || i <= e1.stops[0][0]) return e1.stops[0][1];
    if (i >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
    let a = $785da19a645c07eb$var$wp(e1.stops.map((e1)=>e1[0]), i, "");
    return e1.stops[a][1];
}
function $785da19a645c07eb$var$Ag(e1, t, i) {
    let n = void 0 === e1.base ? 1 : e1.base;
    if ("number" !== $785da19a645c07eb$var$ug(i)) return $785da19a645c07eb$var$mg(e1.default, t.default);
    let a = e1.stops.length;
    if (1 === a || i <= e1.stops[0][0]) return e1.stops[0][1];
    if (i >= e1.stops[a - 1][0]) return e1.stops[a - 1][1];
    let r = $785da19a645c07eb$var$wp(e1.stops.map((e1)=>e1[0]), i, ""), s = function(e1, t, i, n) {
        let a = n - i, r = e1 - i;
        return 0 === a ? 0 : 1 === t ? r / a : (t ** +r - 1) / (t ** +a - 1);
    }(i, n, e1.stops[r][0], e1.stops[r + 1][0]), o = e1.stops[r][1], l = e1.stops[r + 1][1], c = $785da19a645c07eb$var$Mp[t.type] || $785da19a645c07eb$var$dg;
    return "function" == typeof o.evaluate ? {
        evaluate (...t) {
            let i = o.evaluate.apply(void 0, t), n = l.evaluate.apply(void 0, t);
            if (void 0 !== i && void 0 !== n) return c(i, n, s, e1.colorSpace);
        }
    } : c(o, l, s, e1.colorSpace);
}
function $785da19a645c07eb$var$_g(e1, t, i) {
    switch(t.type){
        case "color":
            i = $785da19a645c07eb$var$np.parse(i);
            break;
        case "formatted":
            i = $785da19a645c07eb$var$sp.fromString(i.toString());
            break;
        case "resolvedImage":
            i = $785da19a645c07eb$var$pp.fromString(i.toString());
            break;
        case "padding":
            i = $785da19a645c07eb$var$op.parse(i);
            break;
        case "colorArray":
            i = $785da19a645c07eb$var$cp.parse(i);
            break;
        case "numberArray":
            i = $785da19a645c07eb$var$lp.parse(i);
            break;
        default:
            $785da19a645c07eb$var$ug(i) !== t.type && ("enum" !== t.type || !t.values[i]) && (i = void 0);
    }
    return $785da19a645c07eb$var$mg(i, e1.default, t.default);
}
function $785da19a645c07eb$var$vg(e1) {
    return {
        result: "success",
        value: e1
    };
}
function $785da19a645c07eb$var$yg(e1) {
    return {
        result: "error",
        value: e1
    };
}
var $785da19a645c07eb$var$xg = class {
    constructor(e1, t, i, n){
        this.expression = e1, this._warningHistory = {}, this._evaluator = new $785da19a645c07eb$var$bp, this._defaultValue = i ? $785da19a645c07eb$var$Ig(i) : null, this._enumValues = i && "enum" === i.type ? i.values : null, this._globalState = n, this._rootKey = t;
    }
    evaluateWithoutErrorHandling(e1, t, i, n, a, r) {
        return this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._evaluator.globals = e1, this._evaluator.feature = t, this._evaluator.featureState = i, this._evaluator.canonical = n, this._evaluator.availableImages = a || null, this._evaluator.formattedSection = r, this.expression.evaluate(this._evaluator);
    }
    evaluate(e1, t, i, n, a, r) {
        this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._evaluator.globals = e1, this._evaluator.feature = t || null, this._evaluator.featureState = i || null, this._evaluator.canonical = n, this._evaluator.availableImages = a || null, this._evaluator.formattedSection = r || null;
        try {
            let e1 = this.expression.evaluate(this._evaluator);
            if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
            if (this._enumValues && !(e1 in this._enumValues)) throw new $785da19a645c07eb$var$up(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`, "");
            return e1;
        } catch (e1) {
            let t = e1 instanceof $785da19a645c07eb$var$up ? e1.path : "", i = `${t}|${e1.message}`;
            return this._warningHistory[i] || (this._warningHistory[i] = !0, typeof console < "u" && console.warn($785da19a645c07eb$var$bg(this._rootKey, t, e1.message, this._defaultValue))), this._defaultValue;
        }
    }
};
function $785da19a645c07eb$var$bg(e1, t, i, n) {
    return `${e1}${t}: ${i}${null == n ? "" : ` Falling back to ${String(n)}.`}`;
}
function $785da19a645c07eb$var$wg(e1) {
    if (!e1) throw Error('rootKey must identify the location of the expression in the style JSON, e.g. "layers[3].paint.line-width".');
}
function $785da19a645c07eb$var$Eg(e1) {
    return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && e1[0] in $785da19a645c07eb$var$Wm;
}
function $785da19a645c07eb$var$kg(e1, t, i, n) {
    $785da19a645c07eb$var$wg(t);
    let a = new $785da19a645c07eb$var$Xm($785da19a645c07eb$var$Wm, $785da19a645c07eb$var$tg, [], i ? function(e1) {
        let t = {
            color: $785da19a645c07eb$var$md,
            string: $785da19a645c07eb$var$dd,
            number: $785da19a645c07eb$var$hd,
            enum: $785da19a645c07eb$var$dd,
            boolean: $785da19a645c07eb$var$pd,
            formatted: $785da19a645c07eb$var$yd,
            padding: $785da19a645c07eb$var$xd,
            numberArray: $785da19a645c07eb$var$wd,
            colorArray: $785da19a645c07eb$var$bd,
            projectionDefinition: $785da19a645c07eb$var$gd,
            resolvedImage: $785da19a645c07eb$var$Ed,
            variableAnchorOffsetCollection: $785da19a645c07eb$var$kd
        };
        return "array" === e1.type ? $785da19a645c07eb$var$Sd(t[e1.value] || $785da19a645c07eb$var$Ad, e1.length) : t[e1.type];
    }(i) : void 0), r = a.parse(e1, void 0, void 0, void 0, i && "string" === i.type ? {
        typeAnnotation: "coerce"
    } : void 0);
    return r ? $785da19a645c07eb$var$vg(new $785da19a645c07eb$var$xg(r, t, i, n)) : $785da19a645c07eb$var$yg(a.errors);
}
var $785da19a645c07eb$var$Sg = class {
    constructor(e1, t, i){
        this.kind = e1, this._styleExpression = t, this.isStateDependent = "constant" !== e1 && !$785da19a645c07eb$var$ng(t.expression), this.globalStateRefs = $785da19a645c07eb$var$Pg(t.expression), this._globalState = i;
    }
    evaluateWithoutErrorHandling(e1, t, i, n, a, r) {
        return this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, n, a, r);
    }
    evaluate(e1, t, i, n, a, r) {
        return this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._styleExpression.evaluate(e1, t, i, n, a, r);
    }
}, $785da19a645c07eb$var$Mg = class {
    constructor(e1, t, i, n, a){
        this.kind = e1, this.zoomStops = i, this._styleExpression = t, this.isStateDependent = "camera" !== e1 && !$785da19a645c07eb$var$ng(t.expression), this.globalStateRefs = $785da19a645c07eb$var$Pg(t.expression), this.interpolationType = n, this._globalState = a;
    }
    evaluateWithoutErrorHandling(e1, t, i, n, a, r) {
        return this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, n, a, r);
    }
    evaluate(e1, t, i, n, a, r) {
        return this._globalState && (e1 = $785da19a645c07eb$var$Fg(e1, this._globalState)), this._styleExpression.evaluate(e1, t, i, n, a, r);
    }
    interpolationFactor(e1, t, i) {
        return this.interpolationType ? $785da19a645c07eb$var$kp.interpolationFactor(this.interpolationType, e1, t, i) : 0;
    }
};
function $785da19a645c07eb$var$Cg(e1, t, i, n) {
    let a = $785da19a645c07eb$var$kg(e1, t, i, n);
    if ("error" === a.result) return a;
    let r = a.value.expression, s = $785da19a645c07eb$var$ig(r);
    if (!s && !$785da19a645c07eb$var$rg(i)) return $785da19a645c07eb$var$yg([
        new $785da19a645c07eb$var$Zm("", "data expressions not supported")
    ]);
    let o = $785da19a645c07eb$var$ag(r, [
        "zoom"
    ]);
    if (!o && !$785da19a645c07eb$var$sg(i)) return $785da19a645c07eb$var$yg([
        new $785da19a645c07eb$var$Zm("", "zoom expressions not supported")
    ]);
    let l = $785da19a645c07eb$var$Dg(r);
    if (!l && !o) return $785da19a645c07eb$var$yg([
        new $785da19a645c07eb$var$Zm("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
    ]);
    if (l instanceof $785da19a645c07eb$var$Zm) return $785da19a645c07eb$var$yg([
        l
    ]);
    if (l instanceof $785da19a645c07eb$var$kp && !$785da19a645c07eb$var$og(i)) return $785da19a645c07eb$var$yg([
        new $785da19a645c07eb$var$Zm("", '"interpolate" expressions cannot be used with this property')
    ]);
    if (!l) return $785da19a645c07eb$var$vg(new $785da19a645c07eb$var$Sg(s ? "constant" : "source", a.value, n));
    let c = l instanceof $785da19a645c07eb$var$kp ? l.interpolation : void 0;
    return $785da19a645c07eb$var$vg(new $785da19a645c07eb$var$Mg(s ? "camera" : "composite", a.value, l.labels, c, n));
}
var $785da19a645c07eb$var$Tg = class e1 {
    constructor(e1, t, i){
        this.isStateDependent = !1, this.globalStateRefs = new Set, this._globalState = null, $785da19a645c07eb$var$wg(t), this._parameters = e1, this._specification = i, this._rootKey = t, this._defaultValue = $785da19a645c07eb$var$Ig(i), this._warningHistory = {};
        let n = $785da19a645c07eb$var$pg(this._parameters, this._specification);
        this.kind = n.kind, this.interpolationFactor = n.interpolationFactor, this.zoomStops = n.zoomStops, this.interpolationType = n.interpolationType, this._innerEvaluate = n.evaluate;
    }
    evaluate(e1, t) {
        try {
            return this._innerEvaluate(e1, t);
        } catch (e1) {
            let t = e1 instanceof Error ? e1.message : String(e1), i = `|${t}`;
            return this._warningHistory[i] || (this._warningHistory[i] = !0, typeof console < "u" && console.warn($785da19a645c07eb$var$bg(this._rootKey, "", t, this._defaultValue))), this._defaultValue;
        }
    }
    static deserialize(t) {
        return new e1(t._parameters, t._rootKey, t._specification);
    }
    static serialize(e1) {
        return {
            _parameters: e1._parameters,
            _specification: e1._specification,
            _rootKey: e1._rootKey
        };
    }
};
function $785da19a645c07eb$var$Dg(e1) {
    let t = null;
    if (e1 instanceof $785da19a645c07eb$var$Up) t = $785da19a645c07eb$var$Dg(e1.result);
    else if (e1 instanceof $785da19a645c07eb$var$jp) {
        for (let i of e1.args)if (t = $785da19a645c07eb$var$Dg(i), t) break;
    } else (e1 instanceof $785da19a645c07eb$var$Ep || e1 instanceof $785da19a645c07eb$var$kp) && e1.input instanceof $785da19a645c07eb$var$Qm && "zoom" === e1.input.name && (t = e1);
    return t instanceof $785da19a645c07eb$var$Zm || e1.eachChild((e1)=>{
        let i = $785da19a645c07eb$var$Dg(e1);
        i instanceof $785da19a645c07eb$var$Zm ? t = i : !t && i ? t = new $785da19a645c07eb$var$Zm("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : t && i && t !== i && (t = new $785da19a645c07eb$var$Zm("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
    }), t;
}
function $785da19a645c07eb$var$Pg(e1, t = new Set) {
    return e1 instanceof $785da19a645c07eb$var$Hm && t.add(e1.key), e1.eachChild((e1)=>{
        $785da19a645c07eb$var$Pg(e1, t);
    }), t;
}
function $785da19a645c07eb$var$Ig(e1) {
    if ("color" === e1.type && $785da19a645c07eb$var$hg(e1.default)) return new $785da19a645c07eb$var$np(0, 0, 0, 0);
    switch(e1.type){
        case "color":
            return $785da19a645c07eb$var$np.parse(e1.default) || null;
        case "padding":
            return $785da19a645c07eb$var$op.parse(e1.default) || null;
        case "numberArray":
            return $785da19a645c07eb$var$lp.parse(e1.default) || null;
        case "colorArray":
            return $785da19a645c07eb$var$cp.parse(e1.default) || null;
        case "variableAnchorOffsetCollection":
            return $785da19a645c07eb$var$dp.parse(e1.default) || null;
        case "projectionDefinition":
            return $785da19a645c07eb$var$mp.parse(e1.default) || null;
        default:
            return void 0 === e1.default ? null : e1.default;
    }
}
function $785da19a645c07eb$var$Fg(e1, t) {
    let { zoom: i, heatmapDensity: n, elevation: a, lineProgress: r, isSupportedScript: s, accumulated: o } = e1 ?? {};
    return {
        zoom: i,
        heatmapDensity: n,
        elevation: a,
        lineProgress: r,
        isSupportedScript: s,
        accumulated: o,
        globalState: t
    };
}
function $785da19a645c07eb$var$zg(e1) {
    if ("boolean" == typeof e1) return "neutral";
    if (!Array.isArray(e1) || 0 === e1.length) return "legacy";
    switch(e1[0]){
        case "has":
            return e1.length < 2 || "$id" === e1[1] || "$type" === e1[1] ? "legacy" : 2 === e1.length ? "neutral" : "expression";
        case "in":
            return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2])) ? "expression" : "legacy";
        case "!in":
        case "!has":
        case "none":
            return "legacy";
        case "==":
        case "!=":
        case ">":
        case ">=":
        case "<":
        case "<=":
            return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]) ? "expression" : "legacy";
        case "any":
        case "all":
            return function(e1) {
                let t = !1;
                for (let i of e1){
                    let e1 = $785da19a645c07eb$var$zg(i);
                    if ("expression" === e1) return "expression";
                    "legacy" === e1 && (t = !0);
                }
                return t ? "legacy" : "neutral";
            }(e1.slice(1));
        default:
            return "expression";
    }
}
function $785da19a645c07eb$var$Rg(e1) {
    return "legacy" !== $785da19a645c07eb$var$zg(e1);
}
function $785da19a645c07eb$var$Lg(e1) {
    return "$type" === e1 ? [
        "geometry-type"
    ] : "$id" === e1 ? [
        "id"
    ] : [
        "get",
        e1
    ];
}
function $785da19a645c07eb$var$Bg(e1) {
    if (("<" === e1[0] || "<=" === e1[0] || ">" === e1[0] || ">=" === e1[0]) && "$type" === e1[1]) return `"$type" cannot be use with operator "${e1[0]}"`;
    let t = function(e1) {
        switch(e1[0]){
            case "==":
            case "!=":
            case "<":
            case "<=":
            case ">":
            case ">=":
                return 3 !== e1.length || "string" != typeof e1[1] ? null : [
                    e1[0],
                    $785da19a645c07eb$var$Lg(e1[1]),
                    e1[2]
                ];
            case "in":
            case "!in":
                {
                    if (e1.length < 2 || "string" != typeof e1[1]) return null;
                    let t = [
                        "in",
                        $785da19a645c07eb$var$Lg(e1[1]),
                        [
                            "literal",
                            e1.slice(2)
                        ]
                    ];
                    return "!in" === e1[0] ? [
                        "!",
                        t
                    ] : t;
                }
            case "has":
            case "!has":
                {
                    if (2 !== e1.length || "string" != typeof e1[1] || "$type" === e1[1] || "$id" === e1[1]) return null;
                    let t = [
                        "has",
                        e1[1]
                    ];
                    return "!has" === e1[0] ? [
                        "!",
                        t
                    ] : t;
                }
            default:
                return null;
        }
    }(e1);
    return t ? `Mixing deprecated filter syntax with expression syntax is not supported. Replace ${JSON.stringify(e1)} with ${JSON.stringify(t)}.` : `Mixing deprecated filter syntax with expression syntax is not supported. Convert ${JSON.stringify(e1)} to expression syntax.`;
}
function $785da19a645c07eb$var$Og(e1, t, i) {
    let n = i[e1];
    return Array.isArray(n) ? $785da19a645c07eb$var$Rg(n) ? $785da19a645c07eb$var$Ug(n, t.concat(e1)) : {
        path: t.concat(e1),
        legacyFilter: n
    } : null;
}
function $785da19a645c07eb$var$Ug(e1, t = []) {
    if (!Array.isArray(e1) || e1.length < 1) return null;
    switch(e1[0]){
        case "all":
        case "any":
        case "none":
            for(let i = 1; i < e1.length; i++){
                let n = $785da19a645c07eb$var$Og(i, t, e1);
                if (n) return n;
            }
            break;
        case "!":
            {
                let i = $785da19a645c07eb$var$Og(1, t, e1);
                if (i) return i;
                break;
            }
        case "case":
            for(let i = 1; i < e1.length - 1; i += 2){
                let n = $785da19a645c07eb$var$Og(i, t, e1);
                if (n) return n;
            }
    }
    return null;
}
const $785da19a645c07eb$var$Ng = {
    type: "boolean",
    default: !1,
    transition: !1,
    "property-type": "data-driven",
    expression: {
        interpolated: !1,
        parameters: [
            "zoom",
            "feature"
        ]
    }
};
function $785da19a645c07eb$var$jg(e1, t, i) {
    if (null == e1) return {
        filter: ()=>!0,
        needGeometry: !1,
        getGlobalStateRefs: ()=>new Set
    };
    $785da19a645c07eb$var$Rg(e1) ? function(e1, t) {
        let i = $785da19a645c07eb$var$Ug(e1);
        if (!i || typeof console > "u") return;
        let n = i.path.map((e1)=>`[${e1}]`).join("");
        console.warn(`${t}${n}: ${$785da19a645c07eb$var$Bg(i.legacyFilter)}`);
    }(e1, t) : e1 = $785da19a645c07eb$var$Gg(e1);
    let n = $785da19a645c07eb$var$kg(e1, t, $785da19a645c07eb$var$Ng, i);
    if ("error" === n.result) throw Error(n.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
    return {
        filter: (e1, t, i)=>n.value.evaluate(e1, t, {}, i),
        needGeometry: $785da19a645c07eb$var$qg(e1),
        getGlobalStateRefs: ()=>$785da19a645c07eb$var$Pg(n.value.expression)
    };
}
function $785da19a645c07eb$var$Vg(e1, t) {
    return e1 < t ? -1 : +(e1 > t);
}
function $785da19a645c07eb$var$qg(e1) {
    if (!Array.isArray(e1)) return !1;
    if ("within" === e1[0] || "distance" === e1[0]) return !0;
    for(let t = 1; t < e1.length; t++)if ($785da19a645c07eb$var$qg(e1[t])) return !0;
    return !1;
}
function $785da19a645c07eb$var$Gg(e1) {
    if (!e1) return !0;
    let t = e1[0];
    return e1.length <= 1 ? "any" !== t : "==" === t ? $785da19a645c07eb$var$Hg(e1[1], e1[2], "==") : "!=" === t ? $785da19a645c07eb$var$Kg($785da19a645c07eb$var$Hg(e1[1], e1[2], "==")) : "<" === t || ">" === t || "<=" === t || ">=" === t ? $785da19a645c07eb$var$Hg(e1[1], e1[2], t) : "any" === t ? function(e1) {
        return [
            "any"
        ].concat(e1.map($785da19a645c07eb$var$Gg));
    }(e1.slice(1)) : "all" === t ? [
        "all"
    ].concat(e1.slice(1).map($785da19a645c07eb$var$Gg)) : "none" === t ? [
        "all"
    ].concat(e1.slice(1).map($785da19a645c07eb$var$Gg).map($785da19a645c07eb$var$Kg)) : "in" === t ? $785da19a645c07eb$var$Wg(e1[1], e1.slice(2)) : "!in" === t ? $785da19a645c07eb$var$Kg($785da19a645c07eb$var$Wg(e1[1], e1.slice(2))) : "has" === t ? $785da19a645c07eb$var$Zg(e1[1]) : "!has" !== t || $785da19a645c07eb$var$Kg($785da19a645c07eb$var$Zg(e1[1]));
}
function $785da19a645c07eb$var$Hg(e1, t, i) {
    switch(e1){
        case "$type":
            return [
                `filter-type-${i}`,
                t
            ];
        case "$id":
            return [
                `filter-id-${i}`,
                t
            ];
        default:
            return [
                `filter-${i}`,
                e1,
                t
            ];
    }
}
function $785da19a645c07eb$var$Wg(e1, t) {
    if (0 === t.length) return !1;
    switch(e1){
        case "$type":
            return [
                "filter-type-in",
                [
                    "literal",
                    t
                ]
            ];
        case "$id":
            return [
                "filter-id-in",
                [
                    "literal",
                    t
                ]
            ];
        default:
            return t.length > 200 && !t.some((e1)=>typeof e1 != typeof t[0]) ? [
                "filter-in-large",
                e1,
                [
                    "literal",
                    t.sort($785da19a645c07eb$var$Vg)
                ]
            ] : [
                "filter-in-small",
                e1,
                [
                    "literal",
                    t
                ]
            ];
    }
}
function $785da19a645c07eb$var$Zg(e1) {
    switch(e1){
        case "$type":
            return !0;
        case "$id":
            return [
                "filter-has-id"
            ];
        default:
            return [
                "filter-has",
                e1
            ];
    }
}
function $785da19a645c07eb$var$Kg(e1) {
    return [
        "!",
        e1
    ];
}
function $785da19a645c07eb$var$Xg(e1) {
    let t = e1.key, i = e1.value;
    return i ? [
        new $785da19a645c07eb$var$cd(t, i, "constants have been deprecated as of v8")
    ] : [];
}
function $785da19a645c07eb$var$Qg(e1) {
    return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
}
function $785da19a645c07eb$var$Yg(e1) {
    if (Array.isArray(e1)) return e1.map($785da19a645c07eb$var$Yg);
    if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
        let t = {};
        for(let i in e1)t[i] = $785da19a645c07eb$var$Yg(e1[i]);
        return t;
    }
    return $785da19a645c07eb$var$Qg(e1);
}
function $785da19a645c07eb$var$Jg(e1) {
    let t = e1.key, i = e1.value, n = e1.valueSpec || {}, a = e1.objectElementValidators || {}, r = e1.style, s = e1.styleSpec, o = e1.validateSpec, l = [], c = $785da19a645c07eb$var$ug(i);
    if ("object" !== c) return [
        new $785da19a645c07eb$var$cd(t, i, `object expected, ${c} found`)
    ];
    for(let e1 in i){
        let c, u = e1.split(".")[0], h = $785da19a645c07eb$var$Kd(n, u) || n["*"];
        if ($785da19a645c07eb$var$Kd(a, u)) c = a[u];
        else if ($785da19a645c07eb$var$Kd(n, u)) {
            if (void 0 === i[e1]) continue;
            c = o;
        } else if (a["*"]) c = a["*"];
        else {
            if (!n["*"]) {
                l.push(new $785da19a645c07eb$var$cd(t, i[e1], `unknown property "${e1}"`));
                continue;
            }
            c = o;
        }
        l = l.concat(c({
            key: (t && `${t}.`) + e1,
            value: i[e1],
            valueSpec: h,
            style: r,
            styleSpec: s,
            object: i,
            objectKey: e1,
            validateSpec: o
        }, i));
    }
    for(let e1 in n)a[e1] || n[e1].required && void 0 === n[e1].default && void 0 === i[e1] && l.push(new $785da19a645c07eb$var$cd(t, i, `missing required property "${e1}"`));
    return l;
}
function $785da19a645c07eb$var$$g(e1) {
    let t = e1.value, i = e1.valueSpec, n = e1.validateSpec, a = e1.style, r = e1.styleSpec, s = e1.key, o = e1.arrayElementValidator || n;
    if ("array" !== $785da19a645c07eb$var$ug(t)) return [
        new $785da19a645c07eb$var$cd(s, t, `array expected, ${$785da19a645c07eb$var$ug(t)} found`)
    ];
    if (i.length && t.length !== i.length) return [
        new $785da19a645c07eb$var$cd(s, t, `array length ${i.length} expected, length ${t.length} found`)
    ];
    let l = {
        type: i.value,
        values: i.values
    };
    r.$version < 7 && (l.function = i.function), "object" === $785da19a645c07eb$var$ug(i.value) && (l = i.value);
    let c = [];
    for(let i = 0; i < t.length; i++)c = c.concat(o({
        array: t,
        arrayIndex: i,
        value: t[i],
        valueSpec: l,
        validateSpec: e1.validateSpec,
        style: a,
        styleSpec: r,
        key: `${s}[${i}]`
    }));
    return c;
}
function $785da19a645c07eb$var$ef(e1) {
    let t = e1.key, i = e1.value, n = e1.valueSpec, a = $785da19a645c07eb$var$ug(i);
    return "number" === a && i != i && (a = "NaN"), "number" === a ? "minimum" in n && i < n.minimum ? [
        new $785da19a645c07eb$var$cd(t, i, `${i} is less than the minimum value ${n.minimum}`)
    ] : "maximum" in n && i > n.maximum ? [
        new $785da19a645c07eb$var$cd(t, i, `${i} is greater than the maximum value ${n.maximum}`)
    ] : [] : [
        new $785da19a645c07eb$var$cd(t, i, `number expected, ${a} found`)
    ];
}
function $785da19a645c07eb$var$tf(e1) {
    let t, i, n, a = e1.valueSpec, r = $785da19a645c07eb$var$Qg(e1.value.type), s = {}, o = "categorical" !== r && void 0 === e1.value.property, l = !o, c = "array" === $785da19a645c07eb$var$ug(e1.value.stops) && "array" === $785da19a645c07eb$var$ug(e1.value.stops[0]) && "object" === $785da19a645c07eb$var$ug(e1.value.stops[0][0]), u = $785da19a645c07eb$var$Jg({
        key: e1.key,
        value: e1.value,
        valueSpec: e1.styleSpec.function,
        validateSpec: e1.validateSpec,
        style: e1.style,
        styleSpec: e1.styleSpec,
        objectElementValidators: {
            stops: function(e1) {
                if ("identity" === r) return [
                    new $785da19a645c07eb$var$cd(e1.key, e1.value, 'identity function may not have a "stops" property')
                ];
                let t = [], i = e1.value;
                return t = t.concat($785da19a645c07eb$var$$g({
                    key: e1.key,
                    value: i,
                    valueSpec: e1.valueSpec,
                    validateSpec: e1.validateSpec,
                    style: e1.style,
                    styleSpec: e1.styleSpec,
                    arrayElementValidator: h
                })), "array" === $785da19a645c07eb$var$ug(i) && 0 === i.length && t.push(new $785da19a645c07eb$var$cd(e1.key, i, "array must have at least one stop")), t;
            },
            default: function(e1) {
                return e1.validateSpec({
                    key: e1.key,
                    value: e1.value,
                    valueSpec: a,
                    validateSpec: e1.validateSpec,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                });
            }
        }
    });
    return "identity" === r && o && u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, 'missing required property "property"')), "identity" !== r && !e1.value.stops && u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, 'missing required property "stops"')), "exponential" === r && e1.valueSpec.expression && !$785da19a645c07eb$var$og(e1.valueSpec) && u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, "exponential functions not supported")), e1.styleSpec.$version >= 8 && (l && !$785da19a645c07eb$var$rg(e1.valueSpec) ? u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, "property functions not supported")) : o && !$785da19a645c07eb$var$sg(e1.valueSpec) && u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, "zoom functions not supported"))), ("categorical" === r || c) && void 0 === e1.value.property && u.push(new $785da19a645c07eb$var$cd(e1.key, e1.value, '"property" property is required')), u;
    function h(e1) {
        let t = [], r = e1.value, o = e1.key;
        if ("array" !== $785da19a645c07eb$var$ug(r)) return [
            new $785da19a645c07eb$var$cd(o, r, `array expected, ${$785da19a645c07eb$var$ug(r)} found`)
        ];
        if (2 !== r.length) return [
            new $785da19a645c07eb$var$cd(o, r, `array length 2 expected, length ${r.length} found`)
        ];
        if (c) {
            if ("object" !== $785da19a645c07eb$var$ug(r[0])) return [
                new $785da19a645c07eb$var$cd(o, r, `object expected, ${$785da19a645c07eb$var$ug(r[0])} found`)
            ];
            if (void 0 === r[0].zoom) return [
                new $785da19a645c07eb$var$cd(o, r, "object stop key must have zoom")
            ];
            if (void 0 === r[0].value) return [
                new $785da19a645c07eb$var$cd(o, r, "object stop key must have value")
            ];
            if (n && n > $785da19a645c07eb$var$Qg(r[0].zoom)) return [
                new $785da19a645c07eb$var$cd(o, r[0].zoom, "stop zoom values must appear in ascending order")
            ];
            $785da19a645c07eb$var$Qg(r[0].zoom) !== n && (n = $785da19a645c07eb$var$Qg(r[0].zoom), i = void 0, s = {}), t = t.concat($785da19a645c07eb$var$Jg({
                key: `${o}[0]`,
                value: r[0],
                valueSpec: {
                    zoom: {}
                },
                validateSpec: e1.validateSpec,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    zoom: $785da19a645c07eb$var$ef,
                    value: d
                }
            }));
        } else t = t.concat(d({
            key: `${o}[0]`,
            value: r[0],
            validateSpec: e1.validateSpec,
            style: e1.style,
            styleSpec: e1.styleSpec
        }, r));
        return $785da19a645c07eb$var$Eg($785da19a645c07eb$var$Yg(r[1])) ? t.concat([
            new $785da19a645c07eb$var$cd(`${o}[1]`, r[1], "expressions are not allowed in function stops.")
        ]) : t.concat(e1.validateSpec({
            key: `${o}[1]`,
            value: r[1],
            valueSpec: a,
            validateSpec: e1.validateSpec,
            style: e1.style,
            styleSpec: e1.styleSpec
        }));
    }
    function d(e1, n) {
        let o = $785da19a645c07eb$var$ug(e1.value), l = $785da19a645c07eb$var$Qg(e1.value), c = null === e1.value ? n : e1.value;
        if (t) {
            if (o !== t) return [
                new $785da19a645c07eb$var$cd(e1.key, c, `${o} stop domain type must match previous stop domain type ${t}`)
            ];
        } else t = o;
        if ("number" !== o && "string" !== o && "boolean" !== o) return [
            new $785da19a645c07eb$var$cd(e1.key, c, "stop domain value must be a number, string, or boolean")
        ];
        if ("number" !== o && "categorical" !== r) {
            let t = `number expected, ${o} found`;
            return $785da19a645c07eb$var$rg(a) && void 0 === r && (t += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                new $785da19a645c07eb$var$cd(e1.key, c, t)
            ];
        }
        return "categorical" !== r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== r && "number" === o && void 0 !== i && l < i ? [
            new $785da19a645c07eb$var$cd(e1.key, c, "stop domain values must appear in ascending order")
        ] : (i = l, "categorical" === r && l in s ? [
            new $785da19a645c07eb$var$cd(e1.key, c, "stop domain values must be unique")
        ] : (s[l] = !0, [])) : [
            new $785da19a645c07eb$var$cd(e1.key, c, `integer expected, found ${l}`)
        ];
    }
}
function $785da19a645c07eb$var$nf(e1) {
    let t = ("property" === e1.expressionContext ? $785da19a645c07eb$var$Cg : $785da19a645c07eb$var$kg)($785da19a645c07eb$var$Yg(e1.value), e1.key, e1.valueSpec);
    if ("error" === t.result) return t.value.map((t)=>new $785da19a645c07eb$var$cd(`${e1.key}${t.key}`, e1.value, t.message));
    let i = t.value.expression || t.value._styleExpression.expression;
    if ("property" === e1.expressionContext && "text-font" === e1.propertyKey && !i.outputDefined()) return [
        new $785da19a645c07eb$var$cd(e1.key, e1.value, `Invalid data expression for "${e1.propertyKey}". Output values must be contained as literals within the expression.`)
    ];
    if ("property" === e1.expressionContext && "layout" === e1.propertyType && !$785da19a645c07eb$var$ng(i)) return [
        new $785da19a645c07eb$var$cd(e1.key, e1.value, '"feature-state" data expressions are not supported with layout properties.')
    ];
    if ("filter" === e1.expressionContext && !$785da19a645c07eb$var$ng(i)) return [
        new $785da19a645c07eb$var$cd(e1.key, e1.value, '"feature-state" data expressions are not supported with filters.')
    ];
    if (e1.expressionContext && 0 === e1.expressionContext.indexOf("cluster")) {
        if (!$785da19a645c07eb$var$ag(i, [
            "zoom",
            "feature-state"
        ])) return [
            new $785da19a645c07eb$var$cd(e1.key, e1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
        ];
        if ("cluster-initial" === e1.expressionContext && !$785da19a645c07eb$var$ig(i)) return [
            new $785da19a645c07eb$var$cd(e1.key, e1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
        ];
    }
    return [];
}
function $785da19a645c07eb$var$af(e1) {
    let t = e1.key, i = e1.value, n = $785da19a645c07eb$var$ug(i);
    return "string" === n ? $785da19a645c07eb$var$np.parse(String(i)) ? [] : [
        new $785da19a645c07eb$var$cd(t, i, `color expected, "${i}" found`)
    ] : [
        new $785da19a645c07eb$var$cd(t, i, `color expected, ${n} found`)
    ];
}
function $785da19a645c07eb$var$rf(e1) {
    let t = e1.key, i = e1.value, n = e1.valueSpec, a = [];
    return Array.isArray(n.values) ? -1 === n.values.indexOf($785da19a645c07eb$var$Qg(i)) && a.push(new $785da19a645c07eb$var$cd(t, i, `expected one of [${n.values.join(", ")}], ${JSON.stringify(i)} found`)) : -1 === Object.keys(n.values).indexOf($785da19a645c07eb$var$Qg(i)) && a.push(new $785da19a645c07eb$var$cd(t, i, `expected one of [${Object.keys(n.values).join(", ")}], ${JSON.stringify(i)} found`)), a;
}
function $785da19a645c07eb$var$sf(e1, t) {
    let i = e1;
    for (let e1 of t)i = i[e1];
    return i;
}
function $785da19a645c07eb$var$of(e1, t) {
    let i = $785da19a645c07eb$var$Ug(t);
    return i ? [
        new $785da19a645c07eb$var$cd(`${e1.key}${i.path.map((e1)=>`[${e1}]`).join("")}`, $785da19a645c07eb$var$sf(e1.value, i.path), $785da19a645c07eb$var$Bg(i.legacyFilter), null, "warning")
    ] : [];
}
function $785da19a645c07eb$var$lf(e1) {
    let t = $785da19a645c07eb$var$Yg(e1.value);
    return $785da19a645c07eb$var$Rg(t) ? [
        ...$785da19a645c07eb$var$of(e1, t),
        ...$785da19a645c07eb$var$nf($785da19a645c07eb$var$cg({}, e1, {
            expressionContext: "filter",
            valueSpec: {
                value: "boolean"
            }
        }))
    ] : $785da19a645c07eb$var$cf(e1);
}
function $785da19a645c07eb$var$cf(e1) {
    let t = e1.value, i = e1.key;
    if ("array" !== $785da19a645c07eb$var$ug(t)) return [
        new $785da19a645c07eb$var$cd(i, t, `array expected, ${$785da19a645c07eb$var$ug(t)} found`)
    ];
    let n, a = e1.styleSpec, r = [];
    if (t.length < 1) return [
        new $785da19a645c07eb$var$cd(i, t, "filter array must have at least 1 element")
    ];
    switch(r = r.concat($785da19a645c07eb$var$rf({
        key: `${i}[0]`,
        value: t[0],
        valueSpec: a.filter_operator,
        style: e1.style,
        styleSpec: e1.styleSpec
    })), $785da19a645c07eb$var$Qg(t[0])){
        case "<":
        case "<=":
        case ">":
        case ">=":
            t.length >= 2 && "$type" === $785da19a645c07eb$var$Qg(t[1]) && r.push(new $785da19a645c07eb$var$cd(i, t, `"$type" cannot be use with operator "${t[0]}"`));
        case "==":
        case "!=":
            3 !== t.length && r.push(new $785da19a645c07eb$var$cd(i, t, `filter array for operator "${t[0]}" must have 3 elements`));
        case "in":
        case "!in":
            t.length >= 2 && (n = $785da19a645c07eb$var$ug(t[1]), "string" !== n && r.push(new $785da19a645c07eb$var$cd(`${i}[1]`, t[1], `string expected, ${n} found`)));
            for(let s = 2; s < t.length; s++)n = $785da19a645c07eb$var$ug(t[s]), "$type" === $785da19a645c07eb$var$Qg(t[1]) ? r = r.concat($785da19a645c07eb$var$rf({
                key: `${i}[${s}]`,
                value: t[s],
                valueSpec: a.geometry_type,
                style: e1.style,
                styleSpec: e1.styleSpec
            })) : "string" !== n && "number" !== n && "boolean" !== n && r.push(new $785da19a645c07eb$var$cd(`${i}[${s}]`, t[s], `string, number, or boolean expected, ${n} found`));
            break;
        case "any":
        case "all":
        case "none":
            for(let n = 1; n < t.length; n++)r = r.concat($785da19a645c07eb$var$cf({
                key: `${i}[${n}]`,
                value: t[n],
                style: e1.style,
                styleSpec: e1.styleSpec
            }));
            break;
        case "has":
        case "!has":
            n = $785da19a645c07eb$var$ug(t[1]), 2 === t.length ? "string" !== n && r.push(new $785da19a645c07eb$var$cd(`${i}[1]`, t[1], `string expected, ${n} found`)) : r.push(new $785da19a645c07eb$var$cd(i, t, `filter array for "${t[0]}" operator must have 2 elements`));
    }
    return r;
}
function $785da19a645c07eb$var$uf(e1, t) {
    let i = e1.key, n = e1.validateSpec, a = e1.style, r = e1.styleSpec, s = e1.value, o = e1.objectKey, l = r[`${t}_${e1.layerType}`];
    if (!l) return [];
    let c = o.match($785da19a645c07eb$var$lg);
    if ("paint" === t && c && l[c[1]] && l[c[1]].transition) return n({
        key: i,
        value: s,
        valueSpec: r.transition,
        style: a,
        styleSpec: r
    });
    let u, h = e1.valueSpec || l[o];
    if (!h) return [
        new $785da19a645c07eb$var$cd(i, s, `unknown property "${o}"`)
    ];
    if ("string" === $785da19a645c07eb$var$ug(s) && $785da19a645c07eb$var$rg(h) && !h.tokens && (u = /^{([^}]+)}$/.exec(s))) return [
        new $785da19a645c07eb$var$cd(i, s, `"${o}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(u[1])} }\`.`)
    ];
    let d = [];
    return "symbol" === e1.layerType && "text-font" === o && $785da19a645c07eb$var$hg($785da19a645c07eb$var$Yg(s)) && "identity" === $785da19a645c07eb$var$Qg(s.type) && d.push(new $785da19a645c07eb$var$cd(i, s, '"text-font" does not support identity functions')), d.concat(n({
        key: e1.key,
        value: s,
        valueSpec: h,
        style: a,
        styleSpec: r,
        expressionContext: "property",
        propertyType: t,
        propertyKey: o
    }));
}
function $785da19a645c07eb$var$hf(e1) {
    return $785da19a645c07eb$var$uf(e1, "paint");
}
function $785da19a645c07eb$var$df(e1) {
    return $785da19a645c07eb$var$uf(e1, "layout");
}
function $785da19a645c07eb$var$pf(e1) {
    let t = [], i = e1.value, n = e1.key, a = e1.style, r = e1.styleSpec;
    if ("object" !== $785da19a645c07eb$var$ug(i)) return [
        new $785da19a645c07eb$var$cd(n, i, `object expected, ${$785da19a645c07eb$var$ug(i)} found`)
    ];
    !i.type && !i.ref && t.push(new $785da19a645c07eb$var$cd(n, i, 'either "type" or "ref" is required'));
    let s = $785da19a645c07eb$var$Qg(i.type), o = $785da19a645c07eb$var$Qg(i.ref);
    if (i.id) {
        let r = $785da19a645c07eb$var$Qg(i.id);
        for(let s = 0; s < e1.arrayIndex; s++){
            let e1 = a.layers[s];
            $785da19a645c07eb$var$Qg(e1.id) === r && t.push(new $785da19a645c07eb$var$cd(n, i.id, `duplicate layer id "${i.id}", previously used at line ${e1.id.__line__}`));
        }
    }
    if ("ref" in i) {
        let e1;
        [
            "type",
            "source",
            "source-layer",
            "filter",
            "layout"
        ].forEach((e1)=>{
            e1 in i && t.push(new $785da19a645c07eb$var$cd(n, i[e1], `"${e1}" is prohibited for ref layers`));
        }), a.layers.forEach((t)=>{
            $785da19a645c07eb$var$Qg(t.id) === o && (e1 = t);
        }), e1 ? e1.ref ? t.push(new $785da19a645c07eb$var$cd(n, i.ref, "ref cannot reference another ref layer")) : s = $785da19a645c07eb$var$Qg(e1.type) : t.push(new $785da19a645c07eb$var$cd(n, i.ref, `ref layer "${o}" not found`));
    } else if ("background" !== s) {
        if (i.source) {
            let e1 = a.sources && a.sources[i.source], r = e1 && $785da19a645c07eb$var$Qg(e1.type);
            e1 ? "vector" === r && "raster" === s ? t.push(new $785da19a645c07eb$var$cd(n, i.source, `layer "${i.id}" requires a raster source`)) : "raster-dem" !== r && "hillshade" === s || "raster-dem" !== r && "color-relief" === s ? t.push(new $785da19a645c07eb$var$cd(n, i.source, `layer "${i.id}" requires a raster-dem source`)) : "raster" === r && "raster" !== s ? t.push(new $785da19a645c07eb$var$cd(n, i.source, `layer "${i.id}" requires a vector source`)) : "vector" !== r || i["source-layer"] ? "raster-dem" === r && "hillshade" !== s && "color-relief" !== s ? t.push(new $785da19a645c07eb$var$cd(n, i.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" === s && i.paint && i.paint["line-gradient"] && ("geojson" !== r || !e1.lineMetrics) && t.push(new $785da19a645c07eb$var$cd(n, i, `layer "${i.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : t.push(new $785da19a645c07eb$var$cd(n, i, `layer "${i.id}" must specify a "source-layer"`)) : t.push(new $785da19a645c07eb$var$cd(n, i.source, `source "${i.source}" not found`));
        } else t.push(new $785da19a645c07eb$var$cd(n, i, 'missing required property "source"'));
    }
    return "raster" === s && i.paint?.resampling && i.paint?.["raster-resampling"] && t.push(new $785da19a645c07eb$var$cd(n, i.paint, `layer "${i.id}" redundantly specifies "resampling" and "raster-resampling" paint properties, but only one is allowed. It is advised to use "resampling".`)), t = t.concat($785da19a645c07eb$var$Jg({
        key: n,
        value: i,
        valueSpec: r.layer,
        style: e1.style,
        styleSpec: e1.styleSpec,
        validateSpec: e1.validateSpec,
        objectElementValidators: {
            "*": ()=>[],
            type: ()=>e1.validateSpec({
                    key: `${n}.type`,
                    value: i.type,
                    valueSpec: r.layer.type,
                    style: e1.style,
                    styleSpec: e1.styleSpec,
                    validateSpec: e1.validateSpec,
                    object: i,
                    objectKey: "type"
                }),
            filter: $785da19a645c07eb$var$lf,
            layout: (e1)=>$785da19a645c07eb$var$Jg({
                    layer: i,
                    key: e1.key,
                    value: e1.value,
                    style: e1.style,
                    styleSpec: e1.styleSpec,
                    validateSpec: e1.validateSpec,
                    objectElementValidators: {
                        "*": (e1)=>$785da19a645c07eb$var$df($785da19a645c07eb$var$cg({
                                layerType: s
                            }, e1))
                    }
                }),
            paint: (e1)=>$785da19a645c07eb$var$Jg({
                    layer: i,
                    key: e1.key,
                    value: e1.value,
                    style: e1.style,
                    styleSpec: e1.styleSpec,
                    validateSpec: e1.validateSpec,
                    objectElementValidators: {
                        "*": (e1)=>$785da19a645c07eb$var$hf($785da19a645c07eb$var$cg({
                                layerType: s
                            }, e1))
                    }
                })
        }
    })), t;
}
function $785da19a645c07eb$var$mf(e1) {
    let t = e1.value, i = e1.key, n = $785da19a645c07eb$var$ug(t);
    return "string" === n ? [] : [
        new $785da19a645c07eb$var$cd(i, t, `string expected, ${n} found`)
    ];
}
const $785da19a645c07eb$var$gf = {
    promoteId: function({ key: e1, value: t }) {
        if ("string" === $785da19a645c07eb$var$ug(t)) return $785da19a645c07eb$var$mf({
            key: e1,
            value: t
        });
        {
            let i = [];
            for(let n in t)i.push(...$785da19a645c07eb$var$mf({
                key: `${e1}.${n}`,
                value: t[n]
            }));
            return i;
        }
    }
};
function $785da19a645c07eb$var$ff(e1) {
    let t = e1.value, i = e1.key, n = e1.styleSpec, a = e1.style, r = e1.validateSpec;
    if (!t.type) return [
        new $785da19a645c07eb$var$cd(i, t, '"type" is required')
    ];
    let s, o = $785da19a645c07eb$var$Qg(t.type);
    switch(o){
        case "vector":
        case "raster":
            return s = $785da19a645c07eb$var$Jg({
                key: i,
                value: t,
                valueSpec: n[`source_${o.replace("-", "_")}`],
                style: e1.style,
                styleSpec: n,
                objectElementValidators: $785da19a645c07eb$var$gf,
                validateSpec: r
            }), s;
        case "raster-dem":
            return s = function(e1) {
                let t = e1.sourceName ?? "", i = e1.value, n = e1.styleSpec, a = n.source_raster_dem, r = e1.style, s = [], o = $785da19a645c07eb$var$ug(i);
                if (void 0 === i) return s;
                if ("object" !== o) return s.push(new $785da19a645c07eb$var$cd("source_raster_dem", i, `object expected, ${o} found`)), s;
                let l = "custom" === $785da19a645c07eb$var$Qg(i.encoding), c = [
                    "redFactor",
                    "greenFactor",
                    "blueFactor",
                    "baseShift"
                ], u = e1.value.encoding ? `"${e1.value.encoding}"` : "Default";
                for(let o in i)!l && c.includes(o) ? s.push(new $785da19a645c07eb$var$cd(o, i[o], `In "${t}": "${o}" is only valid when "encoding" is set to "custom". ${u} encoding found`)) : a[o] ? s = s.concat(e1.validateSpec({
                    key: o,
                    value: i[o],
                    valueSpec: a[o],
                    validateSpec: e1.validateSpec,
                    style: r,
                    styleSpec: n
                })) : s.push(new $785da19a645c07eb$var$cd(o, i[o], `unknown property "${o}"`));
                return s;
            }({
                sourceName: i,
                value: t,
                style: e1.style,
                styleSpec: n,
                validateSpec: r
            }), s;
        case "geojson":
            if (s = $785da19a645c07eb$var$Jg({
                key: i,
                value: t,
                valueSpec: n.source_geojson,
                style: a,
                styleSpec: n,
                validateSpec: r,
                objectElementValidators: $785da19a645c07eb$var$gf
            }), t.cluster) for(let e1 in t.clusterProperties){
                let [n, a] = t.clusterProperties[e1], r = "string" == typeof n ? [
                    n,
                    [
                        "accumulated"
                    ],
                    [
                        "get",
                        e1
                    ]
                ] : n;
                s.push(...$785da19a645c07eb$var$nf({
                    key: `${i}.${e1}.map`,
                    value: a,
                    expressionContext: "cluster-map"
                })), s.push(...$785da19a645c07eb$var$nf({
                    key: `${i}.${e1}.reduce`,
                    value: r,
                    expressionContext: "cluster-reduce"
                }));
            }
            return s;
        case "video":
            return $785da19a645c07eb$var$Jg({
                key: i,
                value: t,
                valueSpec: n.source_video,
                style: a,
                validateSpec: r,
                styleSpec: n
            });
        case "image":
            return $785da19a645c07eb$var$Jg({
                key: i,
                value: t,
                valueSpec: n.source_image,
                style: a,
                validateSpec: r,
                styleSpec: n
            });
        case "canvas":
            return [
                new $785da19a645c07eb$var$cd(i, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
            ];
        default:
            return $785da19a645c07eb$var$rf({
                key: `${i}.type`,
                value: t.type,
                valueSpec: {
                    values: [
                        "vector",
                        "raster",
                        "raster-dem",
                        "geojson",
                        "video",
                        "image"
                    ]
                }
            });
    }
}
function $785da19a645c07eb$var$Af(e1) {
    let t = e1.value, i = e1.styleSpec, n = i.light, a = e1.style, r = [], s = $785da19a645c07eb$var$ug(t);
    if (void 0 === t) return r;
    if ("object" !== s) return r = r.concat([
        new $785da19a645c07eb$var$cd("light", t, `object expected, ${s} found`)
    ]), r;
    for(let s in t){
        let o = s.match($785da19a645c07eb$var$lg);
        r = o && n[o[1]] && n[o[1]].transition ? r.concat(e1.validateSpec({
            key: s,
            value: t[s],
            valueSpec: i.transition,
            validateSpec: e1.validateSpec,
            style: a,
            styleSpec: i
        })) : n[s] ? r.concat(e1.validateSpec({
            key: s,
            value: t[s],
            valueSpec: n[s],
            validateSpec: e1.validateSpec,
            style: a,
            styleSpec: i
        })) : r.concat([
            new $785da19a645c07eb$var$cd(s, t[s], `unknown property "${s}"`)
        ]);
    }
    return r;
}
function $785da19a645c07eb$var$_f(e1) {
    let t = e1.value, i = e1.styleSpec, n = i.sky, a = e1.style, r = $785da19a645c07eb$var$ug(t);
    if (void 0 === t) return [];
    if ("object" !== r) return [
        new $785da19a645c07eb$var$cd("sky", t, `object expected, ${r} found`)
    ];
    let s = [];
    for(let r in t){
        let o = r.match($785da19a645c07eb$var$lg);
        s = o && n[o[1]] && n[o[1]].transition ? s.concat(e1.validateSpec({
            key: r,
            value: t[r],
            valueSpec: i.transition,
            style: a,
            styleSpec: i
        })) : n[r] ? s.concat(e1.validateSpec({
            key: r,
            value: t[r],
            valueSpec: n[r],
            style: a,
            styleSpec: i
        })) : s.concat([
            new $785da19a645c07eb$var$cd(r, t[r], `unknown property "${r}"`)
        ]);
    }
    return s;
}
function $785da19a645c07eb$var$vf(e1) {
    let t = e1.value, i = e1.styleSpec, n = i.terrain, a = e1.style, r = [], s = $785da19a645c07eb$var$ug(t);
    if (void 0 === t) return r;
    if ("object" !== s) return r = r.concat([
        new $785da19a645c07eb$var$cd("terrain", t, `object expected, ${s} found`)
    ]), r;
    for(let s in t)r = n[s] ? r.concat(e1.validateSpec({
        key: s,
        value: t[s],
        valueSpec: n[s],
        validateSpec: e1.validateSpec,
        style: a,
        styleSpec: i
    })) : r.concat([
        new $785da19a645c07eb$var$cd(s, t[s], `unknown property "${s}"`)
    ]);
    return r;
}
function $785da19a645c07eb$var$yf(e1) {
    let t = [], i = e1.value, n = e1.key;
    if (Array.isArray(i)) {
        let a = [], r = [];
        for(let s in i)i[s].id && a.includes(i[s].id) && t.push(new $785da19a645c07eb$var$cd(n, i, `all the sprites' ids must be unique, but ${i[s].id} is duplicated`)), a.push(i[s].id), i[s].url && r.includes(i[s].url) && t.push(new $785da19a645c07eb$var$cd(n, i, `all the sprites' URLs must be unique, but ${i[s].url} is duplicated`)), r.push(i[s].url), t = t.concat($785da19a645c07eb$var$Jg({
            key: `${n}[${s}]`,
            value: i[s],
            valueSpec: {
                id: {
                    type: "string",
                    required: !0
                },
                url: {
                    type: "string",
                    required: !0
                }
            },
            validateSpec: e1.validateSpec
        }));
        return t;
    }
    return $785da19a645c07eb$var$mf({
        key: n,
        value: i
    });
}
function $785da19a645c07eb$var$xf(e1) {
    return !!e1 && e1.constructor === Object;
}
function $785da19a645c07eb$var$bf(e1) {
    return $785da19a645c07eb$var$xf(e1.value) ? [] : [
        new $785da19a645c07eb$var$cd(e1.key, e1.value, `object expected, ${$785da19a645c07eb$var$ug(e1.value)} found`)
    ];
}
const $785da19a645c07eb$var$wf = 1114111, $785da19a645c07eb$var$Ef = /^u\+(?:([0-9a-f]{1,6})(?:-([0-9a-f]{1,6}))?|([0-9a-f]{0,5}\?{1,6}))$/i;
function $785da19a645c07eb$var$kf(e1, t) {
    if ("string" !== $785da19a645c07eb$var$ug(t)) return [];
    let i = `${t}`, n = ()=>[
            new $785da19a645c07eb$var$cd(e1, t, 'invalid unicode range, expected a value such as "U+26", "U+0-10FFFF" or "U+4??"')
        ], a = i.match($785da19a645c07eb$var$Ef);
    if (!a) return n();
    let [, r, s, o] = a;
    if (void 0 !== o) return o.length > 6 ? n() : [];
    let l = parseInt(r, 16), c = void 0 === s ? l : parseInt(s, 16);
    return l > $785da19a645c07eb$var$wf || c > $785da19a645c07eb$var$wf ? [
        new $785da19a645c07eb$var$cd(e1, t, "unicode range is out of bounds, the maximum code point is U+10FFFF")
    ] : l > c ? [
        new $785da19a645c07eb$var$cd(e1, t, `unicode range start must not be greater than its end, but ${i} is`)
    ] : [];
}
function $785da19a645c07eb$var$Sf(e1) {
    let t = e1.key ?? "font-faces", i = e1.value, n = e1.validateSpec, a = e1.styleSpec ?? $785da19a645c07eb$var$sd, r = e1.style;
    if (!$785da19a645c07eb$var$xf(i)) return [
        new $785da19a645c07eb$var$cd(t, i, `object expected, ${$785da19a645c07eb$var$ug(i)} found`)
    ];
    let s = [];
    for(let e1 in i){
        let o = i[e1], l = $785da19a645c07eb$var$ug(o);
        if ("string" === l) s.push(...$785da19a645c07eb$var$mf({
            key: `${t}.${e1}`,
            value: o
        }));
        else if ("array" === l) {
            let i = {
                url: {
                    type: "string",
                    required: !0
                },
                "unicode-range": {
                    type: "array",
                    value: "string"
                }
            };
            for (let [l, c] of o.entries()){
                let o = `${t}.${e1}[${l}]`;
                s.push(...$785da19a645c07eb$var$Jg({
                    key: o,
                    value: c,
                    valueSpec: i,
                    styleSpec: a,
                    style: r,
                    validateSpec: n
                }));
                let u = $785da19a645c07eb$var$xf(c) ? c["unicode-range"] : void 0;
                if ("array" === $785da19a645c07eb$var$ug(u)) for (let [e1, t] of u.entries())s.push(...$785da19a645c07eb$var$kf(`${o}.unicode-range[${e1}]`, t));
            }
        } else s.push(new $785da19a645c07eb$var$cd(`${t}.${e1}`, o, `string or array expected, ${l} found`));
    }
    return s;
}
const $785da19a645c07eb$var$Mf = {
    "*": ()=>[],
    array: $785da19a645c07eb$var$$g,
    boolean: function(e1) {
        let t = e1.value, i = e1.key, n = $785da19a645c07eb$var$ug(t);
        return "boolean" === n ? [] : [
            new $785da19a645c07eb$var$cd(i, t, `boolean expected, ${n} found`)
        ];
    },
    number: $785da19a645c07eb$var$ef,
    color: $785da19a645c07eb$var$af,
    constants: $785da19a645c07eb$var$Xg,
    enum: $785da19a645c07eb$var$rf,
    filter: $785da19a645c07eb$var$lf,
    function: $785da19a645c07eb$var$tf,
    layer: $785da19a645c07eb$var$pf,
    object: $785da19a645c07eb$var$Jg,
    source: $785da19a645c07eb$var$ff,
    light: $785da19a645c07eb$var$Af,
    sky: $785da19a645c07eb$var$_f,
    terrain: $785da19a645c07eb$var$vf,
    projection: function(e1) {
        let t = e1.value, i = e1.styleSpec, n = i.projection, a = e1.style, r = $785da19a645c07eb$var$ug(t);
        if (void 0 === t) return [];
        if ("object" !== r) return [
            new $785da19a645c07eb$var$cd("projection", t, `object expected, ${r} found`)
        ];
        let s = [];
        for(let r in t)s = n[r] ? s.concat(e1.validateSpec({
            key: r,
            value: t[r],
            valueSpec: n[r],
            style: a,
            styleSpec: i
        })) : s.concat([
            new $785da19a645c07eb$var$cd(r, t[r], `unknown property "${r}"`)
        ]);
        return s;
    },
    projectionDefinition: function(e1) {
        let t = e1.key, i = e1.value;
        i = i instanceof String ? i.valueOf() : i;
        let n = $785da19a645c07eb$var$ug(i);
        return "array" !== n || function(e1) {
            return Array.isArray(e1) && 3 === e1.length && "string" == typeof e1[0] && "string" == typeof e1[1] && "number" == typeof e1[2];
        }(i) || function(e1) {
            return !![
                "interpolate",
                "step",
                "literal"
            ].includes(e1[0]);
        }(i) ? [
            "array",
            "string"
        ].includes(n) ? [] : [
            new $785da19a645c07eb$var$cd(t, i, `projection expected, invalid type "${n}" found`)
        ] : [
            new $785da19a645c07eb$var$cd(t, i, `projection expected, invalid array ${JSON.stringify(i)} found`)
        ];
    },
    string: $785da19a645c07eb$var$mf,
    formatted: function(e1) {
        return 0 === $785da19a645c07eb$var$mf(e1).length ? [] : $785da19a645c07eb$var$nf(e1);
    },
    resolvedImage: function(e1) {
        return 0 === $785da19a645c07eb$var$mf(e1).length ? [] : $785da19a645c07eb$var$nf(e1);
    },
    padding: function(e1) {
        let t = e1.key, i = e1.value;
        if ("array" === $785da19a645c07eb$var$ug(i)) {
            if (i.length < 1 || i.length > 4) return [
                new $785da19a645c07eb$var$cd(t, i, `padding requires 1 to 4 values; ${i.length} values found`)
            ];
            let n = {
                type: "number"
            }, a = [];
            for(let r = 0; r < i.length; r++)a = a.concat(e1.validateSpec({
                key: `${t}[${r}]`,
                value: i[r],
                validateSpec: e1.validateSpec,
                valueSpec: n
            }));
            return a;
        }
        return $785da19a645c07eb$var$ef({
            key: t,
            value: i,
            valueSpec: {}
        });
    },
    numberArray: function(e1) {
        let t = e1.key, i = e1.value;
        if ("array" === $785da19a645c07eb$var$ug(i)) {
            let n = {
                type: "number"
            };
            if (i.length < 1) return [
                new $785da19a645c07eb$var$cd(t, i, "array length at least 1 expected, length 0 found")
            ];
            let a = [];
            for(let r = 0; r < i.length; r++)a = a.concat(e1.validateSpec({
                key: `${t}[${r}]`,
                value: i[r],
                validateSpec: e1.validateSpec,
                valueSpec: n
            }));
            return a;
        }
        return $785da19a645c07eb$var$ef({
            key: t,
            value: i,
            valueSpec: {}
        });
    },
    colorArray: function(e1) {
        let t = e1.key, i = e1.value;
        if ("array" === $785da19a645c07eb$var$ug(i)) {
            if (i.length < 1) return [
                new $785da19a645c07eb$var$cd(t, i, "array length at least 1 expected, length 0 found")
            ];
            let e1 = [];
            for(let n = 0; n < i.length; n++)e1 = e1.concat($785da19a645c07eb$var$af({
                key: `${t}[${n}]`,
                value: i[n]
            }));
            return e1;
        }
        return $785da19a645c07eb$var$af({
            key: t,
            value: i
        });
    },
    variableAnchorOffsetCollection: function(e1) {
        let t = e1.key, i = e1.value, n = $785da19a645c07eb$var$ug(i), a = e1.styleSpec;
        if ("array" !== n || i.length < 1 || i.length % 2 != 0) return [
            new $785da19a645c07eb$var$cd(t, i, "variableAnchorOffsetCollection requires a non-empty array of even length")
        ];
        let r = [];
        for(let n = 0; n < i.length; n += 2)r = r.concat($785da19a645c07eb$var$rf({
            key: `${t}[${n}]`,
            value: i[n],
            valueSpec: a.layout_symbol["text-anchor"]
        })), r = r.concat($785da19a645c07eb$var$$g({
            key: `${t}[${n + 1}]`,
            value: i[n + 1],
            valueSpec: {
                length: 2,
                value: "number"
            },
            validateSpec: e1.validateSpec,
            style: e1.style,
            styleSpec: a
        }));
        return r;
    },
    sprite: $785da19a645c07eb$var$yf,
    state: $785da19a645c07eb$var$bf,
    fontFaces: $785da19a645c07eb$var$Sf
};
function $785da19a645c07eb$var$Cf(e1) {
    let t = e1.value, i = e1.valueSpec, n = e1.styleSpec;
    return e1.validateSpec = $785da19a645c07eb$var$Cf, i.expression && $785da19a645c07eb$var$hg($785da19a645c07eb$var$Qg(t)) ? $785da19a645c07eb$var$tf(e1) : i.expression && $785da19a645c07eb$var$Eg($785da19a645c07eb$var$Yg(t)) ? $785da19a645c07eb$var$nf(e1) : i.type && $785da19a645c07eb$var$Mf[i.type] ? $785da19a645c07eb$var$Mf[i.type](e1) : $785da19a645c07eb$var$Jg($785da19a645c07eb$var$cg({}, e1, {
        valueSpec: i.type ? n[i.type] : i
    }));
}
function $785da19a645c07eb$var$Tf(e1) {
    let t = e1.value, i = e1.key, n = $785da19a645c07eb$var$mf(e1);
    return n.length || (-1 === t.indexOf("{fontstack}") && n.push(new $785da19a645c07eb$var$cd(i, t, '"glyphs" url must include a "{fontstack}" token')), -1 === t.indexOf("{range}") && n.push(new $785da19a645c07eb$var$cd(i, t, '"glyphs" url must include a "{range}" token'))), n;
}
function $785da19a645c07eb$var$Df(e1, t = $785da19a645c07eb$var$od) {
    let i = [];
    return i = i.concat($785da19a645c07eb$var$Cf({
        key: "",
        value: e1,
        valueSpec: t.$root,
        styleSpec: t,
        style: e1,
        validateSpec: $785da19a645c07eb$var$Cf,
        objectElementValidators: {
            glyphs: $785da19a645c07eb$var$Tf,
            "*": ()=>[]
        }
    })), e1.constants && (i = i.concat($785da19a645c07eb$var$Xg({
        key: "constants",
        value: e1.constants
    }))), $785da19a645c07eb$var$If(i);
}
function $785da19a645c07eb$var$Pf(e1) {
    return function(t) {
        return e1(Object.assign({}, t, {
            validateSpec: $785da19a645c07eb$var$Cf
        }));
    };
}
function $785da19a645c07eb$var$If(e1) {
    return [].concat(e1).sort((e1, t)=>e1.line - t.line);
}
function $785da19a645c07eb$var$Ff(e1) {
    return function(...t) {
        return $785da19a645c07eb$var$If(e1.apply(this, t));
    };
}
$785da19a645c07eb$var$Df.source = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$ff)), $785da19a645c07eb$var$Df.sprite = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$yf)), $785da19a645c07eb$var$Df.glyphs = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$Tf)), $785da19a645c07eb$var$Df.fontFaces = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$Sf)), $785da19a645c07eb$var$Df.light = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$Af)), $785da19a645c07eb$var$Df.sky = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$_f)), $785da19a645c07eb$var$Df.terrain = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$vf)), $785da19a645c07eb$var$Df.state = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$bf)), $785da19a645c07eb$var$Df.layer = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$pf)), $785da19a645c07eb$var$Df.filter = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$lf)), $785da19a645c07eb$var$Df.paintProperty = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$hf)), $785da19a645c07eb$var$Df.layoutProperty = $785da19a645c07eb$var$Ff($785da19a645c07eb$var$Pf($785da19a645c07eb$var$df));
const $785da19a645c07eb$var$zf = {
    type: "enum",
    "property-type": "data-constant",
    expression: {
        interpolated: !1,
        parameters: [
            "global-state"
        ]
    },
    values: {
        visible: {},
        none: {}
    },
    transition: !1,
    default: "visible"
};
var $785da19a645c07eb$var$Rf = class {
    constructor(e1, t, i){
        this._rootKey = t, this._globalState = i, this.setValue(e1);
    }
    evaluate() {
        return this._literalValue ?? this._compiledValue.evaluate({});
    }
    setValue(e1) {
        if (null == e1 || "visible" === e1 || "none" === e1) return this._literalValue = "none" === e1 ? "none" : "visible", this._compiledValue = void 0, void (this._globalStateRefs = new Set);
        let t = $785da19a645c07eb$var$kg(e1, this._rootKey, $785da19a645c07eb$var$zf, this._globalState);
        if ("error" === t.result) throw this._literalValue = "visible", this._compiledValue = void 0, Error(t.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
        this._literalValue = void 0, this._compiledValue = t.value, this._globalStateRefs = $785da19a645c07eb$var$Pg(t.value.expression);
    }
    getGlobalStateRefs() {
        return this._globalStateRefs;
    }
};
const $785da19a645c07eb$var$Lf = $785da19a645c07eb$var$Df, $785da19a645c07eb$var$Bf = new Set(Object.keys($785da19a645c07eb$var$od).filter((e1)=>e1.startsWith("source_")).map((e1)=>e1.slice(7).replaceAll("_", "-")));
function $785da19a645c07eb$var$Of(e1, t) {
    let i = function(e1) {
        return Object.entries(e1.sources ?? {}).filter(([, e1])=>!$785da19a645c07eb$var$Bf.has(e1.type)).map(([e1])=>`sources.${e1}`);
    }(t);
    return $785da19a645c07eb$var$Uf(e1, $785da19a645c07eb$var$Lf(t).filter(({ message: e1 })=>!i.some((t)=>e1.startsWith(`${t}:`) || e1.startsWith(`${t}.`))));
}
function $785da19a645c07eb$var$Uf(e1, t) {
    let i = !1;
    for (let n of t)"warning" !== n.severity ? (e1.fire(new $785da19a645c07eb$var$ad(Error(n.message))), i = !0) : $785da19a645c07eb$var$wh(n.message);
    return i;
}
function $785da19a645c07eb$var$Nf(e1, t, i, n) {
    return !1 !== n?.validate && $785da19a645c07eb$var$Uf(e1, t({
        styleSpec: $785da19a645c07eb$var$od,
        ...i
    }));
}
var $785da19a645c07eb$var$jf = class e1 {
    constructor(e1, t, i){
        let n = this.cells = [];
        if (e1 instanceof ArrayBuffer) {
            this.arrayBuffer = e1;
            let a = new Int32Array(this.arrayBuffer);
            e1 = a[0], t = a[1], i = a[2], this.d = t + 2 * i;
            for(let e1 = 0; e1 < this.d * this.d; e1++){
                let t = a[3 + e1], i = a[3 + e1 + 1];
                n.push(t === i ? null : a.subarray(t, i));
            }
            let r = a[3 + n.length], s = a[3 + n.length + 1];
            this.keys = a.subarray(r, s), this.bboxes = a.subarray(s), this.insert = this._insertReadonly;
        } else {
            this.d = t + 2 * i;
            for(let e1 = 0; e1 < this.d * this.d; e1++)n.push([]);
            this.keys = [], this.bboxes = [];
        }
        this.n = t, this.extent = e1, this.padding = i, this.scale = t / e1, this.uid = 0;
        let a = i / t * e1;
        this.min = -a, this.max = e1 + a;
    }
    insert(e1, t, i, n, a) {
        this._forEachCell(t, i, n, a, this._insertCell, this.uid++, void 0, void 0), this.keys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(n), this.bboxes.push(a);
    }
    _insertReadonly() {
        throw Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
    }
    _insertCell(e1, t, i, n, a, r) {
        this.cells[a].push(r);
    }
    query(e1, t, i, n, a) {
        let r = this.min, s = this.max;
        if (e1 <= r && t <= r && s <= i && s <= n && !a) return [
            ...this.keys
        ];
        {
            let r = [];
            return this._forEachCell(e1, t, i, n, this._queryCell, r, {}, a), r;
        }
    }
    _queryCell(e1, t, i, n, a, r, s, o) {
        let l = this.cells[a];
        if (null !== l) {
            let a = this.keys, c = this.bboxes;
            for (let u of l)if (void 0 === s[u]) {
                let l = 4 * u;
                (o ? o(c[l + 0], c[l + 1], c[l + 2], c[l + 3]) : e1 <= c[l + 2] && t <= c[l + 3] && i >= c[l + 0] && n >= c[l + 1]) ? (s[u] = !0, r.push(a[u])) : s[u] = !1;
            }
        }
    }
    _forEachCell(e1, t, i, n, a, r, s, o) {
        let l = this._convertToCellCoord(e1), c = this._convertToCellCoord(t), u = this._convertToCellCoord(i), h = this._convertToCellCoord(n);
        for(let d = l; d <= u; d++)for(let l = c; l <= h; l++){
            let c = this.d * l + d;
            if ((!o || o(this._convertFromCellCoord(d), this._convertFromCellCoord(l), this._convertFromCellCoord(d + 1), this._convertFromCellCoord(l + 1))) && a.call(this, e1, t, i, n, c, r, s, o)) return;
        }
    }
    _convertFromCellCoord(e1) {
        return (e1 - this.padding) / this.scale;
    }
    _convertToCellCoord(e1) {
        return Math.max(0, Math.min(this.d - 1, Math.floor(e1 * this.scale) + this.padding));
    }
    toArrayBuffer() {
        if (this.arrayBuffer) return this.arrayBuffer;
        let e1 = this.cells, t = 3 + this.cells.length + 1 + 1, i = 0;
        for (let e1 of this.cells)i += e1.length;
        let n = new Int32Array(t + i + this.keys.length + this.bboxes.length);
        n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
        let a = t;
        for(let t = 0; t < e1.length; t++){
            let i = e1[t];
            n[3 + t] = a, n.set(i, a), a += i.length;
        }
        return n[3 + e1.length] = a, n.set(this.keys, a), a += this.keys.length, n[3 + e1.length + 1] = a, n.set(this.bboxes, a), a += this.bboxes.length, n.buffer;
    }
    static serialize(e1, t) {
        let i = e1.toArrayBuffer();
        return t && t.push(i), {
            buffer: i
        };
    }
    static deserialize(t) {
        return new e1(t.buffer);
    }
};
const $785da19a645c07eb$var$Vf = {};
function $785da19a645c07eb$var$qf(e1, t, i = {}) {
    if ($785da19a645c07eb$var$Vf[e1]) throw Error(`${e1} is already registered.`);
    Object.defineProperty(t, "_classRegistryKey", {
        value: e1,
        writeable: !1
    }), $785da19a645c07eb$var$Vf[e1] = {
        klass: t,
        omit: i.omit || [],
        shallow: i.shallow || []
    };
}
$785da19a645c07eb$var$qf("Object", Object), $785da19a645c07eb$var$qf("Set", Set), $785da19a645c07eb$var$qf("TransferableGridIndex", $785da19a645c07eb$var$jf), $785da19a645c07eb$var$qf("Color", $785da19a645c07eb$var$np), $785da19a645c07eb$var$qf("Error", Error), $785da19a645c07eb$var$qf("AJAXError", $785da19a645c07eb$var$Xh), $785da19a645c07eb$var$qf("ResolvedImage", $785da19a645c07eb$var$pp), $785da19a645c07eb$var$qf("StylePropertyFunction", $785da19a645c07eb$var$Tg), $785da19a645c07eb$var$qf("StyleExpression", $785da19a645c07eb$var$xg, {
    omit: [
        "_evaluator"
    ]
}), $785da19a645c07eb$var$qf("ZoomDependentExpression", $785da19a645c07eb$var$Mg), $785da19a645c07eb$var$qf("ZoomConstantExpression", $785da19a645c07eb$var$Sg), $785da19a645c07eb$var$qf("CompoundExpression", $785da19a645c07eb$var$Qm, {
    omit: [
        "_evaluate"
    ]
});
for(let e1 in $785da19a645c07eb$var$Wm)$785da19a645c07eb$var$Wm[e1]._classRegistryKey || $785da19a645c07eb$var$qf(`Expression_${e1}`, $785da19a645c07eb$var$Wm[e1]);
function $785da19a645c07eb$var$Gf(e1) {
    return e1 && typeof ArrayBuffer < "u" && (e1 instanceof ArrayBuffer || "ArrayBuffer" === e1.constructor?.name);
}
function $785da19a645c07eb$var$Hf(e1) {
    let t = e1.constructor;
    return e1.$name || t._classRegistryKey;
}
function $785da19a645c07eb$var$Wf(e1) {
    return !function(e1) {
        if ("object" != typeof e1 || !e1) return !1;
        let t = $785da19a645c07eb$var$Hf(e1);
        return t && "Object" !== t;
    }(e1) && (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp || e1 instanceof Blob || e1 instanceof Error || $785da19a645c07eb$var$Gf(e1) || $785da19a645c07eb$var$Mh(e1) || ArrayBuffer.isView(e1) || e1 instanceof ImageData);
}
function $785da19a645c07eb$var$Zf(e1, t) {
    if ($785da19a645c07eb$var$Wf(e1)) return ($785da19a645c07eb$var$Gf(e1) || $785da19a645c07eb$var$Mh(e1)) && t && t.push(e1), ArrayBuffer.isView(e1) && t && t.push(e1.buffer), e1 instanceof ImageData && t && t.push(e1.data.buffer), e1;
    if (Array.isArray(e1)) {
        let i = [];
        for (let n of e1)i.push($785da19a645c07eb$var$Zf(n, t));
        return i;
    }
    if ("object" != typeof e1) throw Error("can't serialize object of type " + typeof e1);
    let i = $785da19a645c07eb$var$Hf(e1);
    if (!i) throw Error(`can't serialize object of unregistered class ${e1.constructor.name}`);
    if (!$785da19a645c07eb$var$Vf[i]) throw Error(`${i} is not registered.`);
    let { klass: n } = $785da19a645c07eb$var$Vf[i], a = n.serialize ? n.serialize(e1, t) : {};
    if (n.serialize) {
        if (a === t?.[t.length - 1]) throw Error("statically serialized object won't survive transfer of $name property");
    } else {
        for(let n in e1){
            if (!e1.hasOwnProperty(n) || $785da19a645c07eb$var$Vf[i].omit.includes(n)) continue;
            let r = e1[n];
            void 0 !== r && (a[n] = $785da19a645c07eb$var$Vf[i].shallow.includes(n) ? r : $785da19a645c07eb$var$Zf(r, t));
        }
        e1 instanceof Error && (a.message = e1.message);
    }
    if (a.$name) throw Error("$name property is reserved for worker serialization logic.");
    return "Object" !== i && (a.$name = i), a;
}
function $785da19a645c07eb$var$Kf(e1) {
    if ($785da19a645c07eb$var$Wf(e1)) return e1;
    if (Array.isArray(e1)) return e1.map($785da19a645c07eb$var$Kf);
    if ("object" != typeof e1) throw Error("can't deserialize object of type " + typeof e1);
    let t = $785da19a645c07eb$var$Hf(e1) || "Object";
    if (!$785da19a645c07eb$var$Vf[t]) throw Error(`can't deserialize unregistered class ${t}`);
    let { klass: i } = $785da19a645c07eb$var$Vf[t];
    if (!i) throw Error(`can't deserialize unregistered class ${t}`);
    if (i.deserialize) return i.deserialize(e1);
    let n = Object.create(i.prototype);
    for (let i of Object.keys(e1)){
        if ("$name" === i) continue;
        let a = e1[i];
        n[i] = $785da19a645c07eb$var$Vf[t].shallow.includes(i) ? a : $785da19a645c07eb$var$Kf(a);
    }
    return n;
}
var $785da19a645c07eb$var$Xf = class {
    constructor(){
        this.first = !0;
    }
    update(e1, t) {
        let i = Math.floor(e1);
        return this.first ? (this.first = !1, this.lastIntegerZoom = i, this.lastIntegerZoomTime = 0, this.lastZoom = e1, this.lastFloorZoom = i, !0) : (this.lastFloorZoom > i ? (this.lastIntegerZoom = i + 1, this.lastIntegerZoomTime = t) : this.lastFloorZoom < i && (this.lastIntegerZoom = i, this.lastIntegerZoomTime = t), e1 !== this.lastZoom && (this.lastZoom = e1, this.lastFloorZoom = i, !0));
    }
}, $785da19a645c07eb$var$Qf = class {
    constructor(e1, t){
        this.zoom = e1, t ? (this.now = t.now || 0, this.fadeDuration = t.fadeDuration || 0, this.zoomHistory = t.zoomHistory || new $785da19a645c07eb$var$Xf, this.transition = t.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new $785da19a645c07eb$var$Xf, this.transition = {});
    }
    crossFadingFactor() {
        return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
    }
    getCrossfadeParameters() {
        let e1 = this.zoom, t = e1 - Math.floor(e1), i = this.crossFadingFactor();
        return e1 > this.zoomHistory.lastIntegerZoom ? {
            fromScale: 2,
            toScale: 1,
            t: t + (1 - t) * i
        } : {
            fromScale: .5,
            toScale: 1,
            t: 1 - (1 - i) * t
        };
    }
};
const $785da19a645c07eb$var$Yf = "-transition";
var $785da19a645c07eb$var$Jf = class {
    constructor(e1, t, i, n){
        this.property = e1, this.value = t, this.expression = function(e1, t, i, n) {
            if ($785da19a645c07eb$var$hg(e1)) return new $785da19a645c07eb$var$Tg(e1, t, i);
            if ($785da19a645c07eb$var$Eg(e1)) {
                let a = $785da19a645c07eb$var$Cg(e1, t, i, n);
                if ("error" === a.result) throw Error(a.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                return a.value;
            }
            {
                let t = e1;
                return "color" === i.type && "string" == typeof e1 ? t = $785da19a645c07eb$var$np.parse(e1) : "padding" !== i.type || "number" != typeof e1 && !Array.isArray(e1) ? "numberArray" !== i.type || "number" != typeof e1 && !Array.isArray(e1) ? "colorArray" !== i.type || "string" != typeof e1 && !Array.isArray(e1) ? "variableAnchorOffsetCollection" === i.type && Array.isArray(e1) ? t = $785da19a645c07eb$var$dp.parse(e1) : "projectionDefinition" === i.type && "string" == typeof e1 && (t = $785da19a645c07eb$var$mp.parse(e1)) : t = $785da19a645c07eb$var$cp.parse(e1) : t = $785da19a645c07eb$var$lp.parse(e1) : t = $785da19a645c07eb$var$op.parse(e1), {
                    globalStateRefs: new Set,
                    _globalState: null,
                    kind: "constant",
                    evaluate: ()=>t
                };
            }
        }(void 0 === t ? e1.specification.default : t, i, e1.specification, n);
    }
    isDataDriven() {
        return "source" === this.expression.kind || "composite" === this.expression.kind;
    }
    getGlobalStateRefs() {
        return this.expression.globalStateRefs || new Set;
    }
    possiblyEvaluate(e1, t, i) {
        return this.property.possiblyEvaluate(this, e1, t, i);
    }
}, $785da19a645c07eb$var$$f = class {
    constructor(e1, t, i){
        this.property = e1, this.value = new $785da19a645c07eb$var$Jf(e1, void 0, t, i);
    }
    transitioned(e1, t) {
        return new $785da19a645c07eb$var$tA(this.property, this.value, t, $785da19a645c07eb$var$hh({}, e1.transition, this.transition), e1.now);
    }
    untransitioned() {
        return new $785da19a645c07eb$var$tA(this.property, this.value, null, {}, 0);
    }
}, $785da19a645c07eb$var$eA = class {
    constructor(e1, t, i){
        this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._globalState = i, this._rootKey = t;
    }
    _propertyRootKey(e1) {
        return `${this._rootKey}.${String(e1)}`;
    }
    hasProperty(e1) {
        return e1 in this._properties.defaultTransitionablePropertyValues;
    }
    getValue(e1) {
        return $785da19a645c07eb$var$xh(this._values[e1].value.value);
    }
    setValue(e1, t) {
        Object.hasOwn(this._values, e1) || (this._values[e1] = new $785da19a645c07eb$var$$f(this._values[e1].property, this._propertyRootKey(e1), this._globalState)), this._values[e1].value = new $785da19a645c07eb$var$Jf(this._values[e1].property, null === t ? void 0 : $785da19a645c07eb$var$xh(t), this._propertyRootKey(e1), this._globalState);
    }
    getTransition(e1) {
        return $785da19a645c07eb$var$xh(this._values[e1].transition);
    }
    setTransition(e1, t) {
        Object.hasOwn(this._values, e1) || (this._values[e1] = new $785da19a645c07eb$var$$f(this._values[e1].property, this._propertyRootKey(e1), this._globalState)), this._values[e1].transition = $785da19a645c07eb$var$xh(t) || void 0;
    }
    serialize() {
        let e1 = {};
        for (let t of Object.keys(this._values)){
            let i = this.getValue(t);
            void 0 !== i && (e1[t] = i);
            let n = this.getTransition(t);
            void 0 !== n && (e1[`${t}${$785da19a645c07eb$var$Yf}`] = n);
        }
        return e1;
    }
    transitioned(e1, t) {
        let i = new $785da19a645c07eb$var$iA(this._properties);
        for (let n of Object.keys(this._values))i._values[n] = this._values[n].transitioned(e1, t._values[n]);
        return i;
    }
    untransitioned() {
        let e1 = new $785da19a645c07eb$var$iA(this._properties);
        for (let t of Object.keys(this._values))e1._values[t] = this._values[t].untransitioned();
        return e1;
    }
}, $785da19a645c07eb$var$tA = class {
    constructor(e1, t, i, n, a){
        this.property = e1, this.value = t, this.begin = a + n.delay || 0, this.end = this.begin + n.duration || 0, e1.specification.transition && (n.delay || n.duration) && (this.prior = i);
    }
    possiblyEvaluate(e1, t, i) {
        let n = e1.now || 0, a = this.value.possiblyEvaluate(e1, t, i), r = this.prior;
        if (!r) return a;
        if (n > this.end || this.value.isDataDriven()) return this.prior = null, a;
        if (n < this.begin) return r.possiblyEvaluate(e1, t, i);
        {
            let s = (n - this.begin) / (this.end - this.begin);
            return this.property.interpolate(r.possiblyEvaluate(e1, t, i), a, function(e1) {
                if (e1 <= 0) return 0;
                if (e1 >= 1) return 1;
                let t = e1 * e1, i = t * e1;
                return 4 * (e1 < .5 ? i : 3 * (e1 - t) + i - .75);
            }(s));
        }
    }
}, $785da19a645c07eb$var$iA = class {
    constructor(e1){
        this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
    }
    possiblyEvaluate(e1, t, i) {
        let n = new $785da19a645c07eb$var$rA(this._properties);
        for (let a of Object.keys(this._values))n._values[a] = this._values[a].possiblyEvaluate(e1, t, i);
        return n;
    }
    hasTransition() {
        for (let e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
        return !1;
    }
}, $785da19a645c07eb$var$nA = class {
    constructor(e1, t, i){
        this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._globalState = i, this._rootKey = t;
    }
    _propertyRootKey(e1) {
        return `${this._rootKey}.${String(e1)}`;
    }
    hasValue(e1) {
        return void 0 !== this._values[e1].value;
    }
    hasProperty(e1) {
        return e1 in this._properties.defaultPropertyValues;
    }
    getValue(e1) {
        return $785da19a645c07eb$var$xh(this._values[e1].value);
    }
    setValue(e1, t) {
        this._values[e1] = new $785da19a645c07eb$var$Jf(this._values[e1].property, null === t ? void 0 : $785da19a645c07eb$var$xh(t), this._propertyRootKey(e1), this._globalState);
    }
    serialize() {
        let e1 = {};
        for (let t of Object.keys(this._values)){
            let i = this.getValue(t);
            void 0 !== i && (e1[t] = i);
        }
        return e1;
    }
    possiblyEvaluate(e1, t, i) {
        let n = new $785da19a645c07eb$var$rA(this._properties);
        for (let a of Object.keys(this._values))n._values[a] = this._values[a].possiblyEvaluate(e1, t, i);
        return n;
    }
}, $785da19a645c07eb$var$aA = class {
    constructor(e1, t, i){
        this.property = e1, this.value = t, this.parameters = i;
    }
    isConstant() {
        return "constant" === this.value.kind;
    }
    constantOr(e1) {
        return "constant" === this.value.kind ? this.value.value : e1;
    }
    evaluate(e1, t, i, n) {
        return this.property.evaluate(this.value, this.parameters, e1, t, i, n);
    }
}, $785da19a645c07eb$var$rA = class {
    constructor(e1){
        this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
    }
    get(e1) {
        return this._values[e1];
    }
};
function $785da19a645c07eb$var$sA(e1) {
    if (Array.isArray(e1)) return e1.length;
    let t = e1?.values;
    return Array.isArray(t) ? t.length : void 0;
}
function $785da19a645c07eb$var$oA(e1, t) {
    let i = $785da19a645c07eb$var$sA(e1), n = $785da19a645c07eb$var$sA(t);
    return void 0 !== i && void 0 !== n && i !== n;
}
var $785da19a645c07eb$var$lA = class {
    constructor(e1, t){
        this.specification = e1, this.name = t;
    }
    possiblyEvaluate(e1, t) {
        if (e1.isDataDriven()) throw Error("Value should not be data driven");
        return e1.expression.evaluate(t);
    }
    interpolate(e1, t, i) {
        if ($785da19a645c07eb$var$oA(e1, t)) return $785da19a645c07eb$var$wh(`Property "${this.name}" is trying to interpolate arrays of different lengths. Rendering may 'jump'.`), t;
        let n = this.specification.type, a = $785da19a645c07eb$var$Mp[n];
        return a ? a(e1, t, i) : e1;
    }
}, $785da19a645c07eb$var$cA = class {
    constructor(e1, t, i){
        this.specification = e1, this.name = t, this.overrides = i;
    }
    possiblyEvaluate(e1, t, i, n) {
        return "constant" === e1.expression.kind || "camera" === e1.expression.kind ? new $785da19a645c07eb$var$aA(this, {
            kind: "constant",
            value: e1.expression.evaluate(t, null, {}, i, n)
        }, t) : new $785da19a645c07eb$var$aA(this, e1.expression, t);
    }
    interpolate(e1, t, i) {
        if ("constant" !== e1.value.kind || "constant" !== t.value.kind) return e1;
        if (void 0 === e1.value.value || void 0 === t.value.value) return new $785da19a645c07eb$var$aA(this, {
            kind: "constant",
            value: void 0
        }, e1.parameters);
        if ($785da19a645c07eb$var$oA(e1.value.value, t.value.value)) return $785da19a645c07eb$var$wh(`Property "${this.name}" is trying to interpolate arrays of different lengths. Rendering may 'jump'.`), t;
        let n = this.specification.type, a = $785da19a645c07eb$var$Mp[n];
        if (a) {
            let n = a(e1.value.value, t.value.value, i);
            return new $785da19a645c07eb$var$aA(this, {
                kind: "constant",
                value: n
            }, e1.parameters);
        }
        return e1;
    }
    evaluate(e1, t, i, n, a, r) {
        return "constant" === e1.kind ? e1.value : e1.evaluate(t, i, n, a, r);
    }
}, $785da19a645c07eb$var$uA = class extends $785da19a645c07eb$var$cA {
    possiblyEvaluate(e1, t, i, n) {
        if (void 0 === e1.value) return new $785da19a645c07eb$var$aA(this, {
            kind: "constant",
            value: void 0
        }, t);
        if ("constant" === e1.expression.kind) {
            let a = e1.expression.evaluate(t, null, {}, i, n), r = "resolvedImage" === e1.property.specification.type && "string" != typeof a ? a.name : a, s = this._calculate(r, r, r, t);
            return new $785da19a645c07eb$var$aA(this, {
                kind: "constant",
                value: s
            }, t);
        }
        if ("camera" === e1.expression.kind) {
            let i = this._calculate(e1.expression.evaluate({
                zoom: t.zoom - 1
            }), e1.expression.evaluate({
                zoom: t.zoom
            }), e1.expression.evaluate({
                zoom: t.zoom + 1
            }), t);
            return new $785da19a645c07eb$var$aA(this, {
                kind: "constant",
                value: i
            }, t);
        }
        return new $785da19a645c07eb$var$aA(this, e1.expression, t);
    }
    evaluate(e1, t, i, n, a, r) {
        if ("source" === e1.kind) {
            let s = e1.evaluate(t, i, n, a, r);
            return this._calculate(s, s, s, t);
        }
        return "composite" === e1.kind ? this._calculate(e1.evaluate({
            zoom: Math.floor(t.zoom) - 1
        }, i, n), e1.evaluate({
            zoom: Math.floor(t.zoom)
        }, i, n), e1.evaluate({
            zoom: Math.floor(t.zoom) + 1
        }, i, n), t) : e1.value;
    }
    _calculate(e1, t, i, n) {
        return n.zoom > n.zoomHistory.lastIntegerZoom ? {
            from: e1,
            to: t
        } : {
            from: i,
            to: t
        };
    }
    interpolate(e1) {
        return e1;
    }
}, $785da19a645c07eb$var$hA = class {
    constructor(e1, t){
        this.specification = e1, this.name = t;
    }
    possiblyEvaluate(e1, t, i, n) {
        if (void 0 !== e1.value) {
            if ("constant" === e1.expression.kind) {
                let a = e1.expression.evaluate(t, null, {}, i, n);
                return this._calculate(a, a, a, t);
            }
            return this._calculate(e1.expression.evaluate(new $785da19a645c07eb$var$Qf(Math.floor(t.zoom - 1), t)), e1.expression.evaluate(new $785da19a645c07eb$var$Qf(Math.floor(t.zoom), t)), e1.expression.evaluate(new $785da19a645c07eb$var$Qf(Math.floor(t.zoom + 1), t)), t);
        }
    }
    _calculate(e1, t, i, n) {
        return n.zoom > n.zoomHistory.lastIntegerZoom ? {
            from: e1,
            to: t
        } : {
            from: i,
            to: t
        };
    }
    interpolate(e1) {
        return e1;
    }
}, $785da19a645c07eb$var$dA = class {
    constructor(e1, t){
        this.specification = e1, this.name = t;
    }
    possiblyEvaluate(e1, t, i, n) {
        return !!e1.expression.evaluate(t, null, {}, i, n);
    }
    interpolate() {
        return !1;
    }
}, $785da19a645c07eb$var$pA = class {
    constructor(e1){
        this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
        for(let t in e1){
            let i = e1[t];
            i.specification.overridable && this.overridableProperties.push(t);
            let n = this.defaultPropertyValues[t] = new $785da19a645c07eb$var$Jf(i, void 0, i.name, void 0), a = this.defaultTransitionablePropertyValues[t] = new $785da19a645c07eb$var$$f(i, i.name, void 0);
            this.defaultTransitioningPropertyValues[t] = a.untransitioned(), this.defaultPossiblyEvaluatedValues[t] = n.possiblyEvaluate({});
        }
    }
};
$785da19a645c07eb$var$qf("DataDrivenProperty", $785da19a645c07eb$var$cA), $785da19a645c07eb$var$qf("DataConstantProperty", $785da19a645c07eb$var$lA), $785da19a645c07eb$var$qf("CrossFadedDataDrivenProperty", $785da19a645c07eb$var$uA), $785da19a645c07eb$var$qf("CrossFadedProperty", $785da19a645c07eb$var$hA), $785da19a645c07eb$var$qf("ColorRampProperty", $785da19a645c07eb$var$dA);
const $785da19a645c07eb$var$mA = " is a PAINT property not a LAYOUT property. Use get/setPaintProperty instead?", $785da19a645c07eb$var$gA = " is a LAYOUT property not a PAINT property. Use get/setLayoutProperty instead?";
var $785da19a645c07eb$var$fA = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t, i){
        if (super(), this.id = e1.id, this.type = e1.type, this._globalState = i, this._featureFilter = {
            filter: ()=>!0,
            needGeometry: !1,
            getGlobalStateRefs: ()=>new Set
        }, this._visibilityExpression = function(e1, t, i) {
            return new $785da19a645c07eb$var$Rf(e1, t, i);
        }(this.visibility, `layers[${this.id}].layout.visibility`, i), "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter, this._featureFilter = $785da19a645c07eb$var$jg(e1.filter, `layers[${this.id}].filter`, i)), t.layout && (this._unevaluatedLayout = new $785da19a645c07eb$var$nA(t.layout, `layers[${this.id}].layout`, i)), t.paint)) {
            this._transitionablePaint = new $785da19a645c07eb$var$eA(t.paint, `layers[${this.id}].paint`, i);
            for(let t in e1.paint)this.setPaintProperty(t, e1.paint[t], {
                validate: !1
            });
            for(let t in e1.layout)this.setLayoutProperty(t, e1.layout[t], {
                validate: !1
            });
            this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new $785da19a645c07eb$var$rA(t.paint);
        }
    }
    setFilter(e1) {
        this.filter = e1, this._featureFilter = $785da19a645c07eb$var$jg(e1, `layers[${this.id}].filter`, this._globalState);
    }
    getCrossfadeParameters() {
        return this._crossfadeParameters;
    }
    getLayoutProperty(e1) {
        if ("visibility" === e1) return this.visibility;
        if (this._transitionablePaint?.hasProperty(e1)) throw Error(e1 + $785da19a645c07eb$var$mA);
        if (!this._unevaluatedLayout) throw Error(`Cannot get layout property "${e1}" on layer type "${this.type}" which has no layout properties.`);
        return this._unevaluatedLayout.getValue(e1);
    }
    getLayoutAffectingGlobalStateRefs() {
        let e1 = new Set;
        for (let t of this._visibilityExpression.getGlobalStateRefs())e1.add(t);
        if (this._unevaluatedLayout) for(let t in this._unevaluatedLayout._values){
            let i = this._unevaluatedLayout._values[t];
            for (let t of i.getGlobalStateRefs())e1.add(t);
        }
        for (let t of this._featureFilter.getGlobalStateRefs())e1.add(t);
        return e1;
    }
    getPaintAffectingGlobalStateRefs() {
        let e1 = new globalThis.Map;
        if (this._transitionablePaint) for(let t in this._transitionablePaint._values){
            let i = this._transitionablePaint._values[t].value;
            for (let n of i.getGlobalStateRefs()){
                let a = e1.get(n) ?? [];
                a.push({
                    name: t,
                    value: i.value
                }), e1.set(n, a);
            }
        }
        return e1;
    }
    getVisibilityAffectingGlobalStateRefs() {
        return this._visibilityExpression.getGlobalStateRefs();
    }
    setLayoutProperty(e1, t, i = {}) {
        if ("visibility" === e1) return this.visibility = t, this._visibilityExpression.setValue(t), void this.recalculateVisibility();
        this._transitionablePaint?.hasProperty(e1) ? this.fire(new $785da19a645c07eb$var$ad(Error(e1 + $785da19a645c07eb$var$mA))) : null != t && this._validate($785da19a645c07eb$var$Lf.layoutProperty, `layers.${this.id}.layout.${e1}`, e1, t, i) || this._unevaluatedLayout.setValue(e1, t);
    }
    getPaintProperty(e1) {
        if (e1.endsWith("-transition")) {
            let t = e1.slice(0, -11);
            if ("visibility" === t || this._unevaluatedLayout?.hasProperty(t)) throw Error(e1 + $785da19a645c07eb$var$gA);
            return this._transitionablePaint.getTransition(t);
        }
        if ("visibility" === e1 || this._unevaluatedLayout?.hasProperty(e1)) throw Error(e1 + $785da19a645c07eb$var$gA);
        return this._transitionablePaint.getValue(e1);
    }
    setPaintProperty(e1, t, i = {}) {
        if ("visibility" === e1 || this._unevaluatedLayout?.hasProperty(e1)) return this.fire(new $785da19a645c07eb$var$ad(Error(e1 + $785da19a645c07eb$var$gA))), !1;
        if (null != t && this._validate($785da19a645c07eb$var$Lf.paintProperty, `layers.${this.id}.paint.${e1}`, e1, t, i)) return !1;
        if (e1.endsWith("-transition")) return this._transitionablePaint.setTransition(e1.slice(0, -11), t || void 0), !1;
        {
            let i = this._transitionablePaint._values[e1], n = "cross-faded-data-driven" === i.property.specification["property-type"], a = i.value.isDataDriven(), r = i.value;
            this._transitionablePaint.setValue(e1, t), this._handleSpecialPaintPropertyUpdate(e1);
            let s = this._transitionablePaint._values[e1].value;
            return s.isDataDriven() || a || n || this._handleOverridablePaintPropertyUpdate(e1, r, s);
        }
    }
    _handleSpecialPaintPropertyUpdate(e1) {}
    _handleOverridablePaintPropertyUpdate(e1, t, i) {
        return !1;
    }
    isHidden(e1 = this.minzoom, t = !1) {
        return !!(this.minzoom && e1 < (t ? Math.floor(this.minzoom) : this.minzoom) || this.maxzoom && e1 >= this.maxzoom) || "none" === this._evaluatedVisibility;
    }
    updateTransitions(e1) {
        this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
    }
    hasTransition() {
        return this._transitioningPaint.hasTransition();
    }
    recalculateVisibility() {
        this._evaluatedVisibility = this._visibilityExpression.evaluate();
    }
    recalculate(e1, t) {
        e1.getCrossfadeParameters && (this._crossfadeParameters = e1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t);
    }
    serialize() {
        let e1 = {
            id: this.id,
            type: this.type,
            source: this.source,
            "source-layer": this.sourceLayer,
            metadata: this.metadata,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            filter: this.filter,
            layout: this._unevaluatedLayout?.serialize(),
            paint: this._transitionablePaint?.serialize()
        };
        return this.visibility && (e1.layout ||= {}, e1.layout.visibility = this.visibility), $785da19a645c07eb$var$vh(e1, (e1, t)=>!(void 0 === e1 || "layout" === t && !Object.keys(e1).length || "paint" === t && !Object.keys(e1).length));
    }
    _validate(e1, t, i, n, a = {}) {
        return $785da19a645c07eb$var$Nf(this, e1, {
            key: t,
            layerType: this.type,
            objectKey: i,
            value: n
        }, a);
    }
    is3D() {
        return !1;
    }
    isTileClipped() {
        return !1;
    }
    hasOffscreenPass() {
        return !1;
    }
    resize() {}
    isStateDependent() {
        for(let e1 in this.paint._values){
            let t = this.paint.get(e1);
            if (t instanceof $785da19a645c07eb$var$aA && $785da19a645c07eb$var$rg(t.property.specification) && ("source" === t.value.kind || "composite" === t.value.kind) && t.value.isStateDependent) return !0;
        }
        return !1;
    }
};
let $785da19a645c07eb$var$AA;
var $785da19a645c07eb$var$_A = {
    get paint () {
        return $785da19a645c07eb$var$AA ||= new $785da19a645c07eb$var$pA({
            "raster-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-opacity"], "raster-opacity"),
            "raster-hue-rotate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-hue-rotate"], "raster-hue-rotate"),
            "raster-brightness-min": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-brightness-min"], "raster-brightness-min"),
            "raster-brightness-max": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-brightness-max"], "raster-brightness-max"),
            "raster-saturation": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-saturation"], "raster-saturation"),
            "raster-contrast": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-contrast"], "raster-contrast"),
            resampling: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster.resampling, "resampling"),
            "raster-resampling": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-resampling"], "raster-resampling"),
            "raster-fade-duration": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_raster["raster-fade-duration"], "raster-fade-duration")
        });
    }
};
const $785da19a645c07eb$var$vA = (e1)=>"raster" === e1.type;
var $785da19a645c07eb$var$yA = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$_A, t);
    }
};
const $785da19a645c07eb$var$xA = {
    Int8: Int8Array,
    Uint8: Uint8Array,
    Int16: Int16Array,
    Uint16: Uint16Array,
    Int32: Int32Array,
    Uint32: Uint32Array,
    Float32: Float32Array
};
var $785da19a645c07eb$var$bA = class {
    constructor(e1, t){
        this._structArray = e1, this._pos1 = t * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
    }
}, $785da19a645c07eb$var$wA = class {
    constructor(){
        this.isTransferred = !1, this.capacity = -1, this.resize(0);
    }
    static serialize(e1, t) {
        return e1._trim(), t && (e1.isTransferred = !0, t.push(e1.arrayBuffer)), {
            length: e1.length,
            arrayBuffer: e1.arrayBuffer
        };
    }
    static deserialize(e1) {
        let t = Object.create(this.prototype);
        return t.arrayBuffer = e1.arrayBuffer, t.length = e1.length, t.capacity = e1.arrayBuffer.byteLength / t.bytesPerElement, t._refreshViews(), t;
    }
    _trim() {
        this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
    }
    clear() {
        this.length = 0;
    }
    resize(e1) {
        this.reserve(e1), this.length = e1;
    }
    reserve(e1) {
        if (e1 > this.capacity) {
            this.capacity = Math.max(e1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
            let t = this.uint8;
            this._refreshViews(), t && this.uint8.set(t);
        }
    }
    _refreshViews() {
        throw Error("_refreshViews() must be implemented by each concrete StructArray layout");
    }
    freeBufferAfterUpload() {
        this.arrayBuffer = new ArrayBuffer(0), this._refreshViews();
    }
};
function $785da19a645c07eb$var$EA(e1, t = 1) {
    let i = 0, n = 0;
    return {
        members: e1.map((e1)=>{
            let a = function(e1) {
                return $785da19a645c07eb$var$xA[e1].BYTES_PER_ELEMENT;
            }(e1.type), r = i = $785da19a645c07eb$var$kA(i, Math.max(t, a)), s = e1.components || 1;
            return n = Math.max(n, a), i += a * s, {
                name: e1.name,
                type: e1.type,
                components: s,
                offset: r
            };
        }),
        size: $785da19a645c07eb$var$kA(i, Math.max(n, t)),
        alignment: t
    };
}
function $785da19a645c07eb$var$kA(e1, t) {
    return Math.ceil(e1 / t) * t;
}
var $785da19a645c07eb$var$SA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t) {
        let i = this.length;
        return this.resize(i + 1), this.emplace(i, e1, t);
    }
    emplace(e1, t, i) {
        let n = 2 * e1;
        return this.int16[n + 0] = t, this.int16[n + 1] = i, e1;
    }
};
$785da19a645c07eb$var$SA.prototype.bytesPerElement = 4, $785da19a645c07eb$var$qf("StructArrayLayout2i4", $785da19a645c07eb$var$SA);
var $785da19a645c07eb$var$MA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e1, t, i);
    }
    emplace(e1, t, i, n) {
        let a = 3 * e1;
        return this.int16[a + 0] = t, this.int16[a + 1] = i, this.int16[a + 2] = n, e1;
    }
};
$785da19a645c07eb$var$MA.prototype.bytesPerElement = 6, $785da19a645c07eb$var$qf("StructArrayLayout3i6", $785da19a645c07eb$var$MA);
var $785da19a645c07eb$var$CA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n) {
        let a = this.length;
        return this.resize(a + 1), this.emplace(a, e1, t, i, n);
    }
    emplace(e1, t, i, n, a) {
        let r = 4 * e1;
        return this.int16[r + 0] = t, this.int16[r + 1] = i, this.int16[r + 2] = n, this.int16[r + 3] = a, e1;
    }
};
$785da19a645c07eb$var$CA.prototype.bytesPerElement = 8, $785da19a645c07eb$var$qf("StructArrayLayout4i8", $785da19a645c07eb$var$CA);
var $785da19a645c07eb$var$TA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r) {
        let s = this.length;
        return this.resize(s + 1), this.emplace(s, e1, t, i, n, a, r);
    }
    emplace(e1, t, i, n, a, r, s) {
        let o = 6 * e1;
        return this.int16[o + 0] = t, this.int16[o + 1] = i, this.int16[o + 2] = n, this.int16[o + 3] = a, this.int16[o + 4] = r, this.int16[o + 5] = s, e1;
    }
};
$785da19a645c07eb$var$TA.prototype.bytesPerElement = 12, $785da19a645c07eb$var$qf("StructArrayLayout2i4i12", $785da19a645c07eb$var$TA);
var $785da19a645c07eb$var$DA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r) {
        let s = this.length;
        return this.resize(s + 1), this.emplace(s, e1, t, i, n, a, r);
    }
    emplace(e1, t, i, n, a, r, s) {
        let o = 4 * e1, l = 8 * e1;
        return this.int16[o + 0] = t, this.int16[o + 1] = i, this.uint8[l + 4] = n, this.uint8[l + 5] = a, this.uint8[l + 6] = r, this.uint8[l + 7] = s, e1;
    }
};
$785da19a645c07eb$var$DA.prototype.bytesPerElement = 8, $785da19a645c07eb$var$qf("StructArrayLayout2i4ub8", $785da19a645c07eb$var$DA);
var $785da19a645c07eb$var$PA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t) {
        let i = this.length;
        return this.resize(i + 1), this.emplace(i, e1, t);
    }
    emplace(e1, t, i) {
        let n = 2 * e1;
        return this.float32[n + 0] = t, this.float32[n + 1] = i, e1;
    }
};
$785da19a645c07eb$var$PA.prototype.bytesPerElement = 8, $785da19a645c07eb$var$qf("StructArrayLayout2f8", $785da19a645c07eb$var$PA);
var $785da19a645c07eb$var$IA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o, l, c) {
        let u = this.length;
        return this.resize(u + 1), this.emplace(u, e1, t, i, n, a, r, s, o, l, c);
    }
    emplace(e1, t, i, n, a, r, s, o, l, c, u) {
        let h = 10 * e1;
        return this.uint16[h + 0] = t, this.uint16[h + 1] = i, this.uint16[h + 2] = n, this.uint16[h + 3] = a, this.uint16[h + 4] = r, this.uint16[h + 5] = s, this.uint16[h + 6] = o, this.uint16[h + 7] = l, this.uint16[h + 8] = c, this.uint16[h + 9] = u, e1;
    }
};
$785da19a645c07eb$var$IA.prototype.bytesPerElement = 20, $785da19a645c07eb$var$qf("StructArrayLayout10ui20", $785da19a645c07eb$var$IA);
var $785da19a645c07eb$var$FA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o) {
        let l = this.length;
        return this.resize(l + 1), this.emplace(l, e1, t, i, n, a, r, s, o);
    }
    emplace(e1, t, i, n, a, r, s, o, l) {
        let c = 8 * e1;
        return this.uint16[c + 0] = t, this.uint16[c + 1] = i, this.uint16[c + 2] = n, this.uint16[c + 3] = a, this.uint16[c + 4] = r, this.uint16[c + 5] = s, this.uint16[c + 6] = o, this.uint16[c + 7] = l, e1;
    }
};
$785da19a645c07eb$var$FA.prototype.bytesPerElement = 16, $785da19a645c07eb$var$qf("StructArrayLayout8ui16", $785da19a645c07eb$var$FA);
var $785da19a645c07eb$var$zA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o, l, c, u, h, d) {
        let p = this.length;
        return this.resize(p + 1), this.emplace(p, e1, t, i, n, a, r, s, o, l, c, u, h, d);
    }
    emplace(e1, t, i, n, a, r, s, o, l, c, u, h, d, p) {
        let m = 14 * e1, g = 7 * e1;
        return this.int16[m + 0] = t, this.int16[m + 1] = i, this.int16[m + 2] = n, this.int16[m + 3] = a, this.uint16[m + 4] = r, this.uint16[m + 5] = s, this.uint16[m + 6] = o, this.uint16[m + 7] = l, this.int16[m + 8] = c, this.int16[m + 9] = u, this.int16[m + 10] = h, this.int16[m + 11] = d, this.float32[g + 6] = p, e1;
    }
};
$785da19a645c07eb$var$zA.prototype.bytesPerElement = 28, $785da19a645c07eb$var$qf("StructArrayLayout4i4ui4i1f28", $785da19a645c07eb$var$zA);
var $785da19a645c07eb$var$RA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e1, t, i);
    }
    emplace(e1, t, i, n) {
        let a = 3 * e1;
        return this.float32[a + 0] = t, this.float32[a + 1] = i, this.float32[a + 2] = n, e1;
    }
};
$785da19a645c07eb$var$RA.prototype.bytesPerElement = 12, $785da19a645c07eb$var$qf("StructArrayLayout3f12", $785da19a645c07eb$var$RA);
var $785da19a645c07eb$var$LA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
    }
    emplaceBack(e1) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e1);
    }
    emplace(e1, t) {
        let i = 1 * e1;
        return this.uint32[i + 0] = t, e1;
    }
};
$785da19a645c07eb$var$LA.prototype.bytesPerElement = 4, $785da19a645c07eb$var$qf("StructArrayLayout1ul4", $785da19a645c07eb$var$LA);
var $785da19a645c07eb$var$BA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o, l) {
        let c = this.length;
        return this.resize(c + 1), this.emplace(c, e1, t, i, n, a, r, s, o, l);
    }
    emplace(e1, t, i, n, a, r, s, o, l, c) {
        let u = 10 * e1, h = 5 * e1;
        return this.int16[u + 0] = t, this.int16[u + 1] = i, this.int16[u + 2] = n, this.int16[u + 3] = a, this.int16[u + 4] = r, this.int16[u + 5] = s, this.uint32[h + 3] = o, this.uint16[u + 8] = l, this.uint16[u + 9] = c, e1;
    }
};
$785da19a645c07eb$var$BA.prototype.bytesPerElement = 20, $785da19a645c07eb$var$qf("StructArrayLayout6i1ul2ui20", $785da19a645c07eb$var$BA);
var $785da19a645c07eb$var$OA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r) {
        let s = this.length;
        return this.resize(s + 1), this.emplace(s, e1, t, i, n, a, r);
    }
    emplace(e1, t, i, n, a, r, s) {
        let o = 6 * e1;
        return this.int16[o + 0] = t, this.int16[o + 1] = i, this.int16[o + 2] = n, this.int16[o + 3] = a, this.int16[o + 4] = r, this.int16[o + 5] = s, e1;
    }
};
$785da19a645c07eb$var$OA.prototype.bytesPerElement = 12, $785da19a645c07eb$var$qf("StructArrayLayout2i2i2i12", $785da19a645c07eb$var$OA);
var $785da19a645c07eb$var$UA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a) {
        let r = this.length;
        return this.resize(r + 1), this.emplace(r, e1, t, i, n, a);
    }
    emplace(e1, t, i, n, a, r) {
        let s = 4 * e1, o = 8 * e1;
        return this.float32[s + 0] = t, this.float32[s + 1] = i, this.float32[s + 2] = n, this.int16[o + 6] = a, this.int16[o + 7] = r, e1;
    }
};
$785da19a645c07eb$var$UA.prototype.bytesPerElement = 16, $785da19a645c07eb$var$qf("StructArrayLayout2f1f2i16", $785da19a645c07eb$var$UA);
var $785da19a645c07eb$var$NA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r) {
        let s = this.length;
        return this.resize(s + 1), this.emplace(s, e1, t, i, n, a, r);
    }
    emplace(e1, t, i, n, a, r, s) {
        let o = 16 * e1, l = 4 * e1, c = 8 * e1;
        return this.uint8[o + 0] = t, this.uint8[o + 1] = i, this.float32[l + 1] = n, this.float32[l + 2] = a, this.int16[c + 6] = r, this.int16[c + 7] = s, e1;
    }
};
$785da19a645c07eb$var$NA.prototype.bytesPerElement = 16, $785da19a645c07eb$var$qf("StructArrayLayout2ub2f2i16", $785da19a645c07eb$var$NA);
var $785da19a645c07eb$var$jA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e1, t, i);
    }
    emplace(e1, t, i, n) {
        let a = 3 * e1;
        return this.uint16[a + 0] = t, this.uint16[a + 1] = i, this.uint16[a + 2] = n, e1;
    }
};
$785da19a645c07eb$var$jA.prototype.bytesPerElement = 6, $785da19a645c07eb$var$qf("StructArrayLayout3ui6", $785da19a645c07eb$var$jA);
var $785da19a645c07eb$var$VA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A) {
        let _ = this.length;
        return this.resize(_ + 1), this.emplace(_, e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A);
    }
    emplace(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _) {
        let v = 26 * e1, y = 13 * e1, x = 52 * e1;
        return this.int16[v + 0] = t, this.int16[v + 1] = i, this.uint16[v + 2] = n, this.uint16[v + 3] = a, this.uint32[y + 2] = r, this.uint32[y + 3] = s, this.uint32[y + 4] = o, this.uint16[v + 10] = l, this.uint16[v + 11] = c, this.uint16[v + 12] = u, this.float32[y + 7] = h, this.float32[y + 8] = d, this.uint8[x + 36] = p, this.uint8[x + 37] = m, this.uint8[x + 38] = g, this.uint32[y + 10] = f, this.int16[v + 22] = A, this.float32[y + 12] = _, e1;
    }
};
$785da19a645c07eb$var$VA.prototype.bytesPerElement = 52, $785da19a645c07eb$var$qf("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i1f52", $785da19a645c07eb$var$VA);
var $785da19a645c07eb$var$qA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _, v, y, x, b, w, E, k, S, M, C) {
        let T = this.length;
        return this.resize(T + 1), this.emplace(T, e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _, v, y, x, b, w, E, k, S, M, C);
    }
    emplace(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _, v, y, x, b, w, E, k, S, M, C, T) {
        let D = 34 * e1, P = 17 * e1;
        return this.int16[D + 0] = t, this.int16[D + 1] = i, this.int16[D + 2] = n, this.int16[D + 3] = a, this.int16[D + 4] = r, this.int16[D + 5] = s, this.int16[D + 6] = o, this.int16[D + 7] = l, this.uint16[D + 8] = c, this.uint16[D + 9] = u, this.uint16[D + 10] = h, this.uint16[D + 11] = d, this.uint16[D + 12] = p, this.uint16[D + 13] = m, this.uint16[D + 14] = g, this.uint16[D + 15] = f, this.uint16[D + 16] = A, this.uint16[D + 17] = _, this.uint16[D + 18] = v, this.uint16[D + 19] = y, this.uint16[D + 20] = x, this.uint16[D + 21] = b, this.uint16[D + 22] = w, this.uint32[P + 12] = E, this.float32[P + 13] = k, this.float32[P + 14] = S, this.uint16[D + 30] = M, this.uint16[D + 31] = C, this.float32[P + 16] = T, e1;
    }
};
$785da19a645c07eb$var$qA.prototype.bytesPerElement = 68, $785da19a645c07eb$var$qf("StructArrayLayout8i15ui1ul2f2ui1f68", $785da19a645c07eb$var$qA);
var $785da19a645c07eb$var$GA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e1);
    }
    emplace(e1, t) {
        let i = 1 * e1;
        return this.float32[i + 0] = t, e1;
    }
};
$785da19a645c07eb$var$GA.prototype.bytesPerElement = 4, $785da19a645c07eb$var$qf("StructArrayLayout1f4", $785da19a645c07eb$var$GA);
var $785da19a645c07eb$var$HA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e1, t, i);
    }
    emplace(e1, t, i, n) {
        let a = 6 * e1, r = 3 * e1;
        return this.uint16[a + 0] = t, this.float32[r + 1] = i, this.float32[r + 2] = n, e1;
    }
};
$785da19a645c07eb$var$HA.prototype.bytesPerElement = 12, $785da19a645c07eb$var$qf("StructArrayLayout1ui2f12", $785da19a645c07eb$var$HA);
var $785da19a645c07eb$var$WA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i) {
        let n = this.length;
        return this.resize(n + 1), this.emplace(n, e1, t, i);
    }
    emplace(e1, t, i, n) {
        let a = 2 * e1, r = 4 * e1;
        return this.uint32[a + 0] = t, this.uint16[r + 2] = i, this.uint16[r + 3] = n, e1;
    }
};
$785da19a645c07eb$var$WA.prototype.bytesPerElement = 8, $785da19a645c07eb$var$qf("StructArrayLayout1ul2ui8", $785da19a645c07eb$var$WA);
var $785da19a645c07eb$var$ZA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1, t) {
        let i = this.length;
        return this.resize(i + 1), this.emplace(i, e1, t);
    }
    emplace(e1, t, i) {
        let n = 2 * e1;
        return this.uint16[n + 0] = t, this.uint16[n + 1] = i, e1;
    }
};
$785da19a645c07eb$var$ZA.prototype.bytesPerElement = 4, $785da19a645c07eb$var$qf("StructArrayLayout2ui4", $785da19a645c07eb$var$ZA);
var $785da19a645c07eb$var$KA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
    }
    emplaceBack(e1) {
        let t = this.length;
        return this.resize(t + 1), this.emplace(t, e1);
    }
    emplace(e1, t) {
        let i = 1 * e1;
        return this.uint16[i + 0] = t, e1;
    }
};
$785da19a645c07eb$var$KA.prototype.bytesPerElement = 2, $785da19a645c07eb$var$qf("StructArrayLayout1ui2", $785da19a645c07eb$var$KA);
var $785da19a645c07eb$var$XA = class extends $785da19a645c07eb$var$wA {
    _refreshViews() {
        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
    }
    emplaceBack(e1, t, i, n) {
        let a = this.length;
        return this.resize(a + 1), this.emplace(a, e1, t, i, n);
    }
    emplace(e1, t, i, n, a) {
        let r = 4 * e1;
        return this.float32[r + 0] = t, this.float32[r + 1] = i, this.float32[r + 2] = n, this.float32[r + 3] = a, e1;
    }
};
$785da19a645c07eb$var$XA.prototype.bytesPerElement = 16, $785da19a645c07eb$var$qf("StructArrayLayout4f16", $785da19a645c07eb$var$XA);
var $785da19a645c07eb$var$QA = class extends $785da19a645c07eb$var$bA {
    get anchorPointX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorPointY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get x1() {
        return this._structArray.int16[this._pos2 + 2];
    }
    get y1() {
        return this._structArray.int16[this._pos2 + 3];
    }
    get x2() {
        return this._structArray.int16[this._pos2 + 4];
    }
    get y2() {
        return this._structArray.int16[this._pos2 + 5];
    }
    get featureIndex() {
        return this._structArray.uint32[this._pos4 + 3];
    }
    get sourceLayerIndex() {
        return this._structArray.uint16[this._pos2 + 8];
    }
    get bucketIndex() {
        return this._structArray.uint16[this._pos2 + 9];
    }
    get anchorPoint() {
        return new $785da19a645c07eb$var$Kc(this.anchorPointX, this.anchorPointY);
    }
};
$785da19a645c07eb$var$QA.prototype.size = 20;
var $785da19a645c07eb$var$YA = class extends $785da19a645c07eb$var$BA {
    get(e1) {
        return new $785da19a645c07eb$var$QA(this, e1);
    }
};
$785da19a645c07eb$var$qf("CollisionBoxArray", $785da19a645c07eb$var$YA);
var $785da19a645c07eb$var$JA = class extends $785da19a645c07eb$var$bA {
    get anchorX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get glyphStartIndex() {
        return this._structArray.uint16[this._pos2 + 2];
    }
    get numGlyphs() {
        return this._structArray.uint16[this._pos2 + 3];
    }
    get vertexStartIndex() {
        return this._structArray.uint32[this._pos4 + 2];
    }
    get lineStartIndex() {
        return this._structArray.uint32[this._pos4 + 3];
    }
    get lineLength() {
        return this._structArray.uint32[this._pos4 + 4];
    }
    get segment() {
        return this._structArray.uint16[this._pos2 + 10];
    }
    get lowerSize() {
        return this._structArray.uint16[this._pos2 + 11];
    }
    get upperSize() {
        return this._structArray.uint16[this._pos2 + 12];
    }
    get lineOffsetX() {
        return this._structArray.float32[this._pos4 + 7];
    }
    get lineOffsetY() {
        return this._structArray.float32[this._pos4 + 8];
    }
    get writingMode() {
        return this._structArray.uint8[this._pos1 + 36];
    }
    get placedOrientation() {
        return this._structArray.uint8[this._pos1 + 37];
    }
    set placedOrientation(e1) {
        this._structArray.uint8[this._pos1 + 37] = e1;
    }
    get hidden() {
        return this._structArray.uint8[this._pos1 + 38];
    }
    set hidden(e1) {
        this._structArray.uint8[this._pos1 + 38] = e1;
    }
    get crossTileID() {
        return this._structArray.uint32[this._pos4 + 10];
    }
    set crossTileID(e1) {
        this._structArray.uint32[this._pos4 + 10] = e1;
    }
    get associatedIconIndex() {
        return this._structArray.int16[this._pos2 + 22];
    }
    get heightOffset() {
        return this._structArray.float32[this._pos4 + 12];
    }
};
$785da19a645c07eb$var$JA.prototype.size = 52;
var $785da19a645c07eb$var$$A = class extends $785da19a645c07eb$var$VA {
    get(e1) {
        return new $785da19a645c07eb$var$JA(this, e1);
    }
};
$785da19a645c07eb$var$qf("PlacedSymbolArray", $785da19a645c07eb$var$$A);
var $785da19a645c07eb$var$e_ = class extends $785da19a645c07eb$var$bA {
    get anchorX() {
        return this._structArray.int16[this._pos2 + 0];
    }
    get anchorY() {
        return this._structArray.int16[this._pos2 + 1];
    }
    get rightJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 2];
    }
    get centerJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 3];
    }
    get leftJustifiedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 4];
    }
    get verticalPlacedTextSymbolIndex() {
        return this._structArray.int16[this._pos2 + 5];
    }
    get placedIconSymbolIndex() {
        return this._structArray.int16[this._pos2 + 6];
    }
    get verticalPlacedIconSymbolIndex() {
        return this._structArray.int16[this._pos2 + 7];
    }
    get key() {
        return this._structArray.uint16[this._pos2 + 8];
    }
    get textBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 9];
    }
    get textBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 10];
    }
    get verticalTextBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 11];
    }
    get verticalTextBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 12];
    }
    get iconBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 13];
    }
    get iconBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 14];
    }
    get verticalIconBoxStartIndex() {
        return this._structArray.uint16[this._pos2 + 15];
    }
    get verticalIconBoxEndIndex() {
        return this._structArray.uint16[this._pos2 + 16];
    }
    get featureIndex() {
        return this._structArray.uint16[this._pos2 + 17];
    }
    get numHorizontalGlyphVertices() {
        return this._structArray.uint16[this._pos2 + 18];
    }
    get numVerticalGlyphVertices() {
        return this._structArray.uint16[this._pos2 + 19];
    }
    get numIconVertices() {
        return this._structArray.uint16[this._pos2 + 20];
    }
    get numVerticalIconVertices() {
        return this._structArray.uint16[this._pos2 + 21];
    }
    get useRuntimeCollisionCircles() {
        return this._structArray.uint16[this._pos2 + 22];
    }
    get crossTileID() {
        return this._structArray.uint32[this._pos4 + 12];
    }
    set crossTileID(e1) {
        this._structArray.uint32[this._pos4 + 12] = e1;
    }
    get textBoxScale() {
        return this._structArray.float32[this._pos4 + 13];
    }
    get collisionCircleDiameter() {
        return this._structArray.float32[this._pos4 + 14];
    }
    get textAnchorOffsetStartIndex() {
        return this._structArray.uint16[this._pos2 + 30];
    }
    get textAnchorOffsetEndIndex() {
        return this._structArray.uint16[this._pos2 + 31];
    }
    get heightOffset() {
        return this._structArray.float32[this._pos4 + 16];
    }
};
$785da19a645c07eb$var$e_.prototype.size = 68;
var $785da19a645c07eb$var$t_ = class extends $785da19a645c07eb$var$qA {
    get(e1) {
        return new $785da19a645c07eb$var$e_(this, e1);
    }
};
$785da19a645c07eb$var$qf("SymbolInstanceArray", $785da19a645c07eb$var$t_);
var $785da19a645c07eb$var$i_ = class extends $785da19a645c07eb$var$GA {
    getoffsetX(e1) {
        return this.float32[1 * e1 + 0];
    }
};
$785da19a645c07eb$var$qf("GlyphOffsetArray", $785da19a645c07eb$var$i_);
var $785da19a645c07eb$var$n_ = class extends $785da19a645c07eb$var$MA {
    getx(e1) {
        return this.int16[3 * e1 + 0];
    }
    gety(e1) {
        return this.int16[3 * e1 + 1];
    }
    gettileUnitDistanceFromAnchor(e1) {
        return this.int16[3 * e1 + 2];
    }
};
$785da19a645c07eb$var$qf("SymbolLineVertexArray", $785da19a645c07eb$var$n_);
var $785da19a645c07eb$var$a_ = class extends $785da19a645c07eb$var$bA {
    get textAnchor() {
        return this._structArray.uint16[this._pos2 + 0];
    }
    get textOffset0() {
        return this._structArray.float32[this._pos4 + 1];
    }
    get textOffset1() {
        return this._structArray.float32[this._pos4 + 2];
    }
};
$785da19a645c07eb$var$a_.prototype.size = 12;
var $785da19a645c07eb$var$r_ = class extends $785da19a645c07eb$var$HA {
    get(e1) {
        return new $785da19a645c07eb$var$a_(this, e1);
    }
};
$785da19a645c07eb$var$qf("TextAnchorOffsetArray", $785da19a645c07eb$var$r_);
var $785da19a645c07eb$var$s_ = class extends $785da19a645c07eb$var$bA {
    get featureIndex() {
        return this._structArray.uint32[this._pos4 + 0];
    }
    get sourceLayerIndex() {
        return this._structArray.uint16[this._pos2 + 2];
    }
    get bucketIndex() {
        return this._structArray.uint16[this._pos2 + 3];
    }
};
$785da19a645c07eb$var$s_.prototype.size = 8;
var $785da19a645c07eb$var$o_ = class extends $785da19a645c07eb$var$WA {
    get(e1) {
        return new $785da19a645c07eb$var$s_(this, e1);
    }
};
$785da19a645c07eb$var$qf("FeatureIndexArray", $785da19a645c07eb$var$o_);
var $785da19a645c07eb$var$l_ = class extends $785da19a645c07eb$var$SA {
}, $785da19a645c07eb$var$c_ = class extends $785da19a645c07eb$var$MA {
}, $785da19a645c07eb$var$u_ = class extends $785da19a645c07eb$var$CA {
}, $785da19a645c07eb$var$h_ = class extends $785da19a645c07eb$var$SA {
}, $785da19a645c07eb$var$d_ = class extends $785da19a645c07eb$var$SA {
}, $785da19a645c07eb$var$p_ = class extends $785da19a645c07eb$var$TA {
}, $785da19a645c07eb$var$m_ = class extends $785da19a645c07eb$var$DA {
}, $785da19a645c07eb$var$g_ = class extends $785da19a645c07eb$var$PA {
}, $785da19a645c07eb$var$f_ = class extends $785da19a645c07eb$var$IA {
}, $785da19a645c07eb$var$A_ = class extends $785da19a645c07eb$var$FA {
}, $785da19a645c07eb$var$__ = class extends $785da19a645c07eb$var$zA {
}, $785da19a645c07eb$var$v_ = class extends $785da19a645c07eb$var$RA {
}, $785da19a645c07eb$var$y_ = class extends $785da19a645c07eb$var$LA {
}, $785da19a645c07eb$var$x_ = class extends $785da19a645c07eb$var$OA {
}, $785da19a645c07eb$var$b_ = class extends $785da19a645c07eb$var$UA {
}, $785da19a645c07eb$var$w_ = class extends $785da19a645c07eb$var$NA {
}, $785da19a645c07eb$var$E_ = class extends $785da19a645c07eb$var$jA {
}, $785da19a645c07eb$var$k_ = class extends $785da19a645c07eb$var$jA {
}, $785da19a645c07eb$var$S_ = class extends $785da19a645c07eb$var$ZA {
}, $785da19a645c07eb$var$M_ = class extends $785da19a645c07eb$var$KA {
};
const $785da19a645c07eb$var$C_ = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        components: 2,
        type: "Int16"
    }
], 4).members;
var $785da19a645c07eb$var$T_ = class e1 {
    constructor(e1 = []){
        this._forceNewSegmentOnNextPrepare = !1, this.segments = e1;
    }
    prepareSegment(t, i, n, a) {
        let r = this.segments[this.segments.length - 1];
        return t > e1.MAX_VERTEX_ARRAY_LENGTH && $785da19a645c07eb$var$wh(`Max vertices per segment is ${e1.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${t}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${e1.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !r || r.vertexLength + t > e1.MAX_VERTEX_ARRAY_LENGTH || r.sortKey !== a ? this.createNewSegment(i, n, a) : r;
    }
    createNewSegment(e1, t, i) {
        let n = {
            vertexOffset: e1.length,
            primitiveOffset: t.length,
            vertexLength: 0,
            primitiveLength: 0,
            vaos: {}
        };
        return void 0 !== i && (n.sortKey = i), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(n), n;
    }
    getOrCreateLatestSegment(e1, t, i) {
        return this.prepareSegment(0, e1, t, i);
    }
    forceNewSegmentOnNextPrepare() {
        this._forceNewSegmentOnNextPrepare = !0;
    }
    get() {
        return this.segments;
    }
    destroy() {
        for (let e1 of this.segments)for(let t in e1.vaos)e1.vaos[t].destroy();
    }
    static simpleSegment(t, i, n, a) {
        return new e1([
            {
                vertexOffset: t,
                primitiveOffset: i,
                vertexLength: n,
                primitiveLength: a,
                vaos: {},
                sortKey: 0
            }
        ]);
    }
};
function $785da19a645c07eb$var$D_(e1, t) {
    return 256 * (e1 = $785da19a645c07eb$var$ch(Math.floor(e1), 0, 255)) + (t = $785da19a645c07eb$var$ch(Math.floor(t), 0, 255));
}
$785da19a645c07eb$var$T_.MAX_VERTEX_ARRAY_LENGTH = 65535, $785da19a645c07eb$var$qf("SegmentVector", $785da19a645c07eb$var$T_);
const $785da19a645c07eb$var$P_ = $785da19a645c07eb$var$EA([
    {
        name: "a_pattern_from",
        components: 4,
        type: "Uint16"
    },
    {
        name: "a_pattern_to",
        components: 4,
        type: "Uint16"
    },
    {
        name: "a_pixel_ratio_from",
        components: 1,
        type: "Uint16"
    },
    {
        name: "a_pixel_ratio_to",
        components: 1,
        type: "Uint16"
    }
]), $785da19a645c07eb$var$I_ = $785da19a645c07eb$var$EA([
    {
        name: "a_dasharray_from",
        components: 4,
        type: "Uint16"
    },
    {
        name: "a_dasharray_to",
        components: 4,
        type: "Uint16"
    }
]);
var $785da19a645c07eb$var$F_ = $785da19a645c07eb$var$Wc((e1, t)=>{
    void 0 !== t && (t.exports = function(e1, t) {
        for(var i, n, a = 3 & e1.length, r = e1.length - a, s = t, o = 3432918353, l = 461845907, c = 0; c < r;)n = 255 & e1.charCodeAt(c) | (255 & e1.charCodeAt(++c)) << 8 | (255 & e1.charCodeAt(++c)) << 16 | (255 & e1.charCodeAt(++c)) << 24, ++c, s = 27492 + (65535 & (i = 5 * (65535 & (s = (s ^= n = (65535 & (n = (n = (65535 & n) * o + (((n >>> 16) * o & 65535) << 16) & 4294967295) << 15 | n >>> 17)) * l + (((n >>> 16) * l & 65535) << 16) & 4294967295) << 13 | s >>> 19)) + ((5 * (s >>> 16) & 65535) << 16) & 4294967295)) + (((i >>> 16) + 58964 & 65535) << 16);
        switch(n = 0, a){
            case 3:
                n ^= (255 & e1.charCodeAt(c + 2)) << 16;
            case 2:
                n ^= (255 & e1.charCodeAt(c + 1)) << 8;
            case 1:
                s ^= n = (65535 & (n = (n = (65535 & (n ^= 255 & e1.charCodeAt(c))) * o + (((n >>> 16) * o & 65535) << 16) & 4294967295) << 15 | n >>> 17)) * l + (((n >>> 16) * l & 65535) << 16) & 4294967295;
        }
        return s ^= e1.length, s = 2246822507 * (65535 & (s ^= s >>> 16)) + ((2246822507 * (s >>> 16) & 65535) << 16) & 4294967295, s = 3266489909 * (65535 & (s ^= s >>> 13)) + ((3266489909 * (s >>> 16) & 65535) << 16) & 4294967295, (s ^= s >>> 16) >>> 0;
    });
}), $785da19a645c07eb$var$z_ = $785da19a645c07eb$var$Wc((e1, t)=>{
    t.exports = function(e1, t) {
        for(var i, n = e1.length, a = t ^ n, r = 0; n >= 4;)i = 1540483477 * (65535 & (i = 255 & e1.charCodeAt(r) | (255 & e1.charCodeAt(++r)) << 8 | (255 & e1.charCodeAt(++r)) << 16 | (255 & e1.charCodeAt(++r)) << 24)) + ((1540483477 * (i >>> 16) & 65535) << 16), a = 1540483477 * (65535 & a) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ (i = 1540483477 * (65535 & (i ^= i >>> 24)) + ((1540483477 * (i >>> 16) & 65535) << 16)), n -= 4, ++r;
        switch(n){
            case 3:
                a ^= (255 & e1.charCodeAt(r + 2)) << 16;
            case 2:
                a ^= (255 & e1.charCodeAt(r + 1)) << 8;
            case 1:
                a = 1540483477 * (65535 & (a ^= 255 & e1.charCodeAt(r))) + ((1540483477 * (a >>> 16) & 65535) << 16);
        }
        return a = 1540483477 * (65535 & (a ^= a >>> 13)) + ((1540483477 * (a >>> 16) & 65535) << 16), (a ^= a >>> 15) >>> 0;
    };
}), $785da19a645c07eb$var$R_ = ((e1, t, i)=>(i = null == e1 ? {} : $785da19a645c07eb$var$Nc($785da19a645c07eb$var$Gc(e1)), $785da19a645c07eb$var$Zc($785da19a645c07eb$var$jc(i, "default", {
        value: e1,
        enumerable: !0
    }), e1)))($785da19a645c07eb$var$Wc((e1, t)=>{
    var i = $785da19a645c07eb$var$F_(), n = $785da19a645c07eb$var$z_();
    t.exports = i, t.exports.murmur3 = i, t.exports.murmur2 = n;
})()), $785da19a645c07eb$var$L_ = class e1 {
    constructor(){
        this.ids = [], this.positions = [], this.indexed = !1;
    }
    add(e1, t, i, n) {
        this.ids.push($785da19a645c07eb$var$B_(e1)), this.positions.push(t, i, n);
    }
    getPositions(e1) {
        if (!this.indexed) throw Error("Trying to get index, but feature positions are not indexed");
        let t = $785da19a645c07eb$var$B_(e1), i = 0, n = this.ids.length - 1;
        for(; i < n;){
            let e1 = i + n >> 1;
            this.ids[e1] >= t ? n = e1 : i = e1 + 1;
        }
        let a = [];
        for(; this.ids[i] === t;){
            let e1 = this.positions[3 * i], t = this.positions[3 * i + 1], n = this.positions[3 * i + 2];
            a.push({
                index: e1,
                start: t,
                end: n
            }), i++;
        }
        return a;
    }
    static serialize(e1, t) {
        let i = new Float64Array(e1.ids), n = new Uint32Array(e1.positions);
        return $785da19a645c07eb$var$O_(i, n, 0, i.length - 1), t && t.push(i.buffer, n.buffer), {
            ids: i,
            positions: n
        };
    }
    static deserialize(t) {
        let i = new e1;
        return i.ids = t.ids, i.positions = t.positions, i.indexed = !0, i;
    }
};
function $785da19a645c07eb$var$B_(e1) {
    let t = +e1;
    return !isNaN(t) && t <= 2 ** 53 - 1 ? t : (0, $785da19a645c07eb$var$R_.default)(String(e1));
}
function $785da19a645c07eb$var$O_(e1, t, i, n) {
    for(; i < n;){
        let a = e1[i + n >> 1], r = i - 1, s = n + 1;
        for(;;){
            do r++;
            while (e1[r] < a);
            do s--;
            while (e1[s] > a);
            if (r >= s) break;
            $785da19a645c07eb$var$U_(e1, r, s), $785da19a645c07eb$var$U_(t, 3 * r, 3 * s), $785da19a645c07eb$var$U_(t, 3 * r + 1, 3 * s + 1), $785da19a645c07eb$var$U_(t, 3 * r + 2, 3 * s + 2);
        }
        s - i < n - s ? ($785da19a645c07eb$var$O_(e1, t, i, s), i = s + 1) : ($785da19a645c07eb$var$O_(e1, t, s + 1, n), n = s);
    }
}
function $785da19a645c07eb$var$U_(e1, t, i) {
    let n = e1[t];
    e1[t] = e1[i], e1[i] = n;
}
$785da19a645c07eb$var$qf("FeaturePositionMap", $785da19a645c07eb$var$L_);
var $785da19a645c07eb$var$N_ = class {
    constructor(e1, t){
        this.gl = e1.gl, this.location = t;
    }
}, $785da19a645c07eb$var$j_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = 0;
    }
    set(e1) {
        this.current !== e1 && (this.current = e1, this.gl.uniform1i(this.location, e1));
    }
}, $785da19a645c07eb$var$V_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = 0;
    }
    set(e1) {
        this.current !== e1 && (this.current = e1, this.gl.uniform1f(this.location, e1));
    }
}, $785da19a645c07eb$var$q_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = [
            0,
            0
        ];
    }
    set(e1) {
        (e1[0] !== this.current[0] || e1[1] !== this.current[1]) && (this.current = e1, this.gl.uniform2f(this.location, e1[0], e1[1]));
    }
}, $785da19a645c07eb$var$G_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = [
            0,
            0,
            0
        ];
    }
    set(e1) {
        (e1[0] !== this.current[0] || e1[1] !== this.current[1] || e1[2] !== this.current[2]) && (this.current = e1, this.gl.uniform3f(this.location, e1[0], e1[1], e1[2]));
    }
}, $785da19a645c07eb$var$H_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = [
            0,
            0,
            0,
            0
        ];
    }
    set(e1) {
        (e1[0] !== this.current[0] || e1[1] !== this.current[1] || e1[2] !== this.current[2] || e1[3] !== this.current[3]) && (this.current = e1, this.gl.uniform4f(this.location, e1[0], e1[1], e1[2], e1[3]));
    }
}, $785da19a645c07eb$var$W_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = $785da19a645c07eb$var$np.transparent;
    }
    set(e1) {
        (e1.r !== this.current.r || e1.g !== this.current.g || e1.b !== this.current.b || e1.a !== this.current.a) && (this.current = e1, this.gl.uniform4f(this.location, e1.r, e1.g, e1.b, e1.a));
    }
}, $785da19a645c07eb$var$Z_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = [];
    }
    set(e1) {
        if (e1 != this.current) {
            this.current = e1;
            let t = new Float32Array(4 * e1.length);
            for(let i = 0; i < e1.length; i++)t[4 * i] = e1[i].r, t[4 * i + 1] = e1[i].g, t[4 * i + 2] = e1[i].b, t[4 * i + 3] = e1[i].a;
            this.gl.uniform4fv(this.location, t);
        }
    }
}, $785da19a645c07eb$var$K_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = [];
    }
    set(e1) {
        if (e1 != this.current) {
            this.current = e1;
            let t = new Float32Array(e1);
            this.gl.uniform1fv(this.location, t);
        }
    }
};
const $785da19a645c07eb$var$X_ = new Float32Array(16);
var $785da19a645c07eb$var$Q_ = class extends $785da19a645c07eb$var$N_ {
    constructor(e1, t){
        super(e1, t), this.current = $785da19a645c07eb$var$X_;
    }
    set(e1) {
        if (e1[12] !== this.current[12] || e1[0] !== this.current[0]) return this.current = e1, void this.gl.uniformMatrix4fv(this.location, !1, e1);
        for(let t = 1; t < 16; t++)if (e1[t] !== this.current[t]) {
            this.current = e1, this.gl.uniformMatrix4fv(this.location, !1, e1);
            break;
        }
    }
};
function $785da19a645c07eb$var$Y_(e1) {
    return [
        $785da19a645c07eb$var$D_(255 * e1.r, 255 * e1.g),
        $785da19a645c07eb$var$D_(255 * e1.b, 255 * e1.a)
    ];
}
var $785da19a645c07eb$var$J_ = class {
    constructor(e1, t, i){
        this.value = e1, this.uniformNames = t.map((e1)=>`u_${e1}`), this.type = i;
    }
    setUniform(e1, t, i) {
        e1.set(i.constantOr(this.value));
    }
    getBinding(e1, t, i) {
        return "color" === this.type ? new $785da19a645c07eb$var$W_(e1, t) : new $785da19a645c07eb$var$V_(e1, t);
    }
}, $785da19a645c07eb$var$$_ = class {
    constructor(e1, t){
        this.uniformNames = t.map((e1)=>`u_${e1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
    }
    setConstantPatternPositions(e1, t) {
        this.pixelRatioFrom = t.pixelRatio, this.pixelRatioTo = e1.pixelRatio, this.patternFrom = t.tlbr, this.patternTo = e1.tlbr;
    }
    setConstantDashPositions(e1, t) {
        this.dashTo = [
            0,
            e1.y,
            e1.height,
            e1.width
        ], this.dashFrom = [
            0,
            t.y,
            t.height,
            t.width
        ];
    }
    setUniform(e1, t, i, n) {
        let a = null;
        "u_pattern_to" === n ? a = this.patternTo : "u_pattern_from" === n ? a = this.patternFrom : "u_dasharray_to" === n ? a = this.dashTo : "u_dasharray_from" === n ? a = this.dashFrom : "u_pixel_ratio_to" === n ? a = this.pixelRatioTo : "u_pixel_ratio_from" === n && (a = this.pixelRatioFrom), null !== a && e1.set(a);
    }
    getBinding(e1, t, i) {
        return i.startsWith("u_pattern") || i.startsWith("u_dasharray_") ? new $785da19a645c07eb$var$H_(e1, t) : new $785da19a645c07eb$var$V_(e1, t);
    }
}, $785da19a645c07eb$var$ev = class {
    constructor(e1, t, i, n){
        this.expression = e1, this.type = i, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                name: `a_${e1}`,
                type: "Float32",
                components: "color" === i ? 2 : 1,
                offset: 0
            })), this.paintVertexArray = new n;
    }
    populatePaintArray(e1, t, i) {
        let n = this.paintVertexArray.length, a = this.expression.evaluate(new $785da19a645c07eb$var$Qf(0, i), t, {}, i.canonical, [], i.formattedSection);
        this.paintVertexArray.resize(e1), this._setPaintValue(n, e1, a);
    }
    updatePaintArray(e1, t, i, n, a) {
        let r = this.expression.evaluate(new $785da19a645c07eb$var$Qf(0, a), i, n);
        this._setPaintValue(e1, t, r);
    }
    _setPaintValue(e1, t, i) {
        if ("color" === this.type) {
            let n = $785da19a645c07eb$var$Y_(i);
            for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, n[0], n[1]);
        } else {
            for(let n = e1; n < t; n++)this.paintVertexArray.emplace(n, i);
            this.maxValue = Math.max(this.maxValue, Math.abs(i));
        }
    }
    upload(e1) {
        this.paintVertexArray?.arrayBuffer.byteLength && (this.paintVertexBuffer?.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
    }
    destroy() {
        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
    }
}, $785da19a645c07eb$var$tv = class {
    constructor(e1, t, i, n, a, r){
        this.expression = e1, this.uniformNames = t.map((e1)=>`u_${e1}_t`), this.type = i, this.useIntegerZoom = n, this.zoom = a, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                name: `a_${e1}`,
                type: "Float32",
                components: "color" === i ? 4 : 2,
                offset: 0
            })), this.paintVertexArray = new r;
    }
    populatePaintArray(e1, t, i) {
        let n = this.expression.evaluate(new $785da19a645c07eb$var$Qf(this.zoom, i), t, {}, i.canonical, [], i.formattedSection), a = this.expression.evaluate(new $785da19a645c07eb$var$Qf(this.zoom + 1, i), t, {}, i.canonical, [], i.formattedSection), r = this.paintVertexArray.length;
        this.paintVertexArray.resize(e1), this._setPaintValue(r, e1, n, a);
    }
    updatePaintArray(e1, t, i, n, a) {
        let r = this.expression.evaluate(new $785da19a645c07eb$var$Qf(this.zoom, a), i, n), s = this.expression.evaluate(new $785da19a645c07eb$var$Qf(this.zoom + 1, a), i, n);
        this._setPaintValue(e1, t, r, s);
    }
    _setPaintValue(e1, t, i, n) {
        if ("color" === this.type) {
            let a = $785da19a645c07eb$var$Y_(i), r = $785da19a645c07eb$var$Y_(n);
            for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, a[0], a[1], r[0], r[1]);
        } else {
            for(let a = e1; a < t; a++)this.paintVertexArray.emplace(a, i, n);
            this.maxValue = Math.max(this.maxValue, Math.abs(i), Math.abs(n));
        }
    }
    upload(e1) {
        this.paintVertexArray?.arrayBuffer.byteLength && (this.paintVertexBuffer?.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
    }
    destroy() {
        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
    }
    setUniform(e1, t) {
        let i = this.useIntegerZoom ? Math.floor(t.zoom) : t.zoom, n = $785da19a645c07eb$var$ch(this.expression.interpolationFactor(i, this.zoom, this.zoom + 1), 0, 1);
        e1.set(n);
    }
    getBinding(e1, t, i) {
        return new $785da19a645c07eb$var$V_(e1, t);
    }
}, $785da19a645c07eb$var$iv = class {
    constructor(e1, t, i, n, a, r){
        this.expression = e1, this.type = t, this.useIntegerZoom = i, this.zoom = n, this.layerId = r, this.zoomInPaintVertexArray = new a, this.zoomOutPaintVertexArray = new a;
    }
    populatePaintArray(e1, t, i) {
        let n = this.zoomInPaintVertexArray.length;
        this.zoomInPaintVertexArray.resize(e1), this.zoomOutPaintVertexArray.resize(e1), this._setPaintValues(n, e1, this.getPositionIds(t), i);
    }
    updatePaintArray(e1, t, i, n, a) {
        this._setPaintValues(e1, t, this.getPositionIds(i), a);
    }
    _setPaintValues(e1, t, i, n) {
        let a = this.getPositions(n);
        if (!a || !i) return;
        let r = a[i.min], s = a[i.mid], o = a[i.max];
        if (r && s && o) for(let i = e1; i < t; i++)this.emplace(this.zoomInPaintVertexArray, i, r, s), this.emplace(this.zoomOutPaintVertexArray, i, o, s);
    }
    upload(e1) {
        if (this.zoomInPaintVertexArray?.arrayBuffer.byteLength && this.zoomOutPaintVertexArray?.arrayBuffer.byteLength) {
            let t = this.getVertexAttributes();
            this.zoomInPaintVertexBuffer = e1.createVertexBuffer(this.zoomInPaintVertexArray, t, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = e1.createVertexBuffer(this.zoomOutPaintVertexArray, t, this.expression.isStateDependent);
        }
    }
    destroy() {
        this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
    }
}, $785da19a645c07eb$var$nv = class extends $785da19a645c07eb$var$iv {
    getPositions(e1) {
        return e1.imagePositions;
    }
    getPositionIds(e1) {
        return e1.patterns?.[this.layerId];
    }
    getVertexAttributes() {
        return $785da19a645c07eb$var$P_.members;
    }
    emplace(e1, t, i, n) {
        e1.emplace(t, i.tlbr[0], i.tlbr[1], i.tlbr[2], i.tlbr[3], n.tlbr[0], n.tlbr[1], n.tlbr[2], n.tlbr[3], i.pixelRatio, n.pixelRatio);
    }
}, $785da19a645c07eb$var$av = class extends $785da19a645c07eb$var$iv {
    getPositions(e1) {
        return e1.dashPositions;
    }
    getPositionIds(e1) {
        return e1.dashes?.[this.layerId];
    }
    getVertexAttributes() {
        return $785da19a645c07eb$var$I_.members;
    }
    emplace(e1, t, i, n) {
        e1.emplace(t, 0, i.y, i.height, i.width, 0, n.y, n.height, n.width);
    }
}, $785da19a645c07eb$var$rv = class {
    constructor(e1, t, i){
        this.binders = {}, this._buffers = [];
        let n = [];
        for(let a in e1.paint._values){
            if (!i(a)) continue;
            let r = e1.paint.get(a);
            if (!(r instanceof $785da19a645c07eb$var$aA && $785da19a645c07eb$var$rg(r.property.specification))) continue;
            let s = $785da19a645c07eb$var$ov(a, e1.type), o = r.value, l = r.property.specification.type, c = r.property.useIntegerZoom, u = r.property.specification["property-type"], h = "cross-faded" === u || "cross-faded-data-driven" === u;
            if ("constant" === o.kind) this.binders[a] = h ? new $785da19a645c07eb$var$$_(o.value, s) : new $785da19a645c07eb$var$J_(o.value, s, l), n.push(`/u_${a}`);
            else if ("source" === o.kind || h) {
                let i = $785da19a645c07eb$var$lv(a, l, "source");
                this.binders[a] = h ? "line-dasharray" === a ? new $785da19a645c07eb$var$av(o, l, c, t, i, e1.id) : new $785da19a645c07eb$var$nv(o, l, c, t, i, e1.id) : new $785da19a645c07eb$var$ev(o, s, l, i), n.push(`/a_${a}`);
            } else {
                let e1 = $785da19a645c07eb$var$lv(a, l, "composite");
                this.binders[a] = new $785da19a645c07eb$var$tv(o, s, l, c, t, e1), n.push(`/z_${a}`);
            }
        }
        this.cacheKey = n.sort().join("");
    }
    getMaxValue(e1) {
        let t = this.binders[e1];
        return t instanceof $785da19a645c07eb$var$ev || t instanceof $785da19a645c07eb$var$tv ? t.maxValue : 0;
    }
    populatePaintArrays(e1, t, i) {
        for(let n in this.binders){
            let a = this.binders[n];
            (a instanceof $785da19a645c07eb$var$ev || a instanceof $785da19a645c07eb$var$tv || a instanceof $785da19a645c07eb$var$iv) && a.populatePaintArray(e1, t, i);
        }
    }
    setConstantPatternPositions(e1, t) {
        for(let i in this.binders){
            let n = this.binders[i];
            n instanceof $785da19a645c07eb$var$$_ && n.setConstantPatternPositions(e1, t);
        }
    }
    setConstantDashPositions(e1, t) {
        for(let i in this.binders){
            let n = this.binders[i];
            n instanceof $785da19a645c07eb$var$$_ && n.setConstantDashPositions(e1, t);
        }
    }
    updatePaintArrays(e1, t, i, n, a) {
        let r = !1;
        for (let s of e1){
            let e1 = t.getPositions(s.id);
            for (let t of e1){
                let e1 = i.feature(t.index);
                for(let i in this.binders){
                    let o = this.binders[i];
                    (o instanceof $785da19a645c07eb$var$ev || o instanceof $785da19a645c07eb$var$tv || o instanceof $785da19a645c07eb$var$iv) && !0 === o.expression.isStateDependent && (o.expression = n.paint.get(i).value, o.updatePaintArray(t.start, t.end, e1, s.state, a), r = !0);
                }
            }
        }
        return r;
    }
    defines() {
        let e1 = [];
        for(let t in this.binders){
            let i = this.binders[t];
            (i instanceof $785da19a645c07eb$var$J_ || i instanceof $785da19a645c07eb$var$$_) && e1.push(...i.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
        }
        return e1;
    }
    getBinderAttributes() {
        let e1 = [];
        for(let t in this.binders){
            let i = this.binders[t];
            if (i instanceof $785da19a645c07eb$var$ev || i instanceof $785da19a645c07eb$var$tv) for (let t of i.paintVertexAttributes)e1.push(t.name);
            else if (i instanceof $785da19a645c07eb$var$iv) {
                let t = i.getVertexAttributes();
                for (let i of t)e1.push(i.name);
            }
        }
        return e1;
    }
    getBinderUniforms() {
        let e1 = [];
        for(let t in this.binders){
            let i = this.binders[t];
            if (i instanceof $785da19a645c07eb$var$J_ || i instanceof $785da19a645c07eb$var$$_ || i instanceof $785da19a645c07eb$var$tv) for (let t of i.uniformNames)e1.push(t);
        }
        return e1;
    }
    getPaintVertexBuffers() {
        return this._buffers;
    }
    getUniforms(e1, t) {
        let i = [];
        for(let n in this.binders){
            let a = this.binders[n];
            if (a instanceof $785da19a645c07eb$var$J_ || a instanceof $785da19a645c07eb$var$$_ || a instanceof $785da19a645c07eb$var$tv) {
                for (let r of a.uniformNames)if (t[r]) {
                    let s = a.getBinding(e1, t[r], r);
                    i.push({
                        name: r,
                        property: n,
                        binding: s
                    });
                }
            }
        }
        return i;
    }
    setUniforms(e1, t, i, n) {
        for (let { name: e1, property: a, binding: r } of t)this.binders[a].setUniform(r, n, i.get(a), e1);
    }
    updatePaintBuffers(e1) {
        this._buffers = [];
        for(let t in this.binders){
            let i = this.binders[t];
            if (e1 && i instanceof $785da19a645c07eb$var$iv) {
                let t = 2 === e1.fromScale ? i.zoomInPaintVertexBuffer : i.zoomOutPaintVertexBuffer;
                t && this._buffers.push(t);
            } else (i instanceof $785da19a645c07eb$var$ev || i instanceof $785da19a645c07eb$var$tv) && i.paintVertexBuffer && this._buffers.push(i.paintVertexBuffer);
        }
    }
    upload(e1) {
        for(let t in this.binders){
            let i = this.binders[t];
            (i instanceof $785da19a645c07eb$var$ev || i instanceof $785da19a645c07eb$var$tv || i instanceof $785da19a645c07eb$var$iv) && i.upload(e1);
        }
        this.updatePaintBuffers();
    }
    destroy() {
        for(let e1 in this.binders){
            let t = this.binders[e1];
            (t instanceof $785da19a645c07eb$var$ev || t instanceof $785da19a645c07eb$var$tv || t instanceof $785da19a645c07eb$var$iv) && t.destroy();
        }
    }
}, $785da19a645c07eb$var$sv = class {
    constructor(e1, t, i = ()=>!0){
        this.programConfigurations = {};
        for (let n of e1)this.programConfigurations[n.id] = new $785da19a645c07eb$var$rv(n, t, i);
        this.needsUpload = !1, this._featureMap = new $785da19a645c07eb$var$L_, this._bufferOffset = 0;
    }
    populatePaintArrays(e1, t, i, n) {
        for(let i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(e1, t, n);
        void 0 !== t.id && this._featureMap.add(t.id, i, this._bufferOffset, e1), this._bufferOffset = e1, this.needsUpload = !0;
    }
    updatePaintArrays(e1, t, i, n) {
        for (let a of i)this.needsUpload = this.programConfigurations[a.id].updatePaintArrays(e1, this._featureMap, t, a, n) || this.needsUpload;
    }
    get(e1) {
        return this.programConfigurations[e1];
    }
    upload(e1) {
        if (this.needsUpload) {
            for(let t in this.programConfigurations)this.programConfigurations[t].upload(e1);
            this.needsUpload = !1;
        }
    }
    destroy() {
        for(let e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
    }
};
function $785da19a645c07eb$var$ov(e1, t) {
    return ({
        "text-opacity": [
            "opacity"
        ],
        "icon-opacity": [
            "opacity"
        ],
        "text-color": [
            "fill_color"
        ],
        "icon-color": [
            "fill_color"
        ],
        "text-halo-color": [
            "halo_color"
        ],
        "icon-halo-color": [
            "halo_color"
        ],
        "text-halo-blur": [
            "halo_blur"
        ],
        "icon-halo-blur": [
            "halo_blur"
        ],
        "text-halo-width": [
            "halo_width"
        ],
        "icon-halo-width": [
            "halo_width"
        ],
        "line-gap-width": [
            "gapwidth"
        ],
        "line-dasharray": [
            "dasharray_to",
            "dasharray_from"
        ],
        "line-pattern": [
            "pattern_to",
            "pattern_from",
            "pixel_ratio_to",
            "pixel_ratio_from"
        ],
        "fill-pattern": [
            "pattern_to",
            "pattern_from",
            "pixel_ratio_to",
            "pixel_ratio_from"
        ],
        "fill-extrusion-pattern": [
            "pattern_to",
            "pattern_from",
            "pixel_ratio_to",
            "pixel_ratio_from"
        ]
    })[e1] || [
        e1.replace(`${t}-`, "").replace(/-/g, "_")
    ];
}
function $785da19a645c07eb$var$lv(e1, t, i) {
    let n = {
        color: {
            source: $785da19a645c07eb$var$PA,
            composite: $785da19a645c07eb$var$XA
        },
        number: {
            source: $785da19a645c07eb$var$GA,
            composite: $785da19a645c07eb$var$PA
        }
    };
    return function(e1) {
        return ({
            "line-pattern": {
                source: $785da19a645c07eb$var$f_,
                composite: $785da19a645c07eb$var$f_
            },
            "fill-pattern": {
                source: $785da19a645c07eb$var$f_,
                composite: $785da19a645c07eb$var$f_
            },
            "fill-extrusion-pattern": {
                source: $785da19a645c07eb$var$f_,
                composite: $785da19a645c07eb$var$f_
            },
            "line-dasharray": {
                source: $785da19a645c07eb$var$A_,
                composite: $785da19a645c07eb$var$A_
            }
        })[e1];
    }(e1)?.[i] || n[t][i];
}
$785da19a645c07eb$var$qf("ConstantBinder", $785da19a645c07eb$var$J_), $785da19a645c07eb$var$qf("CrossFadedConstantBinder", $785da19a645c07eb$var$$_), $785da19a645c07eb$var$qf("SourceExpressionBinder", $785da19a645c07eb$var$ev), $785da19a645c07eb$var$qf("CrossFadedPatternBinder", $785da19a645c07eb$var$nv), $785da19a645c07eb$var$qf("CrossFadedDasharrayBinder", $785da19a645c07eb$var$av), $785da19a645c07eb$var$qf("CompositeExpressionBinder", $785da19a645c07eb$var$tv), $785da19a645c07eb$var$qf("ProgramConfiguration", $785da19a645c07eb$var$rv, {
    omit: [
        "_buffers"
    ]
}), $785da19a645c07eb$var$qf("ProgramConfigurationSet", $785da19a645c07eb$var$sv);
const $785da19a645c07eb$var$cv = 16383, $785da19a645c07eb$var$uv = -16384;
function $785da19a645c07eb$var$hv(e1) {
    let t = $785da19a645c07eb$var$Vu / e1.extent, i = e1.loadGeometry();
    for (let e1 of i)for (let i of e1){
        let e1 = Math.round(i.x * t), n = Math.round(i.y * t);
        i.x = $785da19a645c07eb$var$ch(e1, $785da19a645c07eb$var$uv, $785da19a645c07eb$var$cv), i.y = $785da19a645c07eb$var$ch(n, $785da19a645c07eb$var$uv, $785da19a645c07eb$var$cv), (e1 < i.x || e1 > i.x + 1 || n < i.y || n > i.y + 1) && $785da19a645c07eb$var$wh("Geometry exceeds allowed extent, reduce your vector tile buffer size");
    }
    return i;
}
function $785da19a645c07eb$var$dv(e1, t) {
    return {
        type: e1.type,
        id: e1.id,
        properties: e1.properties,
        geometry: t ? $785da19a645c07eb$var$hv(e1) : []
    };
}
const $785da19a645c07eb$var$pv = -32768;
function $785da19a645c07eb$var$mv(e1, t, i, n, a) {
    e1.emplaceBack($785da19a645c07eb$var$pv + 8 * t + n, $785da19a645c07eb$var$pv + 8 * i + a);
}
var $785da19a645c07eb$var$gv = class {
    constructor(e1){
        this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.layoutVertexArray = new $785da19a645c07eb$var$h_, this.indexArray = new $785da19a645c07eb$var$k_, this.segments = new $785da19a645c07eb$var$T_, this.programConfigurations = new $785da19a645c07eb$var$sv(e1.layers, e1.zoom), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
    }
    populate(e1, t, i) {
        let n = this.layers[0], a = [], r = null, s = !1, o = "heatmap" === n.type;
        if ("circle" === n.type) {
            let e1 = n;
            r = e1.layout.get("circle-sort-key"), s = !r.isConstant(), o ||= "map" === e1.paint.get("circle-pitch-alignment");
        }
        let l = o ? t.subdivisionGranularity.circle : 1, c = new $785da19a645c07eb$var$Qf(this.zoom), u = this.layers[0]._featureFilter.needGeometry;
        for (let { feature: t, id: n, index: o, sourceLayerIndex: l } of e1){
            let e1 = $785da19a645c07eb$var$dv(t, u);
            if (!this.layers[0]._featureFilter.filter(c, e1, i)) continue;
            let h = s ? r.evaluate(e1, {}, i) : void 0, d = {
                id: n,
                properties: t.properties,
                type: t.type,
                sourceLayerIndex: l,
                index: o,
                geometry: u ? e1.geometry : $785da19a645c07eb$var$hv(t),
                patterns: {},
                sortKey: h
            };
            a.push(d);
        }
        s && a.sort((e1, t)=>e1.sortKey - t.sortKey);
        for (let n of a){
            let { geometry: a, index: r, sourceLayerIndex: s } = n, o = e1[r].feature;
            this.addFeature(n, a, r, i, l), t.featureIndex.insert(o, a, r, s, this.index);
        }
    }
    update(e1, t, i) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
            imagePositions: i
        });
    }
    addFeatures(e1) {}
    isEmpty() {
        return 0 === this.layoutVertexArray.length;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e1) {
        this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, $785da19a645c07eb$var$C_), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
    }
    addFeature(e1, t, i, n, a = 1) {
        let r;
        switch(a){
            case 1:
                r = [
                    0,
                    7
                ];
                break;
            case 3:
                r = [
                    0,
                    2,
                    5,
                    7
                ];
                break;
            case 5:
                r = [
                    0,
                    1,
                    3,
                    4,
                    6,
                    7
                ];
                break;
            case 7:
                r = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7
                ];
                break;
            default:
                throw Error(`Invalid circle bucket granularity: ${a}; valid values are 1, 3, 5, 7.`);
        }
        let s = r.length;
        for (let i of t)for (let t of i){
            let i = t.x, n = t.y;
            if (i < 0 || i >= 8192 || n < 0 || n >= 8192) continue;
            let a = this.segments.prepareSegment(s * s, this.layoutVertexArray, this.indexArray, e1.sortKey), o = a.vertexLength;
            for(let e1 = 0; e1 < s; e1++)for(let t = 0; t < s; t++)$785da19a645c07eb$var$mv(this.layoutVertexArray, i, n, r[t], r[e1]);
            for(let e1 = 0; e1 < s - 1; e1++)for(let t = 0; t < s - 1; t++){
                let i = o + e1 * s + t, n = o + (e1 + 1) * s + t;
                this.indexArray.emplaceBack(i, n + 1, i + 1), this.indexArray.emplaceBack(i, n, n + 1);
            }
            a.vertexLength += s * s, a.primitiveLength += (s - 1) * (s - 1) * 2;
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {
            imagePositions: {},
            canonical: n
        });
    }
};
function $785da19a645c07eb$var$fv(e1, t) {
    for (let i of e1)if ($785da19a645c07eb$var$kv(t, i)) return !0;
    for (let i of t)if ($785da19a645c07eb$var$kv(e1, i)) return !0;
    return $785da19a645c07eb$var$yv(e1, t);
}
function $785da19a645c07eb$var$Av(e1, t, i) {
    return !!$785da19a645c07eb$var$kv(e1, t) || $785da19a645c07eb$var$bv(t, e1, i);
}
function $785da19a645c07eb$var$_v(e1, t) {
    if (1 === e1.length) return $785da19a645c07eb$var$Ev(t, e1[0]);
    for (let i of t)for (let t of i)if ($785da19a645c07eb$var$kv(e1, t)) return !0;
    for (let i of e1)if ($785da19a645c07eb$var$Ev(t, i)) return !0;
    for (let i of t)if ($785da19a645c07eb$var$yv(e1, i)) return !0;
    return !1;
}
function $785da19a645c07eb$var$vv(e1, t, i) {
    if (e1.length > 1) {
        if ($785da19a645c07eb$var$yv(e1, t)) return !0;
        for (let n of t)if ($785da19a645c07eb$var$bv(n, e1, i)) return !0;
    }
    for (let n of e1)if ($785da19a645c07eb$var$bv(n, t, i)) return !0;
    return !1;
}
function $785da19a645c07eb$var$yv(e1, t) {
    if (0 === e1.length || 0 === t.length) return !1;
    for(let i = 0; i < e1.length - 1; i++){
        let n = e1[i], a = e1[i + 1];
        for(let e1 = 0; e1 < t.length - 1; e1++){
            if ($785da19a645c07eb$var$xv(n, a, t[e1], t[e1 + 1])) return !0;
        }
    }
    return !1;
}
function $785da19a645c07eb$var$xv(e1, t, i, n) {
    return $785da19a645c07eb$var$Eh(e1, i, n) !== $785da19a645c07eb$var$Eh(t, i, n) && $785da19a645c07eb$var$Eh(e1, t, i) !== $785da19a645c07eb$var$Eh(e1, t, n);
}
function $785da19a645c07eb$var$bv(e1, t, i) {
    let n = i * i;
    if (1 === t.length) return e1.distSqr(t[0]) < n;
    for(let i = 1; i < t.length; i++){
        if ($785da19a645c07eb$var$wv(e1, t[i - 1], t[i]) < n) return !0;
    }
    return !1;
}
function $785da19a645c07eb$var$wv(e1, t, i) {
    let n = t.distSqr(i);
    if (0 === n) return e1.distSqr(t);
    let a = ((e1.x - t.x) * (i.x - t.x) + (e1.y - t.y) * (i.y - t.y)) / n;
    return a < 0 ? e1.distSqr(t) : a > 1 ? e1.distSqr(i) : e1.distSqr(i.sub(t)._mult(a)._add(t));
}
function $785da19a645c07eb$var$Ev(e1, t) {
    let i, n, a, r = !1;
    for (let s of e1){
        i = s;
        for(let e1 = 0, s = i.length - 1; e1 < i.length; s = e1++)n = i[e1], a = i[s], n.y > t.y != a.y > t.y && t.x < (a.x - n.x) * (t.y - n.y) / (a.y - n.y) + n.x && (r = !r);
    }
    return r;
}
function $785da19a645c07eb$var$kv(e1, t) {
    let i = !1;
    for(let n = 0, a = e1.length - 1; n < e1.length; a = n++){
        let r = e1[n], s = e1[a];
        r.y > t.y != s.y > t.y && t.x < (s.x - r.x) * (t.y - r.y) / (s.y - r.y) + r.x && (i = !i);
    }
    return i;
}
function $785da19a645c07eb$var$Sv(e1, t, i) {
    let n = i[0], a = i[2];
    if (e1.x < n.x && t.x < n.x || e1.x > a.x && t.x > a.x || e1.y < n.y && t.y < n.y || e1.y > a.y && t.y > a.y) return !1;
    let r = $785da19a645c07eb$var$Eh(e1, t, i[0]);
    return r !== $785da19a645c07eb$var$Eh(e1, t, i[1]) || r !== $785da19a645c07eb$var$Eh(e1, t, i[2]) || r !== $785da19a645c07eb$var$Eh(e1, t, i[3]);
}
function $785da19a645c07eb$var$Mv(e1, t, i) {
    let n = t.paint.get(e1).value;
    return "constant" === n.kind ? n.value : i.programConfigurations.get(t.id).getMaxValue(e1);
}
function $785da19a645c07eb$var$Cv(e1) {
    return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
}
function $785da19a645c07eb$var$Tv(e1, t, i, n, a) {
    if (!t[0] && !t[1]) return e1;
    let r = $785da19a645c07eb$var$Kc.convert(t)._mult(a);
    "viewport" === i && r._rotate(-n);
    let s = [];
    for (let t of e1)s.push(t.sub(r));
    return s;
}
function $785da19a645c07eb$var$Dv(e1) {
    let t = [];
    for(let i = 0; i < e1.length; i++){
        let n = e1[i], a = t.at(-1);
        (0 === i || a && !n.equals(a)) && t.push(n);
    }
    return t;
}
function $785da19a645c07eb$var$Pv({ queryGeometry: e1, size: t }, i) {
    return $785da19a645c07eb$var$Av(e1, i, t);
}
function $785da19a645c07eb$var$Iv({ queryGeometry: e1, size: t, transform: i, unwrappedTileID: n, getElevation: a }, r) {
    return $785da19a645c07eb$var$Av(e1, r, t * (i.projectTileCoordinates(r.x, r.y, n, a?.(r.x, r.y)).signedDistanceFromCamera / i.cameraToCenterDistance));
}
function $785da19a645c07eb$var$Fv({ queryGeometry: e1, size: t, transform: i, unwrappedTileID: n, getElevation: a }, r) {
    let s = i.projectTileCoordinates(r.x, r.y, n, a?.(r.x, r.y)).signedDistanceFromCamera, o = t * (i.cameraToCenterDistance / s);
    return $785da19a645c07eb$var$Av(e1, $785da19a645c07eb$var$Lv(r, i, n, a), o);
}
function $785da19a645c07eb$var$zv({ queryGeometry: e1, size: t, transform: i, unwrappedTileID: n, getElevation: a }, r) {
    return $785da19a645c07eb$var$Av(e1, $785da19a645c07eb$var$Lv(r, i, n, a), t);
}
function $785da19a645c07eb$var$Rv({ queryGeometry: e1, size: t, transform: i, unwrappedTileID: n, getElevation: a, pitchAlignment: r = "map", pitchScale: s = "map" }, o) {
    let l = "map" === r ? "map" === s ? $785da19a645c07eb$var$Pv : $785da19a645c07eb$var$Iv : "map" === s ? $785da19a645c07eb$var$Fv : $785da19a645c07eb$var$zv, c = {
        queryGeometry: e1,
        size: t,
        transform: i,
        unwrappedTileID: n,
        getElevation: a
    };
    for (let e1 of o)for (let t of e1)if (l(c, t)) return !0;
    return !1;
}
function $785da19a645c07eb$var$Lv(e1, t, i, n) {
    let a = t.projectTileCoordinates(e1.x, e1.y, i, n?.(e1.x, e1.y)).point;
    return new $785da19a645c07eb$var$Kc((.5 * a.x + .5) * t.width, (.5 * -a.y + .5) * t.height);
}
let $785da19a645c07eb$var$Bv;
$785da19a645c07eb$var$qf("CircleBucket", $785da19a645c07eb$var$gv, {
    omit: [
        "layers"
    ]
});
let $785da19a645c07eb$var$Ov;
var $785da19a645c07eb$var$Uv = {
    get paint () {
        return $785da19a645c07eb$var$Ov ||= new $785da19a645c07eb$var$pA({
            "circle-radius": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-radius"], "circle-radius"),
            "circle-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-color"], "circle-color"),
            "circle-blur": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-blur"], "circle-blur"),
            "circle-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-opacity"], "circle-opacity"),
            "circle-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_circle["circle-translate"], "circle-translate"),
            "circle-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_circle["circle-translate-anchor"], "circle-translate-anchor"),
            "circle-pitch-scale": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_circle["circle-pitch-scale"], "circle-pitch-scale"),
            "circle-pitch-alignment": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_circle["circle-pitch-alignment"], "circle-pitch-alignment"),
            "circle-stroke-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-stroke-width"], "circle-stroke-width"),
            "circle-stroke-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-stroke-color"], "circle-stroke-color"),
            "circle-stroke-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_circle["circle-stroke-opacity"], "circle-stroke-opacity")
        });
    },
    get layout () {
        return $785da19a645c07eb$var$Bv ||= new $785da19a645c07eb$var$pA({
            "circle-sort-key": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_circle["circle-sort-key"], "circle-sort-key")
        });
    }
};
var $785da19a645c07eb$var$Nv = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$Uv, t);
    }
    createBucket(e1) {
        return new $785da19a645c07eb$var$gv(e1);
    }
    queryRadius(e1) {
        let t = e1;
        return $785da19a645c07eb$var$Mv("circle-radius", this, t) + $785da19a645c07eb$var$Mv("circle-stroke-width", this, t) + $785da19a645c07eb$var$Cv(this.paint.get("circle-translate"));
    }
    queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: i, geometry: n, transform: a, pixelsToTileUnits: r, unwrappedTileID: s, getElevation: o }) {
        let l, c, u = $785da19a645c07eb$var$Tv(e1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -a.bearingInRadians, r), h = this.paint.get("circle-radius").evaluate(t, i) + this.paint.get("circle-stroke-width").evaluate(t, i), d = this.paint.get("circle-pitch-scale"), p = this.paint.get("circle-pitch-alignment");
        return "map" === p ? (l = u, c = h * r) : (l = function(e1, t, i, n) {
            return e1.map((e1)=>$785da19a645c07eb$var$Lv(e1, t, i, n));
        }(u, a, s, o), c = h), $785da19a645c07eb$var$Rv({
            queryGeometry: l,
            size: c,
            transform: a,
            unwrappedTileID: s,
            getElevation: o,
            pitchAlignment: p,
            pitchScale: d
        }, n);
    }
}, $785da19a645c07eb$var$jv = class extends $785da19a645c07eb$var$gv {
};
let $785da19a645c07eb$var$Vv;
$785da19a645c07eb$var$qf("HeatmapBucket", $785da19a645c07eb$var$jv, {
    omit: [
        "layers"
    ]
});
var $785da19a645c07eb$var$qv = {
    get paint () {
        return $785da19a645c07eb$var$Vv ||= new $785da19a645c07eb$var$pA({
            "heatmap-radius": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_heatmap["heatmap-radius"], "heatmap-radius"),
            "heatmap-weight": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_heatmap["heatmap-weight"], "heatmap-weight"),
            "heatmap-intensity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_heatmap["heatmap-intensity"], "heatmap-intensity"),
            "heatmap-color": new $785da19a645c07eb$var$dA($785da19a645c07eb$var$od.paint_heatmap["heatmap-color"], "heatmap-color"),
            "heatmap-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_heatmap["heatmap-opacity"], "heatmap-opacity")
        });
    }
};
function $785da19a645c07eb$var$Gv(e1, { width: t, height: i }, n, a) {
    if (a) {
        if (a instanceof Uint8ClampedArray) a = new Uint8Array(a.buffer);
        else if (a.length !== t * i * n) throw RangeError(`mismatched image size. expected: ${a.length} but got: ${t * i * n}`);
    } else a = new Uint8Array(t * i * n);
    return e1.width = t, e1.height = i, e1.data = a, e1;
}
function $785da19a645c07eb$var$Hv(e1, { width: t, height: i }, n) {
    if (t === e1.width && i === e1.height) return;
    let a = $785da19a645c07eb$var$Gv({}, {
        width: t,
        height: i
    }, n);
    $785da19a645c07eb$var$Wv(e1, a, {
        x: 0,
        y: 0
    }, {
        x: 0,
        y: 0
    }, {
        width: Math.min(e1.width, t),
        height: Math.min(e1.height, i)
    }, n), e1.width = t, e1.height = i, e1.data = a.data;
}
function $785da19a645c07eb$var$Wv(e1, t, i, n, a, r) {
    if (0 === a.width || 0 === a.height) return t;
    if (a.width > e1.width || a.height > e1.height || i.x > e1.width - a.width || i.y > e1.height - a.height) throw RangeError("out of range source coordinates for image copy");
    if (a.width > t.width || a.height > t.height || n.x > t.width - a.width || n.y > t.height - a.height) throw RangeError("out of range destination coordinates for image copy");
    let s = e1.data, o = t.data;
    if (s === o) throw Error("srcData equals dstData, so image is already copied");
    for(let l = 0; l < a.height; l++){
        let c = ((i.y + l) * e1.width + i.x) * r, u = ((n.y + l) * t.width + n.x) * r;
        for(let e1 = 0; e1 < a.width * r; e1++)o[u + e1] = s[c + e1];
    }
    return t;
}
var $785da19a645c07eb$var$Zv = class e1 {
    constructor(e1, t){
        $785da19a645c07eb$var$Gv(this, e1, 1, t);
    }
    resize(e1) {
        $785da19a645c07eb$var$Hv(this, e1, 1);
    }
    clone() {
        return new e1({
            width: this.width,
            height: this.height
        }, new Uint8Array(this.data));
    }
    static copy(e1, t, i, n, a) {
        $785da19a645c07eb$var$Wv(e1, t, i, n, a, 1);
    }
}, $785da19a645c07eb$var$Kv = class e1 {
    constructor(e1, t){
        $785da19a645c07eb$var$Gv(this, e1, 4, t);
    }
    resize(e1) {
        $785da19a645c07eb$var$Hv(this, e1, 4);
    }
    replace(e1, t) {
        t ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
    }
    clone() {
        return new e1({
            width: this.width,
            height: this.height
        }, new Uint8Array(this.data));
    }
    static copy(e1, t, i, n, a) {
        $785da19a645c07eb$var$Wv(e1, t, i, n, a, 4);
    }
    setPixel(e1, t, i) {
        let n = 4 * (e1 * this.width + t);
        this.data[n + 0] = Math.round(255 * i.r / i.a), this.data[n + 1] = Math.round(255 * i.g / i.a), this.data[n + 2] = Math.round(255 * i.b / i.a), this.data[n + 3] = Math.round(255 * i.a);
    }
};
function $785da19a645c07eb$var$Xv(e1) {
    let t = new Uint8Array(e1.length);
    for(let i = 0; i < e1.length; i += 4){
        let n = e1[i + 3];
        t[i + 0] = Math.round(e1[i + 0] * n / 255), t[i + 1] = Math.round(e1[i + 1] * n / 255), t[i + 2] = Math.round(e1[i + 2] * n / 255), t[i + 3] = n;
    }
    return t;
}
function $785da19a645c07eb$var$Qv(e1) {
    let t = {}, i = e1.resolution || 256, n = e1.clips ? e1.clips.length : 1, a = e1.image || new $785da19a645c07eb$var$Kv({
        width: i,
        height: n
    });
    if (!function(e1) {
        return Math.log(e1) / Math.LN2 % 1 == 0;
    }(i)) throw Error(`width is not a power of 2 - ${i}`);
    let r = (n, r, s)=>{
        t[e1.evaluationKey] = s;
        let o = e1.expression.evaluate(t);
        a.setPixel(n / 4 / i, r / 4, o);
    };
    if (e1.clips) for(let t = 0, a = 0; t < n; ++t, a += 4 * i)for(let n = 0, s = 0; n < i; n++, s += 4){
        let o = n / (i - 1), { start: l, end: c } = e1.clips[t];
        r(a, s, l * (1 - o) + c * o);
    }
    else for(let e1 = 0, t = 0; e1 < i; e1++, t += 4)r(0, t, e1 / (i - 1));
    return a;
}
$785da19a645c07eb$var$qf("AlphaImage", $785da19a645c07eb$var$Zv), $785da19a645c07eb$var$qf("RGBAImage", $785da19a645c07eb$var$Kv);
const $785da19a645c07eb$var$Yv = "big-fb";
var $785da19a645c07eb$var$Jv = class extends $785da19a645c07eb$var$fA {
    createBucket(e1) {
        return new $785da19a645c07eb$var$jv(e1);
    }
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$qv, t), this.heatmapFbos = new Map, this._updateColorRamp();
    }
    _handleSpecialPaintPropertyUpdate(e1) {
        "heatmap-color" === e1 && this._updateColorRamp();
    }
    _updateColorRamp() {
        let e1 = this._transitionablePaint._values["heatmap-color"].value.expression;
        this.colorRamp = $785da19a645c07eb$var$Qv({
            expression: e1,
            evaluationKey: "heatmapDensity",
            image: this.colorRamp
        }), this.colorRampTexture = null;
    }
    resize() {
        this.heatmapFbos.has("big-fb") && this.heatmapFbos.delete($785da19a645c07eb$var$Yv);
    }
    queryRadius(e1) {
        return $785da19a645c07eb$var$Mv("heatmap-radius", this, e1);
    }
    queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: i, geometry: n, transform: a, pixelsToTileUnits: r, unwrappedTileID: s, getElevation: o }) {
        return $785da19a645c07eb$var$Rv({
            queryGeometry: e1,
            size: this.paint.get("heatmap-radius").evaluate(t, i) * r,
            transform: a,
            unwrappedTileID: s,
            getElevation: o
        }, n);
    }
    hasOffscreenPass() {
        return 0 !== this.paint.get("heatmap-opacity") && !this.isHidden();
    }
};
let $785da19a645c07eb$var$$v;
var $785da19a645c07eb$var$ey = {
    get paint () {
        return $785da19a645c07eb$var$$v ||= new $785da19a645c07eb$var$pA({
            "hillshade-illumination-direction": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-illumination-direction"], "hillshade-illumination-direction"),
            "hillshade-illumination-altitude": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-illumination-altitude"], "hillshade-illumination-altitude"),
            "hillshade-illumination-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-illumination-anchor"], "hillshade-illumination-anchor"),
            "hillshade-exaggeration": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-exaggeration"], "hillshade-exaggeration"),
            "hillshade-shadow-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-shadow-color"], "hillshade-shadow-color"),
            "hillshade-highlight-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-highlight-color"], "hillshade-highlight-color"),
            "hillshade-accent-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-accent-color"], "hillshade-accent-color"),
            "hillshade-method": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade["hillshade-method"], "hillshade-method"),
            resampling: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_hillshade.resampling, "resampling")
        });
    }
};
var $785da19a645c07eb$var$ty = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$ey, t), this.recalculate({
            zoom: 0,
            zoomHistory: {}
        }, void 0);
    }
    getIlluminationProperties() {
        let e1 = this.paint.get("hillshade-illumination-direction").values, t = this.paint.get("hillshade-illumination-altitude").values, i = this.paint.get("hillshade-highlight-color").values, n = this.paint.get("hillshade-shadow-color").values, a = Math.max(e1.length, t.length, i.length, n.length);
        e1 = e1.concat(Array(a - e1.length).fill(e1.at(-1))), t = t.concat(Array(a - t.length).fill(t.at(-1))), i = i.concat(Array(a - i.length).fill(i.at(-1))), n = n.concat(Array(a - n.length).fill(n.at(-1)));
        let r = t.map($785da19a645c07eb$var$Dh);
        return {
            directionRadians: e1.map($785da19a645c07eb$var$Dh),
            altitudeRadians: r,
            shadowColor: n,
            highlightColor: i
        };
    }
    hasOffscreenPass() {
        return 0 !== this.paint.get("hillshade-exaggeration") && !this.isHidden();
    }
};
let $785da19a645c07eb$var$iy;
var $785da19a645c07eb$var$ny = {
    get paint () {
        return $785da19a645c07eb$var$iy ||= new $785da19a645c07eb$var$pA({
            "color-relief-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_color-relief"]["color-relief-opacity"], "color-relief-opacity"),
            "color-relief-color": new $785da19a645c07eb$var$dA($785da19a645c07eb$var$od["paint_color-relief"]["color-relief-color"], "color-relief-color"),
            resampling: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_color-relief"].resampling, "resampling")
        });
    }
};
function $785da19a645c07eb$var$ay(e1) {
    return "data" in e1;
}
var $785da19a645c07eb$var$ry = class {
    constructor(e1, t, i, n){
        this.context = e1, this.format = i, this.texture = e1.gl.createTexture(), this._ownedHandle = this.texture, this.update(t, n);
    }
    update(e1, t, i) {
        let { width: n, height: a } = e1, r = (this.size?.[0] !== n || this.size[1] !== a) && !i, { context: s } = this, { gl: o } = s;
        this.useMipmap = !!t?.useMipmap, r && this.size && this.format === o.RGBA && (o.deleteTexture(this.texture), this.texture = o.createTexture(), this._ownedHandle = this.texture, this.magFilter = void 0, this.minFilter = void 0, this.wrap = void 0), o.bindTexture(o.TEXTURE_2D, this.texture), s.pixelStoreUnpackFlipY.set(!1), s.pixelStoreUnpack.set(1);
        let l = this.format === o.RGBA && !1 !== t?.premultiply;
        if (r) {
            if (this.size = [
                n,
                a
            ], this.format === o.RGBA && n > 0 && a > 0) {
                let t = this.useMipmap ? Math.floor(Math.log2(Math.max(n, a))) + 1 : 1;
                if (o.texStorage2D(o.TEXTURE_2D, t, o.RGBA8, n, a), $785da19a645c07eb$var$ay(e1)) {
                    s.pixelStoreUnpackPremultiplyAlpha.set(!1);
                    let { data: t } = e1;
                    l && t && (t = $785da19a645c07eb$var$Xv(t)), t && o.texSubImage2D(o.TEXTURE_2D, 0, 0, 0, n, a, o.RGBA, o.UNSIGNED_BYTE, t);
                } else s.pixelStoreUnpackPremultiplyAlpha.set(l), o.texSubImage2D(o.TEXTURE_2D, 0, 0, 0, o.RGBA, o.UNSIGNED_BYTE, e1);
            } else $785da19a645c07eb$var$ay(e1) ? (s.pixelStoreUnpackPremultiplyAlpha.set(!1), this._uploadRawData(e1, l, n, a, o)) : (s.pixelStoreUnpackPremultiplyAlpha.set(l), this._uploadDomImage(e1, o));
        } else {
            let { x: t, y: r } = i || {
                x: 0,
                y: 0
            };
            $785da19a645c07eb$var$ay(e1) ? (s.pixelStoreUnpackPremultiplyAlpha.set(!1), this._updateRawData(e1, l, t, r, n, a, o)) : (s.pixelStoreUnpackPremultiplyAlpha.set(l), this._updateDomImage(e1, t, r, o));
        }
        this.useMipmap && !($785da19a645c07eb$var$ay(e1) && null === e1.data) && o.generateMipmap(o.TEXTURE_2D), s.pixelStoreUnpackFlipY.setDefault(), s.pixelStoreUnpack.setDefault(), s.pixelStoreUnpackPremultiplyAlpha.setDefault();
    }
    _uploadDomImage(e1, t) {
        t.texImage2D(t.TEXTURE_2D, 0, this.format, this.format, t.UNSIGNED_BYTE, e1);
    }
    _uploadRawData(e1, t, i, n, a) {
        let { data: r } = e1;
        t && r && (r = $785da19a645c07eb$var$Xv(r)), a.texImage2D(a.TEXTURE_2D, 0, this.format, i, n, 0, this.format, a.UNSIGNED_BYTE, r);
    }
    _updateDomImage(e1, t, i, n) {
        n.texSubImage2D(n.TEXTURE_2D, 0, t, i, n.RGBA, n.UNSIGNED_BYTE, e1);
    }
    _updateRawData(e1, t, i, n, a, r, s) {
        let { data: o } = e1;
        t && o && (o = $785da19a645c07eb$var$Xv(o)), s.texSubImage2D(s.TEXTURE_2D, 0, i, n, a, r, s.RGBA, s.UNSIGNED_BYTE, o);
    }
    bind(e1, t, i) {
        let { context: n } = this, { gl: a } = n;
        this.texture !== this._ownedHandle && (this.texture = this._ownedHandle), a.bindTexture(a.TEXTURE_2D, this.texture), (i === a.LINEAR_MIPMAP_NEAREST || i === a.LINEAR_MIPMAP_LINEAR) && !this.useMipmap && (i = a.LINEAR);
        let r = i || e1;
        e1 !== this.magFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, e1), this.magFilter = e1), r !== this.minFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, r), this.minFilter = r), t !== this.wrap && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, t), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, t), this.wrap = t);
    }
    generateMipmap() {
        if (!this.useMipmap) return;
        let { gl: e1 } = this.context;
        e1.bindTexture(e1.TEXTURE_2D, this.texture), e1.generateMipmap(e1.TEXTURE_2D);
    }
    destroy() {
        let { gl: e1 } = this.context;
        e1.deleteTexture(this.texture), this.texture = null, this._ownedHandle = null;
    }
}, $785da19a645c07eb$var$sy = class e1 {
    static{
        this.byteViewCache = new WeakMap;
    }
    constructor(t, i, n, a = 1, r = 1, s = 1, o = 0){
        if (this.uid = t, i.height !== i.width) throw RangeError("DEM tiles must be square");
        if (n && ![
            "mapbox",
            "terrarium",
            "custom"
        ].includes(n)) return void $785da19a645c07eb$var$wh(`"${n}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
        this.stride = i.height;
        let l = this.dim = i.height - 4;
        switch(this.data = new Uint32Array(i.data.buffer), e1.byteViewCache.set(this, new Uint8Array(this.data.buffer)), n){
            case "terrarium":
                this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                break;
            case "custom":
                this.redFactor = a, this.greenFactor = r, this.blueFactor = s, this.baseShift = o;
                break;
            default:
                this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
        }
        for(let e1 = -2; e1 < l + 2; e1++){
            let t = this._idx(0, Math.max(0, Math.min(l - 1, e1)));
            (e1 < 0 || e1 >= l) && this.data.copyWithin(this._idx(0, e1), t, t + l), this.data.fill(this.data[t], this._idx(-2, e1), this._idx(0, e1)), this.data.fill(this.data[t + l - 1], this._idx(l, e1), this._idx(l + 1, e1) + 1);
        }
        let c = this._getByteView();
        this.min = 2 ** 53 - 1, this.max = -9007199254740991;
        for(let e1 = 0; e1 < l; e1++)for(let t = 0; t < l; t++){
            let i = 4 * this._idx(e1, t), n = this._unpackAtIndex(c, i);
            n > this.max && (this.max = n), n < this.min && (this.min = n);
        }
    }
    get(e1, t) {
        let i = this._getByteView(), n = 4 * this._idx(e1, t);
        return this._unpackAtIndex(i, n);
    }
    sampleBilinear(e1, t) {
        let i = Math.floor(e1), n = Math.floor(t);
        if (i < -1 || i >= this.dim || n < -1 || n >= this.dim) throw RangeError(`Out of range source coordinates for DEM data. x: ${e1}, y: ${t}, dim: ${this.dim}`);
        let a = this._getByteView(), r = 4 * ((n + 2) * this.stride + i + 2), s = 4 * this.stride, o = e1 - i, l = t - n;
        return this._unpackAtIndex(a, r) * (1 - o) * (1 - l) + this._unpackAtIndex(a, r + 4) * o * (1 - l) + this._unpackAtIndex(a, r + s) * (1 - o) * l + this._unpackAtIndex(a, r + s + 4) * o * l;
    }
    getUnpackVector() {
        return [
            this.redFactor,
            this.greenFactor,
            this.blueFactor,
            this.baseShift
        ];
    }
    _idx(e1, t) {
        if (e1 < -2 || e1 >= this.dim + 2 || t < -2 || t >= this.dim + 2) throw RangeError(`Out of range source coordinates for DEM data. x: ${e1}, y: ${t}, dim: ${this.dim}`);
        return (t + 2) * this.stride + (e1 + 2);
    }
    unpack(e1, t, i) {
        return e1 * this.redFactor + t * this.greenFactor + i * this.blueFactor - this.baseShift;
    }
    pack(e1) {
        return $785da19a645c07eb$var$oy(e1, this.getUnpackVector());
    }
    getPixels() {
        return new $785da19a645c07eb$var$Kv({
            width: this.stride,
            height: this.stride
        }, this._getByteView());
    }
    backfillBorder(e1, t, i) {
        if (this.dim !== e1.dim) throw Error("dem dimension mismatch");
        let n = t * this.dim, a = t * this.dim + this.dim, r = i * this.dim, s = i * this.dim + this.dim;
        switch(t){
            case -1:
                n = a - 2;
                break;
            case 1:
                a = n + 2;
        }
        switch(i){
            case -1:
                r = s - 2;
                break;
            case 1:
                s = r + 2;
        }
        let o = -t * this.dim, l = -i * this.dim;
        for(let t = r; t < s; t++)for(let i = n; i < a; i++)this.data[this._idx(i, t)] = e1.data[this._idx(i + o, t + l)];
    }
    _getByteView() {
        let t = e1.byteViewCache.get(this);
        return t?.buffer !== this.data.buffer && (t = new Uint8Array(this.data.buffer), e1.byteViewCache.set(this, t)), t;
    }
    _unpackAtIndex(e1, t) {
        return this.unpack(e1[t], e1[t + 1], e1[t + 2]);
    }
};
function $785da19a645c07eb$var$oy(e1, t) {
    let i = t[0], n = t[1], a = t[2], r = t[3], s = Math.min(i, n, a), o = Math.round((e1 + r) / s);
    return {
        r: Math.floor(o * s / i) % 256,
        g: Math.floor(o * s / n) % 256,
        b: Math.floor(o * s / a) % 256
    };
}
$785da19a645c07eb$var$qf("DEMData", $785da19a645c07eb$var$sy);
var $785da19a645c07eb$var$ly = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$ny, t);
    }
    _createColorRamp(e1) {
        let t = {
            elevationStops: [],
            colorStops: []
        }, i = this._transitionablePaint._values["color-relief-color"].value.expression;
        if (i instanceof $785da19a645c07eb$var$Sg && i._styleExpression.expression instanceof $785da19a645c07eb$var$kp) {
            this.colorRampExpression = i;
            let e1 = i._styleExpression.expression;
            t.elevationStops = e1.labels, t.colorStops = [];
            for (let i of t.elevationStops)t.colorStops.push(e1.evaluate({
                globals: {
                    elevation: i
                }
            }));
        }
        if (t.elevationStops.length < 1 && (t.elevationStops = [
            0
        ], t.colorStops = [
            $785da19a645c07eb$var$np.transparent
        ]), t.elevationStops.length < 2 && (t.elevationStops.push(t.elevationStops[0] + 1), t.colorStops.push(t.colorStops[0])), t.elevationStops.length <= e1) return t;
        let n = {
            elevationStops: [],
            colorStops: []
        }, a = (t.elevationStops.length - 1) / (e1 - 1);
        for(let e1 = 0; e1 < t.elevationStops.length - .5; e1 += a)n.elevationStops.push(t.elevationStops[Math.round(e1)]), n.colorStops.push(t.colorStops[Math.round(e1)]);
        return $785da19a645c07eb$var$wh(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${e1}, provided: ${t.elevationStops.length}`), n;
    }
    _colorRampChanged() {
        return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
    }
    getColorRampTextures(e1, t, i) {
        if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
        let n = this._createColorRamp(t), a = new $785da19a645c07eb$var$Kv({
            width: n.colorStops.length,
            height: 1
        }), r = new $785da19a645c07eb$var$Kv({
            width: n.colorStops.length,
            height: 1
        });
        for(let e1 = 0; e1 < n.elevationStops.length; e1++){
            let t = $785da19a645c07eb$var$oy(n.elevationStops[e1], i);
            r.setPixel(0, e1, new $785da19a645c07eb$var$np(t.r / 255, t.g / 255, t.b / 255, 1)), a.setPixel(0, e1, n.colorStops[e1]);
        }
        return this.colorRampTextures = {
            elevationTexture: new $785da19a645c07eb$var$ry(e1, r, e1.gl.RGBA),
            colorTexture: new $785da19a645c07eb$var$ry(e1, a, e1.gl.RGBA)
        }, this.colorRampTextures;
    }
    hasOffscreenPass() {
        return !this.isHidden() && !!this.colorRampTextures;
    }
};
const $785da19a645c07eb$var$cy = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        components: 2,
        type: "Int16"
    }
], 4).members;
function $785da19a645c07eb$var$uy(e1, t, i) {
    let n = i.patternDependencies, a = !1;
    for (let i of t){
        let t = i.paint.get(`${e1}-pattern`);
        t.isConstant() || (a = !0);
        let r = t.constantOr(null);
        r && (a = !0, n[r.to] = !0, n[r.from] = !0);
    }
    return a;
}
function $785da19a645c07eb$var$hy(e1, t, i, n, a) {
    let { zoom: r } = n, s = a.patternDependencies;
    for (let n of t){
        let t = n.paint.get(`${e1}-pattern`).value;
        if ("constant" !== t.kind) {
            let e1 = t.evaluate({
                zoom: r - 1
            }, i, {}, a.availableImages), o = t.evaluate({
                zoom: r
            }, i, {}, a.availableImages), l = t.evaluate({
                zoom: r + 1
            }, i, {}, a.availableImages);
            e1 = e1?.name ? e1.name : e1, o = o?.name ? o.name : o, l = l?.name ? l.name : l, s[e1] = !0, s[o] = !0, s[l] = !0, i.patterns[n.id] = {
                min: e1,
                mid: o,
                max: l
            };
        }
    }
    return i;
}
const $785da19a645c07eb$var$dy = new Set;
let $785da19a645c07eb$var$py = !1;
function $785da19a645c07eb$var$my(e1, t, i = 2) {
    let n = t && t.length, a = n ? t[0] * i : e1.length;
    $785da19a645c07eb$var$dy.size && $785da19a645c07eb$var$dy.clear();
    let r = $785da19a645c07eb$var$gy(e1, 0, a, i, !0), s = [];
    if (!r || r.next === r.prev) return s;
    let o = 0, l = 0, c = 0;
    if (n && (r = function(e1, t, i, n) {
        let a = [];
        for(let i = 0, r = t.length; i < r; i++){
            let s = $785da19a645c07eb$var$gy(e1, t[i] * n, i < r - 1 ? t[i + 1] * n : e1.length, n, !1);
            s === s.next && $785da19a645c07eb$var$dy.add(s), a.push($785da19a645c07eb$var$Ny(s));
        }
        a.sort($785da19a645c07eb$var$wy), function(e1, t) {
            let i = Math.ceil((e1 + 2 * t) / 16) + t + 2;
            $785da19a645c07eb$var$ky.length < 4 * i && ($785da19a645c07eb$var$ky = new Float64Array(4 * i)), $785da19a645c07eb$var$Sy = 0;
        }(e1.length / n, t.length), $785da19a645c07eb$var$Ty(i, i), $785da19a645c07eb$var$by = !0;
        for(let e1 = 0; e1 < a.length; e1++)i = $785da19a645c07eb$var$Ey(a[e1], i);
        return $785da19a645c07eb$var$by = !1, $785da19a645c07eb$var$fy(i);
    }(e1, t, r, i)), e1.length > 80 * i) {
        o = e1[0], l = e1[1];
        let t = o, n = l;
        for(let r = i; r < a; r += i){
            let i = e1[r], a = e1[r + 1];
            i < o && (o = i), a < l && (l = a), i > t && (t = i), a > n && (n = a);
        }
        c = Math.max(t - o, n - l), c = 0 === c ? 0 : 32767 / c;
    }
    return $785da19a645c07eb$var$Ay(r, s, o, l, c), s;
}
function $785da19a645c07eb$var$gy(e1, t, i, n, a) {
    let r = null;
    if (a === function(e1, t, i, n) {
        let a = 0;
        for(let r = t, s = i - n; r < i; r += n)a += (e1[s] - e1[r]) * (e1[r + 1] + e1[s + 1]), s = r;
        return a;
    }(e1, t, i, n) > 0) for(let a = t; a < i; a += n)r = $785da19a645c07eb$var$Xy(a / n | 0, e1[a], e1[a + 1], r);
    else for(let a = i - n; a >= t; a -= n)r = $785da19a645c07eb$var$Xy(a / n | 0, e1[a], e1[a + 1], r);
    return r && $785da19a645c07eb$var$Gy(r, r.next) && ($785da19a645c07eb$var$Qy(r), r = r.next), r;
}
function $785da19a645c07eb$var$fy(e1, t = e1) {
    let i, n = t === e1, a = e1;
    do i = !1, a === a.next || 0 !== $785da19a645c07eb$var$dy.size && $785da19a645c07eb$var$dy.has(a) || !$785da19a645c07eb$var$Gy(a, a.next) && 0 !== $785da19a645c07eb$var$qy(a.prev, a, a.next) ? (n || a !== t) && (a = a.next, i = !n) : ((n || a === t) && (t = a.prev), $785da19a645c07eb$var$py = !0, $785da19a645c07eb$var$Qy(a), a = a.prev, i = !0);
    while (i || a !== t);
    return t;
}
function $785da19a645c07eb$var$Ay(e1, t, i, n, a) {
    a && function(e1, t, i, n) {
        let a = e1, r = 0;
        do a.z = $785da19a645c07eb$var$Uy(a.x, a.y, t, i, n), $785da19a645c07eb$var$Fy[r++] = a, a = a.next;
        while (a !== e1);
        !function(e1) {
            if (e1 <= 32) {
                for(let t = 1; t < e1; t++){
                    let e1 = $785da19a645c07eb$var$Fy[t], i = e1.z, n = t - 1;
                    for(; n >= 0 && $785da19a645c07eb$var$Fy[n].z > i;)$785da19a645c07eb$var$Fy[n + 1] = $785da19a645c07eb$var$Fy[n], n--;
                    $785da19a645c07eb$var$Fy[n + 1] = e1;
                }
                return;
            }
            $785da19a645c07eb$var$Ry.length < e1 && ($785da19a645c07eb$var$Ry = new Uint32Array(e1), $785da19a645c07eb$var$Ly = new Uint32Array(e1), $785da19a645c07eb$var$zy = Array(e1));
            for(let t = 0; t < e1; t++)$785da19a645c07eb$var$Ry[t] = $785da19a645c07eb$var$Fy[t].z;
            $785da19a645c07eb$var$Oy(e1, $785da19a645c07eb$var$Fy, $785da19a645c07eb$var$Ry, $785da19a645c07eb$var$zy, $785da19a645c07eb$var$Ly, 0), $785da19a645c07eb$var$Oy(e1, $785da19a645c07eb$var$zy, $785da19a645c07eb$var$Ly, $785da19a645c07eb$var$Fy, $785da19a645c07eb$var$Ry, 8), $785da19a645c07eb$var$Oy(e1, $785da19a645c07eb$var$Fy, $785da19a645c07eb$var$Ry, $785da19a645c07eb$var$zy, $785da19a645c07eb$var$Ly, 16), $785da19a645c07eb$var$Oy(e1, $785da19a645c07eb$var$zy, $785da19a645c07eb$var$Ly, $785da19a645c07eb$var$Fy, $785da19a645c07eb$var$Ry, 24);
        }(r);
        let s = null;
        for(let e1 = 0; e1 < r; e1++){
            let t = $785da19a645c07eb$var$Fy[e1];
            t.prevZ = s, s && (s.nextZ = t), s = t;
        }
        s.nextZ = null;
    }(e1, i, n, a);
    let r = e1, s = !1;
    for(; e1.prev !== e1.next;){
        let o = e1.prev, l = e1.next;
        if ($785da19a645c07eb$var$qy(o, e1, l) < 0 && (a ? $785da19a645c07eb$var$vy(e1, i, n, a) : $785da19a645c07eb$var$_y(e1))) t.push(o.i, e1.i, l.i), $785da19a645c07eb$var$Qy(e1), e1 = l, r = l;
        else if ((e1 = l) === r) {
            if ($785da19a645c07eb$var$py = !1, e1 = $785da19a645c07eb$var$fy(e1), $785da19a645c07eb$var$py) {
                r = e1;
                continue;
            }
            if (!s) {
                r = e1 = $785da19a645c07eb$var$yy(e1, t), s = !0;
                continue;
            }
            $785da19a645c07eb$var$xy(e1, t, i, n, a);
            break;
        }
    }
}
function $785da19a645c07eb$var$_y(e1) {
    let t = e1.prev, i = e1, n = e1.next, a = t.x, r = i.x, s = n.x, o = t.y, l = i.y, c = n.y, u = Math.min(a, r, s), h = Math.min(o, l, c), d = Math.max(a, r, s), p = Math.max(o, l, c), m = n.next;
    for(; m !== t;){
        if (m.x >= u && m.x <= d && m.y >= h && m.y <= p && (a !== m.x || o !== m.y) && $785da19a645c07eb$var$jy(a, o, r, l, s, c, m.x, m.y) && $785da19a645c07eb$var$qy(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function $785da19a645c07eb$var$vy(e1, t, i, n) {
    let a = e1.prev, r = e1, s = e1.next, o = a.x, l = r.x, c = s.x, u = a.y, h = r.y, d = s.y, p = Math.min(o, l, c), m = Math.min(u, h, d), g = Math.max(o, l, c), f = Math.max(u, h, d), A = $785da19a645c07eb$var$Uy(p, m, t, i, n), _ = $785da19a645c07eb$var$Uy(g, f, t, i, n), v = e1.prevZ;
    for(; v && v.z >= A;){
        if (v.x >= p && v.x <= g && v.y >= m && v.y <= f && v !== s && (o !== v.x || u !== v.y) && $785da19a645c07eb$var$jy(o, u, l, h, c, d, v.x, v.y) && $785da19a645c07eb$var$qy(v.prev, v, v.next) >= 0) return !1;
        v = v.prevZ;
    }
    let y = e1.nextZ;
    for(; y && y.z <= _;){
        if (y.x >= p && y.x <= g && y.y >= m && y.y <= f && y !== s && (o !== y.x || u !== y.y) && $785da19a645c07eb$var$jy(o, u, l, h, c, d, y.x, y.y) && $785da19a645c07eb$var$qy(y.prev, y, y.next) >= 0) return !1;
        y = y.nextZ;
    }
    return !0;
}
function $785da19a645c07eb$var$yy(e1, t) {
    let i = e1, n = !1;
    do {
        let a = i.prev, r = i.next.next;
        $785da19a645c07eb$var$Hy(a, i, i.next, r, !1) && $785da19a645c07eb$var$Zy(a, r) && $785da19a645c07eb$var$Zy(r, a) && (t.push(a.i, i.i, r.i), $785da19a645c07eb$var$Qy(i), $785da19a645c07eb$var$Qy(i.next), i = e1 = r, n = !0), i = i.next;
    }while (i !== e1);
    return n ? $785da19a645c07eb$var$fy(i) : i;
}
function $785da19a645c07eb$var$xy(e1, t, i, n, a) {
    let r = e1;
    do {
        let e1 = r.next.next;
        for(; e1 !== r.prev;){
            if (r.i !== e1.i && $785da19a645c07eb$var$Vy(r, e1)) {
                let s = $785da19a645c07eb$var$Ky(r, e1);
                return r = $785da19a645c07eb$var$fy(r, r.next), s = $785da19a645c07eb$var$fy(s, s.next), $785da19a645c07eb$var$Ay(r, t, i, n, a), void $785da19a645c07eb$var$Ay(s, t, i, n, a);
            }
            e1 = e1.next;
        }
        r = r.next;
    }while (r !== e1);
}
let $785da19a645c07eb$var$by = !1;
function $785da19a645c07eb$var$wy(e1, t) {
    return e1.x - t.x || e1.y - t.y || (e1.next.y - e1.y) / (e1.next.x - e1.x) - (t.next.y - t.y) / (t.next.x - t.x);
}
function $785da19a645c07eb$var$Ey(e1, t) {
    let i = function(e1, t) {
        let i, n = t, a = e1.x, r = e1.y, s = -1 / 0;
        if ($785da19a645c07eb$var$Gy(e1, n)) return n;
        for(let t = 0, o = 0; t < $785da19a645c07eb$var$Sy; t++, o += 4){
            if (r < $785da19a645c07eb$var$ky[o + 1] || r > $785da19a645c07eb$var$ky[o + 3] || $785da19a645c07eb$var$ky[o] > a || $785da19a645c07eb$var$ky[o + 2] <= s) continue;
            let l = $785da19a645c07eb$var$Dy(t);
            n = $785da19a645c07eb$var$Py(t);
            do {
                if (n.prev.next === n) {
                    if ($785da19a645c07eb$var$Gy(e1, n.next)) return n.next;
                    if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                        let e1 = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                        if (e1 <= a && e1 > s && (s = e1, i = n.x < n.next.x ? n : n.next, e1 === a)) return i;
                    }
                }
                n = n.next;
            }while (n !== l);
        }
        if (!i) return null;
        let o = i.x, l = i.y, c = Math.min(r, l), u = Math.max(r, l), h = 1 / 0;
        for(let t = 0, d = 0; t < $785da19a645c07eb$var$Sy; t++, d += 4){
            if ($785da19a645c07eb$var$ky[d + 2] < o || $785da19a645c07eb$var$ky[d] > a || $785da19a645c07eb$var$ky[d + 3] < c || $785da19a645c07eb$var$ky[d + 1] > u) continue;
            let p = $785da19a645c07eb$var$Dy(t);
            n = $785da19a645c07eb$var$Py(t);
            do {
                if (n.prev.next === n && a >= n.x && n.x >= o && a !== n.x && $785da19a645c07eb$var$jy(r < l ? a : s, r, o, l, r < l ? s : a, r, n.x, n.y)) {
                    let t = Math.abs(r - n.y) / (a - n.x);
                    ($785da19a645c07eb$var$Zy(n, e1) || n.y === r && n.next.y === r && n.next.x > a) && (t < h || t === h && (n.x > i.x || n.x === i.x && $785da19a645c07eb$var$Iy(i, n))) && (i = n, h = t);
                }
                n = n.next;
            }while (n !== p);
        }
        return i;
    }(e1, t);
    if (!i) return t;
    let n = $785da19a645c07eb$var$Ky(i, e1);
    return $785da19a645c07eb$var$Ty(i, n.next.next), $785da19a645c07eb$var$fy(n, n.next), $785da19a645c07eb$var$fy(i, i.next);
}
let $785da19a645c07eb$var$ky = new Float64Array, $785da19a645c07eb$var$Sy = 0;
const $785da19a645c07eb$var$My = [], $785da19a645c07eb$var$Cy = [];
function $785da19a645c07eb$var$Ty(e1, t) {
    let i = e1;
    do {
        let e1 = $785da19a645c07eb$var$Sy++;
        $785da19a645c07eb$var$My[e1] = i;
        let n = 1 / 0, a = 1 / 0, r = -1 / 0, s = -1 / 0, o = 0;
        do {
            let t = i.next;
            i.z = e1, i.x < n && (n = i.x), i.x > r && (r = i.x), i.y < a && (a = i.y), i.y > s && (s = i.y), t.x < n && (n = t.x), t.x > r && (r = t.x), t.y < a && (a = t.y), t.y > s && (s = t.y), i = t;
        }while (++o < 16 && i !== t);
        $785da19a645c07eb$var$Cy[e1] = i;
        let l = 4 * e1;
        $785da19a645c07eb$var$ky[l] = n, $785da19a645c07eb$var$ky[l + 1] = a, $785da19a645c07eb$var$ky[l + 2] = r, $785da19a645c07eb$var$ky[l + 3] = s;
    }while (i !== t);
}
function $785da19a645c07eb$var$Dy(e1) {
    let t = $785da19a645c07eb$var$Cy[e1];
    for(; t.prev.next !== t;)t = t.next;
    return $785da19a645c07eb$var$Cy[e1] = t, t;
}
function $785da19a645c07eb$var$Py(e1) {
    let t = $785da19a645c07eb$var$My[e1];
    for(; t.prev.next !== t;)t = t.next;
    return $785da19a645c07eb$var$My[e1] = t, t;
}
function $785da19a645c07eb$var$Iy(e1, t) {
    return $785da19a645c07eb$var$qy(e1.prev, e1, t.prev) < 0 && $785da19a645c07eb$var$qy(t.next, e1, e1.next) < 0;
}
const $785da19a645c07eb$var$Fy = [];
let $785da19a645c07eb$var$zy = [], $785da19a645c07eb$var$Ry = new Uint32Array, $785da19a645c07eb$var$Ly = new Uint32Array;
const $785da19a645c07eb$var$By = new Uint32Array(256);
function $785da19a645c07eb$var$Oy(e1, t, i, n, a, r) {
    $785da19a645c07eb$var$By.fill(0);
    for(let t = 0; t < e1; t++)$785da19a645c07eb$var$By[i[t] >>> r & 255]++;
    let s = 0;
    for(let e1 = 0; e1 < 256; e1++){
        let t = $785da19a645c07eb$var$By[e1];
        $785da19a645c07eb$var$By[e1] = s, s += t;
    }
    for(let s = 0; s < e1; s++){
        let e1 = i[s], o = $785da19a645c07eb$var$By[e1 >>> r & 255]++;
        n[o] = t[s], a[o] = e1;
    }
}
function $785da19a645c07eb$var$Uy(e1, t, i, n, a) {
    return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - i) * a | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - n) * a | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}
function $785da19a645c07eb$var$Ny(e1) {
    let t = e1, i = e1;
    do (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t), t = t.next;
    while (t !== e1);
    return i;
}
function $785da19a645c07eb$var$jy(e1, t, i, n, a, r, s, o) {
    return (a - s) * (t - o) >= (e1 - s) * (r - o) && (e1 - s) * (n - o) >= (i - s) * (t - o) && (i - s) * (r - o) >= (a - s) * (n - o);
}
function $785da19a645c07eb$var$Vy(e1, t) {
    let i = $785da19a645c07eb$var$Gy(e1, t) && $785da19a645c07eb$var$qy(e1.prev, e1, e1.next) > 0 && $785da19a645c07eb$var$qy(t.prev, t, t.next) > 0;
    return e1.next.i !== t.i && (i || $785da19a645c07eb$var$Zy(e1, t) && $785da19a645c07eb$var$Zy(t, e1) && (0 !== $785da19a645c07eb$var$qy(e1.prev, e1, t.prev) || 0 !== $785da19a645c07eb$var$qy(e1, t.prev, t))) && !function(e1, t) {
        let i = Math.min(e1.x, t.x), n = Math.max(e1.x, t.x), a = Math.min(e1.y, t.y), r = Math.max(e1.y, t.y), s = e1;
        do {
            let o = s.next;
            if (s.x > n && o.x > n || s.x < i && o.x < i || s.y > r && o.y > r || s.y < a && o.y < a) s = o;
            else {
                if (s.i !== e1.i && o.i !== e1.i && s.i !== t.i && o.i !== t.i && $785da19a645c07eb$var$Hy(s, o, e1, t)) return !0;
                s = o;
            }
        }while (s !== e1);
        return !1;
    }(e1, t) && (i || function(e1, t) {
        let i = e1, n = !1, a = (e1.x + t.x) / 2, r = (e1.y + t.y) / 2;
        do {
            let e1 = i.next;
            i.y > r != e1.y > r && a < (e1.x - i.x) * (r - i.y) / (e1.y - i.y) + i.x && (n = !n), i = e1;
        }while (i !== e1);
        return n;
    }(e1, t));
}
function $785da19a645c07eb$var$qy(e1, t, i) {
    return (t.y - e1.y) * (i.x - t.x) - (t.x - e1.x) * (i.y - t.y);
}
function $785da19a645c07eb$var$Gy(e1, t) {
    return e1.x === t.x && e1.y === t.y;
}
function $785da19a645c07eb$var$Hy(e1, t, i, n, a = !0) {
    let r = $785da19a645c07eb$var$qy(e1, t, i), s = $785da19a645c07eb$var$qy(e1, t, n), o = $785da19a645c07eb$var$qy(i, n, e1), l = $785da19a645c07eb$var$qy(i, n, t);
    return (r > 0 && s < 0 || r < 0 && s > 0) && (o > 0 && l < 0 || o < 0 && l > 0) || !!a && !!(0 === r && $785da19a645c07eb$var$Wy(e1, i, t) || 0 === s && $785da19a645c07eb$var$Wy(e1, n, t) || 0 === o && $785da19a645c07eb$var$Wy(i, e1, n) || 0 === l && $785da19a645c07eb$var$Wy(i, t, n));
}
function $785da19a645c07eb$var$Wy(e1, t, i) {
    return t.x <= Math.max(e1.x, i.x) && t.x >= Math.min(e1.x, i.x) && t.y <= Math.max(e1.y, i.y) && t.y >= Math.min(e1.y, i.y);
}
function $785da19a645c07eb$var$Zy(e1, t) {
    return $785da19a645c07eb$var$qy(e1.prev, e1, e1.next) < 0 ? $785da19a645c07eb$var$qy(e1, t, e1.next) >= 0 && $785da19a645c07eb$var$qy(e1, e1.prev, t) >= 0 : $785da19a645c07eb$var$qy(e1, t, e1.prev) < 0 || $785da19a645c07eb$var$qy(e1, e1.next, t) < 0;
}
function $785da19a645c07eb$var$Ky(e1, t) {
    let i = $785da19a645c07eb$var$Yy(e1.i, e1.x, e1.y), n = $785da19a645c07eb$var$Yy(t.i, t.x, t.y), a = e1.next, r = t.prev;
    return e1.next = t, t.prev = e1, i.next = a, a.prev = i, n.next = i, i.prev = n, r.next = n, n.prev = r, n;
}
function $785da19a645c07eb$var$Xy(e1, t, i, n) {
    let a = $785da19a645c07eb$var$Yy(e1, t, i);
    return n ? (a.next = n.next, a.prev = n, n.next.prev = a, n.next = a) : (a.prev = a, a.next = a), a;
}
function $785da19a645c07eb$var$Qy(e1) {
    e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ), $785da19a645c07eb$var$by && function(e1, t) {
        let i = 4 * e1.z;
        t.x < $785da19a645c07eb$var$ky[i] && ($785da19a645c07eb$var$ky[i] = t.x), t.y < $785da19a645c07eb$var$ky[i + 1] && ($785da19a645c07eb$var$ky[i + 1] = t.y), t.x > $785da19a645c07eb$var$ky[i + 2] && ($785da19a645c07eb$var$ky[i + 2] = t.x), t.y > $785da19a645c07eb$var$ky[i + 3] && ($785da19a645c07eb$var$ky[i + 3] = t.y);
    }(e1.prev, e1.next);
}
function $785da19a645c07eb$var$Yy(e1, t, i) {
    return {
        i: e1,
        x: t,
        y: i,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null
    };
}
var $785da19a645c07eb$var$Jy = class {
    constructor(e1, t){
        if (t > e1) throw Error("Min granularity must not be greater than base granularity.");
        this._baseZoomGranularity = e1, this._minGranularity = t;
    }
    getGranularityForZoomLevel(e1) {
        let t = 1 << e1;
        return Math.max(Math.floor(this._baseZoomGranularity / t), this._minGranularity, 1);
    }
}, $785da19a645c07eb$var$$y = class e1 {
    constructor(e1){
        this.fill = e1.fill, this.line = e1.line, this.tile = e1.tile, this.stencil = e1.stencil, this.circle = e1.circle;
    }
    static{
        this.noSubdivision = new e1({
            fill: new $785da19a645c07eb$var$Jy(0, 0),
            line: new $785da19a645c07eb$var$Jy(0, 0),
            tile: new $785da19a645c07eb$var$Jy(0, 0),
            stencil: new $785da19a645c07eb$var$Jy(0, 0),
            circle: 1
        });
    }
};
$785da19a645c07eb$var$qf("SubdivisionGranularityExpression", $785da19a645c07eb$var$Jy), $785da19a645c07eb$var$qf("SubdivisionGranularitySetting", $785da19a645c07eb$var$$y);
const $785da19a645c07eb$var$ex = -32768, $785da19a645c07eb$var$tx = 32767;
var $785da19a645c07eb$var$ix = class {
    constructor(e1, t){
        this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = e1, this._granularityCellSize = $785da19a645c07eb$var$Vu / e1, this._canonical = t;
    }
    _getKey(e1, t) {
        return (e1 += 32768) << 16 | (t += 32768);
    }
    _vertexToIndex(e1, t) {
        if (e1 < -32768 || t < -32768 || e1 > 32767 || t > 32767) throw Error("Vertex coordinates are out of signed 16 bit integer range.");
        let i = 0 | Math.round(e1), n = 0 | Math.round(t), a = this._getKey(i, n);
        if (this._vertexDictionary.has(a)) return this._vertexDictionary.get(a);
        let r = this._vertexBuffer.length / 2;
        return this._vertexDictionary.set(a, r), this._vertexBuffer.push(i, n), r;
    }
    _subdivideTrianglesScanline(e1) {
        if (this._granularity < 2) return function(e1, t) {
            let i = [];
            for(let n = 0; n < t.length; n += 3){
                let a = t[n], r = t[n + 1], s = t[n + 2], o = e1[2 * a], l = e1[2 * a + 1], c = e1[2 * r], u = e1[2 * r + 1], h = e1[2 * s];
                (c - o) * (e1[2 * s + 1] - l) - (u - l) * (h - o) > 0 ? (i.push(a), i.push(s), i.push(r)) : (i.push(a), i.push(r), i.push(s));
            }
            return i;
        }(this._vertexBuffer, e1);
        let t = [], i = e1.length;
        for(let n = 0; n < i; n += 3){
            let i = [
                e1[n + 0],
                e1[n + 1],
                e1[n + 2]
            ], a = [
                this._vertexBuffer[2 * e1[n + 0] + 0],
                this._vertexBuffer[2 * e1[n + 0] + 1],
                this._vertexBuffer[2 * e1[n + 1] + 0],
                this._vertexBuffer[2 * e1[n + 1] + 1],
                this._vertexBuffer[2 * e1[n + 2] + 0],
                this._vertexBuffer[2 * e1[n + 2] + 1]
            ], r = 1 / 0, s = 1 / 0, o = -1 / 0, l = -1 / 0;
            for(let e1 = 0; e1 < 3; e1++){
                let t = a[2 * e1], i = a[2 * e1 + 1];
                r = Math.min(r, t), o = Math.max(o, t), s = Math.min(s, i), l = Math.max(l, i);
            }
            if (r === o || s === l) continue;
            let c = Math.floor(r / this._granularityCellSize), u = Math.ceil(o / this._granularityCellSize), h = Math.floor(s / this._granularityCellSize), d = Math.ceil(l / this._granularityCellSize);
            if (c !== u || h !== d) for(let e1 = h; e1 < d; e1++){
                let n = this._scanlineGenerateVertexRingForCellRow(e1, a, i);
                $785da19a645c07eb$var$rx(this._vertexBuffer, n, t);
            }
            else t.push(...i);
        }
        return t;
    }
    _scanlineGenerateVertexRingForCellRow(e1, t, i) {
        let n = e1 * this._granularityCellSize, a = n + this._granularityCellSize, r = [];
        for(let e1 = 0; e1 < 3; e1++){
            let s = t[2 * e1], o = t[2 * e1 + 1], l = t[2 * (e1 + 1) % 6], c = t[(2 * (e1 + 1) + 1) % 6], u = t[2 * (e1 + 2) % 6], h = t[(2 * (e1 + 2) + 1) % 6], d = l - s, p = c - o, m = 0 === d, g = 0 === p, f = (n - o) / p, A = (a - o) / p, _ = Math.min(f, A), v = Math.max(f, A);
            if (!g && (_ >= 1 || v <= 0) || g && (o < n || o > a)) {
                c >= n && c <= a && r.push(i[(e1 + 1) % 3]);
                continue;
            }
            if (!g && _ > 0) {
                let e1 = s + d * _, t = o + p * _;
                r.push(this._vertexToIndex(e1, t));
            }
            let y = s + d * Math.max(_, 0), x = s + d * Math.min(v, 1);
            if (m || this._generateIntraEdgeVertices(r, s, o, l, c, y, x), !g && v < 1) {
                let e1 = s + d * v, t = o + p * v;
                r.push(this._vertexToIndex(e1, t));
            }
            (g || c >= n && c <= a) && r.push(i[(e1 + 1) % 3]), !g && (c <= n || c >= a) && this._generateInterEdgeVertices(r, s, o, l, c, u, h, x, n, a);
        }
        return r;
    }
    _generateIntraEdgeVertices(e1, t, i, n, a, r, s) {
        let o = n - t, l = a - i, c = 0 === l, u = c ? Math.min(t, n) : Math.min(r, s), h = c ? Math.max(t, n) : Math.max(r, s), d = Math.floor(u / this._granularityCellSize) + 1, p = Math.ceil(h / this._granularityCellSize) - 1;
        if (c ? t < n : r < s) for(let n = d; n <= p; n++){
            let a = n * this._granularityCellSize, r = i + l * (a - t) / o;
            e1.push(this._vertexToIndex(a, r));
        }
        else for(let n = p; n >= d; n--){
            let a = n * this._granularityCellSize, r = i + l * (a - t) / o;
            e1.push(this._vertexToIndex(a, r));
        }
    }
    _generateInterEdgeVertices(e1, t, i, n, a, r, s, o, l, c) {
        let u = a - i, h = r - n, d = s - a, p = (l - a) / d, m = (c - a) / d, g = Math.min(p, m), f = Math.max(p, m), A = n + h * g, _ = Math.floor(Math.min(A, o) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(A, o) / this._granularityCellSize) - 1, y = o < A, x = 0 === d;
        if (x && (s === l || s === c)) return;
        if (x || g >= 1 || f <= 0) {
            let e1 = i - s, n = (l - s) / e1, a = (c - s) / e1, u = r + (t - r) * Math.min(n, a);
            _ = Math.floor(Math.min(u, o) / this._granularityCellSize) + 1, v = Math.ceil(Math.max(u, o) / this._granularityCellSize) - 1, y = o < u;
        }
        let b = u > 0 ? c : l;
        if (y) for(let t = _; t <= v; t++){
            let i = t * this._granularityCellSize;
            e1.push(this._vertexToIndex(i, b));
        }
        else for(let t = v; t >= _; t--){
            let i = t * this._granularityCellSize;
            e1.push(this._vertexToIndex(i, b));
        }
    }
    _generateOutline(e1) {
        let t = [];
        for (let i of e1){
            let e1 = $785da19a645c07eb$var$ax(i, this._granularity, !0), n = this._pointArrayToIndices(e1), a = [];
            for(let e1 = 1; e1 < n.length; e1++)a.push(n[e1 - 1]), a.push(n[e1]);
            t.push(a);
        }
        return t;
    }
    _handlePoles(e1) {
        let t = !1, i = !1;
        this._canonical && (0 === this._canonical.y && (t = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (i = !0)), (t || i) && this._fillPoles(e1, t, i);
    }
    _ensureNoPoleVertices() {
        let e1 = this._vertexBuffer;
        for(let t = 0; t < e1.length; t += 2){
            let i = e1[t + 1];
            -32768 === i && (e1[t + 1] = -32767), 32767 === i && (e1[t + 1] = 32766);
        }
    }
    _generatePoleQuad(e1, t, i, n, a, r) {
        n > a == (-32768 === r) ? (e1.push(i), e1.push(t), e1.push(this._vertexToIndex(n, r)), e1.push(this._vertexToIndex(a, r)), e1.push(i), e1.push(this._vertexToIndex(n, r))) : (e1.push(t), e1.push(i), e1.push(this._vertexToIndex(n, r)), e1.push(i), e1.push(this._vertexToIndex(a, r)), e1.push(this._vertexToIndex(n, r)));
    }
    _fillPoles(e1, t, i) {
        let n = this._vertexBuffer, a = $785da19a645c07eb$var$Vu, r = e1.length;
        for(let s = 2; s < r; s += 3){
            let r = e1[s - 2], o = e1[s - 1], l = e1[s], c = n[2 * r], u = n[2 * r + 1], h = n[2 * o], d = n[2 * o + 1], p = n[2 * l], m = n[2 * l + 1];
            t && (0 === u && 0 === d && this._generatePoleQuad(e1, r, o, c, h, $785da19a645c07eb$var$ex), 0 === d && 0 === m && this._generatePoleQuad(e1, o, l, h, p, $785da19a645c07eb$var$ex), 0 === m && 0 === u && this._generatePoleQuad(e1, l, r, p, c, $785da19a645c07eb$var$ex)), i && (u === a && d === a && this._generatePoleQuad(e1, r, o, c, h, $785da19a645c07eb$var$tx), d === a && m === a && this._generatePoleQuad(e1, o, l, h, p, $785da19a645c07eb$var$tx), m === a && u === a && this._generatePoleQuad(e1, l, r, p, c, $785da19a645c07eb$var$tx));
        }
    }
    _initializeVertices(e1) {
        for(let t = 0; t < e1.length; t += 2)this._vertexToIndex(e1[t], e1[t + 1]);
    }
    subdividePolygonInternal(e1, t) {
        if (this._used) throw Error("Subdivision: multiple use not allowed.");
        this._used = !0;
        let i, { flattened: n, holeIndices: a } = function(e1) {
            let t = [], i = [];
            for (let n of e1)if (0 !== n.length) {
                n !== e1[0] && t.push(i.length / 2);
                for (let e1 of n)i.push(e1.x), i.push(e1.y);
            }
            return {
                flattened: i,
                holeIndices: t
            };
        }(e1);
        this._initializeVertices(n);
        try {
            let e1 = $785da19a645c07eb$var$my(n, a), t = this._convertIndices(n, e1);
            i = this._subdivideTrianglesScanline(t);
        } catch (e1) {
            console.error(e1);
        }
        let r = [];
        return t && (r = this._generateOutline(e1)), this._ensureNoPoleVertices(), this._handlePoles(i), this._granularity >= 2 && 0 === this._canonical?.z && (i = this._removeTrianglesOutsideTileX(i), r = r.map((e1)=>this._removeLinesOutsideTileX(e1))), {
            verticesFlattened: this._vertexBuffer,
            indicesTriangles: i,
            indicesLineList: r
        };
    }
    _vertexOutsideTileX(e1) {
        let t = this._vertexBuffer[2 * e1];
        return t < 0 || t > 8192;
    }
    _removeTrianglesOutsideTileX(e1) {
        let t = [];
        for(let i = 0; i < e1.length; i += 3)this._vertexOutsideTileX(e1[i]) || this._vertexOutsideTileX(e1[i + 1]) || this._vertexOutsideTileX(e1[i + 2]) || t.push(e1[i], e1[i + 1], e1[i + 2]);
        return t;
    }
    _removeLinesOutsideTileX(e1) {
        let t = [];
        for(let i = 0; i < e1.length; i += 2)this._vertexOutsideTileX(e1[i]) || this._vertexOutsideTileX(e1[i + 1]) || t.push(e1[i], e1[i + 1]);
        return t;
    }
    _convertIndices(e1, t) {
        let i = [];
        for (let n of t){
            let t = e1[2 * n], a = e1[2 * n + 1];
            i.push(this._vertexToIndex(t, a));
        }
        return i;
    }
    _pointArrayToIndices(e1) {
        let t = [];
        for (let i of e1)t.push(this._vertexToIndex(i.x, i.y));
        return t;
    }
};
function $785da19a645c07eb$var$nx(e1, t, i, n = !0) {
    return new $785da19a645c07eb$var$ix(i, t).subdividePolygonInternal(e1, n);
}
function $785da19a645c07eb$var$ax(e1, t, i = !1) {
    if (!e1 || e1.length < 1 || e1.length < 2) return [];
    let n = e1[0], a = e1[e1.length - 1], r = i && (n.x !== a.x || n.y !== a.y);
    if (t < 2) return r ? [
        ...e1,
        e1[0]
    ] : [
        ...e1
    ];
    let s = Math.floor($785da19a645c07eb$var$Vu / t), o = [];
    o.push(new $785da19a645c07eb$var$Kc(e1[0].x, e1[0].y));
    let l = e1.length, c = r ? l : l - 1;
    for(let t = 0; t < c; t++){
        let i = e1[t], n = t < l - 1 ? e1[t + 1] : e1[0], a = i.x, r = i.y, c = n.x, u = n.y, h = a !== c, d = r !== u;
        if (!h && !d) continue;
        let p = c - a, m = u - r, g = Math.abs(p), f = Math.abs(m), A = a, _ = r;
        for(;;){
            let e1 = p > 0 ? (Math.floor(A / s) + 1) * s : (Math.ceil(A / s) - 1) * s, t = m > 0 ? (Math.floor(_ / s) + 1) * s : (Math.ceil(_ / s) - 1) * s, i = Math.abs(A - e1), n = Math.abs(_ - t), a = Math.abs(A - c), r = Math.abs(_ - u), l = h ? i / g : 1 / 0, v = d ? n / f : 1 / 0;
            if ((a <= i || !h) && (r <= n || !d)) break;
            if (l < v && h || !d) {
                A = e1, _ += m * l;
                let t = new $785da19a645c07eb$var$Kc(A, Math.round(_));
                (o[o.length - 1].x !== t.x || o[o.length - 1].y !== t.y) && o.push(t);
            } else {
                A += p * v, _ = t;
                let e1 = new $785da19a645c07eb$var$Kc(Math.round(A), _);
                (o[o.length - 1].x !== e1.x || o[o.length - 1].y !== e1.y) && o.push(e1);
            }
        }
        let v = new $785da19a645c07eb$var$Kc(c, u);
        (o[o.length - 1].x !== v.x || o[o.length - 1].y !== v.y) && o.push(v);
    }
    return o;
}
function $785da19a645c07eb$var$rx(e1, t, i) {
    if (0 === t.length) throw Error("Subdivision vertex ring is empty.");
    let n = 0, a = e1[2 * t[0]];
    for(let i = 1; i < t.length; i++){
        let r = e1[2 * t[i]];
        r < a && (a = r, n = i);
    }
    let r = t.length, s = n, o = (s + 1) % r;
    for(;;){
        let n = s - 1 >= 0 ? s - 1 : r - 1, a = (o + 1) % r, l = e1[2 * t[n]], c = e1[2 * t[n] + 1], u = e1[2 * t[a]], h = e1[2 * t[a] + 1], d = e1[2 * t[s]], p = e1[2 * t[s] + 1], m = e1[2 * t[o]], g = e1[2 * t[o] + 1], f = !1;
        if (l < u) f = !0;
        else if (l > u) f = !1;
        else {
            let e1 = g - p, t = -(m - d), i = p < g ? 1 : -1;
            ((l - d) * e1 + (c - p) * t) * i > ((u - d) * e1 + (h - p) * t) * i && (f = !0);
        }
        if (f) {
            let e1 = t[n], a = t[s], l = t[o];
            e1 !== a && e1 !== l && a !== l && i.push(l, a, e1), s--, s < 0 && (s = r - 1);
        } else {
            let e1 = t[a], n = t[s], l = t[o];
            e1 !== n && e1 !== l && n !== l && i.push(l, n, e1), o++, o >= r && (o = 0);
        }
        if (n === a) break;
    }
}
function $785da19a645c07eb$var$sx(e1, t, i, n, a, r, s, o, l) {
    let c = a.length / 2, u = s && o && l;
    if (c < $785da19a645c07eb$var$T_.MAX_VERTEX_ARRAY_LENGTH) {
        let h, d, p = t.prepareSegment(c, i, n), m = p.vertexLength;
        for(let e1 = 0; e1 < r.length; e1 += 3)n.emplaceBack(m + r[e1], m + r[e1 + 1], m + r[e1 + 2]);
        p.vertexLength += c, p.primitiveLength += r.length / 3, u && (d = s.prepareSegment(c, i, o), h = d.vertexLength, d.vertexLength += c);
        for(let t = 0; t < a.length; t += 2)e1(a[t], a[t + 1]);
        if (u) for (let e1 of l){
            for(let t = 1; t < e1.length; t += 2)o.emplaceBack(h + e1[t - 1], h + e1[t]);
            d.primitiveLength += e1.length / 2;
        }
    } else (function(e1, t, i, n, a, r) {
        let s = [];
        for(let e1 = 0; e1 < n.length / 2; e1++)s.push(-1);
        let o = {
            count: 0
        }, l = 0, c = e1.getOrCreateLatestSegment(t, i), u = c.vertexLength;
        for(let h = 2; h < a.length; h += 3){
            let d = a[h - 2], p = a[h - 1], m = a[h], g = s[d] < l, f = s[p] < l, A = s[m] < l, _ = +!!g + +!!f + +!!A;
            c.vertexLength + _ > $785da19a645c07eb$var$T_.MAX_VERTEX_ARRAY_LENGTH && (c = e1.createNewSegment(t, i), l = o.count, g = !0, f = !0, A = !0, u = 0);
            let v = $785da19a645c07eb$var$ox(s, n, r, o, d, g, c), y = $785da19a645c07eb$var$ox(s, n, r, o, p, f, c), x = $785da19a645c07eb$var$ox(s, n, r, o, m, A, c);
            i.emplaceBack(u + v - l, u + y - l, u + x - l), c.primitiveLength++;
        }
    })(t, i, n, a, r, e1), u && function(e1, t, i, n, a, r) {
        let s = [];
        for(let e1 = 0; e1 < n.length / 2; e1++)s.push(-1);
        let o = {
            count: 0
        }, l = 0, c = e1.getOrCreateLatestSegment(t, i), u = c.vertexLength;
        for (let h of a)for(let a = 1; a < h.length; a += 2){
            let d = h[a - 1], p = h[a], m = s[d] < l, g = s[p] < l, f = +!!m + +!!g;
            c.vertexLength + f > $785da19a645c07eb$var$T_.MAX_VERTEX_ARRAY_LENGTH && (c = e1.createNewSegment(t, i), l = o.count, m = !0, g = !0, u = 0);
            let A = $785da19a645c07eb$var$ox(s, n, r, o, d, m, c), _ = $785da19a645c07eb$var$ox(s, n, r, o, p, g, c);
            i.emplaceBack(u + A - l, u + _ - l), c.primitiveLength++;
        }
    }(s, i, o, a, l, e1), t.forceNewSegmentOnNextPrepare(), s?.forceNewSegmentOnNextPrepare();
}
function $785da19a645c07eb$var$ox(e1, t, i, n, a, r, s) {
    if (r) {
        let r = n.count;
        return i(t[2 * a], t[2 * a + 1]), e1[a] = n.count, n.count++, s.vertexLength++, r;
    }
    return e1[a];
}
var $785da19a645c07eb$var$lx = class {
    constructor(e1){
        this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.sdfPatterns = {}, this.patternFeatures = [], this.layoutVertexArray = new $785da19a645c07eb$var$d_, this.indexArray = new $785da19a645c07eb$var$k_, this.indexArray2 = new $785da19a645c07eb$var$S_, this.programConfigurations = new $785da19a645c07eb$var$sv(e1.layers, e1.zoom), this.segments = new $785da19a645c07eb$var$T_, this.segments2 = new $785da19a645c07eb$var$T_, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
    }
    populate(e1, t, i) {
        this.hasDependencies = $785da19a645c07eb$var$uy("fill", this.layers, t);
        let n = this.layers[0].layout.get("fill-sort-key"), a = !n.isConstant(), r = [], s = new $785da19a645c07eb$var$Qf(this.zoom), o = this.layers[0]._featureFilter.needGeometry;
        for (let { feature: l, id: c, index: u, sourceLayerIndex: h } of e1){
            let e1 = $785da19a645c07eb$var$dv(l, o);
            if (!this.layers[0]._featureFilter.filter(s, e1, i)) continue;
            let d = a ? n.evaluate(e1, {}, i, t.availableImages) : void 0, p = {
                id: c,
                properties: l.properties,
                type: l.type,
                sourceLayerIndex: h,
                index: u,
                geometry: o ? e1.geometry : $785da19a645c07eb$var$hv(l),
                patterns: {},
                sortKey: d
            };
            r.push(p);
        }
        a && r.sort((e1, t)=>e1.sortKey - t.sortKey);
        for (let n of r){
            let { geometry: a, index: r, sourceLayerIndex: s } = n;
            if (this.hasDependencies) {
                let e1 = $785da19a645c07eb$var$hy("fill", this.layers, n, {
                    zoom: this.zoom
                }, t);
                this.patternFeatures.push(e1);
            } else this.addFeature(n, a, r, i, {}, t.subdivisionGranularity);
            let o = e1[r].feature;
            t.featureIndex.insert(o, a, r, s, this.index);
        }
    }
    update(e1, t, i) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
            imagePositions: i
        });
    }
    addFeatures({ options: e1, canonical: t, patternPositions: i, patternMap: n }) {
        this.detectSdfPatterns(n);
        for (let n of this.patternFeatures)this.addFeature(n, n.geometry, n.index, t, i, e1.subdivisionGranularity);
    }
    detectSdfPatterns(e1) {
        for (let t of this.patternFeatures)for(let i in t.patterns){
            let n = t.patterns[i];
            this.recordSdfPattern(i, e1[n.min]), this.recordSdfPattern(i, e1[n.mid]), this.recordSdfPattern(i, e1[n.max]);
        }
        for (let t of this.layers){
            let i = t.paint.get("fill-pattern").constantOr(null);
            i && (this.recordSdfPattern(t.id, e1[i.from.toString()]), this.recordSdfPattern(t.id, e1[i.to.toString()]));
        }
    }
    recordSdfPattern(e1, t) {
        if (!t) return;
        let i = !0 === t.sdf, n = this.sdfPatterns[e1];
        void 0 === n ? this.sdfPatterns[e1] = i : n !== i && $785da19a645c07eb$var$wh(`Style sheet warning: Cannot mix SDF and non-SDF fill patterns in layer "${e1}"`);
    }
    isEmpty() {
        return 0 === this.layoutVertexArray.length;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e1) {
        this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, $785da19a645c07eb$var$cy), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.indexBuffer2 = e1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(e1), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
    }
    addFeature(e1, t, i, n, a, r) {
        for (let e1 of $785da19a645c07eb$var$Ip(t, 500)){
            let t = $785da19a645c07eb$var$nx(e1, n, r.fill.getGranularityForZoomLevel(n.z)), i = this.layoutVertexArray;
            $785da19a645c07eb$var$sx((e1, t)=>{
                i.emplaceBack(e1, t);
            }, this.segments, this.layoutVertexArray, this.indexArray, t.verticesFlattened, t.indicesTriangles, this.segments2, this.indexArray2, t.indicesLineList);
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {
            imagePositions: a,
            canonical: n
        });
    }
};
let $785da19a645c07eb$var$cx;
$785da19a645c07eb$var$qf("FillBucket", $785da19a645c07eb$var$lx, {
    omit: [
        "layers",
        "patternFeatures"
    ]
});
let $785da19a645c07eb$var$ux;
var $785da19a645c07eb$var$hx = {
    get paint () {
        return $785da19a645c07eb$var$ux ||= new $785da19a645c07eb$var$pA({
            "fill-antialias": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_fill["fill-antialias"], "fill-antialias"),
            "fill-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_fill["fill-opacity"], "fill-opacity"),
            "fill-layer-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_fill["fill-layer-opacity"], "fill-layer-opacity"),
            "fill-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_fill["fill-color"], "fill-color"),
            "fill-outline-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_fill["fill-outline-color"], "fill-outline-color"),
            "fill-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_fill["fill-translate"], "fill-translate"),
            "fill-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_fill["fill-translate-anchor"], "fill-translate-anchor"),
            "fill-pattern": new $785da19a645c07eb$var$uA($785da19a645c07eb$var$od.paint_fill["fill-pattern"], "fill-pattern")
        });
    },
    get layout () {
        return $785da19a645c07eb$var$cx ||= new $785da19a645c07eb$var$pA({
            "fill-sort-key": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_fill["fill-sort-key"], "fill-sort-key")
        });
    }
};
var $785da19a645c07eb$var$dx = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$hx, t);
    }
    recalculate(e1, t) {
        super.recalculate(e1, t);
        let i = this.paint._values["fill-outline-color"];
        "constant" === i.value.kind && void 0 === i.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
    }
    createBucket(e1) {
        return new $785da19a645c07eb$var$lx(e1);
    }
    queryRadius() {
        return $785da19a645c07eb$var$Cv(this.paint.get("fill-translate"));
    }
    queryIntersectsFeature({ queryGeometry: e1, geometry: t, transform: i, pixelsToTileUnits: n }) {
        return $785da19a645c07eb$var$_v($785da19a645c07eb$var$Tv(e1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -i.bearingInRadians, n), t);
    }
    isTileClipped() {
        return !0;
    }
};
const $785da19a645c07eb$var$px = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        components: 2,
        type: "Int16"
    },
    {
        name: "a_normal_ed",
        components: 4,
        type: "Int16"
    }
], 4), $785da19a645c07eb$var$mx = $785da19a645c07eb$var$EA([
    {
        name: "a_centroid",
        components: 2,
        type: "Int16"
    }
], 4), $785da19a645c07eb$var$gx = $785da19a645c07eb$var$px.members;
var $785da19a645c07eb$var$fx = class e1 {
    constructor(){
        this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
    }
    extend(e1) {
        return this.minX = Math.min(this.minX, e1.x), this.minY = Math.min(this.minY, e1.y), this.maxX = Math.max(this.maxX, e1.x), this.maxY = Math.max(this.maxY, e1.y), this;
    }
    expandBy(e1) {
        return this.minX -= e1, this.minY -= e1, this.maxX += e1, this.maxY += e1, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
    }
    shrinkBy(e1) {
        return this.expandBy(-e1);
    }
    map(t) {
        let i = new e1;
        return i.extend(t(new $785da19a645c07eb$var$Kc(this.minX, this.minY))), i.extend(t(new $785da19a645c07eb$var$Kc(this.maxX, this.minY))), i.extend(t(new $785da19a645c07eb$var$Kc(this.minX, this.maxY))), i.extend(t(new $785da19a645c07eb$var$Kc(this.maxX, this.maxY))), i;
    }
    static fromPoints(t) {
        let i = new e1;
        for (let e1 of t)i.extend(e1);
        return i;
    }
    contains(e1) {
        return e1.x >= this.minX && e1.x <= this.maxX && e1.y >= this.minY && e1.y <= this.maxY;
    }
    empty() {
        return this.minX > this.maxX;
    }
    width() {
        return this.maxX - this.minX;
    }
    height() {
        return this.maxY - this.minY;
    }
    covers(e1) {
        return !this.empty() && !e1.empty() && e1.minX >= this.minX && e1.maxX <= this.maxX && e1.minY >= this.minY && e1.maxY <= this.maxY;
    }
    intersects(e1) {
        return !this.empty() && !e1.empty() && e1.minX <= this.maxX && e1.maxX >= this.minX && e1.minY <= this.maxY && e1.maxY >= this.minY;
    }
};
const $785da19a645c07eb$var$Ax = $785da19a645c07eb$var$fx.fromPoints([
    new $785da19a645c07eb$var$Kc(0, 0),
    new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu)
]);
function $785da19a645c07eb$var$_x(e1, t) {
    return e1.x === t.x && (e1.x < 0 || e1.x > 8192) || e1.y === t.y && (e1.y < 0 || e1.y > 8192);
}
function $785da19a645c07eb$var$vx(e1) {
    return e1.every((e1)=>e1.x < 0) || e1.every((e1)=>e1.x > 8192) || e1.every((e1)=>e1.y < 0) || e1.every((e1)=>e1.y > 8192);
}
var $785da19a645c07eb$var$yx = class {
    constructor(e1, t, i, n, a){
        for(this.properties = Object.create(null), this.extent = i, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = a; e1.pos < t;){
            let t = e1.readVarint();
            if (8 === t) this.id = e1.readVarint();
            else if (18 === t) {
                let t = e1.readVarint() + e1.pos;
                for(; e1.pos < t;){
                    let t = n[e1.readVarint()], i = a[e1.readVarint()];
                    this.properties[t] = i;
                }
            } else 24 === t ? this.type = e1.readVarint() : (34 === t && (this._geometry = e1.pos), e1.skip(t));
        }
    }
    loadGeometry() {
        if (this._geometry < 0) throw Error("feature has no geometry");
        let e1 = this._pbf;
        e1.pos = this._geometry;
        let t, i = e1.readVarint() + e1.pos, n = [], a = 1, r = 0, s = 0, o = 0;
        for(; e1.pos < i;){
            if (r <= 0) {
                let t = e1.readVarint();
                if (a = 7 & t, r = t >> 3, 0 === r) continue;
            }
            if (r--, 1 === a) s += e1.readSVarint(), o += e1.readSVarint(), t && n.push(t), t = [
                new $785da19a645c07eb$var$Kc(s, o)
            ];
            else if (2 === a) s += e1.readSVarint(), o += e1.readSVarint(), t && t.push(new $785da19a645c07eb$var$Kc(s, o));
            else {
                if (7 !== a) throw Error(`unknown command ${a}`);
                t && t.push(t[0].clone());
            }
        }
        return t && n.push(t), n;
    }
    bbox() {
        if (this._geometry < 0) throw Error("feature has no geometry");
        let e1 = this._pbf;
        e1.pos = this._geometry;
        let t = e1.readVarint() + e1.pos, i = 1, n = 0, a = 0, r = 0, s = 1 / 0, o = -1 / 0, l = 1 / 0, c = -1 / 0;
        for(; e1.pos < t;){
            if (n <= 0) {
                let t = e1.readVarint();
                if (i = 7 & t, n = t >> 3, 0 === n) continue;
            }
            if (n--, 1 === i || 2 === i) a += e1.readSVarint(), r += e1.readSVarint(), a < s && (s = a), a > o && (o = a), r < l && (l = r), r > c && (c = r);
            else if (7 !== i) throw Error(`unknown command ${i}`);
        }
        return [
            s,
            l,
            o,
            c
        ];
    }
    toGeoJSON(e1, t, i) {
        let n, a = this.extent * 2 ** i, r = this.extent * e1, s = this.extent * t, o = this.loadGeometry();
        function l(e1) {
            return [
                360 * (e1.x + r) / a - 180,
                360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + s) / a) * Math.PI)) - 90
            ];
        }
        function c(e1) {
            return e1.map(l);
        }
        if (1 === this.type) {
            let e1 = [];
            for (let t of o)e1.push(t[0]);
            let t = c(e1);
            n = 1 === e1.length ? {
                type: "Point",
                coordinates: t[0]
            } : {
                type: "MultiPoint",
                coordinates: t
            };
        } else if (2 === this.type) {
            let e1 = o.map(c);
            n = 1 === e1.length ? {
                type: "LineString",
                coordinates: e1[0]
            } : {
                type: "MultiLineString",
                coordinates: e1
            };
        } else {
            if (3 !== this.type) throw Error("unknown feature type");
            {
                let e1 = $785da19a645c07eb$var$xx(o), t = [];
                for (let i of e1)t.push(i.map(c));
                n = 1 === t.length ? {
                    type: "Polygon",
                    coordinates: t[0]
                } : {
                    type: "MultiPolygon",
                    coordinates: t
                };
            }
        }
        let u = {
            type: "Feature",
            geometry: n,
            properties: this.properties
        };
        return null != this.id && (u.id = this.id), u;
    }
};
function $785da19a645c07eb$var$xx(e1) {
    let t = e1.length;
    if (t <= 1) return [
        e1
    ];
    let i, n, a = [];
    for(let r = 0; r < t; r++){
        let t = $785da19a645c07eb$var$bx(e1[r]);
        0 !== t && (void 0 === n && (n = t < 0), n === t < 0 ? (i && a.push(i), i = [
            e1[r]
        ]) : i && i.push(e1[r]));
    }
    return i && a.push(i), a;
}
function $785da19a645c07eb$var$bx(e1) {
    let t = 0;
    for(let i, n, a = 0, r = e1.length, s = r - 1; a < r; s = a++)i = e1[a], n = e1[s], t += (n.x - i.x) * (i.y + n.y);
    return t;
}
$785da19a645c07eb$var$yx.types = [
    "Unknown",
    "Point",
    "LineString",
    "Polygon"
];
var $785da19a645c07eb$var$wx = class {
    constructor(e1, t){
        for(this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], void 0 === t && (t = e1.length); e1.pos < t;){
            let t = e1.readVarint();
            10 === t ? this.name = e1.readString() : 18 === t ? (this._features.push(e1.pos), e1.skip(t)) : 26 === t ? this._keys.push(e1.readString()) : 34 === t ? this._values.push($785da19a645c07eb$var$Ex(e1)) : 40 === t ? this.extent = e1.readVarint() : 120 === t ? this.version = e1.readVarint() : e1.skip(t);
        }
        this.length = this._features.length;
    }
    feature(e1) {
        if (e1 < 0 || e1 >= this._features.length) throw Error("feature index out of bounds");
        this._pbf.pos = this._features[e1];
        let t = this._pbf.readVarint() + this._pbf.pos;
        return new $785da19a645c07eb$var$yx(this._pbf, t, this.extent, this._keys, this._values);
    }
};
function $785da19a645c07eb$var$Ex(e1) {
    let t = null, i = e1.readVarint() + e1.pos;
    for(; e1.pos < i;){
        let i = e1.readVarint();
        t = 10 === i ? e1.readString() : 21 === i ? e1.readFloat() : 25 === i ? e1.readDouble() : 32 === i ? e1.readVarint(!0) : 40 === i ? e1.readVarint() : 48 === i ? e1.readSVarint() : 56 === i ? e1.readBoolean() : (e1.skip(i), null);
    }
    if (null == t) throw Error("unknown feature value");
    return t;
}
var $785da19a645c07eb$var$kx = class {
    constructor(e1, t = e1.length){
        let i = Object.create(null);
        for(; e1.pos < t;){
            let t = e1.readVarint();
            if (26 === t) {
                let t = new $785da19a645c07eb$var$wx(e1, e1.readVarint() + e1.pos);
                t.length && (i[t.name] = t);
            } else e1.skip(t);
        }
        this.layers = i;
    }
};
const $785da19a645c07eb$var$Sx = 6371008.8;
var $785da19a645c07eb$var$Mx = class e1 {
    constructor(e1, t){
        if (isNaN(e1) || isNaN(t)) throw Error(`Invalid LngLat object: (${e1}, ${t})`);
        if (this.lng = +e1, this.lat = +t, this.lat > 90 || this.lat < -90) throw Error("Invalid LngLat latitude value: must be between -90 and 90");
    }
    wrap() {
        return new e1($785da19a645c07eb$var$uh(this.lng, -180, 180), this.lat);
    }
    toArray() {
        return [
            this.lng,
            this.lat
        ];
    }
    toString() {
        return `LngLat(${this.lng}, ${this.lat})`;
    }
    distanceTo(e1) {
        let t = Math.PI / 180, i = this.lat * t, n = e1.lat * t, a = Math.sin(i) * Math.sin(n) + Math.cos(i) * Math.cos(n) * Math.cos((e1.lng - this.lng) * t);
        return $785da19a645c07eb$var$Sx * Math.acos(Math.min(a, 1));
    }
    static convert(t) {
        if (t instanceof e1) return t;
        if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new e1(Number(t[0]), Number(t[1]));
        if (!Array.isArray(t) && "object" == typeof t && t) return new e1(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
        throw Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
    }
};
const $785da19a645c07eb$var$Cx = 2 * Math.PI * $785da19a645c07eb$var$Sx;
function $785da19a645c07eb$var$Tx(e1) {
    return $785da19a645c07eb$var$Cx * Math.cos(e1 * Math.PI / 180);
}
function $785da19a645c07eb$var$Dx(e1) {
    return (180 + e1) / 360;
}
function $785da19a645c07eb$var$Px(e1) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
}
function $785da19a645c07eb$var$Ix(e1, t) {
    return e1 / $785da19a645c07eb$var$Tx(t);
}
function $785da19a645c07eb$var$Fx(e1) {
    return 360 * e1 - 180;
}
function $785da19a645c07eb$var$zx(e1) {
    let t = 180 - 360 * e1;
    return 360 / Math.PI * Math.atan(Math.exp(t * Math.PI / 180)) - 90;
}
function $785da19a645c07eb$var$Rx(e1, t) {
    return e1 * $785da19a645c07eb$var$Tx($785da19a645c07eb$var$zx(t));
}
var $785da19a645c07eb$var$Lx = class e1 {
    constructor(e1, t, i = 0){
        this.x = +e1, this.y = +t, this.z = +i;
    }
    static fromLngLat(t, i = 0) {
        let n = $785da19a645c07eb$var$Mx.convert(t);
        return new e1($785da19a645c07eb$var$Dx(n.lng), $785da19a645c07eb$var$Px(n.lat), $785da19a645c07eb$var$Ix(i, n.lat));
    }
    toLngLat() {
        return new $785da19a645c07eb$var$Mx($785da19a645c07eb$var$Fx(this.x), $785da19a645c07eb$var$zx(this.y));
    }
    toAltitude() {
        return $785da19a645c07eb$var$Rx(this.z, this.y);
    }
    meterInMercatorCoordinateUnits() {
        return 1 / $785da19a645c07eb$var$Cx * function(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }($785da19a645c07eb$var$zx(this.y));
    }
};
const $785da19a645c07eb$var$Bx = 89.25;
function $785da19a645c07eb$var$Ox(e1, t, i) {
    let n = 1 / (1 << i.z);
    return new $785da19a645c07eb$var$Lx(e1 / $785da19a645c07eb$var$Vu * n + i.x * n, t / $785da19a645c07eb$var$Vu * n + i.y * n);
}
function $785da19a645c07eb$var$Ux(e1, t) {
    let i = $785da19a645c07eb$var$ch(t.lat, -85.051129, $785da19a645c07eb$var$Rh);
    return new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$Dx(t.lng) * e1, $785da19a645c07eb$var$Px(i) * e1);
}
function $785da19a645c07eb$var$Nx(e1, t) {
    return new $785da19a645c07eb$var$Lx(t.x / e1, t.y / e1).toLngLat();
}
function $785da19a645c07eb$var$jx(e1) {
    return e1.cameraToCenterDistance * Math.min(.85 * Math.tan($785da19a645c07eb$var$Dh(90 - e1.pitch)), Math.tan($785da19a645c07eb$var$Dh($785da19a645c07eb$var$Bx - e1.pitch)));
}
function $785da19a645c07eb$var$Vx(e1, t) {
    let i = e1.canonical, n = t / $785da19a645c07eb$var$gh(i.z), a = i.x + 2 ** i.z * e1.wrap, r = new Float64Array(16);
    return $785da19a645c07eb$var$nu(r), $785da19a645c07eb$var$su(r, r, [
        a * n,
        i.y * n,
        0
    ]), $785da19a645c07eb$var$ou(r, r, [
        n / $785da19a645c07eb$var$Vu,
        n / $785da19a645c07eb$var$Vu,
        1
    ]), r;
}
function $785da19a645c07eb$var$qx(e1, t, i, n, a) {
    let r = $785da19a645c07eb$var$Lx.fromLngLat(e1, t), s = a * $785da19a645c07eb$var$Ix(1, e1.lat), { x: o, y: l, z: c } = $785da19a645c07eb$var$Gx(i, n), u = s * -o, h = s * -l, d = s * c;
    return new $785da19a645c07eb$var$Lx(r.x + u, r.y + h, r.z + d);
}
function $785da19a645c07eb$var$Gx(e1, t) {
    let i = $785da19a645c07eb$var$Dh(e1), n = $785da19a645c07eb$var$Dh(t), a = Math.cos(-i), r = Math.sin(i);
    return {
        x: r * Math.sin(n),
        y: -r * Math.cos(n),
        z: a
    };
}
function $785da19a645c07eb$var$Hx(e1, t, i) {
    if (t <= 0 || !e1 || 0 === e1.length) return e1;
    let n = function(e1, t) {
        let i = function(e1, t, i) {
            return $785da19a645c07eb$var$Ox(e1, t, i).toLngLat();
        }(4096, 4096, t), n = $785da19a645c07eb$var$Lx.fromLngLat(i).meterInMercatorCoordinateUnits(), a = (1 << t.z) * $785da19a645c07eb$var$Vu;
        return e1 * n * a;
    }(t, i);
    return e1.map((e1)=>(function(e1, t) {
            if (!e1 || e1.length < 3) return e1;
            let i = e1[0].x === e1[e1.length - 1].x && e1[0].y === e1[e1.length - 1].y, n = i ? e1.length - 1 : e1.length;
            if (n < 3) return e1;
            let a = [];
            for(let i = 0; i < n; i++){
                let r = e1[(i - 1 + n) % n], s = e1[i], o = e1[(i + 1) % n];
                $785da19a645c07eb$var$_x(r, s) || $785da19a645c07eb$var$_x(s, o) ? a.push(s.clone()) : $785da19a645c07eb$var$Wx(a, r, s, o, t);
            }
            let r = function(e1) {
                let t = [];
                for (let i of e1){
                    let e1 = i.round(), n = t[t.length - 1];
                    (n?.x !== e1.x || n?.y !== e1.y) && t.push(e1);
                }
                for(; t.length > 1 && t[0].x === t[t.length - 1].x && t[0].y === t[t.length - 1].y;)t.pop();
                return t;
            }(a);
            return r.length < 3 ? e1 : (i && r.push(r[0].clone()), r);
        })(e1, n));
}
function $785da19a645c07eb$var$Wx(e1, t, i, n, a) {
    let r = t.sub(i), s = n.sub(i), o = r.mag(), l = s.mag();
    if (o < 1e-6 || l < 1e-6) return void e1.push(i.clone());
    r._div(o), s._div(l);
    let c = r.x * s.x + r.y * s.y;
    if (Math.abs(c) > Math.cos(5 * Math.PI / 180)) return void e1.push(i.clone());
    let u = Math.min(a, .2 * o, .2 * l), h = i.add(r.mult(u)), d = i.add(s.mult(u)), p = Math.sqrt((1 + c) / 2), m = i.add(r.add(s)._unit()._mult(u / p)), g = h.sub(m).angleWith(d.sub(m)), f = Math.max(2, Math.ceil(Math.abs(g) / (Math.PI / 6) - 1e-6));
    for(let t = 0; t <= f; t++)e1.push(h.rotateAround(t / f * g, m));
}
const $785da19a645c07eb$var$Zx = 8192;
function $785da19a645c07eb$var$Kx(e1, t, i, n, a, r, s, o) {
    e1.emplaceBack(t, i, 2 * Math.floor(n * $785da19a645c07eb$var$Zx) + s, a * $785da19a645c07eb$var$Zx * 2, r * $785da19a645c07eb$var$Zx * 2, Math.round(o));
}
var $785da19a645c07eb$var$Xx = class {
    constructor(e1){
        this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.layoutVertexArray = new $785da19a645c07eb$var$p_, this.centroidVertexArray = new $785da19a645c07eb$var$l_, this.indexArray = new $785da19a645c07eb$var$k_, this.programConfigurations = new $785da19a645c07eb$var$sv(e1.layers, e1.zoom), this.segments = new $785da19a645c07eb$var$T_, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
    }
    populate(e1, t, i) {
        this.features = [], this.hasDependencies = $785da19a645c07eb$var$uy("fill-extrusion", this.layers, t);
        let n = new $785da19a645c07eb$var$Qf(this.zoom), a = this.layers[0], r = a.layout.get("fill-extrusion-rounded-corner-distance"), s = a._featureFilter.needGeometry;
        for (let { feature: o, id: l, index: c, sourceLayerIndex: u } of e1){
            let e1 = $785da19a645c07eb$var$dv(o, s);
            if (!a._featureFilter.filter(n, e1, i)) continue;
            let h = s ? e1.geometry : $785da19a645c07eb$var$hv(o), d = {
                id: l,
                sourceLayerIndex: u,
                index: c,
                geometry: r > 0 ? $785da19a645c07eb$var$Hx(h, r, i) : h,
                properties: o.properties,
                type: o.type,
                patterns: {}
            };
            this.hasDependencies ? this.features.push($785da19a645c07eb$var$hy("fill-extrusion", this.layers, d, {
                zoom: this.zoom
            }, t)) : this.addFeature(d, d.geometry, c, i, {}, t.subdivisionGranularity), t.featureIndex.insert(o, d.geometry, c, u, this.index, !0);
        }
    }
    addFeatures({ options: e1, canonical: t, patternPositions: i }) {
        for (let n of this.features){
            let { geometry: a } = n;
            this.addFeature(n, a, n.index, t, i, e1.subdivisionGranularity);
        }
    }
    update(e1, t, i) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
            imagePositions: i
        });
    }
    isEmpty() {
        return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e1) {
        this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, $785da19a645c07eb$var$gx), this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, $785da19a645c07eb$var$mx.members, !0), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
    }
    addFeature(e1, t, i, n, a, r) {
        let s = this.layers[0], o = s.layout ? s.layout.get("fill-extrusion-rounded-corner-distance") : 0, l = o > 0 ? $785da19a645c07eb$var$Hx(t, o, n) : t;
        for (let t of $785da19a645c07eb$var$Ip(l, 500)){
            let i = {
                x: 0,
                y: 0,
                sampleCount: 0
            }, a = this.layoutVertexArray.length;
            this.processPolygon(i, n, e1, t, r);
            let s = this.layoutVertexArray.length - a, o = Math.floor(i.x / i.sampleCount), l = Math.floor(i.y / i.sampleCount);
            for(let e1 = 0; e1 < s; e1++)this.centroidVertexArray.emplaceBack(o, l);
        }
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {
            imagePositions: a,
            canonical: n
        });
    }
    processPolygon(e1, t, i, n, a) {
        if (n.length < 1 || $785da19a645c07eb$var$vx(n[0])) return;
        for (let t of n)0 !== t.length && $785da19a645c07eb$var$Qx(e1, t);
        let r = {
            segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
        }, s = a.fill.getGranularityForZoomLevel(t.z), o = "Polygon" === $785da19a645c07eb$var$yx.types[i.type];
        for (let e1 of n){
            if (0 === e1.length || $785da19a645c07eb$var$vx(e1)) continue;
            let t = $785da19a645c07eb$var$ax(e1, s, o);
            this._generateSideFaces(t, r);
        }
        if (!o) return;
        let l = $785da19a645c07eb$var$nx(n, t, s, !1), c = this.layoutVertexArray;
        $785da19a645c07eb$var$sx((e1, t)=>{
            $785da19a645c07eb$var$Kx(c, e1, t, 0, 0, 1, 1, 0);
        }, this.segments, this.layoutVertexArray, this.indexArray, l.verticesFlattened, l.indicesTriangles);
    }
    _generateSideFaces(e1, t) {
        let i = 0;
        for(let n = 1; n < e1.length; n++){
            let a = e1[n], r = e1[n - 1];
            if ($785da19a645c07eb$var$_x(a, r)) continue;
            t.segment.vertexLength + 4 > $785da19a645c07eb$var$T_.MAX_VERTEX_ARRAY_LENGTH && (t.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
            let s = a.sub(r)._perp()._unit(), o = r.dist(a);
            i + o > 32768 && (i = 0), $785da19a645c07eb$var$Kx(this.layoutVertexArray, a.x, a.y, s.x, s.y, 0, 0, i), $785da19a645c07eb$var$Kx(this.layoutVertexArray, a.x, a.y, s.x, s.y, 0, 1, i), i += o, $785da19a645c07eb$var$Kx(this.layoutVertexArray, r.x, r.y, s.x, s.y, 0, 0, i), $785da19a645c07eb$var$Kx(this.layoutVertexArray, r.x, r.y, s.x, s.y, 0, 1, i);
            let l = t.segment.vertexLength;
            this.indexArray.emplaceBack(l, l + 2, l + 1), this.indexArray.emplaceBack(l + 1, l + 2, l + 3), t.segment.vertexLength += 4, t.segment.primitiveLength += 2;
        }
    }
};
function $785da19a645c07eb$var$Qx(e1, t) {
    for(let i = 0; i < t.length; i++){
        let n = t[i];
        (i !== t.length - 1 || t[0].x !== n.x || t[0].y !== n.y) && (e1.x += n.x, e1.y += n.y, e1.sampleCount++);
    }
}
let $785da19a645c07eb$var$Yx;
$785da19a645c07eb$var$qf("FillExtrusionBucket", $785da19a645c07eb$var$Xx, {
    omit: [
        "layers",
        "features"
    ]
});
let $785da19a645c07eb$var$Jx;
var $785da19a645c07eb$var$$x = {
    get paint () {
        return $785da19a645c07eb$var$Jx ||= new $785da19a645c07eb$var$pA({
            "fill-extrusion-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-opacity"], "fill-extrusion-opacity"),
            "fill-extrusion-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-color"], "fill-extrusion-color"),
            "fill-extrusion-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-translate"], "fill-extrusion-translate"),
            "fill-extrusion-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-translate-anchor"], "fill-extrusion-translate-anchor"),
            "fill-extrusion-pattern": new $785da19a645c07eb$var$uA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-pattern"], "fill-extrusion-pattern"),
            "fill-extrusion-height": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-height"], "fill-extrusion-height"),
            "fill-extrusion-base": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-base"], "fill-extrusion-base"),
            "fill-extrusion-vertical-gradient": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"], "fill-extrusion-vertical-gradient")
        });
    },
    get layout () {
        return $785da19a645c07eb$var$Yx ||= new $785da19a645c07eb$var$pA({
            "fill-extrusion-rounded-corner-distance": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od["layout_fill-extrusion"]["fill-extrusion-rounded-corner-distance"], "fill-extrusion-rounded-corner-distance")
        });
    }
};
var $785da19a645c07eb$var$eb = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$$x, t);
    }
    createBucket(e1) {
        return new $785da19a645c07eb$var$Xx(e1);
    }
    queryRadius() {
        return $785da19a645c07eb$var$Cv(this.paint.get("fill-extrusion-translate"));
    }
    is3D() {
        return !0;
    }
    queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: i, geometry: n, transform: a, pixelsToTileUnits: r, pixelPosMatrix: s }) {
        let o = $785da19a645c07eb$var$Tv(e1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -a.bearingInRadians, r), l = this.paint.get("fill-extrusion-height").evaluate(t, i), c = this.paint.get("fill-extrusion-base").evaluate(t, i), u = function(e1, t, i) {
            let n = [];
            for (let a of e1){
                let e1 = [
                    a.x,
                    a.y,
                    i,
                    1
                ];
                $785da19a645c07eb$var$Du(e1, e1, t), n.push(new $785da19a645c07eb$var$Kc(e1[0] / e1[3], e1[1] / e1[3]));
            }
            return n;
        }(o, s, 0), h = function(e1, t, i, n) {
            let a = [], r = [], s = n[8] * t, o = n[9] * t, l = n[10] * t, c = n[11] * t, u = n[8] * i, h = n[9] * i, d = n[10] * i, p = n[11] * i;
            for (let t of e1){
                let e1 = [], i = [];
                for (let a of t){
                    let t = a.x, r = a.y, m = n[0] * t + n[4] * r + n[12], g = n[1] * t + n[5] * r + n[13], f = n[2] * t + n[6] * r + n[14], A = n[3] * t + n[7] * r + n[15], _ = f + l, v = A + c, y = m + u, x = g + h, b = f + d, w = A + p, E = new $785da19a645c07eb$var$Kc((m + s) / v, (g + o) / v);
                    E.z = _ / v, e1.push(E);
                    let k = new $785da19a645c07eb$var$Kc(y / w, x / w);
                    k.z = b / w, i.push(k);
                }
                a.push(e1), r.push(i);
            }
            return [
                a,
                r
            ];
        }(n, c, l, s);
        return function(e1, t, i) {
            let n = 1 / 0;
            $785da19a645c07eb$var$_v(i, t) && (n = $785da19a645c07eb$var$ib(i, t[0]));
            for(let a = 0; a < t.length; a++){
                let r = t[a], s = e1[a];
                for(let e1 = 0; e1 < r.length - 1; e1++){
                    let t = r[e1], a = r[e1 + 1], o = s[e1], l = [
                        t,
                        a,
                        s[e1 + 1],
                        o,
                        t
                    ];
                    $785da19a645c07eb$var$fv(i, l) && (n = Math.min(n, $785da19a645c07eb$var$ib(i, l)));
                }
            }
            return n !== 1 / 0 && n;
        }(h[0], h[1], u);
    }
};
function $785da19a645c07eb$var$tb(e1, t) {
    return e1.x * t.x + e1.y * t.y;
}
function $785da19a645c07eb$var$ib(e1, t) {
    if (1 === e1.length) {
        let i, n = 0, a = t[n++];
        for(; !i || a.equals(i);)if (i = t[n++], !i) return 1 / 0;
        for(; n < t.length; n++){
            let r = t[n], s = e1[0], o = i.sub(a), l = r.sub(a), c = s.sub(a), u = $785da19a645c07eb$var$tb(o, o), h = $785da19a645c07eb$var$tb(o, l), d = $785da19a645c07eb$var$tb(l, l), p = $785da19a645c07eb$var$tb(c, o), m = $785da19a645c07eb$var$tb(c, l), g = u * d - h * h, f = (d * p - h * m) / g, A = (u * m - h * p) / g, _ = 1 - f - A, v = a.z * _ + i.z * f + r.z * A;
            if (isFinite(v)) return v;
        }
        return 1 / 0;
    }
    {
        let e1 = 1 / 0;
        for (let i of t)e1 = Math.min(e1, i.z);
        return e1;
    }
}
const $785da19a645c07eb$var$nb = $785da19a645c07eb$var$EA([
    {
        name: "a_pos_normal",
        components: 2,
        type: "Int16"
    },
    {
        name: "a_data",
        components: 4,
        type: "Uint8"
    }
], 4).members, $785da19a645c07eb$var$ab = $785da19a645c07eb$var$EA([
    {
        name: "a_uv_x",
        components: 1,
        type: "Float32"
    },
    {
        name: "a_split_index",
        components: 1,
        type: "Float32"
    }
]).members, $785da19a645c07eb$var$rb = Math.cos(Math.PI / 180 * 37.5);
var $785da19a645c07eb$var$sb = class {
    constructor(e1){
        this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {};
        for (let e1 of this.layers)this.gradients[e1.id] = {};
        this.layoutVertexArray = new $785da19a645c07eb$var$m_, this.layoutVertexArray2 = new $785da19a645c07eb$var$g_, this.indexArray = new $785da19a645c07eb$var$k_, this.programConfigurations = new $785da19a645c07eb$var$sv(e1.layers, e1.zoom), this.segments = new $785da19a645c07eb$var$T_, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
    }
    populate(e1, t, i) {
        this.hasDependencies = $785da19a645c07eb$var$uy("line", this.layers, t) || this.hasLineDasharray(this.layers);
        let n = this.layers[0].layout.get("line-sort-key"), a = !n.isConstant(), r = [], s = new $785da19a645c07eb$var$Qf(this.zoom), o = this.layers[0]._featureFilter.needGeometry;
        for (let { feature: t, id: l, index: c, sourceLayerIndex: u } of e1){
            let e1 = $785da19a645c07eb$var$dv(t, o);
            if (!this.layers[0]._featureFilter.filter(s, e1, i)) continue;
            let h = a ? n.evaluate(e1, {}, i) : void 0, d = {
                id: l,
                properties: t.properties,
                type: t.type,
                sourceLayerIndex: u,
                index: c,
                geometry: o ? e1.geometry : $785da19a645c07eb$var$hv(t),
                patterns: {},
                dashes: {},
                sortKey: h
            };
            r.push(d);
        }
        a && r.sort((e1, t)=>e1.sortKey - t.sortKey);
        for (let n of r){
            let { geometry: a, index: r, sourceLayerIndex: s } = n;
            this.hasDependencies ? ($785da19a645c07eb$var$uy("line", this.layers, t) ? $785da19a645c07eb$var$hy("line", this.layers, n, {
                zoom: this.zoom
            }, t) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, n, this.zoom, t), this.patternFeatures.push(n)) : this.addFeature(n, a, r, i, {}, {}, t.subdivisionGranularity);
            let o = e1[r].feature;
            t.featureIndex.insert(o, a, r, s, this.index);
        }
    }
    update(e1, t, i, n) {
        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(e1, t, this.stateDependentLayers, {
            imagePositions: i,
            dashPositions: n
        });
    }
    addFeatures({ options: e1, canonical: t, patternPositions: i, dashPositions: n }) {
        for (let a of this.patternFeatures)this.addFeature(a, a.geometry, a.index, t, i, n, e1.subdivisionGranularity);
    }
    isEmpty() {
        return 0 === this.layoutVertexArray.length;
    }
    uploadPending() {
        return !this.uploaded || this.programConfigurations.needsUpload;
    }
    upload(e1) {
        this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, $785da19a645c07eb$var$ab)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, $785da19a645c07eb$var$nb), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
    }
    lineFeatureClips(e1) {
        if (e1.properties && Object.hasOwn(e1.properties, "geojsonvt_clip_start") && Object.hasOwn(e1.properties, "geojsonvt_clip_end")) return {
            start: +e1.properties.geojsonvt_clip_start,
            end: +e1.properties.geojsonvt_clip_end
        };
    }
    addFeature(e1, t, i, n, a, r, s) {
        let o = this.layers[0].layout, l = o.get("line-join").evaluate(e1, {}), c = o.get("line-cap").evaluate(e1, {}), u = o.get("line-miter-limit").evaluate(e1, {}), h = o.get("line-round-limit").evaluate(e1, {});
        this.lineClips = this.lineFeatureClips(e1);
        for (let i of t)this.addLine(i, e1, l, c, u, h, n, s);
        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {
            imagePositions: a,
            dashPositions: r,
            canonical: n
        });
    }
    addLine(e1, t, i, n, a, r, s, o) {
        if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, e1 = $785da19a645c07eb$var$ax(e1, s ? o.line.getGranularityForZoomLevel(s.z) : 1), this.lineClips) {
            this.lineClipsArray.push(this.lineClips);
            for(let t = 0; t < e1.length - 1; t++)this.totalDistance += e1[t].dist(e1[t + 1]);
            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
        }
        let l = "Polygon" === $785da19a645c07eb$var$yx.types[t.type], c = e1.length;
        for(; c >= 2 && e1[c - 1].equals(e1[c - 2]);)c--;
        let u = 0;
        for(; u < c - 1 && e1[u].equals(e1[u + 1]);)u++;
        if (c - u < (l ? 3 : 2)) return;
        "bevel" === i && (a = 1.05);
        let h, d, p, m, g, f = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, A = this.segments.prepareSegment(10 * c, this.layoutVertexArray, this.indexArray);
        this.e1 = this.e2 = -1, l && (h = e1[c - 2], g = e1[u].sub(h)._unit()._perp());
        for(let t = u; t < c; t++){
            if (p = t === c - 1 ? l ? e1[u + 1] : void 0 : e1[t + 1], p && e1[t].equals(p)) continue;
            g && (m = g), h && (d = h), h = e1[t], g = p ? p.sub(h)._unit()._perp() : m, m ||= g;
            let s = m.add(g);
            (0 !== s.x || 0 !== s.y) && s._unit();
            let o = m.x * g.x + m.y * g.y, _ = s.x * g.x + s.y * g.y, v = 0 === _ ? 1 / 0 : 1 / _, y = 2 * Math.sqrt(2 - 2 * _), x = _ < $785da19a645c07eb$var$rb && d && p, b = m.x * g.y - m.y * g.x > 0;
            if (x && t > u) {
                let e1 = h.dist(d);
                if (e1 > 2 * f) {
                    let t = h.sub(h.sub(d)._mult(f / e1)._round());
                    this.updateDistance(d, t), this.addCurrentVertex(t, m, 0, 0, A), d = t;
                }
            }
            let w = d && p, E = w ? i : l ? "butt" : n;
            if (w && "round" === E && (v < r ? E = "miter" : v <= 2 && (E = "fakeround")), "miter" === E && v > a && (E = "bevel"), "bevel" === E && (v > 2 && (E = "flipbevel"), v < a && (E = "miter")), d && this.updateDistance(d, h), "miter" === E) s._mult(v), this.addCurrentVertex(h, s, 0, 0, A);
            else if ("flipbevel" === E) {
                if (v > 100) s = g.mult(-1);
                else {
                    let e1 = v * m.add(g).mag() / m.sub(g).mag();
                    s._perp()._mult(e1 * (b ? -1 : 1));
                }
                this.addCurrentVertex(h, s, 0, 0, A), this.addCurrentVertex(h, s.mult(-1), 0, 0, A);
            } else if ("bevel" === E || "fakeround" === E) {
                let e1 = -Math.sqrt(v * v - 1), t = b ? e1 : 0, i = b ? 0 : e1;
                if (d && this.addCurrentVertex(h, m, t, i, A), "fakeround" === E) {
                    let e1 = Math.round(180 * y / Math.PI / 20);
                    for(let t = 1; t < e1; t++){
                        let i = t / e1;
                        if (.5 !== i) {
                            let e1 = i - .5;
                            i += i * e1 * (i - 1) * ((1.0904 + o * (o * (3.55645 - 1.43519 * o) - 3.2452)) * e1 * e1 + (.848013 + o * (.215638 * o - 1.06021)));
                        }
                        let n = g.sub(m)._mult(i)._add(m)._unit()._mult(b ? -1 : 1);
                        this.addHalfVertex(h, n.x, n.y, !1, b, 0, A);
                    }
                }
                p && this.addCurrentVertex(h, g, -t, -i, A);
            } else if ("butt" === E) this.addCurrentVertex(h, s, 0, 0, A);
            else if ("square" === E) {
                let e1 = d ? 1 : -1;
                this.addCurrentVertex(h, s, e1, e1, A);
            } else "round" === E && (d && (this.addCurrentVertex(h, m, 0, 0, A), this.addCurrentVertex(h, m, 1, 1, A, !0)), p && (this.addCurrentVertex(h, g, -1, -1, A, !0), this.addCurrentVertex(h, g, 0, 0, A)));
            if (x && t < c - 1) {
                let e1 = h.dist(p);
                if (e1 > 2 * f) {
                    let t = h.add(p.sub(h)._mult(f / e1)._round());
                    this.updateDistance(h, t), this.addCurrentVertex(t, g, 0, 0, A), h = t;
                }
            }
        }
    }
    addCurrentVertex(e1, t, i, n, a, r = !1) {
        let s = t.x + t.y * i, o = t.y - t.x * i, l = -t.x + t.y * n, c = -t.y - t.x * n;
        this.addHalfVertex(e1, s, o, r, !1, i, a), this.addHalfVertex(e1, l, c, r, !0, -n, a), this.distance > 16384 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(e1, t, i, n, a, r));
    }
    addHalfVertex({ x: e1, y: t }, i, n, a, r, s, o) {
        let l = .5 * (this.lineClips ? 32767 * this.scaledDistance : this.scaledDistance);
        if (this.layoutVertexArray.emplaceBack(+!!a + (e1 << 1), +!!r + (t << 1), Math.round(63 * i) + 128, Math.round(63 * n) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips) {
            let e1 = (this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start);
            this.layoutVertexArray2.emplaceBack(e1, this.lineClipsArray.length);
        }
        let c = o.vertexLength++;
        this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, c, this.e2), o.primitiveLength++), r ? this.e2 = c : this.e1 = c;
    }
    updateScaledDistance() {
        this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
    }
    updateDistance(e1, t) {
        this.distance += e1.dist(t), this.updateScaledDistance();
    }
    hasLineDasharray(e1) {
        for (let t of e1){
            let e1 = t.paint.get("line-dasharray");
            if (e1 && !e1.isConstant()) return !0;
        }
        return !1;
    }
    addLineDashDependencies(e1, t, i, n) {
        for (let a of e1){
            let e1 = a.paint.get("line-dasharray");
            if (!e1 || "constant" === e1.value.kind) continue;
            let r = "round" === a.layout.get("line-cap").evaluate(t, {}), s = {
                dasharray: e1.value.evaluate({
                    zoom: i - 1
                }, t, {}),
                round: r
            }, o = {
                dasharray: e1.value.evaluate({
                    zoom: i
                }, t, {}),
                round: r
            }, l = {
                dasharray: e1.value.evaluate({
                    zoom: i + 1
                }, t, {}),
                round: r
            }, c = `${s.dasharray.join(",")},${s.round}`, u = `${o.dasharray.join(",")},${o.round}`, h = `${l.dasharray.join(",")},${l.round}`;
            n.dashDependencies[c] = s, n.dashDependencies[u] = o, n.dashDependencies[h] = l, t.dashes[a.id] = {
                min: c,
                mid: u,
                max: h
            };
        }
    }
};
let $785da19a645c07eb$var$ob;
$785da19a645c07eb$var$qf("LineBucket", $785da19a645c07eb$var$sb, {
    omit: [
        "layers",
        "patternFeatures"
    ]
});
let $785da19a645c07eb$var$lb;
var $785da19a645c07eb$var$cb = {
    get paint () {
        return $785da19a645c07eb$var$lb ||= new $785da19a645c07eb$var$pA({
            "line-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-opacity"], "line-opacity"),
            "line-layer-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_line["line-layer-opacity"], "line-layer-opacity"),
            "line-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-color"], "line-color"),
            "line-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_line["line-translate"], "line-translate"),
            "line-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_line["line-translate-anchor"], "line-translate-anchor"),
            "line-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-width"], "line-width"),
            "line-gap-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-gap-width"], "line-gap-width"),
            "line-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-offset"], "line-offset"),
            "line-blur": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_line["line-blur"], "line-blur"),
            "line-dasharray": new $785da19a645c07eb$var$uA($785da19a645c07eb$var$od.paint_line["line-dasharray"], "line-dasharray"),
            "line-pattern": new $785da19a645c07eb$var$uA($785da19a645c07eb$var$od.paint_line["line-pattern"], "line-pattern"),
            "line-gradient": new $785da19a645c07eb$var$dA($785da19a645c07eb$var$od.paint_line["line-gradient"], "line-gradient")
        });
    },
    get layout () {
        return $785da19a645c07eb$var$ob ||= new $785da19a645c07eb$var$pA({
            "line-cap": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_line["line-cap"], "line-cap"),
            "line-join": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_line["line-join"], "line-join"),
            "line-miter-limit": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_line["line-miter-limit"], "line-miter-limit"),
            "line-round-limit": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_line["line-round-limit"], "line-round-limit"),
            "line-sort-key": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_line["line-sort-key"], "line-sort-key")
        });
    }
}, $785da19a645c07eb$var$ub = class extends $785da19a645c07eb$var$cA {
    possiblyEvaluate(e1, t) {
        return t = new $785da19a645c07eb$var$Qf(Math.floor(t.zoom), {
            now: t.now,
            fadeDuration: t.fadeDuration,
            zoomHistory: t.zoomHistory,
            transition: t.transition
        }), super.possiblyEvaluate(e1, t);
    }
    evaluate(e1, t, i, n) {
        return t = $785da19a645c07eb$var$hh({}, t, {
            zoom: Math.floor(t.zoom)
        }), super.evaluate(e1, t, i, n);
    }
};
let $785da19a645c07eb$var$hb;
var $785da19a645c07eb$var$db = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$cb, t), this.gradientVersion = 0, $785da19a645c07eb$var$hb || ($785da19a645c07eb$var$hb = new $785da19a645c07eb$var$ub($785da19a645c07eb$var$cb.paint.properties["line-width"].specification, "line-floorwidth"), $785da19a645c07eb$var$hb.useIntegerZoom = !0);
    }
    _handleSpecialPaintPropertyUpdate(e1) {
        if ("line-gradient" === e1) {
            let e1 = this.gradientExpression();
            this.stepInterpolant = !!function(e1) {
                return void 0 !== e1._styleExpression;
            }(e1) && e1._styleExpression.expression instanceof $785da19a645c07eb$var$Ep, this.gradientVersion = (this.gradientVersion + 1) % (2 ** 53 - 1);
        }
    }
    gradientExpression() {
        return this._transitionablePaint._values["line-gradient"].value.expression;
    }
    recalculate(e1, t) {
        super.recalculate(e1, t), this.paint._values["line-floorwidth"] = $785da19a645c07eb$var$hb.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
    }
    createBucket(e1) {
        return new $785da19a645c07eb$var$sb(e1);
    }
    queryRadius(e1) {
        let t = e1, i = $785da19a645c07eb$var$pb($785da19a645c07eb$var$Mv("line-width", this, t), $785da19a645c07eb$var$Mv("line-gap-width", this, t)), n = $785da19a645c07eb$var$Mv("line-offset", this, t);
        return i / 2 + Math.abs(n) + $785da19a645c07eb$var$Cv(this.paint.get("line-translate"));
    }
    queryIntersectsFeature({ queryGeometry: e1, feature: t, featureState: i, geometry: n, transform: a, pixelsToTileUnits: r }) {
        let s = $785da19a645c07eb$var$Tv(e1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -a.bearingInRadians, r), o = r / 2 * $785da19a645c07eb$var$pb(this.paint.get("line-width").evaluate(t, i), this.paint.get("line-gap-width").evaluate(t, i)), l = this.paint.get("line-offset").evaluate(t, i);
        return l && (n = function(e1, t) {
            let i = [];
            for (let n of e1){
                let e1 = $785da19a645c07eb$var$Dv(n), a = [];
                for(let i = 0; i < e1.length; i++){
                    let n = e1[i], r = e1[i - 1], s = e1[i + 1], o = 0 === i ? new $785da19a645c07eb$var$Kc(0, 0) : n.sub(r)._unit()._perp(), l = i === e1.length - 1 ? new $785da19a645c07eb$var$Kc(0, 0) : s.sub(n)._unit()._perp(), c = o._add(l)._unit(), u = c.x * l.x + c.y * l.y;
                    0 !== u && c._mult(1 / u), a.push(c._mult(t)._add(n));
                }
                i.push(a);
            }
            return i;
        }(n, l * r)), function(e1, t, i) {
            for (let n of t){
                if (e1.length >= 3) {
                    for (let t of n)if ($785da19a645c07eb$var$kv(e1, t)) return !0;
                }
                if ($785da19a645c07eb$var$vv(e1, n, i)) return !0;
            }
            return !1;
        }(s, n, o);
    }
    isTileClipped() {
        return !0;
    }
};
function $785da19a645c07eb$var$pb(e1, t) {
    return t > 0 ? t + 2 * e1 : e1;
}
const $785da19a645c07eb$var$mb = $785da19a645c07eb$var$EA([
    {
        name: "a_pos_offset",
        components: 4,
        type: "Int16"
    },
    {
        name: "a_data",
        components: 4,
        type: "Uint16"
    },
    {
        name: "a_pixeloffset",
        components: 4,
        type: "Int16"
    },
    {
        name: "a_height_offset",
        components: 1,
        type: "Float32"
    }
], 4), $785da19a645c07eb$var$gb = $785da19a645c07eb$var$EA([
    {
        name: "a_projected_pos",
        components: 3,
        type: "Float32"
    }
], 4);
$785da19a645c07eb$var$EA([
    {
        name: "a_fade_opacity",
        components: 1,
        type: "Uint32"
    }
], 4);
const $785da19a645c07eb$var$fb = $785da19a645c07eb$var$EA([
    {
        name: "a_placed",
        components: 2,
        type: "Uint8"
    },
    {
        name: "a_shift",
        components: 2,
        type: "Float32"
    },
    {
        name: "a_box_real",
        components: 2,
        type: "Int16"
    }
]);
$785da19a645c07eb$var$EA([
    {
        type: "Int16",
        name: "anchorPointX"
    },
    {
        type: "Int16",
        name: "anchorPointY"
    },
    {
        type: "Int16",
        name: "x1"
    },
    {
        type: "Int16",
        name: "y1"
    },
    {
        type: "Int16",
        name: "x2"
    },
    {
        type: "Int16",
        name: "y2"
    },
    {
        type: "Uint32",
        name: "featureIndex"
    },
    {
        type: "Uint16",
        name: "sourceLayerIndex"
    },
    {
        type: "Uint16",
        name: "bucketIndex"
    }
]);
const $785da19a645c07eb$var$Ab = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        components: 2,
        type: "Int16"
    },
    {
        name: "a_anchor_pos",
        components: 2,
        type: "Int16"
    },
    {
        name: "a_extrude",
        components: 2,
        type: "Int16"
    }
], 4), $785da19a645c07eb$var$_b = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        components: 2,
        type: "Float32"
    },
    {
        name: "a_radius",
        components: 1,
        type: "Float32"
    },
    {
        name: "a_flags",
        components: 2,
        type: "Int16"
    }
], 4);
$785da19a645c07eb$var$EA([
    {
        name: "triangle",
        components: 3,
        type: "Uint16"
    }
]), $785da19a645c07eb$var$EA([
    {
        type: "Int16",
        name: "anchorX"
    },
    {
        type: "Int16",
        name: "anchorY"
    },
    {
        type: "Uint16",
        name: "glyphStartIndex"
    },
    {
        type: "Uint16",
        name: "numGlyphs"
    },
    {
        type: "Uint32",
        name: "vertexStartIndex"
    },
    {
        type: "Uint32",
        name: "lineStartIndex"
    },
    {
        type: "Uint32",
        name: "lineLength"
    },
    {
        type: "Uint16",
        name: "segment"
    },
    {
        type: "Uint16",
        name: "lowerSize"
    },
    {
        type: "Uint16",
        name: "upperSize"
    },
    {
        type: "Float32",
        name: "lineOffsetX"
    },
    {
        type: "Float32",
        name: "lineOffsetY"
    },
    {
        type: "Uint8",
        name: "writingMode"
    },
    {
        type: "Uint8",
        name: "placedOrientation"
    },
    {
        type: "Uint8",
        name: "hidden"
    },
    {
        type: "Uint32",
        name: "crossTileID"
    },
    {
        type: "Int16",
        name: "associatedIconIndex"
    },
    {
        type: "Float32",
        name: "heightOffset"
    }
]), $785da19a645c07eb$var$EA([
    {
        type: "Int16",
        name: "anchorX"
    },
    {
        type: "Int16",
        name: "anchorY"
    },
    {
        type: "Int16",
        name: "rightJustifiedTextSymbolIndex"
    },
    {
        type: "Int16",
        name: "centerJustifiedTextSymbolIndex"
    },
    {
        type: "Int16",
        name: "leftJustifiedTextSymbolIndex"
    },
    {
        type: "Int16",
        name: "verticalPlacedTextSymbolIndex"
    },
    {
        type: "Int16",
        name: "placedIconSymbolIndex"
    },
    {
        type: "Int16",
        name: "verticalPlacedIconSymbolIndex"
    },
    {
        type: "Uint16",
        name: "key"
    },
    {
        type: "Uint16",
        name: "textBoxStartIndex"
    },
    {
        type: "Uint16",
        name: "textBoxEndIndex"
    },
    {
        type: "Uint16",
        name: "verticalTextBoxStartIndex"
    },
    {
        type: "Uint16",
        name: "verticalTextBoxEndIndex"
    },
    {
        type: "Uint16",
        name: "iconBoxStartIndex"
    },
    {
        type: "Uint16",
        name: "iconBoxEndIndex"
    },
    {
        type: "Uint16",
        name: "verticalIconBoxStartIndex"
    },
    {
        type: "Uint16",
        name: "verticalIconBoxEndIndex"
    },
    {
        type: "Uint16",
        name: "featureIndex"
    },
    {
        type: "Uint16",
        name: "numHorizontalGlyphVertices"
    },
    {
        type: "Uint16",
        name: "numVerticalGlyphVertices"
    },
    {
        type: "Uint16",
        name: "numIconVertices"
    },
    {
        type: "Uint16",
        name: "numVerticalIconVertices"
    },
    {
        type: "Uint16",
        name: "useRuntimeCollisionCircles"
    },
    {
        type: "Uint32",
        name: "crossTileID"
    },
    {
        type: "Float32",
        name: "textBoxScale"
    },
    {
        type: "Float32",
        name: "collisionCircleDiameter"
    },
    {
        type: "Uint16",
        name: "textAnchorOffsetStartIndex"
    },
    {
        type: "Uint16",
        name: "textAnchorOffsetEndIndex"
    },
    {
        type: "Float32",
        name: "heightOffset"
    }
]), $785da19a645c07eb$var$EA([
    {
        type: "Float32",
        name: "offsetX"
    }
]), $785da19a645c07eb$var$EA([
    {
        type: "Int16",
        name: "x"
    },
    {
        type: "Int16",
        name: "y"
    },
    {
        type: "Int16",
        name: "tileUnitDistanceFromAnchor"
    }
]), $785da19a645c07eb$var$EA([
    {
        type: "Uint16",
        name: "textAnchor"
    },
    {
        type: "Float32",
        components: 2,
        name: "textOffset"
    }
]);
const $785da19a645c07eb$var$vb = new class {
    constructor(){
        this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
    }
    setState(e1) {
        this.pluginStatus = e1.pluginStatus, this.pluginURL = e1.pluginURL;
    }
    getState() {
        return {
            pluginStatus: this.pluginStatus,
            pluginURL: this.pluginURL
        };
    }
    setMethods(e1) {
        if ($785da19a645c07eb$var$vb.isParsed()) throw Error("RTL text plugin already registered.");
        this.applyArabicShaping = e1.applyArabicShaping, this.processBidirectionalText = e1.processBidirectionalText, this.processStyledBidirectionalText = e1.processStyledBidirectionalText, this.loadScriptResolve();
    }
    isParsed() {
        return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
    }
    getRTLTextPluginStatus() {
        return this.pluginStatus;
    }
    async syncState(e1, t) {
        if (this.isParsed()) return this.getState();
        if ("loading" !== e1.pluginStatus) return this.setState(e1), e1;
        let i = e1.pluginURL, n = new Promise((e1)=>{
            this.loadScriptResolve = e1;
        }), a = new Promise((e1)=>setTimeout(()=>e1(), this.TIMEOUT));
        if (await t(i), await Promise.race([
            n,
            a
        ]), this.isParsed()) {
            let e1 = {
                pluginStatus: "loaded",
                pluginURL: i
            };
            return this.setState(e1), e1;
        }
        throw this.setState({
            pluginStatus: "error",
            pluginURL: ""
        }), Error(`RTL Text Plugin failed to import scripts from ${i}`);
    }
};
function $785da19a645c07eb$var$yb(e1) {
    return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$xb(e1) {
    return /[\u02EA\u02EB\u1100-\u11FF\u1401-\u167F\u18B0-\u18FF\u2065\u20DD-\u20E0\u20E2-\u20E4\u2B97\u2BF0-\u2BFF\u2E50\u2E51\u2E80-\u3007\u3012\u3013\u3020-\u302F\u3031-\u30FB\u30FD-\uA4CF\uA960-\uA97F\uAC00-\uD7FF\uF900-\uFAFF\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7\uFFF0-\uFFF8]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|[\uD80C-\uD810\uD81C-\uD822\uD83C\uD83D\uD840-\uD87E\uD880-\uD8BE][\uDC00-\uDFFF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFFF]|\uD823[\uDC00-\uDDFF]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFF]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83E[\uDD00-\uDEFF]|[\uD87F\uD8BF][\uDC00-\uDFFD]/gim.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$bb(e1) {
    return /[\u0E01-\u0E3A\u0E40-\u0E4E\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECE\u0EDC-\u0EDF\u0F00-\u0F47\u0F49-\u0F6C\u0F71-\u0F97\u0F99-\u0FBC\u0FBE-\u0FCC\u0FCE-\u0FD4\u0FD9\u0FDA\u1000-\u103F\u1050-\u108F\u109A-\u109F\u1780-\u17D3\u17D7\u17DC\u17DD\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19DE\u19DF\u1A20-\u1A5E\u1A60-\u1A7C\u1AA0-\u1AAD\u1B00-\u1B4C\u1B4E-\u1B7F\uA980-\uA9CD\uA9D0-\uA9D9\uA9DE-\uA9EF\uA9FA-\uA9FE\uAA60-\uAAC2\uAADB-\uAADF]|\uD805[\uDF00-\uDF1A\uDF1D-\uDF2B\uDF3A\uDF3B\uDF3F-\uDF46]/gim.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$wb(e1, t) {
    return /(?:[\u1039\u17D2\u1A60\u1BAB\u200D\uAAF6]|\uD802\uDE3F|\uD804[\uDD33\uDFD0]|\uD806[\uDD3E\uDE47\uDE99]|\uD807[\uDD45\uDD97\uDF42])$/.test(e1) || /^\p{gc=Mc}/u.test(t);
}
const $785da19a645c07eb$var$Eb = {
    C: "18g,1;g2,3;4nb,1",
    D: "17k,1;5,1;1,1;1,5;4,d;1,7;1,2;z,2;8,g;i,12;1,2;9,1;1,1;1,2;14,3;2,1;28,9;3,f;2,4;1,1;2,3;2,6;7a,1;2,5;1,1;g,a;5,2;2,6;1,f",
    R: "17m,4;1,1;1,1;5,4;l,1;14,3;1,3;g,i;12,1;2,9;1,1;1,1;2,2;1,1;o,2;2x,3;f,2;4,1;1,2;3,2;6u,j;b,1;r,3;1,1;2,2;6,1",
    T: "174,b;1,1;1a,l;g,1;2t,7;2,6;2,2;1,4;bt,9;16,o;1,t;1clb,1"
}, $785da19a645c07eb$var$kb = {
    1569: [
        65152,
        0,
        0,
        0
    ],
    1570: [
        65153,
        65154,
        0,
        0
    ],
    1571: [
        65155,
        65156,
        0,
        0
    ],
    1572: [
        65157,
        65158,
        0,
        0
    ],
    1573: [
        65159,
        65160,
        0,
        0
    ],
    1574: [
        65161,
        65162,
        65163,
        65164
    ],
    1575: [
        65165,
        65166,
        0,
        0
    ],
    1576: [
        65167,
        65168,
        65169,
        65170
    ],
    1577: [
        65171,
        65172,
        0,
        0
    ],
    1578: [
        65173,
        65174,
        65175,
        65176
    ],
    1579: [
        65177,
        65178,
        65179,
        65180
    ],
    1580: [
        65181,
        65182,
        65183,
        65184
    ],
    1581: [
        65185,
        65186,
        65187,
        65188
    ],
    1582: [
        65189,
        65190,
        65191,
        65192
    ],
    1583: [
        65193,
        65194,
        0,
        0
    ],
    1584: [
        65195,
        65196,
        0,
        0
    ],
    1585: [
        65197,
        65198,
        0,
        0
    ],
    1586: [
        65199,
        65200,
        0,
        0
    ],
    1587: [
        65201,
        65202,
        65203,
        65204
    ],
    1588: [
        65205,
        65206,
        65207,
        65208
    ],
    1589: [
        65209,
        65210,
        65211,
        65212
    ],
    1590: [
        65213,
        65214,
        65215,
        65216
    ],
    1591: [
        65217,
        65218,
        65219,
        65220
    ],
    1592: [
        65221,
        65222,
        65223,
        65224
    ],
    1593: [
        65225,
        65226,
        65227,
        65228
    ],
    1594: [
        65229,
        65230,
        65231,
        65232
    ],
    1601: [
        65233,
        65234,
        65235,
        65236
    ],
    1602: [
        65237,
        65238,
        65239,
        65240
    ],
    1603: [
        65241,
        65242,
        65243,
        65244
    ],
    1604: [
        65245,
        65246,
        65247,
        65248
    ],
    1605: [
        65249,
        65250,
        65251,
        65252
    ],
    1606: [
        65253,
        65254,
        65255,
        65256
    ],
    1607: [
        65257,
        65258,
        65259,
        65260
    ],
    1608: [
        65261,
        65262,
        0,
        0
    ],
    1609: [
        65263,
        65264,
        64488,
        64489
    ],
    1610: [
        65265,
        65266,
        65267,
        65268
    ],
    1611: [
        65136,
        0,
        0,
        65137
    ],
    1612: [
        65138,
        0,
        0,
        0
    ],
    1613: [
        65140,
        0,
        0,
        0
    ],
    1614: [
        65142,
        0,
        0,
        65143
    ],
    1615: [
        65144,
        0,
        0,
        65145
    ],
    1616: [
        65146,
        0,
        0,
        65147
    ],
    1617: [
        65148,
        0,
        0,
        65149
    ],
    1618: [
        65150,
        0,
        0,
        65151
    ],
    1649: [
        64336,
        64337,
        0,
        0
    ],
    1655: [
        64477,
        0,
        0,
        0
    ],
    1657: [
        64358,
        64359,
        64360,
        64361
    ],
    1658: [
        64350,
        64351,
        64352,
        64353
    ],
    1659: [
        64338,
        64339,
        64340,
        64341
    ],
    1662: [
        64342,
        64343,
        64344,
        64345
    ],
    1663: [
        64354,
        64355,
        64356,
        64357
    ],
    1664: [
        64346,
        64347,
        64348,
        64349
    ],
    1667: [
        64374,
        64375,
        64376,
        64377
    ],
    1668: [
        64370,
        64371,
        64372,
        64373
    ],
    1670: [
        64378,
        64379,
        64380,
        64381
    ],
    1671: [
        64382,
        64383,
        64384,
        64385
    ],
    1672: [
        64392,
        64393,
        0,
        0
    ],
    1676: [
        64388,
        64389,
        0,
        0
    ],
    1677: [
        64386,
        64387,
        0,
        0
    ],
    1678: [
        64390,
        64391,
        0,
        0
    ],
    1681: [
        64396,
        64397,
        0,
        0
    ],
    1688: [
        64394,
        64395,
        0,
        0
    ],
    1700: [
        64362,
        64363,
        64364,
        64365
    ],
    1702: [
        64366,
        64367,
        64368,
        64369
    ],
    1705: [
        64398,
        64399,
        64400,
        64401
    ],
    1709: [
        64467,
        64468,
        64469,
        64470
    ],
    1711: [
        64402,
        64403,
        64404,
        64405
    ],
    1713: [
        64410,
        64411,
        64412,
        64413
    ],
    1715: [
        64406,
        64407,
        64408,
        64409
    ],
    1722: [
        64414,
        64415,
        0,
        0
    ],
    1723: [
        64416,
        64417,
        64418,
        64419
    ],
    1726: [
        64426,
        64427,
        64428,
        64429
    ],
    1728: [
        64420,
        64421,
        0,
        0
    ],
    1729: [
        64422,
        64423,
        64424,
        64425
    ],
    1733: [
        64480,
        64481,
        0,
        0
    ],
    1734: [
        64473,
        64474,
        0,
        0
    ],
    1735: [
        64471,
        64472,
        0,
        0
    ],
    1736: [
        64475,
        64476,
        0,
        0
    ],
    1737: [
        64482,
        64483,
        0,
        0
    ],
    1739: [
        64478,
        64479,
        0,
        0
    ],
    1740: [
        64508,
        64509,
        64510,
        64511
    ],
    1744: [
        64484,
        64485,
        64486,
        64487
    ],
    1746: [
        64430,
        64431,
        0,
        0
    ],
    1747: [
        64432,
        64433,
        0,
        0
    ]
}, $785da19a645c07eb$var$Sb = {
    "\u0644\u0622": [
        65269,
        65270
    ],
    "\u0644\u0623": [
        65271,
        65272
    ],
    "\u0644\u0625": [
        65273,
        65274
    ],
    "\u0644\u0627": [
        65275,
        65276
    ]
}, $785da19a645c07eb$var$Mb = /[\u0600-\u06ff\u0750-\u077f\u0870-\u089f\u08a0-\u08ff\ufb50-\ufdff\ufe70-\ufeff]/;
function $785da19a645c07eb$var$Cb(e1, t, i) {
    let n = 0;
    for (let a of e1.split(";")){
        let [e1, r] = a.split(",").map((e1)=>parseInt(e1, 36)), s = n + e1;
        for(let e1 = s; e1 < s + r; e1++)i.set(e1, t);
        n = s + r;
    }
}
const $785da19a645c07eb$var$Tb = new Map;
for (let [e1, t] of Object.entries($785da19a645c07eb$var$Eb))$785da19a645c07eb$var$Cb(t, e1, $785da19a645c07eb$var$Tb);
function $785da19a645c07eb$var$Db(e1) {
    return $785da19a645c07eb$var$Tb.get(e1) ?? "U";
}
function $785da19a645c07eb$var$Pb(e1) {
    return "D" === e1 || "L" === e1 || "C" === e1;
}
function $785da19a645c07eb$var$Ib(e1) {
    return "D" === e1 || "R" === e1 || "C" === e1;
}
function $785da19a645c07eb$var$Fb(e1, t, i) {
    return "D" === e1 ? t && i ? 3 : t ? 1 : i ? 2 : 0 : "R" === e1 ? +!!t : "L" === e1 ? i ? 2 : 0 : null;
}
function $785da19a645c07eb$var$zb(e1) {
    if (!$785da19a645c07eb$var$Mb.test(e1)) return e1;
    let t = function(e1) {
        return [
            ...e1
        ].map((e1)=>{
            let t = e1.codePointAt(0);
            return {
                codePoint: t,
                type: $785da19a645c07eb$var$Db(t),
                form: null
            };
        });
    }(e1);
    return function(e1) {
        let t = e1.filter((e1)=>"T" !== e1.type);
        for(let e1 = 0; e1 < t.length; e1++){
            let i = t[e1], n = e1 > 0 && $785da19a645c07eb$var$Pb(t[e1 - 1].type), a = e1 + 1 < t.length && $785da19a645c07eb$var$Ib(t[e1 + 1].type);
            i.form = $785da19a645c07eb$var$Fb(i.type, n, a);
        }
    }(t), function(e1) {
        let t = !1;
        for (let i of e1)"T" === i.type ? i.form = t ? 3 : 0 : t = 2 === i.form || 3 === i.form;
    }(t), (function(e1) {
        let t = [];
        for(let i = 0; i < e1.length; i++){
            let n = e1[i];
            if (1604 !== n.codePoint) {
                t.push(n);
                continue;
            }
            let a = i + 1;
            for(; a < e1.length && "T" === e1[a].type;)a++;
            let r = e1[a], s = r && $785da19a645c07eb$var$Sb[String.fromCodePoint(1604, r.codePoint)];
            if (!s) {
                t.push(n);
                continue;
            }
            let o = 3 === n.form || 1 === n.form;
            t.push({
                codePoint: s[+!!o],
                type: "R",
                form: 0
            }), t.push(...e1.slice(i + 1, a)), i = a;
        }
        return t;
    })(t).map((e1)=>String.fromCodePoint(function(e1) {
            if (null === e1.form) return e1.codePoint;
            let t = $785da19a645c07eb$var$kb[e1.codePoint];
            return t && (t[e1.form] || t[0]) || e1.codePoint;
        }(e1))).join("");
}
function $785da19a645c07eb$var$Rb(e1, t, i) {
    let n = t.layout.get("text-transform").evaluate(i, {});
    return "uppercase" === n ? e1 = e1.toLocaleUpperCase() : "lowercase" === n && (e1 = e1.toLocaleLowerCase()), ($785da19a645c07eb$var$vb.applyArabicShaping ?? $785da19a645c07eb$var$zb)(e1);
}
function $785da19a645c07eb$var$Lb(e1, t, i) {
    for (let n of e1.sections)n.text = $785da19a645c07eb$var$Rb(n.text, t, i);
    return e1;
}
const $785da19a645c07eb$var$Bb = typeof Intl < "u" && "Segmenter" in Intl;
let $785da19a645c07eb$var$Ob, $785da19a645c07eb$var$Ub;
function $785da19a645c07eb$var$Nb(e1) {
    if (!$785da19a645c07eb$var$Bb || !function(e1) {
        return /[\r\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0600-\u0605\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DD\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u070F\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0890\u0891\u0897-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3C\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0CF3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D57\u0D62\u0D63\u0D81-\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E33-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB3-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1037\u1039-\u103E\u1056-\u1059\u105E-\u1060\u1071-\u1074\u1082\u1084-\u1086\u108D\u109D\u1100-\u11FF\u135D-\u135F\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60\u1A62\u1A65-\u1A7C\u1A7F\u1AB0-\u1ADD\u1AE0-\u1AEB\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DFF\u200C\u200D\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA82C\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA960-\uA97C\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDD69-\uDD6D\uDEAB\uDEAC\uDEFA-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC00-\uDC02\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC82\uDCB0-\uDCBA\uDCBD\uDCC2\uDCCD\uDD00-\uDD02\uDD27-\uDD34\uDD45\uDD46\uDD73\uDD80-\uDD82\uDDB3-\uDDC0\uDDC2\uDDC3\uDDC9-\uDDCC\uDDCE\uDDCF\uDE2C-\uDE37\uDE3E\uDE41\uDEDF-\uDEEA\uDF00-\uDF03\uDF3B\uDF3C\uDF3E-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF57\uDF62\uDF63\uDF66-\uDF6C\uDF70-\uDF74\uDFB8-\uDFC0\uDFC2\uDFC5\uDFC7-\uDFCA\uDFCC-\uDFD2\uDFE1\uDFE2]|\uD805[\uDC35-\uDC46\uDC5E\uDCB0-\uDCC3\uDDAF-\uDDB5\uDDB8-\uDDC0\uDDDC\uDDDD\uDE30-\uDE40\uDEAB-\uDEB7\uDF1D-\uDF1F\uDF22-\uDF2B]|\uD806[\uDC2C-\uDC3A\uDD30-\uDD35\uDD37\uDD38\uDD3B-\uDD43\uDDD1-\uDDD7\uDDDA-\uDDE0\uDDE4\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE3E\uDE47\uDE51-\uDE5B\uDE84-\uDE99\uDF60-\uDF67]|\uD807[\uDC2F-\uDC36\uDC38-\uDC3F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD8A-\uDD8E\uDD90\uDD91\uDD93-\uDD97\uDEF3-\uDEF6\uDF00-\uDF03\uDF34-\uDF3A\uDF3E-\uDF42\uDF5A]|\uD80D[\uDC40\uDC47-\uDC55]|\uD818[\uDD1E-\uDD2F]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDD63\uDD67-\uDD6A\uDF4F\uDF51-\uDF87\uDF8F-\uDF92\uDFE4\uDFF0\uDFF1]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF\uDDEE\uDDEF\uDEE3\uDEE6\uDEEE\uDEEF\uDEF5]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDDE6-\uDDFF\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF]/.test(e1);
    }(e1)) return [
        ...e1
    ];
    $785da19a645c07eb$var$Ob ??= new Intl.Segmenter(void 0, {
        granularity: "grapheme"
    });
    let t = [];
    for (let { segment: i } of $785da19a645c07eb$var$Ob.segment(e1)){
        let e1 = t.length - 1;
        e1 >= 0 && $785da19a645c07eb$var$wb(t[e1], i) ? t[e1] += i : t.push(i);
    }
    return t;
}
function $785da19a645c07eb$var$jb(e1) {
    let t = new Set;
    if ($785da19a645c07eb$var$Bb) {
        $785da19a645c07eb$var$Ub ??= new Intl.Segmenter(void 0, {
            granularity: "word"
        });
        for (let { index: i } of $785da19a645c07eb$var$Ub.segment(e1))t.add(i);
        return t;
    }
    let i = 0;
    for (let n of e1.split(/\b|(?=\p{Ideo})/u))t.add(i), i += n.length;
    return t;
}
function $785da19a645c07eb$var$Vb(e1) {
    let t = e1.codePointAt(0);
    return e1.length > (t > 65535 ? 2 : 1);
}
function $785da19a645c07eb$var$qb(e1) {
    return /\s/u.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$Gb(e1) {
    for (let t of e1)if ($785da19a645c07eb$var$xb(t.codePointAt(0))) return !0;
    return !1;
}
function $785da19a645c07eb$var$Hb(e1) {
    for (let t of e1)if (!$785da19a645c07eb$var$Wb(t.codePointAt(0))) return !1;
    return !0;
}
function $785da19a645c07eb$var$Wb(e1) {
    return !function(e1) {
        return /[\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061C-\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u070D\u070F-\u074A\u074D-\u077F\u07C0-\u07FA\u07FD-\u07FF\u0840-\u085B\u085E\u0860-\u086A\u0870-\u0891\u0897-\u08E1\u08E3-\u08FF\u1800\u1801\u1804\u1806-\u1819\u1820-\u1878\u1880-\u18AA\uA840-\uA877\uFB50-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFF\uFE70-\uFE74\uFE76-\uFEFC]|\uD802[\uDEC0-\uDEE6\uDEEB-\uDEF6\uDF80-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]|\uD803[\uDD00-\uDD27\uDD30-\uDD39\uDE60-\uDE7E\uDEC2-\uDEC7\uDED0-\uDED8\uDEFA-\uDEFF\uDF30-\uDF59\uDF70-\uDF89\uDFB0-\uDFCB]|\uD805[\uDE60-\uDE6C]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9C-\uDC9F]|\uD83A[\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]/gim.test(String.fromCodePoint(e1));
    }(e1);
}
function $785da19a645c07eb$var$Zb(e1) {
    return !($785da19a645c07eb$var$xb(e1) || function(e1) {
        return /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(e1));
    }(e1));
}
function $785da19a645c07eb$var$Kb(e1) {
    return /\p{sc=Arab}/u.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$Xb(e1) {
    return function(e1) {
        return /[\u0591-\u05C7\u05D0-\u05EA\u05EF-\u05F4\u0600-\u0604\u0606-\u060B\u060D-\u061A\u061C-\u061E\u0620-\u063F\u0641-\u064A\u0656-\u066F\u0671-\u06DC\u06DE-\u070D\u070F-\u074A\u074D-\u07B1\u07C0-\u07FA\u07FD-\u082D\u0830-\u083E\u0840-\u085B\u085E\u0860-\u086A\u0870-\u0891\u0897-\u08E1\u08E3-\u08FF\uFB1D-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFD3D\uFD40-\uFDCF\uFDF0-\uFDFF\uFE70-\uFE74\uFE76-\uFEFC]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC57-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD1F-\uDD39\uDD3F-\uDD59\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F-\uDE48\uDE50-\uDE58\uDE60-\uDE9F\uDEC0-\uDEE6\uDEEB-\uDEF6\uDF00-\uDF35\uDF39-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDF99-\uDF9C\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD27\uDD30-\uDD39\uDD40-\uDD65\uDD69-\uDD85\uDD8E\uDD8F\uDE60-\uDE7E\uDE80-\uDEA9\uDEAB-\uDEAD\uDEB0\uDEB1\uDEC2-\uDEC7\uDED0-\uDED8\uDEFA-\uDF27\uDF30-\uDF59\uDF70-\uDF89\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCD6\uDD00-\uDD4B\uDD50-\uDD59\uDD5E\uDD5F]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB\uDEF0\uDEF1]/gim.test(String.fromCodePoint(e1));
    }(e1);
}
function $785da19a645c07eb$var$Qb(e1) {
    for (let t of e1)if ($785da19a645c07eb$var$Xb(t.codePointAt(0))) return !0;
    return !1;
}
const $785da19a645c07eb$var$Yb = {
    "!": "\uFE15",
    "#": "\uFF03",
    $: "\uFF04",
    "%": "\uFF05",
    "&": "\uFF06",
    "(": "\uFE35",
    ")": "\uFE36",
    "*": "\uFF0A",
    "+": "\uFF0B",
    ",": "\uFE10",
    "-": "\uFE32",
    ".": "\u30FB",
    "/": "\uFF0F",
    ":": "\uFE13",
    ";": "\uFE14",
    "<": "\uFE3F",
    "=": "\uFF1D",
    ">": "\uFE40",
    "?": "\uFE16",
    "@": "\uFF20",
    "[": "\uFE47",
    "\\": "\uFF3C",
    "]": "\uFE48",
    "^": "\uFF3E",
    _: "\uFE33",
    "`": "\uFF40",
    "{": "\uFE37",
    "|": "\u2015",
    "}": "\uFE38",
    "~": "\uFF5E",
    "\xa2": "\uFFE0",
    "\xa3": "\uFFE1",
    "\xa5": "\uFFE5",
    "\xa6": "\uFFE4",
    "\xac": "\uFFE2",
    "\xaf": "\uFFE3",
    "\u2013": "\uFE32",
    "\u2014": "\uFE31",
    "\u2018": "\uFE43",
    "\u2019": "\uFE44",
    "\u201C": "\uFE41",
    "\u201D": "\uFE42",
    "\u2026": "\uFE19",
    "\u22EF": "\uFE19",
    "\u2027": "\u30FB",
    "\u20A9": "\uFFE6",
    "\u3001": "\uFE11",
    "\u3002": "\uFE12",
    "\u3008": "\uFE3F",
    "\u3009": "\uFE40",
    "\u300A": "\uFE3D",
    "\u300B": "\uFE3E",
    "\u300C": "\uFE41",
    "\u300D": "\uFE42",
    "\u300E": "\uFE43",
    "\u300F": "\uFE44",
    "\u3010": "\uFE3B",
    "\u3011": "\uFE3C",
    "\u3014": "\uFE39",
    "\u3015": "\uFE3A",
    "\u3016": "\uFE17",
    "\u3017": "\uFE18",
    "\uFF01": "\uFE15",
    "\uFF08": "\uFE35",
    "\uFF09": "\uFE36",
    "\uFF0C": "\uFE10",
    "\uFF0D": "\uFE32",
    "\uFF0E": "\u30FB",
    "\uFF1A": "\uFE13",
    "\uFF1B": "\uFE14",
    "\uFF1C": "\uFE3F",
    "\uFF1E": "\uFE40",
    "\uFF1F": "\uFE16",
    "\uFF3B": "\uFE47",
    "\uFF3D": "\uFE48",
    "\uFF3F": "\uFE33",
    "\uFF5B": "\uFE37",
    "\uFF5C": "\u2015",
    "\uFF5D": "\uFE38",
    "\uFF5F": "\uFE35",
    "\uFF60": "\uFE36",
    "\uFF61": "\uFE12",
    "\uFF62": "\uFE41",
    "\uFF63": "\uFE42"
};
const $785da19a645c07eb$var$Jb = {
    10: !0,
    13: !0,
    32: !0,
    38: !0,
    41: !0,
    43: !0,
    45: !0,
    47: !0,
    173: !0,
    183: !0,
    8203: !0,
    8208: !0,
    8211: !0,
    8231: !0
}, $785da19a645c07eb$var$$b = {
    40: !0
};
function $785da19a645c07eb$var$ew(e1, t, i, n, a, r) {
    if ("fontStack" in t) {
        let n = i[t.fontStack], r = n?.[e1];
        if (r) return r.metrics.advance * t.scale + a;
        let s = 0;
        for (let i of e1){
            let e1 = n?.[i];
            e1 && (s += e1.metrics.advance * t.scale + a);
        }
        return s;
    }
    {
        let e1 = n[t.imageName];
        return e1 ? e1.displaySize[0] * t.scale * 24 / r + a : 0;
    }
}
function $785da19a645c07eb$var$tw(e1, t, i, n) {
    let a = (e1 - t) ** 2;
    return n ? e1 < t ? a / 2 : 2 * a : a + Math.abs(i) * i;
}
function $785da19a645c07eb$var$iw(e1) {
    return /^\s+$/u.test(e1);
}
function $785da19a645c07eb$var$nw(e1, t, i) {
    let n = 0;
    return (10 === e1 || 13 === e1) && (n -= 1e4), i && (n += 150), (40 === e1 || 65288 === e1) && (n += 50), (41 === t || 65289 === t) && (n += 50), n;
}
function $785da19a645c07eb$var$aw(e1, t, i, n, a, r) {
    let s = null, o = $785da19a645c07eb$var$tw(t, i, a, r);
    for (let e1 of n){
        let n = $785da19a645c07eb$var$tw(t - e1.x, i, a, r) + e1.badness;
        n <= o && (s = e1, o = n);
    }
    return {
        index: e1,
        x: t,
        priorBreak: s,
        badness: o
    };
}
function $785da19a645c07eb$var$rw(e1) {
    return e1 ? $785da19a645c07eb$var$rw(e1.priorBreak).concat(e1.index) : [];
}
var $785da19a645c07eb$var$sw = class e1 {
    constructor(e1 = "", t = [], i = []){
        this.text = e1, this.sections = t, this.sectionIndex = i, this.imageSectionID = null, this._graphemes = null;
    }
    graphemes() {
        return this._graphemes ??= $785da19a645c07eb$var$Nb(this.text), this._graphemes;
    }
    static fromFeature(t, i) {
        let n = new e1;
        for (let e1 of t.sections)e1.image ? n.addImageSection(e1) : n.addTextSection(e1, i);
        return n;
    }
    length() {
        return this.graphemes().length;
    }
    getSection(e1) {
        return this.sections[this.sectionIndex[e1]];
    }
    getSectionIndex(e1) {
        return this.sectionIndex[e1];
    }
    verticalizePunctuation() {
        this.text = function(e1) {
            let t = "", i = {
                premature: !0,
                value: void 0
            }, n = e1[Symbol.iterator](), a = n.next(), r = e1[Symbol.iterator]();
            r.next();
            let s = r.next();
            for(; !a.done;)!s.done && $785da19a645c07eb$var$Zb(s.value.codePointAt(0)) && !$785da19a645c07eb$var$Yb[s.value] || !i.premature && $785da19a645c07eb$var$Zb(i.value.codePointAt(0)) && !$785da19a645c07eb$var$Yb[i.value] || !$785da19a645c07eb$var$Yb[a.value] ? t += a.value : t += $785da19a645c07eb$var$Yb[a.value], i = {
                value: a.value,
                premature: !1
            }, a = n.next(), s = r.next();
            return t;
        }(this.text), this._graphemes = null;
    }
    hasZeroWidthSpaces() {
        return this.text.includes("\u200B");
    }
    trim() {
        let e1 = this.graphemes(), t = 0;
        for(; t < e1.length && $785da19a645c07eb$var$iw(e1[t]);)t++;
        let i = e1.length;
        for(; i > t && $785da19a645c07eb$var$iw(e1[i - 1]);)i--;
        this.text = e1.slice(t, i).join(""), this.sectionIndex = this.sectionIndex.slice(t, i), this._graphemes = null;
    }
    substring(t, i) {
        let n = this.graphemes().slice(t, i).join(""), a = this.sectionIndex.slice(t, i);
        return new e1(n, this.sections, a);
    }
    toCodeUnitIndex(e1) {
        return this.graphemes().slice(0, e1).join("").length;
    }
    toString() {
        return this.text;
    }
    getMaxScale() {
        return this.sectionIndex.reduce((e1, t)=>Math.max(e1, this.sections[t].scale), 0);
    }
    getMaxImageSize(e1) {
        let t = 0, i = 0;
        for(let n = 0; n < this.length(); n++){
            let a = this.getSection(n);
            if ("imageName" in a) {
                let n = e1[a.imageName];
                if (!n) continue;
                let r = n.displaySize;
                t = Math.max(t, r[0]), i = Math.max(i, r[1]);
            }
        }
        return {
            maxImageWidth: t,
            maxImageHeight: i
        };
    }
    _appendSection(e1, t) {
        let i = this.graphemes(), n = i.length > 0 ? i[i.length - 1] : "", a = $785da19a645c07eb$var$Nb(n + e1);
        this.text += e1, this._graphemes = i.slice(0, n ? -1 : void 0).concat(a);
        let r = a.length - +!!n;
        for(let e1 = 0; e1 < r; e1++)this.sectionIndex.push(t);
    }
    addTextSection(e1, t) {
        this.sections.push({
            scale: e1.scale || 1,
            verticalAlign: e1.verticalAlign || "bottom",
            fontStack: e1.fontStack || t
        }), this._appendSection(e1.text, this.sections.length - 1);
    }
    addImageSection(e1) {
        let t = e1.image ? e1.image.name : "";
        if (0 === t.length) return void $785da19a645c07eb$var$wh("Can't add FormattedSection with an empty image.");
        let i = this.getNextImageSectionCharCode();
        i ? (this.sections.push({
            scale: 1,
            verticalAlign: e1.verticalAlign || "bottom",
            imageName: t
        }), this._appendSection(String.fromCharCode(i), this.sections.length - 1)) : $785da19a645c07eb$var$wh("Reached maximum number of images 6401");
    }
    getNextImageSectionCharCode() {
        return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
    }
    determineLineBreaks(e1, t, i, n, a) {
        let r = [], s = this.determineAverageLineWidth(e1, t, i, n, a), o = this.hasZeroWidthSpaces(), l = this.graphemes(), c = null, u = 0, h = 0;
        for(let t = 0; t < l.length; t++){
            let d = l[t];
            if (t > 0) {
                let e1 = l[t - 1].codePointAt(0), i = d.codePointAt(0), n = $785da19a645c07eb$var$yb(e1), a = $785da19a645c07eb$var$bb(e1) && $785da19a645c07eb$var$bb(i);
                ($785da19a645c07eb$var$Jb[e1] || n || "imageName" in this.getSection(t - 1) || void 0 !== l[t + 1] && $785da19a645c07eb$var$$b[i] || a && (c ??= $785da19a645c07eb$var$jb(this.text)).has(h)) && r.push($785da19a645c07eb$var$aw(t, u, s, r, $785da19a645c07eb$var$nw(e1, i, n && o), !1));
            }
            $785da19a645c07eb$var$qb(d.codePointAt(0)) || (u += $785da19a645c07eb$var$ew(d, this.getSection(t), i, n, e1, a)), h += d.length;
        }
        return $785da19a645c07eb$var$rw($785da19a645c07eb$var$aw(this.length(), u, s, r, 0, !0));
    }
    determineAverageLineWidth(e1, t, i, n, a) {
        let r = 0, s = 0;
        for (let t of this.graphemes())r += $785da19a645c07eb$var$ew(t, this.getSection(s), i, n, e1, a), s++;
        return r / Math.max(1, Math.ceil(r / t));
    }
};
const $785da19a645c07eb$var$ow = function(e1) {
    var t = {
        R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
        EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
        ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
        ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
        AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
        CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
        B: "a,3,f+2,2v,690",
        S: "9,2,k",
        WS: "c,k,4f4,1vk+a,u,1j,335",
        ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
        BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
        NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
        AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
        LRO: "6ct",
        RLO: "6cu",
        LRE: "6cq",
        RLE: "6cr",
        PDF: "6cs",
        LRI: "6ee",
        RLI: "6ef",
        FSI: "6eg",
        PDI: "6eh"
    }, i = {}, n = {};
    i.L = 1, n[1] = "L", Object.keys(t).forEach(function(e1, t) {
        i[e1] = 1 << t + 1, n[i[e1]] = e1;
    }), Object.freeze(i);
    var a = i.LRI | i.RLI | i.FSI, r = i.L | i.R | i.AL, s = i.B | i.S | i.WS | i.ON | i.FSI | i.LRI | i.RLI | i.PDI, o = i.BN | i.RLE | i.LRE | i.RLO | i.LRO | i.PDF, l = i.S | i.WS | i.B | a | i.PDI | o, c = null;
    function u(e1) {
        return function() {
            if (!c) {
                c = new Map;
                var e1 = 0;
                for(var n in t)if (t.hasOwnProperty(n)) for(var a = t[n], r = "", s = void 0, o = !1, l = 0, u = 0; u <= a.length + 1; u += 1){
                    var h = a[u];
                    if ("," !== h && u !== a.length) "+" === h ? (o = !0, l = e1 = l + parseInt(r, 36), r = "") : r += h;
                    else {
                        o ? s = e1 + parseInt(r, 36) : (l = e1 = l + parseInt(r, 36), s = e1), o = !1, r = "", l = s;
                        for(var d = e1; d < s + 1; d += 1)c.set(d, i[n]);
                    }
                }
            }
        }(), c.get(e1.codePointAt(0)) || i.L;
    }
    var h, d, p, m = {
        pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
        canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
    };
    function g(e1, t) {
        var i, n = 0, a = new Map, r = t && new Map;
        return e1.split(",").forEach(function e1(s) {
            if (-1 !== s.indexOf("+")) for(var o = +s; o--;)e1(i);
            else {
                i = s;
                var l = s.split(">"), c = l[0], u = l[1];
                c = String.fromCodePoint(n += parseInt(c, 36)), u = String.fromCodePoint(n += parseInt(u, 36)), a.set(c, u), t && r.set(u, c);
            }
        }), {
            map: a,
            reverseMap: r
        };
    }
    function f() {
        if (!h) {
            var e1 = g(m.pairs, !0), t = e1.map, i = e1.reverseMap;
            h = t, d = i, p = g(m.canonical, !1).map;
        }
    }
    function A(e1) {
        return f(), h.get(e1) || null;
    }
    function _(e1) {
        return f(), d.get(e1) || null;
    }
    function v(e1) {
        return f(), p.get(e1) || null;
    }
    var y, x = i.L, b = i.R, w = i.EN, E = i.ES, k = i.ET, S = i.AN, M = i.CS, C = i.B, T = i.S, D = i.ON, P = i.BN, I = i.NSM, F = i.AL, z = i.LRO, R = i.RLO, L1 = i.LRE, B = i.RLE, O = i.PDF, U = i.LRI, N = i.RLI, j = i.FSI, V = i.PDI;
    function q(e1) {
        return function() {
            if (!y) {
                var e1 = g("14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", !0), t = e1.map;
                e1.reverseMap.forEach(function(e1, i) {
                    t.set(i, e1);
                }), y = t;
            }
        }(), y.get(e1) || null;
    }
    function G(e1, t, i, n) {
        var a = e1.length;
        i = Math.max(0, null == i ? 0 : +i), n = Math.min(a - 1, null == n ? a - 1 : +n);
        var r = [];
        return t.paragraphs.forEach(function(a) {
            var s = Math.max(i, a.start), o = Math.min(n, a.end);
            if (s < o) {
                for(var c = t.levels.slice(s, o + 1), h = o; h >= s && u(e1[h]) & l; h--)c[h] = a.level;
                for(var d = a.level, p = 1 / 0, m = 0; m < c.length; m++){
                    var g = c[m];
                    g > d && (d = g), g < p && (p = 1 | g);
                }
                for(var f = d; f >= p; f--)for(var A = 0; A < c.length; A++)if (c[A] >= f) {
                    for(var _ = A; A + 1 < c.length && c[A + 1] >= f;)A++;
                    A > _ && r.push([
                        _ + s,
                        A + s
                    ]);
                }
            }
        }), r;
    }
    function H(e1, t, i, n) {
        for(var a = G(e1, t, i, n), r = [], s = 0; s < e1.length; s++)r[s] = s;
        return a.forEach(function(e1) {
            for(var t = e1[0], i = e1[1], n = r.slice(t, i + 1), a = n.length; a--;)r[i - a] = n[a];
        }), r;
    }
    return e1.closingToOpeningBracket = _, e1.getBidiCharType = u, e1.getBidiCharTypeName = function(e1) {
        return n[u(e1)];
    }, e1.getCanonicalBracket = v, e1.getEmbeddingLevels = function(e1, t) {
        for(var i = new Uint32Array(e1.length), n = 0; n < e1.length; n++)i[n] = u(e1[n]);
        var c = new Map;
        function h(e1, t) {
            var n = i[e1];
            i[e1] = t, c.set(n, c.get(n) - 1), n & s && c.set(s, c.get(s) - 1), c.set(t, (c.get(t) || 0) + 1), t & s && c.set(s, (c.get(s) || 0) + 1);
        }
        for(var d = new Uint8Array(e1.length), p = new Map, m = [], g = null, f = 0; f < e1.length; f++)g || m.push(g = {
            start: f,
            end: e1.length - 1,
            level: "rtl" === t ? 1 : "ltr" === t ? 0 : Nt(f, !1)
        }), i[f] & C && (g.end = f, g = null);
        for(var y = B | L1 | R | z | a | V | O | C, q = function(e1) {
            return e1 + (1 & e1 ? 1 : 2);
        }, G = function(e1) {
            return e1 + (1 & e1 ? 2 : 1);
        }, H = 0; H < m.length; H++){
            var W = [
                {
                    _level: (g = m[H]).level,
                    _override: 0,
                    _isolate: 0
                }
            ], Z = void 0, K = 0, X = 0, Q = 0;
            c.clear();
            for(var Y = g.start; Y <= g.end; Y++){
                var J = i[Y];
                if (Z = W[W.length - 1], c.set(J, (c.get(J) || 0) + 1), J & s && c.set(s, (c.get(s) || 0) + 1), J & y) {
                    if (J & (B | L1)) {
                        d[Y] = Z._level;
                        var $ = (J === B ? G : q)(Z._level);
                        $ <= 125 && !K && !X ? W.push({
                            _level: $,
                            _override: 0,
                            _isolate: 0
                        }) : K || X++;
                    } else if (J & (R | z)) {
                        d[Y] = Z._level;
                        var ee = (J === R ? G : q)(Z._level);
                        ee <= 125 && !K && !X ? W.push({
                            _level: ee,
                            _override: J & R ? b : x,
                            _isolate: 0
                        }) : K || X++;
                    } else if (J & a) {
                        J & j && (J = 1 === Nt(Y + 1, !0) ? N : U), d[Y] = Z._level, Z._override && h(Y, Z._override);
                        var te = (J === N ? G : q)(Z._level);
                        te <= 125 && 0 === K && 0 === X ? (Q++, W.push({
                            _level: te,
                            _override: 0,
                            _isolate: 1,
                            _isolInitIndex: Y
                        })) : K++;
                    } else if (J & V) {
                        if (K > 0) K--;
                        else if (Q > 0) {
                            for(X = 0; !W[W.length - 1]._isolate;)W.pop();
                            var ie = W[W.length - 1]._isolInitIndex;
                            null != ie && (p.set(ie, Y), p.set(Y, ie)), W.pop(), Q--;
                        }
                        Z = W[W.length - 1], d[Y] = Z._level, Z._override && h(Y, Z._override);
                    } else J & O ? (0 === K && (X > 0 ? X-- : !Z._isolate && W.length > 1 && (W.pop(), Z = W[W.length - 1])), d[Y] = Z._level) : J & C && (d[Y] = g.level);
                } else d[Y] = Z._level, Z._override && J !== P && h(Y, Z._override);
            }
            for(var ne = [], ae = null, re = g.start; re <= g.end; re++){
                var se = i[re];
                if (!(se & o)) {
                    var oe = d[re], le = se & a, ce = se === V;
                    ae && oe === ae._level ? (ae._end = re, ae._endsWithIsolInit = le) : ne.push(ae = {
                        _start: re,
                        _end: re,
                        _level: oe,
                        _startsWithPDI: ce,
                        _endsWithIsolInit: le
                    });
                }
            }
            for(var ue = [], he = 0; he < ne.length; he++){
                var de = ne[he];
                if (!de._startsWithPDI || de._startsWithPDI && !p.has(de._start)) {
                    for(var pe = [
                        ae = de
                    ], me = void 0; ae && ae._endsWithIsolInit && null != (me = p.get(ae._end));)for(var ge = he + 1; ge < ne.length; ge++)if (ne[ge]._start === me) {
                        pe.push(ae = ne[ge]);
                        break;
                    }
                    for(var fe = [], Ae = 0; Ae < pe.length; Ae++)for(var _e = pe[Ae], ve = _e._start; ve <= _e._end; ve++)fe.push(ve);
                    for(var ye = d[fe[0]], xe = g.level, be = fe[0] - 1; be >= 0; be--)if (!(i[be] & o)) {
                        xe = d[be];
                        break;
                    }
                    var we = fe[fe.length - 1], Ee = d[we], ke = g.level;
                    if (!(i[we] & a)) {
                        for(var Se = we + 1; Se <= g.end; Se++)if (!(i[Se] & o)) {
                            ke = d[Se];
                            break;
                        }
                    }
                    ue.push({
                        _seqIndices: fe,
                        _sosType: Math.max(xe, ye) % 2 ? b : x,
                        _eosType: Math.max(ke, Ee) % 2 ? b : x
                    });
                }
            }
            for(var Me = 0; Me < ue.length; Me++){
                var Ce = ue[Me], Te = Ce._seqIndices, De = Ce._sosType, Pe = Ce._eosType, Ie = 1 & d[Te[0]] ? b : x;
                if (c.get(I)) for(var Fe = 0; Fe < Te.length; Fe++){
                    var ze = Te[Fe];
                    if (i[ze] & I) {
                        for(var Re = De, Le = Fe - 1; Le >= 0; Le--)if (!(i[Te[Le]] & o)) {
                            Re = i[Te[Le]];
                            break;
                        }
                        h(ze, Re & (a | V) ? D : Re);
                    }
                }
                if (c.get(w)) for(var Be = 0; Be < Te.length; Be++){
                    var Oe = Te[Be];
                    if (i[Oe] & w) for(var Ue = Be - 1; Ue >= -1; Ue--){
                        var Ne = -1 === Ue ? De : i[Te[Ue]];
                        if (Ne & r) {
                            Ne === F && h(Oe, S);
                            break;
                        }
                    }
                }
                if (c.get(F)) for(var je = 0; je < Te.length; je++){
                    var Ve = Te[je];
                    i[Ve] & F && h(Ve, b);
                }
                if (c.get(E) || c.get(M)) for(var qe = 1; qe < Te.length - 1; qe++){
                    var Ge = Te[qe];
                    if (i[Ge] & (E | M)) {
                        for(var He = 0, We = 0, Ze = qe - 1; Ze >= 0 && (He = i[Te[Ze]]) & o; Ze--);
                        for(var Ke = qe + 1; Ke < Te.length && (We = i[Te[Ke]]) & o; Ke++);
                        He === We && (i[Ge] === E ? He === w : He & (w | S)) && h(Ge, He);
                    }
                }
                if (c.get(w)) {
                    for(var Xe = 0; Xe < Te.length; Xe++)if (i[Te[Xe]] & w) {
                        for(var Qe = Xe - 1; Qe >= 0 && i[Te[Qe]] & (k | o); Qe--)h(Te[Qe], w);
                        for(Xe++; Xe < Te.length && i[Te[Xe]] & (k | o | w); Xe++)i[Te[Xe]] !== w && h(Te[Xe], w);
                    }
                }
                if (c.get(k) || c.get(E) || c.get(M)) for(var Ye = 0; Ye < Te.length; Ye++){
                    var Je = Te[Ye];
                    if (i[Je] & (k | E | M)) {
                        h(Je, D);
                        for(var $e = Ye - 1; $e >= 0 && i[Te[$e]] & o; $e--)h(Te[$e], D);
                        for(var et = Ye + 1; et < Te.length && i[Te[et]] & o; et++)h(Te[et], D);
                    }
                }
                if (c.get(w)) for(var tt = 0, it = De; tt < Te.length; tt++){
                    var nt = Te[tt], at = i[nt];
                    at & w ? it === x && h(nt, x) : at & r && (it = at);
                }
                if (c.get(s)) {
                    for(var rt = b | w | S, st = rt | x, ot = [], lt = [], ct = 0; ct < Te.length; ct++)if (i[Te[ct]] & s) {
                        var ut = e1[Te[ct]], ht = void 0;
                        if (null !== A(ut)) {
                            if (!(lt.length < 63)) break;
                            lt.push({
                                char: ut,
                                seqIndex: ct
                            });
                        } else if (null !== (ht = _(ut))) for(var dt = lt.length - 1; dt >= 0; dt--){
                            var pt = lt[dt].char;
                            if (pt === ht || pt === _(v(ut)) || A(v(pt)) === ut) {
                                ot.push([
                                    lt[dt].seqIndex,
                                    ct
                                ]), lt.length = dt;
                                break;
                            }
                        }
                    }
                    ot.sort(function(e1, t) {
                        return e1[0] - t[0];
                    });
                    for(var mt = 0; mt < ot.length; mt++){
                        for(var gt = ot[mt], ft = gt[0], At = gt[1], _t = !1, vt = 0, yt = ft + 1; yt < At; yt++){
                            var xt = Te[yt];
                            if (i[xt] & st) {
                                _t = !0;
                                var bt = i[xt] & rt ? b : x;
                                if (bt === Ie) {
                                    vt = bt;
                                    break;
                                }
                            }
                        }
                        if (_t && !vt) {
                            vt = De;
                            for(var wt = ft - 1; wt >= 0; wt--){
                                var Et = Te[wt];
                                if (i[Et] & st) {
                                    var kt = i[Et] & rt ? b : x;
                                    vt = kt === Ie ? Ie : kt;
                                    break;
                                }
                            }
                        }
                        if (vt) {
                            if (i[Te[ft]] = i[Te[At]] = vt, vt !== Ie) {
                                for(var St = ft + 1; St < Te.length; St++)if (!(i[Te[St]] & o)) {
                                    u(e1[Te[St]]) & I && (i[Te[St]] = vt);
                                    break;
                                }
                            }
                            if (vt !== Ie) {
                                for(var Mt = At + 1; Mt < Te.length; Mt++)if (!(i[Te[Mt]] & o)) {
                                    u(e1[Te[Mt]]) & I && (i[Te[Mt]] = vt);
                                    break;
                                }
                            }
                        }
                    }
                    for(var Ct = 0; Ct < Te.length; Ct++)if (i[Te[Ct]] & s) {
                        for(var Tt = Ct, Dt = Ct, Pt = De, It = Ct - 1; It >= 0; It--){
                            if (!(i[Te[It]] & o)) {
                                Pt = i[Te[It]] & rt ? b : x;
                                break;
                            }
                            Tt = It;
                        }
                        for(var Ft = Pe, zt = Ct + 1; zt < Te.length; zt++){
                            if (!(i[Te[zt]] & (s | o))) {
                                Ft = i[Te[zt]] & rt ? b : x;
                                break;
                            }
                            Dt = zt;
                        }
                        for(var Rt = Tt; Rt <= Dt; Rt++)i[Te[Rt]] = Pt === Ft ? Pt : Ie;
                        Ct = Dt;
                    }
                }
            }
            for(var Lt = g.start; Lt <= g.end; Lt++){
                var Bt = d[Lt], Ot = i[Lt];
                if (1 & Bt ? Ot & (x | w | S) && d[Lt]++ : Ot & b ? d[Lt]++ : Ot & (S | w) && (d[Lt] += 2), Ot & o && (d[Lt] = 0 === Lt ? g.level : d[Lt - 1]), Lt === g.end || u(e1[Lt]) & (T | C)) for(var Ut = Lt; Ut >= 0 && u(e1[Ut]) & l; Ut--)d[Ut] = g.level;
            }
        }
        return {
            levels: d,
            paragraphs: m
        };
        function Nt(t, n) {
            for(var r = t; r < e1.length; r++){
                var s = i[r];
                if (s & (b | F)) return 1;
                if (s & (C | x) || n && s === V) return 0;
                if (s & a) {
                    var o = jt(r);
                    r = -1 === o ? e1.length : o;
                }
            }
            return 0;
        }
        function jt(t) {
            for(var n = 1, r = t + 1; r < e1.length; r++){
                var s = i[r];
                if (s & C) break;
                if (s & V) {
                    if (0 === --n) return r;
                } else s & a && n++;
            }
            return -1;
        }
    }, e1.getMirroredCharacter = q, e1.getMirroredCharactersMap = function(e1, t, i, n) {
        var a = e1.length;
        i = Math.max(0, null == i ? 0 : +i), n = Math.min(a - 1, null == n ? a - 1 : +n);
        for(var r = new Map, s = i; s <= n; s++)if (1 & t[s]) {
            var o = q(e1[s]);
            null !== o && r.set(s, o);
        }
        return r;
    }, e1.getReorderSegments = G, e1.getReorderedIndices = H, e1.getReorderedString = function(e1, t, i, n) {
        var a = H(e1, t, i, n), r = [].concat(e1);
        return a.forEach(function(i, n) {
            r[n] = (1 & t.levels[i] ? q(e1[i]) : null) || e1[i];
        }), r.join("");
    }, e1.openingToClosingBracket = A, Object.defineProperty(e1, "__esModule", {
        value: !0
    }), e1;
}({}), $785da19a645c07eb$var$lw = /[\u061c\u200e\u200f\u202a-\u202e\u2066-\u2069]/, $785da19a645c07eb$var$cw = new Set([
    "WS",
    "FSI",
    "LRI",
    "RLI",
    "PDI"
]), $785da19a645c07eb$var$uw = new Set([
    "S",
    "B"
]);
function $785da19a645c07eb$var$hw(e1) {
    return e1.level % 2 == 0 ? e1.text : $785da19a645c07eb$var$ow.getMirroredCharacter(e1.text) ?? e1.text;
}
function $785da19a645c07eb$var$dw(e1, t, i, n, a) {
    let r = function(e1, t, i, n) {
        let a = [], r = i;
        for (let s of $785da19a645c07eb$var$Nb(e1.slice(i, n)))a.push({
            index: r,
            text: s,
            level: t[r]
        }), r += s.length;
        return a;
    }(e1, t, n, a);
    !function(e1, t) {
        let i = !0;
        for(let n = e1.length - 1; n >= 0; n--){
            let a = $785da19a645c07eb$var$ow.getBidiCharTypeName(e1[n].text[0]);
            $785da19a645c07eb$var$uw.has(a) ? (e1[n].level = t, i = !0) : i && $785da19a645c07eb$var$cw.has(a) ? e1[n].level = t : i = !1;
        }
    }(r, i);
    let s = "", o = [];
    for (let e1 of function(e1, t) {
        let i = t, n = 1 / 0;
        for (let { level: t } of e1)t > i && (i = t), (1 | t) < n && (n = 1 | t);
        let a = e1.slice();
        for(let e1 = i; e1 >= n; e1--)for(let t = 0; t < a.length; t++){
            if (a[t].level < e1) continue;
            let i = t;
            for(; i + 1 < a.length && a[i + 1].level >= e1;)i++;
            for(let e1 = t, n = i; e1 < n; e1++, n--)[a[e1], a[n]] = [
                a[n],
                a[e1]
            ];
            t = i;
        }
        return a;
    }(r, i)){
        if ($785da19a645c07eb$var$lw.test(e1.text)) continue;
        let t = $785da19a645c07eb$var$hw(e1);
        s += t, o.push(...Array(t.length).fill(e1.index));
    }
    return {
        text: s,
        sourceIndices: o
    };
}
function $785da19a645c07eb$var$pw(e1, t) {
    let { levels: i, paragraphs: n } = $785da19a645c07eb$var$ow.getEmbeddingLevels(e1);
    return (function(e1, t) {
        let i = t.filter((t)=>t > 0 && t < e1.length), n = [
            ...new Set([
                0,
                ...i,
                e1.length
            ])
        ].sort((e1, t)=>e1 - t), a = [];
        for(let e1 = 0; e1 + 1 < n.length; e1++)a.push([
            n[e1],
            n[e1 + 1]
        ]);
        return a;
    })(e1, t.concat(n.map((e1)=>e1.start))).map(([t, a])=>$785da19a645c07eb$var$dw(e1, i, function(e1, t) {
            return e1.find((e1)=>t >= e1.start && t <= e1.end)?.level ?? 0;
        }(n, t), t, a));
}
const $785da19a645c07eb$var$mw = 4294967296, $785da19a645c07eb$var$gw = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8");
var $785da19a645c07eb$var$fw = class {
    constructor(e1){
        this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer, this.buf.byteOffset, this.buf.byteLength), this.pos = 0, this.type = 0, this._valueStart = -1, this.length = this.buf.length;
    }
    readFields(e1, t, i = this.length) {
        let n;
        for(; n = this.nextField(i);)e1(n, t, this);
        return t;
    }
    readMessage(e1, t) {
        return this.readFields(e1, t, this.readVarint() + this.pos);
    }
    readFixed32() {
        let e1 = this.dataView.getUint32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readSFixed32() {
        let e1 = this.dataView.getInt32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readFixed64() {
        let e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * $785da19a645c07eb$var$mw;
        return this.pos += 8, e1;
    }
    readSFixed64() {
        let e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * $785da19a645c07eb$var$mw;
        return this.pos += 8, e1;
    }
    readFloat() {
        let e1 = this.dataView.getFloat32(this.pos, !0);
        return this.pos += 4, e1;
    }
    readDouble() {
        let e1 = this.dataView.getFloat64(this.pos, !0);
        return this.pos += 8, e1;
    }
    readVarint(e1) {
        let t = this.buf, i = t[this.pos++];
        if (i < 128) return i;
        let n, a = 127 & i;
        return n = t[this.pos++], a |= (127 & n) << 7, n < 128 || (n = t[this.pos++], a |= (127 & n) << 14, n < 128) || (n = t[this.pos++], a |= (127 & n) << 21, n < 128) ? a : (n = t[this.pos], a |= (15 & n) << 28, function(e1, t, i) {
            let n, a, r = i.buf;
            if (a = r[i.pos++], n = (112 & a) >> 4, a < 128 || (a = r[i.pos++], n |= (127 & a) << 3, a < 128) || (a = r[i.pos++], n |= (127 & a) << 10, a < 128) || (a = r[i.pos++], n |= (127 & a) << 17, a < 128) || (a = r[i.pos++], n |= (127 & a) << 24, a < 128) || (a = r[i.pos++], n |= (1 & a) << 31, a < 128)) return function(e1, t, i) {
                return i ? 4294967296 * t + (e1 >>> 0) : 4294967296 * (t >>> 0) + (e1 >>> 0);
            }(e1, n, t);
            throw Error("Expected varint not more than 10 bytes");
        }(a, e1, this));
    }
    readSVarint() {
        let e1 = this.readVarint();
        return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
    }
    readBoolean() {
        return !!this.readVarint();
    }
    readString() {
        let e1 = this.readVarint() + this.pos, t = this.pos;
        return this.pos = e1, e1 - t >= 12 && $785da19a645c07eb$var$gw ? $785da19a645c07eb$var$gw.decode(this.buf.subarray(t, e1)) : function(e1, t, i) {
            let n = "", a = t;
            for(; a < i;){
                let t, r, s, o = e1[a], l = null, c = o > 239 ? 4 : o > 223 ? 3 : o > 191 ? 2 : 1;
                if (a + c > i) break;
                1 === c ? o < 128 && (l = o) : 2 === c ? (t = e1[a + 1], 128 == (192 & t) && (l = (31 & o) << 6 | 63 & t, l <= 127 && (l = null))) : 3 === c ? (t = e1[a + 1], r = e1[a + 2], 128 == (192 & t) && 128 == (192 & r) && (l = (15 & o) << 12 | (63 & t) << 6 | 63 & r, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === c && (t = e1[a + 1], r = e1[a + 2], s = e1[a + 3], 128 == (192 & t) && 128 == (192 & r) && 128 == (192 & s) && (l = (15 & o) << 18 | (63 & t) << 12 | (63 & r) << 6 | 63 & s, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, c = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), a += c;
            }
            return n;
        }(this.buf, t, e1);
    }
    readBytes() {
        let e1 = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e1);
        return this.pos = e1, t;
    }
    readPackedVarint(e1 = [], t) {
        let i = this.readPackedEnd();
        for(; this.pos < i;)e1.push(this.readVarint(t));
        return e1;
    }
    readPackedSVarint(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSVarint());
        return e1;
    }
    readPackedBoolean(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readBoolean());
        return e1;
    }
    readPackedFloat(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFloat());
        return e1;
    }
    readPackedDouble(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readDouble());
        return e1;
    }
    readPackedFixed32(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFixed32());
        return e1;
    }
    readPackedSFixed32(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSFixed32());
        return e1;
    }
    readPackedFixed64(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readFixed64());
        return e1;
    }
    readPackedSFixed64(e1 = []) {
        let t = this.readPackedEnd();
        for(; this.pos < t;)e1.push(this.readSFixed64());
        return e1;
    }
    readPackedEnd() {
        return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
    }
    nextField(e1 = this.length) {
        if (this.pos === this._valueStart && this.skip(this.type), this.pos >= e1) return 0;
        let t = this.readVarint();
        return this.type = 7 & t, this._valueStart = this.pos, t >>> 3;
    }
    skip(e1) {
        let t = 7 & e1;
        if (0 === t) for(; this.buf[this.pos++] > 127;);
        else if (2 === t) this.pos = this.readVarint() + this.pos;
        else if (5 === t) this.pos += 4;
        else {
            if (1 !== t) throw Error(`Unimplemented type: ${t}`);
            this.pos += 8;
        }
    }
};
function $785da19a645c07eb$var$Aw(e1, t, i) {
    1 === e1 && i.readMessage($785da19a645c07eb$var$_w, t);
}
function $785da19a645c07eb$var$_w(e1, t, i) {
    if (3 === e1) {
        let { id: e1, bitmap: n, width: a, height: r, left: s, top: o, advance: l } = i.readMessage($785da19a645c07eb$var$vw, {});
        t.push({
            id: e1,
            bitmap: new $785da19a645c07eb$var$Zv({
                width: a + 6,
                height: r + 6
            }, n),
            metrics: {
                width: a,
                height: r,
                left: s,
                top: o,
                advance: l
            }
        });
    }
}
function $785da19a645c07eb$var$vw(e1, t, i) {
    1 === e1 ? t.id = i.readVarint() : 2 === e1 ? t.bitmap = i.readBytes() : 3 === e1 ? t.width = i.readVarint() : 4 === e1 ? t.height = i.readVarint() : 5 === e1 ? t.left = i.readSVarint() : 6 === e1 ? t.top = i.readSVarint() : 7 === e1 && (t.advance = i.readVarint());
}
function $785da19a645c07eb$var$yw(e1) {
    return "function" == typeof e1?.renderWithWebGL;
}
function $785da19a645c07eb$var$xw(e1) {
    let { userImage: t } = e1;
    return !(!t?.render || !t.render()) && ($785da19a645c07eb$var$yw(t.data) || e1.data.replace(new Uint8Array(t.data.buffer)), !0);
}
function $785da19a645c07eb$var$bw(e1) {
    let t = 0, i = 0;
    for (let n of e1)t += n.w * n.h, i = Math.max(i, n.w);
    e1.sort((e1, t)=>t.h - e1.h);
    let n = [
        {
            x: 0,
            y: 0,
            w: Math.max(Math.ceil(Math.sqrt(t / .95)), i),
            h: 1 / 0
        }
    ], a = 0, r = 0;
    for (let t of e1)for(let e1 = n.length - 1; e1 >= 0; e1--){
        let i = n[e1];
        if (!(t.w > i.w || t.h > i.h)) {
            if (t.x = i.x, t.y = i.y, r = Math.max(r, t.y + t.h), a = Math.max(a, t.x + t.w), t.w === i.w && t.h === i.h) {
                let t = n.pop();
                t && e1 < n.length && (n[e1] = t);
            } else t.h === i.h ? (i.x += t.w, i.w -= t.w) : t.w === i.w ? (i.y += t.h, i.h -= t.h) : (n.push({
                x: i.x + t.w,
                y: i.y,
                w: i.w - t.w,
                h: t.h
            }), i.y += t.h, i.h -= t.h);
            break;
        }
    }
    return {
        w: a,
        h: r,
        fill: t / (a * r) || 0
    };
}
var $785da19a645c07eb$var$ww = class {
    constructor(e1, { pixelRatio: t, version: i, isWebGLImage: n = !1, stretchX: a, stretchY: r, content: s, textFitWidth: o, textFitHeight: l }){
        this.paddedRect = e1, this.pixelRatio = t, this.stretchX = a, this.stretchY = r, this.content = s, this.version = i, this.needsFirstWebGLRender = n, this.textFitWidth = o, this.textFitHeight = l;
    }
    get tl() {
        return [
            this.paddedRect.x + 1,
            this.paddedRect.y + 1
        ];
    }
    get br() {
        return [
            this.paddedRect.x + this.paddedRect.w - 1,
            this.paddedRect.y + this.paddedRect.h - 1
        ];
    }
    get tlbr() {
        return this.tl.concat(this.br);
    }
    get displaySize() {
        return [
            (this.paddedRect.w - 2) / this.pixelRatio,
            (this.paddedRect.h - 2) / this.pixelRatio
        ];
    }
};
$785da19a645c07eb$var$qf("ImagePosition", $785da19a645c07eb$var$ww), $785da19a645c07eb$var$qf("ImageAtlas", class {
    constructor(e1, t){
        let i = {}, n = {};
        this.haveRenderCallbacks = [], this.patchedUpdateVersion = -1;
        let a = [];
        this.addImages(e1, i, a), this.addImages(t, n, a);
        let { w: r, h: s } = $785da19a645c07eb$var$bw(a), o = new $785da19a645c07eb$var$Kv({
            width: r || 1,
            height: s || 1
        });
        for(let t in e1){
            let n = e1[t];
            if (n.isWebGLImage) continue;
            let a = i[t].paddedRect;
            $785da19a645c07eb$var$Kv.copy(n.data, o, {
                x: 0,
                y: 0
            }, {
                x: a.x + 1,
                y: a.y + 1
            }, n.data);
        }
        for(let e1 in t){
            let i = t[e1], a = n[e1].paddedRect, r = a.x + 1, s = a.y + 1, l = i.data.width, c = i.data.height;
            $785da19a645c07eb$var$Kv.copy(i.data, o, {
                x: 0,
                y: 0
            }, {
                x: r,
                y: s
            }, i.data), $785da19a645c07eb$var$Kv.copy(i.data, o, {
                x: 0,
                y: c - 1
            }, {
                x: r,
                y: s - 1
            }, {
                width: l,
                height: 1
            }), $785da19a645c07eb$var$Kv.copy(i.data, o, {
                x: 0,
                y: 0
            }, {
                x: r,
                y: s + c
            }, {
                width: l,
                height: 1
            }), $785da19a645c07eb$var$Kv.copy(i.data, o, {
                x: l - 1,
                y: 0
            }, {
                x: r - 1,
                y: s
            }, {
                width: 1,
                height: c
            }), $785da19a645c07eb$var$Kv.copy(i.data, o, {
                x: 0,
                y: 0
            }, {
                x: r + l,
                y: s
            }, {
                width: 1,
                height: c
            });
        }
        this.image = o, this.iconPositions = i, this.patternPositions = n;
    }
    addImages(e1, t, i) {
        for(let n in e1){
            let a = e1[n], r = {
                x: 0,
                y: 0,
                w: a.data.width + 2,
                h: a.data.height + 2
            };
            i.push(r), t[n] = new $785da19a645c07eb$var$ww(r, a), a.hasRenderCallback && this.haveRenderCallbacks.push(n);
        }
    }
    patchUpdatedImages(e1, t) {
        if (e1.dispatchRenderCallbacks(this.haveRenderCallbacks), this.patchedUpdateVersion !== e1.updateVersion) {
            this.patchedUpdateVersion = e1.updateVersion;
            for(let i in this.iconPositions)this.patchUpdatedImage(this.iconPositions[i], e1.getImage(i), t);
            for(let i in this.patternPositions)this.patchUpdatedImage(this.patternPositions[i], e1.getImage(i), t);
        }
    }
    patchUpdatedImage(e1, t, i) {
        if (!e1 || !t || !e1.needsFirstWebGLRender && e1.version === t.version) return;
        e1.needsFirstWebGLRender = !1, e1.version = t.version;
        let [n, a] = e1.tl, r = t.userImage?.data;
        if (!$785da19a645c07eb$var$yw(r)) return void i.update(t.data, void 0, {
            x: n,
            y: a
        });
        let { width: s, height: o } = t.data;
        i.context.setCustomLayerDefaults(), r.renderWithWebGL({
            gl: i.context.gl,
            texture: i.texture,
            x: n,
            y: a,
            width: s,
            height: o
        }), i.context.setDirty();
    }
});
var $785da19a645c07eb$var$Ew = function(e1) {
    return e1[e1.none = 0] = "none", e1[e1.horizontal = 1] = "horizontal", e1[e1.vertical = 2] = "vertical", e1[e1.horizontalOnly = 3] = "horizontalOnly", e1;
}($785da19a645c07eb$var$Ew || {});
const $785da19a645c07eb$var$kw = /^\p{gc=M}$/u;
function $785da19a645c07eb$var$Sw(e1, t) {
    let i = t.map((t)=>e1.toCodeUnitIndex(t)), n = $785da19a645c07eb$var$vb.isParsed() ? $785da19a645c07eb$var$vb : null;
    if (1 === e1.sections.length) return n ? n.processBidirectionalText(e1.toString(), i).map((t)=>$785da19a645c07eb$var$Tw(t, e1.sections, [
            ...t
        ].map(()=>0))) : (function(e1, t) {
        return $785da19a645c07eb$var$pw(e1, t).map((e1)=>e1.text);
    })(e1.toString(), i).map((t)=>$785da19a645c07eb$var$Mw([
            ...t
        ], e1.sections, [
            ...t
        ].map(()=>0)));
    let a = function(e1) {
        let t = [], i = 0;
        for (let n of e1.graphemes())t.push(...Array(n.length).fill(e1.sectionIndex[i])), i++;
        return t;
    }(e1);
    return n ? n.processStyledBidirectionalText(e1.text, a, i).map(([t, i])=>$785da19a645c07eb$var$Tw(t, e1.sections, i)) : (function(e1, t, i) {
        return $785da19a645c07eb$var$pw(e1, i).map((e1)=>[
                e1.text,
                e1.sourceIndices.map((e1)=>t[e1] ?? 0)
            ]);
    })(e1.text, a, i).map(([t, i])=>{
        let n = [
            ...t
        ];
        return $785da19a645c07eb$var$Mw(n, e1.sections, $785da19a645c07eb$var$Cw(n).map((e1)=>i[e1] ?? 0));
    });
}
function $785da19a645c07eb$var$Mw(e1, t, i) {
    let n = new $785da19a645c07eb$var$sw(e1.join(""), t, []), a = 0;
    for (let e1 of n.graphemes())n.sectionIndex.push(i[a] ?? 0), a += [
        ...e1
    ].length;
    return n;
}
function $785da19a645c07eb$var$Cw(e1) {
    let t = [], i = 0;
    for (let n of e1)t.push(i), i += n.length;
    return t;
}
function $785da19a645c07eb$var$Tw(e1, t, i) {
    let n = [
        ...e1
    ], a = $785da19a645c07eb$var$Cw(n), r = function(e1) {
        let t = [], i = 0;
        for(; i < e1.length;){
            if (!$785da19a645c07eb$var$kw.test(e1[i])) {
                t.push(i), i++;
                continue;
            }
            let n = i;
            for(; n < e1.length && $785da19a645c07eb$var$kw.test(e1[n]);)n++;
            let a = e1[n];
            if (void 0 !== a && $785da19a645c07eb$var$Xb(a.codePointAt(0))) {
                t.push(n);
                for(let e1 = n - 1; e1 >= i; e1--)t.push(e1);
                i = n + 1;
            } else {
                for(let e1 = i; e1 < n; e1++)t.push(e1);
                i = n;
            }
        }
        return t;
    }(n);
    return $785da19a645c07eb$var$Mw(r.map((e1)=>n[e1]), t, r.map((e1)=>i[a[e1]] ?? 0));
}
function $785da19a645c07eb$var$Dw(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m) {
    let g = $785da19a645c07eb$var$sw.fromFeature(e1, a);
    2 === h && g.verticalizePunctuation();
    let f = g.determineLineBreaks(c, r, t, n, p), A = $785da19a645c07eb$var$Qb(g.text) ? $785da19a645c07eb$var$Sw(g, f) : function(e1, t) {
        let i = [], n = 0;
        for (let a of t)i.push(e1.substring(n, a)), n = a;
        return n < e1.length() && i.push(e1.substring(n, e1.length())), i;
    }(g, f), _ = [], v = {
        positionedLines: _,
        text: g.toString(),
        top: u[1],
        bottom: u[1],
        left: u[0],
        right: u[0],
        writingMode: h,
        iconsInText: !1,
        verticalizable: !1
    };
    return function(e1, t, i, n, a, r, s, o, l, c, u, h) {
        let d = 0, p = 0, m = 0, g = 0, f = "right" === o ? 1 : "left" === o ? 0 : .5, A = 24 / h, _ = 0;
        for (let s of a){
            s.trim();
            let a = s.getMaxScale(), o = {
                positionedGlyphs: [],
                lineOffset: 0
            };
            e1.positionedLines[_] = o;
            let h = o.positionedGlyphs, v = 0;
            if (!s.length()) {
                p += r, ++_;
                continue;
            }
            let y = $785da19a645c07eb$var$Iw(n, s, A), x = 2 !== l || u ? null : $785da19a645c07eb$var$Uw(s), b = s.graphemes();
            for(let r = 0; r < b.length; r++){
                let o = s.getSection(r), m = b[r], g = m.codePointAt(0), f = x ? x[r] : $785da19a645c07eb$var$zw(l, u, g), _ = "fontStack" in o && $785da19a645c07eb$var$Vb(m) && !t[o.fontStack]?.[m] ? [
                    ...m
                ] : [
                    m
                ];
                for (let l of _){
                    let u, m = {
                        glyph: l.codePointAt(0),
                        grapheme: l,
                        imageName: null,
                        x: d,
                        y: p + -17,
                        vertical: f,
                        scale: 1,
                        fontStack: "",
                        sectionIndex: s.getSectionIndex(r),
                        metrics: null,
                        rect: null
                    };
                    if ("fontStack" in o) {
                        if (u = $785da19a645c07eb$var$Nw(o, l, f, y, t, i), !u) continue;
                        m.fontStack = o.fontStack;
                    } else {
                        if (e1.iconsInText = !0, o.scale *= A, u = $785da19a645c07eb$var$jw(o, f, a, y, n), !u) continue;
                        v = Math.max(v, u.imageOffset), m.imageName = o.imageName;
                    }
                    let { rect: g, metrics: _, baselineOffset: x } = u;
                    if (m.y += x, m.scale = o.scale, m.metrics = _, m.rect = g, h.push(m), f) e1.verticalizable = !0, d += ("imageName" in o ? _.advance : 24) * o.scale + c;
                    else d += _.advance * o.scale + c;
                }
            }
            if (0 !== h.length) {
                let e1 = d - c;
                m = Math.max(e1, m), $785da19a645c07eb$var$Vw(h, 0, h.length - 1, f);
            }
            d = 0;
            let w = 24 * (a - 1);
            o.lineOffset = Math.max(v, w);
            let E = r * a + v;
            p += E, g = Math.max(E, g), ++_;
        }
        let { horizontalAlign: v, verticalAlign: y } = $785da19a645c07eb$var$Pw(s);
        (function(e1, t, i, n, a, r, s, o, l) {
            let c = (t - i) * a, u = 0;
            u = r === s ? -n * l * s + .5 * s : -o * n - -17;
            for (let t of e1)for (let e1 of t.positionedGlyphs)e1.x += c, e1.y += u;
        })(e1.positionedLines, f, v, y, m, g, r, p, a.length), e1.top += -y * p, e1.bottom = e1.top + p, e1.left += -v * m, e1.right = e1.left + m;
    }(v, t, i, n, A, s, o, l, h, c, d, m), !function(e1) {
        for (let t of e1)if (0 !== t.positionedGlyphs.length) return !1;
        return !0;
    }(_) && v;
}
function $785da19a645c07eb$var$Pw(e1) {
    let t = .5, i = .5;
    switch(e1){
        case "right":
        case "top-right":
        case "bottom-right":
            t = 1;
            break;
        case "left":
        case "top-left":
        case "bottom-left":
            t = 0;
    }
    switch(e1){
        case "bottom":
        case "bottom-right":
        case "bottom-left":
            i = 1;
            break;
        case "top":
        case "top-right":
        case "top-left":
            i = 0;
    }
    return {
        horizontalAlign: t,
        verticalAlign: i
    };
}
function $785da19a645c07eb$var$Iw(e1, t, i) {
    let n = 24 * t.getMaxScale(), { maxImageWidth: a, maxImageHeight: r } = t.getMaxImageSize(e1), s = Math.max(n, r * i);
    return {
        verticalLineContentWidth: Math.max(n, a * i),
        horizontalLineContentHeight: s
    };
}
function $785da19a645c07eb$var$Fw(e1) {
    switch(e1){
        case "top":
            return 0;
        case "center":
            return .5;
        default:
            return 1;
    }
}
function $785da19a645c07eb$var$zw(e1, t, i) {
    return !(1 === e1 || !t && !$785da19a645c07eb$var$xb(i) || t && ($785da19a645c07eb$var$qb(i) || $785da19a645c07eb$var$Kb(i)));
}
function $785da19a645c07eb$var$Rw(e1) {
    return /\p{Nd}/u.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$Lw(e1) {
    return /\p{Lu}/u.test(String.fromCodePoint(e1));
}
function $785da19a645c07eb$var$Bw(e1) {
    let t = e1.some($785da19a645c07eb$var$Rw) && e1.every((e1)=>$785da19a645c07eb$var$Rw(e1) || function(e1) {
            return /[\p{P}\p{S}]/u.test(String.fromCodePoint(e1));
        }(e1)), i = e1.length <= 3 && e1.every((e1)=>$785da19a645c07eb$var$Lw(e1) || $785da19a645c07eb$var$Rw(e1));
    return t || i;
}
function $785da19a645c07eb$var$Ow(e1) {
    return ($785da19a645c07eb$var$Rw(e1) || $785da19a645c07eb$var$Lw(e1)) && !$785da19a645c07eb$var$Kb(e1);
}
function $785da19a645c07eb$var$Uw(e1) {
    let t = e1.graphemes().slice(), i = t.map((e1)=>e1.codePointAt(0)), n = i.map($785da19a645c07eb$var$xb), a = (t)=>!n[t] && !$785da19a645c07eb$var$qb(i[t]) && !("imageName" in e1.getSection(t));
    for(let e1 = 0; e1 < i.length; e1++){
        if (!a(e1)) continue;
        let t = e1;
        for(; t + 1 < i.length && a(t + 1);)t++;
        if ($785da19a645c07eb$var$Bw(i.slice(e1, t + 1))) for(let a = e1; a <= t; a++)n[a] = $785da19a645c07eb$var$Ow(i[a]);
        e1 = t;
    }
    return function(e1, t) {
        let i = !1;
        for(let n = 0; n < e1.length; n++){
            if (t[n]) continue;
            let a = $785da19a645c07eb$var$Yb[e1[n]];
            a && (0 === n || t[n - 1]) && (n === e1.length - 1 || t[n + 1]) && (e1[n] = a, t[n] = !0, i = !0);
        }
        return i;
    }(t, n) && (e1.text = t.join(""), e1._graphemes = null), n;
}
function $785da19a645c07eb$var$Nw(e1, t, i, n, a, r) {
    let s, o = r[e1.fontStack]?.[t], l = function(e1, t, i, n) {
        if (e1?.rect) return e1;
        let a = t[i.fontStack]?.[n];
        return a ? {
            rect: null,
            metrics: a.metrics
        } : null;
    }(o, a, e1, t);
    if (null === l) return null;
    if (i) s = n.verticalLineContentWidth - 24 * e1.scale;
    else {
        let t = $785da19a645c07eb$var$Fw(e1.verticalAlign);
        s = (n.horizontalLineContentHeight - 24 * e1.scale) * t;
    }
    return {
        rect: l.rect,
        metrics: l.metrics,
        baselineOffset: s
    };
}
function $785da19a645c07eb$var$jw(e1, t, i, n, a) {
    let r = a[e1.imageName];
    if (!r) return null;
    let s, o = r.paddedRect, l = r.displaySize, c = {
        width: l[0],
        height: l[1],
        left: 1,
        top: -3,
        advance: t ? l[1] : l[0]
    };
    if (t) s = n.verticalLineContentWidth - l[1] * e1.scale;
    else {
        let t = $785da19a645c07eb$var$Fw(e1.verticalAlign);
        s = (n.horizontalLineContentHeight - l[1] * e1.scale) * t;
    }
    return {
        rect: o,
        metrics: c,
        baselineOffset: s,
        imageOffset: (t ? l[0] : l[1]) * e1.scale - 24 * i
    };
}
function $785da19a645c07eb$var$Vw(e1, t, i, n) {
    if (0 === n) return;
    let a = e1[i], r = a.metrics.advance * a.scale, s = (e1[i].x + r) * n;
    for(let n = t; n <= i; n++)e1[n].x -= s;
}
function $785da19a645c07eb$var$qw(e1, t, i) {
    let { horizontalAlign: n, verticalAlign: a } = $785da19a645c07eb$var$Pw(i), r = t[0], s = t[1], o = r - e1.displaySize[0] * n, l = o + e1.displaySize[0], c = s - e1.displaySize[1] * a;
    return {
        image: e1,
        top: c,
        bottom: c + e1.displaySize[1],
        left: o,
        right: l
    };
}
function $785da19a645c07eb$var$Gw(e1) {
    let t = e1.left, i = e1.top, n = e1.right - t, a = e1.bottom - i, r = e1.image.content[2] - e1.image.content[0], s = e1.image.content[3] - e1.image.content[1], o = e1.image.textFitWidth ?? "stretchOrShrink", l = e1.image.textFitHeight ?? "stretchOrShrink", c = r / s;
    if ("proportional" === l) {
        if ("stretchOnly" === o && n / a < c || "proportional" === o) {
            let e1 = Math.ceil(a * c);
            t *= e1 / n, n = e1;
        }
    } else if ("proportional" === o && "stretchOnly" === l && 0 !== c && n / a > c) {
        let e1 = Math.ceil(n / c);
        i *= e1 / a, a = e1;
    }
    return {
        x1: t,
        y1: i,
        x2: t + n,
        y2: i + a
    };
}
function $785da19a645c07eb$var$Hw(e1, t, i, n, a, r) {
    let s, o = e1.image;
    if (o.content) {
        let e1 = o.content, t = o.pixelRatio || 1;
        s = [
            e1[0] / t,
            e1[1] / t,
            o.displaySize[0] - e1[2] / t,
            o.displaySize[1] - e1[3] / t
        ];
    }
    let l, c, u, h, d = t.left * r, p = t.right * r;
    "width" === i || "both" === i ? (h = a[0] + d - n[3], c = a[0] + p + n[1]) : (h = a[0] + (d + p - o.displaySize[0]) / 2, c = h + o.displaySize[0]);
    let m = t.top * r, g = t.bottom * r;
    return "height" === i || "both" === i ? (l = a[1] + m - n[0], u = a[1] + g + n[2]) : (l = a[1] + (m + g - o.displaySize[1]) / 2, u = l + o.displaySize[1]), {
        image: o,
        top: l,
        right: c,
        bottom: u,
        left: h,
        collisionPadding: s
    };
}
function $785da19a645c07eb$var$Ww(e1, t) {
    let { expression: i } = t;
    if ("constant" === i.kind) return {
        kind: "constant",
        layoutSize: i.evaluate(new $785da19a645c07eb$var$Qf(e1 + 1))
    };
    if ("source" === i.kind) return {
        kind: "source"
    };
    if ("composite" === i.kind) {
        let { minZoom: t, maxZoom: n } = function(e1, t) {
            let i = 0;
            for(; i < e1.length && e1[i] <= t;)i++;
            i = Math.max(0, i - 1);
            let n = i;
            for(; n < e1.length && e1[n] < t + 1;)n++;
            return n = Math.min(e1.length - 1, n), {
                minZoom: e1[i],
                maxZoom: e1[n]
            };
        }(i.zoomStops, e1);
        return {
            kind: "composite",
            minZoom: t,
            maxZoom: n,
            interpolationType: i.interpolationType
        };
    }
    {
        let t = function(e1) {
            return e1.zoomStops.map((t)=>e1.evaluate(new $785da19a645c07eb$var$Qf(t === -1 / 0 ? e1.zoomStops[1] - 1 : t)));
        }(i), n = i.evaluate(new $785da19a645c07eb$var$Qf(e1 + 1));
        return {
            kind: "camera",
            zoomStops: i.zoomStops,
            sizes: t,
            layoutSize: n,
            interpolationType: i.interpolationType
        };
    }
}
function $785da19a645c07eb$var$Zw(e1, { uSize: t, uSizeT: i }, { lowerSize: n, upperSize: a }) {
    return "source" === e1.kind ? n / 128 : "composite" === e1.kind ? $785da19a645c07eb$var$Mp.number(n / 128, a / 128, i) : t;
}
function $785da19a645c07eb$var$Kw(e1, t) {
    let i = 0, n = 0;
    return "constant" === e1.kind ? n = e1.layoutSize : "camera" === e1.kind ? n = function({ zoomStops: e1, sizes: t, layoutSize: i, interpolationType: n }, a) {
        let r = e1.length - 1;
        for(; r > 0 && e1[r] > a;)r--;
        let s = Math.min(r + 1, e1.length - 1), o = n ? $785da19a645c07eb$var$ch($785da19a645c07eb$var$kp.interpolationFactor(n, a, e1[r], e1[s]), 0, 1) : 0;
        return Math.min($785da19a645c07eb$var$Mp.number(t[r], t[s], o), i);
    }(e1, t) : "composite" === e1.kind && (i = function({ interpolationType: e1, minZoom: t, maxZoom: i }, n) {
        return e1 ? $785da19a645c07eb$var$ch($785da19a645c07eb$var$kp.interpolationFactor(e1, n, t, i), 0, 1) : 0;
    }(e1, t)), {
        uSizeT: i,
        uSize: n
    };
}
var $785da19a645c07eb$var$Xw = class e1 extends $785da19a645c07eb$var$Kc {
    constructor(e1, t, i, n){
        super(e1, t), this.angle = i, void 0 !== n && (this.segment = n);
    }
    clone() {
        return new e1(this.x, this.y, this.angle, this.segment);
    }
};
function $785da19a645c07eb$var$Qw(e1, t, i, n, a) {
    if (void 0 === t.segment || 0 === i) return !0;
    let r = t, s = t.segment + 1, o = 0;
    for(; o > -i / 2;){
        if (s--, s < 0) return !1;
        o -= e1[s].dist(r), r = e1[s];
    }
    o += e1[s].dist(e1[s + 1]), s++;
    let l = [], c = 0;
    for(; o < i / 2;){
        let t = e1[s - 1], i = e1[s], r = e1[s + 1];
        if (!r) return !1;
        let u = t.angleTo(i) - i.angleTo(r);
        for(u = Math.abs((u + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
            distance: o,
            angleDelta: u
        }), c += u; o - l[0].distance > n;)c -= l.shift().angleDelta;
        if (c > a) return !1;
        s++, o += i.dist(r);
    }
    return !0;
}
function $785da19a645c07eb$var$Yw(e1) {
    let t = 0;
    for(let i = 0; i < e1.length - 1; i++)t += e1[i].dist(e1[i + 1]);
    return t;
}
function $785da19a645c07eb$var$Jw(e1, t, i) {
    return e1 ? .6 * t * i : 0;
}
function $785da19a645c07eb$var$$w(e1, t) {
    return Math.max(e1 ? e1.right - e1.left : 0, t ? t.right - t.left : 0);
}
function $785da19a645c07eb$var$eE(e1, t, i, n, a, r) {
    let s = $785da19a645c07eb$var$Jw(i, a, r), o = $785da19a645c07eb$var$$w(i, n) * r, l = 0, c = $785da19a645c07eb$var$Yw(e1) / 2;
    for(let i = 0; i < e1.length - 1; i++){
        let n = e1[i], a = e1[i + 1], r = n.dist(a);
        if (l + r > c) {
            let u = (c - l) / r, h = new $785da19a645c07eb$var$Xw($785da19a645c07eb$var$Mp.number(n.x, a.x, u), $785da19a645c07eb$var$Mp.number(n.y, a.y, u), a.angleTo(n), i);
            return h._round(), !s || $785da19a645c07eb$var$Qw(e1, h, o, s, t) ? h : void 0;
        }
        l += r;
    }
}
function $785da19a645c07eb$var$tE(e1, t, i, n, a, r, s, o, l) {
    let c = $785da19a645c07eb$var$Jw(n, r, s), u = $785da19a645c07eb$var$$w(n, a), h = u * s, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
    return t - h < t / 4 && (t = h + t / 4), $785da19a645c07eb$var$iE(e1, d ? t / 2 * o % t : (u / 2 + 2 * r) * s * o % t, t, c, i, h, d, !1, l);
}
function $785da19a645c07eb$var$iE(e1, t, i, n, a, r, s, o, l) {
    let c = r / 2, u = $785da19a645c07eb$var$Yw(e1), h = 0, d = t - i, p = [];
    for(let t = 0; t < e1.length - 1; t++){
        let s = e1[t], o = e1[t + 1], m = s.dist(o), g = o.angleTo(s);
        for(; d + i < h + m;){
            d += i;
            let f = (d - h) / m, A = $785da19a645c07eb$var$Mp.number(s.x, o.x, f), _ = $785da19a645c07eb$var$Mp.number(s.y, o.y, f);
            if (A >= 0 && A < l && _ >= 0 && _ < l && d - c >= 0 && d + c <= u) {
                let i = new $785da19a645c07eb$var$Xw(A, _, g, t);
                i._round(), (!n || $785da19a645c07eb$var$Qw(e1, i, r, n, a)) && p.push(i);
            }
        }
        h += m;
    }
    return !o && !p.length && !s && (p = $785da19a645c07eb$var$iE(e1, h / 2, i, n, a, r, s, !0, l)), p;
}
function $785da19a645c07eb$var$nE(e1, t, i, n, a) {
    let r = [];
    for (let s of e1){
        let e1;
        for(let o = 0; o < s.length - 1; o++){
            let l = s[o], c = s[o + 1];
            l.x < t && c.x < t || (l.x < t ? l = new $785da19a645c07eb$var$Kc(t, l.y + (c.y - l.y) * ((t - l.x) / (c.x - l.x)))._round() : c.x < t && (c = new $785da19a645c07eb$var$Kc(t, l.y + (c.y - l.y) * ((t - l.x) / (c.x - l.x)))._round()), !(l.y < i && c.y < i) && (l.y < i ? l = new $785da19a645c07eb$var$Kc(l.x + (c.x - l.x) * ((i - l.y) / (c.y - l.y)), i)._round() : c.y < i && (c = new $785da19a645c07eb$var$Kc(l.x + (c.x - l.x) * ((i - l.y) / (c.y - l.y)), i)._round()), !(l.x >= n && c.x >= n) && (l.x >= n ? l = new $785da19a645c07eb$var$Kc(n, l.y + (c.y - l.y) * ((n - l.x) / (c.x - l.x)))._round() : c.x >= n && (c = new $785da19a645c07eb$var$Kc(n, l.y + (c.y - l.y) * ((n - l.x) / (c.x - l.x)))._round()), !(l.y >= a && c.y >= a) && (l.y >= a ? l = new $785da19a645c07eb$var$Kc(l.x + (c.x - l.x) * ((a - l.y) / (c.y - l.y)), a)._round() : c.y >= a && (c = new $785da19a645c07eb$var$Kc(l.x + (c.x - l.x) * ((a - l.y) / (c.y - l.y)), a)._round()), (!e1 || !l.equals(e1[e1.length - 1])) && (e1 = [
                l
            ], r.push(e1)), e1.push(c)))));
        }
    }
    return r;
}
function $785da19a645c07eb$var$aE(e1, t, i, n) {
    let a = [], r = e1.image, s = r.pixelRatio, o = r.paddedRect.w - 2, l = r.paddedRect.h - 2, c = {
        x1: e1.left,
        y1: e1.top,
        x2: e1.right,
        y2: e1.bottom
    }, u = r.stretchX || [
        [
            0,
            o
        ]
    ], h = r.stretchY || [
        [
            0,
            l
        ]
    ], d = (e1, t)=>e1 + t[1] - t[0], p = u.reduce(d, 0), m = h.reduce(d, 0), g = o - p, f = l - m, A = 0, _ = p, v = 0, y = m, x = 0, b = g, w = 0, E = f;
    if (r.content && n) {
        let t = r.content, i = t[2] - t[0], n = t[3] - t[1];
        (r.textFitWidth || r.textFitHeight) && (c = $785da19a645c07eb$var$Gw(e1)), A = $785da19a645c07eb$var$rE(u, 0, t[0]), v = $785da19a645c07eb$var$rE(h, 0, t[1]), _ = $785da19a645c07eb$var$rE(u, t[0], t[2]), y = $785da19a645c07eb$var$rE(h, t[1], t[3]), x = t[0] - A, w = t[1] - v, b = i - _, E = n - y;
    }
    let k = c.x1, S = c.y1, M = c.x2 - k, C = c.y2 - S, T = (e1, n, a, o)=>{
        let l = $785da19a645c07eb$var$oE(e1.stretch - A, _, M, k), c = $785da19a645c07eb$var$lE(e1.fixed - x, b, e1.stretch, p), u = $785da19a645c07eb$var$oE(n.stretch - v, y, C, S), h = $785da19a645c07eb$var$lE(n.fixed - w, E, n.stretch, m), d = $785da19a645c07eb$var$oE(a.stretch - A, _, M, k), g = $785da19a645c07eb$var$lE(a.fixed - x, b, a.stretch, p), f = $785da19a645c07eb$var$oE(o.stretch - v, y, C, S), T = $785da19a645c07eb$var$lE(o.fixed - w, E, o.stretch, m), D = new $785da19a645c07eb$var$Kc(l, u), P = new $785da19a645c07eb$var$Kc(d, u), I = new $785da19a645c07eb$var$Kc(d, f), F = new $785da19a645c07eb$var$Kc(l, f), z = new $785da19a645c07eb$var$Kc(c / s, h / s), R = new $785da19a645c07eb$var$Kc(g / s, T / s), L1 = t * Math.PI / 180;
        if (L1) {
            let e1 = Math.sin(L1), t = Math.cos(L1), i = [
                t,
                -e1,
                e1,
                t
            ];
            D._matMult(i), P._matMult(i), F._matMult(i), I._matMult(i);
        }
        let B = e1.stretch + e1.fixed, O = a.stretch + a.fixed, U = n.stretch + n.fixed, N = o.stretch + o.fixed;
        return {
            tl: D,
            tr: P,
            bl: F,
            br: I,
            tex: {
                x: r.paddedRect.x + 1 + B,
                y: r.paddedRect.y + 1 + U,
                w: O - B,
                h: N - U
            },
            writingMode: void 0,
            glyphOffset: [
                0,
                0
            ],
            sectionIndex: 0,
            pixelOffsetTL: z,
            pixelOffsetBR: R,
            minFontScaleX: b / s / M,
            minFontScaleY: E / s / C,
            isSDF: i
        };
    };
    if (n && (r.stretchX || r.stretchY)) {
        let e1 = $785da19a645c07eb$var$sE(u, g, p), t = $785da19a645c07eb$var$sE(h, f, m);
        for(let i = 0; i < e1.length - 1; i++){
            let n = e1[i], r = e1[i + 1];
            for(let e1 = 0; e1 < t.length - 1; e1++){
                let i = t[e1], s = t[e1 + 1];
                a.push(T(n, i, r, s));
            }
        }
    } else a.push(T({
        fixed: 0,
        stretch: -1
    }, {
        fixed: 0,
        stretch: -1
    }, {
        fixed: 0,
        stretch: o + 1
    }, {
        fixed: 0,
        stretch: l + 1
    }));
    return a;
}
function $785da19a645c07eb$var$rE(e1, t, i) {
    let n = 0;
    for (let a of e1)n += Math.max(t, Math.min(i, a[1])) - Math.max(t, Math.min(i, a[0]));
    return n;
}
function $785da19a645c07eb$var$sE(e1, t, i) {
    let n = [
        {
            fixed: -1,
            stretch: 0
        }
    ];
    for (let [t, i] of e1){
        let e1 = n[n.length - 1];
        n.push({
            fixed: t - e1.stretch,
            stretch: e1.stretch
        }), n.push({
            fixed: t - e1.stretch,
            stretch: e1.stretch + (i - t)
        });
    }
    return n.push({
        fixed: t + 1,
        stretch: i
    }), n;
}
function $785da19a645c07eb$var$oE(e1, t, i, n) {
    return e1 / t * i + n;
}
function $785da19a645c07eb$var$lE(e1, t, i, n) {
    return e1 - t * i / n;
}
$785da19a645c07eb$var$qf("Anchor", $785da19a645c07eb$var$Xw);
var $785da19a645c07eb$var$cE = class {
    constructor(e1, t, i, n, a, r, s, o, l, c){
        if (this.boxStartIndex = e1.length, l) {
            let e1 = r.top, t = r.bottom, i = r.collisionPadding;
            i && (e1 -= i[1], t += i[3]);
            let n = t - e1;
            n > 0 && (n = Math.max(10, n), this.circleDiameter = n);
        } else {
            let l = r.image?.content && (r.image.textFitWidth || r.image.textFitHeight) ? $785da19a645c07eb$var$Gw(r) : {
                x1: r.left,
                y1: r.top,
                x2: r.right,
                y2: r.bottom
            };
            l.y1 = l.y1 * s - o[0], l.y2 = l.y2 * s + o[2], l.x1 = l.x1 * s - o[3], l.x2 = l.x2 * s + o[1];
            let u = r.collisionPadding;
            if (u && (l.x1 -= u[0] * s, l.y1 -= u[1] * s, l.x2 += u[2] * s, l.y2 += u[3] * s), c) {
                let e1 = new $785da19a645c07eb$var$Kc(l.x1, l.y1), t = new $785da19a645c07eb$var$Kc(l.x2, l.y1), i = new $785da19a645c07eb$var$Kc(l.x1, l.y2), n = new $785da19a645c07eb$var$Kc(l.x2, l.y2), a = c * Math.PI / 180;
                e1._rotate(a), t._rotate(a), i._rotate(a), n._rotate(a), l.x1 = Math.min(e1.x, t.x, i.x, n.x), l.x2 = Math.max(e1.x, t.x, i.x, n.x), l.y1 = Math.min(e1.y, t.y, i.y, n.y), l.y2 = Math.max(e1.y, t.y, i.y, n.y);
            }
            e1.emplaceBack(t.x, t.y, l.x1, l.y1, l.x2, l.y2, i, n, a);
        }
        this.boxEndIndex = e1.length;
    }
}, $785da19a645c07eb$var$uE = class {
    constructor(e1 = [], t = (e1, t)=>e1 < t ? -1 : +(e1 > t)){
        if (this.data = e1, this.length = this.data.length, this.compare = t, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
    }
    push(e1) {
        this.data.push(e1), this._up(this.length++);
    }
    pop() {
        if (0 === this.length) return;
        let e1 = this.data[0], t = this.data.pop();
        return --this.length > 0 && (this.data[0] = t, this._down(0)), e1;
    }
    peek() {
        return this.data[0];
    }
    _up(e1) {
        let { data: t, compare: i } = this, n = t[e1];
        for(; e1 > 0;){
            let a = e1 - 1 >> 1, r = t[a];
            if (i(n, r) >= 0) break;
            t[e1] = r, e1 = a;
        }
        t[e1] = n;
    }
    _down(e1) {
        let { data: t, compare: i } = this, n = this.length >> 1, a = t[e1];
        for(; e1 < n;){
            let n = 1 + (e1 << 1), r = n + 1;
            if (r < this.length && i(t[r], t[n]) < 0 && (n = r), i(t[n], a) >= 0) break;
            t[e1] = t[n], e1 = n;
        }
        t[e1] = a;
    }
};
function $785da19a645c07eb$var$hE(e1, t = 1) {
    let i = $785da19a645c07eb$var$fx.fromPoints(e1[0]), n = Math.min(i.width(), i.height()), a = n / 2, r = new $785da19a645c07eb$var$uE([], $785da19a645c07eb$var$dE), { minX: s, minY: o, maxX: l, maxY: c } = i;
    if (0 === n) return new $785da19a645c07eb$var$Kc(s, o);
    for(let t = s; t < l; t += n)for(let i = o; i < c; i += n)r.push(new $785da19a645c07eb$var$pE(t + a, i + a, a, e1));
    let u = function(e1) {
        let t = 0, i = 0, n = 0, a = e1[0];
        for(let e1 = 0, r = a.length, s = r - 1; e1 < r; s = e1++){
            let r = a[e1], o = a[s], l = r.x * o.y - o.x * r.y;
            i += (r.x + o.x) * l, n += (r.y + o.y) * l, t += 3 * l;
        }
        return new $785da19a645c07eb$var$pE(i / t, n / t, 0, e1);
    }(e1), h = u;
    for(; r.length;){
        let i = r.pop();
        (i.d > h.d || !h.d) && (h = i), !(i.max - h.d <= t) && (a = i.h / 2, r.push(new $785da19a645c07eb$var$pE(i.p.x - a, i.p.y - a, a, e1)), r.push(new $785da19a645c07eb$var$pE(i.p.x + a, i.p.y - a, a, e1)), r.push(new $785da19a645c07eb$var$pE(i.p.x - a, i.p.y + a, a, e1)), r.push(new $785da19a645c07eb$var$pE(i.p.x + a, i.p.y + a, a, e1)));
    }
    return u.d > 0 && h.d - u.d <= t ? u.p : h.p;
}
function $785da19a645c07eb$var$dE(e1, t) {
    return t.max - e1.max;
}
var $785da19a645c07eb$var$pE = class {
    constructor(e1, t, i, n){
        this.p = new $785da19a645c07eb$var$Kc(e1, t), this.h = i, this.d = function(e1, t) {
            let i = !1, n = 1 / 0;
            for (let a of t)for(let t = 0, r = a.length, s = r - 1; t < r; s = t++){
                let r = a[t], o = a[s];
                r.y > e1.y != o.y > e1.y && e1.x < (o.x - r.x) * (e1.y - r.y) / (o.y - r.y) + r.x && (i = !i), n = Math.min(n, $785da19a645c07eb$var$wv(e1, r, o));
            }
            return (i ? 1 : -1) * Math.sqrt(n);
        }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
    }
};
let $785da19a645c07eb$var$mE = function(e1) {
    return e1[e1.center = 1] = "center", e1[e1.left = 2] = "left", e1[e1.right = 3] = "right", e1[e1.top = 4] = "top", e1[e1.bottom = 5] = "bottom", e1[e1["top-left"] = 6] = "top-left", e1[e1["top-right"] = 7] = "top-right", e1[e1["bottom-left"] = 8] = "bottom-left", e1[e1["bottom-right"] = 9] = "bottom-right", e1;
}({});
const $785da19a645c07eb$var$gE = 1 / 0;
function $785da19a645c07eb$var$fE(e1, t) {
    return t[1] === $785da19a645c07eb$var$gE ? function(e1, t) {
        let i = 0, n = 0;
        t < 0 && (t = 0);
        let a = t / Math.SQRT2;
        switch(e1){
            case "top-right":
            case "top-left":
                n = a - 7;
                break;
            case "bottom-right":
            case "bottom-left":
                n = 7 - a;
                break;
            case "bottom":
                n = 7 - t;
                break;
            case "top":
                n = t - 7;
        }
        switch(e1){
            case "top-right":
            case "bottom-right":
                i = -a;
                break;
            case "top-left":
            case "bottom-left":
                i = a;
                break;
            case "left":
                i = t;
                break;
            case "right":
                i = -t;
        }
        return [
            i,
            n
        ];
    }(e1, t[0]) : function(e1, t, i) {
        let n = 0, a = 0;
        switch(t = Math.abs(t), i = Math.abs(i), e1){
            case "top-right":
            case "top-left":
            case "top":
                a = i - 7;
                break;
            case "bottom-right":
            case "bottom-left":
            case "bottom":
                a = 7 - i;
        }
        switch(e1){
            case "top-right":
            case "bottom-right":
            case "right":
                n = -t;
                break;
            case "top-left":
            case "bottom-left":
            case "left":
                n = t;
        }
        return [
            n,
            a
        ];
    }(e1, t[0], t[1]);
}
function $785da19a645c07eb$var$AE(e1, t, i) {
    let n = e1.layout, a = n.get("text-variable-anchor-offset")?.evaluate(t, {}, i);
    if (a) {
        let e1 = a.values, t = [];
        for(let i = 0; i < e1.length; i += 2){
            let n = t[i] = e1[i], a = e1[i + 1].map((e1)=>24 * e1);
            n.startsWith("top") ? a[1] -= 7 : n.startsWith("bottom") && (a[1] += 7), t[i + 1] = a;
        }
        return new $785da19a645c07eb$var$dp(t);
    }
    let r = n.get("text-variable-anchor");
    if (r) {
        let a;
        a = void 0 === e1._unevaluatedLayout.getValue("text-radial-offset") ? n.get("text-offset").evaluate(t, {}, i).map((e1)=>24 * e1) : [
            24 * n.get("text-radial-offset").evaluate(t, {}, i),
            $785da19a645c07eb$var$gE
        ];
        let s = [];
        for (let e1 of r)s.push(e1, $785da19a645c07eb$var$fE(e1, a));
        return new $785da19a645c07eb$var$dp(s);
    }
    return null;
}
function $785da19a645c07eb$var$_E(e1) {
    switch(e1){
        case "right":
        case "top-right":
        case "bottom-right":
            return "right";
        case "left":
        case "top-left":
        case "bottom-left":
            return "left";
    }
    return "center";
}
function $785da19a645c07eb$var$vE(e1, t, i, n, a, r, s, o, l, c, u, h) {
    let d = r.textMaxSize.evaluate(t, {});
    void 0 === d && (d = s);
    let p, m = e1.layers[0].layout, g = m.get("icon-offset").evaluate(t, {}, u), f = $785da19a645c07eb$var$xE(i.horizontal), A = s / 24, _ = e1.tilePixelRatio * A, v = e1.tilePixelRatio * d / 24, y = e1.tilePixelRatio * o, x = e1.tilePixelRatio * m.get("symbol-spacing"), b = m.get("text-padding") * e1.tilePixelRatio, w = function(e1, t, i, n = 1) {
        let a = e1.get("icon-padding").evaluate(t, {}, i)?.values;
        return [
            a[0] * n,
            a[1] * n,
            a[2] * n,
            a[3] * n
        ];
    }(m, t, u, e1.tilePixelRatio), E = m.get("text-max-angle") / 180 * Math.PI, k = "viewport" !== m.get("text-rotation-alignment") && "point" !== m.get("symbol-placement"), S = "map" === m.get("icon-rotation-alignment").constantOr("viewport") && "point" !== m.get("symbol-placement"), M = m.get("symbol-placement"), C = x / 2, T = m.get("icon-text-fit");
    n && "none" !== T && (e1.allowVerticalPlacement && i.vertical && (p = $785da19a645c07eb$var$Hw(n, i.vertical, T, m.get("icon-text-fit-padding"), g, A)), f && (n = $785da19a645c07eb$var$Hw(n, f, T, m.get("icon-text-fit-padding"), g, A)));
    let D = u ? h.line.getGranularityForZoomLevel(u.z) : 1, P = (o, h)=>{
        h.x < 0 || h.x >= 8192 || h.y < 0 || h.y >= 8192 || function(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _, v, y, x, b, w, E) {
            let k = e1.addToLineVertexArray(t, i), S = o.layout.get("symbol-height-offset").evaluate(y, {}, w);
            S > e1.maxHeightOffset && (e1.maxHeightOffset = S);
            let M, C, T, D, P = 0, I = 0, F = 0, z = 0, R = -1, L1 = -1, B = {}, O = (0, $785da19a645c07eb$var$R_.default)("");
            if (e1.allowVerticalPlacement && n.vertical) {
                let e1 = o.layout.get("text-rotate").evaluate(y, {}, w) + 90, i = n.vertical;
                T = new $785da19a645c07eb$var$cE(l, t, c, u, h, i, d, p, m, e1), s && (D = new $785da19a645c07eb$var$cE(l, t, c, u, h, s, f, A, m, e1));
            }
            if (a) {
                let i = o.layout.get("icon-rotate").evaluate(y, {}), n = "none" !== o.layout.get("icon-text-fit"), r = $785da19a645c07eb$var$aE(a, i, b, n), d = s ? $785da19a645c07eb$var$aE(s, i, b, n) : void 0;
                C = new $785da19a645c07eb$var$cE(l, t, c, u, h, a, f, A, !1, i), P = 4 * r.length;
                let p = e1.iconSizeData, m = null;
                "source" === p.kind ? (m = [
                    128 * o.layout.get("icon-size").evaluate(y, {})
                ], m[0] > 32640 && $785da19a645c07eb$var$wh(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === p.kind && (m = [
                    128 * x.compositeIconSizes[0].evaluate(y, {}, w),
                    128 * x.compositeIconSizes[1].evaluate(y, {}, w)
                ], (m[0] > 32640 || m[1] > 32640) && $785da19a645c07eb$var$wh(`${e1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, r, m, v, _, y, 0, t, k.lineStartIndex, k.lineLength, -1, w, S), R = e1.icon.placedSymbolArray.length - 1, d && (I = 4 * d.length, e1.addSymbols(e1.icon, d, m, v, _, y, 2, t, k.lineStartIndex, k.lineLength, -1, w, S), L1 = e1.icon.placedSymbolArray.length - 1);
            }
            let U = Object.keys(n.horizontal);
            for (let i of U){
                let a = n.horizontal[i];
                M ||= (O = (0, $785da19a645c07eb$var$R_.default)(a.text), new $785da19a645c07eb$var$cE(l, t, c, u, h, a, d, p, m, o.layout.get("text-rotate").evaluate(y, {}, w)));
                let s = 1 === a.positionedLines.length;
                if (F += $785da19a645c07eb$var$yE(e1, t, a, r, o, m, y, g, S, k, n.vertical ? 1 : 3, s ? U : [
                    i
                ], B, R, x, w), s) break;
            }
            n.vertical && (z += $785da19a645c07eb$var$yE(e1, t, n.vertical, r, o, m, y, g, S, k, 2, [
                "vertical"
            ], B, L1, x, w));
            let N = M ? M.boxStartIndex : e1.collisionBoxArray.length, j = M ? M.boxEndIndex : e1.collisionBoxArray.length, V = T ? T.boxStartIndex : e1.collisionBoxArray.length, q = T ? T.boxEndIndex : e1.collisionBoxArray.length, G = C ? C.boxStartIndex : e1.collisionBoxArray.length, H = C ? C.boxEndIndex : e1.collisionBoxArray.length, W = D ? D.boxStartIndex : e1.collisionBoxArray.length, Z = D ? D.boxEndIndex : e1.collisionBoxArray.length, K = -1, X = (e1, t)=>e1?.circleDiameter ? Math.max(e1.circleDiameter, t) : t;
            K = X(M, K), K = X(T, K), K = X(C, K), K = X(D, K);
            let Q = +(K > -1);
            Q && (K *= E / 24), e1.glyphOffsetArray.length >= e1.maxGlyphs && $785da19a645c07eb$var$wh("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== y.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, y.sortKey);
            let Y = $785da19a645c07eb$var$AE(o, y, w), [J, $] = function(e1, t) {
                let i = e1.length, n = t?.values;
                if (n?.length > 0) for(let t = 0; t < n.length; t += 2){
                    let i = $785da19a645c07eb$var$mE[n[t]], a = n[t + 1];
                    e1.emplaceBack(i, a[0], a[1]);
                }
                return [
                    i,
                    e1.length
                ];
            }(e1.textAnchorOffsets, Y);
            e1.symbolInstances.emplaceBack(t.x, t.y, B.right >= 0 ? B.right : -1, B.center >= 0 ? B.center : -1, B.left >= 0 ? B.left : -1, B.vertical || -1, R, L1, O, N, j, V, q, G, H, W, Z, c, F, z, P, I, Q, 0, d, K, J, $, S);
        }(e1, h, o, i, n, a, p, e1.layers[0], e1.collisionBoxArray, t.index, t.sourceLayerIndex, e1.index, _, [
            b,
            b,
            b,
            b
        ], k, l, y, w, S, g, t, r, c, u, s);
    };
    if ("line" === M) for (let a of $785da19a645c07eb$var$nE(t.geometry, 0, 0, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu)){
        let t = $785da19a645c07eb$var$ax(a, D), r = $785da19a645c07eb$var$tE(t, x, E, i.vertical || f, n, 24, v, e1.overscaling, $785da19a645c07eb$var$Vu);
        for (let i of r)(!f || !$785da19a645c07eb$var$bE(e1, f.text, C, i)) && P(t, i);
    }
    else if ("line-center" === M) {
        for (let e1 of t.geometry)if (e1.length > 1) {
            let t = $785da19a645c07eb$var$ax(e1, D), a = $785da19a645c07eb$var$eE(t, E, i.vertical || f, n, 24, v);
            a && P(t, a);
        }
    } else if ("Polygon" === t.type) for (let e1 of $785da19a645c07eb$var$Ip(t.geometry, 0)){
        let t = $785da19a645c07eb$var$hE(e1, 16);
        P($785da19a645c07eb$var$ax(e1[0], D, !0), new $785da19a645c07eb$var$Xw(t.x, t.y, 0));
    }
    else if ("LineString" === t.type) for (let e1 of t.geometry){
        let t = $785da19a645c07eb$var$ax(e1, D);
        P(t, new $785da19a645c07eb$var$Xw(t[0].x, t[0].y, 0));
    }
    else if ("Point" === t.type) for (let e1 of t.geometry)for (let t of e1)P([
        t
    ], new $785da19a645c07eb$var$Xw(t.x, t.y, 0));
}
function $785da19a645c07eb$var$yE(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g) {
    let f = function(e1, t, i, n, a, r, s, o) {
        let l = n.layout.get("text-rotate").evaluate(r, {}) * Math.PI / 180, c = [];
        for (let e1 of t.positionedLines)for (let n of e1.positionedGlyphs){
            if (!n.rect) continue;
            let r = n.rect || {}, u = 4, h = !0, d = 1, p = 0, m = (a || o) && n.vertical, g = n.metrics.advance * n.scale / 2;
            if (o && t.verticalizable) {
                let t = 24 * (n.scale - 1), i = (24 - n.metrics.width * n.scale) / 2;
                p = e1.lineOffset / 2 - (n.imageName ? -i : t);
            }
            if (n.imageName) {
                let e1 = s[n.imageName];
                h = e1.sdf, d = e1.pixelRatio, u = 1 / d;
            }
            let f = a ? [
                n.x + g,
                n.y
            ] : [
                0,
                0
            ], A = a ? [
                0,
                0
            ] : [
                n.x + g + i[0],
                n.y + i[1] - p
            ], _ = [
                0,
                0
            ];
            m && (_ = A, A = [
                0,
                0
            ]);
            let v = n.metrics.isDoubleResolution ? 2 : 1, y = (n.metrics.left - u) * n.scale - g + A[0], x = (-n.metrics.top - u) * n.scale + A[1], b = y + r.w / v * n.scale / d, w = x + r.h / v * n.scale / d, E = new $785da19a645c07eb$var$Kc(y, x), k = new $785da19a645c07eb$var$Kc(b, x), S = new $785da19a645c07eb$var$Kc(y, w), M = new $785da19a645c07eb$var$Kc(b, w);
            if (m) {
                let e1 = new $785da19a645c07eb$var$Kc(-g, g - -17), t = -Math.PI / 2, i = 12 - g, a = new $785da19a645c07eb$var$Kc(22 - i, -(n.imageName ? i : 0)), r = new $785da19a645c07eb$var$Kc(..._);
                E._rotateAround(t, e1)._add(a)._add(r), k._rotateAround(t, e1)._add(a)._add(r), S._rotateAround(t, e1)._add(a)._add(r), M._rotateAround(t, e1)._add(a)._add(r);
            }
            if (l) {
                let e1 = Math.sin(l), t = Math.cos(l), i = [
                    t,
                    -e1,
                    e1,
                    t
                ];
                E._matMult(i), k._matMult(i), S._matMult(i), M._matMult(i);
            }
            let C = new $785da19a645c07eb$var$Kc(0, 0), T = new $785da19a645c07eb$var$Kc(0, 0);
            c.push({
                tl: E,
                tr: k,
                bl: S,
                br: M,
                tex: r,
                writingMode: t.writingMode,
                glyphOffset: f,
                sectionIndex: n.sectionIndex,
                isSDF: h,
                pixelOffsetTL: C,
                pixelOffsetBR: T,
                minFontScaleX: 0,
                minFontScaleY: 0
            });
        }
        return c;
    }(0, i, o, a, r, s, n, e1.allowVerticalPlacement), A = e1.textSizeData, _ = null;
    "source" === A.kind ? (_ = [
        128 * a.layout.get("text-size").evaluate(s, {})
    ], _[0] > 32640 && $785da19a645c07eb$var$wh(`${e1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === A.kind && (_ = [
        128 * m.compositeTextSizes[0].evaluate(s, {}, g),
        128 * m.compositeTextSizes[1].evaluate(s, {}, g)
    ], (_[0] > 32640 || _[1] > 32640) && $785da19a645c07eb$var$wh(`${e1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), e1.addSymbols(e1.text, f, _, o, r, s, u, t, c.lineStartIndex, c.lineLength, p, g, l);
    for (let t of h)d[t] = e1.text.placedSymbolArray.length - 1;
    return 4 * f.length;
}
function $785da19a645c07eb$var$xE(e1) {
    for(let t in e1)return e1[t];
    return null;
}
function $785da19a645c07eb$var$bE(e1, t, i, n) {
    let a = e1.compareText;
    if (t in a) {
        let e1 = a[t];
        for(let t = e1.length - 1; t >= 0; t--)if (n.dist(e1[t]) < i) return !0;
    } else a[t] = [];
    return a[t].push(n), !1;
}
function $785da19a645c07eb$var$wE(e1, t, i) {
    let n = "never", a = e1.get(t);
    return a ? n = a : e1.get(i) && (n = "always"), n;
}
const $785da19a645c07eb$var$EE = [
    {
        name: "a_fade_opacity",
        components: 1,
        type: "Uint8",
        offset: 0
    }
];
function $785da19a645c07eb$var$kE(e1, t, i, n, a, r, s, o, l, c, u, h, d, p) {
    let m = o ? Math.min(32640, Math.round(o[0])) : 0, g = o ? Math.min(32640, Math.round(o[1])) : 0;
    e1.emplaceBack(t, i, Math.round(32 * n), Math.round(32 * a), r, s, +!!l + (m << 1), g, 16 * c, 16 * u, 256 * h, 256 * d, p);
}
function $785da19a645c07eb$var$SE(e1, t, i) {
    e1.emplaceBack(t.x, t.y, i), e1.emplaceBack(t.x, t.y, i), e1.emplaceBack(t.x, t.y, i), e1.emplaceBack(t.x, t.y, i);
}
function $785da19a645c07eb$var$ME(e1) {
    for (let t of e1.sections)if ($785da19a645c07eb$var$Qb(t.text)) return !0;
    return !1;
}
var $785da19a645c07eb$var$CE = class {
    constructor(e1){
        this.layoutVertexArray = new $785da19a645c07eb$var$__, this.indexArray = new $785da19a645c07eb$var$k_, this.programConfigurations = e1, this.segments = new $785da19a645c07eb$var$T_, this.dynamicLayoutVertexArray = new $785da19a645c07eb$var$v_, this.opacityVertexArray = new $785da19a645c07eb$var$y_, this.hasVisibleVertices = !1, this.placedSymbolArray = new $785da19a645c07eb$var$$A;
    }
    isEmpty() {
        return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
    }
    upload(e1, t, i, n) {
        this.isEmpty() || (i && (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, $785da19a645c07eb$var$mb.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, $785da19a645c07eb$var$gb.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, $785da19a645c07eb$var$EE, !0), this.opacityVertexBuffer.itemSize = 1), (i || n) && this.programConfigurations.upload(e1));
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
    }
};
$785da19a645c07eb$var$qf("SymbolBuffers", $785da19a645c07eb$var$CE);
var $785da19a645c07eb$var$TE = class {
    constructor(e1, t, i){
        this.layoutVertexArray = new e1, this.layoutAttributes = t, this.indexArray = new i, this.segments = new $785da19a645c07eb$var$T_, this.collisionVertexArray = new $785da19a645c07eb$var$w_;
    }
    upload(e1) {
        this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, $785da19a645c07eb$var$fb.members, !0);
    }
    destroy() {
        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
    }
};
$785da19a645c07eb$var$qf("CollisionBuffers", $785da19a645c07eb$var$TE);
var $785da19a645c07eb$var$DE = class {
    constructor(e1){
        this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.id), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasDependencies = !0, this.hasRTLText = !1, this.maxHeightOffset = 0, this.sortKeyRanges = [], this.collisionCircleArray = [], this.maxGlyphs = 65535;
        let t = this.layers[0]._unevaluatedLayout._values;
        this.textSizeData = $785da19a645c07eb$var$Ww(this.zoom, t["text-size"]), this.iconSizeData = $785da19a645c07eb$var$Ww(this.zoom, t["icon-size"]);
        let i = this.layers[0].layout, n = i.get("symbol-sort-key"), a = i.get("symbol-z-order");
        this.canOverlap = "never" !== $785da19a645c07eb$var$wE(i, "text-overlap", "text-allow-overlap") || "never" !== $785da19a645c07eb$var$wE(i, "icon-overlap", "icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== a && !n.isConstant();
        let r = "viewport-y" === a || "auto" === a && !this.sortFeaturesByKey;
        this.sortFeaturesByY = r && this.canOverlap, "point" === i.get("symbol-placement") && (this.writingModes = i.get("text-writing-mode").map((e1)=>$785da19a645c07eb$var$Ew[e1])), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID;
    }
    createArrays() {
        this.text = new $785da19a645c07eb$var$CE(new $785da19a645c07eb$var$sv(this.layers, this.zoom, (e1)=>e1.startsWith("text"))), this.icon = new $785da19a645c07eb$var$CE(new $785da19a645c07eb$var$sv(this.layers, this.zoom, (e1)=>e1.startsWith("icon"))), this.glyphOffsetArray = new $785da19a645c07eb$var$i_, this.lineVertexArray = new $785da19a645c07eb$var$n_, this.symbolInstances = new $785da19a645c07eb$var$t_, this.textAnchorOffsets = new $785da19a645c07eb$var$r_;
    }
    calculateGlyphDependencies(e1, t, i, n, a) {
        let r = (n || this.allowVerticalPlacement) && a, s = $785da19a645c07eb$var$sw.fromFeature(e1, i), o = s.graphemes();
        for(let e1 = 0; e1 < o.length; e1++){
            let i = s.getSection(e1);
            if ("imageName" in i) continue;
            let n = t[i.fontStack] ||= {}, a = o[e1];
            $785da19a645c07eb$var$Vb(a) && (n[a] = !0);
            for (let e1 of a){
                if (n[e1] = !0, !r) continue;
                let t = $785da19a645c07eb$var$Yb[e1];
                t && (n[t] = !0);
            }
        }
    }
    populate(e1, t, i) {
        let n = this.layers[0], a = n.layout, r = a.get("text-font"), s = a.get("text-field"), o = a.get("icon-image"), l = ("constant" !== s.value.kind || s.value.value instanceof $785da19a645c07eb$var$sp && !s.value.value.isEmpty() || s.value.value.toString().length > 0) && ("constant" !== r.value.kind || r.value.value.length > 0), c = "constant" !== o.value.kind || !!o.value.value || Object.keys(o.parameters).length > 0, u = a.get("symbol-sort-key");
        if (this.features = [], !l && !c) return;
        let h = t.iconDependencies, d = t.glyphDependencies, p = t.availableImages, m = new $785da19a645c07eb$var$Qf(this.zoom);
        for (let { feature: t, id: s, index: o, sourceLayerIndex: g } of e1){
            let e1, f, A = n._featureFilter.needGeometry, _ = $785da19a645c07eb$var$dv(t, A);
            if (!n._featureFilter.filter(m, _, i)) continue;
            if (A || (_.geometry = $785da19a645c07eb$var$hv(t)), l) {
                let t = n.getValueAndResolveTokens("text-field", _, i, p), a = $785da19a645c07eb$var$sp.factory(t);
                this.hasRTLText ||= $785da19a645c07eb$var$ME(a), e1 = $785da19a645c07eb$var$Lb(a, n, _);
            }
            if (c) {
                let e1 = n.getValueAndResolveTokens("icon-image", _, i, p);
                f = e1 instanceof $785da19a645c07eb$var$pp ? e1 : $785da19a645c07eb$var$pp.fromString(e1);
            }
            if (!e1 && !f) continue;
            let v = this.sortFeaturesByKey ? u.evaluate(_, {}, i) : void 0, y = {
                id: s,
                text: e1,
                icon: f,
                index: o,
                sourceLayerIndex: g,
                geometry: _.geometry,
                properties: t.properties,
                type: $785da19a645c07eb$var$yx.types[t.type],
                sortKey: v
            };
            if (this.features.push(y), f && (h[f.name] = !0), e1) {
                let t = r.evaluate(_, {}, i).join(","), n = "viewport" !== a.get("text-rotation-alignment") && "point" !== a.get("symbol-placement");
                this.allowVerticalPlacement = this.writingModes?.includes(2);
                let s = $785da19a645c07eb$var$Gb(e1.toString());
                this.calculateGlyphDependencies(e1, d, t, n, s);
                for (let t of e1.sections)t.image && (h[t.image.name] = !0);
            }
        }
        "line" === a.get("symbol-placement") && (this.features = function(e1) {
            let t = {}, i = {}, n = [], a = 0;
            function r(t) {
                n.push(e1[t]), a++;
            }
            function s(e1, t, a) {
                let r = i[e1];
                return delete i[e1], i[t] = r, n[r].geometry[0].pop(), n[r].geometry[0] = n[r].geometry[0].concat(a[0]), r;
            }
            function o(e1, i, a) {
                let r = t[i];
                return delete t[i], t[e1] = r, n[r].geometry[0].shift(), n[r].geometry[0] = a[0].concat(n[r].geometry[0]), r;
            }
            function l(e1, t, i) {
                let n = i ? t[0][t[0].length - 1] : t[0][0];
                return `${e1}:${n.x}:${n.y}`;
            }
            for(let c = 0; c < e1.length; c++){
                let u = e1[c], h = u.geometry, d = u.text ? u.text.toString() : null;
                if (!d) {
                    r(c);
                    continue;
                }
                let p = l(d, h), m = l(d, h, !0);
                if (p in i && m in t && i[p] !== t[m]) {
                    let e1 = o(p, m, h), a = s(p, m, n[e1].geometry);
                    delete t[p], delete i[m], i[l(d, n[a].geometry, !0)] = a, n[e1].geometry = null;
                } else p in i ? s(p, m, h) : m in t ? o(p, m, h) : (r(c), t[p] = a - 1, i[m] = a - 1);
            }
            return n.filter((e1)=>e1.geometry);
        }(this.features)), this.sortFeaturesByKey && this.features.sort((e1, t)=>e1.sortKey - t.sortKey);
    }
    update(e1, t, i) {
        this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(e1, t, this.layers, {
            imagePositions: i
        }), this.icon.programConfigurations.updatePaintArrays(e1, t, this.layers, {
            imagePositions: i
        }));
    }
    addFeatures({ options: e1, canonical: t, glyphMap: i, glyphPositions: n, iconMap: a, iconPositions: r, showCollisionBoxes: s }) {
        !function(e1) {
            e1.bucket.createArrays();
            let t = 512 * e1.bucket.overscaling;
            e1.bucket.tilePixelRatio = $785da19a645c07eb$var$Vu / t, e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
            let i = e1.bucket.layers[0], n = i.layout, a = i._unevaluatedLayout._values, r = {
                layoutIconSize: a["icon-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(e1.bucket.zoom + 1), e1.canonical),
                layoutTextSize: a["text-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(e1.bucket.zoom + 1), e1.canonical),
                textMaxSize: a["text-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(18))
            };
            if ("composite" === e1.bucket.textSizeData.kind) {
                let { minZoom: t, maxZoom: i } = e1.bucket.textSizeData;
                r.compositeTextSizes = [
                    a["text-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(t), e1.canonical),
                    a["text-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(i), e1.canonical)
                ];
            }
            if ("composite" === e1.bucket.iconSizeData.kind) {
                let { minZoom: t, maxZoom: i } = e1.bucket.iconSizeData;
                r.compositeIconSizes = [
                    a["icon-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(t), e1.canonical),
                    a["icon-size"].possiblyEvaluate(new $785da19a645c07eb$var$Qf(i), e1.canonical)
                ];
            }
            let s = 24 * n.get("text-line-height"), o = "viewport" !== n.get("text-rotation-alignment") && "point" !== n.get("symbol-placement"), l = n.get("text-keep-upright"), c = n.get("text-size");
            for (let t of e1.bucket.features){
                let a = n.get("text-font").evaluate(t, {}, e1.canonical).join(","), u = c.evaluate(t, {}, e1.canonical), h = r.layoutTextSize.evaluate(t, {}, e1.canonical), d = r.layoutIconSize.evaluate(t, {}, e1.canonical), p = {
                    horizontal: {},
                    vertical: void 0
                }, m = t.text, g = [
                    0,
                    0
                ];
                if (m) {
                    let r = m.toString(), c = 24 * n.get("text-letter-spacing").evaluate(t, {}, e1.canonical), d = $785da19a645c07eb$var$Hb(r) ? c : 0, f = n.get("text-anchor").evaluate(t, {}, e1.canonical), A = $785da19a645c07eb$var$AE(i, t, e1.canonical);
                    if (!A) {
                        let i = n.get("text-radial-offset").evaluate(t, {}, e1.canonical);
                        g = i ? $785da19a645c07eb$var$fE(f, [
                            24 * i,
                            $785da19a645c07eb$var$gE
                        ]) : n.get("text-offset").evaluate(t, {}, e1.canonical).map((e1)=>24 * e1);
                    }
                    let _ = o ? "center" : n.get("text-justify").evaluate(t, {}, e1.canonical), v = "point" === n.get("symbol-placement") ? 24 * n.get("text-max-width").evaluate(t, {}, e1.canonical) : 1 / 0, y = ()=>{
                        e1.bucket.allowVerticalPlacement && $785da19a645c07eb$var$Gb(r) && (p.vertical = $785da19a645c07eb$var$Dw(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, v, s, f, "left", d, g, 2, !0, h, u));
                    };
                    if (!o && A) {
                        let t = new Set;
                        if ("auto" === _) for(let e1 = 0; e1 < A.values.length; e1 += 2)t.add($785da19a645c07eb$var$_E(A.values[e1]));
                        else t.add(_);
                        let i = !1;
                        for (let n of t)if (!p.horizontal[n]) {
                            if (i) p.horizontal[n] = p.horizontal[0];
                            else {
                                let t = $785da19a645c07eb$var$Dw(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, v, s, "center", n, d, g, 1, !1, h, u);
                                t && (p.horizontal[n] = t, i = 1 === t.positionedLines.length);
                            }
                        }
                        y();
                    } else {
                        "auto" === _ && (_ = $785da19a645c07eb$var$_E(f));
                        let t = $785da19a645c07eb$var$Dw(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, v, s, f, _, d, g, 1, !1, h, u);
                        t && (p.horizontal[_] = t), y(), $785da19a645c07eb$var$Gb(r) && o && l && (p.vertical = $785da19a645c07eb$var$Dw(m, e1.glyphMap, e1.glyphPositions, e1.imagePositions, a, v, s, f, _, d, g, 2, !1, h, u));
                    }
                }
                let f, A = !1;
                if (t.icon?.name) {
                    let i = e1.imageMap[t.icon.name];
                    i && (f = $785da19a645c07eb$var$qw(e1.imagePositions[t.icon.name], n.get("icon-offset").evaluate(t, {}, e1.canonical), n.get("icon-anchor").evaluate(t, {}, e1.canonical)), A = !!i.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = A : e1.bucket.sdfIcons !== A && $785da19a645c07eb$var$wh("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), i.pixelRatio === e1.bucket.pixelRatio ? 0 !== n.get("icon-rotate").constantOr(1) && (e1.bucket.iconsNeedLinear = !0) : e1.bucket.iconsNeedLinear = !0);
                }
                let _ = $785da19a645c07eb$var$xE(p.horizontal) || p.vertical;
                e1.bucket.iconsInText ||= !!_ && _.iconsInText, (_ || f) && $785da19a645c07eb$var$vE(e1.bucket, t, p, f, e1.imageMap, r, h, d, g, A, e1.canonical, e1.subdivisionGranularity);
            }
            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
        }({
            bucket: this,
            glyphMap: i,
            glyphPositions: n,
            imageMap: a,
            imagePositions: r,
            showCollisionBoxes: s,
            canonical: t,
            subdivisionGranularity: e1.subdivisionGranularity
        });
    }
    isEmpty() {
        return 0 === this.symbolInstances.length;
    }
    uploadPending() {
        return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
    }
    upload(e1) {
        !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
    }
    destroyDebugData() {
        this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
    }
    destroy() {
        this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
    }
    addToLineVertexArray(e1, t) {
        let i = this.lineVertexArray.length;
        if (void 0 !== e1.segment) {
            let i = e1.dist(t[e1.segment + 1]), n = e1.dist(t[e1.segment]), a = {};
            for(let n = e1.segment + 1; n < t.length; n++)a[n] = {
                x: t[n].x,
                y: t[n].y,
                tileUnitDistanceFromAnchor: i
            }, n < t.length - 1 && (i += t[n + 1].dist(t[n]));
            for(let i = e1.segment || 0; i >= 0; i--)a[i] = {
                x: t[i].x,
                y: t[i].y,
                tileUnitDistanceFromAnchor: n
            }, i > 0 && (n += t[i - 1].dist(t[i]));
            for(let e1 = 0; e1 < t.length; e1++){
                let t = a[e1];
                this.lineVertexArray.emplaceBack(t.x, t.y, t.tileUnitDistanceFromAnchor);
            }
        }
        return {
            lineStartIndex: i,
            lineLength: this.lineVertexArray.length - i
        };
    }
    addSymbols(e1, t, i, n, a, r, s, o, l, c, u, h, d) {
        let p = e1.indexArray, m = e1.layoutVertexArray, g = e1.segments.prepareSegment(4 * t.length, m, p, this.canOverlap ? r.sortKey : void 0), f = this.glyphOffsetArray.length, A = g.vertexLength, _ = this.allowVerticalPlacement && 2 === s ? Math.PI / 2 : 0, v = r.text && r.text.sections;
        for(let n = 0; n < t.length; n++){
            let { tl: a, tr: s, bl: l, br: c, tex: u, pixelOffsetTL: f, pixelOffsetBR: A, minFontScaleX: y, minFontScaleY: x, glyphOffset: b, isSDF: w, sectionIndex: E } = t[n], k = g.vertexLength, S = b[1];
            $785da19a645c07eb$var$kE(m, o.x, o.y, a.x, S + a.y, u.x, u.y, i, w, f.x, f.y, y, x, d), $785da19a645c07eb$var$kE(m, o.x, o.y, s.x, S + s.y, u.x + u.w, u.y, i, w, A.x, f.y, y, x, d), $785da19a645c07eb$var$kE(m, o.x, o.y, l.x, S + l.y, u.x, u.y + u.h, i, w, f.x, A.y, y, x, d), $785da19a645c07eb$var$kE(m, o.x, o.y, c.x, S + c.y, u.x + u.w, u.y + u.h, i, w, A.x, A.y, y, x, d), $785da19a645c07eb$var$SE(e1.dynamicLayoutVertexArray, o, _), p.emplaceBack(k, k + 2, k + 1), p.emplaceBack(k + 1, k + 2, k + 3), g.vertexLength += 4, g.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(b[0]), (n === t.length - 1 || E !== t[n + 1].sectionIndex) && e1.programConfigurations.populatePaintArrays(m.length, r, r.index, {
                imagePositions: {},
                canonical: h,
                formattedSection: v?.[E]
            });
        }
        e1.placedSymbolArray.emplaceBack(o.x, o.y, f, this.glyphOffsetArray.length - f, A, l, c, o.segment, i ? i[0] : 0, i ? i[1] : 0, n[0], n[1], s, 0, !1, 0, u, d);
    }
    _addCollisionDebugVertex(e1, t, i, n, a, r) {
        return t.emplaceBack(0, 0), e1.emplaceBack(i.x, i.y, n, a, Math.round(r.x), Math.round(r.y));
    }
    addCollisionDebugVertices(e1, t, i, n, a, r, s) {
        let o = a.segments.prepareSegment(4, a.layoutVertexArray, a.indexArray), l = o.vertexLength, c = a.layoutVertexArray, u = a.collisionVertexArray, h = s.anchorX, d = s.anchorY;
        this._addCollisionDebugVertex(c, u, r, h, d, new $785da19a645c07eb$var$Kc(e1, t)), this._addCollisionDebugVertex(c, u, r, h, d, new $785da19a645c07eb$var$Kc(i, t)), this._addCollisionDebugVertex(c, u, r, h, d, new $785da19a645c07eb$var$Kc(i, n)), this._addCollisionDebugVertex(c, u, r, h, d, new $785da19a645c07eb$var$Kc(e1, n)), o.vertexLength += 4;
        let p = a.indexArray;
        p.emplaceBack(l, l + 1), p.emplaceBack(l + 1, l + 2), p.emplaceBack(l + 2, l + 3), p.emplaceBack(l + 3, l), o.primitiveLength += 4;
    }
    addDebugCollisionBoxes(e1, t, i, n) {
        for(let a = e1; a < t; a++){
            let e1 = this.collisionBoxArray.get(a), t = e1.x1, r = e1.y1, s = e1.x2, o = e1.y2;
            this.addCollisionDebugVertices(t, r, s, o, n ? this.textCollisionBox : this.iconCollisionBox, e1.anchorPoint, i);
        }
    }
    generateCollisionDebugBuffers() {
        this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new $785da19a645c07eb$var$TE($785da19a645c07eb$var$x_, $785da19a645c07eb$var$Ab.members, $785da19a645c07eb$var$S_), this.iconCollisionBox = new $785da19a645c07eb$var$TE($785da19a645c07eb$var$x_, $785da19a645c07eb$var$Ab.members, $785da19a645c07eb$var$S_);
        for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
            let t = this.symbolInstances.get(e1);
            this.addDebugCollisionBoxes(t.textBoxStartIndex, t.textBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.verticalTextBoxStartIndex, t.verticalTextBoxEndIndex, t, !0), this.addDebugCollisionBoxes(t.iconBoxStartIndex, t.iconBoxEndIndex, t, !1), this.addDebugCollisionBoxes(t.verticalIconBoxStartIndex, t.verticalIconBoxEndIndex, t, !1);
        }
    }
    _deserializeCollisionBoxesForSymbol(e1, t, i, n, a, r, s, o, l) {
        let c = {};
        for(let n = t; n < i; n++){
            let t = e1.get(n);
            c.textBox = {
                x1: t.x1,
                y1: t.y1,
                x2: t.x2,
                y2: t.y2,
                anchorPointX: t.anchorPointX,
                anchorPointY: t.anchorPointY
            }, c.textFeatureIndex = t.featureIndex;
            break;
        }
        for(let t = n; t < a; t++){
            let i = e1.get(t);
            c.verticalTextBox = {
                x1: i.x1,
                y1: i.y1,
                x2: i.x2,
                y2: i.y2,
                anchorPointX: i.anchorPointX,
                anchorPointY: i.anchorPointY
            }, c.verticalTextFeatureIndex = i.featureIndex;
            break;
        }
        for(let t = r; t < s; t++){
            let i = e1.get(t);
            c.iconBox = {
                x1: i.x1,
                y1: i.y1,
                x2: i.x2,
                y2: i.y2,
                anchorPointX: i.anchorPointX,
                anchorPointY: i.anchorPointY
            }, c.iconFeatureIndex = i.featureIndex;
            break;
        }
        for(let t = o; t < l; t++){
            let i = e1.get(t);
            c.verticalIconBox = {
                x1: i.x1,
                y1: i.y1,
                x2: i.x2,
                y2: i.y2,
                anchorPointX: i.anchorPointX,
                anchorPointY: i.anchorPointY
            }, c.verticalIconFeatureIndex = i.featureIndex;
            break;
        }
        return c;
    }
    deserializeCollisionBoxes(e1) {
        this.collisionArrays = [];
        for(let t = 0; t < this.symbolInstances.length; t++){
            let i = this.symbolInstances.get(t);
            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, i.textBoxStartIndex, i.textBoxEndIndex, i.verticalTextBoxStartIndex, i.verticalTextBoxEndIndex, i.iconBoxStartIndex, i.iconBoxEndIndex, i.verticalIconBoxStartIndex, i.verticalIconBoxEndIndex));
        }
    }
    hasTextData() {
        return this.text.segments.get().length > 0;
    }
    hasIconData() {
        return this.icon.segments.get().length > 0;
    }
    hasDebugData() {
        return this.textCollisionBox && this.iconCollisionBox;
    }
    hasTextCollisionBoxData() {
        return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
    }
    hasIconCollisionBoxData() {
        return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
    }
    addIndicesForPlacedSymbol(e1, t) {
        let i = e1.placedSymbolArray.get(t), n = i.vertexStartIndex + 4 * i.numGlyphs;
        for(let t = i.vertexStartIndex; t < n; t += 4)e1.indexArray.emplaceBack(t, t + 2, t + 1), e1.indexArray.emplaceBack(t + 1, t + 2, t + 3);
    }
    getSortedSymbolIndexes(e1) {
        if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
        let t = Math.sin(e1), i = Math.cos(e1), n = [], a = [], r = [];
        for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
            r.push(e1);
            let s = this.symbolInstances.get(e1);
            n.push(0 | Math.round(t * s.anchorX + i * s.anchorY)), a.push(s.featureIndex);
        }
        return r.sort((e1, t)=>n[e1] - n[t] || a[t] - a[e1]), r;
    }
    addToSortKeyRanges(e1, t) {
        let i = this.sortKeyRanges[this.sortKeyRanges.length - 1];
        i?.sortKey === t ? i.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
            sortKey: t,
            symbolInstanceStart: e1,
            symbolInstanceEnd: e1 + 1
        });
    }
    sortFeatures(e1) {
        if (this.sortFeaturesByY && this.sortedAngle !== e1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
            for (let e1 of this.symbolInstanceIndexes){
                let t = this.symbolInstances.get(e1);
                this.featureSortOrder.push(t.featureIndex);
                let i = [
                    t.rightJustifiedTextSymbolIndex,
                    t.centerJustifiedTextSymbolIndex,
                    t.leftJustifiedTextSymbolIndex
                ];
                for(let e1 = 0; e1 < i.length; e1++){
                    let t = i[e1];
                    t >= 0 && i.indexOf(t) === e1 && this.addIndicesForPlacedSymbol(this.text, t);
                }
                t.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, t.verticalPlacedTextSymbolIndex), t.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.placedIconSymbolIndex), t.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, t.verticalPlacedIconSymbolIndex);
            }
            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
        }
    }
};
let $785da19a645c07eb$var$PE;
$785da19a645c07eb$var$qf("SymbolBucket", $785da19a645c07eb$var$DE, {
    omit: [
        "layers",
        "collisionBoxArray",
        "features",
        "compareText"
    ]
});
let $785da19a645c07eb$var$IE;
var $785da19a645c07eb$var$FE = {
    get paint () {
        return $785da19a645c07eb$var$IE ||= new $785da19a645c07eb$var$pA({
            "icon-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["icon-opacity"], "icon-opacity"),
            "icon-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["icon-color"], "icon-color"),
            "icon-halo-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["icon-halo-color"], "icon-halo-color"),
            "icon-halo-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["icon-halo-width"], "icon-halo-width"),
            "icon-halo-blur": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["icon-halo-blur"], "icon-halo-blur"),
            "icon-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_symbol["icon-translate"], "icon-translate"),
            "icon-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_symbol["icon-translate-anchor"], "icon-translate-anchor"),
            "text-opacity": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["text-opacity"], "text-opacity"),
            "text-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["text-color"], "text-color", {
                runtimeType: $785da19a645c07eb$var$md,
                getOverride: (e1)=>e1.textColor,
                hasOverride: (e1)=>!!e1.textColor
            }),
            "text-halo-color": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["text-halo-color"], "text-halo-color"),
            "text-halo-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["text-halo-width"], "text-halo-width"),
            "text-halo-blur": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.paint_symbol["text-halo-blur"], "text-halo-blur"),
            "text-translate": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_symbol["text-translate"], "text-translate"),
            "text-translate-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_symbol["text-translate-anchor"], "text-translate-anchor")
        });
    },
    get layout () {
        return $785da19a645c07eb$var$PE ||= new $785da19a645c07eb$var$pA({
            "symbol-placement": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["symbol-placement"], "symbol-placement"),
            "symbol-spacing": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["symbol-spacing"], "symbol-spacing"),
            "symbol-avoid-edges": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["symbol-avoid-edges"], "symbol-avoid-edges"),
            "symbol-sort-key": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["symbol-sort-key"], "symbol-sort-key"),
            "symbol-z-order": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["symbol-z-order"], "symbol-z-order"),
            "icon-allow-overlap": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-allow-overlap"], "icon-allow-overlap"),
            "icon-overlap": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-overlap"], "icon-overlap"),
            "icon-ignore-placement": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-ignore-placement"], "icon-ignore-placement"),
            "icon-optional": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-optional"], "icon-optional"),
            "icon-rotation-alignment": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-rotation-alignment"], "icon-rotation-alignment"),
            "icon-size": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-size"], "icon-size"),
            "icon-text-fit": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-text-fit"], "icon-text-fit"),
            "icon-text-fit-padding": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-text-fit-padding"], "icon-text-fit-padding"),
            "icon-image": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-image"], "icon-image"),
            "icon-rotate": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-rotate"], "icon-rotate"),
            "icon-padding": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-padding"], "icon-padding"),
            "icon-keep-upright": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-keep-upright"], "icon-keep-upright"),
            "icon-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-offset"], "icon-offset"),
            "icon-anchor": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["icon-anchor"], "icon-anchor"),
            "icon-pitch-alignment": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["icon-pitch-alignment"], "icon-pitch-alignment"),
            "text-pitch-alignment": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-pitch-alignment"], "text-pitch-alignment"),
            "text-rotation-alignment": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-rotation-alignment"], "text-rotation-alignment"),
            "text-field": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-field"], "text-field"),
            "text-font": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-font"], "text-font"),
            "text-size": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-size"], "text-size"),
            "text-max-width": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-max-width"], "text-max-width"),
            "text-line-height": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-line-height"], "text-line-height"),
            "text-letter-spacing": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-letter-spacing"], "text-letter-spacing"),
            "text-justify": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-justify"], "text-justify"),
            "text-radial-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-radial-offset"], "text-radial-offset"),
            "text-variable-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-variable-anchor"], "text-variable-anchor"),
            "text-variable-anchor-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-variable-anchor-offset"], "text-variable-anchor-offset"),
            "text-anchor": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-anchor"], "text-anchor"),
            "text-max-angle": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-max-angle"], "text-max-angle"),
            "text-writing-mode": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-writing-mode"], "text-writing-mode"),
            "text-rotate": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-rotate"], "text-rotate"),
            "text-padding": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-padding"], "text-padding"),
            "text-keep-upright": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-keep-upright"], "text-keep-upright"),
            "text-transform": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-transform"], "text-transform"),
            "text-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["text-offset"], "text-offset"),
            "text-allow-overlap": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-allow-overlap"], "text-allow-overlap"),
            "text-overlap": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-overlap"], "text-overlap"),
            "text-ignore-placement": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-ignore-placement"], "text-ignore-placement"),
            "text-optional": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["text-optional"], "text-optional"),
            "symbol-height-offset": new $785da19a645c07eb$var$cA($785da19a645c07eb$var$od.layout_symbol["symbol-height-offset"], "symbol-height-offset"),
            "symbol-height-anchor": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.layout_symbol["symbol-height-anchor"], "symbol-height-anchor")
        });
    }
}, $785da19a645c07eb$var$zE = class {
    constructor(e1){
        if (void 0 === e1.property.overrides) throw Error("overrides must be provided to instantiate FormatSectionOverride class");
        this.type = e1.property.overrides ? e1.property.overrides.runtimeType : $785da19a645c07eb$var$ud, this.defaultValue = e1;
    }
    evaluate(e1) {
        if (e1.formattedSection) {
            let t = this.defaultValue.property.overrides;
            if (t?.hasOverride(e1.formattedSection)) return t.getOverride(e1.formattedSection);
        }
        return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
    }
    eachChild(e1) {
        if (!this.defaultValue.isConstant()) e1(this.defaultValue.value._styleExpression.expression);
    }
    outputDefined() {
        return !1;
    }
    serialize() {
        return null;
    }
};
$785da19a645c07eb$var$qf("FormatSectionOverride", $785da19a645c07eb$var$zE, {
    omit: [
        "defaultValue"
    ]
});
const $785da19a645c07eb$var$RE = (e1)=>"symbol" === e1.type;
var $785da19a645c07eb$var$LE = class e1 extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$FE, t);
    }
    recalculate(e1, t) {
        super.recalculate(e1, t);
        let i = this.layout.get("icon-rotation-alignment");
        if (("constant" !== i.value.kind || "auto" === i.value.value) && (this.layout._values["icon-rotation-alignment"] = new $785da19a645c07eb$var$aA(i.property, {
            kind: "constant",
            value: "point" === this.layout.get("symbol-placement") ? "viewport" : "map"
        }, i.parameters)), "auto" === this.layout.get("text-rotation-alignment") && ("point" === this.layout.get("symbol-placement") ? this.layout._values["text-rotation-alignment"] = "viewport" : this.layout._values["text-rotation-alignment"] = "map"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment").constantOr("viewport")), "point" === this.layout.get("symbol-placement")) {
            let e1 = this.layout.get("text-writing-mode");
            if (e1) {
                let t = [];
                for (let i of e1)t.includes(i) || t.push(i);
                this.layout._values["text-writing-mode"] = t;
            } else this.layout._values["text-writing-mode"] = [
                "horizontal"
            ];
        }
        this._setPaintOverrides();
    }
    getValueAndResolveTokens(e1, t, i, n) {
        let a = this.layout.get(e1).evaluate(t, {}, i, n), r = this._unevaluatedLayout._values[e1];
        return r.isDataDriven() || $785da19a645c07eb$var$Eg(r.value) || !a ? a : function(e1, t) {
            return t.replace(/{([^{}]+)}/g, (t, i)=>e1 && i in e1 ? String(e1[i]) : "");
        }(t.properties, a);
    }
    createBucket(e1) {
        return new $785da19a645c07eb$var$DE(e1);
    }
    queryRadius() {
        return 0;
    }
    queryIntersectsFeature() {
        throw Error("Should take a different path in FeatureIndex");
    }
    _setPaintOverrides() {
        for (let t of $785da19a645c07eb$var$FE.paint.overridableProperties){
            if (!e1.hasPaintOverride(this.layout, t)) continue;
            let i = this.paint.get(t), n = new $785da19a645c07eb$var$xg(new $785da19a645c07eb$var$zE(i), `layers[${this.id}].paint.${i.property.name}`, i.property.specification), a = null;
            a = "constant" === i.value.kind || "source" === i.value.kind ? new $785da19a645c07eb$var$Sg("source", n) : new $785da19a645c07eb$var$Mg("composite", n, i.value.zoomStops), this.paint._values[t] = new $785da19a645c07eb$var$aA(i.property, a, i.parameters);
        }
    }
    _handleOverridablePaintPropertyUpdate(t, i, n) {
        return !(!this.layout || i.isDataDriven() || n.isDataDriven()) && e1.hasPaintOverride(this.layout, t);
    }
    static hasPaintOverride(e1, t) {
        let i = e1.get("text-field"), n = $785da19a645c07eb$var$FE.paint.properties[t], a = !1, r = (e1)=>{
            for (let t of e1)if (n.overrides?.hasOverride(t)) return void (a = !0);
        };
        if ("constant" === i.value.kind && i.value.value instanceof $785da19a645c07eb$var$sp) r(i.value.value.sections);
        else if ("source" === i.value.kind || "composite" === i.value.kind) {
            let e1 = (t)=>{
                if (!a) {
                    if (t instanceof $785da19a645c07eb$var$yp && $785da19a645c07eb$var$_p(t.value) === $785da19a645c07eb$var$yd) {
                        let e1 = t.value;
                        r(e1.sections);
                    } else t instanceof $785da19a645c07eb$var$Cp ? r(t.sections) : t.eachChild(e1);
                }
            }, t = i.value;
            t._styleExpression && e1(t._styleExpression.expression);
        }
        return a;
    }
};
let $785da19a645c07eb$var$BE;
var $785da19a645c07eb$var$OE = {
    get paint () {
        return $785da19a645c07eb$var$BE ||= new $785da19a645c07eb$var$pA({
            "background-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_background["background-color"], "background-color"),
            "background-pattern": new $785da19a645c07eb$var$hA($785da19a645c07eb$var$od.paint_background["background-pattern"], "background-pattern"),
            "background-opacity": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.paint_background["background-opacity"], "background-opacity")
        });
    }
};
var $785da19a645c07eb$var$UE = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, $785da19a645c07eb$var$OE, t);
    }
};
var $785da19a645c07eb$var$NE = class extends $785da19a645c07eb$var$fA {
    constructor(e1, t){
        super(e1, {}, t), this.onAdd = (e1)=>{
            this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
        }, this.onRemove = (e1)=>{
            this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
        }, this.implementation = e1;
    }
    is3D() {
        return "3d" === this.implementation.renderingMode;
    }
    hasOffscreenPass() {
        return void 0 !== this.implementation.prerender;
    }
    recalculate() {}
    updateTransitions() {}
    hasTransition() {
        return !1;
    }
    serialize() {
        throw Error("Custom layers cannot be serialized");
    }
};
function $785da19a645c07eb$var$jE(e1, t) {
    if ("custom" === e1.type) return new $785da19a645c07eb$var$NE(e1, t);
    switch(e1.type){
        case "background":
            return new $785da19a645c07eb$var$UE(e1, t);
        case "circle":
            return new $785da19a645c07eb$var$Nv(e1, t);
        case "color-relief":
            return new $785da19a645c07eb$var$ly(e1, t);
        case "fill":
            return new $785da19a645c07eb$var$dx(e1, t);
        case "fill-extrusion":
            return new $785da19a645c07eb$var$eb(e1, t);
        case "heatmap":
            return new $785da19a645c07eb$var$Jv(e1, t);
        case "hillshade":
            return new $785da19a645c07eb$var$ty(e1, t);
        case "line":
            return new $785da19a645c07eb$var$db(e1, t);
        case "raster":
            return new $785da19a645c07eb$var$yA(e1, t);
        case "symbol":
            return new $785da19a645c07eb$var$LE(e1, t);
    }
}
var $785da19a645c07eb$var$VE = class {
    constructor(e1){
        this._methodToThrottle = e1, this._triggered = !1, this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
            this._triggered = !1, this._methodToThrottle();
        };
    }
    trigger() {
        this._triggered || (this._triggered = !0, this._channel?.port1.postMessage(!0));
    }
    remove() {
        delete this._channel, this._methodToThrottle = ()=>{};
    }
};
const $785da19a645c07eb$var$qE = {
    once: !0
};
var $785da19a645c07eb$var$GE = class {
    constructor(e1, t){
        this.target = e1, this.mapId = t, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new $785da19a645c07eb$var$VE(()=>this.process()), this.subscription = $785da19a645c07eb$var$Th(this.target, "message", (e1)=>this.receive(e1), !1), this.globalScope = $785da19a645c07eb$var$kh(self) ? e1 : window;
    }
    registerMessageHandler(e1, t) {
        this.messageHandlers[e1] = t;
    }
    unregisterMessageHandler(e1) {
        delete this.messageHandlers[e1];
    }
    sendAsync(e1, t) {
        return new Promise((i, n)=>{
            let a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), r = t ? $785da19a645c07eb$var$Th(t.signal, "abort", ()=>{
                r?.unsubscribe(), delete this.resolveRejects[a];
                let i = {
                    id: a,
                    type: "<cancel>",
                    origin: location.origin,
                    targetMapId: e1.targetMapId,
                    sourceMapId: this.mapId
                };
                this.target.postMessage(i), n(new $785da19a645c07eb$var$Vh(t.signal.reason));
            }, $785da19a645c07eb$var$qE) : null;
            this.resolveRejects[a] = {
                resolve: (e1)=>{
                    r?.unsubscribe(), i(e1);
                },
                reject: (e1)=>{
                    r?.unsubscribe(), n(e1);
                }
            };
            let s = [], o = {
                ...e1,
                id: a,
                sourceMapId: this.mapId,
                origin: location.origin,
                data: $785da19a645c07eb$var$Zf(e1.data, s)
            };
            this.target.postMessage(o, {
                transfer: s
            });
        });
    }
    receive(e1) {
        let t = e1.data, i = t.id, n = [
            "file://",
            "resource://android",
            "null"
        ], a = [
            t.origin,
            location.origin
        ], r = t.origin === location.origin, s = a.some((e1)=>n.includes(e1));
        if ((r || s) && (!t.targetMapId || this.mapId === t.targetMapId)) {
            if ("<cancel>" === t.type) {
                delete this.tasks[i];
                let e1 = this.abortControllers[i];
                return delete this.abortControllers[i], void (e1 && e1.abort());
            }
            if ($785da19a645c07eb$var$kh(self) || t.mustQueue) return this.tasks[i] = t, this.taskQueue.push(i), void this.invoker.trigger();
            this.processTask(i, t);
        }
    }
    process() {
        if (0 === this.taskQueue.length) return;
        let e1 = this.taskQueue.shift(), t = this.tasks[e1];
        delete this.tasks[e1], this.taskQueue.length > 0 && this.invoker.trigger(), t && this.processTask(e1, t);
    }
    async processTask(e1, t) {
        if ("<response>" === t.type) {
            let i = this.resolveRejects[e1];
            if (delete this.resolveRejects[e1], !i) return;
            return void (t.error ? i.reject($785da19a645c07eb$var$Gu($785da19a645c07eb$var$Kf(t.error))) : i.resolve($785da19a645c07eb$var$Kf(t.data)));
        }
        if (!this.messageHandlers[t.type]) return void this.completeTask(e1, null, null);
        let i = $785da19a645c07eb$var$Kf(t.data), n = new AbortController;
        this.abortControllers[e1] = n;
        try {
            let a = await this.messageHandlers[t.type](t.sourceMapId, i, n);
            this.completeTask(e1, null, a);
        } catch (t) {
            this.completeTask(e1, $785da19a645c07eb$var$Gu(t));
        }
    }
    completeTask(e1, t, i) {
        let n = [];
        delete this.abortControllers[e1];
        let a = {
            id: e1,
            type: "<response>",
            sourceMapId: this.mapId,
            origin: location.origin,
            error: t ? $785da19a645c07eb$var$Zf(t) : null,
            data: $785da19a645c07eb$var$Zf(i, n)
        };
        this.target.postMessage(a, {
            transfer: n
        });
    }
    remove() {
        this.invoker.remove(), this.subscription.unsubscribe();
    }
};
function $785da19a645c07eb$var$HE(e1, t) {
    let { x: i, y: n } = $785da19a645c07eb$var$Lx.fromLngLat(t);
    return !(e1 < 0 || e1 > 25 || n < 0 || n >= 1 || i < 0 || i >= 1);
}
var $785da19a645c07eb$var$WE = class {
    constructor(e1, t, i){
        if (!function(e1, t, i) {
            return !(e1 < 0 || e1 > 25 || i < 0 || i >= 2 ** e1 || t < 0 || t >= 2 ** e1);
        }(e1, t, i)) throw Error(`x=${t}, y=${i}, z=${e1} outside of bounds. 0<=x<${2 ** e1}, 0<=y<${2 ** e1} 0<=z<=25 `);
        this.z = e1, this.x = t, this.y = i, this.key = $785da19a645c07eb$var$XE(0, e1, e1, t, i);
    }
    equals(e1) {
        return this.z === e1.z && this.x === e1.x && this.y === e1.y;
    }
    url(e1, t, i) {
        let n = function(e1, t, i) {
            t = 2 ** i - t - 1;
            let n = $785da19a645c07eb$var$YE(256 * e1, 256 * t, i), a = $785da19a645c07eb$var$YE(256 * (e1 + 1), 256 * (t + 1), i);
            return `${n[0]},${n[1]},${a[0]},${a[1]}`;
        }(this.x, this.y, this.z), a = function(e1, t, i) {
            let n = "";
            for(let a = e1; a > 0; a--){
                let e1 = 1 << a - 1;
                n += (t & e1 ? 1 : 0) + (i & e1 ? 2 : 0);
            }
            return n;
        }(this.z, this.x, this.y);
        return e1[(this.x + this.y) % e1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === i ? 2 ** this.z - this.y - 1 : this.y)).replace(/{ratio}/g, t > 1 ? "@2x" : "").replace(/{quadkey}/g, a).replace(/{bbox-epsg-3857}/g, n);
    }
    isChildOf(e1) {
        let t = this.z - e1.z;
        return t > 0 && e1.x === this.x >> t && e1.y === this.y >> t;
    }
    getTilePoint(e1) {
        let t = 2 ** this.z;
        return new $785da19a645c07eb$var$Kc((e1.x * t - this.x) * $785da19a645c07eb$var$Vu, (e1.y * t - this.y) * $785da19a645c07eb$var$Vu);
    }
    toString() {
        return `${this.z}/${this.x}/${this.y}`;
    }
}, $785da19a645c07eb$var$ZE = class {
    constructor(e1, t){
        this.wrap = e1, this.canonical = t, this.key = $785da19a645c07eb$var$XE(e1, t.z, t.z, t.x, t.y);
    }
}, $785da19a645c07eb$var$KE = class e1 {
    constructor(e1, t, i, n, a){
        if (this.terrainRttPosMatrix32f = null, e1 < i) throw Error(`overscaledZ should be >= z; overscaledZ = ${e1}; z = ${i}`);
        this.overscaledZ = e1, this.wrap = t, this.canonical = new $785da19a645c07eb$var$WE(i, +n, +a), this.key = $785da19a645c07eb$var$XE(t, e1, i, n, a);
    }
    clone() {
        return new e1(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    equals(e1) {
        return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
    }
    scaledTo(t) {
        if (t > this.overscaledZ) throw Error(`targetZ > this.overscaledZ; targetZ = ${t}; overscaledZ = ${this.overscaledZ}`);
        let i = this.canonical.z - t;
        return t > this.canonical.z ? new e1(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new e1(t, this.wrap, t, this.canonical.x >> i, this.canonical.y >> i);
    }
    isOverscaled() {
        return this.overscaledZ > this.canonical.z;
    }
    calculateScaledKey(e1, t) {
        if (e1 > this.overscaledZ) throw Error(`targetZ > this.overscaledZ; targetZ = ${e1}; overscaledZ = ${this.overscaledZ}`);
        let i = this.canonical.z - e1;
        return e1 > this.canonical.z ? $785da19a645c07eb$var$XE(this.wrap * +t, e1, this.canonical.z, this.canonical.x, this.canonical.y) : $785da19a645c07eb$var$XE(this.wrap * +t, e1, e1, this.canonical.x >> i, this.canonical.y >> i);
    }
    isChildOf(e1) {
        if (e1.wrap !== this.wrap || this.overscaledZ - e1.overscaledZ <= 0) return !1;
        if (0 === e1.overscaledZ) return this.overscaledZ > 0;
        let t = this.canonical.z - e1.canonical.z;
        return !(t < 0) && e1.canonical.x === this.canonical.x >> t && e1.canonical.y === this.canonical.y >> t;
    }
    children(t) {
        if (this.overscaledZ >= t) return [
            new e1(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
        ];
        let i = this.canonical.z + 1, n = 2 * this.canonical.x, a = 2 * this.canonical.y;
        return [
            new e1(i, this.wrap, i, n, a),
            new e1(i, this.wrap, i, n + 1, a),
            new e1(i, this.wrap, i, n, a + 1),
            new e1(i, this.wrap, i, n + 1, a + 1)
        ];
    }
    isLessThan(e1) {
        return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
    }
    wrapped() {
        return new e1(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    unwrapTo(t) {
        return new e1(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
    }
    overscaleFactor() {
        return 2 ** (this.overscaledZ - this.canonical.z);
    }
    toUnwrapped() {
        return new $785da19a645c07eb$var$ZE(this.wrap, this.canonical);
    }
    toString() {
        return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
    }
    getTilePoint(e1) {
        return this.canonical.getTilePoint(new $785da19a645c07eb$var$Lx(e1.x - this.wrap, e1.y));
    }
    normalizeCoordinates(t, i, n = $785da19a645c07eb$var$Vu) {
        if (t >= 0 && t < n && i >= 0 && i < n) return {
            tileID: this,
            x: t,
            y: i
        };
        let a = Math.floor(t / n), r = Math.floor(i / n), s = t - a * n, o = i - r * n, l = this.canonical.z, c = 1 << l, u = this.canonical.y + r;
        if (u < 0 || u >= c) return null;
        let h = this.canonical.x + a, d = this.wrap;
        return h < 0 ? (d -= Math.ceil(-h / c), h = (h % c + c) % c) : h >= c && (d += Math.floor(h / c), h %= c), {
            tileID: new e1(this.overscaledZ, d, l, h, u),
            x: s,
            y: o
        };
    }
};
function $785da19a645c07eb$var$XE(e1, t, i, n, a) {
    (e1 *= 2) < 0 && (e1 = -1 * e1 - 1);
    let r = 1 << i;
    return (r * r * e1 + r * a + n).toString(36) + i.toString(36) + t.toString(36);
}
const $785da19a645c07eb$var$QE = 6378137 * Math.PI;
function $785da19a645c07eb$var$YE(e1, t, i) {
    let n = 2 * $785da19a645c07eb$var$QE / 256 / 2 ** i;
    return [
        e1 * n - $785da19a645c07eb$var$QE,
        t * n - $785da19a645c07eb$var$QE
    ];
}
function $785da19a645c07eb$var$JE(e1, t) {
    let i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), n = Math.abs(2 * t.wrap) - +(t.wrap < 0);
    return e1.overscaledZ - t.overscaledZ || n - i || t.canonical.y - e1.canonical.y || t.canonical.x - e1.canonical.x;
}
$785da19a645c07eb$var$qf("CanonicalTileID", $785da19a645c07eb$var$WE), $785da19a645c07eb$var$qf("OverscaledTileID", $785da19a645c07eb$var$KE, {
    omit: [
        "terrainRttPosMatrix32f"
    ]
});
const $785da19a645c07eb$var$$E = "_geojsonTileLayer";
var $785da19a645c07eb$var$ek = class {
    constructor(e1){
        this._stringToNumber = {}, this._numberToString = [];
        for(let t = 0; t < e1.length; t++){
            let i = e1[t];
            this._stringToNumber[i] = t, this._numberToString[t] = i;
        }
    }
    encode(e1) {
        return this._stringToNumber[e1];
    }
    decode(e1) {
        if (e1 >= this._numberToString.length) throw Error(`Out of bounds. Index requested n=${e1} can't be >= this._numberToString.length ${this._numberToString.length}`);
        return this._numberToString[e1];
    }
}, $785da19a645c07eb$var$tk = class {
    constructor(e1, t, i, n, a){
        this.type = "Feature", this._vectorTileFeature = e1, this._x = i, this._y = n, this._z = t;
        for(let t in e1.properties)"string" == typeof e1.properties[t] && e1.properties[t].startsWith("__$json__:") && (e1.properties[t] = JSON.parse(e1.properties[t].slice(10)));
        this.properties = e1.properties, this.id = a;
    }
    projectPoint(e1, t, i, n) {
        return [
            360 * (e1.x + t) / n - 180,
            360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + i) / n) * Math.PI)) - 90
        ];
    }
    projectLine(e1, t, i, n) {
        return e1.map((e1)=>this.projectPoint(e1, t, i, n));
    }
    get geometry() {
        if (this._geometry) return this._geometry;
        let e1 = this._vectorTileFeature, t = e1.extent * 2 ** this._z, i = e1.extent * this._x, n = e1.extent * this._y, a = e1.loadGeometry();
        switch(e1.type){
            case 1:
                {
                    let e1 = [];
                    for (let t of a)e1.push(t[0]);
                    let r = this.projectLine(e1, i, n, t);
                    this._geometry = 1 === e1.length ? {
                        type: "Point",
                        coordinates: r[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: r
                    };
                    break;
                }
            case 2:
                {
                    let e1 = a.map((e1)=>this.projectLine(e1, i, n, t));
                    this._geometry = 1 === e1.length ? {
                        type: "LineString",
                        coordinates: e1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e1
                    };
                    break;
                }
            case 3:
                {
                    let e1 = $785da19a645c07eb$var$xx(a), r = [];
                    for (let a of e1)r.push(a.map((e1)=>this.projectLine(e1, i, n, t)));
                    this._geometry = 1 === r.length ? {
                        type: "Polygon",
                        coordinates: r[0]
                    } : {
                        type: "MultiPolygon",
                        coordinates: r
                    };
                    break;
                }
            default:
                throw Error(`unknown feature type: ${e1.type}`);
        }
        return this._geometry;
    }
    set geometry(e1) {
        this._geometry = e1;
    }
    toJSON() {
        let e1 = {
            geometry: this.geometry
        };
        for(let t in this)"_geometry" !== t && "_vectorTileFeature" !== t && "_x" !== t && "_y" !== t && "_z" !== t && (e1[t] = this[t]);
        return e1;
    }
}, $785da19a645c07eb$var$ik = class {
    constructor(e1, t, i){
        this._name = e1, this.dataBuffer = t, "number" == typeof i ? this._size = i : (this.nullabilityBuffer = i, this._size = i.size());
    }
    getValue(e1) {
        return this.nullabilityBuffer && !this.nullabilityBuffer.get(e1) ? null : this.getValueFromBuffer(e1);
    }
    has(e1) {
        return this.nullabilityBuffer?.get(e1) || !this.nullabilityBuffer;
    }
    get name() {
        return this._name;
    }
    get size() {
        return this._size;
    }
}, $785da19a645c07eb$var$nk = class extends $785da19a645c07eb$var$ik {
}, $785da19a645c07eb$var$ak = class extends $785da19a645c07eb$var$nk {
    getValueFromBuffer(e1) {
        return this.dataBuffer[e1];
    }
}, $785da19a645c07eb$var$rk = class extends $785da19a645c07eb$var$nk {
    getValueFromBuffer(e1) {
        return this.dataBuffer[e1];
    }
}, $785da19a645c07eb$var$sk = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i, n){
        super(e1, t, n), this.delta = i;
    }
}, $785da19a645c07eb$var$ok = class extends $785da19a645c07eb$var$sk {
    constructor(e1, t, i, n, a){
        super(e1, a ? Int32Array.of(t) : Uint32Array.of(t), i, n);
    }
    getValueFromBuffer(e1) {
        return this.dataBuffer[0] + e1 * this.delta;
    }
}, $785da19a645c07eb$var$lk = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i, n){
        super(e1, n ? Int32Array.of(t) : Uint32Array.of(t), i);
    }
    getValueFromBuffer(e1) {
        return this.dataBuffer[0];
    }
}, $785da19a645c07eb$var$ck = class {
    constructor(e1, t, i, n, a = 4096){
        if (this._name = e1, this._geometryVector = t, this._idVector = i, this._propertyVectors = n, this._extent = a, 0 === e1.length) throw Error("Missing layer name");
    }
    get name() {
        return this._name;
    }
    get idVector() {
        return this._idVector;
    }
    get geometryVector() {
        return this._geometryVector;
    }
    get propertyVectors() {
        return this._propertyVectors ?? [];
    }
    getPropertyVector(e1) {
        return this.propertyVectorsMap ||= new Map(this.propertyVectors.map((e1)=>[
                e1.name,
                e1
            ])), this.propertyVectorsMap.get(e1);
    }
    get numFeatures() {
        return this.geometryVector.numGeometries;
    }
    get extent() {
        return this._extent;
    }
    getFeatures() {
        let e1 = [], t = this.geometryVector.getGeometries();
        for(let i = 0; i < this.numFeatures; i++){
            let n;
            if (this.idVector) {
                let e1 = this.idVector.getValue(i);
                null !== e1 && (n = this.containsMaxSafeIntegerValues(this.idVector) ? Number(e1) : e1);
            }
            let a = {
                coordinates: t[i],
                type: this.geometryVector.geometryType(i)
            }, r = {};
            for (let e1 of this.propertyVectors){
                if (!e1) continue;
                let t = e1.name, n = e1.getValue(i);
                null !== n && (r[t] = n);
            }
            e1.push({
                id: n,
                geometry: a,
                properties: r
            });
        }
        return e1;
    }
    containsMaxSafeIntegerValues(e1) {
        return e1 instanceof $785da19a645c07eb$var$ak || e1 instanceof $785da19a645c07eb$var$lk || e1 instanceof $785da19a645c07eb$var$ok || e1 instanceof $785da19a645c07eb$var$rk;
    }
};
const $785da19a645c07eb$var$uk = 0, $785da19a645c07eb$var$hk = 0, $785da19a645c07eb$var$dk = 1, $785da19a645c07eb$var$pk = 2, $785da19a645c07eb$var$mk = 3, $785da19a645c07eb$var$gk = 4, $785da19a645c07eb$var$fk = 5, $785da19a645c07eb$var$Ak = 6, $785da19a645c07eb$var$_k = 7, $785da19a645c07eb$var$vk = 8, $785da19a645c07eb$var$yk = 9, $785da19a645c07eb$var$xk = 0, $785da19a645c07eb$var$bk = 1, $785da19a645c07eb$var$wk = 2, $785da19a645c07eb$var$Ek = 0;
var $785da19a645c07eb$var$kk, $785da19a645c07eb$var$Sk, $785da19a645c07eb$var$Mk = class {
    constructor(e1){
        this.value = e1;
    }
    get() {
        return this.value;
    }
    set(e1) {
        this.value = e1;
    }
    increment() {
        return this.value++;
    }
    add(e1) {
        this.value += e1;
    }
};
!function(e1) {
    e1.NONE = "NONE", e1.DELTA = "DELTA", e1.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", e1.RLE = "RLE", e1.MORTON = "MORTON";
}($785da19a645c07eb$var$kk ||= {}), function(e1) {
    e1.NONE = "NONE", e1.FAST_PFOR = "FAST_PFOR", e1.VARINT = "VARINT";
}($785da19a645c07eb$var$Sk ||= {});
const $785da19a645c07eb$var$Ck = new Uint32Array(33);
$785da19a645c07eb$var$Ck[0] = 0;
for(let e1 = 1; e1 <= 32; e1++)$785da19a645c07eb$var$Ck[e1] = 32 === e1 ? 4294967295 : 4294967295 >>> 32 - e1;
const $785da19a645c07eb$var$Tk = $785da19a645c07eb$var$Ck;
function $785da19a645c07eb$var$Dk(e1, t) {
    return e1 - e1 % t;
}
function $785da19a645c07eb$var$Pk(e1) {
    return $785da19a645c07eb$var$Dk(e1 + 31, 32);
}
function $785da19a645c07eb$var$Ik(e1) {
    let t = e1 >>> 0;
    return ((255 & t) << 24 | (65280 & t) << 8 | t >>> 8 & 65280 | t >>> 24 & 255) >>> 0;
}
const $785da19a645c07eb$var$Fk = function(e1) {
    if (!Number.isFinite(e1) || e1 <= 0) return 65536;
    let t = $785da19a645c07eb$var$Dk(Math.floor(e1), 256);
    return 0 === t ? 256 : t;
}(65536), $785da19a645c07eb$var$zk = 3 * $785da19a645c07eb$var$Fk / 256 + $785da19a645c07eb$var$Fk | 0;
function $785da19a645c07eb$var$Rk() {
    let e1 = new Uint8Array($785da19a645c07eb$var$zk);
    return {
        dataToBePacked: Array(33),
        dataPointers: new Int32Array(33),
        byteContainer: e1,
        byteContainerI32: new Int32Array(e1.buffer, e1.byteOffset, e1.byteLength >>> 2),
        exceptionSizes: new Int32Array(33)
    };
}
function $785da19a645c07eb$var$Lk(e1, t, i, n, a) {
    switch(a){
        case 1:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 1, i[a++] = t >>> 1 & 1, i[a++] = t >>> 2 & 1, i[a++] = t >>> 3 & 1, i[a++] = t >>> 4 & 1, i[a++] = t >>> 5 & 1, i[a++] = t >>> 6 & 1, i[a++] = t >>> 7 & 1, i[a++] = t >>> 8 & 1, i[a++] = t >>> 9 & 1, i[a++] = t >>> 10 & 1, i[a++] = t >>> 11 & 1, i[a++] = t >>> 12 & 1, i[a++] = t >>> 13 & 1, i[a++] = t >>> 14 & 1, i[a++] = t >>> 15 & 1, i[a++] = t >>> 16 & 1, i[a++] = t >>> 17 & 1, i[a++] = t >>> 18 & 1, i[a++] = t >>> 19 & 1, i[a++] = t >>> 20 & 1, i[a++] = t >>> 21 & 1, i[a++] = t >>> 22 & 1, i[a++] = t >>> 23 & 1, i[a++] = t >>> 24 & 1, i[a++] = t >>> 25 & 1, i[a++] = t >>> 26 & 1, i[a++] = t >>> 27 & 1, i[a++] = t >>> 28 & 1, i[a++] = t >>> 29 & 1, i[a++] = t >>> 30 & 1, i[a++] = t >>> 31 & 1;
                }
            }(e1, t, i, n);
            break;
        case 2:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 3, i[a++] = t >>> 2 & 3, i[a++] = t >>> 4 & 3, i[a++] = t >>> 6 & 3, i[a++] = t >>> 8 & 3, i[a++] = t >>> 10 & 3, i[a++] = t >>> 12 & 3, i[a++] = t >>> 14 & 3, i[a++] = t >>> 16 & 3, i[a++] = t >>> 18 & 3, i[a++] = t >>> 20 & 3, i[a++] = t >>> 22 & 3, i[a++] = t >>> 24 & 3, i[a++] = t >>> 26 & 3, i[a++] = t >>> 28 & 3, i[a++] = t >>> 30 & 3, i[a++] = n >>> 0 & 3, i[a++] = n >>> 2 & 3, i[a++] = n >>> 4 & 3, i[a++] = n >>> 6 & 3, i[a++] = n >>> 8 & 3, i[a++] = n >>> 10 & 3, i[a++] = n >>> 12 & 3, i[a++] = n >>> 14 & 3, i[a++] = n >>> 16 & 3, i[a++] = n >>> 18 & 3, i[a++] = n >>> 20 & 3, i[a++] = n >>> 22 & 3, i[a++] = n >>> 24 & 3, i[a++] = n >>> 26 & 3, i[a++] = n >>> 28 & 3, i[a++] = n >>> 30 & 3;
                }
            }(e1, t, i, n);
            break;
        case 3:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 7, i[a++] = t >>> 3 & 7, i[a++] = t >>> 6 & 7, i[a++] = t >>> 9 & 7, i[a++] = t >>> 12 & 7, i[a++] = t >>> 15 & 7, i[a++] = t >>> 18 & 7, i[a++] = t >>> 21 & 7, i[a++] = t >>> 24 & 7, i[a++] = t >>> 27 & 7, i[a++] = 7 & (t >>> 30 | (1 & n) << 2), i[a++] = n >>> 1 & 7, i[a++] = n >>> 4 & 7, i[a++] = n >>> 7 & 7, i[a++] = n >>> 10 & 7, i[a++] = n >>> 13 & 7, i[a++] = n >>> 16 & 7, i[a++] = n >>> 19 & 7, i[a++] = n >>> 22 & 7, i[a++] = n >>> 25 & 7, i[a++] = n >>> 28 & 7, i[a++] = 7 & (n >>> 31 | (3 & s) << 1), i[a++] = s >>> 2 & 7, i[a++] = s >>> 5 & 7, i[a++] = s >>> 8 & 7, i[a++] = s >>> 11 & 7, i[a++] = s >>> 14 & 7, i[a++] = s >>> 17 & 7, i[a++] = s >>> 20 & 7, i[a++] = s >>> 23 & 7, i[a++] = s >>> 26 & 7, i[a++] = s >>> 29 & 7;
                }
            }(e1, t, i, n);
            break;
        case 4:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0, o = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 15, i[a++] = t >>> 4 & 15, i[a++] = t >>> 8 & 15, i[a++] = t >>> 12 & 15, i[a++] = t >>> 16 & 15, i[a++] = t >>> 20 & 15, i[a++] = t >>> 24 & 15, i[a++] = t >>> 28 & 15, i[a++] = n >>> 0 & 15, i[a++] = n >>> 4 & 15, i[a++] = n >>> 8 & 15, i[a++] = n >>> 12 & 15, i[a++] = n >>> 16 & 15, i[a++] = n >>> 20 & 15, i[a++] = n >>> 24 & 15, i[a++] = n >>> 28 & 15, i[a++] = s >>> 0 & 15, i[a++] = s >>> 4 & 15, i[a++] = s >>> 8 & 15, i[a++] = s >>> 12 & 15, i[a++] = s >>> 16 & 15, i[a++] = s >>> 20 & 15, i[a++] = s >>> 24 & 15, i[a++] = s >>> 28 & 15, i[a++] = o >>> 0 & 15, i[a++] = o >>> 4 & 15, i[a++] = o >>> 8 & 15, i[a++] = o >>> 12 & 15, i[a++] = o >>> 16 & 15, i[a++] = o >>> 20 & 15, i[a++] = o >>> 24 & 15, i[a++] = o >>> 28 & 15;
                }
            }(e1, t, i, n);
            break;
        case 5:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0, o = e1[r++] >>> 0, l = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 31, i[a++] = t >>> 5 & 31, i[a++] = t >>> 10 & 31, i[a++] = t >>> 15 & 31, i[a++] = t >>> 20 & 31, i[a++] = t >>> 25 & 31, i[a++] = 31 & (t >>> 30 | (7 & n) << 2), i[a++] = n >>> 3 & 31, i[a++] = n >>> 8 & 31, i[a++] = n >>> 13 & 31, i[a++] = n >>> 18 & 31, i[a++] = n >>> 23 & 31, i[a++] = 31 & (n >>> 28 | (1 & s) << 4), i[a++] = s >>> 1 & 31, i[a++] = s >>> 6 & 31, i[a++] = s >>> 11 & 31, i[a++] = s >>> 16 & 31, i[a++] = s >>> 21 & 31, i[a++] = s >>> 26 & 31, i[a++] = 31 & (s >>> 31 | (15 & o) << 1), i[a++] = o >>> 4 & 31, i[a++] = o >>> 9 & 31, i[a++] = o >>> 14 & 31, i[a++] = o >>> 19 & 31, i[a++] = o >>> 24 & 31, i[a++] = 31 & (o >>> 29 | (3 & l) << 3), i[a++] = l >>> 2 & 31, i[a++] = l >>> 7 & 31, i[a++] = l >>> 12 & 31, i[a++] = l >>> 17 & 31, i[a++] = l >>> 22 & 31, i[a++] = l >>> 27 & 31;
                }
            }(e1, t, i, n);
            break;
        case 6:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0, o = e1[r++] >>> 0, l = e1[r++] >>> 0, c = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 63, i[a++] = t >>> 6 & 63, i[a++] = t >>> 12 & 63, i[a++] = t >>> 18 & 63, i[a++] = t >>> 24 & 63, i[a++] = 63 & (t >>> 30 | (15 & n) << 2), i[a++] = n >>> 4 & 63, i[a++] = n >>> 10 & 63, i[a++] = n >>> 16 & 63, i[a++] = n >>> 22 & 63, i[a++] = 63 & (n >>> 28 | (3 & s) << 4), i[a++] = s >>> 2 & 63, i[a++] = s >>> 8 & 63, i[a++] = s >>> 14 & 63, i[a++] = s >>> 20 & 63, i[a++] = s >>> 26 & 63, i[a++] = o >>> 0 & 63, i[a++] = o >>> 6 & 63, i[a++] = o >>> 12 & 63, i[a++] = o >>> 18 & 63, i[a++] = o >>> 24 & 63, i[a++] = 63 & (o >>> 30 | (15 & l) << 2), i[a++] = l >>> 4 & 63, i[a++] = l >>> 10 & 63, i[a++] = l >>> 16 & 63, i[a++] = l >>> 22 & 63, i[a++] = 63 & (l >>> 28 | (3 & c) << 4), i[a++] = c >>> 2 & 63, i[a++] = c >>> 8 & 63, i[a++] = c >>> 14 & 63, i[a++] = c >>> 20 & 63, i[a++] = c >>> 26 & 63;
                }
            }(e1, t, i, n);
            break;
        case 7:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0, o = e1[r++] >>> 0, l = e1[r++] >>> 0, c = e1[r++] >>> 0, u = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 127, i[a++] = t >>> 7 & 127, i[a++] = t >>> 14 & 127, i[a++] = t >>> 21 & 127, i[a++] = 127 & (t >>> 28 | (7 & n) << 4), i[a++] = n >>> 3 & 127, i[a++] = n >>> 10 & 127, i[a++] = n >>> 17 & 127, i[a++] = n >>> 24 & 127, i[a++] = 127 & (n >>> 31 | (63 & s) << 1), i[a++] = s >>> 6 & 127, i[a++] = s >>> 13 & 127, i[a++] = s >>> 20 & 127, i[a++] = 127 & (s >>> 27 | (3 & o) << 5), i[a++] = o >>> 2 & 127, i[a++] = o >>> 9 & 127, i[a++] = o >>> 16 & 127, i[a++] = o >>> 23 & 127, i[a++] = 127 & (o >>> 30 | (31 & l) << 2), i[a++] = l >>> 5 & 127, i[a++] = l >>> 12 & 127, i[a++] = l >>> 19 & 127, i[a++] = 127 & (l >>> 26 | (1 & c) << 6), i[a++] = c >>> 1 & 127, i[a++] = c >>> 8 & 127, i[a++] = c >>> 15 & 127, i[a++] = c >>> 22 & 127, i[a++] = 127 & (c >>> 29 | (15 & u) << 3), i[a++] = u >>> 4 & 127, i[a++] = u >>> 11 & 127, i[a++] = u >>> 18 & 127, i[a++] = u >>> 25 & 127;
                }
            }(e1, t, i, n);
            break;
        case 8:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 8; t++){
                    let t = e1[r++] >>> 0, n = e1[r++] >>> 0, s = e1[r++] >>> 0, o = e1[r++] >>> 0, l = e1[r++] >>> 0, c = e1[r++] >>> 0, u = e1[r++] >>> 0, h = e1[r++] >>> 0;
                    i[a++] = t >>> 0 & 255, i[a++] = t >>> 8 & 255, i[a++] = t >>> 16 & 255, i[a++] = t >>> 24 & 255, i[a++] = n >>> 0 & 255, i[a++] = n >>> 8 & 255, i[a++] = n >>> 16 & 255, i[a++] = n >>> 24 & 255, i[a++] = s >>> 0 & 255, i[a++] = s >>> 8 & 255, i[a++] = s >>> 16 & 255, i[a++] = s >>> 24 & 255, i[a++] = o >>> 0 & 255, i[a++] = o >>> 8 & 255, i[a++] = o >>> 16 & 255, i[a++] = o >>> 24 & 255, i[a++] = l >>> 0 & 255, i[a++] = l >>> 8 & 255, i[a++] = l >>> 16 & 255, i[a++] = l >>> 24 & 255, i[a++] = c >>> 0 & 255, i[a++] = c >>> 8 & 255, i[a++] = c >>> 16 & 255, i[a++] = c >>> 24 & 255, i[a++] = u >>> 0 & 255, i[a++] = u >>> 8 & 255, i[a++] = u >>> 16 & 255, i[a++] = u >>> 24 & 255, i[a++] = h >>> 0 & 255, i[a++] = h >>> 8 & 255, i[a++] = h >>> 16 & 255, i[a++] = h >>> 24 & 255;
                }
            }(e1, t, i, n);
            break;
        case 16:
            !function(e1, t, i, n) {
                let a = n, r = t;
                for(let t = 0; t < 128; t++){
                    let t = e1[r++] >>> 0;
                    i[a++] = 65535 & t, i[a++] = t >>> 16 & 65535;
                }
            }(e1, t, i, n);
            break;
        default:
            !function(e1, t, i, n, a) {
                let r = $785da19a645c07eb$var$Tk[a] >>> 0, s = t, o = 0, l = e1[s] >>> 0, c = n;
                for(let t = 0; t < 8; t++){
                    for(let t = 0; t < 32; t++)if (o + a <= 32) {
                        let n = l >>> o & r;
                        i[c + t] = 0 | n, o += a, 32 === o && (o = 0, s++, 31 !== t && (l = e1[s] >>> 0));
                    } else {
                        let n = 32 - o, u = l >>> o;
                        s++, l = e1[s] >>> 0;
                        let h = a - n, d = (u | (l & -1 >>> 32 - h >>> 0) << n) & r;
                        i[c + t] = 0 | d, o = h;
                    }
                    c += 32, o = 0, t < 7 && (l = e1[s] >>> 0);
                }
            }(e1, t, i, n, a);
    }
    return t + (a << 3) | 0;
}
function $785da19a645c07eb$var$Bk(e1, t, i, n) {
    if (i + 2 > t) throw Error(`FastPFOR decode: byteContainer underflow at block=${n} (need 2 bytes for [bitWidth, exceptionCount], bytePos=${i}, byteSize=${t})`);
    let a = e1[i++], r = e1[i++];
    if (a > 32) throw Error(`FastPFOR decode: invalid bitWidth=${a} at block=${n} (expected 0..32). This likely indicates corrupted or truncated input.`);
    return {
        bitWidth: a,
        exceptionCount: r,
        bytePosIn: i
    };
}
function $785da19a645c07eb$var$Ok(e1, t, i, n, a, r, s, o, l) {
    let { maxBits: c, exceptionBitWidth: u, bytePosIn: h } = function(e1, t, i, n, a, r) {
        if (i + 1 > t) throw Error(`FastPFOR decode: exception header underflow at block=${r} (need 1 byte for maxBits, bytePos=${i}, byteSize=${t})`);
        let s = e1[i++];
        if (s < n || s > 32) throw Error(`FastPFOR decode: invalid maxBits=${s} at block=${r} (bitWidth=${n}, expected ${n}..32)`);
        let o = s - n | 0;
        if (o < 1 || o > 32) throw Error(`FastPFOR decode: invalid exceptionBitWidth=${o} at block=${r} (bitWidth=${n}, maxBits=${s})`);
        if (i + a > t) throw Error(`FastPFOR decode: exception positions underflow at block=${r} (need=${a}, have=${t - i})`);
        return {
            maxBits: s,
            exceptionBitWidth: o,
            bytePosIn: i
        };
    }(a, r, s, i, n, l);
    if (s = h, 1 === u) {
        let r = 1 << i;
        for(let i = 0; i < n; i = i + 1 | 0)e1[a[s++] + t | 0] |= r;
        return s;
    }
    let d = o.dataToBePacked[u];
    if (!d) throw Error(`FastPFOR decode: missing exception stream for exceptionBitWidth=${u} (bitWidth=${i}, maxBits=${c}) at block ${l}`);
    let p = o.dataPointers, m = 0 | p[u], g = 0 | o.exceptionSizes[u];
    if (m + n > g) throw Error(`FastPFOR decode: exception stream overflow for exceptionBitWidth=${u} (ptr=${m}, need ${n}, size=${g}) at block ${l}`);
    for(let r = 0; r < n; r = r + 1 | 0){
        let n = a[s++], r = 0 | d[m++];
        e1[n + t | 0] |= r << i;
    }
    return p[u] = m, s;
}
function $785da19a645c07eb$var$Uk(e1, t, i, n, a, r) {
    let s = 0 | i, o = 0 | e1[s];
    if (o <= 0 || s + o > e1.length - 1) throw Error(`FastPFOR decode: invalid whereMeta=${o} at pageStart=${s} (expected > 0 and pageStart+whereMeta < encoded.length=${e1.length})`);
    let l = s + 1 | 0, c = s + o | 0, u = e1[c] >>> 0, h = u + 3 >>> 2, d = c + 1, p = d + h;
    if (p >= e1.length) throw Error(`FastPFOR decode: invalid byteSize=${u} (metaInts=${h}, pageStart=${s}, packedEnd=${c}, byteContainerStart=${d}) causes bitmapPos=${p} out of bounds (encoded.length=${e1.length})`);
    let m = function(e1, t, i, n) {
        n.byteContainer.length < i && (n.byteContainer = new Uint8Array(2 * i), n.byteContainerI32 = void 0);
        let a = n.byteContainer, r = i >>> 2;
        if (3 & a.byteOffset) for(let i = 0; i < r; i = i + 1 | 0){
            let n = 0 | e1[t + i | 0], r = i << 2;
            a[r] = 255 & n, a[r + 1 | 0] = n >>> 8 & 255, a[r + 2 | 0] = n >>> 16 & 255, a[r + 3 | 0] = n >>> 24 & 255;
        }
        else {
            let i = n.byteContainerI32;
            (!i || i.buffer !== a.buffer || i.byteOffset !== a.byteOffset || i.length < r) && (i = n.byteContainerI32 = new Int32Array(a.buffer, a.byteOffset, a.byteLength >>> 2)), i.set(e1.subarray(t, t + r));
        }
        let s = 3 & i;
        if (s > 0) {
            let i = 0 | e1[t + r | 0], n = r << 2;
            for(let e1 = 0; e1 < s; e1 = e1 + 1 | 0)a[n + e1 | 0] = i >>> (e1 << 3) & 255;
        }
        return a;
    }(e1, d, u, r), g = u, f = function(e1, t, i) {
        let n = 0 | e1[t++], a = i.dataToBePacked;
        for(let r = 2; r <= 32; r = r + 1 | 0){
            if (!(n >>> r - 1 & 1)) continue;
            if (t >= e1.length) throw Error(`FastPFOR decode: truncated exception stream header (bitWidth=${r}, streamWordIndex=${t}, needWords=1, availableWords=${e1.length - t}, encodedWords=${e1.length})`);
            let s = e1[t++] >>> 0, o = $785da19a645c07eb$var$Pk(s), l = s * r + 31 >>> 5;
            if (t + l > e1.length) throw Error(`FastPFOR decode: truncated exception stream (bitWidth=${r}, size=${s}, streamWordIndex=${t}, needWords=${l}, availableWords=${e1.length - t}, encodedWords=${e1.length})`);
            let c = a[r];
            (!c || c.length < o) && (c = a[r] = new Uint32Array(o));
            let u = 0;
            for(; u < s; u = u + 32 | 0)$785da19a645c07eb$var$jk(e1, t, c, u, r), t = t + r | 0;
            t = t - ((u - s | 0) * r >>> 5) | 0, i.exceptionSizes[r] = s;
        }
        return t;
    }(e1, p, r);
    return r.dataPointers.fill(0), function(e1, t, i, n, a, r, s, o, l, c) {
        let u = 0 | i, h = 0;
        for(let t = 0; t < s; t = t + 1 | 0){
            let i = $785da19a645c07eb$var$Bk(o, l, h, t);
            h = i.bytePosIn;
            let n = i.bitWidth, s = i.exceptionCount, d = r + 256 * t | 0;
            switch(n){
                case 0:
                    a.fill(0, d, d + 256);
                    break;
                case 32:
                    for(let t = 0; t < 256; t = t + 1 | 0)a[d + t | 0] = 0 | e1[u + t | 0];
                    u = u + 256 | 0;
                    break;
                default:
                    u = $785da19a645c07eb$var$Lk(e1, u, a, d, n);
            }
            s > 0 && (h = $785da19a645c07eb$var$Ok(a, d, n, s, o, l, h, c, t));
        }
        if (u !== n) throw Error(`FastPFOR decode: packed region mismatch (pageStart=${t}, packedStart=${i}, consumedPackedEnd=${u}, expectedPackedEnd=${n}, packedWords=${n - i}, encoded.length=${e1.length})`);
    }(e1, s, l, c, t, 0 | n, a / 256 | 0, m, g, r), f;
}
function $785da19a645c07eb$var$Nk(e1, t, i) {
    let n = 0, a = 0, r = new Uint32Array(t), s = i ?? $785da19a645c07eb$var$Rk();
    if (e1.length > 0) {
        let t = 0 | e1[n];
        if (n = n + 1 | 0, 255 & t) throw Error(`FastPFOR decode: invalid alignedLength=${t} (expected multiple of 256)`);
        if (a + t > r.length) throw Error(`FastPFOR decode: output buffer too small (outPos=${a}, alignedLength=${t}, out.length=${r.length})`);
        n = function(e1, t, i, n, a, r) {
            let s = n + $785da19a645c07eb$var$Dk(a, 256), o = n, l = i;
            for(; o !== s;){
                let i = Math.min($785da19a645c07eb$var$Fk, s - o);
                l = $785da19a645c07eb$var$Uk(e1, t, l, o, i, r), o = o + i | 0;
            }
            return l;
        }(e1, r, n, a, t, s), a = a + t | 0;
    }
    return function(e1, t, i, n, a, r) {
        if (0 === r) return t;
        let s = 0, o = t, l = t + i, c = a, u = a, h = a + r, d = 0, p = 0;
        for(; o < l && u < h;){
            let t = e1[o] >>> s & 255;
            if (s += 8, o += s >>> 5, s &= 31, d |= (127 & t) << p, 128 & t) n[u++] = 0 | d, d = 0, p = 0;
            else if (p += 7, p > 28) throw Error(`FastPFOR VByte: unterminated value (expected MSB=1 terminator within 5 bytes; shift=${p}, partial=${d}, decoded=${u - c}/${r}, inPos=${o}, inEnd=${l})`);
        }
        if (u !== h) throw Error(`FastPFOR VByte: truncated stream (decoded=${u - c}, expected=${r}, consumedWords=${o - t}/${i}, vbyteStart=${t}, vbyteEnd=${l})`);
    }(e1, n, e1.length - n | 0, r, a, t - a | 0), r;
}
function $785da19a645c07eb$var$jk(e1, t, i, n, a) {
    switch(a){
        case 2:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0;
                i[a++] = r >>> 0 & 3, i[a++] = r >>> 2 & 3, i[a++] = r >>> 4 & 3, i[a++] = r >>> 6 & 3, i[a++] = r >>> 8 & 3, i[a++] = r >>> 10 & 3, i[a++] = r >>> 12 & 3, i[a++] = r >>> 14 & 3, i[a++] = r >>> 16 & 3, i[a++] = r >>> 18 & 3, i[a++] = r >>> 20 & 3, i[a++] = r >>> 22 & 3, i[a++] = r >>> 24 & 3, i[a++] = r >>> 26 & 3, i[a++] = r >>> 28 & 3, i[a++] = r >>> 30 & 3, i[a++] = s >>> 0 & 3, i[a++] = s >>> 2 & 3, i[a++] = s >>> 4 & 3, i[a++] = s >>> 6 & 3, i[a++] = s >>> 8 & 3, i[a++] = s >>> 10 & 3, i[a++] = s >>> 12 & 3, i[a++] = s >>> 14 & 3, i[a++] = s >>> 16 & 3, i[a++] = s >>> 18 & 3, i[a++] = s >>> 20 & 3, i[a++] = s >>> 22 & 3, i[a++] = s >>> 24 & 3, i[a++] = s >>> 26 & 3, i[a++] = s >>> 28 & 3, i[a] = s >>> 30 & 3;
            }(e1, t, i, n);
        case 3:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0;
                i[a++] = r >>> 0 & 7, i[a++] = r >>> 3 & 7, i[a++] = r >>> 6 & 7, i[a++] = r >>> 9 & 7, i[a++] = r >>> 12 & 7, i[a++] = r >>> 15 & 7, i[a++] = r >>> 18 & 7, i[a++] = r >>> 21 & 7, i[a++] = r >>> 24 & 7, i[a++] = r >>> 27 & 7, i[a++] = 7 & (r >>> 30 | (1 & s) << 2), i[a++] = s >>> 1 & 7, i[a++] = s >>> 4 & 7, i[a++] = s >>> 7 & 7, i[a++] = s >>> 10 & 7, i[a++] = s >>> 13 & 7, i[a++] = s >>> 16 & 7, i[a++] = s >>> 19 & 7, i[a++] = s >>> 22 & 7, i[a++] = s >>> 25 & 7, i[a++] = s >>> 28 & 7, i[a++] = 7 & (s >>> 31 | (3 & o) << 1), i[a++] = o >>> 2 & 7, i[a++] = o >>> 5 & 7, i[a++] = o >>> 8 & 7, i[a++] = o >>> 11 & 7, i[a++] = o >>> 14 & 7, i[a++] = o >>> 17 & 7, i[a++] = o >>> 20 & 7, i[a++] = o >>> 23 & 7, i[a++] = o >>> 26 & 7, i[a] = o >>> 29 & 7;
            }(e1, t, i, n);
        case 4:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0;
                i[a++] = r >>> 0 & 15, i[a++] = r >>> 4 & 15, i[a++] = r >>> 8 & 15, i[a++] = r >>> 12 & 15, i[a++] = r >>> 16 & 15, i[a++] = r >>> 20 & 15, i[a++] = r >>> 24 & 15, i[a++] = r >>> 28 & 15, i[a++] = s >>> 0 & 15, i[a++] = s >>> 4 & 15, i[a++] = s >>> 8 & 15, i[a++] = s >>> 12 & 15, i[a++] = s >>> 16 & 15, i[a++] = s >>> 20 & 15, i[a++] = s >>> 24 & 15, i[a++] = s >>> 28 & 15, i[a++] = o >>> 0 & 15, i[a++] = o >>> 4 & 15, i[a++] = o >>> 8 & 15, i[a++] = o >>> 12 & 15, i[a++] = o >>> 16 & 15, i[a++] = o >>> 20 & 15, i[a++] = o >>> 24 & 15, i[a++] = o >>> 28 & 15, i[a++] = l >>> 0 & 15, i[a++] = l >>> 4 & 15, i[a++] = l >>> 8 & 15, i[a++] = l >>> 12 & 15, i[a++] = l >>> 16 & 15, i[a++] = l >>> 20 & 15, i[a++] = l >>> 24 & 15, i[a] = l >>> 28 & 15;
            }(e1, t, i, n);
        case 5:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0;
                i[a++] = r >>> 0 & 31, i[a++] = r >>> 5 & 31, i[a++] = r >>> 10 & 31, i[a++] = r >>> 15 & 31, i[a++] = r >>> 20 & 31, i[a++] = r >>> 25 & 31, i[a++] = 31 & (r >>> 30 | (7 & s) << 2), i[a++] = s >>> 3 & 31, i[a++] = s >>> 8 & 31, i[a++] = s >>> 13 & 31, i[a++] = s >>> 18 & 31, i[a++] = s >>> 23 & 31, i[a++] = 31 & (s >>> 28 | (1 & o) << 4), i[a++] = o >>> 1 & 31, i[a++] = o >>> 6 & 31, i[a++] = o >>> 11 & 31, i[a++] = o >>> 16 & 31, i[a++] = o >>> 21 & 31, i[a++] = o >>> 26 & 31, i[a++] = 31 & (o >>> 31 | (15 & l) << 1), i[a++] = l >>> 4 & 31, i[a++] = l >>> 9 & 31, i[a++] = l >>> 14 & 31, i[a++] = l >>> 19 & 31, i[a++] = l >>> 24 & 31, i[a++] = 31 & (l >>> 29 | (3 & c) << 3), i[a++] = c >>> 2 & 31, i[a++] = c >>> 7 & 31, i[a++] = c >>> 12 & 31, i[a++] = c >>> 17 & 31, i[a++] = c >>> 22 & 31, i[a] = c >>> 27 & 31;
            }(e1, t, i, n);
        case 6:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0;
                i[a++] = r >>> 0 & 63, i[a++] = r >>> 6 & 63, i[a++] = r >>> 12 & 63, i[a++] = r >>> 18 & 63, i[a++] = r >>> 24 & 63, i[a++] = 63 & (r >>> 30 | (15 & s) << 2), i[a++] = s >>> 4 & 63, i[a++] = s >>> 10 & 63, i[a++] = s >>> 16 & 63, i[a++] = s >>> 22 & 63, i[a++] = 63 & (s >>> 28 | (3 & o) << 4), i[a++] = o >>> 2 & 63, i[a++] = o >>> 8 & 63, i[a++] = o >>> 14 & 63, i[a++] = o >>> 20 & 63, i[a++] = o >>> 26 & 63, i[a++] = l >>> 0 & 63, i[a++] = l >>> 6 & 63, i[a++] = l >>> 12 & 63, i[a++] = l >>> 18 & 63, i[a++] = l >>> 24 & 63, i[a++] = 63 & (l >>> 30 | (15 & c) << 2), i[a++] = c >>> 4 & 63, i[a++] = c >>> 10 & 63, i[a++] = c >>> 16 & 63, i[a++] = c >>> 22 & 63, i[a++] = 63 & (c >>> 28 | (3 & u) << 4), i[a++] = u >>> 2 & 63, i[a++] = u >>> 8 & 63, i[a++] = u >>> 14 & 63, i[a++] = u >>> 20 & 63, i[a] = u >>> 26 & 63;
            }(e1, t, i, n);
        case 7:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0;
                i[a++] = r >>> 0 & 127, i[a++] = r >>> 7 & 127, i[a++] = r >>> 14 & 127, i[a++] = r >>> 21 & 127, i[a++] = 127 & (r >>> 28 | (7 & s) << 4), i[a++] = s >>> 3 & 127, i[a++] = s >>> 10 & 127, i[a++] = s >>> 17 & 127, i[a++] = s >>> 24 & 127, i[a++] = 127 & (s >>> 31 | (63 & o) << 1), i[a++] = o >>> 6 & 127, i[a++] = o >>> 13 & 127, i[a++] = o >>> 20 & 127, i[a++] = 127 & (o >>> 27 | (3 & l) << 5), i[a++] = l >>> 2 & 127, i[a++] = l >>> 9 & 127, i[a++] = l >>> 16 & 127, i[a++] = l >>> 23 & 127, i[a++] = 127 & (l >>> 30 | (31 & c) << 2), i[a++] = c >>> 5 & 127, i[a++] = c >>> 12 & 127, i[a++] = c >>> 19 & 127, i[a++] = 127 & (c >>> 26 | (1 & u) << 6), i[a++] = u >>> 1 & 127, i[a++] = u >>> 8 & 127, i[a++] = u >>> 15 & 127, i[a++] = u >>> 22 & 127, i[a++] = 127 & (u >>> 29 | (15 & h) << 3), i[a++] = h >>> 4 & 127, i[a++] = h >>> 11 & 127, i[a++] = h >>> 18 & 127, i[a] = h >>> 25 & 127;
            }(e1, t, i, n);
        case 8:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0;
                i[a++] = r >>> 0 & 255, i[a++] = r >>> 8 & 255, i[a++] = r >>> 16 & 255, i[a++] = r >>> 24 & 255, i[a++] = s >>> 0 & 255, i[a++] = s >>> 8 & 255, i[a++] = s >>> 16 & 255, i[a++] = s >>> 24 & 255, i[a++] = o >>> 0 & 255, i[a++] = o >>> 8 & 255, i[a++] = o >>> 16 & 255, i[a++] = o >>> 24 & 255, i[a++] = l >>> 0 & 255, i[a++] = l >>> 8 & 255, i[a++] = l >>> 16 & 255, i[a++] = l >>> 24 & 255, i[a++] = c >>> 0 & 255, i[a++] = c >>> 8 & 255, i[a++] = c >>> 16 & 255, i[a++] = c >>> 24 & 255, i[a++] = u >>> 0 & 255, i[a++] = u >>> 8 & 255, i[a++] = u >>> 16 & 255, i[a++] = u >>> 24 & 255, i[a++] = h >>> 0 & 255, i[a++] = h >>> 8 & 255, i[a++] = h >>> 16 & 255, i[a++] = h >>> 24 & 255, i[a++] = d >>> 0 & 255, i[a++] = d >>> 8 & 255, i[a++] = d >>> 16 & 255, i[a] = d >>> 24 & 255;
            }(e1, t, i, n);
        case 9:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0, p = e1[t + 8] >>> 0;
                i[a++] = r >>> 0 & 511, i[a++] = r >>> 9 & 511, i[a++] = r >>> 18 & 511, i[a++] = 511 & (r >>> 27 | (15 & s) << 5), i[a++] = s >>> 4 & 511, i[a++] = s >>> 13 & 511, i[a++] = s >>> 22 & 511, i[a++] = 511 & (s >>> 31 | (255 & o) << 1), i[a++] = o >>> 8 & 511, i[a++] = o >>> 17 & 511, i[a++] = 511 & (o >>> 26 | (7 & l) << 6), i[a++] = l >>> 3 & 511, i[a++] = l >>> 12 & 511, i[a++] = l >>> 21 & 511, i[a++] = 511 & (l >>> 30 | (127 & c) << 2), i[a++] = c >>> 7 & 511, i[a++] = c >>> 16 & 511, i[a++] = 511 & (c >>> 25 | (3 & u) << 7), i[a++] = u >>> 2 & 511, i[a++] = u >>> 11 & 511, i[a++] = u >>> 20 & 511, i[a++] = 511 & (u >>> 29 | (63 & h) << 3), i[a++] = h >>> 6 & 511, i[a++] = h >>> 15 & 511, i[a++] = 511 & (h >>> 24 | (1 & d) << 8), i[a++] = d >>> 1 & 511, i[a++] = d >>> 10 & 511, i[a++] = d >>> 19 & 511, i[a++] = 511 & (d >>> 28 | (31 & p) << 4), i[a++] = p >>> 5 & 511, i[a++] = p >>> 14 & 511, i[a] = p >>> 23 & 511;
            }(e1, t, i, n);
        case 10:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0, p = e1[t + 8] >>> 0, m = e1[t + 9] >>> 0;
                i[a++] = r >>> 0 & 1023, i[a++] = r >>> 10 & 1023, i[a++] = r >>> 20 & 1023, i[a++] = 1023 & (r >>> 30 | (255 & s) << 2), i[a++] = s >>> 8 & 1023, i[a++] = s >>> 18 & 1023, i[a++] = 1023 & (s >>> 28 | (63 & o) << 4), i[a++] = o >>> 6 & 1023, i[a++] = o >>> 16 & 1023, i[a++] = 1023 & (o >>> 26 | (15 & l) << 6), i[a++] = l >>> 4 & 1023, i[a++] = l >>> 14 & 1023, i[a++] = 1023 & (l >>> 24 | (3 & c) << 8), i[a++] = c >>> 2 & 1023, i[a++] = c >>> 12 & 1023, i[a++] = c >>> 22 & 1023, i[a++] = u >>> 0 & 1023, i[a++] = u >>> 10 & 1023, i[a++] = u >>> 20 & 1023, i[a++] = 1023 & (u >>> 30 | (255 & h) << 2), i[a++] = h >>> 8 & 1023, i[a++] = h >>> 18 & 1023, i[a++] = 1023 & (h >>> 28 | (63 & d) << 4), i[a++] = d >>> 6 & 1023, i[a++] = d >>> 16 & 1023, i[a++] = 1023 & (d >>> 26 | (15 & p) << 6), i[a++] = p >>> 4 & 1023, i[a++] = p >>> 14 & 1023, i[a++] = 1023 & (p >>> 24 | (3 & m) << 8), i[a++] = m >>> 2 & 1023, i[a++] = m >>> 12 & 1023, i[a] = m >>> 22 & 1023;
            }(e1, t, i, n);
        case 11:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0, p = e1[t + 8] >>> 0, m = e1[t + 9] >>> 0, g = e1[t + 10] >>> 0;
                i[a++] = r >>> 0 & 2047, i[a++] = r >>> 11 & 2047, i[a++] = 2047 & (r >>> 22 | (1 & s) << 10), i[a++] = s >>> 1 & 2047, i[a++] = s >>> 12 & 2047, i[a++] = 2047 & (s >>> 23 | (3 & o) << 9), i[a++] = o >>> 2 & 2047, i[a++] = o >>> 13 & 2047, i[a++] = 2047 & (o >>> 24 | (7 & l) << 8), i[a++] = l >>> 3 & 2047, i[a++] = l >>> 14 & 2047, i[a++] = 2047 & (l >>> 25 | (15 & c) << 7), i[a++] = c >>> 4 & 2047, i[a++] = c >>> 15 & 2047, i[a++] = 2047 & (c >>> 26 | (31 & u) << 6), i[a++] = u >>> 5 & 2047, i[a++] = u >>> 16 & 2047, i[a++] = 2047 & (u >>> 27 | (63 & h) << 5), i[a++] = h >>> 6 & 2047, i[a++] = h >>> 17 & 2047, i[a++] = 2047 & (h >>> 28 | (127 & d) << 4), i[a++] = d >>> 7 & 2047, i[a++] = d >>> 18 & 2047, i[a++] = 2047 & (d >>> 29 | (255 & p) << 3), i[a++] = p >>> 8 & 2047, i[a++] = p >>> 19 & 2047, i[a++] = 2047 & (p >>> 30 | (511 & m) << 2), i[a++] = m >>> 9 & 2047, i[a++] = m >>> 20 & 2047, i[a++] = 2047 & (m >>> 31 | (1023 & g) << 1), i[a++] = g >>> 10 & 2047, i[a] = g >>> 21 & 2047;
            }(e1, t, i, n);
        case 12:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0, p = e1[t + 8] >>> 0, m = e1[t + 9] >>> 0, g = e1[t + 10] >>> 0, f = e1[t + 11] >>> 0;
                i[a++] = r >>> 0 & 4095, i[a++] = r >>> 12 & 4095, i[a++] = 4095 & (r >>> 24 | (15 & s) << 8), i[a++] = s >>> 4 & 4095, i[a++] = s >>> 16 & 4095, i[a++] = 4095 & (s >>> 28 | (255 & o) << 4), i[a++] = o >>> 8 & 4095, i[a++] = o >>> 20 & 4095, i[a++] = l >>> 0 & 4095, i[a++] = l >>> 12 & 4095, i[a++] = 4095 & (l >>> 24 | (15 & c) << 8), i[a++] = c >>> 4 & 4095, i[a++] = c >>> 16 & 4095, i[a++] = 4095 & (c >>> 28 | (255 & u) << 4), i[a++] = u >>> 8 & 4095, i[a++] = u >>> 20 & 4095, i[a++] = h >>> 0 & 4095, i[a++] = h >>> 12 & 4095, i[a++] = 4095 & (h >>> 24 | (15 & d) << 8), i[a++] = d >>> 4 & 4095, i[a++] = d >>> 16 & 4095, i[a++] = 4095 & (d >>> 28 | (255 & p) << 4), i[a++] = p >>> 8 & 4095, i[a++] = p >>> 20 & 4095, i[a++] = m >>> 0 & 4095, i[a++] = m >>> 12 & 4095, i[a++] = 4095 & (m >>> 24 | (15 & g) << 8), i[a++] = g >>> 4 & 4095, i[a++] = g >>> 16 & 4095, i[a++] = 4095 & (g >>> 28 | (255 & f) << 4), i[a++] = f >>> 8 & 4095, i[a] = f >>> 20 & 4095;
            }(e1, t, i, n);
        case 16:
            return void function(e1, t, i, n) {
                let a = n, r = e1[t] >>> 0, s = e1[t + 1] >>> 0, o = e1[t + 2] >>> 0, l = e1[t + 3] >>> 0, c = e1[t + 4] >>> 0, u = e1[t + 5] >>> 0, h = e1[t + 6] >>> 0, d = e1[t + 7] >>> 0, p = e1[t + 8] >>> 0, m = e1[t + 9] >>> 0, g = e1[t + 10] >>> 0, f = e1[t + 11] >>> 0, A = e1[t + 12] >>> 0, _ = e1[t + 13] >>> 0, v = e1[t + 14] >>> 0, y = e1[t + 15] >>> 0;
                i[a++] = r >>> 0 & 65535, i[a++] = r >>> 16 & 65535, i[a++] = s >>> 0 & 65535, i[a++] = s >>> 16 & 65535, i[a++] = o >>> 0 & 65535, i[a++] = o >>> 16 & 65535, i[a++] = l >>> 0 & 65535, i[a++] = l >>> 16 & 65535, i[a++] = c >>> 0 & 65535, i[a++] = c >>> 16 & 65535, i[a++] = u >>> 0 & 65535, i[a++] = u >>> 16 & 65535, i[a++] = h >>> 0 & 65535, i[a++] = h >>> 16 & 65535, i[a++] = d >>> 0 & 65535, i[a++] = d >>> 16 & 65535, i[a++] = p >>> 0 & 65535, i[a++] = p >>> 16 & 65535, i[a++] = m >>> 0 & 65535, i[a++] = m >>> 16 & 65535, i[a++] = g >>> 0 & 65535, i[a++] = g >>> 16 & 65535, i[a++] = f >>> 0 & 65535, i[a++] = f >>> 16 & 65535, i[a++] = A >>> 0 & 65535, i[a++] = A >>> 16 & 65535, i[a++] = _ >>> 0 & 65535, i[a++] = _ >>> 16 & 65535, i[a++] = v >>> 0 & 65535, i[a++] = v >>> 16 & 65535, i[a++] = y >>> 0 & 65535, i[a] = y >>> 16 & 65535;
            }(e1, t, i, n);
        case 32:
            for(let a = 0; a < 32; a = a + 1 | 0)i[n + a | 0] = 0 | e1[t + a | 0];
            return;
    }
    let r = $785da19a645c07eb$var$Tk[a] >>> 0, s = t, o = 0, l = e1[s] >>> 0;
    for(let t = 0; t < 32; t++)if (o + a <= 32) {
        let c = l >>> o & r;
        i[n + t] = 0 | c, o += a, 32 === o && (o = 0, s++, 31 !== t && (l = e1[s] >>> 0));
    } else {
        let c = 32 - o, u = l >>> o;
        s++, l = e1[s] >>> 0;
        let h = (u | (l & $785da19a645c07eb$var$Tk[a - c] >>> 0) << c) & r;
        i[n + t] = 0 | h, o = a - c;
    }
}
function $785da19a645c07eb$var$Vk(e1, t, i) {
    let n = new Uint32Array(i), a = 0, r = t.get();
    for(let t = 0; t < n.length; t++){
        let t = e1[r++], i = 127 & t;
        t < 128 ? n[a++] = i : (t = e1[r++], i |= (127 & t) << 7, t < 128 ? n[a++] = i : (t = e1[r++], i |= (127 & t) << 14, t < 128 ? n[a++] = i : (t = e1[r++], i |= (127 & t) << 21, t < 128 || (t = e1[r++], i |= (15 & t) << 28), n[a++] = i)));
    }
    return t.set(r), n;
}
function $785da19a645c07eb$var$qk(e1, t, i) {
    let n = new BigUint64Array(i);
    for(let i = 0; i < n.length; i++)n[i] = $785da19a645c07eb$var$Gk(e1, t);
    return n;
}
function $785da19a645c07eb$var$Gk(e1, t) {
    let i = 0n, n = 0, a = t.get();
    for(; a < e1.length;){
        let t = e1[a++];
        if (i |= BigInt(127 & t) << BigInt(n), !(128 & t)) break;
        if (n += 7, n >= 64) throw Error("Varint too long");
    }
    return t.set(a), i;
}
function $785da19a645c07eb$var$Hk(e1, t) {
    let i, n;
    return n = e1[t.get()], t.increment(), i = 127 & n, n < 128 || (n = e1[t.get()], t.increment(), i |= (127 & n) << 7, n < 128) || (n = e1[t.get()], t.increment(), i |= (127 & n) << 14, n < 128) || (n = e1[t.get()], t.increment(), i |= (127 & n) << 21, n < 128) ? i : (n = e1[t.get()], i |= (15 & n) << 28, function(e1, t, i) {
        let n, a;
        if (a = t[i.get()], i.increment(), n = (112 & a) >> 4, a < 128 || (a = t[i.get()], i.increment(), n |= (127 & a) << 3, a < 128) || (a = t[i.get()], i.increment(), n |= (127 & a) << 10, a < 128) || (a = t[i.get()], i.increment(), n |= (127 & a) << 17, a < 128) || (a = t[i.get()], i.increment(), n |= (127 & a) << 24, a < 128) || (a = t[i.get()], i.increment(), n |= (1 & a) << 31, a < 128)) return 4294967296 * n + (e1 >>> 0);
        throw Error("Expected varint not more than 10 bytes");
    }(i, e1, t));
}
function $785da19a645c07eb$var$Wk(e1, t, i, n) {
    return function(e1, t, i, n, a) {
        let r = n.get();
        if (3 & i) throw Error(`FastPFOR: invalid encodedByteLength=${i} at offset=${r} (encodedBytes.length=${e1.length}; expected a multiple of 4 bytes for an int32 big-endian word stream)`);
        let s = i >>> 2, o = function(e1, t) {
            if (t <= e1.encodedWords.length) return e1.encodedWords;
            let i = new Uint32Array(Math.max(16, 2 * t));
            return e1.encodedWords = i, i;
        }(a, s);
        !function(e1, t, i, n) {
            if (t < 0 || i < 0 || t + i > e1.length) throw RangeError(`decodeBigEndianInt32sInto: out of bounds (offset=${t}, byteLength=${i}, bytes.length=${e1.length})`);
            let a = Math.floor(i / 4), r = i % 4 != 0, s = r ? a + 1 : a;
            if (n.length < s) throw RangeError(`decodeBigEndianInt32sInto: out.length=${n.length} < ${s}`);
            if (a > 0) {
                let i = e1.byteOffset + t;
                if (3 & i) for(let i = 0; i < a; i++){
                    let a = t + 4 * i;
                    n[i] = e1[a] << 24 | e1[a + 1] << 16 | e1[a + 2] << 8 | e1[a + 3];
                }
                else {
                    let t = new Uint32Array(e1.buffer, i, a);
                    for(let e1 = 0; e1 < a; e1++)n[e1] = 0 | $785da19a645c07eb$var$Ik(t[e1]);
                }
            }
            if (r) {
                let r = t + 4 * a, s = i - 4 * a, o = 0;
                for(let t = 0; t < s; t++)o |= e1[r + t] << 24 - 8 * t;
                n[a] = 0 | o;
            }
        }(e1, r, i, o);
        let l = $785da19a645c07eb$var$Nk(o.subarray(0, s), t, a.decoderWorkspace);
        return n.add(i), l;
    }(e1, t, i, n, function(e1 = 16) {
        if (e1 < 0) throw RangeError(`initialEncodedWordCapacity must be >= 0, got ${e1}`);
        let t = Math.max(16, 0 | e1);
        return {
            encodedWords: new Uint32Array(t),
            decoderWorkspace: $785da19a645c07eb$var$Rk()
        };
    }(i >>> 2));
}
function $785da19a645c07eb$var$Zk(e1) {
    return e1 >>> 1 ^ -(1 & e1);
}
function $785da19a645c07eb$var$Kk(e1) {
    return e1 >> 1n ^ -(1n & e1);
}
function $785da19a645c07eb$var$Xk(e1) {
    return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
}
function $785da19a645c07eb$var$Qk(e1, t, i) {
    if (void 0 === i) {
        i = 0;
        for(let n = 0; n < t; n++)i += e1[n];
    }
    let n = new Uint32Array(i), a = 0;
    for(let i = 0; i < t; i++){
        let r = e1[i], s = e1[i + t];
        n.fill(s, a, a + r), a += r;
    }
    return n;
}
function $785da19a645c07eb$var$Yk(e1, t, i) {
    if (void 0 === i) {
        i = 0;
        for(let n = 0; n < t; n++)i += Number(e1[n]);
    }
    let n = new BigUint64Array(i), a = 0;
    for(let i = 0; i < t; i++){
        let r = Number(e1[i]), s = e1[i + t];
        n.fill(s, a, a + r), a += r;
    }
    return n;
}
function $785da19a645c07eb$var$Jk(e1, t, i) {
    let n = new Float64Array(i), a = 0;
    for(let i = 0; i < t; i++){
        let r = e1[i], s = e1[i + t];
        n.fill(s, a, a + r), a += r;
    }
    return n;
}
function $785da19a645c07eb$var$$k(e1) {
    let t = new Int32Array(e1.length);
    t[0] = $785da19a645c07eb$var$Zk(e1[0]);
    let i = e1.length / 4 * 4, n = 1;
    if (i >= 4) for(; n < i - 4; n += 4){
        let i = e1[n], a = e1[n + 1], r = e1[n + 2], s = e1[n + 3];
        t[n] = $785da19a645c07eb$var$Zk(i) + t[n - 1], t[n + 1] = $785da19a645c07eb$var$Zk(a) + t[n], t[n + 2] = $785da19a645c07eb$var$Zk(r) + t[n + 1], t[n + 3] = $785da19a645c07eb$var$Zk(s) + t[n + 2];
    }
    for(; n !== e1.length; ++n)t[n] = $785da19a645c07eb$var$Zk(e1[n]) + t[n - 1];
    return t;
}
function $785da19a645c07eb$var$eS(e1) {
    let t = new BigInt64Array(e1.length);
    t[0] = $785da19a645c07eb$var$Kk(e1[0]);
    let i = e1.length / 4 * 4, n = 1;
    if (i >= 4) for(; n < i - 4; n += 4){
        let i = e1[n], a = e1[n + 1], r = e1[n + 2], s = e1[n + 3];
        t[n] = $785da19a645c07eb$var$Kk(i) + t[n - 1], t[n + 1] = $785da19a645c07eb$var$Kk(a) + t[n], t[n + 2] = $785da19a645c07eb$var$Kk(r) + t[n + 1], t[n + 3] = $785da19a645c07eb$var$Kk(s) + t[n + 2];
    }
    for(; n !== t.length; ++n)t[n] = $785da19a645c07eb$var$Kk(e1[n]) + t[n - 1];
    return t;
}
function $785da19a645c07eb$var$tS(e1) {
    let t = e1.length / 4 * 4, i = 1;
    if (t >= 4) for(let n = e1[0]; i < t - 4; i += 4)n = e1[i] += n, n = e1[i + 1] += n, n = e1[i + 2] += n, n = e1[i + 3] += n;
    for(; i !== e1.length;)e1[i] += e1[i - 1], ++i;
}
function $785da19a645c07eb$var$iS(e1) {
    let t = new Uint32Array(e1.length);
    t[0] = $785da19a645c07eb$var$Zk(e1[0]) >>> 0;
    for(let i = 1; i < e1.length; i++)t[i] = t[i - 1] + $785da19a645c07eb$var$Zk(e1[i]) >>> 0;
    return t;
}
function $785da19a645c07eb$var$nS(e1) {
    let t = new BigUint64Array(e1.length);
    t[0] = BigInt.asUintN(64, $785da19a645c07eb$var$Kk(e1[0]));
    for(let i = 1; i < e1.length; i++)t[i] = BigInt.asUintN(64, t[i - 1] + $785da19a645c07eb$var$Kk(e1[i]));
    return t;
}
var $785da19a645c07eb$var$aS, $785da19a645c07eb$var$rS, $785da19a645c07eb$var$sS, $785da19a645c07eb$var$oS;
!function(e1) {
    e1.PRESENT = "PRESENT", e1.DATA = "DATA", e1.OFFSET = "OFFSET", e1.LENGTH = "LENGTH";
}($785da19a645c07eb$var$aS ||= {}), function(e1) {
    e1.NONE = "NONE", e1.SINGLE = "SINGLE", e1.SHARED = "SHARED", e1.VERTEX = "VERTEX", e1.MORTON = "MORTON", e1.FSST = "FSST";
}($785da19a645c07eb$var$rS ||= {}), function(e1) {
    e1.VERTEX = "VERTEX", e1.INDEX = "INDEX", e1.STRING = "STRING", e1.KEY = "KEY";
}($785da19a645c07eb$var$sS ||= {}), function(e1) {
    e1.VAR_BINARY = "VAR_BINARY", e1.GEOMETRIES = "GEOMETRIES", e1.PARTS = "PARTS", e1.RINGS = "RINGS", e1.TRIANGLES = "TRIANGLES", e1.SYMBOL = "SYMBOL", e1.DICTIONARY = "DICTIONARY";
}($785da19a645c07eb$var$oS ||= {});
const $785da19a645c07eb$var$lS = [
    $785da19a645c07eb$var$aS.PRESENT,
    $785da19a645c07eb$var$aS.DATA,
    $785da19a645c07eb$var$aS.OFFSET,
    $785da19a645c07eb$var$aS.LENGTH
], $785da19a645c07eb$var$cS = [
    $785da19a645c07eb$var$kk.NONE,
    $785da19a645c07eb$var$kk.DELTA,
    $785da19a645c07eb$var$kk.COMPONENTWISE_DELTA,
    $785da19a645c07eb$var$kk.RLE,
    $785da19a645c07eb$var$kk.MORTON
], $785da19a645c07eb$var$uS = [
    $785da19a645c07eb$var$Sk.NONE,
    $785da19a645c07eb$var$Sk.FAST_PFOR,
    $785da19a645c07eb$var$Sk.VARINT
], $785da19a645c07eb$var$hS = [
    $785da19a645c07eb$var$rS.NONE,
    $785da19a645c07eb$var$rS.SINGLE,
    $785da19a645c07eb$var$rS.SHARED,
    $785da19a645c07eb$var$rS.VERTEX,
    $785da19a645c07eb$var$rS.MORTON,
    $785da19a645c07eb$var$rS.FSST
], $785da19a645c07eb$var$dS = [
    $785da19a645c07eb$var$sS.VERTEX,
    $785da19a645c07eb$var$sS.INDEX,
    $785da19a645c07eb$var$sS.STRING,
    $785da19a645c07eb$var$sS.KEY
], $785da19a645c07eb$var$pS = [
    $785da19a645c07eb$var$oS.VAR_BINARY,
    $785da19a645c07eb$var$oS.GEOMETRIES,
    $785da19a645c07eb$var$oS.PARTS,
    $785da19a645c07eb$var$oS.RINGS,
    $785da19a645c07eb$var$oS.TRIANGLES,
    $785da19a645c07eb$var$oS.SYMBOL,
    $785da19a645c07eb$var$oS.DICTIONARY
];
function $785da19a645c07eb$var$mS(e1, t) {
    let i = function(e1, t) {
        let i = e1[t.get()], n = $785da19a645c07eb$var$lS[i >> 4], a = {};
        switch(n){
            case $785da19a645c07eb$var$aS.DATA:
                a = {
                    dictionaryType: $785da19a645c07eb$var$hS[15 & i]
                };
                break;
            case $785da19a645c07eb$var$aS.OFFSET:
                a = {
                    offsetType: $785da19a645c07eb$var$dS[15 & i]
                };
                break;
            case $785da19a645c07eb$var$aS.LENGTH:
                a = {
                    lengthType: $785da19a645c07eb$var$pS[15 & i]
                };
        }
        t.increment();
        let r = e1[t.get()], s = $785da19a645c07eb$var$cS[r >> 5], o = $785da19a645c07eb$var$cS[r >> 2 & 7], l = $785da19a645c07eb$var$uS[3 & r];
        t.increment();
        let c = $785da19a645c07eb$var$Vk(e1, t, 2), u = c[0], h = c[1];
        return {
            physicalStreamType: n,
            logicalStreamType: a,
            logicalLevelTechnique1: s,
            logicalLevelTechnique2: o,
            physicalLevelTechnique: l,
            numValues: u,
            byteLength: h,
            decompressedCount: u
        };
    }(e1, t);
    return i.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.MORTON ? function(e1, t, i) {
        let n = $785da19a645c07eb$var$Vk(t, i, 2);
        return {
            physicalStreamType: e1.physicalStreamType,
            logicalStreamType: e1.logicalStreamType,
            logicalLevelTechnique1: e1.logicalLevelTechnique1,
            logicalLevelTechnique2: e1.logicalLevelTechnique2,
            physicalLevelTechnique: e1.physicalLevelTechnique,
            numValues: e1.numValues,
            byteLength: e1.byteLength,
            decompressedCount: e1.decompressedCount,
            numBits: n[0],
            coordinateShift: n[1]
        };
    }(i, e1, t) : $785da19a645c07eb$var$kk.RLE !== i.logicalLevelTechnique1 && $785da19a645c07eb$var$kk.RLE !== i.logicalLevelTechnique2 || $785da19a645c07eb$var$Sk.NONE === i.physicalLevelTechnique ? i : function(e1, t, i) {
        let n = $785da19a645c07eb$var$Vk(t, i, 2);
        return {
            physicalStreamType: e1.physicalStreamType,
            logicalStreamType: e1.logicalStreamType,
            logicalLevelTechnique1: e1.logicalLevelTechnique1,
            logicalLevelTechnique2: e1.logicalLevelTechnique2,
            physicalLevelTechnique: e1.physicalLevelTechnique,
            numValues: e1.numValues,
            byteLength: e1.byteLength,
            decompressedCount: n[1],
            runs: n[0],
            numRleValues: n[1]
        };
    }(i, e1, t);
}
var $785da19a645c07eb$var$gS;
!function(e1) {
    e1[e1.FLAT = 0] = "FLAT", e1[e1.CONST = 1] = "CONST", e1[e1.SEQUENCE = 2] = "SEQUENCE", e1[e1.DICTIONARY = 3] = "DICTIONARY", e1[e1.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
}($785da19a645c07eb$var$gS ||= {});
var $785da19a645c07eb$var$fS = class {
    constructor(e1, t){
        this.values = e1, this._size = t;
    }
    get(e1) {
        let t = Math.floor(e1 / 8), i = e1 % 8;
        return 1 == (this.values[t] >> i & 1);
    }
    set(e1, t) {
        let i = Math.floor(e1 / 8), n = e1 % 8;
        this.values[i] = this.values[i] | +!!t << n;
    }
    getInt(e1) {
        let t = Math.floor(e1 / 8), i = e1 % 8;
        return this.values[t] >> i & 1;
    }
    size() {
        return this._size;
    }
    getBuffer() {
        return this.values;
    }
};
function $785da19a645c07eb$var$AS(e1, t, i) {
    if (!t) return e1;
    let n = t.size(), a = new e1.constructor(n), r = 0;
    for(let s = 0; s < n; s++)a[s] = t.get(s) ? e1[r++] : i;
    return a;
}
function $785da19a645c07eb$var$_S(e1, t, i, n, a) {
    let r = function(e1, t, i, n) {
        let a = new Uint8Array(t), r = 0, s = n.get() + i;
        for(; r < t && !(n.get() >= s);){
            let i = e1[n.increment()];
            if (i <= 127) {
                let s = i + 3, o = e1[n.increment()], l = Math.min(r + s, t);
                a.fill(o, r, l), r = l;
            } else {
                let s = 256 - i;
                for(let i = 0; i < s && r < t; i++)a[r++] = e1[n.increment()];
            }
        }
        return n.set(s), a;
    }(e1, Math.ceil(t / 8), i, n);
    return a ? function(e1, t, i) {
        if (!i) return e1;
        let n = i.size(), a = new $785da19a645c07eb$var$fS(e1, t), r = new $785da19a645c07eb$var$fS(new Uint8Array(Math.ceil(n / 8)), n), s = 0;
        for(let e1 = 0; e1 < n; e1++){
            let t = !!i.get(e1) && a.get(s++);
            r.set(e1, t);
        }
        return r.getBuffer();
    }(r, t, a) : r;
}
function $785da19a645c07eb$var$vS(e1, t, i, n) {
    let a = t.get(), r = a + i * Float32Array.BYTES_PER_ELEMENT, s = new Uint8Array(e1.subarray(a, r)).buffer, o = new Float32Array(s);
    return t.set(r), n ? $785da19a645c07eb$var$AS(o, n, 0) : o;
}
function $785da19a645c07eb$var$yS(e1, t, i, n) {
    let a = t.get(), r = a + i * Float64Array.BYTES_PER_ELEMENT, s = new Uint8Array(e1.subarray(a, r)).buffer, o = new Float64Array(s);
    return t.set(r), n ? $785da19a645c07eb$var$AS(o, n, 0) : o;
}
const $785da19a645c07eb$var$xS = new TextDecoder;
function $785da19a645c07eb$var$bS(e1, t, i) {
    return i - t >= 12 ? $785da19a645c07eb$var$xS.decode(e1.subarray(t, i)) : function(e1, t, i) {
        let n = "", a = t;
        for(; a < i;){
            let t, r, s, o = e1[a], l = null, c = o > 239 ? 4 : o > 223 ? 3 : o > 191 ? 2 : 1;
            if (a + c > i) break;
            1 === c ? o < 128 && (l = o) : 2 === c ? (t = e1[a + 1], 128 == (192 & t) && (l = (31 & o) << 6 | 63 & t, l <= 127 && (l = null))) : 3 === c ? (t = e1[a + 1], r = e1[a + 2], 128 == (192 & t) && 128 == (192 & r) && (l = (15 & o) << 12 | (63 & t) << 6 | 63 & r, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === c && (t = e1[a + 1], r = e1[a + 2], s = e1[a + 3], 128 == (192 & t) && 128 == (192 & r) && 128 == (192 & s) && (l = (15 & o) << 18 | (63 & t) << 12 | (63 & r) << 6 | 63 & s, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, c = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), a += c;
        }
        return n;
    }(e1, t, i);
}
function $785da19a645c07eb$var$wS(e1, t, i, n, a) {
    return function(e1, t, i, n) {
        let a;
        switch(t.logicalLevelTechnique1){
            case $785da19a645c07eb$var$kk.DELTA:
                if (t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
                    let i = t;
                    if (!n) return function(e1, t, i) {
                        let n = new Int32Array(i), a = 0, r = 0;
                        for(let i = 0; i < t; i++){
                            let s = e1[i], o = $785da19a645c07eb$var$Zk(e1[i + t]);
                            for(let e1 = 0; e1 < s; e1++)r += o, n[a++] = r;
                        }
                        return n;
                    }(e1, i.runs, i.numRleValues);
                    a = $785da19a645c07eb$var$$k(e1 = $785da19a645c07eb$var$Qk(e1, i.runs, i.numRleValues));
                } else a = $785da19a645c07eb$var$$k(e1);
                break;
            case $785da19a645c07eb$var$kk.RLE:
                a = function(e1, t, i) {
                    if (void 0 === i) {
                        i = 0;
                        for(let n = 0; n < t; n++)i += e1[n];
                    }
                    let n = new Int32Array(i), a = 0;
                    for(let i = 0; i < t; i++){
                        let r = e1[i], s = e1[i + t];
                        s = $785da19a645c07eb$var$Zk(s), n.fill(s, a, a + r), a += r;
                    }
                    return n;
                }(e1, t.runs, t.numRleValues);
                break;
            case $785da19a645c07eb$var$kk.MORTON:
                $785da19a645c07eb$var$tS(e1), a = new Int32Array(e1);
                break;
            case $785da19a645c07eb$var$kk.COMPONENTWISE_DELTA:
                a = function(e1) {
                    if (e1.length < 2) return new Int32Array(e1);
                    let t = new Int32Array(e1.length);
                    t[0] = $785da19a645c07eb$var$Zk(e1[0]), t[1] = $785da19a645c07eb$var$Zk(e1[1]);
                    let i = e1.length / 4 * 4, n = 2;
                    if (i >= 4) for(; n < i - 4; n += 4){
                        let i = e1[n], a = e1[n + 1], r = e1[n + 2], s = e1[n + 3];
                        t[n] = $785da19a645c07eb$var$Zk(i) + t[n - 2], t[n + 1] = $785da19a645c07eb$var$Zk(a) + t[n - 1], t[n + 2] = $785da19a645c07eb$var$Zk(r) + t[n], t[n + 3] = $785da19a645c07eb$var$Zk(s) + t[n + 1];
                    }
                    for(; n !== e1.length; n += 2)t[n] = $785da19a645c07eb$var$Zk(e1[n]) + t[n - 2], t[n + 1] = $785da19a645c07eb$var$Zk(e1[n + 1]) + t[n - 1];
                    return t;
                }(e1);
                break;
            case $785da19a645c07eb$var$kk.NONE:
                a = function(e1) {
                    let t = new Int32Array(e1.length);
                    for(let i = 0; i < e1.length; i++)t[i] = $785da19a645c07eb$var$Zk(e1[i]);
                    return t;
                }(e1);
                break;
            default:
                throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
        }
        return n ? $785da19a645c07eb$var$AS(a, n, 0) : a;
    }($785da19a645c07eb$var$SS(e1, t, i), i, 0, a);
}
function $785da19a645c07eb$var$ES(e1, t, i, n, a) {
    return function(e1, t, i, n) {
        let a;
        switch(t.logicalLevelTechnique1){
            case $785da19a645c07eb$var$kk.DELTA:
                if (t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
                    let i = t;
                    a = $785da19a645c07eb$var$iS($785da19a645c07eb$var$Qk(e1, i.runs, i.numRleValues));
                } else a = $785da19a645c07eb$var$iS(e1);
                break;
            case $785da19a645c07eb$var$kk.RLE:
                a = $785da19a645c07eb$var$Qk(e1, t.runs, t.numRleValues);
                break;
            case $785da19a645c07eb$var$kk.MORTON:
                $785da19a645c07eb$var$tS(e1), a = e1;
                break;
            case $785da19a645c07eb$var$kk.COMPONENTWISE_DELTA:
                a = function(e1) {
                    if (e1.length < 2) return new Uint32Array(e1);
                    let t = new Uint32Array(e1.length);
                    t[0] = $785da19a645c07eb$var$Zk(e1[0]) >>> 0, t[1] = $785da19a645c07eb$var$Zk(e1[1]) >>> 0;
                    for(let i = 2; i < e1.length; i += 2)t[i] = t[i - 2] + $785da19a645c07eb$var$Zk(e1[i]) >>> 0, t[i + 1] = t[i - 1] + $785da19a645c07eb$var$Zk(e1[i + 1]) >>> 0;
                    return t;
                }(e1);
                break;
            case $785da19a645c07eb$var$kk.NONE:
                a = e1;
                break;
            default:
                throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
        }
        return n ? $785da19a645c07eb$var$AS(a, n, 0) : a;
    }($785da19a645c07eb$var$SS(e1, t, i), i, 0, a);
}
function $785da19a645c07eb$var$kS(e1, t, i) {
    return function(e1, t) {
        if (t.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.DELTA && t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.NONE) return function(e1) {
            let t = new Int32Array(e1.length + 1);
            t[0] = 0, t[1] = $785da19a645c07eb$var$Zk(e1[0]);
            let i = t[1];
            for(let n = 2; n !== t.length; ++n)i += $785da19a645c07eb$var$Zk(e1[n - 1]), t[n] = t[n - 1] + i;
            return new Uint32Array(t);
        }(e1);
        if (t.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.RLE && t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.NONE) {
            let i = t;
            return function(e1, t, i) {
                let n = new Uint32Array(i + 1);
                n[0] = 0;
                let a = 1, r = n[0];
                for(let i = 0; i < t; i++){
                    let s = e1[i], o = e1[i + t];
                    for(let e1 = a; e1 < a + s; e1++)n[e1] = o + r, r = n[e1];
                    a += s;
                }
                return n;
            }(e1, i.runs, i.numRleValues);
        }
        if (t.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.NONE && t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.NONE) {
            !function(e1) {
                let t = 0;
                for(let i = 0; i < e1.length; i++)e1[i] += t, t = e1[i];
            }(e1);
            let i = new Uint32Array(t.numValues + 1);
            return i[0] = 0, i.set(e1, 1), i;
        }
        if (t.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.DELTA && t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
            let i = t, n = function(e1, t, i) {
                let n = new Int32Array(i + 1);
                n[0] = 0;
                let a = 1, r = n[0];
                for(let i = 0; i < t; i++){
                    let s = e1[i], o = e1[i + t];
                    o = $785da19a645c07eb$var$Zk(o);
                    for(let e1 = a; e1 < a + s; e1++)n[e1] = o + r, r = n[e1];
                    a += s;
                }
                return n;
            }(e1, i.runs, i.numRleValues);
            return $785da19a645c07eb$var$tS(n), new Uint32Array(n);
        }
        throw Error("Only delta encoding is supported for transforming length to offset streams yet.");
    }($785da19a645c07eb$var$SS(e1, t, i), i);
}
function $785da19a645c07eb$var$SS(e1, t, i) {
    let n = i.physicalLevelTechnique;
    switch(n){
        case $785da19a645c07eb$var$Sk.FAST_PFOR:
            return $785da19a645c07eb$var$Wk(e1, i.numValues, i.byteLength, t);
        case $785da19a645c07eb$var$Sk.VARINT:
            return $785da19a645c07eb$var$Vk(e1, t, i.numValues);
        case $785da19a645c07eb$var$Sk.NONE:
            return function(e1, t, i) {
                let n = t.get(), a = i * Uint32Array.BYTES_PER_ELEMENT, r = new DataView(e1.buffer, e1.byteOffset, e1.byteLength), s = new Uint32Array(i);
                for(let e1 = 0; e1 < i; e1++)s[e1] = r.getUint32(n + e1 * Uint32Array.BYTES_PER_ELEMENT, !0);
                return t.add(a), s;
            }(e1, t, i.numValues);
        default:
            throw Error(`Specified physicalLevelTechnique ${n} is not supported (yet).`);
    }
}
function $785da19a645c07eb$var$MS(e1, t, i) {
    let n = i.physicalLevelTechnique;
    switch(n){
        case $785da19a645c07eb$var$Sk.VARINT:
            return $785da19a645c07eb$var$qk(e1, t, i.numValues);
        case $785da19a645c07eb$var$Sk.NONE:
            return function(e1, t, i) {
                let n = t.get(), a = i * BigUint64Array.BYTES_PER_ELEMENT, r = new DataView(e1.buffer, e1.byteOffset, e1.byteLength), s = new BigUint64Array(i);
                for(let e1 = 0; e1 < i; e1++)s[e1] = r.getBigUint64(n + e1 * BigUint64Array.BYTES_PER_ELEMENT, !0);
                return t.add(a), s;
            }(e1, t, i.numValues);
        default:
            throw Error(`Specified physicalLevelTechnique ${n} is not supported (yet).`);
    }
}
function $785da19a645c07eb$var$CS(e1, t, i) {
    let n = $785da19a645c07eb$var$SS(e1, t, i);
    return 1 === n.length ? $785da19a645c07eb$var$Zk(n[0]) : function(e1) {
        return $785da19a645c07eb$var$Zk(e1[1]);
    }(n);
}
function $785da19a645c07eb$var$TS(e1, t, i) {
    let n = $785da19a645c07eb$var$SS(e1, t, i);
    return 1 === n.length ? i.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.DELTA ? $785da19a645c07eb$var$Zk(n[0]) : n[0] : function(e1) {
        return e1[1];
    }(n);
}
function $785da19a645c07eb$var$DS(e1, t, i) {
    return function(e1) {
        if (2 === e1.length) {
            let t = $785da19a645c07eb$var$Zk(e1[1]);
            return [
                t,
                t
            ];
        }
        return [
            $785da19a645c07eb$var$Zk(e1[2]),
            $785da19a645c07eb$var$Zk(e1[3])
        ];
    }($785da19a645c07eb$var$SS(e1, t, i));
}
function $785da19a645c07eb$var$PS(e1, t, i) {
    return function(e1) {
        if (2 === e1.length) {
            let t = $785da19a645c07eb$var$Kk(e1[1]);
            return [
                t,
                t
            ];
        }
        return [
            $785da19a645c07eb$var$Kk(e1[2]),
            $785da19a645c07eb$var$Kk(e1[3])
        ];
    }($785da19a645c07eb$var$qk(e1, t, i.numValues));
}
function $785da19a645c07eb$var$IS(e1, t, i, n) {
    return function(e1, t, i) {
        let n;
        switch(t.logicalLevelTechnique1){
            case $785da19a645c07eb$var$kk.DELTA:
                if (t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
                    let a = t;
                    if (!i) return function(e1, t, i) {
                        let n = new BigInt64Array(i), a = 0, r = 0n;
                        for(let i = 0; i < t; i++){
                            let s = Number(e1[i]), o = $785da19a645c07eb$var$Kk(e1[i + t]);
                            for(let e1 = 0; e1 < s; e1++)r += o, n[a++] = r;
                        }
                        return n;
                    }(e1, a.runs, a.numRleValues);
                    n = $785da19a645c07eb$var$eS(e1 = $785da19a645c07eb$var$Yk(e1, a.runs, a.numRleValues));
                } else n = $785da19a645c07eb$var$eS(e1);
                break;
            case $785da19a645c07eb$var$kk.RLE:
                n = function(e1, t, i) {
                    if (void 0 === i) {
                        i = 0;
                        for(let n = 0; n < t; n++)i += Number(e1[n]);
                    }
                    let n = new BigInt64Array(i), a = 0;
                    for(let i = 0; i < t; i++){
                        let r = Number(e1[i]), s = e1[i + t];
                        s = $785da19a645c07eb$var$Kk(s), n.fill(s, a, a + r), a += r;
                    }
                    return n;
                }(e1, t.runs, t.numRleValues);
                break;
            case $785da19a645c07eb$var$kk.NONE:
                n = function(e1) {
                    let t = new BigInt64Array(e1.length);
                    for(let i = 0; i < e1.length; i++)t[i] = $785da19a645c07eb$var$Kk(e1[i]);
                    return t;
                }(e1);
                break;
            default:
                throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
        }
        return i ? $785da19a645c07eb$var$AS(n, i, 0n) : n;
    }($785da19a645c07eb$var$MS(e1, t, i), i, n);
}
function $785da19a645c07eb$var$FS(e1, t, i, n) {
    return $785da19a645c07eb$var$BS($785da19a645c07eb$var$MS(e1, t, i), i, n);
}
function $785da19a645c07eb$var$zS(e1, t, i, n) {
    let a = function(e1, t, i, n) {
        if (i.physicalLevelTechnique === $785da19a645c07eb$var$Sk.VARINT) return function(e1, t, i) {
            switch(t.logicalLevelTechnique1){
                case $785da19a645c07eb$var$kk.DELTA:
                    if (t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
                        let i = t;
                        e1 = $785da19a645c07eb$var$Jk(e1, i.runs, i.numRleValues);
                    }
                    return function(e1) {
                        e1[0] = $785da19a645c07eb$var$Xk(e1[0]);
                        let t = e1.length / 4 * 4, i = 1;
                        if (t >= 4) for(; i < t - 4; i += 4){
                            let t = e1[i], n = e1[i + 1], a = e1[i + 2], r = e1[i + 3];
                            e1[i] = $785da19a645c07eb$var$Xk(t) + e1[i - 1], e1[i + 1] = $785da19a645c07eb$var$Xk(n) + e1[i], e1[i + 2] = $785da19a645c07eb$var$Xk(a) + e1[i + 1], e1[i + 3] = $785da19a645c07eb$var$Xk(r) + e1[i + 2];
                        }
                        for(; i !== e1.length; ++i)e1[i] = $785da19a645c07eb$var$Xk(e1[i]) + e1[i - 1];
                    }(e1), e1;
                case $785da19a645c07eb$var$kk.RLE:
                    return function(e1, t, i) {
                        return i ? function(e1, t, i) {
                            let n = new Float64Array(i), a = 0;
                            for(let i = 0; i < t; i++){
                                let r = e1[i], s = e1[i + t];
                                s = $785da19a645c07eb$var$Xk(s), n.fill(s, a, a + r), a += r;
                            }
                            return n;
                        }(e1, t.runs, t.numRleValues) : $785da19a645c07eb$var$Jk(e1, t.runs, t.numRleValues);
                    }(e1, t, i);
                case $785da19a645c07eb$var$kk.NONE:
                    return e1;
                default:
                    throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
            }
        }(function(e1, t, i) {
            let n = new Float64Array(i);
            for(let a = 0; a < i; a++)n[a] = $785da19a645c07eb$var$Hk(e1, t);
            return n;
        }(e1, t, i.numValues), i, n);
        let a = $785da19a645c07eb$var$MS(e1, t, i), r = $785da19a645c07eb$var$BS(a, i);
        return Float64Array.from(r, Number);
    }(e1, t, i, !1);
    return n ? $785da19a645c07eb$var$AS(a, n, 0) : a;
}
function $785da19a645c07eb$var$RS(e1, t, i) {
    let n = $785da19a645c07eb$var$MS(e1, t, i);
    return 1 === n.length ? $785da19a645c07eb$var$Kk(n[0]) : function(e1) {
        return $785da19a645c07eb$var$Kk(e1[1]);
    }(n);
}
function $785da19a645c07eb$var$LS(e1, t, i) {
    let n = $785da19a645c07eb$var$MS(e1, t, i);
    return 1 === n.length ? i.logicalLevelTechnique1 === $785da19a645c07eb$var$kk.DELTA ? $785da19a645c07eb$var$Kk(n[0]) : n[0] : function(e1) {
        return e1[1];
    }(n);
}
function $785da19a645c07eb$var$BS(e1, t, i) {
    let n;
    switch(t.logicalLevelTechnique1){
        case $785da19a645c07eb$var$kk.DELTA:
            if (t.logicalLevelTechnique2 === $785da19a645c07eb$var$kk.RLE) {
                let i = t;
                n = $785da19a645c07eb$var$nS($785da19a645c07eb$var$Yk(e1, i.runs, i.numRleValues));
            } else n = $785da19a645c07eb$var$nS(e1);
            break;
        case $785da19a645c07eb$var$kk.RLE:
            n = $785da19a645c07eb$var$Yk(e1, t.runs, t.numRleValues);
            break;
        case $785da19a645c07eb$var$kk.NONE:
            n = e1;
            break;
        default:
            throw Error(`The specified Logical level technique is not supported: ${t.logicalLevelTechnique1}`);
    }
    return i ? $785da19a645c07eb$var$AS(n, i, 0n) : n;
}
function $785da19a645c07eb$var$OS(e1, t, i, n, a = "int32") {
    let r = e1.logicalLevelTechnique1;
    if (r === $785da19a645c07eb$var$kk.RLE) return 1 === e1.runs ? $785da19a645c07eb$var$gS.CONST : $785da19a645c07eb$var$gS.FLAT;
    if (r !== $785da19a645c07eb$var$kk.DELTA || e1.logicalLevelTechnique2 !== $785da19a645c07eb$var$kk.RLE) return 1 === e1.numValues ? $785da19a645c07eb$var$gS.CONST : $785da19a645c07eb$var$gS.FLAT;
    let s = t instanceof $785da19a645c07eb$var$fS ? t.size() : t, o = e1;
    if (o.numRleValues !== s) return $785da19a645c07eb$var$gS.FLAT;
    if (1 === o.runs) return $785da19a645c07eb$var$gS.SEQUENCE;
    if (2 !== o.runs) return 1 === e1.numValues ? $785da19a645c07eb$var$gS.CONST : $785da19a645c07eb$var$gS.FLAT;
    let l = n.get();
    if (e1.physicalLevelTechnique === $785da19a645c07eb$var$Sk.VARINT) return function(e1, t, i) {
        let n = new $785da19a645c07eb$var$Mk(t.get());
        if ("int64" === i) {
            let t = $785da19a645c07eb$var$qk(e1, n, 4);
            return 2n === t[2] && 2n === t[3];
        }
        let a = $785da19a645c07eb$var$Vk(e1, n, 4);
        return 2 === a[2] && 2 === a[3];
    }(i, n, a) ? $785da19a645c07eb$var$gS.SEQUENCE : 1 === e1.numValues ? $785da19a645c07eb$var$gS.CONST : $785da19a645c07eb$var$gS.FLAT;
    let c = n.get(), u = new Int32Array(i.buffer, i.byteOffset + c, 4);
    return n.set(l), 2 === u[2] && 2 === u[3] ? $785da19a645c07eb$var$gS.SEQUENCE : 1 === e1.numValues ? $785da19a645c07eb$var$gS.CONST : $785da19a645c07eb$var$gS.FLAT;
}
var $785da19a645c07eb$var$US, $785da19a645c07eb$var$NS, $785da19a645c07eb$var$jS, $785da19a645c07eb$var$VS = class extends $785da19a645c07eb$var$nk {
    getValueFromBuffer(e1) {
        return this.dataBuffer[e1];
    }
}, $785da19a645c07eb$var$qS = class extends $785da19a645c07eb$var$sk {
    constructor(e1, t, i, n, a){
        super(e1, a ? BigInt64Array.of(t) : BigUint64Array.of(t), i, n);
    }
    getValueFromBuffer(e1) {
        return this.dataBuffer[0] + BigInt(e1) * this.delta;
    }
};
function $785da19a645c07eb$var$GS(e1, t, i) {
    return {
        x: $785da19a645c07eb$var$HS(e1, t) - i,
        y: $785da19a645c07eb$var$HS(e1 >> 1, t) - i
    };
}
function $785da19a645c07eb$var$HS(e1, t) {
    let i = 0;
    for(let n = 0; n < t; n++)i |= (e1 & 1 << 2 * n) >> n;
    return i;
}
function $785da19a645c07eb$var$WS(e1, t, i, n, a, r, s) {
    return e1 === $785da19a645c07eb$var$jS.MORTON ? function(e1, t, i, n, a, r) {
        let s = Array(a ? n + 1 : n);
        for(let a = 0; a < n; a++){
            let n = $785da19a645c07eb$var$GS(e1[t[i + a]], r.numBits, r.coordinateShift);
            s[a] = new $785da19a645c07eb$var$Kc(n.x, n.y);
        }
        return a && (s[s.length - 1] = s[0]), s;
    }(t, i, n, a, r, s) : function(e1, t, i, n, a) {
        let r = Array(a ? n + 1 : n);
        for(let a = 0; a < 2 * n; a += 2){
            let n = 2 * t[i + a / 2], s = e1[n], o = e1[n + 1];
            r[a / 2] = new $785da19a645c07eb$var$Kc(s, o);
        }
        return a && (r[r.length - 1] = r[0]), r;
    }(t, i, n, a, r);
}
function $785da19a645c07eb$var$ZS(e1, t, i, n) {
    let a = Array(n ? i + 1 : i);
    for(let n = 0; n < 2 * i; n += 2){
        let i = e1[t + n], r = e1[t + n + 1];
        a[n / 2] = new $785da19a645c07eb$var$Kc(i, r);
    }
    return n && (a[a.length - 1] = a[0]), a;
}
!function(e1) {
    e1[e1.POINT = 0] = "POINT", e1[e1.LINESTRING = 1] = "LINESTRING", e1[e1.POLYGON = 2] = "POLYGON", e1[e1.MULTIPOINT = 3] = "MULTIPOINT", e1[e1.MULTILINESTRING = 4] = "MULTILINESTRING", e1[e1.MULTIPOLYGON = 5] = "MULTIPOLYGON";
}($785da19a645c07eb$var$US ||= {}), function(e1) {
    e1[e1.POINT = 0] = "POINT", e1[e1.LINESTRING = 1] = "LINESTRING", e1[e1.POLYGON = 2] = "POLYGON";
}($785da19a645c07eb$var$NS ||= {}), function(e1) {
    e1[e1.MORTON = 0] = "MORTON", e1[e1.VEC_2 = 1] = "VEC_2", e1[e1.VEC_3 = 2] = "VEC_3";
}($785da19a645c07eb$var$jS ||= {});
var $785da19a645c07eb$var$KS = class {
    constructor(e1, t, i, n, a){
        this._vertexBufferType = e1, this._topologyVector = t, this._vertexOffsets = i, this._vertexBuffer = n, this._mortonSettings = a;
    }
    get vertexBufferType() {
        return this._vertexBufferType;
    }
    get topologyVector() {
        return this._topologyVector;
    }
    get vertexOffsets() {
        return this._vertexOffsets;
    }
    get vertexBuffer() {
        return this._vertexBuffer;
    }
    getSimpleEncodedVertex(e1) {
        let t = this.vertexOffsets ? 2 * this.vertexOffsets[e1] : 2 * e1;
        return [
            this.vertexBuffer[t],
            this.vertexBuffer[t + 1]
        ];
    }
    getVertex(e1) {
        if (this.vertexOffsets && this.mortonSettings) {
            let t = this.vertexOffsets[e1], i = $785da19a645c07eb$var$GS(this.vertexBuffer[t], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
            return [
                i.x,
                i.y
            ];
        }
        let t = this.vertexOffsets ? 2 * this.vertexOffsets[e1] : 2 * e1;
        return [
            this.vertexBuffer[t],
            this.vertexBuffer[t + 1]
        ];
    }
    getGeometries() {
        return function(e1) {
            let t = Array(e1.numGeometries), i = 1, n = 1, a = 1, r = 0, s = 0, o = 0, l = e1.mortonSettings, c = e1.topologyVector, u = c.geometryOffsets, h = c.partOffsets, d = c.ringOffsets, p = e1.vertexOffsets, m = !p || 0 === p.length, g = e1.containsPolygonGeometry(), f = e1.vertexBuffer;
            for(let c = 0; c < e1.numGeometries; c++){
                let A = e1.geometryType(c);
                switch(A){
                    case $785da19a645c07eb$var$US.POINT:
                        {
                            let c, g;
                            if (m) c = f[s++], g = f[s++];
                            else if (e1.vertexBufferType === $785da19a645c07eb$var$jS.MORTON) {
                                let e1 = $785da19a645c07eb$var$GS(f[p[o++]], l.numBits, l.coordinateShift);
                                c = e1.x, g = e1.y;
                            } else {
                                let e1 = 2 * p[o++];
                                c = f[e1], g = f[e1 + 1];
                            }
                            t[r++] = [
                                [
                                    new $785da19a645c07eb$var$Kc(c, g)
                                ]
                            ], u && a++, h && i++, d && n++;
                        }
                        break;
                    case $785da19a645c07eb$var$US.MULTIPOINT:
                        {
                            let c, h = u[a] - u[a - 1];
                            if (a++, m) {
                                c = Array(h);
                                for(let e1 = 0; e1 < h; e1++){
                                    let t = f[s++], i = f[s++];
                                    c[e1] = new $785da19a645c07eb$var$Kc(t, i);
                                }
                            } else c = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, h, !1, l), o += h;
                            t[r++] = c.map((e1)=>[
                                    e1
                                ]), i += h, n += h;
                        }
                        break;
                    case $785da19a645c07eb$var$US.LINESTRING:
                        {
                            let c, A;
                            g ? (c = d[n] - d[n - 1], n++) : c = h[i] - h[i - 1], i++, m ? (A = $785da19a645c07eb$var$ZS(f, s, c, !1), s += 2 * c) : (A = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, c, !1, l), o += c), t[r++] = [
                                A
                            ], u && a++;
                        }
                        break;
                    case $785da19a645c07eb$var$US.POLYGON:
                        {
                            let c = h[i] - h[i - 1];
                            i++;
                            let g, A = Array(c - 1), _ = d[n] - d[n - 1];
                            if (n++, m) {
                                g = $785da19a645c07eb$var$ZS(f, s, _, !0), s += 2 * _;
                                for(let e1 = 0; e1 < A.length; e1++)_ = d[n] - d[n - 1], n++, A[e1] = $785da19a645c07eb$var$ZS(f, s, _, !0), s += 2 * _;
                            } else {
                                g = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, _, !0, l), o += _;
                                for(let t = 0; t < A.length; t++)_ = d[n] - d[n - 1], n++, A[t] = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, _, !0, l), o += _;
                            }
                            t[r++] = [
                                g
                            ].concat(A), u && a++;
                        }
                        break;
                    case $785da19a645c07eb$var$US.MULTILINESTRING:
                        {
                            let c = u[a] - u[a - 1];
                            a++;
                            let A = Array(c);
                            for(let t = 0; t < c; t++){
                                let a;
                                if (g ? (a = d[n] - d[n - 1], n++) : a = h[i] - h[i - 1], i++, m) A[t] = $785da19a645c07eb$var$ZS(f, s, a, !1), s += 2 * a;
                                else {
                                    let i = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, a, !1, l);
                                    A[t] = i, o += a;
                                }
                            }
                            t[r++] = A;
                        }
                        break;
                    case $785da19a645c07eb$var$US.MULTIPOLYGON:
                        {
                            let c = u[a] - u[a - 1];
                            a++;
                            let g = Array(c);
                            for(let t = 0; t < c; t++){
                                let a = h[i] - h[i - 1];
                                i++;
                                let r, c = Array(a - 1), u = d[n] - d[n - 1];
                                n++, m ? (r = $785da19a645c07eb$var$ZS(f, s, u, !0), s += 2 * u) : (r = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, u, !0, l), o += u);
                                for(let t = 0; t < c.length; t++){
                                    let i = d[n] - d[n - 1];
                                    n++, m ? (c[t] = $785da19a645c07eb$var$ZS(f, s, i, !0), s += 2 * i) : (c[t] = $785da19a645c07eb$var$WS(e1.vertexBufferType, f, p, o, i, !0, l), o += i);
                                }
                                g[t] = [
                                    r
                                ].concat(c);
                            }
                            t[r++] = g.flat();
                        }
                        break;
                    default:
                        throw Error(`The specified geometry type (${A}) is currently not supported.`);
                }
            }
            return t;
        }(this);
    }
    get mortonSettings() {
        return this._mortonSettings;
    }
};
var $785da19a645c07eb$var$XS = class extends $785da19a645c07eb$var$KS {
    constructor(e1, t, i, n, a, r, s){
        super(i, n, a, r, s), this._numGeometries = e1, this._geometryType = t;
    }
    geometryType(e1) {
        return this._geometryType;
    }
    get numGeometries() {
        return this._numGeometries;
    }
    containsPolygonGeometry() {
        return this._geometryType === $785da19a645c07eb$var$US.POLYGON || this._geometryType === $785da19a645c07eb$var$US.MULTIPOLYGON;
    }
    containsSingleGeometryType() {
        return !0;
    }
};
function $785da19a645c07eb$var$QS(e1, t, i, n) {
    return new $785da19a645c07eb$var$YS($785da19a645c07eb$var$jS.VEC_2, e1, t, i, n);
}
var $785da19a645c07eb$var$YS = class extends $785da19a645c07eb$var$KS {
    constructor(e1, t, i, n, a, r){
        super(e1, i, n, a, r), this._geometryTypes = t;
    }
    geometryType(e1) {
        return this._geometryTypes[e1];
    }
    get numGeometries() {
        return this._geometryTypes.length;
    }
    containsPolygonGeometry() {
        for(let e1 = 0; e1 < this.numGeometries; e1++)if (this.geometryType(e1) === $785da19a645c07eb$var$US.POLYGON || this.geometryType(e1) === $785da19a645c07eb$var$US.MULTIPOLYGON) return !0;
        return !1;
    }
    containsSingleGeometryType() {
        return !1;
    }
}, $785da19a645c07eb$var$JS = class {
    constructor(e1, t, i, n){
        this._triangleOffsets = e1, this._indexBuffer = t, this._vertexBuffer = i, this._topologyVector = n;
    }
    get triangleOffsets() {
        return this._triangleOffsets;
    }
    get indexBuffer() {
        return this._indexBuffer;
    }
    get vertexBuffer() {
        return this._vertexBuffer;
    }
    get topologyVector() {
        return this._topologyVector;
    }
    getGeometries() {
        if (!this._topologyVector) throw Error("Cannot convert GpuVector to coordinates without topology information");
        let e1 = new Uint32Array(this.numGeometries);
        for(let t = 0; t < this.numGeometries; t++)e1[t] = this.geometryType(t);
        return $785da19a645c07eb$var$QS(e1, this._topologyVector, void 0, this._vertexBuffer).getGeometries();
    }
    [Symbol.iterator]() {
        return null;
    }
};
function $785da19a645c07eb$var$$S(e1, t, i, n, a, r) {
    return new $785da19a645c07eb$var$eM(e1, t, i, n, a, r);
}
var $785da19a645c07eb$var$eM = class extends $785da19a645c07eb$var$JS {
    constructor(e1, t, i, n, a, r){
        super(i, n, a, r), this._numGeometries = e1, this._geometryType = t;
    }
    geometryType(e1) {
        return this._geometryType;
    }
    get numGeometries() {
        return this._numGeometries;
    }
    containsSingleGeometryType() {
        return !0;
    }
};
function $785da19a645c07eb$var$tM(e1, t, i, n, a) {
    return new $785da19a645c07eb$var$iM(e1, t, i, n, a);
}
var $785da19a645c07eb$var$iM = class extends $785da19a645c07eb$var$JS {
    constructor(e1, t, i, n, a){
        super(t, i, n, a), this._geometryTypes = e1;
    }
    geometryType(e1) {
        return this._geometryTypes[e1];
    }
    get numGeometries() {
        return this._geometryTypes.length;
    }
    containsSingleGeometryType() {
        return !1;
    }
};
function $785da19a645c07eb$var$nM(e1, t, i, n, a) {
    let r, s, o, l, c = $785da19a645c07eb$var$mS(e1, i);
    if ($785da19a645c07eb$var$OS(c, n, e1, i) === $785da19a645c07eb$var$gS.CONST) {
        let a, u, h, d, p = $785da19a645c07eb$var$TS(e1, i, c);
        for(let n = 0; n < t - 1; n++){
            let t = $785da19a645c07eb$var$mS(e1, i);
            switch(t.physicalStreamType){
                case $785da19a645c07eb$var$aS.LENGTH:
                    switch(t.logicalStreamType.lengthType){
                        case $785da19a645c07eb$var$oS.GEOMETRIES:
                            a = $785da19a645c07eb$var$kS(e1, i, t);
                            break;
                        case $785da19a645c07eb$var$oS.PARTS:
                            u = $785da19a645c07eb$var$kS(e1, i, t);
                            break;
                        case $785da19a645c07eb$var$oS.RINGS:
                            h = $785da19a645c07eb$var$kS(e1, i, t);
                            break;
                        case $785da19a645c07eb$var$oS.TRIANGLES:
                            d = $785da19a645c07eb$var$kS(e1, i, t);
                    }
                    break;
                case $785da19a645c07eb$var$aS.OFFSET:
                    switch(t.logicalStreamType.offsetType){
                        case $785da19a645c07eb$var$sS.VERTEX:
                            r = $785da19a645c07eb$var$ES(e1, i, t);
                            break;
                        case $785da19a645c07eb$var$sS.INDEX:
                            l = $785da19a645c07eb$var$ES(e1, i, t);
                    }
                    break;
                case $785da19a645c07eb$var$aS.DATA:
                    if ($785da19a645c07eb$var$rS.VERTEX === t.logicalStreamType.dictionaryType) s = $785da19a645c07eb$var$wS(e1, i, t);
                    else {
                        let n = t;
                        o = {
                            numBits: n.numBits,
                            coordinateShift: n.coordinateShift
                        }, s = $785da19a645c07eb$var$ES(e1, i, t);
                    }
            }
        }
        return l ? void 0 !== a || void 0 !== u ? $785da19a645c07eb$var$$S(n, p, d, l, s, {
            geometryOffsets: a,
            partOffsets: u,
            ringOffsets: h
        }) : $785da19a645c07eb$var$$S(n, p, d, l, s) : void 0 === o ? function(e1, t, i, n, a) {
            return new $785da19a645c07eb$var$XS(e1, t, $785da19a645c07eb$var$jS.VEC_2, i, n, a);
        }(n, p, {
            geometryOffsets: a,
            partOffsets: u,
            ringOffsets: h
        }, r, s) : function(e1, t, i, n, a, r) {
            return new $785da19a645c07eb$var$XS(e1, t, $785da19a645c07eb$var$jS.MORTON, i, n, a, r);
        }(n, p, {
            geometryOffsets: a,
            partOffsets: u,
            ringOffsets: h
        }, r, s, o);
    }
    let u, h, d, p, m, g, f, A = $785da19a645c07eb$var$ES(e1, i, c);
    for(let n = 0; n < t - 1; n++){
        let t = $785da19a645c07eb$var$mS(e1, i);
        switch(t.physicalStreamType){
            case $785da19a645c07eb$var$aS.LENGTH:
                switch(t.logicalStreamType.lengthType){
                    case $785da19a645c07eb$var$oS.GEOMETRIES:
                        u = $785da19a645c07eb$var$ES(e1, i, t);
                        break;
                    case $785da19a645c07eb$var$oS.PARTS:
                        h = $785da19a645c07eb$var$ES(e1, i, t);
                        break;
                    case $785da19a645c07eb$var$oS.RINGS:
                        d = $785da19a645c07eb$var$ES(e1, i, t);
                        break;
                    case $785da19a645c07eb$var$oS.TRIANGLES:
                        p = $785da19a645c07eb$var$kS(e1, i, t);
                }
                break;
            case $785da19a645c07eb$var$aS.OFFSET:
                switch(t.logicalStreamType.offsetType){
                    case $785da19a645c07eb$var$sS.VERTEX:
                        r = $785da19a645c07eb$var$ES(e1, i, t);
                        break;
                    case $785da19a645c07eb$var$sS.INDEX:
                        l = $785da19a645c07eb$var$ES(e1, i, t);
                }
                break;
            case $785da19a645c07eb$var$aS.DATA:
                if ($785da19a645c07eb$var$rS.VERTEX === t.logicalStreamType.dictionaryType) s = $785da19a645c07eb$var$wS(e1, i, t);
                else {
                    let n = t;
                    o = {
                        numBits: n.numBits,
                        coordinateShift: n.coordinateShift
                    }, s = $785da19a645c07eb$var$ES(e1, i, t);
                }
        }
    }
    return u ? (m = $785da19a645c07eb$var$aM(A, u, 2), h && d ? (g = $785da19a645c07eb$var$rM(A, m, h, !1), f = function(e1, t, i, n) {
        let a = new Uint32Array(i[i.length - 1] + 1), r = 0;
        a[0] = r;
        let s = 1, o = 1, l = 0;
        for(let c = 0; c < e1.length; c++){
            let u = e1[c], h = t[c + 1] - t[c];
            if (0 !== u && 3 !== u) for(let e1 = 0; e1 < h; e1++){
                let e1 = i[s] - i[s - 1];
                s++;
                for(let t = 0; t < e1; t++)r = a[o++] = r + n[l++];
            }
            else for(let e1 = 0; e1 < h; e1++)a[o++] = ++r, s++;
        }
        return a;
    }(A, m, g, d)) : h && (g = function(e1, t, i) {
        let n = new Uint32Array(t[t.length - 1] + 1), a = 0;
        n[0] = a;
        let r = 1, s = 0;
        for(let o = 0; o < e1.length; o++){
            let l = e1[o], c = t[o + 1] - t[o];
            if (4 === l || 1 === l) for(let e1 = 0; e1 < c; e1++)a = n[r++] = a + i[s++];
            else for(let e1 = 0; e1 < c; e1++)n[r++] = ++a;
        }
        return n;
    }(A, m, h))) : h && d ? (g = $785da19a645c07eb$var$aM(A, h, 1), f = $785da19a645c07eb$var$rM(A, g, d, !0)) : h && (g = $785da19a645c07eb$var$aM(A, h, 0)), l && !g ? $785da19a645c07eb$var$tM(A, p, l, s) : l ? $785da19a645c07eb$var$tM(A, p, l, s, {
        geometryOffsets: m,
        partOffsets: g,
        ringOffsets: f
    }) : void 0 === o ? $785da19a645c07eb$var$QS(A, {
        geometryOffsets: m,
        partOffsets: g,
        ringOffsets: f
    }, r, s) : function(e1, t, i, n, a) {
        return new $785da19a645c07eb$var$YS($785da19a645c07eb$var$jS.MORTON, e1, t, i, n, a);
    }(A, {
        geometryOffsets: m,
        partOffsets: g,
        ringOffsets: f
    }, r, s, o);
}
function $785da19a645c07eb$var$aM(e1, t, i) {
    let n = new Uint32Array(e1.length + 1), a = 0;
    n[0] = a;
    let r = 0;
    for(let s = 0; s < e1.length; s++)a = n[s + 1] = a + (e1[s] > i ? t[r++] : 1);
    return n;
}
function $785da19a645c07eb$var$rM(e1, t, i, n) {
    let a = new Uint32Array(t[t.length - 1] + 1), r = 0;
    a[0] = r;
    let s = 1, o = 0;
    for(let l = 0; l < e1.length; l++){
        let c = e1[l], u = t[l + 1] - t[l];
        if (5 === c || 2 === c || n && (4 === c || 1 === c)) for(let e1 = 0; e1 < u; e1++)r = a[s++] = r + i[o++];
        else for(let e1 = 0; e1 < u; e1++)a[s++] = ++r;
    }
    return a;
}
var $785da19a645c07eb$var$sM = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i){
        super(e1, t.getBuffer(), i), this.dataVector = t;
    }
    getValueFromBuffer(e1) {
        return this.dataVector.get(e1);
    }
}, $785da19a645c07eb$var$oM = class extends $785da19a645c07eb$var$nk {
    getValueFromBuffer(e1) {
        return this.dataBuffer[e1];
    }
}, $785da19a645c07eb$var$lM = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i, n){
        super(e1, n ? BigInt64Array.of(t) : BigUint64Array.of(t), i);
    }
    getValueFromBuffer(e1) {
        return this.dataBuffer[0];
    }
}, $785da19a645c07eb$var$cM = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i, n){
        super(e1, i, n), this.offsetBuffer = t;
    }
}, $785da19a645c07eb$var$uM = class extends $785da19a645c07eb$var$cM {
    constructor(e1, t, i, n){
        super(e1, t, i, n ?? t.length - 1);
    }
    getValueFromBuffer(e1) {
        let t = this.offsetBuffer[e1], i = this.offsetBuffer[e1 + 1];
        return $785da19a645c07eb$var$bS(this.dataBuffer, t, i);
    }
}, $785da19a645c07eb$var$hM = class extends $785da19a645c07eb$var$cM {
    constructor(e1, t, i, n, a){
        super(e1, i, n, a ?? t.length), this.indexBuffer = t, this.indexBuffer = t;
    }
    getValueFromBuffer(e1) {
        let t = this.indexBuffer[e1], i = this.offsetBuffer[t], n = this.offsetBuffer[t + 1];
        return $785da19a645c07eb$var$bS(this.dataBuffer, i, n);
    }
};
var $785da19a645c07eb$var$dM = class extends $785da19a645c07eb$var$cM {
    constructor(e1, t, i, n, a, r, s, o){
        super(e1, i, n, s ?? t.length), this.indexBuffer = t, this.symbolOffsetBuffer = a, this.symbolTableBuffer = r, this.sharedDictionaryCache = o;
    }
    getValueFromBuffer(e1) {
        this.decodedDictionary ?? (this.decodedDictionary = this.sharedDictionaryCache?.decodedDictionary, this.decodedDictionary ?? (this.decodedDictionary = this.decodeDictionary(), this.sharedDictionaryCache && (this.sharedDictionaryCache.decodedDictionary = this.decodedDictionary)));
        let t = this.indexBuffer[e1], i = this.offsetBuffer[t], n = this.offsetBuffer[t + 1];
        return $785da19a645c07eb$var$bS(this.decodedDictionary, i, n);
    }
    decodeDictionary() {
        return this.symbolLengthBuffer ??= this.offsetToLengthBuffer(this.symbolOffsetBuffer), function(e1, t, i) {
            let n = new Uint32Array(t.length);
            for(let e1 = 1; e1 < t.length; e1++)n[e1] = n[e1 - 1] + t[e1 - 1];
            let a = new Uint8Array(function(e1, t) {
                let i = 0;
                for(let n = 0; n < t.length; n++){
                    let a = t[n];
                    255 === a ? (i++, n++) : i += e1[a];
                }
                return i;
            }(t, i)), r = 0;
            for(let s = 0; s < i.length; s++){
                let o = i[s];
                if (255 === o) s++, a[r++] = i[s];
                else {
                    let i = t[o], s = n[o];
                    for(; i-- > 0;)a[r++] = e1[s++];
                }
            }
            return a;
        }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer);
    }
    offsetToLengthBuffer(e1) {
        let t = new Uint32Array(e1.length - 1), i = e1[0];
        for(let n = 1; n < e1.length; n++){
            let a = e1[n];
            t[n - 1] = a - i, i = a;
        }
        return t;
    }
};
function $785da19a645c07eb$var$pM(e1, t, i, n, a) {
    let r, s, o, l, c, u, h, d = a;
    for(let e1 = 0; e1 < n; e1++){
        let e1 = $785da19a645c07eb$var$mS(t, i);
        switch(e1.physicalStreamType){
            case $785da19a645c07eb$var$aS.PRESENT:
                {
                    let n = new $785da19a645c07eb$var$fS($785da19a645c07eb$var$_S(t, e1.numValues, e1.byteLength, i), e1.numValues);
                    d = a ?? n;
                    break;
                }
            case $785da19a645c07eb$var$aS.OFFSET:
                s = $785da19a645c07eb$var$ES(t, i, e1, 0, d);
                break;
            case $785da19a645c07eb$var$aS.LENGTH:
                {
                    let n = $785da19a645c07eb$var$kS(t, i, e1);
                    $785da19a645c07eb$var$oS.DICTIONARY === e1.logicalStreamType.lengthType ? r = n : $785da19a645c07eb$var$oS.SYMBOL === e1.logicalStreamType.lengthType ? l = n : u = n;
                    break;
                }
            case $785da19a645c07eb$var$aS.DATA:
                {
                    let n = t.subarray(i.get(), i.get() + e1.byteLength);
                    i.add(e1.byteLength);
                    let a = e1.logicalStreamType.dictionaryType;
                    $785da19a645c07eb$var$rS.FSST === a ? c = n : $785da19a645c07eb$var$rS.SINGLE === a || $785da19a645c07eb$var$rS.SHARED === a ? o = n : $785da19a645c07eb$var$rS.NONE === a && (h = n);
                    break;
                }
        }
    }
    return function(e1, t, i, n, a, r, s) {
        if (t) {
            if (!(i && n && a && r)) throw Error(`Incomplete FSST dictionary string column "${e1}"`);
            return new $785da19a645c07eb$var$dM(e1, i, n, a, r, t, s);
        }
    }(e1, c, s, r, o, l, d) ?? function(e1, t, i, n, a) {
        if (t) {
            if (!i || !n) throw Error(`Incomplete dictionary string column "${e1}"`);
            return a ? new $785da19a645c07eb$var$hM(e1, i, n, t, a) : new $785da19a645c07eb$var$hM(e1, i, n, t);
        }
    }(e1, o, s, r, d) ?? function(e1, t, i, n, a) {
        if (t && i) {
            if (n) return a ? new $785da19a645c07eb$var$hM(e1, n, t, i, a) : new $785da19a645c07eb$var$hM(e1, n, t, i);
            if (a && a.size() !== t.length - 1) {
                let n = new Uint32Array(a.size()), r = 0;
                for(let e1 = 0; e1 < a.size(); e1++)a.get(e1) ? n[e1] = r++ : n[e1] = 0;
                return new $785da19a645c07eb$var$hM(e1, n, t, i, a);
            }
            return a ? new $785da19a645c07eb$var$uM(e1, t, i, a) : new $785da19a645c07eb$var$uM(e1, t, i);
        }
    }(e1, u, h, s, d);
}
var $785da19a645c07eb$var$mM, $785da19a645c07eb$var$gM, $785da19a645c07eb$var$fM = class extends $785da19a645c07eb$var$ik {
    constructor(e1, t, i){
        super(e1, new Uint8Array, i ?? t.length), this.values = t;
    }
    getValueFromBuffer(e1) {
        return this.values[e1];
    }
};
function $785da19a645c07eb$var$AM(e1, t, i, n) {
    let a = function(e1) {
        let t = "complexType" === e1.type ? e1.complexType.children : void 0;
        return t && 0 !== t.length ? t.map((t)=>e1.name + (t.name ?? "")) : [
            e1.name
        ];
    }(i);
    if (0 === n) return a.map((e1)=>new $785da19a645c07eb$var$fM(e1, []));
    let r = function(e1, t, i) {
        let n = e1[t.get()];
        t.add(1);
        let a = $785da19a645c07eb$var$ES(e1, t, $785da19a645c07eb$var$mS(e1, t)), r = i - 1, s = [];
        n & $785da19a645c07eb$var$mM.STRING && (r -= function(e1, t, i) {
            let n = e1[t.get()];
            t.add(1);
            let a = $785da19a645c07eb$var$pM("", e1, t, n);
            if (a) for(let e1 = 0; e1 < a.size; e1++)i.push(a.getValue(e1));
            return n;
        }(e1, t, s)), r -= function(e1, t, i, n) {
            let a = 0;
            return i & $785da19a645c07eb$var$mM.INT32 ? ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$wS(e1, t, $785da19a645c07eb$var$mS(e1, t))), a++) : i & $785da19a645c07eb$var$mM.INT64 && ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$IS(e1, t, $785da19a645c07eb$var$mS(e1, t))), a++), i & $785da19a645c07eb$var$mM.UINT32 ? ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$ES(e1, t, $785da19a645c07eb$var$mS(e1, t))), a++) : i & $785da19a645c07eb$var$mM.UINT64 && ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$FS(e1, t, $785da19a645c07eb$var$mS(e1, t))), a++), a;
        }(e1, t, n, s), r -= function(e1, t, i, n) {
            let a = 0;
            return i & $785da19a645c07eb$var$mM.FLOAT && ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$vS(e1, t, $785da19a645c07eb$var$mS(e1, t).numValues)), a++), i & $785da19a645c07eb$var$mM.DOUBLE && ($785da19a645c07eb$var$EM(n, $785da19a645c07eb$var$yS(e1, t, $785da19a645c07eb$var$mS(e1, t).numValues)), a++), a;
        }(e1, t, n, s);
        let o, l = 0;
        if (n & $785da19a645c07eb$var$mM.PRESENCE) {
            let i = function(e1, t) {
                let i = $785da19a645c07eb$var$mS(e1, t);
                if (i.physicalStreamType !== $785da19a645c07eb$var$aS.PRESENT) throw Error(`Expected PRESENT stream for map column but found: ${i.physicalStreamType}`);
                let n = i.numValues, a = t.get(), r = new $785da19a645c07eb$var$fS($785da19a645c07eb$var$_S(e1, n, i.byteLength, t), n);
                return t.set(a + i.byteLength), {
                    value: r,
                    count: n
                };
            }(e1, t);
            o = i.value, l = i.count, r--;
        }
        let c = new Uint32Array;
        if (r > 0 && (c = $785da19a645c07eb$var$ES(e1, t, $785da19a645c07eb$var$mS(e1, t)), r--), 0 !== r) throw Error(`Unexpected number of remaining streams while decoding map column: ${r}`);
        return {
            lengthStream: a,
            dictionary: s,
            presentStream: o,
            presentCount: l,
            flattenedValues: c
        };
    }(e1, t, n), s = (r.presentStream ? r.presentCount : r.lengthStream.length) / a.length, o = [], l = 0, c = 0;
    for(let e1 = 0; e1 < a.length; e1++){
        let t = $785da19a645c07eb$var$_M(r, e1, s, l, c);
        o.push(new $785da19a645c07eb$var$fM(a[e1], t.value, t.nullabilityBuffer)), l = t.countsEnd, c = t.valuesEnd;
    }
    return o;
}
function $785da19a645c07eb$var$_M(e1, t, i, n, a) {
    let r, { lengthStream: s, flattenedValues: o, presentStream: l, dictionary: c } = e1, u = t * i, h = i;
    if (l) {
        r = new $785da19a645c07eb$var$fS(new Uint8Array(Math.ceil(i / 8)), i), h = 0;
        for(let e1 = 0; e1 < i; e1++)l.get(u + e1) && (r.set(e1, !0), h++);
    }
    let d = n + h;
    if (d > s.length) throw Error("Merged map counts underflow while decoding child streams");
    let p = Array(i), m = n, g = a;
    for(let e1 = 0; e1 < i; e1++){
        if (l && !l.get(u + e1)) {
            p[e1] = null;
            continue;
        }
        let t = g + s[m++];
        if (t > o.length) throw Error("Map value stream underflow while decoding feature payload");
        let i = $785da19a645c07eb$var$vM(o, g, t, c);
        p[e1] = i.value, g = i.nextIndex;
    }
    let f = 0;
    for(let e1 = n; e1 < d; e1++)f += s[e1];
    let A = a + f;
    if (g !== A) throw Error("Unused flattened map values remain after decode");
    return {
        value: p,
        nullabilityBuffer: r,
        countsEnd: d,
        valuesEnd: A
    };
}
function $785da19a645c07eb$var$vM(e1, t, i, n) {
    return i - t === 1 || e1[t] === $785da19a645c07eb$var$gM.START_LIST ? $785da19a645c07eb$var$xM(e1, t, i, n) : $785da19a645c07eb$var$yM(e1, t, i, n);
}
function $785da19a645c07eb$var$yM(e1, t, i, n) {
    let a = Object.create(null), r = t;
    for(; r < i;){
        let t = $785da19a645c07eb$var$wM(e1[r++], n);
        if ("string" != typeof t) throw Error(`Map key dictionary index does not resolve to a string: ${t}`);
        let s = $785da19a645c07eb$var$xM(e1, r, i, n);
        a[t] = s.value, r = s.nextIndex;
    }
    return {
        value: a,
        nextIndex: r
    };
}
function $785da19a645c07eb$var$xM(e1, t, i, n) {
    if (t >= i) throw Error("Unexpected end of map value stream");
    let a = e1[t];
    if (a === $785da19a645c07eb$var$gM.FALSE) return {
        value: !1,
        nextIndex: t + 1
    };
    if (a === $785da19a645c07eb$var$gM.TRUE) return {
        value: !0,
        nextIndex: t + 1
    };
    if (a === $785da19a645c07eb$var$gM.START_MAP) {
        let a = $785da19a645c07eb$var$bM(e1, t, i);
        return {
            value: $785da19a645c07eb$var$yM(e1, t + 2, a, n).value,
            nextIndex: a
        };
    }
    if (a === $785da19a645c07eb$var$gM.START_LIST) {
        let a = $785da19a645c07eb$var$bM(e1, t, i), r = [], s = t + 2;
        for(; s < a;){
            let t = $785da19a645c07eb$var$xM(e1, s, a, n);
            r.push(t.value), s = t.nextIndex;
        }
        return {
            value: r,
            nextIndex: a
        };
    }
    return {
        value: $785da19a645c07eb$var$wM(a, n),
        nextIndex: t + 1
    };
}
function $785da19a645c07eb$var$bM(e1, t, i) {
    if (t + 1 >= i) throw Error("Missing length for nested map/list payload");
    let n = e1[t + 1];
    if (n < 2) throw Error(`Invalid nested payload length: ${n}`);
    let a = t + n;
    if (a > i) throw Error("Nested payload exceeds containing payload bounds");
    return a;
}
function $785da19a645c07eb$var$wM(e1, t) {
    let i = e1 - $785da19a645c07eb$var$gM.COUNT;
    if (i < 0 || i >= t.length) throw Error(`Scalar dictionary index out of range: ${e1}`);
    return t[i];
}
function $785da19a645c07eb$var$EM(e1, t) {
    for (let i of t)e1.push(i);
}
function $785da19a645c07eb$var$kM(e1, t, i, n, a, r) {
    return "scalarType" === i.type ? function(e1, t, i, n, a, r) {
        let s;
        if (0 === e1) return null;
        if (r.nullable) {
            let e1 = $785da19a645c07eb$var$mS(t, i), n = e1.numValues, a = i.get(), r = $785da19a645c07eb$var$_S(t, n, e1.byteLength, i);
            i.set(a + e1.byteLength), s = new $785da19a645c07eb$var$fS(r, e1.numValues);
        }
        let o = s ?? n;
        switch(a.physicalType){
            case $785da19a645c07eb$var$gk:
            case $785da19a645c07eb$var$mk:
                return function(e1, t, i, n, a) {
                    let r = $785da19a645c07eb$var$mS(e1, t), s = $785da19a645c07eb$var$OS(r, a, e1, t), o = n.physicalType === $785da19a645c07eb$var$mk;
                    if (s === $785da19a645c07eb$var$gS.FLAT) {
                        let n = $785da19a645c07eb$var$SM(a) ? a : void 0, s = o ? $785da19a645c07eb$var$wS(e1, t, r, 0, n) : $785da19a645c07eb$var$ES(e1, t, r, 0, n);
                        return new $785da19a645c07eb$var$ak(i.name, s, a);
                    }
                    if (s === $785da19a645c07eb$var$gS.SEQUENCE) {
                        let n = $785da19a645c07eb$var$DS(e1, t, r);
                        return new $785da19a645c07eb$var$ok(i.name, n[0], n[1], r.numRleValues, o);
                    }
                    let l = o ? $785da19a645c07eb$var$CS(e1, t, r) : $785da19a645c07eb$var$TS(e1, t, r);
                    return new $785da19a645c07eb$var$lk(i.name, l, a, o);
                }(t, i, r, a, o);
            case $785da19a645c07eb$var$yk:
                {
                    let n = r.nullable ? e1 - 1 : e1;
                    return $785da19a645c07eb$var$pM(r.name, t, i, n, s) ?? null;
                }
            case $785da19a645c07eb$var$hk:
                return function(e1, t, i, n, a) {
                    let r = $785da19a645c07eb$var$mS(e1, t), s = r.numValues, o = t.get(), l = $785da19a645c07eb$var$SM(a) ? a : void 0, c = $785da19a645c07eb$var$_S(e1, s, r.byteLength, t, l);
                    t.set(o + r.byteLength);
                    let u = new $785da19a645c07eb$var$fS(c, s);
                    return new $785da19a645c07eb$var$sM(i.name, u, a);
                }(t, i, r, 0, o);
            case $785da19a645c07eb$var$Ak:
            case $785da19a645c07eb$var$fk:
                return function(e1, t, i, n, a) {
                    let r = $785da19a645c07eb$var$mS(e1, t), s = $785da19a645c07eb$var$OS(r, n, e1, t, "int64"), o = a.physicalType === $785da19a645c07eb$var$fk;
                    if (s === $785da19a645c07eb$var$gS.FLAT) {
                        let a = $785da19a645c07eb$var$SM(n) ? n : void 0, s = o ? $785da19a645c07eb$var$IS(e1, t, r, a) : $785da19a645c07eb$var$FS(e1, t, r, a);
                        return new $785da19a645c07eb$var$VS(i.name, s, n);
                    }
                    if (s === $785da19a645c07eb$var$gS.SEQUENCE) {
                        let n = $785da19a645c07eb$var$PS(e1, t, r);
                        return new $785da19a645c07eb$var$qS(i.name, n[0], n[1], r.numRleValues, o);
                    }
                    let l = o ? $785da19a645c07eb$var$RS(e1, t, r) : $785da19a645c07eb$var$LS(e1, t, r);
                    return new $785da19a645c07eb$var$lM(i.name, l, n, o);
                }(t, i, r, o, a);
            case $785da19a645c07eb$var$_k:
                return function(e1, t, i, n) {
                    let a = $785da19a645c07eb$var$mS(e1, t), r = $785da19a645c07eb$var$SM(n) ? n : void 0, s = $785da19a645c07eb$var$vS(e1, t, a.numValues, r);
                    return new $785da19a645c07eb$var$oM(i.name, s, n);
                }(t, i, r, o);
            case $785da19a645c07eb$var$vk:
                return function(e1, t, i, n) {
                    let a = $785da19a645c07eb$var$mS(e1, t), r = $785da19a645c07eb$var$SM(n) ? n : void 0, s = $785da19a645c07eb$var$yS(e1, t, a.numValues, r);
                    return new $785da19a645c07eb$var$rk(i.name, s, n);
                }(t, i, r, o);
            default:
                throw Error(`The specified data type for the field is currently not supported: ${a}`);
        }
    }(n, e1, t, a, i.scalarType, i) : i.complexType?.physicalType === $785da19a645c07eb$var$wk ? $785da19a645c07eb$var$AM(e1, t, i, n) : 0 === n ? null : function(e1, t, i) {
        let n, a, r, s, o = !1;
        for(; !o;){
            let i = $785da19a645c07eb$var$mS(e1, t);
            switch(i.physicalStreamType){
                case $785da19a645c07eb$var$aS.LENGTH:
                    $785da19a645c07eb$var$oS.DICTIONARY === i.logicalStreamType.lengthType ? n = $785da19a645c07eb$var$kS(e1, t, i) : r = $785da19a645c07eb$var$kS(e1, t, i);
                    break;
                case $785da19a645c07eb$var$aS.DATA:
                    $785da19a645c07eb$var$rS.SINGLE === i.logicalStreamType.dictionaryType || $785da19a645c07eb$var$rS.SHARED === i.logicalStreamType.dictionaryType ? (a = e1.subarray(t.get(), t.get() + i.byteLength), o = !0) : s = e1.subarray(t.get(), t.get() + i.byteLength), t.add(i.byteLength);
            }
        }
        if ("complexType" !== i.type) throw Error(`Shared dictionary column ${i.name} must be a complex (struct) column.`);
        if (!n || !a) throw Error(`Incomplete shared dictionary for column "${i.name}"`);
        let l = i.complexType.children, c = [], u = s ? {} : void 0, h = 0;
        for (let o of l){
            let l = $785da19a645c07eb$var$Vk(e1, t, 1)[0];
            if (0 === l) continue;
            let d, p = o.name ? `${i.name}${o.name}` : i.name;
            if ("scalarField" !== o.type || o.scalarField.physicalType !== $785da19a645c07eb$var$yk) throw Error("Currently only scalar string fields are implemented for a struct.");
            if (l > 1 && !o.nullable || 1 === l && o.nullable) throw Error(`The number of streams for the child field ${o.name} does not match its nullability. nullibilty: ${o.nullable}, numStreams: ${l}`);
            if (o.nullable) {
                let i = $785da19a645c07eb$var$mS(e1, t);
                d = new $785da19a645c07eb$var$fS($785da19a645c07eb$var$_S(e1, i.numValues, i.byteLength, t), i.numValues);
            }
            let m = $785da19a645c07eb$var$ES(e1, t, $785da19a645c07eb$var$mS(e1, t), 0, d);
            if (s) {
                if (!r) throw Error(`Incomplete shared FSST dictionary for column "${p}"`);
                c[h++] = new $785da19a645c07eb$var$dM(p, m, n, a, r, s, d, u);
            } else c[h++] = new $785da19a645c07eb$var$hM(p, m, n, a, d);
        }
        return c;
    }(e1, t, i);
}
function $785da19a645c07eb$var$SM(e1) {
    return e1 instanceof $785da19a645c07eb$var$fS;
}
!function(e1) {
    e1[e1.STRING = 1] = "STRING", e1[e1.INT32 = 2] = "INT32", e1[e1.UINT32 = 4] = "UINT32", e1[e1.INT64 = 8] = "INT64", e1[e1.UINT64 = 16] = "UINT64", e1[e1.FLOAT = 32] = "FLOAT", e1[e1.DOUBLE = 64] = "DOUBLE", e1[e1.PRESENCE = 128] = "PRESENCE";
}($785da19a645c07eb$var$mM ||= {}), function(e1) {
    e1[e1.FALSE = 0] = "FALSE", e1[e1.TRUE = 1] = "TRUE", e1[e1.START_MAP = 2] = "START_MAP", e1[e1.START_LIST = 3] = "START_LIST", e1[e1.COUNT = 4] = "COUNT";
}($785da19a645c07eb$var$gM ||= {});
const $785da19a645c07eb$var$MM = 0, $785da19a645c07eb$var$CM = 1, $785da19a645c07eb$var$TM = 2, $785da19a645c07eb$var$DM = 4, $785da19a645c07eb$var$PM = 10, $785da19a645c07eb$var$IM = 30, $785da19a645c07eb$var$FM = 31;
function $785da19a645c07eb$var$zM(e1) {
    switch(e1){
        case $785da19a645c07eb$var$MM:
        case $785da19a645c07eb$var$MM | $785da19a645c07eb$var$CM:
        case $785da19a645c07eb$var$MM | $785da19a645c07eb$var$TM:
        case $785da19a645c07eb$var$MM | $785da19a645c07eb$var$TM | $785da19a645c07eb$var$CM:
            return {
                nullable: 0 !== (e1 & $785da19a645c07eb$var$CM),
                columnScope: $785da19a645c07eb$var$uk,
                type: "scalarType",
                scalarType: {
                    longID: 0 !== (e1 & $785da19a645c07eb$var$TM),
                    type: "logicalType",
                    logicalType: $785da19a645c07eb$var$Ek
                }
            };
        case $785da19a645c07eb$var$DM:
            return {
                nullable: !1,
                columnScope: $785da19a645c07eb$var$uk,
                type: "complexType",
                complexType: {
                    type: "physicalType",
                    physicalType: $785da19a645c07eb$var$xk,
                    children: []
                }
            };
        case $785da19a645c07eb$var$IM:
            return {
                nullable: !1,
                columnScope: $785da19a645c07eb$var$uk,
                type: "complexType",
                complexType: {
                    type: "physicalType",
                    physicalType: $785da19a645c07eb$var$bk,
                    children: []
                }
            };
        case $785da19a645c07eb$var$FM:
            return {
                nullable: !0,
                columnScope: $785da19a645c07eb$var$uk,
                type: "complexType",
                complexType: {
                    type: "physicalType",
                    physicalType: $785da19a645c07eb$var$wk,
                    children: []
                }
            };
        default:
            return function(e1) {
                let t;
                switch(e1){
                    case 10:
                    case 11:
                        t = $785da19a645c07eb$var$hk;
                        break;
                    case 12:
                    case 13:
                        t = $785da19a645c07eb$var$dk;
                        break;
                    case 14:
                    case 15:
                        t = $785da19a645c07eb$var$pk;
                        break;
                    case 16:
                    case 17:
                        t = $785da19a645c07eb$var$mk;
                        break;
                    case 18:
                    case 19:
                        t = $785da19a645c07eb$var$gk;
                        break;
                    case 20:
                    case 21:
                        t = $785da19a645c07eb$var$fk;
                        break;
                    case 22:
                    case 23:
                        t = $785da19a645c07eb$var$Ak;
                        break;
                    case 24:
                    case 25:
                        t = $785da19a645c07eb$var$_k;
                        break;
                    case 26:
                    case 27:
                        t = $785da19a645c07eb$var$vk;
                        break;
                    case 28:
                    case 29:
                        t = $785da19a645c07eb$var$yk;
                        break;
                    default:
                        return null;
                }
                return {
                    nullable: !!(1 & e1),
                    columnScope: $785da19a645c07eb$var$uk,
                    type: "scalarType",
                    scalarType: {
                        longID: !1,
                        type: "physicalType",
                        physicalType: t
                    }
                };
            }(e1);
    }
}
function $785da19a645c07eb$var$RM(e1) {
    return e1 === $785da19a645c07eb$var$IM || e1 === $785da19a645c07eb$var$FM;
}
function $785da19a645c07eb$var$LM(e1) {
    if ("scalarType" === e1.type) {
        let t = e1.scalarType;
        if ("physicalType" === t.type) switch(t.physicalType){
            case $785da19a645c07eb$var$hk:
            case $785da19a645c07eb$var$dk:
            case $785da19a645c07eb$var$pk:
            case $785da19a645c07eb$var$mk:
            case $785da19a645c07eb$var$gk:
            case $785da19a645c07eb$var$fk:
            case $785da19a645c07eb$var$Ak:
            case $785da19a645c07eb$var$_k:
            case $785da19a645c07eb$var$vk:
                return !1;
            case $785da19a645c07eb$var$yk:
                return !0;
            default:
                return !1;
        }
        if ("logicalType" === t.type) return !1;
    } else if ("complexType" === e1.type) {
        let t = e1.complexType;
        if ("physicalType" === t.type) switch(t.physicalType){
            case $785da19a645c07eb$var$xk:
            case $785da19a645c07eb$var$bk:
            case $785da19a645c07eb$var$wk:
                return !0;
            default:
                return !1;
        }
    }
    return console.warn("Unexpected column type in hasStreamCount", e1), !1;
}
function $785da19a645c07eb$var$BM(e1) {
    return "scalarType" === e1.type && "logicalType" === e1.scalarType?.type && e1.scalarType.logicalType === $785da19a645c07eb$var$Ek;
}
function $785da19a645c07eb$var$OM(e1) {
    return "complexType" === e1.type && "physicalType" === e1.complexType?.type && e1.complexType.physicalType === $785da19a645c07eb$var$xk;
}
const $785da19a645c07eb$var$UM = new TextDecoder, $785da19a645c07eb$var$NM = "0-3(ID), 4(GEOMETRY), 10-29(scalars), 30(STRUCT), 31(MAP)";
function $785da19a645c07eb$var$jM(e1, t) {
    let i = $785da19a645c07eb$var$Vk(e1, t, 1)[0];
    if (0 === i) return "";
    let n = t.get(), a = n + i, r = e1.subarray(n, a);
    return t.add(i), $785da19a645c07eb$var$UM.decode(r);
}
function $785da19a645c07eb$var$VM(e1, t) {
    let i = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0, n = i >= $785da19a645c07eb$var$PM ? $785da19a645c07eb$var$zM(i) : null;
    if (!n) throw Error(`Unsupported field type code ${i}. Supported: 10-29(scalars), 30(STRUCT), 31(MAP)`);
    let a = {
        ...n,
        name: $785da19a645c07eb$var$jM(e1, t)
    };
    if ("complexType" === a.type && $785da19a645c07eb$var$RM(i)) {
        let i = a.complexType, n = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0;
        i.children = Array(n);
        for(let a = 0; a < n; a++)i.children[a] = $785da19a645c07eb$var$VM(e1, t);
    }
    return function(e1) {
        let t = e1.name, i = e1.nullable;
        return "scalarType" === e1.type ? {
            type: "scalarField",
            scalarField: e1.scalarType,
            name: t,
            nullable: i
        } : {
            type: "complexField",
            complexField: e1.complexType,
            name: t,
            nullable: i
        };
    }(a);
}
function $785da19a645c07eb$var$qM(e1, t) {
    let i, n = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0, a = $785da19a645c07eb$var$zM(n);
    if (!a) throw Error(`Unsupported column type code ${n}. Supported: ${$785da19a645c07eb$var$NM}`);
    if (function(e1) {
        return e1 >= $785da19a645c07eb$var$PM;
    }(n)) i = $785da19a645c07eb$var$jM(e1, t);
    else if (n < $785da19a645c07eb$var$DM) i = "id";
    else {
        if (n !== $785da19a645c07eb$var$DM) throw Error(`Unsupported column type code ${n}. Supported: ${$785da19a645c07eb$var$NM}`);
        i = "geometry";
    }
    let r = {
        ...a,
        name: i
    };
    if ("complexType" === r.type && $785da19a645c07eb$var$RM(n)) {
        let i = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0, n = r.complexType;
        n.children = Array(i);
        for(let a = 0; a < i; a++)n.children[a] = $785da19a645c07eb$var$VM(e1, t);
    }
    return r;
}
function $785da19a645c07eb$var$GM(e1, t) {
    let i = {
        featureTables: []
    }, n = {};
    if (n.name = $785da19a645c07eb$var$jM(e1, t), 0 === n.name.length) throw Error("Missing layer name");
    let a = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0, r = $785da19a645c07eb$var$Vk(e1, t, 1)[0] >>> 0;
    n.columns = Array(r);
    for(let i = 0; i < r; i++)n.columns[i] = $785da19a645c07eb$var$qM(e1, t);
    return i.featureTables.push(n), [
        i,
        a
    ];
}
function $785da19a645c07eb$var$HM(e1, t, i, n, a, r, s = !1) {
    let o = t.scalarType?.longID ? $785da19a645c07eb$var$Ak : $785da19a645c07eb$var$gk, l = "number" == typeof r ? void 0 : r, c = $785da19a645c07eb$var$OS(a, r, e1, i, o === $785da19a645c07eb$var$Ak ? "int64" : "int32");
    if (o === $785da19a645c07eb$var$gk) switch(c){
        case $785da19a645c07eb$var$gS.FLAT:
            return new $785da19a645c07eb$var$ak(n, $785da19a645c07eb$var$ES(e1, i, a, 0, l), r);
        case $785da19a645c07eb$var$gS.SEQUENCE:
            {
                let t = $785da19a645c07eb$var$DS(e1, i, a);
                return new $785da19a645c07eb$var$ok(n, t[0], t[1], a.numRleValues, !1);
            }
        case $785da19a645c07eb$var$gS.CONST:
            return new $785da19a645c07eb$var$lk(n, $785da19a645c07eb$var$TS(e1, i, a), r, !1);
    }
    switch(c){
        case $785da19a645c07eb$var$gS.FLAT:
            return s ? new $785da19a645c07eb$var$rk(n, $785da19a645c07eb$var$zS(e1, i, a, l), r) : new $785da19a645c07eb$var$VS(n, $785da19a645c07eb$var$FS(e1, i, a, l), r);
        case $785da19a645c07eb$var$gS.SEQUENCE:
            {
                let t = $785da19a645c07eb$var$PS(e1, i, a);
                return new $785da19a645c07eb$var$qS(n, t[0], t[1], a.numRleValues, !1);
            }
        case $785da19a645c07eb$var$gS.CONST:
            return new $785da19a645c07eb$var$lM(n, $785da19a645c07eb$var$LS(e1, i, a), r, !1);
    }
    throw Error("Vector type not supported for id column.");
}
var $785da19a645c07eb$var$WM = class {
    constructor(e1, t){
        switch(this._featureData = e1, this.properties = this._featureData.properties || {}, this._featureData.geometry?.type){
            case $785da19a645c07eb$var$US.POINT:
            case $785da19a645c07eb$var$US.MULTIPOINT:
                this.type = 1;
                break;
            case $785da19a645c07eb$var$US.LINESTRING:
            case $785da19a645c07eb$var$US.MULTILINESTRING:
                this.type = 2;
                break;
            case $785da19a645c07eb$var$US.POLYGON:
            case $785da19a645c07eb$var$US.MULTIPOLYGON:
                this.type = 3;
                break;
            default:
                this.type = 0;
        }
        this.extent = t, this.id = Number(this._featureData.id);
    }
    loadGeometry() {
        let e1 = [];
        for (let t of this._featureData.geometry.coordinates){
            let i = [];
            for (let e1 of t)i.push(new $785da19a645c07eb$var$Kc(e1.x, e1.y));
            e1.push(i);
        }
        return e1;
    }
}, $785da19a645c07eb$var$ZM = class {
    constructor(e1){
        this.features = [], this.featureTable = e1, this.name = e1.name, this.extent = e1.extent, this.version = 2, this.features = e1.getFeatures(), this.length = this.features.length;
    }
    feature(e1) {
        return new $785da19a645c07eb$var$WM(this.features[e1], this.extent);
    }
}, $785da19a645c07eb$var$KM = class {
    constructor(e1){
        this.layers = {};
        let t = function(e1, t, i = !0) {
            let n = new $785da19a645c07eb$var$Mk(0), a = [];
            for(; n.get() < e1.length;){
                let t = $785da19a645c07eb$var$Vk(e1, n, 1)[0] >>> 0, r = n.get() + t;
                if (r > e1.length) throw Error(`Block overruns tile: ${r} > ${e1.length}`);
                let s = $785da19a645c07eb$var$Vk(e1, n, 1)[0] >>> 0;
                if (1 !== s && 2 !== s) {
                    n.set(r);
                    continue;
                }
                let [o, l] = $785da19a645c07eb$var$GM(e1, n), c = o.featureTables[0], u = null, h = null, d = [], p = 0;
                for (let t of c.columns){
                    let a = t.name;
                    if ($785da19a645c07eb$var$BM(t)) {
                        let r = null;
                        if (t.nullable) {
                            let t = $785da19a645c07eb$var$mS(e1, n), i = n.get(), a = $785da19a645c07eb$var$_S(e1, t.numValues, t.byteLength, n);
                            n.set(i + t.byteLength), r = new $785da19a645c07eb$var$fS(a, t.numValues);
                        }
                        let s = $785da19a645c07eb$var$mS(e1, n);
                        p = r ? r.size() : s.decompressedCount, u = $785da19a645c07eb$var$HM(e1, t, n, a, s, r ?? p, i);
                    } else if ($785da19a645c07eb$var$OM(t)) {
                        let t = $785da19a645c07eb$var$Vk(e1, n, 1)[0];
                        if (0 === p) {
                            let t = n.get();
                            p = $785da19a645c07eb$var$mS(e1, n).decompressedCount, n.set(t);
                        }
                        h = $785da19a645c07eb$var$nM(e1, t, n, p);
                    } else {
                        let i = $785da19a645c07eb$var$LM(t) ? $785da19a645c07eb$var$Vk(e1, n, 1)[0] : 1;
                        if (0 === i) continue;
                        let a = $785da19a645c07eb$var$kM(e1, n, t, i, p);
                        if (a) {
                            if (Array.isArray(a)) for (let e1 of a)d.push(e1);
                            else d.push(a);
                        }
                    }
                }
                let m = new $785da19a645c07eb$var$ck(c.name, h, u, d, l);
                a.push(m), n.set(r);
            }
            return a;
        }(new Uint8Array(e1));
        this.layers = t.reduce((e1, t)=>({
                ...e1,
                [t.name]: new $785da19a645c07eb$var$ZM(t)
            }), {});
    }
};
function $785da19a645c07eb$var$XM(e1, t, i, n, a) {
    return $785da19a645c07eb$var$_h(e1, (e1, r)=>{
        let s = t instanceof $785da19a645c07eb$var$rA ? t.get(r) : null;
        return function(e1) {
            return "object" == typeof e1 && !!e1 && "evaluate" in e1;
        }(s) ? s.evaluate(i, n, void 0, a) : s;
    });
}
function $785da19a645c07eb$var$QM(e1, t) {
    return t - e1;
}
$785da19a645c07eb$var$qf("FeatureIndex", class {
    constructor(e1, t){
        this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new $785da19a645c07eb$var$jf($785da19a645c07eb$var$Vu, 16, 0), this.grid3D = new $785da19a645c07eb$var$jf($785da19a645c07eb$var$Vu, 16, 0), this.featureIndexArray = new $785da19a645c07eb$var$o_, this.promoteId = t;
    }
    insert(e1, t, i, n, a, r) {
        let s = this.featureIndexArray.length;
        this.featureIndexArray.emplaceBack(i, n, a);
        let o = r ? this.grid3D : this.grid;
        for (let e1 of t){
            let t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for (let i of e1)t[0] = Math.min(t[0], i.x), t[1] = Math.min(t[1], i.y), t[2] = Math.max(t[2], i.x), t[3] = Math.max(t[3], i.y);
            t[0] < 8192 && t[1] < 8192 && t[2] >= 0 && t[3] >= 0 && o.insert(s, t[0], t[1], t[2], t[3]);
        }
    }
    loadVTLayers() {
        if (!this.vtLayers) {
            if ("mlt" === this.encoding) this.vtLayers = new $785da19a645c07eb$var$KM(this.rawTileData).layers;
            else this.vtLayers = new $785da19a645c07eb$var$kx(new $785da19a645c07eb$var$fw(this.rawTileData)).layers;
            this.sourceLayerCoder = new $785da19a645c07eb$var$ek(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                $785da19a645c07eb$var$$E
            ]);
        }
        return this.vtLayers;
    }
    query(e1, t, i, n) {
        this.loadVTLayers();
        let a = e1.params, r = $785da19a645c07eb$var$Vu / e1.tileSize / e1.scale, s = $785da19a645c07eb$var$jg(a.filter, "queryRenderedFeatures filter", a.globalState), o = e1.queryGeometry, l = e1.queryPadding * r, c = $785da19a645c07eb$var$fx.fromPoints(o), u = this.grid.query(c.minX - l, c.minY - l, c.maxX + l, c.maxY + l), h = $785da19a645c07eb$var$fx.fromPoints(e1.cameraQueryGeometry).expandBy(l), d = this.grid3D.query(h.minX, h.minY, h.maxX, h.maxY, (t, i, n, a)=>(function(e1, t, i, n, a) {
                for (let r of e1)if (t <= r.x && i <= r.y && n >= r.x && a >= r.y) return !0;
                let r = [
                    new $785da19a645c07eb$var$Kc(t, i),
                    new $785da19a645c07eb$var$Kc(t, a),
                    new $785da19a645c07eb$var$Kc(n, a),
                    new $785da19a645c07eb$var$Kc(n, i)
                ];
                if (e1.length > 2) {
                    for (let t of r)if ($785da19a645c07eb$var$kv(e1, t)) return !0;
                }
                for(let t = 0; t < e1.length - 1; t++)if ($785da19a645c07eb$var$Sv(e1[t], e1[t + 1], r)) return !0;
                return !1;
            })(e1.cameraQueryGeometry, t - l, i - l, n + l, a + l));
        for (let e1 of d)u.push(e1);
        u.sort($785da19a645c07eb$var$QM);
        let p, m = {};
        for (let l of u){
            if (l === p) continue;
            p = l;
            let c = this.featureIndexArray.get(l), u = null;
            this.loadMatchingFeature(m, c.bucketIndex, c.sourceLayerIndex, c.featureIndex, s, a.layers, a.availableImages, t, i, n, (t, i, n)=>(u ||= $785da19a645c07eb$var$hv(t), i.queryIntersectsFeature({
                    queryGeometry: o,
                    feature: t,
                    featureState: n,
                    geometry: u,
                    zoom: this.z,
                    transform: e1.transform,
                    pixelsToTileUnits: r,
                    pixelPosMatrix: e1.pixelPosMatrix,
                    unwrappedTileID: this.tileID.toUnwrapped(),
                    getElevation: e1.getElevation
                })));
        }
        return m;
    }
    loadMatchingFeature(e1, t, i, n, a, r, s, o, l, c, u) {
        let h = this.bucketLayerIDs[t];
        if (r && !h.some((e1)=>r.has(e1))) return;
        let d = this.sourceLayerCoder.decode(i), p = this.vtLayers[d].feature(n);
        if (a.needGeometry) {
            let e1 = $785da19a645c07eb$var$dv(p, !0);
            if (!a.filter(new $785da19a645c07eb$var$Qf(this.tileID.overscaledZ), e1, this.tileID.canonical)) return;
        } else if (!a.filter(new $785da19a645c07eb$var$Qf(this.tileID.overscaledZ), p)) return;
        let m = this.getId(p, d);
        for (let t of h){
            if (r && !r.has(t)) continue;
            let i = o[t];
            if (!i) continue;
            let a = {};
            m && c && (a = c.getState(i.sourceLayer || "_geojsonTileLayer", m));
            let h = $785da19a645c07eb$var$hh({}, l[t]);
            h.paint = $785da19a645c07eb$var$XM(h.paint, i.paint, p, a, s), h.layout = $785da19a645c07eb$var$XM(h.layout, i.layout, p, a, s);
            let d = !u || u(p, i, a);
            if (!d) continue;
            let g = new $785da19a645c07eb$var$tk(p, this.z, this.x, this.y, m);
            g.layer = h;
            let f = e1[t];
            void 0 === f && (f = e1[t] = []), f.push({
                featureIndex: n,
                feature: g,
                intersectionZ: d
            });
        }
    }
    lookupSymbolFeatures(e1, t, i, n, a, r, s, o) {
        let l = {};
        this.loadVTLayers();
        let c = $785da19a645c07eb$var$jg(a.filterSpec, "queryRenderedFeatures symbol filter", a.globalState);
        for (let a of e1)this.loadMatchingFeature(l, i, n, a, c, r, s, o, t);
        return l;
    }
    hasLayer(e1) {
        for (let t of this.bucketLayerIDs)for (let i of t)if (e1 === i) return !0;
        return !1;
    }
    getId(e1, t) {
        let i = e1.id;
        if (this.promoteId) {
            let n = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[t];
            i = e1.properties[n], "boolean" == typeof i && (i = Number(i)), void 0 === i && e1.properties?.cluster && this.promoteId && (i = Number(e1.properties.cluster_id));
        }
        return i;
    }
}, {
    omit: [
        "rawTileData",
        "sourceLayerCoder"
    ]
});
var $785da19a645c07eb$var$YM = class {
    constructor(e1, t){
        this.max = e1, this.onRemove = t, this.reset();
    }
    reset() {
        for(let e1 in this.data)for (let t of this.data[e1])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
        return this.data = {}, this.order = [], this;
    }
    add(e1, t, i) {
        let n = e1.wrapped().key;
        void 0 === this.data[n] && (this.data[n] = []);
        let a = {
            value: t,
            timeout: void 0
        };
        if (void 0 !== i && (a.timeout = setTimeout(()=>{
            this.remove(e1, a);
        }, i)), this.data[n].push(a), this.order.push(n), this.order.length > this.max) {
            let e1 = this._getAndRemoveByKey(this.order[0]);
            e1 && this.onRemove(e1);
        }
        return this;
    }
    has(e1) {
        return e1.wrapped().key in this.data;
    }
    getAndRemove(e1) {
        return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
    }
    _getAndRemoveByKey(e1) {
        let t = this.data[e1].shift();
        return t.timeout && clearTimeout(t.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t.value;
    }
    getByKey(e1) {
        let t = this.data[e1];
        return t ? t[0].value : null;
    }
    get(e1) {
        return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
    }
    remove(e1, t) {
        if (!this.has(e1)) return this;
        let i = e1.wrapped().key, n = void 0 === t ? 0 : this.data[i].indexOf(t), a = this.data[i][n];
        return this.data[i].splice(n, 1), a.timeout && clearTimeout(a.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(a.value), this.order.splice(this.order.indexOf(i), 1), this;
    }
    setMaxSize(e1) {
        for(this.max = e1; this.order.length > this.max;){
            let e1 = this._getAndRemoveByKey(this.order[0]);
            e1 && this.onRemove(e1);
        }
        return this;
    }
    filter(e1) {
        let t = [];
        for(let i in this.data)for (let n of this.data[i])e1(n.value) || t.push(n);
        for (let e1 of t)this.remove(e1.value.tileID, e1);
    }
};
/**
* MapLibre GL JS
* @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v6.9.0/LICENSE.txt
*/ function $785da19a645c07eb$var$JM() {
    var e1 = new $785da19a645c07eb$var$$c(4);
    return $785da19a645c07eb$var$$c != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
}
let $785da19a645c07eb$var$$M, $785da19a645c07eb$var$eC, $785da19a645c07eb$var$tC;
const $785da19a645c07eb$var$iC = {
    frame (e1, t, i, n) {
        let a = n || window, r = a.requestAnimationFrame((e1)=>{
            s(), t(e1);
        }), { unsubscribe: s } = $785da19a645c07eb$var$Th(e1.signal, "abort", ()=>{
            s(), a.cancelAnimationFrame(r), i(new $785da19a645c07eb$var$Vh(e1.signal.reason));
        }, !1);
    },
    frameAsync (e1, t) {
        return new Promise((i, n)=>{
            this.frame(e1, i, n, t);
        });
    },
    getImageData (e1, t = 0) {
        return this.getImageCanvasContext(e1).getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
    },
    getImageCanvasContext (e1) {
        let t;
        if ($785da19a645c07eb$var$Yc() && !$785da19a645c07eb$var$Jc()) t = new OffscreenCanvas(e1.width, e1.height).getContext("2d", {
            willReadFrequently: !0
        });
        else {
            let i = window.document.createElement("canvas");
            i.width = e1.width, i.height = e1.height, t = i.getContext("2d", {
                willReadFrequently: !0
            });
        }
        if (!t) throw Error("failed to create canvas 2d context");
        return t.drawImage(e1, 0, 0, e1.width, e1.height), t;
    },
    resolveURL: (e1)=>($785da19a645c07eb$var$$M ||= document.createElement("a"), $785da19a645c07eb$var$$M.href = e1, $785da19a645c07eb$var$$M.href),
    get hardwareConcurrency () {
        return typeof navigator < "u" && navigator.hardwareConcurrency || 4;
    },
    get prefersReducedMotion () {
        return void 0 === $785da19a645c07eb$var$tC ? !!matchMedia && ($785da19a645c07eb$var$eC ??= matchMedia("(prefers-reduced-motion: reduce)"), $785da19a645c07eb$var$eC.matches) : $785da19a645c07eb$var$tC;
    },
    set prefersReducedMotion (e){
        $785da19a645c07eb$var$tC = e;
    }
}, $785da19a645c07eb$var$nC = new class {
    constructor(){
        this._frozenAt = null;
    }
    getCurrentTime() {
        return null === this._frozenAt ? performance.now() : this._frozenAt;
    }
    setNow(e1) {
        this._frozenAt = e1;
    }
    restoreNow() {
        this._frozenAt = null;
    }
    isFrozen() {
        return null !== this._frozenAt;
    }
};
function $785da19a645c07eb$var$aC() {
    return $785da19a645c07eb$var$nC.getCurrentTime();
}
var $785da19a645c07eb$var$rC = class e1 {
    static{
        this.docStyle = typeof window < "u" && window.document?.documentElement.style;
    }
    static{
        this.selectProp = !e1.docStyle || "userSelect" in e1.docStyle ? "userSelect" : "webkitUserSelect";
    }
    static create(e1, t, i) {
        let n = window.document.createElement(e1);
        return void 0 !== t && (n.className = t), i && i.appendChild(n), n;
    }
    static createNS(e1, t) {
        return window.document.createElementNS(e1, t);
    }
    static disableDrag() {
        e1.docStyle && e1.selectProp && (e1.userSelect = e1.docStyle[e1.selectProp], e1.docStyle[e1.selectProp] = "none");
    }
    static enableDrag() {
        e1.docStyle && e1.selectProp && (e1.docStyle[e1.selectProp] = e1.userSelect);
    }
    static suppressClickInternal(t) {
        t.preventDefault(), t.stopPropagation(), window.removeEventListener("click", e1.suppressClickInternal, !0);
    }
    static suppressClick() {
        window.addEventListener("click", e1.suppressClickInternal, !0), window.setTimeout(()=>{
            window.removeEventListener("click", e1.suppressClickInternal, !0);
        }, 0);
    }
    static getScale(e1) {
        let t = e1.getBoundingClientRect();
        return {
            x: t.width / e1.offsetWidth || 1,
            y: t.height / e1.offsetHeight || 1,
            boundingClientRect: t
        };
    }
    static getPoint(e1, t, i) {
        let n = t.boundingClientRect;
        return new $785da19a645c07eb$var$Kc((i.clientX - n.left) / t.x - e1.clientLeft, (i.clientY - n.top) / t.y - e1.clientTop);
    }
    static mousePos(t, i) {
        let n = e1.getScale(t);
        return e1.getPoint(t, n, i);
    }
    static touchPos(t, i) {
        let n = [], a = e1.getScale(t);
        for (let r of i)n.push(e1.getPoint(t, a, r));
        return n;
    }
    static sanitize(t) {
        let i = (new DOMParser).parseFromString(t, "text/html").body || document.createElement("body"), n = i.querySelectorAll("script, iframe");
        for (let e1 of n)e1.remove();
        return e1.clean(i), i.innerHTML;
    }
    static isPossiblyDangerous(e1, t) {
        let i = t.replace(/\s+/g, "").toLowerCase();
        if ([
            "src",
            "href",
            "xlink:href"
        ].includes(e1) && (i.includes("javascript:") || i.includes("data:")) || "srcdoc" === e1 || e1.startsWith("on")) return !0;
    }
    static clean(t) {
        let i = t.children;
        for (let t of i)e1.removeAttributes(t), e1.clean(t);
    }
    static removeAttributes(t) {
        for (let { name: i, value: n } of Array.from(t.attributes))e1.isPossiblyDangerous(i, n) && t.removeAttribute(i);
    }
};
let $785da19a645c07eb$var$sC;
(function(e1) {
    let t, i, n, a;
    e1.resetRequestQueue = ()=>{
        t = [], i = 0, n = 0, a = {};
    }, e1.addThrottleControl = (e1)=>{
        let t = n++;
        return a[t] = e1, t;
    }, e1.removeThrottleControl = (e1)=>{
        delete a[e1], o();
    };
    e1.transformAndGetImage = async function(e1, t, i, n, a = !0, r) {
        let s = await e1.transformRequest(t, i);
        return $785da19a645c07eb$var$Gh(n.signal), $785da19a645c07eb$var$sC.getImage(s, n, a, r);
    }, e1.getImage = (e1, i, n = !0, a)=>new Promise((r, s)=>{
            e1.headers ||= {}, e1.headers.accept = "image/webp,*/*", $785da19a645c07eb$var$hh(e1, {
                type: "image"
            });
            let l = {
                abortController: i,
                requestParameters: e1,
                supportImageRefresh: n,
                imageBitmapOptions: a,
                state: "queued",
                onError: (e1)=>{
                    s(e1);
                },
                onSuccess: (e1)=>{
                    r(e1);
                }
            };
            t.push(l), o();
        });
    let r = (e1, t)=>"function" == typeof createImageBitmap ? (async (e1, t)=>{
            let i = new Blob([
                new Uint8Array(e1)
            ], {
                type: "image/png"
            });
            try {
                return createImageBitmap(i, t);
            } catch (e1) {
                throw Error(`Could not load image because of ${$785da19a645c07eb$var$Gu(e1).message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
            }
        })(e1, t) : ((e1)=>new Promise((t, i)=>{
                let n = new Image;
                n.onload = ()=>{
                    t(n), URL.revokeObjectURL(n.src), n.onload = null, window.requestAnimationFrame(()=>n.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=");
                }, n.onerror = ()=>i(Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                let a = new Blob([
                    new Uint8Array(e1)
                ], {
                    type: "image/png"
                });
                n.src = URL.createObjectURL(a);
            }))(e1), s = async (e1)=>{
        e1.state = "running";
        let { requestParameters: t, supportImageRefresh: n, imageBitmapOptions: a, onError: s, onSuccess: c, abortController: u } = e1, h = !1 === n && !a && !$785da19a645c07eb$var$kh(self) && !$785da19a645c07eb$var$Wh(t.url) && (!t.headers || Object.keys(t.headers).reduce((e1, t)=>e1 && "accept" === t, !0));
        i++;
        let d = h ? l(t, u) : $785da19a645c07eb$var$Yh(t, u);
        try {
            let t = await d;
            delete e1.abortController, e1.state = "completed", t.data instanceof HTMLImageElement || $785da19a645c07eb$var$Mh(t.data) ? c(t) : t.data && 0 !== t.data.byteLength ? c({
                data: await r(t.data, a),
                cacheControl: t.cacheControl,
                expires: t.expires
            }) : c({
                data: null,
                cacheControl: t.cacheControl,
                expires: t.expires
            });
        } catch (t) {
            delete e1.abortController, s($785da19a645c07eb$var$Gu(t));
        } finally{
            i--, o();
        }
    }, o = ()=>{
        let e1 = (()=>{
            for (let e1 of Object.keys(a))if (a[e1]()) return !0;
            return !1;
        })() ? $785da19a645c07eb$var$Hh.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : $785da19a645c07eb$var$Hh.MAX_PARALLEL_IMAGE_REQUESTS;
        for(let n = i; n < e1 && t.length > 0; n++){
            let e1 = t.shift();
            e1.abortController.signal.aborted ? n-- : s(e1);
        }
    }, l = (e1, t)=>new Promise((i, n)=>{
            let a = new Image, r = e1.url, s = e1.credentials;
            s && "include" === s ? a.crossOrigin = "use-credentials" : (s && "same-origin" === s || !$785da19a645c07eb$var$ed(r)) && (a.crossOrigin = "anonymous"), t.signal.addEventListener("abort", ()=>{
                a.src = "", n(new $785da19a645c07eb$var$Vh(t.signal.reason));
            }), a.fetchPriority = "high", a.onload = ()=>{
                a.onerror = a.onload = null, i({
                    data: a
                });
            }, a.onerror = ()=>{
                a.onerror = a.onload = null, !t.signal.aborted && n(Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
            }, a.src = r;
        });
})($785da19a645c07eb$var$sC ||= {}), $785da19a645c07eb$var$sC.resetRequestQueue();
var $785da19a645c07eb$var$oC = class {
    constructor(e1){
        this._transformRequestFn = e1 ?? null;
    }
    transformRequest(e1, t) {
        return this._transformRequestFn && this._transformRequestFn(e1, t) || {
            url: e1
        };
    }
    setTransformRequest(e1) {
        this._transformRequestFn = e1;
    }
}, $785da19a645c07eb$var$lC = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$cC = class extends $785da19a645c07eb$var$lC {
}, $785da19a645c07eb$var$uC = class extends $785da19a645c07eb$var$lC {
    constructor(e1 = {}){
        super("style.load", e1);
    }
}, $785da19a645c07eb$var$hC = class extends $785da19a645c07eb$var$lC {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = "style";
    }
}, $785da19a645c07eb$var$dC = class extends $785da19a645c07eb$var$lC {
    constructor(e1, t = {}){
        super(e1, t), this.dataType = "source";
    }
}, $785da19a645c07eb$var$pC = class extends $785da19a645c07eb$var$lC {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, i, n = {}){
        i = i instanceof MouseEvent ? i : new MouseEvent(e1, i);
        let a = $785da19a645c07eb$var$rC.mousePos(t.getCanvas(), i);
        super(e1, $785da19a645c07eb$var$hh({
            point: a,
            lngLat: t.unproject(a),
            originalEvent: i
        }, n)), this._defaultPrevented = !1, this.target = t;
    }
}, $785da19a645c07eb$var$mC = class extends $785da19a645c07eb$var$lC {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t, i){
        let n = "touchend" === e1 ? i.changedTouches : i.touches, a = $785da19a645c07eb$var$rC.touchPos(t.getCanvasContainer(), n), r = a.map((e1)=>t.unproject(e1)), s = a.reduce((e1, t, i, n)=>e1.add(t.div(n.length)), new $785da19a645c07eb$var$Kc(0, 0));
        super(e1, {
            points: a,
            point: s,
            lngLats: r,
            lngLat: t.unproject(s),
            originalEvent: i
        }), this._defaultPrevented = !1;
    }
}, $785da19a645c07eb$var$gC = class extends $785da19a645c07eb$var$lC {
    preventDefault() {
        this._defaultPrevented = !0;
    }
    get defaultPrevented() {
        return this._defaultPrevented;
    }
    constructor(e1, t){
        super("wheel", {
            originalEvent: t
        }), this._defaultPrevented = !1;
    }
}, $785da19a645c07eb$var$fC = class extends $785da19a645c07eb$var$lC {
}, $785da19a645c07eb$var$AC = class extends $785da19a645c07eb$var$lC {
    constructor(e1 = {}){
        super("terrain", e1);
    }
}, $785da19a645c07eb$var$_C = class extends $785da19a645c07eb$var$lC {
    constructor(e1 = {}){
        super("projectiontransition", e1);
    }
}, $785da19a645c07eb$var$vC = class extends $785da19a645c07eb$var$lC {
}, $785da19a645c07eb$var$yC = class extends $785da19a645c07eb$var$lC {
    constructor(e1 = {}){
        super("styleimagemissing", e1);
    }
};
function $785da19a645c07eb$var$xC(e1, t) {
    let i = {};
    for(let t in e1)"ref" !== t && (i[t] = e1[t]);
    return $785da19a645c07eb$var$ld.forEach((e1)=>{
        e1 in t && (i[e1] = t[e1]);
    }), i;
}
function $785da19a645c07eb$var$bC(e1) {
    e1 = e1.slice();
    let t = Object.create(null);
    for(let i = 0; i < e1.length; i++)t[e1[i].id] = e1[i];
    for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = $785da19a645c07eb$var$xC(e1[i], t[e1[i].ref]));
    return e1;
}
function $785da19a645c07eb$var$wC(e1, t) {
    if (Array.isArray(e1)) {
        if (!Array.isArray(t) || e1.length !== t.length) return !1;
        for(let i = 0; i < e1.length; i++)if (!$785da19a645c07eb$var$wC(e1[i], t[i])) return !1;
        return !0;
    }
    if ("object" == typeof e1 && e1 && null !== t) {
        if ("object" != typeof t || Object.keys(e1).length !== Object.keys(t).length) return !1;
        for(let i in e1)if (!$785da19a645c07eb$var$wC(e1[i], t[i])) return !1;
        return !0;
    }
    return e1 === t;
}
function $785da19a645c07eb$var$EC(e1, t) {
    e1.push(t);
}
function $785da19a645c07eb$var$kC(e1, t, i) {
    $785da19a645c07eb$var$EC(i, {
        command: "addSource",
        args: [
            e1,
            t[e1]
        ]
    });
}
function $785da19a645c07eb$var$SC(e1, t, i) {
    $785da19a645c07eb$var$EC(t, {
        command: "removeSource",
        args: [
            e1
        ]
    }), i[e1] = !0;
}
function $785da19a645c07eb$var$MC(e1, t, i, n) {
    $785da19a645c07eb$var$SC(e1, i, n), $785da19a645c07eb$var$kC(e1, t, i);
}
function $785da19a645c07eb$var$CC(e1, t, i) {
    let n;
    for(n in e1[i])if (Object.prototype.hasOwnProperty.call(e1[i], n) && "data" !== n && !$785da19a645c07eb$var$wC(e1[i][n], t[i][n])) return !1;
    for(n in t[i])if (Object.prototype.hasOwnProperty.call(t[i], n) && "data" !== n && !$785da19a645c07eb$var$wC(e1[i][n], t[i][n])) return !1;
    return !0;
}
function $785da19a645c07eb$var$TC(e1, t, i, n, a, r) {
    e1 ||= {}, t ||= {};
    for(let s in e1)Object.prototype.hasOwnProperty.call(e1, s) && ($785da19a645c07eb$var$wC(e1[s], t[s]) || i.push({
        command: r,
        args: [
            n,
            s,
            t[s],
            a
        ]
    }));
    for(let s in t)Object.prototype.hasOwnProperty.call(t, s) && !Object.prototype.hasOwnProperty.call(e1, s) && ($785da19a645c07eb$var$wC(e1[s], t[s]) || i.push({
        command: r,
        args: [
            n,
            s,
            t[s],
            a
        ]
    }));
}
function $785da19a645c07eb$var$DC(e1) {
    return e1.id;
}
function $785da19a645c07eb$var$PC(e1, t) {
    return e1[t.id] = t, e1;
}
function $785da19a645c07eb$var$IC(e1, t) {
    if (!e1) return [
        {
            command: "setStyle",
            args: [
                t
            ]
        }
    ];
    let i = [];
    try {
        if (!$785da19a645c07eb$var$wC(e1.version, t.version)) return [
            {
                command: "setStyle",
                args: [
                    t
                ]
            }
        ];
        $785da19a645c07eb$var$wC(e1.center, t.center) || i.push({
            command: "setCenter",
            args: [
                t.center
            ]
        }), $785da19a645c07eb$var$wC(e1.state, t.state) || i.push({
            command: "setGlobalState",
            args: [
                t.state
            ]
        }), $785da19a645c07eb$var$wC(e1.centerAltitude, t.centerAltitude) || i.push({
            command: "setCenterAltitude",
            args: [
                t.centerAltitude
            ]
        }), $785da19a645c07eb$var$wC(e1.zoom, t.zoom) || i.push({
            command: "setZoom",
            args: [
                t.zoom
            ]
        }), $785da19a645c07eb$var$wC(e1.bearing, t.bearing) || i.push({
            command: "setBearing",
            args: [
                t.bearing
            ]
        }), $785da19a645c07eb$var$wC(e1.pitch, t.pitch) || i.push({
            command: "setPitch",
            args: [
                t.pitch
            ]
        }), $785da19a645c07eb$var$wC(e1.roll, t.roll) || i.push({
            command: "setRoll",
            args: [
                t.roll
            ]
        }), $785da19a645c07eb$var$wC(e1.sprite, t.sprite) || i.push({
            command: "setSprite",
            args: [
                t.sprite
            ]
        }), $785da19a645c07eb$var$wC(e1.glyphs, t.glyphs) || i.push({
            command: "setGlyphs",
            args: [
                t.glyphs
            ]
        }), $785da19a645c07eb$var$wC(e1["font-faces"], t["font-faces"]) || i.push({
            command: "setFontFaces",
            args: [
                t["font-faces"]
            ]
        }), $785da19a645c07eb$var$wC(e1.transition, t.transition) || i.push({
            command: "setTransition",
            args: [
                t.transition
            ]
        }), $785da19a645c07eb$var$wC(e1.light, t.light) || i.push({
            command: "setLight",
            args: [
                t.light
            ]
        }), $785da19a645c07eb$var$wC(e1.terrain, t.terrain) || i.push({
            command: "setTerrain",
            args: [
                t.terrain
            ]
        }), $785da19a645c07eb$var$wC(e1.sky, t.sky) || i.push({
            command: "setSky",
            args: [
                t.sky
            ]
        }), $785da19a645c07eb$var$wC(e1.projection, t.projection) || i.push({
            command: "setProjection",
            args: [
                t.projection
            ]
        });
        let n = {}, a = [];
        !function(e1, t, i, n) {
            let a;
            for(a in e1 ||= {}, t ||= {}, e1)Object.prototype.hasOwnProperty.call(e1, a) && (Object.prototype.hasOwnProperty.call(t, a) || $785da19a645c07eb$var$SC(a, i, n));
            for(a in t)Object.prototype.hasOwnProperty.call(t, a) && (Object.prototype.hasOwnProperty.call(e1, a) ? $785da19a645c07eb$var$wC(e1[a], t[a]) || ("geojson" === e1[a].type && "geojson" === t[a].type && $785da19a645c07eb$var$CC(e1, t, a) ? $785da19a645c07eb$var$EC(i, {
                command: "setGeoJSONSourceData",
                args: [
                    a,
                    t[a].data
                ]
            }) : $785da19a645c07eb$var$MC(a, t, i, n)) : $785da19a645c07eb$var$kC(a, t, i));
        }(e1.sources, t.sources, a, n);
        let r = [];
        e1.layers && e1.layers.forEach((e1)=>{
            "source" in e1 && n[e1.source] ? i.push({
                command: "removeLayer",
                args: [
                    e1.id
                ]
            }) : r.push(e1);
        }), i = i.concat(a), function(e1, t, i) {
            e1 ||= [], t ||= [];
            let n, a, r, s, o, l = e1.map($785da19a645c07eb$var$DC), c = t.map($785da19a645c07eb$var$DC), u = e1.reduce($785da19a645c07eb$var$PC, {}), h = t.reduce($785da19a645c07eb$var$PC, {}), d = l.slice(), p = Object.create(null);
            for(let e1 = 0, t = 0; e1 < l.length; e1++)n = l[e1], Object.prototype.hasOwnProperty.call(h, n) ? t++ : ($785da19a645c07eb$var$EC(i, {
                command: "removeLayer",
                args: [
                    n
                ]
            }), d.splice(d.indexOf(n, t), 1));
            for(let e1 = 0, t = 0; e1 < c.length; e1++)n = c[c.length - 1 - e1], d[d.length - 1 - e1] !== n && (Object.prototype.hasOwnProperty.call(u, n) ? ($785da19a645c07eb$var$EC(i, {
                command: "removeLayer",
                args: [
                    n
                ]
            }), d.splice(d.lastIndexOf(n, d.length - t), 1)) : t++, s = d[d.length - e1], $785da19a645c07eb$var$EC(i, {
                command: "addLayer",
                args: [
                    h[n],
                    s
                ]
            }), d.splice(d.length - e1, 0, n), p[n] = !0);
            for(let e1 = 0; e1 < c.length; e1++)if (n = c[e1], a = u[n], r = h[n], !p[n] && !$785da19a645c07eb$var$wC(a, r)) {
                if (!$785da19a645c07eb$var$wC(a.source, r.source) || !$785da19a645c07eb$var$wC(a["source-layer"], r["source-layer"]) || !$785da19a645c07eb$var$wC(a.type, r.type)) {
                    $785da19a645c07eb$var$EC(i, {
                        command: "removeLayer",
                        args: [
                            n
                        ]
                    }), s = d[d.lastIndexOf(n) + 1], $785da19a645c07eb$var$EC(i, {
                        command: "addLayer",
                        args: [
                            r,
                            s
                        ]
                    });
                    continue;
                }
                for(o in $785da19a645c07eb$var$TC(a.layout, r.layout, i, n, null, "setLayoutProperty"), $785da19a645c07eb$var$TC(a.paint, r.paint, i, n, null, "setPaintProperty"), $785da19a645c07eb$var$wC(a.filter, r.filter) || $785da19a645c07eb$var$EC(i, {
                    command: "setFilter",
                    args: [
                        n,
                        r.filter
                    ]
                }), (!$785da19a645c07eb$var$wC(a.minzoom, r.minzoom) || !$785da19a645c07eb$var$wC(a.maxzoom, r.maxzoom)) && $785da19a645c07eb$var$EC(i, {
                    command: "setLayerZoomRange",
                    args: [
                        n,
                        r.minzoom,
                        r.maxzoom
                    ]
                }), a)Object.prototype.hasOwnProperty.call(a, o) && "layout" !== o && "paint" !== o && "filter" !== o && "metadata" !== o && "minzoom" !== o && "maxzoom" !== o && (0 === o.indexOf("paint.") ? $785da19a645c07eb$var$TC(a[o], r[o], i, n, o.slice(6), "setPaintProperty") : $785da19a645c07eb$var$wC(a[o], r[o]) || $785da19a645c07eb$var$EC(i, {
                    command: "setLayerProperty",
                    args: [
                        n,
                        o,
                        r[o]
                    ]
                }));
                for(o in r)Object.prototype.hasOwnProperty.call(r, o) && !Object.prototype.hasOwnProperty.call(a, o) && "layout" !== o && "paint" !== o && "filter" !== o && "metadata" !== o && "minzoom" !== o && "maxzoom" !== o && (0 === o.indexOf("paint.") ? $785da19a645c07eb$var$TC(a[o], r[o], i, n, o.slice(6), "setPaintProperty") : $785da19a645c07eb$var$wC(a[o], r[o]) || $785da19a645c07eb$var$EC(i, {
                    command: "setLayerProperty",
                    args: [
                        n,
                        o,
                        r[o]
                    ]
                }));
            }
        }(r, t.layers, i);
    } catch (e1) {
        console.warn("Unable to compute style diff:", e1), i = [
            {
                command: "setStyle",
                args: [
                    t
                ]
            }
        ];
    }
    return i;
}
function $785da19a645c07eb$var$FC(e1) {
    let t = [];
    if ("string" == typeof e1) t.push({
        id: "default",
        url: e1
    });
    else if (e1 && e1.length > 0) {
        let i = [];
        for (let { id: n, url: a } of e1){
            let e1 = `${n}${a}`;
            i.includes(e1) || (i.push(e1), t.push({
                id: n,
                url: a
            }));
        }
    }
    return t;
}
function $785da19a645c07eb$var$zC(e1, t, i) {
    try {
        let n = new URL(e1);
        return n.pathname += `${t}${i}`, n.toString();
    } catch  {
        throw Error(`Invalid sprite URL "${e1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
    }
}
async function $785da19a645c07eb$var$RC(e1, t, i, n) {
    let a = $785da19a645c07eb$var$FC(e1), r = i > 1 ? "@2x" : "", s = {}, o = {};
    for (let { id: e1, url: i } of a){
        let a = await t.transformRequest($785da19a645c07eb$var$zC(i, r, ".json"), "SpriteJSON");
        s[e1] = $785da19a645c07eb$var$Jh(a, n);
        let l = await t.transformRequest($785da19a645c07eb$var$zC(i, r, ".png"), "SpriteImage");
        o[e1] = $785da19a645c07eb$var$sC.getImage(l, n);
    }
    return await Promise.all([
        ...Object.values(s),
        ...Object.values(o)
    ]), async function(e1, t) {
        let i = {};
        for(let n in e1){
            i[n] = {};
            let a = (await t[n]).data;
            if (!a) throw Error(`Could not load sprite image for ${n}: the response is empty`);
            let r = $785da19a645c07eb$var$iC.getImageCanvasContext(a), s = (await e1[n]).data;
            for(let e1 in s){
                let { width: t, height: a, x: o, y: l, sdf: c, pixelRatio: u, stretchX: h, stretchY: d, content: p, textFitWidth: m, textFitHeight: g } = s[e1], f = {
                    width: t,
                    height: a,
                    x: o,
                    y: l,
                    context: r
                };
                i[n][e1] = {
                    data: null,
                    pixelRatio: u,
                    sdf: c,
                    stretchX: h,
                    stretchY: d,
                    content: p,
                    textFitWidth: m,
                    textFitHeight: g,
                    spriteData: f
                };
            }
        }
        return i;
    }(s, o);
}
var $785da19a645c07eb$var$LC = class extends $785da19a645c07eb$var$rd {
    constructor(){
        super(), this.images = {}, this.updateVersion = 0, this.loaded = !1, this.requestors = [], this.missingImageResolver = null, this._spriteImagesIds = {}, this._imagesIds = null, this._renderCallbacksDispatchedThisFrame = {};
    }
    destroy() {
        for (let e1 of Object.keys(this.images))this.removeImage(e1);
        this._spriteImagesIds = {};
    }
    isLoaded() {
        return this.loaded;
    }
    setLoaded(e1) {
        if (this.loaded !== e1 && (this.loaded = e1, e1)) {
            for (let { ids: e1, promiseResolve: t } of this.requestors)t(this._getImagesForIds(e1));
            this.requestors = [];
        }
    }
    getImage(e1) {
        let t = this.images[e1];
        if (t && !t.data && t.spriteData) {
            let e1 = t.spriteData;
            t.data = new $785da19a645c07eb$var$Kv({
                width: e1.width,
                height: e1.height
            }, e1.context.getImageData(e1.x, e1.y, e1.width, e1.height).data), t.spriteData = null;
        }
        return t;
    }
    addImage(e1, t) {
        if (this.images[e1]) throw Error(`Image id ${e1} already exist, use updateImage instead`);
        this._validate(e1, t) && (this.images[e1] = t, this._imagesIds = null, t.isWebGLImage && this.updateImage(e1, t, !1));
    }
    _validate(e1, t) {
        let i = !0, n = t.data || t.spriteData;
        return this._validateStretch(t.stretchX, n?.width) || (this.fire(new $785da19a645c07eb$var$ad(Error(`Image "${e1}" has invalid "stretchX" value`))), i = !1), this._validateStretch(t.stretchY, n?.height) || (this.fire(new $785da19a645c07eb$var$ad(Error(`Image "${e1}" has invalid "stretchY" value`))), i = !1), this._validateContent(t.content, t) || (this.fire(new $785da19a645c07eb$var$ad(Error(`Image "${e1}" has invalid "content" value`))), i = !1), i;
    }
    _validateStretch(e1, t) {
        if (!e1) return !0;
        let i = 0;
        for (let n of e1){
            if (n[0] < i || n[1] < n[0] || t < n[1]) return !1;
            i = n[1];
        }
        return !0;
    }
    _validateContent(e1, t) {
        if (!e1) return !0;
        if (4 !== e1.length) return !1;
        let i = t.spriteData, n = i?.width || t.data.width, a = i?.height || t.data.height;
        return !(e1[0] < 0 || n < e1[0] || e1[1] < 0 || a < e1[1] || e1[2] < 0 || n < e1[2] || e1[3] < 0 || a < e1[3] || e1[2] < e1[0]) && e1[3] >= e1[1];
    }
    updateImage(e1, t, i = !0) {
        let n = this.images[e1];
        if (i) {
            let e1 = n.data || n.spriteData;
            if (e1.width !== t.data.width || e1.height !== t.data.height) throw Error(`size mismatch between old image (${e1.width}x${e1.height}) and new image (${t.data.width}x${t.data.height}).`);
        }
        t.version = (n.version ?? 0) + 1, this.images[e1] = t, this.updateVersion++;
    }
    removeImage(e1) {
        let t = this.images[e1];
        t && (delete this.images[e1], this._imagesIds = null, t.userImage?.onRemove && t.userImage.onRemove());
    }
    listImages() {
        return this._imagesIds ??= Object.keys(this.images), this._imagesIds;
    }
    _getSpriteImageId(e1, t) {
        return "default" === e1 ? t : `${e1}:${t}`;
    }
    setSpriteImages(e1, t) {
        let i = this._spriteImagesIds[e1] ?? [], n = [];
        for(let i in t){
            let a = this._getSpriteImageId(e1, i);
            n.push(a), a in this.images ? this.updateImage(a, t[i], !1) : this.addImage(a, t[i]);
        }
        let a = new Set(n), r = i.filter((e1)=>!a.has(e1));
        for (let e1 of r)this.removeImage(e1);
        return this._spriteImagesIds[e1] = n, {
            loaded: n,
            removed: r
        };
    }
    removeSpriteImages(e1) {
        let t = this._spriteImagesIds[e1] ?? [];
        for (let e1 of t)this.removeImage(e1);
        return delete this._spriteImagesIds[e1], t;
    }
    removeAllSpriteImages() {
        let e1 = Object.values(this._spriteImagesIds).flat();
        for (let t of e1)this.removeImage(t);
        return this._spriteImagesIds = {}, e1;
    }
    setMissingImageResolver(e1) {
        this.missingImageResolver = e1;
    }
    getImages(e1) {
        return new Promise((t, i)=>{
            let n = !0;
            if (!this.isLoaded()) for (let t of e1)this.images[t] || (n = !1);
            this.isLoaded() || n ? t(this._getImagesForIds(e1)) : this.requestors.push({
                ids: e1,
                promiseResolve: t
            });
        });
    }
    async _getImagesForIds(e1) {
        let t = new Set(e1.filter((e1)=>!this.getImage(e1))), i = this.missingImageResolver;
        i && await Promise.allSettled(Array.from(t, (e1)=>i(e1)));
        let n = {};
        for (let i of e1){
            let e1 = this.getImage(i);
            e1 && (t.delete(i), n[i] = {
                data: e1.data.clone(),
                pixelRatio: e1.pixelRatio,
                sdf: e1.sdf,
                version: e1.version,
                stretchX: e1.stretchX,
                stretchY: e1.stretchY,
                content: e1.content,
                textFitWidth: e1.textFitWidth,
                textFitHeight: e1.textFitHeight,
                hasRenderCallback: !!e1.userImage?.render,
                isWebGLImage: e1.isWebGLImage
            });
        }
        for (let e1 of t)this.fire(new $785da19a645c07eb$var$yC({
            id: e1
        })), $785da19a645c07eb$var$wh(`Image "${e1}" could not be loaded. Please make sure you have added the image before it is needed with map.addImage(), resolved it with map.setMissingStyleImageResolver(), or included it in a "sprite" property in your style.`);
        return n;
    }
    beginFrame() {
        this._renderCallbacksDispatchedThisFrame = {};
    }
    dispatchRenderCallbacks(e1) {
        for (let t of e1){
            if (this._renderCallbacksDispatchedThisFrame[t]) continue;
            this._renderCallbacksDispatchedThisFrame[t] = !0;
            let e1 = this.getImage(t);
            e1 || $785da19a645c07eb$var$wh(`Image with ID: "${t}" was not found`), $785da19a645c07eb$var$xw(e1) && this.updateImage(t, e1);
        }
    }
    cloneImages() {
        let e1 = {};
        for(let t in this.images){
            let i = this.images[t];
            e1[t] = {
                ...i,
                data: i.data ? i.data.clone() : null
            };
        }
        return e1;
    }
}, $785da19a645c07eb$var$BC = class {
    constructor(e1){
        this._imageManager = e1, this._entries = {}, this._image = new $785da19a645c07eb$var$Kv({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    destroy() {
        this._texture &&= (this._texture.destroy(), null), this._entries = {}, this._image = new $785da19a645c07eb$var$Kv({
            width: 1,
            height: 1
        }), this._dirty = !0;
    }
    getPixelSize() {
        let { width: e1, height: t } = this._image;
        return {
            width: e1,
            height: t
        };
    }
    getPattern(e1) {
        let t = this._imageManager.getImage(e1);
        if (!t) return null;
        let i = this._entries[e1];
        if (i?.image !== t) {
            let i = {
                w: t.data.width + 2,
                h: t.data.height + 2,
                x: 0,
                y: 0
            };
            this._entries[e1] = {
                bin: i,
                position: new $785da19a645c07eb$var$ww(i, t),
                image: t
            };
        } else {
            if (i.position.version === t.version) return i.position;
            i.position.version = t.version;
        }
        return this._update(), this._entries[e1].position;
    }
    bind(e1) {
        let t = e1.gl;
        this._texture ? this._dirty &&= (this._texture.update(this._image), !1) : (this._texture = new $785da19a645c07eb$var$ry(e1, this._image, t.RGBA), this._dirty = !1), this._texture.bind(t.LINEAR, t.CLAMP_TO_EDGE);
    }
    _update() {
        for(let e1 in this._entries)this._imageManager.getImage(e1) || delete this._entries[e1];
        let e1 = [];
        for(let t in this._entries)e1.push(this._entries[t].bin);
        let { w: t, h: i } = $785da19a645c07eb$var$bw(e1), n = this._image;
        n.resize({
            width: t || 1,
            height: i || 1
        });
        for(let e1 in this._entries){
            let { bin: t } = this._entries[e1], i = t.x + 1, a = t.y + 1, r = this._entries[e1].image.data, s = r.width, o = r.height;
            $785da19a645c07eb$var$Kv.copy(r, n, {
                x: 0,
                y: 0
            }, {
                x: i,
                y: a
            }, {
                width: s,
                height: o
            }), $785da19a645c07eb$var$Kv.copy(r, n, {
                x: 0,
                y: o - 1
            }, {
                x: i,
                y: a - 1
            }, {
                width: s,
                height: 1
            }), $785da19a645c07eb$var$Kv.copy(r, n, {
                x: 0,
                y: 0
            }, {
                x: i,
                y: a + o
            }, {
                width: s,
                height: 1
            }), $785da19a645c07eb$var$Kv.copy(r, n, {
                x: s - 1,
                y: 0
            }, {
                x: i - 1,
                y: a
            }, {
                width: 1,
                height: o
            }), $785da19a645c07eb$var$Kv.copy(r, n, {
                x: 0,
                y: 0
            }, {
                x: i + s,
                y: a
            }, {
                width: 1,
                height: o
            });
        }
        this._dirty = !0;
    }
};
const $785da19a645c07eb$var$OC = 1114111, $785da19a645c07eb$var$UC = {
    start: 0,
    end: $785da19a645c07eb$var$OC
};
let $785da19a645c07eb$var$NC = 0;
function $785da19a645c07eb$var$jC(e1) {
    let t = /^u\+([0-9a-f]*)(\?+)$/i.exec(e1);
    if (t) {
        let [, e1, i] = t;
        return e1.length + i.length > 6 ? null : $785da19a645c07eb$var$VC(parseInt(`${e1}${"0".repeat(i.length)}`, 16), parseInt(`${e1}${"f".repeat(i.length)}`, 16));
    }
    let i = /^u\+([0-9a-f]{1,6})(?:-([0-9a-f]{1,6}))?$/i.exec(e1);
    if (!i) return null;
    let n = parseInt(i[1], 16);
    return $785da19a645c07eb$var$VC(n, void 0 === i[2] ? n : parseInt(i[2], 16));
}
function $785da19a645c07eb$var$VC(e1, t) {
    return e1 > t || e1 > $785da19a645c07eb$var$OC ? null : {
        start: e1,
        end: Math.min(t, $785da19a645c07eb$var$OC)
    };
}
function $785da19a645c07eb$var$qC(e1, t) {
    return e1.ranges.some(({ start: e1, end: i })=>t >= e1 && t <= i);
}
var $785da19a645c07eb$var$GC = class {
    constructor(e1){
        this.requestManager = e1, this._faces = {}, this._registered = new Set;
    }
    setFontFaces(e1) {
        this._unregisterAll(), this._faces = {};
        for (let [t, i] of Object.entries(e1 ?? {})){
            let e1 = Array.isArray(i) ? i : [
                i
            ];
            this._faces[t] = e1.map((e1)=>this._declareFontFace(t, e1)).filter((e1)=>null !== e1);
        }
    }
    hasFontFaces() {
        return Object.keys(this._faces).length > 0;
    }
    async getFontFamily(e1, t) {
        for (let i of e1.split(","))for (let e1 of this._faces[i.trim()] ?? [])if ($785da19a645c07eb$var$qC(e1, t) && (e1.loaded ??= this._loadFontFace(e1), await e1.loaded)) return e1.family;
        return null;
    }
    _declareFontFace(e1, t) {
        let i = "string" == typeof t ? {
            url: t
        } : t;
        if ("string" != typeof i?.url) return $785da19a645c07eb$var$wh(`Ignoring the font face declared for "${e1}": it has no URL.`), null;
        let n = "maplibre-gl-font-face-" + $785da19a645c07eb$var$NC++, a = i["unicode-range"];
        if (!a?.length) return {
            url: i.url,
            ranges: [
                $785da19a645c07eb$var$UC
            ],
            family: n
        };
        let r = [];
        for (let e1 of a){
            let t = $785da19a645c07eb$var$jC(e1);
            t ? r.push(t) : $785da19a645c07eb$var$wh(`Ignoring the unicode range "${e1}" of the font face at ${i.url}: it is not a valid range.`);
        }
        return r.length ? {
            url: i.url,
            ranges: r,
            family: n
        } : null;
    }
    async _loadFontFace(e1) {
        if (typeof FontFace > "u" || typeof document > "u" || !document.fonts) return $785da19a645c07eb$var$wh(`Ignoring the font face at ${e1.url}: this environment has no CSS Font Loading API.`), !1;
        let t;
        try {
            return t = new FontFace(e1.family, await this._downloadFontFile(e1.url)), !!Object.values(this._faces).some((t)=>t.includes(e1)) && (document.fonts.add(t), this._registered.add(t), await t.load(), !0);
        } catch (i) {
            return t && this._unregister(t), $785da19a645c07eb$var$wh(`Ignoring the font face at ${e1.url}: ${$785da19a645c07eb$var$Gu(i).message}`), !1;
        }
    }
    async _downloadFontFile(e1) {
        let t = await this.requestManager.transformRequest(e1, "Glyphs"), i = await $785da19a645c07eb$var$$h(t, new AbortController);
        if (!i?.data) throw Error(`the response was empty for the font file at ${e1}`);
        return i.data;
    }
    _unregister(e1) {
        document.fonts?.delete(e1), this._registered.delete(e1);
    }
    _unregisterAll() {
        for (let e1 of this._registered)document.fonts?.delete(e1);
        this._registered.clear();
    }
    destroy() {
        this._unregisterAll(), this._faces = {};
    }
};
const $785da19a645c07eb$var$HC = 1e20, $785da19a645c07eb$var$WC = new Float64Array(256);
for(let e1 = 0; e1 < 256; e1++){
    let t = .5 - (e1 / 255) ** (1 / 2.2);
    $785da19a645c07eb$var$WC[e1] = t * Math.abs(t);
}
$785da19a645c07eb$var$WC[255] = -100000000000000000000;
var $785da19a645c07eb$var$ZC = class {
    constructor({ fontSize: e1 = 24, buffer: t = 3, radius: i = 8, cutoff: n = .25, fontFamily: a = "sans-serif", fontWeight: r = "normal", fontStyle: s = "normal", lang: o = null } = {}){
        this.buffer = t, this.radius = i, this.cutoff = n, this.lang = o;
        let l = this.size = e1 + 4 * t, c = this._createCanvas(l), u = this.ctx = c.getContext("2d", {
            willReadFrequently: !0
        });
        u.font = `${s} ${r} ${e1}px ${a}`, u.textBaseline = "alphabetic", u.textAlign = "left", u.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
    }
    _createCanvas(e1) {
        if (typeof OffscreenCanvas < "u") return new OffscreenCanvas(e1, e1);
        let t = document.createElement("canvas");
        return t.width = t.height = e1, t;
    }
    draw(e1) {
        let { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: n, actualBoundingBoxLeft: a, actualBoundingBoxRight: r } = this.ctx.measureText(e1), s = Math.ceil(i), o = Math.floor(-a), l = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(r) - o)), c = Math.max(0, Math.min(this.size - this.buffer, s + Math.ceil(n))), u = l + 2 * this.buffer, h = c + 2 * this.buffer, d = Math.max(u * h, 0), p = new Uint8ClampedArray(d), m = {
            data: p,
            width: u,
            height: h,
            glyphWidth: l,
            glyphHeight: c,
            glyphTop: s,
            glyphLeft: o,
            glyphAdvance: t
        };
        if (0 === l || 0 === c) return m;
        let { ctx: g, buffer: f, gridInner: A, gridOuter: _ } = this;
        this.lang && (g.lang = this.lang), g.clearRect(f, f, l, c), g.fillText(e1, f - o, f + s);
        let v = g.getImageData(f, f, l, c);
        _.fill($785da19a645c07eb$var$HC, 0, d), A.fill(0, 0, d);
        let y = 3;
        for(let e1 = 0; e1 < c; e1++){
            let t = (e1 + f) * u + f;
            for(let e1 = 0; e1 < l; e1++, y += 4, t++){
                let e1 = v.data[y];
                if (0 === e1) continue;
                let i = $785da19a645c07eb$var$WC[e1];
                _[t] = Math.max(0, i), A[t] = Math.max(0, -i);
            }
        }
        $785da19a645c07eb$var$KC(_, 0, 0, u, h, u, this.f, this.v, this.z);
        let x = Math.min(f, 1);
        $785da19a645c07eb$var$KC(A, f - x, f - x, l + 2 * x, c + 2 * x, u, this.f, this.v, this.z);
        let b = 255 / this.radius, w = 255 * (1 - this.cutoff);
        for(let e1 = 0; e1 < d; e1++){
            let t = Math.sqrt(_[e1]) - Math.sqrt(A[e1]);
            p[e1] = Math.round(w - b * t);
        }
        return m;
    }
};
function $785da19a645c07eb$var$KC(e1, t, i, n, a, r, s, o, l) {
    for(let c = t; c < t + n; c++)$785da19a645c07eb$var$XC(e1, i * r + c, r, a, s, o, l);
    for(let c = i; c < i + a; c++)$785da19a645c07eb$var$XC(e1, c * r + t, 1, n, s, o, l);
}
function $785da19a645c07eb$var$XC(e1, t, i, n, a, r, s) {
    r[0] = 0, s[0] = -100000000000000000000, s[1] = $785da19a645c07eb$var$HC, a[0] = e1[t];
    for(let o = 1, l = 0, c = 0; o < n; o++){
        a[o] = e1[t + o * i];
        let n = o * o;
        do {
            let e1 = r[l];
            c = (a[o] - a[e1] + n - e1 * e1) / (o - e1) / 2;
        }while (c <= s[l] && --l > -1);
        l++, r[l] = o, s[l] = c, s[l + 1] = $785da19a645c07eb$var$HC;
    }
    for(let o = 0, l = 0; o < n; o++){
        for(; s[l + 1] < o;)l++;
        let n = r[l], c = o - n;
        e1[t + o * i] = a[n] + c * c;
    }
}
const $785da19a645c07eb$var$QC = $785da19a645c07eb$var$od.layout_symbol["text-font"].default.join(","), $785da19a645c07eb$var$YC = (e1, t)=>{
    let i = new $785da19a645c07eb$var$ZC(e1);
    return i.buffer = t, i;
};
var $785da19a645c07eb$var$JC = class {
    constructor(e1, t, i, n = $785da19a645c07eb$var$YC){
        this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = i, this.fontFaceManager = new $785da19a645c07eb$var$GC(e1), this.createRasterizer = n;
    }
    setURL(e1) {
        this.url = e1;
    }
    setFontFaces(e1) {
        this.fontFaceManager.setFontFaces(e1), this.entries = {};
    }
    async getGlyphs(e1) {
        let t = [];
        for(let i in e1)for (let n of e1[i])t.push(this._getAndCacheGlyphsPromise(i, n));
        let i = await Promise.all(t), n = {};
        for (let { stack: e1, id: t, glyph: a } of i)n[e1] ||= {}, n[e1][t] = a && {
            id: a.id,
            bitmap: a.bitmap.clone(),
            metrics: a.metrics
        };
        return n;
    }
    async _getAndCacheGlyphsPromise(e1, t) {
        this.entries[e1] ??= {
            glyphs: {},
            requests: {},
            ranges: {}
        };
        let i = this.entries[e1], n = i.glyphs[t];
        if (void 0 !== n) return {
            stack: e1,
            id: t,
            glyph: n
        };
        let a = t.codePointAt(0), r = this.fontFaceManager.hasFontFaces() ? await this.fontFaceManager.getFontFamily(e1, a) : null;
        return r ? (n = i.glyphs[t] = await this._drawGlyph(i, e1, t, r), {
            stack: e1,
            id: t,
            glyph: n
        }) : !this.url || $785da19a645c07eb$var$Vb(t) || this._charUsesLocalIdeographFontFamily(a) ? (n = i.glyphs[t] = await this._drawGlyph(i, e1, t), {
            stack: e1,
            id: t,
            glyph: n
        }) : await this._downloadAndCacheRangePromise(e1, t);
    }
    async _downloadAndCacheRangePromise(e1, t) {
        let i = t.codePointAt(0), n = this.entries[e1], a = Math.floor(i / 256);
        if (n.ranges[a]) return {
            stack: e1,
            id: t,
            glyph: null
        };
        n.requests[a] ||= this._loadGlyphRange(e1, a);
        try {
            let r = await n.requests[a];
            for(let e1 in r)n.glyphs[String.fromCodePoint(+e1)] = r[+e1];
            return n.ranges[a] = !0, {
                stack: e1,
                id: t,
                glyph: r[i] || null
            };
        } catch (r) {
            let s = n.glyphs[t] = await this._drawGlyph(n, e1, t);
            return this._warnOnMissingGlyphRange(s, a, i, $785da19a645c07eb$var$Gu(r)), {
                stack: e1,
                id: t,
                glyph: s
            };
        }
    }
    async _loadGlyphRange(e1, t) {
        let i = 256 * t, n = i + 255, a = await this.requestManager.transformRequest(this.url.replace("{fontstack}", e1).replace("{range}", `${i}-${n}`), "Glyphs"), r = await $785da19a645c07eb$var$$h(a, new AbortController);
        if (!r?.data) throw Error(`Could not load glyph range. range: ${t}, ${i}-${n}`);
        let s = {};
        for (let e1 of function(e1) {
            return new $785da19a645c07eb$var$fw(e1).readFields($785da19a645c07eb$var$Aw, []);
        }(r.data))s[e1.id] = e1;
        return s;
    }
    _warnOnMissingGlyphRange(e1, t, i, n) {
        let a = 256 * t;
        $785da19a645c07eb$var$wh(`Unable to load glyph range ${t}, ${a}-${a + 255}. Rendering codepoint U+${i.toString(16).padStart(4, "0").toUpperCase()} locally instead. ${n}`);
    }
    _charUsesLocalIdeographFontFamily(e1) {
        return !!this.localIdeographFontFamily && function(e1) {
            return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(e1));
        }(e1);
    }
    async _drawGlyph(e1, t, i, n) {
        let a = (await this._getTinySDF(e1, t, i, n)).draw(i), r = /^\p{gc=Cf}+$/u.test(i);
        return {
            id: i.codePointAt(0),
            bitmap: new $785da19a645c07eb$var$Zv({
                width: a.width || 60,
                height: a.height || 60
            }, a.data),
            metrics: {
                width: r ? 0 : a.glyphWidth / 2 || 24,
                height: a.glyphHeight / 2 || 24,
                left: a.glyphLeft / 2 + .5 || 0,
                top: a.glyphTop / 2 - 27.5 || -8,
                advance: r ? 0 : a.glyphAdvance / 2 || 24,
                isDoubleResolution: !0
            }
        };
    }
    _getTinySDF(e1, t, i, n) {
        let a = $785da19a645c07eb$var$Vb(i);
        if (n) {
            let t = a ? "clusterTinySDFs" : "fontFaceTinySDFs";
            return e1[t] ??= {}, e1[t][n] ||= this._createTinySDF(n, !1, a ? 3 : 1), e1[t][n];
        }
        let r = t === $785da19a645c07eb$var$QC && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(i.codePointAt(0)), s = r ? this.localIdeographFontFamily : t;
        if (a) return e1.clusterTinySDFs ??= {}, e1.clusterTinySDFs[s] ||= this._createTinySDF(s, !0, 3), e1.clusterTinySDFs[s];
        let o = r ? "ideographTinySDF" : "tinySDF";
        return e1[o] ||= this._createTinySDF(s), e1[o];
    }
    async _createTinySDF(e1, t = !0, i = 1) {
        let n = e1 ? e1.split(",") : [];
        n.push("sans-serif");
        let a = n.map((e1)=>/[-\w]+/.test(e1) ? e1 : `'${CSS.escape(e1)}'`).join(","), r = t ? this._fontWeight(n[0]) : void 0, s = t ? this._fontStyle(n[0]) : "normal";
        if (typeof document < "u" && document.fonts?.load) try {
            await document.fonts.load(`${s} ${r || "normal"} 48px ${a}`);
        } catch (e1) {
            $785da19a645c07eb$var$wh(`Failed to load font "${a}": ${$785da19a645c07eb$var$Gu(e1).message}`);
        }
        return this.createRasterizer({
            fontSize: 48,
            buffer: Math.max(6, Math.ceil(48 * (i - 1) / 4)),
            radius: 16,
            cutoff: .25,
            fontFamily: a,
            fontWeight: r,
            fontStyle: s,
            lang: this.lang
        }, 6);
    }
    _fontStyle(e1) {
        return /italic/i.test(e1) ? "italic" : /oblique/i.test(e1) ? "oblique" : "normal";
    }
    _fontWeight(e1) {
        let t, i = {
            thin: 100,
            hairline: 100,
            "extra light": 200,
            "ultra light": 200,
            light: 300,
            normal: 400,
            regular: 400,
            medium: 500,
            semibold: 600,
            demibold: 600,
            bold: 700,
            "extra bold": 800,
            "ultra bold": 800,
            black: 900,
            heavy: 900,
            "extra black": 950,
            "ultra black": 950
        };
        for (let [n, a] of Object.entries(i))RegExp(`\\b${n}\\b`, "i").test(e1) && (t = `${a}`);
        return t;
    }
    destroy() {
        for(let e1 in this.entries){
            let t = this.entries[e1];
            t.tinySDF = null, t.ideographTinySDF = null, t.fontFaceTinySDFs = {}, t.glyphs = {}, t.requests = {}, t.ranges = {};
        }
        this.entries = {}, this.fontFaceManager.destroy();
    }
};
let $785da19a645c07eb$var$$C;
var $785da19a645c07eb$var$eT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t){
        super(), this._transitionable = new $785da19a645c07eb$var$eA($785da19a645c07eb$var$$C ||= new $785da19a645c07eb$var$pA({
            anchor: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.light.anchor, "anchor"),
            position: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.light.position, "position"),
            color: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.light.color, "color"),
            intensity: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.light.intensity, "intensity")
        }), "light", t), this.setLight(e1), this._transitioning = this._transitionable.untransitioned();
    }
    getLight() {
        return this._transitionable.serialize();
    }
    getCartesianPosition() {
        return function([e1, t, i]) {
            return t += 90, t *= Math.PI / 180, i *= Math.PI / 180, [
                e1 * Math.cos(t) * Math.sin(i),
                e1 * Math.sin(t) * Math.sin(i),
                e1 * Math.cos(i)
            ];
        }(this.properties.get("position"));
    }
    setLight(e1, t = {}) {
        if (!this._validate($785da19a645c07eb$var$Lf.light, e1, t)) for(let t in e1){
            let i = e1[t];
            t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
        }
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, i) {
        return $785da19a645c07eb$var$Nf(this, e1, {
            value: t
        }, i);
    }
};
let $785da19a645c07eb$var$tT;
var $785da19a645c07eb$var$iT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t){
        super(), this._transitionable = new $785da19a645c07eb$var$eA($785da19a645c07eb$var$tT ||= new $785da19a645c07eb$var$pA({
            "sky-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["sky-color"], "sky-color"),
            "horizon-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["horizon-color"], "horizon-color"),
            "fog-color": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["fog-color"], "fog-color"),
            "fog-ground-blend": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["fog-ground-blend"], "fog-ground-blend"),
            "horizon-fog-blend": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["horizon-fog-blend"], "horizon-fog-blend"),
            "sky-horizon-blend": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["sky-horizon-blend"], "sky-horizon-blend"),
            "atmosphere-blend": new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.sky["atmosphere-blend"], "atmosphere-blend")
        }), "sky", t), this.setSky(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new $785da19a645c07eb$var$Qf(0));
    }
    setSky(e1, t = {}) {
        if (!this._validate($785da19a645c07eb$var$Lf.sky, e1, t)) {
            e1 ||= {
                "sky-color": "transparent",
                "horizon-color": "transparent",
                "fog-color": "transparent",
                "fog-ground-blend": 1,
                "atmosphere-blend": 0
            };
            for(let t in e1){
                let i = e1[t];
                t.endsWith("-transition") ? this._transitionable.setTransition(t.slice(0, -11), i) : this._transitionable.setValue(t, i);
            }
        }
    }
    getSky() {
        return this._transitionable.serialize();
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
    _validate(e1, t, i = {}) {
        return $785da19a645c07eb$var$Nf(this, e1, {
            value: t
        }, i);
    }
    calculateFogBlendOpacity(e1) {
        return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
    }
}, $785da19a645c07eb$var$nT = class {
    constructor(e1, t){
        this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
    }
    getDash(e1, t) {
        let i = e1.join(",") + String(t);
        return this.dashEntry[i] ||= this.addDash(e1, t), this.dashEntry[i];
    }
    getDashRanges(e1, t, i) {
        let n = [], a = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, r = e1[0] * i, s = !0;
        n.push({
            left: a,
            right: r,
            isDash: s,
            zeroLength: 0 === e1[0]
        });
        let o = e1[0];
        for(let t = 1; t < e1.length; t++){
            s = !s;
            let l = e1[t];
            a = o * i, o += l, r = o * i, n.push({
                left: a,
                right: r,
                isDash: s,
                zeroLength: 0 === l
            });
        }
        return n;
    }
    addRoundDash(e1, t, i) {
        let n = t / 2;
        for(let t = -i; t <= i; t++){
            let a = this.nextRow + i + t, r = this.width * a, s = 0, o = e1[s];
            for(let a = 0; a < this.width; a++){
                a / o.right > 1 && (o = e1[++s]);
                let l, c = Math.abs(a - o.left), u = Math.abs(a - o.right), h = Math.min(c, u), d = t / i * (n + 1);
                if (o.isDash) {
                    let e1 = n - Math.abs(d);
                    l = Math.sqrt(h * h + e1 * e1);
                } else l = n - Math.sqrt(h * h + d * d);
                this.data[r + a] = Math.max(0, Math.min(255, l + 128));
            }
        }
    }
    addRegularDash(e1) {
        for(let t = e1.length - 1; t >= 0; --t){
            let i = e1[t], n = e1[t + 1];
            i.zeroLength ? e1.splice(t, 1) : n?.isDash === i.isDash && (n.left = i.left, e1.splice(t, 1));
        }
        let t = e1[0], i = e1[e1.length - 1];
        t.isDash === i.isDash && (t.left = i.left - this.width, i.right = t.right + this.width);
        let n = this.width * this.nextRow, a = 0, r = e1[a];
        for(let t = 0; t < this.width; t++){
            t / r.right > 1 && (r = e1[++a]);
            let i = Math.abs(t - r.left), s = Math.abs(t - r.right), o = Math.min(i, s), l = r.isDash ? o : -o;
            this.data[n + t] = Math.max(0, Math.min(255, l + 128));
        }
    }
    addDash(e1, t) {
        let i = t ? 7 : 0, n = 2 * i + 1;
        if (this.nextRow + n > this.height) return $785da19a645c07eb$var$wh("LineAtlas out of space"), null;
        let a = 0;
        for (let t of e1)a += t;
        if (0 !== a) {
            let n = this.width / a, r = this.getDashRanges(e1, this.width, n);
            t ? this.addRoundDash(r, n, i) : this.addRegularDash(r);
        }
        let r = {
            y: this.nextRow + i,
            height: 2 * i,
            width: a
        };
        return this.nextRow += n, this.dirty = !0, r;
    }
    bind(e1) {
        let t = e1.gl;
        this.texture ? (t.bindTexture(t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, this.width, this.height, t.ALPHA, t.UNSIGNED_BYTE, this.data))) : (this.texture = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this.texture), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texImage2D(t.TEXTURE_2D, 0, t.ALPHA, this.width, this.height, 0, t.ALPHA, t.UNSIGNED_BYTE, this.data));
    }
};
function $785da19a645c07eb$var$aT(e1, t) {
    if (t) try {
        return new Worker(e1, {
            type: "module"
        });
    } catch (e1) {
        console.warn("Module worker not supported, falling back to classic worker", e1);
    }
    return new Worker(e1);
}


async function $785da19a645c07eb$var$rT() {
    let t = $785da19a645c07eb$var$Hh.WORKER_URL || function() {
        let t = "undefined" == typeof document ? (parcelRequire("e61jG")).pathToFileURL($785da19a645c07eb$var$__filename).href : $785da19a645c07eb$var$e1 && "SCRIPT" === $785da19a645c07eb$var$e1.tagName.toUpperCase() && $785da19a645c07eb$var$e1.src || new URL("index.js", document.baseURI).href;
        if (!/^https?:/.test(t)) return "";
        let i = t.endsWith("-dev.mjs") ? "maplibre-gl-worker-dev.mjs" : "maplibre-gl-worker.mjs";
        return new URL(`./${i}`, t).href;
    }(), i = !t?.endsWith(".cjs");
    if (!function(e1) {
        if (!e1) return !1;
        let t = globalThis.location;
        if (!t) return !1;
        try {
            return new URL(e1, t.href).origin !== t.origin;
        } catch  {
            return !1;
        }
    }(t)) return $785da19a645c07eb$var$aT(t, i);
    if (i) {
        let n = function(t) {
            let i = new Blob([
                `import ${JSON.stringify(new URL(t, "undefined" == typeof document ? (parcelRequire("e61jG")).pathToFileURL($785da19a645c07eb$var$__filename).href : $785da19a645c07eb$var$e1 && "SCRIPT" === $785da19a645c07eb$var$e1.tagName.toUpperCase() && $785da19a645c07eb$var$e1.src || new URL("index.js", document.baseURI).href).href)}`
            ], {
                type: "text/javascript"
            });
            return URL.createObjectURL(i);
        }(t);
        try {
            return $785da19a645c07eb$var$aT(n, i);
        } finally{
            URL.revokeObjectURL(n);
        }
    }
    let n = await async function(e1) {
        let t = await fetch(e1);
        if (!t.ok) throw Error(`Failed to fetch worker script (${t.status}): ${e1}`);
        let i = await t.text(), n = new Blob([
            i
        ], {
            type: "text/javascript"
        });
        return URL.createObjectURL(n);
    }(t);
    try {
        return $785da19a645c07eb$var$aT(n, i);
    } finally{
        URL.revokeObjectURL(n);
    }
}
var $785da19a645c07eb$var$sT = class e1 {
    constructor(){
        this.active = {}, this.workersPromise = null;
    }
    async acquire(t) {
        if (this.active[t] = !0, !this.workersPromise) {
            let t = [];
            for(; t.length < e1.workerCount;)t.push($785da19a645c07eb$var$rT());
            this.workersPromise = Promise.all(t);
        }
        return (await this.workersPromise).slice();
    }
    release(e1) {
        if (delete this.active[e1], 0 === this.numActive() && this.workersPromise) {
            let e1 = this.workersPromise;
            this.workersPromise = null, e1.then((e1)=>{
                for (let t of e1)t.terminate();
            });
        }
    }
    isPreloaded() {
        return !!this.active.maplibre_preloaded_worker_pool;
    }
    numActive() {
        return Object.keys(this.active).length;
    }
};
const $785da19a645c07eb$var$oT = Math.floor($785da19a645c07eb$var$iC.hardwareConcurrency / 2);
let $785da19a645c07eb$var$lT;
function $785da19a645c07eb$var$cT() {
    return $785da19a645c07eb$var$lT ||= new $785da19a645c07eb$var$sT, $785da19a645c07eb$var$lT;
}
$785da19a645c07eb$var$sT.workerCount = function(e1) {
    if (null == $785da19a645c07eb$var$Sh) {
        let t = e1.navigator ? e1.navigator.userAgent : null;
        $785da19a645c07eb$var$Sh = !!e1.safari || !(!t || !(/\b(iPad|iPhone|iPod)\b/.test(t) || t.match("Safari") && !t.match("Chrome")));
    }
    return $785da19a645c07eb$var$Sh;
}(globalThis) ? Math.max(Math.min($785da19a645c07eb$var$oT, 3), 1) : 1;
var $785da19a645c07eb$var$uT = class {
    constructor(e1, t){
        this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = t, this.removed = !1, this.actorsPromise = this.initActors(t);
    }
    async initActors(e1) {
        let t = await this.workerPool.acquire(e1);
        if (this.removed) return [];
        if (this.actors = t.map((t, i)=>{
            let n = new $785da19a645c07eb$var$GE(t, e1);
            return n.name = `Worker ${i}`, n;
        }), !this.actors.length) throw Error("No actors found");
        return this.actors;
    }
    async broadcast(e1, t) {
        let i = await this.actorsPromise;
        return Promise.all(i.map((i)=>i.sendAsync({
                type: e1,
                data: t
            })));
    }
    async getActor() {
        let e1 = await this.actorsPromise;
        return this.currentActor = (this.currentActor + 1) % e1.length, e1[this.currentActor];
    }
    async waitForInitComplete() {
        0 === this.actors.length && await this.actorsPromise;
    }
    getReadyActor() {
        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
    }
    remove(e1 = !0) {
        this.removed = !0;
        for (let e1 of this.actors)e1.remove();
        this.actors = [], e1 && this.workerPool.release(this.id);
    }
    async registerMessageHandler(e1, t) {
        let i = await this.actorsPromise;
        for (let n of i)n.registerMessageHandler(e1, t);
    }
    async unregisterMessageHandler(e1) {
        let t = await this.actorsPromise;
        for (let i of t)i.unregisterMessageHandler(e1);
    }
};
let $785da19a645c07eb$var$hT;
function $785da19a645c07eb$var$dT(e1, t) {
    let i = $785da19a645c07eb$var$tu();
    return $785da19a645c07eb$var$su(i, i, [
        1,
        1,
        0
    ]), $785da19a645c07eb$var$ou(i, i, [
        .5 * e1.width,
        .5 * e1.height,
        1
    ]), e1.calculatePosMatrix ? $785da19a645c07eb$var$ru(i, i, e1.calculatePosMatrix(t.toUnwrapped())) : i;
}
function $785da19a645c07eb$var$pT(e1, t, i, n, a, r, s) {
    let o = function(e1, t, i) {
        if (e1) for (let n of e1){
            let e1 = t[n];
            if (e1?.source === i && "fill-extrusion" === e1.type) return !0;
        }
        else for(let e1 in t){
            let n = t[e1];
            if (n.source === i && "fill-extrusion" === n.type) return !0;
        }
        return !1;
    }(a?.layers ?? null, t, e1.id), l = r.maxPitchScaleFactor(), c = e1.tilesIn(n, l, o);
    c.sort($785da19a645c07eb$var$gT);
    let u = [];
    for (let n of c)u.push({
        wrappedTileID: n.tileID.wrapped().key,
        queryResults: n.tile.queryRenderedFeatures(t, i, e1.getState(), n.queryGeometry, n.cameraQueryGeometry, n.scale, a, r, l, $785da19a645c07eb$var$dT(r, n.tileID), s ? (e1, t)=>s(n.tileID, e1, t) : void 0)
    });
    return function(e1, t) {
        for(let i in e1)for (let n of e1[i])$785da19a645c07eb$var$fT(n, t);
        return e1;
    }(function(e1) {
        let t = {}, i = {};
        for (let { queryResults: n, wrappedTileID: a } of e1){
            i[a] ||= {};
            let e1 = i[a];
            for(let i in n){
                let a = n[i];
                e1[i] ||= {};
                let r = e1[i];
                t[i] ||= [];
                for (let e1 of a)r[e1.featureIndex] || (r[e1.featureIndex] = !0, t[i].push(e1));
            }
        }
        return t;
    }(u), e1);
}
function $785da19a645c07eb$var$mT(e1, t, i, n, a, r, s) {
    let o = {}, l = r.queryRenderedSymbols(n), c = [];
    for (let e1 of Object.keys(l).map(Number))c.push(s[e1]);
    c.sort($785da19a645c07eb$var$gT);
    for (let i of c){
        let n = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, {
            filterSpec: a.filter,
            globalState: a.globalState
        }, a.layers, a.availableImages, e1);
        for(let e1 in n){
            o[e1] ||= [];
            let t = n[e1];
            t.sort((e1, t)=>{
                let n = i.featureSortOrder;
                if (n) {
                    let i = n.indexOf(e1.featureIndex);
                    return n.indexOf(t.featureIndex) - i;
                }
                return t.featureIndex - e1.featureIndex;
            });
            for (let i of t)o[e1].push(i);
        }
    }
    return function(e1, t, i) {
        for(let n in e1)for (let a of e1[n])$785da19a645c07eb$var$fT(a, i[t[n].source]);
        return e1;
    }(o, e1, i);
}
function $785da19a645c07eb$var$gT(e1, t) {
    let i = e1.tileID, n = t.tileID;
    return i.overscaledZ - n.overscaledZ || i.canonical.y - n.canonical.y || i.wrap - n.wrap || i.canonical.x - n.canonical.x;
}
function $785da19a645c07eb$var$fT(e1, t) {
    let i = e1.feature, n = t.getFeatureState(i.layer["source-layer"], i.id);
    i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = n;
}
async function $785da19a645c07eb$var$AT(e1, t, i, n) {
    let a = e1;
    if (e1.url ? a = (await $785da19a645c07eb$var$Jh(await t.transformRequest(e1.url, "Source"), i)).data : await $785da19a645c07eb$var$iC.frameAsync(i, n), !a) return null;
    let r = $785da19a645c07eb$var$dh($785da19a645c07eb$var$hh(a, e1), [
        "tiles",
        "minzoom",
        "maxzoom",
        "attribution",
        "bounds",
        "scheme",
        "tileSize",
        "encoding"
    ]);
    return "vector_layers" in a && a.vector_layers && (r.vectorLayerIds = a.vector_layers.map((e1)=>e1.id)), r;
}
var $785da19a645c07eb$var$_T = class e1 {
    constructor(e1, t){
        e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (4 === e1.length ? this.setSouthWest([
            e1[0],
            e1[1]
        ]).setNorthEast([
            e1[2],
            e1[3]
        ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
    }
    setNorthEast(e1) {
        return this._ne = e1 instanceof $785da19a645c07eb$var$Mx ? new $785da19a645c07eb$var$Mx(e1.lng, e1.lat) : $785da19a645c07eb$var$Mx.convert(e1), this;
    }
    setSouthWest(e1) {
        return this._sw = e1 instanceof $785da19a645c07eb$var$Mx ? new $785da19a645c07eb$var$Mx(e1.lng, e1.lat) : $785da19a645c07eb$var$Mx.convert(e1), this;
    }
    extend(t) {
        let i, n, a = this._sw, r = this._ne;
        if (t instanceof $785da19a645c07eb$var$Mx) i = t, n = t;
        else {
            if (!(t instanceof e1)) {
                if (Array.isArray(t)) {
                    if (4 === t.length || t.every(Array.isArray)) {
                        let i = t;
                        return this.extend(e1.convert(i));
                    }
                    {
                        let e1 = t;
                        return this.extend($785da19a645c07eb$var$Mx.convert(e1));
                    }
                }
                return t && ("lng" in t || "lon" in t) && "lat" in t ? this.extend($785da19a645c07eb$var$Mx.convert(t)) : this;
            }
            if (i = t._sw, n = t._ne, !i || !n) return this;
        }
        return a || r ? (a.lng = Math.min(i.lng, a.lng), a.lat = Math.min(i.lat, a.lat), r.lng = Math.max(n.lng, r.lng), r.lat = Math.max(n.lat, r.lat)) : (this._sw = new $785da19a645c07eb$var$Mx(i.lng, i.lat), this._ne = new $785da19a645c07eb$var$Mx(n.lng, n.lat)), this;
    }
    getCenter() {
        return new $785da19a645c07eb$var$Mx((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
    }
    getSouthWest() {
        return this._sw;
    }
    getNorthEast() {
        return this._ne;
    }
    getNorthWest() {
        return new $785da19a645c07eb$var$Mx(this.getWest(), this.getNorth());
    }
    getSouthEast() {
        return new $785da19a645c07eb$var$Mx(this.getEast(), this.getSouth());
    }
    getWest() {
        return this._sw.lng;
    }
    getSouth() {
        return this._sw.lat;
    }
    getEast() {
        return this._ne.lng;
    }
    getNorth() {
        return this._ne.lat;
    }
    toArray() {
        return [
            this._sw.toArray(),
            this._ne.toArray()
        ];
    }
    toString() {
        return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
    }
    isEmpty() {
        return !(this._sw && this._ne);
    }
    contains(e1) {
        let { lng: t, lat: i } = $785da19a645c07eb$var$Mx.convert(e1), n = this._sw.lat <= i && i <= this._ne.lat, a = this._sw.lng <= t && t <= this._ne.lng;
        return this._sw.lng > this._ne.lng && (a = this._sw.lng >= t && t >= this._ne.lng), n && a;
    }
    intersects(t) {
        if (!((t = e1.convert(t)).getNorth() >= this.getSouth() && t.getSouth() <= this.getNorth())) return !1;
        let i = Math.abs(this.getEast() - this.getWest()), n = Math.abs(t.getEast() - t.getWest());
        if (i >= 360 || n >= 360) return !0;
        let a = $785da19a645c07eb$var$uh(this.getWest(), -180, 180), r = $785da19a645c07eb$var$uh(this.getEast(), -180, 180), s = $785da19a645c07eb$var$uh(t.getWest(), -180, 180), o = $785da19a645c07eb$var$uh(t.getEast(), -180, 180), l = a > r, c = s > o;
        return !(!l || !c) || (l ? o >= a || s <= r : c ? r >= s || a <= o : s <= r && o >= a);
    }
    static convert(t) {
        return t instanceof e1 || !t ? t : new e1(t);
    }
    static fromLngLat(t, i = 0) {
        let n = 360 * i / 40075017, a = n / Math.cos(Math.PI / 180 * t.lat);
        return new e1(new $785da19a645c07eb$var$Mx(t.lng - a, t.lat - n), new $785da19a645c07eb$var$Mx(t.lng + a, t.lat + n));
    }
    adjustAntiMeridian() {
        let t = new $785da19a645c07eb$var$Mx(this._sw.lng, this._sw.lat), i = new $785da19a645c07eb$var$Mx(this._ne.lng, this._ne.lat);
        return t.lng > i.lng ? new e1(t, new $785da19a645c07eb$var$Mx(i.lng + 360, i.lat)) : new e1(t, i);
    }
}, $785da19a645c07eb$var$vT = class {
    constructor(e1, t, i){
        this.bounds = $785da19a645c07eb$var$_T.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
    }
    validateBounds(e1) {
        return Array.isArray(e1) && 4 === e1.length ? [
            Math.max(-180, e1[0]),
            Math.max(-90, e1[1]),
            Math.min(180, e1[2]),
            Math.min(90, e1[3])
        ] : [
            -180,
            -90,
            180,
            90
        ];
    }
    contains(e1) {
        let t = 2 ** e1.z, i = Math.floor($785da19a645c07eb$var$Dx(this.bounds.getWest()) * t), n = Math.floor($785da19a645c07eb$var$Px(this.bounds.getNorth()) * t), a = Math.ceil($785da19a645c07eb$var$Dx(this.bounds.getEast()) * t), r = Math.ceil($785da19a645c07eb$var$Px(this.bounds.getSouth()) * t);
        return e1.x >= i && e1.x < a && e1.y >= n && e1.y < r;
    }
}, $785da19a645c07eb$var$yT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t, i, n){
        if (super(), this.id = e1, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, $785da19a645c07eb$var$hh(this, $785da19a645c07eb$var$dh(t, [
            "url",
            "scheme",
            "tileSize",
            "promoteId",
            "encoding"
        ])), this._options = $785da19a645c07eb$var$hh({
            type: "vector"
        }, t), this._collectResourceTiming = t.collectResourceTiming, 512 !== this.tileSize) throw Error("vector tile sources must have a tileSize of 512");
        this.setEventedParent(n);
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $785da19a645c07eb$var$dC("dataloading")), this._tileJSONRequest = new AbortController;
        try {
            let t = await $785da19a645c07eb$var$AT(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ($785da19a645c07eb$var$hh(this, t), t.bounds && (this.tileBounds = new $785da19a645c07eb$var$vT(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $785da19a645c07eb$var$dC("data", {
                sourceDataType: "metadata"
            })), this.fire(new $785da19a645c07eb$var$dC("data", {
                sourceDataType: "content",
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, $785da19a645c07eb$var$qh(e1) || this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setSourceProperty(e1) {
        this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    serialize() {
        return $785da19a645c07eb$var$hh({}, this._options);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
            request: await this.map._requestManager.transformRequest(t, "Tile"),
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
            type: this.type,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
            encoding: this.encoding,
            overzoomParameters: await this._getOverzoomParameters(e1),
            etag: e1.etag
        };
        i.request.collectResourceTiming = this._collectResourceTiming, await this.dispatcher.waitForInitComplete();
        let n = "RT";
        if (e1.actor && "expired" !== e1.state) {
            if ("loading" === e1.state) return new Promise((t, i)=>{
                e1.reloadPromise = {
                    resolve: t,
                    reject: i
                };
            });
        } else e1.actor = this.dispatcher.getReadyActor(), n = "LT";
        e1.abortController = new AbortController;
        try {
            let t = await e1.actor.sendAsync({
                type: n,
                data: i
            }, e1.abortController);
            if (delete e1.abortController, e1.aborted) return;
            this._afterTileLoadWorkerResponse(e1, t);
            let a = {};
            return t?.etagUnmodified && (a.unmodified = !0), a;
        } catch (t) {
            if (delete e1.abortController, e1.aborted || $785da19a645c07eb$var$qh(t)) return;
            if (t && 404 !== t.status) throw t;
            this._afterTileLoadWorkerResponse(e1, null);
        }
    }
    async _getOverzoomParameters(e1) {
        if (e1.tileID.canonical.z <= this.maxzoom || void 0 === this.map._zoomLevelsToOverscale) return;
        let t = e1.tileID.scaledTo(this.maxzoom).canonical, i = t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        return {
            maxZoomTileID: t,
            overzoomRequest: await this.map._requestManager.transformRequest(i, "Tile")
        };
    }
    _afterTileLoadWorkerResponse(e1, t) {
        if (t?.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.etag = t?.etag, e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
            let t = e1.reloadPromise;
            e1.reloadPromise = null, this.loadTile(e1).then(t.resolve).catch(t.reject);
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.actor && await e1.actor.sendAsync({
            type: "AT",
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), e1.actor && await e1.actor.sendAsync({
            type: "RMT",
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    hasTransition() {
        return !1;
    }
}, $785da19a645c07eb$var$xT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t, i, n){
        super(), this.id = e1, this.dispatcher = i, this.setEventedParent(n), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._premultiplyAlpha = !0, this._options = $785da19a645c07eb$var$hh({
            type: "raster"
        }, t), $785da19a645c07eb$var$hh(this, $785da19a645c07eb$var$dh(t, [
            "url",
            "scheme",
            "tileSize"
        ]));
    }
    async load(e1 = !1) {
        this._loaded = !1, this.fire(new $785da19a645c07eb$var$dC("dataloading")), this._tileJSONRequest = new AbortController;
        try {
            let t = await $785da19a645c07eb$var$AT(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
            this._tileJSONRequest = null, this._loaded = !0, t && ($785da19a645c07eb$var$hh(this, t), t.bounds && (this.tileBounds = new $785da19a645c07eb$var$vT(t.bounds, this.minzoom, this.maxzoom)), this.fire(new $785da19a645c07eb$var$dC("data", {
                sourceDataType: "metadata"
            })), this.fire(new $785da19a645c07eb$var$dC("data", {
                sourceDataType: "content",
                sourceDataChanged: e1
            })));
        } catch (e1) {
            this._tileJSONRequest = null, this._loaded = !0, $785da19a645c07eb$var$qh(e1) || this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null);
    }
    setSourceProperty(e1) {
        this._tileJSONRequest &&= (this._tileJSONRequest.abort(), null), e1(), this.load(!0);
    }
    setTiles(e1) {
        return this.setSourceProperty(()=>{
            this.tiles = e1, this._options.tiles = e1;
        }), this;
    }
    setUrl(e1) {
        return this.setSourceProperty(()=>{
            this.url = e1, this._options.url = e1;
        }), this;
    }
    serialize() {
        return $785da19a645c07eb$var$hh({}, this._options);
    }
    setPremultiplyAlpha(e1) {
        return this._premultiplyAlpha === e1 || this.setSourceProperty(()=>{
            this._premultiplyAlpha = e1;
        }), this;
    }
    hasTile(e1) {
        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = this._premultiplyAlpha, n = i ? void 0 : {
            premultiplyAlpha: "none"
        };
        e1.abortController = new AbortController;
        try {
            let a = await $785da19a645c07eb$var$sC.transformAndGetImage(this.map._requestManager, t, "Tile", e1.abortController, this.map._refreshExpiredTiles, n);
            if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
            if (a) {
                this.map._refreshExpiredTiles && (a.cacheControl || a.expires) && e1.setExpiryData({
                    cacheControl: a.cacheControl,
                    expires: a.expires
                });
                let t = this.map.painter.context, n = t.gl, r = a.data ?? new $785da19a645c07eb$var$Kv({
                    width: 1,
                    height: 1
                }, new Uint8Array(4));
                e1.texture = this.map.painter.getTileTexture(r.width), e1.texture ? e1.texture.update(r, {
                    useMipmap: !0,
                    premultiply: i
                }) : (e1.texture = new $785da19a645c07eb$var$ry(t, r, n.RGBA, {
                    useMipmap: !0,
                    premultiply: i
                }), e1.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE, n.LINEAR_MIPMAP_NEAREST)), e1.state = "loaded";
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
            else if (t) throw e1.state = "errored", t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController);
    }
    async unloadTile(e1) {
        e1.texture && this.map.painter.saveTileTexture(e1.texture);
    }
    hasTransition() {
        return !1;
    }
}, $785da19a645c07eb$var$bT = class extends $785da19a645c07eb$var$xT {
    constructor(e1, t, i, n){
        super(e1, t, i, n), this.type = "raster-dem", this.maxzoom = 22, this._options = $785da19a645c07eb$var$hh({
            type: "raster-dem"
        }, t), this.encoding = t.encoding || "mapbox", this.redFactor = t.redFactor, this.greenFactor = t.greenFactor, this.blueFactor = t.blueFactor, this.baseShift = t.baseShift;
    }
    async loadTile(e1) {
        let t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
        e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
        try {
            let i = await $785da19a645c07eb$var$sC.transformAndGetImage(this.map._requestManager, t, "Tile", e1.abortController, this.map._refreshExpiredTiles, {
                colorSpaceConversion: "none"
            });
            if (delete e1.abortController, e1.aborted) return void (e1.state = "unloaded");
            if (i) {
                if (this.map._refreshExpiredTiles && (i.cacheControl || i.expires) && e1.setExpiryData({
                    cacheControl: i.cacheControl,
                    expires: i.expires
                }), !i.data) return void (e1.state = "loaded");
                let t = i.data, n = $785da19a645c07eb$var$Mh(t) && $785da19a645c07eb$var$Yc() ? t : await this.readImageNow(t), a = {
                    type: this.type,
                    uid: e1.uid,
                    source: this.id,
                    rawImageData: n,
                    encoding: this.encoding,
                    redFactor: this.redFactor,
                    greenFactor: this.greenFactor,
                    blueFactor: this.blueFactor,
                    baseShift: this.baseShift
                };
                if (e1.actor && "expired" !== e1.state && "reloading" !== e1.state) return;
                await this.dispatcher.waitForInitComplete(), (!e1.actor || "expired" === e1.state) && (e1.actor = this.dispatcher.getReadyActor()), e1.dem = await e1.actor.sendAsync({
                    type: "LDT",
                    data: a
                }), e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0, e1.state = "loaded";
            }
        } catch (t) {
            if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
            else if (t) throw e1.state = "errored", t;
        }
    }
    async readImageNow(e1) {
        if (typeof VideoFrame < "u" && $785da19a645c07eb$var$Jc()) {
            let t = e1.width + 4, i = e1.height + 4;
            try {
                return new $785da19a645c07eb$var$Kv({
                    width: t,
                    height: i
                }, await $785da19a645c07eb$var$Ch(e1, -2, -2, t, i));
            } catch  {}
        }
        return $785da19a645c07eb$var$iC.getImageData(e1, 2);
    }
    _getNeighboringTiles(e1) {
        let t = e1.canonical, i = 2 ** t.z, n = (t.x - 1 + i) % i, a = 0 === t.x ? e1.wrap - 1 : e1.wrap, r = (t.x + 1 + i) % i, s = t.x + 1 === i ? e1.wrap + 1 : e1.wrap, o = {};
        return o[new $785da19a645c07eb$var$KE(e1.overscaledZ, a, t.z, n, t.y).key] = {
            backfilled: !1
        }, o[new $785da19a645c07eb$var$KE(e1.overscaledZ, s, t.z, r, t.y).key] = {
            backfilled: !1
        }, t.y > 0 && (o[new $785da19a645c07eb$var$KE(e1.overscaledZ, a, t.z, n, t.y - 1).key] = {
            backfilled: !1
        }, o[new $785da19a645c07eb$var$KE(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
            backfilled: !1
        }, o[new $785da19a645c07eb$var$KE(e1.overscaledZ, s, t.z, r, t.y - 1).key] = {
            backfilled: !1
        }), t.y + 1 < i && (o[new $785da19a645c07eb$var$KE(e1.overscaledZ, a, t.z, n, t.y + 1).key] = {
            backfilled: !1
        }, o[new $785da19a645c07eb$var$KE(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
            backfilled: !1
        }, o[new $785da19a645c07eb$var$KE(e1.overscaledZ, s, t.z, r, t.y + 1).key] = {
            backfilled: !1
        }), o;
    }
    async unloadTile(e1) {
        e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded", e1.actor && await e1.actor.sendAsync({
            type: "RDT",
            data: {
                type: this.type,
                uid: e1.uid,
                source: this.id
            }
        });
    }
};
function $785da19a645c07eb$var$wT(e1, t) {
    return t ? e1.properties[t] : e1.id;
}
function $785da19a645c07eb$var$ET(e1, t, i) {
    if (!e1) return t || {};
    if (!t) return e1 || {};
    let n = $785da19a645c07eb$var$ST(e1), a = $785da19a645c07eb$var$ST(t);
    !function(e1, t) {
        t.removeAll && (e1.add.clear(), e1.update.clear(), e1.remove.clear(), t.remove.clear());
        for (let i of t.remove)e1.add.delete(i), e1.update.delete(i);
        for (let [i, n] of t.update){
            let a = e1.update.get(i);
            a && (t.update.set(i, $785da19a645c07eb$var$kT(a, n)), e1.update.delete(i));
        }
    }(n, a);
    let r = {};
    if ((n.removeAll || a.removeAll) && (r.removeAll = !0), r.remove = new Set([
        ...n.remove,
        ...a.remove
    ]), r.add = new Map([
        ...n.add,
        ...a.add
    ]), r.update = new Map([
        ...n.update,
        ...a.update
    ]), r.remove.size && r.add.size) for (let e1 of r.add.keys())r.remove.delete(e1);
    let s = function(e1) {
        let t = {};
        return e1.removeAll && (t.removeAll = e1.removeAll), e1.remove && (t.remove = Array.from(e1.remove)), e1.add && (t.add = Array.from(e1.add.values())), e1.update && (t.update = Array.from(e1.update.values())), t;
    }(r);
    return s;
}
function $785da19a645c07eb$var$kT(e1, t) {
    let i = {
        id: e1.id
    };
    if (t.removeAllProperties && (delete e1.removeProperties, delete e1.addOrUpdateProperties, delete t.removeProperties), t.removeProperties && e1.addOrUpdateProperties) {
        let i = new Set(t.removeProperties);
        e1.addOrUpdateProperties = e1.addOrUpdateProperties.filter((e1)=>!i.has(e1.key));
    }
    return (e1.removeAllProperties || t.removeAllProperties) && (i.removeAllProperties = !0), (e1.removeProperties || t.removeProperties) && (i.removeProperties = [
        ...e1.removeProperties || [],
        ...t.removeProperties || []
    ]), (e1.addOrUpdateProperties || t.addOrUpdateProperties) && (i.addOrUpdateProperties = [
        ...e1.addOrUpdateProperties || [],
        ...t.addOrUpdateProperties || []
    ]), (e1.newGeometry || t.newGeometry) && (i.newGeometry = t.newGeometry || e1.newGeometry), i;
}
function $785da19a645c07eb$var$ST(e1) {
    if (!e1) return {};
    let t = {};
    return t.removeAll = e1.removeAll, t.remove = new Set(e1.remove || []), t.add = new Map(e1.add?.map((e1)=>[
            e1.id,
            e1
        ])), t.update = new Map(e1.update?.map((e1)=>[
            e1.id,
            e1
        ])), t;
}
function $785da19a645c07eb$var$MT(e1) {
    return e1 && 0 !== e1.length ? "number" == typeof e1[0] ? [
        e1
    ] : e1.flatMap((e1)=>$785da19a645c07eb$var$MT(e1)) : [];
}
function $785da19a645c07eb$var$CT(e1) {
    return "GeometryCollection" === e1.type ? e1.geometries.flatMap((e1)=>$785da19a645c07eb$var$CT(e1)) : $785da19a645c07eb$var$MT(e1.coordinates);
}
function $785da19a645c07eb$var$TT(e1) {
    let t, i = new $785da19a645c07eb$var$_T;
    switch(e1.type){
        case "FeatureCollection":
            t = e1.features.flatMap((e1)=>$785da19a645c07eb$var$CT(e1.geometry));
            break;
        case "Feature":
            t = $785da19a645c07eb$var$CT(e1.geometry);
            break;
        default:
            t = $785da19a645c07eb$var$CT(e1);
    }
    if (0 === t.length) return i;
    for (let e1 of t){
        let [t, n] = e1;
        i.extend([
            t,
            n
        ]);
    }
    return i;
}
var $785da19a645c07eb$var$DT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t, i, n){
        super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
            data: t.data
        }, this.actorPromise = i.getActor(), this.setEventedParent(n), this._data = "string" == typeof t.data ? {
            url: t.data
        } : {
            geojson: t.data
        }, this._options = $785da19a645c07eb$var$hh({}, t), this._collectResourceTiming = t.collectResourceTiming, void 0 !== t.maxzoom && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId, void 0 !== t.clusterMaxZoom && this.maxzoom <= t.clusterMaxZoom && $785da19a645c07eb$var$wh(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${t.clusterMaxZoom}".`), this.workerOptions = $785da19a645c07eb$var$hh({
            source: this.id,
            geojsonVtOptions: {
                buffer: this._pixelsToTileUnits(void 0 === t.buffer ? 128 : t.buffer),
                tolerance: this._pixelsToTileUnits(void 0 === t.tolerance ? .375 : t.tolerance),
                extent: $785da19a645c07eb$var$Vu,
                maxZoom: this.maxzoom,
                lineMetrics: t.lineMetrics || !1,
                generateId: t.generateId || !1,
                promoteId: "string" == typeof t.promoteId ? t.promoteId : void 0,
                cluster: t.cluster || !1,
                clusterOptions: {
                    maxZoom: this._getClusterMaxZoom(t.clusterMaxZoom),
                    minPoints: Math.max(2, t.clusterMinPoints || 2),
                    extent: $785da19a645c07eb$var$Vu,
                    radius: this._pixelsToTileUnits(t.clusterRadius || 50),
                    log: !1,
                    generateId: t.generateId || !1
                }
            },
            clusterProperties: t.clusterProperties,
            filter: t.filter
        }, t.workerOptions);
    }
    _hasPendingWorkerUpdate() {
        return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.updateCluster;
    }
    _pixelsToTileUnits(e1) {
        return e1 * ($785da19a645c07eb$var$Vu / this.tileSize);
    }
    _tileUnitsToPixels(e1) {
        return e1 / ($785da19a645c07eb$var$Vu / this.tileSize);
    }
    _getClusterMaxZoom(e1) {
        let t = e1 ? Math.round(e1) : this.maxzoom - 1;
        return Number.isInteger(e1) || void 0 === e1 || $785da19a645c07eb$var$wh(`Integer expected for option 'clusterMaxZoom': provided value "${e1}" rounded to "${t}"`), t;
    }
    async load() {
        await this._updateWorkerData();
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    setData(e1) {
        return this._data = "string" == typeof e1 ? {
            url: e1
        } : {
            geojson: e1
        }, this._pendingWorkerUpdate = {
            data: e1
        }, this._updateWorkerData();
    }
    updateData(e1) {
        return this._pendingWorkerUpdate.diff = $785da19a645c07eb$var$ET(this._pendingWorkerUpdate.diff, e1), this._updateWorkerData();
    }
    async getData() {
        return this._data.url && await this.once("data"), this._data.geojson ? this._data.geojson : {
            type: "FeatureCollection",
            features: Array.from(this._data.updateable.values())
        };
    }
    async getBounds() {
        return $785da19a645c07eb$var$TT(await this.getData());
    }
    setClusterOptions(e1) {
        return this.workerOptions.geojsonVtOptions.cluster = e1.cluster, void 0 !== e1.clusterRadius && (this.workerOptions.geojsonVtOptions.clusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), void 0 !== e1.clusterMaxZoom && (this.workerOptions.geojsonVtOptions.clusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.updateCluster = !0, this._updateWorkerData();
    }
    getClusterOptions() {
        let { cluster: e1, clusterOptions: t } = this.workerOptions.geojsonVtOptions;
        return {
            cluster: e1,
            clusterMaxZoom: t.maxZoom,
            clusterRadius: this._tileUnitsToPixels(t.radius)
        };
    }
    async getClusterExpansionZoom(e1) {
        return (await this.actorPromise).sendAsync({
            type: "GCEZ",
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterChildren(e1) {
        return (await this.actorPromise).sendAsync({
            type: "GCC",
            data: {
                type: this.type,
                clusterId: e1,
                source: this.id
            }
        });
    }
    async getClusterLeaves(e1, t, i) {
        return (await this.actorPromise).sendAsync({
            type: "GCL",
            data: {
                type: this.type,
                source: this.id,
                clusterId: e1,
                limit: t,
                offset: i
            }
        });
    }
    async _updateWorkerData() {
        if (this._isUpdatingWorker) return this._updatePromise;
        if (!this._hasPendingWorkerUpdate()) return void $785da19a645c07eb$var$wh(`No pending worker updates for GeoJSONSource ${this.id}.`);
        let { data: e1, diff: t, updateCluster: i } = this._pendingWorkerUpdate, n = this._getLoadGeoJSONParameters(e1, t, i);
        void 0 === e1 ? t ? this._pendingWorkerUpdate.diff = void 0 : i && (this._pendingWorkerUpdate.updateCluster = void 0) : this._pendingWorkerUpdate.data = void 0, this._updatePromise = this._dispatchWorkerUpdate(n), await this._updatePromise;
    }
    async _getLoadGeoJSONParameters(e1, t, i) {
        let n = $785da19a645c07eb$var$hh({
            type: this.type,
            source: this.id
        }, this.workerOptions);
        return "string" == typeof e1 ? (n.request = await this.map._requestManager.transformRequest($785da19a645c07eb$var$iC.resolveURL(e1), "Source"), n.request.collectResourceTiming = this._collectResourceTiming, n) : void 0 !== e1 ? (n.data = e1, n) : t ? (n.dataDiff = t, n) : i ? (n.updateCluster = !0, n) : void 0;
    }
    async _dispatchWorkerUpdate(e1) {
        this._isUpdatingWorker = !0, this.fire(new $785da19a645c07eb$var$dC("dataloading"));
        try {
            let t = await e1, i = await (await this.actorPromise).sendAsync({
                type: "LD",
                data: t
            });
            if (this._isUpdatingWorker = !1, this._removed || i.abandoned) return void this.fire(new $785da19a645c07eb$var$dC("dataabort"));
            i.data && (this._data = {
                geojson: i.data
            });
            let n = this._applyDiffToSource(t.dataDiff), a = this._getShouldReloadTileOptions(n), r = {};
            this._applyResourceTiming(r, i), this.fire(new $785da19a645c07eb$var$dC("data", {
                ...r,
                sourceDataType: "metadata"
            })), this.fire(new $785da19a645c07eb$var$dC("data", {
                ...r,
                sourceDataType: "content",
                shouldReloadTileOptions: a
            }));
        } catch (e1) {
            if (this._isUpdatingWorker = !1, this._removed) return void this.fire(new $785da19a645c07eb$var$dC("dataabort"));
            this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        } finally{
            this._hasPendingWorkerUpdate() && await this._updateWorkerData();
        }
    }
    _applyResourceTiming(e1, t) {
        if (!this._collectResourceTiming) return;
        let i = t.resourceTiming?.[this.id];
        if (!i) return;
        let n = i.slice(0);
        n?.length && $785da19a645c07eb$var$hh(e1, {
            resourceTiming: n
        });
    }
    _applyDiffToSource(e1) {
        if (!e1) return;
        let t = "string" == typeof this.promoteId ? this.promoteId : void 0;
        if (!this._data.url && !this._data.updateable) {
            let e1 = function(e1, t) {
                let i = new Map;
                if (null == e1 || null == e1.type) return i;
                if ("Feature" === e1.type) {
                    let n = $785da19a645c07eb$var$wT(e1, t);
                    return null == n ? void 0 : (i.set(n, e1), i);
                }
                if ("FeatureCollection" === e1.type) {
                    let n = new Set;
                    for (let a of e1.features){
                        let e1 = $785da19a645c07eb$var$wT(a, t);
                        if (null == e1 || n.has(e1)) return;
                        n.add(e1), i.set(e1, a);
                    }
                    return i;
                }
            }(this._data.geojson, t);
            if (!e1) throw Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
            this._data = {
                updateable: e1
            };
        }
        if (!this._data.updateable) return;
        let i = function(e1, t, i) {
            let n = [];
            if (t.removeAll) e1.clear();
            else if (t.remove) for (let i of t.remove){
                let t = e1.get(i);
                t && (n.push(t.geometry), e1.delete(i));
            }
            if (t.add) for (let a of t.add){
                let t = $785da19a645c07eb$var$wT(a, i);
                if (null == t) continue;
                let r = e1.get(t);
                r && n.push(r.geometry), n.push(a.geometry), e1.set(t, a);
            }
            if (t.update) for (let i of t.update){
                let t = e1.get(i.id);
                if (!t) continue;
                let a = !!i.newGeometry, r = i.removeAllProperties || i.removeProperties?.length > 0 || i.addOrUpdateProperties?.length > 0;
                if (!a && !r) continue;
                n.push(t.geometry);
                let s = {
                    ...t
                };
                if (e1.set(i.id, s), a && (n.push(i.newGeometry), s.geometry = i.newGeometry), r) {
                    if (s.properties = i.removeAllProperties ? {} : {
                        ...s.properties || {}
                    }, i.removeProperties) for (let e1 of i.removeProperties)delete s.properties[e1];
                    if (i.addOrUpdateProperties) for (let { key: e1, value: t } of i.addOrUpdateProperties)s.properties[e1] = t;
                }
            }
            return n;
        }(this._data.updateable, e1, t);
        return e1.removeAll || this._options.cluster ? void 0 : i;
    }
    _getShouldReloadTileOptions(e1) {
        if (e1) return {
            affectedBounds: e1.filter(Boolean).map((e1)=>$785da19a645c07eb$var$TT(e1))
        };
    }
    shouldReloadTile(e1, { affectedBounds: t }) {
        if ("loading" === e1.state) return !0;
        if ("unloaded" === e1.state) return !1;
        let { buffer: i, extent: n } = this.workerOptions.geojsonVtOptions, a = function({ x: e1, y: t, z: i }, n = 0) {
            let a = $785da19a645c07eb$var$Fx((e1 - n) / 2 ** i), r = $785da19a645c07eb$var$zx((t + 1 + n) / 2 ** i), s = $785da19a645c07eb$var$Fx((e1 + 1 + n) / 2 ** i), o = $785da19a645c07eb$var$zx((t - n) / 2 ** i);
            return new $785da19a645c07eb$var$_T([
                a,
                r
            ], [
                s,
                o
            ]);
        }(e1.tileID.canonical, i / n);
        for (let e1 of t)if (a.intersects(e1)) return !0;
        return !1;
    }
    loaded() {
        return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
    }
    async loadTile(e1) {
        let t = e1.actor ? "RT" : "LT";
        e1.actor = await this.actorPromise;
        let i = {
            type: this.type,
            uid: e1.uid,
            tileID: e1.tileID,
            zoom: e1.tileID.overscaledZ,
            maxZoom: this.maxzoom,
            tileSize: this.tileSize,
            source: this.id,
            pixelRatio: this.map.getPixelRatio(),
            showCollisionBoxes: this.map.showCollisionBoxes,
            promoteId: this.promoteId,
            subdivisionGranularity: this.map.style.projection.subdivisionGranularity
        };
        e1.abortController = new AbortController;
        try {
            let n = await (await this.actorPromise).sendAsync({
                type: t,
                data: i
            }, e1.abortController);
            delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(n, this.map.painter, "RT" === t);
        } catch (t) {
            if (delete e1.abortController, e1.aborted || $785da19a645c07eb$var$qh(t)) return;
            throw t;
        }
    }
    async abortTile(e1) {
        e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
    }
    async unloadTile(e1) {
        e1.unloadVectorData(), await (await this.actorPromise).sendAsync({
            type: "RMT",
            data: {
                uid: e1.uid,
                type: this.type,
                source: this.id
            }
        });
    }
    onRemove() {
        this._removed = !0, this.actorPromise.then((e1)=>e1.sendAsync({
                type: "RS",
                data: {
                    type: this.type,
                    source: this.id
                }
            }));
    }
    serialize() {
        return $785da19a645c07eb$var$hh({}, this._options, {
            type: this.type,
            data: this._data.updateable ? {
                type: "FeatureCollection",
                features: Array.from(this._data.updateable.values())
            } : this._data.url || this._data.geojson
        });
    }
    hasTransition() {
        return !1;
    }
};
const $785da19a645c07eb$var$PT = [
    0,
    0,
    1
], $785da19a645c07eb$var$IT = (e1, t, i, n, a, r)=>({
        u_tl_parent: e1,
        u_scale_parent: t,
        u_buffer_scale: 1,
        u_image_warp: r,
        u_fade_t: i.mix,
        u_opacity: i.opacity * n.paint.get("raster-opacity"),
        u_image0: 0,
        u_image1: 1,
        u_brightness_low: n.paint.get("raster-brightness-min"),
        u_brightness_high: n.paint.get("raster-brightness-max"),
        u_saturation_factor: $785da19a645c07eb$var$RT(n.paint.get("raster-saturation")),
        u_contrast_factor: $785da19a645c07eb$var$zT(n.paint.get("raster-contrast")),
        u_spin_weights: $785da19a645c07eb$var$FT(n.paint.get("raster-hue-rotate")),
        u_coords_top: [
            a[0].x,
            a[0].y,
            a[1].x,
            a[1].y
        ],
        u_coords_bottom: [
            a[3].x,
            a[3].y,
            a[2].x,
            a[2].y
        ]
    });
function $785da19a645c07eb$var$FT(e1) {
    e1 *= Math.PI / 180;
    let t = Math.sin(e1), i = Math.cos(e1);
    return [
        (2 * i + 1) / 3,
        (-Math.sqrt(3) * t - i + 1) / 3,
        (Math.sqrt(3) * t - i + 1) / 3
    ];
}
function $785da19a645c07eb$var$zT(e1) {
    return e1 > 0 ? 1 / (1 - e1) : 1 + e1;
}
function $785da19a645c07eb$var$RT(e1) {
    return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
}
var $785da19a645c07eb$var$LT = class {
    constructor(e1, t, i){
        this.vertexBuffer = e1, this.indexBuffer = t, this.segments = i;
    }
    destroy() {
        this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
    }
};
const $785da19a645c07eb$var$BT = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        type: "Int16",
        components: 2
    }
]);
function $785da19a645c07eb$var$OT(e1, t) {
    let i = function(e1, t) {
        let i = void 0 === e1.granularity ? 1 : Math.max(e1.granularity, 1), n = i + (e1.generateBorders ? 2 : 0), a = i + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), r = n + 1, s = a + 1, o = e1.generateBorders ? -1 : 0, l = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, c = i + +!!e1.generateBorders, u = i + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), h = r * s, d = n * a * 6, p = r * s > 65536;
        if (p && "16bit" === t) throw Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
        let m = p || "32bit" === t, g = new Int16Array(2 * h), f = 0;
        for(let t = l; t <= u; t++)for(let n = o; n <= c; n++){
            let a = n / i * $785da19a645c07eb$var$Vu;
            -1 === n && (a = -64), n === i + 1 && (a = 8256);
            let r = t / i * $785da19a645c07eb$var$Vu;
            -1 === t && (r = e1.extendToNorthPole ? $785da19a645c07eb$var$ex : -64), t === i + 1 && (r = e1.extendToSouthPole ? $785da19a645c07eb$var$tx : 8256), g[f++] = a, g[f++] = r;
        }
        let A = m ? new Uint32Array(d) : new Uint16Array(d), _ = 0;
        for(let e1 = 0; e1 < a; e1++)for(let t = 0; t < n; t++){
            let i = t + e1 * r, n = t + 1 + e1 * r, a = t + (e1 + 1) * r, s = t + 1 + (e1 + 1) * r;
            A[_++] = i, A[_++] = a, A[_++] = n, A[_++] = n, A[_++] = a, A[_++] = s;
        }
        return {
            vertices: g.buffer.slice(0),
            indices: A.buffer.slice(0),
            uses32bitIndices: m
        };
    }(t, "16bit"), n = $785da19a645c07eb$var$l_.deserialize({
        arrayBuffer: i.vertices,
        length: i.vertices.byteLength / 2 / 2
    }), a = $785da19a645c07eb$var$k_.deserialize({
        arrayBuffer: i.indices,
        length: i.indices.byteLength / 2 / 3
    });
    return new $785da19a645c07eb$var$LT(e1.createVertexBuffer(n, $785da19a645c07eb$var$BT.members), e1.createIndexBuffer(a), $785da19a645c07eb$var$T_.simpleSegment(0, 0, n.length, a.length));
}
var $785da19a645c07eb$var$UT = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t, i, n){
        super(), this.imageWarp = $785da19a645c07eb$var$PT, this.flippedWindingOrder = !1, this._warp = "auto", this._imageDirty = !1, this._subdividedQuad = !1, this._subdividedMesh = null, this.id = e1, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(n), this.options = t;
    }
    async load(e1) {
        if (void 0 === this.options.url) return this._loaded = !0, void this._finishLoading();
        this._loaded = !1, this.fire(new $785da19a645c07eb$var$dC("dataloading")), this.url = this.options.url, this._abortController = new AbortController;
        try {
            let t = await $785da19a645c07eb$var$sC.transformAndGetImage(this.map._requestManager, this.url, "Image", this._abortController);
            this._abortController = null, this._loaded = !0, t?.data ? (this._setImage(t.data), e1 && (this.coordinates = e1), this._finishLoading()) : this.fire(new $785da19a645c07eb$var$ad(Error(`Could not load image ${this.url}: the response is empty`)));
        } catch (e1) {
            if ($785da19a645c07eb$var$qh(e1)) return;
            this._abortController = null, this._loaded = !0, this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        }
    }
    loaded() {
        return this._loaded;
    }
    updateImage(e1) {
        return this._abortController &&= (this._abortController.abort(), null), "image" in e1 ? (this._loaded = !0, this._setImage(e1.image), e1.coordinates && (this.coordinates = e1.coordinates), this._finishLoading(), this) : e1.url ? (this.options.url = e1.url, this.load(e1.coordinates), this) : this;
    }
    _setImage(e1) {
        this.image = e1, this._imageDirty = !0;
    }
    getMesh(e1, t) {
        return !this._subdividedQuad || t ? null : (this._subdividedMesh ??= $785da19a645c07eb$var$OT(e1, {
            granularity: 16
        }), this._subdividedMesh);
    }
    _disposeTexture() {
        this.texture?.destroy(), this.texture = null;
    }
    _finishLoading() {
        this.map && (this.setCoordinates(this.coordinates), this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "metadata"
        })));
    }
    onAdd(e1) {
        this.map = e1, this.load();
    }
    onRemove() {
        this._abortController &&= (this._abortController.abort(), null), this._disposeTexture(), this._subdividedMesh?.destroy(), this._subdividedMesh = null, this.image = null, this.tiles = {};
    }
    setWarp(e1) {
        return this._warp === e1 || (this._warp = e1, this.tileCoords && this.setCoordinates(this.coordinates)), this;
    }
    getWarp() {
        return this._warp;
    }
    setCoordinates(e1) {
        this.coordinates = e1;
        let t = e1.map($785da19a645c07eb$var$Lx.fromLngLat);
        return this.tileID = function(e1) {
            let t = $785da19a645c07eb$var$fx.fromPoints(e1), i = t.width(), n = t.height(), a = Math.max(0, Math.floor(-Math.log(Math.max(i, n)) / Math.LN2)), r = 2 ** a;
            return new $785da19a645c07eb$var$WE(a, Math.floor((t.minX + t.maxX) / 2 * r), Math.floor((t.minY + t.maxY) / 2 * r));
        }(t), this.terrainTileRanges = this._getOverlappingTileRanges(t), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = t.map((e1)=>this.tileID.getTilePoint(e1)._round()), this.imageWarp = function(e1, t) {
            if ("flat" === t || $785da19a645c07eb$var$NT(e1)) return $785da19a645c07eb$var$PT;
            let [i, n, a, r] = e1, s = i.x - n.x + a.x - r.x, o = i.y - n.y + a.y - r.y, l = [
                n.x - a.x,
                n.y - a.y,
                r.x - a.x,
                r.y - a.y
            ], [c, u, h, d] = l, p = function(e1) {
                return e1[0] * e1[3] - e1[2] * e1[1];
            }(l), m = (s * d - h * o) / p, g = (c * o - s * u) / p, f = [
                1,
                1 + m,
                1 + m + g,
                1 + g
            ], A = Math.max(...f) / Math.min(...f), _ = "perspective" === t ? 0 : function(e1) {
                let t = (1 - 4 / e1) / (1 - 4 / 512);
                return Math.max(0, t);
            }(A);
            return !(A >= 1 && A <= 512) || _ >= 1 ? $785da19a645c07eb$var$PT : [
                m,
                g,
                _
            ];
        }(this.tileCoords, this._warp), this._subdividedQuad = this.imageWarp[2] > 0 && !$785da19a645c07eb$var$NT(this.tileCoords), this.flippedWindingOrder = function(e1) {
            let t = e1[1].x - e1[0].x, i = e1[1].y - e1[0].y, n = e1[2].x - e1[0].x;
            return t * (e1[2].y - e1[0].y) - i * n < 0;
        }(this.tileCoords), this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "content"
        })), this;
    }
    prepare() {
        if (0 === Object.keys(this.tiles).length || !this.image) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this._imageDirty && (this.texture.update(this.image), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)) : (this.texture = new $785da19a645c07eb$var$ry(e1, this.image, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE)), this._imageDirty = !1;
        let i = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, i = !0);
        }
        i && this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "idle",
            sourceId: this.id
        }));
    }
    async loadTile(e1) {
        this.tileID?.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = "errored";
    }
    serialize() {
        let e1 = {
            type: "image",
            coordinates: this.coordinates
        };
        return void 0 !== this.options.url && (e1.url = this.options.url), e1;
    }
    hasTransition() {
        return !1;
    }
    _getOverlappingTileRanges(e1) {
        let { minX: t, minY: i, maxX: n, maxY: a } = $785da19a645c07eb$var$fx.fromPoints(e1), r = {};
        for(let e1 = 0; e1 <= 25; e1++){
            let s = 2 ** e1, o = Math.floor(t * s), l = Math.floor(i * s), c = Math.floor(n * s), u = Math.floor(a * s), h = (o % s + s) % s, d = c % s, p = Math.floor(o / s), m = Math.floor(c / s);
            r[e1] = {
                minWrap: p,
                maxWrap: m,
                minTileXWrapped: h,
                maxTileXWrapped: d,
                minTileY: l,
                maxTileY: u
            };
        }
        return r;
    }
};
function $785da19a645c07eb$var$NT(e1) {
    let [t, i, n, a] = e1;
    return t.x + n.x === i.x + a.x && t.y + n.y === i.y + a.y;
}
var $785da19a645c07eb$var$jT = class extends $785da19a645c07eb$var$UT {
    constructor(e1, t, i, n){
        super(e1, t, i, n), this._onPlayingHandler = ()=>{
            this.map?.triggerRepaint();
        }, this.roundZoom = !0, this.type = "video", this.options = t;
    }
    async load() {
        this._loaded = !1;
        let e1 = this.options;
        this.urls = [];
        for (let t of e1.urls)this.urls.push((await this.map._requestManager.transformRequest(t, "Source")).url);
        try {
            let e1 = await ((e1)=>{
                let t = window.document.createElement("video");
                return t.muted = !0, new Promise((i)=>{
                    t.onloadstart = ()=>{
                        i(t);
                    };
                    for (let i of e1){
                        let e1 = window.document.createElement("source");
                        $785da19a645c07eb$var$ed(i) || (t.crossOrigin = "Anonymous"), e1.src = i, t.appendChild(e1);
                    }
                });
            })(this.urls);
            if (this._loaded = !0, !e1) return;
            this.video = e1, this.video.loop = !0, this.video.addEventListener("playing", this._onPlayingHandler), this.map && this.video.play(), this._finishLoading();
        } catch (e1) {
            this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        }
    }
    pause() {
        this.video && this.video.pause();
    }
    play() {
        this.video && this.video.play();
    }
    seek(e1) {
        if (this.video) {
            let t = this.video.seekable;
            e1 < t.start(0) || e1 > t.end(0) ? this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
        }
    }
    getVideo() {
        return this.video;
    }
    onAdd(e1) {
        this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
    }
    onRemove() {
        super.onRemove(), this.video && (this.video.removeEventListener("playing", this._onPlayingHandler), this.video.pause());
    }
    prepare() {
        if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
        let e1 = this.map.painter.context, t = e1.gl;
        this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new $785da19a645c07eb$var$ry(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE));
        let i = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, i = !0);
        }
        i && this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "idle",
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: "video",
            urls: this.urls,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this.video && !this.video.paused;
    }
}, $785da19a645c07eb$var$VT = class extends $785da19a645c07eb$var$UT {
    constructor(e1, t, i, n){
        super(e1, t, i, n), t.coordinates ? (!Array.isArray(t.coordinates) || 4 !== t.coordinates.length || t.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1))) && this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${e1}`, null, 'missing required property "coordinates"'))), t.animate && "boolean" != typeof t.animate && this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), t.canvas ? "string" != typeof t.canvas && !(t.canvas instanceof HTMLCanvasElement) && this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new $785da19a645c07eb$var$ad(new $785da19a645c07eb$var$cd(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = t, this.animate = void 0 === t.animate || t.animate;
    }
    async load() {
        this._loaded = !0, this.canvas ||= this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new $785da19a645c07eb$var$ad(Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
            this._playing = !0, this.map.triggerRepaint();
        }, this.pause = function() {
            this._playing &&= (this.prepare(), !1);
        }, this._finishLoading());
    }
    getCanvas() {
        return this.canvas;
    }
    onAdd(e1) {
        this.map = e1, this.load(), this.canvas && this.animate && this.play();
    }
    onRemove() {
        this._playing = !1, super.onRemove();
    }
    prepare() {
        let e1 = !1;
        if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions() || 0 === Object.keys(this.tiles).length) return;
        let t = this.map.painter.context, i = t.gl;
        this.texture ? (e1 || this._playing) && this.texture.update(this.canvas, {
            premultiply: !0
        }) : (this.texture = new $785da19a645c07eb$var$ry(t, this.canvas, i.RGBA, {
            premultiply: !0
        }), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
        let n = !1;
        for(let e1 in this.tiles){
            let t = this.tiles[e1];
            "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture, n = !0);
        }
        n && this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "idle",
            sourceId: this.id
        }));
    }
    serialize() {
        return {
            type: "canvas",
            animate: this.animate,
            canvas: this.options.canvas,
            coordinates: this.coordinates
        };
    }
    hasTransition() {
        return this._playing;
    }
    _hasInvalidDimensions() {
        for (let e1 of [
            this.canvas.width,
            this.canvas.height
        ])if (isNaN(e1) || e1 <= 0) return !0;
        return !1;
    }
};
const $785da19a645c07eb$var$qT = {}, $785da19a645c07eb$var$GT = (e1)=>{
    switch(e1){
        case "geojson":
            return $785da19a645c07eb$var$DT;
        case "image":
            return $785da19a645c07eb$var$UT;
        case "raster":
            return $785da19a645c07eb$var$xT;
        case "raster-dem":
            return $785da19a645c07eb$var$bT;
        case "vector":
            return $785da19a645c07eb$var$yT;
        case "video":
            return $785da19a645c07eb$var$jT;
        case "canvas":
            return $785da19a645c07eb$var$VT;
    }
    return $785da19a645c07eb$var$qT[e1];
};
const $785da19a645c07eb$var$HT = "RTLPluginLoaded";
var $785da19a645c07eb$var$WT = class extends $785da19a645c07eb$var$rd {
    constructor(...e1){
        super(...e1), this.status = "unavailable", this.url = null, this.dispatcher = ($785da19a645c07eb$var$hT || ($785da19a645c07eb$var$hT = new $785da19a645c07eb$var$uT($785da19a645c07eb$var$cT(), $785da19a645c07eb$var$Kh), $785da19a645c07eb$var$hT.registerMessageHandler("GR", (e1, t, i)=>$785da19a645c07eb$var$Yh(t, i))), $785da19a645c07eb$var$hT);
    }
    _syncState(e1) {
        return this.status = e1, this.dispatcher.broadcast("SRPS", {
            pluginStatus: e1,
            pluginURL: this.url
        }).catch((e1)=>{
            throw this.status = "error", e1;
        });
    }
    getRTLTextPluginStatus() {
        return this.status;
    }
    clearRTLTextPlugin() {
        this.status = "unavailable", this.url = null;
    }
    async setRTLTextPlugin(e1, t = !1) {
        if (this.url) throw Error("setRTLTextPlugin cannot be called multiple times.");
        if (this.url = $785da19a645c07eb$var$iC.resolveURL(e1), !this.url) throw Error(`requested url ${e1} is invalid`);
        if ("unavailable" === this.status) {
            if (!t) return this._requestImport();
            this.status = "deferred", this._syncState(this.status);
        } else if ("requested" === this.status) return this._requestImport();
    }
    async _requestImport() {
        await this._syncState("loading"), this.status = "loaded", this.fire(new $785da19a645c07eb$var$nd($785da19a645c07eb$var$HT));
    }
    lazyLoad() {
        "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
    }
};
let $785da19a645c07eb$var$ZT = null;
function $785da19a645c07eb$var$KT() {
    return $785da19a645c07eb$var$ZT ||= new $785da19a645c07eb$var$WT, $785da19a645c07eb$var$ZT;
}
var $785da19a645c07eb$var$XT = class {
    constructor(e1, t){
        this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = $785da19a645c07eb$var$mh(), this.uses = 0, this.tileSize = t, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rttObjects = [], this.rttFingerprint = {}, this.expiredRequestCount = 0, this.state = "loading", this.featureStateRevision = -1;
    }
    isRenderable(e1) {
        return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
    }
    setCrossFadeLogic({ fadingRole: e1, fadingDirection: t, fadingParentID: i, fadeEndTime: n }) {
        this.resetFadeLogic(), this.fadingRole = e1, this.fadingDirection = t, this.fadingParentID = i, this.fadeEndTime = n;
    }
    setSelfFadeLogic(e1) {
        this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
    }
    resetFadeLogic() {
        this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = $785da19a645c07eb$var$aC(), this.fadeEndTime = 0, this.fadeOpacity = 1;
    }
    wasRequested() {
        return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
    }
    clearTextures(e1) {
        this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
    }
    getRTT(e1) {
        return this.rttObjects[e1];
    }
    acquireRTT(e1, t, i) {
        return this.rttObjects[t] = e1.acquireRTT(i);
    }
    releaseRTT(e1) {
        if (0 !== this.rttObjects.length) {
            for (let t of this.rttObjects)t && e1.releaseRTT(t);
            this.rttObjects.length = 0;
        }
    }
    loadVectorData(e1, t, i) {
        if (!0 !== e1?.etagUnmodified) {
            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestEncoding = e1.encoding, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                    let i = {};
                    if (!t) return i;
                    for (let n of e1){
                        let e1 = n.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
                        if (0 !== e1.length) {
                            n.layers = e1, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
                            for (let t of e1)i[t.id] = n;
                        }
                    }
                    return i;
                }(e1.buckets, t?.style), this.hasSymbolBuckets = !1;
                for(let e1 in this.buckets){
                    let t = this.buckets[e1];
                    if (t instanceof $785da19a645c07eb$var$DE) {
                        if (this.hasSymbolBuckets = !0, !i) break;
                        t.justReloaded = !0;
                    }
                }
                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(let e1 in this.buckets){
                    let t = this.buckets[e1];
                    if (t instanceof $785da19a645c07eb$var$DE && t.hasRTLText) {
                        this.hasRTLText = !0, $785da19a645c07eb$var$KT().lazyLoad();
                        break;
                    }
                }
                this.queryPadding = 0;
                for(let e1 in this.buckets){
                    let i = this.buckets[e1];
                    this.queryPadding = Math.max(this.queryPadding, t.style.getLayer(e1).queryRadius(i));
                }
                e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
            } else this.collisionBoxArray = new $785da19a645c07eb$var$YA;
        } else this.state = "loaded";
    }
    unloadVectorData() {
        for(let e1 in this.buckets)this.buckets[e1].destroy();
        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.imageAtlas = null, this.dashPositions = null, this.latestFeatureIndex = null, this.state = "unloaded";
    }
    getBucket(e1) {
        return this.buckets[e1.id];
    }
    upload(e1) {
        for(let t in this.buckets){
            let i = this.buckets[t];
            i.uploadPending() && i.upload(e1);
        }
        let t = e1.gl;
        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new $785da19a645c07eb$var$ry(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage &&= (this.glyphAtlasTexture = new $785da19a645c07eb$var$ry(e1, this.glyphAtlasImage, t.ALPHA), null);
    }
    prepare(e1) {
        this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
    }
    queryRenderedFeatures(e1, t, i, n, a, r, s, o, l, c, u) {
        return this.latestFeatureIndex?.rawTileData ? this.latestFeatureIndex.query({
            queryGeometry: n,
            cameraQueryGeometry: a,
            scale: r,
            tileSize: this.tileSize,
            pixelPosMatrix: c,
            transform: o,
            params: s,
            queryPadding: this.queryPadding * l,
            getElevation: u
        }, e1, t, i) : {};
    }
    querySourceFeatures(e1, t) {
        let i = this.latestFeatureIndex;
        if (!i?.rawTileData) return;
        let n = i.loadVTLayers(), a = t?.sourceLayer ? t.sourceLayer : "", r = n._geojsonTileLayer || n[a];
        if (!r) return;
        let s = $785da19a645c07eb$var$jg(t?.filter, `querySourceFeatures[${a}].filter`, t?.globalState), { z: o, x: l, y: c } = this.tileID.canonical, u = {
            z: o,
            x: l,
            y: c
        };
        for(let t = 0; t < r.length; t++){
            let n = r.feature(t);
            if (s.needGeometry) {
                let e1 = $785da19a645c07eb$var$dv(n, !0);
                if (!s.filter(new $785da19a645c07eb$var$Qf(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
            } else if (!s.filter(new $785da19a645c07eb$var$Qf(this.tileID.overscaledZ), n)) continue;
            let h = i.getId(n, a), d = new $785da19a645c07eb$var$tk(n, o, l, c, h);
            d.tile = u, e1.push(d);
        }
    }
    hasData() {
        return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
    }
    patternsLoaded() {
        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
    }
    setExpiryData(e1) {
        let t = this.expirationTime;
        if (e1.cacheControl) {
            let t = function(e1) {
                let t = {};
                if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, i, n, a)=>{
                    let r = n || a;
                    return t[i] = !r || r.toLowerCase(), "";
                }), t["max-age"]) {
                    let e1 = parseInt(t["max-age"], 10);
                    isNaN(e1) ? delete t["max-age"] : t["max-age"] = e1;
                }
                return t;
            }(e1.cacheControl);
            t["max-age"] && (this.expirationTime = Date.now() + 1e3 * t["max-age"]);
        } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
        if (this.expirationTime) {
            let e1 = Date.now(), i = !1;
            if (this.expirationTime > e1) i = !1;
            else if (t) {
                if (this.expirationTime < t) i = !0;
                else {
                    let n = this.expirationTime - t;
                    n ? this.expirationTime = e1 + Math.max(n, 3e4) : i = !0;
                }
            } else i = !0;
            i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
        }
    }
    getExpiryTimeout() {
        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), 2 ** 31 - 1);
    }
    setFeatureState(e1, t, i) {
        if (!this.latestFeatureIndex?.rawTileData || 0 === Object.keys(e1).length || this.featureStateRevision === i) return;
        this.featureStateRevision = i;
        let n = this.latestFeatureIndex.loadVTLayers();
        for(let i in this.buckets){
            if (!t.style.hasLayer(i)) continue;
            let a = this.buckets[i], r = a.layers[0].sourceLayer || "_geojsonTileLayer", s = n[r], o = e1[r];
            if (!s || !o || 0 === o.length) continue;
            a.update(o, s, this.imageAtlas?.patternPositions || {}, this.dashPositions || {});
            let l = t?.style?.getLayer(i);
            l && (this.queryPadding = Math.max(this.queryPadding, l.queryRadius(a)));
        }
    }
    holdingForSymbolFade() {
        return void 0 !== this.symbolFadeHoldUntil;
    }
    symbolFadeFinished() {
        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < $785da19a645c07eb$var$aC();
    }
    clearSymbolFadeHold() {
        this.symbolFadeHoldUntil = void 0;
    }
    setSymbolHoldDuration(e1) {
        this.symbolFadeHoldUntil = $785da19a645c07eb$var$aC() + e1;
    }
    setDependencies(e1, t) {
        let i = {};
        for (let e1 of t)i[e1] = !0;
        this.dependencies[e1] = i;
    }
    hasDependency(e1, t) {
        for (let i of e1){
            let e1 = this.dependencies[i];
            if (e1) {
                for (let i of t)if (e1[i]) return !0;
            }
        }
        return !1;
    }
};
function $785da19a645c07eb$var$QT(e1) {
    let t = [];
    for(let i in e1)t.push({
        id: i,
        state: e1[i]
    });
    return t;
}
var $785da19a645c07eb$var$YT = class {
    constructor(){
        this.state = {}, this.stateChanges = {}, this.deletedStates = {}, this.revision = 0;
    }
    updateState(e1, t, i) {
        let n = String(t);
        if (this.stateChanges[e1] ||= {}, this.stateChanges[e1][n] ||= {}, $785da19a645c07eb$var$hh(this.stateChanges[e1][n], i), null === this.deletedStates[e1]) {
            this.deletedStates[e1] = {};
            for(let t in this.state[e1])if (t === n) {
                this.deletedStates[e1][n] = {};
                for(let a in this.state[e1][t])void 0 === i[a] && (this.deletedStates[e1][n][a] = null);
            } else this.deletedStates[e1][t] = null;
        } else if (null === this.deletedStates[e1]?.[n]) {
            this.deletedStates[e1][n] = {};
            for(let t in this.state[e1][n])void 0 === i[t] && (this.deletedStates[e1][n][t] = null);
        } else for(let t in i)null === this.deletedStates[e1]?.[n]?.[t] && delete this.deletedStates[e1][n][t];
    }
    removeFeatureState(e1, t, i) {
        if (null === this.deletedStates[e1]) return;
        let n = String(t);
        if (this.deletedStates[e1] ||= {}, i && void 0 !== t) null !== this.deletedStates[e1][n] && (this.deletedStates[e1][n] ||= {}, this.deletedStates[e1][n][i] = null);
        else if (void 0 !== t) {
            if (this.stateChanges[e1]?.[n]) for(i in this.deletedStates[e1][n] = {}, this.stateChanges[e1][n])this.deletedStates[e1][n][i] = null;
            else this.deletedStates[e1][n] = null;
        } else this.deletedStates[e1] = null;
    }
    getState(e1, t) {
        let i = String(t), n = this.state[e1] || {}, a = this.stateChanges[e1] || {}, r = $785da19a645c07eb$var$hh({}, n[i], a[i]);
        if (null === this.deletedStates[e1]) return {};
        if (this.deletedStates[e1]) {
            let i = this.deletedStates[e1][t];
            if (null === i) return {};
            for(let e1 in i)delete r[e1];
        }
        return r;
    }
    initializeTileState(e1, t) {
        let i = {};
        for(let e1 in this.state)i[e1] = $785da19a645c07eb$var$QT(this.state[e1]);
        e1.setFeatureState(i, t, this.revision);
    }
    coalesceChanges(e1, t) {
        let i = {};
        for(let e1 in this.stateChanges){
            this.state[e1] ||= {}, i[e1] ||= {};
            for(let t in this.stateChanges[e1])this.state[e1][t] ||= {}, $785da19a645c07eb$var$hh(this.state[e1][t], this.stateChanges[e1][t]), i[e1][t] = this.state[e1][t];
        }
        for(let e1 in this.deletedStates)if (this.state[e1] ||= {}, i[e1] ||= {}, null === this.deletedStates[e1]) for(let t in this.state[e1])this.state[e1][t] = {}, i[e1][t] = {};
        else for(let t in this.deletedStates[e1]){
            if (null === this.deletedStates[e1][t]) this.state[e1][t] = {};
            else for (let i of Object.keys(this.deletedStates[e1][t]))delete this.state[e1][t][i];
            i[e1][t] = this.state[e1][t];
        }
        if (this.stateChanges = {}, this.deletedStates = {}, 0 === Object.keys(i).length) return;
        this.revision++;
        let n = {};
        for(let e1 in i)n[e1] = $785da19a645c07eb$var$QT(i[e1]);
        e1.setFeatureState(n, t, this.revision);
    }
}, $785da19a645c07eb$var$JT = class e1 {
    constructor(e1, t){
        this.min = e1, this.max = t, this.center = $785da19a645c07eb$var$vu([], $785da19a645c07eb$var$Au([], this.min, this.max), .5);
    }
    quadrant(t) {
        let i = [
            t % 2 == 0,
            t < 2
        ], n = $785da19a645c07eb$var$mu(this.min), a = $785da19a645c07eb$var$mu(this.max);
        for(let e1 = 0; e1 < i.length; e1++)n[e1] = i[e1] ? this.min[e1] : this.center[e1], a[e1] = i[e1] ? this.center[e1] : this.max[e1];
        return a[2] = this.max[2], new e1(n, a);
    }
    distanceX(e1) {
        return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
    }
    distanceY(e1) {
        return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
    }
    intersectsFrustum(e1) {
        let t = !0;
        for (let i of e1.planes){
            let e1 = this.intersectsPlane(i);
            if (0 === e1) return 0;
            1 === e1 && (t = !1);
        }
        return t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
    }
    intersectsPlane(e1) {
        let t = e1[3], i = e1[3];
        for(let n = 0; n < 3; n++)e1[n] > 0 ? (t += e1[n] * this.min[n], i += e1[n] * this.max[n]) : (i += e1[n] * this.min[n], t += e1[n] * this.max[n]);
        return t >= 0 ? 2 : i < 0 ? 0 : 1;
    }
}, $785da19a645c07eb$var$$T = class e1 {
    constructor(e1, t, i){
        this.points = e1, this.planes = t, this.aabb = i;
    }
    static fromInvProjectionMatrix(t, i = 1, n = 0, a, r) {
        let s = r ? [
            [
                6,
                5,
                4
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ] : [
            [
                0,
                1,
                2
            ],
            [
                6,
                5,
                4
            ],
            [
                0,
                3,
                7
            ],
            [
                2,
                1,
                5
            ],
            [
                3,
                2,
                6
            ],
            [
                0,
                4,
                5
            ]
        ], o = 2 ** n, l = [
            [
                -1,
                1,
                -1,
                1
            ],
            [
                1,
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1,
                1
            ],
            [
                -1,
                -1,
                -1,
                1
            ],
            [
                -1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1
            ],
            [
                1,
                -1,
                1,
                1
            ],
            [
                -1,
                -1,
                1,
                1
            ]
        ].map((e1)=>(function(e1, t, i, n) {
                let a = $785da19a645c07eb$var$Du([], e1, t), r = 1 / a[3] / i * n;
                return $785da19a645c07eb$var$Pu(a, a, [
                    r,
                    r,
                    1 / a[3],
                    r
                ]);
            })(e1, t, i, o));
        a && function(e1, t, i, n) {
            let a = n ? 4 : 0, r = n ? 0 : 4, s = 0, o = [], l = [];
            for(let t = 0; t < 4; t++){
                let i = $785da19a645c07eb$var$Cu([], e1[t + r], e1[t + a]), n = $785da19a645c07eb$var$gu(i);
                $785da19a645c07eb$var$vu(i, i, 1 / n), o.push(n), l.push(i);
            }
            for(let t = 0; t < 4; t++){
                let n = $785da19a645c07eb$var$$u(e1[t + a], l[t], i);
                s = null !== n && n >= 0 ? Math.max(s, n) : Math.max(s, o[t]);
            }
            let c = function(e1, t) {
                let i = $785da19a645c07eb$var$Cu([], e1[t[0]], e1[t[1]]), n = $785da19a645c07eb$var$Cu([], e1[t[2]], e1[t[1]]), a = [
                    0,
                    0,
                    0,
                    0
                ];
                return $785da19a645c07eb$var$xu(a, $785da19a645c07eb$var$wu([], i, n)), a[3] = -$785da19a645c07eb$var$bu(a, e1[t[0]]), a;
            }(e1, t), u = function(e1, t) {
                let i = $785da19a645c07eb$var$Tu(e1), n = function(e1, t, i) {
                    return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1;
                }([], e1, 1 / i), a = $785da19a645c07eb$var$Cu([], t, $785da19a645c07eb$var$vu([], n, $785da19a645c07eb$var$bu(t, n))), r = $785da19a645c07eb$var$Tu(a);
                if (r > 0) {
                    let e1 = Math.sqrt(1 - n[3] * n[3]);
                    return $785da19a645c07eb$var$Yu(t, $785da19a645c07eb$var$Au([], $785da19a645c07eb$var$vu([], n, -n[3]), $785da19a645c07eb$var$vu([], a, e1 / r)));
                }
                return null;
            }(i, c);
            if (null !== u) {
                let e1 = u / $785da19a645c07eb$var$bu(l[0], c);
                s = Math.min(s, e1);
            }
            for(let t = 0; t < 4; t++){
                let i = Math.min(s, o[t]);
                e1[t + r] = [
                    e1[t + a][0] + l[t][0] * i,
                    e1[t + a][1] + l[t][1] * i,
                    e1[t + a][2] + l[t][2] * i,
                    1
                ];
            }
        }(l, s[0], a, r);
        let c = s.map((e1)=>{
            let t = $785da19a645c07eb$var$xu([], $785da19a645c07eb$var$wu([], $785da19a645c07eb$var$Cu([], l[e1[0]], l[e1[1]]), $785da19a645c07eb$var$Cu([], l[e1[2]], l[e1[1]]))), i = -$785da19a645c07eb$var$bu(t, l[e1[1]]);
            return t.concat(i);
        }), u = [
            1 / 0,
            1 / 0,
            1 / 0
        ], h = [
            -1 / 0,
            -1 / 0,
            -1 / 0
        ];
        for (let e1 of l)for(let t = 0; t < 3; t++)u[t] = Math.min(u[t], e1[t]), h[t] = Math.max(h[t], e1[t]);
        return new e1(l, c, new $785da19a645c07eb$var$JT(u, h));
    }
};
function $785da19a645c07eb$var$eD(e1, t, i) {
    let n = t.intersectsFrustum(e1);
    if (!i || 0 === n) return n;
    let a = t.intersectsPlane(i);
    return 0 === a ? 0 : 2 === n && 2 === a ? 2 : 1;
}
function $785da19a645c07eb$var$tD(e1, t, i) {
    let n = 0, a = (i - t) / 10;
    for(let r = 0; r < 10; r++){
        let s = t + (r + .5) / 10 * (i - t);
        n += a * Math.cos(s) ** +e1;
    }
    return n;
}
function $785da19a645c07eb$var$iD(e1, t) {
    return function(i, n, a, r, s) {
        let o = 2 * ((e1 - 1) / $785da19a645c07eb$var$fh(Math.cos($785da19a645c07eb$var$Dh($785da19a645c07eb$var$Bx - s)) / Math.cos($785da19a645c07eb$var$Dh($785da19a645c07eb$var$Bx))) - 1), l = Math.acos(a / r), c = 2 * $785da19a645c07eb$var$tD(o - 1, 0, $785da19a645c07eb$var$Dh(s / 2)), u = Math.min($785da19a645c07eb$var$Dh($785da19a645c07eb$var$Bx), l + $785da19a645c07eb$var$Dh(s / 2)), h = $785da19a645c07eb$var$tD(o - 1, Math.min(u, l - $785da19a645c07eb$var$Dh(s / 2)), u), d = Math.atan(n / a), p = i;
        return p += $785da19a645c07eb$var$fh(r / Math.hypot(n, a) / Math.max(.5, Math.cos($785da19a645c07eb$var$Dh(s / 2)))), p += o * $785da19a645c07eb$var$fh(Math.cos(d)) / 2, p -= $785da19a645c07eb$var$fh(Math.max(1, h / c / t)) / 2, p;
    };
}
const $785da19a645c07eb$var$nD = $785da19a645c07eb$var$iD(9.314, 3);
function $785da19a645c07eb$var$aD(e1, t) {
    let i = (t.roundZoom ? Math.round : Math.floor)(e1.zoom + $785da19a645c07eb$var$fh(e1.tileSize / t.tileSize));
    return Math.max(0, i);
}
function $785da19a645c07eb$var$rD(e1, t) {
    let i = e1.getCameraFrustum(), n = e1.getClippingPlane();
    if (n && t.maxContentElevation > 0) {
        let a = Math.hypot(n[0], n[1], n[2]);
        if (a > 0) {
            let r = 1 + t.maxContentElevation / $785da19a645c07eb$var$Sx, s = $785da19a645c07eb$var$ch(-n[3] / a, -1, 1), o = Math.cos(Math.acos(s) + Math.acos(1 / r));
            n = [
                n[0],
                n[1],
                n[2],
                -o * a
            ], i = function(e1, t, i) {
                let n = e1.planes[1], a = e1.points.map((e1)=>{
                    let a = n[0] * e1[0] + n[1] * e1[1] + n[2] * e1[2] + n[3];
                    if (Math.abs(a) > 1e-6) return e1;
                    let r = [
                        e1[0] - i[0],
                        e1[1] - i[1],
                        e1[2] - i[2]
                    ], s = n[0] * r[0] + n[1] * r[1] + n[2] * r[2];
                    if (s >= -0.000000001) return e1;
                    let o = t / -s;
                    return [
                        e1[0] + r[0] * o,
                        e1[1] + r[1] * o,
                        e1[2] + r[2] * o,
                        e1[3]
                    ];
                }), r = e1.planes.map((e1, i)=>1 === i ? [
                        e1[0],
                        e1[1],
                        e1[2],
                        e1[3] + t
                    ] : e1), s = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], o = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (let e1 of a)for(let t = 0; t < 3; t++)s[t] = Math.min(s[t], e1[t]), o[t] = Math.max(o[t], e1[t]);
                return new $785da19a645c07eb$var$$T(a, r, new $785da19a645c07eb$var$JT(s, o));
            }(i, Math.sqrt(r * r - 1), e1.cameraPosition);
        }
    }
    let a = function(e1) {
        let t = $785da19a645c07eb$var$Ix(1, e1.center.lat) * e1.worldSize;
        return $785da19a645c07eb$var$qx(e1.center, e1.elevation, e1.pitch, e1.bearing, e1.cameraToCenterDistance / t);
    }(e1), r = $785da19a645c07eb$var$Lx.fromLngLat(e1.center, e1.elevation), s = function(e1, t) {
        let i = $785da19a645c07eb$var$ch((15 - ($785da19a645c07eb$var$Bx - e1.pitch - e1.fov / 2)) / 15, 0, 1), n = Math.max(500, t ?? 0);
        return e1.elevation + i * n;
    }(e1, t.maxContentElevation), o = e1.getCoveringTilesDetailsProvider(), l = o.allowVariableZoom(e1, t), c = $785da19a645c07eb$var$aD(e1, t), u = t.minzoom || 0, h = void 0 === t.maxzoom ? e1.maxZoom : t.maxzoom, d = Math.min(Math.max(0, c), h), p = 2 ** d, m = [
        p * a.x,
        p * a.y,
        0
    ], g = [
        p * r.x,
        p * r.y,
        0
    ], f = Math.hypot(r.x - a.x, r.y - a.y), A = Math.abs(r.z - a.z), _ = Math.hypot(f, A), v = (e1)=>({
            zoom: 0,
            x: 0,
            y: 0,
            wrap: e1,
            fullyVisible: !1
        }), y = [], x = [];
    if (e1.renderWorldCopies && o.allowWorldCopies()) for(let e1 = 1; e1 <= 3; e1++)y.push(v(-e1)), y.push(v(e1));
    for(y.push(v(0)); y.length > 0;){
        let p = y.pop(), f = p.x, v = p.y, b = p.fullyVisible, w = {
            x: f,
            y: v,
            z: p.zoom
        }, E = o.getTileBoundingVolume(w, p.wrap, s, t);
        if (!b) {
            let e1 = $785da19a645c07eb$var$eD(i, E, n);
            if (0 === e1) continue;
            b = 2 === e1;
        }
        let k = o.distanceToTile2d(a.x, a.y, w, E), S = c;
        l && (S = (t.calculateTileZoom || $785da19a645c07eb$var$nD)(e1.zoom + $785da19a645c07eb$var$fh(e1.tileSize / t.tileSize), k, A, _, e1.fov)), S = (t.roundZoom ? Math.round : Math.floor)(S), S = Math.max(0, S);
        let M = Math.min(S, h);
        if (p.wrap = o.getWrap(r, w, p.wrap), p.zoom >= M) {
            if (p.zoom < u) continue;
            let e1 = d - p.zoom, i = m[0] - .5 - (f << e1), n = m[1] - .5 - (v << e1), a = t.reparseOverscaled ? Math.max(p.zoom, S) : p.zoom;
            x.push({
                tileID: new $785da19a645c07eb$var$KE(p.zoom === h ? a : p.zoom, p.wrap, p.zoom, f, v),
                distanceSq: $785da19a645c07eb$var$ju([
                    g[0] - .5 - f,
                    g[1] - .5 - v
                ]),
                tileDistanceToCamera: Math.sqrt(i * i + n * n)
            });
            continue;
        }
        for(let e1 = 0; e1 < 4; e1++){
            let t = (f << 1) + e1 % 2, i = (v << 1) + (e1 >> 1), n = p.zoom + 1;
            y.push({
                zoom: n,
                x: t,
                y: i,
                wrap: p.wrap,
                fullyVisible: b
            });
        }
    }
    return x.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
}
function $785da19a645c07eb$var$sD(e1) {
    return "raster" === e1 || "image" === e1 || "video" === e1;
}
function $785da19a645c07eb$var$oD(e1, t, i, n, a, r, s) {
    let o = $785da19a645c07eb$var$aC(), l = function(e1) {
        if (!e1.length) return new Set;
        let t = Math.max(...e1.map((e1)=>e1.canonical.z)), i = 1 / 0, n = -1 / 0, a = 1 / 0, r = -1 / 0, s = [];
        for (let o of e1){
            let { x: e1, y: l, z: c } = o.canonical, u = 2 ** (t - c), h = e1 * u, d = l * u;
            s.push({
                id: o,
                x: h,
                y: d
            }), h < i && (i = h), h > n && (n = h), d < a && (a = d), d > r && (r = d);
        }
        let o = new Set;
        for (let e1 of s)(e1.x === i || e1.x === n || e1.y === a || e1.y === r) && o.add(e1.id);
        return o;
    }(t);
    for (let c of t){
        let t = e1.getTileById(c.key);
        (0 === t.fadingDirection || 0 === t.fadeOpacity) && t.resetFadeLogic(), !$785da19a645c07eb$var$lD(e1, t, i, o, n, a, s) && ($785da19a645c07eb$var$cD(e1, t, i, o, r, s) || $785da19a645c07eb$var$hD(t, l, o, s) || t.resetFadeLogic());
    }
}
function $785da19a645c07eb$var$lD(e1, t, i, n, a, r, s) {
    if (!t.hasData()) return !1;
    let { tileID: o, fadingRole: l, fadingDirection: c, fadingParentID: u } = t;
    if (0 === l && 1 === c && u) return i[u.key] = u, !0;
    let h = Math.max(o.overscaledZ - a, r);
    for(let a = o.overscaledZ - 1; a >= h; a--){
        let r = o.scaledTo(a), l = e1.getLoadedTile(r);
        if (l) return t.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 1,
            fadingParentID: l.tileID,
            fadeEndTime: n + s
        }), l.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 0,
            fadeEndTime: n + s
        }), i[r.key] = r, !0;
    }
    return !1;
}
function $785da19a645c07eb$var$cD(e1, t, i, n, a, r) {
    if (!t.hasData()) return !1;
    let s = t.tileID.children(a), o = $785da19a645c07eb$var$uD(e1, t, s, i, n, a, r);
    if (o) return !0;
    for (let l of s)$785da19a645c07eb$var$uD(e1, t, l.children(a), i, n, a, r) && (o = !0);
    return o;
}
function $785da19a645c07eb$var$uD(e1, t, i, n, a, r, s) {
    if (i[0].overscaledZ >= r) return !1;
    let o = !1;
    for (let r of i){
        let i = e1.getLoadedTile(r);
        if (!i) continue;
        let { fadingRole: l, fadingDirection: c, fadingParentID: u } = i;
        (0 !== l || 0 !== c || !u) && (i.setCrossFadeLogic({
            fadingRole: 0,
            fadingDirection: 0,
            fadingParentID: t.tileID,
            fadeEndTime: a + s
        }), t.setCrossFadeLogic({
            fadingRole: 1,
            fadingDirection: 1,
            fadeEndTime: a + s
        })), n[r.key] = r, o = !0;
    }
    return o;
}
function $785da19a645c07eb$var$hD(e1, t, i, n) {
    let a = e1.tileID;
    if (e1.selfFading) return !0;
    if (e1.hasData()) return !1;
    if (t.has(a)) {
        let t = i + n;
        return e1.setSelfFadeLogic(t), !0;
    }
    return !1;
}
function $785da19a645c07eb$var$dD(e1, t) {
    e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.needsColorReliefPrepare = !0;
    let i = t.tileID.canonical.x - e1.tileID.canonical.x, n = t.tileID.canonical.y - e1.tileID.canonical.y, a = 2 ** e1.tileID.canonical.z, r = t.tileID.key;
    (0 !== i || 0 !== n) && (Math.abs(n) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + a) ? i += a : 1 === Math.abs(i - a) && (i -= a)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, i, n), e1.neighboringTiles?.[r] && (e1.neighboringTiles[r].backfilled = !0))));
}
var $785da19a645c07eb$var$pD = class {
    constructor(){
        this._tiles = {};
    }
    handleWrapJump(e1) {
        let t = {};
        for(let i in this._tiles){
            let n = this._tiles[i];
            n.tileID = n.tileID.unwrapTo(n.tileID.wrap + e1), t[n.tileID.key] = n;
        }
        this._tiles = t;
    }
    setFeatureState(e1, t, i) {
        for(let n in this._tiles)this._tiles[n].setFeatureState(e1, t, i);
    }
    getAllTiles() {
        return Object.values(this._tiles);
    }
    getAllIds(e1 = !1) {
        return e1 ? Object.values(this._tiles).map((e1)=>e1.tileID).sort($785da19a645c07eb$var$JE).map((e1)=>e1.key) : Object.keys(this._tiles);
    }
    getTileById(e1) {
        return this._tiles[e1];
    }
    setTile(e1, t) {
        this._tiles[e1] = t;
    }
    deleteTileById(e1) {
        delete this._tiles[e1];
    }
    getLoadedTile(e1) {
        let t = this.getTileById(e1.key);
        return t?.hasData() ? t : null;
    }
    isIdRenderable(e1, t = !1) {
        return this.getTileById(e1)?.isRenderable(t);
    }
    getRenderableIds(e1 = 0, t) {
        let i = [];
        for (let e1 of this.getAllIds())this.isIdRenderable(e1, t) && i.push(this.getTileById(e1));
        return t ? i.sort((t, i)=>{
            let n = t.tileID, a = i.tileID, r = new $785da19a645c07eb$var$Kc(n.canonical.x, n.canonical.y)._rotate(-e1), s = new $785da19a645c07eb$var$Kc(a.canonical.x, a.canonical.y)._rotate(-e1);
            return n.overscaledZ - a.overscaledZ || s.y - r.y || s.x - r.x;
        }).map((e1)=>e1.tileID.key) : i.map((e1)=>e1.tileID).sort($785da19a645c07eb$var$JE).map((e1)=>e1.key);
    }
}, $785da19a645c07eb$var$mD = class e1 extends $785da19a645c07eb$var$rd {
    static{
        this.maxUnderzooming = 10;
    }
    static{
        this.maxOverzooming = 3;
    }
    constructor(e1, t, i){
        super(), this._maxContentElevationSeen = 0, this.id = e1, this.dispatcher = i, this.on("data", (e1)=>{
            this._dataHandler(e1);
        }), this.on("dataloading", ()=>{
            this._sourceErrored = !1;
        }), this.on("error", ()=>{
            this._sourceErrored = this._source.loaded();
        }), this._source = ((e1, t, i, n)=>{
            let a = new ($785da19a645c07eb$var$GT(t.type))(e1, t, i, n);
            if (a.id !== e1) throw Error(`Expected Source id to be ${e1} instead of ${a.id}`);
            return a;
        })(e1, t, i, this), this._inViewTiles = new $785da19a645c07eb$var$pD, this._outOfViewCache = new $785da19a645c07eb$var$YM(0, (e1)=>this._unloadTile(e1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new $785da19a645c07eb$var$YT, this._didEmitContent = !1, this._updated = !1;
    }
    onAdd(e1) {
        this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source?.onAdd && this._source.onAdd(e1);
    }
    onRemove(e1) {
        for (let e1 of this._inViewTiles.getAllTiles())e1.unloadVectorData();
        this.clearTiles(), this._source?.onRemove && this._source.onRemove(e1), this._inViewTiles = new $785da19a645c07eb$var$pD;
    }
    loaded() {
        if (this._sourceErrored) return !0;
        if (!this._sourceLoaded || !this._source.loaded()) return !1;
        if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
        if (!this._updated) return !1;
        for (let e1 of this._inViewTiles.getAllTiles())if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
        return !0;
    }
    getSource() {
        return this._source;
    }
    getState() {
        return this._state;
    }
    pause() {
        this._paused = !0;
    }
    resume() {
        if (!this._paused) return;
        let e1 = this._shouldReloadOnResume;
        this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
    }
    async _loadTile(e1, t, i, n) {
        try {
            let a = await this._source.loadTile(e1);
            this._tileLoaded(e1, t, i, n, a);
        } catch (t) {
            e1.state = "errored", 404 === t.status ? this.update(this.transform, this.terrain) : this._source.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(t), {
                tile: e1
            }));
        }
    }
    _unloadTile(e1) {
        this._source.unloadTile && this._source.unloadTile(e1);
    }
    _abortTile(e1) {
        this._source.abortTile && this._source.abortTile(e1), this._source.fire(new $785da19a645c07eb$var$dC("dataabort", {
            tile: e1,
            coord: e1.tileID
        }));
    }
    serialize() {
        return this._source.serialize();
    }
    prepare(e1) {
        this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
        for (let t of this._inViewTiles.getAllTiles())t.upload(e1), t.prepare(this.map.style.imageManager);
    }
    getIds() {
        return this._inViewTiles.getAllIds(!0);
    }
    getRenderableIds(e1) {
        return this._inViewTiles.getRenderableIds(this.transform?.bearingInRadians, e1);
    }
    hasRenderableParent(e1) {
        let t = e1.overscaledZ - 1;
        if (t >= this._source.minzoom) {
            let i = this.getLoadedTile(e1.scaledTo(t));
            if (i) return this._inViewTiles.isIdRenderable(i.tileID.key);
        }
        return !1;
    }
    reload(e1, t) {
        if (this._paused) this._shouldReloadOnResume = !0;
        else {
            this._outOfViewCache.reset();
            for (let i of this._inViewTiles.getAllIds()){
                let n = this._inViewTiles.getTileById(i);
                (!t || this._source.shouldReloadTile(n, t)) && (e1 ? this._reloadTile(i, "errored" === n.state ? "loading" : "expired") : "errored" !== n.state && this._reloadTile(i, "reloading"));
            }
        }
    }
    async _reloadTile(e1, t) {
        let i = this._inViewTiles.getTileById(e1);
        if (!i) return;
        let n = i.hasData();
        "loading" !== i.state && (i.state = t), await this._loadTile(i, e1, t, n);
    }
    _tileLoaded(e1, t, i, n, a) {
        n || (e1.timeAdded = $785da19a645c07eb$var$aC(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration)), "expired" === i && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), !a?.unmodified && ("raster-dem" === this.getSource().type && e1.dem && function(e1, t) {
            let i = t.getRenderableIds();
            for (let n of i){
                if (!e1.neighboringTiles?.[n]) continue;
                let i = t.getTileById(n);
                e1.neighboringTiles[n].backfilled || $785da19a645c07eb$var$dD(e1, i), !i.neighboringTiles?.[e1.tileID.key]?.backfilled && $785da19a645c07eb$var$dD(i, e1);
            }
        }(e1, this._inViewTiles), e1.featureStateRevision = -1, this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new $785da19a645c07eb$var$dC("data", {
            tile: e1,
            coord: e1.tileID
        })));
    }
    getTile(e1) {
        return this.getTileByID(e1.key);
    }
    getTileByID(e1) {
        return this._inViewTiles.getTileById(e1);
    }
    _retainLoadedChildren(t, i) {
        let n = this._getLoadedDescendents(i), a = new Set;
        for (let r of i){
            let i = n[r.key];
            if (!i?.length) {
                a.add(r);
                continue;
            }
            let s = r.overscaledZ + e1.maxOverzooming, o = i.filter((e1)=>e1.tileID.overscaledZ <= s);
            if (!o.length) {
                a.add(r);
                continue;
            }
            let l = Math.min(...o.map((e1)=>e1.tileID.overscaledZ)), c = o.filter((e1)=>e1.tileID.overscaledZ === l).map((e1)=>e1.tileID);
            for (let e1 of c)t[e1.key] = e1;
            this._areDescendentsComplete(c, l, r.overscaledZ) || a.add(r);
        }
        return a;
    }
    _getLoadedDescendents(e1) {
        let t = {};
        for (let i of this._inViewTiles.getAllTiles().filter((e1)=>e1.hasData()))for (let n of e1)i.tileID.isChildOf(n) && (t[n.key] ||= [], t[n.key].push(i));
        return t;
    }
    _areDescendentsComplete(e1, t, i) {
        return 1 === e1.length && e1[0].isOverscaled() ? e1[0].overscaledZ === t : 4 ** (t - i) === e1.length;
    }
    getLoadedTile(e1) {
        return this._inViewTiles.getLoadedTile(e1);
    }
    updateCacheSize(e1) {
        let t = (Math.ceil(e1.width / this._source.tileSize) + 1) * (Math.ceil(e1.height / this._source.tileSize) + 1), i = null === this._maxTileCacheZoomLevels ? $785da19a645c07eb$var$Hh.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels, n = Math.floor(t * i), a = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, n) : n;
        this._outOfViewCache.setMaxSize(a);
    }
    handleWrapJump(e1) {
        let t = (e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360, i = Math.round(t);
        this._prevLng = e1, i && (this._inViewTiles.handleWrapJump(i), this._resetTileReloadTimers());
    }
    _updateMaxContentElevation() {
        let e1 = this._maxContentElevationSeen, t = this.map?.style?._layers;
        if (!t) return e1;
        let i = this._inViewTiles.getAllTiles();
        for(let n in t){
            let a = t[n];
            if ("symbol" !== a.type || a.source !== this.id || a.isHidden(this.transform.zoom)) continue;
            let r = a;
            if (r.layout) {
                e1 = Math.max(e1, r.layout.get("symbol-height-offset").constantOr(0));
                for (let t of i){
                    let i = t.getBucket(a);
                    i && i.maxHeightOffset > e1 && (e1 = i.maxHeightOffset);
                }
            }
        }
        return this._maxContentElevationSeen = e1, e1;
    }
    update(e1, t) {
        if (!this._sourceLoaded || this._paused) return;
        let i;
        this.transform = e1, this.terrain = t, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? i = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new $785da19a645c07eb$var$KE(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (i = $785da19a645c07eb$var$rD(e1, {
            tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
            minzoom: this._source.minzoom,
            maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? Math.max(this._source.maxzoom, e1.maxZoom - this.map._zoomLevelsToOverscale) : this._source.maxzoom,
            roundZoom: !this.usedForTerrain && this._source.roundZoom,
            reparseOverscaled: this._source.reparseOverscaled,
            terrain: t,
            calculateTileZoom: this._source.calculateTileZoom,
            maxContentElevation: this._updateMaxContentElevation()
        }), this._source.hasTile && (i = i.filter((e1)=>this._source.hasTile(e1)))) : i = [], this.usedForTerrain && (i = this._addTerrainIdealTiles(i));
        let n = 0 === i.length && !this._updated && this._didEmitContent;
        this._updated = !0, n && this.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "idle",
            sourceId: this.id
        }));
        let a = $785da19a645c07eb$var$aD(e1, this._source), r = this._updateRetainedTiles(i, a), s = $785da19a645c07eb$var$sD(this._source.type);
        s && this._rasterFadeDuration > 0 && !t && $785da19a645c07eb$var$oD(this._inViewTiles, i, r, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), s ? this._cleanUpRasterTiles(r) : this._cleanUpVectorTiles(r);
    }
    _cleanUpRasterTiles(e1) {
        for (let t of this._inViewTiles.getAllIds())e1[t] || this._removeTile(t);
    }
    _cleanUpVectorTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let i = this._inViewTiles.getTileById(t);
            e1[t] ? i.clearSymbolFadeHold() : i.hasSymbolBuckets ? i.holdingForSymbolFade() ? i.symbolFadeFinished() && this._removeTile(t) : i.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(t);
        }
    }
    _addTerrainIdealTiles(e1) {
        let t = [];
        for (let i of e1)if (i.canonical.z > this._source.minzoom) {
            let e1 = i.scaledTo(i.canonical.z - 1);
            t.push(e1);
            let n = i.scaledTo(Math.max(this._source.minzoom, Math.min(i.canonical.z, 5)));
            t.push(n);
        }
        return e1.concat(t);
    }
    releaseSymbolFadeTiles() {
        for (let e1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(e1).holdingForSymbolFade() && this._removeTile(e1);
    }
    _updateRetainedTiles(t, i) {
        let n = new Set;
        for (let e1 of t)this._addTile(e1).hasData() || n.add(e1);
        let a = t.reduce((e1, t)=>(e1[t.key] = t, e1), {}), r = this._retainLoadedChildren(a, n), s = {}, o = Math.max(i - e1.maxUnderzooming, this._source.minzoom);
        for (let e1 of r){
            let t = this._inViewTiles.getTileById(e1.key), i = t?.wasRequested();
            for(let n = e1.overscaledZ - 1; n >= o; --n){
                let r = e1.scaledTo(n);
                if (s[r.key]) break;
                if (s[r.key] = !0, t = this.getTile(r), !t && i && (t = this._addTile(r)), t) {
                    let e1 = t.hasData();
                    if ((e1 || !this.map?.cancelPendingTileRequestsWhileZooming || i) && (a[r.key] = r), i = t.wasRequested(), e1) break;
                }
            }
        }
        return a;
    }
    _addTile(e1) {
        let t = this._inViewTiles.getTileById(e1.key);
        if (t) return t;
        t = this._outOfViewCache.getAndRemove(e1), t && (t.resetFadeLogic(), this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null));
        let i = t;
        return t || (t = new $785da19a645c07eb$var$XT(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(t, e1.key, t.state, !1)), t.uses++, this._inViewTiles.setTile(e1.key, t), i || this._source.fire(new $785da19a645c07eb$var$dC("dataloading", {
            tile: t,
            coord: t.tileID
        })), t;
    }
    _setTileReloadTimer(e1, t) {
        this._clearTileReloadTimer(e1);
        let i = t.getExpiryTimeout();
        if (i) {
            let t = ()=>{
                this._reloadTile(e1, "expired"), delete this._timers[e1];
            };
            this._timers[e1] = setTimeout(t, i);
        }
    }
    _clearTileReloadTimer(e1) {
        let t = this._timers[e1];
        t && (clearTimeout(t), delete this._timers[e1]);
    }
    _resetTileReloadTimers() {
        for(let e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
        for (let e1 of this._inViewTiles.getAllIds()){
            let t = this._inViewTiles.getTileById(e1);
            this._setTileReloadTimer(e1, t);
        }
    }
    refreshTiles(e1) {
        for (let t of this._inViewTiles.getAllIds()){
            let i = this._inViewTiles.getTileById(t);
            (this._inViewTiles.isIdRenderable(t) || "errored" == i.state) && e1.some((e1)=>e1.equals(i.tileID.canonical)) && this._reloadTile(t, "expired");
        }
    }
    _removeTile(e1) {
        let t = this._inViewTiles.getTileById(e1);
        t && (t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), !(t.uses > 0) && (t.hasData() && "reloading" !== t.state ? this._outOfViewCache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
    }
    _dataHandler(e1) {
        if ("source" === e1.dataType) {
            if ("metadata" === e1.sourceDataType) return void (this._sourceLoaded = !0);
            "content" === e1.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
        }
    }
    resetMaxContentElevation() {
        this._maxContentElevationSeen = 0;
    }
    clearTiles() {
        this._shouldReloadOnResume = !1, this._paused = !1, this.resetMaxContentElevation();
        for (let e1 of this._inViewTiles.getAllIds())this._removeTile(e1);
        this._outOfViewCache.reset();
    }
    tilesIn(e1, t, i) {
        let n = [], a = this.transform;
        if (!a) return n;
        let r = a.getCoveringTilesDetailsProvider().allowWorldCopies(), s = i ? a.getCameraQueryGeometry(e1) : e1, o = (e1)=>a.screenPointToMercatorCoordinate(e1, this.terrain), l = this.transformBbox(e1, o, !r), c = this.transformBbox(s, o, !r), u = this.getIds(), h = $785da19a645c07eb$var$fx.fromPoints(c);
        for (let e1 of u){
            let i = this._inViewTiles.getTileById(e1);
            if (i.holdingForSymbolFade()) continue;
            let s = r ? [
                i.tileID
            ] : [
                i.tileID.unwrapTo(-1),
                i.tileID.unwrapTo(0)
            ], o = 2 ** (a.zoom - i.tileID.overscaledZ), u = t * i.queryPadding * $785da19a645c07eb$var$Vu / i.tileSize / o;
            for (let e1 of s){
                let t = h.map((t)=>e1.getTilePoint(new $785da19a645c07eb$var$Lx(t.x, t.y)));
                if (t.expandBy(u), t.intersects($785da19a645c07eb$var$Ax)) {
                    let t = l.map((t)=>e1.getTilePoint(t)), a = c.map((t)=>e1.getTilePoint(t));
                    n.push({
                        tile: i,
                        tileID: r ? e1 : e1.unwrapTo(0),
                        queryGeometry: t,
                        cameraQueryGeometry: a,
                        scale: o
                    });
                }
            }
        }
        return n;
    }
    transformBbox(e1, t, i) {
        let n = e1.map(t);
        if (i) {
            let i = $785da19a645c07eb$var$fx.fromPoints(e1);
            i.shrinkBy(.001 * Math.min(i.width(), i.height()));
            let a = i.map(t);
            $785da19a645c07eb$var$fx.fromPoints(n).covers(a) || (n = n.map((e1)=>e1.x > .5 ? new $785da19a645c07eb$var$Lx(e1.x - 1, e1.y, e1.z) : e1));
        }
        return n;
    }
    getVisibleCoordinates(e1) {
        let t = this.getRenderableIds(e1).map((e1)=>this._inViewTiles.getTileById(e1).tileID);
        return this.transform && this.transform.populateCache(t), t;
    }
    hasTransition() {
        return !!this._source.hasTransition() || $785da19a645c07eb$var$sD(this._source.type) && function(e1, t) {
            if (t <= 0) return !1;
            let i = $785da19a645c07eb$var$aC();
            for (let t of e1.getAllTiles())if (t.fadeEndTime >= i) return !0;
            return !1;
        }(this._inViewTiles, this._rasterFadeDuration);
    }
    setRasterFadeDuration(e1) {
        this._rasterFadeDuration = e1;
    }
    setFeatureState(e1, t, i) {
        e1 ||= $785da19a645c07eb$var$$E, this._state.updateState(e1, t, i);
    }
    removeFeatureState(e1, t, i) {
        e1 ||= $785da19a645c07eb$var$$E, this._state.removeFeatureState(e1, t, i);
    }
    getFeatureState(e1, t) {
        return e1 ||= $785da19a645c07eb$var$$E, this._state.getState(e1, t);
    }
    setDependencies(e1, t, i) {
        let n = this._inViewTiles.getTileById(e1);
        n && n.setDependencies(t, i);
    }
    reloadTilesForDependencies(e1, t) {
        for (let i of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(i).hasDependency(e1, t) && this._reloadTile(i, "reloading");
        this._outOfViewCache.filter((i)=>!i.hasDependency(e1, t));
    }
    areTilesLoaded() {
        for (let e1 of this._inViewTiles.getAllTiles())if ("loaded" !== e1.state && "errored" !== e1.state) return !1;
        return !0;
    }
}, $785da19a645c07eb$var$gD = class {
    constructor(e1, t){
        this.reset(e1, t);
    }
    reset(e1, t) {
        this.points = e1 || [], this._distances = [
            0
        ];
        for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
    }
    lerp(e1) {
        if (1 === this.points.length) return this.points[0];
        e1 = $785da19a645c07eb$var$ch(e1, 0, 1);
        let t = 1, i = this._distances[t], n = e1 * this.paddedLength + this.padding;
        for(; i < n && t < this._distances.length;)i = this._distances[++t];
        let a = t - 1, r = this._distances[a], s = i - r, o = s > 0 ? (n - r) / s : 0;
        return this.points[a].mult(1 - o).add(this.points[t].mult(o));
    }
};
function $785da19a645c07eb$var$fD(e1, t, i, n, a) {
    return a ? e1 ? e1(t, i) + n : 0 === n ? void 0 : n : n;
}
function $785da19a645c07eb$var$AD(e1, t) {
    let i = !0;
    return "always" === e1 || ("never" === e1 || "never" === t) && (i = !1), i;
}
var $785da19a645c07eb$var$_D = class {
    constructor(e1, t, i){
        let n = this.boxCells = [], a = this.circleCells = [];
        this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
        for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)n.push([]), a.push([]);
        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
    }
    keysLength() {
        return this.boxKeys.length + this.circleKeys.length;
    }
    insert(e1, t, i, n, a) {
        this._forEachCell(t, i, n, a, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(n), this.bboxes.push(a);
    }
    insertCircle(e1, t, i, n) {
        this._forEachCell(t - n, i - n, t + n, i + n, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(n);
    }
    _insertBoxCell(e1, t, i, n, a, r) {
        this.boxCells[a].push(r);
    }
    _insertCircleCell(e1, t, i, n, a, r) {
        this.circleCells[a].push(r);
    }
    _query(e1, t, i, n, a, r, s) {
        if (i < 0 || e1 > this.width || n < 0 || t > this.height) return [];
        let o = [];
        if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= n) {
            if (a) return [
                {
                    key: null,
                    x1: e1,
                    y1: t,
                    x2: i,
                    y2: n
                }
            ];
            for(let e1 = 0; e1 < this.boxKeys.length; e1++)o.push({
                key: this.boxKeys[e1],
                x1: this.bboxes[4 * e1],
                y1: this.bboxes[4 * e1 + 1],
                x2: this.bboxes[4 * e1 + 2],
                y2: this.bboxes[4 * e1 + 3]
            });
            for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                let t = this.circles[3 * e1], i = this.circles[3 * e1 + 1], n = this.circles[3 * e1 + 2];
                o.push({
                    key: this.circleKeys[e1],
                    x1: t - n,
                    y1: i - n,
                    x2: t + n,
                    y2: i + n
                });
            }
        } else {
            let l = {
                hitTest: a,
                overlapMode: r,
                seenUids: {
                    box: {},
                    circle: {}
                }
            };
            this._forEachCell(e1, t, i, n, this._queryCell, o, l, s);
        }
        return o;
    }
    query(e1, t, i, n) {
        return this._query(e1, t, i, n, !1, null);
    }
    hitTest(e1, t, i, n, a, r) {
        return this._query(e1, t, i, n, !0, a, r).length > 0;
    }
    hitTestCircle(e1, t, i, n, a) {
        let r = e1 - i, s = e1 + i, o = t - i, l = t + i;
        if (s < 0 || r > this.width || l < 0 || o > this.height) return !1;
        let c = [], u = {
            hitTest: !0,
            overlapMode: n,
            circle: {
                x: e1,
                y: t,
                radius: i
            },
            seenUids: {
                box: {},
                circle: {}
            }
        };
        return this._forEachCell(r, o, s, l, this._queryCellCircle, c, u, a), c.length > 0;
    }
    _queryCell(e1, t, i, n, a, r, s, o) {
        let { seenUids: l, hitTest: c, overlapMode: u } = s, h = this.boxCells[a], d = 1e-6;
        if (null !== h) {
            let a = this.bboxes;
            for (let s of h)if (!l.box[s]) {
                l.box[s] = !0;
                let h = 4 * s, p = this.boxKeys[s];
                if (e1 <= a[h + 2] + d && t <= a[h + 3] + d && i >= a[h + 0] - d && n >= a[h + 1] - d && (!o || o(p)) && (!c || !$785da19a645c07eb$var$AD(u, p.overlapMode)) && (r.push({
                    key: p,
                    x1: a[h],
                    y1: a[h + 1],
                    x2: a[h + 2],
                    y2: a[h + 3]
                }), c)) return !0;
            }
        }
        let p = this.circleCells[a];
        if (null !== p) {
            let a = this.circles;
            for (let s of p)if (!l.circle[s]) {
                l.circle[s] = !0;
                let h = 3 * s, d = this.circleKeys[s];
                if (this._circleAndRectCollide(a[h], a[h + 1], a[h + 2], e1, t, i, n) && (!o || o(d)) && (!c || !$785da19a645c07eb$var$AD(u, d.overlapMode))) {
                    let e1 = a[h], t = a[h + 1], i = a[h + 2];
                    if (r.push({
                        key: d,
                        x1: e1 - i,
                        y1: t - i,
                        x2: e1 + i,
                        y2: t + i
                    }), c) return !0;
                }
            }
        }
        return !1;
    }
    _queryCellCircle(e1, t, i, n, a, r, s, o) {
        let { circle: l, seenUids: c, overlapMode: u } = s, h = this.boxCells[a];
        if (null !== h) {
            let e1 = this.bboxes;
            for (let t of h)if (!c.box[t]) {
                c.box[t] = !0;
                let i = 4 * t, n = this.boxKeys[t];
                if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!o || o(n)) && !$785da19a645c07eb$var$AD(u, n.overlapMode)) return r.push(!0), !0;
            }
        }
        let d = this.circleCells[a];
        if (null !== d) {
            let e1 = this.circles;
            for (let t of d)if (!c.circle[t]) {
                c.circle[t] = !0;
                let i = 3 * t, n = this.circleKeys[t];
                if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!o || o(n)) && !$785da19a645c07eb$var$AD(u, n.overlapMode)) return r.push(!0), !0;
            }
        }
    }
    _forEachCell(e1, t, i, n, a, r, s, o) {
        let l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t), u = this._convertToXCellCoord(i), h = this._convertToYCellCoord(n);
        for(let d = l; d <= u; d++)for(let l = c; l <= h; l++){
            let c = this.xCellCount * l + d;
            if (a.call(this, e1, t, i, n, c, r, s, o)) return;
        }
    }
    _convertToXCellCoord(e1) {
        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
    }
    _convertToYCellCoord(e1) {
        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
    }
    _circlesCollide(e1, t, i, n, a, r) {
        let s = n - e1, o = a - t, l = i + r;
        return l * l > s * s + o * o;
    }
    _circleAndRectCollide(e1, t, i, n, a, r, s) {
        let o = (r - n) / 2, l = Math.abs(e1 - (n + o));
        if (l > o + i) return !1;
        let c = (s - a) / 2, u = Math.abs(t - (a + c));
        if (u > c + i) return !1;
        if (l <= o || u <= c) return !0;
        let h = l - o, d = u - c;
        return h * h + d * d <= i * i;
    }
};
function $785da19a645c07eb$var$vD(e1, t) {
    let i = 1 / (t[0] * t[0] + t[1] * t[1] + t[2] * t[2]), n = 1 / (t[8] * t[8] + t[9] * t[9] + t[10] * t[10]), a = t[0] * i, r = t[4] * i, s = t[8] * n, o = t[1] * i, l = t[5] * i, c = t[9] * n, u = t[2] * i, h = t[6] * i, d = t[10] * n;
    e1[0] = a, e1[1] = r, e1[2] = s, e1[4] = o, e1[5] = l, e1[6] = c, e1[8] = u, e1[9] = h, e1[10] = d;
    let p = t[12], m = t[13], g = t[14];
    return e1[12] = -a * p - o * m - u * g, e1[13] = -r * p - l * m - h * g, e1[14] = -s * p - c * m - d * g, e1[3] = 0, e1[7] = 0, e1[11] = 0, e1[15] = 1, e1;
}
const $785da19a645c07eb$var$yD = $785da19a645c07eb$var$tu();
function $785da19a645c07eb$var$xD(e1, t, i) {
    let n = $785da19a645c07eb$var$tu();
    if (!e1) {
        let { vecSouth: e1, vecEast: i } = $785da19a645c07eb$var$wD(t), a = $785da19a645c07eb$var$JM();
        a[0] = i[0], a[1] = i[1], a[2] = e1[0], a[3] = e1[1], function(e1, t) {
            var i = t[0], n = t[1], a = t[2], r = t[3], s = i * r - a * n;
            s && (s = 1 / s, e1[0] = r * s, e1[1] = -n * s, e1[2] = -a * s, e1[3] = i * s);
        }(a, a), n[0] = a[0], n[1] = a[1], n[4] = a[2], n[5] = a[3];
    }
    return $785da19a645c07eb$var$ou(n, n, [
        1 / i,
        1 / i,
        1
    ]), n;
}
function $785da19a645c07eb$var$bD(e1, t, i, n) {
    if (e1) {
        let e1 = $785da19a645c07eb$var$tu();
        if (!t) {
            let { vecSouth: t, vecEast: n } = $785da19a645c07eb$var$wD(i);
            e1[0] = n[0], e1[1] = n[1], e1[4] = t[0], e1[5] = t[1];
        }
        return $785da19a645c07eb$var$ou(e1, e1, [
            n,
            n,
            1
        ]), e1;
    }
    return i.pixelsToClipSpaceMatrix;
}
function $785da19a645c07eb$var$wD(e1) {
    let t = Math.cos(e1.rollInRadians), i = Math.sin(e1.rollInRadians), n = Math.cos(e1.pitchInRadians), a = Math.cos(e1.bearingInRadians), r = Math.sin(e1.bearingInRadians), s = $785da19a645c07eb$var$Lu();
    s[0] = -a * n * i - r * t, s[1] = -r * n * i + a * t;
    let o = $785da19a645c07eb$var$Uu(s);
    o < 1e-9 ? $785da19a645c07eb$var$Nu(s) : $785da19a645c07eb$var$Ou(s, s, 1 / o);
    let l = $785da19a645c07eb$var$Lu();
    l[0] = a * n * t - r * i, l[1] = r * n * t + a * i;
    let c = $785da19a645c07eb$var$Uu(l);
    return c < 1e-9 ? $785da19a645c07eb$var$Nu(l) : $785da19a645c07eb$var$Ou(l, l, 1 / c), {
        vecEast: l,
        vecSouth: s
    };
}
function $785da19a645c07eb$var$ED(e1, t, i) {
    return $785da19a645c07eb$var$fD(e1.getElevation, t, i, e1.heightOffset ?? 0, e1.heightAnchorGround ?? !0);
}
function $785da19a645c07eb$var$kD(e1, t, i, n) {
    let a;
    null == n ? (a = [
        e1,
        t,
        0,
        1
    ], $785da19a645c07eb$var$VD(a, a, i)) : (a = [
        e1,
        t,
        n,
        1
    ], $785da19a645c07eb$var$Du(a, a, i));
    let r = a[3];
    return {
        point: new $785da19a645c07eb$var$Kc(a[0] / r, a[1] / r),
        signedDistanceFromCamera: r,
        isOccluded: !1
    };
}
function $785da19a645c07eb$var$SD(e1, t) {
    return .5 + e1 / t * .5;
}
function $785da19a645c07eb$var$MD(e1, t) {
    return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
}
function $785da19a645c07eb$var$CD(e1, t, i, n, a, r, s, o, l, c, u, h, d) {
    let p = i ? e1.textSizeData : e1.iconSizeData, m = $785da19a645c07eb$var$Kw(p, t.transform.zoom), g = [
        256 / t.width * 2 + 1,
        256 / t.height * 2 + 1
    ], f = i ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
    f.clear();
    let A = e1.lineVertexArray, _ = i ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, v = t.transform.width / t.transform.height, y = !1;
    for(let i = 0; i < _.length; i++){
        let x = _.get(i);
        if (x.hidden || 2 === x.writingMode && !y) {
            $785da19a645c07eb$var$jD(x.numGlyphs, f);
            continue;
        }
        y = !1;
        let b = new $785da19a645c07eb$var$Kc(x.anchorX, x.anchorY), w = {
            getElevation: d,
            pitchedLabelPlaneMatrix: n,
            lineVertexArray: A,
            pitchWithMap: r,
            projectionCache: {
                projections: {},
                offsets: {},
                cachedAnchorPoint: void 0,
                anyProjectionOccluded: !1
            },
            transform: t.transform,
            tileAnchorPoint: b,
            unwrappedTileID: l,
            width: c,
            height: u,
            translation: h
        }, E = $785da19a645c07eb$var$LD(x.anchorX, x.anchorY, w);
        if (!$785da19a645c07eb$var$MD(E.point, g)) {
            $785da19a645c07eb$var$jD(x.numGlyphs, f);
            continue;
        }
        let k = E.signedDistanceFromCamera, S = $785da19a645c07eb$var$SD(t.transform.cameraToCenterDistance, k), M = $785da19a645c07eb$var$Zw(p, m, x), C = r ? M * t.transform.getPitchedTextCorrection(x.anchorX, x.anchorY, l) / S : M * S, T = $785da19a645c07eb$var$PD({
            projectionContext: w,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: x,
            fontSize: C,
            flip: !1,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: f,
            aspectRatio: v,
            rotateToLine: o
        });
        y = T.useVertical, (T.notEnoughRoom || y || T.needsFlipping && $785da19a645c07eb$var$PD({
            projectionContext: w,
            pitchedLabelPlaneMatrixInverse: a,
            symbol: x,
            fontSize: C,
            flip: !0,
            keepUpright: s,
            glyphOffsetArray: e1.glyphOffsetArray,
            dynamicLayoutVertexArray: f,
            aspectRatio: v,
            rotateToLine: o
        }).notEnoughRoom) && $785da19a645c07eb$var$jD(x.numGlyphs, f);
    }
    i ? e1.text.dynamicLayoutVertexBuffer.updateData(f) : e1.icon.dynamicLayoutVertexBuffer.updateData(f);
}
function $785da19a645c07eb$var$TD(e1, t, i, n, a, r, s, o) {
    let l = r.glyphStartIndex + r.numGlyphs, c = r.lineStartIndex, u = r.lineStartIndex + r.lineLength, h = t.getoffsetX(r.glyphStartIndex), d = t.getoffsetX(l - 1), p = $785da19a645c07eb$var$UD(e1 * h, i, n, a, r.segment, c, u, o, s);
    if (!p) return null;
    let m = $785da19a645c07eb$var$UD(e1 * d, i, n, a, r.segment, c, u, o, s);
    return !m || o.projectionCache.anyProjectionOccluded ? null : {
        first: p,
        last: m
    };
}
function $785da19a645c07eb$var$DD(e1, t, i, n) {
    return 1 === e1 && Math.abs(i.y - t.y) > Math.abs(i.x - t.x) * n ? {
        useVertical: !0
    } : (2 === e1 ? t.y < i.y : t.x > i.x) ? {
        needsFlipping: !0
    } : null;
}
function $785da19a645c07eb$var$PD(e1) {
    let t, { projectionContext: i, pitchedLabelPlaneMatrixInverse: n, symbol: a, fontSize: r, flip: s, keepUpright: o, glyphOffsetArray: l, dynamicLayoutVertexArray: c, aspectRatio: u, rotateToLine: h } = e1, d = r / 24, p = a.lineOffsetX * d, m = a.lineOffsetY * d;
    if (a.numGlyphs > 1) {
        let e1 = a.glyphStartIndex + a.numGlyphs, r = a.lineStartIndex, c = a.lineStartIndex + a.lineLength, g = $785da19a645c07eb$var$TD(d, l, p, m, s, a, h, i);
        if (!g) return {
            notEnoughRoom: !0
        };
        let f = $785da19a645c07eb$var$RD(g.first.point.x, g.first.point.y, i, n), A = $785da19a645c07eb$var$RD(g.last.point.x, g.last.point.y, i, n);
        if (o && !s) {
            let e1 = $785da19a645c07eb$var$DD(a.writingMode, f, A, u);
            if (e1) return e1;
        }
        t = [
            g.first
        ];
        for(let n = a.glyphStartIndex + 1; n < e1 - 1; n++){
            let e1 = $785da19a645c07eb$var$UD(d * l.getoffsetX(n), p, m, s, a.segment, r, c, i, h);
            if (!e1) return {
                notEnoughRoom: !0
            };
            t.push(e1);
        }
        t.push(g.last);
    } else {
        if (o && !s) {
            let e1 = $785da19a645c07eb$var$zD(i.tileAnchorPoint.x, i.tileAnchorPoint.y, i).point, t = a.lineStartIndex + a.segment + 1, r = new $785da19a645c07eb$var$Kc(i.lineVertexArray.getx(t), i.lineVertexArray.gety(t)), s = $785da19a645c07eb$var$zD(r.x, r.y, i), o = s.signedDistanceFromCamera > 0 ? s.point : $785da19a645c07eb$var$ID(i.tileAnchorPoint, r, e1, 1, i), l = $785da19a645c07eb$var$RD(e1.x, e1.y, i, n), c = $785da19a645c07eb$var$RD(o.x, o.y, i, n), h = $785da19a645c07eb$var$DD(a.writingMode, l, c, u);
            if (h) return h;
        }
        let e1 = $785da19a645c07eb$var$UD(d * l.getoffsetX(a.glyphStartIndex), p, m, s, a.segment, a.lineStartIndex, a.lineStartIndex + a.lineLength, i, h);
        if (!e1 || i.projectionCache.anyProjectionOccluded) return {
            notEnoughRoom: !0
        };
        t = [
            e1
        ];
    }
    for (let e1 of t)$785da19a645c07eb$var$SE(c, e1.point, e1.angle);
    return {};
}
function $785da19a645c07eb$var$ID(e1, t, i, n, a) {
    let r = e1.add(e1.sub(t)._unit()), s = $785da19a645c07eb$var$zD(r.x, r.y, a).point, o = i.sub(s);
    return i.add(o._mult(n / o.mag()));
}
function $785da19a645c07eb$var$FD(e1, t, i) {
    let n = t.projectionCache;
    if (n.projections[e1]) return n.projections[e1];
    let a = new $785da19a645c07eb$var$Kc(t.lineVertexArray.getx(e1), t.lineVertexArray.gety(e1)), r = $785da19a645c07eb$var$zD(a.x, a.y, t);
    if (r.signedDistanceFromCamera > 0) return n.projections[e1] = r.point, n.anyProjectionOccluded ||= r.isOccluded, r.point;
    let s = e1 - i.direction, o = 0 === i.distanceFromAnchor ? t.tileAnchorPoint : new $785da19a645c07eb$var$Kc(t.lineVertexArray.getx(s), t.lineVertexArray.gety(s)), l = i.absOffsetX - i.distanceFromAnchor + 1;
    return $785da19a645c07eb$var$ID(o, a, i.previousVertex, l, t);
}
function $785da19a645c07eb$var$zD(e1, t, i) {
    let n, a = e1 + i.translation[0], r = t + i.translation[1];
    return i.pitchWithMap ? (n = $785da19a645c07eb$var$kD(a, r, i.pitchedLabelPlaneMatrix, $785da19a645c07eb$var$ED(i, a, r)), n.isOccluded = !1) : (n = i.transform.projectTileCoordinates(a, r, i.unwrappedTileID, $785da19a645c07eb$var$ED(i, a, r)), n.point.x = (.5 * n.point.x + .5) * i.width, n.point.y = (.5 * -n.point.y + .5) * i.height), n;
}
function $785da19a645c07eb$var$RD(e1, t, i, n) {
    if (i.pitchWithMap) {
        let a = [
            e1,
            t,
            0,
            1
        ];
        $785da19a645c07eb$var$Du(a, a, n);
        let r = a[0] / a[3], s = a[1] / a[3];
        return i.transform.projectTileCoordinates(r, s, i.unwrappedTileID, $785da19a645c07eb$var$ED(i, r, s)).point;
    }
    return {
        x: e1 / i.width * 2 - 1,
        y: 1 - t / i.height * 2
    };
}
function $785da19a645c07eb$var$LD(e1, t, i) {
    return i.transform.projectTileCoordinates(e1, t, i.unwrappedTileID, $785da19a645c07eb$var$ED(i, e1, t));
}
function $785da19a645c07eb$var$BD(e1, t, i) {
    return e1._unit()._perp()._mult(t * i);
}
function $785da19a645c07eb$var$OD(e1, t, i, n, a, r, s, o, l) {
    if (o.projectionCache.offsets[e1]) return o.projectionCache.offsets[e1];
    let c = i.add(t);
    if (e1 + l.direction < n || e1 + l.direction >= a) return o.projectionCache.offsets[e1] = c, c;
    let u = $785da19a645c07eb$var$FD(e1 + l.direction, o, l), h = $785da19a645c07eb$var$BD(u.sub(i), s, l.direction), d = i.add(h), p = u.add(h);
    return o.projectionCache.offsets[e1] = function(e1, t, i, n) {
        let a = t.y - e1.y, r = t.x - e1.x, s = n.y - i.y, o = n.x - i.x, l = s * r - o * a;
        if (0 === l) return null;
        let c = (o * (e1.y - i.y) - s * (e1.x - i.x)) / l;
        return new $785da19a645c07eb$var$Kc(e1.x + c * r, e1.y + c * a);
    }(r, c, d, p) || c, o.projectionCache.offsets[e1];
}
function $785da19a645c07eb$var$UD(e1, t, i, n, a, r, s, o, l) {
    let c = n ? e1 - t : e1 + t, u = c > 0 ? 1 : -1, h = 0;
    n && (u *= -1, h = Math.PI), u < 0 && (h += Math.PI);
    let d, p = u > 0 ? r + a : r + a + 1;
    o.projectionCache.cachedAnchorPoint ? d = o.projectionCache.cachedAnchorPoint : (d = $785da19a645c07eb$var$zD(o.tileAnchorPoint.x, o.tileAnchorPoint.y, o).point, o.projectionCache.cachedAnchorPoint = d);
    let m, g, f, A = d, _ = d, v = 0, y = 0, x = Math.abs(c), b = [];
    for(; v + y <= x;){
        if (p += u, p < r || p >= s) return null;
        v += y, _ = A, g = m;
        let e1 = {
            absOffsetX: x,
            direction: u,
            distanceFromAnchor: v,
            previousVertex: _
        };
        if (A = $785da19a645c07eb$var$FD(p, o, e1), 0 === i) b.push(_), f = A.sub(_);
        else {
            let t, n = A.sub(_);
            t = 0 === n.mag() ? $785da19a645c07eb$var$BD($785da19a645c07eb$var$FD(p + u, o, e1).sub(A), i, u) : $785da19a645c07eb$var$BD(n, i, u), g ||= _.add(t), m = $785da19a645c07eb$var$OD(p, t, A, r, s, g, i, o, e1), b.push(g), f = m.sub(g);
        }
        y = f.mag();
    }
    let w = (x - v) / y, E = f._mult(w)._add(g || _), k = h + Math.atan2(A.y - _.y, A.x - _.x);
    return b.push(E), {
        point: E,
        angle: l ? k : 0,
        path: b
    };
}
const $785da19a645c07eb$var$ND = new Float32Array([
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0,
    -1 / 0,
    -1 / 0,
    0
]);
function $785da19a645c07eb$var$jD(e1, t) {
    for(let i = 0; i < e1; i++){
        let e1 = t.length;
        t.resize(e1 + 4), t.float32.set($785da19a645c07eb$var$ND, 3 * e1);
    }
}
function $785da19a645c07eb$var$VD(e1, t, i) {
    let n = t[0], a = t[1];
    return e1[0] = i[0] * n + i[4] * a + i[12], e1[1] = i[1] * n + i[5] * a + i[13], e1[3] = i[3] * n + i[7] * a + i[15], e1;
}
var $785da19a645c07eb$var$qD = class {
    constructor(e1, t = new $785da19a645c07eb$var$_D(e1.width + 200, e1.height + 200, 25), i = new $785da19a645c07eb$var$_D(e1.width + 200, e1.height + 200, 25)){
        this.transform = e1, this.grid = t, this.ignoredGrid = i, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + 100, this.screenBottomBoundary = e1.height + 100, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
    }
    placeCollisionBox(e1, t, i, n, a, r, s, o, l, c, u, h, d = 0, p = !0) {
        let m, g = e1.anchorPointX + o[0], f = e1.anchorPointY + o[1], A = this.projectAndGetPerspectiveRatio(g, f, a, $785da19a645c07eb$var$fD(c, g, f, d, p), h), _ = i * A.perspectiveRatio;
        if (r || s) m = this._projectCollisionBox(e1, _, n, a, r, s, o, A, c, u, h, d, p);
        else {
            let t = A.x + (u ? u.x * _ : 0), i = A.y + (u ? u.y * _ : 0);
            m = {
                allPointsOccluded: !1,
                box: [
                    t + e1.x1 * _,
                    i + e1.y1 * _,
                    t + e1.x2 * _,
                    i + e1.y2 * _
                ]
            };
        }
        let [v, y, x, b] = m.box, w = r ? m.allPointsOccluded : A.isOccluded, E = w;
        return E ||= A.perspectiveRatio < this.perspectiveRatioCutoff, E ||= !this.isInsideGrid(v, y, x, b), E || "always" !== t && this.grid.hitTest(v, y, x, b, t, l) ? {
            box: [
                v,
                y,
                x,
                b
            ],
            placeable: !1,
            offscreen: !1,
            occluded: w
        } : {
            box: [
                v,
                y,
                x,
                b
            ],
            placeable: !0,
            offscreen: this.isOffscreen(v, y, x, b),
            occluded: w
        };
    }
    placeCollisionCircles(e1, t, i, n, a, r, s, o, l, c, u, h, d, p) {
        let m = [], g = new $785da19a645c07eb$var$Kc(t.anchorX, t.anchorY), f = this.getPerspectiveRatio(g.x, g.y, r, p?.(g.x, g.y)), A = (l ? a * this.transform.getPitchedTextCorrection(t.anchorX, t.anchorY, r) / f : a * f) / 24, _ = t.lineOffsetX * A, v = t.lineOffsetY * A, y = {
            getElevation: p,
            pitchedLabelPlaneMatrix: s,
            lineVertexArray: i,
            pitchWithMap: l,
            projectionCache: {
                projections: {},
                offsets: {},
                cachedAnchorPoint: void 0,
                anyProjectionOccluded: !1
            },
            transform: this.transform,
            tileAnchorPoint: g,
            unwrappedTileID: r,
            width: this.transform.width,
            height: this.transform.height,
            translation: d
        }, x = $785da19a645c07eb$var$TD(A, n, _, v, !1, t, !1, y), b = !1, w = !1, E = !0;
        if (x) {
            let t = .5 * u * f + h, i = new $785da19a645c07eb$var$Kc(-100, -100), n = new $785da19a645c07eb$var$Kc(this.screenRightBoundary, this.screenBottomBoundary), a = new $785da19a645c07eb$var$gD, r = x.first, s = x.last, d = [];
            for(let e1 = r.path.length - 1; e1 >= 1; e1--)d.push(r.path[e1]);
            for(let e1 = 1; e1 < s.path.length; e1++)d.push(s.path[e1]);
            let p = 2.5 * t;
            if (l) {
                let e1 = this.projectPathToScreenSpace(d, y);
                d = e1.some((e1)=>e1.signedDistanceFromCamera <= 0) ? [] : e1.map((e1)=>e1.point);
            }
            let g = [];
            if (d.length > 0) {
                let e1 = d[0].clone(), t = d[0].clone();
                for(let i = 1; i < d.length; i++)e1.x = Math.min(e1.x, d[i].x), e1.y = Math.min(e1.y, d[i].y), t.x = Math.max(t.x, d[i].x), t.y = Math.max(t.y, d[i].y);
                g = e1.x >= i.x && t.x <= n.x && e1.y >= i.y && t.y <= n.y ? [
                    d
                ] : t.x < i.x || e1.x > n.x || t.y < i.y || e1.y > n.y ? [] : $785da19a645c07eb$var$nE([
                    d
                ], i.x, i.y, n.x, n.y);
            }
            for (let i of g){
                a.reset(i, .25 * t);
                let n = 0;
                n = a.length <= .5 * t ? 1 : Math.ceil(a.paddedLength / p) + 1;
                for(let i = 0; i < n; i++){
                    let r = i / Math.max(n - 1, 1), s = a.lerp(r), l = s.x + 100, u = s.y + 100;
                    m.push(l, u, t, 0);
                    let h = l - t, d = u - t, p = l + t, g = u + t;
                    if (E &&= this.isOffscreen(h, d, p, g), w ||= this.isInsideGrid(h, d, p, g), "always" !== e1 && this.grid.hitTestCircle(l, u, t, e1, c) && (b = !0, !o)) return {
                        circles: [],
                        offscreen: !1,
                        collisionDetected: b
                    };
                }
            }
        }
        return {
            circles: !o && b || !w || f < this.perspectiveRatioCutoff ? [] : m,
            offscreen: E,
            collisionDetected: b
        };
    }
    projectPathToScreenSpace(e1, t) {
        return function(e1) {
            let t = 0, i = 0, n = 0, a = 0;
            for(let r = 0; r < e1.length; r++)e1[r].isOccluded ? (n = r + 1, a = 0) : (a++, a > i && (i = a, t = n));
            return e1.slice(t, t + i);
        }(function(e1, t) {
            let i = $785da19a645c07eb$var$yD;
            return function(e1, t) {
                let i = 1 / (t[0] * t[5] - t[1] * t[4]);
                e1[0] = t[5] * i, e1[1] = -t[1] * i, e1[2] = 0, e1[3] = 0, e1[4] = -t[4] * i, e1[5] = t[0] * i, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1 / t[10], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1 / t[15];
            }(i, t.pitchedLabelPlaneMatrix), e1.map((e1)=>{
                let n = $785da19a645c07eb$var$kD(e1.x, e1.y, i, $785da19a645c07eb$var$ED(t, e1.x, e1.y)), a = t.transform.projectTileCoordinates(n.point.x, n.point.y, t.unwrappedTileID, $785da19a645c07eb$var$ED(t, n.point.x, n.point.y));
                return a.point.x = (.5 * a.point.x + .5) * t.width, a.point.y = (.5 * -a.point.y + .5) * t.height, a;
            });
        }(e1, t));
    }
    queryRenderedSymbols(e1) {
        if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
        let t = [], i = new $785da19a645c07eb$var$fx;
        for (let n of e1){
            let e1 = new $785da19a645c07eb$var$Kc(n.x + 100, n.y + 100);
            i.extend(e1), t.push(e1);
        }
        let { minX: n, minY: a, maxX: r, maxY: s } = i, o = this.grid.query(n, a, r, s).concat(this.ignoredGrid.query(n, a, r, s)), l = {}, c = {};
        for (let e1 of o){
            let i = e1.key;
            (void 0 === l[i.bucketInstanceId] && (l[i.bucketInstanceId] = {}), l[i.bucketInstanceId][i.featureIndex]) || $785da19a645c07eb$var$fv(t, [
                new $785da19a645c07eb$var$Kc(e1.x1, e1.y1),
                new $785da19a645c07eb$var$Kc(e1.x2, e1.y1),
                new $785da19a645c07eb$var$Kc(e1.x2, e1.y2),
                new $785da19a645c07eb$var$Kc(e1.x1, e1.y2)
            ]) && (l[i.bucketInstanceId][i.featureIndex] = !0, void 0 === c[i.bucketInstanceId] && (c[i.bucketInstanceId] = []), c[i.bucketInstanceId].push(i.featureIndex));
        }
        return c;
    }
    insertCollisionBox(e1, t, i, n, a, r) {
        let s = {
            bucketInstanceId: n,
            featureIndex: a,
            collisionGroupID: r,
            overlapMode: t
        };
        (i ? this.ignoredGrid : this.grid).insert(s, e1[0], e1[1], e1[2], e1[3]);
    }
    insertCollisionCircles(e1, t, i, n, a, r) {
        let s = i ? this.ignoredGrid : this.grid, o = {
            bucketInstanceId: n,
            featureIndex: a,
            collisionGroupID: r,
            overlapMode: t
        };
        for(let t = 0; t < e1.length; t += 4)s.insertCircle(o, e1[t], e1[t + 1], e1[t + 2]);
    }
    projectAndGetPerspectiveRatio(e1, t, i, n, a) {
        if (a) {
            let i;
            null == n ? (i = [
                e1,
                t,
                0,
                1
            ], $785da19a645c07eb$var$VD(i, i, a)) : (i = [
                e1,
                t,
                n,
                1
            ], $785da19a645c07eb$var$Du(i, i, a));
            let r = i[3];
            return {
                x: (i[0] / r + 1) / 2 * this.transform.width + 100,
                y: (-i[1] / r + 1) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / r * .5,
                isOccluded: !1,
                signedDistanceFromCamera: r
            };
        }
        {
            let a = this.transform.projectTileCoordinates(e1, t, i, n);
            return {
                x: (a.point.x + 1) / 2 * this.transform.width + 100,
                y: (1 - a.point.y) / 2 * this.transform.height + 100,
                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / a.signedDistanceFromCamera * .5,
                isOccluded: a.isOccluded,
                signedDistanceFromCamera: a.signedDistanceFromCamera
            };
        }
    }
    getPerspectiveRatio(e1, t, i, n) {
        let a = this.transform.projectTileCoordinates(e1, t, i, n);
        return .5 + this.transform.cameraToCenterDistance / a.signedDistanceFromCamera * .5;
    }
    isOffscreen(e1, t, i, n) {
        return i < 100 || e1 >= this.screenRightBoundary || n < 100 || t > this.screenBottomBoundary;
    }
    isInsideGrid(e1, t, i, n) {
        return i >= 0 && e1 < this.gridRightBoundary && n >= 0 && t < this.gridBottomBoundary;
    }
    getViewportMatrix() {
        let e1 = $785da19a645c07eb$var$nu([]);
        return $785da19a645c07eb$var$su(e1, e1, [
            -100,
            -100,
            0
        ]), e1;
    }
    _projectCollisionBox(e1, t, i, n, a, r, s, o, l, c, u, h = 0, d = !0) {
        let p = 1, m = 0, g = 0, f = 1, A = e1.anchorPointX + s[0], _ = e1.anchorPointY + s[1];
        if (r && !a) {
            let e1 = this.projectAndGetPerspectiveRatio(A + 1, _, n, $785da19a645c07eb$var$fD(l, A + 1, _, h, d), u), t = e1.x - o.x, i = e1.y - o.y, a = Math.atan(i / t) + (t < 0 ? Math.PI : 0), r = Math.sin(a), s = Math.cos(a);
            p = s, m = r, g = -r, f = s;
        } else if (!r && a) {
            let e1 = $785da19a645c07eb$var$wD(this.transform);
            p = e1.vecEast[0], m = e1.vecEast[1], g = e1.vecSouth[0], f = e1.vecSouth[1];
        }
        let v = o.x, y = o.y, x = t;
        if (a && (v = A, y = _, x = 2 ** -(this.transform.zoom - i.overscaledZ), x *= this.transform.getPitchedTextCorrection(A, _, n), !c)) x *= $785da19a645c07eb$var$ch(.5 + .5 * (o.signedDistanceFromCamera / this.transform.cameraToCenterDistance), 0, 4);
        c && (v += p * c.x * x + g * c.y * x, y += m * c.x * x + f * c.y * x);
        let b = e1.x1 * x, w = e1.x2 * x, E = (b + w) / 2, k = e1.y1 * x, S = e1.y2 * x, M = (k + S) / 2, C = [
            {
                offsetX: b,
                offsetY: k
            },
            {
                offsetX: E,
                offsetY: k
            },
            {
                offsetX: w,
                offsetY: k
            },
            {
                offsetX: w,
                offsetY: M
            },
            {
                offsetX: w,
                offsetY: S
            },
            {
                offsetX: E,
                offsetY: S
            },
            {
                offsetX: b,
                offsetY: S
            },
            {
                offsetX: b,
                offsetY: M
            }
        ], T = [];
        for (let { offsetX: e1, offsetY: t } of C)T.push(new $785da19a645c07eb$var$Kc(v + p * e1 + g * t, y + m * e1 + f * t));
        let D = !1;
        if (a) {
            let e1 = T.map((e1)=>this.projectAndGetPerspectiveRatio(e1.x, e1.y, n, $785da19a645c07eb$var$fD(l, e1.x, e1.y, h, d), u));
            D = e1.some((e1)=>!e1.isOccluded), T = e1.map((e1)=>new $785da19a645c07eb$var$Kc(e1.x, e1.y));
        } else D = !0;
        return {
            box: $785da19a645c07eb$var$sh(T),
            allPointsOccluded: !D
        };
    }
}, $785da19a645c07eb$var$GD = class {
    constructor(e1, t, i, n){
        this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : n && i ? 1 : 0, this.placed = i;
    }
    isHidden() {
        return 0 === this.opacity && !this.placed;
    }
}, $785da19a645c07eb$var$HD = class {
    constructor(e1, t, i, n, a){
        this.text = new $785da19a645c07eb$var$GD(e1 ? e1.text : null, t, i, a), this.icon = new $785da19a645c07eb$var$GD(e1 ? e1.icon : null, t, n, a);
    }
    isHidden() {
        return this.text.isHidden() && this.icon.isHidden();
    }
}, $785da19a645c07eb$var$WD = class {
    constructor(e1, t, i){
        this.text = e1, this.icon = t, this.skipFade = i;
    }
}, $785da19a645c07eb$var$ZD = class {
    constructor(e1, t, i, n, a){
        this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = n, this.tileID = a;
    }
}, $785da19a645c07eb$var$KD = class {
    constructor(e1){
        this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
    }
    get(e1) {
        if (this.crossSourceCollisions) return {
            ID: 0,
            predicate: null
        };
        if (!this.collisionGroups[e1]) {
            let t = ++this.maxGroupID;
            this.collisionGroups[e1] = {
                ID: t,
                predicate: (e1)=>e1.collisionGroupID === t
            };
        }
        return this.collisionGroups[e1];
    }
};
function $785da19a645c07eb$var$XD(e1, t, i, n, a) {
    let { horizontalAlign: r, verticalAlign: s } = $785da19a645c07eb$var$Pw(e1), o = -(s - .5) * i;
    return new $785da19a645c07eb$var$Kc(-(r - .5) * t + n[0] * a, o + n[1] * a);
}
var $785da19a645c07eb$var$QD = class {
    constructor(e1, t, i, n, a){
        this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new $785da19a645c07eb$var$qD(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new $785da19a645c07eb$var$KD(n), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = a, a && (a.prevPlacement = void 0), this.placedOrientations = {};
    }
    _getTerrainElevationFunc(e1) {
        let t = this.terrain;
        if (t) return (i, n)=>t.getElevation(e1, i, n);
    }
    getBucketParts(e1, t, i, n) {
        let a = i.getBucket(t), r = i.latestFeatureIndex;
        if (!a || !r || t.id !== a.layerIds[0]) return;
        let s = i.collisionBoxArray, o = a.layers[0].layout, l = a.layers[0].paint, c = 2 ** (this.transform.zoom - i.tileID.overscaledZ), u = i.tileSize / $785da19a645c07eb$var$Vu, h = i.tileID.toUnwrapped(), d = "map" === o.get("text-rotation-alignment"), p = $785da19a645c07eb$var$qu(i, 1, this.transform.zoom), m = $785da19a645c07eb$var$Qu(this.collisionIndex.transform, i, l.get("text-translate"), l.get("text-translate-anchor")), g = $785da19a645c07eb$var$Qu(this.collisionIndex.transform, i, l.get("icon-translate"), l.get("icon-translate-anchor")), f = $785da19a645c07eb$var$xD(d, this.transform, p);
        this.retainedQueryData[a.bucketInstanceId] = new $785da19a645c07eb$var$ZD(a.bucketInstanceId, r, a.sourceLayerIndex, a.index, i.tileID);
        let A = {
            bucket: a,
            layout: o,
            translationText: m,
            translationIcon: g,
            unwrappedTileID: h,
            pitchedLabelPlaneMatrix: f,
            scale: c,
            textPixelRatio: u,
            holdingForFade: i.holdingForSymbolFade(),
            collisionBoxArray: s,
            partiallyEvaluatedTextSize: $785da19a645c07eb$var$Kw(a.textSizeData, this.transform.zoom),
            collisionGroup: this.collisionGroups.get(a.sourceID)
        };
        if (n) for (let t of a.sortKeyRanges){
            let { sortKey: i, symbolInstanceStart: n, symbolInstanceEnd: a } = t;
            e1.push({
                sortKey: i,
                symbolInstanceStart: n,
                symbolInstanceEnd: a,
                parameters: A
            });
        }
        else e1.push({
            symbolInstanceStart: 0,
            symbolInstanceEnd: a.symbolInstances.length,
            parameters: A
        });
    }
    attemptAnchorPlacement(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _, v, y, x) {
        let b = $785da19a645c07eb$var$mE[e1.textAnchor], w = [
            e1.textOffset0,
            e1.textOffset1
        ], E = $785da19a645c07eb$var$XD(b, i, n, w, a), k = this.collisionIndex.placeCollisionBox(t, h, o, l, c, s, r, g, u.predicate, _, E, v, y, x);
        if ((!A || this.collisionIndex.placeCollisionBox(A, h, o, l, c, s, r, f, u.predicate, _, E, v, y, x).placeable) && k.placeable) {
            let e1;
            if (this.prevPlacement?.variableOffsets[d.crossTileID] && this.prevPlacement?.placements[d.crossTileID]?.text && (e1 = this.prevPlacement.variableOffsets[d.crossTileID].anchor), 0 === d.crossTileID) throw Error("symbolInstance.crossTileID can't be 0");
            return this.variableOffsets[d.crossTileID] = {
                textOffset: w,
                width: i,
                height: n,
                anchor: b,
                textBoxScale: a,
                prevAnchor: e1
            }, this.markUsedJustification(p, b, d, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, d), this.placedOrientations[d.crossTileID] = m), {
                shift: E,
                placedGlyphBoxes: k
            };
        }
    }
    placeLayerBucketPart(e1, t, i) {
        let { bucket: n, layout: a, translationText: r, translationIcon: s, unwrappedTileID: o, pitchedLabelPlaneMatrix: l, textPixelRatio: c, holdingForFade: u, collisionBoxArray: h, partiallyEvaluatedTextSize: d, collisionGroup: p } = e1.parameters, m = a.get("text-optional"), g = a.get("icon-optional"), f = $785da19a645c07eb$var$wE(a, "text-overlap", "text-allow-overlap"), A = "always" === f, _ = $785da19a645c07eb$var$wE(a, "icon-overlap", "icon-allow-overlap"), v = "always" === _, y = "map" === a.get("text-rotation-alignment"), x = "map" === a.get("text-pitch-alignment"), b = "none" !== a.get("icon-text-fit"), w = "viewport-y" === a.get("symbol-z-order"), E = "ground" === a.get("symbol-height-anchor"), k = A && (v || !n.hasIconData() || g), S = v && (A || !n.hasTextData() || m);
        !n.collisionArrays && h && n.deserializeCollisionBoxes(h);
        let M = this.retainedQueryData[n.bucketInstanceId].tileID, C = this._getTerrainElevationFunc(M), T = this.transform.getFastPathSimpleProjectionMatrix(M), D = (e1, h, v)=>{
            if (t[e1.crossTileID]) return;
            if (u) return void (this.placements[e1.crossTileID] = new $785da19a645c07eb$var$WD(!1, !1, !1));
            let w = e1.heightOffset, D = !1, P = !1, I = !0, F = null, z = {
                box: null,
                placeable: !1,
                offscreen: null,
                occluded: !1
            }, R = {
                placeable: !1
            }, L1 = null, B = null, O = null, U = 0, N = 0, j = 0;
            h.textFeatureIndex ? U = h.textFeatureIndex : e1.useRuntimeCollisionCircles && (U = e1.featureIndex), h.verticalTextFeatureIndex && (N = h.verticalTextFeatureIndex);
            let V = h.textBox;
            if (V) {
                let t = (t)=>{
                    let i = 1;
                    if (n.allowVerticalPlacement && !t && this.prevPlacement) {
                        let t = this.prevPlacement.placedOrientations[e1.crossTileID];
                        t && (this.placedOrientations[e1.crossTileID] = t, i = t, this.markUsedOrientation(n, i, e1));
                    }
                    return i;
                }, a = (t, i)=>{
                    if (n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && h.verticalTextBox) {
                        for (let e1 of n.writingModes)if (2 === e1 ? (z = i(), R = z) : z = t(), z?.placeable) break;
                    } else z = t();
                }, l = e1.textAnchorOffsetStartIndex, u = e1.textAnchorOffsetEndIndex;
                if (u === l) {
                    let i = (t, i)=>{
                        let a = this.collisionIndex.placeCollisionBox(t, f, c, M, o, x, y, r, p.predicate, C, void 0, T, w, E);
                        return a?.placeable && (this.markUsedOrientation(n, i, e1), this.placedOrientations[e1.crossTileID] = i), a;
                    };
                    a(()=>i(V, 1), ()=>{
                        let t = h.verticalTextBox;
                        return n.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && t ? i(t, 2) : {
                            box: null,
                            offscreen: null
                        };
                    }), t(z?.placeable);
                } else {
                    let d = $785da19a645c07eb$var$mE[this.prevPlacement?.variableOffsets[e1.crossTileID]?.anchor], m = (t, a, h)=>{
                        let m = t.x2 - t.x1, g = t.y2 - t.y1, A = e1.textBoxScale, v = b && "never" === _ ? a : null, k = null, S = "never" === f ? 1 : 2, P = "never";
                        d && S++;
                        for(let i = 0; i < S; i++){
                            for(let i = l; i < u; i++){
                                let a = n.textAnchorOffsets.get(i);
                                if (d && a.textAnchor !== d) continue;
                                let l = this.attemptAnchorPlacement(a, t, m, g, A, y, x, c, M, o, p, P, e1, n, h, r, s, v, C, T, w, E);
                                if (l && (k = l.placedGlyphBoxes, k?.placeable)) return D = !0, F = l.shift, k;
                            }
                            d ? d = null : P = f;
                        }
                        return i && !k && (k = {
                            box: this.collisionIndex.placeCollisionBox(V, "always", c, M, o, x, y, r, p.predicate, C, void 0, T, w, E).box,
                            offscreen: !1,
                            placeable: !1,
                            occluded: !1
                        }), k;
                    };
                    a(()=>m(V, h.iconBox, 1), ()=>{
                        let t = h.verticalTextBox, i = z?.placeable;
                        return n.allowVerticalPlacement && !i && e1.numVerticalGlyphVertices > 0 && t ? m(t, h.verticalIconBox, 2) : {
                            box: null,
                            occluded: !0,
                            offscreen: null
                        };
                    }), z && (D = z.placeable, I = z.offscreen);
                    let g = t(z?.placeable);
                    if (!D && this.prevPlacement) {
                        let t = this.prevPlacement.variableOffsets[e1.crossTileID];
                        t && (this.variableOffsets[e1.crossTileID] = t, this.markUsedJustification(n, t.anchor, e1, g));
                    }
                }
            }
            if (L1 = z, D = L1?.placeable, I = L1?.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                let t = n.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), s = $785da19a645c07eb$var$Zw(n.textSizeData, d, t), c = a.get("text-padding"), u = e1.collisionCircleDiameter;
                B = this.collisionIndex.placeCollisionCircles(f, t, n.lineVertexArray, n.glyphOffsetArray, s, o, l, i, x, p.predicate, u, c, r, C), B.circles.length && B.collisionDetected && !i && $785da19a645c07eb$var$wh("Collisions detected, but collision boxes are not shown"), D = A || B.circles.length > 0 && !B.collisionDetected, I &&= B.offscreen;
            }
            if (h.iconFeatureIndex && (j = h.iconFeatureIndex), h.iconBox) {
                let e1 = (e1)=>this.collisionIndex.placeCollisionBox(e1, _, c, M, o, x, y, s, p.predicate, C, b && F ? F : void 0, T, w, E);
                R && R.placeable && h.verticalIconBox ? (O = e1(h.verticalIconBox), P = O.placeable) : (O = e1(h.iconBox), P = O.placeable), I &&= O.offscreen;
            }
            let q = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, G = g || 0 === e1.numIconVertices;
            q || G ? G ? q || (P &&= D) : D = P && D : P = D = P && D;
            let H = D && L1.placeable, W = P && O.placeable;
            if (H && (R && R.placeable && N ? this.collisionIndex.insertCollisionBox(L1.box, f, a.get("text-ignore-placement"), n.bucketInstanceId, N, p.ID) : this.collisionIndex.insertCollisionBox(L1.box, f, a.get("text-ignore-placement"), n.bucketInstanceId, U, p.ID)), W && this.collisionIndex.insertCollisionBox(O.box, _, a.get("icon-ignore-placement"), n.bucketInstanceId, j, p.ID), B && D && this.collisionIndex.insertCollisionCircles(B.circles, f, a.get("text-ignore-placement"), n.bucketInstanceId, U, p.ID), i && this.storeCollisionData(n.bucketInstanceId, v, h, L1, O, B), 0 === e1.crossTileID) throw Error("symbolInstance.crossTileID can't be 0");
            if (0 === n.bucketInstanceId) throw Error("bucket.bucketInstanceId can't be 0");
            let Z = (D || k) && !L1?.occluded, K = (P || S) && !O?.occluded;
            this.placements[e1.crossTileID] = new $785da19a645c07eb$var$WD(Z, K, I || n.justReloaded), t[e1.crossTileID] = !0;
        };
        if (w) {
            if (0 !== e1.symbolInstanceStart) throw Error("bucket.bucketInstanceId should be 0");
            let t = n.getSortedSymbolIndexes(-this.transform.bearingInRadians);
            for(let e1 = t.length - 1; e1 >= 0; --e1){
                let i = t[e1];
                D(n.symbolInstances.get(i), n.collisionArrays[i], i);
            }
        } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)D(n.symbolInstances.get(t), n.collisionArrays[t], t);
        n.justReloaded = !1;
    }
    storeCollisionData(e1, t, i, n, a, r) {
        if (i.textBox || i.iconBox) {
            let r, s;
            this.collisionBoxArrays.has(e1) ? r = this.collisionBoxArrays.get(e1) : (r = new Map, this.collisionBoxArrays.set(e1, r)), r.has(t) ? s = r.get(t) : (s = {
                text: null,
                icon: null
            }, r.set(t, s)), i.textBox && (s.text = n.box), i.iconBox && (s.icon = a.box);
        }
        if (r) {
            let t = this.collisionCircleArrays[e1];
            void 0 === t && (t = this.collisionCircleArrays[e1] = []);
            for(let e1 = 0; e1 < r.circles.length; e1 += 4)t.push(r.circles[e1 + 0] - 100), t.push(r.circles[e1 + 1] - 100), t.push(r.circles[e1 + 2]), t.push(+!!r.collisionDetected);
        }
    }
    markUsedJustification(e1, t, i, n) {
        let a, r = {
            left: i.leftJustifiedTextSymbolIndex,
            center: i.centerJustifiedTextSymbolIndex,
            right: i.rightJustifiedTextSymbolIndex
        };
        a = 2 === n ? i.verticalPlacedTextSymbolIndex : r[$785da19a645c07eb$var$_E(t)];
        let s = [
            i.leftJustifiedTextSymbolIndex,
            i.centerJustifiedTextSymbolIndex,
            i.rightJustifiedTextSymbolIndex,
            i.verticalPlacedTextSymbolIndex
        ];
        for (let t of s)t >= 0 && (e1.text.placedSymbolArray.get(t).crossTileID = a >= 0 && t !== a ? 0 : i.crossTileID);
    }
    markUsedOrientation(e1, t, i) {
        let n = 1 === t || 3 === t ? t : 0, a = 2 === t ? t : 0, r = [
            i.leftJustifiedTextSymbolIndex,
            i.centerJustifiedTextSymbolIndex,
            i.rightJustifiedTextSymbolIndex
        ];
        for (let t of r)e1.text.placedSymbolArray.get(t).placedOrientation = n;
        i.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(i.verticalPlacedTextSymbolIndex).placedOrientation = a);
    }
    commit(e1) {
        this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
        let t = this.prevPlacement, i = !1;
        this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
        let n = t ? t.symbolFadeChange(e1) : 1, a = t ? t.opacities : {}, r = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
        for(let e1 in this.placements){
            let t = this.placements[e1], r = a[e1];
            r ? (this.opacities[e1] = new $785da19a645c07eb$var$HD(r, n, t.text, t.icon), i ||= t.text !== r.text.placed, i ||= t.icon !== r.icon.placed) : (this.opacities[e1] = new $785da19a645c07eb$var$HD(null, n, t.text, t.icon, t.skipFade), i ||= t.text || t.icon);
        }
        for(let e1 in a){
            let t = a[e1];
            if (!this.opacities[e1]) {
                let a = new $785da19a645c07eb$var$HD(t, n, !1, !1);
                a.isHidden() || (this.opacities[e1] = a, i ||= t.text.placed, i ||= t.icon.placed);
            }
        }
        for(let e1 in r)!this.variableOffsets[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.variableOffsets[e1] = r[e1]);
        for(let e1 in s)!this.placedOrientations[e1] && this.opacities[e1] && !this.opacities[e1].isHidden() && (this.placedOrientations[e1] = s[e1]);
        if (t && void 0 === t.lastPlacementChangeTime) throw Error("Last placement time for previous placement is not defined");
        i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
    }
    updateLayerOpacities(e1, t) {
        let i = {};
        for (let n of t){
            let t = n.getBucket(e1);
            t && n.latestFeatureIndex && e1.id === t.layerIds[0] && this.updateBucketOpacities(t, n.tileID, i, n.collisionBoxArray);
        }
    }
    updateBucketOpacities(e1, t, i, n) {
        e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
        let a = e1.layers[0], r = a.layout, s = new $785da19a645c07eb$var$HD(null, 0, !1, !1, !0), o = r.get("text-allow-overlap"), l = r.get("icon-allow-overlap"), c = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === r.get("text-rotation-alignment"), h = "map" === r.get("text-pitch-alignment"), d = "none" !== r.get("icon-text-fit"), p = new $785da19a645c07eb$var$HD(null, 0, o && (l || !e1.hasIconData() || r.get("icon-optional")), l && (o || !e1.hasTextData() || r.get("text-optional")), !0);
        !e1.collisionArrays && n && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(n);
        let m = (e1, t, i)=>{
            for(let n = 0; n < t / 4; n++)e1.opacityVertexArray.emplaceBack(i);
            e1.hasVisibleVertices ||= i !== $785da19a645c07eb$var$nP;
        }, g = this.collisionBoxArrays.get(e1.bucketInstanceId);
        for(let t = 0; t < e1.symbolInstances.length; t++){
            let n = e1.symbolInstances.get(t), { numHorizontalGlyphVertices: a, numVerticalGlyphVertices: r, crossTileID: o } = n, l = i[o], f = this.opacities[o];
            l ? f = s : f || (f = p, this.opacities[o] = f), i[o] = !0;
            let A = a > 0 || r > 0, _ = n.numIconVertices > 0, v = this.placedOrientations[n.crossTileID], y = 2 === v, x = 1 === v || 3 === v;
            if (A) {
                let t = $785da19a645c07eb$var$iP(f.text), i = y ? $785da19a645c07eb$var$nP : t;
                m(e1.text, a, i);
                let s = x ? $785da19a645c07eb$var$nP : t;
                m(e1.text, r, s);
                let o = f.text.isHidden(), l = [
                    n.rightJustifiedTextSymbolIndex,
                    n.centerJustifiedTextSymbolIndex,
                    n.leftJustifiedTextSymbolIndex
                ];
                for (let t of l)t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = o || y ? 1 : 0);
                n.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(n.verticalPlacedTextSymbolIndex).hidden = o || x ? 1 : 0);
                let c = this.variableOffsets[n.crossTileID];
                c && this.markUsedJustification(e1, c.anchor, n, v);
                let u = this.placedOrientations[n.crossTileID];
                u && (this.markUsedJustification(e1, "left", n, u), this.markUsedOrientation(e1, u, n));
            }
            if (_) {
                let t = $785da19a645c07eb$var$iP(f.icon), i = !(d && n.verticalPlacedIconSymbolIndex && y);
                if (n.placedIconSymbolIndex >= 0) {
                    let a = i ? t : $785da19a645c07eb$var$nP;
                    m(e1.icon, n.numIconVertices, a), e1.icon.placedSymbolArray.get(n.placedIconSymbolIndex).hidden = f.icon.isHidden();
                }
                if (n.verticalPlacedIconSymbolIndex >= 0) {
                    let a = i ? $785da19a645c07eb$var$nP : t;
                    m(e1.icon, n.numVerticalIconVertices, a), e1.icon.placedSymbolArray.get(n.verticalPlacedIconSymbolIndex).hidden = f.icon.isHidden();
                }
            }
            let b = g?.has(t) ? g.get(t) : {
                text: null,
                icon: null
            };
            if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                let i = e1.collisionArrays[t];
                if (i) {
                    let t = new $785da19a645c07eb$var$Kc(0, 0);
                    if (i.textBox || i.verticalTextBox) {
                        let n = !0;
                        if (c) {
                            let e1 = this.variableOffsets[o];
                            e1 ? (t = $785da19a645c07eb$var$XD(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textBoxScale), u && t._rotate(h ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : n = !1;
                        }
                        if (i.textBox || i.verticalTextBox) {
                            let a;
                            i.textBox && (a = y), i.verticalTextBox && (a = x), $785da19a645c07eb$var$YD(e1.textCollisionBox.collisionVertexArray, f.text.placed, !n || a, b.text, t.x, t.y);
                        }
                    }
                    if (i.iconBox || i.verticalIconBox) {
                        let n, a = !(x || !i.verticalIconBox);
                        i.iconBox && (n = a), i.verticalIconBox && (n = !a), $785da19a645c07eb$var$YD(e1.iconCollisionBox.collisionVertexArray, f.icon.placed, n, b.icon, d ? t.x : 0, d ? t.y : 0);
                    }
                }
            }
        }
        if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw Error(`bucket.text.opacityVertexArray.length (= ${e1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${e1.text.layoutVertexArray.length}) / 4`);
        if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw Error(`bucket.icon.opacityVertexArray.length (= ${e1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${e1.icon.layoutVertexArray.length}) / 4`);
        e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
    }
    symbolFadeChange(e1) {
        return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
    }
    zoomAdjustment(e1) {
        return Math.max(0, (this.transform.zoom - e1) / 1.5);
    }
    hasTransitions(e1) {
        return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
    }
    stillRecent(e1, t) {
        let i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
        return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
    }
    setStale() {
        this.stale = !0;
    }
};
function $785da19a645c07eb$var$YD(e1, t, i, n, a, r) {
    (!n || 0 === n.length) && (n = [
        0,
        0,
        0,
        0
    ]);
    let s = n[0] - 100, o = n[1] - 100, l = n[2] - 100, c = n[3] - 100;
    e1.emplaceBack(+!!t, +!!i, a || 0, r || 0, s, o), e1.emplaceBack(+!!t, +!!i, a || 0, r || 0, l, o), e1.emplaceBack(+!!t, +!!i, a || 0, r || 0, l, c), e1.emplaceBack(+!!t, +!!i, a || 0, r || 0, s, c);
}
const $785da19a645c07eb$var$JD = 2 ** 25, $785da19a645c07eb$var$$D = 2 ** 24, $785da19a645c07eb$var$eP = 2 ** 17, $785da19a645c07eb$var$tP = 65536;
function $785da19a645c07eb$var$iP(e1) {
    if (0 === e1.opacity && !e1.placed) return 0;
    if (1 === e1.opacity && e1.placed) return 4294967295;
    let t = +!!e1.placed, i = Math.floor(127 * e1.opacity);
    return i * $785da19a645c07eb$var$JD + t * $785da19a645c07eb$var$$D + i * $785da19a645c07eb$var$eP + t * $785da19a645c07eb$var$tP + 512 * i + 256 * t + 2 * i + t;
}
const $785da19a645c07eb$var$nP = 0;
var $785da19a645c07eb$var$aP = class {
    constructor(e1){
        this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && !e1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
    }
    continuePlacement(e1, t, i, n, a) {
        let r = this._bucketParts;
        for(; this._currentTileIndex < e1.length;){
            let i = e1[this._currentTileIndex];
            if (t.getBucketParts(r, n, i, this._sortAcrossTiles), this._currentTileIndex++, a()) return !0;
        }
        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, r.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < r.length;){
            let e1 = r[this._currentPartIndex];
            if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, i), this._currentPartIndex++, a()) return !0;
        }
        return !1;
    }
}, $785da19a645c07eb$var$rP = class {
    constructor(e1, t, i, n, a, r, s, o){
        this.placement = new $785da19a645c07eb$var$QD(e1, t, r, s, o), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = n, this._showCollisionBoxes = a, this._done = !1;
    }
    isDone() {
        return this._done;
    }
    continuePlacement(e1, t, i) {
        let n = $785da19a645c07eb$var$aC(), a = ()=>!this._forceFullPlacement && $785da19a645c07eb$var$aC() - n > 2;
        for(; this._currentPlacementIndex >= 0;){
            let n = t[e1[this._currentPlacementIndex]], r = this.placement.collisionIndex.transform.zoom;
            if ($785da19a645c07eb$var$RE(n) && n.layout && (!n.minzoom || n.minzoom <= r) && (!n.maxzoom || n.maxzoom > r)) {
                if (this._inProgressLayer ||= new $785da19a645c07eb$var$aP(n), this._inProgressLayer.continuePlacement(i[n.source], this.placement, this._showCollisionBoxes, n, a)) return;
                delete this._inProgressLayer;
            }
            this._currentPlacementIndex--;
        }
        this._done = !0;
    }
    commit(e1) {
        return this.placement.commit(e1), this.placement;
    }
};
const $785da19a645c07eb$var$sP = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
], $785da19a645c07eb$var$oP = new Uint32Array(96);
var $785da19a645c07eb$var$lP = class e1 {
    static from(t) {
        if (!t || void 0 === t.byteLength || t.buffer) throw Error("Data must be an instance of ArrayBuffer or SharedArrayBuffer.");
        let [i, n] = new Uint8Array(t, 0, 2);
        if (219 !== i) throw Error("Data does not appear to be in a KDBush format.");
        let a = n >> 4;
        if (1 !== a) throw Error(`Got v${a} data when expected v1.`);
        let r = $785da19a645c07eb$var$sP[15 & n];
        if (!r) throw Error("Unrecognized array type.");
        let [s] = new Uint16Array(t, 2, 1), [o] = new Uint32Array(t, 4, 1);
        return new e1(o, s, r, void 0, t);
    }
    constructor(e1, t = 64, i = Float64Array, n = ArrayBuffer, a){
        if (isNaN(e1) || e1 < 0) throw Error(`Unexpected numItems value: ${e1}.`);
        this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
        let r = $785da19a645c07eb$var$sP.indexOf(this.ArrayType), s = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, o = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, l = (8 - o % 8) % 8;
        if (r < 0) throw Error(`Unexpected typed array class: ${i}.`);
        if (a) this.data = a, this.ids = new this.IndexArrayType(a, 8, e1), this.coords = new i(a, 8 + o + l, 2 * e1), this._pos = 2 * e1, this._finished = !0;
        else {
            let a = this.data = new n(8 + s + o + l);
            this.ids = new this.IndexArrayType(a, 8, e1), this.coords = new i(a, 8 + o + l, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(a, 0, 2).set([
                219,
                16 + r
            ]), new Uint16Array(a, 2, 1)[0] = t, new Uint32Array(a, 4, 1)[0] = e1;
        }
    }
    add(e1, t) {
        let i = this._pos >> 1;
        return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, i;
    }
    finish() {
        let e1 = this._pos >> 1;
        if (e1 !== this.numItems) throw Error(`Added ${e1} items when expected ${this.numItems}.`);
        return $785da19a645c07eb$var$cP(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
    }
    range(e1, t, i, n) {
        if (!this._finished) throw Error("Data not yet indexed - call index.finish().");
        let { ids: a, coords: r, nodeSize: s } = this;
        $785da19a645c07eb$var$oP[0] = 0, $785da19a645c07eb$var$oP[1] = a.length - 1, $785da19a645c07eb$var$oP[2] = 0;
        let o = 3, l = [];
        for(; o > 0;){
            let c = $785da19a645c07eb$var$oP[--o], u = $785da19a645c07eb$var$oP[--o], h = $785da19a645c07eb$var$oP[--o];
            if (u - h <= s) {
                for(let s = h; s <= u; s++){
                    let o = r[2 * s], c = r[2 * s + 1];
                    o >= e1 && o <= i && c >= t && c <= n && l.push(a[s]);
                }
                continue;
            }
            let d = h + u >> 1, p = r[2 * d], m = r[2 * d + 1];
            p >= e1 && p <= i && m >= t && m <= n && l.push(a[d]), (0 === c ? e1 <= p : t <= m) && ($785da19a645c07eb$var$oP[o++] = h, $785da19a645c07eb$var$oP[o++] = d - 1, $785da19a645c07eb$var$oP[o++] = 1 - c), (0 === c ? i >= p : n >= m) && ($785da19a645c07eb$var$oP[o++] = d + 1, $785da19a645c07eb$var$oP[o++] = u, $785da19a645c07eb$var$oP[o++] = 1 - c);
        }
        return l;
    }
    within(e1, t, i) {
        let n = [];
        return this.withinInto(e1, t, i, n), n;
    }
    withinInto(e1, t, i, n) {
        if (!this._finished) throw Error("Data not yet indexed - call index.finish().");
        let { ids: a, coords: r, nodeSize: s } = this;
        $785da19a645c07eb$var$oP[0] = 0, $785da19a645c07eb$var$oP[1] = a.length - 1, $785da19a645c07eb$var$oP[2] = 0;
        let o = 3, l = 0, c = i * i;
        for(; o > 0;){
            let u = $785da19a645c07eb$var$oP[--o], h = $785da19a645c07eb$var$oP[--o], d = $785da19a645c07eb$var$oP[--o];
            if (h - d <= s) {
                for(let i = d; i <= h; i++)$785da19a645c07eb$var$pP(r[2 * i], r[2 * i + 1], e1, t) <= c && (n[l++] = a[i]);
                continue;
            }
            let p = d + h >> 1, m = r[2 * p], g = r[2 * p + 1];
            $785da19a645c07eb$var$pP(m, g, e1, t) <= c && (n[l++] = a[p]), (0 === u ? e1 - i <= m : t - i <= g) && ($785da19a645c07eb$var$oP[o++] = d, $785da19a645c07eb$var$oP[o++] = p - 1, $785da19a645c07eb$var$oP[o++] = 1 - u), (0 === u ? e1 + i >= m : t + i >= g) && ($785da19a645c07eb$var$oP[o++] = p + 1, $785da19a645c07eb$var$oP[o++] = h, $785da19a645c07eb$var$oP[o++] = 1 - u);
        }
        return l;
    }
};
function $785da19a645c07eb$var$cP(e1, t, i, n, a, r) {
    if (a - n <= i) return;
    let s = n + a >> 1;
    $785da19a645c07eb$var$uP(e1, t, s, n, a, r), $785da19a645c07eb$var$cP(e1, t, i, n, s - 1, 1 - r), $785da19a645c07eb$var$cP(e1, t, i, s + 1, a, 1 - r);
}
function $785da19a645c07eb$var$uP(e1, t, i, n, a, r) {
    for(; a > n;){
        if (a - n > 600) {
            let s = a - n + 1, o = i - n + 1, l = Math.log(s), c = .5 * Math.exp(2 * l / 3), u = .5 * Math.sqrt(l * c * (s - c) / s) * (o - s / 2 < 0 ? -1 : 1);
            $785da19a645c07eb$var$uP(e1, t, i, Math.max(n, Math.floor(i - o * c / s + u)), Math.min(a, Math.floor(i + (s - o) * c / s + u)), r);
        }
        let s = t[2 * i + r], o = n, l = a;
        for($785da19a645c07eb$var$hP(e1, t, n, i), t[2 * a + r] > s && $785da19a645c07eb$var$hP(e1, t, n, a); o < l;){
            for($785da19a645c07eb$var$hP(e1, t, o, l), o++, l--; t[2 * o + r] < s;)o++;
            for(; t[2 * l + r] > s;)l--;
        }
        t[2 * n + r] === s ? $785da19a645c07eb$var$hP(e1, t, n, l) : (l++, $785da19a645c07eb$var$hP(e1, t, l, a)), l <= i && (n = l + 1), i <= l && (a = l - 1);
    }
}
function $785da19a645c07eb$var$hP(e1, t, i, n) {
    $785da19a645c07eb$var$dP(e1, i, n), $785da19a645c07eb$var$dP(t, 2 * i, 2 * n), $785da19a645c07eb$var$dP(t, 2 * i + 1, 2 * n + 1);
}
function $785da19a645c07eb$var$dP(e1, t, i) {
    let n = e1[t];
    e1[t] = e1[i], e1[i] = n;
}
function $785da19a645c07eb$var$pP(e1, t, i, n) {
    let a = e1 - i, r = t - n;
    return a * a + r * r;
}
const $785da19a645c07eb$var$mP = .03125;
var $785da19a645c07eb$var$gP = class {
    constructor(e1, t, i){
        this.tileID = e1, this.bucketInstanceId = i, this._symbolsByKey = {};
        let n = new Map;
        for(let e1 = 0; e1 < t.length; e1++){
            let i = t.get(e1), a = i.key, r = n.get(a);
            r ? r.push(i) : n.set(a, [
                i
            ]);
        }
        for (let [e1, t] of n){
            let i = {
                positions: t.map((e1)=>({
                        x: Math.floor(e1.anchorX * $785da19a645c07eb$var$mP),
                        y: Math.floor(e1.anchorY * $785da19a645c07eb$var$mP)
                    })),
                crossTileIDs: t.map((e1)=>e1.crossTileID)
            };
            if (i.positions.length > 128) {
                let e1 = new $785da19a645c07eb$var$lP(i.positions.length, 16, Uint16Array);
                for (let { x: t, y: n } of i.positions)e1.add(t, n);
                e1.finish(), delete i.positions, i.index = e1;
            }
            this._symbolsByKey[e1] = i;
        }
    }
    getScaledCoordinates(e1, t) {
        let { x: i, y: n, z: a } = this.tileID.canonical, { x: r, y: s, z: o } = t.canonical, l = $785da19a645c07eb$var$mP / 2 ** (o - a), c = (r * $785da19a645c07eb$var$Vu + e1.anchorX) * l, u = (s * $785da19a645c07eb$var$Vu + e1.anchorY) * l, h = i * $785da19a645c07eb$var$Vu * $785da19a645c07eb$var$mP, d = n * $785da19a645c07eb$var$Vu * $785da19a645c07eb$var$mP;
        return {
            x: Math.floor(c - h),
            y: Math.floor(u - d)
        };
    }
    findMatches(e1, t, i) {
        let n = this.tileID.canonical.z < t.canonical.z ? 1 : 2 ** (this.tileID.canonical.z - t.canonical.z);
        for(let a = 0; a < e1.length; a++){
            let r = e1.get(a);
            if (r.crossTileID) continue;
            let s = this._symbolsByKey[r.key];
            if (!s) continue;
            let o = this.getScaledCoordinates(r, t);
            s.index ? this.findMatchesForIndexedEntry(s, r, o, n, i) : s.positions && this.findMatchesForNonIndexedEntry(s, r, o, n, i);
        }
    }
    findMatchesForIndexedEntry(e1, t, i, n, a) {
        let r = e1.index.range(i.x - n, i.y - n, i.x + n, i.y + n), s = 1 / 0;
        for (let t of r)t < s && !a[e1.crossTileIDs[t]] && (s = t);
        if (s !== 1 / 0) {
            let i = e1.crossTileIDs[s];
            a[i] = !0, t.crossTileID = i;
        }
    }
    findMatchesForNonIndexedEntry(e1, t, i, n, a) {
        for(let r = 0; r < e1.positions.length; r++){
            let s = e1.positions[r], o = e1.crossTileIDs[r];
            if (Math.abs(s.x - i.x) <= n && Math.abs(s.y - i.y) <= n && !a[o]) {
                a[o] = !0, t.crossTileID = o;
                break;
            }
        }
    }
    getCrossTileIDsLists() {
        return Object.values(this._symbolsByKey).map(({ crossTileIDs: e1 })=>e1);
    }
}, $785da19a645c07eb$var$fP = class {
    constructor(){
        this.maxCrossTileID = 0;
    }
    generate() {
        return ++this.maxCrossTileID;
    }
}, $785da19a645c07eb$var$AP = class {
    constructor(){
        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
    }
    handleWrapJump(e1) {
        let t = Math.round((e1 - this.lng) / 360);
        if (0 !== t) for(let e1 in this.indexes){
            let i = this.indexes[e1], n = {};
            for(let e1 in i){
                let a = i[e1];
                a.tileID = a.tileID.unwrapTo(a.tileID.wrap + t), n[a.tileID.key] = a;
            }
            this.indexes[e1] = n;
        }
        this.lng = e1;
    }
    addBucket(e1, t, i) {
        if (this.indexes[e1.overscaledZ]?.[e1.key]) {
            if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
            this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++)t.symbolInstances.get(e1).crossTileID = 0;
        this.usedCrossTileIDs[e1.overscaledZ] ||= {};
        let n = this.usedCrossTileIDs[e1.overscaledZ];
        for(let i in this.indexes){
            let a = this.indexes[i];
            if (Number(i) > e1.overscaledZ) for(let i in a){
                let r = a[i];
                r.tileID.isChildOf(e1) && r.findMatches(t.symbolInstances, e1, n);
            }
            else {
                let r = a[e1.scaledTo(Number(i)).key];
                r && r.findMatches(t.symbolInstances, e1, n);
            }
        }
        for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
            let a = t.symbolInstances.get(e1);
            a.crossTileID || (a.crossTileID = i.generate(), n[a.crossTileID] = !0);
        }
        return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new $785da19a645c07eb$var$gP(e1, t.symbolInstances, t.bucketInstanceId), !0;
    }
    removeBucketCrossTileIDs(e1, t) {
        for (let i of t.getCrossTileIDsLists())for (let t of i)delete this.usedCrossTileIDs[e1][t];
    }
    removeStaleBuckets(e1) {
        let t = !1;
        for(let i in this.indexes){
            let n = this.indexes[i];
            for(let a in n)e1[n[a].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, n[a]), delete n[a], t = !0);
        }
        return t;
    }
}, $785da19a645c07eb$var$_P = class {
    constructor(){
        this.layerIndexes = {}, this.crossTileIDs = new $785da19a645c07eb$var$fP, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
    }
    addLayer(e1, t, i) {
        let n = this.layerIndexes[e1.id];
        void 0 === n && (n = this.layerIndexes[e1.id] = new $785da19a645c07eb$var$AP);
        let a = !1, r = {};
        n.handleWrapJump(i);
        for (let i of t){
            let t = i.getBucket(e1);
            e1.id === t?.layerIds[0] && (t.bucketInstanceId ||= (this.maxBucketInstanceId += 1, this.maxBucketInstanceId), n.addBucket(i.tileID, t, this.crossTileIDs) && (a = !0), r[t.bucketInstanceId] = !0);
        }
        return n.removeStaleBuckets(r) && (a = !0), a;
    }
    pruneUnusedLayers(e1) {
        let t = {};
        for (let i of e1)t[i] = !0;
        for(let e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
    }
}, $785da19a645c07eb$var$vP = "void main() {fragColor=vec4(1.0);}";
const $785da19a645c07eb$var$yP = {
    prelude: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;layout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const uint packedOpacity) {return vec2(float(packedOpacity >> 1u)/127.0,float(packedOpacity & 1u));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform highp sampler2D u_depth;layout(std140) uniform TerrainUBO {highp mat4 u_terrain_matrix;highp vec4 u_terrain_unpack;highp float u_terrain_dim;highp float u_terrain_exaggeration;};\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(ivec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texelFetch(u_terrain,pos,0)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+2.0;vec2 f=fract(coord);ivec2 c=ivec2(floor(coord));ivec2 hi=textureSize(u_terrain,0)-1;float tl=ele(clamp(c,ivec2(0),hi));float tr=ele(clamp(c+ivec2(1,0),ivec2(0),hi));float bl=ele(clamp(c+ivec2(0,1),ivec2(0),hi));float br=ele(clamp(c+ivec2(1,1),ivec2(0),hi));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;\n#define PROJECTION_UBO\nlayout(std140) uniform ProjectionUBO {highp mat4 u_projection_matrix;highp mat4 u_projection_fallback_matrix;highp vec4 u_projection_tile_mercator_coords;highp vec4 u_projection_clipping_plane;highp float u_projection_transition;highp int u_projection_clip_antimeridian;};layout(std140) uniform FrameUBO {highp vec2 u_units_to_pixels;highp vec2 u_world_size;highp float u_camera_to_center_distance;highp float u_symbol_fade_change;highp float u_aspect_ratio;highp float u_device_pixel_ratio;highp vec2 u_viewport_size;highp vec2 u_pixel_extrude_scale;highp float u_pitch;};"),
    projectionMercator: $785da19a645c07eb$var$xP("\nvoid clipAntimeridian() {}", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
    projectionGlobe: $785da19a645c07eb$var$xP("in highp float v_projection_tile_x;void clipAntimeridian() {if (u_projection_clip_antimeridian !=0 && (v_projection_tile_x < 0.0 || v_projection_tile_x >=8192.0)) {discard;}}", "#define GLOBE_RADIUS 6371008.8\n#ifndef PROJECTION_UBO\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;\n#endif\nout highp float v_projection_tile_x;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float t=exp(PI-(mercator_pos_y*PI*2.0));return (2.0*t)/(t*t+1.0);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY);if (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;float spherical_x=mercator_pos.x*PI*2.0+PI;float t=exp(PI-(mercator_pos.y*PI*2.0));float t2=t*t;float denom=t2+1.0;float sin_sy=(t2-1.0)/denom;float cos_sy=(2.0*t)/denom;vec3 pos=vec3(sin(spherical_x)*cos_sy,sin_sy,cos(spherical_x)*cos_sy\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {v_projection_tile_x=posInTile.x;vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
    background: $785da19a645c07eb$var$xP("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
    backgroundPattern: $785da19a645c07eb$var$xP("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
    circle: $785da19a645c07eb$var$xP("in vec3 v_data;flat in float v_visibility;\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define mediump float radius\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 stroke_color\n#pragma maplibre: define mediump float stroke_width\n#pragma maplibre: define lowp float stroke_opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump float radius\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 stroke_color\n#pragma maplibre: initialize mediump float stroke_width\n#pragma maplibre: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform vec2 u_translate;layout(location=0) in ivec2 a_pos;out vec3 v_data;flat out float v_visibility;\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define mediump float radius\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 stroke_color\n#pragma maplibre: define mediump float stroke_width\n#pragma maplibre: define lowp float stroke_opacity\nvoid main(void) {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump float radius\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 stroke_color\n#pragma maplibre: initialize mediump float stroke_width\n#pragma maplibre: initialize lowp float stroke_opacity\nivec2 pos_raw=a_pos+32768;vec2 extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;vec2 circle_center=vec2(pos_raw >> 3)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
    clippingMask: $785da19a645c07eb$var$xP($785da19a645c07eb$var$vP, "layout(location=0) in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
    heatmap: $785da19a645c07eb$var$xP("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma maplibre: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma maplibre: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;layout(location=0) in ivec2 a_pos;out vec2 v_extrude;\n#pragma maplibre: define highp float weight\n#pragma maplibre: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma maplibre: initialize highp float weight\n#pragma maplibre: initialize mediump float radius\nivec2 pos_raw=a_pos+32768;vec2 unscaled_extrude=vec2(pos_raw & 7)/7.0*2.0-1.0;float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=vec2(pos_raw >> 3);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
    heatmapTexture: $785da19a645c07eb$var$xP("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world_size,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
    collisionBox: $785da19a645c07eb$var$xP("flat in float v_placed;flat in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "layout(location=0) in vec2 a_anchor_pos;layout(location=1) in vec2 a_placed;layout(location=2) in vec2 a_box_real;flat out float v_placed;flat out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
    collisionCircle: $785da19a645c07eb$var$xP("flat in float v_radius;in vec2 v_extrude;flat in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "layout(location=0) in vec2 a_pos;layout(location=1) in float a_radius;layout(location=2) in vec2 a_flags;flat out float v_radius;out vec2 v_extrude;flat out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
    colorRelief: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {vec4 data=texelFetch(u_elevation_stops,ivec2(stop,0),0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=2.0/u_dimension;float scale=(u_dimension.x-4.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
    debug: $785da19a645c07eb$var$xP("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "layout(location=0) in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
    depth: $785da19a645c07eb$var$xP($785da19a645c07eb$var$vP, "layout(location=0) in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
    fill: $785da19a645c07eb$var$xP("#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float opacity\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
    fillOutline: $785da19a645c07eb$var$xP("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define highp vec4 outline_color\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 outline_color\n#pragma maplibre: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define highp vec4 outline_color\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 outline_color\n#pragma maplibre: initialize lowp float opacity\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
    fillOutlinePattern: $785da19a645c07eb$var$xP("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;uniform bool u_sdf_pattern;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\nvoid main() {\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*alpha*opacity;} else {fragColor=mix(color1,color2,u_fade)*alpha*opacity;}\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\nvoid main() {\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world_size;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
    fillPattern: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform bool u_sdf_pattern;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\nvoid main() {\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);if (u_sdf_pattern) {highp float sdf_edge=(256.0-64.0)/256.0;highp float sdf_gamma_a=max(fwidth(color1.a)*0.5,1.0/255.0/16.0);highp float sdf_gamma_b=max(fwidth(color2.a)*0.5,1.0/255.0/16.0);float sdf_alpha_a=smoothstep(sdf_edge-sdf_gamma_a,sdf_edge+sdf_gamma_a,color1.a);float sdf_alpha_b=smoothstep(sdf_edge-sdf_gamma_b,sdf_edge+sdf_gamma_b,color2.a);fragColor=mix(color*sdf_alpha_a,color*sdf_alpha_b,u_fade)*opacity;} else {fragColor=mix(color1,color2,u_fade)*opacity;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\nvoid main() {\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
    fillExtrusion: $785da19a645c07eb$var$xP("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;\n#ifdef TERRAIN3D\nlayout(location=2) in vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma maplibre: define highp float base\n#pragma maplibre: define highp float height\n#pragma maplibre: define highp vec4 color\nvoid main() {\n#pragma maplibre: initialize highp float base\n#pragma maplibre: initialize highp float height\n#pragma maplibre: initialize highp vec4 color\nvec3 normal=vec3(a_normal_ed.xyz);\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
    fillExtrusionPattern: $785da19a645c07eb$var$xP("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma maplibre: define lowp float base\n#pragma maplibre: define lowp float height\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\nvoid main() {\n#pragma maplibre: initialize lowp float base\n#pragma maplibre: initialize lowp float height\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;layout(location=0) in vec2 a_pos;layout(location=1) in ivec4 a_normal_ed;\n#ifdef TERRAIN3D\nlayout(location=2) in vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma maplibre: define lowp float base\n#pragma maplibre: define lowp float height\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\nvoid main() {\n#pragma maplibre: initialize lowp float base\n#pragma maplibre: initialize lowp float height\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=vec3(a_normal_ed.xyz);float edgedistance=float(a_normal_ed.w);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=float(a_normal_ed.x & 1);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=a_normal_ed.x==1 && a_normal_ed.y==0 && a_normal_ed.z==16384\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
    hillshadePrepare: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(ivec2 texel) {vec4 data=texelFetch(u_image,texel,0)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {ivec2 pos=ivec2(gl_FragCoord.xy)+ivec2(1);float tileSize=u_dimension.x-4.0;float a=getElevation(pos+ivec2(-1,-1));float b=getElevation(pos+ivec2(0,-1));float c=getElevation(pos+ivec2(1,-1));float d=getElevation(pos+ivec2(-1,0));float e=getElevation(pos);float f=getElevation(pos+ivec2(1,0));float g=getElevation(pos+ivec2(-1,1));float h=getElevation(pos+ivec2(0,1));float i=getElevation(pos+ivec2(1,1));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;layout(location=0) in vec2 a_pos;layout(location=1) in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
    hillshade: $785da19a645c07eb$var$xP("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec2 size=vec2(textureSize(u_image,0));vec2 texturePos=(v_pos*(size-2.0)+1.0)/size;vec4 pixel=texture(u_image,texturePos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
    line: $785da19a645c07eb$var$xP("flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\nclipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nlayout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float gapwidth\n#pragma maplibre: define lowp float offset\n#pragma maplibre: define mediump float width\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float gapwidth\n#pragma maplibre: initialize lowp float offset\n#pragma maplibre: initialize mediump float width\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);v_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*2.0;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
    lineGradient: $785da19a645c07eb$var$xP("uniform sampler2D u_image;flat in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\nclipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nlayout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float gapwidth\n#pragma maplibre: define lowp float offset\n#pragma maplibre: define mediump float width\nvoid main() {\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float gapwidth\n#pragma maplibre: initialize lowp float offset\n#pragma maplibre: initialize mediump float width\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
    linePattern: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;flat in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;flat in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\nclipAntimeridian();vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nlayout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;out vec2 v_normal;flat out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;flat out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define lowp float offset\n#pragma maplibre: define mediump float gapwidth\n#pragma maplibre: define mediump float width\n#pragma maplibre: define lowp float floorwidth\n#pragma maplibre: define lowp vec4 pattern_from\n#pragma maplibre: define lowp vec4 pattern_to\n#pragma maplibre: define lowp float pixel_ratio_from\n#pragma maplibre: define lowp float pixel_ratio_to\nvoid main() {\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize lowp float offset\n#pragma maplibre: initialize mediump float gapwidth\n#pragma maplibre: initialize mediump float width\n#pragma maplibre: initialize lowp float floorwidth\n#pragma maplibre: initialize mediump vec4 pattern_from\n#pragma maplibre: initialize mediump vec4 pattern_to\n#pragma maplibre: initialize lowp float pixel_ratio_from\n#pragma maplibre: initialize lowp float pixel_ratio_to\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
    lineSDF: $785da19a645c07eb$var$xP("uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float width\n#pragma maplibre: define lowp float floorwidth\n#pragma maplibre: define mediump vec4 dasharray_from\n#pragma maplibre: define mediump vec4 dasharray_to\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float width\n#pragma maplibre: initialize lowp float floorwidth\n#pragma maplibre: initialize mediump vec4 dasharray_from\n#pragma maplibre: initialize mediump vec4 dasharray_to\nclipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nlayout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define highp vec4 color\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float gapwidth\n#pragma maplibre: define lowp float offset\n#pragma maplibre: define mediump float width\n#pragma maplibre: define lowp float floorwidth\n#pragma maplibre: define mediump vec4 dasharray_from\n#pragma maplibre: define mediump vec4 dasharray_to\nvoid main() {\n#pragma maplibre: initialize highp vec4 color\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float gapwidth\n#pragma maplibre: initialize lowp float offset\n#pragma maplibre: initialize mediump float width\n#pragma maplibre: initialize lowp float floorwidth\n#pragma maplibre: initialize mediump vec4 dasharray_from\n#pragma maplibre: initialize mediump vec4 dasharray_to\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
    lineGradientSDF: $785da19a645c07eb$var$xP("uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;flat in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float width\n#pragma maplibre: define lowp float floorwidth\n#pragma maplibre: define mediump vec4 dasharray_from\n#pragma maplibre: define mediump vec4 dasharray_to\nvoid main() {\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float width\n#pragma maplibre: initialize lowp float floorwidth\n#pragma maplibre: initialize mediump vec4 dasharray_from\n#pragma maplibre: initialize mediump vec4 dasharray_to\nclipAntimeridian();float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nlayout(location=0) in ivec2 a_pos_normal;layout(location=1) in uvec4 a_data;layout(location=2) in float a_uv_x;layout(location=3) in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;flat out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma maplibre: define lowp float blur\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define mediump float gapwidth\n#pragma maplibre: define lowp float offset\n#pragma maplibre: define mediump float width\n#pragma maplibre: define lowp float floorwidth\n#pragma maplibre: define mediump vec4 dasharray_from\n#pragma maplibre: define mediump vec4 dasharray_to\nvoid main() {\n#pragma maplibre: initialize lowp float blur\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize mediump float gapwidth\n#pragma maplibre: initialize lowp float offset\n#pragma maplibre: initialize mediump float width\n#pragma maplibre: initialize lowp float floorwidth\n#pragma maplibre: initialize mediump vec4 dasharray_from\n#pragma maplibre: initialize mediump vec4 dasharray_to\nif (opacity < 0.01) {gl_Position=vec4(-2.0,-2.0,-2.0,1.0);return;}float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(ivec2(a_data.xy)-128);float a_direction=float(int(a_data.z & 3u)-1);float a_linesofar=float((a_data.z >> 2u)+a_data.w*64u)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=vec2(a_pos_normal >> 1);mediump vec2 normal=vec2(a_pos_normal & 1);normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
    layerOpacity: $785da19a645c07eb$var$xP("uniform sampler2D u_image;uniform float u_opacity;in vec2 v_pos;void main() {fragColor=texture(u_image,v_pos)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "layout(location=0) in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos.x*2.0-1.0,1.0-a_pos.y*2.0,0.0,1.0);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
    raster: $785da19a645c07eb$var$xP("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec3 v_pos0;in vec3 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0.xy/v_pos0.z);vec4 color1=texture(u_image1,v_pos1.xy/v_pos1.z);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec3 u_image_warp;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;layout(location=0) in vec2 a_pos;out vec3 v_pos0;out vec3 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 topLeft=u_coords_top.xy;vec2 topRight=u_coords_top.zw;vec2 bottomLeft=u_coords_bottom.xy;vec2 bottomRight=u_coords_bottom.zw;vec2 bilinearPos=mix(mix(topLeft,topRight,fractionalPos.x),mix(bottomLeft,bottomRight,fractionalPos.x),fractionalPos.y);float denominator=dot(u_image_warp.xy,fractionalPos)+1.0;vec2 acrossTop=topRight-topLeft+u_image_warp.x*topRight;vec2 downLeft=bottomLeft-topLeft+u_image_warp.y*bottomLeft;vec2 projectivePos=(acrossTop*fractionalPos.x+downLeft*fractionalPos.y+topLeft)/denominator;vec2 position=mix(projectivePos,bilinearPos,u_image_warp.z);gl_Position=projectTile(position,position);vec2 texturePos=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {texturePos.y=0.0;}if (a_pos.y > 32766.5) {texturePos.y=1.0;}\n#endif\nfloat perspectiveRatio=mix(1.0/denominator,1.0,u_image_warp.z);v_pos0=vec3(texturePos*perspectiveRatio,perspectiveRatio);vec2 parentPos=(texturePos*u_scale_parent)+u_tl_parent;v_pos1=vec3(parentPos*perspectiveRatio,perspectiveRatio);}"),
    symbolIcon: $785da19a645c07eb$var$xP("uniform sampler2D u_texture;in vec2 v_tex;flat in float v_total_opacity;void main() {fragColor=texture(u_texture,v_tex)*v_total_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform bool u_rotate_symbol;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_tex;flat out float v_total_opacity;\n#pragma maplibre: define lowp float opacity\nvoid main() {\n#pragma maplibre: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float visibility=calculate_visibility(projectedPoint);v_total_opacity=opacity*max(0.0,min(visibility,fade_opacity[0]+fade_change));if (v_total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;}"),
    symbolSDF: $785da19a645c07eb$var$xP("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform bool u_is_plain;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma maplibre: define highp vec4 fill_color\n#pragma maplibre: define highp vec4 halo_color\n#pragma maplibre: define lowp float halo_width\n#pragma maplibre: define lowp float halo_blur\nvoid main() {\n#pragma maplibre: initialize highp vec4 fill_color\n#pragma maplibre: initialize highp vec4 halo_color\n#pragma maplibre: initialize lowp float halo_width\n#pragma maplibre: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float total_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out_text,color_alpha_out_halo;if (u_is_plain){highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);color_alpha_out_text=total_opacity*alpha*fill_color;}if (u_is_halo) {float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);float inner_edge_halo=inner_edge+gamma_halo*gamma_scale;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(inner_edge_halo-gamma_scaled_halo,inner_edge_halo+gamma_scaled_halo,dist);highp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha_halo= min(smoothstep(halo_edge-gamma_scaled_halo,halo_edge+gamma_scaled_halo,dist),1.0-alpha_halo);color_alpha_out_halo=total_opacity*alpha_halo*halo_color;}if (u_is_plain && u_is_halo) {fragColor=color_alpha_out_text+(1.-color_alpha_out_text.a)*color_alpha_out_halo;} else if (u_is_halo){fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out_text;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec4 a_pixeloffset;layout(location=3) in vec3 a_projected_pos;layout(location=4) in uint a_fade_opacity;layout(location=5) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec2 v_data0;out vec3 v_data1;\n#pragma maplibre: define highp vec4 fill_color\n#pragma maplibre: define highp vec4 halo_color\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define lowp float halo_width\n#pragma maplibre: define lowp float halo_blur\nvoid main() {\n#pragma maplibre: initialize highp vec4 fill_color\n#pragma maplibre: initialize highp vec4 halo_color\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize lowp float halo_width\n#pragma maplibre: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);vec2 a_pxoffset=a_pixeloffset.xy/16.0;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,total_opacity);}"),
    symbolTextAndIcon: $785da19a645c07eb$var$xP("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform bool u_is_text;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;in vec4 v_data0;in vec3 v_data1;flat in float v_is_sdf;\n#pragma maplibre: define highp vec4 fill_color\n#pragma maplibre: define highp vec4 halo_color\n#pragma maplibre: define lowp float halo_width\n#pragma maplibre: define lowp float halo_blur\nvoid main() {\n#pragma maplibre: initialize highp vec4 fill_color\n#pragma maplibre: initialize highp vec4 halo_color\n#pragma maplibre: initialize lowp float halo_width\n#pragma maplibre: initialize lowp float halo_blur\nfloat total_opacity=v_data1[2];if (v_is_sdf==ICON) {vec2 tex_icon=v_data0.zw;fragColor=texture(u_texture_icon,tex_icon)*total_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;lowp float dist=texture(u_texture,tex).a;lowp vec4 color_alpha_out,color_alpha_out_halo;if (u_is_text) {highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);color_alpha_out=fill_color*(alpha*total_opacity);}if (u_is_halo) {highp float gamma_halo=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);lowp float buff_halo=(6.0-halo_width/fontScale)/SDF_PX;highp float gamma_scaled_halo=gamma_halo*gamma_scale;highp float alpha_halo=smoothstep(buff_halo-gamma_scaled_halo,buff_halo+gamma_scaled_halo,dist);color_alpha_out_halo=halo_color*(alpha_halo*total_opacity);}if (u_is_text && u_is_halo) {fragColor=color_alpha_out+(1.-color_alpha_out.a)*color_alpha_out_halo;} else if (u_is_halo) {fragColor=color_alpha_out_halo;} else {fragColor=color_alpha_out;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "layout(location=0) in vec4 a_pos_offset;layout(location=1) in uvec4 a_data;layout(location=2) in vec3 a_projected_pos;layout(location=3) in uint a_fade_opacity;layout(location=4) in float a_height_offset;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;uniform bool u_is_offset;uniform bool u_height_anchor_ground;out vec4 v_data0;out vec3 v_data1;flat out float v_is_sdf;\n#pragma maplibre: define highp vec4 fill_color\n#pragma maplibre: define highp vec4 halo_color\n#pragma maplibre: define lowp float opacity\n#pragma maplibre: define lowp float halo_width\n#pragma maplibre: define lowp float halo_blur\nvoid main() {\n#pragma maplibre: initialize highp vec4 fill_color\n#pragma maplibre: initialize highp vec4 halo_color\n#pragma maplibre: initialize lowp float opacity\n#pragma maplibre: initialize lowp float halo_width\n#pragma maplibre: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=vec2(a_data.xy);vec2 a_size=vec2(a_data.zw);float a_size_min=float(a_data.z >> 1u);float is_sdf=float(a_data.z & 1u);float ele=a_height_offset+(u_height_anchor_ground ? get_elevation(a_pos) : 0.0);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_symbol_fade_change :-u_symbol_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));float total_opacity=opacity*interpolated_fade_opacity;if (total_opacity < 0.1){gl_Position=vec4(-2.,-2.,-2.,1.);return;}highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);if (!u_is_offset) {size*=perspective_ratio;}float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec3(gamma_scale,size,total_opacity);v_is_sdf=is_sdf;}"),
    terrain: $785da19a645c07eb$var$xP("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && u_fog_ground_blend_opacity > 0.0 && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "layout(location=0) in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
    terrainDepth: $785da19a645c07eb$var$xP("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "layout(location=0) in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
    atmosphere: $785da19a645c07eb$var$xP("#ifdef GL_ES\nprecision highp float;\n#endif\nin vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
    sky: $785da19a645c07eb$var$xP("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;uniform vec3 u_globe_position;uniform float u_globe_radius;in vec3 v_view_direction;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (u_sky_blend > 0.0) {vec3 ray=normalize(v_view_direction);float globe_distance=length(u_globe_position);float angle_to_globe_center=acos(clamp(dot(ray,u_globe_position)/globe_distance,-1.0,1.0));float horizon_angle=asin(min(u_globe_radius/globe_distance,1.0));blend=mix(blend,(angle_to_globe_center-horizon_angle)*u_camera_to_center_distance*u_device_pixel_ratio,u_sky_blend);}if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "layout(location=0) in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 v_view_direction;void main() {v_view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,1.0,1.0);}")
};
function $785da19a645c07eb$var$xP(e1, t) {
    let i = /#pragma maplibre: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, n = t.match(/in ([\w]+) ([\w]+)/g), a = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), r = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = r ? r.concat(a) : a, o = n ? n.length : 0, l = {};
    return e1 = e1.replace(i, (e1, t, i, n, a)=>(l[a] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nin ${i} ${n} ${a};\n#else\nuniform ${i} ${n} u_${a};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${a}\n    ${i} ${n} ${a} = u_${a};\n#endif\n`)), t = t.replace(i, (e1, t, i, n, a)=>{
        let r = "float" === n ? "vec2" : "vec4", s = a.match(/color/) ? "color" : r;
        return l[a] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nlayout(location = ${o++}) in ${i} ${r} a_${a};\nout ${i} ${n} ${a};\n#else\nuniform ${i} ${n} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = a_${a};\n#else\n    ${i} ${n} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${n} ${a} = u_${a};\n#endif\n` : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${a}\nuniform lowp float u_${a}_t;\nlayout(location = ${o++}) in ${i} ${r} a_${a};\n#else\nuniform ${i} ${n} u_${a};\n#endif\n` : "vec4" === s ? `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${n} ${a} = a_${a};\n#else\n    ${i} ${n} ${a} = u_${a};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${a}\n    ${i} ${n} ${a} = unpack_mix_${s}(a_${a}, u_${a}_t);\n#else\n    ${i} ${n} ${a} = u_${a};\n#endif\n`;
    }), {
        fragmentSource: e1,
        vertexSource: t,
        staticAttributes: n,
        staticUniforms: s
    };
}
const $785da19a645c07eb$var$bP = "#define PROJECTION_MERCATOR", $785da19a645c07eb$var$wP = "mercator";
var $785da19a645c07eb$var$EP = class {
    constructor(){
        this._cachedMesh = null;
    }
    get name() {
        return "mercator";
    }
    get useSubdivision() {
        return !1;
    }
    get shaderVariantName() {
        return $785da19a645c07eb$var$wP;
    }
    get shaderDefine() {
        return $785da19a645c07eb$var$bP;
    }
    get shaderPreludeCode() {
        return $785da19a645c07eb$var$yP.projectionMercator;
    }
    get vertexShaderPreludeCode() {
        return $785da19a645c07eb$var$yP.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return $785da19a645c07eb$var$$y.noSubdivision;
    }
    get useGlobeControls() {
        return !1;
    }
    get transitionState() {
        return 0;
    }
    destroy() {}
    getMeshFromTileID(e1, t, i, n, a) {
        if (this._cachedMesh) return this._cachedMesh;
        let r = new $785da19a645c07eb$var$l_;
        r.emplaceBack(0, 0), r.emplaceBack($785da19a645c07eb$var$Vu, 0), r.emplaceBack(0, $785da19a645c07eb$var$Vu), r.emplaceBack($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu);
        let s = e1.createVertexBuffer(r, $785da19a645c07eb$var$BT.members), o = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 2), l = new $785da19a645c07eb$var$k_;
        l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3);
        let c = e1.createIndexBuffer(l);
        return this._cachedMesh = new $785da19a645c07eb$var$LT(s, c, o), this._cachedMesh;
    }
    recalculate() {}
    hasTransition() {
        return !1;
    }
}, $785da19a645c07eb$var$kP = class e1 {
    constructor(e1 = 0, t = 0, i = 0, n = 0){
        if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(n) || n < 0) throw Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
        this.top = e1, this.bottom = t, this.left = i, this.right = n;
    }
    interpolate(e1, t, i) {
        return null != t.top && null != e1.top && (this.top = $785da19a645c07eb$var$Mp.number(e1.top, t.top, i)), null != t.bottom && null != e1.bottom && (this.bottom = $785da19a645c07eb$var$Mp.number(e1.bottom, t.bottom, i)), null != t.left && null != e1.left && (this.left = $785da19a645c07eb$var$Mp.number(e1.left, t.left, i)), null != t.right && null != e1.right && (this.right = $785da19a645c07eb$var$Mp.number(e1.right, t.right, i)), this;
    }
    getCenter(e1, t) {
        return new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$ch((this.left + e1 - this.right) / 2, 0, e1), $785da19a645c07eb$var$ch((this.top + t - this.bottom) / 2, 0, t));
    }
    equals(e1) {
        return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
    }
    clone() {
        return new e1(this.top, this.bottom, this.left, this.right);
    }
    toJSON() {
        return {
            top: this.top,
            bottom: this.bottom,
            left: this.left,
            right: this.right
        };
    }
};
function $785da19a645c07eb$var$SP(e1, t) {
    if (!e1.renderWorldCopies || e1.lngRange) return;
    let i = t.lng - e1.center.lng;
    t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
}
function $785da19a645c07eb$var$MP(e1) {
    return Math.max(0, Math.floor(e1));
}
var $785da19a645c07eb$var$CP = class {
    constructor(e1, t){
        this.applyConstrain = (e1, t)=>null === this._constrainOverride ? this._callbacks.defaultConstrain(e1, t) : this._constrainOverride(e1, t), this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = void 0 === t?.renderWorldCopies || !!t?.renderWorldCopies, this._minZoom = t?.minZoom || 0, this._maxZoom = t?.maxZoom || 22, this._minPitch = null == t?.minPitch ? 0 : t?.minPitch, this._maxPitch = null == t?.maxPitch ? 60 : t?.maxPitch, this._constrainOverride = t?.constrainOverride ?? null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new $785da19a645c07eb$var$Mx(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = $785da19a645c07eb$var$MP(this._zoom), this._scale = $785da19a645c07eb$var$gh(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new $785da19a645c07eb$var$kP, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
    }
    apply(e1, t, i) {
        this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = $785da19a645c07eb$var$MP(this._zoom), this._scale = $785da19a645c07eb$var$gh(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new $785da19a645c07eb$var$kP(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !i && e1.autoCalculateNearFarZ, t && this.constrainInternal(), this._calcMatrices();
    }
    get pixelsToClipSpaceMatrix() {
        return this._pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._clipSpaceToPixelsMatrix;
    }
    get minElevationForCurrentTile() {
        return this._minElevationForCurrentTile;
    }
    setMinElevationForCurrentTile(e1) {
        this._minElevationForCurrentTile = e1;
    }
    get tileSize() {
        return this._tileSize;
    }
    get tileZoom() {
        return this._tileZoom;
    }
    get scale() {
        return this._scale;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get bearingInRadians() {
        return this._bearingInRadians;
    }
    get lngRange() {
        return this._lngRange;
    }
    get latRange() {
        return this._latRange;
    }
    get pixelsToGLUnits() {
        return this._pixelsToGLUnits;
    }
    get minZoom() {
        return this._minZoom;
    }
    setMinZoom(e1) {
        if (this._minZoom === e1) return;
        this._minZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get maxZoom() {
        return this._maxZoom;
    }
    setMaxZoom(e1) {
        if (this._maxZoom === e1) return;
        this._maxZoom = e1;
        let t = this._unmodified;
        this.setZoom(this.applyConstrain(this._center, this.zoom).zoom), this._unmodified = t;
    }
    get minPitch() {
        return this._minPitch;
    }
    setMinPitch(e1) {
        if (this._minPitch === e1) return;
        this._minPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.max(this.pitch, e1)), this._unmodified = t;
    }
    get maxPitch() {
        return this._maxPitch;
    }
    setMaxPitch(e1) {
        if (this._maxPitch === e1) return;
        this._maxPitch = e1;
        let t = this._unmodified;
        this.setPitch(Math.min(this.pitch, e1)), this._unmodified = t;
    }
    get renderWorldCopies() {
        return this._renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
    }
    get constrainOverride() {
        return this._constrainOverride;
    }
    setConstrainOverride(e1) {
        void 0 === e1 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
    }
    get worldSize() {
        return this._tileSize * this._scale;
    }
    get centerOffset() {
        return this.centerPoint._sub(this.size._div(2));
    }
    get size() {
        return new $785da19a645c07eb$var$Kc(this._width, this._height);
    }
    get bearing() {
        return this._bearingInRadians / Math.PI * 180;
    }
    setBearing(e1) {
        let t = $785da19a645c07eb$var$uh(e1, -180, 180) * Math.PI / 180;
        this._bearingInRadians !== t && (this._unmodified = !1, this._bearingInRadians = t, this._calcMatrices(), this._rotationMatrix = $785da19a645c07eb$var$JM(), function(e1, t, i) {
            var n = t[0], a = t[1], r = t[2], s = t[3], o = Math.sin(i), l = Math.cos(i);
            e1[0] = n * l + r * o, e1[1] = a * l + s * o, e1[2] = n * -o + r * l, e1[3] = a * -o + s * l;
        }(this._rotationMatrix, this._rotationMatrix, -this._bearingInRadians));
    }
    get rotationMatrix() {
        return this._rotationMatrix;
    }
    get pitchInRadians() {
        return this._pitchInRadians;
    }
    get pitch() {
        return this._pitchInRadians / Math.PI * 180;
    }
    setPitch(e1) {
        let t = $785da19a645c07eb$var$ch(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
        this._pitchInRadians !== t && (this._unmodified = !1, this._pitchInRadians = t, this._calcMatrices());
    }
    get rollInRadians() {
        return this._rollInRadians;
    }
    get roll() {
        return this._rollInRadians / Math.PI * 180;
    }
    setRoll(e1) {
        let t = e1 / 180 * Math.PI;
        this._rollInRadians !== t && (this._unmodified = !1, this._rollInRadians = t, this._calcMatrices());
    }
    get fovInRadians() {
        return this._fovInRadians;
    }
    get fov() {
        return $785da19a645c07eb$var$Ph(this._fovInRadians);
    }
    setFov(e1) {
        e1 = $785da19a645c07eb$var$ch(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = $785da19a645c07eb$var$Dh(e1), this._calcMatrices());
    }
    get zoom() {
        return this._zoom;
    }
    setZoom(e1) {
        let t = this.applyConstrain(this._center, e1).zoom;
        this._zoom !== t && (this._unmodified = !1, this._zoom = t, this._tileZoom = Math.max(0, Math.floor(t)), this._scale = $785da19a645c07eb$var$gh(t), this.constrainInternal(), this._calcMatrices());
    }
    get center() {
        return this._center;
    }
    setCenter(e1) {
        (e1.lat !== this._center.lat || e1.lng !== this._center.lng) && (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
    }
    get elevation() {
        return this._elevation;
    }
    setElevation(e1) {
        e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
    }
    get padding() {
        return this._edgeInsets.toJSON();
    }
    setPadding(e1) {
        this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
    }
    get centerPoint() {
        return this._edgeInsets.getCenter(this._width, this._height);
    }
    get pixelsPerMeter() {
        return this._pixelPerMeter;
    }
    get unmodified() {
        return this._unmodified;
    }
    get cameraToCenterDistance() {
        return this._cameraToCenterDistance;
    }
    get nearZ() {
        return this._nearZ;
    }
    get farZ() {
        return this._farZ;
    }
    get autoCalculateNearFarZ() {
        return this._autoCalculateNearFarZ;
    }
    overrideNearFarZ(e1, t) {
        this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
    }
    clearNearFarZOverride() {
        this._autoCalculateNearFarZ = !0, this._calcMatrices();
    }
    isPaddingEqual(e1) {
        return this._edgeInsets.equals(e1);
    }
    interpolatePadding(e1, t, i) {
        this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this.constrainInternal(), this._calcMatrices();
    }
    resize(e1, t, i = !0) {
        this._width = e1, this._height = t, i && this.constrainInternal(), this._calcMatrices();
    }
    getMaxBounds() {
        return 2 !== this._latRange?.length || 2 !== this._lngRange?.length ? null : new $785da19a645c07eb$var$_T([
            this._lngRange[0],
            this._latRange[0]
        ], [
            this._lngRange[1],
            this._latRange[1]
        ]);
    }
    setMaxBounds(e1) {
        e1 ? (this._lngRange = [
            e1.getWest(),
            e1.getEast()
        ], this._latRange = [
            e1.getSouth(),
            e1.getNorth()
        ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
            -$785da19a645c07eb$var$Rh,
            $785da19a645c07eb$var$Rh
        ]);
    }
    getCameraQueryGeometry(e1, t) {
        if (1 === t.length) return [
            t[0],
            e1
        ];
        {
            let { minX: i, minY: n, maxX: a, maxY: r } = $785da19a645c07eb$var$fx.fromPoints(t).extend(e1);
            return [
                new $785da19a645c07eb$var$Kc(i, n),
                new $785da19a645c07eb$var$Kc(a, n),
                new $785da19a645c07eb$var$Kc(a, r),
                new $785da19a645c07eb$var$Kc(i, r),
                new $785da19a645c07eb$var$Kc(i, n)
            ];
        }
    }
    constrainInternal() {
        if (!this.center || !this._width || !this._height || this._constraining) return;
        this._constraining = !0;
        let e1 = this._unmodified, { center: t, zoom: i } = this.applyConstrain(this.center, this.zoom);
        this.setCenter(t), this.setZoom(i), this._unmodified = e1, this._constraining = !1;
    }
    _calcMatrices() {
        if (this._pixelPerMeter = $785da19a645c07eb$var$Ix(1, this.center.lat) * this.worldSize, !this._width || !this._height) return;
        this._pixelsToGLUnits = [
            2 / this._width,
            -2 / this._height
        ];
        let e1 = $785da19a645c07eb$var$nu(new Float64Array(16));
        $785da19a645c07eb$var$ou(e1, e1, [
            this._width / 2,
            -this._height / 2,
            1
        ]), $785da19a645c07eb$var$su(e1, e1, [
            1,
            -1,
            0
        ]), this._clipSpaceToPixelsMatrix = e1, e1 = $785da19a645c07eb$var$nu(new Float64Array(16)), $785da19a645c07eb$var$ou(e1, e1, [
            1,
            -1,
            1
        ]), $785da19a645c07eb$var$su(e1, e1, [
            -1,
            -1,
            0
        ]), $785da19a645c07eb$var$ou(e1, e1, [
            2 / this._width,
            2 / this._height,
            1
        ]), this._pixelsToClipSpaceMatrix = e1;
        let t = this.fovInRadians / 2;
        this._cameraToCenterDistance = .5 / Math.tan(t) * this._height, this._callbacks.calcMatrices();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, i, n) {
        let a, r, s = void 0 === i ? this.bearing : i, o = n = void 0 === n ? this.pitch : n, { distanceToCenter: l, clampedElevation: c } = this._distanceToCenterFromAltElevationPitch(t, this.elevation, o), { x: u, y: h } = $785da19a645c07eb$var$Gx(o, s), d = $785da19a645c07eb$var$Lx.fromLngLat(e1, t), p = $785da19a645c07eb$var$Rx(1, d.y), m = 0;
        do {
            if (m += 1, m > 10) break;
            r = l / p;
            let e1 = u * r, t = h * r;
            a = new $785da19a645c07eb$var$Lx(d.x + e1, d.y + t), p = 1 / a.meterInMercatorCoordinateUnits();
        }while (Math.abs(l - r * p) > 1e-12);
        return {
            center: a.toLngLat(),
            elevation: c,
            zoom: $785da19a645c07eb$var$fh(this.height / 2 / Math.tan(this.fovInRadians / 2) / r / this.tileSize)
        };
    }
    recalculateZoomAndCenter(e1) {
        if (this.elevation - e1 === 0) return;
        let t = 1 / this.worldSize, i = $785da19a645c07eb$var$Ix(1, this.center.lat) * this.worldSize, n = $785da19a645c07eb$var$Lx.fromLngLat(this.center, this.elevation), a = n.x / t, r = n.y / t, s = n.z / t, o = this.pitch, l = this.bearing, { x: c, y: u, z: h } = $785da19a645c07eb$var$Gx(o, l), d = this.cameraToCenterDistance, p = a + d * -c, m = r + d * -u, g = s + d * h, { distanceToCenter: f, clampedElevation: A } = this._distanceToCenterFromAltElevationPitch(g / i, e1, o), _ = f * i, v = new $785da19a645c07eb$var$Lx((p + c * _) * t, (m + u * _) * t, 0).toLngLat(), y = $785da19a645c07eb$var$Ix(1, v.lat), x = $785da19a645c07eb$var$fh(this.height / 2 / Math.tan(this.fovInRadians / 2) / f / y / this.tileSize);
        this._elevation = A, this._center = v, this.setZoom(x);
    }
    _distanceToCenterFromAltElevationPitch(e1, t, i) {
        let n, a = -Math.cos($785da19a645c07eb$var$Dh(i)), r = e1 - t, s = t;
        return a * r >= 0 || Math.abs(a) < .1 ? (n = 1e4, s = e1 + n * a) : n = -r / a, {
            distanceToCenter: n,
            clampedElevation: s
        };
    }
    getCameraPoint() {
        let e1 = this.pitchInRadians, t = Math.tan(e1) * (this.cameraToCenterDistance || 1);
        return this.centerPoint.add(new $785da19a645c07eb$var$Kc(t * Math.sin(this.rollInRadians), t * Math.cos(this.rollInRadians)));
    }
    getMercatorTileCoordinates(e1) {
        if (!e1) return [
            0,
            0,
            1,
            1
        ];
        let t = e1.canonical.z >= 0 ? 1 << e1.canonical.z : 2 ** e1.canonical.z;
        return [
            e1.canonical.x / t,
            e1.canonical.y / t,
            1 / t / $785da19a645c07eb$var$Vu,
            1 / t / $785da19a645c07eb$var$Vu
        ];
    }
}, $785da19a645c07eb$var$TP = class {
    distanceToTile2d(e1, t, i, n) {
        let a = n, r = a.distanceX([
            e1,
            t
        ]), s = a.distanceY([
            e1,
            t
        ]);
        return Math.hypot(r, s);
    }
    getWrap(e1, t, i) {
        return i;
    }
    getTileBoundingVolume(e1, t, i, n) {
        let a = Math.min(0, i), r = Math.max(0, i);
        if (n?.terrain) {
            let i = new $785da19a645c07eb$var$KE(e1.z, t, e1.z, e1.x, e1.y), s = n.terrain.getMinMaxElevation(i);
            a = s.minElevation ?? a, r = s.maxElevation ?? r;
        }
        let s = 1 << e1.z;
        return new $785da19a645c07eb$var$JT([
            t + e1.x / s,
            e1.y / s,
            a
        ], [
            t + (e1.x + 1) / s,
            (e1.y + 1) / s,
            r
        ]);
    }
    allowVariableZoom(e1, t) {
        let i = $785da19a645c07eb$var$ch(78.5 - e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height / 2, 0, 60);
        return !!t.terrain || e1.pitch > i;
    }
    allowWorldCopies() {
        return !0;
    }
    prepareNextFrame() {}
};
const $785da19a645c07eb$var$DP = $785da19a645c07eb$var$EA([
    {
        name: "a_pos3d",
        type: "Int16",
        components: 3
    }
]);
var $785da19a645c07eb$var$PP = class extends $785da19a645c07eb$var$rd {
    constructor(e1){
        super(), this._lastTilesetChange = $785da19a645c07eb$var$aC(), this.tileManager = e1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = e1._source.tileSize * 2 ** this.deltaZoom, e1.usedForTerrain = !0, e1.tileSize = this.tileSize;
    }
    destruct() {
        this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null, this.releaseAllRTT();
    }
    getSource() {
        return this.tileManager._source;
    }
    update(e1, t) {
        this.tileManager.update(e1, t), this._renderableTilesKeys = [];
        let i = {}, n = !1;
        for (let a of $785da19a645c07eb$var$rD(e1, {
            tileSize: this.tileSize,
            minzoom: this.minzoom,
            maxzoom: this.maxzoom,
            reparseOverscaled: !1,
            terrain: t,
            calculateTileZoom: this.tileManager._source.calculateTileZoom
        }))i[a.key] = !0, this._renderableTilesKeys.push(a.key), this._tiles[a.key] || (a.terrainRttPosMatrix32f = new Float32Array(16), $785da19a645c07eb$var$du(a.terrainRttPosMatrix32f, 0, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, 0, 0, 1), this._tiles[a.key] = new $785da19a645c07eb$var$XT(a, this.tileSize), this._lastTilesetChange = $785da19a645c07eb$var$aC(), n = !0);
        for(let e1 in this._tiles)i[e1] || (this._tiles[e1].releaseRTT(this.tileManager.map.painter), delete this._tiles[e1], n = !0);
        return n;
    }
    releaseRTT(e1) {
        for(let t in this._tiles){
            let i = this._tiles[t];
            (i.tileID.equals(e1) || i.tileID.isChildOf(e1) || e1.isChildOf(i.tileID)) && i.releaseRTT(this.tileManager.map.painter);
        }
    }
    releaseAllRTT() {
        for(let e1 in this._tiles)this._tiles[e1].releaseRTT(this.tileManager.map.painter);
    }
    getRenderableTiles() {
        return this._renderableTilesKeys.map((e1)=>this.getTileByID(e1));
    }
    getTileByID(e1) {
        return this._tiles[e1];
    }
    getTerrainCoords(e1, t) {
        return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
    }
    _getTerrainCoordsForRegularTile(e1) {
        let t = {};
        for (let i of this._renderableTilesKeys){
            let n = this._tiles[i].tileID, a = e1.clone(), r = $785da19a645c07eb$var$Zu();
            if (n.canonical.equals(e1.canonical)) $785da19a645c07eb$var$du(r, 0, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, 0, 0, 1);
            else if (n.canonical.isChildOf(e1.canonical)) {
                let t = n.canonical.z - e1.canonical.z, i = n.canonical.x - (n.canonical.x >> t << t), a = n.canonical.y - (n.canonical.y >> t << t), s = $785da19a645c07eb$var$Vu >> t;
                $785da19a645c07eb$var$du(r, 0, s, s, 0, 0, 1), $785da19a645c07eb$var$su(r, r, [
                    -i * s,
                    -a * s,
                    0
                ]);
            } else {
                if (!e1.canonical.isChildOf(n.canonical)) continue;
                {
                    let t = e1.canonical.z - n.canonical.z, i = e1.canonical.x - (e1.canonical.x >> t << t), a = e1.canonical.y - (e1.canonical.y >> t << t), s = $785da19a645c07eb$var$Vu >> t;
                    $785da19a645c07eb$var$du(r, 0, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, 0, 0, 1), $785da19a645c07eb$var$su(r, r, [
                        i * s,
                        a * s,
                        0
                    ]), $785da19a645c07eb$var$ou(r, r, [
                        1 / 2 ** t,
                        1 / 2 ** t,
                        0
                    ]);
                }
            }
            a.terrainRttPosMatrix32f = new Float32Array(r), t[i] = a;
        }
        return t;
    }
    _getTerrainCoordsForTileRanges(e1, t) {
        let i = {};
        for (let n of this._renderableTilesKeys){
            let a = this._tiles[n].tileID;
            if (!this._isWithinTileRanges(a, t)) continue;
            let r = e1.clone(), s = $785da19a645c07eb$var$Zu();
            if (a.canonical.z === e1.canonical.z) {
                let t = e1.canonical.x - a.canonical.x + e1.wrap * (1 << e1.canonical.z), i = e1.canonical.y - a.canonical.y;
                $785da19a645c07eb$var$du(s, 0, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, 0, 0, 1), $785da19a645c07eb$var$su(s, s, [
                    t * $785da19a645c07eb$var$Vu,
                    i * $785da19a645c07eb$var$Vu,
                    0
                ]);
            } else if (a.canonical.z > e1.canonical.z) {
                let t = a.canonical.z - e1.canonical.z, i = a.canonical.x - (a.canonical.x >> t << t) + e1.wrap * (1 << a.canonical.z), n = a.canonical.y - (a.canonical.y >> t << t), r = e1.canonical.x - (a.canonical.x >> t), o = e1.canonical.y - (a.canonical.y >> t), l = $785da19a645c07eb$var$Vu >> t;
                $785da19a645c07eb$var$du(s, 0, l, l, 0, 0, 1), $785da19a645c07eb$var$su(s, s, [
                    -i * l + r * $785da19a645c07eb$var$Vu,
                    -n * l + o * $785da19a645c07eb$var$Vu,
                    0
                ]);
            } else {
                let t = e1.canonical.z - a.canonical.z, i = e1.canonical.x - (e1.canonical.x >> t << t) + e1.wrap * (1 << e1.canonical.z), n = e1.canonical.y - (e1.canonical.y >> t << t), r = (e1.canonical.x >> t) - a.canonical.x, o = (e1.canonical.y >> t) - a.canonical.y, l = $785da19a645c07eb$var$Vu << t;
                $785da19a645c07eb$var$du(s, 0, l, l, 0, 0, 1), $785da19a645c07eb$var$su(s, s, [
                    i * $785da19a645c07eb$var$Vu + r * l,
                    n * $785da19a645c07eb$var$Vu + o * l,
                    0
                ]);
            }
            r.terrainRttPosMatrix32f = new Float32Array(s), i[n] = r;
        }
        return i;
    }
    getSourceTile(e1, t) {
        let i = this.tileManager._source, n = e1.overscaledZ - this.deltaZoom;
        if (n > i.maxzoom && (n = i.maxzoom), n < i.minzoom) return;
        this._sourceTileCache[e1.key] ||= e1.scaledTo(n).key;
        let a = this.findTileInCaches(this._sourceTileCache[e1.key]);
        if (!a?.dem && t) for(; n >= i.minzoom && !a?.dem;)a = this.findTileInCaches(e1.scaledTo(n--).key);
        return a;
    }
    findTileInCaches(e1) {
        let t = this.tileManager.getTileByID(e1);
        return t || (t = this.tileManager._outOfViewCache.getByKey(e1), t);
    }
    anyTilesAfterTime(e1 = $785da19a645c07eb$var$aC()) {
        return this._lastTilesetChange >= e1;
    }
    _isWithinTileRanges(e1, t) {
        let i = t[e1.canonical.z];
        return !!i && (e1.wrap > i.minWrap || e1.wrap < i.maxWrap || e1.canonical.x >= i.minTileXWrapped && e1.canonical.x <= i.maxTileXWrapped && e1.canonical.y >= i.minTileY && e1.canonical.y <= i.maxTileY);
    }
};
const $785da19a645c07eb$var$IP = $785da19a645c07eb$var$Vu * (1 - 1e-12);
var $785da19a645c07eb$var$FP = class {
    constructor(e1, t, i, n = "auto"){
        this._meshCache = {}, this.painter = e1, this.tileManager = new $785da19a645c07eb$var$PP(t), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this._terrainSkirtLength = n, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = new Map, this._elevationSamplerCache = new Map;
    }
    destroy() {
        this._fbo &&= (this._fbo.destroy(), null), this._fboDepthTexture &&= (this._fboDepthTexture.destroy(), null), this._emptyDemTexture &&= (this._emptyDemTexture.destroy(), null), this._emptyDepthTexture &&= (this._emptyDepthTexture.destroy(), null);
        for(let e1 in this._meshCache)this._meshCache[e1].destroy();
        this._meshCache = {}, this.tileManager.destruct();
    }
    getDEMElevation(e1, t, i, n = $785da19a645c07eb$var$Vu) {
        let a = e1.normalizeCoordinates(t, i, n);
        if (!a) return 0;
        let r = this.getElevationSampler(a.tileID);
        return r ? r(a.x, a.y, n) : 0;
    }
    getElevationForLngLatZoom(e1, t) {
        if (!$785da19a645c07eb$var$HE(t, e1.wrap())) return 0;
        let { tileID: i, mercatorX: n, mercatorY: a } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getElevation(i, n % $785da19a645c07eb$var$Vu, a % $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu);
    }
    getElevationForLngLat(e1, t) {
        let i = this.getCoverageIndex();
        if (i) {
            let t = $785da19a645c07eb$var$Lx.fromLngLat(e1), n = $785da19a645c07eb$var$RP(i, this.exaggeration, t.x, t.y);
            if (n.demLoaded) return n.elevation;
        }
        let n = $785da19a645c07eb$var$rD(t, {
            maxzoom: this.tileManager.maxzoom,
            minzoom: this.tileManager.minzoom,
            tileSize: 512,
            terrain: this
        }), a = 0;
        for (let e1 of n)e1.canonical.z > a && (a = Math.min(e1.canonical.z, this.tileManager.maxzoom));
        return this.getElevationForLngLatZoom(e1, a);
    }
    getElevation(e1, t, i, n = $785da19a645c07eb$var$Vu) {
        return this.getDEMElevation(e1, t, i, n) * this.exaggeration;
    }
    resetElevationCache() {
        this._elevationSamplerCache.clear(), this._coverageIndex = void 0;
    }
    getCoverageIndex() {
        return void 0 === this._coverageIndex && (this._coverageIndex = this._buildCoverageIndex()), this._coverageIndex;
    }
    _buildCoverageIndex() {
        let e1 = [], t = new Map, i = 0, n = 0;
        for (let a of this.tileManager.getRenderableTiles()){
            if (!a) continue;
            let { canonical: r, wrap: s } = a.tileID;
            e1.includes(r.z) || e1.push(r.z);
            let o = this.getElevationSampler(a.tileID);
            t.set(`${s}/${r.z}/${r.x}/${r.y}`, o);
            let { minElevation: l, maxElevation: c } = this.getMinMaxElevation(a.tileID);
            i = Math.min(i, l ?? 0), n = Math.max(n, c ?? 0);
        }
        return 0 === t.size ? null : (e1.sort((e1, t)=>t - e1), {
            zooms: e1,
            samplerPerTile: t,
            minElevation: i - 10,
            maxElevation: n + 10
        });
    }
    getElevationSampler(e1) {
        let t = e1.key, i = this._elevationSamplerCache.get(t);
        if (i) return i;
        let n = this.tileManager.getSourceTile(e1, !0), a = n?.dem;
        if (!n || !a) return null;
        let r = this._getDEMTileMatrix(e1, n), s = r[0] * a.dim, o = r[5] * a.dim, l = r[12] * a.dim, c = r[13] * a.dim, u = (e1, t, i)=>{
            let n = 8192 === i ? 1 : $785da19a645c07eb$var$Vu / i;
            return a.sampleBilinear(e1 * n * s + l, t * n * o + c);
        };
        return this._elevationSamplerCache.set(t, u), u;
    }
    _getDEMTileMatrix(e1, t) {
        let i = `${t.tileID.key}/${e1.key}`, n = this._demMatrixCache.get(i);
        if (n) return n;
        let a = this.tileManager.getSource().maxzoom, r = e1.canonical.z - t.tileID.canonical.z;
        e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= a ? r = e1.canonical.z - a : $785da19a645c07eb$var$wh("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
        let s = e1.canonical.x - (e1.canonical.x >> r << r), o = e1.canonical.y - (e1.canonical.y >> r << r), l = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }(new Float64Array(16), [
            1 / ($785da19a645c07eb$var$Vu << r),
            1 / ($785da19a645c07eb$var$Vu << r),
            0
        ]);
        return $785da19a645c07eb$var$su(l, l, [
            s * $785da19a645c07eb$var$Vu,
            o * $785da19a645c07eb$var$Vu,
            0
        ]), this._demMatrixCache.set(i, l), l;
    }
    getTerrainData(e1) {
        if (!this._emptyDemTexture) {
            let e1 = this.painter.context, t = new $785da19a645c07eb$var$Kv({
                width: 1,
                height: 1
            }, new Uint8Array(4));
            this._emptyDepthTexture = new $785da19a645c07eb$var$ry(e1, t, e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemUnpack = [
                0,
                0,
                0,
                0
            ], this._emptyDemTexture = new $785da19a645c07eb$var$ry(e1, new $785da19a645c07eb$var$Kv({
                width: 1,
                height: 1
            }), e1.gl.RGBA, {
                premultiply: !1
            }), this._emptyDemTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = $785da19a645c07eb$var$nu([]);
        }
        let t = this.tileManager.getSourceTile(e1, !0);
        if (t?.dem && (!t.demTexture || t.needsTerrainPrepare)) {
            let e1 = this.painter.context;
            t.demTexture ||= this.painter.getTileTexture(t.dem.stride), t.demTexture ? t.demTexture.update(t.dem.getPixels(), {
                premultiply: !1
            }) : t.demTexture = new $785da19a645c07eb$var$ry(e1, t.dem.getPixels(), e1.gl.RGBA, {
                premultiply: !1
            }), t.demTexture.bind(e1.gl.NEAREST, e1.gl.CLAMP_TO_EDGE), t.needsTerrainPrepare = !1;
        }
        let i = t ? this._getDEMTileMatrix(e1, t) : this._emptyDemMatrix;
        return {
            u_depth: 2,
            u_terrain: 3,
            u_terrain_dim: t?.dem?.dim || 1,
            u_terrain_matrix: i,
            u_terrain_unpack: t?.dem?.getUnpackVector() || this._emptyDemUnpack,
            u_terrain_exaggeration: this.exaggeration,
            texture: (t?.demTexture || this._emptyDemTexture).texture,
            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
            tile: t
        };
    }
    getFramebuffer() {
        let e1 = this.painter, t = e1.width / devicePixelRatio, i = e1.height / devicePixelRatio;
        return this._fbo && (this._fbo.width !== t || this._fbo.height !== i) && (this._fbo.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture), this._fboDepthTexture || (this._fboDepthTexture = new $785da19a645c07eb$var$ry(e1.context, {
            width: t,
            height: i,
            data: null
        }, e1.context.gl.RGBA, {
            premultiply: !1
        }), this._fboDepthTexture.bind(e1.context.gl.NEAREST, e1.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = e1.context.createFramebuffer(t, i, !0, !1), this._fbo.depthAttachment.set(e1.context.createRenderbuffer(e1.context.gl.DEPTH_COMPONENT16, t, i))), this._fbo.colorAttachment.set(this._fboDepthTexture.texture), this._fbo;
    }
    depthAtPoint(e1) {
        let t = new Uint8Array(4), i = this.painter.context, n = i.gl;
        return i.bindFramebuffer.set(this.getFramebuffer().framebuffer), n.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, n.RGBA, n.UNSIGNED_BYTE, t), i.bindFramebuffer.set(null), (t[0] / 16777216 + t[1] / 65536 + t[2] / 256 + t[3]) / 256;
    }
    getTerrainMesh(e1) {
        let t = this.painter.style.projection?.transitionState > 0, i = t && 0 === e1.canonical.y, n = t && e1.canonical.y === (1 << e1.canonical.z) - 1, a = `m_${i ? "n" : ""}_${n ? "s" : ""}`;
        if (this._meshCache[a]) return this._meshCache[a];
        let r = this.painter.context, s = new $785da19a645c07eb$var$c_, o = new $785da19a645c07eb$var$k_, l = this.meshSize, c = $785da19a645c07eb$var$Vu / l, u = l * l;
        for(let e1 = 0; e1 <= l; e1++)for(let t = 0; t <= l; t++)s.emplaceBack(t * c, e1 * c, 0);
        for(let e1 = 0; e1 < u; e1 += l + 1)for(let t = 0; t < l; t++)o.emplaceBack(t + e1, l + t + e1 + 1, l + t + e1 + 2), o.emplaceBack(t + e1, l + t + e1 + 2, t + e1 + 1);
        "none" !== this._terrainSkirtLength && this._buildSkirts(s, o, l, c, i, n);
        let h = new $785da19a645c07eb$var$LT(r.createVertexBuffer(s, $785da19a645c07eb$var$DP.members), r.createIndexBuffer(o), $785da19a645c07eb$var$T_.simpleSegment(0, 0, s.length, o.length));
        return this._meshCache[a] = h, h;
    }
    getSkirtLength(e1) {
        return 2 * Math.PI * $785da19a645c07eb$var$Sx / 2 ** Math.max(e1, 0) / 5;
    }
    getMinTileElevationForLngLatZoom(e1, t) {
        if (!$785da19a645c07eb$var$HE(t, e1.wrap())) return 0;
        let { tileID: i } = this._getOverscaledTileIDFromLngLatZoom(e1, t);
        return this.getMinMaxElevation(i).minElevation ?? 0;
    }
    getMinMaxElevation(e1) {
        let t = this.tileManager.getSourceTile(e1, !0), i = {
            minElevation: null,
            maxElevation: null
        };
        return t?.dem && (i.minElevation = t.dem.min * this.exaggeration, i.maxElevation = t.dem.max * this.exaggeration), i;
    }
    _getOverscaledTileIDFromLngLatZoom(e1, t) {
        let i = $785da19a645c07eb$var$Lx.fromLngLat(e1.wrap()), n = (1 << t) * $785da19a645c07eb$var$Vu, a = i.x * n, r = i.y * n, s = Math.floor(a / $785da19a645c07eb$var$Vu), o = Math.floor(r / $785da19a645c07eb$var$Vu);
        return {
            tileID: new $785da19a645c07eb$var$KE(t, 0, t, s, o),
            mercatorX: a,
            mercatorY: r
        };
    }
    _buildSkirts(e1, t, i, n, a, r) {
        let s = e1.length, o = s + (i + 1), l = (i + 1) * i, c = a ? $785da19a645c07eb$var$ex : 0, u = +!a, h = r ? $785da19a645c07eb$var$tx : $785da19a645c07eb$var$Vu, d = +!r;
        for(let t = 0; t <= i; t++)e1.emplaceBack(t * n, c, u);
        for(let t = 0; t <= i; t++)e1.emplaceBack(t * n, h, d);
        for(let e1 = 0; e1 < i; e1++)t.emplaceBack(l + e1, o + e1, o + e1 + 1), t.emplaceBack(l + e1, o + e1 + 1, l + e1 + 1), t.emplaceBack(0 + e1, s + e1 + 1, s + e1), t.emplaceBack(0 + e1, 0 + e1 + 1, s + e1 + 1);
        let p = e1.length, m = p + 2 * (i + 1);
        for (let t of [
            0,
            1
        ])for(let a = 0; a <= i; a++)for (let i of [
            0,
            1
        ])e1.emplaceBack(t * $785da19a645c07eb$var$Vu, a * n, i);
        for(let e1 = 0; e1 < 2 * i; e1 += 2)t.emplaceBack(p + e1, p + e1 + 1, p + e1 + 3), t.emplaceBack(p + e1, p + e1 + 3, p + e1 + 2), t.emplaceBack(m + e1, m + e1 + 3, m + e1 + 1), t.emplaceBack(m + e1, m + e1 + 2, m + e1 + 3);
    }
};
const $785da19a645c07eb$var$zP = {
    covered: !1,
    demLoaded: !1,
    elevation: 0
};
function $785da19a645c07eb$var$RP(e1, t, i, n) {
    if (n < 0 || n >= 1) return $785da19a645c07eb$var$zP;
    let a = Math.floor(i), r = i - a;
    for (let i of e1.zooms){
        let s = 1 << i, o = r * s, l = n * s, c = Math.floor(o), u = Math.floor(l), h = `${a}/${i}/${c}/${u}`;
        if (!e1.samplerPerTile.has(h)) continue;
        let d = e1.samplerPerTile.get(h);
        return d ? {
            covered: !0,
            demLoaded: !0,
            elevation: d(Math.min((o - c) * $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$IP), Math.min((l - u) * $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$IP), $785da19a645c07eb$var$Vu) * t
        } : {
            covered: !0,
            demLoaded: !1,
            elevation: 0
        };
    }
    return $785da19a645c07eb$var$zP;
}
function $785da19a645c07eb$var$LP(e1, t) {
    return e1.covered && t <= e1.elevation + 1e-6;
}
function $785da19a645c07eb$var$BP(e1, t, i, n, a) {
    for(let r = 0; r < 40 && n - i > a; r++){
        let a = (i + n) / 2;
        t(e1, a) ? n = a : i = a;
    }
    return {
        lo: i,
        hi: n
    };
}
var $785da19a645c07eb$var$OP = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, i) {
        this._helper.interpolatePadding(e1, t, i);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, i = !0) {
        this._helper.resize(e1, t, i);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(e1){
        this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (e1, t)=>{
            t = $785da19a645c07eb$var$ch(+t, this.minZoom, this.maxZoom);
            let i = {
                center: new $785da19a645c07eb$var$Mx(e1.lng, e1.lat),
                zoom: t
            }, n = this._helper._lngRange;
            !this._helper._renderWorldCopies && null === n && (n = [
                -179.9999999999,
                180 - 1e-10
            ]);
            let a = this.tileSize * $785da19a645c07eb$var$gh(i.zoom), r = 0, s = a, o = 0, l = a, c = 0, u = 0, { x: h, y: d } = this.size;
            if (this._helper._latRange) {
                let e1 = this._helper._latRange;
                r = $785da19a645c07eb$var$Px(e1[1]) * a, s = $785da19a645c07eb$var$Px(e1[0]) * a, s - r < d && (c = d / (s - r));
            }
            n && (o = $785da19a645c07eb$var$uh($785da19a645c07eb$var$Dx(n[0]) * a, 0, a), l = $785da19a645c07eb$var$uh($785da19a645c07eb$var$Dx(n[1]) * a, 0, a), l < o && (l += a), l - o < h && (u = h / (l - o)));
            let p, m, { x: g, y: f } = $785da19a645c07eb$var$Ux(a, e1), A = Math.max(u || 0, c || 0);
            if (A) {
                let e1 = new $785da19a645c07eb$var$Kc(u ? (l + o) / 2 : g, c ? (s + r) / 2 : f);
                return i.center = $785da19a645c07eb$var$Nx(a, e1).wrap(), i.zoom += $785da19a645c07eb$var$fh(A), i;
            }
            if (this._helper._latRange) {
                let e1 = d / 2;
                f - e1 < r && (m = r + e1), f + e1 > s && (m = s - e1);
            }
            if (n) {
                let e1 = (o + l) / 2, t = g;
                this._helper._renderWorldCopies && (t = $785da19a645c07eb$var$uh(g, e1 - a / 2, e1 + a / 2));
                let i = h / 2;
                t - i < o && (p = o + i), t + i > l && (p = l - i);
            }
            if (void 0 !== p || void 0 !== m) {
                let e1 = new $785da19a645c07eb$var$Kc(p ?? g, m ?? f);
                i.center = $785da19a645c07eb$var$Nx(a, e1).wrap();
            }
            return i;
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $785da19a645c07eb$var$CP({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $785da19a645c07eb$var$TP;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t, i) {
        this._helper.apply(e1, t, i);
    }
    get cameraPosition() {
        return this._cameraPosition;
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._viewProjMatrix;
    }
    get inverseProjectionMatrix() {
        return this._invProjMatrix;
    }
    get mercatorMatrix() {
        return this._mercatorMatrix;
    }
    getVisibleUnwrappedCoordinates(e1) {
        let t = [
            new $785da19a645c07eb$var$ZE(0, e1)
        ];
        if (this._helper._renderWorldCopies) {
            let i = this.screenPointToMercatorCoordinate(new $785da19a645c07eb$var$Kc(0, 0)), n = this.screenPointToMercatorCoordinate(new $785da19a645c07eb$var$Kc(this._helper._width, 0)), a = this.screenPointToMercatorCoordinate(new $785da19a645c07eb$var$Kc(this._helper._width, this._helper._height)), r = this.screenPointToMercatorCoordinate(new $785da19a645c07eb$var$Kc(0, this._helper._height)), s = Math.floor(Math.min(i.x, n.x, a.x, r.x)), o = Math.floor(Math.max(i.x, n.x, a.x, r.x));
            for(let i = s - 1; i <= o + 1; i++)0 !== i && t.push(new $785da19a645c07eb$var$ZE(i, e1));
        }
        return t;
    }
    getCameraFrustum() {
        return $785da19a645c07eb$var$$T.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
    }
    getClippingPlane() {
        return null;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        let t = this.screenPointToLocation(this.centerPoint, e1), i = e1 ? e1.getElevationForLngLat(t, this) : 0;
        this._helper.recalculateZoomAndCenter(i);
    }
    setLocationAtPoint(e1, t, i = this.elevation) {
        let n = i - this.elevation, a = this.screenPointToMercatorCoordinateAtZ(t, n), r = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, 0), s = $785da19a645c07eb$var$Lx.fromLngLat(e1), o = new $785da19a645c07eb$var$Lx(s.x - (a.x - r.x), s.y - (a.y - r.y));
        this.setCenter(o?.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
    }
    locationToScreenPoint(e1, t) {
        return t ? this.coordinatePoint($785da19a645c07eb$var$Lx.fromLngLat(e1), t.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint($785da19a645c07eb$var$Lx.fromLngLat(e1));
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToMercatorCoordinateAtZ(e1, t - this.elevation)?.toLngLat();
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let i = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (null != i) return i;
        }
        return this.screenPointToMercatorCoordinateAtZ(e1);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let i = t.getCoverageIndex();
        if (!i) return null;
        let { near: n, far: a } = this.getRaySegmentFromPixel(e1), r = this.worldSize, s = a[0] - n[0], o = a[1] - n[1], l = a[2] - n[2], c = {
            index: i,
            exaggeration: t.exaggeration,
            near: n,
            dx: s,
            dy: o,
            dz: l,
            worldSize: r
        }, u = 0, h = 1;
        if (0 === l) {
            if (n[2] > i.maxElevation || n[2] < i.minElevation) return null;
        } else {
            let e1 = (i.maxElevation - n[2]) / l, t = (i.minElevation - n[2]) / l;
            if (u = Math.max(u, Math.min(e1, t)), h = Math.min(h, Math.max(e1, t)), u > h) return null;
        }
        let d = Math.hypot(s, o), p = $785da19a645c07eb$var$ch(Math.ceil(d * (h - u) / 4), 1, 512), m = 0, g = !$785da19a645c07eb$var$NP(c, 0);
        for(let e1 = 0; e1 <= p; e1++){
            let t = u + (h - u) * e1 / p;
            if (g) {
                if ($785da19a645c07eb$var$NP(c, t)) {
                    let { lo: e1, hi: i } = $785da19a645c07eb$var$BP(c, $785da19a645c07eb$var$NP, m, t, .001 / d), a = $785da19a645c07eb$var$UP(c, e1), u = $785da19a645c07eb$var$UP(c, i), h = n[2] + e1 * l - a.elevation, p = n[2] + i * l - u.elevation, g = a.covered && h > p ? $785da19a645c07eb$var$ch(e1 + h * (i - e1) / (h - p), e1, i) : i;
                    return new $785da19a645c07eb$var$Lx((n[0] + g * s) / r, (n[1] + g * o) / r, $785da19a645c07eb$var$UP(c, g).elevation);
                }
            } else g = !$785da19a645c07eb$var$NP(c, t);
            m = t;
        }
        return null;
    }
    getRaySegmentFromPixel(e1) {
        let t = [
            e1.x,
            e1.y,
            0,
            1
        ], i = [
            e1.x,
            e1.y,
            1,
            1
        ];
        $785da19a645c07eb$var$Du(t, t, this._pixelMatrixInverse), $785da19a645c07eb$var$Du(i, i, this._pixelMatrixInverse);
        let n = t[3], a = i[3], r = this.elevation;
        return {
            near: [
                t[0] / n,
                t[1] / n,
                t[2] / n + r
            ],
            far: [
                i[0] / a,
                i[1] / a,
                i[2] / a + r
            ]
        };
    }
    screenPointToMercatorCoordinateAtZ(e1, t) {
        let i = t || 0, { near: n, far: a } = this.getRaySegmentFromPixel(e1), r = n[2] === a[2] ? 0 : (i + this.elevation - n[2]) / (a[2] - n[2]);
        return new $785da19a645c07eb$var$Lx($785da19a645c07eb$var$Mp.number(n[0], a[0], r) / this.worldSize, $785da19a645c07eb$var$Mp.number(n[1], a[1], r) / this.worldSize, i);
    }
    coordinatePoint(e1, t = 0, i = this._pixelMatrix) {
        let n = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            t,
            1
        ];
        return $785da19a645c07eb$var$Du(n, n, i), new $785da19a645c07eb$var$Kc(n[0] / n[3], n[1] / n[3]);
    }
    getBounds() {
        let e1 = Math.max(0, this._helper._height / 2 - $785da19a645c07eb$var$jx(this));
        return (new $785da19a645c07eb$var$_T).extend(this.screenPointToLocation(new $785da19a645c07eb$var$Kc(0, e1))).extend(this.screenPointToLocation(new $785da19a645c07eb$var$Kc(this._helper._width, e1))).extend(this.screenPointToLocation(new $785da19a645c07eb$var$Kc(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new $785da19a645c07eb$var$Kc(0, this._helper._height)));
    }
    isPointOnMapSurface(e1, t) {
        return t ? null != this.screenTerrainPointToMercatorCoordinate(e1, t) : e1.y > this.height / 2 - $785da19a645c07eb$var$jx(this);
    }
    calculatePosMatrix(e1, t = !1, i = !1) {
        let n = e1.key ?? $785da19a645c07eb$var$XE(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), a = t ? this._alignedPosMatrixCache : this._posMatrixCache;
        if (a.has(n)) {
            let e1 = a.get(n);
            return i ? e1.f32 : e1.f64;
        }
        let r = $785da19a645c07eb$var$Vx(e1, this.worldSize);
        $785da19a645c07eb$var$ru(r, t ? this._alignedProjMatrix : this._viewProjMatrix, r);
        let s = {
            f64: r,
            f32: new Float32Array(r)
        };
        return a.set(n, s), i ? s.f32 : s.f64;
    }
    calculateFogMatrix(e1) {
        let t = e1.key, i = this._fogMatrixCacheF32;
        if (i.has(t)) return i.get(t);
        let n = $785da19a645c07eb$var$Vx(e1, this.worldSize);
        return $785da19a645c07eb$var$ru(n, this._fogMatrix, n), i.set(t, new Float32Array(n)), i.get(t);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, i, n) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, n);
    }
    calculateCameraOptionsFromTo(e1, t, i, n) {
        let a = $785da19a645c07eb$var$Lx.fromLngLat(e1, t), r = $785da19a645c07eb$var$Lx.fromLngLat(i, n), s = r.x - a.x, o = r.y - a.y, l = r.z - a.z, c = Math.hypot(s, o, l);
        if (0 === c) throw Error("Can't calculate camera options with same From and To");
        let u = Math.hypot(s, o), h = $785da19a645c07eb$var$fh(this.cameraToCenterDistance / c / this.tileSize), d = $785da19a645c07eb$var$Ph(Math.atan2(s, -o)), p = $785da19a645c07eb$var$Ph(Math.acos(u / c));
        return p = l < 0 ? 90 - p : 90 + p, {
            center: r.toLngLat(),
            elevation: n,
            zoom: h,
            pitch: p,
            bearing: d
        };
    }
    _calculateNearFarZIfNeeded(e1, t, i) {
        if (!this._helper.autoCalculateNearFarZ) return;
        let n = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), a = e1 - n * this._helper._pixelPerMeter / Math.cos(t), r = n < 0 ? a : e1, s = Math.PI / 2 + this.pitchInRadians, o = $785da19a645c07eb$var$Dh(this.fov) * (Math.abs(Math.cos($785da19a645c07eb$var$Dh(this.roll))) * this.height + Math.abs(Math.sin($785da19a645c07eb$var$Dh(this.roll))) * this.width) / this.height * (.5 + i.y / this.height), l = Math.sin(o) * r / Math.sin($785da19a645c07eb$var$ch(Math.PI - s - o, .01, Math.PI - .01)), c = $785da19a645c07eb$var$jx(this), u = Math.atan(c / this._helper.cameraToCenterDistance), h = $785da19a645c07eb$var$Dh(.75), d = u > h ? 2 * u * (.5 + i.y / (2 * c)) : h, p = Math.sin(d) * r / Math.sin($785da19a645c07eb$var$ch(Math.PI - s - d, .01, Math.PI - .01)), m = Math.min(l, p);
        this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - t) * m + r), this._helper._nearZ = this._helper._height / 50;
    }
    _calcMatrices() {
        let e1, t = this.centerOffset, i = $785da19a645c07eb$var$Ux(this.worldSize, this.center), n = i.x, a = i.y, r = $785da19a645c07eb$var$Dh(Math.min(this.pitch, $785da19a645c07eb$var$Bx)), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(r));
        this._calculateNearFarZIfNeeded(s, r, t), e1 = new Float64Array(16), $785da19a645c07eb$var$hu(e1, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), function(e1, t) {
            e1[0] = 1 / t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1 / t[5], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 0, e1[11] = 1 / t[14], e1[12] = 0, e1[13] = 0, e1[14] = -1, e1[15] = t[10] / t[14];
        }(this._invProjMatrix, e1), e1[8] = 2 * -t.x / this._helper._width, e1[9] = 2 * t.y / this._helper._height, this._projectionMatrix = $785da19a645c07eb$var$iu(e1), $785da19a645c07eb$var$ou(e1, e1, [
            1,
            -1,
            1
        ]), $785da19a645c07eb$var$su(e1, e1, [
            0,
            0,
            -this._helper.cameraToCenterDistance
        ]), $785da19a645c07eb$var$uu(e1, e1, -this.rollInRadians), $785da19a645c07eb$var$lu(e1, e1, this.pitchInRadians), $785da19a645c07eb$var$uu(e1, e1, -this.bearingInRadians), $785da19a645c07eb$var$su(e1, e1, [
            -n,
            -a,
            0
        ]), this._mercatorMatrix = $785da19a645c07eb$var$ou([], e1, [
            this.worldSize,
            this.worldSize,
            this.worldSize
        ]), $785da19a645c07eb$var$ou(e1, e1, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), this._pixelMatrix = $785da19a645c07eb$var$ru(new Float64Array(16), this.clipSpaceToPixelsMatrix, e1), $785da19a645c07eb$var$su(e1, e1, [
            0,
            0,
            -this.elevation
        ]), this._viewProjMatrix = e1, this._invViewProjMatrix = $785da19a645c07eb$var$au([], e1);
        let o = [
            0,
            0,
            -1,
            1
        ];
        $785da19a645c07eb$var$Du(o, o, this._invViewProjMatrix), this._cameraPosition = [
            o[0] / o[3],
            o[1] / o[3],
            o[2] / o[3]
        ], this._fogMatrix = new Float64Array(16), $785da19a645c07eb$var$hu(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = 2 * -t.x / this.width, this._fogMatrix[9] = 2 * t.y / this.height, $785da19a645c07eb$var$ou(this._fogMatrix, this._fogMatrix, [
            1,
            -1,
            1
        ]), $785da19a645c07eb$var$su(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), $785da19a645c07eb$var$uu(this._fogMatrix, this._fogMatrix, -this.rollInRadians), $785da19a645c07eb$var$lu(this._fogMatrix, this._fogMatrix, this.pitchInRadians), $785da19a645c07eb$var$uu(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), $785da19a645c07eb$var$su(this._fogMatrix, this._fogMatrix, [
            -n,
            -a,
            0
        ]), $785da19a645c07eb$var$ou(this._fogMatrix, this._fogMatrix, [
            1,
            1,
            this._helper._pixelPerMeter
        ]), $785da19a645c07eb$var$su(this._fogMatrix, this._fogMatrix, [
            0,
            0,
            -this.elevation
        ]), this._pixelMatrix3D = $785da19a645c07eb$var$ru(new Float64Array(16), this.clipSpaceToPixelsMatrix, e1);
        let l = this._helper._width % 2 / 2, c = this._helper._height % 2 / 2, u = Math.cos(this.bearingInRadians), h = Math.sin(-this.bearingInRadians), d = n - Math.round(n) + u * l + h * c, p = a - Math.round(a) + u * c + h * l, m = new Float64Array(e1);
        if ($785da19a645c07eb$var$su(m, m, [
            d > .5 ? d - 1 : d,
            p > .5 ? p - 1 : p,
            0
        ]), this._alignedProjMatrix = m, e1 = $785da19a645c07eb$var$au(new Float64Array(16), this._pixelMatrix), !e1) throw Error("failed to invert matrix");
        this._pixelMatrixInverse = e1, this._clearMatrixCaches();
    }
    _clearMatrixCaches() {
        this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
    }
    maxPitchScaleFactor() {
        if (!this._pixelMatrixInverse) return 1;
        let e1 = this.screenPointToMercatorCoordinate(new $785da19a645c07eb$var$Kc(0, 0)), t = [
            e1.x * this.worldSize,
            e1.y * this.worldSize,
            0,
            1
        ];
        return $785da19a645c07eb$var$Du(t, t, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return Math.cos(this.pitchInRadians) * this.cameraToCenterDistance / this.pixelsPerMeter + this.elevation;
    }
    getCameraLngLat() {
        let e1 = $785da19a645c07eb$var$Ix(1, this.center.lat) * this.worldSize, t = this._helper.cameraToCenterDistance / e1;
        return $785da19a645c07eb$var$qx(this.center, this.elevation, this.pitch, this.bearing, t).toLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        let i = $785da19a645c07eb$var$Lx.fromLngLat(e1), n = [
            i.x * this.worldSize,
            i.y * this.worldSize,
            t,
            1
        ];
        return $785da19a645c07eb$var$Du(n, n, this._viewProjMatrix), n[2] / n[3];
    }
    getProjectionData(e1) {
        let t, { overscaledTileID: i, aligned: n, applyTerrainMatrix: a } = e1, r = this._helper.getMercatorTileCoordinates(i), s = i ? this.calculatePosMatrix(i, n, !0) : null;
        return t = i?.terrainRttPosMatrix32f && a ? i.terrainRttPosMatrix32f : s || $785da19a645c07eb$var$Xu(), {
            mainMatrix: t,
            tileMercatorCoords: r,
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: t,
            clipAntimeridian: !1
        };
    }
    isLocationOccluded(e1) {
        return !1;
    }
    getPixelScale() {
        return 1;
    }
    getCircleRadiusCorrection() {
        return 1;
    }
    getPitchedTextCorrection(e1, t, i) {
        return 1;
    }
    transformLightDirection(e1) {
        return $785da19a645c07eb$var$mu(e1);
    }
    getRayDirectionFromPixel(e1) {
        throw Error("Not implemented.");
    }
    projectTileCoordinates(e1, t, i, n) {
        let a, r = this.calculatePosMatrix(i);
        null == n ? (a = [
            e1,
            t,
            0,
            1
        ], $785da19a645c07eb$var$VD(a, a, r)) : (a = [
            e1,
            t,
            n,
            1
        ], $785da19a645c07eb$var$Du(a, a, r));
        let s = a[3];
        return {
            point: new $785da19a645c07eb$var$Kc(a[0] / s, a[1] / s),
            signedDistanceFromCamera: s,
            isOccluded: !1
        };
    }
    populateCache(e1) {
        for (let t of e1)this.calculatePosMatrix(t);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = new $785da19a645c07eb$var$KE(0, 0, 0, 0, 0), i = this.getProjectionData({
            overscaledTileID: t,
            applyGlobeMatrix: e1
        }), n = $785da19a645c07eb$var$Vx(t, this.worldSize);
        $785da19a645c07eb$var$ru(n, this._viewProjMatrix, n);
        let a = [
            $785da19a645c07eb$var$Vu,
            $785da19a645c07eb$var$Vu,
            this.worldSize / this._helper.pixelsPerMeter
        ], r = $785da19a645c07eb$var$Zu();
        return $785da19a645c07eb$var$ou(r, n, a), {
            ...i,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            fallbackMatrix: r,
            mainMatrix: r
        };
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.calculatePosMatrix(e1);
    }
};
function $785da19a645c07eb$var$UP(e1, t) {
    return $785da19a645c07eb$var$RP(e1.index, e1.exaggeration, (e1.near[0] + t * e1.dx) / e1.worldSize, (e1.near[1] + t * e1.dy) / e1.worldSize);
}
function $785da19a645c07eb$var$NP(e1, t) {
    return $785da19a645c07eb$var$LP($785da19a645c07eb$var$UP(e1, t), e1.near[2] + t * e1.dz);
}
function $785da19a645c07eb$var$jP() {
    $785da19a645c07eb$var$wh("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
}
function $785da19a645c07eb$var$VP(e1) {
    if (e1.useSlerp) {
        if (e1.k < 1) {
            let t = $785da19a645c07eb$var$zh(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), i = $785da19a645c07eb$var$zh(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), n = new Float64Array(4);
            $785da19a645c07eb$var$Fu(n, t, i, e1.k);
            let a = function(e1) {
                let t = new Float64Array(9);
                !function(e1, t) {
                    var i = t[0], n = t[1], a = t[2], r = t[3], s = i + i, o = n + n, l = a + a, c = i * s, u = n * s, h = n * o, d = a * s, p = a * o, m = a * l, g = r * s, f = r * o, A = r * l;
                    e1[0] = 1 - h - m, e1[3] = u - A, e1[6] = d + f, e1[1] = u + A, e1[4] = 1 - c - m, e1[7] = p - g, e1[2] = d - f, e1[5] = p + g, e1[8] = 1 - c - h;
                }(t, e1);
                let i, n, a = $785da19a645c07eb$var$Ph(-Math.asin($785da19a645c07eb$var$ch(t[2], -1, 1)));
                return Math.hypot(t[5], t[8]) < .001 ? (i = 0, n = -$785da19a645c07eb$var$Ph(Math.atan2(t[3], t[4]))) : (i = $785da19a645c07eb$var$Ph(0 === t[5] && 0 === t[8] ? 0 : Math.atan2(t[5], t[8])), n = $785da19a645c07eb$var$Ph(0 === t[1] && 0 === t[0] ? 0 : Math.atan2(t[1], t[0]))), {
                    roll: i,
                    pitch: a + 90,
                    bearing: n
                };
            }(n);
            e1.tr.setRoll(a.roll), e1.tr.setPitch(a.pitch), e1.tr.setBearing(a.bearing);
        } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
    } else e1.tr.setRoll($785da19a645c07eb$var$Mp.number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch($785da19a645c07eb$var$Mp.number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing($785da19a645c07eb$var$Mp.number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
}
function $785da19a645c07eb$var$qP(e1, t, i, n, a) {
    let r = a.padding, s = $785da19a645c07eb$var$Ux(a.worldSize, i.getNorthWest()), o = $785da19a645c07eb$var$Ux(a.worldSize, i.getNorthEast()), l = $785da19a645c07eb$var$Ux(a.worldSize, i.getSouthEast()), c = $785da19a645c07eb$var$Ux(a.worldSize, i.getSouthWest()), u = $785da19a645c07eb$var$Dh(-n), h = s.rotate(u), d = o.rotate(u), p = l.rotate(u), m = c.rotate(u), g = new $785da19a645c07eb$var$Kc(Math.max(h.x, d.x, m.x, p.x), Math.max(h.y, d.y, m.y, p.y)), f = new $785da19a645c07eb$var$Kc(Math.min(h.x, d.x, m.x, p.x), Math.min(h.y, d.y, m.y, p.y)), A = g.sub(f), _ = a.width - (r.left + r.right + t.left + t.right), v = a.height - (r.top + r.bottom + t.top + t.bottom), y = _ / A.x, x = v / A.y;
    if (x < 0 || y < 0) return void $785da19a645c07eb$var$jP();
    let b = Math.min($785da19a645c07eb$var$fh(a.scale * Math.min(y, x)), e1.maxZoom), w = $785da19a645c07eb$var$Kc.convert(e1.offset), E = new $785da19a645c07eb$var$Kc((t.left - t.right) / 2, (t.top - t.bottom) / 2).rotate($785da19a645c07eb$var$Dh(n)), k = w.add(E).mult(a.scale / $785da19a645c07eb$var$gh(b));
    return {
        center: $785da19a645c07eb$var$Nx(a.worldSize, s.add(l).div(2).sub(k)),
        zoom: b,
        bearing: n
    };
}
var $785da19a645c07eb$var$GP = class {
    get useGlobeControls() {
        return !1;
    }
    handlePanInertia(e1, t) {
        let i = e1.mag(), n = Math.abs($785da19a645c07eb$var$jx(t));
        return {
            easingOffset: e1.mult(Math.min(.75 * n / i, 1)),
            easingCenter: t.center
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
    }
    handleMapControlsPan(e1, t, i) {
        e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(i, e1.around, e1.aroundElevation);
    }
    cameraForBoxAndBearing(e1, t, i, n, a) {
        return $785da19a645c07eb$var$qP(e1, t, i, n, a);
    }
    handleJumpToCenterZoom(e1, t) {
        let i = void 0 === t.zoom ? e1.zoom : +t.zoom;
        e1.zoom !== i && e1.setZoom(+t.zoom), void 0 !== t.center && e1.setCenter($785da19a645c07eb$var$Mx.convert(t.center));
    }
    handleEaseTo(e1, t) {
        let i = e1.zoom, n = e1.padding, a = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, r = {
            roll: void 0 === t.roll ? e1.roll : t.roll,
            pitch: void 0 === t.pitch ? e1.pitch : t.pitch,
            bearing: void 0 === t.bearing ? e1.bearing : t.bearing
        }, s = void 0 !== t.zoom, o = !e1.isPaddingEqual(t.padding), l = !1, c = s ? +t.zoom : e1.zoom, u = e1.centerPoint.add(t.offsetAsPoint), h = e1.screenPointToLocation(u), { center: d, zoom: p } = e1.applyConstrain($785da19a645c07eb$var$Mx.convert(t.center || h), c ?? i);
        $785da19a645c07eb$var$SP(e1, d);
        let m = $785da19a645c07eb$var$Ux(e1.worldSize, h), g = $785da19a645c07eb$var$Ux(e1.worldSize, d).sub(m), f = $785da19a645c07eb$var$gh(p - i);
        return l = p !== i, {
            easeFunc: (s)=>{
                if (l && e1.setZoom($785da19a645c07eb$var$Mp.number(i, p, s)), $785da19a645c07eb$var$Ih(a, r) || $785da19a645c07eb$var$VP({
                    startEulerAngles: a,
                    endEulerAngles: r,
                    tr: e1,
                    k: s,
                    useSlerp: a.roll != r.roll
                }), o && (e1.interpolatePadding(n, t.padding, s), u = e1.centerPoint.add(t.offsetAsPoint)), t.around) e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = $785da19a645c07eb$var$gh(e1.zoom - i), n = (p > i ? Math.min(2, f) : Math.max(.5, f)) ** (1 - s), a = $785da19a645c07eb$var$Nx(e1.worldSize, m.add(g.mult(s * n)).mult(t));
                    e1.setLocationAtPoint(e1.renderWorldCopies ? a.wrap() : a, u);
                }
            },
            isZooming: l,
            elevationCenter: d
        };
    }
    handleFlyTo(e1, t) {
        let i = void 0 !== t.zoom, n = e1.zoom, a = e1.applyConstrain($785da19a645c07eb$var$Mx.convert(t.center || t.locationAtOffset), i ? +t.zoom : n), r = a.center, s = a.zoom;
        $785da19a645c07eb$var$SP(e1, r);
        let o = e1.worldSize, l = $785da19a645c07eb$var$Ux(o, t.locationAtOffset), c = $785da19a645c07eb$var$Ux(o, r).sub(l), u = c.mag(), h = $785da19a645c07eb$var$gh(s - n), d = void 0 === t.minZoom ? e1.minZoom : +t.minZoom, p = Math.max(d, e1.minZoom), m = Math.min(p, n, s), g = e1.applyConstrain(r, m).zoom;
        return {
            easeFunc: (t, i, a, u)=>{
                e1.setZoom(1 === t ? s : n + $785da19a645c07eb$var$fh(i));
                let h = 1 === t ? r : $785da19a645c07eb$var$Nx(o, l.add(c.mult(a)));
                e1.setLocationAtPoint(e1.renderWorldCopies ? h.wrap() : h, u);
            },
            scaleOfZoom: h,
            targetCenter: r,
            scaleOfMinZoom: $785da19a645c07eb$var$gh(g - n),
            pixelPathLength: u
        };
    }
};
let $785da19a645c07eb$var$HP;
const $785da19a645c07eb$var$WP = new $785da19a645c07eb$var$$y({
    fill: new $785da19a645c07eb$var$Jy(128, 2),
    line: new $785da19a645c07eb$var$Jy(512, 0),
    tile: new $785da19a645c07eb$var$Jy(128, 32),
    stencil: new $785da19a645c07eb$var$Jy(128, 1),
    circle: 3
});
var $785da19a645c07eb$var$ZP = class {
    constructor(){
        this._tileMeshCache = {};
    }
    get name() {
        return "vertical-perspective";
    }
    get transitionState() {
        return 1;
    }
    get useSubdivision() {
        return !0;
    }
    get shaderVariantName() {
        return "globe";
    }
    get shaderDefine() {
        return "#define GLOBE";
    }
    get shaderPreludeCode() {
        return $785da19a645c07eb$var$yP.projectionGlobe;
    }
    get vertexShaderPreludeCode() {
        return $785da19a645c07eb$var$yP.projectionMercator.vertexSource;
    }
    get subdivisionGranularity() {
        return $785da19a645c07eb$var$WP;
    }
    get useGlobeControls() {
        return !0;
    }
    destroy() {}
    _getMeshKey(e1) {
        return `${e1.granularity.toString(36)}_${e1.generateBorders ? "b" : ""}${e1.extendToNorthPole ? "n" : ""}${e1.extendToSouthPole ? "s" : ""}`;
    }
    getMeshFromTileID(e1, t, i, n, a) {
        let r = ("stencil" === a ? $785da19a645c07eb$var$WP.stencil : $785da19a645c07eb$var$WP.tile).getGranularityForZoomLevel(t.z), s = 0 === t.y && n, o = t.y === (1 << t.z) - 1 && n;
        return this._getMesh(e1, {
            granularity: r,
            generateBorders: i,
            extendToNorthPole: s,
            extendToSouthPole: o
        });
    }
    _getMesh(e1, t) {
        let i = this._getMeshKey(t);
        if (i in this._tileMeshCache) return this._tileMeshCache[i];
        let n = $785da19a645c07eb$var$OT(e1, t);
        return this._tileMeshCache[i] = n, n;
    }
    recalculate(e1) {}
    hasTransition() {
        return !1;
    }
}, $785da19a645c07eb$var$KP = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t){
        super(), this._transitionable = new $785da19a645c07eb$var$eA($785da19a645c07eb$var$HP ||= new $785da19a645c07eb$var$pA({
            type: new $785da19a645c07eb$var$lA($785da19a645c07eb$var$od.projection.type, "type")
        }), "projection", t), this.setProjection(e1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new $785da19a645c07eb$var$Qf(0)), this._mercatorProjection = new $785da19a645c07eb$var$EP, this._verticalPerspectiveProjection = new $785da19a645c07eb$var$ZP;
    }
    get transitionState() {
        let e1 = this.properties.get("type");
        if ("string" == typeof e1 && "mercator" === e1) return 0;
        if ("string" == typeof e1 && "vertical-perspective" === e1) return 1;
        if (e1 instanceof $785da19a645c07eb$var$mp) {
            if (e1.from === e1.to) return "mercator" === e1.from ? 0 : 1;
            if ("vertical-perspective" === e1.from && "mercator" === e1.to) return 1 - e1.transition;
            if ("mercator" === e1.from && "vertical-perspective" === e1.to) return e1.transition;
        }
        return 1;
    }
    get useGlobeRendering() {
        return this.transitionState > 0;
    }
    get currentProjection() {
        return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
    }
    get name() {
        return "globe";
    }
    get useSubdivision() {
        return this.currentProjection.useSubdivision;
    }
    get shaderVariantName() {
        return this.currentProjection.shaderVariantName;
    }
    get shaderDefine() {
        return this.currentProjection.shaderDefine;
    }
    get shaderPreludeCode() {
        return this.currentProjection.shaderPreludeCode;
    }
    get vertexShaderPreludeCode() {
        return this.currentProjection.vertexShaderPreludeCode;
    }
    get subdivisionGranularity() {
        return this.currentProjection.subdivisionGranularity;
    }
    get useGlobeControls() {
        return this.transitionState > 0;
    }
    destroy() {
        this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
    }
    getMeshFromTileID(e1, t, i, n, a) {
        return this.currentProjection.getMeshFromTileID(e1, t, i, n, a);
    }
    setProjection(e1) {
        this._transitionable.setValue("type", e1?.type || "mercator");
    }
    updateTransitions(e1) {
        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
    }
    hasTransition() {
        return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
    }
    recalculate(e1) {
        this.properties = this._transitioning.possiblyEvaluate(e1);
    }
};
function $785da19a645c07eb$var$XP(e1) {
    let t = $785da19a645c07eb$var$JP(e1.worldSize, e1.center.lat);
    return 2 * Math.PI * t;
}
function $785da19a645c07eb$var$QP(e1, t, i, n, a) {
    let r = 1 / (1 << a), s = t / $785da19a645c07eb$var$Vu * r + n * r, o = $785da19a645c07eb$var$nh((e1 / $785da19a645c07eb$var$Vu * r + i * r) * Math.PI * 2 + Math.PI, 2 * Math.PI), l = 2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - .5 * Math.PI, c = Math.cos(l), u = new Float64Array(3);
    return u[0] = Math.sin(o) * c, u[1] = Math.sin(l), u[2] = Math.cos(o) * c, u;
}
function $785da19a645c07eb$var$YP(e1) {
    return function(e1, t) {
        let i = Math.cos(t), n = new Float64Array(3);
        return n[0] = Math.sin(e1) * i, n[1] = Math.sin(t), n[2] = Math.cos(e1) * i, n;
    }(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
}
function $785da19a645c07eb$var$JP(e1, t) {
    return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
}
function $785da19a645c07eb$var$$P(e1) {
    let t = $785da19a645c07eb$var$Du($785da19a645c07eb$var$Hu(), [
        0,
        0,
        0,
        1
    ], e1.modelViewProjectionMatrix);
    return $785da19a645c07eb$var$Du(t, t, e1.inverseProjectionMatrix), [
        t[0] / t[3],
        t[1] / t[3],
        t[2] / t[3]
    ];
}
function $785da19a645c07eb$var$eI(e1) {
    let t = Math.asin(e1[1]) / Math.PI * 180, i = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
    if (i > 1e-6) {
        let n = e1[0] / i, a = e1[2] / i, r = Math.acos(a), s = (n > 0 ? r : -r) / Math.PI * 180;
        return new $785da19a645c07eb$var$Mx($785da19a645c07eb$var$uh(s, -180, 180), t);
    }
    return new $785da19a645c07eb$var$Mx(0, t);
}
const $785da19a645c07eb$var$tI = .98 * Math.PI;
function $785da19a645c07eb$var$iI(e1, t) {
    let i = e1.cameraPosition, n = $785da19a645c07eb$var$gu(i);
    if (n <= 1) return e1.screenPointToLocation(t);
    let a = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$xu(a, i);
    let r = e1.getRayDirectionFromPixel(t), s = -$785da19a645c07eb$var$bu(r, a), o = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$yu(o, r, a, s);
    let l = $785da19a645c07eb$var$gu(o);
    if (l < 1e-9) return e1.screenPointToLocation(t);
    let c = Math.atan2(l, s), u = .9 * Math.asin(1 / n);
    if (c < u) return e1.screenPointToLocation(t);
    let h = n * Math.sin(u), d = Math.asin($785da19a645c07eb$var$ch(h, -1, 1)) - u, p = n * Math.cos(u) / Math.sqrt(Math.max(1 - h * h, 1e-12)) - 1, m = $785da19a645c07eb$var$tI - d, g = c - u, f = d + p * g * m / (m + p * g), A = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$vu(A, o, 1 / l);
    let _ = $785da19a645c07eb$var$Wu();
    return $785da19a645c07eb$var$vu(_, a, Math.cos($785da19a645c07eb$var$ch(f, 0, $785da19a645c07eb$var$tI))), $785da19a645c07eb$var$yu(_, _, A, Math.sin($785da19a645c07eb$var$ch(f, 0, $785da19a645c07eb$var$tI))), $785da19a645c07eb$var$xu(_, _), $785da19a645c07eb$var$eI(_);
}
function $785da19a645c07eb$var$nI(e1, t, i, n, a = !0) {
    let r = $785da19a645c07eb$var$iI(e1, i), s = t;
    if (n) s = $785da19a645c07eb$var$iI(e1, i.sub(n));
    else if (!e1.isPointOnMapSurface(i)) return;
    let o = $785da19a645c07eb$var$YP(r), l = $785da19a645c07eb$var$YP(s), c = function(e1, t) {
        return $785da19a645c07eb$var$zu($785da19a645c07eb$var$Hu(), -e1.lng, -e1.lat, t);
    }(e1.center, e1.bearing), u = $785da19a645c07eb$var$wu($785da19a645c07eb$var$Wu(), l, o), h = Math.sqrt($785da19a645c07eb$var$bu(u, u)), d = Math.acos($785da19a645c07eb$var$ch($785da19a645c07eb$var$bu(l, o), -1, 1)) / 2, p = Math.sin(d), m = h ? $785da19a645c07eb$var$Ru(u[1] / h * p, -u[0] / h * p, u[2] / h * p, Math.cos(d)) : $785da19a645c07eb$var$Ru(0, 0, 0, 1), { lng: g, lat: f, bearing: A } = function(e1) {
        let t = e1[0], i = e1[1], n = e1[2], a = e1[3];
        return {
            lng: 180 * -Math.atan2(2 * (a * t + i * n), 1 - 2 * (t * t + i * i)) / Math.PI,
            lat: 180 * -Math.asin($785da19a645c07eb$var$ch(2 * (a * i - n * t), -1, 1)) / Math.PI,
            bearing: 180 * Math.atan2(2 * (a * n + t * i), 1 - 2 * (i * i + n * n)) / Math.PI
        };
    }(function(e1, t, i) {
        var n = t[0], a = t[1], r = t[2], s = t[3], o = i[0], l = i[1], c = i[2], u = i[3];
        return e1[0] = n * u + s * o + a * c - r * l, e1[1] = a * u + s * l + r * o - n * c, e1[2] = r * u + s * c + n * l - a * o, e1[3] = s * u - n * o - a * l - r * c, e1;
    }($785da19a645c07eb$var$Hu(), c, m)), _ = e1.center.lat, v = e1.zoom, y = $785da19a645c07eb$var$ch(f, -90, 90), x = a ? function(e1, t, i, n) {
        let a = e1.center.lng, r = e1.center.lat, s = r >= 0 ? 90 : -90, o = e1.locationToScreenPoint(new $785da19a645c07eb$var$Mx(0, s)), l = t.x - o.x, c = t.y - o.y, u = l * l + c * c, h = $785da19a645c07eb$var$ch(1 - ($785da19a645c07eb$var$Rh - Math.abs(r)) / 12, 0, 1), d = h * h * (3 - 2 * h), p = $785da19a645c07eb$var$nh(n - a + 180, 360) - 180, m = 0;
        if (d > 0 && i) m = (s > 0 ? 1 : -1) * ((l * i.y - c * i.x) / Math.max(u, 400)) * 180 / Math.PI;
        return a + (1 - d) * p + d * m;
    }(e1, i, n, g) : g;
    e1.setCenter(new $785da19a645c07eb$var$Mx($785da19a645c07eb$var$uh(x, -180, 180), y)), a || e1.setBearing(A), e1.setZoom(v + $785da19a645c07eb$var$rI(_, e1.center.lat));
}
function $785da19a645c07eb$var$aI(e1) {
    return Math.cos(e1 * Math.PI / 180);
}
function $785da19a645c07eb$var$rI(e1, t) {
    let i = $785da19a645c07eb$var$aI(e1);
    return $785da19a645c07eb$var$fh($785da19a645c07eb$var$aI(t) / i);
}
function $785da19a645c07eb$var$sI(e1, t) {
    let i = e1.rotate(t.bearingInRadians), n = t.zoom + $785da19a645c07eb$var$rI(t.center.lat, 0), a = $785da19a645c07eb$var$rh(1 / $785da19a645c07eb$var$aI(t.center.lat), 1 / $785da19a645c07eb$var$aI(Math.min(Math.abs(t.center.lat), 60)), $785da19a645c07eb$var$ah(n, 7, 3, 0, 1)), r = function(e1, t) {
        return 360 / $785da19a645c07eb$var$XP({
            worldSize: e1,
            center: {
                lat: t
            }
        });
    }(t.worldSize, t.center.lat);
    return new $785da19a645c07eb$var$Mx(t.center.lng - i.x * r * a, $785da19a645c07eb$var$ch(t.center.lat + i.y * r, -$785da19a645c07eb$var$Rh, $785da19a645c07eb$var$Rh));
}
function $785da19a645c07eb$var$oI(e1) {
    let t = .5 * e1, i = Math.sin(t), n = Math.cos(t);
    return Math.log(i + n) - Math.log(n - i);
}
function $785da19a645c07eb$var$lI(e1, t, i, n) {
    let a = e1.lat + i * n;
    if (Math.abs(i) > 1) {
        let r = e1.lat + i, s = (Math.sign(r) === Math.sign(e1.lat) ? Math.abs(e1.lat) : -Math.abs(e1.lat)) * Math.PI / 180, o = Math.abs(e1.lat + i) * Math.PI / 180, l = $785da19a645c07eb$var$oI(s + n * (o - s)), c = $785da19a645c07eb$var$oI(s), u = (l - c) / ($785da19a645c07eb$var$oI(o) - c), h = e1.lng + t * u;
        return new $785da19a645c07eb$var$Mx(h, a);
    }
    {
        let i = e1.lng + t * n;
        return new $785da19a645c07eb$var$Mx(i, a);
    }
}
function $785da19a645c07eb$var$cI(e1, t, i = 1) {
    let n = $785da19a645c07eb$var$bu(e1, t), a = i * i, r = $785da19a645c07eb$var$Wu(), s = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$vu(s, t, n), $785da19a645c07eb$var$Cu(r, e1, s);
    let o = a - $785da19a645c07eb$var$bu(r, r);
    if (o < 0) return null;
    let l = $785da19a645c07eb$var$bu(e1, e1) - a, c = -n + (n < 0 ? 1 : -1) * Math.sqrt(o), u = l / c, h = c;
    return {
        tMin: Math.min(u, h),
        tMax: Math.max(u, h)
    };
}
var $785da19a645c07eb$var$uI = class {
    constructor(e1){
        this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
    }
    swapBuffers() {
        if (!this._hadAnyChanges) return;
        let e1 = this._cachePrevious;
        this._cachePrevious = this._cache, this._cache = e1, this._cache.clear(), this._hadAnyChanges = !1;
    }
    getTileBoundingVolume(e1, t, i, n) {
        let a = `${e1.z}_${e1.x}_${e1.y}_${n?.terrain ? "t" : ""}_${Math.round(i)}`, r = this._cache.get(a);
        if (r) return r;
        let s = this._cachePrevious.get(a);
        if (s) return this._cache.set(a, s), s;
        let o = this._boundingVolumeFactory(e1, t, i, n);
        return this._cache.set(a, o), this._hadAnyChanges = !0, o;
    }
}, $785da19a645c07eb$var$hI = class e1 {
    constructor(e1, t, i, n){
        this.min = i, this.max = n, this.points = e1, this.planes = t;
    }
    static fromAabb(t, i) {
        let n = [];
        for(let e1 = 0; e1 < 8; e1++)n.push([
            1 & ~e1 ? t[0] : i[0],
            1 == (e1 >> 1 & 1) ? i[1] : t[1],
            1 == (e1 >> 2 & 1) ? i[2] : t[2]
        ]);
        return new e1(n, [
            [
                -1,
                0,
                0,
                i[0]
            ],
            [
                1,
                0,
                0,
                -t[0]
            ],
            [
                0,
                -1,
                0,
                i[1]
            ],
            [
                0,
                1,
                0,
                -t[1]
            ],
            [
                0,
                0,
                -1,
                i[2]
            ],
            [
                0,
                0,
                1,
                -t[2]
            ]
        ], t, i);
    }
    static fromCenterSizeAngles(t, i, n) {
        let a = $785da19a645c07eb$var$zu([], n[0], n[1], n[2]), r = $785da19a645c07eb$var$Eu([], [
            i[0],
            0,
            0
        ], a), s = $785da19a645c07eb$var$Eu([], [
            0,
            i[1],
            0
        ], a), o = $785da19a645c07eb$var$Eu([], [
            0,
            0,
            i[2]
        ], a), l = [
            ...t
        ], c = [
            ...t
        ];
        for(let e1 = 0; e1 < 8; e1++)for(let i = 0; i < 3; i++){
            let n = t[i] + r[i] * (1 & ~e1 ? -1 : 1) + s[i] * (1 == (e1 >> 1 & 1) ? 1 : -1) + o[i] * (1 == (e1 >> 2 & 1) ? 1 : -1);
            l[i] = Math.min(l[i], n), c[i] = Math.max(c[i], n);
        }
        let u = [];
        for(let e1 = 0; e1 < 8; e1++){
            let i = [
                ...t
            ];
            $785da19a645c07eb$var$Au(i, i, $785da19a645c07eb$var$vu([], r, 1 & ~e1 ? -1 : 1)), $785da19a645c07eb$var$Au(i, i, $785da19a645c07eb$var$vu([], s, 1 == (e1 >> 1 & 1) ? 1 : -1)), $785da19a645c07eb$var$Au(i, i, $785da19a645c07eb$var$vu([], o, 1 == (e1 >> 2 & 1) ? 1 : -1)), u.push(i);
        }
        return new e1(u, [
            [
                ...r,
                -$785da19a645c07eb$var$bu(r, u[0])
            ],
            [
                ...s,
                -$785da19a645c07eb$var$bu(s, u[0])
            ],
            [
                ...o,
                -$785da19a645c07eb$var$bu(o, u[0])
            ],
            [
                -r[0],
                -r[1],
                -r[2],
                -$785da19a645c07eb$var$bu(r, u[7])
            ],
            [
                -s[0],
                -s[1],
                -s[2],
                -$785da19a645c07eb$var$bu(s, u[7])
            ],
            [
                -o[0],
                -o[1],
                -o[2],
                -$785da19a645c07eb$var$bu(o, u[7])
            ]
        ], l, c);
    }
    intersectsFrustum(e1) {
        let t = !0, i = this.points.length, n = this.planes.length, a = e1.planes.length, r = e1.points.length;
        for(let n = 0; n < a; n++){
            let a = e1.planes[n], r = 0;
            for(let e1 = 0; e1 < i; e1++){
                let t = this.points[e1];
                a[0] * t[0] + a[1] * t[1] + a[2] * t[2] + a[3] >= 0 && r++;
            }
            if (0 === r) return 0;
            r < i && (t = !1);
        }
        if (t) return 2;
        for(let t = 0; t < n; t++){
            let i = this.planes[t], n = 0;
            for(let t = 0; t < r; t++){
                let a = e1.points[t];
                i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] >= 0 && n++;
            }
            if (0 === n) return 0;
        }
        return 1;
    }
    intersectsPlane(e1) {
        let t = this.points.length, i = 0;
        for(let n = 0; n < t; n++){
            let t = this.points[n];
            e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] >= 0 && i++;
        }
        return i === t ? 2 : 0 === i ? 0 : 1;
    }
};
function $785da19a645c07eb$var$dI(e1, t, i) {
    let n = e1 - t;
    return n < 0 ? -n : Math.max(0, n - i);
}
function $785da19a645c07eb$var$pI(e1, t, i, n, a) {
    let r, s = e1 - i;
    return r = s < 0 ? Math.min(-s, 1 + s - a) : s > a ? Math.min(Math.max(s - a, 0), 1 - s) : 0, Math.max(r, $785da19a645c07eb$var$dI(t, n, a));
}
var $785da19a645c07eb$var$mI = class {
    constructor(){
        this._boundingVolumeCache = new $785da19a645c07eb$var$uI(this._computeTileBoundingVolume);
    }
    prepareNextFrame() {
        this._boundingVolumeCache.swapBuffers();
    }
    distanceToTile2d(e1, t, i, n) {
        let a = 1 << i.z, r = 1 / a, s = i.x / a, o = i.y / a, l = 2;
        return l = Math.min(l, $785da19a645c07eb$var$pI(e1, t, s, o, r)), l = Math.min(l, $785da19a645c07eb$var$pI(e1, t, s + .5, -o - r, r)), l = Math.min(l, $785da19a645c07eb$var$pI(e1, t, s + .5, 2 - o - r, r)), l;
    }
    getWrap(e1, t, i) {
        let n = 1 << t.z, a = 1 / n, r = t.x / n, s = $785da19a645c07eb$var$dI(e1.x, r, a), o = $785da19a645c07eb$var$dI(e1.x, r - 1, a), l = $785da19a645c07eb$var$dI(e1.x, r + 1, a), c = Math.min(s, o, l);
        return c === l ? 1 : c === o ? -1 : 0;
    }
    allowVariableZoom(e1, t) {
        return $785da19a645c07eb$var$aD(e1, t) > 4;
    }
    allowWorldCopies() {
        return !1;
    }
    getTileBoundingVolume(e1, t, i, n) {
        return this._boundingVolumeCache.getTileBoundingVolume(e1, t, i, n);
    }
    _computeTileBoundingVolume(e1, t, i, n) {
        let a = Math.min(0, i), r = Math.max(0, i);
        if (n?.terrain) {
            let i = new $785da19a645c07eb$var$KE(e1.z, t, e1.z, e1.x, e1.y), s = n.terrain.getMinMaxElevation(i);
            a = s.minElevation ?? a, r = Math.max(s.maxElevation ?? r, r);
        }
        if (a /= $785da19a645c07eb$var$Sx, r /= $785da19a645c07eb$var$Sx, a += 1, r += 1, e1.z <= 0) return $785da19a645c07eb$var$hI.fromAabb([
            -r,
            -r,
            -r
        ], [
            r,
            r,
            r
        ]);
        if (1 === e1.z) return $785da19a645c07eb$var$hI.fromAabb([
            0 === e1.x ? -r : 0,
            0 === e1.y ? 0 : -r,
            -r
        ], [
            0 === e1.x ? 0 : r,
            0 === e1.y ? r : 0,
            r
        ]);
        {
            let t = [
                $785da19a645c07eb$var$QP(0, 0, e1.x, e1.y, e1.z),
                $785da19a645c07eb$var$QP($785da19a645c07eb$var$Vu, 0, e1.x, e1.y, e1.z),
                $785da19a645c07eb$var$QP($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, e1.x, e1.y, e1.z),
                $785da19a645c07eb$var$QP(0, $785da19a645c07eb$var$Vu, e1.x, e1.y, e1.z)
            ], i = [];
            for (let e1 of t)i.push($785da19a645c07eb$var$vu([], e1, r));
            if (r !== a) for (let e1 of t)i.push($785da19a645c07eb$var$vu([], e1, a));
            0 === e1.y && i.push([
                0,
                1,
                0
            ]), e1.y === (1 << e1.z) - 1 && i.push([
                0,
                -1,
                0
            ]);
            let n = [
                1,
                1,
                1
            ], s = [
                -1,
                -1,
                -1
            ];
            for (let e1 of i)for(let t = 0; t < 3; t++)n[t] = Math.min(n[t], e1[t]), s[t] = Math.max(s[t], e1[t]);
            let o = $785da19a645c07eb$var$QP(4096, 4096, e1.x, e1.y, e1.z), l = $785da19a645c07eb$var$wu([], [
                0,
                1,
                0
            ], o);
            $785da19a645c07eb$var$xu(l, l);
            let c = $785da19a645c07eb$var$wu([], o, l);
            $785da19a645c07eb$var$xu(c, c);
            let u = $785da19a645c07eb$var$wu([], t[2], t[1]);
            $785da19a645c07eb$var$xu(u, u);
            let h = $785da19a645c07eb$var$wu([], t[0], t[3]);
            $785da19a645c07eb$var$xu(h, h), i.push($785da19a645c07eb$var$vu([], o, r)), e1.y >= (1 << e1.z) / 2 && i.push($785da19a645c07eb$var$vu([], $785da19a645c07eb$var$QP(4096, 0, e1.x, e1.y, e1.z), r)), e1.y < (1 << e1.z) / 2 && i.push($785da19a645c07eb$var$vu([], $785da19a645c07eb$var$QP(4096, $785da19a645c07eb$var$Vu, e1.x, e1.y, e1.z), r));
            let d = $785da19a645c07eb$var$gI(o, i), p = $785da19a645c07eb$var$gI(c, i), m = [
                -o[0],
                -o[1],
                -o[2],
                d.max
            ], g = [
                o[0],
                o[1],
                o[2],
                -d.min
            ], f = [
                -c[0],
                -c[1],
                -c[2],
                p.max
            ], A = [
                c[0],
                c[1],
                c[2],
                -p.min
            ], _ = [
                ...u,
                0
            ], v = [
                ...h,
                0
            ], y = [];
            return 0 === e1.y ? y.push($785da19a645c07eb$var$Ju(v, _, m), $785da19a645c07eb$var$Ju(v, _, g)) : y.push($785da19a645c07eb$var$Ju(f, _, m), $785da19a645c07eb$var$Ju(f, _, g), $785da19a645c07eb$var$Ju(f, v, m), $785da19a645c07eb$var$Ju(f, v, g)), e1.y === (1 << e1.z) - 1 ? y.push($785da19a645c07eb$var$Ju(v, _, m), $785da19a645c07eb$var$Ju(v, _, g)) : y.push($785da19a645c07eb$var$Ju(A, _, m), $785da19a645c07eb$var$Ju(A, _, g), $785da19a645c07eb$var$Ju(A, v, m), $785da19a645c07eb$var$Ju(A, v, g)), new $785da19a645c07eb$var$hI(y, [
                m,
                g,
                f,
                A,
                _,
                v
            ], n, s);
        }
    }
};
function $785da19a645c07eb$var$gI(e1, t) {
    let i = 1 / 0, n = -1 / 0;
    for (let a of t){
        let t = $785da19a645c07eb$var$bu(e1, a);
        i = Math.min(i, t), n = Math.max(n, t);
    }
    return {
        min: i,
        max: n
    };
}
var $785da19a645c07eb$var$fI = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, i) {
        this._helper.interpolatePadding(e1, t, i);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t) {
        this._helper.resize(e1, t);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    setTransitionState(e1) {}
    constructor(e1){
        this._cachedClippingPlane = $785da19a645c07eb$var$Hu(), this._projectionMatrix = $785da19a645c07eb$var$Ku(), this._globeViewProjMatrix32f = $785da19a645c07eb$var$Xu(), this._globeViewProjMatrixF64 = $785da19a645c07eb$var$Ku(), this._globeViewProjMatrixF64Inverted = $785da19a645c07eb$var$Ku(), this._globeProjMatrixInverted = $785da19a645c07eb$var$Ku(), this._cameraPosition = $785da19a645c07eb$var$Wu(), this.defaultConstrain = (e1, t)=>{
            let i = $785da19a645c07eb$var$ch(e1.lat, -$785da19a645c07eb$var$Rh, $785da19a645c07eb$var$Rh), n = $785da19a645c07eb$var$ch(+t, this.minZoom + $785da19a645c07eb$var$rI(0, i), this.maxZoom);
            return {
                center: new $785da19a645c07eb$var$Mx(e1.lng, i),
                zoom: n
            };
        }, this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $785da19a645c07eb$var$CP({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._coveringTilesDetailsProvider = new $785da19a645c07eb$var$mI;
    }
    clone() {
        let t = new e1;
        return t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t);
    }
    get projectionMatrix() {
        return this._projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this._globeViewProjMatrixF64;
    }
    get inverseProjectionMatrix() {
        return this._globeProjMatrixInverted;
    }
    get cameraPosition() {
        let e1 = $785da19a645c07eb$var$Wu();
        return e1[0] = this._cameraPosition[0], e1[1] = this._cameraPosition[1], e1[2] = this._cameraPosition[2], e1;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    getProjectionData(e1) {
        let { overscaledTileID: t, applyGlobeMatrix: i } = e1, n = this._helper.getMercatorTileCoordinates(t);
        return {
            mainMatrix: this._globeViewProjMatrix32f,
            tileMercatorCoords: n,
            clippingPlane: this._cachedClippingPlane,
            projectionTransition: +!!i,
            fallbackMatrix: this._globeViewProjMatrix32f,
            clipAntimeridian: 0 === t?.canonical.z
        };
    }
    _computeClippingPlane(e1) {
        let t = this.pitchInRadians, i = this.cameraToCenterDistance / e1, n = Math.sin(t) * i, a = Math.cos(t) * i + 1, r = 1 / Math.sqrt(n * n + a * a) * 1, s = -n, o = a, l = Math.sqrt(s * s + o * o);
        s /= l, o /= l;
        let c = [
            0,
            s,
            o
        ];
        $785da19a645c07eb$var$Mu(c, c, [
            0,
            0,
            0
        ], -this.bearingInRadians), $785da19a645c07eb$var$ku(c, c, [
            0,
            0,
            0
        ], -1 * this.center.lat * Math.PI / 180), $785da19a645c07eb$var$Su(c, c, [
            0,
            0,
            0
        ], this.center.lng * Math.PI / 180);
        let u = 1 / $785da19a645c07eb$var$gu(c);
        return $785da19a645c07eb$var$vu(c, c, u), [
            ...c,
            -r * u
        ];
    }
    isLocationOccluded(e1) {
        return !this.isSurfacePointVisible($785da19a645c07eb$var$YP(e1));
    }
    transformLightDirection(e1) {
        let t = this._helper._center.lng * Math.PI / 180, i = this._helper._center.lat * Math.PI / 180, n = Math.cos(i), a = [
            Math.sin(t) * n,
            Math.sin(i),
            Math.cos(t) * n
        ], r = [
            a[2],
            0,
            -a[0]
        ], s = [
            0,
            0,
            0
        ];
        $785da19a645c07eb$var$wu(s, r, a), $785da19a645c07eb$var$xu(r, r), $785da19a645c07eb$var$xu(s, s);
        let o = [
            0,
            0,
            0
        ];
        return $785da19a645c07eb$var$xu(o, [
            r[0] * e1[0] + s[0] * e1[1] + a[0] * e1[2],
            r[1] * e1[0] + s[1] * e1[1] + a[1] * e1[2],
            r[2] * e1[0] + s[2] * e1[1] + a[2] * e1[2]
        ]), o;
    }
    getPixelScale() {
        return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getCircleRadiusCorrection() {
        return Math.cos(this._helper._center.lat * Math.PI / 180);
    }
    getPitchedTextCorrection(e1, t, i) {
        let n = $785da19a645c07eb$var$Ox(e1, t, i.canonical), a = function(e1, t) {
            return [
                $785da19a645c07eb$var$nh(e1 * Math.PI * 2 + Math.PI, 2 * Math.PI),
                2 * Math.atan(Math.exp(Math.PI - t * Math.PI * 2)) - .5 * Math.PI
            ];
        }(n.x, n.y);
        return this.getCircleRadiusCorrection() / Math.cos(a[1]);
    }
    projectTileCoordinates(e1, t, i, n) {
        let a, r = i.canonical, s = $785da19a645c07eb$var$QP(e1, t, r.x, r.y, r.z), o = 1 + (n ?? 0) / $785da19a645c07eb$var$Sx, l = s[0] * o, c = s[1] * o, u = s[2] * o, h = [
            l,
            c,
            u,
            1
        ];
        if ($785da19a645c07eb$var$Du(h, h, this._globeViewProjMatrixF64), o <= 1) {
            let e1 = this._cachedClippingPlane;
            a = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2] + e1[3] < 0;
        } else a = this._isLineOfSightBlocked(l, c, u);
        return {
            point: new $785da19a645c07eb$var$Kc(h[0] / h[3], h[1] / h[3]),
            signedDistanceFromCamera: h[3],
            isOccluded: a
        };
    }
    _isLineOfSightBlocked(e1, t, i) {
        let n = this._cameraPosition, a = e1 - n[0], r = t - n[1], s = i - n[2], o = a * a + r * r + s * s;
        if (0 === o) return !1;
        let l = $785da19a645c07eb$var$ch(-(n[0] * a + n[1] * r + n[2] * s) / o, 0, 1), c = n[0] + l * a, u = n[1] + l * r, h = n[2] + l * s;
        return c * c + u * u + h * h < 1;
    }
    _calcMatrices() {
        let e1 = $785da19a645c07eb$var$JP(this.worldSize, this.center.lat), t = $785da19a645c07eb$var$Zu();
        this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * e1), $785da19a645c07eb$var$hu(t, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
        let i = this.centerOffset;
        t[8] = 2 * -i.x / this._helper._width, t[9] = 2 * i.y / this._helper._height, this._projectionMatrix = $785da19a645c07eb$var$iu(t), this._globeProjMatrixInverted = $785da19a645c07eb$var$Zu(), $785da19a645c07eb$var$au(this._globeProjMatrixInverted, t), $785da19a645c07eb$var$su(t, t, [
            0,
            0,
            -this.cameraToCenterDistance
        ]), $785da19a645c07eb$var$uu(t, t, this.rollInRadians), $785da19a645c07eb$var$lu(t, t, -this.pitchInRadians), $785da19a645c07eb$var$uu(t, t, this.bearingInRadians), $785da19a645c07eb$var$su(t, t, [
            0,
            0,
            -e1
        ]);
        let n = $785da19a645c07eb$var$Wu();
        n[0] = e1, n[1] = e1, n[2] = e1, $785da19a645c07eb$var$lu(t, t, this.center.lat * Math.PI / 180), $785da19a645c07eb$var$cu(t, t, -this.center.lng * Math.PI / 180), $785da19a645c07eb$var$ou(t, t, n), this._globeViewProjMatrixF64 = t, this._globeViewProjMatrix32f = new Float32Array(t), this._globeViewProjMatrixF64Inverted = $785da19a645c07eb$var$Zu(), $785da19a645c07eb$var$au(this._globeViewProjMatrixF64Inverted, t);
        let a = $785da19a645c07eb$var$Wu();
        this._cameraPosition = $785da19a645c07eb$var$Wu(), this._cameraPosition[2] = this.cameraToCenterDistance / e1, $785da19a645c07eb$var$Mu(this._cameraPosition, this._cameraPosition, a, -this.rollInRadians), $785da19a645c07eb$var$ku(this._cameraPosition, this._cameraPosition, a, this.pitchInRadians), $785da19a645c07eb$var$Mu(this._cameraPosition, this._cameraPosition, a, -this.bearingInRadians), $785da19a645c07eb$var$Au(this._cameraPosition, this._cameraPosition, [
            0,
            0,
            1
        ]), $785da19a645c07eb$var$ku(this._cameraPosition, this._cameraPosition, a, -this.center.lat * Math.PI / 180), $785da19a645c07eb$var$Su(this._cameraPosition, this._cameraPosition, a, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(e1);
        let r = $785da19a645c07eb$var$iu(this._globeViewProjMatrixF64Inverted);
        $785da19a645c07eb$var$ou(r, r, [
            1,
            1,
            -1
        ]), this._cachedFrustum = $785da19a645c07eb$var$$T.fromInvProjectionMatrix(r, 1, 0, this._cachedClippingPlane, !0);
    }
    calculateFogMatrix(e1) {
        $785da19a645c07eb$var$wh("calculateFogMatrix is not supported on globe projection.");
        let t = $785da19a645c07eb$var$Zu();
        return $785da19a645c07eb$var$nu(t), t;
    }
    getVisibleUnwrappedCoordinates(e1) {
        return [
            new $785da19a645c07eb$var$ZE(0, e1)
        ];
    }
    getCameraFrustum() {
        return this._cachedFrustum;
    }
    getClippingPlane() {
        return this._cachedClippingPlane;
    }
    getCoveringTilesDetailsProvider() {
        return this._coveringTilesDetailsProvider;
    }
    recalculateZoomAndCenter(e1) {
        e1 ? $785da19a645c07eb$var$wh("terrain is not fully supported on vertical perspective projection.") : this._helper.recalculateZoomAndCenter(0);
    }
    maxPitchScaleFactor() {
        return 1;
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return ($785da19a645c07eb$var$gu(this._cameraPosition) - 1) * $785da19a645c07eb$var$Sx;
    }
    getCameraLngLat() {
        let e1 = $785da19a645c07eb$var$Wu();
        return $785da19a645c07eb$var$xu(e1, this._cameraPosition), $785da19a645c07eb$var$eI(e1);
    }
    lngLatToCameraDepth(e1, t) {
        let i = $785da19a645c07eb$var$YP(e1);
        $785da19a645c07eb$var$vu(i, i, 1 + t / $785da19a645c07eb$var$Sx);
        let n = $785da19a645c07eb$var$Hu();
        return $785da19a645c07eb$var$Du(n, [
            i[0],
            i[1],
            i[2],
            1
        ], this._globeViewProjMatrixF64), n[2] / n[3];
    }
    populateCache(e1) {}
    getBounds() {
        let e1 = .5 * this.width, t = .5 * this.height, i = [
            new $785da19a645c07eb$var$Kc(0, 0),
            new $785da19a645c07eb$var$Kc(e1, 0),
            new $785da19a645c07eb$var$Kc(this.width, 0),
            new $785da19a645c07eb$var$Kc(this.width, t),
            new $785da19a645c07eb$var$Kc(this.width, this.height),
            new $785da19a645c07eb$var$Kc(e1, this.height),
            new $785da19a645c07eb$var$Kc(0, this.height),
            new $785da19a645c07eb$var$Kc(0, t)
        ], n = [];
        for (let e1 of i)n.push(this.unprojectScreenPoint(e1));
        let a = 0, r = 0, s = 0, o = 0, l = this.center;
        for (let e1 of n){
            let t = $785da19a645c07eb$var$th(l.lng, e1.lng), i = $785da19a645c07eb$var$th(l.lat, e1.lat);
            t < r && (r = t), t > a && (a = t), i < o && (o = i), i > s && (s = i);
        }
        let c = [
            l.lng + r,
            l.lat + o,
            l.lng + a,
            l.lat + s
        ];
        return this.isSurfacePointOnScreen([
            0,
            1,
            0
        ]) && (c[3] = 90, c[0] = -180, c[2] = 180), this.isSurfacePointOnScreen([
            0,
            -1,
            0
        ]) && (c[1] = -90, c[0] = -180, c[2] = 180), new $785da19a645c07eb$var$_T(c);
    }
    calculateCenterFromCameraLngLatAlt(e1, t, i, n) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, n);
    }
    calculateCameraOptionsFromTo(e1, t, i, n) {
        let a = $785da19a645c07eb$var$Mx.convert(i), r = $785da19a645c07eb$var$YP($785da19a645c07eb$var$Mx.convert(e1));
        $785da19a645c07eb$var$vu(r, r, 1 + t / $785da19a645c07eb$var$Sx);
        let s = $785da19a645c07eb$var$YP(a), o = $785da19a645c07eb$var$vu($785da19a645c07eb$var$Wu(), s, 1 + n / $785da19a645c07eb$var$Sx), l = $785da19a645c07eb$var$_u($785da19a645c07eb$var$Wu(), r, s), c = $785da19a645c07eb$var$gu(l);
        if (c < 1e-12 || function(e1, t) {
            var i = t[0] - e1[0], n = t[1] - e1[1], a = t[2] - e1[2];
            return Math.sqrt(i * i + n * n + a * a);
        }(r, o) < 1e-12) throw Error("Can't calculate camera options with same From and To");
        let u = $785da19a645c07eb$var$Wu();
        $785da19a645c07eb$var$Su(l, l, u, -$785da19a645c07eb$var$Dh(a.lng)), $785da19a645c07eb$var$ku(l, l, u, $785da19a645c07eb$var$Dh(a.lat));
        let h = $785da19a645c07eb$var$Ph(Math.acos($785da19a645c07eb$var$ch(l[2] / c, -1, 1))), d = Math.hypot(l[0], l[1]) < 1e-9 * c ? this.bearing : $785da19a645c07eb$var$Ph(Math.atan2(-l[0], -l[1]));
        return {
            center: a,
            elevation: n,
            zoom: $785da19a645c07eb$var$fh(this.cameraToCenterDistance / c / $785da19a645c07eb$var$JP(this.tileSize, a.lat)),
            pitch: h,
            bearing: d
        };
    }
    setLocationAtPoint(e1, t, i) {
        let n = $785da19a645c07eb$var$YP(this.unprojectScreenPoint(t)), a = $785da19a645c07eb$var$YP(e1), r = $785da19a645c07eb$var$Wu();
        !function(e1) {
            e1[0] = 0, e1[1] = 0, e1[2] = 0;
        }(r);
        let s = $785da19a645c07eb$var$Wu();
        $785da19a645c07eb$var$Su(s, n, r, -this.center.lng * Math.PI / 180), $785da19a645c07eb$var$ku(s, s, r, this.center.lat * Math.PI / 180);
        let o = a[0] * a[0] + a[2] * a[2], l = s[0] * s[0];
        if (o < l) return;
        let c = Math.sqrt(o - l), u = -c, h = $785da19a645c07eb$var$eh(a[0], a[2], s[0], c), d = $785da19a645c07eb$var$eh(a[0], a[2], s[0], u), p = $785da19a645c07eb$var$Wu();
        $785da19a645c07eb$var$Su(p, a, r, -h);
        let m = $785da19a645c07eb$var$eh(p[1], p[2], s[1], s[2]), g = $785da19a645c07eb$var$Wu();
        $785da19a645c07eb$var$Su(g, a, r, -d);
        let f, A, _ = $785da19a645c07eb$var$eh(g[1], g[2], s[1], s[2]), v = .5 * Math.PI, y = m >= -v && m <= v, x = _ >= -v && _ <= v;
        if (y && x) {
            let e1 = this.center.lng * Math.PI / 180, t = this.center.lat * Math.PI / 180;
            $785da19a645c07eb$var$ih(h, e1) + $785da19a645c07eb$var$ih(m, t) < $785da19a645c07eb$var$ih(d, e1) + $785da19a645c07eb$var$ih(_, t) ? (f = h, A = m) : (f = d, A = _);
        } else if (y) f = h, A = m;
        else {
            if (!x) return;
            f = d, A = _;
        }
        let b = f / Math.PI * 180, w = A / Math.PI * 180, E = this.center.lat;
        this.setCenter(new $785da19a645c07eb$var$Mx(b, $785da19a645c07eb$var$ch(w, -90, 90))), this.setZoom(this.zoom + $785da19a645c07eb$var$rI(E, this.center.lat));
    }
    locationToScreenPoint(e1, t) {
        let i = $785da19a645c07eb$var$YP(e1);
        if (t) $785da19a645c07eb$var$vu(i, i, 1 + t.getElevationForLngLatZoom(e1, this._helper._tileZoom) / $785da19a645c07eb$var$Sx);
        return this._projectSurfacePointToScreen(i);
    }
    _projectSurfacePointToScreen(e1) {
        let t = $785da19a645c07eb$var$Hu();
        return $785da19a645c07eb$var$Du(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], new $785da19a645c07eb$var$Kc((.5 * t[0] + .5) * this.width, (.5 * -t[1] + .5) * this.height);
    }
    screenPointToMercatorCoordinate(e1, t) {
        if (t) {
            let i = this.screenTerrainPointToMercatorCoordinate(e1, t);
            if (i) return i;
        }
        return $785da19a645c07eb$var$Lx.fromLngLat(this.unprojectScreenPoint(e1));
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        let i = t.getCoverageIndex();
        if (!i) return null;
        let n = this.cameraPosition, a = this.getRayDirectionFromPixel(e1), r = $785da19a645c07eb$var$cI(n, a, 1 + i.maxElevation / $785da19a645c07eb$var$Sx);
        if (!r) return null;
        let s = $785da19a645c07eb$var$cI(n, a, 1 + i.minElevation / $785da19a645c07eb$var$Sx), o = Math.max(r.tMin, 0), l = s ? s.tMin : r.tMax;
        if (l <= o) return null;
        let c = {
            index: i,
            exaggeration: t.exaggeration,
            origin: n,
            direction: a
        }, u = 0;
        for(let e1 = 0; e1 <= 256; e1++){
            let t = o + (l - o) * e1 / 256;
            if ($785da19a645c07eb$var$_I(c, t)) {
                let { hi: e1 } = $785da19a645c07eb$var$BP(c, $785da19a645c07eb$var$_I, u, t, 1e-12), { sample: i, mercator: n } = $785da19a645c07eb$var$AI(c, e1);
                return new $785da19a645c07eb$var$Lx(n.x, n.y, i.elevation);
            }
            u = t;
        }
        return null;
    }
    screenPointToLocation(e1, t) {
        return this.screenPointToMercatorCoordinate(e1, t)?.toLngLat();
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.screenPointToLocation(e1);
    }
    isPointOnMapSurface(e1, t) {
        return !!$785da19a645c07eb$var$cI(this._cameraPosition, this.getRayDirectionFromPixel(e1));
    }
    getRayDirectionFromPixel(e1) {
        let t = $785da19a645c07eb$var$Hu();
        t[0] = e1.x / this.width * 2 - 1, t[1] = -1 * (e1.y / this.height * 2 - 1), t[2] = 1, t[3] = 1, $785da19a645c07eb$var$Du(t, t, this._globeViewProjMatrixF64Inverted), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3];
        let i = $785da19a645c07eb$var$Wu();
        i[0] = t[0] - this._cameraPosition[0], i[1] = t[1] - this._cameraPosition[1], i[2] = t[2] - this._cameraPosition[2];
        let n = $785da19a645c07eb$var$Wu();
        return $785da19a645c07eb$var$xu(n, i), n;
    }
    isSurfacePointVisible(e1) {
        let t = this._cachedClippingPlane;
        return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3] >= 0;
    }
    isSurfacePointOnScreen(e1) {
        if (!this.isSurfacePointVisible(e1)) return !1;
        let t = $785da19a645c07eb$var$Hu();
        return $785da19a645c07eb$var$Du(t, [
            ...e1,
            1
        ], this._globeViewProjMatrixF64), t[0] /= t[3], t[1] /= t[3], t[2] /= t[3], t[0] > -1 && t[0] < 1 && t[1] > -1 && t[1] < 1 && t[2] > -1 && t[2] < 1;
    }
    unprojectScreenPoint(e1) {
        let t = this._cameraPosition, i = this.getRayDirectionFromPixel(e1), n = $785da19a645c07eb$var$cI(t, i);
        if (n) {
            let e1 = $785da19a645c07eb$var$Wu();
            $785da19a645c07eb$var$Au(e1, t, [
                i[0] * n.tMin,
                i[1] * n.tMin,
                i[2] * n.tMin
            ]);
            let a = $785da19a645c07eb$var$Wu();
            return $785da19a645c07eb$var$xu(a, e1), $785da19a645c07eb$var$eI(a);
        }
        let a = this._cachedClippingPlane, r = a[0] * i[0] + a[1] * i[1] + a[2] * i[2], s = -$785da19a645c07eb$var$Yu(a, t) / r, o = $785da19a645c07eb$var$Wu();
        if (s > 0) $785da19a645c07eb$var$Au(o, t, [
            i[0] * s,
            i[1] * s,
            i[2] * s
        ]);
        else {
            let e1 = $785da19a645c07eb$var$Wu();
            $785da19a645c07eb$var$Au(e1, t, [
                2 * i[0],
                2 * i[1],
                2 * i[2]
            ]);
            let n = $785da19a645c07eb$var$Yu(this._cachedClippingPlane, e1);
            $785da19a645c07eb$var$Cu(o, e1, [
                this._cachedClippingPlane[0] * n,
                this._cachedClippingPlane[1] * n,
                this._cachedClippingPlane[2] * n
            ]);
        }
        let l = function(e1) {
            let t = $785da19a645c07eb$var$Wu();
            return t[0] = e1[0] * -e1[3], t[1] = e1[1] * -e1[3], t[2] = e1[2] * -e1[3], {
                center: t,
                radius: Math.sqrt(1 - e1[3] * e1[3])
            };
        }(a);
        return $785da19a645c07eb$var$eI(function(e1, t, i) {
            let n = $785da19a645c07eb$var$Wu();
            $785da19a645c07eb$var$Cu(n, i, e1);
            let a = $785da19a645c07eb$var$Wu();
            return $785da19a645c07eb$var$yu(a, e1, n, t / $785da19a645c07eb$var$Tu(n)), a;
        }(l.center, l.radius, o));
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this.getProjectionData({
            overscaledTileID: new $785da19a645c07eb$var$KE(0, 0, 0, 0, 0),
            applyGlobeMatrix: e1
        });
        return t.tileMercatorCoords = [
            0,
            0,
            1,
            1
        ], t;
    }
    getFastPathSimpleProjectionMatrix(e1) {}
};
function $785da19a645c07eb$var$AI(e1, t) {
    let i = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$yu(i, e1.origin, e1.direction, t);
    let n = $785da19a645c07eb$var$gu(i), a = $785da19a645c07eb$var$Wu();
    $785da19a645c07eb$var$vu(a, i, 1 / n);
    let r = $785da19a645c07eb$var$eI(a), s = $785da19a645c07eb$var$Lx.fromLngLat(r), o = new $785da19a645c07eb$var$Lx(s.x, $785da19a645c07eb$var$ch(s.y, 0, .999999999)), l = $785da19a645c07eb$var$RP(e1.index, e1.exaggeration, o.x, o.y), c = Math.abs(r.lat) > 85.051129 ? 0 : l.elevation;
    return {
        sample: {
            ...l,
            elevation: c
        },
        radius: n,
        mercator: o
    };
}
function $785da19a645c07eb$var$_I(e1, t) {
    let { sample: i, radius: n } = $785da19a645c07eb$var$AI(e1, t);
    return $785da19a645c07eb$var$LP(i, (n - 1) * $785da19a645c07eb$var$Sx);
}
var $785da19a645c07eb$var$vI = class e1 {
    get pixelsToClipSpaceMatrix() {
        return this._helper.pixelsToClipSpaceMatrix;
    }
    get clipSpaceToPixelsMatrix() {
        return this._helper.clipSpaceToPixelsMatrix;
    }
    get pixelsToGLUnits() {
        return this._helper.pixelsToGLUnits;
    }
    get centerOffset() {
        return this._helper.centerOffset;
    }
    get size() {
        return this._helper.size;
    }
    get rotationMatrix() {
        return this._helper.rotationMatrix;
    }
    get centerPoint() {
        return this._helper.centerPoint;
    }
    get pixelsPerMeter() {
        return this._helper.pixelsPerMeter;
    }
    setMinZoom(e1) {
        this._helper.setMinZoom(e1);
    }
    setMaxZoom(e1) {
        this._helper.setMaxZoom(e1);
    }
    setMinPitch(e1) {
        this._helper.setMinPitch(e1);
    }
    setMaxPitch(e1) {
        this._helper.setMaxPitch(e1);
    }
    setRenderWorldCopies(e1) {
        this._helper.setRenderWorldCopies(e1);
    }
    setBearing(e1) {
        this._helper.setBearing(e1);
    }
    setPitch(e1) {
        this._helper.setPitch(e1);
    }
    setRoll(e1) {
        this._helper.setRoll(e1);
    }
    setFov(e1) {
        this._helper.setFov(e1);
    }
    setZoom(e1) {
        this._helper.setZoom(e1);
    }
    setCenter(e1) {
        this._helper.setCenter(e1);
    }
    setElevation(e1) {
        this._helper.setElevation(e1);
    }
    setMinElevationForCurrentTile(e1) {
        this._helper.setMinElevationForCurrentTile(e1);
    }
    setPadding(e1) {
        this._helper.setPadding(e1);
    }
    interpolatePadding(e1, t, i) {
        this._helper.interpolatePadding(e1, t, i);
    }
    isPaddingEqual(e1) {
        return this._helper.isPaddingEqual(e1);
    }
    resize(e1, t, i = !0) {
        this._helper.resize(e1, t, i);
    }
    getMaxBounds() {
        return this._helper.getMaxBounds();
    }
    setMaxBounds(e1) {
        this._helper.setMaxBounds(e1);
    }
    setConstrainOverride(e1) {
        this._helper.setConstrainOverride(e1);
    }
    overrideNearFarZ(e1, t) {
        this._helper.overrideNearFarZ(e1, t);
    }
    clearNearFarZOverride() {
        this._helper.clearNearFarZOverride();
    }
    getCameraQueryGeometry(e1) {
        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
    }
    get tileSize() {
        return this._helper.tileSize;
    }
    get tileZoom() {
        return this._helper.tileZoom;
    }
    get scale() {
        return this._helper.scale;
    }
    get worldSize() {
        return this._helper.worldSize;
    }
    get width() {
        return this._helper.width;
    }
    get height() {
        return this._helper.height;
    }
    get lngRange() {
        return this._helper.lngRange;
    }
    get latRange() {
        return this._helper.latRange;
    }
    get minZoom() {
        return this._helper.minZoom;
    }
    get maxZoom() {
        return this._helper.maxZoom;
    }
    get zoom() {
        return this._helper.zoom;
    }
    get center() {
        return this._helper.center;
    }
    get minPitch() {
        return this._helper.minPitch;
    }
    get maxPitch() {
        return this._helper.maxPitch;
    }
    get pitch() {
        return this._helper.pitch;
    }
    get pitchInRadians() {
        return this._helper.pitchInRadians;
    }
    get roll() {
        return this._helper.roll;
    }
    get rollInRadians() {
        return this._helper.rollInRadians;
    }
    get bearing() {
        return this._helper.bearing;
    }
    get bearingInRadians() {
        return this._helper.bearingInRadians;
    }
    get fov() {
        return this._helper.fov;
    }
    get fovInRadians() {
        return this._helper.fovInRadians;
    }
    get elevation() {
        return this._helper.elevation;
    }
    get minElevationForCurrentTile() {
        return this._helper.minElevationForCurrentTile;
    }
    get padding() {
        return this._helper.padding;
    }
    get unmodified() {
        return this._helper.unmodified;
    }
    get renderWorldCopies() {
        return this._helper.renderWorldCopies;
    }
    get cameraToCenterDistance() {
        return this._helper.cameraToCenterDistance;
    }
    get constrainOverride() {
        return this._helper.constrainOverride;
    }
    get nearZ() {
        return this._helper.nearZ;
    }
    get farZ() {
        return this._helper.farZ;
    }
    get autoCalculateNearFarZ() {
        return this._helper.autoCalculateNearFarZ;
    }
    get isGlobeRendering() {
        return this._globeness > 0;
    }
    setTransitionState(e1) {
        this._globeness = e1, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
    }
    get currentTransform() {
        return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
    }
    constructor(e1){
        this._globeness = 1, this.defaultConstrain = (e1, t)=>this.currentTransform.defaultConstrain(e1, t), this.applyConstrain = (e1, t)=>this._helper.applyConstrain(e1, t), this._helper = new $785da19a645c07eb$var$CP({
            calcMatrices: ()=>this._calcMatrices(),
            defaultConstrain: (e1, t)=>this.defaultConstrain(e1, t)
        }, e1), this._globeness = 1, this._mercatorTransform = new $785da19a645c07eb$var$OP, this._verticalPerspectiveTransform = new $785da19a645c07eb$var$fI;
    }
    clone() {
        let t = new e1;
        return t._globeness = this._globeness, t.apply(this, !1), t;
    }
    apply(e1, t) {
        this._helper.apply(e1, t), this._mercatorTransform.apply(this, !1), this._verticalPerspectiveTransform.apply(this, !1);
    }
    get projectionMatrix() {
        return this.currentTransform.projectionMatrix;
    }
    get modelViewProjectionMatrix() {
        return this.currentTransform.modelViewProjectionMatrix;
    }
    get inverseProjectionMatrix() {
        return this.currentTransform.inverseProjectionMatrix;
    }
    get cameraPosition() {
        return this.currentTransform.cameraPosition;
    }
    getProjectionData(e1) {
        let t = this._mercatorTransform.getProjectionData(e1), i = this._verticalPerspectiveTransform.getProjectionData(e1);
        return {
            mainMatrix: this.isGlobeRendering ? i.mainMatrix : t.mainMatrix,
            clippingPlane: i.clippingPlane,
            tileMercatorCoords: i.tileMercatorCoords,
            projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
            fallbackMatrix: t.fallbackMatrix,
            clipAntimeridian: i.clipAntimeridian
        };
    }
    isLocationOccluded(e1) {
        return this.currentTransform.isLocationOccluded(e1);
    }
    transformLightDirection(e1) {
        return this.currentTransform.transformLightDirection(e1);
    }
    getPixelScale() {
        return $785da19a645c07eb$var$rh(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
    }
    getCircleRadiusCorrection() {
        return $785da19a645c07eb$var$rh(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
    }
    getPitchedTextCorrection(e1, t, i) {
        return $785da19a645c07eb$var$rh(this._mercatorTransform.getPitchedTextCorrection(e1, t, i), this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, t, i), this._globeness);
    }
    projectTileCoordinates(e1, t, i, n) {
        return this.currentTransform.projectTileCoordinates(e1, t, i, n);
    }
    _calcMatrices() {
        this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, !1), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
    }
    calculateFogMatrix(e1) {
        return this.currentTransform.calculateFogMatrix(e1);
    }
    getVisibleUnwrappedCoordinates(e1) {
        return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
    }
    getCameraFrustum() {
        return this.currentTransform.getCameraFrustum();
    }
    getClippingPlane() {
        return this.currentTransform.getClippingPlane();
    }
    getCoveringTilesDetailsProvider() {
        return this.currentTransform.getCoveringTilesDetailsProvider();
    }
    recalculateZoomAndCenter(e1) {
        this.currentTransform.recalculateZoomAndCenter(e1);
    }
    maxPitchScaleFactor() {
        return this._mercatorTransform.maxPitchScaleFactor();
    }
    getCameraPoint() {
        return this._helper.getCameraPoint();
    }
    getCameraAltitude() {
        return this.currentTransform.getCameraAltitude();
    }
    getCameraLngLat() {
        return this.currentTransform.getCameraLngLat();
    }
    lngLatToCameraDepth(e1, t) {
        return this.currentTransform.lngLatToCameraDepth(e1, t);
    }
    populateCache(e1) {
        this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
    }
    getBounds() {
        return this.currentTransform.getBounds();
    }
    calculateCenterFromCameraLngLatAlt(e1, t, i, n) {
        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, n);
    }
    calculateCameraOptionsFromTo(e1, t, i, n) {
        return this.currentTransform.calculateCameraOptionsFromTo(e1, t, i, n);
    }
    setLocationAtPoint(e1, t, i) {
        if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e1, t, i), void this.apply(this._mercatorTransform, !1);
        this._verticalPerspectiveTransform.setLocationAtPoint(e1, t, i), this.apply(this._verticalPerspectiveTransform, !1);
    }
    locationToScreenPoint(e1, t) {
        return this.currentTransform.locationToScreenPoint(e1, t);
    }
    screenPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
    }
    screenTerrainPointToMercatorCoordinate(e1, t) {
        return this.currentTransform.screenTerrainPointToMercatorCoordinate(e1, t);
    }
    screenPointToLocation(e1, t) {
        return this.currentTransform.screenPointToLocation(e1, t);
    }
    screenPointToLocationAtElevation(e1, t) {
        return this.currentTransform.screenPointToLocationAtElevation(e1, t);
    }
    isPointOnMapSurface(e1, t) {
        return this.currentTransform.isPointOnMapSurface(e1, t);
    }
    getRayDirectionFromPixel(e1) {
        return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
    }
    getProjectionDataForCustomLayer(e1 = !0) {
        let t = this._mercatorTransform.getProjectionDataForCustomLayer(e1);
        if (!this.isGlobeRendering) return t;
        let i = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(e1);
        return i.fallbackMatrix = t.mainMatrix, i.projectionTransition = this._globeness, i;
    }
    getFastPathSimpleProjectionMatrix(e1) {
        return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
    }
}, $785da19a645c07eb$var$yI = class e1 {
    get useGlobeControls() {
        return !0;
    }
    handlePanInertia(e1, t) {
        let i = $785da19a645c07eb$var$sI(e1, t);
        return Math.abs(i.lng - t.center.lng) > 180 && (i.lng = t.center.lng + 179.5 * Math.sign(i.lng - t.center.lng)), {
            easingCenter: i,
            easingOffset: new $785da19a645c07eb$var$Kc(0, 0)
        };
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        let i = e1.around, n = t.screenPointToLocation(i);
        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta);
        let a = t.zoom;
        e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
        let r = t.zoom - a;
        if (0 === r) return;
        let s = $785da19a645c07eb$var$th(t.center.lng, n.lng), o = s / (Math.abs(s / 180) + 1), l = $785da19a645c07eb$var$th(t.center.lat, n.lat), c = t.getRayDirectionFromPixel(i), u = t.cameraPosition, h = -1 * $785da19a645c07eb$var$bu(u, c), d = $785da19a645c07eb$var$Wu();
        $785da19a645c07eb$var$Au(d, u, [
            c[0] * h,
            c[1] * h,
            c[2] * h
        ]);
        let p = $785da19a645c07eb$var$gu(d), m = p - 1, g = Math.exp(.5 * -Math.max(m - .3, 0)), f = $785da19a645c07eb$var$ah(p, .95, .999, 0, 1), A = $785da19a645c07eb$var$ah($785da19a645c07eb$var$JP(t.worldSize, t.center.lat) / Math.min(t.width, t.height), .9, .5, 1, .25), _ = Math.min(g, $785da19a645c07eb$var$rh(1, A, f)), v = (1 - $785da19a645c07eb$var$gh(-r)) * _, y = t.center.lat, x = t.zoom, b = new $785da19a645c07eb$var$Mx(t.center.lng + o * v, $785da19a645c07eb$var$ch(t.center.lat + l * v, -$785da19a645c07eb$var$Rh, $785da19a645c07eb$var$Rh));
        t.setLocationAtPoint(n, i);
        let w = t.center, E = $785da19a645c07eb$var$ah(Math.abs(s), 45, 85, 0, 1), k = Math.max(E, f) ** .25, S = $785da19a645c07eb$var$th(w.lng, b.lng), M = $785da19a645c07eb$var$th(w.lat, b.lat);
        t.setCenter(new $785da19a645c07eb$var$Mx(w.lng + S * k, w.lat + M * k).wrap()), t.setZoom(x + $785da19a645c07eb$var$rI(y, t.center.lat));
    }
    handleMapControlsPan(e1, t, i) {
        e1.panDelta && $785da19a645c07eb$var$nI(t, i, t.isPointOnMapSurface(e1.around) ? e1.around : t.centerPoint, e1.panDelta);
    }
    cameraForBoxAndBearing(t, i, n, a, r) {
        let s = $785da19a645c07eb$var$qP(t, i, n, a, r), o = i.left / r.width * 2 - 1, l = (r.width - i.right) / r.width * 2 - 1, c = i.top / r.height * -2 + 1, u = (r.height - i.bottom) / r.height * -2 + 1, h = $785da19a645c07eb$var$th(n.getWest(), n.getEast()) < 0, d = h ? n.getEast() : n.getWest(), p = h ? n.getWest() : n.getEast(), m = Math.max(n.getNorth(), n.getSouth()), g = Math.min(n.getNorth(), n.getSouth()), f = d + .5 * $785da19a645c07eb$var$th(d, p), A = m + .5 * $785da19a645c07eb$var$th(m, g), _ = r.clone();
        _.setCenter(s.center), _.setBearing(s.bearing), _.setPitch(0), _.setRoll(0), _.setZoom(s.zoom);
        let v = _.modelViewProjectionMatrix, y = [
            $785da19a645c07eb$var$YP(n.getNorthWest()),
            $785da19a645c07eb$var$YP(n.getNorthEast()),
            $785da19a645c07eb$var$YP(n.getSouthWest()),
            $785da19a645c07eb$var$YP(n.getSouthEast()),
            $785da19a645c07eb$var$YP(new $785da19a645c07eb$var$Mx(p, A)),
            $785da19a645c07eb$var$YP(new $785da19a645c07eb$var$Mx(d, A)),
            $785da19a645c07eb$var$YP(new $785da19a645c07eb$var$Mx(f, m)),
            $785da19a645c07eb$var$YP(new $785da19a645c07eb$var$Mx(f, g))
        ], x = $785da19a645c07eb$var$YP(s.center), b = 1 / 0;
        for (let t of y)o < 0 && (b = e1.getLesserNonNegativeNonNull(b, e1.solveVectorScale(t, x, v, "x", o))), l > 0 && (b = e1.getLesserNonNegativeNonNull(b, e1.solveVectorScale(t, x, v, "x", l))), c > 0 && (b = e1.getLesserNonNegativeNonNull(b, e1.solveVectorScale(t, x, v, "y", c))), u < 0 && (b = e1.getLesserNonNegativeNonNull(b, e1.solveVectorScale(t, x, v, "y", u)));
        if (Number.isFinite(b) && 0 !== b) return s.zoom = Math.min(_.zoom + $785da19a645c07eb$var$fh(b), t.maxZoom), s;
        $785da19a645c07eb$var$jP();
    }
    handleJumpToCenterZoom(e1, t) {
        let i = e1.center.lat, n = e1.applyConstrain(t.center ? $785da19a645c07eb$var$Mx.convert(t.center) : e1.center, e1.zoom).center;
        e1.setCenter(n.wrap());
        let a = void 0 === t.zoom ? e1.zoom + $785da19a645c07eb$var$rI(i, n.lat) : +t.zoom;
        e1.zoom !== a && e1.setZoom(a);
    }
    handleEaseTo(e1, t) {
        let i = e1.zoom, n = e1.center, a = e1.padding, r = {
            roll: e1.roll,
            pitch: e1.pitch,
            bearing: e1.bearing
        }, s = {
            roll: void 0 === t.roll ? e1.roll : t.roll,
            pitch: void 0 === t.pitch ? e1.pitch : t.pitch,
            bearing: void 0 === t.bearing ? e1.bearing : t.bearing
        }, o = void 0 !== t.zoom, l = !e1.isPaddingEqual(t.padding), c = !1, u = t.center ? $785da19a645c07eb$var$Mx.convert(t.center) : n, h = e1.applyConstrain(u, i).center;
        $785da19a645c07eb$var$SP(e1, h);
        let d = e1.clone();
        d.setCenter(h), d.setZoom(o ? +t.zoom : i + $785da19a645c07eb$var$rI(n.lat, u.lat)), d.setBearing(t.bearing);
        let p = new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$ch(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), $785da19a645c07eb$var$ch(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        d.setLocationAtPoint(h, p);
        let m = (t.offset && t.offsetAsPoint.mag()) > 0 ? d.center : h, g = o ? +t.zoom : i + $785da19a645c07eb$var$rI(n.lat, m.lat), f = i + $785da19a645c07eb$var$rI(n.lat, 0), A = g + $785da19a645c07eb$var$rI(m.lat, 0), _ = $785da19a645c07eb$var$th(n.lng, m.lng), v = $785da19a645c07eb$var$th(n.lat, m.lat), y = $785da19a645c07eb$var$gh(A - f);
        return c = g !== i, {
            easeFunc: (i)=>{
                if ($785da19a645c07eb$var$Ih(r, s) || $785da19a645c07eb$var$VP({
                    startEulerAngles: r,
                    endEulerAngles: s,
                    tr: e1,
                    k: i,
                    useSlerp: r.roll != s.roll
                }), l && e1.interpolatePadding(a, t.padding, i), t.around) $785da19a645c07eb$var$wh("Easing around a point is not supported under globe projection."), e1.setLocationAtPoint(t.around, t.aroundPoint);
                else {
                    let t = i * (A > f ? Math.min(2, y) : Math.max(.5, y)) ** (1 - i), a = $785da19a645c07eb$var$lI(n, _, v, t);
                    e1.setCenter(a.wrap());
                }
                if (c) {
                    let t = $785da19a645c07eb$var$Mp.number(f, A, i) + $785da19a645c07eb$var$rI(0, e1.center.lat);
                    e1.setZoom(t);
                }
            },
            isZooming: c,
            elevationCenter: m
        };
    }
    handleFlyTo(e1, t) {
        let i = void 0 !== t.zoom, n = e1.center, a = e1.zoom, r = e1.padding, s = !e1.isPaddingEqual(t.padding), o = e1.applyConstrain($785da19a645c07eb$var$Mx.convert(t.center || t.locationAtOffset), a).center, l = i ? +t.zoom : e1.zoom + $785da19a645c07eb$var$rI(e1.center.lat, o.lat), c = e1.clone();
        c.setCenter(o), c.setZoom(l), c.setBearing(t.bearing);
        let u = new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$ch(e1.centerPoint.x + t.offsetAsPoint.x, 0, e1.width), $785da19a645c07eb$var$ch(e1.centerPoint.y + t.offsetAsPoint.y, 0, e1.height));
        c.setLocationAtPoint(o, u);
        let h = c.center;
        $785da19a645c07eb$var$SP(e1, h);
        let d = function(e1, t, i) {
            let n = $785da19a645c07eb$var$bu($785da19a645c07eb$var$YP(t), $785da19a645c07eb$var$YP(i)), a = Math.acos(n), r = $785da19a645c07eb$var$XP(e1);
            return a / (2 * Math.PI) * r;
        }(e1, n, h), p = a + $785da19a645c07eb$var$rI(n.lat, 0), m = l + $785da19a645c07eb$var$rI(h.lat, 0), g = $785da19a645c07eb$var$gh(m - p), f = "number" == typeof t.minZoom ? +t.minZoom : e1.minZoom, A = Math.max(f, e1.minZoom) + $785da19a645c07eb$var$rI(h.lat, 0), _ = Math.min(A, p, m) + $785da19a645c07eb$var$rI(0, h.lat), v = $785da19a645c07eb$var$gh(e1.applyConstrain(h, _).zoom + $785da19a645c07eb$var$rI(h.lat, 0) - p), y = $785da19a645c07eb$var$th(n.lng, h.lng), x = $785da19a645c07eb$var$th(n.lat, h.lat);
        return {
            easeFunc: (i, a, o, c)=>{
                let u = $785da19a645c07eb$var$lI(n, y, x, o);
                s && e1.interpolatePadding(r, t.padding, i);
                let d = 1 === i ? h : u;
                e1.setCenter(d.wrap());
                let m = p + $785da19a645c07eb$var$fh(a);
                e1.setZoom(1 === i ? l : m + $785da19a645c07eb$var$rI(0, d.lat));
            },
            scaleOfZoom: g,
            targetCenter: h,
            scaleOfMinZoom: v,
            pixelPathLength: d
        };
    }
    static solveVectorScale(e1, t, i, n, a) {
        let r = a, s = "x" === n ? [
            i[0],
            i[4],
            i[8],
            i[12]
        ] : [
            i[1],
            i[5],
            i[9],
            i[13]
        ], o = [
            i[3],
            i[7],
            i[11],
            i[15]
        ], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], c = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], u = t[0] * s[0] + t[1] * s[1] + t[2] * s[2], h = t[0] * o[0] + t[1] * o[1] + t[2] * o[2];
        return u + r * c === l + r * h || o[3] * (l - u) + s[3] * (h - c) + l * h === u * c ? null : (u + s[3] - r * h - r * o[3]) / (u - l - r * h + r * c);
    }
    static getLesserNonNegativeNonNull(e1, t) {
        return null !== t && t >= 0 && t < e1 ? t : e1;
    }
}, $785da19a645c07eb$var$xI = class {
    constructor(e1){
        this._globe = e1, this._mercatorCameraHelper = new $785da19a645c07eb$var$GP, this._verticalPerspectiveCameraHelper = new $785da19a645c07eb$var$yI;
    }
    get useGlobeControls() {
        return this._globe.useGlobeRendering;
    }
    get currentHelper() {
        return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
    }
    handlePanInertia(e1, t) {
        return this.currentHelper.handlePanInertia(e1, t);
    }
    handleMapControlsRollPitchBearingZoom(e1, t) {
        this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
    }
    handleMapControlsPan(e1, t, i) {
        this.currentHelper.handleMapControlsPan(e1, t, i);
    }
    cameraForBoxAndBearing(e1, t, i, n, a) {
        return this.currentHelper.cameraForBoxAndBearing(e1, t, i, n, a);
    }
    handleJumpToCenterZoom(e1, t) {
        this.currentHelper.handleJumpToCenterZoom(e1, t);
    }
    handleEaseTo(e1, t) {
        return this.currentHelper.handleEaseTo(e1, t);
    }
    handleFlyTo(e1, t) {
        return this.currentHelper.handleFlyTo(e1, t);
    }
};
const $785da19a645c07eb$var$bI = function() {
    let e1 = {}, t = $785da19a645c07eb$var$od.$version;
    for(let i in $785da19a645c07eb$var$od.$root){
        let n = $785da19a645c07eb$var$od.$root[i];
        if (n.required) {
            let a = null;
            a = "version" === i ? t : "array" === n.type ? [] : {}, null != a && (e1[i] = a);
        }
    }
    return e1;
}();
var $785da19a645c07eb$var$wI = class extends $785da19a645c07eb$var$rd {
    constructor(e1, t = {}){
        super(), this._rtlPluginLoaded = ()=>{
            for(let e1 in this.tileManagers){
                let t = this.tileManagers[e1].getSource().type;
                ("vector" === t || "geojson" === t) && this.tileManagers[e1].reload();
            }
        }, this.map = e1, this.dispatcher = new $785da19a645c07eb$var$uT($785da19a645c07eb$var$cT(), e1._getMapId()), this.dispatcher.registerMessageHandler("GG", (e1, t)=>this.getGlyphs(e1, t)), this.dispatcher.registerMessageHandler("GI", (e1, t)=>this.getImages(e1, t)), this.dispatcher.registerMessageHandler("GDA", (e1, t)=>this.getDashes(e1, t)), this.imageManager = new $785da19a645c07eb$var$LC, this.imageManager.setEventedParent(this), this.imageManager.setMissingImageResolver(e1._missingStyleImageResolver), this.patternAtlas = new $785da19a645c07eb$var$BC(this.imageManager);
        let i = e1._container?.lang || typeof document < "u" && document.documentElement?.lang || void 0;
        this.glyphManager = new $785da19a645c07eb$var$JC(e1._requestManager, t.localIdeographFontFamily, i), this.lineAtlas = new $785da19a645c07eb$var$nT(256, 512), this.crossTileSymbolIndex = new $785da19a645c07eb$var$_P, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast("SR", $785da19a645c07eb$var$Qh()), $785da19a645c07eb$var$KT().on($785da19a645c07eb$var$HT, this._rtlPluginLoaded), this.on("data", (e1)=>{
            if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
            let t = this.tileManagers[e1.sourceId];
            if (!t) return;
            let i = t.getSource();
            if (i?.vectorLayerIds) for(let e1 in this._layers){
                let t = this._layers[e1];
                t.source === i.id && this._validateLayer(t);
            }
        });
    }
    _setInitialValues() {
        this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new $785da19a645c07eb$var$Xf, this._imagesListDirty = !1, this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this._symbolPlacementTriggered = !1, this._placedProjectionTransition = void 0, this.crossTileSymbolIndex = new (this.crossTileSymbolIndex?.constructor || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
    }
    setGlobalStateProperty(e1, t) {
        this._checkLoaded();
        let i = null === t ? this.stylesheet.state?.[e1]?.default ?? null : t;
        if ($785da19a645c07eb$var$yh(i, this._globalState[e1])) return this;
        this._globalState[e1] = i, this._applyGlobalStateChanges([
            e1
        ]);
    }
    getGlobalState() {
        return this._globalState;
    }
    setGlobalState(e1) {
        this._checkLoaded();
        let t = [];
        for(let i in e1)$785da19a645c07eb$var$yh(this._globalState[i], e1[i].default) || (t.push(i), this._globalState[i] = e1[i].default);
        this._applyGlobalStateChanges(t);
    }
    _applyGlobalStateChanges(e1) {
        if (0 === e1.length) return;
        let t = new Set, i = {};
        for (let n of e1){
            i[n] = this._globalState[n];
            for(let e1 in this._layers){
                let i = this._layers[e1], a = i.getLayoutAffectingGlobalStateRefs(), r = i.getPaintAffectingGlobalStateRefs(), s = i.getVisibilityAffectingGlobalStateRefs();
                if (a.has(n) && t.add(i.source), r.has(n)) for (let { name: e1, value: t } of r.get(n))this._updatePaintProperty(i, e1, t);
                s?.has(n) && (i.recalculateVisibility(), this._updateLayer(i));
            }
        }
        this.dispatcher.broadcast("UGS", i);
        for(let e1 in this.tileManagers)t.has(e1) && (this._reloadSource(e1), this._changed = !0);
    }
    async loadURL(e1, t = {}, i) {
        this.fire(new $785da19a645c07eb$var$hC("dataloading")), t.validate = "boolean" != typeof t.validate || t.validate, this._loadStyleRequest = new AbortController;
        let n = this._loadStyleRequest;
        try {
            let a = await this.map._requestManager.transformRequest(e1, "Style");
            $785da19a645c07eb$var$Gh(n.signal);
            let r = await $785da19a645c07eb$var$Jh(a, n);
            this._loadStyleRequest === n && (this._loadStyleRequest = null), this._load(r.data, t, i);
        } catch (e1) {
            this._loadStyleRequest === n && (this._loadStyleRequest = null), e1 && !n.signal.aborted && this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
        }
    }
    loadJSON(e1, t = {}, i) {
        this.fire(new $785da19a645c07eb$var$hC("dataloading")), this._frameRequest = new AbortController, $785da19a645c07eb$var$iC.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
            this._frameRequest = null, t.validate = !1 !== t.validate, this._load(e1, t, i);
        }).catch(()=>{});
    }
    loadEmpty() {
        this.fire(new $785da19a645c07eb$var$hC("dataloading")), this._load($785da19a645c07eb$var$bI, {
            validate: !1
        });
    }
    _load(e1, t, i) {
        let n = t.transformStyle ? t.transformStyle(i, e1) : e1;
        if (!t.validate || !$785da19a645c07eb$var$Of(this, n)) {
            n = {
                ...n
            }, this._loaded = !0, this.stylesheet = n;
            for(let e1 in n.sources)this.addSource(e1, n.sources[e1], {
                validate: !1
            });
            n.sprite ? this._loadSprite(n.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(n.glyphs), this.glyphManager.setFontFaces(n["font-faces"]), this._createLayers(), this.light = new $785da19a645c07eb$var$eT(this.stylesheet.light ?? {}, this._globalState), this._setProjectionInternal(this.stylesheet.projection?.type || "mercator"), this.sky = new $785da19a645c07eb$var$iT(this.stylesheet.sky, this._globalState), this.map.setTerrain(this.stylesheet.terrain ?? null, {
                validate: !1
            }), this.fire(new $785da19a645c07eb$var$hC("data")), this.fire(new $785da19a645c07eb$var$uC);
        }
    }
    _createLayers() {
        let e1 = $785da19a645c07eb$var$bC(this.stylesheet.layers);
        this.setGlobalState(this.stylesheet.state ?? null), this.dispatcher.broadcast("SL", e1), this._order = e1.map((e1)=>e1.id), this._layers = {}, this._serializedLayers = null;
        for (let t of e1){
            let e1 = $785da19a645c07eb$var$jE(t, this._globalState);
            if (e1.setEventedParent(this, {
                layer: {
                    id: t.id
                }
            }), this._layers[t.id] = e1, $785da19a645c07eb$var$vA(e1) && this.tileManagers[e1.source]) {
                let i = t.paint?.["raster-fade-duration"] ?? e1.paint.get("raster-fade-duration");
                this.tileManagers[e1.source].setRasterFadeDuration(i);
            }
        }
    }
    async _loadSprite(e1, t = !1, i) {
        this.imageManager.setLoaded(!1);
        let n, a = new AbortController;
        this._spriteRequest = a;
        try {
            let i = await $785da19a645c07eb$var$RC(e1, this.map._requestManager, this.map.getPixelRatio(), a);
            if (!i) return;
            for(let e1 in i){
                let { loaded: n, removed: a } = this.imageManager.setSpriteImages(e1, i[e1]);
                this._markImagesChanged(a), t && this._markImagesChanged(n);
            }
        } catch (e1) {
            n = e1, a.signal.aborted || this.fire(new $785da19a645c07eb$var$ad(n));
        } finally{
            this._spriteRequest = null, this.imageManager.setLoaded(!0), t && (this._changed = !0), this.dispatcher.broadcast("SI", this.imageManager.listImages()), this.fire(new $785da19a645c07eb$var$hC("data")), i?.(n);
        }
    }
    _unloadSprite() {
        this._markImagesChanged(this.imageManager.removeAllSpriteImages()), this._imagesListDirty = !0, this._changed = !0, this.fire(new $785da19a645c07eb$var$hC("data"));
    }
    _validateLayer(e1) {
        let t = this.tileManagers[e1.source];
        if (!t) return;
        let i = e1.sourceLayer;
        if (!i) return;
        let n = t.getSource();
        ("geojson" === n.type || n.vectorLayerIds && !n.vectorLayerIds.includes(i)) && this.fire(new $785da19a645c07eb$var$ad(Error(`Source layer "${i}" does not exist on source "${n.id}" as specified by style layer "${e1.id}".`)));
    }
    loaded() {
        if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
        for(let e1 in this.tileManagers)if (!this.tileManagers[e1].loaded()) return !1;
        return this.imageManager.isLoaded();
    }
    _serializeByIds(e1, t = !1) {
        let i = this._serializedAllLayers();
        if (!e1 || 0 === e1.length) return Object.values(t ? $785da19a645c07eb$var$xh(i) : i);
        let n = [];
        for (let a of e1)if (i[a]) {
            let e1 = t ? $785da19a645c07eb$var$xh(i[a]) : i[a];
            n.push(e1);
        }
        return n;
    }
    _serializedAllLayers() {
        let e1 = this._serializedLayers;
        if (e1) return e1;
        e1 = this._serializedLayers = {};
        let t = Object.keys(this._layers);
        for (let i of t){
            let t = this._layers[i];
            "custom" !== t.type && (e1[i] = t.serialize());
        }
        return e1;
    }
    hasTransitions() {
        if (this.light?.hasTransition() || this.sky?.hasTransition() || this.projection?.hasTransition()) return !0;
        for(let e1 in this.tileManagers)if (this.tileManagers[e1].hasTransition()) return !0;
        for(let e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
        return !1;
    }
    _checkLoaded() {
        if (!this._loaded) throw Error("Style is not done loading.");
    }
    update(e1) {
        if (!this._loaded) return;
        let t = this._changed;
        if (t) {
            this._imagesListDirty &&= (this.dispatcher.broadcast("SI", this.imageManager.listImages()), !1);
            let t = Object.keys(this._updatedLayers), i = Object.keys(this._removedLayers);
            (t.length || i.length) && this._updateWorkerLayers(t, i);
            for(let e1 in this._updatedSources){
                let t = this._updatedSources[e1];
                if ("reload" === t) this._reloadSource(e1);
                else {
                    if ("clear" !== t) throw Error(`Invalid action ${t}`);
                    this._clearSource(e1);
                }
            }
            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
            for(let t in this._updatedPaintProps)this._layers[t].updateTransitions(e1);
            this._resetUpdates();
        }
        let i = {};
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            i[e1] = t.used, t.used = !1;
        }
        let n = this.imageManager.listImages();
        for (let t of this._order){
            let i = this._layers[t];
            i.recalculate(e1, n), !i.isHidden(e1.zoom) && i.source && (this.tileManagers[i.source].used = !0);
        }
        for(let e1 in i){
            let t = this.tileManagers[e1];
            !!i[e1] != !!t.used && t.fire(new $785da19a645c07eb$var$dC("data", {
                sourceDataType: "visibility",
                sourceId: e1
            }));
        }
        this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, t && this.fire(new $785da19a645c07eb$var$hC("data"));
    }
    _updateTilesForChangedImages() {
        let e1 = Object.keys(this._changedImages);
        if (e1.length) {
            for(let t in this.tileManagers)this.tileManagers[t].reloadTilesForDependencies([
                "icons",
                "patterns"
            ], e1);
            this._changedImages = {};
        }
    }
    _updateTilesForChangedGlyphs() {
        if (this._glyphsDidChange) {
            for(let e1 in this.tileManagers)this.tileManagers[e1].reloadTilesForDependencies([
                "glyphs"
            ], [
                ""
            ]);
            this._glyphsDidChange = !1;
        }
    }
    _updateWorkerLayers(e1, t) {
        this.dispatcher.broadcast("UL", {
            layers: this._serializeByIds(e1, !1),
            removedIds: t
        });
    }
    _resetUpdates() {
        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
    }
    setState(e1, t = {}) {
        this._checkLoaded();
        let i = this.serialize();
        if (e1 = t.transformStyle ? t.transformStyle(i, e1) : e1, (t.validate ?? !0) && $785da19a645c07eb$var$Of(this, e1)) return !1;
        (e1 = $785da19a645c07eb$var$xh(e1)).layers = $785da19a645c07eb$var$bC(e1.layers);
        let n = $785da19a645c07eb$var$IC(i, e1), a = this._getOperationsToPerform(n);
        if (a.unimplemented.length > 0) throw Error(`Unimplemented: ${a.unimplemented.join(", ")}.`);
        if (0 === a.operations.length) return !1;
        for (let e1 of a.operations)e1();
        return this.stylesheet = e1, this._serializedLayers = null, this.fire(new $785da19a645c07eb$var$uC({
            style: this
        })), !0;
    }
    _getOperationsToPerform(e1) {
        let t = [], i = [];
        for (let n of e1)switch(n.command){
            case "setCenter":
            case "setZoom":
            case "setBearing":
            case "setPitch":
            case "setRoll":
                continue;
            case "addLayer":
                t.push(()=>this.addLayer.apply(this, n.args));
                break;
            case "removeLayer":
                t.push(()=>this.removeLayer.apply(this, n.args));
                break;
            case "setPaintProperty":
                t.push(()=>this.setPaintProperty.apply(this, n.args));
                break;
            case "setLayoutProperty":
                t.push(()=>this.setLayoutProperty.apply(this, n.args));
                break;
            case "setFilter":
                t.push(()=>this.setFilter.apply(this, n.args));
                break;
            case "addSource":
                t.push(()=>this.addSource.apply(this, n.args));
                break;
            case "removeSource":
                t.push(()=>this.removeSource.apply(this, n.args));
                break;
            case "setLayerZoomRange":
                t.push(()=>this.setLayerZoomRange.apply(this, n.args));
                break;
            case "setLight":
                t.push(()=>this.setLight.apply(this, n.args));
                break;
            case "setGeoJSONSourceData":
                t.push(()=>this.setGeoJSONSourceData.apply(this, n.args));
                break;
            case "setGlyphs":
                t.push(()=>this.setGlyphs.apply(this, n.args));
                break;
            case "setFontFaces":
                t.push(()=>this.setFontFaces.apply(this, n.args));
                break;
            case "setSprite":
                t.push(()=>this.setSprite.apply(this, n.args));
                break;
            case "setTerrain":
                t.push(()=>this.map.setTerrain.apply(this, n.args));
                break;
            case "setSky":
                t.push(()=>this.setSky.apply(this, n.args));
                break;
            case "setProjection":
                this.setProjection.apply(this, n.args);
                break;
            case "setGlobalState":
                t.push(()=>this.setGlobalState.apply(this, n.args));
                break;
            case "setTransition":
                t.push(()=>{});
                break;
            default:
                i.push(n.command);
        }
        return {
            operations: t,
            unimplemented: i
        };
    }
    addImage(e1, t) {
        this.getImage(e1) ? this.fire(new $785da19a645c07eb$var$ad(Error(`An image named "${e1}" already exists.`))) : (this.imageManager.addImage(e1, t), this._afterImageUpdated(e1));
    }
    updateImage(e1, t) {
        this.imageManager.updateImage(e1, t);
    }
    getImage(e1) {
        return this.imageManager.getImage(e1);
    }
    setMissingImageResolver(e1) {
        this.imageManager.setMissingImageResolver(e1);
    }
    removeImage(e1) {
        this.getImage(e1) ? (this.imageManager.removeImage(e1), this._afterImageUpdated(e1)) : this.fire(new $785da19a645c07eb$var$ad(Error(`An image named "${e1}" does not exist.`)));
    }
    _markImagesChanged(e1) {
        for (let t of e1)this._changedImages[t] = !0;
    }
    _afterImageUpdated(e1) {
        this._changedImages[e1] = !0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $785da19a645c07eb$var$hC("data"));
    }
    listImages() {
        return this._checkLoaded(), this.imageManager.listImages();
    }
    addSource(e1, t, i = {}) {
        if (this._checkLoaded(), void 0 !== this.tileManagers[e1]) throw Error(`Source "${e1}" already exists.`);
        if (!t.type) throw Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(", ")}.`);
        if ($785da19a645c07eb$var$Bf.has(t.type) && this._validate($785da19a645c07eb$var$Lf.source, `sources.${e1}`, t, null, i)) return;
        this.map?._collectResourceTiming && (t.collectResourceTiming = !0);
        let n = this.tileManagers[e1] = new $785da19a645c07eb$var$mD(e1, t, this.dispatcher);
        n.style = this, n.setEventedParent(this, ()=>({
                isSourceLoaded: n.loaded(),
                source: n.serialize(),
                sourceId: e1
            })), n.onAdd(this.map), this._changed = !0;
    }
    removeSource(e1) {
        if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw Error(`There is no source with this ID=${e1}`);
        for(let t in this._layers)if (this._layers[t].source === e1) return this.fire(new $785da19a645c07eb$var$ad(Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
        let t = this.tileManagers[e1];
        delete this.tileManagers[e1], delete this._updatedSources[e1], t.fire(new $785da19a645c07eb$var$dC("data", {
            sourceDataType: "metadata",
            sourceId: e1
        })), t.setEventedParent(null), t.onRemove(this.map), this._changed = !0;
    }
    setGeoJSONSourceData(e1, t) {
        if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw Error(`There is no source with this ID=${e1}`);
        let i = this.tileManagers[e1].getSource();
        if ("geojson" !== i.type) throw Error(`geojsonSource.type is ${i.type}, which is !== 'geojson`);
        i.setData(t), this._changed = !0;
    }
    getSource(e1) {
        return this.tileManagers[e1]?.getSource();
    }
    addLayer(e1, t, i = {}) {
        this._checkLoaded();
        let n, a = e1.id;
        if (this.getLayer(a)) return void this.fire(new $785da19a645c07eb$var$ad(Error(`Layer "${a}" already exists on this map.`)));
        if ("custom" === e1.type) {
            if ($785da19a645c07eb$var$Uf(this, function(e1) {
                let t = [], i = e1.id;
                return void 0 === i && t.push(new $785da19a645c07eb$var$cd(`layers.${i}`, null, 'missing required property "id"')), void 0 === e1.render && t.push(new $785da19a645c07eb$var$cd(`layers.${i}`, null, 'missing required method "render"')), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t.push(new $785da19a645c07eb$var$cd(`layers.${i}`, null, 'property "renderingMode" must be either "2d" or "3d"')), t;
            }(e1))) return;
            n = $785da19a645c07eb$var$jE(e1, this._globalState);
        } else {
            if ("source" in e1 && "object" == typeof e1.source && (this.addSource(a, e1.source), e1 = $785da19a645c07eb$var$hh(e1 = $785da19a645c07eb$var$xh(e1), {
                source: a
            })), this._validate($785da19a645c07eb$var$Lf.layer, `layers.${a}`, e1, {
                arrayIndex: -1
            }, i)) return;
            n = $785da19a645c07eb$var$jE(e1, this._globalState), this._validateLayer(n), n.setEventedParent(this, {
                layer: {
                    id: a
                }
            });
        }
        let r = t ? this._order.indexOf(t) : this._order.length;
        if (t && -1 === r) this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot add layer "${a}" before non-existing layer "${t}".`)));
        else {
            if (this._order.splice(r, 0, a), this._layerOrderChanged = !0, this._layers[a] = n, this._removedLayers[a] && n.source && "custom" !== n.type) {
                let e1 = this._removedLayers[a];
                delete this._removedLayers[a], e1.type === n.type ? (this._updatedSources[n.source] = "reload", this.tileManagers[n.source].pause()) : this._updatedSources[n.source] = "clear";
            }
            this._updateLayer(n), n.onAdd && n.onAdd(this.map);
        }
    }
    moveLayer(e1, t) {
        if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new $785da19a645c07eb$var$ad(Error(`The layer '${e1}' does not exist in the map's style and cannot be moved.`)));
        if (e1 === t) return;
        if (t && !this._order.includes(t)) return void this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot move layer "${e1}" before non-existing layer "${t}".`)));
        let i = this._order.indexOf(e1);
        this._order.splice(i, 1);
        let n = t ? this._order.indexOf(t) : this._order.length;
        this._order.splice(n, 0, e1), this._layerOrderChanged = !0;
    }
    removeLayer(e1) {
        this._checkLoaded();
        let t = this._layers[e1];
        if (!t) return void this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot remove non-existing layer "${e1}".`)));
        t.setEventedParent(null);
        let i = this._order.indexOf(e1);
        this._order.splice(i, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = t, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], "symbol" === t.type && t.source && this.tileManagers[t.source]?.resetMaxContentElevation(), t.onRemove && t.onRemove(this.map);
    }
    getLayer(e1) {
        return this._layers[e1];
    }
    getLayersOrder() {
        return [
            ...this._order
        ];
    }
    hasLayer(e1) {
        return e1 in this._layers;
    }
    setLayerZoomRange(e1, t, i) {
        this._checkLoaded();
        let n = this.getLayer(e1);
        n ? (n.minzoom !== t || n.maxzoom !== i) && (null != t && (n.minzoom = t), null != i && (n.maxzoom = i), this._updateLayer(n)) : this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot set the zoom range of non-existing layer "${e1}".`)));
    }
    setFilter(e1, t, i = {}) {
        this._checkLoaded();
        let n = this.getLayer(e1);
        if (n) {
            if (!$785da19a645c07eb$var$yh(n.filter, t)) {
                if (null == t) return n.setFilter(void 0), void this._updateLayer(n);
                this._validate($785da19a645c07eb$var$Lf.filter, `layers.${n.id}.filter`, t, null, i) || (n.setFilter($785da19a645c07eb$var$xh(t)), this._updateLayer(n));
            }
        } else this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot filter non-existing layer "${e1}".`)));
    }
    getFilter(e1) {
        return $785da19a645c07eb$var$xh(this.getLayer(e1).filter);
    }
    setLayoutProperty(e1, t, i, n = {}) {
        this._checkLoaded();
        let a = this.getLayer(e1);
        a ? $785da19a645c07eb$var$yh(a.getLayoutProperty(t), i) || (a.setLayoutProperty(t, i, n), this._updateLayer(a)) : this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot style non-existing layer "${e1}".`)));
    }
    getLayoutProperty(e1, t) {
        let i = this.getLayer(e1);
        if (i) return i.getLayoutProperty(t);
        this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot get style of non-existing layer "${e1}".`)));
    }
    setPaintProperty(e1, t, i, n = {}) {
        this._checkLoaded();
        let a = this.getLayer(e1);
        a ? $785da19a645c07eb$var$yh(a.getPaintProperty(t), i) || this._updatePaintProperty(a, t, i, n) : this.fire(new $785da19a645c07eb$var$ad(Error(`Cannot style non-existing layer "${e1}".`)));
    }
    _updatePaintProperty(e1, t, i, n = {}) {
        e1.setPaintProperty(t, i, n) && this._updateLayer(e1), $785da19a645c07eb$var$vA(e1) && "raster-fade-duration" === t && this.tileManagers[e1.source].setRasterFadeDuration(i), this._changed = !0, this._updatedPaintProps[e1.id] = !0, "symbol" === e1.type && this.triggerSymbolPlacement(), this._serializedLayers = null;
    }
    getPaintProperty(e1, t) {
        return this.getLayer(e1).getPaintProperty(t);
    }
    setFeatureState(e1, t) {
        this._checkLoaded();
        let i = e1.source, n = e1.sourceLayer, a = this.tileManagers[i];
        if (void 0 === a) return void this.fire(new $785da19a645c07eb$var$ad(Error(`The source '${i}' does not exist in the map's style.`)));
        let r = a.getSource().type;
        if ("geojson" === r && n) return void this.fire(new $785da19a645c07eb$var$ad(Error("GeoJSON sources cannot have a sourceLayer parameter.")));
        if ("vector" === r && !n) return void this.fire(new $785da19a645c07eb$var$ad(Error("The sourceLayer parameter must be provided for vector source types.")));
        if (void 0 === e1.id) return void this.fire(new $785da19a645c07eb$var$ad(Error("The feature id parameter must be provided.")));
        let s = [
            "__proto__",
            "constructor",
            "prototype"
        ];
        t && Object.keys(t).some((e1)=>s.includes(e1)) ? this.fire(new $785da19a645c07eb$var$ad(Error(`The feature state should not include one of the following keys: ${s}`))) : a.setFeatureState(n, e1.id, t);
    }
    removeFeatureState(e1, t) {
        this._checkLoaded();
        let i = e1.source, n = this.tileManagers[i];
        if (void 0 === n) return void this.fire(new $785da19a645c07eb$var$ad(Error(`The source '${i}' does not exist in the map's style.`)));
        let a = n.getSource().type, r = "vector" === a ? e1.sourceLayer : void 0;
        "vector" !== a || r ? t && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new $785da19a645c07eb$var$ad(Error("A feature id is required to remove its specific state property."))) : n.removeFeatureState(r, e1.id, t) : this.fire(new $785da19a645c07eb$var$ad(Error("The sourceLayer parameter must be provided for vector source types.")));
    }
    getFeatureState(e1) {
        this._checkLoaded();
        let t = e1.source, i = e1.sourceLayer, n = this.tileManagers[t];
        if (void 0 !== n) {
            if ("vector" !== n.getSource().type || i) return void 0 === e1.id && this.fire(new $785da19a645c07eb$var$ad(Error("The feature id parameter must be provided."))), n.getFeatureState(i, e1.id);
            this.fire(new $785da19a645c07eb$var$ad(Error("The sourceLayer parameter must be provided for vector source types.")));
        } else this.fire(new $785da19a645c07eb$var$ad(Error(`The source '${t}' does not exist in the map's style.`)));
    }
    getTransition() {
        return $785da19a645c07eb$var$hh({
            duration: 300,
            delay: 0
        }, this.stylesheet?.transition);
    }
    serialize() {
        if (!this._loaded) return;
        let e1 = $785da19a645c07eb$var$_h(this.tileManagers, (e1)=>e1.serialize()), t = this._serializeByIds(this._order, !0), i = this.map.getTerrain() || void 0, n = this.stylesheet;
        return $785da19a645c07eb$var$vh({
            version: n.version,
            name: n.name,
            metadata: n.metadata,
            light: n.light,
            sky: n.sky,
            center: n.center,
            zoom: n.zoom,
            bearing: n.bearing,
            pitch: n.pitch,
            sprite: n.sprite,
            glyphs: n.glyphs,
            "font-faces": n["font-faces"],
            transition: n.transition,
            projection: n.projection,
            state: n.state,
            sources: e1,
            layers: t,
            terrain: i
        }, (e1)=>void 0 !== e1);
    }
    _updateLayer(e1) {
        this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && "raster" !== this.tileManagers[e1.source].getSource().type && (this._updatedSources[e1.source] = "reload", this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
    }
    _flattenAndSortRenderedFeatures(e1) {
        let t = (e1)=>"fill-extrusion" === this._layers[e1].type, i = {}, n = [];
        for(let a = this._order.length - 1; a >= 0; a--){
            let r = this._order[a];
            if (t(r)) {
                i[r] = a;
                for (let t of e1){
                    let e1 = t[r];
                    if (e1) for (let t of e1)n.push(t);
                }
            }
        }
        n.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
        let a = [];
        for(let r = this._order.length - 1; r >= 0; r--){
            let s = this._order[r];
            if (t(s)) for(let e1 = n.length - 1; e1 >= 0; e1--){
                let t = n[e1].feature;
                if (i[t.layer.id] < r) break;
                a.push(t), n.pop();
            }
            else for (let t of e1){
                let e1 = t[s];
                if (e1) for (let t of e1)a.push(t.feature);
            }
        }
        return a;
    }
    queryRenderedFeatures(e1, t, i) {
        t?.filter && this._validate($785da19a645c07eb$var$Lf.filter, "queryRenderedFeatures.filter", t.filter, null, t);
        let n = {};
        if (t?.layers) {
            if (!(Array.isArray(t.layers) || t.layers instanceof Set)) return this.fire(new $785da19a645c07eb$var$ad(Error("parameters.layers must be an Array or a Set of strings"))), [];
            for (let e1 of t.layers){
                let t = this._layers[e1];
                if (!t) return this.fire(new $785da19a645c07eb$var$ad(Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                n[t.source] = !0;
            }
        }
        let a = [];
        t.availableImages = this.imageManager.listImages();
        let r = this._serializedAllLayers(), s = t.layers instanceof Set ? t.layers : Array.isArray(t.layers) ? new Set(t.layers) : null, o = {
            ...t,
            layers: s,
            globalState: this._globalState
        };
        for(let s in this.tileManagers)(!t.layers || n[s]) && a.push($785da19a645c07eb$var$pT(this.tileManagers[s], this._layers, r, e1, o, i, this.map.terrain ? (e1, t, i)=>this.map.terrain.getElevation(e1, t, i) : void 0));
        return this.placement && a.push($785da19a645c07eb$var$mT(this._layers, r, this.tileManagers, e1, o, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(a);
    }
    querySourceFeatures(e1, t) {
        t?.filter && this._validate($785da19a645c07eb$var$Lf.filter, "querySourceFeatures.filter", t.filter, null, t);
        let i = this.tileManagers[e1];
        return i ? function(e1, t) {
            let i = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), n = [], a = {};
            for (let e1 of i){
                let i = e1.tileID.canonical.key;
                a[i] || (a[i] = !0, e1.querySourceFeatures(n, t));
            }
            return n;
        }(i, t ? {
            ...t,
            globalState: this._globalState
        } : {
            globalState: this._globalState
        }) : [];
    }
    getLight() {
        return this.light.getLight();
    }
    setLight(e1, t = {}) {
        this._checkLoaded();
        let i = this.light.getLight(), n = !1;
        for(let t in e1)if (!$785da19a645c07eb$var$yh(e1[t], i[t])) {
            n = !0;
            break;
        }
        if (!n) return;
        let a = {
            now: $785da19a645c07eb$var$aC(),
            transition: $785da19a645c07eb$var$hh({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.light.setLight(e1, t), this.light.updateTransitions(a);
    }
    getProjection() {
        return this.stylesheet?.projection;
    }
    setProjection(e1) {
        this._checkLoaded();
        let t = e1 ?? {
            type: "mercator"
        };
        if (this.stylesheet.projection = e1, this.projection) {
            if (this.projection.name === t.type) return;
            this.projection.destroy(), delete this.projection;
        }
        this._setProjectionInternal(t.type);
    }
    getSky() {
        return this.stylesheet?.sky;
    }
    setSky(e1, t = {}) {
        this._checkLoaded();
        let i = this.getSky(), n = !1;
        if (!e1 && !i) return;
        if (e1 && !i) n = !0;
        else if (!e1 && i) n = !0;
        else for(let t in e1)if (!$785da19a645c07eb$var$yh(e1[t], i[t])) {
            n = !0;
            break;
        }
        if (!n) return;
        let a = {
            now: $785da19a645c07eb$var$aC(),
            transition: $785da19a645c07eb$var$hh({
                duration: 300,
                delay: 0
            }, this.stylesheet.transition)
        };
        this.stylesheet.sky = e1, this.sky.setSky(e1, t), this.sky.updateTransitions(a);
    }
    _setProjectionInternal(e1) {
        let t = function(e1, t, i) {
            let n = {
                constrainOverride: t
            };
            if (Array.isArray(e1)) {
                let t = new $785da19a645c07eb$var$KP({
                    type: e1
                }, i);
                return {
                    projection: t,
                    transform: new $785da19a645c07eb$var$vI(n),
                    cameraHelper: new $785da19a645c07eb$var$xI(t)
                };
            }
            switch(e1){
                case "mercator":
                    return {
                        projection: new $785da19a645c07eb$var$EP,
                        transform: new $785da19a645c07eb$var$OP(n),
                        cameraHelper: new $785da19a645c07eb$var$GP
                    };
                case "globe":
                    {
                        let e1 = new $785da19a645c07eb$var$KP({
                            type: [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "zoom"
                                ],
                                11,
                                "vertical-perspective",
                                12,
                                "mercator"
                            ]
                        }, {});
                        return {
                            projection: e1,
                            transform: new $785da19a645c07eb$var$vI(n),
                            cameraHelper: new $785da19a645c07eb$var$xI(e1)
                        };
                    }
                case "vertical-perspective":
                    return {
                        projection: new $785da19a645c07eb$var$ZP,
                        transform: new $785da19a645c07eb$var$fI(n),
                        cameraHelper: new $785da19a645c07eb$var$yI
                    };
                default:
                    return $785da19a645c07eb$var$wh(`Unknown projection name: ${e1}. Falling back to mercator projection.`), {
                        projection: new $785da19a645c07eb$var$EP,
                        transform: new $785da19a645c07eb$var$OP(n),
                        cameraHelper: new $785da19a645c07eb$var$GP
                    };
            }
        }(e1, this.map._camera?.transform.constrainOverride, this._globalState);
        this.projection = t.projection, this.map.migrateProjection(t.transform, t.cameraHelper);
        for(let e1 in this.tileManagers)this.tileManagers[e1].reload();
    }
    _validate(e1, t, i, n, a = {}) {
        return !1 !== a.validate && $785da19a645c07eb$var$Nf(this, e1, {
            key: t,
            style: this.serialize(),
            value: i,
            ...n
        }, a);
    }
    _remove(e1 = !0) {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null), $785da19a645c07eb$var$KT().off($785da19a645c07eb$var$HT, this._rtlPluginLoaded);
        for(let e1 in this._layers)this._layers[e1].setEventedParent(null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.imageManager.setEventedParent(null), this.setEventedParent(null), e1 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(e1);
    }
    _clearSource(e1) {
        this.tileManagers[e1].clearTiles();
    }
    _reloadSource(e1) {
        this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
    }
    _updateSources(e1) {
        for(let t in this.tileManagers)this.tileManagers[t].update(e1, this.map.terrain);
    }
    _generateCollisionBoxes() {
        for(let e1 in this.tileManagers)this._reloadSource(e1);
    }
    triggerSymbolPlacement() {
        this._symbolPlacementTriggered = !0;
    }
    _placementInputsChanged(e1, t, i) {
        let n = this.pauseablePlacement;
        return !n || this._symbolPlacementTriggered || this._placedProjectionTransition !== this.projection?.transitionState || n._showCollisionBoxes !== t || n.placement.collisionGroups.crossSourceCollisions !== i || n.placement.transform.renderWorldCopies !== e1.renderWorldCopies || !function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8] && e1[9] === t[9] && e1[10] === t[10] && e1[11] === t[11] && e1[12] === t[12] && e1[13] === t[13] && e1[14] === t[14] && e1[15] === t[15];
        }(n.placement.transform.modelViewProjectionMatrix, e1.modelViewProjectionMatrix);
    }
    _updatePlacement(e1, t, i, n, a = !1) {
        let r = !1, s = !1, o = {};
        for (let t of this._order){
            let i = this._layers[t];
            if ("symbol" !== i.type) continue;
            if (!o[i.source]) {
                let e1 = this.tileManagers[i.source];
                o[i.source] = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t)).sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
            }
            let n = this.crossTileSymbolIndex.addLayer(i, o[i.source], e1.center.lng);
            r ||= n;
        }
        this.crossTileSymbolIndex.pruneUnusedLayers(this._order), a ||= this._layerOrderChanged || 0 === i;
        let l = r || this._placementInputsChanged(e1, t, n), c = this.pauseablePlacement?.isDone() && !this.placement.stillRecent($785da19a645c07eb$var$aC(), e1.zoom);
        if ((a || !this.pauseablePlacement || c && (l || this.placement.stale)) && (this._symbolPlacementTriggered = !1, this._placedProjectionTransition = this.projection?.transitionState, this.pauseablePlacement = new $785da19a645c07eb$var$rP(e1, this.map.terrain, this._order, a, t, i, n, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? l && this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, o), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit($785da19a645c07eb$var$aC()), s = !0), r && this.pauseablePlacement.placement.setStale()), s || r) for (let e1 of this._order){
            let t = this._layers[e1];
            "symbol" === t.type && this.placement.updateLayerOpacities(t, o[t.source]);
        }
        return !this.pauseablePlacement.isDone() || this.placement.hasTransitions($785da19a645c07eb$var$aC());
    }
    _releaseSymbolFadeTiles() {
        for(let e1 in this.tileManagers)this.tileManagers[e1].releaseSymbolFadeTiles();
    }
    async getImages(e1, t) {
        let i = await this.imageManager.getImages(t.icons);
        this._updateTilesForChangedImages();
        let n = this.tileManagers[t.source];
        return n && n.setDependencies(t.tileID.key, t.type, t.icons), i;
    }
    async getGlyphs(e1, t) {
        let i = await this.glyphManager.getGlyphs(t.stacks), n = this.tileManagers[t.source];
        return n && n.setDependencies(t.tileID.key, t.type, [
            ""
        ]), i;
    }
    getGlyphsUrl() {
        return this.stylesheet.glyphs || null;
    }
    setGlyphs(e1, t = {}) {
        this._checkLoaded(), (!e1 || !this._validate($785da19a645c07eb$var$Lf.glyphs, "glyphs", e1, null, t)) && (this._changed = !0, this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
    }
    getFontFaces() {
        return this.stylesheet["font-faces"] || null;
    }
    setFontFaces(e1) {
        this._checkLoaded(), this._changed = !0, this._glyphsDidChange = !0, this.stylesheet["font-faces"] = e1, this.glyphManager.setFontFaces(e1);
    }
    async getDashes(e1, t) {
        let i = {};
        for (let [e1, n] of Object.entries(t.dashes))i[e1] = this.lineAtlas.getDash(n.dasharray, n.round);
        return i;
    }
    addSprite(e1, t, i = {}, n) {
        this._checkLoaded();
        let a = [
            {
                id: e1,
                url: t
            }
        ], r = [
            ...$785da19a645c07eb$var$FC(this.stylesheet.sprite),
            ...a
        ];
        this._validate($785da19a645c07eb$var$Lf.sprite, "sprite", r, null, i) || (this.stylesheet.sprite = r, this._loadSprite(a, !0, n));
    }
    removeSprite(e1) {
        this._checkLoaded();
        let t = $785da19a645c07eb$var$FC(this.stylesheet.sprite);
        if (!t.find((t)=>t.id === e1)) return void this.fire(new $785da19a645c07eb$var$ad(Error(`Sprite "${e1}" doesn't exists on this map.`)));
        let i = this.imageManager.removeSpriteImages(e1);
        this._markImagesChanged(i), t.splice(t.findIndex((t)=>t.id === e1), 1), this.stylesheet.sprite = t.length > 0 ? t : void 0, this._imagesListDirty = !0, this._changed = !0, this.fire(new $785da19a645c07eb$var$hC("data"));
    }
    getSprite() {
        return $785da19a645c07eb$var$FC(this.stylesheet.sprite);
    }
    setSprite(e1, t = {}, i) {
        this._checkLoaded(), (!e1 || !this._validate($785da19a645c07eb$var$Lf.sprite, "sprite", e1, null, t)) && (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, i) : (this._unloadSprite(), i && i(null)));
    }
    destroy() {
        this._frameRequest &&= (this._frameRequest.abort(), null), this._loadStyleRequest &&= (this._loadStyleRequest.abort(), null), this._spriteRequest &&= (this._spriteRequest.abort(), null);
        for(let e1 in this.tileManagers){
            let t = this.tileManagers[e1];
            t.setEventedParent(null), t.onRemove(this.map);
        }
        this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this.patternAtlas.destroy()), this.glyphManager && this.glyphManager.destroy();
        for(let e1 in this._layers){
            let t = this._layers[e1];
            t.setEventedParent(null), t.onRemove && t.onRemove(this.map);
        }
        this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
    }
};
const $785da19a645c07eb$var$EI = $785da19a645c07eb$var$EA([
    {
        name: "a_pos",
        type: "Int16",
        components: 2
    },
    {
        name: "a_texture_pos",
        type: "Int16",
        components: 2
    }
]);
var $785da19a645c07eb$var$kI = class {
    constructor(){
        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
    }
    bind(e1, t, i, n, a, r, s, o, l) {
        this.context = e1;
        let c = this.boundPaintVertexBuffers.length !== n.length;
        for(let e1 = 0; !c && e1 < n.length; e1++)this.boundPaintVertexBuffers[e1] !== n[e1] && (c = !0);
        !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || c || this.boundIndexBuffer !== a || this.boundVertexOffset !== r || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== o || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(t, i, n, a, r, s, o, l) : e1.bindVertexArray.set(this.vao);
    }
    freshBind(e1, t, i, n, a, r, s, o) {
        let l = e1.numAttributes, c = this.context, u = c.gl;
        this.vao && this.destroy(), this.vao = c.createVertexArray(), c.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = n, this.boundVertexOffset = a, this.boundDynamicVertexBuffer = r, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = o, t.enableAttributes(u, e1);
        for (let t of i)t.enableAttributes(u, e1);
        r && r.enableAttributes(u, e1), s && s.enableAttributes(u, e1), o && o.enableAttributes(u, e1), t.bind(), t.setVertexAttribPointers(u, e1, a);
        for (let t of i)t.bind(), t.setVertexAttribPointers(u, e1, a);
        r && (r.bind(), r.setVertexAttribPointers(u, e1, a)), n && n.bind(), s && (s.bind(), s.setVertexAttribPointers(u, e1, a)), o && (o.bind(), o.setVertexAttribPointers(u, e1, a)), c.currentNumAttributes = l;
    }
    destroy() {
        this.vao &&= (this.context.deleteVertexArray(this.vao), null);
    }
};
const $785da19a645c07eb$var$SI = (e1, t, i, n, a)=>({
        u_texture: 0,
        u_ele_delta: e1,
        u_fog_matrix: t,
        u_fog_color: i ? i.properties.get("fog-color") : $785da19a645c07eb$var$np.white,
        u_fog_ground_blend: i ? i.properties.get("fog-ground-blend") : 1,
        u_fog_ground_blend_opacity: a ? 0 : i ? i.calculateFogBlendOpacity(n) : 0,
        u_horizon_color: i ? i.properties.get("horizon-color") : $785da19a645c07eb$var$np.white,
        u_horizon_fog_blend: i ? i.properties.get("horizon-fog-blend") : 1,
        u_is_globe_mode: +!!a
    }), $785da19a645c07eb$var$MI = (e1)=>({
        u_ele_delta: e1
    }), $785da19a645c07eb$var$CI = {
    ProjectionUBO: 0,
    TerrainUBO: 1,
    FrameUBO: 2
};
const $785da19a645c07eb$var$TI = {
    float: [
        1,
        1
    ],
    int: [
        1,
        1
    ],
    vec2: [
        2,
        2
    ],
    vec4: [
        4,
        4
    ],
    mat4: [
        16,
        4
    ]
};
function $785da19a645c07eb$var$DI(e1) {
    let t = {}, i = 0;
    for (let { name: n, type: a } of e1){
        let [e1, r] = $785da19a645c07eb$var$TI[a];
        i = Math.ceil(i / r) * r, t[n] = i, i += e1;
    }
    return {
        offsets: t,
        contentWords: i,
        sizeWords: 4 * Math.ceil(i / 4)
    };
}
var $785da19a645c07eb$var$PI = class {
    constructor(e1, t, i){
        this.context = e1, this.binding = t, this.contentWords = i.contentWords;
        let n = e1.gl;
        this.buffer = n.createBuffer(), n.bindBuffer(n.UNIFORM_BUFFER, this.buffer), n.bufferData(n.UNIFORM_BUFFER, 4 * i.sizeWords, n.DYNAMIC_DRAW), n.bindBufferBase(n.UNIFORM_BUFFER, t, this.buffer), this.uploaded = new Float32Array(i.sizeWords), this.pending = new Float32Array(i.sizeWords), this.uploadedWords = new Uint32Array(this.uploaded.buffer), this.pendingWords = new Uint32Array(this.pending.buffer), this.hasData = !1, this.bindingDirty = !1;
    }
    upload() {
        let e1 = this.context.gl, t = !this.hasData;
        if (!t) {
            let e1 = this.pendingWords, i = this.uploadedWords;
            for(let n = 0; n < this.contentWords; n++)if (e1[n] !== i[n]) {
                t = !0;
                break;
            }
        }
        this.bindingDirty &&= (e1.bindBufferBase(e1.UNIFORM_BUFFER, this.binding, this.buffer), !1), t && (e1.bindBuffer(e1.UNIFORM_BUFFER, this.buffer), e1.bufferSubData(e1.UNIFORM_BUFFER, 0, this.pending), this.uploaded.set(this.pending), this.hasData = !0);
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $785da19a645c07eb$var$II = $785da19a645c07eb$var$DI([
    {
        name: "u_projection_matrix",
        type: "mat4"
    },
    {
        name: "u_projection_fallback_matrix",
        type: "mat4"
    },
    {
        name: "u_projection_tile_mercator_coords",
        type: "vec4"
    },
    {
        name: "u_projection_clipping_plane",
        type: "vec4"
    },
    {
        name: "u_projection_transition",
        type: "float"
    },
    {
        name: "u_projection_clip_antimeridian",
        type: "int"
    }
]), $785da19a645c07eb$var$FI = $785da19a645c07eb$var$II.offsets;
const $785da19a645c07eb$var$zI = $785da19a645c07eb$var$DI([
    {
        name: "u_terrain_matrix",
        type: "mat4"
    },
    {
        name: "u_terrain_unpack",
        type: "vec4"
    },
    {
        name: "u_terrain_dim",
        type: "float"
    },
    {
        name: "u_terrain_exaggeration",
        type: "float"
    }
]), $785da19a645c07eb$var$RI = $785da19a645c07eb$var$zI.offsets;
function $785da19a645c07eb$var$LI(e1) {
    let t = [];
    for (let i of e1){
        if (null === i) continue;
        let e1 = i.split(" ");
        t.push(e1.pop());
    }
    return t;
}
var $785da19a645c07eb$var$BI = class {
    constructor(e1, t, i, n, a, r, s, o, l = []){
        let c = e1.gl;
        this.program = c.createProgram();
        let u = $785da19a645c07eb$var$LI(t.staticAttributes), h = i ? i.getBinderAttributes() : [], d = u.concat(h), p = $785da19a645c07eb$var$yP.prelude.staticUniforms ? $785da19a645c07eb$var$LI($785da19a645c07eb$var$yP.prelude.staticUniforms) : [], m = t.staticUniforms ? $785da19a645c07eb$var$LI(t.staticUniforms) : [], g = i ? i.getBinderUniforms() : [], f = p.concat(m).concat(g), A = [];
        for (let e1 of f)A.includes(e1) || A.push(e1);
        let _ = i ? i.defines() : [];
        _.unshift("#version 300 es"), a && _.push("#define OVERDRAW_INSPECTOR;"), r && _.push("#define TERRAIN3D;"), o && _.push(o), l && _.push(...l);
        let v = _.concat($785da19a645c07eb$var$yP.prelude.fragmentSource, s.fragmentSource, t.fragmentSource).join("\n"), y = _.concat($785da19a645c07eb$var$yP.prelude.vertexSource, s.vertexSource, t.vertexSource).join("\n"), x = c.createShader(c.FRAGMENT_SHADER);
        if (c.isContextLost()) return void (this.failedToCreate = !0);
        c.shaderSource(x, v), c.compileShader(x), c.attachShader(this.program, x);
        let b = c.createShader(c.VERTEX_SHADER);
        if (c.isContextLost()) return void (this.failedToCreate = !0);
        c.shaderSource(b, y), c.compileShader(b), c.attachShader(this.program, b), this.attributes = {};
        let w = {};
        if (this.numAttributes = d.length, c.linkProgram(this.program), !c.getProgramParameter(this.program, c.LINK_STATUS)) {
            if (c.isContextLost()) return void (this.failedToCreate = !0);
            throw c.getShaderParameter(x, c.COMPILE_STATUS) ? c.getShaderParameter(b, c.COMPILE_STATUS) ? Error(`Program failed to link: ${c.getProgramInfoLog(this.program)}`) : Error(`Could not compile vertex shader: ${c.getShaderInfoLog(b)}`) : Error(`Could not compile fragment shader: ${c.getShaderInfoLog(x)}`);
        }
        !function(e1, t) {
            for (let [i, n] of Object.entries($785da19a645c07eb$var$CI)){
                let a = e1.getUniformBlockIndex(t, i);
                a !== e1.INVALID_INDEX && e1.uniformBlockBinding(t, a, n);
            }
        }(c, this.program);
        let E = function(e1, t) {
            let i = new Set([
                e1.INT,
                e1.INT_VEC2,
                e1.INT_VEC3,
                e1.INT_VEC4,
                e1.UNSIGNED_INT,
                e1.UNSIGNED_INT_VEC2,
                e1.UNSIGNED_INT_VEC3,
                e1.UNSIGNED_INT_VEC4
            ]), n = new Set, a = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
            for(let r = 0; r < a; r++){
                let a = e1.getActiveAttrib(t, r);
                a && i.has(a.type) && n.add(a.name);
            }
            return n;
        }(c, this.program);
        for (let e1 of d){
            if (!e1) continue;
            let t = c.getAttribLocation(this.program, e1);
            t >= 0 && (this.attributes[e1] = {
                location: t,
                isInteger: E.has(e1)
            });
        }
        c.deleteShader(b), c.deleteShader(x);
        for (let e1 of A)if (e1 && !w[e1]) {
            let t = c.getUniformLocation(this.program, e1);
            t && (w[e1] = t);
        }
        this.fixedUniforms = n(e1, w), this.terrainUniforms = ((e1, t)=>({
                u_depth: new $785da19a645c07eb$var$j_(e1, t.u_depth),
                u_terrain: new $785da19a645c07eb$var$j_(e1, t.u_terrain)
            }))(e1, w), this.binderUniforms = i ? i.getUniforms(e1, w) : [];
    }
    draw(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g, f, A, _) {
        let v = e1.gl;
        if (this.failedToCreate) return;
        if (e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(n), e1.setColorMode(a), e1.setCullFace(r), o) {
            e1.activeTexture.set(v.TEXTURE2), v.bindTexture(v.TEXTURE_2D, o.depthTexture), e1.activeTexture.set(v.TEXTURE3), v.bindTexture(v.TEXTURE_2D, o.texture);
            for(let e1 in this.terrainUniforms)this.terrainUniforms[e1].set(o[e1]);
            !function(e1, t) {
                let i = e1.pending;
                i.set(t.u_terrain_matrix, $785da19a645c07eb$var$RI.u_terrain_matrix), i.set(t.u_terrain_unpack, $785da19a645c07eb$var$RI.u_terrain_unpack), i[$785da19a645c07eb$var$RI.u_terrain_dim] = t.u_terrain_dim, i[$785da19a645c07eb$var$RI.u_terrain_exaggeration] = t.u_terrain_exaggeration, e1.upload();
            }(e1.terrainUniformBuffer, o);
        }
        if (l && function(e1, t) {
            let i = e1.pending;
            i.set(t.mainMatrix, $785da19a645c07eb$var$FI.u_projection_matrix), i.set(t.fallbackMatrix, $785da19a645c07eb$var$FI.u_projection_fallback_matrix), i.set(t.tileMercatorCoords, $785da19a645c07eb$var$FI.u_projection_tile_mercator_coords), i.set(t.clippingPlane, $785da19a645c07eb$var$FI.u_projection_clipping_plane), i[$785da19a645c07eb$var$FI.u_projection_transition] = t.projectionTransition, e1.pendingWords[$785da19a645c07eb$var$FI.u_projection_clip_antimeridian] = +!!t.clipAntimeridian, e1.upload();
        }(e1.projectionUniformBuffer, l), s) for(let e1 in this.fixedUniforms)this.fixedUniforms[e1].set(s[e1]);
        g && g.setUniforms(e1, this.binderUniforms, p, {
            zoom: m
        });
        let y = 0;
        switch(t){
            case v.LINES:
                y = 2;
                break;
            case v.TRIANGLES:
                y = 3;
                break;
            case v.LINE_STRIP:
                y = 1;
        }
        for (let i of d.get())i.vaos ||= {}, i.vaos[c] ||= new $785da19a645c07eb$var$kI, i.vaos[c].bind(e1, this, u, g ? g.getPaintVertexBuffers() : [], h, i.vertexOffset, f, A, _), v.drawElements(t, i.primitiveLength * y, v.UNSIGNED_SHORT, i.primitiveOffset * y * 2);
    }
};
function $785da19a645c07eb$var$OI(e1, t, i) {
    let n = 1 / $785da19a645c07eb$var$qu(i, 1, t.transform.tileZoom), a = 2 ** i.tileID.overscaledZ, r = i.tileSize * 2 ** t.transform.tileZoom / a, s = r * (i.tileID.canonical.x + i.tileID.wrap * a), o = r * i.tileID.canonical.y;
    return {
        u_image: 0,
        u_texsize: i.imageAtlasTexture.size,
        u_scale: [
            n,
            e1.fromScale,
            e1.toScale
        ],
        u_fade: e1.t,
        u_pixel_coord_upper: [
            s >> 16,
            o >> 16
        ],
        u_pixel_coord_lower: [
            65535 & s,
            65535 & o
        ]
    };
}
const $785da19a645c07eb$var$UI = (e1, t, i, n)=>{
    let a = e1.style.light, r = a.getCartesianPosition(), s = $785da19a645c07eb$var$eu();
    "viewport" === a.properties.get("anchor") && function(e1, t) {
        var i = Math.sin(t), n = Math.cos(t);
        e1[0] = n, e1[1] = i, e1[2] = 0, e1[3] = -i, e1[4] = n, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1;
    }(s, e1.transform.bearingInRadians), function(e1, t, i) {
        var n = t[0], a = t[1], r = t[2];
        e1[0] = n * i[0] + a * i[3] + r * i[6], e1[1] = n * i[1] + a * i[4] + r * i[7], e1[2] = n * i[2] + a * i[5] + r * i[8];
    }(r, r, s);
    let o = e1.transform.transformLightDirection(r), l = a.properties.get("color");
    return {
        u_lightpos: r,
        u_lightpos_globe: o,
        u_lightintensity: a.properties.get("intensity"),
        u_lightcolor: [
            l.r,
            l.g,
            l.b
        ],
        u_vertical_gradient: +t,
        u_opacity: i,
        u_fill_translate: n
    };
}, $785da19a645c07eb$var$NI = (e1, t, i, n, a, r, s)=>$785da19a645c07eb$var$hh($785da19a645c07eb$var$UI(e1, t, i, n), $785da19a645c07eb$var$OI(r, e1, s), {
        u_height_factor: -(2 ** a.overscaledZ) / s.tileSize / 8
    }), $785da19a645c07eb$var$jI = (e1, t, i, n, a)=>$785da19a645c07eb$var$hh($785da19a645c07eb$var$OI(t, e1, i), {
        u_fill_translate: n,
        u_sdf_pattern: +!!a
    }), $785da19a645c07eb$var$VI = (e1)=>({
        u_fill_translate: e1
    }), $785da19a645c07eb$var$qI = (e1)=>({
        u_fill_translate: e1
    }), $785da19a645c07eb$var$GI = (e1, t, i, n, a)=>$785da19a645c07eb$var$jI(e1, t, i, n, a), $785da19a645c07eb$var$HI = (e1, t, i, n, a)=>{
    let r, s, o = e1.transform, l = 0;
    if ("map" === i.paint.get("circle-pitch-alignment")) {
        let e1 = $785da19a645c07eb$var$qu(t, 1, o.zoom);
        r = !0, s = [
            e1,
            e1
        ], l = e1 / ($785da19a645c07eb$var$Vu * 2 ** t.tileID.overscaledZ) * 2 * Math.PI * a;
    } else r = !1, s = o.pixelsToGLUnits;
    return {
        u_scale_with_map: +("map" === i.paint.get("circle-pitch-scale")),
        u_pitch_with_map: +r,
        u_extrude_scale: s,
        u_globe_extrude_scale: l,
        u_translate: n
    };
}, $785da19a645c07eb$var$WI = (e1, t = 1)=>({
        u_color: e1,
        u_overlay: 0,
        u_overlay_scale: t
    }), $785da19a645c07eb$var$ZI = (e1, t, i, n)=>{
    let a = $785da19a645c07eb$var$qu(e1, 1, t) / ($785da19a645c07eb$var$Vu * 2 ** e1.tileID.overscaledZ) * 2 * Math.PI * n;
    return {
        u_extrude_scale: $785da19a645c07eb$var$qu(e1, 1, t),
        u_intensity: i,
        u_globe_extrude_scale: a
    };
}, $785da19a645c07eb$var$KI = (e1, t, i, n)=>{
    let a = $785da19a645c07eb$var$tu();
    return $785da19a645c07eb$var$du(a, 0, e1.width, e1.height, 0, 0, 1), {
        u_matrix: a,
        u_image: i,
        u_color_ramp: n,
        u_opacity: t.paint.get("heatmap-opacity")
    };
}, $785da19a645c07eb$var$XI = (e1, t, i)=>{
    let n, a = i.paint.get("hillshade-accent-color");
    switch(i.paint.get("hillshade-method")){
        case "basic":
            n = 4;
            break;
        case "combined":
            n = 1;
            break;
        case "igor":
            n = 2;
            break;
        case "multidirectional":
            n = 3;
            break;
        default:
            n = 0;
    }
    let r = i.getIlluminationProperties();
    for(let t = 0; t < r.directionRadians.length; t++)"viewport" === i.paint.get("hillshade-illumination-anchor") && (r.directionRadians[t] += e1.transform.bearingInRadians);
    return {
        u_image: 0,
        u_latrange: $785da19a645c07eb$var$YI(e1, t.tileID),
        u_exaggeration: i.paint.get("hillshade-exaggeration"),
        u_altitudes: r.altitudeRadians,
        u_azimuths: r.directionRadians,
        u_accent: a,
        u_method: n,
        u_highlights: r.highlightColor,
        u_shadows: r.shadowColor
    };
}, $785da19a645c07eb$var$QI = (e1, t)=>{
    let i = t.stride, n = $785da19a645c07eb$var$tu();
    return $785da19a645c07eb$var$du(n, 0, $785da19a645c07eb$var$Vu, -$785da19a645c07eb$var$Vu, 0, 0, 1), $785da19a645c07eb$var$su(n, n, [
        0,
        -$785da19a645c07eb$var$Vu,
        0
    ]), {
        u_matrix: n,
        u_image: 1,
        u_dimension: [
            i,
            i
        ],
        u_zoom: e1.overscaledZ,
        u_unpack: t.getUnpackVector()
    };
};
function $785da19a645c07eb$var$YI(e1, t) {
    let i = 2 ** t.canonical.z, n = t.canonical.y;
    return [
        new $785da19a645c07eb$var$Lx(0, n / i).toLngLat().lat,
        new $785da19a645c07eb$var$Lx(0, (n + 1) / i).toLngLat().lat
    ];
}
const $785da19a645c07eb$var$JI = (e1, t, i = 0)=>({
        u_image: 0,
        u_unpack: t.getUnpackVector(),
        u_dimension: [
            t.stride,
            t.stride
        ],
        u_elevation_stops: 1,
        u_color_stops: 4,
        u_color_ramp_size: i,
        u_opacity: e1.paint.get("color-relief-opacity")
    }), $785da19a645c07eb$var$$I = (e1, t, i, n)=>{
    let a = e1.transform;
    return {
        u_translation: $785da19a645c07eb$var$rF(e1, t, i),
        u_ratio: n / $785da19a645c07eb$var$qu(t, 1, a.zoom)
    };
}, $785da19a645c07eb$var$eF = (e1, t, i, n, a)=>$785da19a645c07eb$var$hh($785da19a645c07eb$var$$I(e1, t, i, n), {
        u_image: 0,
        u_image_height: a
    }), $785da19a645c07eb$var$tF = (e1, t, i, n, a)=>{
    let r = e1.transform, s = $785da19a645c07eb$var$aF(t, r);
    return {
        u_translation: $785da19a645c07eb$var$rF(e1, t, i),
        u_texsize: t.imageAtlasTexture.size,
        u_ratio: n / $785da19a645c07eb$var$qu(t, 1, r.zoom),
        u_image: 0,
        u_scale: [
            s,
            a.fromScale,
            a.toScale
        ],
        u_fade: a.t
    };
}, $785da19a645c07eb$var$iF = (e1, t, i, n, a)=>{
    let r = $785da19a645c07eb$var$aF(t, e1.transform);
    return $785da19a645c07eb$var$hh($785da19a645c07eb$var$$I(e1, t, i, n), {
        u_tileratio: r,
        u_crossfade_from: a.fromScale,
        u_crossfade_to: a.toScale,
        u_image: 0,
        u_mix: a.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
}, $785da19a645c07eb$var$nF = (e1, t, i, n, a, r)=>{
    let s = $785da19a645c07eb$var$aF(t, e1.transform);
    return $785da19a645c07eb$var$hh($785da19a645c07eb$var$$I(e1, t, i, n), {
        u_image: 0,
        u_image_height: r,
        u_tileratio: s,
        u_crossfade_from: a.fromScale,
        u_crossfade_to: a.toScale,
        u_image_dash: 1,
        u_mix: a.t,
        u_lineatlas_width: e1.lineAtlas.width,
        u_lineatlas_height: e1.lineAtlas.height
    });
};
function $785da19a645c07eb$var$aF(e1, t) {
    return 1 / $785da19a645c07eb$var$qu(e1, 1, t.tileZoom);
}
function $785da19a645c07eb$var$rF(e1, t, i) {
    return $785da19a645c07eb$var$Qu(e1.transform, t, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
}
const $785da19a645c07eb$var$sF = (e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m)=>({
        u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
        u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
        u_size_t: t ? t.uSizeT : 0,
        u_size: t ? t.uSize : 0,
        u_rotate_symbol: +i,
        u_label_plane_matrix: o,
        u_coord_matrix: l,
        u_is_text: +u,
        u_pitch_with_map: +n,
        u_is_along_line: a,
        u_is_variable_anchor: r,
        u_texsize: h,
        u_texture: 0,
        u_translation: c,
        u_pitched_scale: d,
        u_is_offset: p,
        u_height_anchor_ground: +m
    }), $785da19a645c07eb$var$oF = (e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g)=>{
    let f = s.transform;
    return $785da19a645c07eb$var$hh($785da19a645c07eb$var$sF(e1, t, i, n, a, r, 0, o, l, c, u, h, p, m, g), {
        u_gamma_scale: n ? Math.cos(f.pitch * Math.PI / 180) * f.cameraToCenterDistance : 1,
        u_is_halo: +!!d,
        u_is_plain: 1
    });
}, $785da19a645c07eb$var$lF = (e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m)=>$785da19a645c07eb$var$hh($785da19a645c07eb$var$oF(e1, t, i, n, a, r, s, o, l, c, !0, u, !0, d, p, m), {
        u_texsize_icon: h,
        u_texture_icon: 1
    }), $785da19a645c07eb$var$cF = (e1, t)=>({
        u_opacity: e1,
        u_color: t
    }), $785da19a645c07eb$var$uF = (e1, t, i, n, a)=>$785da19a645c07eb$var$hh(function(e1, t, i, n) {
        let a = i.patternAtlas.getPattern(e1.from.toString()), r = i.patternAtlas.getPattern(e1.to.toString()), { width: s, height: o } = i.patternAtlas.getPixelSize(), l = 2 ** n.tileID.overscaledZ, c = n.tileSize * 2 ** i.transform.tileZoom / l, u = c * (n.tileID.canonical.x + n.tileID.wrap * l), h = c * n.tileID.canonical.y;
        return {
            u_image: 0,
            u_pattern_tl_a: a.tl,
            u_pattern_br_a: a.br,
            u_pattern_tl_b: r.tl,
            u_pattern_br_b: r.br,
            u_texsize: [
                s,
                o
            ],
            u_mix: t.t,
            u_pattern_size_a: a.displaySize,
            u_pattern_size_b: r.displaySize,
            u_scale_a: t.fromScale,
            u_scale_b: t.toScale,
            u_tile_units_to_pixels: 1 / $785da19a645c07eb$var$qu(n, 1, i.transform.tileZoom),
            u_pixel_coord_upper: [
                u >> 16,
                h >> 16
            ],
            u_pixel_coord_lower: [
                65535 & u,
                65535 & h
            ]
        };
    }(i, a, t, n), {
        u_opacity: e1
    }), $785da19a645c07eb$var$hF = (e1, t)=>({}), $785da19a645c07eb$var$dF = {
    fillExtrusion: (e1, t)=>({
            u_lightpos: new $785da19a645c07eb$var$G_(e1, t.u_lightpos),
            u_lightpos_globe: new $785da19a645c07eb$var$G_(e1, t.u_lightpos_globe),
            u_lightintensity: new $785da19a645c07eb$var$V_(e1, t.u_lightintensity),
            u_lightcolor: new $785da19a645c07eb$var$G_(e1, t.u_lightcolor),
            u_vertical_gradient: new $785da19a645c07eb$var$V_(e1, t.u_vertical_gradient),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity),
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate)
        }),
    fillExtrusionPattern: (e1, t)=>({
            u_lightpos: new $785da19a645c07eb$var$G_(e1, t.u_lightpos),
            u_lightpos_globe: new $785da19a645c07eb$var$G_(e1, t.u_lightpos_globe),
            u_lightintensity: new $785da19a645c07eb$var$V_(e1, t.u_lightintensity),
            u_lightcolor: new $785da19a645c07eb$var$G_(e1, t.u_lightcolor),
            u_vertical_gradient: new $785da19a645c07eb$var$V_(e1, t.u_vertical_gradient),
            u_height_factor: new $785da19a645c07eb$var$V_(e1, t.u_height_factor),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity),
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_pixel_coord_upper: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_upper),
            u_pixel_coord_lower: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_lower),
            u_scale: new $785da19a645c07eb$var$G_(e1, t.u_scale),
            u_fade: new $785da19a645c07eb$var$V_(e1, t.u_fade)
        }),
    fill: (e1, t)=>({
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate)
        }),
    fillPattern: (e1, t)=>({
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_pixel_coord_upper: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_upper),
            u_pixel_coord_lower: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_lower),
            u_scale: new $785da19a645c07eb$var$G_(e1, t.u_scale),
            u_fade: new $785da19a645c07eb$var$V_(e1, t.u_fade),
            u_sdf_pattern: new $785da19a645c07eb$var$j_(e1, t.u_sdf_pattern),
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate)
        }),
    fillOutline: (e1, t)=>({
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate)
        }),
    fillOutlinePattern: (e1, t)=>({
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_pixel_coord_upper: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_upper),
            u_pixel_coord_lower: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_lower),
            u_scale: new $785da19a645c07eb$var$G_(e1, t.u_scale),
            u_fade: new $785da19a645c07eb$var$V_(e1, t.u_fade),
            u_sdf_pattern: new $785da19a645c07eb$var$j_(e1, t.u_sdf_pattern),
            u_fill_translate: new $785da19a645c07eb$var$q_(e1, t.u_fill_translate)
        }),
    circle: (e1, t)=>({
            u_scale_with_map: new $785da19a645c07eb$var$j_(e1, t.u_scale_with_map),
            u_pitch_with_map: new $785da19a645c07eb$var$j_(e1, t.u_pitch_with_map),
            u_extrude_scale: new $785da19a645c07eb$var$q_(e1, t.u_extrude_scale),
            u_globe_extrude_scale: new $785da19a645c07eb$var$V_(e1, t.u_globe_extrude_scale),
            u_translate: new $785da19a645c07eb$var$q_(e1, t.u_translate)
        }),
    collisionBox: $785da19a645c07eb$var$hF,
    collisionCircle: $785da19a645c07eb$var$hF,
    debug: (e1, t)=>({
            u_color: new $785da19a645c07eb$var$W_(e1, t.u_color),
            u_overlay: new $785da19a645c07eb$var$j_(e1, t.u_overlay),
            u_overlay_scale: new $785da19a645c07eb$var$V_(e1, t.u_overlay_scale)
        }),
    depth: $785da19a645c07eb$var$hF,
    clippingMask: $785da19a645c07eb$var$hF,
    heatmap: (e1, t)=>({
            u_extrude_scale: new $785da19a645c07eb$var$V_(e1, t.u_extrude_scale),
            u_intensity: new $785da19a645c07eb$var$V_(e1, t.u_intensity),
            u_globe_extrude_scale: new $785da19a645c07eb$var$V_(e1, t.u_globe_extrude_scale)
        }),
    heatmapTexture: (e1, t)=>({
            u_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_matrix),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_color_ramp: new $785da19a645c07eb$var$j_(e1, t.u_color_ramp),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity)
        }),
    hillshade: (e1, t)=>({
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_latrange: new $785da19a645c07eb$var$q_(e1, t.u_latrange),
            u_exaggeration: new $785da19a645c07eb$var$V_(e1, t.u_exaggeration),
            u_altitudes: new $785da19a645c07eb$var$K_(e1, t.u_altitudes),
            u_azimuths: new $785da19a645c07eb$var$K_(e1, t.u_azimuths),
            u_accent: new $785da19a645c07eb$var$W_(e1, t.u_accent),
            u_method: new $785da19a645c07eb$var$j_(e1, t.u_method),
            u_shadows: new $785da19a645c07eb$var$Z_(e1, t.u_shadows),
            u_highlights: new $785da19a645c07eb$var$Z_(e1, t.u_highlights)
        }),
    hillshadePrepare: (e1, t)=>({
            u_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_matrix),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_dimension: new $785da19a645c07eb$var$q_(e1, t.u_dimension),
            u_zoom: new $785da19a645c07eb$var$V_(e1, t.u_zoom),
            u_unpack: new $785da19a645c07eb$var$H_(e1, t.u_unpack)
        }),
    colorRelief: (e1, t)=>({
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_unpack: new $785da19a645c07eb$var$H_(e1, t.u_unpack),
            u_dimension: new $785da19a645c07eb$var$q_(e1, t.u_dimension),
            u_elevation_stops: new $785da19a645c07eb$var$j_(e1, t.u_elevation_stops),
            u_color_stops: new $785da19a645c07eb$var$j_(e1, t.u_color_stops),
            u_color_ramp_size: new $785da19a645c07eb$var$j_(e1, t.u_color_ramp_size),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity)
        }),
    line: (e1, t)=>({
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_ratio: new $785da19a645c07eb$var$V_(e1, t.u_ratio)
        }),
    lineGradient: (e1, t)=>({
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_ratio: new $785da19a645c07eb$var$V_(e1, t.u_ratio),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_image_height: new $785da19a645c07eb$var$V_(e1, t.u_image_height)
        }),
    linePattern: (e1, t)=>({
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_ratio: new $785da19a645c07eb$var$V_(e1, t.u_ratio),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_scale: new $785da19a645c07eb$var$G_(e1, t.u_scale),
            u_fade: new $785da19a645c07eb$var$V_(e1, t.u_fade)
        }),
    lineSDF: (e1, t)=>({
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_ratio: new $785da19a645c07eb$var$V_(e1, t.u_ratio),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_mix: new $785da19a645c07eb$var$V_(e1, t.u_mix),
            u_tileratio: new $785da19a645c07eb$var$V_(e1, t.u_tileratio),
            u_crossfade_from: new $785da19a645c07eb$var$V_(e1, t.u_crossfade_from),
            u_crossfade_to: new $785da19a645c07eb$var$V_(e1, t.u_crossfade_to),
            u_lineatlas_width: new $785da19a645c07eb$var$V_(e1, t.u_lineatlas_width),
            u_lineatlas_height: new $785da19a645c07eb$var$V_(e1, t.u_lineatlas_height)
        }),
    lineGradientSDF: (e1, t)=>({
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_ratio: new $785da19a645c07eb$var$V_(e1, t.u_ratio),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_image_height: new $785da19a645c07eb$var$V_(e1, t.u_image_height),
            u_tileratio: new $785da19a645c07eb$var$V_(e1, t.u_tileratio),
            u_crossfade_from: new $785da19a645c07eb$var$V_(e1, t.u_crossfade_from),
            u_crossfade_to: new $785da19a645c07eb$var$V_(e1, t.u_crossfade_to),
            u_image_dash: new $785da19a645c07eb$var$j_(e1, t.u_image_dash),
            u_mix: new $785da19a645c07eb$var$V_(e1, t.u_mix),
            u_lineatlas_width: new $785da19a645c07eb$var$V_(e1, t.u_lineatlas_width),
            u_lineatlas_height: new $785da19a645c07eb$var$V_(e1, t.u_lineatlas_height)
        }),
    layerOpacity: (e1, t)=>({
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity)
        }),
    raster: (e1, t)=>({
            u_tl_parent: new $785da19a645c07eb$var$q_(e1, t.u_tl_parent),
            u_scale_parent: new $785da19a645c07eb$var$V_(e1, t.u_scale_parent),
            u_buffer_scale: new $785da19a645c07eb$var$V_(e1, t.u_buffer_scale),
            u_image_warp: new $785da19a645c07eb$var$G_(e1, t.u_image_warp),
            u_fade_t: new $785da19a645c07eb$var$V_(e1, t.u_fade_t),
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity),
            u_image0: new $785da19a645c07eb$var$j_(e1, t.u_image0),
            u_image1: new $785da19a645c07eb$var$j_(e1, t.u_image1),
            u_brightness_low: new $785da19a645c07eb$var$V_(e1, t.u_brightness_low),
            u_brightness_high: new $785da19a645c07eb$var$V_(e1, t.u_brightness_high),
            u_saturation_factor: new $785da19a645c07eb$var$V_(e1, t.u_saturation_factor),
            u_contrast_factor: new $785da19a645c07eb$var$V_(e1, t.u_contrast_factor),
            u_spin_weights: new $785da19a645c07eb$var$G_(e1, t.u_spin_weights),
            u_coords_top: new $785da19a645c07eb$var$H_(e1, t.u_coords_top),
            u_coords_bottom: new $785da19a645c07eb$var$H_(e1, t.u_coords_bottom)
        }),
    symbolIcon: (e1, t)=>({
            u_is_size_zoom_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_zoom_constant),
            u_is_size_feature_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_feature_constant),
            u_size_t: new $785da19a645c07eb$var$V_(e1, t.u_size_t),
            u_size: new $785da19a645c07eb$var$V_(e1, t.u_size),
            u_rotate_symbol: new $785da19a645c07eb$var$j_(e1, t.u_rotate_symbol),
            u_label_plane_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_label_plane_matrix),
            u_coord_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_coord_matrix),
            u_is_text: new $785da19a645c07eb$var$j_(e1, t.u_is_text),
            u_pitch_with_map: new $785da19a645c07eb$var$j_(e1, t.u_pitch_with_map),
            u_is_along_line: new $785da19a645c07eb$var$j_(e1, t.u_is_along_line),
            u_is_variable_anchor: new $785da19a645c07eb$var$j_(e1, t.u_is_variable_anchor),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_texture: new $785da19a645c07eb$var$j_(e1, t.u_texture),
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_pitched_scale: new $785da19a645c07eb$var$V_(e1, t.u_pitched_scale),
            u_is_offset: new $785da19a645c07eb$var$j_(e1, t.u_is_offset),
            u_height_anchor_ground: new $785da19a645c07eb$var$j_(e1, t.u_height_anchor_ground)
        }),
    symbolSDF: (e1, t)=>({
            u_is_size_zoom_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_zoom_constant),
            u_is_size_feature_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_feature_constant),
            u_size_t: new $785da19a645c07eb$var$V_(e1, t.u_size_t),
            u_size: new $785da19a645c07eb$var$V_(e1, t.u_size),
            u_rotate_symbol: new $785da19a645c07eb$var$j_(e1, t.u_rotate_symbol),
            u_label_plane_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_label_plane_matrix),
            u_coord_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_coord_matrix),
            u_is_text: new $785da19a645c07eb$var$j_(e1, t.u_is_text),
            u_pitch_with_map: new $785da19a645c07eb$var$j_(e1, t.u_pitch_with_map),
            u_is_along_line: new $785da19a645c07eb$var$j_(e1, t.u_is_along_line),
            u_is_variable_anchor: new $785da19a645c07eb$var$j_(e1, t.u_is_variable_anchor),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_texture: new $785da19a645c07eb$var$j_(e1, t.u_texture),
            u_gamma_scale: new $785da19a645c07eb$var$V_(e1, t.u_gamma_scale),
            u_is_halo: new $785da19a645c07eb$var$j_(e1, t.u_is_halo),
            u_is_plain: new $785da19a645c07eb$var$j_(e1, t.u_is_plain),
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_pitched_scale: new $785da19a645c07eb$var$V_(e1, t.u_pitched_scale),
            u_is_offset: new $785da19a645c07eb$var$j_(e1, t.u_is_offset),
            u_height_anchor_ground: new $785da19a645c07eb$var$j_(e1, t.u_height_anchor_ground)
        }),
    symbolTextAndIcon: (e1, t)=>({
            u_is_size_zoom_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_zoom_constant),
            u_is_size_feature_constant: new $785da19a645c07eb$var$j_(e1, t.u_is_size_feature_constant),
            u_size_t: new $785da19a645c07eb$var$V_(e1, t.u_size_t),
            u_size: new $785da19a645c07eb$var$V_(e1, t.u_size),
            u_rotate_symbol: new $785da19a645c07eb$var$j_(e1, t.u_rotate_symbol),
            u_label_plane_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_label_plane_matrix),
            u_coord_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_coord_matrix),
            u_is_text: new $785da19a645c07eb$var$j_(e1, t.u_is_text),
            u_pitch_with_map: new $785da19a645c07eb$var$j_(e1, t.u_pitch_with_map),
            u_is_along_line: new $785da19a645c07eb$var$j_(e1, t.u_is_along_line),
            u_is_variable_anchor: new $785da19a645c07eb$var$j_(e1, t.u_is_variable_anchor),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_texsize_icon: new $785da19a645c07eb$var$q_(e1, t.u_texsize_icon),
            u_texture: new $785da19a645c07eb$var$j_(e1, t.u_texture),
            u_texture_icon: new $785da19a645c07eb$var$j_(e1, t.u_texture_icon),
            u_gamma_scale: new $785da19a645c07eb$var$V_(e1, t.u_gamma_scale),
            u_is_halo: new $785da19a645c07eb$var$j_(e1, t.u_is_halo),
            u_translation: new $785da19a645c07eb$var$q_(e1, t.u_translation),
            u_pitched_scale: new $785da19a645c07eb$var$V_(e1, t.u_pitched_scale),
            u_is_offset: new $785da19a645c07eb$var$j_(e1, t.u_is_offset),
            u_height_anchor_ground: new $785da19a645c07eb$var$j_(e1, t.u_height_anchor_ground)
        }),
    background: (e1, t)=>({
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity),
            u_color: new $785da19a645c07eb$var$W_(e1, t.u_color)
        }),
    backgroundPattern: (e1, t)=>({
            u_opacity: new $785da19a645c07eb$var$V_(e1, t.u_opacity),
            u_image: new $785da19a645c07eb$var$j_(e1, t.u_image),
            u_pattern_tl_a: new $785da19a645c07eb$var$q_(e1, t.u_pattern_tl_a),
            u_pattern_br_a: new $785da19a645c07eb$var$q_(e1, t.u_pattern_br_a),
            u_pattern_tl_b: new $785da19a645c07eb$var$q_(e1, t.u_pattern_tl_b),
            u_pattern_br_b: new $785da19a645c07eb$var$q_(e1, t.u_pattern_br_b),
            u_texsize: new $785da19a645c07eb$var$q_(e1, t.u_texsize),
            u_mix: new $785da19a645c07eb$var$V_(e1, t.u_mix),
            u_pattern_size_a: new $785da19a645c07eb$var$q_(e1, t.u_pattern_size_a),
            u_pattern_size_b: new $785da19a645c07eb$var$q_(e1, t.u_pattern_size_b),
            u_scale_a: new $785da19a645c07eb$var$V_(e1, t.u_scale_a),
            u_scale_b: new $785da19a645c07eb$var$V_(e1, t.u_scale_b),
            u_pixel_coord_upper: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_upper),
            u_pixel_coord_lower: new $785da19a645c07eb$var$q_(e1, t.u_pixel_coord_lower),
            u_tile_units_to_pixels: new $785da19a645c07eb$var$V_(e1, t.u_tile_units_to_pixels)
        }),
    terrain: (e1, t)=>({
            u_texture: new $785da19a645c07eb$var$j_(e1, t.u_texture),
            u_ele_delta: new $785da19a645c07eb$var$V_(e1, t.u_ele_delta),
            u_fog_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_fog_matrix),
            u_fog_color: new $785da19a645c07eb$var$W_(e1, t.u_fog_color),
            u_fog_ground_blend: new $785da19a645c07eb$var$V_(e1, t.u_fog_ground_blend),
            u_fog_ground_blend_opacity: new $785da19a645c07eb$var$V_(e1, t.u_fog_ground_blend_opacity),
            u_horizon_color: new $785da19a645c07eb$var$W_(e1, t.u_horizon_color),
            u_horizon_fog_blend: new $785da19a645c07eb$var$V_(e1, t.u_horizon_fog_blend),
            u_is_globe_mode: new $785da19a645c07eb$var$V_(e1, t.u_is_globe_mode)
        }),
    terrainDepth: (e1, t)=>({
            u_ele_delta: new $785da19a645c07eb$var$V_(e1, t.u_ele_delta)
        }),
    atmosphere: (e1, t)=>({
            u_sun_pos: new $785da19a645c07eb$var$G_(e1, t.u_sun_pos),
            u_atmosphere_blend: new $785da19a645c07eb$var$V_(e1, t.u_atmosphere_blend),
            u_globe_position: new $785da19a645c07eb$var$G_(e1, t.u_globe_position),
            u_globe_radius: new $785da19a645c07eb$var$V_(e1, t.u_globe_radius),
            u_inv_proj_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_inv_proj_matrix)
        }),
    sky: (e1, t)=>({
            u_sky_color: new $785da19a645c07eb$var$W_(e1, t.u_sky_color),
            u_horizon_color: new $785da19a645c07eb$var$W_(e1, t.u_horizon_color),
            u_horizon: new $785da19a645c07eb$var$q_(e1, t.u_horizon),
            u_horizon_normal: new $785da19a645c07eb$var$q_(e1, t.u_horizon_normal),
            u_sky_horizon_blend: new $785da19a645c07eb$var$V_(e1, t.u_sky_horizon_blend),
            u_sky_blend: new $785da19a645c07eb$var$V_(e1, t.u_sky_blend),
            u_inv_proj_matrix: new $785da19a645c07eb$var$Q_(e1, t.u_inv_proj_matrix),
            u_globe_position: new $785da19a645c07eb$var$G_(e1, t.u_globe_position),
            u_globe_radius: new $785da19a645c07eb$var$V_(e1, t.u_globe_radius)
        })
};
var $785da19a645c07eb$var$pF = class {
    constructor(e1, t, i){
        this.context = e1;
        let n = e1.gl;
        this.buffer = n.createBuffer(), this.dynamicDraw = !!i, this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindElementBuffer.set(this.buffer);
    }
    updateData(e1) {
        let t = this.context.gl;
        if (!this.dynamicDraw) throw Error("Attempted to update data while not in dynamic mode.");
        this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
};
const $785da19a645c07eb$var$mF = {
    Int8: "BYTE",
    Uint8: "UNSIGNED_BYTE",
    Int16: "SHORT",
    Uint16: "UNSIGNED_SHORT",
    Int32: "INT",
    Uint32: "UNSIGNED_INT",
    Float32: "FLOAT"
};
var $785da19a645c07eb$var$gF = class {
    constructor(e1, t, i, n){
        this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = n, this.context = e1;
        let a = e1.gl;
        this.buffer = a.createBuffer(), e1.bindVertexBuffer.set(this.buffer), a.bufferData(a.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || t.freeBufferAfterUpload();
    }
    bind() {
        this.context.bindVertexBuffer.set(this.buffer);
    }
    updateData(e1) {
        if (e1.length !== this.length) throw Error(`Length of new data is ${e1.length}, which doesn't match current length of ${this.length}`);
        let t = this.context.gl;
        this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
    }
    enableAttributes(e1, t) {
        for (let i of this.attributes){
            let n = t.attributes[i.name];
            void 0 !== n && e1.enableVertexAttribArray(n.location);
        }
    }
    setVertexAttribPointers(e1, t, i) {
        for (let n of this.attributes){
            let a = t.attributes[n.name];
            if (void 0 !== a) {
                let t = n.offset + this.itemSize * (i || 0);
                a.isInteger ? e1.vertexAttribIPointer(a.location, n.components, e1[$785da19a645c07eb$var$mF[n.type]], this.itemSize, t) : e1.vertexAttribPointer(a.location, n.components, e1[$785da19a645c07eb$var$mF[n.type]], !1, this.itemSize, t);
            }
        }
    }
    destroy() {
        let e1 = this.context.gl;
        this.buffer && (e1.deleteBuffer(this.buffer), delete this.buffer);
    }
}, $785da19a645c07eb$var$fF = class {
    constructor(e1){
        this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
    }
    get() {
        return this.current;
    }
    set(e1) {}
    getDefault() {
        return this.default;
    }
    setDefault() {
        this.set(this.default);
    }
}, $785da19a645c07eb$var$AF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return $785da19a645c07eb$var$np.transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$_F = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return 1;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$vF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return 0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$yF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return [
            !0,
            !0,
            !0,
            !0
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$xF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$bF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return 255;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$wF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return {
            func: this.gl.ALWAYS,
            ref: 0,
            mask: 255
        };
    }
    set(e1) {
        let t = this.current;
        (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$EF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.KEEP,
            e1.KEEP,
            e1.KEEP
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$kF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$SF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return [
            0,
            1
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$MF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$CF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return this.gl.LESS;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$TF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$DF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        let e1 = this.gl;
        return [
            e1.ONE,
            e1.ZERO
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$PF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return $785da19a645c07eb$var$np.transparent;
    }
    set(e1) {
        let t = this.current;
        (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$IF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return this.gl.FUNC_ADD;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$FF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$zF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return this.gl.BACK;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$RF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return this.gl.CCW;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$LF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$BF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return this.gl.TEXTURE0;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$OF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        let e1 = this.gl;
        return [
            0,
            0,
            e1.drawingBufferWidth,
            e1.drawingBufferHeight
        ];
    }
    set(e1) {
        let t = this.current;
        (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$UF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$NF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$jF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$VF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$qF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        let t = this.gl;
        t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$GF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return null;
    }
    set(e1) {
        (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
    }
}, $785da19a645c07eb$var$HF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return 4;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$WF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$ZF = class extends $785da19a645c07eb$var$fF {
    getDefault() {
        return !1;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        let t = this.gl;
        t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$KF = class extends $785da19a645c07eb$var$fF {
    constructor(e1, t){
        super(e1), this.context = e1, this.parent = t;
    }
    getDefault() {
        return null;
    }
}, $785da19a645c07eb$var$XF = class extends $785da19a645c07eb$var$KF {
    setDirty() {
        this.dirty = !0;
    }
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$QF = class extends $785da19a645c07eb$var$KF {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$YF = class extends $785da19a645c07eb$var$KF {
    set(e1) {
        if (e1 === this.current && !this.dirty) return;
        this.context.bindFramebuffer.set(this.parent);
        let t = this.gl;
        t.framebufferRenderbuffer(t.FRAMEBUFFER, t.DEPTH_STENCIL_ATTACHMENT, t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
    }
}, $785da19a645c07eb$var$JF = class {
    constructor(e1, t, i, n, a){
        this.context = e1, this.width = t, this.height = i;
        let r = e1.gl, s = this.framebuffer = r.createFramebuffer();
        if (this.colorAttachment = new $785da19a645c07eb$var$XF(e1, s), n) this.depthAttachment = a ? new $785da19a645c07eb$var$YF(e1, s) : new $785da19a645c07eb$var$QF(e1, s);
        else if (a) throw Error("Stencil cannot be set without depth");
    }
    destroy() {
        let e1 = this.context.gl, t = this.colorAttachment.get();
        if (t && e1.deleteTexture(t), this.depthAttachment) {
            let t = this.depthAttachment.get();
            t && e1.deleteRenderbuffer(t);
        }
        e1.deleteFramebuffer(this.framebuffer);
    }
};
const $785da19a645c07eb$var$$F = $785da19a645c07eb$var$DI([
    {
        name: "u_units_to_pixels",
        type: "vec2"
    },
    {
        name: "u_world_size",
        type: "vec2"
    },
    {
        name: "u_camera_to_center_distance",
        type: "float"
    },
    {
        name: "u_symbol_fade_change",
        type: "float"
    },
    {
        name: "u_aspect_ratio",
        type: "float"
    },
    {
        name: "u_device_pixel_ratio",
        type: "float"
    },
    {
        name: "u_viewport_size",
        type: "vec2"
    },
    {
        name: "u_pixel_extrude_scale",
        type: "vec2"
    },
    {
        name: "u_pitch",
        type: "float"
    }
]), $785da19a645c07eb$var$ez = $785da19a645c07eb$var$$F.offsets;
var $785da19a645c07eb$var$tz = class {
    constructor(e1, t, i){
        this.blendFunction = e1, this.blendColor = t, this.mask = i;
    }
};
$785da19a645c07eb$var$tz.Replace = [
    1,
    0
], $785da19a645c07eb$var$tz.disabled = new $785da19a645c07eb$var$tz($785da19a645c07eb$var$tz.Replace, $785da19a645c07eb$var$np.transparent, [
    !1,
    !1,
    !1,
    !1
]), $785da19a645c07eb$var$tz.unblended = new $785da19a645c07eb$var$tz($785da19a645c07eb$var$tz.Replace, $785da19a645c07eb$var$np.transparent, [
    !0,
    !0,
    !0,
    !0
]), $785da19a645c07eb$var$tz.alphaBlended = new $785da19a645c07eb$var$tz([
    1,
    771
], $785da19a645c07eb$var$np.transparent, [
    !0,
    !0,
    !0,
    !0
]);
var $785da19a645c07eb$var$iz = class {
    constructor(e1){
        this.gl = e1, this.clearColor = new $785da19a645c07eb$var$AF(this), this.clearDepth = new $785da19a645c07eb$var$_F(this), this.clearStencil = new $785da19a645c07eb$var$vF(this), this.colorMask = new $785da19a645c07eb$var$yF(this), this.depthMask = new $785da19a645c07eb$var$xF(this), this.stencilMask = new $785da19a645c07eb$var$bF(this), this.stencilFunc = new $785da19a645c07eb$var$wF(this), this.stencilOp = new $785da19a645c07eb$var$EF(this), this.stencilTest = new $785da19a645c07eb$var$kF(this), this.depthRange = new $785da19a645c07eb$var$SF(this), this.depthTest = new $785da19a645c07eb$var$MF(this), this.depthFunc = new $785da19a645c07eb$var$CF(this), this.blend = new $785da19a645c07eb$var$TF(this), this.blendFunc = new $785da19a645c07eb$var$DF(this), this.blendColor = new $785da19a645c07eb$var$PF(this), this.blendEquation = new $785da19a645c07eb$var$IF(this), this.cullFace = new $785da19a645c07eb$var$FF(this), this.cullFaceSide = new $785da19a645c07eb$var$zF(this), this.frontFace = new $785da19a645c07eb$var$RF(this), this.program = new $785da19a645c07eb$var$LF(this), this.activeTexture = new $785da19a645c07eb$var$BF(this), this.viewport = new $785da19a645c07eb$var$OF(this), this.bindFramebuffer = new $785da19a645c07eb$var$UF(this), this.bindRenderbuffer = new $785da19a645c07eb$var$NF(this), this.bindTexture = new $785da19a645c07eb$var$jF(this), this.bindVertexBuffer = new $785da19a645c07eb$var$VF(this), this.bindElementBuffer = new $785da19a645c07eb$var$qF(this), this.bindVertexArray = new $785da19a645c07eb$var$GF(this), this.pixelStoreUnpack = new $785da19a645c07eb$var$HF(this), this.pixelStoreUnpackPremultiplyAlpha = new $785da19a645c07eb$var$WF(this), this.pixelStoreUnpackFlipY = new $785da19a645c07eb$var$ZF(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), e1.getExtension("EXT_color_buffer_half_float"), e1.getExtension("EXT_color_buffer_float"), this.projectionUniformBuffer = function(e1) {
            return new $785da19a645c07eb$var$PI(e1, $785da19a645c07eb$var$CI.ProjectionUBO, $785da19a645c07eb$var$II);
        }(this), this.terrainUniformBuffer = function(e1) {
            return new $785da19a645c07eb$var$PI(e1, $785da19a645c07eb$var$CI.TerrainUBO, $785da19a645c07eb$var$zI);
        }(this), this.frameUniformBuffer = function(e1) {
            return new $785da19a645c07eb$var$PI(e1, $785da19a645c07eb$var$CI.FrameUBO, $785da19a645c07eb$var$$F);
        }(this);
    }
    setDefault() {
        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    setDirty() {
        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0, this.projectionUniformBuffer.bindingDirty = !0, this.terrainUniformBuffer.bindingDirty = !0, this.frameUniformBuffer.bindingDirty = !0;
    }
    setCustomLayerDefaults() {
        this.unbindVAO(), this.cullFace.setDefault(), this.activeTexture.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
    }
    createIndexBuffer(e1, t) {
        return new $785da19a645c07eb$var$pF(this, e1, t);
    }
    createVertexBuffer(e1, t, i) {
        return new $785da19a645c07eb$var$gF(this, e1, t, i);
    }
    createRenderbuffer(e1, t, i) {
        let n = this.gl, a = n.createRenderbuffer();
        return this.bindRenderbuffer.set(a), n.renderbufferStorage(n.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), a;
    }
    createFramebuffer(e1, t, i, n) {
        return new $785da19a645c07eb$var$JF(this, e1, t, i, n);
    }
    clear({ color: e1, depth: t, stencil: i }) {
        let n = this.gl, a = 0;
        e1 && (a |= n.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set([
            !0,
            !0,
            !0,
            !0
        ])), void 0 !== t && (a |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
            0,
            1
        ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (a |= n.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), n.clear(a);
    }
    setCullFace(e1) {
        !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
    }
    setDepthMode(e1) {
        e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
    }
    setStencilMode(e1) {
        e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
            e1.fail,
            e1.depthFail,
            e1.pass
        ]), this.stencilFunc.set({
            func: e1.test.func,
            ref: e1.ref,
            mask: e1.test.mask
        })) : this.stencilTest.set(!1);
    }
    setColorMode(e1) {
        $785da19a645c07eb$var$yh(e1.blendFunction, $785da19a645c07eb$var$tz.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
    }
    createVertexArray() {
        return this.gl.createVertexArray();
    }
    deleteVertexArray(e1) {
        this.gl.deleteVertexArray(e1);
    }
    unbindVAO() {
        this.bindVertexArray.set(null);
    }
}, $785da19a645c07eb$var$nz = class {
    constructor(e1, t, i){
        this.func = e1, this.mask = t, this.range = i;
    }
};
$785da19a645c07eb$var$nz.ReadOnly = !1, $785da19a645c07eb$var$nz.ReadWrite = !0, $785da19a645c07eb$var$nz.disabled = new $785da19a645c07eb$var$nz(519, $785da19a645c07eb$var$nz.ReadOnly, [
    0,
    1
]);
const $785da19a645c07eb$var$az = 7680;
var $785da19a645c07eb$var$rz = class {
    constructor(e1, t, i, n, a, r){
        this.test = e1, this.ref = t, this.mask = i, this.fail = n, this.depthFail = a, this.pass = r;
    }
};
$785da19a645c07eb$var$rz.disabled = new $785da19a645c07eb$var$rz({
    func: 519,
    mask: 0
}, 0, 0, $785da19a645c07eb$var$az, $785da19a645c07eb$var$az, $785da19a645c07eb$var$az);
const $785da19a645c07eb$var$sz = 2305;
var $785da19a645c07eb$var$oz = class {
    constructor(e1, t, i){
        this.enable = e1, this.mode = t, this.frontFace = i;
    }
};
let $785da19a645c07eb$var$lz;
function $785da19a645c07eb$var$cz(e1, t, i, n, a) {
    let r = e1.context, s = e1.transform, o = r.gl, l = e1.useProgram("collisionBox"), c = [], u = 0, h = 0;
    for (let d of n){
        let n = t.getTile(d).getBucket(i);
        if (!n) continue;
        let p = a ? n.textCollisionBox : n.iconCollisionBox, m = n.collisionCircleArray;
        m.length > 0 && (c.push({
            circleArray: m,
            circleOffset: h,
            coord: d
        }), u += m.length / 4, h = u), p && l.draw(r, o.LINES, $785da19a645c07eb$var$nz.disabled, $785da19a645c07eb$var$rz.disabled, e1.colorModeForRenderPass(), $785da19a645c07eb$var$oz.disabled, null, e1.style.map.terrain?.getTerrainData(d), s.getProjectionData({
            overscaledTileID: d,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !0
        }), i.id, p.layoutVertexBuffer, p.indexBuffer, p.segments, null, e1.transform.zoom, null, null, p.collisionVertexBuffer);
    }
    if (!a || !c.length) return;
    let d = e1.useProgram("collisionCircle"), p = new $785da19a645c07eb$var$b_;
    p.resize(4 * u), p._trim();
    let m = 0;
    for (let e1 of c)for(let t = 0; t < e1.circleArray.length / 4; t++){
        let i = 4 * t, n = e1.circleArray[i + 0], a = e1.circleArray[i + 1], r = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
        p.emplace(m++, n, a, r, s, 0), p.emplace(m++, n, a, r, s, 1), p.emplace(m++, n, a, r, s, 2), p.emplace(m++, n, a, r, s, 3);
    }
    (!$785da19a645c07eb$var$lz || $785da19a645c07eb$var$lz.length < 2 * u) && ($785da19a645c07eb$var$lz = function(e1) {
        let t = 2 * e1, i = new $785da19a645c07eb$var$E_;
        i.resize(t), i._trim();
        for(let e1 = 0; e1 < t; e1++){
            let t = 6 * e1;
            i.uint16[t + 0] = 4 * e1 + 0, i.uint16[t + 1] = 4 * e1 + 1, i.uint16[t + 2] = 4 * e1 + 2, i.uint16[t + 3] = 4 * e1 + 2, i.uint16[t + 4] = 4 * e1 + 3, i.uint16[t + 5] = 4 * e1 + 0;
        }
        return i;
    }(u));
    let g = r.createIndexBuffer($785da19a645c07eb$var$lz, !0), f = r.createVertexBuffer(p, $785da19a645c07eb$var$_b.members, !0);
    for (let t of c)d.draw(r, o.TRIANGLES, $785da19a645c07eb$var$nz.disabled, $785da19a645c07eb$var$rz.disabled, e1.colorModeForRenderPass(), $785da19a645c07eb$var$oz.disabled, null, e1.style.map.terrain?.getTerrainData(t.coord), null, i.id, f, g, $785da19a645c07eb$var$T_.simpleSegment(0, 2 * t.circleOffset, t.circleArray.length, t.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
    f.destroy(), g.destroy();
}
$785da19a645c07eb$var$oz.disabled = new $785da19a645c07eb$var$oz(!1, 1029, $785da19a645c07eb$var$sz), $785da19a645c07eb$var$oz.backCCW = new $785da19a645c07eb$var$oz(!0, 1029, $785da19a645c07eb$var$sz), $785da19a645c07eb$var$oz.frontCCW = new $785da19a645c07eb$var$oz(!0, 1028, $785da19a645c07eb$var$sz);
const $785da19a645c07eb$var$uz = $785da19a645c07eb$var$nu(new Float32Array(16));
function $785da19a645c07eb$var$hz(e1, t, i, n, a, r) {
    let { horizontalAlign: s, verticalAlign: o } = $785da19a645c07eb$var$Pw(e1), l = -(o - .5) * i;
    return new $785da19a645c07eb$var$Kc((-(s - .5) * t / a + n[0]) * r, (l / a + n[1]) * r);
}
function $785da19a645c07eb$var$dz(e1, t, i, n, a, r) {
    let s = t.tileAnchorPoint.add(new $785da19a645c07eb$var$Kc(t.translation[0], t.translation[1]));
    if (t.pitchWithMap) {
        let e1 = n.mult(r);
        i || (e1 = e1.rotate(-a));
        let o = s.add(e1);
        return $785da19a645c07eb$var$kD(o.x, o.y, t.pitchedLabelPlaneMatrix, $785da19a645c07eb$var$ED(t, o.x, o.y)).point;
    }
    if (i) {
        let i = $785da19a645c07eb$var$zD(t.tileAnchorPoint.x + 1, t.tileAnchorPoint.y, t).point.sub(e1), a = Math.atan(i.y / i.x) + (i.x < 0 ? Math.PI : 0);
        return e1.add(n.rotate(a));
    }
    return e1.add(n);
}
function $785da19a645c07eb$var$pz(e1, t, i, n, a, r, s, o, l, c, u, h, d) {
    let p = e1.text.placedSymbolArray, m = e1.text.dynamicLayoutVertexArray, g = e1.icon.dynamicLayoutVertexArray, f = {};
    m.clear();
    for(let g = 0; g < p.length; g++){
        let A = p.get(g), _ = e1.allowVerticalPlacement && !A.placedOrientation, v = A.hidden || !A.crossTileID || _ ? null : n[A.crossTileID];
        if (v) {
            let n = new $785da19a645c07eb$var$Kc(A.anchorX, A.anchorY), p = {
                getElevation: h,
                heightOffset: A.heightOffset,
                heightAnchorGround: d,
                width: a.width,
                height: a.height,
                pitchedLabelPlaneMatrix: r,
                pitchWithMap: i,
                transform: a,
                tileAnchorPoint: n,
                translation: c,
                unwrappedTileID: u
            }, g = i ? $785da19a645c07eb$var$LD(n.x, n.y, p) : $785da19a645c07eb$var$zD(n.x, n.y, p), _ = $785da19a645c07eb$var$SD(a.cameraToCenterDistance, g.signedDistanceFromCamera), y = $785da19a645c07eb$var$Zw(e1.textSizeData, o, A) * _ / 24;
            i && (y *= e1.tilePixelRatio / s);
            let { width: x, height: b, anchor: w, textOffset: E, textBoxScale: k } = v, S = $785da19a645c07eb$var$hz(w, x, b, E, k, y), M = a.getPitchedTextCorrection(n.x + c[0], n.y + c[1], u), C = $785da19a645c07eb$var$dz(g.point, p, t, S, -a.bearingInRadians, M), T = e1.allowVerticalPlacement && 2 === A.placedOrientation ? Math.PI / 2 : 0;
            for(let e1 = 0; e1 < A.numGlyphs; e1++)$785da19a645c07eb$var$SE(m, C, T);
            l && A.associatedIconIndex >= 0 && (f[A.associatedIconIndex] = {
                shiftedAnchor: C,
                angle: T
            });
        } else $785da19a645c07eb$var$jD(A.numGlyphs, m);
    }
    if (l) {
        g.clear();
        let t = e1.icon.placedSymbolArray;
        for(let e1 = 0; e1 < t.length; e1++){
            let i = t.get(e1);
            if (i.hidden) $785da19a645c07eb$var$jD(i.numGlyphs, g);
            else {
                let t = f[e1];
                if (t) for(let e1 = 0; e1 < i.numGlyphs; e1++)$785da19a645c07eb$var$SE(g, t.shiftedAnchor, t.angle);
                else $785da19a645c07eb$var$jD(i.numGlyphs, g);
            }
        }
        e1.icon.dynamicLayoutVertexBuffer.updateData(g);
    }
    e1.text.dynamicLayoutVertexBuffer.updateData(m);
}
function $785da19a645c07eb$var$mz(e1, t, i) {
    return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
}
function $785da19a645c07eb$var$gz(e1, t, i, n, a, r, s, o, l, c, u, h, d) {
    let p = e1.context, m = p.gl, g = e1.transform, f = "map" === o, A = "map" === l, _ = "viewport" !== o && "point" !== i.layout.get("symbol-placement"), v = f && !A && !_, y = !i.layout.get("symbol-sort-key").isConstant(), x = !1, b = e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly), w = i._unevaluatedLayout.hasValue("text-variable-anchor") || i._unevaluatedLayout.hasValue("text-variable-anchor-offset"), E = [], k = g.getCircleRadiusCorrection();
    for (let o of n){
        let n = t.getTile(o), l = n.getBucket(i);
        if (!l) continue;
        let u = a ? l.text : l.icon;
        if (!u?.segments.get().length || !u.hasVisibleVertices) continue;
        let h, p, b, S, M = u.programConfigurations.get(i.id), C = a || l.sdfIcons, T = a ? l.textSizeData : l.iconSizeData, D = A || 0 !== g.pitch, P = e1.useProgram($785da19a645c07eb$var$mz(C, a, l), M), I = $785da19a645c07eb$var$Kw(T, g.zoom), F = e1.style.map.terrain?.getTerrainData(o), z = [
            0,
            0
        ], R = null;
        if (a) {
            if (p = n.glyphAtlasTexture, b = m.LINEAR, h = n.glyphAtlasTexture.size, l.iconsInText) {
                z = n.imageAtlasTexture.size, R = n.imageAtlasTexture;
                let t = "composite" === T.kind || "camera" === T.kind;
                S = D || e1.options.rotating || e1.options.zooming || t ? m.LINEAR : m.NEAREST;
            }
        } else {
            let t = 1 !== i.layout.get("icon-size").constantOr(0) || l.iconsNeedLinear;
            p = n.imageAtlasTexture, b = C || e1.options.rotating || e1.options.zooming || t || D ? m.LINEAR : m.NEAREST, h = n.imageAtlasTexture.size;
        }
        let L1 = $785da19a645c07eb$var$qu(n, 1, e1.transform.zoom), B = $785da19a645c07eb$var$xD(f, e1.transform, L1), O = $785da19a645c07eb$var$bD(A, f, e1.transform, L1), U = $785da19a645c07eb$var$Qu(g, n, r, s), N = g.getProjectionData({
            overscaledTileID: o,
            applyGlobeMatrix: !d,
            applyTerrainMatrix: !0
        }), j = w && l.hasTextData(), V = "none" !== i.layout.get("icon-text-fit") && j && l.hasIconData(), q = i._unevaluatedLayout.hasValue("icon-offset"), G = "ground" === i.layout.get("symbol-height-anchor");
        if (_) {
            let t = $785da19a645c07eb$var$tu();
            $785da19a645c07eb$var$vD(t, B);
            let n = e1.style.map.terrain ? (t, i)=>e1.style.map.terrain.getElevation(o, t, i) : void 0;
            $785da19a645c07eb$var$CD(l, e1, a, B, t, A, c, "map" === i.layout.get("text-rotation-alignment"), o.toUnwrapped(), g.width, g.height, U, n);
        }
        let H, W = a && w || V, Z = A ? B : e1.transform.clipSpaceToPixelsMatrix, K = _ || W ? $785da19a645c07eb$var$uz : Z, X = C && 0 !== i.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(1);
        H = C ? l.iconsInText ? $785da19a645c07eb$var$lF(T.kind, I, v, A, _, W, e1, K, O, U, h, z, k, q, G) : $785da19a645c07eb$var$oF(T.kind, I, v, A, _, W, e1, K, O, U, a, h, X, k, q, G) : $785da19a645c07eb$var$sF(T.kind, I, v, A, _, W, 0, K, O, U, a, h, k, q, G);
        let Q = {
            program: P,
            buffers: u,
            uniformValues: H,
            projectionData: N,
            atlasTexture: p,
            atlasTextureIcon: R,
            atlasInterpolation: b,
            atlasInterpolationIcon: S,
            isSDF: C,
            hasHalo: X
        };
        if (y && l.canOverlap) {
            x = !0;
            let e1 = u.segments.get();
            for (let t of e1)E.push({
                segments: new $785da19a645c07eb$var$T_([
                    t
                ]),
                sortKey: t.sortKey,
                state: Q,
                terrainData: F
            });
        } else E.push({
            segments: u.segments,
            sortKey: 0,
            state: Q,
            terrainData: F
        });
    }
    x && E.sort((e1, t)=>e1.sortKey - t.sortKey);
    let S = i.paint.get(a ? "text-halo-width" : "icon-halo-width").constantOr(null) ?? 1 / 0, M = 24 * i.layout.get("text-letter-spacing").constantOr(0) < 0 || S > 1;
    for (let t of E){
        let n = t.state;
        p.activeTexture.set(m.TEXTURE0), n.atlasTexture.bind(n.atlasInterpolation, m.CLAMP_TO_EDGE), n.atlasTextureIcon && (p.activeTexture.set(m.TEXTURE1), n.atlasTextureIcon && n.atlasTextureIcon.bind(n.atlasInterpolationIcon, m.CLAMP_TO_EDGE));
        let a = n.isSDF && n.hasHalo;
        if (a) {
            let a = n.uniformValues;
            a.u_is_halo = 1, M && (a.u_is_plain = 0, $785da19a645c07eb$var$fz(n.buffers, t.segments, i, e1, n.program, b, u, h, a, n.projectionData, t.terrainData), a.u_is_halo = 0, a.u_is_plain = 1);
        }
        $785da19a645c07eb$var$fz(n.buffers, t.segments, i, e1, n.program, b, u, h, n.uniformValues, n.projectionData, t.terrainData), a && !M && (n.uniformValues.u_is_halo = 0);
    }
}
function $785da19a645c07eb$var$fz(e1, t, i, n, a, r, s, o, l, c, u) {
    let h = n.context, d = h.gl;
    a.draw(h, d.TRIANGLES, r, s, o, $785da19a645c07eb$var$oz.backCCW, l, u, c, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, n.transform.zoom, e1.programConfigurations.get(i.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
}
function $785da19a645c07eb$var$Az(e1, t, i, n, a) {
    let r = e1.context, s = r.gl, o = $785da19a645c07eb$var$rz.disabled, l = new $785da19a645c07eb$var$tz([
        s.ONE,
        s.ONE
    ], $785da19a645c07eb$var$np.transparent, [
        !0,
        !0,
        !0,
        !0
    ]), c = t.getBucket(i);
    if (!c) return;
    let u = n.key, h = i.heatmapFbos.get(u);
    h || (h = $785da19a645c07eb$var$vz(r, t.tileSize, t.tileSize), i.heatmapFbos.set(u, h)), r.bindFramebuffer.set(h.framebuffer), r.viewport.set([
        0,
        0,
        t.tileSize,
        t.tileSize
    ]), r.clear({
        color: $785da19a645c07eb$var$np.transparent
    });
    let d = c.programConfigurations.get(i.id), p = e1.useProgram("heatmap", d, !a), m = e1.transform.getProjectionData({
        overscaledTileID: t.tileID,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    }), g = e1.style.map.terrain.getTerrainData(n);
    p.draw(r, s.TRIANGLES, $785da19a645c07eb$var$nz.disabled, o, l, $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$ZI(t, e1.transform.zoom, i.paint.get("heatmap-intensity"), 1), g, m, i.id, c.layoutVertexBuffer, c.indexBuffer, c.segments, i.paint, e1.transform.zoom, d);
}
function $785da19a645c07eb$var$_z(e1, t, i, n, a) {
    let r = e1.context, s = r.gl, o = e1.transform;
    r.setColorMode(e1.colorModeForRenderPass());
    let l = $785da19a645c07eb$var$yz(r, t), c = i.key, u = t.heatmapFbos.get(c);
    if (!u) return;
    r.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, u.colorAttachment.get()), r.activeTexture.set(s.TEXTURE1), l.bind(s.LINEAR, s.CLAMP_TO_EDGE);
    let h = o.getProjectionData({
        overscaledTileID: i,
        applyTerrainMatrix: a,
        applyGlobeMatrix: !n
    });
    e1.useProgram("heatmapTexture").draw(r, s.TRIANGLES, $785da19a645c07eb$var$nz.disabled, $785da19a645c07eb$var$rz.disabled, e1.colorModeForRenderPass(), $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$KI(e1, t, 0, 1), null, h, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, o.zoom), u.destroy(), t.heatmapFbos.delete(c);
}
function $785da19a645c07eb$var$vz(e1, t, i) {
    let n = e1.gl, a = n.createTexture();
    n.bindTexture(n.TEXTURE_2D, a), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), n.texStorage2D(n.TEXTURE_2D, 1, n.RGBA16F, t, i);
    let r = e1.createFramebuffer(t, i, !1, !1);
    return r.colorAttachment.set(a), r;
}
function $785da19a645c07eb$var$yz(e1, t) {
    return t.colorRampTexture ||= new $785da19a645c07eb$var$ry(e1, t.colorRamp, e1.gl.RGBA), t.colorRampTexture;
}
function $785da19a645c07eb$var$xz(e1, t, i, n) {
    let a = e1.context, r = a.bindFramebuffer.get(), s = a.viewport.get(), [, , o, l] = s;
    return function(e1, t, i) {
        let n = e1.context.gl;
        if (!e1.layerOpacityFbo) {
            let a = e1.context.createFramebuffer(t, i, !0, !0), r = n.createTexture();
            return n.bindTexture(n.TEXTURE_2D, r), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, t, i, 0, n.RGBA, n.UNSIGNED_BYTE, null), a.colorAttachment.set(r), a.depthAttachment.set(e1.context.createRenderbuffer(n.DEPTH_STENCIL, t, i)), e1.layerOpacityFbo = a, void e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        }
        if (e1.layerOpacityFbo.width === t && e1.layerOpacityFbo.height === i) return void e1.context.bindFramebuffer.set(e1.layerOpacityFbo.framebuffer);
        let a = e1.layerOpacityFbo;
        n.bindTexture(n.TEXTURE_2D, a.colorAttachment.get()), n.texImage2D(n.TEXTURE_2D, 0, n.RGBA, t, i, 0, n.RGBA, n.UNSIGNED_BYTE, null), e1.context.bindRenderbuffer.set(a.depthAttachment.get()), n.renderbufferStorage(n.RENDERBUFFER, n.DEPTH_STENCIL, t, i), e1.context.bindRenderbuffer.set(null), a.width = t, a.height = i, e1.context.bindFramebuffer.set(a.framebuffer);
    }(e1, o, l), a.viewport.set([
        0,
        0,
        o,
        l
    ]), a.clear({
        color: $785da19a645c07eb$var$np.transparent,
        depth: 1,
        stencil: 0
    }), e1.currentStencilSource = void 0, e1.renderTileClippingMasks(t, i, n), {
        compositeTarget: r,
        compositeViewport: s
    };
}
function $785da19a645c07eb$var$bz(e1, t, i, n) {
    let a = e1.context, r = a.gl;
    a.bindFramebuffer.set(i.compositeTarget), a.viewport.set(i.compositeViewport), a.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, e1.layerOpacityFbo.colorAttachment.get()), e1.useProgram("layerOpacity").draw(a, r.TRIANGLES, $785da19a645c07eb$var$nz.disabled, $785da19a645c07eb$var$rz.disabled, e1.colorModeForRenderPass(), $785da19a645c07eb$var$oz.disabled, ((e1, t)=>({
            u_image: t,
            u_opacity: e1
        }))(t, 0), null, null, n.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, n.paint, e1.transform.zoom), e1.currentStencilSource = void 0;
}
function $785da19a645c07eb$var$wz(e1, t, i, n, a, r, s, o) {
    let l = 256;
    if (a.stepInterpolant) {
        let n = t.getSource().maxzoom, a = s.canonical.z === n ? Math.ceil(1 << e1.transform.maxZoom - s.canonical.z) : 1;
        l = $785da19a645c07eb$var$ch(function(e1) {
            return e1 <= 1 ? 1 : 2 ** Math.ceil(Math.log(e1) / Math.LN2);
        }(r.maxLineLength / $785da19a645c07eb$var$Vu * 1024 * a), 256, i.maxTextureSize);
    }
    return o.gradient = $785da19a645c07eb$var$Qv({
        expression: a.gradientExpression(),
        evaluationKey: "lineProgress",
        resolution: l,
        image: o.gradient || void 0,
        clips: r.lineClipsArray
    }), o.texture ? o.texture.update(o.gradient) : o.texture = new $785da19a645c07eb$var$ry(i, o.gradient, n.RGBA), o.version = a.gradientVersion, o.texture;
}
function $785da19a645c07eb$var$Ez(e1, t, i, n, a) {
    e1.activeTexture.set(t.TEXTURE0), i.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), n.updatePaintBuffers(a);
}
function $785da19a645c07eb$var$kz(e1, t, i, n, a, r) {
    (a || e1.lineAtlas.dirty) && (t.activeTexture.set(i.TEXTURE0), e1.lineAtlas.bind(t)), n.updatePaintBuffers(r);
}
function $785da19a645c07eb$var$Sz(e1, t, i, n, a, r, s) {
    let o = r.gradients[a.id], l = o.texture;
    a.gradientVersion !== o.version && (l = $785da19a645c07eb$var$wz(e1, t, i, n, a, r, s, o)), i.activeTexture.set(n.TEXTURE0), l.bind(a.stepInterpolant ? n.NEAREST : n.LINEAR, n.CLAMP_TO_EDGE);
}
function $785da19a645c07eb$var$Mz(e1, t, i, n, a, r, s, o, l) {
    let c = r.gradients[a.id], u = c.texture;
    a.gradientVersion !== c.version && (u = $785da19a645c07eb$var$wz(e1, t, i, n, a, r, s, c)), i.activeTexture.set(n.TEXTURE0), u.bind(a.stepInterpolant ? n.NEAREST : n.LINEAR, n.CLAMP_TO_EDGE), i.activeTexture.set(n.TEXTURE1), e1.lineAtlas.bind(i), o.updatePaintBuffers(l);
}
function $785da19a645c07eb$var$Cz(e1, t, i, n, a, r) {
    let s, { isRenderingToTexture: o } = a, l = e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly), c = e1.colorModeForRenderPass(), u = i.paint.get("line-dasharray"), h = u.constantOr(1), d = i.paint.get("line-pattern"), p = d.constantOr(1), m = i.paint.get("line-gradient"), g = i.getCrossfadeParameters();
    s = p ? "linePattern" : h && m ? "lineGradientSDF" : h ? "lineSDF" : m ? "lineGradient" : "line";
    let f = e1.context, A = f.gl, _ = e1.transform, v = !0;
    for (let a of n){
        let n = t.getTile(a);
        if (p && !n.patternsLoaded()) continue;
        let y = n.getBucket(i);
        if (!y) continue;
        let x = y.programConfigurations.get(i.id), b = e1.context.program.get(), w = e1.useProgram(s, x), E = v || w.program !== b, k = r ? e1.getTerrainDataForTile(a, o) : null, S = d.constantOr(null), M = u?.constantOr(null);
        if (S && n.imageAtlas) {
            let e1 = n.imageAtlas, t = e1.patternPositions[S.to.toString()], i = e1.patternPositions[S.from.toString()];
            t && i && x.setConstantPatternPositions(t, i);
        } else if (M) {
            let t = "round" === i.layout.get("line-cap").constantOr(null), n = e1.lineAtlas.getDash(M.to, t), a = e1.lineAtlas.getDash(M.from, t);
            x.setConstantDashPositions(n, a);
        }
        let C, T = _.getProjectionData({
            overscaledTileID: a,
            applyGlobeMatrix: !o,
            applyTerrainMatrix: !0
        }), D = _.getPixelScale();
        p ? (C = $785da19a645c07eb$var$tF(e1, n, i, D, g), $785da19a645c07eb$var$Ez(f, A, n, x, g)) : h && m ? (C = $785da19a645c07eb$var$nF(e1, n, i, D, g, y.lineClipsArray.length), $785da19a645c07eb$var$Mz(e1, t, f, A, i, y, a, x, g)) : h ? (C = $785da19a645c07eb$var$iF(e1, n, i, D, g), $785da19a645c07eb$var$kz(e1, f, A, x, E, g)) : m ? (C = $785da19a645c07eb$var$eF(e1, n, i, D, y.lineClipsArray.length), $785da19a645c07eb$var$Sz(e1, t, f, A, i, y, a)) : C = $785da19a645c07eb$var$$I(e1, n, i, D);
        let P = e1.stencilModeForClipping(a);
        w.draw(f, A.TRIANGLES, l, P, c, $785da19a645c07eb$var$oz.disabled, C, k, T, i.id, y.layoutVertexBuffer, y.indexBuffer, y.segments, i.paint, e1.transform.zoom, x, y.layoutVertexBuffer2), v = !1;
    }
}
function $785da19a645c07eb$var$Tz(e1, t, i, n, a) {
    if (!i || !n?.imageAtlas) return;
    let r = n.imageAtlas.patternPositions, s = r[i.to.toString()], o = r[i.from.toString()];
    if (!s && o && (s = o), !o && s && (o = s), !s || !o) {
        let e1 = a.getPaintProperty(t);
        s = r[e1], o = r[e1];
    }
    s && o && e1.setConstantPatternPositions(s, o);
}
function $785da19a645c07eb$var$Dz(e1, t, i, n, a) {
    let { isRenderingToTexture: r } = a, s = e1.colorModeForRenderPass();
    $785da19a645c07eb$var$Iz(e1, t, i, n, e1.getDepthModeForSublayer(1, $785da19a645c07eb$var$nz.ReadOnly), s, !1, r), $785da19a645c07eb$var$Pz(e1, t, i, n, a);
}
function $785da19a645c07eb$var$Pz(e1, t, i, n, a) {
    if (!i.paint.get("fill-antialias")) return;
    let { isRenderingToTexture: r } = a, s = e1.colorModeForRenderPass();
    $785da19a645c07eb$var$Iz(e1, t, i, n, e1.getDepthModeForSublayer(i.getPaintProperty("fill-outline-color") ? 2 : 0, $785da19a645c07eb$var$nz.ReadOnly), s, !0, r);
}
function $785da19a645c07eb$var$Iz(e1, t, i, n, a, r, s, o) {
    let l, c, u, h, d, p = e1.context.gl, m = "fill-pattern", g = i.paint.get(m), f = g?.constantOr(1), A = i.getCrossfadeParameters(), _ = e1.transform, v = i.paint.get("fill-translate"), y = i.paint.get("fill-translate-anchor");
    s ? (c = f && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", l = p.LINES) : (c = f ? "fillPattern" : "fill", l = p.TRIANGLES);
    let x = g.constantOr(null);
    for (let g of n){
        let n = t.getTile(g);
        if (f && !n.patternsLoaded()) continue;
        let b = n.getBucket(i);
        if (!b) continue;
        let w = b.sdfPatterns[i.id] ?? !1, E = b.programConfigurations.get(i.id), k = e1.useProgram(c, E), S = e1.getTerrainDataForTile(g, o);
        f && (e1.context.activeTexture.set(p.TEXTURE0), n.imageAtlasTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE), E.updatePaintBuffers(A)), $785da19a645c07eb$var$Tz(E, m, x, n, i);
        let M = _.getProjectionData({
            overscaledTileID: g,
            applyGlobeMatrix: !o,
            applyTerrainMatrix: !0
        }), C = $785da19a645c07eb$var$Qu(_, n, v, y);
        s ? (h = b.indexBuffer2, d = b.segments2, u = "fillOutlinePattern" === c && f ? $785da19a645c07eb$var$GI(e1, A, n, C, w) : $785da19a645c07eb$var$qI(C)) : (h = b.indexBuffer, d = b.segments, u = f ? $785da19a645c07eb$var$jI(e1, A, n, C, w) : $785da19a645c07eb$var$VI(C));
        let T = e1.stencilModeForClipping(g);
        k.draw(e1.context, l, a, T, r, $785da19a645c07eb$var$oz.backCCW, u, S, M, i.id, b.layoutVertexBuffer, h, d, i.paint, e1.transform.zoom, E);
    }
}
function $785da19a645c07eb$var$Fz(e1, t, i, n, a, r, s, o) {
    let l = e1.context, c = l.gl, u = "fill-extrusion-pattern", h = i.paint.get(u), d = h.constantOr(1), p = i.getCrossfadeParameters(), m = i.paint.get("fill-extrusion-opacity"), g = h.constantOr(null), f = e1.transform;
    for (let h of n){
        let n = t.getTile(h), A = n.getBucket(i);
        if (!A) continue;
        let _ = e1.style.map.terrain?.getTerrainData(h), v = A.programConfigurations.get(i.id), y = e1.useProgram(d ? "fillExtrusionPattern" : "fillExtrusion", v);
        d && (e1.context.activeTexture.set(c.TEXTURE0), n.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), v.updatePaintBuffers(p));
        let x = f.getProjectionData({
            overscaledTileID: h,
            applyGlobeMatrix: !o,
            applyTerrainMatrix: !0
        });
        $785da19a645c07eb$var$Tz(v, u, g, n, i);
        let b = $785da19a645c07eb$var$Qu(f, n, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), w = i.paint.get("fill-extrusion-vertical-gradient"), E = d ? $785da19a645c07eb$var$NI(e1, w, m, b, h, p, n) : $785da19a645c07eb$var$UI(e1, w, m, b);
        y.draw(l, l.gl.TRIANGLES, a, r, s, $785da19a645c07eb$var$oz.backCCW, E, _, x, i.id, A.layoutVertexBuffer, A.indexBuffer, A.segments, i.paint, e1.transform.zoom, v, e1.style.map.terrain && A.centroidVertexBuffer);
    }
}
function $785da19a645c07eb$var$zz(e1, t, i, n, a, r, s, o, l) {
    let c = e1.style.projection, u = e1.context, h = e1.transform, d = u.gl, p = [
        `#define NUM_ILLUMINATION_SOURCES ${i.paint.get("hillshade-highlight-color").values.length}`
    ], m = e1.useProgram("hillshade", null, !1, p), g = !e1.options.moving;
    for (let p of n){
        let n = t.getTile(p), f = n.fbo;
        if (!f) continue;
        let A = c.getMeshFromTileID(u, p.canonical, o, !0, "raster"), _ = e1.getTerrainDataForTile(p, l);
        u.activeTexture.set(d.TEXTURE0), d.bindTexture(d.TEXTURE_2D, f.colorAttachment.get());
        let v = h.getProjectionData({
            overscaledTileID: p,
            aligned: g,
            applyGlobeMatrix: !l,
            applyTerrainMatrix: !0
        });
        m.draw(u, d.TRIANGLES, r, a[p.overscaledZ], s, $785da19a645c07eb$var$oz.backCCW, $785da19a645c07eb$var$XI(e1, n, i), _, v, i.id, A.vertexBuffer, A.indexBuffer, A.segments);
    }
}
let $785da19a645c07eb$var$Rz = 0;
function $785da19a645c07eb$var$Lz(e1, t, i, n, a, r, s, o, l) {
    let c = e1.style.projection, u = e1.context, h = e1.transform, d = u.gl, p = e1.useProgram("colorRelief"), m = !e1.options.moving, g = "nearest" === i.paint.get("resampling") ? d.NEAREST : d.LINEAR, f = !0, A = 0;
    for (let _ of n){
        let n = t.getTile(_), v = n.dem;
        if (!v?.data) continue;
        if (f) {
            $785da19a645c07eb$var$Rz ||= d.getParameter(d.MAX_TEXTURE_SIZE);
            let e1 = $785da19a645c07eb$var$Rz, { elevationTexture: t, colorTexture: n } = i.getColorRampTextures(u, e1, v.getUnpackVector());
            u.activeTexture.set(d.TEXTURE1), t.bind(d.NEAREST, d.CLAMP_TO_EDGE), u.activeTexture.set(d.TEXTURE4), n.bind(d.LINEAR, d.CLAMP_TO_EDGE), f = !1, A = t.size[0];
        }
        let y = v.stride;
        u.activeTexture.set(d.TEXTURE0), (!n.demTexture || n.needsColorReliefPrepare) && (u.pixelStoreUnpackPremultiplyAlpha.set(!1), n.demTexture ||= e1.getTileTexture(y) ?? new $785da19a645c07eb$var$ry(u, {
            width: y,
            height: y,
            data: null
        }, d.RGBA), n.demTexture.update(v.getPixels(), {
            premultiply: !1
        }), n.needsColorReliefPrepare = !1), n.demTexture.bind(g, d.CLAMP_TO_EDGE);
        let x = c.getMeshFromTileID(u, _.canonical, o, !0, "raster"), b = e1.getTerrainDataForTile(_, l), w = h.getProjectionData({
            overscaledTileID: _,
            aligned: m,
            applyGlobeMatrix: !l,
            applyTerrainMatrix: !0
        });
        p.draw(u, d.TRIANGLES, r, a[_.overscaledZ], s, $785da19a645c07eb$var$oz.backCCW, $785da19a645c07eb$var$JI(i, n.dem, A), b, w, i.id, x.vertexBuffer, x.indexBuffer, x.segments);
    }
}
const $785da19a645c07eb$var$Bz = [
    new $785da19a645c07eb$var$Kc(0, 0),
    new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$Vu, 0),
    new $785da19a645c07eb$var$Kc($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu),
    new $785da19a645c07eb$var$Kc(0, $785da19a645c07eb$var$Vu)
];
function $785da19a645c07eb$var$Oz(e1, t, i, n, a, r, s, o, l, c = !1, u = !1, h = null) {
    let d = n[n.length - 1].overscaledZ, p = e1.context, m = p.gl, g = e1.useProgram("raster"), f = e1.transform, A = e1.style.projection, _ = e1.colorModeForRenderPass(), v = !e1.options.moving, y = i.paint.get("raster-opacity"), x = "nearest" === i.paint.get("resampling") || "nearest" === i.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR, b = i.paint.get("raster-fade-duration"), w = !!e1.style.map.terrain;
    for (let E of n){
        let n = e1.getDepthModeForSublayer(E.overscaledZ - d, 1 === y ? $785da19a645c07eb$var$nz.ReadWrite : $785da19a645c07eb$var$nz.ReadOnly, m.LESS), k = t.getTile(E);
        p.activeTexture.set(m.TEXTURE0), k.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), p.activeTexture.set(m.TEXTURE1);
        let { parentTile: S, parentScaleBy: M, parentTopLeft: C, fadeValues: T } = $785da19a645c07eb$var$Uz(k, t, b, w);
        k.fadeOpacity = T.tileOpacity, S ? (S.fadeOpacity = T.parentTileOpacity, S.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST)) : k.texture.bind(x, m.CLAMP_TO_EDGE, m.LINEAR_MIPMAP_NEAREST), k.texture.useMipmap && p.extTextureFilterAnisotropic && e1.transform.pitch > e1.options.anisotropicFilterPitch && m.texParameterf(m.TEXTURE_2D, p.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, p.extTextureFilterAnisotropicMax);
        let D = e1.getTerrainDataForTile(E, u), P = f.getProjectionData({
            overscaledTileID: E,
            aligned: v,
            applyGlobeMatrix: !u,
            applyTerrainMatrix: !0
        }), I = $785da19a645c07eb$var$IT(C, M, T.fadeMix, i, o, l), F = h ?? A.getMeshFromTileID(p, E.canonical, r, s, "raster"), z = a ? a[E.overscaledZ] : $785da19a645c07eb$var$rz.disabled;
        g.draw(p, m.TRIANGLES, n, z, _, c ? $785da19a645c07eb$var$oz.frontCCW : $785da19a645c07eb$var$oz.backCCW, I, D, P, i.id, F.vertexBuffer, F.indexBuffer, F.segments);
    }
}
function $785da19a645c07eb$var$Uz(e1, t, i, n) {
    let a = {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: {
            tileOpacity: 1,
            parentTileOpacity: 1,
            fadeMix: {
                opacity: 1,
                mix: 0
            }
        }
    };
    if (0 === i || n) return a;
    if (e1.fadingParentID) {
        let n = t.getLoadedTile(e1.fadingParentID);
        if (!n) return a;
        let r = 2 ** (n.tileID.overscaledZ - e1.tileID.overscaledZ);
        return {
            parentTile: n,
            parentScaleBy: r,
            parentTopLeft: [
                e1.tileID.canonical.x * r % 1,
                e1.tileID.canonical.y * r % 1
            ],
            fadeValues: $785da19a645c07eb$var$Nz(e1, n, i)
        };
    }
    return e1.selfFading ? {
        parentTile: null,
        parentScaleBy: 1,
        parentTopLeft: [
            0,
            0
        ],
        fadeValues: $785da19a645c07eb$var$jz(e1, i)
    } : a;
}
function $785da19a645c07eb$var$Nz(e1, t, i) {
    let n = $785da19a645c07eb$var$aC(), a = (n - e1.timeAdded) / i, r = (n - t.timeAdded) / i, s = 1 === e1.fadingDirection, o = $785da19a645c07eb$var$ch(a, 0, 1), l = $785da19a645c07eb$var$ch(1 - r, 0, 1), c = s ? o : l;
    return {
        tileOpacity: c,
        parentTileOpacity: s ? l : o,
        fadeMix: {
            opacity: 1,
            mix: 1 - c
        }
    };
}
function $785da19a645c07eb$var$jz(e1, t) {
    let i = $785da19a645c07eb$var$ch(($785da19a645c07eb$var$aC() - e1.timeAdded) / t, 0, 1);
    return {
        tileOpacity: i,
        fadeMix: {
            opacity: i,
            mix: 0
        }
    };
}
const $785da19a645c07eb$var$Vz = new $785da19a645c07eb$var$np(1, 0, 0, 1), $785da19a645c07eb$var$qz = new $785da19a645c07eb$var$np(0, 1, 0, 1), $785da19a645c07eb$var$Gz = new $785da19a645c07eb$var$np(0, 0, 1, 1), $785da19a645c07eb$var$Hz = new $785da19a645c07eb$var$np(1, 0, 1, 1), $785da19a645c07eb$var$Wz = new $785da19a645c07eb$var$np(0, 1, 1, 1);
function $785da19a645c07eb$var$Zz(e1, t, i, n) {
    $785da19a645c07eb$var$Xz(e1, 0, t + i / 2, e1.transform.width, i, n);
}
function $785da19a645c07eb$var$Kz(e1, t, i, n) {
    $785da19a645c07eb$var$Xz(e1, t - i / 2, 0, i, e1.transform.height, n);
}
function $785da19a645c07eb$var$Xz(e1, t, i, n, a, r) {
    let s = e1.context, o = s.gl;
    o.enable(o.SCISSOR_TEST), o.scissor(t * e1.pixelRatio, i * e1.pixelRatio, n * e1.pixelRatio, a * e1.pixelRatio), s.clear({
        color: r
    }), o.disable(o.SCISSOR_TEST);
}
function $785da19a645c07eb$var$Qz(e1, t, i) {
    let n = e1.context, a = n.gl, r = e1.useProgram("debug"), s = $785da19a645c07eb$var$nz.disabled, o = $785da19a645c07eb$var$rz.disabled, l = e1.colorModeForRenderPass(), c = "$debug", u = e1.style.map.terrain?.getTerrainData(i);
    n.activeTexture.set(a.TEXTURE0);
    let h = t.getTileByID(i.key).latestRawTileData?.byteLength || 0, d = Math.floor(h / 1024), p = t.getTile(i).tileSize, m = 512 / Math.min(p, 512) * (i.overscaledZ / e1.transform.zoom) * .5, g = i.canonical.toString();
    i.overscaledZ !== i.canonical.z && (g += ` => ${i.overscaledZ}`), function(e1, t) {
        e1.initDebugOverlayCanvas();
        let i = e1.debugOverlayCanvas, n = e1.context.gl, a = e1.debugOverlayCanvas.getContext("2d");
        a.clearRect(0, 0, i.width, i.height), a.shadowColor = "white", a.shadowBlur = 2, a.lineWidth = 1.5, a.strokeStyle = "white", a.textBaseline = "top", a.font = "bold 36px Open Sans, sans-serif", a.fillText(t, 5, 5), a.strokeText(t, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(n.LINEAR, n.CLAMP_TO_EDGE);
    }(e1, `${g} ${d}kB`);
    let f = e1.transform.getProjectionData({
        overscaledTileID: i,
        applyGlobeMatrix: !0,
        applyTerrainMatrix: !0
    });
    r.draw(n, a.TRIANGLES, s, o, $785da19a645c07eb$var$tz.alphaBlended, $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$WI($785da19a645c07eb$var$np.transparent, m), null, f, c, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), r.draw(n, a.LINE_STRIP, s, o, l, $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$WI($785da19a645c07eb$var$np.red), u, f, c, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
}
function $785da19a645c07eb$var$Yz(e1, t) {
    if (!t.mesh) {
        let i = new $785da19a645c07eb$var$l_;
        i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1);
        let n = new $785da19a645c07eb$var$k_;
        n.emplaceBack(0, 1, 2), n.emplaceBack(0, 2, 3), t.mesh = new $785da19a645c07eb$var$LT(e1.createVertexBuffer(i, $785da19a645c07eb$var$BT.members), e1.createIndexBuffer(n), $785da19a645c07eb$var$T_.simpleSegment(0, 0, i.length, n.length));
    }
    return t.mesh;
}
const $785da19a645c07eb$var$Jz = {
    symbol: function(e1, t, i, n, a, r) {
        if ("translucent" !== r.currentPass) return;
        let { isRenderingToTexture: s } = r, o = $785da19a645c07eb$var$rz.disabled, l = e1.colorModeForRenderPass();
        (i._unevaluatedLayout.hasValue("text-variable-anchor") || i._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e1, t, i, n, a, r, s, o, l) {
            let c = t.transform, u = t.style.map.terrain, h = "map" === a, d = "map" === r;
            for (let a of e1){
                let e1 = n.getTile(a), r = e1.getBucket(i);
                if (!r?.text?.segments.get().length) continue;
                let p = $785da19a645c07eb$var$Kw(r.textSizeData, c.zoom), m = $785da19a645c07eb$var$qu(e1, 1, t.transform.zoom), g = $785da19a645c07eb$var$xD(h, t.transform, m), f = "none" !== i.layout.get("icon-text-fit") && r.hasIconData();
                if (p) {
                    let t = 2 ** (c.zoom - e1.tileID.overscaledZ), n = u ? (e1, t)=>u.getElevation(a, e1, t) : void 0;
                    $785da19a645c07eb$var$pz(r, h, d, l, c, g, t, p, f, $785da19a645c07eb$var$Qu(c, e1, s, o), a.toUnwrapped(), n, "ground" === i.layout.get("symbol-height-anchor"));
                }
            }
        }(n, e1, i, t, i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), a), 0 !== i.paint.get("icon-opacity").constantOr(1) && $785da19a645c07eb$var$gz(e1, t, i, n, !1, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), i.layout.get("icon-rotation-alignment").constantOr("viewport"), i.layout.get("icon-pitch-alignment"), i.layout.get("icon-keep-upright"), o, l, s), 0 !== i.paint.get("text-opacity").constantOr(1) && $785da19a645c07eb$var$gz(e1, t, i, n, !0, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), i.layout.get("text-keep-upright"), o, l, s), t.map.showCollisionBoxes && ($785da19a645c07eb$var$cz(e1, t, i, n, !0), $785da19a645c07eb$var$cz(e1, t, i, n, !1));
    },
    circle: function(e1, t, i, n, a) {
        if ("translucent" !== a.currentPass) return;
        let { isRenderingToTexture: r } = a, s = i.paint.get("circle-opacity"), o = i.paint.get("circle-stroke-width"), l = i.paint.get("circle-stroke-opacity"), c = !i.layout.get("circle-sort-key").isConstant();
        if (0 === s.constantOr(1) && (0 === o.constantOr(1) || 0 === l.constantOr(1))) return;
        let u = e1.context, h = u.gl, d = e1.transform, p = e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly), m = $785da19a645c07eb$var$rz.disabled, g = e1.colorModeForRenderPass(), f = [], A = d.getCircleRadiusCorrection();
        for (let a of n){
            let n = t.getTile(a), s = n.getBucket(i);
            if (!s) continue;
            let o = $785da19a645c07eb$var$Qu(d, n, i.paint.get("circle-translate"), i.paint.get("circle-translate-anchor")), l = s.programConfigurations.get(i.id), u = e1.useProgram("circle", l), h = s.layoutVertexBuffer, p = s.indexBuffer, m = e1.style.map.terrain?.getTerrainData(a), g = {
                programConfiguration: l,
                program: u,
                layoutVertexBuffer: h,
                indexBuffer: p,
                uniformValues: $785da19a645c07eb$var$HI(e1, n, i, o, A),
                terrainData: m,
                projectionData: d.getProjectionData({
                    overscaledTileID: a,
                    applyGlobeMatrix: !r,
                    applyTerrainMatrix: !0
                })
            };
            if (c) {
                let e1 = s.segments.get();
                for (let t of e1)f.push({
                    segments: new $785da19a645c07eb$var$T_([
                        t
                    ]),
                    sortKey: t.sortKey,
                    state: g
                });
            } else f.push({
                segments: s.segments,
                sortKey: 0,
                state: g
            });
        }
        c && f.sort((e1, t)=>e1.sortKey - t.sortKey);
        for (let t of f){
            let { programConfiguration: n, program: a, layoutVertexBuffer: r, indexBuffer: s, uniformValues: o, terrainData: l, projectionData: c } = t.state, d = t.segments;
            a.draw(u, h.TRIANGLES, p, m, g, $785da19a645c07eb$var$oz.backCCW, o, l, c, i.id, r, s, d, i.paint, e1.transform.zoom, n);
        }
    },
    heatmap: function(e1, t, i, n, a) {
        if (0 === i.paint.get("heatmap-opacity")) return;
        let r = e1.context, { isRenderingToTexture: s, isRenderingGlobe: o } = a;
        if (e1.style.map.terrain) {
            for (let r of n){
                let n = t.getTile(r);
                t.hasRenderableParent(r) || ("offscreen" === a.currentPass ? $785da19a645c07eb$var$Az(e1, n, i, r, o) : "translucent" === a.currentPass && $785da19a645c07eb$var$_z(e1, i, r, s, o));
            }
            r.viewport.set([
                0,
                0,
                e1.width,
                e1.height
            ]);
        } else "offscreen" === a.currentPass ? function(e1, t, i, n) {
            let a = e1.context, r = a.gl, s = e1.transform, o = $785da19a645c07eb$var$rz.disabled, l = new $785da19a645c07eb$var$tz([
                r.ONE,
                r.ONE
            ], $785da19a645c07eb$var$np.transparent, [
                !0,
                !0,
                !0,
                !0
            ]);
            (function(e1, t, i) {
                let n = e1.gl;
                e1.activeTexture.set(n.TEXTURE1), e1.viewport.set([
                    0,
                    0,
                    t.width / 4,
                    t.height / 4
                ]);
                let a = i.heatmapFbos.get($785da19a645c07eb$var$Yv);
                a ? (n.bindTexture(n.TEXTURE_2D, a.colorAttachment.get()), e1.bindFramebuffer.set(a.framebuffer)) : (a = $785da19a645c07eb$var$vz(e1, t.width / 4, t.height / 4), i.heatmapFbos.set($785da19a645c07eb$var$Yv, a));
            })(a, e1, i), a.clear({
                color: $785da19a645c07eb$var$np.transparent
            });
            for (let c of n){
                if (t.hasRenderableParent(c)) continue;
                let n = t.getTile(c), u = n.getBucket(i);
                if (!u) continue;
                let h = u.programConfigurations.get(i.id), d = e1.useProgram("heatmap", h), p = s.getProjectionData({
                    overscaledTileID: c,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !1
                }), m = s.getCircleRadiusCorrection();
                d.draw(a, r.TRIANGLES, $785da19a645c07eb$var$nz.disabled, o, l, $785da19a645c07eb$var$oz.backCCW, $785da19a645c07eb$var$ZI(n, s.zoom, i.paint.get("heatmap-intensity"), m), null, p, i.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, i.paint, s.zoom, h);
            }
            a.viewport.set([
                0,
                0,
                e1.width,
                e1.height
            ]);
        }(e1, t, i, n) : "translucent" === a.currentPass && function(e1, t) {
            let i = e1.context, n = i.gl;
            i.setColorMode(e1.colorModeForRenderPass());
            let a = t.heatmapFbos.get($785da19a645c07eb$var$Yv);
            a && (i.activeTexture.set(n.TEXTURE0), n.bindTexture(n.TEXTURE_2D, a.colorAttachment.get()), i.activeTexture.set(n.TEXTURE1), $785da19a645c07eb$var$yz(i, t).bind(n.LINEAR, n.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(i, n.TRIANGLES, $785da19a645c07eb$var$nz.disabled, $785da19a645c07eb$var$rz.disabled, e1.colorModeForRenderPass(), $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$KI(e1, t, 0, 1), null, null, t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom));
        }(e1, i);
    },
    line: function(e1, t, i, n, a) {
        if ("translucent" !== a.currentPass) return;
        let r = i.paint.get("line-opacity"), s = i.paint.get("line-width"), o = i.paint.get("line-layer-opacity");
        if (0 === r.constantOr(1) || 0 === s.constantOr(1) || 0 === o) return;
        let l = !!e1.style.map.terrain;
        if (o < 1) {
            let r = $785da19a645c07eb$var$xz(e1, i, n, l);
            return $785da19a645c07eb$var$Cz(e1, t, i, n, a, l), void $785da19a645c07eb$var$bz(e1, o, r, i);
        }
        $785da19a645c07eb$var$Cz(e1, t, i, n, a, l);
    },
    fill: function(e1, t, i, n, a) {
        let r = i.paint.get("fill-color"), s = i.paint.get("fill-opacity"), o = i.paint.get("fill-layer-opacity");
        if (0 === s.constantOr(1) || 0 === o) return;
        if (o < 1) {
            if ("translucent" !== a.currentPass) return;
            let r = $785da19a645c07eb$var$xz(e1, i, n, !!e1.style.map.terrain);
            return $785da19a645c07eb$var$Dz(e1, t, i, n, a), void $785da19a645c07eb$var$bz(e1, o, r, i);
        }
        let l = i.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === r.constantOr($785da19a645c07eb$var$np.transparent).a && 1 === s.constantOr(0);
        if (c && "opaque" === a.currentPass) {
            let { isRenderingToTexture: r } = a, s = e1.colorModeForRenderPass();
            return void $785da19a645c07eb$var$Iz(e1, t, i, n, e1.getDepthModeForSublayer(1, $785da19a645c07eb$var$nz.ReadWrite), s, !1, r);
        }
        c && "translucent" === a.currentPass ? $785da19a645c07eb$var$Pz(e1, t, i, n, a) : "translucent" === a.currentPass && $785da19a645c07eb$var$Dz(e1, t, i, n, a);
    },
    fillExtrusion: function(e1, t, i, n, a) {
        let r = i.paint.get("fill-extrusion-opacity");
        if (0 === r) return;
        let { isRenderingToTexture: s } = a;
        if ("translucent" === a.currentPass) {
            let o = new $785da19a645c07eb$var$nz(e1.context.gl.LEQUAL, $785da19a645c07eb$var$nz.ReadWrite, a.depthRangeFor3D);
            if (1 !== r || i.paint.get("fill-extrusion-pattern").constantOr(1)) $785da19a645c07eb$var$Fz(e1, t, i, n, o, $785da19a645c07eb$var$rz.disabled, $785da19a645c07eb$var$tz.disabled, s), $785da19a645c07eb$var$Fz(e1, t, i, n, o, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), s);
            else {
                let a = e1.colorModeForRenderPass();
                $785da19a645c07eb$var$Fz(e1, t, i, n, o, $785da19a645c07eb$var$rz.disabled, a, s);
            }
        }
    },
    hillshade: function(e1, t, i, n, a) {
        if ("offscreen" !== a.currentPass && "translucent" !== a.currentPass) return;
        let { isRenderingToTexture: r } = a, s = e1.context, o = e1.style.projection.useSubdivision, l = e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly), c = e1.colorModeForRenderPass();
        if ("offscreen" === a.currentPass) (function(e1, t, i, n, a, r, s) {
            let o = e1.context, l = o.gl, c = "nearest" === n.paint.get("resampling") ? l.NEAREST : l.LINEAR;
            for (let u of i){
                let i = t.getTile(u), h = i.dem;
                if (!h?.data || !i.needsHillshadePrepare) continue;
                let d = h.dim + 2, p = h.stride, m = h.getPixels();
                if (o.activeTexture.set(l.TEXTURE1), o.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture ||= e1.getTileTexture(p), i.demTexture) {
                    let e1 = i.demTexture;
                    e1.update(m, {
                        premultiply: !1
                    }), e1.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                } else i.demTexture = new $785da19a645c07eb$var$ry(o, m, l.RGBA, {
                    premultiply: !1
                }), i.demTexture.bind(l.NEAREST, l.CLAMP_TO_EDGE);
                o.activeTexture.set(l.TEXTURE0);
                let g = i.fbo;
                if (!g) {
                    let e1 = new $785da19a645c07eb$var$ry(o, {
                        width: d,
                        height: d,
                        data: null
                    }, l.RGBA);
                    e1.bind(c, l.CLAMP_TO_EDGE), g = i.fbo = o.createFramebuffer(d, d, !0, !1), g.colorAttachment.set(e1.texture);
                }
                o.bindFramebuffer.set(g.framebuffer), o.viewport.set([
                    0,
                    0,
                    d,
                    d
                ]), e1.useProgram("hillshadePrepare").draw(o, l.TRIANGLES, a, r, s, $785da19a645c07eb$var$oz.disabled, $785da19a645c07eb$var$QI(i.tileID, h), null, null, n.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), i.needsHillshadePrepare = !1;
            }
        })(e1, t, n, i, l, $785da19a645c07eb$var$rz.disabled, c), s.viewport.set([
            0,
            0,
            e1.width,
            e1.height
        ]);
        else if ("translucent" === a.currentPass) {
            if (o) {
                let [a, s, o] = e1.stencilConfigForOverlapTwoPass(n);
                $785da19a645c07eb$var$zz(e1, t, i, o, a, l, c, !1, r), $785da19a645c07eb$var$zz(e1, t, i, o, s, l, c, !0, r);
            } else {
                let [a, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(n);
                $785da19a645c07eb$var$zz(e1, t, i, s, a, l, c, !1, r);
            }
        }
    },
    colorRelief: function(e1, t, i, n, a) {
        if ("translucent" !== a.currentPass || !n.length) return;
        let { isRenderingToTexture: r } = a, s = e1.style.projection.useSubdivision, o = e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly), l = e1.colorModeForRenderPass();
        if (s) {
            let [a, s, c] = e1.stencilConfigForOverlapTwoPass(n);
            $785da19a645c07eb$var$Lz(e1, t, i, c, a, o, l, !1, r), $785da19a645c07eb$var$Lz(e1, t, i, c, s, o, l, !0, r);
        } else {
            let [a, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(n);
            $785da19a645c07eb$var$Lz(e1, t, i, s, a, o, l, !1, r);
        }
    },
    raster: function(e1, t, i, n, a) {
        if ("translucent" !== a.currentPass || 0 === i.paint.get("raster-opacity") || !n.length) return;
        let { isRenderingToTexture: r } = a, s = t.getSource(), o = e1.style.projection.useSubdivision;
        if (s instanceof $785da19a645c07eb$var$UT) $785da19a645c07eb$var$Oz(e1, t, i, n, null, !1, !1, s.tileCoords, s.imageWarp, s.flippedWindingOrder, r, s.getMesh(e1.context, o));
        else if (o) {
            let [a, s, o] = e1.stencilConfigForOverlapTwoPass(n);
            $785da19a645c07eb$var$Oz(e1, t, i, o, a, !1, !0, $785da19a645c07eb$var$Bz, $785da19a645c07eb$var$PT, !1, r), $785da19a645c07eb$var$Oz(e1, t, i, o, s, !0, !0, $785da19a645c07eb$var$Bz, $785da19a645c07eb$var$PT, !1, r);
        } else {
            let [a, s] = e1.getStencilConfigForOverlapAndUpdateStencilID(n);
            $785da19a645c07eb$var$Oz(e1, t, i, s, a, !1, !0, $785da19a645c07eb$var$Bz, $785da19a645c07eb$var$PT, !1, r);
        }
    },
    background: function(e1, t, i, n, a) {
        let r = i.paint.get("background-color"), s = i.paint.get("background-opacity");
        if (0 === s) return;
        let { isRenderingToTexture: o } = a, l = e1.context, c = l.gl, u = e1.style.projection, h = e1.transform, d = h.tileSize, p = i.paint.get("background-pattern");
        if (e1.isPatternMissing(p)) return;
        let m = !p && 1 === r.a && 1 === s && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
        if (a.currentPass !== m) return;
        let g = $785da19a645c07eb$var$rz.disabled, f = e1.getDepthModeForSublayer(0, "opaque" === m ? $785da19a645c07eb$var$nz.ReadWrite : $785da19a645c07eb$var$nz.ReadOnly), A = e1.colorModeForRenderPass(), _ = e1.useProgram(p ? "backgroundPattern" : "background"), v = n || $785da19a645c07eb$var$rD(h, {
            tileSize: d,
            terrain: e1.style.map.terrain
        });
        p && (l.activeTexture.set(c.TEXTURE0), e1.patternAtlas.bind(e1.context));
        let y = i.getCrossfadeParameters();
        for (let t of v){
            let n = h.getProjectionData({
                overscaledTileID: t,
                applyGlobeMatrix: !o,
                applyTerrainMatrix: !0
            }), a = p ? $785da19a645c07eb$var$uF(s, e1, p, {
                tileID: t,
                tileSize: d
            }, y) : $785da19a645c07eb$var$cF(s, r), m = e1.getTerrainDataForTile(t, o), v = u.getMeshFromTileID(l, t.canonical, !1, !0, "raster");
            _.draw(l, c.TRIANGLES, f, g, A, $785da19a645c07eb$var$oz.backCCW, a, m, n, i.id, v.vertexBuffer, v.indexBuffer, v.segments);
        }
    },
    sky: function(e1, t) {
        let i = e1.context, n = i.gl, a = ((e1, t, i)=>{
            let n = Math.cos(t.rollInRadians), a = Math.sin(t.rollInRadians), r = $785da19a645c07eb$var$jx(t), s = t.getProjectionData({
                overscaledTileID: null,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            }).projectionTransition;
            return {
                u_sky_color: e1.properties.get("sky-color"),
                u_horizon_color: e1.properties.get("horizon-color"),
                u_horizon: [
                    (t.width / 2 - r * a) * i,
                    (t.height / 2 + r * n) * i
                ],
                u_horizon_normal: [
                    -a,
                    n
                ],
                u_sky_horizon_blend: e1.properties.get("sky-horizon-blend") * t.height / 2 * i,
                u_sky_blend: s,
                u_inv_proj_matrix: t.inverseProjectionMatrix,
                u_globe_position: $785da19a645c07eb$var$$P(t),
                u_globe_radius: $785da19a645c07eb$var$JP(t.worldSize, t.center.lat)
            };
        })(t, e1.transform, e1.pixelRatio), r = new $785da19a645c07eb$var$nz(n.LEQUAL, $785da19a645c07eb$var$nz.ReadWrite, [
            0,
            1
        ]), s = $785da19a645c07eb$var$rz.disabled, o = e1.colorModeForRenderPass(), l = e1.useProgram("sky"), c = $785da19a645c07eb$var$Yz(i, t);
        l.draw(i, n.TRIANGLES, r, s, o, $785da19a645c07eb$var$oz.disabled, a, null, void 0, "sky", c.vertexBuffer, c.indexBuffer, c.segments);
    },
    atmosphere: function(e1, t, i) {
        let n = e1.context, a = n.gl, r = e1.useProgram("atmosphere"), s = new $785da19a645c07eb$var$nz(a.LEQUAL, $785da19a645c07eb$var$nz.ReadOnly, [
            0,
            1
        ]), o = e1.transform, l = function(e1, t) {
            let i = e1.getCartesianPosition();
            !function(e1, t) {
                e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2];
            }(i, i);
            let n = $785da19a645c07eb$var$nu(new Float64Array(16));
            return "map" === e1.properties.get("anchor") && ($785da19a645c07eb$var$uu(n, n, t.rollInRadians), $785da19a645c07eb$var$lu(n, n, -t.pitchInRadians), $785da19a645c07eb$var$uu(n, n, t.bearingInRadians), $785da19a645c07eb$var$lu(n, n, t.center.lat * Math.PI / 180), $785da19a645c07eb$var$cu(n, n, -t.center.lng * Math.PI / 180)), function(e1, t, i) {
                var n = t[0], a = t[1], r = t[2], s = i[3] * n + i[7] * a + i[11] * r + i[15];
                s ||= 1, e1[0] = (i[0] * n + i[4] * a + i[8] * r + i[12]) / s, e1[1] = (i[1] * n + i[5] * a + i[9] * r + i[13]) / s, e1[2] = (i[2] * n + i[6] * a + i[10] * r + i[14]) / s;
            }(i, i, n), i;
        }(i, e1.transform), c = o.getProjectionData({
            overscaledTileID: null,
            applyGlobeMatrix: !0,
            applyTerrainMatrix: !0
        }), u = t.properties.get("atmosphere-blend") * c.projectionTransition;
        if (0 === u) return;
        let h = $785da19a645c07eb$var$JP(o.worldSize, o.center.lat), d = ((e1, t, i, n, a)=>({
                u_sun_pos: e1,
                u_atmosphere_blend: t,
                u_globe_position: i,
                u_globe_radius: n,
                u_inv_proj_matrix: a
            }))(l, u, $785da19a645c07eb$var$$P(o), h, o.inverseProjectionMatrix), p = $785da19a645c07eb$var$Yz(n, t);
        r.draw(n, a.TRIANGLES, s, $785da19a645c07eb$var$rz.disabled, $785da19a645c07eb$var$tz.alphaBlended, $785da19a645c07eb$var$oz.disabled, d, null, null, "atmosphere", p.vertexBuffer, p.indexBuffer, p.segments);
    },
    custom: function(e1, t, i, n) {
        let { isRenderingGlobe: a } = n, r = e1.context, s = i.implementation, o = e1.style.projection, l = e1.transform, c = l.getProjectionDataForCustomLayer(a), u = {
            farZ: l.farZ,
            nearZ: l.nearZ,
            fov: l.fov * Math.PI / 180,
            modelViewProjectionMatrix: l.modelViewProjectionMatrix,
            projectionMatrix: l.projectionMatrix,
            shaderData: {
                variantName: o.shaderVariantName,
                vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${o.shaderPreludeCode.vertexSource}`,
                define: o.shaderDefine
            },
            defaultProjectionData: c,
            getProjectionData: (e1)=>l.getProjectionData({
                    overscaledTileID: new $785da19a645c07eb$var$KE(e1.tileID.canonical.z, e1.tileID.wrap ?? 0, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y),
                    aligned: e1.aligned,
                    applyGlobeMatrix: e1.applyGlobeMatrix,
                    applyTerrainMatrix: e1.applyTerrainMatrix
                })
        }, h = s.renderingMode ? s.renderingMode : "2d";
        if ("offscreen" === n.currentPass) {
            let t = s.prerender;
            t && (e1.setCustomLayerDefaults(), r.setColorMode(e1.colorModeForRenderPass()), t.call(s, r.gl, u), r.setDirty(), e1.setBaseState());
        } else if ("translucent" === n.currentPass) {
            e1.setCustomLayerDefaults(), r.setColorMode(e1.colorModeForRenderPass()), r.setStencilMode($785da19a645c07eb$var$rz.disabled);
            let t = "3d" === h ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, $785da19a645c07eb$var$nz.ReadOnly);
            r.setDepthMode(t), s.render(r.gl, u), r.setDirty(), e1.setBaseState(), r.bindFramebuffer.set(null);
        }
    },
    debug: function(e1, t, i) {
        for (let n of i)$785da19a645c07eb$var$Qz(e1, t, n);
    },
    debugPadding: function(e1) {
        let t = e1.transform.padding;
        $785da19a645c07eb$var$Zz(e1, e1.transform.height - (t.top || 0), 3, $785da19a645c07eb$var$Vz), $785da19a645c07eb$var$Zz(e1, t.bottom || 0, 3, $785da19a645c07eb$var$qz), $785da19a645c07eb$var$Kz(e1, t.left || 0, 3, $785da19a645c07eb$var$Gz), $785da19a645c07eb$var$Kz(e1, e1.transform.width - (t.right || 0), 3, $785da19a645c07eb$var$Hz);
        let i = e1.transform.centerPoint;
        !function(e1, t, i, n) {
            $785da19a645c07eb$var$Xz(e1, t - 1, i - 10, 2, 20, n), $785da19a645c07eb$var$Xz(e1, t - 10, i - 1, 20, 2, n);
        }(e1, i.x, e1.transform.height - i.y, $785da19a645c07eb$var$Wz);
    },
    terrainDepth: function(e1, t) {
        let i = e1.context, n = i.gl, a = e1.transform, r = $785da19a645c07eb$var$tz.unblended, s = new $785da19a645c07eb$var$nz(n.LEQUAL, $785da19a645c07eb$var$nz.ReadWrite, [
            0,
            1
        ]), o = t.tileManager.getRenderableTiles(), l = e1.useProgram("terrainDepth");
        i.bindFramebuffer.set(t.getFramebuffer().framebuffer), i.viewport.set([
            0,
            0,
            e1.width / devicePixelRatio,
            e1.height / devicePixelRatio
        ]), i.clear({
            color: $785da19a645c07eb$var$np.white,
            depth: 1
        });
        for (let e1 of o){
            let o = t.getTerrainMesh(e1.tileID), c = t.getTerrainData(e1.tileID), u = a.getProjectionData({
                overscaledTileID: e1.tileID,
                applyTerrainMatrix: !1,
                applyGlobeMatrix: !0
            }), h = $785da19a645c07eb$var$MI(t.getSkirtLength(a.zoom));
            l.draw(i, n.TRIANGLES, s, $785da19a645c07eb$var$rz.disabled, r, $785da19a645c07eb$var$oz.backCCW, h, c, u, "terrain", o.vertexBuffer, o.indexBuffer, o.segments);
        }
        i.bindFramebuffer.set(null), i.viewport.set([
            0,
            0,
            e1.width,
            e1.height
        ]);
    }
};
var $785da19a645c07eb$var$$z = class e1 {
    constructor(e1, t){
        this.drawFunctions = $785da19a645c07eb$var$Jz, this.context = new $785da19a645c07eb$var$iz(e1), this.transform = t, this.layerOpacityFbo = null, this._tileTextures = {}, this._rttObjectRecyclePool = [], this._rttSharedFbo = null, this.terrainFacilitator = {
            depthDirty: !0,
            matrix: $785da19a645c07eb$var$nu(new Float64Array(16)),
            renderTime: 0
        }, this.setup(), this.numSublayers = $785da19a645c07eb$var$mD.maxOverzooming + $785da19a645c07eb$var$mD.maxUnderzooming + 1, this.depthEpsilon = 1 / 65536, this.crossTileSymbolIndex = new $785da19a645c07eb$var$_P;
    }
    resize(e1, t, i) {
        if (this.width = Math.floor(e1 * i), this.height = Math.floor(t * i), this.pixelRatio = i, this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.style) for (let e1 of this.style._order)this.style._layers[e1].resize();
    }
    setup() {
        let e1 = this.context, t = new $785da19a645c07eb$var$l_;
        t.emplaceBack(0, 0), t.emplaceBack($785da19a645c07eb$var$Vu, 0), t.emplaceBack(0, $785da19a645c07eb$var$Vu), t.emplaceBack($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu), this.tileExtentBuffer = e1.createVertexBuffer(t, $785da19a645c07eb$var$BT.members), this.tileExtentSegments = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 2);
        let i = new $785da19a645c07eb$var$l_;
        i.emplaceBack(0, 0), i.emplaceBack($785da19a645c07eb$var$Vu, 0), i.emplaceBack(0, $785da19a645c07eb$var$Vu), i.emplaceBack($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu), this.debugBuffer = e1.createVertexBuffer(i, $785da19a645c07eb$var$BT.members), this.debugSegments = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 5);
        let n = new $785da19a645c07eb$var$u_;
        n.emplaceBack(0, 0, 0, 0), n.emplaceBack($785da19a645c07eb$var$Vu, 0, $785da19a645c07eb$var$Vu, 0), n.emplaceBack(0, $785da19a645c07eb$var$Vu, 0, $785da19a645c07eb$var$Vu), n.emplaceBack($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu), this.rasterBoundsBuffer = e1.createVertexBuffer(n, $785da19a645c07eb$var$EI.members), this.rasterBoundsSegments = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 2);
        let a = new $785da19a645c07eb$var$l_;
        a.emplaceBack(0, 0), a.emplaceBack($785da19a645c07eb$var$Vu, 0), a.emplaceBack(0, $785da19a645c07eb$var$Vu), a.emplaceBack($785da19a645c07eb$var$Vu, $785da19a645c07eb$var$Vu), this.rasterBoundsBufferPosOnly = e1.createVertexBuffer(a, $785da19a645c07eb$var$BT.members), this.rasterBoundsSegmentsPosOnly = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 5);
        let r = new $785da19a645c07eb$var$l_;
        r.emplaceBack(0, 0), r.emplaceBack(1, 0), r.emplaceBack(0, 1), r.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(r, $785da19a645c07eb$var$BT.members), this.viewportSegments = $785da19a645c07eb$var$T_.simpleSegment(0, 0, 4, 2);
        let s = new $785da19a645c07eb$var$M_;
        s.emplaceBack(0), s.emplaceBack(1), s.emplaceBack(3), s.emplaceBack(2), s.emplaceBack(0), this.tileBorderIndexBuffer = e1.createIndexBuffer(s);
        let o = new $785da19a645c07eb$var$k_;
        o.emplaceBack(1, 0, 2), o.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(o);
        let l = this.context.gl;
        this.stencilClearMode = new $785da19a645c07eb$var$rz({
            func: l.ALWAYS,
            mask: 0
        }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.tileExtentMesh = new $785da19a645c07eb$var$LT(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
    }
    clearStencil() {
        let e1 = this.context, t = e1.gl;
        this.nextStencilID = 1, this.currentStencilSource = void 0;
        let i = $785da19a645c07eb$var$tu();
        $785da19a645c07eb$var$du(i, 0, this.width, this.height, 0, 0, 1), $785da19a645c07eb$var$ou(i, i, [
            t.drawingBufferWidth,
            t.drawingBufferHeight,
            0
        ]);
        let n = {
            mainMatrix: i,
            tileMercatorCoords: [
                0,
                0,
                1,
                1
            ],
            clippingPlane: [
                0,
                0,
                0,
                0
            ],
            projectionTransition: 0,
            fallbackMatrix: i,
            clipAntimeridian: !1
        };
        this.useProgram("clippingMask", null, !0).draw(e1, t.TRIANGLES, $785da19a645c07eb$var$nz.disabled, this.stencilClearMode, $785da19a645c07eb$var$tz.disabled, $785da19a645c07eb$var$oz.disabled, null, null, n, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
    }
    renderTileClippingMasks(e1, t, i) {
        if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t?.length) return;
        this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
        let n = this.context;
        n.setColorMode($785da19a645c07eb$var$tz.disabled), n.setDepthMode($785da19a645c07eb$var$nz.disabled);
        let a = {};
        for (let e1 of t)a[e1.key] = this.nextStencilID++;
        this.style.projection.useSubdivision && this._renderTileMasks(a, t, i, !0), this._renderTileMasks(a, t, i, !1), this._tileClippingMaskIDs = a;
    }
    _renderTileMasks(e1, t, i, n) {
        let a = this.context, r = a.gl, s = this.style.projection, o = this.transform, l = this.useProgram("clippingMask");
        for (let c of t){
            let t = e1[c.key], u = this.getTerrainDataForTile(c, i), h = s.getMeshFromTileID(this.context, c.canonical, n, !0, "stencil"), d = o.getProjectionData({
                overscaledTileID: c,
                applyGlobeMatrix: !i,
                applyTerrainMatrix: !0
            });
            l.draw(a, r.TRIANGLES, $785da19a645c07eb$var$nz.disabled, new $785da19a645c07eb$var$rz({
                func: r.ALWAYS,
                mask: 0
            }, t, 255, r.KEEP, r.KEEP, r.REPLACE), $785da19a645c07eb$var$tz.disabled, i ? $785da19a645c07eb$var$oz.disabled : $785da19a645c07eb$var$oz.backCCW, null, u, d, "$clipping", h.vertexBuffer, h.indexBuffer, h.segments);
        }
    }
    getTerrainDataForTile(e1, t) {
        return t && "mercator" === this.style.projection?.name ? null : this.style.map.terrain?.getTerrainData(e1) || null;
    }
    _renderTilesDepthBuffer() {
        let e1 = this.context, t = e1.gl, i = this.style.projection, n = this.transform, a = this.useProgram("depth"), r = this.getDepthModeFor3D(), s = $785da19a645c07eb$var$rD(n, {
            tileSize: n.tileSize
        });
        for (let o of s){
            let s = this.style.map.terrain?.getTerrainData(o), l = i.getMeshFromTileID(this.context, o.canonical, !0, !0, "raster"), c = n.getProjectionData({
                overscaledTileID: o,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            a.draw(e1, t.TRIANGLES, r, $785da19a645c07eb$var$rz.disabled, $785da19a645c07eb$var$tz.disabled, $785da19a645c07eb$var$oz.backCCW, null, s, c, "$clipping", l.vertexBuffer, l.indexBuffer, l.segments);
        }
    }
    stencilModeFor3D() {
        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
        let e1 = this.nextStencilID++, t = this.context.gl;
        return new $785da19a645c07eb$var$rz({
            func: t.NOTEQUAL,
            mask: 255
        }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
    }
    stencilModeForClipping(e1) {
        let t = this.context.gl;
        return new $785da19a645c07eb$var$rz({
            func: t.EQUAL,
            mask: 255
        }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
    }
    getStencilConfigForOverlapAndUpdateStencilID(e1) {
        let t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), n = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - n + 1;
        if (a > 1) {
            this.currentStencilSource = void 0, this.nextStencilID + a > 256 && this.clearStencil();
            let e1 = {};
            for(let i = 0; i < a; i++)e1[i + n] = new $785da19a645c07eb$var$rz({
                func: t.GEQUAL,
                mask: 255
            }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID += a, [
                e1,
                i
            ];
        }
        return [
            {
                [n]: $785da19a645c07eb$var$rz.disabled
            },
            i
        ];
    }
    stencilConfigForOverlapTwoPass(e1) {
        let t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), n = i[i.length - 1].overscaledZ, a = i[0].overscaledZ - n + 1;
        if (this.clearStencil(), a > 1) {
            let e1 = {}, r = {};
            for(let i = 0; i < a; i++)e1[i + n] = new $785da19a645c07eb$var$rz({
                func: t.GREATER,
                mask: 255
            }, a + 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE), r[i + n] = new $785da19a645c07eb$var$rz({
                func: t.GREATER,
                mask: 255
            }, 1 + i, 255, t.KEEP, t.KEEP, t.REPLACE);
            return this.nextStencilID = 2 * a + 1, [
                e1,
                r,
                i
            ];
        }
        return this.nextStencilID = 3, [
            {
                [n]: new $785da19a645c07eb$var$rz({
                    func: t.GREATER,
                    mask: 255
                }, 2, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            {
                [n]: new $785da19a645c07eb$var$rz({
                    func: t.GREATER,
                    mask: 255
                }, 1, 255, t.KEEP, t.KEEP, t.REPLACE)
            },
            i
        ];
    }
    colorModeForRenderPass() {
        let e1 = this.context.gl;
        if (this._showOverdrawInspector) {
            let t = 1 / 8;
            return new $785da19a645c07eb$var$tz([
                e1.CONSTANT_COLOR,
                e1.ONE
            ], new $785da19a645c07eb$var$np(t, t, t, 0), [
                !0,
                !0,
                !0,
                !0
            ]);
        }
        return "opaque" === this.renderOptions.currentPass ? $785da19a645c07eb$var$tz.unblended : $785da19a645c07eb$var$tz.alphaBlended;
    }
    getDepthModeForSublayer(e1, t, i) {
        if (!this.opaquePassEnabledForLayer()) return $785da19a645c07eb$var$nz.disabled;
        let n = 1 - ((1 + this.renderOptions.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
        return new $785da19a645c07eb$var$nz(i || this.context.gl.LEQUAL, t, [
            n,
            n
        ]);
    }
    getDepthModeFor3D() {
        return new $785da19a645c07eb$var$nz(this.context.gl.LEQUAL, $785da19a645c07eb$var$nz.ReadWrite, this.renderOptions.depthRangeFor3D);
    }
    opaquePassEnabledForLayer() {
        return this.renderOptions.currentLayer < this.renderOptions.opaquePassCutoff;
    }
    render(e1, t) {
        this.style = e1, this.options = t;
        let i = this.renderOptions = function(e1, t, i) {
            let n = t?.transitionState ?? 0;
            return {
                currentPass: "offscreen",
                currentLayer: 0,
                opaquePassCutoff: 1 / 0,
                depthRangeFor3D: [
                    0,
                    1
                ],
                isRenderingToTexture: !1,
                transform: e1,
                terrain: i,
                projectionTransition: n,
                isRenderingGlobe: n > 0
            };
        }(this.transform, e1.projection, e1.map.terrain ?? null);
        this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.patternAtlas = e1.patternAtlas, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange($785da19a645c07eb$var$aC()), function(e1, t) {
            let i = e1.pending, { transform: n } = t, a = t.context.gl;
            i[$785da19a645c07eb$var$ez.u_units_to_pixels] = 1 / n.pixelsToGLUnits[0], i[$785da19a645c07eb$var$ez.u_units_to_pixels + 1] = 1 / n.pixelsToGLUnits[1], i[$785da19a645c07eb$var$ez.u_world_size] = a.drawingBufferWidth, i[$785da19a645c07eb$var$ez.u_world_size + 1] = a.drawingBufferHeight, i[$785da19a645c07eb$var$ez.u_camera_to_center_distance] = n.cameraToCenterDistance, i[$785da19a645c07eb$var$ez.u_symbol_fade_change] = t.options.fadeDuration ? t.symbolFadeChange : 1, i[$785da19a645c07eb$var$ez.u_aspect_ratio] = n.width / n.height, i[$785da19a645c07eb$var$ez.u_device_pixel_ratio] = t.pixelRatio, i[$785da19a645c07eb$var$ez.u_viewport_size] = n.width, i[$785da19a645c07eb$var$ez.u_viewport_size + 1] = n.height, i[$785da19a645c07eb$var$ez.u_pixel_extrude_scale] = 1 / n.width, i[$785da19a645c07eb$var$ez.u_pixel_extrude_scale + 1] = 1 / n.height, i[$785da19a645c07eb$var$ez.u_pitch] = n.pitch / 360 * 2 * Math.PI, e1.upload();
        }(this.context.frameUniformBuffer, this), this.imageManager.beginFrame();
        let n = this.style._order, a = this.style.tileManagers, r = {}, s = {}, o = {};
        for(let e1 in a){
            let t = a[e1];
            t.used && t.prepare(this.context), r[e1] = t.getVisibleCoordinates(!1), s[e1] = r[e1].slice().reverse(), o[e1] = t.getVisibleCoordinates(!0).reverse();
        }
        i.opaquePassCutoff = 1 / 0;
        for(let e1 = 0; e1 < n.length; e1++){
            let t = n[e1];
            if (this.style._layers[t].is3D()) {
                i.opaquePassCutoff = e1;
                break;
            }
        }
        this.maybeDrawDepth(), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), i.opaquePassCutoff = 0), i.currentPass = "offscreen";
        for (let e1 of n){
            let t = this.style._layers[e1];
            if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
            let n = s[t.source];
            ("custom" === t.type || n.length) && this.renderLayer(this, a[t.source], t, n, i);
        }
        if (this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.bindFramebuffer.set(null), this.context.clear({
            color: t.showOverdrawInspector ? $785da19a645c07eb$var$np.black : $785da19a645c07eb$var$np.transparent,
            depth: 1
        }), this.clearStencil(), this.style.sky && this.drawFunctions.sky(this, this.style.sky), this._showOverdrawInspector = t.showOverdrawInspector, i.depthRangeFor3D = [
            0,
            1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
        ], !this.renderToTexture) for(i.currentPass = "opaque", i.currentLayer = n.length - 1; i.currentLayer >= 0; i.currentLayer--){
            let e1 = this.style._layers[n[i.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = a[e1.source], s = r[e1.source];
            this.renderTileClippingMasks(e1, s, !1), this.renderLayer(this, t, e1, s, i);
        }
        i.currentPass = "translucent";
        let l = !1;
        for(i.currentLayer = 0; i.currentLayer < n.length; i.currentLayer++){
            let e1 = this.style._layers[n[i.currentLayer]];
            if (e1.isHidden(this.transform.zoom)) continue;
            let t = a[e1.source];
            if (this.renderToTexture?.renderLayer(e1, i)) continue;
            !this.opaquePassEnabledForLayer() && !l && (l = !0, i.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
            let c = ("symbol" === e1.type ? o : s)[e1.source];
            this.renderTileClippingMasks(e1, r[e1.source], !!this.renderToTexture), this.renderLayer(this, t, e1, c, i);
        }
        if (i.isRenderingGlobe && this.drawFunctions.atmosphere(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
            let e1 = function(e1, t) {
                let i = null, n = Object.values(e1._layers).flatMap((i)=>i.source && !i.isHidden(t) ? [
                        e1.tileManagers[i.source]
                    ] : []), a = n.filter((e1)=>"vector" === e1.getSource().type), r = n.filter((e1)=>"vector" !== e1.getSource().type), s = (e1)=>{
                    (!i || i.getSource().maxzoom < e1.getSource().maxzoom) && (i = e1);
                };
                for (let e1 of a)s(e1);
                if (!i) for (let e1 of r)s(e1);
                return i;
            }(this.style, this.transform.zoom);
            e1 && this.drawFunctions.debug(this, e1, e1.getVisibleCoordinates());
        }
        this.options.showPadding && this.drawFunctions.debugPadding(this), this.context.setDefault();
    }
    maybeDrawDepth() {
        if (!this.style?.projection || !this.style.map?.terrain) return;
        let e1 = this.terrainFacilitator.matrix, t = this.transform.modelViewProjectionMatrix, i = this.terrainFacilitator.depthDirty;
        i ||= !function(e1, t) {
            var i = e1[0], n = e1[1], a = e1[2], r = e1[3], s = e1[4], o = e1[5], l = e1[6], c = e1[7], u = e1[8], h = e1[9], d = e1[10], p = e1[11], m = e1[12], g = e1[13], f = e1[14], A = e1[15], _ = t[0], v = t[1], y = t[2], x = t[3], b = t[4], w = t[5], E = t[6], k = t[7], S = t[8], M = t[9], C = t[10], T = t[11], D = t[12], P = t[13], I = t[14], F = t[15];
            return Math.abs(i - _) <= 1e-6 * Math.max(1, Math.abs(i), Math.abs(_)) && Math.abs(n - v) <= 1e-6 * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(a - y) <= 1e-6 * Math.max(1, Math.abs(a), Math.abs(y)) && Math.abs(r - x) <= 1e-6 * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(s - b) <= 1e-6 * Math.max(1, Math.abs(s), Math.abs(b)) && Math.abs(o - w) <= 1e-6 * Math.max(1, Math.abs(o), Math.abs(w)) && Math.abs(l - E) <= 1e-6 * Math.max(1, Math.abs(l), Math.abs(E)) && Math.abs(c - k) <= 1e-6 * Math.max(1, Math.abs(c), Math.abs(k)) && Math.abs(u - S) <= 1e-6 * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(h - M) <= 1e-6 * Math.max(1, Math.abs(h), Math.abs(M)) && Math.abs(d - C) <= 1e-6 * Math.max(1, Math.abs(d), Math.abs(C)) && Math.abs(p - T) <= 1e-6 * Math.max(1, Math.abs(p), Math.abs(T)) && Math.abs(m - D) <= 1e-6 * Math.max(1, Math.abs(m), Math.abs(D)) && Math.abs(g - P) <= 1e-6 * Math.max(1, Math.abs(g), Math.abs(P)) && Math.abs(f - I) <= 1e-6 * Math.max(1, Math.abs(f), Math.abs(I)) && Math.abs(A - F) <= 1e-6 * Math.max(1, Math.abs(A), Math.abs(F));
        }(e1, t), i ||= this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime), i && (function(e1, t) {
            e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15];
        }(e1, t), this.terrainFacilitator.renderTime = $785da19a645c07eb$var$aC(), this.terrainFacilitator.depthDirty = !1, this.drawFunctions.terrainDepth(this, this.style.map.terrain));
    }
    renderLayer(e1, t, i, n, a) {
        if (i.isHidden(this.transform.zoom) || "background" !== i.type && "custom" !== i.type && !(n || []).length) return;
        this.id = i.id;
        let r = this.drawFunctions;
        $785da19a645c07eb$var$RE(i) ? r.symbol(e1, t, i, n, this.style.placement.variableOffsets, a) : ((e1)=>"circle" === e1.type)(i) ? r.circle(e1, t, i, n, a) : ((e1)=>"heatmap" === e1.type)(i) ? r.heatmap(e1, t, i, n, a) : ((e1)=>"line" === e1.type)(i) ? r.line(e1, t, i, n, a) : ((e1)=>"fill" === e1.type)(i) ? r.fill(e1, t, i, n, a) : ((e1)=>"fill-extrusion" === e1.type)(i) ? r.fillExtrusion(e1, t, i, n, a) : ((e1)=>"hillshade" === e1.type)(i) ? r.hillshade(e1, t, i, n, a) : ((e1)=>"color-relief" === e1.type)(i) ? r.colorRelief(e1, t, i, n, a) : $785da19a645c07eb$var$vA(i) ? r.raster(e1, t, i, n, a) : ((e1)=>"background" === e1.type)(i) ? r.background(e1, t, i, n, a) : ((e1)=>"custom" === e1.type)(i) && r.custom(e1, t, i, a);
    }
    static{
        this.MAX_TEXTURE_POOL_SIZE_PER_BUCKET = 50;
    }
    saveTileTexture(t) {
        let i = this._tileTextures[t.size[0]];
        i ? i.length < e1.MAX_TEXTURE_POOL_SIZE_PER_BUCKET ? i.push(t) : t.destroy() : this._tileTextures[t.size[0]] = [
            t
        ];
    }
    getTileTexture(e1) {
        let t = this._tileTextures[e1];
        return t && t.length > 0 ? t.pop() : null;
    }
    acquireRTT(e1) {
        let t = this.context.gl, i = this._rttObjectRecyclePool.pop();
        if (i) return i.size !== e1 && (i.texture.update({
            width: e1,
            height: e1,
            data: null
        }, {
            premultiply: !1,
            useMipmap: !0
        }), i.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), i.size = e1), i;
        let n = new $785da19a645c07eb$var$ry(this.context, {
            width: e1,
            height: e1,
            data: null
        }, t.RGBA, {
            premultiply: !1,
            useMipmap: !0
        });
        return n.bind(t.LINEAR, t.CLAMP_TO_EDGE, t.LINEAR_MIPMAP_LINEAR), this.context.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, this.context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this.context.extTextureFilterAnisotropicMax), {
            texture: n,
            size: e1
        };
    }
    bindRTT(e1) {
        let t = this.context.gl, i = e1.size;
        if (!this._rttSharedFbo) {
            let e1 = this.context.createFramebuffer(i, i, !0, !0), n = this.context.createRenderbuffer(t.DEPTH_STENCIL, i, i);
            e1.depthAttachment.set(n), this._rttSharedFbo = {
                fbo: e1,
                depthRenderbuffer: n,
                size: i
            };
        }
        this._rttSharedFbo.size !== i && (this.context.bindRenderbuffer.set(this._rttSharedFbo.depthRenderbuffer), t.renderbufferStorage(t.RENDERBUFFER, t.DEPTH_STENCIL, i, i), this.context.bindRenderbuffer.set(null), this._rttSharedFbo.fbo.width = i, this._rttSharedFbo.fbo.height = i, this._rttSharedFbo.size = i), this._rttSharedFbo.fbo.colorAttachment.set(e1.texture.texture), this.context.bindFramebuffer.set(this._rttSharedFbo.fbo.framebuffer);
    }
    releaseRTT(e1) {
        this._rttObjectRecyclePool.push(e1);
    }
    isPatternMissing(e1) {
        if (!e1) return !1;
        if (!e1.from || !e1.to) return !0;
        let t = this.patternAtlas.getPattern(e1.from.toString()), i = this.patternAtlas.getPattern(e1.to.toString());
        return !t || !i;
    }
    useProgram(e1, t, i = !1, n = []) {
        this.cache ||= {};
        let a = !!this.style.map.terrain, r = this.style.projection, s = i ? $785da19a645c07eb$var$yP.projectionMercator : r.shaderPreludeCode, o = i ? $785da19a645c07eb$var$bP : r.shaderDefine, l = `/${i ? $785da19a645c07eb$var$wP : r.shaderVariantName}`, c = e1 + (t ? t.cacheKey : "") + l + (this._showOverdrawInspector ? "/overdraw" : "") + (a ? "/terrain" : "") + (n ? `/${n.join("/")}` : "");
        return this.cache[c] ||= new $785da19a645c07eb$var$BI(this.context, $785da19a645c07eb$var$yP[e1], t, $785da19a645c07eb$var$dF[e1], this._showOverdrawInspector, a, s, o, n), this.cache[c];
    }
    setCustomLayerDefaults() {
        this.context.setCustomLayerDefaults();
    }
    setBaseState() {
        let e1 = this.context.gl;
        this.context.cullFace.set(!1), this.context.viewport.set([
            0,
            0,
            this.width,
            this.height
        ]), this.context.blendEquation.set(e1.FUNC_ADD);
    }
    initDebugOverlayCanvas() {
        if (null == this.debugOverlayCanvas) {
            this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
            let e1 = this.context.gl;
            this.debugOverlayTexture = new $785da19a645c07eb$var$ry(this.context, this.debugOverlayCanvas, e1.RGBA);
        }
    }
    destroy() {
        if (this._tileTextures) {
            for(let e1 in this._tileTextures){
                let t = this._tileTextures[e1];
                if (t) for (let e1 of t)e1.destroy();
            }
            this._tileTextures = {};
        }
        for (let e1 of this._rttObjectRecyclePool)e1.texture.destroy();
        if (this._rttObjectRecyclePool = [], this._rttSharedFbo) {
            this._rttSharedFbo.fbo.colorAttachment.set(null), this._rttSharedFbo.fbo.depthAttachment.set(null);
            let e1 = this.context.gl;
            e1.deleteRenderbuffer(this._rttSharedFbo.depthRenderbuffer), e1.deleteFramebuffer(this._rttSharedFbo.fbo.framebuffer), this._rttSharedFbo = null;
        }
        if (this.layerOpacityFbo?.destroy(), this.layerOpacityFbo = null, this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && this.tileExtentMesh.vertexBuffer?.destroy(), this.tileExtentMesh && this.tileExtentMesh.indexBuffer?.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.context.projectionUniformBuffer.destroy(), this.context.terrainUniformBuffer.destroy(), this.context.frameUniformBuffer.destroy(), this.cache) {
            for(let e1 in this.cache){
                let t = this.cache[e1];
                t?.program && this.context.gl.deleteProgram(t.program);
            }
            this.cache = {};
        }
        this.context && this.context.setDefault();
    }
    overLimit() {
        let { drawingBufferWidth: e1, drawingBufferHeight: t } = this.context.gl;
        return this.width !== e1 || this.height !== t;
    }
}, $785da19a645c07eb$var$eR = class extends Error {
    constructor(e1, t){
        super("WebGL2 is required to display this map. We are sorry, but it seems that your browser does not support WebGL2, a technology for rendering 3D graphics on the web. Read more on https://wiki.openstreetmap.org/wiki/This_map_requires_WebGL"), this.name = "GPUInitializationError", this.requestedAttributes = e1, this.statusMessage = t?.statusMessage ?? null;
    }
};
function $785da19a645c07eb$var$tR(e1, t) {
    let i, n = !1, a = null, r = ()=>{
        a = null, n &&= (e1(...i), a = setTimeout(r, t), !1);
    };
    return (...e1)=>(n = !0, i = e1, a || r(), a);
}
var $785da19a645c07eb$var$iR = class {
    constructor(e1){
        this._getHashParams = ()=>new URLSearchParams(window.location.hash.replace("#", "")), this._getCurrentHash = ()=>{
            let e1 = this._getHashParams();
            return this._hashName ? (e1.get(this._hashName) || "").split("/") : ([
                ...e1.keys()
            ][0] ?? "").split("/");
        }, this._onHashChange = ()=>{
            let e1 = this._getCurrentHash();
            if (!this._isValidHash(e1)) return !1;
            let t = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(e1[3] || 0) : this._map.getBearing();
            return this._map.jumpTo({
                center: [
                    +e1[2],
                    +e1[1]
                ],
                zoom: +e1[0],
                bearing: t,
                pitch: +(e1[4] || 0)
            }), !0;
        }, this._updateHashUnthrottled = ()=>{
            let e1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
            window.history.replaceState(window.history.state, null, e1);
        }, this._removeHash = ()=>{
            let e1 = this._getHashParams();
            if (this._hashName) e1.delete(this._hashName);
            else {
                let t = Array.from(e1.keys());
                t.length > 0 && e1.delete(t[0]);
            }
            let t = decodeURIComponent(e1.toString()).replace(/=&/g, "&").replace(/=$/g, ""), i = t ? `#${t}` : "", n = window.location.href.replace(/(#.+)?$/, i);
            n = n.replace("&&", "&"), window.history.replaceState(window.history.state, null, n);
        }, this._updateHash = $785da19a645c07eb$var$tR(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
    }
    addTo(e1) {
        return this._map = e1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
    }
    remove() {
        return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
    }
    getHashString(e1) {
        let t = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, n = 10 ** Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), a = Math.round(t.lng * n) / n, r = Math.round(t.lat * n) / n, s = this._map.getBearing(), o = this._map.getPitch(), l = "";
        if (l += e1 ? `/${a}/${r}/${i}` : `${i}/${r}/${a}`, (s || o) && (l += "/" + Math.round(10 * s) / 10), o && (l += `/${Math.round(o)}`), this._hashName) {
            let e1 = this._getHashParams();
            return e1.set(this._hashName, l), `#${decodeURIComponent(e1.toString()).replace(/=&/g, "&").replace(/=$/g, "")}`;
        }
        return `#${l}`;
    }
    _isValidHash(e1) {
        if (e1.length < 3 || e1.some((e1)=>isNaN(+e1))) return !1;
        try {
            new $785da19a645c07eb$var$Mx(+e1[2], +e1[1]);
        } catch  {
            return !1;
        }
        let t = +e1[0], i = +(e1[3] || 0), n = +(e1[4] || 0);
        return t >= this._map.getMinZoom() && t <= this._map.getMaxZoom() && i >= -180 && i <= 180 && n >= this._map.getMinPitch() && n <= this._map.getMaxPitch();
    }
};
const $785da19a645c07eb$var$nR = {
    linearity: .3,
    easing: $785da19a645c07eb$var$oh(0, 0, .3, 1)
}, $785da19a645c07eb$var$aR = $785da19a645c07eb$var$hh({
    deceleration: 2500,
    maxSpeed: 1400
}, $785da19a645c07eb$var$nR), $785da19a645c07eb$var$rR = $785da19a645c07eb$var$hh({
    deceleration: 20,
    maxSpeed: 1400
}, $785da19a645c07eb$var$nR), $785da19a645c07eb$var$sR = $785da19a645c07eb$var$hh({
    deceleration: 1e3,
    maxSpeed: 360
}, $785da19a645c07eb$var$nR), $785da19a645c07eb$var$oR = $785da19a645c07eb$var$hh({
    deceleration: 1e3,
    maxSpeed: 90
}, $785da19a645c07eb$var$nR), $785da19a645c07eb$var$lR = $785da19a645c07eb$var$hh({
    deceleration: 1e3,
    maxSpeed: 360
}, $785da19a645c07eb$var$nR);
var $785da19a645c07eb$var$cR = class {
    constructor(e1){
        this._map = e1, this.clear();
    }
    clear() {
        this._inertiaBuffer = [];
    }
    record(e1) {
        this._drainInertiaBuffer(), this._inertiaBuffer.push({
            time: $785da19a645c07eb$var$aC(),
            settings: e1
        });
    }
    _drainInertiaBuffer() {
        let e1 = this._inertiaBuffer, t = $785da19a645c07eb$var$aC();
        for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
    }
    _getVelocityEntries() {
        let e1 = this._inertiaBuffer, t = $785da19a645c07eb$var$aC() - 60, i = Math.max(0, e1.length - 2);
        for(; i > 0 && e1[i - 1].time >= t;)i--;
        return e1.slice(i);
    }
    _onMoveEnd(e1) {
        this._drainInertiaBuffer();
        let t = this._getVelocityEntries();
        if (t.length < 2) return void this.clear();
        let i = {
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            pan: new $785da19a645c07eb$var$Kc(0, 0),
            pinchAround: void 0,
            around: void 0
        };
        for (let { settings: e1 } of t)e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
        for (let { settings: e1 } of t.slice(1))i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, i.roll += e1.rollDelta || 0, e1.panDelta && i.pan._add(e1.panDelta);
        if (!(i.pan.mag() || i.zoom || i.bearing || i.pitch || i.roll)) return void this.clear();
        let n = $785da19a645c07eb$var$aC() - t[0].time, a = {};
        if (i.pan.mag()) {
            let t = $785da19a645c07eb$var$hR(i.pan.mag(), n, $785da19a645c07eb$var$hh({}, $785da19a645c07eb$var$aR, e1 || {})), r = i.pan.mult(t.amount / i.pan.mag()), s = this._map._camera.cameraHelper.handlePanInertia(r, this._map._camera.transform);
            a.center = s.easingCenter, a.offset = s.easingOffset, $785da19a645c07eb$var$uR(a, t);
        }
        if (i.zoom) {
            let e1 = $785da19a645c07eb$var$hR(i.zoom, n, $785da19a645c07eb$var$rR);
            a.zoom = $785da19a645c07eb$var$Ah(this._map.getZoom() + e1.amount, this._map.getZoomSnap(), e1.amount), $785da19a645c07eb$var$uR(a, e1);
        }
        if (i.bearing) {
            let e1 = $785da19a645c07eb$var$hR(i.bearing, n, $785da19a645c07eb$var$sR);
            a.bearing = this._map.getBearing() + $785da19a645c07eb$var$ch(e1.amount, -179, 179), $785da19a645c07eb$var$uR(a, e1);
        }
        if (i.pitch) {
            let e1 = $785da19a645c07eb$var$hR(i.pitch, n, $785da19a645c07eb$var$oR);
            a.pitch = this._map.getPitch() + e1.amount, $785da19a645c07eb$var$uR(a, e1);
        }
        if (i.roll) {
            let e1 = $785da19a645c07eb$var$hR(i.roll, n, $785da19a645c07eb$var$lR);
            a.roll = this._map.getRoll() + $785da19a645c07eb$var$ch(e1.amount, -179, 179), $785da19a645c07eb$var$uR(a, e1);
        }
        if (a.zoom || a.bearing) {
            let e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
            a.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
        }
        return this.clear(), $785da19a645c07eb$var$hh(a, {
            noMoveStart: !0
        });
    }
};
function $785da19a645c07eb$var$uR(e1, t) {
    (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
}
function $785da19a645c07eb$var$hR(e1, t, i) {
    let { maxSpeed: n, linearity: a, deceleration: r } = i, s = $785da19a645c07eb$var$ch(e1 * a / (t / 1e3), -n, n), o = Math.abs(s) / (r * a);
    return {
        easing: i.easing,
        duration: 1e3 * o,
        amount: o / 2 * s
    };
}
var $785da19a645c07eb$var$dR = class {
    constructor(e1, t){
        this._map = e1, this._clickTolerance = t.clickTolerance;
    }
    reset() {
        delete this._mousedownPos;
    }
    wheel(e1) {
        return this._firePreventable(new $785da19a645c07eb$var$gC(this._map, e1));
    }
    mousedown(e1, t) {
        return this._mousedownPos = t, this._firePreventable(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    mouseup(e1) {
        this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    click(e1, t) {
        this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    dblclick(e1) {
        return this._firePreventable(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    mouseover(e1) {
        this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    mouseout(e1) {
        this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    touchstart(e1) {
        return this._firePreventable(new $785da19a645c07eb$var$mC(e1.type, this._map, e1));
    }
    touchmove(e1) {
        this._map.fire(new $785da19a645c07eb$var$mC(e1.type, this._map, e1));
    }
    touchend(e1) {
        this._map.fire(new $785da19a645c07eb$var$mC(e1.type, this._map, e1));
    }
    touchcancel(e1) {
        this._map.fire(new $785da19a645c07eb$var$mC(e1.type, this._map, e1));
    }
    _firePreventable(e1) {
        if (this._map.fire(e1), e1.defaultPrevented) return {};
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $785da19a645c07eb$var$pR = class {
    constructor(e1){
        this._map = e1;
    }
    reset() {
        this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
    }
    mousemove(e1) {
        this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1));
    }
    mousedown() {
        this._delayContextMenu = !0, this._ignoreContextMenu = !1;
    }
    mouseup() {
        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new $785da19a645c07eb$var$pC("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
    }
    contextmenu(e1) {
        this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new $785da19a645c07eb$var$pC(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
    }
    isEnabled() {
        return !0;
    }
    isActive() {
        return !1;
    }
    enable() {}
    disable() {}
}, $785da19a645c07eb$var$mR = class {
    constructor(e1, t, i){
        this._map = e1, this._tr = i, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1, t.boxZoom && "object" == typeof t.boxZoom && (this._boxZoomEnd = t.boxZoom.boxZoomEnd);
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
    enable() {
        this.isEnabled() || (this._enabled = !0);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    mousedown(e1, t) {
        this.isEnabled() && e1.shiftKey && 0 === e1.button && ($785da19a645c07eb$var$rC.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
    }
    mousemoveWindow(e1, t) {
        if (!this._active) return;
        let i = t;
        if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
        let n = this._startPos;
        this._lastPos = i, this._box || (this._box = $785da19a645c07eb$var$rC.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e1));
        let a = Math.min(n.x, i.x), r = Math.max(n.x, i.x), s = Math.min(n.y, i.y), o = Math.max(n.y, i.y);
        this._box.style.transform = `translate(${a}px,${s}px)`, this._box.style.width = r - a + "px", this._box.style.height = o - s + "px";
    }
    mouseupWindow(e1, t) {
        if (!this._active || 0 !== e1.button) return;
        let i = this._startPos, n = t;
        if (this.reset(), $785da19a645c07eb$var$rC.suppressClick(), i.x !== n.x || i.y !== n.y) return this._map.fire(new $785da19a645c07eb$var$fC("boxzoomend", {
            originalEvent: e1
        })), this._boxZoomEnd ? void this._boxZoomEnd(this._map, i, n, e1) : {
            cameraAnimation: (e1)=>e1.fitScreenCoordinates(i, n, this._tr.bearing, {
                    linear: !0
                })
        };
        this._fireEvent("boxzoomcancel", e1);
    }
    keydown(e1) {
        this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
    }
    reset() {
        this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box &&= (this._box.remove(), null), $785da19a645c07eb$var$rC.enableDrag(), delete this._startPos, delete this._lastPos;
    }
    _fireEvent(e1, t) {
        return this._map.fire(new $785da19a645c07eb$var$fC(e1, {
            originalEvent: t
        }));
    }
};
function $785da19a645c07eb$var$gR(e1, t) {
    if (e1.length !== t.length) throw Error(`The number of touches and points are not equal - touches ${e1.length}, points ${t.length}`);
    let i = {};
    for(let n = 0; n < e1.length; n++)i[e1[n].identifier] = t[n];
    return i;
}
var $785da19a645c07eb$var$fR = class {
    constructor(e1){
        this.reset(), this.numTouches = e1.numTouches;
    }
    reset() {
        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
    }
    touchstart(e1, t, i) {
        (this.centroid || i.length > this.numTouches) && (this.aborted = !0), !this.aborted && (void 0 === this.startTime && (this.startTime = e1.timeStamp), i.length === this.numTouches && (this.centroid = function(e1) {
            let t = new $785da19a645c07eb$var$Kc(0, 0);
            for (let i of e1)t._add(i);
            return t.div(e1.length);
        }(t), this.touches = $785da19a645c07eb$var$gR(i, t)));
    }
    touchmove(e1, t, i) {
        if (this.aborted || !this.centroid) return;
        let n = $785da19a645c07eb$var$gR(i, t);
        for(let e1 in this.touches){
            let t = this.touches[e1], i = n[e1];
            (!i || i.dist(t) > 30) && (this.aborted = !0);
        }
    }
    touchend(e1, t, i) {
        if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
            let e1 = !this.aborted && this.centroid;
            if (this.reset(), e1) return e1;
        }
    }
}, $785da19a645c07eb$var$AR = class {
    constructor(e1){
        this.singleTap = new $785da19a645c07eb$var$fR(e1), this.numTaps = e1.numTaps, this.reset();
    }
    reset() {
        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
    }
    touchstart(e1, t, i) {
        this.singleTap.touchstart(e1, t, i);
    }
    touchmove(e1, t, i) {
        this.singleTap.touchmove(e1, t, i);
    }
    touchend(e1, t, i) {
        let n = this.singleTap.touchend(e1, t, i);
        if (n) {
            let t = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(n) < 30;
            if ((!t || !i) && this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = n, this.count === this.numTaps) return this.reset(), n;
        }
    }
}, $785da19a645c07eb$var$_R = class {
    constructor(e1, t){
        this._tr = t, this._zoomIn = new $785da19a645c07eb$var$AR({
            numTouches: 1,
            numTaps: 2
        }), this._zoomOut = new $785da19a645c07eb$var$AR({
            numTouches: 2,
            numTaps: 1
        }), this.reset();
    }
    reset() {
        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
    }
    touchstart(e1, t, i) {
        this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
    }
    touchmove(e1, t, i) {
        this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
    }
    touchend(e1, t, i) {
        let n = this._zoomIn.touchend(e1, t, i), a = this._zoomOut.touchend(e1, t, i), r = this._tr;
        return n ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (t)=>t.easeTo({
                    duration: 300,
                    zoom: $785da19a645c07eb$var$Ah(r.zoom + 1, t.getZoomSnap()),
                    around: r.unproject(n)
                }, {
                    originalEvent: e1
                })
        }) : a ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
            cameraAnimation: (t)=>t.easeTo({
                    duration: 300,
                    zoom: $785da19a645c07eb$var$Ah(r.zoom - 1, t.getZoomSnap()),
                    around: r.unproject(a)
                }, {
                    originalEvent: e1
                })
        }) : void 0;
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $785da19a645c07eb$var$vR = class {
    constructor(e1){
        this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
    }
    reset(e1) {
        this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
    }
    _move(...e1) {
        let t = this._moveFunction(...e1);
        if (t.bearingDelta || t.pitchDelta || t.rollDelta || t.around || t.panDelta) return this._active = !0, t;
    }
    dragStart(e1, t) {
        this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
    }
    dragMove(e1, t) {
        if (!this.isEnabled()) return;
        let i = this._lastPoint;
        if (!i) return;
        if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) return void this.reset(e1);
        let n = Array.isArray(t) ? t[0] : t;
        return !this._moved && n.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = n, this._move(i, n));
    }
    dragEnd(e1) {
        this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && $785da19a645c07eb$var$rC.suppressClick(), this.reset(e1));
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    getClickTolerance() {
        return this._clickTolerance;
    }
};
const $785da19a645c07eb$var$yR = {
    0: 1,
    2: 2
};
var $785da19a645c07eb$var$xR = class {
    constructor(e1){
        this._correctEvent = e1.checkCorrectEvent;
    }
    startMove(e1) {
        this._eventButton = e1.button;
    }
    endMove(e1) {
        delete this._eventButton;
    }
    isValidStartEvent(e1) {
        return this._correctEvent(e1);
    }
    isValidMoveEvent(e1) {
        return !function(e1, t) {
            let i = $785da19a645c07eb$var$yR[t];
            return void 0 === e1.buttons || (e1.buttons & i) !== i;
        }(e1, this._eventButton);
    }
    isValidEndEvent(e1) {
        return e1.button === this._eventButton;
    }
}, $785da19a645c07eb$var$bR = class {
    constructor(){
        this._firstTouch = void 0;
    }
    _isOneFingerTouch(e1) {
        return 1 === e1.targetTouches.length;
    }
    _isSameTouchEvent(e1) {
        return e1.targetTouches[0].identifier === this._firstTouch;
    }
    startMove(e1) {
        this._firstTouch = e1.targetTouches[0].identifier;
    }
    endMove(e1) {
        delete this._firstTouch;
    }
    isValidStartEvent(e1) {
        return this._isOneFingerTouch(e1);
    }
    isValidMoveEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
    isValidEndEvent(e1) {
        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
    }
}, $785da19a645c07eb$var$wR = class {
    constructor(e1 = new $785da19a645c07eb$var$xR({
        checkCorrectEvent: ()=>!0
    }), t = new $785da19a645c07eb$var$bR){
        this.mouseMoveStateManager = e1, this.oneFingerTouchMoveStateManager = t;
    }
    _executeRelevantHandler(e1, t, i) {
        return e1 instanceof MouseEvent ? t(e1) : typeof TouchEvent < "u" && e1 instanceof TouchEvent ? i(e1) : void 0;
    }
    startMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.startMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.startMove(e1);
        });
    }
    endMove(e1) {
        this._executeRelevantHandler(e1, (e1)=>{
            this.mouseMoveStateManager.endMove(e1);
        }, (e1)=>{
            this.oneFingerTouchMoveStateManager.endMove(e1);
        });
    }
    isValidStartEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidStartEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(e1));
    }
    isValidMoveEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidMoveEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1));
    }
    isValidEndEvent(e1) {
        return !!this._executeRelevantHandler(e1, (e1)=>this.mouseMoveStateManager.isValidEndEvent(e1), (e1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(e1));
    }
};
const $785da19a645c07eb$var$ER = (e1)=>{
    e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = (e1)=>{
        e1.preventDefault();
    };
};
var $785da19a645c07eb$var$kR = class {
    constructor(e1, t){
        this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
    }
    reset() {
        this._active = !1, this._touches = {}, this._sum = new $785da19a645c07eb$var$Kc(0, 0);
    }
    _shouldBePrevented(e1) {
        return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
    }
    touchstart(e1, t, i) {
        return this._calculateTransform(e1, t, i);
    }
    touchmove(e1, t, i) {
        if (this._active) return this._shouldBePrevented(i.length) ? void this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e1) : (e1.preventDefault(), this._calculateTransform(e1, t, i));
    }
    touchend(e1, t, i) {
        this._calculateTransform(e1, t, i), this._active && this._shouldBePrevented(i.length) && this.reset();
    }
    touchcancel() {
        this.reset();
    }
    _calculateTransform(e1, t, i) {
        i.length > 0 && (this._active = !0);
        let n = $785da19a645c07eb$var$gR(i, t), a = new $785da19a645c07eb$var$Kc(0, 0), r = new $785da19a645c07eb$var$Kc(0, 0), s = 0;
        for(let e1 in n){
            let t = n[e1], i = this._touches[e1];
            i && (a._add(t), r._add(t.sub(i)), s++, n[e1] = t);
        }
        if (this._touches = n, this._shouldBePrevented(s) || !r.mag()) return;
        let o = r.div(s);
        return this._sum._add(o), this._sum.mag() < this._clickTolerance ? void 0 : {
            around: a.div(s),
            panDelta: o
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $785da19a645c07eb$var$SR = class {
    constructor(){
        this.reset();
    }
    reset() {
        this._active = !1, delete this._firstTwoTouches;
    }
    touchstart(e1, t, i) {
        this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
            i[0].identifier,
            i[1].identifier
        ], this._start([
            t[0],
            t[1]
        ]));
    }
    touchmove(e1, t, i) {
        if (!this._firstTwoTouches) return;
        e1.preventDefault();
        let [n, a] = this._firstTwoTouches, r = $785da19a645c07eb$var$MR(i, t, n), s = $785da19a645c07eb$var$MR(i, t, a);
        if (!r || !s) return;
        let o = this._aroundCenter ? null : r.add(s).div(2);
        return this._move([
            r,
            s
        ], o, e1);
    }
    touchend(e1, t, i) {
        if (!this._firstTwoTouches) return;
        let [n, a] = this._firstTwoTouches, r = $785da19a645c07eb$var$MR(i, t, n), s = $785da19a645c07eb$var$MR(i, t, a);
        r && s || (this._active && $785da19a645c07eb$var$rC.suppressClick(), this.reset());
    }
    touchcancel() {
        this.reset();
    }
    enable(e1) {
        this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active;
    }
};
function $785da19a645c07eb$var$MR(e1, t, i) {
    for(let n = 0; n < e1.length; n++)if (e1[n].identifier === i) return t[n];
}
function $785da19a645c07eb$var$CR(e1, t) {
    return Math.log(e1 / t) / Math.LN2;
}
var $785da19a645c07eb$var$TR = class extends $785da19a645c07eb$var$SR {
    constructor(){
        super(), this._zoomRate = 1, this._zoomThreshold = .1;
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    setZoomThreshold(e1) {
        this._zoomThreshold = e1 ?? .1;
    }
    reset() {
        super.reset(), delete this._distance, delete this._startDistance;
    }
    _start(e1) {
        this._startDistance = this._distance = e1[0].dist(e1[1]);
    }
    _move(e1, t) {
        let i = this._distance;
        if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs($785da19a645c07eb$var$CR(this._distance, this._startDistance)) < this._zoomThreshold)) return this._active = !0, {
            zoomDelta: $785da19a645c07eb$var$CR(this._distance, i) * this._zoomRate,
            pinchAround: t
        };
    }
};
function $785da19a645c07eb$var$DR(e1, t) {
    return 180 * e1.angleWith(t) / Math.PI;
}
var $785da19a645c07eb$var$PR = class extends $785da19a645c07eb$var$SR {
    reset() {
        super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
    }
    _start(e1) {
        this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
    }
    _move(e1, t, i) {
        let n = this._vector;
        if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
            bearingDelta: $785da19a645c07eb$var$DR(this._vector, n),
            pinchAround: t
        };
    }
    _isBelowThreshold(e1) {
        this._minDiameter = Math.min(this._minDiameter, e1.mag());
        let t = 25 / (Math.PI * this._minDiameter) * 360, i = $785da19a645c07eb$var$DR(e1, this._startVector);
        return Math.abs(i) < t;
    }
};
function $785da19a645c07eb$var$IR(e1) {
    return Math.abs(e1.y) > Math.abs(e1.x);
}
var $785da19a645c07eb$var$FR = class extends $785da19a645c07eb$var$SR {
    constructor(e1){
        super(), this._currentTouchCount = 0, this._map = e1;
    }
    reset() {
        super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
    }
    touchstart(e1, t, i) {
        super.touchstart(e1, t, i), this._currentTouchCount = i.length;
    }
    _start(e1) {
        this._lastPoints = e1, $785da19a645c07eb$var$IR(e1[0].sub(e1[1])) && (this._valid = !1);
    }
    _move(e1, t, i) {
        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
        let n = e1[0].sub(this._lastPoints[0]), a = e1[1].sub(this._lastPoints[1]);
        return this._valid = this.gestureBeginsVertically(n, a, i.timeStamp), this._valid ? (this._lastPoints = e1, this._active = !0, {
            pitchDelta: (n.y + a.y) / 2 * -0.5
        }) : void 0;
    }
    gestureBeginsVertically(e1, t, i) {
        if (void 0 !== this._valid) return this._valid;
        let n = e1.mag() >= 2, a = t.mag() >= 2;
        if (!n && !a) return;
        if (!n || !a) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
        let r = e1.y > 0 == t.y > 0;
        return $785da19a645c07eb$var$IR(e1) && $785da19a645c07eb$var$IR(t) && r;
    }
};
const $785da19a645c07eb$var$zR = {
    panStep: 100,
    bearingStep: 15,
    pitchStep: 10
};
var $785da19a645c07eb$var$RR = class {
    constructor(e1, t){
        this._tr = t;
        let i = $785da19a645c07eb$var$zR;
        this._panStep = i.panStep, this._bearingStep = i.bearingStep, this._pitchStep = i.pitchStep, this._rotationDisabled = !1;
    }
    reset() {
        this._active = !1;
    }
    keydown(e1) {
        if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
        let t = 0, i = 0, n = 0, a = 0, r = 0;
        switch(e1.keyCode){
            case 61:
            case 107:
            case 171:
            case 187:
                t = 1;
                break;
            case 189:
            case 109:
            case 173:
                t = -1;
                break;
            case 37:
                e1.shiftKey ? i = -1 : (e1.preventDefault(), a = -1);
                break;
            case 39:
                e1.shiftKey ? i = 1 : (e1.preventDefault(), a = 1);
                break;
            case 38:
                e1.shiftKey ? n = 1 : (e1.preventDefault(), r = -1);
                break;
            case 40:
                e1.shiftKey ? n = -1 : (e1.preventDefault(), r = 1);
                break;
            default:
                return;
        }
        return this._rotationDisabled && (i = 0, n = 0), {
            cameraAnimation: (s)=>{
                let o = this._tr;
                s.easeTo({
                    duration: 300,
                    easeId: "keyboardHandler",
                    easing: $785da19a645c07eb$var$LR,
                    zoom: t ? $785da19a645c07eb$var$Ah(o.zoom + t * (e1.shiftKey ? 2 : 1), s.getZoomSnap()) : o.zoom,
                    bearing: o.bearing + i * this._bearingStep,
                    pitch: o.pitch + n * this._pitchStep,
                    offset: [
                        -a * this._panStep,
                        -r * this._panStep
                    ],
                    center: o.center
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
    disableRotation() {
        this._rotationDisabled = !0;
    }
    enableRotation() {
        this._rotationDisabled = !1;
    }
};
function $785da19a645c07eb$var$LR(e1) {
    return e1 * (2 - e1);
}
const $785da19a645c07eb$var$BR = 4.000244140625;
var $785da19a645c07eb$var$OR = class {
    constructor(e1, t, i){
        this._onTimeout = (e1)=>{
            this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
        }, this._map = e1, this._tr = i, this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
    }
    setZoomRate(e1) {
        this._defaultZoomRate = e1;
    }
    setWheelZoomRate(e1) {
        this._wheelZoomRate = e1;
    }
    isEnabled() {
        return !!this._enabled;
    }
    isActive() {
        return !!this._active || void 0 !== this._finishTimeout;
    }
    isZooming() {
        return !!this._zooming;
    }
    enable(e1) {
        this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around);
    }
    disable() {
        this.isEnabled() && (this._enabled = !1);
    }
    _shouldBePrevented(e1) {
        return !!this._map.cooperativeGestures.isEnabled() && !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1));
    }
    wheel(e1) {
        if (!this.isEnabled()) return;
        if (this._shouldBePrevented(e1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e1);
        let t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY, i = $785da19a645c07eb$var$aC(), n = i - (this._lastWheelEventTime || 0);
        this._lastWheelEventTime = i, 0 !== t && t % $785da19a645c07eb$var$BR == 0 ? this._type = "wheel" : 0 !== t && Math.abs(t) < 4 ? this._type = "trackpad" : n > 400 ? (this._type = null, this._lastValue = t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(n * t) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, t += this._lastValue)), e1.shiftKey && t && (t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= t, this._active || this._start(e1)), e1.preventDefault();
    }
    _start(e1) {
        if (!this._delta) return;
        this._needsRerender = !1, this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
        let t = $785da19a645c07eb$var$rC.mousePos(this._map.getCanvas(), e1), i = this._tr;
        this._aroundPoint = this._aroundCenter ? i.transform.locationToScreenPoint($785da19a645c07eb$var$Mx.convert(i.center)) : t, this._needsRerender || (this._needsRerender = !0, this._triggerRenderFrame());
    }
    renderFrame() {
        if (!this._needsRerender || (this._needsRerender = !1, !this.isActive())) return;
        let e1 = this._tr.transform;
        if ("number" == typeof this._lastExpectedZoom) {
            let t = e1.zoom - this._lastExpectedZoom;
            "number" == typeof this._startZoom && (this._startZoom += t), "number" == typeof this._targetZoom && (this._targetZoom += t);
        }
        if (0 !== this._delta) {
            let t = "wheel" === this._type && Math.abs(this._delta) > $785da19a645c07eb$var$BR ? this._wheelZoomRate : this._defaultZoomRate, i = 2 / (1 + Math.exp(-Math.abs(this._delta * t)));
            this._delta < 0 && 0 !== i && (i = 1 / i);
            let n = "number" == typeof this._targetZoom ? $785da19a645c07eb$var$gh(this._targetZoom) : e1.scale, a = e1.applyConstrain(e1.getCameraLngLat(), $785da19a645c07eb$var$fh(n * i)).zoom, r = this._map.getZoomSnap();
            if ("wheel" === this._type && r > 0) {
                let t = $785da19a645c07eb$var$Ah(e1.zoom, r);
                this._targetZoom = $785da19a645c07eb$var$Ah(a, r, a - t);
            } else this._targetZoom = a;
            "wheel" === this._type && (this._startZoom = e1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
        }
        let t, i = "number" == typeof this._targetZoom ? this._targetZoom : e1.zoom, n = this._startZoom, a = this._easing, r = !1;
        if ("wheel" === this._type && n && a) {
            let e1 = $785da19a645c07eb$var$aC() - this._lastWheelEventTime, s = Math.min((e1 + 5) / 200, 1), o = a(s);
            t = $785da19a645c07eb$var$Mp.number(n, i, o), s < 1 ? this._needsRerender = !0 : r = !0;
        } else t = i, r = !0;
        return this._active = !0, r && (this._active = !1, this._finishTimeout = setTimeout(()=>{
            this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
        }, 200)), this._lastExpectedZoom = t, {
            noInertia: !0,
            needsRenderFrame: !r,
            zoomDelta: t - e1.zoom,
            around: this._aroundPoint,
            originalEvent: this._lastWheelEvent
        };
    }
    _smoothOutEasing(e1) {
        let t = $785da19a645c07eb$var$lh;
        if (this._prevEase) {
            let e1 = this._prevEase, i = ($785da19a645c07eb$var$aC() - e1.start) / e1.duration, n = e1.easing(i + .01) - e1.easing(i), a = .27 / Math.sqrt(n * n + 1e-4) * .01;
            t = $785da19a645c07eb$var$oh(a, Math.sqrt(.0729 - a * a), .25, 1);
        }
        return this._prevEase = {
            start: $785da19a645c07eb$var$aC(),
            duration: e1,
            easing: t
        }, t;
    }
    reset() {
        this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
    }
}, $785da19a645c07eb$var$UR = class {
    constructor(e1, t){
        this._clickZoom = e1, this._tapZoom = t;
    }
    enable() {
        this._clickZoom.enable(), this._tapZoom.enable();
    }
    disable() {
        this._clickZoom.disable(), this._tapZoom.disable();
    }
    isEnabled() {
        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
    }
    isActive() {
        return this._clickZoom.isActive() || this._tapZoom.isActive();
    }
}, $785da19a645c07eb$var$NR = class {
    constructor(e1, t){
        this._tr = t, this.reset();
    }
    reset() {
        this._active = !1;
    }
    dblclick(e1, t) {
        return e1.preventDefault(), {
            cameraAnimation: (i)=>{
                i.easeTo({
                    duration: 300,
                    zoom: $785da19a645c07eb$var$Ah(this._tr.zoom + (e1.shiftKey ? -1 : 1), i.getZoomSnap()),
                    around: this._tr.unproject(t)
                }, {
                    originalEvent: e1
                });
            }
        };
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $785da19a645c07eb$var$jR = class {
    constructor(){
        this._tap = new $785da19a645c07eb$var$AR({
            numTouches: 1,
            numTaps: 1
        }), this._zoomRate = 1, this.reset();
    }
    setZoomRate(e1) {
        this._zoomRate = e1 ?? 1;
    }
    reset() {
        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
    }
    touchstart(e1, t, i) {
        if (!this._swipePoint) {
            if (this._tapTime) {
                let n = t[0], a = e1.timeStamp - this._tapTime < 500, r = this._tapPoint.dist(n) < 30;
                a && r ? i.length > 0 && (this._swipePoint = n, this._swipeTouch = i[0].identifier) : this.reset();
            } else this._tap.touchstart(e1, t, i);
        }
    }
    touchmove(e1, t, i) {
        if (this._tapTime) {
            if (this._swipePoint) {
                if (i[0].identifier !== this._swipeTouch) return;
                let n = t[0], a = n.y - this._swipePoint.y;
                return this._swipePoint = n, e1.preventDefault(), this._active = !0, {
                    zoomDelta: a / 128 * this._zoomRate
                };
            }
        } else this._tap.touchmove(e1, t, i);
    }
    touchend(e1, t, i) {
        if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
        else {
            let n = this._tap.touchend(e1, t, i);
            n && (this._tapTime = e1.timeStamp, this._tapPoint = n);
        }
    }
    touchcancel() {
        this.reset();
    }
    enable() {
        this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this.reset();
    }
    isEnabled() {
        return this._enabled;
    }
    isActive() {
        return this._active;
    }
}, $785da19a645c07eb$var$VR = class {
    constructor(e1, t, i){
        this._el = e1, this._mousePan = t, this._touchPan = i;
    }
    enable(e1) {
        this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
    }
    disable() {
        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
    }
    isEnabled() {
        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
    }
    isActive() {
        return this._mousePan.isActive() || this._touchPan.isActive();
    }
}, $785da19a645c07eb$var$qR = class {
    constructor(e1, t, i, n){
        this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = i, this._mouseRoll = n;
    }
    enable() {
        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
    }
    disable() {
        this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
    }
    isEnabled() {
        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
    }
    isActive() {
        return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
    }
}, $785da19a645c07eb$var$GR = class {
    constructor(e1, t, i, n){
        this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = n, this._rotationDisabled = !1, this._enabled = !0;
    }
    enable(e1) {
        this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
    }
    disable() {
        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
    }
    isEnabled() {
        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
    }
    isActive() {
        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
    }
    setZoomRate(e1) {
        this._touchZoom.setZoomRate(e1), this._tapDragZoom.setZoomRate(e1);
    }
    setZoomThreshold(e1) {
        this._touchZoom.setZoomThreshold(e1);
    }
    disableRotation() {
        this._rotationDisabled = !0, this._touchRotate.disable();
    }
    enableRotation() {
        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
    }
}, $785da19a645c07eb$var$HR = class {
    constructor(e1, t){
        this._bypassKey = navigator.userAgent.includes("Mac") ? "metaKey" : "ctrlKey", this._map = e1, this._options = t, this._enabled = !1;
    }
    isActive() {
        return !1;
    }
    reset() {}
    _setupUI() {
        if (this._container) return;
        let e1 = this._map.getCanvasContainer();
        e1.classList.add("maplibregl-cooperative-gestures"), this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-cooperative-gesture-screen", e1);
        let t = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
        "metaKey" === this._bypassKey && (t = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
        let i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), n = document.createElement("div");
        n.className = "maplibregl-desktop-message", n.textContent = t, this._container.appendChild(n);
        let a = document.createElement("div");
        a.className = "maplibregl-mobile-message", a.textContent = i, this._container.appendChild(a), this._container.setAttribute("aria-hidden", "true");
    }
    _destroyUI() {
        this._container && (this._container.remove(), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
    }
    enable() {
        this._setupUI(), this._enabled = !0;
    }
    disable() {
        this._enabled = !1, this._destroyUI();
    }
    isEnabled() {
        return this._enabled;
    }
    isBypassed(e1) {
        return e1[this._bypassKey];
    }
    notifyGestureBlocked(e1, t) {
        this._enabled && (this._map.fire(new $785da19a645c07eb$var$lC("cooperativegestureprevented", {
            gestureType: e1,
            originalEvent: t
        })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
            this._container.classList.remove("maplibregl-show");
        }, 100));
    }
}, $785da19a645c07eb$var$WR = class {
    constructor(e1){
        this._camera = e1;
    }
    get transform() {
        return this._camera._requestedCameraState || this._camera.transform;
    }
    get center() {
        return {
            lng: this.transform.center.lng,
            lat: this.transform.center.lat
        };
    }
    get zoom() {
        return this.transform.zoom;
    }
    get pitch() {
        return this.transform.pitch;
    }
    get bearing() {
        return this.transform.bearing;
    }
    unproject(e1) {
        return this.transform.screenPointToLocation($785da19a645c07eb$var$Kc.convert(e1), this._camera.terrain);
    }
};
const $785da19a645c07eb$var$ZR = (e1)=>e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
var $785da19a645c07eb$var$KR = class extends $785da19a645c07eb$var$nd {
};
function $785da19a645c07eb$var$XR(e1) {
    return e1.panDelta?.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
}
var $785da19a645c07eb$var$QR = class {
    get _ownerDocument() {
        return this._el?.ownerDocument || document;
    }
    get _ownerWindow() {
        return this._el?.ownerDocument?.defaultView || window;
    }
    constructor(e1, t, i){
        this._terrainGestureAnchorElevation = null, this.handleWindowEvent = (e1)=>{
            this.handleEvent(e1, `${e1.type}Window`);
        }, this.handleEvent = (e1, t)=>{
            if ("blur" === e1.type) return void this.stop(!0);
            this._updatingCamera = !0;
            let i = "renderFrame" === e1.type ? void 0 : e1, n = {
                needsRenderFrame: !1
            }, a = {}, r = {};
            for (let { handlerName: s, handler: o, allowed: l } of this._handlers){
                if (!o.isEnabled()) continue;
                let c;
                if (this._blockedByActive(r, l, s)) o.reset();
                else if (o[t || e1.type]) {
                    if ($785da19a645c07eb$var$Uh(e1, t || e1.type)) {
                        let i = $785da19a645c07eb$var$rC.mousePos(this._map.getCanvas(), e1);
                        c = o[t || e1.type](e1, i);
                    } else if ($785da19a645c07eb$var$Oh(e1, t || e1.type)) {
                        let i = e1.touches, n = this._getMapTouches(i), a = $785da19a645c07eb$var$rC.touchPos(this._map.getCanvas(), n);
                        c = o[t || e1.type](e1, a, n);
                    } else $785da19a645c07eb$var$Nh(t || e1.type) || (c = o[t || e1.type](e1));
                    this.mergeHandlerResult(n, a, c, s, i), c?.needsRenderFrame && this._triggerRenderFrame();
                }
                (c || o.isActive()) && (r[s] = o);
            }
            let s = {};
            for(let e1 in this._previousActiveHandlers)r[e1] || (s[e1] = i);
            this._previousActiveHandlers = r, (Object.keys(s).length || $785da19a645c07eb$var$XR(n)) && (this._changes.push([
                n,
                a,
                s
            ]), this._triggerRenderFrame()), (Object.keys(r).length || $785da19a645c07eb$var$XR(n)) && this._camera.stop(!0), this._updatingCamera = !1;
            let { cameraAnimation: o } = n;
            o && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], o(this._map));
        }, this._map = e1, this._camera = t, this._transformProvider = new $785da19a645c07eb$var$WR(this._camera), this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new $785da19a645c07eb$var$cR(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i);
        let n = this._el;
        this._listeners = [
            [
                n,
                "touchstart",
                {
                    passive: !0
                }
            ],
            [
                n,
                "touchmove",
                {
                    passive: !1
                }
            ],
            [
                n,
                "touchend",
                void 0
            ],
            [
                n,
                "touchcancel",
                void 0
            ],
            [
                n,
                "mousedown",
                void 0
            ],
            [
                n,
                "mousemove",
                void 0
            ],
            [
                n,
                "mouseup",
                void 0
            ],
            [
                this._ownerDocument,
                "mousemove",
                {
                    capture: !0
                }
            ],
            [
                this._ownerDocument,
                "mouseup",
                void 0
            ],
            [
                n,
                "mouseover",
                void 0
            ],
            [
                n,
                "mouseout",
                void 0
            ],
            [
                n,
                "dblclick",
                void 0
            ],
            [
                n,
                "click",
                void 0
            ],
            [
                n,
                "keydown",
                {
                    capture: !1
                }
            ],
            [
                n,
                "keyup",
                void 0
            ],
            [
                n,
                "wheel",
                {
                    passive: !1
                }
            ],
            [
                n,
                "contextmenu",
                void 0
            ],
            [
                this._ownerWindow,
                "blur",
                void 0
            ]
        ];
        for (let [e1, t, i] of this._listeners)e1.addEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, i);
    }
    destroy() {
        for (let [e1, t, i] of this._listeners)e1.removeEventListener(t, e1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, i);
    }
    _addDefaultHandlers(e1) {
        let t = this._map, i = t.getCanvasContainer();
        this._add("mapEvent", new $785da19a645c07eb$var$dR(t, e1));
        let n = t.boxZoom = new $785da19a645c07eb$var$mR(t, e1, this._transformProvider);
        this._add("boxZoom", n), e1.interactive && e1.boxZoom && n.enable();
        let a = t.cooperativeGestures = new $785da19a645c07eb$var$HR(t, e1.cooperativeGestures);
        this._add("cooperativeGestures", a), e1.cooperativeGestures && a.enable();
        let r = new $785da19a645c07eb$var$_R(t, this._transformProvider), s = new $785da19a645c07eb$var$NR(t, this._transformProvider);
        t.doubleClickZoom = new $785da19a645c07eb$var$UR(s, r), this._add("tapZoom", r), this._add("clickZoom", s), e1.interactive && e1.doubleClickZoom && t.doubleClickZoom.enable();
        let o = new $785da19a645c07eb$var$jR;
        this._add("tapDragZoom", o);
        let l = t.touchPitch = new $785da19a645c07eb$var$FR(t);
        this._add("touchPitch", l), e1.interactive && e1.touchPitch && t.touchPitch.enable(e1.touchPitch);
        let c = ()=>t.project(t.getCenter()), u = function({ enable: e1, clickTolerance: t, aroundCenter: i = !0, minPixelCenterThreshold: n = 100, rotateSpeed: a = .8 }, r) {
            return new $785da19a645c07eb$var$vR({
                clickTolerance: t,
                move: (e1, t)=>{
                    let s = r();
                    if (i && Math.abs(s.y - e1.y) > n) return {
                        bearingDelta: $785da19a645c07eb$var$Fh(new $785da19a645c07eb$var$Kc(e1.x, t.y), t, s)
                    };
                    let o = (t.x - e1.x) * a;
                    return i && t.y < s.y && (o = -o), {
                        bearingDelta: o
                    };
                },
                moveStateManager: new $785da19a645c07eb$var$xR({
                    checkCorrectEvent: (e1)=>0 === e1.button && e1.ctrlKey || 2 === e1.button && !e1.ctrlKey
                }),
                enable: e1,
                assignEvents: $785da19a645c07eb$var$ER
            });
        }(e1, c), h = function({ enable: e1, clickTolerance: t, pitchSpeed: i = -0.5 }) {
            return new $785da19a645c07eb$var$vR({
                clickTolerance: t,
                move: (e1, t)=>({
                        pitchDelta: (t.y - e1.y) * i
                    }),
                moveStateManager: new $785da19a645c07eb$var$xR({
                    checkCorrectEvent: (e1)=>0 === e1.button && e1.ctrlKey || 2 === e1.button
                }),
                enable: e1,
                assignEvents: $785da19a645c07eb$var$ER
            });
        }(e1), d = function({ enable: e1, clickTolerance: t, rollDegreesPerPixelMoved: i = .3 }, n) {
            return new $785da19a645c07eb$var$vR({
                clickTolerance: t,
                move: (e1, t)=>{
                    let a = n(), r = (t.x - e1.x) * i;
                    return t.y < a.y && (r = -r), {
                        rollDelta: r
                    };
                },
                moveStateManager: new $785da19a645c07eb$var$xR({
                    checkCorrectEvent: (e1)=>2 === e1.button && e1.ctrlKey
                }),
                enable: e1,
                assignEvents: $785da19a645c07eb$var$ER
            });
        }(e1, c);
        t.dragRotate = new $785da19a645c07eb$var$qR(e1, u, h, d), this._add("mouseRotate", u, [
            "mousePitch"
        ]), this._add("mousePitch", h, [
            "mouseRotate",
            "mouseRoll"
        ]), this._add("mouseRoll", d, [
            "mousePitch"
        ]), e1.interactive && e1.dragRotate && t.dragRotate.enable();
        let p = function({ enable: e1, clickTolerance: t }) {
            return new $785da19a645c07eb$var$vR({
                clickTolerance: t,
                move: (e1, t)=>({
                        around: t,
                        panDelta: t.sub(e1)
                    }),
                activateOnStart: !0,
                moveStateManager: new $785da19a645c07eb$var$xR({
                    checkCorrectEvent: (e1)=>0 === e1.button && !e1.ctrlKey
                }),
                enable: e1,
                assignEvents: $785da19a645c07eb$var$ER
            });
        }(e1), m = new $785da19a645c07eb$var$kR(e1, t);
        t.dragPan = new $785da19a645c07eb$var$VR(i, p, m), this._add("mousePan", p), this._add("touchPan", m, [
            "touchZoom",
            "touchRotate"
        ]), e1.interactive && e1.dragPan && t.dragPan.enable(e1.dragPan);
        let g = new $785da19a645c07eb$var$PR, f = new $785da19a645c07eb$var$TR;
        t.touchZoomRotate = new $785da19a645c07eb$var$GR(i, f, g, o), this._add("touchRotate", g, [
            "touchPan",
            "touchZoom"
        ]), this._add("touchZoom", f, [
            "touchPan",
            "touchRotate"
        ]), e1.interactive && e1.touchZoomRotate && t.touchZoomRotate.enable(e1.touchZoomRotate), this._add("blockableMapEvent", new $785da19a645c07eb$var$pR(t));
        let A = t.scrollZoom = new $785da19a645c07eb$var$OR(t, ()=>this._triggerRenderFrame(), this._transformProvider);
        this._add("scrollZoom", A, [
            "mousePan"
        ]), e1.interactive && e1.scrollZoom && t.scrollZoom.enable(e1.scrollZoom);
        let _ = t.keyboard = new $785da19a645c07eb$var$RR(t, this._transformProvider);
        this._add("keyboard", _), e1.interactive && e1.keyboard && t.keyboard.enable();
    }
    _add(e1, t, i) {
        this._handlers.push({
            handlerName: e1,
            handler: t,
            allowed: i
        }), this._handlersById[e1] = t;
    }
    stop(e1) {
        if (!this._updatingCamera) {
            for (let { handler: e1 } of this._handlers)e1.reset();
            this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
        }
    }
    isActive() {
        for (let { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
        return !1;
    }
    isZooming() {
        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
    }
    isRotating() {
        return !!this._eventsInProgress.rotate;
    }
    isMoving() {
        return !!$785da19a645c07eb$var$ZR(this._eventsInProgress) || this.isZooming();
    }
    _blockedByActive(e1, t, i) {
        for(let n in e1)if (n !== i && !t?.includes(n)) return !0;
        return !1;
    }
    _getMapTouches(e1) {
        let t = [];
        for (let i of e1){
            let e1 = i.target;
            this._el.contains(e1) && t.push(i);
        }
        return t;
    }
    mergeHandlerResult(e1, t, i, n, a) {
        if (!i) return;
        $785da19a645c07eb$var$hh(e1, i);
        let r = {
            handlerName: n,
            originalEvent: i.originalEvent || a
        };
        void 0 !== i.zoomDelta && (t.zoom = r), void 0 !== i.panDelta && (t.drag = r), void 0 !== i.rollDelta && (t.roll = r), void 0 !== i.pitchDelta && (t.pitch = r), void 0 !== i.bearingDelta && (t.rotate = r);
    }
    _applyChanges() {
        let e1 = {}, t = {}, i = {};
        for (let [n, a, r] of this._changes)n.panDelta && (e1.panDelta = (e1.panDelta || new $785da19a645c07eb$var$Kc(0, 0))._add(n.panDelta)), n.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + n.zoomDelta), n.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + n.bearingDelta), n.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + n.pitchDelta), n.rollDelta && (e1.rollDelta = (e1.rollDelta || 0) + n.rollDelta), void 0 !== n.around && (e1.around = n.around), void 0 !== n.pinchAround && (e1.pinchAround = n.pinchAround), n.noInertia && (e1.noInertia = n.noInertia), $785da19a645c07eb$var$hh(t, a), $785da19a645c07eb$var$hh(i, r);
        this._updateMapTransform(e1, t, i), this._changes = [];
    }
    _updateMapTransform(e1, t, i) {
        let n = this._map, a = this._camera.getTransformForUpdate(), r = n.terrain;
        if (!($785da19a645c07eb$var$XR(e1) || r && this._terrainMovement)) return void this._fireEvents(t, i, !0);
        this._camera.stop(!0);
        let { panDelta: s, zoomDelta: o, bearingDelta: l, pitchDelta: c, rollDelta: u } = e1, { around: h, aroundOnSurface: d } = this._resolveAround(e1, r, a), p = r ? this._terrainGestureElevation(r, h, d, a, t) : void 0, m = {
            panDelta: s,
            zoomDelta: o,
            rollDelta: u,
            pitchDelta: c,
            bearingDelta: l,
            around: h,
            aroundElevation: p
        };
        this._camera.cameraHelper.useGlobeControls && !a.isPointOnMapSurface(h) && (h = a.centerPoint);
        let g = this._computePreZoomAroundLoc(a, h, s, p);
        this._handleMapControls({
            terrain: r,
            tr: a,
            deltasForHelper: m,
            preZoomAroundLoc: g,
            combinedEventsInProgress: t,
            panDelta: s
        }), this._camera.applyUpdatedTransform(a), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
    }
    _resolveAround(e1, t, i) {
        let n = void 0 === e1.pinchAround ? e1.around : e1.pinchAround;
        return n ||= this._camera.transform.centerPoint, t && !i.isPointOnMapSurface(n) ? {
            around: i.centerPoint,
            aroundOnSurface: !1
        } : {
            around: n,
            aroundOnSurface: !0
        };
    }
    _terrainGestureElevation(e1, t, i, n, a) {
        if (!i) return;
        if (!this._terrainMovement && (a.drag || a.zoom)) {
            let i = n.screenTerrainPointToMercatorCoordinate(t, e1);
            this._terrainGestureAnchorElevation = i ? i.z : null;
        }
        if (null === this._terrainGestureAnchorElevation) return;
        let r = this._terrainGestureAnchorElevation;
        return t.distSqr(n.centerPoint) < .01 || r - n.elevation >= .9 * (n.getCameraAltitude() - n.elevation) ? void 0 : r;
    }
    _computePreZoomAroundLoc(e1, t, i, n) {
        if (t.distSqr(e1.centerPoint) < .01) return e1.center;
        let a = i ? t.sub(i) : t;
        return void 0 === n ? e1.screenPointToLocation(a) : e1.screenPointToLocationAtElevation(a, n);
    }
    _handleMapControls({ terrain: e1, tr: t, deltasForHelper: i, preZoomAroundLoc: n, combinedEventsInProgress: a, panDelta: r }) {
        let s = this._camera.cameraHelper;
        if (s.handleMapControlsRollPitchBearingZoom(i, t), e1) return s.useGlobeControls ? (!this._terrainMovement && (a.drag || a.zoom) && (this._terrainMovement = !0, this._camera.elevationFreeze = !0), void s.handleMapControlsPan(i, t, n)) : this._terrainMovement || !a.drag && !a.zoom ? void (void 0 === i.aroundElevation && a.drag && this._terrainMovement && r ? t.setCenter(t.screenPointToLocation(t.centerPoint.sub(r))) : s.handleMapControlsPan(i, t, n)) : (this._terrainMovement = !0, this._camera.elevationFreeze = !0, void s.handleMapControlsPan(i, t, n));
        s.handleMapControlsPan(i, t, n);
    }
    _fireEvents(e1, t, i) {
        let n = $785da19a645c07eb$var$ZR(this._eventsInProgress), a = $785da19a645c07eb$var$ZR(e1), r = {};
        for(let t in e1){
            let { originalEvent: i } = e1[t];
            this._eventsInProgress[t] || (r[`${t}start`] = i), this._eventsInProgress[t] = e1[t];
        }
        !n && a && this._fireEvent("movestart", a.originalEvent);
        for(let e1 in r)this._fireEvent(e1, r[e1]);
        a && this._fireEvent("move", a.originalEvent);
        for(let t in e1){
            let { originalEvent: i } = e1[t];
            this._fireEvent(t, i);
        }
        let s, o = {};
        for(let e1 in this._eventsInProgress){
            let { handlerName: i, originalEvent: n } = this._eventsInProgress[e1];
            this._handlersById[i].isActive() || (delete this._eventsInProgress[e1], s = t[i] || n, o[`${e1}end`] = s);
        }
        for(let e1 in o)this._fireEvent(e1, o[e1]);
        let l = $785da19a645c07eb$var$ZR(this._eventsInProgress), c = (n || a) && !l;
        if (c && this._terrainMovement) {
            this._camera.elevationFreeze = !1, this._terrainMovement = !1, this._terrainGestureAnchorElevation = null;
            let e1 = this._camera.getTransformForUpdate();
            this._map.getCenterClampedToGround() && e1.recalculateZoomAndCenter(this._map.terrain), this._camera.applyUpdatedTransform(e1);
        }
        if (i && c) {
            this._updatingCamera = !0;
            let e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
            !e1 || !e1.essential && $785da19a645c07eb$var$iC.prefersReducedMotion ? (this._map.fire(new $785da19a645c07eb$var$cC("moveend", {
                originalEvent: s
            })), t(this._map.getBearing()) && this._map.resetNorth()) : (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), e1.freezeElevation = !0, this._map.easeTo(e1, {
                originalEvent: s
            })), this._updatingCamera = !1;
        }
    }
    _fireEvent(e1, t) {
        this._map.fire(new $785da19a645c07eb$var$cC(e1, t ? {
            originalEvent: t
        } : {}));
    }
    _requestFrame() {
        return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
            delete this._frameId, this.handleEvent(new $785da19a645c07eb$var$KR("renderFrame", {
                timeStamp: e1
            })), this._applyChanges();
        });
    }
    _triggerRenderFrame() {
        void 0 === this._frameId && (this._frameId = this._requestFrame());
    }
}, $785da19a645c07eb$var$YR = class extends $785da19a645c07eb$var$rd {
    constructor(e1){
        super(), this._renderFrameCallback = ()=>{
            let e1 = Math.min(($785da19a645c07eb$var$aC() - this._easeStart) / this._easeOptions.duration, 1);
            this._onEaseFrame(this._easeOptions.easing(e1)), e1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
        }, this.transform = new $785da19a645c07eb$var$OP, this.cameraHelper = new $785da19a645c07eb$var$GP, void 0 !== e1.minZoom && this.transform.setMinZoom(e1.minZoom), void 0 !== e1.maxZoom && this.transform.setMaxZoom(e1.maxZoom), void 0 !== e1.minPitch && this.transform.setMinPitch(e1.minPitch), void 0 !== e1.maxPitch && this.transform.setMaxPitch(e1.maxPitch), void 0 !== e1.renderWorldCopies && this.transform.setRenderWorldCopies(e1.renderWorldCopies), null !== e1.transformConstrain && this.transform.setConstrainOverride(e1.transformConstrain), this._moving = !1, this._zooming = !1, this._bearingSnap = e1.bearingSnap, this._zoomSnap = e1.zoomSnap, this._requestRenderFrame = e1.requestRenderFrame, this._cancelRenderFrame = e1.cancelRenderFrame, this.terrain = e1.terrain, this._centerClampedToGround = e1.centerClampedToGround ?? !0, this.transformCameraUpdate = e1.transformCameraUpdate ?? null, this._stopHandlers = e1.stopHandlers ?? (()=>{}), this.on("moveend", ()=>{
            delete this._requestedCameraState;
        });
    }
    migrateProjection(e1, t) {
        if (e1.apply(this.transform, !0), this.transform = e1, this.cameraHelper = t, this._requestedCameraState) {
            let t = e1.clone();
            t.apply(this._requestedCameraState, !0), this._requestedCameraState = t;
        }
    }
    getCenter() {
        return new $785da19a645c07eb$var$Mx(this.transform.center.lng, this.transform.center.lat);
    }
    setCenter(e1, t) {
        return this.jumpTo({
            center: e1
        }, t);
    }
    getCenterElevation() {
        return this.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this.jumpTo({
            elevation: e1
        }, t), this;
    }
    getCenterClampedToGround() {
        return this._centerClampedToGround;
    }
    setCenterClampedToGround(e1) {
        this._centerClampedToGround = e1;
    }
    panBy(e1, t, i) {
        return e1 = $785da19a645c07eb$var$Kc.convert(e1).mult(-1), this.panTo(this.transform.center, $785da19a645c07eb$var$hh({
            offset: e1
        }, t), i);
    }
    panTo(e1, t, i) {
        return this.easeTo($785da19a645c07eb$var$hh({
            center: e1
        }, t), i);
    }
    getZoom() {
        return this.transform.zoom;
    }
    setZoom(e1, t) {
        return this.jumpTo({
            zoom: e1
        }, t), this;
    }
    zoomTo(e1, t, i) {
        return this.easeTo($785da19a645c07eb$var$hh({
            zoom: e1
        }, t), i);
    }
    zoomIn(e1, t) {
        return this.zoomTo($785da19a645c07eb$var$Ah(this.getZoom() + 1, this._zoomSnap), e1, t), this;
    }
    zoomOut(e1, t) {
        return this.zoomTo($785da19a645c07eb$var$Ah(this.getZoom() - 1, this._zoomSnap), e1, t), this;
    }
    getVerticalFieldOfView() {
        return this.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new $785da19a645c07eb$var$cC("movestart", t)).fire(new $785da19a645c07eb$var$cC("move", t)).fire(new $785da19a645c07eb$var$cC("moveend", t))), this;
    }
    getBearing() {
        return this.transform.bearing;
    }
    setZoomSnap(e1) {
        return this._zoomSnap = e1, this;
    }
    getZoomSnap() {
        return this._zoomSnap;
    }
    setBearing(e1, t) {
        return this.jumpTo({
            bearing: e1
        }, t), this;
    }
    getPadding() {
        return this.transform.padding;
    }
    setPadding(e1, t) {
        return this.jumpTo({
            padding: e1
        }, t), this;
    }
    rotateTo(e1, t, i) {
        return this.easeTo($785da19a645c07eb$var$hh({
            bearing: e1
        }, t), i);
    }
    resetNorth(e1, t) {
        return this.rotateTo(0, $785da19a645c07eb$var$hh({
            duration: 1e3
        }, e1), t), this;
    }
    resetNorthPitch(e1, t) {
        return this.easeTo($785da19a645c07eb$var$hh({
            bearing: 0,
            pitch: 0,
            roll: 0,
            duration: 1e3
        }, e1), t), this;
    }
    snapToNorth(e1, t) {
        return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
    }
    getPitch() {
        return this.transform.pitch;
    }
    setPitch(e1, t) {
        return this.jumpTo({
            pitch: e1
        }, t), this;
    }
    getRoll() {
        return this.transform.roll;
    }
    setRoll(e1, t) {
        return this.jumpTo({
            roll: e1
        }, t), this;
    }
    cameraForBounds(e1, t) {
        e1 = $785da19a645c07eb$var$_T.convert(e1).adjustAntiMeridian();
        let i = t?.bearing || 0;
        return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), i, t);
    }
    _cameraForBoxAndBearing(e1, t, i, n) {
        let a = {
            top: 0,
            bottom: 0,
            right: 0,
            left: 0
        };
        if ("number" == typeof (n = $785da19a645c07eb$var$hh({
            padding: a,
            offset: [
                0,
                0
            ],
            maxZoom: this.transform.maxZoom
        }, n)).padding) {
            let e1 = n.padding;
            n.padding = {
                top: e1,
                bottom: e1,
                right: e1,
                left: e1
            };
        }
        let r = $785da19a645c07eb$var$hh(a, n.padding);
        n.padding = r;
        let s = this.transform, o = new $785da19a645c07eb$var$_T(e1, t), l = this.cameraHelper.cameraForBoxAndBearing(n, r, o, i, s);
        return l && this._zoomSnap && (l.zoom = $785da19a645c07eb$var$Ah(l.zoom, this._zoomSnap, -1)), l;
    }
    fitBounds(e1, t, i) {
        return this._fitInternal(this.cameraForBounds(e1, t), t, i);
    }
    fitScreenCoordinates(e1, t, i, n, a) {
        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation($785da19a645c07eb$var$Kc.convert(e1)), this.transform.screenPointToLocation($785da19a645c07eb$var$Kc.convert(t)), i, n), n, a);
    }
    _fitInternal(e1, t, i) {
        return e1 ? (delete (t = $785da19a645c07eb$var$hh(e1, t)).padding, t.linear ? this.easeTo(t, i) : this.flyTo(t, i)) : this;
    }
    jumpTo(e1, t) {
        this.stop(), void 0 !== e1.zoom && this._zoomSnap && (e1.zoom = $785da19a645c07eb$var$Ah(e1.zoom, this._zoomSnap));
        let i = this.getTransformForUpdate(), n = !1, a = !1, r = !1, s = i.zoom;
        this.terrain && i.setElevation(this.terrain.getElevationForLngLat(e1.center ? $785da19a645c07eb$var$Mx.convert(e1.center) : i.center, i)), this.cameraHelper.handleJumpToCenterZoom(i, e1);
        let o = i.zoom !== s;
        return void 0 !== e1.elevation && i.elevation !== +e1.elevation && i.setElevation(+e1.elevation), void 0 !== e1.bearing && i.bearing !== +e1.bearing && (n = !0, i.setBearing(+e1.bearing)), void 0 !== e1.pitch && i.pitch !== +e1.pitch && (a = !0, i.setPitch(+e1.pitch)), void 0 !== e1.roll && i.roll !== +e1.roll && (r = !0, i.setRoll(+e1.roll)), null != e1.padding && !i.isPaddingEqual(e1.padding) && i.setPadding(e1.padding), this.applyUpdatedTransform(i), this.fire(new $785da19a645c07eb$var$cC("movestart", t)).fire(new $785da19a645c07eb$var$cC("move", t)), o && this.fire(new $785da19a645c07eb$var$cC("zoomstart", t)).fire(new $785da19a645c07eb$var$cC("zoom", t)).fire(new $785da19a645c07eb$var$cC("zoomend", t)), n && this.fire(new $785da19a645c07eb$var$cC("rotatestart", t)).fire(new $785da19a645c07eb$var$cC("rotate", t)).fire(new $785da19a645c07eb$var$cC("rotateend", t)), a && this.fire(new $785da19a645c07eb$var$cC("pitchstart", t)).fire(new $785da19a645c07eb$var$cC("pitch", t)).fire(new $785da19a645c07eb$var$cC("pitchend", t)), r && this.fire(new $785da19a645c07eb$var$cC("rollstart", t)).fire(new $785da19a645c07eb$var$cC("roll", t)).fire(new $785da19a645c07eb$var$cC("rollend", t)), this.fire(new $785da19a645c07eb$var$cC("moveend", t));
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, n, a) {
        let r = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, i, n);
        return {
            center: r.center,
            elevation: r.elevation,
            zoom: r.zoom,
            bearing: i,
            pitch: n,
            roll: a
        };
    }
    easeTo(e1, t) {
        this._stop(!1, e1.easeId), void 0 !== (e1 = $785da19a645c07eb$var$hh({
            offset: [
                0,
                0
            ],
            duration: 500,
            easing: $785da19a645c07eb$var$lh
        }, e1)).zoom && this._zoomSnap && (e1.zoom = $785da19a645c07eb$var$Ah(e1.zoom, this._zoomSnap)), (!1 === e1.animate || !e1.essential && $785da19a645c07eb$var$iC.prefersReducedMotion) && (e1.duration = 0);
        let i, n, a = this.getTransformForUpdate(), r = this.getBearing(), s = a.pitch, o = a.roll, l = void 0 === e1.bearing ? r : this._normalizeBearing(e1.bearing, r), c = void 0 === e1.pitch ? s : +e1.pitch, u = void 0 === e1.roll ? o : this._normalizeBearing(e1.roll, o), h = void 0 === e1.padding ? a.padding : e1.padding, d = $785da19a645c07eb$var$Kc.convert(e1.offset);
        e1.around && (i = $785da19a645c07eb$var$Mx.convert(e1.around), n = a.locationToScreenPoint(i));
        let p = {
            moving: this._moving,
            zooming: this._zooming,
            rotating: this._rotating,
            pitching: this._pitching,
            rolling: this._rolling
        }, m = this.cameraHelper.handleEaseTo(a, {
            bearing: l,
            pitch: c,
            roll: u,
            padding: h,
            around: i,
            aroundPoint: n,
            offsetAsPoint: d,
            offset: e1.offset,
            zoom: e1.zoom,
            center: e1.center
        });
        return this._rotating ||= r !== l, this._pitching ||= c !== s, this._rolling ||= u !== o, this._padding = !a.isPaddingEqual(h), this._zooming ||= m.isZooming, this._easeId = e1.easeId, this._prepareEase(t, e1.noMoveStart, p), this.terrain && this._prepareElevation(m.elevationCenter), this._ease((i)=>{
            m.easeFunc(i), this.terrain && !e1.freezeElevation && this._updateElevation(i), this.applyUpdatedTransform(a), this._fireMoveEvents(t);
        }, (i)=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(t, i);
        }, e1), this;
    }
    _prepareEase(e1, t, i = {}) {
        this._moving = !0, !t && !i.moving && this.fire(new $785da19a645c07eb$var$cC("movestart", e1)), this._zooming && !i.zooming && this.fire(new $785da19a645c07eb$var$cC("zoomstart", e1)), this._rotating && !i.rotating && this.fire(new $785da19a645c07eb$var$cC("rotatestart", e1)), this._pitching && !i.pitching && this.fire(new $785da19a645c07eb$var$cC("pitchstart", e1)), this._rolling && !i.rolling && this.fire(new $785da19a645c07eb$var$cC("rollstart", e1));
    }
    _prepareElevation(e1) {
        this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLat(e1, this.transform), this.elevationFreeze = !0;
    }
    _updateElevation(e1) {
        (void 0 === this._elevationStart || void 0 === this._elevationCenter) && this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
        let t = this.terrain.getElevationForLngLat(this._elevationCenter, this.transform);
        if (e1 < 1 && t !== this._elevationTarget) {
            let i = this._elevationTarget - this._elevationStart, n = (t - (i * e1 + this._elevationStart)) / (1 - e1);
            this._elevationStart += e1 * (i - n), this._elevationTarget = t;
        }
        this.transform.setElevation($785da19a645c07eb$var$Mp.number(this._elevationStart, this._elevationTarget, e1));
    }
    _finalizeElevation() {
        this.elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
    }
    getTransformForUpdate() {
        return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState ||= this.transform.clone(), this._requestedCameraState) : this.transform;
    }
    _elevateCameraIfInsideTerrain(e1) {
        if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
        let t = e1.getCameraLngLat(), i = e1.getCameraAltitude(), n = this.terrain ? this.terrain.getElevationForLngLatZoom(t, e1.zoom) : 0;
        if (i < n) {
            let i = e1.calculateCameraOptionsFromTo(t, n, e1.center, e1.elevation);
            return {
                pitch: i.pitch,
                zoom: i.zoom
            };
        }
        return {};
    }
    applyUpdatedTransform(e1) {
        let t = [];
        if (t.push((e1)=>this._elevateCameraIfInsideTerrain(e1)), this.transformCameraUpdate && t.push((e1)=>this.transformCameraUpdate(e1)), !t.length) return;
        let i = e1.clone();
        for (let e1 of t){
            let t = i.clone(), { center: n, zoom: a, roll: r, pitch: s, bearing: o, elevation: l } = e1(t);
            n && t.setCenter(n), void 0 !== l && t.setElevation(l), void 0 !== a && t.setZoom(a), void 0 !== r && t.setRoll(r), void 0 !== s && t.setPitch(s), void 0 !== o && t.setBearing(o), i.apply(t, !1);
        }
        this.transform.apply(i, !1);
    }
    _fireMoveEvents(e1) {
        this.fire(new $785da19a645c07eb$var$cC("move", e1)), this._zooming && this.fire(new $785da19a645c07eb$var$cC("zoom", e1)), this._rotating && this.fire(new $785da19a645c07eb$var$cC("rotate", e1)), this._pitching && this.fire(new $785da19a645c07eb$var$cC("pitch", e1)), this._rolling && this.fire(new $785da19a645c07eb$var$cC("roll", e1));
    }
    _afterEase(e1, t) {
        if (this._easeId && t && this._easeId === t) return;
        delete this._easeId;
        let i = this._zooming, n = this._rotating, a = this._pitching, r = this._rolling;
        this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, i && this.fire(new $785da19a645c07eb$var$cC("zoomend", e1)), n && this.fire(new $785da19a645c07eb$var$cC("rotateend", e1)), a && this.fire(new $785da19a645c07eb$var$cC("pitchend", e1)), r && this.fire(new $785da19a645c07eb$var$cC("rollend", e1)), this.fire(new $785da19a645c07eb$var$cC("moveend", e1));
    }
    flyTo(e1, t) {
        if (!e1.essential && $785da19a645c07eb$var$iC.prefersReducedMotion) {
            let i = $785da19a645c07eb$var$dh(e1, [
                "center",
                "zoom",
                "bearing",
                "pitch",
                "roll",
                "elevation",
                "padding"
            ]);
            return this.jumpTo(i, t);
        }
        this.stop(), void 0 !== (e1 = $785da19a645c07eb$var$hh({
            offset: [
                0,
                0
            ],
            speed: 1.2,
            curve: 1.42,
            easing: $785da19a645c07eb$var$lh
        }, e1)).zoom && this._zoomSnap && (e1.zoom = $785da19a645c07eb$var$Ah(e1.zoom, this._zoomSnap));
        let i = this.getTransformForUpdate(), n = i.bearing, a = i.pitch, r = i.roll, s = i.padding, o = void 0 === e1.bearing ? n : this._normalizeBearing(e1.bearing, n), l = void 0 === e1.pitch ? a : +e1.pitch, c = void 0 === e1.roll ? r : this._normalizeBearing(e1.roll, r), u = void 0 === e1.padding ? i.padding : e1.padding, h = $785da19a645c07eb$var$Kc.convert(e1.offset), d = i.centerPoint.add(h), p = i.screenPointToLocation(d), m = this.cameraHelper.handleFlyTo(i, {
            bearing: o,
            pitch: l,
            roll: c,
            padding: u,
            locationAtOffset: p,
            offsetAsPoint: h,
            center: e1.center,
            minZoom: e1.minZoom,
            zoom: e1.zoom
        }), g = e1.curve, f = Math.max(i.width, i.height), A = f / m.scaleOfZoom, _ = m.pixelPathLength, v = f / m.scaleOfMinZoom;
        g = Math.min(g, Math.sqrt(v / _ * 2));
        let y = g * g;
        function x(e1) {
            let t = (A * A - f * f + (e1 ? -1 : 1) * y * y * _ * _) / (2 * (e1 ? A : f) * y * _);
            return Math.log(Math.sqrt(t * t + 1) - t);
        }
        function b(e1) {
            return (Math.exp(e1) - Math.exp(-e1)) / 2;
        }
        function w(e1) {
            return (Math.exp(e1) + Math.exp(-e1)) / 2;
        }
        let E = x(!1), k = function(e1) {
            return w(E) / w(E + g * e1);
        }, S = function(e1) {
            return f * ((w(E) * function(e1) {
                return b(e1) / w(e1);
            }(E + g * e1) - b(E)) / y) / _;
        }, M = (x(!0) - E) / g;
        if (Math.abs(_) < 2e-6 || !isFinite(M)) {
            if (Math.abs(f - A) < 1e-6) return this.easeTo(e1, t);
            let i = A < f ? -1 : 1;
            M = Math.abs(Math.log(A / f)) / g, S = ()=>0, k = (e1)=>Math.exp(i * g * e1);
        }
        if (void 0 !== e1.duration) e1.duration = +e1.duration;
        else {
            let t = void 0 === e1.screenSpeed ? +e1.speed : +e1.screenSpeed / g;
            e1.duration = 1e3 * M / t;
        }
        return e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = n !== o, this._pitching = l !== a, this._rolling = c !== r, this._padding = !i.isPaddingEqual(u), this._prepareEase(t, !1), this.terrain && this._prepareElevation(m.targetCenter), this._ease((p)=>{
            let g = p * M, f = 1 / k(g), A = S(g);
            this._rotating && i.setBearing($785da19a645c07eb$var$Mp.number(n, o, p)), this._pitching && i.setPitch($785da19a645c07eb$var$Mp.number(a, l, p)), this._rolling && i.setRoll($785da19a645c07eb$var$Mp.number(r, c, p)), this._padding && (i.interpolatePadding(s, u, p), d = i.centerPoint.add(h)), m.easeFunc(p, f, A, d), this.terrain && !e1.freezeElevation && this._updateElevation(p), this.applyUpdatedTransform(i), this._fireMoveEvents(t);
        }, ()=>{
            this.terrain && e1.freezeElevation && this._finalizeElevation(), this._afterEase(t);
        }, e1), this;
    }
    isEasing() {
        return !!this._easeFrameId;
    }
    stop(e1) {
        return this._stop(e1);
    }
    _stop(e1, t) {
        if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
            let e1 = this._onEaseEnd;
            delete this._onEaseEnd, e1.call(this, t);
        }
        return e1 || this._stopHandlers(), this;
    }
    _ease(e1, t, i) {
        !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = $785da19a645c07eb$var$aC(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
    }
    _normalizeBearing(e1, t) {
        e1 = $785da19a645c07eb$var$uh(e1, -180, 180);
        let i = Math.abs(e1 - t);
        return Math.abs(e1 - 360 - t) < i && (e1 -= 360), Math.abs(e1 + 360 - t) < i && (e1 += 360), e1;
    }
    isMoving() {
        return this._moving;
    }
    isZooming() {
        return this._zooming;
    }
    isRotating() {
        return this._rotating;
    }
};
const $785da19a645c07eb$var$JR = {
    compact: !0,
    customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
};
var $785da19a645c07eb$var$$R = class {
    constructor(e1 = $785da19a645c07eb$var$JR){
        this._toggleAttribution = ()=>{
            this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
        }, this._updateData = (e1)=>{
            e1 && ("terrain" === e1.type || "style" === e1.dataType || "source" === e1.dataType && ("metadata" === e1.sourceDataType || "visibility" === e1.sourceDataType)) && this._updateAttributions();
        }, this._updateCompact = ()=>{
            this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : !this._container.classList.contains("maplibregl-compact") && !this._container.classList.contains("maplibregl-attrib-empty") && (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
        }, this._updateCompactMinimize = ()=>{
            this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
        }, this.options = e1;
    }
    getDefaultPosition() {
        return "bottom-right";
    }
    onAdd(e1) {
        return this._map = e1, this._compact = this.options.compact, this._container = $785da19a645c07eb$var$rC.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = $785da19a645c07eb$var$rC.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = $785da19a645c07eb$var$rC.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
    }
    _setElementTitle(e1, t) {
        let i = this._map._getUIString(`AttributionControl.${t}`);
        e1.title = i, e1.setAttribute("aria-label", i);
    }
    _updateAttributions() {
        if (!this._map.style) return;
        let e1 = [];
        if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = e1.concat(this.options.customAttribution.map((e1)=>"string" == typeof e1 ? e1 : "")) : "string" == typeof this.options.customAttribution && e1.push(this.options.customAttribution)), this._map.style.stylesheet) {
            let e1 = this._map.style.stylesheet;
            this.styleOwner = e1.owner, this.styleId = e1.id;
        }
        let t = this._map.style.tileManagers;
        for(let i in t){
            let n = t[i];
            if (n.used || n.usedForTerrain) {
                let t = n.getSource();
                t.attribution && !e1.includes(t.attribution) && e1.push(t.attribution);
            }
        }
        e1 = e1.filter((e1)=>String(e1).trim()), e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, i)=>{
            for(let n = i + 1; n < e1.length; n++)if (e1[n].includes(t)) return !1;
            return !0;
        });
        let i = e1.join(" | ");
        i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = $785da19a645c07eb$var$rC.sanitize(i), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
    }
}, $785da19a645c07eb$var$eL = class {
    constructor(e1 = {}){
        this._updateCompact = ()=>{
            let e1 = this._container.children;
            if (e1.length) {
                let t = e1[0];
                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && t.classList.add("maplibregl-compact") : t.classList.remove("maplibregl-compact");
            }
        }, this.options = e1;
    }
    getDefaultPosition() {
        return "bottom-left";
    }
    onAdd(e1) {
        this._map = e1, this._compact = this.options?.compact, this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-ctrl");
        let t = $785da19a645c07eb$var$rC.create("a", "maplibregl-ctrl-logo");
        return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://maplibre.org/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
    }
}, $785da19a645c07eb$var$tL = class {
    constructor(){
        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
    }
    add(e1) {
        let t = ++this._id;
        return this._queue.push({
            callback: e1,
            id: t,
            cancelled: !1
        }), t;
    }
    remove(e1) {
        let t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
        for (let t of i)if (t.id === e1) return void (t.cancelled = !0);
    }
    run(e1 = 0) {
        if (this._currentlyRunning) throw Error("Attempting to run(), but is already running.");
        let t = this._currentlyRunning = this._queue;
        this._queue = [];
        let i, n = !1;
        for (let a of t)if (!a.cancelled) {
            try {
                a.callback(e1);
            } catch (e1) {
                n || (n = !0, i = e1);
            }
            if (this._cleared) break;
        }
        if (this._cleared = !1, this._currentlyRunning = !1, n) throw i;
    }
    clear() {
        this._currentlyRunning && (this._cleared = !0), this._queue = [];
    }
};
const $785da19a645c07eb$var$iL = [
    "none",
    "zoom",
    "sourceTiles",
    "visibleLayers",
    "revision"
];
var $785da19a645c07eb$var$nL = class {
    constructor(e1, t, i, n){
        this._tileKeys = e1.map((e1)=>e1.key).sort().join(), this._revision = t, this._zoom = i, this._visibleLayerIds = n;
    }
    difference(e1) {
        return this._revision === e1?._revision ? this._visibleLayerIds === e1._visibleLayerIds ? this._tileKeys === e1._tileKeys ? this._zoom === e1._zoom ? "none" : "zoom" : "sourceTiles" : "visibleLayers" : "revision";
    }
};
const $785da19a645c07eb$var$aL = {
    background: !0,
    fill: !0,
    line: !0,
    raster: !0,
    hillshade: !0,
    "color-relief": !0
};
var $785da19a645c07eb$var$rL = class {
    constructor(e1, t){
        this.needsFollowUpFrame = !1, this.painter = e1, this.terrain = t, this.rttSize = t.tileManager.tileSize * t.qualityFactor;
    }
    getTexture(e1) {
        return e1.getRTT(this._stacks.length - 1).texture;
    }
    prepareForRender(e1, t) {
        let i = t !== this._lastPrepareZoom;
        this._lastPrepareZoom = t, this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter((i)=>!e1._layers[i].isHidden(t));
        let n = this._renderableLayerIds.join(), a = new Set;
        for (let t of this._renderableLayerIds){
            let i = e1._layers[t], n = i.source;
            n && $785da19a645c07eb$var$aL[i.type] && a.add(n);
        }
        this._coordsAscending = {}, this._rttFingerprints = {};
        for (let i of a){
            let a = e1.tileManagers[i];
            if (!a) continue;
            this._coordsAscending[i] = {};
            let r = this._coordsAscending[i], s = a.getSource(), o = s instanceof $785da19a645c07eb$var$UT ? s.terrainTileRanges : null;
            for (let e1 of a.getVisibleCoordinates()){
                let t = this.terrain.tileManager.getTerrainCoords(e1, o);
                for(let e1 in t)r[e1] ||= [], r[e1].push(t[e1]);
            }
            this._rttFingerprints[i] = {};
            let l = this._rttFingerprints[i], c = a.getState().revision;
            for(let e1 in r)l[e1] = new $785da19a645c07eb$var$nL(r[e1], c, t, n);
        }
        this.needsFollowUpFrame = !1;
        let r = i || this.painter.options.moving, s = !1;
        for (let e1 of this._renderableTiles){
            let t = this._textureDifference(e1);
            "none" !== t && ("zoom" === t && r || "visibleLayers" === t && i ? this.needsFollowUpFrame = !0 : "zoom" === t || "sourceTiles" === t ? (s ? this.needsFollowUpFrame = !0 : e1.releaseRTT(this.painter), s = !0) : e1.releaseRTT(this.painter));
        }
    }
    _textureDifference(e1) {
        let t = "none";
        for(let i in this._rttFingerprints){
            let n = this._rttFingerprints[i][e1.tileID.key];
            if (!n) continue;
            let a = n.difference(e1.rttFingerprint[i]);
            $785da19a645c07eb$var$iL.indexOf(a) > $785da19a645c07eb$var$iL.indexOf(t) && (t = a);
        }
        return t;
    }
    renderLayer(e1, t) {
        if (e1.isHidden(this.painter.transform.zoom)) return !1;
        let i = {
            ...t,
            isRenderingToTexture: !0
        }, n = e1.type, a = this.painter, r = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
        if ($785da19a645c07eb$var$aL[n] && ((!this._prevType || !$785da19a645c07eb$var$aL[this._prevType]) && this._stacks.push([]), this._prevType = n, this._stacks[this._stacks.length - 1].push(e1.id), !r)) return !0;
        if ($785da19a645c07eb$var$aL[this._prevType] || $785da19a645c07eb$var$aL[n] && r) {
            this._prevType = n;
            let e1 = this._stacks.length - 1, t = this._stacks[e1] || [];
            for (let n of this._renderableTiles){
                if (this._rttTiles.push(n), n.getRTT(e1)) continue;
                let r = n.acquireRTT(a, e1, this.rttSize);
                a.bindRTT(r), a.context.clear({
                    color: $785da19a645c07eb$var$np.transparent,
                    stencil: 0
                }), a.currentStencilSource = void 0;
                for (let e1 of t){
                    let t = a.style._layers[e1], r = t.source ? this._coordsAscending[t.source][n.tileID.key] : [
                        n.tileID
                    ];
                    a.context.viewport.set([
                        0,
                        0,
                        this.rttSize,
                        this.rttSize
                    ]), a.renderTileClippingMasks(t, r, !0), a.renderLayer(a, a.style.tileManagers[t.source], t, r, i), t.source && (n.rttFingerprint[t.source] = this._rttFingerprints[t.source][n.tileID.key]);
                }
                r.texture.generateMipmap();
            }
            return function(e1, t, i, n) {
                let { isRenderingGlobe: a } = n, r = e1.context, s = r.gl, o = e1.transform, l = e1.colorModeForRenderPass(), c = e1.getDepthModeFor3D(), u = e1.useProgram("terrain");
                r.bindFramebuffer.set(null), r.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]);
                for (let n of i){
                    let i = t.getTerrainMesh(n.tileID), h = e1.renderToTexture.getTexture(n), d = t.getTerrainData(n.tileID);
                    r.activeTexture.set(s.TEXTURE0), h.bind(s.LINEAR, s.CLAMP_TO_EDGE, s.LINEAR_MIPMAP_LINEAR);
                    let p = t.getSkirtLength(o.zoom), m = o.calculateFogMatrix(n.tileID.toUnwrapped()), g = $785da19a645c07eb$var$SI(p, m, e1.style.sky, o.pitch, a), f = o.getProjectionData({
                        overscaledTileID: n.tileID,
                        applyTerrainMatrix: !1,
                        applyGlobeMatrix: !0
                    });
                    u.draw(r, s.TRIANGLES, c, $785da19a645c07eb$var$rz.disabled, l, $785da19a645c07eb$var$oz.backCCW, g, d, f, "terrain", i.vertexBuffer, i.indexBuffer, i.segments);
                }
            }(this.painter, this.terrain, this._rttTiles, i), this._rttTiles = [], $785da19a645c07eb$var$aL[n];
        }
        return !1;
    }
};
const $785da19a645c07eb$var$sL = {
    "AttributionControl.ToggleAttribution": "Toggle attribution",
    "AttributionControl.MapFeedback": "Map feedback",
    "FullscreenControl.Enter": "Enter fullscreen",
    "FullscreenControl.Exit": "Exit fullscreen",
    "GeolocateControl.FindMyLocation": "Find my location",
    "GeolocateControl.LocationNotAvailable": "Location not available",
    "LogoControl.Title": "MapLibre logo",
    "Map.Title": "Map",
    "Marker.Title": "Map marker",
    "NavigationControl.ResetBearing": "Drag to rotate map, click to reset north",
    "NavigationControl.ZoomIn": "Zoom in",
    "NavigationControl.ZoomOut": "Zoom out",
    "Popup.Close": "Close popup",
    "ScaleControl.Feet": "ft",
    "ScaleControl.Meters": "m",
    "ScaleControl.Kilometers": "km",
    "ScaleControl.Miles": "mi",
    "ScaleControl.NauticalMiles": "nm",
    "GlobeControl.Enable": "Enable globe",
    "GlobeControl.Disable": "Disable globe",
    "TerrainControl.Enable": "Enable terrain",
    "TerrainControl.Disable": "Disable terrain",
    "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
    "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
    "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
}, $785da19a645c07eb$var$oL = {
    hash: !1,
    interactive: !0,
    bearingSnap: 7,
    zoomSnap: 0,
    attributionControl: $785da19a645c07eb$var$JR,
    maplibreLogo: !1,
    refreshExpiredTiles: !0,
    canvasContextAttributes: {
        antialias: !1,
        preserveDrawingBuffer: !1,
        powerPreference: "high-performance",
        failIfMajorPerformanceCaveat: !1,
        desynchronized: !1,
        contextType: void 0
    },
    scrollZoom: !0,
    minZoom: -2,
    maxZoom: 22,
    minPitch: 0,
    maxPitch: 60,
    boxZoom: !0,
    dragRotate: !0,
    dragPan: !0,
    keyboard: !0,
    doubleClickZoom: !0,
    touchZoomRotate: !0,
    touchPitch: !0,
    cooperativeGestures: !1,
    trackResize: !0,
    center: [
        0,
        0
    ],
    elevation: 0,
    zoom: 0,
    bearing: 0,
    pitch: 0,
    roll: 0,
    renderWorldCopies: !0,
    maxTileCacheSize: null,
    maxTileCacheZoomLevels: $785da19a645c07eb$var$Hh.MAX_TILE_CACHE_ZOOM_LEVELS,
    transformRequest: null,
    transformCameraUpdate: null,
    transformConstrain: null,
    fadeDuration: 300,
    crossSourceCollisions: !0,
    clickTolerance: 3,
    localIdeographFontFamily: "sans-serif",
    pitchWithRotate: !0,
    rollEnabled: !1,
    rotateSpeed: .8,
    pitchSpeed: -0.5,
    reduceMotion: void 0,
    validateStyle: !0,
    maxCanvasSize: [
        4096,
        4096
    ],
    cancelPendingTileRequestsWhileZooming: !0,
    centerClampedToGround: !0,
    terrainSkirtLength: "auto",
    zoomLevelsToOverscale: 4,
    anisotropicFilterPitch: 20
};
var $785da19a645c07eb$var$lL = class extends $785da19a645c07eb$var$rd {
    get _ownerWindow() {
        return this._container?.ownerDocument?.defaultView || window;
    }
    constructor(e1){
        super(), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new $785da19a645c07eb$var$tL, this._controls = [], this._mapId = $785da19a645c07eb$var$mh(), this._styleUrl = null, this._missingStyleImageResolver = null, this._lostContextStyle = {
            style: null,
            images: null
        }, this._contextLost = (e1)=>{
            if (e1.preventDefault(), this._frameRequest &&= (this._frameRequest.abort(), null), this.painter.destroy(), this._lostContextStyle = this._getStyleAndImages(), this.style) {
                for (let e1 of Object.values(this.style._layers))if ("custom" === e1.type && console.warn(`Custom layer with id '${e1.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), e1._listeners) for (let [t] of Object.entries(e1._listeners))console.warn(`Custom layer with id '${e1.id}' had event listeners for event '${t}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
                this.style.destroy(), this.style = null, this.fire(new $785da19a645c07eb$var$vC("webglcontextlost", {
                    originalEvent: e1
                }));
            } else this.fire(new $785da19a645c07eb$var$vC("webglcontextlost", {
                originalEvent: e1
            }));
        }, this._contextRestored = (e1)=>{
            if (this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                diff: !1
            }), this._lostContextStyle.images && this.style) {
                this.style.imageManager.images = this._lostContextStyle.images;
                for(let e1 in this._lostContextStyle.images){
                    let t = this._lostContextStyle.images[e1];
                    t.isWebGLImage && this.style.imageManager.updateImage(e1, t, !1);
                }
            }
            this._lostContextStyle = {
                style: null,
                images: null
            };
            try {
                this._setupPainter();
            } catch (e1) {
                return void this.fire(new $785da19a645c07eb$var$ad(e1));
            }
            this.resize(), this._update(), this._resizeInternal(), this.fire(new $785da19a645c07eb$var$vC("webglcontextrestored", {
                originalEvent: e1
            }));
        }, this._onMapScroll = (e1)=>{
            if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
        }, this._onWindowOnline = ()=>{
            this._update();
        };
        let t = {
            ...$785da19a645c07eb$var$oL,
            ...e1,
            canvasContextAttributes: {
                ...$785da19a645c07eb$var$oL.canvasContextAttributes,
                ...e1.canvasContextAttributes
            }
        };
        if (null != t.minZoom && null != t.maxZoom && t.minZoom > t.maxZoom) throw Error("maxZoom must be greater than or equal to minZoom");
        if (null != t.minPitch && null != t.maxPitch && t.minPitch > t.maxPitch) throw Error("maxPitch must be greater than or equal to minPitch");
        if (null != t.minPitch && t.minPitch < 0) throw Error("minPitch must be greater than or equal to 0");
        if (null != t.maxPitch && t.maxPitch > 180) throw Error("maxPitch must be less than or equal to 180");
        this._camera = new $785da19a645c07eb$var$YR({
            minZoom: t.minZoom,
            maxZoom: t.maxZoom,
            minPitch: t.minPitch,
            maxPitch: t.maxPitch,
            bearingSnap: t.bearingSnap,
            zoomSnap: t.zoomSnap,
            renderWorldCopies: t.renderWorldCopies,
            centerClampedToGround: t.centerClampedToGround,
            terrain: this.terrain,
            transformConstrain: t.transformConstrain,
            requestRenderFrame: (e1)=>this._requestRenderFrame(e1),
            cancelRenderFrame: (e1)=>this._cancelRenderFrame(e1),
            transformCameraUpdate: t.transformCameraUpdate,
            stopHandlers: ()=>this._handlers?.stop(!1)
        }), this._camera.setEventedParent(this), this._interactive = t.interactive, this._maxTileCacheSize = t.maxTileCacheSize, this._maxTileCacheZoomLevels = t.maxTileCacheZoomLevels, this._canvasContextAttributes = {
            ...t.canvasContextAttributes
        }, this._trackResize = !0 === t.trackResize, this._terrainSkirtLength = t.terrainSkirtLength, this._refreshExpiredTiles = !0 === t.refreshExpiredTiles, this._fadeDuration = t.fadeDuration, this._crossSourceCollisions = !0 === t.crossSourceCollisions, this._collectResourceTiming = !0 === t.collectResourceTiming, this._locale = {
            ...$785da19a645c07eb$var$sL,
            ...t.locale
        }, this._clickTolerance = t.clickTolerance, this._overridePixelRatio = t.pixelRatio, this._maxCanvasSize = t.maxCanvasSize, this._zoomLevelsToOverscale = t.zoomLevelsToOverscale, this.cancelPendingTileRequestsWhileZooming = !0 === t.cancelPendingTileRequestsWhileZooming, this.setAnisotropicFilterPitch(t.anisotropicFilterPitch), void 0 !== t.reduceMotion && ($785da19a645c07eb$var$iC.prefersReducedMotion = t.reduceMotion), this._requestManager = new $785da19a645c07eb$var$oC(t.transformRequest), this._container = this._resolveContainer(t.container), t.maxBounds && this.setMaxBounds(t.maxBounds), this._setupContainer();
        try {
            this._setupPainter();
        } catch (e1) {
            throw this._cleanupContainer(), e1;
        }
        this._imageQueueHandle = $785da19a645c07eb$var$sC.addThrottleControl(()=>this.isMoving()), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
            this.painter.terrainFacilitator.depthDirty = !0, this._update(!0);
        }), this.once("idle", ()=>this._idleTriggered = !0), this._handlers = new $785da19a645c07eb$var$QR(this, this._camera, t), typeof window < "u" && (this._ownerWindow.addEventListener("online", this._onWindowOnline, !1), this._setupResizeObserver());
        let i = "string" == typeof t.hash && t.hash || void 0;
        this._hash = t.hash ? new $785da19a645c07eb$var$iR(i).addTo(this) : void 0, this._hash?._onHashChange() || (this.jumpTo({
            center: t.center,
            elevation: t.elevation,
            zoom: t.zoom,
            bearing: t.bearing,
            pitch: t.pitch,
            roll: t.roll
        }), t.bounds && (this.resize(), this.fitBounds(t.bounds, $785da19a645c07eb$var$hh({}, t.fitBoundsOptions, {
            duration: 0
        }))));
        let n = "string" == typeof t.style || "globe" !== t.style?.projection?.type;
        this.resize(null, n), this._localIdeographFontFamily = t.localIdeographFontFamily, this._validateStyle = t.validateStyle, t.style && this.setStyle(t.style, {
            localIdeographFontFamily: t.localIdeographFontFamily
        }), t.attributionControl && this.addControl(new $785da19a645c07eb$var$$R("boolean" == typeof t.attributionControl ? void 0 : t.attributionControl)), t.maplibreLogo && this.addControl(new $785da19a645c07eb$var$eL, t.logoPosition), this.on("style.load", ()=>{
            if (n || this._resizeTransform(), this._camera.transform.unmodified) {
                let e1 = $785da19a645c07eb$var$dh(this.style.stylesheet, [
                    "center",
                    "zoom",
                    "bearing",
                    "pitch",
                    "roll"
                ]);
                this.jumpTo(e1);
            }
        }), this.on("data", (e1)=>{
            this._update("style" === e1.dataType), this.fire("style" === e1.dataType ? new $785da19a645c07eb$var$hC("styledata", e1) : new $785da19a645c07eb$var$dC("sourcedata", e1));
        }), this.on("dataloading", (e1)=>{
            this.fire("style" === e1.dataType ? new $785da19a645c07eb$var$hC("styledataloading", e1) : new $785da19a645c07eb$var$dC("sourcedataloading", e1));
        }), this.on("dataabort", (e1)=>{
            this.fire(new $785da19a645c07eb$var$dC("sourcedataabort", e1));
        });
    }
    _getMapId() {
        return this._mapId;
    }
    setGlobalStateProperty(e1, t) {
        return this.style.setGlobalStateProperty(e1, t), this._update(!0);
    }
    getGlobalState() {
        return this.style.getGlobalState();
    }
    addControl(e1, t) {
        if (void 0 === t && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1?.onAdd) return this.fire(new $785da19a645c07eb$var$ad(Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
        let i = e1.onAdd(this);
        this._controls.push(e1);
        let n = this._controlPositions[t];
        return t.includes("bottom") ? n.insertBefore(i, n.firstChild) : n.appendChild(i), this;
    }
    removeControl(e1) {
        if (!e1?.onRemove) return this.fire(new $785da19a645c07eb$var$ad(Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
        let t = this._controls.indexOf(e1);
        return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
    }
    hasControl(e1) {
        return this._controls.includes(e1);
    }
    coveringTiles(e1) {
        return $785da19a645c07eb$var$rD(this._camera.transform, e1);
    }
    setTransformCameraUpdate(e1) {
        this._camera.transformCameraUpdate = e1;
    }
    getCenter() {
        return new $785da19a645c07eb$var$Mx(this._camera.transform.center.lng, this._camera.transform.center.lat);
    }
    setCenter(e1, t) {
        return this._camera.setCenter(e1, t), this;
    }
    getCenterElevation() {
        return this._camera.transform.elevation;
    }
    setCenterElevation(e1, t) {
        return this._camera.setCenterElevation(e1, t), this;
    }
    setCenterClampedToGround(e1) {
        this._camera.setCenterClampedToGround(e1);
    }
    panBy(e1, t, i) {
        return this._camera.panBy(e1, t, i), this;
    }
    panTo(e1, t, i) {
        return this._camera.panTo(e1, t, i), this;
    }
    getZoom() {
        return this._camera.transform.zoom;
    }
    setZoom(e1, t) {
        return this._camera.setZoom(e1, t), this;
    }
    zoomTo(e1, t, i) {
        return this._camera.zoomTo(e1, t, i), this;
    }
    zoomIn(e1, t) {
        return this._camera.zoomIn(e1, t), this;
    }
    zoomOut(e1, t) {
        return this._camera.zoomOut(e1, t), this;
    }
    getVerticalFieldOfView() {
        return this._camera.transform.fov;
    }
    setVerticalFieldOfView(e1, t) {
        return this._camera.setVerticalFieldOfView(e1, t), this;
    }
    getBearing() {
        return this._camera.transform.bearing;
    }
    setBearing(e1, t) {
        return this._camera.setBearing(e1, t), this;
    }
    getZoomSnap() {
        return this._camera.getZoomSnap();
    }
    setZoomSnap(e1) {
        return this._camera.setZoomSnap(e1), this;
    }
    getPadding() {
        return this._camera.transform.padding;
    }
    setPadding(e1, t) {
        return this._camera.setPadding(e1, t), this;
    }
    rotateTo(e1, t, i) {
        return this._camera.rotateTo(e1, t, i), this;
    }
    resetNorth(e1, t) {
        return this._camera.resetNorth(e1, t), this;
    }
    resetNorthPitch(e1, t) {
        return this._camera.resetNorthPitch(e1, t), this;
    }
    snapToNorth(e1, t) {
        return this._camera.snapToNorth(e1, t), this;
    }
    getPitch() {
        return this._camera.transform.pitch;
    }
    setPitch(e1, t) {
        return this._camera.setPitch(e1, t), this;
    }
    getRoll() {
        return this._camera.transform.roll;
    }
    setRoll(e1, t) {
        return this._camera.setRoll(e1, t), this;
    }
    cameraForBounds(e1, t) {
        return this._camera.cameraForBounds(e1, t);
    }
    fitBounds(e1, t, i) {
        return this._camera.fitBounds(e1, t, i), this;
    }
    fitScreenCoordinates(e1, t, i, n, a) {
        return this._camera.fitScreenCoordinates(e1, t, i, n, a), this;
    }
    jumpTo(e1, t) {
        return this._camera.jumpTo(e1, t), this;
    }
    calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, n, a) {
        return this._camera.calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, n, a);
    }
    easeTo(e1, t) {
        return this._camera.easeTo(e1, t), this;
    }
    flyTo(e1, t) {
        return this._camera.flyTo(e1, t), this;
    }
    stop() {
        return this._camera.stop(), this;
    }
    queryTerrainElevation(e1) {
        return this.terrain ? this.terrain.getElevationForLngLat($785da19a645c07eb$var$Mx.convert(e1), this._camera.transform) : null;
    }
    getCenterClampedToGround() {
        return this._camera.getCenterClampedToGround();
    }
    calculateCameraOptionsFromTo(e1, t, i, n) {
        return null == n && this.terrain && (n = this.terrain.getElevationForLngLat(i, this._camera.transform)), this._camera.transform.calculateCameraOptionsFromTo(e1, t, i, n ?? 0);
    }
    resize(e1, t = !0) {
        if (null !== this._lostContextStyle.style) return this;
        this._resizeInternal(t);
        let i = !this._camera._moving;
        return i && (this.stop(), this.fire(new $785da19a645c07eb$var$cC("movestart", e1)).fire(new $785da19a645c07eb$var$cC("move", e1))), this.fire(new $785da19a645c07eb$var$lC("resize", e1)), i && this.fire(new $785da19a645c07eb$var$cC("moveend", e1)), this;
    }
    _resizeInternal(e1 = !0) {
        let [t, i] = this._containerDimensions(), n = this._getClampedPixelRatio(t, i);
        if (this._resizeCanvas(t, i, n), this.painter.resize(t, i, n), this.painter.overLimit()) {
            let e1 = this.painter.context.gl;
            this._maxCanvasSize = [
                e1.drawingBufferWidth,
                e1.drawingBufferHeight
            ];
            let n = this._getClampedPixelRatio(t, i);
            this._resizeCanvas(t, i, n), this.painter.resize(t, i, n);
        }
        this._resizeTransform(e1);
    }
    _resizeTransform(e1 = !0) {
        let [t, i] = this._containerDimensions();
        this._camera.transform.resize(t, i, e1), this._camera._requestedCameraState?.resize(t, i, e1);
    }
    _getClampedPixelRatio(e1, t) {
        let { 0: i, 1: n } = this._maxCanvasSize, a = this.getPixelRatio(), r = e1 * a, s = t * a, o = r > i ? i / r : 1, l = s > n ? n / s : 1, c = Math.min(o, l);
        return c < 1 && $785da19a645c07eb$var$wh("The canvas is larger than maxCanvasSize and is rendered at a lower pixel ratio to fit. Increase maxCanvasSize, within MAX_TEXTURE_SIZE, to render at full resolution."), c * a;
    }
    getPixelRatio() {
        return this._overridePixelRatio ?? devicePixelRatio;
    }
    setPixelRatio(e1) {
        this._overridePixelRatio = e1, this.resize();
    }
    getBounds() {
        return this._camera.transform.getBounds();
    }
    getMaxBounds() {
        return this._camera.transform.getMaxBounds();
    }
    setMaxBounds(e1) {
        return this._camera.transform.setMaxBounds($785da19a645c07eb$var$_T.convert(e1)), this._update();
    }
    setMinZoom(e1) {
        if (e1 ??= -2, e1 >= -2 && e1 <= this._camera.transform.maxZoom) {
            let t = this._camera.transform.zoom, i = this._camera.getTransformForUpdate();
            return i.setMinZoom(e1), this._camera.applyUpdatedTransform(i), this._update(), t !== this._camera.transform.zoom && this.fire(new $785da19a645c07eb$var$cC("zoomstart")).fire(new $785da19a645c07eb$var$cC("zoom")).fire(new $785da19a645c07eb$var$cC("zoomend")).fire(new $785da19a645c07eb$var$cC("movestart")).fire(new $785da19a645c07eb$var$cC("move")).fire(new $785da19a645c07eb$var$cC("moveend")), this;
        }
        throw Error("minZoom must be between -2 and the current maxZoom, inclusive");
    }
    getMinZoom(e1 = !1) {
        let t = this._camera.transform;
        return e1 ? t.applyConstrain(t.center, t.minZoom).zoom : t.minZoom;
    }
    setMaxZoom(e1) {
        if (e1 ??= 22, e1 >= this._camera.transform.minZoom) {
            let t = this._camera.transform.zoom, i = this._camera.getTransformForUpdate();
            return i.setMaxZoom(e1), this._camera.applyUpdatedTransform(i), this._update(), t !== this._camera.transform.zoom && this.fire(new $785da19a645c07eb$var$cC("zoomstart")).fire(new $785da19a645c07eb$var$cC("zoom")).fire(new $785da19a645c07eb$var$cC("zoomend")).fire(new $785da19a645c07eb$var$cC("movestart")).fire(new $785da19a645c07eb$var$cC("move")).fire(new $785da19a645c07eb$var$cC("moveend")), this;
        }
        throw Error("maxZoom must be greater than the current minZoom");
    }
    getMaxZoom() {
        return this._camera.transform.maxZoom;
    }
    setMinPitch(e1) {
        if (e1 ??= 0, e1 < 0) throw Error("minPitch must be greater than or equal to 0");
        if (e1 >= 0 && e1 <= this._camera.transform.maxPitch) {
            let t = this._camera.transform.pitch, i = this._camera.getTransformForUpdate();
            return i.setMinPitch(e1), this._camera.applyUpdatedTransform(i), this._update(), t !== this._camera.transform.pitch && this.fire(new $785da19a645c07eb$var$cC("pitchstart")).fire(new $785da19a645c07eb$var$cC("pitch")).fire(new $785da19a645c07eb$var$cC("pitchend")).fire(new $785da19a645c07eb$var$cC("movestart")).fire(new $785da19a645c07eb$var$cC("move")).fire(new $785da19a645c07eb$var$cC("moveend")), this;
        }
        throw Error("minPitch must be between 0 and the current maxPitch, inclusive");
    }
    getMinPitch() {
        return this._camera.transform.minPitch;
    }
    setMaxPitch(e1) {
        if (e1 ??= 60, e1 > 180) throw Error("maxPitch must be less than or equal to 180");
        if (e1 >= this._camera.transform.minPitch) {
            let t = this._camera.transform.pitch, i = this._camera.getTransformForUpdate();
            return i.setMaxPitch(e1), this._camera.applyUpdatedTransform(i), this._update(), t !== this._camera.transform.pitch && this.fire(new $785da19a645c07eb$var$cC("pitchstart")).fire(new $785da19a645c07eb$var$cC("pitch")).fire(new $785da19a645c07eb$var$cC("pitchend")).fire(new $785da19a645c07eb$var$cC("movestart")).fire(new $785da19a645c07eb$var$cC("move")).fire(new $785da19a645c07eb$var$cC("moveend")), this;
        }
        throw Error("maxPitch must be greater than the current minPitch");
    }
    getMaxPitch() {
        return this._camera.transform.maxPitch;
    }
    getAnisotropicFilterPitch() {
        return this._anisotropicFilterPitch;
    }
    setAnisotropicFilterPitch(e1) {
        if (e1 ??= 20, e1 > 180) throw Error("anisotropicFilterPitch must be less than or equal to 180");
        if (e1 < 0) throw Error("anisotropicFilterPitch must be greater than or equal to 0");
        return this._anisotropicFilterPitch = e1, this._update();
    }
    getRenderWorldCopies() {
        return this._camera.transform.renderWorldCopies;
    }
    setRenderWorldCopies(e1) {
        return this._camera.transform.setRenderWorldCopies(e1), this._update();
    }
    setTransformConstrain(e1) {
        return this._camera.transform.setConstrainOverride(e1), this._update();
    }
    project(e1) {
        return this._camera.transform.locationToScreenPoint($785da19a645c07eb$var$Mx.convert(e1), this.style && this.terrain);
    }
    unproject(e1) {
        return this._camera.transform.screenPointToLocation($785da19a645c07eb$var$Kc.convert(e1), this.terrain);
    }
    isMoving() {
        return this._camera.isMoving() || this._handlers?.isMoving() || !1;
    }
    isZooming() {
        return this._camera.isZooming() || this._handlers?.isZooming() || !1;
    }
    isRotating() {
        return this._camera.isRotating() || this._handlers?.isRotating() || !1;
    }
    _createDelegatedListener(e1, t, i) {
        if ("mouseenter" === e1 || "mouseover" === e1) {
            let n = !1;
            return {
                layers: t,
                listener: i,
                delegates: {
                    mousemove: (a)=>{
                        let r = t.filter((e1)=>this.getLayer(e1)), s = 0 === r.length ? [] : this.queryRenderedFeatures(a.point, {
                            layers: r
                        });
                        s.length ? n || (n = !0, i.call(this, new $785da19a645c07eb$var$pC(e1, this, a.originalEvent, {
                            features: s
                        }))) : n = !1;
                    },
                    mouseout: ()=>{
                        n = !1;
                    }
                }
            };
        }
        if ("mouseleave" === e1 || "mouseout" === e1) {
            let n = !1;
            return {
                layers: t,
                listener: i,
                delegates: {
                    mousemove: (a)=>{
                        let r = t.filter((e1)=>this.getLayer(e1));
                        (0 === r.length ? [] : this.queryRenderedFeatures(a.point, {
                            layers: r
                        })).length ? n = !0 : n && (n = !1, i.call(this, new $785da19a645c07eb$var$pC(e1, this, a.originalEvent)));
                    },
                    mouseout: (t)=>{
                        n && (n = !1, i.call(this, new $785da19a645c07eb$var$pC(e1, this, t.originalEvent)));
                    }
                }
            };
        }
        {
            let n = (e1)=>{
                let n = t.filter((e1)=>this.getLayer(e1)), a = 0 === n.length ? [] : this.queryRenderedFeatures(e1.point, {
                    layers: n
                });
                a.length && (e1.features = a, i.call(this, e1), delete e1.features);
            };
            return {
                layers: t,
                listener: i,
                delegates: {
                    [e1]: n
                }
            };
        }
    }
    _saveDelegatedListener(e1, t) {
        this._delegatedListeners ||= {}, this._delegatedListeners[e1] ||= [], this._delegatedListeners[e1].push(t);
    }
    _removeDelegatedListener(e1, t, i) {
        if (!this._delegatedListeners?.[e1]) return;
        let n = this._delegatedListeners[e1];
        for(let e1 = 0; e1 < n.length; e1++){
            let a = n[e1];
            if (a.listener === i && a.layers.length === t.length && a.layers.every((e1)=>t.includes(e1))) {
                for(let e1 in a.delegates)this.off(e1, a.delegates[e1]);
                return void n.splice(e1, 1);
            }
        }
    }
    on(e1, t, i) {
        if (void 0 === i) return super.on(e1, t);
        let n = "string" == typeof t ? [
            t
        ] : t, a = this._createDelegatedListener(e1, n, i);
        this._saveDelegatedListener(e1, a);
        for(let e1 in a.delegates)this.on(e1, a.delegates[e1]);
        return {
            unsubscribe: ()=>{
                this._removeDelegatedListener(e1, n, i);
            }
        };
    }
    once(e1, t, i) {
        if (void 0 === i) return super.once(e1, t);
        let n = "string" == typeof t ? [
            t
        ] : t, a = this._createDelegatedListener(e1, n, i);
        for(let t in a.delegates){
            let r = a.delegates[t];
            a.delegates[t] = (...t)=>{
                this._removeDelegatedListener(e1, n, i), r(...t);
            };
        }
        this._saveDelegatedListener(e1, a);
        for(let e1 in a.delegates)this.once(e1, a.delegates[e1]);
        return this;
    }
    off(e1, t, i) {
        if (void 0 === i) return super.off(e1, t);
        let n = "string" == typeof t ? [
            t
        ] : t;
        return this._removeDelegatedListener(e1, n, i), this;
    }
    queryRenderedFeatures(e1, t) {
        if (!this.style) return [];
        let i, n = e1 instanceof $785da19a645c07eb$var$Kc || Array.isArray(e1), a = n ? e1 : [
            [
                0,
                0
            ],
            [
                this._camera.transform.width,
                this._camera.transform.height
            ]
        ];
        if (t ||= (n ? {} : e1) || {}, a instanceof $785da19a645c07eb$var$Kc || "number" == typeof a[0]) i = [
            $785da19a645c07eb$var$Kc.convert(a)
        ];
        else {
            let e1 = $785da19a645c07eb$var$Kc.convert(a[0]), t = $785da19a645c07eb$var$Kc.convert(a[1]);
            i = [
                e1,
                new $785da19a645c07eb$var$Kc(t.x, e1.y),
                t,
                new $785da19a645c07eb$var$Kc(e1.x, t.y),
                e1
            ];
        }
        return this.style.queryRenderedFeatures(i, t, this._camera.transform);
    }
    querySourceFeatures(e1, t) {
        return this.style.querySourceFeatures(e1, t);
    }
    setStyle(e1, t) {
        return t = $785da19a645c07eb$var$hh({}, {
            localIdeographFontFamily: this._localIdeographFontFamily,
            validate: this._validateStyle
        }, t), this._styleUrl = "string" == typeof e1 ? e1 : null, !1 !== t.diff && t.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._updateStyle(e1, t));
    }
    setTransformRequest(e1) {
        return this._requestManager.setTransformRequest(e1), this;
    }
    _getUIString(e1) {
        let t = this._locale[e1];
        if (null == t) throw Error(`Missing UI string '${e1}'`);
        return t;
    }
    _updateStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), this._diffStyleRequest = null, t.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(e1, t));
        let i = this.style && t.transformStyle ? this.style.serialize() : void 0;
        return this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1 ? (this.style = new $785da19a645c07eb$var$wI(this, t || {}), this.style.setEventedParent(this, {
            style: this.style
        }), "string" == typeof e1 ? this.style.loadURL(e1, t, i) : this.style.loadJSON(e1, t, i), this) : (this._frameRequest &&= (this._frameRequest.abort(), null), this.style?.projection?.destroy(), delete this.style, this);
    }
    _lazyInitEmptyStyle() {
        this.style || (this.style = new $785da19a645c07eb$var$wI(this, {}), this.style.setEventedParent(this, {
            style: this.style
        }), this.style.loadEmpty());
    }
    async _diffStyle(e1, t) {
        if (this._diffStyleRequest?.abort(), "string" == typeof e1) {
            let i = e1;
            this._diffStyleRequest = new AbortController;
            let n = this._diffStyleRequest;
            try {
                let e1 = await this._requestManager.transformRequest(i, "Style");
                if (n.signal.aborted) return void (this._diffStyleRequest = null);
                let a = await $785da19a645c07eb$var$Jh(e1, n);
                this._diffStyleRequest = null, this._updateDiff(a.data, t);
            } catch (e1) {
                this._diffStyleRequest = null, $785da19a645c07eb$var$qh(e1) || this.fire(new $785da19a645c07eb$var$ad($785da19a645c07eb$var$Gu(e1)));
            }
        } else "object" == typeof e1 && (this._diffStyleRequest = null, this._updateDiff(e1, t));
    }
    _updateDiff(e1, t) {
        try {
            this.style.setState(e1, t) && this._update(!0);
        } catch (i) {
            $785da19a645c07eb$var$wh(`Unable to perform style diff: ${$785da19a645c07eb$var$Gu(i).message}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
        }
    }
    getStyle() {
        if (this.style) return this.style.serialize();
    }
    getStyleUrl() {
        return this._styleUrl;
    }
    _getStyleAndImages() {
        return this.style ? {
            style: this.style.serialize(),
            images: this.style.imageManager.cloneImages()
        } : {
            style: null,
            images: {}
        };
    }
    isStyleLoaded() {
        if (this.style) return this.style.loaded();
        $785da19a645c07eb$var$wh("There is no style added to the map.");
    }
    addSource(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
    }
    isSourceLoaded(e1) {
        let t = this.style?.tileManagers[e1];
        if (void 0 !== t) return t.loaded();
        this.fire(new $785da19a645c07eb$var$ad(Error(`There is no tile manager with ID '${e1}'`)));
    }
    setTerrain(e1, t = {}) {
        if (this.style._checkLoaded(), e1 && $785da19a645c07eb$var$Nf(this, $785da19a645c07eb$var$Lf.terrain, {
            value: e1
        }, t)) return this;
        if (this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e1) {
            let t = this.style.tileManagers[e1.source];
            if (!t) throw Error(`cannot load terrain, because there exists no source with ID: ${e1.source}`);
            null === this.terrain && t.reload();
            for(let t in this.style._layers){
                let i = this.style._layers[t];
                "hillshade" === i.type && i.source === e1.source && $785da19a645c07eb$var$wh("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === i.type && i.source === e1.source && $785da19a645c07eb$var$wh("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
            }
            this.terrain && this.terrain.destroy(), this.terrain = new $785da19a645c07eb$var$FP(this.painter, t, e1, this._terrainSkirtLength), this.painter.renderToTexture = new $785da19a645c07eb$var$rL(this.painter, this.terrain), this._camera.terrain = this.terrain, this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform)), this._terrainDataCallback = (t)=>this._handleTerrainDataEvent(t, e1.source), this.style.on("data", this._terrainDataCallback);
        } else this.terrain && this.terrain.destroy(), this.terrain = null, this.painter.renderToTexture = null, this._camera.terrain = null, this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0);
        return this.style.triggerSymbolPlacement(), this.fire(new $785da19a645c07eb$var$AC({
            terrain: e1
        })), this;
    }
    _handleTerrainDataEvent(e1, t) {
        if ("style" === e1.dataType) return void this.terrain.tileManager.releaseAllRTT();
        let i = e1.sourceId === t;
        if (i && (this.terrain.resetElevationCache(), this.style.triggerSymbolPlacement()), i && e1.tile && !this._camera.elevationFreeze && (this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform))), e1.tile) {
            if ("image" === e1.source?.type) return void this.terrain.tileManager.releaseAllRTT();
            this.terrain.tileManager.releaseRTT(e1.tile.tileID);
        }
    }
    getTerrain() {
        return this.terrain?.options ?? null;
    }
    areTilesLoaded() {
        let e1 = this.style?.tileManagers;
        for (let t of Object.values(e1))if (!t.areTilesLoaded()) return !1;
        return !0;
    }
    removeSource(e1) {
        return this.style.removeSource(e1), this._update(!0);
    }
    getSource(e1) {
        return this.style?.getSource(e1);
    }
    setSourceTileLodParams(e1, t, i) {
        if (i) {
            let n = this.getSource(i);
            if (!n) throw Error(`There is no source with ID "${i}", cannot set LOD parameters`);
            n.calculateTileZoom = $785da19a645c07eb$var$iD(Math.max(1, e1), Math.max(1, t));
        } else for(let i in this.style.tileManagers)this.style.tileManagers[i].getSource().calculateTileZoom = $785da19a645c07eb$var$iD(Math.max(1, e1), Math.max(1, t));
        return this._update(!0), this;
    }
    refreshTiles(e1, t) {
        let i = this.style.tileManagers[e1];
        if (!i) throw Error(`There is no tile manager with ID "${e1}", cannot refresh tile`);
        void 0 === t ? i.reload(!0) : i.refreshTiles(t.map((e1)=>new $785da19a645c07eb$var$WE(e1.z, e1.x, e1.y)));
    }
    addImage(e1, t, i = {}) {
        this._lazyInitEmptyStyle();
        let n = this._createStyleImage(t, i);
        return n ? (this.style.addImage(e1, n), n.userImage?.onAdd && n.userImage.onAdd(this, e1), this) : this;
    }
    setMissingStyleImageResolver(e1) {
        return this._missingStyleImageResolver = e1, this.style?.setMissingImageResolver(e1), this;
    }
    _createStyleImage(e1, t = {}) {
        let { pixelRatio: i = 1, sdf: n = !1, stretchX: a, stretchY: r, content: s, textFitWidth: o, textFitHeight: l } = t;
        if (e1 instanceof HTMLImageElement || $785da19a645c07eb$var$Mh(e1)) {
            let { width: t, height: c, data: u } = $785da19a645c07eb$var$iC.getImageData(e1);
            return {
                data: new $785da19a645c07eb$var$Kv({
                    width: t,
                    height: c
                }, u),
                pixelRatio: i,
                stretchX: a,
                stretchY: r,
                content: s,
                textFitWidth: o,
                textFitHeight: l,
                sdf: n,
                version: 0
            };
        }
        if (void 0 === e1.width || void 0 === e1.height) return this.fire(new $785da19a645c07eb$var$ad(Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))), null;
        {
            let { width: t, height: c, data: u } = e1, h = e1, d = $785da19a645c07eb$var$yw(h.data);
            return {
                data: d ? new $785da19a645c07eb$var$Kv({
                    width: t,
                    height: c
                }) : new $785da19a645c07eb$var$Kv({
                    width: t,
                    height: c
                }, new Uint8Array(u)),
                pixelRatio: i,
                stretchX: a,
                stretchY: r,
                content: s,
                textFitWidth: o,
                textFitHeight: l,
                sdf: n,
                version: 0,
                isWebGLImage: d,
                userImage: h
            };
        }
    }
    updateImage(e1, t) {
        let i = this.style.getImage(e1);
        if (!i) return this.fire(new $785da19a645c07eb$var$ad(Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
        let { width: n, height: a, data: r } = t instanceof HTMLImageElement || $785da19a645c07eb$var$Mh(t) ? $785da19a645c07eb$var$iC.getImageData(t) : t;
        if (void 0 === n || void 0 === a) return this.fire(new $785da19a645c07eb$var$ad(Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
        if (n !== i.data.width || a !== i.data.height) return this.fire(new $785da19a645c07eb$var$ad(Error("The width and height of the updated image must be that same as the previous version of the image")));
        if (i.isWebGLImage = $785da19a645c07eb$var$yw(r), i.isWebGLImage) i.userImage = t;
        else {
            let e1 = !(t instanceof HTMLImageElement || $785da19a645c07eb$var$Mh(t));
            i.data.replace(r, e1);
        }
        return this.style.updateImage(e1, i), this;
    }
    getImage(e1) {
        return this.style.getImage(e1);
    }
    hasImage(e1) {
        return e1 ? !!this.style.getImage(e1) : (this.fire(new $785da19a645c07eb$var$ad(Error("Missing required image id"))), !1);
    }
    removeImage(e1) {
        this.style.removeImage(e1);
    }
    async loadImage(e1) {
        let t = await $785da19a645c07eb$var$sC.getImage(await this._requestManager.transformRequest(e1, "Image"), new AbortController);
        if (!t.data) throw Error(`Could not load image ${e1}: the response is empty`);
        return t;
    }
    listImages() {
        return this.style?.listImages() ?? [];
    }
    addLayer(e1, t) {
        return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
    }
    moveLayer(e1, t) {
        return this.style.moveLayer(e1, t), this._update(!0);
    }
    removeLayer(e1) {
        return this.style.removeLayer(e1), this._update(!0);
    }
    getLayer(e1) {
        return this.style?.getLayer(e1);
    }
    getLayersOrder() {
        return this.style?.getLayersOrder() ?? [];
    }
    setLayerZoomRange(e1, t, i) {
        return this.style.setLayerZoomRange(e1, t, i), this._update(!0);
    }
    setFilter(e1, t, i = {}) {
        return this.style?.setFilter(e1, t, i), this._update(!0);
    }
    getFilter(e1) {
        return this.style.getFilter(e1);
    }
    setPaintProperty(e1, t, i, n = {}) {
        return this.style?.setPaintProperty(e1, t, i, n), this._update(!0);
    }
    getPaintProperty(e1, t) {
        return this.style.getPaintProperty(e1, t);
    }
    setLayoutProperty(e1, t, i, n = {}) {
        return this.style.setLayoutProperty(e1, t, i, n), this._update(!0);
    }
    getLayoutProperty(e1, t) {
        return this.style.getLayoutProperty(e1, t);
    }
    setGlyphs(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, t), this._update(!0);
    }
    getGlyphs() {
        return this.style.getGlyphsUrl();
    }
    setFontFaces(e1) {
        return this._lazyInitEmptyStyle(), this.style.setFontFaces(e1), this._update(!0);
    }
    getFontFaces() {
        return this.style.getFontFaces();
    }
    addSprite(e1, t, i = {}) {
        return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, i, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    removeSprite(e1) {
        return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
    }
    getSprite() {
        return this.style.getSprite();
    }
    setSprite(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSprite(e1, t, (e1)=>{
            e1 || this._update(!0);
        }), this;
    }
    setLight(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setLight(e1, t), this._update(!0);
    }
    getLight() {
        return this.style.getLight();
    }
    setSky(e1, t = {}) {
        return this._lazyInitEmptyStyle(), this.style.setSky(e1, t), this._update(!0);
    }
    getSky() {
        return this.style.getSky();
    }
    setFeatureState(e1, t) {
        return this.style.setFeatureState(e1, t), this._update();
    }
    removeFeatureState(e1, t) {
        return this.style.removeFeatureState(e1, t), this._update();
    }
    getFeatureState(e1) {
        return this.style.getFeatureState(e1);
    }
    getContainer() {
        return this._container;
    }
    getCanvasContainer() {
        return this._canvasContainer;
    }
    getCanvas() {
        return this._canvas;
    }
    _containerDimensions() {
        let e1 = 0, t = 0;
        return this._container && (e1 = this._container.clientWidth || 400, t = this._container.clientHeight || 300), [
            e1,
            t
        ];
    }
    _shouldHandleInitialResize() {
        if (!this._container?.clientWidth || !this._container.clientHeight) return !1;
        let [e1, t] = this._containerDimensions();
        return e1 !== this._camera.transform.width || t !== this._camera.transform.height;
    }
    _setupResizeObserver() {
        let e1 = !1, t = $785da19a645c07eb$var$tR((e1)=>{
            this._trackResize && !this._removed && (this.resize(e1), this.redraw());
        }, 50), i = this._ownerWindow.ResizeObserver ?? ResizeObserver;
        this._resizeObserver = new i((i)=>{
            !e1 && (e1 = !0, !this._shouldHandleInitialResize()) || t(i);
        }), this._resizeObserver.observe(this._container);
    }
    _resolveContainer(e1) {
        if ("string" == typeof e1) {
            let t = document.getElementById(e1);
            if (!t) throw Error(`Container '${e1}' not found.`);
            return t;
        }
        if (e1 instanceof HTMLElement || e1 && "object" == typeof e1 && 1 === e1.nodeType) return e1;
        throw Error("Invalid type: 'container' must be a String or HTMLElement.");
    }
    _setupContainer() {
        let e1 = this._container;
        e1.classList.add("maplibregl-map");
        let t = this._canvasContainer = $785da19a645c07eb$var$rC.create("div", "maplibregl-canvas-container", e1);
        this._interactive && t.classList.add("maplibregl-interactive"), this._canvas = $785da19a645c07eb$var$rC.create("canvas", "maplibregl-canvas", t), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
        let i = this._containerDimensions(), n = this._getClampedPixelRatio(i[0], i[1]);
        this._resizeCanvas(i[0], i[1], n);
        let a = this._controlContainer = $785da19a645c07eb$var$rC.create("div", "maplibregl-control-container", e1), r = this._controlPositions = {};
        for (let e1 of [
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ])r[e1] = $785da19a645c07eb$var$rC.create("div", `maplibregl-ctrl-${e1} `, a);
        this._container.addEventListener("scroll", this._onMapScroll, !1);
    }
    _cleanupContainer() {
        this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map");
    }
    _resizeCanvas(e1, t, i) {
        this._canvas.width = Math.floor(i * e1), this._canvas.height = Math.floor(i * t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
    }
    _setupPainter() {
        let e1 = {
            ...this._canvasContextAttributes,
            alpha: !0,
            depth: !0,
            stencil: !0,
            premultipliedAlpha: !0
        }, t = null;
        this._canvas.addEventListener("webglcontextcreationerror", (e1)=>{
            t = e1;
        }, {
            once: !0
        });
        let i = this._canvas.getContext("webgl2", e1);
        if (!i) throw new $785da19a645c07eb$var$eR(e1, t);
        this.painter = new $785da19a645c07eb$var$$z(i, this._camera.transform);
    }
    migrateProjection(e1, t) {
        this._camera.migrateProjection(e1, t), this.painter.transform = e1, this.fire(new $785da19a645c07eb$var$_C({
            newProjection: this.style.projection.name
        }));
    }
    loaded() {
        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
    }
    _update(e1) {
        return this.style?._loaded ? (this._styleDirty ||= e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
    }
    _requestRenderFrame(e1) {
        return this._update(), this._renderTaskQueue.add(e1);
    }
    _cancelRenderFrame(e1) {
        this._renderTaskQueue.remove(e1);
    }
    _render(e1) {
        let t = this._idleTriggered ? this._fadeDuration : 0, i = this.style.projection?.transitionState > 0;
        if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
        let n = !1;
        if (this.style && this._styleDirty) {
            this._styleDirty = !1;
            let e1 = this._camera.transform.zoom, i = $785da19a645c07eb$var$aC();
            this.style.zoomHistory.update(e1, i);
            let a = new $785da19a645c07eb$var$Qf(e1, {
                now: i,
                fadeDuration: t,
                zoomHistory: this.style.zoomHistory,
                transition: this.style.getTransition()
            }), r = a.crossFadingFactor();
            (1 !== r || r !== this._crossFadingFactor) && (n = !0, this._crossFadingFactor = r), this.style.update(a);
        }
        let a = this.style.projection?.transitionState > 0 !== i;
        this._camera.transform.setTransitionState(this.style.projection?.transitionState), this.style && (this._sourcesDirty || a) && (this._sourcesDirty = !1, this.style._updateSources(this._camera.transform)), this.terrain ? (this.terrain.tileManager.update(this._camera.transform, this.terrain) && this.terrain.resetElevationCache(), this._camera.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._camera.transform.center, this._camera.transform.tileZoom)), !this._camera.elevationFreeze && this.getCenterClampedToGround() && this._camera.transform.setElevation(this.terrain.getElevationForLngLat(this._camera.transform.center, this._camera.transform))) : (this._camera.transform.setMinElevationForCurrentTile(0), this.getCenterClampedToGround() && this._camera.transform.setElevation(0)), this._placementDirty = this.style?._updatePlacement(this._camera.transform, this.showCollisionBoxes, t, this._crossSourceCollisions, a), this.painter.render(this.style, {
            showTileBoundaries: this.showTileBoundaries,
            showOverdrawInspector: this._showOverdrawInspector,
            rotating: this.isRotating(),
            zooming: this.isZooming(),
            moving: this.isMoving(),
            fadeDuration: t,
            showPadding: this.showPadding,
            anisotropicFilterPitch: this.getAnisotropicFilterPitch()
        }), this.fire(new $785da19a645c07eb$var$lC("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new $785da19a645c07eb$var$lC("load"))), this.style && (this.style.hasTransitions() || n) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
        let r = this._sourcesDirty || this._styleDirty || this._placementDirty || this.painter.renderToTexture?.needsFollowUpFrame;
        return r || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new $785da19a645c07eb$var$lC("idle")), this._loaded && !this._fullyLoaded && !r && (this._fullyLoaded = !0), this;
    }
    redraw() {
        return this.style && (this._frameRequest &&= (this._frameRequest.abort(), null), this._render(0)), this;
    }
    remove() {
        this._hash && this._hash.remove();
        for (let e1 of this._controls)e1.onRemove(this);
        this._controls = [], this._frameRequest &&= (this._frameRequest.abort(), null), this._renderTaskQueue.clear(), this._diffStyleRequest?.abort(), this.painter.destroy(), this._handlers.destroy(), this.setStyle(null), typeof window < "u" && this._ownerWindow.removeEventListener("online", this._onWindowOnline, !1), $785da19a645c07eb$var$sC.removeThrottleControl(this._imageQueueHandle), this._resizeObserver?.disconnect();
        let e1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
        e1?.loseContext && e1.loseContext(), this._cleanupContainer(), this._removed = !0, this.fire(new $785da19a645c07eb$var$lC("remove"));
    }
    triggerRepaint() {
        this.style && !this._frameRequest && (this._frameRequest = new AbortController, $785da19a645c07eb$var$iC.frame(this._frameRequest, (e1)=>{
            this._frameRequest = null;
            try {
                this._render(e1);
            } catch (e1) {
                if (!$785da19a645c07eb$var$qh(e1)) throw e1;
            }
        }, ()=>{}, this._ownerWindow));
    }
    get showTileBoundaries() {
        return !!this._showTileBoundaries;
    }
    set showTileBoundaries(e1) {
        this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
    }
    get showPadding() {
        return !!this._showPadding;
    }
    set showPadding(e1) {
        this._showPadding !== e1 && (this._showPadding = e1, this._update());
    }
    get showCollisionBoxes() {
        return !!this._showCollisionBoxes;
    }
    set showCollisionBoxes(e1) {
        this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
    }
    get showOverdrawInspector() {
        return !!this._showOverdrawInspector;
    }
    set showOverdrawInspector(e1) {
        this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
    }
    get repaint() {
        return !!this._repaint;
    }
    set repaint(e1) {
        this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
    }
    get vertices() {
        return !!this._vertices;
    }
    set vertices(e1) {
        this._vertices = e1, this._update();
    }
    get version() {
        return "6.9.0";
    }
    getCameraTargetElevation() {
        return this._camera.transform.elevation;
    }
    getProjection() {
        return this.style.getProjection();
    }
    setProjection(e1) {
        return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
    }
};
const $785da19a645c07eb$var$cL = {
    showCompass: !0,
    showZoom: !0,
    visualizePitch: !1,
    visualizeRoll: !0
};
var $785da19a645c07eb$var$uL = class {
    constructor(e1){
        this._updateZoomButtons = ()=>{
            let e1 = this._map.getZoom(), t = e1 === this._map.getMaxZoom(), i = e1 === this._map.getMinZoom(!0);
            this._zoomInButton.disabled = t, this._zoomOutButton.disabled = i, this._zoomInButton.setAttribute("aria-disabled", t.toString()), this._zoomOutButton.setAttribute("aria-disabled", i.toString());
        }, this._rotateCompassArrow = ()=>{
            let e1 = this._map.getPitch(), t = this._map.getRoll(), i = this._map.getBearing(), n = 1 / Math.cos($785da19a645c07eb$var$Dh(e1)) ** .5;
            this.options.visualizePitch && this.options.visualizeRoll ? this._compassIcon.style.transform = `scale(${n}) rotateZ(${-t}deg) rotateX(${e1}deg) rotateZ(${-i}deg)` : this.options.visualizePitch ? this._compassIcon.style.transform = `scale(${n}) rotateX(${e1}deg) rotateZ(${-i}deg)` : this.options.visualizeRoll ? this._compassIcon.style.transform = `rotate(${-i - t}deg)` : this._compassIcon.style.transform = `rotate(${-i}deg)`;
        }, this._setButtonTitle = (e1, t)=>{
            let i = this._map._getUIString(`NavigationControl.${t}`);
            e1.title = i, e1.setAttribute("aria-label", i);
        }, this.options = $785da19a645c07eb$var$hh({}, $785da19a645c07eb$var$cL, e1), this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (e1)=>this._map.zoomIn({}, {
                originalEvent: e1
            })), $785da19a645c07eb$var$rC.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (e1)=>this._map.zoomOut({}, {
                originalEvent: e1
            })), $785da19a645c07eb$var$rC.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (e1)=>{
            this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                originalEvent: e1
            }) : this._map.resetNorth({}, {
                originalEvent: e1
            });
        }), this._compassIcon = $785da19a645c07eb$var$rC.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
    }
    onAdd(e1) {
        return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("move", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new $785da19a645c07eb$var$hL(this._map, this._compass, this.options.visualizePitch)), this._container;
    }
    onRemove() {
        this._container.remove(), this.options.showZoom && this._map.off("move", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
    }
    _createButton(e1, t) {
        let i = $785da19a645c07eb$var$rC.create("button", e1, this._container);
        return i.type = "button", i.addEventListener("click", t), i;
    }
}, $785da19a645c07eb$var$hL = class {
    constructor(e1, t, i = !1){
        this.mousedown = (e1)=>{
            this.startMove(e1, $785da19a645c07eb$var$rC.mousePos(this.element, e1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
        }, this.mousemove = (e1)=>{
            this.move(e1, $785da19a645c07eb$var$rC.mousePos(this.element, e1));
        }, this.mouseup = (e1)=>{
            this._rotatePitchHandler.dragEnd(e1), this.offTemp();
        }, this.touchstart = (e1)=>{
            1 === e1.targetTouches.length ? (this._startPos = this._lastPos = $785da19a645c07eb$var$rC.touchPos(this.element, e1.targetTouches)[0], this.startMove(e1, this._startPos), window.addEventListener("touchmove", this.touchmove, {
                passive: !1
            }), window.addEventListener("touchend", this.touchend)) : this.reset();
        }, this.touchmove = (e1)=>{
            1 === e1.targetTouches.length ? (this._lastPos = $785da19a645c07eb$var$rC.touchPos(this.element, e1.targetTouches)[0], this.move(e1, this._lastPos)) : this.reset();
        }, this.touchend = (e1)=>{
            0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this.reset = ()=>{
            this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
        }, this._clickTolerance = 10, this.element = t;
        let n = new $785da19a645c07eb$var$wR;
        this._rotatePitchHandler = new $785da19a645c07eb$var$vR({
            clickTolerance: 3,
            move: (e1, n)=>{
                let a = t.getBoundingClientRect(), r = new $785da19a645c07eb$var$Kc((a.bottom - a.top) / 2, (a.right - a.left) / 2);
                return {
                    bearingDelta: $785da19a645c07eb$var$Fh(new $785da19a645c07eb$var$Kc(e1.x, n.y), n, r),
                    pitchDelta: i ? -0.5 * (n.y - e1.y) : void 0
                };
            },
            moveStateManager: n,
            enable: !0,
            assignEvents: ()=>{}
        }), this.map = e1, t.addEventListener("mousedown", this.mousedown), t.addEventListener("touchstart", this.touchstart, {
            passive: !1
        }), t.addEventListener("touchcancel", this.reset);
    }
    startMove(e1, t) {
        this._rotatePitchHandler.dragStart(e1, t), $785da19a645c07eb$var$rC.disableDrag();
    }
    move(e1, t) {
        let i = this.map, { bearingDelta: n, pitchDelta: a } = this._rotatePitchHandler.dragMove(e1, t) || {};
        n && i.setBearing(i.getBearing() + n), a && i.setPitch(i.getPitch() + a);
    }
    off() {
        let e1 = this.element;
        e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart), window.removeEventListener("touchmove", this.touchmove), window.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
    }
    offTemp() {
        $785da19a645c07eb$var$rC.enableDrag(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup), window.removeEventListener("touchmove", this.touchmove), window.removeEventListener("touchend", this.touchend);
    }
};
let $785da19a645c07eb$var$dL;
function $785da19a645c07eb$var$pL(e1, t, i, n = !1) {
    if (n || !i.getCoveringTilesDetailsProvider().allowWorldCopies()) return e1?.wrap();
    let a = new $785da19a645c07eb$var$Mx(e1.lng, e1.lat);
    if (e1 = new $785da19a645c07eb$var$Mx(e1.lng, e1.lat), t) {
        let n = new $785da19a645c07eb$var$Mx(e1.lng - 360, e1.lat), a = new $785da19a645c07eb$var$Mx(e1.lng + 360, e1.lat), r = i.locationToScreenPoint(e1).distSqr(t);
        i.locationToScreenPoint(n).distSqr(t) < r ? e1 = n : i.locationToScreenPoint(a).distSqr(t) < r && (e1 = a);
    }
    for(; Math.abs(e1.lng - i.center.lng) > 180;){
        let t = i.locationToScreenPoint(e1);
        if (t.x >= 0 && t.y >= 0 && t.x <= i.width && t.y <= i.height) break;
        e1.lng > i.center.lng ? e1.lng -= 360 : e1.lng += 360;
    }
    return e1.lng !== a.lng && i.isPointOnMapSurface(i.locationToScreenPoint(e1)) ? e1 : a;
}
const $785da19a645c07eb$var$mL = {
    center: "translate(-50%,-50%)",
    top: "translate(-50%,0)",
    "top-left": "translate(0,0)",
    "top-right": "translate(-100%,0)",
    bottom: "translate(-50%,-100%)",
    "bottom-left": "translate(0,-100%)",
    "bottom-right": "translate(-100%,-100%)",
    left: "translate(0,-50%)",
    right: "translate(-100%,-50%)"
};
function $785da19a645c07eb$var$gL(e1, t, i) {
    let n = e1.classList;
    for(let e1 in $785da19a645c07eb$var$mL)n.remove(`maplibregl-${i}-anchor-${e1}`);
    n.add(`maplibregl-${i}-anchor-${t}`);
}
const $785da19a645c07eb$var$fL = {
    ArrowLeft: [
        -1,
        0
    ],
    ArrowRight: [
        1,
        0
    ],
    ArrowUp: [
        0,
        -1
    ],
    ArrowDown: [
        0,
        1
    ]
}, $785da19a645c07eb$var$AL = "#3FB1CE";
function $785da19a645c07eb$var$_L(e1, t, i = []) {
    let n = $785da19a645c07eb$var$rC.createNS("http://www.w3.org/2000/svg", e1);
    for(let e1 in t)n.setAttributeNS(null, e1, t[e1]);
    for (let e1 of i)n.appendChild(e1);
    return n;
}
let $785da19a645c07eb$var$vL;
var $785da19a645c07eb$var$yL = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$xL = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$bL = class extends $785da19a645c07eb$var$rd {
    constructor(e1){
        if (super(), this._onClick = (e1)=>{
            this.fire(new $785da19a645c07eb$var$xL("click", {
                originalEvent: e1
            }));
        }, this._onKeyPress = (e1)=>{
            ("Space" === e1.code || "Enter" === e1.code) && this.togglePopup();
        }, this._onKeyDown = (e1)=>{
            if (!this._defaultMarker || !this._draggable || !this._map || !this._lngLat || e1.composedPath()[0] !== this._element || e1.altKey || e1.ctrlKey || e1.metaKey) return;
            let t = $785da19a645c07eb$var$fL[e1.key];
            if (!t) return;
            e1.preventDefault(), e1.stopPropagation();
            let i = e1.shiftKey ? 10 : 1, n = this._map.project(this._lngLat);
            this.setLngLat(this._map.unproject(new $785da19a645c07eb$var$Kc(n.x + t[0] * i, n.y + t[1] * i))), this._keyboardDragActive || (this._keyboardDragActive = !0, this.fire(new $785da19a645c07eb$var$yL("dragstart"))), this.fire(new $785da19a645c07eb$var$yL("drag"));
        }, this._onKeyUp = (e1)=>{
            $785da19a645c07eb$var$fL[e1.key] && this._endKeyboardDrag();
        }, this._onBlur = ()=>{
            this._endKeyboardDrag();
        }, this._onMapClick = (e1)=>{
            let t = e1.originalEvent.target, i = this._element;
            this._popup && (t === i || i.contains(t)) && this.togglePopup();
        }, this._update = (e1)=>{
            if (!this._map) return;
            let t = this._map.loaded() && !this._map.isMoving();
            ("terrain" === e1?.type || "render" === e1?.type && !t) && this._map.once("render", this._update), this._lngLat = $785da19a645c07eb$var$pL(this._lngLat, this._flatPos, this._map._camera.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map._camera.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
            let i = "";
            "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? i = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (i = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
            let n = "";
            "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? n = "rotateX(0deg)" : "map" === this._pitchAlignment && (n = `rotateX(${this._map.getPitch()}deg)`), !this._subpixelPositioning && (!e1 || "moveend" === e1.type) && (this._pos = this._pos.round()), this._element.style.transform = `${$785da19a645c07eb$var$mL[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${n} ${i}`, $785da19a645c07eb$var$iC.frameAsync(new AbortController, this._map._ownerWindow).then(()=>{
                this._updateOpacity("moveend" === e1?.type);
            }).catch(()=>{});
        }, this._onMove = (e1)=>{
            if (!this._isDragging) {
                let t = this._clickTolerance || this._map._clickTolerance;
                this._isDragging = e1.point.dist(this._pointerdownPos) >= t;
            }
            this._isDragging && (this._pos = e1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new $785da19a645c07eb$var$yL("dragstart"))), this.fire(new $785da19a645c07eb$var$yL("drag")));
        }, this._onUp = ()=>{
            this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new $785da19a645c07eb$var$yL("dragend")), this._state = "inactive";
        }, this._addDragHandler = (e1)=>{
            this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(this._pos).add(this._offset), this._pointerdownPos = e1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
        }, this._anchor = e1?.anchor || "center", this._color = e1?.color || $785da19a645c07eb$var$AL, this._scale = e1?.scale || 1, this._draggable = e1?.draggable || !1, this._clickTolerance = e1?.clickTolerance || 0, this._subpixelPositioning = e1?.subpixelPositioning || !1, this._isDragging = !1, this._roleManaged = !1, this._tabIndexManaged = !1, this._keyboardDragActive = !1, this._state = "inactive", this._rotation = e1?.rotation || 0, this._rotationAlignment = e1?.rotationAlignment || "auto", this._pitchAlignment = e1?.pitchAlignment && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : this._rotationAlignment, this.setOpacity(e1?.opacity, e1?.opacityWhenCovered), e1?.element) this._element = e1.element, this._offset = $785da19a645c07eb$var$Kc.convert(e1?.offset || [
            0,
            0
        ]);
        else {
            this._defaultMarker = !0, this._element = $785da19a645c07eb$var$rC.create("div");
            let t = ($785da19a645c07eb$var$vL || ($785da19a645c07eb$var$vL = $785da19a645c07eb$var$_L("svg", {
                display: "block",
                height: "41px",
                width: "27px",
                viewBox: "0 0 27 41"
            }, [
                $785da19a645c07eb$var$_L("g", {
                    "fill-rule": "nonzero"
                }, [
                    $785da19a645c07eb$var$_L("g", {
                        transform: "translate(3.0, 29.0)",
                        fill: "#000000"
                    }, [
                        [
                            "10.5",
                            "5.25002273"
                        ],
                        [
                            "10.5",
                            "5.25002273"
                        ],
                        [
                            "9.5",
                            "4.77275007"
                        ],
                        [
                            "8.5",
                            "4.29549936"
                        ],
                        [
                            "7.5",
                            "3.81822308"
                        ],
                        [
                            "6.5",
                            "3.34094679"
                        ],
                        [
                            "5.5",
                            "2.86367051"
                        ],
                        [
                            "4.5",
                            "2.38636864"
                        ]
                    ].map(([e1, t])=>$785da19a645c07eb$var$_L("ellipse", {
                            opacity: "0.04",
                            cx: "10.5",
                            cy: "5.80029008",
                            rx: e1,
                            ry: t
                        }))),
                    $785da19a645c07eb$var$_L("g", {
                        fill: $785da19a645c07eb$var$AL
                    }, [
                        $785da19a645c07eb$var$_L("path", {
                            d: "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"
                        })
                    ]),
                    $785da19a645c07eb$var$_L("g", {
                        opacity: "0.25",
                        fill: "#000000"
                    }, [
                        $785da19a645c07eb$var$_L("path", {
                            d: "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"
                        })
                    ]),
                    $785da19a645c07eb$var$_L("g", {
                        transform: "translate(6.0, 7.0)",
                        fill: "#FFFFFF"
                    }),
                    $785da19a645c07eb$var$_L("g", {
                        transform: "translate(8.0, 8.0)"
                    }, [
                        $785da19a645c07eb$var$_L("circle", {
                            fill: "#000000",
                            opacity: "0.25",
                            cx: "5.5",
                            cy: "5.5",
                            r: "5.4999962"
                        }),
                        $785da19a645c07eb$var$_L("circle", {
                            fill: "#FFFFFF",
                            cx: "5.5",
                            cy: "5.5",
                            r: "5.4999962"
                        })
                    ])
                ])
            ]), $785da19a645c07eb$var$vL)).cloneNode(!0);
            t.setAttributeNS(null, "height", 41 * this._scale + "px"), t.setAttributeNS(null, "width", 27 * this._scale + "px"), (function(e1) {
                return e1.firstElementChild.children[1];
            })(t).setAttributeNS(null, "fill", this._color), this._element.appendChild(t), this._offset = $785da19a645c07eb$var$Kc.convert(e1?.offset || [
                0,
                -14
            ]);
        }
        if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (e1)=>{
            e1.preventDefault();
        }), this._element.addEventListener("mousedown", (e1)=>{
            e1.preventDefault();
        }), $785da19a645c07eb$var$gL(this._element, this._anchor, "marker"), e1?.className) for (let t of e1.className.split(" "))this._element.classList.add(t);
        this._popup = null;
    }
    addTo(e1) {
        return this.remove(), this._map = e1, this._defaultMarker && !this._element.hasAttribute("aria-label") && this._element.setAttribute("aria-label", e1._getUIString("Marker.Title")), this._updateAccessibilityRole(), e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._update), e1.on("moveend", this._update), e1.on("terrain", this._update), e1.on("projectiontransition", this._update), this._element.addEventListener("click", this._onClick), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
    }
    remove() {
        return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), this._element.removeEventListener("click", this._onClick), this._element.removeEventListener("keydown", this._onKeyDown), this._element.removeEventListener("keyup", this._onKeyUp), this._element.removeEventListener("blur", this._onBlur), this._element.removeEventListener("keypress", this._onKeyPress), this._keyboardDragActive = !1, this._element.remove(), this._popup && this._popup.remove(), this;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = $785da19a645c07eb$var$Mx.convert(e1), this._pos = null, this._update(), this._popup && this._popup.setLngLat(this._lngLat), this;
    }
    getElement() {
        return this._element;
    }
    setPopup(e1) {
        if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress)), e1) {
            if (!("offset" in e1.options)) {
                let t = 13.5 / Math.SQRT2;
                e1.options.offset = this._defaultMarker ? {
                    top: [
                        0,
                        0
                    ],
                    "top-left": [
                        0,
                        0
                    ],
                    "top-right": [
                        0,
                        0
                    ],
                    bottom: [
                        0,
                        -38.1
                    ],
                    "bottom-left": [
                        t,
                        -1 * (24.6 + t)
                    ],
                    "bottom-right": [
                        -t,
                        -1 * (24.6 + t)
                    ],
                    left: [
                        13.5,
                        -24.6
                    ],
                    right: [
                        -13.5,
                        -24.6
                    ]
                } : this._offset;
            }
            this._popup = e1, this._element.addEventListener("keypress", this._onKeyPress);
        }
        return this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    setSubpixelPositioning(e1) {
        return this._subpixelPositioning = e1, this;
    }
    _endKeyboardDrag() {
        this._keyboardDragActive && (this._keyboardDragActive = !1, this.fire(new $785da19a645c07eb$var$yL("dragend")));
    }
    getPopup() {
        return this._popup;
    }
    togglePopup() {
        let e1 = this._popup;
        return this._element.style.opacity === this._opacityWhenCovered ? this : e1 ? (e1.isOpen() ? e1.remove() : (e1.setLngLat(this._lngLat), e1.addTo(this._map)), this) : this;
    }
    _updateOpacity(e1 = !1) {
        let t = this._map?.terrain, i = this._map._camera.transform.isLocationOccluded(this._lngLat);
        if (!t || i) {
            let e1 = i ? this._opacityWhenCovered : this._opacity;
            return void (this._element.style.opacity !== e1 && (this._element.style.opacity = e1, this._element.classList.toggle("maplibregl-marker-covered", i)));
        }
        if (e1) this._opacityTimeout = null;
        else {
            if (this._opacityTimeout) return;
            this._opacityTimeout = setTimeout(()=>{
                this._opacityTimeout = null;
            }, 100);
        }
        let n = this._map, a = n.terrain.depthAtPoint(this._pos), r = n.terrain.getElevationForLngLat(this._lngLat, n._camera.transform);
        if (n._camera.transform.lngLatToCameraDepth(this._lngLat, r) - a < .006) return this._element.style.opacity = this._opacity, void this._element.classList.remove("maplibregl-marker-covered");
        let s = -this._offset.y / n._camera.transform.pixelsPerMeter, o = Math.sin(n.getPitch() * Math.PI / 180) * s, l = n.terrain.depthAtPoint(new $785da19a645c07eb$var$Kc(this._pos.x, this._pos.y - this._offset.y)), c = n._camera.transform.lngLatToCameraDepth(this._lngLat, r + o) - l > .006;
        this._popup?.isOpen() && c && this._popup.remove(), this._element.style.opacity = c ? this._opacityWhenCovered : this._opacity, this._element.classList.toggle("maplibregl-marker-covered", c);
    }
    getOffset() {
        return this._offset;
    }
    setOffset(e1) {
        return this._offset = $785da19a645c07eb$var$Kc.convert(e1), this._update(), this;
    }
    addClassName(e1) {
        this._element.classList.add(e1);
    }
    removeClassName(e1) {
        this._element.classList.remove(e1);
    }
    toggleClassName(e1) {
        return this._element.classList.toggle(e1);
    }
    setDraggable(e1) {
        return this._draggable = !!e1, this._element.classList.toggle("maplibregl-marker-draggable", this._draggable), this._map && (e1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this._defaultMarker && (this._draggable ? (this._element.addEventListener("keydown", this._onKeyDown), this._element.addEventListener("keyup", this._onKeyUp), this._element.addEventListener("blur", this._onBlur)) : (this._element.removeEventListener("keydown", this._onKeyDown), this._element.removeEventListener("keyup", this._onKeyUp), this._element.removeEventListener("blur", this._onBlur), this._endKeyboardDrag())), this._updateTabIndex(), this._updateAccessibilityRole(), this;
    }
    isDraggable() {
        return this._draggable;
    }
    _updateTabIndex() {
        this._popup || this._defaultMarker && this._draggable ? this._element.hasAttribute("tabindex") || (this._element.setAttribute("tabindex", "0"), this._tabIndexManaged = !0) : this._tabIndexManaged &&= ("0" === this._element.getAttribute("tabindex") && this._element.removeAttribute("tabindex"), !1);
    }
    _updateAccessibilityRole() {
        if (!this._defaultMarker || this._element.hasAttribute("role") && !this._roleManaged) return;
        let e1 = this._draggable || this._popup ? "button" : "img";
        this._element.setAttribute("role", e1), this._roleManaged = !0;
    }
    setRotation(e1) {
        return this._rotation = e1 || 0, this._update(), this;
    }
    getRotation() {
        return this._rotation;
    }
    setRotationAlignment(e1) {
        return this._rotationAlignment = e1 || "auto", this._update(), this;
    }
    getRotationAlignment() {
        return this._rotationAlignment;
    }
    setPitchAlignment(e1) {
        return this._pitchAlignment = e1 && "auto" !== e1 ? e1 : this._rotationAlignment, this._update(), this;
    }
    getPitchAlignment() {
        return this._pitchAlignment;
    }
    setOpacity(e1, t) {
        return (void 0 === this._opacity || void 0 === e1 && void 0 === t) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e1 && (this._opacity = String(e1)), void 0 !== t && (this._opacityWhenCovered = String(t)), this._map && this._updateOpacity(!0), this;
    }
};
const $785da19a645c07eb$var$wL = {
    positionOptions: {
        enableHighAccuracy: !1,
        maximumAge: 0,
        timeout: 6e3
    },
    fitBoundsOptions: {
        maxZoom: 15
    },
    trackUserLocation: !1,
    showAccuracyCircle: !0,
    showUserLocation: !0
};
let $785da19a645c07eb$var$EL = 0, $785da19a645c07eb$var$kL = !1;
var $785da19a645c07eb$var$SL = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$ML = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$CL = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$TL = class extends $785da19a645c07eb$var$rd {
    constructor(e1){
        super(), this._onSuccess = (e1)=>{
            if (this._map) {
                if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new $785da19a645c07eb$var$ML("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                    case "WAITING_ACTIVE":
                    case "ACTIVE_LOCK":
                    case "ACTIVE_ERROR":
                        this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                        break;
                    case "BACKGROUND":
                    case "BACKGROUND_ERROR":
                        this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                        break;
                    default:
                        throw Error(`Unexpected watchState ${this._watchState}`);
                }
                this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), (!this.options.trackUserLocation || "ACTIVE_LOCK" === this._watchState) && this._updateCamera(e1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new $785da19a645c07eb$var$ML("geolocate", e1)), this._finish();
            }
        }, this._updateCamera = (e1)=>{
            let t = new $785da19a645c07eb$var$Mx(e1.coords.longitude, e1.coords.latitude), i = e1.coords.accuracy, n = $785da19a645c07eb$var$hh({
                bearing: this._map.getBearing()
            }, this.options.fitBoundsOptions), a = $785da19a645c07eb$var$_T.fromLngLat(t, i);
            this._map.fitBounds(a, n, {
                geolocateSource: !0
            });
        }, this._updateMarker = (e1)=>{
            if (e1) {
                let t = new $785da19a645c07eb$var$Mx(e1.coords.longitude, e1.coords.latitude);
                this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this._updateCircleRadiusIfNeeded();
            } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
        }, this._onUpdate = ()=>{
            this._updateCircleRadiusIfNeeded();
        }, this._onError = (e1)=>{
            if (this._map) {
                if (1 === e1.code) {
                    this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                    let e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                    this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                } else {
                    if (3 === e1.code && $785da19a645c07eb$var$kL) return;
                    this._setErrorState();
                }
                "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new $785da19a645c07eb$var$CL("error", e1)), this._finish();
            }
        }, this._finish = ()=>{
            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
        }, this._onMoveStart = (e1)=>{
            if (!this._map) return;
            let t = e1?.[0] instanceof ResizeObserverEntry;
            !e1.geolocateSource && "ACTIVE_LOCK" === this._watchState && !t && !this._map.isZooming() && (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new $785da19a645c07eb$var$SL("trackuserlocationend")), this.fire(new $785da19a645c07eb$var$SL("userlocationlostfocus")));
        }, this._setupUI = ()=>{
            this._map && (this._container.addEventListener("contextmenu", (e1)=>{
                e1.preventDefault();
            }), this._geolocateButton = $785da19a645c07eb$var$rC.create("button", "maplibregl-ctrl-geolocate", this._container), $785da19a645c07eb$var$rC.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
        }, this._finishSetupUI = (e1)=>{
            if (this._map) {
                if (!1 === e1) {
                    $785da19a645c07eb$var$wh("Geolocation support is not available so the GeolocateControl will be disabled.");
                    let e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                    this._geolocateButton.disabled = !0, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                } else {
                    let e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                    this._geolocateButton.disabled = !1, this._geolocateButton.title = e1, this._geolocateButton.setAttribute("aria-label", e1);
                }
                this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = $785da19a645c07eb$var$rC.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new $785da19a645c07eb$var$bL({
                    element: this._dotElement
                }), this._circleElement = $785da19a645c07eb$var$rC.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new $785da19a645c07eb$var$bL({
                    element: this._circleElement,
                    pitchAlignment: "map"
                }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onUpdate), this._map.on("move", this._onUpdate), this._map.on("rotate", this._onUpdate), this._map.on("pitch", this._onUpdate)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", this._onMoveStart);
            }
        }, this.options = $785da19a645c07eb$var$hh({}, $785da19a645c07eb$var$wL, e1);
    }
    onAdd(e1) {
        return this._map = e1, this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (async function(e1 = !1) {
            if (void 0 !== $785da19a645c07eb$var$dL && !e1) return $785da19a645c07eb$var$dL;
            if (void 0 === window.navigator.permissions) return $785da19a645c07eb$var$dL = !!window.navigator.geolocation, $785da19a645c07eb$var$dL;
            try {
                $785da19a645c07eb$var$dL = "denied" !== (await window.navigator.permissions.query({
                    name: "geolocation"
                })).state;
            } catch  {
                $785da19a645c07eb$var$dL = !!window.navigator.geolocation;
            }
            return $785da19a645c07eb$var$dL;
        })().then((e1)=>this._finishSetupUI(e1)), this._container;
    }
    onRemove() {
        void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("movestart", this._onMoveStart), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, $785da19a645c07eb$var$EL = 0, $785da19a645c07eb$var$kL = !1;
    }
    _isOutOfMapMaxBounds(e1) {
        let t = this._map.getMaxBounds(), i = e1.coords;
        return t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
    }
    _setErrorState() {
        switch(this._watchState){
            case "WAITING_ACTIVE":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                break;
            case "ACTIVE_LOCK":
                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                break;
            case "BACKGROUND":
                this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                break;
            case "ACTIVE_ERROR":
            case "BACKGROUND_ERROR":
            case "OFF":
            case void 0:
                break;
            default:
                throw Error(`Unexpected watchState ${this._watchState}`);
        }
    }
    _updateCircleRadiusIfNeeded() {
        let e1 = this._userLocationDotMarker.getLngLat();
        if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && e1)) return;
        let t = this._map.project(e1), i = this._map.unproject([
            t.x + 100,
            t.y
        ]), n = e1.distanceTo(i) / 100, a = 2 * this._accuracy / n;
        this._circleElement.style.width = `${a.toFixed(2)}px`, this._circleElement.style.height = `${a.toFixed(2)}px`;
    }
    trigger() {
        if (!this._setup) return $785da19a645c07eb$var$wh("Geolocate control triggered before added to a map"), !1;
        if (this.options.trackUserLocation) {
            switch(this._watchState){
                case "OFF":
                    this._watchState = "WAITING_ACTIVE", this.fire(new $785da19a645c07eb$var$SL("trackuserlocationstart"));
                    break;
                case "WAITING_ACTIVE":
                case "ACTIVE_LOCK":
                case "ACTIVE_ERROR":
                case "BACKGROUND_ERROR":
                    $785da19a645c07eb$var$EL--, $785da19a645c07eb$var$kL = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new $785da19a645c07eb$var$SL("trackuserlocationend"));
                    break;
                case "BACKGROUND":
                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new $785da19a645c07eb$var$SL("trackuserlocationstart")), this.fire(new $785da19a645c07eb$var$SL("userlocationfocus"));
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            switch(this._watchState){
                case "WAITING_ACTIVE":
                    this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                    break;
                case "ACTIVE_LOCK":
                    this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                    break;
                case "OFF":
                    break;
                default:
                    throw Error(`Unexpected watchState ${this._watchState}`);
            }
            if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
            else if (void 0 === this._geolocationWatchID) {
                let e1;
                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), $785da19a645c07eb$var$EL++, $785da19a645c07eb$var$EL > 1 ? (e1 = {
                    maximumAge: 6e5,
                    timeout: 0
                }, $785da19a645c07eb$var$kL = !0) : (e1 = this.options.positionOptions, $785da19a645c07eb$var$kL = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, e1);
            }
        } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
        return !0;
    }
    _clearWatch() {
        window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
    }
};
const $785da19a645c07eb$var$DL = {
    maxWidth: 100,
    unit: "metric"
};
var $785da19a645c07eb$var$PL = class {
    constructor(e1){
        this._onMove = ()=>{
            $785da19a645c07eb$var$IL(this._map, this._container, this.options);
        }, this.setUnit = (e1)=>{
            this.options.unit = e1, $785da19a645c07eb$var$IL(this._map, this._container, this.options);
        }, this.options = {
            ...$785da19a645c07eb$var$DL,
            ...e1
        };
    }
    getDefaultPosition() {
        return "bottom-left";
    }
    onAdd(e1) {
        return this._map = e1, this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
    }
    onRemove() {
        this._container.remove(), this._map.off("move", this._onMove), this._map = void 0;
    }
};
function $785da19a645c07eb$var$IL(e1, t, i) {
    let n = i?.maxWidth || 100, a = e1._container.clientHeight / 2, r = e1._container.clientWidth / 2, s = e1.unproject([
        r - n / 2,
        a
    ]), o = e1.unproject([
        r + n / 2,
        a
    ]), l = Math.round(e1.project(o).x - e1.project(s).x), c = Math.min(n, l, e1._container.clientWidth), u = s.distanceTo(o);
    if ("imperial" === i?.unit) {
        let i = 3.2808 * u;
        i > 5280 ? $785da19a645c07eb$var$FL(t, c, i / 5280, e1._getUIString("ScaleControl.Miles")) : $785da19a645c07eb$var$FL(t, c, i, e1._getUIString("ScaleControl.Feet"));
    } else "nautical" === i?.unit ? $785da19a645c07eb$var$FL(t, c, u / 1852, e1._getUIString("ScaleControl.NauticalMiles")) : u >= 1e3 ? $785da19a645c07eb$var$FL(t, c, u / 1e3, e1._getUIString("ScaleControl.Kilometers")) : $785da19a645c07eb$var$FL(t, c, u, e1._getUIString("ScaleControl.Meters"));
}
function $785da19a645c07eb$var$FL(e1, t, i, n) {
    let a = function(e1) {
        let t = 10 ** (`${Math.floor(e1)}`.length - 1), i = e1 / t;
        return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
            let t = 10 ** Math.ceil(-Math.log(e1) / Math.LN10);
            return Math.round(e1 * t) / t;
        }(i), t * i;
    }(i), r = a / i;
    e1.style.width = t * r + "px", e1.innerHTML = `${a}&nbsp;${n}`;
}
const $785da19a645c07eb$var$zL = {
    closeButton: !0,
    closeOnClick: !0,
    focusAfterOpen: !0,
    className: "",
    maxWidth: "240px",
    subpixelPositioning: !1,
    locationOccludedOpacity: void 0,
    padding: void 0
}, $785da19a645c07eb$var$RL = [
    "a[href]",
    "[tabindex]:not([tabindex='-1'])",
    "[contenteditable]:not([contenteditable='false'])",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].join(", ");
var $785da19a645c07eb$var$LL = class extends $785da19a645c07eb$var$nd {
}, $785da19a645c07eb$var$BL = class extends $785da19a645c07eb$var$rd {
    constructor(e1){
        super(), this._updateOpacity = ()=>{
            void 0 !== this.options.locationOccludedOpacity && (this._map._camera.transform.isLocationOccluded(this.getLngLat()) ? this._container.style.opacity = `${this.options.locationOccludedOpacity}` : this._container.style.opacity = "");
        }, this.remove = ()=>(this._content && this._content.remove(), this._container && (this._container.remove(), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousemove", this._update), this._map.off("mouseup", this._update), this._map.off("drag", this._update), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new $785da19a645c07eb$var$LL("close"))), this), this._update = (e1)=>{
            let t, i = this._lngLat || this._trackPointer;
            if (!this._map || !i || !this._content) return;
            if (!this._container) {
                if (this._container = $785da19a645c07eb$var$rC.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = $785da19a645c07eb$var$rC.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (let e1 of this.options.className.split(" "))this._container.classList.add(e1);
                this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
            }
            if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = $785da19a645c07eb$var$pL(this._lngLat, this._flatPos, this._map._camera.transform, this._trackPointer), e1 && "point" in e1 && e1.point && (t = e1.point), this._trackPointer && !t) return;
            let n = this._flatPos = this._pos = this._trackPointer && t ? t : this._map.project(this._lngLat);
            this._map.terrain && (this._flatPos = this._trackPointer && t ? t : this._map._camera.transform.locationToScreenPoint(this._lngLat));
            let a = this.options.anchor, r = $785da19a645c07eb$var$OL(this.options.offset);
            if (!a) {
                let e1, t = this._container.offsetWidth, i = this._container.offsetHeight, s = function(e1) {
                    return e1 ? {
                        top: e1.top ?? 0,
                        right: e1.right ?? 0,
                        bottom: e1.bottom ?? 0,
                        left: e1.left ?? 0
                    } : {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    };
                }(this.options.padding);
                e1 = n.y + r.bottom.y < i + s.top ? [
                    "top"
                ] : n.y > this._map._camera.transform.height - i - s.bottom ? [
                    "bottom"
                ] : [], n.x < t / 2 + s.left ? e1.push("left") : n.x > this._map._camera.transform.width - t / 2 - s.right && e1.push("right"), a = 0 === e1.length ? "bottom" : e1.join("-");
            }
            let s = n.add(r[a]);
            this.options.subpixelPositioning || (s = s.round()), this._container.style.transform = `${$785da19a645c07eb$var$mL[a]} translate(${s.x}px,${s.y}px)`, $785da19a645c07eb$var$gL(this._container, a, "popup"), this._updateOpacity();
        }, this._onClose = ()=>{
            this.remove();
        }, this.options = $785da19a645c07eb$var$hh(Object.create($785da19a645c07eb$var$zL), e1);
    }
    addTo(e1) {
        return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._map.on("terrain", this._update), this._map.on("projectiontransition", this._update), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._update), this._map.on("mouseup", this._update), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new $785da19a645c07eb$var$LL("open")), this;
    }
    isOpen() {
        return !!this._map;
    }
    getLngLat() {
        return this._lngLat;
    }
    setLngLat(e1) {
        return this._lngLat = $785da19a645c07eb$var$Mx.convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._update), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
    }
    trackPointer() {
        return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._update), this._map.on("drag", this._update), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
    }
    getElement() {
        return this._container;
    }
    setText(e1) {
        return this.setDOMContent(document.createTextNode(e1));
    }
    setHTML(e1) {
        let t, i = document.createDocumentFragment(), n = document.createElement("body");
        for(n.innerHTML = e1; t = n.firstChild, t;)i.appendChild(t);
        return this.setDOMContent(i);
    }
    getMaxWidth() {
        return this._container?.style.maxWidth;
    }
    setMaxWidth(e1) {
        return this.options.maxWidth = e1, this._update(), this;
    }
    setDOMContent(e1) {
        if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
        else this._content = $785da19a645c07eb$var$rC.create("div", "maplibregl-popup-content", this._container);
        return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
    }
    addClassName(e1) {
        return this._container && this._container.classList.add(e1), this;
    }
    removeClassName(e1) {
        return this._container && this._container.classList.remove(e1), this;
    }
    setOffset(e1) {
        return this.options.offset = e1, this._update(), this;
    }
    toggleClassName(e1) {
        if (this._container) return this._container.classList.toggle(e1);
    }
    setSubpixelPositioning(e1) {
        this.options.subpixelPositioning = e1;
    }
    setPadding(e1) {
        this.options.padding = e1, this._update();
    }
    _createCloseButton() {
        this.options.closeButton && (this._closeButton = $785da19a645c07eb$var$rC.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
    }
    _focusFirstElement() {
        if (!this.options.focusAfterOpen || !this._container) return;
        let e1 = this._container.querySelector($785da19a645c07eb$var$RL);
        e1 && e1.focus();
    }
};
function $785da19a645c07eb$var$OL(e1) {
    if (!e1) return $785da19a645c07eb$var$OL(new $785da19a645c07eb$var$Kc(0, 0));
    if ("number" == typeof e1) {
        let t = Math.round(Math.abs(e1) / Math.SQRT2);
        return {
            center: new $785da19a645c07eb$var$Kc(0, 0),
            top: new $785da19a645c07eb$var$Kc(0, e1),
            "top-left": new $785da19a645c07eb$var$Kc(t, t),
            "top-right": new $785da19a645c07eb$var$Kc(-t, t),
            bottom: new $785da19a645c07eb$var$Kc(0, -e1),
            "bottom-left": new $785da19a645c07eb$var$Kc(t, -t),
            "bottom-right": new $785da19a645c07eb$var$Kc(-t, -t),
            left: new $785da19a645c07eb$var$Kc(e1, 0),
            right: new $785da19a645c07eb$var$Kc(-e1, 0)
        };
    }
    if (e1 instanceof $785da19a645c07eb$var$Kc || Array.isArray(e1)) {
        let t = $785da19a645c07eb$var$Kc.convert(e1);
        return {
            center: t,
            top: t,
            "top-left": t,
            "top-right": t,
            bottom: t,
            "bottom-left": t,
            "bottom-right": t,
            left: t,
            right: t
        };
    }
    return {
        center: $785da19a645c07eb$var$Kc.convert(e1.center || [
            0,
            0
        ]),
        top: $785da19a645c07eb$var$Kc.convert(e1.top || [
            0,
            0
        ]),
        "top-left": $785da19a645c07eb$var$Kc.convert(e1["top-left"] || [
            0,
            0
        ]),
        "top-right": $785da19a645c07eb$var$Kc.convert(e1["top-right"] || [
            0,
            0
        ]),
        bottom: $785da19a645c07eb$var$Kc.convert(e1.bottom || [
            0,
            0
        ]),
        "bottom-left": $785da19a645c07eb$var$Kc.convert(e1["bottom-left"] || [
            0,
            0
        ]),
        "bottom-right": $785da19a645c07eb$var$Kc.convert(e1["bottom-right"] || [
            0,
            0
        ]),
        left: $785da19a645c07eb$var$Kc.convert(e1.left || [
            0,
            0
        ]),
        right: $785da19a645c07eb$var$Kc.convert(e1.right || [
            0,
            0
        ])
    };
}
var $785da19a645c07eb$var$UL = Uint8Array, $785da19a645c07eb$var$NL = Uint16Array, $785da19a645c07eb$var$jL = Int32Array, $785da19a645c07eb$var$VL = new $785da19a645c07eb$var$UL([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), $785da19a645c07eb$var$qL = new $785da19a645c07eb$var$UL([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), $785da19a645c07eb$var$GL = new $785da19a645c07eb$var$UL([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), $785da19a645c07eb$var$HL = function(e1, t) {
    for(var i = new $785da19a645c07eb$var$NL(31), n = 0; n < 31; ++n)i[n] = t += 1 << e1[n - 1];
    var a = new $785da19a645c07eb$var$jL(i[30]);
    for(n = 1; n < 30; ++n)for(var r = i[n]; r < i[n + 1]; ++r)a[r] = r - i[n] << 5 | n;
    return {
        b: i,
        r: a
    };
}, $785da19a645c07eb$var$WL = $785da19a645c07eb$var$HL($785da19a645c07eb$var$VL, 2), $785da19a645c07eb$var$ZL = $785da19a645c07eb$var$WL.b, $785da19a645c07eb$var$KL = $785da19a645c07eb$var$WL.r;
$785da19a645c07eb$var$ZL[28] = 258, $785da19a645c07eb$var$KL[258] = 28;
for(var $785da19a645c07eb$var$XL = $785da19a645c07eb$var$HL($785da19a645c07eb$var$qL, 0).b, $785da19a645c07eb$var$QL = new $785da19a645c07eb$var$NL(32768), $785da19a645c07eb$var$YL = 0; $785da19a645c07eb$var$YL < 32768; ++$785da19a645c07eb$var$YL){
    var $785da19a645c07eb$var$JL = (43690 & $785da19a645c07eb$var$YL) >> 1 | (21845 & $785da19a645c07eb$var$YL) << 1;
    $785da19a645c07eb$var$JL = (61680 & ($785da19a645c07eb$var$JL = (52428 & $785da19a645c07eb$var$JL) >> 2 | (13107 & $785da19a645c07eb$var$JL) << 2)) >> 4 | (3855 & $785da19a645c07eb$var$JL) << 4, $785da19a645c07eb$var$QL[$785da19a645c07eb$var$YL] = ((65280 & $785da19a645c07eb$var$JL) >> 8 | (255 & $785da19a645c07eb$var$JL) << 8) >> 1;
}
var $785da19a645c07eb$var$$L = function(e1, t, i) {
    for(var n = e1.length, a = 0, r = new $785da19a645c07eb$var$NL(t); a < n; ++a)e1[a] && ++r[e1[a] - 1];
    var s, o = new $785da19a645c07eb$var$NL(t);
    for(a = 1; a < t; ++a)o[a] = o[a - 1] + r[a - 1] << 1;
    if (i) {
        s = new $785da19a645c07eb$var$NL(1 << t);
        var l = 15 - t;
        for(a = 0; a < n; ++a)if (e1[a]) for(var c = a << 4 | e1[a], u = t - e1[a], h = o[e1[a] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[$785da19a645c07eb$var$QL[h] >> l] = c;
    } else for(s = new $785da19a645c07eb$var$NL(n), a = 0; a < n; ++a)e1[a] && (s[a] = $785da19a645c07eb$var$QL[o[e1[a] - 1]++] >> 15 - e1[a]);
    return s;
}, $785da19a645c07eb$var$eB = new $785da19a645c07eb$var$UL(288);
for($785da19a645c07eb$var$YL = 0; $785da19a645c07eb$var$YL < 144; ++$785da19a645c07eb$var$YL)$785da19a645c07eb$var$eB[$785da19a645c07eb$var$YL] = 8;
for($785da19a645c07eb$var$YL = 144; $785da19a645c07eb$var$YL < 256; ++$785da19a645c07eb$var$YL)$785da19a645c07eb$var$eB[$785da19a645c07eb$var$YL] = 9;
for($785da19a645c07eb$var$YL = 256; $785da19a645c07eb$var$YL < 280; ++$785da19a645c07eb$var$YL)$785da19a645c07eb$var$eB[$785da19a645c07eb$var$YL] = 7;
for($785da19a645c07eb$var$YL = 280; $785da19a645c07eb$var$YL < 288; ++$785da19a645c07eb$var$YL)$785da19a645c07eb$var$eB[$785da19a645c07eb$var$YL] = 8;
var $785da19a645c07eb$var$tB = new $785da19a645c07eb$var$UL(32);
for($785da19a645c07eb$var$YL = 0; $785da19a645c07eb$var$YL < 32; ++$785da19a645c07eb$var$YL)$785da19a645c07eb$var$tB[$785da19a645c07eb$var$YL] = 5;
var $785da19a645c07eb$var$iB = $785da19a645c07eb$var$$L($785da19a645c07eb$var$eB, 9, 1), $785da19a645c07eb$var$nB = $785da19a645c07eb$var$$L($785da19a645c07eb$var$tB, 5, 1), $785da19a645c07eb$var$aB = function(e1) {
    for(var t = e1[0], i = 1; i < e1.length; ++i)e1[i] > t && (t = e1[i]);
    return t;
}, $785da19a645c07eb$var$rB = function(e1, t, i) {
    var n = t / 8 | 0;
    return (e1[n] | e1[n + 1] << 8) >> (7 & t) & i;
}, $785da19a645c07eb$var$sB = function(e1, t) {
    var i = t / 8 | 0;
    return (e1[i] | e1[i + 1] << 8 | e1[i + 2] << 16) >> (7 & t);
}, $785da19a645c07eb$var$oB = function(e1) {
    return (e1 + 7) / 8 | 0;
}, $785da19a645c07eb$var$lB = [
    "unexpected EOF",
    "invalid block type",
    "invalid length/literal",
    "invalid distance",
    "stream finished",
    "no stream handler",
    ,
    "no callback",
    "invalid UTF-8 data",
    "extra field too long",
    "date not in range 1980-2099",
    "filename too long",
    "stream finishing",
    "invalid zip data"
], $785da19a645c07eb$var$cB = function(e1, t, i) {
    var n = new Error(t || $785da19a645c07eb$var$lB[e1]);
    if (n.code = e1, Error.captureStackTrace && Error.captureStackTrace(n, $785da19a645c07eb$var$cB), !i) throw n;
    return n;
}, $785da19a645c07eb$var$uB = function(e1, t, i, n) {
    var a = e1.length;
    if (!a || t.f && !t.l) return i || new $785da19a645c07eb$var$UL(0);
    var r = !i, s = r || 2 != t.i, o = t.i;
    r && (i = new $785da19a645c07eb$var$UL(3 * a));
    var l = function(e1) {
        var t = i.length;
        if (e1 > t) {
            var n = new $785da19a645c07eb$var$UL(Math.max(2 * t, e1));
            n.set(i), i = n;
        }
    }, c = t.f || 0, u = t.p || 0, h = t.b || 0, d = t.l, p = t.d, m = t.m, g = t.n, f = 8 * a;
    do {
        if (!d) {
            c = $785da19a645c07eb$var$rB(e1, u, 1);
            var A = $785da19a645c07eb$var$rB(e1, u + 1, 3);
            if (u += 3, !A) {
                var _ = e1[(T = $785da19a645c07eb$var$oB(u) + 4) - 4] | e1[T - 3] << 8, v = T + _;
                if (v > a) {
                    o && $785da19a645c07eb$var$cB(0);
                    break;
                }
                s && l(h + _), i.set(e1.subarray(T, v), h), t.b = h += _, t.p = u = 8 * v, t.f = c;
                continue;
            }
            if (1 == A) d = $785da19a645c07eb$var$iB, p = $785da19a645c07eb$var$nB, m = 9, g = 5;
            else if (2 == A) {
                var y = $785da19a645c07eb$var$rB(e1, u, 31) + 257, x = $785da19a645c07eb$var$rB(e1, u + 10, 15) + 4, b = y + $785da19a645c07eb$var$rB(e1, u + 5, 31) + 1;
                u += 14;
                for(var w = new $785da19a645c07eb$var$UL(b), E = new $785da19a645c07eb$var$UL(19), k = 0; k < x; ++k)E[$785da19a645c07eb$var$GL[k]] = $785da19a645c07eb$var$rB(e1, u + 3 * k, 7);
                u += 3 * x;
                var S = $785da19a645c07eb$var$aB(E), M = (1 << S) - 1, C = $785da19a645c07eb$var$$L(E, S, 1);
                for(k = 0; k < b;){
                    var T, D = C[$785da19a645c07eb$var$rB(e1, u, M)];
                    if (u += 15 & D, (T = D >> 4) < 16) w[k++] = T;
                    else {
                        var P = 0, I = 0;
                        for(16 == T ? (I = 3 + $785da19a645c07eb$var$rB(e1, u, 3), u += 2, P = w[k - 1]) : 17 == T ? (I = 3 + $785da19a645c07eb$var$rB(e1, u, 7), u += 3) : 18 == T && (I = 11 + $785da19a645c07eb$var$rB(e1, u, 127), u += 7); I--;)w[k++] = P;
                    }
                }
                var F = w.subarray(0, y), z = w.subarray(y);
                m = $785da19a645c07eb$var$aB(F), g = $785da19a645c07eb$var$aB(z), d = $785da19a645c07eb$var$$L(F, m, 1), p = $785da19a645c07eb$var$$L(z, g, 1);
            } else $785da19a645c07eb$var$cB(1);
            if (u > f) {
                o && $785da19a645c07eb$var$cB(0);
                break;
            }
        }
        s && l(h + 131072);
        for(var R = (1 << m) - 1, L1 = (1 << g) - 1, B = u;; B = u){
            var O = (P = d[$785da19a645c07eb$var$sB(e1, u) & R]) >> 4;
            if ((u += 15 & P) > f) {
                o && $785da19a645c07eb$var$cB(0);
                break;
            }
            if (P || $785da19a645c07eb$var$cB(2), O < 256) i[h++] = O;
            else {
                if (256 == O) {
                    B = u, d = null;
                    break;
                }
                var U = O - 254;
                if (O > 264) {
                    var N = $785da19a645c07eb$var$VL[k = O - 257];
                    U = $785da19a645c07eb$var$rB(e1, u, (1 << N) - 1) + $785da19a645c07eb$var$ZL[k], u += N;
                }
                var j = p[$785da19a645c07eb$var$sB(e1, u) & L1], V = j >> 4;
                j || $785da19a645c07eb$var$cB(3), u += 15 & j;
                z = $785da19a645c07eb$var$XL[V];
                if (V > 3) {
                    N = $785da19a645c07eb$var$qL[V];
                    z += $785da19a645c07eb$var$sB(e1, u) & (1 << N) - 1, u += N;
                }
                if (u > f) {
                    o && $785da19a645c07eb$var$cB(0);
                    break;
                }
                s && l(h + 131072);
                var q = h + U;
                if (h < z) {
                    var G = 0 - z, H = Math.min(z, q);
                    for(G + h < 0 && $785da19a645c07eb$var$cB(3); h < H; ++h)i[h] = n[G + h];
                }
                for(; h < q; ++h)i[h] = i[h - z];
            }
        }
        t.l = d, t.p = B, t.b = h, t.f = c, d && (c = 1, t.m = m, t.d = p, t.n = g);
    }while (!c);
    return h != i.length && r ? function(e1, t, i) {
        return (null == i || i > e1.length) && (i = e1.length), new $785da19a645c07eb$var$UL(e1.subarray(t, i));
    }(i, 0, h) : i.subarray(0, h);
}, $785da19a645c07eb$var$hB = new $785da19a645c07eb$var$UL(0);
function $785da19a645c07eb$var$dB(e1, t) {
    var i = function(e1) {
        31 == e1[0] && 139 == e1[1] && 8 == e1[2] || $785da19a645c07eb$var$cB(6, "invalid gzip data");
        var t = e1[3], i = 10;
        4 & t && (i += 2 + (e1[10] | e1[11] << 8));
        for(var n = (t >> 3 & 1) + (t >> 4 & 1); n > 0; n -= !e1[i++]);
        return i + (2 & t);
    }(e1);
    return i + 8 > e1.length && $785da19a645c07eb$var$cB(6, "invalid gzip data"), $785da19a645c07eb$var$uB(e1.subarray(i, -8), {
        i: 2
    }, new $785da19a645c07eb$var$UL(function(e1) {
        var t = e1.length;
        return (e1[t - 4] | e1[t - 3] << 8 | e1[t - 2] << 16 | e1[t - 1] << 24) >>> 0;
    }(e1)), t);
}
function $785da19a645c07eb$var$pB(e1, t) {
    return $785da19a645c07eb$var$uB(e1.subarray(function(e1) {
        return (8 != (15 & e1[0]) || e1[0] >> 4 > 7 || (e1[0] << 8 | e1[1]) % 31) && $785da19a645c07eb$var$cB(6, "invalid zlib data"), 1 == (e1[1] >> 5 & 1) && $785da19a645c07eb$var$cB(6, "invalid zlib data: " + (32 & e1[1] ? "need" : "unexpected") + " dictionary"), 2 + (e1[1] >> 3 & 4);
    }(e1), -4), {
        i: 2
    }, t, t);
}
function $785da19a645c07eb$var$mB(e1, t) {
    return 31 == e1[0] && 139 == e1[1] && 8 == e1[2] ? $785da19a645c07eb$var$dB(e1, t) : 8 != (15 & e1[0]) || e1[0] >> 4 > 7 || (e1[0] << 8 | e1[1]) % 31 ? function(e1, t) {
        return $785da19a645c07eb$var$uB(e1, {
            i: 2
        }, t, t);
    }(e1, t) : $785da19a645c07eb$var$pB(e1, t);
}
var $785da19a645c07eb$var$gB = "undefined" != typeof TextDecoder && new TextDecoder;
try {
    $785da19a645c07eb$var$gB.decode($785da19a645c07eb$var$hB, {
        stream: !0
    });
} catch (w2) {}
var $785da19a645c07eb$var$fB = Object.defineProperty, $785da19a645c07eb$var$AB = Math.pow, $785da19a645c07eb$var$_B = (e1, t)=>$785da19a645c07eb$var$fB(e1, "name", {
        value: t,
        configurable: !0
    }), $785da19a645c07eb$var$vB = (e1, t, i)=>new Promise((n, a)=>{
        var r = (e1)=>{
            try {
                o(i.next(e1));
            } catch (e1) {
                a(e1);
            }
        }, s = (e1)=>{
            try {
                o(i.throw(e1));
            } catch (e1) {
                a(e1);
            }
        }, o = (e1)=>e1.done ? n(e1.value) : Promise.resolve(e1.value).then(r, s);
        o((i = i.apply(e1, t)).next());
    });
$785da19a645c07eb$var$_B((e1, t)=>{
    let i = !1, n = "", a = L.GridLayer.extend({
        createTile: $785da19a645c07eb$var$_B((t, a)=>{
            let r = document.createElement("img"), s = new AbortController, o = s.signal;
            return r.cancel = ()=>{
                s.abort();
            }, i || (e1.getHeader().then((e1)=>{
                1 === e1.tileType || 6 === e1.tileType ? console.error("Error: archive contains vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.") : 2 === e1.tileType ? n = "image/png" : 3 === e1.tileType ? n = "image/jpeg" : 4 === e1.tileType ? n = "image/webp" : 5 === e1.tileType && (n = "image/avif");
            }), i = !0), e1.getZxy(t.z, t.x, t.y, o).then((e1)=>{
                if (e1) {
                    let t = new Blob([
                        e1.data
                    ], {
                        type: n
                    }), i = window.URL.createObjectURL(t);
                    r.src = i;
                } else r.style.display = "none";
                r.cancel = void 0, a(void 0, r);
            }).catch((e1)=>{
                if ("AbortError" !== e1.name) throw e1;
            }), r;
        }, "createTile"),
        _removeTile: $785da19a645c07eb$var$_B(function(e1) {
            let t = this._tiles[e1];
            t && (t.el.cancel && t.el.cancel(), t.el.src && window.URL.revokeObjectURL(t.el.src), t.el.width = 0, t.el.height = 0, t.el.deleted = !0, L.DomUtil.remove(t.el), delete this._tiles[e1], this.fire("tileunload", {
                tile: t.el,
                coords: this._keyToTileCoords(e1)
            }));
        }, "_removeTile")
    });
    return new a(t);
}, "leafletRasterLayer");
var $785da19a645c07eb$var$yB = $785da19a645c07eb$var$_B((e1)=>(t, i)=>{
        if (i instanceof AbortController) return e1(t, i);
        let n = new AbortController;
        return e1(t, n).then((e1)=>i(void 0, e1.data, e1.cacheControl || "", e1.expires || ""), (e1)=>i(e1)).catch((e1)=>i(e1)), {
            cancel: $785da19a645c07eb$var$_B(()=>n.abort(), "cancel")
        };
    }, "v3compat"), $785da19a645c07eb$var$xB = class {
    constructor(e1){
        this.tilev4 = $785da19a645c07eb$var$_B((e1, t)=>$785da19a645c07eb$var$vB(this, null, function*() {
                if ("json" === e1.type) {
                    let i = e1.url.substr(10), n = this.tiles.get(i);
                    if (n || (n = new $785da19a645c07eb$var$WB(i), this.tiles.set(i, n)), this.metadata) {
                        let i = yield n.getTileJson(e1.url);
                        return t.signal.throwIfAborted(), {
                            data: i
                        };
                    }
                    let a = yield n.getHeader();
                    return t.signal.throwIfAborted(), (a.minLon >= a.maxLon || a.minLat >= a.maxLat) && console.error(`Bounds of PMTiles archive ${a.minLon},${a.minLat},${a.maxLon},${a.maxLat} are not valid.`), {
                        data: {
                            tiles: [
                                `${e1.url}/{z}/{x}/{y}`
                            ],
                            minzoom: a.minZoom,
                            maxzoom: a.maxZoom,
                            bounds: [
                                a.minLon,
                                a.minLat,
                                a.maxLon,
                                a.maxLat
                            ]
                        }
                    };
                }
                let i = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), n = e1.url.match(i);
                if (!n) throw new Error("Invalid PMTiles protocol URL");
                let a = n[1], r = this.tiles.get(a);
                r || (r = new $785da19a645c07eb$var$WB(a), this.tiles.set(a, r));
                let s = n[2], o = n[3], l = n[4], c = yield null == r ? void 0 : r.getZxy(+s, +o, +l, t.signal);
                if (t.signal.throwIfAborted(), c) return {
                    data: new Uint8Array(c.data),
                    cacheControl: c.cacheControl,
                    expires: c.expires
                };
                let u = yield r.getHeader();
                if (1 === u.tileType || 6 === u.tileType) {
                    if (this.errorOnMissingTile) throw new Error("Tile not found.");
                    return {
                        data: new Uint8Array
                    };
                }
                return {
                    data: null
                };
            }), "tilev4"), this.tile = $785da19a645c07eb$var$yB(this.tilev4), this.tiles = new Map, this.metadata = (null == e1 ? void 0 : e1.metadata) || !1, this.errorOnMissingTile = (null == e1 ? void 0 : e1.errorOnMissingTile) || !1;
    }
    add(e1) {
        this.tiles.set(e1.source.getKey(), e1);
    }
    get(e1) {
        return this.tiles.get(e1);
    }
};
$785da19a645c07eb$var$_B($785da19a645c07eb$var$xB, "Protocol");
var $785da19a645c07eb$var$bB = $785da19a645c07eb$var$xB;
function $785da19a645c07eb$var$wB(e1, t) {
    return 4294967296 * (t >>> 0) + (e1 >>> 0);
}
function $785da19a645c07eb$var$EB(e1, t) {
    let i = t.buf, n = i[t.pos++], a = (112 & n) >> 4;
    if (n < 128 || (n = i[t.pos++], a |= (127 & n) << 3, n < 128) || (n = i[t.pos++], a |= (127 & n) << 10, n < 128) || (n = i[t.pos++], a |= (127 & n) << 17, n < 128) || (n = i[t.pos++], a |= (127 & n) << 24, n < 128) || (n = i[t.pos++], a |= (1 & n) << 31, n < 128)) return $785da19a645c07eb$var$wB(e1, a);
    throw new Error("Expected varint not more than 10 bytes");
}
function $785da19a645c07eb$var$kB(e1) {
    let t = e1.buf, i = t[e1.pos++], n = 127 & i;
    return i < 128 || (i = t[e1.pos++], n |= (127 & i) << 7, i < 128) || (i = t[e1.pos++], n |= (127 & i) << 14, i < 128) || (i = t[e1.pos++], n |= (127 & i) << 21, i < 128) ? n : (i = t[e1.pos], n |= (15 & i) << 28, $785da19a645c07eb$var$EB(n, e1));
}
function $785da19a645c07eb$var$SB(e1, t, i, n, a) {
    return 0 === a ? 0 !== n ? [
        e1 - 1 - i,
        e1 - 1 - t
    ] : [
        i,
        t
    ] : [
        t,
        i
    ];
}
function $785da19a645c07eb$var$MB(e1, t, i) {
    if (e1 > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
    if (t >= 1 << e1 || i >= 1 << e1) throw new Error("tile x/y outside zoom level bounds");
    let n = ((1 << e1) * (1 << e1) - 1) / 3, a = e1 - 1, [r, s] = [
        t,
        i
    ];
    for(let e1 = 1 << a; e1 > 0; e1 >>= 1){
        let t = r & e1, i = s & e1;
        n += (3 * t ^ i) * (1 << a), [r, s] = $785da19a645c07eb$var$SB(e1, r, s, t, i), a--;
    }
    return n;
}
function $785da19a645c07eb$var$CB(e1) {
    let t = 3 * e1 + 1;
    return t < 4294967296 ? 31 - Math.clz32(t) : 63 - Math.clz32(t / 4294967296);
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$wB, "toNum"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$EB, "readVarintRemainder"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$kB, "readVarint"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$SB, "rotate"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$MB, "zxyToTileId"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$CB, "tileIdToZ"), $785da19a645c07eb$var$_B(function(e1) {
    let t = $785da19a645c07eb$var$CB(e1) >> 1;
    if (t > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
    let i = e1 - ((1 << t) * (1 << t) - 1) / 3, n = 0, a = 0, r = 1 << t;
    for(let e1 = 1; e1 < r; e1 <<= 1){
        let t = e1 & i / 2, r = e1 & (i ^ t);
        [n, a] = $785da19a645c07eb$var$SB(e1, n, a, t, r), i /= 2, n += t, a += r;
    }
    return [
        t,
        n,
        a
    ];
}, "tileIdToZxy");
var $785da19a645c07eb$var$TB = ((e1)=>(e1[e1.Unknown = 0] = "Unknown", e1[e1.None = 1] = "None", e1[e1.Gzip = 2] = "Gzip", e1[e1.Brotli = 3] = "Brotli", e1[e1.Zstd = 4] = "Zstd", e1))($785da19a645c07eb$var$TB || {});
function $785da19a645c07eb$var$DB(e1, t) {
    return $785da19a645c07eb$var$vB(this, null, function*() {
        if (1 === t || 0 === t) return e1;
        if (2 === t) {
            if (void 0 === globalThis.DecompressionStream) return $785da19a645c07eb$var$mB(new Uint8Array(e1));
            let t = new Response(e1).body;
            if (!t) throw new Error("Failed to read response stream");
            let i = t.pipeThrough(new globalThis.DecompressionStream("gzip"));
            return new Response(i).arrayBuffer();
        }
        throw new Error("Compression method not supported");
    });
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$DB, "defaultDecompress");
var $785da19a645c07eb$var$PB = ((e1)=>(e1[e1.Unknown = 0] = "Unknown", e1[e1.Mvt = 1] = "Mvt", e1[e1.Png = 2] = "Png", e1[e1.Jpeg = 3] = "Jpeg", e1[e1.Webp = 4] = "Webp", e1[e1.Avif = 5] = "Avif", e1[e1.Mlt = 6] = "Mlt", e1))($785da19a645c07eb$var$PB || {});
function $785da19a645c07eb$var$IB(e1) {
    return 1 === e1 ? ".mvt" : 2 === e1 ? ".png" : 3 === e1 ? ".jpg" : 4 === e1 ? ".webp" : 5 === e1 ? ".avif" : 6 === e1 ? ".mlt" : "";
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$IB, "tileTypeExt");
function $785da19a645c07eb$var$FB(e1, t) {
    let i = 0, n = e1.length - 1;
    for(; i <= n;){
        let a = n + i >> 1, r = t - e1[a].tileId;
        if (r > 0) i = a + 1;
        else {
            if (!(r < 0)) return e1[a];
            n = a - 1;
        }
    }
    return n >= 0 && (0 === e1[n].runLength || t - e1[n].tileId < e1[n].runLength) ? e1[n] : null;
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$FB, "findTile");
$785da19a645c07eb$var$_B(class {
    constructor(e1){
        this.file = e1;
    }
    getKey() {
        return this.file.name;
    }
    getBytes(e1, t) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            return {
                data: yield this.file.slice(e1, e1 + t).arrayBuffer()
            };
        });
    }
}, "FileSource");
var $785da19a645c07eb$var$zB = class {
    constructor(e1, t = new Headers, i){
        var n, a;
        this.url = e1, this.customHeaders = t, this.credentials = i, this.mustReload = !1;
        let r = "";
        "navigator" in globalThis && (r = null != (a = null == (n = globalThis.navigator) ? void 0 : n.userAgent) ? a : "");
        let s = r.indexOf("Windows") > -1, o = /Chrome|Chromium|Edg|OPR|Brave/.test(r);
        this.chromeWindowsNoCache = !1, s && o && (this.chromeWindowsNoCache = !0);
    }
    getKey() {
        return this.url;
    }
    setHeaders(e1) {
        this.customHeaders = e1;
    }
    getBytes(e1, t, i, n) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let a, r;
            i ? r = i : (a = new AbortController, r = a.signal);
            let s, o = new Headers(this.customHeaders);
            o.set("range", `bytes=${e1}-${e1 + t - 1}`), this.mustReload ? s = "reload" : this.chromeWindowsNoCache && (s = "no-store");
            let l = yield fetch(this.url, {
                signal: r,
                cache: s,
                headers: o,
                credentials: this.credentials
            });
            if (0 === e1 && 416 === l.status) {
                let e1 = l.headers.get("Content-Range");
                if (!e1 || !e1.startsWith("bytes */")) throw new Error("Missing content-length on 416 response");
                let t = +e1.substr(8);
                o.set("range", "bytes=0-" + (t - 1)), l = yield fetch(this.url, {
                    signal: r,
                    cache: "reload",
                    headers: o,
                    credentials: this.credentials
                });
            }
            let c = l.headers.get("Etag");
            if (null != c && c.startsWith("W/") && (c = null), 416 === l.status || n && c && c !== n) throw this.mustReload = !0, new $785da19a645c07eb$var$NB(`Server returned non-matching ETag ${n} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
            if (l.status >= 300) throw new Error(`Bad response code: ${l.status}`);
            let u = l.headers.get("Content-Length");
            if (200 === l.status && (!u || +u > t)) throw a && a.abort(), new Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
            return {
                data: yield l.arrayBuffer(),
                etag: c || void 0,
                cacheControl: l.headers.get("Cache-Control") || void 0,
                expires: l.headers.get("Expires") || void 0
            };
        });
    }
};
$785da19a645c07eb$var$_B($785da19a645c07eb$var$zB, "FetchSource");
var $785da19a645c07eb$var$RB = $785da19a645c07eb$var$zB;
function $785da19a645c07eb$var$LB(e1, t) {
    let i = e1.getUint32(t + 4, !0), n = e1.getUint32(t + 0, !0);
    return i * $785da19a645c07eb$var$AB(2, 32) + n;
}
function $785da19a645c07eb$var$BB(e1, t) {
    let i = new DataView(e1), n = i.getUint8(7);
    if (n > 3) throw new Error(`Archive is spec version ${n} but this library supports up to spec version 3`);
    return {
        specVersion: n,
        rootDirectoryOffset: $785da19a645c07eb$var$LB(i, 8),
        rootDirectoryLength: $785da19a645c07eb$var$LB(i, 16),
        jsonMetadataOffset: $785da19a645c07eb$var$LB(i, 24),
        jsonMetadataLength: $785da19a645c07eb$var$LB(i, 32),
        leafDirectoryOffset: $785da19a645c07eb$var$LB(i, 40),
        leafDirectoryLength: $785da19a645c07eb$var$LB(i, 48),
        tileDataOffset: $785da19a645c07eb$var$LB(i, 56),
        tileDataLength: $785da19a645c07eb$var$LB(i, 64),
        numAddressedTiles: $785da19a645c07eb$var$LB(i, 72),
        numTileEntries: $785da19a645c07eb$var$LB(i, 80),
        numTileContents: $785da19a645c07eb$var$LB(i, 88),
        clustered: 1 === i.getUint8(96),
        internalCompression: i.getUint8(97),
        tileCompression: i.getUint8(98),
        tileType: i.getUint8(99),
        minZoom: i.getUint8(100),
        maxZoom: i.getUint8(101),
        minLon: i.getInt32(102, !0) / 1e7,
        minLat: i.getInt32(106, !0) / 1e7,
        maxLon: i.getInt32(110, !0) / 1e7,
        maxLat: i.getInt32(114, !0) / 1e7,
        centerZoom: i.getUint8(118),
        centerLon: i.getInt32(119, !0) / 1e7,
        centerLat: i.getInt32(123, !0) / 1e7,
        etag: t
    };
}
function $785da19a645c07eb$var$OB(e1) {
    let t = {
        buf: new Uint8Array(e1),
        pos: 0
    }, i = $785da19a645c07eb$var$kB(t), n = [], a = 0;
    for(let e1 = 0; e1 < i; e1++){
        let e1 = $785da19a645c07eb$var$kB(t);
        n.push({
            tileId: a + e1,
            offset: 0,
            length: 0,
            runLength: 1
        }), a += e1;
    }
    for(let e1 = 0; e1 < i; e1++)n[e1].runLength = $785da19a645c07eb$var$kB(t);
    for(let e1 = 0; e1 < i; e1++)n[e1].length = $785da19a645c07eb$var$kB(t);
    for(let e1 = 0; e1 < i; e1++){
        let i = $785da19a645c07eb$var$kB(t);
        n[e1].offset = 0 === i && e1 > 0 ? n[e1 - 1].offset + n[e1 - 1].length : i - 1;
    }
    return n;
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$LB, "getUint64"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$BB, "bytesToHeader"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$OB, "deserializeIndex");
var $785da19a645c07eb$var$UB = class extends Error {
};
$785da19a645c07eb$var$_B($785da19a645c07eb$var$UB, "EtagMismatch");
var $785da19a645c07eb$var$NB = $785da19a645c07eb$var$UB;
function $785da19a645c07eb$var$jB(e1, t) {
    return $785da19a645c07eb$var$vB(this, null, function*() {
        let i = yield e1.getBytes(0, 16384);
        if (19792 !== new DataView(i.data).getUint16(0, !0)) throw new Error("Wrong magic number for PMTiles archive");
        let n = $785da19a645c07eb$var$BB(i.data.slice(0, 127), i.etag), a = i.data.slice(n.rootDirectoryOffset, n.rootDirectoryOffset + n.rootDirectoryLength), r = `${e1.getKey()}|${n.etag || ""}|${n.rootDirectoryOffset}|${n.rootDirectoryLength}`, s = $785da19a645c07eb$var$OB((yield t(a, n.internalCompression)));
        return [
            n,
            [
                r,
                s.length,
                s
            ]
        ];
    });
}
function $785da19a645c07eb$var$VB(e1, t, i, n, a, r) {
    return $785da19a645c07eb$var$vB(this, null, function*() {
        let s = yield e1.getBytes(i, n, r, a.etag), o = $785da19a645c07eb$var$OB((yield t(s.data, a.internalCompression)));
        if (0 === o.length) throw new Error("Empty directory is invalid");
        return o;
    });
}
$785da19a645c07eb$var$_B($785da19a645c07eb$var$jB, "getHeaderAndRoot"), $785da19a645c07eb$var$_B($785da19a645c07eb$var$VB, "getDirectory");
$785da19a645c07eb$var$_B(class {
    constructor(e1 = 100, t = !0, i = $785da19a645c07eb$var$DB){
        this.cache = new Map, this.maxCacheEntries = e1, this.counter = 1, this.decompress = i;
    }
    getHeader(e1) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let t = e1.getKey(), i = this.cache.get(t);
            if (i) return i.lastUsed = this.counter++, i.data;
            let n = yield $785da19a645c07eb$var$jB(e1, this.decompress);
            return n[1] && this.cache.set(n[1][0], {
                lastUsed: this.counter++,
                data: n[1][2]
            }), this.cache.set(t, {
                lastUsed: this.counter++,
                data: n[0]
            }), this.prune(), n[0];
        });
    }
    getDirectory(e1, t, i, n, a) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let r = `${e1.getKey()}|${n.etag || ""}|${t}|${i}`, s = this.cache.get(r);
            if (s) return s.lastUsed = this.counter++, s.data;
            let o = yield $785da19a645c07eb$var$VB(e1, this.decompress, t, i, n, a);
            return this.cache.set(r, {
                lastUsed: this.counter++,
                data: o
            }), this.prune(), o;
        });
    }
    prune() {
        if (this.cache.size > this.maxCacheEntries) {
            let e1, t = 1 / 0;
            this.cache.forEach((i, n)=>{
                i.lastUsed < t && (t = i.lastUsed, e1 = n);
            }), e1 && this.cache.delete(e1);
        }
    }
    invalidate(e1) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            this.cache.delete(e1.getKey());
        });
    }
}, "ResolvedValueCache");
var $785da19a645c07eb$var$qB = class {
    constructor(e1 = 100, t = !0, i = $785da19a645c07eb$var$DB){
        this.cache = new Map, this.invalidations = new Map, this.pendingFetches = new Map, this.maxCacheEntries = e1, this.counter = 1, this.decompress = i;
    }
    getHeader(e1) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let t = e1.getKey(), i = this.cache.get(t);
            if (i) return i.lastUsed = this.counter++, yield i.data;
            let n = new Promise((t, i)=>{
                $785da19a645c07eb$var$jB(e1, this.decompress).then((e1)=>{
                    e1[1] && this.cache.set(e1[1][0], {
                        lastUsed: this.counter++,
                        data: Promise.resolve(e1[1][2])
                    }), t(e1[0]), this.prune();
                }).catch((e1)=>{
                    i(e1);
                });
            });
            return this.cache.set(t, {
                lastUsed: this.counter++,
                data: n
            }), n;
        });
    }
    trackSignal(e1, t, i) {
        t.refs++, i.addEventListener("abort", ()=>{
            --t.refs <= 0 && this.pendingFetches.get(e1) === t && (t.controller.abort(), this.cache.delete(e1), this.pendingFetches.delete(e1));
        }, {
            once: !0
        });
    }
    getDirectory(e1, t, i, n, a) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let r = `${e1.getKey()}|${n.etag || ""}|${t}|${i}`, s = this.cache.get(r);
            if (s) {
                s.lastUsed = this.counter++;
                let e1 = this.pendingFetches.get(r);
                return e1 && this.trackSignal(r, e1, null != a ? a : (new AbortController).signal), yield s.data;
            }
            let o = new AbortController, l = {
                controller: o,
                refs: 0
            };
            this.trackSignal(r, l, null != a ? a : (new AbortController).signal), this.pendingFetches.set(r, l);
            let c = new Promise((a, s)=>{
                $785da19a645c07eb$var$VB(e1, this.decompress, t, i, n, o.signal).then((e1)=>{
                    this.pendingFetches.delete(r), a(e1), this.prune();
                }).catch((e1)=>{
                    s(e1);
                });
            });
            return this.cache.set(r, {
                lastUsed: this.counter++,
                data: c
            }), c;
        });
    }
    prune() {
        if (this.cache.size >= this.maxCacheEntries) {
            let e1, t = 1 / 0;
            this.cache.forEach((i, n)=>{
                i.lastUsed < t && (t = i.lastUsed, e1 = n);
            }), e1 && this.cache.delete(e1);
        }
    }
    invalidate(e1) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let t = e1.getKey();
            if (this.invalidations.get(t)) return yield this.invalidations.get(t);
            this.cache.delete(e1.getKey());
            let i = new Promise((i, n)=>{
                this.getHeader(e1).then((e1)=>{
                    i(), this.invalidations.delete(t);
                }).catch((e1)=>{
                    n(e1);
                });
            });
            this.invalidations.set(t, i);
        });
    }
};
$785da19a645c07eb$var$_B($785da19a645c07eb$var$qB, "SharedPromiseCache");
var $785da19a645c07eb$var$GB = $785da19a645c07eb$var$qB, $785da19a645c07eb$var$HB = class {
    constructor(e1, t, i){
        this.source = "string" == typeof e1 ? new $785da19a645c07eb$var$RB(e1) : e1, this.decompress = i || $785da19a645c07eb$var$DB, this.cache = t || new $785da19a645c07eb$var$GB;
    }
    getHeader() {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            return yield this.cache.getHeader(this.source);
        });
    }
    getZxyAttempt(e1, t, i, n) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let a = $785da19a645c07eb$var$MB(e1, t, i), r = yield this.cache.getHeader(this.source);
            if (null == n || n.throwIfAborted(), e1 < r.minZoom || e1 > r.maxZoom) return;
            let s = r.rootDirectoryOffset, o = r.rootDirectoryLength;
            for(let e1 = 0; e1 <= 3; e1++){
                let e1 = yield this.cache.getDirectory(this.source, s, o, r, n);
                null == n || n.throwIfAborted();
                let t = $785da19a645c07eb$var$FB(e1, a);
                if (!t) return;
                if (t.runLength > 0) {
                    let e1 = yield this.source.getBytes(r.tileDataOffset + t.offset, t.length, n, r.etag);
                    return {
                        data: yield this.decompress(e1.data, r.tileCompression),
                        cacheControl: e1.cacheControl,
                        expires: e1.expires
                    };
                }
                s = r.leafDirectoryOffset + t.offset, o = t.length;
            }
            throw new Error("Maximum directory depth exceeded");
        });
    }
    getZxy(e1, t, i, n) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            try {
                return yield this.getZxyAttempt(e1, t, i, n);
            } catch (a) {
                if (a instanceof $785da19a645c07eb$var$NB) return this.cache.invalidate(this.source), yield this.getZxyAttempt(e1, t, i, n);
                throw a;
            }
        });
    }
    getMetadataAttempt() {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let e1 = yield this.cache.getHeader(this.source), t = yield this.source.getBytes(e1.jsonMetadataOffset, e1.jsonMetadataLength, void 0, e1.etag), i = yield this.decompress(t.data, e1.internalCompression), n = new TextDecoder("utf-8");
            return JSON.parse(n.decode(i));
        });
    }
    getMetadata() {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            try {
                return yield this.getMetadataAttempt();
            } catch (e1) {
                if (e1 instanceof $785da19a645c07eb$var$NB) return this.cache.invalidate(this.source), yield this.getMetadataAttempt();
                throw e1;
            }
        });
    }
    getTileJson(e1) {
        return $785da19a645c07eb$var$vB(this, null, function*() {
            let t = yield this.getHeader(), i = yield this.getMetadata(), n = $785da19a645c07eb$var$IB(t.tileType);
            return {
                tilejson: "3.0.0",
                scheme: "xyz",
                tiles: [
                    `${e1}/{z}/{x}/{y}${n}`
                ],
                vector_layers: i.vector_layers,
                attribution: i.attribution,
                description: i.description,
                name: i.name,
                version: i.version,
                bounds: [
                    t.minLon,
                    t.minLat,
                    t.maxLon,
                    t.maxLat
                ],
                center: [
                    t.centerLon,
                    t.centerLat,
                    t.centerZoom
                ],
                minzoom: t.minZoom,
                maxzoom: t.maxZoom
            };
        });
    }
};
$785da19a645c07eb$var$_B($785da19a645c07eb$var$HB, "PMTiles");
var $785da19a645c07eb$var$WB = $785da19a645c07eb$var$HB;
const $785da19a645c07eb$var$ZB = new CSSStyleSheet;
$785da19a645c07eb$var$ZB.replaceSync('.maplibregl-map{font:12px/20px Helvetica Neue,Arial,Helvetica,sans-serif;overflow:hidden;position:relative;-webkit-tap-highlight-color:rgb(0 0 0/0)}.maplibregl-canvas{position:absolute;left:0;top:0}.maplibregl-map:fullscreen{width:100%;height:100%}.maplibregl-ctrl-group button.maplibregl-ctrl-compass{touch-action:none}.maplibregl-canvas-container.maplibregl-interactive,.maplibregl-ctrl-group button.maplibregl-ctrl-compass{cursor:grab;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-canvas-container.maplibregl-interactive.maplibregl-track-pointer{cursor:pointer}.maplibregl-canvas-container.maplibregl-interactive:active,.maplibregl-ctrl-group button.maplibregl-ctrl-compass:active{cursor:grabbing}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-canvas-container.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:pinch-zoom}.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan,.maplibregl-canvas-container.maplibregl-touch-zoom-rotate.maplibregl-touch-drag-pan .maplibregl-canvas{touch-action:none}.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures,.maplibregl-canvas-container.maplibregl-touch-drag-pan.maplibregl-cooperative-gestures .maplibregl-canvas{touch-action:pan-x pan-y}.maplibregl-ctrl-bottom-left,.maplibregl-ctrl-bottom-right,.maplibregl-ctrl-top-left,.maplibregl-ctrl-top-right{position:absolute;pointer-events:none;z-index:2}.maplibregl-ctrl-top-left{top:0;left:0}.maplibregl-ctrl-top-right{top:0;right:0}.maplibregl-ctrl-bottom-left{bottom:0;left:0}.maplibregl-ctrl-bottom-right{right:0;bottom:0}.maplibregl-ctrl{clear:both;pointer-events:auto;transform:translate(0)}.maplibregl-ctrl-top-left .maplibregl-ctrl{margin:10px 0 0 10px;float:left}.maplibregl-ctrl-top-right .maplibregl-ctrl{margin:10px 10px 0 0;float:right}.maplibregl-ctrl-bottom-left .maplibregl-ctrl{margin:0 0 10px 10px;float:left}.maplibregl-ctrl-bottom-right .maplibregl-ctrl{margin:0 10px 10px 0;float:right}.maplibregl-ctrl-group{border-radius:4px;background:#fff}.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px rgba(0,0,0,.1)}@media (forced-colors:active){.maplibregl-ctrl-group:not(:empty){box-shadow:0 0 0 2px ButtonText}}.maplibregl-ctrl-group button{width:29px;height:29px;display:block;padding:0;outline:none;border:0;box-sizing:border-box;background-color:transparent;cursor:pointer}.maplibregl-ctrl-group button+button{border-top:1px solid #ddd}.maplibregl-ctrl button .maplibregl-ctrl-icon{display:block;width:100%;height:100%;background-repeat:no-repeat;background-position:50%}@media (forced-colors:active){.maplibregl-ctrl-icon{background-color:transparent}.maplibregl-ctrl-group button+button{border-top:1px solid ButtonText}}.maplibregl-ctrl button::-moz-focus-inner{border:0;padding:0}.maplibregl-ctrl-attrib-button:focus,.maplibregl-ctrl-group button:focus{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl button:disabled{cursor:not-allowed}.maplibregl-ctrl button:disabled .maplibregl-ctrl-icon{opacity:.25}@media (hover:hover){.maplibregl-ctrl button:not(:disabled):hover{background-color:rgba(0,0,0,.05)}}.maplibregl-ctrl button:not(:disabled):active{background-color:rgba(0,0,0,.05)}.maplibregl-ctrl-group button:focus:focus-visible{box-shadow:0 0 2px 2px #0096ff}.maplibregl-ctrl-group button:focus:not(:focus-visible){box-shadow:none}.maplibregl-ctrl-group button:focus:first-child{border-radius:4px 4px 0 0}.maplibregl-ctrl-group button:focus:last-child{border-radius:0 0 4px 4px}.maplibregl-ctrl-group button:focus:only-child{border-radius:inherit}.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M10%2013c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h9c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M14.5%208.5c-.75%200-1.5.75-1.5%201.5v3h-3c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h3v3c0%20.75.75%201.5%201.5%201.5S16%2019.75%2016%2019v-3h3c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013h-3v-3c0-.75-.75-1.5-1.5-1.5%22%2F%3E%3C%2Fsvg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M10%2013c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h9c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M14.5%208.5c-.75%200-1.5.75-1.5%201.5v3h-3c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h3v3c0%20.75.75%201.5%201.5%201.5S16%2019.75%2016%2019v-3h3c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013h-3v-3c0-.75-.75-1.5-1.5-1.5%22%2F%3E%3C%2Fsvg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-zoom-out .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M10%2013c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h9c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-zoom-in .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M14.5%208.5c-.75%200-1.5.75-1.5%201.5v3h-3c-.75%200-1.5.75-1.5%201.5S9.25%2016%2010%2016h3v3c0%20.75.75%201.5%201.5%201.5S16%2019.75%2016%2019v-3h3c.75%200%201.5-.75%201.5-1.5S19.75%2013%2019%2013h-3v-3c0-.75-.75-1.5-1.5-1.5%22%2F%3E%3C%2Fsvg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M24%2016v5.5c0%201.75-.75%202.5-2.5%202.5H16v-1l3-1.5-4-5.5%201-1%205.5%204%201.5-3zM6%2016l1.5%203%205.5-4%201%201-4%205.5%203%201.5v1H7.5C5.75%2024%205%2023.25%205%2021.5V16zm7-11v1l-3%201.5%204%205.5-1%201-5.5-4L6%2013H5V7.5C5%205.75%205.75%205%207.5%205zm11%202.5c0-1.75-.75-2.5-2.5-2.5H16v1l3%201.5-4%205.5%201%201%205.5-4%201.5%203h1z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M18.5%2016c-1.75%200-2.5.75-2.5%202.5V24h1l1.5-3%205.5%204%201-1-4-5.5%203-1.5v-1zM13%2018.5c0-1.75-.75-2.5-2.5-2.5H5v1l3%201.5L4%2024l1%201%205.5-4%201.5%203h1zm3-8c0%201.75.75%202.5%202.5%202.5H24v-1l-3-1.5L25%205l-1-1-5.5%204L17%205h-1zM10.5%2013c1.75%200%202.5-.75%202.5-2.5V5h-1l-1.5%203L5%204%204%205l4%205.5L5%2012v1z%22%2F%3E%3C%2Fsvg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M24%2016v5.5c0%201.75-.75%202.5-2.5%202.5H16v-1l3-1.5-4-5.5%201-1%205.5%204%201.5-3zM6%2016l1.5%203%205.5-4%201%201-4%205.5%203%201.5v1H7.5C5.75%2024%205%2023.25%205%2021.5V16zm7-11v1l-3%201.5%204%205.5-1%201-5.5-4L6%2013H5V7.5C5%205.75%205.75%205%207.5%205zm11%202.5c0-1.75-.75-2.5-2.5-2.5H16v1l3%201.5-4%205.5%201%201%205.5-4%201.5%203h1z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M18.5%2016c-1.75%200-2.5.75-2.5%202.5V24h1l1.5-3%205.5%204%201-1-4-5.5%203-1.5v-1zM13%2018.5c0-1.75-.75-2.5-2.5-2.5H5v1l3%201.5L4%2024l1%201%205.5-4%201.5%203h1zm3-8c0%201.75.75%202.5%202.5%202.5H24v-1l-3-1.5L25%205l-1-1-5.5%204L17%205h-1zM10.5%2013c1.75%200%202.5-.75%202.5-2.5V5h-1l-1.5%203L5%204%204%205l4%205.5L5%2012v1z%22%2F%3E%3C%2Fsvg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-fullscreen .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M24%2016v5.5c0%201.75-.75%202.5-2.5%202.5H16v-1l3-1.5-4-5.5%201-1%205.5%204%201.5-3zM6%2016l1.5%203%205.5-4%201%201-4%205.5%203%201.5v1H7.5C5.75%2024%205%2023.25%205%2021.5V16zm7-11v1l-3%201.5%204%205.5-1%201-5.5-4L6%2013H5V7.5C5%205.75%205.75%205%207.5%205zm11%202.5c0-1.75-.75-2.5-2.5-2.5H16v1l3%201.5-4%205.5%201%201%205.5-4%201.5%203h1z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-shrink .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22M18.5%2016c-1.75%200-2.5.75-2.5%202.5V24h1l1.5-3%205.5%204%201-1-4-5.5%203-1.5v-1zM13%2018.5c0-1.75-.75-2.5-2.5-2.5H5v1l3%201.5L4%2024l1%201%205.5-4%201.5%203h1zm3-8c0%201.75.75%202.5%202.5%202.5H24v-1l-3-1.5L25%205l-1-1-5.5%204L17%205h-1zM10.5%2013c1.75%200%202.5-.75%202.5-2.5V5h-1l-1.5%203L5%204%204%205l4%205.5L5%2012v1z%22%2F%3E%3C%2Fsvg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22m10.5%2014%204-8%204%208z%22%2F%3E%3Cpath%20fill%3D%22%23ccc%22%20d%3D%22m10.5%2016%204%208%204-8z%22%2F%3E%3C%2Fsvg%3E")}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22m10.5%2014%204-8%204%208z%22%2F%3E%3Cpath%20fill%3D%22%23ccc%22%20d%3D%22m10.5%2016%204%208%204-8z%22%2F%3E%3C%2Fsvg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-compass .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2029%2029%22%3E%3Cpath%20d%3D%22m10.5%2014%204-8%204%208z%22%2F%3E%3Cpath%20fill%3D%22%23ccc%22%20d%3D%22m10.5%2016%204%208%204-8z%22%2F%3E%3C%2Fsvg%3E")}}.maplibregl-ctrl button.maplibregl-ctrl-globe .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22none%22%20stroke%3D%22%23333%22%20viewBox%3D%220%200%2022%2022%22%3E%3Ccircle%20cx%3D%2211%22%20cy%3D%2211%22%20r%3D%228.5%22%2F%3E%3Cpath%20d%3D%22M17.5%2011c0%204.819-3.02%208.5-6.5%208.5S4.5%2015.819%204.5%2011%207.52%202.5%2011%202.5s6.5%203.681%206.5%208.5Z%22%2F%3E%3Cpath%20d%3D%22M13.5%2011c0%202.447-.331%204.64-.853%206.206-.262.785-.562%201.384-.872%201.777-.314.399-.58.517-.775.517s-.461-.118-.775-.517c-.31-.393-.61-.992-.872-1.777C8.831%2015.64%208.5%2013.446%208.5%2011s.331-4.64.853-6.206c.262-.785.562-1.384.872-1.777.314-.399.58-.517.775-.517s.461.118.775.517c.31.393.61.992.872%201.777.522%201.565.853%203.76.853%206.206Z%22%2F%3E%3Cpath%20d%3D%22M11%207.5c-1.909%200-3.622-.166-4.845-.428-.616-.132-1.08-.283-1.379-.434a1.3%201.3%200%200%201-.224-.138q.07-.058.224-.138c.299-.151.763-.302%201.379-.434C7.378%205.666%209.091%205.5%2011%205.5s3.622.166%204.845.428c.616.132%201.08.283%201.379.434.105.053.177.1.224.138q-.07.058-.224.138c-.299.151-.763.302-1.379.434-1.223.262-2.936.428-4.845.428Zm0%209c-1.909%200-3.622-.166-4.845-.428-.616-.132-1.08-.283-1.379-.434a1.3%201.3%200%200%201-.224-.138%201.3%201.3%200%200%201%20.224-.138c.299-.151.763-.302%201.379-.434C7.378%2014.666%209.091%2014.5%2011%2014.5s3.622.166%204.845.428c.616.132%201.08.283%201.379.434.105.053.177.1.224.138a1.3%201.3%200%200%201-.224.138c-.299.151-.763.302-1.379.434-1.223.262-2.936.428-4.845.428Zm0-4c-2.46%200-4.672-.222-6.255-.574-.796-.177-1.406-.38-1.805-.59a1.5%201.5%200%200%201-.39-.272.3.3%200%200%201-.047-.064.3.3%200%200%201%20.048-.064c.066-.073.189-.167.389-.272.399-.21%201.009-.413%201.805-.59C6.328%209.722%208.54%209.5%2011%209.5s4.672.222%206.256.574c.795.177%201.405.38%201.804.59.2.105.323.2.39.272a.3.3%200%200%201%20.047.064.3.3%200%200%201-.048.064%201.4%201.4%200%200%201-.389.272c-.399.21-1.009.413-1.804.59-1.584.352-3.796.574-6.256.574Zm-8.501-1.51v.002zm0%20.018v.002zm17.002.002v-.002zm0-.018v-.002z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-globe-enabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22none%22%20stroke%3D%22%2333b5e5%22%20viewBox%3D%220%200%2022%2022%22%3E%3Ccircle%20cx%3D%2211%22%20cy%3D%2211%22%20r%3D%228.5%22%2F%3E%3Cpath%20d%3D%22M17.5%2011c0%204.819-3.02%208.5-6.5%208.5S4.5%2015.819%204.5%2011%207.52%202.5%2011%202.5s6.5%203.681%206.5%208.5Z%22%2F%3E%3Cpath%20d%3D%22M13.5%2011c0%202.447-.331%204.64-.853%206.206-.262.785-.562%201.384-.872%201.777-.314.399-.58.517-.775.517s-.461-.118-.775-.517c-.31-.393-.61-.992-.872-1.777C8.831%2015.64%208.5%2013.446%208.5%2011s.331-4.64.853-6.206c.262-.785.562-1.384.872-1.777.314-.399.58-.517.775-.517s.461.118.775.517c.31.393.61.992.872%201.777.522%201.565.853%203.76.853%206.206Z%22%2F%3E%3Cpath%20d%3D%22M11%207.5c-1.909%200-3.622-.166-4.845-.428-.616-.132-1.08-.283-1.379-.434a1.3%201.3%200%200%201-.224-.138q.07-.058.224-.138c.299-.151.763-.302%201.379-.434C7.378%205.666%209.091%205.5%2011%205.5s3.622.166%204.845.428c.616.132%201.08.283%201.379.434.105.053.177.1.224.138q-.07.058-.224.138c-.299.151-.763.302-1.379.434-1.223.262-2.936.428-4.845.428Zm0%209c-1.909%200-3.622-.166-4.845-.428-.616-.132-1.08-.283-1.379-.434a1.3%201.3%200%200%201-.224-.138%201.3%201.3%200%200%201%20.224-.138c.299-.151.763-.302%201.379-.434C7.378%2014.666%209.091%2014.5%2011%2014.5s3.622.166%204.845.428c.616.132%201.08.283%201.379.434.105.053.177.1.224.138a1.3%201.3%200%200%201-.224.138c-.299.151-.763.302-1.379.434-1.223.262-2.936.428-4.845.428Zm0-4c-2.46%200-4.672-.222-6.255-.574-.796-.177-1.406-.38-1.805-.59a1.5%201.5%200%200%201-.39-.272.3.3%200%200%201-.047-.064.3.3%200%200%201%20.048-.064c.066-.073.189-.167.389-.272.399-.21%201.009-.413%201.805-.59C6.328%209.722%208.54%209.5%2011%209.5s4.672.222%206.256.574c.795.177%201.405.38%201.804.59.2.105.323.2.39.272a.3.3%200%200%201%20.047.064.3.3%200%200%201-.048.064%201.4%201.4%200%200%201-.389.272c-.399.21-1.009.413-1.804.59-1.584.352-3.796.574-6.256.574Zm-8.501-1.51v.002zm0%20.018v.002zm17.002.002v-.002zm0-.018v-.002z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-terrain .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2022%2022%22%3E%3Cpath%20d%3D%22m1.754%2013.406%204.453-4.851%203.09%203.09%203.281%203.277.969-.969-3.309-3.312%203.844-4.121%206.148%206.886h1.082v-.855l-7.207-8.07-4.84%205.187L6.169%206.57l-5.48%205.965v.871ZM.688%2016.844h20.625v1.375H.688Zm0%200%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-terrain-enabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2222%22%20height%3D%2222%22%20fill%3D%22%2333b5e5%22%20viewBox%3D%220%200%2022%2022%22%3E%3Cpath%20d%3D%22m1.754%2013.406%204.453-4.851%203.09%203.09%203.281%203.277.969-.969-3.309-3.312%203.844-4.121%206.148%206.886h1.082v-.855l-7.207-8.07-4.84%205.187L6.169%206.57l-5.48%205.965v.871ZM.688%2016.844h20.625v1.375H.688Zm0%200%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23333%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23aaa%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3Cpath%20fill%3D%22red%22%20d%3D%22m14%205%201%201-9%209-1-1z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%2333b5e5%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23e58978%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%2333b5e5%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23e54e33%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-waiting .maplibregl-ctrl-icon{animation:maplibregl-spin 2s linear infinite}@media (forced-colors:active){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23fff%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23999%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3Cpath%20fill%3D%22red%22%20d%3D%22m14%205%201%201-9%209-1-1z%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%2333b5e5%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-active-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23e58978%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%2333b5e5%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate.maplibregl-ctrl-geolocate-background-error .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23e54e33%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3C%2Fsvg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl button.maplibregl-ctrl-geolocate .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3C%2Fsvg%3E")}.maplibregl-ctrl button.maplibregl-ctrl-geolocate:disabled .maplibregl-ctrl-icon{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2229%22%20height%3D%2229%22%20fill%3D%22%23666%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M10%204C9%204%209%205%209%205v.1A5%205%200%200%200%205.1%209H5s-1%200-1%201%201%201%201%201h.1A5%205%200%200%200%209%2014.9v.1s0%201%201%201%201-1%201-1v-.1a5%205%200%200%200%203.9-3.9h.1s1%200%201-1-1-1-1-1h-.1A5%205%200%200%200%2011%205.1V5s0-1-1-1m0%202.5a3.5%203.5%200%201%201%200%207%203.5%203.5%200%201%201%200-7%22%2F%3E%3Ccircle%20cx%3D%2210%22%20cy%3D%2210%22%20r%3D%222%22%2F%3E%3Cpath%20fill%3D%22red%22%20d%3D%22m14%205%201%201-9%209-1-1z%22%2F%3E%3C%2Fsvg%3E")}}@keyframes maplibregl-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}a.maplibregl-ctrl-logo{width:88px;height:23px;margin:0 0 -4px -4px;display:block;background-repeat:no-repeat;cursor:pointer;overflow:hidden;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2288%22%20height%3D%2223%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23000%22%20fill-opacity%3D%22.4%22%20fill-rule%3D%22evenodd%22%20d%3D%22M17.408%2016.796h-1.827l2.501-12.095h.198l3.324%206.533.988%202.19.988-2.19%203.258-6.533h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.929%205.644h-.098l-2.914-5.644-.757-1.71-.345%201.71zm1.958-3.42-.726%203.663a1.255%201.255%200%200%201-1.232%201.011h-1.827a1.255%201.255%200%200%201-1.229-1.509l2.501-12.095a1.255%201.255%200%200%201%201.23-1.001h.197a1.25%201.25%200%200%201%201.12.685l3.19%206.273%203.125-6.263a1.25%201.25%200%200%201%201.123-.695h.181a1.255%201.255%200%200%201%201.227.991l1.443%206.71a5%205%200%200%201%20.314-.787l.009-.016a4.6%204.6%200%200%201%201.777-1.887c.782-.46%201.668-.667%202.611-.667a4.6%204.6%200%200%201%201.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255%201.255%200%200%201%201.212.925%201.255%201.255%200%200%201%201.212-.925h1.711c.284%200%20.545.094.755.252.613-.3%201.312-.45%202.075-.45%201.356%200%202.557.445%203.482%201.4q.47.48.763%201.064V4.701a1.255%201.255%200%200%201%201.255-1.255h1.86A1.255%201.255%200%200%201%2054.44%204.7v9.194h2.217c.19%200%20.37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42%202.42%200%200%201-.682-1.71c0-.665.267-1.253.735-1.7a2.45%202.45%200%200%201%201.722-.674%202.43%202.43%200%200%201%201.705.675q.318.302.504.683V4.7a1.255%201.255%200%200%201%201.255-1.255h1.744A1.255%201.255%200%200%201%2065.812%204.7v3.335a4.8%204.8%200%200%201%201.526-.246c.938%200%201.817.214%202.59.69a4.47%204.47%200%200%201%201.67%201.743v-.98a1.255%201.255%200%200%201%201.256-1.256h1.777c.233%200%20.451.064.639.174a3.4%203.4%200%200%201%201.567-.372c.346%200%20.861.02%201.285.232a1.25%201.25%200%200%201%20.689%201.004%204.7%204.7%200%200%201%20.853-.588c.795-.44%201.675-.647%202.61-.647%201.385%200%202.65.39%203.525%201.396.836.938%201.168%202.173%201.168%203.528q-.001.515-.056%201.051a1.255%201.255%200%200%201-.947%201.09l.408.952a1.255%201.255%200%200%201-.477%201.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06%200-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8%205.8%200%200%201-.548-2.512q0-.429.053-.843a1.3%201.3%200%200%201-.333-.086l-.166-.004c-.223%200-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255%201.255%200%200%201-1.256%201.256h-1.777a1.255%201.255%200%200%201-1.256-1.256V15.69l-.032.057a4.8%204.8%200%200%201-1.86%201.833%205.04%205.04%200%200%201-2.484.634%204.5%204.5%200%200%201-1.935-.424%201.25%201.25%200%200%201-.764.258h-1.71a1.255%201.255%200%200%201-1.256-1.255V7.687a2.4%202.4%200%200%201-.428.625c.253.23.412.561.412.93v7.553a1.255%201.255%200%200%201-1.256%201.255h-1.843a1.25%201.25%200%200%201-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255%201.255%200%200%201-1.256-1.255v-1.251l-.061.117a4.7%204.7%200%200%201-1.782%201.884%204.77%204.77%200%200%201-2.485.67%205.6%205.6%200%200%201-1.485-.188l.009%202.764a1.255%201.255%200%200%201-1.255%201.259h-1.729a1.255%201.255%200%200%201-1.255-1.255v-3.537a1.255%201.255%200%200%201-1.167.793h-1.679a1.25%201.25%200%200%201-.77-.263%204.5%204.5%200%200%201-1.945.429c-.885%200-1.724-.21-2.495-.632l-.017-.01a5%205%200%200%201-1.081-.836%201.255%201.255%200%200%201-1.254%201.312h-1.81a1.255%201.255%200%200%201-1.228-.99l-.782-3.625-2.044%203.939a1.25%201.25%200%200%201-1.115.676h-.098a1.25%201.25%200%200%201-1.116-.68l-2.061-3.994zM35.92%2016.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033%201.332h1.678V9.242h-1.694l-.033%201.267q-.133-.329-.526-.658l-.032-.028a3.2%203.2%200%200%200-.668-.428l-.27-.12a3.3%203.3%200%200%200-1.235-.23q-1.136-.001-1.974.493a3.36%203.36%200%200%200-1.3%201.382q-.445.89-.444%202.074%200%201.2.51%202.107a3.8%203.8%200%200%200%201.382%201.381%203.9%203.9%200%200%200%201.893.477q.795%200%201.455-.33zm-2.789-5.38q-.576.675-.575%201.762%200%201.102.559%201.794.576.675%201.645.675a2.25%202.25%200%200%200%20.934-.19%202.2%202.2%200%200%200%20.468-.29l.178-.161a2.2%202.2%200%200%200%20.397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2%202.2%200%200%200-.633-.709l-.13-.086-.047-.028a2.1%202.1%200%200%200-1.073-.285q-1.052%200-1.629.692zm2.316%202.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96%200%200%200-.353-.389.85.85%200%200%200-.464-.127c-.4%200-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945%200%20.506.122.801.27.99.097.11.266.224.68.224.303%200%20.504-.09.687-.269zm7.545%201.705a2.6%202.6%200%200%200%20.331.423q.319.33.755.548l.173.074q.65.255%201.49.255%201.02%200%201.844-.493a3.45%203.45%200%200%200%201.316-1.4q.493-.904.493-2.089%200-1.909-.988-2.913-.988-1.02-2.584-1.02-.898%200-1.575.347a3%203%200%200%200-.415.262l-.199.166a3.4%203.4%200%200%200-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296%201.119.297%201.07%200%201.645-.675.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.435%200-.835.16a2%202%200%200%200-.284.136%202%202%200%200%200-.363.254%202.2%202.2%200%200%200-.46.569l-.082.162a2.6%202.6%200%200%200-.213%201.072v.115q0%20.707.296%201.267l.135.211zm.964-.818a1.1%201.1%200%200%200%20.367.385.94.94%200%200%200%20.476.118c.423%200%20.59-.117.687-.23.159-.194.28-.478.28-.95%200-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1%201%200%200%200-.503.135l-.012.007a.86.86%200%200%200-.335.343c-.073.133-.132.324-.132.614v.115a1.4%201.4%200%200%200%20.14.66zm15.7-6.222q.347-.346.346-.856a1.05%201.05%200%200%200-.345-.79%201.18%201.18%200%200%200-.84-.329q-.51%200-.855.33a1.05%201.05%200%200%200-.346.79q0%20.51.346.855.345.346.856.346.51%200%20.839-.346zm4.337%209.314.033-1.332q.191.403.59.747l.098.081a4%204%200%200%200%20.316.224l.223.122a3.2%203.2%200%200%200%201.44.322%203.8%203.8%200%200%200%201.875-.477%203.5%203.5%200%200%200%201.382-1.366q.527-.89.526-2.09%200-1.184-.444-2.073a3.24%203.24%200%200%200-1.283-1.399q-.823-.51-1.942-.51a3.5%203.5%200%200%200-1.527.344l-.086.043-.165.09a3%203%200%200%200-.33.214q-.432.315-.656.707a2%202%200%200%200-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5%202.5%200%200%200%20.566.7q.117.098.245.18l.144.08a2.1%202.1%200%200%200%20.975.232q1.07%200%201.645-.675.576-.69.576-1.778%200-1.102-.576-1.777-.56-.691-1.645-.692a2.2%202.2%200%200%200-1.015.235q-.22.113-.415.282l-.15.142a2.1%202.1%200%200%200-.42.594q-.223.479-.223%201.1v.115q0%20.705.293%201.26zm2.616-.293c.157-.191.28-.479.28-.967%200-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87%200%200%200-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0%20.285.057.499.144.669a1.1%201.1%200%200%200%20.367.405c.137.082.28.123.455.123.423%200%20.59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493%200%20.642.099l.247-1.794q-.196-.099-.717-.099a2.3%202.3%200%200%200-.545.063%202%202%200%200%200-.411.148%202.2%202.2%200%200%200-.4.249%202.5%202.5%200%200%200-.485.499%202.7%202.7%200%200%200-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5%201.5%200%200%201%20.466-.636%202.5%202.5%200%200%201%20.399-.253%202%202%200%200%201%20.224-.099zm9.784%202.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46%203.46%200%200%200-1.4%201.382q-.493.906-.493%202.106%200%201.07.428%201.975.428.89%201.332%201.432.906.526%202.255.526.973%200%201.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954%200-1.497-.444a1.6%201.6%200%200%201-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1%201%200%200%200-.156-.176q-.46-.428-1.316-.428-.986%200-1.494.604-.379.45-.494%201.234zm-27.053%202.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22m19.63%2011.151-.757-1.71-.345%201.71-1.12%205.644h-1.827L18.083%204.7h.197l3.325%206.533.988%202.19.988-2.19L26.839%204.7h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.93%205.644h-.098l-2.913-5.644zm14.836%205.81q-1.02%200-1.893-.478a3.8%203.8%200%200%201-1.381-1.382q-.51-.906-.51-2.106%200-1.185.444-2.074a3.36%203.36%200%200%201%201.3-1.382q.839-.494%201.974-.494a3.3%203.3%200%200%201%201.234.231%203.3%203.3%200%200%201%20.97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02%201.053a3.17%203.17%200%200%201-1.662.444zm.296-1.482q.938%200%201.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2%202.2%200%200%200-.807-.872%202.1%202.1%200%200%200-1.119-.313q-1.053%200-1.629.692-.575.675-.575%201.76%200%201.103.559%201.795.577.675%201.645.675zm6.521-6.237h1.711v1.4q.906-1.597%202.83-1.597%201.596%200%202.584%201.02.988%201.005.988%202.914%200%201.185-.493%202.09a3.46%203.46%200%200%201-1.316%201.399%203.5%203.5%200%200%201-1.844.493q-.954%200-1.662-.329a2.67%202.67%200%200%201-1.086-.97l.017%205.134h-1.728zm4.048%206.22q1.07%200%201.645-.674.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.592%200-1.12.296-.51.28-.822.823-.296.527-.296%201.234v.115q0%20.708.296%201.267.313.543.823.855.51.296%201.119.297z%22%2F%3E%3Cpath%20fill%3D%22%23e1e3e9%22%20d%3D%22M51.325%204.7h1.86v10.45h3.473v1.646h-5.333zm7.12%204.542h1.843v7.553h-1.843zm.905-1.415a1.16%201.16%200%200%201-.856-.346%201.17%201.17%200%200%201-.346-.856%201.05%201.05%200%200%201%20.346-.79q.346-.329.856-.329.494%200%20.839.33a1.05%201.05%200%200%201%20.345.79%201.16%201.16%200%200%201-.345.855q-.33.346-.84.346zm7.875%209.133a3.17%203.17%200%200%201-1.662-.444q-.723-.46-1.004-1.053l-.033%201.332h-1.71V4.701h1.743v4.657l-.082%201.283q.279-.658%201.086-1.119a3.5%203.5%200%200%201%201.778-.477q1.119%200%201.942.51a3.24%203.24%200%200%201%201.283%201.4q.445.888.444%202.072%200%201.201-.526%202.09a3.5%203.5%200%200%201-1.382%201.366%203.8%203.8%200%200%201-1.876.477zm-.296-1.481q1.069%200%201.645-.675.577-.69.577-1.778%200-1.102-.577-1.776-.56-.691-1.645-.692a2.12%202.12%200%200%200-1.58.659q-.642.641-.642%201.694v.115q0%20.71.296%201.267a2.4%202.4%200%200%200%20.807.872%202.1%202.1%200%200%200%201.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14%202.14%200%200%201%201.349-.46q.527%200%20.724.098l-.247%201.794q-.149-.099-.642-.099-.774%200-1.416.494-.626.493-.626%201.58v3.883h-1.777V9.242zm9.534%207.718q-1.35%200-2.255-.526-.904-.543-1.332-1.432a4.6%204.6%200%200%201-.428-1.975q0-1.2.493-2.106a3.46%203.46%200%200%201%201.4-1.382q.889-.495%202.007-.494%201.744%200%202.584.97.855.956.856%202.7%200%20.444-.05.92h-5.43q.18%201.005.708%201.45.542.443%201.497.443.79%200%201.3-.131a4%204%200%200%200%20.938-.362l.542%201.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728%200-1.991%201.86z%22%2F%3E%3Cpath%20d%3D%22M5.074%2015.948a.484.657%200%200%200-.486.659v1.84a.484.657%200%200%200%20.486.659h4.101a.484.657%200%200%200%20.486-.659v-1.84a.484.657%200%200%200-.486-.659zm3.56%201.16H5.617v.838h3.017z%22%20style%3D%22fill%3A%23fff%3Bfill-rule%3Aevenodd%3Bstroke-width%3A1.03600001%22%2F%3E%3Cg%20style%3D%22stroke-width%3A1.12603545%22%3E%3Cpath%20d%3D%22M-9.408-1.416c-3.833-.025-7.056%202.912-7.08%206.615-.02%203.08%201.653%204.832%203.107%206.268.903.892%201.721%201.74%202.32%202.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87%201.87%200%200%200-.362%201.121l-.011%201.877c-.003.402.104.787.347%201.125.244.338.688.653%201.23.656l4.142.028c.542.003.99-.306%201.238-.641a1.87%201.87%200%200%200%20.363-1.121l.012-1.875a1.87%201.87%200%200%200-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145%201.425-1.983%202.348-2.87%201.473-1.414%203.18-3.149%203.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006%201.1v.002c3.274.02%205.92%202.532%205.9%205.6-.017%202.706-1.39%204.026-2.863%205.44-1.034.994-2.118%202.033-2.814%203.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34%200%200%201-.226.084.34.34%200%200%201-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067%202.7-5.545%205.975-5.523m-.02%202.826c-1.62-.01-2.944%201.315-2.955%202.96-.01%201.646%201.295%202.988%202.916%202.999h.002c1.621.01%202.943-1.316%202.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005%201.1c1.017.006%201.829.83%201.822%201.89s-.83%201.874-1.848%201.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874%201.848-1.868m-2.155%2011.857%204.14.025c.271.002.49.305.487.676l-.013%201.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%22%20style%3D%22color%3A%23000%3Bfont-style%3Anormal%3Bfont-variant%3Anormal%3Bfont-weight%3A400%3Bfont-stretch%3Anormal%3Bfont-size%3Amedium%3Bline-height%3Anormal%3Bfont-family%3Asans-serif%3Bfont-variant-ligatures%3Anormal%3Bfont-variant-position%3Anormal%3Bfont-variant-caps%3Anormal%3Bfont-variant-numeric%3Anormal%3Bfont-variant-alternates%3Anormal%3Bfont-feature-settings%3Anormal%3Btext-indent%3A0%3Btext-align%3Astart%3Btext-decoration%3Anone%3Btext-decoration-line%3Anone%3Btext-decoration-style%3Asolid%3Btext-decoration-color%3A%23000%3Bletter-spacing%3Anormal%3Bword-spacing%3Anormal%3Btext-transform%3Anone%3Bwriting-mode%3Alr-tb%3Bdirection%3Altr%3Btext-orientation%3Amixed%3Bdominant-baseline%3Aauto%3Bbaseline-shift%3Abaseline%3Btext-anchor%3Astart%3Bwhite-space%3Anormal%3Bshape-padding%3A0%3Bclip-rule%3Aevenodd%3Bdisplay%3Ainline%3Boverflow%3Avisible%3Bvisibility%3Avisible%3Bopacity%3A1%3Bisolation%3Aauto%3Bmix-blend-mode%3Anormal%3Bcolor-interpolation%3AsRGB%3Bcolor-interpolation-filters%3AlinearRGB%3Bsolid-color%3A%23000%3Bsolid-opacity%3A1%3Bvector-effect%3Anone%3Bfill%3A%23000%3Bfill-opacity%3A.4%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-dashoffset%3A0%3Bstroke-opacity%3A1%3Bcolor-rendering%3Aauto%3Bimage-rendering%3Aauto%3Bshape-rendering%3Aauto%3Btext-rendering%3Aauto%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-9.415-.316C-12.69-.338-15.37%202.14-15.39%205.207c-.017%202.716%201.326%204.041%202.78%205.477%201.013%201%202.081%202.055%202.78%203.67l.092.076a.34.34%200%200%200%20.225.086.34.34%200%200%200%20.227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6%201.78-2.64%202.814-3.634%201.473-1.414%202.847-2.733%202.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057%208.784c1.621.011%202.944-1.315%202.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945%201.315-2.955%202.96s1.295%202.989%202.916%203%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23e1e3e9%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-11.594%2015.465c-.27-.002-.492.297-.494.668l-.012%201.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23fff%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")}a.maplibregl-ctrl-logo.maplibregl-compact{width:14px}@media (forced-colors:active){a.maplibregl-ctrl-logo{background-color:transparent;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2288%22%20height%3D%2223%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23000%22%20fill-opacity%3D%22.4%22%20fill-rule%3D%22evenodd%22%20d%3D%22M17.408%2016.796h-1.827l2.501-12.095h.198l3.324%206.533.988%202.19.988-2.19%203.258-6.533h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.929%205.644h-.098l-2.914-5.644-.757-1.71-.345%201.71zm1.958-3.42-.726%203.663a1.255%201.255%200%200%201-1.232%201.011h-1.827a1.255%201.255%200%200%201-1.229-1.509l2.501-12.095a1.255%201.255%200%200%201%201.23-1.001h.197a1.25%201.25%200%200%201%201.12.685l3.19%206.273%203.125-6.263a1.25%201.25%200%200%201%201.123-.695h.181a1.255%201.255%200%200%201%201.227.991l1.443%206.71a5%205%200%200%201%20.314-.787l.009-.016a4.6%204.6%200%200%201%201.777-1.887c.782-.46%201.668-.667%202.611-.667a4.6%204.6%200%200%201%201.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255%201.255%200%200%201%201.212.925%201.255%201.255%200%200%201%201.212-.925h1.711c.284%200%20.545.094.755.252.613-.3%201.312-.45%202.075-.45%201.356%200%202.557.445%203.482%201.4q.47.48.763%201.064V4.701a1.255%201.255%200%200%201%201.255-1.255h1.86A1.255%201.255%200%200%201%2054.44%204.7v9.194h2.217c.19%200%20.37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42%202.42%200%200%201-.682-1.71c0-.665.267-1.253.735-1.7a2.45%202.45%200%200%201%201.722-.674%202.43%202.43%200%200%201%201.705.675q.318.302.504.683V4.7a1.255%201.255%200%200%201%201.255-1.255h1.744A1.255%201.255%200%200%201%2065.812%204.7v3.335a4.8%204.8%200%200%201%201.526-.246c.938%200%201.817.214%202.59.69a4.47%204.47%200%200%201%201.67%201.743v-.98a1.255%201.255%200%200%201%201.256-1.256h1.777c.233%200%20.451.064.639.174a3.4%203.4%200%200%201%201.567-.372c.346%200%20.861.02%201.285.232a1.25%201.25%200%200%201%20.689%201.004%204.7%204.7%200%200%201%20.853-.588c.795-.44%201.675-.647%202.61-.647%201.385%200%202.65.39%203.525%201.396.836.938%201.168%202.173%201.168%203.528q-.001.515-.056%201.051a1.255%201.255%200%200%201-.947%201.09l.408.952a1.255%201.255%200%200%201-.477%201.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06%200-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8%205.8%200%200%201-.548-2.512q0-.429.053-.843a1.3%201.3%200%200%201-.333-.086l-.166-.004c-.223%200-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255%201.255%200%200%201-1.256%201.256h-1.777a1.255%201.255%200%200%201-1.256-1.256V15.69l-.032.057a4.8%204.8%200%200%201-1.86%201.833%205.04%205.04%200%200%201-2.484.634%204.5%204.5%200%200%201-1.935-.424%201.25%201.25%200%200%201-.764.258h-1.71a1.255%201.255%200%200%201-1.256-1.255V7.687a2.4%202.4%200%200%201-.428.625c.253.23.412.561.412.93v7.553a1.255%201.255%200%200%201-1.256%201.255h-1.843a1.25%201.25%200%200%201-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255%201.255%200%200%201-1.256-1.255v-1.251l-.061.117a4.7%204.7%200%200%201-1.782%201.884%204.77%204.77%200%200%201-2.485.67%205.6%205.6%200%200%201-1.485-.188l.009%202.764a1.255%201.255%200%200%201-1.255%201.259h-1.729a1.255%201.255%200%200%201-1.255-1.255v-3.537a1.255%201.255%200%200%201-1.167.793h-1.679a1.25%201.25%200%200%201-.77-.263%204.5%204.5%200%200%201-1.945.429c-.885%200-1.724-.21-2.495-.632l-.017-.01a5%205%200%200%201-1.081-.836%201.255%201.255%200%200%201-1.254%201.312h-1.81a1.255%201.255%200%200%201-1.228-.99l-.782-3.625-2.044%203.939a1.25%201.25%200%200%201-1.115.676h-.098a1.25%201.25%200%200%201-1.116-.68l-2.061-3.994zM35.92%2016.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033%201.332h1.678V9.242h-1.694l-.033%201.267q-.133-.329-.526-.658l-.032-.028a3.2%203.2%200%200%200-.668-.428l-.27-.12a3.3%203.3%200%200%200-1.235-.23q-1.136-.001-1.974.493a3.36%203.36%200%200%200-1.3%201.382q-.445.89-.444%202.074%200%201.2.51%202.107a3.8%203.8%200%200%200%201.382%201.381%203.9%203.9%200%200%200%201.893.477q.795%200%201.455-.33zm-2.789-5.38q-.576.675-.575%201.762%200%201.102.559%201.794.576.675%201.645.675a2.25%202.25%200%200%200%20.934-.19%202.2%202.2%200%200%200%20.468-.29l.178-.161a2.2%202.2%200%200%200%20.397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2%202.2%200%200%200-.633-.709l-.13-.086-.047-.028a2.1%202.1%200%200%200-1.073-.285q-1.052%200-1.629.692zm2.316%202.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96%200%200%200-.353-.389.85.85%200%200%200-.464-.127c-.4%200-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945%200%20.506.122.801.27.99.097.11.266.224.68.224.303%200%20.504-.09.687-.269zm7.545%201.705a2.6%202.6%200%200%200%20.331.423q.319.33.755.548l.173.074q.65.255%201.49.255%201.02%200%201.844-.493a3.45%203.45%200%200%200%201.316-1.4q.493-.904.493-2.089%200-1.909-.988-2.913-.988-1.02-2.584-1.02-.898%200-1.575.347a3%203%200%200%200-.415.262l-.199.166a3.4%203.4%200%200%200-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296%201.119.297%201.07%200%201.645-.675.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.435%200-.835.16a2%202%200%200%200-.284.136%202%202%200%200%200-.363.254%202.2%202.2%200%200%200-.46.569l-.082.162a2.6%202.6%200%200%200-.213%201.072v.115q0%20.707.296%201.267l.135.211zm.964-.818a1.1%201.1%200%200%200%20.367.385.94.94%200%200%200%20.476.118c.423%200%20.59-.117.687-.23.159-.194.28-.478.28-.95%200-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1%201%200%200%200-.503.135l-.012.007a.86.86%200%200%200-.335.343c-.073.133-.132.324-.132.614v.115a1.4%201.4%200%200%200%20.14.66zm15.7-6.222q.347-.346.346-.856a1.05%201.05%200%200%200-.345-.79%201.18%201.18%200%200%200-.84-.329q-.51%200-.855.33a1.05%201.05%200%200%200-.346.79q0%20.51.346.855.345.346.856.346.51%200%20.839-.346zm4.337%209.314.033-1.332q.191.403.59.747l.098.081a4%204%200%200%200%20.316.224l.223.122a3.2%203.2%200%200%200%201.44.322%203.8%203.8%200%200%200%201.875-.477%203.5%203.5%200%200%200%201.382-1.366q.527-.89.526-2.09%200-1.184-.444-2.073a3.24%203.24%200%200%200-1.283-1.399q-.823-.51-1.942-.51a3.5%203.5%200%200%200-1.527.344l-.086.043-.165.09a3%203%200%200%200-.33.214q-.432.315-.656.707a2%202%200%200%200-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5%202.5%200%200%200%20.566.7q.117.098.245.18l.144.08a2.1%202.1%200%200%200%20.975.232q1.07%200%201.645-.675.576-.69.576-1.778%200-1.102-.576-1.777-.56-.691-1.645-.692a2.2%202.2%200%200%200-1.015.235q-.22.113-.415.282l-.15.142a2.1%202.1%200%200%200-.42.594q-.223.479-.223%201.1v.115q0%20.705.293%201.26zm2.616-.293c.157-.191.28-.479.28-.967%200-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87%200%200%200-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0%20.285.057.499.144.669a1.1%201.1%200%200%200%20.367.405c.137.082.28.123.455.123.423%200%20.59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493%200%20.642.099l.247-1.794q-.196-.099-.717-.099a2.3%202.3%200%200%200-.545.063%202%202%200%200%200-.411.148%202.2%202.2%200%200%200-.4.249%202.5%202.5%200%200%200-.485.499%202.7%202.7%200%200%200-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5%201.5%200%200%201%20.466-.636%202.5%202.5%200%200%201%20.399-.253%202%202%200%200%201%20.224-.099zm9.784%202.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46%203.46%200%200%200-1.4%201.382q-.493.906-.493%202.106%200%201.07.428%201.975.428.89%201.332%201.432.906.526%202.255.526.973%200%201.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954%200-1.497-.444a1.6%201.6%200%200%201-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1%201%200%200%200-.156-.176q-.46-.428-1.316-.428-.986%200-1.494.604-.379.45-.494%201.234zm-27.053%202.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22m19.63%2011.151-.757-1.71-.345%201.71-1.12%205.644h-1.827L18.083%204.7h.197l3.325%206.533.988%202.19.988-2.19L26.839%204.7h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.93%205.644h-.098l-2.913-5.644zm14.836%205.81q-1.02%200-1.893-.478a3.8%203.8%200%200%201-1.381-1.382q-.51-.906-.51-2.106%200-1.185.444-2.074a3.36%203.36%200%200%201%201.3-1.382q.839-.494%201.974-.494a3.3%203.3%200%200%201%201.234.231%203.3%203.3%200%200%201%20.97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02%201.053a3.17%203.17%200%200%201-1.662.444zm.296-1.482q.938%200%201.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2%202.2%200%200%200-.807-.872%202.1%202.1%200%200%200-1.119-.313q-1.053%200-1.629.692-.575.675-.575%201.76%200%201.103.559%201.795.577.675%201.645.675zm6.521-6.237h1.711v1.4q.906-1.597%202.83-1.597%201.596%200%202.584%201.02.988%201.005.988%202.914%200%201.185-.493%202.09a3.46%203.46%200%200%201-1.316%201.399%203.5%203.5%200%200%201-1.844.493q-.954%200-1.662-.329a2.67%202.67%200%200%201-1.086-.97l.017%205.134h-1.728zm4.048%206.22q1.07%200%201.645-.674.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.592%200-1.12.296-.51.28-.822.823-.296.527-.296%201.234v.115q0%20.708.296%201.267.313.543.823.855.51.296%201.119.297z%22%2F%3E%3Cpath%20fill%3D%22%23e1e3e9%22%20d%3D%22M51.325%204.7h1.86v10.45h3.473v1.646h-5.333zm7.12%204.542h1.843v7.553h-1.843zm.905-1.415a1.16%201.16%200%200%201-.856-.346%201.17%201.17%200%200%201-.346-.856%201.05%201.05%200%200%201%20.346-.79q.346-.329.856-.329.494%200%20.839.33a1.05%201.05%200%200%201%20.345.79%201.16%201.16%200%200%201-.345.855q-.33.346-.84.346zm7.875%209.133a3.17%203.17%200%200%201-1.662-.444q-.723-.46-1.004-1.053l-.033%201.332h-1.71V4.701h1.743v4.657l-.082%201.283q.279-.658%201.086-1.119a3.5%203.5%200%200%201%201.778-.477q1.119%200%201.942.51a3.24%203.24%200%200%201%201.283%201.4q.445.888.444%202.072%200%201.201-.526%202.09a3.5%203.5%200%200%201-1.382%201.366%203.8%203.8%200%200%201-1.876.477zm-.296-1.481q1.069%200%201.645-.675.577-.69.577-1.778%200-1.102-.577-1.776-.56-.691-1.645-.692a2.12%202.12%200%200%200-1.58.659q-.642.641-.642%201.694v.115q0%20.71.296%201.267a2.4%202.4%200%200%200%20.807.872%202.1%202.1%200%200%200%201.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14%202.14%200%200%201%201.349-.46q.527%200%20.724.098l-.247%201.794q-.149-.099-.642-.099-.774%200-1.416.494-.626.493-.626%201.58v3.883h-1.777V9.242zm9.534%207.718q-1.35%200-2.255-.526-.904-.543-1.332-1.432a4.6%204.6%200%200%201-.428-1.975q0-1.2.493-2.106a3.46%203.46%200%200%201%201.4-1.382q.889-.495%202.007-.494%201.744%200%202.584.97.855.956.856%202.7%200%20.444-.05.92h-5.43q.18%201.005.708%201.45.542.443%201.497.443.79%200%201.3-.131a4%204%200%200%200%20.938-.362l.542%201.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728%200-1.991%201.86z%22%2F%3E%3Cpath%20d%3D%22M5.074%2015.948a.484.657%200%200%200-.486.659v1.84a.484.657%200%200%200%20.486.659h4.101a.484.657%200%200%200%20.486-.659v-1.84a.484.657%200%200%200-.486-.659zm3.56%201.16H5.617v.838h3.017z%22%20style%3D%22fill%3A%23fff%3Bfill-rule%3Aevenodd%3Bstroke-width%3A1.03600001%22%2F%3E%3Cg%20style%3D%22stroke-width%3A1.12603545%22%3E%3Cpath%20d%3D%22M-9.408-1.416c-3.833-.025-7.056%202.912-7.08%206.615-.02%203.08%201.653%204.832%203.107%206.268.903.892%201.721%201.74%202.32%202.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87%201.87%200%200%200-.362%201.121l-.011%201.877c-.003.402.104.787.347%201.125.244.338.688.653%201.23.656l4.142.028c.542.003.99-.306%201.238-.641a1.87%201.87%200%200%200%20.363-1.121l.012-1.875a1.87%201.87%200%200%200-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145%201.425-1.983%202.348-2.87%201.473-1.414%203.18-3.149%203.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006%201.1v.002c3.274.02%205.92%202.532%205.9%205.6-.017%202.706-1.39%204.026-2.863%205.44-1.034.994-2.118%202.033-2.814%203.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34%200%200%201-.226.084.34.34%200%200%201-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067%202.7-5.545%205.975-5.523m-.02%202.826c-1.62-.01-2.944%201.315-2.955%202.96-.01%201.646%201.295%202.988%202.916%202.999h.002c1.621.01%202.943-1.316%202.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005%201.1c1.017.006%201.829.83%201.822%201.89s-.83%201.874-1.848%201.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874%201.848-1.868m-2.155%2011.857%204.14.025c.271.002.49.305.487.676l-.013%201.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%22%20style%3D%22color%3A%23000%3Bfont-style%3Anormal%3Bfont-variant%3Anormal%3Bfont-weight%3A400%3Bfont-stretch%3Anormal%3Bfont-size%3Amedium%3Bline-height%3Anormal%3Bfont-family%3Asans-serif%3Bfont-variant-ligatures%3Anormal%3Bfont-variant-position%3Anormal%3Bfont-variant-caps%3Anormal%3Bfont-variant-numeric%3Anormal%3Bfont-variant-alternates%3Anormal%3Bfont-feature-settings%3Anormal%3Btext-indent%3A0%3Btext-align%3Astart%3Btext-decoration%3Anone%3Btext-decoration-line%3Anone%3Btext-decoration-style%3Asolid%3Btext-decoration-color%3A%23000%3Bletter-spacing%3Anormal%3Bword-spacing%3Anormal%3Btext-transform%3Anone%3Bwriting-mode%3Alr-tb%3Bdirection%3Altr%3Btext-orientation%3Amixed%3Bdominant-baseline%3Aauto%3Bbaseline-shift%3Abaseline%3Btext-anchor%3Astart%3Bwhite-space%3Anormal%3Bshape-padding%3A0%3Bclip-rule%3Aevenodd%3Bdisplay%3Ainline%3Boverflow%3Avisible%3Bvisibility%3Avisible%3Bopacity%3A1%3Bisolation%3Aauto%3Bmix-blend-mode%3Anormal%3Bcolor-interpolation%3AsRGB%3Bcolor-interpolation-filters%3AlinearRGB%3Bsolid-color%3A%23000%3Bsolid-opacity%3A1%3Bvector-effect%3Anone%3Bfill%3A%23000%3Bfill-opacity%3A.4%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-dashoffset%3A0%3Bstroke-opacity%3A1%3Bcolor-rendering%3Aauto%3Bimage-rendering%3Aauto%3Bshape-rendering%3Aauto%3Btext-rendering%3Aauto%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-9.415-.316C-12.69-.338-15.37%202.14-15.39%205.207c-.017%202.716%201.326%204.041%202.78%205.477%201.013%201%202.081%202.055%202.78%203.67l.092.076a.34.34%200%200%200%20.225.086.34.34%200%200%200%20.227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6%201.78-2.64%202.814-3.634%201.473-1.414%202.847-2.733%202.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057%208.784c1.621.011%202.944-1.315%202.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945%201.315-2.955%202.96s1.295%202.989%202.916%203%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23e1e3e9%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-11.594%2015.465c-.27-.002-.492.297-.494.668l-.012%201.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23fff%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")}}@media (forced-colors:active) and (prefers-color-scheme:light){a.maplibregl-ctrl-logo{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2288%22%20height%3D%2223%22%20fill%3D%22none%22%3E%3Cpath%20fill%3D%22%23000%22%20fill-opacity%3D%22.4%22%20fill-rule%3D%22evenodd%22%20d%3D%22M17.408%2016.796h-1.827l2.501-12.095h.198l3.324%206.533.988%202.19.988-2.19%203.258-6.533h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.929%205.644h-.098l-2.914-5.644-.757-1.71-.345%201.71zm1.958-3.42-.726%203.663a1.255%201.255%200%200%201-1.232%201.011h-1.827a1.255%201.255%200%200%201-1.229-1.509l2.501-12.095a1.255%201.255%200%200%201%201.23-1.001h.197a1.25%201.25%200%200%201%201.12.685l3.19%206.273%203.125-6.263a1.25%201.25%200%200%201%201.123-.695h.181a1.255%201.255%200%200%201%201.227.991l1.443%206.71a5%205%200%200%201%20.314-.787l.009-.016a4.6%204.6%200%200%201%201.777-1.887c.782-.46%201.668-.667%202.611-.667a4.6%204.6%200%200%201%201.7.32l.306.134c.21-.16.474-.256.759-.256h1.694a1.255%201.255%200%200%201%201.212.925%201.255%201.255%200%200%201%201.212-.925h1.711c.284%200%20.545.094.755.252.613-.3%201.312-.45%202.075-.45%201.356%200%202.557.445%203.482%201.4q.47.48.763%201.064V4.701a1.255%201.255%200%200%201%201.255-1.255h1.86A1.255%201.255%200%200%201%2054.44%204.7v9.194h2.217c.19%200%20.37.043.532.118v-4.77c0-.356.147-.678.385-.906a2.42%202.42%200%200%201-.682-1.71c0-.665.267-1.253.735-1.7a2.45%202.45%200%200%201%201.722-.674%202.43%202.43%200%200%201%201.705.675q.318.302.504.683V4.7a1.255%201.255%200%200%201%201.255-1.255h1.744A1.255%201.255%200%200%201%2065.812%204.7v3.335a4.8%204.8%200%200%201%201.526-.246c.938%200%201.817.214%202.59.69a4.47%204.47%200%200%201%201.67%201.743v-.98a1.255%201.255%200%200%201%201.256-1.256h1.777c.233%200%20.451.064.639.174a3.4%203.4%200%200%201%201.567-.372c.346%200%20.861.02%201.285.232a1.25%201.25%200%200%201%20.689%201.004%204.7%204.7%200%200%201%20.853-.588c.795-.44%201.675-.647%202.61-.647%201.385%200%202.65.39%203.525%201.396.836.938%201.168%202.173%201.168%203.528q-.001.515-.056%201.051a1.255%201.255%200%200%201-.947%201.09l.408.952a1.255%201.255%200%200%201-.477%201.552c-.418.268-.92.463-1.458.612-.613.171-1.304.244-2.049.244-1.06%200-2.043-.207-2.886-.698l-.015-.008c-.798-.48-1.419-1.135-1.818-1.963l-.004-.008a5.8%205.8%200%200%201-.548-2.512q0-.429.053-.843a1.3%201.3%200%200%201-.333-.086l-.166-.004c-.223%200-.426.062-.643.228-.03.024-.142.139-.142.59v3.883a1.255%201.255%200%200%201-1.256%201.256h-1.777a1.255%201.255%200%200%201-1.256-1.256V15.69l-.032.057a4.8%204.8%200%200%201-1.86%201.833%205.04%205.04%200%200%201-2.484.634%204.5%204.5%200%200%201-1.935-.424%201.25%201.25%200%200%201-.764.258h-1.71a1.255%201.255%200%200%201-1.256-1.255V7.687a2.4%202.4%200%200%201-.428.625c.253.23.412.561.412.93v7.553a1.255%201.255%200%200%201-1.256%201.255h-1.843a1.25%201.25%200%200%201-.894-.373c-.228.23-.544.373-.894.373H51.32a1.255%201.255%200%200%201-1.256-1.255v-1.251l-.061.117a4.7%204.7%200%200%201-1.782%201.884%204.77%204.77%200%200%201-2.485.67%205.6%205.6%200%200%201-1.485-.188l.009%202.764a1.255%201.255%200%200%201-1.255%201.259h-1.729a1.255%201.255%200%200%201-1.255-1.255v-3.537a1.255%201.255%200%200%201-1.167.793h-1.679a1.25%201.25%200%200%201-.77-.263%204.5%204.5%200%200%201-1.945.429c-.885%200-1.724-.21-2.495-.632l-.017-.01a5%205%200%200%201-1.081-.836%201.255%201.255%200%200%201-1.254%201.312h-1.81a1.255%201.255%200%200%201-1.228-.99l-.782-3.625-2.044%203.939a1.25%201.25%200%200%201-1.115.676h-.098a1.25%201.25%200%200%201-1.116-.68l-2.061-3.994zM35.92%2016.63l.207-.114.223-.15q.493-.356.735-.785l.061-.118.033%201.332h1.678V9.242h-1.694l-.033%201.267q-.133-.329-.526-.658l-.032-.028a3.2%203.2%200%200%200-.668-.428l-.27-.12a3.3%203.3%200%200%200-1.235-.23q-1.136-.001-1.974.493a3.36%203.36%200%200%200-1.3%201.382q-.445.89-.444%202.074%200%201.2.51%202.107a3.8%203.8%200%200%200%201.382%201.381%203.9%203.9%200%200%200%201.893.477q.795%200%201.455-.33zm-2.789-5.38q-.576.675-.575%201.762%200%201.102.559%201.794.576.675%201.645.675a2.25%202.25%200%200%200%20.934-.19%202.2%202.2%200%200%200%20.468-.29l.178-.161a2.2%202.2%200%200%200%20.397-.561q.244-.5.244-1.15v-.115q0-.708-.296-1.267l-.043-.077a2.2%202.2%200%200%200-.633-.709l-.13-.086-.047-.028a2.1%202.1%200%200%200-1.073-.285q-1.052%200-1.629.692zm2.316%202.706c.163-.17.28-.407.28-.83v-.114c0-.292-.06-.508-.15-.68a.96.96%200%200%200-.353-.389.85.85%200%200%200-.464-.127c-.4%200-.56.114-.664.239l-.01.012c-.148.174-.275.45-.275.945%200%20.506.122.801.27.99.097.11.266.224.68.224.303%200%20.504-.09.687-.269zm7.545%201.705a2.6%202.6%200%200%200%20.331.423q.319.33.755.548l.173.074q.65.255%201.49.255%201.02%200%201.844-.493a3.45%203.45%200%200%200%201.316-1.4q.493-.904.493-2.089%200-1.909-.988-2.913-.988-1.02-2.584-1.02-.898%200-1.575.347a3%203%200%200%200-.415.262l-.199.166a3.4%203.4%200%200%200-.64.82V9.242h-1.712v11.553h1.729l-.017-5.134zm.53-1.138q.206.29.48.5l.155.11.053.034q.51.296%201.119.297%201.07%200%201.645-.675.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.435%200-.835.16a2%202%200%200%200-.284.136%202%202%200%200%200-.363.254%202.2%202.2%200%200%200-.46.569l-.082.162a2.6%202.6%200%200%200-.213%201.072v.115q0%20.707.296%201.267l.135.211zm.964-.818a1.1%201.1%200%200%200%20.367.385.94.94%200%200%200%20.476.118c.423%200%20.59-.117.687-.23.159-.194.28-.478.28-.95%200-.53-.133-.8-.266-.952l-.021-.025c-.078-.094-.231-.221-.68-.221a1%201%200%200%200-.503.135l-.012.007a.86.86%200%200%200-.335.343c-.073.133-.132.324-.132.614v.115a1.4%201.4%200%200%200%20.14.66zm15.7-6.222q.347-.346.346-.856a1.05%201.05%200%200%200-.345-.79%201.18%201.18%200%200%200-.84-.329q-.51%200-.855.33a1.05%201.05%200%200%200-.346.79q0%20.51.346.855.345.346.856.346.51%200%20.839-.346zm4.337%209.314.033-1.332q.191.403.59.747l.098.081a4%204%200%200%200%20.316.224l.223.122a3.2%203.2%200%200%200%201.44.322%203.8%203.8%200%200%200%201.875-.477%203.5%203.5%200%200%200%201.382-1.366q.527-.89.526-2.09%200-1.184-.444-2.073a3.24%203.24%200%200%200-1.283-1.399q-.823-.51-1.942-.51a3.5%203.5%200%200%200-1.527.344l-.086.043-.165.09a3%203%200%200%200-.33.214q-.432.315-.656.707a2%202%200%200%200-.099.198l.082-1.283V4.701h-1.744v12.095zm.473-2.509a2.5%202.5%200%200%200%20.566.7q.117.098.245.18l.144.08a2.1%202.1%200%200%200%20.975.232q1.07%200%201.645-.675.576-.69.576-1.778%200-1.102-.576-1.777-.56-.691-1.645-.692a2.2%202.2%200%200%200-1.015.235q-.22.113-.415.282l-.15.142a2.1%202.1%200%200%200-.42.594q-.223.479-.223%201.1v.115q0%20.705.293%201.26zm2.616-.293c.157-.191.28-.479.28-.967%200-.51-.13-.79-.276-.961l-.021-.026c-.082-.1-.232-.225-.67-.225a.87.87%200%200%200-.681.279l-.012.011c-.154.155-.274.38-.274.807v.115c0%20.285.057.499.144.669a1.1%201.1%200%200%200%20.367.405c.137.082.28.123.455.123.423%200%20.59-.118.686-.23zm8.266-3.013q.345-.13.724-.14l.069-.002q.493%200%20.642.099l.247-1.794q-.196-.099-.717-.099a2.3%202.3%200%200%200-.545.063%202%202%200%200%200-.411.148%202.2%202.2%200%200%200-.4.249%202.5%202.5%200%200%200-.485.499%202.7%202.7%200%200%200-.32.581l-.05.137v-1.48h-1.778v7.553h1.777v-3.884q0-.546.159-.943a1.5%201.5%200%200%201%20.466-.636%202.5%202.5%200%200%201%20.399-.253%202%202%200%200%201%20.224-.099zm9.784%202.656.05-.922q0-1.743-.856-2.698-.838-.97-2.584-.97-1.119-.001-2.007.493a3.46%203.46%200%200%200-1.4%201.382q-.493.906-.493%202.106%200%201.07.428%201.975.428.89%201.332%201.432.906.526%202.255.526.973%200%201.668-.185l.044-.012.135-.04q.613-.184.984-.421l-.542-1.267q-.3.162-.642.274l-.297.087q-.51.131-1.3.131-.954%200-1.497-.444a1.6%201.6%200%200%201-.192-.193q-.366-.44-.512-1.234l-.004-.021zm-5.427-1.256-.003.022h3.752v-.138q-.011-.727-.288-1.118a1%201%200%200%200-.156-.176q-.46-.428-1.316-.428-.986%200-1.494.604-.379.45-.494%201.234zm-27.053%202.77V4.7h-1.86v12.095h5.333V15.15zm7.103-5.908v7.553h-1.843V9.242h1.843z%22%2F%3E%3Cpath%20fill%3D%22%23fff%22%20d%3D%22m19.63%2011.151-.757-1.71-.345%201.71-1.12%205.644h-1.827L18.083%204.7h.197l3.325%206.533.988%202.19.988-2.19L26.839%204.7h.181l2.6%2012.095h-1.81l-1.218-5.644-.362-1.71-.658%201.71-2.93%205.644h-.098l-2.913-5.644zm14.836%205.81q-1.02%200-1.893-.478a3.8%203.8%200%200%201-1.381-1.382q-.51-.906-.51-2.106%200-1.185.444-2.074a3.36%203.36%200%200%201%201.3-1.382q.839-.494%201.974-.494a3.3%203.3%200%200%201%201.234.231%203.3%203.3%200%200%201%20.97.575q.396.33.527.659l.033-1.267h1.694v7.553H37.18l-.033-1.332q-.279.593-1.02%201.053a3.17%203.17%200%200%201-1.662.444zm.296-1.482q.938%200%201.58-.642.642-.66.642-1.711v-.115q0-.708-.296-1.267a2.2%202.2%200%200%200-.807-.872%202.1%202.1%200%200%200-1.119-.313q-1.053%200-1.629.692-.575.675-.575%201.76%200%201.103.559%201.795.577.675%201.645.675zm6.521-6.237h1.711v1.4q.906-1.597%202.83-1.597%201.596%200%202.584%201.02.988%201.005.988%202.914%200%201.185-.493%202.09a3.46%203.46%200%200%201-1.316%201.399%203.5%203.5%200%200%201-1.844.493q-.954%200-1.662-.329a2.67%202.67%200%200%201-1.086-.97l.017%205.134h-1.728zm4.048%206.22q1.07%200%201.645-.674.577-.69.576-1.762%200-1.119-.576-1.777-.558-.675-1.645-.675-.592%200-1.12.296-.51.28-.822.823-.296.527-.296%201.234v.115q0%20.708.296%201.267.313.543.823.855.51.296%201.119.297z%22%2F%3E%3Cpath%20fill%3D%22%23e1e3e9%22%20d%3D%22M51.325%204.7h1.86v10.45h3.473v1.646h-5.333zm7.12%204.542h1.843v7.553h-1.843zm.905-1.415a1.16%201.16%200%200%201-.856-.346%201.17%201.17%200%200%201-.346-.856%201.05%201.05%200%200%201%20.346-.79q.346-.329.856-.329.494%200%20.839.33a1.05%201.05%200%200%201%20.345.79%201.16%201.16%200%200%201-.345.855q-.33.346-.84.346zm7.875%209.133a3.17%203.17%200%200%201-1.662-.444q-.723-.46-1.004-1.053l-.033%201.332h-1.71V4.701h1.743v4.657l-.082%201.283q.279-.658%201.086-1.119a3.5%203.5%200%200%201%201.778-.477q1.119%200%201.942.51a3.24%203.24%200%200%201%201.283%201.4q.445.888.444%202.072%200%201.201-.526%202.09a3.5%203.5%200%200%201-1.382%201.366%203.8%203.8%200%200%201-1.876.477zm-.296-1.481q1.069%200%201.645-.675.577-.69.577-1.778%200-1.102-.577-1.776-.56-.691-1.645-.692a2.12%202.12%200%200%200-1.58.659q-.642.641-.642%201.694v.115q0%20.71.296%201.267a2.4%202.4%200%200%200%20.807.872%202.1%202.1%200%200%200%201.119.313zm5.927-6.237h1.777v1.481q.263-.757.856-1.217a2.14%202.14%200%200%201%201.349-.46q.527%200%20.724.098l-.247%201.794q-.149-.099-.642-.099-.774%200-1.416.494-.626.493-.626%201.58v3.883h-1.777V9.242zm9.534%207.718q-1.35%200-2.255-.526-.904-.543-1.332-1.432a4.6%204.6%200%200%201-.428-1.975q0-1.2.493-2.106a3.46%203.46%200%200%201%201.4-1.382q.889-.495%202.007-.494%201.744%200%202.584.97.855.956.856%202.7%200%20.444-.05.92h-5.43q.18%201.005.708%201.45.542.443%201.497.443.79%200%201.3-.131a4%204%200%200%200%20.938-.362l.542%201.267q-.411.263-1.119.46-.708.198-1.711.197zm1.596-4.558q.016-1.02-.444-1.432-.46-.428-1.316-.428-1.728%200-1.991%201.86z%22%2F%3E%3Cpath%20d%3D%22M5.074%2015.948a.484.657%200%200%200-.486.659v1.84a.484.657%200%200%200%20.486.659h4.101a.484.657%200%200%200%20.486-.659v-1.84a.484.657%200%200%200-.486-.659zm3.56%201.16H5.617v.838h3.017z%22%20style%3D%22fill%3A%23fff%3Bfill-rule%3Aevenodd%3Bstroke-width%3A1.03600001%22%2F%3E%3Cg%20style%3D%22stroke-width%3A1.12603545%22%3E%3Cpath%20d%3D%22M-9.408-1.416c-3.833-.025-7.056%202.912-7.08%206.615-.02%203.08%201.653%204.832%203.107%206.268.903.892%201.721%201.74%202.32%202.902l-.525-.004c-.543-.003-.992.304-1.24.639a1.87%201.87%200%200%200-.362%201.121l-.011%201.877c-.003.402.104.787.347%201.125.244.338.688.653%201.23.656l4.142.028c.542.003.99-.306%201.238-.641a1.87%201.87%200%200%200%20.363-1.121l.012-1.875a1.87%201.87%200%200%200-.348-1.127c-.243-.338-.688-.653-1.23-.656l-.518-.004c.597-1.145%201.425-1.983%202.348-2.87%201.473-1.414%203.18-3.149%203.2-6.226-.016-3.59-2.923-6.684-6.993-6.707m-.006%201.1v.002c3.274.02%205.92%202.532%205.9%205.6-.017%202.706-1.39%204.026-2.863%205.44-1.034.994-2.118%202.033-2.814%203.633-.018.041-.052.055-.075.065q-.013.004-.02.01a.34.34%200%200%201-.226.084.34.34%200%200%201-.224-.086l-.092-.077c-.699-1.615-1.768-2.669-2.781-3.67-1.454-1.435-2.797-2.762-2.78-5.478.02-3.067%202.7-5.545%205.975-5.523m-.02%202.826c-1.62-.01-2.944%201.315-2.955%202.96-.01%201.646%201.295%202.988%202.916%202.999h.002c1.621.01%202.943-1.316%202.953-2.961.011-1.646-1.294-2.988-2.916-2.998m-.005%201.1c1.017.006%201.829.83%201.822%201.89s-.83%201.874-1.848%201.867c-1.018-.006-1.829-.83-1.822-1.89s.83-1.874%201.848-1.868m-2.155%2011.857%204.14.025c.271.002.49.305.487.676l-.013%201.875c-.003.37-.224.67-.495.668l-4.14-.025c-.27-.002-.487-.306-.485-.676l.012-1.875c.003-.37.224-.67.494-.668%22%20style%3D%22color%3A%23000%3Bfont-style%3Anormal%3Bfont-variant%3Anormal%3Bfont-weight%3A400%3Bfont-stretch%3Anormal%3Bfont-size%3Amedium%3Bline-height%3Anormal%3Bfont-family%3Asans-serif%3Bfont-variant-ligatures%3Anormal%3Bfont-variant-position%3Anormal%3Bfont-variant-caps%3Anormal%3Bfont-variant-numeric%3Anormal%3Bfont-variant-alternates%3Anormal%3Bfont-feature-settings%3Anormal%3Btext-indent%3A0%3Btext-align%3Astart%3Btext-decoration%3Anone%3Btext-decoration-line%3Anone%3Btext-decoration-style%3Asolid%3Btext-decoration-color%3A%23000%3Bletter-spacing%3Anormal%3Bword-spacing%3Anormal%3Btext-transform%3Anone%3Bwriting-mode%3Alr-tb%3Bdirection%3Altr%3Btext-orientation%3Amixed%3Bdominant-baseline%3Aauto%3Bbaseline-shift%3Abaseline%3Btext-anchor%3Astart%3Bwhite-space%3Anormal%3Bshape-padding%3A0%3Bclip-rule%3Aevenodd%3Bdisplay%3Ainline%3Boverflow%3Avisible%3Bvisibility%3Avisible%3Bopacity%3A1%3Bisolation%3Aauto%3Bmix-blend-mode%3Anormal%3Bcolor-interpolation%3AsRGB%3Bcolor-interpolation-filters%3AlinearRGB%3Bsolid-color%3A%23000%3Bsolid-opacity%3A1%3Bvector-effect%3Anone%3Bfill%3A%23000%3Bfill-opacity%3A.4%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-linecap%3Abutt%3Bstroke-linejoin%3Amiter%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-dashoffset%3A0%3Bstroke-opacity%3A1%3Bcolor-rendering%3Aauto%3Bimage-rendering%3Aauto%3Bshape-rendering%3Aauto%3Btext-rendering%3Aauto%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-9.415-.316C-12.69-.338-15.37%202.14-15.39%205.207c-.017%202.716%201.326%204.041%202.78%205.477%201.013%201%202.081%202.055%202.78%203.67l.092.076a.34.34%200%200%200%20.225.086.34.34%200%200%200%20.227-.083l.019-.01c.022-.009.057-.024.074-.064.697-1.6%201.78-2.64%202.814-3.634%201.473-1.414%202.847-2.733%202.864-5.44.02-3.067-2.627-5.58-5.901-5.601m-.057%208.784c1.621.011%202.944-1.315%202.955-2.96.01-1.646-1.295-2.988-2.916-2.999-1.622-.01-2.945%201.315-2.955%202.96s1.295%202.989%202.916%203%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23e1e3e9%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3Cpath%20d%3D%22M-11.594%2015.465c-.27-.002-.492.297-.494.668l-.012%201.876c-.003.371.214.673.485.675l4.14.027c.271.002.492-.298.495-.668l.012-1.877c.003-.37-.215-.672-.485-.674z%22%20style%3D%22clip-rule%3Aevenodd%3Bfill%3A%23fff%3Bfill-opacity%3A1%3Bfill-rule%3Aevenodd%3Bstroke%3Anone%3Bstroke-width%3A2.47727823%3Bstroke-miterlimit%3A4%3Bstroke-dasharray%3Anone%3Bstroke-opacity%3A.4%22%20transform%3D%22translate(15.553%202.85)scale(.88807)%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E")}}.maplibregl-ctrl.maplibregl-ctrl-attrib{padding:0 5px;background-color:hsla(0,0%,100%,.5);margin:0}@media screen{.maplibregl-ctrl-attrib.maplibregl-compact{min-height:20px;padding:2px 24px 2px 0;margin:10px;position:relative;background-color:#fff;color:#000;border-radius:12px;box-sizing:content-box}.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 28px 2px 8px;visibility:visible}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact-show,.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact-show{padding:2px 8px 2px 28px;border-radius:12px}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-inner{display:none}.maplibregl-ctrl-attrib-button{display:none;cursor:pointer;position:absolute;background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20fill-rule%3D%22evenodd%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M4%2010a6%206%200%201%200%2012%200%206%206%200%201%200-12%200m5-3a1%201%200%201%200%202%200%201%201%200%201%200-2%200m0%203a1%201%200%201%201%202%200v3a1%201%200%201%201-2%200%22%2F%3E%3C%2Fsvg%3E");background-color:hsla(0,0%,100%,.5);width:24px;height:24px;box-sizing:border-box;border-radius:12px;outline:none;top:0;right:0;border:0}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;list-style:none}.maplibregl-ctrl-attrib summary.maplibregl-ctrl-attrib-button::-webkit-details-marker{display:none}.maplibregl-ctrl-bottom-left .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-top-left .maplibregl-ctrl-attrib-button{left:0}.maplibregl-ctrl-attrib.maplibregl-compact .maplibregl-ctrl-attrib-button,.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-inner{display:block}.maplibregl-ctrl-attrib.maplibregl-compact-show .maplibregl-ctrl-attrib-button{background-color:rgba(0,0,0,.05)}.maplibregl-ctrl-bottom-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;right:0}.maplibregl-ctrl-top-right>.maplibregl-ctrl-attrib.maplibregl-compact:after{top:0;right:0}.maplibregl-ctrl-top-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{top:0;left:0}.maplibregl-ctrl-bottom-left>.maplibregl-ctrl-attrib.maplibregl-compact:after{bottom:0;left:0}}@media screen and (forced-colors:active){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20fill%3D%22%23fff%22%20fill-rule%3D%22evenodd%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M4%2010a6%206%200%201%200%2012%200%206%206%200%201%200-12%200m5-3a1%201%200%201%200%202%200%201%201%200%201%200-2%200m0%203a1%201%200%201%201%202%200v3a1%201%200%201%201-2%200%22%2F%3E%3C%2Fsvg%3E")}}@media screen and (forced-colors:active) and (prefers-color-scheme:light){.maplibregl-ctrl-attrib.maplibregl-compact:after{background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20fill-rule%3D%22evenodd%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cpath%20d%3D%22M4%2010a6%206%200%201%200%2012%200%206%206%200%201%200-12%200m5-3a1%201%200%201%200%202%200%201%201%200%201%200-2%200m0%203a1%201%200%201%201%202%200v3a1%201%200%201%201-2%200%22%2F%3E%3C%2Fsvg%3E")}}.maplibregl-ctrl-attrib a{color:rgba(0,0,0,.75);text-decoration:none}.maplibregl-ctrl-attrib a:hover{color:inherit;text-decoration:underline}.maplibregl-attrib-empty{display:none}.maplibregl-ctrl-scale{background-color:hsla(0,0%,100%,.75);font-size:10px;white-space:nowrap;border-color:#333;border-style:none solid solid;border-width:medium 2px 2px;padding:0 5px;color:#333;box-sizing:border-box}.maplibregl-popup{position:absolute;top:0;left:0;display:flex;will-change:transform;pointer-events:none}.maplibregl-popup-anchor-top,.maplibregl-popup-anchor-top-left,.maplibregl-popup-anchor-top-right{flex-direction:column}.maplibregl-popup-anchor-bottom,.maplibregl-popup-anchor-bottom-left,.maplibregl-popup-anchor-bottom-right{flex-direction:column-reverse}.maplibregl-popup-anchor-left{flex-direction:row}.maplibregl-popup-anchor-right{flex-direction:row-reverse}.maplibregl-popup-tip{width:0;height:0;border:10px solid transparent;z-index:1}.maplibregl-popup-anchor-top .maplibregl-popup-tip{align-self:center;border-top:none;border-bottom-color:#fff}.maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-start;border-top:none;border-left:none;border-bottom-color:#fff}.maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-end;border-top:none;border-right:none;border-bottom-color:#fff}.maplibregl-popup-anchor-bottom .maplibregl-popup-tip{align-self:center;border-bottom:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-start;border-bottom:none;border-left:none;border-top-color:#fff}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-end;border-bottom:none;border-right:none;border-top-color:#fff}.maplibregl-popup-anchor-left .maplibregl-popup-tip{align-self:center;border-left:none;border-right-color:#fff}.maplibregl-popup-anchor-right .maplibregl-popup-tip{align-self:center;border-right:none;border-left-color:#fff}[dir=rtl] .maplibregl-popup-anchor-left{flex-direction:row-reverse}[dir=rtl] .maplibregl-popup-anchor-right{flex-direction:row}[dir=rtl] .maplibregl-popup-anchor-top-left .maplibregl-popup-tip{align-self:flex-end}[dir=rtl] .maplibregl-popup-anchor-top-right .maplibregl-popup-tip{align-self:flex-start}[dir=rtl] .maplibregl-popup-anchor-bottom-left .maplibregl-popup-tip{align-self:flex-end}[dir=rtl] .maplibregl-popup-anchor-bottom-right .maplibregl-popup-tip{align-self:flex-start}.maplibregl-popup-close-button{position:absolute;right:0;top:0;border:0;border-radius:0 3px 0 0;cursor:pointer;background-color:transparent}.maplibregl-popup-close-button:hover{background-color:rgba(0,0,0,.05)}.maplibregl-popup-content{position:relative;background:#fff;border-radius:3px;box-shadow:0 1px 2px rgba(0,0,0,.1);padding:15px 10px;pointer-events:auto}.maplibregl-popup-anchor-top-left .maplibregl-popup-content{border-top-left-radius:0}.maplibregl-popup-anchor-top-right .maplibregl-popup-content{border-top-right-radius:0}.maplibregl-popup-anchor-bottom-left .maplibregl-popup-content{border-bottom-left-radius:0}.maplibregl-popup-anchor-bottom-right .maplibregl-popup-content{border-bottom-right-radius:0}.maplibregl-popup-track-pointer{display:none}.maplibregl-popup-track-pointer *{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.maplibregl-map:hover .maplibregl-popup-track-pointer{display:flex}.maplibregl-map:active .maplibregl-popup-track-pointer{display:none}.maplibregl-marker{position:absolute;top:0;left:0;will-change:transform;transition:opacity .2s}.maplibregl-marker-draggable{cursor:grab}.maplibregl-user-location-dot,.maplibregl-user-location-dot:before{background-color:#1da1f2;width:15px;height:15px;border-radius:50%}.maplibregl-user-location-dot:before{content:"";position:absolute;animation:maplibregl-user-location-dot-pulse 2s infinite}.maplibregl-user-location-dot:after{border-radius:50%;border:2px solid #fff;content:"";height:19px;left:-2px;position:absolute;top:-2px;width:19px;box-sizing:border-box;box-shadow:0 0 3px rgba(0,0,0,.35)}@media (prefers-reduced-motion:reduce){.maplibregl-user-location-dot:before{animation:none}}@keyframes maplibregl-user-location-dot-pulse{0%{transform:scale(1);opacity:1}70%{transform:scale(3);opacity:0}to{transform:scale(1);opacity:0}}.maplibregl-user-location-dot-stale{background-color:#aaa}.maplibregl-user-location-dot-stale:after{display:none}.maplibregl-user-location-accuracy-circle{background-color:#1da1f233;width:1px;height:1px;border-radius:100%}.maplibregl-crosshair,.maplibregl-crosshair .maplibregl-interactive,.maplibregl-crosshair .maplibregl-interactive:active{cursor:crosshair}.maplibregl-boxzoom{position:absolute;top:0;left:0;width:0;height:0;background:#fff;border:2px dotted #202020;opacity:.5}.maplibregl-cooperative-gesture-screen{background:rgba(0,0,0,.4);position:absolute;inset:0;display:flex;justify-content:center;align-items:center;color:#fff;padding:1rem;font-size:1.4em;line-height:1.2;opacity:0;pointer-events:none;transition:opacity 1s ease 1s;z-index:99999}.maplibregl-cooperative-gesture-screen.maplibregl-show{opacity:1;transition:opacity .05s}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:none}@media (hover:none),(pointer:coarse){.maplibregl-cooperative-gesture-screen .maplibregl-desktop-message{display:none}.maplibregl-cooperative-gesture-screen .maplibregl-mobile-message{display:block}}.maplibregl-pseudo-fullscreen{position:fixed!important;width:100%!important;height:100%!important;top:0!important;left:0!important;z-index:99999}');
const $785da19a645c07eb$var$KB = new CSSStyleSheet;

$785da19a645c07eb$var$KB.replaceSync(".maplibregl-map.pnx-map {\n\tbackground: white;\n}\n\n/* Picture thumbnail on map */\n.maplibregl-popup-content {\n\tpadding: 5px !important;\n\tposition: relative;\n\tpointer-events: none !important;\n}\n\n.pnx-map-thumb {\n\tdisplay: inline-block;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmax-width: 130px;\n\tmax-height: 130px;\n}\n\n@keyframes rotating {\n\tfrom { transform: rotate(0deg); }\n\tto { transform: rotate(360deg); }\n}\n\n.pnx-map-thumb-loader {\n\tbackground-color: rgb(230,230,230);\n\tborder-radius: 65px;\n\tmax-height: 60px;\n\tmargin: 5px 35px;\n\tanimation: rotating 2s linear infinite;\n}\n\n.pnx-map-thumb-legend {\n\tdisplay: block;\n\tposition: absolute;\n\tbottom: 5px;\n\tright: 5px;\n\tleft: 5px;\n\tbackground-color: rgba(0,0,0,0.8);\n\tcolor: white;\n\ttext-align: center;\n\tfont-style: italic;\n\tfont-size: 0.8em;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.maplibregl-marker {\n\twidth: 60px;\n}\n\n/* Resize canvas for print */\n@media print {\n\t.pnx-map.maplibregl-map .maplibregl-canvas-container {\n\t\twidth: 100% !important;\n\t\theight: unset !important;\n\t}\n}\n\n/* Discard default indoor= widget */\n.pnx-map .maplibregl-ctrl-indoorequal {\n\tdisplay: none;\n}"), document.adoptedStyleSheets.push($785da19a645c07eb$var$ZB), document.adoptedStyleSheets.push($785da19a645c07eb$var$KB), function(e1) {
    $785da19a645c07eb$var$Hh.WORKER_URL = e1;
}(new URL("./maplibre-gl-worker.mjs", "undefined" == typeof document ? (parcelRequire("e61jG")).pathToFileURL($785da19a645c07eb$var$__filename).href : $785da19a645c07eb$var$e1 && "SCRIPT" === $785da19a645c07eb$var$e1.tagName.toUpperCase() && $785da19a645c07eb$var$e1.src || new URL("index.js", document.baseURI).href).toString()), $785da19a645c07eb$var$Zh("pmtiles", (new $785da19a645c07eb$var$bB).tile), $785da19a645c07eb$var$Zh("panora", (new $785da19a645c07eb$var$zc).tile()), $785da19a645c07eb$var$Zh("panoras", (new $785da19a645c07eb$var$zc).tile());
let $785da19a645c07eb$var$XB = class extends $785da19a645c07eb$var$lL {
    constructor(e1, t, i = {}){
        super({
            container: t,
            style: e1.mapStyleComposer.getMapStyle(),
            center: [
                0,
                0
            ],
            zoom: 0,
            maxZoom: 24,
            attributionControl: !1,
            dragRotate: !1,
            pitchWithRotate: !1,
            touchZoomRotate: !0,
            touchPitch: !1,
            doubleClickZoom: !1,
            canvasContextAttributes: {
                preserveDrawingBuffer: !e1.isWidthSmall()
            },
            transformRequest: e1.api._getMapRequestTransform(),
            locale: e1._t.maplibre,
            hash: !1,
            ...i
        }), this._semMapProtocol = new $785da19a645c07eb$var$Cc(e1), $785da19a645c07eb$var$Zh("sem", this._semMapProtocol.tile()), this._loadMarkerImages(), this._parent = e1, this._parent.mapStyleComposer.map = this, this._options = i, this.getContainer().classList.add("pnx-map"), void 0 === i.touchZoomRotate && this?.touchZoomRotate?.disableRotation(), this._options.raster && (this._options.background = this._options.background || "streets"), this._options.basemaps && this._parent.mapStyleComposer._createManyBasemaps(this._options.basemaps, this._options.background), $785da19a645c07eb$var$Oc(this, ![
            void 0,
            $785da19a645c07eb$var$Rc
        ].includes(this._options?.indoor?.level)), this._attribution = new $785da19a645c07eb$var$$R({
            compact: !1,
            ...i.attributionControl
        }), this.addControl(this._attribution), this._scale = new $785da19a645c07eb$var$PL, this.addControl(this._scale), this._initMapPosition(), this._picMarker = this._getPictureMarker(), this._picMarkerPreview = this._getPictureMarker(!1), this._picPreviewTimer = null, this._picPopup = new $785da19a645c07eb$var$BL({
            closeButton: !1,
            closeOnClick: !this._parent.isWidthSmall(),
            offset: 15
        }), this.on("mouseout", ()=>{
            this._parent?.isMapWide?.() || (this.getCanvas().style.cursor = "", this._dropPreview());
        }), this._picThumbUrl = {}, this._seqPictures = {}, this._parent.addEventListener("select", this._parent.mapStyleComposer.updateMapStyle.bind(this._parent.mapStyleComposer)), this._parent.mapStyleComposer.addEventListener("panoramax-changed", this._onPanoramaxChanged.bind(this)), setTimeout(()=>{
            !this.loaded() && this._parent?.loader.isVisible() && this._parent.loader.dismiss({}, this._parent._t.map.slow_loading, async ()=>{
                await this._postLoad(), this._parent.loader.dismiss();
            });
        }, 15e3), this.waitForEnoughMapLoaded().then(async ()=>await this._postLoad());
    }
    _postLoad() {
        this.resize(), this.fire("ready");
    }
    _dropPreview(e1) {
        clearTimeout(this._picDropPreviewTimer), e1 ? this._picDropPreviewTimer = setTimeout(this._dropPreview.bind(this), 250) : (clearTimeout(this._picPreviewTimer), delete this._picPopup._picId, delete this._picPopup._loading, this._picPopup.remove(), this._picMarkerPreview.remove(), this._picPinMarker?.remove?.());
    }
    destroy() {
        this.remove(), delete this._semMapProtocol, delete this._parent, delete this._options, delete this._attribution, delete this._scale, delete this._picMarker, delete this._picMarkerPreview, delete this._picPreviewTimer, delete this._picPopup, delete this._picThumbUrl, delete this._seqPictures, delete this._picPinMarker;
    }
    waitForEnoughMapLoaded() {
        return new Promise((e1)=>{
            let t = 0, i = 0, n = 0, a = 0;
            const r = (e1)=>{
                "source" === e1.dataType && e1.tile && (e1.sourceId.startsWith("geovisio") ? i++ : t++);
            }, s = (e1)=>{
                "source" === e1.dataType && e1.tile && (e1.sourceId.startsWith("geovisio") ? (a++, e1.isSourceLoaded && (a = i)) : (n++, e1.isSourceLoaded && (n = t))), o();
            }, o = ()=>{
                n / t >= .75 && (0 === i || a / i >= .75) && (this.off("sourcedata", s), this.off("sourcedataloading", r), e1());
            };
            this.on("sourcedataloading", r), this.on("sourcedata", s);
        });
    }
    _initMapPosition() {
        !$785da19a645c07eb$var$Fo(this._options.center) || this._options.zoom && 0 !== this._options.zoom || this._options.hash || this._parent.onceAPIReady().then(()=>{
            let e1 = this._parent?.api?.getDataBbox();
            if (e1) try {
                e1 = new $785da19a645c07eb$var$_T(e1), this.loaded() ? this.fitBounds(e1, {
                    animate: !1
                }) : this.waitForEnoughMapLoaded().then(()=>this.fitBounds(e1, {
                        animate: !1
                    }));
            } catch (t) {
                console.warn("Received invalid bbox: " + e1);
            }
        });
    }
    addSource(e1, t) {
        this._parent.mapStyleComposer.registerSource(e1, t), super.addSource(e1, t);
    }
    addLayer(e1, t) {
        this._parent.mapStyleComposer.registerLayer(e1, t), super.addLayer(e1, t);
    }
    _loadMarkerImages() {
        [
            {
                id: "pnx-marker",
                img: $785da19a645c07eb$var$mo
            }
        ].forEach((e1)=>{
            const t = new Image(64, 64);
            t.onload = ()=>this.addImage(e1.id, t), $785da19a645c07eb$var$Ue(e1.img, t);
        });
    }
    _hasQualityScore() {
        const e1 = this.getStyle()?.metadata?.["panoramax:fields"] || {};
        return e1?.pictures?.includes("gps_accuracy") && e1?.pictures?.includes("h_pixel_density");
    }
    _hasGridStats() {
        const e1 = this.getStyle()?.metadata?.["panoramax:fields"] || {};
        return e1?.grid?.includes("nb_360_pictures") && e1?.grid?.includes("nb_flat_pictures") && e1?.grid?.includes("coef_360_pictures") && e1?.grid?.includes("coef_flat_pictures");
    }
    _hasLoggedGridStats() {
        const e1 = this.getStyle()?.metadata?.["panoramax:fields"] || {};
        return e1?.grid?.includes("logged_coef_360_pictures") && e1?.grid?.includes("logged_coef_flat_pictures") && e1?.grid?.includes("logged_coef");
    }
    reloadVectorTiles() {
        this._parent.mapStyleComposer?.layerRanges?.panoramax && Object.values(this._parent.mapStyleComposer.layerRanges.panoramax).forEach((e1)=>{
            Object.keys(e1.sources).forEach((e1)=>{
                const t = this.getSource(e1);
                t && t.setTiles(t.tiles);
            });
        });
    }
    displayPictureMarker(e1, t, i, n = !1, a = null) {
        this._picMarkerPreview.remove(), this._picPinMarker?.remove?.(), void 0 !== e1 && void 0 !== t ? (this._picMarker.setLngLat([
            e1,
            t
        ]).setRotation(i).addTo(this), this._picMarker.picId = a) : this._picMarker.remove(), this._parent.mapStyleComposer.updateMapStyle(), n || void 0 === e1 || void 0 === t || this.jumpTo({
            center: [
                e1,
                t
            ],
            zoom: this.getZoom() < 17 ? 17 : this.getZoom()
        });
    }
    _onPanoramaxChanged() {
        const e1 = this._parent.mapStyleComposer, t = e1.layerRanges.panoramax[e1.panoramax].layers.find((e1)=>e1.id.endsWith("_pictures"))?.id, i = e1.layerRanges.panoramax[e1.panoramax].layers.find((e1)=>e1.id.endsWith("_sequences_plus"))?.id, n = e1.layerRanges.panoramax[e1.panoramax].layers.find((e1)=>e1.id.endsWith("_grid"))?.id;
        t && i || console.error("Panoramax source not loaded"), this.on("mousemove", t, (e1)=>{
            this.getCanvas().style.cursor = "pointer";
            const i = Object.assign({}, e1);
            this._attachPreviewToPictures(i, t);
        }), this.on("mouseleave", t, ()=>{
            this.getCanvas().style.cursor = "";
        }), this.on("click", t, this._onPictureClick.bind(this)), this.on("mousemove", i, (e1)=>{
            if (!(this.getZoom() >= $785da19a645c07eb$var$fo) && (this._onSequenceHover(e1), this.getCanvas().style.cursor = "pointer", e1.features[0].properties.id)) {
                const t = Object.assign({}, e1);
                this._attachPreviewToPictures(t, i);
            }
        }), this.on("mouseleave", i, ()=>{
            this.getZoom() >= $785da19a645c07eb$var$fo || (this.getCanvas().style.cursor = "", this._dropPreview(!0));
        }), this.on("click", i, (e1)=>{
            e1.preventDefault(), this._onSequenceClick(e1);
        }), n && (this.on("mousemove", n, (e1)=>{
            if (this.getZoom() <= 16) {
                this.getCanvas().style.cursor = "pointer";
                const t = Object.assign({}, e1);
                this._attachPreviewToPictures(t, n);
            }
        }), this.on("mouseleave", n, ()=>{
            this.getZoom() >= $785da19a645c07eb$var$fo || (this._dropPreview(), this.getCanvas().style.cursor = "");
        }), this.on("click", n, (e1)=>{
            e1.preventDefault();
            const t = e1.features[0];
            t.properties.best_item ? (this._parent.select(null, t.properties.best_item), this._parent._setFocus?.("pic")) : 2 !== this._parent.mapStyleComposer._getPanoramaxStyleVersion() && this.flyTo({
                center: e1.lngLat,
                zoom: 9
            });
        }));
    }
    _attachPreviewToPictures(e1, t) {
        let i = e1.features.pop();
        const n = i.properties.best_item_relevance ? i.properties.best_item : i.properties.id;
        if (!i) return void this._picPinMarker?.remove?.();
        if (!i || n == this._picPopup._picId) return;
        clearTimeout(this._picPreviewTimer), clearTimeout(this._picDropPreviewTimer), this._picPopup._loading = n, this._picPopup._picId = n, delete this._picPopup._seqId, e1.lngLat || (e1.lngLat = this.getCenter());
        let a = null;
        if (t.includes("_pictures") && "Point" === i.geometry.type) a = i;
        else if (t.includes("_grid") && "Polygon" === i.geometry.type && i.properties.best_item) a = {
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates: i.geometry.coordinates[0][0]
            },
            properties: {
                id: i.properties.best_item
            }
        };
        else if (this.getZoom() < $785da19a645c07eb$var$fo && t.includes("_sequences") && "LineString" === i.geometry.type) {
            let t = null;
            for(let n = 0; n < i.geometry.coordinates.length; n++){
                let r = e1.lngLat.distanceTo(new $785da19a645c07eb$var$Mx(...i.geometry.coordinates[n]));
                (!t || r < t) && (a = {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: i.geometry.coordinates[n]
                    },
                    properties: {
                        first_sequence: i.properties.id,
                        collection: i.properties.id
                    }
                }, t = r);
            }
        }
        a && void 0 !== a.properties.heading ? (this._picPopup._seqId = a.properties.first_sequence, this._picMarkerPreview.setLngLat?.(a.geometry.coordinates).setRotation(a.properties.heading || 0).addTo(this)) : this._picMarkerPreview?.remove?.();
        let r = a ? a.geometry.coordinates : e1.lngLat;
        if ("thumb" === this._options.preview) this._picPopup.setLngLat(r).addTo(this);
        else if ("marker" === this._options.preview && (!a || void 0 === a.properties.heading)) {
            if (!this._picPinMarker) {
                const e1 = $785da19a645c07eb$var$Ue("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Generator: Adobe Illustrator 16.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Capa_1' x='0px' y='0px' width='32' height='32' viewBox='0 0 32 32' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cdefs id='defs19'%3e%3clinearGradient y2='195.90816' x2='212.88858' y1='98.091812' x1='382.31149' gradientUnits='userSpaceOnUse' id='SVGID_1_' gradientTransform='matrix(4.4379641%2c0%2c0%2c4.4379641%2c-886.70524%2c-217.09784)' spreadMethod='pad'%3e %3cstop id='stop4' style='stop-color:%238F2A85' offset='0' /%3e %3cstop id='stop6' style='stop-color:%232570B6' offset='1' /%3e %3c/linearGradient%3e%3clinearGradient xlink:href='%23SVGID_1_' id='linearGradient27' x1='30.55006' y1='29.297422' x2='17.272936' y2='8.0495806' gradientUnits='userSpaceOnUse' gradientTransform='matrix(0.66910611%2c0%2c0%2c0.66910611%2c0%2c1.2499974)' /%3e%3c/defs%3e%3ccircle style='fill:white%3bfill-opacity:1%3bstroke:none%3bstroke-width:5.30813%3bstroke-linecap:square%3bstroke-linejoin:round%3bpaint-order:markers stroke fill' id='path3' cx='15.999331' cy='9.2110214' r='4.1819134' /%3e%3cpath d='m 24.381558%2c9.7115132 c 0%2c-4.6295451 -3.752348%2c-8.3818922 -8.382562%2c-8.3818922 -4.630214%2c0 -8.381892%2c3.7523471 -8.381892%2c8.3818922 0%2c6.6328488 8.381892%2c16.4479668 8.381892%2c16.4479668 0%2c0 8.382562%2c-9.849242 8.382562%2c-16.4479668 z M 11.865259%2c9.2110219 c 0%2c-2.2836592 1.851416%2c-4.1344067 4.134406%2c-4.1344067 2.28299%2c0 4.134407%2c1.8507475 4.134407%2c4.1344067 0%2c2.2836591 -1.851417%2c4.1344071 -4.134407%2c4.1344071 -2.28299%2c0 -4.134406%2c-1.850748 -4.134406%2c-4.1344071 z' fill='%23006df0' id='path1' style='fill:url(%23linearGradient27)%3bstroke-width:0.414563%3bstroke-dasharray:none' /%3e%3ccircle cx='15.998996' cy='9.2110214' r='2.0327444' fill='%23006df0' id='circle1' style='fill:url(%23SVGID_1_)%3bstroke-width:0.414543' /%3e%3cpath d='m 20.738275%2c20.743521 c -0.683158%2c0.9876 -1.324161%2c1.847402 -1.858108%2c2.537919 5.296644%2c0.318495 8.767967%2c1.461997 10.059341%2c2.312431 -1.512849%2c0.997637 -6.007903%2c2.400083 -12.939174%2c2.400083 -6.9306007%2c0 -11.4263246%2c-1.403115 -12.9391735%2c-2.400083 1.2913747%2c-0.850434 4.7600208%2c-1.993267 10.0513115%2c-2.311762 -0.535284%2c-0.690517 -1.176957%2c-1.54965 -1.860784%2c-2.53725 C 4.7339257%2c21.386532 0%2c23.314895 0%2c25.593202 0%2c28.396756 7.1641191%2c30.670379 16.000334%2c30.670379 24.837219%2c30.670379 32%2c28.398095 32%2c25.593202 32.0013%2c23.313557 27.262059%2c21.384524 20.738275%2c20.743521 Z' fill='%23006df0' id='path2' style='fill:%238f2a85%3bfill-opacity:1%3bstroke-width:0.414543' /%3e%3c/svg%3e");
                e1.style.width = "40px", this._picPinMarker = new $785da19a645c07eb$var$bL({
                    element: e1,
                    anchor: "bottom",
                    offset: [
                        0,
                        10
                    ]
                });
            }
            this._picPinMarker.setLngLat(r).addTo(this);
        }
        a || this._picThumbUrl[n] || this._picPopup.setDOMContent($785da19a645c07eb$var$Io(this._parent._t));
        const s = (e1)=>{
            if ("thumb" === this._options.preview && this._picPopup._loading === n) {
                if (e1) {
                    let t = document.createElement("img");
                    t.classList.add("pnx-map-thumb"), t.alt = this._parent._t.map.thumbnail;
                    let a = new Image;
                    if (a.src = e1, a.addEventListener("load", ()=>{
                        this._picPopup._loading === n && (i.properties.hidden ? t.children[0].src = a.src : t.src = a.src, this._picPopup.setDOMContent(t), delete this._picPopup._loading);
                    }), i.properties.hidden) {
                        const e1 = document.createElement("div");
                        e1.classList.add("pnx-map-thumb-legend"), e1.appendChild(document.createTextNode(this._parent._t.map.not_public));
                        const i = document.createElement("div");
                        i.appendChild(t), i.appendChild(e1), t = i;
                    }
                } else this._picPopup.remove();
            }
        };
        this._picPopup._loading === n && (this._picThumbUrl[a?.properties?.id || n] ? s(this._picThumbUrl[a?.properties?.id || n]) : (clearTimeout(this._picPreviewTimer), this._picPreviewTimer = setTimeout(()=>{
            this._picPopup._loading === n && "thumb" === this._options.preview && (this._picPopup.setDOMContent($785da19a645c07eb$var$Io(this._parent._t)), a ? a.properties.id ? this._getPictureThumbURL(a.properties.id, a.properties.collection).then(s) : this._getSequenceThumbURL(i.properties.collection, r).then(s) : t.endsWith("_grid") ? this._getThumbURL(r).then(s) : t.includes("_sequences") && this._getSequenceThumbURL(n, r).then(s));
        }, 100)));
    }
    _getThumbURL(e1) {
        return this._parent.getAPI().getPicturesAroundCoordinates(e1.lat, e1.lng, .1, 1).then((e1)=>{
            const t = e1?.features?.pop();
            return t ? this._parent.getAPI().findThumbnailInPictureFeature(t) : null;
        });
    }
    _getSequenceThumbURL(e1, t) {
        return t ? this._parent.getAPI().getPicturesAroundCoordinates(t.lat || t[1], t.lng || t[0], 1, 1, e1).then((t)=>t?.features?.length > 0 ? this._parent.getAPI().findThumbnailInPictureFeature(t.features[0]) : this._parent.getAPI().getPictureThumbnailURLForSequence(e1)) : this._parent.getAPI().getPictureThumbnailURLForSequence(e1);
    }
    _getPictureThumbURL(e1, t) {
        let i = Promise.resolve();
        return e1 && (void 0 !== this._picThumbUrl[e1] ? i = "string" == typeof this._picThumbUrl[e1] ? Promise.resolve(this._picThumbUrl[e1]) : this._picThumbUrl[e1] : (this._picThumbUrl[e1] = this._parent.getAPI().getPictureThumbnailURL(e1, t).then((t)=>t ? (this._picThumbUrl[e1] = t, t) : (this._picThumbUrl[e1] = null, null)).catch(()=>{
            this._picThumbUrl[e1] = null;
        }), i = this._picThumbUrl[e1])), i;
    }
    _getPictureMarker(e1 = !0) {
        return new $785da19a645c07eb$var$bL({
            element: $785da19a645c07eb$var$Ue(e1 ? "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg width='48' height='48' viewBox='0 0 48 48' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cpath d='m 8.0222924%2c7.8597977 a 22.594107%2c22.594107 0 0 1 31.9555636%2c0.0027 L 24.001409%2c23.838916 Z' style='fill:%23bf360c%3bfill-opacity:1%3bstroke:white%3bstroke-width:2.50003%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' /%3e %3ccircle cx='24' cy='24' r='9.9777565' style='fill:%23ff6f00%3bfill-opacity:1%3bstroke:white%3bstroke-width:2.49449%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' /%3e%3c/svg%3e" : $785da19a645c07eb$var$mo),
            picId: null
        }).setDraggable(e1 && this._options.picMarkerDraggable);
    }
    _onSequenceHover(e1) {
        e1.preventDefault(), e1.features.length > 0 && e1.features[0].properties?.id && this.fire("sequence-hover", {
            seqId: e1.features[0].properties.id
        });
    }
    _onSequenceClick(e1) {
        if (e1.preventDefault(), e1.originalEvent.stopImmediatePropagation(), "pic" !== this._parent.psv?.getPicturesNavigation() && e1.features.length > 0) {
            let t = e1.features[0];
            e1.features.length > 1 && this._picPopup._seqId && (t = e1.features.find((e1)=>e1.properties.id === this._picPopup._seqId) || t), t.properties?.id && this.fire("sequence-click", {
                seqId: t.properties.id,
                coordinates: e1.lngLat
            });
        }
    }
    _onPictureClick(e1) {
        if (e1.preventDefault(), e1.originalEvent.stopImmediatePropagation(), "pic" === this._parent.psv?.getPicturesNavigation()) return;
        const t = this.queryRenderedFeatures(e1.point);
        if (t.length > 1 && t.find((e1)=>e1?.source?.startsWith("sem-"))) return;
        const i = e1?.features?.length > 0 ? e1.features[0] : null;
        if (i?.properties?.id) {
            let t = null;
            try {
                i.properties.sequences && (Array.isArray(i.properties.sequences) || (i.properties.sequences = JSON.parse(i.properties.sequences)), t = i.properties.sequences.pop());
            } catch (e1) {
                console.log("Sequence ID is not available in vector tiles for picture " + i.properties.id);
            }
            this.fire("picture-click", {
                picId: i.properties.id,
                seqId: t,
                feature: i
            });
        }
    }
    addEventListener(e1, t, i = {}) {
        i?.once ? this.once(e1, t) : this.on(e1, t);
    }
};
const $785da19a645c07eb$var$QB = {
    minDate: "date_from",
    maxDate: "date_to",
    pic_type: "pic_type",
    camera: "camera",
    theme: "theme",
    qualityscore: "pic_score",
    gps: "gps"
}, $785da19a645c07eb$var$YB = Object.fromEntries(Object.entries($785da19a645c07eb$var$QB).map((e1)=>[
        e1[1],
        e1[0]
    ])), $785da19a645c07eb$var$JB = [
    "none",
    "null",
    "false",
    !1
], $785da19a645c07eb$var$$B = [
    "antialias",
    "bearing",
    "bearingSnap",
    "bounds",
    "boxZoom",
    "clickTolerance",
    "collectResourceTiming",
    "cooperativeGestures",
    "crossSourceCollisions",
    "doubleClickZoom",
    "dragPan",
    "dragRotate",
    "fadeDuration",
    "failIfMajorPerformanceCaveat",
    "fitBoundsOptions",
    "hash",
    "interactive",
    "localIdeographFontFamily",
    "locale",
    "logoPosition",
    "maplibreLogo",
    "maxBounds",
    "maxCanvasSize",
    "maxPitch",
    "maxTileCacheSize",
    "maxTileCacheZoomLevels",
    "maxZoom",
    "minPitch",
    "minZoom",
    "pitch",
    "pitchWithRotate",
    "pixelRatio",
    "preserveDrawingBuffer",
    "refreshExpiredTiles",
    "renderWorldCopies",
    "scrollZoom",
    "touchPitch",
    "touchZoomRotate",
    "trackResize",
    "transformCameraUpdate",
    "transformRequest",
    "validateStyle"
];
class $785da19a645c07eb$var$eO {
    constructor(e1 = {}, t = {}, i = {}){
        "false" === e1["url-parameters"] && (t = {});
        let n = {};
        "object" == typeof e1?.["psv-options"] && (n = e1["psv-options"]);
        let a = {};
        "object" == typeof e1?.["map-options"] && (a = e1["map-options"]);
        let r = {};
        "object" == typeof i?.map && (r = i.map);
        let s = t.map && "none" !== t.map ? $785da19a645c07eb$var$tO(t.map) : null, o = !$785da19a645c07eb$var$JB.includes(t.map) && !$785da19a645c07eb$var$JB.includes(e1["map-options"]), l = t.focus || e1.focus, c = t.pic || e1.picture, u = t.seq || e1.sequence, h = t.users || e1["endpoint-to-use"] || r.endpoint, d = t.speed || n?.transitionDuration, p = t.nav || n?.picturesNavigation, m = t.theme || a.theme || r?.theme, g = t.background || a.background || r?.background, f = s?.center || !c && (a.center || r?.center) || [
            0,
            0
        ], A = s?.zoom || a.zoom || r?.zoom, _ = s?.pitch || a.pitch, v = s?.bearing || a.bearing, y = t.level || a.indoor?.level, x = e1.geocoder, b = e1.widgets, w = e1["fetch-options"], E = e1.style, k = e1.lang, S = e1.endpoint, M = a.raster, C = a.basemaps, T = a.indoor, D = a.attributionControl, P = a.preview, I = (F = a, Object.fromEntries(Object.entries(F).filter(([e1])=>$785da19a645c07eb$var$$B.includes(e1))));
        var F;
        let z = e1["keyboard-shortcuts"], R = e1["skip-tags-menu-opening"], L1 = "false" === i?.disableAnnotations || n?.displayAnnotations || !1, B = t.xyz, O = t.date_from, U = t.date_to, N = t.pic_type, j = t.camera, V = t.pic_score, q = t.gps, G = t.overlay, H = t.xywh, W = t.annot;
        !o || c || u ? [
            "map",
            "pic"
        ].includes(l) ? "map" !== l || o || (console.warn("Parameter focus can't be 'map' as map is disabled"), l = "pic") : (console.warn("Invalid value for parameter focus:", l), l = !o || c || u ? "pic" : "map") : l = "map", "aerial" !== g || M || (console.warn("Parameter background can't be 'aerial' as no aerial imagery is available"), g = "streets"), y && !T && console.error("Can't set indoor level if indoor= plugin is not available"), !L1 && W && (L1 = !0), W && !c && console.error("Parameter annot can only be used in combination with 'picture'"), [
            "thumb",
            "marker",
            "none"
        ].includes(P) || (P && P.length > 0 && console.warn("Parameter map-options.preview is invalid, should be 'thumb', 'marker' or 'none'"), P = "thumb"), this._parentInit = {
            map: o,
            fetchOptions: w,
            style: E,
            lang: k,
            endpoint: S
        }, this._parentPostInit = {
            focus: l,
            picture: c,
            sequence: u,
            geocoder: x,
            widgets: b,
            users: h,
            forceFocus: !0,
            keyboardShortcuts: !0,
            willLoadPicture: void 0 !== (c || u),
            skipTagsMenuOpening: "true" === R
        }, this._psvInit = Object.assign(Object.fromEntries(Object.entries(n).filter(([e1])=>![
                "transitionDuration",
                "picturesNavigation",
                "displayAnnotations"
            ].includes(e1))), {
            displayAnnotations: L1
        }), this._psvAny = {
            transitionDuration: d,
            picturesNavigation: p
        }, this._psvPostInit = {
            xyz: B,
            xywh: H,
            annotation: W
        }, this._mapInit = {
            raster: M,
            indoor: T,
            attributionControl: D,
            basemaps: C,
            preview: P,
            ...I
        }, this._mapAny = {
            theme: m,
            background: g,
            center: f,
            zoom: A,
            pitch: _,
            bearing: v,
            level: y
        }, this._mapPostInit = {
            date_from: O,
            date_to: U,
            pic_type: N,
            camera: j,
            pic_score: V,
            gps: q,
            overlay: G
        }, "false" === z && (this._psvInit.keyboard = !1, this._psvInit.keyboardActions = {}, this._mapInit.keyboard = !1, this._parentPostInit.keyboardShortcuts = !1);
    }
    _sanitize(e1) {
        return Object.fromEntries(Object.entries(e1).filter(([, e1])=>void 0 !== e1));
    }
    getParentInit() {
        return this._sanitize(this._parentInit);
    }
    getParentPostInit() {
        return this._sanitize(this._parentPostInit);
    }
    getPSVInit() {
        return this._sanitize(Object.assign({}, this._psvInit, this._psvAny));
    }
    getPSVPostInit() {
        return this._sanitize(Object.assign({}, this._psvPostInit, this._psvAny));
    }
    getMapInit() {
        return this._sanitize(Object.assign({}, this._mapInit, this._mapAny));
    }
    getMapPostInit() {
        return this._sanitize(Object.assign({}, this._mapPostInit, this._mapAny));
    }
    static GetComponentProperties(e1, t) {
        const i = {};
        for(let n in e1.properties)e1.properties[n].state || null == t[n] || (i[n] = t[n]);
        return i;
    }
}
function $785da19a645c07eb$var$tO(e1, t) {
    const i = (e1 || "").split("/");
    if (i.length >= 3 && !i.some((e1)=>isNaN(e1))) {
        const e1 = {
            center: [
                +i[2],
                +i[1]
            ],
            zoom: +i[0],
            pitch: +(i[4] || 0)
        };
        return t && (e1.bearing = t.dragRotate.isEnabled() && t.touchZoomRotate.isEnabled() ? +(i[3] || 0) : t.getBearing()), e1;
    }
    return null;
}
function $785da19a645c07eb$var$iO(e1, t) {
    let i = t.transitionDuration || t.speed;
    void 0 !== i && e1.setTransitionDuration(i);
    let n = t.picturesNavigation || t.nav;
    [
        "none",
        "pic",
        "any",
        "seq"
    ].includes(n) && e1.setPicturesNavigation(n);
    const a = ()=>{
        if (t.xyz) {
            const i = function(e1) {
                const t = (e1 || "").split("/");
                return 3 !== t.length || t.some((e1)=>isNaN(e1)) ? null : {
                    x: +t[0],
                    y: +t[1],
                    z: +t[2]
                };
            }(t.xyz);
            e1.setXYZ(i.x, i.y, i.z);
        }
        if (t.xywh) {
            const i = function(e1, t) {
                let i = (e1 || "").split(",");
                if (4 !== i.length || i.some((e1)=>isNaN(e1))) return null;
                {
                    let [e1, n, a, r] = i.map((e1)=>parseFloat(e1)), s = t.panorama.basePanoData;
                    if ("function" == typeof s) {
                        const e1 = t?.properties?.["pers:interior_orientation"]?.sensor_array_dimensions;
                        s = e1 && 2 === e1.length ? s({
                            width: e1[0],
                            height: e1[1]
                        }) : null;
                    }
                    if (!s?.fullWidth || !s?.fullHeight) return null;
                    const o = s?.croppedX || 0, l = s?.croppedY || 0, c = o + e1 + a / 2 - s.fullWidth / 2, u = -(l + n + r / 2 - s.fullHeight / 2), h = c / s.fullWidth, d = u / s.fullHeight, p = (a / s.fullWidth + r / s.fullHeight) / 2;
                    return {
                        yaw: 2 * h * Math.PI,
                        pitch: d * Math.PI,
                        z: 100 * (1 - p)
                    };
                }
            }(t.xywh, e1.getPictureMetadata());
            e1.rotate(i), e1.zoom(i.z);
        }
        t.annotation && e1.focusOnAnnotation(t.annotation);
    };
    e1.getPictureMetadata() ? a() : e1.addEventListener("picture-loaded", a, {
        once: !0
    });
}
function $785da19a645c07eb$var$nO(e1, t) {
    const i = $785da19a645c07eb$var$tO(t.map, e1);
    i && e1.jumpTo(i), e1.setFilters?.(function(e1) {
        const t = {};
        for(let i in $785da19a645c07eb$var$YB)e1[i] && (t[$785da19a645c07eb$var$YB[i]] = e1[i]);
        if (t.qualityscore) {
            let e1 = t.qualityscore.split("");
            const i = {
                A: 5,
                B: 4,
                C: 3,
                D: 2,
                E: 1
            };
            t.qualityscore = e1.map((e1)=>i[e1]);
        }
        return t;
    }(t)), e1._parent?.mapStyleComposer?.layerRanges.basemaps[t.background] && e1._parent.mapStyleComposer.switchBasemap(t.background), t.overlay && t.overlay.split(",").forEach((t)=>e1._parent.mapStyleComposer.switchDataOverlayVisibility("sem-" + t, !0));
}
function $785da19a645c07eb$var$aO(e1, t) {
    let i = t.picture || t.pic, n = t.sequence || t.seq || null;
    if (i) {
        const t = i.split(";");
        t.length > 1 && console.warn("Multiple picture IDs passed in URL, only first one kept"), e1.select(1 === t.length ? n : null, t[0], !0);
    } else n ? e1.select(n, null, !0) : e1.select();
}
function $785da19a645c07eb$var$rO(e1, t) {
    $785da19a645c07eb$var$aO(e1, t), "map" === t.focus && e1?.map ? (e1.setPopup(!1), e1._setFocus("map", null, t.forceFocus)) : "pic" === t.focus && e1?.mini ? (e1.setPopup(!1), e1._setFocus("pic", null, t.forceFocus)) : t.focus && "meta" === t.focus && e1?.mini && e1._setFocus("pic", null, t.forceFocus), null != t.users && ($785da19a645c07eb$var$Bo(t.users) ? e1.mapStyleComposer._createPanoramaxEndpointForUser(t.users) : e1.mapStyleComposer.switchPanoramaxEndpoint(t.users));
}
const $785da19a645c07eb$var$sO = [
    "streets",
    "aerial"
];
class $785da19a645c07eb$var$oO extends EventTarget {
    constructor(e1){
        super(), this._parent = e1, this.map = null, this._mapUpdateDebounce = null, this.layerRanges = {
            basemaps: {},
            dataUnderlays: {},
            panoramax: {},
            dataOverlays: {}
        }, this.basemap = null, this.dataUnderlays = new Set, this.panoramax = null, this.dataOverlays = new Set, this.detachedSources = {}, this.panoramaxTheme = $785da19a645c07eb$var$Po.default.id, this.panoramaxFilters = {}, this.panoramaxOriginalStyle = {};
    }
    getMapStyle() {
        let e1 = {}, t = [], i = [], n = {}, a = [];
        const r = (e1)=>(this.map && (e1 || []).filter((e1)=>this.map.getLayer(e1.id)).forEach((e1)=>{
                const t = this.map.getFilter(e1.id);
                t && (e1.filter = t);
            }), e1), s = (e1)=>{
            (e1 || []).forEach((e1)=>{
                $785da19a645c07eb$var$zo(e1) ? i.push(e1) : t.push(e1);
            });
        }, o = (e1, t)=>{
            Array.isArray(e1) ? a = a.concat(e1) : "object" == typeof e1 && null != e1 ? a.push(e1) : "string" == typeof e1 && a.push({
                id: t,
                url: e1
            });
        };
        if (Object.entries(this.detachedSources).forEach(([t, i])=>e1[t] = i), this.basemap && this.layerRanges.basemaps[this.basemap] && (e1 = Object.assign(e1, this.layerRanges.basemaps[this.basemap].sources), s(this.layerRanges.basemaps[this.basemap].layers), n = this.layerRanges.basemaps[this.basemap].metadata || {}, o(this.layerRanges.basemaps[this.basemap].sprite, this.basemap), n?.["panoramax:locales"] || (n["panoramax:locales"] = [
            "fr",
            "en",
            "de",
            "es",
            "ru",
            "pt",
            "zh",
            "hi",
            "latin"
        ])), [
            ...this.dataUnderlays
        ].forEach((t)=>{
            this.layerRanges.dataUnderlays[t] && (e1 = Object.assign(e1, this.layerRanges.dataUnderlays[t].sources), s(r(this.layerRanges.dataUnderlays[t].layers)), o(this.layerRanges.dataUnderlays[t].sprite, t));
        }), this.panoramax && this.layerRanges.panoramax[this.panoramax]) {
            n = Object.assign(n, this.layerRanges.panoramax[this.panoramax].metadata), e1 = Object.assign(e1, this.layerRanges.panoramax[this.panoramax].sources), o(this.layerRanges.panoramax[this.panoramax].sprite, this.panoramax);
            let t = this._applyPanoramaxThemeOnLayers(this.layerRanges.panoramax[this.panoramax]);
            t = this._applyPanoramaxFiltersOnLayers(t, this.layerRanges.panoramax[this.panoramax].metadata), s(t);
        }
        if ([
            ...this.dataOverlays
        ].forEach((t)=>{
            this.layerRanges.dataOverlays[t] && (e1 = Object.assign(e1, this.layerRanges.dataOverlays[t].sources), s(r(this.layerRanges.dataOverlays[t].layers)), o(this.layerRanges.dataOverlays[t].sprite, t));
        }), n["panoramax:locales"]) {
            let e1 = this._parent.lang || $785da19a645c07eb$var$ht(n["panoramax:locales"], "latin");
            e1.includes("-") && (e1 = e1.split("-")[0]), e1.includes("_") && (e1 = e1.split("_")[0]), i.forEach((t)=>{
                t.layout["text-field"].includes("name:latin") && (t.layout["text-field"] = [
                    "coalesce",
                    [
                        "get",
                        `name:${e1}`
                    ],
                    [
                        "get",
                        "name:latin"
                    ],
                    [
                        "get",
                        "name"
                    ]
                ]);
            });
        }
        const l = i.find((e1)=>"place_label_city" === e1.id);
        let c = i.find((e1)=>"place_label_capital" === e1.id);
        return l && !c && (l.paint = {
            "text-color": "hsl(0, 0%, 0%)",
            "text-halo-blur": 0,
            "text-halo-color": "hsla(0, 0%, 100%, 1)",
            "text-halo-width": 3
        }, l.layout["text-letter-spacing"] = .1, c = JSON.parse(JSON.stringify(l)), c.id = "place_label_capital", c.filter = c.filter.filter((e1)=>!(">" === e1[0] && "capital" === e1[1])), c.filter.push([
            "<=",
            "capital",
            2
        ]), l.filter.find((e1)=>">" === e1[0] && "capital" === e1[1]) || l.filter.push([
            ">",
            "capital",
            2
        ]), i.push(c)), e1.plan_ign && (e1.plan_ign.maxzoom = 18), e1.openmaptiles && !(e1.openmaptiles.attribution || "").includes("OpenMapTiles") && (e1.openmaptiles.attribution += " | \xa9 <a href='https://openmaptiles.org/'>OpenMapTiles</a>"), {
            version: 8,
            name: "Panoramax Map Style",
            sources: e1,
            layers: t.concat(i).filter((e1)=>e1.id),
            metadata: n,
            sprite: a.length > 0 ? a : void 0
        };
    }
    updateMapStyle(e1 = !1) {
        clearTimeout(this._mapUpdateDebounce), this._mapUpdateDebounce = setTimeout(()=>{
            this.map?.setStyle(this.getMapStyle(), {
                diff: !0
            }), e1 && (this.map._semMapProtocol.clearCache(), Object.entries(this.map?.getStyle()?.sources || {}).filter(([, e1])=>e1.tiles && e1.tiles[0].startsWith("sem")).forEach(([e1])=>{
                const t = this.map.getSource(e1);
                t.setTiles(t.tiles);
            }));
        }, 10);
    }
    registerSource(e1, t) {
        let i = !1;
        const n = Object.keys(this.layerRanges);
        for(let t = 0; t < n.length; t++){
            const a = this.layerRanges[n[t]], r = Object.keys(a);
            for(let t = 0; t < r.length; t++)if (r[t] === e1) {
                i = !0;
                break;
            }
            if (i) break;
        }
        i || ("indoorequal" === e1 && (t.attribution = '<a href="https://indoorequal.org/" target="_blank">\xa9 indoor=</a>'), this.detachedSources[e1] = t);
    }
    registerLayer(e1, t) {
        let i = "dataOverlays";
        if (("indoorequal" === e1.source || t) && (i = "dataUnderlays"), "indoorequal" === e1.source && "indoor-heat" === e1.id && !1 === this._parent?._initParams?.getMapInit()?.indoor?.heatmap) return;
        let n = !1;
        if (Object.values(this.layerRanges[i]).forEach((t)=>{
            t.sources[e1.source] && (t.layers || (t.layers = []), t.layers.push(e1), n = !0);
        }), n) return;
        let a = {
            sources: {},
            layers: [
                e1
            ]
        };
        this.detachedSources[e1.source] && (a.sources[e1.source] = this.detachedSources[e1.source], delete this.detachedSources[e1.source], "dataOverlays" === i ? this.addDataOverlay(e1.id, a, !0) : "dataUnderlays" === i && this.addDataUnderlay(e1.id, a, !0));
    }
    async waitFor(e1, t) {
        return this.layerRanges[e1][t] ? await Promise.resolve() : await new Promise((e1)=>setTimeout(e1, 250)).then(()=>this.waitFor(e1, t));
    }
    async addBasemap(e1, t, i = !1) {
        "string" == typeof t && (t = await fetch(t).then((e1)=>e1.json())), this.layerRanges.basemaps[e1] = t, this.dispatchEvent(new CustomEvent("basemap-added", {
            detail: {
                basemap: e1
            }
        })), i && this.switchBasemap(e1);
    }
    async switchBasemap(e1) {
        e1 && !this.layerRanges.basemaps[e1] && await this.waitFor("basemaps", e1), this.basemap !== e1 && e1 && (this.basemap = e1, this.updateMapStyle(), this.dispatchEvent(new CustomEvent("basemap-changed", {
            detail: {
                basemap: e1
            }
        })));
    }
    hasManyBasemaps() {
        return Object.keys(this.layerRanges.basemaps).length >= 2;
    }
    hasStreetsAerialBasemaps() {
        return null != this.layerRanges.basemaps.aerial && null != this.layerRanges.basemaps.streets;
    }
    hasComplementaryBasemaps() {
        return null != Object.keys(this.layerRanges.basemaps).find((e1)=>!$785da19a645c07eb$var$sO.includes(e1));
    }
    addDataUnderlay(e1, t, i = !1) {
        this.layerRanges.dataUnderlays[e1] = t, this.dispatchEvent(new CustomEvent("dataunderlay-added", {
            detail: {
                dataUnderlay: e1
            }
        })), i && this.switchDataUnderlayVisibility(e1, !0);
    }
    async switchDataUnderlayVisibility(e1, t) {
        e1 && !this.layerRanges.dataUnderlays[e1] && await this.waitFor("dataUnderlays", e1), t ? this.dataUnderlays.add(e1) : this.dataUnderlays.delete(e1), this.updateMapStyle(), this.dispatchEvent(new CustomEvent("dataunderlay-changed", {
            detail: {
                dataUnderlay: e1,
                visible: t
            }
        }));
    }
    addPanoramaxEndpoint(e1, t, i = !1) {
        [
            null,
            void 0,
            1
        ].includes(t.metadata?.["panoramax:tiles_version"]) && Object.values(t?.sources || {}).filter((e1)=>e1.tiles).forEach((e1)=>e1.tiles = e1.tiles.map((e1)=>e1.replace(/^http/, "panora"))), this.layerRanges.panoramax[e1] = t, this.panoramaxOriginalStyle[e1] = JSON.parse(JSON.stringify(t)), this.layerRanges.panoramax[e1].layers = $785da19a645c07eb$var$Lo(t), this.dispatchEvent(new CustomEvent("panoramax-added", {
            detail: {
                endpoint: e1
            }
        })), i && this.switchPanoramaxEndpoint(e1);
    }
    async switchPanoramaxEndpoint(e1) {
        e1 && !this.layerRanges.panoramax[e1] && await this.waitFor("panoramax", e1), e1 && e1 !== this.panoramax && (this.panoramax = e1, this.updateMapStyle(!0)), this.dispatchEvent(new CustomEvent("panoramax-changed", {
            detail: {
                endpoint: e1
            }
        }));
    }
    isPanoramaxEndpointSingleUser() {
        return $785da19a645c07eb$var$Bo(this.panoramax);
    }
    setPanoramaxTheme(e1) {
        e1 !== this.panoramaxTheme && (this.panoramaxTheme = e1, this.updateMapStyle(), this.dispatchEvent(new CustomEvent("theme-changed", {
            detail: {
                theme: e1
            }
        })));
    }
    setPanoramaxFilters(e1) {
        this.panoramaxFilters = e1, this.updateMapStyle(), this.dispatchEvent(new CustomEvent("filters-changed", {
            detail: e1
        }));
    }
    addDataOverlay(e1, t, i = !1) {
        this.layerRanges.dataOverlays[e1] = t, this.dispatchEvent(new CustomEvent("dataoverlay-added", {
            detail: {
                dataOverlay: e1
            }
        })), i && this.switchDataOverlayVisibility(e1, !0);
    }
    async switchDataOverlayVisibility(e1, t) {
        e1 && !this.layerRanges.dataOverlays[e1] && await this.waitFor("dataOverlays", e1), t ? this.dataOverlays.add(e1) : this.dataOverlays.delete(e1), this.updateMapStyle(), this.dispatchEvent(new CustomEvent("dataoverlay-changed", {
            detail: {
                dataOverlay: e1,
                visible: t
            }
        }));
    }
    async _createPanoramaxEndpointFromAPI(e1, t, i = !0) {
        let n;
        t._endpoints.style ? n = t._endpoints.style : t._endpoints.tiles && (n = {
            sources: {
                geovisio: {
                    type: "vector",
                    tiles: [
                        t._endpoints.tiles
                    ]
                }
            }
        }), n && "string" == typeof n && (n = await fetch(n, t._getFetchOptions()).then((e1)=>e1.json())), n && n.sources && this.addPanoramaxEndpoint(e1, n, i);
    }
    async _createPanoramaxEndpointForUser(e1) {
        if (!$785da19a645c07eb$var$Bo(e1)) return;
        if (this.layerRanges.panoramax[e1]) return void this.switchPanoramaxEndpoint(e1);
        let t, i, n;
        e1.startsWith("metacatalog_") ? (i = this._parent.apiMC, n = e1.replace(/^metacatalog_/, "")) : (i = this._parent.api, n = e1), i._endpoints.user_style ? t = i._endpoints.user_style.replace(/\{userId\}/g, n) : i._endpoints.user_tiles && (t = {
            sources: {
                [`geovisio_${n}`]: {
                    tiles: [
                        i._endpoints.user_tiles.replace(/\{userId\}/g, n)
                    ]
                }
            }
        }), t && "string" == typeof t && (t = await fetch(t, i._getFetchOptions()).then((e1)=>e1.json())), t && t.sources && this.addPanoramaxEndpoint(e1, t, !0);
    }
    _createManyBasemaps(e1, t) {
        const i = /\{z:(\d+)\}/;
        Object.entries(e1).forEach(([e1, n])=>{
            if ("string" == typeof n && n.includes(".png")) {
                let t, a;
                const r = n.match(i);
                r && r.length > 1 && (t = parseInt(r[1]), n = n.replace(i, "{z}")), (n.includes("osm") || n.includes("openstreetmap")) && (a = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'), n = {
                    sources: {
                        [e1]: {
                            type: "raster",
                            tiles: [
                                n
                            ],
                            tileSize: 256,
                            maxzoom: t,
                            attribution: a
                        }
                    },
                    layers: [
                        {
                            id: e1,
                            type: "raster",
                            source: e1
                        }
                    ]
                };
            }
            this.addBasemap(e1, n, e1 === t);
        });
    }
    _createRasterBasemap(e1) {
        return this.addBasemap("aerial", {
            sources: {
                [$785da19a645c07eb$var$go]: e1
            },
            layers: [
                {
                    id: $785da19a645c07eb$var$go,
                    type: "raster",
                    source: $785da19a645c07eb$var$go
                }
            ]
        }), $785da19a645c07eb$var$go;
    }
    _applyPanoramaxThemeOnLayers(e1) {
        const t = 2 === e1.metadata?.["panoramax:tiles_version"], i = this._parent.psv ? this._parent.psv?._myVTour?.state?.loadingNode || this._parent.psv?._myVTour?.state?.currentNode?.id : this._parent.picture, n = this._parent.psv ? i ? this._parent.psv?._picturesSequences[i] : null : this._parent.sequence;
        return e1.layers = e1.layers.map((i)=>{
            const a = i.id.endsWith("_pictures"), r = i.id.endsWith("_sequences"), s = i.id.endsWith("_grid");
            if (i.layout || (i.layout = {}), i.paint || (i.paint = {}), a || r) {
                const e1 = [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "hidden"
                        ],
                        !0
                    ],
                    90
                ];
                r && n ? e1.push([
                    "==",
                    [
                        "get",
                        "id"
                    ],
                    n
                ], 100) : a && n && e1.push([
                    "in",
                    n,
                    [
                        "get",
                        "sequences"
                    ]
                ], 100), e1.push(...$785da19a645c07eb$var$Po[this.panoramaxTheme].sort), e1.push(10), i.layout[(a ? "circle" : "line") + "-sort-key"] = e1;
                const t = [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "hidden"
                        ],
                        !0
                    ],
                    $785da19a645c07eb$var$Te.HIDDEN
                ];
                r && n ? t.push([
                    "==",
                    [
                        "get",
                        "id"
                    ],
                    n
                ], $785da19a645c07eb$var$Te.SELECTED) : a && n && t.push([
                    "in",
                    n,
                    [
                        "get",
                        "sequences"
                    ]
                ], $785da19a645c07eb$var$Te.SELECTED), "default" === this.panoramaxTheme ? t.push($785da19a645c07eb$var$Te.BASE) : t.push(...$785da19a645c07eb$var$Po[this.panoramaxTheme].color), i.paint[(a ? "circle" : "line") + "-color"] = t, a && (i.paint["circle-stroke-color"] = t);
            }
            if (s) {
                const n = t ? "fill-color" : "circle-color";
                if (i.paint[n] = [
                    "case",
                    ...$785da19a645c07eb$var$Po[this.panoramaxTheme].color
                ], t && (i.paint["fill-opacity"] = "score" === this.panoramaxTheme ? .8 : .5), "default" === this.panoramaxTheme) {
                    let t = "coef";
                    this.panoramaxFilters.pic_type && (t = "flat" === this.panoramaxFilters.pic_type ? "coef_flat_pictures" : "coef_360_pictures", $785da19a645c07eb$var$Ro(e1) && $785da19a645c07eb$var$tt() && (t = "logged_" + t)), i = $785da19a645c07eb$var$Oo(i, t);
                }
            }
            return i;
        }), e1.layers;
    }
    _applyPanoramaxFiltersOnLayers(e1, t) {
        const i = this.panoramaxFilters, n = 2 === t?.["panoramax:tiles_version"];
        return e1.forEach((e1)=>{
            const t = e1.id.endsWith("_pictures"), a = e1.id.endsWith("_sequences") || e1.id.endsWith("_sequences_plus"), r = e1.id.endsWith("_grid");
            if (!(t || a || r && n)) return;
            let s = [];
            if (i.minDate && "" !== i.minDate && (t ? s.push([
                ">=",
                [
                    "get",
                    "ts"
                ],
                i.minDate
            ]) : (a || n && r) && s.push([
                ">=",
                [
                    "get",
                    "date"
                ],
                i.minDate
            ])), i.maxDate && "" !== i.maxDate && ((a || n && r) && s.push([
                "<=",
                [
                    "get",
                    "date"
                ],
                i.maxDate
            ]), t)) {
                let e1 = new Date(i.maxDate);
                e1.setDate(e1.getDate() + 1), e1 = e1.toISOString().split("T")[0], s.push([
                    "<=",
                    [
                        "get",
                        "ts"
                    ],
                    e1
                ]);
            }
            i.pic_type && "" !== i.pic_type && (i.pic_type = "flat" === i.pic_type ? "flat" : "equirectangular", (a || t || n && r) && s.push([
                "==",
                [
                    "get",
                    "type"
                ],
                i.pic_type
            ])), i.qualityscore && i.qualityscore.length > 0 && (a || t || n && r) && s.push([
                "in",
                $785da19a645c07eb$var$Eo,
                [
                    "literal",
                    i.qualityscore
                ]
            ]), i.gps && i.gps.length > 0 && (a || t || n && r) && s.push([
                "in",
                $785da19a645c07eb$var$wo,
                [
                    "literal",
                    i.gps
                ]
            ]), t && i.featuresRestrictions?.pictures && i.featuresRestrictions.pictures.features?.length >= 0 && ("keep" === i.featuresRestrictions.pictures.rule ? s.push([
                "in",
                [
                    "get",
                    "id"
                ],
                [
                    "literal",
                    i.featuresRestrictions.pictures.features
                ]
            ]) : i.featuresRestrictions.pictures.features.length > 0 && s.push([
                "!",
                [
                    "in",
                    [
                        "get",
                        "id"
                    ],
                    [
                        "literal",
                        i.featuresRestrictions.pictures.features
                    ]
                ]
            ])), a && i.featuresRestrictions?.sequences && i.featuresRestrictions.sequences.features?.length >= 0 && ("keep" === i.featuresRestrictions.sequences.rule ? s.push([
                "in",
                [
                    "get",
                    "id"
                ],
                [
                    "literal",
                    i.featuresRestrictions.sequences.features
                ]
            ]) : i.featuresRestrictions.sequences.features.length > 0 && s.push([
                "!",
                [
                    "in",
                    [
                        "get",
                        "id"
                    ],
                    [
                        "literal",
                        i.featuresRestrictions.sequences.features
                    ]
                ]
            ])), 0 === s.length ? s = [
                "literal",
                !0
            ] : (s.unshift("all"), t && (s = [
                "step",
                [
                    "zoom"
                ],
                !0,
                $785da19a645c07eb$var$fo,
                s
            ])), s && (e1.filter = s);
        }), e1;
    }
    _hideMapFilters() {
        return 2 !== this._getPanoramaxStyleVersion() && this._parent.map.getZoom() < 7;
    }
    _getPanoramaxStyleVersion() {
        return this.layerRanges.panoramax[this.panoramax]?.metadata?.["panoramax:tiles_version"] || 1;
    }
}
const $785da19a645c07eb$var$lO = new CSSStyleSheet;
$785da19a645c07eb$var$lO.replaceSync("pnx-coverage-map {\n\tdisplay: block;\n\tposition: relative;\n}\n\npnx-coverage-map .maplibregl-map {\n\tposition: absolute;\n\tinset: 0;\n\tbackground-color: white;\n}\n"), document.adoptedStyleSheets.push($785da19a645c07eb$var$lO);
class $785da19a645c07eb$var$cO extends $785da19a645c07eb$var$po {
    static properties = {
        "map-options": {
            converter: $785da19a645c07eb$var$po.GetJSONConverter()
        },
        "map-style": {
            type: String
        },
        user: {
            type: String
        },
        ...$785da19a645c07eb$var$po.properties
    };
    constructor(){
        super(), this["map-style"] = this.getAttribute("map-style") || "https://panoramax.openstreetmap.fr/pmtiles/basic.json";
        try {
            this["map-style"] = JSON.parse(this["map-style"]);
        } catch (e1) {}
        this._mapContainer = document.createElement("div");
    }
    connectedCallback() {
        super.connectedCallback(), this.mapStyleComposer = new $785da19a645c07eb$var$oO(this), this.mapStyleComposer.addBasemap("streets", this["map-style"], !0), this.onceAPIReady().then(()=>{
            this.loader.setAttribute("value", 30), this._initParams = new $785da19a645c07eb$var$eO($785da19a645c07eb$var$eO.GetComponentProperties($785da19a645c07eb$var$cO, this));
            const e1 = this.user && "" != this.user;
            this.mapStyleComposer._createPanoramaxEndpointFromAPI("default", this.api, !e1), e1 && this.mapStyleComposer._createPanoramaxEndpointForUser(this.user), this._initMap();
        });
    }
    attributeChangedCallback(e1, t, i) {
        super.attributeChangedCallback(e1, t, i), "user" === e1 && 1 === this.api?._isReady && (i && "" != i ? this.mapStyleComposer._createPanoramaxEndpointForUser(i) : this.mapStyleComposer.switchPanoramaxEndpoint("default"));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.map?.destroy();
    }
    getClassName() {
        return "CoverageMap";
    }
    onceReady() {
        return this.map && this.map.waitForEnoughMapLoaded ? this.map.waitForEnoughMapLoaded() : new Promise((e1)=>setTimeout(e1, 100)).then(this.onceReady.bind(this));
    }
    render() {
        return [
            this.loader,
            this._mapContainer
        ];
    }
    getSubComponentsNames() {
        return super.getSubComponentsNames().concat([
            "map",
            "mapStyleComposer"
        ]);
    }
    _initMap() {
        this.map = new $785da19a645c07eb$var$XB(this, this._mapContainer, Object.assign({}, this._initParams.getMapInit(), {
            hash: !0
        })), this.map.addControl(new $785da19a645c07eb$var$uL({
            showCompass: !1
        })), this.loader.setAttribute("value", 70), this.addEventListener("select", this._onSelect.bind(this)), this.map.on("picture-click", (e1)=>this.select(e1.seqId, e1.picId)), this.map.on("sequence-click", (e1)=>this.select(e1.seqId)), this.map.waitForEnoughMapLoaded().then(()=>{
            $785da19a645c07eb$var$nO(this.map, this._initParams.getMapPostInit()), this.loader.dismiss();
        });
    }
    _onSelect(e1) {
        if (e1.detail.picId || e1.detail.seqId) {
            const t = this.map.getLayersOrder().find((t)=>t.endsWith(e1.detail.picId ? "pictures" : "sequences")), i = this.map.queryRenderedFeatures({
                layers: [
                    t
                ],
                filter: [
                    "==",
                    [
                        "get",
                        "id"
                    ],
                    e1.detail.picId || e1.detail.seqId
                ]
            });
            i.length >= 0 && null != i[0] && this.map._attachPreviewToPictures({
                features: i
            }, t);
        } else this.map._dropPreview();
    }
}
customElements.define("pnx-coverage-map", $785da19a645c07eb$var$cO);
const $785da19a645c07eb$var$uO = $785da19a645c07eb$var$Ne("data:image/svg+xml,%3csvg viewBox='0 0 64 64' width='64' height='64' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cpath d='M 27.359486%2c12.65513 1.4316349%2c43.49917 c -3.2999082%2c3.906014 -0.53876046%2c9.96707 4.6468097%2c9.96707 H 57.934146 c 5.118225%2c0 7.946718%2c-5.993711 4.64681%2c-9.96707 L 36.653105%2c12.65513 c -2.424422%2c-2.8284931 -6.869197%2c-2.8284931 -9.293619%2c0 z' style='fill: currentColor%3bfill-opacity:1%3bstroke-width:0.673451' /%3e%3c/svg%3e", "white"), $785da19a645c07eb$var$hO = $785da19a645c07eb$var$Ne("data:image/svg+xml,%3csvg viewBox='0 0 64 192' width='64' height='192' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3ccircle cx='32' cy='32' r='29.897806' style='fill: currentColor%3bfill-opacity:1%3bstroke:white%3bstroke-width:4.20439%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1' /%3e%3cpath d='m 34.279873%2c20.262171 6.711442%2c6.714294 c 0.891465%2c0.891465 2.339986%2c0.891465 3.231451%2c0 0.891466%2c-0.891465 0.891466%2c-2.339985 0%2c-3.23145 -9.662902%2c-9.665829 -3.794285%2c-3.794286 -8.180297%2c-8.180298 -1.071396%2c-1.074322 -2.525696%2c-1.677165 -4.039972%2c-1.677165 -1.517129%2c0 -2.968576%2c0.602858 -4.042825%2c1.677165 l -8.180298%2c8.180298 c -0.894317%2c0.891465 -0.894317%2c2.339986 0%2c3.23145 0.891466%2c0.891465 2.339987%2c0.891465 3.231452%2c0 l 6.697106%2c-6.694253 v 27.703943 c 0%2c0 -0.109706%2c2.126292 2.285971%2c2.126292 2.395676%2c0 2.28597%2c-2.126292 2.28597%2c-2.126292 z' style='fill:white%3bfill-opacity:1%3bfill-rule:evenodd%3bstroke-width:0.731429' /%3e%3c/svg%3e", $785da19a645c07eb$var$Te.NEXT);
function $785da19a645c07eb$var$dO(e1) {
    if (!([
        null,
        void 0,
        ""
    ].includes(e1) || "string" == typeof e1 && "" === e1.trim())) {
        if ("number" == typeof e1) return e1;
        if ("string" != typeof e1) ;
        else {
            if (/^-?\d+(\.\d+)?\/-?\d+(\.\d+)?$/.test(e1)) {
                const t = e1.split("/").map((e1)=>parseFloat(e1));
                return t[0] / t[1];
            }
            try {
                return parseFloat(e1);
            } catch (e1) {}
        }
    }
}
function $785da19a645c07eb$var$pO(e1) {
    let t = null;
    const i = e1?.properties?.["quality:horizontal_accuracy"] || $785da19a645c07eb$var$dO(e1?.properties?.exif?.["Exif.GPSInfo.GPSHPositioningError"]), n = $785da19a645c07eb$var$dO(e1?.properties?.exif?.["Exif.GPSInfo.GPSDOP"]);
    return void 0 !== i ? t = `${i} m` : void 0 !== n && (t = n < 1 ? "ideal" : n < 2 ? "excellent" : n < 5 ? "good" : n < 10 ? "moderate" : n < 20 ? "fair" : "poor"), t;
}
function $785da19a645c07eb$var$mO(e1) {
    let t = e1.properties?.["view:azimuth"];
    if (void 0 === t) {
        const i = $785da19a645c07eb$var$dO(e1.properties?.exif?.["Exif.GPSInfo.GPSImgDirection"]);
        void 0 !== i && (t = i);
    }
    t = t || 0;
    let i = e1.properties?.["pers:yaw"], n = [
        "Xmp.GPano.PoseHeadingDegrees",
        "Xmp.Camera.Yaw",
        "Exif.MpfInfo.MPFYawAngle"
    ];
    if (void 0 === i) for (let t of n){
        const n = $785da19a645c07eb$var$dO(e1.properties?.exif?.[t]);
        if (void 0 !== n) {
            i = n;
            break;
        }
    }
    i = i || 0, Math.round(t) === Math.round(i) && i > 0 && console.warn("Picture with UUID", e1.id, "has same GPS Image direction and Yaw, could cause rendering issues");
    let a = e1.properties?.["pers:pitch"];
    if (n = [
        "Xmp.GPano.PosePitchDegrees",
        "Xmp.Camera.Pitch",
        "Exif.MpfInfo.MPFPitchAngle"
    ], void 0 === a) for (let t of n){
        const i = $785da19a645c07eb$var$dO(e1.properties?.exif?.[t]);
        if (void 0 !== i) {
            a = i;
            break;
        }
    }
    a = a || 0;
    let r = e1.properties?.["pers:roll"];
    if (n = [
        "Xmp.GPano.PoseRollDegrees",
        "Xmp.Camera.Roll",
        "Exif.MpfInfo.MPFRollAngle"
    ], void 0 === r) for (let t of n){
        const i = $785da19a645c07eb$var$dO(e1.properties?.exif?.[t]);
        if (void 0 !== i) {
            r = i;
            break;
        }
    }
    r = r || 0;
    return !(360 === e1.properties?.["pers:interior_orientation"]?.field_of_view) && (0 !== a || 0 !== r) || 0 !== a && 0 !== r ? {
        pan: $785da19a645c07eb$var$at(i),
        tilt: $785da19a645c07eb$var$at(-a),
        roll: $785da19a645c07eb$var$at(r)
    } : {};
}
function $785da19a645c07eb$var$gO(e1, t) {
    let i;
    if (e1.properties?.["pers:interior_orientation"] && e1.properties["pers:interior_orientation"]?.visible_area && e1.properties["pers:interior_orientation"]?.sensor_array_dimensions) {
        const t = e1.properties["pers:interior_orientation"].visible_area, n = e1.properties["pers:interior_orientation"].sensor_array_dimensions;
        try {
            i = {
                fullWidth: parseInt(n[0]),
                fullHeight: parseInt(n[1]),
                croppedX: parseInt(t[0]),
                croppedY: parseInt(t[1]),
                croppedWidth: parseInt(n[0]) - parseInt(t[2]) - parseInt(t[0]),
                croppedHeight: parseInt(n[1]) - parseInt(t[3]) - parseInt(t[1])
            };
        } catch (t) {
            console.warn("Invalid pers:interior_orientation values for cropped panorama " + e1.id);
        }
    }
    if (!i && e1.properties?.exif) try {
        i = {
            fullWidth: parseInt(e1.properties.exif?.["Xmp.GPano.FullPanoWidthPixels"]),
            fullHeight: parseInt(e1.properties.exif?.["Xmp.GPano.FullPanoHeightPixels"]),
            croppedX: parseInt(e1.properties.exif?.["Xmp.GPano.CroppedAreaLeftPixels"]),
            croppedY: parseInt(e1.properties.exif?.["Xmp.GPano.CroppedAreaTopPixels"]),
            croppedWidth: parseInt(e1.properties.exif?.["Xmp.GPano.CroppedAreaImageWidthPixels"]),
            croppedHeight: parseInt(e1.properties.exif?.["Xmp.GPano.CroppedAreaImageHeightPixels"])
        }, i.croppedWidth > i.fullWidth && (i.fullWidth = i.croppedWidth), i.croppedHeight > i.fullHeight && (i.fullHeight = i.croppedHeight);
    } catch (t) {
        console.warn("Invalid XMP.GPano values for cropped panorama " + e1.id);
    }
    if (i && (i = Object.fromEntries(Object.entries(i || {}).filter((e1)=>!isNaN(e1[1]))), (!i.fullWidth && !i.croppedWidth && i.fullHeight && !i.croppedHeight || i.fullWidth && !i.croppedWidth && !i.fullHeight && !i.croppedHeight || i.fullWidth && !i.croppedWidth && i.fullHeight && !i.croppedHeight || i.fullWidth == i.croppedWidth && i.fullHeight == i.croppedHeight) && (i = {})), i?.fullWidth && t?.width) {
        let e1 = t.width / (i?.croppedWidth || i.fullWidth);
        i = {
            fullWidth: void 0 !== i.fullWidth ? Math.floor(i.fullWidth * e1) : void 0,
            fullHeight: void 0 !== i.fullHeight ? Math.floor(i.fullHeight * e1) : void 0,
            croppedWidth: void 0 !== i.croppedWidth ? Math.floor(i.croppedWidth * e1) : void 0,
            croppedHeight: void 0 !== i.croppedHeight ? Math.floor(i.croppedHeight * e1) : void 0,
            croppedX: void 0 !== i.croppedX ? Math.floor(i.croppedX * e1) : void 0,
            croppedY: void 0 !== i.croppedY ? Math.floor(i.croppedY * e1) : void 0
        };
    }
    return i || {};
}
function $785da19a645c07eb$var$fO(e1) {
    return (t, i)=>"related" !== t.rel && "related" !== i.rel ? 0 : "related" !== t.rel ? -1 : "related" !== i.rel ? 1 : t.date === i.date ? $785da19a645c07eb$var$Oe(e1, t.geometry.coordinates) - $785da19a645c07eb$var$Oe(e1, i.geometry.coordinates) : i.date.localeCompare(t.date);
}
function $785da19a645c07eb$var$AO(e1, t) {
    return e1.is360 !== t.is360 ? e1.is360 : e1.density !== t.density ? e1.density > t.density : e1.dist < t.dist;
}
function $785da19a645c07eb$var$_O(e1, t) {
    const i = new Map;
    for (const n of e1 || []){
        if (!n?.date || !n?.coords) continue;
        const e1 = n.date.slice(0, 7), a = {
            month: e1,
            date: n.date,
            id: n.id,
            seqId: n.seqId,
            coords: n.coords,
            is360: !!n.is360,
            density: n.density || 0,
            thumb: n.thumb || null,
            heading: n.heading ?? null,
            dist: $785da19a645c07eb$var$Oe(t, n.coords)
        }, r = i.get(e1);
        r && !$785da19a645c07eb$var$AO(a, r) || i.set(e1, a);
    }
    return [
        ...i.values()
    ].map(({ month: e1, date: t, id: i, seqId: n, coords: a, is360: r, density: s, thumb: o, heading: l })=>({
            month: e1,
            date: t,
            id: i,
            seqId: n,
            coords: a,
            is360: r,
            density: s,
            thumb: o,
            heading: l
        })).sort((e1, t)=>t.month.localeCompare(e1.month));
}
function $785da19a645c07eb$var$vO(e1, t) {
    const i = {};
    if (e1?.properties?.datetimetz) {
        i.date = new Date(e1.properties.datetimetz);
        const t = e1.properties.datetimetz.match(/([+-]\d{2}):(\d{2})$|Z$/);
        t && ("Z" === t[0] ? i.tz = "UTC" : i.tz = t[0]);
    } else e1?.properties?.datetime && (i.date = new Date(e1.properties.datetime));
    const n = e1?.providers || e1?.properties?.providers;
    if (n) {
        let e1 = n.filter((e1)=>e1?.roles?.includes("producer"));
        if (0 === e1?.length && (e1 = n.filter((e1)=>e1?.roles?.includes("host"))), e1?.length >= 0) {
            const t = {};
            e1.map((e1)=>e1.name).forEach((e1)=>{
                const i = e1.toLowerCase().replace(/\s/g, "");
                t[i] ? t[i].push(e1) : t[i] = [
                    e1
                ];
            }), i.producer = [], Object.values(t).forEach((e1)=>{
                const t = e1[0], n = e1.find((e1)=>e1.toLowerCase() !== e1);
                i.producer.push(n || t);
            });
        }
    }
    if (e1?.properties?.license && (i.license = e1.properties.license, e1?.links)) {
        const n = e1.links.find((e1)=>"license" === e1?.rel);
        n && (i.license = `<a href="${n.href}" title="${t.pnx.metadata_general_license_link}" target="_blank">${i.license}</a>`);
    }
    return i;
}
function $785da19a645c07eb$var$yO(e1, t, i = !1, n = null, a = (e1)=>e1) {
    const r = null != e1.properties?.["pers:interior_orientation"]?.field_of_view;
    let s = r ? parseInt(e1.properties["pers:interior_orientation"].field_of_view) : 70;
    const o = 360 === s, l = a((Object.values(e1.assets).find((e1)=>e1?.roles?.includes("data")) || {}).href), c = e1?.properties?.["tiles:tile_matrix_sets"]?.geovisio, u = e1.links?.find?.((e1)=>"prev" === e1?.rel && "application/geo+json" === e1?.type), h = e1.links?.find?.((e1)=>"next" === e1?.rel && "application/geo+json" === e1?.type), d = Object.values(e1.assets).find((e1)=>e1.roles?.includes("visual") && "image/webp" === e1.type), p = Object.values(e1.assets).find((e1)=>e1.roles?.includes("visual") && "image/jpeg" === e1.type), m = a((d || p).href), g = a(Object.values(e1.assets).find((e1)=>e1.roles?.includes("thumbnail") && "image/jpeg" === e1.type)?.href), f = e1?.asset_templates?.tiles_webp || e1?.asset_templates?.tiles, A = $785da19a645c07eb$var$gO(e1), _ = e1.links?.find?.((e1)=>"via" === e1?.rel && "application/json" === e1?.type), v = e1.properties?.["pers:interior_orientation"]?.sensor_array_dimensions;
    let y;
    if (Object.keys(A).length > 0) y = {
        baseUrl: i ? l : m,
        origBaseUrl: i ? l : m,
        hdUrl: l,
        thumbUrl: g,
        basePanoData: i ? A : (t)=>$785da19a645c07eb$var$gO(e1, t),
        cropData: A,
        width: A.fullWidth,
        cols: 2,
        rows: 1,
        tileUrl: ()=>null
    };
    else if (o && c) y = {
        baseUrl: m,
        origBaseUrl: m,
        basePanoData: (e1)=>({
                fullWidth: e1.width,
                fullHeight: e1.height
            }),
        hdUrl: l,
        thumbUrl: g,
        cols: c && c.tileMatrix[0].matrixWidth,
        rows: c && c.tileMatrix[0].matrixHeight,
        width: c && c.tileMatrix[0].matrixWidth * c.tileMatrix[0].tileWidth,
        tileUrl: c && ((e1, t)=>a(f.href.replace(/\{TileCol\}/g, e1).replace(/\{TileRow\}/g, t)))
    };
    else {
        const e1 = (e1)=>{
            e1.width < e1.height && !r && (s = 35);
            const t = s * e1.height / e1.width, i = 360 * e1.width / s, n = 180 * e1.height / t;
            return {
                fullWidth: Math.floor(i),
                fullHeight: Math.floor(n),
                croppedWidth: e1.width,
                croppedHeight: e1.height,
                croppedX: Math.floor((i - e1.width) / 2),
                croppedY: Math.floor((n - e1.height) / 2)
            };
        };
        let t = v ? e1({
            width: v[0],
            height: v[1]
        }) : null;
        y = {
            baseUrl: i ? l : m,
            origBaseUrl: i ? l : m,
            hdUrl: l,
            thumbUrl: g,
            basePanoData: e1,
            cropData: t,
            width: t?.fullWidth || 2,
            cols: 2,
            rows: 1,
            tileUrl: ()=>null
        };
    }
    e1.properties?.semantics && (e1.properties.semantics = e1.properties.semantics.filter((e1)=>Object.keys(e1).length > 0));
    return {
        id: e1.id,
        caption: $785da19a645c07eb$var$vO(e1, t),
        panorama: y,
        links: $785da19a645c07eb$var$xO(e1, n),
        origLinks: e1.links,
        gps: e1.geometry.coordinates,
        sequence: {
            id: e1.collection,
            nextPic: h ? h.id : void 0,
            prevPic: u ? u.id : void 0
        },
        sphereCorrection: $785da19a645c07eb$var$mO(e1),
        horizontalFov: s,
        origInstance: _,
        properties: e1.properties,
        permissions: $785da19a645c07eb$var$bO(e1)
    };
}
function $785da19a645c07eb$var$xO(e1, t = null) {
    const i = e1.links.filter((e1)=>[
            "next",
            "prev",
            "related"
        ].includes(e1?.rel) && "application/geo+json" === e1?.type).filter((e1)=>!t || t(e1)).map((e1)=>(e1.datetime && (e1.date = e1.datetime.split("T")[0]), e1)), n = e1.geometry.coordinates, a = [], r = {
        N: [],
        ENE: [],
        ESE: [],
        S: [],
        WSW: [],
        WNW: []
    };
    for (let e1 of i)r[$785da19a645c07eb$var$We(n, e1.geometry.coordinates)].push(e1);
    for(let e1 in r){
        const t = r[e1];
        0 !== t.length && (t.sort($785da19a645c07eb$var$fO(n)), a.push(t.shift()));
    }
    let s = (e1)=>"related" === e1.rel ? {
            element: $785da19a645c07eb$var$je($785da19a645c07eb$var$hO),
            size: {
                width: 128 / 3,
                height: 128
            }
        } : {
            element: $785da19a645c07eb$var$je($785da19a645c07eb$var$uO),
            size: {
                width: 75,
                height: 75
            }
        };
    const o = -$785da19a645c07eb$var$at(e1.properties?.["view:azimuth"] || 0);
    return a.map((e1)=>({
            nodeId: e1.id,
            gps: e1.geometry.coordinates,
            arrowStyle: s(e1),
            linkOffset: {
                yaw: o
            }
        }));
}
function $785da19a645c07eb$var$bO(e1) {
    let t = !1, i = !1;
    return e1.links.find((e1)=>"PATCH" === e1.method && e1.attributes.includes("semantics")) && e1.links.find((e1)=>"POST" === e1.method && "add_annotation" === e1.rel) && (t = !0), e1.links.find((e1)=>"DELETE" === e1.method && "delete" === e1.rel) && (i = !0), {
        edit_semantics: t,
        delete_picture: i
    };
}
function $785da19a645c07eb$var$wO(e1) {
    return e1?.properties?.annotations?.length > 0;
}
var $785da19a645c07eb$var$EO = Object.freeze({
    __proto__: null,
    apiFeatureToPSVNode: $785da19a645c07eb$var$yO,
    filterRelatedPicsLinks: $785da19a645c07eb$var$xO,
    getCroppedPanoData: $785da19a645c07eb$var$gO,
    getExifFloat: $785da19a645c07eb$var$dO,
    getGPSPrecision: $785da19a645c07eb$var$pO,
    getHashTags: function(e1) {
        if (!e1?.properties?.semantics) return [];
        const t = e1.properties.semantics.filter((e1)=>"hashtags" === e1.key), i = [];
        return t.forEach((e1)=>e1.value.split(";").forEach((e1)=>i.push(e1.trim()))), i;
    },
    getNodeCaption: $785da19a645c07eb$var$vO,
    getPermissions: $785da19a645c07eb$var$bO,
    getSphereCorrection: $785da19a645c07eb$var$mO,
    hasAnnotations: $785da19a645c07eb$var$wO,
    pickBestPerMonth: $785da19a645c07eb$var$_O,
    sortPicturesInDirection: $785da19a645c07eb$var$fO
}), $785da19a645c07eb$var$kO = "data:image/png;base64,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", $785da19a645c07eb$var$SO = "data:image/png;base64,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";
const $785da19a645c07eb$var$MO = 125, $785da19a645c07eb$var$CO = 50, $785da19a645c07eb$var$TO = -45, $785da19a645c07eb$var$DO = 1e-4;
class $785da19a645c07eb$var$PO {
    constructor(e1, t = !0){
        this.psv = e1, this.isDesktop = t, this.isDesktop && (this._cursor = document.createElement("img"), this._cursor.src = $785da19a645c07eb$var$kO, this.psv.container.appendChild(this._cursor), this._cursor.style.width = "125px", this._cursor.style.height = "125px", this._cursor.style.position = "absolute", this._cursor.style.zIndex = 10, this._cursor.style.pointerEvents = "none", this._cursor.style.display = "none", this._hideCursor = !1), this._couldGoSomewhere = !1, this._mapPreviewPic = null, this.psv.container.addEventListener("mousemove", this._onPointerMove.bind(this)), this.psv.container.addEventListener("mouseleave", this._onPointerLeave.bind(this)), this.psv._myMarkers.addEventListener("enter-marker", this._onHoverOtherStuff.bind(this)), this.psv._myMarkers.addEventListener("leave-marker", this._onLeaveOtherStuff.bind(this)), this.psv._myVTour.addEventListener("enter-arrow", this._onHoverOtherStuff.bind(this)), this.psv._myVTour.addEventListener("leave-arrow", this._onLeaveOtherStuff.bind(this)), this.psv.addEventListener("sequence-playing", this._onHoverOtherStuff.bind(this)), this.psv.addEventListener("sequence-stopped", this._onLeaveOtherStuff.bind(this)), this.psv.addEventListener("sequence-playing", this._onHoverOtherStuff.bind(this)), this.psv.addEventListener("pictures-navigation-changed", this._onPSVPicNavChanged.bind(this)), this.psv.addEventListener("click", this._onClick.bind(this));
    }
    async _onClick(e1) {
        if (this.psv._sequencePlaying || "pic" === this.psv.getPicturesNavigation() || this.psv._myVTour.state.loadingNode || this.psv.getSelectedAnnotations().length > 0 || this.psv._parent.map && this.psv._parent.isMapWide?.()) return;
        if (e1.stopPropagation(), this._mapPreviewPic) return this.psv._keepSameAngle = !0, this.psv._parent.select(this._mapPreviewPic.collection, this._mapPreviewPic.id), void (this._mapPreviewPic = null);
        const t = this.psv.getPictureMetadata();
        if (!t) return;
        let i = Math.min(this._pitchDegToProjectedDistance($785da19a645c07eb$var$nt(e1.data.pitch), $785da19a645c07eb$var$IO(t)), $785da19a645c07eb$var$CO);
        if (i > 0) {
            this._couldGoSomewhere = !0;
            const n = ($785da19a645c07eb$var$nt(e1.data.yaw) + this.psv.getPictureOriginalHeading()) % 360, a = $785da19a645c07eb$var$FO(t.gps, i, n);
            let r;
            this.psv._parent.map && (r = this._getMapNearbyPictures(a)), r && 0 !== r?.length || (r = (await this.psv._parent.api.getPicturesAroundCoordinates(a[1], a[0], $785da19a645c07eb$var$DO, 50))?.features);
            const s = this._bestPicAround(t, a, n, r);
            s ? (this.psv._keepSameAngle = !0, this.psv._parent.select(s.collection, s.id)) : this.isDesktop && (this._cursor.src = $785da19a645c07eb$var$SO, setTimeout(()=>this._cursor.src = $785da19a645c07eb$var$kO, 1500));
        } else this._couldGoSomewhere = !1;
    }
    _onPointerMove(e1) {
        this._couldGoSomewhere = !1;
        const t = this.psv.getPositionFromEvent(e1);
        if (!t || "pic" === this.psv.getPicturesNavigation() || this.psv.getSelectedAnnotations().length > 0 || this.psv._parent.map && this.psv._parent.isMapWide?.()) return;
        const i = this.psv._parent?.map, n = this.psv.getPictureMetadata();
        if (!n) return;
        let a = Math.min(this._pitchDegToProjectedDistance($785da19a645c07eb$var$nt(t.pitch), $785da19a645c07eb$var$IO(n)), $785da19a645c07eb$var$CO);
        if (!this._hideCursor && a > 0) {
            if (this._couldGoSomewhere = !0, this.isDesktop) {
                const r = function(e1) {
                    const t = ((e1 = Math.max(Math.min(e1, 0), $785da19a645c07eb$var$TO)) - $785da19a645c07eb$var$TO) / 45, i = .2;
                    return Math.max(1 - Math.exp(-Math.pow(t - 1, 2) / (2 * i * i)), .4);
                }($785da19a645c07eb$var$nt(t.pitch)), s = 50 * r, o = $785da19a645c07eb$var$MO * r;
                this._cursor.style.top = e1.layerY - 3 * s / 5 + "px", this._cursor.style.left = e1.layerX - o / 2 + "px", this._cursor.style.height = `${s}px`, this._cursor.style.width = `${o}px`, this._cursor.style.display = "block", clearTimeout(this._throttledBestPicMap), this._throttledBestPicMap = setTimeout(()=>{
                    const e1 = ($785da19a645c07eb$var$nt(t.yaw) + this.psv.getPictureOriginalHeading()) % 360, r = $785da19a645c07eb$var$FO(n.gps, a, e1), s = this._getMapNearbyPictures(r);
                    if (s?.length > 0) {
                        const e1 = ($785da19a645c07eb$var$nt(t.yaw) + this.psv.getPictureOriginalHeading()) % 360, r = $785da19a645c07eb$var$FO(n.gps, a, e1), o = this._bestPicAround(n, r, e1, s);
                        o ? (this._cursor.src = $785da19a645c07eb$var$kO, this._mapPreviewPic = o, i._picMarkerPreview.setLngLat(o.geometry.coordinates).setRotation(360 === o.properties?.["pers:interior_orientation"]?.field_of_view ? this.psv.getXYZ().x || 0 : o.properties?.["view:azimuth"] || 0).addTo(i)) : (this._cursor.src = $785da19a645c07eb$var$SO, i._picMarkerPreview?.remove(), this._mapPreviewPic = null);
                    } else this._cursor.src = $785da19a645c07eb$var$kO, this._mapPreviewPic = null, i && (this._isMapShowingPictures() || 0 === this._getMapNearbySequences(r).length) ? (this._cursor.src = $785da19a645c07eb$var$SO, i?._picMarkerPreview?.remove()) : (this._cursor.src = $785da19a645c07eb$var$kO, i?._picMarkerPreview.setLngLat(r).setRotation(e1).addTo(i));
                }, 10);
            }
        } else this.isDesktop && (this._cursor.style.display = "none", this._mapPreviewPic = null, this._hideCursor || i?._picMarkerPreview?.remove());
    }
    _onPointerLeave() {
        this.isDesktop && (this._cursor.style.display = "none"), this._couldGoSomewhere = !1;
    }
    _onHoverOtherStuff() {
        this._hideCursor = !0, this._onPointerLeave();
    }
    _onLeaveOtherStuff() {
        this._hideCursor = !1;
    }
    _onPSVPicNavChanged(e1) {
        if ("pic" === e1?.detail?.value) this._onHoverOtherStuff();
        else this._onLeaveOtherStuff();
    }
    _pitchDegToProjectedDistance(e1, t) {
        return t ? this.isDesktop ? e1 >= 30 ? 0 : e1 >= -2.5 ? $785da19a645c07eb$var$CO : e1 >= -6 ? 25 : e1 >= -15 ? 12.5 : e1 >= $785da19a645c07eb$var$TO ? 6.25 : 0 : e1 >= 20 ? 0 : e1 >= 4 ? $785da19a645c07eb$var$CO / 3 : e1 >= -4 ? $785da19a645c07eb$var$CO / 1.5 : e1 >= -20 ? $785da19a645c07eb$var$CO / 3 : 0 : $785da19a645c07eb$var$CO / 3;
    }
    _isMapShowingPictures() {
        if (this.psv._parent.map) {
            const e1 = this.psv._parent.map;
            let t = e1.getLayersOrder().find((e1)=>e1.endsWith("pictures"));
            if (t) return e1.queryRenderedFeatures({
                layers: [
                    t
                ]
            }).length > 0;
        }
        return !1;
    }
    _getMapNearbyPictures(e1) {
        const t = this.psv._parent.map;
        if (t) {
            const i = this.psv._parent?.mapStyleComposer;
            if (i) {
                const n = Object.keys(i.layerRanges.panoramax[i.panoramax].sources)[0];
                if (n) return t.querySourceFeatures(n, {
                    sourceLayer: "pictures",
                    filter: [
                        "within",
                        {
                            type: "Polygon",
                            coordinates: [
                                [
                                    [
                                        e1[0] - $785da19a645c07eb$var$DO,
                                        e1[1] - $785da19a645c07eb$var$DO
                                    ],
                                    [
                                        e1[0] + $785da19a645c07eb$var$DO,
                                        e1[1] - $785da19a645c07eb$var$DO
                                    ],
                                    [
                                        e1[0] + $785da19a645c07eb$var$DO,
                                        e1[1] + $785da19a645c07eb$var$DO
                                    ],
                                    [
                                        e1[0] - $785da19a645c07eb$var$DO,
                                        e1[1] + $785da19a645c07eb$var$DO
                                    ],
                                    [
                                        e1[0] - $785da19a645c07eb$var$DO,
                                        e1[1] - $785da19a645c07eb$var$DO
                                    ]
                                ]
                            ]
                        }
                    ]
                }).map((e1)=>({
                        id: e1.properties.id,
                        collection: e1.properties.first_sequence || e1.properties?.sequences?.[0],
                        geometry: e1.geometry,
                        properties: {
                            datetime: e1.properties.datetime || e1.properties.ts,
                            "view:azimuth": e1.properties?.["view:azimuth"] || e1.properties.heading,
                            "pers:interior_orientation": e1.properties?.["pers:interior_orientation"] || {
                                field_of_view: "equirectangular" === e1.properties.type ? 360 : void 0
                            }
                        }
                    }));
            }
        }
        return null;
    }
    _getMapNearbySequences(e1) {
        const t = this.psv._parent.map;
        if (t) {
            const i = t.getLayersOrder().find((e1)=>e1.endsWith("sequences"));
            if (i) {
                const n = 25e-6, a = [
                    t.project([
                        e1[0] - n,
                        e1[1] - n
                    ]),
                    t.project([
                        e1[0] + n,
                        e1[1] + n
                    ])
                ];
                return t.queryRenderedFeatures(a, {
                    layers: [
                        i
                    ]
                });
            }
        }
        return [];
    }
    _bestPicAround(e1, t, i, n) {
        if (!Array.isArray(n) || !n.length) return null;
        const a = new Date(e1.properties?.datetime), r = n.filter((t)=>t.id !== e1.id).map((n)=>{
            const r = 360 === n.properties?.["pers:interior_orientation"]?.field_of_view, s = $785da19a645c07eb$var$Oe(t, n.geometry.coordinates), o = n.collection === e1.sequence?.id || "any" === this.psv.getPicturesNavigation(), l = n.properties?.["view:azimuth"], c = r || "number" == typeof l && $785da19a645c07eb$var$qe(i, l) <= 45, u = Math.abs((i - $785da19a645c07eb$var$Ve(e1.gps, n.geometry.coordinates)) % 360) <= 45, h = new Date(n.properties?.datetime), d = a.toDateString() === h.toDateString(), p = Math.abs((a - h) / 864e5);
            let m = !0;
            if (this.psv._parent.map) {
                const e1 = this.psv._parent.map;
                e1.indoorEqual && e1.indoorEqual.level !== $785da19a645c07eb$var$Rc && (m = e1._indoorFeaturesIDs.pictures[e1.indoorEqual.level]?.has(n.id), m || "0" !== e1.indoorEqual.level || (m = !0, Object.entries(e1._indoorFeaturesIDs.pictures).forEach(([e1, t])=>{
                    m && "0" !== e1 && (m = !t.has(n.id));
                })));
            }
            let g = 1 / 0;
            return o && u && m && (d && r ? g = 1 : r && p <= 30 ? g = 2 : c && p <= 30 ? g = 3 : r ? g = 4 : c && (g = 5)), {
                p: n,
                category: g,
                dist: s,
                daysDiff: p,
                headingMatch: c,
                sameDay: d,
                is360: r
            };
        });
        if (!r.length) return null;
        r.sort((e1, t)=>e1.category !== t.category ? e1.category - t.category : e1.dist !== t.dist ? e1.dist - t.dist : e1.daysDiff !== t.daysDiff ? e1.daysDiff - t.daysDiff : 0);
        const s = r[0];
        return s.category < 1 / 0 ? s.p : null;
    }
}
function $785da19a645c07eb$var$IO(e1) {
    return 360 === e1.properties?.["pers:interior_orientation"]?.field_of_view || void 0 !== e1?.properties?.["pers:roll"] || void 0 !== e1?.properties?.["pers:pitch"];
}
function $785da19a645c07eb$var$FO(e1, t, i) {
    const [n, a] = e1, r = $785da19a645c07eb$var$at(a), s = $785da19a645c07eb$var$at(n), o = $785da19a645c07eb$var$at(i), l = t / 6378137, c = Math.sin(r), u = Math.cos(r), h = Math.sin(l), d = Math.cos(l), p = Math.sin(o), m = c * d + u * h * Math.cos(o), g = Math.asin(m), f = p * h * u, A = d - c * m;
    return [
        $785da19a645c07eb$var$nt(s + Math.atan2(f, A)),
        $785da19a645c07eb$var$nt(g)
    ];
}
const $785da19a645c07eb$var$zO = "185", $785da19a645c07eb$var$RO = 1, $785da19a645c07eb$var$LO = 3, $785da19a645c07eb$var$BO = 0, $785da19a645c07eb$var$OO = 1, $785da19a645c07eb$var$UO = 2, $785da19a645c07eb$var$NO = 100, $785da19a645c07eb$var$jO = 101, $785da19a645c07eb$var$VO = 102, $785da19a645c07eb$var$qO = 200, $785da19a645c07eb$var$GO = 201, $785da19a645c07eb$var$HO = 202, $785da19a645c07eb$var$WO = 203, $785da19a645c07eb$var$ZO = 204, $785da19a645c07eb$var$KO = 205, $785da19a645c07eb$var$XO = 206, $785da19a645c07eb$var$QO = 207, $785da19a645c07eb$var$YO = 208, $785da19a645c07eb$var$JO = 209, $785da19a645c07eb$var$$O = 210, $785da19a645c07eb$var$eU = 211, $785da19a645c07eb$var$tU = 212, $785da19a645c07eb$var$iU = 213, $785da19a645c07eb$var$nU = 214, $785da19a645c07eb$var$aU = 0, $785da19a645c07eb$var$rU = 1, $785da19a645c07eb$var$sU = 2, $785da19a645c07eb$var$oU = 3, $785da19a645c07eb$var$lU = 4, $785da19a645c07eb$var$cU = 5, $785da19a645c07eb$var$uU = 6, $785da19a645c07eb$var$hU = 7, $785da19a645c07eb$var$dU = 0, $785da19a645c07eb$var$pU = 1, $785da19a645c07eb$var$mU = 2, $785da19a645c07eb$var$gU = 1, $785da19a645c07eb$var$fU = 2, $785da19a645c07eb$var$AU = 3, $785da19a645c07eb$var$_U = 4, $785da19a645c07eb$var$vU = 5, $785da19a645c07eb$var$yU = 6, $785da19a645c07eb$var$xU = 7, $785da19a645c07eb$var$bU = 301, $785da19a645c07eb$var$wU = 302, $785da19a645c07eb$var$EU = 303, $785da19a645c07eb$var$kU = 304, $785da19a645c07eb$var$SU = 306, $785da19a645c07eb$var$MU = 1e3, $785da19a645c07eb$var$CU = 1001, $785da19a645c07eb$var$TU = 1002, $785da19a645c07eb$var$DU = 1003, $785da19a645c07eb$var$PU = 1004, $785da19a645c07eb$var$IU = 1005, $785da19a645c07eb$var$FU = 1006, $785da19a645c07eb$var$zU = 1007, $785da19a645c07eb$var$RU = 1008, $785da19a645c07eb$var$LU = 1009, $785da19a645c07eb$var$BU = 1010, $785da19a645c07eb$var$OU = 1011, $785da19a645c07eb$var$UU = 1012, $785da19a645c07eb$var$NU = 1013, $785da19a645c07eb$var$jU = 1014, $785da19a645c07eb$var$VU = 1015, $785da19a645c07eb$var$qU = 1016, $785da19a645c07eb$var$GU = 1017, $785da19a645c07eb$var$HU = 1018, $785da19a645c07eb$var$WU = 1020, $785da19a645c07eb$var$ZU = 35902, $785da19a645c07eb$var$KU = 35899, $785da19a645c07eb$var$XU = 1023, $785da19a645c07eb$var$QU = 1026, $785da19a645c07eb$var$YU = 1027, $785da19a645c07eb$var$JU = 1029, $785da19a645c07eb$var$$U = 1030, $785da19a645c07eb$var$eN = 1031, $785da19a645c07eb$var$tN = 1033, $785da19a645c07eb$var$iN = 33776, $785da19a645c07eb$var$nN = 33777, $785da19a645c07eb$var$aN = 33778, $785da19a645c07eb$var$rN = 33779, $785da19a645c07eb$var$sN = 35840, $785da19a645c07eb$var$oN = 35841, $785da19a645c07eb$var$lN = 35842, $785da19a645c07eb$var$cN = 35843, $785da19a645c07eb$var$uN = 36196, $785da19a645c07eb$var$hN = 37492, $785da19a645c07eb$var$dN = 37496, $785da19a645c07eb$var$pN = 37488, $785da19a645c07eb$var$mN = 37489, $785da19a645c07eb$var$gN = 37490, $785da19a645c07eb$var$fN = 37491, $785da19a645c07eb$var$AN = 37808, $785da19a645c07eb$var$_N = 37809, $785da19a645c07eb$var$vN = 37810, $785da19a645c07eb$var$yN = 37811, $785da19a645c07eb$var$xN = 37812, $785da19a645c07eb$var$bN = 37813, $785da19a645c07eb$var$wN = 37814, $785da19a645c07eb$var$EN = 37815, $785da19a645c07eb$var$kN = 37816, $785da19a645c07eb$var$SN = 37817, $785da19a645c07eb$var$MN = 37818, $785da19a645c07eb$var$CN = 37819, $785da19a645c07eb$var$TN = 37820, $785da19a645c07eb$var$DN = 37821, $785da19a645c07eb$var$PN = 36492, $785da19a645c07eb$var$IN = 36494, $785da19a645c07eb$var$FN = 36495, $785da19a645c07eb$var$zN = 36283, $785da19a645c07eb$var$RN = 36284, $785da19a645c07eb$var$LN = 36285, $785da19a645c07eb$var$BN = 36286, $785da19a645c07eb$var$ON = "", $785da19a645c07eb$var$UN = "srgb", $785da19a645c07eb$var$NN = "srgb-linear", $785da19a645c07eb$var$jN = "linear", $785da19a645c07eb$var$VN = "srgb", $785da19a645c07eb$var$qN = 7680, $785da19a645c07eb$var$GN = 512, $785da19a645c07eb$var$HN = 513, $785da19a645c07eb$var$WN = 514, $785da19a645c07eb$var$ZN = 515, $785da19a645c07eb$var$KN = 516, $785da19a645c07eb$var$XN = 517, $785da19a645c07eb$var$QN = 518, $785da19a645c07eb$var$YN = 519, $785da19a645c07eb$var$JN = "300 es", $785da19a645c07eb$var$$N = 2e3, $785da19a645c07eb$var$ej = 2001;
function $785da19a645c07eb$var$tj(e1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", e1);
}
function $785da19a645c07eb$var$ij() {
    const e1 = $785da19a645c07eb$var$tj("canvas");
    return e1.style.display = "block", e1;
}
const $785da19a645c07eb$var$nj = {};
function $785da19a645c07eb$var$aj(...e1) {
    const t = "THREE." + e1.shift();
    console.log(t, ...e1);
}
function $785da19a645c07eb$var$rj(e1) {
    const t = e1[0];
    if ("string" == typeof t && t.startsWith("TSL:")) {
        const t = e1[1];
        t && t.isStackTrace ? e1[0] += " " + t.getLocation() : e1[1] = 'Stack trace not available. Enable "THREE.Node.captureStackTrace" to capture stack traces.';
    }
    return e1;
}
function $785da19a645c07eb$var$sj(...e1) {
    const t = "THREE." + (e1 = $785da19a645c07eb$var$rj(e1)).shift();
    {
        const i = e1[0];
        i && i.isStackTrace ? console.warn(i.getError(t)) : console.warn(t, ...e1);
    }
}
function $785da19a645c07eb$var$oj(...e1) {
    const t = "THREE." + (e1 = $785da19a645c07eb$var$rj(e1)).shift();
    {
        const i = e1[0];
        i && i.isStackTrace ? console.error(i.getError(t)) : console.error(t, ...e1);
    }
}
function $785da19a645c07eb$var$lj(...e1) {
    const t = e1.join(" ");
    t in $785da19a645c07eb$var$nj || ($785da19a645c07eb$var$nj[t] = !0, $785da19a645c07eb$var$sj(...e1));
}
const $785da19a645c07eb$var$cj = {
    [$785da19a645c07eb$var$aU]: 1,
    [$785da19a645c07eb$var$sU]: 6,
    [$785da19a645c07eb$var$lU]: 7,
    [$785da19a645c07eb$var$oU]: 5,
    [$785da19a645c07eb$var$rU]: 0,
    [$785da19a645c07eb$var$uU]: 2,
    [$785da19a645c07eb$var$hU]: 4,
    [$785da19a645c07eb$var$cU]: 3
};
class $785da19a645c07eb$var$uj {
    addEventListener(e1, t) {
        void 0 === this._listeners && (this._listeners = {});
        const i = this._listeners;
        void 0 === i[e1] && (i[e1] = []), -1 === i[e1].indexOf(t) && i[e1].push(t);
    }
    hasEventListener(e1, t) {
        const i = this._listeners;
        return void 0 !== i && void 0 !== i[e1] && -1 !== i[e1].indexOf(t);
    }
    removeEventListener(e1, t) {
        const i = this._listeners;
        if (void 0 === i) return;
        const n = i[e1];
        if (void 0 !== n) {
            const e1 = n.indexOf(t);
            -1 !== e1 && n.splice(e1, 1);
        }
    }
    dispatchEvent(e1) {
        const t = this._listeners;
        if (void 0 === t) return;
        const i = t[e1.type];
        if (void 0 !== i) {
            e1.target = this;
            const t = i.slice(0);
            for(let i = 0, n = t.length; i < n; i++)t[i].call(this, e1);
            e1.target = null;
        }
    }
}
const $785da19a645c07eb$var$hj = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
];
let $785da19a645c07eb$var$dj = 1234567;
const $785da19a645c07eb$var$pj = Math.PI / 180, $785da19a645c07eb$var$mj = 180 / Math.PI;
function $785da19a645c07eb$var$gj() {
    const e1 = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0;
    return ($785da19a645c07eb$var$hj[255 & e1] + $785da19a645c07eb$var$hj[e1 >> 8 & 255] + $785da19a645c07eb$var$hj[e1 >> 16 & 255] + $785da19a645c07eb$var$hj[e1 >> 24 & 255] + "-" + $785da19a645c07eb$var$hj[255 & t] + $785da19a645c07eb$var$hj[t >> 8 & 255] + "-" + $785da19a645c07eb$var$hj[t >> 16 & 15 | 64] + $785da19a645c07eb$var$hj[t >> 24 & 255] + "-" + $785da19a645c07eb$var$hj[63 & i | 128] + $785da19a645c07eb$var$hj[i >> 8 & 255] + "-" + $785da19a645c07eb$var$hj[i >> 16 & 255] + $785da19a645c07eb$var$hj[i >> 24 & 255] + $785da19a645c07eb$var$hj[255 & n] + $785da19a645c07eb$var$hj[n >> 8 & 255] + $785da19a645c07eb$var$hj[n >> 16 & 255] + $785da19a645c07eb$var$hj[n >> 24 & 255]).toLowerCase();
}
function $785da19a645c07eb$var$fj(e1, t, i) {
    return Math.max(t, Math.min(i, e1));
}
function $785da19a645c07eb$var$Aj(e1, t) {
    return (e1 % t + t) % t;
}
function $785da19a645c07eb$var$_j(e1, t, i) {
    return (1 - i) * e1 + i * t;
}
function $785da19a645c07eb$var$vj(e1, t) {
    switch(t.constructor){
        case Float32Array:
            return e1;
        case Uint32Array:
            return e1 / 4294967295;
        case Uint16Array:
            return e1 / 65535;
        case Uint8Array:
            return e1 / 255;
        case Int32Array:
            return Math.max(e1 / 2147483647, -1);
        case Int16Array:
            return Math.max(e1 / 32767, -1);
        case Int8Array:
            return Math.max(e1 / 127, -1);
        default:
            throw new Error("THREE.MathUtils: Invalid component type.");
    }
}
function $785da19a645c07eb$var$yj(e1, t) {
    switch(t.constructor){
        case Float32Array:
            return e1;
        case Uint32Array:
            return Math.round(4294967295 * e1);
        case Uint16Array:
            return Math.round(65535 * e1);
        case Uint8Array:
            return Math.round(255 * e1);
        case Int32Array:
            return Math.round(2147483647 * e1);
        case Int16Array:
            return Math.round(32767 * e1);
        case Int8Array:
            return Math.round(127 * e1);
        default:
            throw new Error("THREE.MathUtils: Invalid component type.");
    }
}
const $785da19a645c07eb$var$xj = {
    DEG2RAD: $785da19a645c07eb$var$pj,
    RAD2DEG: $785da19a645c07eb$var$mj,
    generateUUID: $785da19a645c07eb$var$gj,
    clamp: $785da19a645c07eb$var$fj,
    euclideanModulo: $785da19a645c07eb$var$Aj,
    mapLinear: function(e1, t, i, n, a) {
        return n + (e1 - t) * (a - n) / (i - t);
    },
    inverseLerp: function(e1, t, i) {
        return e1 !== t ? (i - e1) / (t - e1) : 0;
    },
    lerp: $785da19a645c07eb$var$_j,
    damp: function(e1, t, i, n) {
        return $785da19a645c07eb$var$_j(e1, t, 1 - Math.exp(-i * n));
    },
    pingpong: function(e1, t = 1) {
        return t - Math.abs($785da19a645c07eb$var$Aj(e1, 2 * t) - t);
    },
    smoothstep: function(e1, t, i) {
        return e1 <= t ? 0 : e1 >= i ? 1 : (e1 = (e1 - t) / (i - t)) * e1 * (3 - 2 * e1);
    },
    smootherstep: function(e1, t, i) {
        return e1 <= t ? 0 : e1 >= i ? 1 : (e1 = (e1 - t) / (i - t)) * e1 * e1 * (e1 * (6 * e1 - 15) + 10);
    },
    randInt: function(e1, t) {
        return e1 + Math.floor(Math.random() * (t - e1 + 1));
    },
    randFloat: function(e1, t) {
        return e1 + Math.random() * (t - e1);
    },
    randFloatSpread: function(e1) {
        return e1 * (.5 - Math.random());
    },
    seededRandom: function(e1) {
        void 0 !== e1 && ($785da19a645c07eb$var$dj = e1);
        let t = $785da19a645c07eb$var$dj += 1831565813;
        return t = Math.imul(t ^ t >>> 15, 1 | t), t ^= t + Math.imul(t ^ t >>> 7, 61 | t), ((t ^ t >>> 14) >>> 0) / 4294967296;
    },
    degToRad: function(e1) {
        return e1 * $785da19a645c07eb$var$pj;
    },
    radToDeg: function(e1) {
        return e1 * $785da19a645c07eb$var$mj;
    },
    isPowerOfTwo: function(e1) {
        return !(e1 & e1 - 1) && 0 !== e1;
    },
    ceilPowerOfTwo: function(e1) {
        return Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
    },
    floorPowerOfTwo: function(e1) {
        return Math.pow(2, Math.floor(Math.log(e1) / Math.LN2));
    },
    setQuaternionFromProperEuler: function(e1, t, i, n, a) {
        const r = Math.cos, s = Math.sin, o = r(i / 2), l = s(i / 2), c = r((t + n) / 2), u = s((t + n) / 2), h = r((t - n) / 2), d = s((t - n) / 2), p = r((n - t) / 2), m = s((n - t) / 2);
        switch(a){
            case "XYX":
                e1.set(o * u, l * h, l * d, o * c);
                break;
            case "YZY":
                e1.set(l * d, o * u, l * h, o * c);
                break;
            case "ZXZ":
                e1.set(l * h, l * d, o * u, o * c);
                break;
            case "XZX":
                e1.set(o * u, l * m, l * p, o * c);
                break;
            case "YXY":
                e1.set(l * p, o * u, l * m, o * c);
                break;
            case "ZYZ":
                e1.set(l * m, l * p, o * u, o * c);
                break;
            default:
                $785da19a645c07eb$var$sj("MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + a);
        }
    },
    normalize: $785da19a645c07eb$var$yj,
    denormalize: $785da19a645c07eb$var$vj
};
class $785da19a645c07eb$var$bj {
    static{
        $785da19a645c07eb$var$bj.prototype.isVector2 = !0;
    }
    constructor(e1 = 0, t = 0){
        this.x = e1, this.y = t;
    }
    get width() {
        return this.x;
    }
    set width(e1) {
        this.x = e1;
    }
    get height() {
        return this.y;
    }
    set height(e1) {
        this.y = e1;
    }
    set(e1, t) {
        return this.x = e1, this.y = t, this;
    }
    setScalar(e1) {
        return this.x = e1, this.y = e1, this;
    }
    setX(e1) {
        return this.x = e1, this;
    }
    setY(e1) {
        return this.y = e1, this;
    }
    setComponent(e1, t) {
        switch(e1){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            default:
                throw new Error("THREE.Vector2: index is out of range: " + e1);
        }
        return this;
    }
    getComponent(e1) {
        switch(e1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("THREE.Vector2: index is out of range: " + e1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(e1) {
        return this.x = e1.x, this.y = e1.y, this;
    }
    add(e1) {
        return this.x += e1.x, this.y += e1.y, this;
    }
    addScalar(e1) {
        return this.x += e1, this.y += e1, this;
    }
    addVectors(e1, t) {
        return this.x = e1.x + t.x, this.y = e1.y + t.y, this;
    }
    addScaledVector(e1, t) {
        return this.x += e1.x * t, this.y += e1.y * t, this;
    }
    sub(e1) {
        return this.x -= e1.x, this.y -= e1.y, this;
    }
    subScalar(e1) {
        return this.x -= e1, this.y -= e1, this;
    }
    subVectors(e1, t) {
        return this.x = e1.x - t.x, this.y = e1.y - t.y, this;
    }
    multiply(e1) {
        return this.x *= e1.x, this.y *= e1.y, this;
    }
    multiplyScalar(e1) {
        return this.x *= e1, this.y *= e1, this;
    }
    divide(e1) {
        return this.x /= e1.x, this.y /= e1.y, this;
    }
    divideScalar(e1) {
        return this.multiplyScalar(1 / e1);
    }
    applyMatrix3(e1) {
        const t = this.x, i = this.y, n = e1.elements;
        return this.x = n[0] * t + n[3] * i + n[6], this.y = n[1] * t + n[4] * i + n[7], this;
    }
    min(e1) {
        return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this;
    }
    max(e1) {
        return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this;
    }
    clamp(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1.x, t.x), this.y = $785da19a645c07eb$var$fj(this.y, e1.y, t.y), this;
    }
    clampScalar(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1, t), this.y = $785da19a645c07eb$var$fj(this.y, e1, t), this;
    }
    clampLength(e1, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($785da19a645c07eb$var$fj(i, e1, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(e1) {
        return this.x * e1.x + this.y * e1.y;
    }
    cross(e1) {
        return this.x * e1.y - this.y * e1.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    angleTo(e1) {
        const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
        if (0 === t) return Math.PI / 2;
        const i = this.dot(e1) / t;
        return Math.acos($785da19a645c07eb$var$fj(i, -1, 1));
    }
    distanceTo(e1) {
        return Math.sqrt(this.distanceToSquared(e1));
    }
    distanceToSquared(e1) {
        const t = this.x - e1.x, i = this.y - e1.y;
        return t * t + i * i;
    }
    manhattanDistanceTo(e1) {
        return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y);
    }
    setLength(e1) {
        return this.normalize().multiplyScalar(e1);
    }
    lerp(e1, t) {
        return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this;
    }
    lerpVectors(e1, t, i) {
        return this.x = e1.x + (t.x - e1.x) * i, this.y = e1.y + (t.y - e1.y) * i, this;
    }
    equals(e1) {
        return e1.x === this.x && e1.y === this.y;
    }
    fromArray(e1, t = 0) {
        return this.x = e1[t], this.y = e1[t + 1], this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this.x, e1[t + 1] = this.y, e1;
    }
    fromBufferAttribute(e1, t) {
        return this.x = e1.getX(t), this.y = e1.getY(t), this;
    }
    rotateAround(e1, t) {
        const i = Math.cos(t), n = Math.sin(t), a = this.x - e1.x, r = this.y - e1.y;
        return this.x = a * i - r * n + e1.x, this.y = a * n + r * i + e1.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}
class $785da19a645c07eb$var$wj {
    constructor(e1 = 0, t = 0, i = 0, n = 1){
        this.isQuaternion = !0, this._x = e1, this._y = t, this._z = i, this._w = n;
    }
    static slerpFlat(e1, t, i, n, a, r, s) {
        let o = i[n + 0], l = i[n + 1], c = i[n + 2], u = i[n + 3], h = a[r + 0], d = a[r + 1], p = a[r + 2], m = a[r + 3];
        if (u !== m || o !== h || l !== d || c !== p) {
            let e1 = o * h + l * d + c * p + u * m;
            e1 < 0 && (h = -h, d = -d, p = -p, m = -m, e1 = -e1);
            let t = 1 - s;
            if (e1 < .9995) {
                const i = Math.acos(e1), n = Math.sin(i);
                t = Math.sin(t * i) / n, o = o * t + h * (s = Math.sin(s * i) / n), l = l * t + d * s, c = c * t + p * s, u = u * t + m * s;
            } else {
                o = o * t + h * s, l = l * t + d * s, c = c * t + p * s, u = u * t + m * s;
                const e1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                o *= e1, l *= e1, c *= e1, u *= e1;
            }
        }
        e1[t] = o, e1[t + 1] = l, e1[t + 2] = c, e1[t + 3] = u;
    }
    static multiplyQuaternionsFlat(e1, t, i, n, a, r) {
        const s = i[n], o = i[n + 1], l = i[n + 2], c = i[n + 3], u = a[r], h = a[r + 1], d = a[r + 2], p = a[r + 3];
        return e1[t] = s * p + c * u + o * d - l * h, e1[t + 1] = o * p + c * h + l * u - s * d, e1[t + 2] = l * p + c * d + s * h - o * u, e1[t + 3] = c * p - s * u - o * h - l * d, e1;
    }
    get x() {
        return this._x;
    }
    set x(e1) {
        this._x = e1, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e1) {
        this._y = e1, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e1) {
        this._z = e1, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(e1) {
        this._w = e1, this._onChangeCallback();
    }
    set(e1, t, i, n) {
        return this._x = e1, this._y = t, this._z = i, this._w = n, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(e1) {
        return this._x = e1.x, this._y = e1.y, this._z = e1.z, this._w = e1.w, this._onChangeCallback(), this;
    }
    setFromEuler(e1, t = !0) {
        const i = e1._x, n = e1._y, a = e1._z, r = e1._order, s = Math.cos, o = Math.sin, l = s(i / 2), c = s(n / 2), u = s(a / 2), h = o(i / 2), d = o(n / 2), p = o(a / 2);
        switch(r){
            case "XYZ":
                this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                break;
            case "YXZ":
                this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                break;
            case "ZXY":
                this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                break;
            case "ZYX":
                this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                break;
            case "YZX":
                this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                break;
            case "XZY":
                this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                break;
            default:
                $785da19a645c07eb$var$sj("Quaternion: .setFromEuler() encountered an unknown order: " + r);
        }
        return !0 === t && this._onChangeCallback(), this;
    }
    setFromAxisAngle(e1, t) {
        const i = t / 2, n = Math.sin(i);
        return this._x = e1.x * n, this._y = e1.y * n, this._z = e1.z * n, this._w = Math.cos(i), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e1) {
        const t = e1.elements, i = t[0], n = t[4], a = t[8], r = t[1], s = t[5], o = t[9], l = t[2], c = t[6], u = t[10], h = i + s + u;
        if (h > 0) {
            const e1 = .5 / Math.sqrt(h + 1);
            this._w = .25 / e1, this._x = (c - o) * e1, this._y = (a - l) * e1, this._z = (r - n) * e1;
        } else if (i > s && i > u) {
            const e1 = 2 * Math.sqrt(1 + i - s - u);
            this._w = (c - o) / e1, this._x = .25 * e1, this._y = (n + r) / e1, this._z = (a + l) / e1;
        } else if (s > u) {
            const e1 = 2 * Math.sqrt(1 + s - i - u);
            this._w = (a - l) / e1, this._x = (n + r) / e1, this._y = .25 * e1, this._z = (o + c) / e1;
        } else {
            const e1 = 2 * Math.sqrt(1 + u - i - s);
            this._w = (r - n) / e1, this._x = (a + l) / e1, this._y = (o + c) / e1, this._z = .25 * e1;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(e1, t) {
        let i = e1.dot(t) + 1;
        return i < 1e-8 ? (i = 0, Math.abs(e1.x) > Math.abs(e1.z) ? (this._x = -e1.y, this._y = e1.x, this._z = 0, this._w = i) : (this._x = 0, this._y = -e1.z, this._z = e1.y, this._w = i)) : (this._x = e1.y * t.z - e1.z * t.y, this._y = e1.z * t.x - e1.x * t.z, this._z = e1.x * t.y - e1.y * t.x, this._w = i), this.normalize();
    }
    angleTo(e1) {
        return 2 * Math.acos(Math.abs($785da19a645c07eb$var$fj(this.dot(e1), -1, 1)));
    }
    rotateTowards(e1, t) {
        const i = this.angleTo(e1);
        if (0 === i) return this;
        const n = Math.min(1, t / i);
        return this.slerp(e1, n), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(e1) {
        return this._x * e1._x + this._y * e1._y + this._z * e1._z + this._w * e1._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let e1 = this.length();
        return 0 === e1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e1 = 1 / e1, this._x = this._x * e1, this._y = this._y * e1, this._z = this._z * e1, this._w = this._w * e1), this._onChangeCallback(), this;
    }
    multiply(e1) {
        return this.multiplyQuaternions(this, e1);
    }
    premultiply(e1) {
        return this.multiplyQuaternions(e1, this);
    }
    multiplyQuaternions(e1, t) {
        const i = e1._x, n = e1._y, a = e1._z, r = e1._w, s = t._x, o = t._y, l = t._z, c = t._w;
        return this._x = i * c + r * s + n * l - a * o, this._y = n * c + r * o + a * s - i * l, this._z = a * c + r * l + i * o - n * s, this._w = r * c - i * s - n * o - a * l, this._onChangeCallback(), this;
    }
    slerp(e1, t) {
        let i = e1._x, n = e1._y, a = e1._z, r = e1._w, s = this.dot(e1);
        s < 0 && (i = -i, n = -n, a = -a, r = -r, s = -s);
        let o = 1 - t;
        if (s < .9995) {
            const e1 = Math.acos(s), l = Math.sin(e1);
            o = Math.sin(o * e1) / l, t = Math.sin(t * e1) / l, this._x = this._x * o + i * t, this._y = this._y * o + n * t, this._z = this._z * o + a * t, this._w = this._w * o + r * t, this._onChangeCallback();
        } else this._x = this._x * o + i * t, this._y = this._y * o + n * t, this._z = this._z * o + a * t, this._w = this._w * o + r * t, this.normalize();
        return this;
    }
    slerpQuaternions(e1, t, i) {
        return this.copy(e1).slerp(t, i);
    }
    random() {
        const e1 = 2 * Math.PI * Math.random(), t = 2 * Math.PI * Math.random(), i = Math.random(), n = Math.sqrt(1 - i), a = Math.sqrt(i);
        return this.set(n * Math.sin(e1), n * Math.cos(e1), a * Math.sin(t), a * Math.cos(t));
    }
    equals(e1) {
        return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._w === this._w;
    }
    fromArray(e1, t = 0) {
        return this._x = e1[t], this._y = e1[t + 1], this._z = e1[t + 2], this._w = e1[t + 3], this._onChangeCallback(), this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._w, e1;
    }
    fromBufferAttribute(e1, t) {
        return this._x = e1.getX(t), this._y = e1.getY(t), this._z = e1.getZ(t), this._w = e1.getW(t), this._onChangeCallback(), this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(e1) {
        return this._onChangeCallback = e1, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}
class $785da19a645c07eb$var$Ej {
    static{
        $785da19a645c07eb$var$Ej.prototype.isVector3 = !0;
    }
    constructor(e1 = 0, t = 0, i = 0){
        this.x = e1, this.y = t, this.z = i;
    }
    set(e1, t, i) {
        return void 0 === i && (i = this.z), this.x = e1, this.y = t, this.z = i, this;
    }
    setScalar(e1) {
        return this.x = e1, this.y = e1, this.z = e1, this;
    }
    setX(e1) {
        return this.x = e1, this;
    }
    setY(e1) {
        return this.y = e1, this;
    }
    setZ(e1) {
        return this.z = e1, this;
    }
    setComponent(e1, t) {
        switch(e1){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            default:
                throw new Error("THREE.Vector3: index is out of range: " + e1);
        }
        return this;
    }
    getComponent(e1) {
        switch(e1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("THREE.Vector3: index is out of range: " + e1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(e1) {
        return this.x = e1.x, this.y = e1.y, this.z = e1.z, this;
    }
    add(e1) {
        return this.x += e1.x, this.y += e1.y, this.z += e1.z, this;
    }
    addScalar(e1) {
        return this.x += e1, this.y += e1, this.z += e1, this;
    }
    addVectors(e1, t) {
        return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this;
    }
    addScaledVector(e1, t) {
        return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this;
    }
    sub(e1) {
        return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this;
    }
    subScalar(e1) {
        return this.x -= e1, this.y -= e1, this.z -= e1, this;
    }
    subVectors(e1, t) {
        return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this;
    }
    multiply(e1) {
        return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this;
    }
    multiplyScalar(e1) {
        return this.x *= e1, this.y *= e1, this.z *= e1, this;
    }
    multiplyVectors(e1, t) {
        return this.x = e1.x * t.x, this.y = e1.y * t.y, this.z = e1.z * t.z, this;
    }
    applyEuler(e1) {
        return this.applyQuaternion($785da19a645c07eb$var$Sj.setFromEuler(e1));
    }
    applyAxisAngle(e1, t) {
        return this.applyQuaternion($785da19a645c07eb$var$Sj.setFromAxisAngle(e1, t));
    }
    applyMatrix3(e1) {
        const t = this.x, i = this.y, n = this.z, a = e1.elements;
        return this.x = a[0] * t + a[3] * i + a[6] * n, this.y = a[1] * t + a[4] * i + a[7] * n, this.z = a[2] * t + a[5] * i + a[8] * n, this;
    }
    applyNormalMatrix(e1) {
        return this.applyMatrix3(e1).normalize();
    }
    applyMatrix4(e1) {
        const t = this.x, i = this.y, n = this.z, a = e1.elements, r = 1 / (a[3] * t + a[7] * i + a[11] * n + a[15]);
        return this.x = (a[0] * t + a[4] * i + a[8] * n + a[12]) * r, this.y = (a[1] * t + a[5] * i + a[9] * n + a[13]) * r, this.z = (a[2] * t + a[6] * i + a[10] * n + a[14]) * r, this;
    }
    applyQuaternion(e1) {
        const t = this.x, i = this.y, n = this.z, a = e1.x, r = e1.y, s = e1.z, o = e1.w, l = 2 * (r * n - s * i), c = 2 * (s * t - a * n), u = 2 * (a * i - r * t);
        return this.x = t + o * l + r * u - s * c, this.y = i + o * c + s * l - a * u, this.z = n + o * u + a * c - r * l, this;
    }
    project(e1) {
        return this.applyMatrix4(e1.matrixWorldInverse).applyMatrix4(e1.projectionMatrix);
    }
    unproject(e1) {
        return this.applyMatrix4(e1.projectionMatrixInverse).applyMatrix4(e1.matrixWorld);
    }
    transformDirection(e1) {
        const t = this.x, i = this.y, n = this.z, a = e1.elements;
        return this.x = a[0] * t + a[4] * i + a[8] * n, this.y = a[1] * t + a[5] * i + a[9] * n, this.z = a[2] * t + a[6] * i + a[10] * n, this.normalize();
    }
    divide(e1) {
        return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this;
    }
    divideScalar(e1) {
        return this.multiplyScalar(1 / e1);
    }
    min(e1) {
        return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this;
    }
    max(e1) {
        return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this;
    }
    clamp(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1.x, t.x), this.y = $785da19a645c07eb$var$fj(this.y, e1.y, t.y), this.z = $785da19a645c07eb$var$fj(this.z, e1.z, t.z), this;
    }
    clampScalar(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1, t), this.y = $785da19a645c07eb$var$fj(this.y, e1, t), this.z = $785da19a645c07eb$var$fj(this.z, e1, t), this;
    }
    clampLength(e1, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($785da19a645c07eb$var$fj(i, e1, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(e1) {
        return this.x * e1.x + this.y * e1.y + this.z * e1.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e1) {
        return this.normalize().multiplyScalar(e1);
    }
    lerp(e1, t) {
        return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this;
    }
    lerpVectors(e1, t, i) {
        return this.x = e1.x + (t.x - e1.x) * i, this.y = e1.y + (t.y - e1.y) * i, this.z = e1.z + (t.z - e1.z) * i, this;
    }
    cross(e1) {
        return this.crossVectors(this, e1);
    }
    crossVectors(e1, t) {
        const i = e1.x, n = e1.y, a = e1.z, r = t.x, s = t.y, o = t.z;
        return this.x = n * o - a * s, this.y = a * r - i * o, this.z = i * s - n * r, this;
    }
    projectOnVector(e1) {
        const t = e1.lengthSq();
        if (0 === t) return this.set(0, 0, 0);
        const i = e1.dot(this) / t;
        return this.copy(e1).multiplyScalar(i);
    }
    projectOnPlane(e1) {
        return $785da19a645c07eb$var$kj.copy(this).projectOnVector(e1), this.sub($785da19a645c07eb$var$kj);
    }
    reflect(e1) {
        return this.sub($785da19a645c07eb$var$kj.copy(e1).multiplyScalar(2 * this.dot(e1)));
    }
    angleTo(e1) {
        const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
        if (0 === t) return Math.PI / 2;
        const i = this.dot(e1) / t;
        return Math.acos($785da19a645c07eb$var$fj(i, -1, 1));
    }
    distanceTo(e1) {
        return Math.sqrt(this.distanceToSquared(e1));
    }
    distanceToSquared(e1) {
        const t = this.x - e1.x, i = this.y - e1.y, n = this.z - e1.z;
        return t * t + i * i + n * n;
    }
    manhattanDistanceTo(e1) {
        return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y) + Math.abs(this.z - e1.z);
    }
    setFromSpherical(e1) {
        return this.setFromSphericalCoords(e1.radius, e1.phi, e1.theta);
    }
    setFromSphericalCoords(e1, t, i) {
        const n = Math.sin(t) * e1;
        return this.x = n * Math.sin(i), this.y = Math.cos(t) * e1, this.z = n * Math.cos(i), this;
    }
    setFromCylindrical(e1) {
        return this.setFromCylindricalCoords(e1.radius, e1.theta, e1.y);
    }
    setFromCylindricalCoords(e1, t, i) {
        return this.x = e1 * Math.sin(t), this.y = i, this.z = e1 * Math.cos(t), this;
    }
    setFromMatrixPosition(e1) {
        const t = e1.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this;
    }
    setFromMatrixScale(e1) {
        const t = this.setFromMatrixColumn(e1, 0).length(), i = this.setFromMatrixColumn(e1, 1).length(), n = this.setFromMatrixColumn(e1, 2).length();
        return this.x = t, this.y = i, this.z = n, this;
    }
    setFromMatrixColumn(e1, t) {
        return this.fromArray(e1.elements, 4 * t);
    }
    setFromMatrix3Column(e1, t) {
        return this.fromArray(e1.elements, 3 * t);
    }
    setFromEuler(e1) {
        return this.x = e1._x, this.y = e1._y, this.z = e1._z, this;
    }
    setFromColor(e1) {
        return this.x = e1.r, this.y = e1.g, this.z = e1.b, this;
    }
    equals(e1) {
        return e1.x === this.x && e1.y === this.y && e1.z === this.z;
    }
    fromArray(e1, t = 0) {
        return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1;
    }
    fromBufferAttribute(e1, t) {
        return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        const e1 = Math.random() * Math.PI * 2, t = 2 * Math.random() - 1, i = Math.sqrt(1 - t * t);
        return this.x = i * Math.cos(e1), this.y = t, this.z = i * Math.sin(e1), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}
const $785da19a645c07eb$var$kj = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Sj = new $785da19a645c07eb$var$wj;
class $785da19a645c07eb$var$Mj {
    static{
        $785da19a645c07eb$var$Mj.prototype.isMatrix3 = !0;
    }
    constructor(e1, t, i, n, a, r, s, o, l){
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], void 0 !== e1 && this.set(e1, t, i, n, a, r, s, o, l);
    }
    set(e1, t, i, n, a, r, s, o, l) {
        const c = this.elements;
        return c[0] = e1, c[1] = n, c[2] = s, c[3] = t, c[4] = a, c[5] = o, c[6] = i, c[7] = r, c[8] = l, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(e1) {
        const t = this.elements, i = e1.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], this;
    }
    extractBasis(e1, t, i) {
        return e1.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), i.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(e1) {
        const t = e1.elements;
        return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
    }
    multiply(e1) {
        return this.multiplyMatrices(this, e1);
    }
    premultiply(e1) {
        return this.multiplyMatrices(e1, this);
    }
    multiplyMatrices(e1, t) {
        const i = e1.elements, n = t.elements, a = this.elements, r = i[0], s = i[3], o = i[6], l = i[1], c = i[4], u = i[7], h = i[2], d = i[5], p = i[8], m = n[0], g = n[3], f = n[6], A = n[1], _ = n[4], v = n[7], y = n[2], x = n[5], b = n[8];
        return a[0] = r * m + s * A + o * y, a[3] = r * g + s * _ + o * x, a[6] = r * f + s * v + o * b, a[1] = l * m + c * A + u * y, a[4] = l * g + c * _ + u * x, a[7] = l * f + c * v + u * b, a[2] = h * m + d * A + p * y, a[5] = h * g + d * _ + p * x, a[8] = h * f + d * v + p * b, this;
    }
    multiplyScalar(e1) {
        const t = this.elements;
        return t[0] *= e1, t[3] *= e1, t[6] *= e1, t[1] *= e1, t[4] *= e1, t[7] *= e1, t[2] *= e1, t[5] *= e1, t[8] *= e1, this;
    }
    determinant() {
        const e1 = this.elements, t = e1[0], i = e1[1], n = e1[2], a = e1[3], r = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
        return t * r * c - t * s * l - i * a * c + i * s * o + n * a * l - n * r * o;
    }
    invert() {
        const e1 = this.elements, t = e1[0], i = e1[1], n = e1[2], a = e1[3], r = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = c * r - s * l, h = s * o - c * a, d = l * a - r * o, p = t * u + i * h + n * d;
        if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const m = 1 / p;
        return e1[0] = u * m, e1[1] = (n * l - c * i) * m, e1[2] = (s * i - n * r) * m, e1[3] = h * m, e1[4] = (c * t - n * o) * m, e1[5] = (n * a - s * t) * m, e1[6] = d * m, e1[7] = (i * o - l * t) * m, e1[8] = (r * t - i * a) * m, this;
    }
    transpose() {
        let e1;
        const t = this.elements;
        return e1 = t[1], t[1] = t[3], t[3] = e1, e1 = t[2], t[2] = t[6], t[6] = e1, e1 = t[5], t[5] = t[7], t[7] = e1, this;
    }
    getNormalMatrix(e1) {
        return this.setFromMatrix4(e1).invert().transpose();
    }
    transposeIntoArray(e1) {
        const t = this.elements;
        return e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8], this;
    }
    setUvTransform(e1, t, i, n, a, r, s) {
        const o = Math.cos(a), l = Math.sin(a);
        return this.set(i * o, i * l, -i * (o * r + l * s) + r + e1, -n * l, n * o, -n * (-l * r + o * s) + s + t, 0, 0, 1), this;
    }
    scale(e1, t) {
        return $785da19a645c07eb$var$lj("Matrix3: .scale() is deprecated. Use .makeScale() instead."), this.premultiply($785da19a645c07eb$var$Cj.makeScale(e1, t)), this;
    }
    rotate(e1) {
        return $785da19a645c07eb$var$lj("Matrix3: .rotate() is deprecated. Use .makeRotation() instead."), this.premultiply($785da19a645c07eb$var$Cj.makeRotation(-e1)), this;
    }
    translate(e1, t) {
        return $785da19a645c07eb$var$lj("Matrix3: .translate() is deprecated. Use .makeTranslation() instead."), this.premultiply($785da19a645c07eb$var$Cj.makeTranslation(e1, t)), this;
    }
    makeTranslation(e1, t) {
        return e1.isVector2 ? this.set(1, 0, e1.x, 0, 1, e1.y, 0, 0, 1) : this.set(1, 0, e1, 0, 1, t, 0, 0, 1), this;
    }
    makeRotation(e1) {
        const t = Math.cos(e1), i = Math.sin(e1);
        return this.set(t, -i, 0, i, t, 0, 0, 0, 1), this;
    }
    makeScale(e1, t) {
        return this.set(e1, 0, 0, 0, t, 0, 0, 0, 1), this;
    }
    equals(e1) {
        const t = this.elements, i = e1.elements;
        for(let e1 = 0; e1 < 9; e1++)if (t[e1] !== i[e1]) return !1;
        return !0;
    }
    fromArray(e1, t = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = e1[i + t];
        return this;
    }
    toArray(e1 = [], t = 0) {
        const i = this.elements;
        return e1[t] = i[0], e1[t + 1] = i[1], e1[t + 2] = i[2], e1[t + 3] = i[3], e1[t + 4] = i[4], e1[t + 5] = i[5], e1[t + 6] = i[6], e1[t + 7] = i[7], e1[t + 8] = i[8], e1;
    }
    clone() {
        return (new this.constructor).fromArray(this.elements);
    }
}
const $785da19a645c07eb$var$Cj = new $785da19a645c07eb$var$Mj, $785da19a645c07eb$var$Tj = (new $785da19a645c07eb$var$Mj).set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), $785da19a645c07eb$var$Dj = (new $785da19a645c07eb$var$Mj).set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
function $785da19a645c07eb$var$Pj() {
    const e1 = {
        enabled: !0,
        workingColorSpace: $785da19a645c07eb$var$NN,
        spaces: {},
        convert: function(e1, t, i) {
            return !1 !== this.enabled && t !== i && t && i ? (this.spaces[t].transfer === $785da19a645c07eb$var$VN && (e1.r = $785da19a645c07eb$var$Fj(e1.r), e1.g = $785da19a645c07eb$var$Fj(e1.g), e1.b = $785da19a645c07eb$var$Fj(e1.b)), this.spaces[t].primaries !== this.spaces[i].primaries && (e1.applyMatrix3(this.spaces[t].toXYZ), e1.applyMatrix3(this.spaces[i].fromXYZ)), this.spaces[i].transfer === $785da19a645c07eb$var$VN && (e1.r = $785da19a645c07eb$var$zj(e1.r), e1.g = $785da19a645c07eb$var$zj(e1.g), e1.b = $785da19a645c07eb$var$zj(e1.b)), e1) : e1;
        },
        workingToColorSpace: function(e1, t) {
            return this.convert(e1, this.workingColorSpace, t);
        },
        colorSpaceToWorking: function(e1, t) {
            return this.convert(e1, t, this.workingColorSpace);
        },
        getPrimaries: function(e1) {
            return this.spaces[e1].primaries;
        },
        getTransfer: function(e1) {
            return e1 === $785da19a645c07eb$var$ON ? $785da19a645c07eb$var$jN : this.spaces[e1].transfer;
        },
        getToneMappingMode: function(e1) {
            return this.spaces[e1].outputColorSpaceConfig.toneMappingMode || "standard";
        },
        getLuminanceCoefficients: function(e1, t = this.workingColorSpace) {
            return e1.fromArray(this.spaces[t].luminanceCoefficients);
        },
        define: function(e1) {
            Object.assign(this.spaces, e1);
        },
        _getMatrix: function(e1, t, i) {
            return e1.copy(this.spaces[t].toXYZ).multiply(this.spaces[i].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(e1) {
            return this.spaces[e1].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(e1 = this.workingColorSpace) {
            return this.spaces[e1].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function(t, i) {
            return $785da19a645c07eb$var$lj("ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), e1.workingToColorSpace(t, i);
        },
        toWorkingColorSpace: function(t, i) {
            return $785da19a645c07eb$var$lj("ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), e1.colorSpaceToWorking(t, i);
        }
    }, t = [
        .64,
        .33,
        .3,
        .6,
        .15,
        .06
    ], i = [
        .2126,
        .7152,
        .0722
    ], n = [
        .3127,
        .329
    ];
    return e1.define({
        [$785da19a645c07eb$var$NN]: {
            primaries: t,
            whitePoint: n,
            transfer: $785da19a645c07eb$var$jN,
            toXYZ: $785da19a645c07eb$var$Tj,
            fromXYZ: $785da19a645c07eb$var$Dj,
            luminanceCoefficients: i,
            workingColorSpaceConfig: {
                unpackColorSpace: $785da19a645c07eb$var$UN
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $785da19a645c07eb$var$UN
            }
        },
        [$785da19a645c07eb$var$UN]: {
            primaries: t,
            whitePoint: n,
            transfer: $785da19a645c07eb$var$VN,
            toXYZ: $785da19a645c07eb$var$Tj,
            fromXYZ: $785da19a645c07eb$var$Dj,
            luminanceCoefficients: i,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $785da19a645c07eb$var$UN
            }
        }
    }), e1;
}
const $785da19a645c07eb$var$Ij = $785da19a645c07eb$var$Pj();
function $785da19a645c07eb$var$Fj(e1) {
    return e1 < .04045 ? .0773993808 * e1 : Math.pow(.9478672986 * e1 + .0521327014, 2.4);
}
function $785da19a645c07eb$var$zj(e1) {
    return e1 < .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, .41666) - .055;
}
let $785da19a645c07eb$var$Rj;
class $785da19a645c07eb$var$Lj {
    static getDataURL(e1, t = "image/png") {
        if (/^data:/i.test(e1.src)) return e1.src;
        if ("undefined" == typeof HTMLCanvasElement) return e1.src;
        let i;
        if (e1 instanceof HTMLCanvasElement) i = e1;
        else {
            void 0 === $785da19a645c07eb$var$Rj && ($785da19a645c07eb$var$Rj = $785da19a645c07eb$var$tj("canvas")), $785da19a645c07eb$var$Rj.width = e1.width, $785da19a645c07eb$var$Rj.height = e1.height;
            const t = $785da19a645c07eb$var$Rj.getContext("2d");
            e1 instanceof ImageData ? t.putImageData(e1, 0, 0) : t.drawImage(e1, 0, 0, e1.width, e1.height), i = $785da19a645c07eb$var$Rj;
        }
        return i.toDataURL(t);
    }
    static sRGBToLinear(e1) {
        if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
            const t = $785da19a645c07eb$var$tj("canvas");
            t.width = e1.width, t.height = e1.height;
            const i = t.getContext("2d");
            i.drawImage(e1, 0, 0, e1.width, e1.height);
            const n = i.getImageData(0, 0, e1.width, e1.height), a = n.data;
            for(let e1 = 0; e1 < a.length; e1++)a[e1] = 255 * $785da19a645c07eb$var$Fj(a[e1] / 255);
            return i.putImageData(n, 0, 0), t;
        }
        if (e1.data) {
            const t = e1.data.slice(0);
            for(let e1 = 0; e1 < t.length; e1++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e1] = Math.floor(255 * $785da19a645c07eb$var$Fj(t[e1] / 255)) : t[e1] = $785da19a645c07eb$var$Fj(t[e1]);
            return {
                data: t,
                width: e1.width,
                height: e1.height
            };
        }
        return $785da19a645c07eb$var$sj("ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e1;
    }
}
let $785da19a645c07eb$var$Bj = 0;
class $785da19a645c07eb$var$Oj {
    constructor(e1 = null){
        this.isSource = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$Bj++
        }), this.uuid = $785da19a645c07eb$var$gj(), this.data = e1, this.dataReady = !0, this.version = 0;
    }
    getSize(e1) {
        const t = this.data;
        return "undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement ? e1.set(t.videoWidth, t.videoHeight, 0) : "undefined" != typeof VideoFrame && t instanceof VideoFrame ? e1.set(t.displayWidth, t.displayHeight, 0) : null !== t ? e1.set(t.width, t.height, t.depth || 0) : e1.set(0, 0, 0), e1;
    }
    set needsUpdate(e1) {
        !0 === e1 && this.version++;
    }
    toJSON(e1) {
        const t = void 0 === e1 || "string" == typeof e1;
        if (!t && void 0 !== e1.images[this.uuid]) return e1.images[this.uuid];
        const i = {
            uuid: this.uuid,
            url: ""
        }, n = this.data;
        if (null !== n) {
            let e1;
            if (Array.isArray(n)) {
                e1 = [];
                for(let t = 0, i = n.length; t < i; t++)n[t].isDataTexture ? e1.push($785da19a645c07eb$var$Uj(n[t].image)) : e1.push($785da19a645c07eb$var$Uj(n[t]));
            } else e1 = $785da19a645c07eb$var$Uj(n);
            i.url = e1;
        }
        return t || (e1.images[this.uuid] = i), i;
    }
}
function $785da19a645c07eb$var$Uj(e1) {
    return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap ? $785da19a645c07eb$var$Lj.getDataURL(e1) : e1.data ? {
        data: Array.from(e1.data),
        width: e1.width,
        height: e1.height,
        type: e1.data.constructor.name
    } : ($785da19a645c07eb$var$sj("Texture: Unable to serialize Texture."), {});
}
let $785da19a645c07eb$var$Nj = 0;
const $785da19a645c07eb$var$jj = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$Vj extends $785da19a645c07eb$var$uj {
    constructor(e1 = $785da19a645c07eb$var$Vj.DEFAULT_IMAGE, t = $785da19a645c07eb$var$Vj.DEFAULT_MAPPING, i = 1001, n = 1001, a = 1006, r = 1008, s = 1023, o = $785da19a645c07eb$var$LU, l = $785da19a645c07eb$var$Vj.DEFAULT_ANISOTROPY, c = ""){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$Nj++
        }), this.uuid = $785da19a645c07eb$var$gj(), this.name = "", this.source = new $785da19a645c07eb$var$Oj(e1), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = i, this.wrapT = n, this.magFilter = a, this.minFilter = r, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new $785da19a645c07eb$var$bj(0, 0), this.repeat = new $785da19a645c07eb$var$bj(1, 1), this.center = new $785da19a645c07eb$var$bj(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $785da19a645c07eb$var$Mj, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = c, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(e1 && e1.depth && e1.depth > 1), this.pmremVersion = 0, this.normalized = !1;
    }
    get width() {
        return this.source.getSize($785da19a645c07eb$var$jj).x;
    }
    get height() {
        return this.source.getSize($785da19a645c07eb$var$jj).y;
    }
    get depth() {
        return this.source.getSize($785da19a645c07eb$var$jj).z;
    }
    get image() {
        return this.source.data;
    }
    set image(e1) {
        this.source.data = e1;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    addUpdateRange(e1, t) {
        this.updateRanges.push({
            start: e1,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        return this.name = e1.name, this.source = e1.source, this.mipmaps = e1.mipmaps.slice(0), this.mapping = e1.mapping, this.channel = e1.channel, this.wrapS = e1.wrapS, this.wrapT = e1.wrapT, this.magFilter = e1.magFilter, this.minFilter = e1.minFilter, this.anisotropy = e1.anisotropy, this.format = e1.format, this.internalFormat = e1.internalFormat, this.type = e1.type, this.normalized = e1.normalized, this.offset.copy(e1.offset), this.repeat.copy(e1.repeat), this.center.copy(e1.center), this.rotation = e1.rotation, this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrix.copy(e1.matrix), this.generateMipmaps = e1.generateMipmaps, this.premultiplyAlpha = e1.premultiplyAlpha, this.flipY = e1.flipY, this.unpackAlignment = e1.unpackAlignment, this.colorSpace = e1.colorSpace, this.renderTarget = e1.renderTarget, this.isRenderTargetTexture = e1.isRenderTargetTexture, this.isArrayTexture = e1.isArrayTexture, this.userData = JSON.parse(JSON.stringify(e1.userData)), this.needsUpdate = !0, this;
    }
    setValues(e1) {
        for(const t in e1){
            const i = e1[t];
            if (void 0 === i) {
                $785da19a645c07eb$var$sj(`Texture.setValues(): parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            void 0 !== n ? n && i && n.isVector2 && i.isVector2 || n && i && n.isVector3 && i.isVector3 || n && i && n.isMatrix3 && i.isMatrix3 ? n.copy(i) : this[t] = i : $785da19a645c07eb$var$sj(`Texture.setValues(): property '${t}' does not exist.`);
        }
    }
    toJSON(e1) {
        const t = void 0 === e1 || "string" == typeof e1;
        if (!t && void 0 !== e1.textures[this.uuid]) return e1.textures[this.uuid];
        const i = {
            metadata: {
                version: 4.7,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(e1).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            normalized: this.normalized,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (i.userData = this.userData), t || (e1.textures[this.uuid] = i), i;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(e1) {
        if (300 !== this.mapping) return e1;
        if (e1.applyMatrix3(this.matrix), e1.x < 0 || e1.x > 1) switch(this.wrapS){
            case $785da19a645c07eb$var$MU:
                e1.x = e1.x - Math.floor(e1.x);
                break;
            case $785da19a645c07eb$var$CU:
                e1.x = e1.x < 0 ? 0 : 1;
                break;
            case $785da19a645c07eb$var$TU:
                1 === Math.abs(Math.floor(e1.x) % 2) ? e1.x = Math.ceil(e1.x) - e1.x : e1.x = e1.x - Math.floor(e1.x);
        }
        if (e1.y < 0 || e1.y > 1) switch(this.wrapT){
            case $785da19a645c07eb$var$MU:
                e1.y = e1.y - Math.floor(e1.y);
                break;
            case $785da19a645c07eb$var$CU:
                e1.y = e1.y < 0 ? 0 : 1;
                break;
            case $785da19a645c07eb$var$TU:
                1 === Math.abs(Math.floor(e1.y) % 2) ? e1.y = Math.ceil(e1.y) - e1.y : e1.y = e1.y - Math.floor(e1.y);
        }
        return this.flipY && (e1.y = 1 - e1.y), e1;
    }
    set needsUpdate(e1) {
        !0 === e1 && (this.version++, this.source.needsUpdate = !0);
    }
    set needsPMREMUpdate(e1) {
        !0 === e1 && this.pmremVersion++;
    }
}
$785da19a645c07eb$var$Vj.DEFAULT_IMAGE = null, $785da19a645c07eb$var$Vj.DEFAULT_MAPPING = 300, $785da19a645c07eb$var$Vj.DEFAULT_ANISOTROPY = 1;
class $785da19a645c07eb$var$qj {
    static{
        $785da19a645c07eb$var$qj.prototype.isVector4 = !0;
    }
    constructor(e1 = 0, t = 0, i = 0, n = 1){
        this.x = e1, this.y = t, this.z = i, this.w = n;
    }
    get width() {
        return this.z;
    }
    set width(e1) {
        this.z = e1;
    }
    get height() {
        return this.w;
    }
    set height(e1) {
        this.w = e1;
    }
    set(e1, t, i, n) {
        return this.x = e1, this.y = t, this.z = i, this.w = n, this;
    }
    setScalar(e1) {
        return this.x = e1, this.y = e1, this.z = e1, this.w = e1, this;
    }
    setX(e1) {
        return this.x = e1, this;
    }
    setY(e1) {
        return this.y = e1, this;
    }
    setZ(e1) {
        return this.z = e1, this;
    }
    setW(e1) {
        return this.w = e1, this;
    }
    setComponent(e1, t) {
        switch(e1){
            case 0:
                this.x = t;
                break;
            case 1:
                this.y = t;
                break;
            case 2:
                this.z = t;
                break;
            case 3:
                this.w = t;
                break;
            default:
                throw new Error("THREE.Vector4: index is out of range: " + e1);
        }
        return this;
    }
    getComponent(e1) {
        switch(e1){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("THREE.Vector4: index is out of range: " + e1);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(e1) {
        return this.x = e1.x, this.y = e1.y, this.z = e1.z, this.w = void 0 !== e1.w ? e1.w : 1, this;
    }
    add(e1) {
        return this.x += e1.x, this.y += e1.y, this.z += e1.z, this.w += e1.w, this;
    }
    addScalar(e1) {
        return this.x += e1, this.y += e1, this.z += e1, this.w += e1, this;
    }
    addVectors(e1, t) {
        return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this.w = e1.w + t.w, this;
    }
    addScaledVector(e1, t) {
        return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this.w += e1.w * t, this;
    }
    sub(e1) {
        return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this.w -= e1.w, this;
    }
    subScalar(e1) {
        return this.x -= e1, this.y -= e1, this.z -= e1, this.w -= e1, this;
    }
    subVectors(e1, t) {
        return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this.w = e1.w - t.w, this;
    }
    multiply(e1) {
        return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this.w *= e1.w, this;
    }
    multiplyScalar(e1) {
        return this.x *= e1, this.y *= e1, this.z *= e1, this.w *= e1, this;
    }
    applyMatrix4(e1) {
        const t = this.x, i = this.y, n = this.z, a = this.w, r = e1.elements;
        return this.x = r[0] * t + r[4] * i + r[8] * n + r[12] * a, this.y = r[1] * t + r[5] * i + r[9] * n + r[13] * a, this.z = r[2] * t + r[6] * i + r[10] * n + r[14] * a, this.w = r[3] * t + r[7] * i + r[11] * n + r[15] * a, this;
    }
    divide(e1) {
        return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this.w /= e1.w, this;
    }
    divideScalar(e1) {
        return this.multiplyScalar(1 / e1);
    }
    setAxisAngleFromQuaternion(e1) {
        this.w = 2 * Math.acos(e1.w);
        const t = Math.sqrt(1 - e1.w * e1.w);
        return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e1.x / t, this.y = e1.y / t, this.z = e1.z / t), this;
    }
    setAxisAngleFromRotationMatrix(e1) {
        let t, i, n, a;
        const r = .01, s = .1, o = e1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], m = o[2], g = o[6], f = o[10];
        if (Math.abs(c - h) < r && Math.abs(u - m) < r && Math.abs(p - g) < r) {
            if (Math.abs(c + h) < s && Math.abs(u + m) < s && Math.abs(p + g) < s && Math.abs(l + d + f - 3) < s) return this.set(1, 0, 0, 0), this;
            t = Math.PI;
            const e1 = (l + 1) / 2, o = (d + 1) / 2, A = (f + 1) / 2, _ = (c + h) / 4, v = (u + m) / 4, y = (p + g) / 4;
            return e1 > o && e1 > A ? e1 < r ? (i = 0, n = .707106781, a = .707106781) : (i = Math.sqrt(e1), n = _ / i, a = v / i) : o > A ? o < r ? (i = .707106781, n = 0, a = .707106781) : (n = Math.sqrt(o), i = _ / n, a = y / n) : A < r ? (i = .707106781, n = .707106781, a = 0) : (a = Math.sqrt(A), i = v / a, n = y / a), this.set(i, n, a, t), this;
        }
        let A = Math.sqrt((g - p) * (g - p) + (u - m) * (u - m) + (h - c) * (h - c));
        return Math.abs(A) < .001 && (A = 1), this.x = (g - p) / A, this.y = (u - m) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + f - 1) / 2), this;
    }
    setFromMatrixPosition(e1) {
        const t = e1.elements;
        return this.x = t[12], this.y = t[13], this.z = t[14], this.w = t[15], this;
    }
    min(e1) {
        return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this.w = Math.min(this.w, e1.w), this;
    }
    max(e1) {
        return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this.w = Math.max(this.w, e1.w), this;
    }
    clamp(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1.x, t.x), this.y = $785da19a645c07eb$var$fj(this.y, e1.y, t.y), this.z = $785da19a645c07eb$var$fj(this.z, e1.z, t.z), this.w = $785da19a645c07eb$var$fj(this.w, e1.w, t.w), this;
    }
    clampScalar(e1, t) {
        return this.x = $785da19a645c07eb$var$fj(this.x, e1, t), this.y = $785da19a645c07eb$var$fj(this.y, e1, t), this.z = $785da19a645c07eb$var$fj(this.z, e1, t), this.w = $785da19a645c07eb$var$fj(this.w, e1, t), this;
    }
    clampLength(e1, t) {
        const i = this.length();
        return this.divideScalar(i || 1).multiplyScalar($785da19a645c07eb$var$fj(i, e1, t));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(e1) {
        return this.x * e1.x + this.y * e1.y + this.z * e1.z + this.w * e1.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(e1) {
        return this.normalize().multiplyScalar(e1);
    }
    lerp(e1, t) {
        return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this.w += (e1.w - this.w) * t, this;
    }
    lerpVectors(e1, t, i) {
        return this.x = e1.x + (t.x - e1.x) * i, this.y = e1.y + (t.y - e1.y) * i, this.z = e1.z + (t.z - e1.z) * i, this.w = e1.w + (t.w - e1.w) * i, this;
    }
    equals(e1) {
        return e1.x === this.x && e1.y === this.y && e1.z === this.z && e1.w === this.w;
    }
    fromArray(e1, t = 0) {
        return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this.w = e1[t + 3], this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1[t + 3] = this.w, e1;
    }
    fromBufferAttribute(e1, t) {
        return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this.w = e1.getW(t), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}
class $785da19a645c07eb$var$Gj extends $785da19a645c07eb$var$uj {
    constructor(e1 = 1, t = 1, i = {}){
        super(), i = Object.assign({
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: $785da19a645c07eb$var$FU,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1,
            useArrayDepthTexture: !1
        }, i), this.isRenderTarget = !0, this.width = e1, this.height = t, this.depth = i.depth, this.scissor = new $785da19a645c07eb$var$qj(0, 0, e1, t), this.scissorTest = !1, this.viewport = new $785da19a645c07eb$var$qj(0, 0, e1, t), this.textures = [];
        const n = {
            width: e1,
            height: t,
            depth: i.depth
        }, a = new $785da19a645c07eb$var$Vj(n), r = i.count;
        for(let e1 = 0; e1 < r; e1++)this.textures[e1] = a.clone(), this.textures[e1].isRenderTargetTexture = !0, this.textures[e1].renderTarget = this;
        this._setTextureOptions(i), this.depthBuffer = i.depthBuffer, this.stencilBuffer = i.stencilBuffer, this.resolveDepthBuffer = i.resolveDepthBuffer, this.resolveStencilBuffer = i.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = i.depthTexture, this.samples = i.samples, this.multiview = i.multiview, this.useArrayDepthTexture = i.useArrayDepthTexture;
    }
    _setTextureOptions(e1 = {}) {
        const t = {
            minFilter: $785da19a645c07eb$var$FU,
            generateMipmaps: !1,
            flipY: !1,
            internalFormat: null
        };
        void 0 !== e1.mapping && (t.mapping = e1.mapping), void 0 !== e1.wrapS && (t.wrapS = e1.wrapS), void 0 !== e1.wrapT && (t.wrapT = e1.wrapT), void 0 !== e1.wrapR && (t.wrapR = e1.wrapR), void 0 !== e1.magFilter && (t.magFilter = e1.magFilter), void 0 !== e1.minFilter && (t.minFilter = e1.minFilter), void 0 !== e1.format && (t.format = e1.format), void 0 !== e1.type && (t.type = e1.type), void 0 !== e1.anisotropy && (t.anisotropy = e1.anisotropy), void 0 !== e1.colorSpace && (t.colorSpace = e1.colorSpace), void 0 !== e1.flipY && (t.flipY = e1.flipY), void 0 !== e1.generateMipmaps && (t.generateMipmaps = e1.generateMipmaps), void 0 !== e1.internalFormat && (t.internalFormat = e1.internalFormat);
        for(let e1 = 0; e1 < this.textures.length; e1++)this.textures[e1].setValues(t);
    }
    get texture() {
        return this.textures[0];
    }
    set texture(e1) {
        this.textures[0] = e1;
    }
    set depthTexture(e1) {
        null !== this._depthTexture && (this._depthTexture.renderTarget = null), null !== e1 && (e1.renderTarget = this), this._depthTexture = e1;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(e1, t, i = 1) {
        if (this.width !== e1 || this.height !== t || this.depth !== i) {
            this.width = e1, this.height = t, this.depth = i;
            for(let n = 0, a = this.textures.length; n < a; n++)this.textures[n].image.width = e1, this.textures[n].image.height = t, this.textures[n].image.depth = i, !0 !== this.textures[n].isData3DTexture && (this.textures[n].isArrayTexture = this.textures[n].image.depth > 1);
            this.dispose();
        }
        this.viewport.set(0, 0, e1, t), this.scissor.set(0, 0, e1, t);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        this.width = e1.width, this.height = e1.height, this.depth = e1.depth, this.scissor.copy(e1.scissor), this.scissorTest = e1.scissorTest, this.viewport.copy(e1.viewport), this.textures.length = 0;
        for(let t = 0, i = e1.textures.length; t < i; t++){
            this.textures[t] = e1.textures[t].clone(), this.textures[t].isRenderTargetTexture = !0, this.textures[t].renderTarget = this;
            const i = Object.assign({}, e1.textures[t].image);
            this.textures[t].source = new $785da19a645c07eb$var$Oj(i);
        }
        return this.depthBuffer = e1.depthBuffer, this.stencilBuffer = e1.stencilBuffer, this.resolveDepthBuffer = e1.resolveDepthBuffer, this.resolveStencilBuffer = e1.resolveStencilBuffer, null !== e1.depthTexture && (this.depthTexture = e1.depthTexture.clone()), this.samples = e1.samples, this.multiview = e1.multiview, this.useArrayDepthTexture = e1.useArrayDepthTexture, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $785da19a645c07eb$var$Hj extends $785da19a645c07eb$var$Gj {
    constructor(e1 = 1, t = 1, i = {}){
        super(e1, t, i), this.isWebGLRenderTarget = !0;
    }
}
class $785da19a645c07eb$var$Wj extends $785da19a645c07eb$var$Vj {
    constructor(e1 = null, t = 1, i = 1, n = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: e1,
            width: t,
            height: i,
            depth: n
        }, this.magFilter = $785da19a645c07eb$var$DU, this.minFilter = $785da19a645c07eb$var$DU, this.wrapR = $785da19a645c07eb$var$CU, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
    }
    addLayerUpdate(e1) {
        this.layerUpdates.add(e1);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $785da19a645c07eb$var$Zj extends $785da19a645c07eb$var$Vj {
    constructor(e1 = null, t = 1, i = 1, n = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: e1,
            width: t,
            height: i,
            depth: n
        }, this.magFilter = $785da19a645c07eb$var$DU, this.minFilter = $785da19a645c07eb$var$DU, this.wrapR = $785da19a645c07eb$var$CU, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
class $785da19a645c07eb$var$Kj {
    static{
        $785da19a645c07eb$var$Kj.prototype.isMatrix4 = !0;
    }
    constructor(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g){
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ], void 0 !== e1 && this.set(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g);
    }
    set(e1, t, i, n, a, r, s, o, l, c, u, h, d, p, m, g) {
        const f = this.elements;
        return f[0] = e1, f[4] = t, f[8] = i, f[12] = n, f[1] = a, f[5] = r, f[9] = s, f[13] = o, f[2] = l, f[6] = c, f[10] = u, f[14] = h, f[3] = d, f[7] = p, f[11] = m, f[15] = g, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return (new $785da19a645c07eb$var$Kj).fromArray(this.elements);
    }
    copy(e1) {
        const t = this.elements, i = e1.elements;
        return t[0] = i[0], t[1] = i[1], t[2] = i[2], t[3] = i[3], t[4] = i[4], t[5] = i[5], t[6] = i[6], t[7] = i[7], t[8] = i[8], t[9] = i[9], t[10] = i[10], t[11] = i[11], t[12] = i[12], t[13] = i[13], t[14] = i[14], t[15] = i[15], this;
    }
    copyPosition(e1) {
        const t = this.elements, i = e1.elements;
        return t[12] = i[12], t[13] = i[13], t[14] = i[14], this;
    }
    setFromMatrix3(e1) {
        const t = e1.elements;
        return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(e1, t, i) {
        return 0 === this.determinantAffine() ? (e1.set(1, 0, 0), t.set(0, 1, 0), i.set(0, 0, 1), this) : (e1.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), i.setFromMatrixColumn(this, 2), this);
    }
    makeBasis(e1, t, i) {
        return this.set(e1.x, t.x, i.x, 0, e1.y, t.y, i.y, 0, e1.z, t.z, i.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(e1) {
        if (0 === e1.determinantAffine()) return this.identity();
        const t = this.elements, i = e1.elements, n = 1 / $785da19a645c07eb$var$Xj.setFromMatrixColumn(e1, 0).length(), a = 1 / $785da19a645c07eb$var$Xj.setFromMatrixColumn(e1, 1).length(), r = 1 / $785da19a645c07eb$var$Xj.setFromMatrixColumn(e1, 2).length();
        return t[0] = i[0] * n, t[1] = i[1] * n, t[2] = i[2] * n, t[3] = 0, t[4] = i[4] * a, t[5] = i[5] * a, t[6] = i[6] * a, t[7] = 0, t[8] = i[8] * r, t[9] = i[9] * r, t[10] = i[10] * r, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromEuler(e1) {
        const t = this.elements, i = e1.x, n = e1.y, a = e1.z, r = Math.cos(i), s = Math.sin(i), o = Math.cos(n), l = Math.sin(n), c = Math.cos(a), u = Math.sin(a);
        if ("XYZ" === e1.order) {
            const e1 = r * c, i = r * u, n = s * c, a = s * u;
            t[0] = o * c, t[4] = -o * u, t[8] = l, t[1] = i + n * l, t[5] = e1 - a * l, t[9] = -s * o, t[2] = a - e1 * l, t[6] = n + i * l, t[10] = r * o;
        } else if ("YXZ" === e1.order) {
            const e1 = o * c, i = o * u, n = l * c, a = l * u;
            t[0] = e1 + a * s, t[4] = n * s - i, t[8] = r * l, t[1] = r * u, t[5] = r * c, t[9] = -s, t[2] = i * s - n, t[6] = a + e1 * s, t[10] = r * o;
        } else if ("ZXY" === e1.order) {
            const e1 = o * c, i = o * u, n = l * c, a = l * u;
            t[0] = e1 - a * s, t[4] = -r * u, t[8] = n + i * s, t[1] = i + n * s, t[5] = r * c, t[9] = a - e1 * s, t[2] = -r * l, t[6] = s, t[10] = r * o;
        } else if ("ZYX" === e1.order) {
            const e1 = r * c, i = r * u, n = s * c, a = s * u;
            t[0] = o * c, t[4] = n * l - i, t[8] = e1 * l + a, t[1] = o * u, t[5] = a * l + e1, t[9] = i * l - n, t[2] = -l, t[6] = s * o, t[10] = r * o;
        } else if ("YZX" === e1.order) {
            const e1 = r * o, i = r * l, n = s * o, a = s * l;
            t[0] = o * c, t[4] = a - e1 * u, t[8] = n * u + i, t[1] = u, t[5] = r * c, t[9] = -s * c, t[2] = -l * c, t[6] = i * u + n, t[10] = e1 - a * u;
        } else if ("XZY" === e1.order) {
            const e1 = r * o, i = r * l, n = s * o, a = s * l;
            t[0] = o * c, t[4] = -u, t[8] = l * c, t[1] = e1 * u + a, t[5] = r * c, t[9] = i * u - n, t[2] = n * u - i, t[6] = s * c, t[10] = a * u + e1;
        }
        return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
    }
    makeRotationFromQuaternion(e1) {
        return this.compose($785da19a645c07eb$var$Yj, e1, $785da19a645c07eb$var$Jj);
    }
    lookAt(e1, t, i) {
        const n = this.elements;
        return $785da19a645c07eb$var$tV.subVectors(e1, t), 0 === $785da19a645c07eb$var$tV.lengthSq() && ($785da19a645c07eb$var$tV.z = 1), $785da19a645c07eb$var$tV.normalize(), $785da19a645c07eb$var$$j.crossVectors(i, $785da19a645c07eb$var$tV), 0 === $785da19a645c07eb$var$$j.lengthSq() && (1 === Math.abs(i.z) ? $785da19a645c07eb$var$tV.x += 1e-4 : $785da19a645c07eb$var$tV.z += 1e-4, $785da19a645c07eb$var$tV.normalize(), $785da19a645c07eb$var$$j.crossVectors(i, $785da19a645c07eb$var$tV)), $785da19a645c07eb$var$$j.normalize(), $785da19a645c07eb$var$eV.crossVectors($785da19a645c07eb$var$tV, $785da19a645c07eb$var$$j), n[0] = $785da19a645c07eb$var$$j.x, n[4] = $785da19a645c07eb$var$eV.x, n[8] = $785da19a645c07eb$var$tV.x, n[1] = $785da19a645c07eb$var$$j.y, n[5] = $785da19a645c07eb$var$eV.y, n[9] = $785da19a645c07eb$var$tV.y, n[2] = $785da19a645c07eb$var$$j.z, n[6] = $785da19a645c07eb$var$eV.z, n[10] = $785da19a645c07eb$var$tV.z, this;
    }
    multiply(e1) {
        return this.multiplyMatrices(this, e1);
    }
    premultiply(e1) {
        return this.multiplyMatrices(e1, this);
    }
    multiplyMatrices(e1, t) {
        const i = e1.elements, n = t.elements, a = this.elements, r = i[0], s = i[4], o = i[8], l = i[12], c = i[1], u = i[5], h = i[9], d = i[13], p = i[2], m = i[6], g = i[10], f = i[14], A = i[3], _ = i[7], v = i[11], y = i[15], x = n[0], b = n[4], w = n[8], E = n[12], k = n[1], S = n[5], M = n[9], C = n[13], T = n[2], D = n[6], P = n[10], I = n[14], F = n[3], z = n[7], R = n[11], L1 = n[15];
        return a[0] = r * x + s * k + o * T + l * F, a[4] = r * b + s * S + o * D + l * z, a[8] = r * w + s * M + o * P + l * R, a[12] = r * E + s * C + o * I + l * L1, a[1] = c * x + u * k + h * T + d * F, a[5] = c * b + u * S + h * D + d * z, a[9] = c * w + u * M + h * P + d * R, a[13] = c * E + u * C + h * I + d * L1, a[2] = p * x + m * k + g * T + f * F, a[6] = p * b + m * S + g * D + f * z, a[10] = p * w + m * M + g * P + f * R, a[14] = p * E + m * C + g * I + f * L1, a[3] = A * x + _ * k + v * T + y * F, a[7] = A * b + _ * S + v * D + y * z, a[11] = A * w + _ * M + v * P + y * R, a[15] = A * E + _ * C + v * I + y * L1, this;
    }
    multiplyScalar(e1) {
        const t = this.elements;
        return t[0] *= e1, t[4] *= e1, t[8] *= e1, t[12] *= e1, t[1] *= e1, t[5] *= e1, t[9] *= e1, t[13] *= e1, t[2] *= e1, t[6] *= e1, t[10] *= e1, t[14] *= e1, t[3] *= e1, t[7] *= e1, t[11] *= e1, t[15] *= e1, this;
    }
    determinant() {
        const e1 = this.elements, t = e1[0], i = e1[4], n = e1[8], a = e1[12], r = e1[1], s = e1[5], o = e1[9], l = e1[13], c = e1[2], u = e1[6], h = e1[10], d = e1[14], p = e1[3], m = e1[7], g = e1[11], f = e1[15], A = o * d - l * h, _ = s * d - l * u, v = s * h - o * u, y = r * d - l * c, x = r * h - o * c, b = r * u - s * c;
        return t * (m * A - g * _ + f * v) - i * (p * A - g * y + f * x) + n * (p * _ - m * y + f * b) - a * (p * v - m * x + g * b);
    }
    determinantAffine() {
        const e1 = this.elements, t = e1[0], i = e1[4], n = e1[8], a = e1[1], r = e1[5], s = e1[9], o = e1[2], l = e1[6], c = e1[10];
        return t * (r * c - s * l) - i * (a * c - s * o) + n * (a * l - r * o);
    }
    transpose() {
        const e1 = this.elements;
        let t;
        return t = e1[1], e1[1] = e1[4], e1[4] = t, t = e1[2], e1[2] = e1[8], e1[8] = t, t = e1[6], e1[6] = e1[9], e1[9] = t, t = e1[3], e1[3] = e1[12], e1[12] = t, t = e1[7], e1[7] = e1[13], e1[13] = t, t = e1[11], e1[11] = e1[14], e1[14] = t, this;
    }
    setPosition(e1, t, i) {
        const n = this.elements;
        return e1.isVector3 ? (n[12] = e1.x, n[13] = e1.y, n[14] = e1.z) : (n[12] = e1, n[13] = t, n[14] = i), this;
    }
    invert() {
        const e1 = this.elements, t = e1[0], i = e1[1], n = e1[2], a = e1[3], r = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], d = e1[11], p = e1[12], m = e1[13], g = e1[14], f = e1[15], A = t * s - i * r, _ = t * o - n * r, v = t * l - a * r, y = i * o - n * s, x = i * l - a * s, b = n * l - a * o, w = c * m - u * p, E = c * g - h * p, k = c * f - d * p, S = u * g - h * m, M = u * f - d * m, C = h * f - d * g, T = A * C - _ * M + v * S + y * k - x * E + b * w;
        if (0 === T) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const D = 1 / T;
        return e1[0] = (s * C - o * M + l * S) * D, e1[1] = (n * M - i * C - a * S) * D, e1[2] = (m * b - g * x + f * y) * D, e1[3] = (h * x - u * b - d * y) * D, e1[4] = (o * k - r * C - l * E) * D, e1[5] = (t * C - n * k + a * E) * D, e1[6] = (g * v - p * b - f * _) * D, e1[7] = (c * b - h * v + d * _) * D, e1[8] = (r * M - s * k + l * w) * D, e1[9] = (i * k - t * M - a * w) * D, e1[10] = (p * x - m * v + f * A) * D, e1[11] = (u * v - c * x - d * A) * D, e1[12] = (s * E - r * S - o * w) * D, e1[13] = (t * S - i * E + n * w) * D, e1[14] = (m * _ - p * y - g * A) * D, e1[15] = (c * y - u * _ + h * A) * D, this;
    }
    scale(e1) {
        const t = this.elements, i = e1.x, n = e1.y, a = e1.z;
        return t[0] *= i, t[4] *= n, t[8] *= a, t[1] *= i, t[5] *= n, t[9] *= a, t[2] *= i, t[6] *= n, t[10] *= a, t[3] *= i, t[7] *= n, t[11] *= a, this;
    }
    getMaxScaleOnAxis() {
        const e1 = this.elements, t = e1[0] * e1[0] + e1[1] * e1[1] + e1[2] * e1[2], i = e1[4] * e1[4] + e1[5] * e1[5] + e1[6] * e1[6], n = e1[8] * e1[8] + e1[9] * e1[9] + e1[10] * e1[10];
        return Math.sqrt(Math.max(t, i, n));
    }
    makeTranslation(e1, t, i) {
        return e1.isVector3 ? this.set(1, 0, 0, e1.x, 0, 1, 0, e1.y, 0, 0, 1, e1.z, 0, 0, 0, 1) : this.set(1, 0, 0, e1, 0, 1, 0, t, 0, 0, 1, i, 0, 0, 0, 1), this;
    }
    makeRotationX(e1) {
        const t = Math.cos(e1), i = Math.sin(e1);
        return this.set(1, 0, 0, 0, 0, t, -i, 0, 0, i, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(e1) {
        const t = Math.cos(e1), i = Math.sin(e1);
        return this.set(t, 0, i, 0, 0, 1, 0, 0, -i, 0, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(e1) {
        const t = Math.cos(e1), i = Math.sin(e1);
        return this.set(t, -i, 0, 0, i, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(e1, t) {
        const i = Math.cos(t), n = Math.sin(t), a = 1 - i, r = e1.x, s = e1.y, o = e1.z, l = a * r, c = a * s;
        return this.set(l * r + i, l * s - n * o, l * o + n * s, 0, l * s + n * o, c * s + i, c * o - n * r, 0, l * o - n * s, c * o + n * r, a * o * o + i, 0, 0, 0, 0, 1), this;
    }
    makeScale(e1, t, i) {
        return this.set(e1, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this;
    }
    makeShear(e1, t, i, n, a, r) {
        return this.set(1, i, a, 0, e1, 1, r, 0, t, n, 1, 0, 0, 0, 0, 1), this;
    }
    compose(e1, t, i) {
        const n = this.elements, a = t._x, r = t._y, s = t._z, o = t._w, l = a + a, c = r + r, u = s + s, h = a * l, d = a * c, p = a * u, m = r * c, g = r * u, f = s * u, A = o * l, _ = o * c, v = o * u, y = i.x, x = i.y, b = i.z;
        return n[0] = (1 - (m + f)) * y, n[1] = (d + v) * y, n[2] = (p - _) * y, n[3] = 0, n[4] = (d - v) * x, n[5] = (1 - (h + f)) * x, n[6] = (g + A) * x, n[7] = 0, n[8] = (p + _) * b, n[9] = (g - A) * b, n[10] = (1 - (h + m)) * b, n[11] = 0, n[12] = e1.x, n[13] = e1.y, n[14] = e1.z, n[15] = 1, this;
    }
    decompose(e1, t, i) {
        const n = this.elements;
        e1.x = n[12], e1.y = n[13], e1.z = n[14];
        const a = this.determinantAffine();
        if (0 === a) return i.set(1, 1, 1), t.identity(), this;
        let r = $785da19a645c07eb$var$Xj.set(n[0], n[1], n[2]).length();
        const s = $785da19a645c07eb$var$Xj.set(n[4], n[5], n[6]).length(), o = $785da19a645c07eb$var$Xj.set(n[8], n[9], n[10]).length();
        a < 0 && (r = -r), $785da19a645c07eb$var$Qj.copy(this);
        const l = 1 / r, c = 1 / s, u = 1 / o;
        return $785da19a645c07eb$var$Qj.elements[0] *= l, $785da19a645c07eb$var$Qj.elements[1] *= l, $785da19a645c07eb$var$Qj.elements[2] *= l, $785da19a645c07eb$var$Qj.elements[4] *= c, $785da19a645c07eb$var$Qj.elements[5] *= c, $785da19a645c07eb$var$Qj.elements[6] *= c, $785da19a645c07eb$var$Qj.elements[8] *= u, $785da19a645c07eb$var$Qj.elements[9] *= u, $785da19a645c07eb$var$Qj.elements[10] *= u, t.setFromRotationMatrix($785da19a645c07eb$var$Qj), i.x = r, i.y = s, i.z = o, this;
    }
    makePerspective(e1, t, i, n, a, r, s = 2e3, o = !1) {
        const l = this.elements, c = 2 * a / (t - e1), u = 2 * a / (i - n), h = (t + e1) / (t - e1), d = (i + n) / (i - n);
        let p, m;
        if (o) p = a / (r - a), m = r * a / (r - a);
        else if (s === $785da19a645c07eb$var$$N) p = -(r + a) / (r - a), m = -2 * r * a / (r - a);
        else {
            if (s !== $785da19a645c07eb$var$ej) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
            p = -r / (r - a), m = -r * a / (r - a);
        }
        return l[0] = c, l[4] = 0, l[8] = h, l[12] = 0, l[1] = 0, l[5] = u, l[9] = d, l[13] = 0, l[2] = 0, l[6] = 0, l[10] = p, l[14] = m, l[3] = 0, l[7] = 0, l[11] = -1, l[15] = 0, this;
    }
    makeOrthographic(e1, t, i, n, a, r, s = 2e3, o = !1) {
        const l = this.elements, c = 2 / (t - e1), u = 2 / (i - n), h = -(t + e1) / (t - e1), d = -(i + n) / (i - n);
        let p, m;
        if (o) p = 1 / (r - a), m = r / (r - a);
        else if (s === $785da19a645c07eb$var$$N) p = -2 / (r - a), m = -(r + a) / (r - a);
        else {
            if (s !== $785da19a645c07eb$var$ej) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
            p = -1 / (r - a), m = -a / (r - a);
        }
        return l[0] = c, l[4] = 0, l[8] = 0, l[12] = h, l[1] = 0, l[5] = u, l[9] = 0, l[13] = d, l[2] = 0, l[6] = 0, l[10] = p, l[14] = m, l[3] = 0, l[7] = 0, l[11] = 0, l[15] = 1, this;
    }
    equals(e1) {
        const t = this.elements, i = e1.elements;
        for(let e1 = 0; e1 < 16; e1++)if (t[e1] !== i[e1]) return !1;
        return !0;
    }
    fromArray(e1, t = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = e1[i + t];
        return this;
    }
    toArray(e1 = [], t = 0) {
        const i = this.elements;
        return e1[t] = i[0], e1[t + 1] = i[1], e1[t + 2] = i[2], e1[t + 3] = i[3], e1[t + 4] = i[4], e1[t + 5] = i[5], e1[t + 6] = i[6], e1[t + 7] = i[7], e1[t + 8] = i[8], e1[t + 9] = i[9], e1[t + 10] = i[10], e1[t + 11] = i[11], e1[t + 12] = i[12], e1[t + 13] = i[13], e1[t + 14] = i[14], e1[t + 15] = i[15], e1;
    }
}
const $785da19a645c07eb$var$Xj = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Qj = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$Yj = new $785da19a645c07eb$var$Ej(0, 0, 0), $785da19a645c07eb$var$Jj = new $785da19a645c07eb$var$Ej(1, 1, 1), $785da19a645c07eb$var$$j = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$eV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$tV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$iV = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$nV = new $785da19a645c07eb$var$wj;
class $785da19a645c07eb$var$aV {
    constructor(e1 = 0, t = 0, i = 0, n = $785da19a645c07eb$var$aV.DEFAULT_ORDER){
        this.isEuler = !0, this._x = e1, this._y = t, this._z = i, this._order = n;
    }
    get x() {
        return this._x;
    }
    set x(e1) {
        this._x = e1, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(e1) {
        this._y = e1, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(e1) {
        this._z = e1, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(e1) {
        this._order = e1, this._onChangeCallback();
    }
    set(e1, t, i, n = this._order) {
        return this._x = e1, this._y = t, this._z = i, this._order = n, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(e1) {
        return this._x = e1._x, this._y = e1._y, this._z = e1._z, this._order = e1._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(e1, t = this._order, i = !0) {
        const n = e1.elements, a = n[0], r = n[4], s = n[8], o = n[1], l = n[5], c = n[9], u = n[2], h = n[6], d = n[10];
        switch(t){
            case "XYZ":
                this._y = Math.asin($785da19a645c07eb$var$fj(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-r, a)) : (this._x = Math.atan2(h, l), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-$785da19a645c07eb$var$fj(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, a), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin($785da19a645c07eb$var$fj(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-r, l)) : (this._y = 0, this._z = Math.atan2(o, a));
                break;
            case "ZYX":
                this._y = Math.asin(-$785da19a645c07eb$var$fj(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, a)) : (this._x = 0, this._z = Math.atan2(-r, l));
                break;
            case "YZX":
                this._z = Math.asin($785da19a645c07eb$var$fj(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, a)) : (this._x = 0, this._y = Math.atan2(s, d));
                break;
            case "XZY":
                this._z = Math.asin(-$785da19a645c07eb$var$fj(r, -1, 1)), Math.abs(r) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, a)) : (this._x = Math.atan2(-c, d), this._y = 0);
                break;
            default:
                $785da19a645c07eb$var$sj("Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
        }
        return this._order = t, !0 === i && this._onChangeCallback(), this;
    }
    setFromQuaternion(e1, t, i) {
        return $785da19a645c07eb$var$iV.makeRotationFromQuaternion(e1), this.setFromRotationMatrix($785da19a645c07eb$var$iV, t, i);
    }
    setFromVector3(e1, t = this._order) {
        return this.set(e1.x, e1.y, e1.z, t);
    }
    reorder(e1) {
        return $785da19a645c07eb$var$nV.setFromEuler(this), this.setFromQuaternion($785da19a645c07eb$var$nV, e1);
    }
    equals(e1) {
        return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._order === this._order;
    }
    fromArray(e1) {
        return this._x = e1[0], this._y = e1[1], this._z = e1[2], void 0 !== e1[3] && (this._order = e1[3]), this._onChangeCallback(), this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._order, e1;
    }
    _onChange(e1) {
        return this._onChangeCallback = e1, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
}
$785da19a645c07eb$var$aV.DEFAULT_ORDER = "XYZ";
class $785da19a645c07eb$var$rV {
    constructor(){
        this.mask = 1;
    }
    set(e1) {
        this.mask = 1 << e1 >>> 0;
    }
    enable(e1) {
        this.mask |= 1 << e1;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(e1) {
        this.mask ^= 1 << e1;
    }
    disable(e1) {
        this.mask &= ~(1 << e1);
    }
    disableAll() {
        this.mask = 0;
    }
    test(e1) {
        return 0 !== (this.mask & e1.mask);
    }
    isEnabled(e1) {
        return !!(this.mask & 1 << e1);
    }
}
let $785da19a645c07eb$var$sV = 0;
const $785da19a645c07eb$var$oV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$lV = new $785da19a645c07eb$var$wj, $785da19a645c07eb$var$cV = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$uV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$hV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$dV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$pV = new $785da19a645c07eb$var$wj, $785da19a645c07eb$var$mV = new $785da19a645c07eb$var$Ej(1, 0, 0), $785da19a645c07eb$var$gV = new $785da19a645c07eb$var$Ej(0, 1, 0), $785da19a645c07eb$var$fV = new $785da19a645c07eb$var$Ej(0, 0, 1), $785da19a645c07eb$var$AV = {
    type: "added"
}, $785da19a645c07eb$var$_V = {
    type: "removed"
}, $785da19a645c07eb$var$vV = {
    type: "childadded",
    child: null
}, $785da19a645c07eb$var$yV = {
    type: "childremoved",
    child: null
};
class $785da19a645c07eb$var$xV extends $785da19a645c07eb$var$uj {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$sV++
        }), this.uuid = $785da19a645c07eb$var$gj(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = $785da19a645c07eb$var$xV.DEFAULT_UP.clone();
        const e1 = new $785da19a645c07eb$var$Ej, t = new $785da19a645c07eb$var$aV, i = new $785da19a645c07eb$var$wj, n = new $785da19a645c07eb$var$Ej(1, 1, 1);
        t._onChange(function() {
            i.setFromEuler(t, !1);
        }), i._onChange(function() {
            t.setFromQuaternion(i, void 0, !1);
        }), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: e1
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            modelViewMatrix: {
                value: new $785da19a645c07eb$var$Kj
            },
            normalMatrix: {
                value: new $785da19a645c07eb$var$Mj
            }
        }), this.matrix = new $785da19a645c07eb$var$Kj, this.matrixWorld = new $785da19a645c07eb$var$Kj, this.matrixAutoUpdate = $785da19a645c07eb$var$xV.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = $785da19a645c07eb$var$xV.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new $785da19a645c07eb$var$rV, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.static = !1, this.userData = {}, this.pivot = null;
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(e1) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e1), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(e1) {
        return this.quaternion.premultiply(e1), this;
    }
    setRotationFromAxisAngle(e1, t) {
        this.quaternion.setFromAxisAngle(e1, t);
    }
    setRotationFromEuler(e1) {
        this.quaternion.setFromEuler(e1, !0);
    }
    setRotationFromMatrix(e1) {
        this.quaternion.setFromRotationMatrix(e1);
    }
    setRotationFromQuaternion(e1) {
        this.quaternion.copy(e1);
    }
    rotateOnAxis(e1, t) {
        return $785da19a645c07eb$var$lV.setFromAxisAngle(e1, t), this.quaternion.multiply($785da19a645c07eb$var$lV), this;
    }
    rotateOnWorldAxis(e1, t) {
        return $785da19a645c07eb$var$lV.setFromAxisAngle(e1, t), this.quaternion.premultiply($785da19a645c07eb$var$lV), this;
    }
    rotateX(e1) {
        return this.rotateOnAxis($785da19a645c07eb$var$mV, e1);
    }
    rotateY(e1) {
        return this.rotateOnAxis($785da19a645c07eb$var$gV, e1);
    }
    rotateZ(e1) {
        return this.rotateOnAxis($785da19a645c07eb$var$fV, e1);
    }
    translateOnAxis(e1, t) {
        return $785da19a645c07eb$var$oV.copy(e1).applyQuaternion(this.quaternion), this.position.add($785da19a645c07eb$var$oV.multiplyScalar(t)), this;
    }
    translateX(e1) {
        return this.translateOnAxis($785da19a645c07eb$var$mV, e1);
    }
    translateY(e1) {
        return this.translateOnAxis($785da19a645c07eb$var$gV, e1);
    }
    translateZ(e1) {
        return this.translateOnAxis($785da19a645c07eb$var$fV, e1);
    }
    localToWorld(e1) {
        return this.updateWorldMatrix(!0, !1), e1.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(e1) {
        return this.updateWorldMatrix(!0, !1), e1.applyMatrix4($785da19a645c07eb$var$cV.copy(this.matrixWorld).invert());
    }
    lookAt(e1, t, i) {
        e1.isVector3 ? $785da19a645c07eb$var$uV.copy(e1) : $785da19a645c07eb$var$uV.set(e1, t, i);
        const n = this.parent;
        this.updateWorldMatrix(!0, !1), $785da19a645c07eb$var$hV.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? $785da19a645c07eb$var$cV.lookAt($785da19a645c07eb$var$hV, $785da19a645c07eb$var$uV, this.up) : $785da19a645c07eb$var$cV.lookAt($785da19a645c07eb$var$uV, $785da19a645c07eb$var$hV, this.up), this.quaternion.setFromRotationMatrix($785da19a645c07eb$var$cV), n && ($785da19a645c07eb$var$cV.extractRotation(n.matrixWorld), $785da19a645c07eb$var$lV.setFromRotationMatrix($785da19a645c07eb$var$cV), this.quaternion.premultiply($785da19a645c07eb$var$lV.invert()));
    }
    add(e1) {
        if (arguments.length > 1) {
            for(let e1 = 0; e1 < arguments.length; e1++)this.add(arguments[e1]);
            return this;
        }
        return e1 === this ? ($785da19a645c07eb$var$oj("Object3D.add: object can't be added as a child of itself.", e1), this) : (e1 && e1.isObject3D ? (e1.removeFromParent(), e1.parent = this, this.children.push(e1), e1.dispatchEvent($785da19a645c07eb$var$AV), $785da19a645c07eb$var$vV.child = e1, this.dispatchEvent($785da19a645c07eb$var$vV), $785da19a645c07eb$var$vV.child = null) : $785da19a645c07eb$var$oj("Object3D.add: object not an instance of THREE.Object3D.", e1), this);
    }
    remove(e1) {
        if (arguments.length > 1) {
            for(let e1 = 0; e1 < arguments.length; e1++)this.remove(arguments[e1]);
            return this;
        }
        const t = this.children.indexOf(e1);
        return -1 !== t && (e1.parent = null, this.children.splice(t, 1), e1.dispatchEvent($785da19a645c07eb$var$_V), $785da19a645c07eb$var$yV.child = e1, this.dispatchEvent($785da19a645c07eb$var$yV), $785da19a645c07eb$var$yV.child = null), this;
    }
    removeFromParent() {
        const e1 = this.parent;
        return null !== e1 && e1.remove(this), this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(e1) {
        return this.updateWorldMatrix(!0, !1), $785da19a645c07eb$var$cV.copy(this.matrixWorld).invert(), null !== e1.parent && (e1.parent.updateWorldMatrix(!0, !1), $785da19a645c07eb$var$cV.multiply(e1.parent.matrixWorld)), e1.applyMatrix4($785da19a645c07eb$var$cV), e1.removeFromParent(), e1.parent = this, this.children.push(e1), e1.updateWorldMatrix(!1, !0), e1.dispatchEvent($785da19a645c07eb$var$AV), $785da19a645c07eb$var$vV.child = e1, this.dispatchEvent($785da19a645c07eb$var$vV), $785da19a645c07eb$var$vV.child = null, this;
    }
    getObjectById(e1) {
        return this.getObjectByProperty("id", e1);
    }
    getObjectByName(e1) {
        return this.getObjectByProperty("name", e1);
    }
    getObjectByProperty(e1, t) {
        if (this[e1] === t) return this;
        for(let i = 0, n = this.children.length; i < n; i++){
            const n = this.children[i].getObjectByProperty(e1, t);
            if (void 0 !== n) return n;
        }
    }
    getObjectsByProperty(e1, t, i = []) {
        this[e1] === t && i.push(this);
        const n = this.children;
        for(let a = 0, r = n.length; a < r; a++)n[a].getObjectsByProperty(e1, t, i);
        return i;
    }
    getWorldPosition(e1) {
        return this.updateWorldMatrix(!0, !1), e1.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(e1) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($785da19a645c07eb$var$hV, e1, $785da19a645c07eb$var$dV), e1;
    }
    getWorldScale(e1) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($785da19a645c07eb$var$hV, $785da19a645c07eb$var$pV, e1), e1;
    }
    getWorldDirection(e1) {
        this.updateWorldMatrix(!0, !1);
        const t = this.matrixWorld.elements;
        return e1.set(t[8], t[9], t[10]).normalize();
    }
    raycast() {}
    traverse(e1) {
        e1(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverse(e1);
    }
    traverseVisible(e1) {
        if (!1 === this.visible) return;
        e1(this);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].traverseVisible(e1);
    }
    traverseAncestors(e1) {
        const t = this.parent;
        null !== t && (e1(t), t.traverseAncestors(e1));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        const e1 = this.pivot;
        if (null !== e1) {
            const t = e1.x, i = e1.y, n = e1.z, a = this.matrix.elements;
            a[12] += t - a[0] * t - a[4] * i - a[8] * n, a[13] += i - a[1] * t - a[5] * i - a[9] * n, a[14] += n - a[2] * t - a[6] * i - a[10] * n;
        }
        this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(e1) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e1) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, e1 = !0);
        const t = this.children;
        for(let i = 0, n = t.length; i < n; i++)t[i].updateMatrixWorld(e1);
    }
    updateWorldMatrix(e1, t, i = !1) {
        const n = this.parent;
        if (!0 === e1 && null !== n && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || i) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, i = !0), !0 === t) {
            const e1 = this.children;
            for(let t = 0, n = e1.length; t < n; t++)e1[t].updateWorldMatrix(!1, !0, i);
        }
    }
    toJSON(e1) {
        const t = void 0 === e1 || "string" == typeof e1, i = {};
        t && (e1 = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, i.metadata = {
            version: 4.7,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        const n = {};
        function a(t, i) {
            return void 0 === t[i.uuid] && (t[i.uuid] = i.toJSON(e1)), i.uuid;
        }
        if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), !0 === this.castShadow && (n.castShadow = !0), !0 === this.receiveShadow && (n.receiveShadow = !0), !1 === this.visible && (n.visible = !1), !1 === this.frustumCulled && (n.frustumCulled = !1), 0 !== this.renderOrder && (n.renderOrder = this.renderOrder), !1 !== this.static && (n.static = this.static), Object.keys(this.userData).length > 0 && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), n.up = this.up.toArray(), null !== this.pivot && (n.pivot = this.pivot.toArray()), !1 === this.matrixAutoUpdate && (n.matrixAutoUpdate = !1), void 0 !== this.morphTargetDictionary && (n.morphTargetDictionary = Object.assign({}, this.morphTargetDictionary)), void 0 !== this.morphTargetInfluences && (n.morphTargetInfluences = this.morphTargetInfluences.slice()), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (n.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (n.type = "BatchedMesh", n.perObjectFrustumCulled = this.perObjectFrustumCulled, n.sortObjects = this.sortObjects, n.drawRanges = this._drawRanges, n.reservedRanges = this._reservedRanges, n.geometryInfo = this._geometryInfo.map((e1)=>({
                ...e1,
                boundingBox: e1.boundingBox ? e1.boundingBox.toJSON() : void 0,
                boundingSphere: e1.boundingSphere ? e1.boundingSphere.toJSON() : void 0
            })), n.instanceInfo = this._instanceInfo.map((e1)=>({
                ...e1
            })), n.availableInstanceIds = this._availableInstanceIds.slice(), n.availableGeometryIds = this._availableGeometryIds.slice(), n.nextIndexStart = this._nextIndexStart, n.nextVertexStart = this._nextVertexStart, n.geometryCount = this._geometryCount, n.maxInstanceCount = this._maxInstanceCount, n.maxVertexCount = this._maxVertexCount, n.maxIndexCount = this._maxIndexCount, n.geometryInitialized = this._geometryInitialized, n.matricesTexture = this._matricesTexture.toJSON(e1), n.indirectTexture = this._indirectTexture.toJSON(e1), null !== this._colorsTexture && (n.colorsTexture = this._colorsTexture.toJSON(e1)), null !== this.boundingSphere && (n.boundingSphere = this.boundingSphere.toJSON()), null !== this.boundingBox && (n.boundingBox = this.boundingBox.toJSON())), this.isScene) this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(e1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (n.environment = this.environment.toJSON(e1).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            n.geometry = a(e1.geometries, this.geometry);
            const t = this.geometry.parameters;
            if (void 0 !== t && void 0 !== t.shapes) {
                const i = t.shapes;
                if (Array.isArray(i)) for(let t = 0, n = i.length; t < n; t++){
                    const n = i[t];
                    a(e1.shapes, n);
                }
                else a(e1.shapes, i);
            }
        }
        if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (a(e1.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
            if (Array.isArray(this.material)) {
                const t = [];
                for(let i = 0, n = this.material.length; i < n; i++)t.push(a(e1.materials, this.material[i]));
                n.material = t;
            } else n.material = a(e1.materials, this.material);
        }
        if (this.children.length > 0) {
            n.children = [];
            for(let t = 0; t < this.children.length; t++)n.children.push(this.children[t].toJSON(e1).object);
        }
        if (this.animations.length > 0) {
            n.animations = [];
            for(let t = 0; t < this.animations.length; t++){
                const i = this.animations[t];
                n.animations.push(a(e1.animations, i));
            }
        }
        if (t) {
            const t = r(e1.geometries), n = r(e1.materials), a = r(e1.textures), s = r(e1.images), o = r(e1.shapes), l = r(e1.skeletons), c = r(e1.animations), u = r(e1.nodes);
            t.length > 0 && (i.geometries = t), n.length > 0 && (i.materials = n), a.length > 0 && (i.textures = a), s.length > 0 && (i.images = s), o.length > 0 && (i.shapes = o), l.length > 0 && (i.skeletons = l), c.length > 0 && (i.animations = c), u.length > 0 && (i.nodes = u);
        }
        return i.object = n, i;
        function r(e1) {
            const t = [];
            for(const i in e1){
                const n = e1[i];
                delete n.metadata, t.push(n);
            }
            return t;
        }
    }
    clone(e1) {
        return (new this.constructor).copy(this, e1);
    }
    copy(e1, t = !0) {
        if (this.name = e1.name, this.up.copy(e1.up), this.position.copy(e1.position), this.rotation.order = e1.rotation.order, this.quaternion.copy(e1.quaternion), this.scale.copy(e1.scale), this.pivot = null !== e1.pivot ? e1.pivot.clone() : null, this.matrix.copy(e1.matrix), this.matrixWorld.copy(e1.matrixWorld), this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrixWorldAutoUpdate = e1.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = e1.matrixWorldNeedsUpdate, this.layers.mask = e1.layers.mask, this.visible = e1.visible, this.castShadow = e1.castShadow, this.receiveShadow = e1.receiveShadow, this.frustumCulled = e1.frustumCulled, this.renderOrder = e1.renderOrder, this.static = e1.static, this.animations = e1.animations.slice(), this.userData = JSON.parse(JSON.stringify(e1.userData)), !0 === t) for(let t = 0; t < e1.children.length; t++){
            const i = e1.children[t];
            this.add(i.clone());
        }
        return this;
    }
}
$785da19a645c07eb$var$xV.DEFAULT_UP = new $785da19a645c07eb$var$Ej(0, 1, 0), $785da19a645c07eb$var$xV.DEFAULT_MATRIX_AUTO_UPDATE = !0, $785da19a645c07eb$var$xV.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
class $785da19a645c07eb$var$bV extends $785da19a645c07eb$var$xV {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}
const $785da19a645c07eb$var$wV = {
    type: "move"
};
class $785da19a645c07eb$var$EV {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return null === this._hand && (this._hand = new $785da19a645c07eb$var$bV, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return null === this._targetRay && (this._targetRay = new $785da19a645c07eb$var$bV, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new $785da19a645c07eb$var$Ej, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new $785da19a645c07eb$var$Ej), this._targetRay;
    }
    getGripSpace() {
        return null === this._grip && (this._grip = new $785da19a645c07eb$var$bV, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new $785da19a645c07eb$var$Ej, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new $785da19a645c07eb$var$Ej, this._grip.eventsEnabled = !1), this._grip;
    }
    dispatchEvent(e1) {
        return null !== this._targetRay && this._targetRay.dispatchEvent(e1), null !== this._grip && this._grip.dispatchEvent(e1), null !== this._hand && this._hand.dispatchEvent(e1), this;
    }
    connect(e1) {
        if (e1 && e1.hand) {
            const t = this._hand;
            if (t) for (const i of e1.hand.values())this._getHandJoint(t, i);
        }
        return this.dispatchEvent({
            type: "connected",
            data: e1
        }), this;
    }
    disconnect(e1) {
        return this.dispatchEvent({
            type: "disconnected",
            data: e1
        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
    }
    update(e1, t, i) {
        let n = null, a = null, r = null;
        const s = this._targetRay, o = this._grip, l = this._hand;
        if (e1 && "visible-blurred" !== t.session.visibilityState) {
            if (l && e1.hand) {
                r = !0;
                for (const n of e1.hand.values()){
                    const e1 = t.getJointPose(n, i), a = this._getHandJoint(l, n);
                    null !== e1 && (a.matrix.fromArray(e1.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), a.matrixWorldNeedsUpdate = !0, a.jointRadius = e1.radius), a.visible = null !== e1;
                }
                const n = l.joints["index-finger-tip"], a = l.joints["thumb-tip"], s = n.position.distanceTo(a.position), o = .02, c = .005;
                l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: e1.handedness,
                    target: this
                })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: e1.handedness,
                    target: this
                }));
            } else null !== o && e1.gripSpace && (a = t.getPose(e1.gripSpace, i), null !== a && (o.matrix.fromArray(a.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, a.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(a.linearVelocity)) : o.hasLinearVelocity = !1, a.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(a.angularVelocity)) : o.hasAngularVelocity = !1, o.eventsEnabled && o.dispatchEvent({
                type: "gripUpdated",
                data: e1,
                target: this
            })));
            null !== s && (n = t.getPose(e1.targetRaySpace, i), null === n && null !== a && (n = a), null !== n && (s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, n.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(n.linearVelocity)) : s.hasLinearVelocity = !1, n.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(n.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent($785da19a645c07eb$var$wV)));
        }
        return null !== s && (s.visible = null !== n), null !== o && (o.visible = null !== a), null !== l && (l.visible = null !== r), this;
    }
    _getHandJoint(e1, t) {
        if (void 0 === e1.joints[t.jointName]) {
            const i = new $785da19a645c07eb$var$bV;
            i.matrixAutoUpdate = !1, i.visible = !1, e1.joints[t.jointName] = i, e1.add(i);
        }
        return e1.joints[t.jointName];
    }
}
const $785da19a645c07eb$var$kV = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, $785da19a645c07eb$var$SV = {
    h: 0,
    s: 0,
    l: 0
}, $785da19a645c07eb$var$MV = {
    h: 0,
    s: 0,
    l: 0
};
function $785da19a645c07eb$var$CV(e1, t, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e1 + 6 * (t - e1) * i : i < .5 ? t : i < 2 / 3 ? e1 + 6 * (t - e1) * (2 / 3 - i) : e1;
}
class $785da19a645c07eb$var$TV {
    constructor(e1, t, i){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e1, t, i);
    }
    set(e1, t, i) {
        if (void 0 === t && void 0 === i) {
            const t = e1;
            t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t);
        } else this.setRGB(e1, t, i);
        return this;
    }
    setScalar(e1) {
        return this.r = e1, this.g = e1, this.b = e1, this;
    }
    setHex(e1, t = $785da19a645c07eb$var$UN) {
        return e1 = Math.floor(e1), this.r = (e1 >> 16 & 255) / 255, this.g = (e1 >> 8 & 255) / 255, this.b = (255 & e1) / 255, $785da19a645c07eb$var$Ij.colorSpaceToWorking(this, t), this;
    }
    setRGB(e1, t, i, n = $785da19a645c07eb$var$Ij.workingColorSpace) {
        return this.r = e1, this.g = t, this.b = i, $785da19a645c07eb$var$Ij.colorSpaceToWorking(this, n), this;
    }
    setHSL(e1, t, i, n = $785da19a645c07eb$var$Ij.workingColorSpace) {
        if (e1 = $785da19a645c07eb$var$Aj(e1, 1), t = $785da19a645c07eb$var$fj(t, 0, 1), i = $785da19a645c07eb$var$fj(i, 0, 1), 0 === t) this.r = this.g = this.b = i;
        else {
            const n = i <= .5 ? i * (1 + t) : i + t - i * t, a = 2 * i - n;
            this.r = $785da19a645c07eb$var$CV(a, n, e1 + 1 / 3), this.g = $785da19a645c07eb$var$CV(a, n, e1), this.b = $785da19a645c07eb$var$CV(a, n, e1 - 1 / 3);
        }
        return $785da19a645c07eb$var$Ij.colorSpaceToWorking(this, n), this;
    }
    setStyle(e1, t = $785da19a645c07eb$var$UN) {
        function i(t) {
            void 0 !== t && parseFloat(t) < 1 && $785da19a645c07eb$var$sj("Color: Alpha component of " + e1 + " will be ignored.");
        }
        let n;
        if (n = /^(\w+)\(([^\)]*)\)/.exec(e1)) {
            let a;
            const r = n[1], s = n[2];
            switch(r){
                case "rgb":
                case "rgba":
                    if (a = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setRGB(Math.min(255, parseInt(a[1], 10)) / 255, Math.min(255, parseInt(a[2], 10)) / 255, Math.min(255, parseInt(a[3], 10)) / 255, t);
                    if (a = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setRGB(Math.min(100, parseInt(a[1], 10)) / 100, Math.min(100, parseInt(a[2], 10)) / 100, Math.min(100, parseInt(a[3], 10)) / 100, t);
                    break;
                case "hsl":
                case "hsla":
                    if (a = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(a[4]), this.setHSL(parseFloat(a[1]) / 360, parseFloat(a[2]) / 100, parseFloat(a[3]) / 100, t);
                    break;
                default:
                    $785da19a645c07eb$var$sj("Color: Unknown color model " + e1);
            }
        } else if (n = /^\#([A-Fa-f\d]+)$/.exec(e1)) {
            const i = n[1], a = i.length;
            if (3 === a) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, t);
            if (6 === a) return this.setHex(parseInt(i, 16), t);
            $785da19a645c07eb$var$sj("Color: Invalid hex color " + e1);
        } else if (e1 && e1.length > 0) return this.setColorName(e1, t);
        return this;
    }
    setColorName(e1, t = $785da19a645c07eb$var$UN) {
        const i = $785da19a645c07eb$var$kV[e1.toLowerCase()];
        return void 0 !== i ? this.setHex(i, t) : $785da19a645c07eb$var$sj("Color: Unknown color " + e1), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(e1) {
        return this.r = e1.r, this.g = e1.g, this.b = e1.b, this;
    }
    copySRGBToLinear(e1) {
        return this.r = $785da19a645c07eb$var$Fj(e1.r), this.g = $785da19a645c07eb$var$Fj(e1.g), this.b = $785da19a645c07eb$var$Fj(e1.b), this;
    }
    copyLinearToSRGB(e1) {
        return this.r = $785da19a645c07eb$var$zj(e1.r), this.g = $785da19a645c07eb$var$zj(e1.g), this.b = $785da19a645c07eb$var$zj(e1.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(e1 = $785da19a645c07eb$var$UN) {
        return $785da19a645c07eb$var$Ij.workingToColorSpace($785da19a645c07eb$var$DV.copy(this), e1), 65536 * Math.round($785da19a645c07eb$var$fj(255 * $785da19a645c07eb$var$DV.r, 0, 255)) + 256 * Math.round($785da19a645c07eb$var$fj(255 * $785da19a645c07eb$var$DV.g, 0, 255)) + Math.round($785da19a645c07eb$var$fj(255 * $785da19a645c07eb$var$DV.b, 0, 255));
    }
    getHexString(e1 = $785da19a645c07eb$var$UN) {
        return ("000000" + this.getHex(e1).toString(16)).slice(-6);
    }
    getHSL(e1, t = $785da19a645c07eb$var$Ij.workingColorSpace) {
        $785da19a645c07eb$var$Ij.workingToColorSpace($785da19a645c07eb$var$DV.copy(this), t);
        const i = $785da19a645c07eb$var$DV.r, n = $785da19a645c07eb$var$DV.g, a = $785da19a645c07eb$var$DV.b, r = Math.max(i, n, a), s = Math.min(i, n, a);
        let o, l;
        const c = (s + r) / 2;
        if (s === r) o = 0, l = 0;
        else {
            const e1 = r - s;
            switch(l = c <= .5 ? e1 / (r + s) : e1 / (2 - r - s), r){
                case i:
                    o = (n - a) / e1 + (n < a ? 6 : 0);
                    break;
                case n:
                    o = (a - i) / e1 + 2;
                    break;
                case a:
                    o = (i - n) / e1 + 4;
            }
            o /= 6;
        }
        return e1.h = o, e1.s = l, e1.l = c, e1;
    }
    getRGB(e1, t = $785da19a645c07eb$var$Ij.workingColorSpace) {
        return $785da19a645c07eb$var$Ij.workingToColorSpace($785da19a645c07eb$var$DV.copy(this), t), e1.r = $785da19a645c07eb$var$DV.r, e1.g = $785da19a645c07eb$var$DV.g, e1.b = $785da19a645c07eb$var$DV.b, e1;
    }
    getStyle(e1 = $785da19a645c07eb$var$UN) {
        $785da19a645c07eb$var$Ij.workingToColorSpace($785da19a645c07eb$var$DV.copy(this), e1);
        const t = $785da19a645c07eb$var$DV.r, i = $785da19a645c07eb$var$DV.g, n = $785da19a645c07eb$var$DV.b;
        return e1 !== $785da19a645c07eb$var$UN ? `color(${e1} ${t.toFixed(3)} ${i.toFixed(3)} ${n.toFixed(3)})` : `rgb(${Math.round(255 * t)},${Math.round(255 * i)},${Math.round(255 * n)})`;
    }
    offsetHSL(e1, t, i) {
        return this.getHSL($785da19a645c07eb$var$SV), this.setHSL($785da19a645c07eb$var$SV.h + e1, $785da19a645c07eb$var$SV.s + t, $785da19a645c07eb$var$SV.l + i);
    }
    add(e1) {
        return this.r += e1.r, this.g += e1.g, this.b += e1.b, this;
    }
    addColors(e1, t) {
        return this.r = e1.r + t.r, this.g = e1.g + t.g, this.b = e1.b + t.b, this;
    }
    addScalar(e1) {
        return this.r += e1, this.g += e1, this.b += e1, this;
    }
    sub(e1) {
        return this.r = Math.max(0, this.r - e1.r), this.g = Math.max(0, this.g - e1.g), this.b = Math.max(0, this.b - e1.b), this;
    }
    multiply(e1) {
        return this.r *= e1.r, this.g *= e1.g, this.b *= e1.b, this;
    }
    multiplyScalar(e1) {
        return this.r *= e1, this.g *= e1, this.b *= e1, this;
    }
    lerp(e1, t) {
        return this.r += (e1.r - this.r) * t, this.g += (e1.g - this.g) * t, this.b += (e1.b - this.b) * t, this;
    }
    lerpColors(e1, t, i) {
        return this.r = e1.r + (t.r - e1.r) * i, this.g = e1.g + (t.g - e1.g) * i, this.b = e1.b + (t.b - e1.b) * i, this;
    }
    lerpHSL(e1, t) {
        this.getHSL($785da19a645c07eb$var$SV), e1.getHSL($785da19a645c07eb$var$MV);
        const i = $785da19a645c07eb$var$_j($785da19a645c07eb$var$SV.h, $785da19a645c07eb$var$MV.h, t), n = $785da19a645c07eb$var$_j($785da19a645c07eb$var$SV.s, $785da19a645c07eb$var$MV.s, t), a = $785da19a645c07eb$var$_j($785da19a645c07eb$var$SV.l, $785da19a645c07eb$var$MV.l, t);
        return this.setHSL(i, n, a), this;
    }
    setFromVector3(e1) {
        return this.r = e1.x, this.g = e1.y, this.b = e1.z, this;
    }
    applyMatrix3(e1) {
        const t = this.r, i = this.g, n = this.b, a = e1.elements;
        return this.r = a[0] * t + a[3] * i + a[6] * n, this.g = a[1] * t + a[4] * i + a[7] * n, this.b = a[2] * t + a[5] * i + a[8] * n, this;
    }
    equals(e1) {
        return e1.r === this.r && e1.g === this.g && e1.b === this.b;
    }
    fromArray(e1, t = 0) {
        return this.r = e1[t], this.g = e1[t + 1], this.b = e1[t + 2], this;
    }
    toArray(e1 = [], t = 0) {
        return e1[t] = this.r, e1[t + 1] = this.g, e1[t + 2] = this.b, e1;
    }
    fromBufferAttribute(e1, t) {
        return this.r = e1.getX(t), this.g = e1.getY(t), this.b = e1.getZ(t), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
}
const $785da19a645c07eb$var$DV = new $785da19a645c07eb$var$TV;
$785da19a645c07eb$var$TV.NAMES = $785da19a645c07eb$var$kV;
class $785da19a645c07eb$var$PV extends $785da19a645c07eb$var$xV {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new $785da19a645c07eb$var$aV, this.environmentIntensity = 1, this.environmentRotation = new $785da19a645c07eb$var$aV, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(e1, t) {
        return super.copy(e1, t), null !== e1.background && (this.background = e1.background.clone()), null !== e1.environment && (this.environment = e1.environment.clone()), null !== e1.fog && (this.fog = e1.fog.clone()), this.backgroundBlurriness = e1.backgroundBlurriness, this.backgroundIntensity = e1.backgroundIntensity, this.backgroundRotation.copy(e1.backgroundRotation), this.environmentIntensity = e1.environmentIntensity, this.environmentRotation.copy(e1.environmentRotation), null !== e1.overrideMaterial && (this.overrideMaterial = e1.overrideMaterial.clone()), this.matrixAutoUpdate = e1.matrixAutoUpdate, this;
    }
    toJSON(e1) {
        const t = super.toJSON(e1);
        return null !== this.fog && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (t.object.backgroundIntensity = this.backgroundIntensity), t.object.backgroundRotation = this.backgroundRotation.toArray(), 1 !== this.environmentIntensity && (t.object.environmentIntensity = this.environmentIntensity), t.object.environmentRotation = this.environmentRotation.toArray(), t;
    }
}
const $785da19a645c07eb$var$IV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$FV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$zV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$RV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$LV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$BV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$OV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$UV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$NV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$jV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$VV = new $785da19a645c07eb$var$qj, $785da19a645c07eb$var$qV = new $785da19a645c07eb$var$qj, $785da19a645c07eb$var$GV = new $785da19a645c07eb$var$qj;
class $785da19a645c07eb$var$HV {
    constructor(e1 = new $785da19a645c07eb$var$Ej, t = new $785da19a645c07eb$var$Ej, i = new $785da19a645c07eb$var$Ej){
        this.a = e1, this.b = t, this.c = i;
    }
    static getNormal(e1, t, i, n) {
        n.subVectors(i, t), $785da19a645c07eb$var$IV.subVectors(e1, t), n.cross($785da19a645c07eb$var$IV);
        const a = n.lengthSq();
        return a > 0 ? n.multiplyScalar(1 / Math.sqrt(a)) : n.set(0, 0, 0);
    }
    static getBarycoord(e1, t, i, n, a) {
        $785da19a645c07eb$var$IV.subVectors(n, t), $785da19a645c07eb$var$FV.subVectors(i, t), $785da19a645c07eb$var$zV.subVectors(e1, t);
        const r = $785da19a645c07eb$var$IV.dot($785da19a645c07eb$var$IV), s = $785da19a645c07eb$var$IV.dot($785da19a645c07eb$var$FV), o = $785da19a645c07eb$var$IV.dot($785da19a645c07eb$var$zV), l = $785da19a645c07eb$var$FV.dot($785da19a645c07eb$var$FV), c = $785da19a645c07eb$var$FV.dot($785da19a645c07eb$var$zV), u = r * l - s * s;
        if (0 === u) return a.set(0, 0, 0), null;
        const h = 1 / u, d = (l * o - s * c) * h, p = (r * c - s * o) * h;
        return a.set(1 - d - p, p, d);
    }
    static containsPoint(e1, t, i, n) {
        return null !== this.getBarycoord(e1, t, i, n, $785da19a645c07eb$var$RV) && $785da19a645c07eb$var$RV.x >= 0 && $785da19a645c07eb$var$RV.y >= 0 && $785da19a645c07eb$var$RV.x + $785da19a645c07eb$var$RV.y <= 1;
    }
    static getInterpolation(e1, t, i, n, a, r, s, o) {
        return null === this.getBarycoord(e1, t, i, n, $785da19a645c07eb$var$RV) ? (o.x = 0, o.y = 0, "z" in o && (o.z = 0), "w" in o && (o.w = 0), null) : (o.setScalar(0), o.addScaledVector(a, $785da19a645c07eb$var$RV.x), o.addScaledVector(r, $785da19a645c07eb$var$RV.y), o.addScaledVector(s, $785da19a645c07eb$var$RV.z), o);
    }
    static getInterpolatedAttribute(e1, t, i, n, a, r) {
        return $785da19a645c07eb$var$VV.setScalar(0), $785da19a645c07eb$var$qV.setScalar(0), $785da19a645c07eb$var$GV.setScalar(0), $785da19a645c07eb$var$VV.fromBufferAttribute(e1, t), $785da19a645c07eb$var$qV.fromBufferAttribute(e1, i), $785da19a645c07eb$var$GV.fromBufferAttribute(e1, n), r.setScalar(0), r.addScaledVector($785da19a645c07eb$var$VV, a.x), r.addScaledVector($785da19a645c07eb$var$qV, a.y), r.addScaledVector($785da19a645c07eb$var$GV, a.z), r;
    }
    static isFrontFacing(e1, t, i, n) {
        return $785da19a645c07eb$var$IV.subVectors(i, t), $785da19a645c07eb$var$FV.subVectors(e1, t), $785da19a645c07eb$var$IV.cross($785da19a645c07eb$var$FV).dot(n) < 0;
    }
    set(e1, t, i) {
        return this.a.copy(e1), this.b.copy(t), this.c.copy(i), this;
    }
    setFromPointsAndIndices(e1, t, i, n) {
        return this.a.copy(e1[t]), this.b.copy(e1[i]), this.c.copy(e1[n]), this;
    }
    setFromAttributeAndIndices(e1, t, i, n) {
        return this.a.fromBufferAttribute(e1, t), this.b.fromBufferAttribute(e1, i), this.c.fromBufferAttribute(e1, n), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        return this.a.copy(e1.a), this.b.copy(e1.b), this.c.copy(e1.c), this;
    }
    getArea() {
        return $785da19a645c07eb$var$IV.subVectors(this.c, this.b), $785da19a645c07eb$var$FV.subVectors(this.a, this.b), .5 * $785da19a645c07eb$var$IV.cross($785da19a645c07eb$var$FV).length();
    }
    getMidpoint(e1) {
        return e1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(e1) {
        return $785da19a645c07eb$var$HV.getNormal(this.a, this.b, this.c, e1);
    }
    getPlane(e1) {
        return e1.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(e1, t) {
        return $785da19a645c07eb$var$HV.getBarycoord(e1, this.a, this.b, this.c, t);
    }
    getInterpolation(e1, t, i, n, a) {
        return $785da19a645c07eb$var$HV.getInterpolation(e1, this.a, this.b, this.c, t, i, n, a);
    }
    containsPoint(e1) {
        return $785da19a645c07eb$var$HV.containsPoint(e1, this.a, this.b, this.c);
    }
    isFrontFacing(e1) {
        return $785da19a645c07eb$var$HV.isFrontFacing(this.a, this.b, this.c, e1);
    }
    intersectsBox(e1) {
        return e1.intersectsTriangle(this);
    }
    closestPointToPoint(e1, t) {
        const i = this.a, n = this.b, a = this.c;
        let r, s;
        $785da19a645c07eb$var$LV.subVectors(n, i), $785da19a645c07eb$var$BV.subVectors(a, i), $785da19a645c07eb$var$UV.subVectors(e1, i);
        const o = $785da19a645c07eb$var$LV.dot($785da19a645c07eb$var$UV), l = $785da19a645c07eb$var$BV.dot($785da19a645c07eb$var$UV);
        if (o <= 0 && l <= 0) return t.copy(i);
        $785da19a645c07eb$var$NV.subVectors(e1, n);
        const c = $785da19a645c07eb$var$LV.dot($785da19a645c07eb$var$NV), u = $785da19a645c07eb$var$BV.dot($785da19a645c07eb$var$NV);
        if (c >= 0 && u <= c) return t.copy(n);
        const h = o * u - c * l;
        if (h <= 0 && o >= 0 && c <= 0) return r = o / (o - c), t.copy(i).addScaledVector($785da19a645c07eb$var$LV, r);
        $785da19a645c07eb$var$jV.subVectors(e1, a);
        const d = $785da19a645c07eb$var$LV.dot($785da19a645c07eb$var$jV), p = $785da19a645c07eb$var$BV.dot($785da19a645c07eb$var$jV);
        if (p >= 0 && d <= p) return t.copy(a);
        const m = d * l - o * p;
        if (m <= 0 && l >= 0 && p <= 0) return s = l / (l - p), t.copy(i).addScaledVector($785da19a645c07eb$var$BV, s);
        const g = c * p - d * u;
        if (g <= 0 && u - c >= 0 && d - p >= 0) return $785da19a645c07eb$var$OV.subVectors(a, n), s = (u - c) / (u - c + (d - p)), t.copy(n).addScaledVector($785da19a645c07eb$var$OV, s);
        const f = 1 / (g + m + h);
        return r = m * f, s = h * f, t.copy(i).addScaledVector($785da19a645c07eb$var$LV, r).addScaledVector($785da19a645c07eb$var$BV, s);
    }
    equals(e1) {
        return e1.a.equals(this.a) && e1.b.equals(this.b) && e1.c.equals(this.c);
    }
}
class $785da19a645c07eb$var$WV {
    constructor(e1 = new $785da19a645c07eb$var$Ej(1 / 0, 1 / 0, 1 / 0), t = new $785da19a645c07eb$var$Ej(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = e1, this.max = t;
    }
    set(e1, t) {
        return this.min.copy(e1), this.max.copy(t), this;
    }
    setFromArray(e1) {
        this.makeEmpty();
        for(let t = 0, i = e1.length; t < i; t += 3)this.expandByPoint($785da19a645c07eb$var$KV.fromArray(e1, t));
        return this;
    }
    setFromBufferAttribute(e1) {
        this.makeEmpty();
        for(let t = 0, i = e1.count; t < i; t++)this.expandByPoint($785da19a645c07eb$var$KV.fromBufferAttribute(e1, t));
        return this;
    }
    setFromPoints(e1) {
        this.makeEmpty();
        for(let t = 0, i = e1.length; t < i; t++)this.expandByPoint(e1[t]);
        return this;
    }
    setFromCenterAndSize(e1, t) {
        const i = $785da19a645c07eb$var$KV.copy(t).multiplyScalar(.5);
        return this.min.copy(e1).sub(i), this.max.copy(e1).add(i), this;
    }
    setFromObject(e1, t = !1) {
        return this.makeEmpty(), this.expandByObject(e1, t);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        return this.min.copy(e1.min), this.max.copy(e1.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(e1) {
        return this.isEmpty() ? e1.set(0, 0, 0) : e1.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(e1) {
        return this.isEmpty() ? e1.set(0, 0, 0) : e1.subVectors(this.max, this.min);
    }
    expandByPoint(e1) {
        return this.min.min(e1), this.max.max(e1), this;
    }
    expandByVector(e1) {
        return this.min.sub(e1), this.max.add(e1), this;
    }
    expandByScalar(e1) {
        return this.min.addScalar(-e1), this.max.addScalar(e1), this;
    }
    expandByObject(e1, t = !1) {
        e1.updateWorldMatrix(!1, !1);
        const i = e1.geometry;
        if (void 0 !== i) {
            const n = i.getAttribute("position");
            if (!0 === t && void 0 !== n && !0 !== e1.isInstancedMesh) for(let t = 0, i = n.count; t < i; t++)!0 === e1.isMesh ? e1.getVertexPosition(t, $785da19a645c07eb$var$KV) : $785da19a645c07eb$var$KV.fromBufferAttribute(n, t), $785da19a645c07eb$var$KV.applyMatrix4(e1.matrixWorld), this.expandByPoint($785da19a645c07eb$var$KV);
            else void 0 !== e1.boundingBox ? (null === e1.boundingBox && e1.computeBoundingBox(), $785da19a645c07eb$var$XV.copy(e1.boundingBox)) : (null === i.boundingBox && i.computeBoundingBox(), $785da19a645c07eb$var$XV.copy(i.boundingBox)), $785da19a645c07eb$var$XV.applyMatrix4(e1.matrixWorld), this.union($785da19a645c07eb$var$XV);
        }
        const n = e1.children;
        for(let e1 = 0, i = n.length; e1 < i; e1++)this.expandByObject(n[e1], t);
        return this;
    }
    containsPoint(e1) {
        return e1.x >= this.min.x && e1.x <= this.max.x && e1.y >= this.min.y && e1.y <= this.max.y && e1.z >= this.min.z && e1.z <= this.max.z;
    }
    containsBox(e1) {
        return this.min.x <= e1.min.x && e1.max.x <= this.max.x && this.min.y <= e1.min.y && e1.max.y <= this.max.y && this.min.z <= e1.min.z && e1.max.z <= this.max.z;
    }
    getParameter(e1, t) {
        return t.set((e1.x - this.min.x) / (this.max.x - this.min.x), (e1.y - this.min.y) / (this.max.y - this.min.y), (e1.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(e1) {
        return e1.max.x >= this.min.x && e1.min.x <= this.max.x && e1.max.y >= this.min.y && e1.min.y <= this.max.y && e1.max.z >= this.min.z && e1.min.z <= this.max.z;
    }
    intersectsSphere(e1) {
        return this.clampPoint(e1.center, $785da19a645c07eb$var$KV), $785da19a645c07eb$var$KV.distanceToSquared(e1.center) <= e1.radius * e1.radius;
    }
    intersectsPlane(e1) {
        let t, i;
        return e1.normal.x > 0 ? (t = e1.normal.x * this.min.x, i = e1.normal.x * this.max.x) : (t = e1.normal.x * this.max.x, i = e1.normal.x * this.min.x), e1.normal.y > 0 ? (t += e1.normal.y * this.min.y, i += e1.normal.y * this.max.y) : (t += e1.normal.y * this.max.y, i += e1.normal.y * this.min.y), e1.normal.z > 0 ? (t += e1.normal.z * this.min.z, i += e1.normal.z * this.max.z) : (t += e1.normal.z * this.max.z, i += e1.normal.z * this.min.z), t <= -e1.constant && i >= -e1.constant;
    }
    intersectsTriangle(e1) {
        if (this.isEmpty()) return !1;
        this.getCenter($785da19a645c07eb$var$iq), $785da19a645c07eb$var$nq.subVectors(this.max, $785da19a645c07eb$var$iq), $785da19a645c07eb$var$QV.subVectors(e1.a, $785da19a645c07eb$var$iq), $785da19a645c07eb$var$YV.subVectors(e1.b, $785da19a645c07eb$var$iq), $785da19a645c07eb$var$JV.subVectors(e1.c, $785da19a645c07eb$var$iq), $785da19a645c07eb$var$$V.subVectors($785da19a645c07eb$var$YV, $785da19a645c07eb$var$QV), $785da19a645c07eb$var$eq.subVectors($785da19a645c07eb$var$JV, $785da19a645c07eb$var$YV), $785da19a645c07eb$var$tq.subVectors($785da19a645c07eb$var$QV, $785da19a645c07eb$var$JV);
        let t = [
            0,
            -$785da19a645c07eb$var$$V.z,
            $785da19a645c07eb$var$$V.y,
            0,
            -$785da19a645c07eb$var$eq.z,
            $785da19a645c07eb$var$eq.y,
            0,
            -$785da19a645c07eb$var$tq.z,
            $785da19a645c07eb$var$tq.y,
            $785da19a645c07eb$var$$V.z,
            0,
            -$785da19a645c07eb$var$$V.x,
            $785da19a645c07eb$var$eq.z,
            0,
            -$785da19a645c07eb$var$eq.x,
            $785da19a645c07eb$var$tq.z,
            0,
            -$785da19a645c07eb$var$tq.x,
            -$785da19a645c07eb$var$$V.y,
            $785da19a645c07eb$var$$V.x,
            0,
            -$785da19a645c07eb$var$eq.y,
            $785da19a645c07eb$var$eq.x,
            0,
            -$785da19a645c07eb$var$tq.y,
            $785da19a645c07eb$var$tq.x,
            0
        ];
        return !!$785da19a645c07eb$var$sq(t, $785da19a645c07eb$var$QV, $785da19a645c07eb$var$YV, $785da19a645c07eb$var$JV, $785da19a645c07eb$var$nq) && (t = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !!$785da19a645c07eb$var$sq(t, $785da19a645c07eb$var$QV, $785da19a645c07eb$var$YV, $785da19a645c07eb$var$JV, $785da19a645c07eb$var$nq) && ($785da19a645c07eb$var$aq.crossVectors($785da19a645c07eb$var$$V, $785da19a645c07eb$var$eq), t = [
            $785da19a645c07eb$var$aq.x,
            $785da19a645c07eb$var$aq.y,
            $785da19a645c07eb$var$aq.z
        ], $785da19a645c07eb$var$sq(t, $785da19a645c07eb$var$QV, $785da19a645c07eb$var$YV, $785da19a645c07eb$var$JV, $785da19a645c07eb$var$nq)));
    }
    clampPoint(e1, t) {
        return t.copy(e1).clamp(this.min, this.max);
    }
    distanceToPoint(e1) {
        return this.clampPoint(e1, $785da19a645c07eb$var$KV).distanceTo(e1);
    }
    getBoundingSphere(e1) {
        return this.isEmpty() ? e1.makeEmpty() : (this.getCenter(e1.center), e1.radius = .5 * this.getSize($785da19a645c07eb$var$KV).length()), e1;
    }
    intersect(e1) {
        return this.min.max(e1.min), this.max.min(e1.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(e1) {
        return this.min.min(e1.min), this.max.max(e1.max), this;
    }
    applyMatrix4(e1) {
        return this.isEmpty() || ($785da19a645c07eb$var$ZV[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e1), $785da19a645c07eb$var$ZV[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e1), this.setFromPoints($785da19a645c07eb$var$ZV)), this;
    }
    translate(e1) {
        return this.min.add(e1), this.max.add(e1), this;
    }
    equals(e1) {
        return e1.min.equals(this.min) && e1.max.equals(this.max);
    }
    toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    fromJSON(e1) {
        return this.min.fromArray(e1.min), this.max.fromArray(e1.max), this;
    }
}
const $785da19a645c07eb$var$ZV = [
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej,
    new $785da19a645c07eb$var$Ej
], $785da19a645c07eb$var$KV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$XV = new $785da19a645c07eb$var$WV, $785da19a645c07eb$var$QV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$YV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$JV = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$$V = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$eq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$tq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$iq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$nq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$aq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$rq = new $785da19a645c07eb$var$Ej;
function $785da19a645c07eb$var$sq(e1, t, i, n, a) {
    for(let r = 0, s = e1.length - 3; r <= s; r += 3){
        $785da19a645c07eb$var$rq.fromArray(e1, r);
        const s = a.x * Math.abs($785da19a645c07eb$var$rq.x) + a.y * Math.abs($785da19a645c07eb$var$rq.y) + a.z * Math.abs($785da19a645c07eb$var$rq.z), o = t.dot($785da19a645c07eb$var$rq), l = i.dot($785da19a645c07eb$var$rq), c = n.dot($785da19a645c07eb$var$rq);
        if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
    }
    return !0;
}
const $785da19a645c07eb$var$oq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$lq = new $785da19a645c07eb$var$bj;
let $785da19a645c07eb$var$cq = 0;
class $785da19a645c07eb$var$uq extends $785da19a645c07eb$var$uj {
    constructor(e1, t, i = !1){
        if (super(), Array.isArray(e1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$cq++
        }), this.name = "", this.array = e1, this.itemSize = t, this.count = void 0 !== e1 ? e1.length / t : 0, this.normalized = i, this.usage = 35044, this.updateRanges = [], this.gpuType = $785da19a645c07eb$var$VU, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(e1) {
        !0 === e1 && this.version++;
    }
    setUsage(e1) {
        return this.usage = e1, this;
    }
    addUpdateRange(e1, t) {
        this.updateRanges.push({
            start: e1,
            count: t
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(e1) {
        return this.name = e1.name, this.array = new e1.array.constructor(e1.array), this.itemSize = e1.itemSize, this.count = e1.count, this.normalized = e1.normalized, this.usage = e1.usage, this.gpuType = e1.gpuType, this;
    }
    copyAt(e1, t, i) {
        e1 *= this.itemSize, i *= t.itemSize;
        for(let n = 0, a = this.itemSize; n < a; n++)this.array[e1 + n] = t.array[i + n];
        return this;
    }
    copyArray(e1) {
        return this.array.set(e1), this;
    }
    applyMatrix3(e1) {
        if (2 === this.itemSize) for(let t = 0, i = this.count; t < i; t++)$785da19a645c07eb$var$lq.fromBufferAttribute(this, t), $785da19a645c07eb$var$lq.applyMatrix3(e1), this.setXY(t, $785da19a645c07eb$var$lq.x, $785da19a645c07eb$var$lq.y);
        else if (3 === this.itemSize) for(let t = 0, i = this.count; t < i; t++)$785da19a645c07eb$var$oq.fromBufferAttribute(this, t), $785da19a645c07eb$var$oq.applyMatrix3(e1), this.setXYZ(t, $785da19a645c07eb$var$oq.x, $785da19a645c07eb$var$oq.y, $785da19a645c07eb$var$oq.z);
        return this;
    }
    applyMatrix4(e1) {
        for(let t = 0, i = this.count; t < i; t++)$785da19a645c07eb$var$oq.fromBufferAttribute(this, t), $785da19a645c07eb$var$oq.applyMatrix4(e1), this.setXYZ(t, $785da19a645c07eb$var$oq.x, $785da19a645c07eb$var$oq.y, $785da19a645c07eb$var$oq.z);
        return this;
    }
    applyNormalMatrix(e1) {
        for(let t = 0, i = this.count; t < i; t++)$785da19a645c07eb$var$oq.fromBufferAttribute(this, t), $785da19a645c07eb$var$oq.applyNormalMatrix(e1), this.setXYZ(t, $785da19a645c07eb$var$oq.x, $785da19a645c07eb$var$oq.y, $785da19a645c07eb$var$oq.z);
        return this;
    }
    transformDirection(e1) {
        for(let t = 0, i = this.count; t < i; t++)$785da19a645c07eb$var$oq.fromBufferAttribute(this, t), $785da19a645c07eb$var$oq.transformDirection(e1), this.setXYZ(t, $785da19a645c07eb$var$oq.x, $785da19a645c07eb$var$oq.y, $785da19a645c07eb$var$oq.z);
        return this;
    }
    set(e1, t = 0) {
        return this.array.set(e1, t), this;
    }
    getComponent(e1, t) {
        let i = this.array[e1 * this.itemSize + t];
        return this.normalized && (i = $785da19a645c07eb$var$vj(i, this.array)), i;
    }
    setComponent(e1, t, i) {
        return this.normalized && (i = $785da19a645c07eb$var$yj(i, this.array)), this.array[e1 * this.itemSize + t] = i, this;
    }
    getX(e1) {
        let t = this.array[e1 * this.itemSize];
        return this.normalized && (t = $785da19a645c07eb$var$vj(t, this.array)), t;
    }
    setX(e1, t) {
        return this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array)), this.array[e1 * this.itemSize] = t, this;
    }
    getY(e1) {
        let t = this.array[e1 * this.itemSize + 1];
        return this.normalized && (t = $785da19a645c07eb$var$vj(t, this.array)), t;
    }
    setY(e1, t) {
        return this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array)), this.array[e1 * this.itemSize + 1] = t, this;
    }
    getZ(e1) {
        let t = this.array[e1 * this.itemSize + 2];
        return this.normalized && (t = $785da19a645c07eb$var$vj(t, this.array)), t;
    }
    setZ(e1, t) {
        return this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array)), this.array[e1 * this.itemSize + 2] = t, this;
    }
    getW(e1) {
        let t = this.array[e1 * this.itemSize + 3];
        return this.normalized && (t = $785da19a645c07eb$var$vj(t, this.array)), t;
    }
    setW(e1, t) {
        return this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array)), this.array[e1 * this.itemSize + 3] = t, this;
    }
    setXY(e1, t, i) {
        return e1 *= this.itemSize, this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array), i = $785da19a645c07eb$var$yj(i, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = i, this;
    }
    setXYZ(e1, t, i, n) {
        return e1 *= this.itemSize, this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array), i = $785da19a645c07eb$var$yj(i, this.array), n = $785da19a645c07eb$var$yj(n, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = i, this.array[e1 + 2] = n, this;
    }
    setXYZW(e1, t, i, n, a) {
        return e1 *= this.itemSize, this.normalized && (t = $785da19a645c07eb$var$yj(t, this.array), i = $785da19a645c07eb$var$yj(i, this.array), n = $785da19a645c07eb$var$yj(n, this.array), a = $785da19a645c07eb$var$yj(a, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = i, this.array[e1 + 2] = n, this.array[e1 + 3] = a, this;
    }
    onUpload(e1) {
        return this.onUploadCallback = e1, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const e1 = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return "" !== this.name && (e1.name = this.name), 35044 !== this.usage && (e1.usage = this.usage), e1;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
class $785da19a645c07eb$var$hq extends $785da19a645c07eb$var$uq {
    constructor(e1, t, i){
        super(new Uint16Array(e1), t, i);
    }
}
class $785da19a645c07eb$var$dq extends $785da19a645c07eb$var$uq {
    constructor(e1, t, i){
        super(new Uint32Array(e1), t, i);
    }
}
class $785da19a645c07eb$var$pq extends $785da19a645c07eb$var$uq {
    constructor(e1, t, i){
        super(new Float32Array(e1), t, i);
    }
}
const $785da19a645c07eb$var$mq = new $785da19a645c07eb$var$WV, $785da19a645c07eb$var$gq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$fq = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$Aq {
    constructor(e1 = new $785da19a645c07eb$var$Ej, t = -1){
        this.isSphere = !0, this.center = e1, this.radius = t;
    }
    set(e1, t) {
        return this.center.copy(e1), this.radius = t, this;
    }
    setFromPoints(e1, t) {
        const i = this.center;
        void 0 !== t ? i.copy(t) : $785da19a645c07eb$var$mq.setFromPoints(e1).getCenter(i);
        let n = 0;
        for(let t = 0, a = e1.length; t < a; t++)n = Math.max(n, i.distanceToSquared(e1[t]));
        return this.radius = Math.sqrt(n), this;
    }
    copy(e1) {
        return this.center.copy(e1.center), this.radius = e1.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(e1) {
        return e1.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(e1) {
        return e1.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(e1) {
        const t = this.radius + e1.radius;
        return e1.center.distanceToSquared(this.center) <= t * t;
    }
    intersectsBox(e1) {
        return e1.intersectsSphere(this);
    }
    intersectsPlane(e1) {
        return Math.abs(e1.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(e1, t) {
        const i = this.center.distanceToSquared(e1);
        return t.copy(e1), i > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
    }
    getBoundingBox(e1) {
        return this.isEmpty() ? (e1.makeEmpty(), e1) : (e1.set(this.center, this.center), e1.expandByScalar(this.radius), e1);
    }
    applyMatrix4(e1) {
        return this.center.applyMatrix4(e1), this.radius = this.radius * e1.getMaxScaleOnAxis(), this;
    }
    translate(e1) {
        return this.center.add(e1), this;
    }
    expandByPoint(e1) {
        if (this.isEmpty()) return this.center.copy(e1), this.radius = 0, this;
        $785da19a645c07eb$var$gq.subVectors(e1, this.center);
        const t = $785da19a645c07eb$var$gq.lengthSq();
        if (t > this.radius * this.radius) {
            const e1 = Math.sqrt(t), i = .5 * (e1 - this.radius);
            this.center.addScaledVector($785da19a645c07eb$var$gq, i / e1), this.radius += i;
        }
        return this;
    }
    union(e1) {
        return e1.isEmpty() ? this : this.isEmpty() ? (this.copy(e1), this) : (!0 === this.center.equals(e1.center) ? this.radius = Math.max(this.radius, e1.radius) : ($785da19a645c07eb$var$fq.subVectors(e1.center, this.center).setLength(e1.radius), this.expandByPoint($785da19a645c07eb$var$gq.copy(e1.center).add($785da19a645c07eb$var$fq)), this.expandByPoint($785da19a645c07eb$var$gq.copy(e1.center).sub($785da19a645c07eb$var$fq))), this);
    }
    equals(e1) {
        return e1.center.equals(this.center) && e1.radius === this.radius;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    fromJSON(e1) {
        return this.radius = e1.radius, this.center.fromArray(e1.center), this;
    }
}
let $785da19a645c07eb$var$_q = 0;
const $785da19a645c07eb$var$vq = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$yq = new $785da19a645c07eb$var$xV, $785da19a645c07eb$var$xq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$bq = new $785da19a645c07eb$var$WV, $785da19a645c07eb$var$wq = new $785da19a645c07eb$var$WV, $785da19a645c07eb$var$Eq = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$kq extends $785da19a645c07eb$var$uj {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$_q++
        }), this.uuid = $785da19a645c07eb$var$gj(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.indirectOffset = 0, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {}, this._transformed = !1;
    }
    getIndex() {
        return this.index;
    }
    setIndex(e1) {
        return Array.isArray(e1) ? this.index = new ((function(e1) {
            for(let t = e1.length - 1; t >= 0; --t)if (e1[t] >= 65535) return !0;
            return !1;
        }(e1)) ? $785da19a645c07eb$var$dq : $785da19a645c07eb$var$hq)(e1, 1) : this.index = e1, this;
    }
    setIndirect(e1, t = 0) {
        return this.indirect = e1, this.indirectOffset = t, this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(e1) {
        return this.attributes[e1];
    }
    setAttribute(e1, t) {
        return this.attributes[e1] = t, this;
    }
    deleteAttribute(e1) {
        return delete this.attributes[e1], this;
    }
    hasAttribute(e1) {
        return void 0 !== this.attributes[e1];
    }
    addGroup(e1, t, i = 0) {
        this.groups.push({
            start: e1,
            count: t,
            materialIndex: i
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(e1, t) {
        this.drawRange.start = e1, this.drawRange.count = t;
    }
    applyMatrix4(e1) {
        const t = this.attributes.position;
        void 0 !== t && (t.applyMatrix4(e1), t.needsUpdate = !0);
        const i = this.attributes.normal;
        if (void 0 !== i) {
            const t = (new $785da19a645c07eb$var$Mj).getNormalMatrix(e1);
            i.applyNormalMatrix(t), i.needsUpdate = !0;
        }
        const n = this.attributes.tangent;
        return void 0 !== n && (n.transformDirection(e1), n.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this._transformed = !0, this;
    }
    applyQuaternion(e1) {
        return $785da19a645c07eb$var$vq.makeRotationFromQuaternion(e1), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    rotateX(e1) {
        return $785da19a645c07eb$var$vq.makeRotationX(e1), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    rotateY(e1) {
        return $785da19a645c07eb$var$vq.makeRotationY(e1), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    rotateZ(e1) {
        return $785da19a645c07eb$var$vq.makeRotationZ(e1), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    translate(e1, t, i) {
        return $785da19a645c07eb$var$vq.makeTranslation(e1, t, i), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    scale(e1, t, i) {
        return $785da19a645c07eb$var$vq.makeScale(e1, t, i), this.applyMatrix4($785da19a645c07eb$var$vq), this;
    }
    lookAt(e1) {
        return $785da19a645c07eb$var$yq.lookAt(e1), $785da19a645c07eb$var$yq.updateMatrix(), this.applyMatrix4($785da19a645c07eb$var$yq.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter($785da19a645c07eb$var$xq).negate(), this.translate($785da19a645c07eb$var$xq.x, $785da19a645c07eb$var$xq.y, $785da19a645c07eb$var$xq.z), this;
    }
    setFromPoints(e1) {
        const t = this.getAttribute("position");
        if (void 0 === t) {
            const t = [];
            for(let i = 0, n = e1.length; i < n; i++){
                const n = e1[i];
                t.push(n.x, n.y, n.z || 0);
            }
            this.setAttribute("position", new $785da19a645c07eb$var$pq(t, 3));
        } else {
            const i = Math.min(e1.length, t.count);
            for(let n = 0; n < i; n++){
                const i = e1[n];
                t.setXYZ(n, i.x, i.y, i.z || 0);
            }
            e1.length > t.count && $785da19a645c07eb$var$sj("BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), t.needsUpdate = !0;
        }
        return this;
    }
    computeBoundingBox() {
        null === this.boundingBox && (this.boundingBox = new $785da19a645c07eb$var$WV);
        const e1 = this.attributes.position, t = this.morphAttributes.position;
        if (e1 && e1.isGLBufferAttribute) return $785da19a645c07eb$var$oj("BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), void this.boundingBox.set(new $785da19a645c07eb$var$Ej(-1 / 0, -1 / 0, -1 / 0), new $785da19a645c07eb$var$Ej(1 / 0, 1 / 0, 1 / 0));
        if (void 0 !== e1) {
            if (this.boundingBox.setFromBufferAttribute(e1), t) for(let e1 = 0, i = t.length; e1 < i; e1++){
                const i = t[e1];
                $785da19a645c07eb$var$bq.setFromBufferAttribute(i), this.morphTargetsRelative ? ($785da19a645c07eb$var$Eq.addVectors(this.boundingBox.min, $785da19a645c07eb$var$bq.min), this.boundingBox.expandByPoint($785da19a645c07eb$var$Eq), $785da19a645c07eb$var$Eq.addVectors(this.boundingBox.max, $785da19a645c07eb$var$bq.max), this.boundingBox.expandByPoint($785da19a645c07eb$var$Eq)) : (this.boundingBox.expandByPoint($785da19a645c07eb$var$bq.min), this.boundingBox.expandByPoint($785da19a645c07eb$var$bq.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && $785da19a645c07eb$var$oj('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        null === this.boundingSphere && (this.boundingSphere = new $785da19a645c07eb$var$Aq);
        const e1 = this.attributes.position, t = this.morphAttributes.position;
        if (e1 && e1.isGLBufferAttribute) return $785da19a645c07eb$var$oj("BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), void this.boundingSphere.set(new $785da19a645c07eb$var$Ej, 1 / 0);
        if (e1) {
            const i = this.boundingSphere.center;
            if ($785da19a645c07eb$var$bq.setFromBufferAttribute(e1), t) for(let e1 = 0, i = t.length; e1 < i; e1++){
                const i = t[e1];
                $785da19a645c07eb$var$wq.setFromBufferAttribute(i), this.morphTargetsRelative ? ($785da19a645c07eb$var$Eq.addVectors($785da19a645c07eb$var$bq.min, $785da19a645c07eb$var$wq.min), $785da19a645c07eb$var$bq.expandByPoint($785da19a645c07eb$var$Eq), $785da19a645c07eb$var$Eq.addVectors($785da19a645c07eb$var$bq.max, $785da19a645c07eb$var$wq.max), $785da19a645c07eb$var$bq.expandByPoint($785da19a645c07eb$var$Eq)) : ($785da19a645c07eb$var$bq.expandByPoint($785da19a645c07eb$var$wq.min), $785da19a645c07eb$var$bq.expandByPoint($785da19a645c07eb$var$wq.max));
            }
            $785da19a645c07eb$var$bq.getCenter(i);
            let n = 0;
            for(let t = 0, a = e1.count; t < a; t++)$785da19a645c07eb$var$Eq.fromBufferAttribute(e1, t), n = Math.max(n, i.distanceToSquared($785da19a645c07eb$var$Eq));
            if (t) for(let a = 0, r = t.length; a < r; a++){
                const r = t[a], s = this.morphTargetsRelative;
                for(let t = 0, a = r.count; t < a; t++)$785da19a645c07eb$var$Eq.fromBufferAttribute(r, t), s && ($785da19a645c07eb$var$xq.fromBufferAttribute(e1, t), $785da19a645c07eb$var$Eq.add($785da19a645c07eb$var$xq)), n = Math.max(n, i.distanceToSquared($785da19a645c07eb$var$Eq));
            }
            this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && $785da19a645c07eb$var$oj('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const e1 = this.index, t = this.attributes;
        if (null === e1 || void 0 === t.position || void 0 === t.normal || void 0 === t.uv) return void $785da19a645c07eb$var$oj("BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
        const i = t.position, n = t.normal, a = t.uv;
        let r = this.getAttribute("tangent");
        void 0 !== r && r.count === i.count || (r = new $785da19a645c07eb$var$uq(new Float32Array(4 * i.count), 4), this.setAttribute("tangent", r));
        const s = [], o = [];
        for(let e1 = 0; e1 < i.count; e1++)s[e1] = new $785da19a645c07eb$var$Ej, o[e1] = new $785da19a645c07eb$var$Ej;
        const l = new $785da19a645c07eb$var$Ej, c = new $785da19a645c07eb$var$Ej, u = new $785da19a645c07eb$var$Ej, h = new $785da19a645c07eb$var$bj, d = new $785da19a645c07eb$var$bj, p = new $785da19a645c07eb$var$bj, m = new $785da19a645c07eb$var$Ej, g = new $785da19a645c07eb$var$Ej;
        function f(e1, t, n) {
            l.fromBufferAttribute(i, e1), c.fromBufferAttribute(i, t), u.fromBufferAttribute(i, n), h.fromBufferAttribute(a, e1), d.fromBufferAttribute(a, t), p.fromBufferAttribute(a, n), c.sub(l), u.sub(l), d.sub(h), p.sub(h);
            const r = 1 / (d.x * p.y - p.x * d.y);
            isFinite(r) && (m.copy(c).multiplyScalar(p.y).addScaledVector(u, -d.y).multiplyScalar(r), g.copy(u).multiplyScalar(d.x).addScaledVector(c, -p.x).multiplyScalar(r), s[e1].add(m), s[t].add(m), s[n].add(m), o[e1].add(g), o[t].add(g), o[n].add(g));
        }
        let A = this.groups;
        0 === A.length && (A = [
            {
                start: 0,
                count: e1.count
            }
        ]);
        for(let t = 0, i = A.length; t < i; ++t){
            const i = A[t], n = i.start;
            for(let t = n, a = n + i.count; t < a; t += 3)f(e1.getX(t + 0), e1.getX(t + 1), e1.getX(t + 2));
        }
        const _ = new $785da19a645c07eb$var$Ej, v = new $785da19a645c07eb$var$Ej, y = new $785da19a645c07eb$var$Ej, x = new $785da19a645c07eb$var$Ej;
        function b(e1) {
            y.fromBufferAttribute(n, e1), x.copy(y);
            const t = s[e1];
            _.copy(t), _.sub(y.multiplyScalar(y.dot(t))).normalize(), v.crossVectors(x, t);
            const i = v.dot(o[e1]) < 0 ? -1 : 1;
            r.setXYZW(e1, _.x, _.y, _.z, i);
        }
        for(let t = 0, i = A.length; t < i; ++t){
            const i = A[t], n = i.start;
            for(let t = n, a = n + i.count; t < a; t += 3)b(e1.getX(t + 0)), b(e1.getX(t + 1)), b(e1.getX(t + 2));
        }
        this._transformed = !0;
    }
    computeVertexNormals() {
        const e1 = this.index, t = this.getAttribute("position");
        if (void 0 !== t) {
            let i = this.getAttribute("normal");
            if (void 0 === i || i.count !== t.count) i = new $785da19a645c07eb$var$uq(new Float32Array(3 * t.count), 3), this.setAttribute("normal", i);
            else for(let e1 = 0, t = i.count; e1 < t; e1++)i.setXYZ(e1, 0, 0, 0);
            const n = new $785da19a645c07eb$var$Ej, a = new $785da19a645c07eb$var$Ej, r = new $785da19a645c07eb$var$Ej, s = new $785da19a645c07eb$var$Ej, o = new $785da19a645c07eb$var$Ej, l = new $785da19a645c07eb$var$Ej, c = new $785da19a645c07eb$var$Ej, u = new $785da19a645c07eb$var$Ej;
            if (e1) for(let h = 0, d = e1.count; h < d; h += 3){
                const d = e1.getX(h + 0), p = e1.getX(h + 1), m = e1.getX(h + 2);
                n.fromBufferAttribute(t, d), a.fromBufferAttribute(t, p), r.fromBufferAttribute(t, m), c.subVectors(r, a), u.subVectors(n, a), c.cross(u), s.fromBufferAttribute(i, d), o.fromBufferAttribute(i, p), l.fromBufferAttribute(i, m), s.add(c), o.add(c), l.add(c), i.setXYZ(d, s.x, s.y, s.z), i.setXYZ(p, o.x, o.y, o.z), i.setXYZ(m, l.x, l.y, l.z);
            }
            else for(let e1 = 0, s = t.count; e1 < s; e1 += 3)n.fromBufferAttribute(t, e1 + 0), a.fromBufferAttribute(t, e1 + 1), r.fromBufferAttribute(t, e1 + 2), c.subVectors(r, a), u.subVectors(n, a), c.cross(u), i.setXYZ(e1 + 0, c.x, c.y, c.z), i.setXYZ(e1 + 1, c.x, c.y, c.z), i.setXYZ(e1 + 2, c.x, c.y, c.z);
            this.normalizeNormals(), i.needsUpdate = !0;
        }
    }
    normalizeNormals() {
        const e1 = this.attributes.normal;
        for(let t = 0, i = e1.count; t < i; t++)$785da19a645c07eb$var$Eq.fromBufferAttribute(e1, t), $785da19a645c07eb$var$Eq.normalize(), e1.setXYZ(t, $785da19a645c07eb$var$Eq.x, $785da19a645c07eb$var$Eq.y, $785da19a645c07eb$var$Eq.z);
    }
    toNonIndexed() {
        function e1(e1, t) {
            const i = e1.array, n = e1.itemSize, a = e1.normalized, r = new i.constructor(t.length * n);
            let s = 0, o = 0;
            for(let a = 0, l = t.length; a < l; a++){
                s = e1.isInterleavedBufferAttribute ? t[a] * e1.data.stride + e1.offset : t[a] * n;
                for(let e1 = 0; e1 < n; e1++)r[o++] = i[s++];
            }
            return new $785da19a645c07eb$var$uq(r, n, a);
        }
        if (null === this.index) return $785da19a645c07eb$var$sj("BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        const t = new $785da19a645c07eb$var$kq, i = this.index.array, n = this.attributes;
        for(const a in n){
            const r = e1(n[a], i);
            t.setAttribute(a, r);
        }
        const a = this.morphAttributes;
        for(const n in a){
            const r = [], s = a[n];
            for(let t = 0, n = s.length; t < n; t++){
                const n = e1(s[t], i);
                r.push(n);
            }
            t.morphAttributes[n] = r;
        }
        t.morphTargetsRelative = this.morphTargetsRelative;
        const r = this.groups;
        for(let e1 = 0, i = r.length; e1 < i; e1++){
            const i = r[e1];
            t.addGroup(i.start, i.count, i.materialIndex);
        }
        return t;
    }
    toJSON() {
        const e1 = {
            metadata: {
                version: 4.7,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (e1.uuid = this.uuid, e1.type = void 0 !== this.parameters && !0 === this._transformed ? "BufferGeometry" : this.type, "" !== this.name && (e1.name = this.name), Object.keys(this.userData).length > 0 && (e1.userData = this.userData), void 0 !== this.parameters && !0 !== this._transformed) {
            const t = this.parameters;
            for(const i in t)void 0 !== t[i] && (e1[i] = t[i]);
            return e1;
        }
        e1.data = {
            attributes: {}
        };
        const t = this.index;
        null !== t && (e1.data.index = {
            type: t.array.constructor.name,
            array: Array.prototype.slice.call(t.array)
        });
        const i = this.attributes;
        for(const t in i){
            const n = i[t];
            e1.data.attributes[t] = n.toJSON(e1.data);
        }
        const n = {};
        let a = !1;
        for(const t in this.morphAttributes){
            const i = this.morphAttributes[t], r = [];
            for(let t = 0, n = i.length; t < n; t++){
                const n = i[t];
                r.push(n.toJSON(e1.data));
            }
            r.length > 0 && (n[t] = r, a = !0);
        }
        a && (e1.data.morphAttributes = n, e1.data.morphTargetsRelative = this.morphTargetsRelative);
        const r = this.groups;
        r.length > 0 && (e1.data.groups = JSON.parse(JSON.stringify(r)));
        const s = this.boundingSphere;
        return null !== s && (e1.data.boundingSphere = s.toJSON()), e1;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        const t = {};
        this.name = e1.name;
        const i = e1.index;
        null !== i && this.setIndex(i.clone());
        const n = e1.attributes;
        for(const e1 in n){
            const i = n[e1];
            this.setAttribute(e1, i.clone(t));
        }
        const a = e1.morphAttributes;
        for(const e1 in a){
            const i = [], n = a[e1];
            for(let e1 = 0, a = n.length; e1 < a; e1++)i.push(n[e1].clone(t));
            this.morphAttributes[e1] = i;
        }
        this.morphTargetsRelative = e1.morphTargetsRelative;
        const r = e1.groups;
        for(let e1 = 0, t = r.length; e1 < t; e1++){
            const t = r[e1];
            this.addGroup(t.start, t.count, t.materialIndex);
        }
        const s = e1.boundingBox;
        null !== s && (this.boundingBox = s.clone());
        const o = e1.boundingSphere;
        return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = e1.drawRange.start, this.drawRange.count = e1.drawRange.count, this.userData = e1.userData, this._transformed = e1._transformed, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}
let $785da19a645c07eb$var$Sq = 0;
class $785da19a645c07eb$var$Mq extends $785da19a645c07eb$var$uj {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: $785da19a645c07eb$var$Sq++
        }), this.uuid = $785da19a645c07eb$var$gj(), this.name = "", this.type = "Material", this.blending = 1, this.side = 0, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = 204, this.blendDst = 205, this.blendEquation = $785da19a645c07eb$var$NO, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new $785da19a645c07eb$var$TV(0, 0, 0), this.blendAlpha = 0, this.depthFunc = 3, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $785da19a645c07eb$var$qN, this.stencilZFail = $785da19a645c07eb$var$qN, this.stencilZPass = $785da19a645c07eb$var$qN, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(e1) {
        this._alphaTest > 0 != e1 > 0 && this.version++, this._alphaTest = e1;
    }
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(e1) {
        if (void 0 !== e1) for(const t in e1){
            const i = e1[t];
            if (void 0 === i) {
                $785da19a645c07eb$var$sj(`Material: parameter '${t}' has value of undefined.`);
                continue;
            }
            const n = this[t];
            void 0 !== n ? n && n.isColor ? n.set(i) : n && n.isVector2 && i && i.isVector2 || n && n.isEuler && i && i.isEuler || n && n.isVector3 && i && i.isVector3 ? n.copy(i) : this[t] = i : $785da19a645c07eb$var$sj(`Material: '${t}' is not a property of THREE.${this.type}.`);
        }
    }
    toJSON(e1) {
        const t = void 0 === e1 || "string" == typeof e1;
        t && (e1 = {
            textures: {},
            images: {}
        });
        const i = {
            metadata: {
                version: 4.7,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        function n(e1) {
            const t = [];
            for(const i in e1){
                const n = e1[i];
                delete n.metadata, t.push(n);
            }
            return t;
        }
        if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), this.color && this.color.isColor && (i.color = this.color.getHex()), void 0 !== this.roughness && (i.roughness = this.roughness), void 0 !== this.metalness && (i.metalness = this.metalness), void 0 !== this.sheen && (i.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (i.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (i.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()), void 0 !== this.emissiveIntensity && 1 !== this.emissiveIntensity && (i.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (i.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (i.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (i.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (i.shininess = this.shininess), void 0 !== this.clearcoat && (i.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (i.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (i.clearcoatMap = this.clearcoatMap.toJSON(e1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e1).uuid, i.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.sheenColorMap && this.sheenColorMap.isTexture && (i.sheenColorMap = this.sheenColorMap.toJSON(e1).uuid), this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture && (i.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(e1).uuid), void 0 !== this.dispersion && (i.dispersion = this.dispersion), void 0 !== this.iridescence && (i.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (i.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (i.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (i.iridescenceMap = this.iridescenceMap.toJSON(e1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e1).uuid), void 0 !== this.anisotropy && (i.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (i.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (i.anisotropyMap = this.anisotropyMap.toJSON(e1).uuid), this.map && this.map.isTexture && (i.map = this.map.toJSON(e1).uuid), this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(e1).uuid), this.alphaMap && this.alphaMap.isTexture && (i.alphaMap = this.alphaMap.toJSON(e1).uuid), this.lightMap && this.lightMap.isTexture && (i.lightMap = this.lightMap.toJSON(e1).uuid, i.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (i.aoMap = this.aoMap.toJSON(e1).uuid, i.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (i.bumpMap = this.bumpMap.toJSON(e1).uuid, i.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (i.normalMap = this.normalMap.toJSON(e1).uuid, i.normalMapType = this.normalMapType, i.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (i.displacementMap = this.displacementMap.toJSON(e1).uuid, i.displacementScale = this.displacementScale, i.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (i.roughnessMap = this.roughnessMap.toJSON(e1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (i.metalnessMap = this.metalnessMap.toJSON(e1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (i.emissiveMap = this.emissiveMap.toJSON(e1).uuid), this.specularMap && this.specularMap.isTexture && (i.specularMap = this.specularMap.toJSON(e1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (i.specularIntensityMap = this.specularIntensityMap.toJSON(e1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (i.specularColorMap = this.specularColorMap.toJSON(e1).uuid), this.envMap && this.envMap.isTexture && (i.envMap = this.envMap.toJSON(e1).uuid, void 0 !== this.combine && (i.combine = this.combine)), void 0 !== this.envMapRotation && (i.envMapRotation = this.envMapRotation.toArray()), void 0 !== this.envMapIntensity && (i.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (i.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (i.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (i.gradientMap = this.gradientMap.toJSON(e1).uuid), void 0 !== this.transmission && (i.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (i.transmissionMap = this.transmissionMap.toJSON(e1).uuid), void 0 !== this.thickness && (i.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (i.thicknessMap = this.thicknessMap.toJSON(e1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (i.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (i.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (i.size = this.size), null !== this.shadowSide && (i.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (i.sizeAttenuation = this.sizeAttenuation), 1 !== this.blending && (i.blending = this.blending), 0 !== this.side && (i.side = this.side), !0 === this.vertexColors && (i.vertexColors = !0), this.opacity < 1 && (i.opacity = this.opacity), !0 === this.transparent && (i.transparent = !0), 204 !== this.blendSrc && (i.blendSrc = this.blendSrc), 205 !== this.blendDst && (i.blendDst = this.blendDst), this.blendEquation !== $785da19a645c07eb$var$NO && (i.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (i.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (i.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (i.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (i.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (i.blendAlpha = this.blendAlpha), 3 !== this.depthFunc && (i.depthFunc = this.depthFunc), !1 === this.depthTest && (i.depthTest = this.depthTest), !1 === this.depthWrite && (i.depthWrite = this.depthWrite), !1 === this.colorWrite && (i.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (i.stencilWriteMask = this.stencilWriteMask), 519 !== this.stencilFunc && (i.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (i.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (i.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $785da19a645c07eb$var$qN && (i.stencilFail = this.stencilFail), this.stencilZFail !== $785da19a645c07eb$var$qN && (i.stencilZFail = this.stencilZFail), this.stencilZPass !== $785da19a645c07eb$var$qN && (i.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (i.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (i.rotation = this.rotation), !0 === this.polygonOffset && (i.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (i.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (i.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (i.linewidth = this.linewidth), void 0 !== this.dashSize && (i.dashSize = this.dashSize), void 0 !== this.gapSize && (i.gapSize = this.gapSize), void 0 !== this.scale && (i.scale = this.scale), !0 === this.dithering && (i.dithering = !0), this.alphaTest > 0 && (i.alphaTest = this.alphaTest), !0 === this.alphaHash && (i.alphaHash = !0), !0 === this.alphaToCoverage && (i.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (i.premultipliedAlpha = !0), !0 === this.forceSinglePass && (i.forceSinglePass = !0), !1 === this.allowOverride && (i.allowOverride = !1), !0 === this.wireframe && (i.wireframe = !0), this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (i.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (i.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (i.flatShading = !0), !1 === this.visible && (i.visible = !1), !1 === this.toneMapped && (i.toneMapped = !1), !1 === this.fog && (i.fog = !1), Object.keys(this.userData).length > 0 && (i.userData = this.userData), t) {
            const t = n(e1.textures), a = n(e1.images);
            t.length > 0 && (i.textures = t), a.length > 0 && (i.images = a);
        }
        return i;
    }
    fromJSON(e1, t) {
        if (void 0 !== e1.uuid && (this.uuid = e1.uuid), void 0 !== e1.name && (this.name = e1.name), void 0 !== e1.color && void 0 !== this.color && this.color.setHex(e1.color), void 0 !== e1.roughness && (this.roughness = e1.roughness), void 0 !== e1.metalness && (this.metalness = e1.metalness), void 0 !== e1.sheen && (this.sheen = e1.sheen), void 0 !== e1.sheenColor && (this.sheenColor = (new $785da19a645c07eb$var$TV).setHex(e1.sheenColor)), void 0 !== e1.sheenRoughness && (this.sheenRoughness = e1.sheenRoughness), void 0 !== e1.emissive && void 0 !== this.emissive && this.emissive.setHex(e1.emissive), void 0 !== e1.specular && void 0 !== this.specular && this.specular.setHex(e1.specular), void 0 !== e1.specularIntensity && (this.specularIntensity = e1.specularIntensity), void 0 !== e1.specularColor && void 0 !== this.specularColor && this.specularColor.setHex(e1.specularColor), void 0 !== e1.shininess && (this.shininess = e1.shininess), void 0 !== e1.clearcoat && (this.clearcoat = e1.clearcoat), void 0 !== e1.clearcoatRoughness && (this.clearcoatRoughness = e1.clearcoatRoughness), void 0 !== e1.dispersion && (this.dispersion = e1.dispersion), void 0 !== e1.iridescence && (this.iridescence = e1.iridescence), void 0 !== e1.iridescenceIOR && (this.iridescenceIOR = e1.iridescenceIOR), void 0 !== e1.iridescenceThicknessRange && (this.iridescenceThicknessRange = e1.iridescenceThicknessRange), void 0 !== e1.transmission && (this.transmission = e1.transmission), void 0 !== e1.thickness && (this.thickness = e1.thickness), void 0 !== e1.attenuationDistance && (this.attenuationDistance = e1.attenuationDistance), void 0 !== e1.attenuationColor && void 0 !== this.attenuationColor && this.attenuationColor.setHex(e1.attenuationColor), void 0 !== e1.anisotropy && (this.anisotropy = e1.anisotropy), void 0 !== e1.anisotropyRotation && (this.anisotropyRotation = e1.anisotropyRotation), void 0 !== e1.fog && (this.fog = e1.fog), void 0 !== e1.flatShading && (this.flatShading = e1.flatShading), void 0 !== e1.blending && (this.blending = e1.blending), void 0 !== e1.combine && (this.combine = e1.combine), void 0 !== e1.side && (this.side = e1.side), void 0 !== e1.shadowSide && (this.shadowSide = e1.shadowSide), void 0 !== e1.opacity && (this.opacity = e1.opacity), void 0 !== e1.transparent && (this.transparent = e1.transparent), void 0 !== e1.alphaTest && (this.alphaTest = e1.alphaTest), void 0 !== e1.alphaHash && (this.alphaHash = e1.alphaHash), void 0 !== e1.depthFunc && (this.depthFunc = e1.depthFunc), void 0 !== e1.depthTest && (this.depthTest = e1.depthTest), void 0 !== e1.depthWrite && (this.depthWrite = e1.depthWrite), void 0 !== e1.colorWrite && (this.colorWrite = e1.colorWrite), void 0 !== e1.blendSrc && (this.blendSrc = e1.blendSrc), void 0 !== e1.blendDst && (this.blendDst = e1.blendDst), void 0 !== e1.blendEquation && (this.blendEquation = e1.blendEquation), void 0 !== e1.blendSrcAlpha && (this.blendSrcAlpha = e1.blendSrcAlpha), void 0 !== e1.blendDstAlpha && (this.blendDstAlpha = e1.blendDstAlpha), void 0 !== e1.blendEquationAlpha && (this.blendEquationAlpha = e1.blendEquationAlpha), void 0 !== e1.blendColor && void 0 !== this.blendColor && this.blendColor.setHex(e1.blendColor), void 0 !== e1.blendAlpha && (this.blendAlpha = e1.blendAlpha), void 0 !== e1.stencilWriteMask && (this.stencilWriteMask = e1.stencilWriteMask), void 0 !== e1.stencilFunc && (this.stencilFunc = e1.stencilFunc), void 0 !== e1.stencilRef && (this.stencilRef = e1.stencilRef), void 0 !== e1.stencilFuncMask && (this.stencilFuncMask = e1.stencilFuncMask), void 0 !== e1.stencilFail && (this.stencilFail = e1.stencilFail), void 0 !== e1.stencilZFail && (this.stencilZFail = e1.stencilZFail), void 0 !== e1.stencilZPass && (this.stencilZPass = e1.stencilZPass), void 0 !== e1.stencilWrite && (this.stencilWrite = e1.stencilWrite), void 0 !== e1.wireframe && (this.wireframe = e1.wireframe), void 0 !== e1.wireframeLinewidth && (this.wireframeLinewidth = e1.wireframeLinewidth), void 0 !== e1.wireframeLinecap && (this.wireframeLinecap = e1.wireframeLinecap), void 0 !== e1.wireframeLinejoin && (this.wireframeLinejoin = e1.wireframeLinejoin), void 0 !== e1.rotation && (this.rotation = e1.rotation), void 0 !== e1.linewidth && (this.linewidth = e1.linewidth), void 0 !== e1.dashSize && (this.dashSize = e1.dashSize), void 0 !== e1.gapSize && (this.gapSize = e1.gapSize), void 0 !== e1.scale && (this.scale = e1.scale), void 0 !== e1.polygonOffset && (this.polygonOffset = e1.polygonOffset), void 0 !== e1.polygonOffsetFactor && (this.polygonOffsetFactor = e1.polygonOffsetFactor), void 0 !== e1.polygonOffsetUnits && (this.polygonOffsetUnits = e1.polygonOffsetUnits), void 0 !== e1.dithering && (this.dithering = e1.dithering), void 0 !== e1.alphaToCoverage && (this.alphaToCoverage = e1.alphaToCoverage), void 0 !== e1.premultipliedAlpha && (this.premultipliedAlpha = e1.premultipliedAlpha), void 0 !== e1.forceSinglePass && (this.forceSinglePass = e1.forceSinglePass), void 0 !== e1.allowOverride && (this.allowOverride = e1.allowOverride), void 0 !== e1.visible && (this.visible = e1.visible), void 0 !== e1.toneMapped && (this.toneMapped = e1.toneMapped), void 0 !== e1.userData && (this.userData = e1.userData), void 0 !== e1.vertexColors && ("number" == typeof e1.vertexColors ? this.vertexColors = e1.vertexColors > 0 : this.vertexColors = e1.vertexColors), void 0 !== e1.size && (this.size = e1.size), void 0 !== e1.sizeAttenuation && (this.sizeAttenuation = e1.sizeAttenuation), void 0 !== e1.map && (this.map = t[e1.map] || null), void 0 !== e1.matcap && (this.matcap = t[e1.matcap] || null), void 0 !== e1.alphaMap && (this.alphaMap = t[e1.alphaMap] || null), void 0 !== e1.bumpMap && (this.bumpMap = t[e1.bumpMap] || null), void 0 !== e1.bumpScale && (this.bumpScale = e1.bumpScale), void 0 !== e1.normalMap && (this.normalMap = t[e1.normalMap] || null), void 0 !== e1.normalMapType && (this.normalMapType = e1.normalMapType), void 0 !== e1.normalScale) {
            let t = e1.normalScale;
            !1 === Array.isArray(t) && (t = [
                t,
                t
            ]), this.normalScale = (new $785da19a645c07eb$var$bj).fromArray(t);
        }
        return void 0 !== e1.displacementMap && (this.displacementMap = t[e1.displacementMap] || null), void 0 !== e1.displacementScale && (this.displacementScale = e1.displacementScale), void 0 !== e1.displacementBias && (this.displacementBias = e1.displacementBias), void 0 !== e1.roughnessMap && (this.roughnessMap = t[e1.roughnessMap] || null), void 0 !== e1.metalnessMap && (this.metalnessMap = t[e1.metalnessMap] || null), void 0 !== e1.emissiveMap && (this.emissiveMap = t[e1.emissiveMap] || null), void 0 !== e1.emissiveIntensity && (this.emissiveIntensity = e1.emissiveIntensity), void 0 !== e1.specularMap && (this.specularMap = t[e1.specularMap] || null), void 0 !== e1.specularIntensityMap && (this.specularIntensityMap = t[e1.specularIntensityMap] || null), void 0 !== e1.specularColorMap && (this.specularColorMap = t[e1.specularColorMap] || null), void 0 !== e1.envMap && (this.envMap = t[e1.envMap] || null), void 0 !== e1.envMapRotation && this.envMapRotation.fromArray(e1.envMapRotation), void 0 !== e1.envMapIntensity && (this.envMapIntensity = e1.envMapIntensity), void 0 !== e1.reflectivity && (this.reflectivity = e1.reflectivity), void 0 !== e1.refractionRatio && (this.refractionRatio = e1.refractionRatio), void 0 !== e1.lightMap && (this.lightMap = t[e1.lightMap] || null), void 0 !== e1.lightMapIntensity && (this.lightMapIntensity = e1.lightMapIntensity), void 0 !== e1.aoMap && (this.aoMap = t[e1.aoMap] || null), void 0 !== e1.aoMapIntensity && (this.aoMapIntensity = e1.aoMapIntensity), void 0 !== e1.gradientMap && (this.gradientMap = t[e1.gradientMap] || null), void 0 !== e1.clearcoatMap && (this.clearcoatMap = t[e1.clearcoatMap] || null), void 0 !== e1.clearcoatRoughnessMap && (this.clearcoatRoughnessMap = t[e1.clearcoatRoughnessMap] || null), void 0 !== e1.clearcoatNormalMap && (this.clearcoatNormalMap = t[e1.clearcoatNormalMap] || null), void 0 !== e1.clearcoatNormalScale && (this.clearcoatNormalScale = (new $785da19a645c07eb$var$bj).fromArray(e1.clearcoatNormalScale)), void 0 !== e1.iridescenceMap && (this.iridescenceMap = t[e1.iridescenceMap] || null), void 0 !== e1.iridescenceThicknessMap && (this.iridescenceThicknessMap = t[e1.iridescenceThicknessMap] || null), void 0 !== e1.transmissionMap && (this.transmissionMap = t[e1.transmissionMap] || null), void 0 !== e1.thicknessMap && (this.thicknessMap = t[e1.thicknessMap] || null), void 0 !== e1.anisotropyMap && (this.anisotropyMap = t[e1.anisotropyMap] || null), void 0 !== e1.sheenColorMap && (this.sheenColorMap = t[e1.sheenColorMap] || null), void 0 !== e1.sheenRoughnessMap && (this.sheenRoughnessMap = t[e1.sheenRoughnessMap] || null), this;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
    copy(e1) {
        this.name = e1.name, this.blending = e1.blending, this.side = e1.side, this.vertexColors = e1.vertexColors, this.opacity = e1.opacity, this.transparent = e1.transparent, this.blendSrc = e1.blendSrc, this.blendDst = e1.blendDst, this.blendEquation = e1.blendEquation, this.blendSrcAlpha = e1.blendSrcAlpha, this.blendDstAlpha = e1.blendDstAlpha, this.blendEquationAlpha = e1.blendEquationAlpha, this.blendColor.copy(e1.blendColor), this.blendAlpha = e1.blendAlpha, this.depthFunc = e1.depthFunc, this.depthTest = e1.depthTest, this.depthWrite = e1.depthWrite, this.stencilWriteMask = e1.stencilWriteMask, this.stencilFunc = e1.stencilFunc, this.stencilRef = e1.stencilRef, this.stencilFuncMask = e1.stencilFuncMask, this.stencilFail = e1.stencilFail, this.stencilZFail = e1.stencilZFail, this.stencilZPass = e1.stencilZPass, this.stencilWrite = e1.stencilWrite;
        const t = e1.clippingPlanes;
        let i = null;
        if (null !== t) {
            const e1 = t.length;
            i = new Array(e1);
            for(let n = 0; n !== e1; ++n)i[n] = t[n].clone();
        }
        return this.clippingPlanes = i, this.clipIntersection = e1.clipIntersection, this.clipShadows = e1.clipShadows, this.shadowSide = e1.shadowSide, this.colorWrite = e1.colorWrite, this.precision = e1.precision, this.polygonOffset = e1.polygonOffset, this.polygonOffsetFactor = e1.polygonOffsetFactor, this.polygonOffsetUnits = e1.polygonOffsetUnits, this.dithering = e1.dithering, this.alphaTest = e1.alphaTest, this.alphaHash = e1.alphaHash, this.alphaToCoverage = e1.alphaToCoverage, this.premultipliedAlpha = e1.premultipliedAlpha, this.forceSinglePass = e1.forceSinglePass, this.allowOverride = e1.allowOverride, this.visible = e1.visible, this.toneMapped = e1.toneMapped, this.userData = JSON.parse(JSON.stringify(e1.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(e1) {
        !0 === e1 && this.version++;
    }
}
const $785da19a645c07eb$var$Cq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Tq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Dq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Pq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Iq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Fq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$zq = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$Rq {
    constructor(e1 = new $785da19a645c07eb$var$Ej, t = new $785da19a645c07eb$var$Ej(0, 0, -1)){
        this.origin = e1, this.direction = t;
    }
    set(e1, t) {
        return this.origin.copy(e1), this.direction.copy(t), this;
    }
    copy(e1) {
        return this.origin.copy(e1.origin), this.direction.copy(e1.direction), this;
    }
    at(e1, t) {
        return t.copy(this.origin).addScaledVector(this.direction, e1);
    }
    lookAt(e1) {
        return this.direction.copy(e1).sub(this.origin).normalize(), this;
    }
    recast(e1) {
        return this.origin.copy(this.at(e1, $785da19a645c07eb$var$Cq)), this;
    }
    closestPointToPoint(e1, t) {
        t.subVectors(e1, this.origin);
        const i = t.dot(this.direction);
        return i < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, i);
    }
    distanceToPoint(e1) {
        return Math.sqrt(this.distanceSqToPoint(e1));
    }
    distanceSqToPoint(e1) {
        const t = $785da19a645c07eb$var$Cq.subVectors(e1, this.origin).dot(this.direction);
        return t < 0 ? this.origin.distanceToSquared(e1) : ($785da19a645c07eb$var$Cq.copy(this.origin).addScaledVector(this.direction, t), $785da19a645c07eb$var$Cq.distanceToSquared(e1));
    }
    distanceSqToSegment(e1, t, i, n) {
        $785da19a645c07eb$var$Tq.copy(e1).add(t).multiplyScalar(.5), $785da19a645c07eb$var$Dq.copy(t).sub(e1).normalize(), $785da19a645c07eb$var$Pq.copy(this.origin).sub($785da19a645c07eb$var$Tq);
        const a = .5 * e1.distanceTo(t), r = -this.direction.dot($785da19a645c07eb$var$Dq), s = $785da19a645c07eb$var$Pq.dot(this.direction), o = -$785da19a645c07eb$var$Pq.dot($785da19a645c07eb$var$Dq), l = $785da19a645c07eb$var$Pq.lengthSq(), c = Math.abs(1 - r * r);
        let u, h, d, p;
        if (c > 0) {
            if (u = r * o - s, h = r * s - o, p = a * c, u >= 0) {
                if (h >= -p) {
                    if (h <= p) {
                        const e1 = 1 / c;
                        u *= e1, h *= e1, d = u * (u + r * h + 2 * s) + h * (r * u + h + 2 * o) + l;
                    } else h = a, u = Math.max(0, -(r * h + s)), d = -u * u + h * (h + 2 * o) + l;
                } else h = -a, u = Math.max(0, -(r * h + s)), d = -u * u + h * (h + 2 * o) + l;
            } else h <= -p ? (u = Math.max(0, -(-r * a + s)), h = u > 0 ? -a : Math.min(Math.max(-a, -o), a), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-a, -o), a), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(r * a + s)), h = u > 0 ? a : Math.min(Math.max(-a, -o), a), d = -u * u + h * (h + 2 * o) + l);
        } else h = r > 0 ? -a : a, u = Math.max(0, -(r * h + s)), d = -u * u + h * (h + 2 * o) + l;
        return i && i.copy(this.origin).addScaledVector(this.direction, u), n && n.copy($785da19a645c07eb$var$Tq).addScaledVector($785da19a645c07eb$var$Dq, h), d;
    }
    intersectSphere(e1, t) {
        $785da19a645c07eb$var$Cq.subVectors(e1.center, this.origin);
        const i = $785da19a645c07eb$var$Cq.dot(this.direction), n = $785da19a645c07eb$var$Cq.dot($785da19a645c07eb$var$Cq) - i * i, a = e1.radius * e1.radius;
        if (n > a) return null;
        const r = Math.sqrt(a - n), s = i - r, o = i + r;
        return o < 0 ? null : s < 0 ? this.at(o, t) : this.at(s, t);
    }
    intersectsSphere(e1) {
        return !(e1.radius < 0) && this.distanceSqToPoint(e1.center) <= e1.radius * e1.radius;
    }
    distanceToPlane(e1) {
        const t = e1.normal.dot(this.direction);
        if (0 === t) return 0 === e1.distanceToPoint(this.origin) ? 0 : null;
        const i = -(this.origin.dot(e1.normal) + e1.constant) / t;
        return i >= 0 ? i : null;
    }
    intersectPlane(e1, t) {
        const i = this.distanceToPlane(e1);
        return null === i ? null : this.at(i, t);
    }
    intersectsPlane(e1) {
        const t = e1.distanceToPoint(this.origin);
        if (0 === t) return !0;
        return e1.normal.dot(this.direction) * t < 0;
    }
    intersectBox(e1, t) {
        let i, n, a, r, s, o;
        const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
        return l >= 0 ? (i = (e1.min.x - h.x) * l, n = (e1.max.x - h.x) * l) : (i = (e1.max.x - h.x) * l, n = (e1.min.x - h.x) * l), c >= 0 ? (a = (e1.min.y - h.y) * c, r = (e1.max.y - h.y) * c) : (a = (e1.max.y - h.y) * c, r = (e1.min.y - h.y) * c), i > r || a > n ? null : ((a > i || isNaN(i)) && (i = a), (r < n || isNaN(n)) && (n = r), u >= 0 ? (s = (e1.min.z - h.z) * u, o = (e1.max.z - h.z) * u) : (s = (e1.max.z - h.z) * u, o = (e1.min.z - h.z) * u), i > o || s > n ? null : ((s > i || i != i) && (i = s), (o < n || n != n) && (n = o), n < 0 ? null : this.at(i >= 0 ? i : n, t)));
    }
    intersectsBox(e1) {
        return null !== this.intersectBox(e1, $785da19a645c07eb$var$Cq);
    }
    intersectTriangle(e1, t, i, n, a) {
        $785da19a645c07eb$var$Iq.subVectors(t, e1), $785da19a645c07eb$var$Fq.subVectors(i, e1), $785da19a645c07eb$var$zq.crossVectors($785da19a645c07eb$var$Iq, $785da19a645c07eb$var$Fq);
        let r, s = this.direction.dot($785da19a645c07eb$var$zq);
        if (s > 0) {
            if (n) return null;
            r = 1;
        } else {
            if (!(s < 0)) return null;
            r = -1, s = -s;
        }
        $785da19a645c07eb$var$Pq.subVectors(this.origin, e1);
        const o = r * this.direction.dot($785da19a645c07eb$var$Fq.crossVectors($785da19a645c07eb$var$Pq, $785da19a645c07eb$var$Fq));
        if (o < 0) return null;
        const l = r * this.direction.dot($785da19a645c07eb$var$Iq.cross($785da19a645c07eb$var$Pq));
        if (l < 0) return null;
        if (o + l > s) return null;
        const c = -r * $785da19a645c07eb$var$Pq.dot($785da19a645c07eb$var$zq);
        return c < 0 ? null : this.at(c / s, a);
    }
    applyMatrix4(e1) {
        return this.origin.applyMatrix4(e1), this.direction.transformDirection(e1), this;
    }
    equals(e1) {
        return e1.origin.equals(this.origin) && e1.direction.equals(this.direction);
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $785da19a645c07eb$var$Lq extends $785da19a645c07eb$var$Mq {
    constructor(e1){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new $785da19a645c07eb$var$TV(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new $785da19a645c07eb$var$aV, this.combine = 0, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e1);
    }
    copy(e1) {
        return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.envMapRotation.copy(e1.envMapRotation), this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.fog = e1.fog, this;
    }
}
const $785da19a645c07eb$var$Bq = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$Oq = new $785da19a645c07eb$var$Rq, $785da19a645c07eb$var$Uq = new $785da19a645c07eb$var$Aq, $785da19a645c07eb$var$Nq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$jq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Vq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$qq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Gq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Hq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Wq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Zq = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$Kq extends $785da19a645c07eb$var$xV {
    constructor(e1 = new $785da19a645c07eb$var$kq, t = new $785da19a645c07eb$var$Lq){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e1, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
    }
    copy(e1, t) {
        return super.copy(e1, t), void 0 !== e1.morphTargetInfluences && (this.morphTargetInfluences = e1.morphTargetInfluences.slice()), void 0 !== e1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, e1.morphTargetDictionary)), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
    }
    updateMorphTargets() {
        const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
        if (t.length > 0) {
            const i = e1[t[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let e1 = 0, t = i.length; e1 < t; e1++){
                    const t = i[e1].name || String(e1);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                }
            }
        }
    }
    getVertexPosition(e1, t) {
        const i = this.geometry, n = i.attributes.position, a = i.morphAttributes.position, r = i.morphTargetsRelative;
        t.fromBufferAttribute(n, e1);
        const s = this.morphTargetInfluences;
        if (a && s) {
            $785da19a645c07eb$var$Hq.set(0, 0, 0);
            for(let i = 0, n = a.length; i < n; i++){
                const n = s[i], o = a[i];
                0 !== n && ($785da19a645c07eb$var$Gq.fromBufferAttribute(o, e1), r ? $785da19a645c07eb$var$Hq.addScaledVector($785da19a645c07eb$var$Gq, n) : $785da19a645c07eb$var$Hq.addScaledVector($785da19a645c07eb$var$Gq.sub(t), n));
            }
            t.add($785da19a645c07eb$var$Hq);
        }
        return t;
    }
    raycast(e1, t) {
        const i = this.geometry, n = this.material, a = this.matrixWorld;
        if (void 0 !== n) {
            if (null === i.boundingSphere && i.computeBoundingSphere(), $785da19a645c07eb$var$Uq.copy(i.boundingSphere), $785da19a645c07eb$var$Uq.applyMatrix4(a), $785da19a645c07eb$var$Oq.copy(e1.ray).recast(e1.near), !1 === $785da19a645c07eb$var$Uq.containsPoint($785da19a645c07eb$var$Oq.origin)) {
                if (null === $785da19a645c07eb$var$Oq.intersectSphere($785da19a645c07eb$var$Uq, $785da19a645c07eb$var$Nq)) return;
                if ($785da19a645c07eb$var$Oq.origin.distanceToSquared($785da19a645c07eb$var$Nq) > (e1.far - e1.near) ** 2) return;
            }
            $785da19a645c07eb$var$Bq.copy(a).invert(), $785da19a645c07eb$var$Oq.copy(e1.ray).applyMatrix4($785da19a645c07eb$var$Bq), null !== i.boundingBox && !1 === $785da19a645c07eb$var$Oq.intersectsBox(i.boundingBox) || this._computeIntersections(e1, t, $785da19a645c07eb$var$Oq);
        }
    }
    _computeIntersections(e1, t, i) {
        let n;
        const a = this.geometry, r = this.material, s = a.index, o = a.attributes.position, l = a.attributes.uv, c = a.attributes.uv1, u = a.attributes.normal, h = a.groups, d = a.drawRange;
        if (null !== s) {
            if (Array.isArray(r)) for(let a = 0, o = h.length; a < o; a++){
                const o = h[a], p = r[o.materialIndex];
                for(let a = Math.max(o.start, d.start), r = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); a < r; a += 3)n = $785da19a645c07eb$var$Xq(this, p, e1, i, l, c, u, s.getX(a), s.getX(a + 1), s.getX(a + 2)), n && (n.faceIndex = Math.floor(a / 3), n.face.materialIndex = o.materialIndex, t.push(n));
            }
            else for(let a = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); a < o; a += 3)n = $785da19a645c07eb$var$Xq(this, r, e1, i, l, c, u, s.getX(a), s.getX(a + 1), s.getX(a + 2)), n && (n.faceIndex = Math.floor(a / 3), t.push(n));
        } else if (void 0 !== o) {
            if (Array.isArray(r)) for(let a = 0, s = h.length; a < s; a++){
                const s = h[a], p = r[s.materialIndex];
                for(let a = Math.max(s.start, d.start), r = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); a < r; a += 3)n = $785da19a645c07eb$var$Xq(this, p, e1, i, l, c, u, a, a + 1, a + 2), n && (n.faceIndex = Math.floor(a / 3), n.face.materialIndex = s.materialIndex, t.push(n));
            }
            else for(let a = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); a < s; a += 3)n = $785da19a645c07eb$var$Xq(this, r, e1, i, l, c, u, a, a + 1, a + 2), n && (n.faceIndex = Math.floor(a / 3), t.push(n));
        }
    }
}
function $785da19a645c07eb$var$Xq(e1, t, i, n, a, r, s, o, l, c) {
    e1.getVertexPosition(o, $785da19a645c07eb$var$jq), e1.getVertexPosition(l, $785da19a645c07eb$var$Vq), e1.getVertexPosition(c, $785da19a645c07eb$var$qq);
    const u = function(e1, t, i, n, a, r, s, o) {
        let l;
        if (l = 1 === t.side ? n.intersectTriangle(s, r, a, !0, o) : n.intersectTriangle(a, r, s, 0 === t.side, o), null === l) return null;
        $785da19a645c07eb$var$Zq.copy(o), $785da19a645c07eb$var$Zq.applyMatrix4(e1.matrixWorld);
        const c = i.ray.origin.distanceTo($785da19a645c07eb$var$Zq);
        return c < i.near || c > i.far ? null : {
            distance: c,
            point: $785da19a645c07eb$var$Zq.clone(),
            object: e1
        };
    }(e1, t, i, n, $785da19a645c07eb$var$jq, $785da19a645c07eb$var$Vq, $785da19a645c07eb$var$qq, $785da19a645c07eb$var$Wq);
    if (u) {
        const e1 = new $785da19a645c07eb$var$Ej;
        $785da19a645c07eb$var$HV.getBarycoord($785da19a645c07eb$var$Wq, $785da19a645c07eb$var$jq, $785da19a645c07eb$var$Vq, $785da19a645c07eb$var$qq, e1), a && (u.uv = $785da19a645c07eb$var$HV.getInterpolatedAttribute(a, o, l, c, e1, new $785da19a645c07eb$var$bj)), r && (u.uv1 = $785da19a645c07eb$var$HV.getInterpolatedAttribute(r, o, l, c, e1, new $785da19a645c07eb$var$bj)), s && (u.normal = $785da19a645c07eb$var$HV.getInterpolatedAttribute(s, o, l, c, e1, new $785da19a645c07eb$var$Ej), u.normal.dot(n.direction) > 0 && u.normal.multiplyScalar(-1));
        const t = {
            a: o,
            b: l,
            c: c,
            normal: new $785da19a645c07eb$var$Ej,
            materialIndex: 0
        };
        $785da19a645c07eb$var$HV.getNormal($785da19a645c07eb$var$jq, $785da19a645c07eb$var$Vq, $785da19a645c07eb$var$qq, t.normal), u.face = t, u.barycoord = e1;
    }
    return u;
}
class $785da19a645c07eb$var$Qq extends $785da19a645c07eb$var$Vj {
    constructor(e1 = null, t = 1, i = 1, n, a, r, s, o, l = 1003, c = 1003, u, h){
        super(null, r, s, o, l, c, n, a, u, h), this.isDataTexture = !0, this.image = {
            data: e1,
            width: t,
            height: i
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
}
const $785da19a645c07eb$var$Yq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$Jq = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$$q = new $785da19a645c07eb$var$Mj;
class $785da19a645c07eb$var$eG {
    constructor(e1 = new $785da19a645c07eb$var$Ej(1, 0, 0), t = 0){
        this.isPlane = !0, this.normal = e1, this.constant = t;
    }
    set(e1, t) {
        return this.normal.copy(e1), this.constant = t, this;
    }
    setComponents(e1, t, i, n) {
        return this.normal.set(e1, t, i), this.constant = n, this;
    }
    setFromNormalAndCoplanarPoint(e1, t) {
        return this.normal.copy(e1), this.constant = -t.dot(this.normal), this;
    }
    setFromCoplanarPoints(e1, t, i) {
        const n = $785da19a645c07eb$var$Yq.subVectors(i, t).cross($785da19a645c07eb$var$Jq.subVectors(e1, t)).normalize();
        return this.setFromNormalAndCoplanarPoint(n, e1), this;
    }
    copy(e1) {
        return this.normal.copy(e1.normal), this.constant = e1.constant, this;
    }
    normalize() {
        const e1 = 1 / this.normal.length();
        return this.normal.multiplyScalar(e1), this.constant *= e1, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(e1) {
        return this.normal.dot(e1) + this.constant;
    }
    distanceToSphere(e1) {
        return this.distanceToPoint(e1.center) - e1.radius;
    }
    projectPoint(e1, t) {
        return t.copy(e1).addScaledVector(this.normal, -this.distanceToPoint(e1));
    }
    intersectLine(e1, t, i = !0) {
        const n = e1.delta($785da19a645c07eb$var$Yq), a = this.normal.dot(n);
        if (0 === a) return 0 === this.distanceToPoint(e1.start) ? t.copy(e1.start) : null;
        const r = -(e1.start.dot(this.normal) + this.constant) / a;
        return !0 === i && (r < 0 || r > 1) ? null : t.copy(e1.start).addScaledVector(n, r);
    }
    intersectsLine(e1) {
        const t = this.distanceToPoint(e1.start), i = this.distanceToPoint(e1.end);
        return t < 0 && i > 0 || i < 0 && t > 0;
    }
    intersectsBox(e1) {
        return e1.intersectsPlane(this);
    }
    intersectsSphere(e1) {
        return e1.intersectsPlane(this);
    }
    coplanarPoint(e1) {
        return e1.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(e1, t) {
        const i = t || $785da19a645c07eb$var$$q.getNormalMatrix(e1), n = this.coplanarPoint($785da19a645c07eb$var$Yq).applyMatrix4(e1), a = this.normal.applyMatrix3(i).normalize();
        return this.constant = -n.dot(a), this;
    }
    translate(e1) {
        return this.constant -= e1.dot(this.normal), this;
    }
    equals(e1) {
        return e1.normal.equals(this.normal) && e1.constant === this.constant;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $785da19a645c07eb$var$tG = new $785da19a645c07eb$var$Aq, $785da19a645c07eb$var$iG = new $785da19a645c07eb$var$bj(.5, .5), $785da19a645c07eb$var$nG = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$aG {
    constructor(e1 = new $785da19a645c07eb$var$eG, t = new $785da19a645c07eb$var$eG, i = new $785da19a645c07eb$var$eG, n = new $785da19a645c07eb$var$eG, a = new $785da19a645c07eb$var$eG, r = new $785da19a645c07eb$var$eG){
        this.planes = [
            e1,
            t,
            i,
            n,
            a,
            r
        ];
    }
    set(e1, t, i, n, a, r) {
        const s = this.planes;
        return s[0].copy(e1), s[1].copy(t), s[2].copy(i), s[3].copy(n), s[4].copy(a), s[5].copy(r), this;
    }
    copy(e1) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)t[i].copy(e1.planes[i]);
        return this;
    }
    setFromProjectionMatrix(e1, t = 2e3, i = !1) {
        const n = this.planes, a = e1.elements, r = a[0], s = a[1], o = a[2], l = a[3], c = a[4], u = a[5], h = a[6], d = a[7], p = a[8], m = a[9], g = a[10], f = a[11], A = a[12], _ = a[13], v = a[14], y = a[15];
        if (n[0].setComponents(l - r, d - c, f - p, y - A).normalize(), n[1].setComponents(l + r, d + c, f + p, y + A).normalize(), n[2].setComponents(l + s, d + u, f + m, y + _).normalize(), n[3].setComponents(l - s, d - u, f - m, y - _).normalize(), i) n[4].setComponents(o, h, g, v).normalize(), n[5].setComponents(l - o, d - h, f - g, y - v).normalize();
        else if (n[4].setComponents(l - o, d - h, f - g, y - v).normalize(), t === $785da19a645c07eb$var$$N) n[5].setComponents(l + o, d + h, f + g, y + v).normalize();
        else {
            if (t !== $785da19a645c07eb$var$ej) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
            n[5].setComponents(o, h, g, v).normalize();
        }
        return this;
    }
    intersectsObject(e1) {
        if (void 0 !== e1.boundingSphere) null === e1.boundingSphere && e1.computeBoundingSphere(), $785da19a645c07eb$var$tG.copy(e1.boundingSphere).applyMatrix4(e1.matrixWorld);
        else {
            const t = e1.geometry;
            null === t.boundingSphere && t.computeBoundingSphere(), $785da19a645c07eb$var$tG.copy(t.boundingSphere).applyMatrix4(e1.matrixWorld);
        }
        return this.intersectsSphere($785da19a645c07eb$var$tG);
    }
    intersectsSprite(e1) {
        $785da19a645c07eb$var$tG.center.set(0, 0, 0);
        const t = $785da19a645c07eb$var$iG.distanceTo(e1.center);
        return $785da19a645c07eb$var$tG.radius = .7071067811865476 + t, $785da19a645c07eb$var$tG.applyMatrix4(e1.matrixWorld), this.intersectsSphere($785da19a645c07eb$var$tG);
    }
    intersectsSphere(e1) {
        const t = this.planes, i = e1.center, n = -e1.radius;
        for(let e1 = 0; e1 < 6; e1++){
            if (t[e1].distanceToPoint(i) < n) return !1;
        }
        return !0;
    }
    intersectsBox(e1) {
        const t = this.planes;
        for(let i = 0; i < 6; i++){
            const n = t[i];
            if ($785da19a645c07eb$var$nG.x = n.normal.x > 0 ? e1.max.x : e1.min.x, $785da19a645c07eb$var$nG.y = n.normal.y > 0 ? e1.max.y : e1.min.y, $785da19a645c07eb$var$nG.z = n.normal.z > 0 ? e1.max.z : e1.min.z, n.distanceToPoint($785da19a645c07eb$var$nG) < 0) return !1;
        }
        return !0;
    }
    containsPoint(e1) {
        const t = this.planes;
        for(let i = 0; i < 6; i++)if (t[i].distanceToPoint(e1) < 0) return !1;
        return !0;
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
class $785da19a645c07eb$var$rG extends $785da19a645c07eb$var$Mq {
    constructor(e1){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new $785da19a645c07eb$var$TV(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e1);
    }
    copy(e1) {
        return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.linewidth = e1.linewidth, this.linecap = e1.linecap, this.linejoin = e1.linejoin, this.fog = e1.fog, this;
    }
}
const $785da19a645c07eb$var$sG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$oG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$lG = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$cG = new $785da19a645c07eb$var$Rq, $785da19a645c07eb$var$uG = new $785da19a645c07eb$var$Aq, $785da19a645c07eb$var$hG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$dG = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$pG extends $785da19a645c07eb$var$xV {
    constructor(e1 = new $785da19a645c07eb$var$kq, t = new $785da19a645c07eb$var$rG){
        super(), this.isLine = !0, this.type = "Line", this.geometry = e1, this.material = t, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
    }
    copy(e1, t) {
        return super.copy(e1, t), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
    }
    computeLineDistances() {
        const e1 = this.geometry;
        if (null === e1.index) {
            const t = e1.attributes.position, i = [
                0
            ];
            for(let e1 = 1, n = t.count; e1 < n; e1++)$785da19a645c07eb$var$sG.fromBufferAttribute(t, e1 - 1), $785da19a645c07eb$var$oG.fromBufferAttribute(t, e1), i[e1] = i[e1 - 1], i[e1] += $785da19a645c07eb$var$sG.distanceTo($785da19a645c07eb$var$oG);
            e1.setAttribute("lineDistance", new $785da19a645c07eb$var$pq(i, 1));
        } else $785da19a645c07eb$var$sj("Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(e1, t) {
        const i = this.geometry, n = this.matrixWorld, a = e1.params.Line.threshold, r = i.drawRange;
        if (null === i.boundingSphere && i.computeBoundingSphere(), $785da19a645c07eb$var$uG.copy(i.boundingSphere), $785da19a645c07eb$var$uG.applyMatrix4(n), $785da19a645c07eb$var$uG.radius += a, !1 === e1.ray.intersectsSphere($785da19a645c07eb$var$uG)) return;
        $785da19a645c07eb$var$lG.copy(n).invert(), $785da19a645c07eb$var$cG.copy(e1.ray).applyMatrix4($785da19a645c07eb$var$lG);
        const s = a / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = this.isLineSegments ? 2 : 1, c = i.index, u = i.attributes.position;
        if (null !== c) {
            const i = Math.max(0, r.start), n = Math.min(c.count, r.start + r.count);
            for(let a = i, r = n - 1; a < r; a += l){
                const i = c.getX(a), n = c.getX(a + 1), r = $785da19a645c07eb$var$mG(this, e1, $785da19a645c07eb$var$cG, o, i, n, a);
                r && t.push(r);
            }
            if (this.isLineLoop) {
                const a = c.getX(n - 1), r = c.getX(i), s = $785da19a645c07eb$var$mG(this, e1, $785da19a645c07eb$var$cG, o, a, r, n - 1);
                s && t.push(s);
            }
        } else {
            const i = Math.max(0, r.start), n = Math.min(u.count, r.start + r.count);
            for(let a = i, r = n - 1; a < r; a += l){
                const i = $785da19a645c07eb$var$mG(this, e1, $785da19a645c07eb$var$cG, o, a, a + 1, a);
                i && t.push(i);
            }
            if (this.isLineLoop) {
                const a = $785da19a645c07eb$var$mG(this, e1, $785da19a645c07eb$var$cG, o, n - 1, i, n - 1);
                a && t.push(a);
            }
        }
    }
    updateMorphTargets() {
        const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
        if (t.length > 0) {
            const i = e1[t[0]];
            if (void 0 !== i) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let e1 = 0, t = i.length; e1 < t; e1++){
                    const t = i[e1].name || String(e1);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                }
            }
        }
    }
}
function $785da19a645c07eb$var$mG(e1, t, i, n, a, r, s) {
    const o = e1.geometry.attributes.position;
    $785da19a645c07eb$var$sG.fromBufferAttribute(o, a), $785da19a645c07eb$var$oG.fromBufferAttribute(o, r);
    if (i.distanceSqToSegment($785da19a645c07eb$var$sG, $785da19a645c07eb$var$oG, $785da19a645c07eb$var$hG, $785da19a645c07eb$var$dG) > n) return;
    $785da19a645c07eb$var$hG.applyMatrix4(e1.matrixWorld);
    const l = t.ray.origin.distanceTo($785da19a645c07eb$var$hG);
    return l < t.near || l > t.far ? void 0 : {
        distance: l,
        point: $785da19a645c07eb$var$dG.clone().applyMatrix4(e1.matrixWorld),
        index: s,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: e1
    };
}
const $785da19a645c07eb$var$gG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$fG = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$AG extends $785da19a645c07eb$var$pG {
    constructor(e1, t){
        super(e1, t), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        const e1 = this.geometry;
        if (null === e1.index) {
            const t = e1.attributes.position, i = [];
            for(let e1 = 0, n = t.count; e1 < n; e1 += 2)$785da19a645c07eb$var$gG.fromBufferAttribute(t, e1), $785da19a645c07eb$var$fG.fromBufferAttribute(t, e1 + 1), i[e1] = 0 === e1 ? 0 : i[e1 - 1], i[e1 + 1] = i[e1] + $785da19a645c07eb$var$gG.distanceTo($785da19a645c07eb$var$fG);
            e1.setAttribute("lineDistance", new $785da19a645c07eb$var$pq(i, 1));
        } else $785da19a645c07eb$var$sj("LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
}
class $785da19a645c07eb$var$_G extends $785da19a645c07eb$var$Vj {
    constructor(e1, t, i, n, a = 1006, r = 1006, s, o, l){
        super(e1, t, i, n, a, r, s, o, l), this.isVideoTexture = !0, this.generateMipmaps = !1, this._requestVideoFrameCallbackId = 0;
        const c = this;
        "requestVideoFrameCallback" in e1 && (this._requestVideoFrameCallbackId = e1.requestVideoFrameCallback(function t() {
            c.needsUpdate = !0, c._requestVideoFrameCallbackId = e1.requestVideoFrameCallback(t);
        }));
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const e1 = this.image;
        !1 === "requestVideoFrameCallback" in e1 && e1.readyState >= e1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
    dispose() {
        0 !== this._requestVideoFrameCallbackId && (this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId), this._requestVideoFrameCallbackId = 0), super.dispose();
    }
}
class $785da19a645c07eb$var$vG extends $785da19a645c07eb$var$Vj {
    constructor(e1 = [], t = 301, i, n, a, r, s, o, l, c){
        super(e1, t, i, n, a, r, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(e1) {
        this.image = e1;
    }
}
class $785da19a645c07eb$var$yG extends $785da19a645c07eb$var$Vj {
    constructor(e1, t, i = 1014, n, a, r, s = 1003, o = 1003, l, c = 1026, u = 1){
        if (c !== $785da19a645c07eb$var$QU && c !== $785da19a645c07eb$var$YU) throw new Error("THREE.DepthTexture: format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        super({
            width: e1,
            height: t,
            depth: u
        }, n, a, r, s, o, c, i, l), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
    }
    copy(e1) {
        return super.copy(e1), this.source = new $785da19a645c07eb$var$Oj(Object.assign({}, e1.image)), this.compareFunction = e1.compareFunction, this;
    }
    toJSON(e1) {
        const t = super.toJSON(e1);
        return null !== this.compareFunction && (t.compareFunction = this.compareFunction), t;
    }
}
class $785da19a645c07eb$var$xG extends $785da19a645c07eb$var$yG {
    constructor(e1, t = 1014, i = 301, n, a, r = 1003, s = 1003, o, l = 1026){
        const c = {
            width: e1,
            height: e1,
            depth: 1
        }, u = [
            c,
            c,
            c,
            c,
            c,
            c
        ];
        super(e1, e1, t, i, n, a, r, s, o, l), this.image = u, this.isCubeDepthTexture = !0, this.isCubeTexture = !0;
    }
    get images() {
        return this.image;
    }
    set images(e1) {
        this.image = e1;
    }
}
class $785da19a645c07eb$var$bG extends $785da19a645c07eb$var$Vj {
    constructor(e1 = null){
        super(), this.sourceTexture = e1, this.isExternalTexture = !0;
    }
    copy(e1) {
        return super.copy(e1), this.sourceTexture = e1.sourceTexture, this;
    }
}
class $785da19a645c07eb$var$wG extends $785da19a645c07eb$var$kq {
    constructor(e1 = 1, t = 1, i = 1, n = 1, a = 1, r = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: e1,
            height: t,
            depth: i,
            widthSegments: n,
            heightSegments: a,
            depthSegments: r
        };
        const s = this;
        n = Math.floor(n), a = Math.floor(a), r = Math.floor(r);
        const o = [], l = [], c = [], u = [];
        let h = 0, d = 0;
        function p(e1, t, i, n, a, r, p, m, g, f, A) {
            const _ = r / g, v = p / f, y = r / 2, x = p / 2, b = m / 2, w = g + 1, E = f + 1;
            let k = 0, S = 0;
            const M = new $785da19a645c07eb$var$Ej;
            for(let r = 0; r < E; r++){
                const s = r * v - x;
                for(let o = 0; o < w; o++){
                    const h = o * _ - y;
                    M[e1] = h * n, M[t] = s * a, M[i] = b, l.push(M.x, M.y, M.z), M[e1] = 0, M[t] = 0, M[i] = m > 0 ? 1 : -1, c.push(M.x, M.y, M.z), u.push(o / g), u.push(1 - r / f), k += 1;
                }
            }
            for(let e1 = 0; e1 < f; e1++)for(let t = 0; t < g; t++){
                const i = h + t + w * e1, n = h + t + w * (e1 + 1), a = h + (t + 1) + w * (e1 + 1), r = h + (t + 1) + w * e1;
                o.push(i, n, r), o.push(n, a, r), S += 6;
            }
            s.addGroup(d, S, A), d += S, h += k;
        }
        p("z", "y", "x", -1, -1, i, t, e1, r, a, 0), p("z", "y", "x", 1, -1, i, t, -e1, r, a, 1), p("x", "z", "y", 1, 1, e1, i, t, n, r, 2), p("x", "z", "y", 1, -1, e1, i, -t, n, r, 3), p("x", "y", "z", 1, -1, e1, t, i, n, a, 4), p("x", "y", "z", -1, -1, e1, t, -i, n, a, 5), this.setIndex(o), this.setAttribute("position", new $785da19a645c07eb$var$pq(l, 3)), this.setAttribute("normal", new $785da19a645c07eb$var$pq(c, 3)), this.setAttribute("uv", new $785da19a645c07eb$var$pq(u, 2));
    }
    copy(e1) {
        return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
    }
    static fromJSON(e1) {
        return new $785da19a645c07eb$var$wG(e1.width, e1.height, e1.depth, e1.widthSegments, e1.heightSegments, e1.depthSegments);
    }
}
class $785da19a645c07eb$var$EG extends $785da19a645c07eb$var$kq {
    constructor(e1 = 1, t = 1, i = 1, n = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: e1,
            height: t,
            widthSegments: i,
            heightSegments: n
        };
        const a = e1 / 2, r = t / 2, s = Math.floor(i), o = Math.floor(n), l = s + 1, c = o + 1, u = e1 / s, h = t / o, d = [], p = [], m = [], g = [];
        for(let e1 = 0; e1 < c; e1++){
            const t = e1 * h - r;
            for(let i = 0; i < l; i++){
                const n = i * u - a;
                p.push(n, -t, 0), m.push(0, 0, 1), g.push(i / s), g.push(1 - e1 / o);
            }
        }
        for(let e1 = 0; e1 < o; e1++)for(let t = 0; t < s; t++){
            const i = t + l * e1, n = t + l * (e1 + 1), a = t + 1 + l * (e1 + 1), r = t + 1 + l * e1;
            d.push(i, n, r), d.push(n, a, r);
        }
        this.setIndex(d), this.setAttribute("position", new $785da19a645c07eb$var$pq(p, 3)), this.setAttribute("normal", new $785da19a645c07eb$var$pq(m, 3)), this.setAttribute("uv", new $785da19a645c07eb$var$pq(g, 2));
    }
    copy(e1) {
        return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
    }
    static fromJSON(e1) {
        return new $785da19a645c07eb$var$EG(e1.width, e1.height, e1.widthSegments, e1.heightSegments);
    }
}
class $785da19a645c07eb$var$kG extends $785da19a645c07eb$var$kq {
    constructor(e1 = 1, t = 32, i = 16, n = 0, a = 2 * Math.PI, r = 0, s = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: e1,
            widthSegments: t,
            heightSegments: i,
            phiStart: n,
            phiLength: a,
            thetaStart: r,
            thetaLength: s
        }, t = Math.max(3, Math.floor(t)), i = Math.max(2, Math.floor(i));
        const o = Math.min(r + s, Math.PI);
        let l = 0;
        const c = [], u = new $785da19a645c07eb$var$Ej, h = new $785da19a645c07eb$var$Ej, d = [], p = [], m = [], g = [];
        for(let d = 0; d <= i; d++){
            const f = [], A = d / i, _ = r + A * s, v = e1 * Math.cos(_), y = Math.sqrt(e1 * e1 - v * v);
            let x = 0;
            0 === d && 0 === r ? x = .5 / t : d === i && o === Math.PI && (x = -0.5 / t);
            for(let e1 = 0; e1 <= t; e1++){
                const i = e1 / t, r = n + i * a;
                u.x = -y * Math.cos(r), u.y = v, u.z = y * Math.sin(r), p.push(u.x, u.y, u.z), h.copy(u).normalize(), m.push(h.x, h.y, h.z), g.push(i + x, 1 - A), f.push(l++);
            }
            c.push(f);
        }
        for(let e1 = 0; e1 < i; e1++)for(let n = 0; n < t; n++){
            const t = c[e1][n + 1], a = c[e1][n], s = c[e1 + 1][n], l = c[e1 + 1][n + 1];
            (0 !== e1 || r > 0) && d.push(t, a, l), (e1 !== i - 1 || o < Math.PI) && d.push(a, s, l);
        }
        this.setIndex(d), this.setAttribute("position", new $785da19a645c07eb$var$pq(p, 3)), this.setAttribute("normal", new $785da19a645c07eb$var$pq(m, 3)), this.setAttribute("uv", new $785da19a645c07eb$var$pq(g, 2));
    }
    copy(e1) {
        return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
    }
    static fromJSON(e1) {
        return new $785da19a645c07eb$var$kG(e1.radius, e1.widthSegments, e1.heightSegments, e1.phiStart, e1.phiLength, e1.thetaStart, e1.thetaLength);
    }
}
class $785da19a645c07eb$var$SG extends $785da19a645c07eb$var$kq {
    constructor(e1 = null){
        if (super(), this.type = "WireframeGeometry", this.parameters = {
            geometry: e1
        }, null !== e1) {
            const t = [], i = new Set, n = new $785da19a645c07eb$var$Ej, a = new $785da19a645c07eb$var$Ej;
            if (null !== e1.index) {
                const r = e1.attributes.position, s = e1.index;
                let o = e1.groups;
                0 === o.length && (o = [
                    {
                        start: 0,
                        count: s.count,
                        materialIndex: 0
                    }
                ]);
                for(let e1 = 0, l = o.length; e1 < l; ++e1){
                    const l = o[e1], c = l.start;
                    for(let e1 = c, o = c + l.count; e1 < o; e1 += 3)for(let o = 0; o < 3; o++){
                        const l = s.getX(e1 + o), c = s.getX(e1 + (o + 1) % 3);
                        n.fromBufferAttribute(r, l), a.fromBufferAttribute(r, c), !0 === $785da19a645c07eb$var$MG(n, a, i) && (t.push(n.x, n.y, n.z), t.push(a.x, a.y, a.z));
                    }
                }
            } else {
                const r = e1.attributes.position;
                for(let e1 = 0, s = r.count / 3; e1 < s; e1++)for(let s = 0; s < 3; s++){
                    const o = 3 * e1 + s, l = 3 * e1 + (s + 1) % 3;
                    n.fromBufferAttribute(r, o), a.fromBufferAttribute(r, l), !0 === $785da19a645c07eb$var$MG(n, a, i) && (t.push(n.x, n.y, n.z), t.push(a.x, a.y, a.z));
                }
            }
            this.setAttribute("position", new $785da19a645c07eb$var$pq(t, 3));
        }
    }
    copy(e1) {
        return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
    }
}
function $785da19a645c07eb$var$MG(e1, t, i) {
    const n = `${e1.x},${e1.y},${e1.z}-${t.x},${t.y},${t.z}`, a = `${t.x},${t.y},${t.z}-${e1.x},${e1.y},${e1.z}`;
    return !0 !== i.has(n) && !0 !== i.has(a) && (i.add(n), i.add(a), !0);
}
function $785da19a645c07eb$var$CG(e1) {
    const t = {};
    for(const i in e1){
        t[i] = {};
        for(const n in e1[i]){
            const a = e1[i][n];
            if ($785da19a645c07eb$var$DG(a)) a.isRenderTargetTexture ? ($785da19a645c07eb$var$sj("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[i][n] = null) : t[i][n] = a.clone();
            else if (Array.isArray(a)) {
                if ($785da19a645c07eb$var$DG(a[0])) {
                    const e1 = [];
                    for(let t = 0, i = a.length; t < i; t++)e1[t] = a[t].clone();
                    t[i][n] = e1;
                } else t[i][n] = a.slice();
            } else t[i][n] = a;
        }
    }
    return t;
}
function $785da19a645c07eb$var$TG(e1) {
    const t = {};
    for(let i = 0; i < e1.length; i++){
        const n = $785da19a645c07eb$var$CG(e1[i]);
        for(const e1 in n)t[e1] = n[e1];
    }
    return t;
}
function $785da19a645c07eb$var$DG(e1) {
    return e1 && (e1.isColor || e1.isMatrix3 || e1.isMatrix4 || e1.isVector2 || e1.isVector3 || e1.isVector4 || e1.isTexture || e1.isQuaternion);
}
function $785da19a645c07eb$var$PG(e1) {
    const t = e1.getRenderTarget();
    return null === t ? e1.outputColorSpace : !0 === t.isXRRenderTarget ? t.texture.colorSpace : $785da19a645c07eb$var$Ij.workingColorSpace;
}
const $785da19a645c07eb$var$IG = {
    clone: $785da19a645c07eb$var$CG,
    merge: $785da19a645c07eb$var$TG
};
class $785da19a645c07eb$var$FG extends $785da19a645c07eb$var$Mq {
    constructor(e1){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
            clipCullDistance: !1,
            multiDraw: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv1: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== e1 && this.setValues(e1);
    }
    copy(e1) {
        return super.copy(e1), this.fragmentShader = e1.fragmentShader, this.vertexShader = e1.vertexShader, this.uniforms = $785da19a645c07eb$var$CG(e1.uniforms), this.uniformsGroups = function(e1) {
            const t = [];
            for(let i = 0; i < e1.length; i++)t.push(e1[i].clone());
            return t;
        }(e1.uniformsGroups), this.defines = Object.assign({}, e1.defines), this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.fog = e1.fog, this.lights = e1.lights, this.clipping = e1.clipping, this.extensions = Object.assign({}, e1.extensions), this.glslVersion = e1.glslVersion, this.defaultAttributeValues = Object.assign({}, e1.defaultAttributeValues), this.index0AttributeName = e1.index0AttributeName, this.uniformsNeedUpdate = e1.uniformsNeedUpdate, this;
    }
    toJSON(e1) {
        const t = super.toJSON(e1);
        t.glslVersion = this.glslVersion, t.uniforms = {};
        for(const i in this.uniforms){
            const n = this.uniforms[i].value;
            n && n.isTexture ? t.uniforms[i] = {
                type: "t",
                value: n.toJSON(e1).uuid
            } : n && n.isColor ? t.uniforms[i] = {
                type: "c",
                value: n.getHex()
            } : n && n.isVector2 ? t.uniforms[i] = {
                type: "v2",
                value: n.toArray()
            } : n && n.isVector3 ? t.uniforms[i] = {
                type: "v3",
                value: n.toArray()
            } : n && n.isVector4 ? t.uniforms[i] = {
                type: "v4",
                value: n.toArray()
            } : n && n.isMatrix3 ? t.uniforms[i] = {
                type: "m3",
                value: n.toArray()
            } : n && n.isMatrix4 ? t.uniforms[i] = {
                type: "m4",
                value: n.toArray()
            } : t.uniforms[i] = {
                value: n
            };
        }
        Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
        const i = {};
        for(const e1 in this.extensions)!0 === this.extensions[e1] && (i[e1] = !0);
        return Object.keys(i).length > 0 && (t.extensions = i), t;
    }
    fromJSON(e1, t) {
        if (super.fromJSON(e1, t), void 0 !== e1.uniforms) for(const i in e1.uniforms){
            const n = e1.uniforms[i];
            switch(this.uniforms[i] = {}, n.type){
                case "t":
                    this.uniforms[i].value = t[n.value] || null;
                    break;
                case "c":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$TV).setHex(n.value);
                    break;
                case "v2":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$bj).fromArray(n.value);
                    break;
                case "v3":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$Ej).fromArray(n.value);
                    break;
                case "v4":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$qj).fromArray(n.value);
                    break;
                case "m3":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$Mj).fromArray(n.value);
                    break;
                case "m4":
                    this.uniforms[i].value = (new $785da19a645c07eb$var$Kj).fromArray(n.value);
                    break;
                default:
                    this.uniforms[i].value = n.value;
            }
        }
        if (void 0 !== e1.defines && (this.defines = e1.defines), void 0 !== e1.vertexShader && (this.vertexShader = e1.vertexShader), void 0 !== e1.fragmentShader && (this.fragmentShader = e1.fragmentShader), void 0 !== e1.glslVersion && (this.glslVersion = e1.glslVersion), void 0 !== e1.extensions) for(const t in e1.extensions)this.extensions[t] = e1.extensions[t];
        return void 0 !== e1.lights && (this.lights = e1.lights), void 0 !== e1.clipping && (this.clipping = e1.clipping), this;
    }
}
class $785da19a645c07eb$var$zG extends $785da19a645c07eb$var$FG {
    constructor(e1){
        super(e1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
    }
}
class $785da19a645c07eb$var$RG extends $785da19a645c07eb$var$Mq {
    constructor(e1){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e1);
    }
    copy(e1) {
        return super.copy(e1), this.depthPacking = e1.depthPacking, this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this;
    }
}
class $785da19a645c07eb$var$LG extends $785da19a645c07eb$var$Mq {
    constructor(e1){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e1);
    }
    copy(e1) {
        return super.copy(e1), this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this;
    }
}
const $785da19a645c07eb$var$BG = {
    enabled: !1,
    files: {},
    add: function(e1, t) {
        !1 !== this.enabled && ($785da19a645c07eb$var$OG(e1) || (this.files[e1] = t));
    },
    get: function(e1) {
        if (!1 !== this.enabled && !$785da19a645c07eb$var$OG(e1)) return this.files[e1];
    },
    remove: function(e1) {
        delete this.files[e1];
    },
    clear: function() {
        this.files = {};
    }
};
function $785da19a645c07eb$var$OG(e1) {
    try {
        const t = e1.slice(e1.indexOf(":") + 1);
        return "blob:" === new URL(t).protocol;
    } catch (e1) {
        return !1;
    }
}
class $785da19a645c07eb$var$UG {
    constructor(e1, t, i){
        const n = this;
        let a, r = !1, s = 0, o = 0;
        const l = [];
        this.onStart = void 0, this.onLoad = e1, this.onProgress = t, this.onError = i, this._abortController = null, this.itemStart = function(e1) {
            o++, !1 === r && void 0 !== n.onStart && n.onStart(e1, s, o), r = !0;
        }, this.itemEnd = function(e1) {
            s++, void 0 !== n.onProgress && n.onProgress(e1, s, o), s === o && (r = !1, void 0 !== n.onLoad && n.onLoad());
        }, this.itemError = function(e1) {
            void 0 !== n.onError && n.onError(e1);
        }, this.resolveURL = function(e1) {
            return e1 = e1.normalize("NFC"), a ? a(e1) : e1;
        }, this.setURLModifier = function(e1) {
            return a = e1, this;
        }, this.addHandler = function(e1, t) {
            return l.push(e1, t), this;
        }, this.removeHandler = function(e1) {
            const t = l.indexOf(e1);
            return -1 !== t && l.splice(t, 2), this;
        }, this.getHandler = function(e1) {
            for(let t = 0, i = l.length; t < i; t += 2){
                const i = l[t], n = l[t + 1];
                if (i.global && (i.lastIndex = 0), i.test(e1)) return n;
            }
            return null;
        }, this.abort = function() {
            return this.abortController.abort(), this._abortController = null, this;
        };
    }
    get abortController() {
        return this._abortController || (this._abortController = new AbortController), this._abortController;
    }
}
const $785da19a645c07eb$var$NG = new $785da19a645c07eb$var$UG;
let $785da19a645c07eb$var$jG = class {
    constructor(e1){
        this.manager = void 0 !== e1 ? e1 : $785da19a645c07eb$var$NG, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {}, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    load() {}
    loadAsync(e1, t) {
        const i = this;
        return new Promise(function(n, a) {
            i.load(e1, n, t, a);
        });
    }
    parse() {}
    setCrossOrigin(e1) {
        return this.crossOrigin = e1, this;
    }
    setWithCredentials(e1) {
        return this.withCredentials = e1, this;
    }
    setPath(e1) {
        return this.path = e1, this;
    }
    setResourcePath(e1) {
        return this.resourcePath = e1, this;
    }
    setRequestHeader(e1) {
        return this.requestHeader = e1, this;
    }
    abort() {
        return this;
    }
};
$785da19a645c07eb$var$jG.DEFAULT_MATERIAL_NAME = "__DEFAULT";
const $785da19a645c07eb$var$VG = {};
class $785da19a645c07eb$var$qG extends Error {
    constructor(e1, t){
        super(e1), this.response = t;
    }
}
class $785da19a645c07eb$var$GG extends $785da19a645c07eb$var$jG {
    constructor(e1){
        super(e1), this.mimeType = "", this.responseType = "", this._abortController = new AbortController;
    }
    load(e1, t, i, n) {
        void 0 === e1 && (e1 = ""), void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
        const a = $785da19a645c07eb$var$BG.get(`file:${e1}`);
        if (void 0 !== a) return this.manager.itemStart(e1), void setTimeout(()=>{
            t && t(a), this.manager.itemEnd(e1);
        }, 0);
        if (void 0 !== $785da19a645c07eb$var$VG[e1]) return void $785da19a645c07eb$var$VG[e1].push({
            onLoad: t,
            onProgress: i,
            onError: n
        });
        $785da19a645c07eb$var$VG[e1] = [], $785da19a645c07eb$var$VG[e1].push({
            onLoad: t,
            onProgress: i,
            onError: n
        });
        const r = new Request(e1, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin",
            signal: "function" == typeof AbortSignal.any ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        }), s = this.mimeType, o = this.responseType;
        fetch(r).then((t)=>{
            if (200 === t.status || 0 === t.status) {
                if (0 === t.status && $785da19a645c07eb$var$sj("FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === t.body || void 0 === t.body.getReader) return t;
                const i = $785da19a645c07eb$var$VG[e1], n = t.body.getReader(), a = t.headers.get("X-File-Size") || t.headers.get("Content-Length"), r = a ? parseInt(a) : 0, s = 0 !== r;
                let o = 0;
                const l = new ReadableStream({
                    start (e1) {
                        !function t() {
                            n.read().then(({ done: n, value: a })=>{
                                if (n) e1.close();
                                else {
                                    o += a.byteLength;
                                    const n = new ProgressEvent("progress", {
                                        lengthComputable: s,
                                        loaded: o,
                                        total: r
                                    });
                                    for(let e1 = 0, t = i.length; e1 < t; e1++){
                                        const t = i[e1];
                                        t.onProgress && t.onProgress(n);
                                    }
                                    e1.enqueue(a), t();
                                }
                            }, (t)=>{
                                e1.error(t);
                            });
                        }();
                    }
                });
                return new Response(l);
            }
            throw new $785da19a645c07eb$var$qG(`fetch for "${t.url}" responded with ${t.status}: ${t.statusText}`, t);
        }).then((e1)=>{
            switch(o){
                case "arraybuffer":
                    return e1.arrayBuffer();
                case "blob":
                    return e1.blob();
                case "document":
                    return e1.text().then((e1)=>(new DOMParser).parseFromString(e1, s));
                case "json":
                    return e1.json();
                default:
                    if ("" === s) return e1.text();
                    {
                        const t = /charset="?([^;"\s]*)"?/i.exec(s), i = t && t[1] ? t[1].toLowerCase() : void 0, n = new TextDecoder(i);
                        return e1.arrayBuffer().then((e1)=>n.decode(e1));
                    }
            }
        }).then((t)=>{
            $785da19a645c07eb$var$BG.add(`file:${e1}`, t);
            const i = $785da19a645c07eb$var$VG[e1];
            delete $785da19a645c07eb$var$VG[e1];
            for(let e1 = 0, n = i.length; e1 < n; e1++){
                const n = i[e1];
                n.onLoad && n.onLoad(t);
            }
        }).catch((t)=>{
            const i = $785da19a645c07eb$var$VG[e1];
            if (void 0 === i) throw this.manager.itemError(e1), t;
            delete $785da19a645c07eb$var$VG[e1];
            for(let e1 = 0, n = i.length; e1 < n; e1++){
                const n = i[e1];
                n.onError && n.onError(t);
            }
            this.manager.itemError(e1);
        }).finally(()=>{
            this.manager.itemEnd(e1);
        }), this.manager.itemStart(e1);
    }
    setResponseType(e1) {
        return this.responseType = e1, this;
    }
    setMimeType(e1) {
        return this.mimeType = e1, this;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
}
const $785da19a645c07eb$var$HG = new WeakMap;
class $785da19a645c07eb$var$WG extends $785da19a645c07eb$var$jG {
    constructor(e1){
        super(e1);
    }
    load(e1, t, i, n) {
        void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
        const a = this, r = $785da19a645c07eb$var$BG.get(`image:${e1}`);
        if (void 0 !== r) {
            if (!0 === r.complete) a.manager.itemStart(e1), setTimeout(function() {
                t && t(r), a.manager.itemEnd(e1);
            }, 0);
            else {
                let e1 = $785da19a645c07eb$var$HG.get(r);
                void 0 === e1 && (e1 = [], $785da19a645c07eb$var$HG.set(r, e1)), e1.push({
                    onLoad: t,
                    onError: n
                });
            }
            return r;
        }
        const s = $785da19a645c07eb$var$tj("img");
        function o() {
            c(), t && t(this);
            const i = $785da19a645c07eb$var$HG.get(this) || [];
            for(let e1 = 0; e1 < i.length; e1++){
                const t = i[e1];
                t.onLoad && t.onLoad(this);
            }
            $785da19a645c07eb$var$HG.delete(this), a.manager.itemEnd(e1);
        }
        function l(t) {
            c(), n && n(t), $785da19a645c07eb$var$BG.remove(`image:${e1}`);
            const i = $785da19a645c07eb$var$HG.get(this) || [];
            for(let e1 = 0; e1 < i.length; e1++){
                const n = i[e1];
                n.onError && n.onError(t);
            }
            $785da19a645c07eb$var$HG.delete(this), a.manager.itemError(e1), a.manager.itemEnd(e1);
        }
        function c() {
            s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
        }
        return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), $785da19a645c07eb$var$BG.add(`image:${e1}`, s), a.manager.itemStart(e1), s.src = e1, s;
    }
}
const $785da19a645c07eb$var$ZG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$KG = new $785da19a645c07eb$var$wj, $785da19a645c07eb$var$XG = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$QG extends $785da19a645c07eb$var$xV {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new $785da19a645c07eb$var$Kj, this.projectionMatrix = new $785da19a645c07eb$var$Kj, this.projectionMatrixInverse = new $785da19a645c07eb$var$Kj, this.coordinateSystem = $785da19a645c07eb$var$$N, this._reversedDepth = !1;
    }
    get reversedDepth() {
        return this._reversedDepth;
    }
    copy(e1, t) {
        return super.copy(e1, t), this.matrixWorldInverse.copy(e1.matrixWorldInverse), this.projectionMatrix.copy(e1.projectionMatrix), this.projectionMatrixInverse.copy(e1.projectionMatrixInverse), this.coordinateSystem = e1.coordinateSystem, this;
    }
    getWorldDirection(e1) {
        return super.getWorldDirection(e1).negate();
    }
    updateMatrixWorld(e1) {
        super.updateMatrixWorld(e1), this.matrixWorld.decompose($785da19a645c07eb$var$ZG, $785da19a645c07eb$var$KG, $785da19a645c07eb$var$XG), 1 === $785da19a645c07eb$var$XG.x && 1 === $785da19a645c07eb$var$XG.y && 1 === $785da19a645c07eb$var$XG.z ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($785da19a645c07eb$var$ZG, $785da19a645c07eb$var$KG, $785da19a645c07eb$var$XG.set(1, 1, 1)).invert();
    }
    updateWorldMatrix(e1, t, i = !1) {
        super.updateWorldMatrix(e1, t, i), this.matrixWorld.decompose($785da19a645c07eb$var$ZG, $785da19a645c07eb$var$KG, $785da19a645c07eb$var$XG), 1 === $785da19a645c07eb$var$XG.x && 1 === $785da19a645c07eb$var$XG.y && 1 === $785da19a645c07eb$var$XG.z ? this.matrixWorldInverse.copy(this.matrixWorld).invert() : this.matrixWorldInverse.compose($785da19a645c07eb$var$ZG, $785da19a645c07eb$var$KG, $785da19a645c07eb$var$XG.set(1, 1, 1)).invert();
    }
    clone() {
        return (new this.constructor).copy(this);
    }
}
const $785da19a645c07eb$var$YG = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$JG = new $785da19a645c07eb$var$bj, $785da19a645c07eb$var$$G = new $785da19a645c07eb$var$bj;
class $785da19a645c07eb$var$eH extends $785da19a645c07eb$var$QG {
    constructor(e1 = 50, t = 1, i = .1, n = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e1, this.zoom = 1, this.near = i, this.far = n, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(e1, t) {
        return super.copy(e1, t), this.fov = e1.fov, this.zoom = e1.zoom, this.near = e1.near, this.far = e1.far, this.focus = e1.focus, this.aspect = e1.aspect, this.view = null === e1.view ? null : Object.assign({}, e1.view), this.filmGauge = e1.filmGauge, this.filmOffset = e1.filmOffset, this;
    }
    setFocalLength(e1) {
        const t = .5 * this.getFilmHeight() / e1;
        this.fov = 2 * $785da19a645c07eb$var$mj * Math.atan(t), this.updateProjectionMatrix();
    }
    getFocalLength() {
        const e1 = Math.tan(.5 * $785da19a645c07eb$var$pj * this.fov);
        return .5 * this.getFilmHeight() / e1;
    }
    getEffectiveFOV() {
        return 2 * $785da19a645c07eb$var$mj * Math.atan(Math.tan(.5 * $785da19a645c07eb$var$pj * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    getViewBounds(e1, t, i) {
        $785da19a645c07eb$var$YG.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), t.set($785da19a645c07eb$var$YG.x, $785da19a645c07eb$var$YG.y).multiplyScalar(-e1 / $785da19a645c07eb$var$YG.z), $785da19a645c07eb$var$YG.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), i.set($785da19a645c07eb$var$YG.x, $785da19a645c07eb$var$YG.y).multiplyScalar(-e1 / $785da19a645c07eb$var$YG.z);
    }
    getViewSize(e1, t) {
        return this.getViewBounds(e1, $785da19a645c07eb$var$JG, $785da19a645c07eb$var$$G), t.subVectors($785da19a645c07eb$var$$G, $785da19a645c07eb$var$JG);
    }
    setViewOffset(e1, t, i, n, a, r) {
        this.aspect = e1 / t, null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = a, this.view.height = r, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e1 = this.near;
        let t = e1 * Math.tan(.5 * $785da19a645c07eb$var$pj * this.fov) / this.zoom, i = 2 * t, n = this.aspect * i, a = -0.5 * n;
        const r = this.view;
        if (null !== this.view && this.view.enabled) {
            const e1 = r.fullWidth, s = r.fullHeight;
            a += r.offsetX * n / e1, t -= r.offsetY * i / s, n *= r.width / e1, i *= r.height / s;
        }
        const s = this.filmOffset;
        0 !== s && (a += e1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(a, a + n, t, t - i, e1, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e1) {
        const t = super.toJSON(e1);
        return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
    }
}
class $785da19a645c07eb$var$tH extends $785da19a645c07eb$var$QG {
    constructor(e1 = -1, t = 1, i = 1, n = -1, a = .1, r = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e1, this.right = t, this.top = i, this.bottom = n, this.near = a, this.far = r, this.updateProjectionMatrix();
    }
    copy(e1, t) {
        return super.copy(e1, t), this.left = e1.left, this.right = e1.right, this.top = e1.top, this.bottom = e1.bottom, this.near = e1.near, this.far = e1.far, this.zoom = e1.zoom, this.view = null === e1.view ? null : Object.assign({}, e1.view), this;
    }
    setViewOffset(e1, t, i, n, a, r) {
        null === this.view && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = i, this.view.offsetY = n, this.view.width = a, this.view.height = r, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const e1 = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), i = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
        let a = i - e1, r = i + e1, s = n + t, o = n - t;
        if (null !== this.view && this.view.enabled) {
            const e1 = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            a += e1 * this.view.offsetX, r = a + e1 * this.view.width, s -= t * this.view.offsetY, o = s - t * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(a, r, s, o, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e1) {
        const t = super.toJSON(e1);
        return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
    }
}
const $785da19a645c07eb$var$iH = -90;
class $785da19a645c07eb$var$nH extends $785da19a645c07eb$var$xV {
    constructor(e1, t, i){
        super(), this.type = "CubeCamera", this.renderTarget = i, this.coordinateSystem = null, this.activeMipmapLevel = 0;
        const n = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        n.layers = this.layers, this.add(n);
        const a = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        a.layers = this.layers, this.add(a);
        const r = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        r.layers = this.layers, this.add(r);
        const s = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        s.layers = this.layers, this.add(s);
        const o = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        o.layers = this.layers, this.add(o);
        const l = new $785da19a645c07eb$var$eH($785da19a645c07eb$var$iH, 1, e1, t);
        l.layers = this.layers, this.add(l);
    }
    updateCoordinateSystem() {
        const e1 = this.coordinateSystem, t = this.children.concat(), [i, n, a, r, s, o] = t;
        for (const e1 of t)this.remove(e1);
        if (e1 === $785da19a645c07eb$var$$N) i.up.set(0, 1, 0), i.lookAt(1, 0, 0), n.up.set(0, 1, 0), n.lookAt(-1, 0, 0), a.up.set(0, 0, -1), a.lookAt(0, 1, 0), r.up.set(0, 0, 1), r.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
        else {
            if (e1 !== $785da19a645c07eb$var$ej) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e1);
            i.up.set(0, -1, 0), i.lookAt(-1, 0, 0), n.up.set(0, -1, 0), n.lookAt(1, 0, 0), a.up.set(0, 0, 1), a.lookAt(0, 1, 0), r.up.set(0, 0, -1), r.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
        }
        for (const e1 of t)this.add(e1), e1.updateMatrixWorld();
    }
    update(e1, t) {
        null === this.parent && this.updateMatrixWorld();
        const { renderTarget: i, activeMipmapLevel: n } = this;
        this.coordinateSystem !== e1.coordinateSystem && (this.coordinateSystem = e1.coordinateSystem, this.updateCoordinateSystem());
        const [a, r, s, o, l, c] = this.children, u = e1.getRenderTarget(), h = e1.getActiveCubeFace(), d = e1.getActiveMipmapLevel(), p = e1.xr.enabled;
        e1.xr.enabled = !1;
        const m = i.texture.generateMipmaps;
        i.texture.generateMipmaps = !1;
        let g = !1;
        g = !0 === e1.isWebGLRenderer ? e1.state.buffers.depth.getReversed() : e1.reversedDepthBuffer, e1.setRenderTarget(i, 0, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, a), e1.setRenderTarget(i, 1, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, r), e1.setRenderTarget(i, 2, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, s), e1.setRenderTarget(i, 3, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, o), e1.setRenderTarget(i, 4, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, l), i.texture.generateMipmaps = m, e1.setRenderTarget(i, 5, n), g && !1 === e1.autoClear && e1.clearDepth(), e1.render(t, c), e1.setRenderTarget(u, h, d), e1.xr.enabled = p, i.texture.needsPMREMUpdate = !0;
    }
}
class $785da19a645c07eb$var$aH extends $785da19a645c07eb$var$eH {
    constructor(e1 = []){
        super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = e1;
    }
}
const $785da19a645c07eb$var$rH = new $785da19a645c07eb$var$Kj;
class $785da19a645c07eb$var$sH {
    constructor(e1, t, i = 0, n = 1 / 0){
        this.ray = new $785da19a645c07eb$var$Rq(e1, t), this.near = i, this.far = n, this.camera = null, this.layers = new $785da19a645c07eb$var$rV, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(e1, t) {
        this.ray.set(e1, t);
    }
    setFromCamera(e1, t) {
        t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e1.x, e1.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e1.x, e1.y, t.projectionMatrix.elements[14]).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : $785da19a645c07eb$var$oj("Raycaster: Unsupported camera type: " + t.type);
    }
    setFromXRController(e1) {
        return $785da19a645c07eb$var$rH.identity().extractRotation(e1.matrixWorld), this.ray.origin.setFromMatrixPosition(e1.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4($785da19a645c07eb$var$rH), this;
    }
    intersectObject(e1, t = !0, i = []) {
        return $785da19a645c07eb$var$lH(e1, this, i, t), i.sort($785da19a645c07eb$var$oH), i;
    }
    intersectObjects(e1, t = !0, i = []) {
        for(let n = 0, a = e1.length; n < a; n++)$785da19a645c07eb$var$lH(e1[n], this, i, t);
        return i.sort($785da19a645c07eb$var$oH), i;
    }
}
function $785da19a645c07eb$var$oH(e1, t) {
    return e1.distance - t.distance;
}
function $785da19a645c07eb$var$lH(e1, t, i, n) {
    let a = !0;
    if (e1.layers.test(t.layers)) !1 === e1.raycast(t, i) && (a = !1);
    if (!0 === a && !0 === n) {
        const n = e1.children;
        for(let e1 = 0, a = n.length; e1 < a; e1++)$785da19a645c07eb$var$lH(n[e1], t, i, !0);
    }
}
class $785da19a645c07eb$var$cH {
    static{
        $785da19a645c07eb$var$cH.prototype.isMatrix2 = !0;
    }
    constructor(e1, t, i, n){
        this.elements = [
            1,
            0,
            0,
            1
        ], void 0 !== e1 && this.set(e1, t, i, n);
    }
    identity() {
        return this.set(1, 0, 0, 1), this;
    }
    fromArray(e1, t = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = e1[i + t];
        return this;
    }
    set(e1, t, i, n) {
        const a = this.elements;
        return a[0] = e1, a[2] = t, a[1] = i, a[3] = n, this;
    }
}
function $785da19a645c07eb$var$uH(e1, t, i, n) {
    const a = function(e1) {
        switch(e1){
            case $785da19a645c07eb$var$LU:
            case $785da19a645c07eb$var$BU:
                return {
                    byteLength: 1,
                    components: 1
                };
            case $785da19a645c07eb$var$UU:
            case $785da19a645c07eb$var$OU:
            case $785da19a645c07eb$var$qU:
                return {
                    byteLength: 2,
                    components: 1
                };
            case $785da19a645c07eb$var$GU:
            case $785da19a645c07eb$var$HU:
                return {
                    byteLength: 2,
                    components: 4
                };
            case $785da19a645c07eb$var$jU:
            case $785da19a645c07eb$var$NU:
            case $785da19a645c07eb$var$VU:
                return {
                    byteLength: 4,
                    components: 1
                };
            case $785da19a645c07eb$var$ZU:
            case $785da19a645c07eb$var$KU:
                return {
                    byteLength: 4,
                    components: 3
                };
        }
        throw new Error(`THREE.TextureUtils: Unknown texture type ${e1}.`);
    }(n);
    switch(i){
        case 1021:
            return e1 * t;
        case 1028:
        case $785da19a645c07eb$var$JU:
            return e1 * t / a.components * a.byteLength;
        case $785da19a645c07eb$var$$U:
        case $785da19a645c07eb$var$eN:
            return e1 * t * 2 / a.components * a.byteLength;
        case 1022:
            return e1 * t * 3 / a.components * a.byteLength;
        case $785da19a645c07eb$var$XU:
        case $785da19a645c07eb$var$tN:
            return e1 * t * 4 / a.components * a.byteLength;
        case $785da19a645c07eb$var$iN:
        case $785da19a645c07eb$var$nN:
            return Math.floor((e1 + 3) / 4) * Math.floor((t + 3) / 4) * 8;
        case $785da19a645c07eb$var$aN:
        case $785da19a645c07eb$var$rN:
            return Math.floor((e1 + 3) / 4) * Math.floor((t + 3) / 4) * 16;
        case $785da19a645c07eb$var$oN:
        case $785da19a645c07eb$var$cN:
            return Math.max(e1, 16) * Math.max(t, 8) / 4;
        case $785da19a645c07eb$var$sN:
        case $785da19a645c07eb$var$lN:
            return Math.max(e1, 8) * Math.max(t, 8) / 2;
        case $785da19a645c07eb$var$uN:
        case $785da19a645c07eb$var$hN:
        case $785da19a645c07eb$var$pN:
        case $785da19a645c07eb$var$mN:
            return Math.floor((e1 + 3) / 4) * Math.floor((t + 3) / 4) * 8;
        case $785da19a645c07eb$var$dN:
        case $785da19a645c07eb$var$gN:
        case $785da19a645c07eb$var$fN:
        case $785da19a645c07eb$var$AN:
            return Math.floor((e1 + 3) / 4) * Math.floor((t + 3) / 4) * 16;
        case $785da19a645c07eb$var$_N:
            return Math.floor((e1 + 4) / 5) * Math.floor((t + 3) / 4) * 16;
        case $785da19a645c07eb$var$vN:
            return Math.floor((e1 + 4) / 5) * Math.floor((t + 4) / 5) * 16;
        case $785da19a645c07eb$var$yN:
            return Math.floor((e1 + 5) / 6) * Math.floor((t + 4) / 5) * 16;
        case $785da19a645c07eb$var$xN:
            return Math.floor((e1 + 5) / 6) * Math.floor((t + 5) / 6) * 16;
        case $785da19a645c07eb$var$bN:
            return Math.floor((e1 + 7) / 8) * Math.floor((t + 4) / 5) * 16;
        case $785da19a645c07eb$var$wN:
            return Math.floor((e1 + 7) / 8) * Math.floor((t + 5) / 6) * 16;
        case $785da19a645c07eb$var$EN:
            return Math.floor((e1 + 7) / 8) * Math.floor((t + 7) / 8) * 16;
        case $785da19a645c07eb$var$kN:
            return Math.floor((e1 + 9) / 10) * Math.floor((t + 4) / 5) * 16;
        case $785da19a645c07eb$var$SN:
            return Math.floor((e1 + 9) / 10) * Math.floor((t + 5) / 6) * 16;
        case $785da19a645c07eb$var$MN:
            return Math.floor((e1 + 9) / 10) * Math.floor((t + 7) / 8) * 16;
        case $785da19a645c07eb$var$CN:
            return Math.floor((e1 + 9) / 10) * Math.floor((t + 9) / 10) * 16;
        case $785da19a645c07eb$var$TN:
            return Math.floor((e1 + 11) / 12) * Math.floor((t + 9) / 10) * 16;
        case $785da19a645c07eb$var$DN:
            return Math.floor((e1 + 11) / 12) * Math.floor((t + 11) / 12) * 16;
        case $785da19a645c07eb$var$PN:
        case $785da19a645c07eb$var$IN:
        case $785da19a645c07eb$var$FN:
            return Math.ceil(e1 / 4) * Math.ceil(t / 4) * 16;
        case $785da19a645c07eb$var$zN:
        case $785da19a645c07eb$var$RN:
            return Math.ceil(e1 / 4) * Math.ceil(t / 4) * 8;
        case $785da19a645c07eb$var$LN:
        case $785da19a645c07eb$var$BN:
            return Math.ceil(e1 / 4) * Math.ceil(t / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${i} format.`);
}
/**
 * @license
 * Copyright 2010-2026 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ function $785da19a645c07eb$var$hH() {
    let e1 = null, t = !1, i = null, n = null;
    function a(t, r) {
        i(t, r), n = e1.requestAnimationFrame(a);
    }
    return {
        start: function() {
            !0 !== t && null !== i && null !== e1 && (n = e1.requestAnimationFrame(a), t = !0);
        },
        stop: function() {
            null !== e1 && e1.cancelAnimationFrame(n), t = !1;
        },
        setAnimationLoop: function(e1) {
            i = e1;
        },
        setContext: function(t) {
            e1 = t;
        }
    };
}
function $785da19a645c07eb$var$dH(e1) {
    const t = new WeakMap;
    return {
        get: function(e1) {
            return e1.isInterleavedBufferAttribute && (e1 = e1.data), t.get(e1);
        },
        remove: function(i) {
            i.isInterleavedBufferAttribute && (i = i.data);
            const n = t.get(i);
            n && (e1.deleteBuffer(n.buffer), t.delete(i));
        },
        update: function(i, n) {
            if (i.isInterleavedBufferAttribute && (i = i.data), i.isGLBufferAttribute) {
                const e1 = t.get(i);
                return void ((!e1 || e1.version < i.version) && t.set(i, {
                    buffer: i.buffer,
                    type: i.type,
                    bytesPerElement: i.elementSize,
                    version: i.version
                }));
            }
            const a = t.get(i);
            if (void 0 === a) t.set(i, function(t, i) {
                const n = t.array, a = t.usage, r = n.byteLength, s = e1.createBuffer();
                let o;
                if (e1.bindBuffer(i, s), e1.bufferData(i, n, a), t.onUploadCallback(), n instanceof Float32Array) o = e1.FLOAT;
                else if ("undefined" != typeof Float16Array && n instanceof Float16Array) o = e1.HALF_FLOAT;
                else if (n instanceof Uint16Array) o = t.isFloat16BufferAttribute ? e1.HALF_FLOAT : e1.UNSIGNED_SHORT;
                else if (n instanceof Int16Array) o = e1.SHORT;
                else if (n instanceof Uint32Array) o = e1.UNSIGNED_INT;
                else if (n instanceof Int32Array) o = e1.INT;
                else if (n instanceof Int8Array) o = e1.BYTE;
                else if (n instanceof Uint8Array) o = e1.UNSIGNED_BYTE;
                else {
                    if (!(n instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + n);
                    o = e1.UNSIGNED_BYTE;
                }
                return {
                    buffer: s,
                    type: o,
                    bytesPerElement: n.BYTES_PER_ELEMENT,
                    version: t.version,
                    size: r
                };
            }(i, n));
            else if (a.version < i.version) {
                if (a.size !== i.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
                !function(t, i, n) {
                    const a = i.array, r = i.updateRanges;
                    if (e1.bindBuffer(n, t), 0 === r.length) e1.bufferSubData(n, 0, a);
                    else {
                        r.sort((e1, t)=>e1.start - t.start);
                        let t = 0;
                        for(let e1 = 1; e1 < r.length; e1++){
                            const i = r[t], n = r[e1];
                            n.start <= i.start + i.count + 1 ? i.count = Math.max(i.count, n.start + n.count - i.start) : (++t, r[t] = n);
                        }
                        r.length = t + 1;
                        for(let t = 0, i = r.length; t < i; t++){
                            const i = r[t];
                            e1.bufferSubData(n, i.start * a.BYTES_PER_ELEMENT, a, i.start, i.count);
                        }
                        i.clearUpdateRanges();
                    }
                    i.onUploadCallback();
                }(a.buffer, i, n), a.version = i.version;
            }
        }
    };
}
"undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: $785da19a645c07eb$var$zO
    }
})), "undefined" != typeof window && (window.__THREE__ ? $785da19a645c07eb$var$sj("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = $785da19a645c07eb$var$zO);
const $785da19a645c07eb$var$pH = {
    alphahash_fragment: "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
    alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif",
    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    alphatest_fragment: "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif",
    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
    batching_pars_vertex: "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec4 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 );\n\t}\n#endif",
    batching_vertex: "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
    begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif",
    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
    bsdfs: "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
    iridescence_fragment: "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif",
    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
    color_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#endif",
    color_pars_fragment: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#endif",
    color_pars_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec4 vColor;\n#endif",
    color_vertex: "#if defined( USE_COLOR ) || defined( USE_COLOR_ALPHA ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec4( 1.0 );\n#endif\n#ifdef USE_COLOR_ALPHA\n\tvColor *= color;\n#elif defined( USE_COLOR )\n\tvColor.rgb *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.rgb *= instanceColor.rgb;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvColor *= getBatchingColor( getIndirectIndex( gl_DrawID ) );\n#endif",
    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\n#define inverseTransformDirection transformDirectionByInverseViewMatrix\nvec3 transformNormalByInverseViewMatrix( in vec3 normal, in mat4 viewMatrix ) {\n\treturn normalize( ( vec4( normal, 0.0 ) * viewMatrix ).xyz );\n}\nvec3 transformDirectionByInverseViewMatrix( in vec3 dir, in mat4 viewMatrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * viewMatrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n#endif",
    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
    colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * reflectVec );\n\t\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t\t#endif\n\t#endif\n#endif",
    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif",
    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
    envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = transformDirectionByInverseViewMatrix( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
    lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
    lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif\n#include <lightprobes_pars_fragment>",
    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
    lights_physical_pars_fragment: "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\treturn 0.5 / max( gv + gl, EPSILON );\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( material.specularF90 - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t\t#ifdef USE_CLEARCOAT\n\t\t\tvec3 Ncc = geometryClearcoatNormal;\n\t\t\tvec2 uvClearcoat = LTC_Uv( Ncc, viewDir, material.clearcoatRoughness );\n\t\t\tvec4 t1Clearcoat = texture2D( ltc_1, uvClearcoat );\n\t\t\tvec4 t2Clearcoat = texture2D( ltc_2, uvClearcoat );\n\t\t\tmat3 mInvClearcoat = mat3(\n\t\t\t\tvec3( t1Clearcoat.x, 0, t1Clearcoat.y ),\n\t\t\t\tvec3(             0, 1,             0 ),\n\t\t\t\tvec3( t1Clearcoat.z, 0, t1Clearcoat.w )\n\t\t\t);\n\t\t\tvec3 fresnelClearcoat = material.clearcoatF0 * t2Clearcoat.x + ( material.clearcoatF90 - material.clearcoatF0 ) * t2Clearcoat.y;\n\t\t\tclearcoatSpecularDirect += lightColor * fresnelClearcoat * LTC_Evaluate( Ncc, viewDir, position, mInvClearcoat, rectCoords );\n\t\t#endif\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
    lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#ifdef USE_LIGHT_PROBES_GRID\n\t\tvec3 probeWorldPos = ( ( vec4( geometryPosition, 1.0 ) - viewMatrix[ 3 ] ) * viewMatrix ).xyz;\n\t\tvec3 probeWorldNormal = transformNormalByInverseViewMatrix( geometryNormal, viewMatrix );\n\t\tirradiance += getLightProbeGridIrradiance( probeWorldPos, probeWorldNormal );\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\t#if defined( STANDARD ) || defined( LAMBERT ) || defined( PHONG )\n\t\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t\t#endif\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\t#if defined( LAMBERT ) || defined( PHONG )\n\t\tirradiance += iblIrradiance;\n\t#endif\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
    lightprobes_pars_fragment: "#ifdef USE_LIGHT_PROBES_GRID\nuniform highp sampler3D probesSH;\nuniform vec3 probesMin;\nuniform vec3 probesMax;\nuniform vec3 probesResolution;\nvec3 getLightProbeGridIrradiance( vec3 worldPos, vec3 worldNormal ) {\n\tvec3 res = probesResolution;\n\tvec3 gridRange = probesMax - probesMin;\n\tvec3 resMinusOne = res - 1.0;\n\tvec3 probeSpacing = gridRange / resMinusOne;\n\tvec3 samplePos = worldPos + worldNormal * probeSpacing * 0.5;\n\tvec3 uvw = clamp( ( samplePos - probesMin ) / gridRange, 0.0, 1.0 );\n\tuvw = uvw * resMinusOne / res + 0.5 / res;\n\tfloat nz          = res.z;\n\tfloat paddedSlices = nz + 2.0;\n\tfloat atlasDepth  = 7.0 * paddedSlices;\n\tfloat uvZBase     = uvw.z * nz + 1.0;\n\tvec4 s0 = texture( probesSH, vec3( uvw.xy, ( uvZBase                       ) / atlasDepth ) );\n\tvec4 s1 = texture( probesSH, vec3( uvw.xy, ( uvZBase +       paddedSlices   ) / atlasDepth ) );\n\tvec4 s2 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 2.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s3 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 3.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s4 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 4.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s5 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 5.0 * paddedSlices   ) / atlasDepth ) );\n\tvec4 s6 = texture( probesSH, vec3( uvw.xy, ( uvZBase + 6.0 * paddedSlices   ) / atlasDepth ) );\n\tvec3 c0 = s0.xyz;\n\tvec3 c1 = vec3( s0.w, s1.xy );\n\tvec3 c2 = vec3( s1.zw, s2.x );\n\tvec3 c3 = s2.yzw;\n\tvec3 c4 = s3.xyz;\n\tvec3 c5 = vec3( s3.w, s4.xy );\n\tvec3 c6 = vec3( s4.zw, s5.x );\n\tvec3 c7 = s5.yzw;\n\tvec3 c8 = s6.xyz;\n\tfloat x = worldNormal.x, y = worldNormal.y, z = worldNormal.z;\n\tvec3 result = c0 * 0.886227;\n\tresult += c1 * 2.0 * 0.511664 * y;\n\tresult += c2 * 2.0 * 0.511664 * z;\n\tresult += c3 * 2.0 * 0.511664 * x;\n\tresult += c4 * 2.0 * 0.429043 * x * y;\n\tresult += c5 * 2.0 * 0.429043 * y * z;\n\tresult += c6 * ( 0.743125 * z * z - 0.247708 );\n\tresult += c7 * 2.0 * 0.429043 * x * z;\n\tresult += c8 * 0.429043 * ( x * x - y * y );\n\treturn max( result, vec3( 0.0 ) );\n}\n#endif",
    logdepthbuf_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
    logdepthbuf_pars_fragment: "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_pars_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
    logdepthbuf_vertex: "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
    map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
    morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif",
    morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif",
    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
    normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#if defined( USE_PACKED_NORMALMAP )\n\t\tmapN = vec3( mapN.xy, sqrt( saturate( 1.0 - dot( mapN.xy, mapN.xy ) ) ) );\n\t#endif\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t\t#ifdef FLIP_SIDED\n\t\t\tvBitangent = - vBitangent;\n\t\t#endif\n\t#endif\n#endif",
    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
    iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
    opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\n\t\treturn depth * ( far - near ) - far;\n\t#else\n\t\treturn depth * ( near - far ) - near;\n\t#endif\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\t\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\treturn ( near * far ) / ( ( near - far ) * depth - near );\n\t#else\n\t\treturn ( near * far ) / ( ( far - near ) * depth - far );\n\t#endif\n}",
    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
    shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\t\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadowCoord.z -= shadowBias;\n\t\t\t#else\n\t\t\t\tshadowCoord.z += shadowBias;\n\t\t\t#endif\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tfloat dp = ( shadowCameraNear * ( shadowCameraFar - viewSpaceZ ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp -= shadowBias;\n\t\t\t#else\n\t\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\t\tdp += shadowBias;\n\t\t\t#endif\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * PI2;\n\t\t\tvec2 sample0 = vogelDiskSample( 0, 5, phi );\n\t\t\tvec2 sample1 = vogelDiskSample( 1, 5, phi );\n\t\t\tvec2 sample2 = vogelDiskSample( 2, 5, phi );\n\t\t\tvec2 sample3 = vogelDiskSample( 3, 5, phi );\n\t\t\tvec2 sample4 = vogelDiskSample( 4, 5, phi );\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample0.x + bitangent * sample0.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample1.x + bitangent * sample1.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample2.x + bitangent * sample2.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample3.x + bitangent * sample3.y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * sample4.x + bitangent * sample4.y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tdepth = 1.0 - depth;\n\t\t\t#endif\n\t\t\tshadow = step( dp, depth );\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif",
    shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
    shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\t#ifdef HAS_NORMAL\n\t\tvec3 shadowWorldNormal = transformNormalByInverseViewMatrix( transformedNormal, viewMatrix );\n\t#else\n\t\tvec3 shadowWorldNormal = vec3( 0.0 );\n\t#endif\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif",
    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = transformNormalByInverseViewMatrix( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
    uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
    uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
    background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vWorldDirection );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
    cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}",
    distance_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
    distance_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}",
    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}"
}, $785da19a645c07eb$var$mH = {
    common: {
        diffuse: {
            value: new $785da19a645c07eb$var$TV(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: new $785da19a645c07eb$var$Mj
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        },
        dfgLUT: {
            value: null
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        normalScale: {
            value: new $785da19a645c07eb$var$bj(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new $785da19a645c07eb$var$TV(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        },
        probesSH: {
            value: null
        },
        probesMin: {
            value: new $785da19a645c07eb$var$Ej
        },
        probesMax: {
            value: new $785da19a645c07eb$var$Ej
        },
        probesResolution: {
            value: new $785da19a645c07eb$var$Ej
        }
    },
    points: {
        diffuse: {
            value: new $785da19a645c07eb$var$TV(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new $785da19a645c07eb$var$Mj
        }
    },
    sprite: {
        diffuse: {
            value: new $785da19a645c07eb$var$TV(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new $785da19a645c07eb$var$bj(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: new $785da19a645c07eb$var$Mj
        },
        alphaTest: {
            value: 0
        }
    }
}, $785da19a645c07eb$var$gH = {
    basic: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.specularmap,
            $785da19a645c07eb$var$mH.envmap,
            $785da19a645c07eb$var$mH.aomap,
            $785da19a645c07eb$var$mH.lightmap,
            $785da19a645c07eb$var$mH.fog
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshbasic_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshbasic_frag
    },
    lambert: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.specularmap,
            $785da19a645c07eb$var$mH.envmap,
            $785da19a645c07eb$var$mH.aomap,
            $785da19a645c07eb$var$mH.lightmap,
            $785da19a645c07eb$var$mH.emissivemap,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            $785da19a645c07eb$var$mH.fog,
            $785da19a645c07eb$var$mH.lights,
            {
                emissive: {
                    value: new $785da19a645c07eb$var$TV(0)
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshlambert_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshlambert_frag
    },
    phong: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.specularmap,
            $785da19a645c07eb$var$mH.envmap,
            $785da19a645c07eb$var$mH.aomap,
            $785da19a645c07eb$var$mH.lightmap,
            $785da19a645c07eb$var$mH.emissivemap,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            $785da19a645c07eb$var$mH.fog,
            $785da19a645c07eb$var$mH.lights,
            {
                emissive: {
                    value: new $785da19a645c07eb$var$TV(0)
                },
                specular: {
                    value: new $785da19a645c07eb$var$TV(1118481)
                },
                shininess: {
                    value: 30
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshphong_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshphong_frag
    },
    standard: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.envmap,
            $785da19a645c07eb$var$mH.aomap,
            $785da19a645c07eb$var$mH.lightmap,
            $785da19a645c07eb$var$mH.emissivemap,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            $785da19a645c07eb$var$mH.roughnessmap,
            $785da19a645c07eb$var$mH.metalnessmap,
            $785da19a645c07eb$var$mH.fog,
            $785da19a645c07eb$var$mH.lights,
            {
                emissive: {
                    value: new $785da19a645c07eb$var$TV(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshphysical_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshphysical_frag
    },
    toon: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.aomap,
            $785da19a645c07eb$var$mH.lightmap,
            $785da19a645c07eb$var$mH.emissivemap,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            $785da19a645c07eb$var$mH.gradientmap,
            $785da19a645c07eb$var$mH.fog,
            $785da19a645c07eb$var$mH.lights,
            {
                emissive: {
                    value: new $785da19a645c07eb$var$TV(0)
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshtoon_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshtoon_frag
    },
    matcap: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            $785da19a645c07eb$var$mH.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshmatcap_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshmatcap_frag
    },
    points: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.points,
            $785da19a645c07eb$var$mH.fog
        ]),
        vertexShader: $785da19a645c07eb$var$pH.points_vert,
        fragmentShader: $785da19a645c07eb$var$pH.points_frag
    },
    dashed: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.linedashed_vert,
        fragmentShader: $785da19a645c07eb$var$pH.linedashed_frag
    },
    depth: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.displacementmap
        ]),
        vertexShader: $785da19a645c07eb$var$pH.depth_vert,
        fragmentShader: $785da19a645c07eb$var$pH.depth_frag
    },
    normal: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.bumpmap,
            $785da19a645c07eb$var$mH.normalmap,
            $785da19a645c07eb$var$mH.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.meshnormal_vert,
        fragmentShader: $785da19a645c07eb$var$pH.meshnormal_frag
    },
    sprite: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.sprite,
            $785da19a645c07eb$var$mH.fog
        ]),
        vertexShader: $785da19a645c07eb$var$pH.sprite_vert,
        fragmentShader: $785da19a645c07eb$var$pH.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $785da19a645c07eb$var$pH.background_vert,
        fragmentShader: $785da19a645c07eb$var$pH.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: new $785da19a645c07eb$var$Mj
            }
        },
        vertexShader: $785da19a645c07eb$var$pH.backgroundCube_vert,
        fragmentShader: $785da19a645c07eb$var$pH.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: $785da19a645c07eb$var$pH.cube_vert,
        fragmentShader: $785da19a645c07eb$var$pH.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $785da19a645c07eb$var$pH.equirect_vert,
        fragmentShader: $785da19a645c07eb$var$pH.equirect_frag
    },
    distance: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.common,
            $785da19a645c07eb$var$mH.displacementmap,
            {
                referencePosition: {
                    value: new $785da19a645c07eb$var$Ej
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.distance_vert,
        fragmentShader: $785da19a645c07eb$var$pH.distance_frag
    },
    shadow: {
        uniforms: $785da19a645c07eb$var$TG([
            $785da19a645c07eb$var$mH.lights,
            $785da19a645c07eb$var$mH.fog,
            {
                color: {
                    value: new $785da19a645c07eb$var$TV(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $785da19a645c07eb$var$pH.shadow_vert,
        fragmentShader: $785da19a645c07eb$var$pH.shadow_frag
    }
};
$785da19a645c07eb$var$gH.physical = {
    uniforms: $785da19a645c07eb$var$TG([
        $785da19a645c07eb$var$gH.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            clearcoatNormalScale: {
                value: new $785da19a645c07eb$var$bj(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new $785da19a645c07eb$var$TV(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            transmissionSamplerSize: {
                value: new $785da19a645c07eb$var$bj
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new $785da19a645c07eb$var$TV(0)
            },
            specularColor: {
                value: new $785da19a645c07eb$var$TV(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            },
            anisotropyVector: {
                value: new $785da19a645c07eb$var$bj
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: new $785da19a645c07eb$var$Mj
            }
        }
    ]),
    vertexShader: $785da19a645c07eb$var$pH.meshphysical_vert,
    fragmentShader: $785da19a645c07eb$var$pH.meshphysical_frag
};
const $785da19a645c07eb$var$fH = {
    r: 0,
    b: 0,
    g: 0
}, $785da19a645c07eb$var$AH = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$_H = new $785da19a645c07eb$var$Mj;
function $785da19a645c07eb$var$vH(e1, t, i, n, a, r) {
    const s = new $785da19a645c07eb$var$TV(0);
    let o, l, c = !0 === a ? 0 : 1, u = null, h = 0, d = null;
    function p(e1) {
        let i = !0 === e1.isScene ? e1.background : null;
        if (i && i.isTexture) {
            const n = e1.backgroundBlurriness > 0;
            i = t.get(i, n);
        }
        return i;
    }
    function m(t, n) {
        t.getRGB($785da19a645c07eb$var$fH, $785da19a645c07eb$var$PG(e1)), i.buffers.color.setClear($785da19a645c07eb$var$fH.r, $785da19a645c07eb$var$fH.g, $785da19a645c07eb$var$fH.b, n, r);
    }
    return {
        getClearColor: function() {
            return s;
        },
        setClearColor: function(e1, t = 1) {
            s.set(e1), c = t, m(s, c);
        },
        getClearAlpha: function() {
            return c;
        },
        setClearAlpha: function(e1) {
            c = e1, m(s, c);
        },
        render: function(t) {
            let n = !1;
            const a = p(t);
            null === a ? m(s, c) : a && a.isColor && (m(a, 1), n = !0);
            const o = e1.xr.getEnvironmentBlendMode();
            "additive" === o ? i.buffers.color.setClear(0, 0, 0, 1, r) : "alpha-blend" === o && i.buffers.color.setClear(0, 0, 0, 0, r), (e1.autoClear || n) && (i.buffers.depth.setTest(!0), i.buffers.depth.setMask(!0), i.buffers.color.setMask(!0), e1.clear(e1.autoClearColor, e1.autoClearDepth, e1.autoClearStencil));
        },
        addToRenderList: function(t, i) {
            const a = p(i);
            a && (a.isCubeTexture || a.mapping === $785da19a645c07eb$var$SU) ? (void 0 === l && (l = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$wG(1, 1, 1), new $785da19a645c07eb$var$FG({
                name: "BackgroundCubeMaterial",
                uniforms: $785da19a645c07eb$var$CG($785da19a645c07eb$var$gH.backgroundCube.uniforms),
                vertexShader: $785da19a645c07eb$var$gH.backgroundCube.vertexShader,
                fragmentShader: $785da19a645c07eb$var$gH.backgroundCube.fragmentShader,
                side: 1,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(e1, t, i) {
                this.matrixWorld.copyPosition(i.matrixWorld);
            }, Object.defineProperty(l.material, "envMap", {
                get: function() {
                    return this.uniforms.envMap.value;
                }
            }), n.update(l)), l.material.uniforms.envMap.value = a, l.material.uniforms.backgroundBlurriness.value = i.backgroundBlurriness, l.material.uniforms.backgroundIntensity.value = i.backgroundIntensity, l.material.uniforms.backgroundRotation.value.setFromMatrix4($785da19a645c07eb$var$AH.makeRotationFromEuler(i.backgroundRotation)).transpose(), a.isCubeTexture && !1 === a.isRenderTargetTexture && l.material.uniforms.backgroundRotation.value.premultiply($785da19a645c07eb$var$_H), l.material.toneMapped = $785da19a645c07eb$var$Ij.getTransfer(a.colorSpace) !== $785da19a645c07eb$var$VN, u === a && h === a.version && d === e1.toneMapping || (l.material.needsUpdate = !0, u = a, h = a.version, d = e1.toneMapping), l.layers.enableAll(), t.unshift(l, l.geometry, l.material, 0, 0, null)) : a && a.isTexture && (void 0 === o && (o = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$EG(2, 2), new $785da19a645c07eb$var$FG({
                name: "BackgroundMaterial",
                uniforms: $785da19a645c07eb$var$CG($785da19a645c07eb$var$gH.background.uniforms),
                vertexShader: $785da19a645c07eb$var$gH.background.vertexShader,
                fragmentShader: $785da19a645c07eb$var$gH.background.fragmentShader,
                side: 0,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
            })), o.geometry.deleteAttribute("normal"), Object.defineProperty(o.material, "map", {
                get: function() {
                    return this.uniforms.t2D.value;
                }
            }), n.update(o)), o.material.uniforms.t2D.value = a, o.material.uniforms.backgroundIntensity.value = i.backgroundIntensity, o.material.toneMapped = $785da19a645c07eb$var$Ij.getTransfer(a.colorSpace) !== $785da19a645c07eb$var$VN, !0 === a.matrixAutoUpdate && a.updateMatrix(), o.material.uniforms.uvTransform.value.copy(a.matrix), u === a && h === a.version && d === e1.toneMapping || (o.material.needsUpdate = !0, u = a, h = a.version, d = e1.toneMapping), o.layers.enableAll(), t.unshift(o, o.geometry, o.material, 0, 0, null));
        },
        dispose: function() {
            void 0 !== l && (l.geometry.dispose(), l.material.dispose(), l = void 0), void 0 !== o && (o.geometry.dispose(), o.material.dispose(), o = void 0);
        }
    };
}
function $785da19a645c07eb$var$yH(e1, t) {
    const i = e1.getParameter(e1.MAX_VERTEX_ATTRIBS), n = {}, a = c(null);
    let r = a, s = !1;
    function o(t) {
        return e1.bindVertexArray(t);
    }
    function l(t) {
        return e1.deleteVertexArray(t);
    }
    function c(e1) {
        const t = [], n = [], a = [];
        for(let e1 = 0; e1 < i; e1++)t[e1] = 0, n[e1] = 0, a[e1] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: t,
            enabledAttributes: n,
            attributeDivisors: a,
            object: e1,
            attributes: {},
            index: null
        };
    }
    function u() {
        const e1 = r.newAttributes;
        for(let t = 0, i = e1.length; t < i; t++)e1[t] = 0;
    }
    function h(e1) {
        d(e1, 0);
    }
    function d(t, i) {
        const n = r.newAttributes, a = r.enabledAttributes, s = r.attributeDivisors;
        n[t] = 1, 0 === a[t] && (e1.enableVertexAttribArray(t), a[t] = 1), s[t] !== i && (e1.vertexAttribDivisor(t, i), s[t] = i);
    }
    function p() {
        const t = r.newAttributes, i = r.enabledAttributes;
        for(let n = 0, a = i.length; n < a; n++)i[n] !== t[n] && (e1.disableVertexAttribArray(n), i[n] = 0);
    }
    function m(t, i, n, a, r, s, o) {
        !0 === o ? e1.vertexAttribIPointer(t, i, n, r, s) : e1.vertexAttribPointer(t, i, n, a, r, s);
    }
    function g() {
        f(), s = !0, r !== a && (r = a, o(r.object));
    }
    function f() {
        a.geometry = null, a.program = null, a.wireframe = !1;
    }
    return {
        setup: function(i, a, l, g, f) {
            let A = !1;
            const _ = function(t, i, a, r) {
                const s = !0 === r.wireframe;
                let o = n[i.id];
                void 0 === o && (o = {}, n[i.id] = o);
                const l = !0 === t.isInstancedMesh ? t.id : 0;
                let u = o[l];
                void 0 === u && (u = {}, o[l] = u);
                let h = u[a.id];
                void 0 === h && (h = {}, u[a.id] = h);
                let d = h[s];
                void 0 === d && (d = c(e1.createVertexArray()), h[s] = d);
                return d;
            }(i, g, l, a);
            r !== _ && (r = _, o(r.object)), A = function(e1, t, i, n) {
                const a = r.attributes, s = t.attributes;
                let o = 0;
                const l = i.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    const i = a[t];
                    let n = s[t];
                    if (void 0 === n && ("instanceMatrix" === t && e1.instanceMatrix && (n = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (n = e1.instanceColor)), void 0 === i) return !0;
                    if (i.attribute !== n) return !0;
                    if (n && i.data !== n.data) return !0;
                    o++;
                }
                return r.attributesNum !== o || r.index !== n;
            }(i, g, l, f), A && function(e1, t, i, n) {
                const a = {}, s = t.attributes;
                let o = 0;
                const l = i.getAttributes();
                for(const t in l)if (l[t].location >= 0) {
                    let i = s[t];
                    void 0 === i && ("instanceMatrix" === t && e1.instanceMatrix && (i = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (i = e1.instanceColor));
                    const n = {};
                    n.attribute = i, i && i.data && (n.data = i.data), a[t] = n, o++;
                }
                r.attributes = a, r.attributesNum = o, r.index = n;
            }(i, g, l, f), null !== f && t.update(f, e1.ELEMENT_ARRAY_BUFFER), (A || s) && (s = !1, function(i, n, a, r) {
                u();
                const s = r.attributes, o = a.getAttributes(), l = n.defaultAttributeValues;
                for(const n in o){
                    const a = o[n];
                    if (a.location >= 0) {
                        let o = s[n];
                        if (void 0 === o && ("instanceMatrix" === n && i.instanceMatrix && (o = i.instanceMatrix), "instanceColor" === n && i.instanceColor && (o = i.instanceColor)), void 0 !== o) {
                            const n = o.normalized, s = o.itemSize, l = t.get(o);
                            if (void 0 === l) continue;
                            const c = l.buffer, u = l.type, p = l.bytesPerElement, g = u === e1.INT || u === e1.UNSIGNED_INT || o.gpuType === $785da19a645c07eb$var$NU;
                            if (o.isInterleavedBufferAttribute) {
                                const t = o.data, l = t.stride, f = o.offset;
                                if (t.isInstancedInterleavedBuffer) {
                                    for(let e1 = 0; e1 < a.locationSize; e1++)d(a.location + e1, t.meshPerAttribute);
                                    !0 !== i.isInstancedMesh && void 0 === r._maxInstanceCount && (r._maxInstanceCount = t.meshPerAttribute * t.count);
                                } else for(let e1 = 0; e1 < a.locationSize; e1++)h(a.location + e1);
                                e1.bindBuffer(e1.ARRAY_BUFFER, c);
                                for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1, s / a.locationSize, u, n, l * p, (f + s / a.locationSize * e1) * p, g);
                            } else {
                                if (o.isInstancedBufferAttribute) {
                                    for(let e1 = 0; e1 < a.locationSize; e1++)d(a.location + e1, o.meshPerAttribute);
                                    !0 !== i.isInstancedMesh && void 0 === r._maxInstanceCount && (r._maxInstanceCount = o.meshPerAttribute * o.count);
                                } else for(let e1 = 0; e1 < a.locationSize; e1++)h(a.location + e1);
                                e1.bindBuffer(e1.ARRAY_BUFFER, c);
                                for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1, s / a.locationSize, u, n, s * p, s / a.locationSize * e1 * p, g);
                            }
                        } else if (void 0 !== l) {
                            const t = l[n];
                            if (void 0 !== t) switch(t.length){
                                case 2:
                                    e1.vertexAttrib2fv(a.location, t);
                                    break;
                                case 3:
                                    e1.vertexAttrib3fv(a.location, t);
                                    break;
                                case 4:
                                    e1.vertexAttrib4fv(a.location, t);
                                    break;
                                default:
                                    e1.vertexAttrib1fv(a.location, t);
                            }
                        }
                    }
                }
                p();
            }(i, a, l, g), null !== f && e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, t.get(f).buffer));
        },
        reset: g,
        resetDefaultState: f,
        dispose: function() {
            g();
            for(const e1 in n){
                const t = n[e1];
                for(const e1 in t){
                    const i = t[e1];
                    for(const e1 in i){
                        const t = i[e1];
                        for(const e1 in t)l(t[e1].object), delete t[e1];
                        delete i[e1];
                    }
                }
                delete n[e1];
            }
        },
        releaseStatesOfGeometry: function(e1) {
            if (void 0 === n[e1.id]) return;
            const t = n[e1.id];
            for(const e1 in t){
                const i = t[e1];
                for(const e1 in i){
                    const t = i[e1];
                    for(const e1 in t)l(t[e1].object), delete t[e1];
                    delete i[e1];
                }
            }
            delete n[e1.id];
        },
        releaseStatesOfObject: function(e1) {
            for(const t in n){
                const i = n[t], a = !0 === e1.isInstancedMesh ? e1.id : 0, r = i[a];
                if (void 0 !== r) {
                    for(const e1 in r){
                        const t = r[e1];
                        for(const e1 in t)l(t[e1].object), delete t[e1];
                        delete r[e1];
                    }
                    delete i[a], 0 === Object.keys(i).length && delete n[t];
                }
            }
        },
        releaseStatesOfProgram: function(e1) {
            for(const t in n){
                const i = n[t];
                for(const t in i){
                    const n = i[t];
                    if (void 0 === n[e1.id]) continue;
                    const a = n[e1.id];
                    for(const e1 in a)l(a[e1].object), delete a[e1];
                    delete n[e1.id];
                }
            }
        },
        initAttributes: u,
        enableAttribute: h,
        disableUnusedAttributes: p
    };
}
function $785da19a645c07eb$var$xH(e1, t, i) {
    let n;
    this.setMode = function(e1) {
        n = e1;
    }, this.render = function(t, a) {
        e1.drawArrays(n, t, a), i.update(a, n, 1);
    }, this.renderInstances = function(t, a, r) {
        0 !== r && (e1.drawArraysInstanced(n, t, a, r), i.update(a, n, r));
    }, this.renderMultiDraw = function(e1, a, r) {
        if (0 === r) return;
        t.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, e1, 0, a, 0, r);
        let s = 0;
        for(let e1 = 0; e1 < r; e1++)s += a[e1];
        i.update(s, n, 1);
    };
}
function $785da19a645c07eb$var$bH(e1, t, i, n) {
    let a;
    function r(t) {
        if ("highp" === t) {
            if (e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.HIGH_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.HIGH_FLOAT).precision > 0) return "highp";
            t = "mediump";
        }
        return "mediump" === t && e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.MEDIUM_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
    }
    let s = void 0 !== i.precision ? i.precision : "highp";
    const o = r(s);
    o !== s && ($785da19a645c07eb$var$sj("WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
    const l = !0 === i.logarithmicDepthBuffer, c = !0 === i.reversedDepthBuffer && t.has("EXT_clip_control");
    !0 === i.reversedDepthBuffer && !1 === c && $785da19a645c07eb$var$sj("WebGLRenderer: Unable to use reversed depth buffer due to missing EXT_clip_control extension. Fallback to default depth buffer.");
    return {
        isWebGL2: !0,
        getMaxAnisotropy: function() {
            if (void 0 !== a) return a;
            if (!0 === t.has("EXT_texture_filter_anisotropic")) {
                const i = t.get("EXT_texture_filter_anisotropic");
                a = e1.getParameter(i.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            } else a = 0;
            return a;
        },
        getMaxPrecision: r,
        textureFormatReadable: function(t) {
            return t === $785da19a645c07eb$var$XU || n.convert(t) === e1.getParameter(e1.IMPLEMENTATION_COLOR_READ_FORMAT);
        },
        textureTypeReadable: function(i) {
            const a = i === $785da19a645c07eb$var$qU && (t.has("EXT_color_buffer_half_float") || t.has("EXT_color_buffer_float"));
            return !(i !== $785da19a645c07eb$var$LU && n.convert(i) !== e1.getParameter(e1.IMPLEMENTATION_COLOR_READ_TYPE) && i !== $785da19a645c07eb$var$VU && !a);
        },
        precision: s,
        logarithmicDepthBuffer: l,
        reversedDepthBuffer: c,
        maxTextures: e1.getParameter(e1.MAX_TEXTURE_IMAGE_UNITS),
        maxVertexTextures: e1.getParameter(e1.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
        maxTextureSize: e1.getParameter(e1.MAX_TEXTURE_SIZE),
        maxCubemapSize: e1.getParameter(e1.MAX_CUBE_MAP_TEXTURE_SIZE),
        maxAttributes: e1.getParameter(e1.MAX_VERTEX_ATTRIBS),
        maxVertexUniforms: e1.getParameter(e1.MAX_VERTEX_UNIFORM_VECTORS),
        maxVaryings: e1.getParameter(e1.MAX_VARYING_VECTORS),
        maxFragmentUniforms: e1.getParameter(e1.MAX_FRAGMENT_UNIFORM_VECTORS),
        maxSamples: e1.getParameter(e1.MAX_SAMPLES),
        samples: e1.getParameter(e1.SAMPLES)
    };
}
function $785da19a645c07eb$var$wH(e1) {
    const t = this;
    let i = null, n = 0, a = !1, r = !1;
    const s = new $785da19a645c07eb$var$eG, o = new $785da19a645c07eb$var$Mj, l = {
        value: null,
        needsUpdate: !1
    };
    function c(e1, i, n, a) {
        const r = null !== e1 ? e1.length : 0;
        let c = null;
        if (0 !== r) {
            if (c = l.value, !0 !== a || null === c) {
                const t = n + 4 * r, a = i.matrixWorldInverse;
                o.getNormalMatrix(a), (null === c || c.length < t) && (c = new Float32Array(t));
                for(let t = 0, i = n; t !== r; ++t, i += 4)s.copy(e1[t]).applyMatrix4(a, o), s.normal.toArray(c, i), c[i + 3] = s.constant;
            }
            l.value = c, l.needsUpdate = !0;
        }
        return t.numPlanes = r, t.numIntersection = 0, c;
    }
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e1, t) {
        const i = 0 !== e1.length || t || 0 !== n || a;
        return a = t, n = e1.length, i;
    }, this.beginShadows = function() {
        r = !0, c(null);
    }, this.endShadows = function() {
        r = !1;
    }, this.setGlobalState = function(e1, t) {
        i = c(e1, t, 0);
    }, this.setState = function(s, o, u) {
        const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, m = e1.get(s);
        if (!a || null === h || 0 === h.length || r && !p) r ? c(null) : function() {
            l.value !== i && (l.value = i, l.needsUpdate = n > 0);
            t.numPlanes = n, t.numIntersection = 0;
        }();
        else {
            const e1 = r ? 0 : n, t = 4 * e1;
            let a = m.clippingState || null;
            l.value = a, a = c(h, o, t, u);
            for(let e1 = 0; e1 !== t; ++e1)a[e1] = i[e1];
            m.clippingState = a, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += e1;
        }
    };
}
$785da19a645c07eb$var$_H.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
const $785da19a645c07eb$var$EH = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], $785da19a645c07eb$var$kH = 20, $785da19a645c07eb$var$SH = new $785da19a645c07eb$var$tH, $785da19a645c07eb$var$MH = new $785da19a645c07eb$var$TV;
let $785da19a645c07eb$var$CH = null, $785da19a645c07eb$var$TH = 0, $785da19a645c07eb$var$DH = 0, $785da19a645c07eb$var$PH = !1;
const $785da19a645c07eb$var$IH = new $785da19a645c07eb$var$Ej;
class $785da19a645c07eb$var$FH {
    constructor(e1){
        this._renderer = e1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._sizeLods = [], this._sigmas = [], this._lodMeshes = [], this._backgroundBox = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._blurMaterial = null, this._ggxMaterial = null;
    }
    fromScene(e1, t = 0, i = .1, n = 100, a = {}) {
        const { size: r = 256, position: s = $785da19a645c07eb$var$IH } = a;
        $785da19a645c07eb$var$CH = this._renderer.getRenderTarget(), $785da19a645c07eb$var$TH = this._renderer.getActiveCubeFace(), $785da19a645c07eb$var$DH = this._renderer.getActiveMipmapLevel(), $785da19a645c07eb$var$PH = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(r);
        const o = this._allocateTargets();
        return o.depthBuffer = !0, this._sceneToCubeUV(e1, i, n, o, s), t > 0 && this._blur(o, 0, 0, t), this._applyPMREM(o), this._cleanup(o), o;
    }
    fromEquirectangular(e1, t = null) {
        return this._fromTexture(e1, t);
    }
    fromCubemap(e1, t = null) {
        return this._fromTexture(e1, t);
    }
    compileCubemapShader() {
        null === this._cubemapMaterial && (this._cubemapMaterial = $785da19a645c07eb$var$BH(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        null === this._equirectMaterial && (this._equirectMaterial = $785da19a645c07eb$var$LH(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose(), null !== this._backgroundBox && (this._backgroundBox.geometry.dispose(), this._backgroundBox.material.dispose());
    }
    _setSize(e1) {
        this._lodMax = Math.floor(Math.log2(e1)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._ggxMaterial && this._ggxMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
        for(let e1 = 0; e1 < this._lodMeshes.length; e1++)this._lodMeshes[e1].geometry.dispose();
    }
    _cleanup(e1) {
        this._renderer.setRenderTarget($785da19a645c07eb$var$CH, $785da19a645c07eb$var$TH, $785da19a645c07eb$var$DH), this._renderer.xr.enabled = $785da19a645c07eb$var$PH, e1.scissorTest = !1, $785da19a645c07eb$var$RH(e1, 0, 0, e1.width, e1.height);
    }
    _fromTexture(e1, t) {
        e1.mapping === $785da19a645c07eb$var$bU || e1.mapping === $785da19a645c07eb$var$wU ? this._setSize(0 === e1.image.length ? 16 : e1.image[0].width || e1.image[0].image.width) : this._setSize(e1.image.width / 4), $785da19a645c07eb$var$CH = this._renderer.getRenderTarget(), $785da19a645c07eb$var$TH = this._renderer.getActiveCubeFace(), $785da19a645c07eb$var$DH = this._renderer.getActiveMipmapLevel(), $785da19a645c07eb$var$PH = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
        const i = t || this._allocateTargets();
        return this._textureToCubeUV(e1, i), this._applyPMREM(i), this._cleanup(i), i;
    }
    _allocateTargets() {
        const e1 = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, i = {
            magFilter: $785da19a645c07eb$var$FU,
            minFilter: $785da19a645c07eb$var$FU,
            generateMipmaps: !1,
            type: $785da19a645c07eb$var$qU,
            format: $785da19a645c07eb$var$XU,
            colorSpace: $785da19a645c07eb$var$NN,
            depthBuffer: !1
        }, n = $785da19a645c07eb$var$zH(e1, t, i);
        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== e1 || this._pingPongRenderTarget.height !== t) {
            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = $785da19a645c07eb$var$zH(e1, t, i);
            const { _lodMax: n } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = function(e1) {
                const t = [], i = [], n = [];
                let a = e1;
                const r = e1 - 4 + 1 + $785da19a645c07eb$var$EH.length;
                for(let s = 0; s < r; s++){
                    const r = Math.pow(2, a);
                    t.push(r);
                    let o = 1 / r;
                    s > e1 - 4 ? o = $785da19a645c07eb$var$EH[s - e1 + 4 - 1] : 0 === s && (o = 0), i.push(o);
                    const l = 1 / (r - 2), c = -l, u = 1 + l, h = [
                        c,
                        c,
                        u,
                        c,
                        u,
                        u,
                        c,
                        c,
                        u,
                        u,
                        c,
                        u
                    ], d = 6, p = 6, m = 3, g = 2, f = 1, A = new Float32Array(m * p * d), _ = new Float32Array(g * p * d), v = new Float32Array(f * p * d);
                    for(let e1 = 0; e1 < d; e1++){
                        const t = e1 % 3 * 2 / 3 - 1, i = e1 > 2 ? 0 : -1, n = [
                            t,
                            i,
                            0,
                            t + 2 / 3,
                            i,
                            0,
                            t + 2 / 3,
                            i + 1,
                            0,
                            t,
                            i,
                            0,
                            t + 2 / 3,
                            i + 1,
                            0,
                            t,
                            i + 1,
                            0
                        ];
                        A.set(n, m * p * e1), _.set(h, g * p * e1);
                        const a = [
                            e1,
                            e1,
                            e1,
                            e1,
                            e1,
                            e1
                        ];
                        v.set(a, f * p * e1);
                    }
                    const y = new $785da19a645c07eb$var$kq;
                    y.setAttribute("position", new $785da19a645c07eb$var$uq(A, m)), y.setAttribute("uv", new $785da19a645c07eb$var$uq(_, g)), y.setAttribute("faceIndex", new $785da19a645c07eb$var$uq(v, f)), n.push(new $785da19a645c07eb$var$Kq(y, null)), a > 4 && a--;
                }
                return {
                    lodMeshes: n,
                    sizeLods: t,
                    sigmas: i
                };
            }(n)), this._blurMaterial = function(e1, t, i) {
                const n = new Float32Array($785da19a645c07eb$var$kH), a = new $785da19a645c07eb$var$Ej(0, 1, 0), r = new $785da19a645c07eb$var$FG({
                    name: "SphericalGaussianBlur",
                    defines: {
                        n: $785da19a645c07eb$var$kH,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / i,
                        CUBEUV_MAX_MIP: `${e1}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        samples: {
                            value: 1
                        },
                        weights: {
                            value: n
                        },
                        latitudinal: {
                            value: !1
                        },
                        dTheta: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        },
                        poleAxis: {
                            value: a
                        }
                    },
                    vertexShader: $785da19a645c07eb$var$OH(),
                    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                    blending: 0,
                    depthTest: !1,
                    depthWrite: !1
                });
                return r;
            }(n, e1, t), this._ggxMaterial = function(e1, t, i) {
                const n = new $785da19a645c07eb$var$FG({
                    name: "PMREMGGXConvolution",
                    defines: {
                        GGX_SAMPLES: 256,
                        CUBEUV_TEXEL_WIDTH: 1 / t,
                        CUBEUV_TEXEL_HEIGHT: 1 / i,
                        CUBEUV_MAX_MIP: `${e1}.0`
                    },
                    uniforms: {
                        envMap: {
                            value: null
                        },
                        roughness: {
                            value: 0
                        },
                        mipInt: {
                            value: 0
                        }
                    },
                    vertexShader: $785da19a645c07eb$var$OH(),
                    fragmentShader: '\n\n\t\t\tprecision highp float;\n\t\t\tprecision highp int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform float roughness;\n\t\t\tuniform float mipInt;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\t#define PI 3.14159265359\n\n\t\t\t// Van der Corput radical inverse\n\t\t\tfloat radicalInverse_VdC(uint bits) {\n\t\t\t\tbits = (bits << 16u) | (bits >> 16u);\n\t\t\t\tbits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);\n\t\t\t\tbits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);\n\t\t\t\tbits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);\n\t\t\t\tbits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);\n\t\t\t\treturn float(bits) * 2.3283064365386963e-10; // / 0x100000000\n\t\t\t}\n\n\t\t\t// Hammersley sequence\n\t\t\tvec2 hammersley(uint i, uint N) {\n\t\t\t\treturn vec2(float(i) / float(N), radicalInverse_VdC(i));\n\t\t\t}\n\n\t\t\t// GGX VNDF importance sampling (Eric Heitz 2018)\n\t\t\t// "Sampling the GGX Distribution of Visible Normals"\n\t\t\t// https://jcgt.org/published/0007/04/01/\n\t\t\tvec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {\n\t\t\t\tfloat alpha = roughness * roughness;\n\n\t\t\t\t// Section 4.1: Orthonormal basis\n\t\t\t\tvec3 T1 = vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 T2 = cross(V, T1);\n\n\t\t\t\t// Section 4.2: Parameterization of projected area\n\t\t\t\tfloat r = sqrt(Xi.x);\n\t\t\t\tfloat phi = 2.0 * PI * Xi.y;\n\t\t\t\tfloat t1 = r * cos(phi);\n\t\t\t\tfloat t2 = r * sin(phi);\n\t\t\t\tfloat s = 0.5 * (1.0 + V.z);\n\t\t\t\tt2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;\n\n\t\t\t\t// Section 4.3: Reprojection onto hemisphere\n\t\t\t\tvec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * V;\n\n\t\t\t\t// Section 3.4: Transform back to ellipsoid configuration\n\t\t\t\treturn normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));\n\t\t\t}\n\n\t\t\tvoid main() {\n\t\t\t\tvec3 N = normalize(vOutputDirection);\n\t\t\t\tvec3 V = N; // Assume view direction equals normal for pre-filtering\n\n\t\t\t\tvec3 prefilteredColor = vec3(0.0);\n\t\t\t\tfloat totalWeight = 0.0;\n\n\t\t\t\t// For very low roughness, just sample the environment directly\n\t\t\t\tif (roughness < 0.001) {\n\t\t\t\t\tgl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\t// Tangent space basis for VNDF sampling\n\t\t\t\tvec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);\n\t\t\t\tvec3 tangent = normalize(cross(up, N));\n\t\t\t\tvec3 bitangent = cross(N, tangent);\n\n\t\t\t\tfor(uint i = 0u; i < uint(GGX_SAMPLES); i++) {\n\t\t\t\t\tvec2 Xi = hammersley(i, uint(GGX_SAMPLES));\n\n\t\t\t\t\t// For PMREM, V = N, so in tangent space V is always (0, 0, 1)\n\t\t\t\t\tvec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);\n\n\t\t\t\t\t// Transform H back to world space\n\t\t\t\t\tvec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);\n\t\t\t\t\tvec3 L = normalize(2.0 * dot(V, H) * H - V);\n\n\t\t\t\t\tfloat NdotL = max(dot(N, L), 0.0);\n\n\t\t\t\t\tif(NdotL > 0.0) {\n\t\t\t\t\t\t// Sample environment at fixed mip level\n\t\t\t\t\t\t// VNDF importance sampling handles the distribution filtering\n\t\t\t\t\t\tvec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);\n\n\t\t\t\t\t\t// Weight by NdotL for the split-sum approximation\n\t\t\t\t\t\t// VNDF PDF naturally accounts for the visible microfacet distribution\n\t\t\t\t\t\tprefilteredColor += sampleColor * NdotL;\n\t\t\t\t\t\ttotalWeight += NdotL;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif (totalWeight > 0.0) {\n\t\t\t\t\tprefilteredColor = prefilteredColor / totalWeight;\n\t\t\t\t}\n\n\t\t\t\tgl_FragColor = vec4(prefilteredColor, 1.0);\n\t\t\t}\n\t\t',
                    blending: 0,
                    depthTest: !1,
                    depthWrite: !1
                });
                return n;
            }(n, e1, t);
        }
        return n;
    }
    _compileMaterial(e1) {
        const t = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$kq, e1);
        this._renderer.compile(t, $785da19a645c07eb$var$SH);
    }
    _sceneToCubeUV(e1, t, i, n, a) {
        const r = new $785da19a645c07eb$var$eH(90, 1, t, i), s = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], o = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], l = this._renderer, c = l.autoClear, u = l.toneMapping;
        l.getClearColor($785da19a645c07eb$var$MH), l.toneMapping = 0, l.autoClear = !1;
        l.state.buffers.depth.getReversed() && (l.setRenderTarget(n), l.clearDepth(), l.setRenderTarget(null)), null === this._backgroundBox && (this._backgroundBox = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$wG, new $785da19a645c07eb$var$Lq({
            name: "PMREM.Background",
            side: 1,
            depthWrite: !1,
            depthTest: !1
        })));
        const h = this._backgroundBox, d = h.material;
        let p = !1;
        const m = e1.background;
        m ? m.isColor && (d.color.copy(m), e1.background = null, p = !0) : (d.color.copy($785da19a645c07eb$var$MH), p = !0);
        for(let t = 0; t < 6; t++){
            const i = t % 3;
            0 === i ? (r.up.set(0, s[t], 0), r.position.set(a.x, a.y, a.z), r.lookAt(a.x + o[t], a.y, a.z)) : 1 === i ? (r.up.set(0, 0, s[t]), r.position.set(a.x, a.y, a.z), r.lookAt(a.x, a.y + o[t], a.z)) : (r.up.set(0, s[t], 0), r.position.set(a.x, a.y, a.z), r.lookAt(a.x, a.y, a.z + o[t]));
            const c = this._cubeSize;
            $785da19a645c07eb$var$RH(n, i * c, t > 2 ? c : 0, c, c), l.setRenderTarget(n), p && l.render(h, r), l.render(e1, r);
        }
        l.toneMapping = u, l.autoClear = c, e1.background = m;
    }
    _textureToCubeUV(e1, t) {
        const i = this._renderer, n = e1.mapping === $785da19a645c07eb$var$bU || e1.mapping === $785da19a645c07eb$var$wU;
        n ? (null === this._cubemapMaterial && (this._cubemapMaterial = $785da19a645c07eb$var$BH()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === e1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = $785da19a645c07eb$var$LH());
        const a = n ? this._cubemapMaterial : this._equirectMaterial, r = this._lodMeshes[0];
        r.material = a;
        a.uniforms.envMap.value = e1;
        const s = this._cubeSize;
        $785da19a645c07eb$var$RH(t, 0, 0, 3 * s, 2 * s), i.setRenderTarget(t), i.render(r, $785da19a645c07eb$var$SH);
    }
    _applyPMREM(e1) {
        const t = this._renderer, i = t.autoClear;
        t.autoClear = !1;
        const n = this._lodMeshes.length;
        for(let t = 1; t < n; t++)this._applyGGXFilter(e1, t - 1, t);
        t.autoClear = i;
    }
    _applyGGXFilter(e1, t, i) {
        const n = this._renderer, a = this._pingPongRenderTarget, r = this._ggxMaterial, s = this._lodMeshes[i];
        s.material = r;
        const o = r.uniforms, l = i / (this._lodMeshes.length - 1), c = t / (this._lodMeshes.length - 1), u = Math.sqrt(l * l - c * c) * (0 + 1.25 * l), { _lodMax: h } = this, d = this._sizeLods[i], p = 3 * d * (i > h - 4 ? i - h + 4 : 0), m = 4 * (this._cubeSize - d);
        o.envMap.value = e1.texture, o.roughness.value = u, o.mipInt.value = h - t, $785da19a645c07eb$var$RH(a, p, m, 3 * d, 2 * d), n.setRenderTarget(a), n.render(s, $785da19a645c07eb$var$SH), o.envMap.value = a.texture, o.roughness.value = 0, o.mipInt.value = h - i, $785da19a645c07eb$var$RH(e1, p, m, 3 * d, 2 * d), n.setRenderTarget(e1), n.render(s, $785da19a645c07eb$var$SH);
    }
    _blur(e1, t, i, n, a) {
        const r = this._pingPongRenderTarget;
        this._halfBlur(e1, r, t, i, n, "latitudinal", a), this._halfBlur(r, e1, i, i, n, "longitudinal", a);
    }
    _halfBlur(e1, t, i, n, a, r, s) {
        const o = this._renderer, l = this._blurMaterial;
        "latitudinal" !== r && "longitudinal" !== r && $785da19a645c07eb$var$oj("blur direction must be either latitudinal or longitudinal!");
        const c = this._lodMeshes[n];
        c.material = l;
        const u = l.uniforms, h = this._sizeLods[i] - 1, d = isFinite(a) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = a / d, m = isFinite(a) ? 1 + Math.floor(3 * p) : $785da19a645c07eb$var$kH;
        m > $785da19a645c07eb$var$kH && $785da19a645c07eb$var$sj(`sigmaRadians, ${a}, is too large and will clip, as it requested ${m} samples when the maximum is set to 20`);
        const g = [];
        let f = 0;
        for(let e1 = 0; e1 < $785da19a645c07eb$var$kH; ++e1){
            const t = e1 / p, i = Math.exp(-t * t / 2);
            g.push(i), 0 === e1 ? f += i : e1 < m && (f += 2 * i);
        }
        for(let e1 = 0; e1 < g.length; e1++)g[e1] = g[e1] / f;
        u.envMap.value = e1.texture, u.samples.value = m, u.weights.value = g, u.latitudinal.value = "latitudinal" === r, s && (u.poleAxis.value = s);
        const { _lodMax: A } = this;
        u.dTheta.value = d, u.mipInt.value = A - i;
        const _ = this._sizeLods[n];
        $785da19a645c07eb$var$RH(t, 3 * _ * (n > A - 4 ? n - A + 4 : 0), 4 * (this._cubeSize - _), 3 * _, 2 * _), o.setRenderTarget(t), o.render(c, $785da19a645c07eb$var$SH);
    }
}
function $785da19a645c07eb$var$zH(e1, t, i) {
    const n = new $785da19a645c07eb$var$Hj(e1, t, i);
    return n.texture.mapping = $785da19a645c07eb$var$SU, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function $785da19a645c07eb$var$RH(e1, t, i, n, a) {
    e1.viewport.set(t, i, n, a), e1.scissor.set(t, i, n, a);
}
function $785da19a645c07eb$var$LH() {
    return new $785da19a645c07eb$var$FG({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: $785da19a645c07eb$var$OH(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $785da19a645c07eb$var$BH() {
    return new $785da19a645c07eb$var$FG({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: $785da19a645c07eb$var$OH(),
        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
        blending: 0,
        depthTest: !1,
        depthWrite: !1
    });
}
function $785da19a645c07eb$var$OH() {
    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
}
class $785da19a645c07eb$var$UH extends $785da19a645c07eb$var$Hj {
    constructor(e1 = 1, t = {}){
        super(e1, e1, t), this.isWebGLCubeRenderTarget = !0;
        const i = {
            width: e1,
            height: e1,
            depth: 1
        }, n = [
            i,
            i,
            i,
            i,
            i,
            i
        ];
        this.texture = new $785da19a645c07eb$var$vG(n), this._setTextureOptions(t), this.texture.isRenderTargetTexture = !0;
    }
    fromEquirectangularTexture(e1, t) {
        this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
        const i = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
            fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
        }, n = new $785da19a645c07eb$var$wG(5, 5, 5), a = new $785da19a645c07eb$var$FG({
            name: "CubemapFromEquirect",
            uniforms: $785da19a645c07eb$var$CG(i.uniforms),
            vertexShader: i.vertexShader,
            fragmentShader: i.fragmentShader,
            side: 1,
            blending: 0
        });
        a.uniforms.tEquirect.value = t;
        const r = new $785da19a645c07eb$var$Kq(n, a), s = t.minFilter;
        t.minFilter === $785da19a645c07eb$var$RU && (t.minFilter = $785da19a645c07eb$var$FU);
        return new $785da19a645c07eb$var$nH(1, 10, this).update(e1, r), t.minFilter = s, r.geometry.dispose(), r.material.dispose(), this;
    }
    clear(e1, t = !0, i = !0, n = !0) {
        const a = e1.getRenderTarget();
        for(let a = 0; a < 6; a++)e1.setRenderTarget(this, a), e1.clear(t, i, n);
        e1.setRenderTarget(a);
    }
}
function $785da19a645c07eb$var$NH(e1) {
    let t = new WeakMap, i = new WeakMap, n = null;
    function a(e1, t) {
        return t === $785da19a645c07eb$var$EU ? e1.mapping = $785da19a645c07eb$var$bU : t === $785da19a645c07eb$var$kU && (e1.mapping = $785da19a645c07eb$var$wU), e1;
    }
    function r(e1) {
        const i = e1.target;
        i.removeEventListener("dispose", r);
        const n = t.get(i);
        void 0 !== n && (t.delete(i), n.dispose());
    }
    function s(e1) {
        const t = e1.target;
        t.removeEventListener("dispose", s);
        const n = i.get(t);
        void 0 !== n && (i.delete(t), n.dispose());
    }
    return {
        get: function(o, l = !1) {
            return null == o ? null : l ? function(t) {
                if (t && t.isTexture) {
                    const a = t.mapping, r = a === $785da19a645c07eb$var$EU || a === $785da19a645c07eb$var$kU, o = a === $785da19a645c07eb$var$bU || a === $785da19a645c07eb$var$wU;
                    if (r || o) {
                        let a = i.get(t);
                        const l = void 0 !== a ? a.texture.pmremVersion : 0;
                        if (t.isRenderTargetTexture && t.pmremVersion !== l) return null === n && (n = new $785da19a645c07eb$var$FH(e1)), a = r ? n.fromEquirectangular(t, a) : n.fromCubemap(t, a), a.texture.pmremVersion = t.pmremVersion, i.set(t, a), a.texture;
                        if (void 0 !== a) return a.texture;
                        {
                            const l = t.image;
                            return r && l && l.height > 0 || o && l && function(e1) {
                                let t = 0;
                                const i = 6;
                                for(let n = 0; n < i; n++)void 0 !== e1[n] && t++;
                                return t === i;
                            }(l) ? (null === n && (n = new $785da19a645c07eb$var$FH(e1)), a = r ? n.fromEquirectangular(t) : n.fromCubemap(t), a.texture.pmremVersion = t.pmremVersion, i.set(t, a), t.addEventListener("dispose", s), a.texture) : null;
                        }
                    }
                }
                return t;
            }(o) : function(i) {
                if (i && i.isTexture) {
                    const n = i.mapping;
                    if (n === $785da19a645c07eb$var$EU || n === $785da19a645c07eb$var$kU) {
                        if (t.has(i)) return a(t.get(i).texture, i.mapping);
                        {
                            const n = i.image;
                            if (n && n.height > 0) {
                                const s = new $785da19a645c07eb$var$UH(n.height);
                                return s.fromEquirectangularTexture(e1, i), t.set(i, s), i.addEventListener("dispose", r), a(s.texture, i.mapping);
                            }
                            return null;
                        }
                    }
                }
                return i;
            }(o);
        },
        dispose: function() {
            t = new WeakMap, i = new WeakMap, null !== n && (n.dispose(), n = null);
        }
    };
}
function $785da19a645c07eb$var$jH(e1) {
    const t = {};
    function i(i) {
        if (void 0 !== t[i]) return t[i];
        const n = e1.getExtension(i);
        return t[i] = n, n;
    }
    return {
        has: function(e1) {
            return null !== i(e1);
        },
        init: function() {
            i("EXT_color_buffer_float"), i("WEBGL_clip_cull_distance"), i("OES_texture_float_linear"), i("EXT_color_buffer_half_float"), i("WEBGL_multisampled_render_to_texture"), i("WEBGL_render_shared_exponent");
        },
        get: function(e1) {
            const t = i(e1);
            return null === t && $785da19a645c07eb$var$lj("WebGLRenderer: " + e1 + " extension not supported."), t;
        }
    };
}
function $785da19a645c07eb$var$VH(e1, t, i, n) {
    const a = {}, r = new WeakMap;
    function s(e1) {
        const o = e1.target;
        null !== o.index && t.remove(o.index);
        for(const e1 in o.attributes)t.remove(o.attributes[e1]);
        o.removeEventListener("dispose", s), delete a[o.id];
        const l = r.get(o);
        l && (t.remove(l), r.delete(o)), n.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, i.memory.geometries--;
    }
    function o(e1) {
        const i = [], n = e1.index, a = e1.attributes.position;
        let s = 0;
        if (void 0 === a) return;
        if (null !== n) {
            const e1 = n.array;
            s = n.version;
            for(let t = 0, n = e1.length; t < n; t += 3){
                const n = e1[t + 0], a = e1[t + 1], r = e1[t + 2];
                i.push(n, a, a, r, r, n);
            }
        } else {
            const e1 = a.array;
            s = a.version;
            for(let t = 0, n = e1.length / 3 - 1; t < n; t += 3){
                const e1 = t + 0, n = t + 1, a = t + 2;
                i.push(e1, n, n, a, a, e1);
            }
        }
        const o = new (a.count >= 65535 ? $785da19a645c07eb$var$dq : $785da19a645c07eb$var$hq)(i, 1);
        o.version = s;
        const l = r.get(e1);
        l && t.remove(l), r.set(e1, o);
    }
    return {
        get: function(e1, t) {
            return !0 === a[t.id] || (t.addEventListener("dispose", s), a[t.id] = !0, i.memory.geometries++), t;
        },
        update: function(i) {
            const n = i.attributes;
            for(const i in n)t.update(n[i], e1.ARRAY_BUFFER);
        },
        getWireframeAttribute: function(e1) {
            const t = r.get(e1);
            if (t) {
                const i = e1.index;
                null !== i && t.version < i.version && o(e1);
            } else o(e1);
            return r.get(e1);
        }
    };
}
function $785da19a645c07eb$var$qH(e1, t, i) {
    let n, a, r;
    this.setMode = function(e1) {
        n = e1;
    }, this.setIndex = function(e1) {
        a = e1.type, r = e1.bytesPerElement;
    }, this.render = function(t, s) {
        e1.drawElements(n, s, a, t * r), i.update(s, n, 1);
    }, this.renderInstances = function(t, s, o) {
        0 !== o && (e1.drawElementsInstanced(n, s, a, t * r, o), i.update(s, n, o));
    }, this.renderMultiDraw = function(e1, r, s) {
        if (0 === s) return;
        t.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, r, 0, a, e1, 0, s);
        let o = 0;
        for(let e1 = 0; e1 < s; e1++)o += r[e1];
        i.update(o, n, 1);
    };
}
function $785da19a645c07eb$var$GH(e1) {
    const t = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    return {
        memory: {
            geometries: 0,
            textures: 0
        },
        render: t,
        programs: null,
        autoReset: !0,
        reset: function() {
            t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
        },
        update: function(i, n, a) {
            switch(t.calls++, n){
                case e1.TRIANGLES:
                    t.triangles += a * (i / 3);
                    break;
                case e1.LINES:
                    t.lines += a * (i / 2);
                    break;
                case e1.LINE_STRIP:
                    t.lines += a * (i - 1);
                    break;
                case e1.LINE_LOOP:
                    t.lines += a * i;
                    break;
                case e1.POINTS:
                    t.points += a * i;
                    break;
                default:
                    $785da19a645c07eb$var$oj("WebGLInfo: Unknown draw mode:", n);
            }
        }
    };
}
function $785da19a645c07eb$var$HH(e1, t, i) {
    const n = new WeakMap, a = new $785da19a645c07eb$var$qj;
    return {
        update: function(r, s, o) {
            const l = r.morphTargetInfluences, c = s.morphAttributes.position || s.morphAttributes.normal || s.morphAttributes.color, u = void 0 !== c ? c.length : 0;
            let h = n.get(s);
            if (void 0 === h || h.count !== u) {
                void 0 !== h && h.texture.dispose();
                const d = void 0 !== s.morphAttributes.position, p = void 0 !== s.morphAttributes.normal, m = void 0 !== s.morphAttributes.color, g = s.morphAttributes.position || [], f = s.morphAttributes.normal || [], A = s.morphAttributes.color || [];
                let _ = 0;
                !0 === d && (_ = 1), !0 === p && (_ = 2), !0 === m && (_ = 3);
                let v = s.attributes.position.count * _, y = 1;
                v > t.maxTextureSize && (y = Math.ceil(v / t.maxTextureSize), v = t.maxTextureSize);
                const x = new Float32Array(v * y * 4 * u), b = new $785da19a645c07eb$var$Wj(x, v, y, u);
                b.type = $785da19a645c07eb$var$VU, b.needsUpdate = !0;
                const w = 4 * _;
                for(let k = 0; k < u; k++){
                    const S = g[k], M = f[k], C = A[k], T = v * y * 4 * k;
                    for(let D = 0; D < S.count; D++){
                        const P = D * w;
                        !0 === d && (a.fromBufferAttribute(S, D), x[T + P + 0] = a.x, x[T + P + 1] = a.y, x[T + P + 2] = a.z, x[T + P + 3] = 0), !0 === p && (a.fromBufferAttribute(M, D), x[T + P + 4] = a.x, x[T + P + 5] = a.y, x[T + P + 6] = a.z, x[T + P + 7] = 0), !0 === m && (a.fromBufferAttribute(C, D), x[T + P + 8] = a.x, x[T + P + 9] = a.y, x[T + P + 10] = a.z, x[T + P + 11] = 4 === C.itemSize ? a.w : 1);
                    }
                }
                function E() {
                    b.dispose(), n.delete(s), s.removeEventListener("dispose", E);
                }
                h = {
                    count: u,
                    texture: b,
                    size: new $785da19a645c07eb$var$bj(v, y)
                }, n.set(s, h), s.addEventListener("dispose", E);
            }
            if (!0 === r.isInstancedMesh && null !== r.morphTexture) o.getUniforms().setValue(e1, "morphTexture", r.morphTexture, i);
            else {
                let I = 0;
                for(let z = 0; z < l.length; z++)I += l[z];
                const F = s.morphTargetsRelative ? 1 : 1 - I;
                o.getUniforms().setValue(e1, "morphTargetBaseInfluence", F), o.getUniforms().setValue(e1, "morphTargetInfluences", l);
            }
            o.getUniforms().setValue(e1, "morphTargetsTexture", h.texture, i), o.getUniforms().setValue(e1, "morphTargetsTextureSize", h.size);
        }
    };
}
function $785da19a645c07eb$var$WH(e1, t, i, n, a) {
    let r = new WeakMap;
    function s(e1) {
        const t = e1.target;
        t.removeEventListener("dispose", s), n.releaseStatesOfObject(t), i.remove(t.instanceMatrix), null !== t.instanceColor && i.remove(t.instanceColor);
    }
    return {
        update: function(n) {
            const o = a.render.frame, l = n.geometry, c = t.get(n, l);
            if (r.get(c) !== o && (t.update(c), r.set(c, o)), n.isInstancedMesh && (!1 === n.hasEventListener("dispose", s) && n.addEventListener("dispose", s), r.get(n) !== o && (i.update(n.instanceMatrix, e1.ARRAY_BUFFER), null !== n.instanceColor && i.update(n.instanceColor, e1.ARRAY_BUFFER), r.set(n, o))), n.isSkinnedMesh) {
                const e1 = n.skeleton;
                r.get(e1) !== o && (e1.update(), r.set(e1, o));
            }
            return c;
        },
        dispose: function() {
            r = new WeakMap;
        }
    };
}
const $785da19a645c07eb$var$ZH = {
    [$785da19a645c07eb$var$gU]: "LINEAR_TONE_MAPPING",
    [$785da19a645c07eb$var$fU]: "REINHARD_TONE_MAPPING",
    [$785da19a645c07eb$var$AU]: "CINEON_TONE_MAPPING",
    [$785da19a645c07eb$var$_U]: "ACES_FILMIC_TONE_MAPPING",
    [$785da19a645c07eb$var$yU]: "AGX_TONE_MAPPING",
    [$785da19a645c07eb$var$xU]: "NEUTRAL_TONE_MAPPING",
    [$785da19a645c07eb$var$vU]: "CUSTOM_TONE_MAPPING"
};
function $785da19a645c07eb$var$KH(e1, t, i, n, a, r) {
    const s = new $785da19a645c07eb$var$Hj(t, i, {
        type: e1,
        depthBuffer: a,
        stencilBuffer: r,
        samples: n ? 4 : 0,
        depthTexture: a ? new $785da19a645c07eb$var$yG(t, i) : void 0
    }), o = new $785da19a645c07eb$var$Hj(t, i, {
        type: $785da19a645c07eb$var$qU,
        depthBuffer: !1,
        stencilBuffer: !1
    }), l = new $785da19a645c07eb$var$kq;
    l.setAttribute("position", new $785da19a645c07eb$var$pq([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3)), l.setAttribute("uv", new $785da19a645c07eb$var$pq([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    const c = new $785da19a645c07eb$var$zG({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: "\n\t\t\tprecision highp float;\n\n\t\t\tuniform mat4 modelViewMatrix;\n\t\t\tuniform mat4 projectionMatrix;\n\n\t\t\tattribute vec3 position;\n\t\t\tattribute vec2 uv;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\tvoid main() {\n\t\t\t\tvUv = uv;\n\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t}",
        fragmentShader: "\n\t\t\tprecision highp float;\n\n\t\t\tuniform sampler2D tDiffuse;\n\n\t\t\tvarying vec2 vUv;\n\n\t\t\t#include <tonemapping_pars_fragment>\n\t\t\t#include <colorspace_pars_fragment>\n\n\t\t\tvoid main() {\n\t\t\t\tgl_FragColor = texture2D( tDiffuse, vUv );\n\n\t\t\t\t#ifdef LINEAR_TONE_MAPPING\n\t\t\t\t\tgl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( REINHARD_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( CINEON_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( ACES_FILMIC_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( AGX_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( NEUTRAL_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );\n\t\t\t\t#elif defined( CUSTOM_TONE_MAPPING )\n\t\t\t\t\tgl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );\n\t\t\t\t#endif\n\n\t\t\t\t#ifdef SRGB_TRANSFER\n\t\t\t\t\tgl_FragColor = sRGBTransferOETF( gl_FragColor );\n\t\t\t\t#endif\n\t\t\t}",
        depthTest: !1,
        depthWrite: !1
    }), u = new $785da19a645c07eb$var$Kq(l, c), h = new $785da19a645c07eb$var$tH(-1, 1, 1, -1, 0, 1);
    let d, p = null, m = null, g = !1, f = null, A = [], _ = !1;
    this.setSize = function(e1, t) {
        s.setSize(e1, t), o.setSize(e1, t);
        for(let i = 0; i < A.length; i++){
            const n = A[i];
            n.setSize && n.setSize(e1, t);
        }
    }, this.setEffects = function(e1) {
        A = e1, _ = A.length > 0 && !0 === A[0].isRenderPass;
        const t = s.width, i = s.height;
        for(let e1 = 0; e1 < A.length; e1++){
            const n = A[e1];
            n.setSize && n.setSize(t, i);
        }
    }, this.begin = function(e1, t) {
        if (g) return !1;
        if (0 === e1.toneMapping && 0 === A.length) return !1;
        if (f = t, null !== t) {
            const e1 = t.width, i = t.height;
            s.width === e1 && s.height === i || this.setSize(e1, i);
        }
        return !1 === _ && e1.setRenderTarget(s), d = e1.toneMapping, e1.toneMapping = 0, !0;
    }, this.hasRenderPass = function() {
        return _;
    }, this.end = function(e1, t) {
        e1.toneMapping = d, g = !0;
        let i = s, n = o;
        for(let a = 0; a < A.length; a++){
            const r = A[a];
            if (!1 !== r.enabled && (r.render(e1, n, i, t), !1 !== r.needsSwap)) {
                const e1 = i;
                i = n, n = e1;
            }
        }
        if (p !== e1.outputColorSpace || m !== e1.toneMapping) {
            p = e1.outputColorSpace, m = e1.toneMapping, c.defines = {}, $785da19a645c07eb$var$Ij.getTransfer(p) === $785da19a645c07eb$var$VN && (c.defines.SRGB_TRANSFER = "");
            const t = $785da19a645c07eb$var$ZH[m];
            t && (c.defines[t] = ""), c.needsUpdate = !0;
        }
        c.uniforms.tDiffuse.value = i.texture, e1.setRenderTarget(f), e1.render(u, h), f = null, g = !1;
    }, this.isCompositing = function() {
        return g;
    }, this.dispose = function() {
        s.depthTexture && s.depthTexture.dispose(), s.dispose(), o.dispose(), l.dispose(), c.dispose();
    };
}
const $785da19a645c07eb$var$XH = new $785da19a645c07eb$var$Vj, $785da19a645c07eb$var$QH = new $785da19a645c07eb$var$yG(1, 1), $785da19a645c07eb$var$YH = new $785da19a645c07eb$var$Wj, $785da19a645c07eb$var$JH = new $785da19a645c07eb$var$Zj, $785da19a645c07eb$var$$H = new $785da19a645c07eb$var$vG, $785da19a645c07eb$var$eW = [], $785da19a645c07eb$var$tW = [], $785da19a645c07eb$var$iW = new Float32Array(16), $785da19a645c07eb$var$nW = new Float32Array(9), $785da19a645c07eb$var$aW = new Float32Array(4);
function $785da19a645c07eb$var$rW(e1, t, i) {
    const n = e1[0];
    if (n <= 0 || n > 0) return e1;
    const a = t * i;
    let r = $785da19a645c07eb$var$eW[a];
    if (void 0 === r && (r = new Float32Array(a), $785da19a645c07eb$var$eW[a] = r), 0 !== t) {
        n.toArray(r, 0);
        for(let n = 1, a = 0; n !== t; ++n)a += i, e1[n].toArray(r, a);
    }
    return r;
}
function $785da19a645c07eb$var$sW(e1, t) {
    if (e1.length !== t.length) return !1;
    for(let i = 0, n = e1.length; i < n; i++)if (e1[i] !== t[i]) return !1;
    return !0;
}
function $785da19a645c07eb$var$oW(e1, t) {
    for(let i = 0, n = t.length; i < n; i++)e1[i] = t[i];
}
function $785da19a645c07eb$var$lW(e1, t) {
    let i = $785da19a645c07eb$var$tW[t];
    void 0 === i && (i = new Int32Array(t), $785da19a645c07eb$var$tW[t] = i);
    for(let n = 0; n !== t; ++n)i[n] = e1.allocateTextureUnit();
    return i;
}
function $785da19a645c07eb$var$cW(e1, t) {
    const i = this.cache;
    i[0] !== t && (e1.uniform1f(this.addr, t), i[0] = t);
}
function $785da19a645c07eb$var$uW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e1.uniform2f(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform2fv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$hW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e1.uniform3f(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else if (void 0 !== t.r) i[0] === t.r && i[1] === t.g && i[2] === t.b || (e1.uniform3f(this.addr, t.r, t.g, t.b), i[0] = t.r, i[1] = t.g, i[2] = t.b);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform3fv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$dW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e1.uniform4f(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform4fv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$pW(e1, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniformMatrix2fv(this.addr, !1, t), $785da19a645c07eb$var$oW(i, t);
    } else {
        if ($785da19a645c07eb$var$sW(i, n)) return;
        $785da19a645c07eb$var$aW.set(n), e1.uniformMatrix2fv(this.addr, !1, $785da19a645c07eb$var$aW), $785da19a645c07eb$var$oW(i, n);
    }
}
function $785da19a645c07eb$var$mW(e1, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniformMatrix3fv(this.addr, !1, t), $785da19a645c07eb$var$oW(i, t);
    } else {
        if ($785da19a645c07eb$var$sW(i, n)) return;
        $785da19a645c07eb$var$nW.set(n), e1.uniformMatrix3fv(this.addr, !1, $785da19a645c07eb$var$nW), $785da19a645c07eb$var$oW(i, n);
    }
}
function $785da19a645c07eb$var$gW(e1, t) {
    const i = this.cache, n = t.elements;
    if (void 0 === n) {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniformMatrix4fv(this.addr, !1, t), $785da19a645c07eb$var$oW(i, t);
    } else {
        if ($785da19a645c07eb$var$sW(i, n)) return;
        $785da19a645c07eb$var$iW.set(n), e1.uniformMatrix4fv(this.addr, !1, $785da19a645c07eb$var$iW), $785da19a645c07eb$var$oW(i, n);
    }
}
function $785da19a645c07eb$var$fW(e1, t) {
    const i = this.cache;
    i[0] !== t && (e1.uniform1i(this.addr, t), i[0] = t);
}
function $785da19a645c07eb$var$AW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e1.uniform2i(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform2iv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$_W(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e1.uniform3i(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform3iv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$vW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e1.uniform4i(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform4iv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$yW(e1, t) {
    const i = this.cache;
    i[0] !== t && (e1.uniform1ui(this.addr, t), i[0] = t);
}
function $785da19a645c07eb$var$xW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y || (e1.uniform2ui(this.addr, t.x, t.y), i[0] = t.x, i[1] = t.y);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform2uiv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$bW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z || (e1.uniform3ui(this.addr, t.x, t.y, t.z), i[0] = t.x, i[1] = t.y, i[2] = t.z);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform3uiv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$wW(e1, t) {
    const i = this.cache;
    if (void 0 !== t.x) i[0] === t.x && i[1] === t.y && i[2] === t.z && i[3] === t.w || (e1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), i[0] = t.x, i[1] = t.y, i[2] = t.z, i[3] = t.w);
    else {
        if ($785da19a645c07eb$var$sW(i, t)) return;
        e1.uniform4uiv(this.addr, t), $785da19a645c07eb$var$oW(i, t);
    }
}
function $785da19a645c07eb$var$EW(e1, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    let r;
    n[0] !== a && (e1.uniform1i(this.addr, a), n[0] = a), this.type === e1.SAMPLER_2D_SHADOW ? ($785da19a645c07eb$var$QH.compareFunction = i.isReversedDepthBuffer() ? 518 : 515, r = $785da19a645c07eb$var$QH) : r = $785da19a645c07eb$var$XH, i.setTexture2D(t || r, a);
}
function $785da19a645c07eb$var$kW(e1, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e1.uniform1i(this.addr, a), n[0] = a), i.setTexture3D(t || $785da19a645c07eb$var$JH, a);
}
function $785da19a645c07eb$var$SW(e1, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e1.uniform1i(this.addr, a), n[0] = a), i.setTextureCube(t || $785da19a645c07eb$var$$H, a);
}
function $785da19a645c07eb$var$MW(e1, t, i) {
    const n = this.cache, a = i.allocateTextureUnit();
    n[0] !== a && (e1.uniform1i(this.addr, a), n[0] = a), i.setTexture2DArray(t || $785da19a645c07eb$var$YH, a);
}
function $785da19a645c07eb$var$CW(e1, t) {
    e1.uniform1fv(this.addr, t);
}
function $785da19a645c07eb$var$TW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 2);
    e1.uniform2fv(this.addr, i);
}
function $785da19a645c07eb$var$DW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 3);
    e1.uniform3fv(this.addr, i);
}
function $785da19a645c07eb$var$PW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 4);
    e1.uniform4fv(this.addr, i);
}
function $785da19a645c07eb$var$IW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 4);
    e1.uniformMatrix2fv(this.addr, !1, i);
}
function $785da19a645c07eb$var$FW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 9);
    e1.uniformMatrix3fv(this.addr, !1, i);
}
function $785da19a645c07eb$var$zW(e1, t) {
    const i = $785da19a645c07eb$var$rW(t, this.size, 16);
    e1.uniformMatrix4fv(this.addr, !1, i);
}
function $785da19a645c07eb$var$RW(e1, t) {
    e1.uniform1iv(this.addr, t);
}
function $785da19a645c07eb$var$LW(e1, t) {
    e1.uniform2iv(this.addr, t);
}
function $785da19a645c07eb$var$BW(e1, t) {
    e1.uniform3iv(this.addr, t);
}
function $785da19a645c07eb$var$OW(e1, t) {
    e1.uniform4iv(this.addr, t);
}
function $785da19a645c07eb$var$UW(e1, t) {
    e1.uniform1uiv(this.addr, t);
}
function $785da19a645c07eb$var$NW(e1, t) {
    e1.uniform2uiv(this.addr, t);
}
function $785da19a645c07eb$var$jW(e1, t) {
    e1.uniform3uiv(this.addr, t);
}
function $785da19a645c07eb$var$VW(e1, t) {
    e1.uniform4uiv(this.addr, t);
}
function $785da19a645c07eb$var$qW(e1, t, i) {
    const n = this.cache, a = t.length, r = $785da19a645c07eb$var$lW(i, a);
    let s;
    $785da19a645c07eb$var$sW(n, r) || (e1.uniform1iv(this.addr, r), $785da19a645c07eb$var$oW(n, r)), s = this.type === e1.SAMPLER_2D_SHADOW ? $785da19a645c07eb$var$QH : $785da19a645c07eb$var$XH;
    for(let e1 = 0; e1 !== a; ++e1)i.setTexture2D(t[e1] || s, r[e1]);
}
function $785da19a645c07eb$var$GW(e1, t, i) {
    const n = this.cache, a = t.length, r = $785da19a645c07eb$var$lW(i, a);
    $785da19a645c07eb$var$sW(n, r) || (e1.uniform1iv(this.addr, r), $785da19a645c07eb$var$oW(n, r));
    for(let e1 = 0; e1 !== a; ++e1)i.setTexture3D(t[e1] || $785da19a645c07eb$var$JH, r[e1]);
}
function $785da19a645c07eb$var$HW(e1, t, i) {
    const n = this.cache, a = t.length, r = $785da19a645c07eb$var$lW(i, a);
    $785da19a645c07eb$var$sW(n, r) || (e1.uniform1iv(this.addr, r), $785da19a645c07eb$var$oW(n, r));
    for(let e1 = 0; e1 !== a; ++e1)i.setTextureCube(t[e1] || $785da19a645c07eb$var$$H, r[e1]);
}
function $785da19a645c07eb$var$WW(e1, t, i) {
    const n = this.cache, a = t.length, r = $785da19a645c07eb$var$lW(i, a);
    $785da19a645c07eb$var$sW(n, r) || (e1.uniform1iv(this.addr, r), $785da19a645c07eb$var$oW(n, r));
    for(let e1 = 0; e1 !== a; ++e1)i.setTexture2DArray(t[e1] || $785da19a645c07eb$var$YH, r[e1]);
}
class $785da19a645c07eb$var$ZW {
    constructor(e1, t, i){
        this.id = e1, this.addr = i, this.cache = [], this.type = t.type, this.setValue = function(e1) {
            switch(e1){
                case 5126:
                    return $785da19a645c07eb$var$cW;
                case 35664:
                    return $785da19a645c07eb$var$uW;
                case 35665:
                    return $785da19a645c07eb$var$hW;
                case 35666:
                    return $785da19a645c07eb$var$dW;
                case 35674:
                    return $785da19a645c07eb$var$pW;
                case 35675:
                    return $785da19a645c07eb$var$mW;
                case 35676:
                    return $785da19a645c07eb$var$gW;
                case 5124:
                case 35670:
                    return $785da19a645c07eb$var$fW;
                case 35667:
                case 35671:
                    return $785da19a645c07eb$var$AW;
                case 35668:
                case 35672:
                    return $785da19a645c07eb$var$_W;
                case 35669:
                case 35673:
                    return $785da19a645c07eb$var$vW;
                case 5125:
                    return $785da19a645c07eb$var$yW;
                case 36294:
                    return $785da19a645c07eb$var$xW;
                case 36295:
                    return $785da19a645c07eb$var$bW;
                case 36296:
                    return $785da19a645c07eb$var$wW;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $785da19a645c07eb$var$EW;
                case 35679:
                case 36299:
                case 36307:
                    return $785da19a645c07eb$var$kW;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $785da19a645c07eb$var$SW;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $785da19a645c07eb$var$MW;
            }
        }(t.type);
    }
}
class $785da19a645c07eb$var$KW {
    constructor(e1, t, i){
        this.id = e1, this.addr = i, this.cache = [], this.type = t.type, this.size = t.size, this.setValue = function(e1) {
            switch(e1){
                case 5126:
                    return $785da19a645c07eb$var$CW;
                case 35664:
                    return $785da19a645c07eb$var$TW;
                case 35665:
                    return $785da19a645c07eb$var$DW;
                case 35666:
                    return $785da19a645c07eb$var$PW;
                case 35674:
                    return $785da19a645c07eb$var$IW;
                case 35675:
                    return $785da19a645c07eb$var$FW;
                case 35676:
                    return $785da19a645c07eb$var$zW;
                case 5124:
                case 35670:
                    return $785da19a645c07eb$var$RW;
                case 35667:
                case 35671:
                    return $785da19a645c07eb$var$LW;
                case 35668:
                case 35672:
                    return $785da19a645c07eb$var$BW;
                case 35669:
                case 35673:
                    return $785da19a645c07eb$var$OW;
                case 5125:
                    return $785da19a645c07eb$var$UW;
                case 36294:
                    return $785da19a645c07eb$var$NW;
                case 36295:
                    return $785da19a645c07eb$var$jW;
                case 36296:
                    return $785da19a645c07eb$var$VW;
                case 35678:
                case 36198:
                case 36298:
                case 36306:
                case 35682:
                    return $785da19a645c07eb$var$qW;
                case 35679:
                case 36299:
                case 36307:
                    return $785da19a645c07eb$var$GW;
                case 35680:
                case 36300:
                case 36308:
                case 36293:
                    return $785da19a645c07eb$var$HW;
                case 36289:
                case 36303:
                case 36311:
                case 36292:
                    return $785da19a645c07eb$var$WW;
            }
        }(t.type);
    }
}
class $785da19a645c07eb$var$XW {
    constructor(e1){
        this.id = e1, this.seq = [], this.map = {};
    }
    setValue(e1, t, i) {
        const n = this.seq;
        for(let a = 0, r = n.length; a !== r; ++a){
            const r = n[a];
            r.setValue(e1, t[r.id], i);
        }
    }
}
const $785da19a645c07eb$var$QW = /(\w+)(\])?(\[|\.)?/g;
function $785da19a645c07eb$var$YW(e1, t) {
    e1.seq.push(t), e1.map[t.id] = t;
}
function $785da19a645c07eb$var$JW(e1, t, i) {
    const n = e1.name, a = n.length;
    for($785da19a645c07eb$var$QW.lastIndex = 0;;){
        const r = $785da19a645c07eb$var$QW.exec(n), s = $785da19a645c07eb$var$QW.lastIndex;
        let o = r[1];
        const l = "]" === r[2], c = r[3];
        if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === a) {
            $785da19a645c07eb$var$YW(i, void 0 === c ? new $785da19a645c07eb$var$ZW(o, e1, t) : new $785da19a645c07eb$var$KW(o, e1, t));
            break;
        }
        {
            let e1 = i.map[o];
            void 0 === e1 && (e1 = new $785da19a645c07eb$var$XW(o), $785da19a645c07eb$var$YW(i, e1)), i = e1;
        }
    }
}
class $785da19a645c07eb$var$$W {
    constructor(e1, t){
        this.seq = [], this.map = {};
        const i = e1.getProgramParameter(t, e1.ACTIVE_UNIFORMS);
        for(let n = 0; n < i; ++n){
            const i = e1.getActiveUniform(t, n);
            $785da19a645c07eb$var$JW(i, e1.getUniformLocation(t, i.name), this);
        }
        const n = [], a = [];
        for (const t of this.seq)t.type === e1.SAMPLER_2D_SHADOW || t.type === e1.SAMPLER_CUBE_SHADOW || t.type === e1.SAMPLER_2D_ARRAY_SHADOW ? n.push(t) : a.push(t);
        n.length > 0 && (this.seq = n.concat(a));
    }
    setValue(e1, t, i, n) {
        const a = this.map[t];
        void 0 !== a && a.setValue(e1, i, n);
    }
    setOptional(e1, t, i) {
        const n = t[i];
        void 0 !== n && this.setValue(e1, i, n);
    }
    static upload(e1, t, i, n) {
        for(let a = 0, r = t.length; a !== r; ++a){
            const r = t[a], s = i[r.id];
            !1 !== s.needsUpdate && r.setValue(e1, s.value, n);
        }
    }
    static seqWithValue(e1, t) {
        const i = [];
        for(let n = 0, a = e1.length; n !== a; ++n){
            const a = e1[n];
            a.id in t && i.push(a);
        }
        return i;
    }
}
function $785da19a645c07eb$var$eZ(e1, t, i) {
    const n = e1.createShader(t);
    return e1.shaderSource(n, i), e1.compileShader(n), n;
}
let $785da19a645c07eb$var$tZ = 0;
const $785da19a645c07eb$var$iZ = new $785da19a645c07eb$var$Mj;
function $785da19a645c07eb$var$nZ(e1, t, i) {
    const n = e1.getShaderParameter(t, e1.COMPILE_STATUS), a = (e1.getShaderInfoLog(t) || "").trim();
    if (n && "" === a) return "";
    const r = /ERROR: 0:(\d+)/.exec(a);
    if (r) {
        const n = parseInt(r[1]);
        return i.toUpperCase() + "\n\n" + a + "\n\n" + function(e1, t) {
            const i = e1.split("\n"), n = [], a = Math.max(t - 6, 0), r = Math.min(t + 6, i.length);
            for(let e1 = a; e1 < r; e1++){
                const a = e1 + 1;
                n.push(`${a === t ? ">" : " "} ${a}: ${i[e1]}`);
            }
            return n.join("\n");
        }(e1.getShaderSource(t), n);
    }
    return a;
}
function $785da19a645c07eb$var$aZ(e1, t) {
    const i = function(e1) {
        $785da19a645c07eb$var$Ij._getMatrix($785da19a645c07eb$var$iZ, $785da19a645c07eb$var$Ij.workingColorSpace, e1);
        const t = `mat3( ${$785da19a645c07eb$var$iZ.elements.map((e1)=>e1.toFixed(4))} )`;
        switch($785da19a645c07eb$var$Ij.getTransfer(e1)){
            case $785da19a645c07eb$var$jN:
                return [
                    t,
                    "LinearTransferOETF"
                ];
            case $785da19a645c07eb$var$VN:
                return [
                    t,
                    "sRGBTransferOETF"
                ];
            default:
                return $785da19a645c07eb$var$sj("WebGLProgram: Unsupported color space: ", e1), [
                    t,
                    "LinearTransferOETF"
                ];
        }
    }(t);
    return [
        `vec4 ${e1}( vec4 value ) {`,
        `\treturn ${i[1]}( vec4( value.rgb * ${i[0]}, value.a ) );`,
        "}"
    ].join("\n");
}
const $785da19a645c07eb$var$rZ = {
    [$785da19a645c07eb$var$gU]: "Linear",
    [$785da19a645c07eb$var$fU]: "Reinhard",
    [$785da19a645c07eb$var$AU]: "Cineon",
    [$785da19a645c07eb$var$_U]: "ACESFilmic",
    [$785da19a645c07eb$var$yU]: "AgX",
    [$785da19a645c07eb$var$xU]: "Neutral",
    [$785da19a645c07eb$var$vU]: "Custom"
};
function $785da19a645c07eb$var$sZ(e1, t) {
    const i = $785da19a645c07eb$var$rZ[t];
    return void 0 === i ? ($785da19a645c07eb$var$sj("WebGLProgram: Unsupported toneMapping:", t), "vec3 " + e1 + "( vec3 color ) { return LinearToneMapping( color ); }") : "vec3 " + e1 + "( vec3 color ) { return " + i + "ToneMapping( color ); }";
}
const $785da19a645c07eb$var$oZ = new $785da19a645c07eb$var$Ej;
function $785da19a645c07eb$var$lZ() {
    $785da19a645c07eb$var$Ij.getLuminanceCoefficients($785da19a645c07eb$var$oZ);
    return [
        "float luminance( const in vec3 rgb ) {",
        `\tconst vec3 weights = vec3( ${$785da19a645c07eb$var$oZ.x.toFixed(4)}, ${$785da19a645c07eb$var$oZ.y.toFixed(4)}, ${$785da19a645c07eb$var$oZ.z.toFixed(4)} );`,
        "\treturn dot( weights, rgb );",
        "}"
    ].join("\n");
}
function $785da19a645c07eb$var$cZ(e1) {
    return "" !== e1;
}
function $785da19a645c07eb$var$uZ(e1, t) {
    const i = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return e1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, i).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function $785da19a645c07eb$var$hZ(e1, t) {
    return e1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
const $785da19a645c07eb$var$dZ = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $785da19a645c07eb$var$pZ(e1) {
    return e1.replace($785da19a645c07eb$var$dZ, $785da19a645c07eb$var$gZ);
}
const $785da19a645c07eb$var$mZ = new Map;
function $785da19a645c07eb$var$gZ(e1, t) {
    let i = $785da19a645c07eb$var$pH[t];
    if (void 0 === i) {
        const e1 = $785da19a645c07eb$var$mZ.get(t);
        if (void 0 === e1) throw new Error("THREE.WebGLProgram: Can not resolve #include <" + t + ">");
        i = $785da19a645c07eb$var$pH[e1], $785da19a645c07eb$var$sj('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, e1);
    }
    return $785da19a645c07eb$var$pZ(i);
}
const $785da19a645c07eb$var$fZ = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $785da19a645c07eb$var$AZ(e1) {
    return e1.replace($785da19a645c07eb$var$fZ, $785da19a645c07eb$var$_Z);
}
function $785da19a645c07eb$var$_Z(e1, t, i, n) {
    let a = "";
    for(let e1 = parseInt(t); e1 < parseInt(i); e1++)a += n.replace(/\[\s*i\s*\]/g, "[ " + e1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, e1);
    return a;
}
function $785da19a645c07eb$var$vZ(e1) {
    let t = `precision ${e1.precision} float;\n\tprecision ${e1.precision} int;\n\tprecision ${e1.precision} sampler2D;\n\tprecision ${e1.precision} samplerCube;\n\tprecision ${e1.precision} sampler3D;\n\tprecision ${e1.precision} sampler2DArray;\n\tprecision ${e1.precision} sampler2DShadow;\n\tprecision ${e1.precision} samplerCubeShadow;\n\tprecision ${e1.precision} sampler2DArrayShadow;\n\tprecision ${e1.precision} isampler2D;\n\tprecision ${e1.precision} isampler3D;\n\tprecision ${e1.precision} isamplerCube;\n\tprecision ${e1.precision} isampler2DArray;\n\tprecision ${e1.precision} usampler2D;\n\tprecision ${e1.precision} usampler3D;\n\tprecision ${e1.precision} usamplerCube;\n\tprecision ${e1.precision} usampler2DArray;\n\t`;
    return "highp" === e1.precision ? t += "\n#define HIGH_PRECISION" : "mediump" === e1.precision ? t += "\n#define MEDIUM_PRECISION" : "lowp" === e1.precision && (t += "\n#define LOW_PRECISION"), t;
}
const $785da19a645c07eb$var$yZ = {
    [$785da19a645c07eb$var$RO]: "SHADOWMAP_TYPE_PCF",
    [$785da19a645c07eb$var$LO]: "SHADOWMAP_TYPE_VSM"
};
const $785da19a645c07eb$var$xZ = {
    [$785da19a645c07eb$var$bU]: "ENVMAP_TYPE_CUBE",
    [$785da19a645c07eb$var$wU]: "ENVMAP_TYPE_CUBE",
    [$785da19a645c07eb$var$SU]: "ENVMAP_TYPE_CUBE_UV"
};
const $785da19a645c07eb$var$bZ = {
    [$785da19a645c07eb$var$wU]: "ENVMAP_MODE_REFRACTION"
};
const $785da19a645c07eb$var$wZ = {
    [$785da19a645c07eb$var$dU]: "ENVMAP_BLENDING_MULTIPLY",
    [$785da19a645c07eb$var$pU]: "ENVMAP_BLENDING_MIX",
    [$785da19a645c07eb$var$mU]: "ENVMAP_BLENDING_ADD"
};
function $785da19a645c07eb$var$EZ(e1, t, i, n) {
    const a = e1.getContext(), r = i.defines;
    let s = i.vertexShader, o = i.fragmentShader;
    const l = function(e1) {
        return $785da19a645c07eb$var$yZ[e1.shadowMapType] || "SHADOWMAP_TYPE_BASIC";
    }(i), c = function(e1) {
        return !1 === e1.envMap ? "ENVMAP_TYPE_CUBE" : $785da19a645c07eb$var$xZ[e1.envMapMode] || "ENVMAP_TYPE_CUBE";
    }(i), u = function(e1) {
        return !1 === e1.envMap ? "ENVMAP_MODE_REFLECTION" : $785da19a645c07eb$var$bZ[e1.envMapMode] || "ENVMAP_MODE_REFLECTION";
    }(i), h = function(e1) {
        return !1 === e1.envMap ? "ENVMAP_BLENDING_NONE" : $785da19a645c07eb$var$wZ[e1.combine] || "ENVMAP_BLENDING_NONE";
    }(i), d = function(e1) {
        const t = e1.envMapCubeUVHeight;
        if (null === t) return null;
        const i = Math.log2(t) - 2, n = 1 / t;
        return {
            texelWidth: 1 / (3 * Math.max(Math.pow(2, i), 112)),
            texelHeight: n,
            maxMip: i
        };
    }(i), p = function(e1) {
        return [
            e1.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
            e1.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
        ].filter($785da19a645c07eb$var$cZ).join("\n");
    }(i), m = function(e1) {
        const t = [];
        for(const i in e1){
            const n = e1[i];
            !1 !== n && t.push("#define " + i + " " + n);
        }
        return t.join("\n");
    }(r), g = a.createProgram();
    let f, A, _ = i.glslVersion ? "#version " + i.glslVersion + "\n" : "";
    i.isRawShaderMaterial ? (f = [
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        m
    ].filter($785da19a645c07eb$var$cZ).join("\n"), f.length > 0 && (f += "\n"), A = [
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        m
    ].filter($785da19a645c07eb$var$cZ).join("\n"), A.length > 0 && (A += "\n")) : (f = [
        $785da19a645c07eb$var$vZ(i),
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        m,
        i.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        i.batching ? "#define USE_BATCHING" : "",
        i.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        i.instancing ? "#define USE_INSTANCING" : "",
        i.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        i.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        i.useFog && i.fog ? "#define USE_FOG" : "",
        i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
        i.map ? "#define USE_MAP" : "",
        i.envMap ? "#define USE_ENVMAP" : "",
        i.envMap ? "#define " + u : "",
        i.lightMap ? "#define USE_LIGHTMAP" : "",
        i.aoMap ? "#define USE_AOMAP" : "",
        i.bumpMap ? "#define USE_BUMPMAP" : "",
        i.normalMap ? "#define USE_NORMALMAP" : "",
        i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        i.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        i.anisotropy ? "#define USE_ANISOTROPY" : "",
        i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        i.specularMap ? "#define USE_SPECULARMAP" : "",
        i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        i.metalnessMap ? "#define USE_METALNESSMAP" : "",
        i.alphaMap ? "#define USE_ALPHAMAP" : "",
        i.alphaHash ? "#define USE_ALPHAHASH" : "",
        i.transmission ? "#define USE_TRANSMISSION" : "",
        i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        i.mapUv ? "#define MAP_UV " + i.mapUv : "",
        i.alphaMapUv ? "#define ALPHAMAP_UV " + i.alphaMapUv : "",
        i.lightMapUv ? "#define LIGHTMAP_UV " + i.lightMapUv : "",
        i.aoMapUv ? "#define AOMAP_UV " + i.aoMapUv : "",
        i.emissiveMapUv ? "#define EMISSIVEMAP_UV " + i.emissiveMapUv : "",
        i.bumpMapUv ? "#define BUMPMAP_UV " + i.bumpMapUv : "",
        i.normalMapUv ? "#define NORMALMAP_UV " + i.normalMapUv : "",
        i.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + i.displacementMapUv : "",
        i.metalnessMapUv ? "#define METALNESSMAP_UV " + i.metalnessMapUv : "",
        i.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + i.roughnessMapUv : "",
        i.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + i.anisotropyMapUv : "",
        i.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + i.clearcoatMapUv : "",
        i.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + i.clearcoatNormalMapUv : "",
        i.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + i.clearcoatRoughnessMapUv : "",
        i.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + i.iridescenceMapUv : "",
        i.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + i.iridescenceThicknessMapUv : "",
        i.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + i.sheenColorMapUv : "",
        i.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + i.sheenRoughnessMapUv : "",
        i.specularMapUv ? "#define SPECULARMAP_UV " + i.specularMapUv : "",
        i.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + i.specularColorMapUv : "",
        i.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + i.specularIntensityMapUv : "",
        i.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + i.transmissionMapUv : "",
        i.thicknessMapUv ? "#define THICKNESSMAP_UV " + i.thicknessMapUv : "",
        i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
        i.vertexNormals ? "#define HAS_NORMAL" : "",
        i.vertexColors ? "#define USE_COLOR" : "",
        i.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        i.vertexUv1s ? "#define USE_UV1" : "",
        i.vertexUv2s ? "#define USE_UV2" : "",
        i.vertexUv3s ? "#define USE_UV3" : "",
        i.pointsUvs ? "#define USE_POINTS_UV" : "",
        i.flatShading ? "#define FLAT_SHADED" : "",
        i.skinning ? "#define USE_SKINNING" : "",
        i.morphTargets ? "#define USE_MORPHTARGETS" : "",
        i.morphNormals && !1 === i.flatShading ? "#define USE_MORPHNORMALS" : "",
        i.morphColors ? "#define USE_MORPHCOLORS" : "",
        i.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + i.morphTextureStride : "",
        i.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + i.morphTargetsCount : "",
        i.doubleSided ? "#define DOUBLE_SIDED" : "",
        i.flipSided ? "#define FLIP_SIDED" : "",
        i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        i.shadowMapEnabled ? "#define " + l : "",
        i.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        i.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        i.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "\tattribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "\tattribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "\tuniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "\tattribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "\tattribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "\tattribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "\tattribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "\tattribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "\tattribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "\tattribute vec4 skinIndex;",
        "\tattribute vec4 skinWeight;",
        "#endif",
        "\n"
    ].filter($785da19a645c07eb$var$cZ).join("\n"), A = [
        $785da19a645c07eb$var$vZ(i),
        "#define SHADER_TYPE " + i.shaderType,
        "#define SHADER_NAME " + i.shaderName,
        m,
        i.useFog && i.fog ? "#define USE_FOG" : "",
        i.useFog && i.fogExp2 ? "#define FOG_EXP2" : "",
        i.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        i.map ? "#define USE_MAP" : "",
        i.matcap ? "#define USE_MATCAP" : "",
        i.envMap ? "#define USE_ENVMAP" : "",
        i.envMap ? "#define " + c : "",
        i.envMap ? "#define " + u : "",
        i.envMap ? "#define " + h : "",
        d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
        d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
        d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
        i.lightMap ? "#define USE_LIGHTMAP" : "",
        i.aoMap ? "#define USE_AOMAP" : "",
        i.bumpMap ? "#define USE_BUMPMAP" : "",
        i.normalMap ? "#define USE_NORMALMAP" : "",
        i.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        i.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        i.packedNormalMap ? "#define USE_PACKED_NORMALMAP" : "",
        i.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        i.anisotropy ? "#define USE_ANISOTROPY" : "",
        i.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        i.clearcoat ? "#define USE_CLEARCOAT" : "",
        i.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        i.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        i.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        i.dispersion ? "#define USE_DISPERSION" : "",
        i.iridescence ? "#define USE_IRIDESCENCE" : "",
        i.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        i.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        i.specularMap ? "#define USE_SPECULARMAP" : "",
        i.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        i.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        i.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        i.metalnessMap ? "#define USE_METALNESSMAP" : "",
        i.alphaMap ? "#define USE_ALPHAMAP" : "",
        i.alphaTest ? "#define USE_ALPHATEST" : "",
        i.alphaHash ? "#define USE_ALPHAHASH" : "",
        i.sheen ? "#define USE_SHEEN" : "",
        i.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        i.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        i.transmission ? "#define USE_TRANSMISSION" : "",
        i.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        i.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        i.vertexTangents && !1 === i.flatShading ? "#define USE_TANGENT" : "",
        i.vertexColors || i.instancingColor ? "#define USE_COLOR" : "",
        i.vertexAlphas || i.batchingColor ? "#define USE_COLOR_ALPHA" : "",
        i.vertexUv1s ? "#define USE_UV1" : "",
        i.vertexUv2s ? "#define USE_UV2" : "",
        i.vertexUv3s ? "#define USE_UV3" : "",
        i.pointsUvs ? "#define USE_POINTS_UV" : "",
        i.gradientMap ? "#define USE_GRADIENTMAP" : "",
        i.flatShading ? "#define FLAT_SHADED" : "",
        i.doubleSided ? "#define DOUBLE_SIDED" : "",
        i.flipSided ? "#define FLIP_SIDED" : "",
        i.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        i.shadowMapEnabled ? "#define " + l : "",
        i.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        i.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        i.numLightProbeGrids > 0 ? "#define USE_LIGHT_PROBES_GRID" : "",
        i.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        i.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        i.logarithmicDepthBuffer ? "#define USE_LOGARITHMIC_DEPTH_BUFFER" : "",
        i.reversedDepthBuffer ? "#define USE_REVERSED_DEPTH_BUFFER" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        0 !== i.toneMapping ? "#define TONE_MAPPING" : "",
        0 !== i.toneMapping ? $785da19a645c07eb$var$pH.tonemapping_pars_fragment : "",
        0 !== i.toneMapping ? $785da19a645c07eb$var$sZ("toneMapping", i.toneMapping) : "",
        i.dithering ? "#define DITHERING" : "",
        i.opaque ? "#define OPAQUE" : "",
        $785da19a645c07eb$var$pH.colorspace_pars_fragment,
        $785da19a645c07eb$var$aZ("linearToOutputTexel", i.outputColorSpace),
        $785da19a645c07eb$var$lZ(),
        i.useDepthPacking ? "#define DEPTH_PACKING " + i.depthPacking : "",
        "\n"
    ].filter($785da19a645c07eb$var$cZ).join("\n")), s = $785da19a645c07eb$var$pZ(s), s = $785da19a645c07eb$var$uZ(s, i), s = $785da19a645c07eb$var$hZ(s, i), o = $785da19a645c07eb$var$pZ(o), o = $785da19a645c07eb$var$uZ(o, i), o = $785da19a645c07eb$var$hZ(o, i), s = $785da19a645c07eb$var$AZ(s), o = $785da19a645c07eb$var$AZ(o), !0 !== i.isRawShaderMaterial && (_ = "#version 300 es\n", f = [
        p,
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join("\n") + "\n" + f, A = [
        "#define varying in",
        i.glslVersion === $785da19a645c07eb$var$JN ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        i.glslVersion === $785da19a645c07eb$var$JN ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join("\n") + "\n" + A);
    const v = _ + f + s, y = _ + A + o, x = $785da19a645c07eb$var$eZ(a, a.VERTEX_SHADER, v), b = $785da19a645c07eb$var$eZ(a, a.FRAGMENT_SHADER, y);
    function w(t) {
        if (e1.debug.checkShaderErrors) {
            const i = a.getProgramInfoLog(g) || "", n = a.getShaderInfoLog(x) || "", r = a.getShaderInfoLog(b) || "", s = i.trim(), o = n.trim(), l = r.trim();
            let c = !0, u = !0;
            if (!1 === a.getProgramParameter(g, a.LINK_STATUS)) {
                if (c = !1, "function" == typeof e1.debug.onShaderError) e1.debug.onShaderError(a, g, x, b);
                else {
                    const e1 = $785da19a645c07eb$var$nZ(a, x, "vertex"), i = $785da19a645c07eb$var$nZ(a, b, "fragment");
                    $785da19a645c07eb$var$oj("WebGLProgram: Shader Error " + a.getError() + " - VALIDATE_STATUS " + a.getProgramParameter(g, a.VALIDATE_STATUS) + "\n\nMaterial Name: " + t.name + "\nMaterial Type: " + t.type + "\n\nProgram Info Log: " + s + "\n" + e1 + "\n" + i);
                }
            } else "" !== s ? $785da19a645c07eb$var$sj("WebGLProgram: Program Info Log:", s) : "" !== o && "" !== l || (u = !1);
            u && (t.diagnostics = {
                runnable: c,
                programLog: s,
                vertexShader: {
                    log: o,
                    prefix: f
                },
                fragmentShader: {
                    log: l,
                    prefix: A
                }
            });
        }
        a.deleteShader(x), a.deleteShader(b), E = new $785da19a645c07eb$var$$W(a, g), k = function(e1, t) {
            const i = {}, n = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
            for(let a = 0; a < n; a++){
                const n = e1.getActiveAttrib(t, a), r = n.name;
                let s = 1;
                n.type === e1.FLOAT_MAT2 && (s = 2), n.type === e1.FLOAT_MAT3 && (s = 3), n.type === e1.FLOAT_MAT4 && (s = 4), i[r] = {
                    type: n.type,
                    location: e1.getAttribLocation(t, r),
                    locationSize: s
                };
            }
            return i;
        }(a, g);
    }
    let E, k;
    a.attachShader(g, x), a.attachShader(g, b), void 0 !== i.index0AttributeName ? a.bindAttribLocation(g, 0, i.index0AttributeName) : !0 === i.hasPositionAttribute && a.bindAttribLocation(g, 0, "position"), a.linkProgram(g), this.getUniforms = function() {
        return void 0 === E && w(this), E;
    }, this.getAttributes = function() {
        return void 0 === k && w(this), k;
    };
    let S = !1 === i.rendererExtensionParallelShaderCompile;
    return this.isReady = function() {
        return !1 === S && (S = a.getProgramParameter(g, 37297)), S;
    }, this.destroy = function() {
        n.releaseStatesOfProgram(this), a.deleteProgram(g), this.program = void 0;
    }, this.type = i.shaderType, this.name = i.shaderName, this.id = $785da19a645c07eb$var$tZ++, this.cacheKey = t, this.usedTimes = 1, this.program = g, this.vertexShader = x, this.fragmentShader = b, this;
}
let $785da19a645c07eb$var$kZ = 0;
class $785da19a645c07eb$var$SZ {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(e1, t, i) {
        const n = this._getShaderCacheForMaterial(e1);
        return !1 === n.has(t) && (n.add(t), t.usedTimes++), !1 === n.has(i) && (n.add(i), i.usedTimes++), this;
    }
    remove(e1) {
        const t = this.materialCache.get(e1);
        for (const e1 of t)e1.usedTimes--, 0 === e1.usedTimes && this.shaderCache.delete(e1.code);
        return this.materialCache.delete(e1), this;
    }
    getVertexShaderStage(e1) {
        return this._getShaderStage(e1.vertexShader);
    }
    getFragmentShaderStage(e1) {
        return this._getShaderStage(e1.fragmentShader);
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(e1) {
        const t = this.materialCache;
        let i = t.get(e1);
        return void 0 === i && (i = new Set, t.set(e1, i)), i;
    }
    _getShaderStage(e1) {
        const t = this.shaderCache;
        let i = t.get(e1);
        return void 0 === i && (i = new $785da19a645c07eb$var$MZ(e1), t.set(e1, i)), i;
    }
}
class $785da19a645c07eb$var$MZ {
    constructor(e1){
        this.id = $785da19a645c07eb$var$kZ++, this.code = e1, this.usedTimes = 0;
    }
}
function $785da19a645c07eb$var$CZ(e1, t, i, n, a, r) {
    const s = new $785da19a645c07eb$var$rV, o = new $785da19a645c07eb$var$SZ, l = new Set, c = [], u = new Map, h = n.logarithmicDepthBuffer;
    let d = n.precision;
    const p = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distance",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function m(e1) {
        return l.add(e1), 0 === e1 ? "uv" : `uv${e1}`;
    }
    return {
        getParameters: function(a, s, c, u, g, f) {
            const A = u.fog, _ = g.geometry, v = a.isMeshStandardMaterial || a.isMeshLambertMaterial || a.isMeshPhongMaterial ? u.environment : null, y = a.isMeshStandardMaterial || a.isMeshLambertMaterial && !a.envMap || a.isMeshPhongMaterial && !a.envMap, x = t.get(a.envMap || v, y), b = x && x.mapping === $785da19a645c07eb$var$SU ? x.image.height : null, w = p[a.type];
            null !== a.precision && (d = n.getMaxPrecision(a.precision), d !== a.precision && $785da19a645c07eb$var$sj("WebGLProgram.getParameters:", a.precision, "not supported, using", d, "instead."));
            const E = _.morphAttributes.position || _.morphAttributes.normal || _.morphAttributes.color, k = void 0 !== E ? E.length : 0;
            let S, M, C, T, D = 0;
            if (void 0 !== _.morphAttributes.position && (D = 1), void 0 !== _.morphAttributes.normal && (D = 2), void 0 !== _.morphAttributes.color && (D = 3), w) {
                const e1 = $785da19a645c07eb$var$gH[w];
                S = e1.vertexShader, M = e1.fragmentShader;
            } else {
                S = a.vertexShader, M = a.fragmentShader;
                const e1 = o.getVertexShaderStage(a), t = o.getFragmentShaderStage(a);
                o.update(a, e1, t), C = e1.id, T = t.id;
            }
            const P = e1.getRenderTarget(), I = e1.state.buffers.depth.getReversed(), F = !0 === g.isInstancedMesh, z = !0 === g.isBatchedMesh, R = !!a.map, L1 = !!a.matcap, B = !!x, O = !!a.aoMap, U = !!a.lightMap, N = !!a.bumpMap && !1 === a.wireframe, j = !!a.normalMap, V = !!a.displacementMap, q = !!a.emissiveMap, G = !!a.metalnessMap, H = !!a.roughnessMap, W = a.anisotropy > 0, Z = a.clearcoat > 0, K = a.dispersion > 0, X = a.iridescence > 0, Q = a.sheen > 0, Y = a.transmission > 0, J = W && !!a.anisotropyMap, $ = Z && !!a.clearcoatMap, ee = Z && !!a.clearcoatNormalMap, te = Z && !!a.clearcoatRoughnessMap, ie = X && !!a.iridescenceMap, ne = X && !!a.iridescenceThicknessMap, ae = Q && !!a.sheenColorMap, re = Q && !!a.sheenRoughnessMap, se = !!a.specularMap, oe = !!a.specularColorMap, le = !!a.specularIntensityMap, ce = Y && !!a.transmissionMap, ue = Y && !!a.thicknessMap, he = !!a.gradientMap, de = !!a.alphaMap, pe = a.alphaTest > 0, me = !!a.alphaHash, ge = !!a.extensions;
            let fe = 0;
            a.toneMapped && (null !== P && !0 !== P.isXRRenderTarget || (fe = e1.toneMapping));
            const Ae = {
                shaderID: w,
                shaderType: a.type,
                shaderName: a.name,
                vertexShader: S,
                fragmentShader: M,
                defines: a.defines,
                customVertexShaderID: C,
                customFragmentShaderID: T,
                isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                glslVersion: a.glslVersion,
                precision: d,
                batching: z,
                batchingColor: z && null !== g._colorsTexture,
                instancing: F,
                instancingColor: F && null !== g.instanceColor,
                instancingMorph: F && null !== g.morphTexture,
                outputColorSpace: null === P ? e1.outputColorSpace : !0 === P.isXRRenderTarget ? P.texture.colorSpace : $785da19a645c07eb$var$Ij.workingColorSpace,
                alphaToCoverage: !!a.alphaToCoverage,
                map: R,
                matcap: L1,
                envMap: B,
                envMapMode: B && x.mapping,
                envMapCubeUVHeight: b,
                aoMap: O,
                lightMap: U,
                bumpMap: N,
                normalMap: j,
                displacementMap: V,
                emissiveMap: q,
                normalMapObjectSpace: j && 1 === a.normalMapType,
                normalMapTangentSpace: j && 0 === a.normalMapType,
                packedNormalMap: j && 0 === a.normalMapType && (_e = a.normalMap.format, _e === $785da19a645c07eb$var$$U || _e === $785da19a645c07eb$var$gN || _e === $785da19a645c07eb$var$LN),
                metalnessMap: G,
                roughnessMap: H,
                anisotropy: W,
                anisotropyMap: J,
                clearcoat: Z,
                clearcoatMap: $,
                clearcoatNormalMap: ee,
                clearcoatRoughnessMap: te,
                dispersion: K,
                iridescence: X,
                iridescenceMap: ie,
                iridescenceThicknessMap: ne,
                sheen: Q,
                sheenColorMap: ae,
                sheenRoughnessMap: re,
                specularMap: se,
                specularColorMap: oe,
                specularIntensityMap: le,
                transmission: Y,
                transmissionMap: ce,
                thicknessMap: ue,
                gradientMap: he,
                opaque: !1 === a.transparent && 1 === a.blending && !1 === a.alphaToCoverage,
                alphaMap: de,
                alphaTest: pe,
                alphaHash: me,
                combine: a.combine,
                mapUv: R && m(a.map.channel),
                aoMapUv: O && m(a.aoMap.channel),
                lightMapUv: U && m(a.lightMap.channel),
                bumpMapUv: N && m(a.bumpMap.channel),
                normalMapUv: j && m(a.normalMap.channel),
                displacementMapUv: V && m(a.displacementMap.channel),
                emissiveMapUv: q && m(a.emissiveMap.channel),
                metalnessMapUv: G && m(a.metalnessMap.channel),
                roughnessMapUv: H && m(a.roughnessMap.channel),
                anisotropyMapUv: J && m(a.anisotropyMap.channel),
                clearcoatMapUv: $ && m(a.clearcoatMap.channel),
                clearcoatNormalMapUv: ee && m(a.clearcoatNormalMap.channel),
                clearcoatRoughnessMapUv: te && m(a.clearcoatRoughnessMap.channel),
                iridescenceMapUv: ie && m(a.iridescenceMap.channel),
                iridescenceThicknessMapUv: ne && m(a.iridescenceThicknessMap.channel),
                sheenColorMapUv: ae && m(a.sheenColorMap.channel),
                sheenRoughnessMapUv: re && m(a.sheenRoughnessMap.channel),
                specularMapUv: se && m(a.specularMap.channel),
                specularColorMapUv: oe && m(a.specularColorMap.channel),
                specularIntensityMapUv: le && m(a.specularIntensityMap.channel),
                transmissionMapUv: ce && m(a.transmissionMap.channel),
                thicknessMapUv: ue && m(a.thicknessMap.channel),
                alphaMapUv: de && m(a.alphaMap.channel),
                vertexTangents: !!_.attributes.tangent && (j || W),
                vertexNormals: !!_.attributes.normal,
                vertexColors: a.vertexColors,
                vertexAlphas: !0 === a.vertexColors && !!_.attributes.color && 4 === _.attributes.color.itemSize,
                pointsUvs: !0 === g.isPoints && !!_.attributes.uv && (R || de),
                fog: !!A,
                useFog: !0 === a.fog,
                fogExp2: !!A && A.isFogExp2,
                flatShading: !1 === a.wireframe && (!0 === a.flatShading || void 0 === _.attributes.normal && !1 === j && (a.isMeshLambertMaterial || a.isMeshPhongMaterial || a.isMeshStandardMaterial || a.isMeshPhysicalMaterial)),
                sizeAttenuation: !0 === a.sizeAttenuation,
                logarithmicDepthBuffer: h,
                reversedDepthBuffer: I,
                skinning: !0 === g.isSkinnedMesh,
                hasPositionAttribute: void 0 !== _.attributes.position,
                morphTargets: void 0 !== _.morphAttributes.position,
                morphNormals: void 0 !== _.morphAttributes.normal,
                morphColors: void 0 !== _.morphAttributes.color,
                morphTargetsCount: k,
                morphTextureStride: D,
                numDirLights: s.directional.length,
                numPointLights: s.point.length,
                numSpotLights: s.spot.length,
                numSpotLightMaps: s.spotLightMap.length,
                numRectAreaLights: s.rectArea.length,
                numHemiLights: s.hemi.length,
                numDirLightShadows: s.directionalShadowMap.length,
                numPointLightShadows: s.pointShadowMap.length,
                numSpotLightShadows: s.spotShadowMap.length,
                numSpotLightShadowsWithMaps: s.numSpotLightShadowsWithMaps,
                numLightProbes: s.numLightProbes,
                numLightProbeGrids: f.length,
                numClippingPlanes: r.numPlanes,
                numClipIntersection: r.numIntersection,
                dithering: a.dithering,
                shadowMapEnabled: e1.shadowMap.enabled && c.length > 0,
                shadowMapType: e1.shadowMap.type,
                toneMapping: fe,
                decodeVideoTexture: R && !0 === a.map.isVideoTexture && $785da19a645c07eb$var$Ij.getTransfer(a.map.colorSpace) === $785da19a645c07eb$var$VN,
                decodeVideoTextureEmissive: q && !0 === a.emissiveMap.isVideoTexture && $785da19a645c07eb$var$Ij.getTransfer(a.emissiveMap.colorSpace) === $785da19a645c07eb$var$VN,
                premultipliedAlpha: a.premultipliedAlpha,
                doubleSided: 2 === a.side,
                flipSided: 1 === a.side,
                useDepthPacking: a.depthPacking >= 0,
                depthPacking: a.depthPacking || 0,
                index0AttributeName: a.index0AttributeName,
                extensionClipCullDistance: ge && !0 === a.extensions.clipCullDistance && i.has("WEBGL_clip_cull_distance"),
                extensionMultiDraw: (ge && !0 === a.extensions.multiDraw || z) && i.has("WEBGL_multi_draw"),
                rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                customProgramCacheKey: a.customProgramCacheKey()
            };
            var _e;
            return Ae.vertexUv1s = l.has(1), Ae.vertexUv2s = l.has(2), Ae.vertexUv3s = l.has(3), l.clear(), Ae;
        },
        getProgramCacheKey: function(t) {
            const i = [];
            if (t.shaderID ? i.push(t.shaderID) : (i.push(t.customVertexShaderID), i.push(t.customFragmentShaderID)), void 0 !== t.defines) for(const e1 in t.defines)i.push(e1), i.push(t.defines[e1]);
            return !1 === t.isRawShaderMaterial && (!function(e1, t) {
                e1.push(t.precision), e1.push(t.outputColorSpace), e1.push(t.envMapMode), e1.push(t.envMapCubeUVHeight), e1.push(t.mapUv), e1.push(t.alphaMapUv), e1.push(t.lightMapUv), e1.push(t.aoMapUv), e1.push(t.bumpMapUv), e1.push(t.normalMapUv), e1.push(t.displacementMapUv), e1.push(t.emissiveMapUv), e1.push(t.metalnessMapUv), e1.push(t.roughnessMapUv), e1.push(t.anisotropyMapUv), e1.push(t.clearcoatMapUv), e1.push(t.clearcoatNormalMapUv), e1.push(t.clearcoatRoughnessMapUv), e1.push(t.iridescenceMapUv), e1.push(t.iridescenceThicknessMapUv), e1.push(t.sheenColorMapUv), e1.push(t.sheenRoughnessMapUv), e1.push(t.specularMapUv), e1.push(t.specularColorMapUv), e1.push(t.specularIntensityMapUv), e1.push(t.transmissionMapUv), e1.push(t.thicknessMapUv), e1.push(t.combine), e1.push(t.fogExp2), e1.push(t.sizeAttenuation), e1.push(t.morphTargetsCount), e1.push(t.morphAttributeCount), e1.push(t.numDirLights), e1.push(t.numPointLights), e1.push(t.numSpotLights), e1.push(t.numSpotLightMaps), e1.push(t.numHemiLights), e1.push(t.numRectAreaLights), e1.push(t.numDirLightShadows), e1.push(t.numPointLightShadows), e1.push(t.numSpotLightShadows), e1.push(t.numSpotLightShadowsWithMaps), e1.push(t.numLightProbes), e1.push(t.shadowMapType), e1.push(t.toneMapping), e1.push(t.numClippingPlanes), e1.push(t.numClipIntersection), e1.push(t.depthPacking);
            }(i, t), function(e1, t) {
                s.disableAll(), t.instancing && s.enable(0);
                t.instancingColor && s.enable(1);
                t.instancingMorph && s.enable(2);
                t.matcap && s.enable(3);
                t.envMap && s.enable(4);
                t.normalMapObjectSpace && s.enable(5);
                t.normalMapTangentSpace && s.enable(6);
                t.clearcoat && s.enable(7);
                t.iridescence && s.enable(8);
                t.alphaTest && s.enable(9);
                t.vertexColors && s.enable(10);
                t.vertexAlphas && s.enable(11);
                t.vertexUv1s && s.enable(12);
                t.vertexUv2s && s.enable(13);
                t.vertexUv3s && s.enable(14);
                t.vertexTangents && s.enable(15);
                t.anisotropy && s.enable(16);
                t.alphaHash && s.enable(17);
                t.batching && s.enable(18);
                t.dispersion && s.enable(19);
                t.batchingColor && s.enable(20);
                t.gradientMap && s.enable(21);
                t.packedNormalMap && s.enable(22);
                t.vertexNormals && s.enable(23);
                e1.push(s.mask), s.disableAll(), t.fog && s.enable(0);
                t.useFog && s.enable(1);
                t.flatShading && s.enable(2);
                t.logarithmicDepthBuffer && s.enable(3);
                t.reversedDepthBuffer && s.enable(4);
                t.skinning && s.enable(5);
                t.morphTargets && s.enable(6);
                t.morphNormals && s.enable(7);
                t.morphColors && s.enable(8);
                t.premultipliedAlpha && s.enable(9);
                t.shadowMapEnabled && s.enable(10);
                t.doubleSided && s.enable(11);
                t.flipSided && s.enable(12);
                t.useDepthPacking && s.enable(13);
                t.dithering && s.enable(14);
                t.transmission && s.enable(15);
                t.sheen && s.enable(16);
                t.opaque && s.enable(17);
                t.pointsUvs && s.enable(18);
                t.decodeVideoTexture && s.enable(19);
                t.decodeVideoTextureEmissive && s.enable(20);
                t.alphaToCoverage && s.enable(21);
                t.numLightProbeGrids > 0 && s.enable(22);
                t.hasPositionAttribute && s.enable(23);
                e1.push(s.mask);
            }(i, t), i.push(e1.outputColorSpace)), i.push(t.customProgramCacheKey), i.join();
        },
        getUniforms: function(e1) {
            const t = p[e1.type];
            let i;
            if (t) {
                const e1 = $785da19a645c07eb$var$gH[t];
                i = $785da19a645c07eb$var$IG.clone(e1.uniforms);
            } else i = e1.uniforms;
            return i;
        },
        acquireProgram: function(t, i) {
            let n = u.get(i);
            return void 0 !== n ? ++n.usedTimes : (n = new $785da19a645c07eb$var$EZ(e1, i, t, a), c.push(n), u.set(i, n)), n;
        },
        releaseProgram: function(e1) {
            if (0 === --e1.usedTimes) {
                const t = c.indexOf(e1);
                c[t] = c[c.length - 1], c.pop(), u.delete(e1.cacheKey), e1.destroy();
            }
        },
        releaseShaderCache: function(e1) {
            o.remove(e1);
        },
        programs: c,
        dispose: function() {
            o.dispose();
        }
    };
}
function $785da19a645c07eb$var$TZ() {
    let e1 = new WeakMap;
    return {
        has: function(t) {
            return e1.has(t);
        },
        get: function(t) {
            let i = e1.get(t);
            return void 0 === i && (i = {}, e1.set(t, i)), i;
        },
        remove: function(t) {
            e1.delete(t);
        },
        update: function(t, i, n) {
            e1.get(t)[i] = n;
        },
        dispose: function() {
            e1 = new WeakMap;
        }
    };
}
function $785da19a645c07eb$var$DZ(e1, t) {
    return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.material.id !== t.material.id ? e1.material.id - t.material.id : e1.materialVariant !== t.materialVariant ? e1.materialVariant - t.materialVariant : e1.z !== t.z ? e1.z - t.z : e1.id - t.id;
}
function $785da19a645c07eb$var$PZ(e1, t) {
    return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.z !== t.z ? t.z - e1.z : e1.id - t.id;
}
function $785da19a645c07eb$var$IZ() {
    const e1 = [];
    let t = 0;
    const i = [], n = [], a = [];
    function r(e1) {
        let t = 0;
        return e1.isInstancedMesh && (t += 2), e1.isSkinnedMesh && (t += 1), t;
    }
    function s(i, n, a, s, o, l) {
        let c = e1[t];
        return void 0 === c ? (c = {
            id: i.id,
            object: i,
            geometry: n,
            material: a,
            materialVariant: r(i),
            groupOrder: s,
            renderOrder: i.renderOrder,
            z: o,
            group: l
        }, e1[t] = c) : (c.id = i.id, c.object = i, c.geometry = n, c.material = a, c.materialVariant = r(i), c.groupOrder = s, c.renderOrder = i.renderOrder, c.z = o, c.group = l), t++, c;
    }
    return {
        opaque: i,
        transmissive: n,
        transparent: a,
        init: function() {
            t = 0, i.length = 0, n.length = 0, a.length = 0;
        },
        push: function(e1, t, r, o, l, c) {
            const u = s(e1, t, r, o, l, c);
            r.transmission > 0 ? n.push(u) : !0 === r.transparent ? a.push(u) : i.push(u);
        },
        unshift: function(e1, t, r, o, l, c) {
            const u = s(e1, t, r, o, l, c);
            r.transmission > 0 ? n.unshift(u) : !0 === r.transparent ? a.unshift(u) : i.unshift(u);
        },
        finish: function() {
            for(let i = t, n = e1.length; i < n; i++){
                const t = e1[i];
                if (null === t.id) break;
                t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
            }
        },
        sort: function(e1, t, r) {
            i.length > 1 && i.sort(e1 || $785da19a645c07eb$var$DZ), n.length > 1 && n.sort(t || $785da19a645c07eb$var$PZ), a.length > 1 && a.sort(t || $785da19a645c07eb$var$PZ), r && (i.reverse(), n.reverse(), a.reverse());
        }
    };
}
function $785da19a645c07eb$var$FZ() {
    let e1 = new WeakMap;
    return {
        get: function(t, i) {
            const n = e1.get(t);
            let a;
            return void 0 === n ? (a = new $785da19a645c07eb$var$IZ, e1.set(t, [
                a
            ])) : i >= n.length ? (a = new $785da19a645c07eb$var$IZ, n.push(a)) : a = n[i], a;
        },
        dispose: function() {
            e1 = new WeakMap;
        }
    };
}
function $785da19a645c07eb$var$zZ() {
    const e1 = {};
    return {
        get: function(t) {
            if (void 0 !== e1[t.id]) return e1[t.id];
            let i;
            switch(t.type){
                case "DirectionalLight":
                    i = {
                        direction: new $785da19a645c07eb$var$Ej,
                        color: new $785da19a645c07eb$var$TV
                    };
                    break;
                case "SpotLight":
                    i = {
                        position: new $785da19a645c07eb$var$Ej,
                        direction: new $785da19a645c07eb$var$Ej,
                        color: new $785da19a645c07eb$var$TV,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    i = {
                        position: new $785da19a645c07eb$var$Ej,
                        color: new $785da19a645c07eb$var$TV,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    i = {
                        direction: new $785da19a645c07eb$var$Ej,
                        skyColor: new $785da19a645c07eb$var$TV,
                        groundColor: new $785da19a645c07eb$var$TV
                    };
                    break;
                case "RectAreaLight":
                    i = {
                        color: new $785da19a645c07eb$var$TV,
                        position: new $785da19a645c07eb$var$Ej,
                        halfWidth: new $785da19a645c07eb$var$Ej,
                        halfHeight: new $785da19a645c07eb$var$Ej
                    };
            }
            return e1[t.id] = i, i;
        }
    };
}
let $785da19a645c07eb$var$RZ = 0;
function $785da19a645c07eb$var$LZ(e1, t) {
    return (t.castShadow ? 2 : 0) - (e1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e1.map ? 1 : 0);
}
function $785da19a645c07eb$var$BZ(e1) {
    const t = new $785da19a645c07eb$var$zZ, i = function() {
        const e1 = {};
        return {
            get: function(t) {
                if (void 0 !== e1[t.id]) return e1[t.id];
                let i;
                switch(t.type){
                    case "DirectionalLight":
                    case "SpotLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $785da19a645c07eb$var$bj
                        };
                        break;
                    case "PointLight":
                        i = {
                            shadowIntensity: 1,
                            shadowBias: 0,
                            shadowNormalBias: 0,
                            shadowRadius: 1,
                            shadowMapSize: new $785da19a645c07eb$var$bj,
                            shadowCameraNear: 1,
                            shadowCameraFar: 1e3
                        };
                }
                return e1[t.id] = i, i;
            }
        };
    }(), n = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let e1 = 0; e1 < 9; e1++)n.probe.push(new $785da19a645c07eb$var$Ej);
    const a = new $785da19a645c07eb$var$Ej, r = new $785da19a645c07eb$var$Kj, s = new $785da19a645c07eb$var$Kj;
    return {
        setup: function(a) {
            let r = 0, s = 0, o = 0;
            for(let e1 = 0; e1 < 9; e1++)n.probe[e1].set(0, 0, 0);
            let l = 0, c = 0, u = 0, h = 0, d = 0, p = 0, m = 0, g = 0, f = 0, A = 0, _ = 0;
            a.sort($785da19a645c07eb$var$LZ);
            for(let e1 = 0, v = a.length; e1 < v; e1++){
                const v = a[e1], y = v.color, x = v.intensity, b = v.distance;
                let w = null;
                if (v.shadow && v.shadow.map && (w = v.shadow.map.texture.format === $785da19a645c07eb$var$$U ? v.shadow.map.texture : v.shadow.map.depthTexture || v.shadow.map.texture), v.isAmbientLight) r += y.r * x, s += y.g * x, o += y.b * x;
                else if (v.isLightProbe) {
                    for(let e1 = 0; e1 < 9; e1++)n.probe[e1].addScaledVector(v.sh.coefficients[e1], x);
                    _++;
                } else if (v.isDirectionalLight) {
                    const e1 = t.get(v);
                    if (e1.color.copy(v.color).multiplyScalar(v.intensity), v.castShadow) {
                        const e1 = v.shadow, t = i.get(v);
                        t.shadowIntensity = e1.intensity, t.shadowBias = e1.bias, t.shadowNormalBias = e1.normalBias, t.shadowRadius = e1.radius, t.shadowMapSize = e1.mapSize, n.directionalShadow[l] = t, n.directionalShadowMap[l] = w, n.directionalShadowMatrix[l] = v.shadow.matrix, p++;
                    }
                    n.directional[l] = e1, l++;
                } else if (v.isSpotLight) {
                    const e1 = t.get(v);
                    e1.position.setFromMatrixPosition(v.matrixWorld), e1.color.copy(y).multiplyScalar(x), e1.distance = b, e1.coneCos = Math.cos(v.angle), e1.penumbraCos = Math.cos(v.angle * (1 - v.penumbra)), e1.decay = v.decay, n.spot[u] = e1;
                    const a = v.shadow;
                    if (v.map && (n.spotLightMap[f] = v.map, f++, a.updateMatrices(v), v.castShadow && A++), n.spotLightMatrix[u] = a.matrix, v.castShadow) {
                        const e1 = i.get(v);
                        e1.shadowIntensity = a.intensity, e1.shadowBias = a.bias, e1.shadowNormalBias = a.normalBias, e1.shadowRadius = a.radius, e1.shadowMapSize = a.mapSize, n.spotShadow[u] = e1, n.spotShadowMap[u] = w, g++;
                    }
                    u++;
                } else if (v.isRectAreaLight) {
                    const e1 = t.get(v);
                    e1.color.copy(y).multiplyScalar(x), e1.halfWidth.set(.5 * v.width, 0, 0), e1.halfHeight.set(0, .5 * v.height, 0), n.rectArea[h] = e1, h++;
                } else if (v.isPointLight) {
                    const e1 = t.get(v);
                    if (e1.color.copy(v.color).multiplyScalar(v.intensity), e1.distance = v.distance, e1.decay = v.decay, v.castShadow) {
                        const e1 = v.shadow, t = i.get(v);
                        t.shadowIntensity = e1.intensity, t.shadowBias = e1.bias, t.shadowNormalBias = e1.normalBias, t.shadowRadius = e1.radius, t.shadowMapSize = e1.mapSize, t.shadowCameraNear = e1.camera.near, t.shadowCameraFar = e1.camera.far, n.pointShadow[c] = t, n.pointShadowMap[c] = w, n.pointShadowMatrix[c] = v.shadow.matrix, m++;
                    }
                    n.point[c] = e1, c++;
                } else if (v.isHemisphereLight) {
                    const e1 = t.get(v);
                    e1.skyColor.copy(v.color).multiplyScalar(x), e1.groundColor.copy(v.groundColor).multiplyScalar(x), n.hemi[d] = e1, d++;
                }
            }
            h > 0 && (!0 === e1.has("OES_texture_float_linear") ? (n.rectAreaLTC1 = $785da19a645c07eb$var$mH.LTC_FLOAT_1, n.rectAreaLTC2 = $785da19a645c07eb$var$mH.LTC_FLOAT_2) : (n.rectAreaLTC1 = $785da19a645c07eb$var$mH.LTC_HALF_1, n.rectAreaLTC2 = $785da19a645c07eb$var$mH.LTC_HALF_2)), n.ambient[0] = r, n.ambient[1] = s, n.ambient[2] = o;
            const v = n.hash;
            v.directionalLength === l && v.pointLength === c && v.spotLength === u && v.rectAreaLength === h && v.hemiLength === d && v.numDirectionalShadows === p && v.numPointShadows === m && v.numSpotShadows === g && v.numSpotMaps === f && v.numLightProbes === _ || (n.directional.length = l, n.spot.length = u, n.rectArea.length = h, n.point.length = c, n.hemi.length = d, n.directionalShadow.length = p, n.directionalShadowMap.length = p, n.pointShadow.length = m, n.pointShadowMap.length = m, n.spotShadow.length = g, n.spotShadowMap.length = g, n.directionalShadowMatrix.length = p, n.pointShadowMatrix.length = m, n.spotLightMatrix.length = g + f - A, n.spotLightMap.length = f, n.numSpotLightShadowsWithMaps = A, n.numLightProbes = _, v.directionalLength = l, v.pointLength = c, v.spotLength = u, v.rectAreaLength = h, v.hemiLength = d, v.numDirectionalShadows = p, v.numPointShadows = m, v.numSpotShadows = g, v.numSpotMaps = f, v.numLightProbes = _, n.version = $785da19a645c07eb$var$RZ++);
        },
        setupView: function(e1, t) {
            let i = 0, o = 0, l = 0, c = 0, u = 0;
            const h = t.matrixWorldInverse;
            for(let t = 0, d = e1.length; t < d; t++){
                const d = e1[t];
                if (d.isDirectionalLight) {
                    const e1 = n.directional[i];
                    e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), i++;
                } else if (d.isSpotLight) {
                    const e1 = n.spot[l];
                    e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), l++;
                } else if (d.isRectAreaLight) {
                    const e1 = n.rectArea[c];
                    e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), s.identity(), r.copy(d.matrixWorld), r.premultiply(h), s.extractRotation(r), e1.halfWidth.set(.5 * d.width, 0, 0), e1.halfHeight.set(0, .5 * d.height, 0), e1.halfWidth.applyMatrix4(s), e1.halfHeight.applyMatrix4(s), c++;
                } else if (d.isPointLight) {
                    const e1 = n.point[o];
                    e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), o++;
                } else if (d.isHemisphereLight) {
                    const e1 = n.hemi[u];
                    e1.direction.setFromMatrixPosition(d.matrixWorld), e1.direction.transformDirection(h), u++;
                }
            }
        },
        state: n
    };
}
function $785da19a645c07eb$var$OZ(e1) {
    const t = new $785da19a645c07eb$var$BZ(e1), i = [], n = [], a = [];
    const r = {
        lightsArray: i,
        shadowsArray: n,
        lightProbeGridArray: a,
        camera: null,
        lights: t,
        transmissionRenderTarget: {},
        textureUnits: 0
    };
    return {
        init: function(e1) {
            r.camera = e1, i.length = 0, n.length = 0, a.length = 0;
        },
        state: r,
        setupLights: function() {
            t.setup(i);
        },
        setupLightsView: function(e1) {
            t.setupView(i, e1);
        },
        pushLight: function(e1) {
            i.push(e1);
        },
        pushShadow: function(e1) {
            n.push(e1);
        },
        pushLightProbeGrid: function(e1) {
            a.push(e1);
        }
    };
}
function $785da19a645c07eb$var$UZ(e1) {
    let t = new WeakMap;
    return {
        get: function(i, n = 0) {
            const a = t.get(i);
            let r;
            return void 0 === a ? (r = new $785da19a645c07eb$var$OZ(e1), t.set(i, [
                r
            ])) : n >= a.length ? (r = new $785da19a645c07eb$var$OZ(e1), a.push(r)) : r = a[n], r;
        },
        dispose: function() {
            t = new WeakMap;
        }
    };
}
const $785da19a645c07eb$var$NZ = [
    new $785da19a645c07eb$var$Ej(1, 0, 0),
    new $785da19a645c07eb$var$Ej(-1, 0, 0),
    new $785da19a645c07eb$var$Ej(0, 1, 0),
    new $785da19a645c07eb$var$Ej(0, -1, 0),
    new $785da19a645c07eb$var$Ej(0, 0, 1),
    new $785da19a645c07eb$var$Ej(0, 0, -1)
], $785da19a645c07eb$var$jZ = [
    new $785da19a645c07eb$var$Ej(0, -1, 0),
    new $785da19a645c07eb$var$Ej(0, -1, 0),
    new $785da19a645c07eb$var$Ej(0, 0, 1),
    new $785da19a645c07eb$var$Ej(0, 0, -1),
    new $785da19a645c07eb$var$Ej(0, -1, 0),
    new $785da19a645c07eb$var$Ej(0, -1, 0)
], $785da19a645c07eb$var$VZ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$qZ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$GZ = new $785da19a645c07eb$var$Ej;
function $785da19a645c07eb$var$HZ(e1, t, i) {
    let n = new $785da19a645c07eb$var$aG;
    const a = new $785da19a645c07eb$var$bj, r = new $785da19a645c07eb$var$bj, s = new $785da19a645c07eb$var$qj, o = new $785da19a645c07eb$var$RG, l = new $785da19a645c07eb$var$LG, c = {}, u = i.maxTextureSize, h = {
        [$785da19a645c07eb$var$BO]: 1,
        [$785da19a645c07eb$var$OO]: 0,
        [$785da19a645c07eb$var$UO]: 2
    }, d = new $785da19a645c07eb$var$FG({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new $785da19a645c07eb$var$bj
            },
            radius: {
                value: 4
            }
        },
        vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}"
    }), p = d.clone();
    p.defines.HORIZONTAL_PASS = 1;
    const m = new $785da19a645c07eb$var$kq;
    m.setAttribute("position", new $785da19a645c07eb$var$uq(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    const g = new $785da19a645c07eb$var$Kq(m, d), f = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = 1;
    let A = this.type;
    function _(i, n) {
        const r = t.update(g);
        d.defines.VSM_SAMPLES !== i.blurSamples && (d.defines.VSM_SAMPLES = i.blurSamples, p.defines.VSM_SAMPLES = i.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === i.mapPass && (i.mapPass = new $785da19a645c07eb$var$Hj(a.x, a.y, {
            format: $785da19a645c07eb$var$$U,
            type: $785da19a645c07eb$var$qU
        })), d.uniforms.shadow_pass.value = i.map.depthTexture, d.uniforms.resolution.value = i.mapSize, d.uniforms.radius.value = i.radius, e1.setRenderTarget(i.mapPass), e1.clear(), e1.renderBufferDirect(n, null, r, d, g, null), p.uniforms.shadow_pass.value = i.mapPass.texture, p.uniforms.resolution.value = i.mapSize, p.uniforms.radius.value = i.radius, e1.setRenderTarget(i.map), e1.clear(), e1.renderBufferDirect(n, null, r, p, g, null);
    }
    function v(t, i, n, a) {
        let r = null;
        const s = !0 === n.isPointLight ? t.customDistanceMaterial : t.customDepthMaterial;
        if (void 0 !== s) r = s;
        else if (r = !0 === n.isPointLight ? l : o, e1.localClippingEnabled && !0 === i.clipShadows && Array.isArray(i.clippingPlanes) && 0 !== i.clippingPlanes.length || i.displacementMap && 0 !== i.displacementScale || i.alphaMap && i.alphaTest > 0 || i.map && i.alphaTest > 0 || !0 === i.alphaToCoverage) {
            const e1 = r.uuid, t = i.uuid;
            let n = c[e1];
            void 0 === n && (n = {}, c[e1] = n);
            let a = n[t];
            void 0 === a && (a = r.clone(), n[t] = a, i.addEventListener("dispose", x)), r = a;
        }
        if (r.visible = i.visible, r.wireframe = i.wireframe, r.side = 3 === a ? null !== i.shadowSide ? i.shadowSide : i.side : null !== i.shadowSide ? i.shadowSide : h[i.side], r.alphaMap = i.alphaMap, r.alphaTest = !0 === i.alphaToCoverage ? .5 : i.alphaTest, r.map = i.map, r.clipShadows = i.clipShadows, r.clippingPlanes = i.clippingPlanes, r.clipIntersection = i.clipIntersection, r.displacementMap = i.displacementMap, r.displacementScale = i.displacementScale, r.displacementBias = i.displacementBias, r.wireframeLinewidth = i.wireframeLinewidth, r.linewidth = i.linewidth, !0 === n.isPointLight && !0 === r.isMeshDistanceMaterial) e1.properties.get(r).light = n;
        return r;
    }
    function y(i, a, r, s, o) {
        if (!1 === i.visible) return;
        if (i.layers.test(a.layers) && (i.isMesh || i.isLine || i.isPoints) && (i.castShadow || i.receiveShadow && 3 === o) && (!i.frustumCulled || n.intersectsObject(i))) {
            i.modelViewMatrix.multiplyMatrices(r.matrixWorldInverse, i.matrixWorld);
            const n = t.update(i), l = i.material;
            if (Array.isArray(l)) {
                const t = n.groups;
                for(let c = 0, u = t.length; c < u; c++){
                    const u = t[c], h = l[u.materialIndex];
                    if (h && h.visible) {
                        const t = v(i, h, s, o);
                        i.onBeforeShadow(e1, i, a, r, n, t, u), e1.renderBufferDirect(r, null, n, t, i, u), i.onAfterShadow(e1, i, a, r, n, t, u);
                    }
                }
            } else if (l.visible) {
                const t = v(i, l, s, o);
                i.onBeforeShadow(e1, i, a, r, n, t, null), e1.renderBufferDirect(r, null, n, t, i, null), i.onAfterShadow(e1, i, a, r, n, t, null);
            }
        }
        const l = i.children;
        for(let e1 = 0, t = l.length; e1 < t; e1++)y(l[e1], a, r, s, o);
    }
    function x(e1) {
        e1.target.removeEventListener("dispose", x);
        for(const t in c){
            const i = c[t], n = e1.target.uuid;
            if (n in i) i[n].dispose(), delete i[n];
        }
    }
    this.render = function(t, i, o) {
        if (!1 === f.enabled) return;
        if (!1 === f.autoUpdate && !1 === f.needsUpdate) return;
        if (0 === t.length) return;
        2 === this.type && ($785da19a645c07eb$var$sj("WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead."), this.type = 1);
        const l = e1.getRenderTarget(), c = e1.getActiveCubeFace(), h = e1.getActiveMipmapLevel(), d = e1.state;
        d.setBlending(0), !0 === d.buffers.depth.getReversed() ? d.buffers.color.setClear(0, 0, 0, 0) : d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
        const p = A !== this.type;
        p && i.traverse(function(e1) {
            e1.material && (Array.isArray(e1.material) ? e1.material.forEach((e1)=>e1.needsUpdate = !0) : e1.material.needsUpdate = !0);
        });
        for(let l = 0, c = t.length; l < c; l++){
            const c = t[l], h = c.shadow;
            if (void 0 === h) {
                $785da19a645c07eb$var$sj("WebGLShadowMap:", c, "has no shadow.");
                continue;
            }
            if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
            a.copy(h.mapSize);
            const m = h.getFrameExtents();
            a.multiply(m), r.copy(h.mapSize), (a.x > u || a.y > u) && (a.x > u && (r.x = Math.floor(u / m.x), a.x = r.x * m.x, h.mapSize.x = r.x), a.y > u && (r.y = Math.floor(u / m.y), a.y = r.y * m.y, h.mapSize.y = r.y));
            const g = e1.state.buffers.depth.getReversed();
            if (h.camera._reversedDepth = g, null === h.map || !0 === p) {
                if (null !== h.map && (null !== h.map.depthTexture && (h.map.depthTexture.dispose(), h.map.depthTexture = null), h.map.dispose()), 3 === this.type) {
                    if (c.isPointLight) {
                        $785da19a645c07eb$var$sj("WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.");
                        continue;
                    }
                    h.map = new $785da19a645c07eb$var$Hj(a.x, a.y, {
                        format: $785da19a645c07eb$var$$U,
                        type: $785da19a645c07eb$var$qU,
                        minFilter: $785da19a645c07eb$var$FU,
                        magFilter: $785da19a645c07eb$var$FU,
                        generateMipmaps: !1
                    }), h.map.texture.name = c.name + ".shadowMap", h.map.depthTexture = new $785da19a645c07eb$var$yG(a.x, a.y, $785da19a645c07eb$var$VU), h.map.depthTexture.name = c.name + ".shadowMapDepth", h.map.depthTexture.format = $785da19a645c07eb$var$QU, h.map.depthTexture.compareFunction = null, h.map.depthTexture.minFilter = $785da19a645c07eb$var$DU, h.map.depthTexture.magFilter = $785da19a645c07eb$var$DU;
                } else c.isPointLight ? (h.map = new $785da19a645c07eb$var$UH(a.x), h.map.depthTexture = new $785da19a645c07eb$var$xG(a.x, $785da19a645c07eb$var$jU)) : (h.map = new $785da19a645c07eb$var$Hj(a.x, a.y), h.map.depthTexture = new $785da19a645c07eb$var$yG(a.x, a.y, $785da19a645c07eb$var$jU)), h.map.depthTexture.name = c.name + ".shadowMap", h.map.depthTexture.format = $785da19a645c07eb$var$QU, 1 === this.type ? (h.map.depthTexture.compareFunction = g ? 518 : 515, h.map.depthTexture.minFilter = $785da19a645c07eb$var$FU, h.map.depthTexture.magFilter = $785da19a645c07eb$var$FU) : (h.map.depthTexture.compareFunction = null, h.map.depthTexture.minFilter = $785da19a645c07eb$var$DU, h.map.depthTexture.magFilter = $785da19a645c07eb$var$DU);
                h.camera.updateProjectionMatrix();
            }
            const f = h.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let t = 0; t < f; t++){
                if (h.map.isWebGLCubeRenderTarget) e1.setRenderTarget(h.map, t), e1.clear();
                else {
                    0 === t && (e1.setRenderTarget(h.map), e1.clear());
                    const i = h.getViewport(t);
                    s.set(r.x * i.x, r.y * i.y, r.x * i.z, r.y * i.w), d.viewport(s);
                }
                if (c.isPointLight) {
                    const e1 = h.camera, i = h.matrix, n = c.distance || e1.far;
                    n !== e1.far && (e1.far = n, e1.updateProjectionMatrix()), $785da19a645c07eb$var$qZ.setFromMatrixPosition(c.matrixWorld), e1.position.copy($785da19a645c07eb$var$qZ), $785da19a645c07eb$var$GZ.copy(e1.position), $785da19a645c07eb$var$GZ.add($785da19a645c07eb$var$NZ[t]), e1.up.copy($785da19a645c07eb$var$jZ[t]), e1.lookAt($785da19a645c07eb$var$GZ), e1.updateMatrixWorld(), i.makeTranslation(-$785da19a645c07eb$var$qZ.x, -$785da19a645c07eb$var$qZ.y, -$785da19a645c07eb$var$qZ.z), $785da19a645c07eb$var$VZ.multiplyMatrices(e1.projectionMatrix, e1.matrixWorldInverse), h._frustum.setFromProjectionMatrix($785da19a645c07eb$var$VZ, e1.coordinateSystem, e1.reversedDepth);
                } else h.updateMatrices(c);
                n = h.getFrustum(), y(i, o, h.camera, c, this.type);
            }
            !0 !== h.isPointLightShadow && 3 === this.type && _(h, o), h.needsUpdate = !1;
        }
        A = this.type, f.needsUpdate = !1, e1.setRenderTarget(l, c, h);
    };
}
function $785da19a645c07eb$var$WZ(e1, t) {
    const i = new function() {
        let t = !1;
        const i = new $785da19a645c07eb$var$qj;
        let n = null;
        const a = new $785da19a645c07eb$var$qj(0, 0, 0, 0);
        return {
            setMask: function(i) {
                n === i || t || (e1.colorMask(i, i, i, i), n = i);
            },
            setLocked: function(e1) {
                t = e1;
            },
            setClear: function(t, n, r, s, o) {
                !0 === o && (t *= s, n *= s, r *= s), i.set(t, n, r, s), !1 === a.equals(i) && (e1.clearColor(t, n, r, s), a.copy(i));
            },
            reset: function() {
                t = !1, n = null, a.set(-1, 0, 0, 0);
            }
        };
    }, n = new function() {
        let i = !1, n = !1, a = null, r = null, s = null;
        return {
            setReversed: function(e1) {
                if (n !== e1) {
                    const i = t.get("EXT_clip_control");
                    e1 ? i.clipControlEXT(i.LOWER_LEFT_EXT, i.ZERO_TO_ONE_EXT) : i.clipControlEXT(i.LOWER_LEFT_EXT, i.NEGATIVE_ONE_TO_ONE_EXT), n = e1;
                    const a = s;
                    s = null, this.setClear(a);
                }
            },
            getReversed: function() {
                return n;
            },
            setTest: function(t) {
                t ? j(e1.DEPTH_TEST) : V(e1.DEPTH_TEST);
            },
            setMask: function(t) {
                a === t || i || (e1.depthMask(t), a = t);
            },
            setFunc: function(t) {
                if (n && (t = $785da19a645c07eb$var$cj[t]), r !== t) {
                    switch(t){
                        case 0:
                            e1.depthFunc(e1.NEVER);
                            break;
                        case 1:
                            e1.depthFunc(e1.ALWAYS);
                            break;
                        case 2:
                            e1.depthFunc(e1.LESS);
                            break;
                        case 3:
                        default:
                            e1.depthFunc(e1.LEQUAL);
                            break;
                        case 4:
                            e1.depthFunc(e1.EQUAL);
                            break;
                        case 5:
                            e1.depthFunc(e1.GEQUAL);
                            break;
                        case 6:
                            e1.depthFunc(e1.GREATER);
                            break;
                        case 7:
                            e1.depthFunc(e1.NOTEQUAL);
                    }
                    r = t;
                }
            },
            setLocked: function(e1) {
                i = e1;
            },
            setClear: function(t) {
                s !== t && (s = t, n && (t = 1 - t), e1.clearDepth(t));
            },
            reset: function() {
                i = !1, a = null, r = null, s = null, n = !1;
            }
        };
    }, a = new function() {
        let t = !1, i = null, n = null, a = null, r = null, s = null, o = null, l = null, c = null;
        return {
            setTest: function(i) {
                t || (i ? j(e1.STENCIL_TEST) : V(e1.STENCIL_TEST));
            },
            setMask: function(n) {
                i === n || t || (e1.stencilMask(n), i = n);
            },
            setFunc: function(t, i, s) {
                n === t && a === i && r === s || (e1.stencilFunc(t, i, s), n = t, a = i, r = s);
            },
            setOp: function(t, i, n) {
                s === t && o === i && l === n || (e1.stencilOp(t, i, n), s = t, o = i, l = n);
            },
            setLocked: function(e1) {
                t = e1;
            },
            setClear: function(t) {
                c !== t && (e1.clearStencil(t), c = t);
            },
            reset: function() {
                t = !1, i = null, n = null, a = null, r = null, s = null, o = null, l = null, c = null;
            }
        };
    }, r = new WeakMap, s = new WeakMap;
    let o = {}, l = {}, c = {}, u = new WeakMap, h = [], d = null, p = !1, m = null, g = null, f = null, A = null, _ = null, v = null, y = null, x = new $785da19a645c07eb$var$TV(0, 0, 0), b = 0, w = !1, E = null, k = null, S = null, M = null, C = null;
    const T = e1.getParameter(e1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let D = !1, P = 0;
    const I = e1.getParameter(e1.VERSION);
    -1 !== I.indexOf("WebGL") ? (P = parseFloat(/^WebGL (\d)/.exec(I)[1]), D = P >= 1) : -1 !== I.indexOf("OpenGL ES") && (P = parseFloat(/^OpenGL ES (\d)/.exec(I)[1]), D = P >= 2);
    let F = null, z = {};
    const R = e1.getParameter(e1.SCISSOR_BOX), L1 = e1.getParameter(e1.VIEWPORT), B = (new $785da19a645c07eb$var$qj).fromArray(R), O = (new $785da19a645c07eb$var$qj).fromArray(L1);
    function U(t, i, n, a) {
        const r = new Uint8Array(4), s = e1.createTexture();
        e1.bindTexture(t, s), e1.texParameteri(t, e1.TEXTURE_MIN_FILTER, e1.NEAREST), e1.texParameteri(t, e1.TEXTURE_MAG_FILTER, e1.NEAREST);
        for(let s = 0; s < n; s++)t === e1.TEXTURE_3D || t === e1.TEXTURE_2D_ARRAY ? e1.texImage3D(i, 0, e1.RGBA, 1, 1, a, 0, e1.RGBA, e1.UNSIGNED_BYTE, r) : e1.texImage2D(i + s, 0, e1.RGBA, 1, 1, 0, e1.RGBA, e1.UNSIGNED_BYTE, r);
        return s;
    }
    const N = {};
    function j(t) {
        !0 !== o[t] && (e1.enable(t), o[t] = !0);
    }
    function V(t) {
        !1 !== o[t] && (e1.disable(t), o[t] = !1);
    }
    N[e1.TEXTURE_2D] = U(e1.TEXTURE_2D, e1.TEXTURE_2D, 1), N[e1.TEXTURE_CUBE_MAP] = U(e1.TEXTURE_CUBE_MAP, e1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), N[e1.TEXTURE_2D_ARRAY] = U(e1.TEXTURE_2D_ARRAY, e1.TEXTURE_2D_ARRAY, 1, 1), N[e1.TEXTURE_3D] = U(e1.TEXTURE_3D, e1.TEXTURE_3D, 1, 1), i.setClear(0, 0, 0, 1), n.setClear(1), a.setClear(0), j(e1.DEPTH_TEST), n.setFunc(3), W(!1), Z(1), j(e1.CULL_FACE), H(0);
    const q = {
        [$785da19a645c07eb$var$NO]: e1.FUNC_ADD,
        [$785da19a645c07eb$var$jO]: e1.FUNC_SUBTRACT,
        [$785da19a645c07eb$var$VO]: e1.FUNC_REVERSE_SUBTRACT
    };
    q[103] = e1.MIN, q[104] = e1.MAX;
    const G = {
        [$785da19a645c07eb$var$qO]: e1.ZERO,
        [$785da19a645c07eb$var$GO]: e1.ONE,
        [$785da19a645c07eb$var$HO]: e1.SRC_COLOR,
        [$785da19a645c07eb$var$ZO]: e1.SRC_ALPHA,
        [$785da19a645c07eb$var$$O]: e1.SRC_ALPHA_SATURATE,
        [$785da19a645c07eb$var$YO]: e1.DST_COLOR,
        [$785da19a645c07eb$var$XO]: e1.DST_ALPHA,
        [$785da19a645c07eb$var$WO]: e1.ONE_MINUS_SRC_COLOR,
        [$785da19a645c07eb$var$KO]: e1.ONE_MINUS_SRC_ALPHA,
        [$785da19a645c07eb$var$JO]: e1.ONE_MINUS_DST_COLOR,
        [$785da19a645c07eb$var$QO]: e1.ONE_MINUS_DST_ALPHA,
        [$785da19a645c07eb$var$eU]: e1.CONSTANT_COLOR,
        [$785da19a645c07eb$var$tU]: e1.ONE_MINUS_CONSTANT_COLOR,
        [$785da19a645c07eb$var$iU]: e1.CONSTANT_ALPHA,
        [$785da19a645c07eb$var$nU]: e1.ONE_MINUS_CONSTANT_ALPHA
    };
    function H(t, i, n, a, r, s, o, l, c, u) {
        if (0 !== t) {
            if (!1 === p && (j(e1.BLEND), p = !0), 5 === t) r = r || i, s = s || n, o = o || a, i === g && r === _ || (e1.blendEquationSeparate(q[i], q[r]), g = i, _ = r), n === f && a === A && s === v && o === y || (e1.blendFuncSeparate(G[n], G[a], G[s], G[o]), f = n, A = a, v = s, y = o), !1 !== l.equals(x) && c === b || (e1.blendColor(l.r, l.g, l.b, c), x.copy(l), b = c), m = t, w = !1;
            else if (t !== m || u !== w) {
                if (g === $785da19a645c07eb$var$NO && _ === $785da19a645c07eb$var$NO || (e1.blendEquation(e1.FUNC_ADD), g = $785da19a645c07eb$var$NO, _ = $785da19a645c07eb$var$NO), u) switch(t){
                    case 1:
                        e1.blendFuncSeparate(e1.ONE, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 2:
                        e1.blendFunc(e1.ONE, e1.ONE);
                        break;
                    case 3:
                        e1.blendFuncSeparate(e1.ZERO, e1.ONE_MINUS_SRC_COLOR, e1.ZERO, e1.ONE);
                        break;
                    case 4:
                        e1.blendFuncSeparate(e1.DST_COLOR, e1.ONE_MINUS_SRC_ALPHA, e1.ZERO, e1.ONE);
                        break;
                    default:
                        $785da19a645c07eb$var$oj("WebGLState: Invalid blending: ", t);
                }
                else switch(t){
                    case 1:
                        e1.blendFuncSeparate(e1.SRC_ALPHA, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 2:
                        e1.blendFuncSeparate(e1.SRC_ALPHA, e1.ONE, e1.ONE, e1.ONE);
                        break;
                    case 3:
                        $785da19a645c07eb$var$oj("WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                        break;
                    case 4:
                        $785da19a645c07eb$var$oj("WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                        break;
                    default:
                        $785da19a645c07eb$var$oj("WebGLState: Invalid blending: ", t);
                }
                f = null, A = null, v = null, y = null, x.set(0, 0, 0), b = 0, m = t, w = u;
            }
        } else !0 === p && (V(e1.BLEND), p = !1);
    }
    function W(t) {
        E !== t && (t ? e1.frontFace(e1.CW) : e1.frontFace(e1.CCW), E = t);
    }
    function Z(t) {
        0 !== t ? (j(e1.CULL_FACE), t !== k && (1 === t ? e1.cullFace(e1.BACK) : 2 === t ? e1.cullFace(e1.FRONT) : e1.cullFace(e1.FRONT_AND_BACK))) : V(e1.CULL_FACE), k = t;
    }
    function K(t, i, a) {
        t ? (j(e1.POLYGON_OFFSET_FILL), M === i && C === a || (M = i, C = a, n.getReversed() && (i = -i), e1.polygonOffset(i, a))) : V(e1.POLYGON_OFFSET_FILL);
    }
    return {
        buffers: {
            color: i,
            depth: n,
            stencil: a
        },
        enable: j,
        disable: V,
        bindFramebuffer: function(t, i) {
            return c[t] !== i && (e1.bindFramebuffer(t, i), c[t] = i, t === e1.DRAW_FRAMEBUFFER && (c[e1.FRAMEBUFFER] = i), t === e1.FRAMEBUFFER && (c[e1.DRAW_FRAMEBUFFER] = i), !0);
        },
        drawBuffers: function(t, i) {
            let n = h, a = !1;
            if (t) {
                n = u.get(i), void 0 === n && (n = [], u.set(i, n));
                const r = t.textures;
                if (n.length !== r.length || n[0] !== e1.COLOR_ATTACHMENT0) {
                    for(let t = 0, i = r.length; t < i; t++)n[t] = e1.COLOR_ATTACHMENT0 + t;
                    n.length = r.length, a = !0;
                }
            } else n[0] !== e1.BACK && (n[0] = e1.BACK, a = !0);
            a && e1.drawBuffers(n);
        },
        useProgram: function(t) {
            return d !== t && (e1.useProgram(t), d = t, !0);
        },
        setBlending: H,
        setMaterial: function(t, r) {
            2 === t.side ? V(e1.CULL_FACE) : j(e1.CULL_FACE);
            let s = 1 === t.side;
            r && (s = !s), W(s), 1 === t.blending && !1 === t.transparent ? H(0) : H(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), n.setFunc(t.depthFunc), n.setTest(t.depthTest), n.setMask(t.depthWrite), i.setMask(t.colorWrite);
            const o = t.stencilWrite;
            a.setTest(o), o && (a.setMask(t.stencilWriteMask), a.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), a.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), K(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? j(e1.SAMPLE_ALPHA_TO_COVERAGE) : V(e1.SAMPLE_ALPHA_TO_COVERAGE);
        },
        setFlipSided: W,
        setCullFace: Z,
        setLineWidth: function(t) {
            t !== S && (D && e1.lineWidth(t), S = t);
        },
        setPolygonOffset: K,
        setScissorTest: function(t) {
            t ? j(e1.SCISSOR_TEST) : V(e1.SCISSOR_TEST);
        },
        activeTexture: function(t) {
            void 0 === t && (t = e1.TEXTURE0 + T - 1), F !== t && (e1.activeTexture(t), F = t);
        },
        bindTexture: function(t, i, n) {
            void 0 === n && (n = null === F ? e1.TEXTURE0 + T - 1 : F);
            let a = z[n];
            void 0 === a && (a = {
                type: void 0,
                texture: void 0
            }, z[n] = a), a.type === t && a.texture === i || (F !== n && (e1.activeTexture(n), F = n), e1.bindTexture(t, i || N[t]), a.type = t, a.texture = i);
        },
        unbindTexture: function() {
            const t = z[F];
            void 0 !== t && void 0 !== t.type && (e1.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
        },
        compressedTexImage2D: function() {
            try {
                e1.compressedTexImage2D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        compressedTexImage3D: function() {
            try {
                e1.compressedTexImage3D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        texImage2D: function() {
            try {
                e1.texImage2D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        texImage3D: function() {
            try {
                e1.texImage3D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        pixelStorei: function(t, i) {
            l[t] !== i && (e1.pixelStorei(t, i), l[t] = i);
        },
        getParameter: function(t) {
            return void 0 !== l[t] ? l[t] : e1.getParameter(t);
        },
        updateUBOMapping: function(t, i) {
            let n = s.get(i);
            void 0 === n && (n = new WeakMap, s.set(i, n));
            let a = n.get(t);
            void 0 === a && (a = e1.getUniformBlockIndex(i, t.name), n.set(t, a));
        },
        uniformBlockBinding: function(t, i) {
            const n = s.get(i).get(t);
            r.get(i) !== n && (e1.uniformBlockBinding(i, n, t.__bindingPointIndex), r.set(i, n));
        },
        texStorage2D: function() {
            try {
                e1.texStorage2D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        texStorage3D: function() {
            try {
                e1.texStorage3D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        texSubImage2D: function() {
            try {
                e1.texSubImage2D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        texSubImage3D: function() {
            try {
                e1.texSubImage3D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        compressedTexSubImage2D: function() {
            try {
                e1.compressedTexSubImage2D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        compressedTexSubImage3D: function() {
            try {
                e1.compressedTexSubImage3D(...arguments);
            } catch (e1) {
                $785da19a645c07eb$var$oj("WebGLState:", e1);
            }
        },
        scissor: function(t) {
            !1 === B.equals(t) && (e1.scissor(t.x, t.y, t.z, t.w), B.copy(t));
        },
        viewport: function(t) {
            !1 === O.equals(t) && (e1.viewport(t.x, t.y, t.z, t.w), O.copy(t));
        },
        reset: function() {
            e1.disable(e1.BLEND), e1.disable(e1.CULL_FACE), e1.disable(e1.DEPTH_TEST), e1.disable(e1.POLYGON_OFFSET_FILL), e1.disable(e1.SCISSOR_TEST), e1.disable(e1.STENCIL_TEST), e1.disable(e1.SAMPLE_ALPHA_TO_COVERAGE), e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO), e1.blendFuncSeparate(e1.ONE, e1.ZERO, e1.ONE, e1.ZERO), e1.blendColor(0, 0, 0, 0), e1.colorMask(!0, !0, !0, !0), e1.clearColor(0, 0, 0, 0), e1.depthMask(!0), e1.depthFunc(e1.LESS), n.setReversed(!1), e1.clearDepth(1), e1.stencilMask(4294967295), e1.stencilFunc(e1.ALWAYS, 0, 4294967295), e1.stencilOp(e1.KEEP, e1.KEEP, e1.KEEP), e1.clearStencil(0), e1.cullFace(e1.BACK), e1.frontFace(e1.CCW), e1.polygonOffset(0, 0), e1.activeTexture(e1.TEXTURE0), e1.bindFramebuffer(e1.FRAMEBUFFER, null), e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), e1.bindFramebuffer(e1.READ_FRAMEBUFFER, null), e1.useProgram(null), e1.lineWidth(1), e1.scissor(0, 0, e1.canvas.width, e1.canvas.height), e1.viewport(0, 0, e1.canvas.width, e1.canvas.height), e1.pixelStorei(e1.PACK_ALIGNMENT, 4), e1.pixelStorei(e1.UNPACK_ALIGNMENT, 4), e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, !1), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !1), e1.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, e1.BROWSER_DEFAULT_WEBGL), e1.pixelStorei(e1.PACK_ROW_LENGTH, 0), e1.pixelStorei(e1.PACK_SKIP_PIXELS, 0), e1.pixelStorei(e1.PACK_SKIP_ROWS, 0), e1.pixelStorei(e1.UNPACK_ROW_LENGTH, 0), e1.pixelStorei(e1.UNPACK_IMAGE_HEIGHT, 0), e1.pixelStorei(e1.UNPACK_SKIP_PIXELS, 0), e1.pixelStorei(e1.UNPACK_SKIP_ROWS, 0), e1.pixelStorei(e1.UNPACK_SKIP_IMAGES, 0), o = {}, l = {}, F = null, z = {}, c = {}, u = new WeakMap, h = [], d = null, p = !1, m = null, g = null, f = null, A = null, _ = null, v = null, y = null, x = new $785da19a645c07eb$var$TV(0, 0, 0), b = 0, w = !1, E = null, k = null, S = null, M = null, C = null, B.set(0, 0, e1.canvas.width, e1.canvas.height), O.set(0, 0, e1.canvas.width, e1.canvas.height), i.reset(), n.reset(), a.reset();
        }
    };
}
function $785da19a645c07eb$var$ZZ(e1, t, i, n, a, r, s) {
    const o = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, l = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), c = new $785da19a645c07eb$var$bj, u = new WeakMap, h = new Set;
    let d;
    const p = new WeakMap;
    let m = !1;
    try {
        m = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
    } catch (e1) {}
    function g(e1, t) {
        return m ? new OffscreenCanvas(e1, t) : $785da19a645c07eb$var$tj("canvas");
    }
    function f(e1, t, i) {
        let n = 1;
        const a = G(e1);
        if ((a.width > i || a.height > i) && (n = i / Math.max(a.width, a.height)), n < 1) {
            if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap || "undefined" != typeof VideoFrame && e1 instanceof VideoFrame) {
                const i = Math.floor(n * a.width), r = Math.floor(n * a.height);
                void 0 === d && (d = g(i, r));
                const s = t ? g(i, r) : d;
                s.width = i, s.height = r;
                return s.getContext("2d").drawImage(e1, 0, 0, i, r), $785da19a645c07eb$var$sj("WebGLRenderer: Texture has been resized from (" + a.width + "x" + a.height + ") to (" + i + "x" + r + ")."), s;
            }
            return "data" in e1 && $785da19a645c07eb$var$sj("WebGLRenderer: Image in DataTexture is too big (" + a.width + "x" + a.height + ")."), e1;
        }
        return e1;
    }
    function A(e1) {
        return e1.generateMipmaps;
    }
    function _(t) {
        e1.generateMipmap(t);
    }
    function v(t) {
        return t.isWebGLCubeRenderTarget ? e1.TEXTURE_CUBE_MAP : t.isWebGL3DRenderTarget ? e1.TEXTURE_3D : t.isWebGLArrayRenderTarget || t.isCompressedArrayTexture ? e1.TEXTURE_2D_ARRAY : e1.TEXTURE_2D;
    }
    function y(i, n, a, r, s, o = !1) {
        if (null !== i) {
            if (void 0 !== e1[i]) return e1[i];
            $785da19a645c07eb$var$sj("WebGLRenderer: Attempt to use non-existing WebGL internal format '" + i + "'");
        }
        let l;
        r && (l = t.get("EXT_texture_norm16"), l || $785da19a645c07eb$var$sj("WebGLRenderer: Unable to use normalized textures without EXT_texture_norm16 extension"));
        let c = n;
        if (n === e1.RED && (a === e1.FLOAT && (c = e1.R32F), a === e1.HALF_FLOAT && (c = e1.R16F), a === e1.UNSIGNED_BYTE && (c = e1.R8), a === e1.UNSIGNED_SHORT && l && (c = l.R16_EXT), a === e1.SHORT && l && (c = l.R16_SNORM_EXT)), n === e1.RED_INTEGER && (a === e1.UNSIGNED_BYTE && (c = e1.R8UI), a === e1.UNSIGNED_SHORT && (c = e1.R16UI), a === e1.UNSIGNED_INT && (c = e1.R32UI), a === e1.BYTE && (c = e1.R8I), a === e1.SHORT && (c = e1.R16I), a === e1.INT && (c = e1.R32I)), n === e1.RG && (a === e1.FLOAT && (c = e1.RG32F), a === e1.HALF_FLOAT && (c = e1.RG16F), a === e1.UNSIGNED_BYTE && (c = e1.RG8), a === e1.UNSIGNED_SHORT && l && (c = l.RG16_EXT), a === e1.SHORT && l && (c = l.RG16_SNORM_EXT)), n === e1.RG_INTEGER && (a === e1.UNSIGNED_BYTE && (c = e1.RG8UI), a === e1.UNSIGNED_SHORT && (c = e1.RG16UI), a === e1.UNSIGNED_INT && (c = e1.RG32UI), a === e1.BYTE && (c = e1.RG8I), a === e1.SHORT && (c = e1.RG16I), a === e1.INT && (c = e1.RG32I)), n === e1.RGB_INTEGER && (a === e1.UNSIGNED_BYTE && (c = e1.RGB8UI), a === e1.UNSIGNED_SHORT && (c = e1.RGB16UI), a === e1.UNSIGNED_INT && (c = e1.RGB32UI), a === e1.BYTE && (c = e1.RGB8I), a === e1.SHORT && (c = e1.RGB16I), a === e1.INT && (c = e1.RGB32I)), n === e1.RGBA_INTEGER && (a === e1.UNSIGNED_BYTE && (c = e1.RGBA8UI), a === e1.UNSIGNED_SHORT && (c = e1.RGBA16UI), a === e1.UNSIGNED_INT && (c = e1.RGBA32UI), a === e1.BYTE && (c = e1.RGBA8I), a === e1.SHORT && (c = e1.RGBA16I), a === e1.INT && (c = e1.RGBA32I)), n === e1.RGB && (a === e1.UNSIGNED_SHORT && l && (c = l.RGB16_EXT), a === e1.SHORT && l && (c = l.RGB16_SNORM_EXT), a === e1.UNSIGNED_INT_5_9_9_9_REV && (c = e1.RGB9_E5), a === e1.UNSIGNED_INT_10F_11F_11F_REV && (c = e1.R11F_G11F_B10F)), n === e1.RGBA) {
            const t = o ? $785da19a645c07eb$var$jN : $785da19a645c07eb$var$Ij.getTransfer(s);
            a === e1.FLOAT && (c = e1.RGBA32F), a === e1.HALF_FLOAT && (c = e1.RGBA16F), a === e1.UNSIGNED_BYTE && (c = t === $785da19a645c07eb$var$VN ? e1.SRGB8_ALPHA8 : e1.RGBA8), a === e1.UNSIGNED_SHORT && l && (c = l.RGBA16_EXT), a === e1.SHORT && l && (c = l.RGBA16_SNORM_EXT), a === e1.UNSIGNED_SHORT_4_4_4_4 && (c = e1.RGBA4), a === e1.UNSIGNED_SHORT_5_5_5_1 && (c = e1.RGB5_A1);
        }
        return c !== e1.R16F && c !== e1.R32F && c !== e1.RG16F && c !== e1.RG32F && c !== e1.RGBA16F && c !== e1.RGBA32F || t.get("EXT_color_buffer_float"), c;
    }
    function x(t, i) {
        let n;
        return t ? null === i || i === $785da19a645c07eb$var$jU || i === $785da19a645c07eb$var$WU ? n = e1.DEPTH24_STENCIL8 : i === $785da19a645c07eb$var$VU ? n = e1.DEPTH32F_STENCIL8 : i === $785da19a645c07eb$var$UU && (n = e1.DEPTH24_STENCIL8, $785da19a645c07eb$var$sj("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : null === i || i === $785da19a645c07eb$var$jU || i === $785da19a645c07eb$var$WU ? n = e1.DEPTH_COMPONENT24 : i === $785da19a645c07eb$var$VU ? n = e1.DEPTH_COMPONENT32F : i === $785da19a645c07eb$var$UU && (n = e1.DEPTH_COMPONENT16), n;
    }
    function b(e1, t) {
        return !0 === A(e1) || e1.isFramebufferTexture && e1.minFilter !== $785da19a645c07eb$var$DU && e1.minFilter !== $785da19a645c07eb$var$FU ? Math.log2(Math.max(t.width, t.height)) + 1 : void 0 !== e1.mipmaps && e1.mipmaps.length > 0 ? e1.mipmaps.length : e1.isCompressedTexture && Array.isArray(e1.image) ? t.mipmaps.length : 1;
    }
    function w(e1) {
        const t = e1.target;
        t.removeEventListener("dispose", w), function(e1) {
            const t = n.get(e1);
            if (void 0 === t.__webglInit) return;
            const i = e1.source, a = p.get(i);
            if (a) {
                const n = a[t.__cacheKey];
                n.usedTimes--, 0 === n.usedTimes && k(e1), 0 === Object.keys(a).length && p.delete(i);
            }
            n.remove(e1);
        }(t), t.isVideoTexture && u.delete(t), t.isHTMLTexture && h.delete(t);
    }
    function E(t) {
        const i = t.target;
        i.removeEventListener("dispose", E), function(t) {
            const i = n.get(t);
            t.depthTexture && (t.depthTexture.dispose(), n.remove(t.depthTexture));
            if (t.isWebGLCubeRenderTarget) for(let t = 0; t < 6; t++){
                if (Array.isArray(i.__webglFramebuffer[t])) for(let n = 0; n < i.__webglFramebuffer[t].length; n++)e1.deleteFramebuffer(i.__webglFramebuffer[t][n]);
                else e1.deleteFramebuffer(i.__webglFramebuffer[t]);
                i.__webglDepthbuffer && e1.deleteRenderbuffer(i.__webglDepthbuffer[t]);
            }
            else {
                if (Array.isArray(i.__webglFramebuffer)) for(let t = 0; t < i.__webglFramebuffer.length; t++)e1.deleteFramebuffer(i.__webglFramebuffer[t]);
                else e1.deleteFramebuffer(i.__webglFramebuffer);
                if (i.__webglDepthbuffer && e1.deleteRenderbuffer(i.__webglDepthbuffer), i.__webglMultisampledFramebuffer && e1.deleteFramebuffer(i.__webglMultisampledFramebuffer), i.__webglColorRenderbuffer) for(let t = 0; t < i.__webglColorRenderbuffer.length; t++)i.__webglColorRenderbuffer[t] && e1.deleteRenderbuffer(i.__webglColorRenderbuffer[t]);
                i.__webglDepthRenderbuffer && e1.deleteRenderbuffer(i.__webglDepthRenderbuffer);
            }
            const a = t.textures;
            for(let t = 0, i = a.length; t < i; t++){
                const i = n.get(a[t]);
                i.__webglTexture && (e1.deleteTexture(i.__webglTexture), s.memory.textures--), n.remove(a[t]);
            }
            n.remove(t);
        }(i);
    }
    function k(t) {
        const i = n.get(t);
        e1.deleteTexture(i.__webglTexture);
        const a = t.source;
        delete p.get(a)[i.__cacheKey], s.memory.textures--;
    }
    let S = 0;
    function M(t, a) {
        const r = n.get(t);
        if (t.isVideoTexture && function(e1) {
            const t = s.render.frame;
            u.get(e1) !== t && (u.set(e1, t), e1.update());
        }(t), !1 === t.isRenderTargetTexture && !0 !== t.isExternalTexture && t.version > 0 && r.__version !== t.version) {
            const e1 = t.image;
            if (null === e1) $785da19a645c07eb$var$sj("WebGLRenderer: Texture marked for update but no image data found.");
            else {
                if (!1 !== e1.complete) return void z(r, t, a);
                $785da19a645c07eb$var$sj("WebGLRenderer: Texture marked for update but image is incomplete");
            }
        } else t.isExternalTexture && (r.__webglTexture = t.sourceTexture ? t.sourceTexture : null);
        i.bindTexture(e1.TEXTURE_2D, r.__webglTexture, e1.TEXTURE0 + a);
    }
    const C = {
        [$785da19a645c07eb$var$MU]: e1.REPEAT,
        [$785da19a645c07eb$var$CU]: e1.CLAMP_TO_EDGE,
        [$785da19a645c07eb$var$TU]: e1.MIRRORED_REPEAT
    }, T = {
        [$785da19a645c07eb$var$DU]: e1.NEAREST,
        [$785da19a645c07eb$var$PU]: e1.NEAREST_MIPMAP_NEAREST,
        [$785da19a645c07eb$var$IU]: e1.NEAREST_MIPMAP_LINEAR,
        [$785da19a645c07eb$var$FU]: e1.LINEAR,
        [$785da19a645c07eb$var$zU]: e1.LINEAR_MIPMAP_NEAREST,
        [$785da19a645c07eb$var$RU]: e1.LINEAR_MIPMAP_LINEAR
    }, D = {
        [$785da19a645c07eb$var$GN]: e1.NEVER,
        [$785da19a645c07eb$var$YN]: e1.ALWAYS,
        [$785da19a645c07eb$var$HN]: e1.LESS,
        [$785da19a645c07eb$var$ZN]: e1.LEQUAL,
        [$785da19a645c07eb$var$WN]: e1.EQUAL,
        [$785da19a645c07eb$var$QN]: e1.GEQUAL,
        [$785da19a645c07eb$var$KN]: e1.GREATER,
        [$785da19a645c07eb$var$XN]: e1.NOTEQUAL
    };
    function P(i, r) {
        if (r.type !== $785da19a645c07eb$var$VU || !1 !== t.has("OES_texture_float_linear") || r.magFilter !== $785da19a645c07eb$var$FU && r.magFilter !== $785da19a645c07eb$var$zU && r.magFilter !== $785da19a645c07eb$var$IU && r.magFilter !== $785da19a645c07eb$var$RU && r.minFilter !== $785da19a645c07eb$var$FU && r.minFilter !== $785da19a645c07eb$var$zU && r.minFilter !== $785da19a645c07eb$var$IU && r.minFilter !== $785da19a645c07eb$var$RU || $785da19a645c07eb$var$sj("WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), e1.texParameteri(i, e1.TEXTURE_WRAP_S, C[r.wrapS]), e1.texParameteri(i, e1.TEXTURE_WRAP_T, C[r.wrapT]), i !== e1.TEXTURE_3D && i !== e1.TEXTURE_2D_ARRAY || e1.texParameteri(i, e1.TEXTURE_WRAP_R, C[r.wrapR]), e1.texParameteri(i, e1.TEXTURE_MAG_FILTER, T[r.magFilter]), e1.texParameteri(i, e1.TEXTURE_MIN_FILTER, T[r.minFilter]), r.compareFunction && (e1.texParameteri(i, e1.TEXTURE_COMPARE_MODE, e1.COMPARE_REF_TO_TEXTURE), e1.texParameteri(i, e1.TEXTURE_COMPARE_FUNC, D[r.compareFunction])), !0 === t.has("EXT_texture_filter_anisotropic")) {
            if (r.magFilter === $785da19a645c07eb$var$DU) return;
            if (r.minFilter !== $785da19a645c07eb$var$IU && r.minFilter !== $785da19a645c07eb$var$RU) return;
            if (r.type === $785da19a645c07eb$var$VU && !1 === t.has("OES_texture_float_linear")) return;
            if (r.anisotropy > 1 || n.get(r).__currentAnisotropy) {
                const s = t.get("EXT_texture_filter_anisotropic");
                e1.texParameterf(i, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(r.anisotropy, a.getMaxAnisotropy())), n.get(r).__currentAnisotropy = r.anisotropy;
            }
        }
    }
    function I(t, i) {
        let n = !1;
        void 0 === t.__webglInit && (t.__webglInit = !0, i.addEventListener("dispose", w));
        const a = i.source;
        let r = p.get(a);
        void 0 === r && (r = {}, p.set(a, r));
        const o = function(e1) {
            const t = [];
            return t.push(e1.wrapS), t.push(e1.wrapT), t.push(e1.wrapR || 0), t.push(e1.magFilter), t.push(e1.minFilter), t.push(e1.anisotropy), t.push(e1.internalFormat), t.push(e1.format), t.push(e1.type), t.push(e1.generateMipmaps), t.push(e1.premultiplyAlpha), t.push(e1.flipY), t.push(e1.unpackAlignment), t.push(e1.colorSpace), t.join();
        }(i);
        if (o !== t.__cacheKey) {
            void 0 === r[o] && (r[o] = {
                texture: e1.createTexture(),
                usedTimes: 0
            }, s.memory.textures++, n = !0), r[o].usedTimes++;
            const a = r[t.__cacheKey];
            void 0 !== a && (r[t.__cacheKey].usedTimes--, 0 === a.usedTimes && k(i)), t.__cacheKey = o, t.__webglTexture = r[o].texture;
        }
        return n;
    }
    function F(e1, t, i) {
        return Math.floor(Math.floor(e1 / i) / t);
    }
    function z(t, s, o) {
        let l = e1.TEXTURE_2D;
        (s.isDataArrayTexture || s.isCompressedArrayTexture) && (l = e1.TEXTURE_2D_ARRAY), s.isData3DTexture && (l = e1.TEXTURE_3D);
        const c = I(t, s), u = s.source;
        i.bindTexture(l, t.__webglTexture, e1.TEXTURE0 + o);
        const d = n.get(u);
        if (u.version !== d.__version || !0 === c) {
            i.activeTexture(e1.TEXTURE0 + o);
            if (!1 === ("undefined" != typeof ImageBitmap && s.image instanceof ImageBitmap)) {
                const t = $785da19a645c07eb$var$Ij.getPrimaries($785da19a645c07eb$var$Ij.workingColorSpace), n = s.colorSpace === $785da19a645c07eb$var$ON ? null : $785da19a645c07eb$var$Ij.getPrimaries(s.colorSpace), a = s.colorSpace === $785da19a645c07eb$var$ON || t === n ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                i.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, s.flipY), i.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s.premultiplyAlpha), i.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, a);
            }
            i.pixelStorei(e1.UNPACK_ALIGNMENT, s.unpackAlignment);
            let t = f(s.image, !1, a.maxTextureSize);
            t = q(s, t);
            const n = r.convert(s.format, s.colorSpace), p = r.convert(s.type);
            let m, g = y(s.internalFormat, n, p, s.normalized, s.colorSpace, s.isVideoTexture);
            P(l, s);
            const v = s.mipmaps, w = !0 !== s.isVideoTexture, E = void 0 === d.__version || !0 === c, k = u.dataReady, S = b(s, t);
            if (s.isDepthTexture) g = x(s.format === $785da19a645c07eb$var$YU, s.type), E && (w ? i.texStorage2D(e1.TEXTURE_2D, 1, g, t.width, t.height) : i.texImage2D(e1.TEXTURE_2D, 0, g, t.width, t.height, 0, n, p, null));
            else if (s.isDataTexture) {
                if (v.length > 0) {
                    w && E && i.texStorage2D(e1.TEXTURE_2D, S, g, v[0].width, v[0].height);
                    for(let t = 0, a = v.length; t < a; t++)m = v[t], w ? k && i.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, m.width, m.height, n, p, m.data) : i.texImage2D(e1.TEXTURE_2D, t, g, m.width, m.height, 0, n, p, m.data);
                    s.generateMipmaps = !1;
                } else w ? (E && i.texStorage2D(e1.TEXTURE_2D, S, g, t.width, t.height), k && function(t, n, a, r) {
                    const s = t.updateRanges;
                    if (0 === s.length) i.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, n.width, n.height, a, r, n.data);
                    else {
                        s.sort((e1, t)=>e1.start - t.start);
                        let o = 0;
                        for(let e1 = 1; e1 < s.length; e1++){
                            const t = s[o], i = s[e1], a = t.start + t.count, r = F(i.start, n.width, 4), l = F(t.start, n.width, 4);
                            i.start <= a + 1 && r === l && F(i.start + i.count - 1, n.width, 4) === r ? t.count = Math.max(t.count, i.start + i.count - t.start) : (++o, s[o] = i);
                        }
                        s.length = o + 1;
                        const l = i.getParameter(e1.UNPACK_ROW_LENGTH), c = i.getParameter(e1.UNPACK_SKIP_PIXELS), u = i.getParameter(e1.UNPACK_SKIP_ROWS);
                        i.pixelStorei(e1.UNPACK_ROW_LENGTH, n.width);
                        for(let t = 0, o = s.length; t < o; t++){
                            const o = s[t], l = Math.floor(o.start / 4), c = Math.ceil(o.count / 4), u = l % n.width, h = Math.floor(l / n.width), d = c, p = 1;
                            i.pixelStorei(e1.UNPACK_SKIP_PIXELS, u), i.pixelStorei(e1.UNPACK_SKIP_ROWS, h), i.texSubImage2D(e1.TEXTURE_2D, 0, u, h, d, p, a, r, n.data);
                        }
                        t.clearUpdateRanges(), i.pixelStorei(e1.UNPACK_ROW_LENGTH, l), i.pixelStorei(e1.UNPACK_SKIP_PIXELS, c), i.pixelStorei(e1.UNPACK_SKIP_ROWS, u);
                    }
                }(s, t, n, p)) : i.texImage2D(e1.TEXTURE_2D, 0, g, t.width, t.height, 0, n, p, t.data);
            } else if (s.isCompressedTexture) {
                if (s.isCompressedArrayTexture) {
                    w && E && i.texStorage3D(e1.TEXTURE_2D_ARRAY, S, g, v[0].width, v[0].height, t.depth);
                    for(let a = 0, r = v.length; a < r; a++)if (m = v[a], s.format !== $785da19a645c07eb$var$XU) {
                        if (null !== n) {
                            if (w) {
                                if (k) {
                                    if (s.layerUpdates.size > 0) {
                                        const t = $785da19a645c07eb$var$uH(m.width, m.height, s.format, s.type);
                                        for (const r of s.layerUpdates){
                                            const s = m.data.subarray(r * t / m.data.BYTES_PER_ELEMENT, (r + 1) * t / m.data.BYTES_PER_ELEMENT);
                                            i.compressedTexSubImage3D(e1.TEXTURE_2D_ARRAY, a, 0, 0, r, m.width, m.height, 1, n, s);
                                        }
                                        s.clearLayerUpdates();
                                    } else i.compressedTexSubImage3D(e1.TEXTURE_2D_ARRAY, a, 0, 0, 0, m.width, m.height, t.depth, n, m.data);
                                }
                            } else i.compressedTexImage3D(e1.TEXTURE_2D_ARRAY, a, g, m.width, m.height, t.depth, 0, m.data, 0, 0);
                        } else $785da19a645c07eb$var$sj("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                    } else w ? k && i.texSubImage3D(e1.TEXTURE_2D_ARRAY, a, 0, 0, 0, m.width, m.height, t.depth, n, p, m.data) : i.texImage3D(e1.TEXTURE_2D_ARRAY, a, g, m.width, m.height, t.depth, 0, n, p, m.data);
                } else {
                    w && E && i.texStorage2D(e1.TEXTURE_2D, S, g, v[0].width, v[0].height);
                    for(let t = 0, a = v.length; t < a; t++)m = v[t], s.format !== $785da19a645c07eb$var$XU ? null !== n ? w ? k && i.compressedTexSubImage2D(e1.TEXTURE_2D, t, 0, 0, m.width, m.height, n, m.data) : i.compressedTexImage2D(e1.TEXTURE_2D, t, g, m.width, m.height, 0, m.data) : $785da19a645c07eb$var$sj("WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : w ? k && i.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, m.width, m.height, n, p, m.data) : i.texImage2D(e1.TEXTURE_2D, t, g, m.width, m.height, 0, n, p, m.data);
                }
            } else if (s.isDataArrayTexture) {
                if (w) {
                    if (E && i.texStorage3D(e1.TEXTURE_2D_ARRAY, S, g, t.width, t.height, t.depth), k) {
                        if (s.layerUpdates.size > 0) {
                            const a = $785da19a645c07eb$var$uH(t.width, t.height, s.format, s.type);
                            for (const r of s.layerUpdates){
                                const s = t.data.subarray(r * a / t.data.BYTES_PER_ELEMENT, (r + 1) * a / t.data.BYTES_PER_ELEMENT);
                                i.texSubImage3D(e1.TEXTURE_2D_ARRAY, 0, 0, 0, r, t.width, t.height, 1, n, p, s);
                            }
                            s.clearLayerUpdates();
                        } else i.texSubImage3D(e1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, t.width, t.height, t.depth, n, p, t.data);
                    }
                } else i.texImage3D(e1.TEXTURE_2D_ARRAY, 0, g, t.width, t.height, t.depth, 0, n, p, t.data);
            } else if (s.isData3DTexture) w ? (E && i.texStorage3D(e1.TEXTURE_3D, S, g, t.width, t.height, t.depth), k && i.texSubImage3D(e1.TEXTURE_3D, 0, 0, 0, 0, t.width, t.height, t.depth, n, p, t.data)) : i.texImage3D(e1.TEXTURE_3D, 0, g, t.width, t.height, t.depth, 0, n, p, t.data);
            else if (s.isFramebufferTexture) {
                if (E) {
                    if (w) i.texStorage2D(e1.TEXTURE_2D, S, g, t.width, t.height);
                    else {
                        let a = t.width, r = t.height;
                        for(let t = 0; t < S; t++)i.texImage2D(e1.TEXTURE_2D, t, g, a, r, 0, n, p, null), a >>= 1, r >>= 1;
                    }
                }
            } else if (s.isHTMLTexture) {
                if ("texElementImage2D" in e1) {
                    const i = e1.canvas;
                    if (i.hasAttribute("layoutsubtree") || i.setAttribute("layoutsubtree", "true"), t.parentNode !== i) return i.appendChild(t), h.add(s), i.onpaint = (e1)=>{
                        const t = e1.changedElements;
                        for (const e1 of h)t.includes(e1.image) && (e1.needsUpdate = !0);
                    }, void i.requestPaint();
                    if (3 === e1.texElementImage2D.length) e1.texElementImage2D(e1.TEXTURE_2D, e1.RGBA8, t);
                    else {
                        const i = 0, n = e1.RGBA, a = e1.RGBA, r = e1.UNSIGNED_BYTE;
                        e1.texElementImage2D(e1.TEXTURE_2D, i, n, a, r, t);
                    }
                    e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_MIN_FILTER, e1.LINEAR), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_S, e1.CLAMP_TO_EDGE), e1.texParameteri(e1.TEXTURE_2D, e1.TEXTURE_WRAP_T, e1.CLAMP_TO_EDGE);
                }
            } else if (v.length > 0) {
                if (w && E) {
                    const t = G(v[0]);
                    i.texStorage2D(e1.TEXTURE_2D, S, g, t.width, t.height);
                }
                for(let t = 0, a = v.length; t < a; t++)m = v[t], w ? k && i.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, n, p, m) : i.texImage2D(e1.TEXTURE_2D, t, g, n, p, m);
                s.generateMipmaps = !1;
            } else if (w) {
                if (E) {
                    const n = G(t);
                    i.texStorage2D(e1.TEXTURE_2D, S, g, n.width, n.height);
                }
                k && i.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, n, p, t);
            } else i.texImage2D(e1.TEXTURE_2D, 0, g, n, p, t);
            A(s) && _(l), d.__version = u.version, s.onUpdate && s.onUpdate(s);
        }
        t.__version = s.version;
    }
    function R(t, a, s, l, c, u) {
        const h = r.convert(s.format, s.colorSpace), d = r.convert(s.type), p = y(s.internalFormat, h, d, s.normalized, s.colorSpace), m = n.get(a), g = n.get(s);
        if (g.__renderTarget = a, !m.__hasExternalTextures) {
            const t = Math.max(1, a.width >> u), n = Math.max(1, a.height >> u);
            c === e1.TEXTURE_3D || c === e1.TEXTURE_2D_ARRAY ? i.texImage3D(c, u, p, t, n, a.depth, 0, h, d, null) : i.texImage2D(c, u, p, t, n, 0, h, d, null);
        }
        i.bindFramebuffer(e1.FRAMEBUFFER, t), V(a) ? o.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, l, c, g.__webglTexture, 0, j(a)) : (c === e1.TEXTURE_2D || c >= e1.TEXTURE_CUBE_MAP_POSITIVE_X && c <= e1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e1.framebufferTexture2D(e1.FRAMEBUFFER, l, c, g.__webglTexture, u), i.bindFramebuffer(e1.FRAMEBUFFER, null);
    }
    function L1(t, i, n) {
        if (e1.bindRenderbuffer(e1.RENDERBUFFER, t), i.depthBuffer) {
            const a = i.depthTexture, r = a && a.isDepthTexture ? a.type : null, s = x(i.stencilBuffer, r), l = i.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT;
            V(i) ? o.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, j(i), s, i.width, i.height) : n ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, j(i), s, i.width, i.height) : e1.renderbufferStorage(e1.RENDERBUFFER, s, i.width, i.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, l, e1.RENDERBUFFER, t);
        } else {
            const t = i.textures;
            for(let a = 0; a < t.length; a++){
                const s = t[a], l = r.convert(s.format, s.colorSpace), c = r.convert(s.type), u = y(s.internalFormat, l, c, s.normalized, s.colorSpace);
                V(i) ? o.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, j(i), u, i.width, i.height) : n ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, j(i), u, i.width, i.height) : e1.renderbufferStorage(e1.RENDERBUFFER, u, i.width, i.height);
            }
        }
        e1.bindRenderbuffer(e1.RENDERBUFFER, null);
    }
    function B(t, a, s) {
        const l = !0 === a.isWebGLCubeRenderTarget;
        if (i.bindFramebuffer(e1.FRAMEBUFFER, t), !a.depthTexture || !a.depthTexture.isDepthTexture) throw new Error("THREE.WebGLTextures: renderTarget.depthTexture must be an instance of THREE.DepthTexture.");
        const c = n.get(a.depthTexture);
        if (c.__renderTarget = a, c.__webglTexture && a.depthTexture.image.width === a.width && a.depthTexture.image.height === a.height || (a.depthTexture.image.width = a.width, a.depthTexture.image.height = a.height, a.depthTexture.needsUpdate = !0), l) {
            if (void 0 === c.__webglInit && (c.__webglInit = !0, a.depthTexture.addEventListener("dispose", w)), void 0 === c.__webglTexture) {
                c.__webglTexture = e1.createTexture(), i.bindTexture(e1.TEXTURE_CUBE_MAP, c.__webglTexture), P(e1.TEXTURE_CUBE_MAP, a.depthTexture);
                const t = r.convert(a.depthTexture.format), n = r.convert(a.depthTexture.type);
                let s;
                a.depthTexture.format === $785da19a645c07eb$var$QU ? s = e1.DEPTH_COMPONENT24 : a.depthTexture.format === $785da19a645c07eb$var$YU && (s = e1.DEPTH24_STENCIL8);
                for(let i = 0; i < 6; i++)e1.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, s, a.width, a.height, 0, t, n, null);
            }
        } else M(a.depthTexture, 0);
        const u = c.__webglTexture, h = j(a), d = l ? e1.TEXTURE_CUBE_MAP_POSITIVE_X + s : e1.TEXTURE_2D, p = a.depthTexture.format === $785da19a645c07eb$var$YU ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT;
        if (a.depthTexture.format === $785da19a645c07eb$var$QU) V(a) ? o.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, p, d, u, 0, h) : e1.framebufferTexture2D(e1.FRAMEBUFFER, p, d, u, 0);
        else {
            if (a.depthTexture.format !== $785da19a645c07eb$var$YU) throw new Error("THREE.WebGLTextures: Unknown depthTexture format.");
            V(a) ? o.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, p, d, u, 0, h) : e1.framebufferTexture2D(e1.FRAMEBUFFER, p, d, u, 0);
        }
    }
    function O(t) {
        const a = n.get(t), r = !0 === t.isWebGLCubeRenderTarget;
        if (a.__boundDepthTexture !== t.depthTexture) {
            const e1 = t.depthTexture;
            if (a.__depthDisposeCallback && a.__depthDisposeCallback(), e1) {
                const t = ()=>{
                    delete a.__boundDepthTexture, delete a.__depthDisposeCallback, e1.removeEventListener("dispose", t);
                };
                e1.addEventListener("dispose", t), a.__depthDisposeCallback = t;
            }
            a.__boundDepthTexture = e1;
        }
        if (t.depthTexture && !a.__autoAllocateDepthBuffer) {
            if (r) for(let e1 = 0; e1 < 6; e1++)B(a.__webglFramebuffer[e1], t, e1);
            else {
                const e1 = t.texture.mipmaps;
                e1 && e1.length > 0 ? B(a.__webglFramebuffer[0], t, 0) : B(a.__webglFramebuffer, t, 0);
            }
        } else if (r) {
            a.__webglDepthbuffer = [];
            for(let n = 0; n < 6; n++)if (i.bindFramebuffer(e1.FRAMEBUFFER, a.__webglFramebuffer[n]), void 0 === a.__webglDepthbuffer[n]) a.__webglDepthbuffer[n] = e1.createRenderbuffer(), L1(a.__webglDepthbuffer[n], t, !1);
            else {
                const i = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, r = a.__webglDepthbuffer[n];
                e1.bindRenderbuffer(e1.RENDERBUFFER, r), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, i, e1.RENDERBUFFER, r);
            }
        } else {
            const n = t.texture.mipmaps;
            if (n && n.length > 0 ? i.bindFramebuffer(e1.FRAMEBUFFER, a.__webglFramebuffer[0]) : i.bindFramebuffer(e1.FRAMEBUFFER, a.__webglFramebuffer), void 0 === a.__webglDepthbuffer) a.__webglDepthbuffer = e1.createRenderbuffer(), L1(a.__webglDepthbuffer, t, !1);
            else {
                const i = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, n = a.__webglDepthbuffer;
                e1.bindRenderbuffer(e1.RENDERBUFFER, n), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, i, e1.RENDERBUFFER, n);
            }
        }
        i.bindFramebuffer(e1.FRAMEBUFFER, null);
    }
    const U = [], N = [];
    function j(e1) {
        return Math.min(a.maxSamples, e1.samples);
    }
    function V(e1) {
        const i = n.get(e1);
        return e1.samples > 0 && !0 === t.has("WEBGL_multisampled_render_to_texture") && !1 !== i.__useRenderToTexture;
    }
    function q(e1, t) {
        const i = e1.colorSpace, n = e1.format, a = e1.type;
        return !0 === e1.isCompressedTexture || !0 === e1.isVideoTexture || i !== $785da19a645c07eb$var$NN && i !== $785da19a645c07eb$var$ON && ($785da19a645c07eb$var$Ij.getTransfer(i) === $785da19a645c07eb$var$VN ? n === $785da19a645c07eb$var$XU && a === $785da19a645c07eb$var$LU || $785da19a645c07eb$var$sj("WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : $785da19a645c07eb$var$oj("WebGLTextures: Unsupported texture color space:", i)), t;
    }
    function G(e1) {
        return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement ? (c.width = e1.naturalWidth || e1.width, c.height = e1.naturalHeight || e1.height) : "undefined" != typeof VideoFrame && e1 instanceof VideoFrame ? (c.width = e1.displayWidth, c.height = e1.displayHeight) : (c.width = e1.width, c.height = e1.height), c;
    }
    this.allocateTextureUnit = function() {
        const e1 = S;
        return e1 >= a.maxTextures && $785da19a645c07eb$var$sj("WebGLTextures: Trying to use " + e1 + " texture units while this GPU supports only " + a.maxTextures), S += 1, e1;
    }, this.resetTextureUnits = function() {
        S = 0;
    }, this.getTextureUnits = function() {
        return S;
    }, this.setTextureUnits = function(e1) {
        S = e1;
    }, this.setTexture2D = M, this.setTexture2DArray = function(t, a) {
        const r = n.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && r.__version !== t.version ? z(r, t, a) : (t.isExternalTexture && (r.__webglTexture = t.sourceTexture ? t.sourceTexture : null), i.bindTexture(e1.TEXTURE_2D_ARRAY, r.__webglTexture, e1.TEXTURE0 + a));
    }, this.setTexture3D = function(t, a) {
        const r = n.get(t);
        !1 === t.isRenderTargetTexture && t.version > 0 && r.__version !== t.version ? z(r, t, a) : i.bindTexture(e1.TEXTURE_3D, r.__webglTexture, e1.TEXTURE0 + a);
    }, this.setTextureCube = function(t, s) {
        const o = n.get(t);
        !0 !== t.isCubeDepthTexture && t.version > 0 && o.__version !== t.version ? function(t, s, o) {
            if (6 !== s.image.length) return;
            const l = I(t, s), c = s.source;
            i.bindTexture(e1.TEXTURE_CUBE_MAP, t.__webglTexture, e1.TEXTURE0 + o);
            const u = n.get(c);
            if (c.version !== u.__version || !0 === l) {
                i.activeTexture(e1.TEXTURE0 + o);
                const t = $785da19a645c07eb$var$Ij.getPrimaries($785da19a645c07eb$var$Ij.workingColorSpace), n = s.colorSpace === $785da19a645c07eb$var$ON ? null : $785da19a645c07eb$var$Ij.getPrimaries(s.colorSpace), h = s.colorSpace === $785da19a645c07eb$var$ON || t === n ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                i.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, s.flipY), i.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, s.premultiplyAlpha), i.pixelStorei(e1.UNPACK_ALIGNMENT, s.unpackAlignment), i.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, h);
                const d = s.isCompressedTexture || s.image[0].isCompressedTexture, p = s.image[0] && s.image[0].isDataTexture, m = [];
                for(let e1 = 0; e1 < 6; e1++)m[e1] = d || p ? p ? s.image[e1].image : s.image[e1] : f(s.image[e1], !0, a.maxCubemapSize), m[e1] = q(s, m[e1]);
                const g = m[0], v = r.convert(s.format, s.colorSpace), x = r.convert(s.type), w = y(s.internalFormat, v, x, s.normalized, s.colorSpace), E = !0 !== s.isVideoTexture, k = void 0 === u.__version || !0 === l, S = c.dataReady;
                let M, C = b(s, g);
                if (P(e1.TEXTURE_CUBE_MAP, s), d) {
                    E && k && i.texStorage2D(e1.TEXTURE_CUBE_MAP, C, w, g.width, g.height);
                    for(let t = 0; t < 6; t++){
                        M = m[t].mipmaps;
                        for(let n = 0; n < M.length; n++){
                            const a = M[n];
                            s.format !== $785da19a645c07eb$var$XU ? null !== v ? E ? S && i.compressedTexSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, 0, 0, a.width, a.height, v, a.data) : i.compressedTexImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, w, a.width, a.height, 0, a.data) : $785da19a645c07eb$var$sj("WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : E ? S && i.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, 0, 0, a.width, a.height, v, x, a.data) : i.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n, w, a.width, a.height, 0, v, x, a.data);
                        }
                    }
                } else {
                    if (M = s.mipmaps, E && k) {
                        M.length > 0 && C++;
                        const t = G(m[0]);
                        i.texStorage2D(e1.TEXTURE_CUBE_MAP, C, w, t.width, t.height);
                    }
                    for(let t = 0; t < 6; t++)if (p) {
                        E ? S && i.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, m[t].width, m[t].height, v, x, m[t].data) : i.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, w, m[t].width, m[t].height, 0, v, x, m[t].data);
                        for(let n = 0; n < M.length; n++){
                            const a = M[n].image[t].image;
                            E ? S && i.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, a.width, a.height, v, x, a.data) : i.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, w, a.width, a.height, 0, v, x, a.data);
                        }
                    } else {
                        E ? S && i.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, v, x, m[t]) : i.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, w, v, x, m[t]);
                        for(let n = 0; n < M.length; n++){
                            const a = M[n];
                            E ? S && i.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, 0, 0, v, x, a.image[t]) : i.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, n + 1, w, v, x, a.image[t]);
                        }
                    }
                }
                A(s) && _(e1.TEXTURE_CUBE_MAP), u.__version = c.version, s.onUpdate && s.onUpdate(s);
            }
            t.__version = s.version;
        }(o, t, s) : i.bindTexture(e1.TEXTURE_CUBE_MAP, o.__webglTexture, e1.TEXTURE0 + s);
    }, this.rebindTextures = function(t, i, a) {
        const r = n.get(t);
        void 0 !== i && R(r.__webglFramebuffer, t, t.texture, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, 0), void 0 !== a && O(t);
    }, this.setupRenderTarget = function(t) {
        const a = t.texture, o = n.get(t), l = n.get(a);
        t.addEventListener("dispose", E);
        const c = t.textures, u = !0 === t.isWebGLCubeRenderTarget, h = c.length > 1;
        if (h || (void 0 === l.__webglTexture && (l.__webglTexture = e1.createTexture()), l.__version = a.version, s.memory.textures++), u) {
            o.__webglFramebuffer = [];
            for(let t = 0; t < 6; t++)if (a.mipmaps && a.mipmaps.length > 0) {
                o.__webglFramebuffer[t] = [];
                for(let i = 0; i < a.mipmaps.length; i++)o.__webglFramebuffer[t][i] = e1.createFramebuffer();
            } else o.__webglFramebuffer[t] = e1.createFramebuffer();
        } else {
            if (a.mipmaps && a.mipmaps.length > 0) {
                o.__webglFramebuffer = [];
                for(let t = 0; t < a.mipmaps.length; t++)o.__webglFramebuffer[t] = e1.createFramebuffer();
            } else o.__webglFramebuffer = e1.createFramebuffer();
            if (h) for(let t = 0, i = c.length; t < i; t++){
                const i = n.get(c[t]);
                void 0 === i.__webglTexture && (i.__webglTexture = e1.createTexture(), s.memory.textures++);
            }
            if (t.samples > 0 && !1 === V(t)) {
                o.__webglMultisampledFramebuffer = e1.createFramebuffer(), o.__webglColorRenderbuffer = [], i.bindFramebuffer(e1.FRAMEBUFFER, o.__webglMultisampledFramebuffer);
                for(let i = 0; i < c.length; i++){
                    const n = c[i];
                    o.__webglColorRenderbuffer[i] = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, o.__webglColorRenderbuffer[i]);
                    const a = r.convert(n.format, n.colorSpace), s = r.convert(n.type), l = y(n.internalFormat, a, s, n.normalized, n.colorSpace, !0 === t.isXRRenderTarget), u = j(t);
                    e1.renderbufferStorageMultisample(e1.RENDERBUFFER, u, l, t.width, t.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + i, e1.RENDERBUFFER, o.__webglColorRenderbuffer[i]);
                }
                e1.bindRenderbuffer(e1.RENDERBUFFER, null), t.depthBuffer && (o.__webglDepthRenderbuffer = e1.createRenderbuffer(), L1(o.__webglDepthRenderbuffer, t, !0)), i.bindFramebuffer(e1.FRAMEBUFFER, null);
            }
        }
        if (u) {
            i.bindTexture(e1.TEXTURE_CUBE_MAP, l.__webglTexture), P(e1.TEXTURE_CUBE_MAP, a);
            for(let i = 0; i < 6; i++)if (a.mipmaps && a.mipmaps.length > 0) for(let n = 0; n < a.mipmaps.length; n++)R(o.__webglFramebuffer[i][n], t, a, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + i, n);
            else R(o.__webglFramebuffer[i], t, a, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            A(a) && _(e1.TEXTURE_CUBE_MAP), i.unbindTexture();
        } else if (h) {
            for(let a = 0, r = c.length; a < r; a++){
                const r = c[a], s = n.get(r);
                let l = e1.TEXTURE_2D;
                (t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (l = t.isWebGL3DRenderTarget ? e1.TEXTURE_3D : e1.TEXTURE_2D_ARRAY), i.bindTexture(l, s.__webglTexture), P(l, r), R(o.__webglFramebuffer, t, r, e1.COLOR_ATTACHMENT0 + a, l, 0), A(r) && _(l);
            }
            i.unbindTexture();
        } else {
            let n = e1.TEXTURE_2D;
            if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (n = t.isWebGL3DRenderTarget ? e1.TEXTURE_3D : e1.TEXTURE_2D_ARRAY), i.bindTexture(n, l.__webglTexture), P(n, a), a.mipmaps && a.mipmaps.length > 0) for(let i = 0; i < a.mipmaps.length; i++)R(o.__webglFramebuffer[i], t, a, e1.COLOR_ATTACHMENT0, n, i);
            else R(o.__webglFramebuffer, t, a, e1.COLOR_ATTACHMENT0, n, 0);
            A(a) && _(n), i.unbindTexture();
        }
        t.depthBuffer && O(t);
    }, this.updateRenderTargetMipmap = function(e1) {
        const t = e1.textures;
        for(let a = 0, r = t.length; a < r; a++){
            const r = t[a];
            if (A(r)) {
                const t = v(e1), a = n.get(r).__webglTexture;
                i.bindTexture(t, a), _(t), i.unbindTexture();
            }
        }
    }, this.updateMultisampleRenderTarget = function(t) {
        if (t.samples > 0) {
            if (!1 === V(t)) {
                const a = t.textures, r = t.width, s = t.height;
                let o = e1.COLOR_BUFFER_BIT;
                const c = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, u = n.get(t), h = a.length > 1;
                if (h) for(let t = 0; t < a.length; t++)i.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, null), i.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, null, 0);
                i.bindFramebuffer(e1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                const d = t.texture.mipmaps;
                d && d.length > 0 ? i.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglFramebuffer[0]) : i.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                for(let i = 0; i < a.length; i++){
                    if (t.resolveDepthBuffer && (t.depthBuffer && (o |= e1.DEPTH_BUFFER_BIT), t.stencilBuffer && t.resolveStencilBuffer && (o |= e1.STENCIL_BUFFER_BIT)), h) {
                        e1.framebufferRenderbuffer(e1.READ_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, u.__webglColorRenderbuffer[i]);
                        const t = n.get(a[i]).__webglTexture;
                        e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t, 0);
                    }
                    e1.blitFramebuffer(0, 0, r, s, 0, 0, r, s, o, e1.NEAREST), !0 === l && (U.length = 0, N.length = 0, U.push(e1.COLOR_ATTACHMENT0 + i), t.depthBuffer && !1 === t.resolveDepthBuffer && (U.push(c), N.push(c), e1.invalidateFramebuffer(e1.DRAW_FRAMEBUFFER, N)), e1.invalidateFramebuffer(e1.READ_FRAMEBUFFER, U));
                }
                if (i.bindFramebuffer(e1.READ_FRAMEBUFFER, null), i.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), h) for(let t = 0; t < a.length; t++){
                    i.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, u.__webglColorRenderbuffer[t]);
                    const r = n.get(a[t]).__webglTexture;
                    i.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, r, 0);
                }
                i.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
            } else if (t.depthBuffer && !1 === t.resolveDepthBuffer && l) {
                const i = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT;
                e1.invalidateFramebuffer(e1.DRAW_FRAMEBUFFER, [
                    i
                ]);
            }
        }
    }, this.setupDepthRenderbuffer = O, this.setupFrameBufferTexture = R, this.useMultisampledRTT = V, this.isReversedDepthBuffer = function() {
        return i.buffers.depth.getReversed();
    };
}
function $785da19a645c07eb$var$KZ(e1, t) {
    return {
        convert: function(i, n = "") {
            let a;
            const r = $785da19a645c07eb$var$Ij.getTransfer(n);
            if (i === $785da19a645c07eb$var$LU) return e1.UNSIGNED_BYTE;
            if (i === $785da19a645c07eb$var$GU) return e1.UNSIGNED_SHORT_4_4_4_4;
            if (i === $785da19a645c07eb$var$HU) return e1.UNSIGNED_SHORT_5_5_5_1;
            if (i === $785da19a645c07eb$var$ZU) return e1.UNSIGNED_INT_5_9_9_9_REV;
            if (i === $785da19a645c07eb$var$KU) return e1.UNSIGNED_INT_10F_11F_11F_REV;
            if (i === $785da19a645c07eb$var$BU) return e1.BYTE;
            if (i === $785da19a645c07eb$var$OU) return e1.SHORT;
            if (i === $785da19a645c07eb$var$UU) return e1.UNSIGNED_SHORT;
            if (i === $785da19a645c07eb$var$NU) return e1.INT;
            if (i === $785da19a645c07eb$var$jU) return e1.UNSIGNED_INT;
            if (i === $785da19a645c07eb$var$VU) return e1.FLOAT;
            if (i === $785da19a645c07eb$var$qU) return e1.HALF_FLOAT;
            if (1021 === i) return e1.ALPHA;
            if (1022 === i) return e1.RGB;
            if (i === $785da19a645c07eb$var$XU) return e1.RGBA;
            if (i === $785da19a645c07eb$var$QU) return e1.DEPTH_COMPONENT;
            if (i === $785da19a645c07eb$var$YU) return e1.DEPTH_STENCIL;
            if (1028 === i) return e1.RED;
            if (i === $785da19a645c07eb$var$JU) return e1.RED_INTEGER;
            if (i === $785da19a645c07eb$var$$U) return e1.RG;
            if (i === $785da19a645c07eb$var$eN) return e1.RG_INTEGER;
            if (i === $785da19a645c07eb$var$tN) return e1.RGBA_INTEGER;
            if (i === $785da19a645c07eb$var$iN || i === $785da19a645c07eb$var$nN || i === $785da19a645c07eb$var$aN || i === $785da19a645c07eb$var$rN) {
                if (r === $785da19a645c07eb$var$VN) {
                    if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), null === a) return null;
                    if (i === $785da19a645c07eb$var$iN) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (i === $785da19a645c07eb$var$nN) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (i === $785da19a645c07eb$var$aN) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (i === $785da19a645c07eb$var$rN) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else {
                    if (a = t.get("WEBGL_compressed_texture_s3tc"), null === a) return null;
                    if (i === $785da19a645c07eb$var$iN) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (i === $785da19a645c07eb$var$nN) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (i === $785da19a645c07eb$var$aN) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (i === $785da19a645c07eb$var$rN) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                }
            }
            if (i === $785da19a645c07eb$var$sN || i === $785da19a645c07eb$var$oN || i === $785da19a645c07eb$var$lN || i === $785da19a645c07eb$var$cN) {
                if (a = t.get("WEBGL_compressed_texture_pvrtc"), null === a) return null;
                if (i === $785da19a645c07eb$var$sN) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (i === $785da19a645c07eb$var$oN) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (i === $785da19a645c07eb$var$lN) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (i === $785da19a645c07eb$var$cN) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            }
            if (i === $785da19a645c07eb$var$uN || i === $785da19a645c07eb$var$hN || i === $785da19a645c07eb$var$dN || i === $785da19a645c07eb$var$pN || i === $785da19a645c07eb$var$mN || i === $785da19a645c07eb$var$gN || i === $785da19a645c07eb$var$fN) {
                if (a = t.get("WEBGL_compressed_texture_etc"), null === a) return null;
                if (i === $785da19a645c07eb$var$uN || i === $785da19a645c07eb$var$hN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (i === $785da19a645c07eb$var$dN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
                if (i === $785da19a645c07eb$var$pN) return a.COMPRESSED_R11_EAC;
                if (i === $785da19a645c07eb$var$mN) return a.COMPRESSED_SIGNED_R11_EAC;
                if (i === $785da19a645c07eb$var$gN) return a.COMPRESSED_RG11_EAC;
                if (i === $785da19a645c07eb$var$fN) return a.COMPRESSED_SIGNED_RG11_EAC;
            }
            if (i === $785da19a645c07eb$var$AN || i === $785da19a645c07eb$var$_N || i === $785da19a645c07eb$var$vN || i === $785da19a645c07eb$var$yN || i === $785da19a645c07eb$var$xN || i === $785da19a645c07eb$var$bN || i === $785da19a645c07eb$var$wN || i === $785da19a645c07eb$var$EN || i === $785da19a645c07eb$var$kN || i === $785da19a645c07eb$var$SN || i === $785da19a645c07eb$var$MN || i === $785da19a645c07eb$var$CN || i === $785da19a645c07eb$var$TN || i === $785da19a645c07eb$var$DN) {
                if (a = t.get("WEBGL_compressed_texture_astc"), null === a) return null;
                if (i === $785da19a645c07eb$var$AN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (i === $785da19a645c07eb$var$_N) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (i === $785da19a645c07eb$var$vN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (i === $785da19a645c07eb$var$yN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (i === $785da19a645c07eb$var$xN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (i === $785da19a645c07eb$var$bN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (i === $785da19a645c07eb$var$wN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (i === $785da19a645c07eb$var$EN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (i === $785da19a645c07eb$var$kN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (i === $785da19a645c07eb$var$SN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (i === $785da19a645c07eb$var$MN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (i === $785da19a645c07eb$var$CN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (i === $785da19a645c07eb$var$TN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (i === $785da19a645c07eb$var$DN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            }
            if (i === $785da19a645c07eb$var$PN || i === $785da19a645c07eb$var$IN || i === $785da19a645c07eb$var$FN) {
                if (a = t.get("EXT_texture_compression_bptc"), null === a) return null;
                if (i === $785da19a645c07eb$var$PN) return r === $785da19a645c07eb$var$VN ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (i === $785da19a645c07eb$var$IN) return a.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (i === $785da19a645c07eb$var$FN) return a.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            }
            if (i === $785da19a645c07eb$var$zN || i === $785da19a645c07eb$var$RN || i === $785da19a645c07eb$var$LN || i === $785da19a645c07eb$var$BN) {
                if (a = t.get("EXT_texture_compression_rgtc"), null === a) return null;
                if (i === $785da19a645c07eb$var$zN) return a.COMPRESSED_RED_RGTC1_EXT;
                if (i === $785da19a645c07eb$var$RN) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (i === $785da19a645c07eb$var$LN) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (i === $785da19a645c07eb$var$BN) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            }
            return i === $785da19a645c07eb$var$WU ? e1.UNSIGNED_INT_24_8 : void 0 !== e1[i] ? e1[i] : null;
        }
    };
}
class $785da19a645c07eb$var$XZ {
    constructor(){
        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
    }
    init(e1, t) {
        if (null === this.texture) {
            const i = new $785da19a645c07eb$var$bG(e1.texture);
            e1.depthNear === t.depthNear && e1.depthFar === t.depthFar || (this.depthNear = e1.depthNear, this.depthFar = e1.depthFar), this.texture = i;
        }
    }
    getMesh(e1) {
        if (null !== this.texture && null === this.mesh) {
            const t = e1.cameras[0].viewport, i = new $785da19a645c07eb$var$FG({
                vertexShader: "\nvoid main() {\n\n\tgl_Position = vec4( position, 1.0 );\n\n}",
                fragmentShader: "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n\tvec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n\tif ( coord.x >= 1.0 ) {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n\t} else {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n\t}\n\n}",
                uniforms: {
                    depthColor: {
                        value: this.texture
                    },
                    depthWidth: {
                        value: t.z
                    },
                    depthHeight: {
                        value: t.w
                    }
                }
            });
            this.mesh = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$EG(20, 20), i);
        }
        return this.mesh;
    }
    reset() {
        this.texture = null, this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $785da19a645c07eb$var$QZ extends $785da19a645c07eb$var$uj {
    constructor(e1, t){
        super();
        const i = this;
        let n = null, a = 1, r = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
        const m = "undefined" != typeof XRWebGLBinding, g = new $785da19a645c07eb$var$XZ, f = {}, A = t.getContextAttributes();
        let _ = null, v = null;
        const y = [], x = [], b = new $785da19a645c07eb$var$bj;
        let w = null;
        const E = new $785da19a645c07eb$var$eH;
        E.viewport = new $785da19a645c07eb$var$qj;
        const k = new $785da19a645c07eb$var$eH;
        k.viewport = new $785da19a645c07eb$var$qj;
        const S = [
            E,
            k
        ], M = new $785da19a645c07eb$var$aH;
        let C = null, T = null;
        function D(e1) {
            const t = x.indexOf(e1.inputSource);
            if (-1 === t) return;
            const i = y[t];
            void 0 !== i && (i.update(e1.inputSource, e1.frame, l || r), i.dispatchEvent({
                type: e1.type,
                data: e1.inputSource
            }));
        }
        function P() {
            n.removeEventListener("select", D), n.removeEventListener("selectstart", D), n.removeEventListener("selectend", D), n.removeEventListener("squeeze", D), n.removeEventListener("squeezestart", D), n.removeEventListener("squeezeend", D), n.removeEventListener("end", P), n.removeEventListener("inputsourceschange", I);
            for(let e1 = 0; e1 < y.length; e1++){
                const t = x[e1];
                null !== t && (x[e1] = null, y[e1].disconnect(t));
            }
            C = null, T = null, g.reset();
            for(const e1 in f)delete f[e1];
            e1.setRenderTarget(_), d = null, h = null, u = null, n = null, v = null, B.stop(), i.isPresenting = !1, e1.setPixelRatio(w), e1.setSize(b.width, b.height, !1), i.dispatchEvent({
                type: "sessionend"
            });
        }
        function I(e1) {
            for(let t = 0; t < e1.removed.length; t++){
                const i = e1.removed[t], n = x.indexOf(i);
                n >= 0 && (x[n] = null, y[n].disconnect(i));
            }
            for(let t = 0; t < e1.added.length; t++){
                const i = e1.added[t];
                let n = x.indexOf(i);
                if (-1 === n) {
                    for(let e1 = 0; e1 < y.length; e1++){
                        if (e1 >= x.length) {
                            x.push(i), n = e1;
                            break;
                        }
                        if (null === x[e1]) {
                            x[e1] = i, n = e1;
                            break;
                        }
                    }
                    if (-1 === n) break;
                }
                const a = y[n];
                a && a.connect(i);
            }
        }
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e1) {
            let t = y[e1];
            return void 0 === t && (t = new $785da19a645c07eb$var$EV, y[e1] = t), t.getTargetRaySpace();
        }, this.getControllerGrip = function(e1) {
            let t = y[e1];
            return void 0 === t && (t = new $785da19a645c07eb$var$EV, y[e1] = t), t.getGripSpace();
        }, this.getHand = function(e1) {
            let t = y[e1];
            return void 0 === t && (t = new $785da19a645c07eb$var$EV, y[e1] = t), t.getHandSpace();
        }, this.setFramebufferScaleFactor = function(e1) {
            a = e1, !0 === i.isPresenting && $785da19a645c07eb$var$sj("WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(e1) {
            s = e1, !0 === i.isPresenting && $785da19a645c07eb$var$sj("WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return l || r;
        }, this.setReferenceSpace = function(e1) {
            l = e1;
        }, this.getBaseLayer = function() {
            return null !== h ? h : d;
        }, this.getBinding = function() {
            return null === u && m && (u = new XRWebGLBinding(n, t)), u;
        }, this.getFrame = function() {
            return p;
        }, this.getSession = function() {
            return n;
        }, this.setSession = async function(c) {
            if (n = c, null !== n) {
                _ = e1.getRenderTarget(), n.addEventListener("select", D), n.addEventListener("selectstart", D), n.addEventListener("selectend", D), n.addEventListener("squeeze", D), n.addEventListener("squeezestart", D), n.addEventListener("squeezeend", D), n.addEventListener("end", P), n.addEventListener("inputsourceschange", I), !0 !== A.xrCompatible && await t.makeXRCompatible(), w = e1.getPixelRatio(), e1.getSize(b);
                if (m && "createProjectionLayer" in XRWebGLBinding.prototype) {
                    let i = null, r = null, s = null;
                    A.depth && (s = A.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, i = A.stencil ? $785da19a645c07eb$var$YU : $785da19a645c07eb$var$QU, r = A.stencil ? $785da19a645c07eb$var$WU : $785da19a645c07eb$var$jU);
                    const o = {
                        colorFormat: t.RGBA8,
                        depthFormat: s,
                        scaleFactor: a
                    };
                    u = this.getBinding(), h = u.createProjectionLayer(o), n.updateRenderState({
                        layers: [
                            h
                        ]
                    }), e1.setPixelRatio(1), e1.setSize(h.textureWidth, h.textureHeight, !1), v = new $785da19a645c07eb$var$Hj(h.textureWidth, h.textureHeight, {
                        format: $785da19a645c07eb$var$XU,
                        type: $785da19a645c07eb$var$LU,
                        depthTexture: new $785da19a645c07eb$var$yG(h.textureWidth, h.textureHeight, r, void 0, void 0, void 0, void 0, void 0, void 0, i),
                        stencilBuffer: A.stencil,
                        colorSpace: e1.outputColorSpace,
                        samples: A.antialias ? 4 : 0,
                        resolveDepthBuffer: !1 === h.ignoreDepthValues,
                        resolveStencilBuffer: !1 === h.ignoreDepthValues
                    });
                } else {
                    const i = {
                        antialias: A.antialias,
                        alpha: !0,
                        depth: A.depth,
                        stencil: A.stencil,
                        framebufferScaleFactor: a
                    };
                    d = new XRWebGLLayer(n, t, i), n.updateRenderState({
                        baseLayer: d
                    }), e1.setPixelRatio(1), e1.setSize(d.framebufferWidth, d.framebufferHeight, !1), v = new $785da19a645c07eb$var$Hj(d.framebufferWidth, d.framebufferHeight, {
                        format: $785da19a645c07eb$var$XU,
                        type: $785da19a645c07eb$var$LU,
                        colorSpace: e1.outputColorSpace,
                        stencilBuffer: A.stencil,
                        resolveDepthBuffer: !1 === d.ignoreDepthValues,
                        resolveStencilBuffer: !1 === d.ignoreDepthValues
                    });
                }
                v.isXRRenderTarget = !0, this.setFoveation(o), l = null, r = await n.requestReferenceSpace(s), B.setContext(n), B.start(), i.isPresenting = !0, i.dispatchEvent({
                    type: "sessionstart"
                });
            }
        }, this.getEnvironmentBlendMode = function() {
            if (null !== n) return n.environmentBlendMode;
        }, this.getDepthTexture = function() {
            return g.getDepthTexture();
        };
        const F = new $785da19a645c07eb$var$Ej, z = new $785da19a645c07eb$var$Ej;
        function R(e1, t) {
            null === t ? e1.matrixWorld.copy(e1.matrix) : e1.matrixWorld.multiplyMatrices(t.matrixWorld, e1.matrix), e1.matrixWorldInverse.copy(e1.matrixWorld).invert();
        }
        this.updateCamera = function(e1) {
            if (null === n) return;
            let t = e1.near, i = e1.far;
            null !== g.texture && (g.depthNear > 0 && (t = g.depthNear), g.depthFar > 0 && (i = g.depthFar)), M.near = k.near = E.near = t, M.far = k.far = E.far = i, C === M.near && T === M.far || (n.updateRenderState({
                depthNear: M.near,
                depthFar: M.far
            }), C = M.near, T = M.far), M.layers.mask = 6 | e1.layers.mask, E.layers.mask = -5 & M.layers.mask, k.layers.mask = -3 & M.layers.mask;
            const a = e1.parent, r = M.cameras;
            R(M, a);
            for(let e1 = 0; e1 < r.length; e1++)R(r[e1], a);
            2 === r.length ? function(e1, t, i) {
                F.setFromMatrixPosition(t.matrixWorld), z.setFromMatrixPosition(i.matrixWorld);
                const n = F.distanceTo(z), a = t.projectionMatrix.elements, r = i.projectionMatrix.elements, s = a[14] / (a[10] - 1), o = a[14] / (a[10] + 1), l = (a[9] + 1) / a[5], c = (a[9] - 1) / a[5], u = (a[8] - 1) / a[0], h = (r[8] + 1) / r[0], d = s * u, p = s * h, m = n / (-u + h), g = m * -u;
                if (t.matrixWorld.decompose(e1.position, e1.quaternion, e1.scale), e1.translateX(g), e1.translateZ(m), e1.matrixWorld.compose(e1.position, e1.quaternion, e1.scale), e1.matrixWorldInverse.copy(e1.matrixWorld).invert(), -1 === a[10]) e1.projectionMatrix.copy(t.projectionMatrix), e1.projectionMatrixInverse.copy(t.projectionMatrixInverse);
                else {
                    const t = s + m, i = o + m, a = d - g, r = p + (n - g), u = l * o / i * t, h = c * o / i * t;
                    e1.projectionMatrix.makePerspective(a, r, u, h, t, i), e1.projectionMatrixInverse.copy(e1.projectionMatrix).invert();
                }
            }(M, E, k) : M.projectionMatrix.copy(E.projectionMatrix), function(e1, t, i) {
                null === i ? e1.matrix.copy(t.matrixWorld) : (e1.matrix.copy(i.matrixWorld), e1.matrix.invert(), e1.matrix.multiply(t.matrixWorld));
                e1.matrix.decompose(e1.position, e1.quaternion, e1.scale), e1.updateMatrixWorld(!0), e1.projectionMatrix.copy(t.projectionMatrix), e1.projectionMatrixInverse.copy(t.projectionMatrixInverse), e1.isPerspectiveCamera && (e1.fov = 2 * $785da19a645c07eb$var$mj * Math.atan(1 / e1.projectionMatrix.elements[5]), e1.zoom = 1);
            }(e1, M, a);
        }, this.getCamera = function() {
            return M;
        }, this.getFoveation = function() {
            if (null !== h || null !== d) return o;
        }, this.setFoveation = function(e1) {
            o = e1, null !== h && (h.fixedFoveation = e1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = e1);
        }, this.hasDepthSensing = function() {
            return null !== g.texture;
        }, this.getDepthSensingMesh = function() {
            return g.getMesh(M);
        }, this.getCameraTexture = function(e1) {
            return f[e1];
        };
        let L1 = null;
        const B = new $785da19a645c07eb$var$hH;
        B.setAnimationLoop(function(t, a) {
            if (c = a.getViewerPose(l || r), p = a, null !== c) {
                const t = c.views;
                null !== d && (e1.setRenderTargetFramebuffer(v, d.framebuffer), e1.setRenderTarget(v));
                let a = !1;
                t.length !== M.cameras.length && (M.cameras.length = 0, a = !0);
                for(let i = 0; i < t.length; i++){
                    const n = t[i];
                    let r = null;
                    if (null !== d) r = d.getViewport(n);
                    else {
                        const t = u.getViewSubImage(h, n);
                        r = t.viewport, 0 === i && (e1.setRenderTargetTextures(v, t.colorTexture, t.depthStencilTexture), e1.setRenderTarget(v));
                    }
                    let s = S[i];
                    void 0 === s && (s = new $785da19a645c07eb$var$eH, s.layers.enable(i), s.viewport = new $785da19a645c07eb$var$qj, S[i] = s), s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(n.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(r.x, r.y, r.width, r.height), 0 === i && (M.matrix.copy(s.matrix), M.matrix.decompose(M.position, M.quaternion, M.scale)), !0 === a && M.cameras.push(s);
                }
                const r = n.enabledFeatures;
                if (r && r.includes("depth-sensing") && "gpu-optimized" == n.depthUsage && m) {
                    u = i.getBinding();
                    const e1 = u.getDepthInformation(t[0]);
                    e1 && e1.isValid && e1.texture && g.init(e1, n.renderState);
                }
                if (r && r.includes("camera-access") && m) {
                    e1.state.unbindTexture(), u = i.getBinding();
                    for(let e1 = 0; e1 < t.length; e1++){
                        const i = t[e1].camera;
                        if (i) {
                            let e1 = f[i];
                            e1 || (e1 = new $785da19a645c07eb$var$bG, f[i] = e1);
                            const t = u.getCameraImage(i);
                            e1.sourceTexture = t;
                        }
                    }
                }
            }
            for(let e1 = 0; e1 < y.length; e1++){
                const t = x[e1], i = y[e1];
                null !== t && void 0 !== i && i.update(t, a, l || r);
            }
            L1 && L1(t, a), a.detectedPlanes && i.dispatchEvent({
                type: "planesdetected",
                data: a
            }), p = null;
        }), this.setAnimationLoop = function(e1) {
            L1 = e1;
        }, this.dispose = function() {};
    }
}
const $785da19a645c07eb$var$YZ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$JZ = new $785da19a645c07eb$var$Mj;
function $785da19a645c07eb$var$$Z(e1, t) {
    function i(e1, t) {
        !0 === e1.matrixAutoUpdate && e1.updateMatrix(), t.value.copy(e1.matrix);
    }
    function n(e1, n) {
        e1.opacity.value = n.opacity, n.color && e1.diffuse.value.copy(n.color), n.emissive && e1.emissive.value.copy(n.emissive).multiplyScalar(n.emissiveIntensity), n.map && (e1.map.value = n.map, i(n.map, e1.mapTransform)), n.alphaMap && (e1.alphaMap.value = n.alphaMap, i(n.alphaMap, e1.alphaMapTransform)), n.bumpMap && (e1.bumpMap.value = n.bumpMap, i(n.bumpMap, e1.bumpMapTransform), e1.bumpScale.value = n.bumpScale, 1 === n.side && (e1.bumpScale.value *= -1)), n.normalMap && (e1.normalMap.value = n.normalMap, i(n.normalMap, e1.normalMapTransform), e1.normalScale.value.copy(n.normalScale), 1 === n.side && e1.normalScale.value.negate()), n.displacementMap && (e1.displacementMap.value = n.displacementMap, i(n.displacementMap, e1.displacementMapTransform), e1.displacementScale.value = n.displacementScale, e1.displacementBias.value = n.displacementBias), n.emissiveMap && (e1.emissiveMap.value = n.emissiveMap, i(n.emissiveMap, e1.emissiveMapTransform)), n.specularMap && (e1.specularMap.value = n.specularMap, i(n.specularMap, e1.specularMapTransform)), n.alphaTest > 0 && (e1.alphaTest.value = n.alphaTest);
        const a = t.get(n), r = a.envMap, s = a.envMapRotation;
        r && (e1.envMap.value = r, e1.envMapRotation.value.setFromMatrix4($785da19a645c07eb$var$YZ.makeRotationFromEuler(s)).transpose(), r.isCubeTexture && !1 === r.isRenderTargetTexture && e1.envMapRotation.value.premultiply($785da19a645c07eb$var$JZ), e1.reflectivity.value = n.reflectivity, e1.ior.value = n.ior, e1.refractionRatio.value = n.refractionRatio), n.lightMap && (e1.lightMap.value = n.lightMap, e1.lightMapIntensity.value = n.lightMapIntensity, i(n.lightMap, e1.lightMapTransform)), n.aoMap && (e1.aoMap.value = n.aoMap, e1.aoMapIntensity.value = n.aoMapIntensity, i(n.aoMap, e1.aoMapTransform));
    }
    return {
        refreshFogUniforms: function(t, i) {
            i.color.getRGB(t.fogColor.value, $785da19a645c07eb$var$PG(e1)), i.isFog ? (t.fogNear.value = i.near, t.fogFar.value = i.far) : i.isFogExp2 && (t.fogDensity.value = i.density);
        },
        refreshMaterialUniforms: function(e1, a, r, s, o) {
            a.isNodeMaterial ? a.uniformsNeedUpdate = !1 : a.isMeshBasicMaterial ? n(e1, a) : a.isMeshLambertMaterial ? (n(e1, a), a.envMap && (e1.envMapIntensity.value = a.envMapIntensity)) : a.isMeshToonMaterial ? (n(e1, a), function(e1, t) {
                t.gradientMap && (e1.gradientMap.value = t.gradientMap);
            }(e1, a)) : a.isMeshPhongMaterial ? (n(e1, a), function(e1, t) {
                e1.specular.value.copy(t.specular), e1.shininess.value = Math.max(t.shininess, 1e-4);
            }(e1, a), a.envMap && (e1.envMapIntensity.value = a.envMapIntensity)) : a.isMeshStandardMaterial ? (n(e1, a), function(e1, t) {
                e1.metalness.value = t.metalness, t.metalnessMap && (e1.metalnessMap.value = t.metalnessMap, i(t.metalnessMap, e1.metalnessMapTransform));
                e1.roughness.value = t.roughness, t.roughnessMap && (e1.roughnessMap.value = t.roughnessMap, i(t.roughnessMap, e1.roughnessMapTransform));
                t.envMap && (e1.envMapIntensity.value = t.envMapIntensity);
            }(e1, a), a.isMeshPhysicalMaterial && function(e1, t, n) {
                e1.ior.value = t.ior, t.sheen > 0 && (e1.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e1.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e1.sheenColorMap.value = t.sheenColorMap, i(t.sheenColorMap, e1.sheenColorMapTransform)), t.sheenRoughnessMap && (e1.sheenRoughnessMap.value = t.sheenRoughnessMap, i(t.sheenRoughnessMap, e1.sheenRoughnessMapTransform)));
                t.clearcoat > 0 && (e1.clearcoat.value = t.clearcoat, e1.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e1.clearcoatMap.value = t.clearcoatMap, i(t.clearcoatMap, e1.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e1.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, i(t.clearcoatRoughnessMap, e1.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e1.clearcoatNormalMap.value = t.clearcoatNormalMap, i(t.clearcoatNormalMap, e1.clearcoatNormalMapTransform), e1.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), 1 === t.side && e1.clearcoatNormalScale.value.negate()));
                t.dispersion > 0 && (e1.dispersion.value = t.dispersion);
                t.iridescence > 0 && (e1.iridescence.value = t.iridescence, e1.iridescenceIOR.value = t.iridescenceIOR, e1.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e1.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e1.iridescenceMap.value = t.iridescenceMap, i(t.iridescenceMap, e1.iridescenceMapTransform)), t.iridescenceThicknessMap && (e1.iridescenceThicknessMap.value = t.iridescenceThicknessMap, i(t.iridescenceThicknessMap, e1.iridescenceThicknessMapTransform)));
                t.transmission > 0 && (e1.transmission.value = t.transmission, e1.transmissionSamplerMap.value = n.texture, e1.transmissionSamplerSize.value.set(n.width, n.height), t.transmissionMap && (e1.transmissionMap.value = t.transmissionMap, i(t.transmissionMap, e1.transmissionMapTransform)), e1.thickness.value = t.thickness, t.thicknessMap && (e1.thicknessMap.value = t.thicknessMap, i(t.thicknessMap, e1.thicknessMapTransform)), e1.attenuationDistance.value = t.attenuationDistance, e1.attenuationColor.value.copy(t.attenuationColor));
                t.anisotropy > 0 && (e1.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e1.anisotropyMap.value = t.anisotropyMap, i(t.anisotropyMap, e1.anisotropyMapTransform)));
                e1.specularIntensity.value = t.specularIntensity, e1.specularColor.value.copy(t.specularColor), t.specularColorMap && (e1.specularColorMap.value = t.specularColorMap, i(t.specularColorMap, e1.specularColorMapTransform));
                t.specularIntensityMap && (e1.specularIntensityMap.value = t.specularIntensityMap, i(t.specularIntensityMap, e1.specularIntensityMapTransform));
            }(e1, a, o)) : a.isMeshMatcapMaterial ? (n(e1, a), function(e1, t) {
                t.matcap && (e1.matcap.value = t.matcap);
            }(e1, a)) : a.isMeshDepthMaterial ? n(e1, a) : a.isMeshDistanceMaterial ? (n(e1, a), function(e1, i) {
                const n = t.get(i).light;
                e1.referencePosition.value.setFromMatrixPosition(n.matrixWorld), e1.nearDistance.value = n.shadow.camera.near, e1.farDistance.value = n.shadow.camera.far;
            }(e1, a)) : a.isMeshNormalMaterial ? n(e1, a) : a.isLineBasicMaterial ? (function(e1, t) {
                e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, t.map && (e1.map.value = t.map, i(t.map, e1.mapTransform));
            }(e1, a), a.isLineDashedMaterial && function(e1, t) {
                e1.dashSize.value = t.dashSize, e1.totalSize.value = t.dashSize + t.gapSize, e1.scale.value = t.scale;
            }(e1, a)) : a.isPointsMaterial ? function(e1, t, n, a) {
                e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.size.value = t.size * n, e1.scale.value = .5 * a, t.map && (e1.map.value = t.map, i(t.map, e1.uvTransform));
                t.alphaMap && (e1.alphaMap.value = t.alphaMap, i(t.alphaMap, e1.alphaMapTransform));
                t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
            }(e1, a, r, s) : a.isSpriteMaterial ? function(e1, t) {
                e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.rotation.value = t.rotation, t.map && (e1.map.value = t.map, i(t.map, e1.mapTransform));
                t.alphaMap && (e1.alphaMap.value = t.alphaMap, i(t.alphaMap, e1.alphaMapTransform));
                t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
            }(e1, a) : a.isShadowMaterial ? (e1.color.value.copy(a.color), e1.opacity.value = a.opacity) : a.isShaderMaterial && (a.uniformsNeedUpdate = !1);
        }
    };
}
function $785da19a645c07eb$var$eK(e1, t, i, n) {
    let a = {}, r = {}, s = [];
    const o = e1.getParameter(e1.MAX_UNIFORM_BUFFER_BINDINGS);
    function l(t, i, n, a) {
        if (!0 === function(e1, t, i, n) {
            const a = e1.value, r = t + "_" + i;
            if (void 0 === n[r]) return "number" == typeof a || "boolean" == typeof a ? n[r] = a : ArrayBuffer.isView(a) ? n[r] = a.slice() : n[r] = a.clone(), !0;
            {
                const e1 = n[r];
                if ("number" == typeof a || "boolean" == typeof a) {
                    if (e1 !== a) return n[r] = a, !0;
                } else {
                    if (ArrayBuffer.isView(a)) return !0;
                    if (!1 === e1.equals(a)) return e1.copy(a), !0;
                }
            }
            return !1;
        }(t, i, n, a)) {
            const i = t.__offset, n = t.value;
            if (Array.isArray(n)) {
                let e1 = 0;
                for(let i = 0; i < n.length; i++){
                    const a = n[i], r = u(a);
                    c(a, t.__data, e1), "number" == typeof a || "boolean" == typeof a || a.isMatrix3 || ArrayBuffer.isView(a) || (e1 += r.storage / Float32Array.BYTES_PER_ELEMENT);
                }
            } else c(n, t.__data, 0);
            e1.bufferSubData(e1.UNIFORM_BUFFER, i, t.__data);
        }
    }
    function c(e1, t, i) {
        "number" == typeof e1 || "boolean" == typeof e1 ? t[0] = e1 : e1.isMatrix3 ? (t[0] = e1.elements[0], t[1] = e1.elements[1], t[2] = e1.elements[2], t[3] = 0, t[4] = e1.elements[3], t[5] = e1.elements[4], t[6] = e1.elements[5], t[7] = 0, t[8] = e1.elements[6], t[9] = e1.elements[7], t[10] = e1.elements[8], t[11] = 0) : ArrayBuffer.isView(e1) ? t.set(new e1.constructor(e1.buffer, e1.byteOffset, t.length)) : e1.toArray(t, i);
    }
    function u(e1) {
        const t = {
            boundary: 0,
            storage: 0
        };
        return "number" == typeof e1 || "boolean" == typeof e1 ? (t.boundary = 4, t.storage = 4) : e1.isVector2 ? (t.boundary = 8, t.storage = 8) : e1.isVector3 || e1.isColor ? (t.boundary = 16, t.storage = 12) : e1.isVector4 ? (t.boundary = 16, t.storage = 16) : e1.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e1.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e1.isTexture ? $785da19a645c07eb$var$sj("WebGLRenderer: Texture samplers can not be part of an uniforms group.") : ArrayBuffer.isView(e1) ? (t.boundary = 16, t.storage = e1.byteLength) : $785da19a645c07eb$var$sj("WebGLRenderer: Unsupported uniform value type.", e1), t;
    }
    function h(t) {
        const i = t.target;
        i.removeEventListener("dispose", h);
        const n = s.indexOf(i.__bindingPointIndex);
        s.splice(n, 1), e1.deleteBuffer(a[i.id]), delete a[i.id], delete r[i.id];
    }
    return {
        bind: function(e1, t) {
            const i = t.program;
            n.uniformBlockBinding(e1, i);
        },
        update: function(i, c) {
            let d = a[i.id];
            void 0 === d && (!function(e1) {
                const t = e1.uniforms;
                let i = 0;
                const n = 16;
                for(let e1 = 0, a = t.length; e1 < a; e1++){
                    const a = Array.isArray(t[e1]) ? t[e1] : [
                        t[e1]
                    ];
                    for(let e1 = 0, t = a.length; e1 < t; e1++){
                        const t = a[e1], r = Array.isArray(t.value) ? t.value : [
                            t.value
                        ];
                        for(let e1 = 0, a = r.length; e1 < a; e1++){
                            const a = u(r[e1]), s = i % n, o = s % a.boundary, l = s + o;
                            i += o, 0 !== l && n - l < a.storage && (i += n - l), t.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), t.__offset = i, i += a.storage;
                        }
                    }
                }
                const a = i % n;
                a > 0 && (i += n - a);
                e1.__size = i, e1.__cache = {};
            }(i), d = function(t) {
                const i = function() {
                    for(let e1 = 0; e1 < o; e1++)if (-1 === s.indexOf(e1)) return s.push(e1), e1;
                    return $785da19a645c07eb$var$oj("WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                }();
                t.__bindingPointIndex = i;
                const n = e1.createBuffer(), a = t.__size, r = t.usage;
                return e1.bindBuffer(e1.UNIFORM_BUFFER, n), e1.bufferData(e1.UNIFORM_BUFFER, a, r), e1.bindBuffer(e1.UNIFORM_BUFFER, null), e1.bindBufferBase(e1.UNIFORM_BUFFER, i, n), n;
            }(i), a[i.id] = d, i.addEventListener("dispose", h));
            const p = c.program;
            n.updateUBOMapping(i, p);
            const m = t.render.frame;
            r[i.id] !== m && (!function(t) {
                const i = a[t.id], n = t.uniforms, r = t.__cache;
                e1.bindBuffer(e1.UNIFORM_BUFFER, i);
                for(let e1 = 0, t = n.length; e1 < t; e1++){
                    const t = n[e1];
                    if (Array.isArray(t)) for(let i = 0, n = t.length; i < n; i++)l(t[i], e1, i, r);
                    else l(t, e1, 0, r);
                }
                e1.bindBuffer(e1.UNIFORM_BUFFER, null);
            }(i), r[i.id] = m);
        },
        dispose: function() {
            for(const t in a)e1.deleteBuffer(a[t]);
            s = [], a = {}, r = {};
        }
    };
}
$785da19a645c07eb$var$JZ.set(-1, 0, 0, 0, 1, 0, 0, 0, 1);
const $785da19a645c07eb$var$tK = new Uint16Array([
    12469,
    15057,
    12620,
    14925,
    13266,
    14620,
    13807,
    14376,
    14323,
    13990,
    14545,
    13625,
    14713,
    13328,
    14840,
    12882,
    14931,
    12528,
    14996,
    12233,
    15039,
    11829,
    15066,
    11525,
    15080,
    11295,
    15085,
    10976,
    15082,
    10705,
    15073,
    10495,
    13880,
    14564,
    13898,
    14542,
    13977,
    14430,
    14158,
    14124,
    14393,
    13732,
    14556,
    13410,
    14702,
    12996,
    14814,
    12596,
    14891,
    12291,
    14937,
    11834,
    14957,
    11489,
    14958,
    11194,
    14943,
    10803,
    14921,
    10506,
    14893,
    10278,
    14858,
    9960,
    14484,
    14039,
    14487,
    14025,
    14499,
    13941,
    14524,
    13740,
    14574,
    13468,
    14654,
    13106,
    14743,
    12678,
    14818,
    12344,
    14867,
    11893,
    14889,
    11509,
    14893,
    11180,
    14881,
    10751,
    14852,
    10428,
    14812,
    10128,
    14765,
    9754,
    14712,
    9466,
    14764,
    13480,
    14764,
    13475,
    14766,
    13440,
    14766,
    13347,
    14769,
    13070,
    14786,
    12713,
    14816,
    12387,
    14844,
    11957,
    14860,
    11549,
    14868,
    11215,
    14855,
    10751,
    14825,
    10403,
    14782,
    10044,
    14729,
    9651,
    14666,
    9352,
    14599,
    9029,
    14967,
    12835,
    14966,
    12831,
    14963,
    12804,
    14954,
    12723,
    14936,
    12564,
    14917,
    12347,
    14900,
    11958,
    14886,
    11569,
    14878,
    11247,
    14859,
    10765,
    14828,
    10401,
    14784,
    10011,
    14727,
    9600,
    14660,
    9289,
    14586,
    8893,
    14508,
    8533,
    15111,
    12234,
    15110,
    12234,
    15104,
    12216,
    15092,
    12156,
    15067,
    12010,
    15028,
    11776,
    14981,
    11500,
    14942,
    11205,
    14902,
    10752,
    14861,
    10393,
    14812,
    9991,
    14752,
    9570,
    14682,
    9252,
    14603,
    8808,
    14519,
    8445,
    14431,
    8145,
    15209,
    11449,
    15208,
    11451,
    15202,
    11451,
    15190,
    11438,
    15163,
    11384,
    15117,
    11274,
    15055,
    10979,
    14994,
    10648,
    14932,
    10343,
    14871,
    9936,
    14803,
    9532,
    14729,
    9218,
    14645,
    8742,
    14556,
    8381,
    14461,
    8020,
    14365,
    7603,
    15273,
    10603,
    15272,
    10607,
    15267,
    10619,
    15256,
    10631,
    15231,
    10614,
    15182,
    10535,
    15118,
    10389,
    15042,
    10167,
    14963,
    9787,
    14883,
    9447,
    14800,
    9115,
    14710,
    8665,
    14615,
    8318,
    14514,
    7911,
    14411,
    7507,
    14279,
    7198,
    15314,
    9675,
    15313,
    9683,
    15309,
    9712,
    15298,
    9759,
    15277,
    9797,
    15229,
    9773,
    15166,
    9668,
    15084,
    9487,
    14995,
    9274,
    14898,
    8910,
    14800,
    8539,
    14697,
    8234,
    14590,
    7790,
    14479,
    7409,
    14367,
    7067,
    14178,
    6621,
    15337,
    8619,
    15337,
    8631,
    15333,
    8677,
    15325,
    8769,
    15305,
    8871,
    15264,
    8940,
    15202,
    8909,
    15119,
    8775,
    15022,
    8565,
    14916,
    8328,
    14804,
    8009,
    14688,
    7614,
    14569,
    7287,
    14448,
    6888,
    14321,
    6483,
    14088,
    6171,
    15350,
    7402,
    15350,
    7419,
    15347,
    7480,
    15340,
    7613,
    15322,
    7804,
    15287,
    7973,
    15229,
    8057,
    15148,
    8012,
    15046,
    7846,
    14933,
    7611,
    14810,
    7357,
    14682,
    7069,
    14552,
    6656,
    14421,
    6316,
    14251,
    5948,
    14007,
    5528,
    15356,
    5942,
    15356,
    5977,
    15353,
    6119,
    15348,
    6294,
    15332,
    6551,
    15302,
    6824,
    15249,
    7044,
    15171,
    7122,
    15070,
    7050,
    14949,
    6861,
    14818,
    6611,
    14679,
    6349,
    14538,
    6067,
    14398,
    5651,
    14189,
    5311,
    13935,
    4958,
    15359,
    4123,
    15359,
    4153,
    15356,
    4296,
    15353,
    4646,
    15338,
    5160,
    15311,
    5508,
    15263,
    5829,
    15188,
    6042,
    15088,
    6094,
    14966,
    6001,
    14826,
    5796,
    14678,
    5543,
    14527,
    5287,
    14377,
    4985,
    14133,
    4586,
    13869,
    4257,
    15360,
    1563,
    15360,
    1642,
    15358,
    2076,
    15354,
    2636,
    15341,
    3350,
    15317,
    4019,
    15273,
    4429,
    15203,
    4732,
    15105,
    4911,
    14981,
    4932,
    14836,
    4818,
    14679,
    4621,
    14517,
    4386,
    14359,
    4156,
    14083,
    3795,
    13808,
    3437,
    15360,
    122,
    15360,
    137,
    15358,
    285,
    15355,
    636,
    15344,
    1274,
    15322,
    2177,
    15281,
    2765,
    15215,
    3223,
    15120,
    3451,
    14995,
    3569,
    14846,
    3567,
    14681,
    3466,
    14511,
    3305,
    14344,
    3121,
    14037,
    2800,
    13753,
    2467,
    15360,
    0,
    15360,
    1,
    15359,
    21,
    15355,
    89,
    15346,
    253,
    15325,
    479,
    15287,
    796,
    15225,
    1148,
    15133,
    1492,
    15008,
    1749,
    14856,
    1882,
    14685,
    1886,
    14506,
    1783,
    14324,
    1608,
    13996,
    1398,
    13702,
    1183
]);
let $785da19a645c07eb$var$iK = null;
class $785da19a645c07eb$var$nK {
    constructor(e1 = {}){
        const { canvas: t = $785da19a645c07eb$var$ij(), context: i = null, depth: n = !0, stencil: a = !1, alpha: r = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1, reversedDepthBuffer: h = !1, outputBufferType: d = $785da19a645c07eb$var$LU } = e1;
        let p;
        if (this.isWebGLRenderer = !0, null !== i) {
            if ("undefined" != typeof WebGLRenderingContext && i instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
            p = i.getContextAttributes().alpha;
        } else p = r;
        const m = d, g = new Set([
            $785da19a645c07eb$var$tN,
            $785da19a645c07eb$var$eN,
            $785da19a645c07eb$var$JU
        ]), f = new Set([
            $785da19a645c07eb$var$LU,
            $785da19a645c07eb$var$jU,
            $785da19a645c07eb$var$UU,
            $785da19a645c07eb$var$WU,
            $785da19a645c07eb$var$GU,
            $785da19a645c07eb$var$HU
        ]), A = new Uint32Array(4), _ = new Int32Array(4), v = new $785da19a645c07eb$var$Ej;
        let y = null, x = null;
        const b = [], w = [];
        let E = null;
        this.domElement = t, this.debug = {
            checkShaderErrors: !0,
            onShaderError: null
        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = 0, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
        const k = this;
        let S = !1, M = null, C = null, T = null, D = null;
        this._outputColorSpace = $785da19a645c07eb$var$UN;
        let P = 0, I = 0, F = null, z = -1, R = null;
        const L1 = new $785da19a645c07eb$var$qj, B = new $785da19a645c07eb$var$qj;
        let O = null;
        const U = new $785da19a645c07eb$var$TV(0);
        let N = 0, j = t.width, V = t.height, q = 1, G = null, H = null;
        const W = new $785da19a645c07eb$var$qj(0, 0, j, V), Z = new $785da19a645c07eb$var$qj(0, 0, j, V);
        let K = !1;
        const X = new $785da19a645c07eb$var$aG;
        let Q = !1, Y = !1;
        const J = new $785da19a645c07eb$var$Kj, $ = new $785da19a645c07eb$var$Ej, ee = new $785da19a645c07eb$var$qj, te = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: !0
        };
        let ie = !1;
        function ne() {
            return null === F ? q : 1;
        }
        let ae, re, se, oe, le, ce, ue, he, de, pe, me, ge, fe, Ae, _e, ve, ye, xe, be, we, Ee, ke, Se, Me = i;
        function Ce(e1, i) {
            return t.getContext(e1, i);
        }
        try {
            const e1 = {
                alpha: !0,
                depth: n,
                stencil: a,
                antialias: s,
                premultipliedAlpha: o,
                preserveDrawingBuffer: l,
                powerPreference: c,
                failIfMajorPerformanceCaveat: u
            };
            if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${$785da19a645c07eb$var$zO}`), t.addEventListener("webglcontextlost", Pe, !1), t.addEventListener("webglcontextrestored", Ie, !1), t.addEventListener("webglcontextcreationerror", Fe, !1), null === Me) {
                const t = "webgl2";
                if (Me = Ce(t, e1), null === Me) throw Ce(t) ? new Error("THREE.WebGLRenderer: Error creating WebGL context with your selected attributes.") : new Error("THREE.WebGLRenderer: Error creating WebGL context.");
            }
        } catch (e1) {
            throw $785da19a645c07eb$var$oj("WebGLRenderer: " + e1.message), e1;
        }
        function Te() {
            ae = new $785da19a645c07eb$var$jH(Me), ae.init(), Ee = new $785da19a645c07eb$var$KZ(Me, ae), re = new $785da19a645c07eb$var$bH(Me, ae, e1, Ee), se = new $785da19a645c07eb$var$WZ(Me, ae), re.reversedDepthBuffer && h && se.buffers.depth.setReversed(!0), C = Me.createFramebuffer(), T = Me.createFramebuffer(), D = Me.createFramebuffer(), oe = new $785da19a645c07eb$var$GH(Me), le = new $785da19a645c07eb$var$TZ, ce = new $785da19a645c07eb$var$ZZ(Me, ae, se, le, re, Ee, oe), ue = new $785da19a645c07eb$var$NH(k), he = new $785da19a645c07eb$var$dH(Me), ke = new $785da19a645c07eb$var$yH(Me, he), de = new $785da19a645c07eb$var$VH(Me, he, oe, ke), pe = new $785da19a645c07eb$var$WH(Me, de, he, ke, oe), xe = new $785da19a645c07eb$var$HH(Me, re, ce), _e = new $785da19a645c07eb$var$wH(le), me = new $785da19a645c07eb$var$CZ(k, ue, ae, re, ke, _e), ge = new $785da19a645c07eb$var$$Z(k, le), fe = new $785da19a645c07eb$var$FZ, Ae = new $785da19a645c07eb$var$UZ(ae), ye = new $785da19a645c07eb$var$vH(k, ue, se, pe, p, o), ve = new $785da19a645c07eb$var$HZ(k, pe, re), Se = new $785da19a645c07eb$var$eK(Me, oe, re, se), be = new $785da19a645c07eb$var$xH(Me, ae, oe), we = new $785da19a645c07eb$var$qH(Me, ae, oe), oe.programs = me.programs, k.capabilities = re, k.extensions = ae, k.properties = le, k.renderLists = fe, k.shadowMap = ve, k.state = se, k.info = oe;
        }
        Te(), m !== $785da19a645c07eb$var$LU && (E = new $785da19a645c07eb$var$KH(m, t.width, t.height, s, n, a));
        const De = new $785da19a645c07eb$var$QZ(k, Me);
        function Pe(e1) {
            e1.preventDefault(), $785da19a645c07eb$var$aj("WebGLRenderer: Context Lost."), S = !0;
        }
        function Ie() {
            $785da19a645c07eb$var$aj("WebGLRenderer: Context Restored."), S = !1;
            const e1 = oe.autoReset, t = ve.enabled, i = ve.autoUpdate, n = ve.needsUpdate, a = ve.type;
            Te(), oe.autoReset = e1, ve.enabled = t, ve.autoUpdate = i, ve.needsUpdate = n, ve.type = a;
        }
        function Fe(e1) {
            $785da19a645c07eb$var$oj("WebGLRenderer: A WebGL context could not be created. Reason: ", e1.statusMessage);
        }
        function ze(e1) {
            const t = e1.target;
            t.removeEventListener("dispose", ze), function(e1) {
                (function(e1) {
                    const t = le.get(e1).programs;
                    void 0 !== t && (t.forEach(function(e1) {
                        me.releaseProgram(e1);
                    }), e1.isShaderMaterial && me.releaseShaderCache(e1));
                })(e1), le.remove(e1);
            }(t);
        }
        function Re(e1, t, i) {
            !0 === e1.transparent && 2 === e1.side && !1 === e1.forceSinglePass ? (e1.side = 1, e1.needsUpdate = !0, He(e1, t, i), e1.side = 0, e1.needsUpdate = !0, He(e1, t, i), e1.side = 2) : He(e1, t, i);
        }
        this.xr = De, this.getContext = function() {
            return Me;
        }, this.getContextAttributes = function() {
            return Me.getContextAttributes();
        }, this.forceContextLoss = function() {
            const e1 = ae.get("WEBGL_lose_context");
            e1 && e1.loseContext();
        }, this.forceContextRestore = function() {
            const e1 = ae.get("WEBGL_lose_context");
            e1 && e1.restoreContext();
        }, this.getPixelRatio = function() {
            return q;
        }, this.setPixelRatio = function(e1) {
            void 0 !== e1 && (q = e1, this.setSize(j, V, !1));
        }, this.getSize = function(e1) {
            return e1.set(j, V);
        }, this.setSize = function(e1, i, n = !0) {
            De.isPresenting ? $785da19a645c07eb$var$sj("WebGLRenderer: Can't change size while VR device is presenting.") : (j = e1, V = i, t.width = Math.floor(e1 * q), t.height = Math.floor(i * q), !0 === n && (t.style.width = e1 + "px", t.style.height = i + "px"), null !== E && E.setSize(t.width, t.height), this.setViewport(0, 0, e1, i));
        }, this.getDrawingBufferSize = function(e1) {
            return e1.set(j * q, V * q).floor();
        }, this.setDrawingBufferSize = function(e1, i, n) {
            j = e1, V = i, q = n, t.width = Math.floor(e1 * n), t.height = Math.floor(i * n), this.setViewport(0, 0, e1, i);
        }, this.setEffects = function(e1) {
            if (m !== $785da19a645c07eb$var$LU) {
                if (e1) {
                    for(let t = 0; t < e1.length; t++)if (!0 === e1[t].isOutputPass) {
                        $785da19a645c07eb$var$sj("WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.");
                        break;
                    }
                }
                E.setEffects(e1 || []);
            } else $785da19a645c07eb$var$oj("WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.");
        }, this.getCurrentViewport = function(e1) {
            return e1.copy(L1);
        }, this.getViewport = function(e1) {
            return e1.copy(W);
        }, this.setViewport = function(e1, t, i, n) {
            e1.isVector4 ? W.set(e1.x, e1.y, e1.z, e1.w) : W.set(e1, t, i, n), se.viewport(L1.copy(W).multiplyScalar(q).round());
        }, this.getScissor = function(e1) {
            return e1.copy(Z);
        }, this.setScissor = function(e1, t, i, n) {
            e1.isVector4 ? Z.set(e1.x, e1.y, e1.z, e1.w) : Z.set(e1, t, i, n), se.scissor(B.copy(Z).multiplyScalar(q).round());
        }, this.getScissorTest = function() {
            return K;
        }, this.setScissorTest = function(e1) {
            se.setScissorTest(K = e1);
        }, this.setOpaqueSort = function(e1) {
            G = e1;
        }, this.setTransparentSort = function(e1) {
            H = e1;
        }, this.getClearColor = function(e1) {
            return e1.copy(ye.getClearColor());
        }, this.setClearColor = function() {
            ye.setClearColor(...arguments);
        }, this.getClearAlpha = function() {
            return ye.getClearAlpha();
        }, this.setClearAlpha = function() {
            ye.setClearAlpha(...arguments);
        }, this.clear = function(e1 = !0, t = !0, i = !0) {
            let n = 0;
            if (e1) {
                let e1 = !1;
                if (null !== F) {
                    const t = F.texture.format;
                    e1 = g.has(t);
                }
                if (e1) {
                    const e1 = F.texture.type, t = f.has(e1), i = ye.getClearColor(), n = ye.getClearAlpha(), a = i.r, r = i.g, s = i.b;
                    t ? (A[0] = a, A[1] = r, A[2] = s, A[3] = n, Me.clearBufferuiv(Me.COLOR, 0, A)) : (_[0] = a, _[1] = r, _[2] = s, _[3] = n, Me.clearBufferiv(Me.COLOR, 0, _));
                } else n |= Me.COLOR_BUFFER_BIT;
            }
            t && (n |= Me.DEPTH_BUFFER_BIT, this.state.buffers.depth.setMask(!0)), i && (n |= Me.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), 0 !== n && Me.clear(n);
        }, this.clearColor = function() {
            this.clear(!0, !1, !1);
        }, this.clearDepth = function() {
            this.clear(!1, !0, !1);
        }, this.clearStencil = function() {
            this.clear(!1, !1, !0);
        }, this.setNodesHandler = function(e1) {
            e1.setRenderer(this), M = e1;
        }, this.dispose = function() {
            t.removeEventListener("webglcontextlost", Pe, !1), t.removeEventListener("webglcontextrestored", Ie, !1), t.removeEventListener("webglcontextcreationerror", Fe, !1), ye.dispose(), fe.dispose(), Ae.dispose(), le.dispose(), ue.dispose(), pe.dispose(), ke.dispose(), Se.dispose(), me.dispose(), De.dispose(), De.removeEventListener("sessionstart", Be), De.removeEventListener("sessionend", Oe), Ue.stop();
        }, this.renderBufferDirect = function(e1, t, i, n, a, r) {
            null === t && (t = te);
            const s = a.isMesh && a.matrixWorld.determinantAffine() < 0, o = function(e1, t, i, n, a) {
                !0 !== t.isScene && (t = te);
                ce.resetTextureUnits();
                const r = t.fog, s = n.isMeshStandardMaterial || n.isMeshLambertMaterial || n.isMeshPhongMaterial ? t.environment : null, o = null === F ? k.outputColorSpace : !0 === F.isXRRenderTarget ? F.texture.colorSpace : $785da19a645c07eb$var$Ij.workingColorSpace, l = n.isMeshStandardMaterial || n.isMeshLambertMaterial && !n.envMap || n.isMeshPhongMaterial && !n.envMap, c = ue.get(n.envMap || s, l), u = !0 === n.vertexColors && !!i.attributes.color && 4 === i.attributes.color.itemSize, h = !!i.attributes.tangent && (!!n.normalMap || n.anisotropy > 0), d = !!i.morphAttributes.position, p = !!i.morphAttributes.normal, m = !!i.morphAttributes.color;
                let g = 0;
                n.toneMapped && (null !== F && !0 !== F.isXRRenderTarget || (g = k.toneMapping));
                const f = i.morphAttributes.position || i.morphAttributes.normal || i.morphAttributes.color, A = void 0 !== f ? f.length : 0, _ = le.get(n), y = x.state.lights;
                if (!0 === Q && (!0 === Y || e1 !== R)) {
                    const t = e1 === R && n.id === z;
                    _e.setState(n, e1, t);
                }
                let b = !1;
                n.version === _.__version ? _.needsLights && _.lightsStateVersion !== y.state.version || _.outputColorSpace !== o || a.isBatchedMesh && !1 === _.batching ? b = !0 : a.isBatchedMesh || !0 !== _.batching ? a.isBatchedMesh && !0 === _.batchingColor && null === a.colorTexture || a.isBatchedMesh && !1 === _.batchingColor && null !== a.colorTexture || a.isInstancedMesh && !1 === _.instancing ? b = !0 : a.isInstancedMesh || !0 !== _.instancing ? a.isSkinnedMesh && !1 === _.skinning ? b = !0 : a.isSkinnedMesh || !0 !== _.skinning ? a.isInstancedMesh && !0 === _.instancingColor && null === a.instanceColor || a.isInstancedMesh && !1 === _.instancingColor && null !== a.instanceColor || a.isInstancedMesh && !0 === _.instancingMorph && null === a.morphTexture || a.isInstancedMesh && !1 === _.instancingMorph && null !== a.morphTexture || _.envMap !== c || !0 === n.fog && _.fog !== r ? b = !0 : void 0 === _.numClippingPlanes || _.numClippingPlanes === _e.numPlanes && _.numIntersection === _e.numIntersection ? (_.vertexAlphas !== u || _.vertexTangents !== h || _.morphTargets !== d || _.morphNormals !== p || _.morphColors !== m || _.toneMapping !== g || _.morphTargetsCount !== A || !!_.lightProbeGrid != x.state.lightProbeGridArray.length > 0) && (b = !0) : b = !0 : b = !0 : b = !0 : b = !0 : (b = !0, _.__version = n.version);
                let w = _.currentProgram;
                !0 === b && (w = He(n, t, a), M && n.isNodeMaterial && M.onUpdateProgram(n, w, _));
                let E = !1, S = !1, C = !1;
                const T = w.getUniforms(), D = _.uniforms;
                se.useProgram(w.program) && (E = !0, S = !0, C = !0);
                n.id !== z && (z = n.id, S = !0);
                if (_.needsLights) {
                    const e1 = function(e1, t) {
                        if (0 === e1.length) return null;
                        if (1 === e1.length) return null !== e1[0].texture ? e1[0] : null;
                        v.setFromMatrixPosition(t.matrixWorld);
                        for(let t = 0, i = e1.length; t < i; t++){
                            const i = e1[t];
                            if (null !== i.texture && i.boundingBox.containsPoint(v)) return i;
                        }
                        return null;
                    }(x.state.lightProbeGridArray, a);
                    _.lightProbeGrid !== e1 && (_.lightProbeGrid = e1, S = !0);
                }
                if (E || R !== e1) {
                    se.buffers.depth.getReversed() && !0 !== e1.reversedDepth && (e1._reversedDepth = !0, e1.updateProjectionMatrix()), T.setValue(Me, "projectionMatrix", e1.projectionMatrix), T.setValue(Me, "viewMatrix", e1.matrixWorldInverse);
                    const t = T.map.cameraPosition;
                    void 0 !== t && t.setValue(Me, $.setFromMatrixPosition(e1.matrixWorld)), re.logarithmicDepthBuffer && T.setValue(Me, "logDepthBufFC", 2 / (Math.log(e1.far + 1) / Math.LN2)), (n.isMeshPhongMaterial || n.isMeshToonMaterial || n.isMeshLambertMaterial || n.isMeshBasicMaterial || n.isMeshStandardMaterial || n.isShaderMaterial) && T.setValue(Me, "isOrthographic", !0 === e1.isOrthographicCamera), R !== e1 && (R = e1, S = !0, C = !0);
                }
                _.needsLights && (y.state.directionalShadowMap.length > 0 && T.setValue(Me, "directionalShadowMap", y.state.directionalShadowMap, ce), y.state.spotShadowMap.length > 0 && T.setValue(Me, "spotShadowMap", y.state.spotShadowMap, ce), y.state.pointShadowMap.length > 0 && T.setValue(Me, "pointShadowMap", y.state.pointShadowMap, ce));
                if (a.isSkinnedMesh) {
                    T.setOptional(Me, a, "bindMatrix"), T.setOptional(Me, a, "bindMatrixInverse");
                    const e1 = a.skeleton;
                    e1 && (null === e1.boneTexture && e1.computeBoneTexture(), T.setValue(Me, "boneTexture", e1.boneTexture, ce));
                }
                a.isBatchedMesh && (T.setOptional(Me, a, "batchingTexture"), T.setValue(Me, "batchingTexture", a._matricesTexture, ce), T.setOptional(Me, a, "batchingIdTexture"), T.setValue(Me, "batchingIdTexture", a._indirectTexture, ce), T.setOptional(Me, a, "batchingColorTexture"), null !== a._colorsTexture && T.setValue(Me, "batchingColorTexture", a._colorsTexture, ce));
                const P = i.morphAttributes;
                void 0 === P.position && void 0 === P.normal && void 0 === P.color || xe.update(a, i, w);
                (S || _.receiveShadow !== a.receiveShadow) && (_.receiveShadow = a.receiveShadow, T.setValue(Me, "receiveShadow", a.receiveShadow));
                (n.isMeshStandardMaterial || n.isMeshLambertMaterial || n.isMeshPhongMaterial) && null === n.envMap && null !== t.environment && (D.envMapIntensity.value = t.environmentIntensity);
                void 0 !== D.dfgLUT && (D.dfgLUT.value = (null === $785da19a645c07eb$var$iK && ($785da19a645c07eb$var$iK = new $785da19a645c07eb$var$Qq($785da19a645c07eb$var$tK, 16, 16, $785da19a645c07eb$var$$U, $785da19a645c07eb$var$qU), $785da19a645c07eb$var$iK.name = "DFG_LUT", $785da19a645c07eb$var$iK.minFilter = $785da19a645c07eb$var$FU, $785da19a645c07eb$var$iK.magFilter = $785da19a645c07eb$var$FU, $785da19a645c07eb$var$iK.wrapS = $785da19a645c07eb$var$CU, $785da19a645c07eb$var$iK.wrapT = $785da19a645c07eb$var$CU, $785da19a645c07eb$var$iK.generateMipmaps = !1, $785da19a645c07eb$var$iK.needsUpdate = !0), $785da19a645c07eb$var$iK));
                if (S) {
                    if (T.setValue(Me, "toneMappingExposure", k.toneMappingExposure), _.needsLights && (L1 = C, (I = D).ambientLightColor.needsUpdate = L1, I.lightProbe.needsUpdate = L1, I.directionalLights.needsUpdate = L1, I.directionalLightShadows.needsUpdate = L1, I.pointLights.needsUpdate = L1, I.pointLightShadows.needsUpdate = L1, I.spotLights.needsUpdate = L1, I.spotLightShadows.needsUpdate = L1, I.rectAreaLights.needsUpdate = L1, I.hemisphereLights.needsUpdate = L1), r && !0 === n.fog && ge.refreshFogUniforms(D, r), ge.refreshMaterialUniforms(D, n, q, V, x.state.transmissionRenderTarget[e1.id]), _.needsLights && _.lightProbeGrid) {
                        const e1 = _.lightProbeGrid;
                        D.probesSH.value = e1.texture, D.probesMin.value.copy(e1.boundingBox.min), D.probesMax.value.copy(e1.boundingBox.max), D.probesResolution.value.copy(e1.resolution);
                    }
                    $785da19a645c07eb$var$$W.upload(Me, We(_), D, ce);
                }
                var I, L1;
                n.isShaderMaterial && !0 === n.uniformsNeedUpdate && ($785da19a645c07eb$var$$W.upload(Me, We(_), D, ce), n.uniformsNeedUpdate = !1);
                n.isSpriteMaterial && T.setValue(Me, "center", a.center);
                if (T.setValue(Me, "modelViewMatrix", a.modelViewMatrix), T.setValue(Me, "normalMatrix", a.normalMatrix), T.setValue(Me, "modelMatrix", a.matrixWorld), void 0 !== n.uniformsGroups) {
                    const e1 = n.uniformsGroups;
                    for(let t = 0, i = e1.length; t < i; t++){
                        const i = e1[t];
                        Se.update(i, w), Se.bind(i, w);
                    }
                }
                return w;
            }(e1, t, i, n, a);
            se.setMaterial(n, s);
            let l = i.index, c = 1;
            if (!0 === n.wireframe) {
                if (l = de.getWireframeAttribute(i), void 0 === l) return;
                c = 2;
            }
            const u = i.drawRange, h = i.attributes.position;
            let d = u.start * c, p = (u.start + u.count) * c;
            null !== r && (d = Math.max(d, r.start * c), p = Math.min(p, (r.start + r.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
            const m = p - d;
            if (m < 0 || m === 1 / 0) return;
            let g;
            ke.setup(a, n, o, i, l);
            let f = be;
            if (null !== l && (g = he.get(l), f = we, f.setIndex(g)), a.isMesh) !0 === n.wireframe ? (se.setLineWidth(n.wireframeLinewidth * ne()), f.setMode(Me.LINES)) : f.setMode(Me.TRIANGLES);
            else if (a.isLine) {
                let e1 = n.linewidth;
                void 0 === e1 && (e1 = 1), se.setLineWidth(e1 * ne()), a.isLineSegments ? f.setMode(Me.LINES) : a.isLineLoop ? f.setMode(Me.LINE_LOOP) : f.setMode(Me.LINE_STRIP);
            } else a.isPoints ? f.setMode(Me.POINTS) : a.isSprite && f.setMode(Me.TRIANGLES);
            if (a.isBatchedMesh) {
                if (ae.get("WEBGL_multi_draw")) f.renderMultiDraw(a._multiDrawStarts, a._multiDrawCounts, a._multiDrawCount);
                else {
                    const e1 = a._multiDrawStarts, t = a._multiDrawCounts, i = a._multiDrawCount, r = l ? he.get(l).bytesPerElement : 1, s = le.get(n).currentProgram.getUniforms();
                    for(let n = 0; n < i; n++)s.setValue(Me, "_gl_DrawID", n), f.render(e1[n] / r, t[n]);
                }
            } else if (a.isInstancedMesh) f.renderInstances(d, m, a.count);
            else if (i.isInstancedBufferGeometry) {
                const e1 = void 0 !== i._maxInstanceCount ? i._maxInstanceCount : 1 / 0, t = Math.min(i.instanceCount, e1);
                f.renderInstances(d, m, t);
            } else f.render(d, m);
        }, this.compile = function(e1, t, i = null) {
            null === i && (i = e1), x = Ae.get(i), x.init(t), w.push(x), i.traverseVisible(function(e1) {
                e1.isLight && e1.layers.test(t.layers) && (x.pushLight(e1), e1.castShadow && x.pushShadow(e1));
            }), e1 !== i && e1.traverseVisible(function(e1) {
                e1.isLight && e1.layers.test(t.layers) && (x.pushLight(e1), e1.castShadow && x.pushShadow(e1));
            }), x.setupLights();
            const n = new Set;
            return e1.traverse(function(e1) {
                if (!(e1.isMesh || e1.isPoints || e1.isLine || e1.isSprite)) return;
                const t = e1.material;
                if (t) {
                    if (Array.isArray(t)) for(let a = 0; a < t.length; a++){
                        const r = t[a];
                        Re(r, i, e1), n.add(r);
                    }
                    else Re(t, i, e1), n.add(t);
                }
            }), x = w.pop(), n;
        }, this.compileAsync = function(e1, t, i = null) {
            const n = this.compile(e1, t, i);
            return new Promise((t)=>{
                function i() {
                    n.forEach(function(e1) {
                        le.get(e1).currentProgram.isReady() && n.delete(e1);
                    }), 0 !== n.size ? setTimeout(i, 10) : t(e1);
                }
                null !== ae.get("KHR_parallel_shader_compile") ? i() : setTimeout(i, 10);
            });
        };
        let Le = null;
        function Be() {
            Ue.stop();
        }
        function Oe() {
            Ue.start();
        }
        const Ue = new $785da19a645c07eb$var$hH;
        function Ne(e1, t, i, n) {
            if (!1 === e1.visible) return;
            if (e1.layers.test(t.layers)) {
                if (e1.isGroup) i = e1.renderOrder;
                else if (e1.isLOD) !0 === e1.autoUpdate && e1.update(t);
                else if (e1.isLightProbeGrid) x.pushLightProbeGrid(e1);
                else if (e1.isLight) x.pushLight(e1), e1.castShadow && x.pushShadow(e1);
                else if (e1.isSprite) {
                    if (!e1.frustumCulled || X.intersectsSprite(e1)) {
                        n && ee.setFromMatrixPosition(e1.matrixWorld).applyMatrix4(J);
                        const t = pe.update(e1), a = e1.material;
                        a.visible && y.push(e1, t, a, i, ee.z, null);
                    }
                } else if ((e1.isMesh || e1.isLine || e1.isPoints) && (!e1.frustumCulled || X.intersectsObject(e1))) {
                    const t = pe.update(e1), a = e1.material;
                    if (n && (void 0 !== e1.boundingSphere ? (null === e1.boundingSphere && e1.computeBoundingSphere(), ee.copy(e1.boundingSphere.center)) : (null === t.boundingSphere && t.computeBoundingSphere(), ee.copy(t.boundingSphere.center)), ee.applyMatrix4(e1.matrixWorld).applyMatrix4(J)), Array.isArray(a)) {
                        const n = t.groups;
                        for(let r = 0, s = n.length; r < s; r++){
                            const s = n[r], o = a[s.materialIndex];
                            o && o.visible && y.push(e1, t, o, i, ee.z, s);
                        }
                    } else a.visible && y.push(e1, t, a, i, ee.z, null);
                }
            }
            const a = e1.children;
            for(let e1 = 0, r = a.length; e1 < r; e1++)Ne(a[e1], t, i, n);
        }
        function je(e1, t, i, n) {
            const { opaque: a, transmissive: r, transparent: s } = e1;
            x.setupLightsView(i), !0 === Q && _e.setGlobalState(k.clippingPlanes, i), n && se.viewport(L1.copy(n)), a.length > 0 && qe(a, t, i), r.length > 0 && qe(r, t, i), s.length > 0 && qe(s, t, i), se.buffers.depth.setTest(!0), se.buffers.depth.setMask(!0), se.buffers.color.setMask(!0), se.setPolygonOffset(!1);
        }
        function Ve(e1, t, i, n) {
            if (null !== (!0 === i.isScene ? i.overrideMaterial : null)) return;
            if (void 0 === x.state.transmissionRenderTarget[n.id]) {
                const e1 = ae.has("EXT_color_buffer_half_float") || ae.has("EXT_color_buffer_float");
                x.state.transmissionRenderTarget[n.id] = new $785da19a645c07eb$var$Hj(1, 1, {
                    generateMipmaps: !0,
                    type: e1 ? $785da19a645c07eb$var$qU : $785da19a645c07eb$var$LU,
                    minFilter: $785da19a645c07eb$var$RU,
                    samples: Math.max(4, re.samples),
                    stencilBuffer: a,
                    resolveDepthBuffer: !1,
                    resolveStencilBuffer: !1,
                    colorSpace: $785da19a645c07eb$var$Ij.workingColorSpace
                });
            }
            const r = x.state.transmissionRenderTarget[n.id], s = n.viewport || L1;
            r.setSize(s.z * k.transmissionResolutionScale, s.w * k.transmissionResolutionScale);
            const o = k.getRenderTarget(), l = k.getActiveCubeFace(), c = k.getActiveMipmapLevel();
            k.setRenderTarget(r), k.getClearColor(U), N = k.getClearAlpha(), N < 1 && k.setClearColor(16777215, .5), k.clear(), ie && ye.render(i);
            const u = k.toneMapping;
            k.toneMapping = 0;
            const h = n.viewport;
            if (void 0 !== n.viewport && (n.viewport = void 0), x.setupLightsView(n), !0 === Q && _e.setGlobalState(k.clippingPlanes, n), qe(e1, i, n), ce.updateMultisampleRenderTarget(r), ce.updateRenderTargetMipmap(r), !1 === ae.has("WEBGL_multisampled_render_to_texture")) {
                let e1 = !1;
                for(let a = 0, r = t.length; a < r; a++){
                    const r = t[a], { object: s, geometry: o, material: l, group: c } = r;
                    if (2 === l.side && s.layers.test(n.layers)) {
                        const t = l.side;
                        l.side = 1, l.needsUpdate = !0, Ge(s, i, n, o, l, c), l.side = t, l.needsUpdate = !0, e1 = !0;
                    }
                }
                !0 === e1 && (ce.updateMultisampleRenderTarget(r), ce.updateRenderTargetMipmap(r));
            }
            k.setRenderTarget(o, l, c), k.setClearColor(U, N), void 0 !== h && (n.viewport = h), k.toneMapping = u;
        }
        function qe(e1, t, i) {
            const n = !0 === t.isScene ? t.overrideMaterial : null;
            for(let a = 0, r = e1.length; a < r; a++){
                const r = e1[a], { object: s, geometry: o, group: l } = r;
                let c = r.material;
                !0 === c.allowOverride && null !== n && (c = n), s.layers.test(i.layers) && Ge(s, t, i, o, c, l);
            }
        }
        function Ge(e1, t, i, n, a, r) {
            e1.onBeforeRender(k, t, i, n, a, r), e1.modelViewMatrix.multiplyMatrices(i.matrixWorldInverse, e1.matrixWorld), e1.normalMatrix.getNormalMatrix(e1.modelViewMatrix), a.onBeforeRender(k, t, i, n, e1, r), !0 === a.transparent && 2 === a.side && !1 === a.forceSinglePass ? (a.side = 1, a.needsUpdate = !0, k.renderBufferDirect(i, t, n, a, e1, r), a.side = 0, a.needsUpdate = !0, k.renderBufferDirect(i, t, n, a, e1, r), a.side = 2) : k.renderBufferDirect(i, t, n, a, e1, r), e1.onAfterRender(k, t, i, n, a, r);
        }
        function He(e1, t, i) {
            !0 !== t.isScene && (t = te);
            const n = le.get(e1), a = x.state.lights, r = x.state.shadowsArray, s = a.state.version, o = me.getParameters(e1, a.state, r, t, i, x.state.lightProbeGridArray), l = me.getProgramCacheKey(o);
            let c = n.programs;
            n.environment = e1.isMeshStandardMaterial || e1.isMeshLambertMaterial || e1.isMeshPhongMaterial ? t.environment : null, n.fog = t.fog;
            const u = e1.isMeshStandardMaterial || e1.isMeshLambertMaterial && !e1.envMap || e1.isMeshPhongMaterial && !e1.envMap;
            n.envMap = ue.get(e1.envMap || n.environment, u), n.envMapRotation = null !== n.environment && null === e1.envMap ? t.environmentRotation : e1.envMapRotation, void 0 === c && (e1.addEventListener("dispose", ze), c = new Map, n.programs = c);
            let h = c.get(l);
            if (void 0 !== h) {
                if (n.currentProgram === h && n.lightsStateVersion === s) return Ze(e1, o), h;
            } else o.uniforms = me.getUniforms(e1), null !== M && e1.isNodeMaterial && M.build(e1, i, o), e1.onBeforeCompile(o, k), h = me.acquireProgram(o, l), c.set(l, h), n.uniforms = o.uniforms;
            const d = n.uniforms;
            return (e1.isShaderMaterial || e1.isRawShaderMaterial) && !0 !== e1.clipping || (d.clippingPlanes = _e.uniform), Ze(e1, o), n.needsLights = function(e1) {
                return e1.isMeshLambertMaterial || e1.isMeshToonMaterial || e1.isMeshPhongMaterial || e1.isMeshStandardMaterial || e1.isShadowMaterial || e1.isShaderMaterial && !0 === e1.lights;
            }(e1), n.lightsStateVersion = s, n.needsLights && (d.ambientLightColor.value = a.state.ambient, d.lightProbe.value = a.state.probe, d.directionalLights.value = a.state.directional, d.directionalLightShadows.value = a.state.directionalShadow, d.spotLights.value = a.state.spot, d.spotLightShadows.value = a.state.spotShadow, d.rectAreaLights.value = a.state.rectArea, d.ltc_1.value = a.state.rectAreaLTC1, d.ltc_2.value = a.state.rectAreaLTC2, d.pointLights.value = a.state.point, d.pointLightShadows.value = a.state.pointShadow, d.hemisphereLights.value = a.state.hemi, d.directionalShadowMatrix.value = a.state.directionalShadowMatrix, d.spotLightMatrix.value = a.state.spotLightMatrix, d.spotLightMap.value = a.state.spotLightMap, d.pointShadowMatrix.value = a.state.pointShadowMatrix), n.lightProbeGrid = x.state.lightProbeGridArray.length > 0, n.currentProgram = h, n.uniformsList = null, h;
        }
        function We(e1) {
            if (null === e1.uniformsList) {
                const t = e1.currentProgram.getUniforms();
                e1.uniformsList = $785da19a645c07eb$var$$W.seqWithValue(t.seq, e1.uniforms);
            }
            return e1.uniformsList;
        }
        function Ze(e1, t) {
            const i = le.get(e1);
            i.outputColorSpace = t.outputColorSpace, i.batching = t.batching, i.batchingColor = t.batchingColor, i.instancing = t.instancing, i.instancingColor = t.instancingColor, i.instancingMorph = t.instancingMorph, i.skinning = t.skinning, i.morphTargets = t.morphTargets, i.morphNormals = t.morphNormals, i.morphColors = t.morphColors, i.morphTargetsCount = t.morphTargetsCount, i.numClippingPlanes = t.numClippingPlanes, i.numIntersection = t.numClipIntersection, i.vertexAlphas = t.vertexAlphas, i.vertexTangents = t.vertexTangents, i.toneMapping = t.toneMapping;
        }
        Ue.setAnimationLoop(function(e1) {
            Le && Le(e1);
        }), "undefined" != typeof self && Ue.setContext(self), this.setAnimationLoop = function(e1) {
            Le = e1, De.setAnimationLoop(e1), null === e1 ? Ue.stop() : Ue.start();
        }, De.addEventListener("sessionstart", Be), De.addEventListener("sessionend", Oe), this.render = function(e1, t) {
            if (void 0 !== t && !0 !== t.isCamera) return void $785da19a645c07eb$var$oj("WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            if (!0 === S) return;
            null !== M && M.renderStart(e1, t);
            const i = !0 === De.enabled && !0 === De.isPresenting, n = null !== E && (null === F || i) && E.begin(k, F);
            if (!0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), !0 !== De.enabled || !0 !== De.isPresenting || null !== E && !1 !== E.isCompositing() || (!0 === De.cameraAutoUpdate && De.updateCamera(t), t = De.getCamera()), !0 === e1.isScene && e1.onBeforeRender(k, e1, t, F), x = Ae.get(e1, w.length), x.init(t), x.state.textureUnits = ce.getTextureUnits(), w.push(x), J.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), X.setFromProjectionMatrix(J, $785da19a645c07eb$var$$N, t.reversedDepth), Y = this.localClippingEnabled, Q = _e.init(this.clippingPlanes, Y), y = fe.get(e1, b.length), y.init(), b.push(y), !0 === De.enabled && !0 === De.isPresenting) {
                const e1 = k.xr.getDepthSensingMesh();
                null !== e1 && Ne(e1, t, -1 / 0, k.sortObjects);
            }
            Ne(e1, t, 0, k.sortObjects), y.finish(), !0 === k.sortObjects && y.sort(G, H, t.reversedDepth), ie = !1 === De.enabled || !1 === De.isPresenting || !1 === De.hasDepthSensing(), ie && ye.addToRenderList(y, e1), this.info.render.frame++, !0 === this.info.autoReset && this.info.reset(), !0 === Q && _e.beginShadows();
            const a = x.state.shadowsArray;
            ve.render(a, e1, t), !0 === Q && _e.endShadows();
            if (!1 === (n && E.hasRenderPass())) {
                const i = y.opaque, n = y.transmissive;
                if (x.setupLights(), t.isArrayCamera) {
                    const a = t.cameras;
                    if (n.length > 0) for(let t = 0, r = a.length; t < r; t++)Ve(i, n, e1, a[t]);
                    ie && ye.render(e1);
                    for(let t = 0, i = a.length; t < i; t++){
                        const i = a[t];
                        je(y, e1, i, i.viewport);
                    }
                } else n.length > 0 && Ve(i, n, e1, t), ie && ye.render(e1), je(y, e1, t);
            }
            null !== F && 0 === I && (ce.updateMultisampleRenderTarget(F), ce.updateRenderTargetMipmap(F)), n && E.end(k), !0 === e1.isScene && e1.onAfterRender(k, e1, t), ke.resetDefaultState(), z = -1, R = null, w.pop(), w.length > 0 ? (x = w[w.length - 1], ce.setTextureUnits(x.state.textureUnits), !0 === Q && _e.setGlobalState(k.clippingPlanes, x.state.camera)) : x = null, b.pop(), y = b.length > 0 ? b[b.length - 1] : null, null !== M && M.renderEnd();
        }, this.getActiveCubeFace = function() {
            return P;
        }, this.getActiveMipmapLevel = function() {
            return I;
        }, this.getRenderTarget = function() {
            return F;
        }, this.setRenderTargetTextures = function(e1, t, i) {
            const n = le.get(e1);
            n.__autoAllocateDepthBuffer = !1 === e1.resolveDepthBuffer, !1 === n.__autoAllocateDepthBuffer && (n.__useRenderToTexture = !1), le.get(e1.texture).__webglTexture = t, le.get(e1.depthTexture).__webglTexture = n.__autoAllocateDepthBuffer ? void 0 : i, n.__hasExternalTextures = !0;
        }, this.setRenderTargetFramebuffer = function(e1, t) {
            const i = le.get(e1);
            i.__webglFramebuffer = t, i.__useDefaultFramebuffer = void 0 === t;
        }, this.setRenderTarget = function(e1, t = 0, i = 0) {
            F = e1, P = t, I = i;
            let n = null, a = !1, r = !1;
            if (e1) {
                const s = le.get(e1);
                if (void 0 !== s.__useDefaultFramebuffer) return se.bindFramebuffer(Me.FRAMEBUFFER, s.__webglFramebuffer), L1.copy(e1.viewport), B.copy(e1.scissor), O = e1.scissorTest, se.viewport(L1), se.scissor(B), se.setScissorTest(O), void (z = -1);
                if (void 0 === s.__webglFramebuffer) ce.setupRenderTarget(e1);
                else if (s.__hasExternalTextures) ce.rebindTextures(e1, le.get(e1.texture).__webglTexture, le.get(e1.depthTexture).__webglTexture);
                else if (e1.depthBuffer) {
                    const t = e1.depthTexture;
                    if (s.__boundDepthTexture !== t) {
                        if (null !== t && le.has(t) && (e1.width !== t.image.width || e1.height !== t.image.height)) throw new Error("THREE.WebGLRenderer: Attached DepthTexture is initialized to the incorrect size.");
                        ce.setupDepthRenderbuffer(e1);
                    }
                }
                const o = e1.texture;
                (o.isData3DTexture || o.isDataArrayTexture || o.isCompressedArrayTexture) && (r = !0);
                const l = le.get(e1).__webglFramebuffer;
                e1.isWebGLCubeRenderTarget ? (n = Array.isArray(l[t]) ? l[t][i] : l[t], a = !0) : n = e1.samples > 0 && !1 === ce.useMultisampledRTT(e1) ? le.get(e1).__webglMultisampledFramebuffer : Array.isArray(l) ? l[i] : l, L1.copy(e1.viewport), B.copy(e1.scissor), O = e1.scissorTest;
            } else L1.copy(W).multiplyScalar(q).floor(), B.copy(Z).multiplyScalar(q).floor(), O = K;
            0 !== i && (n = C);
            if (se.bindFramebuffer(Me.FRAMEBUFFER, n) && se.drawBuffers(e1, n), se.viewport(L1), se.scissor(B), se.setScissorTest(O), a) {
                const n = le.get(e1.texture);
                Me.framebufferTexture2D(Me.FRAMEBUFFER, Me.COLOR_ATTACHMENT0, Me.TEXTURE_CUBE_MAP_POSITIVE_X + t, n.__webglTexture, i);
            } else if (r) {
                const n = t;
                for(let t = 0; t < e1.textures.length; t++){
                    const a = le.get(e1.textures[t]);
                    Me.framebufferTextureLayer(Me.FRAMEBUFFER, Me.COLOR_ATTACHMENT0 + t, a.__webglTexture, i, n);
                }
            } else if (null !== e1 && 0 !== i) {
                const t = le.get(e1.texture);
                Me.framebufferTexture2D(Me.FRAMEBUFFER, Me.COLOR_ATTACHMENT0, Me.TEXTURE_2D, t.__webglTexture, i);
            }
            z = -1;
        }, this.readRenderTargetPixels = function(e1, t, i, n, a, r, s, o = 0) {
            if (!e1 || !e1.isWebGLRenderTarget) return void $785da19a645c07eb$var$oj("WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = le.get(e1).__webglFramebuffer;
            if (e1.isWebGLCubeRenderTarget && void 0 !== s && (l = l[s]), l) {
                se.bindFramebuffer(Me.FRAMEBUFFER, l);
                try {
                    const s = e1.textures[o], l = s.format, c = s.type;
                    if (e1.textures.length > 1 && Me.readBuffer(Me.COLOR_ATTACHMENT0 + o), !re.textureFormatReadable(l)) return void $785da19a645c07eb$var$oj("WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    if (!re.textureTypeReadable(c)) return void $785da19a645c07eb$var$oj("WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    t >= 0 && t <= e1.width - n && i >= 0 && i <= e1.height - a && Me.readPixels(t, i, n, a, Ee.convert(l), Ee.convert(c), r);
                } finally{
                    const e1 = null !== F ? le.get(F).__webglFramebuffer : null;
                    se.bindFramebuffer(Me.FRAMEBUFFER, e1);
                }
            }
        }, this.readRenderTargetPixelsAsync = async function(e1, t, i, n, a, r, s, o = 0) {
            if (!e1 || !e1.isWebGLRenderTarget) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            let l = le.get(e1).__webglFramebuffer;
            if (e1.isWebGLCubeRenderTarget && void 0 !== s && (l = l[s]), l) {
                if (t >= 0 && t <= e1.width - n && i >= 0 && i <= e1.height - a) {
                    se.bindFramebuffer(Me.FRAMEBUFFER, l);
                    const s = e1.textures[o], c = s.format, u = s.type;
                    if (e1.textures.length > 1 && Me.readBuffer(Me.COLOR_ATTACHMENT0 + o), !re.textureFormatReadable(c)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                    if (!re.textureTypeReadable(u)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                    const h = Me.createBuffer();
                    Me.bindBuffer(Me.PIXEL_PACK_BUFFER, h), Me.bufferData(Me.PIXEL_PACK_BUFFER, r.byteLength, Me.STREAM_READ), Me.readPixels(t, i, n, a, Ee.convert(c), Ee.convert(u), 0);
                    const d = null !== F ? le.get(F).__webglFramebuffer : null;
                    se.bindFramebuffer(Me.FRAMEBUFFER, d);
                    const p = Me.fenceSync(Me.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    return Me.flush(), await function(e1, t, i) {
                        return new Promise(function(n, a) {
                            setTimeout(function r() {
                                switch(e1.clientWaitSync(t, e1.SYNC_FLUSH_COMMANDS_BIT, 0)){
                                    case e1.WAIT_FAILED:
                                        a();
                                        break;
                                    case e1.TIMEOUT_EXPIRED:
                                        setTimeout(r, i);
                                        break;
                                    default:
                                        n();
                                }
                            }, i);
                        });
                    }(Me, p, 4), Me.bindBuffer(Me.PIXEL_PACK_BUFFER, h), Me.getBufferSubData(Me.PIXEL_PACK_BUFFER, 0, r), Me.deleteBuffer(h), Me.deleteSync(p), r;
                }
                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
            }
        }, this.copyFramebufferToTexture = function(e1, t = null, i = 0) {
            const n = Math.pow(2, -i), a = Math.floor(e1.image.width * n), r = Math.floor(e1.image.height * n), s = null !== t ? t.x : 0, o = null !== t ? t.y : 0;
            ce.setTexture2D(e1, 0), Me.copyTexSubImage2D(Me.TEXTURE_2D, i, 0, 0, s, o, a, r), se.unbindTexture();
        }, this.copyTextureToTexture = function(e1, t, i = null, n = null, a = 0, r = 0) {
            let s, o, l, c, u, h, d, p, m;
            const g = e1.isCompressedTexture ? e1.mipmaps[r] : e1.image;
            if (null !== i) s = i.max.x - i.min.x, o = i.max.y - i.min.y, l = i.isBox3 ? i.max.z - i.min.z : 1, c = i.min.x, u = i.min.y, h = i.isBox3 ? i.min.z : 0;
            else {
                const t = Math.pow(2, -a);
                s = Math.floor(g.width * t), o = Math.floor(g.height * t), l = e1.isDataArrayTexture ? g.depth : e1.isData3DTexture ? Math.floor(g.depth * t) : 1, c = 0, u = 0, h = 0;
            }
            null !== n ? (d = n.x, p = n.y, m = n.z) : (d = 0, p = 0, m = 0);
            const f = Ee.convert(t.format), A = Ee.convert(t.type);
            let _;
            t.isData3DTexture ? (ce.setTexture3D(t, 0), _ = Me.TEXTURE_3D) : t.isDataArrayTexture || t.isCompressedArrayTexture ? (ce.setTexture2DArray(t, 0), _ = Me.TEXTURE_2D_ARRAY) : (ce.setTexture2D(t, 0), _ = Me.TEXTURE_2D), se.activeTexture(Me.TEXTURE0), se.pixelStorei(Me.UNPACK_FLIP_Y_WEBGL, t.flipY), se.pixelStorei(Me.UNPACK_PREMULTIPLY_ALPHA_WEBGL, t.premultiplyAlpha), se.pixelStorei(Me.UNPACK_ALIGNMENT, t.unpackAlignment);
            const v = se.getParameter(Me.UNPACK_ROW_LENGTH), y = se.getParameter(Me.UNPACK_IMAGE_HEIGHT), x = se.getParameter(Me.UNPACK_SKIP_PIXELS), b = se.getParameter(Me.UNPACK_SKIP_ROWS), w = se.getParameter(Me.UNPACK_SKIP_IMAGES);
            se.pixelStorei(Me.UNPACK_ROW_LENGTH, g.width), se.pixelStorei(Me.UNPACK_IMAGE_HEIGHT, g.height), se.pixelStorei(Me.UNPACK_SKIP_PIXELS, c), se.pixelStorei(Me.UNPACK_SKIP_ROWS, u), se.pixelStorei(Me.UNPACK_SKIP_IMAGES, h);
            const E = e1.isDataArrayTexture || e1.isData3DTexture, k = t.isDataArrayTexture || t.isData3DTexture;
            if (e1.isDepthTexture) {
                const i = le.get(e1), n = le.get(t), g = le.get(i.__renderTarget), f = le.get(n.__renderTarget);
                se.bindFramebuffer(Me.READ_FRAMEBUFFER, g.__webglFramebuffer), se.bindFramebuffer(Me.DRAW_FRAMEBUFFER, f.__webglFramebuffer);
                for(let i = 0; i < l; i++)E && (Me.framebufferTextureLayer(Me.READ_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, le.get(e1).__webglTexture, a, h + i), Me.framebufferTextureLayer(Me.DRAW_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, le.get(t).__webglTexture, r, m + i)), Me.blitFramebuffer(c, u, s, o, d, p, s, o, Me.DEPTH_BUFFER_BIT, Me.NEAREST);
                se.bindFramebuffer(Me.READ_FRAMEBUFFER, null), se.bindFramebuffer(Me.DRAW_FRAMEBUFFER, null);
            } else if (0 !== a || e1.isRenderTargetTexture || le.has(e1)) {
                const i = le.get(e1), n = le.get(t);
                se.bindFramebuffer(Me.READ_FRAMEBUFFER, T), se.bindFramebuffer(Me.DRAW_FRAMEBUFFER, D);
                for(let e1 = 0; e1 < l; e1++)E ? Me.framebufferTextureLayer(Me.READ_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, i.__webglTexture, a, h + e1) : Me.framebufferTexture2D(Me.READ_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, Me.TEXTURE_2D, i.__webglTexture, a), k ? Me.framebufferTextureLayer(Me.DRAW_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, n.__webglTexture, r, m + e1) : Me.framebufferTexture2D(Me.DRAW_FRAMEBUFFER, Me.COLOR_ATTACHMENT0, Me.TEXTURE_2D, n.__webglTexture, r), 0 !== a ? Me.blitFramebuffer(c, u, s, o, d, p, s, o, Me.COLOR_BUFFER_BIT, Me.NEAREST) : k ? Me.copyTexSubImage3D(_, r, d, p, m + e1, c, u, s, o) : Me.copyTexSubImage2D(_, r, d, p, c, u, s, o);
                se.bindFramebuffer(Me.READ_FRAMEBUFFER, null), se.bindFramebuffer(Me.DRAW_FRAMEBUFFER, null);
            } else k ? e1.isDataTexture || e1.isData3DTexture ? Me.texSubImage3D(_, r, d, p, m, s, o, l, f, A, g.data) : t.isCompressedArrayTexture ? Me.compressedTexSubImage3D(_, r, d, p, m, s, o, l, f, g.data) : Me.texSubImage3D(_, r, d, p, m, s, o, l, f, A, g) : e1.isDataTexture ? Me.texSubImage2D(Me.TEXTURE_2D, r, d, p, s, o, f, A, g.data) : e1.isCompressedTexture ? Me.compressedTexSubImage2D(Me.TEXTURE_2D, r, d, p, g.width, g.height, f, g.data) : Me.texSubImage2D(Me.TEXTURE_2D, r, d, p, s, o, f, A, g);
            se.pixelStorei(Me.UNPACK_ROW_LENGTH, v), se.pixelStorei(Me.UNPACK_IMAGE_HEIGHT, y), se.pixelStorei(Me.UNPACK_SKIP_PIXELS, x), se.pixelStorei(Me.UNPACK_SKIP_ROWS, b), se.pixelStorei(Me.UNPACK_SKIP_IMAGES, w), 0 === r && t.generateMipmaps && Me.generateMipmap(_), se.unbindTexture();
        }, this.initRenderTarget = function(e1) {
            void 0 === le.get(e1).__webglFramebuffer && ce.setupRenderTarget(e1);
        }, this.initTexture = function(e1) {
            e1.isCubeTexture ? ce.setTextureCube(e1, 0) : e1.isData3DTexture ? ce.setTexture3D(e1, 0) : e1.isDataArrayTexture || e1.isCompressedArrayTexture ? ce.setTexture2DArray(e1, 0) : ce.setTexture2D(e1, 0), se.unbindTexture();
        }, this.resetState = function() {
            P = 0, I = 0, F = null, se.reset(), ke.reset();
        }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    get coordinateSystem() {
        return $785da19a645c07eb$var$$N;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(e1) {
        this._outputColorSpace = e1;
        const t = this.getContext();
        t.drawingBufferColorSpace = $785da19a645c07eb$var$Ij._getDrawingBufferColorSpace(e1), t.unpackColorSpace = $785da19a645c07eb$var$Ij._getUnpackColorSpace();
    }
}
/*!
 * Photo Sphere Viewer 5.15.1
 * @copyright 2014-2015 Jérémy Heleine
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ var $785da19a645c07eb$var$aK = Object.defineProperty, $785da19a645c07eb$var$rK = (e1, t)=>{
    for(var i in t)$785da19a645c07eb$var$aK(e1, i, {
        get: t[i],
        enumerable: !0
    });
}, $785da19a645c07eb$var$sK = {};
$785da19a645c07eb$var$rK($785da19a645c07eb$var$sK, {
    ACTIONS: ()=>$785da19a645c07eb$var$AK,
    ANIMATION_MIN_DURATION: ()=>$785da19a645c07eb$var$lK,
    CAPTURE_EVENTS_CLASS: ()=>$785da19a645c07eb$var$fK,
    CTRLZOOM_TIMEOUT: ()=>$785da19a645c07eb$var$pK,
    DBLCLICK_DELAY: ()=>$785da19a645c07eb$var$uK,
    EASINGS: ()=>$785da19a645c07eb$var$xK,
    ICONS: ()=>$785da19a645c07eb$var$yK,
    IDS: ()=>$785da19a645c07eb$var$_K,
    KEY_CODES: ()=>$785da19a645c07eb$var$vK,
    LONGTOUCH_DELAY: ()=>$785da19a645c07eb$var$hK,
    MOVE_THRESHOLD: ()=>$785da19a645c07eb$var$cK,
    SPHERE_RADIUS: ()=>$785da19a645c07eb$var$mK,
    TWOFINGERSOVERLAY_DELAY: ()=>$785da19a645c07eb$var$dK,
    VIEWER_DATA: ()=>$785da19a645c07eb$var$gK
});
var $785da19a645c07eb$var$oK, $785da19a645c07eb$var$lK = 500, $785da19a645c07eb$var$cK = 4, $785da19a645c07eb$var$uK = 300, $785da19a645c07eb$var$hK = 500, $785da19a645c07eb$var$dK = 100, $785da19a645c07eb$var$pK = 2e3, $785da19a645c07eb$var$mK = 10, $785da19a645c07eb$var$gK = "photoSphereViewer", $785da19a645c07eb$var$fK = "psv--capture-event", $785da19a645c07eb$var$AK = ((e1)=>(e1.ROTATE_UP = "ROTATE_UP", e1.ROTATE_DOWN = "ROTATE_DOWN", e1.ROTATE_RIGHT = "ROTATE_RIGHT", e1.ROTATE_LEFT = "ROTATE_LEFT", e1.ZOOM_IN = "ZOOM_IN", e1.ZOOM_OUT = "ZOOM_OUT", e1))($785da19a645c07eb$var$AK || {}), $785da19a645c07eb$var$_K = {
    MENU: "menu",
    TWO_FINGERS: "twoFingers",
    CTRL_ZOOM: "ctrlZoom",
    ERROR: "error",
    DESCRIPTION: "description"
}, $785da19a645c07eb$var$vK = {
    Enter: "Enter",
    Control: "Control",
    Escape: "Escape",
    Space: " ",
    PageUp: "PageUp",
    PageDown: "PageDown",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowRight: "ArrowRight",
    ArrowDown: "ArrowDown",
    Delete: "Delete",
    Plus: "+",
    Minus: "-"
}, $785da19a645c07eb$var$yK = {
    arrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g>\x3c!-- Created by Flatart from the Noun Project --\x3e</svg>\n',
    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>',
    download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/>\x3c!--Created by Michael Zenaty from the Noun Project--\x3e</svg>\n',
    fullscreenIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
    fullscreenOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
    info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/>\x3c!--Created by Arafat Uddin from the Noun Project--\x3e</svg>\n',
    menu: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g><!-- Created by Richard Kun\xe1k from the Noun Project--></svg>\n',
    zoomIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n',
    zoomOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n'
}, $785da19a645c07eb$var$xK = {
    linear: (e1)=>e1,
    inQuad: (e1)=>e1 * e1,
    outQuad: (e1)=>e1 * (2 - e1),
    inOutQuad: (e1)=>e1 < .5 ? 2 * e1 * e1 : (4 - 2 * e1) * e1 - 1,
    inCubic: (e1)=>e1 * e1 * e1,
    outCubic: (e1)=>--e1 * e1 * e1 + 1,
    inOutCubic: (e1)=>e1 < .5 ? 4 * e1 * e1 * e1 : (e1 - 1) * (2 * e1 - 2) * (2 * e1 - 2) + 1,
    inQuart: (e1)=>e1 * e1 * e1 * e1,
    outQuart: (e1)=>1 - --e1 * e1 * e1 * e1,
    inOutQuart: (e1)=>e1 < .5 ? 8 * e1 * e1 * e1 * e1 : 1 - 8 * --e1 * e1 * e1 * e1,
    inQuint: (e1)=>e1 * e1 * e1 * e1 * e1,
    outQuint: (e1)=>1 + --e1 * e1 * e1 * e1 * e1,
    inOutQuint: (e1)=>e1 < .5 ? 16 * e1 * e1 * e1 * e1 * e1 : 1 + 16 * --e1 * e1 * e1 * e1 * e1,
    inSine: (e1)=>1 - Math.cos(e1 * (Math.PI / 2)),
    outSine: (e1)=>Math.sin(e1 * (Math.PI / 2)),
    inOutSine: (e1)=>.5 - .5 * Math.cos(Math.PI * e1),
    inExpo: (e1)=>Math.pow(2, 10 * (e1 - 1)),
    outExpo: (e1)=>1 - Math.pow(2, -10 * e1),
    inOutExpo: (e1)=>(e1 = 2 * e1 - 1) < 0 ? .5 * Math.pow(2, 10 * e1) : 1 - .5 * Math.pow(2, -10 * e1),
    inCirc: (e1)=>1 - Math.sqrt(1 - e1 * e1),
    outCirc: (e1)=>Math.sqrt(1 - (e1 - 1) * (e1 - 1)),
    inOutCirc: (e1)=>(e1 *= 2) < 1 ? .5 - .5 * Math.sqrt(1 - e1 * e1) : .5 + .5 * Math.sqrt(1 - (e1 -= 2) * e1)
}, $785da19a645c07eb$var$bK = {};
function $785da19a645c07eb$var$wK(e1, t) {
    let i = e1 % t;
    return i < 0 && (i += t), i;
}
function $785da19a645c07eb$var$EK(e1) {
    return e1.reduce((e1, t)=>e1 + t, 0);
}
function $785da19a645c07eb$var$kK(e1, t) {
    return Math.sqrt(Math.pow(e1.x - t.x, 2) + Math.pow(e1.y - t.y, 2));
}
function $785da19a645c07eb$var$SK(e1, t) {
    return Math.atan2(t.y - e1.y, t.x - e1.x);
}
function $785da19a645c07eb$var$MK(e1, t) {
    return [
        0,
        2 * Math.PI,
        2 * -Math.PI
    ].reduce((i, n)=>{
        const a = t - e1 + n;
        return Math.abs(a) < Math.abs(i) ? a : i;
    }, 1 / 0);
}
function $785da19a645c07eb$var$CK(e1, t) {
    return Math.acos(Math.cos(e1.pitch) * Math.cos(t.pitch) * Math.cos(e1.yaw - t.yaw) + Math.sin(e1.pitch) * Math.sin(t.pitch));
}
function $785da19a645c07eb$var$TK([e1, t], [i, n]) {
    e1 - i > Math.PI ? e1 -= 2 * Math.PI : e1 - i < -Math.PI && (e1 += 2 * Math.PI);
    const a = (i - e1) * Math.cos((t + n) / 2), r = n - t;
    return Math.sqrt(a * a + r * r);
}
function $785da19a645c07eb$var$DK(e1) {
    return "string" == typeof e1 ? e1.match(/^[a-z]/i) ? document.getElementById(e1) : document.querySelector(e1) : e1;
}
function $785da19a645c07eb$var$PK(e1, t, i) {
    void 0 === i ? e1.classList.toggle(t) : i ? e1.classList.add(t) : i || e1.classList.remove(t);
}
function $785da19a645c07eb$var$IK(e1, t) {
    e1.classList.add(...t.split(" ").filter((e1)=>!!e1));
}
function $785da19a645c07eb$var$FK(e1, t) {
    e1.classList.remove(...t.split(" ").filter((e1)=>!!e1));
}
function $785da19a645c07eb$var$zK(e1, t) {
    let i = e1;
    do {
        if (i === t) return !0;
        i = i.parentElement;
    }while (i);
    return !1;
}
function $785da19a645c07eb$var$RK(e1, t) {
    if (!e1?.matches) return null;
    let i = e1;
    do {
        if (i.matches(t)) return i;
        i = i.parentElement;
    }while (i);
    return null;
}
function $785da19a645c07eb$var$LK(e1) {
    return e1?.composedPath()[0] || null;
}
function $785da19a645c07eb$var$BK(e1, t) {
    return e1 ? e1.composedPath().find((e1)=>(e1 instanceof HTMLElement || e1 instanceof SVGElement) && e1.matches(t)) : null;
}
function $785da19a645c07eb$var$OK(e1) {
    let t = 0, i = 0, n = e1;
    for(; n;)t += n.offsetLeft - n.scrollLeft + n.clientLeft, i += n.offsetTop - n.scrollTop + n.clientTop, n = n.offsetParent;
    return t -= window.scrollX, i -= window.scrollY, {
        x: t,
        y: i
    };
}
function $785da19a645c07eb$var$UK(e1, t) {
    return window.getComputedStyle(e1).getPropertyValue(t);
}
function $785da19a645c07eb$var$NK(e1) {
    if (e1.touches.length < 2) return null;
    const t = {
        x: e1.touches[0].clientX,
        y: e1.touches[0].clientY
    }, i = {
        x: e1.touches[1].clientX,
        y: e1.touches[1].clientY
    };
    return {
        distance: $785da19a645c07eb$var$kK(t, i),
        angle: $785da19a645c07eb$var$SK(t, i),
        center: {
            x: (t.x + i.x) / 2,
            y: (t.y + i.y) / 2
        }
    };
}
function $785da19a645c07eb$var$jK(e1, t = !1) {
    return t ? e1 === $785da19a645c07eb$var$oK : document.fullscreenElement === e1;
}
function $785da19a645c07eb$var$VK(e1, t = !1) {
    t ? ($785da19a645c07eb$var$oK = e1, e1.classList.add("psv-fullscreen-emulation"), document.dispatchEvent(new Event("fullscreenchange"))) : e1.requestFullscreen();
}
function $785da19a645c07eb$var$qK(e1 = !1) {
    e1 ? ($785da19a645c07eb$var$oK.classList.remove("psv-fullscreen-emulation"), $785da19a645c07eb$var$oK = null, document.dispatchEvent(new Event("fullscreenchange"))) : document.exitFullscreen();
}
function $785da19a645c07eb$var$GK(e1, t) {
    let i, n = !1, a = !1, r = !1, s = !1;
    return "+" === t ? i = t : t.split("+").forEach((e1)=>{
        switch(e1){
            case "Shift":
                n = !0;
                break;
            case "Ctrl":
                a = !0;
                break;
            case "Alt":
                r = !0;
                break;
            case "Meta":
                s = !0;
                break;
            case "Space":
                i = " ";
                break;
            case "Plus":
                i = "+";
                break;
            case "Minus":
                i = "-";
                break;
            default:
                i = e1;
        }
    }), n === e1.shiftKey && a === e1.ctrlKey && r === e1.altKey && s === e1.metaKey && i === e1.key;
}
function $785da19a645c07eb$var$HK(e1) {
    return e1.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, (e1, t)=>(t > 0 ? "-" : "") + e1.toLowerCase());
}
function $785da19a645c07eb$var$WK(e1, t) {
    let i = !1;
    return function(...n) {
        i || (i = !0, setTimeout(()=>{
            e1.apply(this, n), i = !1;
        }, t));
    };
}
function $785da19a645c07eb$var$ZK(e1) {
    if ("object" != typeof e1 || null === e1 || "[object Object]" !== Object.prototype.toString.call(e1)) return !1;
    if (null === Object.getPrototypeOf(e1)) return !0;
    let t = e1;
    for(; null !== Object.getPrototypeOf(t);)t = Object.getPrototypeOf(t);
    return Object.getPrototypeOf(e1) === t;
}
function $785da19a645c07eb$var$KK(e1, t) {
    const i = t;
    return function e1(t, n) {
        return Array.isArray(n) ? (t && Array.isArray(t) ? t.length = 0 : t = [], n.forEach((i, n)=>{
            t[n] = e1(null, i);
        })) : "object" == typeof n ? (t && !Array.isArray(t) || (t = {}), Object.keys(n).forEach((a)=>{
            "__proto__" !== a && ("object" == typeof n[a] && n[a] && $785da19a645c07eb$var$ZK(n[a]) ? n[a] !== i && (t[a] ? e1(t[a], n[a]) : t[a] = e1(null, n[a])) : t[a] = n[a]);
        })) : t = n, t;
    }(e1, t);
}
function $785da19a645c07eb$var$XK(e1) {
    return $785da19a645c07eb$var$KK(null, e1);
}
function $785da19a645c07eb$var$QK(e1) {
    return !e1 || 0 === Object.keys(e1).length && e1.constructor === Object;
}
function $785da19a645c07eb$var$YK(e1) {
    return null == e1;
}
function $785da19a645c07eb$var$JK(...e1) {
    for (const t of e1)if (!$785da19a645c07eb$var$YK(t)) return t;
    return null;
}
function $785da19a645c07eb$var$$K(e1, t) {
    if (e1 === t) return !0;
    if ($785da19a645c07eb$var$eX(e1) && $785da19a645c07eb$var$eX(t)) {
        if (Object.keys(e1).length !== Object.keys(t).length) return !1;
        for (const i of Object.keys(e1))if (!$785da19a645c07eb$var$$K(e1[i], t[i])) return !1;
        return !0;
    }
    return !1;
}
function $785da19a645c07eb$var$eX(e1) {
    return "object" == typeof e1 && null !== e1;
}
$785da19a645c07eb$var$rK($785da19a645c07eb$var$bK, {
    Animation: ()=>$785da19a645c07eb$var$PX,
    Dynamic: ()=>$785da19a645c07eb$var$IX,
    MultiDynamic: ()=>$785da19a645c07eb$var$FX,
    PressHandler: ()=>$785da19a645c07eb$var$zX,
    Slider: ()=>$785da19a645c07eb$var$LX,
    SliderDirection: ()=>$785da19a645c07eb$var$RX,
    addClasses: ()=>$785da19a645c07eb$var$IK,
    angle: ()=>$785da19a645c07eb$var$SK,
    applyEulerInverse: ()=>$785da19a645c07eb$var$DX,
    checkClosedShadowDom: ()=>$785da19a645c07eb$var$wX,
    checkStylesheet: ()=>$785da19a645c07eb$var$xX,
    checkVersion: ()=>$785da19a645c07eb$var$bX,
    cleanCssPosition: ()=>$785da19a645c07eb$var$gX,
    clone: ()=>$785da19a645c07eb$var$XK,
    createSizedTexture: ()=>$785da19a645c07eb$var$CX,
    createTexture: ()=>$785da19a645c07eb$var$MX,
    cssPositionIsOrdered: ()=>$785da19a645c07eb$var$fX,
    dasherize: ()=>$785da19a645c07eb$var$HK,
    deepEqual: ()=>$785da19a645c07eb$var$$K,
    deepmerge: ()=>$785da19a645c07eb$var$KK,
    distance: ()=>$785da19a645c07eb$var$kK,
    exitFullscreen: ()=>$785da19a645c07eb$var$qK,
    firstNonNull: ()=>$785da19a645c07eb$var$JK,
    getAbortError: ()=>$785da19a645c07eb$var$aX,
    getAngle: ()=>$785da19a645c07eb$var$CK,
    getClosest: ()=>$785da19a645c07eb$var$RK,
    getConfigParser: ()=>$785da19a645c07eb$var$yX,
    getElement: ()=>$785da19a645c07eb$var$DK,
    getEventTarget: ()=>$785da19a645c07eb$var$LK,
    getMatchingTarget: ()=>$785da19a645c07eb$var$BK,
    getPosition: ()=>$785da19a645c07eb$var$OK,
    getShortestArc: ()=>$785da19a645c07eb$var$MK,
    getStyleProperty: ()=>$785da19a645c07eb$var$UK,
    getTouchData: ()=>$785da19a645c07eb$var$NK,
    getXMPValue: ()=>$785da19a645c07eb$var$lX,
    greatArcDistance: ()=>$785da19a645c07eb$var$TK,
    hasParent: ()=>$785da19a645c07eb$var$zK,
    invertResolvableBoolean: ()=>$785da19a645c07eb$var$nX,
    isAbortError: ()=>$785da19a645c07eb$var$rX,
    isEmpty: ()=>$785da19a645c07eb$var$QK,
    isExtendedPosition: ()=>$785da19a645c07eb$var$oX,
    isFullscreenEnabled: ()=>$785da19a645c07eb$var$jK,
    isNil: ()=>$785da19a645c07eb$var$YK,
    isPlainObject: ()=>$785da19a645c07eb$var$ZK,
    keyPressMatch: ()=>$785da19a645c07eb$var$GK,
    logWarn: ()=>$785da19a645c07eb$var$sX,
    mergePanoData: ()=>$785da19a645c07eb$var$EX,
    parseAngle: ()=>$785da19a645c07eb$var$vX,
    parsePoint: ()=>$785da19a645c07eb$var$mX,
    parseSpeed: ()=>$785da19a645c07eb$var$AX,
    removeClasses: ()=>$785da19a645c07eb$var$FK,
    requestFullscreen: ()=>$785da19a645c07eb$var$VK,
    resolveBoolean: ()=>$785da19a645c07eb$var$iX,
    speedToDuration: ()=>$785da19a645c07eb$var$_X,
    sum: ()=>$785da19a645c07eb$var$EK,
    throttle: ()=>$785da19a645c07eb$var$WK,
    toggleClass: ()=>$785da19a645c07eb$var$PK,
    wrap: ()=>$785da19a645c07eb$var$wK
});
var $785da19a645c07eb$var$tX = class e1 extends Error {
    constructor(t, i){
        super(i && i instanceof Error ? `${t}: ${i.message}` : t), this.name = "PSVError", Error.captureStackTrace?.(this, e1);
    }
};
function $785da19a645c07eb$var$iX(e1, t) {
    $785da19a645c07eb$var$ZK(e1) ? (t(e1.initial, !0), e1.promise.then((e1)=>t(e1, !1))) : t(e1, !0);
}
function $785da19a645c07eb$var$nX(e1) {
    return {
        initial: !e1.initial,
        promise: e1.promise.then((e1)=>!e1)
    };
}
function $785da19a645c07eb$var$aX() {
    const e1 = new Error("Loading was aborted.");
    return e1.name = "AbortError", e1;
}
function $785da19a645c07eb$var$rX(e1) {
    return "AbortError" === e1?.name;
}
function $785da19a645c07eb$var$sX(e1) {
    console.warn(`PhotoSphereViewer: ${e1}`);
}
function $785da19a645c07eb$var$oX(e1) {
    return !(!e1 || Array.isArray(e1)) && [
        [
            "textureX",
            "textureY"
        ],
        [
            "yaw",
            "pitch"
        ]
    ].some(([t, i])=>void 0 !== e1[t] && void 0 !== e1[i]);
}
function $785da19a645c07eb$var$lX(e1, t, i = !0) {
    let n = e1.match("<GPano:" + t + ">(.*)</GPano:" + t + ">");
    if (null !== n) {
        const e1 = i ? parseInt(n[1], 10) : parseFloat(n[1]);
        return isNaN(e1) ? null : e1;
    }
    if (n = e1.match("GPano:" + t + '="(.*?)"'), null !== n) {
        const e1 = i ? parseInt(n[1], 10) : parseFloat(n[1]);
        return isNaN(e1) ? null : e1;
    }
    return null;
}
var $785da19a645c07eb$var$cX = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $785da19a645c07eb$var$uX = [
    "left",
    "center",
    "right"
], $785da19a645c07eb$var$hX = [
    "top",
    "center",
    "bottom"
], $785da19a645c07eb$var$dX = [
    ...$785da19a645c07eb$var$uX,
    ...$785da19a645c07eb$var$hX
], $785da19a645c07eb$var$pX = "center";
function $785da19a645c07eb$var$mX(e1) {
    if (!e1) return {
        x: .5,
        y: .5
    };
    if ("object" == typeof e1) return e1;
    let t = e1.toLocaleLowerCase().split(" ").slice(0, 2);
    1 === t.length && (t = $785da19a645c07eb$var$cX[t[0]] ? [
        t[0],
        $785da19a645c07eb$var$pX
    ] : [
        t[0],
        t[0]
    ]);
    const i = "left" !== t[1] && "right" !== t[1] && "top" !== t[0] && "bottom" !== t[0];
    t = t.map((e1)=>$785da19a645c07eb$var$cX[e1] || e1), i || t.reverse();
    const n = t.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
    return n ? {
        x: parseFloat(n[1]) / 100,
        y: parseFloat(n[2]) / 100
    } : {
        x: .5,
        y: .5
    };
}
function $785da19a645c07eb$var$gX(e1, { allowCenter: t, cssOrder: i } = {
    allowCenter: !0,
    cssOrder: !0
}) {
    return e1 ? ("string" == typeof e1 && (e1 = e1.split(" ")), 1 === e1.length && (e1[0] === $785da19a645c07eb$var$pX ? e1 = [
        $785da19a645c07eb$var$pX,
        $785da19a645c07eb$var$pX
    ] : -1 !== $785da19a645c07eb$var$uX.indexOf(e1[0]) ? e1 = [
        $785da19a645c07eb$var$pX,
        e1[0]
    ] : -1 !== $785da19a645c07eb$var$hX.indexOf(e1[0]) && (e1 = [
        e1[0],
        $785da19a645c07eb$var$pX
    ])), 2 !== e1.length || -1 === $785da19a645c07eb$var$dX.indexOf(e1[0]) || -1 === $785da19a645c07eb$var$dX.indexOf(e1[1]) ? ($785da19a645c07eb$var$sX(`Unparsable position ${e1}`), null) : t || e1[0] !== $785da19a645c07eb$var$pX || e1[1] !== $785da19a645c07eb$var$pX ? (i && !$785da19a645c07eb$var$fX(e1) && (e1 = [
        e1[1],
        e1[0]
    ]), e1[1] === $785da19a645c07eb$var$pX && -1 !== $785da19a645c07eb$var$uX.indexOf(e1[0]) && (e1 = [
        $785da19a645c07eb$var$pX,
        e1[0]
    ]), e1[0] === $785da19a645c07eb$var$pX && -1 !== $785da19a645c07eb$var$hX.indexOf(e1[1]) && (e1 = [
        e1[1],
        $785da19a645c07eb$var$pX
    ]), e1) : ($785da19a645c07eb$var$sX("Invalid position center center"), null)) : null;
}
function $785da19a645c07eb$var$fX(e1) {
    return -1 !== $785da19a645c07eb$var$hX.indexOf(e1[0]) && -1 !== $785da19a645c07eb$var$uX.indexOf(e1[1]);
}
function $785da19a645c07eb$var$AX(e1) {
    let t;
    if ("string" == typeof e1) {
        const i = e1.toString().trim();
        let n = parseFloat(i.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
        const a = i.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
        switch(a.match(/(pm|per minute)$/) && (n /= 60), a){
            case "dpm":
            case "degrees per minute":
            case "dps":
            case "degrees per second":
                t = $785da19a645c07eb$var$xj.degToRad(n);
                break;
            case "rdpm":
            case "radians per minute":
            case "rdps":
            case "radians per second":
                t = n;
                break;
            case "rpm":
            case "revolutions per minute":
            case "rps":
            case "revolutions per second":
                t = n * Math.PI * 2;
                break;
            default:
                throw new $785da19a645c07eb$var$tX(`Unknown speed unit "${a}"`);
        }
    } else t = e1;
    return t;
}
function $785da19a645c07eb$var$_X(e1, t) {
    if ("number" != typeof e1) {
        const i = $785da19a645c07eb$var$AX(e1);
        return t / Math.abs(i) * 1e3;
    }
    return Math.abs(e1);
}
function $785da19a645c07eb$var$vX(e1, t = !1, i = t) {
    let n;
    if ("string" == typeof e1) {
        const t = e1.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
        if (!t) throw new $785da19a645c07eb$var$tX(`Unknown angle "${e1}"`);
        const i = parseFloat(t[1]), a = t[2];
        if (a) switch(a){
            case "deg":
            case "degs":
                n = $785da19a645c07eb$var$xj.degToRad(i);
                break;
            case "rad":
            case "rads":
                n = i;
                break;
            default:
                throw new $785da19a645c07eb$var$tX(`Unknown angle unit "${a}"`);
        }
        else n = i;
    } else {
        if ("number" != typeof e1 || isNaN(e1)) throw new $785da19a645c07eb$var$tX(`Unknown angle "${e1}"`);
        n = e1;
    }
    return n = $785da19a645c07eb$var$wK(t ? n + Math.PI : n, 2 * Math.PI), t ? $785da19a645c07eb$var$xj.clamp(n - Math.PI, -Math.PI / (i ? 2 : 1), Math.PI / (i ? 2 : 1)) : n;
}
function $785da19a645c07eb$var$yX(e1, t) {
    const i = function(i) {
        const n = $785da19a645c07eb$var$XK({
            ...e1,
            ...i
        }), a = {};
        for (let [i, r] of Object.entries(n)){
            if (t && i in t) r = t[i](r, {
                rawConfig: n,
                defValue: e1[i]
            });
            else if (!(i in e1)) {
                $785da19a645c07eb$var$sX(`Unknown option ${i}`);
                continue;
            }
            a[i] = r;
        }
        return a;
    };
    return i.defaults = e1, i.parsers = t || {}, i;
}
function $785da19a645c07eb$var$xX(e1, t) {
    "true" !== $785da19a645c07eb$var$UK(e1, `--psv-${t}-loaded`) && console.error(`PhotoSphereViewer: stylesheet "@photo-sphere-viewer/${t}/index.css" is not loaded`);
}
function $785da19a645c07eb$var$bX(e1, t, i) {
    t && t !== i && console.error(`PhotoSphereViewer: @photo-sphere-viewer/${e1} is in version ${t} but @photo-sphere-viewer/core is in version ${i}`);
}
function $785da19a645c07eb$var$wX(e1) {
    do {
        if (e1 instanceof ShadowRoot && "closed" === e1.mode) return void console.error("PhotoSphereViewer: closed shadow DOM detected, the viewer might not work as expected");
        e1 = e1.parentNode;
    }while (e1);
}
function $785da19a645c07eb$var$EX(e1, t, i, n) {
    const a = {
        isEquirectangular: !0,
        fullWidth: $785da19a645c07eb$var$JK(i?.fullWidth, n?.fullWidth),
        fullHeight: $785da19a645c07eb$var$JK(i?.fullHeight, n?.fullHeight),
        croppedWidth: $785da19a645c07eb$var$JK(i?.croppedWidth, n?.croppedWidth, e1),
        croppedHeight: $785da19a645c07eb$var$JK(i?.croppedHeight, n?.croppedHeight, t),
        croppedX: $785da19a645c07eb$var$JK(i?.croppedX, n?.croppedX),
        croppedY: $785da19a645c07eb$var$JK(i?.croppedY, n?.croppedY),
        poseHeading: $785da19a645c07eb$var$JK(i?.poseHeading, n?.poseHeading, 0),
        posePitch: $785da19a645c07eb$var$JK(i?.posePitch, n?.posePitch, 0),
        poseRoll: $785da19a645c07eb$var$JK(i?.poseRoll, n?.poseRoll, 0),
        initialHeading: n?.initialHeading,
        initialPitch: n?.initialPitch,
        initialFov: n?.initialFov
    };
    if (a.croppedWidth !== e1) {
        const t = e1 / a.croppedWidth;
        [
            "fullWidth",
            "fullHeight",
            "croppedWidth",
            "croppedHeight",
            "croppedX",
            "croppedY"
        ].forEach((e1)=>{
            a[e1] && (a[e1] = Math.round(a[e1] * t));
        });
    }
    return a.fullWidth || a.fullHeight || (a.fullWidth = Math.max(a.croppedWidth, 2 * a.croppedHeight), a.fullHeight = Math.round(a.fullWidth / 2)), a.fullWidth || (a.fullWidth = 2 * a.fullHeight), a.fullHeight || (a.fullHeight = Math.round(a.fullWidth / 2)), null === a.croppedX && (a.croppedX = Math.round((a.fullWidth - e1) / 2)), null === a.croppedY && (a.croppedY = Math.round((a.fullHeight - t) / 2)), Math.abs(a.fullWidth - 2 * a.fullHeight) > 1 && ($785da19a645c07eb$var$sX("Invalid panoData, fullWidth should be twice fullHeight"), a.fullHeight = Math.round(a.fullWidth / 2)), a.croppedX + a.croppedWidth > a.fullWidth && ($785da19a645c07eb$var$sX("Invalid panoData, croppedX + croppedWidth > fullWidth"), a.croppedX = a.fullWidth - a.croppedWidth), a.croppedY + a.croppedHeight > a.fullHeight && ($785da19a645c07eb$var$sX("Invalid panoData, croppedY + croppedHeight > fullHeight"), a.croppedY = a.fullHeight - a.croppedHeight), a.croppedX < 0 && ($785da19a645c07eb$var$sX("Invalid panoData, croppedX < 0"), a.croppedX = 0), a.croppedY < 0 && ($785da19a645c07eb$var$sX("Invalid panoData, croppedY < 0"), a.croppedY = 0), a;
}
var $785da19a645c07eb$var$kX = `${$785da19a645c07eb$var$gK}_touchSupport`, $785da19a645c07eb$var$SX = {
    loaded: !1,
    pixelRatio: 1,
    isWebGLSupported: !1,
    maxTextureWidth: 0,
    isTouchEnabled: null,
    __maxCanvasWidth: null,
    isIphone: !1,
    get maxCanvasWidth () {
        return null === this.__maxCanvasWidth && (this.__maxCanvasWidth = function(e1) {
            let t = e1, i = !1;
            const n = document.createElement("canvas"), a = n.getContext("2d");
            n.width = 1, n.height = 1;
            for(; t > 1024 && !i;){
                const e1 = document.createElement("canvas"), n = e1.getContext("2d");
                e1.width = t, e1.height = t / 2;
                try {
                    n.fillStyle = "white", n.fillRect(t - 1, t / 2 - 1, 1, 1), a.drawImage(e1, t - 1, t / 2 - 1, 1, 1, 0, 0, 1, 1), a.getImageData(0, 0, 1, 1).data[0] > 0 && (i = !0);
                } catch  {}
                e1.width = 0, e1.height = 0, i || (t /= 2);
            }
            if (i) return t;
            throw new $785da19a645c07eb$var$tX("Unable to detect system capabilities");
        }(this.maxTextureWidth)), this.__maxCanvasWidth;
    },
    load () {
        if (!this.loaded) {
            const e1 = function() {
                try {
                    return document.createElement("canvas").getContext("webgl2");
                } catch  {
                    return null;
                }
            }();
            this.pixelRatio = window.devicePixelRatio || 1, this.isWebGLSupported = !!e1, this.maxTextureWidth = e1 ? e1.getParameter(e1.MAX_TEXTURE_SIZE) : 0, this.isTouchEnabled = function() {
                let e1 = "ontouchstart" in window || navigator.maxTouchPoints > 0;
                $785da19a645c07eb$var$kX in localStorage && (e1 = "true" === localStorage[$785da19a645c07eb$var$kX]);
                const t = new Promise((t)=>{
                    const i = ()=>{
                        window.removeEventListener("mousedown", n), window.removeEventListener("touchstart", a), clearTimeout(s);
                    }, n = ()=>{
                        i(), localStorage[$785da19a645c07eb$var$kX] = !1, t(!1);
                    }, a = ()=>{
                        i(), localStorage[$785da19a645c07eb$var$kX] = !0, t(!0);
                    }, r = ()=>{
                        i(), localStorage[$785da19a645c07eb$var$kX] = e1, t(e1);
                    };
                    window.addEventListener("mousedown", n, !1), window.addEventListener("touchstart", a, !1);
                    const s = setTimeout(r, 1e4);
                });
                return {
                    initial: e1,
                    promise: t
                };
            }(), this.isIphone = /iPhone/i.test(navigator.userAgent), this.loaded = !0;
        }
        if (!$785da19a645c07eb$var$SX.isWebGLSupported) throw new $785da19a645c07eb$var$tX("WebGL 2 is not supported.");
        if (0 === $785da19a645c07eb$var$SX.maxTextureWidth) throw new $785da19a645c07eb$var$tX("Unable to detect system capabilities");
    }
};
function $785da19a645c07eb$var$MX(e1, t = !1) {
    const i = new $785da19a645c07eb$var$Vj(e1);
    return i.needsUpdate = !0, i.minFilter = t ? $785da19a645c07eb$var$RU : $785da19a645c07eb$var$FU, i.generateMipmaps = t, i.anisotropy = t ? 2 : 1, i;
}
function $785da19a645c07eb$var$CX(e1, t) {
    if (t || e1.width > $785da19a645c07eb$var$SX.maxTextureWidth) {
        const i = Math.min(1, $785da19a645c07eb$var$SX.maxCanvasWidth / e1.width), n = new OffscreenCanvas(Math.floor(e1.width * i), Math.floor(e1.height * i)), a = n.getContext("2d");
        return t && (a.filter = `blur(${n.width / t.factor}px)`), a.drawImage(e1, 0, 0, n.width, n.height), $785da19a645c07eb$var$MX(n);
    }
    return $785da19a645c07eb$var$MX(e1);
}
var $785da19a645c07eb$var$TX = new $785da19a645c07eb$var$wj;
function $785da19a645c07eb$var$DX(e1, t) {
    $785da19a645c07eb$var$TX.setFromEuler(t).invert(), e1.applyQuaternion($785da19a645c07eb$var$TX);
}
var $785da19a645c07eb$var$PX = class {
    constructor(e1){
        this.easing = $785da19a645c07eb$var$xK.linear, this.callbacks = [], this.resolved = !1, this.cancelled = !1, this.options = e1, e1 ? (e1.easing && (this.easing = "function" == typeof e1.easing ? e1.easing : $785da19a645c07eb$var$xK[e1.easing] || $785da19a645c07eb$var$xK.linear), this.delayTimeout = setTimeout(()=>{
            this.delayTimeout = void 0, this.animationFrame = window.requestAnimationFrame((e1)=>this.__run(e1));
        }, e1.delay || 0)) : this.resolved = !0;
    }
    __run(e1) {
        if (this.cancelled) return;
        this.start || (this.start = e1);
        const t = (e1 - this.start) / this.options.duration, i = {};
        if (t < 1) {
            for (const [e1, n] of Object.entries(this.options.properties))if (n) {
                const a = n.start + (n.end - n.start) * this.easing(t);
                i[e1] = a;
            }
            this.options.onTick(i, t), this.animationFrame = window.requestAnimationFrame((e1)=>this.__run(e1));
        } else {
            for (const [e1, t] of Object.entries(this.options.properties))t && (i[e1] = t.end);
            this.options.onTick(i, 1), this.__resolve(!0), this.animationFrame = void 0;
        }
    }
    __resolve(e1) {
        e1 ? this.resolved = !0 : this.cancelled = !0, this.callbacks.forEach((t)=>t(e1)), this.callbacks.length = 0;
    }
    then(e1) {
        return this.resolved || this.cancelled ? Promise.resolve(this.resolved).then(e1) : new Promise((e1)=>{
            this.callbacks.push(e1);
        }).then(e1);
    }
    cancel() {
        this.cancelled || this.resolved || (this.__resolve(!1), this.delayTimeout && (window.clearTimeout(this.delayTimeout), this.delayTimeout = void 0), this.animationFrame && (window.cancelAnimationFrame(this.animationFrame), this.animationFrame = void 0));
    }
}, $785da19a645c07eb$var$IX = class {
    constructor(e1, t){
        if (this.fn = e1, this.mode = 0, this.speed = 0, this.speedMult = 0, this.currentSpeed = 0, this.target = 0, this.__current = 0, this.min = t.min, this.max = t.max, this.wrap = t.wrap, this.current = t.defaultValue, this.wrap && 0 !== this.min) throw new $785da19a645c07eb$var$tX("invalid config");
        this.fn && this.fn(this.current);
    }
    get current() {
        return this.__current;
    }
    set current(e1) {
        this.__current = e1;
    }
    setSpeed(e1) {
        this.speed = e1;
    }
    goto(e1, t = 1) {
        this.mode = 2, this.target = this.wrap ? $785da19a645c07eb$var$wK(e1, this.max) : $785da19a645c07eb$var$xj.clamp(e1, this.min, this.max), this.speedMult = t;
    }
    step(e1, t = 1) {
        0 === t ? this.setValue(this.current + e1) : (2 !== this.mode && (this.target = this.current), this.goto(this.target + e1, t));
    }
    roll(e1 = !1, t = 1) {
        this.mode = 1, this.target = e1 ? -1 / 0 : 1 / 0, this.speedMult = t;
    }
    stop() {
        this.mode = 0;
    }
    setValue(e1) {
        return this.target = this.wrap ? $785da19a645c07eb$var$wK(e1, this.max) : $785da19a645c07eb$var$xj.clamp(e1, this.min, this.max), this.mode = 0, this.currentSpeed = 0, this.target !== this.current && (this.current = this.target, this.fn && this.fn(this.current), !0);
    }
    update(e1) {
        if (2 === this.mode) {
            this.wrap && Math.abs(this.target - this.current) > this.max / 2 && (this.current = this.current < this.target ? this.current + this.max : this.current - this.max);
            const e1 = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
            Math.abs(this.target - this.current) <= e1 && (this.mode = 0);
        }
        let t = 0 === this.mode ? 0 : this.speed * this.speedMult;
        this.target < this.current && (t = -t), this.currentSpeed < t ? this.currentSpeed = Math.min(t, this.currentSpeed + e1 / 1e3 * this.speed * this.speedMult * 2) : this.currentSpeed > t && (this.currentSpeed = Math.max(t, this.currentSpeed - e1 / 1e3 * this.speed * this.speedMult * 2));
        let i = null;
        return this.current > this.target && this.currentSpeed ? i = Math.max(this.target, this.current + this.currentSpeed * e1 / 1e3) : this.current < this.target && this.currentSpeed && (i = Math.min(this.target, this.current + this.currentSpeed * e1 / 1e3)), null !== i && (i = this.wrap ? $785da19a645c07eb$var$wK(i, this.max) : $785da19a645c07eb$var$xj.clamp(i, this.min, this.max), i !== this.current) && (this.current = i, this.fn && this.fn(this.current), !0);
    }
}, $785da19a645c07eb$var$FX = class {
    constructor(e1, t){
        this.fn = e1, this.dynamics = t, this.fn && this.fn(this.current);
    }
    get current() {
        return Object.entries(this.dynamics).reduce((e1, [t, i])=>(e1[t] = i.current, e1), {});
    }
    setSpeed(e1) {
        for (const t of Object.values(this.dynamics))t.setSpeed(e1);
    }
    goto(e1, t = 1) {
        for (const [i, n] of Object.entries(e1))this.dynamics[i].goto(n, t);
    }
    step(e1, t = 1) {
        if (0 === t) this.setValue(Object.keys(e1).reduce((t, i)=>(t[i] = e1[i] + this.dynamics[i].current, t), {}));
        else for (const [i, n] of Object.entries(e1))this.dynamics[i].step(n, t);
    }
    roll(e1, t = 1) {
        for (const [i, n] of Object.entries(e1))this.dynamics[i].roll(n, t);
    }
    stop() {
        for (const e1 of Object.values(this.dynamics))e1.stop();
    }
    setValue(e1) {
        let t = !1;
        for (const [i, n] of Object.entries(e1))t = this.dynamics[i].setValue(n) || t;
        return t && this.fn && this.fn(this.current), t;
    }
    update(e1) {
        let t = !1;
        for (const i of Object.values(this.dynamics))t = i.update(e1) || t;
        return t && this.fn && this.fn(this.current), t;
    }
}, $785da19a645c07eb$var$zX = class {
    constructor(e1 = 200){
        this.delay = e1, this.time = 0, this.delay = e1;
    }
    get pending() {
        return 0 !== this.time;
    }
    down(e1) {
        this.timeout && (clearTimeout(this.timeout), this.timeout = void 0), this.time = (new Date).getTime(), this.data = e1;
    }
    up(e1) {
        if (!this.time) return;
        Date.now() - this.time < this.delay ? this.timeout = setTimeout(()=>{
            e1(this.data), this.timeout = void 0, this.time = 0, this.data = void 0;
        }, this.delay) : (e1(this.data), this.time = 0, this.data = void 0);
    }
}, $785da19a645c07eb$var$RX = ((e1)=>(e1.VERTICAL = "VERTICAL", e1.HORIZONTAL = "HORIZONTAL", e1))($785da19a645c07eb$var$RX || {}), $785da19a645c07eb$var$LX = class {
    constructor(e1, t, i){
        this.container = e1, this.direction = t, this.listener = i, this.mousedown = !1, this.mouseover = !1, this.container.addEventListener("click", this), this.container.addEventListener("mousedown", this), this.container.addEventListener("mouseenter", this), this.container.addEventListener("mouseleave", this), this.container.addEventListener("touchstart", this), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("touchmove", this, !0), window.addEventListener("mouseup", this), window.addEventListener("touchend", this);
    }
    get isVertical() {
        return "VERTICAL" === this.direction;
    }
    get isHorizontal() {
        return "HORIZONTAL" === this.direction;
    }
    destroy() {
        window.removeEventListener("mouseup", this), window.removeEventListener("touchend", this);
    }
    handleEvent(e1) {
        switch(e1.type){
            case "click":
                e1.stopPropagation();
                break;
            case "mousedown":
                this.__onMouseDown(e1);
                break;
            case "mouseenter":
                this.__onMouseEnter(e1);
                break;
            case "mouseleave":
                this.__onMouseLeave(e1);
                break;
            case "touchstart":
                this.__onTouchStart(e1);
                break;
            case "mousemove":
                this.__onMouseMove(e1);
                break;
            case "touchmove":
                this.__onTouchMove(e1);
                break;
            case "mouseup":
                this.__onMouseUp(e1);
                break;
            case "touchend":
                this.__onTouchEnd(e1);
        }
    }
    __onMouseDown(e1) {
        this.mousedown = !0, this.__update(e1.clientX, e1.clientY, !0);
    }
    __onMouseEnter(e1) {
        this.mouseover = !0, this.__update(e1.clientX, e1.clientY, !0);
    }
    __onTouchStart(e1) {
        this.mouseover = !0, this.mousedown = !0;
        const t = e1.changedTouches[0];
        this.__update(t.clientX, t.clientY, !0);
    }
    __onMouseMove(e1) {
        (this.mousedown || this.mouseover) && (e1.stopPropagation(), this.__update(e1.clientX, e1.clientY, !0));
    }
    __onTouchMove(e1) {
        if (this.mousedown || this.mouseover) {
            e1.stopPropagation();
            const t = e1.changedTouches[0];
            this.__update(t.clientX, t.clientY, !0);
        }
    }
    __onMouseUp(e1) {
        this.mousedown && (this.mousedown = !1, this.__update(e1.clientX, e1.clientY, !1));
    }
    __onMouseLeave(e1) {
        this.mouseover && (this.mouseover = !1, this.__update(e1.clientX, e1.clientY, !0));
    }
    __onTouchEnd(e1) {
        if (this.mousedown) {
            this.mouseover = !1, this.mousedown = !1;
            const t = e1.changedTouches[0];
            this.__update(t.clientX, t.clientY, !1);
        }
    }
    __update(e1, t, i) {
        const n = this.container.getBoundingClientRect();
        let a;
        a = this.isVertical ? $785da19a645c07eb$var$xj.clamp((n.bottom - t) / n.height, 0, 1) : $785da19a645c07eb$var$xj.clamp((e1 - n.left) / n.width, 0, 1), this.listener({
            value: a,
            click: !i,
            mousedown: this.mousedown,
            mouseover: this.mouseover,
            cursor: {
                clientX: e1,
                clientY: t
            }
        });
    }
}, $785da19a645c07eb$var$BX = {};
$785da19a645c07eb$var$rK($785da19a645c07eb$var$BX, {
    BeforeAnimateEvent: ()=>$785da19a645c07eb$var$VX,
    BeforeRenderEvent: ()=>$785da19a645c07eb$var$GX,
    BeforeRotateEvent: ()=>$785da19a645c07eb$var$WX,
    ClickEvent: ()=>$785da19a645c07eb$var$KX,
    ConfigChangedEvent: ()=>$785da19a645c07eb$var$QX,
    DoubleClickEvent: ()=>$785da19a645c07eb$var$JX,
    FullscreenEvent: ()=>$785da19a645c07eb$var$eQ,
    HideNotificationEvent: ()=>$785da19a645c07eb$var$iQ,
    HideOverlayEvent: ()=>$785da19a645c07eb$var$aQ,
    HidePanelEvent: ()=>$785da19a645c07eb$var$sQ,
    HideTooltipEvent: ()=>$785da19a645c07eb$var$lQ,
    KeypressEvent: ()=>$785da19a645c07eb$var$uQ,
    LoadProgressEvent: ()=>$785da19a645c07eb$var$dQ,
    ObjectEnterEvent: ()=>$785da19a645c07eb$var$HQ,
    ObjectEvent: ()=>$785da19a645c07eb$var$qQ,
    ObjectHoverEvent: ()=>$785da19a645c07eb$var$XQ,
    ObjectLeaveEvent: ()=>$785da19a645c07eb$var$ZQ,
    PanoramaErrorEvent: ()=>$785da19a645c07eb$var$_Q,
    PanoramaLoadEvent: ()=>$785da19a645c07eb$var$mQ,
    PanoramaLoadedEvent: ()=>$785da19a645c07eb$var$fQ,
    PositionUpdatedEvent: ()=>$785da19a645c07eb$var$bQ,
    ReadyEvent: ()=>$785da19a645c07eb$var$SQ,
    RenderEvent: ()=>$785da19a645c07eb$var$CQ,
    RollUpdatedEvent: ()=>$785da19a645c07eb$var$EQ,
    ShowNotificationEvent: ()=>$785da19a645c07eb$var$DQ,
    ShowOverlayEvent: ()=>$785da19a645c07eb$var$IQ,
    ShowPanelEvent: ()=>$785da19a645c07eb$var$zQ,
    ShowTooltipEvent: ()=>$785da19a645c07eb$var$LQ,
    SizeUpdatedEvent: ()=>$785da19a645c07eb$var$OQ,
    StopAllEvent: ()=>$785da19a645c07eb$var$NQ,
    TransitionDoneEvent: ()=>$785da19a645c07eb$var$yQ,
    ViewerEvent: ()=>$785da19a645c07eb$var$NX,
    ZoomUpdatedEvent: ()=>$785da19a645c07eb$var$VQ
});
var $785da19a645c07eb$var$OX = class extends Event {
    constructor(e1, t = !1){
        super(e1, {
            cancelable: t
        });
    }
}, $785da19a645c07eb$var$UX = class extends EventTarget {
    dispatchEvent(e1) {
        return super.dispatchEvent(e1);
    }
    addEventListener(e1, t, i) {
        super.addEventListener(e1, t, i);
    }
    removeEventListener(e1, t, i) {
        super.removeEventListener(e1, t, i);
    }
}, $785da19a645c07eb$var$NX = class extends $785da19a645c07eb$var$OX {
}, $785da19a645c07eb$var$jX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t, i){
        super(e1.type, !0), this.position = t, this.zoomLevel = i;
    }
};
$785da19a645c07eb$var$jX.type = "before-animate";
var $785da19a645c07eb$var$VX = $785da19a645c07eb$var$jX, $785da19a645c07eb$var$qX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t, i){
        super(e1.type), this.timestamp = t, this.elapsed = i;
    }
};
$785da19a645c07eb$var$qX.type = "before-render";
var $785da19a645c07eb$var$GX = $785da19a645c07eb$var$qX, $785da19a645c07eb$var$HX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type, !0), this.position = t;
    }
};
$785da19a645c07eb$var$HX.type = "before-rotate";
var $785da19a645c07eb$var$WX = $785da19a645c07eb$var$HX, $785da19a645c07eb$var$ZX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.data = t;
    }
};
$785da19a645c07eb$var$ZX.type = "click";
var $785da19a645c07eb$var$KX = $785da19a645c07eb$var$ZX, $785da19a645c07eb$var$XX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.options = t;
    }
    containsOptions(...e1) {
        return e1.some((e1)=>this.options.includes(e1));
    }
};
$785da19a645c07eb$var$XX.type = "config-changed";
var $785da19a645c07eb$var$QX = $785da19a645c07eb$var$XX, $785da19a645c07eb$var$YX = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.data = t;
    }
};
$785da19a645c07eb$var$YX.type = "dblclick";
var $785da19a645c07eb$var$JX = $785da19a645c07eb$var$YX, $785da19a645c07eb$var$$X = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.fullscreenEnabled = t;
    }
};
$785da19a645c07eb$var$$X.type = "fullscreen";
var $785da19a645c07eb$var$eQ = $785da19a645c07eb$var$$X, $785da19a645c07eb$var$tQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.notificationId = t;
    }
};
$785da19a645c07eb$var$tQ.type = "hide-notification";
var $785da19a645c07eb$var$iQ = $785da19a645c07eb$var$tQ, $785da19a645c07eb$var$nQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.overlayId = t;
    }
};
$785da19a645c07eb$var$nQ.type = "hide-overlay";
var $785da19a645c07eb$var$aQ = $785da19a645c07eb$var$nQ, $785da19a645c07eb$var$rQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.panelId = t;
    }
};
$785da19a645c07eb$var$rQ.type = "hide-panel";
var $785da19a645c07eb$var$sQ = $785da19a645c07eb$var$rQ, $785da19a645c07eb$var$oQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.tooltipData = t;
    }
};
$785da19a645c07eb$var$oQ.type = "hide-tooltip";
var $785da19a645c07eb$var$lQ = $785da19a645c07eb$var$oQ, $785da19a645c07eb$var$cQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t, i){
        super(e1.type, !0), this.key = t, this.originalEvent = i;
    }
    matches(e1) {
        return $785da19a645c07eb$var$GK(this.originalEvent, e1);
    }
};
$785da19a645c07eb$var$cQ.type = "key-press";
var $785da19a645c07eb$var$uQ = $785da19a645c07eb$var$cQ, $785da19a645c07eb$var$hQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.progress = t;
    }
};
$785da19a645c07eb$var$hQ.type = "load-progress";
var $785da19a645c07eb$var$dQ = $785da19a645c07eb$var$hQ, $785da19a645c07eb$var$pQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.panorama = t;
    }
};
$785da19a645c07eb$var$pQ.type = "panorama-load";
var $785da19a645c07eb$var$mQ = $785da19a645c07eb$var$pQ, $785da19a645c07eb$var$gQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.data = t;
    }
};
$785da19a645c07eb$var$gQ.type = "panorama-loaded";
var $785da19a645c07eb$var$fQ = $785da19a645c07eb$var$gQ, $785da19a645c07eb$var$AQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t, i){
        super(e1.type), this.panorama = t, this.error = i;
    }
};
$785da19a645c07eb$var$AQ.type = "panorama-error";
var $785da19a645c07eb$var$_Q = $785da19a645c07eb$var$AQ, $785da19a645c07eb$var$vQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.completed = t;
    }
};
$785da19a645c07eb$var$vQ.type = "transition-done";
var $785da19a645c07eb$var$yQ = $785da19a645c07eb$var$vQ, $785da19a645c07eb$var$xQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.position = t;
    }
};
$785da19a645c07eb$var$xQ.type = "position-updated";
var $785da19a645c07eb$var$bQ = $785da19a645c07eb$var$xQ, $785da19a645c07eb$var$wQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.roll = t;
    }
};
$785da19a645c07eb$var$wQ.type = "roll-updated";
var $785da19a645c07eb$var$EQ = $785da19a645c07eb$var$wQ, $785da19a645c07eb$var$kQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(){
        super(e1.type);
    }
};
$785da19a645c07eb$var$kQ.type = "ready";
var $785da19a645c07eb$var$SQ = $785da19a645c07eb$var$kQ, $785da19a645c07eb$var$MQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(){
        super(e1.type);
    }
};
$785da19a645c07eb$var$MQ.type = "render";
var $785da19a645c07eb$var$CQ = $785da19a645c07eb$var$MQ, $785da19a645c07eb$var$TQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.notificationId = t;
    }
};
$785da19a645c07eb$var$TQ.type = "show-notification";
var $785da19a645c07eb$var$DQ = $785da19a645c07eb$var$TQ, $785da19a645c07eb$var$PQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.overlayId = t;
    }
};
$785da19a645c07eb$var$PQ.type = "show-overlay";
var $785da19a645c07eb$var$IQ = $785da19a645c07eb$var$PQ, $785da19a645c07eb$var$FQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.panelId = t;
    }
};
$785da19a645c07eb$var$FQ.type = "show-panel";
var $785da19a645c07eb$var$zQ = $785da19a645c07eb$var$FQ, $785da19a645c07eb$var$RQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t, i){
        super(e1.type), this.tooltip = t, this.tooltipData = i;
    }
};
$785da19a645c07eb$var$RQ.type = "show-tooltip";
var $785da19a645c07eb$var$LQ = $785da19a645c07eb$var$RQ, $785da19a645c07eb$var$BQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.size = t;
    }
};
$785da19a645c07eb$var$BQ.type = "size-updated";
var $785da19a645c07eb$var$OQ = $785da19a645c07eb$var$BQ, $785da19a645c07eb$var$UQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(){
        super(e1.type);
    }
};
$785da19a645c07eb$var$UQ.type = "stop-all";
var $785da19a645c07eb$var$NQ = $785da19a645c07eb$var$UQ, $785da19a645c07eb$var$jQ = class e1 extends $785da19a645c07eb$var$NX {
    constructor(t){
        super(e1.type), this.zoomLevel = t;
    }
};
$785da19a645c07eb$var$jQ.type = "zoom-updated";
var $785da19a645c07eb$var$VQ = $785da19a645c07eb$var$jQ, $785da19a645c07eb$var$qQ = class extends $785da19a645c07eb$var$NX {
    constructor(e1, t, i, n, a){
        super(e1), this.originalEvent = t, this.object = i, this.viewerPoint = n, this.userDataKey = a;
    }
}, $785da19a645c07eb$var$GQ = class e1 extends $785da19a645c07eb$var$qQ {
    constructor(t, i, n, a){
        super(e1.type, t, i, n, a);
    }
};
$785da19a645c07eb$var$GQ.type = "enter-object";
var $785da19a645c07eb$var$HQ = $785da19a645c07eb$var$GQ, $785da19a645c07eb$var$WQ = class e1 extends $785da19a645c07eb$var$qQ {
    constructor(t, i, n, a){
        super(e1.type, t, i, n, a);
    }
};
$785da19a645c07eb$var$WQ.type = "leave-object";
var $785da19a645c07eb$var$ZQ = $785da19a645c07eb$var$WQ, $785da19a645c07eb$var$KQ = class e1 extends $785da19a645c07eb$var$qQ {
    constructor(t, i, n, a){
        super(e1.type, t, i, n, a);
    }
};
$785da19a645c07eb$var$KQ.type = "hover-object";
var $785da19a645c07eb$var$XQ = $785da19a645c07eb$var$KQ, $785da19a645c07eb$var$QQ = class {
    constructor(e1){
        this.viewer = e1;
    }
    init() {}
    destroy() {}
    supportsTransition(e1) {
        return !1;
    }
    supportsPreload(e1) {
        return !1;
    }
    textureCoordsToSphericalCoords(e1, t) {
        throw new $785da19a645c07eb$var$tX("Current adapter does not support texture coordinates.");
    }
    sphericalCoordsToTextureCoords(e1, t) {
        throw new $785da19a645c07eb$var$tX("Current adapter does not support texture coordinates.");
    }
};
function $785da19a645c07eb$var$YQ(e1) {
    if (e1) {
        for (const [, t] of [
            [
                "_",
                e1
            ],
            ...Object.entries(e1)
        ])if (t.prototype instanceof $785da19a645c07eb$var$QQ) return $785da19a645c07eb$var$bX(t.id, t.VERSION, "5.15.1"), t;
    }
    return null;
}
$785da19a645c07eb$var$QQ.supportsDownload = !1;
var $785da19a645c07eb$var$JQ = $785da19a645c07eb$var$yX({
    shader: !1,
    resolution: 64,
    useXmpData: !0
}, {
    resolution: (e1)=>{
        if (!e1 || !$785da19a645c07eb$var$xj.isPowerOfTwo(e1)) throw new $785da19a645c07eb$var$tX("EquirectangularAdapter resolution must be power of two.");
        return e1;
    }
}), $785da19a645c07eb$var$$Q = class e1 extends $785da19a645c07eb$var$QQ {
    static withConfig(t) {
        return [
            e1,
            t
        ];
    }
    constructor(e1, t){
        super(e1), this.config = $785da19a645c07eb$var$JQ(t), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2;
    }
    supportsTransition() {
        return !0;
    }
    supportsPreload() {
        return !0;
    }
    textureCoordsToSphericalCoords(e1, t) {
        if ($785da19a645c07eb$var$YK(e1.textureX) || $785da19a645c07eb$var$YK(e1.textureY)) throw new $785da19a645c07eb$var$tX("Texture position is missing 'textureX' or 'textureY'");
        const i = (e1.textureX + t.croppedX) / t.fullWidth * Math.PI * 2, n = (e1.textureY + t.croppedY) / t.fullHeight * Math.PI;
        return {
            yaw: i >= Math.PI ? i - Math.PI : i + Math.PI,
            pitch: Math.PI / 2 - n
        };
    }
    sphericalCoordsToTextureCoords(e1, t) {
        const i = e1.yaw / Math.PI / 2 * t.fullWidth, n = e1.pitch / Math.PI * t.fullHeight;
        let a = Math.round(e1.yaw < Math.PI ? i + t.fullWidth / 2 : i - t.fullWidth / 2) - t.croppedX, r = Math.round(t.fullHeight / 2 - n) - t.croppedY;
        return (a < 0 || a > t.croppedWidth || r < 0 || r > t.croppedHeight) && (a = r = void 0), {
            textureX: a,
            textureY: r
        };
    }
    async loadTexture(e1, t = !0, i, n = this.config.useXmpData) {
        if ("string" != typeof e1 && ("object" != typeof e1 || !e1.path)) return Promise.reject(new $785da19a645c07eb$var$tX("Invalid panorama url, are you using the right adapter?"));
        let a;
        a = "string" == typeof e1 ? {
            path: e1,
            data: i
        } : {
            data: i,
            ...e1
        };
        const r = await this.viewer.textureLoader.loadFile(a.path, t ? (e1)=>this.viewer.textureLoader.dispatchProgress(e1) : null, a.path), s = n ? await this.loadXMP(r) : null, o = await this.viewer.textureLoader.blobToImage(r);
        "function" == typeof a.data && (a.data = a.data(o, s));
        const l = $785da19a645c07eb$var$EX(o.width, o.height, a.data, s);
        return {
            panorama: e1,
            texture: $785da19a645c07eb$var$CX(o, a.blur ? {
                factor: 2048
            } : null),
            panoData: l,
            cacheKey: a.path
        };
    }
    async loadXMP(e1) {
        const t = await this.loadBlobAsString(e1), i = t.indexOf("<x:xmpmeta");
        if (-1 === i) return null;
        const n = t.indexOf("</x:xmpmeta>", i);
        if (-1 === n) return null;
        const a = t.substring(i, n);
        return a.includes("GPano:") ? {
            fullWidth: $785da19a645c07eb$var$lX(a, "FullPanoWidthPixels"),
            fullHeight: $785da19a645c07eb$var$lX(a, "FullPanoHeightPixels"),
            croppedWidth: $785da19a645c07eb$var$lX(a, "CroppedAreaImageWidthPixels"),
            croppedHeight: $785da19a645c07eb$var$lX(a, "CroppedAreaImageHeightPixels"),
            croppedX: $785da19a645c07eb$var$lX(a, "CroppedAreaLeftPixels"),
            croppedY: $785da19a645c07eb$var$lX(a, "CroppedAreaTopPixels"),
            poseHeading: $785da19a645c07eb$var$lX(a, "PoseHeadingDegrees", !1),
            posePitch: $785da19a645c07eb$var$lX(a, "PosePitchDegrees", !1),
            poseRoll: $785da19a645c07eb$var$lX(a, "PoseRollDegrees", !1),
            initialHeading: $785da19a645c07eb$var$lX(a, "InitialViewHeadingDegrees", !1),
            initialPitch: $785da19a645c07eb$var$lX(a, "InitialViewPitchDegrees", !1),
            initialFov: $785da19a645c07eb$var$lX(a, "InitialHorizontalFOVDegrees", !1)
        } : null;
    }
    loadBlobAsString(e1) {
        return new Promise((t, i)=>{
            const n = new FileReader;
            n.onload = ()=>t(n.result), n.onerror = i, n.readAsText(e1);
        });
    }
    createMesh(e1) {
        if (this.config.shader) {
            const t = new $785da19a645c07eb$var$kG($785da19a645c07eb$var$mK, 32, 16).scale(-1, 1, 1), i = {
                map: {
                    value: null
                },
                opacity: {
                    value: 1
                },
                radius: {
                    value: $785da19a645c07eb$var$mK
                },
                uvOffset: {
                    value: new $785da19a645c07eb$var$bj(e1.croppedX / e1.fullWidth, (e1.fullHeight - e1.croppedY - e1.croppedHeight) / e1.fullHeight)
                },
                uvScale: {
                    value: new $785da19a645c07eb$var$bj(e1.croppedWidth / e1.fullWidth, e1.croppedHeight / e1.fullHeight)
                }
            }, n = new $785da19a645c07eb$var$FG({
                uniforms: i,
                vertexShader: "// Ray-cast inputs in the panorama's local frame, so sphereCorrection and pose\n// (both folded into modelMatrix) apply to the sampled direction without\n// per-fragment work.\nvarying vec3 vLocalPos;\nvarying vec3 vLocalCam;\n\nvoid main() {\n    vLocalPos = position;\n\n    // mat3(modelMatrix) is a pure rotation, so its inverse is its transpose:\n    // `cameraPosition * M == transpose(M) * cameraPosition`.\n    vLocalCam = cameraPosition * mat3(modelMatrix);\n\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}\n",
                fragmentShader: "varying vec3 vLocalPos;\nvarying vec3 vLocalCam;\nuniform sampler2D map;\nuniform float opacity;\nuniform vec2 uvOffset;\nuniform vec2 uvScale;\nuniform float radius;\n\nconst float PI = 3.1415926535897932384626433832795;\n\n// Analytic edge antialiasing across one screen-space pixel at the\n// cropped-region boundary on a single axis (replaces the MSAA the standard\n// adapter gets by rendering triangles).\nfloat edgeAlpha(float coord, float width) {\n    float dist = min(coord, 1.0 - coord);\n    return clamp(dist / width + 0.5, 0.0, 1.0);\n}\n\n// Screen-space derivative (fwidth) of a coordinate that wraps in [0, 1], such\n// as longitude at the antimeridian. A naive fwidth() spikes to ~1.0 across the\n// seam. Removing the integer jump keeps the result sub-pixel. Assumes the\n// per-pixel change stays well under 0.5, so only the wrap rounds to a non-zero\n// integer (safe unless a pixel spans ~180deg of longitude).\nfloat fwidthWrapped(float coord) {\n    float dx = dFdx(coord); dx -= floor(dx + 0.5);\n    float dy = dFdy(coord); dy -= floor(dy + 0.5);\n    return abs(dx) + abs(dy);\n}\n\nvoid main() {\n    // Ray-cast the true sphere from the camera through the (interpolated, on\n    // the polygon chord) position, and use the exit-point direction for\n    // sampling. This makes the result independent of mesh tessellation even\n    // when the camera is offset from the sphere center (e.g. fisheye config).\n    // Inputs are already in the panorama's local frame (see vertex shader), so\n    // the exit direction is too and needs no further rotation.\n    vec3 rayDir = vLocalPos - vLocalCam;\n    float a = dot(rayDir, rayDir);\n    float b = dot(vLocalCam, rayDir);\n    float c = dot(vLocalCam, vLocalCam) - radius * radius;\n    float t = (-b + sqrt(max(b * b - a * c, 0.0))) / a;\n    vec3 dir = (vLocalCam + t * rayDir) / radius;\n\n    float u = atan(-dir.x, dir.z) / (2.0 * PI) + 0.5;\n    float v = asin(clamp(dir.y, -1.0, 1.0)) / PI + 0.5;\n    vec2 uv = (vec2(u, v) - uvOffset) / uvScale;\n\n    float alpha = 1.0;\n    // `u` wraps at the antimeridian, so derive its width safely.\n    if (uvScale.x < 1.0) alpha = min(alpha, edgeAlpha(uv.x, fwidthWrapped(u) / uvScale.x));\n    if (uvScale.y < 1.0) alpha = min(alpha, edgeAlpha(uv.y, fwidth(uv.y)));\n    if (alpha <= 0.0) discard;\n\n    gl_FragColor = texture2D(map, uv);\n    gl_FragColor.a *= opacity * alpha;\n}\n",
                depthTest: !1,
                depthWrite: !1,
                transparent: !0
            });
            return new $785da19a645c07eb$var$Kq(t, n);
        }
        {
            const t = e1.croppedX / e1.fullWidth * 2 * Math.PI, i = e1.croppedWidth / e1.fullWidth * 2 * Math.PI, n = e1.croppedY / e1.fullHeight * Math.PI, a = e1.croppedHeight / e1.fullHeight * Math.PI, r = new $785da19a645c07eb$var$kG($785da19a645c07eb$var$mK, Math.round(this.SPHERE_SEGMENTS / (2 * Math.PI) * i), Math.round(this.SPHERE_HORIZONTAL_SEGMENTS / Math.PI * a), -Math.PI / 2 + t, i, n, a).scale(-1, 1, 1), s = new $785da19a645c07eb$var$Lq({
                depthTest: !1,
                depthWrite: !1
            });
            return new $785da19a645c07eb$var$Kq(r, s);
        }
    }
    setTexture(e1, t) {
        this.config.shader ? e1.material.uniforms.map.value = t.texture : e1.material.map = t.texture;
    }
    setTextureOpacity(e1, t) {
        this.config.shader ? e1.material.uniforms.opacity.value = t : (e1.material.opacity = t, e1.material.transparent = t < 1);
    }
    disposeTexture({ texture: e1 }) {
        e1.dispose();
    }
    disposeMesh(e1) {
        e1.geometry.dispose(), e1.material.dispose();
    }
};
$785da19a645c07eb$var$$Q.id = "equirectangular", $785da19a645c07eb$var$$Q.VERSION = "5.15.1", $785da19a645c07eb$var$$Q.supportsDownload = !0;
var $785da19a645c07eb$var$eY = $785da19a645c07eb$var$$Q, $785da19a645c07eb$var$tY = class e1 extends $785da19a645c07eb$var$eY {
    static withConfig(t) {
        return [
            e1,
            t
        ];
    }
    constructor(e1, t){
        super(e1, {
            resolution: t?.resolution ?? 64,
            useXmpData: !1
        }), $785da19a645c07eb$var$sX('"DualFisheyeAdapter" must be imported from "@photo-sphere-viewer/dual-fisheye-adapter" package');
    }
    async loadTexture(e1, t) {
        const i = await super.loadTexture(e1, t, null, !1);
        return i.panoData = null, i;
    }
    createMesh() {
        const e1 = new $785da19a645c07eb$var$kG($785da19a645c07eb$var$mK, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS).scale(-1, 1, 1).toNonIndexed(), t = e1.getAttribute("uv"), i = e1.getAttribute("normal");
        for(let e1 = 0; e1 < t.count; e1++)for(let n = 0; n < 3; n++){
            const a = 3 * e1 + n, r = i.getX(a), s = i.getY(a), o = i.getZ(a), l = .947;
            if (e1 < t.count / 6) {
                const e1 = 0 === r && 0 === o ? 1 : Math.acos(s) / Math.sqrt(r * r + o * o) * (2 / Math.PI);
                t.setXY(a, r * (l / 4) * e1 + 1 / 4, o * (l / 2) * e1 + .5);
            } else {
                const e1 = 0 === r && 0 === o ? 1 : Math.acos(-s) / Math.sqrt(r * r + o * o) * (2 / Math.PI);
                t.setXY(a, l / 4 * -r * e1 + 3 / 4, o * (l / 2) * e1 + .5);
            }
        }
        e1.rotateX(-Math.PI / 2), e1.rotateY(Math.PI);
        const n = new $785da19a645c07eb$var$Lq({
            depthTest: !1,
            depthWrite: !1
        });
        return new $785da19a645c07eb$var$Kq(e1, n);
    }
};
$785da19a645c07eb$var$tY.id = "dual-fisheye", $785da19a645c07eb$var$tY.VERSION = "5.15.1";
var $785da19a645c07eb$var$iY = class e1 {
    constructor(t, i){
        this.parent = t, this.children = [], this.state = {
            visible: !0
        }, this.viewer = t instanceof e1 ? t.viewer : t, this.container = document.createElement(i.tagName ?? "div"), this.container.className = i.className || "", this.parent.children.push(this), this.parent.container.appendChild(this.container);
    }
    destroy() {
        this.parent.container.removeChild(this.container);
        const e1 = this.parent.children.indexOf(this);
        -1 !== e1 && this.parent.children.splice(e1, 1), this.children.slice().forEach((e1)=>e1.destroy()), this.children.length = 0;
    }
    toggle(e1 = !this.isVisible()) {
        e1 ? this.show() : this.hide();
    }
    hide(e1) {
        this.container.style.display = "none", this.state.visible = !1;
    }
    show(e1) {
        this.container.style.display = "", this.state.visible = !0;
    }
    isVisible() {
        return this.state.visible;
    }
}, $785da19a645c07eb$var$nY = $785da19a645c07eb$var$yX({
    id: null,
    tagName: null,
    className: null,
    title: null,
    hoverScale: !1,
    collapsable: !1,
    tabbable: !0,
    icon: null,
    iconActive: null
}), $785da19a645c07eb$var$aY = class extends $785da19a645c07eb$var$iY {
    constructor(e1, t){
        super(e1, {
            tagName: t.tagName,
            className: `psv-button ${t.hoverScale ? "psv-button--hover-scale" : ""} ${t.className || ""}`
        }), this.state = {
            visible: !0,
            enabled: !0,
            supported: !0,
            collapsed: !1,
            active: !1,
            width: 0
        }, this.config = $785da19a645c07eb$var$nY(t), t.id || (this.config.id = this.constructor.id), t.icon && this.__setIcon(t.icon), this.state.width = this.container.offsetWidth, this.config.title ? this.container.title = this.viewer.config.lang[this.config.title] ?? this.config.title : this.id && this.id in this.viewer.config.lang && (this.container.title = this.viewer.config.lang[this.id]), t.tabbable && (this.container.tabIndex = 0), this.container.addEventListener("click", (e1)=>{
            this.state.enabled && this.onClick(), e1.stopPropagation();
        }), this.container.addEventListener("keydown", (e1)=>{
            e1.key === $785da19a645c07eb$var$vK.Enter && this.state.enabled && (this.onClick(), e1.stopPropagation());
        });
    }
    get id() {
        return this.config.id;
    }
    get title() {
        return this.container.title;
    }
    get content() {
        return this.container.innerHTML;
    }
    get width() {
        return this.state.width;
    }
    get collapsable() {
        return this.config.collapsable;
    }
    show(e1 = !0) {
        this.isVisible() || (this.state.visible = !0, this.state.collapsed || (this.container.style.display = ""), e1 && this.viewer.navbar.autoSize());
    }
    hide(e1 = !0) {
        this.isVisible() && (this.state.visible = !1, this.container.style.display = "none", e1 && this.viewer.navbar.autoSize());
    }
    checkSupported() {
        $785da19a645c07eb$var$iX(this.isSupported(), (e1, t)=>{
            this.state && (this.state.supported = e1, t ? e1 || this.hide() : this.toggle(e1));
        });
    }
    autoSize() {}
    isSupported() {
        return !0;
    }
    toggleActive(e1 = !this.state.active) {
        e1 !== this.state.active && (this.state.active = e1, $785da19a645c07eb$var$PK(this.container, "psv-button--active", this.state.active), this.config.iconActive && this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon));
    }
    disable() {
        this.container.classList.add("psv-button--disabled"), this.state.enabled = !1;
    }
    enable() {
        this.container.classList.remove("psv-button--disabled"), this.state.enabled = !0;
    }
    collapse() {
        this.state.collapsed = !0, this.container.style.display = "none";
    }
    uncollapse() {
        this.state.collapsed = !1, this.state.visible && (this.container.style.display = "");
    }
    __setIcon(e1) {
        this.container.innerHTML = e1, $785da19a645c07eb$var$IK(this.container.querySelector("svg"), "psv-button-svg");
    }
}, $785da19a645c07eb$var$rY = class extends $785da19a645c07eb$var$aY {
    constructor(e1, t){
        super(e1, {
            id: t.id ?? `psvButton-${Math.random().toString(36).substring(2)}`,
            className: `psv-custom-button ${t.className || ""}`,
            hoverScale: !1,
            collapsable: !1 !== t.collapsable,
            tabbable: !1 !== t.tabbable,
            title: t.title
        }), this.customOnClick = t.onClick, t.content && ("string" == typeof t.content ? this.container.innerHTML = t.content : (this.container.classList.add("psv-custom-button--no-padding"), t.content.style.height = "100%", t.content.attachViewer?.(this.viewer), this.container.appendChild(t.content))), this.state.width = this.container.offsetWidth, t.disabled && this.disable(), !1 === t.visible && this.hide();
    }
    onClick() {
        this.customOnClick?.(this.viewer);
    }
}, $785da19a645c07eb$var$sY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-description-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $785da19a645c07eb$var$yK.info
        }), this.mode = 0, this.viewer.addEventListener($785da19a645c07eb$var$iQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$DQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$sQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$zQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$QX.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$iQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$DQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$sQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$zQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$QX.type, this), super.destroy();
    }
    handleEvent(e1) {
        if (e1 instanceof $785da19a645c07eb$var$QX) return void (e1.containsOptions("description") && this.autoSize(!0));
        if (!this.mode) return;
        let t = !1;
        e1 instanceof $785da19a645c07eb$var$iQ ? t = 1 === this.mode : e1 instanceof $785da19a645c07eb$var$DQ ? t = 1 === this.mode && e1.notificationId !== $785da19a645c07eb$var$_K.DESCRIPTION : e1 instanceof $785da19a645c07eb$var$sQ ? t = 2 === this.mode : e1 instanceof $785da19a645c07eb$var$zQ && (t = 2 === this.mode && e1.panelId !== $785da19a645c07eb$var$_K.DESCRIPTION), t && (this.toggleActive(!1), this.mode = 0);
    }
    onClick() {
        this.mode ? this.__close() : this.__open();
    }
    hide(e1) {
        super.hide(e1), this.mode && this.__close();
    }
    autoSize(e1 = !1) {
        if (e1) {
            const e1 = this.viewer.navbar.getButton("caption", !1), t = e1 && !e1.isVisible(), i = !!this.viewer.config.description;
            t || i ? this.show(!1) : this.hide(!1);
        }
    }
    __close() {
        switch(this.mode){
            case 1:
                this.viewer.notification.hide($785da19a645c07eb$var$_K.DESCRIPTION);
                break;
            case 2:
                this.viewer.panel.hide($785da19a645c07eb$var$_K.DESCRIPTION);
        }
    }
    __open() {
        this.toggleActive(!0), this.viewer.config.description ? (this.mode = 2, this.viewer.panel.show({
            id: $785da19a645c07eb$var$_K.DESCRIPTION,
            content: `${this.viewer.config.caption ? `<p>${this.viewer.config.caption}</p>` : ""}${this.viewer.config.description}`
        })) : (this.mode = 1, this.viewer.notification.show({
            id: $785da19a645c07eb$var$_K.DESCRIPTION,
            content: this.viewer.config.caption
        }));
    }
};
$785da19a645c07eb$var$sY.id = "description";
var $785da19a645c07eb$var$oY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            tagName: "a",
            className: "psv-download-button",
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0,
            icon: $785da19a645c07eb$var$yK.download
        }), this.viewer.addEventListener($785da19a645c07eb$var$QX.type, this), this.viewer.addEventListener($785da19a645c07eb$var$fQ.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$QX.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$fQ.type, this), super.destroy();
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$QX ? (e1.containsOptions("downloadUrl") && this.checkSupported(), e1.containsOptions("downloadUrl", "downloadName") && this.__update()) : e1 instanceof $785da19a645c07eb$var$fQ && this.__update();
    }
    onClick() {}
    checkSupported() {
        this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl ? this.show() : this.hide();
    }
    __update() {
        const e1 = this.container;
        e1.href = this.viewer.config.downloadUrl || this.viewer.config.panorama, e1.target = "_blank", e1.href.startsWith("data:") && !this.viewer.config.downloadName ? e1.download = "panorama." + e1.href.substring(0, e1.href.indexOf(";")).split("/").pop() : e1.download = this.viewer.config.downloadName || e1.href.split("/").pop();
    }
};
$785da19a645c07eb$var$oY.id = "download";
var $785da19a645c07eb$var$lY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-fullscreen-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $785da19a645c07eb$var$yK.fullscreenIn,
            iconActive: $785da19a645c07eb$var$yK.fullscreenOut
        }), this.viewer.addEventListener($785da19a645c07eb$var$eQ.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$eQ.type, this), super.destroy();
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$eQ && this.toggleActive(e1.fullscreenEnabled);
    }
    onClick() {
        this.viewer.toggleFullscreen();
    }
};
$785da19a645c07eb$var$lY.id = "fullscreen";
var $785da19a645c07eb$var$cY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-menu-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $785da19a645c07eb$var$yK.menu
        }), this.viewer.addEventListener($785da19a645c07eb$var$zQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$sQ.type, this), super.hide();
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$zQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$sQ.type, this), super.destroy();
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$zQ ? this.toggleActive(e1.panelId === $785da19a645c07eb$var$_K.MENU) : e1 instanceof $785da19a645c07eb$var$sQ && this.toggleActive(!1);
    }
    onClick() {
        this.state.active ? this.__hideMenu() : this.__showMenu();
    }
    hide(e1) {
        super.hide(e1), this.__hideMenu();
    }
    show(e1) {
        super.show(e1), this.state.active && this.__showMenu();
    }
    __showMenu() {
        var e1, t;
        this.viewer.panel.show({
            id: $785da19a645c07eb$var$_K.MENU,
            content: (e1 = this.viewer.navbar.collapsed, t = this.viewer.config.lang.menu, `\n<div class="psv-panel-menu psv-panel-menu--stripped">\n  <h1 class="psv-panel-menu-title">${$785da19a645c07eb$var$yK.menu} ${t}</h1>\n  <ul class="psv-panel-menu-list">\n    ${e1.map((e1)=>`\n    <li data-psv-button="${e1.id}" class="psv-panel-menu-item" tabindex="0">\n      <span class="psv-panel-menu-item-icon">${e1.content}</span>\n      <span class="psv-panel-menu-item-label">${e1.title}</span>\n    </li>\n    `).join("")}\n  </ul>\n</div>\n`),
            noMargin: !0,
            clickHandler: (e1)=>{
                const t = e1 ? $785da19a645c07eb$var$RK(e1, ".psv-panel-menu-item") : void 0, i = t ? t.dataset.psvButton : void 0;
                i && (this.viewer.navbar.getButton(i).onClick(), this.__hideMenu());
            }
        });
    }
    __hideMenu() {
        this.viewer.panel.hide($785da19a645c07eb$var$_K.MENU);
    }
};
function $785da19a645c07eb$var$uY(e1) {
    let t;
    switch(e1){
        case 0:
            t = 90;
            break;
        case 1:
            t = -90;
            break;
        case 3:
            t = 180;
            break;
        default:
            t = 0;
    }
    return $785da19a645c07eb$var$yK.arrow.replace("rotate(0", `rotate(${t}`);
}
$785da19a645c07eb$var$cY.id = "menu";
var $785da19a645c07eb$var$hY = class extends $785da19a645c07eb$var$aY {
    constructor(e1, t){
        super(e1, {
            className: "psv-move-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: $785da19a645c07eb$var$uY(t)
        }), this.direction = t, this.handler = new $785da19a645c07eb$var$zX, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
    }
    destroy() {
        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case "mousedown":
                this.__onMouseDown();
                break;
            case "mouseup":
            case "touchend":
                this.__onMouseUp();
                break;
            case "keydown":
                e1.key === $785da19a645c07eb$var$vK.Enter && this.__onMouseDown();
                break;
            case "keyup":
                e1.key === $785da19a645c07eb$var$vK.Enter && this.__onMouseUp();
        }
    }
    onClick() {}
    isSupported() {
        return $785da19a645c07eb$var$nX($785da19a645c07eb$var$SX.isTouchEnabled);
    }
    __onMouseDown() {
        if (!this.state.enabled) return;
        const e1 = {};
        switch(this.direction){
            case 0:
                e1.pitch = !1;
                break;
            case 1:
                e1.pitch = !0;
                break;
            case 3:
                e1.yaw = !1;
                break;
            default:
                e1.yaw = !0;
        }
        this.viewer.stopAll(), this.viewer.dynamics.position.roll(e1), this.handler.down();
    }
    __onMouseUp() {
        this.state.enabled && this.handler.up(()=>{
            this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer();
        });
    }
};
$785da19a645c07eb$var$hY.groupId = "move";
var $785da19a645c07eb$var$dY = class extends $785da19a645c07eb$var$hY {
    constructor(e1){
        super(e1, 1);
    }
};
$785da19a645c07eb$var$dY.id = "moveDown";
var $785da19a645c07eb$var$pY = class extends $785da19a645c07eb$var$hY {
    constructor(e1){
        super(e1, 2);
    }
};
$785da19a645c07eb$var$pY.id = "moveLeft";
var $785da19a645c07eb$var$mY = class extends $785da19a645c07eb$var$hY {
    constructor(e1){
        super(e1, 3);
    }
};
$785da19a645c07eb$var$mY.id = "moveRight";
var $785da19a645c07eb$var$gY = class extends $785da19a645c07eb$var$hY {
    constructor(e1){
        super(e1, 0);
    }
};
$785da19a645c07eb$var$gY.id = "moveUp";
var $785da19a645c07eb$var$fY = class extends $785da19a645c07eb$var$aY {
    constructor(e1, t, i){
        super(e1, {
            className: "psv-zoom-button",
            hoverScale: !0,
            collapsable: !1,
            tabbable: !0,
            icon: t
        }), this.direction = i, this.handler = new $785da19a645c07eb$var$zX, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
    }
    destroy() {
        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case "mousedown":
                this.__onMouseDown();
                break;
            case "mouseup":
            case "touchend":
                this.__onMouseUp();
                break;
            case "keydown":
                e1.key === $785da19a645c07eb$var$vK.Enter && this.__onMouseDown();
                break;
            case "keyup":
                e1.key === $785da19a645c07eb$var$vK.Enter && this.__onMouseUp();
        }
    }
    onClick() {}
    isSupported() {
        return $785da19a645c07eb$var$nX($785da19a645c07eb$var$SX.isTouchEnabled);
    }
    __onMouseDown() {
        this.state.enabled && (this.viewer.dynamics.zoom.roll(1 === this.direction), this.handler.down());
    }
    __onMouseUp() {
        this.state.enabled && this.handler.up(()=>this.viewer.dynamics.zoom.stop());
    }
};
$785da19a645c07eb$var$fY.groupId = "zoom";
var $785da19a645c07eb$var$AY = class extends $785da19a645c07eb$var$fY {
    constructor(e1){
        super(e1, $785da19a645c07eb$var$yK.zoomIn, 0);
    }
};
$785da19a645c07eb$var$AY.id = "zoomIn";
var $785da19a645c07eb$var$_Y = class extends $785da19a645c07eb$var$fY {
    constructor(e1){
        super(e1, $785da19a645c07eb$var$yK.zoomOut, 1);
    }
};
$785da19a645c07eb$var$_Y.id = "zoomOut";
var $785da19a645c07eb$var$vY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-zoom-range",
            hoverScale: !1,
            collapsable: !1,
            tabbable: !1
        }), this.zoomRange = document.createElement("div"), this.zoomRange.className = "psv-zoom-range-line", this.container.appendChild(this.zoomRange), this.zoomValue = document.createElement("div"), this.zoomValue.className = "psv-zoom-range-handle", this.zoomRange.appendChild(this.zoomValue), this.slider = new $785da19a645c07eb$var$LX(this.container, "HORIZONTAL", (e1)=>this.__onSliderUpdate(e1)), this.mediaMinWidth = parseInt($785da19a645c07eb$var$UK(this.container, "max-width"), 10), this.viewer.addEventListener($785da19a645c07eb$var$VQ.type, this), this.viewer.state.ready ? this.__moveZoomValue(this.viewer.getZoomLevel()) : this.viewer.addEventListener($785da19a645c07eb$var$SQ.type, this);
    }
    destroy() {
        this.slider.destroy(), this.viewer.removeEventListener($785da19a645c07eb$var$VQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$SQ.type, this), super.destroy();
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$VQ ? this.__moveZoomValue(e1.zoomLevel) : e1 instanceof $785da19a645c07eb$var$SQ && this.__moveZoomValue(this.viewer.getZoomLevel());
    }
    onClick() {}
    isSupported() {
        return $785da19a645c07eb$var$nX($785da19a645c07eb$var$SX.isTouchEnabled);
    }
    autoSize() {
        this.state.supported && (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible ? this.hide(!1) : this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible && this.show(!1));
    }
    __moveZoomValue(e1) {
        this.zoomValue.style.left = e1 / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
    }
    __onSliderUpdate(e1) {
        e1.mousedown && this.viewer.zoom(100 * e1.value);
    }
};
$785da19a645c07eb$var$vY.id = "zoomRange", $785da19a645c07eb$var$vY.groupId = "zoom";
var $785da19a645c07eb$var$yY = class extends $785da19a645c07eb$var$UX {
    constructor(e1){
        super(), this.viewer = e1;
    }
    init() {}
    destroy() {}
}, $785da19a645c07eb$var$xY = class extends $785da19a645c07eb$var$yY {
    constructor(e1, t){
        super(e1), this.config = this.constructor.configParser(t);
    }
    setOption(e1, t) {
        this.setOptions({
            [e1]: t
        });
    }
    setOptions(e1) {
        const t = {
            ...this.config,
            ...e1
        }, i = this.constructor, n = i.configParser, a = i.readonlyOptions, r = i.id;
        for (let [i, s] of Object.entries(e1))i in n.defaults ? a.includes(i) ? $785da19a645c07eb$var$sX(`${r}: Option "${i}" cannot be updated`) : (i in n.parsers && (s = n.parsers[i](s, {
            rawConfig: t,
            defValue: n.defaults[i]
        })), this.config[i] = s) : $785da19a645c07eb$var$sX(`${r}: Unknown option "${i}"`);
    }
};
function $785da19a645c07eb$var$bY(e1) {
    if (e1) {
        for (const [, t] of [
            [
                "_",
                e1
            ],
            ...Object.entries(e1)
        ])if (t.prototype instanceof $785da19a645c07eb$var$yY) return $785da19a645c07eb$var$bX(t.id, t.VERSION, "5.15.1"), t;
    }
    return null;
}
$785da19a645c07eb$var$xY.readonlyOptions = [];
var $785da19a645c07eb$var$wY = {
    panorama: null,
    container: null,
    adapter: [
        $785da19a645c07eb$var$eY,
        null
    ],
    plugins: [],
    caption: null,
    description: null,
    downloadUrl: null,
    downloadName: null,
    loadingImg: null,
    loadingTxt: "",
    size: null,
    fisheye: 0,
    minFov: 30,
    maxFov: 90,
    defaultZoomLvl: 50,
    defaultYaw: 0,
    defaultPitch: 0,
    sphereCorrection: null,
    moveSpeed: 1,
    zoomSpeed: 1,
    moveInertia: .8,
    mousewheel: !0,
    mousemove: !0,
    mousewheelCtrlKey: !1,
    touchmoveTwoFingers: !1,
    panoData: null,
    requestHeaders: null,
    canvasBackground: "#000",
    defaultTransition: {
        speed: 1500,
        rotation: !0,
        effect: "fade"
    },
    rendererParameters: {
        alpha: !0,
        antialias: !0
    },
    withCredentials: ()=>!1,
    navbar: [
        "zoom",
        "move",
        "download",
        "description",
        "caption",
        "fullscreen"
    ],
    lang: {
        zoom: "Zoom",
        zoomOut: "Zoom out",
        zoomIn: "Zoom in",
        moveUp: "Move up",
        moveDown: "Move down",
        moveLeft: "Move left",
        moveRight: "Move right",
        description: "Description",
        download: "Download",
        fullscreen: "Fullscreen",
        loading: "Loading...",
        menu: "Menu",
        close: "Close",
        twoFingers: "Use two fingers to navigate",
        ctrlZoom: "Use ctrl + scroll to zoom the image",
        loadError: "The panorama cannot be loaded",
        webglError: "Your browser does not seem to support WebGL"
    },
    keyboard: "fullscreen",
    keyboardActions: {
        [$785da19a645c07eb$var$vK.ArrowUp]: "ROTATE_UP",
        [$785da19a645c07eb$var$vK.ArrowDown]: "ROTATE_DOWN",
        [$785da19a645c07eb$var$vK.ArrowRight]: "ROTATE_RIGHT",
        [$785da19a645c07eb$var$vK.ArrowLeft]: "ROTATE_LEFT",
        [$785da19a645c07eb$var$vK.PageUp]: "ZOOM_IN",
        [$785da19a645c07eb$var$vK.PageDown]: "ZOOM_OUT",
        [$785da19a645c07eb$var$vK.Plus]: "ZOOM_IN",
        [$785da19a645c07eb$var$vK.Minus]: "ZOOM_OUT"
    }
}, $785da19a645c07eb$var$EY = {
    panorama: "Use setPanorama method to change the panorama",
    panoData: "Use setPanorama method to change the panorama",
    container: "Cannot change viewer container",
    adapter: "Cannot change adapter",
    plugins: "Cannot change plugins"
}, $785da19a645c07eb$var$kY = {
    container: (e1)=>{
        if (!e1) throw new $785da19a645c07eb$var$tX("No value given for container.");
        return e1;
    },
    adapter: (e1, { defValue: t })=>{
        if (!(e1 = e1 ? Array.isArray(e1) ? [
            $785da19a645c07eb$var$YQ(e1[0]),
            e1[1]
        ] : [
            $785da19a645c07eb$var$YQ(e1),
            null
        ] : t)[0]) throw new $785da19a645c07eb$var$tX("An undefined value was given for adapter.");
        if (!e1[0].id) throw new $785da19a645c07eb$var$tX("Adapter has no id.");
        return e1;
    },
    defaultYaw: (e1)=>$785da19a645c07eb$var$vX(e1),
    defaultPitch: (e1)=>$785da19a645c07eb$var$vX(e1, !0),
    defaultZoomLvl: (e1)=>$785da19a645c07eb$var$xj.clamp(e1, 0, 100),
    minFov: (e1, { rawConfig: t })=>(t.maxFov < e1 && ($785da19a645c07eb$var$sX("maxFov cannot be lower than minFov"), e1 = t.maxFov), $785da19a645c07eb$var$xj.clamp(e1, 1, 179)),
    maxFov: (e1, { rawConfig: t })=>(e1 < t.minFov && (e1 = t.minFov), $785da19a645c07eb$var$xj.clamp(e1, 1, 179)),
    moveInertia: (e1, { defValue: t })=>!0 === e1 ? t : !1 === e1 ? 0 : e1,
    lang: (e1)=>({
            ...$785da19a645c07eb$var$wY.lang,
            ...e1
        }),
    fisheye: (e1)=>!0 === e1 ? 1 : !1 === e1 ? 0 : $785da19a645c07eb$var$xj.clamp(e1, 0, 2),
    requestHeaders: (e1)=>e1 && "object" == typeof e1 ? ()=>e1 : "function" == typeof e1 ? e1 : null,
    withCredentials: (e1)=>"boolean" == typeof e1 ? ()=>e1 : "function" == typeof e1 ? e1 : ()=>!1,
    defaultTransition: (e1, { defValue: t })=>null === e1 || 0 === e1.speed ? null : {
            ...t,
            ...e1
        },
    rendererParameters: (e1, { defValue: t })=>({
            ...e1,
            ...t
        }),
    plugins: (e1)=>e1.map((e1, t)=>{
            if (!(e1 = Array.isArray(e1) ? [
                $785da19a645c07eb$var$bY(e1[0]),
                e1[1]
            ] : [
                $785da19a645c07eb$var$bY(e1),
                null
            ])[0]) throw new $785da19a645c07eb$var$tX(`An undefined value was given for plugin ${t}.`);
            if (!e1[0].id) throw new $785da19a645c07eb$var$tX(`Plugin ${t} has no id.`);
            return e1;
        }),
    navbar: (e1)=>!1 === e1 ? null : !0 === e1 ? $785da19a645c07eb$var$XK($785da19a645c07eb$var$wY.navbar) : "string" == typeof e1 ? e1.split(/[ ,]/) : e1
}, $785da19a645c07eb$var$SY = $785da19a645c07eb$var$yX($785da19a645c07eb$var$wY, $785da19a645c07eb$var$kY), $785da19a645c07eb$var$MY = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-caption",
            hoverScale: !1,
            collapsable: !1,
            tabbable: !0
        }), this.contentWidth = 0, this.state.width = 0, this.contentElt = document.createElement("div"), this.contentElt.className = "psv-caption-content", this.container.appendChild(this.contentElt), this.setCaption(this.viewer.config.caption);
    }
    hide() {
        this.contentElt.style.display = "none", this.state.visible = !1;
    }
    show() {
        this.contentElt.style.display = "", this.state.visible = !0;
    }
    onClick() {}
    setCaption(e1) {
        this.show(), this.contentElt.innerHTML = e1 ?? "", this.contentElt.innerHTML ? this.contentWidth = this.contentElt.offsetWidth : this.contentWidth = 0, this.autoSize();
    }
    autoSize() {
        this.toggle(this.container.offsetWidth >= this.contentWidth), this.__refreshButton();
    }
    __refreshButton() {
        this.viewer.navbar.getButton($785da19a645c07eb$var$sY.id, !1)?.autoSize(!0);
    }
};
$785da19a645c07eb$var$MY.id = "caption";
var $785da19a645c07eb$var$CY = {}, $785da19a645c07eb$var$TY = {};
function $785da19a645c07eb$var$DY(e1, t) {
    if (!e1.id) throw new $785da19a645c07eb$var$tX("Button id is required");
    if ($785da19a645c07eb$var$CY[e1.id] = e1, e1.groupId && ($785da19a645c07eb$var$TY[e1.groupId] = $785da19a645c07eb$var$TY[e1.groupId] || []).push(e1), t) {
        const i = $785da19a645c07eb$var$wY.navbar;
        switch(t){
            case "start":
                i.unshift(e1.id);
                break;
            case "end":
                i.push(e1.id);
                break;
            default:
                {
                    const [n, a] = t.split(":"), r = i.indexOf(n);
                    if (!n || !a || -1 === r) throw new $785da19a645c07eb$var$tX(`Invalid defaultPosition ${t}`);
                    i.splice(r + ("right" === a ? 1 : 0), 0, e1.id);
                }
        }
    }
}
[
    $785da19a645c07eb$var$_Y,
    $785da19a645c07eb$var$vY,
    $785da19a645c07eb$var$AY,
    $785da19a645c07eb$var$sY,
    $785da19a645c07eb$var$MY,
    $785da19a645c07eb$var$oY,
    $785da19a645c07eb$var$lY,
    $785da19a645c07eb$var$pY,
    $785da19a645c07eb$var$mY,
    $785da19a645c07eb$var$gY,
    $785da19a645c07eb$var$dY
].forEach((e1)=>$785da19a645c07eb$var$DY(e1));
var $785da19a645c07eb$var$PY = class extends $785da19a645c07eb$var$iY {
    constructor(e1){
        super(e1, {
            className: `psv-navbar ${$785da19a645c07eb$var$fK}`
        }), this.collapsed = [], this.state.visible = !1;
    }
    show() {
        this.viewer.container.classList.add("psv--has-navbar"), this.container.classList.add("psv-navbar--open"), this.state.visible = !0;
    }
    hide() {
        this.viewer.container.classList.remove("psv--has-navbar"), this.container.classList.remove("psv-navbar--open"), this.state.visible = !1;
    }
    setButtons(e1) {
        this.children.slice().forEach((e1)=>e1.destroy()), this.children.length = 0, -1 !== e1.indexOf($785da19a645c07eb$var$MY.id) && -1 === e1.indexOf($785da19a645c07eb$var$sY.id) && e1.splice(e1.indexOf($785da19a645c07eb$var$MY.id), 0, $785da19a645c07eb$var$sY.id), e1.forEach((e1)=>{
            "object" == typeof e1 ? new $785da19a645c07eb$var$rY(this, e1) : $785da19a645c07eb$var$CY[e1] ? new $785da19a645c07eb$var$CY[e1](this) : $785da19a645c07eb$var$TY[e1] ? $785da19a645c07eb$var$TY[e1].forEach((e1)=>{
                new e1(this);
            }) : $785da19a645c07eb$var$sX(`Unknown button ${e1}`);
        }), new $785da19a645c07eb$var$cY(this), this.children.forEach((e1)=>{
            e1 instanceof $785da19a645c07eb$var$aY && e1.checkSupported();
        }), this.autoSize();
    }
    setCaption(e1) {
        this.children.some((t)=>t instanceof $785da19a645c07eb$var$MY && (t.setCaption(e1), !0));
    }
    getButton(e1, t = !0) {
        const i = this.children.find((t)=>t instanceof $785da19a645c07eb$var$aY && t.id === e1);
        return !i && t && $785da19a645c07eb$var$sX(`button "${e1}" not found in the navbar`), i;
    }
    focusButton(e1) {
        this.isVisible() && (this.getButton(e1, !1)?.container || this.container.firstElementChild)?.focus();
    }
    autoSize() {
        this.children.forEach((e1)=>{
            e1 instanceof $785da19a645c07eb$var$aY && e1.autoSize();
        });
        const e1 = this.container.offsetWidth;
        let t = 0;
        const i = [];
        this.children.forEach((e1)=>{
            e1.isVisible() && e1 instanceof $785da19a645c07eb$var$aY && (t += e1.width, e1.collapsable && i.push(e1));
        }), 0 !== t && (e1 < t && i.length > 0 ? (i.forEach((e1)=>e1.collapse()), this.collapsed = i, this.getButton($785da19a645c07eb$var$cY.id).show(!1)) : e1 >= t && this.collapsed.length > 0 && (this.collapsed.forEach((e1)=>e1.uncollapse()), this.collapsed = [], this.getButton($785da19a645c07eb$var$cY.id).hide(!1)), this.getButton($785da19a645c07eb$var$MY.id, !1)?.autoSize());
    }
};
$785da19a645c07eb$var$BG.enabled = !1;
var $785da19a645c07eb$var$IY = {
    enabled: !0,
    maxItems: 10,
    ttl: 600,
    items: {},
    purgeInterval: null,
    init () {
        $785da19a645c07eb$var$BG.enabled && ($785da19a645c07eb$var$sX("ThreeJS cache should be disabled"), $785da19a645c07eb$var$BG.enabled = !1), !this.purgeInterval && this.enabled && (this.purgeInterval = setInterval(()=>this.purge(), 6e4));
    },
    add (e1, t, i) {
        this.enabled && t && (this.items[t] = this.items[t] ?? {
            files: {},
            lastAccess: null
        }, this.items[t].files[e1] = i, this.items[t].lastAccess = Date.now());
    },
    get (e1, t) {
        if (this.enabled && t && this.items[t]) return this.items[t].lastAccess = Date.now(), this.items[t].files[e1];
    },
    remove (e1, t) {
        this.enabled && t && this.items[t] && (delete this.items[t].files[e1], 0 === Object.keys(this.items[t].files).length && delete this.items[t]);
    },
    purge () {
        Object.entries(this.items).sort(([, e1], [, t])=>t.lastAccess - e1.lastAccess).forEach(([e1, { lastAccess: t }], i)=>{
            i > 0 && (Date.now() - t >= 1e3 * this.ttl || i >= this.maxItems) && delete this.items[e1];
        });
    }
}, $785da19a645c07eb$var$FY = class extends $785da19a645c07eb$var$iY {
    constructor(e1){
        super(e1, {
            className: "psv-loader-container"
        }), this.loader = document.createElement("div"), this.loader.className = "psv-loader", this.container.appendChild(this.loader), this.size = this.loader.offsetWidth, this.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.canvas.setAttribute("class", "psv-loader-canvas"), this.canvas.setAttribute("viewBox", `0 0 ${this.size} ${this.size}`), this.loader.appendChild(this.canvas), this.textColor = $785da19a645c07eb$var$UK(this.loader, "color"), this.color = $785da19a645c07eb$var$UK(this.canvas, "color"), this.border = parseInt($785da19a645c07eb$var$UK(this.loader, "--psv-loader-border"), 10), this.thickness = parseInt($785da19a645c07eb$var$UK(this.loader, "--psv-loader-tickness"), 10);
        const t = this.size / 2;
        this.canvas.innerHTML = `\n            <circle cx="${t}" cy="${t}" r="${t}" fill="${this.color}"/>\n            <path d="" fill="none" stroke="${this.textColor}" stroke-width="${this.thickness}" stroke-linecap="round"/>\n        `, this.viewer.addEventListener($785da19a645c07eb$var$QX.type, this), this.__updateContent(), this.hide();
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$QX.type, this), super.destroy();
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$QX && e1.containsOptions("loadingImg", "loadingTxt", "lang") && this.__updateContent();
    }
    setProgress(e1) {
        this.container.classList.remove("psv-loader--undefined");
        const t = $785da19a645c07eb$var$xj.clamp(e1, 0, 99.999) / 100 * Math.PI * 2, i = this.size / 2, n = i, a = this.thickness / 2 + this.border, r = (this.size - this.thickness) / 2 - this.border, s = Math.sin(t) * r + i, o = -Math.cos(t) * r + i, l = e1 > 50 ? "1" : "0";
        this.canvas.querySelector("path").setAttributeNS(null, "d", `M ${n} ${a} A ${r} ${r} 0 ${l} 1 ${s} ${o}`);
    }
    showUndefined() {
        this.show(), this.setProgress(25), this.container.classList.add("psv-loader--undefined");
    }
    __updateContent() {
        const e1 = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
        let t;
        if (e1 && this.loader.removeChild(e1), this.viewer.config.loadingImg ? (t = document.createElement("img"), t.className = "psv-loader-image", t.src = this.viewer.config.loadingImg) : null !== this.viewer.config.loadingTxt && (t = document.createElement("div"), t.className = "psv-loader-text", t.innerHTML = this.viewer.config.loadingTxt || this.viewer.config.lang.loading), t) {
            const e1 = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
            t.style.maxWidth = e1 + "px", t.style.maxHeight = e1 + "px", this.loader.appendChild(t);
        }
    }
}, $785da19a645c07eb$var$zY = class extends $785da19a645c07eb$var$iY {
    constructor(e1){
        super(e1, {
            className: "psv-notification"
        }), this.state = {
            visible: !1,
            contentId: null,
            timeout: null
        }, this.content = document.createElement("div"), this.content.className = "psv-notification-content", this.container.appendChild(this.content), this.content.addEventListener("click", ()=>this.hide());
    }
    isVisible(e1) {
        return this.state.visible && (!e1 || !this.state.contentId || this.state.contentId === e1);
    }
    toggle() {
        throw new $785da19a645c07eb$var$tX("Notification cannot be toggled");
    }
    show(e1) {
        this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null), "string" == typeof e1 && (e1 = {
            content: e1
        }), this.state.contentId = e1.id || null, this.content.innerHTML = e1.content, this.container.classList.add("psv-notification--visible"), this.state.visible = !0, this.viewer.dispatchEvent(new $785da19a645c07eb$var$DQ(this.state.contentId)), e1.timeout && (this.state.timeout = setTimeout(()=>this.hide(this.state.contentId), e1.timeout));
    }
    hide(e1) {
        if (this.isVisible(e1)) {
            const e1 = this.state.contentId;
            this.container.classList.remove("psv-notification--visible"), this.state.visible = !1, this.state.contentId = null, this.viewer.dispatchEvent(new $785da19a645c07eb$var$iQ(e1));
        }
    }
}, $785da19a645c07eb$var$RY = class extends $785da19a645c07eb$var$iY {
    constructor(e1){
        super(e1, {
            className: `psv-overlay ${$785da19a645c07eb$var$fK}`
        }), this.state = {
            visible: !1,
            contentId: null,
            dismissible: !0
        }, this.image = document.createElement("div"), this.image.className = "psv-overlay-image", this.container.appendChild(this.image), this.title = document.createElement("div"), this.title.className = "psv-overlay-title", this.container.appendChild(this.title), this.text = document.createElement("div"), this.text.className = "psv-overlay-text", this.container.appendChild(this.text), this.container.addEventListener("click", this), this.viewer.addEventListener($785da19a645c07eb$var$uQ.type, this), super.hide();
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$uQ.type, this), super.destroy();
    }
    handleEvent(e1) {
        "click" === e1.type ? this.isVisible() && this.state.dismissible && (this.hide(), e1.stopPropagation()) : e1 instanceof $785da19a645c07eb$var$uQ && this.isVisible() && this.state.dismissible && e1.matches($785da19a645c07eb$var$vK.Escape) && (this.hide(), e1.preventDefault());
    }
    isVisible(e1) {
        return this.state.visible && (!e1 || !this.state.contentId || this.state.contentId === e1);
    }
    toggle() {
        throw new $785da19a645c07eb$var$tX("Overlay cannot be toggled");
    }
    show(e1) {
        "string" == typeof e1 && (e1 = {
            title: e1
        }), this.state.contentId = e1.id || null, this.state.dismissible = !1 !== e1.dismissible, this.image.innerHTML = e1.image || "", this.title.innerHTML = e1.title || "", this.text.innerHTML = e1.text || "", super.show(), this.viewer.dispatchEvent(new $785da19a645c07eb$var$IQ(this.state.contentId));
    }
    hide(e1) {
        if (this.isVisible(e1)) {
            const e1 = this.state.contentId;
            super.hide(), this.state.contentId = null, this.viewer.dispatchEvent(new $785da19a645c07eb$var$aQ(e1));
        }
    }
}, $785da19a645c07eb$var$LY = "psv-panel-content--no-interaction", $785da19a645c07eb$var$BY = class extends $785da19a645c07eb$var$iY {
    constructor(e1){
        super(e1, {
            className: `psv-panel ${$785da19a645c07eb$var$fK}`
        }), this.state = {
            visible: !1,
            contentId: null,
            mouseX: 0,
            mouseY: 0,
            mousedown: !1,
            clickHandler: null,
            keyHandler: null,
            width: {}
        };
        const t = document.createElement("div");
        t.className = "psv-panel-resizer", this.container.appendChild(t);
        const i = document.createElement("div");
        i.className = "psv-panel-close-button", i.innerHTML = $785da19a645c07eb$var$yK.close, i.title = e1.config.lang.close, this.container.appendChild(i), this.content = document.createElement("div"), this.content.className = "psv-panel-content", this.container.appendChild(this.content), i.addEventListener("click", ()=>this.hide()), t.addEventListener("mousedown", this), t.addEventListener("touchstart", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this), this.viewer.container.addEventListener("mousemove", this), this.viewer.container.addEventListener("touchmove", this), this.viewer.addEventListener($785da19a645c07eb$var$uQ.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$uQ.type, this), this.viewer.container.removeEventListener("mousemove", this), this.viewer.container.removeEventListener("touchmove", this), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case "mousedown":
                this.__onMouseDown(e1);
                break;
            case "touchstart":
                this.__onTouchStart(e1);
                break;
            case "mousemove":
                this.__onMouseMove(e1);
                break;
            case "touchmove":
                this.__onTouchMove(e1);
                break;
            case "mouseup":
                this.__onMouseUp(e1);
                break;
            case "touchend":
                this.__onTouchEnd(e1);
                break;
            case $785da19a645c07eb$var$uQ.type:
                this.__onKeyPress(e1);
        }
    }
    isVisible(e1) {
        return this.state.visible && (!e1 || !this.state.contentId || this.state.contentId === e1);
    }
    toggle() {
        throw new $785da19a645c07eb$var$tX("Panel cannot be toggled");
    }
    show(e1) {
        "string" == typeof e1 && (e1 = {
            content: e1
        });
        const t = this.isVisible(e1.id);
        this.state.contentId = e1.id || null, this.state.visible = !0, this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), e1.id && this.state.width[e1.id] ? this.container.style.width = this.state.width[e1.id] : e1.width ? this.container.style.width = e1.width : this.container.style.width = null, this.content.innerHTML = e1.content, this.content.scrollTop = 0, this.container.classList.add("psv-panel--open"), $785da19a645c07eb$var$PK(this.content, "psv-panel-content--no-margin", !0 === e1.noMargin), e1.clickHandler && (this.state.clickHandler = (t)=>{
            e1.clickHandler($785da19a645c07eb$var$LK(t));
        }, this.state.keyHandler = (t)=>{
            t.key === $785da19a645c07eb$var$vK.Enter && e1.clickHandler($785da19a645c07eb$var$LK(t));
        }, this.content.addEventListener("click", this.state.clickHandler), this.content.addEventListener("keydown", this.state.keyHandler), t || setTimeout(()=>{
            this.content.querySelector("a,button,[tabindex]")?.focus();
        }, 300)), this.viewer.dispatchEvent(new $785da19a645c07eb$var$zQ(this.state.contentId));
    }
    hide(e1) {
        if (this.isVisible(e1)) {
            const e1 = this.state.contentId;
            this.state.visible = !1, this.state.contentId = null, this.content.innerHTML = null, this.container.classList.remove("psv-panel--open"), this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), this.viewer.dispatchEvent(new $785da19a645c07eb$var$sQ(e1));
        }
    }
    __onMouseDown(e1) {
        e1.stopPropagation(), this.__startResize(e1.clientX, e1.clientY);
    }
    __onTouchStart(e1) {
        if (e1.stopPropagation(), 1 === e1.touches.length) {
            const t = e1.touches[0];
            this.__startResize(t.clientX, t.clientY);
        }
    }
    __onMouseUp(e1) {
        this.state.mousedown && (e1.stopPropagation(), this.state.mousedown = !1, this.content.classList.remove($785da19a645c07eb$var$LY));
    }
    __onTouchEnd(e1) {
        this.state.mousedown && (e1.stopPropagation(), 0 === e1.touches.length && (this.state.mousedown = !1, this.content.classList.remove($785da19a645c07eb$var$LY)));
    }
    __onMouseMove(e1) {
        this.state.mousedown && (e1.stopPropagation(), this.__resize(e1.clientX, e1.clientY));
    }
    __onTouchMove(e1) {
        if (this.state.mousedown) {
            const t = e1.touches[0];
            this.__resize(t.clientX, t.clientY);
        }
    }
    __onKeyPress(e1) {
        this.isVisible() && e1.matches($785da19a645c07eb$var$vK.Escape) && (this.hide(), e1.preventDefault());
    }
    __startResize(e1, t) {
        this.state.mouseX = e1, this.state.mouseY = t, this.state.mousedown = !0, this.content.classList.add($785da19a645c07eb$var$LY);
    }
    __resize(e1, t) {
        const i = e1, n = t, a = Math.max(200, this.container.offsetWidth - (i - this.state.mouseX)) + "px";
        this.state.contentId && (this.state.width[this.state.contentId] = a), this.container.style.width = a, this.state.mouseX = i, this.state.mouseY = n;
    }
}, $785da19a645c07eb$var$OY = class extends $785da19a645c07eb$var$iY {
    constructor(e1, t){
        super(e1, {
            className: "psv-tooltip"
        }), this.state = {
            visible: !0,
            arrow: 0,
            border: 0,
            state: 0,
            width: 0,
            height: 0,
            pos: "",
            config: null,
            data: null,
            hideTimeout: null
        }, this.content = document.createElement("div"), this.content.className = "psv-tooltip-content", this.container.appendChild(this.content), this.arrow = document.createElement("div"), this.arrow.className = "psv-tooltip-arrow", this.container.appendChild(this.arrow), this.container.addEventListener("transitionend", this), this.container.addEventListener("touchdown", (e1)=>e1.stopPropagation()), this.container.addEventListener("mousedown", (e1)=>e1.stopPropagation()), this.container.style.top = "-1000px", this.container.style.left = "-1000px", this.show(t);
    }
    handleEvent(e1) {
        "transitionend" === e1.type && this.__onTransitionEnd(e1);
    }
    destroy() {
        clearTimeout(this.state.hideTimeout), delete this.state.data, super.destroy();
    }
    toggle() {
        throw new $785da19a645c07eb$var$tX("Tooltip cannot be toggled");
    }
    show(e1) {
        if (0 !== this.state.state) throw new $785da19a645c07eb$var$tX("Initialized tooltip cannot be re-initialized");
        e1.className && $785da19a645c07eb$var$IK(this.container, e1.className), e1.style && Object.assign(this.container.style, e1.style), this.state.state = 3, this.update(e1.content, e1), this.state.data = e1.data, this.state.state = 1, this.viewer.dispatchEvent(new $785da19a645c07eb$var$LQ(this, this.state.data)), this.__waitImages();
    }
    update(e1, t) {
        this.content.innerHTML = e1;
        const i = this.container.getBoundingClientRect();
        this.state.width = i.right - i.left, this.state.height = i.bottom - i.top, this.state.arrow = parseInt($785da19a645c07eb$var$UK(this.arrow, "border-top-width"), 10), this.state.border = parseInt($785da19a645c07eb$var$UK(this.container, "border-top-left-radius"), 10), this.move(t ?? this.state.config), this.__waitImages();
    }
    move(e1) {
        if (1 !== this.state.state && 3 !== this.state.state) throw new $785da19a645c07eb$var$tX("Uninitialized tooltip cannot be moved");
        e1.box = e1.box ?? this.state.config?.box ?? {
            width: 0,
            height: 0
        }, this.state.config = e1;
        const t = this.container, i = this.arrow, n = {
            posClass: $785da19a645c07eb$var$gX(e1.position, {
                allowCenter: !1,
                cssOrder: !1
            }) || [
                "top",
                "center"
            ],
            width: this.state.width,
            height: this.state.height,
            top: 0,
            left: 0,
            arrowTop: 0,
            arrowLeft: 0
        };
        this.__computeTooltipPosition(n, e1);
        let a = null, r = null;
        if (n.top < 0 ? a = "bottom" : n.top + n.height > this.viewer.state.size.height && (a = "top"), n.left < 0 ? r = "right" : n.left + n.width > this.viewer.state.size.width && (r = "left"), r || a) {
            const t = $785da19a645c07eb$var$fX(n.posClass);
            a && (n.posClass[t ? 0 : 1] = a), r && (n.posClass[t ? 1 : 0] = r), this.__computeTooltipPosition(n, e1);
        }
        t.style.top = n.top + "px", t.style.left = n.left + "px", i.style.top = n.arrowTop + "px", i.style.left = n.arrowLeft + "px";
        const s = n.posClass.join("-");
        s !== this.state.pos && (t.classList.remove(`psv-tooltip--${this.state.pos}`), this.state.pos = s, t.classList.add(`psv-tooltip--${this.state.pos}`));
    }
    hide() {
        this.container.classList.remove("psv-tooltip--visible"), this.state.state = 2, this.viewer.dispatchEvent(new $785da19a645c07eb$var$lQ(this.state.data));
        const e1 = parseFloat($785da19a645c07eb$var$UK(this.container, "transition-duration"));
        this.state.hideTimeout = setTimeout(()=>{
            this.destroy();
        }, 2 * e1);
    }
    __onTransitionEnd(e1) {
        if ("transform" === e1.propertyName) switch(this.state.state){
            case 1:
                this.container.classList.add("psv-tooltip--visible"), this.state.state = 3;
                break;
            case 2:
                this.state.state = 0, this.destroy();
        }
    }
    __computeTooltipPosition(e1, t) {
        const i = this.state.arrow, n = t.top, a = e1.height, r = t.left, s = e1.width, o = i + this.state.border, l = t.box.width / 2 + 2 * i, c = t.box.height / 2 + 2 * i;
        switch(e1.posClass.join("-")){
            case "top-left":
                e1.top = n - c - a, e1.left = r + o - s, e1.arrowTop = a, e1.arrowLeft = s - o - i;
                break;
            case "top-center":
                e1.top = n - c - a, e1.left = r - s / 2, e1.arrowTop = a, e1.arrowLeft = s / 2 - i;
                break;
            case "top-right":
                e1.top = n - c - a, e1.left = r - o, e1.arrowTop = a, e1.arrowLeft = i;
                break;
            case "bottom-left":
                e1.top = n + c, e1.left = r + o - s, e1.arrowTop = 2 * -i, e1.arrowLeft = s - o - i;
                break;
            case "bottom-center":
                e1.top = n + c, e1.left = r - s / 2, e1.arrowTop = 2 * -i, e1.arrowLeft = s / 2 - i;
                break;
            case "bottom-right":
                e1.top = n + c, e1.left = r - o, e1.arrowTop = 2 * -i, e1.arrowLeft = i;
                break;
            case "left-top":
                e1.top = n + o - a, e1.left = r - l - s, e1.arrowTop = a - o - i, e1.arrowLeft = s;
                break;
            case "center-left":
                e1.top = n - a / 2, e1.left = r - l - s, e1.arrowTop = a / 2 - i, e1.arrowLeft = s;
                break;
            case "left-bottom":
                e1.top = n - o, e1.left = r - l - s, e1.arrowTop = i, e1.arrowLeft = s;
                break;
            case "right-top":
                e1.top = n + o - a, e1.left = r + l, e1.arrowTop = a - o - i, e1.arrowLeft = 2 * -i;
                break;
            case "center-right":
                e1.top = n - a / 2, e1.left = r + l, e1.arrowTop = a / 2 - i, e1.arrowLeft = 2 * -i;
                break;
            case "right-bottom":
                e1.top = n - o, e1.left = r + l, e1.arrowTop = i, e1.arrowLeft = 2 * -i;
        }
    }
    __waitImages() {
        const e1 = this.content.querySelectorAll("img");
        if (e1.length > 0) {
            const t = [];
            e1.forEach((e1)=>{
                e1.complete || t.push(new Promise((t)=>{
                    e1.onload = t, e1.onerror = t;
                }));
            }), t.length && Promise.all(t).then(()=>{
                if (1 === this.state.state || 3 === this.state.state) {
                    const e1 = this.container.getBoundingClientRect();
                    this.state.width = e1.right - e1.left, this.state.height = e1.bottom - e1.top, this.move(this.state.config);
                }
            });
        }
    }
}, $785da19a645c07eb$var$UY = class {
    constructor(e1){
        this.viewer = e1, this.config = e1.config, this.state = e1.state;
    }
    destroy() {}
}, $785da19a645c07eb$var$NY = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$jY = new $785da19a645c07eb$var$aV(0, 0, 0, "ZXY"), $785da19a645c07eb$var$VY = class extends $785da19a645c07eb$var$UY {
    constructor(e1){
        super(e1);
    }
    fovToZoomLevel(e1) {
        const t = Math.round((e1 - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
        return $785da19a645c07eb$var$xj.clamp(t - 2 * (t - 50), 0, 100);
    }
    zoomLevelToFov(e1) {
        return this.config.maxFov + e1 / 100 * (this.config.minFov - this.config.maxFov);
    }
    vFovToHFov(e1) {
        return $785da19a645c07eb$var$xj.radToDeg(2 * Math.atan(Math.tan($785da19a645c07eb$var$xj.degToRad(e1) / 2) * this.state.aspect));
    }
    hFovToVFov(e1) {
        return $785da19a645c07eb$var$xj.radToDeg(2 * Math.atan(Math.tan($785da19a645c07eb$var$xj.degToRad(e1) / 2) / this.state.aspect));
    }
    getAnimationProperties(e1, t, i) {
        const n = !$785da19a645c07eb$var$YK(t), a = !$785da19a645c07eb$var$YK(i), r = {};
        let s = null;
        if (n) {
            const i = this.viewer.getPosition(), n = $785da19a645c07eb$var$MK(i.yaw, t.yaw);
            r.yaw = {
                start: i.yaw,
                end: i.yaw + n
            }, r.pitch = {
                start: i.pitch,
                end: t.pitch
            }, s = $785da19a645c07eb$var$_X(e1, $785da19a645c07eb$var$CK(i, t));
        }
        if (a) {
            const t = this.viewer.getZoomLevel(), n = Math.abs(i - t);
            r.zoom = {
                start: t,
                end: i
            }, null === s && (s = $785da19a645c07eb$var$_X(e1, Math.PI / 4 * n / 100));
        }
        return s = null === s ? "number" == typeof e1 ? e1 : $785da19a645c07eb$var$lK : Math.max($785da19a645c07eb$var$lK, s), {
            duration: s,
            properties: r
        };
    }
    getTransitionOptions(e1) {
        let t;
        const i = this.config.defaultTransition ?? $785da19a645c07eb$var$wY.defaultTransition;
        return t = !1 === e1.transition || null === e1.transition ? null : !0 === e1.transition ? {
            ...i
        } : "object" == typeof e1.transition ? {
            ...i,
            ...e1.transition
        } : this.config.defaultTransition, t;
    }
    textureCoordsToSphericalCoords(e1) {
        if (!this.state.textureData?.panoData) throw new $785da19a645c07eb$var$tX("Current adapter does not support texture coordinates or no texture has been loaded");
        const t = this.viewer.adapter.textureCoordsToSphericalCoords(e1, this.state.textureData.panoData);
        return $785da19a645c07eb$var$jY.equals(this.viewer.renderer.panoramaPose) && $785da19a645c07eb$var$jY.equals(this.viewer.renderer.sphereCorrection) ? t : (this.sphericalCoordsToVector3(t, $785da19a645c07eb$var$NY), $785da19a645c07eb$var$NY.applyEuler(this.viewer.renderer.panoramaPose), $785da19a645c07eb$var$NY.applyEuler(this.viewer.renderer.sphereCorrection), this.vector3ToSphericalCoords($785da19a645c07eb$var$NY));
    }
    sphericalCoordsToTextureCoords(e1) {
        if (!this.state.textureData?.panoData) throw new $785da19a645c07eb$var$tX("Current adapter does not support texture coordinates or no texture has been loaded");
        return $785da19a645c07eb$var$jY.equals(this.viewer.renderer.panoramaPose) && $785da19a645c07eb$var$jY.equals(this.viewer.renderer.sphereCorrection) || (this.sphericalCoordsToVector3(e1, $785da19a645c07eb$var$NY), $785da19a645c07eb$var$DX($785da19a645c07eb$var$NY, this.viewer.renderer.sphereCorrection), $785da19a645c07eb$var$DX($785da19a645c07eb$var$NY, this.viewer.renderer.panoramaPose), e1 = this.vector3ToSphericalCoords($785da19a645c07eb$var$NY)), this.viewer.adapter.sphericalCoordsToTextureCoords(e1, this.state.textureData.panoData);
    }
    sphericalCoordsToVector3(e1, t, i = $785da19a645c07eb$var$mK) {
        return t || (t = new $785da19a645c07eb$var$Ej), t.x = i * -Math.cos(e1.pitch) * Math.sin(e1.yaw), t.y = i * Math.sin(e1.pitch), t.z = i * Math.cos(e1.pitch) * Math.cos(e1.yaw), t;
    }
    vector3ToSphericalCoords(e1) {
        const t = Math.acos(e1.y / Math.sqrt(e1.x * e1.x + e1.y * e1.y + e1.z * e1.z)), i = Math.atan2(e1.x, e1.z);
        return {
            yaw: i < 0 ? -i : 2 * Math.PI - i,
            pitch: Math.PI / 2 - t
        };
    }
    viewerCoordsToVector3(e1) {
        const t = this.viewer.renderer.getIntersections(e1).filter((e1)=>e1.object.userData[$785da19a645c07eb$var$gK]);
        return t.length ? t[0].point : null;
    }
    viewerCoordsToSphericalCoords(e1) {
        const t = this.viewerCoordsToVector3(e1);
        return t ? this.vector3ToSphericalCoords(t) : null;
    }
    vector3ToViewerCoords(e1) {
        const t = e1.clone();
        return t.project(this.viewer.renderer.camera), {
            x: Math.round((t.x + 1) / 2 * this.state.size.width),
            y: Math.round((1 - t.y) / 2 * this.state.size.height)
        };
    }
    sphericalCoordsToViewerCoords(e1) {
        return this.sphericalCoordsToVector3(e1, $785da19a645c07eb$var$NY), this.vector3ToViewerCoords($785da19a645c07eb$var$NY);
    }
    isPointVisible(e1) {
        let t, i;
        if (e1 instanceof $785da19a645c07eb$var$Ej) t = e1, i = this.vector3ToViewerCoords(e1);
        else {
            if (!$785da19a645c07eb$var$oX(e1)) return !1;
            t = this.sphericalCoordsToVector3(e1, $785da19a645c07eb$var$NY), i = this.vector3ToViewerCoords(t);
        }
        return t.dot(this.viewer.state.direction) > 0 && i.x >= 0 && i.x <= this.viewer.state.size.width && i.y >= 0 && i.y <= this.viewer.state.size.height;
    }
    cleanPosition(e1) {
        if ("yaw" in e1 || "pitch" in e1) {
            if (!("yaw" in e1) || !("pitch" in e1)) throw new $785da19a645c07eb$var$tX("Position is missing 'yaw' or 'pitch'");
            return {
                yaw: $785da19a645c07eb$var$vX(e1.yaw),
                pitch: $785da19a645c07eb$var$vX(e1.pitch, !0)
            };
        }
        return this.textureCoordsToSphericalCoords(e1);
    }
    cleanSphereCorrection(e1) {
        return {
            pan: $785da19a645c07eb$var$vX(e1?.pan || 0),
            tilt: $785da19a645c07eb$var$vX(e1?.tilt || 0, !0),
            roll: $785da19a645c07eb$var$vX(e1?.roll || 0, !0, !1)
        };
    }
    cleanPanoramaPose(e1) {
        return {
            pan: $785da19a645c07eb$var$xj.degToRad(e1?.poseHeading || 0),
            tilt: $785da19a645c07eb$var$xj.degToRad(e1?.posePitch || 0),
            roll: $785da19a645c07eb$var$xj.degToRad(e1?.poseRoll || 0)
        };
    }
    cleanPanoramaOptions(e1, t) {
        return t?.isEquirectangular ? ($785da19a645c07eb$var$YK(e1.zoom) && !$785da19a645c07eb$var$YK(t.initialFov) && (e1 = {
            ...e1,
            zoom: this.fovToZoomLevel(this.hFovToVFov(t.initialFov))
        }), !$785da19a645c07eb$var$YK(e1.position) || $785da19a645c07eb$var$YK(t.initialHeading) || $785da19a645c07eb$var$YK(t.initialPitch) || (e1 = {
            ...e1,
            position: {
                yaw: $785da19a645c07eb$var$xj.degToRad(t.initialHeading),
                pitch: $785da19a645c07eb$var$xj.degToRad(t.initialPitch)
            }
        }), e1) : e1;
    }
}, $785da19a645c07eb$var$qY = class e1 {
    constructor(){
        this.$ = e1.IDLE;
    }
    is(...e1) {
        return e1.some((e1)=>this.$ & e1);
    }
    set(e1) {
        this.$ = e1;
    }
    add(e1) {
        this.$ |= e1;
    }
    remove(e1) {
        this.$ &= ~e1;
    }
};
$785da19a645c07eb$var$qY.IDLE = 0, $785da19a645c07eb$var$qY.CLICK = 1, $785da19a645c07eb$var$qY.MOVING = 2;
var $785da19a645c07eb$var$GY = $785da19a645c07eb$var$qY, $785da19a645c07eb$var$HY = class extends $785da19a645c07eb$var$UY {
    constructor(e1){
        super(e1), this.data = {
            startMouseX: 0,
            startMouseY: 0,
            mouseX: 0,
            mouseY: 0,
            pinchDist: 0,
            moveDelta: {
                yaw: 0,
                pitch: 0,
                zoom: 0
            },
            accumulatorFactor: 0,
            ctrlKeyDown: !1,
            dblclickData: null,
            dblclickTimeout: null,
            longtouchTimeout: null,
            twofingersTimeout: null,
            ctrlZoomTimeout: null
        }, this.step = new $785da19a645c07eb$var$GY, this.keyHandler = new $785da19a645c07eb$var$zX, this.resizeObserver = new ResizeObserver($785da19a645c07eb$var$WK(()=>this.viewer.autoSize(), 50)), this.moveThreshold = $785da19a645c07eb$var$cK * $785da19a645c07eb$var$SX.pixelRatio;
    }
    init() {
        window.addEventListener("keydown", this, {
            passive: !1
        }), window.addEventListener("keyup", this), this.viewer.container.addEventListener("mousedown", this), window.addEventListener("mousemove", this, {
            passive: !1
        }), window.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchstart", this, {
            passive: !1
        }), window.addEventListener("touchmove", this, {
            passive: !1
        }), window.addEventListener("touchend", this, {
            passive: !1
        }), this.viewer.container.addEventListener("wheel", this, {
            passive: !1
        }), document.addEventListener("fullscreenchange", this), this.resizeObserver.observe(this.viewer.container), this.viewer.addEventListener($785da19a645c07eb$var$GX.type, this), this.viewer.addEventListener($785da19a645c07eb$var$NQ.type, this);
    }
    destroy() {
        window.removeEventListener("keydown", this), window.removeEventListener("keyup", this), this.viewer.container.removeEventListener("mousedown", this), window.removeEventListener("mousemove", this), window.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), this.viewer.container.removeEventListener("wheel", this), document.removeEventListener("fullscreenchange", this), this.resizeObserver.disconnect(), this.viewer.removeEventListener($785da19a645c07eb$var$GX.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$NQ.type, this), clearTimeout(this.data.dblclickTimeout), clearTimeout(this.data.longtouchTimeout), clearTimeout(this.data.twofingersTimeout), clearTimeout(this.data.ctrlZoomTimeout), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case "keydown":
                this.__onKeyDown(e1);
                break;
            case "keyup":
                this.__onKeyUp();
                break;
            case "mousemove":
                this.__onMouseMove(e1);
                break;
            case "mouseup":
                this.__onMouseUp(e1);
                break;
            case "touchmove":
                this.__onTouchMove(e1);
                break;
            case "touchend":
                this.__onTouchEnd(e1);
                break;
            case "fullscreenchange":
                this.__onFullscreenChange();
                break;
            case $785da19a645c07eb$var$GX.type:
                this.__applyMoveDelta();
                break;
            case $785da19a645c07eb$var$NQ.type:
                this.__clearMoveDelta();
        }
        if (!$785da19a645c07eb$var$BK(e1, "." + $785da19a645c07eb$var$fK)) switch(e1.type){
            case "mousedown":
                this.__onMouseDown(e1);
                break;
            case "touchstart":
                this.__onTouchStart(e1);
                break;
            case "wheel":
                this.__onMouseWheel(e1);
        }
    }
    __onKeyDown(e1) {
        if (this.config.mousewheelCtrlKey && (this.data.ctrlKeyDown = e1.key === $785da19a645c07eb$var$vK.Control, this.data.ctrlKeyDown && (clearTimeout(this.data.ctrlZoomTimeout), this.viewer.overlay.hide($785da19a645c07eb$var$_K.CTRL_ZOOM))), this.viewer.dispatchEvent(new $785da19a645c07eb$var$uQ(e1.key, e1)) && this.state.keyboardEnabled && this.config.keyboardActions && !this.keyHandler.pending) {
            for (const [t, i] of Object.entries(this.config.keyboardActions))if ($785da19a645c07eb$var$GK(e1, t)) {
                if ("function" == typeof i) i(this.viewer, e1);
                else {
                    switch("ZOOM_IN" !== i && "ZOOM_OUT" !== i && this.viewer.stopAll(), i){
                        case "ROTATE_UP":
                            this.viewer.dynamics.position.roll({
                                pitch: !1
                            });
                            break;
                        case "ROTATE_DOWN":
                            this.viewer.dynamics.position.roll({
                                pitch: !0
                            });
                            break;
                        case "ROTATE_RIGHT":
                            this.viewer.dynamics.position.roll({
                                yaw: !1
                            });
                            break;
                        case "ROTATE_LEFT":
                            this.viewer.dynamics.position.roll({
                                yaw: !0
                            });
                            break;
                        case "ZOOM_IN":
                            this.viewer.dynamics.zoom.roll(!1);
                            break;
                        case "ZOOM_OUT":
                            this.viewer.dynamics.zoom.roll(!0);
                    }
                    this.keyHandler.down(i);
                }
                return void e1.preventDefault();
            }
        }
    }
    __onKeyUp() {
        this.data.ctrlKeyDown = !1, this.state.keyboardEnabled && this.keyHandler.up((e1)=>{
            "ZOOM_IN" === e1 || "ZOOM_OUT" === e1 ? this.viewer.dynamics.zoom.stop() : (this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer());
        });
    }
    __onMouseDown(e1) {
        this.step.add($785da19a645c07eb$var$GY.CLICK), this.data.startMouseX = e1.clientX, this.data.startMouseY = e1.clientY, this.config.mousemove && e1.preventDefault();
    }
    __onMouseUp(e1) {
        this.step.is($785da19a645c07eb$var$GY.CLICK, $785da19a645c07eb$var$GY.MOVING) && this.__stopMove(e1.clientX, e1.clientY, e1, 2 === e1.button);
    }
    __onMouseMove(e1) {
        this.config.mousemove && this.step.is($785da19a645c07eb$var$GY.CLICK, $785da19a645c07eb$var$GY.MOVING) && (e1.preventDefault(), this.__doMove(e1.clientX, e1.clientY)), this.__handleObjectsEvents(e1);
    }
    __onTouchStart(e1) {
        1 === e1.touches.length ? (this.step.add($785da19a645c07eb$var$GY.CLICK), this.data.startMouseX = e1.touches[0].clientX, this.data.startMouseY = e1.touches[0].clientY, this.data.longtouchTimeout || (this.data.longtouchTimeout = setTimeout(()=>{
            const t = e1.touches[0];
            this.__stopMove(t.clientX, t.clientY, e1, !0), this.data.longtouchTimeout = null;
        }, $785da19a645c07eb$var$hK))) : 2 === e1.touches.length && (this.step.set($785da19a645c07eb$var$GY.IDLE), this.__cancelLongTouch(), this.config.mousemove && (this.__cancelTwoFingersOverlay(), this.__startMoveZoom(e1), e1.preventDefault()));
    }
    __onTouchEnd(e1) {
        if (this.__cancelLongTouch(), this.step.is($785da19a645c07eb$var$GY.CLICK, $785da19a645c07eb$var$GY.MOVING)) {
            if (e1.preventDefault(), this.__cancelTwoFingersOverlay(), 1 === e1.touches.length) this.__stopMove(this.data.mouseX, this.data.mouseY);
            else if (0 === e1.touches.length) {
                const t = e1.changedTouches[0];
                this.__stopMove(t.clientX, t.clientY, e1);
            }
        }
    }
    __onTouchMove(e1) {
        if (this.__cancelLongTouch(), this.config.mousemove) {
            if (1 === e1.touches.length) {
                if (this.config.touchmoveTwoFingers) this.step.is($785da19a645c07eb$var$GY.CLICK) && !this.data.twofingersTimeout && (this.data.twofingersTimeout = setTimeout(()=>{
                    this.viewer.overlay.show({
                        id: $785da19a645c07eb$var$_K.TWO_FINGERS,
                        image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/>\x3c!--Created by AomAm from the Noun Project--\x3e</svg>\n',
                        title: this.config.lang.twoFingers
                    });
                }, $785da19a645c07eb$var$dK));
                else if (this.step.is($785da19a645c07eb$var$GY.CLICK, $785da19a645c07eb$var$GY.MOVING)) {
                    e1.preventDefault();
                    const t = e1.touches[0];
                    this.__doMove(t.clientX, t.clientY);
                }
            } else this.__doMoveZoom(e1), this.__cancelTwoFingersOverlay();
        }
    }
    __cancelLongTouch() {
        this.data.longtouchTimeout && (clearTimeout(this.data.longtouchTimeout), this.data.longtouchTimeout = null);
    }
    __cancelTwoFingersOverlay() {
        this.config.touchmoveTwoFingers && (this.data.twofingersTimeout && (clearTimeout(this.data.twofingersTimeout), this.data.twofingersTimeout = null), this.viewer.overlay.hide($785da19a645c07eb$var$_K.TWO_FINGERS));
    }
    __onMouseWheel(e1) {
        if (!this.config.mousewheel || !e1.deltaY) return;
        if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) return this.viewer.overlay.show({
            id: $785da19a645c07eb$var$_K.CTRL_ZOOM,
            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/>\x3c!-- Created by Icon Island from the Noun Project --\x3e</svg>\n',
            title: this.config.lang.ctrlZoom
        }), clearTimeout(this.data.ctrlZoomTimeout), void (this.data.ctrlZoomTimeout = setTimeout(()=>this.viewer.overlay.hide($785da19a645c07eb$var$_K.CTRL_ZOOM), $785da19a645c07eb$var$pK));
        e1.preventDefault(), e1.stopPropagation();
        const t = e1.deltaY / Math.abs(e1.deltaY) * 5 * this.config.zoomSpeed;
        0 !== t && this.viewer.dynamics.zoom.step(-t, 5);
    }
    __onFullscreenChange() {
        const e1 = this.viewer.isFullscreenEnabled();
        "fullscreen" === this.config.keyboard && (e1 ? this.viewer.startKeyboardControl() : this.viewer.stopKeyboardControl()), this.viewer.dispatchEvent(new $785da19a645c07eb$var$eQ(e1));
    }
    __resetMove() {
        this.step.set($785da19a645c07eb$var$GY.IDLE), this.data.mouseX = 0, this.data.mouseY = 0, this.data.startMouseX = 0, this.data.startMouseY = 0;
    }
    __startMoveZoom(e1) {
        this.viewer.stopAll(), this.__resetMove();
        const t = $785da19a645c07eb$var$NK(e1);
        this.step.set($785da19a645c07eb$var$GY.MOVING), this.data.accumulatorFactor = this.config.moveInertia, { distance: this.data.pinchDist, center: { x: this.data.mouseX, y: this.data.mouseY } } = t;
    }
    __stopMove(e1, t, i, n = !1) {
        this.step.is($785da19a645c07eb$var$GY.CLICK) && !this.__moveThresholdReached(e1, t) && this.__doClick(e1, t, i, n), this.config.moveInertia && (this.data.accumulatorFactor = Math.pow(this.config.moveInertia, .5)), this.__resetMove(), this.viewer.resetIdleTimer();
    }
    __doClick(e1, t, i, n = !1) {
        const a = this.viewer.container.getBoundingClientRect(), r = e1 - a.left, s = t - a.top, o = this.viewer.renderer.getIntersections({
            x: r,
            y: s
        }), l = o.find((e1)=>e1.object.userData[$785da19a645c07eb$var$gK]);
        if (l) {
            const a = this.viewer.dataHelper.vector3ToSphericalCoords(l.point), c = {
                rightclick: n,
                originalEvent: i,
                target: $785da19a645c07eb$var$LK(i),
                clientX: e1,
                clientY: t,
                viewerX: r,
                viewerY: s,
                yaw: a.yaw,
                pitch: a.pitch,
                objects: o.map((e1)=>e1.object).filter((e1)=>!e1.userData[$785da19a645c07eb$var$gK])
            };
            try {
                const e1 = this.viewer.dataHelper.sphericalCoordsToTextureCoords(c);
                Object.assign(c, e1);
            } catch  {}
            this.data.dblclickTimeout ? (Math.abs(this.data.dblclickData.clientX - c.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - c.clientY) < this.moveThreshold && this.viewer.dispatchEvent(new $785da19a645c07eb$var$JX(this.data.dblclickData)), clearTimeout(this.data.dblclickTimeout), this.data.dblclickTimeout = null, this.data.dblclickData = null) : (this.viewer.dispatchEvent(new $785da19a645c07eb$var$KX(c)), this.data.dblclickData = $785da19a645c07eb$var$XK(c), this.data.dblclickTimeout = setTimeout(()=>{
                this.data.dblclickTimeout = null, this.data.dblclickData = null;
            }, $785da19a645c07eb$var$uK));
        }
    }
    __handleObjectsEvents(e1) {
        if (!$785da19a645c07eb$var$QK(this.state.objectsObservers) && e1.composedPath().includes(this.viewer.container)) {
            const t = $785da19a645c07eb$var$OK(this.viewer.container), i = {
                x: e1.clientX - t.x,
                y: e1.clientY - t.y
            }, n = this.viewer.renderer.getIntersections(i), a = (t, n, a)=>{
                this.viewer.dispatchEvent(new a(e1, t, i, n));
            };
            for (const [e1, t] of Object.entries(this.state.objectsObservers)){
                const i = n.find((t)=>t.object.userData[e1]);
                i ? (t && i.object !== t && (a(t, e1, $785da19a645c07eb$var$ZQ), this.state.objectsObservers[e1] = null), t ? a(i.object, e1, $785da19a645c07eb$var$XQ) : (this.state.objectsObservers[e1] = i.object, a(i.object, e1, $785da19a645c07eb$var$HQ))) : t && (a(t, e1, $785da19a645c07eb$var$ZQ), this.state.objectsObservers[e1] = null);
            }
        }
    }
    __doMove(e1, t) {
        if (this.step.is($785da19a645c07eb$var$GY.CLICK) && this.__moveThresholdReached(e1, t)) this.viewer.stopAll(), this.__resetMove(), this.step.set($785da19a645c07eb$var$GY.MOVING), this.data.mouseX = e1, this.data.mouseY = t, this.data.accumulatorFactor = this.config.moveInertia;
        else if (this.step.is($785da19a645c07eb$var$GY.MOVING)) {
            const i = (e1 - this.data.mouseX) * Math.cos(this.state.roll) - (t - this.data.mouseY) * Math.sin(this.state.roll), n = (t - this.data.mouseY) * Math.cos(this.state.roll) + (e1 - this.data.mouseX) * Math.sin(this.state.roll), a = {
                yaw: this.config.moveSpeed * (i / this.state.size.width) * $785da19a645c07eb$var$xj.degToRad(this.state.hFov),
                pitch: this.config.moveSpeed * (n / this.state.size.height) * $785da19a645c07eb$var$xj.degToRad(this.state.vFov)
            };
            this.data.moveDelta.yaw += a.yaw, this.data.moveDelta.pitch += a.pitch, this.data.mouseX = e1, this.data.mouseY = t;
        }
    }
    __moveThresholdReached(e1, t) {
        return Math.abs(e1 - this.data.startMouseX) >= this.moveThreshold || Math.abs(t - this.data.startMouseY) >= this.moveThreshold;
    }
    __doMoveZoom(e1) {
        if (this.step.is($785da19a645c07eb$var$GY.MOVING)) {
            e1.preventDefault();
            const t = $785da19a645c07eb$var$NK(e1);
            this.__doMove(t.center.x, t.center.y), this.data.moveDelta.zoom += this.config.zoomSpeed * ((t.distance - this.data.pinchDist) / $785da19a645c07eb$var$SX.pixelRatio), this.data.pinchDist = t.distance;
        }
    }
    __applyMoveDelta() {
        const e1 = .001;
        if (Math.abs(this.data.moveDelta.yaw) > 0 || Math.abs(this.data.moveDelta.pitch) > 0) {
            const t = this.viewer.getPosition();
            this.viewer.rotate({
                yaw: t.yaw - this.data.moveDelta.yaw * (1 - this.config.moveInertia),
                pitch: t.pitch + this.data.moveDelta.pitch * (1 - this.config.moveInertia)
            }), this.data.moveDelta.yaw *= this.data.accumulatorFactor, this.data.moveDelta.pitch *= this.data.accumulatorFactor, Math.abs(this.data.moveDelta.yaw) <= e1 && (this.data.moveDelta.yaw = 0), Math.abs(this.data.moveDelta.pitch) <= e1 && (this.data.moveDelta.pitch = 0);
        }
        if (Math.abs(this.data.moveDelta.zoom) > 0) {
            const t = this.viewer.getZoomLevel();
            this.viewer.zoom(t + this.data.moveDelta.zoom * (1 - this.config.moveInertia)), this.data.moveDelta.zoom *= this.config.moveInertia, Math.abs(this.data.moveDelta.zoom) <= e1 && (this.data.moveDelta.zoom = 0);
        }
    }
    __clearMoveDelta() {
        this.data.moveDelta.yaw = 0, this.data.moveDelta.pitch = 0, this.data.moveDelta.zoom = 0;
    }
};
$785da19a645c07eb$var$Ij.enabled = !1;
var $785da19a645c07eb$var$WY = new $785da19a645c07eb$var$bj, $785da19a645c07eb$var$ZY = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$KY = new $785da19a645c07eb$var$WV, $785da19a645c07eb$var$XY = class extends $785da19a645c07eb$var$UY {
    constructor(e1){
        super(e1), this.frustumNeedsUpdate = !0, this.renderer = new $785da19a645c07eb$var$nK(this.config.rendererParameters), this.renderer.setPixelRatio($785da19a645c07eb$var$SX.pixelRatio), this.renderer.outputColorSpace = $785da19a645c07eb$var$NN, this.renderer.toneMapping = 1, this.renderer.domElement.className = "psv-canvas", this.renderer.domElement.style.background = this.config.canvasBackground, this.scene = new $785da19a645c07eb$var$PV, this.camera = new $785da19a645c07eb$var$eH(50, 16 / 9, .1, 2 * $785da19a645c07eb$var$mK), this.camera.matrixAutoUpdate = !1;
        const t = new $785da19a645c07eb$var$Kq(new $785da19a645c07eb$var$kG($785da19a645c07eb$var$mK).scale(-1, 1, 1), new $785da19a645c07eb$var$Lq({
            opacity: 0,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1
        }));
        t.userData = {
            [$785da19a645c07eb$var$gK]: !0
        }, this.scene.add(t), this.raycaster = new $785da19a645c07eb$var$sH, this.frustum = new $785da19a645c07eb$var$aG, this.container = document.createElement("div"), this.container.className = "psv-canvas-container", this.container.appendChild(this.renderer.domElement), this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.viewer.addEventListener($785da19a645c07eb$var$OQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$VQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$bQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$EQ.type, this), this.viewer.addEventListener($785da19a645c07eb$var$QX.type, this), this.hide();
    }
    get panoramaPose() {
        return this.mesh.rotation;
    }
    get sphereCorrection() {
        return this.meshContainer.rotation;
    }
    init() {
        this.show(), this.renderer.setAnimationLoop((e1)=>this.__renderLoop(e1));
    }
    destroy() {
        this.renderer.setAnimationLoop(null), this.cleanScene(this.scene), this.renderer.dispose(), this.viewer.container.removeChild(this.container), this.viewer.removeEventListener($785da19a645c07eb$var$OQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$VQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$bQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$EQ.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$QX.type, this), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case $785da19a645c07eb$var$OQ.type:
                this.__onSizeUpdated();
                break;
            case $785da19a645c07eb$var$VQ.type:
                this.__onZoomUpdated();
                break;
            case $785da19a645c07eb$var$bQ.type:
            case $785da19a645c07eb$var$EQ.type:
                this.__onPositionUpdated();
                break;
            case $785da19a645c07eb$var$QX.type:
                e1.containsOptions("fisheye") && this.__onPositionUpdated(), e1.containsOptions("canvasBackground") && (this.renderer.domElement.style.background = this.config.canvasBackground);
        }
    }
    hide() {
        this.container.style.opacity = "0";
    }
    show() {
        this.container.style.opacity = "1";
    }
    setCustomRenderer(e1) {
        this.customRenderer = e1 ? e1(this.renderer) : null, this.viewer.needsUpdate();
    }
    __onSizeUpdated() {
        this.renderer.setSize(this.state.size.width, this.state.size.height), this.camera.aspect = this.state.aspect, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __onZoomUpdated() {
        this.camera.fov = this.state.vFov, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __onPositionUpdated() {
        this.camera.position.set(0, 0, 0), this.camera.lookAt(this.state.direction), this.config.fisheye && this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate(), this.camera.rotateZ(-this.state.roll), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
    }
    __renderLoop(e1) {
        const t = this.timestamp ? e1 - this.timestamp : 0;
        this.timestamp = e1, this.viewer.dispatchEvent(new $785da19a645c07eb$var$GX(e1, t)), this.viewer.dynamics.update(t), (this.state.needsUpdate || this.state.continuousUpdateCount > 0) && (this.state.needsUpdate = !1, (this.customRenderer || this.renderer).render(this.scene, this.camera), this.viewer.dispatchEvent(new $785da19a645c07eb$var$CQ));
    }
    setTexture(e1) {
        this.meshContainer || (this.meshContainer = new $785da19a645c07eb$var$bV, this.scene.add(this.meshContainer)), this.state.textureData && this.viewer.adapter.disposeTexture(this.state.textureData), this.mesh && (this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh)), this.mesh = this.viewer.adapter.createMesh(e1.panoData), this.viewer.adapter.setTexture(this.mesh, e1, !1), this.meshContainer.add(this.mesh), this.state.textureData = e1, this.viewer.needsUpdate();
    }
    setPanoramaPose(e1, t = this.mesh) {
        const i = this.viewer.dataHelper.cleanPanoramaPose(e1);
        t.rotation.set(-i.tilt, -i.pan, i.roll, "YXZ");
    }
    setSphereCorrection(e1, t = this.meshContainer) {
        const i = this.viewer.dataHelper.cleanSphereCorrection(e1);
        t.rotation.set(i.tilt, i.pan, i.roll, "YXZ");
    }
    transition(e1, t, i) {
        const n = "fade" === i.effect || i.rotation, a = !$785da19a645c07eb$var$YK(t.position), r = !$785da19a645c07eb$var$YK(t.zoom), s = new $785da19a645c07eb$var$VX(a ? this.viewer.dataHelper.cleanPosition(t.position) : void 0, t.zoom);
        this.viewer.dispatchEvent(s);
        const o = new $785da19a645c07eb$var$bV, l = this.viewer.adapter.createMesh(e1.panoData);
        if (this.viewer.adapter.setTexture(l, e1, !0), this.viewer.adapter.setTextureOpacity(l, 0), this.setPanoramaPose(e1.panoData, l), this.setSphereCorrection(t.sphereCorrection, o), a && !i.rotation) {
            const e1 = this.viewer.getPosition(), t = new $785da19a645c07eb$var$Ej(0, 1, 0);
            o.rotateOnWorldAxis(t, s.position.yaw - e1.yaw);
            const i = new $785da19a645c07eb$var$Ej(0, 1, 0).cross(this.camera.getWorldDirection(new $785da19a645c07eb$var$Ej)).normalize();
            o.rotateOnWorldAxis(i, s.position.pitch - e1.pitch);
        }
        o.add(l), this.scene.add(o);
        const c = new $785da19a645c07eb$var$Hj;
        this.renderer.setRenderTarget(c), this.renderer.render(this.scene, this.camera), this.renderer.setRenderTarget(null), c.dispose();
        const { duration: u, properties: h } = this.viewer.dataHelper.getAnimationProperties(i.speed, i.rotation ? s.position : null, n ? s.zoomLevel : null), d = new $785da19a645c07eb$var$PX({
            properties: {
                ...h,
                opacity: {
                    start: 0,
                    end: 1
                }
            },
            duration: u,
            easing: "inOutCubic",
            onTick: (e1)=>{
                switch(i.effect){
                    case "fade":
                        this.viewer.adapter.setTextureOpacity(l, e1.opacity);
                        break;
                    case "black":
                    case "white":
                        e1.opacity < .5 ? this.renderer.toneMappingExposure = "black" === i.effect ? $785da19a645c07eb$var$xj.mapLinear(e1.opacity, 0, .5, 1, 0) : $785da19a645c07eb$var$xj.mapLinear(e1.opacity, 0, .5, 1, 5) : (this.renderer.toneMappingExposure = "black" === i.effect ? $785da19a645c07eb$var$xj.mapLinear(e1.opacity, .5, 1, 0, 1) : $785da19a645c07eb$var$xj.mapLinear(e1.opacity, .5, 1, 5, 1), this.mesh.visible = !1, this.viewer.adapter.setTextureOpacity(l, 1), r && !n && this.viewer.dynamics.zoom.setValue(s.zoomLevel));
                }
                a && i.rotation && this.viewer.dynamics.position.setValue({
                    yaw: e1.yaw,
                    pitch: e1.pitch
                }), r && n && this.viewer.dynamics.zoom.setValue(e1.zoom), this.viewer.needsUpdate();
            }
        });
        return d.then((n)=>{
            o.remove(l), this.scene.remove(o), n ? (this.viewer.adapter.disposeTexture(this.state.textureData), this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh), this.mesh = l, this.meshContainer.add(l), this.state.textureData = e1, this.setPanoramaPose(e1.panoData), this.setSphereCorrection(t.sphereCorrection), a && !i.rotation && this.viewer.rotate(t.position)) : (this.viewer.adapter.disposeTexture(e1), this.viewer.adapter.disposeMesh(l));
        }), d;
    }
    getIntersections(e1) {
        $785da19a645c07eb$var$WY.x = 2 * e1.x / this.state.size.width - 1, $785da19a645c07eb$var$WY.y = -2 * e1.y / this.state.size.height + 1, this.raycaster.setFromCamera($785da19a645c07eb$var$WY, this.camera);
        const t = this.raycaster.intersectObjects(this.scene.children, !0).filter((e1)=>e1.object.visible).filter((e1)=>e1.object.isMesh && !!e1.object.userData);
        return this.customRenderer?.getIntersections && t.push(...this.customRenderer.getIntersections(this.raycaster, $785da19a645c07eb$var$WY)), t;
    }
    isObjectVisible(e1) {
        if (!e1) return !1;
        if (this.frustumNeedsUpdate && ($785da19a645c07eb$var$ZY.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse), this.frustum.setFromProjectionMatrix($785da19a645c07eb$var$ZY), this.frustumNeedsUpdate = !1), e1.isVector3) return this.frustum.containsPoint(e1);
        if (e1.isMesh && e1.geometry) {
            const t = e1;
            return t.geometry.boundingBox || t.geometry.computeBoundingBox(), $785da19a645c07eb$var$KY.copy(t.geometry.boundingBox).applyMatrix4(t.matrixWorld), this.frustum.intersectsBox($785da19a645c07eb$var$KY);
        }
        return !!e1.isObject3D && this.frustum.intersectsObject(e1);
    }
    addObject(e1) {
        this.scene.add(e1);
    }
    removeObject(e1) {
        this.scene.remove(e1);
    }
    cleanScene(e1) {
        const t = (e1)=>{
            e1.map?.dispose(), e1.uniforms && Object.values(e1.uniforms).forEach((e1)=>{
                e1.value?.dispose?.();
            }), e1.dispose();
        };
        e1.traverse((i)=>{
            i.geometry?.dispose(), i.material && (Array.isArray(i.material) ? i.material.forEach((e1)=>{
                t(e1);
            }) : t(i.material)), i instanceof $785da19a645c07eb$var$PV || i.dispose?.(), i !== e1 && this.cleanScene(i);
        });
    }
}, $785da19a645c07eb$var$QY = class extends $785da19a645c07eb$var$WG {
    constructor(){
        super(...arguments), this._abortController = new AbortController;
    }
    abort() {
        return this._abortController.abort(), this._abortController = new AbortController, this;
    }
    load(e1, t, i, n) {
        const a = this._abortController.signal, r = super.load(e1, (e1)=>{
            o(), t(e1);
        }, i, (e1)=>{
            if (o(), a.aborted) {
                const e1 = new Error;
                e1.name = "AbortError", e1.message = "The operation was aborted.", n(e1);
            } else n(e1);
        });
        function s() {
            r.src = "";
        }
        function o() {
            a.removeEventListener("abort", s, !1);
        }
        return a.addEventListener("abort", s, !1), r;
    }
}, $785da19a645c07eb$var$YY = class extends $785da19a645c07eb$var$UY {
    constructor(e1){
        super(e1), this.fileLoader = new $785da19a645c07eb$var$GG, this.fileLoader.setResponseType("blob"), this.imageLoader = new $785da19a645c07eb$var$QY;
    }
    destroy() {
        this.abortLoading(), super.destroy();
    }
    abortLoading() {
        this.fileLoader.abort?.(), this.imageLoader.abort();
    }
    loadFile(e1, t, i) {
        const n = $785da19a645c07eb$var$IY.get(e1, i);
        if (n) {
            if (n instanceof Blob) return t?.(100), Promise.resolve(n);
            $785da19a645c07eb$var$IY.remove(e1, i);
        }
        this.config.requestHeaders && this.fileLoader.setRequestHeader(this.config.requestHeaders(e1)), this.fileLoader.setWithCredentials(this.config.withCredentials(e1));
        let a = 0;
        return t?.(a), this.fileLoader.loadAsync(e1, (e1)=>{
            if (e1.lengthComputable) {
                const i = e1.loaded / e1.total * 100;
                i > a && (a = i, t?.(a));
            }
        }).then((n)=>(a = 100, t?.(a), $785da19a645c07eb$var$IY.add(e1, i, n), n));
    }
    loadImage(e1, t, i) {
        const n = $785da19a645c07eb$var$IY.get(e1, i);
        return n ? (t?.(100), n instanceof Blob ? this.blobToImage(n) : Promise.resolve(n)) : t || this.config.requestHeaders ? this.loadFile(e1, t, i).then((e1)=>this.blobToImage(e1)) : (this.imageLoader.setWithCredentials(this.config.withCredentials(e1)), this.imageLoader.loadAsync(e1).then((t)=>($785da19a645c07eb$var$IY.add(e1, i, t), t)));
    }
    blobToImage(e1) {
        return new Promise((t, i)=>{
            const n = document.createElement("img");
            n.onload = ()=>{
                URL.revokeObjectURL(n.src), t(n);
            }, n.onerror = i, n.src = URL.createObjectURL(e1);
        });
    }
    preloadPanorama(e1) {
        return this.viewer.adapter.supportsPreload(e1) ? this.viewer.adapter.loadTexture(e1, !1) : Promise.reject(new $785da19a645c07eb$var$tX("Current adapter does not support preload"));
    }
    dispatchProgress(e1) {
        this.viewer.loader.setProgress(e1), this.viewer.dispatchEvent(new $785da19a645c07eb$var$dQ(Math.round(e1)));
    }
}, $785da19a645c07eb$var$JY = class extends $785da19a645c07eb$var$UY {
    constructor(e1){
        super(e1), this.zoom = new $785da19a645c07eb$var$IX((e1)=>{
            this.viewer.state.vFov = this.viewer.dataHelper.zoomLevelToFov(e1), this.viewer.state.hFov = this.viewer.dataHelper.vFovToHFov(this.viewer.state.vFov), this.viewer.dispatchEvent(new $785da19a645c07eb$var$VQ(e1));
        }, {
            defaultValue: this.viewer.config.defaultZoomLvl,
            min: 0,
            max: 100,
            wrap: !1
        }), this.position = new $785da19a645c07eb$var$FX((e1)=>{
            this.viewer.dataHelper.sphericalCoordsToVector3(e1, this.viewer.state.direction), this.viewer.dispatchEvent(new $785da19a645c07eb$var$bQ(e1));
        }, {
            yaw: new $785da19a645c07eb$var$IX(null, {
                defaultValue: this.config.defaultYaw,
                min: 0,
                max: 2 * Math.PI,
                wrap: !0
            }),
            pitch: new $785da19a645c07eb$var$IX(null, {
                defaultValue: this.config.defaultPitch,
                min: -Math.PI / 2,
                max: Math.PI / 2,
                wrap: !1
            })
        }), this.roll = new $785da19a645c07eb$var$IX((e1)=>{
            this.viewer.state.roll = e1, this.viewer.dispatchEvent(new $785da19a645c07eb$var$EQ(e1));
        }, {
            defaultValue: 0,
            min: -Math.PI,
            max: Math.PI,
            wrap: !1
        }), this.updateSpeeds();
    }
    updateSpeeds() {
        this.zoom.setSpeed(50 * this.config.zoomSpeed), this.position.setSpeed($785da19a645c07eb$var$xj.degToRad(50 * this.config.moveSpeed)), this.roll.setSpeed($785da19a645c07eb$var$xj.degToRad(50 * this.config.moveSpeed));
    }
    update(e1) {
        this.zoom.update(e1), this.position.update(e1), this.roll.update(e1);
    }
}, $785da19a645c07eb$var$$Y = class {
    constructor(){
        this.ready = !1, this.needsUpdate = !1, this.continuousUpdateCount = 0, this.keyboardEnabled = !1, this.direction = new $785da19a645c07eb$var$Ej(0, 0, $785da19a645c07eb$var$mK), this.roll = 0, this.vFov = 60, this.hFov = 60, this.aspect = 1, this.animation = null, this.transitionAnimation = null, this.loadingPromise = null, this.idleTime = -1, this.objectsObservers = {}, this.size = {
            width: 0,
            height: 0
        };
    }
}, $785da19a645c07eb$var$eJ = class extends $785da19a645c07eb$var$UX {
    constructor(e1){
        if (super(), this.plugins = {}, this.children = [], this.parent = $785da19a645c07eb$var$DK(e1.container), !this.parent) throw new $785da19a645c07eb$var$tX('"container" element not found.');
        this.parent[$785da19a645c07eb$var$gK] = this, this.container = document.createElement("div"), this.container.classList.add("psv-container"), this.parent.appendChild(this.container), $785da19a645c07eb$var$wX(this.parent), $785da19a645c07eb$var$xX(this.container, "core"), this.state = new $785da19a645c07eb$var$$Y, this.config = $785da19a645c07eb$var$SY(e1), this.__setSize(this.config.size), this.overlay = new $785da19a645c07eb$var$RY(this);
        try {
            $785da19a645c07eb$var$SX.load();
        } catch (e1) {
            return console.error(e1), void this.showError(this.config.lang.webglError);
        }
        $785da19a645c07eb$var$IY.init(), this.adapter = new this.config.adapter[0](this, this.config.adapter[1]), this.renderer = new $785da19a645c07eb$var$XY(this), this.textureLoader = new $785da19a645c07eb$var$YY(this), this.eventsHandler = new $785da19a645c07eb$var$HY(this), this.dataHelper = new $785da19a645c07eb$var$VY(this), this.dynamics = new $785da19a645c07eb$var$JY(this), this.adapter.init?.(), this.loader = new $785da19a645c07eb$var$FY(this), this.navbar = new $785da19a645c07eb$var$PY(this), this.panel = new $785da19a645c07eb$var$BY(this), this.notification = new $785da19a645c07eb$var$zY(this), this.autoSize(), this.setCursor(null), $785da19a645c07eb$var$iX($785da19a645c07eb$var$SX.isTouchEnabled, (e1)=>{
            $785da19a645c07eb$var$PK(this.container, "psv--is-touch", e1);
        }), this.config.plugins.forEach(([e1, t])=>{
            this.plugins[e1.id] = new e1(this, t);
        });
        for (const e1 of Object.values(this.plugins))e1.init?.();
        this.config.navbar && this.navbar.setButtons(this.config.navbar), this.state.loadingPromise || (this.config.panorama ? this.setPanorama(this.config.panorama, {
            sphereCorrection: this.config.sphereCorrection,
            panoData: this.config.panoData
        }) : this.loader.show());
    }
    destroy() {
        this.stopAll(), this.stopKeyboardControl(), this.exitFullscreen();
        for (const [e1, t] of Object.entries(this.plugins))t.destroy(), delete this.plugins[e1];
        this.children.slice().forEach((e1)=>e1.destroy()), this.children.length = 0, this.eventsHandler?.destroy(), this.renderer?.destroy(), this.textureLoader?.destroy(), this.dataHelper?.destroy(), this.adapter?.destroy(), this.dynamics?.destroy(), this.parent.removeChild(this.container), delete this.parent[$785da19a645c07eb$var$gK];
    }
    init() {
        this.eventsHandler.init(), this.renderer.init(), this.config.navbar && this.navbar.show(), "always" === this.config.keyboard && this.startKeyboardControl(), this.resetIdleTimer(), this.state.ready = !0, this.dispatchEvent(new $785da19a645c07eb$var$SQ);
    }
    resetIdleTimer() {
        this.state.idleTime = performance.now();
    }
    disableIdleTimer() {
        this.state.idleTime = -1;
    }
    getPlugin(e1) {
        if ("string" == typeof e1) return this.plugins[e1];
        {
            const t = $785da19a645c07eb$var$bY(e1);
            return t ? this.plugins[t.id] : null;
        }
    }
    getPosition() {
        return this.dataHelper.cleanPosition(this.dynamics.position.current);
    }
    getZoomLevel() {
        return this.dynamics.zoom.current;
    }
    getSize() {
        return {
            ...this.state.size
        };
    }
    isFullscreenEnabled() {
        return $785da19a645c07eb$var$jK(this.parent, $785da19a645c07eb$var$SX.isIphone);
    }
    needsUpdate() {
        this.state.needsUpdate = !0;
    }
    needsContinuousUpdate(e1) {
        e1 ? this.state.continuousUpdateCount++ : this.state.continuousUpdateCount > 0 && this.state.continuousUpdateCount--;
    }
    autoSize() {
        this.container.clientWidth === this.state.size.width && this.container.clientHeight === this.state.size.height || (this.state.size.width = Math.round(this.container.clientWidth), this.state.size.height = Math.round(this.container.clientHeight), this.state.aspect = this.state.size.width / this.state.size.height, this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov), this.dispatchEvent(new $785da19a645c07eb$var$OQ(this.getSize())), this.navbar.autoSize());
    }
    setPanorama(e1, t = {}) {
        this.textureLoader.abortLoading(), this.state.transitionAnimation?.cancel();
        const i = this.dataHelper.getTransitionOptions(t);
        void 0 === t.showLoader && (t.showLoader = !0), void 0 === t.caption && (t.caption = this.config.caption), void 0 === t.description && (t.description = this.config.description), t.panoData || "function" != typeof this.config.panoData || (t.panoData = this.config.panoData), void 0 === t.sphereCorrection && (t.sphereCorrection = this.config.sphereCorrection), this.hideError(), this.resetIdleTimer(), this.config.panorama = e1, this.config.caption = t.caption, this.config.description = t.description, this.config.sphereCorrection = t.sphereCorrection, "function" == typeof this.config.panoData && "function" != typeof t.panoData || (this.config.panoData = t.panoData);
        const n = (t)=>{
            if ($785da19a645c07eb$var$rX(t)) return !1;
            if (this.loader.hide(), this.state.loadingPromise = null, t) throw this.navbar.setCaption(null), this.showError(this.config.lang.loadError), console.error(t), this.dispatchEvent(new $785da19a645c07eb$var$_Q(e1, t)), t;
            return this.navbar.setCaption(this.config.caption), !0;
        };
        this.navbar.setCaption(`<em>${this.config.lang.loading}</em>`), !t.showLoader && this.state.ready || this.loader.show(), this.dispatchEvent(new $785da19a645c07eb$var$mQ(e1));
        const a = this.adapter.loadTexture(this.config.panorama, !0, t.panoData).then((e1)=>{
            if (e1.panorama !== this.config.panorama) throw this.adapter.disposeTexture(e1), $785da19a645c07eb$var$aX();
            const i = this.dataHelper.cleanPanoramaOptions(t, e1.panoData);
            return $785da19a645c07eb$var$YK(i.zoom) && $785da19a645c07eb$var$YK(i.position) || this.stopAll(), {
                textureData: e1,
                cleanOptions: i
            };
        });
        return i && this.state.ready && this.adapter.supportsTransition(this.config.panorama) ? this.state.loadingPromise = a.then(({ textureData: e1, cleanOptions: t })=>(this.loader.hide(), this.dispatchEvent(new $785da19a645c07eb$var$fQ(e1)), this.state.transitionAnimation = this.renderer.transition(e1, t, i), this.state.transitionAnimation)).then((e1)=>{
            if (this.state.transitionAnimation = null, this.dispatchEvent(new $785da19a645c07eb$var$yQ(e1)), !e1) throw $785da19a645c07eb$var$aX();
        }).then(()=>n(), (e1)=>n(e1)) : this.state.loadingPromise = a.then(({ textureData: e1, cleanOptions: i })=>{
            this.renderer.show(), this.renderer.setTexture(e1), this.renderer.setPanoramaPose(e1.panoData), this.renderer.setSphereCorrection(t.sphereCorrection), this.state.ready || this.init(), this.dispatchEvent(new $785da19a645c07eb$var$fQ(e1)), $785da19a645c07eb$var$YK(i.zoom) || this.zoom(i.zoom), $785da19a645c07eb$var$YK(i.position) || this.rotate(i.position);
        }).then(()=>n(), (e1)=>n(e1)), this.state.loadingPromise;
    }
    setOptions(e1) {
        const t = {
            ...this.config,
            ...e1
        };
        for (let [i, n] of Object.entries(e1))if (i in $785da19a645c07eb$var$wY) {
            if (i in $785da19a645c07eb$var$EY) $785da19a645c07eb$var$sX($785da19a645c07eb$var$EY[i]);
            else switch(i in $785da19a645c07eb$var$kY && (n = $785da19a645c07eb$var$kY[i](n, {
                rawConfig: t,
                defValue: $785da19a645c07eb$var$wY[i]
            })), this.config[i] = n, i){
                case "mousemove":
                    this.state.cursorOverride || this.setCursor(null);
                    break;
                case "caption":
                    this.navbar.setCaption(this.config.caption);
                    break;
                case "size":
                    this.resize(this.config.size);
                    break;
                case "sphereCorrection":
                    this.renderer.setSphereCorrection(this.config.sphereCorrection);
                    break;
                case "navbar":
                case "lang":
                    this.navbar.setButtons(this.config.navbar);
                    break;
                case "moveSpeed":
                case "zoomSpeed":
                    this.dynamics.updateSpeeds();
                    break;
                case "minFov":
                case "maxFov":
                    this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov)), this.dispatchEvent(new $785da19a645c07eb$var$VQ(this.getZoomLevel()));
                    break;
                case "keyboard":
                    "always" === this.config.keyboard ? this.startKeyboardControl() : this.stopKeyboardControl();
            }
        } else $785da19a645c07eb$var$sX(`Unknown option ${i}`);
        this.needsUpdate(), this.dispatchEvent(new $785da19a645c07eb$var$QX(Object.keys(e1)));
    }
    setOption(e1, t) {
        this.setOptions({
            [e1]: t
        });
    }
    showError(e1) {
        this.overlay.show({
            id: $785da19a645c07eb$var$_K.ERROR,
            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/>\x3c!--Created by Shastry from the Noun Project--\x3e</svg>\n',
            title: e1,
            dismissible: !1
        });
    }
    hideError() {
        this.overlay.hide($785da19a645c07eb$var$_K.ERROR);
    }
    rotate(e1) {
        const t = new $785da19a645c07eb$var$WX(this.dataHelper.cleanPosition(e1));
        this.dispatchEvent(t), t.defaultPrevented || this.dynamics.position.setValue(t.position);
    }
    zoom(e1) {
        this.dynamics.zoom.setValue(e1);
    }
    zoomIn(e1 = 1) {
        this.dynamics.zoom.step(e1);
    }
    zoomOut(e1 = 1) {
        this.dynamics.zoom.step(-e1);
    }
    animate(e1) {
        const t = $785da19a645c07eb$var$oX(e1), i = !$785da19a645c07eb$var$YK(e1.zoom), n = new $785da19a645c07eb$var$VX(t ? this.dataHelper.cleanPosition(e1) : void 0, e1.zoom);
        if (this.dispatchEvent(n), n.defaultPrevented) return;
        this.stopAll();
        const { duration: a, properties: r } = this.dataHelper.getAnimationProperties(e1.speed, n.position, n.zoomLevel);
        return a ? (this.state.animation = new $785da19a645c07eb$var$PX({
            properties: r,
            duration: a,
            easing: e1.easing || "inOutSine",
            onTick: (e1)=>{
                t && this.dynamics.position.setValue({
                    yaw: e1.yaw,
                    pitch: e1.pitch
                }), i && this.dynamics.zoom.setValue(e1.zoom);
            }
        }), this.state.animation.then(()=>{
            this.state.animation = null, this.resetIdleTimer();
        }), this.state.animation) : (t && this.rotate(n.position), i && this.zoom(n.zoomLevel), new $785da19a645c07eb$var$PX(null));
    }
    stopAnimation() {
        return this.state.animation ? (this.state.animation.cancel(), this.state.animation) : Promise.resolve();
    }
    resize(e1) {
        this.__setSize(e1), this.autoSize();
    }
    __setSize(e1) {
        [
            "width",
            "height"
        ].forEach((t)=>{
            e1?.[t] && (/^[0-9.]+$/.test(e1[t]) && (e1[t] += "px"), this.parent.style[t] = e1[t]);
        });
    }
    enterFullscreen() {
        this.isFullscreenEnabled() || $785da19a645c07eb$var$VK(this.parent, $785da19a645c07eb$var$SX.isIphone);
    }
    exitFullscreen() {
        this.isFullscreenEnabled() && $785da19a645c07eb$var$qK($785da19a645c07eb$var$SX.isIphone);
    }
    toggleFullscreen() {
        this.isFullscreenEnabled() ? this.exitFullscreen() : this.enterFullscreen();
    }
    startKeyboardControl() {
        this.state.keyboardEnabled = !0;
    }
    stopKeyboardControl() {
        this.state.keyboardEnabled = !1;
    }
    createTooltip(e1) {
        return new $785da19a645c07eb$var$OY(this, e1);
    }
    setCursor(e1) {
        this.state.cursorOverride = e1, this.container.style.cursor = e1 || (this.config.mousemove ? "move" : "default");
    }
    observeObjects(e1) {
        this.state.objectsObservers[e1] || (this.state.objectsObservers[e1] = null);
    }
    unobserveObjects(e1) {
        delete this.state.objectsObservers[e1];
    }
    stopAll() {
        return this.dispatchEvent(new $785da19a645c07eb$var$NQ), this.disableIdleTimer(), this.stopAnimation();
    }
}, $785da19a645c07eb$var$tJ = Object.defineProperty;
((e1, t)=>{
    for(var i in t)$785da19a645c07eb$var$tJ(e1, i, {
        get: t[i],
        enumerable: !0
    });
})({}, {
    EnterArrowEvent: ()=>$785da19a645c07eb$var$rJ,
    LeaveArrowEvent: ()=>$785da19a645c07eb$var$oJ,
    NodeChangedEvent: ()=>$785da19a645c07eb$var$nJ
});
var $785da19a645c07eb$var$iJ = class e1 extends $785da19a645c07eb$var$OX {
    constructor(t, i){
        super(e1.type), this.node = t, this.data = i;
    }
};
$785da19a645c07eb$var$iJ.type = "node-changed";
var $785da19a645c07eb$var$nJ = $785da19a645c07eb$var$iJ, $785da19a645c07eb$var$aJ = class e1 extends $785da19a645c07eb$var$OX {
    constructor(t, i){
        super(e1.type), this.link = t, this.node = i;
    }
};
$785da19a645c07eb$var$aJ.type = "enter-arrow";
var $785da19a645c07eb$var$rJ = $785da19a645c07eb$var$aJ, $785da19a645c07eb$var$sJ = class e1 extends $785da19a645c07eb$var$OX {
    constructor(t, i){
        super(e1.type), this.link = t, this.node = i;
    }
};
$785da19a645c07eb$var$sJ.type = "leave-arrow";
var $785da19a645c07eb$var$oJ = $785da19a645c07eb$var$sJ, $785da19a645c07eb$var$lJ = class extends $785da19a645c07eb$var$xV {
    constructor(e1 = document.createElement("div")){
        super(), this.isCSS2DObject = !0, this.element = e1, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.center = new $785da19a645c07eb$var$bj(.5, .5), this.addEventListener("removed", function() {
            this.traverse(function(e1) {
                e1.element && e1.element instanceof e1.element.ownerDocument.defaultView.Element && null !== e1.element.parentNode && e1.element.remove();
            });
        });
    }
    copy(e1, t) {
        return super.copy(e1, t), this.element = e1.element.cloneNode(!0), this.center = e1.center, this;
    }
}, $785da19a645c07eb$var$cJ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$uJ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$hJ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$dJ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$pJ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$mJ = class {
    constructor(e1 = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            objects: new WeakMap
        }, o = void 0 !== e1.element ? e1.element : document.createElement("div");
        function l(e1) {
            e1.isCSS2DObject && (e1.element.style.display = "none");
            for(let t = 0, i = e1.children.length; t < i; t++)l(e1.children[t]);
        }
        function c(e1, i, n) {
            if (!1 !== e1.visible) {
                if (e1.isCSS2DObject) {
                    $785da19a645c07eb$var$cJ.setFromMatrixPosition(e1.matrixWorld), $785da19a645c07eb$var$cJ.applyMatrix4($785da19a645c07eb$var$hJ);
                    const l = $785da19a645c07eb$var$cJ.z >= -1 && $785da19a645c07eb$var$cJ.z <= 1 && !0 === e1.layers.test(n.layers), c = e1.element;
                    c.style.display = !0 === l ? "" : "none", !0 === l && (e1.onBeforeRender(t, i, n), c.style.transform = "translate(" + -100 * e1.center.x + "%," + -100 * e1.center.y + "%)translate(" + ($785da19a645c07eb$var$cJ.x * a + a) + "px," + (-$785da19a645c07eb$var$cJ.y * r + r) + "px)", c.parentNode !== o && o.appendChild(c), e1.onAfterRender(t, i, n));
                    const h = {
                        distanceToCameraSquared: u(n, e1)
                    };
                    s.objects.set(e1, h);
                }
                for(let t = 0, a = e1.children.length; t < a; t++)c(e1.children[t], i, n);
            } else l(e1);
        }
        function u(e1, t) {
            return $785da19a645c07eb$var$dJ.setFromMatrixPosition(e1.matrixWorld), $785da19a645c07eb$var$pJ.setFromMatrixPosition(t.matrixWorld), $785da19a645c07eb$var$dJ.distanceToSquared($785da19a645c07eb$var$pJ);
        }
        o.style.overflow = "hidden", this.domElement = o, this.sortObjects = !0, this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e1, t) {
            !0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), $785da19a645c07eb$var$uJ.copy(t.matrixWorldInverse), $785da19a645c07eb$var$hJ.multiplyMatrices(t.projectionMatrix, $785da19a645c07eb$var$uJ), c(e1, e1, t), this.sortObjects && function(e1) {
                const t = (function(e1) {
                    const t = [];
                    return e1.traverseVisible(function(e1) {
                        e1.isCSS2DObject && t.push(e1);
                    }), t;
                })(e1).sort(function(e1, t) {
                    if (e1.renderOrder !== t.renderOrder) return t.renderOrder - e1.renderOrder;
                    return s.objects.get(e1).distanceToCameraSquared - s.objects.get(t).distanceToCameraSquared;
                }), i = t.length;
                for(let e1 = 0, n = t.length; e1 < n; e1++)t[e1].element.style.zIndex = i - e1;
            }(e1);
        }, this.setSize = function(e1, t) {
            i = e1, n = t, a = i / 2, r = n / 2, o.style.width = e1 + "px", o.style.height = t + "px";
        };
    }
}, $785da19a645c07eb$var$gJ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$fJ = new $785da19a645c07eb$var$wj, $785da19a645c07eb$var$AJ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$_J = class extends $785da19a645c07eb$var$xV {
    constructor(e1 = document.createElement("div")){
        super(), this.isCSS3DObject = !0, this.element = e1, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
            this.traverse(function(e1) {
                e1.element && e1.element instanceof e1.element.ownerDocument.defaultView.Element && null !== e1.element.parentNode && e1.element.remove();
            });
        });
    }
    copy(e1, t) {
        return super.copy(e1, t), this.element = e1.element.cloneNode(!0), this;
    }
}, $785da19a645c07eb$var$vJ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$yJ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$xJ = class {
    constructor(e1 = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            camera: {
                style: ""
            },
            objects: new WeakMap
        }, o = void 0 !== e1.element ? e1.element : document.createElement("div");
        o.style.overflow = "hidden", this.domElement = o;
        const l = document.createElement("div");
        l.style.transformOrigin = "0 0", l.style.pointerEvents = "none", o.appendChild(l);
        const c = document.createElement("div");
        function u(e1) {
            return Math.abs(e1) < 1e-10 ? 0 : e1;
        }
        function h(e1) {
            const t = e1.elements;
            return "matrix3d(" + u(t[0]) + "," + u(-t[1]) + "," + u(t[2]) + "," + u(t[3]) + "," + u(t[4]) + "," + u(-t[5]) + "," + u(t[6]) + "," + u(t[7]) + "," + u(t[8]) + "," + u(-t[9]) + "," + u(t[10]) + "," + u(t[11]) + "," + u(t[12]) + "," + u(-t[13]) + "," + u(t[14]) + "," + u(t[15]) + ")";
        }
        function d(e1) {
            const t = e1.elements;
            return "translate(-50%,-50%)" + ("matrix3d(" + u(t[0]) + "," + u(t[1]) + "," + u(t[2]) + "," + u(t[3]) + "," + u(-t[4]) + "," + u(-t[5]) + "," + u(-t[6]) + "," + u(-t[7]) + "," + u(t[8]) + "," + u(t[9]) + "," + u(t[10]) + "," + u(t[11]) + "," + u(t[12]) + "," + u(t[13]) + "," + u(t[14]) + "," + u(t[15]) + ")");
        }
        function p(e1) {
            e1.isCSS3DObject && (e1.element.style.display = "none");
            for(let t = 0, i = e1.children.length; t < i; t++)p(e1.children[t]);
        }
        function m(e1, i, n, a) {
            if (!1 !== e1.visible) {
                if (e1.isCSS3DObject) {
                    const a = !0 === e1.layers.test(n.layers), r = e1.element;
                    if (r.style.display = !0 === a ? "" : "none", !0 === a) {
                        let a;
                        e1.onBeforeRender(t, i, n), e1.isCSS3DSprite ? ($785da19a645c07eb$var$vJ.copy(n.matrixWorldInverse), $785da19a645c07eb$var$vJ.transpose(), 0 !== e1.rotation2D && $785da19a645c07eb$var$vJ.multiply($785da19a645c07eb$var$yJ.makeRotationZ(e1.rotation2D)), e1.matrixWorld.decompose($785da19a645c07eb$var$gJ, $785da19a645c07eb$var$fJ, $785da19a645c07eb$var$AJ), $785da19a645c07eb$var$vJ.setPosition($785da19a645c07eb$var$gJ), $785da19a645c07eb$var$vJ.scale($785da19a645c07eb$var$AJ), $785da19a645c07eb$var$vJ.elements[3] = 0, $785da19a645c07eb$var$vJ.elements[7] = 0, $785da19a645c07eb$var$vJ.elements[11] = 0, $785da19a645c07eb$var$vJ.elements[15] = 1, a = d($785da19a645c07eb$var$vJ)) : a = d(e1.matrixWorld);
                        const o = s.objects.get(e1);
                        if (void 0 === o || o.style !== a) {
                            r.style.transform = a;
                            const t = {
                                style: a
                            };
                            s.objects.set(e1, t);
                        }
                        r.parentNode !== c && c.appendChild(r), e1.onAfterRender(t, i, n);
                    }
                }
                for(let t = 0, a = e1.children.length; t < a; t++)m(e1.children[t], i, n);
            } else p(e1);
        }
        c.style.transformStyle = "preserve-3d", l.appendChild(c), this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e1, t) {
            const o = t.projectionMatrix.elements[5] * r;
            let d, p;
            t.view && t.view.enabled ? (l.style.transform = `translate( ${-t.view.offsetX * (i / t.view.width)}px, ${-t.view.offsetY * (n / t.view.height)}px )`, l.style.transform += `scale( ${t.view.fullWidth / t.view.width}, ${t.view.fullHeight / t.view.height} )`) : l.style.transform = "", !0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), t.isOrthographicCamera && (d = -(t.right + t.left) / 2, p = (t.top + t.bottom) / 2);
            const g = t.view && t.view.enabled ? t.view.height / t.view.fullHeight : 1, f = t.isOrthographicCamera ? `scale( ${g} )scale(` + o + ")translate(" + u(d) + "px," + u(p) + "px)" + h(t.matrixWorldInverse) : `scale( ${g} )translateZ(` + o + "px)" + h(t.matrixWorldInverse), A = (t.isPerspectiveCamera ? "perspective(" + o + "px) " : "") + f + "translate(" + a + "px," + r + "px)";
            s.camera.style !== A && (c.style.transform = A, s.camera.style = A), m(e1, e1, t);
        }, this.setSize = function(e1, t) {
            i = e1, n = t, a = i / 2, r = n / 2, o.style.width = e1 + "px", o.style.height = t + "px", l.style.width = e1 + "px", l.style.height = t + "px", c.style.width = e1 + "px", c.style.height = t + "px";
        };
    }
}, $785da19a645c07eb$var$bJ = "tourLink", $785da19a645c07eb$var$wJ = "__tour-link__", $785da19a645c07eb$var$EJ = {
    className: "psv-virtual-tour-tooltip",
    content: '<div class="psv-virtual-tour-loader"><div></div><div></div><div></div></div>'
}, $785da19a645c07eb$var$kJ = {
    element: ()=>{
        const e1 = document.createElement("button");
        return e1.className = "psv-virtual-tour-arrow", e1.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n    <path fill-rule="even-odd" fill="currentColor" d="\n        M50,50 m45,0\n        a45,45 0 1,0 -90,0\n        a45,45 0 1,0  90,0\n\n        M50,50 m38,0\n        a38,38 0 0,1 -76,0\n        a38,38 0 0,1  76,0\n\n        M50,50 m30,0\n        a30,30 0 1,0 -60,0\n        a30,30 0 1,0  60,0\n        \n        M50,40 m2.5,-2.5\n        l17.5,17.5\n        a 2.5,2.5 0 0 1 -5,5\n        l-15,-15\n        l-15,15\n        a 2.5,2.5 0 0 1 -5,-5\n        l17.5,-17.5\n        a 3.5,3.5 0 0 1 5,0\n    "/>\n</svg>', e1;
    },
    size: {
        width: 80,
        height: 80
    }
}, $785da19a645c07eb$var$SJ = "arrow", $785da19a645c07eb$var$MJ = class extends $785da19a645c07eb$var$iY {
    constructor(e1, t){
        super(e1, {
            className: "psv-virtual-tour-arrows"
        }), this.plugin = t, this.renderer = this.is3D ? new $785da19a645c07eb$var$xJ({
            element: this.container
        }) : new $785da19a645c07eb$var$mJ({
            element: this.container
        }), this.camera = this.is3D ? new $785da19a645c07eb$var$eH(30, 1) : null, this.scene = new $785da19a645c07eb$var$PV, this.viewer.addEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this, {
            once: !0
        }), this.viewer.addEventListener($785da19a645c07eb$var$BX.PositionUpdatedEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.SizeUpdatedEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ClickEvent.type, this), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("contextmenu", (e1)=>e1.preventDefault());
    }
    get is3D() {
        return this.plugin.is3D;
    }
    get arrowsPosition() {
        return this.plugin.config.arrowsPosition;
    }
    get arrowStyle() {
        return this.plugin.config.arrowStyle;
    }
    init() {
        this.is3D && (this.gallery = this.viewer.getPlugin("gallery"), this.gallery?.addEventListener("show-gallery", this), this.gallery?.addEventListener("hide-gallery", this));
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.PositionUpdatedEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.SizeUpdatedEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ClickEvent.type, this), this.gallery?.removeEventListener("show-gallery", this), this.gallery?.removeEventListener("hide-gallery", this), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case $785da19a645c07eb$var$BX.ReadyEvent.type:
            case $785da19a645c07eb$var$BX.SizeUpdatedEvent.type:
            case $785da19a645c07eb$var$BX.PositionUpdatedEvent.type:
                this.__updateCamera();
                break;
            case $785da19a645c07eb$var$BX.RenderEvent.type:
                this.render();
                break;
            case $785da19a645c07eb$var$BX.ClickEvent.type:
                {
                    if (e1.data.rightclick) break;
                    const t = this.__getTargetLink(e1.data.target, !0);
                    t && this.plugin.setCurrentNode(t.nodeId, null, t);
                    break;
                }
            case "mouseenter":
                {
                    const t = this.__getTargetLink($785da19a645c07eb$var$bK.getEventTarget(e1));
                    t && this.plugin.__onEnterArrow(t, e1);
                    break;
                }
            case "mouseleave":
                {
                    const t = this.__getTargetLink($785da19a645c07eb$var$bK.getEventTarget(e1));
                    t && this.plugin.__onLeaveArrow(t);
                    break;
                }
            case "mousemove":
                this.__getTargetLink($785da19a645c07eb$var$bK.getEventTarget(e1), !0) && this.plugin.__onHoverArrow(e1);
                break;
            case "hide-gallery":
                this.__onToggleGallery(!1);
                break;
            case "show-gallery":
                e1.fullscreen || this.__onToggleGallery(!0);
        }
    }
    __updateCamera() {
        const e1 = this.viewer.getSize();
        if (this.renderer.setSize(e1.width, e1.height), this.is3D) {
            const t = this.viewer.getPosition();
            t.pitch = $785da19a645c07eb$var$xj.clamp(t.pitch, -this.arrowsPosition.maxPitch, -this.arrowsPosition.minPitch), this.viewer.dataHelper.sphericalCoordsToVector3(t, this.camera.position, 2 * e1.height).negate(), this.camera.lookAt(0, 0, 0), this.camera.translateY(e1.height / 3), this.camera.updateProjectionMatrix();
        }
    }
    render() {
        if (this.is3D) {
            const e1 = this.viewer.getPosition(), t = [];
            let i = Number.MAX_SAFE_INTEGER;
            this.scene.children.forEach((n)=>{
                const a = n.userData[$785da19a645c07eb$var$SJ];
                if (a.conflict) {
                    const r = Math.abs($785da19a645c07eb$var$bK.getShortestArc(e1.yaw, a.yaw));
                    i = Math.min(i, r), t.push([
                        n,
                        r
                    ]);
                }
            }), t.forEach(([e1, t])=>{
                const n = t !== i;
                e1.element.style.opacity = n ? "0.5" : null, e1.element.style.zIndex = n ? "-1" : null;
            }), this.renderer.render(this.scene, this.camera);
        } else this.renderer.render(this.scene, this.viewer.renderer.camera);
    }
    clear() {
        this.scene.clear();
    }
    __buildArrowElement(e1, t) {
        if (t?.image) {
            const e1 = document.createElement("img");
            return e1.src = t.image, e1;
        }
        if (t?.element) return "function" == typeof t.element ? t.element(e1) : t.element;
    }
    addLinkArrow(e1, t, i = 1) {
        let n = this.__buildArrowElement(e1, e1.arrowStyle);
        n || (n = this.__buildArrowElement(e1, this.arrowStyle)), n[$785da19a645c07eb$var$bJ] = e1;
        const a = {
            ...this.arrowStyle,
            ...e1.arrowStyle
        };
        if (n.classList.add("psv-virtual-tour-link"), a.className && $785da19a645c07eb$var$bK.addClasses(n, a.className), a.style && Object.assign(n.style, a.style), this.is3D) {
            n.style.width = 1.5 * a.size.width + "px", n.style.height = 1.5 * a.size.height + "px";
            let e1 = !1;
            this.scene.children.forEach((i)=>{
                const n = i.userData[$785da19a645c07eb$var$SJ];
                Math.abs($785da19a645c07eb$var$bK.getShortestArc(n.yaw, t.yaw)) < this.arrowsPosition.linkOverlapAngle && (n.conflict = !0, e1 = !0);
            });
            const r = new $785da19a645c07eb$var$_J(n);
            r.userData[$785da19a645c07eb$var$SJ] = {
                yaw: t.yaw,
                conflict: e1
            }, r.rotation.set(-Math.PI / 2, 0, Math.PI - t.yaw), this.viewer.dataHelper.sphericalCoordsToVector3({
                yaw: t.yaw,
                pitch: 0
            }, r.position, 100 * i), this.scene.add(r);
        } else {
            n.style.width = a.size.width + "px", n.style.height = a.size.height + "px", n.style.pointerEvents = "auto";
            const e1 = new $785da19a645c07eb$var$lJ(n);
            this.viewer.dataHelper.sphericalCoordsToVector3(t, e1.position), this.scene.add(e1);
        }
    }
    __getTargetLink(e1, t = !1) {
        const i = t ? $785da19a645c07eb$var$bK.getClosest(e1, ".psv-virtual-tour-link") : e1;
        return i ? i[$785da19a645c07eb$var$bJ] : void 0;
    }
    __onToggleGallery(e1) {
        this.container.style.marginBottom = e1 ? this.viewer.container.querySelector(".psv-gallery").offsetHeight + "px" : "";
    }
}, $785da19a645c07eb$var$CJ = class {
    constructor(e1, t){
        this.plugin = e1, this.viewer = t, this.nodes = {};
    }
    destroy() {}
    checkNode(e1) {
        if (!e1.id) throw new $785da19a645c07eb$var$tX("No id given for node");
        if (!e1.panorama) throw new $785da19a645c07eb$var$tX(`No panorama provided for node ${e1.id}`);
        if (this.plugin.isGps && !(e1.gps?.length >= 2)) throw new $785da19a645c07eb$var$tX(`No GPS position provided for node ${e1.id}`);
        if (!this.plugin.isGps && e1.markers?.some((e1)=>e1.gps && !e1.position)) throw new $785da19a645c07eb$var$tX("Cannot use GPS positioning for markers in manual mode");
        e1.links || ($785da19a645c07eb$var$bK.logWarn(`Node ${e1.id} has no links`), e1.links = []);
    }
    checkLink(e1, t) {
        if (!t.nodeId) throw new $785da19a645c07eb$var$tX(`Link of node ${e1.id} has no target id`);
        if (t.nodeId === e1.id) throw new $785da19a645c07eb$var$tX(`Node ${e1.id} links to itself`);
        if (!this.plugin.isGps && !$785da19a645c07eb$var$bK.isExtendedPosition(t.position)) throw new $785da19a645c07eb$var$tX(`No position provided for link ${t.nodeId} of node ${e1.id}`);
        if (this.plugin.isGps && !t.gps) throw new $785da19a645c07eb$var$tX(`No GPS position provided for link ${t.nodeId} of node ${e1.id}`);
    }
}, $785da19a645c07eb$var$TJ = class extends $785da19a645c07eb$var$CJ {
    async loadNode(e1) {
        if (this.nodes[e1]) return this.nodes[e1];
        throw new $785da19a645c07eb$var$tX(`Node ${e1} not found`);
    }
    setNodes(e1) {
        if (!e1?.length) throw new $785da19a645c07eb$var$tX("No nodes provided");
        const t = {}, i = {};
        e1.forEach((e1)=>{
            if (this.checkNode(e1), t[e1.id]) throw new $785da19a645c07eb$var$tX(`Duplicate node ${e1.id}`);
            t[e1.id] = e1;
        }), e1.forEach((e1)=>{
            this.__checkLinks(e1, t), e1.links.forEach((e1)=>{
                i[e1.nodeId] = !0;
            });
        }), e1.forEach((e1)=>{
            i[e1.id] || $785da19a645c07eb$var$bK.logWarn(`Node ${e1.id} is never linked to`);
        }), this.nodes = t;
    }
    updateNode(e1) {
        if (!e1.id) throw new $785da19a645c07eb$var$tX("No id given for node");
        const t = this.nodes[e1.id];
        if (!t) throw new $785da19a645c07eb$var$tX(`Node ${e1.id} does not exist`);
        return Object.assign(t, e1), this.checkNode(t), this.__checkLinks(t, this.nodes), t;
    }
    __checkLinks(e1, t) {
        e1.links.forEach((i)=>{
            if (!t[i.nodeId]) throw new $785da19a645c07eb$var$tX(`Target node ${i.nodeId} of node ${e1.id} does not exists`);
            i.gps = i.gps || t[i.nodeId].gps, this.checkLink(e1, i);
        });
    }
}, $785da19a645c07eb$var$DJ = class extends $785da19a645c07eb$var$CJ {
    constructor(e1, t){
        if (super(e1, t), !e1.config.getNode) throw new $785da19a645c07eb$var$tX("Missing getNode() option.");
        this.nodeResolver = e1.config.getNode;
    }
    async loadNode(e1) {
        if (this.nodes[e1]) return this.nodes[e1];
        {
            const t = await this.nodeResolver(e1);
            return this.checkNode(t), t.links.forEach((e1)=>{
                this.checkLink(t, e1);
            }), this.nodes[e1] = t, t;
        }
    }
    clearCache() {
        this.nodes = {};
    }
};
function $785da19a645c07eb$var$PJ(e1, t) {
    const i = $785da19a645c07eb$var$IJ(e1), n = $785da19a645c07eb$var$IJ(t), a = e1[2] ?? 0, r = t[2] ?? 0;
    let s = 0;
    a !== r && (s = Math.atan((r - a) / function(e1, t) {
        return 6371e3 * $785da19a645c07eb$var$bK.greatArcDistance(e1, t);
    }(i, n)));
    const o = function(e1, t) {
        const [i, n] = e1, [a, r] = t, s = Math.sin(a - i) * Math.cos(r), o = Math.cos(n) * Math.sin(r) - Math.sin(n) * Math.cos(r) * Math.cos(a - i);
        return Math.atan2(s, o);
    }(i, n);
    return {
        yaw: o,
        pitch: s
    };
}
function $785da19a645c07eb$var$IJ(e1) {
    return [
        $785da19a645c07eb$var$xj.degToRad(e1[0]),
        $785da19a645c07eb$var$xj.degToRad(e1[1])
    ];
}
var $785da19a645c07eb$var$FJ = $785da19a645c07eb$var$bK.getConfigParser({
    dataMode: "client",
    positionMode: "manual",
    renderMode: "3d",
    nodes: null,
    getNode: null,
    startNodeId: null,
    preload: !1,
    transitionOptions: {
        showLoader: !0,
        speed: "20rpm",
        effect: "fade",
        rotation: !0
    },
    linksOnCompass: !0,
    showLinkTooltip: !0,
    getLinkTooltip: null,
    arrowStyle: $785da19a645c07eb$var$kJ,
    arrowsPosition: {
        minPitch: .3,
        maxPitch: Math.PI / 2,
        linkOverlapAngle: Math.PI / 4,
        linkPitchOffset: -0.1
    },
    map: null
}, {
    dataMode (e1) {
        if ("client" !== e1 && "server" !== e1) throw new $785da19a645c07eb$var$tX("VirtualTourPlugin: invalid dataMode");
        return e1;
    },
    positionMode (e1) {
        if ("gps" !== e1 && "manual" !== e1) throw new $785da19a645c07eb$var$tX("VirtualTourPlugin: invalid positionMode");
        return e1;
    },
    renderMode (e1) {
        if ("3d" !== e1 && "2d" !== e1) throw new $785da19a645c07eb$var$tX("VirtualTourPlugin: invalid renderMode");
        return e1;
    },
    arrowsPosition: (e1, { defValue: t })=>({
            ...t,
            ...e1
        }),
    arrowStyle: (e1, { defValue: t })=>({
            ...t,
            ...e1
        }),
    map (e1, { rawConfig: t }) {
        if (e1) {
            if ("server" === t.dataMode) return $785da19a645c07eb$var$bK.logWarn("VirtualTourPlugin: The map cannot be used in server side mode"), null;
            if (!e1.imageUrl) return $785da19a645c07eb$var$bK.logWarn('VirtualTourPlugin: configuring the map requires at least "imageUrl"'), null;
            "recenter" in e1 || (e1.recenter = !0);
        }
        return e1;
    }
}), $785da19a645c07eb$var$zJ = class e1 extends $785da19a645c07eb$var$xY {
    constructor(e1, t){
        super(e1, t), this.state = {
            currentNode: null,
            currentTooltip: null,
            loadingNode: null,
            preload: {}
        }, this.arrowsRenderer = new $785da19a645c07eb$var$MJ(this.viewer, this);
    }
    get is3D() {
        return "3d" === this.config.renderMode;
    }
    get isServerSide() {
        return "server" === this.config.dataMode;
    }
    get isGps() {
        return "gps" === this.config.positionMode;
    }
    static withConfig(t) {
        return [
            e1,
            t
        ];
    }
    init() {
        super.init(), this.arrowsRenderer.init(), $785da19a645c07eb$var$bK.checkStylesheet(this.viewer.container, "virtual-tour-plugin"), this.markers = this.viewer.getPlugin("markers"), this.compass = this.viewer.getPlugin("compass"), this.markers?.config.markers && ($785da19a645c07eb$var$bK.logWarn("No default markers can be configured on the MarkersPlugin when using the VirtualTourPlugin. Consider defining `markers` on each tour node."), delete this.markers.config.markers), this.isGps && (this.plan = this.viewer.getPlugin("plan")), this.isServerSide || (this.gallery = this.viewer.getPlugin("gallery"), this.map = this.viewer.getPlugin("map"), this.config.map && !this.map && $785da19a645c07eb$var$bK.logWarn("The map is configured on the VirtualTourPlugin but the MapPlugin is not loaded.")), this.datasource = this.isServerSide ? new $785da19a645c07eb$var$DJ(this, this.viewer) : new $785da19a645c07eb$var$TJ(this, this.viewer), this.map && (this.map.addEventListener("select-hotspot", this), this.map.setImage(this.config.map.imageUrl)), this.plan?.addEventListener("select-hotspot", this), this.isServerSide ? this.config.startNodeId && this.setCurrentNode(this.config.startNodeId) : this.config.nodes && (this.setNodes(this.config.nodes, this.config.startNodeId), delete this.config.nodes);
    }
    destroy() {
        this.map?.removeEventListener("select-hotspot", this), this.plan?.removeEventListener("select-hotspot", this), this.datasource.destroy(), this.arrowsRenderer.destroy(), delete this.datasource, delete this.markers, delete this.compass, delete this.gallery, delete this.arrowsRenderer, super.destroy();
    }
    handleEvent(e1) {
        if (e1 instanceof $785da19a645c07eb$var$BX.ClickEvent) {
            const t = e1.data.objects.find((e1)=>e1.userData[$785da19a645c07eb$var$bJ])?.userData[$785da19a645c07eb$var$bJ];
            t && this.setCurrentNode(t.nodeId, null, t);
        } else if ("select-hotspot" === e1.type) {
            const t = e1.hotspotId;
            t.startsWith($785da19a645c07eb$var$wJ) && this.setCurrentNode(t.substring(13));
        }
    }
    getCurrentNode() {
        return this.state.currentNode;
    }
    setNodes(e1, t) {
        if (this.isServerSide) throw new $785da19a645c07eb$var$tX("Cannot set nodes in server side mode");
        this.__hideTooltip(), this.state.currentNode = null, this.datasource.setNodes(e1), t ? this.datasource.nodes[t] || (t = e1[0].id, $785da19a645c07eb$var$bK.logWarn(`startNodeId not found is provided nodes, resetted to ${t}`)) : t = e1[0].id, this.setCurrentNode(t), this.__setGalleryItems(), this.__setMapHotspots(), this.__setPlanHotspots();
    }
    setCurrentNode(e1, t, i) {
        if (e1 === this.state.currentNode?.id && !t?.forceUpdate) return Promise.resolve(!0);
        t?.forceUpdate && this.isServerSide && this.datasource.clearCache(), this.viewer.hideError(), this.state.loadingNode = e1;
        const n = this.state.currentNode, a = n && i ? this.__getLinkPosition(n, i) : null;
        return Promise.resolve(this.state.preload[e1]).then(()=>{
            if (this.state.loadingNode !== e1) throw $785da19a645c07eb$var$bK.getAbortError();
            return this.datasource.loadNode(e1);
        }).then((r)=>{
            if (this.state.loadingNode !== e1) throw $785da19a645c07eb$var$bK.getAbortError();
            const s = {
                ...$785da19a645c07eb$var$FJ.defaults.transitionOptions,
                rotateTo: a,
                zoomTo: a ? this.viewer.getZoomLevel() : null,
                ..."function" == typeof this.config.transitionOptions ? this.config.transitionOptions(r, n, i) : this.config.transitionOptions,
                ...t
            };
            return s.effect || (s.effect = "none"), this.viewer.panel.hide("description"), this.__hideTooltip(), this.arrowsRenderer.clear(), this.gallery?.config.hideOnClick && this.gallery.hide(), this.map?.config.minimizeOnHotspotClick && this.map.minimize(), this.plan?.config.minimizeOnHotspotClick && this.plan.minimize(), s.rotation && "none" === s.effect ? this.viewer.animate({
                ...s.rotateTo,
                zoom: s.zoomTo,
                speed: s.speed
            }).then(()=>[
                    r,
                    s
                ]) : Promise.resolve([
                r,
                s
            ]);
        }).then(([t, i])=>{
            if (this.state.loadingNode !== e1) throw $785da19a645c07eb$var$bK.getAbortError();
            return this.markers?.clearMarkers(), this.config.linksOnCompass && this.compass?.clearHotspots(), this.viewer.setPanorama(t.panorama, {
                caption: t.caption,
                description: t.description,
                panoData: t.panoData,
                sphereCorrection: t.sphereCorrection,
                showLoader: i.showLoader,
                position: i.rotateTo,
                zoom: i.zoomTo,
                transition: "none" !== i.effect && {
                    effect: i.effect,
                    rotation: i.rotation,
                    speed: i.speed
                }
            }).then((e1)=>{
                if (!e1) throw $785da19a645c07eb$var$bK.getAbortError();
                return t;
            });
        }).then((t)=>{
            if (this.state.loadingNode !== e1) throw $785da19a645c07eb$var$bK.getAbortError();
            return this.state.currentNode = t, this.map && this.map.setCenter(this.__getNodeMapPosition(t) ?? this.map.config.center, this.config.map.recenter), this.plan?.setCoordinates(t.gps), this.__addNodeMarkers(t), this.__renderLinks(t), this.__preload(t), this.state.loadingNode = null, this.dispatchEvent(new $785da19a645c07eb$var$nJ(t, {
                fromNode: n,
                fromLink: i,
                fromLinkPosition: a
            })), this.viewer.resetIdleTimer(), !0;
        }).catch((e1)=>{
            if ($785da19a645c07eb$var$bK.isAbortError(e1)) return !1;
            throw this.viewer.showError(this.viewer.config.lang.loadError), this.viewer.loader.hide(), this.viewer.navbar.setCaption(""), this.state.loadingNode = null, e1;
        });
    }
    async gotoLink(e1, t = "8rpm") {
        const i = this.getLinkPosition(e1);
        t ? await this.viewer.animate({
            ...i,
            speed: t
        }) : this.viewer.rotate(i);
    }
    getLinkPosition(e1) {
        const t = this.state.currentNode?.links.find((t)=>t.nodeId === e1);
        if (!t) throw new $785da19a645c07eb$var$tX(`Cannot find link "${e1}"`);
        return this.__getLinkPosition(this.state.currentNode, t);
    }
    updateNode(e1) {
        if (this.isServerSide) throw new $785da19a645c07eb$var$tX("Cannot update node in server side mode");
        const t = this.datasource.updateNode(e1);
        if ((e1.name || e1.thumbnail || e1.panorama) && this.__setGalleryItems(), (e1.name || e1.gps || e1.map) && this.__setMapHotspots(), (e1.name || e1.gps || e1.plan) && this.__setPlanHotspots(), this.state.currentNode?.id === t.id) {
            if (this.__hideTooltip(), e1.panorama || e1.panoData || e1.sphereCorrection) return void this.setCurrentNode(t.id, {
                forceUpdate: !0
            });
            e1.caption && this.viewer.setOption("caption", t.caption), e1.description && this.viewer.setOption("description", t.description), (e1.links || e1.gps) && this.__renderLinks(t), e1.gps && this.plan?.setCoordinates(t.gps), (e1.map || e1.gps) && this.map?.setCenter(this.__getNodeMapPosition(t)), (e1.markers || e1.gps) && this.__addNodeMarkers(t);
        }
    }
    __setGalleryItems() {
        this.gallery && this.gallery.setItems(Object.values(this.datasource.nodes).filter((e1)=>!1 !== e1.showInGallery).map((e1)=>({
                id: e1.id,
                panorama: e1.panorama,
                name: e1.name,
                thumbnail: e1.thumbnail
            })), (e1)=>{
            this.setCurrentNode(e1);
        });
    }
    __setMapHotspots() {
        this.map && this.map.setHotspots(Object.values(this.datasource.nodes).filter((e1)=>!1 !== e1.map).map((e1)=>({
                tooltip: e1.name,
                ...e1.map || {},
                ...this.__getNodeMapPosition(e1),
                id: $785da19a645c07eb$var$wJ + e1.id
            })));
    }
    __setPlanHotspots() {
        this.plan && this.plan.setHotspots(Object.values(this.datasource.nodes).filter((e1)=>!1 !== e1.plan).map((e1)=>({
                tooltip: e1.name,
                ...e1.plan || {},
                coordinates: e1.gps,
                id: $785da19a645c07eb$var$wJ + e1.id
            })));
    }
    __renderLinks(e1) {
        this.arrowsRenderer.clear();
        const t = [];
        e1.links.forEach((i)=>{
            const n = this.__getLinkPosition(e1, i);
            n.yaw += i.linkOffset?.yaw ?? 0, n.pitch += i.linkOffset?.pitch ?? 0, this.isGps && !this.is3D && (n.pitch += this.config.arrowsPosition.linkPitchOffset), t.push(n), this.arrowsRenderer.addLinkArrow(i, n, i.linkOffset?.depth);
        }), this.arrowsRenderer.render(), this.config.linksOnCompass && this.compass?.setHotspots(t);
    }
    __getLinkPosition(e1, t) {
        return this.isGps ? $785da19a645c07eb$var$PJ(e1.gps, t.gps) : this.viewer.dataHelper.cleanPosition(t.position);
    }
    async __getTooltipContent(e1) {
        const t = await this.datasource.loadNode(e1.nodeId), i = [];
        (t.name || t.thumbnail || t.caption) && (t.name && i.push(`<h3>${t.name}</h3>`), t.thumbnail && i.push(`<img src="${t.thumbnail}">`), t.caption && i.push(`<p>${t.caption}</p>`));
        let n = i.join("");
        return this.config.getLinkTooltip && (n = this.config.getLinkTooltip(n, e1, t)), n;
    }
    __onEnterArrow(e1, t) {
        const i = $785da19a645c07eb$var$bK.getPosition(this.viewer.container), n = {
            x: t.clientX - i.x,
            y: t.clientY - i.y
        };
        this.config.showLinkTooltip && (this.state.currentTooltip = this.viewer.createTooltip({
            ...$785da19a645c07eb$var$EJ,
            left: n.x,
            top: n.y,
            box: {
                width: 20,
                height: 20
            }
        }), this.__getTooltipContent(e1).then((e1)=>{
            e1 ? this.state.currentTooltip.update(e1) : this.__hideTooltip();
        })), this.map?.setActiveHotspot($785da19a645c07eb$var$wJ + e1.nodeId), this.plan?.setActiveHotspot($785da19a645c07eb$var$wJ + e1.nodeId), this.dispatchEvent(new $785da19a645c07eb$var$rJ(e1, this.state.currentNode));
    }
    __onHoverArrow(e1) {
        const t = $785da19a645c07eb$var$bK.getPosition(this.viewer.container), i = {
            x: e1.clientX - t.x,
            y: e1.clientY - t.y
        };
        this.state.currentTooltip?.move({
            left: i.x,
            top: i.y
        });
    }
    __onLeaveArrow(e1) {
        this.__hideTooltip(), this.map?.setActiveHotspot(null), this.plan?.setActiveHotspot(null), this.dispatchEvent(new $785da19a645c07eb$var$oJ(e1, this.state.currentNode));
    }
    __hideTooltip() {
        this.state.currentTooltip?.hide(), this.state.currentTooltip = null;
    }
    __preload(e1) {
        this.config.preload && (this.state.preload[e1.id] = !0, this.state.currentNode.links.filter((e1)=>!this.state.preload[e1.nodeId]).filter((e1)=>"function" != typeof this.config.preload || this.config.preload(this.state.currentNode, e1)).forEach((e1)=>{
            this.state.preload[e1.nodeId] = this.datasource.loadNode(e1.nodeId).then((e1)=>this.viewer.textureLoader.preloadPanorama(e1.panorama)).then(()=>{
                this.state.preload[e1.nodeId] = !0;
            }).catch(()=>{
                delete this.state.preload[e1.nodeId];
            });
        }));
    }
    __addNodeMarkers(e1) {
        e1.markers && (this.markers ? this.markers.setMarkers(e1.markers.map((t)=>(t.gps && this.isGps && (t.position = $785da19a645c07eb$var$PJ(e1.gps, t.gps), t.data?.map && Object.assign(t.data.map, this.__getGpsMapPosition(t.gps)), t.data?.plan && (t.data.plan.coordinates = t.gps)), t))) : $785da19a645c07eb$var$bK.logWarn(`Node ${e1.id} markers ignored because the plugin is not loaded.`));
    }
    __getNodeMapPosition(e1) {
        const t = this.__getGpsMapPosition(e1.gps);
        return t || (e1.map ? {
            x: e1.map.x,
            y: e1.map.y
        } : null);
    }
    __getGpsMapPosition(e1) {
        const t = this.config.map;
        return this.isGps && t && t.extent && t.size ? {
            x: $785da19a645c07eb$var$xj.mapLinear(e1[0], t.extent[0], t.extent[2], 0, t.size.width),
            y: $785da19a645c07eb$var$xj.mapLinear(e1[1], t.extent[1], t.extent[3], 0, t.size.height)
        } : null;
    }
};
$785da19a645c07eb$var$zJ.id = "virtual-tour", $785da19a645c07eb$var$zJ.VERSION = "5.15.1", $785da19a645c07eb$var$zJ.configParser = $785da19a645c07eb$var$FJ, $785da19a645c07eb$var$zJ.readonlyOptions = Object.keys($785da19a645c07eb$var$FJ.defaults);
var $785da19a645c07eb$var$RJ = $785da19a645c07eb$var$zJ, $785da19a645c07eb$var$LJ = Object.defineProperty;
/*!
 * Photo Sphere Viewer / Markers Plugin 5.15.1
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ ((e1, t)=>{
    for(var i in t)$785da19a645c07eb$var$LJ(e1, i, {
        get: t[i],
        enumerable: !0
    });
})({}, {
    EnterMarkerEvent: ()=>$785da19a645c07eb$var$HJ,
    GotoMarkerDoneEvent: ()=>$785da19a645c07eb$var$jJ,
    HideMarkersEvent: ()=>$785da19a645c07eb$var$$J,
    LeaveMarkerEvent: ()=>$785da19a645c07eb$var$qJ,
    MarkerVisibilityEvent: ()=>$785da19a645c07eb$var$UJ,
    MarkersPluginEvent: ()=>$785da19a645c07eb$var$BJ,
    RenderMarkersListEvent: ()=>$785da19a645c07eb$var$r$,
    SelectMarkerEvent: ()=>$785da19a645c07eb$var$ZJ,
    SelectMarkerListEvent: ()=>$785da19a645c07eb$var$XJ,
    SetMarkersEvent: ()=>$785da19a645c07eb$var$t$,
    ShowMarkersEvent: ()=>$785da19a645c07eb$var$n$,
    UnselectMarkerEvent: ()=>$785da19a645c07eb$var$YJ
});
var $785da19a645c07eb$var$BJ = class extends $785da19a645c07eb$var$OX {
}, $785da19a645c07eb$var$OJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t, i){
        super(e1.type), this.marker = t, this.visible = i;
    }
};
$785da19a645c07eb$var$OJ.type = "marker-visibility";
var $785da19a645c07eb$var$UJ = $785da19a645c07eb$var$OJ, $785da19a645c07eb$var$NJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.marker = t;
    }
};
$785da19a645c07eb$var$NJ.type = "goto-marker-done";
var $785da19a645c07eb$var$jJ = $785da19a645c07eb$var$NJ, $785da19a645c07eb$var$VJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.marker = t;
    }
};
$785da19a645c07eb$var$VJ.type = "leave-marker";
var $785da19a645c07eb$var$qJ = $785da19a645c07eb$var$VJ, $785da19a645c07eb$var$GJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.marker = t;
    }
};
$785da19a645c07eb$var$GJ.type = "enter-marker";
var $785da19a645c07eb$var$HJ = $785da19a645c07eb$var$GJ, $785da19a645c07eb$var$WJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t, i, n){
        super(e1.type), this.marker = t, this.doubleClick = i, this.rightClick = n;
    }
};
$785da19a645c07eb$var$WJ.type = "select-marker";
var $785da19a645c07eb$var$ZJ = $785da19a645c07eb$var$WJ, $785da19a645c07eb$var$KJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.marker = t;
    }
};
$785da19a645c07eb$var$KJ.type = "select-marker-list";
var $785da19a645c07eb$var$XJ = $785da19a645c07eb$var$KJ, $785da19a645c07eb$var$QJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.marker = t;
    }
};
$785da19a645c07eb$var$QJ.type = "unselect-marker";
var $785da19a645c07eb$var$YJ = $785da19a645c07eb$var$QJ, $785da19a645c07eb$var$JJ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(){
        super(e1.type);
    }
};
$785da19a645c07eb$var$JJ.type = "hide-markers";
var $785da19a645c07eb$var$$J = $785da19a645c07eb$var$JJ, $785da19a645c07eb$var$e$ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.markers = t;
    }
};
$785da19a645c07eb$var$e$.type = "set-markers";
var $785da19a645c07eb$var$t$ = $785da19a645c07eb$var$e$, $785da19a645c07eb$var$i$ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(){
        super(e1.type);
    }
};
$785da19a645c07eb$var$i$.type = "show-markers";
var $785da19a645c07eb$var$n$ = $785da19a645c07eb$var$i$, $785da19a645c07eb$var$a$ = class e1 extends $785da19a645c07eb$var$BJ {
    constructor(t){
        super(e1.type), this.markers = t;
    }
};
$785da19a645c07eb$var$a$.type = "render-markers-list";
var $785da19a645c07eb$var$r$ = $785da19a645c07eb$var$a$, $785da19a645c07eb$var$s$ = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: "psv-markers-button",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n',
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0
        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.plugin.addEventListener($785da19a645c07eb$var$n$.type, this), this.plugin.addEventListener($785da19a645c07eb$var$$J.type, this), this.toggleActive(!0));
    }
    destroy() {
        this.plugin && (this.plugin.removeEventListener($785da19a645c07eb$var$n$.type, this), this.plugin.removeEventListener($785da19a645c07eb$var$$J.type, this)), super.destroy();
    }
    isSupported() {
        return !!this.plugin;
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$n$ ? this.toggleActive(!0) : e1 instanceof $785da19a645c07eb$var$$J && this.toggleActive(!1);
    }
    onClick() {
        this.plugin.toggleAllMarkers();
    }
};
$785da19a645c07eb$var$s$.id = "markers";
var $785da19a645c07eb$var$o$ = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n', $785da19a645c07eb$var$l$ = "http://www.w3.org/2000/svg", $785da19a645c07eb$var$c$ = "psvMarker", $785da19a645c07eb$var$u$ = $785da19a645c07eb$var$bK.dasherize($785da19a645c07eb$var$c$), $785da19a645c07eb$var$h$ = "marker", $785da19a645c07eb$var$d$ = "markersList", $785da19a645c07eb$var$p$ = {
    amount: 2,
    duration: 100,
    easing: "linear"
}, $785da19a645c07eb$var$m$ = (e1, t)=>`\n<div class="psv-panel-menu psv-panel-menu--stripped">\n    <h1 class="psv-panel-menu-title">${$785da19a645c07eb$var$o$} ${t}</h1>\n    <ul class="psv-panel-menu-list">\n    ${e1.map((e1)=>`\n        <li data-${$785da19a645c07eb$var$u$}="${e1.id}" class="psv-panel-menu-item" tabindex="0">\n          ${"image" === e1.type ? `<span class="psv-panel-menu-item-icon"><img src="${e1.definition}"/></span>` : ""}\n          <span class="psv-panel-menu-item-label">${e1.getListContent()}</span>\n        </li>\n    `).join("")}\n    </ul>\n</div>\n`, $785da19a645c07eb$var$g$ = class extends $785da19a645c07eb$var$aY {
    constructor(e1){
        super(e1, {
            className: " psv-markers-list-button",
            icon: $785da19a645c07eb$var$o$,
            hoverScale: !0,
            collapsable: !0,
            tabbable: !0
        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.viewer.addEventListener($785da19a645c07eb$var$BX.ShowPanelEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.HidePanelEvent.type, this));
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$BX.ShowPanelEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.HidePanelEvent.type, this), super.destroy();
    }
    isSupported() {
        return !!this.plugin;
    }
    handleEvent(e1) {
        e1 instanceof $785da19a645c07eb$var$BX.ShowPanelEvent ? this.toggleActive(e1.panelId === $785da19a645c07eb$var$d$) : e1 instanceof $785da19a645c07eb$var$BX.HidePanelEvent && this.toggleActive(!1);
    }
    onClick() {
        this.plugin.toggleMarkersList();
    }
};
$785da19a645c07eb$var$g$.id = "markersList";
var $785da19a645c07eb$var$f$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$A$ = new $785da19a645c07eb$var$wj, $785da19a645c07eb$var$_$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$v$ = class extends $785da19a645c07eb$var$xV {
    constructor(e1 = document.createElement("div")){
        super(), this.isCSS3DObject = !0, this.element = e1, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
            this.traverse(function(e1) {
                e1.element && e1.element instanceof e1.element.ownerDocument.defaultView.Element && null !== e1.element.parentNode && e1.element.remove();
            });
        });
    }
    copy(e1, t) {
        return super.copy(e1, t), this.element = e1.element.cloneNode(!0), this;
    }
}, $785da19a645c07eb$var$y$ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$x$ = new $785da19a645c07eb$var$Kj, $785da19a645c07eb$var$b$ = class {
    constructor(e1 = {}){
        const t = this;
        let i, n, a, r;
        const s = {
            camera: {
                style: ""
            },
            objects: new WeakMap
        }, o = void 0 !== e1.element ? e1.element : document.createElement("div");
        o.style.overflow = "hidden", this.domElement = o;
        const l = document.createElement("div");
        l.style.transformOrigin = "0 0", l.style.pointerEvents = "none", o.appendChild(l);
        const c = document.createElement("div");
        function u(e1) {
            return Math.abs(e1) < 1e-10 ? 0 : e1;
        }
        function h(e1) {
            const t = e1.elements;
            return "matrix3d(" + u(t[0]) + "," + u(-t[1]) + "," + u(t[2]) + "," + u(t[3]) + "," + u(t[4]) + "," + u(-t[5]) + "," + u(t[6]) + "," + u(t[7]) + "," + u(t[8]) + "," + u(-t[9]) + "," + u(t[10]) + "," + u(t[11]) + "," + u(t[12]) + "," + u(-t[13]) + "," + u(t[14]) + "," + u(t[15]) + ")";
        }
        function d(e1) {
            const t = e1.elements;
            return "translate(-50%,-50%)" + ("matrix3d(" + u(t[0]) + "," + u(t[1]) + "," + u(t[2]) + "," + u(t[3]) + "," + u(-t[4]) + "," + u(-t[5]) + "," + u(-t[6]) + "," + u(-t[7]) + "," + u(t[8]) + "," + u(t[9]) + "," + u(t[10]) + "," + u(t[11]) + "," + u(t[12]) + "," + u(t[13]) + "," + u(t[14]) + "," + u(t[15]) + ")");
        }
        function p(e1) {
            e1.isCSS3DObject && (e1.element.style.display = "none");
            for(let t = 0, i = e1.children.length; t < i; t++)p(e1.children[t]);
        }
        function m(e1, i, n, a) {
            if (!1 !== e1.visible) {
                if (e1.isCSS3DObject) {
                    const a = !0 === e1.layers.test(n.layers), r = e1.element;
                    if (r.style.display = !0 === a ? "" : "none", !0 === a) {
                        let a;
                        e1.onBeforeRender(t, i, n), e1.isCSS3DSprite ? ($785da19a645c07eb$var$y$.copy(n.matrixWorldInverse), $785da19a645c07eb$var$y$.transpose(), 0 !== e1.rotation2D && $785da19a645c07eb$var$y$.multiply($785da19a645c07eb$var$x$.makeRotationZ(e1.rotation2D)), e1.matrixWorld.decompose($785da19a645c07eb$var$f$, $785da19a645c07eb$var$A$, $785da19a645c07eb$var$_$), $785da19a645c07eb$var$y$.setPosition($785da19a645c07eb$var$f$), $785da19a645c07eb$var$y$.scale($785da19a645c07eb$var$_$), $785da19a645c07eb$var$y$.elements[3] = 0, $785da19a645c07eb$var$y$.elements[7] = 0, $785da19a645c07eb$var$y$.elements[11] = 0, $785da19a645c07eb$var$y$.elements[15] = 1, a = d($785da19a645c07eb$var$y$)) : a = d(e1.matrixWorld);
                        const o = s.objects.get(e1);
                        if (void 0 === o || o.style !== a) {
                            r.style.transform = a;
                            const t = {
                                style: a
                            };
                            s.objects.set(e1, t);
                        }
                        r.parentNode !== c && c.appendChild(r), e1.onAfterRender(t, i, n);
                    }
                }
                for(let t = 0, a = e1.children.length; t < a; t++)m(e1.children[t], i, n);
            } else p(e1);
        }
        c.style.transformStyle = "preserve-3d", l.appendChild(c), this.getSize = function() {
            return {
                width: i,
                height: n
            };
        }, this.render = function(e1, t) {
            const o = t.projectionMatrix.elements[5] * r;
            let d, p;
            t.view && t.view.enabled ? (l.style.transform = `translate( ${-t.view.offsetX * (i / t.view.width)}px, ${-t.view.offsetY * (n / t.view.height)}px )`, l.style.transform += `scale( ${t.view.fullWidth / t.view.width}, ${t.view.fullHeight / t.view.height} )`) : l.style.transform = "", !0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), t.isOrthographicCamera && (d = -(t.right + t.left) / 2, p = (t.top + t.bottom) / 2);
            const g = t.view && t.view.enabled ? t.view.height / t.view.fullHeight : 1, f = t.isOrthographicCamera ? `scale( ${g} )scale(` + o + ")translate(" + u(d) + "px," + u(p) + "px)" + h(t.matrixWorldInverse) : `scale( ${g} )translateZ(` + o + "px)" + h(t.matrixWorldInverse), A = (t.isPerspectiveCamera ? "perspective(" + o + "px) " : "") + f + "translate(" + a + "px," + r + "px)";
            s.camera.style !== A && (c.style.transform = A, s.camera.style = A), m(e1, e1, t);
        }, this.setSize = function(e1, t) {
            i = e1, n = t, a = i / 2, r = n / 2, o.style.width = e1 + "px", o.style.height = t + "px", l.style.width = e1 + "px", l.style.height = t + "px", c.style.width = e1 + "px", c.style.height = t + "px";
        };
    }
}, $785da19a645c07eb$var$w$ = class {
    constructor(e1){
        this.viewer = e1, this.element = document.createElement("div"), this.element.className = "psv-markers-css3d-container", this.renderer = new $785da19a645c07eb$var$b$({
            element: this.element
        }), this.scene = new $785da19a645c07eb$var$PV, this.intersectionObserver = new IntersectionObserver((e1)=>{
            e1.forEach((e1)=>{
                const t = e1.target[$785da19a645c07eb$var$c$];
                t.config.visible && (t.viewportIntersection = e1.isIntersecting);
            });
        }, {
            root: this.element
        }), e1.addEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this, {
            once: !0
        }), e1.addEventListener($785da19a645c07eb$var$BX.SizeUpdatedEvent.type, this), e1.addEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this);
    }
    handleEvent(e1) {
        switch(e1.type){
            case $785da19a645c07eb$var$BX.ReadyEvent.type:
            case $785da19a645c07eb$var$BX.SizeUpdatedEvent.type:
                this.updateSize();
                break;
            case $785da19a645c07eb$var$BX.RenderEvent.type:
                this.render();
        }
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.SizeUpdatedEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this), this.intersectionObserver.disconnect();
    }
    updateSize() {
        const e1 = this.viewer.getSize();
        this.renderer.setSize(e1.width, e1.height);
    }
    render() {
        this.renderer.render(this.scene, this.viewer.renderer.camera);
    }
    addObject(e1) {
        this.scene.add(e1.threeElement), this.intersectionObserver.observe(e1.domElement);
    }
    removeObject(e1) {
        this.scene.remove(e1.threeElement), this.intersectionObserver.unobserve(e1.domElement);
    }
}, $785da19a645c07eb$var$E$ = ((e1)=>(e1.image = "image", e1.html = "html", e1.element = "element", e1.imageLayer = "imageLayer", e1.videoLayer = "videoLayer", e1.elementLayer = "elementLayer", e1.polygon = "polygon", e1.polygonPixels = "polygonPixels", e1.polyline = "polyline", e1.polylinePixels = "polylinePixels", e1.square = "square", e1.rect = "rect", e1.circle = "circle", e1.ellipse = "ellipse", e1.path = "path", e1))($785da19a645c07eb$var$E$ || {});
function $785da19a645c07eb$var$k$(e1, t = !1) {
    const i = [];
    if (Object.keys($785da19a645c07eb$var$E$).forEach((t)=>{
        e1[t] && i.push(t);
    }), 0 === i.length && !t) throw new $785da19a645c07eb$var$tX(`missing marker content, either ${Object.keys($785da19a645c07eb$var$E$).join(", ")}`);
    if (i.length > 1) throw new $785da19a645c07eb$var$tX(`multiple marker content, either ${Object.keys($785da19a645c07eb$var$E$).join(", ")}`);
    return i[0];
}
var $785da19a645c07eb$var$S$ = class {
    constructor(e1, t, i){
        if (this.viewer = e1, this.plugin = t, this.state = {
            anchor: null,
            visible: !1,
            staticTooltip: !1,
            position: null,
            position2D: null,
            positions3D: null,
            size: null
        }, !i.id) throw new $785da19a645c07eb$var$tX("missing marker id");
        this.type = $785da19a645c07eb$var$k$(i), this.createElement(), this.update(i);
    }
    get id() {
        return this.config.id;
    }
    get data() {
        return this.config.data;
    }
    get domElement() {
        return null;
    }
    get threeElement() {
        return null;
    }
    get video() {
        return null;
    }
    destroy() {
        delete this.viewer, delete this.plugin, delete this.element, this.hideTooltip();
    }
    is3d() {
        return !1;
    }
    isNormal() {
        return !1;
    }
    isPoly() {
        return !1;
    }
    isSvg() {
        return !1;
    }
    isCss3d() {
        return !1;
    }
    update(e1) {
        const t = $785da19a645c07eb$var$k$(e1, !0);
        if (void 0 !== t && t !== this.type) throw new $785da19a645c07eb$var$tX(`cannot change marker ${e1.id} type`);
        if (this.config = $785da19a645c07eb$var$bK.deepmerge(this.config, e1), "string" == typeof this.config.tooltip && (this.config.tooltip = {
            content: this.config.tooltip
        }), this.config.tooltip && !this.config.tooltip.trigger && (this.config.tooltip.trigger = "hover"), $785da19a645c07eb$var$bK.isNil(this.config.visible) && (this.config.visible = !0), $785da19a645c07eb$var$bK.isNil(this.config.zIndex) && (this.config.zIndex = 1), $785da19a645c07eb$var$bK.isNil(this.config.opacity) && (this.config.opacity = 1), this.config.rotation) {
            const e1 = this.config.rotation;
            this.config.rotation = "object" == typeof e1 ? {
                yaw: e1.yaw ? $785da19a645c07eb$var$bK.parseAngle(e1.yaw, !0, !1) : 0,
                pitch: e1.pitch ? $785da19a645c07eb$var$bK.parseAngle(e1.pitch, !0, !1) : 0,
                roll: e1.roll ? $785da19a645c07eb$var$bK.parseAngle(e1.roll, !0, !1) : 0
            } : {
                yaw: 0,
                pitch: 0,
                roll: $785da19a645c07eb$var$bK.parseAngle(e1, !0, !1)
            };
        } else this.config.rotation = {
            yaw: 0,
            pitch: 0,
            roll: 0
        };
        this.state.anchor = $785da19a645c07eb$var$bK.parsePoint(this.config.anchor);
    }
    getListContent() {
        return this.config.listContent ? this.config.listContent : this.config.tooltip?.content ? this.config.tooltip.content : this.config.html ? this.config.html : this.id;
    }
    showTooltip(e1, t, i = !1) {
        if (this.state.visible && this.config.tooltip?.content && this.state.position2D) {
            const n = {
                ...this.config.tooltip,
                style: {
                    pointerEvents: this.state.staticTooltip ? "auto" : "none"
                },
                data: this,
                top: 0,
                left: 0
            };
            if (this.isPoly() || this.is3d() || this.isCss3d()) {
                if (e1 || t) {
                    const i = $785da19a645c07eb$var$bK.getPosition(this.viewer.container);
                    n.top = t - i.y + 10, n.left = e1 - i.x, n.box = {
                        width: 20,
                        height: 20
                    };
                } else n.top = this.state.position2D.y, n.left = this.state.position2D.x;
            } else {
                const e1 = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                let t = this.state.size.width, i = this.state.size.height;
                this.config.hoverScale && !this.state.staticTooltip && (t *= this.config.hoverScale.amount, i *= this.config.hoverScale.amount), n.top = e1.y - i * this.state.anchor.y + i / 2, n.left = e1.x - t * this.state.anchor.x + t / 2, n.box = {
                    width: t,
                    height: i
                };
            }
            this.tooltip ? i ? this.tooltip.update(this.config.tooltip.content, n) : this.tooltip.move(n) : this.tooltip = this.viewer.createTooltip(n);
        }
    }
    hideTooltip() {
        this.tooltip && (this.tooltip.hide(), this.tooltip = null);
    }
}, $785da19a645c07eb$var$M$ = class extends $785da19a645c07eb$var$S$ {
    get domElement() {
        return this.element;
    }
    constructor(e1, t, i){
        super(e1, t, i);
    }
    afterCreateElement() {
        this.element[$785da19a645c07eb$var$c$] = this;
    }
    destroy() {
        delete this.element[$785da19a645c07eb$var$c$], super.destroy();
    }
    update(e1) {
        super.update(e1);
        const t = this.domElement;
        t.id = `psv-marker-${this.config.id}`, t.setAttribute("class", "psv-marker"), this.state.visible && t.classList.add("psv-marker--visible"), this.config.tooltip && t.classList.add("psv-marker--has-tooltip"), this.config.content && t.classList.add("psv-marker--has-content"), this.config.className && $785da19a645c07eb$var$bK.addClasses(t, this.config.className), t.style.opacity = `${this.config.opacity}`, t.style.zIndex = `${30 + this.config.zIndex}`, this.config.style && Object.assign(t.style, this.config.style);
    }
}, $785da19a645c07eb$var$C$ = class extends $785da19a645c07eb$var$M$ {
    constructor(e1, t, i){
        super(e1, t, i);
    }
    afterCreateElement() {
        super.afterCreateElement(), this.domElement.addEventListener("transitionend", ()=>{
            this.domElement.style.transition = "";
        });
    }
    render({ viewerPosition: e1, zoomLevel: t, hoveringMarker: i }) {
        this.__updateSize();
        const n = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
        n.x -= this.state.size.width * this.state.anchor.x, n.y -= this.state.size.height * this.state.anchor.y;
        return this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && n.x + this.state.size.width >= 0 && n.x - this.state.size.width <= this.viewer.state.size.width && n.y + this.state.size.height >= 0 && n.y - this.state.size.height <= this.viewer.state.size.height ? (this.domElement.style.translate = `${n.x}px ${n.y}px 0px`, this.applyScale({
            zoomLevel: t,
            viewerPosition: e1,
            mouseover: this === i
        }), n) : null;
    }
    update(e1) {
        if (super.update(e1), !$785da19a645c07eb$var$bK.isExtendedPosition(this.config.position)) throw new $785da19a645c07eb$var$tX(`missing marker ${this.id} position`);
        try {
            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
        } catch (e1) {
            throw new $785da19a645c07eb$var$tX(`invalid marker ${this.id} position`, e1);
        }
        this.state.positions3D = [
            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
        ];
        const t = this.domElement;
        t.classList.add("psv-marker--normal"), this.config.scale && Array.isArray(this.config.scale) && (this.config.scale = {
            zoom: this.config.scale
        }), "boolean" == typeof this.config.hoverScale ? this.config.hoverScale = this.config.hoverScale ? this.plugin.config.defaultHoverScale || $785da19a645c07eb$var$p$ : null : "number" == typeof this.config.hoverScale ? this.config.hoverScale = {
            amount: this.config.hoverScale
        } : this.config.hoverScale || (this.config.hoverScale = this.plugin.config.defaultHoverScale), this.config.hoverScale && (this.config.hoverScale = {
            ...this.plugin.config.defaultHoverScale,
            ...this.config.hoverScale
        }), t.style.rotate = 0 !== this.config.rotation.roll ? $785da19a645c07eb$var$xj.radToDeg(this.config.rotation.roll) + "deg" : null, t.style.transformOrigin = `${100 * this.state.anchor.x}% ${100 * this.state.anchor.y}%`;
    }
    __updateSize() {
        if (!this.needsUpdateSize) return;
        const e1 = this.domElement, t = !this.state.visible || !this.state.size;
        if (t && e1.classList.add("psv-marker--transparent"), this.isSvg()) {
            const t = e1.firstElementChild.getBoundingClientRect();
            this.state.size = {
                width: t.width,
                height: t.height
            };
        } else this.state.size = {
            width: e1.offsetWidth,
            height: e1.offsetHeight
        };
        t && e1.classList.remove("psv-marker--transparent"), this.isSvg() && (e1.style.width = this.state.size.width + "px", e1.style.height = this.state.size.height + "px"), "element" !== this.type && (this.needsUpdateSize = !1);
    }
    applyScale({ zoomLevel: e1, viewerPosition: t, mouseover: i }) {
        null !== i && this.config.hoverScale && (this.domElement.style.transition = `scale ${this.config.hoverScale.duration}ms ${this.config.hoverScale.easing}`);
        let n = 1;
        if ("function" == typeof this.config.scale) n = this.config.scale(e1, t);
        else if (this.config.scale) {
            if (Array.isArray(this.config.scale.zoom)) {
                const [t, i] = this.config.scale.zoom;
                n *= t + (i - t) * $785da19a645c07eb$var$sK.EASINGS.inQuad(e1 / 100);
            }
            if (Array.isArray(this.config.scale.yaw)) {
                const [e1, i] = this.config.scale.yaw, a = $785da19a645c07eb$var$xj.degToRad(this.viewer.state.hFov) / 2, r = Math.abs($785da19a645c07eb$var$bK.getShortestArc(this.state.position.yaw, t.yaw));
                n *= i + (e1 - i) * $785da19a645c07eb$var$sK.EASINGS.outQuad(Math.max(0, (a - r) / a));
            }
        }
        i && this.config.hoverScale && (n *= this.config.hoverScale.amount), this.domElement.style.scale = `${n}`;
    }
}, $785da19a645c07eb$var$T$ = class extends $785da19a645c07eb$var$FG {
    get map() {
        return this.uniforms.map.value;
    }
    set map(e1) {
        this.uniforms.map.value = e1;
    }
    set alpha(e1) {
        this.uniforms.alpha.value = e1;
    }
    get offset() {
        return this.uniforms.offset.value;
    }
    get repeat() {
        return this.uniforms.repeat.value;
    }
    set chromaKey(e1) {
        this.uniforms.keying.value = !0 === e1?.enabled, e1?.enabled && ("object" == typeof e1.color && "r" in e1.color ? this.uniforms.color.value.set(e1.color.r / 255, e1.color.g / 255, e1.color.b / 255) : this.uniforms.color.value.set(e1.color ?? 65280), this.uniforms.similarity.value = e1.similarity ?? .2, this.uniforms.smoothness.value = e1.smoothness ?? .2);
    }
    constructor(e1){
        super({
            transparent: !0,
            depthTest: !1,
            depthWrite: !1,
            uniforms: {
                map: {
                    value: e1?.map
                },
                repeat: {
                    value: new $785da19a645c07eb$var$bj(1, 1)
                },
                offset: {
                    value: new $785da19a645c07eb$var$bj(0, 0)
                },
                alpha: {
                    value: e1?.alpha ?? 1
                },
                keying: {
                    value: !1
                },
                color: {
                    value: new $785da19a645c07eb$var$TV(65280)
                },
                similarity: {
                    value: .2
                },
                smoothness: {
                    value: .2
                },
                spill: {
                    value: .1
                }
            },
            vertexShader: "varying vec2 vUv;\nuniform vec2 repeat;\nuniform vec2 offset;\n\nvoid main() {\n    vUv = uv * repeat + offset;\n    gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}\n",
            fragmentShader: "// https://www.8thwall.com/playground/chromakey-threejs\n\nuniform sampler2D map;\nuniform float alpha;\nuniform bool keying;\nuniform vec3 color;\nuniform float similarity;\nuniform float smoothness;\nuniform float spill;\n\nvarying vec2 vUv;\n\nvec2 RGBtoUV(vec3 rgb) {\n    return vec2(\n        rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,\n        rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5\n    );\n}\n\nvoid main(void) {\n    gl_FragColor = texture2D(map, vUv);\n\n    if (keying) {\n        float chromaDist = distance(RGBtoUV(gl_FragColor.rgb), RGBtoUV(color));\n\n        float baseMask = chromaDist - similarity;\n        float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);\n        gl_FragColor.a *= fullMask * alpha;\n\n        float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);\n        float desat = clamp(gl_FragColor.r * 0.2126 + gl_FragColor.g * 0.7152 + gl_FragColor.b * 0.0722, 0., 1.);\n        gl_FragColor.rgb = mix(vec3(desat, desat, desat), gl_FragColor.rgb, spillVal);\n    } else {\n        gl_FragColor.a *= alpha;\n    }\n}\n"
        }), this.chromaKey = e1?.chromaKey;
    }
};
function $785da19a645c07eb$var$D$(e1, t, i) {
    const [n, a] = e1, [r, s] = t, o = $785da19a645c07eb$var$bK.greatArcDistance(e1, t), l = Math.sin((1 - i) * o) / Math.sin(o), c = Math.sin(i * o) / Math.sin(o), u = l * Math.cos(a) * Math.cos(n) + c * Math.cos(s) * Math.cos(r), h = l * Math.cos(a) * Math.sin(n) + c * Math.cos(s) * Math.sin(r), d = l * Math.sin(a) + c * Math.sin(s);
    return [
        Math.atan2(h, u),
        Math.atan2(d, Math.sqrt(u * u + h * h))
    ];
}
function $785da19a645c07eb$var$P$(e1) {
    return e1.reduce((e1, t)=>e1.add(t), new $785da19a645c07eb$var$Ej).normalize();
}
function $785da19a645c07eb$var$I$(e1) {
    const t = function(e1) {
        const t = [
            e1[0]
        ];
        let i = 0;
        for(let n = 1; n < e1.length; n++){
            const a = e1[n - 1][0] - e1[n][0];
            a > Math.PI ? i += 1 : a < -Math.PI && (i -= 1), t.push([
                e1[n][0] + 2 * i * Math.PI,
                e1[n][1]
            ]);
        }
        return t;
    }(e1);
    let i = 0;
    const n = [];
    for(let e1 = 0; e1 < t.length - 1; e1++){
        const a = $785da19a645c07eb$var$bK.greatArcDistance(t[e1], t[e1 + 1]) * $785da19a645c07eb$var$sK.SPHERE_RADIUS;
        n.push(a), i += a;
    }
    let a = 0;
    for(let e1 = 0; e1 < t.length - 1; e1++){
        if (a + n[e1] > i / 2) {
            const r = (i / 2 - a) / n[e1];
            return $785da19a645c07eb$var$D$(t[e1], t[e1 + 1], r);
        }
        a += n[e1];
    }
    return t[Math.round(t.length / 2)];
}
var $785da19a645c07eb$var$F$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$z$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$R$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$L$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$B$ = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$O$ = new $785da19a645c07eb$var$Ej;
function $785da19a645c07eb$var$U$(e1, t, i) {
    $785da19a645c07eb$var$F$.copy(i).normalize(), $785da19a645c07eb$var$z$.crossVectors(e1, t).normalize(), $785da19a645c07eb$var$R$.crossVectors($785da19a645c07eb$var$z$, e1).normalize(), $785da19a645c07eb$var$L$.copy(e1).multiplyScalar(-$785da19a645c07eb$var$F$.dot($785da19a645c07eb$var$R$)), $785da19a645c07eb$var$B$.copy($785da19a645c07eb$var$R$).multiplyScalar($785da19a645c07eb$var$F$.dot(e1));
    const n = (new $785da19a645c07eb$var$Ej).addVectors($785da19a645c07eb$var$L$, $785da19a645c07eb$var$B$).normalize();
    return $785da19a645c07eb$var$O$.crossVectors(n, $785da19a645c07eb$var$F$), n.applyAxisAngle($785da19a645c07eb$var$O$, .01).multiplyScalar($785da19a645c07eb$var$sK.SPHERE_RADIUS);
}
var $785da19a645c07eb$var$N$ = class extends $785da19a645c07eb$var$S$ {
    get threeElement() {
        return this.element;
    }
    get threeMesh() {
        return this.threeElement.children[0];
    }
    get video() {
        return "videoLayer" === this.type ? this.threeMesh.material.map.image : null;
    }
    constructor(e1, t, i){
        super(e1, t, i);
    }
    is3d() {
        return !0;
    }
    createElement() {
        const e1 = new $785da19a645c07eb$var$T$({
            alpha: 0
        }), t = new $785da19a645c07eb$var$EG(1, 1), i = new $785da19a645c07eb$var$Kq(t, e1);
        i.userData = {
            [$785da19a645c07eb$var$c$]: this
        }, Object.defineProperty(i, "visible", {
            enumerable: !0,
            get: function() {
                return this.userData[$785da19a645c07eb$var$c$].config.visible;
            },
            set: function(e1) {
                this.userData[$785da19a645c07eb$var$c$].config.visible = e1;
            }
        }), this.element = (new $785da19a645c07eb$var$bV).add(i), "videoLayer" === this.type && this.viewer.needsContinuousUpdate(!0);
    }
    destroy() {
        delete this.threeMesh.userData[$785da19a645c07eb$var$c$], "videoLayer" === this.type && (this.video.pause(), this.viewer.needsContinuousUpdate(!1)), super.destroy();
    }
    render() {
        return this.viewer.renderer.isObjectVisible(this.threeMesh) ? this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position) : null;
    }
    update(e1) {
        super.update(e1);
        const t = this.threeMesh, i = t.parent, n = t.material;
        if ($785da19a645c07eb$var$bK.isExtendedPosition(this.config.position)) {
            try {
                this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
            } catch (e1) {
                throw new $785da19a645c07eb$var$tX(`invalid marker ${this.id} position`, e1);
            }
            if (!this.config.size) throw new $785da19a645c07eb$var$tX(`missing marker ${this.id} size`);
            this.state.size = this.config.size, t.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1), t.position.set(t.scale.x * (.5 - this.state.anchor.x), t.scale.y * (this.state.anchor.y - .5), 0), t.rotation.set(0, 0, 0), this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position, i.position), i.lookAt(0, i.position.y, 0), t.rotateY(-this.config.rotation.yaw), t.rotateX(-this.config.rotation.pitch), t.rotateZ(-this.config.rotation.roll);
            const e1 = t.geometry.getAttribute("position");
            this.state.positions3D = [
                0,
                1,
                3,
                2
            ].map((i)=>{
                const n = new $785da19a645c07eb$var$Ej;
                return n.fromBufferAttribute(e1, i), t.localToWorld(n);
            });
        } else {
            if (4 !== this.config.position?.length) throw new $785da19a645c07eb$var$tX(`missing marker ${this.id} position`);
            let e1;
            try {
                e1 = this.config.position.map((e1)=>this.viewer.dataHelper.cleanPosition(e1));
            } catch (e1) {
                throw new $785da19a645c07eb$var$tX(`invalid marker ${this.id} position`, e1);
            }
            const i = e1.map((e1)=>this.viewer.dataHelper.sphericalCoordsToVector3(e1)), a = $785da19a645c07eb$var$P$(i);
            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(a), this.state.positions3D = i;
            const r = t.geometry.getAttribute("position");
            [
                i[0],
                i[1],
                i[3],
                i[2]
            ].forEach((e1, t)=>{
                r.setX(t, e1.x), r.setY(t, e1.y), r.setZ(t, e1.z);
            }), r.needsUpdate = !0, this.__setTextureWrap(n);
        }
        switch(this.type){
            case "videoLayer":
                if (this.definition !== this.config.videoLayer) {
                    n.map?.dispose();
                    const e1 = function({ src: e1, withCredentials: t, muted: i, autoplay: n }) {
                        const a = document.createElement("video");
                        return a.crossOrigin = t ? "use-credentials" : "anonymous", a.loop = !0, a.playsInline = !0, a.autoplay = n, a.muted = i, a.preload = "metadata", e1 instanceof MediaStream ? a.srcObject = e1 : a.src = e1, a;
                    }({
                        src: this.config.videoLayer,
                        withCredentials: this.viewer.config.withCredentials(this.config.videoLayer),
                        muted: !0,
                        autoplay: this.config.autoplay ?? !0
                    }), i = new $785da19a645c07eb$var$_G(e1);
                    n.map = i, n.alpha = 0, e1.addEventListener("loadedmetadata", ()=>{
                        this.viewer && (n.alpha = this.config.opacity, $785da19a645c07eb$var$bK.isExtendedPosition(this.config.position) || (t.material.userData[$785da19a645c07eb$var$c$] = {
                            width: e1.videoWidth,
                            height: e1.videoHeight
                        }, this.__setTextureWrap(n)));
                    }, {
                        once: !0
                    }), e1.autoplay && e1.play(), this.definition = this.config.videoLayer;
                } else n.alpha = this.config.opacity;
                break;
            case "imageLayer":
                if (this.definition !== this.config.imageLayer) {
                    n.map?.dispose();
                    const e1 = new $785da19a645c07eb$var$Vj;
                    n.map = e1, n.alpha = 0, this.viewer.textureLoader.loadImage(this.config.imageLayer).then((i)=>{
                        this.viewer && ($785da19a645c07eb$var$bK.isExtendedPosition(this.config.position) || (t.material.userData[$785da19a645c07eb$var$c$] = {
                            width: i.width,
                            height: i.height
                        }, this.__setTextureWrap(n)), e1.image = i, e1.anisotropy = 4, e1.needsUpdate = !0, n.alpha = this.config.opacity, this.viewer.needsUpdate());
                    }), this.definition = this.config.imageLayer;
                } else n.alpha = this.config.opacity;
        }
        n.chromaKey = this.config.chromaKey, t.renderOrder = 1e3 + this.config.zIndex, t.geometry.boundingBox = null;
    }
    __setTextureWrap(e1) {
        const t = e1.userData[$785da19a645c07eb$var$c$];
        if (!t || !t.height || !t.width) return e1.repeat.set(1, 1), void e1.offset.set(0, 0);
        const i = this.config.position.map((e1)=>this.viewer.dataHelper.cleanPosition(e1)), n = ($785da19a645c07eb$var$bK.greatArcDistance([
            i[0].yaw,
            i[0].pitch
        ], [
            i[1].yaw,
            i[1].pitch
        ]) + $785da19a645c07eb$var$bK.greatArcDistance([
            i[3].yaw,
            i[3].pitch
        ], [
            i[2].yaw,
            i[2].pitch
        ])) / ($785da19a645c07eb$var$bK.greatArcDistance([
            i[1].yaw,
            i[1].pitch
        ], [
            i[2].yaw,
            i[2].pitch
        ]) + $785da19a645c07eb$var$bK.greatArcDistance([
            i[0].yaw,
            i[0].pitch
        ], [
            i[3].yaw,
            i[3].pitch
        ])), a = t.width / t.height;
        let r = 0, s = 0;
        n < a ? r = a - n : s = 1 / a - 1 / n, e1.repeat.set(1 - r, 1 - s), e1.offset.set(r / 2, s / 2);
    }
}, $785da19a645c07eb$var$j$ = class extends $785da19a645c07eb$var$M$ {
    constructor(e1, t, i){
        super(e1, t, i), this.viewportIntersection = !1;
    }
    get threeElement() {
        return this.object;
    }
    isCss3d() {
        return !0;
    }
    createElement() {
        this.element = document.createElement("div"), this.object = new $785da19a645c07eb$var$v$(this.element), this.object.userData = {
            [$785da19a645c07eb$var$c$]: this
        }, Object.defineProperty(this.object, "visible", {
            enumerable: !0,
            get: function() {
                return this.userData[$785da19a645c07eb$var$c$].config.visible;
            },
            set: function(e1) {
                this.userData[$785da19a645c07eb$var$c$].config.visible = e1;
            }
        }), this.afterCreateElement();
    }
    destroy() {
        delete this.object.userData[$785da19a645c07eb$var$c$], delete this.object, super.destroy();
    }
    render({ viewerPosition: e1, zoomLevel: t }) {
        const i = this.domElement;
        this.state.size = {
            width: i.offsetWidth,
            height: i.offsetHeight
        };
        if (this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && this.viewportIntersection) {
            const i = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
            return this.config.elementLayer.updateMarker?.({
                marker: this,
                position: i,
                viewerPosition: e1,
                zoomLevel: t,
                viewerSize: this.viewer.state.size
            }), i;
        }
        return null;
    }
    update(e1) {
        if (super.update(e1), !$785da19a645c07eb$var$bK.isExtendedPosition(this.config.position)) throw new $785da19a645c07eb$var$tX(`missing marker ${this.id} position`);
        try {
            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
        } catch (e1) {
            throw new $785da19a645c07eb$var$tX(`invalid marker ${this.id} position`, e1);
        }
        this.state.positions3D = [
            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
        ];
        const t = this.threeElement, i = this.domElement;
        i.classList.add("psv-marker--css3d"), i.childNodes.forEach((e1)=>e1.remove()), i.appendChild(this.config.elementLayer), this.config.elementLayer.style.display = "block", t.position.copy(this.state.positions3D[0]).multiplyScalar(100), t.lookAt(0, 100 * this.state.positions3D[0].y, 0), t.rotateY(-this.config.rotation.yaw), t.rotateX(-this.config.rotation.pitch), t.rotateZ(-this.config.rotation.roll);
    }
}, $785da19a645c07eb$var$V$ = class extends $785da19a645c07eb$var$C$ {
    constructor(e1, t, i){
        super(e1, t, i);
    }
    isNormal() {
        return !0;
    }
    createElement() {
        this.element = document.createElement("div"), this.afterCreateElement();
    }
    render(e1) {
        const t = super.render(e1);
        return t && "element" === this.type && this.config.element.updateMarker?.({
            marker: this,
            position: t,
            viewerPosition: e1.viewerPosition,
            zoomLevel: e1.zoomLevel,
            viewerSize: this.viewer.state.size
        }), t;
    }
    update(e1) {
        super.update(e1);
        const t = this.domElement;
        if (this.config.image && !this.config.size) throw new $785da19a645c07eb$var$tX(`missing marker ${this.id} size`);
        switch(this.config.size ? (this.needsUpdateSize = !1, this.state.size = this.config.size, t.style.width = this.config.size.width + "px", t.style.height = this.config.size.height + "px") : this.needsUpdateSize = !0, this.type){
            case "image":
                this.definition = this.config.image, t.style.backgroundImage = `url("${this.config.image}")`;
                break;
            case "html":
                this.definition = this.config.html, t.innerHTML = this.config.html;
                break;
            case "element":
                this.definition !== this.config.element && (this.definition = this.config.element, t.childNodes.forEach((e1)=>e1.remove()), t.appendChild(this.config.element), this.config.element.style.display = "block");
        }
    }
}, $785da19a645c07eb$var$q$ = class extends $785da19a645c07eb$var$M$ {
    constructor(e1, t, i){
        super(e1, t, i);
    }
    createElement() {
        this.element = document.createElementNS($785da19a645c07eb$var$l$, "path"), this.element[$785da19a645c07eb$var$c$] = this;
    }
    isPoly() {
        return !0;
    }
    get isPixels() {
        return "polygonPixels" === this.type || "polylinePixels" === this.type;
    }
    get isPolygon() {
        return "polygon" === this.type || "polygonPixels" === this.type;
    }
    get isPolyline() {
        return "polyline" === this.type || "polylinePixels" === this.type;
    }
    get coords() {
        return this.definition;
    }
    render() {
        const e1 = this.__getAllPolyPositions();
        if (e1[0].length > (this.isPolygon ? 2 : 1)) {
            const t = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position), i = e1.filter((e1)=>e1.length > 0).map((e1)=>{
                let i = "M";
                return i += e1.map((e1)=>`${e1.x - t.x},${e1.y - t.y}`).join("L"), this.isPolygon && (i += "Z"), i;
            }).join(" ");
            return this.domElement.setAttributeNS(null, "d", i), this.domElement.setAttributeNS(null, "transform", `translate(${t.x} ${t.y})`), t;
        }
        return null;
    }
    update(e1) {
        super.update(e1);
        const t = this.domElement;
        t.classList.add("psv-marker--poly"), this.config.svgStyle ? (Object.entries(this.config.svgStyle).forEach(([e1, i])=>{
            t.setAttributeNS(null, $785da19a645c07eb$var$bK.dasherize(e1), i);
        }), this.isPolyline && !this.config.svgStyle.fill && t.setAttributeNS(null, "fill", "none")) : this.isPolygon ? t.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)") : this.isPolyline && (t.setAttributeNS(null, "fill", "none"), t.setAttributeNS(null, "stroke", "rgb(0,0,0)"));
        try {
            let e1 = this.config[this.type];
            if (!Array.isArray(e1[0]) && "object" != typeof e1[0]) for(let t = 0; t < e1.length; t++)e1.splice(t, 2, [
                e1[t],
                e1[t + 1]
            ]);
            if (Array.isArray(e1[0][0]) || "object" == typeof e1[0][0] || (e1 = [
                e1
            ]), this.isPolyline && e1.length > 1) throw new $785da19a645c07eb$var$tX("polylines cannot have holes");
            this.isPixels ? this.definition = e1.map((e1)=>e1.map((e1)=>{
                    let t;
                    return t = $785da19a645c07eb$var$bK.isExtendedPosition(e1) ? this.viewer.dataHelper.cleanPosition(e1) : this.viewer.dataHelper.textureCoordsToSphericalCoords({
                        textureX: e1[0],
                        textureY: e1[1]
                    }), [
                        t.yaw,
                        t.pitch
                    ];
                })) : this.definition = e1.map((e1)=>e1.map((e1)=>{
                    let t;
                    return t = $785da19a645c07eb$var$bK.isExtendedPosition(e1) ? this.viewer.dataHelper.cleanPosition(e1) : this.viewer.dataHelper.cleanPosition({
                        yaw: e1[0],
                        pitch: e1[1]
                    }), [
                        t.yaw,
                        t.pitch
                    ];
                }));
        } catch (e1) {
            throw new $785da19a645c07eb$var$tX(`invalid marker ${this.id} position`, e1);
        }
        if (this.positions3D = this.coords.map((e1)=>e1.map((e1)=>this.viewer.dataHelper.sphericalCoordsToVector3({
                    yaw: e1[0],
                    pitch: e1[1]
                }))), this.isPolygon) {
            const e1 = $785da19a645c07eb$var$P$(this.positions3D[0]);
            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(e1);
        } else {
            const e1 = $785da19a645c07eb$var$I$(this.coords[0]);
            this.state.position = {
                yaw: e1[0],
                pitch: e1[1]
            };
        }
        this.state.positions3D = this.positions3D[0];
    }
    __getAllPolyPositions() {
        return this.positions3D.map((e1)=>this.__getPolyPositions(e1));
    }
    __getPolyPositions(e1) {
        const t = e1.length, i = e1.map((e1)=>({
                vector: e1,
                visible: e1.dot(this.viewer.state.direction) > 0
            })), n = [];
        return i.forEach((e1, a)=>{
            if (!e1.visible) [
                0 === a ? i[t - 1] : i[a - 1],
                a === t - 1 ? i[0] : i[a + 1]
            ].forEach((t)=>{
                t.visible && n.push({
                    visible: t.vector,
                    invisible: e1.vector,
                    index: a
                });
            });
        }), n.reverse().forEach((e1)=>{
            i.splice(e1.index, 0, {
                vector: $785da19a645c07eb$var$U$(e1.visible, e1.invisible, this.viewer.state.direction),
                visible: !0
            });
        }), i.filter((e1)=>e1.visible).map((e1)=>this.viewer.dataHelper.vector3ToViewerCoords(e1.vector));
    }
}, $785da19a645c07eb$var$G$ = class extends $785da19a645c07eb$var$C$ {
    get svgElement() {
        return this.domElement.firstElementChild;
    }
    constructor(e1, t, i){
        super(e1, t, i);
    }
    isSvg() {
        return !0;
    }
    createElement() {
        const e1 = "square" === this.type ? "rect" : this.type, t = document.createElementNS($785da19a645c07eb$var$l$, e1);
        this.element = document.createElementNS($785da19a645c07eb$var$l$, "svg"), this.element.appendChild(t), this.afterCreateElement();
    }
    update(e1) {
        super.update(e1);
        const t = this.svgElement;
        switch(this.needsUpdateSize = !0, this.type){
            case "square":
                this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.square,
                    height: this.config.square
                };
                break;
            case "rect":
                Array.isArray(this.config.rect) ? this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.rect[0],
                    height: this.config.rect[1]
                } : this.definition = {
                    x: 0,
                    y: 0,
                    width: this.config.rect.width,
                    height: this.config.rect.height
                };
                break;
            case "circle":
                this.definition = {
                    cx: this.config.circle,
                    cy: this.config.circle,
                    r: this.config.circle
                };
                break;
            case "ellipse":
                Array.isArray(this.config.ellipse) ? this.definition = {
                    cx: this.config.ellipse[0],
                    cy: this.config.ellipse[1],
                    rx: this.config.ellipse[0],
                    ry: this.config.ellipse[1]
                } : this.definition = {
                    cx: this.config.ellipse.rx,
                    cy: this.config.ellipse.ry,
                    rx: this.config.ellipse.rx,
                    ry: this.config.ellipse.ry
                };
                break;
            case "path":
                this.definition = {
                    d: this.config.path
                };
        }
        Object.entries(this.definition).forEach(([e1, i])=>{
            t.setAttributeNS(null, e1, i);
        }), this.config.svgStyle ? Object.entries(this.config.svgStyle).forEach(([e1, i])=>{
            t.setAttributeNS(null, $785da19a645c07eb$var$bK.dasherize(e1), i);
        }) : t.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
    }
}, $785da19a645c07eb$var$H$ = $785da19a645c07eb$var$bK.getConfigParser({
    clickEventOnMarker: !1,
    gotoMarkerSpeed: "8rpm",
    markers: null,
    defaultHoverScale: null
}, {
    defaultHoverScale: (e1)=>e1 ? (!0 === e1 && (e1 = $785da19a645c07eb$var$p$), "number" == typeof e1 && (e1 = {
            amount: e1
        }), {
            ...$785da19a645c07eb$var$p$,
            ...e1
        }) : null
});
var $785da19a645c07eb$var$W$ = class e1 extends $785da19a645c07eb$var$xY {
    constructor(e1, t){
        super(e1, t), this.markers = {}, this.state = {
            allVisible: !0,
            showAllTooltips: !1,
            currentMarker: null,
            hoveringMarker: null,
            needsReRender: !1,
            lastClientX: null,
            lastClientY: null
        }, this.container = document.createElement("div"), this.container.className = "psv-markers", this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.svgContainer = document.createElementNS($785da19a645c07eb$var$l$, "svg"), this.svgContainer.setAttribute("class", "psv-markers-svg-container"), this.container.appendChild(this.svgContainer), this.css3DContainer = new $785da19a645c07eb$var$w$(e1), this.container.appendChild(this.css3DContainer.element), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0);
    }
    static withConfig(t) {
        return [
            e1,
            t
        ];
    }
    init() {
        super.init(), $785da19a645c07eb$var$bK.checkStylesheet(this.viewer.container, "markers-plugin"), this.viewer.addEventListener($785da19a645c07eb$var$BX.ClickEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.DoubleClickEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ConfigChangedEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ObjectEnterEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ObjectHoverEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ObjectLeaveEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this, {
            once: !0
        });
    }
    destroy() {
        this.clearMarkers(!1), this.viewer.unobserveObjects($785da19a645c07eb$var$c$), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ClickEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.DoubleClickEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.RenderEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ObjectEnterEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ObjectHoverEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ObjectLeaveEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ReadyEvent.type, this), this.css3DContainer.destroy(), this.viewer.container.removeChild(this.container), super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case $785da19a645c07eb$var$BX.ReadyEvent.type:
                this.config.markers && (this.setMarkers(this.config.markers), delete this.config.markers);
                break;
            case $785da19a645c07eb$var$BX.RenderEvent.type:
                this.renderMarkers();
                break;
            case $785da19a645c07eb$var$BX.ClickEvent.type:
                this.__onClick(e1, !1);
                break;
            case $785da19a645c07eb$var$BX.DoubleClickEvent.type:
                this.__onClick(e1, !0);
                break;
            case $785da19a645c07eb$var$BX.ObjectEnterEvent.type:
            case $785da19a645c07eb$var$BX.ObjectLeaveEvent.type:
            case $785da19a645c07eb$var$BX.ObjectHoverEvent.type:
                if (e1.userDataKey === $785da19a645c07eb$var$c$) {
                    const t = e1.originalEvent, i = e1.object.userData[$785da19a645c07eb$var$c$];
                    switch(e1.type){
                        case $785da19a645c07eb$var$BX.ObjectEnterEvent.type:
                            i.config.style?.cursor ? this.viewer.setCursor(i.config.style.cursor) : (i.config.tooltip || i.config.content) && this.viewer.setCursor("pointer"), this.__onEnterMarker(t, i);
                            break;
                        case $785da19a645c07eb$var$BX.ObjectLeaveEvent.type:
                            this.viewer.setCursor(null), this.__onLeaveMarker(i);
                            break;
                        case $785da19a645c07eb$var$BX.ObjectHoverEvent.type:
                            this.__onHoverMarker(t, i);
                    }
                }
                break;
            case "mouseenter":
                {
                    const t = this.__getTargetMarker($785da19a645c07eb$var$bK.getEventTarget(e1));
                    this.__onEnterMarker(e1, t);
                    break;
                }
            case "mouseleave":
                {
                    const t = this.__getTargetMarker($785da19a645c07eb$var$bK.getEventTarget(e1));
                    this.__onLeaveMarker(t);
                    break;
                }
            case "mousemove":
                {
                    const t = this.__getTargetMarker($785da19a645c07eb$var$bK.getEventTarget(e1), !0);
                    this.__onHoverMarker(e1, t);
                    break;
                }
        }
    }
    toggleAllMarkers() {
        this.state.allVisible ? this.hideAllMarkers() : this.showAllMarkers();
    }
    showAllMarkers() {
        this.state.allVisible = !0, Object.values(this.markers).forEach((e1)=>{
            e1.config.visible = !0;
        }), this.renderMarkers(), this.dispatchEvent(new $785da19a645c07eb$var$n$);
    }
    hideAllMarkers() {
        this.state.allVisible = !1, Object.values(this.markers).forEach((e1)=>{
            e1.config.visible = !1;
        }), this.renderMarkers(), this.dispatchEvent(new $785da19a645c07eb$var$$J);
    }
    toggleAllTooltips() {
        this.state.showAllTooltips ? this.hideAllTooltips() : this.showAllTooltips();
    }
    showAllTooltips() {
        this.state.showAllTooltips = !0, Object.values(this.markers).forEach((e1)=>{
            e1.state.staticTooltip = !0, e1.showTooltip();
        });
    }
    hideAllTooltips() {
        this.state.showAllTooltips = !1, Object.values(this.markers).forEach((e1)=>{
            e1.state.staticTooltip = !1, e1.hideTooltip();
        });
    }
    getNbMarkers() {
        return Object.keys(this.markers).length;
    }
    getMarkers() {
        return Object.values(this.markers);
    }
    addMarker(e1, t = !0) {
        if (this.markers[e1.id]) throw new $785da19a645c07eb$var$tX(`marker "${e1.id}" already exists`);
        const i = new (function(e1) {
            switch($785da19a645c07eb$var$k$(e1, !1)){
                case "image":
                case "html":
                case "element":
                    return $785da19a645c07eb$var$V$;
                case "imageLayer":
                case "videoLayer":
                    return $785da19a645c07eb$var$N$;
                case "elementLayer":
                    return $785da19a645c07eb$var$j$;
                case "polygon":
                case "polyline":
                case "polygonPixels":
                case "polylinePixels":
                    return $785da19a645c07eb$var$q$;
                case "square":
                case "rect":
                case "circle":
                case "ellipse":
                case "path":
                    return $785da19a645c07eb$var$G$;
                default:
                    throw new $785da19a645c07eb$var$tX("invalid marker type");
            }
        }(e1))(this.viewer, this, e1);
        i.isPoly() ? this.svgContainer.appendChild(i.domElement) : i.isCss3d() ? this.css3DContainer.addObject(i) : i.is3d() ? this.viewer.renderer.addObject(i.threeElement) : this.container.appendChild(i.domElement), this.markers[i.id] = i, this.state.showAllTooltips && (i.state.staticTooltip = !0), t && this.__afterChangeMarkers();
    }
    getMarker(e1) {
        const t = "object" == typeof e1 ? e1.id : e1;
        if (!this.markers[t]) throw new $785da19a645c07eb$var$tX(`cannot find marker "${t}"`);
        return this.markers[t];
    }
    getCurrentMarker() {
        return this.state.currentMarker;
    }
    updateMarker(e1, t = !0) {
        const i = this.getMarker(e1.id);
        i.update(e1), t && (this.__afterChangeMarkers(), (i === this.state.hoveringMarker && "hover" === i.config.tooltip?.trigger || i.state.staticTooltip) && i.showTooltip(this.state.lastClientX, this.state.lastClientY, !0));
    }
    removeMarker(e1, t = !0) {
        const i = this.getMarker(e1);
        i.isPoly() ? this.svgContainer.removeChild(i.domElement) : i.isCss3d() ? this.css3DContainer.removeObject(i) : i.is3d() ? this.viewer.renderer.removeObject(i.threeElement) : this.container.removeChild(i.domElement), this.state.hoveringMarker === i && (this.state.hoveringMarker = null), this.state.currentMarker === i && (this.state.currentMarker = null), i.destroy(), delete this.markers[i.id], t && this.__afterChangeMarkers();
    }
    removeMarkers(e1, t = !0) {
        e1.forEach((e1)=>this.removeMarker(e1, !1)), t && this.__afterChangeMarkers();
    }
    setMarkers(e1, t = !0) {
        this.clearMarkers(!1), e1?.forEach((e1)=>{
            this.addMarker(e1, !1);
        }), t && this.__afterChangeMarkers();
    }
    clearMarkers(e1 = !0) {
        Object.keys(this.markers).forEach((e1)=>{
            this.removeMarker(e1, !1);
        }), e1 && this.__afterChangeMarkers();
    }
    gotoMarker(e1, t = this.config.gotoMarkerSpeed) {
        const i = this.getMarker(e1);
        return t ? this.viewer.animate({
            ...i.state.position,
            zoom: i.config.zoomLvl,
            speed: t
        }).then(()=>{
            this.dispatchEvent(new $785da19a645c07eb$var$jJ(i));
        }) : (this.viewer.rotate(i.state.position), $785da19a645c07eb$var$bK.isNil(i.config.zoomLvl) || this.viewer.zoom(i.config.zoomLvl), this.dispatchEvent(new $785da19a645c07eb$var$jJ(i)), Promise.resolve());
    }
    hideMarker(e1) {
        this.toggleMarker(e1, !1);
    }
    showMarker(e1) {
        this.toggleMarker(e1, !0);
    }
    showMarkerTooltip(e1) {
        const t = this.getMarker(e1);
        t.state.staticTooltip = !0, t.showTooltip();
    }
    hideMarkerTooltip(e1) {
        const t = this.getMarker(e1);
        t.state.staticTooltip = !1, t.hideTooltip();
    }
    toggleMarker(e1, t) {
        const i = this.getMarker(e1);
        i.config.visible = $785da19a645c07eb$var$bK.isNil(t) ? !i.config.visible : t, this.renderMarkers();
    }
    showMarkerPanel(e1) {
        const t = this.getMarker(e1);
        t.config.content ? this.viewer.panel.show({
            id: $785da19a645c07eb$var$h$,
            content: t.config.content
        }) : this.hideMarkerPanel();
    }
    hideMarkerPanel() {
        this.viewer.panel.hide($785da19a645c07eb$var$h$);
    }
    toggleMarkersList() {
        this.viewer.panel.isVisible($785da19a645c07eb$var$d$) ? this.hideMarkersList() : this.showMarkersList();
    }
    showMarkersList() {
        let e1 = [];
        Object.values(this.markers).forEach((t)=>{
            t.config.visible && !t.config.hideList && e1.push(t);
        });
        const t = new $785da19a645c07eb$var$r$(e1);
        this.dispatchEvent(t), e1 = t.markers, this.viewer.panel.show({
            id: $785da19a645c07eb$var$d$,
            content: $785da19a645c07eb$var$m$(e1, this.viewer.config.lang[$785da19a645c07eb$var$s$.id]),
            noMargin: !0,
            clickHandler: (e1)=>{
                const t = $785da19a645c07eb$var$bK.getClosest(e1, ".psv-panel-menu-item"), i = t ? t.dataset[$785da19a645c07eb$var$c$] : void 0;
                if (i) {
                    const e1 = this.getMarker(i);
                    this.dispatchEvent(new $785da19a645c07eb$var$XJ(e1)), this.gotoMarker(e1.id), this.hideMarkersList();
                }
            }
        });
    }
    hideMarkersList() {
        this.viewer.panel.hide($785da19a645c07eb$var$d$);
    }
    renderMarkers() {
        if (this.state.needsReRender) return void (this.state.needsReRender = !1);
        const e1 = this.viewer.getZoomLevel(), t = this.viewer.getPosition(), i = this.state.hoveringMarker;
        Object.values(this.markers).forEach((n)=>{
            let a = n.config.visible, r = null;
            a && (r = n.render({
                viewerPosition: t,
                zoomLevel: e1,
                hoveringMarker: i
            }), a = !!r);
            const s = n.state.visible !== a;
            n.state.visible = a, n.state.position2D = r, n.domElement && $785da19a645c07eb$var$bK.toggleClass(n.domElement, "psv-marker--visible", a), a ? n.state.staticTooltip ? n.showTooltip() : n !== this.state.hoveringMarker && n.hideTooltip() : n.hideTooltip(), s && (this.dispatchEvent(new $785da19a645c07eb$var$UJ(n, a)), (n.is3d() || n.isCss3d()) && (this.state.needsReRender = !0));
        }), this.state.needsReRender && this.viewer.needsUpdate();
    }
    __getTargetMarker(e1, t = !1) {
        if (e1 instanceof Node) {
            const i = t ? $785da19a645c07eb$var$bK.getClosest(e1, ".psv-marker") : e1;
            return i ? i[$785da19a645c07eb$var$c$] : void 0;
        }
        return Array.isArray(e1) ? e1.map((e1)=>e1.userData[$785da19a645c07eb$var$c$]).filter((e1)=>!!e1).sort((e1, t)=>t.config.zIndex - e1.config.zIndex)[0] : null;
    }
    __onEnterMarker(e1, t) {
        t && (this.state.hoveringMarker = t, this.state.lastClientX = e1.clientX, this.state.lastClientY = e1.clientY, this.dispatchEvent(new $785da19a645c07eb$var$HJ(t)), t instanceof $785da19a645c07eb$var$C$ && t.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: !0
        }), t.state.staticTooltip || "hover" !== t.config.tooltip?.trigger || t.showTooltip(e1.clientX, e1.clientY));
    }
    __onLeaveMarker(e1) {
        e1 && (this.dispatchEvent(new $785da19a645c07eb$var$qJ(e1)), e1 instanceof $785da19a645c07eb$var$C$ && e1.applyScale({
            zoomLevel: this.viewer.getZoomLevel(),
            viewerPosition: this.viewer.getPosition(),
            mouseover: !1
        }), this.state.hoveringMarker = null, e1.state.staticTooltip || "hover" !== e1.config.tooltip?.trigger ? e1.state.staticTooltip && e1.showTooltip() : e1.hideTooltip());
    }
    __onHoverMarker(e1, t) {
        t && (this.state.lastClientX = e1.clientX, this.state.lastClientY = e1.clientY, (t.isPoly() || t.is3d() || t.isCss3d()) && "hover" === t.config.tooltip?.trigger && t.showTooltip(e1.clientX, e1.clientY));
    }
    __onClick(e1, t) {
        const i = this.__getTargetMarker(e1.data.objects), n = this.__getTargetMarker(e1.data.target, !0) || i;
        this.state.currentMarker && this.state.currentMarker !== n && (this.dispatchEvent(new $785da19a645c07eb$var$YJ(this.state.currentMarker)), this.viewer.panel.hide($785da19a645c07eb$var$h$), this.state.showAllTooltips || "click" !== this.state.currentMarker.config.tooltip?.trigger || this.hideMarkerTooltip(this.state.currentMarker.id), this.state.currentMarker = null), n && (this.state.currentMarker = n, this.dispatchEvent(new $785da19a645c07eb$var$ZJ(n, t, e1.data.rightclick)), this.config.clickEventOnMarker ? e1.data.marker = n : e1.stopImmediatePropagation(), this.markers[n.id] && !e1.data.rightclick && ("click" === n.config.tooltip?.trigger ? n.tooltip ? this.hideMarkerTooltip(n.id) : this.showMarkerTooltip(n.id) : this.showMarkerPanel(n.id)));
    }
    __afterChangeMarkers() {
        this.__refreshUi(), this.__checkObjectsObserver(), this.viewer.needsUpdate(), this.dispatchEvent(new $785da19a645c07eb$var$t$(this.getMarkers()));
    }
    __refreshUi() {
        const e1 = Object.values(this.markers).filter((e1)=>!e1.config.hideList).length;
        0 === e1 ? (this.viewer.panel.hide($785da19a645c07eb$var$h$), this.viewer.panel.hide($785da19a645c07eb$var$d$)) : this.viewer.panel.isVisible($785da19a645c07eb$var$d$) ? this.showMarkersList() : this.viewer.panel.isVisible($785da19a645c07eb$var$h$) && (this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide()), this.viewer.navbar.getButton($785da19a645c07eb$var$s$.id, !1)?.toggle(e1 > 0), this.viewer.navbar.getButton($785da19a645c07eb$var$g$.id, !1)?.toggle(e1 > 0);
    }
    __checkObjectsObserver() {
        Object.values(this.markers).some((e1)=>e1.is3d()) ? this.viewer.observeObjects($785da19a645c07eb$var$c$) : this.viewer.unobserveObjects($785da19a645c07eb$var$c$);
    }
};
$785da19a645c07eb$var$W$.id = "markers", $785da19a645c07eb$var$W$.VERSION = "5.15.1", $785da19a645c07eb$var$W$.configParser = $785da19a645c07eb$var$H$, $785da19a645c07eb$var$W$.readonlyOptions = [
    "markers"
];
var $785da19a645c07eb$var$Z$ = $785da19a645c07eb$var$W$;
$785da19a645c07eb$var$wY.lang[$785da19a645c07eb$var$s$.id] = "Markers", $785da19a645c07eb$var$wY.lang[$785da19a645c07eb$var$g$.id] = "Markers list", $785da19a645c07eb$var$DY($785da19a645c07eb$var$s$, "caption:left"), $785da19a645c07eb$var$DY($785da19a645c07eb$var$g$, "caption:left");
/*!
 * Photo Sphere Viewer / Equirectangular Tiles Adapter 5.15.1
 * @copyright 2015-2026 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */ var $785da19a645c07eb$var$K$ = class {
    constructor(e1, t, i){
        this.id = e1, this.priority = t, this.fn = i, this.status = 1;
    }
    start() {
        return this.status = 2, this.fn(this).then(()=>{
            this.status = 4;
        }, ()=>{
            this.status = 5;
        });
    }
    cancel() {
        this.status = 3;
    }
    isCancelled() {
        return 3 === this.status;
    }
}, $785da19a645c07eb$var$X$ = class {
    constructor(e1 = 8){
        this.concurency = e1, this.runningTasks = {}, this.tasks = {};
    }
    enqueue(e1) {
        this.tasks[e1.id] = e1;
    }
    clear() {
        Object.values(this.tasks).forEach((e1)=>e1.cancel()), this.tasks = {}, this.runningTasks = {};
    }
    setPriority(e1, t) {
        const i = this.tasks[e1];
        i && (i.priority = t, 0 === i.status && (i.status = 1));
    }
    disableAllTasks() {
        Object.values(this.tasks).forEach((e1)=>{
            e1.status = 0;
        });
    }
    start() {
        if (Object.keys(this.runningTasks).length >= this.concurency) return;
        const e1 = Object.values(this.tasks).filter((e1)=>1 === e1.status).sort((e1, t)=>t.priority - e1.priority).pop();
        e1 && (this.runningTasks[e1.id] = !0, e1.start().then(()=>{
            e1.isCancelled() || (delete this.tasks[e1.id], delete this.runningTasks[e1.id], this.start());
        }), this.start());
    }
};
var $785da19a645c07eb$var$Q$ = [
    "dodgerblue",
    "limegreen",
    "indianred"
];
function $785da19a645c07eb$var$Y$(e1) {
    return !!e1.levels;
}
function $785da19a645c07eb$var$J$(e1, t, i) {
    return {
        ...e1,
        level: t,
        colSize: e1.width / e1.cols,
        rowSize: e1.width / 2 / e1.rows,
        facesByCol: i.SPHERE_SEGMENTS / e1.cols,
        facesByRow: i.SPHERE_HORIZONTAL_SEGMENTS / e1.rows
    };
}
function $785da19a645c07eb$var$$$(e1, t, i, n, a) {
    let r, s;
    return $785da19a645c07eb$var$Y$(e1) ? (n ? (s = e1.levels.findIndex((e1)=>{
        const a = e1.width / 360 * t, r = e1.width / 2 / 180 * i;
        return a >= n.width && r >= n.height;
    }), -1 === s && (s = e1.levels.length - 1)) : s = 0, r = e1.levels[s]) : (s = 0, r = {
        ...e1
    }), $785da19a645c07eb$var$J$(r, s, a);
}
function $785da19a645c07eb$var$e0(e1, t, i) {
    return $785da19a645c07eb$var$Y$(e1) && e1.levels[t] ? $785da19a645c07eb$var$J$(e1.levels[t], t, i) : null;
}
function $785da19a645c07eb$var$t0(e1, t) {
    if (!e1.width || !e1.cols || !e1.rows) throw new $785da19a645c07eb$var$tX("Invalid panorama configuration, are you using the right adapter?");
    if (e1.cols > t.SPHERE_SEGMENTS) throw new $785da19a645c07eb$var$tX(`Panorama cols must not be greater than ${t.SPHERE_SEGMENTS}.`);
    if (e1.rows > t.SPHERE_HORIZONTAL_SEGMENTS) throw new $785da19a645c07eb$var$tX(`Panorama rows must not be greater than ${t.SPHERE_HORIZONTAL_SEGMENTS}.`);
    if (!$785da19a645c07eb$var$xj.isPowerOfTwo(e1.cols) || !$785da19a645c07eb$var$xj.isPowerOfTwo(e1.rows)) throw new $785da19a645c07eb$var$tX("Panorama cols and rows must be powers of 2.");
}
function $785da19a645c07eb$var$i0(e1, t) {
    for(let i = 0; i < t.cols; i++){
        const n = e1.tileUrl(i, t.rows / 2, t.level);
        if (n) return n;
    }
    return e1.tileUrl.toString();
}
function $785da19a645c07eb$var$n0(e1) {
    return `${e1.col}x${e1.row}/${e1.config.level}`;
}
function $785da19a645c07eb$var$a0(e1) {
    return e1.children;
}
var $785da19a645c07eb$var$r0 = $785da19a645c07eb$var$bK.getConfigParser({
    resolution: 64,
    showErrorTile: !0,
    baseBlur: !0,
    antialias: !0,
    debug: !1,
    useXmpData: !1
}), $785da19a645c07eb$var$s0 = new $785da19a645c07eb$var$Ej, $785da19a645c07eb$var$o0 = class e1 extends $785da19a645c07eb$var$QQ {
    constructor(e1, t){
        super(e1), this.state = {
            tileConfig: null,
            tiles: {},
            faces: {},
            geom: null,
            materials: [],
            errorMaterial: null,
            inTransition: !1
        }, this.queue = new $785da19a645c07eb$var$X$, this.config = $785da19a645c07eb$var$r0(t), this.adapter = new $785da19a645c07eb$var$eY(this.viewer, {
            shader: !1,
            resolution: this.config.resolution
        }), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2, this.NB_VERTICES = 2 * this.SPHERE_SEGMENTS * 3 + (this.SPHERE_HORIZONTAL_SEGMENTS - 2) * this.SPHERE_SEGMENTS * 6, this.NB_GROUPS = this.SPHERE_SEGMENTS * this.SPHERE_HORIZONTAL_SEGMENTS, this.viewer.config.requestHeaders && $785da19a645c07eb$var$bK.logWarn('EquirectangularTilesAdapter fallbacks to file loader because "requestHeaders" where provided. Consider removing "requestHeaders" if you experience performances issues.');
    }
    static withConfig(t) {
        return [
            e1,
            t
        ];
    }
    init() {
        super.init(), this.viewer.addEventListener($785da19a645c07eb$var$BX.TransitionDoneEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.PositionUpdatedEvent.type, this), this.viewer.addEventListener($785da19a645c07eb$var$BX.ZoomUpdatedEvent.type, this);
    }
    destroy() {
        this.viewer.removeEventListener($785da19a645c07eb$var$BX.TransitionDoneEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.PositionUpdatedEvent.type, this), this.viewer.removeEventListener($785da19a645c07eb$var$BX.ZoomUpdatedEvent.type, this), this.__cleanup(), this.state.errorMaterial?.map?.dispose(), this.state.errorMaterial?.dispose(), this.adapter.destroy(), delete this.adapter, delete this.state.geom, delete this.state.errorMaterial, super.destroy();
    }
    handleEvent(e1) {
        switch(e1.type){
            case $785da19a645c07eb$var$BX.PositionUpdatedEvent.type:
            case $785da19a645c07eb$var$BX.ZoomUpdatedEvent.type:
                this.__refresh();
                break;
            case $785da19a645c07eb$var$BX.TransitionDoneEvent.type:
                this.state.inTransition = !1, e1.completed && this.__switchMesh(this.viewer.renderer.mesh);
        }
    }
    supportsTransition(e1) {
        return !!e1.baseUrl;
    }
    supportsPreload(e1) {
        return !!e1.baseUrl;
    }
    textureCoordsToSphericalCoords(e1, t) {
        return this.adapter.textureCoordsToSphericalCoords(e1, t);
    }
    sphericalCoordsToTextureCoords(e1, t) {
        return this.adapter.sphericalCoordsToTextureCoords(e1, t);
    }
    async loadTexture(e1, t = !0) {
        !function(e1, t) {
            if ("object" != typeof e1 || !e1.tileUrl) throw new $785da19a645c07eb$var$tX("Invalid panorama configuration, are you using the right adapter?");
            $785da19a645c07eb$var$Y$(e1) ? (e1.levels.forEach((e1)=>{
                $785da19a645c07eb$var$t0(e1, t), "zoomRange" in e1 && $785da19a645c07eb$var$bK.logWarn('EquirectangularTilesAdapter: "zoomRange" property is deprecated and must be removed');
            }), e1.levels.sort((e1, t)=>e1.width - t.width)) : $785da19a645c07eb$var$t0(e1, t);
        }(e1, this);
        const i = $785da19a645c07eb$var$$$(e1, 0, 0, null, this), n = {
            isEquirectangular: !0,
            fullWidth: i.width,
            fullHeight: i.width / 2,
            croppedWidth: i.width,
            croppedHeight: i.width / 2,
            croppedX: 0,
            croppedY: 0,
            poseHeading: 0,
            posePitch: 0,
            poseRoll: 0
        };
        if (e1.baseUrl) {
            const i = {
                path: e1.baseUrl,
                data: e1.basePanoData,
                blur: this.config.baseBlur
            }, a = await this.adapter.loadTexture(i, t, null, !0);
            return {
                panorama: e1,
                panoData: {
                    ...n,
                    baseData: a.panoData
                },
                cacheKey: a.cacheKey,
                texture: a.texture
            };
        }
        return {
            panorama: e1,
            panoData: {
                ...n,
                baseData: null
            },
            cacheKey: $785da19a645c07eb$var$i0(e1, i),
            texture: null
        };
    }
    createMesh(e1) {
        const t = this.adapter.createMesh(e1.baseData ?? e1), i = new $785da19a645c07eb$var$kG($785da19a645c07eb$var$sK.SPHERE_RADIUS, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1).toNonIndexed();
        i.clearGroups();
        let n = 0, a = 0;
        for(; n < 3 * this.SPHERE_SEGMENTS; n += 3)i.addGroup(n, 3, a++);
        for(; n < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS; n += 6)i.addGroup(n, 6, a++);
        for(; n < this.NB_VERTICES; n += 3)i.addGroup(n, 3, a++);
        const r = [], s = new $785da19a645c07eb$var$Lq({
            opacity: 0,
            transparent: !0,
            depthTest: !1,
            depthWrite: !1
        });
        for(let e1 = 0; e1 < this.NB_GROUPS; e1++)r.push(s);
        const o = new $785da19a645c07eb$var$Kq(i, r);
        o.renderOrder = 1;
        const l = new $785da19a645c07eb$var$bV;
        return l.add(t), l.add(o), l;
    }
    setTexture(e1, t, i) {
        const [n] = $785da19a645c07eb$var$a0(e1);
        t.texture ? this.adapter.setTexture(n, {
            panorama: t.panorama.baseUrl,
            texture: t.texture,
            panoData: t.panoData.baseData
        }) : n.visible = !1, i ? this.state.inTransition = !0 : this.__switchMesh(e1);
    }
    setTextureOpacity(e1, t) {
        const [i] = $785da19a645c07eb$var$a0(e1);
        this.adapter.setTextureOpacity(i, t);
    }
    disposeTexture({ texture: e1 }) {
        e1?.dispose();
    }
    disposeMesh(e1) {
        const [t, i] = $785da19a645c07eb$var$a0(e1);
        t.geometry.dispose(), t.material.dispose(), i.geometry.dispose(), i.material.forEach((e1)=>{
            e1.map?.dispose(), e1.dispose();
        });
    }
    __refresh() {
        if (!this.state.geom || this.state.inTransition) return;
        const e1 = this.viewer.config.panorama, t = $785da19a645c07eb$var$$$(e1, this.viewer.state.hFov, this.viewer.state.vFov, this.viewer.state.size, this), i = this.state.geom.getAttribute("position"), n = {};
        for(let a = 0; a < this.NB_VERTICES; a += 1)if ($785da19a645c07eb$var$s0.fromBufferAttribute(i, a), $785da19a645c07eb$var$s0.applyEuler(this.viewer.renderer.sphereCorrection), this.viewer.renderer.isObjectVisible($785da19a645c07eb$var$s0)) {
            let i;
            i = a < 3 * this.SPHERE_SEGMENTS ? Math.floor(a / 3) : a < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS ? Math.floor((a / 3 - this.SPHERE_SEGMENTS) / 2) + this.SPHERE_SEGMENTS : Math.floor((a - this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS) / 3) + this.SPHERE_HORIZONTAL_SEGMENTS * (this.SPHERE_SEGMENTS - 1);
            const r = Math.floor(i / this.SPHERE_SEGMENTS), s = i - r * this.SPHERE_SEGMENTS;
            let o = t;
            for(; o;){
                const t = Math.floor(r / o.facesByRow), i = Math.floor(s / o.facesByCol);
                let a = $785da19a645c07eb$var$s0.angleTo(this.viewer.state.direction);
                0 !== t && t !== o.rows - 1 || (a *= 2);
                const l = {
                    row: t,
                    col: i,
                    angle: a,
                    config: o,
                    url: null
                }, c = $785da19a645c07eb$var$n0(l);
                if (n[c]) {
                    n[c].angle = Math.min(n[c].angle, a);
                    break;
                }
                if (l.url = e1.tileUrl(i, t, o.level), l.url) {
                    n[c] = l;
                    break;
                }
                o = $785da19a645c07eb$var$e0(e1, o.level - 1, this);
            }
        }
        this.state.tileConfig = t, this.__loadTiles(Object.values(n));
    }
    __loadTiles(e1) {
        this.queue.disableAllTasks(), e1.forEach((e1)=>{
            const t = $785da19a645c07eb$var$n0(e1);
            this.state.tiles[t] ? this.queue.setPriority(t, e1.angle) : (this.state.tiles[t] = !0, this.queue.enqueue(new $785da19a645c07eb$var$K$(t, e1.angle, (t)=>this.__loadTile(e1, t))));
        }), this.queue.start();
    }
    __loadTile(e1, t) {
        return this.viewer.textureLoader.loadImage(e1.url, null, this.viewer.state.textureData.cacheKey).then((i)=>{
            if (!t.isCancelled()) {
                this.config.debug && (i = function(e1, t, i) {
                    const n = document.createElement("canvas");
                    n.width = e1.width, n.height = e1.height;
                    const a = n.getContext("2d");
                    a.fillStyle = $785da19a645c07eb$var$Q$[t % $785da19a645c07eb$var$Q$.length], a.fillRect(0, 0, n.width, n.height), a.globalCompositeOperation = "multiply", a.drawImage(e1, 0, 0);
                    const r = e1.width / 7;
                    return a.globalCompositeOperation = "source-over", a.fillStyle = "white", a.font = `${r}px monospace`, a.textAlign = "center", i.split("\n").forEach((t, i)=>{
                        a.fillText(t, e1.width / 2, e1.height / 2 + r * (.3 + i));
                    }), n;
                }(i, e1.config.level, $785da19a645c07eb$var$n0(e1)));
                const t = this.config.antialias && e1.config.level > 0, n = new $785da19a645c07eb$var$Lq({
                    map: $785da19a645c07eb$var$bK.createTexture(i, t)
                });
                this.__swapMaterial(e1, n, !1), this.viewer.needsUpdate();
            }
        }).catch((i)=>{
            $785da19a645c07eb$var$bK.isAbortError(i) || t.isCancelled() || !this.config.showErrorTile || (this.state.errorMaterial || (this.state.errorMaterial = function() {
                const e1 = new OffscreenCanvas(512, 512), t = e1.getContext("2d");
                return t.fillStyle = "#333", t.fillRect(0, 0, e1.width, e1.height), t.font = e1.width / 5 + "px serif", t.fillStyle = "#a22", t.textAlign = "center", t.textBaseline = "middle", t.fillText("\u26A0", e1.width / 2, e1.height / 2), new $785da19a645c07eb$var$Lq({
                    map: $785da19a645c07eb$var$bK.createTexture(e1)
                });
            }()), this.__swapMaterial(e1, this.state.errorMaterial, !0), this.viewer.needsUpdate());
        });
    }
    __swapMaterial(e1, t, i) {
        const n = this.state.geom.getAttribute("uv");
        for(let a = 0; a < e1.config.facesByCol; a++)for(let r = 0; r < e1.config.facesByRow; r++){
            const s = e1.col * e1.config.facesByCol + a, o = e1.row * e1.config.facesByRow + r, l = 0 === o, c = o === this.SPHERE_HORIZONTAL_SEGMENTS - 1;
            let u;
            if (u = l ? 3 * s : c ? this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS + 3 * s : 3 * this.SPHERE_SEGMENTS + (o - 1) * this.SPHERE_SEGMENTS * 6 + 6 * s, i && this.state.faces[u] > -1) continue;
            if (this.state.faces[u] > e1.config.level) continue;
            this.state.faces[u] = i ? -1 : e1.config.level;
            const h = this.state.geom.groups.find((e1)=>e1.start === u).materialIndex;
            this.state.materials[h] = t;
            const d = 1 - r / e1.config.facesByRow, p = 1 - (r + 1) / e1.config.facesByRow, m = a / e1.config.facesByCol, g = (a + 1) / e1.config.facesByCol;
            l ? (n.setXY(u, (m + g) / 2, d), n.setXY(u + 1, m, p), n.setXY(u + 2, g, p)) : c ? (n.setXY(u, g, d), n.setXY(u + 1, m, d), n.setXY(u + 2, (m + g) / 2, p)) : (n.setXY(u, g, d), n.setXY(u + 1, m, d), n.setXY(u + 2, g, p), n.setXY(u + 3, m, d), n.setXY(u + 4, m, p), n.setXY(u + 5, g, p));
        }
        n.needsUpdate = !0;
    }
    __switchMesh(e1) {
        const [, t] = $785da19a645c07eb$var$a0(e1);
        if (this.__cleanup(), this.state.materials = t.material, this.state.geom = t.geometry, this.config.debug) {
            const e1 = function(e1) {
                const t = new $785da19a645c07eb$var$SG(e1), i = new $785da19a645c07eb$var$AG(t);
                return i.material.depthTest = !1, i.material.depthWrite = !1, i.material.opacity = .25, i.material.transparent = !0, i;
            }(this.state.geom);
            this.viewer.renderer.addObject(e1), this.viewer.renderer.setSphereCorrection(this.viewer.config.sphereCorrection, e1);
        }
        setTimeout(()=>this.__refresh());
    }
    __cleanup() {
        this.queue.clear(), this.state.tiles = {}, this.state.faces = {}, this.state.materials = [], this.state.inTransition = !1;
    }
};
$785da19a645c07eb$var$o0.id = "equirectangular-tiles", $785da19a645c07eb$var$o0.VERSION = "5.15.1", $785da19a645c07eb$var$o0.supportsDownload = !1;
var $785da19a645c07eb$var$l0 = $785da19a645c07eb$var$o0;
class $785da19a645c07eb$var$c0 extends $785da19a645c07eb$var$l0 {
    constructor(e1, t){
        super(e1, t), this._shouldGoFast = t.shouldGoFast || (()=>!0);
    }
    loadTexture(e1, t) {
        return e1.origBaseUrl ? e1.baseUrl = e1.origBaseUrl : e1.origBaseUrl = e1.baseUrl, this._shouldGoFast() && e1.thumbUrl && !e1.hdLoaded && 1 == e1.rows && e1.cropData?.croppedWidth !== e1.cropData?.fullWidth && (e1.baseUrl = e1.thumbUrl), super.loadTexture(e1, t).then((t)=>(e1.baseUrl === e1.origBaseUrl && (e1.hdLoaded = !0), t)).catch((e1)=>{
            console.error("Can't load texture", e1);
        });
    }
    __loadTiles(e1) {
        this._shouldGoFast() || super.__loadTiles(e1);
    }
}
const $785da19a645c07eb$var$u0 = new CSSStyleSheet;
$785da19a645c07eb$var$u0.replaceSync('/*!\n * Photo Sphere Viewer 5.15.1\n * @copyright 2014-2015 J\xe9r\xe9my Heleine\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-core-loaded: true;\n  container-name: psv-container;\n  container-type: size;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  background:\n    radial-gradient(\n      #fff 0%,\n      #fdfdfd 16%,\n      #fbfbfb 33%,\n      #f8f8f8 49%,\n      #efefef 66%,\n      #dfdfdf 82%,\n      #bfbfbf 100%);\n  overflow: hidden;\n}\n.psv-container * {\n  box-sizing: content-box;\n}\n.psv-canvas-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 0;\n  transition: opacity linear 100ms;\n}\n.psv-fullscreen-emulation {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 9999;\n}\n.psv-loader-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 80;\n}\n.psv-loader {\n  --psv-loader-border: 3px;\n  --psv-loader-tickness: 10px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: rgba(255, 255, 255, 0.7);\n  width: 150px;\n  height: 150px;\n}\n.psv-loader-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  color: rgba(61, 61, 61, 0.5);\n  z-index: -1;\n}\n.psv-loader-text {\n  font: 600 16px sans-serif;\n  text-align: center;\n}\n.psv-loader--undefined .psv-loader-canvas {\n  animation: psv-loader 2s cubic-bezier(0.75, 0.25, 0.25, 0.75) infinite;\n}\n@keyframes psv-loader {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.psv-navbar {\n  display: flex;\n  position: absolute;\n  z-index: 90;\n  bottom: -40px;\n  left: 0;\n  width: 100%;\n  height: 40px;\n  background: rgba(61, 61, 61, 0.5);\n  transition: bottom ease-in-out 0.1s;\n  font: 16px sans-serif;\n  cursor: default;\n}\n.psv-navbar--open {\n  bottom: 0;\n}\n.psv-navbar,\n.psv-navbar * {\n  box-sizing: content-box;\n}\n.psv-button {\n  flex: 0 0 auto;\n  padding: 10px;\n  position: relative;\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n}\n.psv-button--active {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-button--disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n.psv-button-svg {\n  width: 100%;\n  transform: scale(1);\n  transition: transform 200ms ease;\n  vertical-align: initial;\n}\n.psv-button:not(.psv-button--disabled):focus-visible {\n  outline: 2px solid #007cff;\n  outline-offset: -2px;\n}\n.psv-container:not(.psv--is-touch) .psv-button--hover-scale:not(.psv-button--disabled):hover .psv-button-svg {\n  transform: scale(1.2);\n}\n.psv-move-button + .psv-move-button {\n  margin-left: -10px;\n}\n.psv-download-button {\n  color: rgba(255, 255, 255, 0.7) !important;\n  text-decoration: none !important;\n}\n.psv-download-button::before,\n.psv-download-button::after {\n  display: none !important;\n}\n.psv-custom-button {\n  width: auto;\n  min-width: 20px;\n}\n.psv-custom-button--no-padding {\n  padding: 0;\n  height: 100%;\n}\n.psv-caption {\n  flex: 1 1 100%;\n  color: rgba(255, 255, 255, 0.7);\n  overflow: hidden;\n  text-align: center;\n  cursor: unset;\n  padding: unset;\n  height: unset;\n  width: unset;\n}\n.psv-caption-content {\n  display: inline-block;\n  padding: 10px;\n  white-space: nowrap;\n}\n.psv-zoom-range.psv-button {\n  width: 80px;\n  height: 1px;\n  margin: 10px 0;\n  padding: 9.5px 0;\n  max-width: 600px;\n}\n.psv-zoom-range-line {\n  position: relative;\n  width: 80px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.7);\n  transition: all 0.3s ease;\n}\n.psv-zoom-range-handle {\n  position: absolute;\n  border-radius: 50%;\n  top: -3px;\n  width: 7px;\n  height: 7px;\n  background: rgba(255, 255, 255, 0.7);\n  transform: scale(1);\n  transition: transform 0.3s ease;\n}\n.psv-zoom-range:not(.psv-button--disabled):hover .psv-zoom-range-line {\n  box-shadow: 0 0 2px rgba(255, 255, 255, 0.7);\n}\n.psv-zoom-range:not(.psv-button--disabled):hover .psv-zoom-range-handle {\n  transform: scale(1.3);\n}\n.psv-notification {\n  position: absolute;\n  z-index: 100;\n  bottom: -40px;\n  display: flex;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 2em;\n  opacity: 0;\n  transition-property: opacity, bottom;\n  transition-timing-function: ease-in-out;\n  transition-duration: 200ms;\n}\n.psv-notification-content {\n  max-width: 50em;\n  background: rgba(61, 61, 61, 0.8);\n  border-radius: 4px;\n  padding: 0.5em 1em;\n  font: 14px sans-serif;\n  color: rgb(255, 255, 255);\n}\n.psv-notification--visible {\n  opacity: 100;\n  bottom: 80px;\n}\n.psv-overlay {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  z-index: 110;\n  inset: 0;\n  background:\n    radial-gradient(\n      #fff 0%,\n      #fdfdfd 16%,\n      #fbfbfb 33%,\n      #f8f8f8 49%,\n      #efefef 66%,\n      #dfdfdf 82%,\n      #bfbfbf 100%);\n  opacity: 0.8;\n  cursor: default;\n}\n.psv-overlay-image {\n  width: 100%;\n  text-align: center;\n  color: rgb(48, 48, 48);\n}\n.psv-overlay-image svg {\n  width: 50%;\n}\n@container psv-container (orientation: landscape) {\n  .psv-overlay-image svg {\n    width: 33%;\n  }\n}\n.psv-overlay-title {\n  color: black;\n  margin-top: 1em;\n  font: 30px sans-serif;\n  text-align: center;\n}\n.psv-overlay-text {\n  color: rgba(0, 0, 0, 0.8);\n  font: 20px sans-serif;\n  opacity: 0.8;\n  text-align: center;\n}\n.psv-panel {\n  position: absolute;\n  z-index: 90;\n  right: 0;\n  height: 100%;\n  width: 400px;\n  max-width: calc(100% - 9px);\n  background: rgba(10, 10, 10, 0.7);\n  transform: translate3d(100%, 0, 0);\n  opacity: 0;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 100ms;\n  cursor: default;\n  margin-left: 9px;\n}\n.psv--has-navbar .psv-panel {\n  height: calc(100% - 40px);\n}\n.psv-panel-close-button {\n  display: none;\n  position: absolute;\n  top: -1px;\n  right: 0;\n  width: 19.2px;\n  height: 19.2px;\n  padding: 6.4px;\n  background: transparent;\n  color: #fff;\n  transition: background 300ms ease-in-out;\n  cursor: pointer;\n}\n.psv-panel-close-button svg {\n  transition: transform 300ms ease-in-out;\n}\n.psv-panel-close-button:hover {\n  background: rgba(0, 0, 0, 0.9);\n}\n.psv-panel-close-button:hover svg {\n  transform: scale(-1);\n}\n.psv-panel-resizer {\n  display: none;\n  position: absolute;\n  top: 0;\n  left: -9px;\n  width: 9px;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  cursor: col-resize;\n}\n.psv-panel-resizer::before {\n  content: "";\n  position: absolute;\n  top: 50%;\n  left: 5.5px;\n  margin-top: -14.5px;\n  width: 1px;\n  height: 1px;\n  box-shadow:\n    1px 0 #fff,\n    3px 0px #fff,\n    5px 0px #fff,\n    1px 2px #fff,\n    3px 2px #fff,\n    5px 2px #fff,\n    1px 4px #fff,\n    3px 4px #fff,\n    5px 4px #fff,\n    1px 6px #fff,\n    3px 6px #fff,\n    5px 6px #fff,\n    1px 8px #fff,\n    3px 8px #fff,\n    5px 8px #fff,\n    1px 10px #fff,\n    3px 10px #fff,\n    5px 10px #fff,\n    1px 12px #fff,\n    3px 12px #fff,\n    5px 12px #fff,\n    1px 14px #fff,\n    3px 14px #fff,\n    5px 14px #fff,\n    1px 16px #fff,\n    3px 16px #fff,\n    5px 16px #fff,\n    1px 18px #fff,\n    3px 18px #fff,\n    5px 18px #fff,\n    1px 20px #fff,\n    3px 20px #fff,\n    5px 20px #fff,\n    1px 22px #fff,\n    3px 22px #fff,\n    5px 22px #fff,\n    1px 24px #fff,\n    3px 24px #fff,\n    5px 24px #fff,\n    1px 26px #fff,\n    3px 26px #fff,\n    5px 26px #fff,\n    1px 28px #fff,\n    3px 28px #fff,\n    5px 28px #fff;\n  background: transparent;\n}\n.psv-panel-content {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  color: rgb(220, 220, 220);\n  font: 16px sans-serif;\n  overflow: auto;\n}\n.psv-panel-content:not(.psv-panel-content--no-margin) {\n  padding: 1em;\n}\n.psv-panel-content--no-interaction {\n  user-select: none;\n  pointer-events: none;\n}\n.psv-panel--open {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n  transition-duration: 0.2s;\n}\n.psv-panel--open .psv-panel-close-button,\n.psv-panel--open .psv-panel-resizer {\n  display: block;\n}\n@container psv-container (max-width: 400px) {\n  .psv-panel {\n    width: 100% !important;\n    max-width: none;\n  }\n  .psv-panel-resizer {\n    display: none !important;\n  }\n}\n.psv-panel-menu {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.psv-panel-menu-title {\n  flex: none;\n  display: flex;\n  align-items: center;\n  font: 24px sans-serif;\n  margin: 24px 12px;\n}\n.psv-panel-menu-title svg {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n.psv-panel-menu-list {\n  flex: 1;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n.psv-panel-menu-item {\n  min-height: 1.5em;\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: background 0.1s ease-in-out;\n}\n.psv-panel-menu-item--active {\n  outline: 1px solid currentcolor;\n  outline-offset: -1px;\n}\n.psv-panel-menu-item-icon {\n  flex: none;\n  height: 1.5em;\n  width: 1.5em;\n  margin-right: 0.5em;\n}\n.psv-panel-menu-item-icon img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.psv-panel-menu-item-icon {\n}\n.psv-panel-menu-item-icon svg {\n  width: 100%;\n  height: 100%;\n}\n.psv-panel-menu-item:focus-visible {\n  outline: 2px solid #007cff;\n  outline-offset: -2px;\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(odd),\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(odd)::before {\n  background: rgba(255, 255, 255, 0.1);\n}\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(even),\n.psv-panel-menu--stripped .psv-panel-menu-item:nth-child(even)::before {\n  background: transparent;\n}\n.psv-container:not(.psv--is-touch) .psv-panel-menu-item:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n.psv-tooltip {\n  position: absolute;\n  z-index: 50;\n  box-sizing: border-box;\n  max-width: 200px;\n  background: rgba(61, 61, 61, 0.8);\n  border-radius: 4px;\n  opacity: 0;\n  transition-property: opacity, transform;\n  transition-timing-function: ease-in-out;\n  transition-duration: 100ms;\n  cursor: default;\n}\n.psv-tooltip-content {\n  color: rgb(255, 255, 255);\n  font: 14px sans-serif;\n  text-shadow: 0 1px #000;\n  padding: 0.5em 1em;\n}\n.psv-tooltip-arrow {\n  position: absolute;\n  height: 0;\n  width: 0;\n  border: 7px solid transparent;\n}\n.psv-tooltip--top-left,\n.psv-tooltip--top-center,\n.psv-tooltip--top-right {\n  transform: translate3d(0, 5px, 0);\n}\n.psv-tooltip--top-left .psv-tooltip-arrow,\n.psv-tooltip--top-center .psv-tooltip-arrow,\n.psv-tooltip--top-right .psv-tooltip-arrow {\n  border-top-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--bottom-left,\n.psv-tooltip--bottom-center,\n.psv-tooltip--bottom-right {\n  transform: translate3d(0, -5px, 0);\n}\n.psv-tooltip--bottom-left .psv-tooltip-arrow,\n.psv-tooltip--bottom-center .psv-tooltip-arrow,\n.psv-tooltip--bottom-right .psv-tooltip-arrow {\n  border-bottom-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--left-top,\n.psv-tooltip--center-left,\n.psv-tooltip--left-bottom {\n  transform: translate3d(5px, 0, 0);\n}\n.psv-tooltip--left-top .psv-tooltip-arrow,\n.psv-tooltip--center-left .psv-tooltip-arrow,\n.psv-tooltip--left-bottom .psv-tooltip-arrow {\n  border-left-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--right-top,\n.psv-tooltip--center-right,\n.psv-tooltip--right-bottom {\n  transform: translate3d(-5px, 0, 0);\n}\n.psv-tooltip--right-top .psv-tooltip-arrow,\n.psv-tooltip--center-right .psv-tooltip-arrow,\n.psv-tooltip--right-bottom .psv-tooltip-arrow {\n  border-right-color: rgba(61, 61, 61, 0.8);\n}\n.psv-tooltip--left-top,\n.psv-tooltip--top-left {\n  box-shadow: -3px -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--top-center {\n  box-shadow: 0 -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--right-top,\n.psv-tooltip--top-right {\n  box-shadow: 3px -3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--left-bottom,\n.psv-tooltip--bottom-left {\n  box-shadow: -3px 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--bottom-center {\n  box-shadow: 0 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--right-bottom,\n.psv-tooltip--bottom-right {\n  box-shadow: 3px 3px 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--center-left {\n  box-shadow: -3px 0 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--center-right {\n  box-shadow: 3px 0 0 rgba(90, 90, 90, 0.7);\n}\n.psv-tooltip--visible {\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n/*# sourceMappingURL=index.css.map */');
const $785da19a645c07eb$var$h0 = new CSSStyleSheet;
$785da19a645c07eb$var$h0.replaceSync('/*!\n * Photo Sphere Viewer / Virtual Tour Plugin 5.15.1\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-virtual-tour-plugin-loaded: true;\n}\n.psv-virtual-tour-tooltip h3 {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n.psv-virtual-tour-tooltip h3:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n.psv-virtual-tour-tooltip img {\n  display: block;\n  width: 200px;\n  margin: 0 -1em;\n}\n.psv-virtual-tour-tooltip img:first-child {\n  border-radius: 4px 4px 0 0;\n}\n.psv-virtual-tour-tooltip img:last-child {\n  border-radius: 0 0 4px 4px;\n}\n.psv-virtual-tour-tooltip img:not(:last-child) {\n  margin-bottom: 0.5em;\n}\n.psv-virtual-tour-tooltip p {\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n}\n.psv-virtual-tour-link {\n  cursor: pointer;\n  transform-origin: center;\n}\n.psv-virtual-tour-arrows {\n  position: absolute;\n  overflow: visible !important;\n  z-index: 11;\n  bottom: 0;\n  left: 0;\n  filter: drop-shadow(0 10px 2px rgba(0, 0, 0, 0.7));\n  pointer-events: none;\n  transition: margin ease-in-out 0.3s;\n}\n.psv-virtual-tour-arrows .psv-virtual-tour-link {\n  transition: opacity linear 0.2s;\n}\n.psv-virtual-tour-arrows .psv-virtual-tour-link:hover {\n  opacity: 1 !important;\n}\n.psv-virtual-tour-arrow {\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  border: none;\n  background: none;\n  color: rgba(255, 255, 255, 0.8);\n  border-radius: 50%;\n}\n.psv-virtual-tour-arrow:hover {\n  animation: psv-virtual-tour-link-button-in 1s ease-out forwards;\n}\n.psv-virtual-tour-loader {\n  display: block;\n  position: relative;\n  width: 40px;\n  height: 30px;\n  margin: 0 40px;\n}\n.psv-virtual-tour-loader div {\n  display: inline-block;\n  position: absolute;\n  left: 10%;\n  width: 20%;\n  background: #fff;\n  animation: psv-virtual-tour-loader 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;\n}\n.psv-virtual-tour-loader div:nth-child(1) {\n  left: 10%;\n  animation-delay: -0.24s;\n}\n.psv-virtual-tour-loader div:nth-child(2) {\n  left: 40%;\n  animation-delay: -0.12s;\n}\n.psv-virtual-tour-loader div:nth-child(3) {\n  left: 70%;\n  animation-delay: 0;\n}\n@keyframes psv-virtual-tour-loader {\n  0% {\n    top: 10%;\n    height: 80%;\n  }\n  50%, 100% {\n    top: 30%;\n    height: 40%;\n  }\n}\n@keyframes psv-virtual-tour-link-button-in {\n  0% {\n    box-shadow: 0 0 0 0 rgba(97, 170, 242, 0);\n  }\n  20% {\n    box-shadow: 0 0 0 5px #61aaf2;\n  }\n  100% {\n    box-shadow: 0 0 0 20px rgba(97, 170, 242, 0);\n  }\n}\n/*# sourceMappingURL=index.css.map */');
const $785da19a645c07eb$var$d0 = new CSSStyleSheet;
$785da19a645c07eb$var$d0.replaceSync('/*!\n * Photo Sphere Viewer / Markers Plugin 5.15.1\n * @copyright 2015-2026 Damien "Mistic" Sorel\n * @licence MIT (https://opensource.org/licenses/MIT)\n */\n/* src/styles/index.scss */\n.psv-container {\n  --psv-markers-plugin-loaded: true;\n}\n.psv-markers {\n  pointer-events: none;\n  position: absolute;\n  z-index: 10;\n  width: 100%;\n  height: 100%;\n}\n.psv-markers-svg-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n}\n.psv-markers-css3d-container {\n  position: absolute;\n  z-index: 21;\n}\n.psv-marker {\n  display: none;\n  pointer-events: auto;\n}\n.psv-marker--normal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 30;\n  overflow: visible;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n.psv-marker--css3d {\n  display: block;\n}\n.psv-marker--transparent {\n  display: block;\n  opacity: 0;\n}\n.psv-marker--visible {\n  display: block;\n}\n.psv-marker--has-tooltip,\n.psv-marker--has-content {\n  cursor: pointer;\n}\n/*# sourceMappingURL=index.css.map */');
const $785da19a645c07eb$var$p0 = new CSSStyleSheet;
$785da19a645c07eb$var$p0.replaceSync("/* Smaller loading text */\n.psv-loader-text {\n\ttext-align: center;\n\tfont-size: 0.9em;\n}\n\n.psv-loader-image { width: 80%; }\n\n.psv-overlay { opacity: 1 !important; }\n\n/* Hide PSV tooltips */\n.psv-virtual-tour-tooltip { display: none; }\n\n/* Resize canvas for print */\n@media print {\n\t.pnx-psv canvas {\n\t\twidth: 100% !important;\n\t\theight: unset !important;\n\t}\n}\n\n/* Virtual Tour SVG arrows */\n.pnx-psv-tour-arrows {\n\tbackground: none;\n\tborder: none;\n\n}\n.pnx-psv-tour-arrows:active svg,\n.pnx-psv-tour-arrows.pnx-clicked svg {\n\topacity: 0.4;\n\ttransition: opacity 0.2s ease;\n}\n.pnx-psv-tour-arrows svg {\n\twidth: 100%;\n\theight: auto;\n}\n\n.pnx-psv-tour-arrows svg:hover {\n\tfilter: drop-shadow(0 0 15px var(--blue));\n}\n\n.pnx-psv-playing .pnx-psv-tour-arrows {\n\tdisplay: none;\n}\n\n/* No virtual tour arrows or annotations if photo is reduced */\npnx-mini .psv-virtual-tour-arrows,\npnx-mini .pnx-psv-annotation {\n\tdisplay: none;\n}");
var $785da19a645c07eb$var$m0 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Created with Inkscape (http://www.inkscape.org/) --%3e%3csvg width='48' height='48' viewBox='0 0 12.7 12.7' version='1.1' id='svg5' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e%3cdefs id='defs2'%3e%3cfilter style='color-interpolation-filters:sRGB%3b' id='filter1345' x='-0.2314438' y='-0.2314438' width='1.4628876' height='1.4628876'%3e%3cfeFlood flood-opacity='0.498039' flood-color='rgb(0%2c0%2c0)' result='flood' id='feFlood1335' /%3e%3cfeComposite in='flood' in2='SourceGraphic' operator='in' result='composite1' id='feComposite1337' /%3e%3cfeGaussianBlur in='composite1' stdDeviation='0.5' result='blur' id='feGaussianBlur1339' /%3e%3cfeOffset dx='0' dy='0' result='offset' id='feOffset1341' /%3e%3cfeComposite in='SourceGraphic' in2='offset' operator='over' result='composite2' id='feComposite1343' /%3e%3c/filter%3e%3cfilter style='color-interpolation-filters:sRGB%3b' id='filter1389' x='-0.19034556' y='-0.19034556' width='1.3806911' height='1.3806911'%3e%3cfeFlood flood-opacity='0.498039' flood-color='rgb(0%2c0%2c0)' result='flood' id='feFlood1379' /%3e%3cfeComposite in='flood' in2='SourceGraphic' operator='in' result='composite1' id='feComposite1381' /%3e%3cfeGaussianBlur in='composite1' stdDeviation='0.5' result='blur' id='feGaussianBlur1383' /%3e%3cfeOffset dx='0' dy='0' result='offset' id='feOffset1385' /%3e%3cfeComposite in='SourceGraphic' in2='offset' operator='over' result='composite2' id='feComposite1387' /%3e%3c/filter%3e%3c/defs%3e%3cg id='layer1'%3e%3cpath style='fill:%23bf674c%3bfill-opacity:1%3bstroke:white%3bstroke-width:0.661458%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1%3bfilter:url(%23filter1389)' id='path6342' transform='matrix(-0.23019089%2c-0.85909373%2c0.85909246%2c-0.23019564%2c0.96173083%2c0.76136943)' d='M -1.2578926%2c1.9117668 A 8.0418425%2c8.0418425 0 0 1 -9.2997351%2c9.9536092 V 1.9117668 Z' /%3e%3ccircle style='fill:%23be621c%3bfill-opacity:1%3bstroke:white%3bstroke-width:0.88787%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-opacity:1%3bfilter:url(%23filter1345)' id='path846' cx='7.9277072' cy='5.4758525' r='3.5514777' transform='matrix(0.77024177%2c0.44469933%2c-0.44469933%2c0.77024177%2c0.96173083%2c0.76136943)' /%3e%3cg id='g892' transform='matrix(1.1784639%2c0%2c0%2c1.1784639%2c-0.83676862%2c-1.6599522)'%3e%3cpath d='M 3.5996678%2c9.4106252 H 5.7824803 V 9.8075001 H 3.5996678 Z' id='path254' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3cpath d='M 4.1283053%2c8.2700064 3.8301199%2c8.0048939 4.0952324%2c7.7067085 3.7986345%2c7.4429189 3.533522%2c7.7411043 3.2353366%2c7.4759918 2.971547%2c7.7725898 3.2697324%2c8.0377023 3.0046199%2c8.3358877 3.3012178%2c8.5996772 3.5663303%2c8.3014918 3.8645157%2c8.5666043 Z' id='path256' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3cpath d='M 6.2780449%2c7.7069731 5.981447%2c7.4431835 5.7163345%2c7.7413689 5.4181491%2c7.4762564 5.1543595%2c7.7728543 5.4525449%2c8.0379668 5.1874324%2c8.3361522 5.4840303%2c8.5999418 5.7491428%2c8.3017564 6.0473282%2c8.5668689 6.3111178%2c8.270271 6.0129324%2c8.0051585 Z' id='path258' style='fill:white%3bfill-opacity:1%3bstroke-width:0.264583' /%3e%3c/g%3e%3c/g%3e%3c/svg%3e", $785da19a645c07eb$var$g0 = "data:image/jpeg;base64,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";
document.adoptedStyleSheets.push($785da19a645c07eb$var$u0), document.adoptedStyleSheets.push($785da19a645c07eb$var$h0), document.adoptedStyleSheets.push($785da19a645c07eb$var$d0), document.adoptedStyleSheets.push($785da19a645c07eb$var$p0);
const $785da19a645c07eb$var$f0 = {
    baseUrl: $785da19a645c07eb$var$g0,
    width: 1280,
    cols: 2,
    rows: 1,
    tileUrl: ()=>null
}, $785da19a645c07eb$var$A0 = {
    id: $785da19a645c07eb$var$Ce,
    caption: "",
    panorama: $785da19a645c07eb$var$f0,
    links: [],
    gps: [
        0,
        0
    ],
    sequence: {},
    sphereCorrection: {},
    horizontalFov: 360,
    properties: {}
}, $785da19a645c07eb$var$_0 = 250, $785da19a645c07eb$var$v0 = 3e3, $785da19a645c07eb$var$y0 = "draw-annotation-1", $785da19a645c07eb$var$x0 = "draw-annotation-2", $785da19a645c07eb$var$b0 = "draw-annotation-r", $785da19a645c07eb$var$w0 = "rgb(224, 64, 251)", $785da19a645c07eb$var$E0 = "rgb(224, 64, 251, 0.5)", $785da19a645c07eb$var$k0 = "rgb(123, 31, 162)", $785da19a645c07eb$var$S0 = "rgba(123, 31, 162, 0.5)";
$785da19a645c07eb$var$eJ.useNewAnglesOrder = !0;
class $785da19a645c07eb$var$M0 extends $785da19a645c07eb$var$eJ {
    constructor(e1, t, i = {}){
        var n;
        super({
            container: t,
            adapter: [
                $785da19a645c07eb$var$c0,
                {
                    showErrorTile: !1,
                    baseBlur: !1,
                    resolution: e1.isWidthSmall() ? 32 : 64,
                    shouldGoFast: i?.shouldGoFast || (()=>!1),
                    useXmpData: !1
                }
            ],
            withCredentials: e1.api._getPSVWithCredentials(),
            requestHeaders: e1?.["fetch-options"]?.headers,
            panorama: $785da19a645c07eb$var$f0,
            lang: e1._t.psv,
            minFov: 5,
            loadingTxt: "&nbsp;",
            navbar: null,
            rendererParameters: {
                preserveDrawingBuffer: !e1.isWidthSmall()
            },
            plugins: [
                [
                    $785da19a645c07eb$var$RJ,
                    {
                        dataMode: "server",
                        positionMode: "gps",
                        renderMode: "3d",
                        preload: !0,
                        getNode: ()=>{},
                        transitionOptions: ()=>{},
                        arrowsPosition: {
                            linkOverlapAngle: Math.PI / 6
                        }
                    }
                ],
                [
                    $785da19a645c07eb$var$Z$,
                    {}
                ],
                ...i.plugins || []
            ],
            ...(n = i, Object.fromEntries(Object.entries(n).filter(([e1])=>![
                    "plugins",
                    "shouldGoFast",
                    "displayAnnotations",
                    "transitionDuration",
                    "picturesNavigation"
                ].includes(e1))))
        }), this._parent = e1, this._options = i, t.classList.add("pnx-psv"), this._shouldGoFast = i?.shouldGoFast || (()=>!1), this._transitionDuration = i?.transitionDuration || $785da19a645c07eb$var$_0, this._myVTour = this.getPlugin($785da19a645c07eb$var$RJ), this._myVTour.datasource.nodeResolver = this._getNodeFromAPI.bind(this), this._myVTour.config.transitionOptions = this._psvNodeTransition.bind(this), this._clearArrows = this._myVTour.arrowsRenderer.clear.bind(this._myVTour.arrowsRenderer), this._myVTour.arrowsRenderer.clear = ()=>{}, this._myMarkers = this.getPlugin($785da19a645c07eb$var$Z$), this._annotationsVisible = !0 === this._options.displayAnnotations, this._drawingAnnotation = null, this._sequencePlaying = 0, this._picturesNavigation = this._options.picturesNavigation || "any", this._picturesSequences = {}, this._myVTour.addEventListener("enter-arrow", this._onEnterArrow.bind(this)), this._myVTour.addEventListener("leave-arrow", this._onLeaveArrow.bind(this)), this._myVTour.addEventListener("node-changed", this._onNodeChanged.bind(this)), this._myMarkers.addEventListener("select-marker", this._onSelectMarker.bind(this)), this.addEventListener("position-updated", this._onPositionUpdated.bind(this)), this.addEventListener("zoom-updated", this._onZoomUpdated.bind(this)), this.addEventListener("dblclick", this._onDoubleClick.bind(this)), this._parent.addEventListener("select", this._onSelect.bind(this)), this._parent.mapStyleComposer?.addEventListener("filters-changed", ()=>{
            const e1 = this.getPictureMetadata();
            e1 && setTimeout(()=>{
                const t = Object.assign({}, this._myVTour.state.currentNode);
                e1.geometry = {
                    coordinates: t.gps
                }, e1.links = e1.origLinks, t.links = $785da19a645c07eb$var$xO(e1, this._picturesNavFilter.bind(this)), this._myVTour.datasource.nodes[t.id] = t, this._myVTour.__renderLinks(t);
            }, 2e3);
        }), this.loader.size = 150, this.loader.color = "rgba(61, 61, 61, 0.5)", this.loader.textColor = "rgba(255, 255, 255, 0.7)", this.loader.border = 5, this.loader.thickness = 10, this.loader.canvas.setAttribute("viewBox", "0 0 150 150"), this.loader.__updateContent(), this._options.position && !this._parent.picture && this.goToPosition(...this._options.position), this._clickAndGo = new $785da19a645c07eb$var$PO(this, !this._parent.isWidthSmall());
    }
    async _getNodeFromAPI(e1, t = !1) {
        if ($785da19a645c07eb$var$Le(e1)) return $785da19a645c07eb$var$A0;
        const i = t ? this._parent.api : this._parent.getAPI(), n = await fetch(i.getPictureMetadataUrl(e1, this._picturesSequences[e1]), i._getFetchOptions());
        let a = await n.json();
        if (a.features && (a = a.features.pop()), !a || 0 === Object.keys(a).length || !n.ok) {
            if (this._parent.hasTwoAPIs?.() && !t) return console.log("Failed to find picture on metacatalog, check local API"), await this._getNodeFromAPI(e1, !0);
            throw new Error("Picture with ID " + e1 + " was not found");
        }
        this._picturesSequences[e1] = a.collection;
        const r = $785da19a645c07eb$var$yO(a, this._parent._t, this._parent._isInternetFast, this._picturesNavFilter.bind(this), this._parent.getAPI().cleanResourceURL.bind(this._parent.getAPI()));
        return r?.sequence?.prevPic && (this._picturesSequences[r?.sequence?.prevPic] = a.collection), r?.sequence?.nextPic && (this._picturesSequences[r?.sequence?.nextPic] = a.collection), r;
    }
    _psvNodeTransition(e1, t, i) {
        let n = {};
        const a = this._shouldGoFast() ? 0 : Math.min($785da19a645c07eb$var$_0, this._transitionDuration), r = a > 100, s = null != (i || t?.links.find((t)=>t.nodeId == e1.id)), o = t && e1.sequence.id === t.sequence.id, l = $785da19a645c07eb$var$at(t?.properties?.["view:azimuth"] || 0), c = $785da19a645c07eb$var$at(e1?.properties?.["view:azimuth"] || 0), u = $785da19a645c07eb$var$at($785da19a645c07eb$var$He(e1));
        this.setOption("maxFov", Math.min(3 * e1.horizontalFov / 4, 90));
        const h = {
            showLoader: !1,
            effect: "none",
            speed: 0,
            rotation: !1,
            rotateTo: {
                pitch: 0,
                yaw: -u
            },
            zoomTo: 30
        };
        if (360 == e1.horizontalFov) t ? $785da19a645c07eb$var$Oe(t.gps, e1.gps) >= .005 ? n = h : (n = {
            speed: a,
            effect: s && r ? "fade" : "none",
            rotation: s && o && r,
            rotateTo: this.getPosition()
        }, this._keepSameAngle && (n.rotateTo.yaw += l - c, this._keepSameAngle = !1)) : n = h;
        else if (o) {
            const e1 = this.getPosition().yaw, i = $785da19a645c07eb$var$at(t.horizontalFov) / 2, o = e1 <= i || e1 >= 2 * Math.PI - i, u = Math.abs(l - c) <= Math.PI / 4;
            n = {
                speed: a,
                effect: s && u && r ? "fade" : "none",
                rotation: s && u && r,
                rotateTo: o ? this.getPosition() : {
                    pitch: 0,
                    yaw: 0
                },
                zoomTo: o ? this.getZoomLevel() : 30
            };
        } else n = Object.assign(h, {
            rotateTo: {
                pitch: 0,
                yaw: 0
            }
        });
        "fade" === n.effect && n.speed >= 150 ? setTimeout(this._clearArrows, n.speed - 100) : this._clearArrows();
        const d = new CustomEvent("picture-loading", {
            detail: {
                ...Object.assign({}, this.getXYZ(), n.rotateTo ? {
                    x: $785da19a645c07eb$var$nt(c + n.rotateTo.yaw)
                } : null, n.zoomTo ? {
                    z: n.zoomTo
                } : null),
                picId: e1.id,
                lon: e1.gps[0],
                lat: e1.gps[1],
                first: this._parent._initParams?.getParentPostInit().picture == e1.id
            }
        });
        return this.dispatchEvent(d), n;
    }
    _onEnterArrow(e1) {
        const t = e1.link, i = e1.node;
        let n;
        i && (n = 360 === i.horizontalFov ? (this.getPictureOriginalHeading() + $785da19a645c07eb$var$nt(this.getPosition().yaw)) % 360 : this.getPictureOriginalHeading());
        const a = new CustomEvent("picture-preview-started", {
            detail: {
                picId: t.nodeId,
                coordinates: t.gps,
                direction: n
            }
        });
        this.dispatchEvent(a);
    }
    _onLeaveArrow(e1) {
        const t = e1.link, i = new CustomEvent("picture-preview-stopped", {
            detail: {
                picId: t.nodeId
            }
        });
        this.dispatchEvent(i);
    }
    _onPositionUpdated({ position: e1 }) {
        const t = $785da19a645c07eb$var$Ze(e1, this.getZoomLevel());
        t.x += this.getPictureOriginalHeading(), t.x = t.x % 360;
        const i = new CustomEvent("view-rotated", {
            detail: t
        });
        this.dispatchEvent(i), this._onTilesStartLoading();
    }
    _onZoomUpdated({ zoomLevel: e1 }) {
        const t = new CustomEvent("view-rotated", {
            detail: {
                ...this.getXY(),
                z: e1
            }
        });
        this.dispatchEvent(t), this._onTilesStartLoading();
    }
    _onDoubleClick() {
        this.unfocusAnnotation(!1, !0);
    }
    _onNodeChanged(e1) {
        for (let e1 of document.getElementsByClassName("pnx-psv-tour-arrows"))e1.classList.remove("pnx-clicked");
        if (e1.node.id) {
            const t = this._parent._initParams?.getParentPostInit().picture == e1.node.id;
            this._parent.select(e1.node?.sequence?.id, e1.node.id);
            const i = this.getPictureMetadata();
            if (!i) return void this.dispatchEvent(new CustomEvent("picture-loaded", {
                detail: {}
            }));
            this._prevSequence = i.sequence.id;
            const n = new CustomEvent("picture-loaded", {
                detail: {
                    ...this.getXYZ(),
                    picId: e1.node.id,
                    lon: i.gps[0],
                    lat: i.gps[1],
                    first: t
                }
            });
            this.dispatchEvent(n), i.panorama.hdUrl ? (this.setOption("downloadUrl", i.panorama.hdUrl), this.setOption("downloadName", e1.node.id + ".jpg")) : this.setOption("downloadUrl", null), this._annotationsVisible && this.toggleAllAnnotations(!0);
        }
        this._onTilesStartLoading();
    }
    _onSelectMarker(e1) {
        if (e1.marker && e1.marker.id?.startsWith("annotation-")) {
            const t = this.getSelectedAnnotations().find((e1)=>this._myMarkers.markers["annotation-" + e1]?.config?.data?.blockFocus);
            if (t) return;
            this.getSelectedAnnotations().find((t)=>e1.marker.id.endsWith(t)) ? this.unfocusAnnotation(!1, !1, "user-click") : this.focusOnAnnotation(e1.marker.data.id);
        }
    }
    _onTilesStartLoading() {
        this._tilesQueueTimer && (clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer), this._tilesQueueTimer = setInterval(()=>{
            if (0 === Object.keys(this.adapter.queue.tasks).length) {
                if (this._myVTour.state.currentNode) {
                    const e1 = new CustomEvent("picture-tiles-loaded", {
                        detail: {
                            picId: this._myVTour.state.currentNode.id
                        }
                    });
                    this.dispatchEvent(e1);
                }
                clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer;
            }
        }, 100);
    }
    getPictureMetadata() {
        return $785da19a645c07eb$var$Le(this._myVTour?.state?.currentNode?.id) ? null : this._myVTour.state.currentNode ? Object.assign({}, this._myVTour.state.currentNode) : null;
    }
    getPictureId() {
        const e1 = this._myVTour?.state?.loadingNode || this._myVTour?.state?.currentNode?.id;
        return $785da19a645c07eb$var$Le(e1) ? null : e1;
    }
    _onSelect(e1) {
        if (!this._parent.getAPI()) return (this._parent.onceAllAPIsReady || this._parent.onceAPIReady).bind(this._parent)().then(()=>this._onSelect(e1));
        e1.detail.seqId && (this._picturesSequences[e1.detail.picId] = e1.detail.seqId);
        const t = (e1)=>{
            const t = new CustomEvent("picture-failed", {
                detail: {
                    picId: this._parent.picture,
                    error: e1
                }
            });
            this.dispatchEvent(t);
        };
        e1.detail.seqId && !e1.detail.picId ? (this.loader.show(), this._parent.getAPI().getSequenceItems(e1.detail.seqId, null, null, 1).then((t)=>{
            if (t?.features?.length > 0) {
                const i = t.features[0].id;
                this._picturesSequences[i] = e1.detail.seqId, this._parent.select(e1.detail.seqId, i);
            }
        }).catch(t)) : e1.detail.picId ? this.getPictureId() !== e1.detail.picId && (this.loader.show(), this._myVTour.setCurrentNode(e1.detail.picId).catch(t)) : (this._myVTour.state.currentNode = null, this._myVTour.state.loadingNode = null, this._myVTour.setCurrentNode(null));
    }
    goToNextPicture() {
        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        const e1 = this.getPictureMetadata().sequence.nextPic;
        if (!e1) throw new Error("No next picture available");
        this._parent.select(this.getPictureMetadata().sequence.id, e1);
    }
    goToPrevPicture() {
        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        const e1 = this.getPictureMetadata().sequence.prevPic;
        if (!e1) throw new Error("No previous picture available");
        this._parent.select(this.getPictureMetadata().sequence.id, e1);
    }
    async goToPosition(e1, t) {
        if ("pic" === this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
        return await this._parent.getAPI().getPicturesAroundCoordinates(e1, t).then((e1)=>{
            if (e1.features.length > 0) {
                const t = e1.features.pop();
                return this._parent.select(t?.collection, t.id), t.id;
            }
            return Promise.reject(new Error("No picture found nearby given coordinates"));
        });
    }
    getXY() {
        const e1 = $785da19a645c07eb$var$Ze(this.getPosition());
        return e1.x = (e1.x + this.getPictureOriginalHeading()) % 360, e1;
    }
    getXYZ() {
        const e1 = this.getXY();
        return e1.z = this.getZoomLevel(), e1;
    }
    getPictureOriginalHeading() {
        return this.getPictureMetadata()?.properties?.["view:azimuth"] || 0;
    }
    getPictureRelativeHeading() {
        let e1 = this.getPictureOriginalHeading() - this.getRoadAbsoluteHeading();
        for(; e1 > 180;)e1 -= 360;
        for(; e1 < -180;)e1 += 360;
        return e1;
    }
    getRoadAbsoluteHeading() {
        return $785da19a645c07eb$var$Ge(this.getPictureMetadata());
    }
    clearPictureMetadataCache() {
        const e1 = this.getPictureMetadata()?.id, t = this.getPictureMetadata()?.sequence?.id;
        this._myVTour.state.currentTooltip?.hide(), this._myVTour.state.currentTooltip = null, this._myVTour.state.currentNode = null, this._myVTour.state.preload = {}, this._myVTour.datasource.nodes = {}, e1 && this._parent.select(t, e1);
    }
    setXYZ(e1, t, i) {
        const n = $785da19a645c07eb$var$Ke(e1 - this.getPictureOriginalHeading(), t, i);
        this.rotate({
            yaw: n.yaw,
            pitch: n.pitch
        }), this.zoom(n.zoom);
    }
    setHigherContrast(e1) {
        this.setContrast(e1 ? 1 : 0);
    }
    setContrast(e1) {
        switch(e1){
            case -1:
                this.renderer.renderer.toneMapping = 3, this.renderer.renderer.toneMappingExposure = .3;
                break;
            case 1:
                this.renderer.renderer.toneMapping = 3, this.renderer.renderer.toneMappingExposure = 1.7;
                break;
            default:
                this.renderer.renderer.toneMapping = 0, this.renderer.renderer.toneMappingExposure = 1;
        }
        this.needsUpdate();
    }
    getTransitionDuration() {
        return this._transitionDuration;
    }
    setTransitionDuration(e1) {
        if ((e1 = parseFloat(e1)) < 100 || e1 > $785da19a645c07eb$var$v0) throw new Error("Invalid transition duration (should be between 100 and 3000)");
        this._transitionDuration = e1;
        const t = new CustomEvent("transition-duration-changed", {
            detail: {
                value: e1
            }
        });
        this.dispatchEvent(t);
    }
    setPanorama(e1, t) {
        if (e1.baseUrl.startsWith("data:")) return Promise.resolve();
        const i = (e1)=>this.showErrorOverlay(e1, this._parent?._t.pnx.error_pic, !0);
        try {
            return super.setPanorama(e1, t).catch(i);
        } catch (e1) {
            i(e1);
        }
    }
    showErrorOverlay(e1, t, i) {
        this._parent?.loader.isVisible() || !this.overlay.isVisible() ? this._parent?.loader.dismiss(e1, t, i ? ()=>{
            this._parent?.loader.dismiss(), this.overlay.hide();
        } : void 0) : (console.error(e1), this.overlay.show({
            image: `<img style="width: 200px" src="${$785da19a645c07eb$var$m0}" alt="" />`,
            title: this._parent?._t.pnx.error,
            text: t + "<br />" + this._parent?._t.pnx.error_click,
            dissmisable: i
        }));
    }
    playSequence(e1 = !1) {
        this._sequencePlaying = e1 ? -1 : 1, this.container.classList.add("pnx-psv-playing");
        const t = new CustomEvent("sequence-playing", {
            detail: {
                backward: e1
            },
            bubbles: !0,
            composed: !0
        });
        this.dispatchEvent(t);
        const i = ()=>{
            if (this._sequencePlaying) {
                this.addEventListener("picture-loaded", ()=>{
                    this._playTimer = setTimeout(()=>{
                        i();
                    }, this.getTransitionDuration());
                }, {
                    once: !0
                });
                try {
                    1 === this._sequencePlaying ? this.goToNextPicture() : -1 === this._sequencePlaying && this.goToPrevPicture();
                } catch (e1) {
                    this.stopSequence();
                }
            }
        };
        this.addEventListener("click", ()=>this.stopSequence()), i();
    }
    stopSequence() {
        this._sequencePlaying = 0, this.container.classList.remove("pnx-psv-playing"), this._playTimer && (clearTimeout(this._playTimer), delete this._playTimer), this.forceRefresh();
        const e1 = new Event("sequence-stopped", {
            bubbles: !0,
            composed: !0
        });
        this.dispatchEvent(e1);
    }
    isSequencePlaying() {
        return 0 !== this._sequencePlaying;
    }
    toggleSequencePlaying() {
        this.isSequencePlaying() ? this.stopSequence() : this.playSequence();
    }
    getPicturesNavigation() {
        return this._picturesNavigation;
    }
    setPicturesNavigation(e1) {
        "none" === e1 && (e1 = "pic"), this._picturesNavigation = e1;
        const t = this.container.querySelector(".psv-virtual-tour-arrows");
        t && (t.style.display = "pic" === e1 ? "none" : null);
        const i = new CustomEvent("pictures-navigation-changed", {
            detail: {
                value: e1
            }
        });
        this.dispatchEvent(i);
    }
    _picturesNavFilter(e1) {
        switch(this._picturesNavigation){
            case "seq":
            case "any":
            default:
                return [
                    "next",
                    "prev"
                ].includes(e1.rel);
            case "pic":
            case "none":
                return !1;
        }
    }
    areAnnotationsVisible() {
        return this._annotationsVisible;
    }
    getSelectedAnnotations() {
        return Object.keys(this._myMarkers.markers).filter((e1)=>e1.startsWith("annotation-") && this._myMarkers.markers[e1]?.config?.data?.selected).map((e1)=>e1.replace("annotation-", ""));
    }
    toggleAllAnnotations(e1) {
        const t = this.getPictureMetadata(), i = this._annotationsVisible === e1;
        if (!t) throw this._myMarkers.clearMarkers(), new Error("No picture currently selected");
        if (e1) {
            let e1 = t.properties.annotations || [];
            0 === e1?.length && console.warn("No annotation available on picture", t.id), e1 = e1.map((e1)=>{
                if (!t.properties["pers:interior_orientation"].sensor_array_dimensions) return console.warn("Picture lacks pers:interior_orientation.sensor_array_dimensions property, can't compute marker"), null;
                const i = e1.shape.coordinates.map((e1)=>e1.map((e1)=>{
                        const i = t.panorama?.cropData, n = {
                            textureX: e1[0] + (i?.croppedX || 0),
                            textureY: e1[1] + (i?.croppedY || 0)
                        };
                        return this.dataHelper.textureCoordsToSphericalCoords(n);
                    }));
                return {
                    id: `annotation-${e1.id}`,
                    polygon: i,
                    data: {
                        id: e1.id
                    },
                    className: "pnx-psv-annotation",
                    svgStyle: {
                        stroke: "var(--orange)",
                        strokeWidth: "3px",
                        fill: "var(--orange-transparent)",
                        cursor: "pointer"
                    },
                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                };
            }), this._myMarkers.setMarkers(e1);
        } else this._myMarkers.clearMarkers();
        this._annotationsVisible = e1, i || this.dispatchEvent(new CustomEvent("annotations-toggled", {
            detail: {
                visible: e1
            }
        }));
    }
    focusOnAnnotation(e1, t = !1, i = !1) {
        const n = this.getSelectedAnnotations();
        if (e1 && 1 === n.length && n[0] === e1) return;
        this.areAnnotationsVisible() || this.toggleAllAnnotations(!0), this.unfocusAnnotation(!0);
        const a = `annotation-${e1}`;
        if (this._myMarkers.markers[a]) {
            if (this._myMarkers.updateMarker({
                id: a,
                svgStyle: {
                    stroke: "var(--red)",
                    strokeWidth: "3px",
                    fill: "var(--red-transparent)"
                },
                data: {
                    selected: !0,
                    blockFocus: t
                },
                tooltip: this._parent._t.pnx.semantics_annotation_tooltip_close
            }), this._myMarkers.gotoMarker(a, 0), this.zoom(Math.max(65, this.getZoomLevel())), !i) {
                const t = new CustomEvent("annotation-focused", {
                    detail: {
                        annotationId: e1
                    }
                });
                this.dispatchEvent(t);
            }
        } else setTimeout(()=>this.focusOnAnnotation(e1, t, i), 100);
    }
    unfocusAnnotation(e1 = !1, t = !1, i = null) {
        const n = this.getSelectedAnnotations();
        if (n.length > 0) {
            let a = 0;
            n.forEach((e1)=>{
                const i = "annotation-" + e1;
                t && this._myMarkers.markers[i]?.config?.data?.blockFocus ? a++ : this._myMarkers.updateMarker({
                    id: i,
                    svgStyle: {
                        stroke: "var(--orange)",
                        strokeWidth: "3px",
                        fill: "var(--orange-transparent)"
                    },
                    data: {
                        selected: !1,
                        blockFocus: !1
                    },
                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                });
            }), !e1 && a < n.length && this.dispatchEvent(new CustomEvent("annotations-unfocused", {
                detail: {
                    source: i
                }
            }));
        }
    }
    startDrawAnnotation() {
        this.toggleAllAnnotations(!1), this._drawingAnnotation = [], this._drawingMoves = 0, this._myMarkers.addMarker({
            id: $785da19a645c07eb$var$b0,
            polygon: [
                {
                    yaw: 0,
                    pitch: 0
                },
                {
                    yaw: 0,
                    pitch: 0
                },
                {
                    yaw: 0,
                    pitch: 0
                }
            ],
            svgStyle: {
                fill: $785da19a645c07eb$var$S0,
                stroke: $785da19a645c07eb$var$k0,
                strokeWidth: "2px"
            },
            visible: !1
        }), this._myMarkers.addMarker({
            id: $785da19a645c07eb$var$y0,
            circle: 5,
            position: {
                yaw: 0,
                pitch: 0
            },
            style: {
                cursor: "pointer"
            },
            svgStyle: {
                fill: $785da19a645c07eb$var$E0,
                stroke: $785da19a645c07eb$var$w0,
                strokeWidth: "3px"
            }
        }), this._myMarkers.addMarker({
            id: $785da19a645c07eb$var$x0,
            circle: 5,
            position: {
                yaw: 0,
                pitch: 0
            },
            style: {
                cursor: "pointer"
            },
            svgStyle: {
                fill: $785da19a645c07eb$var$E0,
                stroke: $785da19a645c07eb$var$w0,
                strokeWidth: "3px"
            },
            visible: !1
        });
        const e1 = (e1)=>{
            const t = this.getPositionFromEvent(e1);
            t && this._myMarkers.markers[$785da19a645c07eb$var$y0] && (this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$y0,
                position: t,
                style: {
                    cursor: "grab"
                }
            }), 2 === this._drawingAnnotation.length && this._myMarkers.markers[$785da19a645c07eb$var$b0] && this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$b0,
                polygon: [
                    t,
                    {
                        yaw: t.yaw,
                        pitch: this._drawingAnnotation[1].pitch
                    },
                    this._drawingAnnotation[1],
                    {
                        yaw: this._drawingAnnotation[1].yaw,
                        pitch: t.pitch
                    }
                ]
            }));
        }, t = (e1)=>{
            const t = this.getPositionFromEvent(e1);
            t && this._myMarkers.markers[$785da19a645c07eb$var$x0] && (this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$x0,
                position: t,
                style: {
                    cursor: "grab"
                }
            }), this._drawingAnnotation.length >= 1 && this._myMarkers.markers[$785da19a645c07eb$var$b0] && this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$b0,
                polygon: [
                    this._drawingAnnotation[0],
                    {
                        yaw: this._drawingAnnotation[0].yaw,
                        pitch: t.pitch
                    },
                    t,
                    {
                        yaw: t.yaw,
                        pitch: this._drawingAnnotation[0].pitch
                    }
                ]
            }));
        };
        this._drawListeners = [
            e1,
            t
        ], this.parent.addEventListener("mousemove", e1), this._drawingMoves = 1, this._drawListenerClick = (i)=>{
            let n = !1;
            if (2 !== this._drawingMoves && i.marker.id === $785da19a645c07eb$var$y0 ? 0 === this._drawingAnnotation.length ? (this.dispatchEvent(new Event("annotation-drawing")), this._drawingAnnotation.push({
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }), this.parent.removeEventListener("mousemove", e1), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$y0,
                style: {
                    cursor: "pointer"
                }
            }), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$x0,
                visible: !0,
                position: {
                    yaw: i.marker.config.position.yaw,
                    pitch: i.marker.config.position.pitch
                }
            }), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$b0,
                visible: !0
            }), this.parent.addEventListener("mousemove", t), this._drawingMoves = 2) : 0 === this._drawingMoves ? (this.parent.addEventListener("mousemove", e1), this._drawingMoves = 1) : (this._drawingAnnotation[0] = {
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }, this.parent.removeEventListener("mousemove", e1), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$y0,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : 1 !== this._drawingMoves && i.marker.id === $785da19a645c07eb$var$x0 && (1 === this._drawingAnnotation.length ? (this._drawingAnnotation.push({
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }), this.parent.removeEventListener("mousemove", t), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$x0,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : 2 === this._drawingMoves ? (this._drawingAnnotation[1] = {
                yaw: i.marker.config.position.yaw,
                pitch: i.marker.config.position.pitch
            }, this.parent.removeEventListener("mousemove", t), this._myMarkers.updateMarker({
                id: $785da19a645c07eb$var$x0,
                style: {
                    cursor: "pointer"
                }
            }), this._drawingMoves = 0, n = !0) : (this.parent.addEventListener("mousemove", t), this._drawingMoves = 2)), n) {
                let e1 = this._myMarkers.markers[$785da19a645c07eb$var$b0].config.polygon.map((e1)=>{
                    const t = this.dataHelper.sphericalCoordsToTextureCoords(e1);
                    return [
                        t.textureX,
                        t.textureY
                    ];
                });
                const t = this.getPictureMetadata()?.panorama?.cropData;
                t && (e1 = e1.map(([e1, i])=>[
                        e1 - t.croppedX,
                        i - t.croppedY
                    ]), e1.find(([e1, i])=>e1 < 0 || e1 > t.croppedWidth || i < 0 || i > t.croppedHeight) && (e1 = null), e1 || (alert(this._parent._t.pnx.semantics_draw_invalid_annotation), this.stopDrawAnnotation(), this.startDrawAnnotation())), e1[0][0] === e1[e1.length - 1][0] && e1[0][1] === e1[e1.length - 1][1] || e1.push(e1[0]);
                const i = new CustomEvent("annotation-drawn", {
                    detail: {
                        shape: e1
                    }
                });
                this.dispatchEvent(i);
            }
        }, this._myMarkers.addEventListener("select-marker", this._drawListenerClick);
    }
    fixDrawAnnotation() {
        [
            $785da19a645c07eb$var$y0,
            $785da19a645c07eb$var$x0
        ].forEach((e1)=>{
            try {
                this._myMarkers.removeMarker(e1);
            } catch (e1) {}
        }), (this._drawListeners || []).forEach((e1)=>this.parent.removeEventListener("mousemove", e1)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), this._myMarkers.updateMarker({
            id: $785da19a645c07eb$var$b0,
            svgStyle: {
                stroke: "var(--red)",
                strokeWidth: "3px",
                fill: "var(--red-transparent)",
                cursor: "pointer"
            }
        }), this._drawingMoves = 0;
    }
    stopDrawAnnotation() {
        [
            $785da19a645c07eb$var$y0,
            $785da19a645c07eb$var$x0,
            $785da19a645c07eb$var$b0
        ].forEach((e1)=>{
            try {
                this._myMarkers.removeMarker(e1);
            } catch (e1) {}
        }), (this._drawListeners || []).forEach((e1)=>this.parent.removeEventListener("mousemove", e1)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), delete this._drawingMoves, this._drawingAnnotation = null;
    }
    getPositionFromEvent(e1) {
        const t = this.container.getBoundingClientRect(), i = e1.clientX - t.left, n = e1.clientY - t.top, a = this.renderer.getIntersections({
            x: i,
            y: n
        }).find((e1)=>e1.object.userData[$785da19a645c07eb$var$sK.VIEWER_DATA]);
        if (a) return this.dataHelper.vector3ToSphericalCoords(a.point);
    }
    forceRefresh() {
        const e1 = this._myVTour.getCurrentNode();
        if (e1 && e1.panorama.baseUrl !== e1?.panorama?.origBaseUrl) {
            const t = this.getZoomLevel(), i = this.getPosition();
            this._myVTour.state.currentNode = null, this._myVTour.setCurrentNode(e1.id, {
                zoomTo: t,
                rotateTo: i,
                fadeIn: !1,
                speed: 0,
                rotation: !1
            });
        }
        e1 && e1.panorama.rows > 1 && this.adapter.__refresh();
    }
}
const $785da19a645c07eb$var$C0 = new CSSStyleSheet;
$785da19a645c07eb$var$C0.replaceSync("/* General layout */\npnx-editor {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n}\n\npnx-editor .pnx-map,\npnx-editor .pnx-psv {\n\theight: 50%;\n\tposition: relative;\n}\n\n/* Map background widget */\npnx-editor pnx-map-background {\n\tposition: absolute;\n\tpadding: 7px;\n\tz-index: 120;\n\tborder-radius: 10px;\n\tborder: 1px solid var(--widget-border-div);\n\tbackground-color: var(--widget-bg);\n  \tcolor: var(--widget-font);\n\tbottom: 10px;\n\tleft: 10px;\n\tfont-family: var(--font-family);\n}\n\n/* Player widget */\npnx-editor pnx-widget-player {\n\tmargin-top: 10px;\n}\npnx-editor pnx-widget-player #pnx-player-play,\npnx-editor pnx-widget-player #pnx-player-play-backward {\n\tdisplay: none;\n}\n\n/* Map scale */\npnx-editor .maplibregl-ctrl-scale {\n\tposition: absolute;\n\tbottom: 75px;\n\tleft: 0;\n\tfloat: unset;\n}"), document.adoptedStyleSheets.push($785da19a645c07eb$var$C0);
const $785da19a645c07eb$var$T0 = "sequence-headings";
class $785da19a645c07eb$var$D0 extends $785da19a645c07eb$var$po {
    static properties = {
        raster: {
            converter: $785da19a645c07eb$var$po.GetJSONConverter()
        },
        background: {
            type: String
        },
        "map-style": {
            type: String
        },
        "allow-drag-picture": {
            type: Boolean
        },
        ...$785da19a645c07eb$var$po.properties
    };
    constructor(){
        super(), this.raster = null, this.background = "streets", this["allow-drag-picture"] = !1, this["map-style"] = this.getAttribute("map-style") || "https://panoramax.openstreetmap.fr/pmtiles/basic.json";
        try {
            this["map-style"] = JSON.parse(this["map-style"]);
        } catch (e1) {}
        this._psvContainer = document.createElement("div"), this._psvContainer.setAttribute("slot", "bg"), this._mapContainer = document.createElement("div"), this._mapContainer.setAttribute("slot", "bg"), this.grid = $785da19a645c07eb$var$ks("pnx-cornered-grid"), this.grid.appendChild(this._psvContainer), this.grid.appendChild(this._mapContainer);
    }
    connectedCallback() {
        if (super.connectedCallback(), this.mapStyleComposer = new $785da19a645c07eb$var$oO(this), this.mapStyleComposer.addBasemap("streets", this["map-style"], !0), this.raster) {
            const e1 = this.mapStyleComposer._createRasterBasemap(this.raster);
            "aerial" === this.background && this.mapStyleComposer.switchBasemap(e1);
        }
        this._moveChildToGrid(), window.addEventListener("DOMContentLoaded", ()=>{
            this._moveChildToGrid();
        }, {
            once: !0
        }), this.onceAPIReady().then(()=>{
            this.loader.setAttribute("value", 30), this.sequence || this.loader.dismiss({}, "No sequence is selected"), this.addEventListener("select", this._onSelect.bind(this)), this._initPSV(), this._initMap();
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.map?.destroy(), this.psv?.destroy();
    }
    getClassName() {
        return "Editor";
    }
    onceReady() {
        return this.map && this.psv && this.map.loaded?.() ? Promise.resolve() : new Promise((e1)=>setTimeout(e1, 100)).then(this.onceReady.bind(this));
    }
    render() {
        return [
            this.loader,
            this.grid
        ];
    }
    getSubComponentsNames() {
        return super.getSubComponentsNames().concat([
            "map",
            "psv",
            "grid",
            "mapStyleComposer"
        ]);
    }
    _initPSV() {
        try {
            this.psv = new $785da19a645c07eb$var$M0(this, this._psvContainer, {
                picturesNavigation: "seq"
            }), this.psv._myVTour.datasource.nodeResolver = this._getNode.bind(this), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-player", {
                slot: "top",
                _parent: this,
                class: "pnx-only-psv pnx-print-hidden",
                size: "xl",
                more: "never"
            }));
        } catch (e1) {
            let t = $785da19a645c07eb$var$SX.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
            this.loader.dismiss(e1, t);
        }
    }
    _initMap() {
        try {
            this.map = new $785da19a645c07eb$var$XB(this, this._mapContainer, {
                background: this.background,
                zoom: 15,
                picMarkerDraggable: this["allow-drag-picture"]
            }), $785da19a645c07eb$var$Uo(this), this.loader.setAttribute("value", 50), this._loadSequence(), this.map.once("load", ()=>{
                this.mapStyleComposer.hasManyBasemaps() && this._addMapBackgroundWidget();
            });
            const e1 = this.map._picMarker.setRotation.bind(this.map._picMarker);
            this.map._picMarker.setRotation = (t)=>(t = void 0 === this._lastRelHeading ? t : t + this._lastRelHeading - this.psv.getPictureRelativeHeading(), e1(t));
        } catch (e1) {
            this.loader.dismiss(e1, this._t.pnx.error_psv);
        }
    }
    _loadSequence() {
        return this.loader.setAttribute("value", 60), this.api.getSequenceItems(this.sequence).then((e1)=>{
            this.loader.setAttribute("value", 80), this._sequenceData = e1.features;
            const t = {
                type: "FeatureCollection",
                features: [
                    {
                        id: this.sequence,
                        type: "Feature",
                        properties: {
                            id: this.sequence
                        },
                        geometry: {
                            type: "LineString",
                            coordinates: e1.features.map((e1)=>e1.geometry.coordinates)
                        }
                    },
                    ...e1.features.map((e1)=>(e1.properties.id = e1.id, e1.properties.sequences = [
                            this.sequence
                        ], e1))
                ]
            };
            if (this.map.once("styledata", ()=>this.loader.dismiss()), this.mapStyleComposer.addPanoramaxEndpoint("default", {
                sources: {
                    geovisio: {
                        type: "geojson",
                        data: t
                    }
                }
            }, !0), this.picture) {
                const t = e1.features.find((e1)=>e1.id === this.picture);
                t ? (this.select(this.sequence, this.picture, !0), this.map.jumpTo({
                    center: t.geometry.coordinates,
                    zoom: 18
                })) : console.log("Picture with ID", t, "was not found");
            } else {
                const t = [
                    ...e1.features[0].geometry.coordinates,
                    ...e1.features[0].geometry.coordinates
                ];
                for(let i = 1; i < e1.features.length; i++){
                    const n = e1.features[i].geometry.coordinates;
                    n[0] < t[0] && (t[0] = n[0]), n[1] < t[1] && (t[1] = n[1]), n[0] > t[2] && (t[2] = n[0]), n[1] > t[3] && (t[3] = n[1]);
                }
                this.map.fitBounds(t, {
                    animate: !1
                });
            }
        }).catch((e1)=>this.loader.dismiss(e1, this._t.pnx.error_api));
    }
    _getNode(e1) {
        const t = this._sequenceData.find((t)=>t.properties.id === e1), i = t ? $785da19a645c07eb$var$yO(t, this._t, this._isInternetFast, void 0, (e1)=>this.api.cleanResourceURL(e1)) : null;
        return i;
    }
    _addMapBackgroundWidget() {
        const e1 = $785da19a645c07eb$var$ks("pnx-map-background", {
            _parent: this,
            size: "sm",
            slot: "bottom-left"
        });
        this.grid.appendChild(e1);
    }
    _moveChildToGrid() {
        Array.from(this.querySelectorAll("[slot]")).forEach((e1)=>{
            e1.tagName?.toLowerCase().startsWith("pnx-") && (e1._parent = this, e1._t = this._t), this.grid.appendChild(e1);
        });
    }
    previewSequenceHeadingChange(e1) {
        const t = void 0 !== this.mapStyleComposer.layerRanges.dataOverlays[$785da19a645c07eb$var$T0];
        if (this.map._picMarkerPreview.remove(), void 0 === e1) return delete this._lastRelHeading, t && this.mapStyleComposer.switchDataOverlayVisibility($785da19a645c07eb$var$T0, !1), void (this.picture && this.map._picMarker.setRotation(this.psv.getXY().x));
        this._lastRelHeading = e1, t ? this.mapStyleComposer.switchDataOverlayVisibility($785da19a645c07eb$var$T0, !0) : this.mapStyleComposer.addDataOverlay($785da19a645c07eb$var$T0, {
            layers: [
                {
                    id: $785da19a645c07eb$var$T0,
                    type: "symbol",
                    source: "geovisio",
                    layout: {
                        "icon-image": "pnx-marker",
                        "icon-overlap": "always",
                        "icon-size": .8
                    }
                }
            ]
        }, !0), this.picture && this.map._picMarker.setRotation(this.psv.getXY().x), this.mapStyleComposer.waitFor("dataOverlays", $785da19a645c07eb$var$T0).then(()=>{
            const t = this.mapStyleComposer.layerRanges.dataOverlays[$785da19a645c07eb$var$T0], i = -this.psv.getPictureRelativeHeading();
            t.layers[0].layout["icon-rotate"] = [
                "+",
                [
                    "get",
                    "view:azimuth"
                ],
                i,
                e1
            ];
            const n = [
                [
                    "==",
                    [
                        "geometry-type"
                    ],
                    "Point"
                ]
            ];
            this.picture && n.push([
                "!=",
                [
                    "get",
                    "id"
                ],
                this.picture
            ]), t.filter = [
                "all",
                ...n
            ], this.mapStyleComposer.updateMapStyle(), setTimeout(()=>{
                this.map.setFilter($785da19a645c07eb$var$T0, [
                    "all",
                    ...n
                ]);
            }, 100);
        });
    }
    _onSelect() {
        void 0 !== this._lastRelHeading && this.previewSequenceHeadingChange(this._lastRelHeading);
    }
}
customElements.define("pnx-editor", $785da19a645c07eb$var$D0);
const $785da19a645c07eb$var$P0 = [
    "speed",
    "nav",
    "focus",
    "pic",
    "xyz",
    "map",
    "background",
    "users",
    "s",
    "xywh",
    "annot",
    "seq",
    "overlay",
    "level"
].concat(Object.values($785da19a645c07eb$var$QB)), $785da19a645c07eb$var$I0 = [
    "focus-changed",
    "pictures-navigation-changed"
], $785da19a645c07eb$var$F0 = [
    "position-updated",
    "zoom-updated",
    "view-rotated",
    "picture-loaded",
    "picture-failed",
    "transition-duration-changed",
    "annotation-focused",
    "annotations-unfocused"
], $785da19a645c07eb$var$z0 = [
    "moveend",
    "zoomend",
    "boxzoomend",
    "styledata"
], $785da19a645c07eb$var$R0 = [
    "filters-changed",
    "theme-changed",
    "panoramax-changed",
    "basemap-changed"
];
class $785da19a645c07eb$var$L0 extends EventTarget {
    constructor(e1){
        super(), this._parent = e1, this._delay = null;
    }
    listenToChanges() {
        window.addEventListener("popstate", this._onURLChange.bind(this), !1), $785da19a645c07eb$var$I0.forEach((e1)=>this._parent.addEventListener(e1, this._onParentChange.bind(this))), $785da19a645c07eb$var$F0.forEach((e1)=>this._parent.psv.addEventListener(e1, this._onParentChange.bind(this))), this._parent.map && ($785da19a645c07eb$var$z0.forEach((e1)=>this._parent.map.on(e1, this._onParentChange.bind(this))), $785da19a645c07eb$var$R0.forEach((e1)=>this._parent.mapStyleComposer.addEventListener(e1, this._onParentChange.bind(this))), this._parent.map.indoorEqual?.on("levelchange", this._onParentChange.bind(this)));
    }
    destroy() {
        window.removeEventListener("popstate", this._onURLChange);
    }
    nextURLParams() {
        let e1 = {};
        "number" == typeof this._parent.psv.getTransitionDuration() && (e1.speed = this._parent.psv.getTransitionDuration()), [
            null,
            "any"
        ].includes(this._parent.psv.getPicturesNavigation()) || (e1.nav = this._parent.psv.getPicturesNavigation()), this._parent.psv.getPictureId() && (e1.pic = this._parent.psv.getPictureId());
        const t = this._parent.psv.getPictureMetadata();
        t && (e1.xyz = this.currentPSVString(), t.sequence?.id && (e1.seq = t.sequence.id));
        const i = this._parent.psv.getSelectedAnnotations();
        if (i?.length > 0 && (e1.annot = i[0]), this._parent.map?.loaded) {
            if (e1.map = this.currentMapString(), e1.focus = "pic", this._parent.isMapWide() && (e1.focus = "map"), this._parent.mapStyleComposer?.hasManyBasemaps?.() && this._parent.mapStyleComposer?.basemap && (e1.background = this._parent.mapStyleComposer.basemap), this._parent.mapStyleComposer?.panoramax && (e1.users = this._parent.mapStyleComposer.panoramax), this._parent.mapStyleComposer?.panoramaxTheme && (e1.theme = this._parent.mapStyleComposer.panoramaxTheme), this._parent.mapStyleComposer.panoramaxFilters) {
                for(let t in $785da19a645c07eb$var$QB)"theme" !== t && this._parent.mapStyleComposer.panoramaxFilters[t] && (e1[$785da19a645c07eb$var$QB[t]] = this._parent.mapStyleComposer.panoramaxFilters[t]);
                if (e1.pic_score) {
                    if (Array.isArray(e1.pic_score) || (e1.pic_score = e1.pic_score.split(",")), 5 === e1.pic_score.length) delete e1.pic_score;
                    else {
                        const t = [
                            null,
                            "E",
                            "D",
                            "C",
                            "B",
                            "A"
                        ];
                        e1.pic_score = e1.pic_score.map((e1)=>t[e1]).join("");
                    }
                }
                Array.isArray(e1.gps) && 5 === e1.gps.length && delete e1.gps;
            }
            if (this._parent.map?.getSemanticOverlays) {
                const t = this._parent.map.getSemanticOverlays().filter((e1)=>this._parent.mapStyleComposer.dataOverlays.has(e1.source)).map((e1)=>e1.id);
                t.length > 0 && (e1.overlay = t.join(","));
            }
            this._parent.map?.indoorEqual && (e1.level = this._parent.map.indoorEqual.level);
        }
        return e1;
    }
    nextURLString() {
        let e1 = "";
        return Object.entries(this.nextURLParams()).sort((e1, t)=>e1[0].localeCompare(t[0])).forEach((t)=>{
            let [i, n] = t, a = !1;
            const r = e1.split("&").map((e1)=>{
                const t = e1.split("=")[0];
                return t === i ? (a = !0, `${t}=${n}`) : e1;
            }).filter((e1)=>e1);
            a || r.push(`${i}=${n}`), e1 = `${r.join("&")}`;
        }), `?${e1}`.replace(/^\?+/, "?");
    }
    currentURLParams(e1 = !1) {
        const t = (e1 ? window.location.hash : window.location.search).replace(/^[?#]/, "").replace(/&amp;/g, "&");
        let i = {};
        if (t.split("&").map((e1)=>e1.split("=")).filter((e1)=>void 0 !== e1[0] && e1[0].length > 0 && $785da19a645c07eb$var$P0.includes(e1[0])).forEach((e1)=>{
            i[e1[0]] = e1[1];
        }), i.s) {
            const e1 = Object.fromEntries(decodeURIComponent(i.s).split(";").map((e1)=>[
                    e1[0],
                    e1.substring(1)
                ]));
            i = {}, "m" === e1.f ? i.focus = "map" : "p" === e1.f ? i.focus = "pic" : "t" === e1.f && (i.focus = "meta"), "" !== e1.s && (i.speed = 100 * parseFloat(e1.s)), "a" === e1.n ? i.nav = "any" : "s" === e1.n && (i.nav = "seq"), [
                "n",
                "p"
            ].includes(e1.n) && (i.nav = "pic"), "" !== e1.p && (i.pic = e1.p), "" !== e1.a && (i.annot = e1.a), "" !== e1.c && (i.xyz = e1.c), "" !== e1.m && (i.map = e1.m), "" !== e1.d && (i.date_from = e1.d), "" !== e1.e && (i.date_to = e1.e), "f" === e1.t ? i.pic_type = "flat" : "e" === e1.t && (i.pic_type = "equirectangular"), "" !== e1.k && (i.camera = e1.k), "d" === e1.v ? i.theme = "default" : "a" === e1.v ? i.theme = "age" : "t" === e1.v ? i.theme = "type" : "s" === e1.v ? i.theme = "score" : "g" === e1.v && (i.theme = "gps"), "s" === e1.b ? i.background = "streets" : "a" === e1.b && (i.background = "aerial"), "" !== e1.u && (i.users = e1.u), "" !== e1.q && (i.pic_score = e1.q), "" !== e1.g && (i.gps = e1.g), "" !== e1.o && (i.overlay = e1.o), "" !== e1.l && (i.level = e1.l);
        }
        return i;
    }
    currentMapString() {
        if (!this._parent.map?.loaded) return "";
        const e1 = this._parent.map.getCenter(), t = Math.round(100 * this._parent.map.getZoom()) / 100, i = Math.ceil((t * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), n = Math.pow(10, i), a = Math.round(e1.lng * n) / n, r = Math.round(e1.lat * n) / n, s = this._parent.map.getBearing(), o = this._parent.map.getPitch();
        let l = `${t}/${r}/${a}`;
        return (s || o) && (l += "/" + Math.round(10 * s) / 10), o && (l += `/${Math.round(o)}`), l;
    }
    currentPSVString() {
        const e1 = this._parent.psv.getXYZ();
        return `${e1.x.toFixed(2)}/${e1.y.toFixed(2)}/${Math.round(e1.z || 0)}`;
    }
    _onURLChange() {
        let e1 = this.currentURLParams();
        "Viewer" === this._parent.getClassName() ? $785da19a645c07eb$var$rO(this._parent, e1) : $785da19a645c07eb$var$aO(this._parent, e1), $785da19a645c07eb$var$iO(this._parent.psv, e1), this._parent.map && $785da19a645c07eb$var$nO(this._parent.map, e1);
    }
    nextShortLink(e1) {
        const t = new URL(e1), i = this.nextURLParams(), n = {
            f: (i.focus || "").substring(0, 1),
            s: isNaN(parseInt(i.speed)) ? void 0 : Math.floor(parseInt(i.speed) / 100),
            n: (i.nav || "").substring(0, 1),
            p: i.pic,
            c: i.xyz,
            m: i.map,
            d: i.date_from,
            e: i.date_to,
            t: (i.pic_type || "").substring(0, 1),
            k: i.camera,
            v: (i.theme || "").substring(0, 1),
            b: $785da19a645c07eb$var$sO.includes(i.background) ? (i.background || "").substring(0, 1) : i.background || "",
            u: i.users,
            q: i.pic_score,
            a: i.annot,
            g: i.gps,
            o: i.overlay,
            l: i.level
        }, a = Object.entries(n).filter(([, e1])=>null != e1 && "" != e1).map(([e1, t])=>`${e1}${t}`).join(";");
        return t.search = `s=${a}`, t;
    }
    getUnmanagedParameters(e1) {
        return new URLSearchParams(Array.from(e1.searchParams).filter(([e1])=>!$785da19a645c07eb$var$P0.includes(e1))).toString();
    }
    _onParentChange() {
        this._delay && (clearTimeout(this._delay), this._delay = null), this._delay = setTimeout(()=>{
            const e1 = new URL(window.location.href), t = new URL(window.location.href), i = this.getUnmanagedParameters(e1);
            if (t.search = this._parent ? this.nextURLString() + (i.length > 0 ? "&" + i : "") : "", Object.keys(this.currentURLParams(!0)).length > 0 && (t.hash = ""), e1.search === t.search) return;
            const n = this.currentURLParams().pic || "", a = this._parent?.psv?.getPictureId?.() || "";
            try {
                if (n != a ? window.history.pushState(window.history.state, null, t.href) : window.history.replaceState(window.history.state, null, t.href), this._parent) {
                    const e1 = new CustomEvent("url-changed", {
                        detail: {
                            url: t.href
                        }
                    });
                    this.dispatchEvent(e1);
                }
            } catch (e1) {}
        }, 500);
    }
}
const $785da19a645c07eb$var$B0 = {
    fas: "fa7-solid"
}, $785da19a645c07eb$var$O0 = {};
class $785da19a645c07eb$var$U0 {
    constructor(e1 = null, t = !1){
        this._ready = !1, this._presets = null, this._translations = {}, t || this._load(e1);
    }
    async _load(e1) {
        e1 = e1?.substring(0, 2) || $785da19a645c07eb$var$ft()[0]?.substring(0, 2);
        try {
            const [t, i, n] = await Promise.all([
                fetch("https://presets.panoramax.fr/translations/en.min.json"),
                e1 ? fetch(`https://presets.panoramax.fr/translations/${e1}.min.json`) : Promise.resolve({
                    ok: !0
                }),
                fetch("https://presets.panoramax.fr/presets.min.json")
            ]);
            if (!(t && i && n && t.ok && i.ok && n.ok)) throw this._ready = -1, new Error("Presets service is not available");
            this._presets = await n.json(), this._translations.en = (await t.json())?.en?.presets, e1 && (this._translations[e1] = (await i.json())?.[e1]?.presets), Object.entries(this._presets).forEach(([t, i])=>{
                if (this._translations[e1]?.presets?.[t]?.name ? i.name = this._translations[e1].presets[t].name : this._translations.en?.presets?.[t]?.name && (i.name = this._translations.en.presets[t].name), i.icon) {
                    const e1 = i.icon.split("-")[0], t = $785da19a645c07eb$var$B0[e1];
                    i.iconify = t ? i.icon.replace(e1 + "-", t + ":") : i.icon.split("-")[0] + ":" + i.icon.split("-").slice(1).join("-"), $785da19a645c07eb$var$O0[i.iconify] && (i.iconify = $785da19a645c07eb$var$O0[i.iconify]);
                }
            }), this._ready = !0;
        } catch (e1) {
            console.error("Presets service throws an error:", e1), this._ready = -1;
        }
    }
    async onceReady() {
        return this._ready ? -1 === this._ready ? Promise.reject() : Promise.resolve() : (await new Promise((e1)=>setTimeout(e1, 250)), this.onceReady());
    }
    async getPreset(e1) {
        return await this.getPresets(e1).then((e1)=>e1.shift());
    }
    async getPresets(e1) {
        return await this.onceReady().then(()=>{
            const t = Object.values(this._presets).filter((t)=>{
                if (0 === Object.keys(t.tags).length) return !1;
                for(let i in t.tags){
                    const n = t.tags[i];
                    if (!e1.semantics || !e1.semantics.find((e1)=>"delete" !== e1.action && e1.key === i && ("*" === n || n === e1.value))) return !1;
                }
                return !0;
            });
            return t.sort((e1, t)=>{
                const i = Object.keys(e1.tags).length, n = Object.keys(t.tags).length;
                if (i > n) return -1;
                if (i === n) {
                    const i = Object.values(e1.tags).filter((e1)=>"*" === e1).length, n = Object.values(t.tags).filter((e1)=>"*" === e1).length;
                    return i < n ? -1 : i > n ? 1 : 0;
                }
                return 1;
            }), t;
        });
    }
}
const $785da19a645c07eb$var$N0 = new CSSStyleSheet;
$785da19a645c07eb$var$N0.replaceSync('pnx-photo-viewer {\n\tposition: relative;\n\tdisplay: block;\n}\n\n/* Maximized components */\npnx-photo-viewer .pnx-psv {\n\tposition: absolute;\n\tinset: 0;\n\tz-index: 0;\n}\n\n/* No PSV loader */\npnx-photo-viewer .psv-loader {\n\tdisplay: none;\n}\n\n/* Cornered grid layout */\npnx-photo-viewer pnx-cornered-grid::part(corner-top-left),\npnx-photo-viewer pnx-cornered-grid::part(corner-top),\npnx-photo-viewer pnx-cornered-grid::part(corner-top-right),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom-left),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom),\npnx-photo-viewer pnx-cornered-grid::part(corner-bottom-right) {\n\tgap: 10px;\n\tpadding: 10px;\n}\n\n@media screen and (max-width: 576px) {\n\tpnx-photo-viewer pnx-cornered-grid::part(corner-top-right) {\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tjustify-content: flex-start;\n\t}\n\n\tpnx-photo-viewer pnx-cornered-grid::part(corner-top-left) {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: flex-start;\n\t}\n}\n\n/* Hidden widgets on sequence play */\npnx-photo-viewer.pnx-playing pnx-bottom-drawer,\npnx-photo-viewer.pnx-playing pnx-widget-legend,\npnx-photo-viewer.pnx-playing pnx-widget-zoom,\npnx-photo-viewer.pnx-playing pnx-time-travel {\n\tdisplay: none;\n}\n\n/* Override legend positioning */\n@media screen and (min-width: 576px) {\n\tpnx-photo-viewer pnx-widget-legend:not([light="true"]) {\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\twidth: 100%;\n\t}\n}\n\n/* Hidden widgets on grid toggled */\npnx-photo-viewer .psv-virtual-tour-arrows {\n\ttransition: opacity 0.25s ease-in-out;\n\topacity: 100%;\n}\npnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows {\n\topacity: 0%;\n}\npnx-photo-viewer.pnx-grid-toggled .psv-virtual-tour-arrows button {\n\tpointer-events: none;\n\tcursor: unset;\n}'), document.adoptedStyleSheets.push($785da19a645c07eb$var$N0);
const $785da19a645c07eb$var$j0 = Math.PI / 6, $785da19a645c07eb$var$V0 = [
    "pnx-mini",
    "pnx-widget-player",
    "pnx-widget-zoom"
];
class $785da19a645c07eb$var$q0 extends $785da19a645c07eb$var$po {
    static properties = {
        "psv-options": {
            converter: $785da19a645c07eb$var$po.GetJSONConverter()
        },
        widgets: {
            type: String
        },
        "url-parameters": {
            type: String
        },
        "keyboard-shortcuts": {
            type: String
        },
        tabindex: {
            type: Number
        },
        "skip-tags-menu-opening": {
            type: String
        },
        "share-base-url": {
            type: String
        },
        ...$785da19a645c07eb$var$po.properties
    };
    constructor(){
        super(), this["psv-options"] = {}, this["url-parameters"] = this.getAttribute("url-parameters") || "true", this["keyboard-shortcuts"] = this.getAttribute("keyboard-shortcuts") || "true", this["skip-tags-menu-opening"] = "true" !== (this.getAttribute("skip-tags-menu-opening") || "false"), this["share-base-url"] = this.getAttribute("share-base-url") || null, this.widgets = this.getAttribute("widgets") || "true", this.grid = $785da19a645c07eb$var$ks("pnx-cornered-grid"), this.psvContainer = document.createElement("div"), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.popup = $785da19a645c07eb$var$ks("pnx-popup", {
            _parent: this,
            onclose: this._onPopupClose.bind(this)
        }), this.tabindex = 0, this._sequencesMetadata = {}, this._openedMenus = 0, this._openedMenusChanges = null, this.addEventListener("menu-opened", ()=>{
            this._openedMenusChanges = [
                Date.now(),
                this._openedMenus
            ], this._openedMenus++;
        }), this.addEventListener("menu-closed", ()=>{
            this._openedMenusChanges = [
                Date.now(),
                this._openedMenus
            ], this._openedMenus--;
        });
    }
    _createInitParamsHandler() {
        this._initParams = new $785da19a645c07eb$var$eO($785da19a645c07eb$var$eO.GetComponentProperties($785da19a645c07eb$var$q0, this), Object.assign({}, this.urlHandler?.currentURLParams(), this.urlHandler?.currentURLParams(!0)), {
            disableAnnotations: localStorage.getItem($785da19a645c07eb$var$Me)
        });
    }
    _initWidgets() {
        "false" !== this._initParams.getParentPostInit().widgets && ($785da19a645c07eb$var$Ye() || (this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-player", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-annotations-switch", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        }))), $785da19a645c07eb$var$Ye() ? (this.legend = $785da19a645c07eb$var$ks("pnx-widget-legend", {
            slot: "bottom-right",
            light: !0,
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this.grid.appendChild(this.legend)) : this.isWidthSmall() ? (this.legend = $785da19a645c07eb$var$ks("pnx-picture-legend", {
            _parent: this
        }), this.bottomDrawer = $785da19a645c07eb$var$ks("pnx-bottom-drawer", {
            slot: "bottom",
            _parent: this,
            openness: this._initParams.getParentPostInit().willLoadPicture ? void 0 : "hidden"
        }), this._initParams.getParentPostInit().willLoadPicture && this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer)) : (this.legend = $785da19a645c07eb$var$ks("pnx-widget-legend", {
            slot: this.isWidthSmall() ? void 0 : "top-left",
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-fullscreen", {
            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
            _parent: this
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-zoom", {
            slot: "bottom-right",
            class: "pnx-print-hidden",
            _parent: this
        })), this.grid.appendChild(this.legend), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-time-travel", {
            slot: "bottom",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: "xl"
        }))));
    }
    connectedCallback() {
        super.connectedCallback(), this.presetsManager = new $785da19a645c07eb$var$U0(this.lang), "false" !== this["url-parameters"] && (this.urlHandler = new $785da19a645c07eb$var$L0(this), this.onceReady().then(()=>{
            this.urlHandler.listenToChanges(), this.urlHandler._onParentChange();
        })), this.onceAPIReady().then(this._postAPIInit.bind(this)), this._moveChildToGrid(), window.addEventListener("DOMContentLoaded", ()=>{
            this._moveChildToGrid();
        }, {
            once: !0
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.urlHandler?.destroy(), this.psv?.destroy(), document.body.removeEventListener("click", this._toggleKeyboardBasedOnFocus), window.removeEventListener("keypress", this._toggleKeyboardBasedOnFocus);
    }
    getClassName() {
        return "PhotoViewer";
    }
    async onceReady() {
        return await this.oncePSVReady().then(()=>this._initParams.getParentPostInit().willLoadPicture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
    }
    render() {
        return [
            this.loader,
            this.grid,
            this.popup
        ];
    }
    getSubComponentsNames() {
        return super.getSubComponentsNames().concat([
            "psv",
            "grid",
            "popup",
            "urlHandler"
        ]);
    }
    oncePSVReady() {
        let e1;
        return new Promise((t)=>{
            e1 = setInterval(()=>{
                this.psv && "object" == typeof this.psv && (this.psv.container ? (clearInterval(e1), t()) : this.psv.addEventListener && this.psv.addEventListener("ready", ()=>{
                    clearInterval(e1), t();
                }, {
                    once: !0
                }));
            }, 250);
        });
    }
    onceFirstPicLoaded() {
        return this.oncePSVReady().then(()=>this.psv.getPictureMetadata() ? Promise.resolve() : new Promise((e1)=>{
                const t = ()=>{
                    this.psv.removeEventListener("picture-failed", i), e1();
                }, i = ()=>{
                    this.psv.removeEventListener("picture-loaded", t), e1();
                };
                this.psv.addEventListener("picture-loaded", t, {
                    once: !0
                }), this.psv.addEventListener("picture-failed", i, {
                    once: !0
                });
            }));
    }
    _postAPIInit() {
        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
        const e1 = this._initParams.getParentPostInit();
        if (this._initPSV(), this._initWidgets(), $785da19a645c07eb$var$aO(this, e1), e1.keyboardShortcuts && this._handleKeyboardManagement(), e1.willLoadPicture) {
            if (this.psv.getPictureMetadata()) this.loader.dismiss();
            else {
                const e1 = ()=>{
                    this.loader.dismiss(), this.psv.removeEventListener("picture-failed", t);
                }, t = ()=>{
                    this.loader.dismiss(!0, this._t.pnx.error_pic), this.psv.removeEventListener("picture-loaded", e1);
                };
                this.psv.addEventListener("picture-loaded", e1, {
                    once: !0
                }), this.psv.addEventListener("picture-failed", t, {
                    once: !0
                });
            }
        } else this.loader.dismiss();
    }
    _initPSV() {
        try {
            this.psv = new $785da19a645c07eb$var$M0(this, this.psvContainer, {
                shouldGoFast: this._psvShouldGoFast.bind(this),
                keyboard: "always",
                keyboardActions: {
                    ...$785da19a645c07eb$var$wY.keyboardActions,
                    8: "ROTATE_UP",
                    2: "ROTATE_DOWN",
                    4: "ROTATE_LEFT",
                    6: "ROTATE_RIGHT",
                    PageUp: ()=>this.psv.goToNextPicture(),
                    9: ()=>this.psv.goToNextPicture(),
                    PageDown: ()=>this.psv.goToPrevPicture(),
                    3: ()=>this.psv.goToPrevPicture(),
                    5: ()=>this.moveCenter(),
                    "*": ()=>this.moveCenter(),
                    Home: ()=>this._toggleFocus?.(),
                    7: ()=>this._toggleFocus?.(),
                    End: ()=>this.mini.toggleAttribute("collapsed"),
                    1: ()=>this.mini.toggleAttribute("collapsed"),
                    " ": ()=>this.psv.toggleSequencePlaying(),
                    0: ()=>this.psv.toggleSequencePlaying()
                },
                ...this._initParams.getPSVInit()
            }), this.oncePSVReady().then(()=>{
                this.loader.setAttribute("value", 50), $785da19a645c07eb$var$iO(this.psv, this._initParams.getPSVPostInit());
            }), this.psv.addEventListener("sequence-playing", ()=>this.classList.add("pnx-playing")), this.psv.addEventListener("sequence-stopped", ()=>this.classList.remove("pnx-playing")), this.psv.addEventListener("picture-failed", ()=>this.select(null, null));
        } catch (e1) {
            let t = $785da19a645c07eb$var$SX.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
            this.loader.dismiss(e1, t);
        }
    }
    _hasMenuOpened() {
        return this._openedMenus > 0 || this._openedMenusChanges && Date.now() - this._openedMenusChanges[0] <= 250 && this._openedMenusChanges[1] >= 0;
    }
    _enableKeyboard() {
        this.psv.startKeyboardControl();
    }
    _disableKeyboard() {
        this.psv.stopKeyboardControl();
    }
    _toggleKeyboardBasedOnFocus(e1) {
        const t = e1?.target || document.activeElement;
        if (this.contains(t)) {
            for (let e1 of this.grid.childNodes)if ("bg" !== e1.getAttribute("slot") && !$785da19a645c07eb$var$V0.includes(e1.tagName.toLowerCase()) && e1.contains(t)) return void this._disableKeyboard();
            if (null !== this.popup.getAttribute("visible")) return void this._disableKeyboard();
            this._enableKeyboard();
        } else this._disableKeyboard();
    }
    _handleKeyboardManagement() {
        window.addEventListener("click", (e1)=>this._toggleKeyboardBasedOnFocus(e1)), window.addEventListener("keypress", this._toggleKeyboardBasedOnFocus.bind(this)), this.popup.addEventListener("open", this._disableKeyboard.bind(this)), this.popup.addEventListener("close", this._enableKeyboard.bind(this)), this.psv.addEventListener("click", this._enableKeyboard.bind(this));
        for (let e1 of this.grid.childNodes)"bg" === e1.getAttribute("slot") || $785da19a645c07eb$var$V0.includes(e1.tagName.toLowerCase()) || (e1.addEventListener("focusin", this._disableKeyboard.bind(this)), e1.addEventListener("focusout", ()=>{
            null === this.popup.getAttribute("visible") && this._enableKeyboard();
        }));
    }
    _psvShouldGoFast() {
        return this.psv._sequencePlaying && this.psv.getTransitionDuration() < 1e3;
    }
    _moveChildToGrid() {
        Array.from(this.querySelectorAll("[slot]")).forEach((e1)=>{
            e1.tagName?.toLowerCase().startsWith("pnx-") && (e1._parent = this, e1._t = this._t), "editors" === e1.getAttribute("slot") ? this.onceReady().then(()=>this.legend?.appendChild(e1)) : this.grid.appendChild(e1);
        });
    }
    isBottomDrawerVisible() {
        return "hidden" !== this.bottomDrawer.getAttribute("openness");
    }
    setBottomDrawer(e1, t = null, i = null) {
        this.bottomDrawer && (e1 || this.bottomDrawer.setAttribute("openness", "hidden"), i?.autoclose ? this.bottomDrawer.setAttribute("autoclose", "") : this.bottomDrawer.removeAttribute("autoclose", ""), i?.autoadjust ? this.bottomDrawer.setAttribute("autoadjust", "") : this.bottomDrawer.removeAttribute("autoadjust", ""), this.bottomDrawer.clearContent(), t && ("string" == typeof t ? this.bottomDrawer.setContent(t) : Array.isArray(t) ? t.forEach((e1)=>this.bottomDrawer.appendChild(e1)) : "object" == typeof t && this.bottomDrawer.appendChild(t)), !this.psv?._clickAndGo?._couldGoSomewhere && e1 && this.bottomDrawer.setAttribute("openness", i?.autoadjust ? "opened" : "half-opened"));
    }
    setPopup(e1, t = null) {
        e1 ? this.popup.setAttribute("visible", "") : this.popup.removeAttribute("visible"), this.popup.innerHTML = "", "string" == typeof t ? this.popup.innerHTML = t : Array.isArray(t) && t.forEach((e1)=>this.popup.appendChild(e1));
    }
    _onPopupClose() {
        this.dispatchEvent(new CustomEvent("focus-changed", {
            detail: {
                focus: this.map && this.isMapWide() ? "map" : "pic"
            }
        }));
    }
    _showQualityScoreDoc() {
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-quality-score-doc", {
                _t: this._t
            })
        ]);
    }
    _showReportForm() {
        if (!this.psv.getPictureMetadata()) throw new Error("No picture currently selected");
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-report-form", {
                _parent: this
            })
        ]);
    }
    _showShareOptions() {
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-share-menu", {
                _parent: this,
                "base-url": this["share-base-url"]
            })
        ]);
    }
    _showSemanticsDoc() {
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-semantics-doc", {
                _t: this._t
            })
        ]);
    }
    _showSemanticsDownload() {
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-semantics-download", {
                _t: this._t
            })
        ]);
    }
    moveCenter() {
        this.psv.getPictureMetadata() && this._psvAnimate({
            speed: $785da19a645c07eb$var$_0,
            yaw: 0,
            pitch: 0,
            zoom: 30
        });
    }
    moveLeft() {
        this._moveToDirection("left");
    }
    moveRight() {
        this._moveToDirection("right");
    }
    moveUp() {
        this._moveToDirection("up");
    }
    moveDown() {
        this._moveToDirection("down");
    }
    _moveToDirection(e1) {
        let t = this.psv.getPosition();
        switch(e1){
            case "up":
                t.pitch += $785da19a645c07eb$var$j0;
                break;
            case "left":
                t.yaw -= $785da19a645c07eb$var$j0;
                break;
            case "down":
                t.pitch -= $785da19a645c07eb$var$j0;
                break;
            case "right":
                t.yaw += $785da19a645c07eb$var$j0;
        }
        this._psvAnimate({
            speed: $785da19a645c07eb$var$_0,
            ...t
        });
    }
    _psvAnimate(e1) {
        this._lastPsvAnim && this._lastPsvAnim.cancel(), this._lastPsvAnim = this.psv.animate(e1);
    }
    addEventListener(e1, t, i) {
        super.addEventListener(e1, t, i);
    }
}
customElements.define("pnx-photo-viewer", $785da19a645c07eb$var$q0);
const $785da19a645c07eb$var$G0 = [
    [
        "features",
        '"semantics" IS NOT NULL',
        {
            metadata: {
                name: "All features"
            },
            type: "circle",
            layout: {
                visibility: "none"
            },
            paint: {
                "circle-radius": 4,
                "circle-color": "#00897B"
            }
        }
    ],
    [
        "tfsigns",
        '"semantics.osm|traffic_sign" IS NOT NULL',
        {
            metadata: {
                name: "Traffic signs"
            },
            type: "symbol",
            layout: {
                visibility: "none",
                "icon-overlap": "never",
                "icon-image": [
                    "case",
                    [
                        "in",
                        ";",
                        [
                            "get",
                            "osm|traffic_sign"
                        ]
                    ],
                    "pnx-tfsigns-fr:0_many",
                    [
                        "==",
                        [
                            "slice",
                            [
                                "get",
                                "osm|traffic_sign"
                            ],
                            0,
                            2
                        ],
                        "FR"
                    ],
                    [
                        "concat",
                        "pnx-tfsigns-fr:",
                        [
                            "slice",
                            [
                                "get",
                                "osm|traffic_sign"
                            ],
                            3
                        ]
                    ],
                    [
                        "==",
                        [
                            "get",
                            "osm|traffic_sign"
                        ],
                        "yes"
                    ],
                    "pnx-tfsigns-fr:0_unknown",
                    [
                        "has",
                        "osm|traffic_sign"
                    ],
                    "pnx-tfsigns-fr:0_unknown",
                    ""
                ]
            }
        },
        {
            "pnx-tfsigns-fr": "https://presets.panoramax.fr/sprites/trafficsigns_fr"
        }
    ]
];
function $785da19a645c07eb$var$H0(e1, t, i) {
    return $785da19a645c07eb$var$H`<a href=${t} target="_blank" title=${i}>${e1}</a>`;
}
const $785da19a645c07eb$var$W0 = [
    "highway",
    "building",
    "amenity",
    "landuse",
    "natural",
    "waterway",
    "leisure",
    "shop",
    "railway",
    "tourism",
    "barrier",
    "boundary",
    "place",
    "power"
], $785da19a645c07eb$var$Z0 = {};
function $785da19a645c07eb$var$K0(e1, t) {
    if ($785da19a645c07eb$var$Z0[e1]) return Promise.resolve($785da19a645c07eb$var$Z0[e1]);
    {
        const i = e1.startsWith("P") ? `properties/${e1}` : `items/${e1}/labels`;
        return fetch(`https://www.wikidata.org/w/rest.php/wikibase/v1/entities/${i}`).then((e1)=>e1.json()).then((i)=>($785da19a645c07eb$var$Z0[e1] = $785da19a645c07eb$var$gt(i.labels || i, t.PREF_LANG), $785da19a645c07eb$var$Z0[e1]));
    }
}
const $785da19a645c07eb$var$X0 = {
    "": {
        title: "Panoramax",
        value_transform: (e1, t)=>"osm" === e1.key ? $785da19a645c07eb$var$H0(e1.value, `https://openstreetmap.org/${e1.value}`, t.pnx.semantics_value_show_osm) : e1.value
    },
    osm: {
        title: "OpenStreetMap",
        logo: "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Created with Inkscape (http://www.inkscape.org/) --%3e%3csvg width='240mm' height='239.99869mm' viewBox='0 0 240 239.99869' id='svg6743' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cg id='layer1' transform='translate(-30%2c-27.000656)'%3e %3cg id='g7426' transform='translate(322.142%2c-53.972906)'%3e %3cpath style='display:inline%3bfill:%2376c551%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' id='path33449' d='m -81.063095%2c208.94609 c -11.906339%2c9.92421 -27.194885%2c15.8987 -43.860635%2c15.8987 -4.95854%2c0 -9.78728%2c-0.55158 -14.45059%2c-1.55504 l -4.79842%2c5.8446 c -10.66449%2c-2.85736 -20.38429%2c-7.94043 -28.6326%2c-14.74578 l -12.89559%2c12.92212 1.58177%2c9.54347 -47.96347%2c47.98965 4.63827%2c1.7685 45.04032%2c-17.15658 45.0402%2c17.15658 45.040312%2c-17.15658 17.158544%2c-45.03976 z' /%3e %3cpath d='m -272.48495%2c89.294626 17.1585%2c45.040274 -17.1585%2c45.03993 17.1585%2c45.03972 -17.1585%2c45.03977 10.53634%2c4.02267 57.2385%2c-57.21102 10.26764%2c1.58169 12.46673%2c-12.46669 c -7.35519%2c-8.52221 -12.86173%2c-18.6902 -15.87027%2c-29.92032 l 5.8446%2c-4.79842 c -1.00531%2c-4.66323 -1.55503%2c-9.49189 -1.55503%2c-14.45044 0%2c-24.76984 13.21043%2c-46.53472 32.94893%2c-58.606534 l -21.79693%2c-8.31063 -45.04019%2c17.158544 z' id='path33447' style='display:inline%3bfill:%2376c551%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' /%3e %3cpath style='display:inline%3bfill:%2359a336%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:3.61532' id='path33451' d='m -81.063095%2c208.94609 c -11.906339%2c9.92421 -27.194885%2c15.8987 -43.860635%2c15.8987 -4.95854%2c0 -9.78728%2c-0.55158 -14.45059%2c-1.55504 l -4.79842%2c5.8446 -28.67744%2c-15.11228 -12.85075%2c13.28862 1.58177%2c9.54347 46.85284%2c7.05799 -0.0982%2c42.70016 45.040313%2c-17.15658 17.158544%2c-45.03976 z' /%3e %3cellipse style='opacity:1%3bfill:white%3bfill-opacity:1%3bstroke:none%3bstroke-width:12.7048%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-dashoffset:0%3bstroke-opacity:1%3bmarker:none' id='ellipse33453' cx='-122.83165' cy='155.70955' rx='59.801929' ry='60.929199' /%3e %3cpath style='opacity:1%3bfill:%23cccccc%3bfill-opacity:1%3bstroke:none%3bstroke-width:12.7048%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-miterlimit:4%3bstroke-dasharray:none%3bstroke-dashoffset:0%3bstroke-opacity:1%3bmarker:none' d='m -70.867543%2c179.77128 c -4.021615%2c-66.77094 -70.182367%2c-83.311142 -110.499567%2c-45.77004 21.03677%2c-28.56709 48.05279%2c-46.045197 78.56638%2c-33.40602 30.51362%2c12.63913 41.797793%2c45.98173 31.933187%2c79.17606 z' id='path33455' /%3e %3cpath id='path33457' d='m -73.395575%2c102.22726 c -28.338185%2c-28.338264 -74.283665%2c-28.338264 -102.621895%2c0 -17.93779%2c17.93776 -24.48523%2c42.91327 -19.71413%2c66.02883 l -11.27485%2c8.16937 c 5.13477%2c13.61756 12.1317%2c21.8574 16.91241%2c26.2963 l -10.22839%2c10.22834 h -10.80252 l -81.01705%2c81.01654 27.00583%2c27.00561 81.01701%2c-81.01683 v -10.80225 l 10.19464%2c-10.19425 c 4.56162%2c4.75244 12.69997%2c11.38138 25.75686%2c16.30469 l 7.86543%2c-10.90386 c 23.35858%2c5.12197 48.742245%2c-1.34701 66.906498%2c-19.5115 28.338386%2c-28.33732 28.33819%2c-74.28276 1.57e-4%2c-102.62099 z m -12.962835%2c12.96296 c 21.179095%2c21.17921 21.179095%2c55.51685 0%2c76.69579 -21.17902%2c21.17897 -55.51721%2c21.17897 -76.6963%2c0 -21.17898%2c-21.17894 -21.17898%2c-55.51658 0%2c-76.69579 21.17929%2c-21.179216 55.51728%2c-21.179216 76.6963%2c0 z' style='color:black%3bdisplay:inline%3boverflow:visible%3bvisibility:visible%3bfill:%232f2f2f%3bfill-opacity:1%3bfill-rule:nonzero%3bstroke:none%3bstroke-width:7.76059%3bmarker:none%3benable-background:accumulate' /%3e %3c/g%3e %3c/g%3e%3c/svg%3e",
        key_transform: (e1, t)=>$785da19a645c07eb$var$H0(e1.key, `https://wiki.openstreetmap.org/wiki/Key:${e1.key}`, t.pnx.semantics_key_doc),
        value_transform: (e1, t)=>$785da19a645c07eb$var$W0.includes(e1.key) ? $785da19a645c07eb$var$H0(e1.value, `https://wiki.openstreetmap.org/wiki/Tag:${e1.key}=${e1.value}`, t.pnx.semantics_value_doc) : e1.value
    },
    wd: {
        title: "Wikidata",
        logo: "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 18'%3e%3cpath d='M2.5 1h1v16h-1zm2 0h3v16h-3zm4 0h3v16h-3z' fill='%23900'/%3e%3cpath d='M12.5 1h1v16h-1zm2 0h1v16h-1zm12 0h1v16h-1zm2 0h1v16h-1z' fill='%23396'/%3e%3cpath d='M16.5 1h3v16h-3zm4 0h1v16h-1zm2 0h3v16h-3z' fill='%23069'/%3e%3c/svg%3e",
        key_transform: (e1, t)=>{
            const i = `https://www.wikidata.org/wiki/Property:${e1.key}`;
            if (t.pnx.semantics_wikidata_properties[e1.key]) return $785da19a645c07eb$var$H0($785da19a645c07eb$var$H`${t.pnx.semantics_wikidata_properties[e1.key]} <small>(${e1.key})</small>`, i, t.pnx.semantics_key_doc);
            {
                const n = document.createElement("span");
                return n.innerText = e1.key, $785da19a645c07eb$var$K0(e1.key, t).then((t)=>{
                    n.innerHTML = `${t} <small>(${e1.key})</small>`;
                }), $785da19a645c07eb$var$H0(n, i, t.pnx.semantics_key_doc);
            }
        },
        value_transform: (e1, t)=>{
            const i = document.createElement("span");
            return i.innerText = e1.value, $785da19a645c07eb$var$K0(e1.value, t).then((t)=>{
                i.innerHTML = `${t} <small>(${e1.value})</small>`;
            }), $785da19a645c07eb$var$H0(i, `https://www.wikidata.org/wiki/${e1.value}`, t.pnx.semantics_value_doc);
        }
    },
    exif: {
        title: "EXIF"
    }
};
function $785da19a645c07eb$var$Q0(e1) {
    const t = (e1 || "").lastIndexOf("=");
    if (t < 0) return null;
    const i = $785da19a645c07eb$var$Y0(e1.substring(0, t));
    return i.subkey.indexOf("=") >= 0 ? null : {
        key: i,
        value: e1.substring(t + 1)
    };
}
function $785da19a645c07eb$var$Y0(e1 = "") {
    const t = e1.match(/^(?:([a-z_]+)\|)?([^[]+)(?:\[(.*)\])?$/);
    if (!t) return {
        prefix: "",
        subkey: e1,
        qualifies: null
    };
    const [, i, n, a] = t;
    return {
        key: e1,
        prefix: i || "",
        subkey: n,
        qualifies: $785da19a645c07eb$var$Q0(a)
    };
}
function $785da19a645c07eb$var$J0(e1) {
    const t = e1.split("\n").map((e1)=>{
        const t = $785da19a645c07eb$var$Q0(e1);
        return t && t.key.key.length <= 256 && t.value.length <= 2048 ? {
            key: t.key.key,
            value: t.value
        } : null;
    });
    if (t.findIndex((e1)=>!e1) >= 0) {
        if (0 === e1.trim().length && 1 === t.length) return [];
        throw new Error("Invalid tags");
    }
    return t;
}
function $785da19a645c07eb$var$$0(e1) {
    return (e1 || []).map((e1)=>`${e1.key}=${e1.value}`).join("\n");
}
function $785da19a645c07eb$var$e11(e1 = [], t = []) {
    const i = [];
    return (t || []).filter((t)=>void 0 === e1.find((e1)=>e1.key == t.key && e1.value == t.value)).forEach((e1)=>i.push({
            key: e1.key,
            value: e1.value,
            action: "add"
        })), (e1 || []).filter((e1)=>void 0 === t.find((t)=>e1.key == t.key && e1.value == t.value)).forEach((e1)=>i.push({
            key: e1.key,
            value: e1.value,
            action: "delete"
        })), i;
}
function $785da19a645c07eb$var$t1(e1) {
    const t = {}, i = [];
    return e1.forEach((e1)=>{
        if ("delete" === e1.action) return;
        const n = $785da19a645c07eb$var$Y0(e1.key);
        n.qualifies ? i.push(Object.assign({}, e1, n)) : (t[n.prefix] || (t[n.prefix] = []), t[n.prefix].push(n.prefix.length > 0 ? {
            key: n.subkey,
            value: e1.value
        } : e1));
    }), i.forEach(({ key: e1, prefix: i, subkey: n, qualifies: a, value: r })=>{
        const s = t[a.key.prefix]?.find((e1)=>e1.key === a.key.subkey && (!a.value || a.value === e1.value));
        s && (s.qualifiers || (s.qualifiers = []), s.qualifiers.push({
            key: e1,
            prefix: i,
            subkey: n,
            value: r
        }));
    }), Object.entries(t).map(([e1, t])=>$785da19a645c07eb$var$X0[e1] ? Object.assign({
            prefix: e1,
            tags: t
        }, $785da19a645c07eb$var$X0[e1]) : {
            prefix: e1,
            title: e1,
            tags: t
        });
}
var $785da19a645c07eb$var$i1 = Object.freeze({
    __proto__: null,
    SEMANTICS_OVERLAYS: $785da19a645c07eb$var$G0,
    computeDiffTags: $785da19a645c07eb$var$e11,
    decodeBasicTag: $785da19a645c07eb$var$Q0,
    decodeKey: $785da19a645c07eb$var$Y0,
    groupByPrefix: $785da19a645c07eb$var$t1,
    parseSemanticsString: $785da19a645c07eb$var$J0,
    semanticsToString: $785da19a645c07eb$var$$0
});
class $785da19a645c07eb$var$n1 extends $785da19a645c07eb$var$XB {
    constructor(e1, t, i = {}){
        super(e1, t, i), this._options.theme && this._parent.mapStyleComposer.setPanoramaxTheme(this._options.theme), this._featuresRestrict = {
            pictures: {},
            sequences: {}
        };
    }
    async _postLoad() {
        this._parent.api._endpoints.queryables && $785da19a645c07eb$var$G0.forEach((e1)=>this.addSemanticOverlay(...e1)), await super._postLoad();
    }
    setFilters(e1) {
        const t = this._parent.mapStyleComposer.panoramaxFilters, i = Object.assign({
            featuresRestrictions: t.featuresRestrictions
        }, e1);
        this._parent.mapStyleComposer.setPanoramaxFilters(i), e1.theme && this._parent.mapStyleComposer.setPanoramaxTheme(e1.theme);
    }
    restrictVisibleFeatures(e1, t, i) {
        this._featuresRestrict[t] = {
            rule: e1,
            features: i
        };
        const n = this._parent.mapStyleComposer.panoramaxFilters, a = Object.assign({}, n, {
            featuresRestrictions: this._featuresRestrict
        });
        this._parent.mapStyleComposer.setPanoramaxFilters(a);
    }
    addSemanticOverlay(e1, t, i, n = {}) {
        if (!this._parent.getAPI()._endpoints.queryables) throw new Error("Semantics overlay are not available on API");
        const a = "sem-" + e1, r = "none" !== i.layout.visibility, s = {
            sources: {
                [a]: {
                    type: "vector",
                    tiles: [
                        `sem:///${t}/{z}/{x}/{y}`
                    ],
                    minzoom: 15,
                    maxzoom: 19
                }
            },
            layers: [
                {
                    id: e1,
                    source: a,
                    "source-layer": "layer",
                    ...JSON.parse(JSON.stringify(i))
                }
            ],
            sprite: Object.entries(n || {}).map(([e1, t])=>({
                    id: e1,
                    url: t
                }))
        };
        delete s.layers[0].layout.visibility, this._parent.mapStyleComposer.addDataOverlay(a, s, r), this.on("click", e1, (e1)=>{
            if (e1.preventDefault(), e1?.features?.length > 0) {
                const t = e1.features[0];
                this._parent.select(t.properties.seqid, t.properties.picid), this._parent.psv.addEventListener("picture-loaded", ()=>{
                    const e1 = this._parent.psv.getPictureMetadata();
                    1 === e1.properties?.annotations?.length && this._parent.psv.focusOnAnnotation(e1.properties.annotations[0].id);
                }, {
                    once: !0
                });
            }
        });
    }
    getSemanticOverlays() {
        return Object.entries(this._parent.mapStyleComposer.layerRanges.dataOverlays).filter(([e1])=>e1.startsWith("sem-")).map(([, e1])=>e1.layers[0]);
    }
    toggleAllSemanticOverlays(e1) {
        Object.keys(this._parent.mapStyleComposer.layerRanges.dataOverlays).filter((e1)=>e1.startsWith("sem-")).forEach((t)=>this._parent.mapStyleComposer.switchDataOverlayVisibility(t, e1));
    }
}
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $785da19a645c07eb$var$a1 = {
    prefix: "fas",
    iconName: "at",
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
}, $785da19a645c07eb$var$r1 = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
}, $785da19a645c07eb$var$s1 = {
    prefix: "fas",
    iconName: "backward",
    icon: [
        512,
        512,
        [
            9194
        ],
        "f04a",
        "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z"
    ]
}, $785da19a645c07eb$var$o1 = {
    prefix: "fas",
    iconName: "circle-notch",
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"
    ]
}, $785da19a645c07eb$var$l1 = {
    prefix: "fas",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"
    ]
}, $785da19a645c07eb$var$c1 = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
}, $785da19a645c07eb$var$u1 = {
    prefix: "fas",
    iconName: "compress",
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"
    ]
}, $785da19a645c07eb$var$h1 = {
    prefix: "fas",
    iconName: "share-nodes",
    icon: [
        448,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
    ]
}, $785da19a645c07eb$var$d1 = $785da19a645c07eb$var$h1, $785da19a645c07eb$var$p1 = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [
        512,
        512,
        [],
        "f077",
        "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
}, $785da19a645c07eb$var$m1 = {
    prefix: "fas",
    iconName: "user",
    icon: [
        448,
        512,
        [
            128100,
            62144
        ],
        "f007",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"
    ]
}, $785da19a645c07eb$var$g1 = {
    prefix: "fas",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"
    ]
}, $785da19a645c07eb$var$f1 = {
    prefix: "fas",
    iconName: "square-plus",
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
}, $785da19a645c07eb$var$A1 = {
    prefix: "fas",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
}, $785da19a645c07eb$var$_1 = {
    prefix: "fas",
    iconName: "caret-up",
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"
    ]
}, $785da19a645c07eb$var$v1 = {
    prefix: "fas",
    iconName: "scroll",
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z"
    ]
}, $785da19a645c07eb$var$y1 = {
    prefix: "fas",
    iconName: "pause",
    icon: [
        320,
        512,
        [
            9208
        ],
        "f04c",
        "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z"
    ]
}, $785da19a645c07eb$var$x1 = {
    prefix: "fas",
    iconName: "palette",
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
}, $785da19a645c07eb$var$b1 = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [
        576,
        512,
        [],
        "f5fd",
        "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"
    ]
}, $785da19a645c07eb$var$w1 = {
    prefix: "fas",
    iconName: "vector-square",
    icon: [
        448,
        512,
        [],
        "f5cb",
        "M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32L128 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM96 160c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l-192 0c0-17.7-14.3-32-32-32l0-192zM48 400l32 0 0 32-32 0 0-32zm320 32l0-32 32 0 0 32-32 0zM48 112l0-32 32 0 0 32-32 0z"
    ]
}, $785da19a645c07eb$var$E1 = {
    prefix: "fas",
    iconName: "question",
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
}, $785da19a645c07eb$var$k1 = {
    prefix: "fas",
    iconName: "arrow-right",
    icon: [
        448,
        512,
        [
            8594
        ],
        "f061",
        "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
}, $785da19a645c07eb$var$S1 = {
    prefix: "fas",
    iconName: "satellite-dish",
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
}, $785da19a645c07eb$var$M1 = {
    prefix: "fas",
    iconName: "panorama",
    icon: [
        640,
        512,
        [],
        "e209",
        "M45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z"
    ]
}, $785da19a645c07eb$var$C1 = {
    prefix: "fas",
    iconName: "tags",
    icon: [
        512,
        512,
        [],
        "f02c",
        "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
}, $785da19a645c07eb$var$T1 = {
    prefix: "fas",
    iconName: "pen",
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"
    ]
}, $785da19a645c07eb$var$D1 = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
}, $785da19a645c07eb$var$P1 = {
    prefix: "fas",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
}, $785da19a645c07eb$var$I1 = {
    prefix: "fas",
    iconName: "trash",
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"
    ]
}, $785da19a645c07eb$var$F1 = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [
        448,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
}, $785da19a645c07eb$var$z1 = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
}, $785da19a645c07eb$var$R1 = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
}, $785da19a645c07eb$var$L1 = $785da19a645c07eb$var$R1, $785da19a645c07eb$var$B1 = {
    prefix: "fas",
    iconName: "camera",
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
}, $785da19a645c07eb$var$O1 = {
    prefix: "fas",
    iconName: "minus",
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
    ]
}, $785da19a645c07eb$var$U1 = {
    prefix: "fas",
    iconName: "clock",
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
}, $785da19a645c07eb$var$N1 = {
    prefix: "fas",
    iconName: "caret-down",
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
}, $785da19a645c07eb$var$j1 = {
    prefix: "fas",
    iconName: "sliders",
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"
    ]
}, $785da19a645c07eb$var$V1 = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"
    ]
}, $785da19a645c07eb$var$q1 = $785da19a645c07eb$var$V1, $785da19a645c07eb$var$G1 = {
    prefix: "fas",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z"
    ]
}, $785da19a645c07eb$var$H1 = {
    prefix: "fas",
    iconName: "download",
    icon: [
        512,
        512,
        [],
        "f019",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
}, $785da19a645c07eb$var$W1 = {
    prefix: "fas",
    iconName: "forward",
    icon: [
        512,
        512,
        [
            9193
        ],
        "f04e",
        "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z"
    ]
}, $785da19a645c07eb$var$Z1 = {
    prefix: "fas",
    iconName: "user-lock",
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
    ]
}, $785da19a645c07eb$var$K1 = {
    prefix: "fas",
    iconName: "medal",
    icon: [
        512,
        512,
        [
            127941
        ],
        "f5a2",
        "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
    ]
}, $785da19a645c07eb$var$X1 = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
}, $785da19a645c07eb$var$Q1 = $785da19a645c07eb$var$X1, $785da19a645c07eb$var$Y1 = {
    prefix: "fas",
    iconName: "eraser",
    icon: [
        576,
        512,
        [],
        "f12d",
        "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
    ]
}, $785da19a645c07eb$var$J1 = {
    prefix: "fas",
    iconName: "link",
    icon: [
        640,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
    ]
}, $785da19a645c07eb$var$$1 = {
    prefix: "fas",
    iconName: "play",
    icon: [
        384,
        512,
        [
            9654
        ],
        "f04b",
        "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"
    ]
}, $785da19a645c07eb$var$e2 = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
}, $785da19a645c07eb$var$t2 = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [
        512,
        512,
        [],
        "f078",
        "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
}, $785da19a645c07eb$var$i2 = {
    prefix: "fas",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z"
    ]
}, $785da19a645c07eb$var$n2 = {
    prefix: "fas",
    iconName: "plus",
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
    ]
}, $785da19a645c07eb$var$a2 = {
    prefix: "fas",
    iconName: "expand",
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
    ]
}, $785da19a645c07eb$var$r2 = {
    prefix: "fas",
    iconName: "xmark",
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
    ]
}, $785da19a645c07eb$var$s2 = $785da19a645c07eb$var$r2, $785da19a645c07eb$var$o2 = {
    prefix: "fas",
    iconName: "map",
    icon: [
        576,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z"
    ]
}, $785da19a645c07eb$var$l2 = {
    prefix: "fas",
    iconName: "rocket",
    icon: [
        512,
        512,
        [],
        "f135",
        "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
}, $785da19a645c07eb$var$c2 = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
}, $785da19a645c07eb$var$u2 = {
    prefix: "fas",
    iconName: "person-biking",
    icon: [
        640,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
}, $785da19a645c07eb$var$h2 = {
    prefix: "fas",
    iconName: "calendar",
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z"
    ]
}, $785da19a645c07eb$var$d2 = {
    prefix: "fas",
    iconName: "check",
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
    ]
}, $785da19a645c07eb$var$p2 = {
    prefix: "fas",
    iconName: "earth-europe",
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
    ]
}, $785da19a645c07eb$var$m2 = $785da19a645c07eb$var$p2, $785da19a645c07eb$var$g2 = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
}, $785da19a645c07eb$var$f2 = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [
            61913
        ],
        "f1d8",
        "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"
    ]
}, $785da19a645c07eb$var$A2 = new CSSStyleSheet;
$785da19a645c07eb$var$A2.replaceSync('pnx-viewer {\n\tposition: relative;\n\tdisplay: block;\n}\n\n/* Maximized components */\npnx-viewer .pnx-map.maplibregl-map,\npnx-viewer .pnx-psv {\n\tposition: absolute;\n\tinset: 0;\n\tz-index: 0;\n}\n\n/* No PSV loader */\npnx-viewer .psv-loader {\n\tdisplay: none;\n}\n\n/* Search bar over other components */\npnx-widget-geosearch {\n\tz-index: 129;\n}\n\n/* Cornered grid layout */\npnx-viewer pnx-cornered-grid::part(corner-top-left),\npnx-viewer pnx-cornered-grid::part(corner-top),\npnx-viewer pnx-cornered-grid::part(corner-top-right),\npnx-viewer pnx-cornered-grid::part(corner-bottom-left),\npnx-viewer pnx-cornered-grid::part(corner-bottom),\npnx-viewer pnx-cornered-grid::part(corner-bottom-right) {\n\tgap: 10px;\n\tpadding: 10px;\n}\n\n@media screen and (max-width: 576px) {\n\tpnx-viewer pnx-cornered-grid::part(corner-top-right) {\n\t\tflex-direction: column;\n\t\talign-items: flex-end;\n\t\tjustify-content: flex-start;\n\t}\n\n\tpnx-viewer pnx-cornered-grid::part(corner-top-left) {\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tjustify-content: flex-start;\n\t}\n\n\t/* Offset bottom buttons on smartphones */\n\tpnx-viewer:not(.pnx-iframed) pnx-cornered-grid::part(corner-bottom-right),\n\tpnx-viewer:not(.pnx-iframed) pnx-cornered-grid::part(corner-bottom-left) {\n\t\tmargin-bottom: 30px;\n\t}\n}\n\n/* Mini component */\npnx-viewer pnx-mini {\n\tbox-sizing: border-box;\n\taspect-ratio: 1/1;\n\tmin-width: 250px;\n\tmin-height: 250px;\n\tposition: relative;\n\tdisplay: block;\n\tz-index: 120;\n}\n\n@media screen and ((max-width: 576px)) {\n\tpnx-viewer pnx-mini {\n\t\tmin-width: unset;\n\t\tmin-height: unset;\n\t}\n}\n\npnx-viewer pnx-mini .psv-container,\npnx-viewer pnx-mini .pnx-map {\n\tborder-radius: 10px;\n}\n\n/* Hidden elements depending on focus */\npnx-viewer:not(pnx-viewer[focus="map"]) .pnx-only-map,\npnx-viewer:not(pnx-viewer[focus="pic"]) .pnx-only-psv {\n\tdisplay: none;\n}\n\n/* Override legend positioning */\n@media screen and (min-width: 576px) {\n\tpnx-viewer pnx-widget-legend:not([light="true"]) {\n\t\tposition: absolute;\n\t\tleft: 10px;\n\t\ttop: 60px;\n\t}\n\n\tpnx-viewer[focus="pic"] pnx-widget-legend:not([light="true"]) {\n\t\ttop: 10px;\n\t\twidth: 100%;\n\t}\n}\n\n/* Hide default map legend */\npnx-viewer .pnx-map .maplibregl-ctrl-attrib {\n\tdisplay: none;\n}\n\n/* Override geosearch sizing */\n@media screen and (max-width: 576px) {\n\tpnx-widget-geosearch pnx-search-bar:not([reduced])::part(container) {\n\t\twidth: 250px;\n\t\tmax-width: 40vw;\n\t}\n}\n\n/* Hidden widgets on sequence play */\npnx-viewer.pnx-playing pnx-bottom-drawer,\npnx-viewer.pnx-playing pnx-mini,\npnx-viewer.pnx-playing pnx-widget-legend,\npnx-viewer.pnx-playing pnx-widget-zoom,\npnx-viewer.pnx-playing pnx-time-travel {\n\tdisplay: none;\n}\n\n/* Hidden widgets on grid toggled */\npnx-viewer .psv-virtual-tour-arrows {\n\ttransition: opacity 0.25s ease-in-out;\n\topacity: 100%;\n}\npnx-viewer.pnx-grid-toggled .psv-virtual-tour-arrows {\n\topacity: 0%;\n}\npnx-viewer.pnx-grid-toggled .psv-virtual-tour-arrows button {\n\tpointer-events: none;\n\tcursor: unset;\n}'), document.adoptedStyleSheets.push($785da19a645c07eb$var$A2);
const $785da19a645c07eb$var$_2 = 100;
class $785da19a645c07eb$var$v2 extends $785da19a645c07eb$var$q0 {
    static properties = {
        "map-options": {
            converter: $785da19a645c07eb$var$q0.GetJSONConverter()
        },
        "map-style": {
            type: String
        },
        focus: {
            type: String,
            reflect: !0
        },
        geocoder: {
            type: String
        },
        tabindex: {
            type: Number
        },
        metacatalog: {
            type: String
        },
        "endpoint-to-use": {
            type: String
        },
        ...$785da19a645c07eb$var$q0.properties
    };
    constructor(){
        super(), this["map-options"] = !0, this["map-style"] = this.getAttribute("map-style") || "https://panoramax.openstreetmap.fr/pmtiles/basic.json", this.geocoder = this.getAttribute("geocoder") || "nominatim";
        try {
            this["map-style"] = JSON.parse(this["map-style"]);
        } catch (e1) {}
        this.mini = $785da19a645c07eb$var$ks("pnx-mini", {
            slot: "bottom-left",
            _parent: this,
            onexpand: this._onMiniExpand.bind(this),
            collapsed: !!$785da19a645c07eb$var$Le(this.picture) || void 0
        }), this.mini.addEventListener("expand", this._toggleFocus.bind(this)), this.grid.appendChild(this.mini), this.mapContainer = document.createElement("div"), this.tabindex = 0;
    }
    connectedCallback() {
        super.connectedCallback(), this.metacatalog = this.getAttribute("metacatalog"), [
            null,
            void 0,
            ""
        ].includes(this.metacatalog) && (this.metacatalog = "https://explore.panoramax.fr"), this["endpoint-to-use"] = this.getAttribute("endpoint-to-use"), this.mapStyleComposer = new $785da19a645c07eb$var$oO(this), this.mapStyleComposer.addBasemap("streets", this["map-style"], !0);
    }
    _createInitParamsHandler() {
        this._initParams = new $785da19a645c07eb$var$eO($785da19a645c07eb$var$eO.GetComponentProperties($785da19a645c07eb$var$v2, this), Object.assign({}, this.urlHandler?.currentURLParams(), this.urlHandler?.currentURLParams(!0)), {
            map: $785da19a645c07eb$var$Vo(),
            disableAnnotations: localStorage.getItem($785da19a645c07eb$var$Me)
        });
    }
    _initWidgets() {
        "false" !== this._initParams.getParentPostInit().widgets && ($785da19a645c07eb$var$Ye() || this.isWidthSmall() || this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-fullscreen", {
            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
            _parent: this
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-zoom", {
            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
            _parent: this
        })), $785da19a645c07eb$var$Ye() ? (this.legend = $785da19a645c07eb$var$ks("pnx-widget-legend", {
            slot: "bottom-right",
            light: !0,
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this.grid.appendChild(this.legend)) : this.isWidthSmall() ? (this.legend = $785da19a645c07eb$var$ks("pnx-picture-legend", {
            _parent: this
        }), this.bottomDrawer = $785da19a645c07eb$var$ks("pnx-bottom-drawer", {
            slot: "bottom",
            _parent: this,
            openness: "hidden"
        }), this.grid.appendChild(this.bottomDrawer)) : (this.legend = $785da19a645c07eb$var$ks("pnx-widget-legend", {
            slot: this.isWidthSmall() ? "top" : "top-left",
            _parent: this,
            focus: this._initParams.getParentPostInit().focus,
            picture: this._initParams.getParentPostInit().picture
        }), this._miniPicLegend = $785da19a645c07eb$var$ks("pnx-mini-picture-legend", {
            _parent: this
        }), this.grid.appendChild(this.legend)), $785da19a645c07eb$var$Ye() || (this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-player", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-annotations-switch", {
            slot: this.isWidthMedium() ? "top-right" : "top",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: this.isHeightSmall() || this.isWidthMedium() ? "md" : "xl"
        })), this.isWidthSmall() || this.grid.appendChild($785da19a645c07eb$var$ks("pnx-time-travel", {
            slot: "bottom",
            _parent: this,
            class: "pnx-only-psv pnx-print-hidden",
            size: "xl"
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-geosearch", {
            slot: this.isWidthSmall() ? "top-right" : "top-left",
            _parent: this,
            class: "pnx-only-map pnx-print-hidden",
            geocoder: this._initParams.getParentPostInit().geocoder
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-mapfilters", {
            slot: this.isWidthSmall() ? "top-right" : "top-left",
            _parent: this,
            "user-search": null !== this.api._endpoints.user_search && null !== this.api._endpoints.user_tiles,
            "quality-score": this.map?._hasQualityScore?.() || !1,
            "no-source": !this.hasTwoAPIs(),
            class: "pnx-only-map pnx-print-hidden"
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-semantics-filters", {
            slot: this.isWidthSmall() ? "top-right" : "top-left",
            _parent: this,
            class: "pnx-only-map pnx-print-hidden"
        })), this.grid.appendChild($785da19a645c07eb$var$ks("pnx-widget-maplayers", {
            slot: "top-right",
            _parent: this,
            class: "pnx-only-map pnx-print-hidden"
        }))));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.map?.destroy();
    }
    getClassName() {
        return "Viewer";
    }
    getSubComponentsNames() {
        return super.getSubComponentsNames().concat([
            "mini",
            "map",
            "mapStyleComposer"
        ]);
    }
    onceReady() {
        return Promise.all([
            this.oncePSVReady(),
            this.onceMapReady()
        ]).then(()=>this._initParams.getParentPostInit().willLoadPicture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
    }
    onceAPIReady() {
        return this.api ? this.api.onceReady() : new Promise((e1)=>setTimeout(e1, 250)).then(this.onceAPIReady.bind(this));
    }
    onceAllAPIsReady() {
        return this.getAPI() ? this.getAPI().onceReady() : new Promise((e1)=>setTimeout(e1, 250)).then(this.onceAllAPIsReady.bind(this));
    }
    attributeChangedCallback(e1, t, i) {
        if (super.attributeChangedCallback(e1, t, i), "picture" === e1) {
            this.legend?.setAttribute?.("picture", i);
            const e1 = document.getElementById("pnx-widget-search-bar"), n = !e1 || e1.value !== i;
            if ($785da19a645c07eb$var$Le(t) && !$785da19a645c07eb$var$Le(i) && this.mini.removeAttribute("collapsed"), $785da19a645c07eb$var$Le(i) ? this.legend.parentNode === this.bottomDrawer && this.setBottomDrawer(!1) : (this.setBottomDrawer(!0, this.legend), this.isWidthSmall() && !$785da19a645c07eb$var$Ye() && this._setFocus("pic")), $785da19a645c07eb$var$Le(i)) this.map && this.isMapWide() ? this.mini.classList.add("pnx-hidden") : this.map && !this.isMapWide() && this._setFocus("map");
            else if ($785da19a645c07eb$var$Le(t) && this.sequence == this._initParams.getParentPostInit().sequence && !this._initParams.getParentPostInit().picture && n) this.mini.classList.remove("pnx-hidden"), this.mini.removeAttribute("collapsed");
            else {
                const e1 = ()=>{
                    this.mini.classList.remove("pnx-hidden");
                };
                this.psv.addEventListener("picture-loaded", e1, {
                    once: !0
                }), this.psv.addEventListener("picture-failed", ()=>{
                    n && alert(this._t.pnx.error_pic_load), this.psv.removeEventListener("picture-loaded", e1);
                }, {
                    once: !0
                });
            }
        }
        "focus" === e1 && this._setFocus(i);
    }
    onceMapReady() {
        if (!this["map-options"]) return Promise.resolve();
        let e1;
        return new Promise((t)=>{
            e1 = setInterval(()=>{
                "object" == typeof this.map && (this.map?.loaded?.() ? (clearInterval(e1), t()) : this.map?.once && this.map.once("render", ()=>{
                    clearInterval(e1), t();
                }));
            }, 250);
        });
    }
    async _initMap() {
        await new Promise((e1)=>{
            const t = this._initParams.getMapInit();
            t.raster && this.mapStyleComposer._createRasterBasemap(t.raster), this.map = new $785da19a645c07eb$var$n1(this, this.mapContainer, t), $785da19a645c07eb$var$Ye() || $785da19a645c07eb$var$qo(this.map), this.map.waitForEnoughMapLoaded().then(()=>{
                this.loader.setAttribute("value", Math.max(75, parseInt(this.loader.getAttribute("value"))));
            }), e1();
        }), await $785da19a645c07eb$var$nO(this.map, this._initParams.getMapPostInit()), $785da19a645c07eb$var$No(this), $785da19a645c07eb$var$Uo(this);
    }
    hasTwoAPIs() {
        return null != this.apiMC && null != this.api || "false" !== this.metacatalog;
    }
    getAPI() {
        let e1 = this.mapStyleComposer.panoramax || this._initParams.getParentPostInit().users || (this.hasTwoAPIs() ? "metacatalog" : "default");
        return !e1.startsWith("metacatalog") || this.hasTwoAPIs() && "false" !== this.metacatalog || (e1 = e1.replace("metacatalog", "default")), e1?.startsWith("metacatalog") ? this.apiMC : this.api;
    }
    async _postAPIInit() {
        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
        const e1 = this._initParams.getParentPostInit(), t = [
            null,
            void 0,
            "",
            "default"
        ].includes(e1.users);
        if (await this._lookForMetacatalog(!t), this.mapStyleComposer._createPanoramaxEndpointFromAPI("default", this.api, t || !this.apiMC), this._initPSV(), await this._initMap(), this._initWidgets(), this._moveChildToGrid(), $785da19a645c07eb$var$rO(this, e1), e1.keyboardShortcuts && this._handleKeyboardManagement(), e1.willLoadPicture) {
            const t = ()=>{
                $785da19a645c07eb$var$rO(this, e1), this.loader.dismiss(), this.psv.removeEventListener("picture-failed", i);
            }, i = ()=>{
                $785da19a645c07eb$var$rO(this, e1), this.select(), this.psv.removeEventListener("picture-loaded", t), this.loader.dismiss(!0, this._t.pnx.error_pic, ()=>this.loader.dismiss());
            };
            this.psv.addEventListener("picture-loaded", t, {
                once: !0
            }), this.psv.addEventListener("picture-failed", i, {
                once: !0
            });
        } else this.map.waitForEnoughMapLoaded().then(()=>{
            this.loader.dismiss();
        });
    }
    _lookForMetacatalog(e1) {
        if (this.hasTwoAPIs()) return this.apiMC = new $785da19a645c07eb$var$st(this.metacatalog + "/api"), new Promise((t)=>{
            this.apiMC.onceReady().then(()=>{
                this.mapStyleComposer._createPanoramaxEndpointFromAPI("metacatalog", this.apiMC, e1), t();
            }).catch(()=>{
                console.error("Metacatalog API is not available, fallback to local instance"), this.apiMC = null, this["endpoint-to-use"] = (this["endpoint-to-use"] || "default").replace("metacatalog", "default"), this.metacatalog = "false", t();
            });
        });
    }
    _enableKeyboard() {
        this.map && this.isMapWide() ? this._enableKeyboardMap() : this._enableKeyboardPSV();
    }
    _enableKeyboardMap() {
        this.psv.stopKeyboardControl(), this.map.keyboard.enable();
    }
    _enableKeyboardPSV() {
        this.psv.startKeyboardControl(), this.map.keyboard.disable();
    }
    _disableKeyboard() {
        this.psv.stopKeyboardControl(), this.map.keyboard.disable();
    }
    _handleKeyboardManagement() {
        window.addEventListener("click", (e1)=>this._toggleKeyboardBasedOnFocus(e1)), window.addEventListener("keypress", this._toggleKeyboardBasedOnFocus.bind(this)), this.addEventListener("focus-changed", (e1)=>{
            this.popup.getAttribute("visible") ? this._disableKeyboard() : "map" === e1.detail.focus ? this._enableKeyboardMap() : this._enableKeyboardPSV();
        }), this.popup.addEventListener("open", this._disableKeyboard.bind(this)), this.popup.addEventListener("close", this._enableKeyboard.bind(this)), this.psv.addEventListener("click", this._enableKeyboardPSV.bind(this));
        for (let e1 of this.grid.childNodes)"bg" === e1.getAttribute("slot") || $785da19a645c07eb$var$V0.includes(e1.tagName.toLowerCase()) || (e1.addEventListener("focusin", this._disableKeyboard.bind(this)), e1.addEventListener("focusout", ()=>{
            null === this.popup.getAttribute("visible") && this._enableKeyboard();
        }));
    }
    moveCenter() {
        const e1 = this.psv.getPictureMetadata();
        e1 && (this.map && this.isMapWide() ? this.map.flyTo({
            center: e1.gps,
            zoom: 20
        }) : super.moveCenter());
    }
    _moveToDirection(e1) {
        if (this.map && this.isMapWide()) {
            let t;
            switch(e1){
                case "up":
                    t = [
                        0,
                        -100
                    ];
                    break;
                case "left":
                    t = [
                        -100,
                        0
                    ];
                    break;
                case "down":
                    t = [
                        0,
                        $785da19a645c07eb$var$_2
                    ];
                    break;
                case "right":
                    t = [
                        $785da19a645c07eb$var$_2,
                        0
                    ];
            }
            this.map.panBy(t);
        } else super._moveToDirection(e1);
    }
    isMapWide() {
        return this.mapContainer.parentNode === this.grid;
    }
    _setFocus(e1, t = !1, i = !1) {
        if ("map" === e1 && !this.map) throw new Error("Map is not enabled");
        if (![
            "map",
            "pic"
        ].includes(e1)) throw new Error("Invalid focus value (should be pic or map)");
        if (this.focus = e1, (i || ("map" !== e1 || !this.map || !this.isMapWide()) && ("pic" !== e1 || this.map && this.isMapWide())) && ("map" === e1 ? (this.psvContainer.parentNode === this.grid && (this.grid.removeChild(this.psvContainer), this.psvContainer.removeAttribute("slot")), this.mapContainer.parentNode === this.mini && this.mini.removeChild(this.mapContainer), this.mapContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.mapContainer), this.mini.appendChild(this.psvContainer), this.mini.icon = $785da19a645c07eb$var$ws($785da19a645c07eb$var$M1), this._miniPicLegend && this.mini.appendChild(this._miniPicLegend), $785da19a645c07eb$var$Le(this.picture) ? this.mini.classList.add("pnx-hidden") : this.mini.classList.remove("pnx-hidden"), this.map.getCanvas().focus()) : (this.mapContainer.parentNode === this.grid && (this.grid.removeChild(this.mapContainer), this.mapContainer.removeAttribute("slot")), this.psvContainer.parentNode === this.mini && (this.mini.removeChild(this.psvContainer), this._miniPicLegend && this.mini.removeChild(this._miniPicLegend)), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.mini.classList.remove("pnx-hidden"), this.mini.appendChild(this.mapContainer), this.mini.icon = $785da19a645c07eb$var$ws($785da19a645c07eb$var$o2), this.psvContainer.focus()), this?.map?.resize?.(), this.psv.autoSize(), this.psv.forceRefresh(), this.legend?.setAttribute?.("focus", this.focus), $785da19a645c07eb$var$Le(this.picture) || !this.legend.parentNode !== this.bottomDrawer || this.setBottomDrawer(!0, this.legend), !t)) {
            const t = new CustomEvent("focus-changed", {
                detail: {
                    focus: e1
                }
            });
            this.dispatchEvent(t);
        }
    }
    _toggleFocus() {
        this._setFocus(this.isMapWide() ? "pic" : "map");
    }
    _onMiniExpand() {
        this.map.resize(), this.psv.autoSize();
    }
    _showLocationPrecisionDoc() {
        this.setPopup(!0, [
            $785da19a645c07eb$var$ks("pnx-location-precision-doc", {
                _t: this._t
            })
        ]);
    }
}
customElements.define("pnx-viewer", $785da19a645c07eb$var$v2);
var $785da19a645c07eb$var$y2 = Object.freeze({
    __proto__: null,
    Basic: $785da19a645c07eb$var$po,
    CoverageMap: $785da19a645c07eb$var$cO,
    Editor: $785da19a645c07eb$var$D0,
    PhotoViewer: $785da19a645c07eb$var$q0,
    Viewer: $785da19a645c07eb$var$v2
});
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $785da19a645c07eb$var$x2 = 1;
class $785da19a645c07eb$var$b2 {
    constructor(e1){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(e1, t, i) {
        this._$Ct = e1, this._$AM = t, this._$Ci = i;
    }
    _$AS(e1, t) {
        return this.update(e1, t);
    }
    update(e1, t) {
        return this.render(...t);
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $785da19a645c07eb$var$w2 = ((e1)=>(...t)=>({
            _$litDirective$: e1,
            values: t
        }))(class extends $785da19a645c07eb$var$b2 {
    constructor(e1){
        if (super(e1), e1.type !== $785da19a645c07eb$var$x2 || "class" !== e1.name || e1.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(e1) {
        return " " + Object.keys(e1).filter((t)=>e1[t]).join(" ") + " ";
    }
    update(e1, [t]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== e1.strings && (this.nt = new Set(e1.strings.join(" ").split(/\s/).filter((e1)=>"" !== e1)));
            for(const e1 in t)t[e1] && !this.nt?.has(e1) && this.st.add(e1);
            return this.render(t);
        }
        const i = e1.element.classList;
        for (const e1 of this.st)e1 in t || (i.remove(e1), this.st.delete(e1));
        for(const e1 in t){
            const n = !!t[e1];
            n === this.st.has(e1) || this.nt?.has(e1) || (n ? (i.add(e1), this.st.add(e1)) : (i.remove(e1), this.st.delete(e1)));
        }
        return $785da19a645c07eb$var$W;
    }
}), $785da19a645c07eb$var$E2 = {
    opened: 0,
    "half-opened": .7,
    closed: 1,
    hidden: 1
};
class $785da19a645c07eb$var$k2 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 130;
			pointer-events: none;
			touch-action: none;
		}

		.drawer {
			background: var(--widget-bg);
			border-top-left-radius: 16px;
			border-top-right-radius: 16px;
			box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
			display: flex;
			flex-direction: column;
			transition: transform 0.3s ease;
			will-change: transform;
			touch-action: auto;
			pointer-events: auto;
		}

		.drawer.dragging { transition: none; }
		.drawer.closed { transform: translateY(calc(100% - 30px)); }
		.drawer.half-opened { transform: translateY(70%); }
		.drawer.half-opened .content { overflow-y: hidden; }
		.drawer.opened { transform: translateY(0%); }
		.drawer.hidden { display: none; }

		.drawer.autoadjust.opened {
			transform: unset;
			height: max-content !important;
		}

		.handle {
			height: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		.handle.autoclose {
			align-items: end;
			justify-content: end;
			padding: 0 15px;
		}

		.handle-bar {
			width: 40px;
			height: 5px;
			background: var(--grey-pale);
			border-radius: 3px;
		}

		.content {
			overflow: auto;
			flex: 1;
		}
	`;
    static properties = {
        _fingerY: {
            state: !0
        },
        _deltaFingerY: {
            state: !0
        },
        _drawerY: {
            state: !0
        },
        _isDragging: {
            state: !0
        },
        _drawerHeight: {
            state: !0
        },
        openness: {
            type: String,
            reflect: !0
        },
        autoclose: {
            type: Boolean
        },
        autoadjust: {
            type: Boolean
        }
    };
    constructor(){
        super(), this._isDragging = !1, this.openness = "half-opened", this.autoclose = !1, this.autoadjust = !1;
    }
    firstUpdated() {
        super.firstUpdated(), this._boundTouchMove = this._onTouchMove.bind(this), this._boundTouchEnd = this._onTouchEnd.bind(this), this._drawerHeight = window.innerHeight - 30;
        const e1 = this._getDrawer();
        e1 && (e1.style.height = `${this._drawerHeight}px`, e1.style.maxHeight = `${this._drawerHeight}px`, $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            const e1 = ()=>{
                [
                    "hidden",
                    "closed",
                    null
                ].includes(this.openness) || (this.openness = this.autoclose ? "hidden" : "closed");
            };
            this._parent.map?.addEventListener("click", e1), this._parent.psv?.addEventListener("click", (t)=>{
                this._parent.psv?._clickAndGo?._couldGoSomewhere || e1();
            });
        }));
    }
    attributeChangedCallback(e1, t, i) {
        if (super.attributeChangedCallback(e1, t, i), "openness" === e1) {
            if ([
                "hidden",
                "closed",
                null
            ].includes(t) && i?.includes("open") ? this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
                detail: {
                    menu: this
                }
            })) : t?.includes("open") && [
                "hidden",
                "closed",
                null
            ].includes(i) && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
                detail: {
                    menu: this
                }
            })), "opened" !== i) {
                const e1 = this.shadowRoot?.querySelector(".content");
                e1 && (e1.scrollTop = 0);
            }
            const e1 = this._getDrawer();
            e1 && (e1.style.transform = null);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._cleanupTouchListeners();
    }
    setContent(e1) {
        const t = this.shadowRoot?.querySelector(".content slot");
        t && (t.innerHTML = e1);
    }
    clearContent() {
        const e1 = this.shadowRoot?.querySelector(".content slot")?.assignedElements();
        e1 && e1.length > 0 && e1.forEach((e1)=>e1.parentNode.removeChild(e1));
    }
    _getDrawer() {
        return this.shadowRoot?.querySelector(".drawer");
    }
    _onHandleClick() {
        "opened" === this.openness ? this.openness = this.autoclose ? "hidden" : "closed" : "half-opened" === this.openness ? this.openness = this.autoclose ? "hidden" : "opened" : "closed" === this.openness && (this.openness = "half-opened");
    }
    _onTouchStart(e1) {
        this._isDragging = !0, this._startFingerY = e1.touches[0].clientY, this._deltaFingerY = 0, this._drawerY = this._drawerHeight * $785da19a645c07eb$var$E2[this.openness], window.addEventListener("touchmove", this._boundTouchMove, {
            passive: !0
        }), window.addEventListener("touchend", this._boundTouchEnd), window.addEventListener("touchcancel", this._boundTouchEnd);
    }
    _onTouchMove(e1) {
        if (!this._isDragging) return;
        const t = this.shadowRoot.querySelector(".content");
        t.scrollHeight > t.offsetHeight && t.scrollTop > 0 ? this._updateDrawerTransform(0) : (this._deltaFingerY = e1.touches[0].clientY - this._startFingerY, this._updateDrawerTransform(this._drawerY + this._deltaFingerY));
    }
    _onTouchEnd(e1) {
        (this._isDragging && !(Math.abs(this._deltaFingerY) < 30) || e1.target.closest(".handle")) && (e1.preventDefault(), this._isDragging = !1, 0 === this._deltaFingerY && "closed" === this.openness ? this.openness = "half-opened" : this._updateDrawerTransform(this._drawerY + this._deltaFingerY, !0), this._cleanupTouchListeners(), this._startFingerY = null, this._deltaFingerY = null);
    }
    _cleanupTouchListeners() {
        window.removeEventListener("touchmove", this._boundTouchMove), window.removeEventListener("touchend", this._boundTouchEnd), window.removeEventListener("touchcancel", this._boundTouchCancel);
    }
    _updateDrawerTransform(e1, t = !1) {
        const i = this._getDrawer();
        i && (e1 = Math.max(0, Math.min(e1, this._drawerHeight - 30)), t && (this._deltaFingerY < 0 ? "closed" === this.openness ? Math.abs(this._deltaFingerY) > this._drawerHeight * (1 - $785da19a645c07eb$var$E2["half-opened"]) ? this.openness = "opened" : this.openness = "half-opened" : this.openness = "opened" : this.openness = this.autoclose ? "hidden" : "closed", this._drawerY = null, e1 = Math.max(0, Math.min($785da19a645c07eb$var$E2[this.openness] * this._drawerHeight, this._drawerHeight - 30))), i.style.transform = `translateY(${e1}px)`);
    }
    render() {
        const e1 = {
            drawer: !0,
            [this.openness]: !0,
            dragging: this._isDragging,
            autoadjust: this.autoadjust
        };
        return $785da19a645c07eb$var$H`
			<div
				class=${$785da19a645c07eb$var$w2(e1)}
				@touchstart="${this._onTouchStart}"
				@touchmove="${this._onTouchMove}"
				@touchend="${this._onTouchEnd}"
			>
				<div
					class=${$785da19a645c07eb$var$w2({
            handle: !0,
            autoclose: this.autoclose
        })}
					@click=${this._onHandleClick}
				>
					${this.autoclose ? $785da19a645c07eb$var$H`
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$s2, {
            styles: {
                height: "20px"
            }
        })}
					` : $785da19a645c07eb$var$H`
						<div class="handle-bar"></div>
					`}
				</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-bottom-drawer", $785da19a645c07eb$var$k2);
class $785da19a645c07eb$var$S2 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 5px;
			flex-wrap: no-wrap;
		}

		.bg {
			position: absolute;
			inset: 0;
			z-index: 0;
		}

		.row {
			display: flex;
			flex-direction: row;
			flex: 1 1 50%;
			pointer-events: none;
		}

		.row.bottom { align-items: flex-end; }

		.row.top.toggled { margin: -100% 0 200% 0; }
		.row.bottom.toggled { margin: 200% 0 -100% 0; }
		@media screen and (min-width: 576px) {
			.row.top.toggled { margin: -50% 0 100% 0; }
			.row.bottom.toggled { margin: 100% 0 -50% 0; }
		}

		.corner {
			position: relative;
			flex: 1 1 33%;
			display: flex;
			gap: 10px;
			height: min-content;
		}

		.corner slot {
			pointer-events: auto;
			position: relative;
			z-index: 120;
		}

		.row.bottom .corner:not(.middle) { flex-direction: column; }
		.row.bottom .corner.left { flex-direction: column-reverse; justify-content: flex-start; align-items: flex-start; width: 33%; }
		.row.bottom .corner.middle { justify-content: center; align-items: flex-end; width: 33%; }
		.row.bottom .corner.right { justify-content: flex-end; align-items: flex-end; width: 33%; }

		.row.top .corner { flex-direction: row; }
		.row.top .corner.left { justify-content: flex-start; align-items: flex-start; }
		.row.top .corner.middle { justify-content: center; }
		.row.top .corner.right { justify-content: flex-end; align-items: flex-start; }
	`;
    static properties = {
        _hidden: {
            state: !0
        }
    };
    constructor(){
        super(), this._hidden = !1;
    }
    toggleAway(e1) {
        return this._hidden = null == e1 ? !this._hidden : !e1, this._hidden;
    }
    render() {
        return this.renderRoot.host.className = this._hidden ? "toggled" : "", $785da19a645c07eb$var$H`
			<div class="bg">
				<slot name="bg"></slot>
			</div>
			<div class=${$785da19a645c07eb$var$w2({
            row: !0,
            top: !0,
            toggled: this._hidden
        })}>
				<div class="corner left" part="corner-top-left">
					<slot name="top-left"></slot>
				</div>
				<div class="corner middle" part="corner-top">
					<slot name="top"></slot>
				</div>
				<div class="corner right" part="corner-top-right">
					<slot name="top-right"></slot>
				</div>
			</div>
			<div class=${$785da19a645c07eb$var$w2({
            row: !0,
            bottom: !0,
            toggled: this._hidden
        })}>
				<div class="corner left" part="corner-bottom-left">
					<slot name="bottom-left"></slot>
				</div>
				<div class="corner middle" part="corner-bottom">
					<slot name="bottom"></slot>
				</div>
				<div class="corner right" part="corner-bottom-right">
					<slot name="bottom-right"></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-cornered-grid", $785da19a645c07eb$var$S2);
const $785da19a645c07eb$var$M2 = $785da19a645c07eb$var$Ue("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg version='1.1' x='0px' y='0px' viewBox='0 0 90.455002 90.452003' id='svg10' width='90.455002' height='90.452003' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cpath d='m 2.512%2c90.45 h 8.012 12.834 c 0.008%2c0 0.014%2c0.002 0.02%2c0.002 h 15.423 c 0.008%2c0 0.014%2c-0.002 0.02%2c-0.002 h 1.164 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 52.813 l 27.52%2c-27.516 v 19.109 c 0%2c1.386 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.126 2.512%2c-2.512 V 19.233 c 0%2c-1.387 -1.125%2c-2.514 -2.512%2c-2.514 H 47.356 c -1.389%2c0 -2.514%2c1.127 -2.514%2c2.514 0%2c1.387 1.125%2c2.512 2.514%2c2.512 H 66.463 L 40.226%2c47.977 c -0.08%2c-0.008 -0.16%2c-0.023 -0.242%2c-0.023 H 2.512 C 1.125%2c47.954 0%2c49.079 0%2c50.466 v 1.188 15.424 12.854 8.008 c 0%2c1.385 1.125%2c2.51 2.512%2c2.51 z M 5.025%2c79.93 V 67.077 52.977 H 37.471 V 85.424 H 10.523 5.025 Z' id='path1' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 67.078%2c90.452 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 0%2c-1.387 -1.125%2c-2.512 -2.514%2c-2.512 H 51.655 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.389 1.125%2c2.514 2.512%2c2.514 z' id='path2' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 90.455%2c79.93 c 0%2c-1.387 -1.125%2c-2.512 -2.514%2c-2.512 -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 v 5.496 h -5.496 c -1.389%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.389 1.123%2c2.514 2.512%2c2.514 h 8.008 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 z' id='path3' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 87.942%2c41.311 c 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 23.373 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 15.424 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 z' id='path4' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 85.428%2c67.075 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 51.651 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 z' id='path5' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 87.942%2c0 h -8.008 c -1.389%2c0 -2.512%2c1.127 -2.512%2c2.514 0%2c1.387 1.123%2c2.512 2.512%2c2.512 h 5.494 v 5.496 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 2.514 C 90.453%2c1.127 89.328%2c0 87.942%2c0 Z' id='path6' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 23.377%2c5.024 h 15.422 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 41.313%2c1.125 40.188%2c0 38.799%2c0 H 23.377 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 z' id='path7' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 51.653%2c5.024 h 15.424 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 69.591%2c1.125 68.466%2c0 67.077%2c0 H 51.653 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path8' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 2.512%2c13.033 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.514 V 5.024 h 5.498 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 C 13.036%2c1.125 11.911%2c0 10.524%2c0 H 2.512 C 1.125%2c0 0%2c1.125 0%2c2.512 v 8.008 c 0%2c1.388 1.125%2c2.513 2.512%2c2.513 z' id='path9' style='fill:%232954e9%3bfill-opacity:1' /%3e %3cpath d='m 2.512%2c41.311 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 V 23.375 C 5.026%2c21.988 3.901%2c20.863 2.512%2c20.863 1.125%2c20.863 0%2c21.988 0%2c23.375 v 15.424 c 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path10' style='fill:%232954e9%3bfill-opacity:1' /%3e%3c/svg%3e"), $785da19a645c07eb$var$C2 = $785da19a645c07eb$var$Ue("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3csvg version='1.1' x='0px' y='0px' viewBox='0 0 90.169998 90.171997' enable-background='new 0 0 91 91' id='svg12' width='90.169998' height='90.171997' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3e %3cdefs id='defs1' /%3e %3cpath d='m 45.832%2c18.039 c -1.388%2c0 -2.513%2c1.125 -2.513%2c2.512 V 45.64 c 0%2c1.39 1.125%2c2.515 2.513%2c2.515 h 25.089 c 1.389%2c0 2.512%2c-1.125 2.512%2c-2.515 0%2c-1.386 -1.123%2c-2.511 -2.512%2c-2.511 H 51.894 L 79.386%2c15.635 c 0.982%2c-0.98 0.982%2c-2.57 0%2c-3.553 -0.98%2c-0.98 -2.572%2c-0.98 -3.553%2c0 L 48.343%2c39.576 V 20.551 c 0%2c-1.387 -1.125%2c-2.512 -2.511%2c-2.512 z' id='path1' /%3e %3cpath d='m 2.512%2c90.171 h 0.002 7.982 12.808 15.372 1.182 c 1.388%2c0 2.514%2c-1.125 2.514%2c-2.514 v -37.35 c 0%2c-1.387 -1.126%2c-2.512 -2.514%2c-2.512 H 2.514 c -1.389%2c0 -2.513%2c1.125 -2.513%2c2.512 v 1.17 C 0.001%2c51.481 0%2c51.487 0%2c51.491 v 15.373 c 0%2c0.006 0.001%2c0.01 0.001%2c0.016 V 79.661 C 0.001%2c79.665 0%2c79.671 0%2c79.675 v 7.982 c 0%2c1.389 1.124%2c2.514 2.512%2c2.514 z M 5.026%2c52.819 H 37.345 V 85.145 H 23.304 10.497 5.026 Z' id='path2' /%3e %3cpath d='m 51.487%2c85.145 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.389 1.125%2c2.514 2.514%2c2.514 H 66.86 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.514 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path3' /%3e %3cpath d='m 87.657%2c77.163 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 5.471 h -5.469 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.389 1.125%2c2.514 2.514%2c2.514 h 7.983 c 1.387%2c0 2.512%2c-1.125 2.512%2c-2.514 v -7.982 c 0%2c-1.388 -1.125%2c-2.513 -2.512%2c-2.513 z' id='path4' /%3e %3cpath d='m 87.657%2c48.979 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 v 15.373 c 0%2c1.387 1.125%2c2.514 2.514%2c2.514 1.387%2c0 2.512%2c-1.127 2.512%2c-2.514 V 51.491 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path5' /%3e %3cpath d='m 87.657%2c20.795 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 V 38.68 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 23.307 c 0%2c-1.387 -1.125%2c-2.512 -2.512%2c-2.512 z' id='path6' /%3e %3cpath d='m 87.657%2c0.002 h -7.982 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 h 5.469 v 5.471 c 0%2c1.387 1.125%2c2.512 2.514%2c2.512 1.387%2c0 2.512%2c-1.125 2.512%2c-2.512 V 2.514 C 90.169%2c1.127 89.044%2c0.002 87.657%2c0.002 Z' id='path7' /%3e %3cpath d='m 38.678%2c5.024 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 C 41.191%2c1.125 40.067%2c0 38.678%2c0 H 23.305 c -1.387%2c0 -2.512%2c1.125 -2.512%2c2.512 0%2c1.387 1.125%2c2.512 2.512%2c2.512 z' id='path8' /%3e %3cpath d='m 66.86%2c5.024 c 1.389%2c0 2.514%2c-1.125 2.514%2c-2.512 C 69.374%2c1.125 68.249%2c0 66.86%2c0 H 51.489 c -1.389%2c0 -2.514%2c1.125 -2.514%2c2.512 0%2c1.387 1.125%2c2.512 2.514%2c2.512 z' id='path9' /%3e %3cpath d='m 2.512%2c13.006 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 v -5.47 h 5.468 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 C 13.006%2c1.125 11.882%2c0 10.493%2c0 H 2.513 C 1.125%2c0 10e-4%2c1.125 10e-4%2c2.512 v 7.982 C 0%2c11.881 1.124%2c13.006 2.512%2c13.006 Z' id='path10' /%3e %3cpath d='m 2.512%2c41.192 c 1.389%2c0 2.513%2c-1.125 2.513%2c-2.512 V 23.307 C 5.025%2c21.92 3.901%2c20.795 2.512%2c20.795 1.124%2c20.795 0%2c21.92 0%2c23.307 V 38.68 c 0%2c1.387 1.124%2c2.512 2.512%2c2.512 z' id='path11' /%3e%3c/svg%3e");
class $785da19a645c07eb$var$T2 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			display: block;
			position: absolute;
			inset: 0;
			pointer-events: none;
		}

		slot {
			z-index: 120;
			pointer-events: auto;
		}

		pnx-button {
			z-index: 121;
			position: absolute;
			pointer-events: auto;
		}

		pnx-button img {
			height: 20px;
		}

		pnx-button:not([size="xxl"])::part(btn) {
			border-top-left-radius: 0;
			border-bottom-right-radius: 0;
		}
	`;
    static properties = {
        icon: {
            type: String
        },
        collapsed: {
            type: Boolean,
            reflect: !0
        }
    };
    constructor(){
        super(), this.collapsed = !1, this.icon = null;
    }
    render() {
        const e1 = this._parent?.isWidthSmall() || this._parent?.isWidthMedium() || this._parent?.isHeightSmall(), t = ()=>this.dispatchEvent(new Event("expand", {
                bubbles: !0,
                composed: !0
            }));
        if (this.collapsed || e1) return $785da19a645c07eb$var$H`<pnx-button
				kind="flat"
				size="xxl"
				style="bottom: 0"
				@click=${e1 ? t : ()=>this.collapsed = !1}
			>${this.icon}</pnx-button>`;
        return $785da19a645c07eb$var$H`
				<slot></slot>

				<pnx-button
					kind="superflat"
					title=${this._parent?._t.pnx.expand_info}
					style="top: 0; right: 0"
					@click=${t}
				>
					${$785da19a645c07eb$var$M2}
					${this._parent?._t.pnx.expand}
				</pnx-button>

				<pnx-button
					kind="flat"
					title=${this._parent?._t.pnx.minimize}
					style="bottom: 0; left: 0"
					@click=${()=>this.collapsed = !0}
				>
					${$785da19a645c07eb$var$C2}
				</pnx-button>
			`;
    }
}
customElements.define("pnx-mini", $785da19a645c07eb$var$T2);
class $785da19a645c07eb$var$D2 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		/* Tabs */
		nav {
			display: flex;
			gap: 5px;
			align-items: stretch;
			overflow-x: auto;
			touch-action: pan-x;
			position: sticky;
			top: 0;
			background: white;
			z-index: 125;
		}
		nav ::slotted(*) {
			color: var(--grey-dark);
			border-bottom: 2px solid rgba(0,0,0,0);
			cursor: pointer;
			transition: all 0.1s;
			flex: 1;
		}
		nav ::slotted(*:hover:not(.active)) { background-color: var(--blue-pale); }
		nav ::slotted(*.active) {
			color: var(--blue-dark);
			border-bottom: 2px solid var(--blue-dark);
		}

		/* Content */
		.contents ::slotted(div) { display: none !important; }
		.contents ::slotted(.active) { display: block !important; }
	`;
    static properties = {
        activeTabIndex: {
            type: Number,
            reflect: !0
        },
        hideNav: {
            type: Boolean
        }
    };
    constructor(){
        super(), this.activeTabIndex = 0, this.hideNav = !1;
    }
    _getTabs() {
        return this.shadowRoot.querySelector("slot[name='title']")?.assignedNodes() || [];
    }
    _getContents() {
        return this.shadowRoot.querySelector("slot[name='content']")?.assignedNodes() || [];
    }
    _changeTab(e1, t) {
        const i = this._getTabs(), n = this._getContents();
        void 0 === e1 && void 0 === t || (e1 && (t = i.findIndex((t)=>t === e1 || t === e1.parentNode)), !isNaN(t) && t >= 0 && t < i.length && i.forEach((e1, i)=>{
            i == t ? (this.activeTabIndex = i, n[i].classList.add("active"), e1.classList.add("active")) : (n[i].classList.remove("active"), e1.classList.remove("active"));
        }));
    }
    _handleTabClick(e1) {
        this._changeTab(e1.target);
    }
    updated(e1) {
        e1.has("activeTabIndex") && this._changeTab(void 0, this.activeTabIndex);
    }
    render() {
        return $785da19a645c07eb$var$H`
			${this.hideNav ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`<nav @click="${this._handleTabClick}">
				<slot name="title" @slotchange=${()=>this.activeTabIndex = 0}></slot>
			</nav>`}
			<div class="contents">
				<slot name="content"></slot>
			</div>
		`;
    }
}
customElements.define("pnx-tabs", $785da19a645c07eb$var$D2);
var $785da19a645c07eb$var$P2 = Object.freeze({
    __proto__: null,
    BottomDrawer: $785da19a645c07eb$var$k2,
    CorneredGrid: $785da19a645c07eb$var$S2,
    Mini: $785da19a645c07eb$var$T2,
    Tabs: $785da19a645c07eb$var$D2
});
const $785da19a645c07eb$var$I2 = $785da19a645c07eb$var$o`
	.pnx-panel {
		position: absolute;
		transition: opacity 0.2s 0.1s;
		border-radius: 20px;
		border: 1px solid var(--widget-border-div);
		background-color: var(--widget-bg);
		color: var(--widget-font);
		min-width: 250px;
		box-sizing: border-box;
		font-family: var(--font-family);
	}

	.pnx-panel.pnx-hidden {
		opacity: 0;
		display: block !important;
		pointer-events: none;
	}

	.pnx-panel.pnx-padded {
		padding: 15px;
	}
`, $785da19a645c07eb$var$F2 = $785da19a645c07eb$var$o`
	.pnx-hidden { display: none !important; }
`, $785da19a645c07eb$var$z2 = $785da19a645c07eb$var$o`
	.svg-inline--fa {
		display: var(--fa-display, inline-block);
		height: 1em;
		overflow: visible;
		vertical-align: -0.125em;
	}
	svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
		overflow: visible;
		box-sizing: content-box;
	}
	@keyframes fa-spin {
		from {transform:rotate(0deg);}
		to {transform:rotate(360deg);}
	}
	.fa-spin {
		animation: fa-spin 2s infinite linear;
	}
`, $785da19a645c07eb$var$R2 = $785da19a645c07eb$var$o`
	textarea {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 10px;
		padding: 5px;
		width: 100%;
		box-sizing: border-box;
		font-family: var(--font-family);
		resize: vertical;
	}
`, $785da19a645c07eb$var$L2 = $785da19a645c07eb$var$o`
	select {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	select[disabled] {
		background-color: var(--widget-bg-inactive);
	}

	select.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, $785da19a645c07eb$var$B2 = $785da19a645c07eb$var$o`
	input {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	input.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, $785da19a645c07eb$var$O2 = $785da19a645c07eb$var$o`
	:host {
		display: inline-flex;
	}
	
	/* Common properties */
	.pnx-btn {
		white-space: nowrap;
		font-size: 1em;
		font-family: var(--font-family);
		flex-grow: 1;
		flex-shrink: 1;
		text-align: center;
		padding: 5px;
		font-weight: 600;
		flex-basis: 30%;
		line-height: 18px;
		justify-content: center;
		border-radius: 8px;
		cursor: pointer;
		text-decoration: none;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		position: relative;
		width: 100%;
		height: 100%;
		min-width: 26px;
	}

	.pnx-btn:disabled { color: var(--widget-bg-inactive); }

	.pnx-btn.pnx-btn-active,
	.pnx-btn.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-full.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-outline.pnx-btn-active:hover {
		background-color: var(--widget-bg-active);
		border-color: var(--widget-bg-active);
		color: var(--widget-font-active);
	}

	.pnx-btn .svg-inline--fa,
	.pnx-btn ::slotted(.svg-inline--fa),
	.pnx-btn slot .svg-inline--fa {
		height: 16px;
		pointer-events: none;
	}

	/* Sizing */
	.pnx-btn-sm {
		border-radius: 6px;
		line-height: 12px;
		font-size: 12px;
		min-width: unset;
	}

	.pnx-btn.pnx-btn-sm .svg-inline--fa,
	.pnx-btn.pnx-btn-sm ::slotted(.svg-inline--fa) {
		height: 12px;
	}

	.pnx-btn-l {
		border-radius: 12px;
		height: 24px;
		line-height: 24px;
		font-size: 20px;
		min-width: 24px;
	}

	.pnx-btn-xl {
		border-radius: 20px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		min-width: 40px;
		padding: 0 10px;
		gap: 8px;
	}

	.pnx-btn.pnx-btn-xl .svg-inline--fa,
	.pnx-btn.pnx-btn-xl ::slotted(.svg-inline--fa) {
		height: 16px;
	}

	.pnx-btn-xxl {
		border-radius: 28px;
		height: 56px;
		line-height: 56px;
		font-size: 24px;
		min-width: 56px;
	}

	.pnx-btn.pnx-btn-xxl .svg-inline--fa,
	.pnx-btn.pnx-btn-xxl ::slotted(.svg-inline--fa) {
		height: 24px;
	}

	/* Fully-filled style */
	.pnx-btn-full {
		background-color: var(--widget-bg-primary);
		color: var(--widget-font-direct);
		border: none;
	}

	.pnx-btn-full:not(:disabled):hover {
		background-color: var(--widget-bg-primary-hover);
	}

	/* Fully-filled warning style */
	.pnx-btn-fullwarn {
		background-color: var(--widget-bg-warn);
		color: var(--widget-font-warn);
		border: none;
	}

	.pnx-btn-fullwarn:not(:disabled):hover {
		background-color: var(--widget-bg-warn);
	}

	/* Fully-filled danger style */
	.pnx-btn-fulldanger {
		background-color: var(--widget-bg-danger);
		color: var(--widget-font-danger);
		border: none;
	}

	.pnx-btn-fulldanger:not(:disabled):hover {
		background-color: var(--widget-bg-danger);
	}

	/* Fully-filled success style */
	.pnx-btn-fullsuccess {
		background-color: var(--widget-bg-success);
		color: var(--widget-font-success);
		border: none;
	}

	.pnx-btn-fullsuccess:not(:disabled):hover {
		background-color: var(--widget-bg-success);
	}

	/* Outline style */
	.pnx-btn-outline {
		border: 1px solid var(--widget-border-btn);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-outline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Flat style */
	.pnx-btn-flat,
	.pnx-btn-flat.pnx-btn-active,
	.pnx-btn-flat.pnx-btn-active:hover,
	.pnx-btn-flat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font);
		background-color: var(--widget-bg);
	}

	.pnx-btn-flat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superflat style */
	.pnx-btn-superflat,
	.pnx-btn-superflat.pnx-btn-active,
	.pnx-btn-superflat.pnx-btn-active:hover,
	.pnx-btn-superflat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-superflat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Inline style */
	.pnx-btn-inline,
	.pnx-btn-inline.pnx-btn-active,
	.pnx-btn-inline.pnx-btn-active:hover,
	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		border: none;
		color: var(--widget-font);
		background: none;
	}

	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superinline style */
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		color: var(--widget-font-direct);
	}
`, $785da19a645c07eb$var$U2 = $785da19a645c07eb$var$o`
	pnx-button-group > pnx-button {
		display: inline-flex;
	}

	pnx-button-group > pnx-button::part(btn) {
		height: unset;
	}

	/* Togglable in group */
	pnx-button-group > pnx-togglable-group > pnx-button {
		width: 100%;
		height: 100%;
	}

	/* Row */
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-left: none;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :first-child::part(btn),
	pnx-button-group[dir="row"] > :first-child > ::part(btn) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :last-child::part(btn),
	pnx-button-group[dir="row"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: none;
	}

	/* Column */
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-top: none;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :first-child::part(btn),
	pnx-button-group[dir="column"] > :first-child > ::part(btn) {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :last-child::part(btn),
	pnx-button-group[dir="column"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-top: none;
	}
`, $785da19a645c07eb$var$N2 = $785da19a645c07eb$var$o`
	h1, h2, h3, h4, h5, h6 {
		font-family: var(--font-family);
	}
	
	h3 {
		font-size: 1.1em;
		line-height: 1.1em;
		font-weight: 500;
		margin: 10px 0 10px 0;
	}

	h4 {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}

	h4:first-of-type { margin-top: 0; }

	h4 > svg.svg-inline--fa {
		height: 18px;
	}

	h4[slot="title"] {
		margin: 0;
		justify-content: center;
		font-size: 0.8em;
		line-height: 2em;
		padding: 0.5em 0;
	}
	h4[slot="title"] svg.svg-inline--fa {
		height: 14px;
	}
`, $785da19a645c07eb$var$j2 = $785da19a645c07eb$var$o`
	.pnx-active-icon {
		box-sizing: border-box;
		background-color: var(--orange);
		border: 3px solid #fff;
		border-radius: 8px;
		height: 15px;
		left: 20px;
		position: absolute;
		top: 5px;
		width: 15px;
	}
`, $785da19a645c07eb$var$V2 = $785da19a645c07eb$var$o`
	.pnx-badge-count {
		box-sizing: border-box;
		background-color: var(--grey-pale);
		border-radius: 8px;
		right: -6px;
		position: absolute;
		top: -6px;
		width: 12px;
		height: 12px;
		font-size: 10px;
		text-align: center;
		line-height: 12px;
		font-weight: 800;
	}
`, $785da19a645c07eb$var$q2 = $785da19a645c07eb$var$o`
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: 1000px 0;
		}
	}

	.pnx-placeholder-loading {
		width: 100px;
		height: 100px;
		background-image: linear-gradient(
			90deg,
			#e4e4e4 0%,
			#f1f1f1 40%,
			#ededed 60%,
			#e4e4e4 100%
		);
		background-position: 0px 0px;
		background-repeat: repeat;
		animation: animatedBackground 5s linear infinite;
	}
`;
$785da19a645c07eb$var$o`
	details summary {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		cursor: pointer;
	}

	details summary svg {
		height: 18px;
		vertical-align: sub;
		margin-right: 2px;
	}
`;
const $785da19a645c07eb$var$G2 = $785da19a645c07eb$var$o`
	@media print {
		.pnx-print-hidden { display: none !important; }
	}
`, $785da19a645c07eb$var$H2 = $785da19a645c07eb$var$o`
	table {
		border-collapse: collapse;
		font-size: 0.9rem;
		width: 100%;
		max-width: 100%;
		font-family: var(--font-family);
		background: var(--white);
	}

	th, td {
		padding: 10px;
		text-align: left;
		border-bottom: 1px solid #ddd;
	}

	th { font-weight: 600; }
`, $785da19a645c07eb$var$W2 = $785da19a645c07eb$var$o`
	iconify-icon {
		display: inline-block;
		width: 1em;
		height: 1em;
	}
`, $785da19a645c07eb$var$Z2 = $785da19a645c07eb$var$o`
	.data-block {
		display: inline-block;
		margin: 8px 0;
		box-sizing: border-box;
		vertical-align: top;
	}
	.data-block h5 {
		font-size: 0.8em;
		font-weight: 400;
		color: var(--blue-dark);
		margin: 0 0 5px 0;
		display: flex;
		align-items: center;
		gap: 5px;
	}
	.data-block h5 pnx-button { vertical-align: middle; }
	.data-block h5 svg.svg-inline--fa { height: 14px; }
	.data-block div {
		font-size: 0.8em;
	}
`, $785da19a645c07eb$var$K2 = $785da19a645c07eb$var$o`
	h4 {
		font-size: 1.3em;
		font-weight: 600;
		border-bottom: 3px solid var(--grey-pale);
		padding-bottom: 10px;
  		padding-top: 5px;
	}
`;
class $785da19a645c07eb$var$X2 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$K2
    ];
    render() {
        return $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$Q1)} ${this._t?.pnx.filter_gps_precision}</h4>
			<p>${this._t?.pnx.filter_gps_precision_help_1}</p>
			<p>${this._t?.pnx.filter_gps_precision_help_2}</p>
			<pnx-grade-filter grade=""></pnx-grade-filter>
			<p>${this._t?.pnx.filter_gps_precision_help_3.replace("{p5}", $785da19a645c07eb$var$ze[1]).replace("{p1}", $785da19a645c07eb$var$ze[7]).replace(/\.01/g, "")}</p>
			<p>${this._t?.pnx.filter_gps_precision_help_4}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/#gps-position-accuracy"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$z1)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-location-precision-doc", $785da19a645c07eb$var$X2);
class $785da19a645c07eb$var$Q2 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$o`
		:host {
			justify-content: space-evenly;
			box-sizing: border-box;
			display: flex;
			gap: 10px;
		}
		input { display: none; }
		label {
			cursor: pointer;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 3px;
			font-size: 0.8rem;
			color: var(--grey-dark);
		}

		img {
			width: 40px;
			border-radius: 5px;
			vertical-align: middle;
			border: 2px solid var(--widget-bg);
		}

		img.sm { width: 32px; }

		@media screen and (max-width: 576px) {
			label { font-size: 0.9rem; }
		}

		input:checked + label img {
			outline: 3px solid var(--widget-border-btn);
		}

		input:disabled + label {
			opacity: 0.4;
			cursor: not-allowed;
		}

		.select-as-radio {
			position: relative;
		}

		.select-as-radio select {
			opacity: 0;
			position: absolute;
			inset: 0;
		}
	`
    ];
    static properties = {
        bg: {
            state: !0
        },
        size: {
            type: String
        }
    };
    constructor(){
        super(), this.size = "md";
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._parent.mapStyleComposer?.addEventListener("basemap-changed", (e1)=>{
                this.bg = e1.detail.basemap;
            }), this.bg = this._parent.mapStyleComposer?.basemap;
        });
    }
    _onBgSelect(e1) {
        this.bg = e1.target.value;
        const t = this.shadowRoot.querySelector("#pnx-map-bg-more");
        t && (t.value = null), this._parent?.mapStyleComposer?.switchBasemap(this.bg);
    }
    render() {
        const e1 = [
            $785da19a645c07eb$var$H`
			<input
				type="radio"
				id="bg-streets"
				name="bg"
				value="streets"
				@change=${this._onBgSelect}
				.checked=${"streets" === this.bg}
			/>
			<label for="bg-streets">
				<img src=${"data:image/jpeg;base64,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"} class=${this.size} alt="" />
				${this._parent?._t.pnx.map_background_streets}
			</label>
		`
        ];
        if (this._parent.mapStyleComposer.hasStreetsAerialBasemaps() && e1.push($785da19a645c07eb$var$H`
				<input
					type="radio"
					id="bg-aerial"
					name="bg"
					value="aerial"
					@change=${this._onBgSelect}
					.checked=${"aerial" === this.bg}
				/>
				<label for="bg-aerial">
					<img src=${"data:image/jpeg;base64,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"} class=${this.size} alt="" />
					${this._parent?._t.pnx.map_background_aerial}
				</label>
			`), this._parent.mapStyleComposer.hasComplementaryBasemaps()) {
            const t = Object.entries(this._parent.mapStyleComposer.layerRanges.basemaps).filter(([e1])=>!$785da19a645c07eb$var$sO.includes(e1)).map(([e1, t])=>$785da19a645c07eb$var$H`
					<option value="${e1}" .selected=${this._parent.mapStyleComposer.basemap === e1}>
						${t.layers[0]?.metadata?.name || e1}
					</option>
				`);
            e1.push($785da19a645c07eb$var$H`
				<div class="select-as-radio">
					<input
						type="radio"
						id="bg-more"
						name="bg"
						value="more"
						@change=${this._onBgSelect}
						.checked=${![
                "aerial",
                "streets"
            ].includes(this.bg)}
					/>
					<label for="bg-more">
						<img src=${"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAACy9AAAsvQEkECqWAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA/JJREFUeJzt3ctS01Acx/FfknIJM46O172O6EIrXkZHH8O3cO9C34Q3AN7AtxAvG8rgA1BdQGtC6SUuaDFA0p6T8z8nafr77hgWB+Yz+f8ThrZe5/2HBHOUF/aS4M1eG0juWj8s8BG8bba8cGXd+lkANo+6Ld/FQVJ5YQ+NV/uxM4wXjyNXGFvH0eDL35P1uQHxwh6C5wdJEgzXrB8W+Ag21uHduGb/LADbnQg73agBAA0XB5rmrfUQPDsAlvue9cMmGDevWz8KOMPY7kTnX1cexAt7CDYOgOW+/cNKxgCASo+s8ZhaGAygwiCLiAFUFGRRMYAKgiwyBlAxkEXHACoEQoyzKgFCjP+V/hySeuizf1jFMYCSQRbtoU+l0kYWx1R2pYAQIz/nIMSYntMdwgU+O2cgXOBqORlZHFPqWQchhl5WQYihnzUQYhTLylLn3VTxxEF4N2WW6MjimDJPDIQYMomAEEOmUXxv33iHcIHLNOrcj+Lvnx8agXCByzQ6eoT458c1jFaKjyyOKZnGGMBoBUDBHUIMmS5jAAVAiCFTFgagCUIMmfIwAI0ndd5NyTQNA1AE4d2UTLMwAIWRxTElkwoGMAOEGDKpYgBTQIghkw4GkLNDuMBl0sUAMkC4wGUqggFcGlkcUzIVxQBSIMSQyQQDGINMXpRPDLNMMQDA98JeErzcjxfhRfk2k8AAAD94vfcbjWEo9HPlRwylfHjJHYGfaXrEUM7+//YSQyu7IMTQzh4IMQplB4QYhZMHIYZRsiDEME4OhBgiyYAQQ6ikbf5yBGKIFAwHcbO9e8sMhBgiLQ1P8aT9LQz7kcHIIoZIYwyE/bPfrRgIMUS6jAEUASGGSFkYgO5rDIkh0tLwFE8Pd7E6iK98T/0KIYZIkysjCwNQBSGGSHljKt1sEGKIpIIBzAIhhkiqGMC0pU4MkaYt8KyyrxBiiDRrgWd1FYQYIumMqXQXQYghUlEMIA1CDJFMMIAJCDFEMsUAAP/808iIYdTkbsoEAwD84F2z5fLTyOqKoXs3lZfvrbr5nL66Y5heGZOcvE0sMdSzDkIMvay+s3WdMXT+HKKTtSukzhhSCzwrKyB1x5AeU+nEQYhhligIMcwTAyGGTCJ3WXXGsHU3lZfxFVJnDJt3U3kZgdQdw9WYSlcYhBh2KgRCDHtpL/U6Y7he4FlpXSF1xihjgWelDFJ3jDLHVDolEGK4ayYIMdw2FYQY7ssFIUY5ZYIQo7yugBCj3C48GNYZowoPfSqdXyF1xqjKQ59KPgBsHUcDZxjHD2Jnb1cxGp7Mw5hK528edVs73cjJB90nJ7d/xT8+hS4wPCR/modfl+cJAwD+ATSdVhCjsMt9AAAAAElFTkSuQmCC"} class=${this.size} alt="" />
						${this._parent?._t.pnx.map_background_more}
					</label>
					<select id="pnx-map-bg-more" @change=${this._onBgSelect}>
						${t}
					</select>
				</div>
			`);
        }
        return e1;
    }
}
customElements.define("pnx-map-background", $785da19a645c07eb$var$Q2);
class $785da19a645c07eb$var$Y2 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$o`
		.pnx-input-group {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 5px;
		}

		/* Filter block */
		.pnx-filter-block {
			position: relative;
			padding: 10px 15px;
			border-bottom: 2px solid var(--widget-border-div);
		}
		.pnx-filter-block:first-child {
			padding-top: 15px;
		}
		.pnx-filter-block:last-child {
			border-bottom: none;
			padding-bottom: 15px;
		}
		.pnx-filter-block h4 {
			margin-bottom: 5px;
		}
		.pnx-filter-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.9);
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			border-radius: 25px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: baseline;
			padding: 15px;
		}
		.pnx-filter-zoomin h5 {
			font-weight: 900;
			margin: 0 0 5px 0;
			font-size: 1em;
		}
		.pnx-filter-zoomin div {
			font-weight: unset;
  			font-size: 0.9em;
		}
		.pnx-filter-zoomin.hidden {
			display: none;
		}

		/* Input styles */
		.pnx-filter-active,
		pnx-search-bar.pnx-filter-active::part(container),
		pnx-search-bar.pnx-filter-active::part(input) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}
		input[type=date] {
			min-width: 0;
			flex-grow: 2;
			padding: 2px 0;
			text-align: center;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			border: 1px solid var(--widget-border-div);
			border-radius: 20px;
			font-family: var(--font-family);
		}

		/* Input shortcuts */
		.pnx-input-shortcuts {
			margin-top: 0px;
			margin-bottom: 5px;
		}
		.pnx-input-shortcuts button {
			border: none;
			font-size: 0.75em;
			padding: 2px 6px;
			vertical-align: middle;
			background-color: var(--grey-pale);
			color: var(--black);
			border-radius: 10px;
			cursor: pointer;
			font-family: var(--font-family);
		}
		.pnx-input-shortcuts button:hover {
			background-color: #d9dcd9;
		}

		/* Checkbox looking like buttons */
		.pnx-input-group.pnx-checkbox-btns {
			gap: 0;
			align-items: stretch;
		}
		.pnx-checkbox-btns label {
			display: inline-block;
			padding: 2px 7px;
			background: none;
			border: 1px solid var(--widget-border-btn);
			color: var(--widget-font-direct);
			cursor: pointer;
			font-size: 16px;
			text-decoration: none;
			border-left-width: 0px;
		}
		.pnx-checkbox-btns label:hover {
			background-color: var(--widget-bg-hover);
		}
		.pnx-checkbox-btns label:first-of-type {
			border-top-left-radius: 8px;
			border-bottom-left-radius: 8px;
			border-left-width: 1px;
		}
		.pnx-checkbox-btns label:last-of-type {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		.pnx-checkbox-btns input[type="radio"] { display: none; }
		.pnx-checkbox-btns input[type="radio"]:checked + label {
			background-color: var(--widget-bg-active);
			color: var(--widget-font-active);
		}
		.pnx-checkbox-btns input[type="radio"]:checked + label:first-of-type {
			border-right-color: white;
		}

		/* Force user search width */
		#pnx-filter-search-user::part(container) { width: 100%; }
	`
    ];
    static properties = {
        "quality-score": {
            type: Boolean
        },
        "user-search": {
            type: Boolean
        },
        "no-date": {
            type: Boolean
        },
        "no-picture-type": {
            type: Boolean
        },
        "no-gps": {
            type: Boolean
        },
        "no-source": {
            type: Boolean
        },
        showZoomIn: {
            state: !0
        },
        minDate: {
            state: !0
        },
        maxDate: {
            state: !0
        },
        type: {
            state: !0
        },
        score: {
            state: !0
        },
        user: {
            state: !0
        },
        gps: {
            state: !0
        },
        source: {
            state: !0
        }
    };
    constructor(){
        super(), this._formDelay = null, this.showZoomIn = !0;
    }
    connectedCallback() {
        super.connectedCallback();
        for (let e1 of this.shadowRoot.querySelectorAll("input"))e1.addEventListener("change", this._onFormChange.bind(this)), e1.addEventListener("keypress", this._onFormChange.bind(this)), e1.addEventListener("paste", this._onFormChange.bind(this)), e1.addEventListener("input", this._onFormChange.bind(this));
        $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceMapReady?.().then(()=>{
                this._parent.map.on("zoomend", this._onUpdateZoomIn.bind(this)), this._parent.mapStyleComposer.addEventListener("filters-changed", (e1)=>this._onParentFilterChange(e1.detail)), this._parent.mapStyleComposer.addEventListener("panoramax-changed", ()=>this._onParentFilterChange(this._parent.mapStyleComposer.panoramaxFilters)), this._onUpdateZoomIn(), this._onParentFilterChange(this._parent.mapStyleComposer.panoramaxFilters), this._parent.addEventListener("menu-closed", (e1)=>{
                    if (e1.detail.menu === this.parentNode) {
                        const e1 = this.shadowRoot.querySelector("#pnx-filter-search-user");
                        e1 && (e1._results = null);
                    }
                });
            }));
    }
    _onUpdateZoomIn() {
        this.showZoomIn = this._parent.mapStyleComposer._hideMapFilters();
    }
    _onParentFilterChange(e1) {
        if (this._onUpdateZoomIn(), this.minDate = e1?.minDate || null, this.maxDate = e1?.maxDate || null, this.minDate && this.maxDate && this.minDate > this.maxDate) {
            const e1 = this.minDate;
            this.minDate = this.maxDate, this.maxDate = e1, this._onFormChange();
        }
        if (this.score = Array.isArray(e1?.qualityscore) ? e1.qualityscore.join(",") : e1?.qualityscore || "", this.gps = e1?.gps && Array.isArray(e1.gps) ? e1.gps.join(",") : e1?.gps?.length > 0 ? e1.gps : "", this.type = "", e1?.pic_type && "" !== e1.pic_type && (this.type = "flat" === e1.pic_type ? "flat" : "equirectangular"), $785da19a645c07eb$var$Bo(this._parent.mapStyleComposer.panoramax)) {
            if (this.source = this._parent.mapStyleComposer.panoramax.startsWith("metacatalog_") ? "metacatalog" : "default", null == this.user) {
                let e1 = this._parent.mapStyleComposer.panoramax.replace("metacatalog_", "");
                this._parent.getAPI().getUserName(e1).then((e1)=>{
                    this.user = e1, this.shadowRoot.querySelector("#pnx-filter-search-user").setAttribute("value", e1);
                });
            }
        } else this.source = this._parent.mapStyleComposer.panoramax, this.user = null;
    }
    _onSubmit(e1) {
        return e1.preventDefault(), this._onFormChange(), !1;
    }
    _onFormChange() {
        this._formDelay && clearTimeout(this._formDelay), this._formDelay = setTimeout(()=>{
            this.minDate = this.shadowRoot.querySelector("#pnx-filter-date-from")?.value, this.maxDate = this.shadowRoot.querySelector("#pnx-filter-date-end")?.value;
            const e1 = this.shadowRoot.querySelector("#pnx-filter-type-flat"), t = this.shadowRoot.querySelector("#pnx-filter-type-360");
            this.type = t.checked ? "equirectangular" : e1.checked ? "flat" : "", this.score = this.shadowRoot.querySelector("#pnx-filter-qualityscore")?.grade, this.gps = this.shadowRoot.querySelector("#pnx-filter-gps")?.grade;
            const i = this._parent.mapStyleComposer, n = {
                minDate: this.minDate,
                maxDate: this.maxDate,
                pic_type: this.type,
                qualityscore: this.score,
                gps: this.gps,
                featuresRestrictions: i.panoramaxFilters.featuresRestrictions
            };
            i.setPanoramaxFilters(n);
        }, 250);
    }
    _onSourceChange(e1) {
        this.source = e1.target.checked ? "default" : "metacatalog", this.user = null, this._onUserSearchResult();
    }
    _userSearch(e1) {
        return this._parent.getAPI?.().searchUsers(e1).then((e1)=>(e1 || []).map((e1)=>({
                    title: e1.label,
                    data: e1
                })));
    }
    _onUserSearchResult(e1) {
        if (e1?.detail?.data) {
            e1.target.classList.add("pnx-filter-active");
            const t = "metacatalog" === this.source ? "metacatalog_" + e1.detail.data.id : e1.detail.data.id;
            return this._parent?.mapStyleComposer._createPanoramaxEndpointForUser(t);
        }
        {
            const t = e1?.target || this.shadowRoot.querySelector("#pnx-filter-search-user");
            return t && (t.classList.remove("pnx-filter-active"), t.setAttribute("value", "")), this._parent?.mapStyleComposer.switchPanoramaxEndpoint(this.source);
        }
    }
    _onReset() {
        this.shadowRoot.querySelector("#pnx-filter-qualityscore")?.setAttribute("grade", ""), this.shadowRoot.querySelector("#pnx-filter-search-user")?.reset(), this.shadowRoot.querySelector("#pnx-filter-gps")?.setAttribute("grade", ""), this.minDate = null, this.maxDate = null, this.type = "", this.score = null, this.user = null, this._onFormChange();
    }
    _onDateShortcut(e1) {
        const t = this.shadowRoot.getElementById("pnx-filter-date-from"), i = this.shadowRoot.getElementById("pnx-filter-date-end");
        t && (t.value !== e1 ? t.value = e1 : t.value = ""), i && (i.value = "");
    }
    _onMeUserSearch() {
        const e1 = $785da19a645c07eb$var$tt();
        if (!e1) return;
        const t = this.shadowRoot.getElementById("pnx-filter-search-user");
        this._parent?.mapStyleComposer?.panoramax?.endsWith(e1.id) ? t?._onResultClick() : t?._onResultClick({
            title: e1.name,
            data: {
                id: e1.id
            }
        });
    }
    render() {
        const e1 = $785da19a645c07eb$var$tt(), t = {
            1: this._parent?._t.pnx.filter_gps_precision_morethan.replace("{n}", $785da19a645c07eb$var$ze[7]).replace(/\.01/g, ""),
            2: this._parent?._t.pnx.filter_gps_precision_between.replace("{n1}", $785da19a645c07eb$var$ze[5]).replace("{n2}", $785da19a645c07eb$var$ze[7]).replace(/\.01/g, ""),
            3: this._parent?._t.pnx.filter_gps_precision_between.replace("{n1}", $785da19a645c07eb$var$ze[3]).replace("{n2}", $785da19a645c07eb$var$ze[5]).replace(/\.01/g, ""),
            4: this._parent?._t.pnx.filter_gps_precision_between.replace("{n1}", $785da19a645c07eb$var$ze[1]).replace("{n2}", $785da19a645c07eb$var$ze[3]).replace(/\.01/g, ""),
            5: this._parent?._t.pnx.filter_gps_precision_lessthan.replace("{n}", $785da19a645c07eb$var$ze[1]).replace(/\.01/g, "")
        };
        let i = this._parent.api._metadata?.name;
        i && "Unnamed" !== i || (i = this._parent?._t.pnx.filter_source_local);
        const n = ()=>$785da19a645c07eb$var$H`
			<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">
				<h5>${this._parent?._t.pnx.filter_locked}</h5>
				<div>${this._parent?._t.pnx.filter_zoom_in}</div>
			</div>`;
        return $785da19a645c07eb$var$H`<form
			@reset=${this._onReset}
			@change=${this._onFormChange}
			@submit=${this._onSubmit}
		>
			${this["no-source"] ? "" : $785da19a645c07eb$var$H`<div class="pnx-filter-block">
				<pnx-icon-switch
					id="pnx-pictures-source"
					name="pnx-pictures-source"
					@change=${this._onSourceChange}
					.checked=${"default" === this.source}
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$m2, {
            attributes: {
                slot: "icon-left"
            }
        })}
					<span slot="label-left">${this._parent?._t.pnx.filter_source_world}</span>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$g1, {
            attributes: {
                slot: "icon-right"
            }
        })}
					<span slot="label-right">${i}</span>
				</pnx-icon-switch>
			</div>`}

			${this["no-picture-type"] ? "" : $785da19a645c07eb$var$H`<div class="pnx-filter-block">
				<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$A1)} ${this._parent?._t.pnx.filter_picture}</h4>
				<div class="pnx-input-group pnx-checkbox-btns" style="justify-content: center;">
					<input
						type="radio"
						id="pnx-filter-type-all"
						name="pnx-filter-type"
						value=""
						.checked=${!this.type || "" === this.type}
					/>
					<label for="pnx-filter-type-all">${this._parent?._t.pnx.picture_all}</label>
					<input
						type="radio"
						id="pnx-filter-type-flat"
						name="pnx-filter-type"
						value="flat"
						.checked=${"flat" === this.type}
					/>
					<label for="pnx-filter-type-flat">${this._parent?._t.pnx.picture_flat}</label>
					<input
						type="radio"
						id="pnx-filter-type-360"
						name="pnx-filter-type"
						value="equirectangular"
						.checked=${"equirectangular" === this.type}
					/>
					<label for="pnx-filter-type-360">${this._parent?._t.pnx.picture_360}</label>
				</div>
			</div>`}

			${this["user-search"] ? $785da19a645c07eb$var$H`
				<div class="pnx-filter-block">
					<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$m1)} ${this._parent?._t.pnx.filter_user}</h4>
					${"default" === this.source && e1 ? $785da19a645c07eb$var$H`
						<div class="pnx-input-shortcuts">
							<button @click=${this._onMeUserSearch}>
								${this._parent?._t.pnx.filter_user_mypics}
							</button>
						</div>
					` : $785da19a645c07eb$var$Z}
					<pnx-search-bar
						id="pnx-filter-search-user"
						placeholder=${this._parent?._t.pnx.search_user}
						class=${this.user ? "pnx-filter-active" : ""}
						.value=${this.user}
						@result=${this._onUserSearchResult}
						.searcher=${this._userSearch.bind(this)}
						._parent=${this._parent}
						no-menu-closure
						keep-on-menu-closure
					>
					</pnx-search-bar>
				</div>
			` : $785da19a645c07eb$var$Z}

			${this["no-date"] ? "" : $785da19a645c07eb$var$H`<div class="pnx-filter-block">
				${n()}
				<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$h2)} ${this._parent?._t.pnx.filter_date}</h4>
				<div class="pnx-input-shortcuts">
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 1)).toISOString().split("T")[0])}
					>${this._parent?._t.pnx.filter_date_1month}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 6)).toISOString().split("T")[0])}
					>${this._parent?._t.pnx.filter_date_6months}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setFullYear((new Date).getFullYear() - 1)).toISOString().split("T")[0])}
					>${this._parent?._t.pnx.filter_date_1year}</button>
				</div>
				<div class="pnx-input-group">
					<input
						type="date"
						id="pnx-filter-date-from"
						.value=${this.minDate}
						class=${this.minDate && "" !== this.minDate ? "pnx-filter-active" : ""}
					/>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$k1)}
					<input
						type="date"
						id="pnx-filter-date-end"
						.value=${this.maxDate}
						class=${this.maxDate && "" !== this.maxDate ? "pnx-filter-active" : ""}
					/>
				</div>
			</div>`}

			${this["quality-score"] ? $785da19a645c07eb$var$H`
				<div class="pnx-filter-block">
					${n()}
					<h4>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$K1)} ${this._parent?._t.pnx.filter_qualityscore}
						<pnx-button
							title="${this._parent?._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>this._parent?._showQualityScoreDoc()}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}
						</pnx-button>
					</h4>
					<div class="pnx-input-group">
						<pnx-quality-score
							id="pnx-filter-qualityscore"
							._t=${this._parent?._t}
							input="pnx-filter-qualityscore"
							grade=${this.score}
							@change=${this._onFormChange}
						>
						</pnx-quality-score>
					</div>
				</div>
			` : $785da19a645c07eb$var$Z}

			${this["no-gps"] ? "" : $785da19a645c07eb$var$H`
				<div class="pnx-filter-block">
					${n()}
					<h4>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$Q1)} ${this._parent?._t.pnx.filter_gps_precision}
						${this._parent._showLocationPrecisionDoc ? $785da19a645c07eb$var$H`
							<pnx-button
								title="${this._parent?._t.pnx.filter_gps_precision_help}"
								kind="superinline"
								@click=${()=>this._parent._showLocationPrecisionDoc()}
							>
								${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}
							</pnx-button>
						` : $785da19a645c07eb$var$Z}
					</h4>
					<div class="pnx-input-group">
						<pnx-grade-filter
							id="pnx-filter-gps"
							._t=${this._parent?._t}
							input="pnx-filter-gps"
							grade=${this.gps}
							@change=${this._onFormChange}
							.labels=${t}
						>
						</pnx-grade-filter>
					</div>
				</div>
			`}

		</form>`;
    }
}
customElements.define("pnx-map-filters-menu", $785da19a645c07eb$var$Y2);
class $785da19a645c07eb$var$J2 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$L2,
        $785da19a645c07eb$var$o`
		:host {
			display: flex;
			flex-direction: column;
			align-items: end;
			gap: 5px;
			max-width: calc(100vw - 20px);
		}

		.btn-close {
			position: absolute;
			top: 8px;
			right: 5px;
			z-index: 10;
		}

		.btn-close svg {
			height: 16px;
		}

		.pnx-panel {
			position: relative;
			min-width: unset;
		}

		.map-layers {
			max-width: 100%;
			overflow-x: auto;
			padding: 10px 0;
		}
		
		.map-layers-blocks { display: flex; }

		.map-layers-block {
			border-right: 2px solid var(--grey-pale);
  			padding: 0 15px;
		}

		.map-layers-block:last-child { border-right: none; }
		.map-layers-block-bg { padding-left: 18px; }

		.map-layers-block h4 {
			margin: 0 0 10px 0;
		}

		pnx-switch {
			padding: 0 15px 0 0;
			box-sizing: border-box;
			float: right;
		}

		.legend {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-evenly;
			padding: 5px 10px;
  			gap: 10px;
			align-items: center;
		}

		.legend-entry {
			line-height: 12px;
			display: flex;
			align-items: center;
			font-size: 1.0em;
		}

		.legend-color {
			display: inline-block;
			width: 15px;
			height: 15px;
			border-radius: 3px;
			margin-right: 5px;
		}

		.style-v2 .legend-color {
			opacity: 0.8;
		}

		.legend-score {
			justify-content: center;
			gap: 0;
		}

		@media screen and (max-width: 576px) {
			:host {
				max-width: 100%;
				align-items: center;
			}
			.map-layers-block h4 {
				font-size: 1.2rem;
				margin: 0 0 15px 0;
			}
			.map-layers {
				border: none;
				width: 100%;
				padding: 0 20px;
			}
			.map-layers-blocks {
				flex-direction: column-reverse;
				gap: 20px;
				text-align: center;
			}
			.map-layers-block {
				padding: 0;
				border: none;
			}
			pnx-switch {
				float: unset;
				padding: 0;
			}
			.legend {
				border: none;
				margin: 10px 0;
				min-height: 50px;
				background: var(--grey-very-pale);
			}
			.legend-entry {
				font-size: 0.8em;
			}
		}
	`
    ];
    static properties = {
        theme: {
            state: !0
        }
    };
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.onceMapReady?.().then(()=>{
                this.theme = this._parent.mapStyleComposer.panoramaxTheme, this._parent.mapStyleComposer.addEventListener("theme-changed", (e1)=>this.theme = e1.detail.theme), this._parent.mapStyleComposer.addEventListener("panoramax-changed", ()=>setTimeout(this.requestUpdate.bind(this), 1e3)), this._parent.mapStyleComposer.addEventListener("basemap-changed", ()=>this.requestUpdate()), this._parent.map.indoorEqual?.on("levelschange", ()=>this.requestUpdate()), this._parent.map.indoorEqual?.on("levelchange", ()=>this.requestUpdate());
            }));
    }
    _onIndoorSwitchChange(e1) {
        this._parent?.map?.indoorEqual ? this._parent.map.indoorEqual.setLevel(e1.target.checked ? "0" : $785da19a645c07eb$var$Rc) : $785da19a645c07eb$var$Oc(this._parent.map, !0);
    }
    render() {
        const e1 = 2 === this._parent?.mapStyleComposer?._getPanoramaxStyleVersion(), t = this._parent?.map?.indoorEqual || !1 === this._parent?.map?._options?.indoor?.visible;
        let i, n;
        t && (i = this._parent.map.indoorEqual, n = $785da19a645c07eb$var$H`
				<pnx-switch
					.checked=${i && i.level !== $785da19a645c07eb$var$Rc}
					.disabled=${i && 0 === i.levels.length}
					@change=${this._onIndoorSwitchChange.bind(this)}
					name="pnx-level-switch"
				>
					${this._parent?._t.pnx.indoor_switch}
				</pnx-switch>
			`);
        const a = this._parent?.isWidthSmall(), r = this._parent?.map?._hasGridStats?.() || !1;
        return $785da19a645c07eb$var$H`
			${a ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`
				<pnx-button
					class="btn-close"
					kind="inline"
					size="l"
					@click=${()=>this.parentNode.close()}
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$r2)}
				</pnx-button>
			`}

			<div class="pnx-panel map-layers">
				<div class="map-layers-blocks">
					<div class="map-layers-block">
						<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$x1)} ${this._parent?._t.pnx.map_theme}</h4>
						<pnx-map-theme ._parent=${this._parent}></pnx-map-theme>
					</div>

					${t && this._parent?.isWidthSmall() ? n : $785da19a645c07eb$var$Z}

					${this._parent?.mapStyleComposer?.hasManyBasemaps?.() ? $785da19a645c07eb$var$H`
						<div class="map-layers-block map-layers-block-bg">
							<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$p2)} ${this._parent?._t.pnx.map_background}</h4>
							<pnx-map-background ._parent=${this._parent}></pnx-map-background>
						</div>
					` : $785da19a645c07eb$var$Z}
				</div>

				${t && !this._parent?.isWidthSmall() ? n : $785da19a645c07eb$var$Z}
			</div>

			<div class=${$785da19a645c07eb$var$w2({
            "pnx-panel": !0,
            legend: !0,
            "style-v2": e1,
            "pnx-hidden": !r && this.theme === $785da19a645c07eb$var$Po.default.id
        })}>
				${this.theme === $785da19a645c07eb$var$Po.default.id && r ? $785da19a645c07eb$var$H`
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.default.color[1]}"></span>
						${this._parent?._t.pnx.map_theme_default_4}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.default.color[3]}"></span>
						${this._parent?._t.pnx.map_theme_default_3}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.default.color[5]}"></span>
						${this._parent?._t.pnx.map_theme_default_2}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.default.color[7]}"></span>
						${this._parent?._t.pnx.map_theme_default_1}
					</div>
				` : $785da19a645c07eb$var$Z}

				${this.theme === $785da19a645c07eb$var$Po.age.id ? $785da19a645c07eb$var$H`
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.age.color[3]}"></span>
						${this._parent?._t.pnx.map_theme_age_4}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.age.color[5]}"></span>
						${this._parent?._t.pnx.map_theme_age_3}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.age.color[7]}"></span>
						${this._parent?._t.pnx.map_theme_age_2}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.age.color[8]}"></span>
						${this._parent?._t.pnx.map_theme_age_1}
					</div>
				` : $785da19a645c07eb$var$Z}

				${this.theme === $785da19a645c07eb$var$Po.type.id ? $785da19a645c07eb$var$H`
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.type.color[3]}"></span>
						${this._parent?._t.pnx.picture_360}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.type.color[4]}"></span>
						${this._parent?._t.pnx.picture_flat}
					</div>
				` : $785da19a645c07eb$var$Z}

				${this.theme === $785da19a645c07eb$var$Po.score.id ? $785da19a645c07eb$var$H`
					<pnx-quality-score></pnx-quality-score>
					<pnx-button
						title="${this._parent?._t.pnx.metadata_quality_help}"
						kind="superinline"
						@click=${()=>this._parent?._showQualityScoreDoc()}
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}
					</pnx-button>
				` : $785da19a645c07eb$var$Z}

				${this.theme === $785da19a645c07eb$var$Po.gps.id ? $785da19a645c07eb$var$H`
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[1]}"></span>
						${$785da19a645c07eb$var$Re[0].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[3]}"></span>
						${$785da19a645c07eb$var$Re[1].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[5]}"></span>
						${$785da19a645c07eb$var$Re[2].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[6]}"></span>
						${$785da19a645c07eb$var$Re[3].label}
					</div>
				` : $785da19a645c07eb$var$Z}
			</div>
		`;
    }
}
customElements.define("pnx-map-layers-menu", $785da19a645c07eb$var$J2);
class $785da19a645c07eb$var$$2 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			font-size: 0.7em;
		}
		small {
			font-size: 1em;
		}
		.maplibregl-ctrl-attrib-inner {
			display: inline-block;
		}
		.maplibregl-ctrl-scale {
			font-size: 8px;
			white-space: nowrap;
			border-bottom: 1px solid var(--grey-dark);
			padding: 3px 0 0 3px;
			box-sizing: border-box;
			position: relative;
		}
		.maplibregl-ctrl-scale:before,
		.maplibregl-ctrl-scale:after {
			content: '';
			position: absolute;
			bottom: 0px;
			height: 3px;
		}
		.maplibregl-ctrl-scale:before {
			left: 0;
			border-left: 1px solid var(--grey-dark);
		}
		.maplibregl-ctrl-scale:after {
			right: 0;
			border-right: 1px solid var(--grey-dark);
		}
	`;
    static properties = {
        light: {
            type: Boolean
        }
    };
    constructor(){
        super(), this.light = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this.requestUpdate()), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceMapReady?.().then(()=>{
                this._parent.map.on("styledata", ()=>this.requestUpdate()), this._parent.map.on("data", ()=>this.requestUpdate()), this.requestUpdate();
            }));
    }
    render() {
        const e1 = this._parent?.map?._attribution?._innerContainer, t = this._parent?._t.map.map_data.split("{m}"), i = this._parent?.map?._scale?._container;
        return i && this.light && i.remove(), this.light ? e1 && e1.innerHTML.length > 0 ? e1 : $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`
				${e1 && e1.innerHTML.length > 0 ? $785da19a645c07eb$var$H`${t.shift()}${e1}${t.shift()}` : $785da19a645c07eb$var$Z}
				${i}
			`;
    }
}
customElements.define("pnx-map-legend", $785da19a645c07eb$var$$2);
class $785da19a645c07eb$var$e3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			justify-content: space-evenly;
			box-sizing: border-box;
			display: flex;
			position: relative;
		}
		input { display: none; }
		label {
			cursor: pointer;
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 5px;
			font-size: 0.7rem;
			line-height: 0.8rem;
			color: var(--grey-dark);
			width: 50px;
			text-align: center;
			word-break: break-word;
			margin-right: 10px;
		}
		label:last-child { margin-right: unset; }

		.colors-scheme {
			width: 40px;
			height: 40px;
			border-radius: 22px;
			vertical-align: middle;
			border: 2px solid var(--widget-bg);
			display: flex;
			flex-direction: row;
			overflow: hidden;
		}

		@media screen and (max-width: 576px) {
			label { font-size: 0.9rem; }
		}

		.colors-scheme .color-entry {
			display: block;
			width: 100%;
			height: 100%;
		}

		input:checked + label .colors-scheme {
			outline: 3px solid var(--widget-border-btn);
		}

		.pnx-theme-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.9);
			position: absolute;
			top: -10px;
			right: 0;
			left: 0;
			bottom: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: baseline;
		}
		.pnx-theme-zoomin h5 {
			font-weight: 900;
			margin: 0 0 5px 0;
			font-size: 1em;
		}
		.pnx-theme-zoomin div {
			font-weight: unset;
  			font-size: 0.9em;
		}
		.pnx-theme-zoomin.hidden {
			display: none;
		}
	`;
    static properties = {
        theme: {
            state: !0
        }
    };
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.onceMapReady?.().then(()=>{
                this.requestUpdate(), this._parent.mapStyleComposer?.addEventListener("theme-changed", (e1)=>{
                    this.theme = e1.detail.theme, this.requestUpdate();
                }), this._parent.mapStyleComposer?.addEventListener("panoramax-changed", ()=>setTimeout(this.requestUpdate.bind(this), 1e3)), this._parent.mapStyleComposer?.addEventListener("filters-changed", ()=>this.requestUpdate()), this._parent.map?.on("zoomend", ()=>this.requestUpdate()), this.theme = this._parent.mapStyleComposer.panoramaxTheme;
            }));
    }
    _onThemeSelect(e1) {
        this.theme = e1.target.value, this._parent?.mapStyleComposer.setPanoramaxTheme(this.theme);
    }
    render() {
        const e1 = this._parent?.isWidthSmall(), t = this._parent?.map?._hasGridStats?.() || !1, i = this._parent.mapStyleComposer._hideMapFilters();
        return $785da19a645c07eb$var$H`
			<div class="pnx-theme-zoomin ${i ? "" : "hidden"}">
				<h5>${this._parent?._t.pnx.widget_locked}</h5>
				<div>${this._parent?._t.pnx.filter_zoom_in}</div>
			</div>
			<input
				type="radio"
				id="pnx-map-theme-default"
				name="pnx-map-theme"
				value=${$785da19a645c07eb$var$Po.default.id}
				@change=${this._onThemeSelect}
				.checked=${this.theme === $785da19a645c07eb$var$Po.default.id}
			/>
			<label for="pnx-map-theme-default">
				<div class="colors-scheme">
					${t ? $785da19a645c07eb$var$H`
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.default.color[1]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.default.color[3]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.default.color[5]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.default.color[7]}"></span>
					` : $785da19a645c07eb$var$H`
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Te.BASE}"></span>
					`}
				</div>
				${t ? e1 ? this._parent?._t.pnx.map_theme_default_coef_short : this._parent?._t.pnx.map_theme_default_coef : e1 ? this._parent?._t.pnx.map_theme_default_short : this._parent?._t.pnx.map_theme_default}
			</label>

			<input
				type="radio"
				id="pnx-map-theme-age"
				name="pnx-map-theme"
				value=${$785da19a645c07eb$var$Po.age.id}
				@change=${this._onThemeSelect}
				.checked=${this.theme === $785da19a645c07eb$var$Po.age.id}
			/>
			<label for="pnx-map-theme-age">
				<div class="colors-scheme">
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.age.color[3]}"></span>
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.age.color[5]}"></span>
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.age.color[7]}"></span>
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.age.color[8]}"></span>
				</div>
				${e1 ? this._parent?._t.pnx.map_theme_age_short : this._parent?._t.pnx.map_theme_age}
			</label>

			<input
				type="radio"
				id="pnx-map-theme-type"
				name="pnx-map-theme"
				value=${$785da19a645c07eb$var$Po.type.id}
				@change=${this._onThemeSelect}
				.checked=${this.theme === $785da19a645c07eb$var$Po.type.id}
			/>
			<label for="pnx-map-theme-type">
				<div class="colors-scheme">
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.type.color[3]}"></span>
					<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.type.color[4]}"></span>
				</div>
				${e1 ? this._parent?._t.pnx.map_theme_type_short : this._parent?._t.pnx.map_theme_type}
			</label>

			${this._parent?.map?._hasQualityScore?.() && $785da19a645c07eb$var$H`
				<input
					type="radio"
					id="pnx-map-theme-score"
					name="pnx-map-theme"
					value=${$785da19a645c07eb$var$Po.score.id}
					@change=${this._onThemeSelect}
					.checked=${this.theme === $785da19a645c07eb$var$Po.score.id}
				/>
				<label for="pnx-map-theme-score">
					<div class="colors-scheme">
						${$785da19a645c07eb$var$Pe.map((e1)=>$785da19a645c07eb$var$H`
							<span class="color-entry" style="background-color: ${e1.color}"></span>
						`)}
					</div>
					${e1 ? this._parent?._t.pnx.map_theme_score_short : this._parent?._t.pnx.map_theme_score}
				</label>

				<input
					type="radio"
					id="pnx-map-theme-gps"
					name="pnx-map-theme"
					value=${$785da19a645c07eb$var$Po.gps.id}
					@change=${this._onThemeSelect}
					.checked=${this.theme === $785da19a645c07eb$var$Po.gps.id}
				/>
				<label for="pnx-map-theme-gps">
					<div class="colors-scheme">
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[1]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[3]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[5]}"></span>
						<span class="color-entry" style="background-color: ${$785da19a645c07eb$var$Po.gps.color[6]}"></span>
					</div>
					${e1 ? this._parent?._t.pnx.map_theme_gps_short : this._parent?._t.pnx.map_theme_gps}
				</label>
			`}
		`;
    }
}
customElements.define("pnx-map-theme", $785da19a645c07eb$var$e3);
class $785da19a645c07eb$var$t3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		.pnx-panel {
			bottom: 0;
			right: 0;
			width: unset;
			min-width: unset;
			border-radius: 10px;
			border-top-right-radius: 0;
			border-bottom-left-radius: 0;
			border-right: none;
			border-bottom: none;
			padding: 2px 5px;
			font-size: 0.7em;
		}
	`
    ];
    static properties = {
        _caption: {
            state: !0
        }
    };
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            });
        });
    }
    _onPicChange(e1) {
        this._caption = e1?.caption;
    }
    render() {
        return this._caption?.date ? $785da19a645c07eb$var$H`<div class="pnx-panel">${this._caption.date.toLocaleDateString(this._parent?.lang || window.navigator.language, {
            year: "numeric",
            month: "long",
            day: "numeric"
        })}</div>` : $785da19a645c07eb$var$Z;
    }
}
customElements.define("pnx-mini-picture-legend", $785da19a645c07eb$var$t3);
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $785da19a645c07eb$var$i3 = Symbol.for(""), $785da19a645c07eb$var$n3 = (e1)=>{
    if (e1?.r === $785da19a645c07eb$var$i3) return e1?._$litStatic$;
}, $785da19a645c07eb$var$a3 = (e1)=>({
        _$litStatic$: e1,
        r: $785da19a645c07eb$var$i3
    }), $785da19a645c07eb$var$r3 = new Map, $785da19a645c07eb$var$s3 = ((e1)=>(t, ...i)=>{
        const n = i.length;
        let a, r;
        const s = [], o = [];
        let l, c = 0, u = !1;
        for(; c < n;){
            for(l = t[c]; c < n && void 0 !== (r = i[c], a = $785da19a645c07eb$var$n3(r));)l += a + t[++c], u = !0;
            c !== n && o.push(r), s.push(l), c++;
        }
        if (c === n && s.push(t[n]), u) {
            const e1 = s.join("$$lit$$");
            void 0 === (t = $785da19a645c07eb$var$r3.get(e1)) && (s.raw = s, $785da19a645c07eb$var$r3.set(e1, t = s)), i = o;
        }
        return e1(t, ...i);
    })($785da19a645c07eb$var$H), $785da19a645c07eb$var$o3 = {
    house: 20,
    housenumber: 20,
    street: 18,
    locality: 15,
    district: 13,
    municipality: 12,
    city: 12,
    county: 8,
    region: 7,
    state: 7,
    country: 5
};
function $785da19a645c07eb$var$l3(e1) {
    let t = {};
    return Object.entries(e1).filter((e1)=>void 0 !== e1[1] && null !== e1[1]).forEach((e1)=>t[e1[0]] = e1[1]), new URLSearchParams(t).toString();
}
function $785da19a645c07eb$var$c3(e1) {
    const t = {
        q: e1.query,
        countrycodes: e1.countries,
        limit: e1.limit,
        viewbox: e1.bbox
    };
    return fetch(`https://nominatim.openstreetmap.org/search?${$785da19a645c07eb$var$l3(t)}&format=geocodejson&addressdetails=1`).then((e1)=>e1.json()).then((e1)=>{
        const t = {
            features: []
        }, i = [];
        return (e1.features || []).forEach((e1)=>{
            const n = $785da19a645c07eb$var$d3(e1.properties?.geocoding) || e1.properties?.geocoding?.label;
            i.includes(n) || (t.features.push({
                place_type: [
                    "place"
                ],
                place_name: n,
                center: e1.geometry.coordinates,
                zoom: $785da19a645c07eb$var$o3[e1.properties?.geocoding?.type]
            }), i.push(n));
        }), t;
    });
}
function $785da19a645c07eb$var$u3(e1, t) {
    return fetch(`https://nominatim.openstreetmap.org/reverse?lat=${e1}&lon=${t}&zoom=18&format=geocodejson`).then((e1)=>e1.json()).then((e1)=>$785da19a645c07eb$var$d3(e1?.features?.shift()?.properties?.geocoding));
}
function $785da19a645c07eb$var$h3(e1) {
    return $785da19a645c07eb$var$p3(e1, "https://data.geopf.fr/geocodage/search");
}
function $785da19a645c07eb$var$d3(e1) {
    if (!e1 || "object" != typeof e1) return "";
    let t = e1.name, i = [], n = [];
    switch(e1.type){
        case "hamlet":
        case "croft":
        case "isolated_dwelling":
        case "neighbourhood":
        case "allotments":
        case "quarter":
        case "farm":
        case "farmyard":
        case "industrial":
        case "commercial":
        case "retail":
        case "city_block":
        case "residential":
        case "locality":
        case "district":
            n.push(e1.city), n.push(e1.county), n.push(e1.state), n.push(e1.country);
            break;
        case "city":
        case "region":
            n.push(e1.county), n.push(e1.state), n.push(e1.country);
            break;
        case "country":
            break;
        case "house":
        case "housenumber":
            i.push(e1.housenumber), i.push(e1.street), i.push(e1.locality), i.push(e1.district), n.push(e1.city), n.push(e1.county), n.push(e1.state), n.push(e1.country);
            break;
        default:
            i.push(e1.street), i.push(e1.locality), i.push(e1.district), n.push(e1.city), n.push(e1.county), n.push(e1.state), n.push(e1.country);
    }
    i = i.filter((e1)=>e1), i = i.filter((e1, n)=>e1 !== t && (0 === n || i[n - 1] !== e1)), i = i.length > 0 ? e1.housenumber ? i.slice(0, 2).join(" ") : i.shift() : null, i === t && (i = null), n = n.filter((e1)=>e1), n = n.filter((e1, a)=>!(e1 === t || i && i.includes(e1) || 0 !== a && n[a - 1] === e1));
    let a = [
        t,
        i,
        n.shift()
    ].filter((e1)=>e1);
    return a.join(", ");
}
function $785da19a645c07eb$var$p3(e1, t) {
    const i = {
        q: e1.query,
        limit: e1.limit
    };
    if ("string" == typeof e1.proximity) {
        const [t, n] = e1.proximity.split(",").map((e1)=>parseFloat(e1.trim()));
        i.lat = t, i.lon = n;
    }
    return fetch(`${t}/?${$785da19a645c07eb$var$l3(i)}`).then((e1)=>e1.json()).then((e1)=>{
        const t = {
            features: []
        }, i = [];
        return (e1.features || []).forEach((e1)=>{
            const n = $785da19a645c07eb$var$d3(e1.properties);
            i.includes(n) || "other" === e1.properties.type || (t.features.push({
                place_type: [
                    "place"
                ],
                place_name: n,
                center: e1.geometry.coordinates,
                zoom: $785da19a645c07eb$var$o3[e1.properties.type]
            }), i.push(n));
        }), t;
    });
}
var $785da19a645c07eb$var$m3 = Object.freeze({
    __proto__: null,
    forwardGeocodingBAN: $785da19a645c07eb$var$h3,
    forwardGeocodingNominatim: $785da19a645c07eb$var$c3,
    forwardGeocodingStandard: $785da19a645c07eb$var$p3,
    reverseGeocodingNominatim: $785da19a645c07eb$var$u3
});
class $785da19a645c07eb$var$g3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$q2,
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$F2,
        $785da19a645c07eb$var$o`
		:host {
			display: flex;
			flex-direction: column;
			margin: 0;
			font-family: var(--font-family);
			flex-wrap: nowrap;
		}

		@media screen and (min-width: 576px) {
			:host {
				max-height: 70vh;
			}
		}

		/* Top bar */
		.headline {
			display: flex;
			gap: 10px;
			align-items: center;
			margin: 10px 10px 5px 10px;
			justify-content: space-between;
			flex: 1;
		}

		.headline-buttons {
			display: flex;
			gap: 5px;
			align-items: center;
		}

		/* Address line */
		#pic-legend-addr {
			line-height: 1.2em;
			font-size: 1em;
			margin-bottom: 2px;
			flex-grow: 5;
			font-weight: 800;
			text-overflow: ellipsis;
			overflow: hidden;
  			white-space: nowrap;
		}

		#pic-legend-addr span {
			display: inline-block;
			height: 100%;
			width: 100%;
		}

		/* Visibility badge */
		.visibility-badge {
			cursor: help;
			background: var(--blue);
			color: var(--white);
			border-radius: 10px;
			height: 20px;
			display: inline-flex;
			font-size: 0.8em;
			padding: 0 5px;
  			gap: 3px;
			font-size: 0.7em;
  			align-items: center;
		}

		.visibility-badge svg {
			height: 1em;
		}

		/* Minimal info block */
		#pic-legend-info {
			margin: 10px;
			display: flex;
			gap: 10px;
			justify-content: space-around;
		}
		.info-block {
			display: flex;
			flex-shrink: 1;
			gap: 5px;
			font-weight: 600;
			font-size: 0.85em;
			align-items: center;
		}
		.info-block svg { height: 18px; }

		/* Expand button */
		#pic-legend-expand {
			display: block;
			margin-top: 5px;
			max-width: 100%;
			flex: 1;
		}
		#pic-legend-expand::part(btn) {
			border-radius: 10px;
			border-top-right-radius: 0;
			border-top-left-radius: 0;
		}

		/* Details block */
		pnx-picture-metadata {
			margin: 5px 10px;
			display: block;
			box-sizing: border-box;
			flex: 1;
			overflow-y: auto;
		}

		/* Details actions */
		#pic-legend-cta {
			display: flex;
			margin: 5px 10px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			gap: 5px;
			flex-wrap: wrap;
			flex: 1;
		}

		/* More options menu */
		#pnx-legend-opts { min-width: unset; }

		/* Editors */
		#pic-legend-editors { margin: 0 10px; }

		/* Light version */
		.pnx-picture-legend-light {
			width: max-content;
			font-size: 10px;
		}
	`
    ];
    static properties = {
        light: {
            type: Boolean
        },
        _caption: {
            state: !0
        },
        _addr: {
            state: !0
        },
        _expanded: {
            state: !0
        },
        _blockOnEditor: {
            state: !0
        },
        _visibility: {
            state: !0
        },
        collapsable: {
            type: Boolean
        }
    };
    constructor(){
        super(), this._expanded = !0, this.collapsable = !1, this.light = !1;
    }
    connectedCallback() {
        super.connectedCallback(), this._expanded = !this.collapsable, this._prevSearches = {}, $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                this._onPicChange(this._parent.psv.getPictureMetadata());
            }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                this._expanded = !0;
            }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || this._parent.psv.addEventListener("annotations-toggled", (e1)=>{
                e1.detail.visible && (this._expanded = !0);
            }), this._parent.psv.getSelectedAnnotations().length > 0 && (this._expanded = !0);
        });
    }
    _onPicChange(e1) {
        if (clearTimeout(this._addrTimer1), this._caption = e1?.caption, e1) {
            this._visibility = e1.properties?.["geovisio:visibility"] || null, "anyone" === this._visibility && (this._visibility = null);
            const t = `${e1.gps[0].toFixed(4)}/${e1.gps[1].toFixed(4)}`;
            this._prevSearches[t] ? this._addr = this._prevSearches[t] : this._parent.psv._sequencePlaying || (this._addr = "", this._addrTimer1 = setTimeout(()=>{
                $785da19a645c07eb$var$u3(e1.gps[1], e1.gps[0]).then((e1)=>{
                    clearTimeout(this._addrTimer2), this._addr = e1, this._prevSearches[t] = e1;
                });
            }, 500));
        } else this._visibility = null, this._addr = "";
    }
    _onBackClick() {
        this._parent.isWidthSmall() && "map" === this._parent.focus ? this._parent.select() : this._parent._setFocus?.("map");
    }
    _onDeleteClick() {
        if (confirm(this._parent?._t.pnx.delete_picture_warn)) {
            const e1 = this._parent.psv.getPictureMetadata(), t = e1.sequence.nextPic || e1.sequence.prevPic || null;
            this._parent.api.deletePicture(e1.sequence.id, e1.id).then(()=>{
                this._parent.psv.clearPictureMetadataCache(), this._parent.map?.reloadVectorTiles(), alert(this._parent?._t.pnx.delete_picture_ok), t ? this._parent.select(e1.sequence.id, t) : this._parent.select(null, null);
            }).catch((e1)=>alert(this._parent?._t.pnx.delete_picture_error.replace("{e}", e1)));
        }
    }
    blockOnEditing(e1) {
        this._blockOnEditor = e1;
    }
    render() {
        if (!this._caption) return $785da19a645c07eb$var$Z;
        const e1 = this._parent?.lang || window.navigator.language, t = $785da19a645c07eb$var$w2({
            "pnx-hidden": this._expanded
        }), i = $785da19a645c07eb$var$w2({
            "pnx-hidden": !this._expanded
        });
        return this.light ? $785da19a645c07eb$var$s3`<div class="pnx-picture-legend-light">
				${this._caption.producer?.length > 0 ? $785da19a645c07eb$var$s3`
					<a
						href=${"https://explore.panoramax.fr/?pic=" + this._parent.psv.getPictureMetadata().id}
						target="_blank"
						title=${this._parent?._t.pnx.share_page}
					>${this._caption.producer[this._caption.producer.length - 1]}</a>
				</div>` : $785da19a645c07eb$var$Z}

				${this._caption.producer?.length > 0 && this._caption.date ? "-" : ""}

				${this._caption.date ? new Intl.DateTimeFormat(e1, {
            timeZone: this._caption.tz,
            dateStyle: "short"
        }).format(this._caption.date) : $785da19a645c07eb$var$Z}

				${(this._caption.producer?.length > 0 || this._caption.date) && this._caption?.license ? "|" : ""}

				${this._caption?.license ? $785da19a645c07eb$var$s3`${$785da19a645c07eb$var$a3(this._caption.license)}` : $785da19a645c07eb$var$Z}
			` : $785da19a645c07eb$var$s3`
			<div class=${$785da19a645c07eb$var$w2({
            headline: !0,
            "pnx-hidden": this._blockOnEditor
        })}>
				${this._parent._setFocus ? $785da19a645c07eb$var$s3`
					<pnx-button
						kind="superinline"
						@click=${this._onBackClick}
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$F1)}
					</pnx-button>
				` : $785da19a645c07eb$var$Z}

				<div id="pic-legend-addr" title=${this._addr || ""}>
					${this._addr?.length > 0 ? this._addr : $785da19a645c07eb$var$s3`<span class="pnx-placeholder-loading">&nbsp;</span>`}
				</div>

				<div class="headline-buttons">
					${this._visibility ? $785da19a645c07eb$var$s3`
						<div
							class="visibility-badge"
							title=${this._parent?._t.pnx["visibility_title_" + this._visibility]}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$Z1, {
            transform: {
                size: 16
            }
        })}
							${this._parent?._t.pnx["visibility_" + this._visibility]}
						</div>
					` : $785da19a645c07eb$var$Z}

					<pnx-button
						size="sm"
						class=${t}
						title=${this._parent?._t.pnx.share}
						@click=${()=>this._parent._showShareOptions()}
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$h1)}
					</pnx-button>

					<pnx-picture-legend-actions
						@click=${(e1)=>e1.stopPropagation()}
						._parent=${this._parent}
						?full=${this._expanded}
					></pnx-picture-legend-actions>
				</div>
			</div>

			<div id="pic-legend-info" class=${t}>
				${this._caption.producer?.length > 0 ? $785da19a645c07eb$var$s3`<div class="info-block">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$m1)}
					${this._caption.producer[this._caption.producer.length - 1]}
				</div>` : $785da19a645c07eb$var$Z}

				${this._caption.date ? $785da19a645c07eb$var$s3`<div class="info-block">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$r1)}
					${this._caption.date.toLocaleDateString(this._parent?.lang || window.navigator.language, {
            year: "numeric",
            month: "long",
            day: "numeric"
        })}				</div>` : $785da19a645c07eb$var$Z}
			</div>

			<div id="pic-legend-cta" class=${$785da19a645c07eb$var$w2({
            "pnx-hidden": !this._expanded || this._blockOnEditor
        })}>
				<pnx-button size="sm" @click=${()=>this._parent._showShareOptions()}>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$h1)} ${this._parent?._t.pnx.share}
				</pnx-button>

				${this._parent.psv.getPictureMetadata().permissions.delete_picture ? $785da19a645c07eb$var$s3`
					<pnx-button kind="fulldanger" size="sm" @click=${this._onDeleteClick.bind(this)}>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$I1)} ${this._parent?._t.pnx.delete_picture}
					</pnx-button>` : this._parent.getAPI()._endpoints.report ? $785da19a645c07eb$var$s3`
					<pnx-button kind="fullwarn" size="sm" @click=${()=>this._parent._showReportForm()}>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$g2)} ${this._parent?._t.pnx.report}
					</pnx-button>
				` : $785da19a645c07eb$var$Z}

				<slot name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</div>

			<pnx-picture-metadata
				class=${i}
				.block-editor=${this._blockOnEditor}
				._parent=${this._parent}
			></pnx-picture-metadata>

			${this.collapsable && !this._blockOnEditor ? $785da19a645c07eb$var$s3`<pnx-button
				kind="inline"
				size="sm"
				id="pic-legend-expand"
				@click=${()=>this._expanded = !this._expanded}
			>${this._expanded ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$p1) : $785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}</pnx-button>` : $785da19a645c07eb$var$Z}
		`;
    }
}
customElements.define("pnx-picture-legend", $785da19a645c07eb$var$g3);
const $785da19a645c07eb$var$f3 = ()=>$785da19a645c07eb$var$ws($785da19a645c07eb$var$E1, {
        styles: {
            height: "16px"
        }
    });
class $785da19a645c07eb$var$A3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$R2,
        $785da19a645c07eb$var$F2,
        $785da19a645c07eb$var$Z2,
        $785da19a645c07eb$var$o`
		div[slot="content"] {
			padding: 5px 10px;
			background-color: #ededed;
		}

		.data-block {
			min-width: 50%;
		}

		pnx-semantics-table {
			overflow-x: auto;
  			display: block;
		}
	`
    ];
    static properties = {
        _meta: {
            state: !0
        },
        "block-editor": {
            type: Boolean
        }
    };
    connectedCallback() {
        super.connectedCallback();
        const e1 = ()=>{
            const e1 = this.shadowRoot.querySelector("pnx-tabs");
            e1 && e1.setAttribute("activeTabIndex", 4);
        };
        window.navigation?.addEventListener("navigate", ()=>{
            this.requestUpdate();
        }), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._meta = this._parent?.psv?.getPictureMetadata(), this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._meta = this._parent.psv.getPictureMetadata();
                }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || (this._parent.psv.addEventListener("annotation-focused", e1), this._parent.psv.addEventListener("annotations-toggled", (t)=>{
                    t.detail.visible && setTimeout(e1, 250);
                }), this._parent.psv.getSelectedAnnotations().length > 0 && e1());
            });
        });
    }
    _onQualityScoreClick() {
        const e1 = this.shadowRoot.querySelector("pnx-tabs");
        e1 && e1.setAttribute("activeTabIndex", 3);
    }
    _onCaptureDateClick() {
        const e1 = this.shadowRoot.querySelector("pnx-tabs");
        e1 && e1.setAttribute("activeTabIndex", 1);
    }
    _toTab(e1, t) {
        return $785da19a645c07eb$var$s3`
			<h4 slot="title">${e1}</h4>
			<div slot="content" class="data-blocks">
				${t.filter((e1)=>e1).map((e1)=>$785da19a645c07eb$var$s3`<div class="data-block" style=${e1.style}>
					<h5>${e1.title}</h5>
					<div style=${e1.content_style} @click=${e1.click}>${e1.content}</div>
				</div>`)}
			</div>
		`;
    }
    render() {
        if (!this._meta) return $785da19a645c07eb$var$Z;
        const e1 = this._parent?.lang || window.navigator.language, t = this._meta?.properties?.["pers:interior_orientation"], i = [
            t.camera_manufacturer,
            t.camera_model
        ].filter((e1)=>e1).join(" "), n = t?.focal_length ? `${t?.focal_length} mm` : $785da19a645c07eb$var$f3();
        let a = t?.sensor_array_dimensions;
        a && (a = `${a[0]} x ${a[1]} px (${Math.floor(a[0] * a[1] / 1e6)} Mpx)`);
        let r = this._parent?._t.pnx.picture_flat, s = this._parent?._t.pnx.picture_flat_long, o = t?.field_of_view;
        null != o && (360 === o ? (r = this._parent?._t.pnx.picture_360, s = this._parent?._t.pnx.picture_360_long) : r += ` (${o}\xb0)`);
        const l = [
            {
                title: this._parent?._t.pnx.metadata_camera_make,
                content: t?.camera_manufacturer || $785da19a645c07eb$var$f3()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_model,
                content: t?.camera_model || $785da19a645c07eb$var$f3()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_type,
                content: r
            },
            {
                title: this._parent?._t.pnx.metadata_camera_resolution,
                content: a || $785da19a645c07eb$var$f3()
            },
            {
                title: this._parent?._t.pnx.metadata_camera_focal_length,
                content: n
            },
            this._meta?.caption?.date && {
                title: this._parent?._t.pnx.metadata_general_date,
                content: $785da19a645c07eb$var$s3`
					<strong>${new Intl.DateTimeFormat(e1, {
                    timeZone: this._meta.caption.tz,
                    dateStyle: "short"
                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(e1, {
                    timeZone: this._meta.caption.tz,
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    fractionalSecondDigits: 3,
                    timeZoneName: "longOffset"
                }).format(this._meta.caption.date)}
				`
            }
        ], c = void 0 !== this._meta?.properties?.["view:azimuth"] && `${this._meta.properties["view:azimuth"]}\xb0`, u = [
            {
                title: this._parent?._t.pnx.metadata_location_coordinates,
                content: $785da19a645c07eb$var$s3`
					${this._meta.gps[0].toFixed(5)}, ${this._meta.gps[1].toFixed(5)}
					<pnx-copy-coordinates
						._parent=${this._parent}
						.gps=${this._meta.gps}
						style="margin-left: 10px"
					></pnx-copy-coordinates>
				`,
                style: "width: 100%"
            },
            {
                title: this._parent?._t.pnx.metadata_location_orientation,
                content: c || $785da19a645c07eb$var$f3()
            },
            {
                title: this._parent?._t.pnx.metadata_location_precision,
                content: $785da19a645c07eb$var$pO(this._meta) || $785da19a645c07eb$var$f3()
            }
        ], h = this._parent?.map?._hasQualityScore?.() || this._meta?.properties?.["quality:horizontal_accuracy"] || this._meta?.properties?.["panoramax:horizontal_pixel_density"];
        let d, p;
        if (h) {
            const e1 = $785da19a645c07eb$var$Be($785da19a645c07eb$var$ze, this._meta?.properties?.["quality:horizontal_accuracy"]), t = $785da19a645c07eb$var$Be(360 === this._meta?.horizontalFov ? $785da19a645c07eb$var$Fe : $785da19a645c07eb$var$Ie, this._meta?.properties?.["panoramax:horizontal_pixel_density"]);
            p = Math.round(.8 * (t || 1) + .2 * (e1 || 1)), d = [
                {
                    title: $785da19a645c07eb$var$s3`
						${this._parent?._t.pnx.metadata_quality_score}
						<pnx-button
							title="${this._parent?._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>this._parent?._showQualityScoreDoc()}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}
						</pnx-button>
					`,
                    content: $785da19a645c07eb$var$s3`<pnx-quality-score grade=${p} style="font-size: 16px"></pnx-quality-score>`,
                    style: "width: 100%"
                },
                {
                    title: this._parent?._t.pnx.metadata_quality_gps_score,
                    content: $785da19a645c07eb$var$ks("pnx-grade", {
                        stars: e1,
                        _t: this._parent?._t
                    })
                },
                {
                    title: this._parent?._t.pnx.metadata_quality_resolution_score,
                    content: $785da19a645c07eb$var$ks("pnx-grade", {
                        stars: t,
                        _t: this._parent?._t
                    })
                }
            ];
        }
        const m = Object.entries(this._meta?.properties?.exif || {}).sort().filter(([, e1])=>e1).map(([e1, t])=>(JSON.stringify(t).includes("\\u") && (t = JSON.stringify(t).replace(/\\u[0-9A-Fa-f]{4}/g, (e1)=>" 0x" + parseInt(e1.slice(2), 16).toString(16).toUpperCase().padStart(4, "0")).slice(1, -1).trim()), {
                title: e1,
                content: t.length > 30 ? $785da19a645c07eb$var$s3`<textarea readonly .value=${t}></textarea>` : t,
                style: t.length > 30 ? "width: 100%" : void 0
            }));
        m.unshift({
            content: $785da19a645c07eb$var$s3`
				<pnx-link-button
					size="sm"
					target="_blank"
					href="https://exiv2.org/metadata.html"
					title=${this._parent?._t.pnx.metadata_exif_doc_title}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)} ${this._parent?._t.pnx.metadata_exif_doc}</pnx-link-button>
			`,
            style: "width: 100%"
        });
        const g = [
            this._meta.properties.title?.length > 0 && {
                title: this._parent?._t.pnx.metadata_general_title,
                content: this._meta.properties.title
            },
            this._meta?.caption?.producer?.length > 0 && {
                title: this._parent?._t.pnx.metadata_general_author,
                content: $785da19a645c07eb$var$s3`
					<strong>${this._meta.caption.producer[this._meta.caption.producer.length - 1]}</strong>
					${this._meta.caption.producer.length > 1 ? $785da19a645c07eb$var$s3`<br />${this._meta.caption.producer.slice(0, -1).join(", ")}` : $785da19a645c07eb$var$Z}
				`
            },
            this._meta?.caption?.date && {
                title: this._parent?._t.pnx.metadata_general_date,
                click: this._onCaptureDateClick,
                content_style: "cursor: pointer",
                content: $785da19a645c07eb$var$s3`
					<strong>${new Intl.DateTimeFormat(e1, {
                    timeZone: this._meta.caption.tz,
                    dateStyle: "long"
                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(e1, {
                    timeZone: this._meta.caption.tz,
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                }).format(this._meta.caption.date)}
				`
            },
            t && {
                title: this._parent?._t.pnx.metadata_camera,
                content: $785da19a645c07eb$var$s3`
					<strong>${i.length > 0 ? i : $785da19a645c07eb$var$f3()}</strong>
					<br />${s}
				`
            },
            this._meta?.caption?.license && {
                title: this._parent?._t.pnx.metadata_general_license,
                content: $785da19a645c07eb$var$s3`${$785da19a645c07eb$var$a3(this._meta.caption.license)}`
            },
            h && {
                title: this._parent?._t.pnx.metadata_quality,
                click: this._onQualityScoreClick,
                content: $785da19a645c07eb$var$s3`<pnx-quality-score
					grade=${p}
					style="font-size: 14px; cursor: pointer"
				/>`
            },
            {
                title: this._parent?._t.pnx.metadata_general_copy_id,
                content_style: "display: flex; gap: 5px;",
                content: $785da19a645c07eb$var$s3`
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${this._parent?._t}
						text=${this._meta.id}
						title=${this._meta.id}
						style="flex: 1"
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$A1)} ${this._parent?._t.pnx.metadata_general_picid}
					</pnx-copy-button>
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${this._parent?._t}
						text=${this._meta.sequence.id}
						title=${this._meta.sequence.id}
						style="flex: 1"
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$G1)} ${this._parent?._t.pnx.metadata_general_seqid}
					</pnx-copy-button>
				`
            },
            this._meta?.origInstance && {
                title: this._parent?._t.pnx.metadata_general_instance,
                content: $785da19a645c07eb$var$s3`<strong>
					<a href=${this._meta.origInstance.href + window.location.search} target="_blank" style="text-decoration: none">
						<img
							src=${"https://explore.panoramax.fr/api/instances/" + this._meta.origInstance.instance_name + "/logo"}
							style="height: 30px; max-width: 150px; vertical-align: middle"
							alt=""
						/>
						<span style="text-decoration: underline">
							${this._meta.origInstance.instance_name || this._meta.origInstance.href.replace(/^http.?:\/\//, "")}
						</span>
					</a>
				</strong>`
            }
        ];
        return $785da19a645c07eb$var$s3`<pnx-tabs .hideNav=${this["block-editor"]}>
			${this._toTab($785da19a645c07eb$var$s3`${$785da19a645c07eb$var$ws($785da19a645c07eb$var$A1)} ${this._parent?._t.pnx.metadata_summary}`, g)}

			${this._toTab($785da19a645c07eb$var$s3`${$785da19a645c07eb$var$ws($785da19a645c07eb$var$B1)} ${this._parent?._t.pnx.metadata_camera}`, l)}

			${this._toTab($785da19a645c07eb$var$s3`${$785da19a645c07eb$var$ws($785da19a645c07eb$var$X1)} ${this._parent?._t.pnx.metadata_location}`, u)}

			${h ? this._toTab($785da19a645c07eb$var$s3`${$785da19a645c07eb$var$ws($785da19a645c07eb$var$K1)} ${this._parent?._t.pnx.metadata_quality}`, d) : $785da19a645c07eb$var$Z}

			<h4 slot="title">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$C1)} ${this._parent?._t.pnx.semantics_title}</h4>
			<div slot="content" class="data-blocks">
				<pnx-semantics-metadata ._parent=${this._parent}></pnx-semantics-metadata>
			</div>

			${this._meta.properties?.exif ? this._toTab($785da19a645c07eb$var$s3`${$785da19a645c07eb$var$ws($785da19a645c07eb$var$v1)} ${this._parent?._t.pnx.metadata_exif}`, m) : $785da19a645c07eb$var$Z}
		</pnx-tabs>`;
    }
}
customElements.define("pnx-picture-metadata", $785da19a645c07eb$var$A3);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ const $785da19a645c07eb$var$_3 = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M297.2 248.9C311.6 228.3 320 203.2 320 176c0-70.7-57.3-128-128-128S64 105.3 64 176c0 27.2 8.4 52.3 22.8 72.9c3.7 5.3 8.1 11.3 12.8 17.7c0 0 0 0 0 0c12.9 17.7 28.3 38.9 39.8 59.8c10.4 19 15.7 38.8 18.3 57.5L109 384c-2.2-12-5.9-23.7-11.8-34.5c-9.9-18-22.2-34.9-34.5-51.8c0 0 0 0 0 0s0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176C16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4c0 0 0 0 0 0s0 0 0 0c-12.3 16.8-24.6 33.7-34.5 51.8c-5.9 10.8-9.6 22.5-11.8 34.5l-48.6 0c2.6-18.7 7.9-38.6 18.3-57.5c11.5-20.9 26.9-42.1 39.8-59.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c4.7-6.4 9-12.4 12.7-17.7zM192 128c-26.5 0-48 21.5-48 48c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 384c-44.2 0-80-35.8-80-80l0-16 160 0 0 16c0 44.2-35.8 80-80 80z"
    ]
}, $785da19a645c07eb$var$v3 = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
    ]
};
class $785da19a645c07eb$var$y3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$o`
		:host {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 15px;
			padding: 5px 15px;
		}

		.pnx-input-range {
			display: flex;
			justify-content: space-between;
			gap: 10px;
			align-items: center;
			width: 100%;
		}
	`
    ];
    static properties = {
        contrast: {
            state: !0
        }
    };
    constructor(){
        super(), this.contrast = 0;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.psv?.addEventListener("transition-duration-changed", (e1)=>{
                this.renderRoot.querySelector("#pnx-player-speed").value = $785da19a645c07eb$var$v0 - e1.detail.value;
            }));
    }
    _onSpeedChange(e1) {
        const t = $785da19a645c07eb$var$v0 - e1.target.value;
        this._parent?.psv?.setTransitionDuration(t);
    }
    _onContrastClick() {
        this.contrast++, this.contrast > 1 && (this.contrast = -1), this._parent?.psv?.setContrast(this.contrast);
    }
    render() {
        return $785da19a645c07eb$var$H`
			<div class="pnx-input-range" title="${this._parent?._t.pnx.sequence_speed}">
				${$785da19a645c07eb$var$ws($785da19a645c07eb$var$u2)}
				<input
					id="pnx-player-speed"
					type="range" name="speed"
					min="0" max="${2900}"
					value="${$785da19a645c07eb$var$v0 - this._parent?.psv.getTransitionDuration()}"
					title="${this._parent?._t.pnx.sequence_speed}"
					style="width: 100%;"
					@change=${this._onSpeedChange}
				/>
				${$785da19a645c07eb$var$ws($785da19a645c07eb$var$l2)}
			</div>
			<pnx-button
				id="pnx-player-contrast"
				title=${this._parent?._t.pnx[0 === this.contrast ? "contrast" : 1 === this.contrast ? "low_contrast" : "reset_contrast"]}
				kind="outline"
				.active=${0 !== this.contrast ? "true" : null}
				@click=${this._onContrastClick}
			>
				${-1 === this.contrast ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$_3) : $785da19a645c07eb$var$ws($785da19a645c07eb$var$l1)}
			</pnx-button>
		`;
    }
}
customElements.define("pnx-player-options", $785da19a645c07eb$var$y3);
class $785da19a645c07eb$var$x3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$K2
    ];
    render() {
        return $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$K1)} ${this._t?.pnx.filter_qualityscore}</h4>
			<p>${this._t?.pnx.qualityscore_doc_1}</p>
			<p>${this._t?.pnx.qualityscore_doc_2}</p>
			<pnx-quality-score grade=""></pnx-quality-score>
			<p>${this._t?.pnx.qualityscore_doc_3}</p>
			<p>${this._t?.pnx.qualityscore_doc_4}</p>
			<ul>
				<li>${this._t?.pnx.qualityscore_doc_41}</li>
				<li>${this._t?.pnx.qualityscore_doc_42}</li>
			</ul>
			<p>${this._t?.pnx.qualityscore_doc_5}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$z1)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-quality-score-doc", $785da19a645c07eb$var$x3);
const $785da19a645c07eb$var$b3 = [
    "",
    "blur_missing",
    "blur_excess",
    "inappropriate",
    "privacy",
    "picture_low_quality",
    "mislocated",
    "copyright",
    "other"
];
class $785da19a645c07eb$var$w3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$L2,
        $785da19a645c07eb$var$R2,
        $785da19a645c07eb$var$B2,
        $785da19a645c07eb$var$o`
		.group {
			margin-bottom: 10px;
		}

		.group:not(.group-inline) label {
			margin-bottom: 5px;
			display: inline-block;
		}
	`
    ];
    static properties = {
        mode: {
            state: !0
        },
        failure: {
            state: !0
        }
    };
    _onSubmit(e1) {
        e1.preventDefault();
        const t = this._parent?.psv?.getPictureMetadata(), i = Object.fromEntries(new FormData(e1.target)), n = {
            issue: i.issue,
            picture_id: i["whole-sequence"] ? null : t?.id,
            reporter_comments: i.comments,
            reporter_email: i.email,
            sequence_id: t?.sequence?.id
        };
        this.mode = "wait", this._parent?.getAPI().sendReport(n).then(()=>{
            this.mode = "success";
        }).catch((e1)=>{
            console.error(e1), this.mode = "failure", this.failure = e1;
        });
    }
    render() {
        const e1 = $785da19a645c07eb$var$tt();
        return this.mode ? $785da19a645c07eb$var$H`
				<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$g2)} ${this._parent?._t.pnx.report}</h4>
				<p>
					${"wait" === this.mode ? this._parent?._t.pnx.report_wait : $785da19a645c07eb$var$Z}
					${"success" === this.mode ? this._parent?._t.pnx.report_success : $785da19a645c07eb$var$Z}
					${"failure" === this.mode ? this._parent?._t.pnx.report_failure.replace("{e}", this.failure) : $785da19a645c07eb$var$Z}
				</p>
			` : $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$g2)} ${this._parent?._t.pnx.report}</h4>

			${e1 && this._parent?._t ? $785da19a645c07eb$var$H`
				<p>${this._parent?._t.pnx.report_auth.replace("{a}", e1.name)}</p>
			` : $785da19a645c07eb$var$Z}

			<form @submit=${this._onSubmit.bind(this)}>
				<div class="group">
					<label for="issue">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$R1)} ${this._parent?._t.pnx.report_nature_label}</label>
					<select name="issue" id="issue" required class="pnx-100w">
						${$785da19a645c07eb$var$b3.map((e1)=>$785da19a645c07eb$var$H`
							<option
								value=${e1}
								${"" === e1 ? $785da19a645c07eb$var$H`disabled selected hidden` : $785da19a645c07eb$var$Z}
							>
								${this._parent?._t.pnx.report_nature[e1]}
							</option>
						`)}
					</select>
				</div>

				<div class="group group-inline">
					<input name="whole-sequence" id="whole-sequence" type="checkbox" />
					<label for="whole-sequence">${this._parent?._t.pnx.report_whole_sequence}</label>
				</div>

				<div class="group">
					<label for="comments">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$P1)} ${this._parent?._t.pnx.report_details}</label>
					<textarea name="comments" id="comments" placeholder=${this._parent?._t.pnx.report_details_placeholder}></textarea>
				</div>

				${e1 ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`
					<div class="group">
						<label for="email">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$a1)} ${this._parent?._t.pnx.report_email}</label>
						<input type="email" name="email" id="email" placeholder=${this._parent?._t.pnx.report_email_placeholder} class="pnx-100w" />
					</div>
				`}

				<pnx-button type="submit" style="width: 100%">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$f2)} ${this._parent?._t.pnx.report_submit}
				</pnx-button>
			</form>
		`;
    }
}
customElements.define("pnx-report-form", $785da19a645c07eb$var$w3);
class $785da19a645c07eb$var$E3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$K2
    ];
    render() {
        return $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$C1)} ${this._t?.pnx.semantics_title}</h4>
			<p>${this._t?.pnx.semantics_doc_info1}</p>
			<ul style="padding-left: 1.5em;">
				<li>${this._t?.pnx.semantics_doc_info1u1}</li>
				<li>${this._t?.pnx.semantics_doc_info2}</li>
			</ul>
			<p>${this._t?.pnx.semantics_doc_info3}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/tags/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$z1)} ${this._t?.pnx.popup_details_link}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-semantics-doc", $785da19a645c07eb$var$E3);
class $785da19a645c07eb$var$k3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$z2
    ];
    render() {
        return $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$H1)} ${this._t?.pnx.semantics_download_title}</h4>
			<p>${this._t?.pnx.semantics_download_info}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/federated-catalog/data_export/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${this._t?.pnx.semantics_download_cta}</pnx-link-button>
		`;
    }
}
customElements.define("pnx-semantics-download", $785da19a645c07eb$var$k3);
class $785da19a645c07eb$var$S3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		.pnx-tags-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.8);
			text-align: center;
			font-weight: 800;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 25px;
		}
		.pnx-tags-zoomin.hidden {
			display: none;
		}
		.pnx-tags-cta {
			display: flex;
			align-items: center;
  			justify-content: end;
		}
		pnx-switch {
			display: block;
			margin: 5px 0;
		}
	`;
    static properties = {
        _showZoomIn: {
            state: !0
        },
        _layers: {
            state: !0
        }
    };
    constructor(){
        super(), this.showZoomIn = !0, this._layers = [], $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceMapReady?.().then(()=>{
                const e1 = ()=>{
                    this._onLayersChange(), this.requestUpdate();
                };
                this._parent.map.on("zoomend", this._onMapZoom.bind(this)), this._parent.map.on("styledata", e1), this._parent.mapStyleComposer.addEventListener("dataoverlay-added", e1), this._onMapZoom(), e1();
            }));
    }
    _layersToSet(e1) {
        return e1.map((e1)=>e1.source + "/" + this._parent.mapStyleComposer.dataOverlays.has(e1.source)).sort().join("|");
    }
    _onLayersChange() {
        clearTimeout(this._debouncedChange), this._debouncedChange = setTimeout(()=>{
            const e1 = this._parent?.map?.getSemanticOverlays();
            this._layersToSet(e1) != this._layersToSet(this._layers) && (this._layers = e1, this.dispatchEvent(new CustomEvent("change", {
                bubbles: !0,
                composed: !0,
                detail: {
                    layers: e1
                }
            })));
        }, 10);
    }
    _onMapZoom() {
        this._showZoomIn = this._parent.map.getZoom() < 15;
    }
    render() {
        if (this._layers && 0 !== this._layers.length) return $785da19a645c07eb$var$H`
			<div class="pnx-tags-zoomin ${this._showZoomIn ? "" : "hidden"}">
				${this._parent?._t.pnx.semantics_zoom_in}
			</div>

			<div class="pnx-tags-cta">
				<pnx-button
					kind="full"
					size="sm"
					@click=${()=>this._parent?._showSemanticsDownload()}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$H1)} ${this._parent?._t.pnx.semantics_download}</pnx-button>

				<pnx-button
					id="pnx-semfilt-doc"
					kind="superinline"
					size="md"
					title=${this._parent?._t.pnx.semantics_doc}
					@click=${()=>this._parent?._showSemanticsDoc()}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}</pnx-button>
			</div>

			${this._layers.filter((e1)=>e1.metadata).map((e1)=>$785da19a645c07eb$var$H`
				<pnx-switch
					name=${"pnx-semfilt-" + e1.id}
					.checked=${this._parent.mapStyleComposer.dataOverlays.has(e1.source)}
					@change=${(t)=>this._parent.mapStyleComposer.switchDataOverlayVisibility(e1.source, t.target.checked)}
				>${this._parent?._t.pnx.semantics_overlays[e1.id] || e1.metadata.name || e1.id}</pnx-switch>
			`)}
			<slot name="extra"></slot>
		`;
    }
}
customElements.define("pnx-map-semantics-filters-menu", $785da19a645c07eb$var$S3);
class $785da19a645c07eb$var$M3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$W2,
        $785da19a645c07eb$var$V2,
        $785da19a645c07eb$var$o`
		.annotation { background: var(--white); }
		.info { padding: 10px 0; }
		pnx-list-item {
			display: block;
			margin: 5px 0;
		}
	`
    ];
    static properties = {
        editable: {
            type: Boolean
        },
        _meta: {
            state: !0
        },
        _seqMeta: {
            state: !0
        },
        _entries: {
            state: !0
        },
        _selectedEntry: {
            state: !0
        },
        _annotPresets: {
            state: !0
        },
        _picPresets: {
            state: !0
        },
        _seqPresets: {
            state: !0
        }
    };
    constructor(){
        super(), this._meta = {}, this._seqMeta = {}, this._selectedEntry = null, this._annotPresets = {}, this._picPresets = [], this._seqPresets = [], this._entries = null, this.editable = !1, $785da19a645c07eb$var$Es();
    }
    connectedCallback() {
        super.connectedCallback(), this._onPicChange(), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._parent.psv?.addEventListener("picture-loaded", this._onPicChange.bind(this)), this._parent.psv?.addEventListener("annotation-focused", (e1)=>this.showAnnotation(e1.detail.annotationId)), this._parent.psv?.addEventListener("annotations-unfocused", (e1)=>{
                "user-click" === e1.detail.source && delete this._prevPsvView, this._onListItemClick(null);
            });
            const e1 = this._parent.psv.getSelectedAnnotations();
            e1.length > 0 && this.showAnnotation(e1[0]);
        });
    }
    showAnnotation(e1) {
        this._entries ? this._onListItemClick(this._entries.find((t)=>"annotation" === t.type && t.annotation.id == e1)) : setTimeout(()=>this.showAnnotation(e1), 200);
    }
    showTagsGroup(e1) {
        this._entries ? this._onListItemClick(this._entries.find((t)=>{
            if ("annotation" === t?.type) return !1;
            for(let i = 0; i < e1.length; i++)if (!t.tagGroup.semantics.find((t)=>e1[i].key === t.key && e1[i].value === t.value)) return !1;
            return !0;
        })) : setTimeout(()=>this.showTagsGroup(e1), 200);
    }
    _onPicChange() {
        this._meta = this._parent?.psv?.getPictureMetadata(), this._getSeqMeta(), delete this._prevPsvView, this._selectedEntry = null, this._entries = null, this.dispatchEvent(new CustomEvent("select", {
            detail: {
                item: null
            }
        })), this._meta && this._parent?.presetsManager && (this._annotPresets = {}, this._picPresets = [], this._parent.presetsManager.getPresets(this._meta.properties).then((e1)=>{
            this._picPresets = e1, this._computeEntries();
        }), this._meta.properties?.annotations?.length > 0 && Promise.all(this._meta.properties.annotations.map((e1)=>this._parent.presetsManager.getPreset(e1).then((t)=>{
                this._annotPresets[e1.id] = t;
            }))).then(()=>this._computeEntries()));
    }
    async _getSeqMeta() {
        const e1 = this._meta?.sequence?.id;
        if (e1 && !this._parent._sequencesMetadata[e1] && (this._parent._sequencesMetadata[e1] = await this._parent.getAPI().getSequenceMetadata(e1)), this._seqMeta = this._parent._sequencesMetadata[e1], this._seqPresets = [], this._seqMeta?.semantics?.length > 0) {
            const e1 = await this._parent.presetsManager.getPresets(this._seqMeta);
            this._seqPresets = e1, this._computeEntries();
        }
    }
    _getGroupedTags(e1, t, i, n) {
        if (!e1) return;
        const a = [], r = (e1, t)=>{
            const i = [
                {
                    key: t,
                    value: e1.value
                }
            ];
            return e1.qualifiers && e1.qualifiers.forEach((e1)=>i.push({
                    key: e1.key,
                    value: e1.value
                })), i;
        }, s = $785da19a645c07eb$var$t1(e1), o = [];
        return s.forEach((e1)=>{
            const i = {};
            e1.tags.forEach((s)=>{
                const l = "" !== e1.prefix ? `${e1.prefix}|${s.key}` : s.key;
                if (i[`${l}=${s.value}`]) return void r(s, l).forEach((e1)=>i[`${l}=${s.value}`].push(e1));
                const c = n.find((e1)=>[
                        "*",
                        s.value
                    ].includes(e1.tags[l]));
                if (c) {
                    const e1 = r(s, l);
                    let n = 0;
                    Object.entries(c.tags).forEach(([t, a])=>{
                        let r = a;
                        "*" === a && (r = this._meta.properties.semantics.find((e1)=>e1.key === l)?.value), i[t + "=" + r] = e1, n++;
                    }), a.push({
                        title: c.name,
                        icon: c.iconify || "fa6-solid:cube",
                        associatedTags: (s.qualifiers?.length || 0) + n,
                        tagGroup: {
                            semantics: e1
                        },
                        type: t
                    });
                } else o.push({
                    key: l,
                    value: s.value,
                    qualifiers: s.qualifiers
                });
            });
        }), o.length > 0 && a.push({
            title: this._parent?._t.pnx.semantics_features_default_title.replace("{nb}", i++),
            icon: "fa6-solid:tag",
            associatedTags: o.length,
            tagGroup: {
                semantics: o
            },
            type: t
        }), [
            a,
            i
        ];
    }
    _computeEntries() {
        let e1 = 1, t = [], i = [];
        this._seqMeta?.semantics?.length > 0 && ([t, e1] = this._getGroupedTags(this._seqMeta.semantics, "seqtags", e1, this._seqPresets)), this._meta.properties?.semantics?.length > 0 && ([i, e1] = this._getGroupedTags(this._meta.properties?.semantics, "pictags", e1, this._picPresets), t = t.concat(i)), t = t.concat(this._meta.properties?.annotations?.map((t)=>({
                title: this._annotPresets[t.id]?.name || this._parent?._t.pnx.semantics_features_default_title.replace("{nb}", e1++),
                icon: this._annotPresets[t.id]?.iconify || "fa6-solid:cube",
                associatedTags: t.semantics.filter((e1)=>"delete" !== e1.action).length,
                type: "annotation",
                annotation: t
            })) || []), this._entries = t;
    }
    _onListItemHover(e1) {
        "annotation" === e1?.type ? (this._prevPsvView || (this._prevPsvView = [
            this._parent.psv.getZoomLevel(),
            this._parent.psv.getPosition()
        ]), this._parent.psv.focusOnAnnotation(e1.annotation.id, void 0, !0)) : (this._parent.psv.unfocusAnnotation(), this._prevPsvView && (this._parent.psv.zoom(this._prevPsvView[0]), this._parent.psv.rotate(this._prevPsvView[1]), delete this._prevPsvView));
    }
    _onListItemClick(e1) {
        this._selectedEntry = e1, this._onListItemHover(e1), this.dispatchEvent(new CustomEvent("select", {
            detail: {
                item: e1
            }
        }));
    }
    _onItemEditClick(e1) {
        e1.stopPropagation(), this.dispatchEvent(new CustomEvent("edit-click", {
            detail: {
                item: this._selectedEntry
            }
        }));
    }
    _onItemDeleteClick(e1) {
        e1.stopPropagation(), this.dispatchEvent(new CustomEvent("delete-click", {
            detail: {
                item: this._selectedEntry
            }
        }));
    }
    render() {
        if (!this._meta) return $785da19a645c07eb$var$Z;
        if (this._selectedEntry) return $785da19a645c07eb$var$H`<div class="annotation">
				<pnx-list-item
					title=${this._selectedEntry.title}
					@click=${()=>this._onListItemClick(null)}
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$F1, {
            transform: {
                size: 24
            },
            attributes: {
                slot: "icon"
            }
        })}
					<iconify-icon
						slot="icon"
						icon=${this._selectedEntry.icon}
						style="font-size: 1.5em"
					></iconify-icon>

					<pnx-copy-button
						kind="superinline"
						text=${$785da19a645c07eb$var$$0((this._selectedEntry?.annotation || this._selectedEntry?.tagGroup)?.semantics)}
						slot="action"
						._t=${this._parent?._t}
						title=${this._parent?._t.pnx.semantics_copy}
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$i2, {
            transform: {
                size: 18
            }
        })}
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$d2, {
            attributes: {
                slot: "oncopy"
            },
            transform: {
                size: 18
            }
        })}
					</pnx-copy-button>

					${this.editable && "seqtags" !== this._selectedEntry.type ? $785da19a645c07eb$var$H`
						<pnx-button
							kind="superinline"
							title=${this._parent?._t.pnx.semantics_edit}
							slot="action"
							@click=${this._onItemEditClick}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$T1, {
            transform: {
                size: 18
            }
        })}
						</pnx-button>
						<pnx-button
							kind="superinline"
							title=${this._parent?._t.pnx.semantics_delete_annotation}
							slot="action"
							@click=${this._onItemDeleteClick}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$I1, {
            transform: {
                size: 18
            }
        })}
						</pnx-button>` : $785da19a645c07eb$var$Z}
				</pnx-list-item>
				<pnx-semantics-table
					._t=${this._parent?._t}
					.source=${"annotation" === this._selectedEntry?.type ? this._selectedEntry.annotation : this._selectedEntry.tagGroup}
				/>
			</div>`;
        if (this.editable || 0 !== (this._entries || []).length) {
            const e1 = {
                seqtags: this._parent?._t.pnx.semantics_sequence_tags,
                pictags: this._parent?._t.pnx.semantics_picture_tags,
                annotation: this._parent?._t.pnx.semantics_annotation_tags
            };
            return $785da19a645c07eb$var$H`<div class="list">
				${(this._entries || []).map((t)=>$785da19a645c07eb$var$H`
					<pnx-list-item
						title=${t.title}
						tooltip=${e1[t.type]}
						@click=${()=>this._onListItemClick(t)}
						@mouseover=${()=>this._onListItemHover(t)}
						@mouseout=${()=>this._onListItemHover(null)}
					>
						<iconify-icon
							slot="icon"
							icon=${t.icon}
							style="font-size: 1.5em"
						></iconify-icon>
						${t.associatedTags > 1 ? $785da19a645c07eb$var$H`
							<span slot="icon" class="pnx-badge-count">${t.associatedTags}</span>
						` : $785da19a645c07eb$var$Z}
						${"annotation" === t?.type ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$w1, {
                    transform: {
                        size: 20
                    },
                    styles: {
                        "margin-right": "20px"
                    },
                    attributes: {
                        slot: "action"
                    }
                }) : $785da19a645c07eb$var$Z}
						${"seqtags" === t?.type ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$G1, {
                    transform: {
                        size: 20
                    },
                    styles: {
                        "margin-right": "20px"
                    },
                    attributes: {
                        slot: "action"
                    }
                }) : $785da19a645c07eb$var$Z}
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$c2, {
                    transform: {
                        size: 20
                    },
                    attributes: {
                        slot: "action"
                    }
                })}
					</pnx-list-item>
				`)}
			</div>`;
        }
        return $785da19a645c07eb$var$H`<div class="info">${this._parent?._t.pnx.semantics_empty}</div>`;
    }
}
customElements.define("pnx-semantics-list", $785da19a645c07eb$var$M3);
const $785da19a645c07eb$var$C3 = "doing";
class $785da19a645c07eb$var$T3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$F2,
        $785da19a645c07eb$var$Z2,
        $785da19a645c07eb$var$o`
		.top-btns, pnx-semantics-list {
			font-size: 0.8em;
		}
		.top-btns {
			display: flex;
			margin: 5px 0;
			gap: 5px;
		}
		.top-btns > * {
			overflow: hidden;
		}
		.top-btns > *::part(btn) {
			height: unset;
		}
		.data-block {
			width: 100%;
		}
		.data-block h5 {
			justify-content: space-between;
		}
	`
    ];
    static properties = {
        _meta: {
            state: !0
        },
        _prevPSVPicNav: {
            state: !0
        },
        _authUrl: {
            state: !0
        },
        _showLinks: {
            state: !0
        },
        _addTag: {
            state: !0
        },
        _editTag: {
            state: !0
        },
        _addTagGeom: {
            state: !0
        },
        _editTagSem: {
            state: !0
        }
    };
    constructor(){
        super(), this._meta = {}, this._prevPSVPicNav = null, this._authUrl = null, this._showLinks = !0, this._addTag = !1, this._editTag = null, this._addTagGeom = null, this._editTagSem = null;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._meta = this._parent?.psv?.getPictureMetadata(), this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._meta = this._parent.psv.getPictureMetadata();
                }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                    const e1 = this.shadowRoot.querySelector("pnx-tabs");
                    e1 && e1.setAttribute("activeTabIndex", 4);
                });
                const e1 = setInterval(()=>{
                    $785da19a645c07eb$var$tt() && (clearInterval(e1), this.requestUpdate());
                }, 1e3);
            }), this._parent.getAPI().getAuthURL().then((e1)=>this._authUrl = e1);
        });
    }
    _blockPicChange(e1) {
        this._parent?.legend?.renderRoot.querySelector("pnx-picture-legend")?.blockOnEditing(e1), this._parent?.mini && (this._parent.mini.style.display = e1 ? "none" : null);
        const t = this._parent.renderRoot.querySelector("pnx-annotations-switch");
        t && (t.style.display = e1 ? "none" : null), e1 ? (this._prevPSVPicNav = this._parent.psv.getPicturesNavigation(), this._parent.psv.setPicturesNavigation("pic"), this._parent._disableKeyboard(), window.addEventListener("beforeunload", this._onBrowserQuit)) : (this._parent.psv.setPicturesNavigation(this._prevPSVPicNav), this._parent._enableKeyboard(), window.removeEventListener("beforeunload", this._onBrowserQuit));
    }
    _onBrowserQuit(e1) {
        e1.preventDefault(), e1.returnValue = !0;
    }
    _checkCanEdit() {
        const e1 = !this._meta.origInstance || this._parent?.api?._endpoint.startsWith(this._meta.origInstance.href);
        if (e1 && null !== $785da19a645c07eb$var$tt()) return !0;
        if (!e1 && confirm((this._parent?._t.pnx.semantics_login_needed || "").replace("{n}", this._meta.origInstance.instance_name || this._meta.origInstance.href))) window.location.href = this._meta.origInstance.href + window.location.search.replace(/&?nav=pic/, "");
        else {
            if (!e1 || !confirm((this._parent?._t.pnx.semantics_login_needed || "").replace("{n}", this._parent.getAPI()._metadata.name))) return !1;
            window.location.href = this._authUrl.replace("<CBURL>", encodeURIComponent(window.location.href));
        }
    }
    _startAddTag() {
        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !0, this._editTag = !1, this._addTagGeom = null, this._editTagSem = null, this._addTagGeomListener = (e1)=>{
            this.renderRoot.querySelector("#pnx-sem-editor")?.forceInput(), this._addTagGeom = e1.detail.shape;
        }, this._parent.psv.addEventListener("annotation-drawn", this._addTagGeomListener), this._parent.psv.addEventListener("annotation-drawing", ()=>this._addTagGeom = $785da19a645c07eb$var$C3), this._parent.psv.startDrawAnnotation());
    }
    _onTagSemChange(e1) {
        this._editTagSem = e1.detail;
    }
    _onSaveTag() {
        const e1 = this.renderRoot.querySelector("#pnx-sem-editor");
        e1 && e1.checkValidity() && this._editTagSem && this._editTagSem.delta && 0 !== this._editTagSem.delta.length ? "annotation" === this._editTag?.type ? this._parent?.api.editPictureAnnotation(this._editTag.annotation.id, this._editTagSem.delta).then((e1)=>{
            const t = this._meta.properties.annotations.findIndex((t)=>t.id === e1.id);
            this._meta.properties.annotations[t] = e1, this._onCancelEditTag(e1);
        }).catch((e1)=>{
            console.error("Can't send annotation", e1), this._onCancelEditTag(this._editTag.annotation), alert(this._parent?._t.pnx.semantics_send_fail);
        }) : this._addTag && this._addTagGeom === $785da19a645c07eb$var$C3 ? alert(this._parent?._t.pnx.semantics_draw_unfinished_annotation) : this._addTag && this._addTagGeom ? (this._parent.psv.fixDrawAnnotation(), this._parent?.api.createPictureAnnotation(this._meta, this._addTagGeom, this._editTagSem.delta).then((e1)=>{
            this._meta.properties.annotations.push(e1), this._onCancelEditTag(e1, !0);
        }).catch((e1)=>{
            console.error("Can't send annotation", e1), alert(this._parent?._t.pnx.semantics_send_fail), this._onCancelEditTag();
        })) : (this._addTag || this._editTag && "annotation" !== this._editTag.type) && this._parent?.api.sendPictureSemantics(this._meta, this._editTagSem.delta).then((e1)=>{
            this._meta.properties.semantics = e1.properties.semantics, this._onCancelEditTag(this._editTagSem.delta);
        }).catch((e1)=>{
            alert(this._parent?._t.pnx.semantics_send_fail), console.error("Can't send semantics", e1), this._onCancelEditTag();
        }) : e1.reportValidity();
    }
    _onEraseDrawnAnnotation() {
        this._parent.psv.stopDrawAnnotation(), this._addTagGeom = null, this._parent.psv.startDrawAnnotation();
    }
    _onEditTag(e1) {
        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !1, this._addTagGeom = null, this._editTagSem = "annotation" === e1.detail.item?.type ? {
            semantics: e1.detail.item.annotation.semantics
        } : e1.detail.item.tagGroup, this._editTag = e1.detail.item, "annotation" === e1.detail.item?.type && this._parent.psv.focusOnAnnotation(e1.detail.item.annotation.id, !0));
    }
    _onCancelEditTag(e1 = null, t = !1) {
        this.renderRoot.querySelector("#pnx-sem-editor").reset(), this._addTag = !1, this._addTagGeom = null, this._editTag = null, t || this._parent.psv.stopDrawAnnotation(), this._blockPicChange(!1), this.getUpdateComplete().then(()=>{
            const t = this.renderRoot.querySelector("#pnx-sem-list");
            e1 && t && (e1.id ? t.showAnnotation(e1.id) : t.showTagsGroup(e1));
        });
    }
    _onDeleteTag(e1) {
        if (this._checkCanEdit() && confirm(this._parent?._t.pnx.semantics_delete_annotation_confirm)) {
            const t = e1.detail.item;
            if ("annotation" === t?.type) this._parent?.api.deletePictureAnnotation(t.annotation.id).then(()=>{
                const e1 = Object.assign({}, this._meta);
                e1.properties.annotations = this._meta.properties.annotations.filter((e1)=>e1.id != t.annotation.id), this._meta = e1, this._parent.psv.toggleAllAnnotations(!0), this.renderRoot.querySelector("pnx-semantics-list")?._onPicChange();
            }).catch((e1)=>{
                console.error("Can't send annotation", e1), alert(this._parent?._t.pnx.semantics_send_fail);
            });
            else {
                const e1 = t.tagGroup.semantics.map((e1)=>Object.assign({
                        action: "delete"
                    }, e1));
                this._parent?.api.sendPictureSemantics(this._meta, e1).then((e1)=>{
                    this._meta.properties.semantics = e1.properties.semantics, this.renderRoot.querySelector("pnx-semantics-list")?._onPicChange();
                }).catch((e1)=>{
                    alert(this._parent?._t.pnx.semantics_send_fail), console.error("Can't send semantics", e1);
                });
            }
        }
    }
    render() {
        if (!this._meta?.properties) return;
        const e1 = !this._meta.origInstance && this._meta.permissions.edit_semantics, t = e1 || this._meta.origInstance && this._parent.api._endpoint.startsWith(this._meta.origInstance.href), i = e1 && (this._authUrl || null !== $785da19a645c07eb$var$tt());
        return $785da19a645c07eb$var$H`
			${this._addTag || this._editTag ? $785da19a645c07eb$var$H`
				<div class="data-block">
					<h5>
						${this._addTag ? this._parent?._t.pnx.semantics_add_annotation : this._parent?._t.pnx.semantics_edit}

						<pnx-button-group>
							<pnx-button
								kind="fullsuccess"
								style="margin-right: 3px"
								title=${this._parent?._t.pnx.semantics_save}
								@click=${this._onSaveTag}
							>
								${$785da19a645c07eb$var$ws($785da19a645c07eb$var$D1)}
							</pnx-button>
							<pnx-button
								kind="fullwarn"
								title=${this._parent?._t.pnx.semantics_undo}
								@click=${()=>this._onCancelEditTag(this._editTag?.annotation || this._editTag)}
							>
								${$785da19a645c07eb$var$ws($785da19a645c07eb$var$s2)}
							</pnx-button>
						</pnx-button-group>
					</h5>
					<div>
						${this._addTag ? this._parent?._t.pnx.semantics_draw_annotation : $785da19a645c07eb$var$Z}
						${this._addTag && this._addTagGeom ? $785da19a645c07eb$var$H`<pnx-button
								kind="full"
								style="margin-top: 5px; width: 100%"
								@click=${this._onEraseDrawnAnnotation}
							>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$Y1)} ${this._parent?._t.pnx.semantics_erase_annotation}
						</pnx-button>` : $785da19a645c07eb$var$Z}

						<pnx-semantics-editor
							id="pnx-sem-editor"
							style="display: block; margin-top: 5px"
							.semantics=${this._editTagSem?.semantics || []}
							._t=${this._parent._t}
							@change=${this._onTagSemChange}
						></pnx-semantics-editor>
					</div>
				</div>
			` : $785da19a645c07eb$var$H`
				${this._showLinks && t ? $785da19a645c07eb$var$H`
					<div class="top-btns">
						<pnx-button
							kind="full"
							size="md"
							style="flex: 2 1"
							@click=${this._startAddTag}
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$f1)} ${this._parent?._t.pnx.semantics_add_annotation}
						</pnx-button>
						<pnx-button
							kind="full"
							size="md"
							style="flex: 1 1"
							@click=${()=>this._parent?._showSemanticsDoc()}
						>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)} ${this._parent?._t.pnx.semantics_doc}</pnx-button>
					</div>
				` : $785da19a645c07eb$var$Z}

				<pnx-semantics-list
					id="pnx-sem-list"
					.editable=${i}
					@select=${(e1)=>this._showLinks = null == e1.detail.item}
					@edit-click=${this._onEditTag}
					@delete-click=${this._onDeleteTag}
					._parent=${this._parent}
				/>
			`}
		`;
    }
}
customElements.define("pnx-semantics-metadata", $785da19a645c07eb$var$T3);
class $785da19a645c07eb$var$D3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$B2,
        $785da19a645c07eb$var$R2,
        $785da19a645c07eb$var$N2,
        $785da19a645c07eb$var$o`
		div[slot="content"] {
			margin-top: 10px;
		}
		.links {
			display: flex;
			gap: 5px;
		}
		.embed {
			display: flex;
			gap: 5px;
			align-items: center;
			flex-direction: column;
		}
	`
    ];
    static properties = {
        _url: {
            state: !0
        },
        "base-url": {
            type: String
        }
    };
    constructor(){
        super(), this._onUrlChange();
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            this._onUrlChange(), this._parent.urlHandler.addEventListener("url-changed", this._onUrlChange.bind(this));
        });
    }
    _onUrlChange() {
        const e1 = (this["base-url"] || window.location.href).replace(/\/$/, "");
        this._url = this._parent?.urlHandler?.nextShortLink(e1) || e1;
    }
    render() {
        const e1 = `<iframe src="${this._url}" style="border: none; width: 500px; height: 300px"></iframe>`;
        return $785da19a645c07eb$var$H`
			<h4>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$d1)} ${this._parent?._t.pnx.share}</h4>
			<pnx-tabs>
				<h4 slot="title">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$J1)} ${this._parent?._t.pnx.share_page}</h4>
				<div slot="content">
					<div class="links">
						<input type="text" readonly value=${this._url} style="flex: 2" />
						<pnx-copy-button ._t=${this._parent?._t} text=${this._url}></pnx-copy-button>
					</div>
				</div>

				<h4 slot="title">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$o2)} ${this._parent?._t.pnx.share_embed}</h4>
				<div slot="content">
					<div class="embed">
						<pnx-link-button
							href="https://docs.panoramax.fr/web-viewer/03_URL_settings/"
							target="_blank"
							kind="superinline"
							size="sm"
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$R1)} ${this._parent?._t.pnx.share_embed_docs}
						</pnx-link-button>
						<textarea readonly .value=${e1}></textarea>
						<pnx-copy-button
							._t=${this._parent?._t}
							text=${e1}
							style="width: 100%"
						></pnx-copy-button>
					</div>
				</div>
			</pnx-tabs>
			<slot name="extra"></slot>`;
    }
}
customElements.define("pnx-share-menu", $785da19a645c07eb$var$D3);
var $785da19a645c07eb$var$P3 = Object.freeze({
    __proto__: null,
    LocationPrecisionDoc: $785da19a645c07eb$var$X2,
    MapBackground: $785da19a645c07eb$var$Q2,
    MapFilters: $785da19a645c07eb$var$Y2,
    MapLayers: $785da19a645c07eb$var$J2,
    MapLegend: $785da19a645c07eb$var$$2,
    MapTheme: $785da19a645c07eb$var$e3,
    MiniPictureLegend: $785da19a645c07eb$var$t3,
    PictureLegend: $785da19a645c07eb$var$g3,
    PictureMetadata: $785da19a645c07eb$var$A3,
    PlayerOptions: $785da19a645c07eb$var$y3,
    QualityScoreDoc: $785da19a645c07eb$var$x3,
    ReportForm: $785da19a645c07eb$var$w3,
    SemanticsDoc: $785da19a645c07eb$var$E3,
    SemanticsDownload: $785da19a645c07eb$var$k3,
    SemanticsFilters: $785da19a645c07eb$var$S3,
    SemanticsList: $785da19a645c07eb$var$M3,
    SemanticsMetadata: $785da19a645c07eb$var$T3,
    Share: $785da19a645c07eb$var$D3
});
class $785da19a645c07eb$var$I3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		.pnx-panel {
			padding: 5px;
			margin-top: 5px;
			width: max-content;
  			min-width: unset;
		}

		/* Custom button look */
		pnx-button::part(btn) {
			border-radius: 8px;
			height: 26px;
			width: 26px;
		}

		pnx-button[size="xl"]::part(btn) {
			border-radius: 8px;
			height: 38px;
			width: 38px;
		}

		pnx-button[active]::part(btn),
		pnx-button[active]:hover::part(btn) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}

		/* No-annotations badge */
		.pnx-annotations-switch-empty {
			position: absolute;
			top: 1px;
			right: 1px;
			color: var(--orange);
			height: 8px;
		}

		pnx-button[size="xl"] .pnx-annotations-switch-empty {
			top: 2px;
			right: 2px;
			height: 12px;
		}

		pnx-button[active] .pnx-annotations-switch-empty {
			color: var(--yellow);
		}
	`
    ];
    static properties = {
        size: {
            type: String
        },
        _annotationsToggled: {
            state: !0
        },
        _warnNoAnnot: {
            state: !0
        },
        _warnNoAnnotTooltip: {
            state: !0
        }
    };
    constructor(){
        super(), this._annotationsToggled = !1, this._warnNoAnnot = !1, this._warnNoAnnotTooltip = !1, this.size = "xl";
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._parent.onceReady().then(()=>{
                this._parent.psv.addEventListener("annotations-toggled", (e1)=>{
                    this._annotationsToggled = e1.detail.visible, this._persistAnnotationsLocalStorage(this._annotationsToggled);
                }), this._warnNoAnnot = !$785da19a645c07eb$var$wO(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                    this._warnNoAnnot = !$785da19a645c07eb$var$wO(this._parent.psv.getPictureMetadata());
                });
            }), this._parent.onceFirstPicLoaded().then(()=>{
                this._annotationsToggled = this._parent.psv.areAnnotationsVisible() || !1, this._persistAnnotationsLocalStorage(this._annotationsToggled);
            });
        });
    }
    _persistAnnotationsLocalStorage(e1) {
        localStorage.setItem($785da19a645c07eb$var$Me, e1 ? "false" : "true");
    }
    _onClick() {
        !this._annotationsToggled && this._warnNoAnnot && (this._warnNoAnnotTooltip = !0, setTimeout(()=>this._warnNoAnnotTooltip = !1, 2e3)), this._persistAnnotationsLocalStorage(!this._annotationsToggled), this._parent.psv.toggleAllAnnotations(!this._annotationsToggled);
    }
    render() {
        const e1 = {
            "pnx-panel": !0,
            "pnx-hidden": !this._warnNoAnnotTooltip
        };
        return $785da19a645c07eb$var$H`
			<pnx-button
				kind="superflat"
				size=${this.size}
				style="vertical-align: middle"
				class="pnx-print-hidden"
				title=${this._annotationsToggled ? this._parent._t?.pnx.semantics_hide_annotations : this._parent._t?.pnx.semantics_show_annotations}
				active=${this._annotationsToggled ? "" : $785da19a645c07eb$var$Z}
				@click=${this._onClick}
			>
				${$785da19a645c07eb$var$ws($785da19a645c07eb$var$C1, {
            styles: {
                height: "20px"
            }
        })}
				${this._warnNoAnnot ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$g2, {
            classes: "pnx-annotations-switch-empty"
        }) : $785da19a645c07eb$var$Z}
			</pnx-button>
			<div
				class=${$785da19a645c07eb$var$w2(e1)}
				@click=${()=>this._warnNoAnnotTooltip = !1}
			>
				${this._parent._t?.pnx.semantics_zero_annotations}
			</div>
		`;
    }
}
customElements.define("pnx-annotations-switch", $785da19a645c07eb$var$I3);
const $785da19a645c07eb$var$F3 = new CSSStyleSheet;
$785da19a645c07eb$var$F3.replaceSync('/* Also defined in styles.js */\n\npnx-button-group > pnx-button {\n\tdisplay: inline-flex;\n}\n\npnx-button-group > pnx-button::part(btn) {\n\theight: unset;\n}\n\n/* Togglable in group */\npnx-button-group > pnx-togglable-group > pnx-button {\n\twidth: 100%;\n\theight: 100%;\n}\n\n/* Row */\npnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),\npnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {\n\tborder-radius: 0;\n\tborder-left: none;\n\tborder-right: none;\n}\n\npnx-button-group[dir="row"] > :first-child::part(btn),\npnx-button-group[dir="row"] > :first-child > ::part(btn) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n\tborder-right: none;\n}\n\npnx-button-group[dir="row"] > :last-child::part(btn),\npnx-button-group[dir="row"] > :last-child > ::part(btn) {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n\tborder-left: none;\n}\n\n/* Column */\npnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),\npnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {\n\tborder-radius: 0;\n\tborder-top: none;\n\tborder-bottom: none;\n}\n\npnx-button-group[dir="column"] > :first-child::part(btn),\npnx-button-group[dir="column"] > :first-child > ::part(btn) {\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom: none;\n}\n\npnx-button-group[dir="column"] > :last-child::part(btn),\npnx-button-group[dir="column"] > :last-child > ::part(btn) {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n\tborder-top: none;\n}\n'), document.adoptedStyleSheets.push($785da19a645c07eb$var$F3);
class $785da19a645c07eb$var$z3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		div {
			display: flex;
			flex-wrap: nowrap;
			align-items: stretch;
			align-content: stretch;
			justify-content: center;
		}

		div.row { flex-direction: row; }
		div.column { flex-direction: column; }

		div.xl { line-height: 38px; font-size: 20px; }
		div.row.xl { height: 38px; }
		div.column.xl { width: 38px; }

		div.row ::slotted(*) { height: 100%; min-width: 24px; }
		div.column ::slotted(*) { width: 100%; min-height: 24px; }

		div.row.xl ::slotted(*) { min-width: 38px; }
		div.column.xl ::slotted(*) { min-height: 38px; }
	`;
    static properties = {
        dir: {
            type: String
        },
        size: {
            type: String
        }
    };
    constructor(){
        super(), this.dir = "row", this.size = "md";
    }
    render() {
        return $785da19a645c07eb$var$H`<div class="${this.dir} ${this.size}" part="btn-group">
			<slot></slot>
		</div>`;
    }
}
customElements.define("pnx-button-group", $785da19a645c07eb$var$z3);
class $785da19a645c07eb$var$R3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$O2;
    static properties = {
        active: {
            type: Boolean
        },
        kind: {
            type: String
        },
        size: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        type: {
            type: String
        },
        title: {
            type: String
        }
    };
    constructor(){
        super(), this.active = !1, this.disabled = !1, this.kind = "full", this.size = "md";
    }
    connectedCallback() {
        super.connectedCallback(), "submit" === this.type && this.addEventListener("click", ()=>this.closest("FORM")?.requestSubmit());
    }
    render() {
        const e1 = document.createElement("button");
        e1.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((e1)=>void 0 !== this[e1] && !1 !== this[e1] && ![
                "active",
                "kind",
                "size"
            ].includes(e1)).forEach((t)=>e1.setAttribute(t, this[t])), e1.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`), this.active && e1.classList.add("pnx-btn-active");
        const t = document.createElement("slot");
        return e1.appendChild(t), e1;
    }
}
customElements.define("pnx-button", $785da19a645c07eb$var$R3);
class $785da19a645c07eb$var$L3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$O2,
        $785da19a645c07eb$var$o`
		.pnx-btn-unstyled {
			border: none;
			background: none;
			font-family: var(--font-family);
			font-size: 1em;
			color: var(--widget-font);
			cursor: pointer;
			padding: 0;
			margin: 0;
		}
	`
    ];
    static properties = {
        text: {
            type: String
        },
        input: {
            type: String
        },
        kind: {
            type: String
        },
        size: {
            type: String
        },
        unstyled: {
            type: Boolean
        },
        title: {
            type: String
        },
        _active: {
            state: !0,
            type: Boolean
        }
    };
    constructor(){
        super(), this.data = "", this.input = "", this.unstyled = !1, this.kind = "full", this.size = "md", this._active = !1, this.addEventListener("click", this._onClick);
    }
    _onClick(e1) {
        let t;
        if (e1.stopPropagation(), "" !== this.input) {
            const e1 = document.getElementById(this.input);
            t = e1.innerText || e1.value;
        } else "" !== this.text && (t = this.text);
        navigator?.clipboard ? (navigator.clipboard.writeText(t), this._active = !0, setTimeout(()=>this._active = !1, 2e3)) : alert("Clipboard is not available");
    }
    render() {
        const e1 = {
            "pnx-btn": !this.unstyled,
            "pnx-btn-full": !this.unstyled,
            "pnx-btn-active": !this.unstyled && this._active,
            "pnx-btn-unstyled": this.unstyled,
            [`pnx-btn-${this.kind}`]: !this.unstyled,
            [`pnx-btn-${this.size}`]: !this.unstyled
        };
        return $785da19a645c07eb$var$H`<button title=${this.title} class=${$785da19a645c07eb$var$w2(e1)} part="btn">
			${this._active ? $785da19a645c07eb$var$H`<slot name="oncopy">${this._t?.pnx.copied || ""} ${$785da19a645c07eb$var$ws($785da19a645c07eb$var$d2)}</slot>` : $785da19a645c07eb$var$H`<slot>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$i2)} ${this._t?.pnx.copy || ""}</slot>`}
		</button>`;
    }
}
customElements.define("pnx-copy-button", $785da19a645c07eb$var$L3);
class $785da19a645c07eb$var$B3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$o`
		span { color: var(--orange); }
	`
    ];
    static properties = {
        stars: {
            type: Number
        }
    };
    constructor(){
        super(), this.stars = 0;
    }
    render() {
        const e1 = this.stars || 0, t = [];
        for(let i = 1; i <= e1; i++)t.push($785da19a645c07eb$var$ws($785da19a645c07eb$var$g1));
        for(let i = e1 + 1; i <= 5; i++)t.push($785da19a645c07eb$var$ws($785da19a645c07eb$var$v3));
        return $785da19a645c07eb$var$H`<span>
			${t}
		</span> (${this.stars ? this.stars + "/5" : this._t?.pnx.metadata_quality_missing || "?"})`;
    }
}
customElements.define("pnx-grade", $785da19a645c07eb$var$B3);
class $785da19a645c07eb$var$O3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			gap: 0;
			align-items: stretch;
			display: flex;
		}
		label {
			display: inline-flex;
			padding: 2px 7px;
			background: none;
			border: 1px solid var(--widget-border-btn);
			color: var(--widget-font-direct);
			cursor: pointer;
			font-size: 16px;
			text-decoration: none;
			border-left-width: 0px;
		}
		label:hover {
			background-color: var(--widget-bg-hover);
		}
		label:first-of-type {
			border-top-left-radius: 8px;
			border-bottom-left-radius: 8px;
			border-left-width: 1px;
		}
		label:last-of-type {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		label svg {
			display: block;
			width: 0.8em;
		}
		input[type="checkbox"] { display: none; }
		input[type="checkbox"]:checked + label {
			background-color: var(--widget-bg-active);
			color: var(--widget-font-active);
		}
		input[type="checkbox"]:checked + label:first-of-type {
			border-right-color: white;
		}
	`;
    static properties = {
        grade: {
            type: String
        },
        input: {
            type: String
        },
        labels: {
            type: Object
        }
    };
    constructor(){
        super(), this.grade = 0, this.input = "", this.labels = {};
    }
    _onInput() {
        const e1 = [];
        for (let t of this.renderRoot.querySelectorAll("input"))t.checked && e1.push(t.value);
        this.grade = e1.join(","), this.dispatchEvent(new CustomEvent("change", {
            bubbles: !0,
            composed: !0
        }));
    }
    render() {
        const e1 = `${this.grade}`.split(",").map((e1)=>parseInt(e1)).filter((e1)=>!isNaN(e1));
        return [
            5,
            4,
            3,
            2,
            1
        ].map((t)=>$785da19a645c07eb$var$H`
			<input
				id="${this.input}-${t}"
				type="checkbox"
				name=${this.input}
				value=${t}
				@change="${this._onInput}"
				.checked=${e1.includes(t)}
			/>
			<label
				for="${this.input}-${t}"
				title=${this.labels?.[t] ? this.labels[t] : null}
			>
				${t} ${$785da19a645c07eb$var$ws($785da19a645c07eb$var$g1)}
			</label>
		`);
    }
}
customElements.define("pnx-grade-filter", $785da19a645c07eb$var$O3);
class $785da19a645c07eb$var$U3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		.toggle {
			cursor: pointer;
			display: flex;
			align-items: flex-start;
			justify-content: center;
		}

		.toggle-switch {
			display: inline-block;
			background: var(--widget-option-left);
			border-radius: 11px;
			width: 42px;
			min-width: 42px;
			max-width: 42px;
			height: 22px;
			min-height: 22px;
			max-height: 22px;
			position: relative;
			vertical-align: middle;
			transition: background 0.25s;
			flex: 1;
		}
		.toggle-switch:before, .toggle-switch:after {
			content: "";
		}
		.toggle-switch:before {
			display: block;
			background: linear-gradient(to bottom, #fff 0%, #eee 100%);
			border-radius: 50%;
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
			width: 16px;
			height: 16px;
			position: absolute;
			top: 3px;
			left: 3px;
			transition: left 0.25s;
		}
		.toggle:hover .toggle-switch:before {
			background: linear-gradient(to bottom, #fff 0%, #fff 100%);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
		}
		.toggle-checkbox:checked + .toggle-switch {
			background: var(--widget-option-right);
		}
		.toggle-checkbox:disabled + .toggle-switch:before,
		.toggle-checkbox:disabled:hover + .toggle-switch:before {
			background: var(--grey-pale);
			box-shadow: none;
		}
		.toggle-checkbox:disabled + .toggle-switch {
			background: var(--grey);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
		}
		.toggle-checkbox:checked + .toggle-switch:before {
			left: 22px;
		}

		.toggle-icon {
			pointer-events: none;
			height: 22px;
			width: 22px;
			position: absolute;
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 11px;
			font-size: 11px;
			opacity: 1;
			transition: opacity 0.15s 0.1s;
		}

		.toggle-icon.icon-left {
			left: 0;
			color: var(--widget-option-left);
		}
		.toggle-icon.icon-right {
			right: 0;
			color: var(--widget-option-right);
		}

		.toggle-checkbox:checked + .toggle-switch .toggle-icon.icon-left,
		.toggle-checkbox:not(:checked) + .toggle-switch .toggle-icon.icon-right {
			opacity: 0;
			transition: opacity 0s;
		}

		.toggle-checkbox {
			position: absolute;
			visibility: hidden;
		}

		.toggle-label {
			margin-left: 5px;
			margin-right: 5px;
			position: relative;
			flex: 2;
			text-align: center;
			font-size: 0.9em;
			line-height: 22px;
		}
	`;
    static properties = {
        checked: {
            type: Boolean,
            reflect: !0
        },
        disabled: {
            type: Boolean,
            reflect: !0
        },
        name: {
            type: String
        }
    };
    constructor(){
        super(), this.checked = !1, this.disabled = !1, this.name = "pnx-icon-switch-1";
    }
    _onChange(e1) {
        this.checked = e1.target.checked, this.dispatchEvent(new Event("change"));
    }
    render() {
        return $785da19a645c07eb$var$H`
			<label class="toggle" for=${this.name}>
				<span class="toggle-label">
					<slot name="label-left"></slot>
				</span>
				<input
					class="toggle-checkbox"
					type="checkbox"
					id=${this.name}
					name=${this.name}
					.checked=${this.checked}
					.disabled=${this.disabled}
					@change=${this._onChange.bind(this)}
				/>
				<div class="toggle-switch">
					<span class="toggle-icon icon-left">
						<slot name="icon-left"></slot>
					</span>
					<span class="toggle-icon icon-right">
						<slot name="icon-right"></slot>
					</span>
				</div>
				<span class="toggle-label">
					<slot name="label-right"></slot>
				</span>
			</label>
		`;
    }
}
customElements.define("pnx-icon-switch", $785da19a645c07eb$var$U3);
class $785da19a645c07eb$var$N3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$O2;
    static properties = {
        href: {
            type: String
        },
        target: {
            type: String
        },
        title: {
            type: String
        },
        download: {
            type: String
        },
        class: {
            type: String
        },
        kind: {
            type: String
        },
        size: {
            type: String
        }
    };
    constructor(){
        super(), this.kind = "full", this.size = "md";
    }
    render() {
        const e1 = document.createElement("a");
        e1.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((e1)=>void 0 !== this[e1]).forEach((t)=>e1.setAttribute(t, this[t])), e1.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`);
        const t = document.createElement("slot");
        return e1.appendChild(t), e1;
    }
}
customElements.define("pnx-link-button", $785da19a645c07eb$var$N3);
class $785da19a645c07eb$var$j3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		:host ::slotted(*) {
			text-decoration: none;
			border: none;
			border-bottom: 1px solid var(--widget-border-div);
			background: none;
			display: block;
			width: 100%;
			color: var(--widget-font);
			font-family: var(--font-family);
			cursor: pointer;
			font-size: 1em;
			font-weight: 400;
			line-height: 18px;
			padding: 5px 10px;
  			min-width: 150px;
			width: 100%;
			text-align: left;
			box-sizing: border-box;
		}

		:host ::slotted(*:hover) {
			background-color: var(--widget-bg-hover);
		}

		:host ::slotted(*:first-child) {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		:host ::slotted(*:last-child) {
			border: none;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	`
    ];
    render() {
        return $785da19a645c07eb$var$H`<slot></slot>`;
    }
}
customElements.define("pnx-list-group", $785da19a645c07eb$var$j3);
class $785da19a645c07eb$var$V3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		.list-item {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			font-family: var(--font-family);
			background: var(--white);
			min-height: 40px;
			box-sizing: border-box;
		}
		.list-item:hover { background: var(--widget-bg-hover); }
		.icon {
			margin-right: 16px;
			display: flex;
			align-items: center;
			gap: 10px;
			position: relative;
		}
		.action {
			margin-left: 16px;
			display: flex;
  			gap: 5px;
		}
		.content {
			flex: 1;
		}
		.title {
			font-weight: 600;
		}
		.subtitle {
			font-size: 0.9em;
			color: var(--grey-dark);
		}
	`;
    static properties = {
        title: {
            type: String
        },
        subtitle: {
            type: String
        },
        tooltip: {
            type: String
        }
    };
    render() {
        return $785da19a645c07eb$var$H`
			<div class="list-item" title=${this.tooltip}>
				<div class="icon">
					<slot name="icon"></slot>
				</div>
				<div class="content">
					<div class="title">${this.title}</div>
					<div class="subtitle">${this.subtitle}</div>
				</div>
				<div class="action">
					<slot name="action"></slot>
				</div>
			</div>
		`;
    }
}
customElements.define("pnx-list-item", $785da19a645c07eb$var$V3);
class $785da19a645c07eb$var$q3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			position: absolute;
			inset: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 10px;
			align-items: center;
			background-image: url('${$785da19a645c07eb$var$s($785da19a645c07eb$var$g0)}');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			z-index: 200;
			font-family: var(--font-family);
			font-weight: 550;
			color: var(--black);
			font-size: 1.4em;
			text-align: center;
			visibility: hidden;
			opacity: 0;
		}
		:host(*[visible]) {
			visibility: visible;
			opacity: 1;
		}

		div.label {
			background-color: rgba(255,255,255,0.5);
			box-shadow: white 0 0 10px;
			padding: 3px 10px;
			border-radius: 50px;
		}
		/* Logo */
		img.logo-dead { width: 100px; }
	`;
    static properties = {
        _mode: {
            state: !0
        },
        _label: {
            state: !0
        },
        _isLabelFun: {
            state: !0
        },
        visible: {
            type: Boolean,
            reflect: !0
        },
        "no-label": {
            type: Boolean
        },
        value: {
            type: Number
        }
    };
    constructor(){
        super(), this.visible = !0, this["no-label"] = !1, this._mode = "loading", this._isLabelFun = !1, this.value = -1;
    }
    connectedCallback() {
        super.connectedCallback(), this._nextLabel();
    }
    isVisible() {
        return this.visible;
    }
    dismiss(e1 = null, t = null, i = null) {
        if (clearTimeout(this._loaderLabelChanger), e1) {
            !0 !== e1 && console.error(e1);
            let n = [
                this._parent?._t.pnx.error,
                $785da19a645c07eb$var$H`<br />`
            ];
            t && n.push(t, $785da19a645c07eb$var$H`<br />`), i ? (n.push($785da19a645c07eb$var$H`<pnx-button kind="full">${this._parent?._t.pnx.error_click}</pnx-button>`), this.addEventListener("click", i)) : n.push($785da19a645c07eb$var$H`<small>${this._parent?._t.pnx.error_retry}</small>`), this._mode = "error", this._label = n;
            const a = t || "Panoramax JS had a blocking exception", r = new CustomEvent("broken", {
                detail: {
                    error: a
                }
            });
            throw this._parent.dispatchEvent(r), new Error(a);
        }
        {
            this.value = 100, this._mode = "done", this.visible = !1, this.style.transition = "all 0.5s", setTimeout(()=>{
                this.parentNode && this.parentNode.removeChild(this);
            }, 2e3);
            const e1 = new CustomEvent("ready");
            this._parent.dispatchEvent(e1), i && i();
        }
    }
    _nextLabel() {
        this._isLabelFun ? this._label = this._parent?._t.pnx.loading_labels_fun[$785da19a645c07eb$var$it(0, this._parent?._t.pnx.loading_labels_fun.length - 1)] : (this._label = this._parent?._t.pnx.loading_labels_serious[$785da19a645c07eb$var$it(0, this._parent?._t.pnx.loading_labels_serious.length - 1)], this._isLabelFun = !0), this._loaderLabelChanger = setTimeout(this._nextLabel.bind(this), $785da19a645c07eb$var$it(500, 1500));
    }
    render() {
        return "error" === this._mode ? $785da19a645c07eb$var$H`
				<img class="logo-dead" src=${$785da19a645c07eb$var$m0} alt="" title=${this._parent?._t.map.loading} />
				${this._label}
			` : $785da19a645c07eb$var$H`
			<pnx-progress-bar .value=${this.value}></pnx-progress-bar>
			${this["no-label"] ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`<div class="label">${this._label}</div>`}
		`;
    }
}
customElements.define("pnx-loader", $785da19a645c07eb$var$q3);
class $785da19a645c07eb$var$G3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$o`
		/* Backdrop */
		:host {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: all 0.2s;
			background: rgba(0, 0, 0, 0.85);
		}
		:host(*[visible]) {
			opacity: 1;
			visibility: visible;
			pointer-events: unset;
			z-index: 200;
		}

		/* Content backgroud */
		.pnx-panel {
			box-sizing: border-box;
			position: relative;
			width: 90%;
			max-height: 90%;
			max-width: 400px;
			overflow-y: auto;
		}

		.btn-close {
			position: absolute;
			top: 15px;
			right: 15px;
		}
	`
    ];
    static properties = {
        visible: {
            type: Boolean,
            reflect: !0
        }
    };
    constructor(){
        super(), this.visible = !1;
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("click", (e1)=>{
            e1.target === this && this.close();
        }), document.addEventListener("keyup", (e1)=>{
            "Escape" === e1.key && this.visible && this.close();
        });
    }
    attributeChangedCallback(e1, t, i) {
        super.attributeChangedCallback(e1, t, i), "visible" === e1 && ("" !== i && !0 !== i || this.dispatchEvent(new Event("open")));
    }
    close() {
        this.visible = !1, this.dispatchEvent(new Event("close"));
    }
    render() {
        return $785da19a645c07eb$var$H`
			<div class="pnx-panel pnx-padded">
				<pnx-button
					class="btn-close"
					kind="inline"
					size="l"
					@click=${this.close.bind(this)}
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$r2)}
				</pnx-button>

				<slot></slot>
			</div>
		`;
    }
}
customElements.define("pnx-popup", $785da19a645c07eb$var$G3);
class $785da19a645c07eb$var$H3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		progress {
			max-width: 80vh;
			width: 300px;
			height: 16px;
			appearance: none;
			-webkit-appearance: none;
			border: 1px solid var(--grey-semi-dark);
			background-color: var(--grey);
			border-radius: 8px;
			overflow: hidden;
			padding: 3px;
			box-sizing: border-box;
			display: block;
		}

		progress::-webkit-progress-bar {
			background-color: var(--grey);
		}

		/* Don't merge with -moz below, for some f*ing reason a list selector doesn't work with Chrome */
		progress::-webkit-progress-value {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress::-moz-progress-bar {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress[value=""]::-moz-progress-bar,
		progress:not([value])::-moz-progress-bar {
			animation: indeterminateAnimation 1.5s infinite linear;
		}

		progress.indeterminate {
			position: relative;
			background-color: var(--grey);
			overflow: hidden;
		}

		progress.indeterminate::after {
			content: "";
			position: absolute;
			left: 3px;
			top: 3px;
			bottom: 3px;
			width: 20%;
			background-color: var(--blue);
			border-radius: 5px;
			animation: indeterminateAnimation 1.5s infinite linear;
			pointer-events: none;
		}

		@keyframes indeterminateAnimation {
			0%   { margin-left: 0%; width: 2%; }
			15%  { margin-left: 0%; width: 20%; }
			50%  { margin-left: 40%; width: 20%; }
			85%  { margin-left: 80%; width: 20%; }
			100% { margin-left: 98%; width: 2%; }
		}
	`;
    static properties = {
        value: {
            type: Number
        }
    };
    render() {
        return $785da19a645c07eb$var$H`
			<progress
				value=${this.value >= 0 ? this.value : $785da19a645c07eb$var$Z}
				class=${this.value >= 0 ? $785da19a645c07eb$var$Z : "indeterminate"}
				max="100"
				title=${this._t?.map.loading}
			></progress>
		`;
    }
}
customElements.define("pnx-progress-bar", $785da19a645c07eb$var$H3);
class $785da19a645c07eb$var$W3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		:host {
			gap: 0px;
			justify-content: center;
			height: 2em;
			font-size: 18px;
			display: inline-flex;
			align-items: center;
			color: white;
		}

		/* Single letter */
		span, label {
			width: 1.2em;
			height: 1.5em;
			line-height: 1.5em;
			display: inline-block;
			border: 0.05em solid white;
			text-align: center;
			background-color: gray;
			color: rgba(255,255,255,0.9);
			font-family: var(--font-family);
			font-weight: 800;
			vertical-align: middle;
		}

		/* Rounded corners for first/last */
		span:first-of-type, label:first-of-type {
			border-top-left-radius: 0.4em;
			border-bottom-left-radius: 0.4em;
		}

		span:last-of-type, label:last-of-type {
			border-top-right-radius: 0.4em;
			border-bottom-right-radius: 0.4em;
		}

		/* Selected letter */
		.selected, input[type="checkbox"]:checked + label {
			font-size: 1.3em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		/* Clickable letter for input */
		label { cursor: pointer; }

		label:hover {
			font-size: 1.2em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		input[type="checkbox"] { display: none; }
	`;
    static properties = {
        grade: {
            type: String,
            reflect: !0
        },
        input: {
            type: String
        }
    };
    constructor(){
        super(), this.grade = 0, this.input = !1;
    }
    _onInput() {
        const e1 = [];
        for (let t of this.renderRoot.querySelectorAll("input"))t.checked && e1.push(t.value);
        this.grade = e1.join(","), this.dispatchEvent(new CustomEvent("change", {
            bubbles: !0,
            composed: !0
        }));
    }
    render() {
        const e1 = `${this.grade}`.split(",").map((e1)=>parseInt(e1)).filter((e1)=>!isNaN(e1));
        return this.input ? $785da19a645c07eb$var$Pe.map((t, i)=>$785da19a645c07eb$var$H`
				<input
					id="${this.input}-${t.label}"
					type="checkbox"
					name="qualityscore"
					value="${5 - i}"
					@change="${this._onInput}"
					.checked=${e1.includes(5 - i)}
				/>
				<label
					for="${this.input}-${t.label}"
					title="${this._t?.pnx.filter_qualityscore_help}"
					style="background-color: ${t.color}"
				>
					${t.label}
				</label>
			`) : $785da19a645c07eb$var$Pe.map((t, i)=>$785da19a645c07eb$var$H`
				<span class="${e1.includes(5 - i) ? "selected" : ""}" style="background-color: ${t.color}">
					${t.label}
				</span>
			`);
    }
}
customElements.define("pnx-quality-score", $785da19a645c07eb$var$W3);
const $785da19a645c07eb$var$Z3 = new CSSStyleSheet;
$785da19a645c07eb$var$Z3.replaceSync("/* Search results */\n.sb-results {\n\tposition: fixed;\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tmax-width: calc(100% - 20px);\n\tborder: 1px solid var(--widget-border-div);\n\tborder-radius: 10px;\n\tbackground-color: var(--widget-bg);\n\tcolor: var(--widget-font);\n\tz-index: 130;\n\tfont-size: 1.05em;\n\tline-height: normal;\n\tfont-family: var(--font-family);\n\tmax-height: 30vh;\n\toverflow-y: auto;\n}\n.sb-result,\n.sb-empty {\n\tdisplay: block;\n\tpadding: 5px 15px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tcursor: pointer;\n\tborder-radius: 0;\n}\n.sb-result:hover {\n\tbackground-color: var(--widget-bg-hover);\n}\n.sb-result:first-child {\n\tborder-top-right-radius: 10px;\n\tborder-top-left-radius: 10px;\n\tpadding-top: 15px;\n}\n.sb-result:last-child {\n\tborder-bottom-right-radius: 10px;\n\tborder-bottom-left-radius: 10px;\n\tpadding-bottom: 15px;\n}"), document.adoptedStyleSheets.push($785da19a645c07eb$var$Z3);
class $785da19a645c07eb$var$K3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$z2,
        $785da19a645c07eb$var$o`
		/* Container */
		.sb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			border: 1px solid var(--widget-border-div);
			border-radius: 5px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			height: 30px;
			border-radius: 20px;
			position: relative;
			padding: 0 0 0 10px;
			width: fit-content;
			max-width: 100%;
			box-sizing: border-box;
			font-family: var(--font-family);
		}
		.sb.sb-xxl {
			height: 40px;
			line-height: 40px;
		}
		.sb.sb-reduceable {
			width: 360px;
		}
		.sb.sb-reduceable.sb-reduced {
			width: fit-content;
			padding: 0;
			gap: 0;
		}

		/* Text field */
		.sb input {
			background: none;
			border: none !important;
			outline: none;
			height: 20px;
			width: 100%;
			font-family: var(--font-family);
		}
		.sb.sb-xxl input {
			font-size: 1.1em;
		}
		.sb.sb-reduceable.sb-reduced input {
			display: none;
		}

		/* Status icon */
		.sb-icon {
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			width: 30px;
			min-width: 30px;
			text-align: center;
		}
		.sb.sb-xxl .sb-icon {
			height: 40px;
			line-height: 40px;
			width: 40px;
			min-width: 40px;
		}
		.sb-icon svg {
			pointer-events: none;
			width: 14px;
			height: 14px;
		}
	`
    ];
    static properties = {
        id: {
            type: String
        },
        placeholder: {
            type: String
        },
        reduceable: {
            type: Boolean,
            reflect: !0
        },
        reduced: {
            type: Boolean,
            reflect: !0
        },
        value: {
            type: String
        },
        size: {
            type: String
        },
        _icon: {
            state: !0
        },
        _results: {
            state: !0
        },
        searcher: {
            type: Function
        },
        "no-menu-closure": {
            type: Boolean
        },
        "keep-on-menu-closure": {
            type: Boolean
        }
    };
    constructor(){
        super(), this.reduceable = !1, this.reduced = !1, this.placeholder = $785da19a645c07eb$var$Z, this.size = "md", this._icon = "search", this._results = null, this["no-menu-closure"] = !1, this["keep-on-menu-closure"] = !1, this._throttler = null, delete this._lastSearch;
    }
    attributeChangedCallback(e1, t, i) {
        super.attributeChangedCallback(e1, t, i), "value" === e1 && ([
            null,
            void 0,
            "",
            "null"
        ].includes(i) ? this._icon = "search" : this._icon = "empty");
    }
    _onIconClick() {
        [
            "empty",
            "warn"
        ].includes(this._icon) && this.reset(), this.reduceable && "search" === this._icon && (this.reduced = !this.reduced);
    }
    _onInputChange(e1) {
        this.value !== e1.target.value && (this.value = e1.target.value, this._throttledSearch());
    }
    _onResultClick(e1) {
        let t = null !== this._results;
        this._results = null, t && !this["no-menu-closure"] && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this._popup
            }
        })), this._throttler && (clearTimeout(this._throttler), this._throttler = null), !this.reduceable && e1 ? (this.value = e1?.title, this._icon = "empty") : (this.value = "", this._icon = "search", this.reduceable && (this.reduced = !0)), this.dispatchEvent(new CustomEvent("result", {
            bubbles: !0,
            composed: !0,
            detail: e1
        }));
    }
    _throttledSearch() {
        this._throttler && (clearTimeout(this._throttler), delete this._throttler), this._throttler = setTimeout(this._search.bind(this), 500);
    }
    _search() {
        if (!this.value || 0 === this.value.length) return void this.reset();
        if (!this.searcher) return void console.warn("No search handler defined");
        this._icon = "loading";
        let e1 = null !== this._results;
        this._results = null, e1 && !this["no-menu-closure"] && this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this._popup
            }
        })), this.searcher(this.value).then((t)=>{
            "loading" === this._icon && (this._icon = "empty", e1 = null !== this._results, t && 0 !== t.length ? this._results = !0 === t ? null : t : this._results = [], this["no-menu-closure"] || (!this._results && e1 ? this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
                detail: {
                    menu: this._popup
                }
            })) : this._results && this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
                detail: {
                    menu: this._popup
                }
            }))));
        }).catch((e1)=>{
            console.error(e1), this._icon = "warn";
        });
    }
    reset() {
        this._onResultClick(null);
    }
    render() {
        const e1 = {
            sb: !0,
            "sb-xxl": "xxl" === this.size,
            "sb-reduceable": this.reduceable,
            "sb-reduced": this.reduced
        }, t = this.id + "-popup";
        if (this._popup = document.getElementById(t), this._popup || (this._popup = document.createElement("div"), this._popup.id = t, this._popup._parent = this._parent, this._popup.classList.add("sb-results", "pnx-panel"), this._parent.renderRoot.appendChild(this._popup), this["keep-on-menu-closure"] ? $785da19a645c07eb$var$Ss(this._popup, ()=>this._results = null) : $785da19a645c07eb$var$Ss(this._popup, this.reset.bind(this))), !this.reduced && this._results) {
            $785da19a645c07eb$var$oe($785da19a645c07eb$var$H`
				${0 === this._results.length ? $785da19a645c07eb$var$H`
					<div class="sb-empty">${this._parent?._t?.pnx.search_empty}</div>
				` : $785da19a645c07eb$var$Z}

				${/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function*(e1, t) {
                if (void 0 !== e1) {
                    let i = 0;
                    for (const n of e1)yield t(n, i++);
                }
            }(this._results, (e1)=>$785da19a645c07eb$var$H`
					<div class="sb-result" @click=${()=>this._onResultClick(e1)}>
						${e1.title}
						${e1.subtitle && "" !== e1.subtitle ? $785da19a645c07eb$var$H`<br /><small>${e1.subtitle}</small>` : $785da19a645c07eb$var$Z}
					</div>
				`)}
			`, this._popup);
            const e1 = this.renderRoot.host.getBoundingClientRect();
            this._popup.style.display = "block", this._popup.style.top = `${e1.bottom + 5}px`, this._popup.style.left = `${e1.left + 5}px`;
        } else this._popup && (this._popup.style.display = "none");
        return $785da19a645c07eb$var$H`<div
			id=${this.id}
			class=${$785da19a645c07eb$var$w2(e1)}
			part="container"
		>
			<slot name="pre" class=${$785da19a645c07eb$var$w2({
            "sb-reduced": this.reduced
        })}></slot>

			<input
				id="${this.id}-input"
				type="text"
				placeholder=${this.placeholder}
				autocomplete="off"
				@change=${this._onInputChange.bind(this)}
				@keypress=${this._onInputChange.bind(this)}
				@paste=${this._onInputChange.bind(this)}
				@input=${this._onInputChange.bind(this)}
				.value=${this.value || ""}
				part="input"
			/>

			<span
				class="sb-icon"
				@click=${this._onIconClick.bind(this)}
			>
				${"search" === this._icon ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$e2) : $785da19a645c07eb$var$Z}
				${"loading" === this._icon ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$o1, {
            classes: [
                "fa-spin"
            ]
        }) : $785da19a645c07eb$var$Z}
				${"empty" === this._icon ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$r2) : $785da19a645c07eb$var$Z}
				${"warn" === this._icon ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$c1) : $785da19a645c07eb$var$Z}
			</span>
		</div>`;
    }
}
customElements.define("pnx-search-bar", $785da19a645c07eb$var$K3);
class $785da19a645c07eb$var$X3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$R2,
        $785da19a645c07eb$var$o`
		textarea:invalid {
			border: 2px solid var(--red);
			background-color:var(--beige);
		}
	`
    ];
    static properties = {
        semantics: {
            converter: $785da19a645c07eb$var$po.GetJSONConverter(),
            reflect: !0
        },
        rows: {
            type: Number
        },
        _valid: {
            state: !0
        },
        _t: {
            converter: $785da19a645c07eb$var$po.GetJSONConverter()
        },
        _firstSemantics: {
            state: !0
        }
    };
    constructor(){
        super(), this.semantics = null, this._valid = !0, this._firstSemantics = null, this.rows = 3;
    }
    connectedCallback() {
        super.connectedCallback(), this._firstSemantics = null === this.semantics ? [] : $785da19a645c07eb$var$co.parse($785da19a645c07eb$var$co.stringify(this.semantics));
    }
    getDiff() {
        return $785da19a645c07eb$var$e11(this._firstSemantics || [], this.semantics);
    }
    checkValidity() {
        return this._valid;
    }
    reportValidity() {
        this.renderRoot.querySelector("textarea")?.reportValidity();
    }
    reset(e1 = null) {
        this.semantics = null, this._valid = !0;
        const t = this.renderRoot.querySelector("textarea");
        t?.setCustomValidity(""), t?.reportValidity(), this._firstSemantics = e1, this.semantics = e1;
    }
    forceInput() {
        const e1 = this.renderRoot.querySelector("textarea");
        this._onInput({
            target: e1
        }), this._onBlur({
            target: e1
        });
    }
    _onInput(e1) {
        const t = e1.target;
        try {
            this.semantics = $785da19a645c07eb$var$J0(t.value) || [], this._valid = !0;
        } catch (e1) {
            "Invalid tags" !== e1.message && console.error(e1), this._valid = !1;
        }
    }
    _onBlur(e1) {
        const t = e1.target.checkValidity();
        this._valid ? (e1.target.setCustomValidity(""), this.dispatchEvent(new CustomEvent("change", {
            detail: {
                semantics: this.semantics || [],
                delta: $785da19a645c07eb$var$e11(this._firstSemantics || [], this.semantics)
            }
        }))) : t && (e1.target.setCustomValidity(this._t?.pnx.semantics_editor_error || "Invalid syntax"), e1.target.reportValidity());
    }
    render() {
        return $785da19a645c07eb$var$H`
			<textarea
				part="text"
				autocomplete="off"
				autocorrect="off"
				autocapitalize="off"
				spellcheck="false"
				placeholder=${this._t?.pnx.semantics_editor_example || "key1=value1\nprefix|key2=value2"}
				@input=${this._onInput}
  				@blur=${this._onBlur}
				rows=${this.rows}
				.value=${$785da19a645c07eb$var$$0(this.semantics)}
			></textarea>
		`;
    }
}
customElements.define("pnx-semantics-editor", $785da19a645c07eb$var$X3);
class $785da19a645c07eb$var$Q3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$H2,
        $785da19a645c07eb$var$o`
		:host { display: block; }
		th:first-child, td:first-child { width: 40%; }
		td { vertical-align: top; }

		td small { color: var(--grey-semi-dark); }
		td a small { color: unset; }
		.qualifiers { margin-top: 5px; }
		.qualifiers > b { margin: 8px 0; }
		.qualifiers ul {
			list-style: none;
			margin: 0px 0px 0px 15px;
			padding: 0;
		}

		img.prefix-logo {
			max-width: 15px;
			max-height: 15px;
			aspect-ratio: 1;
			vertical-align: middle;
		}
	`
    ];
    static properties = {
        source: {
            type: Object
        }
    };
    render() {
        if (!this.source) return $785da19a645c07eb$var$Z;
        const e1 = $785da19a645c07eb$var$t1(this.source.semantics);
        return $785da19a645c07eb$var$H`<table>
			<thead>
				<tr><th>${this._t.pnx.semantics_key}</th><th>${this._t.pnx.semantics_value}</th></tr>
			</thead>
			<tbody>
				${e1.map((e1)=>e1.tags.map((t)=>$785da19a645c07eb$var$H`
					<tr>
						<td>
							${"" !== e1.prefix ? e1.logo ? $785da19a645c07eb$var$H`<img src=${e1.logo} class="prefix-logo" alt=${e1.prefix} title=${e1.title} />` : $785da19a645c07eb$var$H`<small>(${e1.prefix})</small>` : $785da19a645c07eb$var$Z}
							${e1.key_transform ? e1.key_transform(t, this._t) : t.key}
						</td>
						<td>
							${e1.value_transform ? e1.value_transform(t, this._t) : t.value}
							${t.qualifiers ? $785da19a645c07eb$var$H`<div class="qualifiers">
								<b>${this._t.pnx.semantics_qualifiers}</b>
								<ul>
									${t.qualifiers.map((e1)=>$785da19a645c07eb$var$H`<li>${e1.subkey} = ${e1.value}</li>`)}
								</ul>
							</div>` : $785da19a645c07eb$var$Z}
						</td>
					</tr>
				`))}
			</tbody>
		</table>`;
    }
}
customElements.define("pnx-semantics-table", $785da19a645c07eb$var$Q3);
class $785da19a645c07eb$var$Y3 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		.toggle {
			cursor: pointer;
			display: inline-block;
		}

		.toggle-switch {
			display: inline-block;
			background: #ccc;
			border-radius: 11px;
			width: 42px;
			height: 22px;
			position: relative;
			vertical-align: middle;
			transition: background 0.25s;
		}
		.toggle-switch:before, .toggle-switch:after {
			content: "";
		}
		.toggle-switch:before {
			display: block;
			background: linear-gradient(to bottom, #fff 0%, #eee 100%);
			border-radius: 50%;
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
			width: 16px;
			height: 16px;
			position: absolute;
			top: 3px;
			left: 3px;
			transition: left 0.25s;
		}
		.toggle:hover .toggle-switch:before {
			background: linear-gradient(to bottom, #fff 0%, #fff 100%);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
		}
		.toggle-checkbox:checked + .toggle-switch {
			background: var(--widget-bg-active);
		}
		.toggle-checkbox:disabled + .toggle-switch:before,
		.toggle-checkbox:disabled:hover + .toggle-switch:before {
			background: var(--grey-pale);
			box-shadow: none;
		}
		.toggle-checkbox:disabled + .toggle-switch {
			background: var(--grey);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
		}
		.toggle-checkbox:checked + .toggle-switch:before {
			left: 23px;
		}

		.toggle-checkbox {
			position: absolute;
			visibility: hidden;
		}

		.toggle-label {
			margin-left: 5px;
			position: relative;
			top: 2px;
		}
	`;
    static properties = {
        checked: {
            type: Boolean,
            reflect: !0
        },
        disabled: {
            type: Boolean,
            reflect: !0
        },
        name: {
            type: String
        }
    };
    constructor(){
        super(), this.checked = !1, this.disabled = !1, this.name = "pnx-switch-1";
    }
    _onChange(e1) {
        this.checked = e1.target.checked, this.dispatchEvent(new Event("change"));
    }
    render() {
        return $785da19a645c07eb$var$H`
			<label class="toggle" for=${this.name}>
				<input
					class="toggle-checkbox"
					type="checkbox"
					id=${this.name}
					name=${this.name}
					.checked=${this.checked}
					.disabled=${this.disabled}
					@change=${this._onChange}
				/>
				<div class="toggle-switch"></div>
				<span class="toggle-label">
					<slot></slot>
				</span>
			</label>
		`;
    }
}
customElements.define("pnx-switch", $785da19a645c07eb$var$Y3);
const $785da19a645c07eb$var$J3 = 15e-5;
class $785da19a645c07eb$var$$3 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		:host { pointer-events: none; }
		:host > * { pointer-events: auto; }

		/* Toggle button: same look as the other viewer widgets. */
		pnx-button::part(btn) { border-radius: 8px; height: 26px; width: 26px; }
		pnx-button[size="xl"]::part(btn) { border-radius: 8px; height: 38px; width: 38px; }
		.pnx-tt-count {
			position: absolute;
			top: -4px;
			right: -4px;
			min-width: 16px;
			height: 16px;
			padding: 0 3px;
			box-sizing: border-box;
			border-radius: 8px;
			background: var(--widget-bg-active);
			color: var(--widget-font-active);
			font: 11px/16px var(--font-family);
			text-align: center;
		}

		/* Filmstrip: reuse the classic panel look (white background, theme font). */
		.pnx-tt-strip {
			position: relative;
			display: flex;
			align-items: stretch;
			gap: 6px;
			padding: 8px;
			min-width: unset;
			max-width: 50vw;
			border-radius: 20px;
		}
		.pnx-tt-items {
			display: flex;
			gap: 8px;
			overflow-x: scroll;
			scrollbar-gutter: stable;
			padding-bottom: 10px;
		}
		.pnx-tt-item {
			flex: 0 0 auto;
			width: 130px;
			padding: 0;
			border: 2px solid var(--grey-pale);
			border-radius: 10px;
			background: var(--widget-bg);
			color: var(--widget-font);
			cursor: pointer;
			overflow: hidden;
			font-family: var(--font-family);
		}
		.pnx-tt-item img {
			display: block;
			width: 100%;
			height: 75px;
			object-fit: cover;
			background: var(--widget-bg-inactive);
		}
		.pnx-tt-date { display: block; padding: 4px; font-size: 10px; text-align: center; white-space: nowrap; }
		.pnx-tt-item:hover { border-color: var(--widget-bg-active); }
		.pnx-tt-item.pnx-tt-current { border-color: var(--widget-bg-active); }
		.pnx-tt-close::part(btn) { height: 100% !important; }
	`
    ];
    static properties = {
        size: {
            type: String,
            reflect: !0
        },
        _entries: {
            state: !0
        },
        _current: {
            state: !0
        },
        _open: {
            state: !0
        },
        _dragMouseDown: {
            state: !0
        },
        _dragStartX: {
            state: !0
        },
        _dragScrollLeft: {
            state: !0
        }
    };
    constructor(){
        super(), this.size = "xl", this._entries = [], this._current = null, this._open = !1, this._thumbs = new Map, this._anchor = null, this._collecting = !1, this._rawPics = [], this._currentIs360 = !1, this._rotateTimer = null, this._dragMouseDown = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>{
            this._parent.onceReady().then(()=>{
                this._parent.psv.addEventListener("picture-loaded", ()=>this._onPictureChange()), this._parent.psv.addEventListener("view-rotated", ()=>this._onViewRotated());
            }), this._parent.onceFirstPicLoaded().then(()=>this._onPictureChange());
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._rotateTimer && clearTimeout(this._rotateTimer);
    }
    _onViewRotated() {
        this._currentIs360 && this._rawPics.length && (this._rotateTimer && clearTimeout(this._rotateTimer), this._rotateTimer = setTimeout(()=>{
            this._rotateTimer = null, this._rebuildEntries();
        }, 300));
    }
    _onPictureChange() {
        const e1 = this._parent?.psv?.getPictureMetadata?.(), t = e1?.gps || e1?.geometry?.coordinates, i = e1?.properties?.datetime;
        t && i ? (this._current = i.slice(0, 7), this._currentIs360 = 360 === e1?.properties?.["pers:interior_orientation"]?.field_of_view, this._anchor && (this._rawPics.length || this._collecting) && $785da19a645c07eb$var$Oe(t, this._anchor) <= $785da19a645c07eb$var$J3 ? this._rebuildEntries() : (this._anchor = t, this._collecting = !0, this._collect(t).then((e1)=>{
            this._rawPics = e1, this._rebuildEntries();
        }).catch((e1)=>{
            console.warn("Time-travel collect failed:", e1), this._rawPics = [], this._entries = [];
        }).finally(()=>{
            this._collecting = !1, this.requestUpdate();
        }))) : this._reset();
    }
    _rebuildEntries() {
        this._anchor ? (this._entries = $785da19a645c07eb$var$_O(this._filterByDirection(this._rawPics), this._anchor), this.requestUpdate()) : this._entries = [];
    }
    _currentRefDir() {
        const e1 = this._parent?.psv;
        if (!e1?.getPictureOriginalHeading) return null;
        const t = e1.getPictureOriginalHeading() || 0;
        if (this._currentIs360) return (t + $785da19a645c07eb$var$nt(e1.getPosition?.()?.yaw || 0) + 360) % 360;
        return (t + 360) % 360;
    }
    _filterByDirection(e1) {
        const t = this._currentRefDir();
        return null === t ? e1 : (e1 || []).filter((e1)=>e1.is360 || null == e1.heading || function(e1, t) {
                return Math.abs((e1 - t + 540) % 360 - 180);
            }(e1.heading, t) <= 45);
    }
    _reset() {
        this._entries = [], this._rawPics = [], this._anchor = null, this._open = !1;
    }
    _picLayerId() {
        const e1 = this._parent?.mapStyleComposer, t = e1?.layerRanges?.panoramax?.[e1?.panoramax];
        return t?.layers?.find((e1)=>e1.id.endsWith("_pictures"))?.id || null;
    }
    _collect(e1) {
        const t = this._parent?.map, i = this._picLayerId();
        return t && i ? this._pollTiles(e1, t, i).then((t)=>t.length ? t : this._collectFromApi(e1)) : this._collectFromApi(e1);
    }
    _pollTiles(e1, t, i) {
        const n = Date.now() + 4e3;
        return new Promise((a)=>{
            const r = ()=>{
                if (t.getLayer?.(i) && t.getZoom?.() >= $785da19a645c07eb$var$fo) {
                    const n = this._collectFromTiles(e1, t, i);
                    if (n.length) return void a(n);
                }
                Date.now() >= n ? a([]) : setTimeout(r, 300);
            };
            r();
        });
    }
    _collectFromTiles(e1, t, i) {
        let n;
        try {
            const i = t.project(e1);
            n = [
                [
                    i.x - 45,
                    i.y - 45
                ],
                [
                    i.x + 45,
                    i.y + 45
                ]
            ];
        } catch (e1) {
            return [];
        }
        const a = new Set, r = [];
        for (const s of t.queryRenderedFeatures(n, {
            layers: [
                i
            ]
        })){
            const t = s.properties?.id, i = s.properties?.ts, n = s.geometry?.coordinates;
            t && i && n && !a.has(t) && ($785da19a645c07eb$var$Oe(e1, n) > $785da19a645c07eb$var$J3 || (a.add(t), r.push({
                id: t,
                seqId: s.properties.sequence || null,
                coords: n,
                date: String(i).slice(0, 10),
                density: Number(s.properties.h_pixel_density) || 0,
                is360: "equirectangular" === s.properties.type,
                heading: null != s.properties.heading ? Number(s.properties.heading) : null,
                thumb: null
            })));
        }
        return r;
    }
    _collectFromApi(e1) {
        const [t, i] = e1, n = this._parent.getAPI();
        return n.getPicturesAroundCoordinates(i, t, $785da19a645c07eb$var$J3, 1e3).then((e1)=>(e1?.features || []).map((e1)=>{
                const t = e1.properties?.["pers:interior_orientation"] || {}, i = t.field_of_view, a = t.sensor_array_dimensions?.[0];
                let r = null;
                try {
                    r = n.findThumbnailInPictureFeature(e1);
                } catch (e1) {}
                const s = e1.properties?.["view:azimuth"];
                return {
                    id: e1.id,
                    seqId: e1.collection,
                    coords: e1.geometry.coordinates,
                    date: e1.properties.datetime,
                    density: a && i ? a / i : 0,
                    is360: 360 === i,
                    heading: null != s ? Number(s) : null,
                    thumb: r
                };
            }));
    }
    _thumbFor(e1) {
        return e1.thumb ? e1.thumb : this._thumbs.has(e1.id) ? this._thumbs.get(e1.id) : (this._thumbs.set(e1.id, null), Promise.resolve(this._parent.getAPI().getPictureThumbnailURL(e1.id, e1.seqId)).then((t)=>{
            this._thumbs.set(e1.id, t), this.requestUpdate();
        }).catch(()=>{}), null);
    }
    _monthLabel(e1) {
        const t = new Date(e1.date);
        return isNaN(t.getTime()) ? e1.month : t.toLocaleDateString(this._parent?.lang || void 0, {
            year: "numeric",
            month: "short"
        });
    }
    _hoverOn(e1) {
        const t = this._parent?.map;
        if (t && t._picMarkerPreview && e1.coords) try {
            t._picMarkerPreview.setLngLat(e1.coords).setRotation(e1.heading || 0).addTo(t);
        } catch (e1) {}
    }
    _hoverOff() {
        const e1 = this._parent?.map;
        if (e1 && e1._picMarkerPreview) try {
            e1._picMarkerPreview.remove();
        } catch (e1) {}
    }
    _startDragging(e1) {
        e1.preventDefault();
        const t = this.shadowRoot.querySelector(".pnx-tt-items");
        this._dragMouseDown = !0, this._dragStartX = e1.pageX - t.offsetLeft, this._dragScrollLeft = t.scrollLeft;
    }
    _stopDragging() {
        this._dragMouseDown = !1;
    }
    _moveDragging(e1) {
        if (e1.preventDefault(), !this._dragMouseDown) return;
        const t = this.shadowRoot.querySelector(".pnx-tt-items"), i = e1.pageX - t.offsetLeft - this._dragStartX;
        t.scrollLeft = this._dragScrollLeft - i;
    }
    _select(e1) {
        this._parent.psv._keepSameAngle = !0, this._parent.select(e1.seqId, e1.id);
    }
    render() {
        const e1 = this._entries && this._entries.length >= 2;
        return e1 && !this._open ? $785da19a645c07eb$var$H`
				<pnx-button
					kind="superflat"
					size=${this.size}
					class="pnx-print-hidden"
					style="vertical-align: middle"
					title=${this._parent._t?.pnx.time_travel}
					@click=${()=>this._open = !0}
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$U1, {
            styles: {
                height: "20px"
            }
        })}
					<span class="pnx-tt-count">${this._entries.length}</span>
				</pnx-button>
			` : e1 && this._open ? $785da19a645c07eb$var$H`
				<div
					class="pnx-tt-strip pnx-panel pnx-print-hidden"
					@mouseleave=${()=>{
            this._hoverOff(), this._stopDragging();
        }}
					@mousemove=${(e1)=>this._moveDragging(e1)}
					@mousedown=${(e1)=>this._startDragging(e1)}
					@mouseup=${(e1)=>this._stopDragging(e1)}
				>
					<div class="pnx-tt-items">
						${this._entries.map((e1)=>{
            const t = this._thumbFor(e1), i = "pnx-tt-item" + (e1.month === this._current ? " pnx-tt-current" : "");
            return $785da19a645c07eb$var$H`
								<button
									class=${i}
									title=${this._monthLabel(e1)}
									@click=${()=>this._select(e1)}
									@mouseenter=${()=>this._hoverOn(e1)}
								>
									${t ? $785da19a645c07eb$var$H`<img src=${t} alt=${e1.month} loading="lazy" draggable="false" />` : $785da19a645c07eb$var$Z}
									<span class="pnx-tt-date">${this._monthLabel(e1)}</span>
								</button>
							`;
        })}
					</div>
					<pnx-button
						kind="superflat"
						size="md"
						class="pnx-tt-close"
						title=${this._parent._t?.pnx.time_travel_close}
						@click=${()=>this._open = !1}
					>
						${$785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}
					</pnx-button>
				</div>
			` : $785da19a645c07eb$var$Z;
    }
}
customElements.define("pnx-time-travel", $785da19a645c07eb$var$$3);
class $785da19a645c07eb$var$e5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		div.container {
			position: relative;
			height: 100%;
		}

		.pnx-panel { z-index: 130; }
		.pnx-panel-fixed { position: fixed; }

		.pnx-panel.pnx-panel-nobg {
			border: none;
			background: none;
		}
	`
    ];
    static properties = {
        _opened: {
            state: !0
        },
        padded: {
            type: String
        },
        nobg: {
            type: Boolean
        },
        "over-button": {
            type: Boolean
        }
    };
    constructor(){
        super(), this._opened = !1;
    }
    open() {
        this._opened = !0, this._parent?.dispatchEvent(new CustomEvent("menu-opened", {
            detail: {
                menu: this
            }
        })), this.adjustMenuPosition(this._btn), this._chevron && (this._chevron.style.rotate = "180deg");
    }
    close() {
        this._opened && (this._opened = !1, this._parent?.dispatchEvent(new CustomEvent("menu-closed", {
            detail: {
                menu: this
            }
        })), this._chevron && (this._chevron.style.rotate = ""));
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Ss(this, this.close.bind(this));
    }
    handleButtonSlotChange(e1) {
        this._btn = e1.target.assignedNodes().pop(), this._btn && (this._chevron = this._btn.querySelector("svg.fa-chevron-down"), this._chevron && (this._chevron.style.transition = "rotate 0.2s", this._chevron.style.rotate = this._opened ? "180deg" : ""), this._btn.addEventListener("click", ()=>{
            this._opened ? this.close() : this.open();
        }));
    }
    adjustMenuPosition(e1) {
        const t = this.shadowRoot.querySelector("div[part='menu']");
        t.style.top = null, t.style.bottom = null, t.style.right = null, t.style.left = null, t.style.overflowY = null, t.style.marginTop = null;
        const i = e1.getBoundingClientRect();
        let n = t.getBoundingClientRect();
        const a = n.right <= window.innerWidth - 10, r = n.bottom <= window.innerHeight - 10;
        a && r ? t.style.top = this["over-button"] ? `${i.top}px` : `${i.bottom + 5}px` : a || r ? r ? a || (this["over-button"] ? t.style.top = `${i.top}px` : t.style.marginTop = "5px", t.style.right = window.innerWidth - i.right + "px") : (t.style.bottom = "10px", t.style.top = this["over-button"] ? `${i.top}px` : `${i.bottom + 5}px`, t.style.overflowY = "auto") : (t.style.right = this["over-button"] ? window.innerWidth - i.right + "px" : window.innerWidth - i.left + 5 + "px", t.style.bottom = window.innerHeight - i.bottom + "px", n = t.getBoundingClientRect(), n.top - 10 < 0 && (t.style.bottom = "10px", t.style.top = `${i.top}px`, t.style.overflowY = "auto"));
    }
    render() {
        const e1 = {
            "pnx-panel": !0,
            "pnx-panel-fixed": !0,
            "pnx-panel-nobg": this.nobg,
            "pnx-hidden": !this._opened,
            "pnx-padded": "false" !== this.padded
        };
        return $785da19a645c07eb$var$H`<div class="container" @click=${(e1)=>e1.stopPropagation()}>
			<slot name="button" @slotchange=${this.handleButtonSlotChange}></slot>
			<div class=${$785da19a645c07eb$var$w2(e1)} part="menu">
				<slot></slot>
			</div>
		</div>`;
    }
}
customElements.define("pnx-togglable-group", $785da19a645c07eb$var$e5);
class $785da19a645c07eb$var$t5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$U2,
        $785da19a645c07eb$var$o`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
    ];
    static properties = {
        gps: {
            type: Array
        }
    };
    render() {
        const e1 = $785da19a645c07eb$var$Xe(this.gps[0]), t = e1.d < 0 ? `${Math.abs(e1.d)}\xb0${e1.m}'${e1.s}"W` : `${e1.d}\xb0${e1.m}'${e1.s}"E`, i = $785da19a645c07eb$var$Xe(this.gps[1]), n = i.d < 0 ? `${Math.abs(i.d)}\xb0${i.m}'${i.s}"S` : `${i.d}\xb0${i.m}'${i.s}"N`, a = {
            ddeclatlon: `${this.gps[1].toFixed(5)}, ${this.gps[0].toFixed(5)}`,
            ddeclonlat: `${this.gps[0].toFixed(5)}, ${this.gps[1].toFixed(5)}`,
            ddmslonlat: `${t}, ${n}`,
            ddmslatlon: `${n}, ${t}`
        };
        return $785da19a645c07eb$var$H`<pnx-button-group style="display: inline-block; vertical-align: baseline" dir="row">
			<pnx-copy-button
				size="sm"
				text=${a.ddeclonlat}
				title=${this._parent?._t.pnx.metadata_location_copy.replace("{v}", a.ddeclonlat)}
			></pnx-copy-button>

			<pnx-togglable-group padded="false" ._parent=${this._parent}>
				<pnx-button
					size="sm"
					slot="button"
					title=${this._parent?._t.pnx.metadata_location_copy_more}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}</pnx-button>
				<pnx-list-group>
					${Object.values(a).map((e1)=>$785da19a645c07eb$var$H`
						<pnx-copy-button unstyled text=${e1} ._t=${this._parent._t}>
							${this._parent?._t.pnx.metadata_location_copy.replace("{v}", e1)}
						</pnx-copy-button>
					`)}
				</pnx-list-group>
			</pnx-togglable-group>
		</pnx-button-group>`;
    }
}
customElements.define("pnx-copy-coordinates", $785da19a645c07eb$var$t5);
class $785da19a645c07eb$var$i5 extends $785da19a645c07eb$var$ce {
    static styles = $785da19a645c07eb$var$o`
		pnx-button, pnx-button::part(btn) {
			width: 38px !important;
			height: 38px !important;
			max-width: 38px !important;
			max-height: 38px !important;
			min-width: unset !important;
			min-height: unset !important;
		}

		pnx-button[data-enabled="true"] {
			position: fixed;
			bottom: 10px;
			right: 10px;
		}
	`;
    static properties = {
        _enabled: {
            state: !0
        }
    };
    constructor(){
        super(), this._enabled = !1;
    }
    async _changeFullscreen(e1) {
        if (this._enabled = e1, this._enabled) {
            const e1 = this._parent;
            let t = (e1.requestFullscreen || e1.webkitRequestFullScreen || e1.mozRequestFullScreen || e1.requestFullScreen)?.bind(e1);
            t ? await t() : this._enabled = !1;
        } else try {
            const e1 = (document.exitFullscreen || document.webkitCancelFullScreen || document.mozCancelFullScreen || document.cancelFullScreen)?.bind(document);
            e1 ? await e1() : this._enabled = !0;
        } catch (e1) {
            e1.message.includes("Not in fullscreen") ? this._enabled = !1 : console.error(e1);
        }
        this._enabled ? this._parent?.grid?.toggleAway(!1) : this._parent?.grid?.toggleAway(!0);
    }
    render() {
        return $785da19a645c07eb$var$H`
			<pnx-button
				id="pnx-zoom-in"
				size="xl"
				class="pnx-mobile-hidden pnx-print-hidden"
				kind="superflat"
				title=${this._parent?._t.pnx.zoomIn}
				data-enabled=${this._enabled}
				@click=${()=>this._changeFullscreen(!this._enabled)}
			>${$785da19a645c07eb$var$ws(this._enabled ? $785da19a645c07eb$var$u1 : $785da19a645c07eb$var$a2)}</pnx-button>
		`;
    }
}
customElements.define("pnx-widget-fullscreen", $785da19a645c07eb$var$i5);
const $785da19a645c07eb$var$n5 = new CSSStyleSheet;
$785da19a645c07eb$var$n5.replaceSync("pnx-widget-geosearch .maplibregl-ctrl {\n\tbox-shadow: none !important;\n\tbackground: none !important;\n}\n\npnx-widget-geosearch .maplibregl-ctrl-geolocate {\n\tborder-radius: 15px;\t\n}\n\npnx-widget-geosearch pnx-search-bar[reduced] .maplibregl-ctrl-geolocate {\n\twidth: 40px;\n}\n\npnx-widget-geosearch pnx-search-bar:not([reduced]) .maplibregl-ctrl-geolocate {\n\tmargin-left: -5px;\n}\n\npnx-widget-geosearch pnx-search-bar:not([reduceable])::part(input) {\n\twidth: 300px;\n\tmax-width: 30vw;\n}"), document.adoptedStyleSheets.push($785da19a645c07eb$var$n5);
const $785da19a645c07eb$var$a5 = {
    ban: $785da19a645c07eb$var$h3,
    standard: $785da19a645c07eb$var$p3,
    nominatim: $785da19a645c07eb$var$c3
};
class $785da19a645c07eb$var$r5 extends $785da19a645c07eb$var$ce {
    static properties = {
        geocoder: {
            type: String
        },
        _geolocate: {
            state: !0
        }
    };
    constructor(){
        super(), this.geocoder = "nominatim", this._geolocateCtrl = new $785da19a645c07eb$var$TL({
            positionOptions: {
                enableHighAccuracy: !0,
                timeout: 6e4,
                maximumAge: 3e5
            },
            showAccuracyCircle: !0,
            showUserLocation: !0,
            trackUserLocation: !0
        });
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), this._geocoderEngine = $785da19a645c07eb$var$a5[this.geocoder] || ((e1)=>$785da19a645c07eb$var$a5.standard(e1, this.geocoder)), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.onceMapReady?.().then(()=>{
                this._geolocate || (this._geolocate = this._geolocateCtrl.onAdd(this._parent.map), this._geolocate.setAttribute("slot", "pre"));
            }));
    }
    _onInput(e1) {
        const t = e1.match(/([-+]?\d{1,2}\.\d+),\s*([-+]?\d{1,3}\.\d+)/), i = e1.match(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/);
        if (t) {
            const e1 = parseFloat(t[1]), i = parseFloat(t[2]);
            return this._parent.map.jumpTo({
                center: [
                    i,
                    e1
                ],
                zoom: 16
            }), Promise.resolve(!0);
        }
        return i ? new Promise((t, i)=>{
            this._parent.psv.addEventListener("picture-failed", i, {
                once: !0
            }), this._parent.psv.addEventListener("picture-loaded", ()=>t(!0), {
                once: !0
            }), this._parent.select(null, e1);
        }) : this._geocoderEngine({
            query: e1,
            limit: 5,
            proximity: this._parent.map.getCenter().lat + "," + this._parent.map.getCenter().lng
        }).then((e1)=>(e1 = e1.features.map((e1)=>({
                    title: e1.place_name.split(",")[0],
                    subtitle: e1.place_name.split(",").slice(1).join(", "),
                    data: e1
                })), e1));
    }
    _onSelect(e1) {
        const t = e1.detail;
        t && (t.data.bounds ? this._parent?.map.fitBounds(t.data.bounds, {
            animate: !1
        }) : this._parent?.map.jumpTo({
            center: t.data.center,
            zoom: t.data.zoom || 13
        }));
    }
    render() {
        const e1 = this._parent?.isWidthSmall() || !1;
        return $785da19a645c07eb$var$H`
			<pnx-search-bar
				id="pnx-widget-search-bar"
				placeholder=${this._parent?._t.pnx.search_address}
				._parent=${this._parent}
				.searcher=${this._onInput.bind(this)}
				.reduceable=${e1}
				.reduced=${e1}
				size="xxl"
				class="pnx-print-hidden"
				@result=${this._onSelect.bind(this)}
			>
				${this._geolocate}
			</pnx-search-bar>
		`;
    }
}
customElements.define("pnx-widget-geosearch", $785da19a645c07eb$var$r5);
class $785da19a645c07eb$var$s5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$I2,
        $785da19a645c07eb$var$o`
		:host {
			pointer-events: none;
		}
		.pnx-panel[part="panel"] {
			border-radius: 10px;
			position: relative;
			max-width: 450px;
			z-index: 121; /* To appear above mini component */
			min-width: unset;
			pointer-events: auto;
		}
		.pnx-panel[part="panel"].pnx-padded {
			padding: 10px;
			width: 250px;
		}
		.presentation {
			font-size: 0.85em;
			line-height: 1em;
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.logo {
			width: 45px;
		}
		pnx-map-legend {
			display: block;
			margin-top: 5px;
		}

		/* Lighter/smaller version */
		.pnx-panel[part="panel"].pnx-legend-light {
			display: flex;
			gap: 3px;
			padding: 3px 8px 3px 3px;
			width: unset;
			min-width: unset;
			align-items: center;
			font-size: 10px;
			margin-right: -10px;
			margin-bottom: -10px;
			border-radius: 0;
			border-top-left-radius: 5px;
			border-right: none;
  			border-bottom: none;
		}
		.pnx-legend-light a,
		.pnx-legend-light .presentation {
			font-size: 10px;
		}
		.pnx-legend-light .logo {
			width: 15px;
		}

		.pnx-legend-light pnx-map-legend {
			width: max-content;
			margin-top: unset;
			font-size: 10px;
		}
	`
    ];
    static properties = {
        focus: {
            type: String
        },
        picture: {
            type: String
        },
        light: {
            type: Boolean
        }
    };
    constructor(){
        super(), this.light = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this.requestUpdate());
    }
    render() {
        const e1 = {
            "pnx-panel": !0,
            "pnx-padded": "map" === this.focus,
            "pnx-legend-light": this.light
        }, t = $785da19a645c07eb$var$Ue("data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8' standalone='no'%3f%3e%3c!-- Generator: Adobe Illustrator 24.0.2%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3csvg version='1.1' id='Calque_1' x='0px' y='0px' width='343.25757mm' height='343.25757mm' viewBox='0 0 1297.3515 1297.3513' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/'%3e%3cmetadata id='metadata118'%3e%3crdf:RDF%3e%3ccc:Work rdf:about=''%3e%3cdc:format%3eimage/svg%2bxml%3c/dc:format%3e%3cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage'/%3e%3c/cc:Work%3e%3c/rdf:RDF%3e%3c/metadata%3e%3cdefs id='defs72'%3e%3crect x='1150.3843' y='2292.8162' width='2107.8879' height='701.88715' id='rect141823'/%3e%3crect x='411.88269' y='1261.6108' width='815.34668' height='181.92911' id='rect66775'/%3e%3crect x='253.02008' y='1213.0352' width='2209.7197' height='583.65765' id='rect60279'/%3e%3crect x='1150.3843' y='2292.8162' width='2551.0081' height='701.39136' id='rect141823-1'/%3e%3clinearGradient y2='62.288601' x2='248.6918' y1='231.7114' x1='346.50821' gradientUnits='userSpaceOnUse' id='SVGID_1_' gradientTransform='matrix(6.6326761%2c0%2c0%2c6.6326761%2c-1221.4079%2c-713.64667)'%3e %3cstop id='stop4' style='stop-color:%238F2A85' offset='0'/%3e %3cstop id='stop6' style='stop-color:%232570B6' offset='1'/%3e %3c/linearGradient%3e%3c/defs%3e%3cstyle type='text/css' id='style2'%3e .st0%7bfill:url(%23SVGID_1_)%3b%7d .st1%7bfill:white%3b%7d .st2%7bdisplay:none%3bfill:none%3bstroke:%23E62054%3bstroke-width:7.5%3bstroke-miterlimit:10%3b%7d%3c/style%3e%3ctext y='-2248.8188' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:125%25%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect60279)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text60277' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-4324.1934' x='304.06815' style='font-style:normal%3bfont-weight:normal%3bfont-size:89.8058px%3bline-height:200%25%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect66775)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:2.24515px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text66773' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-2248.5173' x='-121.66869' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:0%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect141823)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text141821' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3ctext y='-3181.1731' x='-158.83984' style='font-style:normal%3bfont-weight:normal%3bfont-size:40px%3bline-height:0%3bfont-family:Sans%3bletter-spacing:0px%3bword-spacing:0px%3bwhite-space:pre%3bshape-inside:url(%23rect141823-1)%3bdisplay:inline%3bfill:black%3bfill-opacity:1%3bstroke:none%3bstroke-width:1px%3bstroke-linecap:butt%3bstroke-linejoin:miter%3bstroke-opacity:1' id='text141821-0' xml:space='preserve' transform='matrix(0.99999889%2c0%2c0%2c0.99999889%2c-164.71991%2c-165.18467)'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path49' d='m 1065.871%2c503.42011 c -19.2347%2c0 -35.1531%2c-15.91842 -35.1531%2c-35.15318 V 334.28687 H 870.87032 c -19.23476%2c0 -35.15319%2c-15.91842 -35.15319%2c-35.15318 0%2c-19.23476 15.91843%2c-35.15319 35.15319%2c-35.15319 H 1065.871 c 19.2348%2c0 35.1532%2c15.91843 35.1532%2c35.15319 v 169.13324 c 0.6633%2c19.23476 -15.2551%2c35.15318 -35.1532%2c35.15318 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path53' d='M 426.48102%2c1032.7077 H 231.48034 c -19.23476%2c0 -35.15318%2c-15.9185 -35.15318%2c-35.15322 V 828.42124 c 0%2c-19.23476 15.91842%2c-35.15318 35.15318%2c-35.15318 19.23476%2c0 35.15318%2c15.91842 35.15318%2c35.15318 v 133.31679 h 159.8475 c 19.23476%2c0 35.15318%2c15.91842 35.15318%2c35.15318 0%2c19.23479 -15.25515%2c35.81649 -35.15318%2c35.81649 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path57' d='m 231.48034%2c503.42011 c -19.23476%2c0 -35.15318%2c-15.91842 -35.15318%2c-35.15318 V 299.13369 c 0%2c-19.23476 15.91842%2c-35.15319 35.15318%2c-35.15319 h 195.00068 c 19.23476%2c0 35.15318%2c15.91843 35.15318%2c35.15319 0%2c19.23476 -15.91842%2c35.15318 -35.15318%2c35.15318 h -159.8475 v 133.31679 c 0.66327%2c19.89803 -15.25515%2c35.81645 -35.15318%2c35.81645 z' class='st2'/%3e%3cpath style='display:none%3bfill:none%3bstroke:%23e62054%3bstroke-width:49.7451%3bstroke-miterlimit:10' id='path61' d='M 1065.871%2c1032.7077 H 870.87032 c -19.23476%2c0 -35.15319%2c-15.9185 -35.15319%2c-35.15322 0%2c-19.23476 15.91843%2c-35.15318 35.15319%2c-35.15318 H 1030.7179 V 829.08451 c 0%2c-19.23476 15.9184%2c-35.15319 35.1531%2c-35.15319 19.2348%2c0 35.1532%2c15.91843 35.1532%2c35.15319 v 169.13324 c 0.6633%2c18.57145 -15.2551%2c34.48995 -35.1532%2c34.48995 z' class='st2'/%3e%3cg id='g1' transform='translate(-103.80084%2c387.319)'%3e%3ccircle style='fill:url(%23SVGID_1_)%3bstroke-width:6.63268' id='circle9' r='648.67572' cy='261.35672' cx='752.47656' class='st0'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path11' d='m 465.28163%2c199.67283 c -0.66327%2c0 -1.32653%2c0 -1.9898%2c0 l -36.47972%2c-10.61228 c -2.65307%2c-0.66327 -4.64287%2c-3.31634 -4.64287%2c-6.63268 v -49.0818 c 0%2c-1.9898 1.32653%2c-3.97961 2.65307%2c-5.30614 1.9898%2c-1.32654 3.9796%2c-1.32654 5.96941%2c-0.66327 l 36.47972%2c13.26535 c 2.65307%2c0.66327 4.64287%2c3.31634 4.64287%2c5.96941 v 46.42873 c 0%2c1.98981 -0.66327%2c3.97961 -2.65307%2c5.30614 -1.32654%2c0.66327 -2.65307%2c1.32654 -3.97961%2c1.32654 z m -29.84704%2c-22.5511 23.21437%2c6.63268 v -33.16338 l -23.21437%2c-8.62248 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path13' d='m 465.28163%2c292.53029 c -0.66327%2c0 -0.66327%2c0 -1.32653%2c0 l -36.47972%2c-7.95921 c -3.31634%2c-0.66326 -5.30614%2c-3.31633 -5.30614%2c-6.63267 V 228.8566 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-5.30614 1.32653%2c-1.32653 3.9796%2c-1.9898 5.96941%2c-1.32653 l 36.47972%2c9.28574 c 2.65307%2c0.66327 5.30614%2c3.31634 5.30614%2c6.63268 v 47.75527 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.98981%2c0.66327 -3.31634%2c1.32653 -4.64288%2c1.32653 z m -29.84704%2c-19.89802 23.21437%2c5.30614 v -34.48992 l -23.21437%2c-5.96941 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path15' d='m 525.63898%2c306.45891 c -0.66326%2c0 -1.32653%2c0 -1.32653%2c0 l -36.47972%2c-8.62247 c -3.31634%2c-0.66327 -5.30614%2c-3.31634 -5.30614%2c-6.63268 v -48.41854 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-5.30614 1.9898%2c-1.32653 3.97961%2c-1.9898 5.96941%2c-1.32653 l 36.47972%2c9.28574 c 2.65307%2c0.66327 5.30614%2c3.31634 5.30614%2c6.63268 v 47.75527 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.9898%2c0.66327 -3.31634%2c1.32653 -4.64288%2c1.32653 z m -29.84704%2c-20.56129 23.21437%2c5.30614 v -34.48992 l -23.21437%2c-5.96941 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path17' d='m 609.87397%2c285.23435 c -0.66327%2c0 -1.32653%2c0 -1.9898%2c0 l -43.1124%2c-14.59189 c -2.65307%2c-0.66326 -3.9796%2c-3.31633 -3.9796%2c-5.30614 v -30.51031 c 0%2c-1.9898 0.66327%2c-3.9796 2.65307%2c-4.64287 1.32653%2c-1.32654 3.31634%2c-1.32654 5.30614%2c-0.66327 l 43.11239%2c15.91842 c 1.98981%2c0.66327 3.97961%2c3.31634 3.97961%2c5.30614 v 29.18378 c 0%2c1.9898 -0.66327%2c3.31634 -2.65307%2c4.64287 -0.66327%2c0 -1.9898%2c0.66327 -3.31634%2c0.66327 z m -37.14298%2c-24.5409 31.83684%2c10.61228 v -17.24496 l -31.83684%2c-11.93881 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path19' d='m 638.39448%2c350.23458 c -0.66327%2c0 -0.66327%2c0 -1.32654%2c0 l -41.78586%2c-9.94902 c -2.65307%2c-0.66327 -4.64287%2c-2.65307 -4.64287%2c-5.30614 v -31.17358 c 0%2c-1.9898 0.66327%2c-3.31633 1.9898%2c-4.64287 1.32654%2c-1.32653 3.31634%2c-1.32653 5.30614%2c-0.66327 l 41.78586%2c11.27555 c 2.65307%2c0.66327 3.97961%2c2.65307 3.97961%2c5.30614 v 29.84705 c 0%2c1.9898 -0.66327%2c3.31633 -1.9898%2c4.64287 -0.66327%2c0 -1.98981%2c0.66327 -3.31634%2c0.66327 z m -35.81645%2c-20.5613 30.51031%2c7.29594 V 319.061 l -30.51031%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path21' d='m 525.63898%2c218.24432 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 l -37.14298%2c-9.94901 c -2.65307%2c-0.66327 -4.64288%2c-3.31634 -4.64288%2c-6.63268 v -49.0818 c 0%2c-1.9898 1.32654%2c-3.97961 2.65307%2c-5.30614 1.98981%2c-1.32654 3.97961%2c-1.32654 5.96941%2c-0.66327 l 37.14299%2c13.26535 c 2.65307%2c0.66327 4.64287%2c3.31634 4.64287%2c5.96941 v 45.76547 c 0%2c1.9898 -0.66327%2c3.9796 -2.65307%2c5.30614 -1.32653%2c0.66326 -2.65307%2c1.32653 -3.97961%2c1.32653 z m -30.51031%2c-21.88783 23.87764%2c6.63268 v -32.50012 l -23.87764%2c-8.62247 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path23' d='m 690.79262%2c356.86725 c -8.62248%2c0 -15.25516%2c-7.95921 -15.25516%2c-17.24496 0%2c-9.28574 6.63268%2c-17.24495 15.25516%2c-17.24495 8.62248%2c0 15.25515%2c7.95921 15.25515%2c17.24495 0%2c9.28575 -6.63267%2c17.24496 -15.25515%2c17.24496 z m 0%2c-25.20417 c -3.31634%2c0 -5.96941%2c3.31634 -5.96941%2c7.95921 0%2c4.64288 2.65307%2c7.95922 5.96941%2c7.95922 3.31634%2c0 5.96941%2c-3.31634 5.96941%2c-7.95922 0%2c-4.64287 -2.65307%2c-7.95921 -5.96941%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path25' d='m 1041.6612%2c199.67283 c -1.3265%2c0 -2.6531%2c-0.66327 -3.9796%2c-1.32654 -1.9898%2c-1.32653 -2.6531%2c-3.31633 -2.6531%2c-5.30614 v -46.42873 c 0%2c-2.65307 1.9898%2c-5.30614 4.6429%2c-5.96941 l 36.4797%2c-13.26535 c 1.9898%2c-0.66327 3.9796%2c-0.66327 5.9694%2c0.66327 1.9898%2c1.32653 2.6531%2c3.31634 2.6531%2c5.30614 v 49.0818 c 0%2c2.65307 -1.9898%2c5.30614 -4.6429%2c6.63268 l -36.4797%2c10.61228 c -0.6633%2c0 -1.3265%2c0 -1.9898%2c0 z m 6.6327%2c-48.41854 v 33.16338 l 23.2143%2c-6.63267 v -34.48992 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path27' d='m 1041.6612%2c292.53029 c -1.3265%2c0 -2.6531%2c-0.66326 -3.9796%2c-1.32653 -1.3266%2c-1.32654 -2.6531%2c-3.31634 -2.6531%2c-5.30614 v -47.75527 c 0%2c-3.31634 1.9898%2c-5.96941 5.3062%2c-6.63268 l 36.4797%2c-9.28574 c 1.9898%2c-0.66327 3.9796%2c0 5.9694%2c1.32653 1.3265%2c1.32654 2.653%2c3.31634 2.653%2c5.30614 v 49.08181 c 0%2c3.31634 -1.9898%2c5.96941 -5.3061%2c6.63267 l -36.4797%2c7.95921 c -1.3265%2c0 -1.3265%2c0 -1.9898%2c0 z m 6.6327%2c-49.0818 v 34.48992 l 23.2143%2c-5.30614 v -35.15319 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path29' d='m 981.9671%2c306.45891 c -1.32653%2c0 -2.65307%2c-0.66326 -3.97961%2c-1.32653 -1.32653%2c-1.32654 -2.65307%2c-3.31634 -2.65307%2c-5.30614 v -47.75527 c 0%2c-3.31634 1.98981%2c-5.96941 5.30615%2c-6.63268 l 36.47973%2c-9.28574 c 1.9898%2c-0.66327 3.9796%2c0 5.9694%2c1.32653 1.3265%2c1.32654 2.6531%2c3.31634 2.6531%2c5.30614 v 48.41854 c 0%2c3.31634 -1.9898%2c5.96941 -5.3062%2c6.63268 l -36.4797%2c8.62247 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 z m 6.63268%2c-49.0818 v 34.48992 l 23.21432%2c-5.30614 v -34.48992 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path31' d='m 897.06885%2c285.23435 c -1.32654%2c0 -2.65307%2c-0.66327 -3.31634%2c-1.32653 -1.32654%2c-1.32654 -2.65307%2c-2.65307 -2.65307%2c-4.64288 v -29.18377 c 0%2c-2.65307 1.32653%2c-4.64288 3.9796%2c-5.30614 l 43.77567%2c-15.91843 c 1.9898%2c-0.66326 3.9796%2c-0.66326 5.30614%2c0.66327 1.32653%2c1.32654 2.65307%2c2.65307 2.65307%2c4.64287 v 30.51031 c 0%2c2.65308 -1.32654%2c4.64288 -3.97961%2c5.30615 l -43.77566%2c14.59188 c -0.66327%2c0.66327 -1.32654%2c0.66327 -1.9898%2c0.66327 z m 5.9694%2c-31.17358 v 17.24496 l 32.50012%2c-10.61228 v -17.90823 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path33' d='m 865.89527%2c349.57131 c -1.32654%2c-1.32654 -1.9898%2c-2.65307 -1.9898%2c-4.64287 v -29.84705 c 0%2c-2.65307 1.9898%2c-4.64287 3.9796%2c-5.30614 l 41.78586%2c-11.27555 c 1.9898%2c-0.66326 3.31634%2c0 5.30614%2c0.66327 1.32654%2c1.32654 1.9898%2c2.65307 1.9898%2c4.64287 v 31.17358 c 0%2c2.65307 -1.9898%2c5.30614 -4.64287%2c5.30614 l -41.78586%2c9.94902 c -0.66327%2c0.66326 -3.9796%2c0 -4.64287%2c-0.66327 z m 9.28575%2c-29.84704 v 17.90822 l 30.51031%2c-7.29594 v -19.23476 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path35' d='m 981.9671%2c218.24432 c -1.32653%2c0 -2.65307%2c-0.66327 -3.97961%2c-1.32653 -1.32653%2c-1.32654 -2.65307%2c-3.31634 -2.65307%2c-5.30614 v -45.76547 c 0%2c-2.65307 1.98981%2c-5.30614 4.64288%2c-5.96941 l 36.4797%2c-13.26535 c 1.9898%2c-0.66327 3.9796%2c-0.66327 5.9694%2c0.66327 1.9898%2c1.32653 2.6531%2c3.31634 2.6531%2c5.30614 v 49.0818 c 0%2c3.31634 -1.9898%2c5.30614 -4.6429%2c6.63268 l -36.4797%2c9.94901 c -0.66326%2c0 -1.32653%2c0 -1.9898%2c0 z m 6.63268%2c-47.75527 v 32.50012 l 23.21432%2c-6.63268 v -34.48991 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path37' d='m 816.81347%2c356.86725 c -8.62248%2c0 -15.25516%2c-7.95921 -15.25516%2c-17.24496 0%2c-9.28574 6.63268%2c-17.24495 15.25516%2c-17.24495 8.62247%2c0 15.25515%2c7.95921 15.25515%2c17.24495 0%2c9.28575 -6.63268%2c17.24496 -15.25515%2c17.24496 z m 0%2c-25.20417 c -3.31634%2c0 -5.96941%2c3.31634 -5.96941%2c7.95921 0%2c4.64288 2.65307%2c7.95922 5.96941%2c7.95922 3.31633%2c0 5.9694%2c-3.31634 5.9694%2c-7.95922 0%2c-4.64287 -2.65307%2c-7.95921 -5.9694%2c-7.95921 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path39' d='m 1275.7947%2c-13.236074 c 0%2c-1.326535 0%2c-1.989803 0%2c-3.316338 -1.3266%2c-3.316338 -5.3062%2c-5.306141 -8.6225%2c-3.979606 l -37.143%2c13.9286203 V 7.3252221 13.957898 l 32.5001%2c-15.2551549 V 529.31683 h -32.5001 v 13.26535 h 39.1328 c 3.9796%2c0 6.6327%2c-2.65307 7.2959%2c-6.63267 V -11.909539 c 0%2c0 0%2c-0.663267 -0.6632%2c-1.326535 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path41' d='m 1108.6512%2c53.090687 v -13.92862 l -33.1634%2c12.602085 c -0.6632%2c0 -0.6632%2c0.663268 -1.3265%2c0.663268 0%2c0 -113.41876%2c69.6431 -115.40857%2c70.96963 -1.9898%2c1.32654 -3.9796%2c3.31634 -3.9796%2c5.96941 v 37.80626 l -109.43916%2c65.00022 c -1.9898%2c0.66327 -3.31634%2c3.31634 -3.31634%2c5.30614 l -0.66326%2c31.83685 -59.69409%2c35.15318 c -3.31634%2c1.9898 -1.9898%2c6.63268 -1.9898%2c9.94902 0%2c3.31633 0%2c72.29616 0%2c72.29616 l -25.20417%2c-9.28574 c -1.32654%2c-0.66327 -3.31634%2c-0.66327 -4.64287%2c0 l -22.5511%2c9.28574 c 0%2c0 0%2c-71.6329 0%2c-72.29616 0%2c-3.97961 0.66327%2c-7.29595 -2.65307%2c-9.28575 l -59.69409%2c-35.15318 -0.66326%2c-31.83685 c 0%2c-1.9898 -1.32654%2c-3.97961 -3.31634%2c-5.30614 L 552.16969%2c168.49925 v -39.13279 c 0%2c-2.65307 -1.32654%2c-4.64287 -3.97961%2c-5.96941 l -8.62248%2c-3.9796 -130.66371%2c-78.928847 c -0.66327%2c0 -0.66327%2c-0.663268 -1.32654%2c-0.663268 l -9.28575%2c-3.979606 v 14.591888 l 3.97961%2c1.989803 31.17358%2c19.898028 -25.20417%2c-11.27555 c -0.66327%2c0 -0.66327%2c0 -0.66327%2c0 l -9.28575%2c-5.30614 v 15.918422 458.98119 13.26535 h 5.96941 c 1.9898%2c0 3.31634%2c-0.66327 5.30614%2c-1.9898 1.98981%2c-1.32654 342.90936%2c-150.56175 342.90936%2c-150.56175 0%2c0 346.88899%2c151.88828 348.87879%2c152.55155 1.9898%2c0.66327 7.2959%2c0 7.2959%2c0 V 530.64337 71.66218 57.73356 l -60.3573%2c26.530705 31.8368%2c-19.898028 z M 502.42462%2c485.54117 451.35301%2c508.09227 V 343.6019 l 51.07161%2c9.28575 z m 35.81645%2c-290.51121 v 273.92952 l -22.5511%2c9.94901 V 347.58151 c 0%2c-3.31634 -1.9898%2c-5.96941 -5.30614%2c-6.63268 l -64.33696%2c-11.27555 c -1.9898%2c-0.66327 -3.9796%2c0 -5.30614%2c1.32654 -1.9898%2c1.32653 -2.65307%2c3.31633 -2.65307%2c5.30614 v 177.09245 l -26.5307%2c11.93882 V 76.968321 l 119.38817%2c53.061409 7.29594%2c3.97961 z m 13.92862%2c-11.27555 47.092%2c27.85724 -47.092%2c-20.5613 z m 35.81645%2c183.72512 27.85724%2c3.97961 0.66327%2c63.01042 -27.85724%2c11.93882 z m 61.68389%2c-76.93904 c 0%2c0.66327 0%2c1.9898 0%2c2.65307 v 126.68412 l -22.5511%2c9.94901 -0.66327%2c-63.01042 c 0%2c-3.31634 -1.9898%2c-5.30614 -4.64287%2c-5.96941 L 582.68%2c354.87745 c -1.9898%2c0 -3.31634%2c0 -4.64287%2c1.32653 -1.32654%2c1.32654 -1.98981%2c2.65308 -1.98981%2c4.64288 l 0.66327%2c90.86766 -24.5409%2c10.61228 V 204.97897 l 97.50034%2c43.11239 z m 13.26535%2c-5.96941 11.93882%2c7.29595 -11.93882%2c-3.97961 z m 33.16338%2c115.40857 -11.27555%2c5.30614 v -31.17358 l 11.27555%2c1.32654 z m 17.90823%2c-7.95921 -8.62248%2c3.31633 V 370.1326 c 0%2c-2.65307 -1.98981%2c-4.64287 -4.64288%2c-4.64287 l -20.56129%2c-1.32653 c -1.32654%2c0 -2.65307%2c0.66326 -3.31634%2c1.32653 -0.66327%2c0.66327 -1.32654%2c1.9898 -1.32654%2c3.31634 v 40.45932 l -12.60208%2c5.30614 V 302.47931 l 51.07161%2c17.24496 z m 108.11262%2c11.93881 -11.27555%2c-5.30614 v -24.5409 l 11.27555%2c-0.66327 z m 21.88783%2c9.94902 -13.26535%2c-5.96941 v -39.13279 c 0%2c-1.32654 -0.66327%2c-2.65307 -1.32654%2c-3.31634 -0.66327%2c-0.66327 -1.9898%2c-1.32653 -3.31634%2c-1.32653 l -20.56129%2c1.32653 c -2.65307%2c0 -4.64288%2c1.9898 -4.64288%2c4.64287 v 24.54091 l -7.95921%2c-3.31634 v -72.95944 l 51.07161%2c-16.58169 z m 0%2c-125.35758 -22.5511%2c7.29594 22.5511%2c-13.26535 z m 72.29617%2c157.19442 -27.85724%2c-12.60208 0.66327%2c-63.67369 27.85723%2c-3.97961 z m 38.46952%2c17.24496 -27.19397%2c-11.93882 0.66326%2c-91.53093 c 0%2c-1.9898 -0.66326%2c-3.31634 -1.9898%2c-4.64287 -1.32653%2c-1.32654 -2.65307%2c-1.32654 -4.64287%2c-1.32654 l -39.13279%2c5.96941 c -2.65307%2c0.66327 -4.64287%2c3.31634 -4.64287%2c5.96941 l -0.66327%2c63.01042 -19.89803%2c-8.62247 v -126.68412 -45.1022 l 97.50034%2c-43.11239 z m 0%2c-271.93972 -57.04102%2c25.20417 57.04102%2c-33.82665 z M 1001.8651%2c484.8779 V 350.89784 l 51.0716%2c-8.62247 V 506.76573 Z M 1094.7226%2c77.631589 V 526.00049 l -28.5205%2c-12.60208 V 334.97942 c 0%2c-1.9898 -1.3265%2c-3.9796 -2.6531%2c-5.30614 -1.3265%2c-1.32653 -3.3163%2c-1.9898 -5.3061%2c-1.32653 l -64.33698%2c11.27554 c -3.31634%2c0.66327 -5.30614%2c3.31634 -5.30614%2c6.63268 v 132.65352 l -19.89803%2c-8.62248 -0.66327%2c-335.61341 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path43' d='M 243.08698%2c-0.63398925 274.92383%2c13.957898 V 9.9782925 -3.9503273 l -28.52051%2c-9.9490137 -7.29594%2c-3.316338 c -2.65307%2c-0.663268 -4.64288%2c-0.663268 -6.63268%2c0.663267 -1.9898%2c0.663268 -3.31634%2c3.316338 -3.31634%2c5.306141 V 536.61277 c 0%2c3.97961 2.65307%2c6.63268 6.63268%2c6.63268 h 39.13279 V 529.9801 h -31.83685 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path51' d='m 1169.6718%2c118.09091 c -20.5613%2c0 -37.143%2c-16.58169 -37.143%2c-37.142983 V -51.042328 H 974.67116 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.142986 0%2c-20.561296 16.58169%2c-37.142986 37.14299%2c-37.142986 h 195.00064 c 20.5613%2c0 37.143%2c16.58169 37.143%2c37.142986 V 80.947927 c 0%2c20.561293 -16.5817%2c37.142983 -37.143%2c37.142983 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path55' d='M 530.28186%2c647.37847 H 335.28118 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.14299 V 441.10224 c 0%2c-20.5613 16.58169%2c-37.14299 37.14299%2c-37.14299 20.5613%2c0 37.14299%2c16.58169 37.14299%2c37.14299 v 131.99025 h 157.85769 c 20.56129%2c0 37.14298%2c16.58169 37.14298%2c37.14299 0%2c20.5613 -16.58169%2c37.14299 -37.14298%2c37.14299 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path59' d='m 335.28118%2c118.09091 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.142983 V -88.185314 c 0%2c-20.561296 16.58169%2c-37.142986 37.14299%2c-37.142986 h 195.00068 c 20.56129%2c0 37.14298%2c16.58169 37.14298%2c37.142986 0%2c20.561296 -16.58169%2c37.142986 -37.14298%2c37.142986 H 372.42417 V 80.947927 c 0%2c20.561293 -16.58169%2c37.142983 -37.14299%2c37.142983 z' class='st1'/%3e%3cpath style='fill:white%3bstroke-width:6.63268' id='path63' d='M 1169.6718%2c647.37847 H 974.67116 c -20.5613%2c0 -37.14299%2c-16.58169 -37.14299%2c-37.14299 0%2c-20.5613 16.58169%2c-37.14299 37.14299%2c-37.14299 H 1132.5288 V 441.10224 c 0%2c-20.5613 16.5817%2c-37.14299 37.143%2c-37.14299 20.5613%2c0 37.143%2c16.58169 37.143%2c37.14299 v 169.13324 c 0%2c20.5613 -16.5817%2c37.14299 -37.143%2c37.14299 z' class='st1'/%3e%3c/g%3e%3c/svg%3e");
        return t.classList.add("logo"), $785da19a645c07eb$var$H`<div class=${$785da19a645c07eb$var$w2(e1)} part="panel">
			<div
				class="presentation"
				style=${!this.light && "map" !== this.focus && this.picture ? "display: none" : ""}
			>
				${t}

				${this.light ? $785da19a645c07eb$var$H`
					&copy; <a
						href=${"https://panoramax.fr"}
						title=${this._parent?._t.map.more_panoramax}
						target="_blank"
					>${this._parent?._t.pnx.panoramax}</a> |
				` : $785da19a645c07eb$var$H`
					<div>
						${this._parent?._t.pnx.whats_panoramax}
						<pnx-link-button
							title=${this._parent?._t.map.more_panoramax}
							kind="superinline"
							href=${"https://panoramax.fr"}
							target="_blank"
							size="sm"
						>
							${$785da19a645c07eb$var$ws($785da19a645c07eb$var$L1)}
						</pnx-link-button>
					</div>
				`}
			</div>
			<pnx-picture-legend
				._parent=${this._parent}
				style=${"map" === this.focus ? "display: none" : ""}
				collapsable
				light=${this.light || $785da19a645c07eb$var$Z}
			>
				<slot slot="editors" name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</pnx-picture-legend>
			<pnx-map-legend
				._parent=${this._parent}
				style=${"map" !== this.focus ? "display: none" : ""}
				light=${this.light || $785da19a645c07eb$var$Z}
			></pnx-map-legend>
		</div>`;
    }
}
customElements.define("pnx-widget-legend", $785da19a645c07eb$var$s5);
const $785da19a645c07eb$var$o5 = new CSSStyleSheet;
$785da19a645c07eb$var$o5.replaceSync("/*\n * Common rules\n */\n\n/* Long level numbers */\npnx-level-select pnx-button.pnx-level-long::part(btn) {\n\tfont-size: 0.6em;\n}\n\n\n/*\n * Shrink selector\n */\n\npnx-level-select pnx-button {\n\tmin-height: fit-content;\n\tfont-family: var(--font-family);\n\tfont-size: 0.9em;\n}\n\npnx-level-select pnx-button.pnx-level-minimal::part(btn) {\n\tpadding: 2px 5px;\n}\n\n\n/*\n * Expanded selector\n */\n\n/* Selected level */\npnx-level-select pnx-button .pnx-level-active {\n\tbackground-color: var(--widget-bg-active);\n\tborder-radius: 13px;\n\tcolor: var(--widget-font-active);\n\theight: 26px;\n\tline-height: 26px;\n\twidth: 26px;\n}\n\n/* Shrink button */\npnx-level-select pnx-button.pnx-level-shrink::part(btn) {\n\tborder-top: 1px solid #cfcfcf !important;\n}\n\n/* Long list of levels scrolling */\npnx-level-select .pnx-level-scroller {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tmax-height: 150px;\n\tscroll-behavior: smooth;\n}\n"), document.adoptedStyleSheets.push($785da19a645c07eb$var$o5), document.adoptedStyleSheets.push($785da19a645c07eb$var$F3);
class $785da19a645c07eb$var$l5 extends $785da19a645c07eb$var$ce {
    static properties = {
        _expanded: {
            state: !0
        }
    };
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(this._parent.onceMapReady?.()).then(()=>{
            this._parent.map.indoorEqual.on("levelchange", ()=>this.requestUpdate()), this._parent.map.indoorEqual.on("levelschange", ()=>this.requestUpdate());
        });
    }
    updated(e1) {
        super.updated(e1), this._expanded && (e1?.has("_expanded") ? this._scrollToCurrentLevel(!1, "instant") : this._scrollToCurrentLevel(!0, "smooth"));
    }
    _scrollToCurrentLevel(e1, t) {
        const i = this.renderRoot.querySelector(".pnx-level-active");
        setTimeout(()=>i?.scrollIntoView({
                behavior: t,
                block: "center",
                container: "nearest"
            }), e1 ? 0 : 50);
    }
    render() {
        const e1 = this._parent.map.indoorEqual;
        if (e1.level === $785da19a645c07eb$var$Rc || 0 === e1.levels.length) return $785da19a645c07eb$var$Z;
        const t = e1.levels.findIndex((t)=>t == e1.level), i = t > 0 ? t - 1 : null, n = null !== i ? e1.levels[i] : null, a = t < e1.levels.length - 1 ? t + 1 : null, r = null !== a ? e1.levels[a] : null;
        return $785da19a645c07eb$var$H`
			<pnx-button-group
				dir="column"
				size="xl"
				class="pnx-print-hidden"
			>
				<pnx-button
					kind="superflat"
					@click=${()=>e1.setLevel(n)}
					.disabled=${null === n}
					class="pnx-level-minimal"
					title=${this._parent?._t?.pnx.indoor_selector_levelup}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$_1)}</pnx-button>

				${this._expanded ? $785da19a645c07eb$var$H`
					<pnx-button-group
						dir="column"
						size="xl"
						class="pnx-print-hidden pnx-level-scroller"
					>
						${e1.levels.map((t)=>$785da19a645c07eb$var$H`
							<pnx-button
								kind="superflat"
								@click=${()=>e1.setLevel(t)}
								class=${t.length > 2 ? "pnx-level-long" : null}
							>
								${e1.level == t ? $785da19a645c07eb$var$H`<span class="pnx-level-active">${t}</span>` : t}
							</pnx-button>
						`)}
					</pnx-button-group>
				` : $785da19a645c07eb$var$H`
					<pnx-button
						kind="superflat"
						class="pnx-level-minimal"
						title=${this._parent?._t?.pnx.indoor_selector_expand}
						@click=${e1.levels.length > 1 ? ()=>this._expanded = !0 : null}
					>${e1.level}</pnx-button>
				`}

				<pnx-button
					kind="superflat"
					@click=${()=>e1.setLevel(r)}
					.disabled=${null === r}
					class="pnx-level-minimal"
					title=${this._parent?._t?.pnx.indoor_selector_leveldown}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$N1)}</pnx-button>

				${this._expanded ? $785da19a645c07eb$var$H`
					<pnx-button
						kind="flat"
						class="pnx-level-shrink"
						@click=${()=>this._expanded = !1}
						title=${this._parent?._t?.pnx.indoor_selector_shrink}
					>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$s2)}</pnx-button>
				` : $785da19a645c07eb$var$Z}
			</pnx-button-group>
		`;
    }
}
customElements.define("pnx-level-select", $785da19a645c07eb$var$l5);
class $785da19a645c07eb$var$c5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$j2
    ];
    static properties = {
        "quality-score": {
            type: Boolean
        },
        "user-search": {
            type: Boolean
        },
        "no-date": {
            type: Boolean
        },
        "no-picture-type": {
            type: Boolean
        },
        "no-gps": {
            type: Boolean
        },
        "no-source": {
            type: Boolean
        },
        _active: {
            state: !0
        }
    };
    constructor(){
        super(), this["user-search"] = !1, this["quality-score"] = !1, this["no-date"] = !1, this["no-picture-type"] = !1, this["no-gps"] = !1, this["no-source"] = !1, this._active = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.onceMapReady?.().then(()=>{
                this._active = this._isActive(), this._parent.mapStyleComposer.addEventListener("filters-changed", ()=>this._active = this._isActive()), this._parent.mapStyleComposer.addEventListener("panoramax-changed", ()=>this._active = this._isActive());
            }));
    }
    _isActive() {
        return Object.entries(this._parent.mapStyleComposer.panoramaxFilters).filter(([e1, t])=>e1 && t && ![
                "featuresRestrictions",
                "theme"
            ].includes(e1)).length > 0 || this._parent.mapStyleComposer.isPanoramaxEndpointSingleUser();
    }
    render() {
        const e1 = this._parent?.isWidthSmall() || this._parent?.isWidthMedium(), t = $785da19a645c07eb$var$ws($785da19a645c07eb$var$r2, {
            styles: {
                "pointer-events": "auto"
            }
        });
        return t.addEventListener("click", (e1)=>{
            e1.stopPropagation(), this.shadowRoot.querySelector("pnx-map-filters-menu")._onReset(), this.shadowRoot.querySelector("#pnx-widget-filter")._opened = !1;
        }), $785da19a645c07eb$var$H`
			<pnx-togglable-group
				id="pnx-widget-filter"
				padded="false"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$j1)}
					${this._active ? $785da19a645c07eb$var$H`<span class="pnx-active-icon"></span>` : $785da19a645c07eb$var$Z}
					${e1 ? $785da19a645c07eb$var$Z : this._parent?._t.pnx.filters}
					${e1 ? $785da19a645c07eb$var$Z : this._active ? t : $785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}
				</pnx-button>
				<pnx-map-filters-menu
					id="pnx-map-filters-menu"
					._parent=${this._parent}
					user-search=${this["user-search"]}
					quality-score=${this["quality-score"]}
					.no-date=${this["no-date"]}
					.no-picture-type=${this["no-picture-type"]}
					.no-gps=${this["no-gps"]}
					.no-source=${this["no-source"]}
				></pnx-map-filters-menu>
			</pnx-togglable-group>
		`;
    }
}
customElements.define("pnx-widget-mapfilters", $785da19a645c07eb$var$c5);
class $785da19a645c07eb$var$u5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$j2
    ];
    static properties = {
        _active: {
            state: !0
        }
    };
    constructor(){
        super(), this._active = !1;
    }
    connectedCallback() {
        super.connectedCallback();
        const e1 = [
            void 0,
            null,
            "",
            "default"
        ];
        $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.onceMapReady?.().then(()=>{
                this._active = !e1.includes(this._parent.mapStyleComposer.panoramaxTheme), this._parent.mapStyleComposer.addEventListener("theme-changed", (t)=>{
                    this._active = !e1.includes(t.detail.theme);
                });
            }));
    }
    _toggleDrawer() {
        if (this._parent?.isBottomDrawerVisible?.()) {
            const e1 = this._parent.bottomDrawer.shadowRoot.querySelector("slot")?.assignedNodes();
            if (e1.find((e1)=>"pnx-map-layers-menu" === e1.tagName.toLowerCase())) return void this._parent?.setBottomDrawer(!1);
        }
        this._parent?.setBottomDrawer?.(!0, [
            $785da19a645c07eb$var$ks("pnx-map-layers-menu", {
                id: "pnx-map-layers-menu",
                _parent: this._parent
            })
        ], {
            autoadjust: !0,
            autoclose: !0
        });
    }
    render() {
        const e1 = this._parent?.isWidthSmall(), t = this._parent?.isWidthMedium(), i = $785da19a645c07eb$var$ws($785da19a645c07eb$var$r2, {
            styles: {
                "pointer-events": "auto"
            }
        });
        return i.addEventListener("click", (e1)=>{
            e1.stopPropagation(), this._parent.mapStyleComposer.setPanoramaxTheme("default");
        }), e1 ? $785da19a645c07eb$var$H`
			<pnx-button kind="flat" size="xl" slot="button" @click=${this._toggleDrawer}>
				${$785da19a645c07eb$var$ws($785da19a645c07eb$var$b1)}
				${this._active ? $785da19a645c07eb$var$H`<span class="pnx-active-icon"></span>` : $785da19a645c07eb$var$Z}
			</pnx-button>
		` : $785da19a645c07eb$var$H`
			<pnx-togglable-group
				id="pnx-widget-map-layers"
				class="pnx-print-hidden"
				nobg
				padded="false"
				over-button
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$b1)}
					${this._active ? $785da19a645c07eb$var$H`<span class="pnx-active-icon"></span>` : $785da19a645c07eb$var$Z}
					${t ? $785da19a645c07eb$var$Z : this._parent?._t.pnx.layers}
					${t ? $785da19a645c07eb$var$Z : this._active ? i : $785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}
				</pnx-button>
				<pnx-map-layers-menu
					id="pnx-map-layers-menu"
					._parent=${this._parent}
				></pnx-map-layers-menu>
			</pnx-togglable-group>
		`;
    }
}
customElements.define("pnx-widget-maplayers", $785da19a645c07eb$var$u5);
const $785da19a645c07eb$var$h5 = "http://127.0.0.1:8111";
class $785da19a645c07eb$var$d5 extends $785da19a645c07eb$var$ce {
    static properties = {
        _pic: {
            state: !0
        },
        _josm: {
            state: !0
        }
    };
    static styles = $785da19a645c07eb$var$o`
		:host { display: inline-flex; gap: 5px; }
		:host > * { flex: 1; }
		pnx-link-button::part(btn) { height: auto; }
	`;
    constructor(){
        super(), this._josm = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            this._parent.onceFirstPicLoaded().then(this._onPictureLoad.bind(this)), this._parent.psv.addEventListener("picture-loaded", this._onPictureLoad.bind(this));
        });
    }
    _onPictureLoad() {
        this._pic = this._parent?.psv?.getPictureMetadata();
    }
    _toggleJOSMLive() {
        this._josm = !this._josm, this._josm ? fetch($785da19a645c07eb$var$h5 + "/version").then(()=>{
            const e1 = $785da19a645c07eb$var$Qe(this._parent?.psv?.getPictureMetadata?.());
            if (e1) fetch(`${$785da19a645c07eb$var$h5}/load_and_zoom?${e1}`).catch((e1)=>{
                console.warn(e1), this._toggleJOSMLive();
            });
            this._josmListener = ()=>{
                const e1 = $785da19a645c07eb$var$Qe(this._parent?.psv?.getPictureMetadata?.());
                if (e1) fetch(`${$785da19a645c07eb$var$h5}/zoom?${e1}`).catch((e1)=>{
                    console.warn(e1), this._toggleJOSMLive();
                });
            }, this._parent?.psv?.addEventListener?.("picture-loaded", this._josmListener), this._parent?.psv?.addEventListener?.("picture-loading", this._josmListener);
        }).catch((e1)=>{
            console.warn(e1), alert(this._parent?._t.pnx.error_josm), this._toggleJOSMLive();
        }) : this._josmListener && (this._parent?.psv?.removeEventListener?.("picture-loading", this._josmListener), this._parent?.psv?.removeEventListener?.("picture-loaded", this._josmListener), delete this._josmListener);
    }
    render() {
        if (!this._pic) return $785da19a645c07eb$var$Z;
        if (this._parent?.isWidthSmall()) return $785da19a645c07eb$var$H`
				<pnx-link-button
					size="sm"
					href="geo:${this._pic.gps[1]},${this._pic.gps[0]};u=3"
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$z1)} ${this._parent?._t.pnx.geo_uri}
				</pnx-link-button>
			`;
        {
            const e1 = {
                map: `19/${this._pic.gps[1]}/${this._pic.gps[0]}`,
                source: "Panoramax",
                photo_overlay: "panoramax",
                photo: `panoramax/${this._pic.id}`
            }, t = e1 && `https://www.openstreetmap.org/edit?editor=id#${new URLSearchParams(e1).toString()}`;
            return $785da19a645c07eb$var$H`
				<pnx-link-button
					size="sm"
					href=${t}
					target="_blank"
					title="${this._parent?._t.pnx.contribute_id}"
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$X1)} ${this._parent?._t.pnx.id}
				</pnx-link-button>

				<pnx-button
					id="pnx-edit-josm"
					size="sm"
					active=${this._josm ? "" : $785da19a645c07eb$var$Z}
					@click=${this._toggleJOSMLive}
					title="${this._parent?._t.pnx.josm_live}"
				>
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$S1)} ${this._parent?._t.pnx.josm}
				</pnx-button>
			`;
        }
    }
}
customElements.define("pnx-widget-osmeditors", $785da19a645c07eb$var$d5);
class $785da19a645c07eb$var$p5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$G2,
        $785da19a645c07eb$var$o`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
    ];
    static properties = {
        full: {
            type: Boolean
        },
        _meta: {
            state: !0
        }
    };
    constructor(){
        super(), this.full = !1;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceReady()).then(()=>{
            this._meta = this._parent.psv.getPictureMetadata(), this._parent.psv.addEventListener("picture-loaded", ()=>{
                this._meta = this._parent.psv.getPictureMetadata();
            });
        });
    }
    _onPrint() {
        this._closeGroup(), window.print();
    }
    _closeGroup() {
        this.renderRoot.querySelector("#pic-legend-headline-menu").close();
    }
    render() {
        return $785da19a645c07eb$var$H`<pnx-togglable-group padded="false" id="pic-legend-headline-menu" ._parent=${this._parent}>
			<pnx-button slot="button" kind="inline">${$785da19a645c07eb$var$ws($785da19a645c07eb$var$q1)}</pnx-button>
			<pnx-list-group class="pnx-print-hidden" @click=${this._closeGroup}>
				${this._meta ? $785da19a645c07eb$var$H`<pnx-copy-button ._t=${this._parent?._t} text=${this._meta.id} unstyled>
					${this._parent?._t.pnx.metadata_general_copy_picid}
				</pnx-copy-button>` : $785da19a645c07eb$var$Z}

				<a
					download
					target="_blank"
					href=${this._meta?.panorama?.hdUrl}
					@click=${this._closeGroup}
				>${this._parent?._t.pnx.share_image}</a>

				${this._parent.isWidthSmall() ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`<button @click=${this._onPrint}>
					${this._parent?._t.pnx.share_print}
				</button>`}

				${this._parent?.api?.getRSSURL() && !this._parent.isWidthSmall() && $785da19a645c07eb$var$H`
					<a
						target="_blank"
						href=${this._parent?.api.getRSSURL(this._parent?.map?.getBounds?.())}
						title=${this._parent?._t.pnx.share_rss_title}
						@click=${this._closeGroup}
					>
						${this._parent?._t.pnx.share_rss}
					</a>
				`}
			</pnx-list-group>
		</pnx-togglable-group>`;
    }
}
customElements.define("pnx-picture-legend-actions", $785da19a645c07eb$var$p5);
const $785da19a645c07eb$var$m5 = new CSSStyleSheet;
$785da19a645c07eb$var$m5.replaceSync("pnx-widget-player {\n\tpointer-events: none;\n}\n\npnx-widget-player > pnx-button-group {\n\tpointer-events: auto;\n}\n"), document.adoptedStyleSheets.push($785da19a645c07eb$var$m5);
class $785da19a645c07eb$var$g5 extends $785da19a645c07eb$var$ce {
    static properties = {
        playing: {
            type: Number,
            reflect: !0
        },
        size: {
            type: String
        },
        more: {
            type: String
        },
        _activePrev: {
            state: !0
        },
        _activePlayBack: {
            state: !0
        },
        _activePlay: {
            state: !0
        },
        _activeNext: {
            state: !0
        }
    };
    constructor(){
        super(), this.playing = 0, this.size = "xl", this.more = "depends", this._activePrev = !0, this._activePlayBack = !0, this._activePlay = !0, this._activeNext = !0;
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.oncePSVReady?.().then(()=>{
                this._parent.psv.addEventListener("sequence-playing", (e1)=>this.playing = e1.detail.backward ? -1 : 1), this._parent.psv.addEventListener("sequence-stopped", ()=>this.playing = 0), this._parent.psv.addEventListener("picture-loaded", this._changeActiveStates.bind(this)), this._parent.psv.addEventListener("pictures-navigation-changed", this._changeActiveStates.bind(this)), this._changeActiveStates();
            }));
    }
    _changeActiveStates() {
        "pic" === this._parent.psv.getPicturesNavigation?.() ? (this._activeNext = !1, this._activePlayBack = !1, this._activePlay = !1, this._activePrev = !1) : (this._activePrev = null != this._parent.psv.getPictureMetadata()?.sequence?.prevPic, this._activePlayBack = this._activePrev, this._activeNext = null != this._parent.psv.getPictureMetadata()?.sequence?.nextPic, this._activePlay = this._activeNext), this.requestUpdate();
    }
    _onPlayClick() {
        this._parent?.psv?.isSequencePlaying() && 1 === this.playing ? (this.playing = 0, this._parent?.psv?.stopSequence()) : (this.playing = 1, this._parent?.psv?.playSequence());
    }
    _onPlayBackClick() {
        this._parent?.psv?.isSequencePlaying() && -1 === this.playing ? (this.playing = 0, this._parent?.psv?.stopSequence()) : (this.playing = -1, this._parent?.psv?.playSequence(!0));
    }
    render() {
        return this._parent?.psv?.addEventListener ? $785da19a645c07eb$var$H`
			<pnx-button-group
				id="pnx-widget-player"
				dir="row"
				size=${this.size}
				class="pnx-print-hidden"
				style=${this._activePrev || this._activePlay || this._activeNext ? "" : "display: none"}
			>
				<pnx-button
					kind="superflat"
					id="pnx-player-prev"
					title=${this._parent?._t.pnx.sequence_prev}
					@click=${()=>this._parent?.psv?.goToPrevPicture()}
					.disabled=${!this._activePrev}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$s1)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play-backward"
					title=${-1 === this.playing ? this._parent?._t.pnx.sequence_pause : this._parent?._t.pnx.sequence_play_backwards}
					.disabled=${!this._activePlayBack}
					@click=${this._onPlayBackClick.bind(this)}
				>${-1 === this.playing ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$y1) : $785da19a645c07eb$var$ws($785da19a645c07eb$var$$1, {
            transform: {
                rotate: 180
            }
        })}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play"
					title=${1 === this.playing ? this._parent?._t.pnx.sequence_pause : this._parent?._t.pnx.sequence_play}
					.disabled=${!this._activePlay}
					@click=${this._onPlayClick.bind(this)}
				>${1 === this.playing ? $785da19a645c07eb$var$ws($785da19a645c07eb$var$y1) : $785da19a645c07eb$var$ws($785da19a645c07eb$var$$1)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-next"
					title=${this._parent?._t.pnx.sequence_next}
					.disabled=${!this._activeNext}
					@click=${()=>this._parent?.psv?.goToNextPicture()}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$W1)}</pnx-button>

				${"never" === this.more || "always" !== this.more && this._parent?.isWidthSmall() ? $785da19a645c07eb$var$Z : $785da19a645c07eb$var$H`
					<pnx-togglable-group padded="false" ._parent=${this._parent}>
						<pnx-button
							kind="flat"
							id="pnx-player-more"
							title=${this._parent?._t.pnx.sequence_more}
							class=${"depends" === this.more ? "pnx-xs-hidden" : ""}
							slot="button"
						>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$V1)}</pnx-button>

						<pnx-player-options ._parent=${this._parent}></pnx-player-options>
					</pnx-togglable-group>
				`}
			</pnx-button-group>
		` : $785da19a645c07eb$var$Z;
    }
}
customElements.define("pnx-widget-player", $785da19a645c07eb$var$g5);
class $785da19a645c07eb$var$f5 extends $785da19a645c07eb$var$ce {
    static styles = [
        $785da19a645c07eb$var$j2
    ];
    constructor(){
        super(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent.onceMapReady?.().then(()=>{
                this.requestUpdate(), this._parent?.mapStyleComposer?.addEventListener("dataoverlay-added", ()=>this.requestUpdate()), this._parent?.mapStyleComposer?.addEventListener("dataoverlay-changed", ()=>this.requestUpdate()), this._parent?.mapStyleComposer?.addEventListener("dataunderlay-added", ()=>this.requestUpdate()), this._parent?.mapStyleComposer?.addEventListener("dataunderlay-changed", ()=>this.requestUpdate()), this._parent?.map?.addEventListener("styledata", ()=>this.requestUpdate());
            }));
    }
    render() {
        const e1 = this._parent.map?.getSemanticOverlays?.();
        if (!e1 || 0 === e1.length) return;
        const t = e1.filter((e1)=>e1.metadata && this._parent.mapStyleComposer.dataOverlays.has(e1.source)).length > 0, i = this._parent?.isWidthSmall() || this._parent?.isWidthMedium(), n = $785da19a645c07eb$var$ws($785da19a645c07eb$var$r2, {
            styles: {
                "pointer-events": "auto"
            }
        });
        return n.addEventListener("click", (e1)=>{
            e1.stopPropagation(), this._parent?.map?.toggleAllSemanticOverlays(!1);
        }), $785da19a645c07eb$var$H`
			<pnx-togglable-group
				id="pnx-widget-semantics-filter"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${$785da19a645c07eb$var$ws($785da19a645c07eb$var$C1)}
					${t ? $785da19a645c07eb$var$H`<span class="pnx-active-icon"></span>` : $785da19a645c07eb$var$Z}
					${i ? $785da19a645c07eb$var$Z : this._parent?._t.pnx.semantics_title}
					${i ? $785da19a645c07eb$var$Z : t ? n : $785da19a645c07eb$var$ws($785da19a645c07eb$var$t2)}
				</pnx-button>
				<pnx-map-semantics-filters-menu
					id="pnx-map-semantics-filters-menu"
					._parent=${this._parent}
					@change=${this._onLayersChange}
				></pnx-map-semantics-filters-menu>
			</pnx-togglable-group>
		`;
    }
}
customElements.define("pnx-widget-semantics-filters", $785da19a645c07eb$var$f5), document.adoptedStyleSheets.push($785da19a645c07eb$var$F3);
class $785da19a645c07eb$var$A5 extends $785da19a645c07eb$var$ce {
    static properties = {
        _lastWantedZoom: {
            state: !0
        }
    };
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback(), $785da19a645c07eb$var$Cs(this).then(()=>this._parent?.oncePSVReady?.().then(()=>{
                this._lastWantedZoom = this._parent?.psv?.getZoomLevel() || 30;
            }));
    }
    _onClick(e1, t) {
        if (this._parent.map && this._parent.isMapWide()) t ? this._parent.map.zoomIn({}, {
            originalEvent: e1
        }) : this._parent.map.zoomOut({}, {
            originalEvent: e1
        });
        else {
            this._parent.lastPsvAnim && this._parent.lastPsvAnim.cancel();
            const e1 = t ? Math.min(100, this._lastWantedZoom + 20) : Math.max(0, this._lastWantedZoom - 20);
            this._parent.lastPsvAnim = this._parent.psv.animate({
                speed: $785da19a645c07eb$var$_0,
                zoom: e1
            }), this._lastWantedZoom = e1;
        }
    }
    render() {
        return $785da19a645c07eb$var$H`
			<pnx-button-group
				id="pnx-widget-zoom"
				dir="column"
				size="xl"
				class="pnx-mobile-hidden pnx-print-hidden"
			>
				<pnx-button
					id="pnx-zoom-in"
					kind="superflat"
					title=${this._parent?._t.pnx.zoomIn}
					@click=${(e1)=>this._onClick(e1, !0)}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$n2)}</pnx-button>

				<pnx-button
					id="pnx-zoom-out"
					kind="superflat"
					title=${this._parent?._t.pnx.zoomOut}
					@click=${(e1)=>this._onClick(e1, !1)}
				>${$785da19a645c07eb$var$ws($785da19a645c07eb$var$O1)}</pnx-button>
			</pnx-button-group>
		`;
    }
}
customElements.define("pnx-widget-zoom", $785da19a645c07eb$var$A5);
var $785da19a645c07eb$var$_5 = Object.freeze({
    __proto__: null,
    CopyCoordinates: $785da19a645c07eb$var$t5,
    Fullscreen: $785da19a645c07eb$var$i5,
    GeoSearch: $785da19a645c07eb$var$r5,
    Legend: $785da19a645c07eb$var$s5,
    LevelSelect: $785da19a645c07eb$var$l5,
    MapFiltersButton: $785da19a645c07eb$var$c5,
    MapLayersButton: $785da19a645c07eb$var$u5,
    OSMEditors: $785da19a645c07eb$var$d5,
    PictureLegendActions: $785da19a645c07eb$var$p5,
    Player: $785da19a645c07eb$var$g5,
    SemanticsFiltersButton: $785da19a645c07eb$var$f5,
    Zoom: $785da19a645c07eb$var$A5
}), $785da19a645c07eb$var$v5 = Object.freeze({
    __proto__: null,
    AnnotationsSwitch: $785da19a645c07eb$var$I3,
    Button: $785da19a645c07eb$var$R3,
    ButtonGroup: $785da19a645c07eb$var$z3,
    CopyButton: $785da19a645c07eb$var$L3,
    Grade: $785da19a645c07eb$var$B3,
    GradeFilter: $785da19a645c07eb$var$O3,
    IconSwitch: $785da19a645c07eb$var$U3,
    LinkButton: $785da19a645c07eb$var$N3,
    ListGroup: $785da19a645c07eb$var$j3,
    ListItem: $785da19a645c07eb$var$V3,
    Loader: $785da19a645c07eb$var$q3,
    Map: $785da19a645c07eb$var$XB,
    MapMore: $785da19a645c07eb$var$n1,
    Photo: $785da19a645c07eb$var$M0,
    Popup: $785da19a645c07eb$var$G3,
    ProgressBar: $785da19a645c07eb$var$H3,
    QualityScore: $785da19a645c07eb$var$W3,
    SearchBar: $785da19a645c07eb$var$K3,
    SemanticsEditor: $785da19a645c07eb$var$X3,
    SemanticsTable: $785da19a645c07eb$var$Q3,
    Switch: $785da19a645c07eb$var$Y3,
    TimeTravel: $785da19a645c07eb$var$$3,
    TogglableGroup: $785da19a645c07eb$var$e5,
    widgets: $785da19a645c07eb$var$_5
}), $785da19a645c07eb$var$y5 = Object.freeze({
    __proto__: null,
    core: $785da19a645c07eb$var$y2,
    layout: $785da19a645c07eb$var$P2,
    menus: $785da19a645c07eb$var$P3,
    ui: $785da19a645c07eb$var$v5
}), $785da19a645c07eb$var$x5 = Object.freeze({
    __proto__: null,
    API: $785da19a645c07eb$var$st,
    InitParameters: $785da19a645c07eb$var$eO,
    MapStyleComposer: $785da19a645c07eb$var$oO,
    PhotoAdapter: $785da19a645c07eb$var$c0,
    PresetsManager: $785da19a645c07eb$var$U0,
    URLHandler: $785da19a645c07eb$var$L0,
    geocoder: $785da19a645c07eb$var$m3,
    i18n: $785da19a645c07eb$var$At,
    indoor: $785da19a645c07eb$var$Uc,
    map: $785da19a645c07eb$var$Go,
    picture: $785da19a645c07eb$var$EO,
    semantics: $785da19a645c07eb$var$i1,
    services: $785da19a645c07eb$var$Se,
    utils: $785da19a645c07eb$var$rt,
    widgets: $785da19a645c07eb$var$Ts
});
$785da19a645c07eb$export$f361a1aa61d15026 = $785da19a645c07eb$var$cO, $785da19a645c07eb$export$7cda8d932e2f33c0 = $785da19a645c07eb$var$D0, $785da19a645c07eb$export$fe59e85e16b5f4fb = $785da19a645c07eb$var$q0, $785da19a645c07eb$export$2ec4afd9b3c16a85 = $785da19a645c07eb$var$v2, $785da19a645c07eb$export$9b5ac10f59f76296 = $785da19a645c07eb$var$y5, $785da19a645c07eb$export$eab97d15b1788b8d = $785da19a645c07eb$var$x5;


parcelRequire("9YUWX");


parcelRequire("033rz");
})();
//# sourceMappingURL=panoramax.js.map
